
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec720"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec720"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("hdX8Q", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $c8a186e1757974bb$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("6OX6Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f754377033842c6$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("esGEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874c42e2166676d$export$2e2bcd8739ae039);
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("gdr0J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bce2d00733a79246$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bce2d00733a79246$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bce2d00733a79246$var$_typeof(obj);
}
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $bce2d00733a79246$var$_typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});



parcelRegister("kehhj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eba2848fce1475e9$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR = 3600000;
function $eba2848fce1475e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR);
}

});
parcelRegister("8eaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd7da45fede2458$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var timestamp = (0, $gdr0J.default)(dirtyDate).getTime();
    var amount = (0, $esGEx.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("6IhJz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e349bc0dbb08c36$export$2e2bcd8739ae039);

var $cFZfS = parcelRequire("cFZfS");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $iDIba = parcelRequire("iDIba");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");

var $d7Pru = parcelRequire("d7Pru");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $gdr0J.default)(dirtyDate);
    if (!(0, $cFZfS.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9vfYB.default)(originalDate);
    var utcDate = (0, $8NlMJ.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $iDIba.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("cFZfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93a8d45f3f5c7cb9$export$2e2bcd8739ae039);

var $9BdaM = parcelRequire("9BdaM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    if (!(0, $9BdaM.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $gdr0J.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("9BdaM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $6fd1c9a3eeaafbe4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6fd1c9a3eeaafbe4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6fd1c9a3eeaafbe4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6fd1c9a3eeaafbe4$var$_typeof(obj);
}
function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $4LmDH.default)(1, arguments);
    return value instanceof Date || $6fd1c9a3eeaafbe4$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("8NlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6673cc5b62dfa592$export$2e2bcd8739ae039);

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, -amount);
}

});

parcelRegister("iDIba", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e238bf521c720$export$2e2bcd8739ae039);

var $iT1Z6 = parcelRequire("iT1Z6");

var $jsJZZ = parcelRequire("jsJZZ");

var $7sdBg = parcelRequire("7sdBg");

var $gTlfB = parcelRequire("gTlfB");

var $kB1VM = parcelRequire("kB1VM");

var $bGZx9 = parcelRequire("bGZx9");

var $cbpKX = parcelRequire("cbpKX");
var $d91e238bf521c720$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $cbpKX.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $kB1VM.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $bGZx9.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $bGZx9.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7sdBg.default)(date); // Padding
        return (0, $bGZx9.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $bGZx9.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $cbpKX.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $bGZx9.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $gTlfB.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $bGZx9.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $jsJZZ.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $bGZx9.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $cbpKX.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iT1Z6.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $bGZx9.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $bGZx9.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $bGZx9.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $bGZx9.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $cbpKX.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $cbpKX.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $cbpKX.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $cbpKX.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $cbpKX.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $bGZx9.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $bGZx9.default)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $bGZx9.default)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $bGZx9.default)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $bGZx9.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $bGZx9.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;

});
parcelRegister("iT1Z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfee7256f9ba04c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("jsJZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b4503c694c959a$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bY8nB = parcelRequire("bY8nB");

var $6KmMb = parcelRequire("6KmMb");

var $4LmDH = parcelRequire("4LmDH");
var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $bY8nB.default)(date).getTime() - (0, $6KmMb.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("bY8nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6bcc549b1c1b29$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6KmMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98b4d5a2488885$export$2e2bcd8739ae039);

var $7sdBg = parcelRequire("7sdBg");

var $bY8nB = parcelRequire("bY8nB");

var $4LmDH = parcelRequire("4LmDH");
function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $7sdBg.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $bY8nB.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7sdBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d5b29bd1df6af4$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $bY8nB = parcelRequire("bY8nB");
function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $bY8nB.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $bY8nB.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gTlfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c2445bc457b574$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $1cqVL = parcelRequire("1cqVL");

var $7Pzkw = parcelRequire("7Pzkw");

var $4LmDH = parcelRequire("4LmDH");
var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $1cqVL.default)(date, options).getTime() - (0, $7Pzkw.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1cqVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfbcd4e04a34858$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2GvpZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $1f47e002602f8387$export$430a3269e24b912e);
var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}

});


parcelRegister("7Pzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b38b39a484f4993$export$2e2bcd8739ae039);

var $kB1VM = parcelRequire("kB1VM");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $kB1VM.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $1cqVL.default)(firstWeek, options);
    return date;
}

});
parcelRegister("kB1VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe8c2ce4ac4bd36$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1cqVL.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1cqVL.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bGZx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $88335940ad51fc8f$export$2e2bcd8739ae039);
function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("cbpKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dea7dd01f0b97c2$export$2e2bcd8739ae039);

var $bGZx9 = parcelRequire("bGZx9");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bGZx9.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $bGZx9.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $bGZx9.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $bGZx9.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $bGZx9.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bGZx9.default)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;

});


parcelRegister("6MGGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f085685fa15e740$export$2e2bcd8739ae039);
var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;

});

parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("ebrmh", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a5375092e28b891e$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a5375092e28b891e$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a5375092e28b891e$export$8073c1ae88f0e727);
var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("d7Pru", function(module, exports) {

$parcel$export(module.exports, "default", () => $98e3d5324cb7d94c$export$2e2bcd8739ae039);

var $15nwl = parcelRequire("15nwl");
var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $15nwl.default);

});
parcelRegister("15nwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca880ce53ce49f9$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $fW24Y = parcelRequire("fW24Y");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $fW24Y.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;

});
parcelRegister("2qFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e78b8ee7f66d8$export$2e2bcd8739ae039);
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;

});

parcelRegister("fW24Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99de2b03d4f39be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;

});
parcelRegister("uq3Ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b7040d79e43f9d$export$2e2bcd8739ae039);
function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("1uXR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $117705cf2af2348d$export$2e2bcd8739ae039);
var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;

});

parcelRegister("cPhtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9567ced935a3b497$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;

});
parcelRegister("kp3bq", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda89c8f88184c82$export$2e2bcd8739ae039);
function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2SJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $219397ebd8b56b11$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;

});
parcelRegister("gKbFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c309fdccb9ef673a$export$2e2bcd8739ae039);
function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7pOAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56621c36efca199b$export$2e2bcd8739ae039);
function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("auRgN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a460707bf147158$export$2e2bcd8739ae039);

var $d7Pru = parcelRequire("d7Pru");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $6yoAC = parcelRequire("6yoAC");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $d6B4A = parcelRequire("d6B4A");

var $gznWl = parcelRequire("gznWl");

var $2GvpZ = parcelRequire("2GvpZ");
function $7a460707bf147158$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7a460707bf147158$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7a460707bf147158$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7a460707bf147158$var$_typeof(obj);
}
function $7a460707bf147158$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $7a460707bf147158$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7a460707bf147158$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7a460707bf147158$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7a460707bf147158$var$_arrayLikeToArray(o, minLen);
}
function $7a460707bf147158$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $gdr0J.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $d6B4A.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $6MGGE.default)) {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = $7a460707bf147158$var$_createForOfIteratorHelper(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $gznWl.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                 // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
                 // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ($7a460707bf147158$var$_typeof(_ret) === "object") return _ret.v;
        } // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $gdr0J.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $8NlMJ.default)(date, (0, $9vfYB.default)(date));
    var flags = {};
    var _iterator2 = $7a460707bf147158$var$_createForOfIteratorHelper(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6yoAC.default)(flags, result[1]); // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("6yoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c58fe0eb0761e95$export$2e2bcd8739ae039);
function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("d6B4A", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $98a897cde0f0abfd$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee);
function $98a897cde0f0abfd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $98a897cde0f0abfd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $98a897cde0f0abfd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $98a897cde0f0abfd$var$_typeof(obj);
}
function $98a897cde0f0abfd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $98a897cde0f0abfd$var$_setPrototypeOf(subClass, superClass);
}
function $98a897cde0f0abfd$var$_setPrototypeOf(o, p) {
    $98a897cde0f0abfd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $98a897cde0f0abfd$var$_setPrototypeOf(o, p);
}
function $98a897cde0f0abfd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $98a897cde0f0abfd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $98a897cde0f0abfd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $98a897cde0f0abfd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $98a897cde0f0abfd$var$_possibleConstructorReturn(this, result);
    };
}
function $98a897cde0f0abfd$var$_possibleConstructorReturn(self, call) {
    if (call && ($98a897cde0f0abfd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $98a897cde0f0abfd$var$_assertThisInitialized(self);
}
function $98a897cde0f0abfd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $98a897cde0f0abfd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $98a897cde0f0abfd$var$_getPrototypeOf(o) {
    $98a897cde0f0abfd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $98a897cde0f0abfd$var$_getPrototypeOf(o);
}
function $98a897cde0f0abfd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $98a897cde0f0abfd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $98a897cde0f0abfd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $98a897cde0f0abfd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $98a897cde0f0abfd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $98a897cde0f0abfd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY = 10;
var $98a897cde0f0abfd$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        $98a897cde0f0abfd$var$_classCallCheck(this, Setter);
        $98a897cde0f0abfd$var$_defineProperty(this, "subPriority", 0);
    }
    $98a897cde0f0abfd$var$_createClass(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $98a897cde0f0abfd$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    $98a897cde0f0abfd$var$_inherits(ValueSetter, _Setter);
    var _super = $98a897cde0f0abfd$var$_createSuper(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        $98a897cde0f0abfd$var$_classCallCheck(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    $98a897cde0f0abfd$var$_createClass(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);
var $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    $98a897cde0f0abfd$var$_inherits(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = $98a897cde0f0abfd$var$_createSuper(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        $98a897cde0f0abfd$var$_classCallCheck(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        $98a897cde0f0abfd$var$_defineProperty($98a897cde0f0abfd$var$_assertThisInitialized(_this2), "priority", $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY);
        $98a897cde0f0abfd$var$_defineProperty($98a897cde0f0abfd$var$_assertThisInitialized(_this2), "subPriority", -1);
        return _this2;
    }
    $98a897cde0f0abfd$var$_createClass(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);

});

parcelRegister("gznWl", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $c1027c3b7f83f29d$export$19131010e7fd8373);

var $75WXJ = parcelRequire("75WXJ");

var $a8eKR = parcelRequire("a8eKR");

var $fj1li = parcelRequire("fj1li");

var $44HZq = parcelRequire("44HZq");

var $fwa91 = parcelRequire("fwa91");

var $dt2Qm = parcelRequire("dt2Qm");

var $dOVGV = parcelRequire("dOVGV");

var $7o7jr = parcelRequire("7o7jr");

var $8dk1W = parcelRequire("8dk1W");

var $hW0pX = parcelRequire("hW0pX");

var $anGh5 = parcelRequire("anGh5");

var $cjr07 = parcelRequire("cjr07");

var $mnuhN = parcelRequire("mnuhN");

var $gqUjS = parcelRequire("gqUjS");

var $eglEX = parcelRequire("eglEX");

var $7jfsL = parcelRequire("7jfsL");

var $7ANJo = parcelRequire("7ANJo");

var $bUyT3 = parcelRequire("bUyT3");

var $jYJCf = parcelRequire("jYJCf");

var $7q5qq = parcelRequire("7q5qq");

var $2ashg = parcelRequire("2ashg");

var $fGBwT = parcelRequire("fGBwT");

var $1ZCjh = parcelRequire("1ZCjh");

var $8I45K = parcelRequire("8I45K");

var $ajDAU = parcelRequire("ajDAU");

var $9fJ56 = parcelRequire("9fJ56");

var $1If4X = parcelRequire("1If4X");

var $cAns0 = parcelRequire("cAns0");

var $kuK4G = parcelRequire("kuK4G");

var $jhVfr = parcelRequire("jhVfr");

var $gDlDV = parcelRequire("gDlDV");
var $c1027c3b7f83f29d$export$19131010e7fd8373 = {
    G: new (0, $75WXJ.EraParser)(),
    y: new (0, $a8eKR.YearParser)(),
    Y: new (0, $fj1li.LocalWeekYearParser)(),
    R: new (0, $44HZq.ISOWeekYearParser)(),
    u: new (0, $fwa91.ExtendedYearParser)(),
    Q: new (0, $dt2Qm.QuarterParser)(),
    q: new (0, $dOVGV.StandAloneQuarterParser)(),
    M: new (0, $7o7jr.MonthParser)(),
    L: new (0, $8dk1W.StandAloneMonthParser)(),
    w: new (0, $hW0pX.LocalWeekParser)(),
    I: new (0, $anGh5.ISOWeekParser)(),
    d: new (0, $cjr07.DateParser)(),
    D: new (0, $mnuhN.DayOfYearParser)(),
    E: new (0, $gqUjS.DayParser)(),
    e: new (0, $eglEX.LocalDayParser)(),
    c: new (0, $7jfsL.StandAloneLocalDayParser)(),
    i: new (0, $7ANJo.ISODayParser)(),
    a: new (0, $bUyT3.AMPMParser)(),
    b: new (0, $jYJCf.AMPMMidnightParser)(),
    B: new (0, $7q5qq.DayPeriodParser)(),
    h: new (0, $2ashg.Hour1to12Parser)(),
    H: new (0, $fGBwT.Hour0to23Parser)(),
    K: new (0, $1ZCjh.Hour0To11Parser)(),
    k: new (0, $8I45K.Hour1To24Parser)(),
    m: new (0, $ajDAU.MinuteParser)(),
    s: new (0, $9fJ56.SecondParser)(),
    S: new (0, $1If4X.FractionOfSecondParser)(),
    X: new (0, $cAns0.ISOTimezoneWithZParser)(),
    x: new (0, $kuK4G.ISOTimezoneParser)(),
    t: new (0, $jhVfr.TimestampSecondsParser)(),
    T: new (0, $gDlDV.TimestampMillisecondsParser)()
};

});
parcelRegister("75WXJ", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $52a6bcb88b20d48f$export$8e5a1d3f85a9688);

var $dVUCv = parcelRequire("dVUCv");
function $52a6bcb88b20d48f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52a6bcb88b20d48f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52a6bcb88b20d48f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52a6bcb88b20d48f$var$_typeof(obj);
}
function $52a6bcb88b20d48f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52a6bcb88b20d48f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52a6bcb88b20d48f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52a6bcb88b20d48f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52a6bcb88b20d48f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52a6bcb88b20d48f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52a6bcb88b20d48f$var$_setPrototypeOf(subClass, superClass);
}
function $52a6bcb88b20d48f$var$_setPrototypeOf(o, p) {
    $52a6bcb88b20d48f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52a6bcb88b20d48f$var$_setPrototypeOf(o, p);
}
function $52a6bcb88b20d48f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52a6bcb88b20d48f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52a6bcb88b20d48f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52a6bcb88b20d48f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52a6bcb88b20d48f$var$_possibleConstructorReturn(this, result);
    };
}
function $52a6bcb88b20d48f$var$_possibleConstructorReturn(self, call) {
    if (call && ($52a6bcb88b20d48f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $52a6bcb88b20d48f$var$_assertThisInitialized(self);
}
function $52a6bcb88b20d48f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52a6bcb88b20d48f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52a6bcb88b20d48f$var$_getPrototypeOf(o) {
    $52a6bcb88b20d48f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52a6bcb88b20d48f$var$_getPrototypeOf(o);
}
function $52a6bcb88b20d48f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $52a6bcb88b20d48f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    $52a6bcb88b20d48f$var$_inherits(EraParser, _Parser);
    var _super = $52a6bcb88b20d48f$var$_createSuper(EraParser);
    function EraParser() {
        var _this;
        $52a6bcb88b20d48f$var$_classCallCheck(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $52a6bcb88b20d48f$var$_defineProperty($52a6bcb88b20d48f$var$_assertThisInitialized(_this), "priority", 140);
        $52a6bcb88b20d48f$var$_defineProperty($52a6bcb88b20d48f$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    $52a6bcb88b20d48f$var$_createClass(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $dVUCv.Parser));

});
parcelRegister("dVUCv", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a24c84ce3b2e818f$export$7acfa6ed01010e37);

var $d6B4A = parcelRequire("d6B4A");
function $a24c84ce3b2e818f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a24c84ce3b2e818f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a24c84ce3b2e818f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a24c84ce3b2e818f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a24c84ce3b2e818f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $a24c84ce3b2e818f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        $a24c84ce3b2e818f$var$_classCallCheck(this, Parser);
    }
    $a24c84ce3b2e818f$var$_createClass(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $d6B4A.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("a8eKR", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $760618bd8dde9a2e$export$48d352de7cd4a988);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $760618bd8dde9a2e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $760618bd8dde9a2e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $760618bd8dde9a2e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $760618bd8dde9a2e$var$_typeof(obj);
}
function $760618bd8dde9a2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $760618bd8dde9a2e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $760618bd8dde9a2e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $760618bd8dde9a2e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $760618bd8dde9a2e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $760618bd8dde9a2e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $760618bd8dde9a2e$var$_setPrototypeOf(subClass, superClass);
}
function $760618bd8dde9a2e$var$_setPrototypeOf(o, p) {
    $760618bd8dde9a2e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $760618bd8dde9a2e$var$_setPrototypeOf(o, p);
}
function $760618bd8dde9a2e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $760618bd8dde9a2e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $760618bd8dde9a2e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $760618bd8dde9a2e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $760618bd8dde9a2e$var$_possibleConstructorReturn(this, result);
    };
}
function $760618bd8dde9a2e$var$_possibleConstructorReturn(self, call) {
    if (call && ($760618bd8dde9a2e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $760618bd8dde9a2e$var$_assertThisInitialized(self);
}
function $760618bd8dde9a2e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $760618bd8dde9a2e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $760618bd8dde9a2e$var$_getPrototypeOf(o) {
    $760618bd8dde9a2e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $760618bd8dde9a2e$var$_getPrototypeOf(o);
}
function $760618bd8dde9a2e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $760618bd8dde9a2e$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    $760618bd8dde9a2e$var$_inherits(YearParser, _Parser);
    var _super = $760618bd8dde9a2e$var$_createSuper(YearParser);
    function YearParser() {
        var _this;
        $760618bd8dde9a2e$var$_classCallCheck(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $760618bd8dde9a2e$var$_defineProperty($760618bd8dde9a2e$var$_assertThisInitialized(_this), "priority", 130);
        $760618bd8dde9a2e$var$_defineProperty($760618bd8dde9a2e$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $760618bd8dde9a2e$var$_createClass(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $dVUCv.Parser));

});
parcelRegister("XhBEN", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $0b232b0fb2037abb$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $0b232b0fb2037abb$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $0b232b0fb2037abb$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $0b232b0fb2037abb$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $0b232b0fb2037abb$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $0b232b0fb2037abb$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $0b232b0fb2037abb$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $0b232b0fb2037abb$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $0b232b0fb2037abb$export$3d50627710b84d75);

var $6Q3SV = parcelRequire("6Q3SV");

var $629aZ = parcelRequire("629aZ");
function $0b232b0fb2037abb$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * (0, $6Q3SV.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$d931c43c4608a164(dateString) {
    return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).anyDigitsSigned, dateString);
}
function $0b232b0fb2037abb$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigit, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigits, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigits, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigits, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $0b232b0fb2037abb$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $0b232b0fb2037abb$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $0b232b0fb2037abb$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $0b232b0fb2037abb$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("6Q3SV", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $4faa9cd956e257dc$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $4faa9cd956e257dc$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $4faa9cd956e257dc$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$3913210603d8e9ae = 365.2425;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;
var $4faa9cd956e257dc$export$815a9362476d2fe3 = $4faa9cd956e257dc$export$698aec755e92c695 * 24;
var $4faa9cd956e257dc$export$34804a017b31e2fe = $4faa9cd956e257dc$export$815a9362476d2fe3 * 7;
var $4faa9cd956e257dc$export$7271e9e3478110d1 = $4faa9cd956e257dc$export$815a9362476d2fe3 * $4faa9cd956e257dc$export$3913210603d8e9ae;
var $4faa9cd956e257dc$export$8e6600bbdee7dabb = $4faa9cd956e257dc$export$7271e9e3478110d1 / 12;
var $4faa9cd956e257dc$export$be1dccf2de902d31 = $4faa9cd956e257dc$export$8e6600bbdee7dabb * 3;

});

parcelRegister("629aZ", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $464a0c2b40e7950e$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $464a0c2b40e7950e$export$a7ee192b982af9c1);
var $464a0c2b40e7950e$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $464a0c2b40e7950e$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("fj1li", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $b249abf1c76e715b$export$b8ef38dfcf05d5db);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $kB1VM = parcelRequire("kB1VM");

var $1cqVL = parcelRequire("1cqVL");
function $b249abf1c76e715b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b249abf1c76e715b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b249abf1c76e715b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b249abf1c76e715b$var$_typeof(obj);
}
function $b249abf1c76e715b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b249abf1c76e715b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b249abf1c76e715b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b249abf1c76e715b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b249abf1c76e715b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b249abf1c76e715b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b249abf1c76e715b$var$_setPrototypeOf(subClass, superClass);
}
function $b249abf1c76e715b$var$_setPrototypeOf(o, p) {
    $b249abf1c76e715b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b249abf1c76e715b$var$_setPrototypeOf(o, p);
}
function $b249abf1c76e715b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b249abf1c76e715b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b249abf1c76e715b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b249abf1c76e715b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b249abf1c76e715b$var$_possibleConstructorReturn(this, result);
    };
}
function $b249abf1c76e715b$var$_possibleConstructorReturn(self, call) {
    if (call && ($b249abf1c76e715b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b249abf1c76e715b$var$_assertThisInitialized(self);
}
function $b249abf1c76e715b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b249abf1c76e715b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b249abf1c76e715b$var$_getPrototypeOf(o) {
    $b249abf1c76e715b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b249abf1c76e715b$var$_getPrototypeOf(o);
}
function $b249abf1c76e715b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b249abf1c76e715b$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    $b249abf1c76e715b$var$_inherits(LocalWeekYearParser, _Parser);
    var _super = $b249abf1c76e715b$var$_createSuper(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        $b249abf1c76e715b$var$_classCallCheck(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b249abf1c76e715b$var$_defineProperty($b249abf1c76e715b$var$_assertThisInitialized(_this), "priority", 130);
        $b249abf1c76e715b$var$_defineProperty($b249abf1c76e715b$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $b249abf1c76e715b$var$_createClass(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $kB1VM.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $1cqVL.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $1cqVL.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("44HZq", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $2f79a8958a9b0819$export$951d1df011fde06f);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $bY8nB = parcelRequire("bY8nB");
function $2f79a8958a9b0819$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2f79a8958a9b0819$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2f79a8958a9b0819$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2f79a8958a9b0819$var$_typeof(obj);
}
function $2f79a8958a9b0819$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2f79a8958a9b0819$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2f79a8958a9b0819$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2f79a8958a9b0819$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2f79a8958a9b0819$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2f79a8958a9b0819$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2f79a8958a9b0819$var$_setPrototypeOf(subClass, superClass);
}
function $2f79a8958a9b0819$var$_setPrototypeOf(o, p) {
    $2f79a8958a9b0819$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2f79a8958a9b0819$var$_setPrototypeOf(o, p);
}
function $2f79a8958a9b0819$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2f79a8958a9b0819$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2f79a8958a9b0819$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2f79a8958a9b0819$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2f79a8958a9b0819$var$_possibleConstructorReturn(this, result);
    };
}
function $2f79a8958a9b0819$var$_possibleConstructorReturn(self, call) {
    if (call && ($2f79a8958a9b0819$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2f79a8958a9b0819$var$_assertThisInitialized(self);
}
function $2f79a8958a9b0819$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2f79a8958a9b0819$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2f79a8958a9b0819$var$_getPrototypeOf(o) {
    $2f79a8958a9b0819$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2f79a8958a9b0819$var$_getPrototypeOf(o);
}
function $2f79a8958a9b0819$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2f79a8958a9b0819$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    $2f79a8958a9b0819$var$_inherits(ISOWeekYearParser, _Parser);
    var _super = $2f79a8958a9b0819$var$_createSuper(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        $2f79a8958a9b0819$var$_classCallCheck(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $2f79a8958a9b0819$var$_defineProperty($2f79a8958a9b0819$var$_assertThisInitialized(_this), "priority", 130);
        $2f79a8958a9b0819$var$_defineProperty($2f79a8958a9b0819$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $2f79a8958a9b0819$var$_createClass(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $bY8nB.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("fwa91", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $b4c1b6ab03bfe94f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b4c1b6ab03bfe94f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b4c1b6ab03bfe94f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b4c1b6ab03bfe94f$var$_typeof(obj);
}
function $b4c1b6ab03bfe94f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b4c1b6ab03bfe94f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b4c1b6ab03bfe94f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b4c1b6ab03bfe94f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b4c1b6ab03bfe94f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b4c1b6ab03bfe94f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b4c1b6ab03bfe94f$var$_setPrototypeOf(subClass, superClass);
}
function $b4c1b6ab03bfe94f$var$_setPrototypeOf(o, p) {
    $b4c1b6ab03bfe94f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b4c1b6ab03bfe94f$var$_setPrototypeOf(o, p);
}
function $b4c1b6ab03bfe94f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b4c1b6ab03bfe94f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b4c1b6ab03bfe94f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b4c1b6ab03bfe94f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b4c1b6ab03bfe94f$var$_possibleConstructorReturn(this, result);
    };
}
function $b4c1b6ab03bfe94f$var$_possibleConstructorReturn(self, call) {
    if (call && ($b4c1b6ab03bfe94f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b4c1b6ab03bfe94f$var$_assertThisInitialized(self);
}
function $b4c1b6ab03bfe94f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b4c1b6ab03bfe94f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b4c1b6ab03bfe94f$var$_getPrototypeOf(o) {
    $b4c1b6ab03bfe94f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b4c1b6ab03bfe94f$var$_getPrototypeOf(o);
}
function $b4c1b6ab03bfe94f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    $b4c1b6ab03bfe94f$var$_inherits(ExtendedYearParser, _Parser);
    var _super = $b4c1b6ab03bfe94f$var$_createSuper(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        $b4c1b6ab03bfe94f$var$_classCallCheck(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b4c1b6ab03bfe94f$var$_defineProperty($b4c1b6ab03bfe94f$var$_assertThisInitialized(_this), "priority", 130);
        $b4c1b6ab03bfe94f$var$_defineProperty($b4c1b6ab03bfe94f$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $b4c1b6ab03bfe94f$var$_createClass(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dt2Qm", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $9ce0307b40bcf431$export$5cb0f701186dde1d);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $9ce0307b40bcf431$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ce0307b40bcf431$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ce0307b40bcf431$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ce0307b40bcf431$var$_typeof(obj);
}
function $9ce0307b40bcf431$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ce0307b40bcf431$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ce0307b40bcf431$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ce0307b40bcf431$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ce0307b40bcf431$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9ce0307b40bcf431$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9ce0307b40bcf431$var$_setPrototypeOf(subClass, superClass);
}
function $9ce0307b40bcf431$var$_setPrototypeOf(o, p) {
    $9ce0307b40bcf431$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ce0307b40bcf431$var$_setPrototypeOf(o, p);
}
function $9ce0307b40bcf431$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9ce0307b40bcf431$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9ce0307b40bcf431$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9ce0307b40bcf431$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9ce0307b40bcf431$var$_possibleConstructorReturn(this, result);
    };
}
function $9ce0307b40bcf431$var$_possibleConstructorReturn(self, call) {
    if (call && ($9ce0307b40bcf431$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9ce0307b40bcf431$var$_assertThisInitialized(self);
}
function $9ce0307b40bcf431$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9ce0307b40bcf431$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9ce0307b40bcf431$var$_getPrototypeOf(o) {
    $9ce0307b40bcf431$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ce0307b40bcf431$var$_getPrototypeOf(o);
}
function $9ce0307b40bcf431$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9ce0307b40bcf431$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    $9ce0307b40bcf431$var$_inherits(QuarterParser, _Parser);
    var _super = $9ce0307b40bcf431$var$_createSuper(QuarterParser);
    function QuarterParser() {
        var _this;
        $9ce0307b40bcf431$var$_classCallCheck(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $9ce0307b40bcf431$var$_defineProperty($9ce0307b40bcf431$var$_assertThisInitialized(_this), "priority", 120);
        $9ce0307b40bcf431$var$_defineProperty($9ce0307b40bcf431$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $9ce0307b40bcf431$var$_createClass(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dOVGV", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $a0fcb22d028fbb12$export$300c0c2990e20e6d);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $a0fcb22d028fbb12$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a0fcb22d028fbb12$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a0fcb22d028fbb12$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a0fcb22d028fbb12$var$_typeof(obj);
}
function $a0fcb22d028fbb12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0fcb22d028fbb12$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a0fcb22d028fbb12$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a0fcb22d028fbb12$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a0fcb22d028fbb12$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a0fcb22d028fbb12$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a0fcb22d028fbb12$var$_setPrototypeOf(subClass, superClass);
}
function $a0fcb22d028fbb12$var$_setPrototypeOf(o, p) {
    $a0fcb22d028fbb12$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a0fcb22d028fbb12$var$_setPrototypeOf(o, p);
}
function $a0fcb22d028fbb12$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a0fcb22d028fbb12$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a0fcb22d028fbb12$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a0fcb22d028fbb12$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a0fcb22d028fbb12$var$_possibleConstructorReturn(this, result);
    };
}
function $a0fcb22d028fbb12$var$_possibleConstructorReturn(self, call) {
    if (call && ($a0fcb22d028fbb12$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a0fcb22d028fbb12$var$_assertThisInitialized(self);
}
function $a0fcb22d028fbb12$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a0fcb22d028fbb12$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a0fcb22d028fbb12$var$_getPrototypeOf(o) {
    $a0fcb22d028fbb12$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a0fcb22d028fbb12$var$_getPrototypeOf(o);
}
function $a0fcb22d028fbb12$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a0fcb22d028fbb12$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    $a0fcb22d028fbb12$var$_inherits(StandAloneQuarterParser, _Parser);
    var _super = $a0fcb22d028fbb12$var$_createSuper(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        $a0fcb22d028fbb12$var$_classCallCheck(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a0fcb22d028fbb12$var$_defineProperty($a0fcb22d028fbb12$var$_assertThisInitialized(_this), "priority", 120);
        $a0fcb22d028fbb12$var$_defineProperty($a0fcb22d028fbb12$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $a0fcb22d028fbb12$var$_createClass(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7o7jr", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $5610726e2a84c5bb$export$400dd8b40ef138a3);

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
function $5610726e2a84c5bb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5610726e2a84c5bb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5610726e2a84c5bb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5610726e2a84c5bb$var$_typeof(obj);
}
function $5610726e2a84c5bb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5610726e2a84c5bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5610726e2a84c5bb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5610726e2a84c5bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5610726e2a84c5bb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5610726e2a84c5bb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5610726e2a84c5bb$var$_setPrototypeOf(subClass, superClass);
}
function $5610726e2a84c5bb$var$_setPrototypeOf(o, p) {
    $5610726e2a84c5bb$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5610726e2a84c5bb$var$_setPrototypeOf(o, p);
}
function $5610726e2a84c5bb$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5610726e2a84c5bb$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5610726e2a84c5bb$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5610726e2a84c5bb$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5610726e2a84c5bb$var$_possibleConstructorReturn(this, result);
    };
}
function $5610726e2a84c5bb$var$_possibleConstructorReturn(self, call) {
    if (call && ($5610726e2a84c5bb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5610726e2a84c5bb$var$_assertThisInitialized(self);
}
function $5610726e2a84c5bb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5610726e2a84c5bb$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5610726e2a84c5bb$var$_getPrototypeOf(o) {
    $5610726e2a84c5bb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5610726e2a84c5bb$var$_getPrototypeOf(o);
}
function $5610726e2a84c5bb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5610726e2a84c5bb$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    $5610726e2a84c5bb$var$_inherits(MonthParser, _Parser);
    var _super = $5610726e2a84c5bb$var$_createSuper(MonthParser);
    function MonthParser() {
        var _this;
        $5610726e2a84c5bb$var$_classCallCheck(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5610726e2a84c5bb$var$_defineProperty($5610726e2a84c5bb$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        $5610726e2a84c5bb$var$_defineProperty($5610726e2a84c5bb$var$_assertThisInitialized(_this), "priority", 110);
        return _this;
    }
    $5610726e2a84c5bb$var$_createClass(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("8dk1W", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $5faf133932f8fa0d$export$1d7eaa53eaa5deba);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $5faf133932f8fa0d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5faf133932f8fa0d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5faf133932f8fa0d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5faf133932f8fa0d$var$_typeof(obj);
}
function $5faf133932f8fa0d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5faf133932f8fa0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5faf133932f8fa0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5faf133932f8fa0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5faf133932f8fa0d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5faf133932f8fa0d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5faf133932f8fa0d$var$_setPrototypeOf(subClass, superClass);
}
function $5faf133932f8fa0d$var$_setPrototypeOf(o, p) {
    $5faf133932f8fa0d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5faf133932f8fa0d$var$_setPrototypeOf(o, p);
}
function $5faf133932f8fa0d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5faf133932f8fa0d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5faf133932f8fa0d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5faf133932f8fa0d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5faf133932f8fa0d$var$_possibleConstructorReturn(this, result);
    };
}
function $5faf133932f8fa0d$var$_possibleConstructorReturn(self, call) {
    if (call && ($5faf133932f8fa0d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5faf133932f8fa0d$var$_assertThisInitialized(self);
}
function $5faf133932f8fa0d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5faf133932f8fa0d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5faf133932f8fa0d$var$_getPrototypeOf(o) {
    $5faf133932f8fa0d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5faf133932f8fa0d$var$_getPrototypeOf(o);
}
function $5faf133932f8fa0d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5faf133932f8fa0d$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    $5faf133932f8fa0d$var$_inherits(StandAloneMonthParser, _Parser);
    var _super = $5faf133932f8fa0d$var$_createSuper(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        $5faf133932f8fa0d$var$_classCallCheck(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5faf133932f8fa0d$var$_defineProperty($5faf133932f8fa0d$var$_assertThisInitialized(_this), "priority", 110);
        $5faf133932f8fa0d$var$_defineProperty($5faf133932f8fa0d$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $5faf133932f8fa0d$var$_createClass(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("hW0pX", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $d0e82d5cf6f5412c$export$c4005ffc174e07c0);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $aj6ZU = parcelRequire("aj6ZU");

var $1cqVL = parcelRequire("1cqVL");
function $d0e82d5cf6f5412c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d0e82d5cf6f5412c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d0e82d5cf6f5412c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d0e82d5cf6f5412c$var$_typeof(obj);
}
function $d0e82d5cf6f5412c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0e82d5cf6f5412c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d0e82d5cf6f5412c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0e82d5cf6f5412c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0e82d5cf6f5412c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d0e82d5cf6f5412c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d0e82d5cf6f5412c$var$_setPrototypeOf(subClass, superClass);
}
function $d0e82d5cf6f5412c$var$_setPrototypeOf(o, p) {
    $d0e82d5cf6f5412c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0e82d5cf6f5412c$var$_setPrototypeOf(o, p);
}
function $d0e82d5cf6f5412c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d0e82d5cf6f5412c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d0e82d5cf6f5412c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d0e82d5cf6f5412c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d0e82d5cf6f5412c$var$_possibleConstructorReturn(this, result);
    };
}
function $d0e82d5cf6f5412c$var$_possibleConstructorReturn(self, call) {
    if (call && ($d0e82d5cf6f5412c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d0e82d5cf6f5412c$var$_assertThisInitialized(self);
}
function $d0e82d5cf6f5412c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d0e82d5cf6f5412c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d0e82d5cf6f5412c$var$_getPrototypeOf(o) {
    $d0e82d5cf6f5412c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d0e82d5cf6f5412c$var$_getPrototypeOf(o);
}
function $d0e82d5cf6f5412c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d0e82d5cf6f5412c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    $d0e82d5cf6f5412c$var$_inherits(LocalWeekParser, _Parser);
    var _super = $d0e82d5cf6f5412c$var$_createSuper(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        $d0e82d5cf6f5412c$var$_classCallCheck(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d0e82d5cf6f5412c$var$_defineProperty($d0e82d5cf6f5412c$var$_assertThisInitialized(_this), "priority", 100);
        $d0e82d5cf6f5412c$var$_defineProperty($d0e82d5cf6f5412c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $d0e82d5cf6f5412c$var$_createClass(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $1cqVL.default)((0, $aj6ZU.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("aj6ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $78111b508c05f859$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $gTlfB = parcelRequire("gTlfB");

var $4LmDH = parcelRequire("4LmDH");
function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var week = (0, $esGEx.default)(dirtyWeek);
    var diff = (0, $gTlfB.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("anGh5", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $01f34dcf5c011194$export$6fc8dbedd560a6af);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $jIUvX = parcelRequire("jIUvX");

var $bY8nB = parcelRequire("bY8nB");
function $01f34dcf5c011194$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $01f34dcf5c011194$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $01f34dcf5c011194$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $01f34dcf5c011194$var$_typeof(obj);
}
function $01f34dcf5c011194$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $01f34dcf5c011194$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $01f34dcf5c011194$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $01f34dcf5c011194$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $01f34dcf5c011194$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $01f34dcf5c011194$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $01f34dcf5c011194$var$_setPrototypeOf(subClass, superClass);
}
function $01f34dcf5c011194$var$_setPrototypeOf(o, p) {
    $01f34dcf5c011194$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $01f34dcf5c011194$var$_setPrototypeOf(o, p);
}
function $01f34dcf5c011194$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $01f34dcf5c011194$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $01f34dcf5c011194$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $01f34dcf5c011194$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $01f34dcf5c011194$var$_possibleConstructorReturn(this, result);
    };
}
function $01f34dcf5c011194$var$_possibleConstructorReturn(self, call) {
    if (call && ($01f34dcf5c011194$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $01f34dcf5c011194$var$_assertThisInitialized(self);
}
function $01f34dcf5c011194$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $01f34dcf5c011194$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $01f34dcf5c011194$var$_getPrototypeOf(o) {
    $01f34dcf5c011194$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $01f34dcf5c011194$var$_getPrototypeOf(o);
}
function $01f34dcf5c011194$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $01f34dcf5c011194$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    $01f34dcf5c011194$var$_inherits(ISOWeekParser, _Parser);
    var _super = $01f34dcf5c011194$var$_createSuper(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        $01f34dcf5c011194$var$_classCallCheck(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $01f34dcf5c011194$var$_defineProperty($01f34dcf5c011194$var$_assertThisInitialized(_this), "priority", 100);
        $01f34dcf5c011194$var$_defineProperty($01f34dcf5c011194$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $01f34dcf5c011194$var$_createClass(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $bY8nB.default)((0, $jIUvX.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("jIUvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5bdf6fda1ca18fd$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $jsJZZ = parcelRequire("jsJZZ");

var $4LmDH = parcelRequire("4LmDH");
function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var isoWeek = (0, $esGEx.default)(dirtyISOWeek);
    var diff = (0, $jsJZZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("cjr07", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $8f6c3433250540ef$export$e8d4b28a20981dd2);

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
function $8f6c3433250540ef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8f6c3433250540ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8f6c3433250540ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8f6c3433250540ef$var$_typeof(obj);
}
function $8f6c3433250540ef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8f6c3433250540ef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8f6c3433250540ef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8f6c3433250540ef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8f6c3433250540ef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8f6c3433250540ef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8f6c3433250540ef$var$_setPrototypeOf(subClass, superClass);
}
function $8f6c3433250540ef$var$_setPrototypeOf(o, p) {
    $8f6c3433250540ef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8f6c3433250540ef$var$_setPrototypeOf(o, p);
}
function $8f6c3433250540ef$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8f6c3433250540ef$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8f6c3433250540ef$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8f6c3433250540ef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8f6c3433250540ef$var$_possibleConstructorReturn(this, result);
    };
}
function $8f6c3433250540ef$var$_possibleConstructorReturn(self, call) {
    if (call && ($8f6c3433250540ef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8f6c3433250540ef$var$_assertThisInitialized(self);
}
function $8f6c3433250540ef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8f6c3433250540ef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8f6c3433250540ef$var$_getPrototypeOf(o) {
    $8f6c3433250540ef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8f6c3433250540ef$var$_getPrototypeOf(o);
}
function $8f6c3433250540ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8f6c3433250540ef$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // Day of the month
var $8f6c3433250540ef$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    $8f6c3433250540ef$var$_inherits(DateParser, _Parser);
    var _super = $8f6c3433250540ef$var$_createSuper(DateParser);
    function DateParser() {
        var _this;
        $8f6c3433250540ef$var$_classCallCheck(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $8f6c3433250540ef$var$_defineProperty($8f6c3433250540ef$var$_assertThisInitialized(_this), "priority", 90);
        $8f6c3433250540ef$var$_defineProperty($8f6c3433250540ef$var$_assertThisInitialized(_this), "subPriority", 1);
        $8f6c3433250540ef$var$_defineProperty($8f6c3433250540ef$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $8f6c3433250540ef$var$_createClass(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $dVUCv.Parser));

});

parcelRegister("mnuhN", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $0434465071b161c2$export$6cfe0d613455f615);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $0434465071b161c2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0434465071b161c2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0434465071b161c2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0434465071b161c2$var$_typeof(obj);
}
function $0434465071b161c2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0434465071b161c2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0434465071b161c2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0434465071b161c2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0434465071b161c2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0434465071b161c2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0434465071b161c2$var$_setPrototypeOf(subClass, superClass);
}
function $0434465071b161c2$var$_setPrototypeOf(o, p) {
    $0434465071b161c2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0434465071b161c2$var$_setPrototypeOf(o, p);
}
function $0434465071b161c2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0434465071b161c2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0434465071b161c2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0434465071b161c2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0434465071b161c2$var$_possibleConstructorReturn(this, result);
    };
}
function $0434465071b161c2$var$_possibleConstructorReturn(self, call) {
    if (call && ($0434465071b161c2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $0434465071b161c2$var$_assertThisInitialized(self);
}
function $0434465071b161c2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0434465071b161c2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0434465071b161c2$var$_getPrototypeOf(o) {
    $0434465071b161c2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0434465071b161c2$var$_getPrototypeOf(o);
}
function $0434465071b161c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0434465071b161c2$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    $0434465071b161c2$var$_inherits(DayOfYearParser, _Parser);
    var _super = $0434465071b161c2$var$_createSuper(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        $0434465071b161c2$var$_classCallCheck(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $0434465071b161c2$var$_defineProperty($0434465071b161c2$var$_assertThisInitialized(_this), "priority", 90);
        $0434465071b161c2$var$_defineProperty($0434465071b161c2$var$_assertThisInitialized(_this), "subpriority", 1);
        $0434465071b161c2$var$_defineProperty($0434465071b161c2$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $0434465071b161c2$var$_createClass(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gqUjS", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $bf6ac2f87af55cf1$export$1b03c8b76262f7bd);

var $dVUCv = parcelRequire("dVUCv");

var $hCHMu = parcelRequire("hCHMu");
function $bf6ac2f87af55cf1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bf6ac2f87af55cf1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bf6ac2f87af55cf1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bf6ac2f87af55cf1$var$_typeof(obj);
}
function $bf6ac2f87af55cf1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bf6ac2f87af55cf1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bf6ac2f87af55cf1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf6ac2f87af55cf1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf6ac2f87af55cf1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bf6ac2f87af55cf1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bf6ac2f87af55cf1$var$_setPrototypeOf(subClass, superClass);
}
function $bf6ac2f87af55cf1$var$_setPrototypeOf(o, p) {
    $bf6ac2f87af55cf1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bf6ac2f87af55cf1$var$_setPrototypeOf(o, p);
}
function $bf6ac2f87af55cf1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bf6ac2f87af55cf1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bf6ac2f87af55cf1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bf6ac2f87af55cf1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bf6ac2f87af55cf1$var$_possibleConstructorReturn(this, result);
    };
}
function $bf6ac2f87af55cf1$var$_possibleConstructorReturn(self, call) {
    if (call && ($bf6ac2f87af55cf1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bf6ac2f87af55cf1$var$_assertThisInitialized(self);
}
function $bf6ac2f87af55cf1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bf6ac2f87af55cf1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bf6ac2f87af55cf1$var$_getPrototypeOf(o) {
    $bf6ac2f87af55cf1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bf6ac2f87af55cf1$var$_getPrototypeOf(o);
}
function $bf6ac2f87af55cf1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bf6ac2f87af55cf1$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    $bf6ac2f87af55cf1$var$_inherits(DayParser, _Parser);
    var _super = $bf6ac2f87af55cf1$var$_createSuper(DayParser);
    function DayParser() {
        var _this;
        $bf6ac2f87af55cf1$var$_classCallCheck(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $bf6ac2f87af55cf1$var$_defineProperty($bf6ac2f87af55cf1$var$_assertThisInitialized(_this), "priority", 90);
        $bf6ac2f87af55cf1$var$_defineProperty($bf6ac2f87af55cf1$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $bf6ac2f87af55cf1$var$_createClass(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("hCHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd47f247bdfd58ed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(2, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = (0, $esGEx.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("eglEX", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $a6235c79c7d2d223$export$44d1c127ab42c480);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
function $a6235c79c7d2d223$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a6235c79c7d2d223$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a6235c79c7d2d223$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a6235c79c7d2d223$var$_typeof(obj);
}
function $a6235c79c7d2d223$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6235c79c7d2d223$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a6235c79c7d2d223$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a6235c79c7d2d223$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a6235c79c7d2d223$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a6235c79c7d2d223$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a6235c79c7d2d223$var$_setPrototypeOf(subClass, superClass);
}
function $a6235c79c7d2d223$var$_setPrototypeOf(o, p) {
    $a6235c79c7d2d223$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a6235c79c7d2d223$var$_setPrototypeOf(o, p);
}
function $a6235c79c7d2d223$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a6235c79c7d2d223$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a6235c79c7d2d223$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a6235c79c7d2d223$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a6235c79c7d2d223$var$_possibleConstructorReturn(this, result);
    };
}
function $a6235c79c7d2d223$var$_possibleConstructorReturn(self, call) {
    if (call && ($a6235c79c7d2d223$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a6235c79c7d2d223$var$_assertThisInitialized(self);
}
function $a6235c79c7d2d223$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a6235c79c7d2d223$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a6235c79c7d2d223$var$_getPrototypeOf(o) {
    $a6235c79c7d2d223$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a6235c79c7d2d223$var$_getPrototypeOf(o);
}
function $a6235c79c7d2d223$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a6235c79c7d2d223$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    $a6235c79c7d2d223$var$_inherits(LocalDayParser, _Parser);
    var _super = $a6235c79c7d2d223$var$_createSuper(LocalDayParser);
    function LocalDayParser() {
        var _this;
        $a6235c79c7d2d223$var$_classCallCheck(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a6235c79c7d2d223$var$_defineProperty($a6235c79c7d2d223$var$_assertThisInitialized(_this), "priority", 90);
        $a6235c79c7d2d223$var$_defineProperty($a6235c79c7d2d223$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $a6235c79c7d2d223$var$_createClass(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7jfsL", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $55264d63d00b69b4$export$e447a647caaaec1d);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
function $55264d63d00b69b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $55264d63d00b69b4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $55264d63d00b69b4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $55264d63d00b69b4$var$_typeof(obj);
}
function $55264d63d00b69b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $55264d63d00b69b4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $55264d63d00b69b4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $55264d63d00b69b4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $55264d63d00b69b4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $55264d63d00b69b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $55264d63d00b69b4$var$_setPrototypeOf(subClass, superClass);
}
function $55264d63d00b69b4$var$_setPrototypeOf(o, p) {
    $55264d63d00b69b4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $55264d63d00b69b4$var$_setPrototypeOf(o, p);
}
function $55264d63d00b69b4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $55264d63d00b69b4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $55264d63d00b69b4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $55264d63d00b69b4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $55264d63d00b69b4$var$_possibleConstructorReturn(this, result);
    };
}
function $55264d63d00b69b4$var$_possibleConstructorReturn(self, call) {
    if (call && ($55264d63d00b69b4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $55264d63d00b69b4$var$_assertThisInitialized(self);
}
function $55264d63d00b69b4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $55264d63d00b69b4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $55264d63d00b69b4$var$_getPrototypeOf(o) {
    $55264d63d00b69b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $55264d63d00b69b4$var$_getPrototypeOf(o);
}
function $55264d63d00b69b4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $55264d63d00b69b4$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    $55264d63d00b69b4$var$_inherits(StandAloneLocalDayParser, _Parser);
    var _super = $55264d63d00b69b4$var$_createSuper(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        $55264d63d00b69b4$var$_classCallCheck(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $55264d63d00b69b4$var$_defineProperty($55264d63d00b69b4$var$_assertThisInitialized(_this), "priority", 90);
        $55264d63d00b69b4$var$_defineProperty($55264d63d00b69b4$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    $55264d63d00b69b4$var$_createClass(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7ANJo", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $587278c8279e961b$export$693fb1e525095b2a);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $ay6wS = parcelRequire("ay6wS");
function $587278c8279e961b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $587278c8279e961b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $587278c8279e961b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $587278c8279e961b$var$_typeof(obj);
}
function $587278c8279e961b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $587278c8279e961b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $587278c8279e961b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $587278c8279e961b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $587278c8279e961b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $587278c8279e961b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $587278c8279e961b$var$_setPrototypeOf(subClass, superClass);
}
function $587278c8279e961b$var$_setPrototypeOf(o, p) {
    $587278c8279e961b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $587278c8279e961b$var$_setPrototypeOf(o, p);
}
function $587278c8279e961b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $587278c8279e961b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $587278c8279e961b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $587278c8279e961b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $587278c8279e961b$var$_possibleConstructorReturn(this, result);
    };
}
function $587278c8279e961b$var$_possibleConstructorReturn(self, call) {
    if (call && ($587278c8279e961b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $587278c8279e961b$var$_assertThisInitialized(self);
}
function $587278c8279e961b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $587278c8279e961b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $587278c8279e961b$var$_getPrototypeOf(o) {
    $587278c8279e961b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $587278c8279e961b$var$_getPrototypeOf(o);
}
function $587278c8279e961b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $587278c8279e961b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    $587278c8279e961b$var$_inherits(ISODayParser, _Parser);
    var _super = $587278c8279e961b$var$_createSuper(ISODayParser);
    function ISODayParser() {
        var _this;
        $587278c8279e961b$var$_classCallCheck(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $587278c8279e961b$var$_defineProperty($587278c8279e961b$var$_assertThisInitialized(_this), "priority", 90);
        $587278c8279e961b$var$_defineProperty($587278c8279e961b$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $587278c8279e961b$var$_createClass(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $ay6wS.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("ay6wS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae224ed93d5e7cb$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4LmDH.default)(2, arguments);
    var day = (0, $esGEx.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("bUyT3", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $8abffc7926620950$export$8d1e08492351df91);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $8abffc7926620950$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8abffc7926620950$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8abffc7926620950$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8abffc7926620950$var$_typeof(obj);
}
function $8abffc7926620950$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8abffc7926620950$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8abffc7926620950$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8abffc7926620950$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8abffc7926620950$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8abffc7926620950$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8abffc7926620950$var$_setPrototypeOf(subClass, superClass);
}
function $8abffc7926620950$var$_setPrototypeOf(o, p) {
    $8abffc7926620950$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8abffc7926620950$var$_setPrototypeOf(o, p);
}
function $8abffc7926620950$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8abffc7926620950$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8abffc7926620950$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8abffc7926620950$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8abffc7926620950$var$_possibleConstructorReturn(this, result);
    };
}
function $8abffc7926620950$var$_possibleConstructorReturn(self, call) {
    if (call && ($8abffc7926620950$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8abffc7926620950$var$_assertThisInitialized(self);
}
function $8abffc7926620950$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8abffc7926620950$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8abffc7926620950$var$_getPrototypeOf(o) {
    $8abffc7926620950$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8abffc7926620950$var$_getPrototypeOf(o);
}
function $8abffc7926620950$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8abffc7926620950$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    $8abffc7926620950$var$_inherits(AMPMParser, _Parser);
    var _super = $8abffc7926620950$var$_createSuper(AMPMParser);
    function AMPMParser() {
        var _this;
        $8abffc7926620950$var$_classCallCheck(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $8abffc7926620950$var$_defineProperty($8abffc7926620950$var$_assertThisInitialized(_this), "priority", 80);
        $8abffc7926620950$var$_defineProperty($8abffc7926620950$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $8abffc7926620950$var$_createClass(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jYJCf", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $e8b7014308632edf$export$73ca2bd0a17d273);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $e8b7014308632edf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e8b7014308632edf$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e8b7014308632edf$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e8b7014308632edf$var$_typeof(obj);
}
function $e8b7014308632edf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e8b7014308632edf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e8b7014308632edf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e8b7014308632edf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e8b7014308632edf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e8b7014308632edf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e8b7014308632edf$var$_setPrototypeOf(subClass, superClass);
}
function $e8b7014308632edf$var$_setPrototypeOf(o, p) {
    $e8b7014308632edf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e8b7014308632edf$var$_setPrototypeOf(o, p);
}
function $e8b7014308632edf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e8b7014308632edf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e8b7014308632edf$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e8b7014308632edf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e8b7014308632edf$var$_possibleConstructorReturn(this, result);
    };
}
function $e8b7014308632edf$var$_possibleConstructorReturn(self, call) {
    if (call && ($e8b7014308632edf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e8b7014308632edf$var$_assertThisInitialized(self);
}
function $e8b7014308632edf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e8b7014308632edf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e8b7014308632edf$var$_getPrototypeOf(o) {
    $e8b7014308632edf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e8b7014308632edf$var$_getPrototypeOf(o);
}
function $e8b7014308632edf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e8b7014308632edf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    $e8b7014308632edf$var$_inherits(AMPMMidnightParser, _Parser);
    var _super = $e8b7014308632edf$var$_createSuper(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        $e8b7014308632edf$var$_classCallCheck(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e8b7014308632edf$var$_defineProperty($e8b7014308632edf$var$_assertThisInitialized(_this), "priority", 80);
        $e8b7014308632edf$var$_defineProperty($e8b7014308632edf$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $e8b7014308632edf$var$_createClass(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7q5qq", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $566f2b76640556a4$export$bb9212adf05373db);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $566f2b76640556a4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $566f2b76640556a4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $566f2b76640556a4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $566f2b76640556a4$var$_typeof(obj);
}
function $566f2b76640556a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $566f2b76640556a4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $566f2b76640556a4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $566f2b76640556a4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $566f2b76640556a4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $566f2b76640556a4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $566f2b76640556a4$var$_setPrototypeOf(subClass, superClass);
}
function $566f2b76640556a4$var$_setPrototypeOf(o, p) {
    $566f2b76640556a4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $566f2b76640556a4$var$_setPrototypeOf(o, p);
}
function $566f2b76640556a4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $566f2b76640556a4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $566f2b76640556a4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $566f2b76640556a4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $566f2b76640556a4$var$_possibleConstructorReturn(this, result);
    };
}
function $566f2b76640556a4$var$_possibleConstructorReturn(self, call) {
    if (call && ($566f2b76640556a4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $566f2b76640556a4$var$_assertThisInitialized(self);
}
function $566f2b76640556a4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $566f2b76640556a4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $566f2b76640556a4$var$_getPrototypeOf(o) {
    $566f2b76640556a4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $566f2b76640556a4$var$_getPrototypeOf(o);
}
function $566f2b76640556a4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $566f2b76640556a4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    $566f2b76640556a4$var$_inherits(DayPeriodParser, _Parser);
    var _super = $566f2b76640556a4$var$_createSuper(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        $566f2b76640556a4$var$_classCallCheck(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $566f2b76640556a4$var$_defineProperty($566f2b76640556a4$var$_assertThisInitialized(_this), "priority", 80);
        $566f2b76640556a4$var$_defineProperty($566f2b76640556a4$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    $566f2b76640556a4$var$_createClass(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $dVUCv.Parser));

});

parcelRegister("2ashg", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $1942733da4af1ace$export$8a04050a727a1756);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $1942733da4af1ace$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1942733da4af1ace$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1942733da4af1ace$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1942733da4af1ace$var$_typeof(obj);
}
function $1942733da4af1ace$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1942733da4af1ace$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1942733da4af1ace$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1942733da4af1ace$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1942733da4af1ace$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1942733da4af1ace$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1942733da4af1ace$var$_setPrototypeOf(subClass, superClass);
}
function $1942733da4af1ace$var$_setPrototypeOf(o, p) {
    $1942733da4af1ace$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1942733da4af1ace$var$_setPrototypeOf(o, p);
}
function $1942733da4af1ace$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1942733da4af1ace$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1942733da4af1ace$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1942733da4af1ace$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1942733da4af1ace$var$_possibleConstructorReturn(this, result);
    };
}
function $1942733da4af1ace$var$_possibleConstructorReturn(self, call) {
    if (call && ($1942733da4af1ace$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1942733da4af1ace$var$_assertThisInitialized(self);
}
function $1942733da4af1ace$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1942733da4af1ace$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1942733da4af1ace$var$_getPrototypeOf(o) {
    $1942733da4af1ace$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1942733da4af1ace$var$_getPrototypeOf(o);
}
function $1942733da4af1ace$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1942733da4af1ace$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    $1942733da4af1ace$var$_inherits(Hour1to12Parser, _Parser);
    var _super = $1942733da4af1ace$var$_createSuper(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        $1942733da4af1ace$var$_classCallCheck(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1942733da4af1ace$var$_defineProperty($1942733da4af1ace$var$_assertThisInitialized(_this), "priority", 70);
        $1942733da4af1ace$var$_defineProperty($1942733da4af1ace$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $1942733da4af1ace$var$_createClass(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("fGBwT", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $b6b7e3dd27c7b193$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b6b7e3dd27c7b193$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b6b7e3dd27c7b193$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b6b7e3dd27c7b193$var$_typeof(obj);
}
function $b6b7e3dd27c7b193$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b6b7e3dd27c7b193$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b6b7e3dd27c7b193$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b6b7e3dd27c7b193$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6b7e3dd27c7b193$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b6b7e3dd27c7b193$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b6b7e3dd27c7b193$var$_setPrototypeOf(subClass, superClass);
}
function $b6b7e3dd27c7b193$var$_setPrototypeOf(o, p) {
    $b6b7e3dd27c7b193$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b6b7e3dd27c7b193$var$_setPrototypeOf(o, p);
}
function $b6b7e3dd27c7b193$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b6b7e3dd27c7b193$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b6b7e3dd27c7b193$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b6b7e3dd27c7b193$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b6b7e3dd27c7b193$var$_possibleConstructorReturn(this, result);
    };
}
function $b6b7e3dd27c7b193$var$_possibleConstructorReturn(self, call) {
    if (call && ($b6b7e3dd27c7b193$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b6b7e3dd27c7b193$var$_assertThisInitialized(self);
}
function $b6b7e3dd27c7b193$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b6b7e3dd27c7b193$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b6b7e3dd27c7b193$var$_getPrototypeOf(o) {
    $b6b7e3dd27c7b193$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b6b7e3dd27c7b193$var$_getPrototypeOf(o);
}
function $b6b7e3dd27c7b193$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    $b6b7e3dd27c7b193$var$_inherits(Hour0to23Parser, _Parser);
    var _super = $b6b7e3dd27c7b193$var$_createSuper(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        $b6b7e3dd27c7b193$var$_classCallCheck(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b6b7e3dd27c7b193$var$_defineProperty($b6b7e3dd27c7b193$var$_assertThisInitialized(_this), "priority", 70);
        $b6b7e3dd27c7b193$var$_defineProperty($b6b7e3dd27c7b193$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $b6b7e3dd27c7b193$var$_createClass(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("1ZCjh", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1739347ee422fc25$export$cbbe855312f87d77);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $1739347ee422fc25$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1739347ee422fc25$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1739347ee422fc25$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1739347ee422fc25$var$_typeof(obj);
}
function $1739347ee422fc25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1739347ee422fc25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1739347ee422fc25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1739347ee422fc25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1739347ee422fc25$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1739347ee422fc25$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1739347ee422fc25$var$_setPrototypeOf(subClass, superClass);
}
function $1739347ee422fc25$var$_setPrototypeOf(o, p) {
    $1739347ee422fc25$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1739347ee422fc25$var$_setPrototypeOf(o, p);
}
function $1739347ee422fc25$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1739347ee422fc25$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1739347ee422fc25$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1739347ee422fc25$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1739347ee422fc25$var$_possibleConstructorReturn(this, result);
    };
}
function $1739347ee422fc25$var$_possibleConstructorReturn(self, call) {
    if (call && ($1739347ee422fc25$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1739347ee422fc25$var$_assertThisInitialized(self);
}
function $1739347ee422fc25$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1739347ee422fc25$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1739347ee422fc25$var$_getPrototypeOf(o) {
    $1739347ee422fc25$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1739347ee422fc25$var$_getPrototypeOf(o);
}
function $1739347ee422fc25$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1739347ee422fc25$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    $1739347ee422fc25$var$_inherits(Hour0To11Parser, _Parser);
    var _super = $1739347ee422fc25$var$_createSuper(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        $1739347ee422fc25$var$_classCallCheck(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1739347ee422fc25$var$_defineProperty($1739347ee422fc25$var$_assertThisInitialized(_this), "priority", 70);
        $1739347ee422fc25$var$_defineProperty($1739347ee422fc25$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $1739347ee422fc25$var$_createClass(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("8I45K", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $65759b4c9622f058$export$6008046d2b34b6a5);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $65759b4c9622f058$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $65759b4c9622f058$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $65759b4c9622f058$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $65759b4c9622f058$var$_typeof(obj);
}
function $65759b4c9622f058$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65759b4c9622f058$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $65759b4c9622f058$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $65759b4c9622f058$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $65759b4c9622f058$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $65759b4c9622f058$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $65759b4c9622f058$var$_setPrototypeOf(subClass, superClass);
}
function $65759b4c9622f058$var$_setPrototypeOf(o, p) {
    $65759b4c9622f058$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $65759b4c9622f058$var$_setPrototypeOf(o, p);
}
function $65759b4c9622f058$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $65759b4c9622f058$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $65759b4c9622f058$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $65759b4c9622f058$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $65759b4c9622f058$var$_possibleConstructorReturn(this, result);
    };
}
function $65759b4c9622f058$var$_possibleConstructorReturn(self, call) {
    if (call && ($65759b4c9622f058$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $65759b4c9622f058$var$_assertThisInitialized(self);
}
function $65759b4c9622f058$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $65759b4c9622f058$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $65759b4c9622f058$var$_getPrototypeOf(o) {
    $65759b4c9622f058$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $65759b4c9622f058$var$_getPrototypeOf(o);
}
function $65759b4c9622f058$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $65759b4c9622f058$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    $65759b4c9622f058$var$_inherits(Hour1To24Parser, _Parser);
    var _super = $65759b4c9622f058$var$_createSuper(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        $65759b4c9622f058$var$_classCallCheck(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $65759b4c9622f058$var$_defineProperty($65759b4c9622f058$var$_assertThisInitialized(_this), "priority", 70);
        $65759b4c9622f058$var$_defineProperty($65759b4c9622f058$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    $65759b4c9622f058$var$_createClass(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("ajDAU", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $782a6455ff67a7ae$export$2b52670d9e2be53);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $782a6455ff67a7ae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $782a6455ff67a7ae$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $782a6455ff67a7ae$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $782a6455ff67a7ae$var$_typeof(obj);
}
function $782a6455ff67a7ae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $782a6455ff67a7ae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $782a6455ff67a7ae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $782a6455ff67a7ae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $782a6455ff67a7ae$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $782a6455ff67a7ae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $782a6455ff67a7ae$var$_setPrototypeOf(subClass, superClass);
}
function $782a6455ff67a7ae$var$_setPrototypeOf(o, p) {
    $782a6455ff67a7ae$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $782a6455ff67a7ae$var$_setPrototypeOf(o, p);
}
function $782a6455ff67a7ae$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $782a6455ff67a7ae$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $782a6455ff67a7ae$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $782a6455ff67a7ae$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $782a6455ff67a7ae$var$_possibleConstructorReturn(this, result);
    };
}
function $782a6455ff67a7ae$var$_possibleConstructorReturn(self, call) {
    if (call && ($782a6455ff67a7ae$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $782a6455ff67a7ae$var$_assertThisInitialized(self);
}
function $782a6455ff67a7ae$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $782a6455ff67a7ae$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $782a6455ff67a7ae$var$_getPrototypeOf(o) {
    $782a6455ff67a7ae$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $782a6455ff67a7ae$var$_getPrototypeOf(o);
}
function $782a6455ff67a7ae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $782a6455ff67a7ae$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    $782a6455ff67a7ae$var$_inherits(MinuteParser, _Parser);
    var _super = $782a6455ff67a7ae$var$_createSuper(MinuteParser);
    function MinuteParser() {
        var _this;
        $782a6455ff67a7ae$var$_classCallCheck(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $782a6455ff67a7ae$var$_defineProperty($782a6455ff67a7ae$var$_assertThisInitialized(_this), "priority", 60);
        $782a6455ff67a7ae$var$_defineProperty($782a6455ff67a7ae$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $782a6455ff67a7ae$var$_createClass(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $dVUCv.Parser));

});

parcelRegister("9fJ56", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $6bc87bf726e3a9ef$export$94d46d540cf1366a);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $6bc87bf726e3a9ef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6bc87bf726e3a9ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6bc87bf726e3a9ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6bc87bf726e3a9ef$var$_typeof(obj);
}
function $6bc87bf726e3a9ef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6bc87bf726e3a9ef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6bc87bf726e3a9ef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6bc87bf726e3a9ef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6bc87bf726e3a9ef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6bc87bf726e3a9ef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6bc87bf726e3a9ef$var$_setPrototypeOf(subClass, superClass);
}
function $6bc87bf726e3a9ef$var$_setPrototypeOf(o, p) {
    $6bc87bf726e3a9ef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6bc87bf726e3a9ef$var$_setPrototypeOf(o, p);
}
function $6bc87bf726e3a9ef$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6bc87bf726e3a9ef$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6bc87bf726e3a9ef$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6bc87bf726e3a9ef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6bc87bf726e3a9ef$var$_possibleConstructorReturn(this, result);
    };
}
function $6bc87bf726e3a9ef$var$_possibleConstructorReturn(self, call) {
    if (call && ($6bc87bf726e3a9ef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6bc87bf726e3a9ef$var$_assertThisInitialized(self);
}
function $6bc87bf726e3a9ef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6bc87bf726e3a9ef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6bc87bf726e3a9ef$var$_getPrototypeOf(o) {
    $6bc87bf726e3a9ef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6bc87bf726e3a9ef$var$_getPrototypeOf(o);
}
function $6bc87bf726e3a9ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6bc87bf726e3a9ef$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    $6bc87bf726e3a9ef$var$_inherits(SecondParser, _Parser);
    var _super = $6bc87bf726e3a9ef$var$_createSuper(SecondParser);
    function SecondParser() {
        var _this;
        $6bc87bf726e3a9ef$var$_classCallCheck(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6bc87bf726e3a9ef$var$_defineProperty($6bc87bf726e3a9ef$var$_assertThisInitialized(_this), "priority", 50);
        $6bc87bf726e3a9ef$var$_defineProperty($6bc87bf726e3a9ef$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $6bc87bf726e3a9ef$var$_createClass(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("1If4X", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $13f598d9d9f39eef$export$b8e6f8b2d70893b1);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $13f598d9d9f39eef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $13f598d9d9f39eef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $13f598d9d9f39eef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $13f598d9d9f39eef$var$_typeof(obj);
}
function $13f598d9d9f39eef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13f598d9d9f39eef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $13f598d9d9f39eef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $13f598d9d9f39eef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $13f598d9d9f39eef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $13f598d9d9f39eef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $13f598d9d9f39eef$var$_setPrototypeOf(subClass, superClass);
}
function $13f598d9d9f39eef$var$_setPrototypeOf(o, p) {
    $13f598d9d9f39eef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13f598d9d9f39eef$var$_setPrototypeOf(o, p);
}
function $13f598d9d9f39eef$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $13f598d9d9f39eef$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $13f598d9d9f39eef$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $13f598d9d9f39eef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $13f598d9d9f39eef$var$_possibleConstructorReturn(this, result);
    };
}
function $13f598d9d9f39eef$var$_possibleConstructorReturn(self, call) {
    if (call && ($13f598d9d9f39eef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $13f598d9d9f39eef$var$_assertThisInitialized(self);
}
function $13f598d9d9f39eef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $13f598d9d9f39eef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $13f598d9d9f39eef$var$_getPrototypeOf(o) {
    $13f598d9d9f39eef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $13f598d9d9f39eef$var$_getPrototypeOf(o);
}
function $13f598d9d9f39eef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $13f598d9d9f39eef$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    $13f598d9d9f39eef$var$_inherits(FractionOfSecondParser, _Parser);
    var _super = $13f598d9d9f39eef$var$_createSuper(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        $13f598d9d9f39eef$var$_classCallCheck(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $13f598d9d9f39eef$var$_defineProperty($13f598d9d9f39eef$var$_assertThisInitialized(_this), "priority", 30);
        $13f598d9d9f39eef$var$_defineProperty($13f598d9d9f39eef$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $13f598d9d9f39eef$var$_createClass(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("cAns0", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $929b09a4780dfe0c$export$104d901d49fea29b);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $929b09a4780dfe0c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $929b09a4780dfe0c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $929b09a4780dfe0c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $929b09a4780dfe0c$var$_typeof(obj);
}
function $929b09a4780dfe0c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $929b09a4780dfe0c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $929b09a4780dfe0c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $929b09a4780dfe0c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $929b09a4780dfe0c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $929b09a4780dfe0c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $929b09a4780dfe0c$var$_setPrototypeOf(subClass, superClass);
}
function $929b09a4780dfe0c$var$_setPrototypeOf(o, p) {
    $929b09a4780dfe0c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $929b09a4780dfe0c$var$_setPrototypeOf(o, p);
}
function $929b09a4780dfe0c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $929b09a4780dfe0c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $929b09a4780dfe0c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $929b09a4780dfe0c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $929b09a4780dfe0c$var$_possibleConstructorReturn(this, result);
    };
}
function $929b09a4780dfe0c$var$_possibleConstructorReturn(self, call) {
    if (call && ($929b09a4780dfe0c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $929b09a4780dfe0c$var$_assertThisInitialized(self);
}
function $929b09a4780dfe0c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $929b09a4780dfe0c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $929b09a4780dfe0c$var$_getPrototypeOf(o) {
    $929b09a4780dfe0c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $929b09a4780dfe0c$var$_getPrototypeOf(o);
}
function $929b09a4780dfe0c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $929b09a4780dfe0c$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    $929b09a4780dfe0c$var$_inherits(ISOTimezoneWithZParser, _Parser);
    var _super = $929b09a4780dfe0c$var$_createSuper(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        $929b09a4780dfe0c$var$_classCallCheck(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $929b09a4780dfe0c$var$_defineProperty($929b09a4780dfe0c$var$_assertThisInitialized(_this), "priority", 10);
        $929b09a4780dfe0c$var$_defineProperty($929b09a4780dfe0c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    $929b09a4780dfe0c$var$_createClass(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $dVUCv.Parser));

});

parcelRegister("kuK4G", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $eeba5969587208af$export$12910e5204b52b9);

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
function $eeba5969587208af$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eeba5969587208af$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eeba5969587208af$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eeba5969587208af$var$_typeof(obj);
}
function $eeba5969587208af$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eeba5969587208af$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eeba5969587208af$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eeba5969587208af$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eeba5969587208af$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $eeba5969587208af$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $eeba5969587208af$var$_setPrototypeOf(subClass, superClass);
}
function $eeba5969587208af$var$_setPrototypeOf(o, p) {
    $eeba5969587208af$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eeba5969587208af$var$_setPrototypeOf(o, p);
}
function $eeba5969587208af$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eeba5969587208af$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $eeba5969587208af$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $eeba5969587208af$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $eeba5969587208af$var$_possibleConstructorReturn(this, result);
    };
}
function $eeba5969587208af$var$_possibleConstructorReturn(self, call) {
    if (call && ($eeba5969587208af$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $eeba5969587208af$var$_assertThisInitialized(self);
}
function $eeba5969587208af$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $eeba5969587208af$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $eeba5969587208af$var$_getPrototypeOf(o) {
    $eeba5969587208af$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $eeba5969587208af$var$_getPrototypeOf(o);
}
function $eeba5969587208af$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $eeba5969587208af$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    $eeba5969587208af$var$_inherits(ISOTimezoneParser, _Parser);
    var _super = $eeba5969587208af$var$_createSuper(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        $eeba5969587208af$var$_classCallCheck(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $eeba5969587208af$var$_defineProperty($eeba5969587208af$var$_assertThisInitialized(_this), "priority", 10);
        $eeba5969587208af$var$_defineProperty($eeba5969587208af$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    $eeba5969587208af$var$_createClass(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jhVfr", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $e0ac031eec4beddf$export$2cd8bf877a05e96);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $e0ac031eec4beddf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e0ac031eec4beddf$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e0ac031eec4beddf$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e0ac031eec4beddf$var$_typeof(obj);
}
function $e0ac031eec4beddf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e0ac031eec4beddf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e0ac031eec4beddf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e0ac031eec4beddf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e0ac031eec4beddf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e0ac031eec4beddf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e0ac031eec4beddf$var$_setPrototypeOf(subClass, superClass);
}
function $e0ac031eec4beddf$var$_setPrototypeOf(o, p) {
    $e0ac031eec4beddf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0ac031eec4beddf$var$_setPrototypeOf(o, p);
}
function $e0ac031eec4beddf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e0ac031eec4beddf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e0ac031eec4beddf$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e0ac031eec4beddf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e0ac031eec4beddf$var$_possibleConstructorReturn(this, result);
    };
}
function $e0ac031eec4beddf$var$_possibleConstructorReturn(self, call) {
    if (call && ($e0ac031eec4beddf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e0ac031eec4beddf$var$_assertThisInitialized(self);
}
function $e0ac031eec4beddf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e0ac031eec4beddf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e0ac031eec4beddf$var$_getPrototypeOf(o) {
    $e0ac031eec4beddf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e0ac031eec4beddf$var$_getPrototypeOf(o);
}
function $e0ac031eec4beddf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e0ac031eec4beddf$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    $e0ac031eec4beddf$var$_inherits(TimestampSecondsParser, _Parser);
    var _super = $e0ac031eec4beddf$var$_createSuper(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        $e0ac031eec4beddf$var$_classCallCheck(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e0ac031eec4beddf$var$_defineProperty($e0ac031eec4beddf$var$_assertThisInitialized(_this), "priority", 40);
        $e0ac031eec4beddf$var$_defineProperty($e0ac031eec4beddf$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $e0ac031eec4beddf$var$_createClass(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gDlDV", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $c1c113b2a9b78e15$export$6d8f69c6906d6368);

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
function $c1c113b2a9b78e15$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c1c113b2a9b78e15$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c1c113b2a9b78e15$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c1c113b2a9b78e15$var$_typeof(obj);
}
function $c1c113b2a9b78e15$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1c113b2a9b78e15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c1c113b2a9b78e15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1c113b2a9b78e15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1c113b2a9b78e15$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c1c113b2a9b78e15$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c1c113b2a9b78e15$var$_setPrototypeOf(subClass, superClass);
}
function $c1c113b2a9b78e15$var$_setPrototypeOf(o, p) {
    $c1c113b2a9b78e15$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1c113b2a9b78e15$var$_setPrototypeOf(o, p);
}
function $c1c113b2a9b78e15$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c1c113b2a9b78e15$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c1c113b2a9b78e15$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c1c113b2a9b78e15$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c1c113b2a9b78e15$var$_possibleConstructorReturn(this, result);
    };
}
function $c1c113b2a9b78e15$var$_possibleConstructorReturn(self, call) {
    if (call && ($c1c113b2a9b78e15$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c1c113b2a9b78e15$var$_assertThisInitialized(self);
}
function $c1c113b2a9b78e15$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c1c113b2a9b78e15$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c1c113b2a9b78e15$var$_getPrototypeOf(o) {
    $c1c113b2a9b78e15$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1c113b2a9b78e15$var$_getPrototypeOf(o);
}
function $c1c113b2a9b78e15$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c1c113b2a9b78e15$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    $c1c113b2a9b78e15$var$_inherits(TimestampMillisecondsParser, _Parser);
    var _super = $c1c113b2a9b78e15$var$_createSuper(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        $c1c113b2a9b78e15$var$_classCallCheck(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c1c113b2a9b78e15$var$_defineProperty($c1c113b2a9b78e15$var$_assertThisInitialized(_this), "priority", 20);
        $c1c113b2a9b78e15$var$_defineProperty($c1c113b2a9b78e15$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $c1c113b2a9b78e15$var$_createClass(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $dVUCv.Parser));

});



parcelRegister("hd4PZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c877673681ebf3f8$var$isValid;

var $c877673681ebf3f8$var$_index = $c877673681ebf3f8$var$_interopRequireDefault((parcelRequire("iBMsA")));

var $c877673681ebf3f8$var$_index2 = $c877673681ebf3f8$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $c877673681ebf3f8$var$_index3 = $c877673681ebf3f8$var$_interopRequireDefault((parcelRequire("KC37V")));
function $c877673681ebf3f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $c877673681ebf3f8$var$isValid(dirtyDate) {
    (0, $c877673681ebf3f8$var$_index3.default)(1, arguments);
    if (!(0, $c877673681ebf3f8$var$_index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $c877673681ebf3f8$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});
parcelRegister("iBMsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8c145da40008c03$var$isDate;

var $d8c145da40008c03$var$_index = $d8c145da40008c03$var$_interopRequireDefault((parcelRequire("KC37V")));
function $d8c145da40008c03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d8c145da40008c03$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d8c145da40008c03$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d8c145da40008c03$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d8c145da40008c03$var$_typeof(obj);
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $d8c145da40008c03$var$isDate(value) {
    (0, $d8c145da40008c03$var$_index.default)(1, arguments);
    return value instanceof Date || $d8c145da40008c03$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = module.exports.default;

});
parcelRegister("KC37V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08c1cfd134d45f5c$var$requiredArgs;
function $08c1cfd134d45f5c$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});


parcelRegister("j6xwb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de8893d6e3a73192$var$toDate;

var $de8893d6e3a73192$var$_index = $de8893d6e3a73192$var$_interopRequireDefault((parcelRequire("KC37V")));
function $de8893d6e3a73192$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $de8893d6e3a73192$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $de8893d6e3a73192$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $de8893d6e3a73192$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $de8893d6e3a73192$var$_typeof(obj);
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $de8893d6e3a73192$var$toDate(argument) {
    (0, $de8893d6e3a73192$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $de8893d6e3a73192$var$_typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});


parcelRegister("bwb8V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $862b53a0b2b68362$var$subMilliseconds;

var $862b53a0b2b68362$var$_index = $862b53a0b2b68362$var$_interopRequireDefault((parcelRequire("9xjCn")));

var $862b53a0b2b68362$var$_index2 = $862b53a0b2b68362$var$_interopRequireDefault((parcelRequire("KC37V")));

var $862b53a0b2b68362$var$_index3 = $862b53a0b2b68362$var$_interopRequireDefault((parcelRequire("gXISN")));
function $862b53a0b2b68362$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $862b53a0b2b68362$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $862b53a0b2b68362$var$_index2.default)(2, arguments);
    var amount = (0, $862b53a0b2b68362$var$_index3.default)(dirtyAmount);
    return (0, $862b53a0b2b68362$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("9xjCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f1669decf85998c$var$addMilliseconds;

var $6f1669decf85998c$var$_index = $6f1669decf85998c$var$_interopRequireDefault((parcelRequire("gXISN")));

var $6f1669decf85998c$var$_index2 = $6f1669decf85998c$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $6f1669decf85998c$var$_index3 = $6f1669decf85998c$var$_interopRequireDefault((parcelRequire("KC37V")));
function $6f1669decf85998c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $6f1669decf85998c$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $6f1669decf85998c$var$_index3.default)(2, arguments);
    var timestamp = (0, $6f1669decf85998c$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $6f1669decf85998c$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});
parcelRegister("gXISN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c594f8cbaedc1c23$var$toInteger;
function $c594f8cbaedc1c23$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});



parcelRegister("gbhVa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc7b932f4bb7f27d$var$_index = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("4s493")));

var $bc7b932f4bb7f27d$var$_index2 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("4xBqW")));

var $bc7b932f4bb7f27d$var$_index3 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("a33Wj")));

var $bc7b932f4bb7f27d$var$_index4 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("8OLS0")));

var $bc7b932f4bb7f27d$var$_index5 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("jYjaC")));

var $bc7b932f4bb7f27d$var$_index6 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("hpcfL")));

var $bc7b932f4bb7f27d$var$_index7 = $bc7b932f4bb7f27d$var$_interopRequireDefault((parcelRequire("bqIZz")));
function $bc7b932f4bb7f27d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bc7b932f4bb7f27d$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $bc7b932f4bb7f27d$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $bc7b932f4bb7f27d$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $bc7b932f4bb7f27d$var$_index5.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $bc7b932f4bb7f27d$var$_index6.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $bc7b932f4bb7f27d$var$_index3.default)(date); // Padding
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $bc7b932f4bb7f27d$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bc7b932f4bb7f27d$var$_index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $bc7b932f4bb7f27d$var$_index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $bc7b932f4bb7f27d$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $bc7b932f4bb7f27d$var$_index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $bc7b932f4bb7f27d$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $bc7b932f4bb7f27d$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $bc7b932f4bb7f27d$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $bc7b932f4bb7f27d$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $bc7b932f4bb7f27d$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $bc7b932f4bb7f27d$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $bc7b932f4bb7f27d$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $bc7b932f4bb7f27d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $bc7b932f4bb7f27d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $bc7b932f4bb7f27d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $bc7b932f4bb7f27d$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $bc7b932f4bb7f27d$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $bc7b932f4bb7f27d$var$_index6.default)(timestamp, token.length);
    }
};
function $bc7b932f4bb7f27d$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $bc7b932f4bb7f27d$var$_index6.default)(minutes, 2);
}
function $bc7b932f4bb7f27d$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $bc7b932f4bb7f27d$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $bc7b932f4bb7f27d$var$formatTimezone(offset, dirtyDelimiter);
}
function $bc7b932f4bb7f27d$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $bc7b932f4bb7f27d$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $bc7b932f4bb7f27d$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $bc7b932f4bb7f27d$var$_default = $bc7b932f4bb7f27d$var$formatters;
module.exports.default = $bc7b932f4bb7f27d$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4s493", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33dcfe0ed5be7064$var$getUTCDayOfYear;

var $33dcfe0ed5be7064$var$_index = $33dcfe0ed5be7064$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $33dcfe0ed5be7064$var$_index2 = $33dcfe0ed5be7064$var$_interopRequireDefault((parcelRequire("KC37V")));
function $33dcfe0ed5be7064$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $33dcfe0ed5be7064$var$MILLISECONDS_IN_DAY = 86400000;
function $33dcfe0ed5be7064$var$getUTCDayOfYear(dirtyDate) {
    (0, $33dcfe0ed5be7064$var$_index2.default)(1, arguments);
    var date = (0, $33dcfe0ed5be7064$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $33dcfe0ed5be7064$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("4xBqW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34e7480543268dfc$var$getUTCISOWeek;

var $34e7480543268dfc$var$_index = $34e7480543268dfc$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $34e7480543268dfc$var$_index2 = $34e7480543268dfc$var$_interopRequireDefault((parcelRequire("3dTBW")));

var $34e7480543268dfc$var$_index3 = $34e7480543268dfc$var$_interopRequireDefault((parcelRequire("cuYba")));

var $34e7480543268dfc$var$_index4 = $34e7480543268dfc$var$_interopRequireDefault((parcelRequire("KC37V")));
function $34e7480543268dfc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34e7480543268dfc$var$MILLISECONDS_IN_WEEK = 604800000;
function $34e7480543268dfc$var$getUTCISOWeek(dirtyDate) {
    (0, $34e7480543268dfc$var$_index4.default)(1, arguments);
    var date = (0, $34e7480543268dfc$var$_index.default)(dirtyDate);
    var diff = (0, $34e7480543268dfc$var$_index2.default)(date).getTime() - (0, $34e7480543268dfc$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $34e7480543268dfc$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("3dTBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $258db92ca1ced022$var$startOfUTCISOWeek;

var $258db92ca1ced022$var$_index = $258db92ca1ced022$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $258db92ca1ced022$var$_index2 = $258db92ca1ced022$var$_interopRequireDefault((parcelRequire("KC37V")));
function $258db92ca1ced022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $258db92ca1ced022$var$startOfUTCISOWeek(dirtyDate) {
    (0, $258db92ca1ced022$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $258db92ca1ced022$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cuYba", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9196f7b1f78a0b0b$var$startOfUTCISOWeekYear;

var $9196f7b1f78a0b0b$var$_index = $9196f7b1f78a0b0b$var$_interopRequireDefault((parcelRequire("a33Wj")));

var $9196f7b1f78a0b0b$var$_index2 = $9196f7b1f78a0b0b$var$_interopRequireDefault((parcelRequire("3dTBW")));

var $9196f7b1f78a0b0b$var$_index3 = $9196f7b1f78a0b0b$var$_interopRequireDefault((parcelRequire("KC37V")));
function $9196f7b1f78a0b0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9196f7b1f78a0b0b$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $9196f7b1f78a0b0b$var$_index3.default)(1, arguments);
    var year = (0, $9196f7b1f78a0b0b$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $9196f7b1f78a0b0b$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("a33Wj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $750d3d86be6350d4$var$getUTCISOWeekYear;

var $750d3d86be6350d4$var$_index = $750d3d86be6350d4$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $750d3d86be6350d4$var$_index2 = $750d3d86be6350d4$var$_interopRequireDefault((parcelRequire("KC37V")));

var $750d3d86be6350d4$var$_index3 = $750d3d86be6350d4$var$_interopRequireDefault((parcelRequire("3dTBW")));
function $750d3d86be6350d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $750d3d86be6350d4$var$getUTCISOWeekYear(dirtyDate) {
    (0, $750d3d86be6350d4$var$_index2.default)(1, arguments);
    var date = (0, $750d3d86be6350d4$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $750d3d86be6350d4$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $750d3d86be6350d4$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("8OLS0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66b8204224d690f0$var$getUTCWeek;

var $66b8204224d690f0$var$_index = $66b8204224d690f0$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $66b8204224d690f0$var$_index2 = $66b8204224d690f0$var$_interopRequireDefault((parcelRequire("bmOlp")));

var $66b8204224d690f0$var$_index3 = $66b8204224d690f0$var$_interopRequireDefault((parcelRequire("jWHAr")));

var $66b8204224d690f0$var$_index4 = $66b8204224d690f0$var$_interopRequireDefault((parcelRequire("KC37V")));
function $66b8204224d690f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $66b8204224d690f0$var$MILLISECONDS_IN_WEEK = 604800000;
function $66b8204224d690f0$var$getUTCWeek(dirtyDate, options) {
    (0, $66b8204224d690f0$var$_index4.default)(1, arguments);
    var date = (0, $66b8204224d690f0$var$_index.default)(dirtyDate);
    var diff = (0, $66b8204224d690f0$var$_index2.default)(date, options).getTime() - (0, $66b8204224d690f0$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $66b8204224d690f0$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("bmOlp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8468cd1e55185c19$var$startOfUTCWeek;

var $8468cd1e55185c19$var$_index = $8468cd1e55185c19$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $8468cd1e55185c19$var$_index2 = $8468cd1e55185c19$var$_interopRequireDefault((parcelRequire("KC37V")));

var $8468cd1e55185c19$var$_index3 = $8468cd1e55185c19$var$_interopRequireDefault((parcelRequire("gXISN")));

var $4SVS3 = parcelRequire("4SVS3");
function $8468cd1e55185c19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8468cd1e55185c19$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $8468cd1e55185c19$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $4SVS3.getDefaultOptions)();
    var weekStartsOn = (0, $8468cd1e55185c19$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8468cd1e55185c19$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("4SVS3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $38e91888e505cc6c$var$getDefaultOptions;
module.exports.setDefaultOptions = $38e91888e505cc6c$var$setDefaultOptions;
var $38e91888e505cc6c$var$defaultOptions = {};
function $38e91888e505cc6c$var$getDefaultOptions() {
    return $38e91888e505cc6c$var$defaultOptions;
}
function $38e91888e505cc6c$var$setDefaultOptions(newOptions) {
    $38e91888e505cc6c$var$defaultOptions = newOptions;
}

});


parcelRegister("jWHAr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8553e84048e7698$var$startOfUTCWeekYear;

var $e8553e84048e7698$var$_index = $e8553e84048e7698$var$_interopRequireDefault((parcelRequire("jYjaC")));

var $e8553e84048e7698$var$_index2 = $e8553e84048e7698$var$_interopRequireDefault((parcelRequire("KC37V")));

var $e8553e84048e7698$var$_index3 = $e8553e84048e7698$var$_interopRequireDefault((parcelRequire("bmOlp")));

var $e8553e84048e7698$var$_index4 = $e8553e84048e7698$var$_interopRequireDefault((parcelRequire("gXISN")));

var $4SVS3 = parcelRequire("4SVS3");
function $e8553e84048e7698$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8553e84048e7698$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e8553e84048e7698$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $4SVS3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $e8553e84048e7698$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $e8553e84048e7698$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $e8553e84048e7698$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("jYjaC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8a27db99388718c$var$getUTCWeekYear;

var $e8a27db99388718c$var$_index = $e8a27db99388718c$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $e8a27db99388718c$var$_index2 = $e8a27db99388718c$var$_interopRequireDefault((parcelRequire("KC37V")));

var $e8a27db99388718c$var$_index3 = $e8a27db99388718c$var$_interopRequireDefault((parcelRequire("bmOlp")));

var $e8a27db99388718c$var$_index4 = $e8a27db99388718c$var$_interopRequireDefault((parcelRequire("gXISN")));

var $4SVS3 = parcelRequire("4SVS3");
function $e8a27db99388718c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8a27db99388718c$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e8a27db99388718c$var$_index2.default)(1, arguments);
    var date = (0, $e8a27db99388718c$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4SVS3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $e8a27db99388718c$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e8a27db99388718c$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e8a27db99388718c$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("hpcfL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cabe46b15880b68c$var$addLeadingZeros;
function $cabe46b15880b68c$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("bqIZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $852505eaefa031f3$var$_index = $852505eaefa031f3$var$_interopRequireDefault((parcelRequire("hpcfL")));
function $852505eaefa031f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $852505eaefa031f3$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $852505eaefa031f3$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $852505eaefa031f3$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $852505eaefa031f3$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $852505eaefa031f3$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $852505eaefa031f3$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $852505eaefa031f3$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $852505eaefa031f3$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $852505eaefa031f3$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $852505eaefa031f3$var$_default = $852505eaefa031f3$var$formatters;
module.exports.default = $852505eaefa031f3$var$_default;
module.exports = module.exports.default;

});


parcelRegister("cPeQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9565c34afda93dca$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $9565c34afda93dca$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $9565c34afda93dca$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9565c34afda93dca$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $9565c34afda93dca$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $9565c34afda93dca$var$timeLongFormatter(timePattern, formatLong));
};
var $9565c34afda93dca$var$longFormatters = {
    p: $9565c34afda93dca$var$timeLongFormatter,
    P: $9565c34afda93dca$var$dateTimeLongFormatter
};
var $9565c34afda93dca$var$_default = $9565c34afda93dca$var$longFormatters;
module.exports.default = $9565c34afda93dca$var$_default;
module.exports = module.exports.default;

});

parcelRegister("hxMZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc5b85695a3eeb7b$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $cc5b85695a3eeb7b$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("7LTOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8837ecd5cf1aee$var$_index = $5a8837ecd5cf1aee$var$_interopRequireDefault((parcelRequire("g7MZE")));
function $5a8837ecd5cf1aee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5a8837ecd5cf1aee$var$_default = $5a8837ecd5cf1aee$var$_index.default;
module.exports.default = $5a8837ecd5cf1aee$var$_default;
module.exports = module.exports.default;

});
parcelRegister("g7MZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbd34ddcbc069fa5$var$_index = $bbd34ddcbc069fa5$var$_interopRequireDefault((parcelRequire("kAGaU")));

var $bbd34ddcbc069fa5$var$_index2 = $bbd34ddcbc069fa5$var$_interopRequireDefault((parcelRequire("kft0I")));

var $bbd34ddcbc069fa5$var$_index3 = $bbd34ddcbc069fa5$var$_interopRequireDefault((parcelRequire("1h2xg")));

var $bbd34ddcbc069fa5$var$_index4 = $bbd34ddcbc069fa5$var$_interopRequireDefault((parcelRequire("ambYg")));

var $bbd34ddcbc069fa5$var$_index5 = $bbd34ddcbc069fa5$var$_interopRequireDefault((parcelRequire("gJ3hi")));
function $bbd34ddcbc069fa5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $bbd34ddcbc069fa5$var$locale = {
    code: 'en-US',
    formatDistance: $bbd34ddcbc069fa5$var$_index.default,
    formatLong: $bbd34ddcbc069fa5$var$_index2.default,
    formatRelative: $bbd34ddcbc069fa5$var$_index3.default,
    localize: $bbd34ddcbc069fa5$var$_index4.default,
    match: $bbd34ddcbc069fa5$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $bbd34ddcbc069fa5$var$_default = $bbd34ddcbc069fa5$var$locale;
module.exports.default = $bbd34ddcbc069fa5$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kAGaU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $efd7e287fab7c824$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $efd7e287fab7c824$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $efd7e287fab7c824$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $efd7e287fab7c824$var$_default = $efd7e287fab7c824$var$formatDistance;
module.exports.default = $efd7e287fab7c824$var$_default;
module.exports = module.exports.default;

});

parcelRegister("kft0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebdbb63b90814a94$var$_index = $ebdbb63b90814a94$var$_interopRequireDefault((parcelRequire("d0MwY")));
function $ebdbb63b90814a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ebdbb63b90814a94$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $ebdbb63b90814a94$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $ebdbb63b90814a94$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ebdbb63b90814a94$var$formatLong = {
    date: (0, $ebdbb63b90814a94$var$_index.default)({
        formats: $ebdbb63b90814a94$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ebdbb63b90814a94$var$_index.default)({
        formats: $ebdbb63b90814a94$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ebdbb63b90814a94$var$_index.default)({
        formats: $ebdbb63b90814a94$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ebdbb63b90814a94$var$_default = $ebdbb63b90814a94$var$formatLong;
module.exports.default = $ebdbb63b90814a94$var$_default;
module.exports = module.exports.default;

});
parcelRegister("d0MwY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9790ebacfc4c5a1c$var$buildFormatLongFn;
function $9790ebacfc4c5a1c$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("1h2xg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $0ed9587bc52056a6$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $0ed9587bc52056a6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0ed9587bc52056a6$var$formatRelativeLocale[token];
};
var $0ed9587bc52056a6$var$_default = $0ed9587bc52056a6$var$formatRelative;
module.exports.default = $0ed9587bc52056a6$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ambYg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01f2262bf627fb26$var$_index = $01f2262bf627fb26$var$_interopRequireDefault((parcelRequire("9M0IH")));
function $01f2262bf627fb26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01f2262bf627fb26$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $01f2262bf627fb26$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $01f2262bf627fb26$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $01f2262bf627fb26$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $01f2262bf627fb26$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $01f2262bf627fb26$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $01f2262bf627fb26$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $01f2262bf627fb26$var$localize = {
    ordinalNumber: $01f2262bf627fb26$var$ordinalNumber,
    era: (0, $01f2262bf627fb26$var$_index.default)({
        values: $01f2262bf627fb26$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $01f2262bf627fb26$var$_index.default)({
        values: $01f2262bf627fb26$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $01f2262bf627fb26$var$_index.default)({
        values: $01f2262bf627fb26$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $01f2262bf627fb26$var$_index.default)({
        values: $01f2262bf627fb26$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $01f2262bf627fb26$var$_index.default)({
        values: $01f2262bf627fb26$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $01f2262bf627fb26$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $01f2262bf627fb26$var$_default = $01f2262bf627fb26$var$localize;
module.exports.default = $01f2262bf627fb26$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9M0IH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71d927b7b763dc94$var$buildLocalizeFn;
function $71d927b7b763dc94$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("gJ3hi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2d36441156d95a1$var$_index = $c2d36441156d95a1$var$_interopRequireDefault((parcelRequire("lyL2K")));

var $c2d36441156d95a1$var$_index2 = $c2d36441156d95a1$var$_interopRequireDefault((parcelRequire("ciuzP")));
function $c2d36441156d95a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2d36441156d95a1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $c2d36441156d95a1$var$parseOrdinalNumberPattern = /\d+/i;
var $c2d36441156d95a1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $c2d36441156d95a1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $c2d36441156d95a1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $c2d36441156d95a1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c2d36441156d95a1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $c2d36441156d95a1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $c2d36441156d95a1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $c2d36441156d95a1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $c2d36441156d95a1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $c2d36441156d95a1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $c2d36441156d95a1$var$match = {
    ordinalNumber: (0, $c2d36441156d95a1$var$_index2.default)({
        matchPattern: $c2d36441156d95a1$var$matchOrdinalNumberPattern,
        parsePattern: $c2d36441156d95a1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c2d36441156d95a1$var$_index.default)({
        matchPatterns: $c2d36441156d95a1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2d36441156d95a1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $c2d36441156d95a1$var$_index.default)({
        matchPatterns: $c2d36441156d95a1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2d36441156d95a1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c2d36441156d95a1$var$_index.default)({
        matchPatterns: $c2d36441156d95a1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2d36441156d95a1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $c2d36441156d95a1$var$_index.default)({
        matchPatterns: $c2d36441156d95a1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c2d36441156d95a1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $c2d36441156d95a1$var$_index.default)({
        matchPatterns: $c2d36441156d95a1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c2d36441156d95a1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c2d36441156d95a1$var$_default = $c2d36441156d95a1$var$match;
module.exports.default = $c2d36441156d95a1$var$_default;
module.exports = module.exports.default;

});
parcelRegister("lyL2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb2143c744905073$var$buildMatchFn;
function $fb2143c744905073$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $fb2143c744905073$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $fb2143c744905073$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $fb2143c744905073$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $fb2143c744905073$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("ciuzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f3ee263b4612003$var$buildMatchPatternFn;
function $8f3ee263b4612003$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});




parcelRegister("cLApH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94b61ec730dbb2d9$var$assign;
function $94b61ec730dbb2d9$var$assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("6ye6I", function(module, exports) {

$parcel$export(module.exports, "schema", () => schema);
$parcel$export(module.exports, "normalize", () => normalize$1);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */ /**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */ function isImmutable(object) {
    return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
    object._map && object._map.hasOwnProperty('__ownerID'))); // Immutable.Record
}
/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */ function denormalizeImmutable(schema, input, unvisit) {
    return Object.keys(schema).reduce(function(object, key) {
        // Immutable maps cast keys to strings on write so we need to ensure
        // we're accessing them using string keys.
        var stringKey = "" + key;
        if (object.has(stringKey)) return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
        else return object;
    }, input);
}
var getDefaultGetId = function getDefaultGetId(idAttribute) {
    return function(input) {
        return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
    };
};
var EntitySchema = /*#__PURE__*/ function() {
    function EntitySchema(key, definition, options) {
        if (definition === void 0) definition = {};
        if (options === void 0) options = {};
        if (!key || typeof key !== 'string') throw new Error("Expected a string key for Entity, but found " + key + ".");
        var _options = options, _options$idAttribute = _options.idAttribute, idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute, _options$mergeStrateg = _options.mergeStrategy, mergeStrategy = _options$mergeStrateg === void 0 ? function(entityA, entityB) {
            return _extends({}, entityA, entityB);
        } : _options$mergeStrateg, _options$processStrat = _options.processStrategy, processStrategy = _options$processStrat === void 0 ? function(input) {
            return _extends({}, input);
        } : _options$processStrat, _options$fallbackStra = _options.fallbackStrategy, fallbackStrategy = _options$fallbackStra === void 0 ? function(key, schema) {
            return undefined;
        } : _options$fallbackStra;
        this._key = key;
        this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
        this._idAttribute = idAttribute;
        this._mergeStrategy = mergeStrategy;
        this._processStrategy = processStrategy;
        this._fallbackStrategy = fallbackStrategy;
        this.define(definition);
    }
    var _proto = EntitySchema.prototype;
    _proto.define = function define(definition) {
        this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
            var _extends2;
            var schema = definition[key];
            return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
        }, this.schema || {});
    };
    _proto.getId = function getId(input, parent, key) {
        return this._getId(input, parent, key);
    };
    _proto.merge = function merge(entityA, entityB) {
        return this._mergeStrategy(entityA, entityB);
    };
    _proto.fallback = function fallback(id, schema) {
        return this._fallbackStrategy(id, schema);
    };
    _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
        var _this = this;
        var id = this.getId(input, parent, key);
        var entityType = this.key;
        if (!(entityType in visitedEntities)) visitedEntities[entityType] = {};
        if (!(id in visitedEntities[entityType])) visitedEntities[entityType][id] = [];
        if (visitedEntities[entityType][id].some(function(entity) {
            return entity === input;
        })) return id;
        visitedEntities[entityType][id].push(input);
        var processedEntity = this._processStrategy(input, parent, key);
        Object.keys(this.schema).forEach(function(key) {
            if (processedEntity.hasOwnProperty(key) && typeof processedEntity[key] === 'object') {
                var schema = _this.schema[key];
                var resolvedSchema = typeof schema === 'function' ? schema(input) : schema;
                processedEntity[key] = visit(processedEntity[key], processedEntity, key, resolvedSchema, addEntity, visitedEntities);
            }
        });
        addEntity(this, processedEntity, input, parent, key);
        return id;
    };
    _proto.denormalize = function denormalize(entity, unvisit) {
        var _this2 = this;
        if (isImmutable(entity)) return denormalizeImmutable(this.schema, entity, unvisit);
        Object.keys(this.schema).forEach(function(key) {
            if (entity.hasOwnProperty(key)) {
                var schema = _this2.schema[key];
                entity[key] = unvisit(entity[key], schema);
            }
        });
        return entity;
    };
    _createClass(EntitySchema, [
        {
            key: "key",
            get: function get() {
                return this._key;
            }
        },
        {
            key: "idAttribute",
            get: function get() {
                return this._idAttribute;
            }
        }
    ]);
    return EntitySchema;
}();
var PolymorphicSchema = /*#__PURE__*/ function() {
    function PolymorphicSchema(definition, schemaAttribute) {
        if (schemaAttribute) this._schemaAttribute = typeof schemaAttribute === 'string' ? function(input) {
            return input[schemaAttribute];
        } : schemaAttribute;
        this.define(definition);
    }
    var _proto = PolymorphicSchema.prototype;
    _proto.define = function define(definition) {
        this.schema = definition;
    };
    _proto.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
        return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
    };
    _proto.inferSchema = function inferSchema(input, parent, key) {
        if (this.isSingleSchema) return this.schema;
        var attr = this.getSchemaAttribute(input, parent, key);
        return this.schema[attr];
    };
    _proto.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity, visitedEntities) {
        var schema = this.inferSchema(value, parent, key);
        if (!schema) return value;
        var normalizedValue = visit(value, parent, key, schema, addEntity, visitedEntities);
        return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
            id: normalizedValue,
            schema: this.getSchemaAttribute(value, parent, key)
        };
    };
    _proto.denormalizeValue = function denormalizeValue(value, unvisit) {
        var schemaKey = isImmutable(value) ? value.get('schema') : value.schema;
        if (!this.isSingleSchema && !schemaKey) return value;
        var id = this.isSingleSchema ? undefined : isImmutable(value) ? value.get('id') : value.id;
        var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
        return unvisit(id || value, schema);
    };
    _createClass(PolymorphicSchema, [
        {
            key: "isSingleSchema",
            get: function get() {
                return !this._schemaAttribute;
            }
        }
    ]);
    return PolymorphicSchema;
}();
var UnionSchema = /*#__PURE__*/ function(_PolymorphicSchema) {
    _inheritsLoose(UnionSchema, _PolymorphicSchema);
    function UnionSchema(definition, schemaAttribute) {
        if (!schemaAttribute) throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
        return _PolymorphicSchema.call(this, definition, schemaAttribute) || this;
    }
    var _proto = UnionSchema.prototype;
    _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
        return this.normalizeValue(input, parent, key, visit, addEntity, visitedEntities);
    };
    _proto.denormalize = function denormalize(input, unvisit) {
        return this.denormalizeValue(input, unvisit);
    };
    return UnionSchema;
}(PolymorphicSchema);
var ValuesSchema = /*#__PURE__*/ function(_PolymorphicSchema) {
    _inheritsLoose(ValuesSchema, _PolymorphicSchema);
    function ValuesSchema() {
        return _PolymorphicSchema.apply(this, arguments) || this;
    }
    var _proto = ValuesSchema.prototype;
    _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
        var _this = this;
        return Object.keys(input).reduce(function(output, key, index) {
            var _extends2;
            var value = input[key];
            return value !== undefined && value !== null ? _extends({}, output, (_extends2 = {}, _extends2[key] = _this.normalizeValue(value, input, key, visit, addEntity, visitedEntities), _extends2)) : output;
        }, {});
    };
    _proto.denormalize = function denormalize(input, unvisit) {
        var _this2 = this;
        return Object.keys(input).reduce(function(output, key) {
            var _extends3;
            var entityOrId = input[key];
            return _extends({}, output, (_extends3 = {}, _extends3[key] = _this2.denormalizeValue(entityOrId, unvisit), _extends3));
        }, {});
    };
    return ValuesSchema;
}(PolymorphicSchema);
var validateSchema = function validateSchema(definition) {
    var isArray = Array.isArray(definition);
    if (isArray && definition.length > 1) throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
    return definition[0];
};
var getValues = function getValues(input) {
    return Array.isArray(input) ? input : Object.keys(input).map(function(key) {
        return input[key];
    });
};
var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
    schema = validateSchema(schema);
    var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
    // is not any special information that can be gathered from themselves directly
    return values.map(function(value, index) {
        return visit(value, parent, key, schema, addEntity, visitedEntities);
    });
};
var denormalize = function denormalize(schema, input, unvisit) {
    schema = validateSchema(schema);
    return input && input.map ? input.map(function(entityOrId) {
        return unvisit(entityOrId, schema);
    }) : input;
};
var ArraySchema = /*#__PURE__*/ function(_PolymorphicSchema) {
    _inheritsLoose(ArraySchema, _PolymorphicSchema);
    function ArraySchema() {
        return _PolymorphicSchema.apply(this, arguments) || this;
    }
    var _proto = ArraySchema.prototype;
    _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
        var _this = this;
        var values = getValues(input);
        return values.map(function(value, index) {
            return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
        }).filter(function(value) {
            return value !== undefined && value !== null;
        });
    };
    _proto.denormalize = function denormalize(input, unvisit) {
        var _this2 = this;
        return input && input.map ? input.map(function(value) {
            return _this2.denormalizeValue(value, unvisit);
        }) : input;
    };
    return ArraySchema;
}(PolymorphicSchema);
var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
    var object = _extends({}, input);
    Object.keys(schema).forEach(function(key) {
        var localSchema = schema[key];
        var resolvedLocalSchema = typeof localSchema === 'function' ? localSchema(input) : localSchema;
        var value = visit(input[key], input, key, resolvedLocalSchema, addEntity, visitedEntities);
        if (value === undefined || value === null) delete object[key];
        else object[key] = value;
    });
    return object;
};
var _denormalize = function denormalize(schema, input, unvisit) {
    if (isImmutable(input)) return denormalizeImmutable(schema, input, unvisit);
    var object = _extends({}, input);
    Object.keys(schema).forEach(function(key) {
        if (object[key] != null) object[key] = unvisit(object[key], schema[key]);
    });
    return object;
};
var ObjectSchema = /*#__PURE__*/ function() {
    function ObjectSchema(definition) {
        this.define(definition);
    }
    var _proto = ObjectSchema.prototype;
    _proto.define = function define(definition) {
        this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
            var _extends2;
            var schema = definition[key];
            return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
        }, this.schema || {});
    };
    _proto.normalize = function normalize() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _normalize.apply(void 0, [
            this.schema
        ].concat(args));
    };
    _proto.denormalize = function denormalize() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _denormalize.apply(void 0, [
            this.schema
        ].concat(args));
    };
    return ObjectSchema;
}();
var visit = function visit(value, parent, key, schema, addEntity, visitedEntities) {
    if (typeof value !== 'object' || !value) return value;
    if (typeof schema === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
        var method = Array.isArray(schema) ? normalize : _normalize;
        return method(schema, value, parent, key, visit, addEntity, visitedEntities);
    }
    return schema.normalize(value, parent, key, visit, addEntity, visitedEntities);
};
var addEntities = function addEntities(entities) {
    return function(schema, processedEntity, value, parent, key) {
        var schemaKey = schema.key;
        var id = schema.getId(value, parent, key);
        if (!(schemaKey in entities)) entities[schemaKey] = {};
        var existingEntity = entities[schemaKey][id];
        if (existingEntity) entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
        else entities[schemaKey][id] = processedEntity;
    };
};
var schema = {
    Array: ArraySchema,
    Entity: EntitySchema,
    Object: ObjectSchema,
    Union: UnionSchema,
    Values: ValuesSchema
};
var normalize$1 = function normalize(input, schema) {
    if (!input || typeof input !== 'object') throw new Error("Unexpected input given to normalize. Expected type to be \"object\", found \"" + (input === null ? 'null' : typeof input) + "\".");
    var entities = {};
    var addEntity = addEntities(entities);
    var visitedEntities = {};
    var result = visit(input, input, null, schema, addEntity, visitedEntities);
    return {
        entities: entities,
        result: result
    };
};
var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
    var entity = getEntity(id, schema);
    if (entity === undefined && schema instanceof EntitySchema) entity = schema.fallback(id, schema);
    if (typeof entity !== 'object' || entity === null) return entity;
    if (!cache[schema.key]) cache[schema.key] = {};
    if (!cache[schema.key][id]) {
        // Ensure we don't mutate it non-immutable objects
        var entityCopy = isImmutable(entity) ? entity : _extends({}, entity); // Need to set this first so that if it is referenced further within the
        // denormalization the reference will already exist.
        cache[schema.key][id] = entityCopy;
        cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
    }
    return cache[schema.key][id];
};
var getUnvisit = function getUnvisit(entities) {
    var cache = {};
    var getEntity = getEntities(entities);
    return function unvisit(input, schema) {
        if (typeof schema === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
            var method = Array.isArray(schema) ? denormalize : _denormalize;
            return method(schema, input, unvisit);
        }
        if (input === undefined || input === null) return input;
        if (schema instanceof EntitySchema) return unvisitEntity(input, schema, unvisit, getEntity, cache);
        return schema.denormalize(input, unvisit);
    };
};
var getEntities = function getEntities(entities) {
    var isImmutable$1 = isImmutable(entities);
    return function(entityOrId, schema) {
        var schemaKey = schema.key;
        if (typeof entityOrId === 'object') return entityOrId;
        if (isImmutable$1) return entities.getIn([
            schemaKey,
            entityOrId.toString()
        ]);
        return entities[schemaKey] && entities[schemaKey][entityOrId];
    };
};
var denormalize$1 = function denormalize(input, schema, entities) {
    if (typeof input !== 'undefined') return getUnvisit(entities)(input, schema);
};

});

parcelRegister("6cmjs", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionTypes", () => $a9ec436cddcd6371$export$7f8ff94880d72a10);
var $a9ec436cddcd6371$export$7f8ff94880d72a10 = /*#__PURE__*/ function(AnalyticsActionTypes) {
    AnalyticsActionTypes["FETCH_HOSPITAL_DATA_PENDING"] = "@@analytics/FETCH_HOSPITAL_DATA_PENDING";
    AnalyticsActionTypes["FETCH_HOSPITAL_DATA_SUCCESS"] = "@@analytics/FETCH_HOSPITAL_DATA_SUCCESS";
    AnalyticsActionTypes["FETCH_HOSPITAL_DATA_ERROR"] = "@@analytics/FETCH_HOSPITAL_DATA_ERROR";
    AnalyticsActionTypes["FETCH_USER_DATA_PENDING"] = "@@analytics/FETCH_USER_DATA_PENDING";
    AnalyticsActionTypes["FETCH_USER_DATA_SUCCESS"] = "@@analytics/FETCH_USER_DATA_SUCCESS";
    AnalyticsActionTypes["FETCH_USER_DATA_ERROR"] = "@@analytics/FETCH_USER_DATA_ERROR";
    return AnalyticsActionTypes;
}({});

});

parcelRegister("cd5S4", function(module, exports) {

var $2AbXc = parcelRequire("2AbXc");
$parcel$exportWildcard(module.exports, $2AbXc);

});
parcelRegister("2AbXc", function(module, exports) {

$parcel$export(module.exports, "takeEvery", () => $1e1837559b2734c8$export$4e24be1e1c9d5c69);
$parcel$export(module.exports, "takeLatest", () => $1e1837559b2734c8$export$ca010cea618a298a);
$parcel$export(module.exports, "takeLeading", () => $1e1837559b2734c8$export$ab18f80dcccecca4);
$parcel$export(module.exports, "throttle", () => $1e1837559b2734c8$export$de363e709c412c8a);
$parcel$export(module.exports, "retry", () => $1e1837559b2734c8$export$9369b12211e1fce4);
$parcel$export(module.exports, "debounce", () => $1e1837559b2734c8$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "actionChannel", () => (parcelRequire("k6WuE")).U);
$parcel$export(module.exports, "all", () => (parcelRequire("k6WuE")).$);
$parcel$export(module.exports, "apply", () => (parcelRequire("k6WuE")).a0);
$parcel$export(module.exports, "call", () => (parcelRequire("k6WuE")).O);
$parcel$export(module.exports, "cancel", () => (parcelRequire("k6WuE")).N);
$parcel$export(module.exports, "cancelled", () => (parcelRequire("k6WuE")).a5);
$parcel$export(module.exports, "cps", () => (parcelRequire("k6WuE")).a1);
$parcel$export(module.exports, "delay", () => (parcelRequire("k6WuE")).Q);
$parcel$export(module.exports, "effectTypes", () => (parcelRequire("k6WuE")).X);
$parcel$export(module.exports, "flush", () => (parcelRequire("k6WuE")).a6);
$parcel$export(module.exports, "fork", () => (parcelRequire("k6WuE")).M);
$parcel$export(module.exports, "getContext", () => (parcelRequire("k6WuE")).a7);
$parcel$export(module.exports, "join", () => (parcelRequire("k6WuE")).a3);
$parcel$export(module.exports, "put", () => (parcelRequire("k6WuE")).Z);
$parcel$export(module.exports, "putResolve", () => (parcelRequire("k6WuE"))._);
$parcel$export(module.exports, "race", () => (parcelRequire("k6WuE")).W);
$parcel$export(module.exports, "select", () => (parcelRequire("k6WuE")).a4);
$parcel$export(module.exports, "setContext", () => (parcelRequire("k6WuE")).a8);
$parcel$export(module.exports, "spawn", () => (parcelRequire("k6WuE")).a2);
$parcel$export(module.exports, "take", () => (parcelRequire("k6WuE")).L);
$parcel$export(module.exports, "takeMaybe", () => (parcelRequire("k6WuE")).Y);
parcelRequire("5QIeP");
parcelRequire("8nd05");

var $1NYpB = parcelRequire("1NYpB");

var $k6WuE = parcelRequire("k6WuE");
parcelRequire("5Z0E9");
var $1e1837559b2734c8$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $1e1837559b2734c8$var$qEnd = {};
function $1e1837559b2734c8$var$safeName(patternOrChannel) {
    if ((0, $1NYpB.channel)(patternOrChannel)) return 'channel';
    if ((0, $1NYpB.stringableFunc)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $1NYpB.func)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $1e1837559b2734c8$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $1e1837559b2734c8$var$qEnd) return $1e1837559b2734c8$var$done(arg);
        if (error && !errorState) {
            nextState = $1e1837559b2734c8$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $1e1837559b2734c8$var$qEnd ? $1e1837559b2734c8$var$done(arg) : effect;
        }
    }
    return (0, $k6WuE.q)(next, function(error) {
        return next(null, error);
    }, name);
}
function $1e1837559b2734c8$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $k6WuE.L)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $k6WuE.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yFork(action)
            };
        }
    }, 'q1', "takeEvery(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $k6WuE.L)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $k6WuE.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $k6WuE.N)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: 'q3',
                effect: yCancel(task)
            } : {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, 'q1', "takeLatest(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $k6WuE.L)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $k6WuE.O).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yCall(action)
            };
        }
    }, 'q1', "takeLeading(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $k6WuE.L)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $k6WuE.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $k6WuE.Q)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $1NYpB.channel)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $k6WuE.U)(patternOrChannel, (0, $k6WuE.V)(1))
            };
            return {
                nextState: 'q2',
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: 'q4',
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: 'q2',
                effect: yDelay
            };
        }
    }, needsChannel ? 'q1' : 'q2', "throttle(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $k6WuE.O).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $k6WuE.Q)(delayLength)
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yCall,
                errorState: 'q10'
            };
        },
        q2: function q2() {
            return {
                nextState: $1e1837559b2734c8$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: 'q1',
                effect: yDelay
            };
        }
    }, 'q1', "retry(" + fn.name + ")");
}
function $1e1837559b2734c8$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $k6WuE.L)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $k6WuE.W)({
            action: (0, $k6WuE.L)(patternOrChannel),
            debounce: (0, $k6WuE.Q)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $k6WuE.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: 'q1',
                effect: yFork(action)
            } : {
                nextState: 'q2',
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, 'q1', "debounce(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $1e1837559b2734c8$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $k6WuE.c)(patternOrChannel, (0, $1NYpB.notUndef), fn.name + " requires a pattern or channel");
    (0, $k6WuE.c)(worker, (0, $1NYpB.notUndef), fn.name + " requires a saga parameter");
};
function $1e1837559b2734c8$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $k6WuE.M).apply(void 0, [
        $1e1837559b2734c8$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $k6WuE.M).apply(void 0, [
        $1e1837559b2734c8$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $k6WuE.M).apply(void 0, [
        $1e1837559b2734c8$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $k6WuE.M).apply(void 0, [
        $1e1837559b2734c8$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $k6WuE.O).apply(void 0, [
        $1e1837559b2734c8$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $k6WuE.M).apply(void 0, [
        $1e1837559b2734c8$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}

});
parcelRegister("5QIeP", function(module, exports) {

$parcel$export(module.exports, "CANCEL", () => $44241fd6c875387f$export$2b10f4b30fb65583);
$parcel$export(module.exports, "CHANNEL_END_TYPE", () => $44241fd6c875387f$export$3281fbb3edc9dee3);
$parcel$export(module.exports, "IO", () => $44241fd6c875387f$export$8f8422ac5947a789);
$parcel$export(module.exports, "MATCH", () => $44241fd6c875387f$export$5a1a83be8f503735);
$parcel$export(module.exports, "MULTICAST", () => $44241fd6c875387f$export$9074c4e62c4e51bb);
$parcel$export(module.exports, "SAGA_ACTION", () => $44241fd6c875387f$export$7d963e45ecdffba1);
$parcel$export(module.exports, "SELF_CANCELLATION", () => $44241fd6c875387f$export$3f4d38f8b89bfda7);
$parcel$export(module.exports, "TASK", () => $44241fd6c875387f$export$9355e489ad16f98e);
$parcel$export(module.exports, "TASK_CANCEL", () => $44241fd6c875387f$export$a47f788ef0b36709);
$parcel$export(module.exports, "TERMINATE", () => $44241fd6c875387f$export$d966e43d90bf4c05);
$parcel$export(module.exports, "SAGA_LOCATION", () => $44241fd6c875387f$export$bdae2c4f4f03305d);
var $44241fd6c875387f$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $44241fd6c875387f$export$2b10f4b30fb65583 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('CANCEL_PROMISE');
var $44241fd6c875387f$export$3281fbb3edc9dee3 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('CHANNEL_END');
var $44241fd6c875387f$export$8f8422ac5947a789 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('IO');
var $44241fd6c875387f$export$5a1a83be8f503735 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('MATCH');
var $44241fd6c875387f$export$9074c4e62c4e51bb = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('MULTICAST');
var $44241fd6c875387f$export$7d963e45ecdffba1 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('SAGA_ACTION');
var $44241fd6c875387f$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('SELF_CANCELLATION');
var $44241fd6c875387f$export$9355e489ad16f98e = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('TASK');
var $44241fd6c875387f$export$a47f788ef0b36709 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('TASK_CANCEL');
var $44241fd6c875387f$export$d966e43d90bf4c05 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('TERMINATE');
var $44241fd6c875387f$export$bdae2c4f4f03305d = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol('LOCATION');

});

parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1NYpB", function(module, exports) {

$parcel$export(module.exports, "undef", () => $15093a965cf6fe1c$export$c7b6444af1f098df);
$parcel$export(module.exports, "notUndef", () => $15093a965cf6fe1c$export$1352885233577768);
$parcel$export(module.exports, "func", () => $15093a965cf6fe1c$export$86951950244e2001);
$parcel$export(module.exports, "string", () => $15093a965cf6fe1c$export$22b082955e083ec3);
$parcel$export(module.exports, "array", () => $15093a965cf6fe1c$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $15093a965cf6fe1c$export$be5493f9613cbbe);
$parcel$export(module.exports, "promise", () => $15093a965cf6fe1c$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "iterator", () => $15093a965cf6fe1c$export$6f58e2338da23f4d);
$parcel$export(module.exports, "pattern", () => $15093a965cf6fe1c$export$24f82734ea047e6f);
$parcel$export(module.exports, "symbol", () => $15093a965cf6fe1c$export$8f701197936bc2a6);
$parcel$export(module.exports, "channel", () => $15093a965cf6fe1c$export$1f95fbd68d964d36);
$parcel$export(module.exports, "stringableFunc", () => $15093a965cf6fe1c$export$32b5e46230afa379);
$parcel$export(module.exports, "multicast", () => $15093a965cf6fe1c$export$1364843af8d5a963);
$parcel$export(module.exports, "effect", () => $15093a965cf6fe1c$export$dc573d8a6576cdb3);

var $5QIeP = parcelRequire("5QIeP");
var $15093a965cf6fe1c$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $15093a965cf6fe1c$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $15093a965cf6fe1c$export$86951950244e2001 = function func(f) {
    return typeof f === 'function';
};
var $15093a965cf6fe1c$export$98e628dec113755e = function number(n) {
    return typeof n === 'number';
};
var $15093a965cf6fe1c$export$22b082955e083ec3 = function string(s) {
    return typeof s === 'string';
};
var $15093a965cf6fe1c$export$2f23118c22fb2630 = Array.isArray;
var $15093a965cf6fe1c$export$be5493f9613cbbe = function object(obj) {
    return obj && !$15093a965cf6fe1c$export$2f23118c22fb2630(obj) && typeof obj === 'object';
};
var $15093a965cf6fe1c$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $15093a965cf6fe1c$export$86951950244e2001(p.then);
};
var $15093a965cf6fe1c$export$6f58e2338da23f4d = function iterator(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(it.next) && $15093a965cf6fe1c$export$86951950244e2001(it.throw);
};
var $15093a965cf6fe1c$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(Symbol) ? $15093a965cf6fe1c$export$86951950244e2001(it[Symbol.iterator]) : $15093a965cf6fe1c$export$2f23118c22fb2630(it);
};
var $15093a965cf6fe1c$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $5QIeP.TASK];
};
var $15093a965cf6fe1c$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $5QIeP.SAGA_ACTION]);
};
var $15093a965cf6fe1c$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $15093a965cf6fe1c$export$86951950244e2001(ob.subscribe);
};
var $15093a965cf6fe1c$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $15093a965cf6fe1c$export$86951950244e2001(buf.isEmpty) && $15093a965cf6fe1c$export$86951950244e2001(buf.take) && $15093a965cf6fe1c$export$86951950244e2001(buf.put);
};
var $15093a965cf6fe1c$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($15093a965cf6fe1c$export$22b082955e083ec3(pat) || $15093a965cf6fe1c$export$8f701197936bc2a6(pat) || $15093a965cf6fe1c$export$86951950244e2001(pat) || $15093a965cf6fe1c$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $15093a965cf6fe1c$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $15093a965cf6fe1c$export$86951950244e2001(ch.take) && $15093a965cf6fe1c$export$86951950244e2001(ch.close);
};
var $15093a965cf6fe1c$export$32b5e46230afa379 = function stringableFunc(f) {
    return $15093a965cf6fe1c$export$86951950244e2001(f) && f.hasOwnProperty('toString');
};
var $15093a965cf6fe1c$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $15093a965cf6fe1c$export$1364843af8d5a963 = function multicast(ch) {
    return $15093a965cf6fe1c$export$1f95fbd68d964d36(ch) && ch[0, $5QIeP.MULTICAST];
};
var $15093a965cf6fe1c$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $5QIeP.IO];
};

});

parcelRegister("k6WuE", function(module, exports) {

$parcel$export(module.exports, "k", () => $ea41bdbb61e4673e$export$342063e11d6c3cad);
$parcel$export(module.exports, "t", () => $ea41bdbb61e4673e$export$625550452a3fa3ec);
$parcel$export(module.exports, "H", () => $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "c", () => $ea41bdbb61e4673e$export$db3b6bfb95261072);
$parcel$export(module.exports, "p", () => $ea41bdbb61e4673e$export$ffb5f4729a158638);
$parcel$export(module.exports, "u", () => $ea41bdbb61e4673e$export$3b14a55fb2447963);
$parcel$export(module.exports, "r", () => $ea41bdbb61e4673e$export$43caf9889c228507);
$parcel$export(module.exports, "o", () => $ea41bdbb61e4673e$export$ae1af26003f05816);
$parcel$export(module.exports, "q", () => $ea41bdbb61e4673e$export$9e5f44173e64f162);
$parcel$export(module.exports, "D", () => $ea41bdbb61e4673e$export$96f57966bedc81b4);
$parcel$export(module.exports, "i", () => $ea41bdbb61e4673e$export$23f2a1d2818174ef);
$parcel$export(module.exports, "m", () => $ea41bdbb61e4673e$export$953cecd6e717a553);
$parcel$export(module.exports, "E", () => $ea41bdbb61e4673e$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "z", () => $ea41bdbb61e4673e$export$df995fae86a55f06);
$parcel$export(module.exports, "y", () => $ea41bdbb61e4673e$export$4a5767248b18ef41);
$parcel$export(module.exports, "s", () => $ea41bdbb61e4673e$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "l", () => $ea41bdbb61e4673e$export$882b5998b3b9117c);
$parcel$export(module.exports, "j", () => $ea41bdbb61e4673e$export$35e795649ee09318);
$parcel$export(module.exports, "v", () => $ea41bdbb61e4673e$export$90a7f3efeed30595);
$parcel$export(module.exports, "B", () => $ea41bdbb61e4673e$export$ef35774e6d314e91);
$parcel$export(module.exports, "n", () => $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "V", () => $ea41bdbb61e4673e$export$e7c866399fa523f5);
$parcel$export(module.exports, "e", () => $ea41bdbb61e4673e$export$f1e1789686576879);
$parcel$export(module.exports, "T", () => $ea41bdbb61e4673e$export$971d5caa766a69d7);
$parcel$export(module.exports, "P", () => $ea41bdbb61e4673e$export$56c0d5a1e737357d);
$parcel$export(module.exports, "A", () => $ea41bdbb61e4673e$export$ebd11618f299a286);
$parcel$export(module.exports, "R", () => $ea41bdbb61e4673e$export$db202ddc8be9136);
$parcel$export(module.exports, "C", () => $ea41bdbb61e4673e$export$e7094788287c5e9b);
$parcel$export(module.exports, "a", () => $ea41bdbb61e4673e$export$407448d2b89b1813);
$parcel$export(module.exports, "F", () => $ea41bdbb61e4673e$export$d66501df72047452);
$parcel$export(module.exports, "J", () => $ea41bdbb61e4673e$export$b4171a6734a65d42);
$parcel$export(module.exports, "b", () => $ea41bdbb61e4673e$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "S", () => $ea41bdbb61e4673e$export$25ce5a424b770e84);
$parcel$export(module.exports, "d", () => $ea41bdbb61e4673e$export$4368d992c4eafac0);
$parcel$export(module.exports, "f", () => $ea41bdbb61e4673e$export$2d1720544b23b823);
$parcel$export(module.exports, "g", () => $ea41bdbb61e4673e$export$39b482c5e57630a8);
$parcel$export(module.exports, "G", () => $ea41bdbb61e4673e$export$2329c99376c9d0a4);
$parcel$export(module.exports, "h", () => $ea41bdbb61e4673e$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "X", () => $ea41bdbb61e4673e$export$78acf4525d8a74c4);
$parcel$export(module.exports, "L", () => $ea41bdbb61e4673e$export$61196ced6d74a310);
$parcel$export(module.exports, "Y", () => $ea41bdbb61e4673e$export$8743009a87fcb00f);
$parcel$export(module.exports, "Z", () => $ea41bdbb61e4673e$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "_", () => $ea41bdbb61e4673e$export$71511d61b312f219);
$parcel$export(module.exports, "$", () => $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "W", () => $ea41bdbb61e4673e$export$71cec2538cb2c617);
$parcel$export(module.exports, "Q", () => $ea41bdbb61e4673e$export$3722cfe417b6ed86);
$parcel$export(module.exports, "O", () => $ea41bdbb61e4673e$export$c4ce752e73470fba);
$parcel$export(module.exports, "a0", () => $ea41bdbb61e4673e$export$34aec0b863436764);
$parcel$export(module.exports, "a1", () => $ea41bdbb61e4673e$export$3c2fa207a37baaea);
$parcel$export(module.exports, "M", () => $ea41bdbb61e4673e$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "a2", () => $ea41bdbb61e4673e$export$ce26c07117d59d6a);
$parcel$export(module.exports, "a3", () => $ea41bdbb61e4673e$export$6559d589eb85fbb6);
$parcel$export(module.exports, "N", () => $ea41bdbb61e4673e$export$a07804094c3ecf2d);
$parcel$export(module.exports, "a4", () => $ea41bdbb61e4673e$export$efca4cbe5dd06740);
$parcel$export(module.exports, "U", () => $ea41bdbb61e4673e$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "a5", () => $ea41bdbb61e4673e$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a6", () => $ea41bdbb61e4673e$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a7", () => $ea41bdbb61e4673e$export$a93c5207d687da10);
$parcel$export(module.exports, "a8", () => $ea41bdbb61e4673e$export$c3950d9923825c02);

var $5QIeP = parcelRequire("5QIeP");

var $8nd05 = parcelRequire("8nd05");

var $1NYpB = parcelRequire("1NYpB");

var $5Z0E9 = parcelRequire("5Z0E9");
var $ea41bdbb61e4673e$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $ea41bdbb61e4673e$export$342063e11d6c3cad = /*#__PURE__*/ $ea41bdbb61e4673e$var$konst(true);
var $ea41bdbb61e4673e$export$625550452a3fa3ec = function noop() {};
var $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd = function identity(v) {
    return v;
};
var $ea41bdbb61e4673e$var$hasSymbol = typeof Symbol === 'function';
var $ea41bdbb61e4673e$export$d141bba7fdc215a3 = $ea41bdbb61e4673e$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function $ea41bdbb61e4673e$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $ea41bdbb61e4673e$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $8nd05.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $ea41bdbb61e4673e$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $ea41bdbb61e4673e$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $ea41bdbb61e4673e$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $ea41bdbb61e4673e$var$kThrow = function kThrow(err) {
    throw err;
};
var $ea41bdbb61e4673e$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $ea41bdbb61e4673e$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $ea41bdbb61e4673e$var$kThrow;
    if (name === void 0) name = 'iterator';
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $ea41bdbb61e4673e$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== 'undefined') iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ea41bdbb61e4673e$export$96f57966bedc81b4(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $ea41bdbb61e4673e$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $ea41bdbb61e4673e$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var $ea41bdbb61e4673e$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $ea41bdbb61e4673e$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $ea41bdbb61e4673e$export$a9c23c6ac3fc3eca = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $5QIeP.SAGA_ACTION), {
            value: true
        }));
    };
};
var $ea41bdbb61e4673e$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $5QIeP.TERMINATE);
};
var $ea41bdbb61e4673e$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $5QIeP.TASK_CANCEL);
};
var $ea41bdbb61e4673e$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $ea41bdbb61e4673e$export$df995fae86a55f06(res) || $ea41bdbb61e4673e$export$4a5767248b18ef41(res);
};
function $ea41bdbb61e4673e$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $1NYpB.array)(shape) ? $ea41bdbb61e4673e$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $ea41bdbb61e4673e$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $ea41bdbb61e4673e$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $ea41bdbb61e4673e$export$35e795649ee09318(fn) {
    return {
        name: fn.name || 'anonymous',
        location: $ea41bdbb61e4673e$export$90a7f3efeed30595(fn)
    };
}
function $ea41bdbb61e4673e$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $5QIeP.SAGA_LOCATION];
}
function $ea41bdbb61e4673e$export$ef35774e6d314e91() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
var $ea41bdbb61e4673e$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW = 1;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_DROP = 2;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE = 3;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND = 4;
var $ea41bdbb61e4673e$var$zeroBuffer = {
    isEmpty: $ea41bdbb61e4673e$export$342063e11d6c3cad,
    put: $ea41bdbb61e4673e$export$625550452a3fa3ec,
    take: $ea41bdbb61e4673e$export$625550452a3fa3ec
};
function $ea41bdbb61e4673e$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW:
                        throw new Error($ea41bdbb61e4673e$var$BUFFER_OVERFLOW);
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5 = function none() {
    return $ea41bdbb61e4673e$var$zeroBuffer;
};
var $ea41bdbb61e4673e$var$fixed = function fixed(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW);
};
var $ea41bdbb61e4673e$var$dropping = function dropping(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_DROP);
};
var $ea41bdbb61e4673e$export$e7c866399fa523f5 = function sliding(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE);
};
var $ea41bdbb61e4673e$export$f1e1789686576879 = function expanding(initialSize) {
    return $ea41bdbb61e4673e$var$ringBuffer(initialSize, $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND);
};
var $ea41bdbb61e4673e$export$9bb611d729802a56 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5,
    fixed: $ea41bdbb61e4673e$var$fixed,
    dropping: $ea41bdbb61e4673e$var$dropping,
    sliding: $ea41bdbb61e4673e$export$e7c866399fa523f5,
    expanding: $ea41bdbb61e4673e$export$f1e1789686576879
});
var $ea41bdbb61e4673e$export$971d5caa766a69d7 = 'TAKE';
var $ea41bdbb61e4673e$export$56c0d5a1e737357d = 'PUT';
var $ea41bdbb61e4673e$export$ebd11618f299a286 = 'ALL';
var $ea41bdbb61e4673e$export$db202ddc8be9136 = 'RACE';
var $ea41bdbb61e4673e$export$e7094788287c5e9b = 'CALL';
var $ea41bdbb61e4673e$export$407448d2b89b1813 = 'CPS';
var $ea41bdbb61e4673e$export$d66501df72047452 = 'FORK';
var $ea41bdbb61e4673e$export$b4171a6734a65d42 = 'JOIN';
var $ea41bdbb61e4673e$export$8b22cf2602fb60ce = 'CANCEL';
var $ea41bdbb61e4673e$export$25ce5a424b770e84 = 'SELECT';
var $ea41bdbb61e4673e$export$4368d992c4eafac0 = 'ACTION_CHANNEL';
var $ea41bdbb61e4673e$export$2d1720544b23b823 = 'CANCELLED';
var $ea41bdbb61e4673e$export$39b482c5e57630a8 = 'FLUSH';
var $ea41bdbb61e4673e$export$2329c99376c9d0a4 = 'GET_CONTEXT';
var $ea41bdbb61e4673e$export$dda1d9f60106f0e9 = 'SET_CONTEXT';
var $ea41bdbb61e4673e$export$78acf4525d8a74c4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $ea41bdbb61e4673e$export$971d5caa766a69d7,
    PUT: $ea41bdbb61e4673e$export$56c0d5a1e737357d,
    ALL: $ea41bdbb61e4673e$export$ebd11618f299a286,
    RACE: $ea41bdbb61e4673e$export$db202ddc8be9136,
    CALL: $ea41bdbb61e4673e$export$e7094788287c5e9b,
    CPS: $ea41bdbb61e4673e$export$407448d2b89b1813,
    FORK: $ea41bdbb61e4673e$export$d66501df72047452,
    JOIN: $ea41bdbb61e4673e$export$b4171a6734a65d42,
    CANCEL: $ea41bdbb61e4673e$export$8b22cf2602fb60ce,
    SELECT: $ea41bdbb61e4673e$export$25ce5a424b770e84,
    ACTION_CHANNEL: $ea41bdbb61e4673e$export$4368d992c4eafac0,
    CANCELLED: $ea41bdbb61e4673e$export$2d1720544b23b823,
    FLUSH: $ea41bdbb61e4673e$export$39b482c5e57630a8,
    GET_CONTEXT: $ea41bdbb61e4673e$export$2329c99376c9d0a4,
    SET_CONTEXT: $ea41bdbb61e4673e$export$dda1d9f60106f0e9
});
var $ea41bdbb61e4673e$var$TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';
var $ea41bdbb61e4673e$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $5QIeP.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $ea41bdbb61e4673e$var$isForkEffect = function isForkEffect(eff) {
    return (0, $1NYpB.effect)(eff) && eff.type === $ea41bdbb61e4673e$export$d66501df72047452;
};
var $ea41bdbb61e4673e$export$3466f893ebf79586 = function detach(eff) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$d66501df72047452, (0, $8nd05.default)({}, eff.payload, {
        detached: true
    }));
};
function $ea41bdbb61e4673e$export$61196ced6d74a310(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = '*';
    if ((0, $1NYpB.pattern)(patternOrChannel)) {
        if ((0, $1NYpB.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $1NYpB.multicast)(patternOrChannel) && (0, $1NYpB.notUndef)(multicastPattern) && (0, $1NYpB.pattern)(multicastPattern)) return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $1NYpB.channel)(patternOrChannel)) {
        if ((0, $1NYpB.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $ea41bdbb61e4673e$export$8743009a87fcb00f = function takeMaybe() {
    var eff = $ea41bdbb61e4673e$export$61196ced6d74a310.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $ea41bdbb61e4673e$export$dc98b0b04f4c7758(channel$1, action) {
    if ((0, $1NYpB.undef)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $ea41bdbb61e4673e$export$71511d61b312f219 = function putResolve() {
    var eff = $ea41bdbb61e4673e$export$dc98b0b04f4c7758.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9(effects) {
    var eff = $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $ea41bdbb61e4673e$export$71cec2538cb2c617(effects) {
    var eff = $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $ea41bdbb61e4673e$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $ea41bdbb61e4673e$export$db3b6bfb95261072(fnDescriptor, (0, $1NYpB.notUndef), effectName + ": argument fn is undefined or null");
    if ((0, $1NYpB.func)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $1NYpB.array)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $1NYpB.notUndef), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $1NYpB.object)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $1NYpB.notUndef), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fnDescriptor, (0, $1NYpB.func), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $1NYpB.string)(fn)) {
        $ea41bdbb61e4673e$export$db3b6bfb95261072(context[fn], (0, $1NYpB.func), effectName + ": context arguments has no such method - \"" + fn + "\"");
        return;
    }
    $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $1NYpB.func), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $1NYpB.func)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $1NYpB.array)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $1NYpB.string)(fn) && (0, $1NYpB.func)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $ea41bdbb61e4673e$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $ea41bdbb61e4673e$export$3722cfe417b6ed86;
};
function $ea41bdbb61e4673e$export$c4ce752e73470fba(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$e7094788287c5e9b, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$34aec0b863436764(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$e7094788287c5e9b, $ea41bdbb61e4673e$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $ea41bdbb61e4673e$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$407448d2b89b1813, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$3a1a48c8f6ef640e(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$d66501df72047452, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$ce26c07117d59d6a(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $ea41bdbb61e4673e$export$3466f893ebf79586($ea41bdbb61e4673e$export$3a1a48c8f6ef640e.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $ea41bdbb61e4673e$export$6559d589eb85fbb6(taskOrTasks) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$b4171a6734a65d42, taskOrTasks);
}
function $ea41bdbb61e4673e$export$a07804094c3ecf2d(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $5QIeP.SELF_CANCELLATION);
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$8b22cf2602fb60ce, taskOrTasks);
}
function $ea41bdbb61e4673e$export$efca4cbe5dd06740(selector) {
    if (selector === void 0) selector = $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $ea41bdbb61e4673e$export$3a6d5c9ae78a2c08(pattern$1, buffer$1) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $ea41bdbb61e4673e$export$a8550f7dbe79f93a() {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$2d1720544b23b823, {});
}
function $ea41bdbb61e4673e$export$2e2af4578d910ddf(channel$1) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$39b482c5e57630a8, channel$1);
}
function $ea41bdbb61e4673e$export$a93c5207d687da10(prop) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$2329c99376c9d0a4, prop);
}
function $ea41bdbb61e4673e$export$c3950d9923825c02(props) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$dda1d9f60106f0e9, props);
}
var $ea41bdbb61e4673e$export$3722cfe417b6ed86 = /*#__PURE__*/ $ea41bdbb61e4673e$export$c4ce752e73470fba.bind(null, (0, $5Z0E9.default));

});
parcelRegister("5Z0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b326adf3eff15d$export$2e2bcd8739ae039);

var $5QIeP = parcelRequire("5QIeP");
var $45b326adf3eff15d$var$MAX_SIGNED_INT = 2147483647;
function $45b326adf3eff15d$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($45b326adf3eff15d$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $5QIeP.CANCEL] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $45b326adf3eff15d$export$2e2bcd8739ae039 = $45b326adf3eff15d$var$delayP;

});




parcelRegister("6QJY8", function(module, exports) {

$parcel$export(module.exports, "RoutePaths", () => $ee27929fe011fbcf$export$4c364d4282b11f3a);
$parcel$export(module.exports, "Routes", () => $ee27929fe011fbcf$export$3565eb3d00ca5a74);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $695Jh = parcelRequire("695Jh");

var $4KSAX = parcelRequire("4KSAX");

var $5wPBK = parcelRequire("5wPBK");

var $lIZKg = parcelRequire("lIZKg");

var $236Dw = parcelRequire("236Dw");

var $jcbSx = parcelRequire("jcbSx");

var $2yQbT = parcelRequire("2yQbT");

var $11pqD = parcelRequire("11pqD");

var $5Q36E = parcelRequire("5Q36E");

var $aesrM = parcelRequire("aesrM");

var $eYI5x = parcelRequire("eYI5x");

var $2wnYh = parcelRequire("2wnYh");

var $d8ZmP = parcelRequire("d8ZmP");

var $hPG5I = parcelRequire("hPG5I");

var $eEX4u = parcelRequire("eEX4u");

var $hLLeY = parcelRequire("hLLeY");

var $b703n = parcelRequire("b703n");

var $2xY9J = parcelRequire("2xY9J");

var $7Rg00 = parcelRequire("7Rg00");

var $bZlxZ = parcelRequire("bZlxZ");

var $1izku = parcelRequire("1izku");

var $cOo5I = parcelRequire("cOo5I");

var $5YjhR = parcelRequire("5YjhR");

var $fP19p = parcelRequire("fP19p");

var $lxRZO = parcelRequire("lxRZO");

var $2Baud = parcelRequire("2Baud");

var $lPAGv = parcelRequire("lPAGv");

var $l1h9J = parcelRequire("l1h9J");

var $l57QH = parcelRequire("l57QH");

var $cmDWF = parcelRequire("cmDWF");

var $5Pjrh = parcelRequire("5Pjrh");

var $jaEgr = parcelRequire("jaEgr");

var $3dYgQ = parcelRequire("3dYgQ");

var $2amIx = parcelRequire("2amIx");

var $beTuk = parcelRequire("beTuk");

var $k0GJk = parcelRequire("k0GJk");

var $dlT2f = parcelRequire("dlT2f");

var $jvnqh = parcelRequire("jvnqh");

var $8k0Gy = parcelRequire("8k0Gy");

var $3EEnl = parcelRequire("3EEnl");

var $3cQf2 = parcelRequire("3cQf2");

var $47VIt = parcelRequire("47VIt");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $giWzi = parcelRequire("giWzi");

var $6lvMC = parcelRequire("6lvMC");

var $cA1jy = parcelRequire("cA1jy");

var $8G3Yk = parcelRequire("8G3Yk");

var $6XB6Y = parcelRequire("6XB6Y");

var $jSDfI = parcelRequire("jSDfI");
var $ee27929fe011fbcf$export$4c364d4282b11f3a = /*#__PURE__*/ function(RoutePaths) {
    RoutePaths["ROOT"] = "/";
    RoutePaths["SIGN_IN"] = "/signin";
    RoutePaths["SSO"] = "/sso";
    RoutePaths["SETUP_MFA_INTRO"] = "/setup-mfa/intro";
    RoutePaths["SETUP_MFA_TOTP"] = "/setup-mfa/totp";
    RoutePaths["SETUP_MFA_TOTP_COMPLETE"] = "/setup-mfa/totp-complete";
    RoutePaths["SETUP_MFA_SMS_COMPLETE"] = "/setup-mfa/sms-complete";
    RoutePaths["MFA_TOTP"] = "/mfa/totp";
    RoutePaths["TERMS"] = "/terms";
    RoutePaths["SET_PASSWORD"] = "/set-password";
    RoutePaths["MEETING_LIVE"] = "/meeting/:meetingId/live";
    RoutePaths["MEETINGS"] = "/meetings";
    RoutePaths["MEETING_NEW"] = "/meeting/new";
    RoutePaths["MEETING_EDIT"] = "/meeting/:meetingId/edit";
    RoutePaths["MEETING"] = "/meeting/:meetingId";
    RoutePaths["MEETING_CASE"] = "/meetingcase/:meetingCaseId/:currentTab?";
    RoutePaths["USERS"] = "/users";
    RoutePaths["USER"] = "/user/:userId";
    RoutePaths["USER_NEW"] = "/user/new";
    RoutePaths["USER_NEW_GUEST"] = "/user/new_guest";
    RoutePaths["USER_EDIT"] = "/user/:userId/edit";
    RoutePaths["CASES"] = "/cases";
    RoutePaths["CASE_NEW"] = "/case/new";
    RoutePaths["CASE_EDIT"] = "/case/:caseId/edit";
    RoutePaths["CASE_LOCK"] = "/case/:caseId/lock";
    RoutePaths["CASE_UNLOCK"] = "/case/:caseId/unlock";
    RoutePaths["CASE"] = "/case/:caseId/:currentTab?";
    RoutePaths["PATIENTS"] = "/patients";
    RoutePaths["PATIENT"] = "/patient/:patientId";
    RoutePaths["PATIENT_NEW"] = "/patient/new";
    RoutePaths["PATIENT_EDIT_DETAILS"] = "/patient/:patientId/details/edit";
    RoutePaths["PATIENT_EDIT_FURTHER_DETAILS"] = "/patient/:patientId/further-details/edit";
    RoutePaths["PATIENT_CASE_NEW"] = "/patient/:patientId/cases/new";
    RoutePaths["RADIOLOGY"] = "/radiology";
    RoutePaths["NOTIFICATIONS"] = "/notifications";
    RoutePaths["TASKS"] = "/tasks";
    RoutePaths["ADMIN"] = "/admin";
    RoutePaths["TEAMS"] = "/teams";
    RoutePaths["TEAMS_NEW"] = "/team/new";
    RoutePaths["TEAM_EDIT"] = "/team/:teamId/edit";
    RoutePaths["TEAM"] = "/team/:teamId";
    RoutePaths["MESSAGES"] = "/messages";
    RoutePaths["PATHWAYS"] = "/pathways";
    RoutePaths["PATHWAY"] = "/pathway/:pathwayId";
    RoutePaths["PATHWAY_NEW"] = "/pathway/new";
    RoutePaths["ANALYTICS"] = "/analytics";
    return RoutePaths;
}({});
const $ee27929fe011fbcf$var$blacklistDeepLinks = [
    "/signin",
    "/set-password",
    "/setup-mfa/intro",
    "/setup-mfa/totp",
    "/setup-mfa/totp-complete",
    "/setup-mfa/sms-complete",
    "/mfa/totp"
];
const $ee27929fe011fbcf$export$3565eb3d00ca5a74 = ()=>{
    // preload all transations
    (0, $4KSAX.useTranslation)((0, $5wPBK.translationFilenames));
    const navigate = (0, $COwA0.useNavigate)();
    // the following is to support deep links while not signed in
    // initially storing the deep link should be done synchronously, as otherwise
    // the redirect to sign in has already taken place
    const [deepLinkPath, setDeepLinkPath] = (0, $acw62.useState)(null);
    const apiToken = (0, $iD0SF.useSelector)((state)=>state.userSession.apiToken);
    const { oauthIdToken: oauthIdToken } = (0, $jSDfI.getSession)();
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!apiToken && !deepLinkPath) setDeepLinkPath(location.pathname);
    (0, $acw62.useEffect)(()=>{
        if (!apiToken || !oauthIdToken || !currentUser || currentUser.mfaRequired) return;
        if (deepLinkPath && !$ee27929fe011fbcf$var$blacklistDeepLinks.includes(deepLinkPath)) navigate(deepLinkPath, {
            replace: true
        });
        setDeepLinkPath(null);
    }, [
        apiToken,
        currentUser?.mfaRequired
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $COwA0.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/signin",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5YjhR.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Q36E.default), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/sso",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5YjhR.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Q36E.default), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/set-password",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5YjhR.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPG5I.default), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/terms",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fP19p.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZlxZ.default), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/tenant/:tenantId/*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($ee27929fe011fbcf$var$AuthenticatedApp, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($ee27929fe011fbcf$var$AuthenticatedApp, {})
            })
        ]
    });
};
const $ee27929fe011fbcf$var$AuthenticatedApp = ()=>{
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { tenantId: tenantId } = (0, $COwA0.useParams)();
    const matchedPath = tenantId ? `/tenant/${tenantId}` : "";
    const defaultRedirect = currentUser && (0, $cA1jy.isGuest)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Navigate), {
        to: matchedPath + "/cases",
        replace: true
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Navigate), {
        to: matchedPath + "/meetings",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $COwA0.Routes), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                index: true,
                element: defaultRedirect
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/",
                element: defaultRedirect
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meeting/:meetingId/live",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $lIZKg.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meetings",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $11pqD.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meeting/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $aesrM.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meeting/:meetingId/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $eYI5x.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meeting/:meetingId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $2yQbT.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/radiology",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $6XB6Y.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/meetingcase/:meetingCaseId/:currentTab?",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $2xY9J.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/users",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $2wnYh.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/user/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $236Dw.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/user/new_guest",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $jcbSx.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/user/:userId/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $d8ZmP.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/cases",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $eEX4u.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/case/:caseId/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $b703n.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/case/:caseId/:currentTab?",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $hLLeY.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/notifications",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $7Rg00.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/tasks",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $l57QH.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patients",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $cmDWF.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patient/:patientId/details/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $dlT2f.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patient/:patientId/further-details/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $jvnqh.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patient/:patientId/cases/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $k0GJk.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patient/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $beTuk.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/patient/:patientId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $2amIx.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/pathways",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $5Pjrh.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/pathway/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $3dYgQ.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/pathway/:pathwayId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $jaEgr.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/admin",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $1izku.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/analytics",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $8G3Yk.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/setup-mfa/intro",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lPAGv.default), {
                            directRoute: true
                        }),
                    layout: (0, $5YjhR.default),
                    overrideMfaIntercept: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/setup-mfa/totp-complete",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $lxRZO.default),
                    layout: (0, $5YjhR.default),
                    overrideMfaIntercept: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/setup-mfa/sms-complete",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $l1h9J.default),
                    layout: (0, $5YjhR.default),
                    overrideMfaIntercept: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/mfa/totp",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $2Baud.default),
                    layout: (0, $5YjhR.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/teams",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $8k0Gy.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/team/:teamId/edit",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $47VIt.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/team/new",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $3EEnl.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/team/:teamId",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $3cQf2.default),
                    layout: (0, $cOo5I.default)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Route), {
                path: "/messages",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $695Jh.default), {
                    component: (0, $giWzi.default),
                    layout: (0, $cOo5I.default)
                })
            })
        ]
    });
};

});
parcelRegister("COwA0", function(module, exports) {

$parcel$export(module.exports, "generatePath", () => $3e8179397014bb35$export$82476f982757e71e);
$parcel$export(module.exports, "DataRouterContext", () => $3e8179397014bb35$export$2eeee58951ff3c1c);
$parcel$export(module.exports, "useLocation", () => $3e8179397014bb35$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $3e8179397014bb35$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $3e8179397014bb35$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useBlocker", () => $3e8179397014bb35$export$b273b3273281a049);
$parcel$export(module.exports, "createMemoryRouter", () => $3e8179397014bb35$export$f30f7e456d254e83);
$parcel$export(module.exports, "RouterProvider", () => $3e8179397014bb35$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "Navigate", () => $3e8179397014bb35$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $3e8179397014bb35$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $3e8179397014bb35$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "createBrowserRouter", () => $3e8179397014bb35$export$1f3f55432a00e06d);
$parcel$export(module.exports, "Link", () => $3e8179397014bb35$export$a6c7ac8248d6e38a);
/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $3e8179397014bb35$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-OB3PAWPO.mjs"
});
var $3e8179397014bb35$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $3e8179397014bb35$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $3e8179397014bb35$var$__typeError("Cannot " + msg);
var $3e8179397014bb35$var$__privateGet = (obj, member, getter)=>($3e8179397014bb35$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $3e8179397014bb35$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $3e8179397014bb35$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $3e8179397014bb35$var$__privateSet = (obj, member, value, setter)=>($3e8179397014bb35$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $3e8179397014bb35$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $3e8179397014bb35$export$825a82322d91916e = /^[\\/]{2}/;
function $3e8179397014bb35$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $3e8179397014bb35$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($3e8179397014bb35$export$e19cd5f9376f8cee || {});
var $3e8179397014bb35$var$PopStateEventType = "popstate";
function $3e8179397014bb35$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $3e8179397014bb35$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $3e8179397014bb35$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $3e8179397014bb35$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $3e8179397014bb35$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $3e8179397014bb35$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $3e8179397014bb35$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $3e8179397014bb35$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    }
    return $3e8179397014bb35$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $3e8179397014bb35$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $3e8179397014bb35$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $3e8179397014bb35$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $3e8179397014bb35$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $3e8179397014bb35$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $3e8179397014bb35$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $3e8179397014bb35$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $3e8179397014bb35$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $3e8179397014bb35$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $3e8179397014bb35$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $3e8179397014bb35$var$createKey(),
        mask: mask
    };
    return location;
}
function $3e8179397014bb35$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $3e8179397014bb35$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $3e8179397014bb35$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $3e8179397014bb35$var$isLocation(to) ? to : $3e8179397014bb35$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $3e8179397014bb35$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $3e8179397014bb35$var$isLocation(to) ? to : $3e8179397014bb35$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $3e8179397014bb35$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $3e8179397014bb35$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($3e8179397014bb35$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($3e8179397014bb35$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $3e8179397014bb35$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $3e8179397014bb35$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $3e8179397014bb35$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $3e8179397014bb35$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $3e8179397014bb35$var$_map;
var $3e8179397014bb35$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).has(context)) return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).set(context, value);
    }
};
$3e8179397014bb35$var$_map = new WeakMap();
var $3e8179397014bb35$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3e8179397014bb35$var$isUnsupportedLazyRouteObjectKey(key) {
    return $3e8179397014bb35$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $3e8179397014bb35$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $3e8179397014bb35$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $3e8179397014bb35$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $3e8179397014bb35$var$isIndexRoute(route) {
    return route.index === true;
}
function $3e8179397014bb35$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $3e8179397014bb35$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $3e8179397014bb35$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($3e8179397014bb35$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $3e8179397014bb35$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $3e8179397014bb35$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $3e8179397014bb35$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $3e8179397014bb35$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $3e8179397014bb35$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $3e8179397014bb35$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $3e8179397014bb35$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $3e8179397014bb35$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $3e8179397014bb35$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $3e8179397014bb35$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $3e8179397014bb35$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $3e8179397014bb35$var$flattenAndRankRoutes(routes) {
    let branches = $3e8179397014bb35$var$flattenRoutes(routes);
    $3e8179397014bb35$var$rankRouteBranches(branches);
    return branches;
}
function $3e8179397014bb35$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $3e8179397014bb35$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $3e8179397014bb35$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $3e8179397014bb35$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $3e8179397014bb35$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3e8179397014bb35$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $3e8179397014bb35$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $3e8179397014bb35$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $3e8179397014bb35$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $3e8179397014bb35$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $3e8179397014bb35$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $3e8179397014bb35$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $3e8179397014bb35$var$paramRe = /^:[\w-]+$/;
var $3e8179397014bb35$var$dynamicSegmentValue = 3;
var $3e8179397014bb35$var$indexRouteValue = 2;
var $3e8179397014bb35$var$emptySegmentValue = 1;
var $3e8179397014bb35$var$staticSegmentValue = 10;
var $3e8179397014bb35$var$splatPenalty = -2;
var $3e8179397014bb35$var$isSplat = (s)=>s === "*";
function $3e8179397014bb35$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($3e8179397014bb35$var$isSplat)) initialScore += $3e8179397014bb35$var$splatPenalty;
    if (index) initialScore += $3e8179397014bb35$var$indexRouteValue;
    return segments.filter((s)=>!$3e8179397014bb35$var$isSplat(s)).reduce((score, segment)=>score + ($3e8179397014bb35$var$paramRe.test(segment) ? $3e8179397014bb35$var$dynamicSegmentValue : segment === "" ? $3e8179397014bb35$var$emptySegmentValue : $3e8179397014bb35$var$staticSegmentValue), initialScore);
}
function $3e8179397014bb35$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $3e8179397014bb35$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $3e8179397014bb35$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $3e8179397014bb35$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $3e8179397014bb35$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $3e8179397014bb35$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3e8179397014bb35$var$normalizePathname($3e8179397014bb35$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3e8179397014bb35$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $3e8179397014bb35$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $3e8179397014bb35$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $3e8179397014bb35$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $3e8179397014bb35$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $3e8179397014bb35$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $3e8179397014bb35$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $3e8179397014bb35$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $3e8179397014bb35$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $3e8179397014bb35$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3e8179397014bb35$var$compilePath(path, caseSensitive = false, end = true) {
    $3e8179397014bb35$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $3e8179397014bb35$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $3e8179397014bb35$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $3e8179397014bb35$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $3e8179397014bb35$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        pathname
    ]);
}
var $3e8179397014bb35$var$isAbsoluteUrl = (url)=>$3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(url);
function $3e8179397014bb35$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $3e8179397014bb35$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $3e8179397014bb35$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $3e8179397014bb35$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $3e8179397014bb35$var$normalizeSearch(search),
        hash: $3e8179397014bb35$var$normalizeHash(hash)
    };
}
function $3e8179397014bb35$var$resolvePathname(relativePath, fromPathname) {
    let segments = $3e8179397014bb35$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3e8179397014bb35$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $3e8179397014bb35$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $3e8179397014bb35$var$getResolveToMatches(matches) {
    let pathMatches = $3e8179397014bb35$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $3e8179397014bb35$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $3e8179397014bb35$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $3e8179397014bb35$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $3e8179397014bb35$var$getInvalidPathError("?", "pathname", "search", to));
        $3e8179397014bb35$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $3e8179397014bb35$var$getInvalidPathError("#", "pathname", "hash", to));
        $3e8179397014bb35$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $3e8179397014bb35$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $3e8179397014bb35$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $3e8179397014bb35$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $3e8179397014bb35$var$joinPaths = (paths)=>$3e8179397014bb35$var$removeDoubleSlashes(paths.join("/"));
function $3e8179397014bb35$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $3e8179397014bb35$var$normalizePathname = (pathname)=>$3e8179397014bb35$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $3e8179397014bb35$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $3e8179397014bb35$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $3e8179397014bb35$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $3e8179397014bb35$export$4051a07651545597(data2, init) {
    return new $3e8179397014bb35$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $3e8179397014bb35$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $3e8179397014bb35$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $3e8179397014bb35$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $3e8179397014bb35$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $3e8179397014bb35$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $3e8179397014bb35$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $3e8179397014bb35$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $3e8179397014bb35$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $3e8179397014bb35$var$joinPaths(parts) || "/";
}
var $3e8179397014bb35$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $3e8179397014bb35$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($3e8179397014bb35$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $3e8179397014bb35$export$825a82322d91916e.test(to) ? new URL($3e8179397014bb35$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $3e8179397014bb35$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $3e8179397014bb35$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $3e8179397014bb35$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $3e8179397014bb35$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $3e8179397014bb35$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$3e8179397014bb35$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated[key], original, (...args)=>$3e8179397014bb35$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$3e8179397014bb35$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$3e8179397014bb35$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated.middleware, original, (...args)=>$3e8179397014bb35$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$3e8179397014bb35$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $3e8179397014bb35$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$3e8179397014bb35$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $3e8179397014bb35$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $3e8179397014bb35$export$fe53371bee54353d(to) : ".",
                ...$3e8179397014bb35$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$3e8179397014bb35$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$3e8179397014bb35$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $3e8179397014bb35$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$3e8179397014bb35$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$3e8179397014bb35$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $3e8179397014bb35$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $3e8179397014bb35$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $3e8179397014bb35$var$getReadonlyRequest(request),
            context: context != null ? $3e8179397014bb35$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $3e8179397014bb35$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $3e8179397014bb35$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $3e8179397014bb35$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $3e8179397014bb35$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $3e8179397014bb35$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $3e8179397014bb35$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $3e8179397014bb35$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $3e8179397014bb35$var$getReadonlyContext(context)
    };
}
function $3e8179397014bb35$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $3e8179397014bb35$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $3e8179397014bb35$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $3e8179397014bb35$var$getReadonlyContext(context) {
    if ($3e8179397014bb35$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $3e8179397014bb35$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3e8179397014bb35$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3e8179397014bb35$var$objectProtoNames;
}
// lib/router/navigation.ts
var $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL;
    }
}
function $3e8179397014bb35$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $3e8179397014bb35$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $3e8179397014bb35$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$3e8179397014bb35$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$3e8179397014bb35$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$3e8179397014bb35$var$isExplicitUrl(original, originalUrl) || !$3e8179397014bb35$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $3e8179397014bb35$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $3e8179397014bb35$var$validMutationMethods = new Set($3e8179397014bb35$var$validMutationMethodsArr);
var $3e8179397014bb35$var$validRequestMethodsArr = [
    "GET",
    ...$3e8179397014bb35$var$validMutationMethodsArr
];
var $3e8179397014bb35$var$validRequestMethods = new Set($3e8179397014bb35$var$validRequestMethodsArr);
var $3e8179397014bb35$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $3e8179397014bb35$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $3e8179397014bb35$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3e8179397014bb35$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3e8179397014bb35$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $3e8179397014bb35$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $3e8179397014bb35$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $3e8179397014bb35$var$_routes, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$_hmrRoutes, $3e8179397014bb35$var$_hmrBranches;
var $3e8179397014bb35$var$DataRoutes = class {
    constructor(routes){
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_routes);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_branches);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_hmrRoutes);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_hmrBranches);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes) ?? $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrBranches) ?? $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_branches);
    }
    get hasHMRRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrRoutes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrBranches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes)) {
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes));
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrBranches));
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrRoutes, void 0);
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrBranches, void 0);
        }
    }
};
$3e8179397014bb35$var$_routes = new WeakMap();
$3e8179397014bb35$var$_branches = new WeakMap();
$3e8179397014bb35$var$_hmrRoutes = new WeakMap();
$3e8179397014bb35$var$_hmrBranches = new WeakMap();
function $3e8179397014bb35$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $3e8179397014bb35$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $3e8179397014bb35$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3e8179397014bb35$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $3e8179397014bb35$var$DataRoutes($3e8179397014bb35$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $3e8179397014bb35$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$3e8179397014bb35$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $3e8179397014bb35$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $3e8179397014bb35$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $3e8179397014bb35$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $3e8179397014bb35$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$3e8179397014bb35$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $3e8179397014bb35$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $3e8179397014bb35$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $3e8179397014bb35$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $3e8179397014bb35$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $3e8179397014bb35$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $3e8179397014bb35$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $3e8179397014bb35$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($3e8179397014bb35$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $3e8179397014bb35$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $3e8179397014bb35$export$fe53371bee54353d(opts.mask), $3e8179397014bb35$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $3e8179397014bb35$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $3e8179397014bb35$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $3e8179397014bb35$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $3e8179397014bb35$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $3e8179397014bb35$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $3e8179397014bb35$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $3e8179397014bb35$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $3e8179397014bb35$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $3e8179397014bb35$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($3e8179397014bb35$var$isErrorResult(result) && $3e8179397014bb35$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $3e8179397014bb35$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$3e8179397014bb35$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $3e8179397014bb35$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $3e8179397014bb35$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $3e8179397014bb35$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $3e8179397014bb35$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $3e8179397014bb35$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $3e8179397014bb35$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $3e8179397014bb35$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3e8179397014bb35$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$3e8179397014bb35$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $3e8179397014bb35$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $3e8179397014bb35$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$3e8179397014bb35$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $3e8179397014bb35$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $3e8179397014bb35$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $3e8179397014bb35$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3e8179397014bb35$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $3e8179397014bb35$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($3e8179397014bb35$var$isRedirectResult(actionResult) || $3e8179397014bb35$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($3e8179397014bb35$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $3e8179397014bb35$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($3e8179397014bb35$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $3e8179397014bb35$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3e8179397014bb35$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $3e8179397014bb35$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $3e8179397014bb35$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $3e8179397014bb35$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $3e8179397014bb35$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $3e8179397014bb35$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $3e8179397014bb35$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $3e8179397014bb35$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $3e8179397014bb35$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3e8179397014bb35$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $3e8179397014bb35$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
            return;
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $3e8179397014bb35$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $3e8179397014bb35$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $3e8179397014bb35$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $3e8179397014bb35$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($3e8179397014bb35$var$isAbsoluteUrl(location)) {
                const url = $3e8179397014bb35$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $3e8179397014bb35$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($3e8179397014bb35$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $3e8179397014bb35$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $3e8179397014bb35$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $3e8179397014bb35$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$3e8179397014bb35$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($3e8179397014bb35$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $3e8179397014bb35$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $3e8179397014bb35$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $3e8179397014bb35$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $3e8179397014bb35$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $3e8179397014bb35$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $3e8179397014bb35$export$386d57f03f0b2883;
        $3e8179397014bb35$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $3e8179397014bb35$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $3e8179397014bb35$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$3e8179397014bb35$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($3e8179397014bb35$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $3e8179397014bb35$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $3e8179397014bb35$export$3336b097a6fbc59a(routes, opts) {
    $3e8179397014bb35$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $3e8179397014bb35$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3e8179397014bb35$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $3e8179397014bb35$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $3e8179397014bb35$var$defaultNormalizePath;
        let method = request.method;
        let location = $3e8179397014bb35$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        if (!$3e8179397014bb35$var$isValidMethod(method) && method !== "HEAD") {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $3e8179397014bb35$export$f5708dca728d7177(requestContext instanceof $3e8179397014bb35$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $3e8179397014bb35$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $3e8179397014bb35$var$createDataFunctionUrl(request, location),
                    pattern: $3e8179397014bb35$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($3e8179397014bb35$export$6e80290866a84dd4(error)) return error;
                    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $3e8179397014bb35$export$f2680fa305b734ca(error.status, error.statusText, await $3e8179397014bb35$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(error)) error = $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $3e8179397014bb35$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $3e8179397014bb35$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $3e8179397014bb35$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $3e8179397014bb35$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $3e8179397014bb35$var$defaultNormalizePath;
        let method = request.method;
        let location = $3e8179397014bb35$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        if (!$3e8179397014bb35$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $3e8179397014bb35$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $3e8179397014bb35$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $3e8179397014bb35$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $3e8179397014bb35$export$f5708dca728d7177(requestContext instanceof $3e8179397014bb35$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $3e8179397014bb35$var$runServerMiddlewarePipeline({
                request: request,
                url: $3e8179397014bb35$var$createDataFunctionUrl(request, location),
                pattern: $3e8179397014bb35$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($3e8179397014bb35$var$dataWithResponseInitToResponse(error));
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $3e8179397014bb35$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($3e8179397014bb35$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $3e8179397014bb35$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($3e8179397014bb35$var$isDataStrategyResult(e) && $3e8179397014bb35$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($3e8179397014bb35$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($3e8179397014bb35$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($3e8179397014bb35$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $3e8179397014bb35$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $3e8179397014bb35$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $3e8179397014bb35$var$callDataStrategyImpl(dataStrategy || $3e8179397014bb35$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($3e8179397014bb35$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result.result)) throw $3e8179397014bb35$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $3e8179397014bb35$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $3e8179397014bb35$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $3e8179397014bb35$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $3e8179397014bb35$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $3e8179397014bb35$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $3e8179397014bb35$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $3e8179397014bb35$var$resolveTo(to ? to : ".", $3e8179397014bb35$var$getResolveToMatches(contextualMatches), $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $3e8179397014bb35$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $3e8179397014bb35$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $3e8179397014bb35$export$fe53371bee54353d(path);
}
function $3e8179397014bb35$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$3e8179397014bb35$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$3e8179397014bb35$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $3e8179397014bb35$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $3e8179397014bb35$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $3e8179397014bb35$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$3e8179397014bb35$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$3e8179397014bb35$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $3e8179397014bb35$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $3e8179397014bb35$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $3e8179397014bb35$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $3e8179397014bb35$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $3e8179397014bb35$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $3e8179397014bb35$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $3e8179397014bb35$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $3e8179397014bb35$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$3e8179397014bb35$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $3e8179397014bb35$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($3e8179397014bb35$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($3e8179397014bb35$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $3e8179397014bb35$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $3e8179397014bb35$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($3e8179397014bb35$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $3e8179397014bb35$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $3e8179397014bb35$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$3e8179397014bb35$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $3e8179397014bb35$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $3e8179397014bb35$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $3e8179397014bb35$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $3e8179397014bb35$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$3e8179397014bb35$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $3e8179397014bb35$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $3e8179397014bb35$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$3e8179397014bb35$var$isSameRoute(aChild, bChild))) ?? false;
}
var $3e8179397014bb35$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $3e8179397014bb35$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $3e8179397014bb35$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $3e8179397014bb35$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $3e8179397014bb35$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $3e8179397014bb35$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $3e8179397014bb35$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $3e8179397014bb35$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $3e8179397014bb35$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $3e8179397014bb35$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $3e8179397014bb35$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $3e8179397014bb35$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $3e8179397014bb35$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $3e8179397014bb35$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $3e8179397014bb35$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $3e8179397014bb35$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $3e8179397014bb35$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $3e8179397014bb35$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $3e8179397014bb35$var$isNonNullable(value) {
    return value !== void 0;
}
function $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $3e8179397014bb35$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($3e8179397014bb35$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $3e8179397014bb35$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $3e8179397014bb35$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $3e8179397014bb35$var$defaultDataStrategy(args);
    return $3e8179397014bb35$var$runClientMiddlewarePipeline(args, ()=>$3e8179397014bb35$var$defaultDataStrategy(args));
}
function $3e8179397014bb35$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, processResult, $3e8179397014bb35$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $3e8179397014bb35$export$e0163cfdf7bc9cfa(result) ? $3e8179397014bb35$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $3e8179397014bb35$var$runClientMiddlewarePipeline(args, handler) {
    return $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($3e8179397014bb35$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $3e8179397014bb35$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $3e8179397014bb35$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $3e8179397014bb35$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $3e8179397014bb35$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $3e8179397014bb35$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $3e8179397014bb35$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $3e8179397014bb35$var$loadLazyRoute(match.route, $3e8179397014bb35$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $3e8179397014bb35$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $3e8179397014bb35$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $3e8179397014bb35$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$3e8179397014bb35$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($3e8179397014bb35$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $3e8179397014bb35$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $3e8179397014bb35$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $3e8179397014bb35$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $3e8179397014bb35$var$createDataFunctionUrl(request, path),
        pattern: $3e8179397014bb35$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $3e8179397014bb35$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $3e8179397014bb35$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $3e8179397014bb35$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $3e8179397014bb35$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $3e8179397014bb35$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $3e8179397014bb35$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $3e8179397014bb35$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $3e8179397014bb35$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $3e8179397014bb35$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $3e8179397014bb35$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $3e8179397014bb35$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $3e8179397014bb35$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$3e8179397014bb35$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $3e8179397014bb35$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $3e8179397014bb35$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $3e8179397014bb35$export$961a3ef7a4da3a39(location) {
    try {
        return $3e8179397014bb35$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $3e8179397014bb35$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($3e8179397014bb35$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $3e8179397014bb35$export$825a82322d91916e.test(normalizedLocation) ? new URL($3e8179397014bb35$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($3e8179397014bb35$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $3e8179397014bb35$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($3e8179397014bb35$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $3e8179397014bb35$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($3e8179397014bb35$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $3e8179397014bb35$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $3e8179397014bb35$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $3e8179397014bb35$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $3e8179397014bb35$export$f5708dca728d7177(!$3e8179397014bb35$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $3e8179397014bb35$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $3e8179397014bb35$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $3e8179397014bb35$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($3e8179397014bb35$var$isRedirectResult(result)) $3e8179397014bb35$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $3e8179397014bb35$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $3e8179397014bb35$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $3e8179397014bb35$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $3e8179397014bb35$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $3e8179397014bb35$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $3e8179397014bb35$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $3e8179397014bb35$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $3e8179397014bb35$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $3e8179397014bb35$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($3e8179397014bb35$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $3e8179397014bb35$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(path) : path;
    return $3e8179397014bb35$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $3e8179397014bb35$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $3e8179397014bb35$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(data2) {
    return new $3e8179397014bb35$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $3e8179397014bb35$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $3e8179397014bb35$var$isDataStrategyResult(value));
}
function $3e8179397014bb35$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $3e8179397014bb35$var$isRedirectDataStrategyResult(result) {
    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result) && $3e8179397014bb35$var$redirectStatusCodes.has(result.result.status);
}
function $3e8179397014bb35$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $3e8179397014bb35$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $3e8179397014bb35$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $3e8179397014bb35$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $3e8179397014bb35$export$794b2760043cf8cd(statusCode) {
    return $3e8179397014bb35$var$redirectStatusCodes.has(statusCode);
}
function $3e8179397014bb35$export$6e80290866a84dd4(result) {
    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result) && $3e8179397014bb35$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $3e8179397014bb35$var$isValidMethod(method) {
    return $3e8179397014bb35$var$validRequestMethods.has(method.toUpperCase());
}
function $3e8179397014bb35$export$cbae47800eb95bc3(method) {
    return $3e8179397014bb35$var$validMutationMethods.has(method.toUpperCase());
}
function $3e8179397014bb35$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $3e8179397014bb35$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $3e8179397014bb35$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $3e8179397014bb35$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $3e8179397014bb35$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $3e8179397014bb35$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $3e8179397014bb35$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $3e8179397014bb35$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $3e8179397014bb35$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $3e8179397014bb35$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $3e8179397014bb35$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $3e8179397014bb35$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $3e8179397014bb35$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $3e8179397014bb35$export$2eeee58951ff3c1c = $acw62.createContext(null);
$3e8179397014bb35$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $3e8179397014bb35$export$315e3ffb01f217 = $acw62.createContext(null);
$3e8179397014bb35$export$315e3ffb01f217.displayName = "DataRouterState";
var $3e8179397014bb35$export$717f757c655223f1 = $acw62.createContext(false);
function $3e8179397014bb35$var$useIsRSCRouterContext() {
    return $acw62.useContext($3e8179397014bb35$export$717f757c655223f1);
}
var $3e8179397014bb35$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$3e8179397014bb35$export$3681f408decb40d1.displayName = "ViewTransition";
var $3e8179397014bb35$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$3e8179397014bb35$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $3e8179397014bb35$var$AwaitContext = $acw62.createContext(null);
$3e8179397014bb35$var$AwaitContext.displayName = "Await";
var $3e8179397014bb35$export$2666c20e15407622 = (props)=>$acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, props);
var $3e8179397014bb35$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$3e8179397014bb35$export$3044ab7fdabeaee6.displayName = "Navigation";
var $3e8179397014bb35$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$3e8179397014bb35$export$e6a44b110a0c44d3.displayName = "Location";
var $3e8179397014bb35$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$3e8179397014bb35$export$aac280ed165a4397.displayName = "Route";
var $3e8179397014bb35$var$RouteErrorContext = $acw62.createContext(null);
$3e8179397014bb35$var$RouteErrorContext.displayName = "RouteError";
var $3e8179397014bb35$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $3e8179397014bb35$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $3e8179397014bb35$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $3e8179397014bb35$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $3e8179397014bb35$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$3e8179397014bb35$var$ERROR_DIGEST_BASE}:${$3e8179397014bb35$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $3e8179397014bb35$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$3e8179397014bb35$var$ERROR_DIGEST_BASE}:${$3e8179397014bb35$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $3e8179397014bb35$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $3e8179397014bb35$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $3e8179397014bb35$export$9c954a9d03d32f4a() {
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3) != null;
}
function $3e8179397014bb35$export$45d76561a5302f2b() {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3).location;
}
function $3e8179397014bb35$export$1b3f31771c5d07c() {
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3).navigationType;
}
function $3e8179397014bb35$export$6c330e8992e8a295(pattern) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$3e8179397014bb35$export$81336c211d5ff295(pattern, $3e8179397014bb35$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $3e8179397014bb35$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $3e8179397014bb35$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $3e8179397014bb35$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    return isDataRoute ? $3e8179397014bb35$var$useNavigateStable() : $3e8179397014bb35$var$useNavigateUnstable();
}
function $3e8179397014bb35$var$useNavigateUnstable() {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3e8179397014bb35$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $3e8179397014bb35$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $3e8179397014bb35$var$warning(activeRef.current, $3e8179397014bb35$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $3e8179397014bb35$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
            basename,
            path.pathname
        ]);
        $3e8179397014bb35$export$6c8e41f66e7aa990(typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), navigator.createHref(path), $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $3e8179397014bb35$var$OutletContext = $acw62.createContext(null);
function $3e8179397014bb35$export$4138103a3ae699cc() {
    return $acw62.useContext($3e8179397014bb35$var$OutletContext);
}
function $3e8179397014bb35$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $3e8179397014bb35$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $3e8179397014bb35$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3e8179397014bb35$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$3e8179397014bb35$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $3e8179397014bb35$export$5d3fca4a98652595(routes, locationArg) {
    return $3e8179397014bb35$var$useRoutesImpl(routes, locationArg);
}
function $3e8179397014bb35$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $3e8179397014bb35$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $3e8179397014bb35$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $3e8179397014bb35$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $3e8179397014bb35$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        $3e8179397014bb35$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $3e8179397014bb35$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $3e8179397014bb35$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $3e8179397014bb35$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $3e8179397014bb35$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3e8179397014bb35$var$DefaultErrorComponent() {
    let error = $3e8179397014bb35$export$ed527bf60f6e05f2();
    let message = $3e8179397014bb35$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $3e8179397014bb35$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$DefaultErrorComponent, null);
var $3e8179397014bb35$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $3e8179397014bb35$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$3e8179397014bb35$var$RenderErrorBoundary.contextType = $3e8179397014bb35$export$717f757c655223f1;
var $3e8179397014bb35$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $3e8179397014bb35$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $3e8179397014bb35$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $3e8179397014bb35$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $3e8179397014bb35$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $3e8179397014bb35$export$6c8e41f66e7aa990(redirect2.location, target, $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($3e8179397014bb35$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($3e8179397014bb35$var$isBrowser && !$3e8179397014bb35$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $3e8179397014bb35$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $3e8179397014bb35$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $3e8179397014bb35$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $3e8179397014bb35$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $3e8179397014bb35$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $3e8179397014bb35$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3e8179397014bb35$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $3e8179397014bb35$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3e8179397014bb35$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$export$f5708dca728d7177(ctx, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $3e8179397014bb35$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$export$f5708dca728d7177(state, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return state;
}
function $3e8179397014bb35$var$useRouteContext(hookName) {
    let route = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    $3e8179397014bb35$export$f5708dca728d7177(route, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return route;
}
function $3e8179397014bb35$var$useCurrentRouteId(hookName) {
    let route = $3e8179397014bb35$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $3e8179397014bb35$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $3e8179397014bb35$var$useRouteId() {
    return $3e8179397014bb35$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $3e8179397014bb35$export$d0fd4b7106de2769() {
    let state = $3e8179397014bb35$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $3e8179397014bb35$export$600dc272ed516c15() {
    let dataRouterContext = $3e8179397014bb35$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $3e8179397014bb35$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $3e8179397014bb35$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3e8179397014bb35$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$3e8179397014bb35$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $3e8179397014bb35$export$1448a5050d252c4d() {
    let state = $3e8179397014bb35$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $3e8179397014bb35$export$fd5d37484eab868d(routeId) {
    let state = $3e8179397014bb35$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $3e8179397014bb35$export$fdc00f3f26066d5e() {
    let state = $3e8179397014bb35$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $3e8179397014bb35$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($3e8179397014bb35$var$RouteErrorContext);
    let state = $3e8179397014bb35$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $3e8179397014bb35$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($3e8179397014bb35$var$AwaitContext);
    return value?._data;
}
function $3e8179397014bb35$export$17f53340677d5831() {
    let value = $acw62.useContext($3e8179397014bb35$var$AwaitContext);
    return value?._error;
}
var $3e8179397014bb35$var$blockerId = 0;
function $3e8179397014bb35$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3e8179397014bb35$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $3e8179397014bb35$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $3e8179397014bb35$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $3e8179397014bb35$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$3e8179397014bb35$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $3e8179397014bb35$export$386d57f03f0b2883;
}
function $3e8179397014bb35$var$useNavigateStable() {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $3e8179397014bb35$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $3e8179397014bb35$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $3e8179397014bb35$var$warning(activeRef.current, $3e8179397014bb35$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $3e8179397014bb35$var$alreadyWarned = {};
function $3e8179397014bb35$var$warningOnce(key, cond, message) {
    if (!cond && !$3e8179397014bb35$var$alreadyWarned[key]) {
        $3e8179397014bb35$var$alreadyWarned[key] = true;
        $3e8179397014bb35$var$warning(false, message);
    }
}
function $3e8179397014bb35$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $3e8179397014bb35$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $3e8179397014bb35$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $3e8179397014bb35$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $3e8179397014bb35$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $3e8179397014bb35$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$3e8179397014bb35$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$3e8179397014bb35$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $3e8179397014bb35$var$alreadyWarned2 = {};
function $3e8179397014bb35$export$5b28268982f175ba(condition, message) {
    if (!condition && !$3e8179397014bb35$var$alreadyWarned2[message]) {
        $3e8179397014bb35$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $3e8179397014bb35$var$USE_OPTIMISTIC = "useOptimistic";
var $3e8179397014bb35$var$useOptimisticImpl = $acw62[$3e8179397014bb35$var$USE_OPTIMISTIC];
var $3e8179397014bb35$var$stableUseOptimisticSetter = ()=>void 0;
function $3e8179397014bb35$var$useOptimisticSafe(val) {
    if ($3e8179397014bb35$var$useOptimisticImpl) return $3e8179397014bb35$var$useOptimisticImpl(val);
    else return [
        val,
        $3e8179397014bb35$var$stableUseOptimisticSetter
    ];
}
function $3e8179397014bb35$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.element) $3e8179397014bb35$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $3e8179397014bb35$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.errorElement) $3e8179397014bb35$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $3e8179397014bb35$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $3e8179397014bb35$export$f30f7e456d254e83(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $3e8179397014bb35$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $3e8179397014bb35$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $3e8179397014bb35$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $3e8179397014bb35$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $3e8179397014bb35$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $3e8179397014bb35$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $3e8179397014bb35$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$3e8179397014bb35$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $3e8179397014bb35$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$3e8179397014bb35$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $3e8179397014bb35$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $3e8179397014bb35$var$MemoizedDataRoutes = $acw62.memo($3e8179397014bb35$var$DataRoutes2);
function $3e8179397014bb35$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $3e8179397014bb35$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $3e8179397014bb35$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    $3e8179397014bb35$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let path = $3e8179397014bb35$var$resolveTo(to, $3e8179397014bb35$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $3e8179397014bb35$export$6c8e41f66e7aa990(typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), navigator.createHref(path), $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $3e8179397014bb35$export$910ae8079b2c2852(props) {
    return $3e8179397014bb35$export$a3be3530d8e40d0b(props.context);
}
function $3e8179397014bb35$export$e7b0ac011bb776c6(props) {
    $3e8179397014bb35$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $3e8179397014bb35$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $3e8179397014bb35$export$f5708dca728d7177(!$3e8179397014bb35$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $3e8179397014bb35$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $3e8179397014bb35$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $3e8179397014bb35$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $3e8179397014bb35$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $3e8179397014bb35$export$5d3fca4a98652595($3e8179397014bb35$export$16da398f5434bdec(children), location);
}
function $3e8179397014bb35$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $3e8179397014bb35$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$ResolveAwait, null, children));
}
var $3e8179397014bb35$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $3e8179397014bb35$var$ResolveAwait({ children: children }) {
    let data2 = $3e8179397014bb35$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $3e8179397014bb35$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $3e8179397014bb35$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $3e8179397014bb35$export$f5708dca728d7177(element.type === $3e8179397014bb35$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $3e8179397014bb35$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3e8179397014bb35$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $3e8179397014bb35$export$9b5b6d122dea0c88 = $3e8179397014bb35$export$16da398f5434bdec;
function $3e8179397014bb35$export$daf73786167a7f72(matches) {
    return $3e8179397014bb35$var$_renderMatches(matches);
}
function $3e8179397014bb35$var$useRouteComponentProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e(),
        matches: $3e8179397014bb35$export$2378eb7f5ff86053()
    };
}
function $3e8179397014bb35$export$6c4f3826290c37af({ children: children }) {
    const props = $3e8179397014bb35$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $3e8179397014bb35$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $3e8179397014bb35$var$useHydrateFallbackProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e()
    };
}
function $3e8179397014bb35$export$f8cff34f39c1932a({ children: children }) {
    const props = $3e8179397014bb35$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $3e8179397014bb35$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $3e8179397014bb35$var$useErrorBoundaryProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e(),
        error: $3e8179397014bb35$export$ed527bf60f6e05f2()
    };
}
function $3e8179397014bb35$export$e5afde5c4b6d747b({ children: children }) {
    const props = $3e8179397014bb35$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $3e8179397014bb35$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $3e8179397014bb35$var$defaultMethod = "get";
var $3e8179397014bb35$var$defaultEncType = "application/x-www-form-urlencoded";
function $3e8179397014bb35$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $3e8179397014bb35$var$isButtonElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3e8179397014bb35$var$isFormElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3e8179397014bb35$var$isInputElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3e8179397014bb35$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3e8179397014bb35$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3e8179397014bb35$var$isModifiedEvent(event);
}
function $3e8179397014bb35$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3e8179397014bb35$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3e8179397014bb35$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $3e8179397014bb35$var$_formDataSupportsSubmitter = null;
function $3e8179397014bb35$var$isFormDataSubmitterSupported() {
    if ($3e8179397014bb35$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3e8179397014bb35$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3e8179397014bb35$var$_formDataSupportsSubmitter = true;
    }
    return $3e8179397014bb35$var$_formDataSupportsSubmitter;
}
var $3e8179397014bb35$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3e8179397014bb35$var$getFormEncType(encType) {
    if (encType != null && !$3e8179397014bb35$var$supportedFormEncTypes.has(encType)) {
        $3e8179397014bb35$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$3e8179397014bb35$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $3e8179397014bb35$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3e8179397014bb35$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $3e8179397014bb35$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $3e8179397014bb35$var$defaultMethod;
        encType = $3e8179397014bb35$var$getFormEncType(target.getAttribute("enctype")) || $3e8179397014bb35$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3e8179397014bb35$var$isButtonElement(target) || $3e8179397014bb35$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $3e8179397014bb35$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3e8179397014bb35$var$defaultMethod;
        encType = $3e8179397014bb35$var$getFormEncType(target.getAttribute("formenctype")) || $3e8179397014bb35$var$getFormEncType(form.getAttribute("enctype")) || $3e8179397014bb35$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$3e8179397014bb35$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3e8179397014bb35$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $3e8179397014bb35$var$defaultMethod;
        action = null;
        encType = $3e8179397014bb35$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $3e8179397014bb35$var$HOLE = -1;
var $3e8179397014bb35$var$NAN = -2;
var $3e8179397014bb35$var$NEGATIVE_INFINITY = -3;
var $3e8179397014bb35$var$NEGATIVE_ZERO = -4;
var $3e8179397014bb35$var$NULL = -5;
var $3e8179397014bb35$var$POSITIVE_INFINITY = -6;
var $3e8179397014bb35$var$UNDEFINED = -7;
var $3e8179397014bb35$var$TYPE_BIGINT = "B";
var $3e8179397014bb35$var$TYPE_DATE = "D";
var $3e8179397014bb35$var$TYPE_ERROR = "E";
var $3e8179397014bb35$var$TYPE_MAP = "M";
var $3e8179397014bb35$var$TYPE_NULL_OBJECT = "N";
var $3e8179397014bb35$var$TYPE_PROMISE = "P";
var $3e8179397014bb35$var$TYPE_REGEXP = "R";
var $3e8179397014bb35$var$TYPE_SET = "S";
var $3e8179397014bb35$var$TYPE_SYMBOL = "Y";
var $3e8179397014bb35$var$TYPE_URL = "U";
var $3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $3e8179397014bb35$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $3e8179397014bb35$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $3e8179397014bb35$var$TIME_LIMIT_MS = 1;
var $3e8179397014bb35$var$getNow = ()=>Date.now();
var $3e8179397014bb35$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $3e8179397014bb35$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $3e8179397014bb35$var$UNDEFINED;
    if (input === null) return $3e8179397014bb35$var$NULL;
    if (Number.isNaN(input)) return $3e8179397014bb35$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $3e8179397014bb35$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $3e8179397014bb35$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $3e8179397014bb35$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $3e8179397014bb35$var$stringify.call(this, stack);
    return index;
}
async function $3e8179397014bb35$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $3e8179397014bb35$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $3e8179397014bb35$var$UNDEFINED;
        if (value === null) return $3e8179397014bb35$var$NULL;
        if (Number.isNaN(value)) return $3e8179397014bb35$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $3e8179397014bb35$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $3e8179397014bb35$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $3e8179397014bb35$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $3e8179397014bb35$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $3e8179397014bb35$var$TIME_LIMIT_MS) {
            await $3e8179397014bb35$var$yieldToMain();
            lastYieldTime = $3e8179397014bb35$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$3e8179397014bb35$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$3e8179397014bb35$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$3e8179397014bb35$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $3e8179397014bb35$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$3e8179397014bb35$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$3e8179397014bb35$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$3e8179397014bb35$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$3e8179397014bb35$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$3e8179397014bb35$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$3e8179397014bb35$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$3e8179397014bb35$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$3e8179397014bb35$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$3e8179397014bb35$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$3e8179397014bb35$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($3e8179397014bb35$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $3e8179397014bb35$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3e8179397014bb35$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3e8179397014bb35$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $3e8179397014bb35$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $3e8179397014bb35$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $3e8179397014bb35$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $3e8179397014bb35$var$hydrate.call(this, startIndex);
}
function $3e8179397014bb35$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $3e8179397014bb35$var$UNDEFINED:
                set(void 0);
                continue;
            case $3e8179397014bb35$var$NULL:
                set(null);
                continue;
            case $3e8179397014bb35$var$NAN:
                set(NaN);
                continue;
            case $3e8179397014bb35$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $3e8179397014bb35$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $3e8179397014bb35$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $3e8179397014bb35$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $3e8179397014bb35$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $3e8179397014bb35$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $3e8179397014bb35$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $3e8179397014bb35$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $3e8179397014bb35$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $3e8179397014bb35$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $3e8179397014bb35$var$globalObj && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $3e8179397014bb35$var$globalObj && typeof $3e8179397014bb35$var$globalObj[errorType] === "function" ? new $3e8179397014bb35$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $3e8179397014bb35$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $3e8179397014bb35$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $3e8179397014bb35$var$Deferred2();
    const reader = readable.pipeThrough($3e8179397014bb35$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $3e8179397014bb35$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $3e8179397014bb35$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $3e8179397014bb35$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $3e8179397014bb35$var$unflatten.call(this, line)
    };
}
async function $3e8179397014bb35$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $3e8179397014bb35$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3e8179397014bb35$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $3e8179397014bb35$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3e8179397014bb35$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $3e8179397014bb35$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $3e8179397014bb35$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $3e8179397014bb35$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:[["${$3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $3e8179397014bb35$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:[["${$3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $3e8179397014bb35$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $3e8179397014bb35$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $3e8179397014bb35$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $3e8179397014bb35$export$4cf11838cdc2a8a8(html) {
    return html.replace($3e8179397014bb35$var$ESCAPE_REGEX, (match)=>$3e8179397014bb35$var$ESCAPE_LOOKUP[match]);
}
function $3e8179397014bb35$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $3e8179397014bb35$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $3e8179397014bb35$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $3e8179397014bb35$var$SingleFetchNoResultError = class extends Error {
};
var $3e8179397014bb35$export$ae9272e641ead836 = 202;
var $3e8179397014bb35$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $3e8179397014bb35$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $3e8179397014bb35$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $3e8179397014bb35$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $3e8179397014bb35$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $3e8179397014bb35$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $3e8179397014bb35$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $3e8179397014bb35$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $3e8179397014bb35$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $3e8179397014bb35$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $3e8179397014bb35$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $3e8179397014bb35$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3e8179397014bb35$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result) || $3e8179397014bb35$export$972111febbeef05b(result.result) || $3e8179397014bb35$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $3e8179397014bb35$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $3e8179397014bb35$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $3e8179397014bb35$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$3e8179397014bb35$var$createDeferred2());
    let singleFetchDfd = $3e8179397014bb35$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $3e8179397014bb35$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $3e8179397014bb35$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $3e8179397014bb35$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $3e8179397014bb35$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3e8179397014bb35$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $3e8179397014bb35$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $3e8179397014bb35$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$3e8179397014bb35$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$3e8179397014bb35$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $3e8179397014bb35$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $3e8179397014bb35$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $3e8179397014bb35$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $3e8179397014bb35$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $3e8179397014bb35$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $3e8179397014bb35$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($3e8179397014bb35$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $3e8179397014bb35$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $3e8179397014bb35$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($3e8179397014bb35$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$3e8179397014bb35$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $3e8179397014bb35$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $3e8179397014bb35$export$4023ad4ecd4126a2(body, global) {
    return $3e8179397014bb35$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $3e8179397014bb35$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$3e8179397014bb35$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $3e8179397014bb35$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $3e8179397014bb35$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $3e8179397014bb35$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $3e8179397014bb35$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $3e8179397014bb35$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $3e8179397014bb35$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $3e8179397014bb35$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest);
    return $3e8179397014bb35$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $3e8179397014bb35$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $3e8179397014bb35$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $3e8179397014bb35$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($3e8179397014bb35$var$prefetchStyleLink));
}
async function $3e8179397014bb35$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$3e8179397014bb35$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$3e8179397014bb35$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$3e8179397014bb35$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($3e8179397014bb35$var$prefetchStyleLink));
}
async function $3e8179397014bb35$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $3e8179397014bb35$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $3e8179397014bb35$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $3e8179397014bb35$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $3e8179397014bb35$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $3e8179397014bb35$var$dedupeLinkDescriptors(links.flat(1).filter($3e8179397014bb35$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $3e8179397014bb35$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $3e8179397014bb35$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $3e8179397014bb35$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $3e8179397014bb35$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$3e8179397014bb35$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($3e8179397014bb35$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $3e8179397014bb35$var$_isPreloadSupported;
function $3e8179397014bb35$var$isPreloadSupported() {
    if ($3e8179397014bb35$var$_isPreloadSupported !== void 0) return $3e8179397014bb35$var$_isPreloadSupported;
    let el = document.createElement("link");
    $3e8179397014bb35$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $3e8179397014bb35$var$_isPreloadSupported;
}
function $3e8179397014bb35$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $3e8179397014bb35$var$useFrameworkContext();
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $3e8179397014bb35$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $3e8179397014bb35$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $3e8179397014bb35$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $3e8179397014bb35$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RemixRootDefaultErrorBoundary, {
            error: $3e8179397014bb35$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $3e8179397014bb35$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $3e8179397014bb35$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $3e8179397014bb35$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3e8179397014bb35$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $3e8179397014bb35$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $3e8179397014bb35$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $3e8179397014bb35$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $3e8179397014bb35$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $3e8179397014bb35$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $3e8179397014bb35$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $3e8179397014bb35$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $3e8179397014bb35$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $3e8179397014bb35$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $3e8179397014bb35$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $3e8179397014bb35$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $3e8179397014bb35$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $3e8179397014bb35$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $3e8179397014bb35$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $3e8179397014bb35$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $3e8179397014bb35$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $3e8179397014bb35$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $3e8179397014bb35$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $3e8179397014bb35$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $3e8179397014bb35$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $3e8179397014bb35$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $3e8179397014bb35$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3e8179397014bb35$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $3e8179397014bb35$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $3e8179397014bb35$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $3e8179397014bb35$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $3e8179397014bb35$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $3e8179397014bb35$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $3e8179397014bb35$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $3e8179397014bb35$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $3e8179397014bb35$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $3e8179397014bb35$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $3e8179397014bb35$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $3e8179397014bb35$var$nextPaths = /* @__PURE__ */ new Set();
var $3e8179397014bb35$var$discoveredPathsMaxSize = 1e3;
var $3e8179397014bb35$var$discoveredPaths = /* @__PURE__ */ new Set();
var $3e8179397014bb35$export$b5915cf27fa06b9f = 7680;
function $3e8179397014bb35$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $3e8179397014bb35$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $3e8179397014bb35$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($3e8179397014bb35$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $3e8179397014bb35$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $3e8179397014bb35$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $3e8179397014bb35$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$3e8179397014bb35$var$discoveredPaths.has(pathname)) $3e8179397014bb35$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($3e8179397014bb35$var$nextPaths.keys()).filter((path)=>{
                if ($3e8179397014bb35$var$discoveredPaths.has(path)) {
                    $3e8179397014bb35$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $3e8179397014bb35$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $3e8179397014bb35$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $3e8179397014bb35$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $3e8179397014bb35$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $3e8179397014bb35$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $3e8179397014bb35$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($3e8179397014bb35$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $3e8179397014bb35$export$b5915cf27fa06b9f) {
        $3e8179397014bb35$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$3e8179397014bb35$var$addToFifoQueue(p, $3e8179397014bb35$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $3e8179397014bb35$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $3e8179397014bb35$var$addToFifoQueue(path, queue) {
    if (queue.size >= $3e8179397014bb35$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $3e8179397014bb35$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $3e8179397014bb35$var$useDataRouterContext2() {
    let context = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $3e8179397014bb35$var$useDataRouterStateContext() {
    let context = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $3e8179397014bb35$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$3e8179397014bb35$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $3e8179397014bb35$var$useFrameworkContext() {
    let context = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $3e8179397014bb35$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $3e8179397014bb35$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $3e8179397014bb35$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $3e8179397014bb35$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $3e8179397014bb35$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $3e8179397014bb35$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $3e8179397014bb35$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $3e8179397014bb35$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$3e8179397014bb35$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $3e8179397014bb35$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $3e8179397014bb35$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$3e8179397014bb35$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$3e8179397014bb35$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$3e8179397014bb35$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$3e8179397014bb35$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $3e8179397014bb35$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $3e8179397014bb35$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$3e8179397014bb35$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $3e8179397014bb35$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $3e8179397014bb35$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $3e8179397014bb35$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let { future: future } = $3e8179397014bb35$var$useFrameworkContext();
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $3e8179397014bb35$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $3e8179397014bb35$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $3e8179397014bb35$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$3e8179397014bb35$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $3e8179397014bb35$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $3e8179397014bb35$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $3e8179397014bb35$var$useDataRouterStateContext();
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let _matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$3e8179397014bb35$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $3e8179397014bb35$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $3e8179397014bb35$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $3e8179397014bb35$var$isHydrated = false;
function $3e8179397014bb35$export$3be068dde909e563() {
    $3e8179397014bb35$var$isHydrated = true;
}
function $3e8179397014bb35$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $3e8179397014bb35$var$useDataRouterContext2();
    let { matches: routerMatches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let isRSCRouterContext = $3e8179397014bb35$var$useIsRSCRouterContext();
    let enableFogOfWar = $3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $3e8179397014bb35$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $3e8179397014bb35$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($3e8179397014bb35$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $3e8179397014bb35$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $3e8179397014bb35$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $3e8179397014bb35$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $3e8179397014bb35$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $3e8179397014bb35$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $3e8179397014bb35$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $3e8179397014bb35$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($3e8179397014bb35$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $3e8179397014bb35$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $3e8179397014bb35$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$ff0bf87698939488, null) : null)));
}
var $3e8179397014bb35$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($3e8179397014bb35$var$isBrowser2) window.__reactRouterVersion = "7.18.4";
} catch (e) {}
function $3e8179397014bb35$export$1f3f55432a00e06d(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3e8179397014bb35$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $3e8179397014bb35$export$1ba7ed8a3a7b3765(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3e8179397014bb35$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $3e8179397014bb35$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $3e8179397014bb35$var$deserializeErrors(state.errors)
    };
    return state;
}
function $3e8179397014bb35$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $3e8179397014bb35$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $3e8179397014bb35$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$3e8179397014bb35$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $3e8179397014bb35$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $3e8179397014bb35$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $3e8179397014bb35$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $3e8179397014bb35$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $3e8179397014bb35$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $3e8179397014bb35$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $3e8179397014bb35$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$3e8179397014bb35$export$a6c7ac8248d6e38a.displayName = "Link";
var $3e8179397014bb35$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3e8179397014bb35$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $3e8179397014bb35$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$3e8179397014bb35$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $3e8179397014bb35$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $3e8179397014bb35$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let submit = $3e8179397014bb35$export$47c85c6e3a081d3();
    let formAction = $3e8179397014bb35$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$3e8179397014bb35$export$a7fed597f4b8afd8.displayName = "Form";
function $3e8179397014bb35$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let matches = $3e8179397014bb35$export$2378eb7f5ff86053();
    $3e8179397014bb35$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$3e8179397014bb35$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $3e8179397014bb35$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3e8179397014bb35$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$export$f5708dca728d7177(ctx, $3e8179397014bb35$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $3e8179397014bb35$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$export$f5708dca728d7177(state, $3e8179397014bb35$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $3e8179397014bb35$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($3e8179397014bb35$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $3e8179397014bb35$export$fe53371bee54353d(location) === $3e8179397014bb35$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $3e8179397014bb35$export$f1a78c17382fe22a(defaultInit) {
    $3e8179397014bb35$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($3e8179397014bb35$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3e8179397014bb35$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3e8179397014bb35$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $3e8179397014bb35$var$fetcherId = 0;
var $3e8179397014bb35$var$getUniqueFetcherId = ()=>`__${String(++$3e8179397014bb35$var$fetcherId)}__`;
function $3e8179397014bb35$export$47c85c6e3a081d3() {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let currentRouteId = $3e8179397014bb35$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3e8179397014bb35$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $3e8179397014bb35$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $3e8179397014bb35$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    $3e8179397014bb35$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$3e8179397014bb35$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $3e8179397014bb35$export$fe53371bee54353d(path);
}
function $3e8179397014bb35$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $3e8179397014bb35$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($3e8179397014bb35$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $3e8179397014bb35$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $3e8179397014bb35$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $3e8179397014bb35$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $3e8179397014bb35$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $3e8179397014bb35$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $3e8179397014bb35$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $3e8179397014bb35$export$fa996778a3a31087() {
    let state = $3e8179397014bb35$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $acw62.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $3e8179397014bb35$var$savedScrollPositions = {};
function $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $3e8179397014bb35$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3e8179397014bb35$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let matches = $3e8179397014bb35$export$2378eb7f5ff86053();
    let navigation = $3e8179397014bb35$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $3e8179397014bb35$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey);
            $3e8179397014bb35$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3e8179397014bb35$var$savedScrollPositions));
        } catch (error) {
            $3e8179397014bb35$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3e8179397014bb35$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($3e8179397014bb35$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$3e8179397014bb35$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $3e8179397014bb35$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $3e8179397014bb35$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3e8179397014bb35$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3e8179397014bb35$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $3e8179397014bb35$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $3e8179397014bb35$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($3e8179397014bb35$export$3681f408decb40d1);
    $3e8179397014bb35$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $3e8179397014bb35$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $3e8179397014bb35$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $3e8179397014bb35$export$81336c211d5ff295(path.pathname, nextPath) != null || $3e8179397014bb35$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $3e8179397014bb35$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $3e8179397014bb35$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $3e8179397014bb35$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $3e8179397014bb35$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $3e8179397014bb35$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $3e8179397014bb35$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $3e8179397014bb35$var$serializeErrors(context.errors)
        };
        let json = $3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $3e8179397014bb35$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($3e8179397014bb35$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $3e8179397014bb35$var$getStatelessNavigator() {
    return {
        createHref: $3e8179397014bb35$var$createHref,
        encodeLocation: $3e8179397014bb35$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $3e8179397014bb35$export$69163f0b72ec60d9(routes, opts) {
    return $3e8179397014bb35$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e
    });
}
function $3e8179397014bb35$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(routes, $3e8179397014bb35$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $3e8179397014bb35$var$createHref,
        encodeLocation: $3e8179397014bb35$var$encodeLocation,
        getFetcher () {
            return $3e8179397014bb35$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $3e8179397014bb35$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $3e8179397014bb35$var$createHref(to) {
    return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
}
function $3e8179397014bb35$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("695Jh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a256f1dc0160731b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $aG8X9 = parcelRequire("aG8X9");

var $1l1FS = parcelRequire("1l1FS");

var $eZxmj = parcelRequire("eZxmj");

var $6lvMC = parcelRequire("6lvMC");

var $lPAGv = parcelRequire("lPAGv");

var $5YjhR = parcelRequire("5YjhR");

var $6QJY8 = parcelRequire("6QJY8");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $f2yI9 = parcelRequire("f2yI9");

var $55Oux = parcelRequire("55Oux");

var $4NV2o = parcelRequire("4NV2o");

var $kYqkq = parcelRequire("kYqkq");

var $f1q41 = parcelRequire("f1q41");

var $jSDfI = parcelRequire("jSDfI");

var $ai857 = parcelRequire("ai857");
const $a256f1dc0160731b$var$AuthenticatedRoute = ({ layout: layout = "div", ...props })=>{
    const apiToken = (0, $iD0SF.useSelector)((state)=>state.userSession.apiToken);
    const { oauthIdToken: oauthIdToken } = (0, $jSDfI.getSession)();
    const currentUserId = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserId));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { tenantId: tenantId } = (0, $COwA0.useParams)();
    const [renderSwitchToTenant, setRenderSwitchTenant] = (0, $acw62.useState)(false);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        if (!currentUserId) return;
        // this ensures the user is always loaded. It's a bit defensive, though, but
        // it prevents certain issues for edge cases. Not sure they still occur, but
        // leaving this in just to be sure...
        dispatch((0, $ai857.fetchCurrentUserAction)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!tenantId || !currentUser) {
            setRenderSwitchTenant(false);
            return;
        }
        if (currentUser.currentTenantId != tenantId) setRenderSwitchTenant(true);
    }, [
        currentUser,
        tenantId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!apiToken && !oauthIdToken) (0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).SIGN_IN);
    }, [
        apiToken,
        oauthIdToken
    ]);
    const throttledCheckSessionAction = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).throttle(()=>{
        dispatch((0, $4NV2o.checkSessionAction)());
    }, 60000);
    const checkSession = ()=>{
        if (!apiToken) return;
        throttledCheckSessionAction();
    };
    // in testing this, I found that neither event are reliably triggered, but
    // one or the other generally is. So I thought to just add the listener on
    // both. The throttling of the action anyway takes care of it not being called
    // more often then neccessary
    //
    // The actions on keydown and pointermove are all to chech if a user is still
    // using the application, in which case we trigger the same event, as this  will
    // also reset the validity of the session token.
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("keydown", checkSession);
        document.addEventListener("pointermove", checkSession);
        document.addEventListener("visibilitychange", checkSession);
        window.addEventListener("focus", checkSession);
        // Calls onFocus when the window first loads
        return ()=>{
            document.removeEventListener("keydown", checkSession);
            document.removeEventListener("pointermove", checkSession);
            document.removeEventListener("visibilitychange", checkSession);
            window.removeEventListener("focus", checkSession);
        };
    }, []);
    if (!currentUser || currentUser.mfaRequired == undefined) return null;
    if (currentUser.mfaRequired && !props.overrideMfaIntercept) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eZxmj.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aG8X9.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5YjhR.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lPAGv.default), {})
            })
        })
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Layout = layout;
    const Component = props.component;
    const content = Component ? /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {}) : props.children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eZxmj.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aG8X9.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55Oux.ExternalUsersContextProvider), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Layout, {
                    children: [
                        renderSwitchToTenant ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f2yI9.default), {
                            tenantId: tenantId
                        }) : null,
                        content
                    ]
                })
            })
        })
    });
};
var $a256f1dc0160731b$export$2e2bcd8739ae039 = $a256f1dc0160731b$var$AuthenticatedRoute;

});
parcelRegister("aG8X9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cdcc4689e434221$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8RAYl = parcelRequire("8RAYl");

var $i6lWx = parcelRequire("i6lWx");

var $1Lj4p = parcelRequire("1Lj4p");
const $8cdcc4689e434221$var$UserConfigProvider = (props)=>{
    const userConfig = (0, $iD0SF.useSelector)((state)=>state.userConfig);
    const userId = (0, $iD0SF.useSelector)((state)=>state.userSession.id);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchUserConfig = (userId)=>{
        dispatch((0, $i6lWx.fetchUserConfigAction)(userId));
    };
    (0, $acw62.useEffect)(()=>{
        fetchUserConfig(userId);
    }, [
        userId
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $8RAYl.default).changeLanguage(userConfig.locale);
    }, [
        userConfig.locale
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Lj4p.UserConfigContext).Provider, {
        value: userConfig,
        children: props.children
    });
};
var $8cdcc4689e434221$export$2e2bcd8739ae039 = $8cdcc4689e434221$var$UserConfigProvider;

});
parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("iStRg")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");

var $9b0Yv = parcelRequire("9b0Yv");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");

var $iD0SF = parcelRequire("iD0SF");

var $iStRg = parcelRequire("iStRg");
parcelRequire("gCPmi");
(0, $iD0SF.initializeUseSelector)((0, $9b0Yv.useSyncExternalStoreWithSelector));
(0, $iStRg.initializeConnect)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("30Ie1"));

});
parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
'use strict';

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});


parcelRegister("9b0Yv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6VZtt"));

});
parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
'use strict';

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);

var $1u0KT = parcelRequire("1u0KT");

});

parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;

});

parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $d8fc8d639f906efc$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $d8fc8d639f906efc$export$2105062e25df4afe);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $i41js.notInitialized);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : (0, $1ubyh.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d8fc8d639f906efc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $acw62.useRef)(true);
        const wrappedSelector = (0, $acw62.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $11518dc3bb05d381$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$d4d6226d5fc61558(context = (0, $7iEsg.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $acw62.useContext)(context);
        return contextValue;
    };
}
const $11518dc3bb05d381$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $11518dc3bb05d381$export$d4d6226d5fc61558();

});
parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$var$ContextKey = Symbol.for(`react-redux-context`);
const $55099852ccad0564$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55099852ccad0564$var$getContext() {
    var _gT$ContextKey;
    if (!$acw62.createContext) return {};
    const contextMap = (_gT$ContextKey = $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey]) != null ? _gT$ContextKey : $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey] = new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ $55099852ccad0564$var$getContext();
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});


parcelRegister("i41js", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $d2699e687deeb28e$export$20656a4825650bd0);
const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("iStRg", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $dbe46e5c642d971b$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $dbe46e5c642d971b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $40Fxm = parcelRequire("40Fxm");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("7CByU");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $i41js.notInitialized);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8PZ7r.default), areStatePropsEqual: areStatePropsEqual = (0, $8PZ7r.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8PZ7r.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $7iEsg.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $kSE8V.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $ih4tx.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $7EQ16.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $1En50.default)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ $acw62.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $acw62.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $40Fxm.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $acw62.useRef();
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef();
            const renderIsScheduled = $acw62.useRef(false);
            const isProcessingDispatch = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef();
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $acw62.createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $acw62.createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});



parcelRegister("cfvvO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cgj07"));

});
parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});


parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
parcelRequire("d6Wo0");
const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $1En50.default)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7CByU.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps');
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $d4dd493c66c4df43$export$b69a785ceac019a6);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>(0, $96XmR.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $kC3dh.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);
parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("kC3dh", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $f019d9508e58fcb7$export$19ef7b929f7e2559);
function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $f337fd5395077a96$export$e00e93951827eda7);

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $kC3dh.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $59349e43bbd01749$export$17457cf6fa742f84);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jKoYp");

var $kC3dh = parcelRequire("kC3dh");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $kC3dh.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $lnBci.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("iStRg")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);

var $4hUQH = parcelRequire("4hUQH");

var $iStRg = parcelRequire("iStRg");

var $7iEsg = parcelRequire("7iEsg");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("gKObn");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $acw62.useMemo(()=>{
        const subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $7iEsg.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});

parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $20d80f3cecee513e$export$8ad76b76a4c905f8);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $7iEsg.ReactReduxContext)) {
    const useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : (0, $1ubyh.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});


parcelRegister("gKObn", function(module, exports) {

});



parcelRegister("8RAYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $673ff3dfc4a496de$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hzjST = parcelRequire("hzjST");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");
var $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $673ff3dfc4a496de$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6CZeq.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $cHPF9.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $hzjST.default)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
var $673ff3dfc4a496de$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $6CZeq.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $cHPF9.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $673ff3dfc4a496de$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    var _getLastOfPath = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    var _getLastOfPath3 = $673ff3dfc4a496de$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    var value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return $673ff3dfc4a496de$var$_entityMap[s];
    });
    return data;
}
var $673ff3dfc4a496de$var$isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (typeof mix === 'string') return mix;
            if (p && typeof mix[p] === 'string') return mix[p];
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $673ff3dfc4a496de$var$ResourceStore = function(_EventEmitter) {
    (0, $1gYAD.default)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $6CZeq.default)(this, ResourceStore);
        _this = (0, $9715X.default)(this, (0, $jDKKo.default)(ResourceStore).call(this));
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $cHPF9.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = $673ff3dfc4a496de$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $673ff3dfc4a496de$var$setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
                if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $hzjST.default)({}, pack, resources);
                $673ff3dfc4a496de$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return (0, $hzjST.default)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $673ff3dfc4a496de$var$checkedLoadedFor = {};
var $673ff3dfc4a496de$var$Translator = function(_EventEmitter) {
    (0, $1gYAD.default)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6CZeq.default)(this, Translator);
        _this = (0, $9715X.default)(this, (0, $jDKKo.default)(Translator).call(this));
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $hDpcU.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
        return _this;
    }
    (0, $cHPF9.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $fSwVM.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, (0, $hzjST.default)({}, options, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $hzjST.default)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $hzjST.default)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $hzjST.default)({}, options, {
                        interpolation: (0, $hzjST.default)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $hzjST.default)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $hzjST.default)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $673ff3dfc4a496de$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $6CZeq.default)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    (0, $cHPF9.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $673ff3dfc4a496de$var$createRules() {
    var rules = {};
    $673ff3dfc4a496de$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $673ff3dfc4a496de$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6CZeq.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    (0, $cHPF9.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = 'plural';
                        else if (suffix === 1) suffix = '';
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === 'v1') {
                        if (suffix === 1) return '';
                        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        }
    ]);
    return PluralResolver;
}();
var $673ff3dfc4a496de$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $6CZeq.default)(this, Interpolator);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $cHPF9.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, (0, $hzjST.default)({}, options, data, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, k), f, lng, (0, $hzjST.default)({}, options, data, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += safeValue.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $hzjST.default)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $hzjST.default)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = $673ff3dfc4a496de$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, (0, $hzjST.default)({}, options, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $673ff3dfc4a496de$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $673ff3dfc4a496de$var$Connector = function(_EventEmitter) {
    (0, $1gYAD.default)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $6CZeq.default)(this, Connector);
        _this = (0, $9715X.default)(this, (0, $jDKKo.default)(Connector).call(this));
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $cHPF9.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $673ff3dfc4a496de$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $673ff3dfc4a496de$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $hzjST.default)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $fSwVM.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $fSwVM.default)(args[2]) === 'object' || (0, $fSwVM.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist = options.whitelist.concat([
            'cimode'
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $673ff3dfc4a496de$var$noop() {}
var $673ff3dfc4a496de$var$I18n = function(_EventEmitter) {
    (0, $1gYAD.default)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $6CZeq.default)(this, I18n);
        _this = (0, $9715X.default)(this, (0, $jDKKo.default)(I18n).call(this));
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.options = $673ff3dfc4a496de$var$transformOptions(options);
        _this.services = {};
        _this.logger = $673ff3dfc4a496de$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $9715X.default)(_this, (0, $hDpcU.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $cHPF9.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $hzjST.default)({}, $673ff3dfc4a496de$var$get(), this.options, $673ff3dfc4a496de$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
                    var lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
                    this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $673ff3dfc4a496de$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $673ff3dfc4a496de$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $673ff3dfc4a496de$var$defer();
                this.emit('languageChanging', lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $fSwVM.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $hzjST.default)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var mergedOptions = (0, $hzjST.default)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $hzjST.default)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages
                };
            }
        }
    ]);
    return I18n;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$i18next = new $673ff3dfc4a496de$var$I18n();
var $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$i18next;

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hzjST", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca52131e67e00d1$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $cca52131e67e00d1$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("i6lWx", function(module, exports) {

$parcel$export(module.exports, "fetchUserConfigAction", () => $da29e1b72928343e$export$969aa5835a0956ff);
$parcel$export(module.exports, "updateUserConfigAction", () => $da29e1b72928343e$export$72062c1a75aefef5);
$parcel$export(module.exports, "updateUISettingAction", () => $da29e1b72928343e$export$44c7cdbf862aa42b);

var $93tzC = parcelRequire("93tzC");
const $da29e1b72928343e$export$969aa5835a0956ff = (userId)=>{
    return {
        type: (0, $93tzC.UserConfigActionTypes).FETCH_USER_CONFIG_ASYNC_PENDING,
        payload: userId
    };
};
const $da29e1b72928343e$export$72062c1a75aefef5 = (userId, userData)=>{
    return {
        type: (0, $93tzC.UserConfigActionTypes).UPDATE_USER_CONFIG_ASYNC_PENDING,
        payload: {
            id: userId,
            user: userData
        }
    };
};
const $da29e1b72928343e$export$44c7cdbf862aa42b = (userId, setting)=>{
    return {
        type: (0, $93tzC.UserConfigActionTypes).UPDATE_UI_SETTING_ASYNC_PENDING,
        payload: {
            id: userId,
            data: setting
        }
    };
};

});
parcelRegister("93tzC", function(module, exports) {

$parcel$export(module.exports, "UserLanguages", () => $6a786505a957762d$export$e918664357b94bbe);
$parcel$export(module.exports, "UserTimezones", () => $6a786505a957762d$export$a30394b8219deb77);
$parcel$export(module.exports, "UserConfigActionTypes", () => $6a786505a957762d$export$149e4c5659e7ef55);
// State
var $6a786505a957762d$export$e918664357b94bbe = /*#__PURE__*/ function(UserLanguages) {
    UserLanguages["Chinese"] = "zh";
    UserLanguages["Dutch"] = "nl";
    UserLanguages["English"] = "en";
    UserLanguages["French"] = "fr";
    UserLanguages["German"] = "de";
    UserLanguages["Italian"] = "it";
    UserLanguages["Japanese"] = "ja";
    UserLanguages["Spanish"] = "es";
    return UserLanguages;
}({});
var $6a786505a957762d$export$a30394b8219deb77 = /*#__PURE__*/ function(UserTimezones) {
    UserTimezones["Default"] = "default";
    UserTimezones["Pacific/Honolulu: Hawaii"] = "Pacific/Honolulu";
    UserTimezones["America/Juneau: Alaska"] = "America/Juneau";
    UserTimezones["America/Chihuahua: Chihuahua, La Paz, Mazatlan"] = "America/Chihuahua";
    UserTimezones["America/Phoenix: Arizona"] = "America/Phoenix";
    UserTimezones["America/Chicago: Central Time"] = "America/Chicago";
    UserTimezones["America/Regina: Saskatchewan"] = "America/Regina";
    UserTimezones["America/Mexico City: Guadalajara, Mexico City, Monterrey"] = "America/Mexico_City";
    UserTimezones["America/Guatemala: Central America"] = "America/Guatemala";
    UserTimezones["America/New York: Eastern Time"] = "America/New_York";
    UserTimezones["America/Bogota: Bogota, Lima, Quito"] = "America/Bogota";
    UserTimezones["America/Caracas: Caracas, La Paz"] = "America/Caracas";
    UserTimezones["America/Santiago: Santiago"] = "America/Santiago";
    UserTimezones["America/Sao Paulo: Brasilia"] = "America/Sao_Paulo";
    UserTimezones["America/Tijuana: Tijuana, Pacific Time"] = "America/Tijuana";
    UserTimezones["America/Argentina/Buenos Aires: Buenos Aires, Georgetown"] = "America/Argentina/Buenos_Aires";
    UserTimezones["Atlantic/Cape Verde: Cape Verde Islands"] = "Atlantic/Cape_Verde";
    UserTimezones["Europe/London: Edinburgh, London"] = "Europe/London";
    UserTimezones["Europe/Dublin: Dublin"] = "Europe/Dublin";
    UserTimezones["Europe/Lisbon: Lisbon"] = "Europe/Lisbon";
    UserTimezones["Africa/Casablanca: Casablanca, Monrovia"] = "Africa/Casablanca";
    UserTimezones["Atlantic/Canary: Canary Islands"] = "Atlantic/Canary";
    UserTimezones["Europe/Belgrade: Belgrade, Bratislava, Budapest, Ljubljana, Prague"] = "Europe/Belgrade";
    UserTimezones["Europe/Sarajevo: Sarajevo, Skopje, Warsaw, Zagreb"] = "Europe/Sarajevo";
    UserTimezones["Europe/Paris: Brussels, Copenhagen, Madrid, Paris"] = "Europe/Paris";
    UserTimezones["Europe/Amsterdam: Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"] = "Europe/Amsterdam";
    UserTimezones["Africa/Algiers: West Central Africa"] = "Africa/Algiers";
    UserTimezones["Europe/Bucharest: Bucharest"] = "Europe/Bucharest";
    UserTimezones["Africa/Cairo: Cairo"] = "Africa/Cairo";
    UserTimezones["Europe/Helsinki: Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"] = "Europe/Helsinki";
    UserTimezones["Europe/Athens: Athens, Istanbul, Minsk"] = "Europe/Athens";
    UserTimezones["Asia/Jerusalem: Jerusalem"] = "Asia/Jerusalem";
    UserTimezones["Africa/Harare: Harare, Pretoria, Windhoek"] = "Africa/Harare";
    UserTimezones["Europe/Moscow: Moscow, St. Petersburg, Volgograd"] = "Europe/Moscow";
    UserTimezones["Asia/Kuwait: Kuwait, Riyadh"] = "Asia/Kuwait";
    UserTimezones["Africa/Nairobi: Nairobi"] = "Africa/Nairobi";
    UserTimezones["Asia/Baghdad: Baghdad"] = "Asia/Baghdad";
    UserTimezones["Asia/Tehran: Tehran"] = "Asia/Tehran";
    UserTimezones["Asia/Muscat: Abu Dhabi, Dubai, Muscat"] = "Asia/Muscat";
    UserTimezones["Asia/Baku: Baku, Tbilisi, Yerevan"] = "Asia/Baku";
    UserTimezones["Asia/Kabul: Kabul"] = "Asia/Kabul";
    UserTimezones["Asia/Yekaterinburg: Ekaterinburg"] = "Asia/Yekaterinburg";
    UserTimezones["Asia/Karachi: Islamabad, Karachi, Tashkent"] = "Asia/Karachi";
    UserTimezones["Asia/Kolkata: Chennai, Kolkata, Mumbai, New Delhi"] = "Asia/Kolkata";
    UserTimezones["Asia/Kathmandu: Kathmandu"] = "Asia/Kathmandu";
    UserTimezones["Asia/Dhaka: Dhaka, Nur-Sultan"] = "Asia/Dhaka";
    UserTimezones["Asia/Colombo: Sri Jayawardenepura"] = "Asia/Colombo";
    UserTimezones["Asia/Almaty: Almaty, Novosibirsk"] = "Asia/Almaty";
    UserTimezones["Asia/Rangoon: Yangon Rangoon"] = "Asia/Rangoon";
    UserTimezones["Asia/Bangkok: Bangkok, Hanoi, Jakarta"] = "Asia/Bangkok";
    UserTimezones["Asia/Krasnoyarsk: Krasnoyarsk"] = "Asia/Krasnoyarsk";
    UserTimezones["Asia/Shanghai: Beijing, Chongqing, Hong Kong SAR, Urumqi"] = "Asia/Shanghai";
    UserTimezones["Asia/Kuala Lumpur: Kuala Lumpur, Singapore"] = "Asia/Kuala_Lumpur";
    UserTimezones["Asia/Taipei: Taipei"] = "Asia/Taipei";
    UserTimezones["Australia/Perth: Perth"] = "Australia/Perth";
    UserTimezones["Asia/Ulaanbaatar: Irkutsk, Ulaanbaatar"] = "Asia/Ulaanbaatar";
    UserTimezones["Asia/Seoul: Seoul"] = "Asia/Seoul";
    UserTimezones["Asia/Tokyo: Osaka, Sapporo, Tokyo"] = "Asia/Tokyo";
    UserTimezones["Asia/Yakutsk: Yakutsk"] = "Asia/Yakutsk";
    UserTimezones["Australia/Darwin: Darwin"] = "Australia/Darwin";
    UserTimezones["Australia/Adelaide: Adelaide"] = "Australia/Adelaide";
    UserTimezones["Australia/Sydney: Canberra, Melbourne, Sydney"] = "Australia/Sydney";
    UserTimezones["Australia/Brisbane: Brisbane"] = "Australia/Brisbane";
    UserTimezones["Australia/Hobart: Hobart"] = "Australia/Hobart";
    UserTimezones["Asia/Vladivostok: Vladivostok"] = "Asia/Vladivostok";
    UserTimezones["Pacific/Auckland: Auckland, Wellington"] = "Pacific/Auckland";
    return UserTimezones;
}({});
var $6a786505a957762d$export$149e4c5659e7ef55 = /*#__PURE__*/ function(UserConfigActionTypes) {
    UserConfigActionTypes["FETCH_USER_CONFIG_ASYNC_PENDING"] = "@@userConfig/FETCH_USER_CONFIG_ASYNC_PENDING";
    UserConfigActionTypes["FETCH_USER_CONFIG_ASYNC_SUCCESS"] = "@@userConfig/FETCH_USER_CONFIG_ASYNC_SUCCESS";
    UserConfigActionTypes["FETCH_USER_CONFIG_ASYNC_ERROR"] = "@@userConfig/FETCH_USER_CONFIG_ASYNC_ERROR";
    UserConfigActionTypes["UPDATE_USER_CONFIG_ASYNC_PENDING"] = "@@userConfig/UPDATE_USER_CONFIG_ASYNC_PENDING";
    UserConfigActionTypes["UPDATE_USER_CONFIG_ASYNC_SUCCESS"] = "@@userConfig/UPDATE_USER_CONFIG_ASYNC_SUCCESS";
    UserConfigActionTypes["UPDATE_USER_CONFIG_ASYNC_ERROR"] = "@@userConfig/UPDATE_USER_CONFIG_ASYNC_ERROR";
    UserConfigActionTypes["UPDATE_UI_SETTING_ASYNC_PENDING"] = "@@userConfig/UPDATE_UI_SETTING_ASYNC_PENDING";
    UserConfigActionTypes["UPDATE_UI_SETTING_ASYNC_SUCCESS"] = "@@userConfig/UPDATE_UI_SETTING_ASYNC_SUCCESS";
    UserConfigActionTypes["UPDATE_UI_SETTING_ASYNC_ERROR"] = "@@userConfig/UPDATE_UI_SETTING_ASYNC_ERROR";
    return UserConfigActionTypes;
}({});

});


parcelRegister("1Lj4p", function(module, exports) {

$parcel$export(module.exports, "userConfigContextInitialState", () => $2dbe69defb890a1d$export$9e6c01d98cb2c847);
$parcel$export(module.exports, "UserConfigContext", () => $2dbe69defb890a1d$export$29ca32a15ab7a73c);

var $acw62 = parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");
const $2dbe69defb890a1d$export$9e6c01d98cb2c847 = {
    locale: "en",
    timezone: (0, $ahLi9.systemTimezone),
    uiSettings: {
        showQuickStartGuide: false
    }
};
const $2dbe69defb890a1d$export$29ca32a15ab7a73c = (0, $acw62.createContext)($2dbe69defb890a1d$export$9e6c01d98cb2c847);

});
parcelRegister("ahLi9", function(module, exports) {

$parcel$export(module.exports, "systemTimezone", () => $7618937159643e4f$export$646d71d3ef1b0eae);
$parcel$export(module.exports, "formatTimeString", () => $7618937159643e4f$export$2de90790c3ad23b1);
$parcel$export(module.exports, "formatDateString", () => $7618937159643e4f$export$1e32f7407816b987);
$parcel$export(module.exports, "formatDatePickerString", () => $7618937159643e4f$export$60f17a3564dffcd5);
$parcel$export(module.exports, "formatDatePicker", () => $7618937159643e4f$export$c559ff7de4b26a9b);
$parcel$export(module.exports, "timeFormatValid", () => $7618937159643e4f$export$e09ffcf3fc76ae0b);
$parcel$export(module.exports, "addHour", () => $7618937159643e4f$export$4755c637aac4edd7);
$parcel$export(module.exports, "parseTime", () => $7618937159643e4f$export$c9698ec7f05a07e1);
$parcel$export(module.exports, "dateWithTime", () => $7618937159643e4f$export$9bacc6f8831db921);
$parcel$export(module.exports, "startEndDates", () => $7618937159643e4f$export$fc8a5543472184eb);
$parcel$export(module.exports, "valuesToDateOfBirth", () => $7618937159643e4f$export$7c776e4fe21dfde8);
$parcel$export(module.exports, "dateIsFuture", () => $7618937159643e4f$export$e47170bfc0276b42);
$parcel$export(module.exports, "utcDateToZonedTime", () => $7618937159643e4f$export$8b59f24a687a2df9);
$parcel$export(module.exports, "zonedDateToUtc", () => $7618937159643e4f$export$d1004ba7e20747f0);
$parcel$export(module.exports, "utcDateToDaysFromNow", () => $7618937159643e4f$export$9a5272a9993a9f3e);
$parcel$export(module.exports, "daysFromNowToDate", () => $7618937159643e4f$export$2c22be56cc1f09c3);
$parcel$export(module.exports, "dateOnly", () => $7618937159643e4f$export$5d2b20971922fd0);
$parcel$export(module.exports, "formatDayDate", () => $7618937159643e4f$export$d7c693dcb7383756);
$parcel$export(module.exports, "dateWithTimezone", () => $7618937159643e4f$export$8ffa996cf335ecae);
$parcel$export(module.exports, "dateWithoutTimezone", () => $7618937159643e4f$export$332377bdb03176b9);
$parcel$export(module.exports, "getDayOptions", () => $7618937159643e4f$export$c9a4384ba880408a);
$parcel$export(module.exports, "getMonthOptions", () => $7618937159643e4f$export$5365e964dff332d1);
$parcel$export(module.exports, "getYearOptions", () => $7618937159643e4f$export$9865296f13ed9cac);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6OX6Q = parcelRequire("6OX6Q");
var $kehhj = parcelRequire("kehhj");
var $6IhJz = parcelRequire("6IhJz");
var $kI79P = parcelRequire("kI79P");
var $cFZfS = parcelRequire("cFZfS");
var $auRgN = parcelRequire("auRgN");
parcelRequire("bd5y7");
var $6uApQ = parcelRequire("6uApQ");
var $beM2Q = parcelRequire("beM2Q");
var $4kSfC = parcelRequire("4kSfC");

var $6UbtV = parcelRequire("6UbtV");
var $c3iH1 = parcelRequire("c3iH1");
var $15nwl = parcelRequire("15nwl");

var $f1q41 = parcelRequire("f1q41");
const $7618937159643e4f$export$646d71d3ef1b0eae = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $7618937159643e4f$export$2de90790c3ad23b1 = "hh:mmaaaaa'm'";
const $7618937159643e4f$export$1e32f7407816b987 = "dd MMM yyyy";
const $7618937159643e4f$export$60f17a3564dffcd5 = "dd/MM/yyyy";
const $7618937159643e4f$export$c559ff7de4b26a9b = (date)=>{
    return (0, $6IhJz.default)(date, $7618937159643e4f$export$60f17a3564dffcd5);
};
const $7618937159643e4f$export$e09ffcf3fc76ae0b = (time)=>{
    return (0, $cFZfS.default)((0, $auRgN.default)(time, $7618937159643e4f$export$2de90790c3ad23b1, new Date()));
};
const $7618937159643e4f$export$4755c637aac4edd7 = (time, hours)=>{
    const t = (0, $auRgN.default)(time, $7618937159643e4f$export$2de90790c3ad23b1, new Date());
    if ((0, $cFZfS.default)(t)) return (0, $6IhJz.default)((0, $kehhj.default)(new Date(t), hours), $7618937159643e4f$export$2de90790c3ad23b1);
};
const $7618937159643e4f$export$c9698ec7f05a07e1 = (time)=>{
    return (0, $auRgN.default)(time, $7618937159643e4f$export$2de90790c3ad23b1, new Date());
};
const $7618937159643e4f$export$9bacc6f8831db921 = (date, time)=>{
    const dateString = $7618937159643e4f$export$c559ff7de4b26a9b(date);
    return (0, $auRgN.default)(dateString + " " + time, `${$7618937159643e4f$export$60f17a3564dffcd5} ${$7618937159643e4f$export$2de90790c3ad23b1}`, new Date());
};
const $7618937159643e4f$export$fc8a5543472184eb = (startDate, startTime, endTime, timezone)=>{
    const start = $7618937159643e4f$export$9bacc6f8831db921(startDate, startTime);
    const endDate = $7618937159643e4f$export$9bacc6f8831db921(startDate, endTime);
    const end = endDate <= start ? (0, $6OX6Q.default)(endDate, 1) : endDate;
    return {
        start: (0, $4kSfC.default)(start, timezone),
        end: (0, $4kSfC.default)(end, timezone)
    };
};
const $7618937159643e4f$export$7c776e4fe21dfde8 = (day, month, year)=>{
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};
const $7618937159643e4f$export$e47170bfc0276b42 = (date, startTime = "11:59pm", timezone)=>{
    if (!date) return false;
    const utcTime = (0, $4kSfC.default)($7618937159643e4f$export$9bacc6f8831db921(date, startTime), timezone);
    return (0, $kI79P.default)(utcTime);
};
const $7618937159643e4f$export$8b59f24a687a2df9 = (date, timezone)=>{
    if ((0, $cFZfS.default)(new Date(date))) return (0, $beM2Q.default)(date, timezone);
};
const $7618937159643e4f$export$d1004ba7e20747f0 = (date, timezone, time)=>{
    const dateToConvert = time ? $7618937159643e4f$export$9bacc6f8831db921(date, time) : new Date(date);
    if ((0, $cFZfS.default)(dateToConvert)) return (0, $4kSfC.default)(dateToConvert, timezone);
};
const $7618937159643e4f$export$9a5272a9993a9f3e = (dateString, _timezone)=>{
    const date = new Date(dateString);
    date.setHours(23);
    date.setMinutes(59);
    if ((0, $cFZfS.default)(date)) {
        const difference = date.getTime() - new Date().getTime();
        const differenceInDays = Math.floor(difference / 1000 / 60 / 60 / 24);
        return differenceInDays;
    }
};
const $7618937159643e4f$export$2c22be56cc1f09c3 = (daysFromNow)=>{
    return (0, $6OX6Q.default)(new Date(), daysFromNow);
};
const $7618937159643e4f$export$5d2b20971922fd0 = (utcTime, timezone)=>{
    const dateZoned = $7618937159643e4f$export$8b59f24a687a2df9(utcTime, timezone);
    return (0, $6IhJz.default)(dateZoned, $7618937159643e4f$export$1e32f7407816b987, {
        locale: (0, $c3iH1.default)
    });
};
const $7618937159643e4f$export$d7c693dcb7383756 = (date)=>{
    return (0, $6IhJz.default)(new Date(date), "E do", {
        locale: (0, $c3iH1.default)
    });
};
const $7618937159643e4f$export$c3ed80aac0e17c99 = (timezone)=>{
    if (timezone.includes("America")) return 0, $15nwl.default;
    else if (timezone.includes("Australia")) return 0, $6UbtV.default;
    else return 0, $c3iH1.default;
};
const $7618937159643e4f$var$dateFormatter = (utcTime, timezone, withoutTZ)=>{
    const dateZoned = $7618937159643e4f$export$8b59f24a687a2df9(utcTime, timezone);
    const format = `${$7618937159643e4f$export$1e32f7407816b987} ${$7618937159643e4f$export$2de90790c3ad23b1}${withoutTZ ? "" : " zzz"}`;
    return (0, $6uApQ.default)(dateZoned, format, {
        locale: $7618937159643e4f$export$c3ed80aac0e17c99(timezone),
        timeZone: timezone
    });
};
const $7618937159643e4f$export$8ffa996cf335ecae = (utcTime, timezone)=>{
    return $7618937159643e4f$var$dateFormatter(utcTime, timezone);
};
const $7618937159643e4f$export$332377bdb03176b9 = (utcTime, timezone)=>{
    return $7618937159643e4f$var$dateFormatter(utcTime, timezone, true);
};
const $7618937159643e4f$export$c9a4384ba880408a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).range(1, 32).map((day)=>{
        return {
            label: day.toString(),
            value: day.toString()
        };
    });
};
const $7618937159643e4f$export$5365e964dff332d1 = (t)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).range(1, 13).map((month)=>{
        return {
            label: t(`shared:month${month}`),
            value: month.toString()
        };
    });
};
const $7618937159643e4f$export$9865296f13ed9cac = ()=>{
    const now = new Date();
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).range(now.getFullYear() - 121, now.getFullYear() + 1).reverse().map((year)=>{
        return {
            label: year.toString(),
            value: year.toString()
        };
    });
};

});
parcelRegister("kI79P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13d780f5b37c59f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f13d780f5b37c59f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $gdr0J.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("bd5y7", function(module, exports) {

$parcel$export(module.exports, "format", () => (parcelRequire("6uApQ")).default);
$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("fp2Qd")).default);
$parcel$export(module.exports, "utcToZonedTime", () => (parcelRequire("beM2Q")).default);
$parcel$export(module.exports, "zonedTimeToUtc", () => (parcelRequire("4kSfC")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $6uApQ = parcelRequire("6uApQ");

var $fp2Qd = parcelRequire("fp2Qd");



var $beM2Q = parcelRequire("beM2Q");

var $4kSfC = parcelRequire("4kSfC");

});
parcelRegister("6uApQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba1cad8f341c545$export$2e2bcd8739ae039);

var $fvXpO = parcelRequire("fvXpO");

var $j1L9C = parcelRequire("j1L9C");

var $bA01q = parcelRequire("bA01q");
var $4ba1cad8f341c545$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $4ba1cad8f341c545$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($4ba1cad8f341c545$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bA01q.default)(dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $j1L9C.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fvXpO)))(dirtyDate, formatStr, options);
}

});
parcelRegister("fvXpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4b7d6e3f82a7a84$var$format;

var $b4b7d6e3f82a7a84$var$_index = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("hd4PZ")));

var $b4b7d6e3f82a7a84$var$_index2 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("bwb8V")));

var $b4b7d6e3f82a7a84$var$_index3 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("j6xwb")));

var $b4b7d6e3f82a7a84$var$_index4 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("gbhVa")));

var $b4b7d6e3f82a7a84$var$_index5 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("cPeQq")));

var $b4b7d6e3f82a7a84$var$_index6 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("hxMZx")));

var $buk4u = parcelRequire("buk4u");

var $b4b7d6e3f82a7a84$var$_index8 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("gXISN")));

var $b4b7d6e3f82a7a84$var$_index9 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("KC37V")));

var $4SVS3 = parcelRequire("4SVS3");

var $b4b7d6e3f82a7a84$var$_index11 = $b4b7d6e3f82a7a84$var$_interopRequireDefault((parcelRequire("7LTOB")));
function $b4b7d6e3f82a7a84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $b4b7d6e3f82a7a84$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $b4b7d6e3f82a7a84$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $b4b7d6e3f82a7a84$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $b4b7d6e3f82a7a84$var$doubleQuoteRegExp = /''/g;
var $b4b7d6e3f82a7a84$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $b4b7d6e3f82a7a84$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $b4b7d6e3f82a7a84$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4SVS3.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $b4b7d6e3f82a7a84$var$_index11.default;
    var firstWeekContainsDate = (0, $b4b7d6e3f82a7a84$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $b4b7d6e3f82a7a84$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $b4b7d6e3f82a7a84$var$_index3.default)(dirtyDate);
    if (!(0, $b4b7d6e3f82a7a84$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $b4b7d6e3f82a7a84$var$_index6.default)(originalDate);
    var utcDate = (0, $b4b7d6e3f82a7a84$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($b4b7d6e3f82a7a84$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $b4b7d6e3f82a7a84$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($b4b7d6e3f82a7a84$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $b4b7d6e3f82a7a84$var$cleanEscapedString(substring);
        var formatter = $b4b7d6e3f82a7a84$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $buk4u.isProtectedWeekYearToken)(substring)) (0, $buk4u.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $buk4u.isProtectedDayOfYearToken)(substring)) (0, $buk4u.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($b4b7d6e3f82a7a84$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $b4b7d6e3f82a7a84$var$cleanEscapedString(input) {
    var matched = input.match($b4b7d6e3f82a7a84$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($b4b7d6e3f82a7a84$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("buk4u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $85d210d33a7c65af$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $85d210d33a7c65af$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $85d210d33a7c65af$var$throwProtectedError;
var $85d210d33a7c65af$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $85d210d33a7c65af$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $85d210d33a7c65af$var$isProtectedDayOfYearToken(token) {
    return $85d210d33a7c65af$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $85d210d33a7c65af$var$isProtectedWeekYearToken(token) {
    return $85d210d33a7c65af$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $85d210d33a7c65af$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});


parcelRegister("j1L9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda2b0228e9506ac$export$2e2bcd8739ae039);

var $liW8L = parcelRequire("liW8L");

var $knPBH = parcelRequire("knPBH");
var $dda2b0228e9506ac$var$MILLISECONDS_IN_MINUTE = 60000;
var $dda2b0228e9506ac$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $dda2b0228e9506ac$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $dda2b0228e9506ac$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $dda2b0228e9506ac$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $dda2b0228e9506ac$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $dda2b0228e9506ac$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $dda2b0228e9506ac$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $dda2b0228e9506ac$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $dda2b0228e9506ac$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $dda2b0228e9506ac$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $dda2b0228e9506ac$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $dda2b0228e9506ac$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        var originalDate = options._originalDate || date;
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $liW8L.default)('short', originalDate, options);
            // Long
            case 'zzzz':
            default:
                return (0, $liW8L.default)('long', originalDate, options);
        }
    }
};
function $dda2b0228e9506ac$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $knPBH.default)(timeZone, originalDate, true) / $dda2b0228e9506ac$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $dda2b0228e9506ac$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $dda2b0228e9506ac$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $dda2b0228e9506ac$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $dda2b0228e9506ac$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $dda2b0228e9506ac$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $dda2b0228e9506ac$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $dda2b0228e9506ac$var$formatTimezone(offset, dirtyDelimeter);
}
function $dda2b0228e9506ac$var$formatTimezoneShort(offset, dirtyDelimeter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimeter = dirtyDelimeter || '';
    return sign + String(hours) + delimeter + $dda2b0228e9506ac$var$addLeadingZeros(minutes, 2);
}
var $dda2b0228e9506ac$export$2e2bcd8739ae039 = $dda2b0228e9506ac$var$formatters;

});
parcelRegister("liW8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82860dde59865ff$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $f82860dde59865ff$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $f82860dde59865ff$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $f82860dde59865ff$var$partsTimeZone(dtf, date) : $f82860dde59865ff$var$hackyTimeZone(dtf, date);
}
function $f82860dde59865ff$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $f82860dde59865ff$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $f82860dde59865ff$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("knPBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d45ac936dc2ec0$export$2e2bcd8739ae039);

var $gcbCD = parcelRequire("gcbCD");

var $6G324 = parcelRequire("6G324");
var $03d45ac936dc2ec0$var$MILLISECONDS_IN_HOUR = 3600000;
var $03d45ac936dc2ec0$var$MILLISECONDS_IN_MINUTE = 60000;
var $03d45ac936dc2ec0$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function $03d45ac936dc2ec0$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (timezoneString === '') return 0;
    // Z
    token = $03d45ac936dc2ec0$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $03d45ac936dc2ec0$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$03d45ac936dc2ec0$var$validateTimezone(hours)) return NaN;
        return -(hours * $03d45ac936dc2ec0$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $03d45ac936dc2ec0$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        var minutes = parseInt(token[2], 10);
        if (!$03d45ac936dc2ec0$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $03d45ac936dc2ec0$var$MILLISECONDS_IN_HOUR + minutes * $03d45ac936dc2ec0$var$MILLISECONDS_IN_MINUTE;
        return hours > 0 ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($03d45ac936dc2ec0$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $03d45ac936dc2ec0$var$toUtcDate(date);
        var offset = $03d45ac936dc2ec0$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $03d45ac936dc2ec0$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $03d45ac936dc2ec0$var$toUtcDate(date) {
    return (0, $6G324.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $03d45ac936dc2ec0$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gcbCD.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6G324.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $03d45ac936dc2ec0$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $03d45ac936dc2ec0$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $03d45ac936dc2ec0$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $03d45ac936dc2ec0$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $03d45ac936dc2ec0$var$validIANATimezoneCache = {};
function $03d45ac936dc2ec0$var$isValidTimezoneIANAString(timeZoneString) {
    if ($03d45ac936dc2ec0$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $03d45ac936dc2ec0$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gcbCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6c83b43754c0a$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $bca6c83b43754c0a$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $bca6c83b43754c0a$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $bca6c83b43754c0a$var$partsOffset(dtf, date) : $bca6c83b43754c0a$var$hackyOffset(dtf, date);
}
var $bca6c83b43754c0a$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $bca6c83b43754c0a$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $bca6c83b43754c0a$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $bca6c83b43754c0a$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $bca6c83b43754c0a$var$dtfCache = {};
function $bca6c83b43754c0a$var$getDateTimeFormat(timeZone) {
    if (!$bca6c83b43754c0a$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: 'America/New_York',
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $bca6c83b43754c0a$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $bca6c83b43754c0a$var$dtfCache[timeZone];
}

});

parcelRegister("6G324", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc9048306206770$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $4dc9048306206770$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bA01q", function(module, exports) {

$parcel$export(module.exports, "default", () => $86e312d90f5f393c$export$2e2bcd8739ae039);

var $gXISN = parcelRequire("gXISN");

var $hxMZx = parcelRequire("hxMZx");

var $knPBH = parcelRequire("knPBH");

var $lBTiy = parcelRequire("lBTiy");
var $86e312d90f5f393c$var$MILLISECONDS_IN_HOUR = 3600000;
var $86e312d90f5f393c$var$MILLISECONDS_IN_MINUTE = 60000;
var $86e312d90f5f393c$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $86e312d90f5f393c$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $lBTiy.default)
};
function $86e312d90f5f393c$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $86e312d90f5f393c$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($gXISN)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $86e312d90f5f393c$var$splitDateString(argument);
    var parseYearResult = $86e312d90f5f393c$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $86e312d90f5f393c$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $86e312d90f5f393c$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $knPBH.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($hxMZx)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($hxMZx)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $86e312d90f5f393c$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $86e312d90f5f393c$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $86e312d90f5f393c$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $86e312d90f5f393c$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $86e312d90f5f393c$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $86e312d90f5f393c$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $86e312d90f5f393c$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $86e312d90f5f393c$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $86e312d90f5f393c$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $86e312d90f5f393c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $86e312d90f5f393c$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$86e312d90f5f393c$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $86e312d90f5f393c$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$86e312d90f5f393c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $86e312d90f5f393c$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$86e312d90f5f393c$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $86e312d90f5f393c$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$86e312d90f5f393c$var$validateWeekDate(year, week)) return new Date(NaN);
        return $86e312d90f5f393c$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $86e312d90f5f393c$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$86e312d90f5f393c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $86e312d90f5f393c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $86e312d90f5f393c$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $86e312d90f5f393c$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$86e312d90f5f393c$var$validateTime(hours)) return NaN;
        return hours % 24 * $86e312d90f5f393c$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $86e312d90f5f393c$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$86e312d90f5f393c$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $86e312d90f5f393c$var$MILLISECONDS_IN_HOUR + minutes * $86e312d90f5f393c$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $86e312d90f5f393c$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$86e312d90f5f393c$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $86e312d90f5f393c$var$MILLISECONDS_IN_HOUR + minutes * $86e312d90f5f393c$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $86e312d90f5f393c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $86e312d90f5f393c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $86e312d90f5f393c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $86e312d90f5f393c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $86e312d90f5f393c$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $86e312d90f5f393c$var$isLeapYearIndex(year);
        if (isLeapYear && date > $86e312d90f5f393c$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $86e312d90f5f393c$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $86e312d90f5f393c$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $86e312d90f5f393c$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $86e312d90f5f393c$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $86e312d90f5f393c$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("lBTiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb7f2c29156ed4f$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $fbb7f2c29156ed4f$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $fbb7f2c29156ed4f$export$2e2bcd8739ae039 = $fbb7f2c29156ed4f$var$tzPattern;

});



parcelRegister("fp2Qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36b64fd4b50d96d$export$2e2bcd8739ae039);

var $9tPQb = parcelRequire("9tPQb");

var $6uApQ = parcelRequire("6uApQ");

var $beM2Q = parcelRequire("beM2Q");
function $b36b64fd4b50d96d$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($9tPQb)))(options);
    extendedOptions.timeZone = timeZone;
    return (0, $6uApQ.default)((0, $beM2Q.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("9tPQb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e6f08f56aee8e5d$var$cloneObject;

var $6e6f08f56aee8e5d$var$_index = $6e6f08f56aee8e5d$var$_interopRequireDefault((parcelRequire("cLApH")));
function $6e6f08f56aee8e5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e6f08f56aee8e5d$var$cloneObject(object) {
    return (0, $6e6f08f56aee8e5d$var$_index.default)({}, object);
}
module.exports = module.exports.default;

});

parcelRegister("beM2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e6453b7fe2e871$export$2e2bcd8739ae039);

var $knPBH = parcelRequire("knPBH");

var $bA01q = parcelRequire("bA01q");
function $82e6453b7fe2e871$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bA01q.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $knPBH.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("4kSfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $32831cccc24caf5d$export$2e2bcd8739ae039);

var $9tPQb = parcelRequire("9tPQb");

var $bA01q = parcelRequire("bA01q");

var $lBTiy = parcelRequire("lBTiy");

var $knPBH = parcelRequire("knPBH");

var $6G324 = parcelRequire("6G324");
function $32831cccc24caf5d$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $lBTiy.default))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($9tPQb)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $bA01q.default)(date, extendedOptions);
    }
    var d = (0, $bA01q.default)(date, options);
    var utc = (0, $6G324.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $knPBH.default)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

});


parcelRegister("6UbtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5070e10bd881859c$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $5l2UL = parcelRequire("5l2UL");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $5070e10bd881859c$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $5l2UL.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $5070e10bd881859c$export$2e2bcd8739ae039 = $5070e10bd881859c$var$locale;

});
parcelRegister("5l2UL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e312cb322a843cd$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $3e312cb322a843cd$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $3e312cb322a843cd$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $3e312cb322a843cd$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3e312cb322a843cd$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3e312cb322a843cd$export$2e2bcd8739ae039 = $3e312cb322a843cd$var$formatLong;

});


parcelRegister("c3iH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6443de4506cab4$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $7utLT = parcelRequire("7utLT");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $8c6443de4506cab4$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $7utLT.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $8c6443de4506cab4$export$2e2bcd8739ae039 = $8c6443de4506cab4$var$locale;

});
parcelRegister("7utLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $57426dbaa8ce599d$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $57426dbaa8ce599d$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $57426dbaa8ce599d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $57426dbaa8ce599d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $57426dbaa8ce599d$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $57426dbaa8ce599d$export$2e2bcd8739ae039 = $57426dbaa8ce599d$var$formatLong;

});





parcelRegister("1l1FS", function(module, exports) {

$parcel$export(module.exports, "router", () => $3ae8469aaf1264e6$export$5375cda95f0b0eb4);
$parcel$export(module.exports, "default", () => $3ae8469aaf1264e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");
const $3ae8469aaf1264e6$var$RootRoutes = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6QJY8.Routes));
};
const $3ae8469aaf1264e6$export$5375cda95f0b0eb4 = typeof window !== "undefined" && typeof document !== "undefined" ? (0, $COwA0.createBrowserRouter)([
    {
        path: "*",
        Component: $3ae8469aaf1264e6$var$RootRoutes
    }
]) : (0, $COwA0.createMemoryRouter)([
    {
        path: "*",
        Component: $3ae8469aaf1264e6$var$RootRoutes
    }
]);
const $3ae8469aaf1264e6$export$cae722b0cc860f13 = (to, baseHref)=>{
    if (typeof to === "string" && !to.startsWith("/") && !to.startsWith("#") && !to.startsWith("?") && !to.includes(":")) {
        const base = baseHref || (typeof window !== "undefined" && window.location?.href ? window.location.href : "http://localhost/");
        const url = new URL(to, base);
        return url.pathname + url.search + url.hash;
    }
    return to;
};
const $3ae8469aaf1264e6$var$history = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    push: (to, state)=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.navigate($3ae8469aaf1264e6$export$cae722b0cc860f13(to), {
            state: state
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace: (to, state)=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.navigate($3ae8469aaf1264e6$export$cae722b0cc860f13(to), {
            replace: true,
            state: state
        });
    },
    go: (delta)=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.navigate(delta);
    },
    back: ()=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.navigate(-1);
    },
    forward: ()=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.navigate(1);
    },
    get location () {
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.state?.location || {
            pathname: typeof window !== "undefined" ? window.location.pathname : "/",
            search: typeof window !== "undefined" ? window.location.search : "",
            hash: typeof window !== "undefined" ? window.location.hash : "",
            state: null,
            key: "default"
        };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listen: (listener)=>{
        return $3ae8469aaf1264e6$export$5375cda95f0b0eb4.subscribe(listener);
    }
};
var $3ae8469aaf1264e6$export$2e2bcd8739ae039 = $3ae8469aaf1264e6$var$history;

});

parcelRegister("eZxmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90507e7d7972538$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8eh8V = parcelRequire("8eh8V");

var $aeos3 = parcelRequire("aeos3");
const $a90507e7d7972538$var$TenantConfigProvider = (props)=>{
    const tenantConfig = (0, $iD0SF.useSelector)((state)=>state.tenantConfig);
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8eh8V.fetchTenantConfigAsync)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aeos3.TenantConfigContext).Provider, {
        value: tenantConfig,
        children: props.children
    });
};
var $a90507e7d7972538$export$2e2bcd8739ae039 = $a90507e7d7972538$var$TenantConfigProvider;

});
parcelRegister("8eh8V", function(module, exports) {

$parcel$export(module.exports, "fetchTenantConfigAsync", () => $3cdf74ec241d5a25$export$9e5c1587c4371c90);

var $83zyI = parcelRequire("83zyI");
const $3cdf74ec241d5a25$export$9e5c1587c4371c90 = ()=>{
    return {
        type: (0, $83zyI.TenantConfigActionTypes).FETCH_TENANT_CONFIG_ASYNC_PENDING
    };
};

});
parcelRegister("83zyI", function(module, exports) {

$parcel$export(module.exports, "TenantConfigActionTypes", () => $af3609d01b3eebc2$export$f34f2020dfba9408);
// State
var $af3609d01b3eebc2$export$f34f2020dfba9408 = /*#__PURE__*/ function(TenantConfigActionTypes) {
    TenantConfigActionTypes["FETCH_TENANT_CONFIG_ASYNC_PENDING"] = "@@tenantConfig/FETCH_TENANT_CONFIG_ASYNC_PENDING";
    TenantConfigActionTypes["FETCH_TENANT_CONFIG_ASYNC_SUCCESS"] = "@@tenantConfig/FETCH_TENANT_CONFIG_ASYNC_SUCCESS";
    TenantConfigActionTypes["FETCH_TENANT_CONFIG_ASYNC_ERROR"] = "@@tenantConfig/FETCH_TENANT_CONFIG_ASYNC_ERROR";
    return TenantConfigActionTypes;
}({});

});


parcelRegister("aeos3", function(module, exports) {

$parcel$export(module.exports, "tenantConfigContextInitialState", () => $4c77ae2219f1b523$export$c4a0b08752f0f153);
$parcel$export(module.exports, "TenantConfigContext", () => $4c77ae2219f1b523$export$366987f8767b3b86);

var $acw62 = parcelRequire("acw62");
const $4c77ae2219f1b523$export$c4a0b08752f0f153 = {
    tenantName: null,
    tenantLogoPath: null,
    healthcareIdLabel: "NHS Number",
    careProviderIdLabel: "Hospital Number",
    healthcareIdRequired: false,
    careProviderIdRequired: false,
    signedOffByRequired: false,
    messagingEnabled: false,
    messagingNotificationsEnabled: false,
    changeTrackingEnabled: false,
    pathwaysEnabled: false,
    analyticsEnabled: false,
    radiologyEnabled: false,
    mdtRoles: [],
    hideMenuItemUsers: true,
    contextFormsEnabled: false
};
const $4c77ae2219f1b523$export$366987f8767b3b86 = (0, $acw62.createContext)($4c77ae2219f1b523$export$c4a0b08752f0f153);

});


parcelRegister("6lvMC", function(module, exports) {

$parcel$export(module.exports, "getUserSession", () => $8272168c1e151a61$export$8c60d41759eab72b);
$parcel$export(module.exports, "getCurrentUser", () => $8272168c1e151a61$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "getCurrentUserId", () => $8272168c1e151a61$export$5ebc6cb2748e1881);
$parcel$export(module.exports, "getAllUsers", () => $8272168c1e151a61$export$69093b9c569a5b5b);
$parcel$export(module.exports, "getAllUserIds", () => $8272168c1e151a61$export$1d20fadca2b4c45d);
$parcel$export(module.exports, "getUserByHasUserId", () => $8272168c1e151a61$export$ffb4ec8b0450b5fc);
$parcel$export(module.exports, "getUserById", () => $8272168c1e151a61$export$84e4772154052003);
$parcel$export(module.exports, "getCurrentUserAbilities", () => $8272168c1e151a61$export$d41f7ddff9171ce7);
$parcel$export(module.exports, "getCurrentUserWithConfig", () => $8272168c1e151a61$export$8a312383e45266a4);
$parcel$export(module.exports, "getAllActiveUsersSortedFirstNameLastName", () => $8272168c1e151a61$export$33032858b844fee9);
$parcel$export(module.exports, "getAllInternalActiveUsersSorted", () => $8272168c1e151a61$export$93817f868f5415cb);
$parcel$export(module.exports, "getTerms", () => $8272168c1e151a61$export$8cf95f68879c0fe2);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $cA1jy = parcelRequire("cA1jy");
const $8272168c1e151a61$export$72b9f77d22616e14 = (state)=>state.liveMeetingConfig.userConfigs[state.userSession.id];
const $8272168c1e151a61$export$8c60d41759eab72b = (state)=>state.userSession;
const $8272168c1e151a61$export$2eeec381bef70e8f = (state)=>state.userSession.signInType;
const $8272168c1e151a61$export$e5432d4c8eb97ea7 = (state)=>{
    return state.entities.users.byId[state.userSession.id];
};
const $8272168c1e151a61$export$5ebc6cb2748e1881 = (state)=>state.userSession.id;
const $8272168c1e151a61$export$69093b9c569a5b5b = (state)=>state.entities.users.byId;
const $8272168c1e151a61$export$1d20fadca2b4c45d = (state)=>state.entities.users.allIds;
const $8272168c1e151a61$export$ed0f9825534c8ef3 = (0, $6SpLG.createSelector)([
    $8272168c1e151a61$export$69093b9c569a5b5b,
    (_state, userIds)=>userIds
], (allUsers, userIds)=>{
    if (!userIds) return [];
    return userIds.map((id)=>allUsers[id]);
});
const $8272168c1e151a61$export$ffb4ec8b0450b5fc = (state, ownProps)=>$8272168c1e151a61$export$84e4772154052003(state, ownProps.userId);
const $8272168c1e151a61$export$84e4772154052003 = (state, id)=>state.entities.users.byId[id];
const $8272168c1e151a61$export$d41f7ddff9171ce7 = (0, $6SpLG.createSelector)($8272168c1e151a61$export$e5432d4c8eb97ea7, (user)=>{
    return user?.abilities;
});
const $8272168c1e151a61$export$8a312383e45266a4 = (0, $6SpLG.createSelector)($8272168c1e151a61$export$e5432d4c8eb97ea7, $8272168c1e151a61$export$72b9f77d22616e14, (user, currentUserConfig)=>{
    return {
        ...user,
        config: currentUserConfig
    };
});
const $8272168c1e151a61$export$33032858b844fee9 = (0, $6SpLG.createSelector)($8272168c1e151a61$export$69093b9c569a5b5b, (allUsers)=>{
    const activeUsers = Object.values(allUsers).filter((u)=>u.activeInCurrentTenant);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(activeUsers, [
        "firstName",
        "lastName"
    ]);
});
const $8272168c1e151a61$export$93817f868f5415cb = (0, $6SpLG.createSelector)($8272168c1e151a61$export$69093b9c569a5b5b, (allUsers)=>{
    const activeUsers = Object.values(allUsers).filter((u)=>u.activeInCurrentTenant && !(0, $cA1jy.isGuest)(u));
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(activeUsers, [
        "firstName",
        "lastName"
    ]);
});
const $8272168c1e151a61$export$8cf95f68879c0fe2 = (state)=>state.userSession.terms;

});
parcelRegister("6SpLG", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $501bc638b8425ea6$export$595d22ed68ca2841);

var $9EdUm = parcelRequire("9EdUm");
function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $9EdUm.defaultMemoize));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("9EdUm", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $7062a3595350e02d$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = 'NOT_FOUND';
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("cA1jy", function(module, exports) {

$parcel$export(module.exports, "isAdmin", () => $b04ffe7b12d381fc$export$fc970ed23da99565);
$parcel$export(module.exports, "isGuest", () => $b04ffe7b12d381fc$export$6609c30cb732e549);

var $f1q41 = parcelRequire("f1q41");
const $b04ffe7b12d381fc$export$fc970ed23da99565 = (user)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(user?.roles, "admin");
};
const $b04ffe7b12d381fc$export$6609c30cb732e549 = (user)=>{
    return user.tenantGuest;
};

});


parcelRegister("lPAGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfdea0ad77e2838$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $abB7C = parcelRequire("abB7C");

var $6941e = parcelRequire("6941e");

var $80zSA = parcelRequire("80zSA");

var $2Baud = parcelRequire("2Baud");

var $gYqVD = parcelRequire("gYqVD");
var $4cfdea0ad77e2838$var$MfaStage = /*#__PURE__*/ function(MfaStage) {
    MfaStage[MfaStage["INTRO"] = 0] = "INTRO";
    MfaStage[MfaStage["TOTP_SETUP"] = 1] = "TOTP_SETUP";
    MfaStage[MfaStage["SMS_SETUP"] = 2] = "SMS_SETUP";
    MfaStage[MfaStage["TOTP_SETUP_COMPLETE"] = 3] = "TOTP_SETUP_COMPLETE";
    MfaStage[MfaStage["TOTP"] = 4] = "TOTP";
    MfaStage[MfaStage["SMS"] = 5] = "SMS";
    return MfaStage;
}($4cfdea0ad77e2838$var$MfaStage || {});
const $4cfdea0ad77e2838$var$MfaPage = (props)=>{
    const [phoneDetails, setPhoneDetails] = (0, $acw62.useState)(null);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const [mfaStage, setMfaStage] = (0, $acw62.useState)(0);
    const setupOtpAction = ()=>{
        setMfaStage(1);
    };
    const setupSmsAction = (phoneDetails)=>{
        setPhoneDetails(phoneDetails);
        setMfaStage(2);
    };
    (0, $acw62.useEffect)(()=>{
        if (props.directRoute && !currentUser.mfaRequired) return;
        if (currentUser.mfaMethods.length > 0) {
            if (currentUser.mfaMethods.includes("totp")) setMfaStage(4);
            else setMfaStage(5);
        }
    }, [
        currentUser
    ]);
    switch(mfaStage){
        case 0:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abB7C.default), {
                phoneDetails: phoneDetails,
                totpAction: setupOtpAction,
                smsAction: setupSmsAction
            });
        case 1:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6941e.default), {
                phoneDetails: phoneDetails,
                backToIntro: ()=>setMfaStage(0)
            });
        case 2:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80zSA.default), {
                phoneDetails: phoneDetails,
                backToIntro: ()=>setMfaStage(0)
            });
        case 4:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Baud.default), {
                switchToSms: ()=>setMfaStage(5)
            });
        case 5:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gYqVD.default), {
                switchToTotp: ()=>setMfaStage(4)
            });
        default:
    }
};
var $4cfdea0ad77e2838$export$2e2bcd8739ae039 = $4cfdea0ad77e2838$var$MfaPage;

});
parcelRegister("abB7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $112b0da6d18daf66$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5GZlj = parcelRequire("5GZlj");

var $2sUu6 = parcelRequire("2sUu6");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $5wPBK = parcelRequire("5wPBK");

var $eTqMc = parcelRequire("eTqMc");
const $112b0da6d18daf66$var$phoneDetailsValidationSchema = ()=>{
    return $hDGtv.create().shape({
        phoneNumber: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).matches(/^[0-9- ]+$/, (0, $5wPBK.default).t("account:mfaPhoneNumberFormatError")).min(7).max(15),
        countryCode: $gcL7X.create().required((0, $5wPBK.default).t("shared:required"))
    });
};
const $112b0da6d18daf66$var$SetupMfaPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!currentUser) return null;
    const initialValues = props.phoneDetails || {
        countryCode: currentUser.phoneCountryCode || "44",
        phoneNumber: currentUser.phoneNumber
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col items-center mb-5",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-ch-blue-500 text-xl mb-3",
                    children: t("mfaSetupHeader")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: t("mfaSetupText1")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt-5",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        initialValues: initialValues,
                        onSubmit: props.smsAction,
                        validationSchema: $112b0da6d18daf66$var$phoneDetailsValidationSchema,
                        validateOnMount: true,
                        children: ({ values: values, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting, errors: errors, touched: touched, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-wrap justify-center space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w-full md:w-64",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                                name: "countryCode",
                                                                children: t("countryCode")
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                                name: "countryCode",
                                                                options: (0, $2sUu6.default),
                                                                onChange: handleChange,
                                                                onBlur: handleBlur
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                                errorMessage: errors.countryCode,
                                                                isVisible: errors.countryCode && touched.countryCode
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w-full md:w-64",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                                name: "phoneNumber",
                                                                children: t("phoneNumber")
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                                value: values.phoneNumber,
                                                                name: "phoneNumber",
                                                                onChange: handleChange,
                                                                onBlur: handleBlur
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                                errorMessage: errors.phoneNumber,
                                                                isVisible: errors.phoneNumber && touched.phoneNumber
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                isDisabled: !isValid || isSubmitting,
                                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                                className: "min-w-48 mt-3",
                                                isSubmit: true,
                                                children: t("mfaRequestSms")
                                            }, "1")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col items-center mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex-row my-3",
                                                children: t("mfaSetupText2")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                isDisabled: isSubmitting,
                                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                                action: ()=>props.totpAction(),
                                                children: t("mfaSetupTotp")
                                            }, "2")
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        })
    });
};
var $112b0da6d18daf66$export$2e2bcd8739ae039 = $112b0da6d18daf66$var$SetupMfaPage;

});
parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", () => useFormikContext);
$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "useField", () => useField);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "FieldArray", () => FieldArray);

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $6rtST = parcelRequire("6rtST");

var $3rtvu = parcelRequire("3rtvu");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9RYKL = parcelRequire("9RYKL");

var $9ORqK = parcelRequire("9ORqK");

var $chB0Q = parcelRequire("chB0Q");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, $acw62.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $6rtST.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $6rtST.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $6rtST.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $9RYKL.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false);
            return (0, $acw62.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
                var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false);
        !!(component && render) && (0, $9RYKL.default)(false);
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("ai2Pb", function(module, exports) {
'use strict';
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("6rtST", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b0c721ae20b3264$export$2e2bcd8739ae039);
var $4b0c721ae20b3264$var$isMergeableObject = function isMergeableObject(value) {
    return $4b0c721ae20b3264$var$isNonNullObject(value) && !$4b0c721ae20b3264$var$isSpecial(value);
};
function $4b0c721ae20b3264$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $4b0c721ae20b3264$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $4b0c721ae20b3264$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $4b0c721ae20b3264$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $4b0c721ae20b3264$var$REACT_ELEMENT_TYPE = $4b0c721ae20b3264$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $4b0c721ae20b3264$var$isReactElement(value) {
    return value.$$typeof === $4b0c721ae20b3264$var$REACT_ELEMENT_TYPE;
}
function $4b0c721ae20b3264$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $4b0c721ae20b3264$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $4b0c721ae20b3264$var$deepmerge($4b0c721ae20b3264$var$emptyTarget(value), value, options) : value;
}
function $4b0c721ae20b3264$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $4b0c721ae20b3264$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $4b0c721ae20b3264$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $4b0c721ae20b3264$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $4b0c721ae20b3264$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $4b0c721ae20b3264$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $4b0c721ae20b3264$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $4b0c721ae20b3264$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $4b0c721ae20b3264$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $4b0c721ae20b3264$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $4b0c721ae20b3264$var$mergeObject(target, source, options);
}
$4b0c721ae20b3264$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $4b0c721ae20b3264$var$deepmerge(prev, next, options);
    }, {});
};
var $4b0c721ae20b3264$var$deepmerge_1 = $4b0c721ae20b3264$var$deepmerge;
var $4b0c721ae20b3264$export$2e2bcd8739ae039 = $4b0c721ae20b3264$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = '[object Arguments]', $bc81bf84e8d65dab$var$arrayTag = '[object Array]', $bc81bf84e8d65dab$var$boolTag = '[object Boolean]', $bc81bf84e8d65dab$var$dateTag = '[object Date]', $bc81bf84e8d65dab$var$errorTag = '[object Error]', $bc81bf84e8d65dab$var$funcTag = '[object Function]', $bc81bf84e8d65dab$var$genTag = '[object GeneratorFunction]', $bc81bf84e8d65dab$var$mapTag = '[object Map]', $bc81bf84e8d65dab$var$numberTag = '[object Number]', $bc81bf84e8d65dab$var$objectTag = '[object Object]', $bc81bf84e8d65dab$var$regexpTag = '[object RegExp]', $bc81bf84e8d65dab$var$setTag = '[object Set]', $bc81bf84e8d65dab$var$stringTag = '[object String]', $bc81bf84e8d65dab$var$symbolTag = '[object Symbol]', $bc81bf84e8d65dab$var$weakMapTag = '[object WeakMap]';
var $bc81bf84e8d65dab$var$arrayBufferTag = '[object ArrayBuffer]', $bc81bf84e8d65dab$var$dataViewTag = '[object DataView]', $bc81bf84e8d65dab$var$float32Tag = '[object Float32Array]', $bc81bf84e8d65dab$var$float64Tag = '[object Float64Array]', $bc81bf84e8d65dab$var$int8Tag = '[object Int8Array]', $bc81bf84e8d65dab$var$int16Tag = '[object Int16Array]', $bc81bf84e8d65dab$var$int32Tag = '[object Int32Array]', $bc81bf84e8d65dab$var$uint8Tag = '[object Uint8Array]', $bc81bf84e8d65dab$var$uint8ClampedTag = '[object Uint8ClampedArray]', $bc81bf84e8d65dab$var$uint16Tag = '[object Uint16Array]', $bc81bf84e8d65dab$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype['delete'] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype['delete'] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), 'Map');
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp('^' + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = '[object AsyncFunction]', $397b12740d7995ef$var$funcTag = '[object Function]', $397b12740d7995ef$var$genTag = '[object GeneratorFunction]', $397b12740d7995ef$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)['__core-js_shared__'];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype['delete'] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $lSo3Y.default),
        'map': new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        'string': new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype['delete'] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, 'create');
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, 'callee') && !$44fca59879666c41$var$propertyIsEnumerable.call(value, 'callee');
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = '[object Arguments]', $a51ff94e4fd33486$var$arrayTag = '[object Array]', $a51ff94e4fd33486$var$boolTag = '[object Boolean]', $a51ff94e4fd33486$var$dateTag = '[object Date]', $a51ff94e4fd33486$var$errorTag = '[object Error]', $a51ff94e4fd33486$var$funcTag = '[object Function]', $a51ff94e4fd33486$var$mapTag = '[object Map]', $a51ff94e4fd33486$var$numberTag = '[object Number]', $a51ff94e4fd33486$var$objectTag = '[object Object]', $a51ff94e4fd33486$var$regexpTag = '[object RegExp]', $a51ff94e4fd33486$var$setTag = '[object Set]', $a51ff94e4fd33486$var$stringTag = '[object String]', $a51ff94e4fd33486$var$weakMapTag = '[object WeakMap]';
var $a51ff94e4fd33486$var$arrayBufferTag = '[object ArrayBuffer]', $a51ff94e4fd33486$var$dataViewTag = '[object DataView]', $a51ff94e4fd33486$var$float32Tag = '[object Float32Array]', $a51ff94e4fd33486$var$float64Tag = '[object Float64Array]', $a51ff94e4fd33486$var$int8Tag = '[object Int8Array]', $a51ff94e4fd33486$var$int16Tag = '[object Int16Array]', $a51ff94e4fd33486$var$int32Tag = '[object Int32Array]', $a51ff94e4fd33486$var$uint8Tag = '[object Uint8Array]', $a51ff94e4fd33486$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a51ff94e4fd33486$var$uint16Tag = '[object Uint16Array]', $a51ff94e4fd33486$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = '[object Map]', $34aa59a61c7ccccb$var$objectTag = '[object Object]', $34aa59a61c7ccccb$var$promiseTag = '[object Promise]', $34aa59a61c7ccccb$var$setTag = '[object Set]', $34aa59a61c7ccccb$var$weakMapTag = '[object WeakMap]';
var $34aa59a61c7ccccb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), 'DataView');
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), 'Promise');
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), 'Set');
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), 'WeakMap');
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7103088c29fc4f0b$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = '[object Boolean]', $d8c6c80dd3650253$var$dateTag = '[object Date]', $d8c6c80dd3650253$var$mapTag = '[object Map]', $d8c6c80dd3650253$var$numberTag = '[object Number]', $d8c6c80dd3650253$var$regexpTag = '[object RegExp]', $d8c6c80dd3650253$var$setTag = '[object Set]', $d8c6c80dd3650253$var$stringTag = '[object String]', $d8c6c80dd3650253$var$symbolTag = '[object Symbol]';
var $d8c6c80dd3650253$var$arrayBufferTag = '[object ArrayBuffer]', $d8c6c80dd3650253$var$dataViewTag = '[object DataView]', $d8c6c80dd3650253$var$float32Tag = '[object Float32Array]', $d8c6c80dd3650253$var$float64Tag = '[object Float64Array]', $d8c6c80dd3650253$var$int8Tag = '[object Int8Array]', $d8c6c80dd3650253$var$int16Tag = '[object Int16Array]', $d8c6c80dd3650253$var$int32Tag = '[object Int32Array]', $d8c6c80dd3650253$var$uint8Tag = '[object Uint8Array]', $d8c6c80dd3650253$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d8c6c80dd3650253$var$uint16Tag = '[object Uint16Array]', $d8c6c80dd3650253$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == 'string' || (0, $1WN0o.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? '-0' : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? '' : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + '';
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? '-0' : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});


parcelRegister("cxhNX", function(module, exports) {

$parcel$export(module.exports, "mixed", () => (parcelRequire("dmHdY")).create);
$parcel$export(module.exports, "boolean", () => (parcelRequire("bNQHE")).create);
$parcel$export(module.exports, "string", () => (parcelRequire("gcL7X")).create);
$parcel$export(module.exports, "number", () => (parcelRequire("5Hirs")).create);
$parcel$export(module.exports, "date", () => (parcelRequire("8CK3p")).create);
$parcel$export(module.exports, "object", () => (parcelRequire("hDGtv")).create);
$parcel$export(module.exports, "array", () => (parcelRequire("jpuYg")).create);
$parcel$export(module.exports, "ref", () => (parcelRequire("l6pyh")).create);

var $dmHdY = parcelRequire("dmHdY");

var $bNQHE = parcelRequire("bNQHE");

var $gcL7X = parcelRequire("gcL7X");

var $5Hirs = parcelRequire("5Hirs");

var $8CK3p = parcelRequire("8CK3p");

var $hDGtv = parcelRequire("hDGtv");

var $jpuYg = parcelRequire("jpuYg");

var $l6pyh = parcelRequire("l6pyh");

var $7LzLt = parcelRequire("7LzLt");

var $i6D11 = parcelRequire("i6D11");

var $7Qa2h = parcelRequire("7Qa2h");

var $2vNMA = parcelRequire("2vNMA");

var $k9zcs = parcelRequire("k9zcs");

var $gdFPP = parcelRequire("gdFPP");
function $920660c8aca77688$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $2vNMA.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}

});
parcelRegister("dmHdY", function(module, exports) {

$parcel$export(module.exports, "create", () => $9baedbe56e25b51a$export$185802fd694ee1f5);

var $gdFPP = parcelRequire("gdFPP");
const $9baedbe56e25b51a$var$Mixed = (0, $gdFPP.default);
var $9baedbe56e25b51a$export$2e2bcd8739ae039 = $9baedbe56e25b51a$var$Mixed;
function $9baedbe56e25b51a$export$185802fd694ee1f5() {
    return new $9baedbe56e25b51a$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$9baedbe56e25b51a$export$185802fd694ee1f5.prototype = $9baedbe56e25b51a$var$Mixed.prototype;

});
parcelRegister("gdFPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcee4fc8dbde13e1$export$2e2bcd8739ae039);

var $gES77 = parcelRequire("gES77");

var $5nwN5 = parcelRequire("5nwN5");

var $aQNBY = parcelRequire("aQNBY");

var $i6asA = parcelRequire("i6asA");

var $aFRKX = parcelRequire("aFRKX");

var $58i62 = parcelRequire("58i62");

var $l6pyh = parcelRequire("l6pyh");

var $7Qa2h = parcelRequire("7Qa2h");

var $i6D11 = parcelRequire("i6D11");

var $5qm0W = parcelRequire("5qm0W");

var $37zBL = parcelRequire("37zBL");
function $bcee4fc8dbde13e1$var$_extends() {
    $bcee4fc8dbde13e1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bcee4fc8dbde13e1$var$_extends.apply(this, arguments);
}
class $bcee4fc8dbde13e1$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $5qm0W.default)();
        this._blacklist = new (0, $5qm0W.default)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $5nwN5.mixed).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $bcee4fc8dbde13e1$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $bcee4fc8dbde13e1$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $gES77.default)($bcee4fc8dbde13e1$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $bcee4fc8dbde13e1$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($bcee4fc8dbde13e1$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $58i62.default)(value);
            let formattedResult = (0, $58i62.default)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $bcee4fc8dbde13e1$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $i6asA.default)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $i6asA.default)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $bcee4fc8dbde13e1$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $i6D11.default).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $i6D11.default).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $gES77.default)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $5nwN5.mixed).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $5nwN5.mixed).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $5nwN5.mixed).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $aFRKX.default)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $37zBL.default)(keys).map((key)=>new (0, $l6pyh.default)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $aQNBY.default)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $aFRKX.default)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $5nwN5.mixed).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $aFRKX.default)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $5nwN5.mixed).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $aFRKX.default)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $7Qa2h.getIn)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $bcee4fc8dbde13e1$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notOneOf;
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.optional = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notRequired;

});
parcelRegister("gES77", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20a5baa3b2b3be7$export$2e2bcd8739ae039);
// ES6 Map
var $c20a5baa3b2b3be7$var$map;
try {
    $c20a5baa3b2b3be7$var$map = Map;
} catch (_) {}
var $c20a5baa3b2b3be7$var$set;
// ES6 Set
try {
    $c20a5baa3b2b3be7$var$set = Set;
} catch (_) {}
function $c20a5baa3b2b3be7$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($c20a5baa3b2b3be7$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($c20a5baa3b2b3be7$var$map && src instanceof $c20a5baa3b2b3be7$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($c20a5baa3b2b3be7$var$set && src instanceof $c20a5baa3b2b3be7$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $c20a5baa3b2b3be7$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $c20a5baa3b2b3be7$export$2e2bcd8739ae039(src) {
    return $c20a5baa3b2b3be7$var$baseClone(src, [], []);
}

});

parcelRegister("5nwN5", function(module, exports) {

$parcel$export(module.exports, "mixed", () => $3ea8894c2d1a8ff8$export$9b30b6294c1449a8);
$parcel$export(module.exports, "string", () => $3ea8894c2d1a8ff8$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $3ea8894c2d1a8ff8$export$98e628dec113755e);
$parcel$export(module.exports, "date", () => $3ea8894c2d1a8ff8$export$324d90190a8b822a);
$parcel$export(module.exports, "boolean", () => $3ea8894c2d1a8ff8$export$4a21f16c33752377);
$parcel$export(module.exports, "object", () => $3ea8894c2d1a8ff8$export$be5493f9613cbbe);
$parcel$export(module.exports, "array", () => $3ea8894c2d1a8ff8$export$2f23118c22fb2630);
$parcel$export(module.exports, "default", () => $3ea8894c2d1a8ff8$export$2e2bcd8739ae039);

var $58i62 = parcelRequire("58i62");
let $3ea8894c2d1a8ff8$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $58i62.default)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $58i62.default)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $3ea8894c2d1a8ff8$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $3ea8894c2d1a8ff8$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $3ea8894c2d1a8ff8$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $3ea8894c2d1a8ff8$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $3ea8894c2d1a8ff8$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $3ea8894c2d1a8ff8$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $3ea8894c2d1a8ff8$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $3ea8894c2d1a8ff8$export$9b30b6294c1449a8,
    string: $3ea8894c2d1a8ff8$export$22b082955e083ec3,
    number: $3ea8894c2d1a8ff8$export$98e628dec113755e,
    date: $3ea8894c2d1a8ff8$export$324d90190a8b822a,
    object: $3ea8894c2d1a8ff8$export$be5493f9613cbbe,
    array: $3ea8894c2d1a8ff8$export$2f23118c22fb2630,
    boolean: $3ea8894c2d1a8ff8$export$4a21f16c33752377
});

});
parcelRegister("58i62", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bcbbcae986c2431$export$2e2bcd8739ae039);
const $3bcbbcae986c2431$var$toString = Object.prototype.toString;
const $3bcbbcae986c2431$var$errorToString = Error.prototype.toString;
const $3bcbbcae986c2431$var$regExpToString = RegExp.prototype.toString;
const $3bcbbcae986c2431$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $3bcbbcae986c2431$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $3bcbbcae986c2431$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $3bcbbcae986c2431$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $3bcbbcae986c2431$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $3bcbbcae986c2431$var$symbolToString.call(val).replace($3bcbbcae986c2431$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $3bcbbcae986c2431$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $3bcbbcae986c2431$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $3bcbbcae986c2431$var$regExpToString.call(val);
    return null;
}
function $3bcbbcae986c2431$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $3bcbbcae986c2431$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $3bcbbcae986c2431$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}

});


parcelRegister("aQNBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e653e8008789a27$export$2e2bcd8739ae039);

var $jplJt = parcelRequire("jplJt");

var $2vNMA = parcelRequire("2vNMA");
class $7e653e8008789a27$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jplJt)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $2vNMA.default)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $7e653e8008789a27$export$2e2bcd8739ae039 = $7e653e8008789a27$var$Condition;

});
parcelRegister("jplJt", function(module, exports) {

var $5aSdf = parcelRequire("5aSdf");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $btvBm(object, path, $5aSdf);
}
module.exports = $e21135b6db383fe3$var$has;

});
parcelRegister("5aSdf", function(module, exports) {
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
module.exports = $3c47f0745c8ad323$var$baseHas;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});
parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});




parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});


parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});


parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});





parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});

parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $9dr3u(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});



parcelRegister("2vNMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d4517ced724be00$export$2e2bcd8739ae039);
const $1d4517ced724be00$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $1d4517ced724be00$export$2e2bcd8739ae039 = $1d4517ced724be00$var$isSchema;

});


parcelRegister("i6asA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d0e6ad55c8832e$export$2e2bcd8739ae039);

var $i6D11 = parcelRequire("i6D11");
const $d2d0e6ad55c8832e$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $d2d0e6ad55c8832e$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $d2d0e6ad55c8832e$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $i6D11.default)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $i6D11.default).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $i6D11.default)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}

});
parcelRegister("i6D11", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e70d35996a7daf$export$2e2bcd8739ae039);

var $58i62 = parcelRequire("58i62");

var $37zBL = parcelRequire("37zBL");
function $d2e70d35996a7daf$var$_extends() {
    $d2e70d35996a7daf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e70d35996a7daf$var$_extends.apply(this, arguments);
}
let $d2e70d35996a7daf$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $d2e70d35996a7daf$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $d2e70d35996a7daf$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($d2e70d35996a7daf$var$strReg, (_, key)=>(0, $58i62.default)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $37zBL.default)(errorOrErrors).forEach((err)=>{
            if ($d2e70d35996a7daf$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d2e70d35996a7daf$export$2e2bcd8739ae039);
    }
}

});
parcelRegister("37zBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $245da59127fdc582$export$2e2bcd8739ae039);
function $245da59127fdc582$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}

});



parcelRegister("aFRKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c576e9ad8044c54$export$2e2bcd8739ae039);

var $1Z7cU = parcelRequire("1Z7cU");

var $i6D11 = parcelRequire("i6D11");

var $l6pyh = parcelRequire("l6pyh");
function $7c576e9ad8044c54$var$_extends() {
    $7c576e9ad8044c54$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c576e9ad8044c54$var$_extends.apply(this, arguments);
}
function $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c576e9ad8044c54$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $l6pyh.default).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($1Z7cU)))($7c576e9ad8044c54$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $i6D11.default)((0, $i6D11.default).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $7c576e9ad8044c54$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $i6D11.default).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $i6D11.default).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}

});
parcelRegister("1Z7cU", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7MWok(iteratee, 3);
    $4xK4A(object, function(value, key, object) {
        $cWbJD(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $17211428bc2045c4$var$mapValues;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $4hwTc) $4hwTc(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});


parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});


parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});

parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4Nq5y;
    if (typeof value == 'object') return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});


parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});

parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});
parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});


parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});




parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});





parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});


parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});



parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});

parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});




parcelRegister("l6pyh", function(module, exports) {

$parcel$export(module.exports, "create", () => $f5cdfa956e941194$export$185802fd694ee1f5);
$parcel$export(module.exports, "default", () => $f5cdfa956e941194$export$2e2bcd8739ae039);

var $Sk64T = parcelRequire("Sk64T");
const $f5cdfa956e941194$var$prefixes = {
    context: '$',
    value: '.'
};
function $f5cdfa956e941194$export$185802fd694ee1f5(key, options) {
    return new $f5cdfa956e941194$export$2e2bcd8739ae039(key, options);
}
class $f5cdfa956e941194$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $f5cdfa956e941194$var$prefixes.context;
        this.isValue = this.key[0] === $f5cdfa956e941194$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $f5cdfa956e941194$var$prefixes.context : this.isValue ? $f5cdfa956e941194$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $Sk64T.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$f5cdfa956e941194$export$2e2bcd8739ae039.prototype.__isYupRef = true;

});
parcelRegister("Sk64T", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
module.exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ''
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}

});



parcelRegister("7Qa2h", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $5b552ca0a6c1ed5f$export$c52e5867d5879e24);

var $Sk64T = parcelRequire("Sk64T");
let $5b552ca0a6c1ed5f$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $5b552ca0a6c1ed5f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $Sk64T.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $5b552ca0a6c1ed5f$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $5b552ca0a6c1ed5f$var$reach = (obj, path, value, context)=>$5b552ca0a6c1ed5f$export$c52e5867d5879e24(obj, path, value, context).schema;
var $5b552ca0a6c1ed5f$export$2e2bcd8739ae039 = $5b552ca0a6c1ed5f$var$reach;

});

parcelRegister("5qm0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f307508f67966f1$export$2e2bcd8739ae039);

var $l6pyh = parcelRequire("l6pyh");
class $3f307508f67966f1$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $l6pyh.default).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $l6pyh.default).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $l6pyh.default).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $3f307508f67966f1$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}

});



parcelRegister("bNQHE", function(module, exports) {

$parcel$export(module.exports, "create", () => $0237b22d97657ad7$export$185802fd694ee1f5);

var $gdFPP = parcelRequire("gdFPP");

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");
function $0237b22d97657ad7$export$185802fd694ee1f5() {
    return new $0237b22d97657ad7$export$2e2bcd8739ae039();
}
class $0237b22d97657ad7$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $5nwN5.boolean).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $5nwN5.boolean).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value === false;
            }
        });
    }
}
$0237b22d97657ad7$export$185802fd694ee1f5.prototype = $0237b22d97657ad7$export$2e2bcd8739ae039.prototype;

});
parcelRegister("7mZW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $55daa1cd95624d91$export$2e2bcd8739ae039);
const $55daa1cd95624d91$var$isAbsent = (value)=>value == null;
var $55daa1cd95624d91$export$2e2bcd8739ae039 = $55daa1cd95624d91$var$isAbsent;

});


parcelRegister("gcL7X", function(module, exports) {

$parcel$export(module.exports, "create", () => $bcc252d93ab3046c$export$185802fd694ee1f5);

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");

var $gdFPP = parcelRequire("gdFPP");
let $bcc252d93ab3046c$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $bcc252d93ab3046c$var$isTrimmed = (value)=>(0, $7mZW8.default)(value) || value === value.trim();
let $bcc252d93ab3046c$var$objStringTag = ({}).toString();
function $bcc252d93ab3046c$export$185802fd694ee1f5() {
    return new $bcc252d93ab3046c$export$2e2bcd8739ae039();
}
class $bcc252d93ab3046c$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $bcc252d93ab3046c$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $5nwN5.string).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $5nwN5.string).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $5nwN5.string).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $5nwN5.string).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $7mZW8.default)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $5nwN5.string).email) {
        return this.matches($bcc252d93ab3046c$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $5nwN5.string).url) {
        return this.matches($bcc252d93ab3046c$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $5nwN5.string).uuid) {
        return this.matches($bcc252d93ab3046c$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $5nwN5.string).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $bcc252d93ab3046c$var$isTrimmed
        });
    }
    lowercase(message = (0, $5nwN5.string).lowercase) {
        return this.transform((value)=>!(0, $7mZW8.default)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $7mZW8.default)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $5nwN5.string).uppercase) {
        return this.transform((value)=>!(0, $7mZW8.default)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $7mZW8.default)(value) || value === value.toUpperCase()
        });
    }
}
$bcc252d93ab3046c$export$185802fd694ee1f5.prototype = $bcc252d93ab3046c$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //

});

parcelRegister("5Hirs", function(module, exports) {

$parcel$export(module.exports, "create", () => $425f4614c2bd74f2$export$185802fd694ee1f5);

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");

var $gdFPP = parcelRequire("gdFPP");
let $425f4614c2bd74f2$var$isNaN = (value)=>value != +value;
function $425f4614c2bd74f2$export$185802fd694ee1f5() {
    return new $425f4614c2bd74f2$export$2e2bcd8739ae039();
}
class $425f4614c2bd74f2$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$425f4614c2bd74f2$var$isNaN(value);
    }
    min(min, message = (0, $5nwN5.number).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $5nwN5.number).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $5nwN5.number).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $5nwN5.number).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $5nwN5.number).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $5nwN5.number).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $5nwN5.number).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $7mZW8.default)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $7mZW8.default)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $7mZW8.default)(value) ? Math[method](value) : value);
    }
}
$425f4614c2bd74f2$export$185802fd694ee1f5.prototype = $425f4614c2bd74f2$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //

});

parcelRegister("8CK3p", function(module, exports) {

$parcel$export(module.exports, "create", () => $647598aeb0c659d9$export$185802fd694ee1f5);
// @ts-ignore

var $aBQOZ = parcelRequire("aBQOZ");

var $5nwN5 = parcelRequire("5nwN5");

var $7mZW8 = parcelRequire("7mZW8");

var $l6pyh = parcelRequire("l6pyh");

var $gdFPP = parcelRequire("gdFPP");
let $647598aeb0c659d9$var$invalidDate = new Date('');
let $647598aeb0c659d9$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $647598aeb0c659d9$export$185802fd694ee1f5() {
    return new $647598aeb0c659d9$export$2e2bcd8739ae039();
}
class $647598aeb0c659d9$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $aBQOZ.default)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $647598aeb0c659d9$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $647598aeb0c659d9$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $l6pyh.default).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $5nwN5.date).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $5nwN5.date).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$647598aeb0c659d9$export$2e2bcd8739ae039.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;
$647598aeb0c659d9$export$185802fd694ee1f5.prototype = $647598aeb0c659d9$export$2e2bcd8739ae039.prototype;
$647598aeb0c659d9$export$185802fd694ee1f5.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;

});
parcelRegister("aBQOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b96554ad88dbbc3$export$2e2bcd8739ae039);
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7b96554ad88dbbc3$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7b96554ad88dbbc3$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7b96554ad88dbbc3$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}

});


parcelRegister("hDGtv", function(module, exports) {

$parcel$export(module.exports, "create", () => $cd7706ce94a8dfd1$export$185802fd694ee1f5);

var $jplJt = parcelRequire("jplJt");

var $6MySP = parcelRequire("6MySP");

var $ikqdL = parcelRequire("ikqdL");

var $4tffG = parcelRequire("4tffG");

var $1Z7cU = parcelRequire("1Z7cU");

var $Sk64T = parcelRequire("Sk64T");

var $5nwN5 = parcelRequire("5nwN5");

var $eVHXo = parcelRequire("eVHXo");

var $fAFBj = parcelRequire("fAFBj");

var $i6asA = parcelRequire("i6asA");

var $i6D11 = parcelRequire("i6D11");

var $gdFPP = parcelRequire("gdFPP");
function $cd7706ce94a8dfd1$var$_extends() {
    $cd7706ce94a8dfd1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd7706ce94a8dfd1$var$_extends.apply(this, arguments);
}
let $cd7706ce94a8dfd1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $cd7706ce94a8dfd1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cd7706ce94a8dfd1$var$defaultSort = (0, $fAFBj.default)([]);
class $cd7706ce94a8dfd1$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $cd7706ce94a8dfd1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $cd7706ce94a8dfd1$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $cd7706ce94a8dfd1$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($jplJt)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $i6D11.default).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$cd7706ce94a8dfd1$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $cd7706ce94a8dfd1$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $i6asA.default)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $cd7706ce94a8dfd1$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $gdFPP.default) && schemaOrRef instanceof (0, $gdFPP.default)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $fAFBj.default)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $eVHXo.default)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $Sk64T.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($jplJt)))(obj, from)) {
                newObj = $cd7706ce94a8dfd1$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $5nwN5.object).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cd7706ce94a8dfd1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $5nwN5.object).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($4tffG)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($ikqdL))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($6MySP))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($6MySP)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($1Z7cU)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $cd7706ce94a8dfd1$export$185802fd694ee1f5(spec) {
    return new $cd7706ce94a8dfd1$export$2e2bcd8739ae039(spec);
}
$cd7706ce94a8dfd1$export$185802fd694ee1f5.prototype = $cd7706ce94a8dfd1$export$2e2bcd8739ae039.prototype;

});
parcelRegister("6MySP", function(module, exports) {

var $Xus0v = parcelRequire("Xus0v");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $4f0248df72a92950$var$snakeCase = $Xus0v(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
module.exports = $4f0248df72a92950$var$snakeCase;

});
parcelRegister("Xus0v", function(module, exports) {

var $1FZZ3 = parcelRequire("1FZZ3");

var $koe5E = parcelRequire("koe5E");

var $1CRrQ = parcelRequire("1CRrQ");
/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1FZZ3($1CRrQ($koe5E(string).replace($0b2d21aee1d97729$var$reApos, '')), callback, '');
    };
}
module.exports = $0b2d21aee1d97729$var$createCompounder;

});
parcelRegister("1FZZ3", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1389b3710f5da9e8$var$arrayReduce;

});

parcelRegister("koe5E", function(module, exports) {

var $4qdBK = parcelRequire("4qdBK");

var $l6E2L = parcelRequire("l6E2L");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = '\\u0300-\\u036f', $ed80fa8833e2b532$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ed80fa8833e2b532$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = '[' + $ed80fa8833e2b532$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $l6E2L(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $4qdBK).replace($ed80fa8833e2b532$var$reComboMark, '');
}
module.exports = $ed80fa8833e2b532$var$deburr;

});
parcelRegister("4qdBK", function(module, exports) {

var $iWLIn = parcelRequire("iWLIn");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $iWLIn($3384256242a1b577$var$deburredLetters);
module.exports = $3384256242a1b577$var$deburrLetter;

});
parcelRegister("iWLIn", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $dcb2a7eb44d37cba$var$basePropertyOf;

});



parcelRegister("1CRrQ", function(module, exports) {

var $aP9V7 = parcelRequire("aP9V7");

var $by7Kg = parcelRequire("by7Kg");

var $l6E2L = parcelRequire("l6E2L");

var $4k1Gy = parcelRequire("4k1Gy");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $l6E2L(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $by7Kg(string) ? $4k1Gy(string) : $aP9V7(string);
    return string.match(pattern) || [];
}
module.exports = $12f2ccb7e11b3895$var$words;

});
parcelRegister("aP9V7", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
module.exports = $7e165cbd28a9af51$var$asciiWords;

});

parcelRegister("by7Kg", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
module.exports = $8688e0b23f5a081b$var$hasUnicodeWord;

});

parcelRegister("4k1Gy", function(module, exports) {
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = '\\ud800-\\udfff', $325a565efdffbc96$var$rsComboMarksRange = '\\u0300-\\u036f', $325a565efdffbc96$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $325a565efdffbc96$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = '\\u2700-\\u27bf', $325a565efdffbc96$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $325a565efdffbc96$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $325a565efdffbc96$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $325a565efdffbc96$var$rsPunctuationRange = '\\u2000-\\u206f', $325a565efdffbc96$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $325a565efdffbc96$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $325a565efdffbc96$var$rsVarRange = '\\ufe0e\\ufe0f', $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = '[' + $325a565efdffbc96$var$rsBreakRange + ']', $325a565efdffbc96$var$rsCombo = '[' + $325a565efdffbc96$var$rsComboRange + ']', $325a565efdffbc96$var$rsDigits = '\\d+', $325a565efdffbc96$var$rsDingbat = '[' + $325a565efdffbc96$var$rsDingbatRange + ']', $325a565efdffbc96$var$rsLower = '[' + $325a565efdffbc96$var$rsLowerRange + ']', $325a565efdffbc96$var$rsMisc = '[^' + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $325a565efdffbc96$var$rsModifier = '(?:' + $325a565efdffbc96$var$rsCombo + '|' + $325a565efdffbc96$var$rsFitz + ')', $325a565efdffbc96$var$rsNonAstral = '[^' + $325a565efdffbc96$var$rsAstralRange + ']', $325a565efdffbc96$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $325a565efdffbc96$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $325a565efdffbc96$var$rsUpper = '[' + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = '(?:' + $325a565efdffbc96$var$rsLower + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsMiscUpper = '(?:' + $325a565efdffbc96$var$rsUpper + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsOptContrLower = '(?:' + $325a565efdffbc96$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $325a565efdffbc96$var$rsOptContrUpper = '(?:' + $325a565efdffbc96$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + '?', $325a565efdffbc96$var$rsOptVar = '[' + $325a565efdffbc96$var$rsVarRange + ']?', $325a565efdffbc96$var$rsOptJoin = '(?:' + $325a565efdffbc96$var$rsZWJ + '(?:' + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ')*', $325a565efdffbc96$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $325a565efdffbc96$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = '(?:' + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsLower + '+' + $325a565efdffbc96$var$rsOptContrLower + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsMiscUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsMiscLower + '+' + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
module.exports = $325a565efdffbc96$var$unicodeWords;

});




parcelRegister("ikqdL", function(module, exports) {

var $6lBJo = parcelRequire("6lBJo");

var $Xus0v = parcelRequire("Xus0v");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $d57e6f3349076887$var$camelCase = $Xus0v(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $6lBJo(word) : word);
});
module.exports = $d57e6f3349076887$var$camelCase;

});
parcelRegister("6lBJo", function(module, exports) {

var $l6E2L = parcelRequire("l6E2L");

var $iKqE0 = parcelRequire("iKqE0");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $49f1f8db3e260fbf$var$capitalize(string) {
    return $iKqE0($l6E2L(string).toLowerCase());
}
module.exports = $49f1f8db3e260fbf$var$capitalize;

});
parcelRegister("iKqE0", function(module, exports) {

var $1ammj = parcelRequire("1ammj");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $1ammj('toUpperCase');
module.exports = $da6130e1e4702e32$var$upperFirst;

});
parcelRegister("1ammj", function(module, exports) {

var $hQFv5 = parcelRequire("hQFv5");

var $05hp8 = parcelRequire("05hp8");

var $dgUhg = parcelRequire("dgUhg");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $l6E2L(string);
        var strSymbols = $05hp8(string) ? $dgUhg(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $hQFv5(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $0d9811a54a2f955a$var$createCaseFirst;

});
parcelRegister("hQFv5", function(module, exports) {

var $1quiu = parcelRequire("1quiu");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $1quiu(array, start, end);
}
module.exports = $cfe77c1a7b7c7d6e$var$castSlice;

});
parcelRegister("1quiu", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $109fb88fe59de104$var$baseSlice;

});


parcelRegister("05hp8", function(module, exports) {
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
module.exports = $00fdf7eab00be2e7$var$hasUnicode;

});

parcelRegister("dgUhg", function(module, exports) {

var $5OuFP = parcelRequire("5OuFP");

var $05hp8 = parcelRequire("05hp8");

var $gNXOw = parcelRequire("gNXOw");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $05hp8(string) ? $gNXOw(string) : $5OuFP(string);
}
module.exports = $9a986c87d425808c$var$stringToArray;

});
parcelRegister("5OuFP", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $43b96a6d93895c83$var$asciiToArray;

});

parcelRegister("gNXOw", function(module, exports) {
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = '\\ud800-\\udfff', $c3bf9ebcb1b53b1d$var$rsComboMarksRange = '\\u0300-\\u036f', $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = '[' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsCombo = '[' + $c3bf9ebcb1b53b1d$var$rsComboRange + ']', $c3bf9ebcb1b53b1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c3bf9ebcb1b53b1d$var$rsModifier = '(?:' + $c3bf9ebcb1b53b1d$var$rsCombo + '|' + $c3bf9ebcb1b53b1d$var$rsFitz + ')', $c3bf9ebcb1b53b1d$var$rsNonAstral = '[^' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c3bf9ebcb1b53b1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c3bf9ebcb1b53b1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + '?', $c3bf9ebcb1b53b1d$var$rsOptVar = '[' + $c3bf9ebcb1b53b1d$var$rsVarRange + ']?', $c3bf9ebcb1b53b1d$var$rsOptJoin = '(?:' + $c3bf9ebcb1b53b1d$var$rsZWJ + '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join('|') + ')' + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ')*', $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + '?',
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + '(?=' + $c3bf9ebcb1b53b1d$var$rsFitz + ')|' + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
module.exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;

});






parcelRegister("4tffG", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $3415b394b567e74a$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $7MWok(iteratee, 3);
    $4xK4A(object, function(value, key, object) {
        $cWbJD(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $3415b394b567e74a$var$mapKeys;

});

parcelRegister("eVHXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade87c847c1ee6bb$export$2e2bcd8739ae039);

var $jplJt = parcelRequire("jplJt");

var $dYCFZ = parcelRequire("dYCFZ");

var $Sk64T = parcelRequire("Sk64T");

var $l6pyh = parcelRequire("l6pyh");

var $2vNMA = parcelRequire("2vNMA");
function $ade87c847c1ee6bb$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $Sk64T.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($jplJt)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $l6pyh.default).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $2vNMA.default)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dYCFZ))).array(Array.from(nodes), edges).reverse();
}

});
parcelRegister("dYCFZ", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
module.exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("fAFBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039);
function $b59a7ce2e5e0a1e4$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $b59a7ce2e5e0a1e4$var$findIndex(keys, a) - $b59a7ce2e5e0a1e4$var$findIndex(keys, b);
    };
}

});


parcelRegister("jpuYg", function(module, exports) {

$parcel$export(module.exports, "create", () => $e218604b96487b25$export$185802fd694ee1f5);

var $7mZW8 = parcelRequire("7mZW8");

var $2vNMA = parcelRequire("2vNMA");

var $58i62 = parcelRequire("58i62");

var $5nwN5 = parcelRequire("5nwN5");

var $i6asA = parcelRequire("i6asA");

var $i6D11 = parcelRequire("i6D11");

var $gdFPP = parcelRequire("gdFPP");
function $e218604b96487b25$var$_extends() {
    $e218604b96487b25$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e218604b96487b25$var$_extends.apply(this, arguments);
}
function $e218604b96487b25$export$185802fd694ee1f5(type) {
    return new $e218604b96487b25$export$2e2bcd8739ae039(type);
}
class $e218604b96487b25$export$2e2bcd8739ae039 extends (0, $gdFPP.default) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $e218604b96487b25$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $i6D11.default).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $e218604b96487b25$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $i6asA.default)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $2vNMA.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $58i62.default)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $5nwN5.array).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $5nwN5.array).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $7mZW8.default)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $5nwN5.array).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $7mZW8.default)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$e218604b96487b25$export$185802fd694ee1f5.prototype = $e218604b96487b25$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //

});

parcelRegister("7LzLt", function(module, exports) {

var $2vNMA = parcelRequire("2vNMA");
function $5a78aa552a6b7bb3$export$185802fd694ee1f5(builder) {
    return new $5a78aa552a6b7bb3$var$Lazy(builder);
}
class $5a78aa552a6b7bb3$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $2vNMA.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $5a78aa552a6b7bb3$export$2e2bcd8739ae039 = $5a78aa552a6b7bb3$var$Lazy;

});

parcelRegister("k9zcs", function(module, exports) {

var $5nwN5 = parcelRequire("5nwN5");
function $eabff3e78de076bd$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $5nwN5.default)[type][method] = custom[type][method];
        });
    });
}

});


parcelRegister("5GZlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6f79deda88cfad$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $a3QyA = parcelRequire("a3QyA");

var $7YFi7 = parcelRequire("7YFi7");
const $7c6f79deda88cfad$var$SelectField = ({ isDisabled: isDisabled = false, isMulti: isMulti = false, isGrouped: isGrouped = false, isClearable: isClearable = false, closeMenuOnSelect: closeMenuOnSelect = true, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
        component: $7c6f79deda88cfad$var$ReactSelectField,
        id: props.name,
        isGrouped: isGrouped,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnSelect: closeMenuOnSelect,
        isMulti: isMulti,
        ...props
    });
};
var $7c6f79deda88cfad$export$2e2bcd8739ae039 = $7c6f79deda88cfad$var$SelectField;
const $7c6f79deda88cfad$var$ReactSelectField = (props)=>{
    // Add custom styles here
    const customStyles = {
        option: (provided, _state)=>({
                ...provided
            }),
        control: (provided, _state)=>({
                ...provided,
                paddingTop: "1px",
                paddingBottom: "2px",
                marginBottom: "0.25rem"
            })
    };
    const flattenGroupedOptions = (options)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).flatten((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(options, "options"));
    };
    const onChange = (option)=>{
        const value = props.isMulti ? option?.map((item)=>item.value) : option?.value;
        props.form.setFieldValue(props.field.name, value);
        // No React.ChangeEvent
        // https://github.com/JedWatson/react-select/issues/1631
        props.onChange({
            currentTarget: {
                name: props.field.name,
                value: value
            }
        });
    };
    const getValue = ()=>{
        let options = props.options;
        if (options?.length) {
            if (props.isGrouped) options = flattenGroupedOptions(props.options);
            return props.isMulti ? options.filter((option)=>props.field.value.indexOf(option.value) >= 0) : options.find((option)=>option.value === props.field.value) || "";
        } else return props.isMulti ? [] : "";
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3QyA.default), {
        options: props.options,
        inputId: props.field.name,
        name: props.field.name,
        value: getValue(),
        isClearable: props.isClearable,
        closeMenuOnSelect: props.closeMenuOnSelect,
        isDisabled: props.isDisabled,
        isMulti: props.isMulti,
        placeholder: props.placeholder,
        onChange: onChange,
        onBlur: props.field.onBlur,
        onFocus: props.onFocus,
        styles: customStyles,
        components: props.components,
        filterOption: props.filterOption,
        theme: (theme)=>({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary25: "#E0E0E0",
                    primary50: "#ADADAD",
                    primary: "#A3C3C4",
                    neutral20: "#A3C3C4",
                    neutral30: "#75A7A9",
                    danger: "#C20000",
                    dangerLight: "#FAE8D8"
                }
            })
    });
};

});
parcelRegister("a3QyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7532f3e29d96fa2a$export$2e2bcd8739ae039);

var $dwyob = parcelRequire("dwyob");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9Hi20 = parcelRequire("9Hi20");

var $k7M2x = parcelRequire("k7M2x");

var $lDTld = parcelRequire("lDTld");

parcelRequire("cbdLd");
parcelRequire("02Ztr");
parcelRequire("gZU1N");
parcelRequire("fu0YK");
parcelRequire("lR7jo");
parcelRequire("f8wIT");
parcelRequire("9jKhT");
parcelRequire("fUHKi");

parcelRequire("41YNz");
parcelRequire("gS6QF");
parcelRequire("g5Zhu");
parcelRequire("1u0KT");

parcelRequire("jLbqB");
var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $dwyob.u)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $9Hi20.S), (0, $8nd05.default)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $lDTld.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $k7M2x.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("dwyob", function(module, exports) {

$parcel$export(module.exports, "u", () => $9d88f0746ba78f85$export$3b14a55fb2447963);

var $d49SP = parcelRequire("d49SP");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $9X7IJ.default)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $eUqlC.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $eUqlC.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $eUqlC.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $d49SP.default)((0, $d49SP.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("9Hi20", function(module, exports) {

$parcel$export(module.exports, "S", () => $70f61dd951fba0f0$export$25ce5a424b770e84);

var $8nd05 = parcelRequire("8nd05");

var $d49SP = parcelRequire("d49SP");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");

var $jJwlt = parcelRequire("jJwlt");

var $8zogs = parcelRequire("8zogs");

var $jk22o = parcelRequire("jk22o");

var $9X7IJ = parcelRequire("9X7IJ");
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $70f61dd951fba0f0$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $70f61dd951fba0f0$var$A11yText = function A11yText(props) {
    return (0, $8zogs.jsx)("span", (0, $8nd05.default)({
        css: $70f61dd951fba0f0$var$_ref
    }, props));
};
var $70f61dd951fba0f0$var$A11yText$1 = $70f61dd951fba0f0$var$A11yText;
var $70f61dd951fba0f0$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $70f61dd951fba0f0$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $d49SP.default)((0, $d49SP.default)({}, $70f61dd951fba0f0$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $d49SP.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $8zogs.jsx)((0, $acw62.Fragment), null, (0, $8zogs.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $8zogs.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $8zogs.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $8zogs.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $8zogs.jsx)((0, $acw62.Fragment), null, (0, $8zogs.jsx)($70f61dd951fba0f0$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $8zogs.jsx)($70f61dd951fba0f0$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $70f61dd951fba0f0$var$LiveRegion$1 = $70f61dd951fba0f0$var$LiveRegion;
var $70f61dd951fba0f0$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $70f61dd951fba0f0$var$anyDiacritic = new RegExp('[' + $70f61dd951fba0f0$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $70f61dd951fba0f0$var$diacriticToBase = {};
for(var $70f61dd951fba0f0$var$i = 0; $70f61dd951fba0f0$var$i < $70f61dd951fba0f0$var$diacritics.length; $70f61dd951fba0f0$var$i++){
    var $70f61dd951fba0f0$var$diacritic = $70f61dd951fba0f0$var$diacritics[$70f61dd951fba0f0$var$i];
    for(var $70f61dd951fba0f0$var$j = 0; $70f61dd951fba0f0$var$j < $70f61dd951fba0f0$var$diacritic.letters.length; $70f61dd951fba0f0$var$j++)$70f61dd951fba0f0$var$diacriticToBase[$70f61dd951fba0f0$var$diacritic.letters[$70f61dd951fba0f0$var$j]] = $70f61dd951fba0f0$var$diacritic.base;
}
var $70f61dd951fba0f0$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($70f61dd951fba0f0$var$anyDiacritic, function(match) {
        return $70f61dd951fba0f0$var$diacriticToBase[match];
    });
};
var $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput = (0, $jk22o.default)($70f61dd951fba0f0$var$stripDiacritics);
var $70f61dd951fba0f0$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $70f61dd951fba0f0$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $70f61dd951fba0f0$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $d49SP.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $70f61dd951fba0f0$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $70f61dd951fba0f0$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $70f61dd951fba0f0$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput(input);
            candidate = $70f61dd951fba0f0$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $70f61dd951fba0f0$var$_excluded = [
    "innerRef"
];
function $70f61dd951fba0f0$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $9X7IJ.default)(_ref, $70f61dd951fba0f0$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jJwlt.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $8zogs.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $8zogs.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $70f61dd951fba0f0$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $70f61dd951fba0f0$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $70f61dd951fba0f0$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jJwlt.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $70f61dd951fba0f0$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $70f61dd951fba0f0$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $70f61dd951fba0f0$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $70f61dd951fba0f0$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $70f61dd951fba0f0$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $70f61dd951fba0f0$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $70f61dd951fba0f0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $70f61dd951fba0f0$var$activeScrollLocks = 0;
var $70f61dd951fba0f0$var$listenerOptions = {
    capture: false,
    passive: false
};
function $70f61dd951fba0f0$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($70f61dd951fba0f0$var$LOCK_STYLES).forEach(function(key) {
                var val = $70f61dd951fba0f0$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks = Math.max($70f61dd951fba0f0$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $70f61dd951fba0f0$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $70f61dd951fba0f0$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $70f61dd951fba0f0$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $70f61dd951fba0f0$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $8zogs.jsx)((0, $acw62.Fragment), null, lockEnabled && (0, $8zogs.jsx)("div", {
        onClick: $70f61dd951fba0f0$var$blurSelectInput,
        css: $70f61dd951fba0f0$var$_ref2$1
    }), children(targetRef));
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $70f61dd951fba0f0$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $8zogs.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $70f61dd951fba0f0$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $70f61dd951fba0f0$var$RequiredInput$1 = $70f61dd951fba0f0$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $70f61dd951fba0f0$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $70f61dd951fba0f0$var$isIPhone() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPhone/i);
}
function $70f61dd951fba0f0$var$isMac() {
    return $70f61dd951fba0f0$var$testPlatform(/^Mac/i);
}
function $70f61dd951fba0f0$var$isIPad() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $70f61dd951fba0f0$var$isMac() && navigator.maxTouchPoints > 1;
}
function $70f61dd951fba0f0$var$isIOS() {
    return $70f61dd951fba0f0$var$isIPhone() || $70f61dd951fba0f0$var$isIPad();
}
function $70f61dd951fba0f0$var$isAppleDevice() {
    return $70f61dd951fba0f0$var$isMac() || $70f61dd951fba0f0$var$isIOS();
}
var $70f61dd951fba0f0$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $70f61dd951fba0f0$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $70f61dd951fba0f0$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $70f61dd951fba0f0$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $70f61dd951fba0f0$var$defaultStyles = {
    clearIndicator: (0, $jJwlt.a),
    container: (0, $jJwlt.b),
    control: (0, $jJwlt.d),
    dropdownIndicator: (0, $jJwlt.e),
    group: (0, $jJwlt.g),
    groupHeading: (0, $jJwlt.f),
    indicatorsContainer: (0, $jJwlt.i),
    indicatorSeparator: (0, $jJwlt.h),
    input: (0, $jJwlt.j),
    loadingIndicator: (0, $jJwlt.l),
    loadingMessage: (0, $jJwlt.k),
    menu: (0, $jJwlt.m),
    menuList: (0, $jJwlt.n),
    menuPortal: (0, $jJwlt.o),
    multiValue: (0, $jJwlt.p),
    multiValueLabel: (0, $jJwlt.q),
    multiValueRemove: (0, $jJwlt.t),
    noOptionsMessage: (0, $jJwlt.u),
    option: (0, $jJwlt.v),
    placeholder: (0, $jJwlt.w),
    singleValue: (0, $jJwlt.x),
    valueContainer: (0, $jJwlt.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $70f61dd951fba0f0$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $d49SP.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $70f61dd951fba0f0$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $70f61dd951fba0f0$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $70f61dd951fba0f0$var$baseUnit = 4;
// The minimum height of the control
var $70f61dd951fba0f0$var$controlHeight = 38;
// The amount of space between the control and menu */
var $70f61dd951fba0f0$var$menuGutter = $70f61dd951fba0f0$var$baseUnit * 2;
var $70f61dd951fba0f0$var$spacing = {
    baseUnit: $70f61dd951fba0f0$var$baseUnit,
    controlHeight: $70f61dd951fba0f0$var$controlHeight,
    menuGutter: $70f61dd951fba0f0$var$menuGutter
};
var $70f61dd951fba0f0$export$4368d992c4eafac0 = {
    borderRadius: $70f61dd951fba0f0$var$borderRadius,
    colors: $70f61dd951fba0f0$var$colors,
    spacing: $70f61dd951fba0f0$var$spacing
};
var $70f61dd951fba0f0$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jJwlt.z)(),
    captureMenuScroll: !(0, $jJwlt.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $70f61dd951fba0f0$export$db3b6bfb95261072(),
    formatGroupLabel: $70f61dd951fba0f0$var$formatGroupLabel,
    getOptionLabel: $70f61dd951fba0f0$export$8b22cf2602fb60ce,
    getOptionValue: $70f61dd951fba0f0$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $70f61dd951fba0f0$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jJwlt.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue);
    var label = $70f61dd951fba0f0$var$getOptionLabel(props, option);
    var value = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $70f61dd951fba0f0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jJwlt.K));
}
function $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $kbxxf.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) {
    return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue));
}
function $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$70f61dd951fba0f0$var$shouldHideSelectedOptions(props) || !isSelected) && $70f61dd951fba0f0$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $70f61dd951fba0f0$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $70f61dd951fba0f0$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $70f61dd951fba0f0$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $70f61dd951fba0f0$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $70f61dd951fba0f0$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $70f61dd951fba0f0$var$getOptionValue(props, i) === candidate;
    });
}
function $70f61dd951fba0f0$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $70f61dd951fba0f0$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $70f61dd951fba0f0$var$instanceId = 1;
var $70f61dd951fba0f0$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = (0, $enfmq.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jJwlt.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jJwlt.B)([].concat((0, $kbxxf.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jJwlt.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jJwlt.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jJwlt.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jJwlt.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jJwlt.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $70f61dd951fba0f0$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jJwlt.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $70f61dd951fba0f0$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $70f61dd951fba0f0$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $70f61dd951fba0f0$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jJwlt.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $d49SP.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jJwlt.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $70f61dd951fba0f0$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$70f61dd951fba0f0$var$instanceId);
        _this.state.selectValue = (0, $jJwlt.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jJwlt.I)(this.menuListRef, this.focusedOptionRef);
                if ($70f61dd951fba0f0$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jJwlt.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $70f61dd951fba0f0$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($70f61dd951fba0f0$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $d49SP.default)((0, $d49SP.default)({}, $70f61dd951fba0f0$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $70f61dd951fba0f0$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jJwlt.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $jJwlt.M), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$LiveRegion$1, (0, $8nd05.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jJwlt.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $70f61dd951fba0f0$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $70f61dd951fba0f0$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jJwlt.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $d49SP.default)((0, $d49SP.default)((0, $d49SP.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$70f61dd951fba0f0$export$25ce5a424b770e84.defaultProps = $70f61dd951fba0f0$export$407448d2b89b1813;

});
parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $fhGLX.default)();
    return function() {
        var e, o = (0, $jDKKo.default)(t);
        if (r) {
            var s = (0, $jDKKo.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $9715X.default)(this, e);
    };
}

});
parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});


parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jJwlt", function(module, exports) {

$parcel$export(module.exports, "J", () => $e5db4f66b3bbccc3$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "G", () => $e5db4f66b3bbccc3$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $e5db4f66b3bbccc3$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $e5db4f66b3bbccc3$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e5db4f66b3bbccc3$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e5db4f66b3bbccc3$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $e5db4f66b3bbccc3$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $e5db4f66b3bbccc3$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e5db4f66b3bbccc3$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e5db4f66b3bbccc3$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e5db4f66b3bbccc3$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e5db4f66b3bbccc3$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e5db4f66b3bbccc3$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e5db4f66b3bbccc3$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e5db4f66b3bbccc3$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e5db4f66b3bbccc3$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e5db4f66b3bbccc3$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e5db4f66b3bbccc3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e5db4f66b3bbccc3$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e5db4f66b3bbccc3$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e5db4f66b3bbccc3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e5db4f66b3bbccc3$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e5db4f66b3bbccc3$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e5db4f66b3bbccc3$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e5db4f66b3bbccc3$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e5db4f66b3bbccc3$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e5db4f66b3bbccc3$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e5db4f66b3bbccc3$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e5db4f66b3bbccc3$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e5db4f66b3bbccc3$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e5db4f66b3bbccc3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e5db4f66b3bbccc3$export$d141bba7fdc215a3);
$parcel$export(module.exports, "F", () => $e5db4f66b3bbccc3$export$d66501df72047452);

var $d49SP = parcelRequire("d49SP");

var $8nd05 = parcelRequire("8nd05");

var $8zogs = parcelRequire("8zogs");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $hvnYt = parcelRequire("hvnYt");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");

var $jLbqB = parcelRequire("jLbqB");
var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $9X7IJ.default)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $d49SP.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $eUqlC.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $eUqlC.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $d49SP.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $kSlfw.default)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $kSlfw.default)(_objectSpread2, "position", 'absolute'), (0, $kSlfw.default)(_objectSpread2, "width", '100%'), (0, $kSlfw.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $eUqlC.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $eUqlC.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $jLbqB.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $d49SP.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $9X7IJ.default)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $9X7IJ.default)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $eUqlC.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $eUqlC.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $jLbqB.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $618j3.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $jLbqB.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $d49SP.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $8zogs.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $8zogs.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $8zogs.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $d49SP.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $d49SP.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $8zogs.jsx)("span", (0, $8nd05.default)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $8zogs.keyframes)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $hvnYt.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $d49SP.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $8zogs.jsx)("span", {
        css: /*#__PURE__*/ (0, $8zogs.css)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $9X7IJ.default)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $d49SP.default)((0, $d49SP.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $d49SP.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $8zogs.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $8zogs.jsx)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $d49SP.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)((0, $d49SP.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $d49SP.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $d49SP.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $9X7IJ.default)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $8zogs.jsx)("input", (0, $8nd05.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $d49SP.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $d49SP.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $8zogs.jsx)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({
        role: "button"
    }, innerProps), children || (0, $8zogs.jsx)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $8zogs.jsx)(Container, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $8zogs.jsx)(Label, {
        data: data,
        innerProps: (0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $8zogs.jsx)(Remove, {
        data: data,
        innerProps: (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $d49SP.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $8zogs.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $d49SP.default)((0, $d49SP.default)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("8zogs", function(module, exports) {

$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $63d46a01db878c10$export$c8a8987d4410bf2d);

var $acw62 = parcelRequire("acw62");
parcelRequire("lDTld");

var $k7M2x = parcelRequire("k7M2x");
parcelRequire("3p9rK");
parcelRequire("iq6RI");
parcelRequire("9ORqK");


var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.10.5",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.5",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.18.5",
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.5",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.5",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $k7M2x.h).call(props, 'css')) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $k7M2x.E);
    createElementArgArray[1] = (0, $k7M2x.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $k7M2x.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, (0, $acw62.useContext)((0, $k7M2x.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $acw62.useRef)();
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $k7M2x.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $acw62.useContext)((0, $k7M2x.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRegister("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $jmsCu = parcelRequire("jmsCu");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("iq6RI");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? children[0].children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jmsCu.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = $fc182b1f84212d3f$var$createCache;

});
parcelRegister("jmsCu", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e18645ac1956fbe6$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(O += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(O) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(O += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) O += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = O += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = $d68ffb0773f38e18$var$weakMemoize;

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $6bb1e54ce1bc6efa$export$2e2bcd8739ae039 = $6bb1e54ce1bc6efa$var$memoize;

});


parcelRegister("k7M2x", function(module, exports) {

$parcel$export(module.exports, "h", () => $ea69b9ccc73b096b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $ea69b9ccc73b096b$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $ea69b9ccc73b096b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $ea69b9ccc73b096b$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $ea69b9ccc73b096b$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $kKN31 = parcelRequire("kKN31");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $ea69b9ccc73b096b$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ea69b9ccc73b096b$var$EmotionCacheContext = /* #__PURE__ */ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $lDTld.default)({
    key: 'css'
}) : null);
var $ea69b9ccc73b096b$export$e7094788287c5e9b = $ea69b9ccc73b096b$var$EmotionCacheContext.Provider;
var $ea69b9ccc73b096b$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
};
var $ea69b9ccc73b096b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $ea69b9ccc73b096b$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $acw62.createContext)({});
var $ea69b9ccc73b096b$export$3b14a55fb2447963 = function useTheme() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
};
var $ea69b9ccc73b096b$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $ea69b9ccc73b096b$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $ea69b9ccc73b096b$var$getTheme(outerTheme, theme);
    });
});
var $ea69b9ccc73b096b$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ea69b9ccc73b096b$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ea69b9ccc73b096b$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $acw62.createElement)(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $ea69b9ccc73b096b$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]);
    return undefined;
};
var $ea69b9ccc73b096b$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $ea69b9ccc73b096b$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $ea69b9ccc73b096b$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($ea69b9ccc73b096b$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $ea69b9ccc73b096b$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $ea69b9ccc73b096b$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $ea69b9ccc73b096b$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $ea69b9ccc73b096b$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ea69b9ccc73b096b$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $ea69b9ccc73b096b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $ea69b9ccc73b096b$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ea69b9ccc73b096b$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $ea69b9ccc73b096b$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ (0, $acw62.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};
var $f1be2661c8fac766$export$2e2bcd8739ae039 = $f1be2661c8fac766$var$hoistNonReactStatics;

});

parcelRegister("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, '-$&').toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $3629985b3ecf741f$export$2e2bcd8739ae039 = $3629985b3ecf741f$var$murmur2;

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $936be3b045ab836e$export$2e2bcd8739ae039 = $936be3b045ab836e$var$unitlessKeys;

});


parcelRegister("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $19b532704a3a90e7$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || (0, $acw62.useLayoutEffect);

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hvnYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe7edbf3ccb8828$export$2e2bcd8739ae039);
function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === 'rtl') x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $1obCQ.max)(rect.top, top);
        right = (0, $1obCQ.min)(rect.right, right);
        bottom = (0, $1obCQ.min)(rect.bottom, bottom);
        left = (0, $1obCQ.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $33bLr.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $1obCQ.getAlignment)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $973e4da43f2a375d$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $973e4da43f2a375d$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $973e4da43f2a375d$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $1obCQ.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $1obCQ.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $1obCQ.rectToClientRect)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === 'left';
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $1obCQ.rectToClientRect)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $1obCQ.clamp)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $1obCQ.max)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $1obCQ.max)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    const side = $10310cf078d13212$export$3c915306cb7fc97a(placement);
    return $10310cf078d13212$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $238ac70369f38756$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $238ac70369f38756$var$containRe = /paint|layout|strict|content/;
const $238ac70369f38756$var$isNotNone = (value)=>!!value && value !== 'none';
let $238ac70369f38756$var$isWebKitValue;
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$isNotNone(css.transform) || $238ac70369f38756$var$isNotNone(css.translate) || $238ac70369f38756$var$isNotNone(css.scale) || $238ac70369f38756$var$isNotNone(css.rotate) || $238ac70369f38756$var$isNotNone(css.perspective) || !$238ac70369f38756$export$78551043582a6a98() && ($238ac70369f38756$var$isNotNone(css.backdropFilter) || $238ac70369f38756$var$isNotNone(css.filter)) || $238ac70369f38756$var$willChangeRe.test(css.willChange || '') || $238ac70369f38756$var$containRe.test(css.contain || '');
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if ($238ac70369f38756$var$isWebKitValue == null) $238ac70369f38756$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $238ac70369f38756$var$isWebKitValue;
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("jLbqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b4578a0a2b358$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);

});


parcelRegister("jk22o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9jKhT", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $5HCVq = parcelRequire("5HCVq");

var $eN9hz = parcelRequire("eN9hz");
function $6c89cb228f797fa5$var$_createSuper(t) {
    var r = $5HCVq();
    return function() {
        var e, o = $cGTaw(t);
        if (r) {
            var s = $cGTaw(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $eN9hz(this, e);
    };
}
module.exports = $6c89cb228f797fa5$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gS6QF", function(module, exports) {
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $c4870074adc2be76$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2sUu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f293882901e659f$export$2e2bcd8739ae039);
const $5f293882901e659f$var$countryCodeList = [
    {
        "country": "United States of America (+1)",
        "code": "1"
    },
    {
        "country": "Canada (+1)",
        "code": "1"
    },
    {
        "country": "Russia (+7)",
        "code": "7"
    },
    {
        "country": "Kazakhstan (+7)",
        "code": "7"
    },
    {
        "country": "Egypt (+20)",
        "code": "20"
    },
    {
        "country": "South Africa (+27)",
        "code": "27"
    },
    {
        "country": "Greece (+30)",
        "code": "30"
    },
    {
        "country": "Netherlands (+31)",
        "code": "31"
    },
    {
        "country": "Belgium (+32)",
        "code": "32"
    },
    {
        "country": "France (+33)",
        "code": "33"
    },
    {
        "country": "Spain (+34)",
        "code": "34"
    },
    {
        "country": "Hungary (+36)",
        "code": "36"
    },
    {
        "country": "Italy (+39)",
        "code": "39"
    },
    {
        "country": "Romania (+40)",
        "code": "40"
    },
    {
        "country": "Switzerland (+41)",
        "code": "41"
    },
    {
        "country": "Austria (+43)",
        "code": "43"
    },
    {
        "country": "United Kingdom (+44)",
        "code": "44"
    },
    {
        "country": "Guernsey (+44)",
        "code": "44"
    },
    {
        "country": "Isle of Man (+44)",
        "code": "44"
    },
    {
        "country": "Jersey (+44)",
        "code": "44"
    },
    {
        "country": "Denmark (+45)",
        "code": "45"
    },
    {
        "country": "Sweden (+46)",
        "code": "46"
    },
    {
        "country": "Norway (+47)",
        "code": "47"
    },
    {
        "country": "Poland (+48)",
        "code": "48"
    },
    {
        "country": "Germany (+49)",
        "code": "49"
    },
    {
        "country": "Peru (+51)",
        "code": "51"
    },
    {
        "country": "Mexico (+52)",
        "code": "52"
    },
    {
        "country": "Cuba (+53)",
        "code": "53"
    },
    {
        "country": "Argentina (+54)",
        "code": "54"
    },
    {
        "country": "Brazil (+55)",
        "code": "55"
    },
    {
        "country": "Chile (+56)",
        "code": "56"
    },
    {
        "country": "Colombia (+57)",
        "code": "57"
    },
    {
        "country": "Venezuela (+58)",
        "code": "58"
    },
    {
        "country": "Malaysia (+60)",
        "code": "60"
    },
    {
        "country": "Australia (+61)",
        "code": "61"
    },
    {
        "country": "Indonesia (+62)",
        "code": "62"
    },
    {
        "country": "Philippines (+63)",
        "code": "63"
    },
    {
        "country": "New Zealand (+64)",
        "code": "64"
    },
    {
        "country": "Singapore (+65)",
        "code": "65"
    },
    {
        "country": "Thailand (+66)",
        "code": "66"
    },
    {
        "country": "Japan (+81)",
        "code": "81"
    },
    {
        "country": "Korea (+South) (+82)",
        "code": "82"
    },
    {
        "country": "Vietnam (+84)",
        "code": "84"
    },
    {
        "country": "China (+86)",
        "code": "86"
    },
    {
        "country": "Turkey (+90)",
        "code": "90"
    },
    {
        "country": "India (+91)",
        "code": "91"
    },
    {
        "country": "Pakistan (+92)",
        "code": "92"
    },
    {
        "country": "Afghanistan (+93)",
        "code": "93"
    },
    {
        "country": "Sri Lanka (+94)",
        "code": "94"
    },
    {
        "country": "Myanmar (+95)",
        "code": "95"
    },
    {
        "country": "Iran (+98)",
        "code": "98"
    },
    {
        "country": "Morocco (+212)",
        "code": "212"
    },
    {
        "country": "Algeria (+213)",
        "code": "213"
    },
    {
        "country": "Tunisia (+216)",
        "code": "216"
    },
    {
        "country": "Libya (+218)",
        "code": "218"
    },
    {
        "country": "Gambia (+220)",
        "code": "220"
    },
    {
        "country": "Senegal (+221)",
        "code": "221"
    },
    {
        "country": "Mauritania (+222)",
        "code": "222"
    },
    {
        "country": "Mali Republic (+223)",
        "code": "223"
    },
    {
        "country": "Guinea (+224)",
        "code": "224"
    },
    {
        "country": "Ivory Coast (+225)",
        "code": "225"
    },
    {
        "country": "Burkina Faso (+226)",
        "code": "226"
    },
    {
        "country": "Niger (+227)",
        "code": "227"
    },
    {
        "country": "Togo (+228)",
        "code": "228"
    },
    {
        "country": "Benin (+229)",
        "code": "229"
    },
    {
        "country": "Mauritius (+230)",
        "code": "230"
    },
    {
        "country": "Liberia (+231)",
        "code": "231"
    },
    {
        "country": "Sierra Leone (+232)",
        "code": "232"
    },
    {
        "country": "Ghana (+233)",
        "code": "233"
    },
    {
        "country": "Nigeria (+234)",
        "code": "234"
    },
    {
        "country": "Chad (+235)",
        "code": "235"
    },
    {
        "country": "Central African Republic (+236)",
        "code": "236"
    },
    {
        "country": "Cameroon (+237)",
        "code": "237"
    },
    {
        "country": "Cape Verde Islands (+238)",
        "code": "238"
    },
    {
        "country": "Sao Tome and Principe (+239)",
        "code": "239"
    },
    {
        "country": "Gabon (+241)",
        "code": "241"
    },
    {
        "country": "Congo, Democratic Republ (+243)",
        "code": "243"
    },
    {
        "country": "Angola (+244)",
        "code": "244"
    },
    {
        "country": "Guinea-Bissau (+245)",
        "code": "245"
    },
    {
        "country": "Seychelles (+248)",
        "code": "248"
    },
    {
        "country": "Sudan (+249)",
        "code": "249"
    },
    {
        "country": "Rwanda (+250)",
        "code": "250"
    },
    {
        "country": "Ethiopia (+251)",
        "code": "251"
    },
    {
        "country": "Somalia (+252)",
        "code": "252"
    },
    {
        "country": "Djibouti (+253)",
        "code": "253"
    },
    {
        "country": "Kenya (+254)",
        "code": "254"
    },
    {
        "country": "Tanzania (+255)",
        "code": "255"
    },
    {
        "country": "Uganda (+256)",
        "code": "256"
    },
    {
        "country": "Burundi (+257)",
        "code": "257"
    },
    {
        "country": "Mozambique (+258)",
        "code": "258"
    },
    {
        "country": "Zambia (+260)",
        "code": "260"
    },
    {
        "country": "Madagascar (+261)",
        "code": "261"
    },
    {
        "country": "Reunion (+262)",
        "code": "262"
    },
    {
        "country": "Zimbabwe (+263)",
        "code": "263"
    },
    {
        "country": "Namibia (+264)",
        "code": "264"
    },
    {
        "country": "Malawi (+265)",
        "code": "265"
    },
    {
        "country": "Lesotho (+266)",
        "code": "266"
    },
    {
        "country": "Botswana (+267)",
        "code": "267"
    },
    {
        "country": "Swaziland (+268)",
        "code": "268"
    },
    {
        "country": "Mayotte Island (+269)",
        "code": "269"
    },
    {
        "country": "Aruba (+297)",
        "code": "297"
    },
    {
        "country": "Faroe Islands (+298)",
        "code": "298"
    },
    {
        "country": "Greenland (+299)",
        "code": "299"
    },
    {
        "country": "Gibraltar (+350)",
        "code": "350"
    },
    {
        "country": "Portugal (+351)",
        "code": "351"
    },
    {
        "country": "Luxembourg (+352)",
        "code": "352"
    },
    {
        "country": "Ireland (+353)",
        "code": "353"
    },
    {
        "country": "Iceland (+354)",
        "code": "354"
    },
    {
        "country": "Albania (+355)",
        "code": "355"
    },
    {
        "country": "Malta (+356)",
        "code": "356"
    },
    {
        "country": "Cyprus (+357)",
        "code": "357"
    },
    {
        "country": "Finland (+358)",
        "code": "358"
    },
    {
        "country": "Bulgaria (+359)",
        "code": "359"
    },
    {
        "country": "Lithuania (+370)",
        "code": "370"
    },
    {
        "country": "Latvia (+371)",
        "code": "371"
    },
    {
        "country": "Estonia (+372)",
        "code": "372"
    },
    {
        "country": "Moldova (+373)",
        "code": "373"
    },
    {
        "country": "Armenia (+374)",
        "code": "374"
    },
    {
        "country": "Belarus (+375)",
        "code": "375"
    },
    {
        "country": "Andorra (+376)",
        "code": "376"
    },
    {
        "country": "Monaco (+377)",
        "code": "377"
    },
    {
        "country": "San Marino (+378)",
        "code": "378"
    },
    {
        "country": "Ukraine (+380)",
        "code": "380"
    },
    {
        "country": "Serbia (+381)",
        "code": "381"
    },
    {
        "country": "Montenegro (+382)",
        "code": "382"
    },
    {
        "country": "Croatia (+385)",
        "code": "385"
    },
    {
        "country": "Slovenia (+386)",
        "code": "386"
    },
    {
        "country": "Bosnia-Herzegovina (+387)",
        "code": "387"
    },
    {
        "country": "Macedonia (+389)",
        "code": "389"
    },
    {
        "country": "Czech Republic (+420)",
        "code": "420"
    },
    {
        "country": "Slovakia (+421)",
        "code": "421"
    },
    {
        "country": "Liechtenstein (+423)",
        "code": "423"
    },
    {
        "country": "Falkland Islands (+500)",
        "code": "500"
    },
    {
        "country": "Belize (+501)",
        "code": "501"
    },
    {
        "country": "Guatemala (+502)",
        "code": "502"
    },
    {
        "country": "El Salvador (+503)",
        "code": "503"
    },
    {
        "country": "Honduras (+504)",
        "code": "504"
    },
    {
        "country": "Nicaragua (+505)",
        "code": "505"
    },
    {
        "country": "Costa Rica (+506)",
        "code": "506"
    },
    {
        "country": "Panama (+507)",
        "code": "507"
    },
    {
        "country": "Haiti (+509)",
        "code": "509"
    },
    {
        "country": "Guadeloupe (+590)",
        "code": "590"
    },
    {
        "country": "Bolivia (+591)",
        "code": "591"
    },
    {
        "country": "Guyana (+592)",
        "code": "592"
    },
    {
        "country": "Ecuador (+593)",
        "code": "593"
    },
    {
        "country": "French Guiana (+594)",
        "code": "594"
    },
    {
        "country": "Paraguay (+595)",
        "code": "595"
    },
    {
        "country": "Martinique (+596)",
        "code": "596"
    },
    {
        "country": "Suriname (+597)",
        "code": "597"
    },
    {
        "country": "Uruguay (+598)",
        "code": "598"
    },
    {
        "country": "Netherlands Antilles (+599)",
        "code": "599"
    },
    {
        "country": "Timor-Leste (+670)",
        "code": "670"
    },
    {
        "country": "Guam (+1671)",
        "code": "1671"
    },
    {
        "country": "Brunei (+673)",
        "code": "673"
    },
    {
        "country": "Nauru (+674)",
        "code": "674"
    },
    {
        "country": "Papua New Guinea (+675)",
        "code": "675"
    },
    {
        "country": "Tonga (+676)",
        "code": "676"
    },
    {
        "country": "Solomon Islands (+677)",
        "code": "677"
    },
    {
        "country": "Vanuatu (+678)",
        "code": "678"
    },
    {
        "country": "Fiji Islands (+679)",
        "code": "679"
    },
    {
        "country": "Cook Islands (+682)",
        "code": "682"
    },
    {
        "country": "Samoa (+685)",
        "code": "685"
    },
    {
        "country": "New Caledonia (+687)",
        "code": "687"
    },
    {
        "country": "French Polynesia (+689)",
        "code": "689"
    },
    {
        "country": "Korea (+North) (+850)",
        "code": "850"
    },
    {
        "country": "HongKong (+852)",
        "code": "852"
    },
    {
        "country": "Macau (+853)",
        "code": "853"
    },
    {
        "country": "Cambodia (+855)",
        "code": "855"
    },
    {
        "country": "Laos (+856)",
        "code": "856"
    },
    {
        "country": "Bangladesh (+880)",
        "code": "880"
    },
    {
        "country": "International (+882)",
        "code": "882"
    },
    {
        "country": "Taiwan (+886)",
        "code": "886"
    },
    {
        "country": "Maldives (+960)",
        "code": "960"
    },
    {
        "country": "Lebanon (+961)",
        "code": "961"
    },
    {
        "country": "Jordan (+962)",
        "code": "962"
    },
    {
        "country": "Syria (+963)",
        "code": "963"
    },
    {
        "country": "Iraq (+964)",
        "code": "964"
    },
    {
        "country": "Kuwait (+965)",
        "code": "965"
    },
    {
        "country": "Saudi Arabia (+966)",
        "code": "966"
    },
    {
        "country": "Yemen (+967)",
        "code": "967"
    },
    {
        "country": "Oman (+968)",
        "code": "968"
    },
    {
        "country": "Palestine (+970)",
        "code": "970"
    },
    {
        "country": "United Arab Emirates (+971)",
        "code": "971"
    },
    {
        "country": "Israel (+972)",
        "code": "972"
    },
    {
        "country": "Bahrain (+973)",
        "code": "973"
    },
    {
        "country": "Qatar (+974)",
        "code": "974"
    },
    {
        "country": "Bhutan (+975)",
        "code": "975"
    },
    {
        "country": "Mongolia (+976)",
        "code": "976"
    },
    {
        "country": "Nepal (+977)",
        "code": "977"
    },
    {
        "country": "Tajikistan (+992)",
        "code": "992"
    },
    {
        "country": "Turkmenistan (+993)",
        "code": "993"
    },
    {
        "country": "Azerbaijan (+994)",
        "code": "994"
    },
    {
        "country": "Georgia (+995)",
        "code": "995"
    },
    {
        "country": "Kyrgyzstan (+996)",
        "code": "996"
    },
    {
        "country": "Uzbekistan (+998)",
        "code": "998"
    },
    {
        "country": "Bahamas (+1242)",
        "code": "1242"
    },
    {
        "country": "Barbados (+1246)",
        "code": "1246"
    },
    {
        "country": "Anguilla (+1264)",
        "code": "1264"
    },
    {
        "country": "Antigua and Barbuda (+1268)",
        "code": "1268"
    },
    {
        "country": "Virgin Islands, British (+1284)",
        "code": "1284"
    },
    {
        "country": "Cayman Islands (+1345)",
        "code": "1345"
    },
    {
        "country": "Bermuda (+1441)",
        "code": "1441"
    },
    {
        "country": "Grenada (+1473)",
        "code": "1473"
    },
    {
        "country": "Turks and Caicos Islands (+1649)",
        "code": "1649"
    },
    {
        "country": "Montserrat (+1664)",
        "code": "1664"
    },
    {
        "country": "Saint Lucia (+1758)",
        "code": "1758"
    },
    {
        "country": "Dominica (+1767)",
        "code": "1767"
    },
    {
        "country": "St. Vincent and The Gren (+1784)",
        "code": "1784"
    },
    {
        "country": "Puerto Rico (+1787)",
        "code": "1787"
    },
    {
        "country": "Dominican Republic (+1809)",
        "code": "1809"
    },
    {
        "country": "Dominican Republic2 (+1829)",
        "code": "1829"
    },
    {
        "country": "Dominican Republic3 (+1849)",
        "code": "1849"
    },
    {
        "country": "Trinidad and Tobago (+1868)",
        "code": "1868"
    },
    {
        "country": "Saint Kitts and Nevis (+1869)",
        "code": "1869"
    },
    {
        "country": "Jamaica (+1876)",
        "code": "1876"
    },
    {
        "country": "Congo (+242)",
        "code": "242"
    }
];
const $5f293882901e659f$var$countryCodeOptions = $5f293882901e659f$var$countryCodeList.map((countryCode)=>({
        value: countryCode.code,
        label: countryCode.country
    }));
var $5f293882901e659f$export$2e2bcd8739ae039 = $5f293882901e659f$var$countryCodeOptions;

});

parcelRegister("ifbAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e817db0d7663e1a5$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");
const $e817db0d7663e1a5$var$InputField = ({ className: className, name: name, value: value, type: type = "text", autoFocus: autoFocus, autoComplete: autoComplete, innerRef: innerRef, onChange: onChange, onBlur: onBlur, onFocus: onFocus, as: as, skipClasses: skipClasses, maxLength: maxLength, isDisabled: isDisabled = false })=>{
    const defaultClasses = [
        "flex",
        "w-full",
        "text-ch-gray-600",
        "py-2",
        "px-3",
        "rounded",
        "border",
        "border-ch-blue-alt-300",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "appearance-none",
        "focus:ring-2",
        "ring-ch-blue-alt-300"
    ];
    const propClasses = className ? className.split(" ") : [];
    const skipList = skipClasses ? skipClasses.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ];
    const filteredClasses = allClasses.filter((cls)=>!skipList.includes(cls)).join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
        innerRef: innerRef,
        autoFocus: autoFocus,
        type: type,
        name: name,
        id: name,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        value: value,
        autoComplete: autoComplete,
        className: filteredClasses,
        maxLength: maxLength,
        as: as,
        disabled: isDisabled
    });
};
var $e817db0d7663e1a5$export$2e2bcd8739ae039 = $e817db0d7663e1a5$var$InputField;

});

parcelRegister("7UN5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d68b525cf5138d2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $8d68b525cf5138d2$var$Label = (props)=>{
    const defaultClasses = [
        "block",
        "text-ch-gray-600",
        "mb-1"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    const required = props.required ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-ch-purple-500",
        children: "*"
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        htmlFor: props.name,
        className: allClasses,
        children: [
            props.children,
            required
        ]
    });
};
var $8d68b525cf5138d2$export$2e2bcd8739ae039 = $8d68b525cf5138d2$var$Label;

});

parcelRegister("4KSAX", function(module, exports) {

$parcel$export(module.exports, "useTranslation", () => $3765cebd031b52c0$export$9fc83ad70ead8663);

var $02Ztr = parcelRequire("02Ztr");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $x4LLZ = parcelRequire("x4LLZ");

var $hPEPQ = parcelRequire("hPEPQ");
function $3765cebd031b52c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3765cebd031b52c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3765cebd031b52c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3765cebd031b52c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3765cebd031b52c0$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $acw62.useContext)((0, $x4LLZ.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $x4LLZ.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $x4LLZ.ReportNamespaces)();
    if (!i18n) {
        (0, $hPEPQ.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $hPEPQ.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread({}, (0, $x4LLZ.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $hPEPQ.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $acw62.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    var isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $hPEPQ.loadNamespaces)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $hPEPQ.loadNamespaces)(i18n, namespaces, function() {
            resolve();
        });
    });
}

});
parcelRegister("x4LLZ", function(module, exports) {

$parcel$export(module.exports, "I18nContext", () => $0636c84fe4549f1f$export$5603ab5ced17ce64);
$parcel$export(module.exports, "getDefaults", () => $0636c84fe4549f1f$export$212bb2fc580a90a8);
$parcel$export(module.exports, "ReportNamespaces", () => $0636c84fe4549f1f$export$ea171b67e3820290);
$parcel$export(module.exports, "getI18n", () => $0636c84fe4549f1f$export$64af334f494c2f47);
$parcel$export(module.exports, "initReactI18next", () => $0636c84fe4549f1f$export$ae7e14d40d89f296);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $ixulw = parcelRequire("ixulw");
function $0636c84fe4549f1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0636c84fe4549f1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0636c84fe4549f1f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0636c84fe4549f1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0636c84fe4549f1f$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $ixulw.unescape)
};
var $0636c84fe4549f1f$var$i18nInstance;
var $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
function $0636c84fe4549f1f$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $0636c84fe4549f1f$var$defaultOptions = $0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, $0636c84fe4549f1f$var$defaultOptions), options);
}
function $0636c84fe4549f1f$export$212bb2fc580a90a8() {
    return $0636c84fe4549f1f$var$defaultOptions;
}
var $0636c84fe4549f1f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $0636c84fe4549f1f$export$a039134f2fc7e0(instance) {
    $0636c84fe4549f1f$var$i18nInstance = instance;
}
function $0636c84fe4549f1f$export$64af334f494c2f47() {
    return $0636c84fe4549f1f$var$i18nInstance;
}
var $0636c84fe4549f1f$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $0636c84fe4549f1f$export$2e2366488d12e20d(instance.options.react);
        $0636c84fe4549f1f$export$a039134f2fc7e0(instance);
    }
};
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    var i18n = $0636c84fe4549f1f$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("ixulw", function(module, exports) {

$parcel$export(module.exports, "unescape", () => $d7f2d92b0368699f$export$e8bacd2802a88316);
var $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $d7f2d92b0368699f$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $d7f2d92b0368699f$var$htmlEntities[m];
};
var $d7f2d92b0368699f$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);
};

});


parcelRegister("hPEPQ", function(module, exports) {

$parcel$export(module.exports, "warn", () => $cfb6e0167e0b350d$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "warnOnce", () => $cfb6e0167e0b350d$export$5b28268982f175ba);
$parcel$export(module.exports, "loadNamespaces", () => $cfb6e0167e0b350d$export$83be934b53fff43b);
$parcel$export(module.exports, "hasLoadedNamespace", () => $cfb6e0167e0b350d$export$93d9ee97c1ad3f31);
function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

});


parcelRegister("lCZwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fcd09c5a96349e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $jF0Xa = parcelRequire("jF0Xa");
const $a4fcd09c5a96349e$var$Button = (props)=>{
    let variant = props.variant;
    if (!variant) variant = (0, $jF0Xa.StyleVariants).GRAY;
    const defaultClasses = [
        "block",
        "text-white",
        "uppercase",
        "px-3 sm:px-4",
        "rounded-full"
    ];
    const chunkyClasses = [
        "font-semibold",
        "text-sm",
        "py-1.5 sm:py-2"
    ];
    const thinClasses = [
        "font-light",
        "py-1"
    ];
    let stateClasses = [
        `bg-${variant}-500`,
        `hover:bg-${variant}-600`
    ];
    if (props.customColour) stateClasses = [
        `bg-${props.customColour}-500`,
        `hover:bg-${props.customColour}-600`
    ];
    if (props.isDisabled) stateClasses = [
        "bg-ch-gray-450",
        "hover:bg-ch-gray-450",
        "cursor-not-allowed"
    ];
    const additionalClasses = props.isChunky ? chunkyClasses : thinClasses;
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...additionalClasses,
        ...propClasses,
        ...stateClasses
    ].join(" ");
    if (props.href) {
        if (props.external) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: props.href,
            target: "_blank",
            rel: "noreferrer",
            className: allClasses,
            children: props.children
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Link), {
            to: props.href,
            className: allClasses,
            children: props.children
        });
    }
    const buttonProps = {
        className: allClasses
    };
    buttonProps.type = props.isSubmit ? "submit" : "button";
    if (props.action) buttonProps.onClick = props.action;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        ...buttonProps,
        disabled: props.isDisabled,
        children: props.children
    });
};
var $a4fcd09c5a96349e$export$2e2bcd8739ae039 = $a4fcd09c5a96349e$var$Button;

});
parcelRegister("jF0Xa", function(module, exports) {

$parcel$export(module.exports, "SharedActionTypes", () => $ccbc99cf98225a2e$export$8b642afdbec82644);
$parcel$export(module.exports, "StyleVariants", () => $ccbc99cf98225a2e$export$9dc588862b70e27d);
$parcel$export(module.exports, "ColorPalette", () => $ccbc99cf98225a2e$export$de3ce00f2432aaff);
$parcel$export(module.exports, "defaultModalStyle", () => $ccbc99cf98225a2e$export$4701360ab7a041e9);
$parcel$export(module.exports, "bottomModalStyle", () => $ccbc99cf98225a2e$export$1c0be46eeb78dc64);
$parcel$export(module.exports, "smallModalStyle", () => $ccbc99cf98225a2e$export$6e030e8de560033b);
$parcel$export(module.exports, "dialogueModalStyle", () => $ccbc99cf98225a2e$export$3d5670924539d492);
$parcel$export(module.exports, "ResultsPerPageOptions", () => $ccbc99cf98225a2e$export$467ab7e2201aa47);
$parcel$export(module.exports, "defaultPerPage", () => $ccbc99cf98225a2e$export$30371e67659592d1);
$parcel$export(module.exports, "SharedChannelName", () => $ccbc99cf98225a2e$export$b0d3d31d424ed502);
$parcel$export(module.exports, "sharedCablePrefix", () => $ccbc99cf98225a2e$export$80806e0ad6cf6073);
$parcel$export(module.exports, "SharedCableActionTypes", () => $ccbc99cf98225a2e$export$f30ed0f361070d7c);

var $b5weT = parcelRequire("b5weT");
var $ccbc99cf98225a2e$export$8b642afdbec82644 = /*#__PURE__*/ function(SharedActionTypes) {
    SharedActionTypes["REHYDRATE"] = "persist/REHYDRATE";
    return SharedActionTypes;
}({});
var $ccbc99cf98225a2e$export$9dc588862b70e27d = /*#__PURE__*/ function(StyleVariants) {
    StyleVariants["GRAY"] = "ch-gray";
    StyleVariants["BLUE"] = "ch-blue";
    StyleVariants["BLUE_ALT"] = "ch-blue-alt";
    StyleVariants["ORANGE"] = "ch-orange";
    StyleVariants["PURPLE"] = "ch-purple";
    return StyleVariants;
}({});
var $ccbc99cf98225a2e$export$de3ce00f2432aaff = /*#__PURE__*/ function(ColorPalette) {
    ColorPalette["PURPLE"] = "#730B4D";
    ColorPalette["BLUE"] = "#13B7BF";
    ColorPalette["BLUE_ALT"] = "#006F74";
    ColorPalette["ORANGE"] = "#E2781F";
    ColorPalette["GREEN"] = "#98C465";
    ColorPalette["WHITE"] = "#FFFFFF";
    return ColorPalette;
}({});
const $ccbc99cf98225a2e$export$4701360ab7a041e9 = {
    overlay: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($b5weT))).defaultStyles.overlay,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        zIndex: 1000
    },
    content: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($b5weT))).defaultStyles.content,
        overflow: "hidden",
        borderRadius: "0.375rem",
        padding: "10px",
        width: "95vw",
        height: "95vh",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};
const $ccbc99cf98225a2e$export$1c0be46eeb78dc64 = {
    overlay: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($b5weT))).defaultStyles.overlay,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        zIndex: 900
    },
    content: {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($b5weT))).defaultStyles.content,
        overflow: "hidden",
        borderRadius: "0.375rem",
        padding: "10px",
        width: "95vw",
        height: "95vh",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};
const $ccbc99cf98225a2e$export$6e030e8de560033b = {
    ...$ccbc99cf98225a2e$export$4701360ab7a041e9,
    content: {
        inset: "30vh 6vw auto 6vw"
    }
};
const $ccbc99cf98225a2e$export$3d5670924539d492 = {
    ...$ccbc99cf98225a2e$export$4701360ab7a041e9,
    content: {
        ...$ccbc99cf98225a2e$export$4701360ab7a041e9.content,
        overflow: "hidden",
        borderRadius: "0.375rem",
        padding: "10px",
        width: "auto",
        maxWidth: "65vw",
        height: "auto",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};
var $ccbc99cf98225a2e$export$467ab7e2201aa47 = /*#__PURE__*/ function(ResultsPerPageOptions) {
    ResultsPerPageOptions["010"] = "10";
    ResultsPerPageOptions["025"] = "25";
    ResultsPerPageOptions["050"] = "50";
    ResultsPerPageOptions["0100"] = "100";
    return ResultsPerPageOptions;
}({});
const $ccbc99cf98225a2e$export$30371e67659592d1 = parseInt("25");
const $ccbc99cf98225a2e$export$b0d3d31d424ed502 = "SharedChannel";
const $ccbc99cf98225a2e$export$80806e0ad6cf6073 = "@@sharedCable/";
var $ccbc99cf98225a2e$export$f30ed0f361070d7c = /*#__PURE__*/ function(SharedCableActionTypes) {
    SharedCableActionTypes["UPDATE_USER_STATUS"] = "@@sharedCable/users/UPDATE_USER_STATUS";
    return SharedCableActionTypes;
}({});

});
parcelRegister("b5weT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2UcEv = parcelRequire("2UcEv");
var $81292b5b491156fc$var$_Modal2 = $81292b5b491156fc$var$_interopRequireDefault($2UcEv);
function $81292b5b491156fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $81292b5b491156fc$var$_Modal2.default;
module.exports = module.exports["default"];

});
parcelRegister("2UcEv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bodyOpenClassName = module.exports.portalClassName = undefined;
var $21daa036d62cc547$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $21daa036d62cc547$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $21daa036d62cc547$var$_react2 = $21daa036d62cc547$var$_interopRequireDefault($acw62);

var $1u0KT = parcelRequire("1u0KT");
var $21daa036d62cc547$var$_reactDom2 = $21daa036d62cc547$var$_interopRequireDefault($1u0KT);

var $c9Z8w = parcelRequire("c9Z8w");
var $21daa036d62cc547$var$_propTypes2 = $21daa036d62cc547$var$_interopRequireDefault($c9Z8w);

var $brdkq = parcelRequire("brdkq");
var $21daa036d62cc547$var$_ModalPortal2 = $21daa036d62cc547$var$_interopRequireDefault($brdkq);

var $gKo3c = parcelRequire("gKo3c");
var $21daa036d62cc547$var$ariaAppHider = $21daa036d62cc547$var$_interopRequireWildcard($gKo3c);

var $gHLoi = parcelRequire("gHLoi");
var $21daa036d62cc547$var$_safeHTMLElement2 = $21daa036d62cc547$var$_interopRequireDefault($gHLoi);

var $hdX8Q = parcelRequire("hdX8Q");
function $21daa036d62cc547$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $21daa036d62cc547$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21daa036d62cc547$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21daa036d62cc547$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $21daa036d62cc547$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $21daa036d62cc547$var$portalClassName = module.exports.portalClassName = "ReactModalPortal";
var $21daa036d62cc547$var$bodyOpenClassName = module.exports.bodyOpenClassName = "ReactModal__Body--open";
var $21daa036d62cc547$var$isReact16 = $gHLoi.canUseDOM && $21daa036d62cc547$var$_reactDom2.default.createPortal !== undefined;
var $21daa036d62cc547$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $21daa036d62cc547$var$getCreatePortal = function getCreatePortal() {
    return $21daa036d62cc547$var$isReact16 ? $21daa036d62cc547$var$_reactDom2.default.createPortal : $21daa036d62cc547$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $21daa036d62cc547$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $21daa036d62cc547$var$Modal = function(_Component) {
    $21daa036d62cc547$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $21daa036d62cc547$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $21daa036d62cc547$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$21daa036d62cc547$var$isReact16 && $21daa036d62cc547$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $21daa036d62cc547$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $21daa036d62cc547$var$getCreatePortal();
            var portal = createPortal(_this, $21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $21daa036d62cc547$var$_possibleConstructorReturn(_this, _ret);
    }
    $21daa036d62cc547$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$gHLoi.canUseDOM) return;
                if (!$21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $21daa036d62cc547$var$getParentElement(prevProps.parentSelector);
                var nextParent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$gHLoi.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$gHLoi.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$gHLoi.canUseDOM || !$21daa036d62cc547$var$isReact16) return null;
                if (!this.node && $21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                var createPortal = $21daa036d62cc547$var$getCreatePortal();
                return createPortal($21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $21daa036d62cc547$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($acw62.Component);
$21daa036d62cc547$var$Modal.propTypes = {
    isOpen: $21daa036d62cc547$var$_propTypes2.default.bool.isRequired,
    style: $21daa036d62cc547$var$_propTypes2.default.shape({
        content: $21daa036d62cc547$var$_propTypes2.default.object,
        overlay: $21daa036d62cc547$var$_propTypes2.default.object
    }),
    portalClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    bodyOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    htmlOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    className: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($gHLoi.SafeHTMLCollection),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($gHLoi.SafeNodeList),
        $21daa036d62cc547$var$_propTypes2.default.arrayOf($21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $21daa036d62cc547$var$_propTypes2.default.func,
    onRequestClose: $21daa036d62cc547$var$_propTypes2.default.func,
    closeTimeoutMS: $21daa036d62cc547$var$_propTypes2.default.number,
    ariaHideApp: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $21daa036d62cc547$var$_propTypes2.default.bool,
    preventScroll: $21daa036d62cc547$var$_propTypes2.default.bool,
    parentSelector: $21daa036d62cc547$var$_propTypes2.default.func,
    aria: $21daa036d62cc547$var$_propTypes2.default.object,
    data: $21daa036d62cc547$var$_propTypes2.default.object,
    role: $21daa036d62cc547$var$_propTypes2.default.string,
    contentLabel: $21daa036d62cc547$var$_propTypes2.default.string,
    shouldCloseOnEsc: $21daa036d62cc547$var$_propTypes2.default.bool,
    overlayRef: $21daa036d62cc547$var$_propTypes2.default.func,
    contentRef: $21daa036d62cc547$var$_propTypes2.default.func,
    id: $21daa036d62cc547$var$_propTypes2.default.string,
    overlayElement: $21daa036d62cc547$var$_propTypes2.default.func,
    contentElement: $21daa036d62cc547$var$_propTypes2.default.func
};
$21daa036d62cc547$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $21daa036d62cc547$var$portalClassName,
    bodyOpenClassName: $21daa036d62cc547$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, children);
    }
};
$21daa036d62cc547$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $hdX8Q.polyfill)($21daa036d62cc547$var$Modal);
module.exports.default = $21daa036d62cc547$var$Modal;

});
parcelRegister("brdkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $853c8e196b6200d7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $853c8e196b6200d7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $853c8e196b6200d7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $853c8e196b6200d7$var$_propTypes2 = $853c8e196b6200d7$var$_interopRequireDefault($c9Z8w);

var $6nu5B = parcelRequire("6nu5B");
var $853c8e196b6200d7$var$focusManager = $853c8e196b6200d7$var$_interopRequireWildcard($6nu5B);

var $bUn0I = parcelRequire("bUn0I");
var $853c8e196b6200d7$var$_scopeTab2 = $853c8e196b6200d7$var$_interopRequireDefault($bUn0I);

var $gKo3c = parcelRequire("gKo3c");
var $853c8e196b6200d7$var$ariaAppHider = $853c8e196b6200d7$var$_interopRequireWildcard($gKo3c);

var $kYIf9 = parcelRequire("kYIf9");
var $853c8e196b6200d7$var$classList = $853c8e196b6200d7$var$_interopRequireWildcard($kYIf9);

var $gHLoi = parcelRequire("gHLoi");
var $853c8e196b6200d7$var$_safeHTMLElement2 = $853c8e196b6200d7$var$_interopRequireDefault($gHLoi);

var $kczmP = parcelRequire("kczmP");
var $853c8e196b6200d7$var$_portalOpenInstances2 = $853c8e196b6200d7$var$_interopRequireDefault($kczmP);
parcelRequire("fmy2t");
function $853c8e196b6200d7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $853c8e196b6200d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $853c8e196b6200d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $853c8e196b6200d7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $853c8e196b6200d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $853c8e196b6200d7$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $853c8e196b6200d7$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $853c8e196b6200d7$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $853c8e196b6200d7$var$ariaHiddenInstances = 0;
var $853c8e196b6200d7$var$ModalPortal = function(_Component) {
    $853c8e196b6200d7$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $853c8e196b6200d7$var$_classCallCheck(this, ModalPortal);
        var _this = $853c8e196b6200d7$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $853c8e196b6200d7$var$ariaHiddenInstances > 0) {
                $853c8e196b6200d7$var$ariaHiddenInstances -= 1;
                if ($853c8e196b6200d7$var$ariaHiddenInstances === 0) $853c8e196b6200d7$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $853c8e196b6200d7$var$focusManager.returnFocus(_this.props.preventScroll);
                    $853c8e196b6200d7$var$focusManager.teardownScopedFocus();
                } else $853c8e196b6200d7$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $853c8e196b6200d7$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $853c8e196b6200d7$var$focusManager.setupScopedFocus(_this.node);
                    $853c8e196b6200d7$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($853c8e196b6200d7$var$isTabKey(event)) (0, $853c8e196b6200d7$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $853c8e196b6200d7$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $853c8e196b6200d7$var$_typeof(additional)) === "object" ? additional : {
                base: $853c8e196b6200d7$var$CLASS_NAMES[which],
                afterOpen: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $853c8e196b6200d7$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $853c8e196b6200d7$var$ariaHiddenInstances += 1;
                    $853c8e196b6200d7$var$ariaAppHider.hide(appElement);
                }
                $853c8e196b6200d7$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $853c8e196b6200d7$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $853c8e196b6200d7$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $853c8e196b6200d7$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $853c8e196b6200d7$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($acw62.Component);
$853c8e196b6200d7$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$853c8e196b6200d7$var$ModalPortal.propTypes = {
    isOpen: $853c8e196b6200d7$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    style: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    className: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    overlayClassName: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    parentSelector: $853c8e196b6200d7$var$_propTypes2.default.func,
    bodyOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    htmlOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    ariaHideApp: $853c8e196b6200d7$var$_propTypes2.default.bool,
    appElement: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($gHLoi.SafeHTMLCollection),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($gHLoi.SafeNodeList),
        $853c8e196b6200d7$var$_propTypes2.default.arrayOf($853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $853c8e196b6200d7$var$_propTypes2.default.func,
    onAfterClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    onRequestClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    closeTimeoutMS: $853c8e196b6200d7$var$_propTypes2.default.number,
    shouldFocusAfterRender: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $853c8e196b6200d7$var$_propTypes2.default.bool,
    preventScroll: $853c8e196b6200d7$var$_propTypes2.default.bool,
    role: $853c8e196b6200d7$var$_propTypes2.default.string,
    contentLabel: $853c8e196b6200d7$var$_propTypes2.default.string,
    aria: $853c8e196b6200d7$var$_propTypes2.default.object,
    data: $853c8e196b6200d7$var$_propTypes2.default.object,
    children: $853c8e196b6200d7$var$_propTypes2.default.node,
    shouldCloseOnEsc: $853c8e196b6200d7$var$_propTypes2.default.bool,
    overlayRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    id: $853c8e196b6200d7$var$_propTypes2.default.string,
    overlayElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    testId: $853c8e196b6200d7$var$_propTypes2.default.string
};
module.exports.default = $853c8e196b6200d7$var$ModalPortal;
module.exports = module.exports["default"];

});
parcelRegister("6nu5B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $4a4c3b2f05aea188$var$resetState;
module.exports.log = $4a4c3b2f05aea188$var$log;
module.exports.handleBlur = $4a4c3b2f05aea188$var$handleBlur;
module.exports.handleFocus = $4a4c3b2f05aea188$var$handleFocus;
module.exports.markForFocusLater = $4a4c3b2f05aea188$var$markForFocusLater;
module.exports.returnFocus = $4a4c3b2f05aea188$var$returnFocus;
module.exports.popWithoutFocus = $4a4c3b2f05aea188$var$popWithoutFocus;
module.exports.setupScopedFocus = $4a4c3b2f05aea188$var$setupScopedFocus;
module.exports.teardownScopedFocus = $4a4c3b2f05aea188$var$teardownScopedFocus;

var $iRreP = parcelRequire("iRreP");
var $4a4c3b2f05aea188$var$_tabbable2 = $4a4c3b2f05aea188$var$_interopRequireDefault($iRreP);
function $4a4c3b2f05aea188$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4a4c3b2f05aea188$var$focusLaterElements = [];
var $4a4c3b2f05aea188$var$modalElement = null;
var $4a4c3b2f05aea188$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $4a4c3b2f05aea188$var$resetState() {
    $4a4c3b2f05aea188$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $4a4c3b2f05aea188$var$log() {}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$handleBlur() {
    $4a4c3b2f05aea188$var$needToFocus = true;
}
function $4a4c3b2f05aea188$var$handleFocus() {
    if ($4a4c3b2f05aea188$var$needToFocus) {
        $4a4c3b2f05aea188$var$needToFocus = false;
        if (!$4a4c3b2f05aea188$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($4a4c3b2f05aea188$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $4a4c3b2f05aea188$var$_tabbable2.default)($4a4c3b2f05aea188$var$modalElement)[0] || $4a4c3b2f05aea188$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $4a4c3b2f05aea188$var$markForFocusLater() {
    $4a4c3b2f05aea188$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $4a4c3b2f05aea188$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($4a4c3b2f05aea188$var$focusLaterElements.length !== 0) {
            toFocus = $4a4c3b2f05aea188$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$popWithoutFocus() {
    $4a4c3b2f05aea188$var$focusLaterElements.length > 0 && $4a4c3b2f05aea188$var$focusLaterElements.pop();
}
function $4a4c3b2f05aea188$var$setupScopedFocus(element) {
    $4a4c3b2f05aea188$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $4a4c3b2f05aea188$var$handleBlur, false);
        document.addEventListener("focus", $4a4c3b2f05aea188$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.attachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}
function $4a4c3b2f05aea188$var$teardownScopedFocus() {
    $4a4c3b2f05aea188$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $4a4c3b2f05aea188$var$handleBlur);
        document.removeEventListener("focus", $4a4c3b2f05aea188$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.detachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}

});
parcelRegister("iRreP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbb24e2c8fdaedca$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $dbb24e2c8fdaedca$var$DISPLAY_NONE = "none";
var $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS = "contents";
var $dbb24e2c8fdaedca$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $dbb24e2c8fdaedca$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS && $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) : displayValue === $dbb24e2c8fdaedca$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $dbb24e2c8fdaedca$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($dbb24e2c8fdaedca$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $dbb24e2c8fdaedca$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $dbb24e2c8fdaedca$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $dbb24e2c8fdaedca$var$visible(element);
}
function $dbb24e2c8fdaedca$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $dbb24e2c8fdaedca$var$focusable(element, !isTabIndexNaN);
}
function $dbb24e2c8fdaedca$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $dbb24e2c8fdaedca$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($dbb24e2c8fdaedca$var$tabbable);
}
module.exports = module.exports["default"];

});


parcelRegister("bUn0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ab6c60fe3353573$var$scopeTab;

var $iRreP = parcelRequire("iRreP");
var $8ab6c60fe3353573$var$_tabbable2 = $8ab6c60fe3353573$var$_interopRequireDefault($iRreP);
function $8ab6c60fe3353573$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ab6c60fe3353573$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $8ab6c60fe3353573$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $8ab6c60fe3353573$var$scopeTab(node, event) {
    var tabbable = (0, $8ab6c60fe3353573$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $8ab6c60fe3353573$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = module.exports["default"];

});

parcelRegister("gKo3c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $c3139925b7b56b46$var$resetState;
module.exports.log = $c3139925b7b56b46$var$log;
module.exports.assertNodeList = $c3139925b7b56b46$var$assertNodeList;
module.exports.setElement = $c3139925b7b56b46$var$setElement;
module.exports.validateElement = $c3139925b7b56b46$var$validateElement;
module.exports.hide = $c3139925b7b56b46$var$hide;
module.exports.show = $c3139925b7b56b46$var$show;
module.exports.documentNotReadyOrSSRTesting = $c3139925b7b56b46$var$documentNotReadyOrSSRTesting;

var $kg9aN = parcelRequire("kg9aN");
var $c3139925b7b56b46$var$_warning2 = $c3139925b7b56b46$var$_interopRequireDefault($kg9aN);

var $gHLoi = parcelRequire("gHLoi");
function $c3139925b7b56b46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c3139925b7b56b46$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $c3139925b7b56b46$var$resetState() {
    if ($c3139925b7b56b46$var$globalElement) {
        if ($c3139925b7b56b46$var$globalElement.removeAttribute) $c3139925b7b56b46$var$globalElement.removeAttribute("aria-hidden");
        else if ($c3139925b7b56b46$var$globalElement.length != null) $c3139925b7b56b46$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($c3139925b7b56b46$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $c3139925b7b56b46$var$globalElement = null;
}
/* istanbul ignore next */ function $c3139925b7b56b46$var$log() {
    var check;
}
/* eslint-enable no-console */ function $c3139925b7b56b46$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $c3139925b7b56b46$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $gHLoi.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $c3139925b7b56b46$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $c3139925b7b56b46$var$globalElement = useElement || $c3139925b7b56b46$var$globalElement;
    return $c3139925b7b56b46$var$globalElement;
}
function $c3139925b7b56b46$var$validateElement(appElement) {
    var el = appElement || $c3139925b7b56b46$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $c3139925b7b56b46$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $c3139925b7b56b46$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $c3139925b7b56b46$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $c3139925b7b56b46$var$documentNotReadyOrSSRTesting() {
    $c3139925b7b56b46$var$globalElement = null;
}

});
parcelRegister("kg9aN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $ebfc6adce9fdacf8$var$warning;

});

parcelRegister("gHLoi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canUseDOM = module.exports.SafeNodeList = module.exports.SafeHTMLCollection = undefined;

var $djCxr = parcelRequire("djCxr");
var $c2956c5113267bbb$var$_exenv2 = $c2956c5113267bbb$var$_interopRequireDefault($djCxr);
function $c2956c5113267bbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2956c5113267bbb$var$EE = $c2956c5113267bbb$var$_exenv2.default;
var $c2956c5113267bbb$var$SafeHTMLElement = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLElement : {};
var $c2956c5113267bbb$var$SafeHTMLCollection = module.exports.SafeHTMLCollection = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLCollection : {};
var $c2956c5113267bbb$var$SafeNodeList = module.exports.SafeNodeList = $c2956c5113267bbb$var$EE.canUseDOM ? window.NodeList : {};
var $c2956c5113267bbb$var$canUseDOM = module.exports.canUseDOM = $c2956c5113267bbb$var$EE.canUseDOM;
module.exports.default = $c2956c5113267bbb$var$SafeHTMLElement;

});
parcelRegister("djCxr", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});



parcelRegister("kYIf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $f45bbb0d96c30d54$var$resetState;
module.exports.log = $f45bbb0d96c30d54$var$log;
var $f45bbb0d96c30d54$var$htmlClassList = {};
var $f45bbb0d96c30d54$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $f45bbb0d96c30d54$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $f45bbb0d96c30d54$var$htmlClassList)$f45bbb0d96c30d54$var$removeClass(htmlElement, $f45bbb0d96c30d54$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $f45bbb0d96c30d54$var$docBodyClassList)$f45bbb0d96c30d54$var$removeClass(body, $f45bbb0d96c30d54$var$docBodyClassList[_cls]);
    $f45bbb0d96c30d54$var$htmlClassList = {};
    $f45bbb0d96c30d54$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $f45bbb0d96c30d54$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $f45bbb0d96c30d54$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$add = module.exports.add = function add(element, classString) {
    return $f45bbb0d96c30d54$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$remove = module.exports.remove = function remove(element, classString) {
    return $f45bbb0d96c30d54$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};

});

parcelRegister("kczmP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.log = $eb505cd0fca5b004$var$log;
module.exports.resetState = $eb505cd0fca5b004$var$resetState;
function $eb505cd0fca5b004$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $eb505cd0fca5b004$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $eb505cd0fca5b004$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $eb505cd0fca5b004$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($eb505cd0fca5b004$var$portalOpenInstances.openInstances.length);
    $eb505cd0fca5b004$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $eb505cd0fca5b004$var$resetState() {
    $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
}
/* eslint-enable no-console */ module.exports.default = $eb505cd0fca5b004$var$portalOpenInstances;

});

parcelRegister("fmy2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $b2f35082d0ec1256$var$resetState;
module.exports.log = $b2f35082d0ec1256$var$log;

var $kczmP = parcelRequire("kczmP");
var $b2f35082d0ec1256$var$_portalOpenInstances2 = $b2f35082d0ec1256$var$_interopRequireDefault($kczmP);
function $b2f35082d0ec1256$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $b2f35082d0ec1256$var$before = void 0, $b2f35082d0ec1256$var$after = void 0, $b2f35082d0ec1256$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $b2f35082d0ec1256$var$resetState() {
    var _arr = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $b2f35082d0ec1256$var$before = $b2f35082d0ec1256$var$after = null;
    $b2f35082d0ec1256$var$instances = [];
}
/* istanbul ignore next */ function $b2f35082d0ec1256$var$log() {
    console.log("bodyTrap ----------");
    console.log($b2f35082d0ec1256$var$instances.length);
    var _arr2 = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $b2f35082d0ec1256$var$focusContent() {
    if ($b2f35082d0ec1256$var$instances.length === 0) return;
    $b2f35082d0ec1256$var$instances[$b2f35082d0ec1256$var$instances.length - 1].focusContent();
}
function $b2f35082d0ec1256$var$bodyTrap(eventType, openInstances) {
    if (!$b2f35082d0ec1256$var$before && !$b2f35082d0ec1256$var$after) {
        $b2f35082d0ec1256$var$before = document.createElement("div");
        $b2f35082d0ec1256$var$before.setAttribute("data-react-modal-body-trap", "");
        $b2f35082d0ec1256$var$before.style.position = "absolute";
        $b2f35082d0ec1256$var$before.style.opacity = "0";
        $b2f35082d0ec1256$var$before.setAttribute("tabindex", "0");
        $b2f35082d0ec1256$var$before.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
        $b2f35082d0ec1256$var$after = $b2f35082d0ec1256$var$before.cloneNode();
        $b2f35082d0ec1256$var$after.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
    }
    $b2f35082d0ec1256$var$instances = openInstances;
    if ($b2f35082d0ec1256$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $b2f35082d0ec1256$var$before) document.body.insertBefore($b2f35082d0ec1256$var$before, document.body.firstChild);
        if (document.body.lastChild !== $b2f35082d0ec1256$var$after) document.body.appendChild($b2f35082d0ec1256$var$after);
    } else {
        // Remove focus trap
        if ($b2f35082d0ec1256$var$before.parentElement) $b2f35082d0ec1256$var$before.parentElement.removeChild($b2f35082d0ec1256$var$before);
        if ($b2f35082d0ec1256$var$after.parentElement) $b2f35082d0ec1256$var$after.parentElement.removeChild($b2f35082d0ec1256$var$after);
    }
}
$b2f35082d0ec1256$var$_portalOpenInstances2.default.subscribe($b2f35082d0ec1256$var$bodyTrap);

});






parcelRegister("5wPBK", function(module, exports) {

$parcel$export(module.exports, "translationFilenames", () => $c936d1efa211d805$export$ddb94e743d8abc7);
$parcel$export(module.exports, "default", () => $c936d1efa211d805$export$2e2bcd8739ae039);

var $8RAYl = parcelRequire("8RAYl");

var $8fx7t = parcelRequire("8fx7t");

var $5sT3m = parcelRequire("5sT3m");

var $x4LLZ = parcelRequire("x4LLZ");
const $c936d1efa211d805$export$d0d68bb9ed2c643d = [
    "en",
    "fr",
    "it",
    "es",
    "de",
    "zh",
    "ja",
    "nl"
];
const $c936d1efa211d805$export$ddb94e743d8abc7 = [
    "account",
    "admin",
    "asset",
    "case",
    "caseReport",
    "liveMeeting",
    "meeting",
    "notification",
    "shared",
    "user",
    "userMessage"
];
(0, $8RAYl.default).use((0, $8fx7t.default)).use((0, $5sT3m.default)).use((0, $x4LLZ.initReactI18next)).init({
    lng: $c936d1efa211d805$export$d0d68bb9ed2c643d[0],
    fallbackLng: $c936d1efa211d805$export$d0d68bb9ed2c643d[0],
    whitelist: $c936d1efa211d805$export$d0d68bb9ed2c643d,
    interpolation: {
        escapeValue: false
    },
    preload: [
        $c936d1efa211d805$export$d0d68bb9ed2c643d[0]
    ],
    react: {
        useSuspense: true
    }
});
var $c936d1efa211d805$export$2e2bcd8739ae039 = (0, $8RAYl.default);

});
parcelRegister("8fx7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $60196a4650e96cb1$export$2e2bcd8739ae039);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ] // cookieMinutes: 10,
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $6CZeq.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, $cHPF9.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';

});

parcelRegister("5sT3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3faa45b77b2a48ba$export$2e2bcd8739ae039);
//#region lib/utils.js
const $3faa45b77b2a48ba$var$arr = [];
$3faa45b77b2a48ba$var$arr.forEach;
$3faa45b77b2a48ba$var$arr.slice;
const $3faa45b77b2a48ba$var$UNSAFE_KEYS$1 = [
    "__proto__",
    "constructor",
    "prototype"
];
function $3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v) {
    if (typeof v !== "string") return false;
    if (v.length === 0 || v.length > 128) return false;
    if ($3faa45b77b2a48ba$var$UNSAFE_KEYS$1.indexOf(v) > -1) return false;
    if (v.indexOf("..") > -1) return false;
    if (v.indexOf("\\") > -1) return false;
    if (/[?#%:\s]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function $3faa45b77b2a48ba$var$isSafeLangUrlSegment(v) {
    if (!$3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf("/") > -1 || v.indexOf("@") > -1) return false;
    return true;
}
function $3faa45b77b2a48ba$var$isSafeNsUrlSegment(v) {
    if (!$3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf("//") > -1) return false;
    return true;
}
const $3faa45b77b2a48ba$var$SAFETY_CHECK_BY_KEY = {
    lng: $3faa45b77b2a48ba$var$isSafeLangUrlSegment,
    ns: $3faa45b77b2a48ba$var$isSafeNsUrlSegment
};
function $3faa45b77b2a48ba$var$sanitizeLogValue(v) {
    if (typeof v !== "string") return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, " ");
}
function $3faa45b77b2a48ba$var$redactUrlCredentials(u) {
    if (typeof u !== "string" || u.length === 0) return u;
    try {
        const parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = "";
            parsed.password = "";
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, "$1");
    }
}
function $3faa45b77b2a48ba$var$hasXMLHttpRequest() {
    return typeof XMLHttpRequest === "function" || typeof XMLHttpRequest === "object";
}
/**
* Determine whether the given `maybePromise` is a Promise.
*
* @param {*} maybePromise
*
* @returns {Boolean}
*/ function $3faa45b77b2a48ba$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
/**
* Convert any value to a Promise than will resolve to this value.
*
* @param {*} maybePromise
*
* @returns {Promise}
*/ function $3faa45b77b2a48ba$var$makePromise(maybePromise) {
    if ($3faa45b77b2a48ba$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
const $3faa45b77b2a48ba$var$interpolationRegexp = /\{\{(.+?)\}\}/g;
function $3faa45b77b2a48ba$var$interpolateUrl(str, data) {
    let unsafe = false;
    const result = str.replace($3faa45b77b2a48ba$var$interpolationRegexp, (match, key)=>{
        const k = key.trim();
        if ($3faa45b77b2a48ba$var$UNSAFE_KEYS$1.indexOf(k) > -1) return match;
        const value = data[k];
        if (value == null) return match;
        const check = $3faa45b77b2a48ba$var$SAFETY_CHECK_BY_KEY[k] || $3faa45b77b2a48ba$var$isSafeLangUrlSegment;
        const segments = String(value).split("+");
        for (const seg of segments)if (!check(seg)) {
            unsafe = true;
            return match;
        }
        return segments.join("+");
    });
    return unsafe ? null : result;
}
//#endregion
//#region lib/request.js
const $3faa45b77b2a48ba$var$g = typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : void 0;
let $3faa45b77b2a48ba$var$fetchApi;
if (typeof fetch === "function") $3faa45b77b2a48ba$var$fetchApi = fetch;
else if ($3faa45b77b2a48ba$var$g && typeof $3faa45b77b2a48ba$var$g.fetch === "function") $3faa45b77b2a48ba$var$fetchApi = $3faa45b77b2a48ba$var$g.fetch;
const $3faa45b77b2a48ba$var$XmlHttpRequestApi = $3faa45b77b2a48ba$var$hasXMLHttpRequest() && $3faa45b77b2a48ba$var$g ? $3faa45b77b2a48ba$var$g.XMLHttpRequest : void 0;
const $3faa45b77b2a48ba$var$ActiveXObjectApi = typeof ActiveXObject === "function" && $3faa45b77b2a48ba$var$g ? $3faa45b77b2a48ba$var$g.ActiveXObject : void 0;
const $3faa45b77b2a48ba$var$UNSAFE_KEYS = [
    "__proto__",
    "constructor",
    "prototype"
];
const $3faa45b77b2a48ba$var$addQueryString = (url, params)=>{
    if (params && typeof params === "object") {
        let queryString = "";
        for (const paramName of Object.keys(params)){
            if ($3faa45b77b2a48ba$var$UNSAFE_KEYS.indexOf(paramName) > -1) continue;
            queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        }
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
const $3faa45b77b2a48ba$var$fetchIt = (url, fetchOptions, callback, altFetch)=>{
    const resolver = (response)=>{
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then((data)=>{
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        const altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === "function") fetch(url, fetchOptions).then(resolver).catch(callback);
    else $3faa45b77b2a48ba$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
const $3faa45b77b2a48ba$var$requestWithFetch = (options, url, payload, callback)=>{
    if (options.queryStringParams) url = $3faa45b77b2a48ba$var$addQueryString(url, options.queryStringParams);
    const headers = {
        ...typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders
    };
    if (typeof window === "undefined" && typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && $parcel$global.process.versions && $parcel$global.process.versions.node) headers["User-Agent"] = `i18next-http-backend (node/${$parcel$global.process.version}; ${$parcel$global.process.platform} ${$parcel$global.process.arch})`;
    if (payload) headers["Content-Type"] = "application/json";
    const reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    const fetchOptions = {
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : void 0,
        headers: headers,
        ...options._omitFetchOptions ? {} : reqOptions
    };
    const altFetch = typeof options.alternateFetch === "function" && options.alternateFetch.length >= 1 ? options.alternateFetch : void 0;
    try {
        $3faa45b77b2a48ba$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach((opt)=>{
                delete fetchOptions[opt];
            });
            $3faa45b77b2a48ba$var$fetchIt(url, fetchOptions, callback, altFetch);
            options._omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
const $3faa45b77b2a48ba$var$requestWithXmlHttpRequest = (options, url, payload, callback)=>{
    if (payload && typeof payload === "object") payload = $3faa45b77b2a48ba$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $3faa45b77b2a48ba$var$addQueryString(url, options.queryStringParams);
    try {
        const x = $3faa45b77b2a48ba$var$XmlHttpRequestApi ? new $3faa45b77b2a48ba$var$XmlHttpRequestApi() : new $3faa45b77b2a48ba$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        let h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for (const i of Object.keys(h)){
            if ($3faa45b77b2a48ba$var$UNSAFE_KEYS.indexOf(i) > -1) continue;
            x.setRequestHeader(i, h[i]);
        }
        x.onreadystatechange = ()=>{
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
const $3faa45b77b2a48ba$var$request = (options, url, payload, callback)=>{
    if (typeof payload === "function") {
        callback = payload;
        payload = void 0;
    }
    callback = callback || (()=>{});
    if ($3faa45b77b2a48ba$var$fetchApi && url.indexOf("file:") !== 0) return $3faa45b77b2a48ba$var$requestWithFetch(options, url, payload, callback);
    if ($3faa45b77b2a48ba$var$hasXMLHttpRequest() || typeof ActiveXObject === "function") return $3faa45b77b2a48ba$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(/* @__PURE__ */ new Error("No fetch and no xhr implementation found!"));
};
//#endregion
//#region lib/index.js
const $3faa45b77b2a48ba$var$getDefaults = ()=>{
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        parse: (data)=>JSON.parse(data),
        stringify: JSON.stringify,
        parsePayload: (namespace, key, fallbackValue)=>({
                [key]: fallbackValue || ""
            }),
        parseLoadPayload: (languages, namespaces)=>void 0,
        request: $3faa45b77b2a48ba$var$request,
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = class {
    constructor(services, options = {}, allOptions = {}){
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    init(services, options = {}, allOptions = {}) {
        this.services = services;
        this.options = {
            ...$3faa45b77b2a48ba$var$getDefaults(),
            ...this.options || {},
            ...options
        };
        this.allOptions = allOptions;
        if (this.services && this.options.reloadInterval) {
            const timer = setInterval(()=>this.reload(), this.options.reloadInterval);
            if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
        }
    }
    readMulti(languages, namespaces, callback) {
        this._readAny(languages, languages, namespaces, namespaces, callback);
    }
    read(language, namespace, callback) {
        this._readAny([
            language
        ], language, [
            namespace
        ], namespace, callback);
    }
    _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
        let loadPath = this.options.loadPath;
        if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
        loadPath = $3faa45b77b2a48ba$var$makePromise(loadPath);
        loadPath.then((resolvedLoadPath)=>{
            if (!resolvedLoadPath) return callback(null, {});
            const url = $3faa45b77b2a48ba$var$interpolateUrl(resolvedLoadPath, {
                lng: languages.join("+"),
                ns: namespaces.join("+")
            });
            if (url == null) {
                const safeLngs = languages.map($3faa45b77b2a48ba$var$sanitizeLogValue).join(", ");
                const safeNss = namespaces.map($3faa45b77b2a48ba$var$sanitizeLogValue).join(", ");
                return callback(/* @__PURE__ */ new Error("i18next-http-backend: unsafe lng/ns value \u2014 refusing to build request URL for languages=[" + safeLngs + "] namespaces=[" + safeNss + "]"), false);
            }
            this.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
        });
    }
    loadUrl(url, callback, languages, namespaces) {
        const lng = typeof languages === "string" ? [
            languages
        ] : languages;
        const ns = typeof namespaces === "string" ? [
            namespaces
        ] : namespaces;
        const payload = this.options.parseLoadPayload(lng, ns);
        const safeUrl = $3faa45b77b2a48ba$var$sanitizeLogValue($3faa45b77b2a48ba$var$redactUrlCredentials(url));
        this.options.request(this.options, url, payload, (err, res)=>{
            if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + safeUrl + "; status code: " + res.status, true);
            if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + safeUrl + "; status code: " + res.status, false);
            if (!res && err && err.message) {
                const errorMessage = err.message.toLowerCase();
                if ([
                    "failed",
                    "fetch",
                    "network",
                    "load"
                ].find((term)=>errorMessage.indexOf(term) > -1)) return callback("failed loading " + safeUrl + ": " + $3faa45b77b2a48ba$var$sanitizeLogValue(err.message), true);
            }
            if (err) return callback(err, false);
            let ret, parseErr;
            try {
                if (typeof res.data === "string") ret = this.options.parse(res.data, languages, namespaces);
                else ret = res.data;
            } catch (e) {
                parseErr = "failed parsing " + safeUrl + " to json";
            }
            if (parseErr) return callback(parseErr, false);
            callback(null, ret);
        });
    }
    create(languages, namespace, key, fallbackValue, callback) {
        if (!this.options.addPath) return;
        if (typeof languages === "string") languages = [
            languages
        ];
        const payload = this.options.parsePayload(namespace, key, fallbackValue);
        let finished = 0;
        const dataArray = [];
        const resArray = [];
        languages.forEach((lng)=>{
            let addPath = this.options.addPath;
            if (typeof this.options.addPath === "function") addPath = this.options.addPath(lng, namespace);
            const url = $3faa45b77b2a48ba$var$interpolateUrl(addPath, {
                lng: lng,
                ns: namespace
            });
            if (url == null) {
                finished += 1;
                if (callback && finished === languages.length) callback(dataArray, resArray);
                return;
            }
            this.options.request(this.options, url, payload, (data, res)=>{
                finished += 1;
                dataArray.push(data);
                resArray.push(res);
                if (finished === languages.length) {
                    if (typeof callback === "function") callback(dataArray, resArray);
                }
            });
        });
    }
    reload() {
        const { backendConnector: backendConnector, languageUtils: languageUtils, logger: logger } = this.services;
        const currentLanguage = backendConnector.language;
        if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
        const toLoad = [];
        const append = (lng)=>{
            languageUtils.toResolveHierarchy(lng).forEach((l)=>{
                if (toLoad.indexOf(l) < 0) toLoad.push(l);
            });
        };
        append(currentLanguage);
        if (this.allOptions.preload) this.allOptions.preload.forEach((l)=>append(l));
        toLoad.forEach((lng)=>{
            this.allOptions.ns.forEach((ns)=>{
                backendConnector.read(lng, ns, "read", null, null, (err, data)=>{
                    if (err) logger.warn(`loading namespace ${ns} for language ${lng} failed`, err);
                    if (!err && data) logger.log(`loaded namespace ${ns} for language ${lng}`, data);
                    backendConnector.loaded(`${lng}|${ns}`, err, data);
                });
            });
        });
    }
};
$3faa45b77b2a48ba$export$2e2bcd8739ae039.type = "backend";

});


parcelRegister("eTqMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0458326c22ffbc0b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0458326c22ffbc0b$var$FieldError = (props)=>{
    const defaultClasses = [
        "flex",
        "text-ch-red-500",
        "text-sm",
        "mb-1"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    if (!props.isVisible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: allClasses,
        children: props.errorMessage
    });
};
var $0458326c22ffbc0b$export$2e2bcd8739ae039 = $0458326c22ffbc0b$var$FieldError;

});


parcelRegister("6941e", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60fe2ea90bbea46$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $4KSAX = parcelRequire("4KSAX");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $aEgqS = parcelRequire("aEgqS");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $ai857 = parcelRequire("ai857");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
const $d60fe2ea90bbea46$var$codeValidationSchema = ()=>{
    return $hDGtv.create().shape({
        code: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")).min(6)
    });
};
const $d60fe2ea90bbea46$var$SetupMfaTotpPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account",
        "shared"
    ]);
    const [qrCodeUrl, setQrCodeUrl] = (0, $acw62.useState)(null);
    const [imageLoaded, setImageLoaded] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const submitCode = (code, setSubmitting)=>{
        (0, $5s7Tw.default).post("/user/mfa/confirm_totp", {
            code: code
        }, (0, $1zizz.withAuthHeader)()).then(()=>{
            (0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).SETUP_MFA_TOTP_COMPLETE);
            dispatch((0, $ai857.fetchCurrentUserAction)());
        }).catch(()=>{
            setSubmitting(false);
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaInvalidCode",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (qrCodeUrl) return;
        (0, $5s7Tw.default).post("/user/mfa/qr_code", {
            user: props.phoneDetails
        }, (0, $1zizz.withAuthHeader)()).then((response)=>{
            setQrCodeUrl(response.data.qrCode);
        }).catch((error)=>{
            props.backToIntro();
            if (error.status == 400) dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaPhoneNumberAlreadyInUse",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
            else dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaErrorGettingQrCode",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        inputRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-3",
                children: t("mfaTotpSetupHeader")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-3",
                children: t("account:mfaTotp1OpenApp")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "",
                children: t("mfaTotp2ScanQrCode")
            }),
            qrCodeUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: qrCodeUrl,
                onLoad: ()=>setImageLoaded(true)
            }) : null,
            imageLoaded ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    code: ""
                },
                onSubmit: null,
                validationSchema: $d60fe2ea90bbea46$var$codeValidationSchema,
                validateOnMount: true,
                children: ({ values: values, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting, isValid: isValid, setSubmitting: setSubmitting })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col items-center leading-tight mb-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "code",
                                        className: "mb-3",
                                        children: t("mfaTotp3EnterCode")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "m-auto w-full md:w-1/3 mb-5",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            className: "text-xl text-center",
                                            innerRef: inputRef,
                                            autoComplete: "off",
                                            name: "code",
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "flex-row-reverse space-x-reverse space-x-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: !isValid || isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                                        action: ()=>{
                                            submitCode(values.code, setSubmitting);
                                        },
                                        children: t("submit")
                                    }, "2"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        action: props.backToIntro,
                                        children: t("back")
                                    }, "1")
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $d60fe2ea90bbea46$export$2e2bcd8739ae039 = $d60fe2ea90bbea46$var$SetupMfaTotpPage;

});
parcelRegister("5s7Tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $298c1e8d3173a741$export$2e2bcd8739ae039);
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $cg3B3 = parcelRequire("cg3B3");

var $3Ukkm = parcelRequire("3Ukkm");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $jSDfI = parcelRequire("jSDfI");
const $298c1e8d3173a741$var$API = (0, $7we3r.default).create({
    baseURL: "/api",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    },
    transformResponse: [
        ...(0, $7we3r.default).defaults.transformResponse,
        (data)=>(0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelizeKeys(data)
    ],
    transformRequest: [
        (data)=>{
            if (data instanceof FormData) return data;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(data);
        },
        ...(0, $7we3r.default).defaults.transformRequest
    ]
});
$298c1e8d3173a741$var$API.interceptors.response.use((response)=>{
    return response;
}, (error)=>{
    if (error.response.status === 401) {
        if (error.response.headers["www-authenticate"] && error.response.headers["www-authenticate"].match(/MFA required/)) {
            (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SETUP_MFA_INTRO);
            return Promise.reject(error);
        }
        (0, $jSDfI.clearSession)();
        (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SIGN_IN);
        return Promise.reject(error);
    }
    if (error.response.status === 451) {
        (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).TERMS);
        return new Promise(()=>{
        // doing this to prevent the error bubbling up and then showing a flash message eg meetings not found
        });
    }
    return new Promise((_, reject)=>{
        reject(error);
    });
});
(0, $cg3B3.default)($298c1e8d3173a741$var$API, {
    retries: 3,
    retryCondition: (error)=>{
        return error.response?.status == 429;
    }
});
var $298c1e8d3173a741$export$2e2bcd8739ae039 = $298c1e8d3173a741$var$API;

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $c319b2c832c2914a$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $c319b2c832c2914a$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $c319b2c832c2914a$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $c319b2c832c2914a$var$getPrototypeOf(obj);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $c319b2c832c2914a$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $c319b2c832c2914a$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $c319b2c832c2914a$var$getPrototypeOf(current);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) continue;
            if (!$c319b2c832c2914a$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
const $c319b2c832c2914a$var$isSet = $c319b2c832c2914a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($c319b2c832c2914a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                    $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    toSafeFlatObject: $c319b2c832c2914a$var$toSafeFlatObject,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $475Ki = parcelRequire("475Ki");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $gKvUL.default).getSafeProp(config, 'method') || (0, $gKvUL.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach((0, $475Ki.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $gKvUL.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $dlZEJ.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $gKvUL.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $gKvUL.default).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $gKvUL.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", () => $e6cbd383b18c9625$export$659081b45d03227d);
$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $5vpyF = parcelRequire("5vpyF");
'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $gKvUL.default).getSafeProp(options, name);
        return (0, $gKvUL.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $e6cbd383b18c9625$export$659081b45d03227d);
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $5vpyF.default) && (0, $5vpyF.default).isBufferAvailable()) return (0, $5vpyF.default).from(value);
            throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.', (0, $6HVMZ.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $6HVMZ.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $gKvUL.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "REDACTED", () => $4e2395edb77acf3a$export$6acd2efa8ac62a1b);
$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $4e2395edb77acf3a$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $gKvUL.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $gKvUL.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $gKvUL.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $bxxyx.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $gKvUL.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $gKvUL.default).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $4e2395edb77acf3a$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $4e2395edb77acf3a$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $4e2395edb77acf3a$var$stringifySafely(entry.message) : $4e2395edb77acf3a$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $gKvUL.default).isArray(error.errors) && error.errors.length) message = $4e2395edb77acf3a$var$aggregateErrorMessage(error);
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $gKvUL.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $gKvUL.default).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $gKvUL.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});
parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");

var $lnc0M = parcelRequire("lnc0M");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $lnc0M.sanitizeHeaderValue)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $866cce54f6bdfb0c$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $866cce54f6bdfb0c$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $866cce54f6bdfb0c$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $866cce54f6bdfb0c$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $866cce54f6bdfb0c$var$trimOWS(part.slice(0, equals));
        if (!$866cce54f6bdfb0c$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $866cce54f6bdfb0c$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $866cce54f6bdfb0c$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $gKvUL.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $gKvUL.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $gKvUL.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $866cce54f6bdfb0c$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $gKvUL.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $gKvUL.default).hasOwnProp($fc026bbf9ee156f1$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("lnc0M", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", () => $f8f5102fdfcbfec9$export$9e344cffce061a22);
$parcel$export(module.exports, "toByteStringHeaderObject", () => $f8f5102fdfcbfec9$export$c30c72bb7e677d54);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $gKvUL.default).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $gKvUL.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});




parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
const $5de878cd737ef277$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $5de878cd737ef277$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $5de878cd737ef277$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $5de878cd737ef277$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $5de878cd737ef277$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$5de878cd737ef277$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$5de878cd737ef277$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $5de878cd737ef277$var$syncHandlerEntries(this, this[$5de878cd737ef277$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $5de878cd737ef277$var$syncHandlerEntries(this, internals);
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = $5de878cd737ef277$var$countHandlers(this.handlers);
            }
        }
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $gKvUL.default).toSafeFlatObject(_config);
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from((0, $gKvUL.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");

var $475Ki = parcelRequire("475Ki");
'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $gKvUL.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach((0, $475Ki.default), (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $jOwpo = parcelRequire("jOwpo");
'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $jOwpo.DEFAULT_FORM_DATA_MAX_DEPTH);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $6HVMZ.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = (0, $gKvUL.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $gKvUL.default).hasOwnProp(target, name) || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});

parcelRegister("475Ki", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fec45dc063f0c4b$export$2e2bcd8739ae039);
'use strict';
const $2fec45dc063f0c4b$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $2fec45dc063f0c4b$export$2e2bcd8739ae039 = $2fec45dc063f0c4b$var$methodList;

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $6HVMZ.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $6T0Ji = parcelRequire("6T0Ji");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $lnc0M = parcelRequire("lnc0M");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $32jg5.default)((0, $6T0Ji.default)(_config.url)) || (0, $32jg5.default)((0, $g65xr.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach((0, $lnc0M.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && !(0, $g65xr.default).protocols.includes(protocol)) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $6HVMZ.default).ERR_BAD_REQUEST : (0, $6HVMZ.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("6T0Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $503871fd6eafbe9c$export$2e2bcd8739ae039);
'use strict';
const $503871fd6eafbe9c$var$urlParserControlCharacters = /[\t\n\r]/g;
function $503871fd6eafbe9c$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($503871fd6eafbe9c$var$urlParserControlCharacters, '');
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        if (!e || !(0, $gKvUL.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn, scheduler = (0, $gKvUL.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $lW6v2 = parcelRequire("lW6v2");

var $cbIsf = parcelRequire("cbIsf");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $lk5EI.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $gKvUL.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $gKvUL.default).getSafeProp(auth, 'username') || '';
        const password = (0, $gKvUL.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $gKvUL.default).isFormData(data)) {
        const getHeaders = (0, $gKvUL.default).getSafeProp(data, 'getHeaders');
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv || (0, $gKvUL.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $gKvUL.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $lW6v2.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        if ((0, $gKvUL.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $889er.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");

var $6T0Ji = parcelRequire("6T0Ji");
'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $598acbfafd2c63c5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $6HVMZ.REDACTED}`;
    });
}
function $598acbfafd2c63c5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $6HVMZ.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $6HVMZ.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$598acbfafd2c63c5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $6T0Ji.default)(url);
        if ($598acbfafd2c63c5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $6HVMZ.default)(`Invalid URL ${JSON.stringify($598acbfafd2c63c5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $6HVMZ.default).ERR_INVALID_URL, config);
    }
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $fE4ul.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
const $f85fda54cd977b19$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $gKvUL.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $gKvUL.default).isUndefined(transitional2)) {
            if ((0, $gKvUL.default).isPlainObject(transitional2)) {
                if ((0, $gKvUL.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $gKvUL.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $gKvUL.default).isPlainObject(transitional1) && (0, $gKvUL.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $gKvUL.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $gKvUL.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach($f85fda54cd977b19$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $gKvUL.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $gKvUL.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $gKvUL.default).hasOwnProp(config2, 'validateStatus') && (0, $gKvUL.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $gKvUL.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("lW6v2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff840e6c220d182f$export$2e2bcd8739ae039);
'use strict';
const $ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ff840e6c220d182f$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");

var $iKBwL = parcelRequire("iKBwL");

var $35BUy = parcelRequire("35BUy");

var $lnc0M = parcelRequire("lnc0M");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $gKvUL.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $gKvUL.default).global !== undefined && (0, $gKvUL.default).global !== null ? (0, $gKvUL.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $g65xr.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $eHGD2.default)(config);
        const hasMaxContentLength = (0, $gKvUL.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $gKvUL.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $gKvUL.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $6HVMZ.default)('Request body larger than maxBodyLength limit', (0, $6HVMZ.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $gKvUL.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $gKvUL.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $g65xr.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $iKBwL.default)(url);
                if (estimated > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $gKvUL.default).isReadableStream(data) || (0, $gKvUL.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $hhnAb.trackStream)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $6HVMZ.default)('Stream request bodies are not supported by the current fetch implementation', (0, $6HVMZ.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $gKvUL.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $35BUy.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $lnc0M.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $gKvUL.default).forEach($e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $bxxyx.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $6HVMZ.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $6HVMZ.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("iKBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $da69a2069c6136ea$export$2e2bcd8739ae039);
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
const $da69a2069c6136ea$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $da69a2069c6136ea$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $da69a2069c6136ea$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $da69a2069c6136ea$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $da69a2069c6136ea$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            code = $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 1)) * 16 + $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($da69a2069c6136ea$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$da69a2069c6136ea$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $da69a2069c6136ea$var$estimateBase64BufferAllocation(body);
    return $da69a2069c6136ea$var$base64Bytes(significant);
};
const $da69a2069c6136ea$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $da69a2069c6136ea$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes);
}
function $da69a2069c6136ea$export$1f39e64b554a246f(url) {
    return $da69a2069c6136ea$var$estimateDataURLBytes(url, $da69a2069c6136ea$var$estimateBase64BufferAllocation);
}

});

parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});


parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    if ($f919374d785e9fb8$var$HttpStatusCode[value] === undefined) $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("cg3B3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec9c4dd31c40890$export$2e2bcd8739ae039);

var $h9yIk = parcelRequire("h9yIk");
function $8ec9c4dd31c40890$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $8ec9c4dd31c40890$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $8ec9c4dd31c40890$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $8ec9c4dd31c40890$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $8ec9c4dd31c40890$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ec9c4dd31c40890$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ec9c4dd31c40890$var$ownKeys(Object(source), true).forEach(function(key) {
            $8ec9c4dd31c40890$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ec9c4dd31c40890$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ec9c4dd31c40890$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8ec9c4dd31c40890$export$76a88f7de6507443 = 'axios-retry';
function $8ec9c4dd31c40890$export$476aa014e2fd89d5(error) {
    var CODE_EXCLUDE_LIST = [
        'ERR_CANCELED',
        'ECONNABORTED'
    ];
    return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
    !CODE_EXCLUDE_LIST.includes(error.code) && // Prevents retrying timed out & cancelled requests
    (0, (/*@__PURE__*/$parcel$interopDefault($h9yIk)))(error) // Prevents retrying unsafe errors
    ;
}
var $8ec9c4dd31c40890$var$SAFE_HTTP_METHODS = [
    'get',
    'head',
    'options'
];
var $8ec9c4dd31c40890$var$IDEMPOTENT_HTTP_METHODS = $8ec9c4dd31c40890$var$SAFE_HTTP_METHODS.concat([
    'put',
    'delete'
]);
function $8ec9c4dd31c40890$export$5f1dc21fa925930b(error) {
    return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
function $8ec9c4dd31c40890$export$693cf906fd8817e5(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $8ec9c4dd31c40890$export$5f1dc21fa925930b(error) && $8ec9c4dd31c40890$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $8ec9c4dd31c40890$export$d26799ad4978234d(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $8ec9c4dd31c40890$export$5f1dc21fa925930b(error) && $8ec9c4dd31c40890$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $8ec9c4dd31c40890$export$606bf0a2b170eb2(error) {
    return $8ec9c4dd31c40890$export$476aa014e2fd89d5(error) || $8ec9c4dd31c40890$export$d26799ad4978234d(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */ function $8ec9c4dd31c40890$var$noDelay() {
    return 0;
}
function $8ec9c4dd31c40890$export$ce2bf54576c66713() {
    var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var error = arguments.length > 1 ? arguments[1] : undefined;
    var delayFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var delay = Math.pow(2, retryNumber) * delayFactor;
    var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
var $8ec9c4dd31c40890$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $8ec9c4dd31c40890$export$606bf0a2b170eb2,
    retryDelay: $8ec9c4dd31c40890$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{}
};
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {IAxiosRetryConfig} defaultOptions
 * @return {IAxiosRetryConfigExtended}
 */ function $8ec9c4dd31c40890$var$getRequestOptions(config, defaultOptions) {
    return $8ec9c4dd31c40890$var$_objectSpread($8ec9c4dd31c40890$var$_objectSpread($8ec9c4dd31c40890$var$_objectSpread({}, $8ec9c4dd31c40890$export$93ca5d3f8675ae4c), defaultOptions), config[$8ec9c4dd31c40890$export$76a88f7de6507443]);
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @param  {IAxiosRetryConfig} defaultOptions
 * @return {IAxiosRetryConfigExtended}
 */ function $8ec9c4dd31c40890$var$getCurrentState(config, defaultOptions) {
    var currentState = $8ec9c4dd31c40890$var$getRequestOptions(config, defaultOptions);
    currentState.retryCount = currentState.retryCount || 0;
    config[$8ec9c4dd31c40890$export$76a88f7de6507443] = currentState;
    return currentState;
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */ function $8ec9c4dd31c40890$var$fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) delete config.agent;
    if (axios.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axios.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
/**
 * Checks retryCondition if request can be retried. Handles it's returning value or Promise.
 * @param  {IAxiosRetryConfigExtended} currentState
 * @param  {Error} error
 * @return {Promise<boolean>}
 */ function $8ec9c4dd31c40890$var$shouldRetry(_x, _x2) {
    return $8ec9c4dd31c40890$var$_shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 * @param {Function} [defaultOptions.onRetry=()=>{}]
 *        A function to get notified when a retry occurs
 * @return {{ requestInterceptorId: number, responseInterceptorId: number }}
 *        The ids of the interceptors added to the request and to the response (so they can be ejected at a later time)
 */ function $8ec9c4dd31c40890$var$_shouldRetry() {
    $8ec9c4dd31c40890$var$_shouldRetry = $8ec9c4dd31c40890$var$_asyncToGenerator(function*(currentState, error) {
        var { retries: retries, retryCondition: retryCondition } = currentState;
        var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise
        if (typeof shouldRetryOrPromise === 'object') try {
            var shouldRetryPromiseResult = yield shouldRetryOrPromise; // keep return true unless shouldRetryPromiseResult return false for compatibility
            return shouldRetryPromiseResult !== false;
        } catch (_err) {
            return false;
        }
        return shouldRetryOrPromise;
    });
    return $8ec9c4dd31c40890$var$_shouldRetry.apply(this, arguments);
}
function $8ec9c4dd31c40890$export$2e2bcd8739ae039(axios, defaultOptions) {
    var requestInterceptorId = axios.interceptors.request.use((config)=>{
        var currentState = $8ec9c4dd31c40890$var$getCurrentState(config, defaultOptions);
        currentState.lastRequestTime = Date.now();
        return config;
    });
    var responseInterceptorId = axios.interceptors.response.use(null, /*#__PURE__*/ function() {
        var _ref = $8ec9c4dd31c40890$var$_asyncToGenerator(function*(error) {
            var { config: config } = error; // If we have no information to retry the request
            if (!config) return Promise.reject(error);
            var currentState = $8ec9c4dd31c40890$var$getCurrentState(config, defaultOptions);
            if (yield $8ec9c4dd31c40890$var$shouldRetry(currentState, error)) {
                currentState.retryCount += 1;
                var { retryDelay: retryDelay, shouldResetTimeout: shouldResetTimeout, onRetry: onRetry } = currentState;
                var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
                // with circular structures: https://github.com/mzabriskie/axios/issues/370
                $8ec9c4dd31c40890$var$fixConfig(axios, config);
                if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                    var lastRequestDuration = Date.now() - currentState.lastRequestTime;
                    var timeout = config.timeout - lastRequestDuration - delay;
                    if (timeout <= 0) return Promise.reject(error);
                    config.timeout = timeout;
                }
                config.transformRequest = [
                    (data)=>data
                ];
                yield onRetry(currentState.retryCount, error, config);
                return new Promise((resolve)=>setTimeout(()=>resolve(axios(config)), delay));
            }
            return Promise.reject(error);
        });
        return function(_x3) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
} // Compatibility with CommonJS
$8ec9c4dd31c40890$export$2e2bcd8739ae039.isNetworkError = $8ec9c4dd31c40890$export$476aa014e2fd89d5;
$8ec9c4dd31c40890$export$2e2bcd8739ae039.isSafeRequestError = $8ec9c4dd31c40890$export$693cf906fd8817e5;
$8ec9c4dd31c40890$export$2e2bcd8739ae039.isIdempotentRequestError = $8ec9c4dd31c40890$export$d26799ad4978234d;
$8ec9c4dd31c40890$export$2e2bcd8739ae039.isNetworkOrIdempotentRequestError = $8ec9c4dd31c40890$export$606bf0a2b170eb2;
$8ec9c4dd31c40890$export$2e2bcd8739ae039.exponentialDelay = $8ec9c4dd31c40890$export$ce2bf54576c66713;
$8ec9c4dd31c40890$export$2e2bcd8739ae039.isRetryableError = $8ec9c4dd31c40890$export$5f1dc21fa925930b;

});
parcelRegister("h9yIk", function(module, exports) {
'use strict';
const $c7ce3462bc4e6bd2$var$denyList = new Set([
    'ENOTFOUND',
    'ENETUNREACH',
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    'UNABLE_TO_GET_ISSUER_CERT',
    'UNABLE_TO_GET_CRL',
    'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
    'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
    'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
    'CERT_SIGNATURE_FAILURE',
    'CRL_SIGNATURE_FAILURE',
    'CERT_NOT_YET_VALID',
    'CERT_HAS_EXPIRED',
    'CRL_NOT_YET_VALID',
    'CRL_HAS_EXPIRED',
    'ERROR_IN_CERT_NOT_BEFORE_FIELD',
    'ERROR_IN_CERT_NOT_AFTER_FIELD',
    'ERROR_IN_CRL_LAST_UPDATE_FIELD',
    'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
    'OUT_OF_MEM',
    'DEPTH_ZERO_SELF_SIGNED_CERT',
    'SELF_SIGNED_CERT_IN_CHAIN',
    'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
    'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
    'CERT_CHAIN_TOO_LONG',
    'CERT_REVOKED',
    'INVALID_CA',
    'PATH_LENGTH_EXCEEDED',
    'INVALID_PURPOSE',
    'CERT_UNTRUSTED',
    'CERT_REJECTED',
    'HOSTNAME_MISMATCH'
]);
// TODO: Use `error?.code` when targeting Node.js 14
module.exports = (error)=>!$c7ce3462bc4e6bd2$var$denyList.has(error && error.code);

});


parcelRegister("3Ukkm", function(module, exports) {
// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
(function(global) {
    var _processKeys = function(convert, obj, options) {
        if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) return obj;
        var output, i = 0, l = 0;
        if (_isArray(obj)) {
            output = [];
            for(l = obj.length; i < l; i++)output.push(_processKeys(convert, obj[i], options));
        } else {
            output = {};
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
        return output;
    };
    // String conversion methods
    var separateWords = function(string, options) {
        options = options || {};
        var separator = options.separator || '_';
        var split = options.split || /(?=[A-Z])/;
        return string.split(split).join(separator);
    };
    var camelize = function(string) {
        if (_isNumerical(string)) return string;
        string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
            return chr ? chr.toUpperCase() : '';
        });
        // Ensure 1st char is always lowercase
        return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function(string) {
        var camelized = camelize(string);
        // Ensure 1st char is always uppercase
        return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function(string, options) {
        return separateWords(string, options).toLowerCase();
    };
    // Utilities
    // Taken from Underscore.js
    var toString = Object.prototype.toString;
    var _isFunction = function(obj) {
        return typeof obj === 'function';
    };
    var _isObject = function(obj) {
        return obj === Object(obj);
    };
    var _isArray = function(obj) {
        return toString.call(obj) == '[object Array]';
    };
    var _isDate = function(obj) {
        return toString.call(obj) == '[object Date]';
    };
    var _isRegExp = function(obj) {
        return toString.call(obj) == '[object RegExp]';
    };
    var _isBoolean = function(obj) {
        return toString.call(obj) == '[object Boolean]';
    };
    // Performant way to determine if obj coerces to a number
    var _isNumerical = function(obj) {
        obj = obj - 0;
        return obj === obj;
    };
    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function(convert, options) {
        var callback = options && 'process' in options ? options.process : options;
        if (typeof callback !== 'function') return convert;
        return function(string, options) {
            return callback(string, convert, options);
        };
    };
    var humps = {
        camelize: camelize,
        decamelize: decamelize,
        pascalize: pascalize,
        depascalize: decamelize,
        camelizeKeys: function(object, options) {
            return _processKeys(_processor(camelize, options), object);
        },
        decamelizeKeys: function(object, options) {
            return _processKeys(_processor(decamelize, options), object, options);
        },
        pascalizeKeys: function(object, options) {
            return _processKeys(_processor(pascalize, options), object);
        },
        depascalizeKeys: function() {
            return this.decamelizeKeys.apply(this, arguments);
        }
    };
    if (typeof define === 'function' && define.amd) define(humps);
    else if (module.exports) module.exports = humps;
    else global.humps = humps;
})(module.exports);

});

parcelRegister("jSDfI", function(module, exports) {

$parcel$export(module.exports, "loadSession", () => $a4f9b4c7940038b5$export$fa0b40e553fd7792);
$parcel$export(module.exports, "getSession", () => $a4f9b4c7940038b5$export$12151e9ef3722552);
$parcel$export(module.exports, "setOAuthIdToken", () => $a4f9b4c7940038b5$export$71249819fa1108e6);
$parcel$export(module.exports, "setSession", () => $a4f9b4c7940038b5$export$b94982631f8f9752);
$parcel$export(module.exports, "clearSession", () => $a4f9b4c7940038b5$export$7809a8af6f3e4c63);
const $a4f9b4c7940038b5$var$TOKEN_KEY_NAME = "session_token";
const $a4f9b4c7940038b5$var$EMAIL_KEY_NAME = "session_key";
const $a4f9b4c7940038b5$var$ID_KEY_NAME = "session_user_id";
const $a4f9b4c7940038b5$var$OAUTH_ID_TOKEN_KEY_NAME = "oauth_id_token";
const $a4f9b4c7940038b5$var$MFA_CLIENT_ID = "client_id";
function $a4f9b4c7940038b5$var$generateSecureToken(length = 16) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return [
        ...array
    ].map((x)=>chars[x % chars.length]).join("");
}
const $a4f9b4c7940038b5$export$fa0b40e553fd7792 = ()=>{
    try {
        const session = $a4f9b4c7940038b5$export$12151e9ef3722552();
        if (!session.token || !session.userId) return {};
        return {
            userSession: {
                id: session.userId,
                apiToken: session.token
            }
        };
    } catch (err) {
        console.error("there was an issue with the session", err);
        return {};
    }
};
const $a4f9b4c7940038b5$export$71249819fa1108e6 = (token)=>{
    $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$OAUTH_ID_TOKEN_KEY_NAME, token);
};
const $a4f9b4c7940038b5$export$b94982631f8f9752 = (token, id, email)=>{
    $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$TOKEN_KEY_NAME, token);
    $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$EMAIL_KEY_NAME, email);
    $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$ID_KEY_NAME, id);
    if ($a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$MFA_CLIENT_ID) == null) $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$MFA_CLIENT_ID, $a4f9b4c7940038b5$var$generateSecureToken(32));
};
const $a4f9b4c7940038b5$export$12151e9ef3722552 = ()=>{
    if ($a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$MFA_CLIENT_ID) == null) $a4f9b4c7940038b5$var$setItem($a4f9b4c7940038b5$var$MFA_CLIENT_ID, $a4f9b4c7940038b5$var$generateSecureToken(32));
    return {
        token: $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$TOKEN_KEY_NAME),
        email: $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$EMAIL_KEY_NAME),
        userId: $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$ID_KEY_NAME),
        oauthIdToken: $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$OAUTH_ID_TOKEN_KEY_NAME),
        clientId: $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$MFA_CLIENT_ID)
    };
};
const $a4f9b4c7940038b5$export$257b2d10b709d8ef = ()=>{
    return $a4f9b4c7940038b5$var$getItem($a4f9b4c7940038b5$var$TOKEN_KEY_NAME);
};
const $a4f9b4c7940038b5$export$3f3434baf5a5c9c = ()=>{
    return localStorage.getItem($a4f9b4c7940038b5$var$TOKEN_KEY_NAME);
};
const $a4f9b4c7940038b5$export$7809a8af6f3e4c63 = ()=>{
    localStorage.removeItem($a4f9b4c7940038b5$var$TOKEN_KEY_NAME);
    localStorage.removeItem($a4f9b4c7940038b5$var$EMAIL_KEY_NAME);
    localStorage.removeItem($a4f9b4c7940038b5$var$ID_KEY_NAME);
    localStorage.removeItem($a4f9b4c7940038b5$var$OAUTH_ID_TOKEN_KEY_NAME);
// NOTE: DO NOT CLEAR THE CLIENT ID HERE
};
const $a4f9b4c7940038b5$var$setItem = (key, value)=>localStorage.setItem(key, value);
const $a4f9b4c7940038b5$var$getItem = (key)=>localStorage.getItem(key);

});


parcelRegister("1zizz", function(module, exports) {

$parcel$export(module.exports, "withAuthHeader", () => $bba17edb49bf96b5$export$3e353ab815f7d91f);

var $jSDfI = parcelRequire("jSDfI");
const $bba17edb49bf96b5$export$3e353ab815f7d91f = ()=>{
    const { token: token, email: email, oauthIdToken: oauthIdToken, clientId: clientId } = (0, $jSDfI.getSession)();
    if (token) {
        const headers = {
            "X-USER-TOKEN": `${token}`,
            "X-USER-EMAIL": `${email}`,
            "X-CLIENT-ID": `${clientId}`
        };
        return {
            headers: headers
        };
    }
    if (!token && oauthIdToken) {
        const headers = {
            "Authorization": `Bearer ${oauthIdToken}`
        };
        return {
            headers: headers
        };
    }
    return {
        headers: {
            "X-CLIENT-ID": `${clientId}`
        }
    };
};

});

parcelRegister("04A9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f80ce00833b822$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
const $22f80ce00833b822$var$Buttons = (props)=>{
    const defaultClasses = [
        "flex",
        "flex-wrap",
        "flex-1",
        "justify-center"
    ];
    if (props.reverse) defaultClasses.push("flex-row-reverse");
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: allClasses,
        children: props.buttons.map((button, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-2", {
                    "ml-2": index !== 0
                }),
                children: button
            }, index);
        })
    });
};
var $22f80ce00833b822$export$2e2bcd8739ae039 = $22f80ce00833b822$var$Buttons;

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});


parcelRegister("aEgqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2b7ec1a39000cc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $5f2b7ec1a39000cc$var$LoadingSpinner = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex 1 p-10 justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                display: "block",
                margin: "auto"
            },
            width: "35px",
            height: "35px",
            viewBox: "0 0 100 100",
            preserveAspectRatio: "xMidYMid",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                stroke: "#13b7bf",
                strokeWidth: "10",
                r: "35",
                strokeDasharray: "164.93361431346415 56.97787143782138",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    repeatCount: "indefinite",
                    dur: "1s",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1"
                })
            })
        })
    });
};
var $5f2b7ec1a39000cc$export$2e2bcd8739ae039 = $5f2b7ec1a39000cc$var$LoadingSpinner;

});

parcelRegister("ai857", function(module, exports) {

$parcel$export(module.exports, "createUserAction", () => $bf82c0ad07925c20$export$949c4003b0e4372f);
$parcel$export(module.exports, "addUserToCurrentTenantAction", () => $bf82c0ad07925c20$export$283e2434c5ebe0db);
$parcel$export(module.exports, "fetchCurrentUserAction", () => $bf82c0ad07925c20$export$af3084fbc035f98);
$parcel$export(module.exports, "fetchUserAction", () => $bf82c0ad07925c20$export$8a2d55e93b6d36e4);
$parcel$export(module.exports, "updateUserAction", () => $bf82c0ad07925c20$export$c5828de22585d94);
$parcel$export(module.exports, "changePasswordAction", () => $bf82c0ad07925c20$export$d91d65c714abbcec);
$parcel$export(module.exports, "setTenantAction", () => $bf82c0ad07925c20$export$ee507eeba10d04aa);
$parcel$export(module.exports, "checkUserAction", () => $bf82c0ad07925c20$export$1d72811186db50f6);
$parcel$export(module.exports, "resetCheckUserAction", () => $bf82c0ad07925c20$export$3657ac60c3be74ac);
$parcel$export(module.exports, "fetchExternalAccountsAction", () => $bf82c0ad07925c20$export$1055f1368e91fd5e);
$parcel$export(module.exports, "createCaseGuestUser", () => $bf82c0ad07925c20$export$66a3f4c406f33ab4);
$parcel$export(module.exports, "createGuestUser", () => $bf82c0ad07925c20$export$59368a508f69e5d6);

var $8e5HJ = parcelRequire("8e5HJ");

var $6qYxq = parcelRequire("6qYxq");
const $bf82c0ad07925c20$export$949c4003b0e4372f = (user)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_PENDING,
        payload: user
    };
};
const $bf82c0ad07925c20$export$283e2434c5ebe0db = (userId, type)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).ADD_USER_TO_TENANT_ASYNC_PENDING,
        payload: {
            id: userId,
            type: type
        }
    };
};
const $bf82c0ad07925c20$export$af3084fbc035f98 = ()=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).FETCH_CURRENT_USER_ASYNC_PENDING
    };
};
const $bf82c0ad07925c20$export$8a2d55e93b6d36e4 = (userId)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_PENDING,
        payload: userId
    };
};
const $bf82c0ad07925c20$export$c5828de22585d94 = (userId, userData)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).UPDATE_USER_ASYNC_PENDING,
        payload: {
            id: userId,
            user: userData
        }
    };
};
const $bf82c0ad07925c20$export$d91d65c714abbcec = (userId, userData)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).CHANGE_PASSWORD_ASYNC_PENDING,
        payload: {
            id: userId,
            user: userData
        }
    };
};
const $bf82c0ad07925c20$export$ee507eeba10d04aa = (tenantId, path)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).SET_TENANT_ASYNC_PENDING,
        payload: {
            id: tenantId,
            path: path
        }
    };
};
const $bf82c0ad07925c20$export$1d72811186db50f6 = (userCheckData)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_PENDING,
        payload: {
            userCheckData: userCheckData
        }
    };
};
const $bf82c0ad07925c20$export$3657ac60c3be74ac = ()=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_RESET
    };
};
const $bf82c0ad07925c20$export$1055f1368e91fd5e = ()=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_PENDING
    };
};
const $bf82c0ad07925c20$export$66a3f4c406f33ab4 = (caseId, guestUserData)=>{
    return {
        type: (0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            guestUserData: guestUserData
        }
    };
};
const $bf82c0ad07925c20$export$59368a508f69e5d6 = (guestUserData)=>{
    return {
        type: (0, $8e5HJ.UserActionTypes).CREATE_GUEST_USER_ASYNC_PENDING,
        payload: {
            guestUserData: guestUserData
        }
    };
};

});
parcelRegister("8e5HJ", function(module, exports) {

$parcel$export(module.exports, "SignInType", () => $66b368ba5cdfdcb9$export$6799840c52aa9a6b);
$parcel$export(module.exports, "UserTitles", () => $66b368ba5cdfdcb9$export$f0f62e45fe7fc60a);
$parcel$export(module.exports, "UserCheckStatuses", () => $66b368ba5cdfdcb9$export$16a4a1a2f3b5da63);
$parcel$export(module.exports, "UserActionTypes", () => $66b368ba5cdfdcb9$export$8472e4796ef4c0c);
$parcel$export(module.exports, "UserChannelName", () => $66b368ba5cdfdcb9$export$6b10671bbecc2d63);
$parcel$export(module.exports, "userCablePrefix", () => $66b368ba5cdfdcb9$export$164322dd8925584d);
var $66b368ba5cdfdcb9$export$6799840c52aa9a6b = /*#__PURE__*/ function(SignInType) {
    SignInType["Local"] = "local";
    SignInType["NotFound"] = "not_found";
    SignInType["Oauth"] = "oauth";
    return SignInType;
}({});
var $66b368ba5cdfdcb9$export$f0f62e45fe7fc60a = /*#__PURE__*/ function(UserTitles) {
    UserTitles["Mr"] = "Mr";
    UserTitles["Mrs"] = "Mrs";
    UserTitles["Ms"] = "Ms";
    UserTitles["Miss"] = "Miss";
    UserTitles["Mx"] = "Mx";
    UserTitles["Dr"] = "Dr";
    UserTitles["Prof"] = "Prof";
    return UserTitles;
}({});
var $66b368ba5cdfdcb9$export$1dbdf8499aadc9ab = /*#__PURE__*/ function(UserGenders) {
    UserGenders["Unknown"] = "unknown";
    UserGenders["Unspecified"] = "unspecified";
    UserGenders["Male"] = "male";
    UserGenders["Female"] = "female";
    return UserGenders;
}({});
var $66b368ba5cdfdcb9$export$16a4a1a2f3b5da63 = /*#__PURE__*/ function(UserCheckStatuses) {
    UserCheckStatuses["Pending"] = "pending";
    UserCheckStatuses["Found"] = "found";
    UserCheckStatuses["Not_Found"] = "not_found";
    return UserCheckStatuses;
}({});
var $66b368ba5cdfdcb9$export$8472e4796ef4c0c = /*#__PURE__*/ function(UserActionTypes) {
    UserActionTypes["CREATE_USER_ASYNC_PENDING"] = "@@user/CREATE_USER_ASYNC_REQUEST";
    UserActionTypes["CREATE_USER_ASYNC_SUCCESS"] = "@@user/CREATE_USER_ASYNC_SUCCESS";
    UserActionTypes["CREATE_USER_ASYNC_ERROR"] = "@@user/CREATE_USER_ASYNC_ERROR";
    UserActionTypes["CREATE_GUEST_USER_ASYNC_PENDING"] = "@@user/CREATE_GUEST_USER_ASYNC_REQUEST";
    UserActionTypes["ADD_USER_TO_TENANT_ASYNC_PENDING"] = "@@user/ADD_USER_TO_TENANT_ASYNC_REQUEST";
    UserActionTypes["ADD_USER_TO_TENANT_ASYNC_SUCCESS"] = "@@user/ADD_USER_TO_TENANT_ASYNC_SUCCESS";
    UserActionTypes["ADD_USER_TO_TENANT_ASYNC_ERROR"] = "@@user/ADD_USER_TO_TENANT_ASYNC_ERROR";
    UserActionTypes["UPDATE_USER_ASYNC_PENDING"] = "@@user/UPDATE_USER_ASYNC_REQUEST";
    UserActionTypes["UPDATE_USER_ASYNC_SUCCESS"] = "@@user/UPDATE_USER_ASYNC_SUCCESS";
    UserActionTypes["UPDATE_USER_ASYNC_ERROR"] = "@@user/UPDATE_USER_ASYNC_ERROR";
    UserActionTypes["CHANGE_PASSWORD_ASYNC_PENDING"] = "@@user/CHANGE_PASSWORD_ASYNC_REQUEST";
    UserActionTypes["CHANGE_PASSWORD_ASYNC_SUCCESS"] = "@@user/CHANGE_PASSWORD_ASYNC_SUCCESS";
    UserActionTypes["CHANGE_PASSWORD_ASYNC_ERROR"] = "@@user/CHANGE_PASSWORD_ASYNC_ERROR";
    UserActionTypes["FETCH_USER_ASYNC_PENDING"] = "@@user/FETCH_USER_ASYNC_REQUEST";
    UserActionTypes["FETCH_USER_ASYNC_SUCCESS"] = "@@user/FETCH_USER_ASYNC_SUCCESS";
    UserActionTypes["FETCH_USER_ASYNC_ERROR"] = "@@user/FETCH_USER_ASYNC_ERROR";
    UserActionTypes["SET_TENANT_ASYNC_PENDING"] = "@@user/SET_TENANT_ASYNC_REQUEST";
    UserActionTypes["SET_TENANT_ASYNC_SUCCESS"] = "@@user/SET_TENANT_ASYNC_SUCCESS";
    UserActionTypes["SET_TENANT_ASYNC_ERROR"] = "@@user/SET_TENANT_ASYNC_ERROR";
    UserActionTypes["RESEND_INVITE_ASYNC_PENDING"] = "@@user/RESEND_INVITE_ASYNC_REQUEST";
    UserActionTypes["CLEAR_MFA_ASYNC_PENDING"] = "@@user/CLEAR_MFA_ASYNC_REQUEST";
    // FETCH_CURRENT_USER hooks back into tho FETCH_USER_ASYNC_SUCCESS events, as they return the same data
    // for that reason, there are no SUCCESS or ERROR actions
    UserActionTypes["FETCH_CURRENT_USER_ASYNC_PENDING"] = "@@user/FETCH_CURRENT_USER_ASYNC_REQUEST";
    UserActionTypes["CHECK_USER_ASYNC_RESET"] = "@@user/CHECK_USER_RESET";
    UserActionTypes["CHECK_USER_ASYNC_PENDING"] = "@@user/CHECK_USER_ASYNC_PENDING";
    UserActionTypes["CHECK_USER_ASYNC_FOUND"] = "@@user/CHECK_USER_ASYNC_FOUND";
    UserActionTypes["CHECK_USER_ASYNC_NOT_FOUND"] = "@@user/CHECK_USER_ASYNC_NOT_FOUND";
    UserActionTypes["FETCH_EXTERNAL_ACCOUNTS_ASYNC_PENDING"] = "@@user/FETCH_EXTERNAL_ACCOUNTS_ASYNC_REQUEST";
    UserActionTypes["FETCH_EXTERNAL_ACCOUNTS_ASYNC_SUCCESS"] = "@@user/FETCH_EXTERNAL_ACCOUNTS_ASYNC_SUCCESS";
    UserActionTypes["FETCH_EXTERNAL_ACCOUNTS_ASYNC_ERROR"] = "@@user/FETCH_EXTERNAL_ACCOUNTS_ASYNC_ERROR";
    return UserActionTypes;
}({});
const $66b368ba5cdfdcb9$export$6b10671bbecc2d63 = "UserChannel";
const $66b368ba5cdfdcb9$export$164322dd8925584d = "@@userCable/";

});

parcelRegister("6qYxq", function(module, exports) {

$parcel$export(module.exports, "CaseTypes", () => $4d41d473e1088650$export$bd5db7c02582e300);
$parcel$export(module.exports, "CaseActionTypes", () => $4d41d473e1088650$export$f5260385a2ba3674);
$parcel$export(module.exports, "CaseChannelName", () => $4d41d473e1088650$export$51b29a8c28957ba1);
$parcel$export(module.exports, "CaseCablePrefix", () => $4d41d473e1088650$export$800608dc1de1789f);
$parcel$export(module.exports, "CaseCableActionTypes", () => $4d41d473e1088650$export$7acfada73cffcf8a);
var $4d41d473e1088650$export$bd5db7c02582e300 = /*#__PURE__*/ function(CaseTypes) {
    CaseTypes["SuspectedCancer"] = "suspected_cancer";
    CaseTypes["Cancer"] = "cancer";
    CaseTypes["NonCancer"] = "non_cancer";
    return CaseTypes;
}({});
var $4d41d473e1088650$export$f5260385a2ba3674 = /*#__PURE__*/ function(CaseActionTypes) {
    CaseActionTypes["FETCH_CASE_ASYNC_PENDING"] = "@@case/FETCH_CASE_ASYNC_PENDING";
    CaseActionTypes["FETCH_CASE_ASYNC_SUCCESS"] = "@@case/FETCH_CASE_ASYNC_SUCCESS";
    CaseActionTypes["FETCH_CASE_ASYNC_ERROR"] = "@@case/FETCH_CASE_ASYNC_ERROR";
    CaseActionTypes["UPDATE_CASE_ASYNC_PENDING"] = "@@case/UPDATE_CASE_ASYNC_PENDING";
    CaseActionTypes["UPDATE_CASE_ASYNC_SUCCESS"] = "@@case/UPDATE_CASE_ASYNC_SUCCESS";
    CaseActionTypes["UPDATE_CASE_ASYNC_ERROR"] = "@@case/UPDATE_CASE_ASYNC_ERROR";
    CaseActionTypes["UPDATE_CASE_MEMBERS_ASYNC_PENDING"] = "@@case/UPDATE_CASE_MEMBERS_ASYNC_PENDING";
    CaseActionTypes["UPDATE_CASE_MEMBERS_ASYNC_SUCCESS"] = "@@case/UPDATE_CASE_MEMBERS_ASYNC_SUCCESS";
    CaseActionTypes["UPDATE_CASE_MEMBERS_ASYNC_ERROR"] = "@@case/UPDATE_CASE_MEMBERS_ASYNC_ERROR";
    CaseActionTypes["TOGGLE_CASE_LOCKED_ASYNC_PENDING"] = "@@case/TOGGLE_CASE_LOCKED_ASYNC_PENDING";
    CaseActionTypes["TOGGLE_CASE_LOCKED_ASYNC_SUCCESS"] = "@@case/TOGGLE_CASE_LOCKED_ASYNC_SUCCESS";
    CaseActionTypes["TOGGLE_CASE_LOCKED_ASYNC_ERROR"] = "@@case/TOGGLE_CASE_LOCKED_ASYNC_ERROR";
    CaseActionTypes["CREATE_CASE_GUEST_USER_ASYNC_PENDING"] = "@@case/CREATE_CASE_GUEST_USER_ASYNC_PENDING";
    CaseActionTypes["CREATE_CASE_GUEST_USER_ASYNC_SUCCESS"] = "@@case/CREATE_CASE_GUEST_USER_ASYNC_SUCCESS";
    CaseActionTypes["CREATE_CASE_GUEST_USER_ASYNC_ERROR"] = "@@case/CREATE_CASE_GUEST_USER_ASYNC_ERROR";
    return CaseActionTypes;
}({});
const $4d41d473e1088650$export$51b29a8c28957ba1 = "CaseChannel";
const $4d41d473e1088650$export$800608dc1de1789f = "@@caseCable/";
var $4d41d473e1088650$export$7acfada73cffcf8a = /*#__PURE__*/ function(CaseCableActionTypes) {
    CaseCableActionTypes["ASSETS_CHANGED"] = "@@caseCable/ASSETS_CHANGED";
    CaseCableActionTypes["MEMBERS_CHANGED"] = "@@caseCable/MEMBERS_CHANGED";
    return CaseCableActionTypes;
}({});

});


parcelRegister("arZQw", function(module, exports) {

$parcel$export(module.exports, "displayUserMessageAction", () => $691c87787d2dcbf3$export$71617d133c02d50f);
$parcel$export(module.exports, "markUserMessageRead", () => $691c87787d2dcbf3$export$4bd34f91ec130848);
$parcel$export(module.exports, "displayUserError", () => $691c87787d2dcbf3$export$3c3a9e4057b04704);
$parcel$export(module.exports, "displayUserSuccess", () => $691c87787d2dcbf3$export$147cbfb1e38371ca);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");

var $jiIfA = parcelRequire("jiIfA");
const $691c87787d2dcbf3$export$71617d133c02d50f = (userMessage)=>{
    return {
        type: (0, $jiIfA.UserMessageActionTypes).DISPLAY_USER_MESSAGE,
        payload: userMessage
    };
};
const $691c87787d2dcbf3$export$4bd34f91ec130848 = ()=>{
    return {
        type: (0, $jiIfA.UserMessageActionTypes).MARK_USER_MESSAGE_READ
    };
};
const $691c87787d2dcbf3$export$3c3a9e4057b04704 = (messageKey)=>{
    return (0, $k6WuE.Z)($691c87787d2dcbf3$export$71617d133c02d50f({
        messageKey: messageKey,
        type: (0, $jiIfA.UserMessageTypes).ERROR
    }));
};
const $691c87787d2dcbf3$export$147cbfb1e38371ca = (messageKey)=>{
    return (0, $k6WuE.Z)($691c87787d2dcbf3$export$71617d133c02d50f({
        messageKey: messageKey,
        type: (0, $jiIfA.UserMessageTypes).SUCCESS
    }));
};
const $691c87787d2dcbf3$export$8d0c19c5b835c3a4 = (messageKey)=>{
    return (0, $k6WuE.Z)($691c87787d2dcbf3$export$71617d133c02d50f({
        messageKey: messageKey,
        type: (0, $jiIfA.UserMessageTypes).MESSAGE
    }));
};

});
parcelRegister("jiIfA", function(module, exports) {

$parcel$export(module.exports, "UserMessageTypes", () => $ad71095b509d7002$export$e5ad6bff5e333374);
$parcel$export(module.exports, "UserMessageActionTypes", () => $ad71095b509d7002$export$58e371b565abd256);
var $ad71095b509d7002$export$e5ad6bff5e333374 = /*#__PURE__*/ function(UserMessageTypes) {
    UserMessageTypes["MESSAGE"] = "message";
    UserMessageTypes["ERROR"] = "error";
    UserMessageTypes["SUCCESS"] = "success";
    return UserMessageTypes;
}({});
var $ad71095b509d7002$export$58e371b565abd256 = /*#__PURE__*/ function(UserMessageActionTypes) {
    UserMessageActionTypes["DISPLAY_USER_MESSAGE"] = "@@userMessage/DISPLAY_USER_MESSAGE";
    UserMessageActionTypes["MARK_USER_MESSAGE_READ"] = "@@userMessage/MARK_USER_MESSAGE_READ";
    return UserMessageActionTypes;
}({});

});



parcelRegister("80zSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bb3cb5f2956d3b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $7YFi7 = parcelRequire("7YFi7");

var $4KSAX = parcelRequire("4KSAX");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $ifbAI = parcelRequire("ifbAI");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $aEgqS = parcelRequire("aEgqS");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $ai857 = parcelRequire("ai857");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $8g1PZ = parcelRequire("8g1PZ");
const $e3bb3cb5f2956d3b$var$codeValidationSchema = ()=>{
    return $hDGtv.create().shape({
        code: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")).min(6)
    });
};
const $e3bb3cb5f2956d3b$var$SetupMfaTotpPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account"
    ]);
    const [smsSent, setSmsSent] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const submitCode = (code, isSubmitting, setSubmitting)=>{
        if (isSubmitting) return;
        (0, $5s7Tw.default).post("/user/mfa/verify_sms", {
            code: code
        }, (0, $1zizz.withAuthHeader)()).then(()=>{
            (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SETUP_MFA_SMS_COMPLETE);
            dispatch((0, $ai857.fetchCurrentUserAction)());
        }).catch(()=>{
            setSubmitting(false);
            inputRef.current.focus();
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaInvalidCode",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    const requestSms = ()=>{
        setSmsSent(false);
        (0, $5s7Tw.default).post("/user/mfa/register_sms", {
            user: props.phoneDetails
        }, (0, $1zizz.withAuthHeader)()).then(()=>{
            setTimeout(()=>setSmsSent(true), 1000);
        }).catch((error)=>{
            props.backToIntro();
            if (error.status == 400) dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaPhoneNumberAlreadyInUse",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
            else dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaErrorSendingSms",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (smsSent) return;
        const timeout = setTimeout(requestSms, 100);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!smsSent) return;
        inputRef.current.focus();
    }, [
        smsSent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center justify-center text-center ",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-3",
                children: t("mfaSmsSetupHeader", props.phoneDetails)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-3 w-full  md:w-1/2 ",
                children: t("mfaSmsSetupExplanation")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-3 w-full md:w-1/2 mx-auto", {
                    hidden: !smsSent
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    initialValues: {
                        code: ""
                    },
                    onSubmit: null,
                    validationSchema: $e3bb3cb5f2956d3b$var$codeValidationSchema,
                    validateOnMount: true,
                    children: ({ values: values, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting, setSubmitting: setSubmitting, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "m-auto w-full md:w-1/3 mb-5",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        className: "text-xl text-center",
                                        innerRef: inputRef,
                                        autoComplete: "off",
                                        name: "code",
                                        onChange: handleChange,
                                        onBlur: handleBlur
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                    className: "flex-row-reverse space-x-reverse space-x-2",
                                    buttons: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: values.code == "" || !isValid || isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).BLUE,
                                            action: ()=>{
                                                submitCode(values.code, isSubmitting, setSubmitting);
                                            },
                                            children: t("submit")
                                        }, "2"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            action: props.backToIntro,
                                            children: t("back")
                                        }, "1")
                                    ]
                                })
                            ]
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    hidden: smsSent
                }),
                children: [
                    t("mfaSmsSending"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {})
                ]
            })
        ]
    });
};
var $e3bb3cb5f2956d3b$export$2e2bcd8739ae039 = $e3bb3cb5f2956d3b$var$SetupMfaTotpPage;

});

parcelRegister("2Baud", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3e67c24e53f4b0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7YFi7 = parcelRequire("7YFi7");

var $ifbAI = parcelRequire("ifbAI");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $ai857 = parcelRequire("ai857");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
const $fc3e67c24e53f4b0$var$MfaTotpPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const inputRef = (0, $acw62.useRef)(null);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const verifyTotpCode = async (code, setSubmitting)=>{
        (0, $5s7Tw.default).post("/user/mfa/verify_totp", {
            code: code
        }, (0, $1zizz.withAuthHeader)()).then(()=>{
            dispatch((0, $ai857.fetchCurrentUserAction)());
            (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).MEETINGS);
        }).catch(()=>{
            setSubmitting(false);
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaInvalidCode",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
            inputRef.current.focus();
        });
    };
    (0, $acw62.useEffect)(()=>{
        inputRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center justify-center overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-5",
                children: t("mfaRequiredHeader", {
                    email: currentUser.email
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5",
                children: t("mfaEnterTotpCode")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    code: ""
                },
                onSubmit: ({ code: code }, helpers)=>{
                    verifyTotpCode(code, helpers.setSubmitting);
                },
                children: ({ handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "m-auto w-full md:w-48 mb-5",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    className: "text-xl text-center",
                                    innerRef: inputRef,
                                    name: "code",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    autoComplete: "false"
                                })
                            }),
                            currentUser.mfaMethods.includes("sms") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5 text-sm",
                                children: [
                                    "If you prefer to receive an sms to authenticate, please click",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        onClick: props.switchToSms,
                                        className: "whitespace-pre text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer",
                                        children: " here "
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("submit")
                                    }, "1")
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $fc3e67c24e53f4b0$export$2e2bcd8739ae039 = $fc3e67c24e53f4b0$var$MfaTotpPage;

});

parcelRegister("gYqVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $719deef4bc8d84f2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7YFi7 = parcelRequire("7YFi7");

var $ifbAI = parcelRequire("ifbAI");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $ai857 = parcelRequire("ai857");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $aEgqS = parcelRequire("aEgqS");

var $3JTjr = parcelRequire("3JTjr");

var $kYqkq = parcelRequire("kYqkq");

var $i1qLR = parcelRequire("i1qLR");
const $719deef4bc8d84f2$var$MfaSmsPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const inputRef = (0, $acw62.useRef)(null);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const smsSent = !(0, $kYqkq.useAppSelector)((0, $i1qLR.mfaSmsRequesting));
    const verifyCode = async (code, setSubmitting)=>{
        setSubmitting(true);
        (0, $5s7Tw.default).post("/user/mfa/verify_sms", {
            code: code
        }, (0, $1zizz.withAuthHeader)()).then(()=>{
            dispatch((0, $ai857.fetchCurrentUserAction)());
            (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).MEETINGS);
        }).catch(()=>{
            setSubmitting(false);
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "mfaInvalidCode",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
            inputRef.current.focus();
        });
    };
    const requestSms = ()=>{
        dispatch((0, $3JTjr.requestMfaSmsAction)());
    };
    (0, $acw62.useEffect)(()=>{
        if (!currentUser) return;
        if (!currentUser.mfaRequired) (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).ROOT);
    }, [
        currentUser
    ]);
    (0, $acw62.useEffect)(()=>{
        requestSms();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!smsSent) return;
        inputRef.current.focus();
    }, [
        smsSent
    ]);
    const form = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: {
            code: ""
        },
        onSubmit: (values, { setSubmitting: setSubmitting })=>{
            verifyCode(values.code, setSubmitting);
        },
        children: ({ handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col items-center justify-center overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "m-auto w-full md:w-1/3 mb-3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    className: "text-xl text-center",
                                    innerRef: inputRef,
                                    name: "code",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    autoComplete: "false"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb-5 text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer",
                                onClick: requestSms,
                                children: t("mfaSmsResendCode")
                            }),
                            currentUser.mfaMethods.includes("totp") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5 text-sm",
                                children: [
                                    "If you prefer to authenticate with a TOTP code, please click",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        onClick: props.switchToTotp,
                                        className: "whitespace-pre text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer",
                                        children: " here "
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("submit")
                            }, "1")
                        ]
                    })
                ]
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center justify-center overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-5",
                children: t("mfaRequiredHeader", {
                    email: currentUser.email
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5",
                children: smsSent ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mb-5",
                            children: t("mfaSmsSent")
                        }),
                        form
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            t("mfaSmsSending"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {})
                        ]
                    })
                })
            })
        ]
    });
};
var $719deef4bc8d84f2$export$2e2bcd8739ae039 = $719deef4bc8d84f2$var$MfaSmsPage;

});
parcelRegister("3JTjr", function(module, exports) {

$parcel$export(module.exports, "requestMfaSmsAction", () => $5510693beadbe2c1$export$b49d9ce07e32c1f3);

var $iLVpj = parcelRequire("iLVpj");
const $5510693beadbe2c1$export$b49d9ce07e32c1f3 = ()=>({
        type: (0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_PENDING
    });

});
parcelRegister("iLVpj", function(module, exports) {

$parcel$export(module.exports, "MfaActionTypes", () => $ac57393fdf4c6b18$export$a56425308b315546);
var $ac57393fdf4c6b18$export$a56425308b315546 = /*#__PURE__*/ function(MfaActionTypes) {
    MfaActionTypes["REQUEST_SMS_ASYNC_PENDING"] = "@@mfa/REQUEST_SMS_ASYNC_PENDING";
    MfaActionTypes["REQUEST_SMS_ASYNC_SUCCESS"] = "@@mfa/REQUEST_SMS_ASYNC_SUCCESS";
    MfaActionTypes["REQUEST_SMS_ASYNC_ERROR"] = "@@mfa/REQUEST_SMS_ASYNC_ERROR";
    return MfaActionTypes;
}({});

});


parcelRegister("kYqkq", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", () => $cc343649d849f7f2$export$f51d452c10d5b956);
$parcel$export(module.exports, "useAppSelector", () => $cc343649d849f7f2$export$a7347740d65f620b);
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
const $cc343649d849f7f2$export$f51d452c10d5b956 = (0, $2OPjR.useDispatch);
const $cc343649d849f7f2$export$a7347740d65f620b = (0, $iD0SF.useSelector);

});

parcelRegister("i1qLR", function(module, exports) {

$parcel$export(module.exports, "mfaSmsRequesting", () => $4243b2c8ae0cf20b$export$382d82ef52efadd2);
const $4243b2c8ae0cf20b$export$382d82ef52efadd2 = (state)=>state.userSession.mfa?.sms?.requesting;

});



parcelRegister("5YjhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa820ed6fcf1f89b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("cIYPX");
var $frTKF = parcelRequire("frTKF");
const $fa820ed6fcf1f89b$var$AccountLayout = ({ children: children })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const defaultClasses = "bg-ch-blue-alt-200 h-screen flex flex-col items-center p-3 md:p-12";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: defaultClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white shadow-md rounded-md border border-ch-blue-alt-300 p-8 w-full sm:w-2/3 xl:w-1/2 mb-10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center p-1 justify-center mb-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $frTKF.default), {
                                className: "w-64",
                                title: t("shared:contextMeeting")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-ch-blue-600 hidden",
                                children: t("shared:contextMeeting")
                            })
                        ]
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col font-thin items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mb-4 text-xs",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "shared:termsAndPrivacyLinks",
                            components: {
                                TermsLink: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.contexthealth.com/legal/terms-and-conditions.pdf",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "text-ch-blue-500 hover:text-ch-blue-600"
                                }),
                                PrivacyLink: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://www.contexthealth.com/legal/privacy-statement.pdf",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "text-ch-blue-500 hover:text-ch-blue-600"
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-xs",
                        children: t("shared:copyright", {
                            year: new Date().getFullYear()
                        })
                    })
                ]
            })
        ]
    });
};
var $fa820ed6fcf1f89b$export$2e2bcd8739ae039 = $fa820ed6fcf1f89b$var$AccountLayout;

});
parcelRegister("jfXvU", function(module, exports) {

$parcel$export(module.exports, "Trans", () => $e04d9533328ca578$export$8d6a9236f2e3f2ce);

var $gZU1N = parcelRequire("gZU1N");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $915hL = parcelRequire("915hL");

var $x4LLZ = parcelRequire("x4LLZ");

var $hPEPQ = parcelRequire("hPEPQ");
var $e04d9533328ca578$var$_excluded = [
    "format"
], $e04d9533328ca578$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $e04d9533328ca578$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e04d9533328ca578$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e04d9533328ca578$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e04d9533328ca578$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e04d9533328ca578$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $e04d9533328ca578$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $e04d9533328ca578$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every(function(child) {
        return (0, $acw62.isValidElement)(child);
    });
}
function $e04d9533328ca578$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $e04d9533328ca578$var$mergeProps(source, target) {
    var newTarget = $e04d9533328ca578$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $e04d9533328ca578$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = $e04d9533328ca578$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === 'string') stringNode += "".concat(child);
        else if ((0, $acw62.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $e04d9533328ca578$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $hPEPQ.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === 'object') {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(child, $e04d9533328ca578$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $hPEPQ.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $hPEPQ.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $e04d9533328ca578$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $e04d9533328ca578$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === 'string') return;
            if ($e04d9533328ca578$var$hasChildren(child)) getData($e04d9533328ca578$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === 'object' && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $915hL.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $e04d9533328ca578$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $e04d9533328ca578$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $e04d9533328ca578$var$getAsArray(reactNode);
        var astNodes = $e04d9533328ca578$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $e04d9533328ca578$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $acw62.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $e04d9533328ca578$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === 'object' && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($e04d9533328ca578$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === 'object' && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $e04d9533328ca578$var$getAsArray(children || []));
    return $e04d9533328ca578$var$getChildren(result[0]);
}
function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e04d9533328ca578$var$_excluded2);
    var _ref2 = (0, $acw62.useContext)((0, $x4LLZ.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $x4LLZ.getI18n)();
    if (!i18n) {
        (0, $hPEPQ.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, (0, $x4LLZ.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var defaultValue = defaults || $e04d9533328ca578$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $e04d9533328ca578$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("915hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $69084eaa2e6a0d50$export$2e2bcd8739ae039);

var $iWvxr = parcelRequire("iWvxr");
var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($iWvxr)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;

});
parcelRegister("iWvxr", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});



parcelRegister("cIYPX", function(module, exports) {

$parcel$export(module.exports, "LogoContextBadge", () => (parcelRequire("hcnin")).default);
$parcel$export(module.exports, "LogoFull", () => (parcelRequire("frTKF")).default);
$parcel$export(module.exports, "CepLogoColour", () => (parcelRequire("ji22T")).default);
$parcel$export(module.exports, "LogoSectra", () => (parcelRequire("dHVXA")).default);

var $hcnin = parcelRequire("hcnin");

var $frTKF = parcelRequire("frTKF");

var $7TIrv = parcelRequire("7TIrv");

var $ji22T = parcelRequire("ji22T");

var $V052v = parcelRequire("V052v");

var $dHVXA = parcelRequire("dHVXA");

});
parcelRegister("hcnin", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08b1bc96fbe0ff6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d08b1bc96fbe0ff6$var$SvgLogoContextBadge({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 47 55",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("filter", {
                        id: "logo-context-badge_svg__a",
                        width: "101%",
                        height: "116.5%",
                        x: "-.5%",
                        y: "-5.9%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feOffset", {
                                dy: 2,
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        id: "logo-context-badge_svg__b",
                        d: "M0 0h1440v85H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#ECF5F5",
                        d: "M-20-15h1440v900H-20z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        transform: "translate(-20 -15)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("use", {
                                fill: "#000",
                                filter: "url(#logo-context-badge_svg__a)",
                                xlinkHref: "#logo-context-badge_svg__b"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("use", {
                                fill: "#FFF",
                                xlinkHref: "#logo-context-badge_svg__b"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M23.444 33.839v6.768l11.722-6.768-5.86-3.384z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M23.444 13.536l11.722 6.767-5.86 3.384-5.862-3.384-5.86 3.384-5.862-3.384zm0-13.536L0 13.536l7.62 4.399L31.062 4.399z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M39.269 17.935V31.47l7.62-4.4V13.537zm0 18.272l-15.825 9.137v8.798l15.825-9.136 7.62-4.4v-8.798z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M27.547 11.167l11.722 6.768 7.62-4.4-11.723-6.767z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M23.444 33.839v6.768l-5.86-3.384-5.862-3.384V20.303l5.861 3.384v6.768z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M0 40.607l7.62 4.399 15.824 9.136v-8.798L7.62 36.208V17.935L0 13.535z"
                    })
                ]
            })
        ]
    });
}
var $d08b1bc96fbe0ff6$export$2e2bcd8739ae039 = $d08b1bc96fbe0ff6$var$SvgLogoContextBadge;

});

parcelRegister("frTKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d836d4767cf3bb0d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d836d4767cf3bb0d$var$SvgLogoFull({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 247 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M10.46 15.439v3.088l5.23-3.088-2.615-1.544z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M10.46 6.176l5.23 3.087-2.615 1.544-2.615-1.544-2.615 1.544L5.23 9.263zm0-6.176L0 6.176l3.4 2.006 10.46-6.175z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M17.52 8.182l3.4-2.007v6.176l-3.4 2.007V8.182zm-7.06 12.506v4.014l7.06-4.169 3.4-2.007v-4.014l-3.4 2.008-7.06 4.168z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M15.69 3.088l5.23 3.088-3.4 2.007-5.23-3.088z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M10.46 15.439v3.088l-2.615-1.544-2.615-1.544V9.263l2.615 1.544v3.088z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M0 18.526l3.4 2.008 7.06 4.168v-4.014L3.4 16.52V8.183L0 6.176z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "#006F74",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39.901 17.219a4.92 4.92 0 002.028-.415 4.64 4.64 0 001.587-1.148 5.446 5.446 0 001.147-2.05h3.927a8.869 8.869 0 01-2.353 4.48 8.6 8.6 0 01-2.816 1.906c-1.09.464-2.279.696-3.568.696-1.288 0-2.473-.232-3.555-.696a8.825 8.825 0 01-2.804-1.881 8.42 8.42 0 01-1.838-2.785A8.956 8.956 0 0131 11.893v-.049c0-1.221.222-2.366.668-3.432a8.875 8.875 0 011.85-2.81 8.598 8.598 0 012.815-1.906c1.09-.464 2.28-.696 3.568-.696 1.289 0 2.474.232 3.556.696a8.826 8.826 0 012.804 1.882c.787.79 1.4 1.718 1.837 2.784.227.553.394 1.126.504 1.72H44.65a5.19 5.19 0 00-1.158-2.024 5.05 5.05 0 00-1.611-1.161 4.8 4.8 0 00-2.029-.428c-.748 0-1.428.139-2.04.415a4.673 4.673 0 00-1.575 1.149 5.429 5.429 0 00-1.026 1.698 5.716 5.716 0 00-.37 2.064v.05c0 .732.123 1.424.37 2.076a5.177 5.177 0 001.05 1.71 5.08 5.08 0 001.599 1.16c.612.285 1.292.428 2.04.428"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M57.882 20.688c1.288 0 2.478-.232 3.567-.696a8.596 8.596 0 002.816-1.905 8.871 8.871 0 001.85-2.81 8.818 8.818 0 00.667-3.432v-.05a8.958 8.958 0 00-.656-3.432 8.43 8.43 0 00-1.837-2.785 8.826 8.826 0 00-2.804-1.88C60.403 3.232 59.218 3 57.93 3c-1.289 0-2.478.232-3.568.696a8.596 8.596 0 00-2.816 1.906 8.871 8.871 0 00-1.849 2.81 8.818 8.818 0 00-.668 3.432v.048c0 1.222.219 2.366.656 3.433a8.43 8.43 0 001.838 2.785 8.826 8.826 0 002.803 1.881c1.082.464 2.267.696 3.556.696zm.048-3.469c-.748 0-1.428-.142-2.04-.427a5.087 5.087 0 01-1.6-1.16 5.182 5.182 0 01-1.05-1.71 5.817 5.817 0 01-.37-2.077v-.05c0-.732.124-1.42.37-2.064a5.435 5.435 0 011.027-1.698 4.67 4.67 0 011.575-1.148c.612-.277 1.292-.415 2.04-.415a4.8 4.8 0 012.028.427c.62.286 1.157.672 1.61 1.16a5.182 5.182 0 011.05 1.711c.247.652.37 1.344.37 2.077v.048c0 .733-.123 1.421-.37 2.065a5.435 5.435 0 01-1.025 1.698 4.64 4.64 0 01-1.587 1.148 4.92 4.92 0 01-2.028.415zm13.792 3.176V9.524l8.09 10.871h3.125V3.294H79.31v10.53l-7.827-10.53h-3.388v17.101zm20.832 0V6.763h5.082V3.294h-13.84v3.47h5.083v13.631zm18.66 0v-3.347h-9.068v-3.591h7.875V10.11h-7.875V6.641h8.949V3.294h-12.6v17.101zm4.224 0l3.77-5.863 3.746 5.863h4.295l-5.822-8.746 5.584-8.355h-4.176l-3.532 5.546-3.507-5.546H111.5l5.584 8.404-5.822 8.697z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M135.601 20.395V6.763h5.083V3.294h-13.84v3.47h5.082v13.631zm8.137 0V6.568l6.085 9.137h.096l6.085-9.162v13.852h1.885V3.294h-1.91l-6.084 9.332-6.085-9.332h-1.91v17.101zm29.112 0v-1.759h-10.308v-5.985h9.115v-1.76h-9.115V5.054h10.189v-1.76h-12.074v17.101zm14.031 0v-1.759h-10.308v-5.985h9.115v-1.76h-9.115V5.054h10.189v-1.76h-12.074v17.101zm8.161 0V5.077h5.608V3.294h-13.124v1.783h5.607v15.318zm9.235 0V3.294h-1.885v17.101zm4.773 0V6.372l10.785 14.023h1.503V3.294h-1.837v13.705L208.978 3.294h-1.766v17.101zm22.812.293c1.416 0 2.692-.256 3.83-.77 1.137-.512 2.095-1.127 2.875-1.844v-6.816h-6.896v1.735h5.082v4.25c-.572.473-1.28.876-2.123 1.21-.843.334-1.742.5-2.697.5-1.018 0-1.933-.178-2.744-.537a6.047 6.047 0 01-2.076-1.49 6.674 6.674 0 01-1.324-2.26c-.31-.871-.466-1.82-.466-2.846 0-.96.16-1.869.478-2.724a7.12 7.12 0 011.312-2.235 6.213 6.213 0 012.005-1.515 5.817 5.817 0 012.553-.562c.588 0 1.125.05 1.61.147.486.098.931.232 1.337.403a6.71 6.71 0 011.133.61c.35.237.684.502 1.002.795l1.217-1.466a11.73 11.73 0 00-1.276-.965 7.689 7.689 0 00-1.408-.72 8.2 8.2 0 00-1.623-.44 11.613 11.613 0 00-1.92-.147c-1.257 0-2.399.24-3.425.72a8.146 8.146 0 00-2.637 1.943 8.89 8.89 0 00-1.706 2.834 9.47 9.47 0 00-.608 3.371c0 1.222.195 2.37.584 3.445a8.186 8.186 0 001.695 2.81 7.932 7.932 0 002.672 1.88c1.042.456 2.223.684 3.544.684zm9.703-13.818V3.402h1.269V3h-2.97v.403h1.269V6.87zm2.04 0V3.74l1.377 2.068h.021l1.377-2.073v3.134h.427V3h-.432l-1.377 2.112L243.62 3h-.432v3.87z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $d836d4767cf3bb0d$export$2e2bcd8739ae039 = $d836d4767cf3bb0d$var$SvgLogoFull;

});

parcelRegister("7TIrv", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $efa3604c02e6fd27$var$SvgLogoPoweredBy({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 155 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#455354",
                        fillRule: "nonzero",
                        d: "M27.45 9V6.754h.671c.734 0 1.299-.156 1.693-.467.395-.311.592-.756.592-1.334 0-1.11-.713-1.664-2.14-1.664h-1.48V9h.663zm.597-2.816h-.598v-2.32h.742c.524 0 .91.092 1.157.277.247.185.37.466.37.843 0 .42-.13.724-.394.914-.263.19-.689.286-1.277.286zm5.89 2.894c.823 0 1.466-.262 1.928-.785.462-.523.694-1.242.694-2.156 0-.917-.23-1.636-.692-2.157-.46-.52-1.101-.78-1.922-.78-.843 0-1.494.255-1.953.767-.458.512-.687 1.232-.687 2.162 0 .937.228 1.663.685 2.178.457.514 1.106.771 1.948.771zm0-.582c-.627 0-1.106-.2-1.435-.6-.33-.4-.494-.986-.494-1.76 0-.762.165-1.344.494-1.743.33-.4.81-.6 1.443-.6.63 0 1.106.199 1.428.596.322.397.482.98.482 1.748 0 .776-.161 1.363-.484 1.761-.323.399-.8.598-1.434.598zM39.25 9l1.117-3.8c.125-.41.216-.786.274-1.13.002.052.037.207.105.465s.129.472.184.64L42.082 9h.656l1.528-5.71h-.703l-.899 3.519c-.138.53-.232.981-.281 1.351a10.652 10.652 0 00-.317-1.367l-1.074-3.504h-.703l-1.023 3.473a9.705 9.705 0 00-.313 1.398 13.119 13.119 0 00-.273-1.344l-.903-3.527h-.703L38.594 9h.656zm9.094 0v-.594h-2.52V6.305h2.367v-.586h-2.367v-1.84h2.52v-.59H45.16V9h3.184zm1.93 0V6.625h1.19L52.849 9h.785l-1.551-2.566c.766-.266 1.148-.776 1.148-1.532 0-.539-.167-.942-.501-1.21-.335-.269-.853-.403-1.553-.403H49.61V9h.664zm.91-2.945h-.91V3.87h.863c.492 0 .85.083 1.072.25.223.167.334.439.334.816 0 .373-.11.652-.328.838-.219.187-.563.28-1.031.28zM57.738 9v-.594h-2.52V6.305h2.368v-.586h-2.367v-1.84h2.52v-.59h-3.184V9h3.183zm2.848 0c.96 0 1.697-.25 2.209-.748.512-.499.767-1.22.767-2.162 0-.883-.246-1.57-.738-2.063-.492-.492-1.182-.738-2.07-.738h-1.75V9h1.582zm-.11-.574h-.808V3.863h.965c.737 0 1.292.19 1.666.567.374.377.56.938.56 1.683 0 .763-.199 1.34-.597 1.729-.399.39-.994.584-1.785.584zm8.43.574c.62 0 1.102-.143 1.448-.43.345-.286.517-.685.517-1.195 0-.763-.433-1.219-1.3-1.367v-.04c.361-.064.637-.207.825-.427.19-.22.284-.5.284-.838 0-.49-.17-.848-.508-1.074-.339-.227-.887-.34-1.645-.34h-1.613V9h1.992zm-.234-3.266h-1.094v-1.87h.977c.5 0 .864.07 1.093.212.23.142.344.373.344.694 0 .348-.103.597-.308.744-.206.147-.543.22-1.012.22zm.098 2.7h-1.192V6.297h1.137c.487 0 .85.083 1.088.25.238.167.357.427.357.781 0 .38-.116.66-.35.838-.233.178-.58.268-1.04.268zM73.809 9V6.785l1.906-3.496h-.719l-1.523 2.856-1.512-2.856h-.727l1.903 3.527V9h.672z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "#006F74",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M30.357 20.558c.44 0 .847-.084 1.22-.25.374-.167.693-.397.956-.691a3.278 3.278 0 00.69-1.233h2.363a5.338 5.338 0 01-1.416 2.696 5.176 5.176 0 01-1.694 1.147 5.423 5.423 0 01-2.148.419 5.37 5.37 0 01-2.14-.42 5.311 5.311 0 01-1.687-1.132 5.068 5.068 0 01-1.106-1.676A5.39 5.39 0 0125 17.352v-.03a5.342 5.342 0 011.515-3.757 5.175 5.175 0 011.695-1.146A5.421 5.421 0 0130.357 12a5.358 5.358 0 013.828 1.551 5.202 5.202 0 011.409 2.71l-2.378.001a3.123 3.123 0 00-.697-1.218 3.04 3.04 0 00-.97-.699 2.889 2.889 0 00-1.22-.257c-.45 0-.86.083-1.229.25a2.812 2.812 0 00-.947.691c-.264.294-.47.635-.618 1.022a3.44 3.44 0 00-.223 1.243v.029c0 .44.074.858.223 1.25.148.392.359.735.632 1.029.273.294.593.527.962.698a2.87 2.87 0 001.228.258"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M41.179 22.646c.775 0 1.491-.14 2.147-.42a5.173 5.173 0 001.695-1.146 5.34 5.34 0 001.515-3.757v-.03c0-.734-.132-1.423-.395-2.065a5.073 5.073 0 00-1.106-1.676 5.312 5.312 0 00-1.688-1.132 5.37 5.37 0 00-2.14-.42c-.775 0-1.49.14-2.146.42a5.17 5.17 0 00-1.695 1.146 5.34 5.34 0 00-1.515 3.757v.03c0 .735.131 1.423.395 2.065a5.078 5.078 0 001.106 1.677 5.312 5.312 0 001.687 1.132 5.37 5.37 0 002.14.419zm.029-2.088c-.45 0-.86-.086-1.228-.257a3.061 3.061 0 01-1.594-1.728 3.5 3.5 0 01-.223-1.25v-.03c0-.44.074-.855.223-1.242a3.27 3.27 0 01.617-1.022 2.81 2.81 0 01.948-.69c.369-.167.778-.25 1.228-.25.44 0 .847.085 1.22.257.374.171.697.404.97.698.273.294.484.637.632 1.03a3.5 3.5 0 01.223 1.25v.029c0 .44-.075.855-.223 1.242a3.27 3.27 0 01-.618 1.022 2.792 2.792 0 01-.955.69c-.373.168-.78.25-1.22.25zm8.301 1.912v-6.544l4.868 6.543h1.882V12.177h-2.183v6.337l-4.711-6.337h-2.04v10.292zm12.537 0v-8.205h3.06v-2.088h-8.33v2.088h3.059v8.204zm11.231 0v-2.015H67.82v-2.161h4.739v-2.015h-4.74v-2.088h5.386v-2.014h-7.583v10.292zm2.542 0l2.27-3.53 2.254 3.53h2.585l-3.504-5.264 3.36-5.029h-2.513l-2.125 3.338-2.112-3.338H73.45l3.36 5.058-3.503 5.234z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                fillRule: "nonzero",
                                d: "M87.954 22.47v-8.205h3.06v-2.088h-8.33v2.088h3.059v8.204zm4.898 0v-8.323l3.662 5.5h.057l3.663-5.514v8.336h1.134V12.177h-1.149l-3.662 5.617-3.662-5.617h-1.15v10.292zm17.521 0v-1.06h-6.204v-3.602h5.486V16.75h-5.486v-3.514h6.132v-1.059h-7.267v10.292zm8.444 0v-1.06h-6.204v-3.602h5.486V16.75h-5.486v-3.514h6.133v-1.059h-7.267v10.292zm4.913 0v-9.22h3.374v-1.073h-7.899v1.073h3.375v9.22zm5.557 0V12.176h-1.135v10.292zm2.873 0v-8.44l6.49 8.44h.906V12.176h-1.106v8.249l-6.334-8.249h-1.063v10.292zm13.729.176c.852 0 1.62-.155 2.305-.463.685-.31 1.261-.68 1.73-1.11V16.97h-4.15v1.044h3.06v2.559a4.763 4.763 0 01-1.28.727 4.358 4.358 0 01-1.622.302c-.613 0-1.163-.108-1.652-.324a3.64 3.64 0 01-1.249-.897 4.017 4.017 0 01-.797-1.36 5.073 5.073 0 01-.28-1.713c0-.578.096-1.124.287-1.639.192-.515.455-.963.79-1.345a3.74 3.74 0 011.206-.912c.47-.225.982-.338 1.537-.338a5 5 0 01.97.088 3.98 3.98 0 011.486.61c.21.142.412.302.603.478l.733-.882a7.06 7.06 0 00-.769-.58 4.627 4.627 0 00-.847-.435 4.936 4.936 0 00-.977-.264 6.99 6.99 0 00-1.156-.088c-.756 0-1.443.144-2.06.433a4.902 4.902 0 00-1.588 1.17 5.35 5.35 0 00-1.027 1.705 5.7 5.7 0 00-.366 2.029c0 .735.118 1.426.352 2.073a4.774 4.774 0 002.628 2.823c.627.275 1.338.412 2.133.412zm5.84-8.317v-2.086h.764V12h-1.788v.243h.764v2.086zm1.228 0v-1.883l.828 1.244h.013l.829-1.248v1.887h.257v-2.33h-.26l-.83 1.272-.828-1.271h-.26v2.329z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M10.46 15.439v3.088l5.23-3.088-2.615-1.544z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M10.46 6.176l5.23 3.087-2.615 1.544-2.615-1.544-2.615 1.544L5.23 9.263zm0-6.176L0 6.176l3.4 2.006 10.46-6.175z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#006F74",
                        d: "M17.52 8.182l3.4-2.007v6.176l-3.4 2.007V8.182zm-7.06 12.506v4.014l7.06-4.169 3.4-2.007v-4.014l-3.4 2.008-7.06 4.168z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#75A7A9",
                        d: "M15.69 3.088l5.23 3.088-3.4 2.007-5.23-3.088z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M10.46 15.439v3.088l-2.615-1.544-2.615-1.544V9.263l2.615 1.544v3.088z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#A3C3C4",
                        d: "M0 18.526l3.4 2.008 7.06 4.168v-4.014L3.4 16.52V8.183L0 6.176z"
                    })
                ]
            })
        ]
    });
}
var $efa3604c02e6fd27$export$2e2bcd8739ae039 = $efa3604c02e6fd27$var$SvgLogoPoweredBy;

});

parcelRegister("ji22T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac6ab2f8089da2c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $2ac6ab2f8089da2c$var$SvgCepLogoColour = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 2621 1208",
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M336.944 178.736v35.567l61.604-35.568-30.802-17.783-30.802 17.784Z",
                style: {
                    fill: "#127074"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m336.944 72.035 61.604 35.568-30.802 17.783-30.802-17.784-30.801 17.784-30.802-17.783 61.603-35.568ZM376.986 24.02 336.944.902 213.738 72.036l40.042 23.119L376.986 24.02Z",
                style: {
                    fill: "#75a8a9"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m420.109 95.155 40.042-23.119v71.132l-40.042 23.119V95.155ZM336.944 239.2v46.237l83.165-48.016v.001l40.042-23.119v-46.238l-40.042 23.119-83.165 48.016Z",
                style: {
                    fill: "#127074"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m398.548 36.469 61.603 35.567-40.042 23.119-61.603-35.568 40.042-23.118Z",
                style: {
                    fill: "#75a8a9"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M336.944 178.736v35.567l-30.801-17.784-30.802-17.784v-71.132l30.802 17.783v35.566l30.801 17.784Z",
                style: {
                    fill: "#a2c4c5"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m253.78 95.155-40.042-23.119v142.267l40.042 23.119v-.001l83.164 48.016V239.2l-83.164-48.016V95.155Z",
                style: {
                    fill: "#a2c4c5"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(-26 117)",
                children: "C"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1477.34,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(-26 117)",
                children: "ONTEXT"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(-30.3 446.313)",
                children: "E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1449.44,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(-30.3 446.313)",
                children: "xchange"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(-30.3 782.25)",
                children: "P"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(166.7 778.95)",
                children: "o"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("text", {
                x: 1427.24,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(166.7 778.95)",
                children: [
                    "r",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                        x: 1542.14,
                        y: 291.718,
                        children: "t"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1651.64,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#137074"
                },
                transform: "translate(166.7 778.95)",
                children: "al"
            })
        ]
    });
var $2ac6ab2f8089da2c$export$2e2bcd8739ae039 = $2ac6ab2f8089da2c$var$SvgCepLogoColour;

});

parcelRegister("V052v", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $fb66d518f47a6187$var$SvgCepLogoWhite = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 2621 1208",
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M336.944 178.736v35.567l61.604-35.568-30.802-17.783-30.802 17.784ZM336.944 72.035l61.604 35.568-30.802 17.783-30.802-17.784-30.801 17.784-30.802-17.783 61.603-35.568ZM376.986 24.02 336.944.902 213.738 72.036l40.042 23.119L376.986 24.02ZM420.109 95.155l40.042-23.119v71.132l-40.042 23.119V95.155ZM336.944 239.2v46.237l83.165-48.016v.001l40.042-23.119v-46.238l-40.042 23.119-83.165 48.016Z",
                style: {
                    fill: "#fff"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m398.548 36.469 61.603 35.567-40.042 23.119-61.603-35.568 40.042-23.118ZM336.944 178.736v35.567l-30.801-17.784-30.802-17.784v-71.132l30.802 17.783v35.566l30.801 17.784Z",
                style: {
                    fill: "#fff"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m253.78 95.155-40.042-23.119v142.267l40.042 23.119v-.001l83.164 48.016V239.2l-83.164-48.016V95.155Z",
                style: {
                    fill: "#fff"
                },
                transform: "translate(-879 8) scale(4.16667)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(-26 117)",
                children: "C"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1477.34,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(-26 117)",
                children: "ONTEXT"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(-30.3 446.313)",
                children: "E"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1449.44,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(-30.3 446.313)",
                children: "xchange"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue-Bold','Helvetica Neue'",
                    fontWeight: 700,
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(-30.3 782.25)",
                children: "P"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1255.04,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(166.7 778.95)",
                children: "o"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("text", {
                x: 1427.24,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(166.7 778.95)",
                children: [
                    "r",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                        x: 1542.14,
                        y: 291.718,
                        children: "t"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("text", {
                x: 1651.64,
                y: 291.718,
                style: {
                    fontFamily: "'HelveticaNeue','Helvetica Neue'",
                    fontSize: 300,
                    fill: "#fff"
                },
                transform: "translate(166.7 778.95)",
                children: "al"
            })
        ]
    });
var $fb66d518f47a6187$export$2e2bcd8739ae039 = $fb66d518f47a6187$var$SvgCepLogoWhite;

});

parcelRegister("dHVXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0203a160cafa7dbe$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0203a160cafa7dbe$var$SvgLogoSectra = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 151.281,
        height: 29.469,
        viewBox: "0 0 40.027 7.797",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "logo-sectra_svg__a",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M425.871 757.781H445V780h-19.129zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "logo-sectra_svg__b",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M446 757.781h14V779h-14zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "logo-sectra_svg__c",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M461 757.781h20V780h-20zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "logo-sectra_svg__d",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M499 757.781h19V779h-19zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "logo-sectra_svg__e",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M518 757.781h20.582V779H518Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#logo-sectra_svg__a)",
                transform: "matrix(.35278 0 0 .35278 -150.106 -267.196)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fill: "currentColor",
                    d: "M431.016 779.133c-1.684 0-2.961-.336-3.836-1.008-.871-.672-1.309-1.656-1.309-2.957v-3.816h8.414v1.484c0 .523.078.906.238 1.14.16.239.422.356.774.356.363 0 .629-.129.793-.379.164-.254.246-.672.246-1.258 0-.656-.078-1.117-.234-1.379-.157-.261-.547-.52-1.172-.773l-5.703-2.305c-1.309-.535-2.196-1.11-2.66-1.726-.465-.617-.696-1.461-.696-2.535v-2.254c0-1.293.438-2.274 1.309-2.938.875-.668 2.152-1.004 3.836-1.004h8.488c1.684 0 2.957.336 3.828 1.004.871.664 1.305 1.645 1.305 2.938v2.496h-8.352v-.266c0-.465-.09-.816-.273-1.058-.18-.239-.442-.36-.79-.36-.296 0-.534.094-.718.277-.18.188-.27.438-.27.747 0 .304.082.554.246.742.165.191.575.422 1.235.691l6.64 2.801c.844.363 1.438.871 1.774 1.527.34.653.508 1.645.508 2.97v2.331c0 1.547-.418 2.684-1.25 3.418-.832.73-2.125 1.094-3.883 1.094zm0 0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#logo-sectra_svg__b)",
                transform: "matrix(.35278 0 0 .35278 -150.106 -267.196)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fill: "currentColor",
                    d: "M446.41 778.98v-21.07h13.281v4.8h-5.054v2.31h5.054v4.8h-5.054v4.36h5.054v4.8zm0 0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#logo-sectra_svg__c)",
                transform: "matrix(.35278 0 0 .35278 -150.106 -267.196)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fill: "currentColor",
                    d: "M480.219 770.39v4.208c0 1.613-.406 2.773-1.211 3.476-.805.707-2.137 1.059-3.996 1.059h-8.594c-1.73 0-2.996-.363-3.8-1.094-.802-.734-1.204-1.879-1.204-3.441v-11.785c0-1.84.375-3.141 1.121-3.895.746-.758 2.043-1.137 3.883-1.137h8.594c1.957 0 3.316.375 4.074 1.117.754.743 1.133 2.047 1.133 3.915v2.773h-8.352v-1.531c0-.551-.082-.938-.246-1.172-.164-.23-.437-.348-.816-.348-.364 0-.63.121-.793.36-.164.242-.246.628-.246 1.16v8.78c0 .532.082.919.246 1.161.164.242.43.36.793.36.363 0 .629-.122.804-.368.172-.246.258-.629.258-1.152v-2.445zm0 0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M21.174 7.61V1.872H19.68V.178h5.869V1.87h-1.493v5.74zm0 0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#logo-sectra_svg__d)",
                transform: "matrix(.35278 0 0 .35278 -150.106 -267.196)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fill: "currentColor",
                    d: "M507.375 762.71v2.981h.91c.43 0 .738-.113.918-.332.184-.218.274-.601.274-1.14 0-.567-.09-.957-.266-1.176-.176-.223-.488-.332-.926-.332zm2.102 16.27v-7.183c0-.559-.09-.95-.266-1.172-.176-.223-.488-.336-.926-.336h-.91v8.691h-8.227v-21.07h13.332c1.91 0 3.274.387 4.094 1.164.817.778 1.227 2.059 1.227 3.84 0 1.418-.262 2.5-.785 3.238-.524.739-1.395 1.262-2.61 1.563 1.215.289 2.09.883 2.621 1.789.535.902.801 2.254.801 4.055v5.421zm0 0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#logo-sectra_svg__e)",
                transform: "matrix(.35278 0 0 .35278 -150.106 -267.196)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    fill: "currentColor",
                    d: "M527.547 769.77h1.734l-.847-7.16zm-9.262 9.21 3.711-21.07h12.875l3.711 21.07h-8.516l-.468-4.562h-2.356l-.469 4.562zm0 0"
                })
            })
        ]
    });
var $0203a160cafa7dbe$export$2e2bcd8739ae039 = $0203a160cafa7dbe$var$SvgLogoSectra;

});



parcelRegister("f2yI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c209733c9e2cdf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $ai857 = parcelRequire("ai857");

var $lCZwG = parcelRequire("lCZwG");

var $04A9g = parcelRequire("04A9g");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("cIYPX");
var $frTKF = parcelRequire("frTKF");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");
const $20c209733c9e2cdf$var$SwitchToTenantModal = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const setTenant = ()=>{
        const tenantPrefix = `/tenant/${props.tenantId}`;
        const newPath = (0, $1l1FS.default).location.pathname.replace(tenantPrefix, "") || "/";
        dispatch((0, $ai857.setTenantAction)(props.tenantId, newPath));
    };
    const stayInCurrentTenant = ()=>{
        (0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).MEETINGS);
    };
    const switchTenantButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: setTenant,
        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
        children: t("resourceInTenant.switchTenantButtonText")
    }, "1");
    const stayInTenantButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: stayInCurrentTenant,
        variant: (0, $jF0Xa.StyleVariants).PURPLE,
        children: t("resourceInTenant.stayButtonText")
    }, "2");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: true,
        style: (0, $jF0Xa.smallModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col mt-10 justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center items-center mb-5 relative",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $frTKF.default), {
                                className: "h-8"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center items-center mb-5 relative",
                        children: t("resourceInTenant.message")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center items-center mb-5 relative",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                stayInTenantButton,
                                switchTenantButton
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $20c209733c9e2cdf$export$2e2bcd8739ae039 = $20c209733c9e2cdf$var$SwitchToTenantModal;

});
parcelRegister("7jD0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6cb3e617f36dfc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $7Bj8I = parcelRequire("7Bj8I");
parcelRequire("jitSV");
var $chuvC = parcelRequire("chuvC");

var $kQILj = parcelRequire("kQILj");

var $2MEcG = parcelRequire("2MEcG");
const $ab6cb3e617f36dfc$var$ModalContainer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const mainScrollToPosition = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getScrollUI)(state).mainScrollToPosition);
    const dispatch = (0, $2OPjR.useDispatch)();
    const resetScrollPosition = ()=>dispatch((0, $2MEcG.scrollUpdatePosition)((0, $7Bj8I.ScrollActionTypes).UPDATE_MAIN_SCROLL_TO_POSITION, null));
    const scrollElementRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        scrollElementRef.current.scrollTo({
            top: mainScrollToPosition,
            behavior: "smooth"
        });
        resetScrollPosition();
    }, [
        mainScrollToPosition
    ]);
    const renderCloseButton = ()=>{
        if (!props.handleClose) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            onClick: props.handleClose,
            className: "text-ch-blue-500 hover:text-ch-blue-600 self-end mb-3 lg:mb-5 z-50 cursor-pointer",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chuvC.default), {
                className: "fill-current w-6 h-6",
                title: t("shared:close")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex w-full h-full flex-col relative",
        children: [
            renderCloseButton(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: scrollElementRef,
                className: "w-full h-full flex-1 overflow-y-auto overflow-x-hidden mb-5 pl-3 pr-3 lg:pl-14 lg:pr-14",
                children: props.children
            })
        ]
    });
};
var $ab6cb3e617f36dfc$export$2e2bcd8739ae039 = $ab6cb3e617f36dfc$var$ModalContainer;

});
parcelRegister("7Bj8I", function(module, exports) {

$parcel$export(module.exports, "ScrollActionTypes", () => $a5398afdf9453f5f$export$24ddf74bbe4daee0);
// State
var $a5398afdf9453f5f$export$24ddf74bbe4daee0 = /*#__PURE__*/ function(ScrollActionTypes) {
    ScrollActionTypes["UPDATE_MAIN_SCROLL_TO_POSITION"] = "@@scroll/UPDATE_MAIN_SCROLL_TO_POSITION";
    ScrollActionTypes["UPDATE_MODAL_SCROLL_TO_POSITION"] = "@@scroll/UPDATE_MODAL_SCROLL_TO_POSITION";
    return ScrollActionTypes;
}({});

});

parcelRegister("jitSV", function(module, exports) {

$parcel$export(module.exports, "IconAcceptThin", () => (parcelRequire("4o7Oq")).default);
$parcel$export(module.exports, "IconAccept", () => (parcelRequire("ij7yF")).default);
$parcel$export(module.exports, "IconAlert", () => (parcelRequire("9IdeF")).default);
$parcel$export(module.exports, "IconAssetMenu", () => (parcelRequire("gc4wS")).default);
$parcel$export(module.exports, "IconAttachment", () => (parcelRequire("hTUUb")).default);
$parcel$export(module.exports, "IconBin", () => (parcelRequire("eY7ZC")).default);
$parcel$export(module.exports, "IconCalendar", () => (parcelRequire("9c2AV")).default);
$parcel$export(module.exports, "IconChangeTracking", () => (parcelRequire("h5KXb")).default);
$parcel$export(module.exports, "IconClose", () => (parcelRequire("chuvC")).default);
$parcel$export(module.exports, "IconCog", () => (parcelRequire("irSmE")).default);
$parcel$export(module.exports, "IconCollapseUp", () => (parcelRequire("rSxjF")).default);
$parcel$export(module.exports, "IconComment", () => (parcelRequire("hHsFn")).default);
$parcel$export(module.exports, "IconComments", () => (parcelRequire("7wpDl")).default);
$parcel$export(module.exports, "IconDeferral", () => (parcelRequire("2D4bH")).default);
$parcel$export(module.exports, "IconDicom", () => (parcelRequire("57bqY")).default);
$parcel$export(module.exports, "IconDownload", () => (parcelRequire("1xXym")).default);
$parcel$export(module.exports, "IconDrag", () => (parcelRequire("fcxUP")).default);
$parcel$export(module.exports, "IconExclamation", () => (parcelRequire("3kOP8")).default);
$parcel$export(module.exports, "IconExitFullscreen", () => (parcelRequire("l8Ars")).default);
$parcel$export(module.exports, "IconExpandDown", () => (parcelRequire("hA7qy")).default);
$parcel$export(module.exports, "IconEye", () => (parcelRequire("518YH")).default);
$parcel$export(module.exports, "IconFiles", () => (parcelRequire("8Jzjq")).default);
$parcel$export(module.exports, "IconFolder", () => (parcelRequire("6Hpf8")).default);
$parcel$export(module.exports, "IconFullscreen", () => (parcelRequire("18DPn")).default);
$parcel$export(module.exports, "IconFurtherDetails", () => (parcelRequire("1P0Mf")).default);
$parcel$export(module.exports, "IconGrid", () => (parcelRequire("cunZf")).default);
$parcel$export(module.exports, "IconHandshake", () => (parcelRequire("fllUo")).default);
$parcel$export(module.exports, "IconHome", () => (parcelRequire("8xwyy")).default);
$parcel$export(module.exports, "IconImage", () => (parcelRequire("fioxl")).default);
$parcel$export(module.exports, "IconLink", () => (parcelRequire("e11eN")).default);
$parcel$export(module.exports, "IconList", () => (parcelRequire("OPxe7")).default);
$parcel$export(module.exports, "IconLock", () => (parcelRequire("8lynw")).default);
$parcel$export(module.exports, "IconMeeting", () => (parcelRequire("18j2c")).default);
$parcel$export(module.exports, "IconMenu", () => (parcelRequire("2XYVX")).default);
$parcel$export(module.exports, "IconMessageRead", () => (parcelRequire("91duj")).default);
$parcel$export(module.exports, "IconMessage", () => (parcelRequire("5AYDs")).default);
$parcel$export(module.exports, "IconMicOff", () => (parcelRequire("9rcVu")).default);
$parcel$export(module.exports, "IconMicOn", () => (parcelRequire("h8MLf")).default);
$parcel$export(module.exports, "IconNa", () => (parcelRequire("8tyXr")).default);
$parcel$export(module.exports, "IconNotification", () => (parcelRequire("bbiXR")).default);
$parcel$export(module.exports, "IconPathway", () => (parcelRequire("k6suX")).default);
$parcel$export(module.exports, "IconPatient", () => (parcelRequire("eEYoR")).default);
$parcel$export(module.exports, "IconPdf", () => (parcelRequire("e1x9J")).default);
$parcel$export(module.exports, "IconPencil", () => (parcelRequire("7laxl")).default);
$parcel$export(module.exports, "IconPlus", () => (parcelRequire("asRrx")).default);
$parcel$export(module.exports, "IconPresenter", () => (parcelRequire("80TYb")).default);
$parcel$export(module.exports, "IconQuestionMark", () => (parcelRequire("5pIma")).default);
$parcel$export(module.exports, "IconQuestion", () => (parcelRequire("9ZBPP")).default);
$parcel$export(module.exports, "IconRadiology", () => (parcelRequire("hSnpV")).default);
$parcel$export(module.exports, "IconRecommendation", () => (parcelRequire("lx7Y0")).default);
$parcel$export(module.exports, "IconRejectThin", () => (parcelRequire("6EQca")).default);
$parcel$export(module.exports, "IconReject", () => (parcelRequire("4e1aD")).default);
$parcel$export(module.exports, "IconRotate", () => (parcelRequire("ls9xE")).default);
$parcel$export(module.exports, "IconScreenShareOff", () => (parcelRequire("lhJr8")).default);
$parcel$export(module.exports, "IconScreenShareOn", () => (parcelRequire("9fvzA")).default);
$parcel$export(module.exports, "IconScribe", () => (parcelRequire("3NuIO")).default);
$parcel$export(module.exports, "IconSelectCross", () => (parcelRequire("4rRXd")).default);
$parcel$export(module.exports, "IconSignOut", () => (parcelRequire("77EBI")).default);
$parcel$export(module.exports, "IconSplitscreen", () => (parcelRequire("bnAWr")).default);
$parcel$export(module.exports, "IconStep", () => (parcelRequire("bKaLx")).default);
$parcel$export(module.exports, "IconSwitchTenant", () => (parcelRequire("jcQWI")).default);
$parcel$export(module.exports, "IconTask", () => (parcelRequire("dIfKX")).default);
$parcel$export(module.exports, "IconTeam", () => (parcelRequire("4fat5")).default);
$parcel$export(module.exports, "IconTick", () => (parcelRequire("lHtgo")).default);
$parcel$export(module.exports, "IconUser", () => (parcelRequire("chRXN")).default);
$parcel$export(module.exports, "IconUsers", () => (parcelRequire("ft8ez")).default);
$parcel$export(module.exports, "IconVideoOff", () => (parcelRequire("bZDhf")).default);
$parcel$export(module.exports, "IconVideoOn", () => (parcelRequire("7eN5N")).default);

var $4o7Oq = parcelRequire("4o7Oq");

var $ij7yF = parcelRequire("ij7yF");

var $9IdeF = parcelRequire("9IdeF");

var $kNH5k = parcelRequire("kNH5k");

var $gc4wS = parcelRequire("gc4wS");

var $h55D4 = parcelRequire("h55D4");

var $hTUUb = parcelRequire("hTUUb");

var $eY7ZC = parcelRequire("eY7ZC");

var $9c2AV = parcelRequire("9c2AV");

var $h5KXb = parcelRequire("h5KXb");

var $chuvC = parcelRequire("chuvC");

var $irSmE = parcelRequire("irSmE");

var $ctM8Y = parcelRequire("ctM8Y");

var $rSxjF = parcelRequire("rSxjF");

var $hHsFn = parcelRequire("hHsFn");

var $7wpDl = parcelRequire("7wpDl");

var $2D4bH = parcelRequire("2D4bH");

var $57bqY = parcelRequire("57bqY");

var $1xXym = parcelRequire("1xXym");

var $fcxUP = parcelRequire("fcxUP");

var $3kOP8 = parcelRequire("3kOP8");

var $l8Ars = parcelRequire("l8Ars");

var $hA7qy = parcelRequire("hA7qy");

var $h909q = parcelRequire("h909q");

var $518YH = parcelRequire("518YH");

var $8Jzjq = parcelRequire("8Jzjq");

var $khgu4 = parcelRequire("khgu4");

var $6Hpf8 = parcelRequire("6Hpf8");

var $18DPn = parcelRequire("18DPn");

var $1P0Mf = parcelRequire("1P0Mf");

var $cunZf = parcelRequire("cunZf");

var $fllUo = parcelRequire("fllUo");

var $8xwyy = parcelRequire("8xwyy");

var $fioxl = parcelRequire("fioxl");

var $e11eN = parcelRequire("e11eN");

var $OPxe7 = parcelRequire("OPxe7");

var $8lynw = parcelRequire("8lynw");

var $18j2c = parcelRequire("18j2c");

var $2XYVX = parcelRequire("2XYVX");

var $91duj = parcelRequire("91duj");

var $5AYDs = parcelRequire("5AYDs");

var $9rcVu = parcelRequire("9rcVu");

var $h8MLf = parcelRequire("h8MLf");

var $giMAJ = parcelRequire("giMAJ");

var $8tyXr = parcelRequire("8tyXr");

var $kDaeH = parcelRequire("kDaeH");

var $bbiXR = parcelRequire("bbiXR");

var $8BOWl = parcelRequire("8BOWl");

var $k6suX = parcelRequire("k6suX");

var $eEYoR = parcelRequire("eEYoR");

var $e1x9J = parcelRequire("e1x9J");

var $7laxl = parcelRequire("7laxl");

var $asRrx = parcelRequire("asRrx");

var $80TYb = parcelRequire("80TYb");

var $5pIma = parcelRequire("5pIma");

var $9ZBPP = parcelRequire("9ZBPP");

var $hSnpV = parcelRequire("hSnpV");

var $lx7Y0 = parcelRequire("lx7Y0");

var $6EQca = parcelRequire("6EQca");

var $4e1aD = parcelRequire("4e1aD");

var $ls9xE = parcelRequire("ls9xE");

var $lhJr8 = parcelRequire("lhJr8");

var $9fvzA = parcelRequire("9fvzA");

var $3NuIO = parcelRequire("3NuIO");

var $4rRXd = parcelRequire("4rRXd");

var $6dmyz = parcelRequire("6dmyz");

var $77EBI = parcelRequire("77EBI");

var $bnAWr = parcelRequire("bnAWr");

var $bKaLx = parcelRequire("bKaLx");

var $jcQWI = parcelRequire("jcQWI");

var $dIfKX = parcelRequire("dIfKX");

var $4fat5 = parcelRequire("4fat5");

var $5iELo = parcelRequire("5iELo");

var $lHtgo = parcelRequire("lHtgo");

var $jdbjz = parcelRequire("jdbjz");

var $chRXN = parcelRequire("chRXN");

var $ft8ez = parcelRequire("ft8ez");

var $bZDhf = parcelRequire("bZDhf");

var $7eN5N = parcelRequire("7eN5N");

});
parcelRegister("4o7Oq", function(module, exports) {

$parcel$export(module.exports, "default", () => $811855b910f5c28d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $811855b910f5c28d$var$SvgIconAcceptThin({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 15",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M0 7.5a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm7.072 3.21l4.318-5.398-.78-.624-3.682 4.601L4.32 7.116l-.64.768 3.392 2.827v-.001z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h15v15H0z"
                    })
                ]
            })
        ]
    });
}
var $811855b910f5c28d$export$2e2bcd8739ae039 = $811855b910f5c28d$var$SvgIconAcceptThin;

});

parcelRegister("ij7yF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fd42ab7a10754b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $61fd42ab7a10754b$var$SvgIconAccept({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M23.48 10.779l-1.363-1.374a.726.726 0 00-1.026 0l-8.55 8.48-3.616-3.645a.726.726 0 00-1.026 0L6.524 15.6a.726.726 0 000 1.026l5.49 5.535a.726.726 0 001.027 0l10.435-10.352a.726.726 0 000-1.026l.004-.004zM15 2.899c6.683 0 12.1 5.419 12.1 12.1 0 6.683-5.417 12.1-12.1 12.1S2.9 21.683 2.9 15C2.895 8.324 8.303 2.906 14.98 2.9H15zM15 0C6.716 0 0 6.717 0 15c0 8.286 6.716 15 15 15 8.285 0 15-6.714 15-15 0-8.283-6.715-15-15-15z"
            })
        ]
    });
}
var $61fd42ab7a10754b$export$2e2bcd8739ae039 = $61fd42ab7a10754b$var$SvgIconAccept;

});

parcelRegister("9IdeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0db98e0d0dfe61e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $c0db98e0d0dfe61e$var$SvgIconAlert({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 21 21",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M12.289 3.578l7.264 14.528A2 2 0 0117.764 21H3.236a2 2 0 01-1.789-2.894L8.711 3.578a2 2 0 013.578 0zM10.3 16.488c.409 0 .725.109.949.325.225.217.337.527.337.931 0 .389-.114.696-.34.92-.227.224-.542.336-.946.336-.413 0-.734-.11-.96-.329-.227-.219-.34-.528-.34-.927 0-.414.111-.726.332-.938.222-.212.545-.318.968-.318zM11.586 8l-.377 7.218H9.406L9.03 8h2.556z"
            })
        ]
    });
}
var $c0db98e0d0dfe61e$export$2e2bcd8739ae039 = $c0db98e0d0dfe61e$var$SvgIconAlert;

});

parcelRegister("kNH5k", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $cdfd03fcbfbf28bd$var$SvgIconArrowSmallDown({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 9 6",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M.5 0a.5.5 0 00-.374.832l4 4.5a.5.5 0 00.748 0l4-4.5A.5.5 0 008.5 0h-8z"
            })
        ]
    });
}
var $cdfd03fcbfbf28bd$export$2e2bcd8739ae039 = $cdfd03fcbfbf28bd$var$SvgIconArrowSmallDown;

});

parcelRegister("gc4wS", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac06b9b6349d9a3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $aac06b9b6349d9a3$var$SvgIconAssetMenu({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22 18",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        d: "M2 11.5h2.5c.688 0 1.25-.563 1.25-1.25v-2.5c0-.688-.563-1.25-1.25-1.25H2c-.688 0-1.25.563-1.25 1.25v2.5c0 .688.563 1.25 1.25 1.25zm0 6.25h2.5c.688 0 1.25-.563 1.25-1.25V14c0-.688-.563-1.25-1.25-1.25H2c-.688 0-1.25.563-1.25 1.25v2.5c0 .688.563 1.25 1.25 1.25zm0-12.5h2.5c.688 0 1.25-.563 1.25-1.25V1.5C5.75.812 5.187.25 4.5.25H2C1.312.25.75.813.75 1.5V4c0 .688.563 1.25 1.25 1.25zm6.25 6.25h12.5c.688 0 1.25-.563 1.25-1.25v-2.5c0-.688-.563-1.25-1.25-1.25H8.25C7.562 6.5 7 7.063 7 7.75v2.5c0 .688.563 1.25 1.25 1.25zm0 6.25h12.5c.688 0 1.25-.563 1.25-1.25V14c0-.688-.563-1.25-1.25-1.25H8.25C7.562 12.75 7 13.313 7 14v2.5c0 .688.563 1.25 1.25 1.25zM7 1.5V4c0 .688.563 1.25 1.25 1.25h12.5C21.438 5.25 22 4.687 22 4V1.5c0-.688-.563-1.25-1.25-1.25H8.25C7.562.25 7 .813 7 1.5z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-3-6h30v30H-3z"
                    })
                ]
            })
        ]
    });
}
var $aac06b9b6349d9a3$export$2e2bcd8739ae039 = $aac06b9b6349d9a3$var$SvgIconAssetMenu;

});

parcelRegister("h55D4", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d90e17305bb36a62$var$SvgIconAssets({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "currentColor",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.667 6.667h-12A.667.667 0 008 7.333V22c0 .368.298.667.667.667h12a.667.667 0 00.666-.667V7.333a.667.667 0 00-.666-.666zm-2 10.666h-8V16h8v1.333zm0-2.666h-8v-1.334h8v1.334zm0-2.667h-8v-1.333h8V12z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M4 16V2.667h12V2a.667.667 0 00-.667-.667h-12A.667.667 0 002.667 2v14.667c0 .368.298.666.666.666H4V16z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.667 18.667V5.333h12v-.666A.667.667 0 0018 4H6a.667.667 0 00-.667.667v14.666c0 .369.299.667.667.667h.667v-1.333z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $d90e17305bb36a62$export$2e2bcd8739ae039 = $d90e17305bb36a62$var$SvgIconAssets;

});

parcelRegister("hTUUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1985a6b447b1f4f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $a1985a6b447b1f4f$var$SvgIconAttachment({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 30 30",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M24.558 4.474c-1.665-1.47-4.367-1.47-6.031 0L5.974 15.55c-2.872 2.535-2.872 6.64 0 9.175 2.872 2.535 7.525 2.535 10.397 0l10.37-9.15c.743-.657 1.958-.657 2.701 0 .744.655.744 1.727 0 2.383l-10.37 9.151c-4.366 3.853-11.434 3.853-15.8 0-4.363-3.853-4.363-10.09 0-13.943L15.825 2.09c3.159-2.787 8.276-2.787 11.434 0 3.159 2.786 3.159 7.302 0 10.09L15.252 22.776c-1.951 1.721-5.117 1.721-7.068 0-1.952-1.722-1.952-4.516 0-6.238l9.824-8.669c.744-.656 1.958-.656 2.702 0 .743.656.743 1.728 0 2.384l-9.824 8.67a.958.958 0 000 1.469 1.296 1.296 0 001.664 0L24.558 9.796c1.664-1.47 1.664-3.853 0-5.322z"
            })
        ]
    });
}
var $a1985a6b447b1f4f$export$2e2bcd8739ae039 = $a1985a6b447b1f4f$var$SvgIconAttachment;

});

parcelRegister("eY7ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea1922dd39f3a37$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $dea1922dd39f3a37$var$SvgIconBin({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M9 3v1H4v2h1v13a2 2 0 002 2h10a2 2 0 002-2V6h1V4h-5V3H9m0 5h2v9H9V8m4 0h2v9h-2V8z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $dea1922dd39f3a37$export$2e2bcd8739ae039 = $dea1922dd39f3a37$var$SvgIconBin;

});

parcelRegister("9c2AV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede8f79fa9468ac8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $ede8f79fa9468ac8$var$SvgIconCalendar({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M21 20V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zM9 18H7v-2h2v2zm0-4H7v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm2-5H5V7h14v2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $ede8f79fa9468ac8$export$2e2bcd8739ae039 = $ede8f79fa9468ac8$var$SvgIconCalendar;

});

parcelRegister("h5KXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $474cbfa828d5d307$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $474cbfa828d5d307$var$SvgIconChangeTracking({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M3.001 10.12h6.78L7.041 7.3c2.73-2.7 7.15-2.8 9.88-.1a6.875 6.875 0 010 9.79 7.02 7.02 0 01-9.88 0c-1.36-1.34-2.04-2.91-2.04-4.89h-2c0 1.98.88 4.55 2.64 6.29 3.51 3.48 9.21 3.48 12.72 0 3.5-3.47 3.53-9.11.02-12.58a8.987 8.987 0 00-12.65 0L3.001 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $474cbfa828d5d307$export$2e2bcd8739ae039 = $474cbfa828d5d307$var$SvgIconChangeTracking;

});

parcelRegister("chuvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $434ff44c013fc2ab$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $434ff44c013fc2ab$var$SvgIconClose({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M18.75 17L17 18.75l-4.5-4.5-4.5 4.5L6.25 17l4.5-4.5L6.25 8 8 6.25l4.5 4.5 4.5-4.5L18.75 8l-4.501 4.5L18.75 17zM12.5 0C5.596 0 0 5.597 0 12.5 0 19.404 5.596 25 12.5 25 19.403 25 25 19.404 25 12.5 25.024 5.621 19.467.025 12.587 0H12.5z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-2-3h30v30H-2z"
                    })
                ]
            })
        ]
    });
}
var $434ff44c013fc2ab$export$2e2bcd8739ae039 = $434ff44c013fc2ab$var$SvgIconClose;

});

parcelRegister("irSmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $948b906a3301d58b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $948b906a3301d58b$var$SvgIconCog({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 438.529 438.529",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M436.25 181.438c-1.529-2.002-3.524-3.193-5.995-3.571l-52.249-7.992c-2.854-9.137-6.756-18.461-11.704-27.98 3.422-4.758 8.559-11.466 15.41-20.129 6.851-8.661 11.703-14.987 14.561-18.986 1.523-2.094 2.279-4.281 2.279-6.567 0-2.663-.66-4.755-1.998-6.28-6.848-9.708-22.552-25.885-47.106-48.536-2.275-1.903-4.661-2.854-7.132-2.854-2.857 0-5.14.855-6.854 2.567l-40.539 30.549c-7.806-3.999-16.371-7.52-25.693-10.565l-7.994-52.529c-.191-2.474-1.287-4.521-3.285-6.139C255.95.806 253.623 0 250.954 0h-63.38c-5.52 0-8.947 2.663-10.278 7.993-2.475 9.513-5.236 27.214-8.28 53.1a163.366 163.366 0 00-25.981 10.853l-39.399-30.549c-2.474-1.903-4.948-2.854-7.422-2.854-4.187 0-13.179 6.804-26.979 20.413-13.8 13.612-23.169 23.841-28.122 30.69-1.714 2.474-2.568 4.664-2.568 6.567 0 2.286.95 4.57 2.853 6.851 12.751 15.42 22.936 28.549 30.55 39.403-4.759 8.754-8.47 17.511-11.132 26.265l-53.105 7.992c-2.093.382-3.9 1.621-5.424 3.715C.76 182.531 0 184.722 0 187.002v63.383c0 2.478.76 4.709 2.284 6.708 1.524 1.998 3.521 3.195 5.996 3.572l52.25 7.71c2.663 9.325 6.564 18.743 11.704 28.257-3.424 4.761-8.563 11.468-15.415 20.129-6.851 8.665-11.709 14.989-14.561 18.986-1.525 2.102-2.285 4.285-2.285 6.57 0 2.471.666 4.658 1.997 6.561 7.423 10.284 23.125 26.272 47.109 47.969 2.095 2.094 4.475 3.138 7.137 3.138 2.857 0 5.236-.852 7.138-2.563l40.259-30.553c7.808 3.997 16.371 7.519 25.697 10.568l7.993 52.529c.193 2.471 1.287 4.518 3.283 6.14 1.997 1.622 4.331 2.423 6.995 2.423h63.38c5.53 0 8.952-2.662 10.287-7.994 2.471-9.514 5.229-27.213 8.274-53.098a163.044 163.044 0 0025.981-10.855l39.402 30.84c2.663 1.712 5.141 2.563 7.42 2.563 4.186 0 13.131-6.752 26.833-20.27 13.709-13.511 23.13-23.79 28.264-30.837 1.711-1.902 2.569-4.09 2.569-6.561 0-2.478-.947-4.862-2.857-7.139-13.698-16.754-23.883-29.882-30.546-39.402 3.806-7.043 7.519-15.701 11.136-25.98l52.817-7.988c2.279-.383 4.189-1.622 5.708-3.716 1.523-2.098 2.279-4.288 2.279-6.571v-63.376c.005-2.474-.751-4.707-2.278-6.707zm-165.304 89.501c-14.271 14.277-31.497 21.416-51.676 21.416-20.177 0-37.401-7.139-51.678-21.416-14.272-14.271-21.411-31.498-21.411-51.673 0-20.177 7.135-37.401 21.411-51.678 14.277-14.272 31.504-21.411 51.678-21.411 20.179 0 37.406 7.139 51.676 21.411 14.274 14.277 21.413 31.501 21.413 51.678 0 20.175-7.138 37.403-21.413 51.673z"
            })
        ]
    });
}
var $948b906a3301d58b$export$2e2bcd8739ae039 = $948b906a3301d58b$var$SvgIconCog;

});

parcelRegister("ctM8Y", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $97f6f9d8324e9d87$var$SvgIconCollapseHeaderArrow({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 9",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.62 8.987L7.202 3.569 1.784 8.987 0 7.203 7.202 0l7.203 7.203z"
            })
        ]
    });
}
var $97f6f9d8324e9d87$export$2e2bcd8739ae039 = $97f6f9d8324e9d87$var$SvgIconCollapseHeaderArrow;

});

parcelRegister("rSxjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf00a7766cc2a111$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $cf00a7766cc2a111$var$SvgIconCollapseUp({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M0 0v2.5h20V0H0zm10 7.5l-5 5h10l-5-5zM0 15v5h20v-5H0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h20v20H0z"
                    })
                ]
            })
        ]
    });
}
var $cf00a7766cc2a111$export$2e2bcd8739ae039 = $cf00a7766cc2a111$var$SvgIconCollapseUp;

});

parcelRegister("hHsFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c89c86c3b0661e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e2c89c86c3b0661e$var$SvgIconComment({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M13 4C7.477 4 3 7.637 3 12.125c0 1.938.836 3.71 2.227 5.105-.489 1.97-2.122 3.723-2.141 3.743a.31.31 0 00-.059.34c.051.117.16.187.285.187 2.59 0 4.532-1.242 5.493-2.008A11.92 11.92 0 0013 20.25c5.523 0 10-3.637 10-8.125C23 7.637 18.523 4 13 4z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                ]
            })
        ]
    });
}
var $e2c89c86c3b0661e$export$2e2bcd8739ae039 = $e2c89c86c3b0661e$var$SvgIconComment;

});

parcelRegister("7wpDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a71d324ca99d06$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e4a71d324ca99d06$var$SvgIconComments({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M18.857 7.286c0 1.24-.42 2.388-1.259 3.442-.84 1.053-1.984 1.886-3.435 2.497-1.45.612-3.03.918-4.734.918-.768 0-1.554-.072-2.358-.214a11.264 11.264 0 01-3.723 1.714c-.321.08-.705.152-1.152.214h-.04a.418.418 0 01-.274-.107.442.442 0 01-.154-.281.274.274 0 01-.014-.087.53.53 0 01.007-.087.284.284 0 01.027-.08l.033-.068.047-.073.054-.067.06-.067.054-.06a9.36 9.36 0 01.308-.335c.16-.17.276-.302.348-.395.071-.094.172-.224.301-.389a3.39 3.39 0 00.335-.515c.094-.179.185-.375.275-.59-1.108-.643-1.978-1.433-2.612-2.37C.317 9.348 0 8.348 0 7.286c0-1.241.42-2.389 1.259-3.442.84-1.054 1.984-1.886 3.435-2.498C6.145.734 7.724.429 9.43.429c1.705 0 3.283.305 4.734.917 1.45.612 2.596 1.444 3.435 2.498.84 1.053 1.26 2.2 1.26 3.442zM24 10.714c0 1.072-.317 2.074-.95 3.007-.635.933-1.505 1.721-2.613 2.364.09.214.181.41.275.59.094.178.205.35.335.515.13.165.23.294.301.388.072.094.188.226.348.395a9.36 9.36 0 01.362.395c.027.032.047.054.06.067a.57.57 0 01.054.067.604.604 0 01.047.074l.033.067.027.08.007.087-.014.087a.496.496 0 01-.174.295.404.404 0 01-.294.094 11.26 11.26 0 01-1.152-.215 11.264 11.264 0 01-3.723-1.714 13.45 13.45 0 01-2.358.214c-2.42 0-4.526-.589-6.321-1.767.518.035.91.053 1.179.053 1.437 0 2.817-.2 4.138-.603 1.321-.401 2.5-.977 3.536-1.727 1.116-.822 1.973-1.768 2.571-2.84a6.874 6.874 0 00.59-5.437c1.151.634 2.062 1.429 2.732 2.384.67.955 1.004 1.982 1.004 3.08z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0-3h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $e4a71d324ca99d06$export$2e2bcd8739ae039 = $e4a71d324ca99d06$var$SvgIconComments;

});

parcelRegister("2D4bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e4534929b127638$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $1e4534929b127638$var$SvgIconDeferral({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M17.776.04a1.63 1.63 0 011.951 1.232l1.62 7.163a1.632 1.632 0 01-1.232 1.951L12.978 12a1.632 1.632 0 01-.72-3.183l3.17-.717a6.593 6.593 0 00-2.58-.532 6.592 6.592 0 00-6.585 6.584 6.592 6.592 0 006.585 6.585 1.632 1.632 0 110 3.263C7.418 24 3 19.582 3 14.152c0-5.43 4.418-9.848 9.848-9.848a9.87 9.87 0 014.46 1.07l-.764-3.382A1.631 1.631 0 0117.776.041zm-.453 19.29a1.652 1.652 0 110 3.303 1.652 1.652 0 010-3.304zm2.963-3.585a1.645 1.645 0 110 3.29 1.645 1.645 0 010-3.29z"
                    })
                ]
            })
        ]
    });
}
var $1e4534929b127638$export$2e2bcd8739ae039 = $1e4534929b127638$var$SvgIconDeferral;

});

parcelRegister("57bqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde2c9e5ba0bcbc9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
const $bde2c9e5ba0bcbc9$var$SvgIconDicom = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: 48,
        height: 50,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.803 3.18c0-.559 0-.948.025-1.252.024-.297.068-.469.133-.598a1.5 1.5 0 0 1 .672-.672c.13-.065.3-.11.598-.133C6.535.5 6.924.5 7.483.5h10.032v3.094c0 .258 0 .482.014.666.016.194.05.388.144.575.145.29.38.526.671.671.187.093.38.128.575.143.184.015.408.015.667.015h3.217V21.82c0 .559 0 .948-.025 1.252-.024.297-.068.469-.133.599a1.5 1.5 0 0 1-.672.67c-.13.066-.3.11-.598.134-.304.025-.693.025-1.252.025H7.483c-.559 0-.948 0-1.252-.025-.297-.024-.469-.068-.598-.133a1.5 1.5 0 0 1-.672-.671c-.065-.13-.11-.302-.133-.6a17.34 17.34 0 0 1-.025-1.251V3.18Z",
                stroke: "#80A6A8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0 14.199a1 1 0 0 1 1-1h19.58a1 1 0 0 1 1 1v4.08a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V14.2Z",
                fill: "#4E898C"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0 14.199a1 1 0 0 1 1-1h19.58a1 1 0 0 1 1 1v4.08a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V14.2Z",
                stroke: "#80A6A8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.908 18.24H1.465v-4.073H2.92c.41 0 .763.081 1.058.244.296.162.523.395.682.698.16.304.241.667.241 1.09 0 .424-.08.789-.24 1.094-.16.305-.388.539-.687.702-.297.163-.652.244-1.066.244Zm-.582-.738h.547c.254 0 .468-.046.642-.136a.87.87 0 0 0 .394-.423c.089-.193.133-.44.133-.744 0-.301-.044-.547-.133-.738a.863.863 0 0 0-.392-.421 1.383 1.383 0 0 0-.642-.136h-.55v2.598ZM6.4 14.166v4.072h-.861v-4.073H6.4Zm4.302 1.425H9.83a.852.852 0 0 0-.098-.3.764.764 0 0 0-.188-.227.833.833 0 0 0-.267-.143 1.02 1.02 0 0 0-.324-.05.967.967 0 0 0-.551.158 1.003 1.003 0 0 0-.364.453c-.086.197-.13.438-.13.72 0 .29.044.534.13.732.088.197.21.346.366.447a.98.98 0 0 0 .543.151c.115 0 .222-.015.32-.045a.767.767 0 0 0 .455-.35.845.845 0 0 0 .108-.29l.87.003a1.626 1.626 0 0 1-.529 1.004c-.149.136-.328.243-.536.323-.207.078-.44.117-.702.117-.363 0-.688-.082-.974-.247a1.75 1.75 0 0 1-.677-.714c-.164-.311-.246-.688-.246-1.131 0-.444.083-.822.25-1.134.167-.311.394-.549.68-.712.287-.164.61-.246.967-.246.236 0 .455.033.656.1.203.066.383.162.54.29.156.126.283.28.381.463.1.183.163.392.19.628Zm4.36.61c0 .445-.084.823-.253 1.134a1.75 1.75 0 0 1-.684.714 1.932 1.932 0 0 1-.97.245c-.362 0-.687-.082-.974-.247a1.754 1.754 0 0 1-.683-.714c-.167-.311-.25-.688-.25-1.131 0-.444.083-.822.25-1.134.167-.311.395-.549.683-.712.287-.164.612-.246.974-.246.36 0 .683.082.97.246.29.164.517.4.684.712.169.312.253.69.253 1.134Zm-.873 0c0-.287-.043-.53-.13-.727a.985.985 0 0 0-.36-.45.968.968 0 0 0-.544-.152.968.968 0 0 0-.545.153.997.997 0 0 0-.362.45c-.085.197-.127.44-.127.727 0 .288.042.53.127.728a.997.997 0 0 0 .362.45.968.968 0 0 0 .545.152c.208 0 .39-.05.545-.153a.985.985 0 0 0 .36-.45c.086-.197.129-.44.129-.727Zm1.51-2.036h1.063l1.121 2.737h.048l1.122-2.736h1.062v4.072h-.836v-2.65h-.033l-1.054 2.63h-.57l-1.053-2.64h-.034v2.66H15.7v-4.073Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                stroke: "#80A6A8",
                d: "m17.683.404 5.241 5.089"
            })
        ]
    });
var $bde2c9e5ba0bcbc9$export$2e2bcd8739ae039 = $bde2c9e5ba0bcbc9$var$SvgIconDicom;

});

parcelRegister("1xXym", function(module, exports) {

$parcel$export(module.exports, "default", () => $478982cb6714762d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $478982cb6714762d$var$SvgIconDownload({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29.978 29.978",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M25.462 19.105v6.848H4.515v-6.848H.489v8.861c0 1.111.9 2.012 2.016 2.012h24.967c1.115 0 2.016-.9 2.016-2.012v-8.861h-4.026zm-10.842-.679l-5.764-6.965s-.877-.828.074-.828h3.248V.494S12.049 0 12.793 0h4.572c.536 0 .524.416.524.416v10.008h2.998c1.154 0 .285.867.285.867s-4.904 6.51-5.588 7.193c-.492.495-.964-.058-.964-.058z"
            })
        ]
    });
}
var $478982cb6714762d$export$2e2bcd8739ae039 = $478982cb6714762d$var$SvgIconDownload;

});

parcelRegister("fcxUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb9822b7d629ccd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $deb9822b7d629ccd$var$SvgIconDrag({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 10 16",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-7-4h24v24H-7z"
                    })
                ]
            })
        ]
    });
}
var $deb9822b7d629ccd$export$2e2bcd8739ae039 = $deb9822b7d629ccd$var$SvgIconDrag;

});

parcelRegister("3kOP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b283053d497124$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $40b283053d497124$var$SvgIconExclamation({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 51 51",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M35.294 5.527a2.076 2.076 0 00-1.472-.61H17.154a2.075 2.075 0 00-1.473.61L5.265 15.944a2.076 2.076 0 00-.61 1.473v16.666c0 .555.219 1.084.61 1.473l10.417 10.417a2.074 2.074 0 001.473.61H33.82a2.07 2.07 0 001.473-.61L45.71 35.556a2.074 2.074 0 00.61-1.473V17.417a2.076 2.076 0 00-.61-1.473L35.294 5.527zm-7.722 30.64h-4.167V32h4.166v4.167zm0-8.334h-4.167v-12.5h4.166v12.5z"
            })
        ]
    });
}
var $40b283053d497124$export$2e2bcd8739ae039 = $40b283053d497124$var$SvgIconExclamation;

});

parcelRegister("l8Ars", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21360106db93fee$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b21360106db93fee$var$SvgIconExitFullscreen = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5 2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H5V2.5a.5.5 0 0 1 .5-.5Zm4 0a.5.5 0 0 1 .5.5V5h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5ZM2 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V10H2.5a.5.5 0 0 1-.5-.5Zm7 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H10v2.5a.5.5 0 0 1-1 0v-3Z",
            fill: "currentColor"
        })
    });
var $b21360106db93fee$export$2e2bcd8739ae039 = $b21360106db93fee$var$SvgIconExitFullscreen;

});

parcelRegister("hA7qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f704fe2e917f2c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $27f704fe2e917f2c$var$SvgIconExpandDown({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M0 0v2.5h20V0H0zm5 5l5 5 5-5H5zM0 15v5h20v-5H0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h20v20H0z"
                    })
                ]
            })
        ]
    });
}
var $27f704fe2e917f2c$export$2e2bcd8739ae039 = $27f704fe2e917f2c$var$SvgIconExpandDown;

});

parcelRegister("h909q", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $447b564a6930f3ae$var$SvgIconExpandHeaderArrow({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 9",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.62 0L7.202 5.418 1.784 0 0 1.784l7.202 7.203 7.203-7.203z"
            })
        ]
    });
}
var $447b564a6930f3ae$export$2e2bcd8739ae039 = $447b564a6930f3ae$var$SvgIconExpandHeaderArrow;

});

parcelRegister("518YH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7e4f710d5b301a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $bd7e4f710d5b301a$var$SvgIconEye({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 18",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0-1h30v21H0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        d: "M15.032 0c3.369 0 6.407.834 9.115 2.503S28.806 6.338 30 9c-1.194 2.662-3.145 4.828-5.853 6.497C21.44 17.166 18.401 18 15.032 18c-3.369 0-6.418-.834-9.147-2.503C3.155 13.828 1.194 11.662 0 9c1.194-2.662 3.156-4.828 5.885-6.497C8.615.834 11.663 0 15.032 0zm0 15.019c1.876 0 3.475-.59 4.797-1.772 1.322-1.181 1.983-2.597 1.983-4.247s-.66-3.066-1.983-4.247c-1.322-1.181-2.92-1.772-4.797-1.772-1.876 0-3.486.59-4.83 1.772C8.86 5.934 8.189 7.35 8.189 9s.671 3.066 2.015 4.247c1.343 1.181 2.953 1.772 4.829 1.772zM15 5.4c1.13 0 2.1.347 2.91 1.04.81.694 1.216 1.548 1.216 2.56s-.405 1.866-1.216 2.56c-.81.693-1.78 1.04-2.91 1.04-1.13 0-2.09-.347-2.878-1.04-.79-.694-1.184-1.548-1.184-2.56s.395-1.866 1.184-2.56C12.91 5.748 13.87 5.4 15 5.4z"
                    })
                ]
            })
        ]
    });
}
var $bd7e4f710d5b301a$export$2e2bcd8739ae039 = $bd7e4f710d5b301a$var$SvgIconEye;

});

parcelRegister("8Jzjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0703b6dc86ed205e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $0703b6dc86ed205e$var$SvgIconFiles({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 22",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "currentColor",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M18.667 5.667h-12A.667.667 0 006 6.333V21c0 .368.298.667.667.667h12a.667.667 0 00.666-.667V6.333a.667.667 0 00-.666-.666zm-2 10.666h-8V15h8v1.333zm0-2.666h-8v-1.334h8v1.334zm0-2.667h-8V9.667h8V11z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M2 15V1.667h12V1a.667.667 0 00-.667-.667h-12A.667.667 0 00.667 1v14.667c0 .368.298.666.666.666H2V15z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M4.667 17.667V4.333h12v-.666A.667.667 0 0016 3H4a.667.667 0 00-.667.667v14.666c0 .369.299.667.667.667h.667v-1.333z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-2-1h24v24H-2z"
                    })
                ]
            })
        ]
    });
}
var $0703b6dc86ed205e$export$2e2bcd8739ae039 = $0703b6dc86ed205e$var$SvgIconFiles;

});

parcelRegister("khgu4", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $779db97d812cb84e$var$SvgIconFlag({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 23",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M17.693.118A.692.692 0 0118 .692v10.385a.693.693 0 01-.435.642l-.257-.642.257.642-.004.002-.008.004-.032.012a30.2 30.2 0 01-2 .693c-1.13.349-2.601.724-3.752.724-1.172 0-2.143-.388-2.988-.727l-.039-.014c-.877-.353-1.625-.644-2.511-.644-.97 0-2.268.319-3.375.66-.495.155-.986.324-1.471.506v8.527a.693.693 0 01-1.385 0V.692a.692.692 0 111.385 0v.39a30.95 30.95 0 011.093-.36C3.608.378 5.082 0 6.231 0c1.163 0 2.11.384 2.937.719l.06.025c.86.347 1.61.64 2.541.64.97 0 2.268-.318 3.374-.66a27.205 27.205 0 001.868-.659l.027-.01.005-.002h.002"
            })
        ]
    });
}
var $779db97d812cb84e$export$2e2bcd8739ae039 = $779db97d812cb84e$var$SvgIconFlag;

});

parcelRegister("6Hpf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0cc7cc4e7edcd1a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $a0cc7cc4e7edcd1a$var$SvgIconFolder({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M24.528 9.542a1.188 1.188 0 00-1.007-.514H7.757a1.799 1.799 0 00-1.563 1.055.694.694 0 000 .098l-2.027 7.18v-12.5h4.507l1.812 2.493c.131.18.34.285.563.285h11.173a1.39 1.39 0 00-1.389-1.389h-9.43L9.799 4.042a1.389 1.389 0 00-1.125-.57H4.167a1.39 1.39 0 00-1.39 1.39v15.756c.023.52.46.925.98.91h17.312a.694.694 0 00.695-.5l2.91-10.486a1.14 1.14 0 00-.146-1z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                ]
            })
        ]
    });
}
var $a0cc7cc4e7edcd1a$export$2e2bcd8739ae039 = $a0cc7cc4e7edcd1a$var$SvgIconFolder;

});

parcelRegister("18DPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e01bb2a932bd17$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $62e01bb2a932bd17$var$SvgIconFullscreen = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3Zm7 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V3H9.5a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 1 .5.5V12h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm10 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H12V9.5a.5.5 0 0 1 .5-.5Z",
            fill: "currentColor"
        })
    });
var $62e01bb2a932bd17$export$2e2bcd8739ae039 = $62e01bb2a932bd17$var$SvgIconFullscreen;

});

parcelRegister("1P0Mf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f3fedfd04f3d37b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $7f3fedfd04f3d37b$var$SvgIconFurtherDetails({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 40 45",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8 0a4.5 4.5 0 00-4.5 4.5V12h-3v3h3v15h-3v3h3v7.5A4.5 4.5 0 008 45h27a4.5 4.5 0 004.5-4.5v-36A4.5 4.5 0 0035 0H8zm7.5 15a6 6 0 1112 0 6 6 0 01-12 0zm-3 18a9 9 0 0118 0v3h-18v-3z",
                clipRule: "evenodd"
            })
        ]
    });
}
var $7f3fedfd04f3d37b$export$2e2bcd8739ae039 = $7f3fedfd04f3d37b$var$SvgIconFurtherDetails;

});

parcelRegister("cunZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b807a5cf6fb9dd31$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $b807a5cf6fb9dd31$var$SvgIconGrid({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M0 7.257h6.452V0H0zm8.871 0h6.452V0H8.87zm8.872 0h6.45V0h-6.45zM0 16.128h6.452V8.87H0zm8.871.001h6.452V8.871H8.87zm8.872-.001h6.45V8.87h-6.45zM0 25h6.452v-7.258H0zm8.871 0h6.452v-7.258H8.87zm8.872 0h6.45v-7.258h-6.45z"
            })
        ]
    });
}
var $b807a5cf6fb9dd31$export$2e2bcd8739ae039 = $b807a5cf6fb9dd31$var$SvgIconGrid;

});

parcelRegister("fllUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5681979ec54a8c93$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $5681979ec54a8c93$var$SvgIconHandshake({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 16",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M16.98.5h-3.355a1.25 1.25 0 00-.844.328l-3.84 3.516-.011.015a1.554 1.554 0 00-.082 2.188c.496.543 1.539.687 2.191.105.004-.004.012-.004.016-.007l3.12-2.86a.624.624 0 11.844.922L14 5.641l5.688 4.617c.113.094.214.195.308.3V3L17.863.867A1.241 1.241 0 0016.98.5zm4.27 2.508v8.746c0 .691.559 1.25 1.25 1.25H25V3.008h-3.75zm1.875 8.746a.627.627 0 01-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625a.627.627 0 01-.625.625zM0 13h2.5a1.25 1.25 0 001.25-1.25V3.008H0V13zm1.875-2.496c.344 0 .625.281.625.625a.627.627 0 01-.625.625.624.624 0 110-1.25zm17.027.726L13.07 6.496 11.898 7.57a2.816 2.816 0 01-3.972-.172 2.814 2.814 0 01.172-3.972L11.293.5H8.02c-.332 0-.649.133-.883.367L5 3v8.746h.715l3.535 3.2a2.5 2.5 0 003.516-.364l.007-.008.7.606c.62.508 1.539.41 2.043-.211l1.226-1.508.211.172a1.248 1.248 0 001.758-.184l.371-.457a1.252 1.252 0 00-.18-1.762z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0-2h25v20H0z"
                    })
                ]
            })
        ]
    });
}
var $5681979ec54a8c93$export$2e2bcd8739ae039 = $5681979ec54a8c93$var$SvgIconHandshake;

});

parcelRegister("8xwyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3525b7202247e8f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e3525b7202247e8f$var$SvgIconHome({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M21.743 12.331l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A.998.998 0 003 14h2v7a1 1 0 001 1h3a1 1 0 001-1v-4h4v4a1 1 0 001 1h3a1 1 0 001-1v-7h2a.998.998 0 00.743-1.669z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $e3525b7202247e8f$export$2e2bcd8739ae039 = $e3525b7202247e8f$var$SvgIconHome;

});

parcelRegister("fioxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $34f987d26c87aad2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $34f987d26c87aad2$var$SvgIconImage({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M49.2 1.5c-3 .7-9.2 3.2-14 5.5-12.5 6.2-22.4 16.3-28.5 29.1-2.5 5.2-5 11.8-5.6 14.7-1.5 7.5-1.5 402.9 0 410.4.6 2.9 3.1 9.5 5.6 14.7 3.7 7.7 5.9 10.8 12.2 17.2 6.4 6.3 9.5 8.5 17.2 12.2 5.2 2.5 11.8 5 14.7 5.6 7.5 1.5 402.9 1.5 410.4 0 2.9-.6 9.5-3.1 14.7-5.6 13.3-6.4 23-16.1 29.4-29.4 2.5-5.2 5-11.8 5.6-14.7 1.5-7.5 1.5-402.9 0-410.4-.6-2.9-3.1-9.5-5.6-14.7-6.4-13.3-16.1-23-29.4-29.4-5.2-2.5-11.8-5-14.7-5.6-8.3-1.7-404.9-1.4-412 .4zm409.5 31.6c8 3 17.2 12.2 20.2 20.2l2.1 5.8-.2 109.1-.3 109.1-35.6-43.9c-19.6-24.2-37.2-45.3-39.1-47-8.7-7.6-21.1-11.2-32.5-9.4-14.5 2.3-11-.7-89.3 77.6L212.5 326l-2.5-2.4c-7.3-7-52.2-43.1-56.1-45.1-12.2-6.2-29.1-5.2-40.3 2.3-2.2 1.5-21.5 17.7-43 35.9L31.5 350l-.3-145.5L31 59.1l2.2-5.8c2.9-8 11.2-16.5 19.3-19.8l6-2.5h394.4l5.8 2.1zM433 268.5l47.9 59 .1 62.7c0 61.6 0 62.8-2.1 68.5-3 8-12.2 17.2-20.2 20.2l-5.8 2.1H59.1l-5.8-2.1c-8-3-17.2-12.2-20.2-20.2-2-5.4-2.1-7.6-2.1-36.5l.1-30.7 49.4-42c27.2-23.1 50.8-42.6 52.4-43.2 2.1-.9 3.8-1 5.6-.3 1.4.5 9.2 6.5 17.3 13.3 53.5 44.8 53.7 45 62.5 42.7 3.8-1 12.1-9.1 80.2-77.5 53.8-54.2 76.7-76.5 78.5-76.8 1.4-.2 3.7.2 5.3.7 1.9.8 18.1 20 50.7 60.1z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M143.5 64.6c-3.3.8-10.3 3.5-15.5 6.1-7.9 3.9-10.9 6.1-18 13.3-9.8 9.8-14 16.5-18.3 28.8-2.8 8-3 9.9-3.1 22.2-.1 11.5.3 14.6 2.2 21 7.9 25.1 26 43.1 50.7 50.2 6.2 1.7 10.6 2.3 19.5 2.3 14.1 0 19.6-1.3 32.9-7.7 9-4.3 11.6-6.2 18.5-13.2 14.4-14.4 20.5-28.5 21.3-48.6.7-17.7-3.2-31.7-12.7-45.5-9.6-14-25.9-24.9-43.2-29-8-1.9-26.3-1.8-34.3.1zm34.8 33.1c11.5 5.4 20.1 15.6 23.3 27.8 7.6 28.2-17.6 56-46.6 51.4-8.9-1.3-16.5-5.2-23.1-11.8-21.9-22-13.9-57.6 15.5-68.8 5.1-1.9 7.6-2.3 15.1-2 7.7.2 10 .7 15.8 3.4z"
                    })
                ]
            })
        ]
    });
}
var $34f987d26c87aad2$export$2e2bcd8739ae039 = $34f987d26c87aad2$var$SvgIconImage;

});

parcelRegister("e11eN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28328e262c69d65$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d28328e262c69d65$var$SvgIconLink({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M10.156 18.076l-.99.955a2.262 2.262 0 01-3.108 0 2.061 2.061 0 01-.638-1.485c0-.558.23-1.093.638-1.486l3.64-3.506c.753-.728 2.172-1.798 3.207-.801.303.314.758.442 1.187.334.43-.108.763-.435.871-.852a1.156 1.156 0 00-.352-1.152c-1.756-1.694-4.355-1.381-6.618.801l-3.64 3.508a4.351 4.351 0 000 6.308 4.686 4.686 0 003.26 1.3 4.679 4.679 0 003.26-1.3l.99-.956c.228-.219.357-.517.358-.83a1.156 1.156 0 00-.352-.83 1.24 1.24 0 00-1.713-.008zM20.642 4.41c-1.894-1.79-4.541-1.886-6.292-.23l-1.235 1.17c-.308.29-.43.716-.319 1.115.111.399.437.711.855.82.418.108.865-.004 1.173-.295l1.236-1.17c.906-.858 2.095-.503 2.873.23.411.39.639.909.639 1.46 0 .552-.228 1.07-.64 1.46l-3.893 3.678c-1.78 1.68-2.615.893-2.971.556a1.255 1.255 0 00-1.173-.295 1.188 1.188 0 00-.855.82c-.11.4.01.824.318 1.115.818.772 1.751 1.155 2.728 1.155 1.197 0 2.461-.574 3.665-1.711l3.894-3.678A4.252 4.252 0 0022 7.511a4.245 4.245 0 00-1.358-3.101z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                ]
            })
        ]
    });
}
var $d28328e262c69d65$export$2e2bcd8739ae039 = $d28328e262c69d65$var$SvgIconLink;

});

parcelRegister("OPxe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e843f31a63cf0a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $10e843f31a63cf0a$var$SvgIconList({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M0 7.257h29.032V0H0zm0 8.871h29.032V8.87H0zM0 25h29.032v-7.258H0z"
            })
        ]
    });
}
var $10e843f31a63cf0a$export$2e2bcd8739ae039 = $10e843f31a63cf0a$var$SvgIconList;

});

parcelRegister("8lynw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8226fd6fca8b8b1e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $8226fd6fca8b8b1e$var$SvgIconLock({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 21",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M8.5.083a5.214 5.214 0 00-5.208 5.209v3.125H2.25C1.1 8.417.167 9.349.167 10.5v8.333c0 1.15.932 2.084 2.083 2.084h12.5c1.15 0 2.083-.933 2.083-2.084V10.5c0-1.15-.932-2.083-2.083-2.083h-1.042V5.292A5.214 5.214 0 008.5.083zM5.375 5.292A3.129 3.129 0 018.5 2.167a3.129 3.129 0 013.125 3.125v3.125h-6.25V5.292zm4.167 11.17v2.371H7.458v-2.372a2.076 2.076 0 01.591-3.83 2.084 2.084 0 012.534 2.036 2.073 2.073 0 01-1.041 1.794z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-4-2h25v25H-4z"
                    })
                ]
            })
        ]
    });
}
var $8226fd6fca8b8b1e$export$2e2bcd8739ae039 = $8226fd6fca8b8b1e$var$SvgIconLock;

});

parcelRegister("18j2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3969f0073a31f78d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $3969f0073a31f78d$var$SvgIconMeeting({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-2 8v2H7v-3h10v1zm2-3H5V7h14v2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $3969f0073a31f78d$export$2e2bcd8739ae039 = $3969f0073a31f78d$var$SvgIconMeeting;

});

parcelRegister("2XYVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cfad07f1bad81e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $54cfad07f1bad81e$var$SvgIconMenu({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 12",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M16.68 4.8H1.32C.658 4.8.6 5.336.6 6c0 .664.058 1.2.72 1.2h15.36c.662 0 .72-.536.72-1.2 0-.664-.058-1.2-.72-1.2zm0 4.8H1.32c-.662 0-.72.536-.72 1.2 0 .664.058 1.2.72 1.2h15.36c.662 0 .72-.536.72-1.2 0-.664-.058-1.2-.72-1.2zM1.32 2.4h15.36c.662 0 .72-.536.72-1.2 0-.664-.058-1.2-.72-1.2H1.32C.658 0 .6.536.6 1.2c0 .664.058 1.2.72 1.2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M-3-6h24v24H-3z"
                    })
                ]
            })
        ]
    });
}
var $54cfad07f1bad81e$export$2e2bcd8739ae039 = $54cfad07f1bad81e$var$SvgIconMenu;

});

parcelRegister("91duj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e6fe74f5321a78$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $f6e6fe74f5321a78$var$SvgIconMessageRead({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 27 19",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                stroke: "currentColor",
                strokeOpacity: 0.6,
                strokeWidth: 3,
                d: "M1.518 8.734l7.347 7.735L18.66 1m6.131.791L14.666 18.11"
            })
        ]
    });
}
var $f6e6fe74f5321a78$export$2e2bcd8739ae039 = $f6e6fe74f5321a78$var$SvgIconMessageRead;

});

parcelRegister("5AYDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3a19617f5848cf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $6b3a19617f5848cf$var$SvgIconMessage({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 35 35",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M31.111 0H3.89C1.744 0 0 1.57 0 3.5v21C0 26.43 1.744 28 3.889 28h6.805l6.806 7 6.806-7h6.805C33.256 28 35 26.43 35 24.5v-21C35 1.57 33.256 0 31.111 0zM11.667 17.5c-.511 0-1.017-.09-1.489-.267a3.944 3.944 0 01-1.262-.759 3.502 3.502 0 01-.843-1.136 3.199 3.199 0 01-.295-1.34c0-.46.1-.915.296-1.34.196-.424.482-.81.844-1.135.361-.325.79-.583 1.262-.759a4.266 4.266 0 011.489-.266c1.031 0 2.02.37 2.75 1.026.73.657 1.139 1.548 1.138 2.476 0 .928-.41 1.819-1.14 2.475-.73.657-1.719 1.025-2.75 1.025zm11.666 0c-.51 0-1.016-.09-1.488-.267a3.944 3.944 0 01-1.262-.759 3.5 3.5 0 01-.843-1.136 3.199 3.199 0 01-.296-1.34c0-.46.101-.915.297-1.34a3.5 3.5 0 01.843-1.135c.362-.325.79-.583 1.263-.759a4.267 4.267 0 011.488-.266c1.032 0 2.021.37 2.75 1.026.73.657 1.14 1.548 1.14 2.476-.001.928-.411 1.819-1.14 2.475-.73.657-1.72 1.025-2.752 1.025z"
            })
        ]
    });
}
var $6b3a19617f5848cf$export$2e2bcd8739ae039 = $6b3a19617f5848cf$var$SvgIconMessage;

});

parcelRegister("9rcVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $24122b823f6fb2eb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $24122b823f6fb2eb$var$SvgIconMicOff({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M26.667 15.111h-1.778c0 1.6-.445 3.111-1.245 4.445l1.334 1.333c1.066-1.778 1.6-3.733 1.689-5.778zm-4.445 0V8a6.13 6.13 0 00-6.31-6.133c-2.579 0-4.979 1.689-5.779 4.177L21.69 17.6c.355-.8.533-1.689.533-2.489zm.178 8.533l6.133 6.134 1.245-1.245L3.556 2.311 2.31 3.556l7.467 7.466v4.09A6.184 6.184 0 0016 21.332c1.156 0 2.222-.266 3.2-.889l1.956 1.956C19.644 23.467 17.866 24 16 24c-4.8.178-8.711-3.644-8.889-8.356v-.533H5.333c.09 5.511 4.267 10.133 9.778 10.667v2.666h-2.667c-.533 0-.888.356-.888.89 0 .533.355.888.888.888h7.112c.533 0 .888-.355.888-.889 0-.533-.355-.889-.888-.889h-2.667v-2.666c1.955-.178 3.911-.89 5.511-2.134z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $24122b823f6fb2eb$export$2e2bcd8739ae039 = $24122b823f6fb2eb$var$SvgIconMicOff;

});

parcelRegister("h8MLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7edd59e3c7f261$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $1f7edd59e3c7f261$var$SvgIconMicOn({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "currentColor",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16 21.333a6.184 6.184 0 006.222-6.222V8A6.184 6.184 0 0016 1.778 6.184 6.184 0 009.778 8v7.111A6.184 6.184 0 0016 21.333z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M26.667 15.111h-1.778C24.889 20 20.889 24 16 24c-4.889 0-8.889-4-8.889-8.889H5.333c0 5.6 4.267 10.133 9.778 10.578v2.755h-2.667c-.533 0-.888.356-.888.89 0 .533.355.888.888.888h7.112c.533 0 .888-.355.888-.889 0-.533-.355-.889-.888-.889h-2.667V25.69c5.511-.445 9.778-4.978 9.778-10.578z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $1f7edd59e3c7f261$export$2e2bcd8739ae039 = $1f7edd59e3c7f261$var$SvgIconMicOn;

});

parcelRegister("giMAJ", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $74228baf18ac39c9$var$SvgIconMinus({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5zm4.5 11.063a.188.188 0 01-.188.187H7.688a.188.188 0 01-.187-.188v-1.124c0-.104.084-.188.188-.188h8.625c.103 0 .187.084.187.188v1.124z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $74228baf18ac39c9$export$2e2bcd8739ae039 = $74228baf18ac39c9$var$SvgIconMinus;

});

parcelRegister("8tyXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2475e39d3983767d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $2475e39d3983767d$var$SvgIconNa({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M7.13 22.869A11.13 11.13 0 015.88 8.618l15.5 15.499a11.129 11.129 0 01-14.25-1.248zM22.87 7.13a11.13 11.13 0 011.25 14.253l-15.5-15.5a11.13 11.13 0 0114.253 1.25l-.003-.002zM14.999 0C6.717 0 0 6.716 0 15c0 8.285 6.717 15 15 15 8.285 0 15-6.715 15-15 0-8.284-6.715-15-15-15z"
            })
        ]
    });
}
var $2475e39d3983767d$export$2e2bcd8739ae039 = $2475e39d3983767d$var$SvgIconNa;

});

parcelRegister("kDaeH", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $3d83e4d0dea34ada$var$SvgIconNote({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M15.714 16.714v5.572H3.286a1.24 1.24 0 01-.911-.375A1.24 1.24 0 012 21V3c0-.357.125-.66.375-.91s.554-.376.91-.376h18c.358 0 .661.125.911.375s.375.554.375.911v12.429H17c-.357 0-.66.125-.91.375a1.24 1.24 0 00-.376.91zm1.715.429h5.102c-.134.732-.424 1.321-.87 1.768l-2.465 2.464c-.446.446-1.035.737-1.767.87v-5.102z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $3d83e4d0dea34ada$export$2e2bcd8739ae039 = $3d83e4d0dea34ada$var$SvgIconNote;

});

parcelRegister("bbiXR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a7285aa84cb84e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $a4a7285aa84cb84e$var$SvgIconNotification({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M5.705 3.71l-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42l-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 002.818-2H9.182A2.98 2.98 0 0012 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742A1.99 1.99 0 0012 2a1.99 1.99 0 00-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 003 17v1a1 1 0 001 1h16a1 1 0 001-1v-1a.996.996 0 00-.293-.707L19 14.586z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $a4a7285aa84cb84e$export$2e2bcd8739ae039 = $a4a7285aa84cb84e$var$SvgIconNotification;

});

parcelRegister("8BOWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7c2da67094d81c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $fd7c2da67094d81c$var$SvgIconOptions({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 37",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M17.506 36.234c9.665 0 17.5-7.996 17.5-17.859 0-9.863-7.835-17.86-17.5-17.86S.006 8.513.006 18.376s7.835 17.86 17.5 17.86zm-7.5-15.308a2.475 2.475 0 01-1.768-.747 2.578 2.578 0 01-.732-1.804c0-.677.263-1.326.732-1.804a2.475 2.475 0 011.768-.747c.663 0 1.299.268 1.768.747.469.478.732 1.127.732 1.804s-.264 1.326-.732 1.804a2.475 2.475 0 01-1.768.747zm10-2.551a2.58 2.58 0 01-.732 1.804 2.475 2.475 0 01-1.768.747 2.475 2.475 0 01-1.768-.747 2.579 2.579 0 01-.732-1.804c0-.677.263-1.326.732-1.804a2.475 2.475 0 011.768-.747c.663 0 1.299.268 1.768.747a2.58 2.58 0 01.732 1.804zm5 2.551a2.475 2.475 0 01-1.768-.747 2.579 2.579 0 01-.732-1.804c0-.677.263-1.326.732-1.804a2.475 2.475 0 011.768-.747c.663 0 1.299.268 1.768.747.468.478.732 1.127.732 1.804s-.264 1.326-.732 1.804a2.475 2.475 0 01-1.768.747z"
            })
        ]
    });
}
var $fd7c2da67094d81c$export$2e2bcd8739ae039 = $fd7c2da67094d81c$var$SvgIconOptions;

});

parcelRegister("k6suX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba7c4bf3c314a095$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $ba7c4bf3c314a095$var$SvgIconPathway({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 34 38",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M33.965 31.22c0 1.799-.746 3.523-2.072 4.794A7.232 7.232 0 0126.89 38a7.233 7.233 0 01-5.002-1.986c-1.326-1.271-2.072-2.995-2.072-4.794.003-.84.165-1.672.478-2.457l-8.153-5.017a7.164 7.164 0 01-3.618 1.907 7.36 7.36 0 01-4.113-.355 7.02 7.02 0 01-3.206-2.495A6.581 6.581 0 010 19.017c0-1.348.42-2.666 1.205-3.785a7.022 7.022 0 013.206-2.495 7.36 7.36 0 014.113-.355 7.164 7.164 0 013.619 1.907l8.152-5.017a6.692 6.692 0 01-.478-2.458 6.624 6.624 0 011.607-4.325 7.153 7.153 0 014.109-2.36 7.362 7.362 0 014.737.683 6.906 6.906 0 013.203 3.414 6.532 6.532 0 01.208 4.587 6.834 6.834 0 01-2.883 3.666 7.334 7.334 0 01-4.658 1.074 7.215 7.215 0 01-4.307-2.01l-8.152 5.017a6.565 6.565 0 010 4.915l8.152 5.017a7.167 7.167 0 013.617-1.898 7.36 7.36 0 014.106.358 7.021 7.021 0 013.2 2.49 6.583 6.583 0 011.209 3.779z"
            })
        ]
    });
}
var $ba7c4bf3c314a095$export$2e2bcd8739ae039 = $ba7c4bf3c314a095$var$SvgIconPathway;

});

parcelRegister("eEYoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $427754d300b5fdef$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $427754d300b5fdef$var$SvgIconPatient({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M18.75 3H15c0-1.655-1.345-3-3-3S9 1.345 9 3H5.25A2.25 2.25 0 003 5.25v16.5A2.25 2.25 0 005.25 24h13.5A2.25 2.25 0 0021 21.75V5.25A2.25 2.25 0 0018.75 3zM12 1.875c.623 0 1.125.502 1.125 1.125S12.623 4.125 12 4.125A1.122 1.122 0 0110.875 3c0-.623.502-1.125 1.125-1.125zm4.5 14.25a.376.376 0 01-.375.375H13.5v2.625a.376.376 0 01-.375.375h-2.25a.376.376 0 01-.375-.375V16.5H7.875a.376.376 0 01-.375-.375v-2.25c0-.206.169-.375.375-.375H10.5v-2.625c0-.206.169-.375.375-.375h2.25c.206 0 .375.169.375.375V13.5h2.625c.206 0 .375.169.375.375v2.25zm0-9a.376.376 0 01-.375.375h-8.25a.376.376 0 01-.375-.375v-.75c0-.206.169-.375.375-.375h8.25c.206 0 .375.169.375.375v.75z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $427754d300b5fdef$export$2e2bcd8739ae039 = $427754d300b5fdef$var$SvgIconPatient;

});

parcelRegister("e1x9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a6f72833e760e8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $58a6f72833e760e8$var$SvgIconPdf({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 37",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M26.972 7.08l-6.118-6.06A3.516 3.516 0 0018.382 0H3.5C1.568.007 0 1.56 0 3.475v30.057C0 35.447 1.568 37 3.5 37h21c1.932 0 3.5-1.553 3.5-3.468V9.537a3.47 3.47 0 00-1.028-2.456zm-2.756 2.175h-5.55V3.757l5.55 5.498zM3.5 33.532V3.475h11.667v7.514c0 .961.78 1.734 1.75 1.734H24.5v20.809h-21zm18.244-10.383c-.89-.867-3.427-.628-4.696-.47-1.254-.758-2.093-1.806-2.683-3.344.284-1.164.736-2.934.393-4.047-.306-1.893-2.756-1.705-3.106-.426-.32 1.163-.03 2.782.51 4.848-.729 1.727-1.815 4.046-2.58 5.376-1.46.744-3.428 1.893-3.72 3.338-.24 1.141 1.896 3.988 5.55-2.255 1.633-.534 3.412-1.192 4.987-1.452 1.378.737 2.99 1.229 4.069 1.229 1.86 0 2.041-2.038 1.276-2.797zM7.299 28.771c.372-.99 1.786-2.132 2.217-2.53-1.386 2.19-2.217 2.58-2.217 2.53zm5.95-13.772c.54 0 .489 2.32.131 2.948-.32-1.004-.313-2.948-.131-2.948zm-1.78 9.87c.708-1.221 1.313-2.673 1.802-3.952.605 1.09 1.378 1.965 2.195 2.565-1.517.31-2.837.946-3.996 1.387zm9.597-.361s-.365.433-2.72-.564c2.56-.188 2.982.39 2.72.564z"
            })
        ]
    });
}
var $58a6f72833e760e8$export$2e2bcd8739ae039 = $58a6f72833e760e8$var$SvgIconPdf;

});

parcelRegister("7laxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc506cadda519463$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $bc506cadda519463$var$SvgIconPencil({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M6.53 14.78l6.97-6.97-3.31-3.31-6.97 6.97a.752.752 0 00-.198.348L2.25 15.75l3.931-.773a.751.751 0 00.35-.197zm9.22-9.22a1.5 1.5 0 000-2.12l-1.19-1.19a1.5 1.5 0 00-2.12 0l-1.19 1.19 3.31 3.31 1.19-1.19z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h18v18H0z"
                    })
                ]
            })
        ]
    });
}
var $bc506cadda519463$export$2e2bcd8739ae039 = $bc506cadda519463$var$SvgIconPencil;

});

parcelRegister("asRrx", function(module, exports) {

$parcel$export(module.exports, "default", () => $495b96f51df43893$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $495b96f51df43893$var$SvgIconPlus({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $495b96f51df43893$export$2e2bcd8739ae039 = $495b96f51df43893$var$SvgIconPlus;

});

parcelRegister("80TYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0760a04e7dbd7c89$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $0760a04e7dbd7c89$var$SvgIconPresenter({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M15.16 4.781c-.739-.014-1.344.605-1.344 1.345V9h-.263V3.192c0-.739-.605-1.358-1.344-1.344a1.318 1.318 0 00-1.293 1.318V9h-.264V1.907c0-.74-.605-1.358-1.344-1.344A1.318 1.318 0 008.016 1.88V9h-.264V3.225c0-.739-.605-1.358-1.344-1.344A1.318 1.318 0 005.115 3.2v7.778L4.072 9.543a1.318 1.318 0 10-2.132 1.55l4.14 5.693c.297.41.773.651 1.279.651h6.512c.734 0 1.372-.505 1.54-1.22l.874-3.712a6.32 6.32 0 00.168-1.45V6.1c0-.72-.576-1.305-1.292-1.319z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h18v18H0z"
                    })
                ]
            })
        ]
    });
}
var $0760a04e7dbd7c89$export$2e2bcd8739ae039 = $0760a04e7dbd7c89$var$SvgIconPresenter;

});

parcelRegister("5pIma", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd90fae788bed46$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $ddd90fae788bed46$var$SvgIconQuestionMark({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 45 45",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M22.5 0C10.094 0 0 10.094 0 22.5 0 34.907 10.094 45 22.5 45 34.907 45 45 34.907 45 22.5 45 10.094 34.907 0 22.5 0zm2.25 36h-4.5v-4.5h4.5V36zm2.196-10.991c-.441.355-.866.695-1.204 1.032-.918.916-.99 1.749-.992 1.785v.299h-4.5v-.376c0-.265.065-2.648 2.308-4.891.44-.439.984-.884 1.555-1.348 1.652-1.339 2.736-2.315 2.736-3.66a4.351 4.351 0 00-8.7.002h-4.5c0-4.88 3.97-8.852 8.851-8.852 4.88 0 8.852 3.971 8.852 8.852 0 3.593-2.653 5.737-4.406 7.157z"
            })
        ]
    });
}
var $ddd90fae788bed46$export$2e2bcd8739ae039 = $ddd90fae788bed46$var$SvgIconQuestionMark;

});

parcelRegister("9ZBPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e5c5e201d85cee4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $7e5c5e201d85cee4$var$SvgIconQuestion({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 46 46",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M25.95 2.138a4.176 4.176 0 00-5.906 0L1.724 20.462a4.17 4.17 0 000 5.901L20.05 44.691a4.169 4.169 0 005.9 0l18.327-18.328a4.17 4.17 0 000-5.9L25.95 2.137zm-9.998 15.745a.664.664 0 01-.675-.695c.267-4.767 4.168-6.43 7.734-6.43 3.927 0 7.515 2.054 7.515 6.3 0 3.038-1.786 4.484-3.498 5.787-2.073 1.572-2.841 2.16-2.841 4.18v.295a.703.703 0 01-.703.703h-2.278a.703.703 0 01-.703-.692l-.012-.61c-.107-2.608 1.392-4.214 3.285-5.59 1.66-1.248 2.714-2.07 2.714-3.856 0-2.32-1.766-3.285-3.695-3.285-2.259 0-3.524 1.345-3.775 3.19-.05.385-.36.703-.748.703h-2.32zm6.539 18.122c-1.643 0-2.838-1.108-2.838-2.607 0-1.553 1.195-2.644 2.84-2.644 1.714 0 2.892 1.091 2.892 2.644 0 1.499-1.181 2.607-2.894 2.607z"
            })
        ]
    });
}
var $7e5c5e201d85cee4$export$2e2bcd8739ae039 = $7e5c5e201d85cee4$var$SvgIconQuestion;

});

parcelRegister("hSnpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a3a3be6e587fff$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $71a3a3be6e587fff$var$SvgRadiology({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 48 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M39 8H9C8.44771 8 8 8.44772 8 9V39C8 39.5523 8.44772 40 9 40H39C39.5523 40 40 39.5523 40 39V9C40 8.44771 39.5523 8 39 8ZM9 6C7.34315 6 6 7.34315 6 9V39C6 40.6569 7.34315 42 9 42H39C40.6569 42 42 40.6569 42 39V9C42 7.34315 40.6569 6 39 6H9Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M14 21C13.4477 21 13 21.4477 13 22V37C13 37.5523 13.4477 38 14 38H19C19 37.407 19.2638 36.8734 19.5605 36.4598 19.8677 36.0315 20.278 35.6361 20.7267 35.2983 21.3693 34.8145 22.1707 34.39 23 34.1644V31.1465H21.2C20.0095 31.1465 18.8653 31.5443 17.9884 31.972 17.556 32.1829 17.2036 32.3938 16.9617 32.5501 16.8411 32.6281 16.749 32.6919 16.6891 32.7346 16.6592 32.756 16.6374 32.7719 16.6242 32.7817L16.6111 32.7916C16.6113 32.7914 16.6112 32.7914 16 32 15.3888 31.2085 15.389 31.2084 15.3892 31.2082L15.391 31.2069 15.394 31.2045 15.4029 31.1978 15.431 31.1766C15.4544 31.1593 15.4869 31.1354 15.5281 31.1061 15.6104 31.0474 15.7276 30.9664 15.8758 30.8706 16.1714 30.6795 16.594 30.4269 17.1116 30.1745 18.1347 29.6754 19.5905 29.1465 21.2 29.1465H23V27H21.9C21.0004 27 20.1423 27.216 19.4936 27.4436 19.173 27.5561 18.9128 27.6681 18.7358 27.7505 18.6475 27.7915 18.5805 27.8249 18.5378 27.8468 18.5164 27.8578 18.5011 27.8659 18.4923 27.8706L18.4852 27.8744C18.4854 27.8743 18.4856 27.8742 18 27 17.5144 26.1258 17.5146 26.1257 17.5148 26.1256L17.5164 26.1247 17.5191 26.1232 17.5265 26.1192 17.5492 26.1069C17.5677 26.097 17.5932 26.0836 17.6251 26.0672 17.689 26.0345 17.7791 25.9897 17.8923 25.937 18.1185 25.8319 18.4395 25.6939 18.8314 25.5564 19.6077 25.284 20.6996 25 21.9 25H23V23H25V25H25.8C26.8511 25 28.0154 25.2855 28.865 25.543 29.3009 25.6751 29.6766 25.8069 29.9442 25.906 30.0782 25.9557 30.1859 25.9974 30.2611 26.0271 30.2988 26.042 30.3284 26.0539 30.3492 26.0624L30.3737 26.0724 30.3809 26.0754 30.3843 26.0768C30.3845 26.0769 30.3846 26.0769 30 27 29.6154 27.9231 29.6155 27.9231 29.6156 27.9232L29.6124 27.9218 29.596 27.9152C29.5808 27.909 29.5571 27.8994 29.5256 27.8869 29.4626 27.862 29.3686 27.8256 29.2496 27.7815 29.0109 27.6931 28.6741 27.5749 28.285 27.457 27.4846 27.2145 26.5489 27 25.8 27H25V29.1465H26.4C27.8091 29.1465 29.3628 29.6776 30.4882 30.1517 31.0671 30.3955 31.5658 30.6388 31.9203 30.8213 32.0979 30.9128 32.2403 30.9895 32.3396 31.0441 32.3892 31.0714 32.4282 31.0932 32.4555 31.1086L32.4875 31.1268 32.4967 31.132 32.4995 31.1337 32.5005 31.1343C32.5007 31.1344 32.5012 31.1347 32 32 31.4988 32.8653 31.4989 32.8654 31.499 32.8655L31.494 32.8626 31.4715 32.8498C31.4507 32.838 31.4186 32.82 31.376 32.7967 31.291 32.7499 31.1646 32.6818 31.0047 32.5995 30.6842 32.4344 30.2329 32.2143 29.7118 31.9948 28.6372 31.5421 27.3909 31.1465 26.4 31.1465H25V34.132C25.8253 34.3413 26.6213 34.7753 27.2498 35.2552 27.7038 35.602 28.119 36.0086 28.4298 36.4438 28.7273 36.8603 29 37.4027 29 38H34C34.5523 38 35 37.5523 35 37V22C35 21.4477 34.5523 21 34 21H14zM26.9999 38C26.9994 37.9944 26.9956 37.9619 26.9704 37.899 26.9403 37.8241 26.8872 37.725 26.8023 37.6062 26.631 37.3664 26.3676 37.098 26.0359 36.8448 25.3594 36.3282 24.5874 36.0129 24.0338 36.0004 23.3896 36.0561 22.5878 36.4005 21.9296 36.896 21.6023 37.1425 21.3485 37.3985 21.1856 37.6255 21.1051 37.7378 21.0556 37.8308 21.0278 37.9008 21.0019 37.9661 21.0001 37.9977 21 38H26.9999zM28.5 14.5C28.5 16.9853 26.4853 19 24 19 21.5147 19 19.5 16.9853 19.5 14.5 19.5 12.0147 21.5147 10 24 10 26.4853 10 28.5 12.0147 28.5 14.5z",
                clipRule: "evenodd"
            })
        ]
    });
}
var $71a3a3be6e587fff$export$2e2bcd8739ae039 = $71a3a3be6e587fff$var$SvgRadiology;

});

parcelRegister("lx7Y0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7624a21f2c6c0b54$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $7624a21f2c6c0b54$var$SvgIconRecommendation({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        fillRule: "nonzero",
                        d: "M18.5 2h-13C3.6 2 2 3.6 2 5.5v13C2 20.4 3.6 22 5.5 22H16l6-6V5.5C22 3.6 20.4 2 18.5 2M7 12.5l1.3-1.4 2.1 2.1L15.6 8 17 9.4 10.5 16 7 12.5m8 7.5v-1.5c0-1.9 1.6-3.5 3.5-3.5H20l-5 5z"
                    })
                ]
            })
        ]
    });
}
var $7624a21f2c6c0b54$export$2e2bcd8739ae039 = $7624a21f2c6c0b54$var$SvgIconRecommendation;

});

parcelRegister("6EQca", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf58088536ed1c6d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $bf58088536ed1c6d$var$SvgIconRejectThin({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 15",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M12.844 2.188c-2.925-2.917-7.725-2.917-10.65 0-2.925 2.918-2.925 7.706 0 10.624a7.482 7.482 0 0010.575 0c2.925-2.918 3-7.706.075-10.624zm-3.225 8.454l-2.1-2.095-2.1 2.095-1.05-1.047 2.1-2.095-2.1-2.095 1.05-1.047 2.1 2.095 2.1-2.095 1.05 1.047-2.1 2.095 2.1 2.095-1.05 1.047z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h15v15H0z"
                    })
                ]
            })
        ]
    });
}
var $bf58088536ed1c6d$export$2e2bcd8739ae039 = $bf58088536ed1c6d$var$SvgIconRejectThin;

});

parcelRegister("4e1aD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff07d9b7daccf152$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $ff07d9b7daccf152$var$SvgIconReject({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M21.157 11.24L17.4 15l3.762 3.762a.726.726 0 01.001 1.027l-1.373 1.368a.727.727 0 01-1.027.002l-.002-.002-3.76-3.757-3.763 3.762a.726.726 0 01-1.027.002v-.002L8.842 19.79a.725.725 0 010-1.027v-.001L12.6 15l-3.762-3.762a.724.724 0 010-1.026v-.002l1.367-1.367a.726.726 0 011.028 0L15 12.6l3.761-3.762a.728.728 0 011.028-.001h.001l1.367 1.368a.726.726 0 01.001 1.027v.009zM15 27.1C8.317 27.1 2.9 21.682 2.9 15 2.9 8.318 8.317 2.9 15 2.9c6.682 0 12.1 5.418 12.1 12.1.004 6.679-5.407 12.096-12.086 12.1H15zM15 0C6.716 0 0 6.716 0 15c0 8.285 6.716 15 15 15 8.284 0 15-6.715 15-15 0-8.284-6.716-15-15-15z"
            })
        ]
    });
}
var $ff07d9b7daccf152$export$2e2bcd8739ae039 = $ff07d9b7daccf152$var$SvgIconReject;

});

parcelRegister("ls9xE", function(module, exports) {

$parcel$export(module.exports, "default", () => $784451001fc59876$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $784451001fc59876$var$SvgIconRotate = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
            })
        ]
    });
var $784451001fc59876$export$2e2bcd8739ae039 = $784451001fc59876$var$SvgIconRotate;

});

parcelRegister("lhJr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae55acebe5d7915f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $ae55acebe5d7915f$var$SvgIconScreenShareOff({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M28.293 24.027l2.667 2.666H32v-2.666h-3.707zm1.027-2.667l.013-13.333a2.667 2.667 0 00-2.666-2.667H9.627l6.973 6.973c.24-.053.48-.093.733-.133V9.36l5.334 4.973-2.107 1.96 7.387 7.387a2.643 2.643 0 001.373-2.32zM3.187 2.307L1.48 4l2.053 2.053a2.645 2.645 0 00-.866 1.974V21.36a2.667 2.667 0 002.666 2.667H0v2.666h24.173l3.614 3.614 1.693-1.694L3.187 2.307zm6.146 17.72c.414-1.974 1.227-3.934 2.76-5.414l2.12 2.12c-2.053.507-3.6 1.574-4.88 3.294z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $ae55acebe5d7915f$export$2e2bcd8739ae039 = $ae55acebe5d7915f$var$SvgIconScreenShareOff;

});

parcelRegister("9fvzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $71870801ee743622$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $71870801ee743622$var$SvgIconScreenShareOn({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M26.667 24c1.466 0 2.653-1.2 2.653-2.667L29.333 8a2.667 2.667 0 00-2.666-2.667H5.333A2.657 2.657 0 002.667 8v13.333A2.667 2.667 0 005.333 24H0v2.667h32V24h-5.333zm-9.334-4.707v-2.92c-3.706 0-6.146 1.134-8 3.627.747-3.56 2.814-7.107 8-7.827v-2.84l5.334 4.974-5.334 4.986z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $71870801ee743622$export$2e2bcd8739ae039 = $71870801ee743622$var$SvgIconScreenShareOn;

});

parcelRegister("3NuIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $92ee4dcc6c9b02e1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $92ee4dcc6c9b02e1$var$SvgIconScribe({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M4.5 1.5C3.667 1.5 3 2.167 3 3v12a1.5 1.5 0 001.5 1.5h3v-1.432L9.068 13.5H4.5V12h6.068l1.5-1.5H4.5V9h9.068L15 7.567V6l-4.5-4.5h-6m5.25 1.125l4.125 4.125H9.75V2.625m5.363 7.125a.413.413 0 00-.3.12l-.766.765 1.568 1.56.765-.758a.43.43 0 000-.592l-.975-.975a.408.408 0 00-.292-.12m-1.508 1.328L9 15.69v1.56h1.56l4.612-4.613-1.567-1.56z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h18v18H0z"
                    })
                ]
            })
        ]
    });
}
var $92ee4dcc6c9b02e1$export$2e2bcd8739ae039 = $92ee4dcc6c9b02e1$var$SvgIconScribe;

});

parcelRegister("4rRXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4345d7e190de8cbe$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $4345d7e190de8cbe$var$SvgIconSelectCross({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.348 14.849a1.2 1.2 0 01-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 11-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 111.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 111.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 010 1.698z"
            })
        ]
    });
}
var $4345d7e190de8cbe$export$2e2bcd8739ae039 = $4345d7e190de8cbe$var$SvgIconSelectCross;

});

parcelRegister("6dmyz", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $bd3e437934cdebb8$var$SvgIconSelected({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 18,
                cy: 18,
                r: 18,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M26.546 11.191a1.87 1.87 0 00-2.642.284l-6.626 8.3a2 2 0 01-2.94.203l-2.652-2.517a1.722 1.722 0 00-2.372 2.498l5.457 5.183a2 2 0 002.925-.183l9.116-11.133a1.87 1.87 0 00-.266-2.635z"
            })
        ]
    });
}
var $bd3e437934cdebb8$export$2e2bcd8739ae039 = $bd3e437934cdebb8$var$SvgIconSelected;

});

parcelRegister("77EBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $84280da068fd8f6b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $84280da068fd8f6b$var$SvgIconSignOut({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M23.297 12.797l-7.875 7.875c-.703.703-1.922.21-1.922-.797v-4.5H7.125A1.122 1.122 0 016 14.25v-4.5c0-.623.502-1.125 1.125-1.125H13.5v-4.5c0-1.003 1.214-1.5 1.922-.797l7.875 7.875c.436.44.436 1.153 0 1.594zM9 20.437v-1.875A.564.564 0 008.437 18H4.5c-.83 0-1.5-.67-1.5-1.5v-9C3 6.67 3.67 6 4.5 6h3.938A.565.565 0 009 5.437V3.563A.564.564 0 008.437 3H4.5A4.501 4.501 0 000 7.5v9C0 18.984 2.016 21 4.5 21h3.938A.564.564 0 009 20.437z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $84280da068fd8f6b$export$2e2bcd8739ae039 = $84280da068fd8f6b$var$SvgIconSignOut;

});

parcelRegister("bnAWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $531b9cf9b6825fb9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $531b9cf9b6825fb9$var$SvgIconSplitscreen({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M0 19.617h29V0H0v19.617zm16.206-2.559h9.382V5.118h-9.382v11.94zm-12.794 0h9.383V5.118H3.412v11.94z"
            })
        ]
    });
}
var $531b9cf9b6825fb9$export$2e2bcd8739ae039 = $531b9cf9b6825fb9$var$SvgIconSplitscreen;

});

parcelRegister("bKaLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf70a6260099115f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $cf70a6260099115f$var$SvgIconStep({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 37 12",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 6,
                cy: 6,
                r: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: 31,
                cy: 6,
                r: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                stroke: "currentColor",
                strokeWidth: 4,
                d: "M6 6h25"
            })
        ]
    });
}
var $cf70a6260099115f$export$2e2bcd8739ae039 = $cf70a6260099115f$var$SvgIconStep;

});

parcelRegister("jcQWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2a2eec07a16e36f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d2a2eec07a16e36f$var$SvgIconSwitchTenant({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 69 59",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34.594 5.386c-7.322 0-13.87 3.395-18.197 8.73a2.372 2.372 0 01-.71.626 2.332 2.332 0 01-1.83.21 2.346 2.346 0 01-.829-.45 2.394 2.394 0 01-.59-.743 2.434 2.434 0 01.322-2.697 28.301 28.301 0 0113.204-9.097 27.842 27.842 0 0115.94-.393 28.237 28.237 0 0113.621 8.434 29.03 29.03 0 016.986 14.589h-4.799c-1.089-5.423-3.985-10.296-8.197-13.796a23.345 23.345 0 00-14.92-5.413zM11.476 34.2a24.165 24.165 0 006.084 11.804 23.508 23.508 0 0011.33 6.685 23.203 23.203 0 0013.087-.492 23.59 23.59 0 0010.815-7.52c.193-.254.434-.467.71-.625a2.33 2.33 0 012.658.24c.244.205.445.458.591.743a2.434 2.434 0 01-.322 2.697 28.302 28.302 0 01-13.204 9.097 27.841 27.841 0 01-15.94.394 28.236 28.236 0 01-13.621-8.435A29.032 29.032 0 016.678 34.2h4.798z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                d: "M36.213 13.927a3.01 3.01 0 00-1.866-.646 3.01 3.01 0 00-1.865.646l-10.27 8.116c-.349.276-.63.624-.823 1.02a2.9 2.9 0 00-.293 1.271v14.727c0 .78.314 1.526.873 2.077.559.551 1.317.86 2.108.86h3.313c.791 0 1.55-.309 2.109-.86.559-.55.873-1.298.873-2.077v-8.486a.97.97 0 01.291-.692c.186-.184.44-.287.703-.287h5.963a1 1 0 01.703.287.972.972 0 01.291.692v8.486c0 .78.314 1.526.873 2.077.56.551 1.318.86 2.109.86h3.313c.79 0 1.55-.309 2.108-.86.56-.55.874-1.298.874-2.077V24.334a2.92 2.92 0 00-1.116-2.29l-10.27-8.117zM8.35 23.378a1 1 0 011.7 0l6.175 9.997a1 1 0 01-.85 1.525H3.024a1 1 0 01-.85-1.525l6.174-9.997zm52.186 12.484a1 1 0 01-1.702 0l-6.174-9.997a1 1 0 01.85-1.526h12.35a1 1 0 01.85 1.526l-6.174 9.997z"
            })
        ]
    });
}
var $d2a2eec07a16e36f$export$2e2bcd8739ae039 = $d2a2eec07a16e36f$var$SvgIconSwitchTenant;

});

parcelRegister("dIfKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $af70623a24669031$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $af70623a24669031$var$SvgIconTask({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        viewBox: "0 0 20 20",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v9.883l-2.495 2.52-.934-.953a1.5 1.5 0 10-2.142 2.1l.441.45H6a2 2 0 01-2-2V4zm5 5.5a.5.5 0 00.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zM9.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 13.5a.5.5 0 00.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zm-2-3a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 10-2 0 1 1 0 002 0zm-1 9a1 1 0 100-2 1 1 0 000 2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M17.855 14.852a.5.5 0 00-.71-.704l-3.643 3.68-1.645-1.678a.5.5 0 10-.714.7l1.929 1.968a.6.6 0 00.855.002l3.928-3.968z"
                    })
                ]
            })
        ]
    });
}
var $af70623a24669031$export$2e2bcd8739ae039 = $af70623a24669031$var$SvgIconTask;

});

parcelRegister("4fat5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c497862611552d7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $0c497862611552d7$var$SvgIconTeam({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm.295 13.972l-.278.005a5.785 5.785 0 00-4.264 1.632l-.15.17v3.22l.01.125a.96.96 0 00.279.542c.18.174.42.27.67.265h6.89l.124-.006a.938.938 0 00.548-.26.953.953 0 00.288-.665v-3.21l-.144-.181-.204-.19a5.717 5.717 0 00-4.047-1.442zm4.068-2.53l-.269.002c-.218 0-.436.013-.653.037a3.977 3.977 0 01-1.2 1.48c1.144.32 2.18.946 2.999 1.814l.15.169.323.375v1.638h1.363l.116-.007a1 1 0 00.884-.993v-2.82l-.126-.17-.196-.186a5.174 5.174 0 00-3.66-1.337zm-8.801.018l-.268.01a5.18 5.18 0 00-3.319 1.516l-.144.169v2.796l.007.116a1 1 0 00.993.884h1.447v-1.632l.33-.375.15-.175.217-.215a6.584 6.584 0 012.607-1.514 3.979 3.979 0 01-1.23-1.578h-.521l-.27-.002zm4.31-4.325c-1.48 0-2.68 1.21-2.68 2.701a2.69 2.69 0 002.68 2.702c1.481 0 2.681-1.21 2.681-2.702s-1.2-2.701-2.68-2.701zm-2.008-.653a2.442 2.442 0 00-2.977-.936 2.476 2.476 0 00-1.482 2.765 2.458 2.458 0 002.408 1.997v-.024H8l-.019-.208a3.907 3.907 0 011.884-3.594zm7.093-1.003a2.443 2.443 0 00-2.926 1.063 3.955 3.955 0 011.775 3.288c.008.14.008.279 0 .417.115.019.232.029.348.03h.114l.165-.014a2.462 2.462 0 002.132-2.1 2.474 2.474 0 00-1.608-2.684z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $0c497862611552d7$export$2e2bcd8739ae039 = $0c497862611552d7$var$SvgIconTeam;

});

parcelRegister("5iELo", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $b0425f37ef1c0a39$var$SvgIconThumbsUp({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M6.7 22H2v-9h2l2.7 9zM20 9h-6V5a3 3 0 00-3-3h-1v4L7.1 9.625A5.02 5.02 0 006 12.76V14l2.1 7h8.337a4 4 0 003.88-3.03l1.622-6.485A2 2 0 0020 9z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $b0425f37ef1c0a39$export$2e2bcd8739ae039 = $b0425f37ef1c0a39$var$SvgIconThumbsUp;

});

parcelRegister("lHtgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a534c5cdb80d3b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e6a534c5cdb80d3b$var$SvgIconTick({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M11.957.82L5.543 9.278 1.75 5.488 0 7.238l5.832 5.832L14 2.57z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h14v14H0z"
                    })
                ]
            })
        ]
    });
}
var $e6a534c5cdb80d3b$export$2e2bcd8739ae039 = $e6a534c5cdb80d3b$var$SvgIconTick;

});

parcelRegister("jdbjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3a36a9d5ebfa3f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $2d3a36a9d5ebfa3f$var$SvgIconTime({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m2 15l-3-5.2V7h1.5v4.4l2.8 4.9-1.3.7z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h24v24H0z"
                    })
                ]
            })
        ]
    });
}
var $2d3a36a9d5ebfa3f$export$2e2bcd8739ae039 = $2d3a36a9d5ebfa3f$var$SvgIconTime;

});

parcelRegister("chRXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $28be16fd4cf4a41a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $28be16fd4cf4a41a$var$SvgIconUser({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 30",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M17.18 16.364c4.067 0 7.364 3.418 7.365 7.635v2.364c0 1.507-1.178 2.728-2.63 2.728H2.63C1.178 29.09 0 27.87 0 26.363V24c.001-4.216 3.297-7.633 7.363-7.635h.915a9.228 9.228 0 007.988 0h.915zM12.734 0a7.273 7.273 0 11-7.278 7.28v-.013A7.273 7.273 0 0112.733 0z"
            })
        ]
    });
}
var $28be16fd4cf4a41a$export$2e2bcd8739ae039 = $28be16fd4cf4a41a$var$SvgIconUser;

});

parcelRegister("ft8ez", function(module, exports) {

$parcel$export(module.exports, "default", () => $a151e9943e1382c0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $a151e9943e1382c0$var$SvgIconUsers({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 25",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.13 10.14A8.67 8.67 0 00.7 12.66l-.24.28v5.28a1 1 0 001 1h3.08v-2.7l.55-.62.25-.29a11 11 0 014.71-2.86A6.59 6.59 0 018 10.14h-.87zm20.21 2.49a8.67 8.67 0 00-6.43-2.52 10.47 10.47 0 00-1.09.06 6.59 6.59 0 01-2 2.45 10.91 10.91 0 015 3l.25.28.54.62v2.71h2.94a1 1 0 001-1v-5.32l-.21-.28zM7.1 8.19h.31a6.45 6.45 0 013.11-6.29A4.09 4.09 0 107.1 8.23v-.04zm13.33-.75c.012.23.012.46 0 .69.192.03.386.047.58.05h.19A4.09 4.09 0 1017.47 2a6.53 6.53 0 012.96 5.44z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: 13.87,
                        cy: 7.45,
                        r: 4.47
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7 17l-.25.28v5.33a1.57 1.57 0 001.6 1.54h11.49a1.57 1.57 0 001.6-1.54V17.3l-.24-.3a9.58 9.58 0 00-7.09-2.7A9.69 9.69 0 007 17z"
                    })
                ]
            })
        ]
    });
}
var $a151e9943e1382c0$export$2e2bcd8739ae039 = $a151e9943e1382c0$var$SvgIconUsers;

});

parcelRegister("bZDhf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d41d7552f259f12$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $7d41d7552f259f12$var$SvgIconVideoOff({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 33 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M19.557 25H5.958a2 2 0 01-2-2V9.399L0 5.439 1.44 4 25 27.562 23.56 29l-4.003-4zM7 5h16.27a2 2 0 012 2v4.06l5.418-3.87A1 1 0 0132.27 8v14a1 1 0 01-1.58.81l-5.42-3.87V23c0 .098-.007.196-.02.291L7 5z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $7d41d7552f259f12$export$2e2bcd8739ae039 = $7d41d7552f259f12$var$SvgIconVideoOff;

});

parcelRegister("7eN5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e2919af226a8238$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $1e2919af226a8238$var$SvgIconVideoOn({ title: title, titleId: titleId, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "currentColor",
                        d: "M21 26H4a2 2 0 01-2-2V8a2 2 0 012-2h17a2 2 0 012 2v4.06l5.42-3.87A1 1 0 0130 9v14a1 1 0 01-1.58.81L23 19.94V24a2 2 0 01-2 2z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M0 0h32v32H0z"
                    })
                ]
            })
        ]
    });
}
var $1e2919af226a8238$export$2e2bcd8739ae039 = $1e2919af226a8238$var$SvgIconVideoOn;

});


parcelRegister("kQILj", function(module, exports) {

$parcel$export(module.exports, "getSelectedUserViewTab", () => $c70406ced42630db$export$5e86b86c44c25b06);
$parcel$export(module.exports, "getSelectedYourViewTab", () => $c70406ced42630db$export$99bc12d2625c3363);
$parcel$export(module.exports, "getIsSplitScreen", () => $c70406ced42630db$export$388f24b3d4b61cd4);
$parcel$export(module.exports, "getIsYourViewAssetListOpen", () => $c70406ced42630db$export$8c3321b70e4abaf6);
$parcel$export(module.exports, "getYourViewSelectedAssetId", () => $c70406ced42630db$export$6cd1b70cf67b7323);
$parcel$export(module.exports, "getIsMenuOpen", () => $c70406ced42630db$export$2d2344cc584492aa);
$parcel$export(module.exports, "getIsQuickViewOpen", () => $c70406ced42630db$export$3bd085c75b3d1d13);
$parcel$export(module.exports, "getQuickViewResourceId", () => $c70406ced42630db$export$a5d96a4a4c00220d);
$parcel$export(module.exports, "getMeetingsUI", () => $c70406ced42630db$export$d9966c2c9210cc34);
$parcel$export(module.exports, "getCasesUI", () => $c70406ced42630db$export$cde52263bdb15abb);
$parcel$export(module.exports, "getUsersUI", () => $c70406ced42630db$export$61c30e4682d23de2);
$parcel$export(module.exports, "getTeamsUI", () => $c70406ced42630db$export$5ad23f9388828f90);
$parcel$export(module.exports, "getNotificationsUI", () => $c70406ced42630db$export$2ecda28c1ef4030d);
$parcel$export(module.exports, "getTasksUI", () => $c70406ced42630db$export$c1f4babb7fba8cd9);
$parcel$export(module.exports, "getPatientsUI", () => $c70406ced42630db$export$8ea248ab95bd2126);
$parcel$export(module.exports, "getPathwaysUI", () => $c70406ced42630db$export$5a0772011367d4ad);
$parcel$export(module.exports, "getAddPathwayToCaseUI", () => $c70406ced42630db$export$5b4bf4404725bbe1);
$parcel$export(module.exports, "getAddFormToCaseUI", () => $c70406ced42630db$export$dedce6a41332bfbf);
$parcel$export(module.exports, "getChatsUI", () => $c70406ced42630db$export$7dfad62a205af98c);
$parcel$export(module.exports, "getChatMessagesUI", () => $c70406ced42630db$export$75da490df83cf00a);
$parcel$export(module.exports, "getAddCaseToMeetingUI", () => $c70406ced42630db$export$e1adc42bd11a70e2);
$parcel$export(module.exports, "getPatientNewUI", () => $c70406ced42630db$export$2caf46f46b0b82b8);
$parcel$export(module.exports, "getUserCheckUI", () => $c70406ced42630db$export$e13979ecceb3f549);
$parcel$export(module.exports, "getScrollUI", () => $c70406ced42630db$export$48219892d8f737f0);
const $c70406ced42630db$export$5e86b86c44c25b06 = (state)=>state.ui.liveMeeting.selectedUsersViewTab;
const $c70406ced42630db$export$99bc12d2625c3363 = (state)=>state.ui.liveMeeting.selectedYourViewTab;
const $c70406ced42630db$export$388f24b3d4b61cd4 = (state)=>state.ui.liveMeeting.isSplitScreen;
const $c70406ced42630db$export$8c3321b70e4abaf6 = (state)=>state.ui.liveMeeting.isYourViewAssetListOpen;
const $c70406ced42630db$export$6cd1b70cf67b7323 = (state)=>state.ui.liveMeeting.yourViewSelectedAssetId;
const $c70406ced42630db$export$2d2344cc584492aa = (state)=>state.ui.nav?.isMenuOpen;
const $c70406ced42630db$export$3bd085c75b3d1d13 = (state)=>state.ui.nav?.isQuickViewOpen;
const $c70406ced42630db$export$a5d96a4a4c00220d = (state)=>state.ui.nav?.quickViewResourceId;
const $c70406ced42630db$export$d9966c2c9210cc34 = (state)=>state.ui.meetings;
const $c70406ced42630db$export$cde52263bdb15abb = (state)=>state.ui.cases;
const $c70406ced42630db$export$61c30e4682d23de2 = (state)=>state.ui.users;
const $c70406ced42630db$export$5ad23f9388828f90 = (state)=>state.ui.teams;
const $c70406ced42630db$export$2ecda28c1ef4030d = (state)=>state.ui.notifications;
const $c70406ced42630db$export$c1f4babb7fba8cd9 = (state)=>state.ui.tasks;
const $c70406ced42630db$export$8ea248ab95bd2126 = (state)=>state.ui.patients;
const $c70406ced42630db$export$5a0772011367d4ad = (state)=>state.ui.pathways;
const $c70406ced42630db$export$5b4bf4404725bbe1 = (state)=>state.ui.addPathwayToCase;
const $c70406ced42630db$export$dedce6a41332bfbf = (state)=>state.ui.addFormToCase;
const $c70406ced42630db$export$7dfad62a205af98c = (state)=>state.ui.chats;
const $c70406ced42630db$export$75da490df83cf00a = (state)=>state.ui.messages;
const $c70406ced42630db$export$e1adc42bd11a70e2 = (state)=>state.ui.addCaseToMeeting;
const $c70406ced42630db$export$2caf46f46b0b82b8 = (state)=>state.ui.patientNew;
const $c70406ced42630db$export$e13979ecceb3f549 = (state)=>state.ui.userCheck;
const $c70406ced42630db$export$48219892d8f737f0 = (state)=>state.ui.scroll;

});

parcelRegister("2MEcG", function(module, exports) {

$parcel$export(module.exports, "scrollUpdatePosition", () => $21dab39992a63de4$export$c99285c80cc8abb3);
const $21dab39992a63de4$export$c99285c80cc8abb3 = (type, position)=>{
    return {
        type: type,
        payload: position
    };
};

});



parcelRegister("55Oux", function(module, exports) {

$parcel$export(module.exports, "ExternalUsersContext", () => $219e5270e8750d6c$export$461bdcebb722f502);
$parcel$export(module.exports, "ExternalUsersContextProvider", () => $219e5270e8750d6c$export$e2f23a7954c56211);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $c4ihx = parcelRequire("c4ihx");

var $WjKKb = parcelRequire("WjKKb");

var $ai857 = parcelRequire("ai857");

var $f1q41 = parcelRequire("f1q41");
const $219e5270e8750d6c$export$461bdcebb722f502 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
$219e5270e8750d6c$export$461bdcebb722f502.displayName = "ExternalUsersContext";
const $219e5270e8750d6c$export$e2f23a7954c56211 = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const entityExternalUsers = (0, $iD0SF.useSelector)((0, $c4ihx.getAllExternalUserEntities));
    const cookieExternalUsers = (0, $WjKKb.default)();
    const [externalUsers, setExternalUsers] = (0, $acw62.useState)([]);
    const [groupedExternalUsers, setGroupedExternalUsers] = (0, $acw62.useState)({});
    const [totalTenantCount, setTotalTenantCount] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        fetchExternalUsers();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const combinedExternalUsers = [
            ...entityExternalUsers,
            ...cookieExternalUsers
        ];
        const distinctUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy(combinedExternalUsers, (u)=>u.id);
        setExternalUsers(distinctUsers);
        const combinedTotalTenantCount = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sumBy(distinctUsers, (externalUser)=>externalUser.tenants.length);
        setTotalTenantCount(combinedTotalTenantCount);
        const _groupedExternalUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).groupBy(distinctUsers, "email");
        setGroupedExternalUsers(_groupedExternalUsers);
    }, [
        cookieExternalUsers,
        entityExternalUsers
    ]);
    const fetchExternalUsers = ()=>{
        dispatch((0, $ai857.fetchExternalAccountsAction)());
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($219e5270e8750d6c$export$461bdcebb722f502.Provider, {
        value: {
            fetchExternalUsers: fetchExternalUsers,
            externalUsers: externalUsers,
            groupedExternalUsers: groupedExternalUsers,
            totalTenantCount: totalTenantCount
        },
        children: props.children
    });
};

});
parcelRegister("c4ihx", function(module, exports) {

$parcel$export(module.exports, "getAllExternalUserEntities", () => $86f2b1d5dd0c1232$export$9c3d04e966a1fcf2);

var $6SpLG = parcelRequire("6SpLG");
const $86f2b1d5dd0c1232$export$9a52bd44b2a1b4f4 = (state)=>state.entities.externalUsers.byId;
const $86f2b1d5dd0c1232$export$9c3d04e966a1fcf2 = (0, $6SpLG.createSelector)($86f2b1d5dd0c1232$export$9a52bd44b2a1b4f4, (externalUsers)=>{
    if (!externalUsers) return [];
    return Object.values(externalUsers);
});

});

parcelRegister("WjKKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce949a678a20402$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2e3dz = parcelRequire("2e3dz");

var $kYqkq = parcelRequire("kYqkq");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $mZ3Ai = parcelRequire("mZ3Ai");

var $f1q41 = parcelRequire("f1q41");
const $9ce949a678a20402$var$useExternalUserCookie = ()=>{
    const cookieName = "externalUsers";
    const [cookies, setCookie] = (0, $2e3dz.useCookies)([
        cookieName
    ]);
    const [externalUsersCookie, setExternalUserCookie] = (0, $acw62.useState)([]);
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const userTenants = (0, $iD0SF.useSelector)((0, $mZ3Ai.getAllUserTenants));
    (0, $acw62.useEffect)(()=>{
        if (!cookies?.externalUsers) return;
        setExternalUserCookie(cookies.externalUsers);
    }, [
        cookies?.externalUsers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isNewTenant()) return;
        addTenantToCookie();
    }, [
        currentUser.currentTenantId
    ]);
    const isNewTenant = ()=>{
        const externalUsers = cookies?.externalUsers;
        const currentTenantId = currentUser.currentTenantId;
        const matchingExternalUsers = externalUsers?.filter((externalUser)=>{
            const hasMatchingTenant = externalUser.tenants.some((tenant)=>tenant.id === currentTenantId);
            const hasSameEmail = externalUser.email === currentUser.email;
            const hasSameLocation = externalUser.location === window.location.origin;
            return hasMatchingTenant && hasSameEmail && hasSameLocation;
        });
        return !matchingExternalUsers?.length;
    };
    const addTenantToCookie = ()=>{
        const cookieDomain = undefined;
        const cookie = cookies.externalUsers || [];
        const newExternalUser = {
            id: currentUser.id,
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            email: currentUser.email,
            tenants: userTenants,
            location: window.location.origin
        };
        const newCookie = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
            ...cookie,
            newExternalUser
        ]);
        setCookie(cookieName, newCookie, {
            domain: `.${cookieDomain}`
        });
    };
    return externalUsersCookie;
};
var $9ce949a678a20402$export$2e2bcd8739ae039 = $9ce949a678a20402$var$useExternalUserCookie;

});
parcelRegister("2e3dz", function(module, exports) {

$parcel$export(module.exports, "CookiesProvider", () => $4ada3cd58fe2e84e$export$f049e22368c2ed81);
$parcel$export(module.exports, "useCookies", () => $4ada3cd58fe2e84e$export$14c4ae2979db17de);

var $f3UAG = parcelRequire("f3UAG");

var $acw62 = parcelRequire("acw62");
const $4ada3cd58fe2e84e$var$CookiesContext = $acw62.createContext(new (0, $f3UAG.default)());
const { Provider: $4ada3cd58fe2e84e$var$Provider, Consumer: $4ada3cd58fe2e84e$var$Consumer } = $4ada3cd58fe2e84e$var$CookiesContext;
class $4ada3cd58fe2e84e$export$f049e22368c2ed81 extends $acw62.Component {
    constructor(props){
        super(props);
        if (props.cookies) this.cookies = props.cookies;
        else this.cookies = new (0, $f3UAG.default)(undefined, props.defaultSetOptions);
    }
    render() {
        return $acw62.createElement($4ada3cd58fe2e84e$var$Provider, {
            value: this.cookies
        }, this.props.children);
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $4ada3cd58fe2e84e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
function $4ada3cd58fe2e84e$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $4ada3cd58fe2e84e$var$reactIs = {
    exports: {}
};
var $4ada3cd58fe2e84e$var$reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ada3cd58fe2e84e$var$hasRequiredReactIs_production_min;
function $4ada3cd58fe2e84e$var$requireReactIs_production_min() {
    if ($4ada3cd58fe2e84e$var$hasRequiredReactIs_production_min) return $4ada3cd58fe2e84e$var$reactIs_production_min;
    $4ada3cd58fe2e84e$var$hasRequiredReactIs_production_min = 1;
    var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
        if ("object" === typeof a && null !== a) {
            var u = a.$$typeof;
            switch(u){
                case c:
                    switch(a = a.type, a){
                        case l:
                        case m:
                        case e:
                        case g:
                        case f:
                        case p:
                            return a;
                        default:
                            switch(a = a && a.$$typeof, a){
                                case k:
                                case n:
                                case t:
                                case r:
                                case h:
                                    return a;
                                default:
                                    return u;
                            }
                    }
                case d:
                    return u;
            }
        }
    }
    function A(a) {
        return z(a) === m;
    }
    $4ada3cd58fe2e84e$var$reactIs_production_min.AsyncMode = l;
    $4ada3cd58fe2e84e$var$reactIs_production_min.ConcurrentMode = m;
    $4ada3cd58fe2e84e$var$reactIs_production_min.ContextConsumer = k;
    $4ada3cd58fe2e84e$var$reactIs_production_min.ContextProvider = h;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Element = c;
    $4ada3cd58fe2e84e$var$reactIs_production_min.ForwardRef = n;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Fragment = e;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Lazy = t;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Memo = r;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Portal = d;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Profiler = g;
    $4ada3cd58fe2e84e$var$reactIs_production_min.StrictMode = f;
    $4ada3cd58fe2e84e$var$reactIs_production_min.Suspense = p;
    $4ada3cd58fe2e84e$var$reactIs_production_min.isAsyncMode = function(a) {
        return A(a) || z(a) === l;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isConcurrentMode = A;
    $4ada3cd58fe2e84e$var$reactIs_production_min.isContextConsumer = function(a) {
        return z(a) === k;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isContextProvider = function(a) {
        return z(a) === h;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isElement = function(a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isForwardRef = function(a) {
        return z(a) === n;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isFragment = function(a) {
        return z(a) === e;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isLazy = function(a) {
        return z(a) === t;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isMemo = function(a) {
        return z(a) === r;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isPortal = function(a) {
        return z(a) === d;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isProfiler = function(a) {
        return z(a) === g;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isStrictMode = function(a) {
        return z(a) === f;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isSuspense = function(a) {
        return z(a) === p;
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.isValidElementType = function(a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    $4ada3cd58fe2e84e$var$reactIs_production_min.typeOf = z;
    return $4ada3cd58fe2e84e$var$reactIs_production_min;
}
var $4ada3cd58fe2e84e$var$reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ada3cd58fe2e84e$var$hasRequiredReactIs_development;
function $4ada3cd58fe2e84e$var$requireReactIs_development() {
    if ($4ada3cd58fe2e84e$var$hasRequiredReactIs_development) return $4ada3cd58fe2e84e$var$reactIs_development;
    $4ada3cd58fe2e84e$var$hasRequiredReactIs_development = 1;
    return $4ada3cd58fe2e84e$var$reactIs_development;
}
var $4ada3cd58fe2e84e$var$hasRequiredReactIs;
function $4ada3cd58fe2e84e$var$requireReactIs() {
    if ($4ada3cd58fe2e84e$var$hasRequiredReactIs) return $4ada3cd58fe2e84e$var$reactIs.exports;
    $4ada3cd58fe2e84e$var$hasRequiredReactIs = 1;
    $4ada3cd58fe2e84e$var$reactIs.exports = $4ada3cd58fe2e84e$var$requireReactIs_production_min();
    return $4ada3cd58fe2e84e$var$reactIs.exports;
}
var $4ada3cd58fe2e84e$var$hoistNonReactStatics_cjs;
var $4ada3cd58fe2e84e$var$hasRequiredHoistNonReactStatics_cjs;
function $4ada3cd58fe2e84e$var$requireHoistNonReactStatics_cjs() {
    if ($4ada3cd58fe2e84e$var$hasRequiredHoistNonReactStatics_cjs) return $4ada3cd58fe2e84e$var$hoistNonReactStatics_cjs;
    $4ada3cd58fe2e84e$var$hasRequiredHoistNonReactStatics_cjs = 1;
    var reactIs = $4ada3cd58fe2e84e$var$requireReactIs();
    /**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */ var REACT_STATICS = {
        childContextTypes: true,
        contextType: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromError: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    var FORWARD_REF_STATICS = {
        '$$typeof': true,
        render: true,
        defaultProps: true,
        displayName: true,
        propTypes: true
    };
    var MEMO_STATICS = {
        '$$typeof': true,
        compare: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
        type: true
    };
    var TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
        // React v16.11 and below
        if (reactIs.isMemo(component)) return MEMO_STATICS;
         // React v16.12 and above
        return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
    }
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = Object.prototype;
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
            var keys = getOwnPropertyNames(sourceComponent);
            if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            var targetStatics = getStatics(targetComponent);
            var sourceStatics = getStatics(sourceComponent);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try {
                        // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
        }
        return targetComponent;
    }
    $4ada3cd58fe2e84e$var$hoistNonReactStatics_cjs = hoistNonReactStatics;
    return $4ada3cd58fe2e84e$var$hoistNonReactStatics_cjs;
}
var $4ada3cd58fe2e84e$var$hoistNonReactStatics_cjsExports = $4ada3cd58fe2e84e$var$requireHoistNonReactStatics_cjs();
var $4ada3cd58fe2e84e$var$hoistStatics = /*@__PURE__*/ $4ada3cd58fe2e84e$var$getDefaultExportFromCjs($4ada3cd58fe2e84e$var$hoistNonReactStatics_cjsExports);
function $4ada3cd58fe2e84e$export$7c2cd585733fa877(WrappedComponent) {
    // @ts-ignore
    const name = WrappedComponent.displayName || WrappedComponent.name;
    class CookieWrapper extends $acw62.Component {
        constructor(){
            super(...arguments);
            this.onChange = ()=>{
                // Make sure to update children with new values
                this.forceUpdate();
            };
        }
        listen() {
            this.props.cookies.addChangeListener(this.onChange);
        }
        unlisten(cookies) {
            (cookies || this.props.cookies).removeChangeListener(this.onChange);
        }
        componentDidMount() {
            this.listen();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.cookies !== this.props.cookies) {
                this.unlisten(prevProps.cookies);
                this.listen();
            }
        }
        componentWillUnmount() {
            this.unlisten();
        }
        render() {
            const _a = this.props, { forwardedRef: forwardedRef, cookies: cookies } = _a, restProps = $4ada3cd58fe2e84e$var$__rest(_a, [
                "forwardedRef",
                "cookies"
            ]);
            const allCookies = cookies.getAll({
                doNotUpdate: true
            });
            return $acw62.createElement(WrappedComponent, Object.assign({}, restProps, {
                ref: forwardedRef,
                cookies: cookies,
                allCookies: allCookies
            }));
        }
    }
    CookieWrapper.displayName = `withCookies(${name})`;
    CookieWrapper.WrappedComponent = WrappedComponent;
    const ForwardedComponent = $acw62.forwardRef((props, ref)=>{
        return $acw62.createElement($4ada3cd58fe2e84e$var$Consumer, null, (cookies)=>$acw62.createElement(CookieWrapper, Object.assign({
                cookies: cookies
            }, props, {
                forwardedRef: ref
            })));
    });
    ForwardedComponent.displayName = CookieWrapper.displayName;
    ForwardedComponent.WrappedComponent = CookieWrapper.WrappedComponent;
    return $4ada3cd58fe2e84e$var$hoistStatics(ForwardedComponent, WrappedComponent);
}
function $4ada3cd58fe2e84e$var$isInBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}
function $4ada3cd58fe2e84e$export$14c4ae2979db17de(dependencies, options) {
    const cookies = (0, $acw62.useContext)($4ada3cd58fe2e84e$var$CookiesContext);
    if (!cookies) throw new Error('Missing <CookiesProvider>');
    const defaultOptions = {
        doNotUpdate: true
    };
    const getOptions = Object.assign(Object.assign({}, defaultOptions), options);
    const [allCookies, setCookies] = (0, $acw62.useState)(()=>cookies.getAll(getOptions));
    if ($4ada3cd58fe2e84e$var$isInBrowser()) (0, $acw62.useLayoutEffect)(()=>{
        function onChange() {
            const newCookies = cookies.getAll(getOptions);
            if ($4ada3cd58fe2e84e$var$shouldUpdate(dependencies || null, newCookies, allCookies)) setCookies(newCookies);
        }
        cookies.addChangeListener(onChange);
        return ()=>{
            cookies.removeChangeListener(onChange);
        };
    }, [
        cookies,
        allCookies
    ]);
    const setCookie = (0, $acw62.useMemo)(()=>cookies.set.bind(cookies), [
        cookies
    ]);
    const removeCookie = (0, $acw62.useMemo)(()=>cookies.remove.bind(cookies), [
        cookies
    ]);
    const updateCookies = (0, $acw62.useMemo)(()=>cookies.update.bind(cookies), [
        cookies
    ]);
    return [
        allCookies,
        setCookie,
        removeCookie,
        updateCookies
    ];
}
function $4ada3cd58fe2e84e$var$shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) return true;
    for (let dependency of dependencies){
        if (newCookies[dependency] !== oldCookies[dependency]) return true;
    }
    return false;
}

});
parcelRegister("f3UAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9444ae58ea249d4$export$2e2bcd8739ae039);
var $f9444ae58ea249d4$var$cookie = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ var $f9444ae58ea249d4$var$hasRequiredCookie;
function $f9444ae58ea249d4$var$requireCookie() {
    if ($f9444ae58ea249d4$var$hasRequiredCookie) return $f9444ae58ea249d4$var$cookie;
    $f9444ae58ea249d4$var$hasRequiredCookie = 1;
    /**
	 * Module exports.
	 * @public
	 */ $f9444ae58ea249d4$var$cookie.parse = parse;
    $f9444ae58ea249d4$var$cookie.serialize = serialize;
    /**
	 * Module variables.
	 * @private
	 */ var __toString = Object.prototype.toString;
    var __hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
	 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
	 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
	 * which has been replaced by the token definition in RFC 7230 appendix B.
	 *
	 * cookie-name       = token
	 * token             = 1*tchar
	 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
	 *                     "*" / "+" / "-" / "." / "^" / "_" /
	 *                     "`" / "|" / "~" / DIGIT / ALPHA
	 */ var cookieNameRegExp = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
    /**
	 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
	 *
	 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
	 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
	 *                     ; US-ASCII characters excluding CTLs,
	 *                     ; whitespace DQUOTE, comma, semicolon,
	 *                     ; and backslash
	 */ var cookieValueRegExp = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/;
    /**
	 * RegExp to match domain-value in RFC 6265 sec 4.1.1
	 *
	 * domain-value      = <subdomain>
	 *                     ; defined in [RFC1034], Section 3.5, as
	 *                     ; enhanced by [RFC1123], Section 2.1
	 * <subdomain>       = <label> | <subdomain> "." <label>
	 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
	 *                     Labels must be 63 characters or less.
	 *                     'let-dig' not 'letter' in the first char, per RFC1123
	 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	 * <let-dig-hyp>     = <let-dig> | "-"
	 * <let-dig>         = <letter> | <digit>
	 * <letter>          = any one of the 52 alphabetic characters A through Z in
	 *                     upper case and a through z in lower case
	 * <digit>           = any one of the ten digits 0 through 9
	 *
	 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
	 *
	 * > (Note that a leading %x2E ("."), if present, is ignored even though that
	 * character is not permitted, but a trailing %x2E ("."), if present, will
	 * cause the user agent to ignore the attribute.)
	 */ var domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
    /**
	 * RegExp to match path-value in RFC 6265 sec 4.1.1
	 *
	 * path-value        = <any CHAR except CTLs or ";">
	 * CHAR              = %x01-7F
	 *                     ; defined in RFC 5234 appendix B.1
	 */ var pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
    /**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [opt]
	 * @return {object}
	 * @public
	 */ function parse(str, opt) {
        if (typeof str !== 'string') throw new TypeError('argument str must be a string');
        var obj = {};
        var len = str.length;
        // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
        if (len < 2) return obj;
        var dec = opt && opt.decode || decode;
        var index = 0;
        var eqIdx = 0;
        var endIdx = 0;
        do {
            eqIdx = str.indexOf('=', index);
            if (eqIdx === -1) break; // No more cookie pairs.
            endIdx = str.indexOf(';', index);
            if (endIdx === -1) endIdx = len;
            else if (eqIdx > endIdx) {
                // backtrack on prior semicolon
                index = str.lastIndexOf(';', eqIdx - 1) + 1;
                continue;
            }
            var keyStartIdx = startIndex(str, index, eqIdx);
            var keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
            var key = str.slice(keyStartIdx, keyEndIdx);
            // only assign once
            if (!__hasOwnProperty.call(obj, key)) {
                var valStartIdx = startIndex(str, eqIdx + 1, endIdx);
                var valEndIdx = endIndex(str, endIdx, valStartIdx);
                if (str.charCodeAt(valStartIdx) === 0x22 /* " */  && str.charCodeAt(valEndIdx - 1) === 0x22 /* " */ ) {
                    valStartIdx++;
                    valEndIdx--;
                }
                var val = str.slice(valStartIdx, valEndIdx);
                obj[key] = tryDecode(val, dec);
            }
            index = endIdx + 1;
        }while (index < len);
        return obj;
    }
    function startIndex(str, index, max) {
        do {
            var code = str.charCodeAt(index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
        }while (++index < max);
        return max;
    }
    function endIndex(str, index, min) {
        while(index > min){
            var code = str.charCodeAt(--index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
        }
        return min;
    }
    /**
	 * Serialize data into a cookie header.
	 *
	 * Serialize a name value pair into a cookie string suitable for
	 * http headers. An optional options object specifies cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [opt]
	 * @return {string}
	 * @public
	 */ function serialize(name, val, opt) {
        var enc = opt && opt.encode || encodeURIComponent;
        if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
        if (!cookieNameRegExp.test(name)) throw new TypeError('argument name is invalid');
        var value = enc(val);
        if (!cookieValueRegExp.test(value)) throw new TypeError('argument val is invalid');
        var str = name + '=' + value;
        if (!opt) return str;
        if (null != opt.maxAge) {
            var maxAge = Math.floor(opt.maxAge);
            if (!isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
            str += '; Max-Age=' + maxAge;
        }
        if (opt.domain) {
            if (!domainValueRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
            str += '; Domain=' + opt.domain;
        }
        if (opt.path) {
            if (!pathValueRegExp.test(opt.path)) throw new TypeError('option path is invalid');
            str += '; Path=' + opt.path;
        }
        if (opt.expires) {
            var expires = opt.expires;
            if (!isDate(expires) || isNaN(expires.valueOf())) throw new TypeError('option expires is invalid');
            str += '; Expires=' + expires.toUTCString();
        }
        if (opt.httpOnly) str += '; HttpOnly';
        if (opt.secure) str += '; Secure';
        if (opt.partitioned) str += '; Partitioned';
        if (opt.priority) {
            var priority = typeof opt.priority === 'string' ? opt.priority.toLowerCase() : opt.priority;
            switch(priority){
                case 'low':
                    str += '; Priority=Low';
                    break;
                case 'medium':
                    str += '; Priority=Medium';
                    break;
                case 'high':
                    str += '; Priority=High';
                    break;
                default:
                    throw new TypeError('option priority is invalid');
            }
        }
        if (opt.sameSite) {
            var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
            switch(sameSite){
                case true:
                    str += '; SameSite=Strict';
                    break;
                case 'lax':
                    str += '; SameSite=Lax';
                    break;
                case 'strict':
                    str += '; SameSite=Strict';
                    break;
                case 'none':
                    str += '; SameSite=None';
                    break;
                default:
                    throw new TypeError('option sameSite is invalid');
            }
        }
        return str;
    }
    /**
	 * URL-decode string value. Optimized to skip native call when no %.
	 *
	 * @param {string} str
	 * @returns {string}
	 */ function decode(str) {
        return str.indexOf('%') !== -1 ? decodeURIComponent(str) : str;
    }
    /**
	 * Determine if value is a Date.
	 *
	 * @param {*} val
	 * @private
	 */ function isDate(val) {
        return __toString.call(val) === '[object Date]';
    }
    /**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */ function tryDecode(str, decode) {
        try {
            return decode(str);
        } catch (e) {
            return str;
        }
    }
    return $f9444ae58ea249d4$var$cookie;
}
var $f9444ae58ea249d4$var$cookieExports = $f9444ae58ea249d4$var$requireCookie();
function $f9444ae58ea249d4$var$hasDocumentCookie() {
    const testingValue = typeof $parcel$global === 'undefined' ? undefined : $parcel$global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') return testingValue;
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $f9444ae58ea249d4$var$parseCookies(cookies) {
    if (typeof cookies === 'string') return $f9444ae58ea249d4$var$cookieExports.parse(cookies);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $f9444ae58ea249d4$var$readCookie(value, options = {}) {
    const cleanValue = $f9444ae58ea249d4$var$cleanupCookieValue(value);
    if (!options.doNotParse) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $f9444ae58ea249d4$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}
class $f9444ae58ea249d4$export$2e2bcd8739ae039 {
    constructor(cookies, defaultSetOptions = {}){
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = ()=>{
            if (!this.HAS_DOCUMENT_COOKIE) return;
            const previousCookies = this.cookies;
            this.cookies = $f9444ae58ea249d4$var$cookieExports.parse(document.cookie);
            this._checkChanges(previousCookies);
        };
        const domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = $f9444ae58ea249d4$var$parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = $f9444ae58ea249d4$var$hasDocumentCookie();
    }
    _emitChange(params) {
        for(let i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    }
    _checkChanges(previousCookies) {
        const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
        names.forEach((name)=>{
            if (previousCookies[name] !== this.cookies[name]) this._emitChange({
                name: name,
                value: $f9444ae58ea249d4$var$readCookie(this.cookies[name])
            });
        });
    }
    _startPolling() {
        this.pollingInterval = setInterval(this.update, 300);
    }
    _stopPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    get(name, options = {}) {
        if (!options.doNotUpdate) this.update();
        return $f9444ae58ea249d4$var$readCookie(this.cookies[name], options);
    }
    getAll(options = {}) {
        if (!options.doNotUpdate) this.update();
        const result = {};
        for(let name in this.cookies)result[name] = $f9444ae58ea249d4$var$readCookie(this.cookies[name], options);
        return result;
    }
    set(name, value, options) {
        if (options) options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
        else options = this.defaultSetOptions;
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        this.cookies = Object.assign(Object.assign({}, this.cookies), {
            [name]: stringValue
        });
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $f9444ae58ea249d4$var$cookieExports.serialize(name, stringValue, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    }
    remove(name, options) {
        const finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = Object.assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $f9444ae58ea249d4$var$cookieExports.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    }
    addChangeListener(callback) {
        this.changeListeners.push(callback);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.addEventListener('change', this.update);
            else this._startPolling();
        }
    }
    removeChangeListener(callback) {
        const idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.removeEventListener('change', this.update);
            else this._stopPolling();
        }
    }
}

});


parcelRegister("mZ3Ai", function(module, exports) {

$parcel$export(module.exports, "getAllUserTenants", () => $9264e7b431fbd08c$export$60248dfe2266fc63);

var $6SpLG = parcelRequire("6SpLG");

var $6lvMC = parcelRequire("6lvMC");
const $9264e7b431fbd08c$export$60248dfe2266fc63 = (0, $6SpLG.createSelector)((0, $6lvMC.getCurrentUser), (user)=>{
    if (!user?.tenantUsers) return [];
    return user.tenantUsers.filter(({ active: active })=>active).map(({ tenant: tenant })=>tenant);
});

});



parcelRegister("4NV2o", function(module, exports) {

$parcel$export(module.exports, "AppActionTypes", () => $6179cfc7bf231206$export$1e9ff8aeca5817f9);
$parcel$export(module.exports, "checkSessionAction", () => $6179cfc7bf231206$export$5db63a9926169aaf);
var $6179cfc7bf231206$export$1e9ff8aeca5817f9 = /*#__PURE__*/ function(AppActionTypes) {
    AppActionTypes["CHECK_SESSION_ACTIVE_PENDING"] = "@@app/CHECK_SESSION_ACTIVE_PENDING";
    return AppActionTypes;
}({});
const $6179cfc7bf231206$export$5db63a9926169aaf = ()=>{
    return {
        type: "@@app/CHECK_SESSION_ACTIVE_PENDING"
    };
};

});


parcelRegister("lIZKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $611cf45a6bb4cc4a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $COwA0 = parcelRequire("COwA0");

var $8g1PZ = parcelRequire("8g1PZ");

var $j0qQC = parcelRequire("j0qQC");

var $jikyI = parcelRequire("jikyI");

var $4Z6GL = parcelRequire("4Z6GL");

var $rDKvs = parcelRequire("rDKvs");

var $kbfou = parcelRequire("kbfou");

var $cKREw = parcelRequire("cKREw");

var $5RtA9 = parcelRequire("5RtA9");

var $KCPBw = parcelRequire("KCPBw");

var $xQehV = parcelRequire("xQehV");

var $3TcXu = parcelRequire("3TcXu");

var $cYRvU = parcelRequire("cYRvU");

var $iHApv = parcelRequire("iHApv");

var $6rb7h = parcelRequire("6rb7h");

var $et8Rr = parcelRequire("et8Rr");

var $4VtCQ = parcelRequire("4VtCQ");

var $7HZDe = parcelRequire("7HZDe");

var $aEgqS = parcelRequire("aEgqS");

var $4KSAX = parcelRequire("4KSAX");

var $8UrgM = parcelRequire("8UrgM");

var $6j1K3 = parcelRequire("6j1K3");

var $2D4mW = parcelRequire("2D4mW");

var $9iUtM = parcelRequire("9iUtM");

var $aeos3 = parcelRequire("aeos3");

var $e5EhV = parcelRequire("e5EhV");

var $3mOhS = parcelRequire("3mOhS");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6lvMC = parcelRequire("6lvMC");

var $kYqkq = parcelRequire("kYqkq");

var $f1q41 = parcelRequire("f1q41");

var $kon2z = parcelRequire("kon2z");

var $6UuII = parcelRequire("6UuII");
const $611cf45a6bb4cc4a$var$LiveMeetingPage = ()=>{
    // Preload all the required translaions to prevent page reload when suspense triggers
    (0, $4KSAX.useTranslation)([
        "shared",
        "liveMeeting",
        "case",
        "meeting",
        "user",
        "asset"
    ]);
    const { meetingId: meetingId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const meeting = (0, $kYqkq.useAppSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: meetingId
        }));
    const webRtcApiKey = meeting?.webRtcApiKey;
    const sessionId = meeting?.sessionId;
    const meetingToken = meeting?.token;
    const liveMeetingUI = (0, $kYqkq.useAppSelector)((state)=>state.ui.liveMeeting);
    const selectedMeetingCase = (0, $kYqkq.useAppSelector)((0, $3mOhS.getSelectedMeetingCase));
    const selectedCase = (0, $kYqkq.useAppSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: selectedMeetingCase?.case
        }));
    const liveMeetingConfig = (0, $kYqkq.useAppSelector)((state)=>state.liveMeetingConfig);
    const { presenterId: presenterId, scribeId: scribeId, caseStage: caseStage, recommendationsSavedAt: recommendationsSavedAt } = liveMeetingConfig;
    const presenter = (0, $kYqkq.useAppSelector)((state)=>(0, $6lvMC.getUserById)(state, presenterId));
    const scribe = (0, $kYqkq.useAppSelector)((state)=>(0, $6lvMC.getUserById)(state, scribeId));
    const [isChatOpen, setIsChatOpen] = (0, $acw62.useState)(false);
    const [isChangeCaseModalOpen, setIsCaseChangeModalOpen] = (0, $acw62.useState)(false);
    const { messagingEnabled: messagingEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(0);
    (0, $e5EhV.useBeforeunload)(()=>{
        setConnectionRefresherIndex(connectionRefresherIndex + 1);
    });
    const refetchMeetingCase = ()=>{
        // Refresh case assets
        dispatch((0, $7HZDe.fetchCaseAssetsAction)(selectedMeetingCase?.case));
        // Refresh meeting case assets & meeting case status
        dispatch((0, $6j1K3.fetchMeetingCaseAction)(selectedMeetingCase?.id));
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4Z6GL.fetchMeetingAction)(meetingId));
        dispatch((0, $rDKvs.fetchLiveMeetingConfigAsync)(meetingId));
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    // call fetchLiveMeetingConfig at most every 5 seconds
    // because the function updates the liveMeetingConfig state object (even if it's content stays the same)
    // this will trigger a call of the debounced function, calling it again in 5 seconds
    const reloadMeetingConfig = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce(()=>{
        dispatch((0, $rDKvs.fetchLiveMeetingConfigAsync)(meetingId));
    }, 5000), []);
    (0, $acw62.useEffect)(()=>{
        reloadMeetingConfig();
    }, [
        liveMeetingConfig
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedCase) return;
        setIsCaseChangeModalOpen(true);
        console.log(selectedMeetingCase);
    }, [
        selectedMeetingCase?.id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedMeetingCase) return;
        refetchMeetingCase();
    }, [
        selectedMeetingCase?.id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedMeetingCase || !recommendationsSavedAt || !recommendationsSavedAt[selectedMeetingCase.id]) return;
        refetchMeetingCase();
    }, [
        recommendationsSavedAt
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!scribeId || !scribe) return;
        dispatch((0, $arZQw.displayUserMessageAction)({
            messageKey: "scribeChangedWithName",
            messageArgs: {
                firstName: scribe.firstName,
                lastName: scribe.lastName
            },
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    }, [
        scribeId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!presenterId || !presenter) return;
        dispatch((0, $arZQw.displayUserMessageAction)({
            messageKey: "presenterChangedWithName",
            messageArgs: {
                firstName: presenter.firstName,
                lastName: presenter.lastName
            },
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    }, [
        presenterId
    ]);
    const isSplitScreen = liveMeetingUI.isSplitScreen || caseStage == (0, $j0qQC.CaseStage).APPROVING;
    const approving = caseStage == (0, $j0qQC.CaseStage).APPROVING;
    if (!meetingToken) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const renderMessaging = ()=>{
        if (!messagingEnabled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2D4mW.default), {
                    isOpen: isChatOpen,
                    setIsOpen: setIsChatOpen,
                    chatId: meeting.chatId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iUtM.default), {
                    chatId: meeting.chatId,
                    isOpen: isChatOpen,
                    setIsOpen: setIsChatOpen
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
        resourceId: meetingId,
        channelName: (0, $j0qQC.LiveMeetingChannelName),
        actionPrefix: (0, $j0qQC.liveMeetingCablePrefix),
        awaitConnection: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $KCPBw.default), {
            webRtcApiKey: webRtcApiKey,
            sessionId: sessionId,
            meetingToken: meetingToken,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3TcXu.default), {
                    publisherOptions: (0, $xQehV.userStreamPublisherOptions)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6rb7h.default), {
                    publisherOptions: (0, $xQehV.screenshareStreamPublisherOptions)
                }),
                renderMessaging(),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6UuII.default), {
                    isOpen: isChangeCaseModalOpen,
                    caseId: selectedCase?.id,
                    setIsOpen: setIsCaseChangeModalOpen
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col h-screen bg-ch-blue-100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jikyI.default), {
                            meetingId: meetingId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col flex-1 overflow-hidden mx-5 mb-5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lg:flex",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lg:w-1/2 bg-white rounded-md p-2 mb-2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RtA9.default), {
                                                meetingId: meetingId
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lg:w-1/2 lg:ml-1 flex mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "bg-ch-blue-500 rounded-md p-2 flex-1 sm:flex-auto sm:mr-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kbfou.default), {})
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "bg-ch-blue-500 rounded-md p-2 hidden sm:block",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cKREw.default), {})
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col h-full sm:grid sm:grid-cols-2 gap-1 overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1 bg-white rounded-md overflow-hidden", {
                                                "col-span-1": isSplitScreen,
                                                "col-span-2": !isSplitScreen
                                            }),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cYRvU.default), {
                                                meetingId: meetingId
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1 bg-white rounded-md overflow-hidden", "relative", {
                                                "col-span-1 block": approving,
                                                "col-span-1 hidden sm:block": isSplitScreen && !approving,
                                                "hidden": !isSplitScreen && !approving
                                            }),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iHApv.default), {
                                                meetingId: meetingId
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, connectionRefresherIndex);
};
var $611cf45a6bb4cc4a$export$2e2bcd8739ae039 = $611cf45a6bb4cc4a$var$LiveMeetingPage;

});
parcelRegister("j0qQC", function(module, exports) {

$parcel$export(module.exports, "LiveMeetingChannelName", () => $4a8a7908cce689ba$export$56799c0e26158749);
$parcel$export(module.exports, "ConsentResponse", () => $4a8a7908cce689ba$export$e2cb0222f188195c);
$parcel$export(module.exports, "RecommendationStatus", () => $4a8a7908cce689ba$export$b6c25459278323a0);
$parcel$export(module.exports, "CaseStage", () => $4a8a7908cce689ba$export$c66f4f9359a2481);
$parcel$export(module.exports, "YourViewTabs", () => $4a8a7908cce689ba$export$ca6e779a86ec5c5b);
$parcel$export(module.exports, "UsersViewTabs", () => $4a8a7908cce689ba$export$75e528327b8c9945);
$parcel$export(module.exports, "LiveMeetingActionTypes", () => $4a8a7908cce689ba$export$e54346e1d4964101);
$parcel$export(module.exports, "liveMeetingCablePrefix", () => $4a8a7908cce689ba$export$18782b96a1df258);
$parcel$export(module.exports, "LiveMeetingCableActionTypes", () => $4a8a7908cce689ba$export$e6a094a7f4d2902);
const $4a8a7908cce689ba$export$56799c0e26158749 = "LiveMeetingConfigChannel";
var $4a8a7908cce689ba$export$e2cb0222f188195c = /*#__PURE__*/ function(ConsentResponse) {
    ConsentResponse["APPROVE"] = "approve";
    ConsentResponse["REJECT"] = "reject";
    ConsentResponse["NA"] = "na";
    ConsentResponse["PENDING"] = "pending";
    return ConsentResponse;
}({});
var $4a8a7908cce689ba$export$b6c25459278323a0 = /*#__PURE__*/ function(RecommendationStatus) {
    RecommendationStatus["PENDING"] = "pending";
    RecommendationStatus["final"] = "final";
    return RecommendationStatus;
}({});
var $4a8a7908cce689ba$export$3a8c8363200890be = /*#__PURE__*/ function(RecommendationType) {
    RecommendationType["CASE"] = "case";
    RecommendationType["MEETING"] = "meeting";
    return RecommendationType;
}({});
var $4a8a7908cce689ba$export$c66f4f9359a2481 = /*#__PURE__*/ function(CaseStage) {
    CaseStage[CaseStage["PRESENTING"] = 1] = "PRESENTING";
    CaseStage[CaseStage["DEFERRING"] = 2] = "DEFERRING";
    CaseStage[CaseStage["RECOMMENDING"] = 3] = "RECOMMENDING";
    CaseStage[CaseStage["APPROVING"] = 4] = "APPROVING";
    return CaseStage;
}({});
var $4a8a7908cce689ba$export$ca6e779a86ec5c5b = /*#__PURE__*/ function(YourViewTabs) {
    YourViewTabs[YourViewTabs["YOUR_VIEW"] = 1] = "YOUR_VIEW";
    YourViewTabs[YourViewTabs["USERS_VIEW"] = 2] = "USERS_VIEW";
    return YourViewTabs;
}({});
var $4a8a7908cce689ba$export$75e528327b8c9945 = /*#__PURE__*/ function(UsersViewTabs) {
    UsersViewTabs[UsersViewTabs["LIST"] = 1] = "LIST";
    UsersViewTabs[UsersViewTabs["GRID"] = 2] = "GRID";
    return UsersViewTabs;
}({});
var $4a8a7908cce689ba$export$e54346e1d4964101 = /*#__PURE__*/ function(LiveMeetingActionTypes) {
    LiveMeetingActionTypes["FETCH_LIVE_MEETING_CONFIG_ASYNC_PENDING"] = "@@liveMeeting/FETCH_LIVE_MEETING_CONFIG_ASYNC_PENDING";
    LiveMeetingActionTypes["FETCH_LIVE_MEETING_CONFIG_ASYNC_SUCCESS"] = "@@liveMeeting/FETCH_LIVE_MEETING_CONFIG_ASYNC_SUCCESS";
    LiveMeetingActionTypes["FETCH_LIVE_MEETING_CONFIG_ASYNC_ERROR"] = "@@liveMeeting/FETCH_LIVE_MEETING_CONFIG_ASYNC_ERROR";
    LiveMeetingActionTypes["TOGGLE_SPLIT_SCREEN"] = "@@liveMeeting/TOGGLE_SPLIT_SCREEN";
    LiveMeetingActionTypes["CHANGE_YOUR_VIEW_TAB"] = "@@liveMeeting/CHANGE_YOUR_VIEW_TAB";
    LiveMeetingActionTypes["CHANGE_USERS_VIEW_TAB"] = "@@liveMeeting/CHANGE_USERS_VIEW_TAB";
    LiveMeetingActionTypes["TOGGLE_YOUR_VIEW_ASSET_LIST_OPEN"] = "@@liveMeeting/TOGGLE_YOUR_VIEW_ASSET_LIST_OPEN";
    LiveMeetingActionTypes["UPDATE_YOUR_VIEW_SELECTED_ASSET"] = "@@liveMeeting/UPDATE_YOUR_VIEW_SELECTED_ASSET";
    LiveMeetingActionTypes["USER_SPEAKING"] = "@@liveMeeting/USER_SPEAKING";
    LiveMeetingActionTypes["MEDIA_ERROR"] = "@@liveMeeint/MEDIA_ERROR";
    return LiveMeetingActionTypes;
}({});
const $4a8a7908cce689ba$export$18782b96a1df258 = "@@liveMeetingCable/";
var $4a8a7908cce689ba$export$e6a094a7f4d2902 = /*#__PURE__*/ function(LiveMeetingCableActionTypes) {
    // INBOUND
    LiveMeetingCableActionTypes["UPDATE_CONFIG"] = "@@liveMeetingCable/UPDATE_CONFIG";
    LiveMeetingCableActionTypes["UPDATE_MEETING_CASES"] = "@@liveMeetingCable/UPDATE_MEETING_CASES";
    LiveMeetingCableActionTypes["UPDATE_MEETING"] = "@@liveMeetingCable/UPDATE_MEETING";
    LiveMeetingCableActionTypes["UPDATE_CASE_ASSETS"] = "@@liveMeetingCable/UPDATE_CASE_ASSETS";
    // OUTBOUND
    LiveMeetingCableActionTypes["SELECT_MEETING_CASE"] = "@@liveMeetingCable/SELECT_MEETING_CASE";
    LiveMeetingCableActionTypes["TOGGLE_IS_ONLINE"] = "@@liveMeetingCable/TOGGLE_IS_ONLINE";
    LiveMeetingCableActionTypes["TOGGLE_IS_PRESENT"] = "@@liveMeetingCable/TOGGLE_IS_PRESENT";
    LiveMeetingCableActionTypes["TOGGLE_IS_SHARING_AUDIO"] = "@@liveMeetingCable/TOGGLE_IS_SHARING_AUDIO";
    LiveMeetingCableActionTypes["TOGGLE_IS_SHARING_VIDEO"] = "@@liveMeetingCable/TOGGLE_IS_SHARING_VIDEO";
    LiveMeetingCableActionTypes["TOGGLE_IS_SHARING_SCREEN"] = "@@liveMeetingCable/TOGGLE_IS_SHARING_SCREEN";
    LiveMeetingCableActionTypes["UPDATE_SHARED_VIEW_SELECTED_ASSET"] = "@@liveMeetingCable/UPDATE_SHARED_VIEW_SELECTED_ASSET";
    LiveMeetingCableActionTypes["UPDATE_SHARED_VIEW_HOVERED_ASSET"] = "@@liveMeetingCable/UPDATE_SHARED_VIEW_HOVERED_ASSET";
    LiveMeetingCableActionTypes["UPDATE_SHARED_IMAGE_ZOOM_STATE"] = "@@liveMeetingCable/UPDATE_SHARED_IMAGE_ZOOM_STATE";
    LiveMeetingCableActionTypes["UPDATE_SHARED_PDF_STATE"] = "@@liveMeetingCable/UPDATE_SHARED_PDF_STATE";
    LiveMeetingCableActionTypes["TRANSFER_PRESENTER"] = "@@liveMeetingCable/TRANSFER_PRESENTER";
    LiveMeetingCableActionTypes["TRANSFER_SCRIBE"] = "@@liveMeetingCable/TRANSFER_SCRIBE";
    LiveMeetingCableActionTypes["UPDATE_RECOMMENDATION"] = "@@liveMeetingCable/UPDATE_RECOMMENDATION";
    LiveMeetingCableActionTypes["SHARE_RECOMMENDATION"] = "@@liveMeetingCable/SHARE_RECOMMENDATION";
    LiveMeetingCableActionTypes["REQUEST_APPROVAL_RECOMMENDATION"] = "@@liveMeetingCable/REQUEST_APPROVAL_RECOMMENDATION";
    LiveMeetingCableActionTypes["DEFER_RECOMMENDATION"] = "@@liveMeetingCable/DEFER_RECOMMENDATION";
    LiveMeetingCableActionTypes["SAVE_DEFER_RECOMMENDATION"] = "@@liveMeetingCable/SAVE_DEFER_RECOMMENDATION";
    LiveMeetingCableActionTypes["CANCEL_RECOMMENDATION"] = "@@liveMeetingCable/CANCEL_RECOMMENDATION";
    LiveMeetingCableActionTypes["SAVE_RECOMMENDATION"] = "@@liveMeetingCable/SAVE_RECOMMENDATION";
    LiveMeetingCableActionTypes["ADD_CONSENT"] = "@@liveMeetingCable/ADD_CONSENT";
    LiveMeetingCableActionTypes["ADD_CONSENT_ON_BEHALF"] = "@@liveMeetingCable/ADD_CONSENT_ON_BEHALF";
    return LiveMeetingCableActionTypes;
}({});

});

parcelRegister("jikyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb48d602cadbf2ff$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $4jmv8 = parcelRequire("4jmv8");

var $7hl6H = parcelRequire("7hl6H");

var $jF0Xa = parcelRequire("jF0Xa");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4VtCQ = parcelRequire("4VtCQ");

var $aeos3 = parcelRequire("aeos3");

var $adP1p = parcelRequire("adP1p");

var $cQAM9 = parcelRequire("cQAM9");
const $fb48d602cadbf2ff$var$LiveMeetingHeaderContainer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const { tenantName: tenantName } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const leaveMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: props.meetingId
    });
    if (!meeting) return;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "px-5 sm:pt-2 pb-2 mb-3 bg-white shadow",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "block sm:flex justify-between items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "sm:flex items-center sm:m-1 lg:pr-5 justify-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "hidden md:block",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adP1p.default), {
                                className: "h-14 mr-2"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col lg:flex-row sm:items-start text-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-sm md:text-base text-ch-gray-600 uppercase mr-2",
                                    children: tenantName
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "hidden md:block lg:ml-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cQAM9.default), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 lg:pr-5 text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-sm leading-tight md:text-base lg:text-xl text-ch-blue-600",
                            children: meeting.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                            utcTime: meeting.startDate,
                            className: "hidden sm:block text-sm lg:text-lg text-ch-blue-600 italic font-thin"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-sm lg:text-base pr-5 lg:block hidden",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jmv8.default), {
                                utcStartTime: meeting.startDateActual
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-col",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                href: leaveMeetingUrl,
                                className: "mt-1 sm:mb-2",
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isChunky: true,
                                children: t("liveMeeting:leaveMeeting")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $fb48d602cadbf2ff$export$2e2bcd8739ae039 = $fb48d602cadbf2ff$var$LiveMeetingHeaderContainer;

});
parcelRegister("4jmv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec6da67eff06fd0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $8xDhD = parcelRequire("8xDhD");
const $dec6da67eff06fd0$var$LiveMeetingElapsedTime = ({ utcStartTime: utcStartTime })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const [time, setTime] = (0, $acw62.useState)(getTime());
    function getTime() {
        const diff = (0, $8xDhD.default)(new Date(), new Date(utcStartTime));
        const hours = Math.floor(diff / 3600);
        const minutes = Math.floor((diff - 3600 * hours) / 60);
        return {
            h: hours,
            m: minutes
        };
    }
    (0, $acw62.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            setTime(getTime());
        }, 500);
        return ()=>clearInterval(intervalId);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex items-center uppercase flex-col"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: t("liveMeeting:meetingElapsedTime")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mr-2"),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: time.h
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t("liveMeeting:hours")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: time.m
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: t("liveMeeting:mins")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $dec6da67eff06fd0$export$2e2bcd8739ae039 = $dec6da67eff06fd0$var$LiveMeetingElapsedTime;

});
parcelRegister("8xDhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $637fe0a8b24e6f33$export$2e2bcd8739ae039);

var $bFuWZ = parcelRequire("bFuWZ");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $637fe0a8b24e6f33$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $bFuWZ.default)(dateLeft, dateRight) / 1000;
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("bFuWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87eb8823ffa05467$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $87eb8823ffa05467$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $4LmDH.default)(2, arguments);
    return (0, $gdr0J.default)(dateLeft).getTime() - (0, $gdr0J.default)(dateRight).getTime();
}

});

parcelRegister("hbRD3", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $c83d105896c1098b$export$b6474a47258c1211);
var $c83d105896c1098b$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $c83d105896c1098b$var$defaultRoundingMethod = 'trunc';
function $c83d105896c1098b$export$b6474a47258c1211(method) {
    return method ? $c83d105896c1098b$var$roundingMap[method] : $c83d105896c1098b$var$roundingMap[$c83d105896c1098b$var$defaultRoundingMethod];
}

});



parcelRegister("7hl6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $9feea7dc84e6d861$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");

var $1Lj4p = parcelRequire("1Lj4p");
const $9feea7dc84e6d861$var$TimeDefaultFormat = ({ utcTime: utcTime, className: className, withoutTZ: withoutTZ })=>{
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    if (!utcTime) return null;
    const formattedDate = withoutTZ ? (0, $ahLi9.dateWithoutTimezone)(utcTime, timezone) : (0, $ahLi9.dateWithTimezone)(utcTime, timezone);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: className,
        children: formattedDate
    });
};
var $9feea7dc84e6d861$export$2e2bcd8739ae039 = $9feea7dc84e6d861$var$TimeDefaultFormat;

});

parcelRegister("4VtCQ", function(module, exports) {

$parcel$export(module.exports, "getAllMeetingIdsUiIndexPage", () => $4369da2181a28c50$export$43a452a5544cf6c);
$parcel$export(module.exports, "getMeetingById", () => $4369da2181a28c50$export$3266a194afcfa615);
$parcel$export(module.exports, "getAllMeetings", () => $4369da2181a28c50$export$212181928ce3fd8);
$parcel$export(module.exports, "getMeetingsByIdsAsArray", () => $4369da2181a28c50$export$a00feffeb2900040);
$parcel$export(module.exports, "getAllMeetingsAsArray", () => $4369da2181a28c50$export$9ab6cdef49b62b13);
$parcel$export(module.exports, "getMeetingCaseById", () => $4369da2181a28c50$export$e63f1ba23b381997);
$parcel$export(module.exports, "getAllMeetingCases", () => $4369da2181a28c50$export$1a8c121204845c1e);
$parcel$export(module.exports, "getMeetingCaseIds", () => $4369da2181a28c50$export$c046090f92328661);
$parcel$export(module.exports, "getMeetingUserIds", () => $4369da2181a28c50$export$e04ffa6721d9713b);
$parcel$export(module.exports, "getMeetingUsers", () => $4369da2181a28c50$export$6d4876000512a5d1);
$parcel$export(module.exports, "getMeetingUserByMeetingUserId", () => $4369da2181a28c50$export$3dd431b1c5dc8d35);
$parcel$export(module.exports, "getMeetingUserByCurrentUserId", () => $4369da2181a28c50$export$668bb7719914de33);
$parcel$export(module.exports, "getMeetingUserByUserIdAndMeetingId", () => $4369da2181a28c50$export$7fffbf77d34b4f94);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $6lvMC = parcelRequire("6lvMC");
const $4369da2181a28c50$export$43a452a5544cf6c = (state)=>state.ui.meetings.idsOnIndexPage;
const $4369da2181a28c50$export$3266a194afcfa615 = (state, ownProps)=>{
    const meetingId = ownProps.meetingId;
    return state.entities.meetings.byId[meetingId];
};
const $4369da2181a28c50$export$212181928ce3fd8 = (state)=>state.entities.meetings.byId;
const $4369da2181a28c50$export$a00feffeb2900040 = (0, $6SpLG.createSelector)([
    $4369da2181a28c50$export$212181928ce3fd8,
    (_state, ownProps)=>ownProps?.meetingIds
], (byId, meetingIds)=>{
    if (!meetingIds) return [];
    return meetingIds.map((meetingId)=>byId[meetingId]);
});
const $4369da2181a28c50$export$9ab6cdef49b62b13 = (0, $6SpLG.createSelector)([
    (state)=>state.entities.meetings.allIds,
    $4369da2181a28c50$export$212181928ce3fd8
], (allIds, byId)=>{
    if (!allIds) return [];
    return allIds.map((meetingId)=>byId[meetingId]);
});
const $4369da2181a28c50$export$e63f1ba23b381997 = (state, ownProps)=>state.entities.meetingCases.byId[ownProps.meetingCaseId] ?? null;
const $4369da2181a28c50$export$1a8c121204845c1e = (state)=>state.entities.meetingCases.byId;
const $4369da2181a28c50$export$c046090f92328661 = (0, $6SpLG.createSelector)($4369da2181a28c50$export$3266a194afcfa615, (meeting)=>{
    if (!meeting) return [];
    return meeting.meetingCases;
});
const $4369da2181a28c50$export$e04ffa6721d9713b = (0, $6SpLG.createSelector)($4369da2181a28c50$export$3266a194afcfa615, (meeting)=>{
    if (!meeting) return [];
    return meeting.users;
});
const $4369da2181a28c50$export$6d4876000512a5d1 = (0, $6SpLG.createSelector)((0, $6lvMC.getAllUsers), $4369da2181a28c50$export$e04ffa6721d9713b, (allUsers, meetingUserIds)=>{
    if (!meetingUserIds) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pick(allUsers, meetingUserIds);
});
const $4369da2181a28c50$export$3dd431b1c5dc8d35 = (state, ownProps)=>{
    return state.entities.meetingUsers.byId[ownProps.meetingUserId] ?? null;
};
const $4369da2181a28c50$var$meetingUserByUserId = (state, meetingId, userId)=>{
    const meeting = state.entities.meetings.byId[meetingId];
    if (!meeting || !meeting.meetingUsers) return null;
    return meeting.meetingUsers.map((x)=>state.entities.meetingUsers.byId[x]).find((user)=>{
        if (!user) return null;
        return user.userId == userId || null;
    });
};
const $4369da2181a28c50$export$668bb7719914de33 = (state, meetingId)=>{
    return $4369da2181a28c50$var$meetingUserByUserId(state, meetingId, state.userSession.id);
};
const $4369da2181a28c50$export$7fffbf77d34b4f94 = (state, meetingId, userId)=>{
    return $4369da2181a28c50$var$meetingUserByUserId(state, meetingId, userId);
};

});

parcelRegister("adP1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91370879adbdf72$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aeos3 = parcelRequire("aeos3");

var $jUk5c = parcelRequire("jUk5c");
const $f91370879adbdf72$var$TenantLogo = (props)=>{
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)("");
    const { tenantName: tenantName, tenantLogoPath: tenantLogoPath } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    (0, $acw62.useEffect)(()=>{
        if (!tenantLogoPath) return;
        (0, $jUk5c.default)(tenantLogoPath, setBlobUrl);
    }, [
        tenantLogoPath
    ]);
    if (!blobUrl) return null;
    const defaultClasses = [
        "flex"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            className: "max-h-full",
            src: blobUrl,
            title: tenantName
        })
    });
};
var $f91370879adbdf72$export$2e2bcd8739ae039 = $f91370879adbdf72$var$TenantLogo;

});
parcelRegister("jUk5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $d032b089425ea600$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $1zizz = parcelRequire("1zizz");
const $d032b089425ea600$var$fetchBlob = (path, setBlobUrlCallback)=>{
    if (path === undefined || path === "") {
        setBlobUrlCallback("");
        return;
    }
    const url = "/api" + path;
    fetch(url, (0, $1zizz.withAuthHeader)()).then((response)=>{
        if (!response.body) return;
        const reader = response.body.getReader();
        return new ReadableStream({
            start (controller) {
                return pump();
                function pump() {
                    return reader.read().then(({ done: done, value: value })=>{
                        // When no more data needs to be consumed, close the stream
                        if (done) {
                            controller.close();
                            return;
                        }
                        // Enqueue the next data chunk into our target stream
                        controller.enqueue(value);
                        return pump();
                    });
                }
            }
        });
    }).then((stream)=>new Response(stream)).then((response)=>response.blob()).then((blob)=>URL.createObjectURL(blob)).then((url)=>{
        setBlobUrlCallback(url);
    }).catch((err)=>console.error(err));
};
var // Ideally, we'd wrap the above function in a self contained function that can
// just be called to get the blob url, but donin
// the below caused React to re-render some elements all the time and thus blow up.
// If someone would like to have a go at getting this to work that would be great!
// const fetchResource = (path:string, ctx) =>{
//   const [blobUrl, setBlobUrl] = useState("")
//   if (path === undefined || path === "") {
//     setBlobUrl("")
//     return
//   };
//   useEffect.call(this, () => {
//     fetchBlob(path, setBlobUrl)
//   }, [path])
//   return blobUrl
// }
$d032b089425ea600$export$2e2bcd8739ae039 = $d032b089425ea600$var$fetchBlob;

});


parcelRegister("cQAM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4acd251f493c96a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $5pIma = parcelRequire("5pIma");

var $2ywbu = parcelRequire("2ywbu");
const $e4acd251f493c96a$var$HelpButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mt-auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
            noPaddingY: !props.asButton,
            noPaddingX: !props.asButton,
            variant: "ch-gray-alt",
            baseTextColour: props.asButton ? "text-ch-gray-500" : null,
            hoverTextColour: props.asButton ? "hover:text-white" : null,
            className: props.asButton ? "hover:bg-ch-blue-700 rounded-md" : null,
            action: props.action,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5pIma.default), {
                    className: "w-5 h-5 mr-2",
                    title: t("shared:helpGuide")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("shared:helpGuide")
                })
            ]
        })
    });
};
var $e4acd251f493c96a$export$2e2bcd8739ae039 = $e4acd251f493c96a$var$HelpButton;

});
parcelRegister("2ywbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a99f53e0e56a116$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $jF0Xa = parcelRequire("jF0Xa");
const $3a99f53e0e56a116$var$ButtonLink = ({ noHover: noHover, className: className, href: href, action: action, variant: variant, children: children, ...props })=>{
    if (!variant) variant = (0, $jF0Xa.StyleVariants).GRAY;
    const baseTextColour = props.baseTextColour || `text-${variant}-500`;
    const hoverTextColour = props.hoverTextColour || `hover:text-${variant}-600`;
    const defaultClasses = [
        baseTextColour,
        props.noPaddingX ? "" : "px-4",
        props.noPaddingY ? "" : "py-2",
        noHover ? "cursor-default" : hoverTextColour,
        "flex",
        "items-center"
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    if (href) {
        if (href.toLowerCase().startsWith("http")) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noreferrer",
            className: allClasses,
            children: children
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Link), {
            to: href,
            className: allClasses,
            children: children
        });
    }
    if (action) return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        onClick: action,
        className: allClasses,
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "submit",
        className: allClasses,
        children: children
    });
};
var $3a99f53e0e56a116$export$2e2bcd8739ae039 = $3a99f53e0e56a116$var$ButtonLink;

});



parcelRegister("4Z6GL", function(module, exports) {

$parcel$export(module.exports, "fetchMeetingAction", () => $74cb13ca39720423$export$4bc95979a8385137);
$parcel$export(module.exports, "startMeetingAction", () => $74cb13ca39720423$export$3551f7434d913241);
$parcel$export(module.exports, "createMeetingAction", () => $74cb13ca39720423$export$85228cac0503ef4f);
$parcel$export(module.exports, "updateMeetingAction", () => $74cb13ca39720423$export$d2f954338cfd1109);
$parcel$export(module.exports, "endMeetingAction", () => $74cb13ca39720423$export$c4d32ea41a62c3c6);
$parcel$export(module.exports, "cancelMeetingAction", () => $74cb13ca39720423$export$f20794c862913a55);

var $32kQ2 = parcelRequire("32kQ2");
const $74cb13ca39720423$export$4bc95979a8385137 = (meetingId)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_PENDING,
        payload: meetingId
    };
};
const $74cb13ca39720423$export$3551f7434d913241 = (meetingId)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).START_MEETING_ASYNC_PENDING,
        payload: meetingId
    };
};
const $74cb13ca39720423$export$85228cac0503ef4f = (meetingData)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).CREATE_MEETING_ASYNC_PENDING,
        payload: meetingData
    };
};
const $74cb13ca39720423$export$d2f954338cfd1109 = (meetingId, meetingData)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_PENDING,
        payload: {
            id: meetingId,
            meeting: meetingData
        }
    };
};
const $74cb13ca39720423$export$c4d32ea41a62c3c6 = (meetingId)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).END_MEETING_ASYNC_PENDING,
        payload: meetingId
    };
};
const $74cb13ca39720423$export$f20794c862913a55 = (meetingId)=>{
    return {
        type: (0, $32kQ2.MeetingActionTypes).CANCEL_MEETING_ASYNC_PENDING,
        payload: meetingId
    };
};

});
parcelRegister("32kQ2", function(module, exports) {

$parcel$export(module.exports, "MeetingStatuses", () => $41c16f30864f58c2$export$6f70260822891da6);
$parcel$export(module.exports, "MeetingRoles", () => $41c16f30864f58c2$export$4425252c6cac294e);
$parcel$export(module.exports, "MeetingActionTypes", () => $41c16f30864f58c2$export$4f0de1bf6ce5d739);
$parcel$export(module.exports, "MeetingCablePrefix", () => $41c16f30864f58c2$export$4fabec543e5de036);
$parcel$export(module.exports, "MeetingChannelName", () => $41c16f30864f58c2$export$f43680a148a80798);
$parcel$export(module.exports, "MeetingCableActionTypes", () => $41c16f30864f58c2$export$5b2f89172a5cb798);
var $41c16f30864f58c2$export$6f70260822891da6 = /*#__PURE__*/ function(MeetingStatuses) {
    MeetingStatuses["Scheduled"] = "scheduled";
    MeetingStatuses["InProgress"] = "in_progress";
    MeetingStatuses["Ended"] = "ended";
    MeetingStatuses["Cancelled"] = "cancelled";
    return MeetingStatuses;
}({});
var $41c16f30864f58c2$export$4425252c6cac294e = /*#__PURE__*/ function(MeetingRoles) {
    MeetingRoles["Coordinator"] = "coordinator";
    MeetingRoles["Invited"] = "invited";
    return MeetingRoles;
}({});
var $41c16f30864f58c2$export$4f0de1bf6ce5d739 = /*#__PURE__*/ function(MeetingActionTypes) {
    MeetingActionTypes["FETCH_MEETING_ASYNC_PENDING"] = "@@meeting/FETCH_MEETING_ASYNC_PENDING";
    MeetingActionTypes["FETCH_MEETING_ASYNC_SUCCESS"] = "@@meeting/FETCH_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["FETCH_MEETING_ASYNC_ERROR"] = "@@meeting/FETCH_MEETING_ASYNC_ERROR";
    MeetingActionTypes["START_MEETING_ASYNC_PENDING"] = "@@meeting/START_MEETING_ASYNC_PENDING";
    MeetingActionTypes["START_MEETING_ASYNC_SUCCESS"] = "@@meeting/START_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["START_MEETING_ASYNC_ERROR"] = "@@meeting/START_MEETING_ASYNC_ERROR";
    MeetingActionTypes["CREATE_MEETING_ASYNC_PENDING"] = "@@meeting/CREATE_MEETING_ASYNC_PENDING";
    MeetingActionTypes["CREATE_MEETING_ASYNC_SUCCESS"] = "@@meeting/CREATE_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["CREATE_MEETING_ASYNC_ERROR"] = "@@meeting/CREATE_MEETING_ASYNC_ERROR";
    MeetingActionTypes["UPDATE_MEETING_ASYNC_PENDING"] = "@@meeting/UPDATE_MEETING_ASYNC_PENDING";
    MeetingActionTypes["UPDATE_MEETING_ASYNC_SUCCESS"] = "@@meeting/UPDATE_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["UPDATE_MEETING_ASYNC_ERROR"] = "@@meeting/UPDATE_MEETING_ASYNC_ERROR";
    MeetingActionTypes["END_MEETING_ASYNC_PENDING"] = "@@meeting/END_MEETING_ASYNC_PENDING";
    MeetingActionTypes["END_MEETING_ASYNC_SUCCESS"] = "@@meeting/END_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["END_MEETING_ASYNC_ERROR"] = "@@meeting/END_MEETING_ASYNC_ERROR";
    MeetingActionTypes["CANCEL_MEETING_ASYNC_PENDING"] = "@@meeting/CANCEL_MEETING_ASYNC_PENDING";
    MeetingActionTypes["CANCEL_MEETING_ASYNC_SUCCESS"] = "@@meeting/CANCEL_MEETING_ASYNC_SUCCESS";
    MeetingActionTypes["CANCEL_MEETING_ASYNC_ERROR"] = "@@meeting/CANCEL_MEETING_ASYNC_ERROR";
    return MeetingActionTypes;
}({});
const $41c16f30864f58c2$export$4fabec543e5de036 = "@@meetingCable/";
const $41c16f30864f58c2$export$f43680a148a80798 = "MeetingChannel";
var $41c16f30864f58c2$export$5b2f89172a5cb798 = /*#__PURE__*/ function(MeetingCableActionTypes) {
    MeetingCableActionTypes["MEETING_CASES_CHANGED"] = "@@meetingCable/MEETING_CASES_CHANGED";
    MeetingCableActionTypes["MEETING_USERS_CHANGED"] = "@@meetingCable/MEETING_USERS_CHANGED";
    return MeetingCableActionTypes;
}({});

});


parcelRegister("rDKvs", function(module, exports) {

$parcel$export(module.exports, "fetchLiveMeetingConfigAsync", () => $4b0dedba5aafa1d1$export$cd9d492d70d375e7);
$parcel$export(module.exports, "toggleSplitScreenAction", () => $4b0dedba5aafa1d1$export$2fb1889c8b003b1c);
$parcel$export(module.exports, "changeYourViewTabAction", () => $4b0dedba5aafa1d1$export$996523b8781db674);
$parcel$export(module.exports, "changeUsersViewTabAction", () => $4b0dedba5aafa1d1$export$64c7ccae00a0d862);
$parcel$export(module.exports, "selectMeetingCaseAction", () => $4b0dedba5aafa1d1$export$a5133da29d58dcab);
$parcel$export(module.exports, "toggleIsOnlineAction", () => $4b0dedba5aafa1d1$export$e467b7fba224477c);
$parcel$export(module.exports, "toggleIsPresentAction", () => $4b0dedba5aafa1d1$export$41f7e3a2b6f0c337);
$parcel$export(module.exports, "toggleIsSharingAudioAction", () => $4b0dedba5aafa1d1$export$1979474deaf39410);
$parcel$export(module.exports, "toggleIsSharingVideoAction", () => $4b0dedba5aafa1d1$export$7e5e23338ba30462);
$parcel$export(module.exports, "toggleIsSharingScreenAction", () => $4b0dedba5aafa1d1$export$3d52dc30a1263042);
$parcel$export(module.exports, "updateSharedViewHoveredAssetAction", () => $4b0dedba5aafa1d1$export$4f46a2fc8acb1724);
$parcel$export(module.exports, "updateSharedViewSelectedAssetAction", () => $4b0dedba5aafa1d1$export$6a5c0c1af858f935);
$parcel$export(module.exports, "updateYourViewSelectedAssetAction", () => $4b0dedba5aafa1d1$export$f10bcf2bdb55eae6);
$parcel$export(module.exports, "updateSharedImageZoomStateAction", () => $4b0dedba5aafa1d1$export$ccedb682d2595e05);
$parcel$export(module.exports, "updateSharedPdfStateAction", () => $4b0dedba5aafa1d1$export$83700d31f8ab7df1);
$parcel$export(module.exports, "presenterTransferAction", () => $4b0dedba5aafa1d1$export$4a9642d4119d1c09);
$parcel$export(module.exports, "scribeTransferAction", () => $4b0dedba5aafa1d1$export$75c464697e4531d2);
$parcel$export(module.exports, "updateRecommendationAction", () => $4b0dedba5aafa1d1$export$23adc935d427ff9d);
$parcel$export(module.exports, "deferRecommendationAction", () => $4b0dedba5aafa1d1$export$79de6bd3ada31212);
$parcel$export(module.exports, "deferCurrentCaseAction", () => $4b0dedba5aafa1d1$export$4a4fa111054ffaa8);
$parcel$export(module.exports, "shareRecommendationAction", () => $4b0dedba5aafa1d1$export$707d57f9528d5af4);
$parcel$export(module.exports, "requestApprovalAction", () => $4b0dedba5aafa1d1$export$cd2850d7e01348ca);
$parcel$export(module.exports, "saveRecommendationAction", () => $4b0dedba5aafa1d1$export$af335a69f5abd900);
$parcel$export(module.exports, "cancelRecommendationAction", () => $4b0dedba5aafa1d1$export$2827c52a8b2421a7);
$parcel$export(module.exports, "giveConsentAction", () => $4b0dedba5aafa1d1$export$cd41e160590d7eda);
$parcel$export(module.exports, "giveConsentOnBehalfAction", () => $4b0dedba5aafa1d1$export$284f085d95c01da4);

var $j0qQC = parcelRequire("j0qQC");
const $4b0dedba5aafa1d1$export$cd9d492d70d375e7 = (meetingId)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.FETCH_LIVE_MEETING_CONFIG_ASYNC_PENDING,
        payload: meetingId
    };
};
const $4b0dedba5aafa1d1$export$2fb1889c8b003b1c = (isSplitScreen)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.TOGGLE_SPLIT_SCREEN,
        payload: isSplitScreen
    };
};
const $4b0dedba5aafa1d1$export$20311a8c94e5b977 = (isYourViewAssetListOpen)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.TOGGLE_YOUR_VIEW_ASSET_LIST_OPEN,
        payload: isYourViewAssetListOpen
    };
};
const $4b0dedba5aafa1d1$export$996523b8781db674 = (selectedTab)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.CHANGE_YOUR_VIEW_TAB,
        payload: selectedTab
    };
};
const $4b0dedba5aafa1d1$export$64c7ccae00a0d862 = (selectedTab)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.CHANGE_USERS_VIEW_TAB,
        payload: selectedTab
    };
};
const $4b0dedba5aafa1d1$export$a5133da29d58dcab = (meetingCaseId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.SELECT_MEETING_CASE,
        payload: meetingCaseId,
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$e467b7fba224477c = (userId, isOnline)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TOGGLE_IS_ONLINE,
        payload: {
            userId: userId,
            isOnline: isOnline
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$41f7e3a2b6f0c337 = (userId, isPresent)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TOGGLE_IS_PRESENT,
        payload: {
            userId: userId,
            isPresent: isPresent
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$1979474deaf39410 = (userId, isSharingAudio)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TOGGLE_IS_SHARING_AUDIO,
        payload: {
            userId: userId,
            isSharingAudio: isSharingAudio
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$7e5e23338ba30462 = (userId, isSharingVideo)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TOGGLE_IS_SHARING_VIDEO,
        payload: {
            userId: userId,
            isSharingVideo: isSharingVideo
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$3d52dc30a1263042 = (userId, isSharingScreen)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TOGGLE_IS_SHARING_SCREEN,
        payload: {
            userId: userId,
            isSharingScreen: isSharingScreen
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$4f46a2fc8acb1724 = (assetId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.UPDATE_SHARED_VIEW_HOVERED_ASSET,
        payload: {
            assetId: assetId
        },
        meta: {
            isOptimistic: false
        }
    };
};
const $4b0dedba5aafa1d1$export$6a5c0c1af858f935 = (assetId, assetTypeFilters)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.UPDATE_SHARED_VIEW_SELECTED_ASSET,
        payload: {
            assetId: assetId,
            assetTypeFilters: assetTypeFilters
        },
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$f10bcf2bdb55eae6 = (assetId)=>{
    return {
        type: $j0qQC.LiveMeetingActionTypes.UPDATE_YOUR_VIEW_SELECTED_ASSET,
        payload: assetId
    };
};
const $4b0dedba5aafa1d1$export$ccedb682d2595e05 = (shareImageZoomState)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.UPDATE_SHARED_IMAGE_ZOOM_STATE,
        payload: shareImageZoomState,
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$83700d31f8ab7df1 = (sharedPdfState)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.UPDATE_SHARED_PDF_STATE,
        payload: sharedPdfState,
        meta: {
            isOptimistic: true
        }
    };
};
const $4b0dedba5aafa1d1$export$4a9642d4119d1c09 = (userId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TRANSFER_PRESENTER,
        payload: userId
    };
};
const $4b0dedba5aafa1d1$export$75c464697e4531d2 = (userId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.TRANSFER_SCRIBE,
        payload: userId
    };
};
const $4b0dedba5aafa1d1$export$23adc935d427ff9d = (text, caseId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.UPDATE_RECOMMENDATION,
        payload: {
            text: text,
            caseId: caseId
        }
    };
};
const $4b0dedba5aafa1d1$export$79de6bd3ada31212 = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.DEFER_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$4a4fa111054ffaa8 = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.SAVE_DEFER_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$707d57f9528d5af4 = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.SHARE_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$cd2850d7e01348ca = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.REQUEST_APPROVAL_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$af335a69f5abd900 = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.SAVE_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$2827c52a8b2421a7 = ()=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.CANCEL_RECOMMENDATION
    };
};
const $4b0dedba5aafa1d1$export$cd41e160590d7eda = (response, comment)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.ADD_CONSENT,
        payload: {
            response: response,
            comment: comment
        }
    };
};
const $4b0dedba5aafa1d1$export$284f085d95c01da4 = (response, userId)=>{
    return {
        type: $j0qQC.LiveMeetingCableActionTypes.ADD_CONSENT_ON_BEHALF,
        payload: {
            response: response,
            userId: userId
        }
    };
};

});

parcelRegister("kbfou", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e846f99cb87ccdc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jdkTb = parcelRequire("jdkTb");

var $oTX0J = parcelRequire("oTX0J");

var $kW0Hq = parcelRequire("kW0Hq");
const $5e846f99cb87ccdc$var$LiveMeetingUserContainer = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex space-between md:grid md:grid-cols-12 gap-3 relative",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "md:col-span-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $oTX0J.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 md:col-span-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kW0Hq.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden sm:block md:col-span-1 xl:static absolute right-0 flex justify-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdkTb.default), {})
            })
        ]
    });
};
var $5e846f99cb87ccdc$export$2e2bcd8739ae039 = $5e846f99cb87ccdc$var$LiveMeetingUserContainer;

});
parcelRegister("jdkTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61ae99d8f426a99$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $irSmE = parcelRequire("irSmE");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $crcfN = parcelRequire("crcfN");

var $1Fz7P = parcelRequire("1Fz7P");

var $6lvMC = parcelRequire("6lvMC");

var $dyeCj = parcelRequire("dyeCj");

var $kF2ec = parcelRequire("kF2ec");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");
const $a61ae99d8f426a99$var$LiveMeetingUserAudioSettings = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    const [audioSettingsModalIsOpen, setAudioSettingsModalIsOpen] = (0, $acw62.useState)(false);
    const [blurEnabled, setBlurEnabled] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!publisher) return;
        if (blurEnabled) {
            const videoFilter = {
                type: "backgroundBlur",
                blurStrength: "low"
            };
            publisher.applyVideoFilter(videoFilter);
        } else publisher.clearVideoFilter();
    }, [
        blurEnabled
    ]);
    const openAudioSettingsModal = ()=>{
        setAudioSettingsModalIsOpen(true);
    };
    const closeAudioSettingsModal = ()=>{
        setAudioSettingsModalIsOpen(false);
    };
    if (!user.config?.isOnline) return null;
    const renderToggleBlur = ()=>{
        if (!OT.hasMediaProcessorSupport()) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: t("blurNotAvailable")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            onClick: ()=>setBlurEnabled(!blurEnabled),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    blur: blurEnabled
                },
                onSubmit: null,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "flex space-x-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kF2ec.default), {
                            value: "blur",
                            name: "blur",
                            isSelected: blurEnabled,
                            className: "mb-2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                            name: "blur",
                            children: t("blurEnabled")
                        })
                    ]
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "#",
                onClick: openAudioSettingsModal,
                className: "text-ch-gray-600 hover:text-white",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irSmE.default), {
                    className: "fill-current w-4 h-4",
                    title: t("liveMeeting:audioSettings")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: audioSettingsModalIsOpen,
                onRequestClose: closeAudioSettingsModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeAudioSettingsModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg text-ch-blue-600 mb-1",
                            children: t("liveMeeting:audioSettings")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mb-2",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $crcfN.default), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg text-ch-blue-600 mb-1",
                            children: t("liveMeeting:videoSettings")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Fz7P.default), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-2",
                            children: renderToggleBlur()
                        })
                    ]
                })
            })
        ]
    });
};
var $a61ae99d8f426a99$export$2e2bcd8739ae039 = $a61ae99d8f426a99$var$LiveMeetingUserAudioSettings;

});
parcelRegister("crcfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549a9728d6d1b9c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $j6YIz = parcelRequire("j6YIz");

var $kGUIk = parcelRequire("kGUIk");

var $dyeCj = parcelRequire("dyeCj");
const $a549a9728d6d1b9c$var$LiveMeetingUserAudioDeviceList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const audioDeviceIds = (0, $iD0SF.useSelector)((0, $dyeCj.getAllWebRTCAudioDeviceIds));
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    const dispatch = (0, $2OPjR.useDispatch)();
    const getAudioDevices = ()=>dispatch((0, $kGUIk.getAudioDevicesAction)());
    const getAudioSource = (publisher)=>dispatch((0, $kGUIk.getAudioSourceAction)(publisher));
    (0, $acw62.useEffect)(()=>{
        getAudioDevices();
        getAudioSource(publisher);
    }, []);
    const renderList = ()=>{
        if (!audioDeviceIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "No audio devices"
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            className: "p-2 border-ch-gray-300 border",
            children: audioDeviceIds.map((deviceId)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j6YIz.default), {
                    deviceId: deviceId
                }, deviceId);
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "mb-2",
                children: t("liveMeeting:chooseAudioInput")
            }),
            renderList()
        ]
    });
};
var $a549a9728d6d1b9c$export$2e2bcd8739ae039 = $a549a9728d6d1b9c$var$LiveMeetingUserAudioDeviceList;

});
parcelRegister("j6YIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1652bfd28223ac8f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $h8MLf = parcelRequire("h8MLf");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $kGUIk = parcelRequire("kGUIk");

var $dyeCj = parcelRequire("dyeCj");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
const $1652bfd28223ac8f$var$LiveMeetingUserAudioDeviceListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickSelect = (publisher, deviceId)=>dispatch((0, $kGUIk.setAudioSourceAction)(publisher, deviceId));
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    const selectedAudioDeviceId = (0, $iD0SF.useSelector)((0, $dyeCj.getSelectedAudioDeviceId));
    const audioDevice = (0, $iD0SF.useSelector)((state)=>(0, $dyeCj.getWebRTCAudioDeviceById)(state, props));
    const isSelected = audioDevice.deviceId == selectedAudioDeviceId;
    const renderSelectButton = ()=>{
        if (isSelected) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-sm font-semibold uppercase text-ch-blue-500",
            children: t("shared:selected")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>onClickSelect(publisher, audioDevice.deviceId),
            className: "self-center self-end",
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            isChunky: true,
            children: t("shared:select")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-1", "mb-2", "rounded-md", "p-4", "justify-between", "border-2", "items-center", {
            "border-ch-gray-300": !isSelected,
            "border-ch-blue-500": isSelected,
            "bg-ch-gray-300": !isSelected,
            "bg-white": isSelected
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-center p-2 text-ch-gray-600 bg-white border border-ch-gray-400 rounded-full w-12 h-12 text-ch-purple-500 mr-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8MLf.default), {
                    className: "fill-current w-6 h-6",
                    title: audioDevice.label
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 mr-4",
                children: audioDevice.label
            }),
            renderSelectButton()
        ]
    });
};
var $1652bfd28223ac8f$export$2e2bcd8739ae039 = $1652bfd28223ac8f$var$LiveMeetingUserAudioDeviceListItem;

});
parcelRegister("kGUIk", function(module, exports) {

$parcel$export(module.exports, "connectToWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$993adf9b475c6512);
$parcel$export(module.exports, "disconnectFromWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$6b0c0d71727b05d7);
$parcel$export(module.exports, "updateWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$bf56636cbc6f3acf);
$parcel$export(module.exports, "publishToWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$6a4d34f65f547e8a);
$parcel$export(module.exports, "publishScreenToWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$b66dfc8ed64762a);
$parcel$export(module.exports, "stopPublishScreenToWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$cb2ca16611ad4699);
$parcel$export(module.exports, "unpublishFromWebRTCSessionAction", () => $ddf9a7c37ca2ba8c$export$cb2f41aa58ce63a5);
$parcel$export(module.exports, "updateWebRTCPublisherAction", () => $ddf9a7c37ca2ba8c$export$fec252e2ee422d43);
$parcel$export(module.exports, "subscribeToWebRTCStreamAction", () => $ddf9a7c37ca2ba8c$export$567b3690f1f94fb7);
$parcel$export(module.exports, "toggleWebRTCPublishAudioAction", () => $ddf9a7c37ca2ba8c$export$6c1c4aa4254ba85f);
$parcel$export(module.exports, "toggleWebRTCPublishVideoAction", () => $ddf9a7c37ca2ba8c$export$61d167703109519b);
$parcel$export(module.exports, "toggleWebRTCScreenShareIsOnAction", () => $ddf9a7c37ca2ba8c$export$417267496408fcd9);
$parcel$export(module.exports, "webRTCScreenShareCurrentAction", () => $ddf9a7c37ca2ba8c$export$6552b3be5774ca1c);
$parcel$export(module.exports, "addWebRTCStreamAction", () => $ddf9a7c37ca2ba8c$export$1b145a03a04c1333);
$parcel$export(module.exports, "removeWebRTCStreamAction", () => $ddf9a7c37ca2ba8c$export$cf9602c84c52670c);
$parcel$export(module.exports, "updateWebRTCStreamAction", () => $ddf9a7c37ca2ba8c$export$ca6b46eecfdade43);
$parcel$export(module.exports, "updateWebRTCScreenStreamAction", () => $ddf9a7c37ca2ba8c$export$2b86b986f76b26ce);
$parcel$export(module.exports, "getAudioDevicesAction", () => $ddf9a7c37ca2ba8c$export$6735baa85e5856ee);
$parcel$export(module.exports, "getAudioSourceAction", () => $ddf9a7c37ca2ba8c$export$44c82261d252aa2e);
$parcel$export(module.exports, "setAudioSourceAction", () => $ddf9a7c37ca2ba8c$export$93a611306f5629db);
$parcel$export(module.exports, "cycleVideoSourceAction", () => $ddf9a7c37ca2ba8c$export$d1e0ed20a5df5aa9);

var $5ng6u = parcelRequire("5ng6u");
const $ddf9a7c37ca2ba8c$export$993adf9b475c6512 = (apiKey, sessionId, meetingToken, eventHandlers)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).CONNECT_TO_WEB_RTC_SESSION_ASYNC_PENDING,
        payload: {
            apiKey: apiKey,
            sessionId: sessionId,
            meetingToken: meetingToken,
            eventHandlers: eventHandlers
        }
    };
};
const $ddf9a7c37ca2ba8c$export$6b0c0d71727b05d7 = (session)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_PENDING,
        payload: {
            session: session
        }
    };
};
const $ddf9a7c37ca2ba8c$export$bf56636cbc6f3acf = (session)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SESSION,
        payload: {
            session: session
        }
    };
};
const $ddf9a7c37ca2ba8c$export$6a4d34f65f547e8a = (session, containerRef, options, eventHandlers)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_PENDING,
        payload: {
            session: session,
            containerRef: containerRef,
            options: options,
            eventHandlers: eventHandlers
        }
    };
};
const $ddf9a7c37ca2ba8c$export$b66dfc8ed64762a = (session, containerRef, options, eventHandlers)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING,
        payload: {
            session: session,
            containerRef: containerRef,
            options: options,
            eventHandlers: eventHandlers
        }
    };
};
const $ddf9a7c37ca2ba8c$export$cb2ca16611ad4699 = (session, publisher)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING,
        payload: {
            session: session,
            publisher: publisher
        }
    };
};
const $ddf9a7c37ca2ba8c$export$cb2f41aa58ce63a5 = (session, publisher)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).UNPUBLISH_FROM_WEB_RTC_SESSION_PENDING,
        payload: {
            session: session,
            publisher: publisher
        }
    };
};
const $ddf9a7c37ca2ba8c$export$fec252e2ee422d43 = (publisher)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_PUBLISHER,
        payload: {
            publisher: publisher
        }
    };
};
const $ddf9a7c37ca2ba8c$export$567b3690f1f94fb7 = (session, stream, containerRef, options)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_PENDING,
        payload: {
            session: session,
            stream: stream,
            containerRef: containerRef,
            options: options
        }
    };
};
const $ddf9a7c37ca2ba8c$export$6c1c4aa4254ba85f = (userId, publisher, isSharingAudio)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_AUDIO_PENDING,
        payload: {
            userId: userId,
            publisher: publisher,
            isSharingAudio: isSharingAudio
        }
    };
};
const $ddf9a7c37ca2ba8c$export$61d167703109519b = (userId, publisher, isSharingVideo)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_VIDEO_PENDING,
        payload: {
            userId: userId,
            publisher: publisher,
            isSharingVideo: isSharingVideo
        }
    };
};
const $ddf9a7c37ca2ba8c$export$417267496408fcd9 = (isSharingScreen)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON,
        payload: {
            isSharingScreen: isSharingScreen
        }
    };
};
const $ddf9a7c37ca2ba8c$export$6552b3be5774ca1c = ()=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON,
        payload: {
            isSharingScreen: true,
            preferCurrentTab: true
        }
    };
};
const $ddf9a7c37ca2ba8c$export$1b145a03a04c1333 = (userId, stream)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).ADD_WEB_RTC_STREAM,
        payload: {
            userId: userId,
            stream: stream
        }
    };
};
const $ddf9a7c37ca2ba8c$export$cf9602c84c52670c = (userId)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).REMOVE_WEB_RTC_STREAM,
        payload: {
            userId: userId
        }
    };
};
const $ddf9a7c37ca2ba8c$export$ca6b46eecfdade43 = (userId, stream)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_STREAM,
        payload: {
            userId: userId,
            stream: stream
        }
    };
};
const $ddf9a7c37ca2ba8c$export$2b86b986f76b26ce = (stream)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SCREEN_STREAM,
        payload: stream
    };
};
const $ddf9a7c37ca2ba8c$export$6735baa85e5856ee = ()=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_PENDING
    };
};
const $ddf9a7c37ca2ba8c$export$44c82261d252aa2e = (publisher)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_SOURCE_PENDING,
        payload: {
            publisher: publisher
        }
    };
};
const $ddf9a7c37ca2ba8c$export$93a611306f5629db = (publisher, deviceId)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).SET_WEB_RTC_AUDIO_SOURCE_PENDING,
        payload: {
            deviceId: deviceId,
            publisher: publisher
        }
    };
};
const $ddf9a7c37ca2ba8c$export$d1e0ed20a5df5aa9 = (publisher)=>{
    return {
        type: (0, $5ng6u.WebRTCActionTypes).CYCLE_WEB_RTC_VIDEO_SOURCE_PENDING,
        payload: {
            publisher: publisher
        }
    };
};

});
parcelRegister("5ng6u", function(module, exports) {

$parcel$export(module.exports, "WebRTCActionTypes", () => $24429a6efbccbd3a$export$f5c7d05d0e2b8473);
var $24429a6efbccbd3a$export$f5c7d05d0e2b8473 = /*#__PURE__*/ function(WebRTCActionTypes) {
    WebRTCActionTypes["CONNECT_TO_WEB_RTC_SESSION_ASYNC_PENDING"] = "@@webRTC/CONNECT_TO_WEB_RTC_SESSION_ASYNC_PENDING";
    WebRTCActionTypes["CONNECT_TO_WEB_RTC_SESSION_ASYNC_SUCCESS"] = "@@webRTC/CONNECT_TO_WEB_RTC_SESSION_ASYNC_SUCCESS";
    WebRTCActionTypes["CONNECT_TO_WEB_RTC_SESSION_ASYNC_ERROR"] = "@@webRTC/CONNECT_TO_WEB_RTC_SESSION_ASYNC_ERROR";
    WebRTCActionTypes["DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_PENDING"] = "@@webRTC/DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_PENDING";
    WebRTCActionTypes["DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_SUCCESS"] = "@@webRTC/DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_SUCCESS";
    WebRTCActionTypes["DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_ERROR"] = "@@webRTC/DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_ERROR";
    WebRTCActionTypes["UPDATE_WEB_RTC_SESSION"] = "@@webRTC/UPDATE_WEB_RTC_SESSION";
    WebRTCActionTypes["PUBLISH_TO_WEB_RTC_SESSION_ASYNC_PENDING"] = "@@webRTC/PUBLISH_TO_WEB_RTC_SESSION_ASYNC_PENDING";
    WebRTCActionTypes["PUBLISH_TO_WEB_RTC_SESSION_ASYNC_SUCCESS"] = "@@webRTC/PUBLISH_TO_WEB_RTC_SESSION_ASYNC_SUCCESS";
    WebRTCActionTypes["PUBLISH_TO_WEB_RTC_SESSION_ASYNC_ERROR"] = "@@webRTC/PUBLISH_TO_WEB_RTC_SESSION_ASYNC_ERROR";
    WebRTCActionTypes["PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING"] = "@@webRTC/PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING";
    WebRTCActionTypes["PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS"] = "@@webRTC/PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS";
    WebRTCActionTypes["PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR"] = "@@webRTC/PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR";
    WebRTCActionTypes["STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING"] = "@@webRTC/STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING";
    WebRTCActionTypes["STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS"] = "@@webRTC/STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS";
    WebRTCActionTypes["STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR"] = "@@webRTC/STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR";
    WebRTCActionTypes["UNPUBLISH_FROM_WEB_RTC_SESSION_PENDING"] = "@@webRTC/UNPUBLISH_FROM_WEB_RTC_SESSION_PENDING";
    WebRTCActionTypes["UNPUBLISH_FROM_WEB_RTC_SESSION_SUCCESS"] = "@@webRTC/UNPUBLISH_FROM_WEB_RTC_SESSION_SUCCESS";
    WebRTCActionTypes["UNPUBLISH_FROM_WEB_RTC_SESSION_ERROR"] = "@@webRTC/UNPUBLISH_FROM_WEB_RTC_SESSION_ERROR";
    WebRTCActionTypes["UPDATE_WEB_RTC_PUBLISHER"] = "@@webRTC/UPDATE_WEB_RTC_PUBLISHER";
    WebRTCActionTypes["SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_PENDING"] = "@@webRTC/SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_PENDING";
    WebRTCActionTypes["SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_SUCCESS"] = "@@webRTC/SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_SUCCESS";
    WebRTCActionTypes["SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_ERROR"] = "@@webRTC/SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_ERROR";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_AUDIO_PENDING"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_AUDIO_PENDING";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_AUDIO_SUCCESS"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_AUDIO_SUCCESS";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_AUDIO_ERROR"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_AUDIO_ERROR";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_VIDEO_PENDING"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_VIDEO_PENDING";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_VIDEO_SUCCESS"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_VIDEO_SUCCESS";
    WebRTCActionTypes["TOGGLE_WEB_RTC_PUBLISHER_VIDEO_ERROR"] = "@@webRTC/TOGGLE_WEB_RTC_PUBLISHER_VIDEO_ERROR";
    WebRTCActionTypes["TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON"] = "@@webRTC/TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON";
    WebRTCActionTypes["ADD_WEB_RTC_STREAM"] = "@@webRTC/ADD_WEB_RTC_STREAM";
    WebRTCActionTypes["REMOVE_WEB_RTC_STREAM"] = "@@webRTC/REMOVE_WEB_RTC_STREAM";
    WebRTCActionTypes["UPDATE_WEB_RTC_STREAM"] = "@@webRTC/UPDATE_WEB_RTC_STREAM";
    WebRTCActionTypes["UPDATE_WEB_RTC_SCREEN_STREAM"] = "@@webRTC/UPDATE_WEB_RTC_SCREEN_STREAM";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_DEVICES_PENDING"] = "@@webRTC/GET_WEB_RTC_AUDIO_DEVICES_PENDING";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_DEVICES_SUCCESS"] = "@@webRTC/GET_WEB_RTC_AUDIO_DEVICES_SUCCESS";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_DEVICES_ERROR"] = "@@webRTC/GET_WEB_RTC_AUDIO_DEVICES_ERROR";
    WebRTCActionTypes["GET_WEB_RTC_VIDEO_DEVICES_PENDING"] = "@@webRTC/GET_WEB_RTC_VIDEO_DEVICES_PENDING";
    WebRTCActionTypes["GET_WEB_RTC_VIDEO_DEVICES_SUCCESS"] = "@@webRTC/GET_WEB_RTC_VIDEO_DEVICES_SUCCESS";
    WebRTCActionTypes["GET_WEB_RTC_VIDEO_DEVICES_ERROR"] = "@@webRTC/GET_WEB_RTC_VIDEO_DEVICES_ERROR";
    WebRTCActionTypes["SET_WEB_RTC_AUDIO_SOURCE_PENDING"] = "@@webRTC/SET_WEB_RTC_AUDIO_SOURCE_PENDING";
    WebRTCActionTypes["SET_WEB_RTC_AUDIO_SOURCE_SUCCESS"] = "@@webRTC/SET_WEB_RTC_AUDIO_SOURCE_SUCCESS";
    WebRTCActionTypes["SET_WEB_RTC_AUDIO_SOURCE_ERROR"] = "@@webRTC/SET_WEB_RTC_AUDIO_SOURCE_ERROR";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_SOURCE_PENDING"] = "@@webRTC/GET_WEB_RTC_AUDIO_SOURCE_PENDING";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_SOURCE_SUCCESS"] = "@@webRTC/GET_WEB_RTC_AUDIO_SOURCE_SUCCESS";
    WebRTCActionTypes["GET_WEB_RTC_AUDIO_SOURCE_ERROR"] = "@@webRTC/GET_WEB_RTC_AUDIO_SOURCE_ERROR";
    WebRTCActionTypes["CYCLE_WEB_RTC_VIDEO_SOURCE_PENDING"] = "@@webRTC/CYCLE_WEB_RTC_VIDEO_SOURCE_PENDING";
    WebRTCActionTypes["CYCLE_WEB_RTC_VIDEO_SOURCE_SUCCESS"] = "@@webRTC/CYCLE_WEB_RTC_VIDEO_SOURCE_SUCCESS";
    WebRTCActionTypes["CYCLE_WEB_RTC_VIDEO_SOURCE_ERROR"] = "@@webRTC/CYCLE_WEB_RTC_VIDEO_SOURCE_ERROR";
    return WebRTCActionTypes;
}({});

});


parcelRegister("dyeCj", function(module, exports) {

$parcel$export(module.exports, "getWebRTCSession", () => $51c762abce3d0e93$export$42971b38f87dd7d8);
$parcel$export(module.exports, "getWebRTCPublisher", () => $51c762abce3d0e93$export$b9d5a4cb331ad256);
$parcel$export(module.exports, "getWebRTCErrors", () => $51c762abce3d0e93$export$139750f9d583746a);
$parcel$export(module.exports, "getWebRTCScreenPublisher", () => $51c762abce3d0e93$export$d2cde3e983ed4200);
$parcel$export(module.exports, "getWebRTCScreenShareIsOn", () => $51c762abce3d0e93$export$a73157cc15c5e6e6);
$parcel$export(module.exports, "getWebRTCScreenSharePreferCurrentTab", () => $51c762abce3d0e93$export$6399fb9382a1223a);
$parcel$export(module.exports, "getWebRTCScreenShareStream", () => $51c762abce3d0e93$export$a79f975c9632d83b);
$parcel$export(module.exports, "getWebRTCStreamByUserId", () => $51c762abce3d0e93$export$96117d6567a4850c);
$parcel$export(module.exports, "getAllWebRTCAudioDeviceIds", () => $51c762abce3d0e93$export$d429d96af06d6a79);
$parcel$export(module.exports, "getWebRTCAudioDeviceById", () => $51c762abce3d0e93$export$a17b1062c896d61d);
$parcel$export(module.exports, "getSelectedAudioDeviceId", () => $51c762abce3d0e93$export$758d1f0391819420);

var $6SpLG = parcelRequire("6SpLG");

var $6lvMC = parcelRequire("6lvMC");
const $51c762abce3d0e93$export$42971b38f87dd7d8 = (state)=>state.webRTC.session;
const $51c762abce3d0e93$export$b9d5a4cb331ad256 = (state)=>state.webRTC.publisher;
const $51c762abce3d0e93$export$139750f9d583746a = (state)=>state.webRTC.errors;
const $51c762abce3d0e93$export$d2cde3e983ed4200 = (state)=>state.webRTC.screenShare.publisher;
const $51c762abce3d0e93$export$a73157cc15c5e6e6 = (state)=>state.webRTC.screenShare.isOn;
const $51c762abce3d0e93$export$6399fb9382a1223a = (state)=>state.webRTC.screenShare.preferCurrentTab;
const $51c762abce3d0e93$export$a79f975c9632d83b = (state)=>state.webRTC.screenShare.stream;
const $51c762abce3d0e93$export$c63ce9136f7c3169 = (state)=>state.webRTC.streams.byUserId;
const $51c762abce3d0e93$export$96117d6567a4850c = (state, ownProps)=>state.webRTC.streams.byUserId[ownProps.userId];
const $51c762abce3d0e93$export$569cbf5a0ae5d514 = (state)=>state.webRTC.audioDevices.byId;
const $51c762abce3d0e93$export$d429d96af06d6a79 = (state)=>state.webRTC.audioDevices.allIds;
const $51c762abce3d0e93$export$a17b1062c896d61d = (state, ownProps)=>state.webRTC.audioDevices.byId[ownProps.deviceId];
const $51c762abce3d0e93$export$758d1f0391819420 = (state)=>state.webRTC.audioDevices.selectedId;
const $51c762abce3d0e93$export$2e113cdc3db6b380 = (0, $6SpLG.createSelector)((0, $6lvMC.getCurrentUser), $51c762abce3d0e93$export$c63ce9136f7c3169, (currentUser, allWebRTCStreamsByUserId)=>{
    if (!currentUser) return null;
    return allWebRTCStreamsByUserId[currentUser.id];
});

});



parcelRegister("1Fz7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c46abd019203fb9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $kGUIk = parcelRequire("kGUIk");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $dyeCj = parcelRequire("dyeCj");
const $9c46abd019203fb9$var$LiveMeetingUserVideoDeviceSelect = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickSwitchVideoInput = (publisher)=>dispatch((0, $kGUIk.cycleVideoSourceAction)(publisher));
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "mb-2",
                children: t("liveMeeting:chooseVideoInput")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-2 border-ch-gray-300 border",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mb-2",
                        children: t("liveMeeting:cycleVideoSource")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: ()=>onClickSwitchVideoInput(publisher),
                        className: "self-center self-end",
                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                        isChunky: true,
                        children: t("liveMeeting:switchCamera")
                    })
                ]
            })
        ]
    });
};
var $9c46abd019203fb9$export$2e2bcd8739ae039 = $9c46abd019203fb9$var$LiveMeetingUserVideoDeviceSelect;

});

parcelRegister("kF2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $2510b827bf9df2f2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $lHtgo = parcelRequire("lHtgo");

var $7YFi7 = parcelRequire("7YFi7");

var $8g1PZ = parcelRequire("8g1PZ");
const $2510b827bf9df2f2$var$RadioCheckbox = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mt-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex items-center justify-center cursor-pointer rounded border border-ch-blue-alt-300 hover:border-ch-blue-alt-400 w-5 h-5", props.className, {
                    "text-ch-gray-500": !props.value
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lHtgo.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-green-500 fill-current w-3 h-3", {
                        "hidden": !props.isSelected
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                    type: "radio",
                    name: props.name,
                    value: props.value
                })
            })
        ]
    });
};
var $2510b827bf9df2f2$export$2e2bcd8739ae039 = $2510b827bf9df2f2$var$RadioCheckbox;

});


parcelRegister("oTX0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c368fc62dbd873d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $80TYb = parcelRequire("80TYb");
var $3NuIO = parcelRequire("3NuIO");

var $6t04b = parcelRequire("6t04b");

var $6lvMC = parcelRequire("6lvMC");
const $4c368fc62dbd873d$var$LiveMeetingUserDetails = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "user"
    ]);
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const isScribeOrPresenter = ()=>{
        return user.config.isPresenter || user.config.isScribe;
    };
    const hasRoles = ()=>{
        return user.config.isCoordinator || isScribeOrPresenter();
    };
    const renderDivider = ()=>{
        if (!user.config.isCoordinator || !isScribeOrPresenter()) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "mx-1",
            children: "|"
        });
    };
    const renderCoordinator = ()=>{
        if (!user.config.isCoordinator) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "hidden sm:block",
            children: t("user:coordinator")
        });
    };
    const renderPresenter = ()=>{
        if (!user.config.isPresenter) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "mr-2 text-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80TYb.default), {
                className: "fill-current w-5 h-5",
                title: t("user:presenter")
            })
        });
    };
    const renderScribe = ()=>{
        if (!user.config.isScribe) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "mr-2 text-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3NuIO.default), {
                className: "fill-current w-5 h-5",
                title: t("user:scribe")
            })
        });
    };
    const renderRoles = ()=>{
        if (!hasRoles()) return;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center text-sm font-thin uppercase",
            children: [
                renderCoordinator(),
                renderDivider(),
                renderScribe(),
                renderPresenter()
            ]
        });
    };
    if (!user.config) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "hidden sm:block",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: user.firstName,
                    lastName: user.lastName
                })
            }),
            renderRoles()
        ]
    });
};
var $4c368fc62dbd873d$export$2e2bcd8739ae039 = $4c368fc62dbd873d$var$LiveMeetingUserDetails;

});
parcelRegister("6t04b", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda77aa45fe415ce$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $irdpp = parcelRequire("irdpp");

var $26LRi = parcelRequire("26LRi");
const $dda77aa45fe415ce$var$NameUser = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user",
        "team"
    ]);
    const renderTitle = ()=>{
        if (!props.title) return null;
        const title = t(`shared:${props.title}`);
        return `(${title})`;
    };
    const renderGender = ()=>{
        if (!props.gender) return null;
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.gender);
        return t(`shared:${translationKey}`);
    };
    const renderProfessionalTitle = ()=>{
        if (!props.professionalTitle) return null;
        const professionalTitleText = t(`shared:${props.professionalTitle}`);
        return ` - ${professionalTitleText}`;
    };
    const renderDisabled = ()=>{
        if (!props.disabled) return null;
        return `(${t("user:inactive")})`;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "uppercase",
                        children: props.lastName
                    }),
                    ", ",
                    props.firstName
                ]
            }),
            [
                renderTitle(),
                renderGender(),
                renderProfessionalTitle(),
                renderDisabled()
            ].filter((el)=>el != null).map((el, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        " ",
                        el
                    ]
                }, i)),
            props.label,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irdpp.PendingLabel), {
                isPending: props.isPending
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26LRi.GuestLabel), {
                isGuest: props.isGuest
            })
        ]
    });
};
var $dda77aa45fe415ce$export$2e2bcd8739ae039 = $dda77aa45fe415ce$var$NameUser;

});
parcelRegister("irdpp", function(module, exports) {

$parcel$export(module.exports, "PendingLabel", () => $08c90b75963a99bf$export$912d6c16dc850fa9);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $08c90b75963a99bf$export$912d6c16dc850fa9 = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    if (!props.isPending) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-sm text-white px-2 rounded bg-ch-orange-500 ml-1 uppercase",
        children: t("user:pending")
    });
};

});

parcelRegister("26LRi", function(module, exports) {

$parcel$export(module.exports, "GuestLabel", () => $705ee4205343dcca$export$4f2d0b7623396e8c);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $705ee4205343dcca$export$4f2d0b7623396e8c = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    if (!props.isGuest) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-sm text-white px-2 rounded bg-ch-blue-alt-500 ml-1 uppercase",
        children: t("user:guest")
    });
};

});



parcelRegister("kW0Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd09ce3665f42bb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $9IdeF = parcelRequire("9IdeF");
var $9rcVu = parcelRequire("9rcVu");
var $h8MLf = parcelRequire("h8MLf");
var $lhJr8 = parcelRequire("lhJr8");
var $9fvzA = parcelRequire("9fvzA");
var $bZDhf = parcelRequire("bZDhf");
var $7eN5N = parcelRequire("7eN5N");

var $kGUIk = parcelRequire("kGUIk");

var $6lvMC = parcelRequire("6lvMC");

var $dyeCj = parcelRequire("dyeCj");

var $2ghAH = parcelRequire("2ghAH");
const $2dd09ce3665f42bb$var$LiveMeetingUserStreamControls = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    const errors = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCErrors));
    const onToggleAudio = (userId, publisher, isSharingAudio)=>{
        dispatch((0, $kGUIk.toggleWebRTCPublishAudioAction)(userId, publisher, isSharingAudio));
    };
    const onToggleVideo = (userId, publisher, isSharingVideo)=>{
        dispatch((0, $kGUIk.toggleWebRTCPublishVideoAction)(userId, publisher, isSharingVideo));
    };
    const onToggleScreenShare = (isSharingScreen)=>{
        dispatch((0, $kGUIk.toggleWebRTCScreenShareIsOnAction)(isSharingScreen));
    };
    const iconClasses = "fill-current lg:w-6 lg:h-6 w-4 h-4 mb-1";
    const linkClassesWhite = "flex flex-col items-center text-sm lg:text-base text-white hover:text-ch-gray-600";
    const linkClassesGray = "flex flex-col items-center text-sm lg:text-base text-ch-gray-600 hover:text-white";
    const renderVideoControl = ()=>{
        if (user.config.isSharingVideo) return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesWhite,
            onClick: ()=>onToggleVideo(user.id, publisher, false),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eN5N.default), {
                    className: iconClasses,
                    title: t("liveMeeting:stopVideo")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:video")
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesGray,
            onClick: ()=>onToggleVideo(user.id, publisher, true),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bZDhf.default), {
                    className: iconClasses,
                    title: t("liveMeeting:startVideo")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:video")
                })
            ]
        });
    };
    const renderAudioControl = ()=>{
        if (user.config.isSharingAudio) return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesWhite,
            onClick: ()=>onToggleAudio(user.id, publisher, false),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8MLf.default), {
                    className: iconClasses,
                    title: t("liveMeeting:muteAudio")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:mic")
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesGray,
            onClick: ()=>onToggleAudio(user.id, publisher, true),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9rcVu.default), {
                    className: iconClasses,
                    title: t("liveMeeting:unmuteAudio")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:mic")
                })
            ]
        });
    };
    const renderScreenShareControl = ()=>{
        if (!user.config.isPresenter) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col items-center text-ch-blue-600",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lhJr8.default), {
                    className: iconClasses,
                    title: t("liveMeeting:mustBePresenterToShareScreen")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:screen")
                })
            ]
        });
        if (user.config.isSharingScreen) return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesWhite,
            onClick: ()=>onToggleScreenShare(false),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fvzA.default), {
                    className: iconClasses,
                    title: t("liveMeeting:startShareScreen")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:startShareScreen")
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            className: linkClassesGray,
            onClick: ()=>onToggleScreenShare(true),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lhJr8.default), {
                    className: iconClasses,
                    title: t("liveMeeting:startShareScreen")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:screen")
                })
            ]
        });
    };
    if (errors.mediaError) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center text-sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9IdeF.default), {
                className: "text-ch-red-500 h-12 mr-5"
            }),
            t("liveMeeting:mediaError")
        ]
    });
    if (!publisher) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex justify-end",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ghAH.default), {
                className: "text-white mr-3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ml-1",
                children: t("liveMeeting:connecting")
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex justify-around",
        children: [
            renderVideoControl(),
            renderAudioControl(),
            renderScreenShareControl()
        ]
    });
};
var $2dd09ce3665f42bb$export$2e2bcd8739ae039 = $2dd09ce3665f42bb$var$LiveMeetingUserStreamControls;

});
parcelRegister("2ghAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b508c2a4f3c9b570$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b508c2a4f3c9b570$var$LoadingSpinnerSmall = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                display: "block",
                margin: "auto"
            },
            width: "15px",
            height: "15px",
            viewBox: "0 0 100 100",
            preserveAspectRatio: "xMidYMid",
            className: props.className || "text-ch-blue-500",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "10",
                r: "35",
                strokeDasharray: "164.93361431346415 56.97787143782138",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    repeatCount: "indefinite",
                    dur: "1s",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1"
                })
            })
        })
    });
};
var $b508c2a4f3c9b570$export$2e2bcd8739ae039 = $b508c2a4f3c9b570$var$LoadingSpinnerSmall;

});



parcelRegister("cKREw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8940ed00d7c5680$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $rDKvs = parcelRequire("rDKvs");

var $bFrjs = parcelRequire("bFrjs");
parcelRequire("jitSV");
var $bnAWr = parcelRequire("bnAWr");
var $ft8ez = parcelRequire("ft8ez");

var $j0qQC = parcelRequire("j0qQC");

var $kQILj = parcelRequire("kQILj");
const $b8940ed00d7c5680$var$LiveMeetingViewControlsContainer = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const isSplitScreen = (0, $iD0SF.useSelector)((0, $kQILj.getIsSplitScreen));
    const selectedYourViewTab = (0, $iD0SF.useSelector)((0, $kQILj.getSelectedYourViewTab));
    const onToggleSplitScreen = (isSplitScreen)=>dispatch((0, $rDKvs.toggleSplitScreenAction)(isSplitScreen));
    const onChangeYourViewTab = (selectedTab)=>dispatch((0, $rDKvs.changeYourViewTabAction)(selectedTab));
    const renderYourViewTab = ()=>{
        const isSelected = selectedYourViewTab == (0, $j0qQC.YourViewTabs).YOUR_VIEW;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            onClick: ()=>onChangeYourViewTab((0, $j0qQC.YourViewTabs).YOUR_VIEW),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "items-center", "rounded-l-md", "py-1", "px-2", "whitespace-nowrap", {
                "bg-ch-blue-400": !isSelected,
                "hover:bg-ch-blue-300": !isSelected,
                "bg-white": isSelected
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnAWr.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current", "w-6", "h-6", {
                        "text-white": !isSelected,
                        "text-ch-blue-500": isSelected
                    }),
                    title: t("liveMeeting:yourView")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:yourView")
                })
            ]
        });
    };
    const renderUsersViewTab = ()=>{
        const isSelected = selectedYourViewTab == (0, $j0qQC.YourViewTabs).USERS_VIEW;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: "#",
            onClick: ()=>onChangeYourViewTab((0, $j0qQC.YourViewTabs).USERS_VIEW),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "items-center", "rounded-r-md", "py-1", "px-2", "whitespace-nowrap", {
                "bg-ch-blue-400": !isSelected,
                "hover:bg-ch-blue-300": !isSelected,
                "bg-white": isSelected
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ft8ez.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current", "w-6", "h-6", {
                        "text-white": !isSelected,
                        "text-ch-blue-500": isSelected
                    }),
                    title: t("liveMeeting:users")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("liveMeeting:users")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "items-center text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFrjs.default), {
                        name: "isSplitScreen",
                        action: ()=>onToggleSplitScreen(!isSplitScreen),
                        value: isSplitScreen
                    }),
                    t("liveMeeting:splitScreen")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "border-r-2 border-white border-dashed mx-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "mr-px",
                        children: renderYourViewTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: renderUsersViewTab()
                    })
                ]
            })
        ]
    });
};
var $b8940ed00d7c5680$export$2e2bcd8739ae039 = $b8940ed00d7c5680$var$LiveMeetingViewControlsContainer;

});
parcelRegister("bFrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7940fe387c7e2f9e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
const $7940fe387c7e2f9e$var$Switch = ({ className: className, name: name, action: action, value: value })=>{
    const defaultClasses = [
        "flex",
        "justify-center",
        "items-center"
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("relative", "rounded-full", "w-12", "h-6", "transition", "duration-200", "ease-linear", {
                "bg-white": value,
                "bg-ch-blue-300": !value
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    htmlFor: name,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("absolute", "left-0", "border-2", "mb-2", "w-6", "h-6", "rounded-full", "transition", "transform duration-100", "ease-linear", "cursor-pointer", {
                        "translate-x-full": value,
                        "bg-ch-blue-500": value,
                        "bg-white": !value,
                        "border-white": value,
                        "translate-x-0": !value,
                        "border-ch-blue-300": !value
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "checkbox",
                    id: name,
                    name: name,
                    className: "appearance-none w-full h-full active:outline-none focus:outline-none cursor-pointer",
                    onClick: action
                })
            ]
        })
    });
};
var $7940fe387c7e2f9e$export$2e2bcd8739ae039 = $7940fe387c7e2f9e$var$Switch;

});


parcelRegister("5RtA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65b9f11cb2b2f35$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lgHNQ = parcelRequire("lgHNQ");

var $hFs6L = parcelRequire("hFs6L");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $6lvMC = parcelRequire("6lvMC");

var $3mOhS = parcelRequire("3mOhS");

var $dQiiy = parcelRequire("dQiiy");

var $j0qQC = parcelRequire("j0qQC");
const $a65b9f11cb2b2f35$var$LiveMeetingCaseContainer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "liveMeeting"
    ]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const selectedMeetingCase = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCase));
    const liveMeetingConfig = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig));
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const renderSelectCaseButton = ()=>{
        if (!user.config?.isPresenter) return;
        const buttonText = selectedMeetingCase ? t("liveMeeting:switchCase") : t("liveMeeting:selectCase");
        const enabled = liveMeetingConfig.caseStage == (0, $j0qQC.CaseStage).PRESENTING;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: openModal,
            className: "self-center",
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            isChunky: true,
            isDisabled: !enabled,
            children: buttonText
        });
    };
    if (!user.config) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sm:flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "flex items-center text-ch-purple-500 mr-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                className: "fill-current w-6 h-6 mr-2",
                                title: t("shared:case")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-lg",
                                children: t("shared:case")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex-1 mr-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lgHNQ.default), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center sm:justify-end",
                        children: renderSelectCaseButton()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg text-ch-blue-600 mb-1",
                            children: t("liveMeeting:chooseCase")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hFs6L.default), {
                            meetingId: props.meetingId,
                            closeModal: closeModal
                        })
                    ]
                })
            })
        ]
    });
};
var $a65b9f11cb2b2f35$export$2e2bcd8739ae039 = $a65b9f11cb2b2f35$var$LiveMeetingCaseContainer;

});
parcelRegister("lgHNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa6fd8f1bbf72ec$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");

var $6qYxq = parcelRequire("6qYxq");

var $3mOhS = parcelRequire("3mOhS");

var $et8Rr = parcelRequire("et8Rr");

var $e5EhV = parcelRequire("e5EhV");
const $efa6fd8f1bbf72ec$var$LiveMeetingSelectedCaseDetails = ()=>{
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(0);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const caseData = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseDetails));
    (0, $e5EhV.useBeforeunload)(()=>{
        setConnectionRefresherIndex(connectionRefresherIndex + 1);
    });
    if (!caseData) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
        resourceId: caseData.id,
        channelName: (0, $6qYxq.CaseChannelName),
        actionPrefix: (0, $6qYxq.CaseCablePrefix),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "grid md:grid-cols-2 gap-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "md:col-span-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                firstName: caseData.firstName,
                                lastName: caseData.lastName,
                                title: caseData.title,
                                gender: caseData.gender,
                                className: "font-bold"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                t("case:dateOfBirth"),
                                ":",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                                    utcTime: caseData.dateOfBirth
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "md:col-span-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                healthcareIdLabel,
                                ": ",
                                caseData.healthcareId
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                careProviderIdLabel,
                                ": ",
                                caseData.careProviderId
                            ]
                        })
                    ]
                })
            ]
        })
    }, connectionRefresherIndex);
};
var $efa6fd8f1bbf72ec$export$2e2bcd8739ae039 = $efa6fd8f1bbf72ec$var$LiveMeetingSelectedCaseDetails;

});
parcelRegister("j2STh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0799ef2a6599f969$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5uuPM = parcelRequire("5uuPM");

var $ahLi9 = parcelRequire("ahLi9");
parcelRequire("bd5y7");
var $fp2Qd = parcelRequire("fp2Qd");
const $0799ef2a6599f969$var$TimeDateOfBirth = ({ utcTime: utcTime, className: className })=>{
    if (!utcTime) return null;
    const dob = new Date(utcTime);
    const formatTime = (0, $fp2Qd.default)(dob, "UTC", (0, $ahLi9.formatDateString));
    const age = (0, $5uuPM.default)(new Date(), dob);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: className,
        children: [
            formatTime,
            " (",
            age,
            ")"
        ]
    });
};
var $0799ef2a6599f969$export$2e2bcd8739ae039 = $0799ef2a6599f969$var$TimeDateOfBirth;

});
parcelRegister("5uuPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ff7ac235dc3be01$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $jMhzE = parcelRequire("jMhzE");

var $bQPWp = parcelRequire("bQPWp");

var $4LmDH = parcelRequire("4LmDH");
function $3ff7ac235dc3be01$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = (0, $bQPWp.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $jMhzE.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $bQPWp.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("jMhzE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e66021df2494c23e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("bQPWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0cd77776020c49$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8a0cd77776020c49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}

});



parcelRegister("3mOhS", function(module, exports) {

$parcel$export(module.exports, "getSelectedMeetingCaseId", () => $1619532a12ad3910$export$87a6573b7b04dd97);
$parcel$export(module.exports, "getSelectedMeetingCase", () => $1619532a12ad3910$export$d06157db45f8c153);
$parcel$export(module.exports, "getSelectedMeetingCaseDetails", () => $1619532a12ad3910$export$19cb6584888d9e7d);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $7twpo = parcelRequire("7twpo");

var $lxTgp = parcelRequire("lxTgp");

var $kon2z = parcelRequire("kon2z");

var $4VtCQ = parcelRequire("4VtCQ");
const $1619532a12ad3910$export$87a6573b7b04dd97 = (state)=>state.liveMeetingConfig.selectedMeetingCaseId;
const $1619532a12ad3910$export$d06157db45f8c153 = (0, $6SpLG.createSelector)((0, $4VtCQ.getAllMeetingCases), $1619532a12ad3910$export$87a6573b7b04dd97, (allMeetingCases, selectedMeetingCaseId)=>{
    return allMeetingCases[selectedMeetingCaseId];
});
const $1619532a12ad3910$export$19cb6584888d9e7d = (0, $6SpLG.createSelector)((0, $kon2z.getAllCases), $1619532a12ad3910$export$d06157db45f8c153, (allCases, selectedMeetingCase)=>{
    if (!selectedMeetingCase) return null;
    return allCases[selectedMeetingCase.case];
});
const $1619532a12ad3910$export$5d7dc03f4dc17edd = (0, $6SpLG.createSelector)($1619532a12ad3910$export$19cb6584888d9e7d, (selectedMeetingCaseDetails)=>{
    selectedMeetingCaseDetails;
    if (!selectedMeetingCaseDetails) return [];
    return selectedMeetingCaseDetails.assets;
});
const $1619532a12ad3910$export$e8f43eaca7f1c3b5 = (0, $6SpLG.createSelector)((0, $lxTgp.getAllAssets), $1619532a12ad3910$export$d06157db45f8c153, (allAssetsById, selectedMeetingCase)=>{
    const selectedMeetingCaseAssetIds = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(selectedMeetingCase.meetingCaseAssets, (meetingCaseAsset)=>meetingCaseAsset.caseAssetId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject(selectedMeetingCaseAssetIds, (assetId)=>{
        const asset = allAssetsById[assetId];
        return asset?.assetType != (0, $7twpo.AssetTypes).Comment;
    });
});

});
parcelRegister("7twpo", function(module, exports) {

$parcel$export(module.exports, "FormState", () => $ba7fc755325d39e9$export$35e922fb7c997117);
$parcel$export(module.exports, "CaseReportStatuses", () => $ba7fc755325d39e9$export$5e127de5460edeb4);
$parcel$export(module.exports, "AssetsActionTypes", () => $ba7fc755325d39e9$export$6b73d7a3a68d2074);
$parcel$export(module.exports, "AssetTypes", () => $ba7fc755325d39e9$export$c70f1cc794ed0c61);
$parcel$export(module.exports, "CommentTypes", () => $ba7fc755325d39e9$export$a7a2a5e87e990c9);
$parcel$export(module.exports, "AssetComponentTypes", () => $ba7fc755325d39e9$export$8e3f1aea4ab422a3);
var $ba7fc755325d39e9$export$35e922fb7c997117 = /*#__PURE__*/ function(FormState) {
    FormState["draft"] = "draft";
    FormState["complete"] = "complete";
    return FormState;
}({});
var $ba7fc755325d39e9$export$5e127de5460edeb4 = /*#__PURE__*/ function(CaseReportStatuses) {
    CaseReportStatuses["PENDING"] = "pending";
    CaseReportStatuses["DONE"] = "done";
    return CaseReportStatuses;
}({});
var $ba7fc755325d39e9$export$6b73d7a3a68d2074 = /*#__PURE__*/ function(AssetsActionTypes) {
    AssetsActionTypes["FETCH_CASE_ASSETS_ASYNC_PENDING"] = "@@assets/FETCH_CASE_ASSETS_ASYNC_PENDING";
    AssetsActionTypes["FETCH_CASE_ASSETS_ASYNC_SUCCESS"] = "@@assets/FETCH_CASE_ASSETS_ASYNC_SUCCESS";
    AssetsActionTypes["FETCH_CASE_ASSETS_ASYNC_ERROR"] = "@@assets/FETCH_CASE_ASSETS_ASYNC_ERROR";
    AssetsActionTypes["FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_PENDING"] = "@@assets/FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_PENDING";
    AssetsActionTypes["FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS"] = "@@assets/FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS";
    AssetsActionTypes["FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_ERROR"] = "@@assets/FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_ERROR";
    AssetsActionTypes["CREATE_CASE_COMMENT_ASYNC_PENDING"] = "@@assets/CREATE_CASE_COMMENT_ASYNC_PENDING";
    AssetsActionTypes["CREATE_CASE_COMMENT_ASYNC_SUCCESS"] = "@@assets/CREATE_CASE_COMMENT_ASYNC_SUCCESS";
    AssetsActionTypes["CREATE_CASE_COMMENT_ASYNC_ERROR"] = "@@assets/CREATE_CASE_COMMENT_ASYNC_ERROR";
    AssetsActionTypes["UPLOAD_CASE_FILE_ASYNC_PENDING"] = "@@assets/UPLOAD_CASE_FILE_ASYNC_PENDING";
    AssetsActionTypes["UPLOAD_CASE_FILE_ASYNC_SUCCESS"] = "@@assets/UPLOAD_CASE_FILE_ASYNC_SUCCESS";
    AssetsActionTypes["UPLOAD_CASE_FILE_ASYNC_ERROR"] = "@@assets/UPLOAD_CASE_FILE_ASYNC_ERROR";
    AssetsActionTypes["DELETE_CASE_ASSET_ASYNC_PENDING"] = "@@assets/DELETE_CASE_ASSET_ASYNC_PENDING";
    AssetsActionTypes["DELETE_CASE_ASSET_ASYNC_SUCCESS"] = "@@assets/DELETE_CASE_ASSET_ASYNC_SUCCESS";
    AssetsActionTypes["DELETE_CASE_ASSET_ASYNC_ERROR"] = "@@assets/DELETE_CASE_ASSET_ASYNC_ERROR";
    AssetsActionTypes["CREATE_CASE_LINK_ASYNC_PENDING"] = "@@assets/CREATE_CASE_LINK_ASYNC_PENDING";
    AssetsActionTypes["CREATE_CASE_LINK_ASYNC_SUCCESS"] = "@@assets/CREATE_CASE_LINK_ASYNC_SUCCESS";
    AssetsActionTypes["CREATE_CASE_LINK_ASYNC_ERROR"] = "@@assets/CREATE_CASE_LINK_ASYNC_ERROR";
    AssetsActionTypes["CREATE_CASE_RADIOLOGY_LINK_ASYNC_PENDING"] = "@@assets/CREATE_CASE_RADIOLOGY_LINK_ASYNC_PENDING";
    AssetsActionTypes["CREATE_CASE_RADIOLOGY_LINK_ASYNC_SUCCESS"] = "@@assets/CREATE_CASE_RADIOLOGY_LINK_ASYNC_SUCCESS";
    AssetsActionTypes["CREATE_CASE_RADIOLOGY_LINK_ASYNC_ERROR"] = "@@assets/CREATE_CASE_RADIOLOGY_LINK_ASYNC_ERROR";
    AssetsActionTypes["CREATE_CASE_RECOMMENDATION_ASYNC_PENDING"] = "@@assets/CREATE_CASE_RECOMMENDATION_ASYNC_PENDING";
    AssetsActionTypes["CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS"] = "@@assets/CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS";
    AssetsActionTypes["CREATE_CASE_RECOMMENDATION_ASYNC_ERROR"] = "@@assets/CREATE_CASE_RECOMMENDATION_ASYNC_ERROR";
    AssetsActionTypes["ADD_CONSENT_ASYNC_PENDING"] = "@@assets/ADD_CONSENT_ASYNC_PENDING";
    AssetsActionTypes["ADD_CONSENT_ASYNC_SUCCESS"] = "@@assets/ADD_CONSENT_ASYNC_SUCCESS";
    AssetsActionTypes["ADD_CONSENT_ASYNC_ERROR"] = "@@assets/ADD_CONSENT_ASYNC_ERROR";
    AssetsActionTypes["SAVE_CASE_RECOMMENDATION_ASYNC_PENDING"] = "@@assets/SAVE_CASE_RECOMMENDATION_ASYNC_PENDING";
    AssetsActionTypes["SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS"] = "@@assets/SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS";
    AssetsActionTypes["SAVE_CASE_RECOMMENDATION_ASYNC_ERROR"] = "@@assets/SAVE_CASE_RECOMMENDATION_ASYNC_ERROR";
    return AssetsActionTypes;
}({});
var $ba7fc755325d39e9$export$c70f1cc794ed0c61 = /*#__PURE__*/ function(AssetTypes) {
    AssetTypes["Link"] = "Link";
    AssetTypes["RadiologyLink"] = "RadiologyLink";
    AssetTypes["Comment"] = "Comment";
    AssetTypes["Document"] = "Document";
    AssetTypes["CaseReport"] = "CaseReport";
    AssetTypes["MessageDocument"] = "MessageDocument";
    AssetTypes["Form"] = "Form";
    return AssetTypes;
}({});
var $ba7fc755325d39e9$export$a7a2a5e87e990c9 = /*#__PURE__*/ function(CommentTypes) {
    CommentTypes["Comment"] = "comment";
    CommentTypes["Decision"] = "decision";
    CommentTypes["Deferral"] = "deferral";
    CommentTypes["Recommendation"] = "recommendation";
    return CommentTypes;
}({});
var $ba7fc755325d39e9$export$8e3f1aea4ab422a3 = /*#__PURE__*/ function(AssetComponentTypes) {
    AssetComponentTypes["Link"] = "link";
    AssetComponentTypes["RadiologyLink"] = "radiology_link";
    AssetComponentTypes["Comment"] = "comment";
    AssetComponentTypes["Decision"] = "decision";
    AssetComponentTypes["Deferral"] = "deferral";
    AssetComponentTypes["Recommendation"] = "recommendation";
    AssetComponentTypes["Pdf"] = "pdf";
    AssetComponentTypes["Image"] = "image";
    AssetComponentTypes["CaseReport"] = "report";
    AssetComponentTypes["Form"] = "context_form";
    return AssetComponentTypes;
}({});

});

parcelRegister("lxTgp", function(module, exports) {

$parcel$export(module.exports, "getAllAssets", () => $9386d30e60adea86$export$8ba88d299d15120b);
$parcel$export(module.exports, "getAssetById", () => $9386d30e60adea86$export$4c6f2903688a9645);
$parcel$export(module.exports, "getAllMeetingCaseAssetIds", () => $9386d30e60adea86$export$23fab1a5087b538a);
$parcel$export(module.exports, "getAllCaseAssetIds", () => $9386d30e60adea86$export$9c5abcd267096109);
$parcel$export(module.exports, "getLatestRecommendationAssetId", () => $9386d30e60adea86$export$f2a10fe4f2407259);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $7twpo = parcelRequire("7twpo");

var $kon2z = parcelRequire("kon2z");

var $4VtCQ = parcelRequire("4VtCQ");
const $9386d30e60adea86$export$8ba88d299d15120b = (state)=>state.entities.assets.byId;
const $9386d30e60adea86$export$4c6f2903688a9645 = (state, ownProps)=>state.entities.assets.byId[ownProps.assetId];
const $9386d30e60adea86$export$23fab1a5087b538a = (0, $6SpLG.createSelector)((0, $4VtCQ.getMeetingCaseById), (meetingCase)=>{
    if (!meetingCase) return [];
    return meetingCase.meetingCaseAssets;
});
const $9386d30e60adea86$export$9c5abcd267096109 = (0, $6SpLG.createSelector)((0, $kon2z.getCaseById), (caseData)=>{
    if (!caseData) return [];
    return caseData.assets;
});
const $9386d30e60adea86$export$f2a10fe4f2407259 = (0, $6SpLG.createSelector)((0, $kon2z.getCaseById), $9386d30e60adea86$export$8ba88d299d15120b, (caseData, allAssets)=>{
    if (!caseData || !allAssets) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(caseData.assets, (assetId)=>{
        const comment = allAssets[assetId]?.asset;
        return comment?.commentType == (0, $7twpo.CommentTypes).Recommendation;
    });
});

});
parcelRegister("kon2z", function(module, exports) {

$parcel$export(module.exports, "getAllCaseIds", () => $dd2349901d04bc6a$export$9c2aefdf6b43a1da);
$parcel$export(module.exports, "getAllCases", () => $dd2349901d04bc6a$export$73558ca5ab7fd2aa);
$parcel$export(module.exports, "getCaseById", () => $dd2349901d04bc6a$export$1ae6a5bbe85c810);
$parcel$export(module.exports, "getCaseMembersStatus", () => $dd2349901d04bc6a$export$6520c7971ed053f1);
$parcel$export(module.exports, "getLeadCareUserByCaseId", () => $dd2349901d04bc6a$export$6302ca3b80207861);
$parcel$export(module.exports, "getCaseByMeetingCaseId", () => $dd2349901d04bc6a$export$ccf40c8592934cbe);
$parcel$export(module.exports, "getCaseMeetingIds", () => $dd2349901d04bc6a$export$bcca515c5e2a2e58);
$parcel$export(module.exports, "getMeetingsForCase", () => $dd2349901d04bc6a$export$efbbc6b09b6a4027);
$parcel$export(module.exports, "getUserIdsForCaseMeetings", () => $dd2349901d04bc6a$export$cf93fb4742a06fc4);
$parcel$export(module.exports, "getCaseMemberUsers", () => $dd2349901d04bc6a$export$bb0d9f891925effd);
$parcel$export(module.exports, "getCaseMemberUserIds", () => $dd2349901d04bc6a$export$61afd38004331067);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $6lvMC = parcelRequire("6lvMC");

var $4VtCQ = parcelRequire("4VtCQ");

var $cA1jy = parcelRequire("cA1jy");
const $dd2349901d04bc6a$export$9c2aefdf6b43a1da = (state)=>state.entities.cases.allIds;
const $dd2349901d04bc6a$export$73558ca5ab7fd2aa = (state)=>state.entities.cases.byId;
const $dd2349901d04bc6a$export$1ae6a5bbe85c810 = (state, ownProps)=>state.entities.cases.byId[ownProps.caseId];
const $dd2349901d04bc6a$export$6520c7971ed053f1 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (caseData)=>{
    if (!caseData) return null;
    const caseMemberStatusData = {};
    caseData?.caseMembersStatus?.map((status)=>{
        caseMemberStatusData[status.userId] = status;
    });
    return caseMemberStatusData;
});
const $dd2349901d04bc6a$export$6302ca3b80207861 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (0, $6lvMC.getAllUsers), (caseData, users)=>{
    if (!caseData) return null;
    return users[caseData.leadCareUser];
});
const $dd2349901d04bc6a$export$ccf40c8592934cbe = (state, ownProps)=>{
    const caseId = state.entities.meetingCases.byId[ownProps.meetingCaseId]?.case;
    return state.entities.cases.byId[caseId] ?? null;
};
const $dd2349901d04bc6a$export$bcca515c5e2a2e58 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (caseData)=>{
    if (!caseData) return [];
    return caseData.meetings;
});
const $dd2349901d04bc6a$export$efbbc6b09b6a4027 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (0, $4VtCQ.getAllMeetings), (caseData, allMeetings)=>{
    if (!caseData) return [];
    const meetings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pick(allMeetings, caseData.meetings);
    return Object.values(meetings);
});
const $dd2349901d04bc6a$export$cf93fb4742a06fc4 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (0, $4VtCQ.getAllMeetings), (caseData, allMeetings)=>{
    if (!caseData) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41)))(allMeetings).pick(caseData.meetings).flatMap((meeting)=>meeting.users).uniq().value();
});
const $dd2349901d04bc6a$export$fb651f8cae6202c7 = (0, $6SpLG.createSelector)($dd2349901d04bc6a$export$1ae6a5bbe85c810, (caseData)=>{
    if (!caseData) return [];
    return caseData.members;
});
const $dd2349901d04bc6a$export$bb0d9f891925effd = (0, $6SpLG.createSelector)((0, $6lvMC.getAllUsers), $dd2349901d04bc6a$export$fb651f8cae6202c7, (allUsers, caseMemberIds)=>{
    if (!caseMemberIds) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41)))(allUsers).pick(caseMemberIds).pickBy((user)=>!(0, $cA1jy.isGuest)(user)).value();
});
const $dd2349901d04bc6a$export$61afd38004331067 = (0, $6SpLG.createSelector)((0, $6lvMC.getAllUsers), $dd2349901d04bc6a$export$fb651f8cae6202c7, (allUsers, caseMemberIds)=>{
    if (!caseMemberIds) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41)))(allUsers).pick(caseMemberIds).pickBy((user)=>!(0, $cA1jy.isGuest)(user)).keys().value();
});

});



parcelRegister("et8Rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b2630907e0527c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gONkJ = parcelRequire("gONkJ");

var $aEgqS = parcelRequire("aEgqS");

var $iChsq = parcelRequire("iChsq");

var $kYqkq = parcelRequire("kYqkq");

var $i1qLR = parcelRequire("i1qLR");

var $fqupj = parcelRequire("fqupj");
const $05b2630907e0527c$var$CableConnection = (props)=>{
    const { apiToken: apiToken, consumer: consumer } = (0, $acw62.useContext)((0, $iChsq.CableContext));
    const [isConnected, setIsConnected] = (0, $acw62.useState)(false);
    const isConnectedRef = (0, $acw62.useRef)(false);
    isConnectedRef.current = isConnected;
    const requestingSms = (0, $kYqkq.useAppSelector)((0, $i1qLR.mfaSmsRequesting));
    (0, $acw62.useEffect)(()=>{
        if (!apiToken || apiToken.length === 0 || !consumer || requestingSms) {
            setIsConnected(false);
            return;
        }
        const channelParams = {
            channel: props.channelName
        };
        if (props.resourceId) channelParams.resource_id = props.resourceId;
        if (props.tenantId) channelParams.tenant_id = props.tenantId;
        const subId = `${props.channelName}-${props.resourceId || ""}-${props.tenantId || ""}-${Math.random().toString(36).substring(2, 9)}`;
        const subscription = consumer.subscriptions.create(channelParams, {
            connected () {
                setIsConnected(true);
            },
            disconnected () {
                console.error(`Disconnected ws connection: ${props.channelName}`);
                setIsConnected(false);
            },
            rejected () {
                console.error(`Rejected ws connection: ${props.channelName}`);
                setIsConnected(false);
            },
            received (data) {
                if (data && typeof data === "object" && "type" in data) {
                    const action = data;
                    (0, $gONkJ.store).dispatch({
                        ...action,
                        meta: {
                            ...action.meta || {},
                            fromServer: true,
                            __cablecar__: true,
                            channel: props.channelName
                        }
                    });
                }
            }
        });
        (0, $fqupj.registerCableSubscription)({
            id: subId,
            channelName: props.channelName,
            actionPrefix: props.actionPrefix,
            subscription: subscription,
            isConnected: ()=>isConnectedRef.current
        });
        return ()=>{
            // setTimeout to kill cable connection after final webRTC
            // events have been sent eg. to show user offline
            setTimeout(()=>{
                (0, $fqupj.unregisterCableSubscription)(subId);
                subscription.unsubscribe();
            });
        };
    }, [
        consumer,
        apiToken,
        requestingSms,
        props.channelName,
        props.actionPrefix,
        props.resourceId,
        props.tenantId
    ]);
    if (props.awaitConnection && !isConnected && props.children) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    if (!props.children) return null;
    if (!apiToken || apiToken.length === 0 || !consumer) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: props.children
    });
};
var $05b2630907e0527c$export$2e2bcd8739ae039 = $05b2630907e0527c$var$CableConnection;

});
parcelRegister("gONkJ", function(module, exports) {

$parcel$export(module.exports, "store", () => $d60fd404bd4d32d3$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "persistor", () => $d60fd404bd4d32d3$export$7b682ac9934ca3e4);

var $i5N98 = parcelRequire("i5N98");

var $gmHK3 = parcelRequire("gmHK3");

var $fqupj = parcelRequire("fqupj");

var $8U7Jd = parcelRequire("8U7Jd");
parcelRequire("jH000");
var $9WT1n = parcelRequire("9WT1n");
var $64C8N = parcelRequire("64C8N");

var $fp14A = parcelRequire("fp14A");

var $EUKm7 = parcelRequire("EUKm7");

var $cYXkn = parcelRequire("cYXkn");

var $jSDfI = parcelRequire("jSDfI");

var $lnXep = parcelRequire("lnXep");
const $d60fd404bd4d32d3$var$persistedState = (0, $jSDfI.loadSession)();
const $d60fd404bd4d32d3$var$initialState = {
    ...$d60fd404bd4d32d3$var$persistedState
};
const $d60fd404bd4d32d3$export$11c9ec5ddf44c79c = (0, $gmHK3.default)();
const $d60fd404bd4d32d3$var$rootReducer = (state, action)=>{
    if (action?.type == (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_SUCCESS) state = undefined;
    return (0, $EUKm7.default)(state, action);
};
const $d60fd404bd4d32d3$var$persistConfig = {
    key: "root",
    storage: $fp14A.default,
    whitelist: [
        "ui",
        "liveMeetingConfig"
    ]
};
const $d60fd404bd4d32d3$var$persistedReducer = (0, $9WT1n.default)($d60fd404bd4d32d3$var$persistConfig, $d60fd404bd4d32d3$var$rootReducer);
const $d60fd404bd4d32d3$export$6f57813fe9f31bf9 = (0, $i5N98.legacy_createStore)($d60fd404bd4d32d3$var$persistedReducer, $d60fd404bd4d32d3$var$initialState, (0, $8U7Jd.composeWithDevTools)((0, $i5N98.applyMiddleware)($d60fd404bd4d32d3$export$11c9ec5ddf44c79c, (0, $fqupj.cableMiddleware))));
const $d60fd404bd4d32d3$export$7b682ac9934ca3e4 = (0, $64C8N.default)($d60fd404bd4d32d3$export$6f57813fe9f31bf9);
$d60fd404bd4d32d3$export$11c9ec5ddf44c79c.run((0, $cYXkn.default));

});
parcelRegister("i5N98", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $d2bed10dff9b4968$export$f51a9068ac82ea43);
$parcel$export(module.exports, "legacy_createStore", () => $d2bed10dff9b4968$export$8928921ea2d3b126);
$parcel$export(module.exports, "combineReducers", () => $d2bed10dff9b4968$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $d2bed10dff9b4968$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $d2bed10dff9b4968$export$9ff26e0402cc7b7);
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("gmHK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea0a19dd4c5e28d$export$2e2bcd8739ae039);

var $aFDGl = parcelRequire("aFDGl");
var $bea0a19dd4c5e28d$export$2e2bcd8739ae039 = (0, $aFDGl.default);

});
parcelRegister("aFDGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4c83baead83c48$export$2e2bcd8739ae039);

var $5QIeP = parcelRequire("5QIeP");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $1NYpB = parcelRequire("1NYpB");

var $k6WuE = parcelRequire("k6WuE");

var $iKXfo = parcelRequire("iKXfo");
parcelRequire("5Z0E9");
var $7c4c83baead83c48$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $7c4c83baead83c48$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $7c4c83baead83c48$var$exec(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        task();
    } finally{
        $7c4c83baead83c48$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $7c4c83baead83c48$var$asap(task) {
    $7c4c83baead83c48$var$queue.push(task);
    if (!$7c4c83baead83c48$var$semaphore) {
        $7c4c83baead83c48$var$suspend();
        $7c4c83baead83c48$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $7c4c83baead83c48$var$immediately(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        return task();
    } finally{
        $7c4c83baead83c48$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $7c4c83baead83c48$var$suspend() {
    $7c4c83baead83c48$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $7c4c83baead83c48$var$release() {
    $7c4c83baead83c48$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $7c4c83baead83c48$var$flush() {
    $7c4c83baead83c48$var$release();
    var task;
    while(!$7c4c83baead83c48$var$semaphore && (task = $7c4c83baead83c48$var$queue.shift()) !== undefined)$7c4c83baead83c48$var$exec(task);
}
var $7c4c83baead83c48$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $7c4c83baead83c48$var$matcher(p)(input);
        });
    };
};
var $7c4c83baead83c48$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $7c4c83baead83c48$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $7c4c83baead83c48$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $7c4c83baead83c48$var$wildcard = function wildcard() {
    return 0, $k6WuE.k;
};
function $7c4c83baead83c48$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === '*' ? $7c4c83baead83c48$var$wildcard : (0, $1NYpB.string)(pattern) ? $7c4c83baead83c48$var$string : (0, $1NYpB.array)(pattern) ? $7c4c83baead83c48$var$array : (0, $1NYpB.stringableFunc)(pattern) ? $7c4c83baead83c48$var$string : (0, $1NYpB.func)(pattern) ? $7c4c83baead83c48$var$predicate : (0, $1NYpB.symbol)(pattern) ? $7c4c83baead83c48$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $7c4c83baead83c48$export$32239d68d9c6cb49 = {
    type: (0, $5QIeP.CHANNEL_END_TYPE)
};
var $7c4c83baead83c48$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $5QIeP.CHANNEL_END_TYPE);
};
var $7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var $7c4c83baead83c48$var$INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var $7c4c83baead83c48$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $7c4c83baead83c48$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $k6WuE.e)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $k6WuE.i)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $k6WuE.i)('Cannot have pending takers with non empty buffer');
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($7c4c83baead83c48$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $k6WuE.r)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $7c4c83baead83c48$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $k6WuE.n)();
    var closed = false;
    var unsubscribe;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $1NYpB.func)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $k6WuE.o)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $7c4c83baead83c48$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $k6WuE.i)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $5QIeP.MULTICAST] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $5QIeP.MATCH](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $7c4c83baead83c48$var$wildcard;
        if (closed) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $5QIeP.MATCH] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $k6WuE.o)(function() {
            ensureCanMutateNextTakers();
            (0, $k6WuE.r)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $7c4c83baead83c48$export$e987d166a3a4f3ec() {
    var chan = $7c4c83baead83c48$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $5QIeP.SAGA_ACTION]) {
            put(input);
            return;
        }
        $7c4c83baead83c48$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $7c4c83baead83c48$var$RUNNING = 0;
var $7c4c83baead83c48$var$CANCELLED = 1;
var $7c4c83baead83c48$var$ABORTED = 2;
var $7c4c83baead83c48$var$DONE = 3;
function $7c4c83baead83c48$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $5QIeP.CANCEL];
    if ((0, $1NYpB.func)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $7c4c83baead83c48$var$current = 0;
var $7c4c83baead83c48$var$nextSagaId = function() {
    return ++$7c4c83baead83c48$var$current;
};
var $7c4c83baead83c48$var$_effectRunnerMap;
function $7c4c83baead83c48$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $k6WuE.j)(fn);
}
function $7c4c83baead83c48$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $1NYpB.iterator)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $1NYpB.promise)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $k6WuE.q)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $k6WuE.q)(function() {
            throw err;
        });
    }
}
function $7c4c83baead83c48$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $7c4c83baead83c48$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $1NYpB.promise)(result)) $7c4c83baead83c48$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $7c4c83baead83c48$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $5QIeP.TERMINATE));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $1NYpB.notUndef)(pattern) ? $7c4c83baead83c48$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $7c4c83baead83c48$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $1NYpB.promise)(result)) {
            $7c4c83baead83c48$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $1NYpB.iterator)(result)) {
            // resolve iterator
            $7c4c83baead83c48$var$proc(env, result, task.context, $7c4c83baead83c48$var$current, (0, $k6WuE.j)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $1NYpB.undef)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $7c4c83baead83c48$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $7c4c83baead83c48$var$getIteratorMetaInfo(taskIterator, fn);
    $7c4c83baead83c48$var$immediately(function() {
        var child = $7c4c83baead83c48$var$proc(env, taskIterator, parent.context, $7c4c83baead83c48$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $7c4c83baead83c48$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $k6WuE.r)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $1NYpB.array)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $k6WuE.l)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $7c4c83baead83c48$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $7c4c83baead83c48$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $5QIeP.SELF_CANCELLATION)) $7c4c83baead83c48$var$cancelSingleTask(task);
    else if ((0, $1NYpB.array)(taskOrTasks)) taskOrTasks.forEach($7c4c83baead83c48$var$cancelSingleTask);
    else $7c4c83baead83c48$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $7c4c83baead83c48$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $1NYpB.array)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $k6WuE.l)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $7c4c83baead83c48$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    var response = (0, $1NYpB.array)(effects) ? (0, $k6WuE.m)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $k6WuE.s)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $k6WuE.t);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $7c4c83baead83c48$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var match = $7c4c83baead83c48$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$7c4c83baead83c48$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $7c4c83baead83c48$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $7c4c83baead83c48$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $7c4c83baead83c48$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $7c4c83baead83c48$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $k6WuE.p)(task.context, props);
    cb();
}
var $7c4c83baead83c48$var$effectRunnerMap = ($7c4c83baead83c48$var$_effectRunnerMap = {}, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.T] = $7c4c83baead83c48$var$runTakeEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.P] = $7c4c83baead83c48$var$runPutEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.A] = $7c4c83baead83c48$var$runAllEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.R] = $7c4c83baead83c48$var$runRaceEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.C] = $7c4c83baead83c48$var$runCallEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.a] = $7c4c83baead83c48$var$runCPSEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.F] = $7c4c83baead83c48$var$runForkEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.J] = $7c4c83baead83c48$var$runJoinEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.b] = $7c4c83baead83c48$var$runCancelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.S] = $7c4c83baead83c48$var$runSelectEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.d] = $7c4c83baead83c48$var$runChannelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.f] = $7c4c83baead83c48$var$runCancelledEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.g] = $7c4c83baead83c48$var$runFlushEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.G] = $7c4c83baead83c48$var$runGetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $k6WuE.h] = $7c4c83baead83c48$var$runSetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $7c4c83baead83c48$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $k6WuE.r)(tasks, task);
            task.cont = (0, $k6WuE.t);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $k6WuE.t);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $7c4c83baead83c48$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $7c4c83baead83c48$var$effectLocationAsString(effect) {
    var location = (0, $k6WuE.v)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $7c4c83baead83c48$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return '';
}
function $7c4c83baead83c48$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $7c4c83baead83c48$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $7c4c83baead83c48$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $k6WuE.u)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return '';
    return [
        'Tasks cancelled due to error:'
    ].concat(cancelledTasks).join('\n');
}
var $7c4c83baead83c48$var$crashedEffect = null;
var $7c4c83baead83c48$var$sagaStack = [];
var $7c4c83baead83c48$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $7c4c83baead83c48$var$crashedEffect;
    $7c4c83baead83c48$var$sagaStack.push(frame);
};
var $7c4c83baead83c48$var$clear = function clear() {
    $7c4c83baead83c48$var$crashedEffect = null;
    $7c4c83baead83c48$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $7c4c83baead83c48$var$setCrashedEffect = function setCrashedEffect(effect) {
    $7c4c83baead83c48$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $7c4c83baead83c48$var$toString = function toString() {
    var firstSaga = $7c4c83baead83c48$var$sagaStack[0], otherSagas = $7c4c83baead83c48$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $7c4c83baead83c48$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $7c4c83baead83c48$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $7c4c83baead83c48$var$sagaLocationAsString(s.meta);
    }), [
        $7c4c83baead83c48$var$cancelledTasksAsString($7c4c83baead83c48$var$sagaStack)
    ]).join('\n');
};
function $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $k6WuE.t);
    var status = $7c4c83baead83c48$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $7c4c83baead83c48$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $7c4c83baead83c48$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $7c4c83baead83c48$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $5QIeP.TASK_CANCEL), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $5QIeP.TASK_CANCEL)) status = $7c4c83baead83c48$var$CANCELLED;
            else if (status !== $7c4c83baead83c48$var$CANCELLED) status = $7c4c83baead83c48$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $7c4c83baead83c48$var$ABORTED;
            $7c4c83baead83c48$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $7c4c83baead83c48$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $7c4c83baead83c48$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $k6WuE.p)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $iKXfo.default)();
        if (status === $7c4c83baead83c48$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $7c4c83baead83c48$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $5QIeP.TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $7c4c83baead83c48$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $7c4c83baead83c48$var$CANCELLED || status === $7c4c83baead83c48$var$RUNNING && mainTask.status === $7c4c83baead83c48$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $7c4c83baead83c48$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $7c4c83baead83c48$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $k6WuE.t);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $7c4c83baead83c48$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $7c4c83baead83c48$var$RUNNING) {
            mainTask.status = $7c4c83baead83c48$var$CANCELLED;
            next((0, $5QIeP.TASK_CANCEL));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $7c4c83baead83c48$var$clear();
            } else if ((0, $k6WuE.y)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $7c4c83baead83c48$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $1NYpB.func)(iterator$1.return) ? iterator$1.return((0, $5QIeP.TASK_CANCEL)) : {
                    done: true,
                    value: (0, $5QIeP.TASK_CANCEL)
                };
            } else if ((0, $k6WuE.z)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $1NYpB.func)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $7c4c83baead83c48$var$CANCELLED) mainTask.status = $7c4c83baead83c48$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $7c4c83baead83c48$var$CANCELLED) throw error;
            mainTask.status = $7c4c83baead83c48$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $1NYpB.promise)(effect)) $7c4c83baead83c48$var$resolvePromise(effect, currCb);
        else if ((0, $1NYpB.iterator)(effect)) // resolve iterator
        $7c4c83baead83c48$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $5QIeP.IO]) {
            var effectRunner = $7c4c83baead83c48$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = '';
        var effectId = $7c4c83baead83c48$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $k6WuE.t); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $7c4c83baead83c48$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $k6WuE.t); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $k6WuE.t); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var $7c4c83baead83c48$var$NON_GENERATOR_ERR = $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $7c4c83baead83c48$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $k6WuE.D) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $7c4c83baead83c48$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $k6WuE.t);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $k6WuE.t);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $k6WuE.t);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $k6WuE.t);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $k6WuE.t);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $k6WuE.t);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $k6WuE.B).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $k6WuE.H);
    var env = {
        channel: channel,
        dispatch: (0, $k6WuE.E)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $7c4c83baead83c48$var$immediately(function() {
        var task = $7c4c83baead83c48$var$proc(env, iterator$1, context, effectId, (0, $k6WuE.j)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $7c4c83baead83c48$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $1En50.default)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $7c4c83baead83c48$export$3d8d44bf0c43bb61.bind(null, (0, $8nd05.default)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $k6WuE.p)(context, props);
    };
    return sagaMiddleware;
}
var $7c4c83baead83c48$export$2e2bcd8739ae039 = $7c4c83baead83c48$var$sagaMiddlewareFactory;

});
parcelRegister("iKXfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7a7b2afd0c6e2b$export$2e2bcd8739ae039);
function $da7a7b2afd0c6e2b$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $da7a7b2afd0c6e2b$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($da7a7b2afd0c6e2b$var$deferred());
    return arr;
}
var $da7a7b2afd0c6e2b$export$2e2bcd8739ae039 = $da7a7b2afd0c6e2b$var$deferred;

});



parcelRegister("fqupj", function(module, exports) {

$parcel$export(module.exports, "registerCableSubscription", () => $def6bc4ae7a932e7$export$fc30ab5e71623c47);
$parcel$export(module.exports, "unregisterCableSubscription", () => $def6bc4ae7a932e7$export$b0974f77999d9614);
$parcel$export(module.exports, "cableMiddleware", () => $def6bc4ae7a932e7$export$897f614fbf7a4475);
const $def6bc4ae7a932e7$var$subscriptions = new Map();
const $def6bc4ae7a932e7$export$fc30ab5e71623c47 = (registration)=>{
    $def6bc4ae7a932e7$var$subscriptions.set(registration.id, registration);
};
const $def6bc4ae7a932e7$export$b0974f77999d9614 = (id)=>{
    $def6bc4ae7a932e7$var$subscriptions.delete(id);
};
const $def6bc4ae7a932e7$export$aee72173eb3223 = ()=>{
    return $def6bc4ae7a932e7$var$subscriptions;
};
const $def6bc4ae7a932e7$export$b5cb2be6c8a0d62f = ()=>{
    $def6bc4ae7a932e7$var$subscriptions.clear();
};
const $def6bc4ae7a932e7$export$897f614fbf7a4475 = (store)=>(next)=>(rawAction)=>{
            const action = rawAction;
            // If action was received from server or marked as from cable, do not re-broadcast
            if (action?.meta?.fromServer || action?.meta?.__cablecar__) return next(action);
            let matched = false;
            for (const registration of $def6bc4ae7a932e7$var$subscriptions.values())if (typeof action?.type === "string" && action.type.startsWith(registration.actionPrefix)) {
                matched = true;
                if (registration.isConnected()) registration.subscription.send(action);
                else console.warn(`Cable channel "${registration.channelName}" dropped action (not connected):`, action);
            }
            if (matched) {
                // Optimistic actions update Redux store immediately
                if (action?.meta?.isOptimistic) return next(action);
                // Non-optimistic actions are handled on the server before state is broadcast back
                return store.getState();
            }
            return next(action);
        };
var $def6bc4ae7a932e7$export$2e2bcd8739ae039 = $def6bc4ae7a932e7$export$897f614fbf7a4475;

});

parcelRegister("8U7Jd", function(module, exports) {

$parcel$export(module.exports, "composeWithDevTools", () => $67b98c6460b6abea$export$d32324a03b6bde1b);

var $i5N98 = parcelRequire("i5N98");



function $67b98c6460b6abea$var$extensionComposeStub() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return undefined;
    if (typeof funcs[0] === 'object') return 0, $i5N98.compose;
    return (0, $i5N98.compose)(...funcs);
}
const $67b98c6460b6abea$export$d32324a03b6bde1b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : $67b98c6460b6abea$var$extensionComposeStub;
const $67b98c6460b6abea$export$321b1ffcca858b2b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};

});

parcelRegister("jH000", function(module, exports) {

$parcel$export(module.exports, "persistReducer", () => (parcelRequire("9WT1n")).default);
$parcel$export(module.exports, "persistStore", () => (parcelRequire("64C8N")).default);

var $9WT1n = parcelRequire("9WT1n");

var $pCdmM = parcelRequire("pCdmM");

var $64C8N = parcelRequire("64C8N");

var $jZL09 = parcelRequire("jZL09");

var $erd43 = parcelRequire("erd43");

var $S91eB = parcelRequire("S91eB");

var $dRDaT = parcelRequire("dRDaT");

var $6FDHu = parcelRequire("6FDHu");
parcelRequire("iUB9U");

});
parcelRegister("9WT1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e435e2fc216b6c$export$2e2bcd8739ae039);

var $iUB9U = parcelRequire("iUB9U");

var $3WFhx = parcelRequire("3WFhx");

var $dRDaT = parcelRequire("dRDaT");

var $S91eB = parcelRequire("S91eB");

var $6FDHu = parcelRequire("6FDHu");
function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $iUB9U.DEFAULT_VERSION);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $3WFhx.default) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $S91eB.default);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $iUB9U.PERSIST)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $dRDaT.default)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $iUB9U.PURGE)) {
            _purge = true;
            action.result((0, $6FDHu.default)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $iUB9U.FLUSH)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $iUB9U.PAUSE)) _paused = true;
        else if (action.type === (0, $iUB9U.REHYDRATE)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}

});
parcelRegister("iUB9U", function(module, exports) {

$parcel$export(module.exports, "KEY_PREFIX", () => $dc4a47ea750d5f98$export$711117ad6ad27992);
$parcel$export(module.exports, "FLUSH", () => $dc4a47ea750d5f98$export$2aaee4793dd13a52);
$parcel$export(module.exports, "REHYDRATE", () => $dc4a47ea750d5f98$export$1647ef958242c4e2);
$parcel$export(module.exports, "PAUSE", () => $dc4a47ea750d5f98$export$dd1033c27a16bbd3);
$parcel$export(module.exports, "PERSIST", () => $dc4a47ea750d5f98$export$913fe0e161ed92a2);
$parcel$export(module.exports, "PURGE", () => $dc4a47ea750d5f98$export$5514fc3b4067675f);
$parcel$export(module.exports, "REGISTER", () => $dc4a47ea750d5f98$export$51e82cdd7353a0e1);
$parcel$export(module.exports, "DEFAULT_VERSION", () => $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
var $dc4a47ea750d5f98$export$711117ad6ad27992 = 'persist:';
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $dc4a47ea750d5f98$export$5514fc3b4067675f = 'persist/PURGE';
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;

});

parcelRegister("3WFhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df6cf986f188332$export$2e2bcd8739ae039);
function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}

});

parcelRegister("dRDaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a17e9ce2c74bd9e8$export$2e2bcd8739ae039);

var $iUB9U = parcelRequire("iUB9U");
function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $iUB9U.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}

});

parcelRegister("S91eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);

var $iUB9U = parcelRequire("iUB9U");
function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $iUB9U.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}

});

parcelRegister("6FDHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4db55e14b5a1f785$export$2e2bcd8739ae039);

var $iUB9U = parcelRequire("iUB9U");
function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $iUB9U.KEY_PREFIX)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}

});


parcelRegister("pCdmM", function(module, exports) {

var $i5N98 = parcelRequire("i5N98");

var $9WT1n = parcelRequire("9WT1n");

var $ap3Jx = parcelRequire("ap3Jx");
function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $ap3Jx.default) : config.stateReconciler;
    return (0, $9WT1n.default)(config, (0, $i5N98.combineReducers)(reducers));
}

});
parcelRegister("ap3Jx", function(module, exports) {

$parcel$export(module.exports, "default", () => $792f2290643e73f9$export$2e2bcd8739ae039);
function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === 'object';
}

});


parcelRegister("64C8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c0b3c6eec1f9fa$export$2e2bcd8739ae039);

var $i5N98 = parcelRequire("i5N98");

var $iUB9U = parcelRequire("iUB9U");
function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $iUB9U.REGISTER:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $iUB9U.REHYDRATE:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $i5N98.createStore)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $iUB9U.REGISTER),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $iUB9U.REHYDRATE),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $iUB9U.PURGE),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $iUB9U.FLUSH),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $iUB9U.PAUSE)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $iUB9U.PERSIST),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}

});

parcelRegister("jZL09", function(module, exports) {

var $iUB9U = parcelRequire("iUB9U");
function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $iUB9U.DEFAULT_VERSION);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

});

parcelRegister("erd43", function(module, exports) {
function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}

});


parcelRegister("fp14A", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36a05dffe55b995$export$2e2bcd8739ae039, (v) => $b36a05dffe55b995$export$2e2bcd8739ae039 = v);
var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)('local');
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;

});

parcelRegister("EUKm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $155813e4ada9e58c$export$2e2bcd8739ae039);

var $i5N98 = parcelRequire("i5N98");

var $4Bn9h = parcelRequire("4Bn9h");

var $9OAyG = parcelRequire("9OAyG");

var $7t2oX = parcelRequire("7t2oX");

var $cCrQC = parcelRequire("cCrQC");

var $akDEs = parcelRequire("akDEs");

var $hKS78 = parcelRequire("hKS78");

var $bHP5N = parcelRequire("bHP5N");

var $3vcrm = parcelRequire("3vcrm");

var $iRUYI = parcelRequire("iRUYI");

var $6mKzG = parcelRequire("6mKzG");

var $k7bTN = parcelRequire("k7bTN");

var $4xxiw = parcelRequire("4xxiw");

var $deES6 = parcelRequire("deES6");

var $igAso = parcelRequire("igAso");

var $4XOZB = parcelRequire("4XOZB");

var $7KAZ8 = parcelRequire("7KAZ8");

var $5xx1T = parcelRequire("5xx1T");

var $gE7bZ = parcelRequire("gE7bZ");

var $ljQrH = parcelRequire("ljQrH");

var $bATSQ = parcelRequire("bATSQ");

var $7k8Gb = parcelRequire("7k8Gb");

var $idNXT = parcelRequire("idNXT");

var $j9q5r = parcelRequire("j9q5r");

var $gA2tj = parcelRequire("gA2tj");

var $iWvmU = parcelRequire("iWvmU");

var $hy4X2 = parcelRequire("hy4X2");

var $1ITbw = parcelRequire("1ITbw");

var $69iaN = parcelRequire("69iaN");

var $3ZMdG = parcelRequire("3ZMdG");

var $hMZD6 = parcelRequire("hMZD6");

var $3caoj = parcelRequire("3caoj");

var $HjPPt = parcelRequire("HjPPt");

var $jXunK = parcelRequire("jXunK");

var $1zsuY = parcelRequire("1zsuY");

var $8e5HJ = parcelRequire("8e5HJ");

var $lnXep = parcelRequire("lnXep");

var $8Ihcy = parcelRequire("8Ihcy");

var $aHV2Z = parcelRequire("aHV2Z");

var $8ZR2S = parcelRequire("8ZR2S");

var $39eBL = parcelRequire("39eBL");

var $5gWL3 = parcelRequire("5gWL3");

var $6JuOP = parcelRequire("6JuOP");

var $aD4Mq = parcelRequire("aD4Mq");

var $7Rmod = parcelRequire("7Rmod");

var $dkFx6 = parcelRequire("dkFx6");

var $3zYtN = parcelRequire("3zYtN");

var $jpYGU = parcelRequire("jpYGU");

var $fFTSq = parcelRequire("fFTSq");

var $bfz8k = parcelRequire("bfz8k");

var $d6pre = parcelRequire("d6pre");

var $60s55 = parcelRequire("60s55");

var $8LOtr = parcelRequire("8LOtr");

var $2R48E = parcelRequire("2R48E");

var $9iRAU = parcelRequire("9iRAU");

var $aRBkT = parcelRequire("aRBkT");

var $lTFOR = parcelRequire("lTFOR");

var $huXgp = parcelRequire("huXgp");

var $h1k78 = parcelRequire("h1k78");
const $155813e4ada9e58c$var$entitiesReducer = (0, $i5N98.combineReducers)({
    cases: (0, $7t2oX.caseEntityReducer),
    meetings: (0, $hKS78.meetingEntityReducer),
    meetingCases: (0, $3vcrm.meetingCaseEntityReducer),
    meetingUsers: (0, $iRUYI.meetingUserEntityReducer),
    users: (0, $bHP5N.userEntityReducer),
    assets: (0, $k7bTN.assetEntityReducer),
    specialties: (0, $bATSQ.specialtiesReducer),
    caseClassification: (0, $7k8Gb.caseClassificationReducer),
    patients: (0, $idNXT.patientsReducer),
    pathways: (0, $j9q5r.pathwaysEntityReducer),
    casePathways: (0, $fFTSq.casePathwaysEntityReducer),
    notifications: (0, $hy4X2.notificationEntityReducer),
    teams: (0, $hMZD6.teamEntityReducer),
    teamUsers: (0, $8ZR2S.teamUserEntityReducer),
    tasks: (0, $3caoj.taskEntityReducer),
    taskResponses: (0, $HjPPt.taskResponseEntityReducer),
    chats: (0, $5gWL3.chatEntityReducer),
    messages: (0, $6JuOP.messageEntityReducer),
    messageAssets: (0, $3zYtN.messageAssetEntityReducer),
    auditEvents: (0, $7Rmod.auditEventsEntityReducer),
    caseSources: (0, $bfz8k.caseSourceEntityReducer),
    sharedAssets: (0, $d6pre.sharedAssetEntityReducer),
    externalUsers: (0, $2R48E.externalUsersEntityReducer),
    patientRadiologyLinks: (0, $9iRAU.patientRadiologyLinkReducer),
    formTemplates: (0, $huXgp.formTemplateEntityReducer)
});
const $155813e4ada9e58c$var$uiReducer = (0, $i5N98.combineReducers)({
    scroll: (0, $3ZMdG.scrollUIReducer),
    nav: (0, $ljQrH.navUIReducer),
    liveMeeting: (0, $cCrQC.liveMeetingUIReducer),
    meetings: (0, $7KAZ8.meetingsSearchUIReducer),
    cases: (0, $iWvmU.casesUIReducer),
    users: (0, $gA2tj.usersUIReducer),
    notifications: (0, $1ITbw.notificationsUIReducer),
    tasks: (0, $jXunK.tasksUIReducer),
    addCaseToMeeting: (0, $69iaN.addCaseToMeetingUIReducer),
    patients: (0, $1zsuY.patientsUIReducer),
    patientNew: (0, $8Ihcy.patientNewUIReducer),
    teams: (0, $aHV2Z.teamsSearchUIReducer),
    chats: (0, $39eBL.chatsUIReducer),
    messages: (0, $aD4Mq.messagesUIReducer),
    pathways: (0, $dkFx6.pathwaysUIReducer),
    addPathwayToCase: (0, $jpYGU.addPathwayToCaseUIReducer),
    userCheck: (0, $60s55.userCheckUIReducer),
    analytics: (0, $8LOtr.analyticsReducer),
    patientRadiologyLink: (0, $aRBkT.patientRadiologyLinkUIReducer),
    addFormToCase: (0, $h1k78.addFormsToCaseUIReducer)
});
const $155813e4ada9e58c$var$wrapReducer = (reducer)=>(state, action)=>{
        if (action.type == (0, $8e5HJ.UserActionTypes).SET_TENANT_ASYNC_SUCCESS || action.type == (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_SUCCESS) return reducer(undefined, action);
        return reducer(state, action);
    };
const $155813e4ada9e58c$var$appReducer = (0, $i5N98.combineReducers)({
    entities: $155813e4ada9e58c$var$wrapReducer($155813e4ada9e58c$var$entitiesReducer),
    ui: $155813e4ada9e58c$var$wrapReducer($155813e4ada9e58c$var$uiReducer),
    userSession: (0, $4Bn9h.userSessionReducer),
    tenantConfig: $155813e4ada9e58c$var$wrapReducer((0, $6mKzG.tenantConfigReducer)),
    userConfig: $155813e4ada9e58c$var$wrapReducer((0, $9OAyG.userConfigReducer)),
    liveMeetingConfig: $155813e4ada9e58c$var$wrapReducer((0, $akDEs.liveMeetingConfigReducer)),
    webRTC: (0, $i5N98.combineReducers)({
        session: (0, $4xxiw.webRTCSessionReducer),
        publisher: (0, $deES6.webRTCPublisherReducer),
        streams: (0, $4XOZB.webRTCStreamReducer),
        screenShare: (0, $5xx1T.webRTCScreenShareReducer),
        audioDevices: (0, $gE7bZ.webRTCAudioDeviceReducer),
        errors: (0, $lTFOR.webRTCErrorReducer)
    }),
    userMessage: $155813e4ada9e58c$var$wrapReducer((0, $igAso.userMessageReducer))
});
var $155813e4ada9e58c$export$2e2bcd8739ae039 = $155813e4ada9e58c$var$appReducer;

});
parcelRegister("4Bn9h", function(module, exports) {

$parcel$export(module.exports, "userSessionReducer", () => $fefa6baf110d963a$export$e000d3d9900f9612);

var $lnXep = parcelRequire("lnXep");

var $iLVpj = parcelRequire("iLVpj");
const $fefa6baf110d963a$export$d4c72bab9d6cc13a = {
    id: null,
    apiToken: null,
    signInType: null,
    oauthAuthority: null,
    oauthClientId: null,
    isLoading: false,
    error: null,
    terms: null,
    mfa: {
        sms: {
            requesting: false
        }
    }
};
const $fefa6baf110d963a$export$e000d3d9900f9612 = (state = $fefa6baf110d963a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_PENDING:
            return {
                ...state,
                mfa: {
                    sms: {
                        requesting: true
                    }
                }
            };
        case (0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_SUCCESS:
        case (0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_ERROR:
            return {
                ...state,
                mfa: {
                    sms: {
                        requesting: false
                    }
                }
            };
        case (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_PENDING:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        // FIXME: I introduced this for Oauth, but this shouldn't be here. Leaving it for now, as a reminder
        //
        // case UserActionTypes.FETCH_USER_ASYNC_SUCCESS:
        //   console.log(action.payload.result)
        //   return {
        //     ...state,
        //     id: action.payload.result
        //   }
        case (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.session,
                isLoading: false,
                error: null
            };
        case (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_SUCCESS:
            return $fefa6baf110d963a$export$d4c72bab9d6cc13a;
        case (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.statusText
            };
        case (0, $lnXep.AccountActionTypes).USER_SIGN_IN_TYPE_ASYNC_SUCCESS:
            return {
                ...state,
                signInType: action.payload.signInType,
                oauthAuthority: action.payload.authority,
                oauthClientId: action.payload.clientId
            };
        case (0, $lnXep.AccountActionTypes).SEND_RESET_PASSWORD_LINK_ASYNC_SUCCESS:
            return $fefa6baf110d963a$export$d4c72bab9d6cc13a;
        case (0, $lnXep.AccountActionTypes).FETCH_TERMS_ASYNC_SUCCESS:
            return {
                ...state,
                terms: action.payload
            };
        default:
            return {
                ...state
            };
    }
};

});
parcelRegister("lnXep", function(module, exports) {

$parcel$export(module.exports, "AccountActionTypes", () => $f19f51c2d0abbcb5$export$560ad5b3f634a866);
// State
var $f19f51c2d0abbcb5$export$560ad5b3f634a866 = /*#__PURE__*/ function(AccountActionTypes) {
    AccountActionTypes["SET_PASSWORD_ASYNC_PENDING"] = "@@account/SET_PASSWORD_ASYNC_REQUEST";
    AccountActionTypes["SET_PASSWORD_ASYNC_SUCCESS"] = "@@account/SET_PASSWORD_ASYNC_SUCCESS";
    AccountActionTypes["SET_PASSWORD_ASYNC_ERROR"] = "@@account/SET_PASSWORD_ASYNC_ERROR";
    AccountActionTypes["PREPARE_TOTP_ASYNC_PENDING"] = "@@account/SETUP_TOTP_ASYNC_REQUEST";
    AccountActionTypes["PREPARE_TOTP_ASYNC_SUCCESS"] = "@@account/SETUP_TOTP_ASYNC_SUCCESS";
    AccountActionTypes["PREPARE_TOTP_ASYNC_ERROR"] = "@@account/SETUP_TOTP_ASYNC_ERROR";
    AccountActionTypes["VERIFY_MFA_ASYNC_PENDING"] = "@@account/VERIFY_MFA_ASYNC_REQUEST";
    AccountActionTypes["VERIFY_MFA_ASYNC_SUCCESS"] = "@@account/VERIFY_MFA_ASYNC_SUCCESS";
    AccountActionTypes["VERIFY_MFA_ASYNC_ERROR"] = "@@account/VERIFY_MFA_ASYNC_ERROR";
    AccountActionTypes["SEND_RESET_PASSWORD_LINK_ASYNC_PENDING"] = "@@account/SEND_RESET_PASSWORD_LINK_ASYNC_REQUEST";
    AccountActionTypes["SEND_RESET_PASSWORD_LINK_ASYNC_SUCCESS"] = "@@account/SEND_RESET_PASSWORD_LINK_ASYNC_SUCCESS";
    AccountActionTypes["SEND_RESET_PASSWORD_LINK_ASYNC_ERROR"] = "@@account/SEND_RESET_PASSWORD_LINK_ASYNC_ERROR";
    AccountActionTypes["SIGN_IN_USER_ASYNC_PENDING"] = "@@account/SIGN_IN_USER_ASYNC_REQUEST";
    AccountActionTypes["SIGN_IN_USER_ASYNC_SUCCESS"] = "@@account/SIGN_IN_USER_ASYNC_SUCCESS";
    AccountActionTypes["SIGN_IN_USER_ASYNC_ERROR"] = "@@account/SIGN_IN_USER_ASYNC_ERROR";
    AccountActionTypes["SIGN_IN_SWAP_OAUTH_TOKEN"] = "@@account/SIGN_IN_SWAP_OAUTH_TOKEN";
    AccountActionTypes["SIGN_OUT_USER_ASYNC_PENDING"] = "@@account/SIGN_OUT_USER_ASYNC_REQUEST";
    AccountActionTypes["SIGN_OUT_USER_ASYNC_SUCCESS"] = "@@account/SIGN_OUT_USER_ASYNC_SUCCESS";
    AccountActionTypes["SIGN_OUT_USER_ASYNC_ERROR"] = "@@account/SIGN_OUT_USER_ASYNC_ERROR";
    AccountActionTypes["USER_SIGN_IN_TYPE_ASYNC_PENDING"] = "@@account/USER_SIGN_IN_TYPE_ASYNC_PENDING";
    AccountActionTypes["USER_SIGN_IN_TYPE_ASYNC_SUCCESS"] = "@@account/USER_SIGN_IN_TYPE_ASYNC_SUCCESS";
    AccountActionTypes["USER_SIGN_IN_TYPE_ASYNC_ERROR"] = "@@account/USER_SIGN_IN_TYPE_ASYNC_ERROR";
    AccountActionTypes["FETCH_TERMS_ASYNC_PENDING"] = "@@account/FETCH_TERMS_ASYNC_REQUEST";
    AccountActionTypes["FETCH_TERMS_ASYNC_SUCCESS"] = "@@account/FETCH_TERMS_ASYNC_SUCCESS";
    AccountActionTypes["FETCH_TERMS_ASYNC_ERROR"] = "@@account/FETCH_TERMS_ASYNC_ERROR";
    AccountActionTypes["ACCEPT_TERMS_ASYNC_PENDING"] = "@@account/ACCEPT_TERMS_ASYNC_REQUEST";
    AccountActionTypes["ACCEPT_TERMS_ASYNC_SUCCESS"] = "@@account/ACCEPT_TERMS_ASYNC_SUCCESS";
    AccountActionTypes["ACCEPT_TERMS_ASYNC_ERROR"] = "@@account/ACCEPT_TERMS_ASYNC_ERROR";
    return AccountActionTypes;
}({});

});


parcelRegister("9OAyG", function(module, exports) {

$parcel$export(module.exports, "userConfigReducer", () => $e264e70c5c1df9a5$export$6362a9749a0ee7e0);

var $f1q41 = parcelRequire("f1q41");

var $jF0Xa = parcelRequire("jF0Xa");

var $1Lj4p = parcelRequire("1Lj4p");

var $93tzC = parcelRequire("93tzC");
const $e264e70c5c1df9a5$export$d4c72bab9d6cc13a = (0, $1Lj4p.userConfigContextInitialState);
const $e264e70c5c1df9a5$export$6362a9749a0ee7e0 = (state = $e264e70c5c1df9a5$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $jF0Xa.SharedActionTypes).REHYDRATE:
            if (!action.payload?.userConfig) return {
                ...state
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.userConfig);
        case (0, $93tzC.UserConfigActionTypes).FETCH_USER_CONFIG_ASYNC_SUCCESS:
        case (0, $93tzC.UserConfigActionTypes).UPDATE_USER_CONFIG_ASYNC_SUCCESS:
            // only keeps state value if payload value is null
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mergeWith({}, state, action.payload, (stateValue, payloadValue)=>payloadValue === null ? stateValue : undefined);
        case (0, $93tzC.UserConfigActionTypes).UPDATE_UI_SETTING_ASYNC_PENDING:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, {
                uiSettings: action.payload.data
            });
        default:
            return {
                ...state
            };
    }
};

});

parcelRegister("7t2oX", function(module, exports) {

$parcel$export(module.exports, "caseEntityReducer", () => $14b7a94cfe74f538$export$cecb959a8a53f742);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $32kQ2 = parcelRequire("32kQ2");

var $bal3N = parcelRequire("bal3N");

var $cCibL = parcelRequire("cCibL");

var $6qYxq = parcelRequire("6qYxq");

var $7twpo = parcelRequire("7twpo");

var $bP3DF = parcelRequire("bP3DF");

var $7YL61 = parcelRequire("7YL61");

var $dbP5t = parcelRequire("dbP5t");

var $aif7R = parcelRequire("aif7R");

var $el6QJ = parcelRequire("el6QJ");

var $4VdtH = parcelRequire("4VdtH");

var $55aym = parcelRequire("55aym");

var $5dOcp = parcelRequire("5dOcp");

var $udwHW = parcelRequire("udwHW");
const $14b7a94cfe74f538$export$acc42f961369cecb = {};
const $14b7a94cfe74f538$export$2dee9bf55024b46d = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $14b7a94cfe74f538$var$latestTaskResponseAssetId = (payload)=>{
    const allTaskResponses = payload.all.entities.taskResponses;
    const allTasks = payload.all.entities.tasks;
    const task = allTasks[payload.taskId];
    const latestTaskResponseId = task.taskResponses[0];
    const latestTaskResponse = allTaskResponses[latestTaskResponseId];
    return latestTaskResponse.asset ? [
        latestTaskResponse.asset
    ] : [];
};
const $14b7a94cfe74f538$export$a1920133d5b0a75 = (state = $14b7a94cfe74f538$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.cases);
        case (0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_SUCCESS:
            {
                const newState = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.cases);
                return {
                    ...newState,
                    [action.payload.result]: {
                        ...newState[action.payload.result],
                        members: action.payload.entities.cases[action.payload.result].members
                    }
                };
            }
        case (0, $6qYxq.CaseActionTypes).TOGGLE_CASE_LOCKED_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.cases);
        case (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_SUCCESS:
            // This is similar to the CREATE_CASE_COMMENT and _RECOMMENDATION, but
            // when this result is empty, we need to set it, as is is always correct,
            // even when empty
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    assets: action.payload.all.result
                }
            };
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_SUCCESS:
        case (0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    assets: action.payload.all.result
                }
            };
        case (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    assets: [
                        action.payload.all.result,
                        ...state[action.payload.caseId].assets || []
                    ]
                }
            };
        case (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    outstandingTaskCount: action.payload.all.entities.tasks[action.payload.taskId].case.outstandingTaskCount,
                    assets: [
                        ...$14b7a94cfe74f538$var$latestTaskResponseAssetId(action.payload),
                        ...state[action.payload.caseId].assets || []
                    ]
                }
            };
        case (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    tasks: action.payload.all.result
                }
            };
        case (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    outstandingTaskCount: action.payload.all.entities.tasks[action.payload.all.result].case.outstandingTaskCount,
                    tasks: [
                        action.payload.all.result,
                        ...state[action.payload.caseId].tasks || []
                    ]
                }
            };
        case (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    tasks: action.payload.all.result
                }
            };
        case (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    casePathways: action.payload.all.result
                }
            };
        case (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    casePathways: [
                        action.payload.all.result,
                        ...state[action.payload.caseId].casePathways || []
                    ],
                    tasks: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(Object.keys(action.payload.all.entities.tasks || {}), state[action.payload.caseId].tasks || []))
                }
            };
        case (0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_SUCCESS:
        case (0, $6qYxq.CaseActionTypes).UPDATE_CASE_MEMBERS_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    members: action.payload.all.entities.cases[action.payload.caseId].members
                }
            };
        case (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_SUCCESS:
        case (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.cases);
        case (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.entities.cases)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    meetings: action.payload.all.entities.cases[action.payload.caseId].meetings
                }
            };
        case (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.caseId]: {
                    ...state[action.payload.caseId],
                    meetings: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).remove(state[action.payload.caseId].meetings, (meetingId)=>{
                        return meetingId !== action.payload.meetingId;
                    })
                }
            };
        default:
            return {
                ...state
            };
    }
};
const $14b7a94cfe74f538$export$a3c51a603cf683c5 = (state = $14b7a94cfe74f538$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result));
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.cases || [])));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.cases || [])));
        default:
            return state;
    }
};
const $14b7a94cfe74f538$export$cecb959a8a53f742 = (0, $i5N98.combineReducers)({
    byId: $14b7a94cfe74f538$export$a1920133d5b0a75,
    allIds: $14b7a94cfe74f538$export$a3c51a603cf683c5
});

});
parcelRegister("bal3N", function(module, exports) {

$parcel$export(module.exports, "MeetingsActionTypes", () => $0764c0954e73daab$export$da56f5e8d28a7299);
var $0764c0954e73daab$export$da56f5e8d28a7299 = /*#__PURE__*/ function(MeetingsActionTypes) {
    MeetingsActionTypes["FETCH_MEETINGS_ASYNC_PENDING"] = "@@meetings/FETCH_MEETINGS_ASYNC_PENDING";
    MeetingsActionTypes["FETCH_MEETINGS_ASYNC_SUCCESS"] = "@@meetings/FETCH_MEETINGS_ASYNC_SUCCESS";
    MeetingsActionTypes["FETCH_MEETINGS_ASYNC_ERROR"] = "@@meetings/FETCH_MEETINGS_ASYNC_ERROR";
    MeetingsActionTypes["TOGGLE_LIST_VIEW"] = "@@meetings/TOGGLE_LIST_VIEW";
    MeetingsActionTypes["FETCH_MEETINGS_IN_RANGE_ASYNC_PENDING"] = "@@meetings/FETCH_MEETINGS_IN_RANGE_ASYNC_PENDING";
    MeetingsActionTypes["FETCH_MEETINGS_IN_RANGE_ASYNC_ERROR"] = "@@meetings/FETCH_MEETINGS_IN_RANGE_ASYNC_ERROR";
    MeetingsActionTypes["FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS"] = "@@meetings/FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS";
    return MeetingsActionTypes;
}({});

});

parcelRegister("cCibL", function(module, exports) {

$parcel$export(module.exports, "CasesActionTypes", () => $c4fc514f54bf792e$export$ed360331fc1995d1);
var $c4fc514f54bf792e$export$ed360331fc1995d1 = /*#__PURE__*/ function(CasesActionTypes) {
    CasesActionTypes["FETCH_CASES_ASYNC_PENDING"] = "@@cases/FETCH_CASES_ASYNC_PENDING";
    CasesActionTypes["FETCH_CASES_ASYNC_SUCCESS"] = "@@cases/FETCH_CASES_ASYNC_SUCCESS";
    CasesActionTypes["FETCH_CASES_ASYNC_ERROR"] = "@@cases/FETCH_CASES_ASYNC_ERROR";
    return CasesActionTypes;
}({});

});

parcelRegister("bP3DF", function(module, exports) {

$parcel$export(module.exports, "MeetingCaseRecommendationStatus", () => $7008fe9aed0d8ef5$export$6eaa6d434003a6a0);
$parcel$export(module.exports, "MeetingCaseActionTypes", () => $7008fe9aed0d8ef5$export$1a4a755c4f2320d2);
$parcel$export(module.exports, "MeetingCaseCableActionTypes", () => $7008fe9aed0d8ef5$export$bd6e6b1183a8e928);
$parcel$export(module.exports, "MeetingCaseChannelName", () => $7008fe9aed0d8ef5$export$d837e36cc43fcb31);
$parcel$export(module.exports, "MeetingCaseCablePrefix", () => $7008fe9aed0d8ef5$export$31b278e1165ebf55);
var $7008fe9aed0d8ef5$export$6eaa6d434003a6a0 = /*#__PURE__*/ function(MeetingCaseRecommendationStatus) {
    MeetingCaseRecommendationStatus["DEFERRED"] = "deferred";
    MeetingCaseRecommendationStatus["RECOMMENDED"] = "recommended";
    MeetingCaseRecommendationStatus["RECOMMENDATION_PENDING"] = "pending";
    return MeetingCaseRecommendationStatus;
}({});
var $7008fe9aed0d8ef5$export$1a4a755c4f2320d2 = /*#__PURE__*/ function(MeetingCaseActionTypes) {
    MeetingCaseActionTypes["FETCH_MEETING_CASE_ASYNC_PENDING"] = "@@meetingCase/FETCH_MEETING_CASE_ASYNC_PENDING";
    MeetingCaseActionTypes["FETCH_MEETING_CASE_ASYNC_SUCCESS"] = "@@meetingCase/FETCH_MEETING_CASE_ASYNC_SUCCESS";
    MeetingCaseActionTypes["FETCH_MEETING_CASE_ASYNC_ERROR"] = "@@meetingCase/FETCH_MEETING_CASE_ASYNC_ERROR";
    MeetingCaseActionTypes["CREATE_MEETING_CASE_ASYNC_PENDING"] = "@@meeting/CREATE_MEETING_CASE_ASYNC_PENDING";
    MeetingCaseActionTypes["CREATE_MEETING_CASE_ASYNC_SUCCESS"] = "@@meeting/CREATE_MEETING_CASE_ASYNC_SUCCESS";
    MeetingCaseActionTypes["CREATE_MEETING_CASE_ASYNC_ERROR"] = "@@meeting/CREATE_MEETING_CASE_ASYNC_ERROR";
    MeetingCaseActionTypes["DELETE_MEETING_CASE_ASYNC_PENDING"] = "@@meeting/DELETE_MEETING_CASE_ASYNC_PENDING";
    MeetingCaseActionTypes["DELETE_MEETING_CASE_ASYNC_SUCCESS"] = "@@meeting/DELETE_MEETING_CASE_ASYNC_SUCCESS";
    MeetingCaseActionTypes["DELETE_MEETING_CASE_ASYNC_ERROR"] = "@@meeting/DELETE_MEETING_CASE_ASYNC_ERROR";
    return MeetingCaseActionTypes;
}({});
var $7008fe9aed0d8ef5$export$bd6e6b1183a8e928 = /*#__PURE__*/ function(MeetingCaseCableActionTypes) {
    MeetingCaseCableActionTypes["ASSETS_CHANGED"] = "@@meetingCaseCable/ASSETS_CHANGED";
    return MeetingCaseCableActionTypes;
}({});
const $7008fe9aed0d8ef5$export$d837e36cc43fcb31 = "MeetingCaseChannel";
const $7008fe9aed0d8ef5$export$31b278e1165ebf55 = "@@meetingCaseCable/";

});

parcelRegister("7YL61", function(module, exports) {

$parcel$export(module.exports, "AddCaseToMeetingActionTypes", () => $5f749b045f534694$export$cebe91d6f82583b9);
var $5f749b045f534694$export$cebe91d6f82583b9 = /*#__PURE__*/ function(AddCaseToMeetingActionTypes) {
    AddCaseToMeetingActionTypes["FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_PENDING"] = "@@addCaseToMeeting/FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_PENDING";
    AddCaseToMeetingActionTypes["FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS"] = "@@addCaseToMeeting/FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS";
    AddCaseToMeetingActionTypes["FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_ERROR"] = "@@addCaseToMeeting/FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_ERROR";
    return AddCaseToMeetingActionTypes;
}({});

});

parcelRegister("dbP5t", function(module, exports) {

$parcel$export(module.exports, "TasksOrderByOptions", () => $d450e4f845048704$export$825b2c6fb06d021e);
$parcel$export(module.exports, "TasksActionTypes", () => $d450e4f845048704$export$914fb97b68f044e3);
$parcel$export(module.exports, "tasksCableActionTypes", () => $d450e4f845048704$export$546fa23aa4e20da2);
var $d450e4f845048704$export$825b2c6fb06d021e = /*#__PURE__*/ function(TasksOrderByOptions) {
    TasksOrderByOptions["CreatedAtDesc"] = "created_at_desc";
    TasksOrderByOptions["CreatedAtAsc"] = "created_at_asc";
    TasksOrderByOptions["UpdatedAtDesc"] = "updated_at_desc";
    TasksOrderByOptions["DueDateAsc"] = "due_date_asc";
    return TasksOrderByOptions;
}({});
var $d450e4f845048704$export$914fb97b68f044e3 = /*#__PURE__*/ function(TasksActionTypes) {
    TasksActionTypes["FETCH_CASE_TASKS_ASYNC_PENDING"] = "@@tasks/FETCH_CASE_TASKS_ASYNC_PENDING";
    TasksActionTypes["FETCH_CASE_TASKS_ASYNC_SUCCESS"] = "@@tasks/FETCH_CASE_TASKS_ASYNC_SUCCESS";
    TasksActionTypes["FETCH_CASE_TASKS_ASYNC_ERROR"] = "@@tasks/FETCH_CASE_TASKS_ASYNC_ERROR";
    TasksActionTypes["CREATE_CASE_TASK_ASYNC_PENDING"] = "@@tasks/CREATE_CASE_TASK_ASYNC_PENDING";
    TasksActionTypes["CREATE_CASE_TASK_ASYNC_SUCCESS"] = "@@tasks/CREATE_CASE_TASK_ASYNC_SUCCESS";
    TasksActionTypes["CREATE_CASE_TASK_ASYNC_ERROR"] = "@@tasks/CREATE_CASE_TASK_ASYNC_ERROR";
    TasksActionTypes["DELETE_CASE_TASK_ASYNC_PENDING"] = "@@tasks/DELETE_CASE_TASK_ASYNC_PENDING";
    TasksActionTypes["DELETE_CASE_TASK_ASYNC_SUCCESS"] = "@@tasks/DELETE_CASE_TASK_ASYNC_SUCCESS";
    TasksActionTypes["DELETE_CASE_TASK_ASYNC_ERROR"] = "@@tasks/DELETE_CASE_TASK_ASYNC_ERROR";
    TasksActionTypes["FETCH_TASKS_ASYNC_PENDING"] = "@@tasks/FETCH_TASKS_ASYNC_PENDING";
    TasksActionTypes["FETCH_TASKS_ASYNC_SUCCESS"] = "@@tasks/FETCH_TASKS_ASYNC_SUCCESS";
    TasksActionTypes["FETCH_TASKS_ASYNC_ERROR"] = "@@tasks/FETCH_TASKS_ASYNC_ERROR";
    return TasksActionTypes;
}({});
var $d450e4f845048704$export$546fa23aa4e20da2 = /*#__PURE__*/ function(tasksCableActionTypes) {
    // INBOUND
    tasksCableActionTypes["UPDATE_OUTSTANDING_COUNT"] = "@@userCable/tasks/UPDATE_OUTSTANDING_COUNT";
    return tasksCableActionTypes;
}({});

});

parcelRegister("aif7R", function(module, exports) {

$parcel$export(module.exports, "TaskResponseActionTypes", () => $5a948b9309e1f8ca$export$5f52a02cabeb5e73);
var $5a948b9309e1f8ca$export$5f52a02cabeb5e73 = /*#__PURE__*/ function(TaskResponseActionTypes) {
    TaskResponseActionTypes["CREATE_CASE_TASK_RESPONSE_ASYNC_PENDING"] = "@@taskResponses/CREATE_CASE_TASK_RESPONSE_ASYNC_PENDING";
    TaskResponseActionTypes["CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS"] = "@@taskResponses/CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS";
    TaskResponseActionTypes["CREATE_CASE_TASK_RESPONSE_ASYNC_ERROR"] = "@@taskResponses/CREATE_CASE_TASK_RESPONSE_ASYNC_ERROR";
    return TaskResponseActionTypes;
}({});

});

parcelRegister("el6QJ", function(module, exports) {

$parcel$export(module.exports, "AmendmentTypes", () => $26b3656216226f8c$export$dda502571ab2d51a);
$parcel$export(module.exports, "PatientTitles", () => $26b3656216226f8c$export$3e5592859d86af73);
$parcel$export(module.exports, "PatientGenders", () => $26b3656216226f8c$export$db13627ab7884d13);
$parcel$export(module.exports, "PatientActionTypes", () => $26b3656216226f8c$export$3c9e6abdf399cb76);
var $26b3656216226f8c$export$dda502571ab2d51a = /*#__PURE__*/ function(AmendmentTypes) {
    AmendmentTypes["ErrorCorrection"] = "error_correction";
    AmendmentTypes["RecordUpdate"] = "record_update";
    return AmendmentTypes;
}({});
var $26b3656216226f8c$export$3e5592859d86af73 = /*#__PURE__*/ function(PatientTitles) {
    PatientTitles["Mr"] = "mr";
    PatientTitles["Mrs"] = "mrs";
    PatientTitles["Ms"] = "ms";
    PatientTitles["Miss"] = "miss";
    PatientTitles["Mx"] = "mx";
    PatientTitles["Dr"] = "dr";
    PatientTitles["Prof"] = "prof";
    return PatientTitles;
}({});
var $26b3656216226f8c$export$db13627ab7884d13 = /*#__PURE__*/ function(PatientGenders) {
    PatientGenders["Unknown"] = "unknown";
    PatientGenders["Unspecified"] = "unspecified";
    PatientGenders["Male"] = "male";
    PatientGenders["Female"] = "female";
    PatientGenders["OtherSpecific"] = "other_specific";
    return PatientGenders;
}({});
var $26b3656216226f8c$export$3c9e6abdf399cb76 = /*#__PURE__*/ function(PatientActionTypes) {
    PatientActionTypes["FETCH_PATIENT_ASYNC_PENDING"] = "@@case/FETCH_PATIENT_ASYNC_PENDING";
    PatientActionTypes["FETCH_PATIENT_ASYNC_SUCCESS"] = "@@case/FETCH_PATIENT_ASYNC_SUCCESS";
    PatientActionTypes["FETCH_PATIENT_ASYNC_ERROR"] = "@@case/FETCH_PATIENT_ASYNC_ERROR";
    return PatientActionTypes;
}({});

});

parcelRegister("4VdtH", function(module, exports) {

$parcel$export(module.exports, "ChatsActionTypes", () => $fa9638eb6124b4aa$export$8ae9aafa5eb58cc1);
var $fa9638eb6124b4aa$export$8ae9aafa5eb58cc1 = /*#__PURE__*/ function(ChatsActionTypes) {
    ChatsActionTypes["UPDATED_SELECTED_CHAT_ID"] = "@@chats/UPDATED_SELECTED_CHAT_ID";
    ChatsActionTypes["FETCH_CHATS_ASYNC_PENDING"] = "@@chats/FETCH_CHATS_ASYNC_PENDING";
    ChatsActionTypes["FETCH_CHATS_ASYNC_SUCCESS"] = "@@chats/FETCH_CHATS_ASYNC_SUCCESS";
    ChatsActionTypes["FETCH_CHATS_ASYNC_ERROR"] = "@@chats/FETCH_CHATS_ASYNC_ERROR";
    return ChatsActionTypes;
}({});

});

parcelRegister("55aym", function(module, exports) {

$parcel$export(module.exports, "PatientsOrderByOptions", () => $509173d0488bfa40$export$e8c42dbea10a4394);
$parcel$export(module.exports, "PatientsActionTypes", () => $509173d0488bfa40$export$87aa7b00f01dd660);
var $509173d0488bfa40$export$e8c42dbea10a4394 = /*#__PURE__*/ function(PatientsOrderByOptions) {
    PatientsOrderByOptions["CreatedAtDesc"] = "created_at_desc";
    PatientsOrderByOptions["CreatedAtAsc"] = "created_at_asc";
    PatientsOrderByOptions["UpdatedAtDesc"] = "updated_at_desc";
    return PatientsOrderByOptions;
}({});
var $509173d0488bfa40$export$87aa7b00f01dd660 = /*#__PURE__*/ function(PatientsActionTypes) {
    PatientsActionTypes["FETCH_PATIENTS_ASYNC_PENDING"] = "@@patients/FETCH_PATIENTS_ASYNC_PENDING";
    PatientsActionTypes["FETCH_PATIENTS_ASYNC_SUCCESS"] = "@@patients/FETCH_PATIENTS_ASYNC_SUCCESS";
    PatientsActionTypes["FETCH_PATIENTS_ASYNC_ERROR"] = "@@patients/FETCH_PATIENTS_ASYNC_ERROR";
    PatientsActionTypes["FETCH_ALL_PATIENTS_ASYNC_PENDING"] = "@@patients/FETCH_ALL_PATIENTS_ASYNC_PENDING";
    PatientsActionTypes["FETCH_ALL_PATIENTS_ASYNC_SUCCESS"] = "@@patients/FETCH_ALL_PATIENTS_ASYNC_SUCCESS";
    PatientsActionTypes["FETCH_ALL_PATIENTS_ASYNC_ERROR"] = "@@patients/FETCH_ALL_PATIENTS_ASYNC_ERROR";
    PatientsActionTypes["UPLOAD_PATIENTS_CSV_ASYNC_PENDING"] = "@@patients/UPLOAD_PATIENTS_CSV_ASYNC_PENDING";
    PatientsActionTypes["UPLOAD_PATIENTS_CSV_ASYNC_SUCCESS"] = "@@patients/UPLOAD_PATIENTS_CSV_ASYNC_SUCCESS";
    PatientsActionTypes["UPLOAD_PATIENTS_CSV_ASYNC_ERROR"] = "@@patients/UPLOAD_PATIENTS_CSV_ASYNC_ERROR";
    return PatientsActionTypes;
}({});

});

parcelRegister("5dOcp", function(module, exports) {

$parcel$export(module.exports, "CasePathwaysActionTypes", () => $b3bc9d043f569fa6$export$b22b90ea19d861ea);
var $b3bc9d043f569fa6$export$b22b90ea19d861ea = /*#__PURE__*/ function(CasePathwaysActionTypes) {
    CasePathwaysActionTypes["FETCH_CASE_PATHWAYS_ASYNC_PENDING"] = "@@casePathways/FETCH_CASE_PATHWAYS_ASYNC_PENDING";
    CasePathwaysActionTypes["FETCH_CASE_PATHWAYS_ASYNC_SUCCESS"] = "@@casePathways/FETCH_CASE_PATHWAYS_ASYNC_SUCCESS";
    CasePathwaysActionTypes["FETCH_CASE_PATHWAYS_ASYNC_ERROR"] = "@@casePathways/FETCH_CASE_PATHWAYS_ASYNC_ERROR";
    CasePathwaysActionTypes["CREATE_CASE_PATHWAY_ASYNC_PENDING"] = "@@casePathways/CREATE_CASE_PATHWAY_ASYNC_PENDING";
    CasePathwaysActionTypes["CREATE_CASE_PATHWAY_ASYNC_SUCCESS"] = "@@casePathways/CREATE_CASE_PATHWAY_ASYNC_SUCCESS";
    CasePathwaysActionTypes["CREATE_CASE_PATHWAY_ASYNC_ERROR"] = "@@casePathways/CREATE_CASE_PATHWAY_ASYNC_ERROR";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_ASYNC_PENDING"] = "@@casePathways/UPDATE_CASE_PATHWAY_ASYNC_PENDING";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_ASYNC_SUCCESS"] = "@@casePathways/UPDATE_CASE_PATHWAY_ASYNC_SUCCESS";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_ASYNC_ERROR"] = "@@casePathways/UPDATE_CASE_PATHWAY_ASYNC_ERROR";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_TASK_ASYNC_PENDING"] = "@@casePathways/UPDATE_CASE_PATHWAY_TASK_ASYNC_PENDING";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_TASK_ASYNC_SUCCESS"] = "@@casePathways/UPDATE_CASE_PATHWAY_TASK_ASYNC_SUCCESS";
    CasePathwaysActionTypes["UPDATE_CASE_PATHWAY_TASK_ASYNC_ERROR"] = "@@casePathways/UPDATE_CASE_PATHWAY_TASK_ASYNC_ERROR";
    return CasePathwaysActionTypes;
}({});

});

parcelRegister("udwHW", function(module, exports) {

$parcel$export(module.exports, "AddFormToCaseActionTypes", () => $0c317d7a6d279415$export$2264fc592dfde7af);
var $0c317d7a6d279415$export$2264fc592dfde7af = /*#__PURE__*/ function(AddFormToCaseActionTypes) {
    AddFormToCaseActionTypes["FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING"] = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_PENDING";
    AddFormToCaseActionTypes["FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS"] = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_SUCCESS";
    AddFormToCaseActionTypes["FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_ERROR"] = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_ERROR";
    AddFormToCaseActionTypes["CREATE_FORM_FOR_CASE_ASYNC_PENDING"] = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_PENDING";
    AddFormToCaseActionTypes["CREATE_FORM_FOR_CASE_ASYNC_SUCCESS"] = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_SUCCESS";
    AddFormToCaseActionTypes["CREATE_FORM_FOR_CASE_ASYNC_ERROR"] = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_ERROR";
    AddFormToCaseActionTypes["MARK_FORM_COMPLETE_ASYNC_PENDING"] = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_PENDING";
    AddFormToCaseActionTypes["MARK_FORM_COMPLETE_ASYNC_SUCCESS"] = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_SUCCESS";
    AddFormToCaseActionTypes["MARK_FORM_COMPLETE_ASYNC_ERROR"] = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_ERROR";
    return AddFormToCaseActionTypes;
}({});

});


parcelRegister("cCrQC", function(module, exports) {

$parcel$export(module.exports, "liveMeetingUIReducer", () => $f6418fc56483c673$export$23a72185aa64c752);

var $j0qQC = parcelRequire("j0qQC");

var $jF0Xa = parcelRequire("jF0Xa");
const $f6418fc56483c673$export$d4c72bab9d6cc13a = {
    isSplitScreen: true,
    selectedYourViewTab: (0, $j0qQC.YourViewTabs).USERS_VIEW,
    selectedUsersViewTab: (0, $j0qQC.UsersViewTabs).GRID,
    isYourViewAssetListOpen: false,
    yourViewSelectedAssetId: null
};
const $f6418fc56483c673$export$23a72185aa64c752 = (state = $f6418fc56483c673$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $jF0Xa.SharedActionTypes).REHYDRATE:
            if (!action.payload?.ui.liveMeeting) return {
                ...state
            };
            return {
                ...state,
                ...action.payload.ui.liveMeeting
            };
        case (0, $j0qQC.LiveMeetingActionTypes).TOGGLE_SPLIT_SCREEN:
            return {
                ...state,
                isSplitScreen: action.payload
            };
        case (0, $j0qQC.LiveMeetingActionTypes).CHANGE_YOUR_VIEW_TAB:
            return {
                ...state,
                selectedYourViewTab: action.payload
            };
        case (0, $j0qQC.LiveMeetingActionTypes).CHANGE_USERS_VIEW_TAB:
            return {
                ...state,
                selectedUsersViewTab: action.payload
            };
        case (0, $j0qQC.LiveMeetingActionTypes).TOGGLE_YOUR_VIEW_ASSET_LIST_OPEN:
            return {
                ...state,
                isYourViewAssetListOpen: action.payload
            };
        case (0, $j0qQC.LiveMeetingActionTypes).UPDATE_YOUR_VIEW_SELECTED_ASSET:
            return {
                ...state,
                yourViewSelectedAssetId: action.payload
            };
        default:
            return {
                ...state
            };
    }
};

});

parcelRegister("akDEs", function(module, exports) {

$parcel$export(module.exports, "liveMeetingConfigReducer", () => $6a609c60b85224ce$export$a345045f4548fcbf);

var $f1q41 = parcelRequire("f1q41");

var $j0qQC = parcelRequire("j0qQC");

var $jF0Xa = parcelRequire("jF0Xa");

var $fad40 = parcelRequire("fad40");
const $6a609c60b85224ce$export$d4c72bab9d6cc13a = {
    timestamp: 0,
    version: 0,
    userConfigs: {},
    selectedMeetingCaseId: null,
    sharedViewHoveredAssetId: null,
    sharedViewSelectedAssetId: null,
    sharedViewSelectedAssetTypeFilters: null,
    sharedPdfState: {
        rotation: 0
    },
    sharedImageZoomState: {
        zoom: 1,
        posX: 0,
        posY: 0
    },
    coordinatorId: null,
    presenterId: null,
    scribeId: null,
    recommendations: {},
    caseStage: (0, $j0qQC.CaseStage).PRESENTING,
    consents: {},
    speaking: {}
};
const $6a609c60b85224ce$export$a345045f4548fcbf = (state = $6a609c60b85224ce$export$d4c72bab9d6cc13a, action)=>{
    let liveMeetingConfig;
    switch(action.type){
        case (0, $jF0Xa.SharedActionTypes).REHYDRATE:
            if (!action.payload?.liveMeetingConfig) return state;
            if (action.payload.liveMeetingConfig.consents == undefined) action.payload.liveMeetingConfig.consents = {};
            return {
                ...state,
                ...action.payload.liveMeetingConfig
            };
        case (0, $j0qQC.LiveMeetingActionTypes).FETCH_LIVE_MEETING_CONFIG_ASYNC_SUCCESS:
            liveMeetingConfig = $6a609c60b85224ce$var$addUserMeetingRoleProperties(action.payload);
            // these lines below is needed, as the recommendations object is transformed
            // to camelcase by default (because of the axios pipeline we set up).
            // so the line below transforms the keys back to standard uuid format.
            // The same applies to the consents
            liveMeetingConfig.recommendations = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).transform(liveMeetingConfig.recommendations, (result, v, k)=>{
                result[$fad40.addHyphen(k).toLowerCase()] = v;
            });
            liveMeetingConfig.consents = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).transform(liveMeetingConfig.consents, (result, v, k)=>{
                result[$fad40.addHyphen(k).toLowerCase()] = v;
            });
            return {
                ...state,
                ...liveMeetingConfig
            };
        case (0, $j0qQC.LiveMeetingCableActionTypes).SELECT_MEETING_CASE:
            return {
                ...state,
                selectedMeetingCaseId: action.payload,
                caseStage: (0, $j0qQC.CaseStage).PRESENTING
            };
        case (0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_SHARED_VIEW_SELECTED_ASSET:
            return {
                ...state,
                sharedViewSelectedAssetId: action.payload.assetId
            };
        case (0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_SHARED_IMAGE_ZOOM_STATE:
            return {
                ...state,
                sharedImageZoomState: action.payload
            };
        case (0, $j0qQC.LiveMeetingCableActionTypes).TOGGLE_IS_ONLINE:
            return $6a609c60b85224ce$var$updateUserConfig(state, action.payload, "isOnline");
        case (0, $j0qQC.LiveMeetingCableActionTypes).TOGGLE_IS_SHARING_AUDIO:
            return $6a609c60b85224ce$var$updateUserConfig(state, action.payload, "isSharingAudio");
        case (0, $j0qQC.LiveMeetingCableActionTypes).TOGGLE_IS_SHARING_VIDEO:
            return $6a609c60b85224ce$var$updateUserConfig(state, action.payload, "isSharingVideo");
        case (0, $j0qQC.LiveMeetingCableActionTypes).TOGGLE_IS_SHARING_SCREEN:
            return $6a609c60b85224ce$var$updateUserConfig(state, action.payload, "isSharingScreen");
        case (0, $j0qQC.LiveMeetingActionTypes).USER_SPEAKING:
            {
                const speakingNow = action.payload.speakingNow;
                const speakerId = action.payload.userId;
                return {
                    ...state,
                    speaking: {
                        ...state.speaking,
                        [speakerId]: speakingNow
                    }
                };
            }
        case (0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_CONFIG:
            liveMeetingConfig = action.payload;
            if (liveMeetingConfig.version < state.version) return state;
            liveMeetingConfig.userConfigs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mapKeys(liveMeetingConfig.userConfigs, "id");
            liveMeetingConfig = $6a609c60b85224ce$var$addUserMeetingRoleProperties(liveMeetingConfig);
            if (liveMeetingConfig.consents == undefined) liveMeetingConfig.consents = {};
            return {
                ...state,
                ...liveMeetingConfig
            };
        default:
            return state;
    }
};
const $6a609c60b85224ce$var$updateUserConfig = (state, payload, property)=>{
    return {
        ...state,
        userConfigs: {
            ...state.userConfigs,
            [payload.userId]: {
                ...state.userConfigs[payload.userId],
                [property]: payload[property]
            }
        }
    };
};
const $6a609c60b85224ce$var$addUserMeetingRoleProperties = (liveMeetingConfig)=>{
    const userConfigs = liveMeetingConfig.userConfigs;
    let userId;
    for(userId in userConfigs){
        userConfigs[userId].isCoordinator = userId === liveMeetingConfig.coordinatorId;
        userConfigs[userId].isPresenter = userId === liveMeetingConfig.presenterId;
        userConfigs[userId].isScribe = userId === liveMeetingConfig.scribeId;
    }
    return liveMeetingConfig;
};

});
parcelRegister("fad40", function(module, exports) {

$parcel$export(module.exports, "addHyphen", () => $ecc8c8bf4f0ee51c$export$b680b0edf957cf7e);
// copied from https://github.com/YasudaYutaka/uuid-utils/blob/main/src/utils/uuidUtils.js
// which was published under MIT license
const $ecc8c8bf4f0ee51c$export$a4c72ae47296db0c = (uuid)=>{
    const pattern = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
    return pattern.test(uuid);
};
const $ecc8c8bf4f0ee51c$export$c1cd7f573c1d582e = (uuid)=>{
    const pattern = /^[0-9a-fA-F]{32}$/;
    return pattern.test(uuid);
};
const $ecc8c8bf4f0ee51c$export$b680b0edf957cf7e = (uuid)=>$ecc8c8bf4f0ee51c$export$a4c72ae47296db0c(uuid) ? uuid : $ecc8c8bf4f0ee51c$export$c1cd7f573c1d582e(uuid) ? `${uuid.slice(0, 8)}-${uuid.slice(8, 12)}-${uuid.slice(12, 16)}-${uuid.slice(16, 20)}-${uuid.slice(20)}` : "Invalid UUID without hyphen";

});


parcelRegister("hKS78", function(module, exports) {

$parcel$export(module.exports, "meetingEntityReducer", () => $96c3f83376a4d2ba$export$645b510d407f26c);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $32kQ2 = parcelRequire("32kQ2");

var $bal3N = parcelRequire("bal3N");

var $5xpc0 = parcelRequire("5xpc0");

var $bP3DF = parcelRequire("bP3DF");

var $6qYxq = parcelRequire("6qYxq");

var $cCibL = parcelRequire("cCibL");
const $96c3f83376a4d2ba$export$acc42f961369cecb = {};
const $96c3f83376a4d2ba$export$2dee9bf55024b46d = [];
const $96c3f83376a4d2ba$export$a1920133d5b0a75 = (state = $96c3f83376a4d2ba$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.result]: {
                    ...state[action.payload.result],
                    ...action.payload.entities.meetings[action.payload.result]
                }
            };
        case (0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).END_MEETING_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).START_MEETING_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).CANCEL_MEETING_ASYNC_SUCCESS:
        case (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_SUCCESS:
        case (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_SUCCESS:
        case (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_SUCCESS:
        case (0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.meetings);
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.meetings);
        case (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetings || []
            };
        case (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_SUCCESS:
        case (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.meetingId]: {
                    ...state[action.payload.meetingId],
                    ...action.payload.all.entities.meetings[action.payload.meetingId]
                }
            };
        default:
            return {
                ...state
            };
    }
};
const $96c3f83376a4d2ba$export$a3c51a603cf683c5 = (state = $96c3f83376a4d2ba$export$2dee9bf55024b46d, action)=>{
    // the list of ids on the index page has been moved to the meetingsUI. This
    // should only containt the actual list of ALL meetings, not just the ones
    // that are being displayed.
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.all.result));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.all.result));
        default:
            return state;
    }
};
const $96c3f83376a4d2ba$export$645b510d407f26c = (0, $i5N98.combineReducers)({
    byId: $96c3f83376a4d2ba$export$a1920133d5b0a75,
    allIds: $96c3f83376a4d2ba$export$a3c51a603cf683c5
});

});
parcelRegister("5xpc0", function(module, exports) {

$parcel$export(module.exports, "AcceptanceResponses", () => $48b44cbe49a33b85$export$339eb13e6ac04d35);
$parcel$export(module.exports, "MeetingUserActionTypes", () => $48b44cbe49a33b85$export$dcc950b5dbd88cd7);
// Models
var $48b44cbe49a33b85$export$339eb13e6ac04d35 = /*#__PURE__*/ function(AcceptanceResponses) {
    AcceptanceResponses["Accepted"] = "accepted";
    AcceptanceResponses["Rejected"] = "rejected";
    AcceptanceResponses["Pending"] = "pending";
    return AcceptanceResponses;
}({});
var $48b44cbe49a33b85$export$dcc950b5dbd88cd7 = /*#__PURE__*/ function(MeetingUserActionTypes) {
    MeetingUserActionTypes["CREATE_MEETING_USER_ASYNC_PENDING"] = "@@meetingUser/CREATE_MEETING_USER_ASYNC_PENDING";
    MeetingUserActionTypes["CREATE_MEETING_USER_ASYNC_SUCCESS"] = "@@meetingUser/CREATE_MEETING_USER_ASYNC_SUCCESS";
    MeetingUserActionTypes["CREATE_MEETING_USER_ASYNC_ERROR"] = "@@meetingUser/CREATE_MEETING_USER_ASYNC_ERROR";
    MeetingUserActionTypes["UPDATE_MEETING_USER_ASYNC_PENDING"] = "@@meetingUser/UPDATE_MEETING_USER_ASYNC_PENDING";
    MeetingUserActionTypes["UPDATE_MEETING_USER_ASYNC_SUCCESS"] = "@@meetingUser/UPDATE_MEETING_USER_ASYNC_SUCCESS";
    MeetingUserActionTypes["UPDATE_MEETING_USER_ASYNC_ERROR"] = "@@meetingUser/UPDATE_MEETING_USER_ASYNC_ERROR";
    MeetingUserActionTypes["DESTROY_MEETING_USER_ASYNC_PENDING"] = "@@meetingUser/DESTROY_MEETING_USER_ASYNC_PENDING";
    MeetingUserActionTypes["DESTROY_MEETING_USER_ASYNC_SUCCESS"] = "@@meetingUser/DESTROY_MEETING_USER_ASYNC_SUCCESS";
    MeetingUserActionTypes["DESTROY_MEETING_USER_ASYNC_ERROR"] = "@@meetingUser/DESTROY_MEETING_USER_ASYNC_ERROR";
    return MeetingUserActionTypes;
}({});

});


parcelRegister("bHP5N", function(module, exports) {

$parcel$export(module.exports, "userEntityReducer", () => $cd87e59619d03e5d$export$9159299ecfa54b9b);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $32kQ2 = parcelRequire("32kQ2");

var $8e5HJ = parcelRequire("8e5HJ");

var $bal3N = parcelRequire("bal3N");

var $cX1nf = parcelRequire("cX1nf");

var $cCibL = parcelRequire("cCibL");

var $lnXep = parcelRequire("lnXep");

var $bP3DF = parcelRequire("bP3DF");

var $el6QJ = parcelRequire("el6QJ");

var $62Lcu = parcelRequire("62Lcu");

var $1WoI7 = parcelRequire("1WoI7");

var $i78re = parcelRequire("i78re");

var $jF0Xa = parcelRequire("jF0Xa");

var $55aym = parcelRequire("55aym");

var $eGEsd = parcelRequire("eGEsd");

var $eCmSQ = parcelRequire("eCmSQ");

var $6qYxq = parcelRequire("6qYxq");
const $cd87e59619d03e5d$export$acc42f961369cecb = {};
const $cd87e59619d03e5d$export$2dee9bf55024b46d = [];
const $cd87e59619d03e5d$export$a1920133d5b0a75 = (state = $cd87e59619d03e5d$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $lnXep.AccountActionTypes).VERIFY_MFA_ASYNC_SUCCESS:
        case (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_SUCCESS:
        case (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_FOUND:
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
        case (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_SUCCESS:
        case (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_SUCCESS:
        case (0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_SUCCESS:
        case (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_SUCCESS:
        case (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_SUCCESS:
        case (0, $i78re.TenantActionTypes).CREATE_TENANT_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.users);
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.users);
        case (0, $jF0Xa.SharedCableActionTypes).UPDATE_USER_STATUS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload);
        case (0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_SUCCESS:
        case (0, $8e5HJ.UserActionTypes).UPDATE_USER_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case (0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.users);
        case (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.user.entities.users
            };
        default:
            return {
                ...state
            };
    }
};
const $cd87e59619d03e5d$export$a3c51a603cf683c5 = (state = $cd87e59619d03e5d$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.users)));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.users || [])));
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.users || [])));
        case (0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.users)));
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        case (0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.id));
        case (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.user.entities.users)));
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.users || [])));
        default:
            return state;
    }
};
const $cd87e59619d03e5d$export$9159299ecfa54b9b = (0, $i5N98.combineReducers)({
    byId: $cd87e59619d03e5d$export$a1920133d5b0a75,
    allIds: $cd87e59619d03e5d$export$a3c51a603cf683c5
});

});
parcelRegister("cX1nf", function(module, exports) {

$parcel$export(module.exports, "UsersActionTypes", () => $f35eab397f346f51$export$dd069e923557f5b4);
var $f35eab397f346f51$export$dd069e923557f5b4 = /*#__PURE__*/ function(UsersActionTypes) {
    UsersActionTypes["FETCH_USERS_ASYNC_PENDING"] = "@@users/FETCH_USERS_ASYNC_PENDING";
    UsersActionTypes["FETCH_USERS_ASYNC_SUCCESS"] = "@@users/FETCH_USERS_ASYNC_SUCCESS";
    UsersActionTypes["FETCH_USERS_ASYNC_ERROR"] = "@@users/FETCH_USERS_ASYNC_ERROR";
    UsersActionTypes["FETCH_ALL_USERS_ASYNC_PENDING"] = "@@user/FETCH_ALL_USERS_ASYNC_REQUEST";
    UsersActionTypes["FETCH_ALL_USERS_ASYNC_SUCCESS"] = "@@user/FETCH_ALL_USERS_ASYNC_SUCCESS";
    UsersActionTypes["FETCH_ALL_USERS_ASYNC_ERROR"] = "@@user/FETCH_ALL_USERS_ASYNC_ERROR";
    return UsersActionTypes;
}({});

});

parcelRegister("62Lcu", function(module, exports) {

$parcel$export(module.exports, "TeamsOrderByOptions", () => $1ea11b7659e20df6$export$9a636475018370fe);
$parcel$export(module.exports, "TeamsActionTypes", () => $1ea11b7659e20df6$export$186aebe27e1af899);
var $1ea11b7659e20df6$export$9a636475018370fe = /*#__PURE__*/ function(TeamsOrderByOptions) {
    TeamsOrderByOptions["UpdatedDesc"] = "updated_at_desc";
    TeamsOrderByOptions["UpdatedAsc"] = "updated_at_asc";
    TeamsOrderByOptions["NameAsc"] = "name_asc";
    TeamsOrderByOptions["NameDesc"] = "name_desc";
    return TeamsOrderByOptions;
}({});
var $1ea11b7659e20df6$export$186aebe27e1af899 = /*#__PURE__*/ function(TeamsActionTypes) {
    TeamsActionTypes["FETCH_TEAMS_ASYNC_PENDING"] = "@@teams/FETCH_TEAMS_ASYNC_PENDING";
    TeamsActionTypes["FETCH_TEAMS_ASYNC_SUCCESS"] = "@@teams/FETCH_TEAMS_ASYNC_SUCCESS";
    TeamsActionTypes["FETCH_TEAMS_ASYNC_ERROR"] = "@@teams/FETCH_TEAMS_ASYNC_ERROR";
    TeamsActionTypes["FETCH_ALL_TEAMS_ASYNC_PENDING"] = "@@teams/FETCH_ALL_TEAMS_ASYNC_PENDING";
    TeamsActionTypes["FETCH_ALL_TEAMS_ASYNC_SUCCESS"] = "@@teams/FETCH_ALL_TEAMS_ASYNC_SUCCESS";
    TeamsActionTypes["FETCH_ALL_TEAMS_ASYNC_ERROR"] = "@@teams/FETCH_ALL_TEAMS_ASYNC_ERROR";
    return TeamsActionTypes;
}({});

});

parcelRegister("1WoI7", function(module, exports) {

$parcel$export(module.exports, "TeamTypes", () => $29c8486c4c65abf4$export$f867fa8c0aff872);
$parcel$export(module.exports, "TeamActionTypes", () => $29c8486c4c65abf4$export$b7789a17d8800da8);
var $29c8486c4c65abf4$export$f867fa8c0aff872 = /*#__PURE__*/ function(TeamTypes) {
    TeamTypes["mdt"] = "mdt";
    TeamTypes["basic"] = "basic";
    return TeamTypes;
}({});
var $29c8486c4c65abf4$export$b7789a17d8800da8 = /*#__PURE__*/ function(TeamActionTypes) {
    TeamActionTypes["FETCH_TEAM_ASYNC_PENDING"] = "@@team/FETCH_TEAM_ASYNC_PENDING";
    TeamActionTypes["FETCH_TEAM_ASYNC_SUCCESS"] = "@@team/FETCH_TEAM_ASYNC_SUCCESS";
    TeamActionTypes["FETCH_TEAM_ASYNC_ERROR"] = "@@team/FETCH_TEAM_ASYNC_ERROR";
    TeamActionTypes["CREATE_TEAM_ASYNC_PENDING"] = "@@team/CREATE_TEAM_ASYNC_PENDING";
    TeamActionTypes["CREATE_TEAM_ASYNC_SUCCESS"] = "@@team/CREATE_TEAM_ASYNC_SUCCESS";
    TeamActionTypes["CREATE_TEAM_ASYNC_ERROR"] = "@@team/CREATE_TEAM_ASYNC_ERROR";
    TeamActionTypes["UPDATE_TEAM_ASYNC_PENDING"] = "@@team/UPDATE_TEAM_ASYNC_PENDING";
    TeamActionTypes["UPDATE_TEAM_ASYNC_SUCCESS"] = "@@team/UPDATE_TEAM_ASYNC_SUCCESS";
    TeamActionTypes["UPDATE_TEAM_ASYNC_ERROR"] = "@@team/UPDATE_TEAM_ASYNC_ERROR";
    TeamActionTypes["UPDATE_TEAM_USERS_ASYNC_PENDING"] = "@@team/UPDATE_TEAM_USERS_ASYNC_PENDING";
    TeamActionTypes["UPDATE_TEAM_USERS_ASYNC_SUCCESS"] = "@@team/UPDATE_TEAM_USERS_ASYNC_SUCCESS";
    TeamActionTypes["UPDATE_TEAM_USERS_ASYNC_ERROR"] = "@@team/UPDATE_TEAM_USERS_ASYNC_ERROR";
    TeamActionTypes["DELETE_TEAM_ASYNC_PENDING"] = "@@team/DELETE_TEAM_ASYNC_PENDING";
    TeamActionTypes["DELETE_TEAM_ASYNC_SUCCESS"] = "@@team/DELETE_TEAM_ASYNC_SUCCESS";
    TeamActionTypes["DELETE_TEAM_ASYNC_ERROR"] = "@@team/DELETE_TEAM_ASYNC_ERROR";
    return TeamActionTypes;
}({});

});

parcelRegister("i78re", function(module, exports) {

$parcel$export(module.exports, "TenantActionTypes", () => $6cbafcc643074d48$export$ff5b8fa78eb94501);
// Models
var $6cbafcc643074d48$export$ff5b8fa78eb94501 = /*#__PURE__*/ function(TenantActionTypes) {
    TenantActionTypes["CREATE_TENANT_ASYNC_PENDING"] = "@@tenant/CREATE_TENANT_ASYNC_PENDING";
    TenantActionTypes["CREATE_TENANT_ASYNC_SUCCESS"] = "@@tenant/CREATE_TENANT_ASYNC_SUCCESS";
    TenantActionTypes["CREATE_TENANT_ASYNC_ERROR"] = "@@tenant/CREATE_TENANT_ASYNC_ERROR";
    return TenantActionTypes;
}({});

});

parcelRegister("eGEsd", function(module, exports) {

$parcel$export(module.exports, "PathwayActionTypes", () => $1d68d3aa0cb754bf$export$1b26884b5b327b0d);
var $1d68d3aa0cb754bf$export$1b26884b5b327b0d = /*#__PURE__*/ function(PathwayActionTypes) {
    PathwayActionTypes["FETCH_PATHWAY_ASYNC_PENDING"] = "@@pathways/FETCH_PATHWAY_ASYNC_PENDING";
    PathwayActionTypes["FETCH_PATHWAY_ASYNC_SUCCESS"] = "@@pathways/FETCH_PATHWAY_ASYNC_SUCCESS";
    PathwayActionTypes["FETCH_PATHWAY_ASYNC_ERROR"] = "@@pathways/FETCH_PATHWAY_ASYNC_ERROR";
    PathwayActionTypes["CREATE_PATHWAY_ASYNC_PENDING"] = "@@pathways/CREATE_PATHWAY_ASYNC_PENDING";
    PathwayActionTypes["CREATE_PATHWAY_ASYNC_SUCCESS"] = "@@pathways/CREATE_PATHWAY_ASYNC_SUCCESS";
    PathwayActionTypes["CREATE_PATHWAY_ASYNC_ERROR"] = "@@pathways/CREATE_PATHWAY_ASYNC_ERROR";
    PathwayActionTypes["UPDATE_PATHWAY_ASYNC_PENDING"] = "@@pathways/UPDATE_PATHWAY_ASYNC_PENDING";
    PathwayActionTypes["UPDATE_PATHWAY_ASYNC_SUCCESS"] = "@@pathways/UPDATE_PATHWAY_ASYNC_SUCCESS";
    PathwayActionTypes["UPDATE_PATHWAY_ASYNC_ERROR"] = "@@pathways/UPDATE_PATHWAY_ASYNC_ERROR";
    PathwayActionTypes["DELETE_PATHWAY_ASYNC_PENDING"] = "@@pathways/DELETE_PATHWAY_ASYNC_PENDING";
    PathwayActionTypes["DELETE_PATHWAY_ASYNC_SUCCESS"] = "@@pathways/DELETE_PATHWAY_ASYNC_SUCCESS";
    PathwayActionTypes["DELETE_PATHWAY_ASYNC_ERROR"] = "@@pathways/DELETE_PATHWAY_ASYNC_ERROR";
    PathwayActionTypes["CREATE_PATHWAY_STEP_ASYNC_PENDING"] = "@@pathways/CREATE_PATHWAY_STEP_ASYNC_PENDING";
    PathwayActionTypes["CREATE_PATHWAY_STEP_ASYNC_SUCCESS"] = "@@pathways/CREATE_PATHWAY_STEP_ASYNC_SUCCESS";
    PathwayActionTypes["CREATE_PATHWAY_STEP_ASYNC_ERROR"] = "@@pathways/CREATE_PATHWAY_STEP_ASYNC_ERROR";
    PathwayActionTypes["UPDATE_PATHWAY_STEP_ASYNC_PENDING"] = "@@pathways/UPDATE_PATHWAY_STEP_ASYNC_PENDING";
    PathwayActionTypes["UPDATE_PATHWAY_STEP_ASYNC_SUCCESS"] = "@@pathways/UPDATE_PATHWAY_STEP_ASYNC_SUCCESS";
    PathwayActionTypes["UPDATE_PATHWAY_STEP_ASYNC_ERROR"] = "@@pathways/UPDATE_PATHWAY_STEP_ASYNC_ERROR";
    PathwayActionTypes["DELETE_PATHWAY_STEP_ASYNC_PENDING"] = "@@pathways/DELETE_PATHWAY_STEP_ASYNC_PENDING";
    PathwayActionTypes["DELETE_PATHWAY_STEP_ASYNC_SUCCESS"] = "@@pathways/DELETE_PATHWAY_STEP_ASYNC_SUCCESS";
    PathwayActionTypes["DELETE_PATHWAY_STEP_ASYNC_ERROR"] = "@@pathways/DELETE_PATHWAY_STEP_ASYNC_ERROR";
    PathwayActionTypes["ADD_PATHWAY_USERS_ASYNC_PENDING"] = "@@pathways/ADD_PATHWAY_USERS_ASYNC_PENDING";
    PathwayActionTypes["ADD_PATHWAY_USERS_ASYNC_SUCCESS"] = "@@pathways/ADD_PATHWAY_USERS_ASYNC_SUCCESS";
    PathwayActionTypes["ADD_PATHWAY_USERS_ASYNC_ERROR"] = "@@pathways/ADD_PATHWAY_USERS_ASYNC_ERROR";
    PathwayActionTypes["REMOVE_PATHWAY_USER_ASYNC_PENDING"] = "@@pathways/REMOVE_PATHWAY_USER_ASYNC_PENDING";
    PathwayActionTypes["REMOVE_PATHWAY_USER_ASYNC_SUCCESS"] = "@@pathways/REMOVE_PATHWAY_USER_ASYNC_SUCCESS";
    PathwayActionTypes["REMOVE_PATHWAY_USER_ASYNC_ERROR"] = "@@pathways/REMOVE_PATHWAY_USER_ASYNC_ERROR";
    return PathwayActionTypes;
}({});

});

parcelRegister("eCmSQ", function(module, exports) {

$parcel$export(module.exports, "PathwaysOrderByOptions", () => $7b1f63687c5e1363$export$c7ce700b1d717230);
$parcel$export(module.exports, "PathwaysActionTypes", () => $7b1f63687c5e1363$export$55137e4c79962c1e);
var $7b1f63687c5e1363$export$c7ce700b1d717230 = /*#__PURE__*/ function(PathwaysOrderByOptions) {
    PathwaysOrderByOptions["CreatedAtDesc"] = "created_at_desc";
    PathwaysOrderByOptions["CreatedAtAsc"] = "created_at_asc";
    PathwaysOrderByOptions["NameDesc"] = "name_desc";
    PathwaysOrderByOptions["NameAsc"] = "name_asc";
    return PathwaysOrderByOptions;
}({});
var $7b1f63687c5e1363$export$55137e4c79962c1e = /*#__PURE__*/ function(PathwaysActionTypes) {
    PathwaysActionTypes["FETCH_PATHWAYS_ASYNC_PENDING"] = "@@pathways/FETCH_PATHWAYS_ASYNC_PENDING";
    PathwaysActionTypes["FETCH_PATHWAYS_ASYNC_SUCCESS"] = "@@pathways/FETCH_PATHWAYS_ASYNC_SUCCESS";
    PathwaysActionTypes["FETCH_PATHWAYS_ASYNC_ERROR"] = "@@pathways/FETCH_PATHWAYS_ASYNC_ERROR";
    return PathwaysActionTypes;
}({});

});


parcelRegister("3vcrm", function(module, exports) {

$parcel$export(module.exports, "meetingCaseEntityReducer", () => $1424b818d5ea36aa$export$8c4ec9a63ca808f2);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $bP3DF = parcelRequire("bP3DF");

var $32kQ2 = parcelRequire("32kQ2");

var $bal3N = parcelRequire("bal3N");

var $b9HAQ = parcelRequire("b9HAQ");

var $6qYxq = parcelRequire("6qYxq");
const $1424b818d5ea36aa$export$acc42f961369cecb = {};
const $1424b818d5ea36aa$export$2dee9bf55024b46d = [];
const $1424b818d5ea36aa$export$a1920133d5b0a75 = (state = $1424b818d5ea36aa$export$acc42f961369cecb, action)=>{
    const newState = {
        ...state
    };
    switch(action.type){
        case (0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.meetingCases);
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.meetingCases);
        // Of the meeting cases received here, only the 'result' meeting case is
        // complete, the others are only ID's, needed for the meetings, so the
        // other, empty meeting cases shouldn't be added to the state
        case (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_SUCCESS:
            {
                const id = action.payload.result;
                return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, {
                    [id]: action.payload.entities.meetingCases[id]
                });
            }
        case (0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_MEETING_CASE_ASSET_ASYNC_SUCCESS:
        case (0, $b9HAQ.MeetingCaseAssetsActionTypes).DELETE_MEETING_CASE_ASSET_ASYNC_SUCCESS:
        case (0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetingCases
            };
        case (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.meetingCases
            };
        case (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_SUCCESS:
            delete newState[action.payload.meetingCaseId];
            return newState;
        default:
            return {
                ...state
            };
    }
};
const $1424b818d5ea36aa$export$a3c51a603cf683c5 = (state = $1424b818d5ea36aa$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.meetingCases || [])));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.meetingCases || [])));
        case (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.meetingCases || [])));
        default:
            return state;
    }
};
const $1424b818d5ea36aa$export$8c4ec9a63ca808f2 = (0, $i5N98.combineReducers)({
    byId: $1424b818d5ea36aa$export$a1920133d5b0a75,
    allIds: $1424b818d5ea36aa$export$a3c51a603cf683c5
});

});
parcelRegister("b9HAQ", function(module, exports) {

$parcel$export(module.exports, "MeetingCaseAssetsActionTypes", () => $53c6af5864d51551$export$9782569ffb8de4c5);
var $53c6af5864d51551$export$9782569ffb8de4c5 = /*#__PURE__*/ function(MeetingCaseAssetsActionTypes) {
    MeetingCaseAssetsActionTypes["CREATE_MEETING_CASE_ASSET_ASYNC_PENDING"] = "@@meetingCaseAssets/CREATE_MEETING_CASE_ASSET_ASYNC_PENDING";
    MeetingCaseAssetsActionTypes["CREATE_MEETING_CASE_ASSET_ASYNC_SUCCESS"] = "@@meetingCaseAssets/CREATE_MEETING_CASE_ASSET_ASYNC_SUCCESS";
    MeetingCaseAssetsActionTypes["CREATE_MEETING_CASE_ASSET_ASYNC_ERROR"] = "@@meetingCaseAssets/CREATE_MEETING_CASE_ASSET_ASYNC_ERROR";
    MeetingCaseAssetsActionTypes["CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_PENDING"] = "@@meetingCaseAssets/CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_PENDING";
    MeetingCaseAssetsActionTypes["CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_SUCCESS"] = "@@meetingCaseAssets/CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_SUCCESS";
    MeetingCaseAssetsActionTypes["CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_ERROR"] = "@@meetingCaseAssets/CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_ERROR";
    MeetingCaseAssetsActionTypes["DELETE_MEETING_CASE_ASSET_ASYNC_PENDING"] = "@@meetingCaseAssets/DELETE_MEETING_CASE_ASSET_ASYNC_PENDING";
    MeetingCaseAssetsActionTypes["DELETE_MEETING_CASE_ASSET_ASYNC_SUCCESS"] = "@@meetingCaseAssets/DELETE_MEETING_CASE_ASSET_ASYNC_SUCCESS";
    MeetingCaseAssetsActionTypes["DELETE_MEETING_CASE_ASSET_ASYNC_ERROR"] = "@@meetingCaseAssets/DELETE_MEETING_CASE_ASSET_ASYNC_ERROR";
    return MeetingCaseAssetsActionTypes;
}({});

});


parcelRegister("iRUYI", function(module, exports) {

$parcel$export(module.exports, "meetingUserEntityReducer", () => $e6b32371e5df32b4$export$36ad3720307705ed);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $32kQ2 = parcelRequire("32kQ2");

var $bal3N = parcelRequire("bal3N");

var $5xpc0 = parcelRequire("5xpc0");
const $e6b32371e5df32b4$export$acc42f961369cecb = {};
const $e6b32371e5df32b4$export$2dee9bf55024b46d = [];
const $e6b32371e5df32b4$export$a1920133d5b0a75 = (state = $e6b32371e5df32b4$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
        case (0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetingUsers
            };
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.meetingUsers
            };
        case (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetingUsers
            };
        case (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetingUsers
            };
        case (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.meetingUsers
            };
        default:
            return {
                ...state
            };
    }
};
const $e6b32371e5df32b4$export$a3c51a603cf683c5 = (state = $e6b32371e5df32b4$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.meetingUsers || [])));
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.all.entities.meetingUsers || [])));
        case (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.meetingUsers || [])));
        case (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.meetingUsers || [])));
        case (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.meetingUsers || [])));
        default:
            return state;
    }
};
const $e6b32371e5df32b4$export$36ad3720307705ed = (0, $i5N98.combineReducers)({
    byId: $e6b32371e5df32b4$export$a1920133d5b0a75,
    allIds: $e6b32371e5df32b4$export$a3c51a603cf683c5
});

});

parcelRegister("6mKzG", function(module, exports) {

$parcel$export(module.exports, "tenantConfigReducer", () => $d303cda2294bdc4b$export$2e01036f02280a72);

var $f1q41 = parcelRequire("f1q41");

var $jF0Xa = parcelRequire("jF0Xa");

var $aeos3 = parcelRequire("aeos3");

var $83zyI = parcelRequire("83zyI");

var $dz6fA = parcelRequire("dz6fA");
const $d303cda2294bdc4b$export$d4c72bab9d6cc13a = (0, $aeos3.tenantConfigContextInitialState);
const $d303cda2294bdc4b$export$2e01036f02280a72 = (state = $d303cda2294bdc4b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $jF0Xa.SharedActionTypes).REHYDRATE:
            if (!action.payload?.tenantConfig) return {
                ...state
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.tenantConfig);
        case (0, $83zyI.TenantConfigActionTypes).FETCH_TENANT_CONFIG_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload);
        case (0, $dz6fA.AdminActionTypes).UPLOAD_TENANT_LOGO_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload);
        default:
            return {
                ...state
            };
    }
};

});
parcelRegister("dz6fA", function(module, exports) {

$parcel$export(module.exports, "AdminActionTypes", () => $0f6197d5864cf3fb$export$8ad67b5262c56830);
// State
var $0f6197d5864cf3fb$export$8ad67b5262c56830 = /*#__PURE__*/ function(AdminActionTypes) {
    AdminActionTypes["UPLOAD_TERMS_FILE_ASYNC_PENDING"] = "@@admin/UPLOAD_TERMS_FILE_ASYNC_PENDING";
    AdminActionTypes["UPLOAD_TERMS_FILE_ASYNC_SUCCESS"] = "@@admin/UPLOAD_TERMS_FILE_ASYNC_SUCCESS";
    AdminActionTypes["UPLOAD_TERMS_FILE_ASYNC_ERROR"] = "@@admin/UPLOAD_TERMS_FILE_ASYNC_ERROR";
    AdminActionTypes["UPLOAD_TENANT_LOGO_ASYNC_PENDING"] = "@@admin/UPLOAD_TENANT_LOGO_ASYNC_PENDING";
    AdminActionTypes["UPLOAD_TENANT_LOGO_ASYNC_SUCCESS"] = "@@admin/UPLOAD_TENANT_LOGO_ASYNC_SUCCESS";
    AdminActionTypes["UPLOAD_TENANT_LOGO_ASYNC_ERROR"] = "@@admin/UPLOAD_TENANT_LOGO_ASYNC_ERROR";
    return AdminActionTypes;
}({});

});


parcelRegister("k7bTN", function(module, exports) {

$parcel$export(module.exports, "assetEntityReducer", () => $302a397e987ab80f$export$2f87dd67c69c608c);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $7twpo = parcelRequire("7twpo");

var $aif7R = parcelRequire("aif7R");

var $udwHW = parcelRequire("udwHW");
const $302a397e987ab80f$export$acc42f961369cecb = {};
const $302a397e987ab80f$export$2dee9bf55024b46d = [];
const $302a397e987ab80f$export$a1920133d5b0a75 = (state = $302a397e987ab80f$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).ADD_CONSENT_ASYNC_SUCCESS:
        case (0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_SUCCESS:
        case (0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_SUCCESS:
        case (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.assets);
        case (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_SUCCESS:
            return action.payload.all.entities.assets || [];
        default:
            return {
                ...state
            };
    }
};
const $302a397e987ab80f$export$a3c51a603cf683c5 = (state = $302a397e987ab80f$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_SUCCESS:
        case (0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_SUCCESS:
        case (0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        case (0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(action.payload.all.result, state));
        default:
            return state;
    }
};
const $302a397e987ab80f$export$2f87dd67c69c608c = (0, $i5N98.combineReducers)({
    byId: $302a397e987ab80f$export$a1920133d5b0a75,
    allIds: $302a397e987ab80f$export$a3c51a603cf683c5
});

});

parcelRegister("4xxiw", function(module, exports) {

$parcel$export(module.exports, "webRTCSessionReducer", () => $14a9b011e40db422$export$e9db0dedc9f14fb1);

var $5ng6u = parcelRequire("5ng6u");
const $14a9b011e40db422$export$d4c72bab9d6cc13a = null;
const $14a9b011e40db422$export$e9db0dedc9f14fb1 = (state = $14a9b011e40db422$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).CONNECT_TO_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SESSION:
            return {
                ...state,
                ...action.payload.session
            };
        case (0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return $14a9b011e40db422$export$d4c72bab9d6cc13a;
        default:
            return state;
    }
};

});

parcelRegister("deES6", function(module, exports) {

$parcel$export(module.exports, "webRTCPublisherReducer", () => $97f0af44e173f6b6$export$aff716f1a8d0e27f);

var $5ng6u = parcelRequire("5ng6u");
const $97f0af44e173f6b6$export$d4c72bab9d6cc13a = null;
const $97f0af44e173f6b6$export$aff716f1a8d0e27f = (state = $97f0af44e173f6b6$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_PUBLISHER:
            return {
                ...state,
                ...action.payload.publisher
            };
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SESSION:
            return Object.assign({}, state, {
                session: action.payload.session
            });
        case (0, $5ng6u.WebRTCActionTypes).UNPUBLISH_FROM_WEB_RTC_SESSION_SUCCESS:
            return $97f0af44e173f6b6$export$d4c72bab9d6cc13a;
        default:
            return state;
    }
};

});

parcelRegister("igAso", function(module, exports) {

$parcel$export(module.exports, "userMessageReducer", () => $de90a3a151a0a108$export$95b0e17150f505f8);

var $jiIfA = parcelRequire("jiIfA");
const $de90a3a151a0a108$export$d4c72bab9d6cc13a = {
    messageKey: null,
    type: null,
    isRead: false
};
const $de90a3a151a0a108$export$95b0e17150f505f8 = (state = $de90a3a151a0a108$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $jiIfA.UserMessageActionTypes).DISPLAY_USER_MESSAGE:
            return {
                ...state,
                ...action.payload,
                isRead: false
            };
        case (0, $jiIfA.UserMessageActionTypes).MARK_USER_MESSAGE_READ:
            return $de90a3a151a0a108$export$d4c72bab9d6cc13a;
        default:
            return {
                ...state
            };
    }
};

});

parcelRegister("4XOZB", function(module, exports) {

$parcel$export(module.exports, "webRTCStreamReducer", () => $e814b447cc2f2576$export$74da9cf3eec29519);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $5ng6u = parcelRequire("5ng6u");
const $e814b447cc2f2576$export$2c8dee2b3e9d54d8 = {};
const $e814b447cc2f2576$export$6d9407bef515fb01 = (state = $e814b447cc2f2576$export$2c8dee2b3e9d54d8, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).ADD_WEB_RTC_STREAM:
            return {
                ...state,
                [action.payload.userId]: action.payload.stream
            };
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_STREAM:
            return {
                ...state,
                [action.payload.userId]: {
                    ...state[action.payload.userId],
                    ...action.payload.stream
                }
            };
        case (0, $5ng6u.WebRTCActionTypes).REMOVE_WEB_RTC_STREAM:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(state, action.payload.userId);
        case (0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return $e814b447cc2f2576$export$2c8dee2b3e9d54d8;
        default:
            return {
                ...state
            };
    }
};
const $e814b447cc2f2576$export$74da9cf3eec29519 = (0, $i5N98.combineReducers)({
    byUserId: $e814b447cc2f2576$export$6d9407bef515fb01
});

});

parcelRegister("7KAZ8", function(module, exports) {

$parcel$export(module.exports, "meetingsSearchUIReducer", () => $b50cfa84ee2758ce$export$1bc6275e42afe292);

var $i5N98 = parcelRequire("i5N98");

var $bal3N = parcelRequire("bal3N");

var $jF0Xa = parcelRequire("jF0Xa");
const $b50cfa84ee2758ce$export$5aefd3376c5da593 = (state = [], action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.all.result;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$38717ffdeae219ea = (state = 0, action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$2e414180c3a13344 = (state = [], action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$f18af21d6f4dafd8 = (state = "date_desc", action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$b176f387246834a9 = (state = false, action)=>{
    switch(action.type){
        case (0, $bal3N.MeetingsActionTypes).TOGGLE_LIST_VIEW:
            return action.payload;
        default:
            return state;
    }
};
const $b50cfa84ee2758ce$export$1bc6275e42afe292 = (0, $i5N98.combineReducers)({
    idsOnIndexPage: $b50cfa84ee2758ce$export$5aefd3376c5da593,
    totalMeetingsCount: $b50cfa84ee2758ce$export$38717ffdeae219ea,
    totalPages: $b50cfa84ee2758ce$export$828d4f39ed844b18,
    appliedFilters: $b50cfa84ee2758ce$export$2e414180c3a13344,
    orderBy: $b50cfa84ee2758ce$export$f18af21d6f4dafd8,
    resultsPerPage: $b50cfa84ee2758ce$export$2491e5eef6485e6c,
    searchTerm: $b50cfa84ee2758ce$export$83ab5e31da45bcb4,
    isListView: $b50cfa84ee2758ce$export$b176f387246834a9
});

});

parcelRegister("5xx1T", function(module, exports) {

$parcel$export(module.exports, "webRTCScreenShareReducer", () => $5f014b888aba7668$export$bb769538d0331c3a);

var $i5N98 = parcelRequire("i5N98");

var $5ng6u = parcelRequire("5ng6u");
const $5f014b888aba7668$export$e4efd779766c7850 = null;
const $5f014b888aba7668$export$eb39f87c5509319c = (state = $5f014b888aba7668$export$e4efd779766c7850, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SCREEN_STREAM:
            if (!action.payload) return $5f014b888aba7668$export$e4efd779766c7850;
            return state;
        case (0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case (0, $5ng6u.WebRTCActionTypes).STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS:
            return $5f014b888aba7668$export$e4efd779766c7850;
        default:
            return state;
    }
};
const $5f014b888aba7668$export$1673506febe34428 = null;
const $5f014b888aba7668$export$4938110305e6185f = (state = $5f014b888aba7668$export$1673506febe34428, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SCREEN_STREAM:
            if (!action.payload) return $5f014b888aba7668$export$1673506febe34428;
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};
const $5f014b888aba7668$export$82a77cab9f0a1030 = false;
const $5f014b888aba7668$export$1a2d97de39ecbb75 = (state = $5f014b888aba7668$export$82a77cab9f0a1030, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).UPDATE_WEB_RTC_SCREEN_STREAM:
            if (!action.payload) return $5f014b888aba7668$export$82a77cab9f0a1030;
            return state;
        case (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON:
            return action.payload.isSharingScreen;
        case (0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR:
            return $5f014b888aba7668$export$82a77cab9f0a1030;
        default:
            return state;
    }
};
const $5f014b888aba7668$export$886af907fea58b43 = (state = false, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_SCREEN_SHARING_IS_ON:
            // this will reset the preferCurrentTab state when sharing is stopped
            return !!action.payload.isSharingScreen && !!action.payload.preferCurrentTab;
        default:
            return state;
    }
};
const $5f014b888aba7668$export$bb769538d0331c3a = (0, $i5N98.combineReducers)({
    publisher: $5f014b888aba7668$export$eb39f87c5509319c,
    stream: $5f014b888aba7668$export$4938110305e6185f,
    isOn: $5f014b888aba7668$export$1a2d97de39ecbb75,
    preferCurrentTab: $5f014b888aba7668$export$886af907fea58b43
});

});

parcelRegister("gE7bZ", function(module, exports) {

$parcel$export(module.exports, "webRTCAudioDeviceReducer", () => $1bb957d62276c947$export$6aaf2abc6841d0f6);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $5ng6u = parcelRequire("5ng6u");
const $1bb957d62276c947$export$153534ef20f82fda = null;
const $1bb957d62276c947$export$acc42f961369cecb = {};
const $1bb957d62276c947$export$2dee9bf55024b46d = [];
const $1bb957d62276c947$export$a3470d1e3c89b98c = (state = $1bb957d62276c947$export$153534ef20f82fda, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_SOURCE_SUCCESS:
            return action.payload.device.deviceId;
        case (0, $5ng6u.WebRTCActionTypes).SET_WEB_RTC_AUDIO_SOURCE_SUCCESS:
            return action.payload.deviceId;
        default:
            return state;
    }
};
const $1bb957d62276c947$export$a1920133d5b0a75 = (state = $1bb957d62276c947$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(action.payload.devices, "deviceId");
        default:
            return {
                ...state
            };
    }
};
const $1bb957d62276c947$export$a3c51a603cf683c5 = (state = $1bb957d62276c947$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(action.payload.devices, "deviceId");
        default:
            return state;
    }
};
const $1bb957d62276c947$export$6aaf2abc6841d0f6 = (0, $i5N98.combineReducers)({
    selectedId: $1bb957d62276c947$export$a3470d1e3c89b98c,
    byId: $1bb957d62276c947$export$a1920133d5b0a75,
    allIds: $1bb957d62276c947$export$a3c51a603cf683c5
});

});

parcelRegister("ljQrH", function(module, exports) {

$parcel$export(module.exports, "navUIReducer", () => $dcf69c87574dcf96$export$4e71ec2afb9a4c5d);

var $jF0Xa = parcelRequire("jF0Xa");

var $lkuVs = parcelRequire("lkuVs");
const $dcf69c87574dcf96$export$d4c72bab9d6cc13a = {
    isMenuOpen: true,
    isQuickViewOpen: false,
    quickViewResourceId: null
};
const $dcf69c87574dcf96$export$4e71ec2afb9a4c5d = (state = $dcf69c87574dcf96$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $jF0Xa.SharedActionTypes).REHYDRATE:
            if (!action.payload?.ui.nav) return {
                ...state
            };
            return {
                ...state,
                ...action.payload.ui.nav
            };
        case (0, $lkuVs.NavActionTypes).TOGGLE_IS_MENU_OPEN:
            return {
                ...state,
                isMenuOpen: action.payload
            };
        case (0, $lkuVs.NavActionTypes).TOGGLE_IS_QUICK_VIEW_OPEN:
            return {
                ...state,
                ...action.payload
            };
        default:
            return {
                ...state
            };
    }
};

});
parcelRegister("lkuVs", function(module, exports) {

$parcel$export(module.exports, "NavActionTypes", () => $2a0dfdc2b237eb91$export$70656c7aa0cbaba);
// State
var $2a0dfdc2b237eb91$export$70656c7aa0cbaba = /*#__PURE__*/ function(NavActionTypes) {
    NavActionTypes["TOGGLE_IS_MENU_OPEN"] = "@@nav/TOGGLE_IS_MENU_OPEN";
    NavActionTypes["TOGGLE_IS_QUICK_VIEW_OPEN"] = "@@nav/TOGGLE_IS_QUICK_VIEW_OPEN";
    NavActionTypes["UPDATE_QUICK_VIEW_RESOURCE_ID"] = "@@nav/UPDATE_QUICK_VIEW_RESOURCE_ID";
    return NavActionTypes;
}({});

});


parcelRegister("bATSQ", function(module, exports) {

$parcel$export(module.exports, "specialtiesReducer", () => $4d402089422664bf$export$979a970b1af52412);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $5yBCT = parcelRequire("5yBCT");
const $4d402089422664bf$export$acc42f961369cecb = {};
const $4d402089422664bf$export$2dee9bf55024b46d = [];
const $4d402089422664bf$export$a1920133d5b0a75 = (state = $4d402089422664bf$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.specialties
            };
        default:
            return {
                ...state
            };
    }
};
const $4d402089422664bf$export$a3c51a603cf683c5 = (state = $4d402089422664bf$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result));
        default:
            return state;
    }
};
const $4d402089422664bf$export$979a970b1af52412 = (0, $i5N98.combineReducers)({
    byId: $4d402089422664bf$export$a1920133d5b0a75,
    allIds: $4d402089422664bf$export$a3c51a603cf683c5
});

});
parcelRegister("5yBCT", function(module, exports) {

$parcel$export(module.exports, "SpecialtyActionTypes", () => $01601d1115da4094$export$f956427897af7ded);
var $01601d1115da4094$export$f956427897af7ded = /*#__PURE__*/ function(SpecialtyActionTypes) {
    SpecialtyActionTypes["FETCH_SPECIALTIES_ASYNC_PENDING"] = "@@specialties/FETCH_SPECIALTIES_ASYNC_PENDING";
    SpecialtyActionTypes["FETCH_SPECIALTIES_ASYNC_SUCCESS"] = "@@specialties/FETCH_SPECIALTIES_ASYNC_SUCCESS";
    SpecialtyActionTypes["FETCH_SPECIALTIES_ASYNC_ERROR"] = "@@specialties/FETCH_SPECIALTIES_ASYNC_ERROR";
    return SpecialtyActionTypes;
}({});

});


parcelRegister("7k8Gb", function(module, exports) {

$parcel$export(module.exports, "caseClassificationReducer", () => $54fa10f7731b7404$export$15a3a1b28fe54ddb);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $7k78k = parcelRequire("7k78k");
const $54fa10f7731b7404$export$acc42f961369cecb = {};
const $54fa10f7731b7404$export$2dee9bf55024b46d = [];
const $54fa10f7731b7404$export$a1920133d5b0a75 = (state = $54fa10f7731b7404$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.caseClassifications
            };
        default:
            return {
                ...state
            };
    }
};
const $54fa10f7731b7404$export$a3c51a603cf683c5 = (state = $54fa10f7731b7404$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result));
        default:
            return state;
    }
};
const $54fa10f7731b7404$export$15a3a1b28fe54ddb = (0, $i5N98.combineReducers)({
    byId: $54fa10f7731b7404$export$a1920133d5b0a75,
    allIds: $54fa10f7731b7404$export$a3c51a603cf683c5
});

});
parcelRegister("7k78k", function(module, exports) {

$parcel$export(module.exports, "CaseClassificationActionTypes", () => $a1d3b31ff5ab94f4$export$48ea4d39f8c8dc66);
var $a1d3b31ff5ab94f4$export$48ea4d39f8c8dc66 = /*#__PURE__*/ function(CaseClassificationActionTypes) {
    CaseClassificationActionTypes["FETCH_CASE_CLASSIFICATION_ASYNC_PENDING"] = "@@caseClassification/FETCH_CASE_CLASSIFICATION_ASYNC_PENDING";
    CaseClassificationActionTypes["FETCH_CASE_CLASSIFICATION_ASYNC_SUCCESS"] = "@@caseClassification/FETCH_CASE_CLASSIFICATION_ASYNC_SUCCESS";
    CaseClassificationActionTypes["FETCH_CASE_CLASSIFICATION_ASYNC_ERROR"] = "@@caseClassification/FETCH_CASE_CLASSIFICATION_ASYNC_ERROR";
    return CaseClassificationActionTypes;
}({});

});


parcelRegister("idNXT", function(module, exports) {

$parcel$export(module.exports, "patientsReducer", () => $a228fb6538a8e1d6$export$f87f49e4a9bdb15d);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $el6QJ = parcelRequire("el6QJ");

var $5tA5l = parcelRequire("5tA5l");

var $55aym = parcelRequire("55aym");
const $a228fb6538a8e1d6$export$acc42f961369cecb = {};
const $a228fb6538a8e1d6$export$2dee9bf55024b46d = [];
const $a228fb6538a8e1d6$export$a1920133d5b0a75 = (state = $a228fb6538a8e1d6$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_SUCCESS:
        case (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_FOUND:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.patients);
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.patients);
        case (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.patients);
        default:
            return {
                ...state
            };
    }
};
const $a228fb6538a8e1d6$export$a3c51a603cf683c5 = (state = $a228fb6538a8e1d6$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, Object.keys(action.payload.entities.patients)));
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        default:
            return state;
    }
};
const $a228fb6538a8e1d6$export$f87f49e4a9bdb15d = (0, $i5N98.combineReducers)({
    byId: $a228fb6538a8e1d6$export$a1920133d5b0a75,
    allIds: $a228fb6538a8e1d6$export$a3c51a603cf683c5
});

});
parcelRegister("5tA5l", function(module, exports) {

$parcel$export(module.exports, "PatientNewCheckDetailsStatuses", () => $22683ee6ebb7c00f$export$d478955080f71878);
$parcel$export(module.exports, "PatientNewActionTypes", () => $22683ee6ebb7c00f$export$442955845adc476b);
// Models
var $22683ee6ebb7c00f$export$d478955080f71878 = /*#__PURE__*/ function(PatientNewCheckDetailsStatuses) {
    PatientNewCheckDetailsStatuses["Pending"] = "pending";
    PatientNewCheckDetailsStatuses["Found"] = "found";
    PatientNewCheckDetailsStatuses["Not_Found"] = "not_found";
    return PatientNewCheckDetailsStatuses;
}({});
var $22683ee6ebb7c00f$export$442955845adc476b = /*#__PURE__*/ function(PatientNewActionTypes) {
    PatientNewActionTypes["CHECK_PATIENT_ASYNC_RESET"] = "@@patient/CHECK_PATIENT_RESET";
    PatientNewActionTypes["CHECK_PATIENT_ASYNC_PENDING"] = "@@patient/CHECK_PATIENT_ASYNC_PENDING";
    PatientNewActionTypes["CHECK_PATIENT_ASYNC_FOUND"] = "@@patient/CHECK_PATIENT_ASYNC_FOUND";
    PatientNewActionTypes["CHECK_PATIENT_ASYNC_NOT_FOUND"] = "@@patient/CHECK_PATIENT_ASYNC_NOT_FOUND";
    PatientNewActionTypes["CREATE_PATIENT_ASYNC_PENDING"] = "@@patient/CREATE_PATIENT_ASYNC_PENDING";
    PatientNewActionTypes["CREATE_PATIENT_ASYNC_SUCCESS"] = "@@patient/CREATE_PATIENT_ASYNC_SUCCESS";
    PatientNewActionTypes["CREATE_PATIENT_ASYNC_ERROR"] = "@@patient/CREATE_PATIENT_ASYNC_ERROR";
    return PatientNewActionTypes;
}({});

});


parcelRegister("j9q5r", function(module, exports) {

$parcel$export(module.exports, "pathwaysEntityReducer", () => $94f59402518dd730$export$ec0c96734838531a);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $eCmSQ = parcelRequire("eCmSQ");

var $eGEsd = parcelRequire("eGEsd");

var $cmXxm = parcelRequire("cmXxm");
const $94f59402518dd730$export$acc42f961369cecb = {};
const $94f59402518dd730$export$2dee9bf55024b46d = [];
const $94f59402518dd730$export$a1920133d5b0a75 = (state = $94f59402518dd730$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.pathways || {});
        case (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_STEP_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).ADD_PATHWAY_USERS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.pathways || {});
        case (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_STEP_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_STEP_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).REMOVE_PATHWAY_USER_ASYNC_SUCCESS:
            // here we need to replace the returned pathway, so no _.merge
            return {
                ...state,
                ...action.payload.entities.pathways
            };
        case (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(state, [
                action.payload.pathwayId
            ]);
        default:
            return {
                ...state
            };
    }
};
const $94f59402518dd730$export$a3c51a603cf683c5 = (state = $94f59402518dd730$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.all.result || []));
        case (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_SUCCESS:
        case (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result || []));
        case (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).without(state, action.payload.pathwayId);
        default:
            return state;
    }
};
const $94f59402518dd730$export$ec0c96734838531a = (0, $i5N98.combineReducers)({
    byId: $94f59402518dd730$export$a1920133d5b0a75,
    allIds: $94f59402518dd730$export$a3c51a603cf683c5
});

});
parcelRegister("cmXxm", function(module, exports) {

$parcel$export(module.exports, "AddPathwayToCaseActionTypes", () => $ee03aff0fcf4749a$export$70406d9d125dadd1);
var $ee03aff0fcf4749a$export$70406d9d125dadd1 = /*#__PURE__*/ function(AddPathwayToCaseActionTypes) {
    AddPathwayToCaseActionTypes["FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_PENDING"] = "@@addPathwayToCase/FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_PENDING";
    AddPathwayToCaseActionTypes["FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS"] = "@@addPathwayToCase/FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS";
    AddPathwayToCaseActionTypes["FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_ERROR"] = "@@addPathwayToCase/FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_ERROR";
    return AddPathwayToCaseActionTypes;
}({});

});


parcelRegister("gA2tj", function(module, exports) {

$parcel$export(module.exports, "usersUIReducer", () => $dd22e0cf8303afde$export$8719ee820ca5f34b);

var $i5N98 = parcelRequire("i5N98");

var $cX1nf = parcelRequire("cX1nf");

var $4LWrD = parcelRequire("4LWrD");

var $jF0Xa = parcelRequire("jF0Xa");
const $dd22e0cf8303afde$export$4fbe93214b6a2920 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$2e414180c3a13344 = (state = [
    "active"
], action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$f18af21d6f4dafd8 = (state = (0, $4LWrD.UserOrderByOptions).nameAsc, action)=>{
    switch(action.type){
        case (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $dd22e0cf8303afde$export$8719ee820ca5f34b = (0, $i5N98.combineReducers)({
    totalUsersCount: $dd22e0cf8303afde$export$4fbe93214b6a2920,
    totalPages: $dd22e0cf8303afde$export$828d4f39ed844b18,
    searchTerm: $dd22e0cf8303afde$export$83ab5e31da45bcb4,
    resultsPerPage: $dd22e0cf8303afde$export$2491e5eef6485e6c,
    appliedFilters: $dd22e0cf8303afde$export$2e414180c3a13344,
    orderBy: $dd22e0cf8303afde$export$f18af21d6f4dafd8
});

});
parcelRegister("4LWrD", function(module, exports) {

$parcel$export(module.exports, "UserOrderByOptions", () => $a5c3139762eaf7c1$export$c627b1f543cf8b24);
var $a5c3139762eaf7c1$export$c627b1f543cf8b24 = /*#__PURE__*/ function(UserOrderByOptions) {
    UserOrderByOptions["nameAsc"] = "last_name_asc";
    UserOrderByOptions["nameDesc"] = "last_name_desc";
    UserOrderByOptions["dateAddedAsc"] = "created_at_asc";
    UserOrderByOptions["dateAddedDesc"] = "created_at_desc";
    UserOrderByOptions["lastSeenDesc"] = "last_seen_date_desc";
    return UserOrderByOptions;
}({});

});


parcelRegister("iWvmU", function(module, exports) {

$parcel$export(module.exports, "casesUIReducer", () => $08a934398a7ab76e$export$af90b19d6f1f0f2);

var $i5N98 = parcelRequire("i5N98");

var $cCibL = parcelRequire("cCibL");

var $jF0Xa = parcelRequire("jF0Xa");
const $08a934398a7ab76e$export$25c0806b421fd8a2 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$2e414180c3a13344 = (state = [], action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$f18af21d6f4dafd8 = (state = "updated_desc", action)=>{
    switch(action.type){
        case (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $08a934398a7ab76e$export$af90b19d6f1f0f2 = (0, $i5N98.combineReducers)({
    totalCasesCount: $08a934398a7ab76e$export$25c0806b421fd8a2,
    totalPages: $08a934398a7ab76e$export$828d4f39ed844b18,
    appliedFilters: $08a934398a7ab76e$export$2e414180c3a13344,
    resultsPerPage: $08a934398a7ab76e$export$2491e5eef6485e6c,
    searchTerm: $08a934398a7ab76e$export$83ab5e31da45bcb4,
    orderBy: $08a934398a7ab76e$export$f18af21d6f4dafd8
});

});

parcelRegister("hy4X2", function(module, exports) {

$parcel$export(module.exports, "notificationEntityReducer", () => $767b56790d0125ba$export$9942b65d40fe1a0a);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $9VqZS = parcelRequire("9VqZS");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");
const $767b56790d0125ba$export$acc42f961369cecb = {};
const $767b56790d0125ba$export$2dee9bf55024b46d = [];
const $767b56790d0125ba$export$45de1630b4d84a29 = (notificationsById)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mapValues(notificationsById, (notification)=>{
        return {
            ...notification,
            readAt: new Date().toISOString()
        };
    });
};
const $767b56790d0125ba$export$a1920133d5b0a75 = (state = $767b56790d0125ba$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
            return {
                ...action.payload.all.entities.notifications
            };
        case (0, $9VqZS.NotificationsCableActionTypes).DELIVER_NOTIFICATION:
            return {
                ...state,
                // Payload from cable must be normalized
                ...(0, $6ye6I.normalize)(action.payload.notification, (0, $k0jcd.notificationsSchema)).entities.notifications || {}
            };
        case (0, $9VqZS.NotificationsCableActionTypes).MARK_ALL_AS_READ:
            return {
                ...state,
                ...$767b56790d0125ba$export$45de1630b4d84a29(state)
            };
        case (0, $9VqZS.NotificationsCableActionTypes).MARK_AS_READ:
            return {
                ...state,
                [action.payload.notificationId]: {
                    ...state[action.payload.notificationId],
                    readAt: new Date().toISOString()
                }
            };
        case (0, $9VqZS.NotificationsCableActionTypes).MARK_AS_UNREAD:
            return {
                ...state,
                [action.payload.notificationId]: {
                    ...state[action.payload.notificationId],
                    readAt: null
                }
            };
        default:
            return {
                ...state
            };
    }
};
const $767b56790d0125ba$export$a3c51a603cf683c5 = (state = $767b56790d0125ba$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        case (0, $9VqZS.NotificationsCableActionTypes).DELIVER_NOTIFICATION:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(action.payload.notification.id, state));
        default:
            return state;
    }
};
const $767b56790d0125ba$export$9942b65d40fe1a0a = (0, $i5N98.combineReducers)({
    byId: $767b56790d0125ba$export$a1920133d5b0a75,
    allIds: $767b56790d0125ba$export$a3c51a603cf683c5
});

});
parcelRegister("9VqZS", function(module, exports) {

$parcel$export(module.exports, "NotificationsActionTypes", () => $195e5e76a03bc5ef$export$ad7a34416ad8520c);
$parcel$export(module.exports, "NotificationsCableActionTypes", () => $195e5e76a03bc5ef$export$15ef4f48ffbe220d);
var $195e5e76a03bc5ef$export$ad7a34416ad8520c = /*#__PURE__*/ function(NotificationsActionTypes) {
    NotificationsActionTypes["FETCH_NOTIFICATIONS_ASYNC_PENDING"] = "@@notifications/FETCH_NOTIFICATIONS_ASYNC_PENDING";
    NotificationsActionTypes["FETCH_NOTIFICATIONS_ASYNC_SUCCESS"] = "@@notifications/FETCH_NOTIFICATIONS_ASYNC_SUCCESS";
    NotificationsActionTypes["FETCH_NOTIFICATIONS_ASYNC_ERROR"] = "@@notifications/FETCH_NOTIFICATIONS_ASYNC_ERROR";
    return NotificationsActionTypes;
}({});
var $195e5e76a03bc5ef$export$15ef4f48ffbe220d = /*#__PURE__*/ function(NotificationsCableActionTypes) {
    // INBOUND
    NotificationsCableActionTypes["UPDATE_UNREAD_COUNT"] = "@@userCable/notifications/UPDATE_UNREAD_COUNT";
    NotificationsCableActionTypes["DELIVER_NOTIFICATION"] = "@@userCable/notifications/DELIVER_NOTIFICATION";
    // OUTBOUND
    NotificationsCableActionTypes["MARK_ALL_AS_READ"] = "@@userCable/notifications/MARK_ALL_AS_READ";
    NotificationsCableActionTypes["MARK_AS_READ"] = "@@userCable/notifications/MARK_AS_READ";
    NotificationsCableActionTypes["MARK_AS_UNREAD"] = "@@userCable/notifications/MARK_AS_UNREAD";
    return NotificationsCableActionTypes;
}({});

});

parcelRegister("k0jcd", function(module, exports) {

$parcel$export(module.exports, "patientRadiologyLinkSchema", () => $3f5b95c03216183e$export$44101f463f44d7f7);
$parcel$export(module.exports, "userSchema", () => $3f5b95c03216183e$export$431bbfaa07941dc7);
$parcel$export(module.exports, "patientsSchema", () => $3f5b95c03216183e$export$49eb4e1b6600667e);
$parcel$export(module.exports, "assetsSchema", () => $3f5b95c03216183e$export$c0aef4fd59bb877d);
$parcel$export(module.exports, "auditEventsSchema", () => $3f5b95c03216183e$export$23a46ccc12de4410);
$parcel$export(module.exports, "contextFormTemplatesSchema", () => $3f5b95c03216183e$export$41b3829e68bde3b1);
$parcel$export(module.exports, "pathwaysSchema", () => $3f5b95c03216183e$export$40277dca6ceb6687);
$parcel$export(module.exports, "messageAssetsSchema", () => $3f5b95c03216183e$export$9411805911153210);
$parcel$export(module.exports, "caseClassificationsSchema", () => $3f5b95c03216183e$export$f99797643eb6a481);
$parcel$export(module.exports, "specialtySchema", () => $3f5b95c03216183e$export$f2dc82468981d46b);
$parcel$export(module.exports, "tasksSchema", () => $3f5b95c03216183e$export$4d22362d9e759546);
$parcel$export(module.exports, "casePathwaySchema", () => $3f5b95c03216183e$export$f8e29d8419a01875);
$parcel$export(module.exports, "notificationsSchema", () => $3f5b95c03216183e$export$3b2ffce4a2dd7263);
$parcel$export(module.exports, "fetchCaseSchema", () => $3f5b95c03216183e$export$87152462d2750f10);
$parcel$export(module.exports, "fetchMeetingsSchema", () => $3f5b95c03216183e$export$ec62d4b5587020fb);
$parcel$export(module.exports, "fetchMeetingSchema", () => $3f5b95c03216183e$export$5a54fe2fedd8ed4c);
$parcel$export(module.exports, "fetchMeetingCaseSchema", () => $3f5b95c03216183e$export$b0807034b9e786c0);
$parcel$export(module.exports, "fetchTeamSchema", () => $3f5b95c03216183e$export$a029490cb1d0421e);
$parcel$export(module.exports, "fetchChatsSchema", () => $3f5b95c03216183e$export$91849b17585ff521);
$parcel$export(module.exports, "fetchMessagesSchema", () => $3f5b95c03216183e$export$20c2bcd3dafa7114);
$parcel$export(module.exports, "caseSourcesSchema", () => $3f5b95c03216183e$export$fcf2624b00ed6a9);

var $6ye6I = parcelRequire("6ye6I");
const $3f5b95c03216183e$export$44101f463f44d7f7 = new (0, $6ye6I.schema).Entity("patientRadiologyLink", {}, {
    idAttribute: "fileUuid"
});
const $3f5b95c03216183e$export$431bbfaa07941dc7 = new (0, $6ye6I.schema).Entity("users", {});
const $3f5b95c03216183e$export$7c96bbbf4cb1d6a8 = new (0, $6ye6I.schema).Entity("meetingUsers", {});
const $3f5b95c03216183e$export$49eb4e1b6600667e = new (0, $6ye6I.schema).Entity("patients", {
    cases: [
        new (0, $6ye6I.schema).Entity("cases", {
            leadCareUser: $3f5b95c03216183e$export$431bbfaa07941dc7
        })
    ]
});
const $3f5b95c03216183e$export$c0aef4fd59bb877d = new (0, $6ye6I.schema).Entity("assets", {});
const $3f5b95c03216183e$export$a9f72eb6997559e1 = new (0, $6ye6I.schema).Entity("teamUsers", {});
const $3f5b95c03216183e$export$23a46ccc12de4410 = new (0, $6ye6I.schema).Entity("auditEvents", {});
const $3f5b95c03216183e$export$41b3829e68bde3b1 = new (0, $6ye6I.schema).Entity("formTemplates", {});
const $3f5b95c03216183e$export$40277dca6ceb6687 = new (0, $6ye6I.schema).Entity("pathways", {
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ]
});
const $3f5b95c03216183e$export$9411805911153210 = new (0, $6ye6I.schema).Entity("messageAssets", {});
const $3f5b95c03216183e$export$f99797643eb6a481 = new (0, $6ye6I.schema).Entity("caseClassifications", {
    children: [
        new (0, $6ye6I.schema).Entity("caseClassifications", {})
    ]
});
const $3f5b95c03216183e$export$f2dc82468981d46b = new (0, $6ye6I.schema).Entity("specialties", {
    children: [
        new (0, $6ye6I.schema).Entity("specialties", {})
    ]
});
const $3f5b95c03216183e$export$cf4ec302fad65bfd = new (0, $6ye6I.schema).Entity("taskResponses", {
    asset: $3f5b95c03216183e$export$c0aef4fd59bb877d
});
const $3f5b95c03216183e$export$4d22362d9e759546 = new (0, $6ye6I.schema).Entity("tasks", {
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ],
    taskResponses: [
        $3f5b95c03216183e$export$cf4ec302fad65bfd
    ]
});
const $3f5b95c03216183e$export$f8e29d8419a01875 = new (0, $6ye6I.schema).Entity("casePathways", {
    tasks: [
        $3f5b95c03216183e$export$4d22362d9e759546
    ]
});
const $3f5b95c03216183e$export$3b2ffce4a2dd7263 = new (0, $6ye6I.schema).Entity("notifications", {
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ]
});
const $3f5b95c03216183e$export$87152462d2750f10 = new (0, $6ye6I.schema).Entity("cases", {
    leadCareUser: $3f5b95c03216183e$export$431bbfaa07941dc7,
    meetings: [
        new (0, $6ye6I.schema).Entity("meetings", {
            users: [
                $3f5b95c03216183e$export$431bbfaa07941dc7
            ],
            meetingUsers: [
                $3f5b95c03216183e$export$7c96bbbf4cb1d6a8
            ]
        })
    ],
    members: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ],
    meetingCases: [
        new (0, $6ye6I.schema).Entity("meetingCases", {
            case: new (0, $6ye6I.schema).Entity("cases", {}),
            meeting: new (0, $6ye6I.schema).Entity("meetings", {})
        })
    ]
});
const $3f5b95c03216183e$export$ec62d4b5587020fb = new (0, $6ye6I.schema).Entity("meetings", {
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ],
    meetingCases: [
        new (0, $6ye6I.schema).Entity("meetingCases")
    ]
});
const $3f5b95c03216183e$export$5a54fe2fedd8ed4c = new (0, $6ye6I.schema).Entity("meetings", {
    meetingCases: [
        new (0, $6ye6I.schema).Entity("meetingCases", {
            case: new (0, $6ye6I.schema).Entity("cases", {
                leadCareUser: $3f5b95c03216183e$export$431bbfaa07941dc7,
                meetings: [
                    new (0, $6ye6I.schema).Entity("meetings", {})
                ]
            }),
            meeting: new (0, $6ye6I.schema).Entity("meetings", {})
        })
    ],
    meetingUsers: [
        $3f5b95c03216183e$export$7c96bbbf4cb1d6a8
    ],
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ]
});
const $3f5b95c03216183e$export$b0807034b9e786c0 = new (0, $6ye6I.schema).Entity("meetingCases", {
    meeting: new (0, $6ye6I.schema).Entity("meetings", {
        meetingCases: [
            new (0, $6ye6I.schema).Entity("meetingCases", {})
        ],
        users: [
            $3f5b95c03216183e$export$431bbfaa07941dc7
        ]
    }),
    case: new (0, $6ye6I.schema).Entity("cases", {
        leadCareUser: $3f5b95c03216183e$export$431bbfaa07941dc7,
        meetings: [
            new (0, $6ye6I.schema).Entity("meetings", {})
        ]
    })
});
const $3f5b95c03216183e$export$a029490cb1d0421e = new (0, $6ye6I.schema).Entity("teams", {
    teamUsers: [
        $3f5b95c03216183e$export$a9f72eb6997559e1
    ],
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ],
    owner: $3f5b95c03216183e$export$431bbfaa07941dc7
});
const $3f5b95c03216183e$export$91849b17585ff521 = new (0, $6ye6I.schema).Entity("chats", {
    users: [
        $3f5b95c03216183e$export$431bbfaa07941dc7
    ],
    case: new (0, $6ye6I.schema).Entity("cases", {
        leadCareUser: $3f5b95c03216183e$export$431bbfaa07941dc7
    }),
    team: new (0, $6ye6I.schema).Entity("teams", {
        teamUsers: [
            $3f5b95c03216183e$export$a9f72eb6997559e1
        ]
    })
});
const $3f5b95c03216183e$export$20c2bcd3dafa7114 = new (0, $6ye6I.schema).Entity("messages", {
    messageAssets: [
        $3f5b95c03216183e$export$9411805911153210
    ]
});
const $3f5b95c03216183e$export$fcf2624b00ed6a9 = new (0, $6ye6I.schema).Entity("caseSources", {
    caseSources: {}
});

});


parcelRegister("1ITbw", function(module, exports) {

$parcel$export(module.exports, "notificationsUIReducer", () => $a1dedccd5c69439f$export$1a9fea9bcceac580);

var $i5N98 = parcelRequire("i5N98");

var $9VqZS = parcelRequire("9VqZS");

var $jF0Xa = parcelRequire("jF0Xa");
const $a1dedccd5c69439f$export$2d3655bedbdaa06c = (state = 0, action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $a1dedccd5c69439f$export$acb9fd9c5a541324 = (state = 0, action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
        case (0, $9VqZS.NotificationsCableActionTypes).UPDATE_UNREAD_COUNT:
        case (0, $9VqZS.NotificationsCableActionTypes).DELIVER_NOTIFICATION:
            return action.payload.unreadCount;
        default:
            return state;
    }
};
const $a1dedccd5c69439f$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $a1dedccd5c69439f$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $a1dedccd5c69439f$export$1a9fea9bcceac580 = (0, $i5N98.combineReducers)({
    totalNotificationsCount: $a1dedccd5c69439f$export$2d3655bedbdaa06c,
    unreadCount: $a1dedccd5c69439f$export$acb9fd9c5a541324,
    totalPages: $a1dedccd5c69439f$export$828d4f39ed844b18,
    resultsPerPage: $a1dedccd5c69439f$export$2491e5eef6485e6c
});

});

parcelRegister("69iaN", function(module, exports) {

$parcel$export(module.exports, "addCaseToMeetingUIReducer", () => $4631f046b398e486$export$e56ee4d9f5522a2f);

var $i5N98 = parcelRequire("i5N98");

var $7YL61 = parcelRequire("7YL61");
const $4631f046b398e486$export$25c0806b421fd8a2 = (state = 0, action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $4631f046b398e486$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $4631f046b398e486$export$2e414180c3a13344 = (state = [], action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $4631f046b398e486$export$2491e5eef6485e6c = (state = 50, action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $4631f046b398e486$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $4631f046b398e486$export$f18af21d6f4dafd8 = (state = "updated_desc", action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $4631f046b398e486$export$ea7449eefc853a26 = (state = [], action)=>{
    switch(action.type){
        case (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS:
            return action.payload.all.result;
        default:
            return state;
    }
};
const $4631f046b398e486$export$e56ee4d9f5522a2f = (0, $i5N98.combineReducers)({
    totalCasesCount: $4631f046b398e486$export$25c0806b421fd8a2,
    totalPages: $4631f046b398e486$export$828d4f39ed844b18,
    appliedFilters: $4631f046b398e486$export$2e414180c3a13344,
    resultsPerPage: $4631f046b398e486$export$2491e5eef6485e6c,
    searchTerm: $4631f046b398e486$export$83ab5e31da45bcb4,
    orderBy: $4631f046b398e486$export$f18af21d6f4dafd8,
    resultIds: $4631f046b398e486$export$ea7449eefc853a26
});

});

parcelRegister("3ZMdG", function(module, exports) {

$parcel$export(module.exports, "scrollUIReducer", () => $9056b451e06e9407$export$a4d7af23c447e10c);

var $7Bj8I = parcelRequire("7Bj8I");
const $9056b451e06e9407$export$d4c72bab9d6cc13a = {
    mainScrollToPosition: null,
    modalScrollToPosition: null
};
const $9056b451e06e9407$export$a4d7af23c447e10c = (state = $9056b451e06e9407$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $7Bj8I.ScrollActionTypes).UPDATE_MAIN_SCROLL_TO_POSITION:
            return {
                ...state,
                mainScrollToPosition: action.payload
            };
        case (0, $7Bj8I.ScrollActionTypes).UPDATE_MODAL_SCROLL_TO_POSITION:
            return {
                ...state,
                mainScrollToPosition: action.payload
            };
        default:
            return {
                ...state
            };
    }
};

});

parcelRegister("hMZD6", function(module, exports) {

$parcel$export(module.exports, "teamEntityReducer", () => $49d42d667cc6a779$export$53991c4c0f2ffe00);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $1WoI7 = parcelRequire("1WoI7");

var $62Lcu = parcelRequire("62Lcu");

var $hflQv = parcelRequire("hflQv");

var $4VdtH = parcelRequire("4VdtH");

var $fpLIl = parcelRequire("fpLIl");

var $k0jcd = parcelRequire("k0jcd");

var $6ye6I = parcelRequire("6ye6I");
const $49d42d667cc6a779$export$acc42f961369cecb = {};
const $49d42d667cc6a779$export$2dee9bf55024b46d = [];
const $49d42d667cc6a779$export$a1920133d5b0a75 = (state = $49d42d667cc6a779$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_SUCCESS:
        case (0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_SUCCESS:
        case (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_SUCCESS:
        case (0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_SUCCESS:
        case (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.teams || []
            };
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.teams);
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_CHAT:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, (0, $6ye6I.normalize)(action.payload.chat, (0, $k0jcd.fetchChatsSchema)).entities.teams);
        default:
            return {
                ...state
            };
    }
};
const $49d42d667cc6a779$export$a3c51a603cf683c5 = (state = $49d42d667cc6a779$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.all.result;
        case (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_SUCCESS:
            return action.payload.result;
        default:
            return state;
    }
};
const $49d42d667cc6a779$export$53991c4c0f2ffe00 = (0, $i5N98.combineReducers)({
    byId: $49d42d667cc6a779$export$a1920133d5b0a75,
    allIds: $49d42d667cc6a779$export$a3c51a603cf683c5
});

});
parcelRegister("hflQv", function(module, exports) {

$parcel$export(module.exports, "TeamUserActionTypes", () => $fcf1c59aae3be03e$export$452188d226d454a);
// Models
var $fcf1c59aae3be03e$export$452188d226d454a = /*#__PURE__*/ function(TeamUserActionTypes) {
    TeamUserActionTypes["CREATE_TEAM_USER_ASYNC_PENDING"] = "@@teamUser/CREATE_TEAM_USER_ASYNC_PENDING";
    TeamUserActionTypes["CREATE_TEAM_USER_ASYNC_SUCCESS"] = "@@teamUser/CREATE_TEAM_USER_ASYNC_SUCCESS";
    TeamUserActionTypes["CREATE_TEAM_USER_ASYNC_ERROR"] = "@@teamUser/CREATE_TEAM_USER_ASYNC_ERROR";
    TeamUserActionTypes["DESTROY_TEAM_USER_ASYNC_PENDING"] = "@@teamUser/DESTROY_TEAM_USER_ASYNC_PENDING";
    TeamUserActionTypes["DESTROY_TEAM_USER_ASYNC_SUCCESS"] = "@@teamUser/DESTROY_TEAM_USER_ASYNC_SUCCESS";
    TeamUserActionTypes["DESTROY_TEAM_USER_ASYNC_ERROR"] = "@@teamUser/DESTROY_TEAM_USER_ASYNC_ERROR";
    return TeamUserActionTypes;
}({});

});

parcelRegister("fpLIl", function(module, exports) {

$parcel$export(module.exports, "ChatChannelName", () => $904880c3c2bfecbe$export$e70fb58e878f6888);
$parcel$export(module.exports, "chatCablePrefix", () => $904880c3c2bfecbe$export$6b24a5943a92045f);
$parcel$export(module.exports, "ChatTypes", () => $904880c3c2bfecbe$export$c87fd205be4f689b);
$parcel$export(module.exports, "ChatActionTypes", () => $904880c3c2bfecbe$export$779dfa3e072c79af);
$parcel$export(module.exports, "ChatCableActionTypes", () => $904880c3c2bfecbe$export$131d2111203d6f75);
const $904880c3c2bfecbe$export$e70fb58e878f6888 = "ChatChannel";
const $904880c3c2bfecbe$export$6b24a5943a92045f = "@@chatCable/";
var $904880c3c2bfecbe$export$c87fd205be4f689b = /*#__PURE__*/ function(ChatTypes) {
    ChatTypes["TEAM"] = "TeamChat";
    ChatTypes["MEETING"] = "MeetingChat";
    return ChatTypes;
}({});
var $904880c3c2bfecbe$export$779dfa3e072c79af = /*#__PURE__*/ function(ChatActionTypes) {
    ChatActionTypes["FETCH_CHAT_ASYNC_PENDING"] = "@@chats/FETCH_CHAT_ASYNC_PENDING";
    ChatActionTypes["FETCH_CHAT_ASYNC_SUCCESS"] = "@@chats/FETCH_CHAT_ASYNC_SUCCESS";
    ChatActionTypes["FETCH_CHAT_ASYNC_ERROR"] = "@@chats/FETCH_CHAT_ASYNC_ERROR";
    ChatActionTypes["END_CHAT_ASYNC_PENDING"] = "@@chats/END_CHAT_ASYNC_PENDING";
    ChatActionTypes["END_CHAT_ASYNC_SUCCESS"] = "@@chats/END_CHAT_ASYNC_SUCCESS";
    ChatActionTypes["END_CHAT_ASYNC_ERROR"] = "@@chats/END_CHAT_ASYNC_ERROR";
    ChatActionTypes["TOGGLE_MUTED_CHAT_ASYNC_PENDING"] = "@@chats/TOGGLE_MUTED_CHAT_ASYNC_PENDING";
    ChatActionTypes["TOGGLE_MUTED_CHAT_ASYNC_SUCCESS"] = "@@chats/TOGGLE_MUTED_CHAT_ASYNC_SUCCESS";
    ChatActionTypes["TOGGLE_MUTED_CHAT_ASYNC_ERROR"] = "@@chats/TOGGLE_MUTED_CHAT_ASYNC_ERROR";
    ChatActionTypes["FETCH_CHAT_ASSETS_ASYNC_PENDING"] = "@@chats/FETCH_CHAT_ASSETS_ASYNC_PENDING";
    ChatActionTypes["FETCH_CHAT_ASSETS_ASYNC_SUCCESS"] = "@@chats/FETCH_CHAT_ASSETS_ASYNC_SUCCESS";
    ChatActionTypes["FETCH_CHAT_ASSETS_ASYNC_ERROR"] = "@@chats/FETCH_CHAT_ASSETS_ASYNC_ERROR";
    ChatActionTypes["EXPORT_CHAT_ASYNC_PENDING"] = "@@chats/EXPORT_CHAT_ASYNC_PENDING";
    ChatActionTypes["EXPORT_CHAT_ASYNC_SUCCESS"] = "@@chats/EXPORT_CHAT_ASYNC_SUCCESS";
    ChatActionTypes["EXPORT_CHAT_ASYNC_ERROR"] = "@@chats/EXPORT_CHAT_ASYNC_ERROR";
    return ChatActionTypes;
}({});
var $904880c3c2bfecbe$export$131d2111203d6f75 = /*#__PURE__*/ function(ChatCableActionTypes) {
    // INBOUND
    ChatCableActionTypes["DELIVER_MESSAGE"] = "@@chatCable/message/DELIVER";
    ChatCableActionTypes["UPDATE_MESSAGE"] = "@@chatCable/message/UPDATE";
    ChatCableActionTypes["DELIVER_CHAT"] = "@@chatCable/chat/DELIVER";
    ChatCableActionTypes["UPDATE_UNREAD_COUNT"] = "@@chatCable/chat/UPDATE_UNREAD_COUNT";
    ChatCableActionTypes["UPDATE_TOTAL_UNREAD_COUNT"] = "@@chatCable/chats/UPDATE_TOTAL_UNREAD_COUNT";
    ChatCableActionTypes["MARK_USER_START_TYPING"] = "@@chatCable/chat/MARK_USER_START_TYPING";
    ChatCableActionTypes["MARK_USER_STOP_TYPING"] = "@@chatCable/chat/MARK_USER_STOP_TYPING";
    // OUTBOUND
    ChatCableActionTypes["MARK_MESSAGE_AS_READ"] = "@@chatCable/message/MARK_AS_READ";
    ChatCableActionTypes["MARK_CHAT_MESSAGES_AS_READ"] = "@@chatCable/chat/MARK_CHAT_MESSAGES_AS_READ";
    ChatCableActionTypes["UPDATE_USER_IS_TYPING"] = "@@chatCable/chat/UPDATE_USER_IS_TYPING";
    return ChatCableActionTypes;
}({});

});


parcelRegister("3caoj", function(module, exports) {

$parcel$export(module.exports, "taskEntityReducer", () => $3bc6ecc4ccf5d1e9$export$5c232438d407b92e);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $dbP5t = parcelRequire("dbP5t");

var $aif7R = parcelRequire("aif7R");

var $5dOcp = parcelRequire("5dOcp");
const $3bc6ecc4ccf5d1e9$export$acc42f961369cecb = {};
const $3bc6ecc4ccf5d1e9$export$2dee9bf55024b46d = [];
const $3bc6ecc4ccf5d1e9$export$a1920133d5b0a75 = (state = $3bc6ecc4ccf5d1e9$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
        case (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_SUCCESS:
        case (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_SUCCESS:
        case (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_SUCCESS:
        case (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_SUCCESS:
        case (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.tasks || []
            };
        case (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.tasks);
        case (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_TASK_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.all.result]: action.payload.all.entities.tasks[action.payload.all.result] || {}
            };
        case (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_SUCCESS:
            return action.payload.all.entities.tasks || [];
        default:
            return {
                ...state
            };
    }
};
const $3bc6ecc4ccf5d1e9$export$a3c51a603cf683c5 = (state = $3bc6ecc4ccf5d1e9$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(action.payload.all.result);
        default:
            return state;
    }
};
const $3bc6ecc4ccf5d1e9$export$5c232438d407b92e = (0, $i5N98.combineReducers)({
    byId: $3bc6ecc4ccf5d1e9$export$a1920133d5b0a75,
    allIds: $3bc6ecc4ccf5d1e9$export$a3c51a603cf683c5
});

});

parcelRegister("HjPPt", function(module, exports) {

$parcel$export(module.exports, "taskResponseEntityReducer", () => $6330a9999b422f12$export$7f4ef8746b09826e);

var $i5N98 = parcelRequire("i5N98");

var $aif7R = parcelRequire("aif7R");

var $dbP5t = parcelRequire("dbP5t");
const $6330a9999b422f12$export$acc42f961369cecb = {};
const $6330a9999b422f12$export$2dee9bf55024b46d = [];
const $6330a9999b422f12$export$a1920133d5b0a75 = (state = $6330a9999b422f12$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
        case (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_SUCCESS:
        case (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.taskResponses || []
            };
        default:
            return {
                ...state
            };
    }
};
const $6330a9999b422f12$export$a3c51a603cf683c5 = (state = $6330a9999b422f12$export$2dee9bf55024b46d, action)=>{
    action.type;
    return state;
};
const $6330a9999b422f12$export$7f4ef8746b09826e = (0, $i5N98.combineReducers)({
    byId: $6330a9999b422f12$export$a1920133d5b0a75,
    allIds: $6330a9999b422f12$export$a3c51a603cf683c5
});

});

parcelRegister("jXunK", function(module, exports) {

$parcel$export(module.exports, "tasksUIReducer", () => $b66974e37455ee2b$export$d59f4298b1e885af);

var $i5N98 = parcelRequire("i5N98");

var $dbP5t = parcelRequire("dbP5t");

var $jF0Xa = parcelRequire("jF0Xa");
const $b66974e37455ee2b$export$f1b03e6a643fec67 = (state = 0, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$2f4a5744f45495fe = (state = 0, action)=>{
    switch(action.type){
        case (0, $dbP5t.tasksCableActionTypes).UPDATE_OUTSTANDING_COUNT:
            return action.payload.outstandingCount;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$2e414180c3a13344 = (state = [
    "outstanding"
], action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$f18af21d6f4dafd8 = (state = (0, $dbP5t.TasksOrderByOptions).DueDateAsc, action)=>{
    switch(action.type){
        case (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $b66974e37455ee2b$export$d59f4298b1e885af = (0, $i5N98.combineReducers)({
    totalTasksCount: $b66974e37455ee2b$export$f1b03e6a643fec67,
    outstandingCount: $b66974e37455ee2b$export$2f4a5744f45495fe,
    totalPages: $b66974e37455ee2b$export$828d4f39ed844b18,
    resultsPerPage: $b66974e37455ee2b$export$2491e5eef6485e6c,
    appliedFilters: $b66974e37455ee2b$export$2e414180c3a13344,
    orderBy: $b66974e37455ee2b$export$f18af21d6f4dafd8
});

});

parcelRegister("1zsuY", function(module, exports) {

$parcel$export(module.exports, "patientsUIReducer", () => $f2672adece833ca3$export$aa330b1ec8cc3723);

var $i5N98 = parcelRequire("i5N98");

var $55aym = parcelRequire("55aym");

var $jF0Xa = parcelRequire("jF0Xa");
const $f2672adece833ca3$export$9eee933574076659 = (state = 0, action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $f2672adece833ca3$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $f2672adece833ca3$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $f2672adece833ca3$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $f2672adece833ca3$export$f18af21d6f4dafd8 = (state = (0, $55aym.PatientsOrderByOptions).UpdatedAtDesc, action)=>{
    switch(action.type){
        case (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $f2672adece833ca3$export$aa330b1ec8cc3723 = (0, $i5N98.combineReducers)({
    totalPatientsCount: $f2672adece833ca3$export$9eee933574076659,
    totalPages: $f2672adece833ca3$export$828d4f39ed844b18,
    resultsPerPage: $f2672adece833ca3$export$2491e5eef6485e6c,
    searchTerm: $f2672adece833ca3$export$83ab5e31da45bcb4,
    orderBy: $f2672adece833ca3$export$f18af21d6f4dafd8
});

});

parcelRegister("8Ihcy", function(module, exports) {

$parcel$export(module.exports, "patientNewUIReducer", () => $42390489a6b6f1aa$export$fa6abadc76d823fd);

var $i5N98 = parcelRequire("i5N98");

var $5tA5l = parcelRequire("5tA5l");
const $42390489a6b6f1aa$export$99390c19497b01aa = {
    existingPatientIds: null,
    status: null
};
const $42390489a6b6f1aa$export$db4d055dc7679ce0 = (state = $42390489a6b6f1aa$export$99390c19497b01aa, action)=>{
    switch(action.type){
        case (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_FOUND:
            return {
                ...state,
                existingPatientIds: action.payload.result,
                status: (0, $5tA5l.PatientNewCheckDetailsStatuses).Found
            };
        case (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_NOT_FOUND:
            return {
                ...state,
                existingPatientIds: null,
                status: (0, $5tA5l.PatientNewCheckDetailsStatuses).Not_Found
            };
        case (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_PENDING:
            return {
                ...state,
                existingPatientIds: null,
                status: (0, $5tA5l.PatientNewCheckDetailsStatuses).Pending
            };
        case (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_RESET:
            return {
                ...state,
                existingPatientIds: null,
                status: null
            };
        default:
            return state;
    }
};
const $42390489a6b6f1aa$export$fa6abadc76d823fd = (0, $i5N98.combineReducers)({
    checkDetails: $42390489a6b6f1aa$export$db4d055dc7679ce0
});

});

parcelRegister("aHV2Z", function(module, exports) {

$parcel$export(module.exports, "teamsSearchUIReducer", () => $9f41cb252d1e8ce7$export$5c2e7c9292cb42dd);

var $i5N98 = parcelRequire("i5N98");

var $62Lcu = parcelRequire("62Lcu");

var $jF0Xa = parcelRequire("jF0Xa");
const $9f41cb252d1e8ce7$export$61e95feac200bba6 = (state = 0, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$2e414180c3a13344 = (state = [
    "isMember",
    "isOwner"
], action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$f18af21d6f4dafd8 = (state = (0, $62Lcu.TeamsOrderByOptions).UpdatedDesc, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $9f41cb252d1e8ce7$export$5c2e7c9292cb42dd = (0, $i5N98.combineReducers)({
    totalItems: $9f41cb252d1e8ce7$export$61e95feac200bba6,
    totalPages: $9f41cb252d1e8ce7$export$828d4f39ed844b18,
    appliedFilters: $9f41cb252d1e8ce7$export$2e414180c3a13344,
    resultsPerPage: $9f41cb252d1e8ce7$export$2491e5eef6485e6c,
    searchTerm: $9f41cb252d1e8ce7$export$83ab5e31da45bcb4,
    orderBy: $9f41cb252d1e8ce7$export$f18af21d6f4dafd8
});

});

parcelRegister("8ZR2S", function(module, exports) {

$parcel$export(module.exports, "teamUserEntityReducer", () => $86c17e83a666c62d$export$725c14189a9bf1dd);

var $i5N98 = parcelRequire("i5N98");

var $hflQv = parcelRequire("hflQv");

var $62Lcu = parcelRequire("62Lcu");

var $1WoI7 = parcelRequire("1WoI7");
const $86c17e83a666c62d$export$acc42f961369cecb = {};
const $86c17e83a666c62d$export$2dee9bf55024b46d = [];
const $86c17e83a666c62d$export$a1920133d5b0a75 = (state = $86c17e83a666c62d$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.teamUsers
            };
        case (0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_SUCCESS:
        case (0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_SUCCESS:
        case (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_SUCCESS:
        case (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.teamUsers
            };
        default:
            return {
                ...state
            };
    }
};
const $86c17e83a666c62d$export$a3c51a603cf683c5 = (state = $86c17e83a666c62d$export$2dee9bf55024b46d, action)=>{
    action.type;
    return state;
};
const $86c17e83a666c62d$export$725c14189a9bf1dd = (0, $i5N98.combineReducers)({
    byId: $86c17e83a666c62d$export$a1920133d5b0a75,
    allIds: $86c17e83a666c62d$export$a3c51a603cf683c5
});

});

parcelRegister("39eBL", function(module, exports) {

$parcel$export(module.exports, "chatsUIReducer", () => $b3e6bf82a979bf71$export$ccb4ec716ea52acb);

var $i5N98 = parcelRequire("i5N98");

var $jF0Xa = parcelRequire("jF0Xa");

var $4VdtH = parcelRequire("4VdtH");
const $b3e6bf82a979bf71$export$5ef5b6eebdb40a69 = (state = null, action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).UPDATED_SELECTED_CHAT_ID:
            return action.payload;
        default:
            return state;
    }
};
const $b3e6bf82a979bf71$export$61e95feac200bba6 = (state = 0, action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $b3e6bf82a979bf71$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $b3e6bf82a979bf71$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $b3e6bf82a979bf71$export$ccb4ec716ea52acb = (0, $i5N98.combineReducers)({
    selectedChatId: $b3e6bf82a979bf71$export$5ef5b6eebdb40a69,
    totalItems: $b3e6bf82a979bf71$export$61e95feac200bba6,
    totalPages: $b3e6bf82a979bf71$export$828d4f39ed844b18,
    resultsPerPage: $b3e6bf82a979bf71$export$2491e5eef6485e6c
});

});

parcelRegister("5gWL3", function(module, exports) {

$parcel$export(module.exports, "chatEntityReducer", () => $9a64aad1e7fd08b4$export$e89a1aa7c0c281f8);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $4VdtH = parcelRequire("4VdtH");

var $fpLIl = parcelRequire("fpLIl");

var $5Ah2h = parcelRequire("5Ah2h");

var $gyfTN = parcelRequire("gyfTN");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");
const $9a64aad1e7fd08b4$export$acc42f961369cecb = {};
const $9a64aad1e7fd08b4$export$2dee9bf55024b46d = [];
const $9a64aad1e7fd08b4$export$a1920133d5b0a75 = (state = $9a64aad1e7fd08b4$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.chats);
        case (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASYNC_SUCCESS:
        case (0, $fpLIl.ChatActionTypes).END_CHAT_ASYNC_SUCCESS:
        case (0, $fpLIl.ChatActionTypes).TOGGLE_MUTED_CHAT_ASYNC_SUCCESS:
        case (0, $fpLIl.ChatActionTypes).EXPORT_CHAT_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.entities.chats);
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.chatId]: {
                    ...state[action.payload.chatId],
                    messages: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
                        ...state[action.payload.chatId].messages || [],
                        ...action.payload.all.result
                    ])
                }
            };
        case (0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.chats);
        case (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty(action.payload.all.result)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.chatId]: {
                    ...state[action.payload.chatId],
                    messageAssets: action.payload.all.result
                }
            };
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_CHAT:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, (0, $6ye6I.normalize)(action.payload.chat, (0, $k0jcd.fetchChatsSchema)).entities.chats);
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
            return {
                ...state,
                [action.payload.message.chatId]: {
                    ...state[action.payload.message.chatId],
                    latestMessage: action.payload.message,
                    unreadCount: action.payload.unreadCount,
                    messages: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
                        action.payload.message.id,
                        ...state[action.payload.message.chatId].messages || []
                    ])
                }
            };
        case (0, $fpLIl.ChatCableActionTypes).UPDATE_MESSAGE:
            if (state[action.payload?.message?.chatId]?.latestMessage?.id !== action.payload.message.id) return state;
            return {
                ...state,
                [action.payload.message.chatId]: {
                    ...state[action.payload.message.chatId],
                    unreadCount: action.payload.unreadCount,
                    latestMessage: action.payload.message
                }
            };
        case (0, $fpLIl.ChatCableActionTypes).UPDATE_UNREAD_COUNT:
            return {
                ...state,
                [action.payload.chatId]: {
                    ...state[action.payload.chatId],
                    unreadCount: action.payload.unreadCount
                }
            };
        case (0, $fpLIl.ChatCableActionTypes).MARK_USER_START_TYPING:
            if (!state[action.payload.chatId]) return state;
            if (state[action.payload.chatId].options?.muted) return state;
            return {
                ...state,
                [action.payload.chatId]: {
                    ...state[action.payload.chatId],
                    usersTypingIds: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
                        ...state[action.payload.chatId].usersTypingIds || [],
                        action.payload.userId
                    ])
                }
            };
        case (0, $fpLIl.ChatCableActionTypes).MARK_USER_STOP_TYPING:
            if (!state[action.payload.chatId]) return state;
            return {
                ...state,
                [action.payload.chatId]: {
                    ...state[action.payload.chatId],
                    usersTypingIds: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).remove(state[action.payload.chatId].usersTypingIds, (userId)=>{
                        action.payload.userId;
                    })
                }
            };
        default:
            return {
                ...state
            };
    }
};
const $9a64aad1e7fd08b4$export$a3c51a603cf683c5 = (state = $9a64aad1e7fd08b4$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
                ...state || [],
                ...action.payload.all.result
            ]);
        case (0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(action.payload.all.result, state));
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(action.payload.message.chatId, state));
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_CHAT:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(action.payload.chat.id, state));
        default:
            return state;
    }
};
const $9a64aad1e7fd08b4$export$e89a1aa7c0c281f8 = (0, $i5N98.combineReducers)({
    byId: $9a64aad1e7fd08b4$export$a1920133d5b0a75,
    allIds: $9a64aad1e7fd08b4$export$a3c51a603cf683c5
});

});
parcelRegister("5Ah2h", function(module, exports) {

$parcel$export(module.exports, "ChatMessagesActionTypes", () => $ff0b3de4f9aa53e5$export$9856bda487bfae67);
var $ff0b3de4f9aa53e5$export$9856bda487bfae67 = /*#__PURE__*/ function(ChatMessagesActionTypes) {
    ChatMessagesActionTypes["FETCH_CHAT_MESSAGES_ASYNC_PENDING"] = "@@messages/FETCH_CHAT_MESSAGES_ASYNC_PENDING";
    ChatMessagesActionTypes["FETCH_CHAT_MESSAGES_ASYNC_SUCCESS"] = "@@messages/FETCH_CHAT_MESSAGES_ASYNC_SUCCESS";
    ChatMessagesActionTypes["FETCH_CHAT_MESSAGES_ASYNC_ERROR"] = "@@messages/FETCH_CHAT_MESSAGES_ASYNC_ERROR";
    ChatMessagesActionTypes["UPDATE_NOTIFICATION_MESSAGE"] = "@@messages/UPDATE_NOTIFICATION_MESSAGE";
    return ChatMessagesActionTypes;
}({});

});

parcelRegister("gyfTN", function(module, exports) {

$parcel$export(module.exports, "ChatNewActionTypes", () => $485b1a4368d9a1af$export$9b285d114695c50d);
// Models
var $485b1a4368d9a1af$export$9b285d114695c50d = /*#__PURE__*/ function(ChatNewActionTypes) {
    ChatNewActionTypes["CREATE_CHAT_ASYNC_PENDING"] = "@@chats/CREATE_CHAT_ASYNC_PENDING";
    ChatNewActionTypes["CREATE_CHAT_ASYNC_SUCCESS"] = "@@chats/CREATE_CHAT_ASYNC_SUCCESS";
    ChatNewActionTypes["CREATE_CHAT_ASYNC_ERROR"] = "@@chats/CREATE_CHAT_ASYNC_ERROR";
    return ChatNewActionTypes;
}({});

});


parcelRegister("6JuOP", function(module, exports) {

$parcel$export(module.exports, "messageEntityReducer", () => $cec813e62762628c$export$e3208bfdbd8a696c);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $5Ah2h = parcelRequire("5Ah2h");

var $fpLIl = parcelRequire("fpLIl");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");
const $cec813e62762628c$export$acc42f961369cecb = {};
const $cec813e62762628c$export$2dee9bf55024b46d = [];
const $cec813e62762628c$export$a1920133d5b0a75 = (state = $cec813e62762628c$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.messages);
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
        case (0, $fpLIl.ChatCableActionTypes).UPDATE_MESSAGE:
            return {
                ...state,
                // Payload from cable must be normalized
                ...(0, $6ye6I.normalize)(action.payload.message, (0, $k0jcd.fetchMessagesSchema)).entities.messages || {}
            };
        default:
            return {
                ...state
            };
    }
};
const $cec813e62762628c$export$a3c51a603cf683c5 = (state = $cec813e62762628c$export$2dee9bf55024b46d, action)=>{
    action.type;
    return state;
};
const $cec813e62762628c$export$e3208bfdbd8a696c = (0, $i5N98.combineReducers)({
    byId: $cec813e62762628c$export$a1920133d5b0a75,
    allIds: $cec813e62762628c$export$a3c51a603cf683c5
});

});

parcelRegister("aD4Mq", function(module, exports) {

$parcel$export(module.exports, "messagesUIReducer", () => $9d33d92b4b4d0c4c$export$1c2d175d9818f549);

var $i5N98 = parcelRequire("i5N98");

var $jF0Xa = parcelRequire("jF0Xa");

var $fpLIl = parcelRequire("fpLIl");

var $5Ah2h = parcelRequire("5Ah2h");
const $9d33d92b4b4d0c4c$export$61e95feac200bba6 = (state = 0, action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
            return action.payload.totalItems;
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
            return state + 1;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$20bb0d907fbbe433 = (state = false, action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_ERROR:
            return false;
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_PENDING:
            return true;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$acb9fd9c5a541324 = (state = 0, action)=>{
    switch(action.type){
        case (0, $fpLIl.ChatCableActionTypes).UPDATE_TOTAL_UNREAD_COUNT:
            return action.payload.unreadCount;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$bf74c78c591ce4e2 = (state = null, action)=>{
    switch(action.type){
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
            return action.payload.message.id;
        case (0, $5Ah2h.ChatMessagesActionTypes).UPDATE_NOTIFICATION_MESSAGE:
            return action.payload;
        default:
            return state;
    }
};
const $9d33d92b4b4d0c4c$export$1c2d175d9818f549 = (0, $i5N98.combineReducers)({
    totalItems: $9d33d92b4b4d0c4c$export$61e95feac200bba6,
    totalPages: $9d33d92b4b4d0c4c$export$828d4f39ed844b18,
    resultsPerPage: $9d33d92b4b4d0c4c$export$2491e5eef6485e6c,
    isLoading: $9d33d92b4b4d0c4c$export$20bb0d907fbbe433,
    unreadCount: $9d33d92b4b4d0c4c$export$acb9fd9c5a541324,
    notificationMessageId: $9d33d92b4b4d0c4c$export$bf74c78c591ce4e2
});

});

parcelRegister("7Rmod", function(module, exports) {

$parcel$export(module.exports, "auditEventsEntityReducer", () => $6701c16db7df73d7$export$6c0629cfc6d8ae70);

var $i5N98 = parcelRequire("i5N98");

var $aBwAi = parcelRequire("aBwAi");

var $f1q41 = parcelRequire("f1q41");
const $6701c16db7df73d7$export$acc42f961369cecb = {};
const $6701c16db7df73d7$export$2dee9bf55024b46d = {};
const $6701c16db7df73d7$export$a1920133d5b0a75 = (state = $6701c16db7df73d7$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.auditEvents);
        default:
            return {
                ...state
            };
    }
};
const $6701c16db7df73d7$export$48669d9f41bbb8bb = (state = $6701c16db7df73d7$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, {
                [action.payload.entityId]: action.payload.all.result
            });
        default:
            return state;
    }
};
const $6701c16db7df73d7$export$6c0629cfc6d8ae70 = (0, $i5N98.combineReducers)({
    byId: $6701c16db7df73d7$export$a1920133d5b0a75,
    allIdsByEntityId: $6701c16db7df73d7$export$48669d9f41bbb8bb
});

});
parcelRegister("aBwAi", function(module, exports) {

$parcel$export(module.exports, "AuditEventsActionTypes", () => $4a9137391c0affce$export$3fea86d629f7ff61);
$parcel$export(module.exports, "AuditAssetComponentTypes", () => $4a9137391c0affce$export$c9abea3e2750b9d);
$parcel$export(module.exports, "AuditEventDocumentTypes", () => $4a9137391c0affce$export$1edb4acdecab431a);
$parcel$export(module.exports, "AuditEventTypes", () => $4a9137391c0affce$export$9653db67860e4db2);
$parcel$export(module.exports, "AuditEventsWithTimeOnly", () => $4a9137391c0affce$export$66a2b845cd77e91d);
$parcel$export(module.exports, "CardIconStyle", () => $4a9137391c0affce$export$de9d0831cb80938);
$parcel$export(module.exports, "CardObjectTypes", () => $4a9137391c0affce$export$2a4ef76e618ce955);
var $4a9137391c0affce$export$3fea86d629f7ff61 = /*#__PURE__*/ function(AuditEventsActionTypes) {
    AuditEventsActionTypes["FETCH_AUDIT_EVENTS_ASYNC_PENDING"] = "@@assets/FETCH_AUDIT_EVENTS_ASYNC_PENDING";
    AuditEventsActionTypes["FETCH_AUDIT_EVENTS_ASYNC_SUCCESS"] = "@@assets/FETCH_AUDIT_EVENTS_ASYNC_SUCCESS";
    AuditEventsActionTypes["FETCH_AUDIT_EVENTS_ASYNC_ERROR"] = "@@assets/FETCH_AUDIT_EVENTS_ASYNC_ERROR";
    return AuditEventsActionTypes;
}({});
var $4a9137391c0affce$export$c9abea3e2750b9d = /*#__PURE__*/ function(AuditAssetComponentTypes) {
    AuditAssetComponentTypes["commentAdd"] = "comment_added";
    AuditAssetComponentTypes["commentRemove"] = "comment_removed";
    AuditAssetComponentTypes["decision"] = "decision_added";
    AuditAssetComponentTypes["deferral"] = "deferral";
    AuditAssetComponentTypes["recommendationAdded"] = "recommendation_added";
    AuditAssetComponentTypes["recommendationApproved"] = "recommendation_approved";
    AuditAssetComponentTypes["recommendationRejected"] = "recommendation_rejected";
    AuditAssetComponentTypes["recommendationSaved"] = "recommendation_saved";
    AuditAssetComponentTypes["recommendationUpdated"] = "recommendation_updated";
    AuditAssetComponentTypes["caseReportGenerated"] = "case_report_generated";
    AuditAssetComponentTypes["documentAdded"] = "document_added";
    AuditAssetComponentTypes["documentRemoved"] = "document_removed";
    AuditAssetComponentTypes["linkAdded"] = "link_added";
    AuditAssetComponentTypes["linkRemoved"] = "link_removed";
    AuditAssetComponentTypes["commentSelectedToMeetingAssets"] = "comment_selected_to_meeting_assets";
    AuditAssetComponentTypes["commentRemovedFromMeetingAssets"] = "comment_removed_from_meeting_assets";
    AuditAssetComponentTypes["decisionSelectedToMeetingAssets"] = "decision_selected_to_meeting_assets";
    AuditAssetComponentTypes["decisionRemovedFromMeetingAssets"] = "decision_removed_from_meeting_assets";
    AuditAssetComponentTypes["recommendationSelectedToMeetingAssets"] = "recommendation_selected_to_meeting_assets";
    AuditAssetComponentTypes["recommendationRemovedFromMeetingAssets"] = "recommendation_removed_from_meeting_assets";
    AuditAssetComponentTypes["casereportSelectedToMeetingAssets"] = "casereport_selected_to_meeting_assets";
    AuditAssetComponentTypes["casereportRemovedFromMeetingAssets"] = "casereport_removed_from_meeting_assets";
    AuditAssetComponentTypes["imageSelectedToMeetingAssets"] = "image_selected_to_meeting_assets";
    AuditAssetComponentTypes["imageRemovedFromMeetingAssets"] = "image_removed_from_meeting_assets";
    AuditAssetComponentTypes["pdfSelectedToMeetingAssets"] = "pdf_selected_to_meeting_assets";
    AuditAssetComponentTypes["pdfRemovedFromMeetingAssets"] = "pdf_removed_from_meeting_assets";
    AuditAssetComponentTypes["linkSelectedToMeetingAssets"] = "link_selected_to_meeting_assets";
    AuditAssetComponentTypes["linkRemovedFromMeetingAssets"] = "link_removed_from_meeting_assets";
    AuditAssetComponentTypes["meetingCreated"] = "meeting_created";
    AuditAssetComponentTypes["meetingUserAdded"] = "meeting_user_added";
    AuditAssetComponentTypes["meetingUserRemoved"] = "meeting_user_removed";
    AuditAssetComponentTypes["meetingCaseAdded"] = "meeting_case_added";
    AuditAssetComponentTypes["meetingCaseRemoved"] = "meeting_case_removed";
    AuditAssetComponentTypes["meetingedited"] = "meeting_edited";
    AuditAssetComponentTypes["meetingInProgress"] = "meeting_in_progress";
    AuditAssetComponentTypes["meetingUserJoined"] = "meeting_user_joined";
    AuditAssetComponentTypes["meetingUserLeft"] = "meeting_user_left";
    AuditAssetComponentTypes["meetingCoordinatorAssigned"] = "meeting_coordinator_assigned";
    AuditAssetComponentTypes["meetingPresenterAssigned"] = "meeting_presenter_assigned";
    AuditAssetComponentTypes["meetingScribeAssigned"] = "meeting_scribe_assigned";
    AuditAssetComponentTypes["meetingPresenterAccepted"] = "meeting_presenter_accepted";
    AuditAssetComponentTypes["meetingScribeAccepted"] = "meeting_scribe_accepted";
    AuditAssetComponentTypes["meetingSelectedCase"] = "meeting_selected_case";
    AuditAssetComponentTypes["meetingRecommendationPending"] = "meeting_recommendation_pending";
    AuditAssetComponentTypes["meetingConsent"] = "meeting_consent";
    AuditAssetComponentTypes["meetingConsentOnBehalf"] = "meeting_consent_on_behalf";
    AuditAssetComponentTypes["meetingRecommendationSaved"] = "meeting_recommendation_saved";
    AuditAssetComponentTypes["meetingRecommendationDeferred"] = "meeting_recommendation_deferred";
    AuditAssetComponentTypes["meetingEnded"] = "meeting_ended";
    AuditAssetComponentTypes["meetingCancelled"] = "meeting_cancelled";
    AuditAssetComponentTypes["meetingCaseDeferred"] = "meeting_case_deferred";
    AuditAssetComponentTypes["caseCreated"] = "case_created";
    AuditAssetComponentTypes["caseMemberAdded"] = "case_member_added";
    AuditAssetComponentTypes["caseMemberRemoved"] = "case_member_removed";
    AuditAssetComponentTypes["caseUpdated"] = "case_updated";
    AuditAssetComponentTypes["caseLocked"] = "case_locked";
    AuditAssetComponentTypes["caseUnlocked"] = "case_unlocked";
    AuditAssetComponentTypes["deferralAdded"] = "deferral_added";
    AuditAssetComponentTypes["userEdited"] = "user_edited";
    AuditAssetComponentTypes["userRemoveSpecialty"] = "user_remove_specialty";
    AuditAssetComponentTypes["userAddSpecialty"] = "user_add_specialty";
    AuditAssetComponentTypes["userCreated"] = "user_created";
    AuditAssetComponentTypes["userStatus"] = "user_status";
    AuditAssetComponentTypes["userActivated"] = "user_activated";
    return AuditAssetComponentTypes;
}({});
var $4a9137391c0affce$export$1edb4acdecab431a = /*#__PURE__*/ function(AuditEventDocumentTypes) {
    AuditEventDocumentTypes["PdfFile"] = "application/pdf";
    AuditEventDocumentTypes["ImagePng"] = "image/png";
    AuditEventDocumentTypes["ImageJpeg"] = "image/jpeg";
    return AuditEventDocumentTypes;
}({});
var $4a9137391c0affce$export$9653db67860e4db2 = /*#__PURE__*/ function(AuditEventTypes) {
    AuditEventTypes["MEETING_CASE"] = "MeetingCase";
    AuditEventTypes["MEETING"] = "Meeting";
    AuditEventTypes["CASE"] = "Case";
    return AuditEventTypes;
}({});
var $4a9137391c0affce$export$66a2b845cd77e91d = /*#__PURE__*/ function(AuditEventsWithTimeOnly) {
    AuditEventsWithTimeOnly["meeting_user_joined"] = "meeting_user_joined";
    AuditEventsWithTimeOnly["meeting_user_left"] = "meeting_user_left";
    return AuditEventsWithTimeOnly;
}({});
var $4a9137391c0affce$export$de9d0831cb80938 = /*#__PURE__*/ function(CardIconStyle) {
    CardIconStyle["purpleColor"] = "text-ch-purple-500";
    CardIconStyle["orangeColor"] = "text-ch-orange-500";
    CardIconStyle["grayColor"] = "text-ch-gray-500";
    CardIconStyle["blueColor"] = "text-ch-blue-500";
    CardIconStyle["redColor"] = "text-ch-red-500";
    CardIconStyle["greenColor"] = "text-ch-green-500";
    CardIconStyle["imageStyle"] = "mr-2 mt-1 w-5 h-5";
    return CardIconStyle;
}({});
var $4a9137391c0affce$export$2a4ef76e618ce955 = /*#__PURE__*/ function(CardObjectTypes) {
    CardObjectTypes["noChangeInTime"] = "noChange";
    return CardObjectTypes;
}({});

});


parcelRegister("dkFx6", function(module, exports) {

$parcel$export(module.exports, "pathwaysUIReducer", () => $fc83565876eb9ad5$export$510f617ea940c127);

var $i5N98 = parcelRequire("i5N98");

var $eCmSQ = parcelRequire("eCmSQ");

var $jF0Xa = parcelRequire("jF0Xa");
const $fc83565876eb9ad5$export$5abde1a972b588f4 = (state = 0, action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$2e414180c3a13344 = (state = [], action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$f18af21d6f4dafd8 = (state = (0, $eCmSQ.PathwaysOrderByOptions).NameAsc, action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$48d7d2e4ea012dfb = (state = [], action)=>{
    switch(action.type){
        case (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS:
            return action.payload.all.result;
        default:
            return state;
    }
};
const $fc83565876eb9ad5$export$510f617ea940c127 = (0, $i5N98.combineReducers)({
    totalPathwaysCount: $fc83565876eb9ad5$export$5abde1a972b588f4,
    totalPages: $fc83565876eb9ad5$export$828d4f39ed844b18,
    appliedFilters: $fc83565876eb9ad5$export$2e414180c3a13344,
    resultsPerPage: $fc83565876eb9ad5$export$2491e5eef6485e6c,
    searchTerm: $fc83565876eb9ad5$export$83ab5e31da45bcb4,
    orderBy: $fc83565876eb9ad5$export$f18af21d6f4dafd8,
    onPage: $fc83565876eb9ad5$export$48d7d2e4ea012dfb
});

});

parcelRegister("3zYtN", function(module, exports) {

$parcel$export(module.exports, "messageAssetEntityReducer", () => $713943ac3c98dda9$export$480c05bff769de03);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $5Ah2h = parcelRequire("5Ah2h");

var $fpLIl = parcelRequire("fpLIl");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");
const $713943ac3c98dda9$export$acc42f961369cecb = {};
const $713943ac3c98dda9$export$2dee9bf55024b46d = [];
const $713943ac3c98dda9$export$a1920133d5b0a75 = (state = $713943ac3c98dda9$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS:
        case (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.messageAssets);
        case (0, $fpLIl.ChatCableActionTypes).DELIVER_MESSAGE:
        case (0, $fpLIl.ChatCableActionTypes).UPDATE_MESSAGE:
            return {
                ...state,
                // Payload from cable must be normalized
                ...(0, $6ye6I.normalize)(action.payload.message, (0, $k0jcd.fetchMessagesSchema)).entities.messageAssets || {}
            };
        default:
            return {
                ...state
            };
    }
};
const $713943ac3c98dda9$export$a3c51a603cf683c5 = (state = $713943ac3c98dda9$export$2dee9bf55024b46d, action)=>{
    action.type;
    return state;
};
const $713943ac3c98dda9$export$480c05bff769de03 = (0, $i5N98.combineReducers)({
    byId: $713943ac3c98dda9$export$a1920133d5b0a75,
    allIds: $713943ac3c98dda9$export$a3c51a603cf683c5
});

});

parcelRegister("jpYGU", function(module, exports) {

$parcel$export(module.exports, "addPathwayToCaseUIReducer", () => $85ca60278d03efec$export$5a4d219163f049b4);

var $i5N98 = parcelRequire("i5N98");

var $cmXxm = parcelRequire("cmXxm");
const $85ca60278d03efec$export$5abde1a972b588f4 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.totalItems;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.totalPages;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$2e414180c3a13344 = (state = [], action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.appliedFilters;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$2491e5eef6485e6c = (state = 50, action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.resultsPerPage;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.searchTerm;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$f18af21d6f4dafd8 = (state = "updated_desc", action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.orderBy;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$ea7449eefc853a26 = (state = [], action)=>{
    switch(action.type){
        case (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS:
            return action.payload.all.result;
        default:
            return state;
    }
};
const $85ca60278d03efec$export$5a4d219163f049b4 = (0, $i5N98.combineReducers)({
    totalPathwaysCount: $85ca60278d03efec$export$5abde1a972b588f4,
    totalPages: $85ca60278d03efec$export$828d4f39ed844b18,
    appliedFilters: $85ca60278d03efec$export$2e414180c3a13344,
    resultsPerPage: $85ca60278d03efec$export$2491e5eef6485e6c,
    searchTerm: $85ca60278d03efec$export$83ab5e31da45bcb4,
    orderBy: $85ca60278d03efec$export$f18af21d6f4dafd8,
    resultIds: $85ca60278d03efec$export$ea7449eefc853a26
});

});

parcelRegister("fFTSq", function(module, exports) {

$parcel$export(module.exports, "casePathwaysEntityReducer", () => $c8cad5713e9ffd47$export$892381d7be246ef6);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $5dOcp = parcelRequire("5dOcp");

var $dbP5t = parcelRequire("dbP5t");
const $c8cad5713e9ffd47$export$acc42f961369cecb = {};
const $c8cad5713e9ffd47$export$2dee9bf55024b46d = [];
const $c8cad5713e9ffd47$export$a1920133d5b0a75 = (state = $c8cad5713e9ffd47$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_SUCCESS:
        case (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_SUCCESS:
        case (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.all.entities.casePathways || []
            };
        case (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_SUCCESS:
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isUndefined(action.payload.casePathwayId)) return {
                ...state
            };
            return {
                ...state,
                [action.payload.casePathwayId]: {
                    ...state[action.payload.casePathwayId],
                    tasks: [
                        ...state[action.payload.casePathwayId].tasks || [],
                        Object.keys(action.payload.all.entities.tasks)[0] || {}
                    ]
                }
            };
        case (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.casePathwayId]: {
                    ...state[action.payload.casePathwayId],
                    tasks: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).without(state[action.payload.casePathwayId].tasks, action.payload.taskId)
                }
            };
        default:
            return {
                ...state
            };
    }
};
const $c8cad5713e9ffd47$export$a3c51a603cf683c5 = (state = $c8cad5713e9ffd47$export$2dee9bf55024b46d, action)=>{
    action.type;
    return state;
};
const $c8cad5713e9ffd47$export$892381d7be246ef6 = (0, $i5N98.combineReducers)({
    byId: $c8cad5713e9ffd47$export$a1920133d5b0a75,
    allIds: $c8cad5713e9ffd47$export$a3c51a603cf683c5
});

});

parcelRegister("bfz8k", function(module, exports) {

$parcel$export(module.exports, "caseSourceEntityReducer", () => $418f436f499e8035$export$62f6d832bd97c1de);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $g7ibY = parcelRequire("g7ibY");
const $418f436f499e8035$export$acc42f961369cecb = {};
const $418f436f499e8035$export$2dee9bf55024b46d = [];
const $418f436f499e8035$export$a1920133d5b0a75 = (state = $418f436f499e8035$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_SUCCESS:
            return {
                ...state,
                ...action.payload.entities.caseSources
            };
        default:
            return {
                ...state
            };
    }
};
const $418f436f499e8035$export$a3c51a603cf683c5 = (state = $418f436f499e8035$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.result));
        default:
            return state;
    }
};
const $418f436f499e8035$export$62f6d832bd97c1de = (0, $i5N98.combineReducers)({
    byId: $418f436f499e8035$export$a1920133d5b0a75,
    allIds: $418f436f499e8035$export$a3c51a603cf683c5
});

});
parcelRegister("g7ibY", function(module, exports) {

$parcel$export(module.exports, "CaseSourceActionTypes", () => $525a384b5cf25ab7$export$cb0ebc8d065cc705);
var $525a384b5cf25ab7$export$cb0ebc8d065cc705 = /*#__PURE__*/ function(CaseSourceActionTypes) {
    CaseSourceActionTypes["FETCH_CASE_SOURCES_ASYNC_PENDING"] = "@@caseSource/FETCH_CASE_SOURCES_ASYNC_PENDING";
    CaseSourceActionTypes["FETCH_CASE_SOURCES_ASYNC_SUCCESS"] = "@@caseSource/FETCH_CASE_SOURCES_ASYNC_SUCCESS";
    CaseSourceActionTypes["FETCH_CASE_SOURCES_ASYNC_ERROR"] = "@@caseSource/FETCH_CASE_SOURCE_ASYNC_ERROR";
    return CaseSourceActionTypes;
}({});

});


parcelRegister("d6pre", function(module, exports) {

$parcel$export(module.exports, "sharedAssetEntityReducer", () => $0619361ba9263341$export$8ce7c3fb7a1e5648);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $dUFb6 = parcelRequire("dUFb6");
const $0619361ba9263341$export$a1920133d5b0a75 = (state = {}, action)=>{
    switch(action.type){
        case (0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_SUCCESS:
        case (0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_SUCCESS:
        case (0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload.all.entities.assets);
        default:
            return state;
    }
};
const $0619361ba9263341$export$53f56914385eb158 = (state = {}, action)=>{
    switch(action.type){
        case (0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_SUCCESS:
        case (0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_SUCCESS:
        case (0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS:
            return {
                ...state,
                [action.payload.userId]: {
                    ...state[action.payload.userId],
                    [action.payload.caseId]: action.payload.all.result
                }
            };
        default:
            return state;
    }
};
const $0619361ba9263341$export$8ce7c3fb7a1e5648 = (0, $i5N98.combineReducers)({
    byId: $0619361ba9263341$export$a1920133d5b0a75,
    canBeSharedWithUserByUserId: $0619361ba9263341$export$53f56914385eb158
});

});
parcelRegister("dUFb6", function(module, exports) {

$parcel$export(module.exports, "CaseSharedAssetsActionTypes", () => $f723397c39530204$export$4493a6c500f3a4b);
var $f723397c39530204$export$4493a6c500f3a4b = /*#__PURE__*/ function(CaseSharedAssetsActionTypes) {
    CaseSharedAssetsActionTypes["FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_PENDING"] = "@@caseSharedAssets/FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_PENDING";
    CaseSharedAssetsActionTypes["FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_SUCCESS"] = "@@caseSharedAssets/FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_SUCCESS";
    CaseSharedAssetsActionTypes["FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_ERROR"] = "@@caseSharedAssets/FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_ERROR";
    CaseSharedAssetsActionTypes["CREATE_CASE_SHARED_ASSET_ASYNC_PENDING"] = "@@caseSharedAssets/CREATE_CASE_SHARED_ASSET_ASYNC_PENDING";
    CaseSharedAssetsActionTypes["CREATE_CASE_SHARED_ASSET_ASYNC_SUCCESS"] = "@@caseSharedAssets/CREATE_CASE_SHARED_ASSET_ASYNC_SUCCESS";
    CaseSharedAssetsActionTypes["CREATE_CASE_SHARED_ASSET_ASYNC_ERROR"] = "@@caseSharedAssets/CREATE_CASE_SHARED_ASSET_ASYNC_ERROR";
    CaseSharedAssetsActionTypes["DELETE_CASE_SHARED_ASSET_ASYNC_PENDING"] = "@@caseSharedAssets/DELETE_CASE_SHARED_ASSET_ASYNC_PENDING";
    CaseSharedAssetsActionTypes["DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS"] = "@@caseSharedAssets/DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS";
    CaseSharedAssetsActionTypes["DELETE_CASE_SHARED_ASSET_ASYNC_ERROR"] = "@@caseSharedAssets/DELETE_CASE_SHARED_ASSET_ASYNC_ERROR";
    return CaseSharedAssetsActionTypes;
}({});

});


parcelRegister("60s55", function(module, exports) {

$parcel$export(module.exports, "userCheckUIReducer", () => $5ed68bb1a2a5205d$export$75b47af9ae8c2bc);

var $8e5HJ = parcelRequire("8e5HJ");
const $5ed68bb1a2a5205d$export$2ada65d534916c4 = {
    existingUserIds: null,
    status: null
};
const $5ed68bb1a2a5205d$export$75b47af9ae8c2bc = (state = $5ed68bb1a2a5205d$export$2ada65d534916c4, action)=>{
    switch(action.type){
        case (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_FOUND:
            return {
                ...state,
                existingUserIds: action.payload.result,
                status: (0, $8e5HJ.UserCheckStatuses).Found
            };
        case (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_NOT_FOUND:
            return {
                ...state,
                existingUserIds: null,
                status: (0, $8e5HJ.UserCheckStatuses).Not_Found
            };
        case (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_PENDING:
            return {
                ...state,
                status: (0, $8e5HJ.UserCheckStatuses).Pending
            };
        case (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_RESET:
            return {
                ...state,
                existingUserIds: null,
                status: null
            };
        default:
            return state;
    }
};

});

parcelRegister("8LOtr", function(module, exports) {

$parcel$export(module.exports, "analyticsReducer", () => $25ca618a0c180ff4$export$faa4d33b9592bf8b);

var $i5N98 = parcelRequire("i5N98");

var $fMICH = parcelRequire("fMICH");

var $kzoRg = parcelRequire("kzoRg");
const $25ca618a0c180ff4$export$faa4d33b9592bf8b = (0, $i5N98.combineReducers)({
    hospital: (0, $fMICH.hospitalAnalyticsReducer),
    user: (0, $kzoRg.userAnalyticsReducer)
});

});
parcelRegister("fMICH", function(module, exports) {

$parcel$export(module.exports, "hospitalAnalyticsReducer", () => $a21e5c7958b9a47d$export$eb1056b87e49c593);

var $i5N98 = parcelRequire("i5N98");

var $6cmjs = parcelRequire("6cmjs");
function $a21e5c7958b9a47d$export$3fbc163af1c8dc2b(state = [], action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_SUCCESS:
            return [
                ...action.payload.hospitalMeetings
            ];
        default:
            return [
                ...state
            ];
    }
}
function $a21e5c7958b9a47d$export$1cc22839a6311df0(state = [], action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_SUCCESS:
            return [
                ...action.payload.monthlyData
            ];
        default:
            return [
                ...state
            ];
    }
}
function $a21e5c7958b9a47d$export$96a4adb346e3ca03(state = {
    fromYear: new Date().getFullYear()
}, action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_SUCCESS:
            return {
                ...action.payload.meta
            };
        default:
            return {
                ...state
            };
    }
}
const $a21e5c7958b9a47d$export$eb1056b87e49c593 = (0, $i5N98.combineReducers)({
    meetings: $a21e5c7958b9a47d$export$3fbc163af1c8dc2b,
    monthlyData: $a21e5c7958b9a47d$export$1cc22839a6311df0,
    metaData: $a21e5c7958b9a47d$export$96a4adb346e3ca03
});

});

parcelRegister("kzoRg", function(module, exports) {

$parcel$export(module.exports, "userAnalyticsReducer", () => $a4ad95eec3dc26b0$export$afa38b76b5995664);

var $f1q41 = parcelRequire("f1q41");

var $i5N98 = parcelRequire("i5N98");

var $6cmjs = parcelRequire("6cmjs");
function $a4ad95eec3dc26b0$export$75b3c058ed26a0d7(state = {}, action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(action.payload.mdtMeetings, "name");
        default:
            return {
                ...state
            };
    }
}
function $a4ad95eec3dc26b0$export$20361f91b7138bbc(state = {}, action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_SUCCESS:
            {
                const monthlyData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(action.payload.monthlyMeetingData, "name");
                const totalStart = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                const totalMonthlyData = [
                    "invited",
                    "attended",
                    "mdtsInvited",
                    "mdtsAttended",
                    "mdtsContributed"
                ].reduce((acc, key)=>{
                    acc[key] = totalStart;
                    return acc;
                }, {});
                Object.keys(totalMonthlyData).forEach((category)=>{
                    const total = Object.keys(monthlyData).reduce((total, specialty)=>{
                        const specialtyCounts = monthlyData[specialty].monthlyData[category];
                        const newCounts = total.map((t, i)=>t + specialtyCounts[i]);
                        return newCounts;
                    }, totalStart);
                    totalMonthlyData[category] = total;
                });
                monthlyData.Total = {
                    name: "Total",
                    monthlyData: totalMonthlyData
                };
                return monthlyData;
            }
        default:
            return {
                ...state
            };
    }
}
function $a4ad95eec3dc26b0$export$b427ac946693ce20(state = {}, action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(action.payload.monthlyRecomendationData, "name");
        default:
            return {
                ...state
            };
    }
}
const $a4ad95eec3dc26b0$var$initialMetaDataState = {
    fromYear: new Date().getFullYear(),
    months: []
};
function $a4ad95eec3dc26b0$export$96a4adb346e3ca03(state = $a4ad95eec3dc26b0$var$initialMetaDataState, action) {
    switch(action.type){
        case (0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_SUCCESS:
            return {
                ...action.payload.meta
            };
        default:
            return {
                ...state
            };
    }
}
const $a4ad95eec3dc26b0$export$afa38b76b5995664 = (0, $i5N98.combineReducers)({
    mdtMeetings: $a4ad95eec3dc26b0$export$75b3c058ed26a0d7,
    monthlyMeetingData: $a4ad95eec3dc26b0$export$20361f91b7138bbc,
    monthlyRecommendationData: $a4ad95eec3dc26b0$export$b427ac946693ce20,
    metaData: $a4ad95eec3dc26b0$export$96a4adb346e3ca03
});

});


parcelRegister("2R48E", function(module, exports) {

$parcel$export(module.exports, "externalUsersEntityReducer", () => $5011e4ea77feeb25$export$60a1d31193d2543a);

var $i5N98 = parcelRequire("i5N98");

var $f1q41 = parcelRequire("f1q41");

var $8e5HJ = parcelRequire("8e5HJ");
const $5011e4ea77feeb25$var$byId = (state = {}, action)=>{
    switch(action.type){
        case (0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).merge({}, state, action.payload);
        default:
            return state;
    }
};
const $5011e4ea77feeb25$export$a3c51a603cf683c5 = (state = [], action)=>{
    switch(action.type){
        case (0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(state, action.payload.map((user)=>user.id)));
        default:
            return state;
    }
};
const $5011e4ea77feeb25$export$60a1d31193d2543a = (0, $i5N98.combineReducers)({
    byId: $5011e4ea77feeb25$var$byId,
    allIds: $5011e4ea77feeb25$export$a3c51a603cf683c5
});

});

parcelRegister("9iRAU", function(module, exports) {

$parcel$export(module.exports, "patientRadiologyLinkReducer", () => $723d1d2314723a15$export$55b7314939e405b8);

var $i5N98 = parcelRequire("i5N98");

var $7twpo = parcelRequire("7twpo");
const $723d1d2314723a15$export$acc42f961369cecb = {};
const $723d1d2314723a15$export$2dee9bf55024b46d = [];
const $723d1d2314723a15$export$a1920133d5b0a75 = (state = $723d1d2314723a15$export$acc42f961369cecb, action)=>{
    switch(action.type){
        case (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS:
            return action.payload.entities?.patientRadiologyLink || {};
        default:
            return state;
    }
};
const $723d1d2314723a15$export$a3c51a603cf683c5 = (state = $723d1d2314723a15$export$2dee9bf55024b46d, action)=>{
    switch(action.type){
        case (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS:
            return action.payload.result || [];
        default:
            return state;
    }
};
const $723d1d2314723a15$export$55b7314939e405b8 = (0, $i5N98.combineReducers)({
    byId: $723d1d2314723a15$export$a1920133d5b0a75,
    allIds: $723d1d2314723a15$export$a3c51a603cf683c5
});

});

parcelRegister("aRBkT", function(module, exports) {

$parcel$export(module.exports, "patientRadiologyLinkUIReducer", () => $43d4e01c8c745072$export$f17fefbb5f4c21a1);

var $i5N98 = parcelRequire("i5N98");

var $7twpo = parcelRequire("7twpo");
const $43d4e01c8c745072$export$d4c72bab9d6cc13a = {
    fetching: false
};
const $43d4e01c8c745072$export$ba2ae000e8c8d0bd = (state = $43d4e01c8c745072$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_PENDING:
            return true;
        case (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS:
        case (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_ERROR:
            return false;
        default:
            return state;
    }
};
const $43d4e01c8c745072$export$f17fefbb5f4c21a1 = (0, $i5N98.combineReducers)({
    fetching: $43d4e01c8c745072$export$ba2ae000e8c8d0bd
});

});

parcelRegister("lTFOR", function(module, exports) {

$parcel$export(module.exports, "webRTCErrorReducer", () => $507f575636b996d3$export$2ac1c59f70e4df2a);

var $i5N98 = parcelRequire("i5N98");

var $5ng6u = parcelRequire("5ng6u");
const $507f575636b996d3$export$2c8dee2b3e9d54d8 = {};
const $507f575636b996d3$export$22332b17edfb086 = (state = "", action)=>{
    switch(action.type){
        case (0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_ERROR:
            return action.payload.name;
        default:
            return state;
    }
};
const $507f575636b996d3$export$2ac1c59f70e4df2a = (0, $i5N98.combineReducers)({
    mediaError: $507f575636b996d3$export$22332b17edfb086
});

});

parcelRegister("huXgp", function(module, exports) {

$parcel$export(module.exports, "formTemplateEntityReducer", () => $eb3467e3a56fc6ca$export$8bb3729464b21c7c);

var $i5N98 = parcelRequire("i5N98");

var $udwHW = parcelRequire("udwHW");
const $eb3467e3a56fc6ca$var$byId = (state = {}, action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.all.entities.formTemplates;
        default:
            return state;
    }
};
const $eb3467e3a56fc6ca$export$a3c51a603cf683c5 = (state = [], action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.all.result;
        default:
            return state;
    }
};
const $eb3467e3a56fc6ca$export$8bb3729464b21c7c = (0, $i5N98.combineReducers)({
    byId: $eb3467e3a56fc6ca$var$byId,
    allIds: $eb3467e3a56fc6ca$export$a3c51a603cf683c5
});

});

parcelRegister("h1k78", function(module, exports) {

$parcel$export(module.exports, "addFormsToCaseUIReducer", () => $7917afcc7b0f92f7$export$23f2adab655f9454);

var $i5N98 = parcelRequire("i5N98");

var $jF0Xa = parcelRequire("jF0Xa");

var $udwHW = parcelRequire("udwHW");
const $7917afcc7b0f92f7$export$40bc849f07071d2c = (state = 0, action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.totalItems || 0;
        default:
            return state;
    }
};
const $7917afcc7b0f92f7$export$828d4f39ed844b18 = (state = 0, action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.totalPages || 0;
        default:
            return state;
    }
};
const $7917afcc7b0f92f7$export$83ab5e31da45bcb4 = (state = "", action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.searchTerm || "";
        default:
            return state;
    }
};
const $7917afcc7b0f92f7$export$2491e5eef6485e6c = (state = (0, $jF0Xa.defaultPerPage), action)=>{
    switch(action.type){
        case (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
            return action.payload.resultsPerPage || 25;
        default:
            return state;
    }
};
const $7917afcc7b0f92f7$export$23f2adab655f9454 = (0, $i5N98.combineReducers)({
    totalItemsCount: $7917afcc7b0f92f7$export$40bc849f07071d2c,
    totalPages: $7917afcc7b0f92f7$export$828d4f39ed844b18,
    searchTerm: $7917afcc7b0f92f7$export$83ab5e31da45bcb4,
    resultsPerPage: $7917afcc7b0f92f7$export$2491e5eef6485e6c
});

});


parcelRegister("cYXkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7731f34b37c475f$export$2e2bcd8739ae039);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");

var $jbaZ6 = parcelRequire("jbaZ6");

var $1ytqf = parcelRequire("1ytqf");

var $dpAzW = parcelRequire("dpAzW");

var $b7oeO = parcelRequire("b7oeO");

var $jiE79 = parcelRequire("jiE79");

var $2X3Yp = parcelRequire("2X3Yp");

var $crPZr = parcelRequire("crPZr");

var $fsK8M = parcelRequire("fsK8M");

var $jaGaz = parcelRequire("jaGaz");

var $9K2yN = parcelRequire("9K2yN");

var $2Bnvt = parcelRequire("2Bnvt");

var $bliaq = parcelRequire("bliaq");

var $fmC5S = parcelRequire("fmC5S");

var $4a4o1 = parcelRequire("4a4o1");

var $gGw13 = parcelRequire("gGw13");

var $b1nhW = parcelRequire("b1nhW");

var $lNBNb = parcelRequire("lNBNb");

var $aTJFr = parcelRequire("aTJFr");

var $huqcL = parcelRequire("huqcL");

var $g65S5 = parcelRequire("g65S5");

var $eSI7x = parcelRequire("eSI7x");

var $8TRYc = parcelRequire("8TRYc");

var $9CuVR = parcelRequire("9CuVR");

var $cPJVX = parcelRequire("cPJVX");

var $kbbQX = parcelRequire("kbbQX");

var $iJhw3 = parcelRequire("iJhw3");

var $8R3hK = parcelRequire("8R3hK");

var $6zGCD = parcelRequire("6zGCD");

var $9Ujgr = parcelRequire("9Ujgr");

var $2DA70 = parcelRequire("2DA70");

var $5mbCb = parcelRequire("5mbCb");

var $5yqYK = parcelRequire("5yqYK");

var $diHh0 = parcelRequire("diHh0");

var $acSKo = parcelRequire("acSKo");

var $7Dbe5 = parcelRequire("7Dbe5");

var $hr8vc = parcelRequire("hr8vc");

var $3Z0uW = parcelRequire("3Z0uW");

var $3Kxye = parcelRequire("3Kxye");

var $8Ej42 = parcelRequire("8Ej42");

var $aZIV3 = parcelRequire("aZIV3");

var $99nwM = parcelRequire("99nwM");

var $idlfx = parcelRequire("idlfx");

var $6pkbE = parcelRequire("6pkbE");

var $8UrmS = parcelRequire("8UrmS");

var $bYwoy = parcelRequire("bYwoy");

var $hzIUn = parcelRequire("hzIUn");

var $gOH3n = parcelRequire("gOH3n");

var $dlQwf = parcelRequire("dlQwf");

var $bi37B = parcelRequire("bi37B");

var $lIh5L = parcelRequire("lIh5L");

var $hlvWF = parcelRequire("hlvWF");

var $cTdOQ = parcelRequire("cTdOQ");

var $5Qhwh = parcelRequire("5Qhwh");

var $ap7AJ = parcelRequire("ap7AJ");

var $ir3DA = parcelRequire("ir3DA");

var $6wWHW = parcelRequire("6wWHW");

var $41iOM = parcelRequire("41iOM");

var $dP85u = parcelRequire("dP85u");

var $3YWdJ = parcelRequire("3YWdJ");

var $ajhjw = parcelRequire("ajhjw");

var $az88Y = parcelRequire("az88Y");

var $3YlN4 = parcelRequire("3YlN4");

var $2Cl6B = parcelRequire("2Cl6B");

var $afJyW = parcelRequire("afJyW");

var $5A7aD = parcelRequire("5A7aD");

var $daslz = parcelRequire("daslz");

var $gMltz = parcelRequire("gMltz");

var $hxfav = parcelRequire("hxfav");

var $5Fqa8 = parcelRequire("5Fqa8");

var $9wRwq = parcelRequire("9wRwq");

var $eekTo = parcelRequire("eekTo");

var $dPkhY = parcelRequire("dPkhY");

var $ecK25 = parcelRequire("ecK25");

var $3Lz9Y = parcelRequire("3Lz9Y");

var $egaCo = parcelRequire("egaCo");

var $3mrfe = parcelRequire("3mrfe");

var $bQbFW = parcelRequire("bQbFW");
function* $a7731f34b37c475f$export$2e2bcd8739ae039() {
    yield (0, $k6WuE.$)([
        (0, $egaCo.watchAppActions)(),
        (0, $gGw13.signinWatchers)(),
        (0, $b1nhW.watchSetPasswordAsync)(),
        (0, $b1nhW.watchSendResetPasswordLinkAsync)(),
        (0, $6zGCD.watchFetchTermsAsync)(),
        (0, $6zGCD.watchAcceptTermsAsync)(),
        (0, $lNBNb.watchFetchAllUsers)(),
        (0, $lNBNb.watchFetchUsersAsync)(),
        (0, $aTJFr.watchUserActions)(),
        (0, $huqcL.watchUpdateCaseAsync)(),
        (0, $huqcL.watchToggleCaseLockedAsync)(),
        (0, $huqcL.watchCaseCableActions)(),
        (0, $b7oeO.watchDeleteAssetsAsync)(),
        (0, $huqcL.watchUpdateCaseMembersAsync)(),
        (0, $g65S5.meetingWatchers)(),
        (0, $2X3Yp.watchFetchMeetingCaseAsync)(),
        (0, $2X3Yp.watchDeleteMeetingCase)(),
        (0, $crPZr.watchStartMeetingAsync)(),
        (0, $jiE79.watchFetchMeetingsAsync)(),
        (0, $jiE79.watchFetchMeetingsInDateRangeAsync)(),
        (0, $eSI7x.watchCreateMeetingUser)(),
        (0, $eSI7x.watchUpdateMeetingUser)(),
        (0, $eSI7x.watchDestroyMeetingUser)(),
        (0, $huqcL.watchFetchCaseAsync)(),
        (0, $cPJVX.watchFetchCasesAsync)(),
        (0, $acSKo.watchFetchCasesAddableToMeetingsAsync)(),
        (0, $jbaZ6.liveMeetingWatchers)(),
        (0, $1ytqf.watchUserConfigActions)(),
        (0, $dpAzW.watchFetchTenantConfigAsync)(),
        (0, $b7oeO.watchFetchCaseAssetsAsync)(),
        (0, $hr8vc.watchFetchCaseTasksAsync)(),
        (0, $hr8vc.watchDeleteCaseTaskAsync)(),
        (0, $hr8vc.watchCreateTaskAsync)(),
        (0, $3Z0uW.watchCreateTaskResponseAsync)(),
        (0, $3Kxye.watchFetchTasksAsync)(),
        (0, $kbbQX.watchCreateCommentAsync)(),
        (0, $5mbCb.watchCreateRecommendationAsync)(),
        (0, $5mbCb.watchSaveCaseRecommendationAsync)(),
        (0, $5yqYK.watchAddConsentAsync)(),
        (0, $iJhw3.watchUploadFileAsync)(),
        (0, $2DA70.watchCreateLinkAsync)(),
        (0, $fsK8M.watchConnectToWebRTCSessionAsync)(),
        (0, $fsK8M.watchDisconnectFromWebRTCSessionAsync)(),
        (0, $jaGaz.watchPublishToWebRTCSessionAsync)(),
        (0, $9K2yN.watchPublishScreenToWebRTCSessionAsync)(),
        (0, $9K2yN.watchStopPublishScreenToWebRTCSessionAsync)(),
        (0, $jaGaz.watchUnpublishFromWebRTCSession)(),
        (0, $2Bnvt.watchSubscribeToWebRTCStreamAsync)(),
        (0, $bliaq.watchToggleWebRTCPublishAudioAsync)(),
        (0, $fmC5S.watchToggleWebRTCPublishVideoAsync)(),
        (0, $fmC5S.watchCycleWebRTCVideoSourceAsync)(),
        (0, $bliaq.watchSetWebRTCAudioSourceAsync)(),
        (0, $bliaq.watchGetWebRTCAudioDevicesAsync)(),
        (0, $bliaq.watchGetWebRTCAudioSourceAsync)(),
        (0, $4a4o1.watchFetchSpecialtiesAsync)(),
        (0, $8TRYc.watchFetchCaseClassificationAsync)(),
        (0, $9CuVR.watchFetchPatientsAsync)(),
        (0, $9CuVR.watchFetchAllPatientsAsync)(),
        (0, $9CuVR.watchUploadPatientsCSVAsync)(),
        (0, $8Ej42.watchFetchPatientAsync)(),
        (0, $aZIV3.watchCheckPatientAsync)(),
        (0, $aZIV3.watchCreatePatientAsync)(),
        (0, $99nwM.watchUpdatePatientAsync)(),
        (0, $99nwM.watchAddCaseForPatientAsync)(),
        (0, $2X3Yp.watchCreateMeetingCase)(),
        (0, $8R3hK.watchFetchNotificationsAsync)(),
        (0, $9Ujgr.watchUploadTermsFileAsync)(),
        (0, $diHh0.watchUploadTenantLogoAsync)(),
        (0, $idlfx.teamWatchers)(),
        (0, $7Dbe5.watchFetchTeamsAsync)(),
        (0, $6pkbE.watchCreateTeamUser)(),
        (0, $6pkbE.watchDestroyTeamUser)(),
        (0, $7Dbe5.watchFetchAllTeamsAsync)(),
        (0, $8UrmS.meetingCaseAssetWatchers)(),
        (0, $bYwoy.watchCreateTenantAsync)(),
        (0, $hzIUn.watchFetchChatsAsync)(),
        (0, $lIh5L.watchFetchChatAsync)(),
        (0, $bi37B.watchCreateChatAsync)(),
        (0, $gOH3n.watchFetchChatMessagesAsync)(),
        (0, $dlQwf.watchCreateChatMessageAsync)(),
        (0, $cTdOQ.watchEndChatAsync)(),
        (0, $5Qhwh.watchToggleMutedChatAsync)(),
        (0, $2Cl6B.watchFetchChatAssetsAsync)(),
        (0, $afJyW.watchExportChatAsync)(),
        (0, $ap7AJ.watchFetchPathways)(),
        (0, $ir3DA.watchFetchPathwayAsync)(),
        (0, $6wWHW.watchCreatePathwayAsync)(),
        (0, $41iOM.watchUpdatePathwayAsync)(),
        (0, $gMltz.watchDeletePathwayAsync)(),
        (0, $dP85u.watchCreatePathwayStepAsync)(),
        (0, $3YWdJ.watchUpdatePathwayStepAsync)(),
        (0, $ajhjw.watchDeletePathwayStepAsync)(),
        (0, $az88Y.watchAddPathwayUsersAsync)(),
        (0, $3YlN4.watchRemovePathwayUserAsync)(),
        (0, $5A7aD.watchFetchPathwaysAddableToCase)(),
        (0, $daslz.watchFetchCasePathwaysAsync)(),
        (0, $daslz.watchCreateCasePathwayAsync)(),
        (0, $daslz.watchUpdateCasePathwayAsync)(),
        (0, $daslz.watchUpdateCasePathwayTaskAsync)(),
        (0, $hlvWF.watchFetchAuditEventsAsync)(),
        (0, $hxfav.watchFetchCaseSourceAsync)(),
        (0, $2X3Yp.watchReceiveMeetingCaseCableUpdateCaseAssets)(),
        (0, $g65S5.meetingChannelWatchers)(),
        (0, $5Fqa8.watchCreateCaseGuestUserAsync)(),
        (0, $9wRwq.watchFetchCaseAssetsCanBeSharedWithUser)(),
        (0, $eekTo.watchCreateCaseSharedAssetAsync)(),
        (0, $dPkhY.watchDeleteCaseSharedAssetAsync)(),
        (0, $ecK25.watchCheckUserAsync)(),
        (0, $3Lz9Y.watchAnalyticsActions)(),
        (0, $bQbFW.mfaWatchers)(),
        (0, $3mrfe.watchFormsActions)()
    ]);
}

});
parcelRegister("jbaZ6", function(module, exports) {

$parcel$export(module.exports, "liveMeetingWatchers", () => $fcb4e4f3dfd37700$export$5fa846da276f4ce0);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $f1q41 = parcelRequire("f1q41");

var $j0qQC = parcelRequire("j0qQC");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $4Z6GL = parcelRequire("4Z6GL");

var $7HZDe = parcelRequire("7HZDe");

var $6j1K3 = parcelRequire("6j1K3");

var $efsoN = parcelRequire("efsoN");
function* $fcb4e4f3dfd37700$export$5fa846da276f4ce0() {
    yield (0, $2AbXc.takeLeading)((0, $j0qQC.LiveMeetingActionTypes).FETCH_LIVE_MEETING_CONFIG_ASYNC_PENDING, $fcb4e4f3dfd37700$export$cd9d492d70d375e7);
    yield (0, $2AbXc.takeLeading)((0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_MEETING_CASES, $fcb4e4f3dfd37700$export$29806895a7cde4f5);
    yield (0, $2AbXc.takeLeading)((0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_CASE_ASSETS, $fcb4e4f3dfd37700$export$b71e02bbaa180908);
    yield (0, $2AbXc.takeLeading)((0, $j0qQC.LiveMeetingCableActionTypes).UPDATE_MEETING, $fcb4e4f3dfd37700$export$bb0f2d50674f9560);
}
function* $fcb4e4f3dfd37700$export$cd9d492d70d375e7(action) {
    try {
        const meetingId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/meetings/${meetingId}/live_meeting_config`, (0, $1zizz.withAuthHeader)());
        response.data.userConfigs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mapKeys(response.data.userConfigs, "id");
        yield (0, $efsoN.handleSuccess)((0, $j0qQC.LiveMeetingActionTypes).FETCH_LIVE_MEETING_CONFIG_ASYNC_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $j0qQC.LiveMeetingActionTypes).FETCH_LIVE_MEETING_CONFIG_ASYNC_ERROR, error);
    }
}
function* $fcb4e4f3dfd37700$export$29806895a7cde4f5(action) {
    yield (0, $k6WuE.Z)((0, $4Z6GL.fetchMeetingAction)(action.payload.meetingId));
    yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
    yield (0, $k6WuE.Z)((0, $7HZDe.fetchCaseAssetsAction)(action.payload.caseId));
}
function* $fcb4e4f3dfd37700$export$b71e02bbaa180908(action) {
    const { caseId: caseId, meetingCaseId: meetingCaseId } = action.payload;
    yield (0, $k6WuE.Z)((0, $7HZDe.fetchCaseAssetsAction)(caseId));
    yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(meetingCaseId));
}
function* $fcb4e4f3dfd37700$export$bb0f2d50674f9560(action) {
    const { meetingId: meetingId } = action.payload;
    yield (0, $k6WuE.Z)((0, $4Z6GL.fetchMeetingAction)(meetingId));
}

});
parcelRegister("7HZDe", function(module, exports) {

$parcel$export(module.exports, "fetchCaseAssetsAction", () => $6560628dc9623aaf$export$ed00dd625bbc389a);
$parcel$export(module.exports, "createCaseCommentAction", () => $6560628dc9623aaf$export$752ebadeb2bec1d7);
$parcel$export(module.exports, "createCaseRecommendationAction", () => $6560628dc9623aaf$export$807ae5832c88f205);
$parcel$export(module.exports, "uploadCaseFileAction", () => $6560628dc9623aaf$export$c06d9d6cc3be85e4);
$parcel$export(module.exports, "deleteAssetAction", () => $6560628dc9623aaf$export$b63759158680a442);
$parcel$export(module.exports, "fetchPatientRadiologyLinksAction", () => $6560628dc9623aaf$export$92985efac236818b);
$parcel$export(module.exports, "createCaseLinkAction", () => $6560628dc9623aaf$export$837034e618448be7);
$parcel$export(module.exports, "createCaseRadiologyLinkAction", () => $6560628dc9623aaf$export$f0cbcb27a887328c);
$parcel$export(module.exports, "addConsentAction", () => $6560628dc9623aaf$export$2734e49949f16efb);
$parcel$export(module.exports, "saveCaseRecommendationAction", () => $6560628dc9623aaf$export$5aaf7996295f0848);

var $7twpo = parcelRequire("7twpo");
const $6560628dc9623aaf$export$ed00dd625bbc389a = (caseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_PENDING,
        payload: caseId
    };
};
const $6560628dc9623aaf$export$752ebadeb2bec1d7 = (caseId, comment, meetingCaseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            comment: comment,
            meetingCaseId: meetingCaseId
        }
    };
};
const $6560628dc9623aaf$export$807ae5832c88f205 = (caseId, recommendation, meetingCaseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            recommendation: recommendation,
            meetingCaseId: meetingCaseId
        }
    };
};
const $6560628dc9623aaf$export$c06d9d6cc3be85e4 = (caseId, values, meetingCaseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            values: values,
            meetingCaseId: meetingCaseId
        }
    };
};
const $6560628dc9623aaf$export$b63759158680a442 = (caseId, assetId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            assetId: assetId
        }
    };
};
const $6560628dc9623aaf$export$92985efac236818b = (caseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_PENDING,
        payload: {
            caseId: caseId
        }
    };
};
const $6560628dc9623aaf$export$837034e618448be7 = (caseId, link, meetingCaseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            link: link,
            meetingCaseId: meetingCaseId
        }
    };
};
const $6560628dc9623aaf$export$f0cbcb27a887328c = (caseId, radiologyLink, meetingCaseId)=>{
    return {
        type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_RADIOLOGY_LINK_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            radiologyLink: radiologyLink,
            meetingCaseId: meetingCaseId
        }
    };
};
const $6560628dc9623aaf$export$2734e49949f16efb = (recommendationId, userId, response, comment)=>({
        type: (0, $7twpo.AssetsActionTypes).ADD_CONSENT_ASYNC_PENDING,
        payload: {
            recommendationId: recommendationId,
            userId: userId,
            response: response,
            comment: comment
        }
    });
const $6560628dc9623aaf$export$5aaf7996295f0848 = (recommendationId, caseId)=>({
        type: (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_PENDING,
        payload: {
            recommendationId: recommendationId,
            caseId: caseId
        }
    });

});

parcelRegister("6j1K3", function(module, exports) {

$parcel$export(module.exports, "createMeetingCaseAction", () => $7ba2335e98225730$export$738a1c3cc46df9ea);
$parcel$export(module.exports, "fetchMeetingCaseAction", () => $7ba2335e98225730$export$814ee1c17fd609bf);
$parcel$export(module.exports, "deleteMeetingCaseAction", () => $7ba2335e98225730$export$5df95516ca632f77);

var $bP3DF = parcelRequire("bP3DF");
const $7ba2335e98225730$export$738a1c3cc46df9ea = (meetingId, caseId, redirectPath)=>{
    return {
        type: (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_PENDING,
        payload: {
            meetingId: meetingId,
            caseId: caseId,
            redirectPath: redirectPath
        }
    };
};
const $7ba2335e98225730$export$814ee1c17fd609bf = (meetingCaseId)=>{
    return {
        type: (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_PENDING,
        payload: meetingCaseId
    };
};
const $7ba2335e98225730$export$5df95516ca632f77 = (meetingId, caseId, meetingCaseId)=>{
    return {
        type: (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_PENDING,
        payload: {
            meetingId: meetingId,
            caseId: caseId,
            meetingCaseId: meetingCaseId
        }
    };
};

});

parcelRegister("efsoN", function(module, exports) {

$parcel$export(module.exports, "checkCurrentUser", () => $40f70554380105da$export$49241c9786f0999c);
$parcel$export(module.exports, "getNormalisedSingle", () => $40f70554380105da$export$9db4e81d54aa2ecf);
$parcel$export(module.exports, "deleteNormalisedSingle", () => $40f70554380105da$export$c491b909a2bd01ad);
$parcel$export(module.exports, "postNormalisedSingle", () => $40f70554380105da$export$c8a589a93f76a766);
$parcel$export(module.exports, "postNormalisedMultiple", () => $40f70554380105da$export$a0dbf422d9632efe);
$parcel$export(module.exports, "patchNormalisedSingle", () => $40f70554380105da$export$e25886b4a9ee3381);
$parcel$export(module.exports, "patchNormalisedMultiple", () => $40f70554380105da$export$abb7f564a3f9b110);
$parcel$export(module.exports, "handleError", () => $40f70554380105da$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "handleSuccess", () => $40f70554380105da$export$3134aad02465a5ae);
$parcel$export(module.exports, "logError", () => $40f70554380105da$export$58da9968c3170cb1);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $6lvMC = parcelRequire("6lvMC");

var $9EFkG = parcelRequire("9EFkG");
function* $40f70554380105da$export$49241c9786f0999c({ byUserId: byUserId }) {
    const currentUserId = yield (0, $k6WuE.a4)((0, $6lvMC.getCurrentUserId));
    return byUserId == currentUserId;
}
function $40f70554380105da$var$putAction(type, payload) {
    return (0, $k6WuE.Z)({
        type: type,
        payload: payload
    });
}
function* $40f70554380105da$export$9db4e81d54aa2ecf(path, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, path, (0, $1zizz.withAuthHeader)());
    if (schema) {
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, schema);
        return normalizedResponse;
    }
    return response.data;
}
function* $40f70554380105da$export$c491b909a2bd01ad(path, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, path, (0, $1zizz.withAuthHeader)());
    if (schema) {
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, schema);
        return normalizedResponse;
    }
    return response.data;
}
function* $40f70554380105da$export$c8a589a93f76a766(path, data, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, path, data, (0, $1zizz.withAuthHeader)());
    if (schema) {
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, schema);
        return normalizedResponse;
    }
    return response.data;
}
function* $40f70554380105da$export$a0dbf422d9632efe(path, data, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, path, data, (0, $1zizz.withAuthHeader)());
    if (schema) return (0, $6ye6I.normalize)(response.data.all, schema);
    return response.data.all;
}
function* $40f70554380105da$export$e25886b4a9ee3381(path, data, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, path, data, (0, $1zizz.withAuthHeader)());
    if (schema) return (0, $6ye6I.normalize)(response.data, schema);
    return response.data;
}
function* $40f70554380105da$export$abb7f564a3f9b110(path, data, schema) {
    const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, path, data, (0, $1zizz.withAuthHeader)());
    if (schema) return (0, $6ye6I.normalize)(response.data.all, schema);
    return response.data.all;
}
function* $40f70554380105da$export$d3da1ecaf1206c58(type, data, messageKey) {
    yield $40f70554380105da$var$putAction(type, data);
    if (messageKey) yield (0, $arZQw.displayUserError)(messageKey);
}
function* $40f70554380105da$export$3134aad02465a5ae(type, data, messageKey) {
    yield $40f70554380105da$var$putAction(type, data);
    if (messageKey) yield (0, $arZQw.displayUserSuccess)(messageKey);
}
function* $40f70554380105da$export$58da9968c3170cb1(message, error) {
    yield console.error(message, error);
    yield (0, $9EFkG.default).captureError(error);
}

});
parcelRegister("9EFkG", function(module, exports) {

$parcel$export(module.exports, "default", () => $358a567e656a791f$export$2e2bcd8739ae039);

var $8S4CW = parcelRequire("8S4CW");
const $358a567e656a791f$var$name = "cm2-" + window.location.hostname.replace(/[^0-9a-zA-Z]/g, " - ");
const $358a567e656a791f$var$Apm = (0, $8S4CW.init)({
    serviceName: $358a567e656a791f$var$name,
    serverUrl: "https://cm2-elastic-1.apm.uksouth.azure.elastic-cloud.com",
    serviceVersion: "1",
    active: window.location.hostname != "localhost",
    logLevel: "error"
});
var $358a567e656a791f$export$2e2bcd8739ae039 = $358a567e656a791f$var$Apm;

});
parcelRegister("8S4CW", function(module, exports) {

$parcel$export(module.exports, "init", () => $6756f4b2093f4254$export$2cd8252107eb640b);

var $jUyKM = parcelRequire("jUyKM");
var $7AUo1 = parcelRequire("7AUo1");
var $5LMma = parcelRequire("5LMma");

var $eqUZ6 = parcelRequire("eqUZ6");
function $6756f4b2093f4254$var$getApmBase() {
    if ((0, $5LMma.isBrowser) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $jUyKM.bootstrap)();
    var serviceFactory = (0, $7AUo1.createServiceFactory)();
    var apmBase = new (0, $eqUZ6.default)(serviceFactory, !enabled);
    if (0, $5LMma.isBrowser) window.elasticApm = apmBase;
    return apmBase;
}
var $6756f4b2093f4254$export$66cd81c234b843ce = $6756f4b2093f4254$var$getApmBase();
var $6756f4b2093f4254$export$2cd8252107eb640b = $6756f4b2093f4254$export$66cd81c234b843ce.init.bind($6756f4b2093f4254$export$66cd81c234b843ce);
var $6756f4b2093f4254$export$2e2bcd8739ae039 = $6756f4b2093f4254$export$2cd8252107eb640b;

});
parcelRegister("jUyKM", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $e7ee34a08d615f9e$export$36aff1fbb4f5dfc6);

var $5LMma = parcelRequire("5LMma");

var $9KMIT = parcelRequire("9KMIT");

var $6cgIX = parcelRequire("6cgIX");
var $e7ee34a08d615f9e$var$enabled = false;
function $e7ee34a08d615f9e$export$36aff1fbb4f5dfc6() {
    if ((0, $5LMma.isPlatformSupported)()) {
        (0, $9KMIT.patchAll)();
        (0, $6cgIX.state).bootstrapTime = (0, $5LMma.now)();
        $e7ee34a08d615f9e$var$enabled = true;
    } else if (0, $5LMma.isBrowser) console.log('[Elastic APM] platform is not supported!');
    return $e7ee34a08d615f9e$var$enabled;
}

});
parcelRegister("5LMma", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $4336da1df7cce5bd$export$4e09c449d6c407f7);
$parcel$export(module.exports, "PERF", () => $4336da1df7cce5bd$export$20dfe5c0db9ba10);
$parcel$export(module.exports, "generateRandomId", () => $4336da1df7cce5bd$export$59b2544ec352d56);
$parcel$export(module.exports, "getDtHeaderValue", () => $4336da1df7cce5bd$export$312052e2a8d615c6);
$parcel$export(module.exports, "parseDtHeaderValue", () => $4336da1df7cce5bd$export$86a08f9fd706a6b8);
$parcel$export(module.exports, "isDtHeaderValid", () => $4336da1df7cce5bd$export$a6f4cb80c241b86f);
$parcel$export(module.exports, "getTSHeaderValue", () => $4336da1df7cce5bd$export$6fbffd43bfec7ed8);
$parcel$export(module.exports, "setRequestHeader", () => $4336da1df7cce5bd$export$4a0dedceb084213c);
$parcel$export(module.exports, "checkSameOrigin", () => $4336da1df7cce5bd$export$8731073ee4364c34);
$parcel$export(module.exports, "isPlatformSupported", () => $4336da1df7cce5bd$export$69a8fd7b83cf9f89);
$parcel$export(module.exports, "setLabel", () => $4336da1df7cce5bd$export$4f65e594f6031297);
$parcel$export(module.exports, "removeInvalidChars", () => $4336da1df7cce5bd$export$fbffb0ac2c2ec159);
$parcel$export(module.exports, "getServerTimingInfo", () => $4336da1df7cce5bd$export$11b3928e177dda19);
$parcel$export(module.exports, "stripQueryStringFromUrl", () => $4336da1df7cce5bd$export$b3289ee923920b2a);
$parcel$export(module.exports, "getCurrentScript", () => $4336da1df7cce5bd$export$8fc24885882b6ead);
$parcel$export(module.exports, "extend", () => $4336da1df7cce5bd$export$8b58be045bf06082);
$parcel$export(module.exports, "merge", () => $4336da1df7cce5bd$export$4950aa0f605343fb);
$parcel$export(module.exports, "isUndefined", () => $4336da1df7cce5bd$export$fce6876652108ab);
$parcel$export(module.exports, "noop", () => $4336da1df7cce5bd$export$8793edee2d425525);
$parcel$export(module.exports, "getLatestNonXHRSpan", () => $4336da1df7cce5bd$export$4066158e069099c5);
$parcel$export(module.exports, "getLatestXHRSpan", () => $4336da1df7cce5bd$export$9db886af3c22d167);
$parcel$export(module.exports, "getEarliestSpan", () => $4336da1df7cce5bd$export$26335e41fd84043b);
$parcel$export(module.exports, "now", () => $4336da1df7cce5bd$export$461939dd4422153);
$parcel$export(module.exports, "getTime", () => $4336da1df7cce5bd$export$1428f42a7de81803);
$parcel$export(module.exports, "getDuration", () => $4336da1df7cce5bd$export$75bba95db5c3e753);
$parcel$export(module.exports, "scheduleMicroTask", () => $4336da1df7cce5bd$export$3262a5e6cc4c389e);
$parcel$export(module.exports, "isPerfTimelineSupported", () => $4336da1df7cce5bd$export$475e1d086d647d28);
$parcel$export(module.exports, "isPerfTypeSupported", () => $4336da1df7cce5bd$export$c043ff66aa95c00c);
$parcel$export(module.exports, "isBeaconInspectionEnabled", () => $4336da1df7cce5bd$export$7aca418b79512736);

var $alnvF = parcelRequire("alnvF");
var $4336da1df7cce5bd$var$slice = [].slice;
var $4336da1df7cce5bd$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $4336da1df7cce5bd$export$20dfe5c0db9ba10 = $4336da1df7cce5bd$export$4e09c449d6c407f7 && typeof performance !== 'undefined' ? performance : {};
function $4336da1df7cce5bd$export$98d4a615201428ae() {
    var xhr = new window.XMLHttpRequest();
    return 'withCredentials' in xhr;
}
var $4336da1df7cce5bd$var$byteToHex = [];
for(var $4336da1df7cce5bd$var$i = 0; $4336da1df7cce5bd$var$i < 256; ++$4336da1df7cce5bd$var$i)$4336da1df7cce5bd$var$byteToHex[$4336da1df7cce5bd$var$i] = ($4336da1df7cce5bd$var$i + 0x100).toString(16).substr(1);
function $4336da1df7cce5bd$export$58b867e287a802c8(buffer) {
    var hexOctets = [];
    for(var _i = 0; _i < buffer.length; _i++)hexOctets.push($4336da1df7cce5bd$var$byteToHex[buffer[_i]]);
    return hexOctets.join('');
}
var $4336da1df7cce5bd$var$destination = new Uint8Array(16);
function $4336da1df7cce5bd$export$cd94982b18c6332c() {
    if (typeof crypto != 'undefined' && typeof crypto.getRandomValues == 'function') return crypto.getRandomValues($4336da1df7cce5bd$var$destination);
    else if (typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function') return msCrypto.getRandomValues($4336da1df7cce5bd$var$destination);
    return $4336da1df7cce5bd$var$destination;
}
function $4336da1df7cce5bd$export$59b2544ec352d56(length) {
    var id = $4336da1df7cce5bd$export$58b867e287a802c8($4336da1df7cce5bd$export$cd94982b18c6332c());
    return id.substr(0, length);
}
function $4336da1df7cce5bd$export$312052e2a8d615c6(span) {
    var dtVersion = '00';
    var dtUnSampledFlags = '00';
    var dtSampledFlags = '01';
    if (span && span.traceId && span.id && span.parentId) {
        var flags = span.sampled ? dtSampledFlags : dtUnSampledFlags;
        var id = span.sampled ? span.id : span.parentId;
        return dtVersion + '-' + span.traceId + '-' + id + '-' + flags;
    }
}
function $4336da1df7cce5bd$export$86a08f9fd706a6b8(value) {
    var parsed = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(value);
    if (parsed) {
        var flags = parsed[4];
        var sampled = flags !== '00';
        return {
            traceId: parsed[2],
            id: parsed[3],
            sampled: sampled
        };
    }
}
function $4336da1df7cce5bd$export$a6f4cb80c241b86f(header) {
    return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(header) && header.slice(3, 35) !== '00000000000000000000000000000000' && header.slice(36, 52) !== '0000000000000000';
}
function $4336da1df7cce5bd$export$6fbffd43bfec7ed8(_ref) {
    var sampleRate = _ref.sampleRate;
    if (typeof sampleRate !== 'number' || String(sampleRate).length > 256) return;
    var NAMESPACE = 'es';
    var SEPARATOR = '=';
    return "" + NAMESPACE + SEPARATOR + "s:" + sampleRate;
}
function $4336da1df7cce5bd$export$4a0dedceb084213c(target, name, value) {
    if (typeof target.setRequestHeader === 'function') target.setRequestHeader(name, value);
    else if (target.headers && typeof target.headers.append === 'function') target.headers.append(name, value);
    else target[name] = value;
}
function $4336da1df7cce5bd$export$8731073ee4364c34(source, target) {
    var isSame = false;
    if (typeof target === 'string') isSame = source === target;
    else if (target && typeof target.test === 'function') isSame = target.test(source);
    else if (Array.isArray(target)) target.forEach(function(t) {
        if (!isSame) isSame = $4336da1df7cce5bd$export$8731073ee4364c34(source, t);
    });
    return isSame;
}
function $4336da1df7cce5bd$export$69a8fd7b83cf9f89() {
    return $4336da1df7cce5bd$export$4e09c449d6c407f7 && typeof Set === 'function' && typeof JSON.stringify === 'function' && $4336da1df7cce5bd$export$20dfe5c0db9ba10 && typeof $4336da1df7cce5bd$export$20dfe5c0db9ba10.now === 'function' && $4336da1df7cce5bd$export$98d4a615201428ae();
}
function $4336da1df7cce5bd$export$4f65e594f6031297(key, value, obj) {
    if (!obj || !key) return;
    var skey = $4336da1df7cce5bd$export$fbffb0ac2c2ec159(key);
    var valueType = typeof value;
    if (value != undefined && valueType !== 'boolean' && valueType !== 'number') value = String(value);
    obj[skey] = value;
    return obj;
}
function $4336da1df7cce5bd$export$11b3928e177dda19(serverTimingEntries) {
    if (serverTimingEntries === void 0) serverTimingEntries = [];
    var serverTimingInfo = [];
    var entrySeparator = ', ';
    var valueSeparator = ';';
    for(var _i2 = 0; _i2 < serverTimingEntries.length; _i2++){
        var _serverTimingEntries$ = serverTimingEntries[_i2], name = _serverTimingEntries$.name, duration = _serverTimingEntries$.duration, description = _serverTimingEntries$.description;
        var timingValue = name;
        if (description) timingValue += valueSeparator + 'desc=' + description;
        if (duration) timingValue += valueSeparator + 'dur=' + duration;
        serverTimingInfo.push(timingValue);
    }
    return serverTimingInfo.join(entrySeparator);
}
function $4336da1df7cce5bd$export$e752b05e58096a2f() {
    return $4336da1df7cce5bd$export$20dfe5c0db9ba10.timing.fetchStart;
}
function $4336da1df7cce5bd$export$b3289ee923920b2a(url) {
    return url && url.split('?')[0];
}
function $4336da1df7cce5bd$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === 'object';
}
function $4336da1df7cce5bd$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $4336da1df7cce5bd$export$bf6cb145536e8bab(dst, objs, deep) {
    for(var i = 0, ii = objs.length; i < ii; ++i){
        var obj = objs[i];
        if (!$4336da1df7cce5bd$export$a6cdc56e425d0d0a(obj) && !$4336da1df7cce5bd$export$f6e2535fb5126e54(obj)) continue;
        var keys = Object.keys(obj);
        for(var j = 0, jj = keys.length; j < jj; j++){
            var key = keys[j];
            var src = obj[key];
            if (deep && $4336da1df7cce5bd$export$a6cdc56e425d0d0a(src)) {
                if (!$4336da1df7cce5bd$export$a6cdc56e425d0d0a(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
                $4336da1df7cce5bd$export$bf6cb145536e8bab(dst[key], [
                    src
                ], false);
            } else dst[key] = src;
        }
    }
    return dst;
}
function $4336da1df7cce5bd$export$bf6fdd3c8902f077() {
    if (typeof document !== 'undefined') {
        var scripts = document.getElementsByTagName('script');
        for(var i = 0, l = scripts.length; i < l; i++){
            var sc = scripts[i];
            if (sc.src.indexOf('elastic') > 0) return sc;
        }
    }
}
function $4336da1df7cce5bd$export$8fc24885882b6ead() {
    if (typeof document !== 'undefined') {
        var currentScript = document.currentScript;
        if (!currentScript) return $4336da1df7cce5bd$export$bf6fdd3c8902f077();
        return currentScript;
    }
}
function $4336da1df7cce5bd$export$8b58be045bf06082(dst) {
    return $4336da1df7cce5bd$export$bf6cb145536e8bab(dst, $4336da1df7cce5bd$var$slice.call(arguments, 1), false);
}
function $4336da1df7cce5bd$export$4950aa0f605343fb(dst) {
    return $4336da1df7cce5bd$export$bf6cb145536e8bab(dst, $4336da1df7cce5bd$var$slice.call(arguments, 1), true);
}
function $4336da1df7cce5bd$export$fce6876652108ab(obj) {
    return typeof obj === 'undefined';
}
function $4336da1df7cce5bd$export$8793edee2d425525() {}
function $4336da1df7cce5bd$export$71aa6c912b956294(array, predicate, thisArg) {
    if (array == null) throw new TypeError('array is null or not defined');
    var o = Object(array);
    var len = o.length >>> 0;
    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
    var k = 0;
    while(k < len){
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) return kValue;
        k++;
    }
    return undefined;
}
function $4336da1df7cce5bd$export$fbffb0ac2c2ec159(key) {
    return key.replace(/[.*"]/g, '_');
}
function $4336da1df7cce5bd$var$getLatestSpan(spans, typeFilter) {
    var latestSpan = null;
    for(var _i3 = 0; _i3 < spans.length; _i3++){
        var span = spans[_i3];
        if (typeFilter && typeFilter(span.type) && (!latestSpan || latestSpan._end < span._end)) latestSpan = span;
    }
    return latestSpan;
}
function $4336da1df7cce5bd$export$4066158e069099c5(spans) {
    return $4336da1df7cce5bd$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') === -1;
    });
}
function $4336da1df7cce5bd$export$9db886af3c22d167(spans) {
    return $4336da1df7cce5bd$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') !== -1;
    });
}
function $4336da1df7cce5bd$export$26335e41fd84043b(spans) {
    var earliestSpan = spans[0];
    for(var _i4 = 1; _i4 < spans.length; _i4++){
        var span = spans[_i4];
        if (earliestSpan._start > span._start) earliestSpan = span;
    }
    return earliestSpan;
}
function $4336da1df7cce5bd$export$461939dd4422153() {
    return $4336da1df7cce5bd$export$20dfe5c0db9ba10.now();
}
function $4336da1df7cce5bd$export$1428f42a7de81803(time) {
    return typeof time === 'number' && time >= 0 ? time : $4336da1df7cce5bd$export$461939dd4422153();
}
function $4336da1df7cce5bd$export$75bba95db5c3e753(start, end) {
    if ($4336da1df7cce5bd$export$fce6876652108ab(end) || $4336da1df7cce5bd$export$fce6876652108ab(start)) return null;
    return parseInt(end - start);
}
function $4336da1df7cce5bd$export$fbacb21386347f76(callback) {
    setTimeout(callback, 0);
}
function $4336da1df7cce5bd$export$3262a5e6cc4c389e(callback) {
    (0, $alnvF.Promise).resolve().then(callback);
}
function $4336da1df7cce5bd$export$475e1d086d647d28() {
    return typeof $4336da1df7cce5bd$export$20dfe5c0db9ba10.getEntriesByType === 'function';
}
function $4336da1df7cce5bd$export$c043ff66aa95c00c(type) {
    return typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.indexOf(type) >= 0;
}
function $4336da1df7cce5bd$export$7aca418b79512736() {
    var flagName = '_elastic_inspect_beacon_';
    if (sessionStorage.getItem(flagName) != null) return true;
    if (!window.URL || !window.URLSearchParams) return false;
    try {
        var parsedUrl = new URL(window.location.href);
        var isFlagSet = parsedUrl.searchParams.has(flagName);
        if (isFlagSet) sessionStorage.setItem(flagName, true);
        return isFlagSet;
    } catch (e) {}
    return false;
}

});
parcelRegister("alnvF", function(module, exports) {

$parcel$export(module.exports, "Promise", () => $787e1a15c5851890$export$775f0de60169233c);

var $cSbQH = parcelRequire("cSbQH");

var $5LMma = parcelRequire("5LMma");
var $787e1a15c5851890$var$local = {};
if (0, $5LMma.isBrowser) $787e1a15c5851890$var$local = window;
else if (typeof self !== 'undefined') $787e1a15c5851890$var$local = self;
var $787e1a15c5851890$export$775f0de60169233c = 'Promise' in $787e1a15c5851890$var$local ? $787e1a15c5851890$var$local.Promise : (0, $cSbQH.default);

});
parcelRegister("cSbQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f3b82b2127a3ee$export$2e2bcd8739ae039);

var $jXety = parcelRequire("jXety");

var $eFAmG = parcelRequire("eFAmG");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $95f3b82b2127a3ee$var$setTimeoutFunc = setTimeout;
function $95f3b82b2127a3ee$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $95f3b82b2127a3ee$var$noop() {}
// Polyfill for Function.prototype.bind
function $95f3b82b2127a3ee$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $95f3b82b2127a3ee$var$Promise(fn) {
    if (!(this instanceof $95f3b82b2127a3ee$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $95f3b82b2127a3ee$var$doResolve(fn, this);
}
function $95f3b82b2127a3ee$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $95f3b82b2127a3ee$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $95f3b82b2127a3ee$var$resolve : $95f3b82b2127a3ee$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $95f3b82b2127a3ee$var$reject(deferred.promise, e);
            return;
        }
        $95f3b82b2127a3ee$var$resolve(deferred.promise, ret);
    });
}
function $95f3b82b2127a3ee$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $95f3b82b2127a3ee$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $95f3b82b2127a3ee$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $95f3b82b2127a3ee$var$doResolve($95f3b82b2127a3ee$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $95f3b82b2127a3ee$var$finale(self);
    } catch (e) {
        $95f3b82b2127a3ee$var$reject(self, e);
    }
}
function $95f3b82b2127a3ee$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $95f3b82b2127a3ee$var$finale(self);
}
function $95f3b82b2127a3ee$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $95f3b82b2127a3ee$var$Promise._immediateFn(function() {
        if (!self._handled) $95f3b82b2127a3ee$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$95f3b82b2127a3ee$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $95f3b82b2127a3ee$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $95f3b82b2127a3ee$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $95f3b82b2127a3ee$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $95f3b82b2127a3ee$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $95f3b82b2127a3ee$var$reject(self, ex);
    }
}
$95f3b82b2127a3ee$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$95f3b82b2127a3ee$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($95f3b82b2127a3ee$var$noop);
    $95f3b82b2127a3ee$var$handle(this, new $95f3b82b2127a3ee$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$95f3b82b2127a3ee$var$Promise.prototype['finally'] = (0, $jXety.default);
$95f3b82b2127a3ee$var$Promise.all = function(arr) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        if (!$95f3b82b2127a3ee$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$95f3b82b2127a3ee$var$Promise.allSettled = (0, $eFAmG.default);
$95f3b82b2127a3ee$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $95f3b82b2127a3ee$var$Promise) return value;
    return new $95f3b82b2127a3ee$var$Promise(function(resolve) {
        resolve(value);
    });
};
$95f3b82b2127a3ee$var$Promise.reject = function(value) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$95f3b82b2127a3ee$var$Promise.race = function(arr) {
    return new $95f3b82b2127a3ee$var$Promise(function(resolve, reject) {
        if (!$95f3b82b2127a3ee$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$95f3b82b2127a3ee$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$95f3b82b2127a3ee$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $95f3b82b2127a3ee$var$setTimeoutFunc(fn, 0);
};
$95f3b82b2127a3ee$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $95f3b82b2127a3ee$export$2e2bcd8739ae039 = $95f3b82b2127a3ee$var$Promise;

});
parcelRegister("jXety", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86ec1941a88c97e$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $e86ec1941a88c97e$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $e86ec1941a88c97e$export$2e2bcd8739ae039 = $e86ec1941a88c97e$var$finallyConstructor;

});

parcelRegister("eFAmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae11a54844710ec$export$2e2bcd8739ae039);
function $aae11a54844710ec$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $aae11a54844710ec$export$2e2bcd8739ae039 = $aae11a54844710ec$var$allSettled;

});




parcelRegister("9KMIT", function(module, exports) {

$parcel$export(module.exports, "patchEventHandler", () => $719e3450a6ddaeef$export$602cc6306ec009d8);
$parcel$export(module.exports, "patchAll", () => $719e3450a6ddaeef$export$94da54533f7f9289);

var $4jYj0 = parcelRequire("4jYj0");

var $kMQW2 = parcelRequire("kMQW2");

var $gUHuu = parcelRequire("gUHuu");

var $iTGhh = parcelRequire("iTGhh");

var $cs9KU = parcelRequire("cs9KU");
var $719e3450a6ddaeef$export$602cc6306ec009d8 = new (0, $iTGhh.default)();
var $719e3450a6ddaeef$var$alreadyPatched = false;
function $719e3450a6ddaeef$export$94da54533f7f9289() {
    if (!$719e3450a6ddaeef$var$alreadyPatched) {
        $719e3450a6ddaeef$var$alreadyPatched = true;
        (0, $4jYj0.patchXMLHttpRequest)(function(event, task) {
            $719e3450a6ddaeef$export$602cc6306ec009d8.send((0, $cs9KU.XMLHTTPREQUEST), [
                event,
                task
            ]);
        });
        (0, $kMQW2.patchFetch)(function(event, task) {
            $719e3450a6ddaeef$export$602cc6306ec009d8.send((0, $cs9KU.FETCH), [
                event,
                task
            ]);
        });
        (0, $gUHuu.patchHistory)(function(event, task) {
            $719e3450a6ddaeef$export$602cc6306ec009d8.send((0, $cs9KU.HISTORY), [
                event,
                task
            ]);
        });
    }
    return $719e3450a6ddaeef$export$602cc6306ec009d8;
}

});
parcelRegister("4jYj0", function(module, exports) {

$parcel$export(module.exports, "patchXMLHttpRequest", () => $3257b72fe7eaa68d$export$41ed32b4ed20742);

var $cLdmR = parcelRequire("cLdmR");

var $cs9KU = parcelRequire("cs9KU");
function $3257b72fe7eaa68d$export$41ed32b4ed20742(callback) {
    var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
    if (!XMLHttpRequestPrototype || !XMLHttpRequestPrototype[0, $cs9KU.ADD_EVENT_LISTENER_STR]) return;
    var READY_STATE_CHANGE = 'readystatechange';
    var LOAD = 'load';
    var ERROR = 'error';
    var TIMEOUT = 'timeout';
    var ABORT = 'abort';
    function invokeTask(task, status) {
        if (task.state !== (0, $cs9KU.INVOKE)) {
            task.state = (0, $cs9KU.INVOKE);
            task.data.status = status;
            callback((0, $cs9KU.INVOKE), task);
        }
    }
    function scheduleTask(task) {
        if (task.state === (0, $cs9KU.SCHEDULE)) return;
        task.state = (0, $cs9KU.SCHEDULE);
        callback((0, $cs9KU.SCHEDULE), task);
        var target = task.data.target;
        function addListener(name) {
            target[0, $cs9KU.ADD_EVENT_LISTENER_STR](name, function(_ref) {
                var type = _ref.type;
                if (type === READY_STATE_CHANGE) {
                    if (target.readyState === 4 && target.status !== 0) invokeTask(task, 'success');
                } else {
                    var status = type === LOAD ? 'success' : type;
                    invokeTask(task, status);
                }
            });
        }
        addListener(READY_STATE_CHANGE);
        addListener(LOAD);
        addListener(TIMEOUT);
        addListener(ERROR);
        addListener(ABORT);
    }
    var openNative = (0, $cLdmR.patchMethod)(XMLHttpRequestPrototype, 'open', function() {
        return function(self, args) {
            if (!self[0, $cLdmR.XHR_IGNORE]) {
                self[0, $cLdmR.XHR_METHOD] = args[0];
                self[0, $cLdmR.XHR_URL] = args[1];
                self[0, $cLdmR.XHR_SYNC] = args[2] === false;
            }
            return openNative.apply(self, args);
        };
    });
    var sendNative = (0, $cLdmR.patchMethod)(XMLHttpRequestPrototype, 'send', function() {
        return function(self, args) {
            if (self[0, $cLdmR.XHR_IGNORE]) return sendNative.apply(self, args);
            var task = {
                source: (0, $cs9KU.XMLHTTPREQUEST),
                state: '',
                type: 'macroTask',
                data: {
                    target: self,
                    method: self[0, $cLdmR.XHR_METHOD],
                    sync: self[0, $cLdmR.XHR_SYNC],
                    url: self[0, $cLdmR.XHR_URL],
                    status: ''
                }
            };
            try {
                scheduleTask(task);
                return sendNative.apply(self, args);
            } catch (e) {
                invokeTask(task, ERROR);
                throw e;
            }
        };
    });
}

});
parcelRegister("cLdmR", function(module, exports) {

$parcel$export(module.exports, "globalState", () => $94a43e5a182015b0$export$8e769ad4338a911e);
$parcel$export(module.exports, "patchMethod", () => $94a43e5a182015b0$export$27a263d91197d790);
$parcel$export(module.exports, "XHR_IGNORE", () => $94a43e5a182015b0$export$1d2facecfc1955cc);
$parcel$export(module.exports, "XHR_SYNC", () => $94a43e5a182015b0$export$bda265647bf75488);
$parcel$export(module.exports, "XHR_URL", () => $94a43e5a182015b0$export$9a7ca3b2c2e97bd9);
$parcel$export(module.exports, "XHR_METHOD", () => $94a43e5a182015b0$export$90db053605542d02);
var $94a43e5a182015b0$export$8e769ad4338a911e = {
    fetchInProgress: false
};
function $94a43e5a182015b0$export$652b0f25a523f48f(name) {
    return '__apm_symbol__' + name;
}
function $94a43e5a182015b0$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
}
function $94a43e5a182015b0$var$attachOriginToPatched(patched, original) {
    patched[$94a43e5a182015b0$export$652b0f25a523f48f('OriginalDelegate')] = original;
}
function $94a43e5a182015b0$export$27a263d91197d790(target, name, patchFn) {
    var proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = Object.getPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    var delegateName = $94a43e5a182015b0$export$652b0f25a523f48f(name);
    var delegate;
    if (proto && !(delegate = proto[delegateName])) {
        delegate = proto[delegateName] = proto[name];
        var desc = proto && Object.getOwnPropertyDescriptor(proto, name);
        if ($94a43e5a182015b0$var$isPropertyWritable(desc)) {
            var patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $94a43e5a182015b0$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
var $94a43e5a182015b0$export$1d2facecfc1955cc = $94a43e5a182015b0$export$652b0f25a523f48f('xhrIgnore');
var $94a43e5a182015b0$export$bda265647bf75488 = $94a43e5a182015b0$export$652b0f25a523f48f('xhrSync');
var $94a43e5a182015b0$export$9a7ca3b2c2e97bd9 = $94a43e5a182015b0$export$652b0f25a523f48f('xhrURL');
var $94a43e5a182015b0$export$90db053605542d02 = $94a43e5a182015b0$export$652b0f25a523f48f('xhrMethod');

});

parcelRegister("cs9KU", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE", () => $910faad2fdd3508c$export$2cb68534ade458e0);
$parcel$export(module.exports, "INVOKE", () => $910faad2fdd3508c$export$156c69d71663cf9e);
$parcel$export(module.exports, "ADD_EVENT_LISTENER_STR", () => $910faad2fdd3508c$export$19be37673fbac3e8);
$parcel$export(module.exports, "RESOURCE_INITIATOR_TYPES", () => $910faad2fdd3508c$export$fcac77ffb8211a1f);
$parcel$export(module.exports, "REUSABILITY_THRESHOLD", () => $910faad2fdd3508c$export$1307ffda4f2726e8);
$parcel$export(module.exports, "MAX_SPAN_DURATION", () => $910faad2fdd3508c$export$92d7cb2c71942fbd);
$parcel$export(module.exports, "PAGE_LOAD_DELAY", () => $910faad2fdd3508c$export$b78d68e75d8e9dad);
$parcel$export(module.exports, "PAGE_LOAD", () => $910faad2fdd3508c$export$1502f4f8c48fa539);
$parcel$export(module.exports, "TYPE_CUSTOM", () => $910faad2fdd3508c$export$dd0e4c11f1ad6f76);
$parcel$export(module.exports, "USER_INTERACTION", () => $910faad2fdd3508c$export$ca341a703d5e2151);
$parcel$export(module.exports, "HTTP_REQUEST_TYPE", () => $910faad2fdd3508c$export$c774c31b4c31da8);
$parcel$export(module.exports, "TEMPORARY_TYPE", () => $910faad2fdd3508c$export$c757be00d1bf3ef5);
$parcel$export(module.exports, "NAME_UNKNOWN", () => $910faad2fdd3508c$export$f0eae82cd3ba085f);
$parcel$export(module.exports, "TRANSACTION_TYPE_ORDER", () => $910faad2fdd3508c$export$38ee95dde3859fb7);
$parcel$export(module.exports, "OUTCOME_SUCCESS", () => $910faad2fdd3508c$export$ffae20858202e0de);
$parcel$export(module.exports, "OUTCOME_FAILURE", () => $910faad2fdd3508c$export$a1656598af524751);
$parcel$export(module.exports, "OUTCOME_UNKNOWN", () => $910faad2fdd3508c$export$f46af96a885f2c9b);
$parcel$export(module.exports, "USER_TIMING_THRESHOLD", () => $910faad2fdd3508c$export$833fd3a4a36bef5e);
$parcel$export(module.exports, "TRANSACTION_START", () => $910faad2fdd3508c$export$53ee6f7d651aa888);
$parcel$export(module.exports, "TRANSACTION_END", () => $910faad2fdd3508c$export$3583e51eacab0340);
$parcel$export(module.exports, "CONFIG_CHANGE", () => $910faad2fdd3508c$export$36257f40a0d30563);
$parcel$export(module.exports, "QUEUE_FLUSH", () => $910faad2fdd3508c$export$19245af82a094556);
$parcel$export(module.exports, "QUEUE_ADD_TRANSACTION", () => $910faad2fdd3508c$export$c11a56b9bfcb1d0f);
$parcel$export(module.exports, "XMLHTTPREQUEST", () => $910faad2fdd3508c$export$942b1c2707517311);
$parcel$export(module.exports, "FETCH", () => $910faad2fdd3508c$export$4a07cffb9c3bc884);
$parcel$export(module.exports, "HISTORY", () => $910faad2fdd3508c$export$149eb684a26496a2);
$parcel$export(module.exports, "EVENT_TARGET", () => $910faad2fdd3508c$export$2c4d7da089dce968);
$parcel$export(module.exports, "CLICK", () => $910faad2fdd3508c$export$cb5542418ddbb7ed);
$parcel$export(module.exports, "ERROR", () => $910faad2fdd3508c$export$103bedf43ba882db);
$parcel$export(module.exports, "BEFORE_EVENT", () => $910faad2fdd3508c$export$d75a03bca9277b83);
$parcel$export(module.exports, "AFTER_EVENT", () => $910faad2fdd3508c$export$eeaba87877acb280);
$parcel$export(module.exports, "LOCAL_CONFIG_KEY", () => $910faad2fdd3508c$export$f1f46202fdd81911);
$parcel$export(module.exports, "LONG_TASK", () => $910faad2fdd3508c$export$fd2c36a5e8e50e04);
$parcel$export(module.exports, "PAINT", () => $910faad2fdd3508c$export$ef5de76f1655b5ca);
$parcel$export(module.exports, "MEASURE", () => $910faad2fdd3508c$export$20471946a1148a1b);
$parcel$export(module.exports, "NAVIGATION", () => $910faad2fdd3508c$export$f52dcf7131a7f04);
$parcel$export(module.exports, "RESOURCE", () => $910faad2fdd3508c$export$84ba8fa7099b85b);
$parcel$export(module.exports, "FIRST_CONTENTFUL_PAINT", () => $910faad2fdd3508c$export$c2572a516b804ad3);
$parcel$export(module.exports, "LARGEST_CONTENTFUL_PAINT", () => $910faad2fdd3508c$export$6de1676190bd73c4);
$parcel$export(module.exports, "FIRST_INPUT", () => $910faad2fdd3508c$export$98085453dd812392);
$parcel$export(module.exports, "LAYOUT_SHIFT", () => $910faad2fdd3508c$export$fc5ce9a4261f08e8);
$parcel$export(module.exports, "ERRORS", () => $910faad2fdd3508c$export$4fd720569787ab6f);
$parcel$export(module.exports, "TRANSACTIONS", () => $910faad2fdd3508c$export$33e749855cc8f893);
$parcel$export(module.exports, "CONFIG_SERVICE", () => $910faad2fdd3508c$export$11170dadd5705a7b);
$parcel$export(module.exports, "LOGGING_SERVICE", () => $910faad2fdd3508c$export$7d973190a36b8246);
$parcel$export(module.exports, "TRANSACTION_SERVICE", () => $910faad2fdd3508c$export$ab6389d1a16bebfe);
$parcel$export(module.exports, "APM_SERVER", () => $910faad2fdd3508c$export$8f8a420bfb2d7e37);
$parcel$export(module.exports, "PERFORMANCE_MONITORING", () => $910faad2fdd3508c$export$6a0f49a7699bafca);
$parcel$export(module.exports, "ERROR_LOGGING", () => $910faad2fdd3508c$export$3bb4e88cf5c5fd65);
$parcel$export(module.exports, "TRUNCATED_TYPE", () => $910faad2fdd3508c$export$58a4ef0ce68953f5);
$parcel$export(module.exports, "KEYWORD_LIMIT", () => $910faad2fdd3508c$export$1ef49423f809800e);
$parcel$export(module.exports, "SESSION_TIMEOUT", () => $910faad2fdd3508c$export$c74ee24a01db1ae5);
$parcel$export(module.exports, "HTTP_REQUEST_TIMEOUT", () => $910faad2fdd3508c$export$304f7f334b3888b0);
var $910faad2fdd3508c$export$2cb68534ade458e0 = 'schedule';
var $910faad2fdd3508c$export$156c69d71663cf9e = 'invoke';
var $910faad2fdd3508c$export$19be37673fbac3e8 = 'addEventListener';
var $910faad2fdd3508c$export$2d40f446af293d52 = 'removeEventListener';
var $910faad2fdd3508c$export$fcac77ffb8211a1f = [
    'link',
    'css',
    'script',
    'img',
    'xmlhttprequest',
    'fetch',
    'beacon',
    'iframe'
];
var $910faad2fdd3508c$export$1307ffda4f2726e8 = 5000;
var $910faad2fdd3508c$export$92d7cb2c71942fbd = 300000;
var $910faad2fdd3508c$export$b78d68e75d8e9dad = 1000;
var $910faad2fdd3508c$export$1502f4f8c48fa539 = 'page-load';
var $910faad2fdd3508c$export$e9e58a8c189b78b1 = 'route-change';
var $910faad2fdd3508c$export$dd0e4c11f1ad6f76 = 'custom';
var $910faad2fdd3508c$export$ca341a703d5e2151 = 'user-interaction';
var $910faad2fdd3508c$export$c774c31b4c31da8 = 'http-request';
var $910faad2fdd3508c$export$c757be00d1bf3ef5 = 'temporary';
var $910faad2fdd3508c$export$f0eae82cd3ba085f = 'Unknown';
var $910faad2fdd3508c$export$38ee95dde3859fb7 = [
    $910faad2fdd3508c$export$1502f4f8c48fa539,
    $910faad2fdd3508c$export$e9e58a8c189b78b1,
    $910faad2fdd3508c$export$ca341a703d5e2151,
    $910faad2fdd3508c$export$c774c31b4c31da8,
    $910faad2fdd3508c$export$dd0e4c11f1ad6f76,
    $910faad2fdd3508c$export$c757be00d1bf3ef5
];
var $910faad2fdd3508c$export$ffae20858202e0de = 'success';
var $910faad2fdd3508c$export$a1656598af524751 = 'failure';
var $910faad2fdd3508c$export$f46af96a885f2c9b = 'unknown';
var $910faad2fdd3508c$export$833fd3a4a36bef5e = 60;
var $910faad2fdd3508c$export$53ee6f7d651aa888 = 'transaction:start';
var $910faad2fdd3508c$export$3583e51eacab0340 = 'transaction:end';
var $910faad2fdd3508c$export$36257f40a0d30563 = 'config:change';
var $910faad2fdd3508c$export$19245af82a094556 = 'queue:flush';
var $910faad2fdd3508c$export$c11a56b9bfcb1d0f = 'queue:add_transaction';
var $910faad2fdd3508c$export$942b1c2707517311 = 'xmlhttprequest';
var $910faad2fdd3508c$export$4a07cffb9c3bc884 = 'fetch';
var $910faad2fdd3508c$export$149eb684a26496a2 = 'history';
var $910faad2fdd3508c$export$2c4d7da089dce968 = 'eventtarget';
var $910faad2fdd3508c$export$cb5542418ddbb7ed = 'click';
var $910faad2fdd3508c$export$103bedf43ba882db = 'error';
var $910faad2fdd3508c$export$d75a03bca9277b83 = ':before';
var $910faad2fdd3508c$export$eeaba87877acb280 = ':after';
var $910faad2fdd3508c$export$f1f46202fdd81911 = 'elastic_apm_config';
var $910faad2fdd3508c$export$fd2c36a5e8e50e04 = 'longtask';
var $910faad2fdd3508c$export$ef5de76f1655b5ca = 'paint';
var $910faad2fdd3508c$export$20471946a1148a1b = 'measure';
var $910faad2fdd3508c$export$f52dcf7131a7f04 = 'navigation';
var $910faad2fdd3508c$export$84ba8fa7099b85b = 'resource';
var $910faad2fdd3508c$export$c2572a516b804ad3 = 'first-contentful-paint';
var $910faad2fdd3508c$export$6de1676190bd73c4 = 'largest-contentful-paint';
var $910faad2fdd3508c$export$98085453dd812392 = 'first-input';
var $910faad2fdd3508c$export$fc5ce9a4261f08e8 = 'layout-shift';
var $910faad2fdd3508c$export$4fd720569787ab6f = 'errors';
var $910faad2fdd3508c$export$33e749855cc8f893 = 'transactions';
var $910faad2fdd3508c$export$11170dadd5705a7b = 'ConfigService';
var $910faad2fdd3508c$export$7d973190a36b8246 = 'LoggingService';
var $910faad2fdd3508c$export$ab6389d1a16bebfe = 'TransactionService';
var $910faad2fdd3508c$export$8f8a420bfb2d7e37 = 'ApmServer';
var $910faad2fdd3508c$export$6a0f49a7699bafca = 'PerformanceMonitoring';
var $910faad2fdd3508c$export$3bb4e88cf5c5fd65 = 'ErrorLogging';
var $910faad2fdd3508c$export$58a4ef0ce68953f5 = '.truncated';
var $910faad2fdd3508c$export$1ef49423f809800e = 1024;
var $910faad2fdd3508c$export$c74ee24a01db1ae5 = 1800000;
var $910faad2fdd3508c$export$304f7f334b3888b0 = 10000;

});


parcelRegister("kMQW2", function(module, exports) {

$parcel$export(module.exports, "patchFetch", () => $f2215a2197d7d00b$export$28f71c1f202028d4);

var $alnvF = parcelRequire("alnvF");

var $cLdmR = parcelRequire("cLdmR");

var $cs9KU = parcelRequire("cs9KU");

var $5LMma = parcelRequire("5LMma");

var $jvvj2 = parcelRequire("jvvj2");
function $f2215a2197d7d00b$export$28f71c1f202028d4(callback) {
    if (!(0, $jvvj2.isFetchSupported)()) return;
    function scheduleTask(task) {
        task.state = (0, $cs9KU.SCHEDULE);
        callback((0, $cs9KU.SCHEDULE), task);
    }
    function invokeTask(task) {
        task.state = (0, $cs9KU.INVOKE);
        callback((0, $cs9KU.INVOKE), task);
    }
    function handleResponseError(task, error) {
        task.data.aborted = $f2215a2197d7d00b$var$isAbortError(error);
        task.data.error = error;
        invokeTask(task);
    }
    function readStream(stream, task) {
        var reader = stream.getReader();
        var read = function read() {
            reader.read().then(function(_ref) {
                var done = _ref.done;
                if (done) invokeTask(task);
                else read();
            }, function(error) {
                handleResponseError(task, error);
            });
        };
        read();
    }
    var nativeFetch = window.fetch;
    window.fetch = function(input, init) {
        var fetchSelf = this;
        var args = arguments;
        var request, url;
        if (typeof input === 'string') {
            request = new Request(input, init);
            url = input;
        } else if (input) {
            request = input;
            url = request.url;
        } else return nativeFetch.apply(fetchSelf, args);
        var task = {
            source: (0, $cs9KU.FETCH),
            state: '',
            type: 'macroTask',
            data: {
                target: request,
                method: request.method,
                url: url,
                aborted: false
            }
        };
        return new (0, $alnvF.Promise)(function(resolve, reject) {
            (0, $cLdmR.globalState).fetchInProgress = true;
            scheduleTask(task);
            var promise;
            try {
                promise = nativeFetch.apply(fetchSelf, [
                    request
                ]);
            } catch (error) {
                reject(error);
                task.data.error = error;
                invokeTask(task);
                (0, $cLdmR.globalState).fetchInProgress = false;
                return;
            }
            promise.then(function(response) {
                var clonedResponse = response.clone ? response.clone() : {};
                resolve(response);
                (0, $5LMma.scheduleMicroTask)(function() {
                    task.data.response = response;
                    var body = clonedResponse.body;
                    if (body) readStream(body, task);
                    else invokeTask(task);
                });
            }, function(error) {
                reject(error);
                (0, $5LMma.scheduleMicroTask)(function() {
                    handleResponseError(task, error);
                });
            });
            (0, $cLdmR.globalState).fetchInProgress = false;
        });
    };
}
function $f2215a2197d7d00b$var$isAbortError(error) {
    return error && error.name === 'AbortError';
}

});
parcelRegister("jvvj2", function(module, exports) {

$parcel$export(module.exports, "shouldUseFetchWithKeepAlive", () => $e339324fb2147c4a$export$7671e9773d28088a);
$parcel$export(module.exports, "isFetchSupported", () => $e339324fb2147c4a$export$f8c1c61350d9749);
$parcel$export(module.exports, "sendFetchRequest", () => $e339324fb2147c4a$export$de4ef9c2599856d6);

var $cs9KU = parcelRequire("cs9KU");

var $kDgVV = parcelRequire("kDgVV");
function $e339324fb2147c4a$var$_extends() {
    $e339324fb2147c4a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e339324fb2147c4a$var$_extends.apply(this, arguments);
}
var $e339324fb2147c4a$export$1080ec02d04a92c0 = 60000;
function $e339324fb2147c4a$export$7671e9773d28088a(method, payload) {
    if (!$e339324fb2147c4a$export$f8c1c61350d9749()) return false;
    var isKeepAliveSupported = 'keepalive' in new Request('');
    if (!isKeepAliveSupported) return false;
    var size = $e339324fb2147c4a$var$calculateSize(payload);
    return method === 'POST' && size < $e339324fb2147c4a$export$1080ec02d04a92c0;
}
function $e339324fb2147c4a$export$de4ef9c2599856d6(method, url, _ref) {
    var _ref$keepalive = _ref.keepalive, keepalive = _ref$keepalive === void 0 ? false : _ref$keepalive, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? (0, $cs9KU.HTTP_REQUEST_TIMEOUT) : _ref$timeout, payload = _ref.payload, headers = _ref.headers, sendCredentials = _ref.sendCredentials;
    var timeoutConfig = {};
    if (typeof AbortController === 'function') {
        var controller = new AbortController();
        timeoutConfig.signal = controller.signal;
        setTimeout(function() {
            return controller.abort();
        }, timeout);
    }
    var fetchResponse;
    return window.fetch(url, $e339324fb2147c4a$var$_extends({
        body: payload,
        headers: headers,
        method: method,
        keepalive: keepalive,
        credentials: sendCredentials ? 'include' : 'omit'
    }, timeoutConfig)).then(function(response) {
        fetchResponse = response;
        return fetchResponse.text();
    }).then(function(responseText) {
        var bodyResponse = {
            url: url,
            status: fetchResponse.status,
            responseText: responseText
        };
        if (!(0, $kDgVV.isResponseSuccessful)(fetchResponse.status)) throw bodyResponse;
        return bodyResponse;
    });
}
function $e339324fb2147c4a$export$f8c1c61350d9749() {
    return typeof window.fetch === 'function' && typeof window.Request === 'function';
}
function $e339324fb2147c4a$var$calculateSize(payload) {
    if (!payload) return 0;
    if (payload instanceof Blob) return payload.size;
    return new Blob([
        payload
    ]).size;
}

});
parcelRegister("kDgVV", function(module, exports) {

$parcel$export(module.exports, "isResponseSuccessful", () => $f05495c9ad96123c$export$1f29f0bf55f6a59e);
function $f05495c9ad96123c$export$1f29f0bf55f6a59e(status) {
    if (status === 0 || status > 399 && status < 600) return false;
    return true;
}

});



parcelRegister("gUHuu", function(module, exports) {

$parcel$export(module.exports, "patchHistory", () => $c5039cacea1bcecd$export$1c3c71cac9d1d555);

var $cs9KU = parcelRequire("cs9KU");
function $c5039cacea1bcecd$export$1c3c71cac9d1d555(callback) {
    if (!window.history) return;
    var nativePushState = history.pushState;
    if (typeof nativePushState === 'function') history.pushState = function(state, title, url) {
        var task = {
            source: (0, $cs9KU.HISTORY),
            data: {
                state: state,
                title: title,
                url: url
            }
        };
        callback((0, $cs9KU.INVOKE), task);
        nativePushState.apply(this, arguments);
    };
}

});

parcelRegister("iTGhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1e28867f9b3a7d$export$2e2bcd8739ae039);

var $cs9KU = parcelRequire("cs9KU");
var $dc1e28867f9b3a7d$var$EventHandler = function() {
    function EventHandler() {
        this.observers = {};
    }
    var _proto = EventHandler.prototype;
    _proto.observe = function observe(name, fn) {
        var _this = this;
        if (typeof fn === 'function') {
            if (!this.observers[name]) this.observers[name] = [];
            this.observers[name].push(fn);
            return function() {
                var index = _this.observers[name].indexOf(fn);
                if (index > -1) _this.observers[name].splice(index, 1);
            };
        }
    };
    _proto.sendOnly = function sendOnly(name, args) {
        var obs = this.observers[name];
        if (obs) obs.forEach(function(fn) {
            try {
                fn.apply(undefined, args);
            } catch (error) {
                console.log(error, error.stack);
            }
        });
    };
    _proto.send = function send(name, args) {
        this.sendOnly(name + (0, $cs9KU.BEFORE_EVENT), args);
        this.sendOnly(name, args);
        this.sendOnly(name + (0, $cs9KU.AFTER_EVENT), args);
    };
    return EventHandler;
}();
var $dc1e28867f9b3a7d$export$2e2bcd8739ae039 = $dc1e28867f9b3a7d$var$EventHandler;

});


parcelRegister("6cgIX", function(module, exports) {

$parcel$export(module.exports, "__DEV__", () => $4830d62025528325$export$a866f231438cc228);
$parcel$export(module.exports, "state", () => $4830d62025528325$export$ca000e230c0caa3e);
var $4830d62025528325$export$a866f231438cc228 = false;
var $4830d62025528325$export$ca000e230c0caa3e = {
    bootstrapTime: null,
    lastHiddenStart: Number.MIN_SAFE_INTEGER
};

});


parcelRegister("7AUo1", function(module, exports) {

$parcel$export(module.exports, "createServiceFactory", () => $5877a25a5ce52c3e$export$791d8bdb130abda4);

var $iCvAY = parcelRequire("iCvAY");

var $aA8l1 = parcelRequire("aA8l1");

var $lwQjO = parcelRequire("lwQjO");

var $5LMma = parcelRequire("5LMma");


var $cyYT5 = parcelRequire("cyYT5");
var $2Hl1n = parcelRequire("2Hl1n");

var $cs9KU = parcelRequire("cs9KU");

var $kLexY = parcelRequire("kLexY");


var $jUyKM = parcelRequire("jUyKM");

function $5877a25a5ce52c3e$export$791d8bdb130abda4() {
    (0, $aA8l1.registerServices)();
    (0, $iCvAY.registerServices)();
    var serviceFactory = new (0, $lwQjO.ServiceFactory)();
    return serviceFactory;
}

});
parcelRegister("iCvAY", function(module, exports) {

$parcel$export(module.exports, "registerServices", () => $d8e448c32c6e1e30$export$174fd5f90dd8a5db);

var $kuIAl = parcelRequire("kuIAl");

var $cs9KU = parcelRequire("cs9KU");

var $lwQjO = parcelRequire("lwQjO");
function $d8e448c32c6e1e30$export$174fd5f90dd8a5db() {
    (0, $lwQjO.serviceCreators)[0, $cs9KU.ERROR_LOGGING] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $cs9KU.APM_SERVER),
            (0, $cs9KU.CONFIG_SERVICE),
            (0, $cs9KU.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1], transactionService = _serviceFactory$getSe[2];
        return new (0, $kuIAl.default)(apmServer, configService, transactionService);
    };
}

});
parcelRegister("kuIAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeb931ae566e8e99$export$2e2bcd8739ae039);

var $38Vvb = parcelRequire("38Vvb");

var $5LMma = parcelRequire("5LMma");

var $aUu0v = parcelRequire("aUu0v");

var $ahm0M = parcelRequire("ahm0M");

var $hSUrg = parcelRequire("hSUrg");
var $eeb931ae566e8e99$var$_excluded = [
    "tags"
];
function $eeb931ae566e8e99$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $eeb931ae566e8e99$var$IGNORE_KEYS = [
    'stack',
    'message'
];
function $eeb931ae566e8e99$var$getErrorProperties(error) {
    var propertyFound = false;
    var properties = {};
    Object.keys(error).forEach(function(key) {
        if ($eeb931ae566e8e99$var$IGNORE_KEYS.indexOf(key) >= 0) return;
        var val = error[key];
        if (val == null || typeof val === 'function') return;
        if (typeof val === 'object') {
            if (typeof val.toISOString !== 'function') return;
            val = val.toISOString();
        }
        properties[key] = val;
        propertyFound = true;
    });
    if (propertyFound) return properties;
}
var $eeb931ae566e8e99$var$ErrorLogging = function() {
    function ErrorLogging(apmServer, configService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._transactionService = transactionService;
    }
    var _proto = ErrorLogging.prototype;
    _proto.createErrorDataModel = function createErrorDataModel(errorEvent) {
        var frames = (0, $38Vvb.createStackTraces)((0, (/*@__PURE__*/$parcel$interopDefault($hSUrg))), errorEvent);
        var filteredFrames = (0, $38Vvb.filterInvalidFrames)(frames);
        var culprit = '(inline script)';
        var lastFrame = filteredFrames[filteredFrames.length - 1];
        if (lastFrame && lastFrame.filename) culprit = lastFrame.filename;
        var message = errorEvent.message, error = errorEvent.error;
        var errorMessage = message;
        var errorType = '';
        var errorContext = {};
        if (error && typeof error === 'object') {
            errorMessage = errorMessage || error.message;
            errorType = error.name;
            var customProperties = $eeb931ae566e8e99$var$getErrorProperties(error);
            if (customProperties) errorContext.custom = customProperties;
        }
        if (!errorType) {
            if (errorMessage && errorMessage.indexOf(':') > -1) errorType = errorMessage.split(':')[0];
        }
        var currentTransaction = this._transactionService.getCurrentTransaction();
        var transactionContext = currentTransaction ? currentTransaction.context : {};
        var _this$_configService$ = this._configService.get('context'), tags = _this$_configService$.tags, configContext = $eeb931ae566e8e99$var$_objectWithoutPropertiesLoose(_this$_configService$, $eeb931ae566e8e99$var$_excluded);
        var pageContext = (0, $aUu0v.getPageContext)();
        var context = (0, $5LMma.merge)({}, pageContext, transactionContext, configContext, errorContext);
        var errorObject = {
            id: (0, $5LMma.generateRandomId)(),
            culprit: culprit,
            exception: {
                message: errorMessage,
                stacktrace: filteredFrames,
                type: errorType
            },
            context: context
        };
        if (currentTransaction) errorObject = (0, $5LMma.extend)(errorObject, {
            trace_id: currentTransaction.traceId,
            parent_id: currentTransaction.id,
            transaction_id: currentTransaction.id,
            transaction: {
                type: currentTransaction.type,
                sampled: currentTransaction.sampled
            }
        });
        return (0, $ahm0M.truncateModel)((0, $ahm0M.ERROR_MODEL), errorObject);
    };
    _proto.logErrorEvent = function logErrorEvent(errorEvent) {
        if (typeof errorEvent === 'undefined') return;
        var errorObject = this.createErrorDataModel(errorEvent);
        if (typeof errorObject.exception.message === 'undefined') return;
        this._apmServer.addError(errorObject);
    };
    _proto.registerListeners = function registerListeners() {
        var _this = this;
        window.addEventListener('error', function(errorEvent) {
            return _this.logErrorEvent(errorEvent);
        });
        window.addEventListener('unhandledrejection', function(promiseRejectionEvent) {
            return _this.logPromiseEvent(promiseRejectionEvent);
        });
    };
    _proto.logPromiseEvent = function logPromiseEvent(promiseRejectionEvent) {
        var prefix = 'Unhandled promise rejection: ';
        var reason = promiseRejectionEvent.reason;
        if (reason == null) reason = '<no reason specified>';
        var errorEvent;
        if (typeof reason.message === 'string') {
            var name = reason.name ? reason.name + ': ' : '';
            errorEvent = {
                error: reason,
                message: prefix + name + reason.message
            };
        } else {
            reason = typeof reason === 'object' ? '<object>' : typeof reason === 'function' ? '<function>' : reason;
            errorEvent = {
                message: prefix + reason
            };
        }
        this.logErrorEvent(errorEvent);
    };
    _proto.logError = function logError(messageOrError) {
        var errorEvent = {};
        if (typeof messageOrError === 'string') errorEvent.message = messageOrError;
        else errorEvent.error = messageOrError;
        return this.logErrorEvent(errorEvent);
    };
    return ErrorLogging;
}();
var $eeb931ae566e8e99$export$2e2bcd8739ae039 = $eeb931ae566e8e99$var$ErrorLogging;

});
parcelRegister("38Vvb", function(module, exports) {

$parcel$export(module.exports, "createStackTraces", () => $249eb9260e1d4a34$export$8c8855196b9f04f8);
$parcel$export(module.exports, "filterInvalidFrames", () => $249eb9260e1d4a34$export$388e43ae04f18461);
function $249eb9260e1d4a34$var$filePathToFileName(fileUrl) {
    var origin = window.location.origin || window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    if (fileUrl.indexOf(origin) > -1) fileUrl = fileUrl.replace(origin + '/', '');
    return fileUrl;
}
function $249eb9260e1d4a34$var$cleanFilePath(filePath) {
    if (filePath === void 0) filePath = '';
    if (filePath === '<anonymous>') filePath = '';
    return filePath;
}
function $249eb9260e1d4a34$var$isFileInline(fileUrl) {
    if (fileUrl) return window.location.href.indexOf(fileUrl) === 0;
    return false;
}
function $249eb9260e1d4a34$var$normalizeStackFrames(stackFrames) {
    return stackFrames.map(function(frame) {
        if (frame.functionName) frame.functionName = $249eb9260e1d4a34$var$normalizeFunctionName(frame.functionName);
        return frame;
    });
}
function $249eb9260e1d4a34$var$normalizeFunctionName(fnName) {
    var parts = fnName.split('/');
    if (parts.length > 1) fnName = [
        'Object',
        parts[parts.length - 1]
    ].join('.');
    else fnName = parts[0];
    fnName = fnName.replace(/.<$/gi, '.<anonymous>');
    fnName = fnName.replace(/^Anonymous function$/, '<anonymous>');
    parts = fnName.split('.');
    if (parts.length > 1) fnName = parts[parts.length - 1];
    else fnName = parts[0];
    return fnName;
}
function $249eb9260e1d4a34$var$isValidStackTrace(stackTraces) {
    if (stackTraces.length === 0) return false;
    if (stackTraces.length === 1) {
        var stackTrace = stackTraces[0];
        return 'lineNumber' in stackTrace;
    }
    return true;
}
function $249eb9260e1d4a34$export$8c8855196b9f04f8(stackParser, errorEvent) {
    var error = errorEvent.error, filename = errorEvent.filename, lineno = errorEvent.lineno, colno = errorEvent.colno;
    var stackTraces = [];
    if (error) try {
        stackTraces = stackParser.parse(error);
    } catch (e) {}
    if (!$249eb9260e1d4a34$var$isValidStackTrace(stackTraces)) stackTraces = [
        {
            fileName: filename,
            lineNumber: lineno,
            columnNumber: colno
        }
    ];
    var normalizedStackTraces = $249eb9260e1d4a34$var$normalizeStackFrames(stackTraces);
    return normalizedStackTraces.map(function(stack) {
        var fileName = stack.fileName, lineNumber = stack.lineNumber, columnNumber = stack.columnNumber, _stack$functionName = stack.functionName, functionName = _stack$functionName === void 0 ? '<anonymous>' : _stack$functionName;
        if (!fileName && !lineNumber) return {};
        if (!columnNumber && !lineNumber) return {};
        var filePath = $249eb9260e1d4a34$var$cleanFilePath(fileName);
        var cleanedFileName = $249eb9260e1d4a34$var$filePathToFileName(filePath);
        if ($249eb9260e1d4a34$var$isFileInline(filePath)) cleanedFileName = '(inline script)';
        return {
            abs_path: fileName,
            filename: cleanedFileName,
            function: functionName,
            lineno: lineNumber,
            colno: columnNumber
        };
    });
}
function $249eb9260e1d4a34$export$388e43ae04f18461(frames) {
    return frames.filter(function(_ref) {
        var filename = _ref.filename, lineno = _ref.lineno;
        return typeof filename !== 'undefined' && typeof lineno !== 'undefined';
    });
}

});

parcelRegister("aUu0v", function(module, exports) {

$parcel$export(module.exports, "getPageContext", () => $7f16692931a73406$export$1303843c2f44065a);
$parcel$export(module.exports, "addSpanContext", () => $7f16692931a73406$export$ed109afa225aed5b);
$parcel$export(module.exports, "addTransactionContext", () => $7f16692931a73406$export$d10ae57e760667a5);

var $kgscU = parcelRequire("kgscU");

var $cs9KU = parcelRequire("cs9KU");

var $5LMma = parcelRequire("5LMma");
var $7f16692931a73406$var$_excluded = [
    "tags"
];
function $7f16692931a73406$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7f16692931a73406$var$LEFT_SQUARE_BRACKET = 91;
var $7f16692931a73406$var$RIGHT_SQUARE_BRACKET = 93;
var $7f16692931a73406$var$EXTERNAL = 'external';
var $7f16692931a73406$var$RESOURCE = 'resource';
var $7f16692931a73406$var$HARD_NAVIGATION = 'hard-navigation';
function $7f16692931a73406$var$getPortNumber(port, protocol) {
    if (port === '') port = protocol === 'http:' ? '80' : protocol === 'https:' ? '443' : '';
    return port;
}
function $7f16692931a73406$var$getResponseContext(perfTimingEntry) {
    var transferSize = perfTimingEntry.transferSize, encodedBodySize = perfTimingEntry.encodedBodySize, decodedBodySize = perfTimingEntry.decodedBodySize, serverTiming = perfTimingEntry.serverTiming;
    var respContext = {
        transfer_size: transferSize,
        encoded_body_size: encodedBodySize,
        decoded_body_size: decodedBodySize
    };
    var serverTimingStr = (0, $5LMma.getServerTimingInfo)(serverTiming);
    if (serverTimingStr) respContext.headers = {
        'server-timing': serverTimingStr
    };
    return respContext;
}
function $7f16692931a73406$var$getDestination(parsedUrl) {
    var port = parsedUrl.port, protocol = parsedUrl.protocol, hostname = parsedUrl.hostname;
    var portNumber = $7f16692931a73406$var$getPortNumber(port, protocol);
    var ipv6Hostname = hostname.charCodeAt(0) === $7f16692931a73406$var$LEFT_SQUARE_BRACKET && hostname.charCodeAt(hostname.length - 1) === $7f16692931a73406$var$RIGHT_SQUARE_BRACKET;
    var address = hostname;
    if (ipv6Hostname) address = hostname.slice(1, -1);
    return {
        service: {
            resource: hostname + ':' + portNumber,
            name: '',
            type: ''
        },
        address: address,
        port: Number(portNumber)
    };
}
function $7f16692931a73406$var$getResourceContext(data) {
    var entry = data.entry, url = data.url;
    var parsedUrl = new (0, $kgscU.Url)(url);
    var destination = $7f16692931a73406$var$getDestination(parsedUrl);
    return {
        http: {
            url: url,
            response: $7f16692931a73406$var$getResponseContext(entry)
        },
        destination: destination
    };
}
function $7f16692931a73406$var$getExternalContext(data) {
    var url = data.url, method = data.method, target = data.target, response = data.response;
    var parsedUrl = new (0, $kgscU.Url)(url);
    var destination = $7f16692931a73406$var$getDestination(parsedUrl);
    var context = {
        http: {
            method: method,
            url: parsedUrl.href
        },
        destination: destination
    };
    var statusCode;
    if (target && typeof target.status !== 'undefined') statusCode = target.status;
    else if (response) statusCode = response.status;
    context.http.status_code = statusCode;
    return context;
}
function $7f16692931a73406$var$getNavigationContext(data) {
    var url = data.url;
    var parsedUrl = new (0, $kgscU.Url)(url);
    var destination = $7f16692931a73406$var$getDestination(parsedUrl);
    return {
        destination: destination
    };
}
function $7f16692931a73406$export$1303843c2f44065a() {
    return {
        page: {
            referer: document.referrer,
            url: location.href
        }
    };
}
function $7f16692931a73406$export$ed109afa225aed5b(span, data) {
    if (!data) return;
    var type = span.type;
    var context;
    switch(type){
        case $7f16692931a73406$var$EXTERNAL:
            context = $7f16692931a73406$var$getExternalContext(data);
            break;
        case $7f16692931a73406$var$RESOURCE:
            context = $7f16692931a73406$var$getResourceContext(data);
            break;
        case $7f16692931a73406$var$HARD_NAVIGATION:
            context = $7f16692931a73406$var$getNavigationContext(data);
            break;
    }
    span.addContext(context);
}
function $7f16692931a73406$export$d10ae57e760667a5(transaction, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, tags = _ref.tags, configContext = $7f16692931a73406$var$_objectWithoutPropertiesLoose(_ref, $7f16692931a73406$var$_excluded);
    var pageContext = $7f16692931a73406$export$1303843c2f44065a();
    var responseContext = {};
    if (transaction.type === (0, $cs9KU.PAGE_LOAD) && (0, $5LMma.isPerfTimelineSupported)()) {
        var entries = (0, $5LMma.PERF).getEntriesByType((0, $cs9KU.NAVIGATION));
        if (entries && entries.length > 0) responseContext = {
            response: $7f16692931a73406$var$getResponseContext(entries[0])
        };
    }
    transaction.addContext(pageContext, responseContext, configContext);
}

});
parcelRegister("kgscU", function(module, exports) {

$parcel$export(module.exports, "Url", () => $ec0b2ea3826b1056$export$59d795186a5d3f58);
$parcel$export(module.exports, "slugifyUrl", () => $ec0b2ea3826b1056$export$456a5af62e4119f6);

var $5LMma = parcelRequire("5LMma");
function $ec0b2ea3826b1056$var$isDefaultPort(port, protocol) {
    switch(protocol){
        case 'http:':
            return port === '80';
        case 'https:':
            return port === '443';
    }
    return true;
}
var $ec0b2ea3826b1056$var$RULES = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    [
        '/',
        'path'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1
    ]
];
var $ec0b2ea3826b1056$var$PROTOCOL_REGEX = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
var $ec0b2ea3826b1056$export$59d795186a5d3f58 = function() {
    function Url(url) {
        var _this$extractProtocol = this.extractProtocol(url || ''), protocol = _this$extractProtocol.protocol, address = _this$extractProtocol.address, slashes = _this$extractProtocol.slashes;
        var relative = !protocol && !slashes;
        var location = this.getLocation();
        var instructions = $ec0b2ea3826b1056$var$RULES.slice();
        address = address.replace('\\', '/');
        if (!slashes) instructions[2] = [
            NaN,
            'path'
        ];
        var index;
        for(var i = 0; i < instructions.length; i++){
            var instruction = instructions[i];
            var parse = instruction[0];
            var key = instruction[1];
            if (typeof parse === 'string') {
                index = address.indexOf(parse);
                if (~index) {
                    var instLength = instruction[2];
                    if (instLength) {
                        var newIndex = address.lastIndexOf(parse);
                        index = Math.max(index, newIndex);
                        this[key] = address.slice(0, index);
                        address = address.slice(index + instLength);
                    } else {
                        this[key] = address.slice(index);
                        address = address.slice(0, index);
                    }
                }
            } else {
                this[key] = address;
                address = '';
            }
            this[key] = this[key] || (relative && instruction[3] ? location[key] || '' : '');
            if (instruction[3]) this[key] = this[key].toLowerCase();
        }
        if (relative && this.path.charAt(0) !== '/') this.path = '/' + this.path;
        this.relative = relative;
        this.protocol = protocol || location.protocol;
        this.hostname = this.host;
        this.port = '';
        if (/:\d+$/.test(this.host)) {
            var value = this.host.split(':');
            var port = value.pop();
            var hostname = value.join(':');
            if ($ec0b2ea3826b1056$var$isDefaultPort(port, this.protocol)) this.host = hostname;
            else this.port = port;
            this.hostname = hostname;
        }
        this.origin = this.protocol && this.host && this.protocol !== 'file:' ? this.protocol + '//' + this.host : 'null';
        this.href = this.toString();
    }
    var _proto = Url.prototype;
    _proto.toString = function toString() {
        var result = this.protocol;
        result += '//';
        if (this.auth) {
            var REDACTED = '[REDACTED]';
            var userpass = this.auth.split(':');
            var username = userpass[0] ? REDACTED : '';
            var password = userpass[1] ? ':' + REDACTED : '';
            result += username + password + '@';
        }
        result += this.host;
        result += this.path;
        result += this.query;
        result += this.hash;
        return result;
    };
    _proto.getLocation = function getLocation() {
        var globalVar = {};
        if (0, $5LMma.isBrowser) globalVar = window;
        return globalVar.location;
    };
    _proto.extractProtocol = function extractProtocol(url) {
        var match = $ec0b2ea3826b1056$var$PROTOCOL_REGEX.exec(url);
        return {
            protocol: match[1] ? match[1].toLowerCase() : '',
            slashes: !!match[2],
            address: match[3]
        };
    };
    return Url;
}();
function $ec0b2ea3826b1056$export$456a5af62e4119f6(urlStr, depth) {
    if (depth === void 0) depth = 2;
    var parsedUrl = new $ec0b2ea3826b1056$export$59d795186a5d3f58(urlStr);
    var query = parsedUrl.query, path = parsedUrl.path;
    var pathParts = path.substring(1).split('/');
    var redactString = ':id';
    var wildcard = '*';
    var specialCharsRegex = /\W|_/g;
    var digitsRegex = /[0-9]/g;
    var lowerCaseRegex = /[a-z]/g;
    var upperCaseRegex = /[A-Z]/g;
    var redactedParts = [];
    var redactedBefore = false;
    for(var index = 0; index < pathParts.length; index++){
        var part = pathParts[index];
        if (redactedBefore || index > depth - 1) {
            if (part) redactedParts.push(wildcard);
            break;
        }
        var numberOfSpecialChars = (part.match(specialCharsRegex) || []).length;
        if (numberOfSpecialChars >= 2) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberOfDigits = (part.match(digitsRegex) || []).length;
        if (numberOfDigits > 3 || part.length > 3 && numberOfDigits / part.length >= 0.3) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberofUpperCase = (part.match(upperCaseRegex) || []).length;
        var numberofLowerCase = (part.match(lowerCaseRegex) || []).length;
        var lowerCaseRate = numberofLowerCase / part.length;
        var upperCaseRate = numberofUpperCase / part.length;
        if (part.length > 5 && (upperCaseRate > 0.3 && upperCaseRate < 0.6 || lowerCaseRate > 0.3 && lowerCaseRate < 0.6)) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        part && redactedParts.push(part);
    }
    var redacted = '/' + (redactedParts.length >= 2 ? redactedParts.join('/') : redactedParts.join('')) + (query ? '?{query}' : '');
    return redacted;
}

});


parcelRegister("ahm0M", function(module, exports) {

$parcel$export(module.exports, "METADATA_MODEL", () => $77bc90f82ae41bfe$export$cddc53a868778b3a);
$parcel$export(module.exports, "SPAN_MODEL", () => $77bc90f82ae41bfe$export$41c959b800170f79);
$parcel$export(module.exports, "TRANSACTION_MODEL", () => $77bc90f82ae41bfe$export$d887b343e3ec3a69);
$parcel$export(module.exports, "ERROR_MODEL", () => $77bc90f82ae41bfe$export$fdad63db1c0e037c);
$parcel$export(module.exports, "truncateModel", () => $77bc90f82ae41bfe$export$488247de36c98c6b);

var $cs9KU = parcelRequire("cs9KU");
var $77bc90f82ae41bfe$export$cddc53a868778b3a = {
    service: {
        name: [
            (0, $cs9KU.KEYWORD_LIMIT),
            true
        ],
        version: true,
        agent: {
            version: [
                (0, $cs9KU.KEYWORD_LIMIT),
                true
            ]
        },
        environment: true
    },
    labels: {
        '*': true
    }
};
var $77bc90f82ae41bfe$export$a92fd7a0c1236a31 = {
    '*': true,
    headers: {
        '*': true
    }
};
var $77bc90f82ae41bfe$var$DESTINATION_MODEL = {
    address: [
        (0, $cs9KU.KEYWORD_LIMIT)
    ],
    service: {
        '*': [
            (0, $cs9KU.KEYWORD_LIMIT),
            true
        ]
    }
};
var $77bc90f82ae41bfe$var$CONTEXT_MODEL = {
    user: {
        id: true,
        email: true,
        username: true
    },
    tags: {
        '*': true
    },
    http: {
        response: $77bc90f82ae41bfe$export$a92fd7a0c1236a31
    },
    destination: $77bc90f82ae41bfe$var$DESTINATION_MODEL,
    response: $77bc90f82ae41bfe$export$a92fd7a0c1236a31
};
var $77bc90f82ae41bfe$export$41c959b800170f79 = {
    name: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    type: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    parent_id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    transaction_id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    subtype: true,
    action: true,
    context: $77bc90f82ae41bfe$var$CONTEXT_MODEL
};
var $77bc90f82ae41bfe$export$d887b343e3ec3a69 = {
    name: true,
    parent_id: true,
    type: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    span_count: {
        started: [
            (0, $cs9KU.KEYWORD_LIMIT),
            true
        ]
    },
    context: $77bc90f82ae41bfe$var$CONTEXT_MODEL
};
var $77bc90f82ae41bfe$export$fdad63db1c0e037c = {
    id: [
        (0, $cs9KU.KEYWORD_LIMIT),
        true
    ],
    trace_id: true,
    transaction_id: true,
    parent_id: true,
    culprit: true,
    exception: {
        type: true
    },
    transaction: {
        type: true
    },
    context: $77bc90f82ae41bfe$var$CONTEXT_MODEL
};
function $77bc90f82ae41bfe$export$6a506b36fdea397d(value, limit, required, placeholder) {
    if (limit === void 0) limit = (0, $cs9KU.KEYWORD_LIMIT);
    if (required === void 0) required = false;
    if (placeholder === void 0) placeholder = 'N/A';
    if (required && $77bc90f82ae41bfe$var$isEmpty(value)) value = placeholder;
    if (typeof value === 'string') return value.substring(0, limit);
    return value;
}
function $77bc90f82ae41bfe$var$isEmpty(value) {
    return value == null || value === '' || typeof value === 'undefined';
}
function $77bc90f82ae41bfe$var$replaceValue(target, key, currModel) {
    var value = $77bc90f82ae41bfe$export$6a506b36fdea397d(target[key], currModel[0], currModel[1]);
    if ($77bc90f82ae41bfe$var$isEmpty(value)) {
        delete target[key];
        return;
    }
    target[key] = value;
}
function $77bc90f82ae41bfe$export$488247de36c98c6b(model, target, childTarget) {
    if (model === void 0) model = {};
    if (childTarget === void 0) childTarget = target;
    var keys = Object.keys(model);
    var emptyArr = [];
    var _loop = function _loop(i) {
        var currKey = keys[i];
        var currModel = model[currKey] === true ? emptyArr : model[currKey];
        if (!Array.isArray(currModel)) $77bc90f82ae41bfe$export$488247de36c98c6b(currModel, target, childTarget[currKey]);
        else if (currKey === '*') Object.keys(childTarget).forEach(function(key) {
            return $77bc90f82ae41bfe$var$replaceValue(childTarget, key, currModel);
        });
        else $77bc90f82ae41bfe$var$replaceValue(childTarget, currKey, currModel);
    };
    for(var i = 0; i < keys.length; i++)_loop(i);
    return target;
}

});

parcelRegister("hSUrg", function(module, exports) {

(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
        'stackframe'
    ], factory);
    else module.exports = factory((parcelRequire("bNczT")));
})(module.exports, function ErrorStackParser(StackFrame) {
    'use strict';
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
    function _map(array, fn, thisArg) {
        if (typeof Array.prototype.map === 'function') return array.map(fn, thisArg);
        else {
            var output = new Array(array.length);
            for(var i = 0; i < array.length; i++)output[i] = fn.call(thisArg, array[i]);
            return output;
        }
    }
    function _filter(array, fn, thisArg) {
        if (typeof Array.prototype.filter === 'function') return array.filter(fn, thisArg);
        else {
            var output = [];
            for(var i = 0; i < array.length; i++)if (fn.call(thisArg, array[i])) output.push(array[i]);
            return output;
        }
    }
    function _indexOf(array, target) {
        if (typeof Array.prototype.indexOf === 'function') return array.indexOf(target);
        else {
            for(var i = 0; i < array.length; i++){
                if (array[i] === target) return i;
            }
            return -1;
        }
    }
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error('Cannot parse given Error object');
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
                var locationParts = this.extractLocation(tokens.pop());
                var functionName = tokens.join(' ') || undefined;
                var fileName = _indexOf([
                    'eval',
                    '<anonymous>'
                ], locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame(line);
                else {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionName = tokens.join('@') || undefined;
                    return new StackFrame(functionName, undefined, locationParts[0], locationParts[1], locationParts[2], line);
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(match[3] || undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return _map(filtered, function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || '';
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                return new StackFrame(functionName, args, locationParts[0], locationParts[1], locationParts[2], line);
            }, this);
        }
    };
});

});
parcelRegister("bNczT", function(module, exports) {
(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
    else module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
        if (functionName !== undefined) this.setFunctionName(functionName);
        if (args !== undefined) this.setArgs(args);
        if (fileName !== undefined) this.setFileName(fileName);
        if (lineNumber !== undefined) this.setLineNumber(lineNumber);
        if (columnNumber !== undefined) this.setColumnNumber(columnNumber);
        if (source !== undefined) this.setSource(source);
    }
    StackFrame.prototype = {
        getFunctionName: function() {
            return this.functionName;
        },
        setFunctionName: function(v) {
            this.functionName = String(v);
        },
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
            this.args = v;
        },
        // NOTE: Property name may be misleading as it includes the path,
        // but it somewhat mirrors V8's JavaScriptStackTraceApi
        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
        getFileName: function() {
            return this.fileName;
        },
        setFileName: function(v) {
            this.fileName = String(v);
        },
        getLineNumber: function() {
            return this.lineNumber;
        },
        setLineNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Line Number must be a Number');
            this.lineNumber = Number(v);
        },
        getColumnNumber: function() {
            return this.columnNumber;
        },
        setColumnNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Column Number must be a Number');
            this.columnNumber = Number(v);
        },
        getSource: function() {
            return this.source;
        },
        setSource: function(v) {
            this.source = String(v);
        },
        toString: function() {
            var functionName = this.getFunctionName() || '{anonymous}';
            var args = '(' + (this.getArgs() || []).join(',') + ')';
            var fileName = this.getFileName() ? '@' + this.getFileName() : '';
            var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
            var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
            return functionName + args + fileName + lineNumber + columnNumber;
        }
    };
    return StackFrame;
});

});



parcelRegister("lwQjO", function(module, exports) {

$parcel$export(module.exports, "serviceCreators", () => $fac52b7c63faf74d$export$a7d9bc765837b75c);
$parcel$export(module.exports, "ServiceFactory", () => $fac52b7c63faf74d$export$654036ce31f352db);

var $dgYTr = parcelRequire("dgYTr");

var $5xwuM = parcelRequire("5xwuM");

var $Nwvg7 = parcelRequire("Nwvg7");

var $cs9KU = parcelRequire("cs9KU");

var $6cgIX = parcelRequire("6cgIX");
var $fac52b7c63faf74d$var$_serviceCreators;
var $fac52b7c63faf74d$export$a7d9bc765837b75c = ($fac52b7c63faf74d$var$_serviceCreators = {}, $fac52b7c63faf74d$var$_serviceCreators[0, $cs9KU.CONFIG_SERVICE] = function() {
    return new (0, $5xwuM.default)();
}, $fac52b7c63faf74d$var$_serviceCreators[0, $cs9KU.LOGGING_SERVICE] = function() {
    return new (0, $Nwvg7.default)({
        prefix: '[Elastic APM] '
    });
}, $fac52b7c63faf74d$var$_serviceCreators[0, $cs9KU.APM_SERVER] = function(factory) {
    var _factory$getService = factory.getService([
        (0, $cs9KU.CONFIG_SERVICE),
        (0, $cs9KU.LOGGING_SERVICE)
    ]), configService = _factory$getService[0], loggingService = _factory$getService[1];
    return new (0, $dgYTr.default)(configService, loggingService);
}, $fac52b7c63faf74d$var$_serviceCreators);
var $fac52b7c63faf74d$export$654036ce31f352db = function() {
    function ServiceFactory() {
        this.instances = {};
        this.initialized = false;
    }
    var _proto = ServiceFactory.prototype;
    _proto.init = function init() {
        if (this.initialized) return;
        this.initialized = true;
        var configService = this.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.init();
        var _this$getService = this.getService([
            (0, $cs9KU.LOGGING_SERVICE),
            (0, $cs9KU.APM_SERVER)
        ]), loggingService = _this$getService[0], apmServer = _this$getService[1];
        configService.events.observe((0, $cs9KU.CONFIG_CHANGE), function() {
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
        });
        apmServer.init();
    };
    _proto.getService = function getService(name) {
        var _this = this;
        if (typeof name === 'string') {
            if (!this.instances[name]) {
                if (typeof $fac52b7c63faf74d$export$a7d9bc765837b75c[name] === 'function') this.instances[name] = $fac52b7c63faf74d$export$a7d9bc765837b75c[name](this);
                else if (0, $6cgIX.__DEV__) console.log('Cannot get service, No creator for: ' + name);
            }
            return this.instances[name];
        } else if (Array.isArray(name)) return name.map(function(n) {
            return _this.getService(n);
        });
    };
    return ServiceFactory;
}();

});
parcelRegister("dgYTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9c011cebb58d72$export$2e2bcd8739ae039);

var $fmOqd = parcelRequire("fmOqd");

var $4uMU4 = parcelRequire("4uMU4");

var $2yp55 = parcelRequire("2yp55");

var $ahm0M = parcelRequire("ahm0M");

var $cs9KU = parcelRequire("cs9KU");

var $5LMma = parcelRequire("5LMma");

var $alnvF = parcelRequire("alnvF");

var $7sv5s = parcelRequire("7sv5s");

var $6cgIX = parcelRequire("6cgIX");

var $jvvj2 = parcelRequire("jvvj2");

var $jHr8e = parcelRequire("jHr8e");
var $9a9c011cebb58d72$var$THROTTLE_INTERVAL = 60000;
var $9a9c011cebb58d72$var$ApmServer = function() {
    function ApmServer(configService, loggingService) {
        this._configService = configService;
        this._loggingService = loggingService;
        this.queue = undefined;
        this.throttleEvents = (0, $5LMma.noop);
    }
    var _proto = ApmServer.prototype;
    _proto.init = function init() {
        var _this = this;
        var queueLimit = this._configService.get('queueLimit');
        var flushInterval = this._configService.get('flushInterval');
        var limit = this._configService.get('eventsLimit');
        var onFlush = function onFlush(events) {
            var promise = _this.sendEvents(events);
            if (promise) promise.catch(function(reason) {
                _this._loggingService.warn('Failed sending events!', _this._constructError(reason));
            });
        };
        this.queue = new (0, $fmOqd.default)(onFlush, {
            queueLimit: queueLimit,
            flushInterval: flushInterval
        });
        this.throttleEvents = (0, $4uMU4.default)(this.queue.add.bind(this.queue), function() {
            return _this._loggingService.warn('Dropped events due to throttling!');
        }, {
            limit: limit,
            interval: $9a9c011cebb58d72$var$THROTTLE_INTERVAL
        });
        this._configService.observeEvent((0, $cs9KU.QUEUE_FLUSH), function() {
            _this.queue.flush();
        });
    };
    _proto._postJson = function _postJson(endPoint, payload) {
        var _this2 = this;
        var headers = {
            'Content-Type': 'application/x-ndjson'
        };
        var apmRequest = this._configService.get('apmRequest');
        var params = {
            payload: payload,
            headers: headers,
            beforeSend: apmRequest
        };
        return (0, $7sv5s.compressPayload)(params).catch(function(error) {
            if (0, $6cgIX.__DEV__) _this2._loggingService.debug('Compressing the payload using CompressionStream API failed', error.message);
            return params;
        }).then(function(result) {
            return _this2._makeHttpRequest('POST', endPoint, result);
        }).then(function(_ref) {
            var responseText = _ref.responseText;
            return responseText;
        });
    };
    _proto._constructError = function _constructError(reason) {
        var url = reason.url, status = reason.status, responseText = reason.responseText;
        if (typeof status == 'undefined') return reason;
        var message = url + ' HTTP status: ' + status;
        if ((0, $6cgIX.__DEV__) && responseText) try {
            var serverErrors = [];
            var response = JSON.parse(responseText);
            if (response.errors && response.errors.length > 0) {
                response.errors.forEach(function(err) {
                    return serverErrors.push(err.message);
                });
                message += ' ' + serverErrors.join(',');
            }
        } catch (e) {
            this._loggingService.debug('Error parsing response from APM server', e);
        }
        return new Error(message);
    };
    _proto._makeHttpRequest = function _makeHttpRequest(method, url, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? (0, $cs9KU.HTTP_REQUEST_TIMEOUT) : _ref2$timeout, payload = _ref2.payload, headers = _ref2.headers, beforeSend = _ref2.beforeSend;
        var sendCredentials = this._configService.get('sendCredentials');
        if (!beforeSend && (0, $jvvj2.shouldUseFetchWithKeepAlive)(method, payload)) return (0, $jvvj2.sendFetchRequest)(method, url, {
            keepalive: true,
            timeout: timeout,
            payload: payload,
            headers: headers,
            sendCredentials: sendCredentials
        }).catch(function(reason) {
            if (reason instanceof TypeError) return (0, $jHr8e.sendXHR)(method, url, {
                timeout: timeout,
                payload: payload,
                headers: headers,
                beforeSend: beforeSend,
                sendCredentials: sendCredentials
            });
            throw reason;
        });
        return (0, $jHr8e.sendXHR)(method, url, {
            timeout: timeout,
            payload: payload,
            headers: headers,
            beforeSend: beforeSend,
            sendCredentials: sendCredentials
        });
    };
    _proto.fetchConfig = function fetchConfig(serviceName, environment) {
        var _this3 = this;
        var _this$getEndpoints = this.getEndpoints(), configEndpoint = _this$getEndpoints.configEndpoint;
        if (!serviceName) return (0, $alnvF.Promise).reject('serviceName is required for fetching central config.');
        configEndpoint += "?service.name=" + serviceName;
        if (environment) configEndpoint += "&service.environment=" + environment;
        var localConfig = this._configService.getLocalConfig();
        if (localConfig) configEndpoint += "&ifnonematch=" + localConfig.etag;
        var apmRequest = this._configService.get('apmRequest');
        return this._makeHttpRequest('GET', configEndpoint, {
            timeout: 5000,
            beforeSend: apmRequest
        }).then(function(xhr) {
            var status = xhr.status, responseText = xhr.responseText;
            if (status === 304) return localConfig;
            else {
                var remoteConfig = JSON.parse(responseText);
                var etag = xhr.getResponseHeader('etag');
                if (etag) {
                    remoteConfig.etag = etag.replace(/["]/g, '');
                    _this3._configService.setLocalConfig(remoteConfig, true);
                }
                return remoteConfig;
            }
        }).catch(function(reason) {
            var error = _this3._constructError(reason);
            return (0, $alnvF.Promise).reject(error);
        });
    };
    _proto.createMetaData = function createMetaData() {
        var cfg = this._configService;
        var metadata = {
            service: {
                name: cfg.get('serviceName'),
                version: cfg.get('serviceVersion'),
                agent: {
                    name: 'rum-js',
                    version: cfg.version
                },
                language: {
                    name: 'javascript'
                },
                environment: cfg.get('environment')
            },
            labels: cfg.get('context.tags')
        };
        return (0, $ahm0M.truncateModel)((0, $ahm0M.METADATA_MODEL), metadata);
    };
    _proto.addError = function addError(error) {
        var _this$throttleEvents;
        this.throttleEvents((_this$throttleEvents = {}, _this$throttleEvents[0, $cs9KU.ERRORS] = error, _this$throttleEvents));
    };
    _proto.addTransaction = function addTransaction(transaction) {
        var _this$throttleEvents2;
        this.throttleEvents((_this$throttleEvents2 = {}, _this$throttleEvents2[0, $cs9KU.TRANSACTIONS] = transaction, _this$throttleEvents2));
    };
    _proto.ndjsonErrors = function ndjsonErrors(errors, compress) {
        var key = compress ? 'e' : 'error';
        return errors.map(function(error) {
            var _NDJSON$stringify;
            return (0, $2yp55.default).stringify((_NDJSON$stringify = {}, _NDJSON$stringify[key] = compress ? (0, $7sv5s.compressError)(error) : error, _NDJSON$stringify));
        });
    };
    _proto.ndjsonMetricsets = function ndjsonMetricsets(metricsets) {
        return metricsets.map(function(metricset) {
            return (0, $2yp55.default).stringify({
                metricset: metricset
            });
        }).join('');
    };
    _proto.ndjsonTransactions = function ndjsonTransactions(transactions, compress) {
        var _this4 = this;
        var key = compress ? 'x' : 'transaction';
        return transactions.map(function(tr) {
            var _NDJSON$stringify2;
            var spans = '', breakdowns = '';
            if (!compress) {
                if (tr.spans) {
                    spans = tr.spans.map(function(span) {
                        return (0, $2yp55.default).stringify({
                            span: span
                        });
                    }).join('');
                    delete tr.spans;
                }
                if (tr.breakdown) {
                    breakdowns = _this4.ndjsonMetricsets(tr.breakdown);
                    delete tr.breakdown;
                }
            }
            return (0, $2yp55.default).stringify((_NDJSON$stringify2 = {}, _NDJSON$stringify2[key] = compress ? (0, $7sv5s.compressTransaction)(tr) : tr, _NDJSON$stringify2)) + spans + breakdowns;
        });
    };
    _proto.sendEvents = function sendEvents(events) {
        var _payload, _NDJSON$stringify3;
        if (events.length === 0) return;
        var transactions = [];
        var errors = [];
        for(var i = 0; i < events.length; i++){
            var event = events[i];
            if (event[0, $cs9KU.TRANSACTIONS]) transactions.push(event[0, $cs9KU.TRANSACTIONS]);
            if (event[0, $cs9KU.ERRORS]) errors.push(event[0, $cs9KU.ERRORS]);
        }
        if (transactions.length === 0 && errors.length === 0) return;
        var cfg = this._configService;
        var payload = (_payload = {}, _payload[0, $cs9KU.TRANSACTIONS] = transactions, _payload[0, $cs9KU.ERRORS] = errors, _payload);
        var filteredPayload = cfg.applyFilters(payload);
        if (!filteredPayload) {
            this._loggingService.warn('Dropped payload due to filtering!');
            return;
        }
        var apiVersion = cfg.get('apiVersion');
        var compress = apiVersion > 2;
        var ndjson = [];
        var metadata = this.createMetaData();
        var metadataKey = compress ? 'm' : 'metadata';
        ndjson.push((0, $2yp55.default).stringify((_NDJSON$stringify3 = {}, _NDJSON$stringify3[metadataKey] = compress ? (0, $7sv5s.compressMetadata)(metadata) : metadata, _NDJSON$stringify3)));
        ndjson = ndjson.concat(this.ndjsonErrors(filteredPayload[0, $cs9KU.ERRORS], compress), this.ndjsonTransactions(filteredPayload[0, $cs9KU.TRANSACTIONS], compress));
        var ndjsonPayload = ndjson.join('');
        var _this$getEndpoints2 = this.getEndpoints(), intakeEndpoint = _this$getEndpoints2.intakeEndpoint;
        return this._postJson(intakeEndpoint, ndjsonPayload);
    };
    _proto.getEndpoints = function getEndpoints() {
        var serverUrl = this._configService.get('serverUrl');
        var apiVersion = this._configService.get('apiVersion');
        var serverUrlPrefix = this._configService.get('serverUrlPrefix') || "/intake/v" + apiVersion + "/rum/events";
        var intakeEndpoint = serverUrl + serverUrlPrefix;
        var configEndpoint = serverUrl + "/config/v1/rum/agents";
        return {
            intakeEndpoint: intakeEndpoint,
            configEndpoint: configEndpoint
        };
    };
    return ApmServer;
}();
var $9a9c011cebb58d72$export$2e2bcd8739ae039 = $9a9c011cebb58d72$var$ApmServer;

});
parcelRegister("fmOqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b30005d541c78cc7$export$2e2bcd8739ae039);
var $b30005d541c78cc7$var$Queue = function() {
    function Queue(onFlush, opts) {
        if (opts === void 0) opts = {};
        this.onFlush = onFlush;
        this.items = [];
        this.queueLimit = opts.queueLimit || -1;
        this.flushInterval = opts.flushInterval || 0;
        this.timeoutId = undefined;
    }
    var _proto = Queue.prototype;
    _proto._setTimer = function _setTimer() {
        var _this = this;
        this.timeoutId = setTimeout(function() {
            return _this.flush();
        }, this.flushInterval);
    };
    _proto._clear = function _clear() {
        if (typeof this.timeoutId !== 'undefined') {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this.items = [];
    };
    _proto.flush = function flush() {
        this.onFlush(this.items);
        this._clear();
    };
    _proto.add = function add(item) {
        this.items.push(item);
        if (this.queueLimit !== -1 && this.items.length >= this.queueLimit) this.flush();
        else if (typeof this.timeoutId === 'undefined') this._setTimer();
    };
    return Queue;
}();
var $b30005d541c78cc7$export$2e2bcd8739ae039 = $b30005d541c78cc7$var$Queue;

});

parcelRegister("4uMU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $345fe5f8b87ce6d1$export$2e2bcd8739ae039);
function $345fe5f8b87ce6d1$export$2e2bcd8739ae039(fn, onThrottle, opts) {
    var context = this;
    var limit = opts.limit;
    var interval = opts.interval;
    var counter = 0;
    var timeoutId;
    return function() {
        counter++;
        if (typeof timeoutId === 'undefined') timeoutId = setTimeout(function() {
            counter = 0;
            timeoutId = undefined;
        }, interval);
        if (counter > limit && typeof onThrottle === 'function') return onThrottle.apply(context, arguments);
        else return fn.apply(context, arguments);
    };
}

});

parcelRegister("2yp55", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc2364fe11ecc9e$export$2e2bcd8739ae039);
var $1dc2364fe11ecc9e$var$NDJSON = function() {
    function NDJSON() {}
    NDJSON.stringify = function stringify(object) {
        return JSON.stringify(object) + '\n';
    };
    return NDJSON;
}();
var $1dc2364fe11ecc9e$export$2e2bcd8739ae039 = $1dc2364fe11ecc9e$var$NDJSON;

});

parcelRegister("7sv5s", function(module, exports) {

$parcel$export(module.exports, "compressMetadata", () => $56e3432e299bdac7$export$12b7560e2fabea9);
$parcel$export(module.exports, "compressTransaction", () => $56e3432e299bdac7$export$2113d87e265597f0);
$parcel$export(module.exports, "compressError", () => $56e3432e299bdac7$export$c8289256501a337d);
$parcel$export(module.exports, "compressPayload", () => $56e3432e299bdac7$export$5569fdd03c217956);

var $alnvF = parcelRequire("alnvF");

var $7J1OQ = parcelRequire("7J1OQ");

var $5LMma = parcelRequire("5LMma");
function $56e3432e299bdac7$var$compressStackFrames(frames) {
    return frames.map(function(frame) {
        return {
            ap: frame.abs_path,
            f: frame.filename,
            fn: frame.function,
            li: frame.lineno,
            co: frame.colno
        };
    });
}
function $56e3432e299bdac7$var$compressResponse(response) {
    return {
        ts: response.transfer_size,
        ebs: response.encoded_body_size,
        dbs: response.decoded_body_size
    };
}
function $56e3432e299bdac7$var$compressHTTP(http) {
    var compressed = {};
    var method = http.method, status_code = http.status_code, url = http.url, response = http.response;
    compressed.url = url;
    if (method) compressed.mt = method;
    if (status_code) compressed.sc = status_code;
    if (response) compressed.r = $56e3432e299bdac7$var$compressResponse(response);
    return compressed;
}
function $56e3432e299bdac7$var$compressContext(context) {
    if (!context) return null;
    var compressed = {};
    var page = context.page, http = context.http, response = context.response, destination = context.destination, user = context.user, custom = context.custom;
    if (page) compressed.p = {
        rf: page.referer,
        url: page.url
    };
    if (http) compressed.h = $56e3432e299bdac7$var$compressHTTP(http);
    if (response) compressed.r = $56e3432e299bdac7$var$compressResponse(response);
    if (destination) {
        var service = destination.service;
        compressed.dt = {
            se: {
                n: service.name,
                t: service.type,
                rc: service.resource
            },
            ad: destination.address,
            po: destination.port
        };
    }
    if (user) compressed.u = {
        id: user.id,
        un: user.username,
        em: user.email
    };
    if (custom) compressed.cu = custom;
    return compressed;
}
function $56e3432e299bdac7$var$compressMarks(marks) {
    if (!marks) return null;
    var compressedNtMarks = $56e3432e299bdac7$var$compressNavigationTimingMarks(marks.navigationTiming);
    var compressed = {
        nt: compressedNtMarks,
        a: $56e3432e299bdac7$var$compressAgentMarks(compressedNtMarks, marks.agent)
    };
    return compressed;
}
function $56e3432e299bdac7$var$compressNavigationTimingMarks(ntMarks) {
    if (!ntMarks) return null;
    var compressed = {};
    (0, $7J1OQ.COMPRESSED_NAV_TIMING_MARKS).forEach(function(mark, index) {
        var mapping = (0, $7J1OQ.NAVIGATION_TIMING_MARKS)[index];
        compressed[mark] = ntMarks[mapping];
    });
    return compressed;
}
function $56e3432e299bdac7$var$compressAgentMarks(compressedNtMarks, agentMarks) {
    var compressed = {};
    if (compressedNtMarks) compressed = {
        fb: compressedNtMarks.rs,
        di: compressedNtMarks.di,
        dc: compressedNtMarks.dc
    };
    if (agentMarks) {
        var fp = agentMarks.firstContentfulPaint;
        var lp = agentMarks.largestContentfulPaint;
        if (fp) compressed.fp = fp;
        if (lp) compressed.lp = lp;
    }
    if (Object.keys(compressed).length === 0) return null;
    return compressed;
}
function $56e3432e299bdac7$export$12b7560e2fabea9(metadata) {
    var service = metadata.service, labels = metadata.labels;
    var agent = service.agent, language = service.language;
    return {
        se: {
            n: service.name,
            ve: service.version,
            a: {
                n: agent.name,
                ve: agent.version
            },
            la: {
                n: language.name
            },
            en: service.environment
        },
        l: labels
    };
}
function $56e3432e299bdac7$export$2113d87e265597f0(transaction) {
    var spans = transaction.spans.map(function(span) {
        var spanData = {
            id: span.id,
            n: span.name,
            t: span.type,
            s: span.start,
            d: span.duration,
            c: $56e3432e299bdac7$var$compressContext(span.context),
            o: span.outcome,
            sr: span.sample_rate
        };
        if (span.parent_id !== transaction.id) spanData.pid = span.parent_id;
        if (span.sync === true) spanData.sy = true;
        if (span.subtype) spanData.su = span.subtype;
        if (span.action) spanData.ac = span.action;
        return spanData;
    });
    var tr = {
        id: transaction.id,
        tid: transaction.trace_id,
        n: transaction.name,
        t: transaction.type,
        d: transaction.duration,
        c: $56e3432e299bdac7$var$compressContext(transaction.context),
        k: $56e3432e299bdac7$var$compressMarks(transaction.marks),
        me: $56e3432e299bdac7$export$9327fccd6912fe3c(transaction.breakdown),
        y: spans,
        yc: {
            sd: spans.length
        },
        sm: transaction.sampled,
        sr: transaction.sample_rate,
        o: transaction.outcome
    };
    if (transaction.experience) {
        var _transaction$experien = transaction.experience, cls = _transaction$experien.cls, fid = _transaction$experien.fid, tbt = _transaction$experien.tbt, longtask = _transaction$experien.longtask;
        tr.exp = {
            cls: cls,
            fid: fid,
            tbt: tbt,
            lt: longtask
        };
    }
    if (transaction.session) {
        var _transaction$session = transaction.session, id = _transaction$session.id, sequence = _transaction$session.sequence;
        tr.ses = {
            id: id,
            seq: sequence
        };
    }
    return tr;
}
function $56e3432e299bdac7$export$c8289256501a337d(error) {
    var exception = error.exception;
    var compressed = {
        id: error.id,
        cl: error.culprit,
        ex: {
            mg: exception.message,
            st: $56e3432e299bdac7$var$compressStackFrames(exception.stacktrace),
            t: error.type
        },
        c: $56e3432e299bdac7$var$compressContext(error.context)
    };
    var transaction = error.transaction;
    if (transaction) {
        compressed.tid = error.trace_id;
        compressed.pid = error.parent_id;
        compressed.xid = error.transaction_id;
        compressed.x = {
            t: transaction.type,
            sm: transaction.sampled
        };
    }
    return compressed;
}
function $56e3432e299bdac7$export$9327fccd6912fe3c(breakdowns) {
    return breakdowns.map(function(_ref) {
        var span = _ref.span, samples = _ref.samples;
        var isSpan = span != null;
        if (isSpan) return {
            y: {
                t: span.type
            },
            sa: {
                ysc: {
                    v: samples['span.self_time.count'].value
                },
                yss: {
                    v: samples['span.self_time.sum.us'].value
                }
            }
        };
        return {
            sa: {
                xdc: {
                    v: samples['transaction.duration.count'].value
                },
                xds: {
                    v: samples['transaction.duration.sum.us'].value
                },
                xbc: {
                    v: samples['transaction.breakdown.count'].value
                }
            }
        };
    });
}
function $56e3432e299bdac7$export$5569fdd03c217956(params, type) {
    if (type === void 0) type = 'gzip';
    var isCompressionStreamSupported = typeof CompressionStream === 'function';
    return new (0, $alnvF.Promise)(function(resolve) {
        if (!isCompressionStreamSupported) return resolve(params);
        if ((0, $5LMma.isBeaconInspectionEnabled)()) return resolve(params);
        var payload = params.payload, headers = params.headers, beforeSend = params.beforeSend;
        var payloadStream = new Blob([
            payload
        ]).stream();
        var compressedStream = payloadStream.pipeThrough(new CompressionStream(type));
        return new Response(compressedStream).blob().then(function(payload) {
            headers['Content-Encoding'] = type;
            return resolve({
                payload: payload,
                headers: headers,
                beforeSend: beforeSend
            });
        });
    });
}

});
parcelRegister("7J1OQ", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TIMING_MARKS", () => $59fe259a0fb2d6e9$export$76056912abddbcc9);
$parcel$export(module.exports, "COMPRESSED_NAV_TIMING_MARKS", () => $59fe259a0fb2d6e9$export$82a807639806d09d);
$parcel$export(module.exports, "captureNavigation", () => $59fe259a0fb2d6e9$export$ffbf565d212a6a74);

var $lPS7D = parcelRequire("lPS7D");

var $cs9KU = parcelRequire("cs9KU");

var $5LMma = parcelRequire("5LMma");

var $6cgIX = parcelRequire("6cgIX");
var $59fe259a0fb2d6e9$var$eventPairs = [
    [
        'domainLookupStart',
        'domainLookupEnd',
        'Domain lookup'
    ],
    [
        'connectStart',
        'connectEnd',
        'Making a connection to the server'
    ],
    [
        'requestStart',
        'responseEnd',
        'Requesting and receiving the document'
    ],
    [
        'domLoading',
        'domInteractive',
        'Parsing the document, executing sync. scripts'
    ],
    [
        'domContentLoadedEventStart',
        'domContentLoadedEventEnd',
        'Fire "DOMContentLoaded" event'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Fire "load" event'
    ]
];
function $59fe259a0fb2d6e9$var$shouldCreateSpan(start, end, trStart, trEnd, baseTime) {
    if (baseTime === void 0) baseTime = 0;
    return typeof start === 'number' && typeof end === 'number' && start >= baseTime && end > start && start - baseTime >= trStart && end - baseTime <= trEnd && end - start < (0, $cs9KU.MAX_SPAN_DURATION) && start - baseTime < (0, $cs9KU.MAX_SPAN_DURATION) && end - baseTime < (0, $cs9KU.MAX_SPAN_DURATION);
}
function $59fe259a0fb2d6e9$export$3f88cb87ead13585(timings, baseTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < $59fe259a0fb2d6e9$var$eventPairs.length; i++){
        var start = timings[$59fe259a0fb2d6e9$var$eventPairs[i][0]];
        var end = timings[$59fe259a0fb2d6e9$var$eventPairs[i][1]];
        if (!$59fe259a0fb2d6e9$var$shouldCreateSpan(start, end, trStart, trEnd, baseTime)) continue;
        var span = new (0, $lPS7D.default)($59fe259a0fb2d6e9$var$eventPairs[i][2], 'hard-navigation.browser-timing');
        var data = null;
        if ($59fe259a0fb2d6e9$var$eventPairs[i][0] === 'requestStart') {
            span.pageResponse = true;
            data = {
                url: location.origin
            };
        }
        span._start = start - baseTime;
        span.end(end - baseTime, data);
        spans.push(span);
    }
    return spans;
}
function $59fe259a0fb2d6e9$var$createResourceTimingSpan(resourceTimingEntry) {
    var name = resourceTimingEntry.name, initiatorType = resourceTimingEntry.initiatorType, startTime = resourceTimingEntry.startTime, responseEnd = resourceTimingEntry.responseEnd;
    var kind = 'resource';
    if (initiatorType) kind += '.' + initiatorType;
    var spanName = (0, $5LMma.stripQueryStringFromUrl)(name);
    var span = new (0, $lPS7D.default)(spanName, kind);
    span._start = startTime;
    span.end(responseEnd, {
        url: name,
        entry: resourceTimingEntry
    });
    return span;
}
function $59fe259a0fb2d6e9$var$isCapturedByPatching(resourceStartTime, requestPatchTime) {
    return requestPatchTime != null && resourceStartTime > requestPatchTime;
}
function $59fe259a0fb2d6e9$var$isIntakeAPIEndpoint(url) {
    return /intake\/v\d+\/rum\/events/.test(url);
}
function $59fe259a0fb2d6e9$export$c7038f2b5602881b(entries, requestPatchTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], initiatorType = _entries$i.initiatorType, name = _entries$i.name, startTime = _entries$i.startTime, responseEnd = _entries$i.responseEnd;
        if ((0, $cs9KU.RESOURCE_INITIATOR_TYPES).indexOf(initiatorType) === -1 || name == null) continue;
        if ((initiatorType === 'xmlhttprequest' || initiatorType === 'fetch') && ($59fe259a0fb2d6e9$var$isIntakeAPIEndpoint(name) || $59fe259a0fb2d6e9$var$isCapturedByPatching(startTime, requestPatchTime))) continue;
        if ($59fe259a0fb2d6e9$var$shouldCreateSpan(startTime, responseEnd, trStart, trEnd)) spans.push($59fe259a0fb2d6e9$var$createResourceTimingSpan(entries[i]));
    }
    return spans;
}
function $59fe259a0fb2d6e9$export$d31d86bf4b796a11(entries, trStart, trEnd) {
    var userTimingSpans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i2 = entries[i], name = _entries$i2.name, startTime = _entries$i2.startTime, duration = _entries$i2.duration;
        var end = startTime + duration;
        if (duration <= (0, $cs9KU.USER_TIMING_THRESHOLD) || !$59fe259a0fb2d6e9$var$shouldCreateSpan(startTime, end, trStart, trEnd)) continue;
        var kind = 'app';
        var span = new (0, $lPS7D.default)(name, kind);
        span._start = startTime;
        span.end(end);
        userTimingSpans.push(span);
    }
    return userTimingSpans;
}
var $59fe259a0fb2d6e9$export$76056912abddbcc9 = [
    'fetchStart',
    'domainLookupStart',
    'domainLookupEnd',
    'connectStart',
    'connectEnd',
    'requestStart',
    'responseStart',
    'responseEnd',
    'domLoading',
    'domInteractive',
    'domContentLoadedEventStart',
    'domContentLoadedEventEnd',
    'domComplete',
    'loadEventStart',
    'loadEventEnd'
];
var $59fe259a0fb2d6e9$export$82a807639806d09d = [
    'fs',
    'ls',
    'le',
    'cs',
    'ce',
    'qs',
    'rs',
    're',
    'dl',
    'di',
    'ds',
    'de',
    'dc',
    'es',
    'ee'
];
function $59fe259a0fb2d6e9$var$getNavigationTimingMarks(timing) {
    var fetchStart = timing.fetchStart, navigationStart = timing.navigationStart, responseStart = timing.responseStart, responseEnd = timing.responseEnd;
    if (fetchStart >= navigationStart && responseStart >= fetchStart && responseEnd >= responseStart) {
        var marks = {};
        $59fe259a0fb2d6e9$export$76056912abddbcc9.forEach(function(timingKey) {
            var m = timing[timingKey];
            if (m && m >= fetchStart) marks[timingKey] = parseInt(m - fetchStart);
        });
        return marks;
    }
    return null;
}
function $59fe259a0fb2d6e9$export$f010c0904d0d2983(timing) {
    var marks = $59fe259a0fb2d6e9$var$getNavigationTimingMarks(timing);
    if (marks == null) return null;
    return {
        navigationTiming: marks,
        agent: {
            timeToFirstByte: marks.responseStart,
            domInteractive: marks.domInteractive,
            domComplete: marks.domComplete
        }
    };
}
function $59fe259a0fb2d6e9$export$ffbf565d212a6a74(transaction) {
    if (!transaction.captureTimings) return;
    var trEnd = transaction._end;
    if (transaction.type === (0, $cs9KU.PAGE_LOAD)) {
        if (transaction.marks && transaction.marks.custom) {
            var customMarks = transaction.marks.custom;
            Object.keys(customMarks).forEach(function(key) {
                customMarks[key] += transaction._start;
            });
        }
        var trStart = 0;
        transaction._start = trStart;
        var timings = (0, $5LMma.PERF).timing;
        $59fe259a0fb2d6e9$export$3f88cb87ead13585(timings, timings.fetchStart, trStart, trEnd).forEach(function(span) {
            span.traceId = transaction.traceId;
            span.sampled = transaction.sampled;
            if (span.pageResponse && transaction.options.pageLoadSpanId) span.id = transaction.options.pageLoadSpanId;
            transaction.spans.push(span);
        });
        transaction.addMarks($59fe259a0fb2d6e9$export$f010c0904d0d2983(timings));
    }
    if ((0, $5LMma.isPerfTimelineSupported)()) {
        var _trStart = transaction._start;
        var resourceEntries = (0, $5LMma.PERF).getEntriesByType((0, $cs9KU.RESOURCE));
        $59fe259a0fb2d6e9$export$c7038f2b5602881b(resourceEntries, (0, $6cgIX.state).bootstrapTime, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
        var userEntries = (0, $5LMma.PERF).getEntriesByType((0, $cs9KU.MEASURE));
        $59fe259a0fb2d6e9$export$d31d86bf4b796a11(userEntries, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
    }
}

});
parcelRegister("lPS7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe5857eb8ef052b5$export$2e2bcd8739ae039);

var $2m8fl = parcelRequire("2m8fl");

var $aUu0v = parcelRequire("aUu0v");
function $fe5857eb8ef052b5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $fe5857eb8ef052b5$var$_setPrototypeOf(subClass, superClass);
}
function $fe5857eb8ef052b5$var$_setPrototypeOf(o, p) {
    $fe5857eb8ef052b5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe5857eb8ef052b5$var$_setPrototypeOf(o, p);
}
var $fe5857eb8ef052b5$var$Span = function(_SpanBase) {
    $fe5857eb8ef052b5$var$_inheritsLoose(Span, _SpanBase);
    function Span(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.parentId = _this.options.parentId;
        _this.subtype = undefined;
        _this.action = undefined;
        if (_this.type.indexOf('.') !== -1) {
            var fields = _this.type.split('.', 3);
            _this.type = fields[0];
            _this.subtype = fields[1];
            _this.action = fields[2];
        }
        _this.sync = _this.options.sync;
        return _this;
    }
    var _proto = Span.prototype;
    _proto.end = function end(endTime, data) {
        _SpanBase.prototype.end.call(this, endTime);
        (0, $aUu0v.addSpanContext)(this, data);
    };
    return Span;
}((0, $2m8fl.default));
var $fe5857eb8ef052b5$export$2e2bcd8739ae039 = $fe5857eb8ef052b5$var$Span;

});
parcelRegister("2m8fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b74086ccbb258b0$export$2e2bcd8739ae039);

var $5LMma = parcelRequire("5LMma");

var $cs9KU = parcelRequire("cs9KU");
var $1b74086ccbb258b0$var$SpanBase = function() {
    function SpanBase(name, type, options) {
        if (options === void 0) options = {};
        if (!name) name = (0, $cs9KU.NAME_UNKNOWN);
        if (!type) type = (0, $cs9KU.TYPE_CUSTOM);
        this.name = name;
        this.type = type;
        this.options = options;
        this.id = options.id || (0, $5LMma.generateRandomId)(16);
        this.traceId = options.traceId;
        this.sampled = options.sampled;
        this.sampleRate = options.sampleRate;
        this.timestamp = options.timestamp;
        this._start = (0, $5LMma.getTime)(options.startTime);
        this._end = undefined;
        this.ended = false;
        this.outcome = undefined;
        this.onEnd = options.onEnd;
    }
    var _proto = SpanBase.prototype;
    _proto.ensureContext = function ensureContext() {
        if (!this.context) this.context = {};
    };
    _proto.addLabels = function addLabels(tags) {
        this.ensureContext();
        var ctx = this.context;
        if (!ctx.tags) ctx.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $5LMma.setLabel)(k, tags[k], ctx.tags);
        });
    };
    _proto.addContext = function addContext() {
        for(var _len = arguments.length, context = new Array(_len), _key = 0; _key < _len; _key++)context[_key] = arguments[_key];
        if (context.length === 0) return;
        this.ensureContext();
        (0, $5LMma.merge).apply(void 0, [
            this.context
        ].concat(context));
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $5LMma.getTime)(endTime);
        this.callOnEnd();
    };
    _proto.callOnEnd = function callOnEnd() {
        if (typeof this.onEnd === 'function') this.onEnd(this);
    };
    _proto.duration = function duration() {
        return (0, $5LMma.getDuration)(this._start, this._end);
    };
    return SpanBase;
}();
var $1b74086ccbb258b0$export$2e2bcd8739ae039 = $1b74086ccbb258b0$var$SpanBase;

});




parcelRegister("jHr8e", function(module, exports) {

$parcel$export(module.exports, "sendXHR", () => $e577144ae9c05b7e$export$998d51f5856d10f5);

var $cLdmR = parcelRequire("cLdmR");

var $kDgVV = parcelRequire("kDgVV");

var $alnvF = parcelRequire("alnvF");
function $e577144ae9c05b7e$export$998d51f5856d10f5(method, url, _ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? HTTP_REQUEST_TIMEOUT : _ref$timeout, payload = _ref.payload, headers = _ref.headers, beforeSend = _ref.beforeSend, sendCredentials = _ref.sendCredentials;
    return new (0, $alnvF.Promise)(function(resolve, reject) {
        var xhr = new window.XMLHttpRequest();
        xhr[0, $cLdmR.XHR_IGNORE] = true;
        xhr.open(method, url, true);
        xhr.timeout = timeout;
        xhr.withCredentials = sendCredentials;
        if (headers) {
            for(var header in headers)if (headers.hasOwnProperty(header)) xhr.setRequestHeader(header, headers[header]);
        }
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var status = xhr.status, responseText = xhr.responseText;
                if ((0, $kDgVV.isResponseSuccessful)(status)) resolve(xhr);
                else reject({
                    url: url,
                    status: status,
                    responseText: responseText
                });
            }
        };
        xhr.onerror = function() {
            var status = xhr.status, responseText = xhr.responseText;
            reject({
                url: url,
                status: status,
                responseText: responseText
            });
        };
        var canSend = true;
        if (typeof beforeSend === 'function') canSend = beforeSend({
            url: url,
            method: method,
            headers: headers,
            payload: payload,
            xhr: xhr
        });
        if (canSend) xhr.send(payload);
        else reject({
            url: url,
            status: 0,
            responseText: 'Request rejected by user configuration.'
        });
    });
}

});


parcelRegister("5xwuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $40893dbc8936fb80$export$2e2bcd8739ae039);

var $5LMma = parcelRequire("5LMma");

var $iTGhh = parcelRequire("iTGhh");

var $cs9KU = parcelRequire("cs9KU");
function $40893dbc8936fb80$var$_extends() {
    $40893dbc8936fb80$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $40893dbc8936fb80$var$_extends.apply(this, arguments);
}
function $40893dbc8936fb80$var$getConfigFromScript() {
    var script = (0, $5LMma.getCurrentScript)();
    var config = $40893dbc8936fb80$var$getDataAttributesFromNode(script);
    return config;
}
function $40893dbc8936fb80$var$getDataAttributesFromNode(node) {
    if (!node) return {};
    var dataAttrs = {};
    var dataRegex = /^data-([\w-]+)$/;
    var attrs = node.attributes;
    for(var i = 0; i < attrs.length; i++){
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
            var key = attr.nodeName.match(dataRegex)[1];
            var camelCasedkey = key.split('-').map(function(value, index) {
                return index > 0 ? value.charAt(0).toUpperCase() + value.substring(1) : value;
            }).join('');
            dataAttrs[camelCasedkey] = attr.value || attr.nodeValue;
        }
    }
    return dataAttrs;
}
var $40893dbc8936fb80$var$Config = function() {
    function Config() {
        this.config = {
            serviceName: '',
            serviceVersion: '',
            environment: '',
            serverUrl: 'http://localhost:8200',
            serverUrlPrefix: '',
            active: true,
            instrument: true,
            disableInstrumentations: [],
            logLevel: 'warn',
            breakdownMetrics: false,
            ignoreTransactions: [],
            eventsLimit: 80,
            queueLimit: -1,
            flushInterval: 500,
            distributedTracing: true,
            distributedTracingOrigins: [],
            distributedTracingHeaderName: 'traceparent',
            pageLoadTraceId: '',
            pageLoadSpanId: '',
            pageLoadSampled: false,
            pageLoadTransactionName: '',
            propagateTracestate: false,
            transactionSampleRate: 1.0,
            centralConfig: false,
            monitorLongtasks: true,
            apiVersion: 2,
            context: {},
            session: false,
            apmRequest: null,
            sendCredentials: false
        };
        this.events = new (0, $iTGhh.default)();
        this.filters = [];
        this.version = '';
    }
    var _proto = Config.prototype;
    _proto.init = function init() {
        var scriptData = $40893dbc8936fb80$var$getConfigFromScript();
        this.setConfig(scriptData);
    };
    _proto.setVersion = function setVersion(version) {
        this.version = version;
    };
    _proto.addFilter = function addFilter(cb) {
        if (typeof cb !== 'function') throw new Error('Argument to must be function');
        this.filters.push(cb);
    };
    _proto.applyFilters = function applyFilters(data) {
        for(var i = 0; i < this.filters.length; i++){
            data = this.filters[i](data);
            if (!data) return;
        }
        return data;
    };
    _proto.get = function get(key) {
        return key.split('.').reduce(function(obj, objKey) {
            return obj && obj[objKey];
        }, this.config);
    };
    _proto.setUserContext = function setUserContext(userContext) {
        if (userContext === void 0) userContext = {};
        var context = {};
        var _userContext = userContext, id = _userContext.id, username = _userContext.username, email = _userContext.email;
        if (typeof id === 'number' || typeof id === 'string') context.id = id;
        if (typeof username === 'string') context.username = username;
        if (typeof email === 'string') context.email = email;
        this.config.context.user = (0, $5LMma.extend)(this.config.context.user || {}, context);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        if (customContext === void 0) customContext = {};
        this.config.context.custom = (0, $5LMma.extend)(this.config.context.custom || {}, customContext);
    };
    _proto.addLabels = function addLabels(tags) {
        var _this = this;
        if (!this.config.context.tags) this.config.context.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $5LMma.setLabel)(k, tags[k], _this.config.context.tags);
        });
    };
    _proto.setConfig = function setConfig(properties) {
        if (properties === void 0) properties = {};
        var _properties = properties, transactionSampleRate = _properties.transactionSampleRate, serverUrl = _properties.serverUrl;
        if (serverUrl) properties.serverUrl = serverUrl.replace(/\/+$/, '');
        if (!(0, $5LMma.isUndefined)(transactionSampleRate)) {
            if (transactionSampleRate < 0.0001 && transactionSampleRate > 0) transactionSampleRate = 0.0001;
            properties.transactionSampleRate = Math.round(transactionSampleRate * 10000) / 10000;
        }
        (0, $5LMma.merge)(this.config, properties);
        this.events.send((0, $cs9KU.CONFIG_CHANGE), [
            this.config
        ]);
    };
    _proto.validate = function validate(properties) {
        if (properties === void 0) properties = {};
        var requiredKeys = [
            'serviceName',
            'serverUrl'
        ];
        var allKeys = Object.keys(this.config);
        var errors = {
            missing: [],
            invalid: [],
            unknown: []
        };
        Object.keys(properties).forEach(function(key) {
            if (requiredKeys.indexOf(key) !== -1 && !properties[key]) errors.missing.push(key);
            if (allKeys.indexOf(key) === -1) errors.unknown.push(key);
        });
        if (properties.serviceName && !/^[a-zA-Z0-9 _-]+$/.test(properties.serviceName)) errors.invalid.push({
            key: 'serviceName',
            value: properties.serviceName,
            allowed: 'a-z, A-Z, 0-9, _, -, <space>'
        });
        var sampleRate = properties.transactionSampleRate;
        if (typeof sampleRate !== 'undefined' && (typeof sampleRate !== 'number' || isNaN(sampleRate) || sampleRate < 0 || sampleRate > 1)) errors.invalid.push({
            key: 'transactionSampleRate',
            value: sampleRate,
            allowed: 'Number between 0 and 1'
        });
        return errors;
    };
    _proto.getLocalConfig = function getLocalConfig() {
        var storage = sessionStorage;
        if (this.config.session) storage = localStorage;
        var config = storage.getItem((0, $cs9KU.LOCAL_CONFIG_KEY));
        if (config) return JSON.parse(config);
    };
    _proto.setLocalConfig = function setLocalConfig(config, merge) {
        if (config) {
            if (merge) {
                var prevConfig = this.getLocalConfig();
                config = $40893dbc8936fb80$var$_extends({}, prevConfig, config);
            }
            var storage = sessionStorage;
            if (this.config.session) storage = localStorage;
            storage.setItem((0, $cs9KU.LOCAL_CONFIG_KEY), JSON.stringify(config));
        }
    };
    _proto.dispatchEvent = function dispatchEvent(name, args) {
        this.events.send(name, args);
    };
    _proto.observeEvent = function observeEvent(name, fn) {
        return this.events.observe(name, fn);
    };
    return Config;
}();
var $40893dbc8936fb80$export$2e2bcd8739ae039 = $40893dbc8936fb80$var$Config;

});

parcelRegister("Nwvg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $094dca2c088c3a8e$export$2e2bcd8739ae039);

var $5LMma = parcelRequire("5LMma");
var $094dca2c088c3a8e$var$LoggingService = function() {
    function LoggingService(spec) {
        if (spec === void 0) spec = {};
        this.levels = [
            'trace',
            'debug',
            'info',
            'warn',
            'error'
        ];
        this.level = spec.level || 'warn';
        this.prefix = spec.prefix || '';
        this.resetLogMethods();
    }
    var _proto = LoggingService.prototype;
    _proto.shouldLog = function shouldLog(level) {
        return this.levels.indexOf(level) >= this.levels.indexOf(this.level);
    };
    _proto.setLevel = function setLevel(level) {
        if (level === this.level) return;
        this.level = level;
        this.resetLogMethods();
    };
    _proto.resetLogMethods = function resetLogMethods() {
        var _this = this;
        this.levels.forEach(function(level) {
            _this[level] = _this.shouldLog(level) ? log : (0, $5LMma.noop);
            function log() {
                var normalizedLevel = level;
                if (level === 'trace' || level === 'debug') normalizedLevel = 'info';
                var args = arguments;
                args[0] = this.prefix + args[0];
                if (console) {
                    var realMethod = console[normalizedLevel] || console.log;
                    if (typeof realMethod === 'function') realMethod.apply(console, args);
                }
            }
        });
    };
    return LoggingService;
}();
var $094dca2c088c3a8e$export$2e2bcd8739ae039 = $094dca2c088c3a8e$var$LoggingService;

});



parcelRegister("aA8l1", function(module, exports) {

$parcel$export(module.exports, "registerServices", () => $7b43bbeaee4493df$export$174fd5f90dd8a5db);

var $gZqsk = parcelRequire("gZqsk");

var $5p3YC = parcelRequire("5p3YC");

var $cs9KU = parcelRequire("cs9KU");

var $lwQjO = parcelRequire("lwQjO");
function $7b43bbeaee4493df$export$174fd5f90dd8a5db() {
    (0, $lwQjO.serviceCreators)[0, $cs9KU.TRANSACTION_SERVICE] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $cs9KU.LOGGING_SERVICE),
            (0, $cs9KU.CONFIG_SERVICE)
        ]), loggingService = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1];
        return new (0, $5p3YC.default)(loggingService, configService);
    };
    (0, $lwQjO.serviceCreators)[0, $cs9KU.PERFORMANCE_MONITORING] = function(serviceFactory) {
        var _serviceFactory$getSe2 = serviceFactory.getService([
            (0, $cs9KU.APM_SERVER),
            (0, $cs9KU.CONFIG_SERVICE),
            (0, $cs9KU.LOGGING_SERVICE),
            (0, $cs9KU.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe2[0], configService = _serviceFactory$getSe2[1], loggingService = _serviceFactory$getSe2[2], transactionService = _serviceFactory$getSe2[3];
        return new (0, $gZqsk.default)(apmServer, configService, loggingService, transactionService);
    };
}

});
parcelRegister("gZqsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e6dd75fc47022d$export$2e2bcd8739ae039);

var $5LMma = parcelRequire("5LMma");

var $kgscU = parcelRequire("kgscU");

var $9KMIT = parcelRequire("9KMIT");

var $cLdmR = parcelRequire("cLdmR");

var $cs9KU = parcelRequire("cs9KU");

var $ahm0M = parcelRequire("ahm0M");

var $6cgIX = parcelRequire("6cgIX");
var $c5e6dd75fc47022d$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO = 0.05;
var $c5e6dd75fc47022d$var$TRANSACTION_DURATION_THRESHOLD = 60000;
function $c5e6dd75fc47022d$export$82a182639eda9ace(originalSpans, transDuration, threshold) {
    originalSpans.sort(function(spanA, spanB) {
        return spanA._start - spanB._start;
    });
    var spans = [];
    var lastCount = 1;
    originalSpans.forEach(function(span, index) {
        if (spans.length === 0) spans.push(span);
        else {
            var lastSpan = spans[spans.length - 1];
            var isContinuouslySimilar = lastSpan.type === span.type && lastSpan.subtype === span.subtype && lastSpan.action === span.action && lastSpan.name === span.name && span.duration() / transDuration < threshold && (span._start - lastSpan._end) / transDuration < threshold;
            var isLastSpan = originalSpans.length === index + 1;
            if (isContinuouslySimilar) {
                lastCount++;
                lastSpan._end = span._end;
            }
            if (lastCount > 1 && (!isContinuouslySimilar || isLastSpan)) {
                lastSpan.name = lastCount + 'x ' + lastSpan.name;
                lastCount = 1;
            }
            if (!isContinuouslySimilar) spans.push(span);
        }
    });
    return spans;
}
function $c5e6dd75fc47022d$export$e5fabcf37bedf526(transaction) {
    if (transaction.sampled) {
        var filterdSpans = transaction.spans.filter(function(span) {
            return span.duration() > 0 && span._start >= transaction._start && span._end <= transaction._end;
        });
        if (transaction.isManaged()) {
            var duration = transaction.duration();
            var similarSpans = $c5e6dd75fc47022d$export$82a182639eda9ace(filterdSpans, duration, $c5e6dd75fc47022d$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO);
            transaction.spans = similarSpans;
        } else transaction.spans = filterdSpans;
    } else transaction.resetFields();
    return transaction;
}
var $c5e6dd75fc47022d$export$2e2bcd8739ae039 = function() {
    function PerformanceMonitoring(apmServer, configService, loggingService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._logginService = loggingService;
        this._transactionService = transactionService;
    }
    var _proto = PerformanceMonitoring.prototype;
    _proto.init = function init(flags) {
        var _this = this;
        if (flags === void 0) flags = {};
        this._configService.events.observe((0, $cs9KU.TRANSACTION_END) + (0, $cs9KU.AFTER_EVENT), function(tr) {
            var payload = _this.createTransactionPayload(tr);
            if (payload) {
                _this._apmServer.addTransaction(payload);
                _this._configService.dispatchEvent((0, $cs9KU.QUEUE_ADD_TRANSACTION));
            }
        });
        if (flags[0, $cs9KU.HISTORY]) (0, $9KMIT.patchEventHandler).observe((0, $cs9KU.HISTORY), this.getHistorySub());
        if (flags[0, $cs9KU.XMLHTTPREQUEST]) (0, $9KMIT.patchEventHandler).observe((0, $cs9KU.XMLHTTPREQUEST), this.getXHRSub());
        if (flags[0, $cs9KU.FETCH]) (0, $9KMIT.patchEventHandler).observe((0, $cs9KU.FETCH), this.getFetchSub());
    };
    _proto.getHistorySub = function getHistorySub() {
        var transactionService = this._transactionService;
        return function(event, task) {
            if (task.source === (0, $cs9KU.HISTORY) && event === (0, $cs9KU.INVOKE)) transactionService.startTransaction(task.data.title, 'route-change', {
                managed: true,
                canReuse: true
            });
        };
    };
    _proto.getXHRSub = function getXHRSub() {
        var _this2 = this;
        return function(event, task) {
            if (task.source === (0, $cs9KU.XMLHTTPREQUEST) && !(0, $cLdmR.globalState).fetchInProgress) _this2.processAPICalls(event, task);
        };
    };
    _proto.getFetchSub = function getFetchSub() {
        var _this3 = this;
        return function(event, task) {
            if (task.source === (0, $cs9KU.FETCH)) _this3.processAPICalls(event, task);
        };
    };
    _proto.processAPICalls = function processAPICalls(event, task) {
        var configService = this._configService;
        var transactionService = this._transactionService;
        if (task.data && task.data.url) {
            var endpoints = this._apmServer.getEndpoints();
            var isOwnEndpoint = Object.keys(endpoints).some(function(endpoint) {
                return task.data.url.indexOf(endpoints[endpoint]) !== -1;
            });
            if (isOwnEndpoint) return;
        }
        if (event === (0, $cs9KU.SCHEDULE) && task.data) {
            var data = task.data;
            var requestUrl = new (0, $kgscU.Url)(data.url);
            var spanName = data.method + ' ' + (requestUrl.relative ? requestUrl.path : (0, $5LMma.stripQueryStringFromUrl)(requestUrl.href));
            if (!transactionService.getCurrentTransaction()) transactionService.startTransaction(spanName, (0, $cs9KU.HTTP_REQUEST_TYPE), {
                managed: true
            });
            var span = transactionService.startSpan(spanName, 'external.http', {
                blocking: true
            });
            if (!span) return;
            var isDtEnabled = configService.get('distributedTracing');
            var dtOrigins = configService.get('distributedTracingOrigins');
            var currentUrl = new (0, $kgscU.Url)(window.location.href);
            var isSameOrigin = (0, $5LMma.checkSameOrigin)(requestUrl.origin, currentUrl.origin) || (0, $5LMma.checkSameOrigin)(requestUrl.origin, dtOrigins);
            var target = data.target;
            if (isDtEnabled && isSameOrigin && target) {
                this.injectDtHeader(span, target);
                var propagateTracestate = configService.get('propagateTracestate');
                if (propagateTracestate) this.injectTSHeader(span, target);
            } else if (0, $6cgIX.__DEV__) this._logginService.debug("Could not inject distributed tracing header to the request origin ('" + requestUrl.origin + "') from the current origin ('" + currentUrl.origin + "')");
            if (data.sync) span.sync = data.sync;
            data.span = span;
        } else if (event === (0, $cs9KU.INVOKE)) {
            var _data = task.data;
            if (_data && _data.span) {
                var _span = _data.span, response = _data.response, _target = _data.target;
                var status;
                if (response) status = response.status;
                else status = _target.status;
                var outcome;
                if (_data.status != 'abort' && !_data.aborted) {
                    if (status >= 400 || status == 0) outcome = (0, $cs9KU.OUTCOME_FAILURE);
                    else outcome = (0, $cs9KU.OUTCOME_SUCCESS);
                } else outcome = (0, $cs9KU.OUTCOME_UNKNOWN);
                _span.outcome = outcome;
                var tr = transactionService.getCurrentTransaction();
                if (tr && tr.type === (0, $cs9KU.HTTP_REQUEST_TYPE)) tr.outcome = outcome;
                transactionService.endSpan(_span, _data);
            }
        }
    };
    _proto.injectDtHeader = function injectDtHeader(span, target) {
        var headerName = this._configService.get('distributedTracingHeaderName');
        var headerValue = (0, $5LMma.getDtHeaderValue)(span);
        var isHeaderValid = (0, $5LMma.isDtHeaderValid)(headerValue);
        if (isHeaderValid && headerValue && headerName) (0, $5LMma.setRequestHeader)(target, headerName, headerValue);
    };
    _proto.injectTSHeader = function injectTSHeader(span, target) {
        var headerValue = (0, $5LMma.getTSHeaderValue)(span);
        if (headerValue) (0, $5LMma.setRequestHeader)(target, 'tracestate', headerValue);
    };
    _proto.extractDtHeader = function extractDtHeader(target) {
        var configService = this._configService;
        var headerName = configService.get('distributedTracingHeaderName');
        if (target) return (0, $5LMma.parseDtHeaderValue)(target[headerName]);
    };
    _proto.filterTransaction = function filterTransaction(tr) {
        var duration = tr.duration();
        if (!duration) {
            if (0, $6cgIX.__DEV__) {
                var message = "transaction(" + tr.id + ", " + tr.name + ") was discarded! ";
                if (duration === 0) message += "Transaction duration is 0";
                else message += "Transaction wasn't ended";
                this._logginService.debug(message);
            }
            return false;
        }
        if (tr.isManaged()) {
            if (duration > $c5e6dd75fc47022d$var$TRANSACTION_DURATION_THRESHOLD) {
                if (0, $6cgIX.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction duration (" + duration + ") is greater than managed transaction threshold (" + $c5e6dd75fc47022d$var$TRANSACTION_DURATION_THRESHOLD + ")");
                return false;
            }
            if (tr.sampled && tr.spans.length === 0) {
                if (0, $6cgIX.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction does not have any spans");
                return false;
            }
        }
        return true;
    };
    _proto.createTransactionDataModel = function createTransactionDataModel(transaction) {
        var transactionStart = transaction._start;
        var spans = transaction.spans.map(function(span) {
            var spanData = {
                id: span.id,
                transaction_id: transaction.id,
                parent_id: span.parentId || transaction.id,
                trace_id: transaction.traceId,
                name: span.name,
                type: span.type,
                subtype: span.subtype,
                action: span.action,
                sync: span.sync,
                start: parseInt(span._start - transactionStart),
                duration: span.duration(),
                context: span.context,
                outcome: span.outcome,
                sample_rate: span.sampleRate
            };
            return (0, $ahm0M.truncateModel)((0, $ahm0M.SPAN_MODEL), spanData);
        });
        var transactionData = {
            id: transaction.id,
            trace_id: transaction.traceId,
            session: transaction.session,
            name: transaction.name,
            type: transaction.type,
            duration: transaction.duration(),
            spans: spans,
            context: transaction.context,
            marks: transaction.marks,
            breakdown: transaction.breakdownTimings,
            span_count: {
                started: spans.length
            },
            sampled: transaction.sampled,
            sample_rate: transaction.sampleRate,
            experience: transaction.experience,
            outcome: transaction.outcome
        };
        return (0, $ahm0M.truncateModel)((0, $ahm0M.TRANSACTION_MODEL), transactionData);
    };
    _proto.createTransactionPayload = function createTransactionPayload(transaction) {
        var adjustedTransaction = $c5e6dd75fc47022d$export$e5fabcf37bedf526(transaction);
        var filtered = this.filterTransaction(adjustedTransaction);
        if (filtered) return this.createTransactionDataModel(transaction);
    };
    return PerformanceMonitoring;
}();

});

parcelRegister("5p3YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef25f3db5edc06f$export$2e2bcd8739ae039);

var $alnvF = parcelRequire("alnvF");

var $fvK05 = parcelRequire("fvK05");

var $keN4D = parcelRequire("keN4D");

var $5LMma = parcelRequire("5LMma");

var $7J1OQ = parcelRequire("7J1OQ");

var $cs9KU = parcelRequire("cs9KU");

var $aUu0v = parcelRequire("aUu0v");

var $6cgIX = parcelRequire("6cgIX");

var $kgscU = parcelRequire("kgscU");
var $3ef25f3db5edc06f$var$TransactionService = function() {
    function TransactionService(logger, config) {
        var _this = this;
        this._config = config;
        this._logger = logger;
        this.currentTransaction = undefined;
        this.respIntervalId = undefined;
        this.recorder = new (0, $keN4D.PerfEntryRecorder)(function(list) {
            var tr = _this.getCurrentTransaction();
            if (tr && tr.captureTimings) {
                var _tr$spans;
                var isHardNavigation = tr.type === (0, $cs9KU.PAGE_LOAD);
                var _captureObserverEntri = (0, $keN4D.captureObserverEntries)(list, {
                    isHardNavigation: isHardNavigation,
                    trStart: isHardNavigation ? 0 : tr._start
                }), spans = _captureObserverEntri.spans, marks = _captureObserverEntri.marks;
                (_tr$spans = tr.spans).push.apply(_tr$spans, spans);
                tr.addMarks({
                    agent: marks
                });
            }
        });
    }
    var _proto = TransactionService.prototype;
    _proto.createCurrentTransaction = function createCurrentTransaction(name, type, options) {
        var tr = new (0, $fvK05.default)(name, type, options);
        this.currentTransaction = tr;
        return tr;
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.currentTransaction && !this.currentTransaction.ended) return this.currentTransaction;
    };
    _proto.createOptions = function createOptions(options) {
        var config = this._config.config;
        var presetOptions = {
            transactionSampleRate: config.transactionSampleRate
        };
        var perfOptions = (0, $5LMma.extend)(presetOptions, options);
        if (perfOptions.managed) perfOptions = (0, $5LMma.extend)({
            pageLoadTraceId: config.pageLoadTraceId,
            pageLoadSampled: config.pageLoadSampled,
            pageLoadSpanId: config.pageLoadSpanId,
            pageLoadTransactionName: config.pageLoadTransactionName
        }, perfOptions);
        return perfOptions;
    };
    _proto.startManagedTransaction = function startManagedTransaction(name, type, perfOptions) {
        var tr = this.getCurrentTransaction();
        var isRedefined = false;
        if (!tr) tr = this.createCurrentTransaction(name, type, perfOptions);
        else if (tr.canReuse() && perfOptions.canReuse) {
            var redefineType = tr.type;
            var currentTypeOrder = (0, $cs9KU.TRANSACTION_TYPE_ORDER).indexOf(tr.type);
            var redefineTypeOrder = (0, $cs9KU.TRANSACTION_TYPE_ORDER).indexOf(type);
            if (currentTypeOrder >= 0 && redefineTypeOrder < currentTypeOrder) redefineType = type;
            if (0, $6cgIX.__DEV__) this._logger.debug("redefining transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", 'to', "(" + (name || tr.name) + ", " + redefineType + ")", tr);
            tr.redefine(name, redefineType, perfOptions);
            isRedefined = true;
        } else {
            if (0, $6cgIX.__DEV__) this._logger.debug("ending previous transaction(" + tr.id + ", " + tr.name + ")", tr);
            tr.end();
            tr = this.createCurrentTransaction(name, type, perfOptions);
        }
        if (tr.type === (0, $cs9KU.PAGE_LOAD)) {
            if (!isRedefined) {
                this.recorder.start((0, $cs9KU.LARGEST_CONTENTFUL_PAINT));
                this.recorder.start((0, $cs9KU.PAINT));
                this.recorder.start((0, $cs9KU.FIRST_INPUT));
                this.recorder.start((0, $cs9KU.LAYOUT_SHIFT));
            }
            if (perfOptions.pageLoadTraceId) tr.traceId = perfOptions.pageLoadTraceId;
            if (perfOptions.pageLoadSampled) tr.sampled = perfOptions.pageLoadSampled;
            if (tr.name === (0, $cs9KU.NAME_UNKNOWN) && perfOptions.pageLoadTransactionName) tr.name = perfOptions.pageLoadTransactionName;
        }
        if (!isRedefined && this._config.get('monitorLongtasks')) this.recorder.start((0, $cs9KU.LONG_TASK));
        if (tr.sampled) tr.captureTimings = true;
        return tr;
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        var _this2 = this;
        var perfOptions = this.createOptions(options);
        var tr;
        var fireOnstartHook = true;
        if (perfOptions.managed) {
            var current = this.currentTransaction;
            tr = this.startManagedTransaction(name, type, perfOptions);
            if (current === tr) fireOnstartHook = false;
        } else tr = new (0, $fvK05.default)(name, type, perfOptions);
        tr.onEnd = function() {
            return _this2.handleTransactionEnd(tr);
        };
        if (fireOnstartHook) {
            if (0, $6cgIX.__DEV__) this._logger.debug("startTransaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")");
            this._config.events.send((0, $cs9KU.TRANSACTION_START), [
                tr
            ]);
        }
        return tr;
    };
    _proto.handleTransactionEnd = function handleTransactionEnd(tr) {
        var _this3 = this;
        this.recorder.stop();
        var currentUrl = window.location.href;
        return (0, $alnvF.Promise).resolve().then(function() {
            var name = tr.name, type = tr.type;
            var lastHiddenStart = (0, $6cgIX.state).lastHiddenStart;
            if (lastHiddenStart >= tr._start) {
                if (0, $6cgIX.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") was discarded! The page was hidden during the transaction!");
                return;
            }
            if (_this3.shouldIgnoreTransaction(name) || type === (0, $cs9KU.TEMPORARY_TYPE)) {
                if (0, $6cgIX.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") is ignored");
                return;
            }
            if (type === (0, $cs9KU.PAGE_LOAD)) {
                var pageLoadTransactionName = _this3._config.get('pageLoadTransactionName');
                if (name === (0, $cs9KU.NAME_UNKNOWN) && pageLoadTransactionName) tr.name = pageLoadTransactionName;
                if (tr.captureTimings) {
                    var cls = (0, $keN4D.metrics).cls, fid = (0, $keN4D.metrics).fid, tbt = (0, $keN4D.metrics).tbt, longtask = (0, $keN4D.metrics).longtask;
                    if (tbt.duration > 0) tr.spans.push((0, $keN4D.createTotalBlockingTimeSpan)(tbt));
                    tr.experience = {};
                    if ((0, $5LMma.isPerfTypeSupported)((0, $cs9KU.LONG_TASK))) tr.experience.tbt = tbt.duration;
                    if ((0, $5LMma.isPerfTypeSupported)((0, $cs9KU.LAYOUT_SHIFT))) tr.experience.cls = cls.score;
                    if (fid > 0) tr.experience.fid = fid;
                    if (longtask.count > 0) tr.experience.longtask = {
                        count: longtask.count,
                        sum: longtask.duration,
                        max: longtask.max
                    };
                }
                _this3.setSession(tr);
            }
            if (tr.name === (0, $cs9KU.NAME_UNKNOWN)) tr.name = (0, $kgscU.slugifyUrl)(currentUrl);
            (0, $7J1OQ.captureNavigation)(tr);
            _this3.adjustTransactionTime(tr);
            var breakdownMetrics = _this3._config.get('breakdownMetrics');
            if (breakdownMetrics) tr.captureBreakdown();
            var configContext = _this3._config.get('context');
            (0, $aUu0v.addTransactionContext)(tr, configContext);
            _this3._config.events.send((0, $cs9KU.TRANSACTION_END), [
                tr
            ]);
            if (0, $6cgIX.__DEV__) _this3._logger.debug("end transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", tr);
        }, function(err) {
            if (0, $6cgIX.__DEV__) _this3._logger.debug("error ending transaction(" + tr.id + ", " + tr.name + ")", err);
        });
    };
    _proto.setSession = function setSession(tr) {
        var session = this._config.get('session');
        if (session) {
            if (typeof session == 'boolean') tr.session = {
                id: (0, $5LMma.generateRandomId)(16),
                sequence: 1
            };
            else if (session.timestamp && Date.now() - session.timestamp > (0, $cs9KU.SESSION_TIMEOUT)) tr.session = {
                id: (0, $5LMma.generateRandomId)(16),
                sequence: 1
            };
            else tr.session = {
                id: session.id,
                sequence: session.sequence ? session.sequence + 1 : 1
            };
            var sessionConfig = {
                session: {
                    id: tr.session.id,
                    sequence: tr.session.sequence,
                    timestamp: Date.now()
                }
            };
            this._config.setConfig(sessionConfig);
            this._config.setLocalConfig(sessionConfig, true);
        }
    };
    _proto.adjustTransactionTime = function adjustTransactionTime(transaction) {
        var spans = transaction.spans;
        var earliestSpan = (0, $5LMma.getEarliestSpan)(spans);
        if (earliestSpan && earliestSpan._start < transaction._start) transaction._start = earliestSpan._start;
        var latestSpan = (0, $5LMma.getLatestNonXHRSpan)(spans) || {};
        var latestSpanEnd = latestSpan._end || 0;
        if (transaction.type === (0, $cs9KU.PAGE_LOAD)) {
            var transactionEndWithoutDelay = transaction._end - (0, $cs9KU.PAGE_LOAD_DELAY);
            var lcp = (0, $keN4D.metrics).lcp || 0;
            var latestXHRSpan = (0, $5LMma.getLatestXHRSpan)(spans) || {};
            var latestXHRSpanEnd = latestXHRSpan._end || 0;
            transaction._end = Math.max(latestSpanEnd, latestXHRSpanEnd, lcp, transactionEndWithoutDelay);
        } else if (latestSpanEnd > transaction._end) transaction._end = latestSpanEnd;
        this.truncateSpans(spans, transaction._end);
    };
    _proto.truncateSpans = function truncateSpans(spans, transactionEnd) {
        for(var i = 0; i < spans.length; i++){
            var span = spans[i];
            if (span._end > transactionEnd) {
                span._end = transactionEnd;
                span.type += (0, $cs9KU.TRUNCATED_TYPE);
            }
            if (span._start > transactionEnd) span._start = transactionEnd;
        }
    };
    _proto.shouldIgnoreTransaction = function shouldIgnoreTransaction(transactionName) {
        var ignoreList = this._config.get('ignoreTransactions');
        if (ignoreList && ignoreList.length) for(var i = 0; i < ignoreList.length; i++){
            var element = ignoreList[i];
            if (typeof element.test === 'function') {
                if (element.test(transactionName)) return true;
            } else if (element === transactionName) return true;
        }
        return false;
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var tr = this.getCurrentTransaction();
        if (!tr) tr = this.createCurrentTransaction(undefined, (0, $cs9KU.TEMPORARY_TYPE), this.createOptions({
            canReuse: true,
            managed: true
        }));
        var span = tr.startSpan(name, type, options);
        if (0, $6cgIX.__DEV__) this._logger.debug("startSpan(" + name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        return span;
    };
    _proto.endSpan = function endSpan(span, context) {
        if (!span) return;
        if (0, $6cgIX.__DEV__) {
            var tr = this.getCurrentTransaction();
            tr && this._logger.debug("endSpan(" + span.name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        }
        span.end(null, context);
    };
    return TransactionService;
}();
var $3ef25f3db5edc06f$export$2e2bcd8739ae039 = $3ef25f3db5edc06f$var$TransactionService;

});
parcelRegister("fvK05", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ad6efbf1cb6266$export$2e2bcd8739ae039);

var $lPS7D = parcelRequire("lPS7D");

var $2m8fl = parcelRequire("2m8fl");

var $5LMma = parcelRequire("5LMma");

var $cs9KU = parcelRequire("cs9KU");

var $lI3Io = parcelRequire("lI3Io");
function $b4ad6efbf1cb6266$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b4ad6efbf1cb6266$var$_setPrototypeOf(subClass, superClass);
}
function $b4ad6efbf1cb6266$var$_setPrototypeOf(o, p) {
    $b4ad6efbf1cb6266$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b4ad6efbf1cb6266$var$_setPrototypeOf(o, p);
}
var $b4ad6efbf1cb6266$var$Transaction = function(_SpanBase) {
    $b4ad6efbf1cb6266$var$_inheritsLoose(Transaction, _SpanBase);
    function Transaction(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.traceId = (0, $5LMma.generateRandomId)();
        _this.marks = undefined;
        _this.spans = [];
        _this._activeSpans = {};
        _this._activeTasks = new Set();
        _this.blocked = false;
        _this.captureTimings = false;
        _this.breakdownTimings = [];
        _this.sampleRate = _this.options.transactionSampleRate;
        _this.sampled = Math.random() <= _this.sampleRate;
        return _this;
    }
    var _proto = Transaction.prototype;
    _proto.addMarks = function addMarks(obj) {
        this.marks = (0, $5LMma.merge)(this.marks || {}, obj);
    };
    _proto.mark = function mark(key) {
        var skey = (0, $5LMma.removeInvalidChars)(key);
        var markTime = (0, $5LMma.now)() - this._start;
        var custom = {};
        custom[skey] = markTime;
        this.addMarks({
            custom: custom
        });
    };
    _proto.canReuse = function canReuse() {
        var threshold = this.options.reuseThreshold || (0, $cs9KU.REUSABILITY_THRESHOLD);
        return !!this.options.canReuse && !this.ended && (0, $5LMma.now)() - this._start < threshold;
    };
    _proto.redefine = function redefine(name, type, options) {
        if (name) this.name = name;
        if (type) this.type = type;
        if (options) {
            this.options.reuseThreshold = options.reuseThreshold;
            (0, $5LMma.extend)(this.options, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var _this2 = this;
        if (this.ended) return;
        var opts = (0, $5LMma.extend)({}, options);
        opts.onEnd = function(trc) {
            _this2._onSpanEnd(trc);
        };
        opts.traceId = this.traceId;
        opts.sampled = this.sampled;
        opts.sampleRate = this.sampleRate;
        if (!opts.parentId) opts.parentId = this.id;
        var span = new (0, $lPS7D.default)(name, type, opts);
        this._activeSpans[span.id] = span;
        if (opts.blocking) this.addTask(span.id);
        return span;
    };
    _proto.isFinished = function isFinished() {
        return !this.blocked && this._activeTasks.size === 0;
    };
    _proto.detectFinish = function detectFinish() {
        if (this.isFinished()) this.end();
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $5LMma.getTime)(endTime);
        for(var sid in this._activeSpans){
            var span = this._activeSpans[sid];
            span.type = span.type + (0, $cs9KU.TRUNCATED_TYPE);
            span.end(endTime);
        }
        this.callOnEnd();
    };
    _proto.captureBreakdown = function captureBreakdown() {
        this.breakdownTimings = (0, $lI3Io.captureBreakdown)(this);
    };
    _proto.block = function block(flag) {
        this.blocked = flag;
        if (!this.blocked) this.detectFinish();
    };
    _proto.addTask = function addTask(taskId) {
        if (!taskId) taskId = 'task-' + (0, $5LMma.generateRandomId)(16);
        this._activeTasks.add(taskId);
        return taskId;
    };
    _proto.removeTask = function removeTask(taskId) {
        var deleted = this._activeTasks.delete(taskId);
        deleted && this.detectFinish();
    };
    _proto.resetFields = function resetFields() {
        this.spans = [];
        this.sampleRate = 0;
    };
    _proto._onSpanEnd = function _onSpanEnd(span) {
        this.spans.push(span);
        delete this._activeSpans[span.id];
        this.removeTask(span.id);
    };
    _proto.isManaged = function isManaged() {
        return !!this.options.managed;
    };
    return Transaction;
}((0, $2m8fl.default));
var $b4ad6efbf1cb6266$export$2e2bcd8739ae039 = $b4ad6efbf1cb6266$var$Transaction;

});
parcelRegister("lI3Io", function(module, exports) {

$parcel$export(module.exports, "captureBreakdown", () => $fce096c3f0df0960$export$f29e26af65381f57);

var $5LMma = parcelRequire("5LMma");

var $cs9KU = parcelRequire("cs9KU");
var $fce096c3f0df0960$var$pageLoadBreakdowns = [
    [
        'domainLookupStart',
        'domainLookupEnd',
        'DNS'
    ],
    [
        'connectStart',
        'connectEnd',
        'TCP'
    ],
    [
        'requestStart',
        'responseStart',
        'Request'
    ],
    [
        'responseStart',
        'responseEnd',
        'Response'
    ],
    [
        'domLoading',
        'domComplete',
        'Processing'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Load'
    ]
];
function $fce096c3f0df0960$var$getValue(value) {
    return {
        value: value
    };
}
function $fce096c3f0df0960$var$calculateSelfTime(transaction) {
    var spans = transaction.spans, _start = transaction._start, _end = transaction._end;
    if (spans.length === 0) return transaction.duration();
    spans.sort(function(span1, span2) {
        return span1._start - span2._start;
    });
    var span = spans[0];
    var spanEnd = span._end;
    var spanStart = span._start;
    var lastContinuousEnd = spanEnd;
    var selfTime = spanStart - _start;
    for(var i = 1; i < spans.length; i++){
        span = spans[i];
        spanStart = span._start;
        spanEnd = span._end;
        if (spanStart > lastContinuousEnd) {
            selfTime += spanStart - lastContinuousEnd;
            lastContinuousEnd = spanEnd;
        } else if (spanEnd > lastContinuousEnd) lastContinuousEnd = spanEnd;
    }
    if (lastContinuousEnd < _end) selfTime += _end - lastContinuousEnd;
    return selfTime;
}
function $fce096c3f0df0960$var$groupSpans(transaction) {
    var spanMap = {};
    var transactionSelfTime = $fce096c3f0df0960$var$calculateSelfTime(transaction);
    spanMap['app'] = {
        count: 1,
        duration: transactionSelfTime
    };
    var spans = transaction.spans;
    for(var i = 0; i < spans.length; i++){
        var span = spans[i];
        var duration = span.duration();
        if (duration === 0 || duration == null) continue;
        var type = span.type, subtype = span.subtype;
        var key = type.replace((0, $cs9KU.TRUNCATED_TYPE), '');
        if (subtype) key += '.' + subtype;
        if (!spanMap[key]) spanMap[key] = {
            duration: 0,
            count: 0
        };
        spanMap[key].count++;
        spanMap[key].duration += duration;
    }
    return spanMap;
}
function $fce096c3f0df0960$var$getSpanBreakdown(transactionDetails, _ref) {
    var details = _ref.details, _ref$count = _ref.count, count = _ref$count === void 0 ? 1 : _ref$count, duration = _ref.duration;
    return {
        transaction: transactionDetails,
        span: details,
        samples: {
            'span.self_time.count': $fce096c3f0df0960$var$getValue(count),
            'span.self_time.sum.us': $fce096c3f0df0960$var$getValue(duration)
        }
    };
}
function $fce096c3f0df0960$export$f29e26af65381f57(transaction, timings) {
    if (timings === void 0) timings = (0, $5LMma.PERF).timing;
    var breakdowns = [];
    var trDuration = transaction.duration();
    var name = transaction.name, type = transaction.type, sampled = transaction.sampled;
    var transactionDetails = {
        name: name,
        type: type
    };
    breakdowns.push({
        transaction: transactionDetails,
        samples: {
            'transaction.duration.count': $fce096c3f0df0960$var$getValue(1),
            'transaction.duration.sum.us': $fce096c3f0df0960$var$getValue(trDuration),
            'transaction.breakdown.count': $fce096c3f0df0960$var$getValue(sampled ? 1 : 0)
        }
    });
    if (!sampled) return breakdowns;
    if (type === (0, $cs9KU.PAGE_LOAD) && timings) for(var i = 0; i < $fce096c3f0df0960$var$pageLoadBreakdowns.length; i++){
        var current = $fce096c3f0df0960$var$pageLoadBreakdowns[i];
        var start = timings[current[0]];
        var end = timings[current[1]];
        var duration = (0, $5LMma.getDuration)(start, end);
        if (duration === 0 || duration == null) continue;
        breakdowns.push($fce096c3f0df0960$var$getSpanBreakdown(transactionDetails, {
            details: {
                type: current[2]
            },
            duration: duration
        }));
    }
    else {
        var spanMap = $fce096c3f0df0960$var$groupSpans(transaction);
        Object.keys(spanMap).forEach(function(key) {
            var _key$split = key.split('.'), type = _key$split[0], subtype = _key$split[1];
            var _spanMap$key = spanMap[key], duration = _spanMap$key.duration, count = _spanMap$key.count;
            breakdowns.push($fce096c3f0df0960$var$getSpanBreakdown(transactionDetails, {
                details: {
                    type: type,
                    subtype: subtype
                },
                duration: duration,
                count: count
            }));
        });
    }
    return breakdowns;
}

});


parcelRegister("keN4D", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "createTotalBlockingTimeSpan", () => $ebbb2e7aefdc9d7b$export$4f167c0032dd3716);
$parcel$export(module.exports, "captureObserverEntries", () => $ebbb2e7aefdc9d7b$export$9042c3a3f5ee2ee);
$parcel$export(module.exports, "PerfEntryRecorder", () => $ebbb2e7aefdc9d7b$export$e105e1823c980668);

var $cs9KU = parcelRequire("cs9KU");

var $5LMma = parcelRequire("5LMma");

var $lPS7D = parcelRequire("lPS7D");
var $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54 = {
    fid: 0,
    fcp: 0,
    tbt: {
        start: Infinity,
        duration: 0
    },
    cls: {
        score: 0,
        firstEntryTime: Number.NEGATIVE_INFINITY,
        prevEntryTime: Number.NEGATIVE_INFINITY,
        currentSessionScore: 0
    },
    longtask: {
        count: 0,
        duration: 0,
        max: 0
    }
};
var $ebbb2e7aefdc9d7b$var$LONG_TASK_THRESHOLD = 50;
function $ebbb2e7aefdc9d7b$export$2bed7abe701121db(longtasks, agg) {
    var spans = [];
    for(var i = 0; i < longtasks.length; i++){
        var _longtasks$i = longtasks[i], name = _longtasks$i.name, startTime = _longtasks$i.startTime, duration = _longtasks$i.duration, attribution = _longtasks$i.attribution;
        var end = startTime + duration;
        var span = new (0, $lPS7D.default)("Longtask(" + name + ")", (0, $cs9KU.LONG_TASK), {
            startTime: startTime
        });
        agg.count++;
        agg.duration += duration;
        agg.max = Math.max(duration, agg.max);
        if (attribution.length > 0) {
            var _attribution$ = attribution[0], _name = _attribution$.name, containerType = _attribution$.containerType, containerName = _attribution$.containerName, containerId = _attribution$.containerId;
            var customContext = {
                attribution: _name,
                type: containerType
            };
            if (containerName) customContext.name = containerName;
            if (containerId) customContext.id = containerId;
            span.addContext({
                custom: customContext
            });
        }
        span.end(end);
        spans.push(span);
    }
    return spans;
}
function $ebbb2e7aefdc9d7b$export$dbb9abd64c7ad2de(fidEntries) {
    var firstInput = fidEntries[0];
    if (firstInput) {
        var startTime = firstInput.startTime, processingStart = firstInput.processingStart;
        var span = new (0, $lPS7D.default)('First Input Delay', (0, $cs9KU.FIRST_INPUT), {
            startTime: startTime
        });
        span.end(processingStart);
        return span;
    }
}
function $ebbb2e7aefdc9d7b$export$4f167c0032dd3716(tbtObject) {
    var start = tbtObject.start, duration = tbtObject.duration;
    var tbtSpan = new (0, $lPS7D.default)('Total Blocking Time', (0, $cs9KU.LONG_TASK), {
        startTime: start
    });
    tbtSpan.end(start + duration);
    return tbtSpan;
}
function $ebbb2e7aefdc9d7b$export$cdc3b71aeb75f979(longtaskEntries) {
    longtaskEntries.forEach(function(entry) {
        var name = entry.name, startTime = entry.startTime, duration = entry.duration;
        if (startTime < $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.fcp) return;
        if (name !== 'self' && name.indexOf('same-origin') === -1) return;
        $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.tbt.start = Math.min($ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.tbt.start, startTime);
        var blockingTime = duration - $ebbb2e7aefdc9d7b$var$LONG_TASK_THRESHOLD;
        if (blockingTime > 0) $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.tbt.duration += blockingTime;
    });
}
function $ebbb2e7aefdc9d7b$export$1ee9edc2f05fc2c0(clsEntries) {
    clsEntries.forEach(function(entry) {
        if (!entry.hadRecentInput && entry.value) {
            var shouldCreateNewSession = entry.startTime - $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.firstEntryTime > 5000 || entry.startTime - $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.prevEntryTime > 1000;
            if (shouldCreateNewSession) {
                $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.firstEntryTime = entry.startTime;
                $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.currentSessionScore = 0;
            }
            $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.prevEntryTime = entry.startTime;
            $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.currentSessionScore += entry.value;
            $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.score = Math.max($ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.score, $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.cls.currentSessionScore);
        }
    });
}
function $ebbb2e7aefdc9d7b$export$9042c3a3f5ee2ee(list, _ref) {
    var isHardNavigation = _ref.isHardNavigation, trStart = _ref.trStart;
    var longtaskEntries = list.getEntriesByType((0, $cs9KU.LONG_TASK)).filter(function(entry) {
        return entry.startTime >= trStart;
    });
    var longTaskSpans = $ebbb2e7aefdc9d7b$export$2bed7abe701121db(longtaskEntries, $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.longtask);
    var result = {
        spans: longTaskSpans,
        marks: {}
    };
    if (!isHardNavigation) return result;
    var lcpEntries = list.getEntriesByType((0, $cs9KU.LARGEST_CONTENTFUL_PAINT));
    var lastLcpEntry = lcpEntries[lcpEntries.length - 1];
    if (lastLcpEntry) {
        var lcp = parseInt(lastLcpEntry.startTime);
        $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.lcp = lcp;
        result.marks.largestContentfulPaint = lcp;
    }
    var timing = (0, $5LMma.PERF).timing;
    var unloadDiff = timing.fetchStart - timing.navigationStart;
    var fcpEntry = list.getEntriesByName((0, $cs9KU.FIRST_CONTENTFUL_PAINT))[0];
    if (fcpEntry) {
        var fcp = parseInt(unloadDiff >= 0 ? fcpEntry.startTime - unloadDiff : fcpEntry.startTime);
        $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.fcp = fcp;
        result.marks.firstContentfulPaint = fcp;
    }
    var fidEntries = list.getEntriesByType((0, $cs9KU.FIRST_INPUT));
    var fidSpan = $ebbb2e7aefdc9d7b$export$dbb9abd64c7ad2de(fidEntries);
    if (fidSpan) {
        $ebbb2e7aefdc9d7b$export$b0c5c2fac8144e54.fid = fidSpan.duration();
        result.spans.push(fidSpan);
    }
    $ebbb2e7aefdc9d7b$export$cdc3b71aeb75f979(longtaskEntries);
    var clsEntries = list.getEntriesByType((0, $cs9KU.LAYOUT_SHIFT));
    $ebbb2e7aefdc9d7b$export$1ee9edc2f05fc2c0(clsEntries);
    return result;
}
var $ebbb2e7aefdc9d7b$export$e105e1823c980668 = function() {
    function PerfEntryRecorder(callback) {
        this.po = {
            observe: (0, $5LMma.noop),
            disconnect: (0, $5LMma.noop)
        };
        if (window.PerformanceObserver) this.po = new PerformanceObserver(callback);
    }
    var _proto = PerfEntryRecorder.prototype;
    _proto.start = function start(type) {
        try {
            this.po.observe({
                type: type,
                buffered: true
            });
        } catch (_) {}
    };
    _proto.stop = function stop() {
        this.po.disconnect();
    };
    return PerfEntryRecorder;
}();

});



parcelRegister("cyYT5", function(module, exports) {

$parcel$export(module.exports, "observePageClicks", () => $9257e3f9b0dc4069$export$1f926008e0357783);

var $cs9KU = parcelRequire("cs9KU");
function $9257e3f9b0dc4069$export$1f926008e0357783(transactionService) {
    var clickHandler = function clickHandler(event) {
        if (event.target instanceof Element) $9257e3f9b0dc4069$var$createUserInteractionTransaction(transactionService, event.target);
    };
    var eventName = 'click';
    var useCapture = true;
    window.addEventListener(eventName, clickHandler, useCapture);
    return function() {
        window.removeEventListener(eventName, clickHandler, useCapture);
    };
}
function $9257e3f9b0dc4069$var$createUserInteractionTransaction(transactionService, target) {
    var _getTransactionMetada = $9257e3f9b0dc4069$var$getTransactionMetadata(target), transactionName = _getTransactionMetada.transactionName, context = _getTransactionMetada.context;
    var tr = transactionService.startTransaction("Click - " + transactionName, (0, $cs9KU.USER_INTERACTION), {
        managed: true,
        canReuse: true,
        reuseThreshold: 300
    });
    if (tr && context) tr.addContext(context);
}
function $9257e3f9b0dc4069$var$getTransactionMetadata(target) {
    var metadata = {
        transactionName: null,
        context: null
    };
    var tagName = target.tagName.toLowerCase();
    var transactionName = tagName;
    if (!!target.dataset.transactionName) transactionName = target.dataset.transactionName;
    else {
        var name = target.getAttribute('name');
        if (!!name) transactionName = tagName + "[\"" + name + "\"]";
    }
    metadata.transactionName = transactionName;
    var classes = target.getAttribute('class');
    if (classes) metadata.context = {
        custom: {
            classes: classes
        }
    };
    return metadata;
}

});

parcelRegister("2Hl1n", function(module, exports) {

$parcel$export(module.exports, "observePageVisibility", () => $1f6fe74f2096874b$export$469e44f8217c68b6);

var $cs9KU = parcelRequire("cs9KU");

var $6cgIX = parcelRequire("6cgIX");

var $5LMma = parcelRequire("5LMma");
function $1f6fe74f2096874b$export$469e44f8217c68b6(configService, transactionService) {
    if (document.visibilityState === 'hidden') (0, $6cgIX.state).lastHiddenStart = 0;
    var visibilityChangeHandler = function visibilityChangeHandler() {
        if (document.visibilityState === 'hidden') $1f6fe74f2096874b$var$onPageHidden(configService, transactionService);
    };
    var pageHideHandler = function pageHideHandler() {
        return $1f6fe74f2096874b$var$onPageHidden(configService, transactionService);
    };
    var useCapture = true;
    window.addEventListener('visibilitychange', visibilityChangeHandler, useCapture);
    window.addEventListener('pagehide', pageHideHandler, useCapture);
    return function() {
        window.removeEventListener('visibilitychange', visibilityChangeHandler, useCapture);
        window.removeEventListener('pagehide', pageHideHandler, useCapture);
    };
}
function $1f6fe74f2096874b$var$onPageHidden(configService, transactionService) {
    var tr = transactionService.getCurrentTransaction();
    if (tr) {
        var unobserve = configService.observeEvent((0, $cs9KU.QUEUE_ADD_TRANSACTION), function() {
            configService.dispatchEvent((0, $cs9KU.QUEUE_FLUSH));
            (0, $6cgIX.state).lastHiddenStart = (0, $5LMma.now)();
            unobserve();
        });
        tr.end();
    } else {
        configService.dispatchEvent((0, $cs9KU.QUEUE_FLUSH));
        (0, $6cgIX.state).lastHiddenStart = (0, $5LMma.now)();
    }
}

});

parcelRegister("kLexY", function(module, exports) {

$parcel$export(module.exports, "getInstrumentationFlags", () => $f1d37b24f6de347d$export$7852da8de47c1ce0);

var $cs9KU = parcelRequire("cs9KU");
function $f1d37b24f6de347d$export$7852da8de47c1ce0(instrument, disabledInstrumentations) {
    var _flags;
    var flags = (_flags = {}, _flags[0, $cs9KU.XMLHTTPREQUEST] = false, _flags[0, $cs9KU.FETCH] = false, _flags[0, $cs9KU.HISTORY] = false, _flags[0, $cs9KU.PAGE_LOAD] = false, _flags[0, $cs9KU.ERROR] = false, _flags[0, $cs9KU.EVENT_TARGET] = false, _flags[0, $cs9KU.CLICK] = false, _flags);
    if (!instrument) return flags;
    Object.keys(flags).forEach(function(key) {
        if (disabledInstrumentations.indexOf(key) === -1) flags[key] = true;
    });
    return flags;
}

});


parcelRegister("eqUZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a81fb25abcc15ec1$export$2e2bcd8739ae039);

var $cs9KU = parcelRequire("cs9KU");
var $kLexY = parcelRequire("kLexY");
var $cyYT5 = parcelRequire("cyYT5");
var $2Hl1n = parcelRequire("2Hl1n");
var $a81fb25abcc15ec1$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        return this.isEnabled() && this._initialized && configService.get('active');
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $cs9KU.CONFIG_SERVICE),
                (0, $cs9KU.LOGGING_SERVICE),
                (0, $cs9KU.TRANSACTION_SERVICE)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion('5.12.0');
            this.config(config);
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get('active');
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $kLexY.getInstrumentationFlags)(configService.get('instrument'), configService.get('disableInstrumentations'));
                var performanceMonitoring = this.serviceFactory.getService((0, $cs9KU.PERFORMANCE_MONITORING));
                performanceMonitoring.init(flags);
                if (flags[0, $cs9KU.ERROR]) {
                    var errorLogging = this.serviceFactory.getService((0, $cs9KU.ERROR_LOGGING));
                    errorLogging.registerListeners();
                }
                if (configService.get('session')) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $cs9KU.PAGE_LOAD] && _this._sendPageLoadMetrics();
                };
                if (configService.get('centralConfig')) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $2Hl1n.observePageVisibility)(configService, transactionService);
                if (flags[0, $cs9KU.EVENT_TARGET] && flags[0, $cs9KU.CLICK]) (0, $cyYT5.observePageClicks)(transactionService);
            } else {
                this._disable = true;
                loggingService.warn('RUM agent is inactive');
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $cs9KU.APM_SERVER),
            (0, $cs9KU.LOGGING_SERVICE),
            (0, $cs9KU.CONFIG_SERVICE)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get('serviceName'), configService.get('environment')).then(function(config) {
            var transactionSampleRate = config['transaction_sample_rate'];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn("invalid value \"" + value + "\" for " + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn('failed fetching config:', error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $cs9KU.PAGE_LOAD), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $cs9KU.PAGE_LOAD));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $cs9KU.PAGE_LOAD));
            }, (0, $cs9KU.PAGE_LOAD_DELAY));
        };
        if (document.readyState === 'complete') sendPageLoadMetrics();
        else window.addEventListener('load', sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $cs9KU.CONFIG_SERVICE),
            (0, $cs9KU.LOGGING_SERVICE)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = 'Unknown config options are specified for RUM agent: ' + unknown.join(', ');
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ', ';
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + ' is missing';
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + " \"" + value + "\" contains invalid characters! (allowed: " + allowed + ")" + (index !== invalid.length - 1 ? separator : '');
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $cs9KU.TRANSACTION_SERVICE));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $cs9KU.TRANSACTION_SERVICE));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $cs9KU.TRANSACTION_SERVICE));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $cs9KU.ERROR_LOGGING));
            return errorLogging.logError(error);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $cs9KU.CONFIG_SERVICE));
        configService.addFilter(fn);
    };
    return ApmBase;
}();

});





parcelRegister("1ytqf", function(module, exports) {

$parcel$export(module.exports, "watchUserConfigActions", () => $8f38709150187674$export$d21c97ad68f4646c);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $93tzC = parcelRequire("93tzC");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $efsoN = parcelRequire("efsoN");
function* $8f38709150187674$export$d21c97ad68f4646c() {
    yield (0, $2AbXc.takeLeading)((0, $93tzC.UserConfigActionTypes).FETCH_USER_CONFIG_ASYNC_PENDING, $8f38709150187674$export$1ced3c5b7bf03a86);
    yield (0, $2AbXc.takeLeading)((0, $93tzC.UserConfigActionTypes).UPDATE_USER_CONFIG_ASYNC_PENDING, $8f38709150187674$export$95ef1f3bbcf0ab0);
    yield (0, $2AbXc.takeLeading)((0, $93tzC.UserConfigActionTypes).UPDATE_UI_SETTING_ASYNC_PENDING, $8f38709150187674$export$d293819f15f8963);
}
function* $8f38709150187674$export$1ced3c5b7bf03a86(action) {
    try {
        const userId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/users/${userId}/user_config`, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $93tzC.UserConfigActionTypes).FETCH_USER_CONFIG_ASYNC_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $93tzC.UserConfigActionTypes).FETCH_USER_CONFIG_ASYNC_ERROR, error);
    }
}
function* $8f38709150187674$export$95ef1f3bbcf0ab0(action) {
    const user = {
        user: action.payload.user
    };
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/users/${action.payload.id}/user_config`, user, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $93tzC.UserConfigActionTypes).UPDATE_USER_CONFIG_ASYNC_SUCCESS, response.data, "updateUserSuccess");
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).MEETINGS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $93tzC.UserConfigActionTypes).UPDATE_USER_CONFIG_ASYNC_ERROR, error, "updateUserFail");
    }
}
function* $8f38709150187674$export$d293819f15f8963(action) {
    const data = {
        uiSettings: action.payload.data
    };
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/users/${action.payload.id}/user_config/update_ui_setting`, data, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $93tzC.UserConfigActionTypes).UPDATE_UI_SETTING_ASYNC_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $93tzC.UserConfigActionTypes).UPDATE_UI_SETTING_ASYNC_ERROR, error);
    }
}

});

parcelRegister("dpAzW", function(module, exports) {

$parcel$export(module.exports, "watchFetchTenantConfigAsync", () => $95630b83bca9e0ad$export$db74045bc46efa00);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $83zyI = parcelRequire("83zyI");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");
function* $95630b83bca9e0ad$export$9e5c1587c4371c90() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/tenant_config", (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $83zyI.TenantConfigActionTypes).FETCH_TENANT_CONFIG_ASYNC_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $83zyI.TenantConfigActionTypes).FETCH_TENANT_CONFIG_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $95630b83bca9e0ad$export$db74045bc46efa00() {
    yield (0, $2AbXc.takeLeading)((0, $83zyI.TenantConfigActionTypes).FETCH_TENANT_CONFIG_ASYNC_PENDING, $95630b83bca9e0ad$export$9e5c1587c4371c90);
}

});

parcelRegister("b7oeO", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseAssetsAsync", () => $041c92495c62945b$export$b5737badff1c1941);
$parcel$export(module.exports, "watchDeleteAssetsAsync", () => $041c92495c62945b$export$98c7934306356514);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $7twpo = parcelRequire("7twpo");
function* $041c92495c62945b$export$db2b230be82c046d(action) {
    try {
        const caseId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases/${caseId}/assets`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $041c92495c62945b$export$b5737badff1c1941() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).FETCH_CASE_ASSETS_ASYNC_PENDING, $041c92495c62945b$export$db2b230be82c046d);
}
function* $041c92495c62945b$export$202d193054659864(action) {
    try {
        const caseId = action.payload.caseId;
        const assetId = action.payload.assetId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/cases/${caseId}/assets/${assetId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteAssetSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteAssetFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $041c92495c62945b$export$98c7934306356514() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).DELETE_CASE_ASSET_ASYNC_PENDING, $041c92495c62945b$export$202d193054659864);
}

});

parcelRegister("jiE79", function(module, exports) {

$parcel$export(module.exports, "watchFetchMeetingsAsync", () => $43358742bef7178d$export$e54451627b17fd9c);
$parcel$export(module.exports, "watchFetchMeetingsInDateRangeAsync", () => $43358742bef7178d$export$2ad0e959422147c5);

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $bal3N = parcelRequire("bal3N");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
function* $43358742bef7178d$export$2e1a23a993b4258d(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/meetings?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchMeetingsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                appliedFilters: response.data.searchQuery.appliedFilters,
                orderBy: response.data.searchQuery.orderBy,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                searchTerm: response.data.searchQuery.searchTerm
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "meetingsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $43358742bef7178d$export$e54451627b17fd9c() {
    yield (0, $2AbXc.takeLeading)((0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_PENDING, $43358742bef7178d$export$2e1a23a993b4258d);
}
function* $43358742bef7178d$export$325ce99254ebba11(action) {
    try {
        const { start: start, end: end } = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/meetings/in_range/${start}/${end}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchMeetingsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "meetingsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $43358742bef7178d$export$2ad0e959422147c5() {
    yield (0, $2AbXc.takeEvery)((0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_PENDING, $43358742bef7178d$export$325ce99254ebba11);
}

});
parcelRegister("5ofNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ecb7368762fc268$export$2e2bcd8739ae039);

var $1wmL6 = parcelRequire("1wmL6");
var $3ecb7368762fc268$export$2e2bcd8739ae039 = $1wmL6;

});
parcelRegister("1wmL6", function(module, exports) {

$parcel$export(module.exports, "extract", () => $11ba6efd360d635f$export$f9380c9a627682d3);
$parcel$export(module.exports, "parse", () => $11ba6efd360d635f$export$98e6a39c04603d36);
$parcel$export(module.exports, "stringify", () => $11ba6efd360d635f$export$fac44ee5b035f737);
$parcel$export(module.exports, "parseUrl", () => $11ba6efd360d635f$export$7a5253c0f62e0150);
$parcel$export(module.exports, "stringifyUrl", () => $11ba6efd360d635f$export$a8c1621ea79325d3);
$parcel$export(module.exports, "pick", () => $11ba6efd360d635f$export$357523c63a2253b9);
$parcel$export(module.exports, "exclude", () => $11ba6efd360d635f$export$44c361b8ec72ef7f);

var $5yzCy = parcelRequire("5yzCy");

var $4IJyT = parcelRequire("4IJyT");

var $KvXt7 = parcelRequire("KvXt7");
const $11ba6efd360d635f$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $11ba6efd360d635f$var$strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $11ba6efd360d635f$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $11ba6efd360d635f$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) {
                        result.push([
                            $11ba6efd360d635f$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join(''));
                        return result;
                    }
                    result.push([
                        $11ba6efd360d635f$var$encode(key, options),
                        '[',
                        $11ba6efd360d635f$var$encode(index, options),
                        ']=',
                        $11ba6efd360d635f$var$encode(value, options)
                    ].join(''));
                    return result;
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) {
                        result.push([
                            $11ba6efd360d635f$var$encode(key, options),
                            '[]'
                        ].join(''));
                        return result;
                    }
                    result.push([
                        $11ba6efd360d635f$var$encode(key, options),
                        '[]=',
                        $11ba6efd360d635f$var$encode(value, options)
                    ].join(''));
                    return result;
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) {
                        result.push([
                            $11ba6efd360d635f$var$encode(key, options),
                            ':list='
                        ].join(''));
                        return result;
                    }
                    result.push([
                        $11ba6efd360d635f$var$encode(key, options),
                        ':list=',
                        $11ba6efd360d635f$var$encode(value, options)
                    ].join(''));
                    return result;
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSeparator = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) {
                            result.push([
                                $11ba6efd360d635f$var$encode(key, options),
                                keyValueSeparator,
                                $11ba6efd360d635f$var$encode(value, options)
                            ].join(''));
                            return result;
                        }
                        result.push($11ba6efd360d635f$var$encode(value, options));
                        return result;
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) {
                        result.push($11ba6efd360d635f$var$encode(key, options));
                        return result;
                    }
                    result.push([
                        $11ba6efd360d635f$var$encode(key, options),
                        '=',
                        $11ba6efd360d635f$var$encode(value, options)
                    ].join(''));
                    return result;
                };
    }
}
function $11ba6efd360d635f$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                if (!Array.isArray(accumulator[key])) {
                    accumulator[key] = [
                        accumulator[key],
                        value
                    ];
                    return;
                }
                accumulator[key].push(value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                if (!Array.isArray(accumulator[key])) {
                    accumulator[key] = [
                        accumulator[key],
                        value
                    ];
                    return;
                }
                accumulator[key].push(value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const newValue = isArray ? value.split(options.arrayFormatSeparator).map((item)=>$11ba6efd360d635f$var$decode(item, options)) : value === null ? value : $11ba6efd360d635f$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $11ba6efd360d635f$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : $11ba6efd360d635f$var$decode(value, options).split(options.arrayFormatSeparator);
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                if (!Array.isArray(accumulator[key])) accumulator[key] = [
                    accumulator[key]
                ];
                for (const item of arrayValue)accumulator[key].push(item);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                if (Array.isArray(accumulator[key])) {
                    accumulator[key].push(value);
                    return;
                }
                accumulator[key] = [
                    accumulator[key],
                    value
                ];
            };
    }
}
function $11ba6efd360d635f$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $11ba6efd360d635f$var$encode(value, options) {
    if (options.encode) return options.strict ? $11ba6efd360d635f$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $11ba6efd360d635f$var$decode(value, options) {
    if (options.decode) return (0, $5yzCy.default)(value);
    return value;
}
function $11ba6efd360d635f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $11ba6efd360d635f$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $11ba6efd360d635f$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $11ba6efd360d635f$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $11ba6efd360d635f$var$getUrlWithoutQuery(url) {
    // Avoid `split('?')` so query-heavy URLs don't allocate large arrays.
    const queryStart = url.indexOf('?');
    return queryStart === -1 ? url : url.slice(0, queryStart);
}
function $11ba6efd360d635f$var$parseValue(value, options, type) {
    if (type === 'string' && typeof value === 'string') return value;
    if (typeof type === 'function' && typeof value === 'string') return type(value);
    if (type === 'boolean' && value === null) return true;
    if (type === 'boolean' && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) return value.toLowerCase() === 'true';
    if (type === 'boolean' && value !== null && (value.toLowerCase() === '1' || value.toLowerCase() === '0')) return value.toLowerCase() === '1';
    if (type === 'string[]' && options.arrayFormat !== 'none' && typeof value === 'string') return [
        value
    ];
    if (type === 'number[]' && options.arrayFormat !== 'none' && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return [
        Number(value)
    ];
    if (type === 'number' && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) return value.toLowerCase() === 'true';
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    return value;
}
function $11ba6efd360d635f$export$f9380c9a627682d3(input) {
    input = $11ba6efd360d635f$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $11ba6efd360d635f$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    $11ba6efd360d635f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $11ba6efd360d635f$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== 'string') return returnValue;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return returnValue;
    if (/^&+$/.test(query)) return returnValue;
    let parameterStart = 0;
    let firstSeparator = query.indexOf('&');
    if (firstSeparator === -1) firstSeparator = query.length;
    for(let index = firstSeparator; index <= query.length; index++){
        if (index < query.length && query[index] !== '&') continue;
        if (index === parameterStart) {
            parameterStart = index + 1;
            continue;
        }
        const parameter = query.slice(parameterStart, index);
        const parameter_ = options.decode ? parameter.replaceAll('+', ' ') : parameter;
        let [key, value] = (0, $KvXt7.default)(parameter_, '=');
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $11ba6efd360d635f$var$decode(value, options);
        formatter($11ba6efd360d635f$var$decode(key, options), value, returnValue);
        parameterStart = index + 1;
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === 'object' && value !== null && options.types[key] !== 'string') for (const [key2, value2] of Object.entries(value)){
            const typeOption = options.types[key];
            const type = typeof typeOption === 'function' ? typeOption : typeOption ? typeOption.replace('[]', '') : undefined;
            value[key2] = $11ba6efd360d635f$var$parseValue(value2, options, type);
        }
        else if (typeof value === 'object' && value !== null && options.types[key] === 'string') returnValue[key] = Object.values(value).join(options.arrayFormatSeparator);
        else returnValue[key] = $11ba6efd360d635f$var$parseValue(value, options, options.types[key]);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? $11ba6efd360d635f$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $11ba6efd360d635f$export$fac44ee5b035f737(object, options) {
    if (!object) return '';
    options = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        ...options
    };
    $11ba6efd360d635f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $11ba6efd360d635f$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $11ba6efd360d635f$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        let value = object[key];
        // Apply replacer function if provided
        if (options.replacer) {
            value = options.replacer(key, value);
            // If replacer returns undefined, skip this key
            if (value === undefined) return '';
        }
        if (value === undefined) return '';
        if (value === null) return $11ba6efd360d635f$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $11ba6efd360d635f$var$encode(key, options) + '[]';
            // Apply replacer to array elements if provided
            // Note: We don't re-apply replacer to the array itself, only to elements
            let processedArray = value;
            if (options.replacer) processedArray = value.map((item, index)=>options.replacer(`${key}[${index}]`, item)).filter((item)=>item !== undefined);
            const result = processedArray.reduce(formatter(key), []);
            const arrayFormatSeparator = [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? options.arrayFormatSeparator : '&';
            return result.join(arrayFormatSeparator);
        }
        return $11ba6efd360d635f$var$encode(key, options) + '=' + $11ba6efd360d635f$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
}
function $11ba6efd360d635f$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $KvXt7.default)(url, '#');
    if (url_ === undefined) url_ = url;
    return {
        url: $11ba6efd360d635f$var$getUrlWithoutQuery(url_ ?? ''),
        query: $11ba6efd360d635f$export$98e6a39c04603d36($11ba6efd360d635f$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $11ba6efd360d635f$var$decode(hash, options)
        } : {}
    };
}
function $11ba6efd360d635f$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$11ba6efd360d635f$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $11ba6efd360d635f$var$getUrlWithoutQuery($11ba6efd360d635f$var$removeHash(object.url)) || '';
    const queryFromUrl = $11ba6efd360d635f$export$f9380c9a627682d3(object.url);
    const query = {
        ...$11ba6efd360d635f$export$98e6a39c04603d36(queryFromUrl, {
            sort: false,
            ...options
        }),
        ...object.query
    };
    let queryString = $11ba6efd360d635f$export$fac44ee5b035f737(query, options);
    queryString &&= `?${queryString}`;
    let hash = $11ba6efd360d635f$var$getHash(object.url);
    if (typeof object.fragmentIdentifier === 'string') {
        hash = `#${object.fragmentIdentifier}`;
        if (options[$11ba6efd360d635f$var$encodeFragmentIdentifier]) {
            // Percent-encode the fragment with a throwaway URL. The fragment percent-encode set does not depend on the scheme, so the caller's URL is deliberately not parsed here; it may not even be parseable.
            const throwawayUrl = new URL('https://query-string.invalid');
            throwawayUrl.hash = hash;
            hash = throwawayUrl.hash;
        }
    }
    return `${url}${queryString}${hash}`;
}
function $11ba6efd360d635f$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$11ba6efd360d635f$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $11ba6efd360d635f$export$7a5253c0f62e0150(input, options);
    return $11ba6efd360d635f$export$a8c1621ea79325d3({
        url: url,
        query: (0, $4IJyT.includeKeys)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $11ba6efd360d635f$export$44c361b8ec72ef7f(input, filter, options) {
    if (Array.isArray(filter)) {
        const filterSet = new Set(filter);
        return $11ba6efd360d635f$export$357523c63a2253b9(input, (key)=>!filterSet.has(key), options);
    }
    return $11ba6efd360d635f$export$357523c63a2253b9(input, (key, value)=>!filter(key, value), options);
}

});
parcelRegister("5yzCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40bbc24beab9f9b8$export$2e2bcd8739ae039);
// Matches one or more consecutive percent-encoded bytes (e.g. `%C3%A5`).
const $40bbc24beab9f9b8$var$token = '%[a-f0-9]{2}';
const $40bbc24beab9f9b8$var$multiMatcher = new RegExp(`(${$40bbc24beab9f9b8$var$token})+`, 'gi');
const $40bbc24beab9f9b8$var$hexPair = /^[a-f\d]{2}$/i;
// Read a `%XX` sequence at `position`, returning the byte value and where to continue scanning.
function $40bbc24beab9f9b8$var$parsePercentByte(input, position) {
    if (input.codePointAt(position) !== 37 || position + 3 > input.length) return;
    const digits = input.slice(position + 1, position + 3);
    if (!$40bbc24beab9f9b8$var$hexPair.test(digits)) return;
    return {
        byte: Number.parseInt(digits, 16),
        next: position + 3
    };
}
/**
 * Return how many bytes a UTF-8 code point needs based on its lead byte.
 * Returns 0 for continuation bytes and other invalid lead bytes.
 */ function $40bbc24beab9f9b8$var$utf8SequenceLength(byte) {
    if (byte <= 0x7F) return 1;
    // Start at 0xC2 to exclude overlong 2-byte encodings (0xC0/0xC1).
    if (byte >= 0xC2 && byte <= 0xDF) return 2;
    if (byte >= 0xE0 && byte <= 0xEF) return 3;
    if (byte >= 0xF0 && byte <= 0xF4) return 4;
    return 0;
}
function $40bbc24beab9f9b8$var$isContinuationByte(byte) {
    return byte >= 0x80 && byte <= 0xBF;
}
/**
 * Decode as much of `input` as possible without throwing.
 *Scans left-to-right in O(n), decoding valid UTF-8 runs and leaving the rest literal.
 */ function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let output = '';
        let position = 0;
        while(position < input.length){
            if (input.codePointAt(position) !== 37) {
                output += input.charAt(position);
                position++;
                continue;
            }
            const firstByte = $40bbc24beab9f9b8$var$parsePercentByte(input, position);
            // `%` not followed by two hex digits (e.g. `%` or `%G`).
            if (!firstByte) {
                output += input.charAt(position);
                position++;
                continue;
            }
            const sequenceLength = $40bbc24beab9f9b8$var$utf8SequenceLength(firstByte.byte);
            // Continuation byte or invalid lead byte — emit one `%XX` literally.
            if (sequenceLength === 0) {
                output += input.slice(position, position + 3);
                position += 3;
                continue;
            }
            let end = firstByte.next;
            let validSequence = true;
            for(let index = 1; index < sequenceLength; index++){
                const nextByte = $40bbc24beab9f9b8$var$parsePercentByte(input, end);
                if (!nextByte || !$40bbc24beab9f9b8$var$isContinuationByte(nextByte.byte)) {
                    validSequence = false;
                    break;
                }
                end = nextByte.next;
            }
            if (validSequence) {
                const encodedSequence = input.slice(position, end);
                try {
                    output += decodeURIComponent(encodedSequence);
                    position = end;
                    continue;
                } catch  {
                // Invalid UTF-8 despite correct structure — emit the first byte literally.
                }
            }
            // Missing continuation bytes or decode failure — emit the first byte literally.
            output += input.slice(position, position + 3);
            position += 3;
        }
        return output;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    // Find percent-encoded runs separated by literal text or lone `%` characters.
    let match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    return input;
}
function $40bbc24beab9f9b8$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError(`Expected \`encodedURI\` to be of type \`string\`, got \`${typeof encodedURI}\``);
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
}

});

parcelRegister("4IJyT", function(module, exports) {

$parcel$export(module.exports, "includeKeys", () => $36fe9d1ef26e3f64$export$ff05df6c2df24b52);
function $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $36fe9d1ef26e3f64$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $36fe9d1ef26e3f64$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}

});

parcelRegister("KvXt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $08bd16383ca1ef3d$export$2e2bcd8739ae039);
function $08bd16383ca1ef3d$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (string === '' || separator === '') return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

});




parcelRegister("2X3Yp", function(module, exports) {

$parcel$export(module.exports, "watchFetchMeetingCaseAsync", () => $7bb90deaac5c565c$export$7fd668d8f63e9968);
$parcel$export(module.exports, "watchCreateMeetingCase", () => $7bb90deaac5c565c$export$f0c5baeee3b7b99d);
$parcel$export(module.exports, "watchDeleteMeetingCase", () => $7bb90deaac5c565c$export$183ebeb10de105eb);
$parcel$export(module.exports, "watchReceiveMeetingCaseCableUpdateCaseAssets", () => $7bb90deaac5c565c$export$9ed12838d360808e);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $bP3DF = parcelRequire("bP3DF");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $1zizz = parcelRequire("1zizz");

var $1l1FS = parcelRequire("1l1FS");

var $7HZDe = parcelRequire("7HZDe");

var $6j1K3 = parcelRequire("6j1K3");
function* $7bb90deaac5c565c$export$9a89e82a714aab58(action) {
    try {
        const meetingCaseId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/meeting_cases/${meetingCaseId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingCaseSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "meetingCaseNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $7bb90deaac5c565c$export$7fd668d8f63e9968() {
    yield (0, $2AbXc.takeLeading)((0, $bP3DF.MeetingCaseActionTypes).FETCH_MEETING_CASE_ASYNC_PENDING, $7bb90deaac5c565c$export$9a89e82a714aab58);
}
function* $7bb90deaac5c565c$export$c6c6a7be6e79c9cc(action) {
    const payload = action.payload;
    try {
        const meetingCaseData = {
            meetingCase: payload
        };
        // responds with the full meeting
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/meeting_cases", meetingCaseData, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: payload.caseId,
                meetingId: payload.meetingId
            }
        });
        // TODO: Remove this redirect?! Not sure what it is for
        if (payload.redirectPath) yield (0, $k6WuE.O)((0, $1l1FS.default).push, payload.redirectPath);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $7bb90deaac5c565c$export$f0c5baeee3b7b99d() {
    yield (0, $2AbXc.takeLeading)((0, $bP3DF.MeetingCaseActionTypes).CREATE_MEETING_CASE_ASYNC_PENDING, $7bb90deaac5c565c$export$c6c6a7be6e79c9cc);
}
function* $7bb90deaac5c565c$export$940ad36ad8f52411(action) {
    const payload = action.payload;
    try {
        const meetingCaseId = payload.meetingCaseId;
        // responds with the full meeting
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `meeting_cases/${meetingCaseId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: payload.caseId,
                meetingId: payload.meetingId,
                meetingCaseId: meetingCaseId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $7bb90deaac5c565c$export$183ebeb10de105eb() {
    yield (0, $2AbXc.takeLeading)((0, $bP3DF.MeetingCaseActionTypes).DELETE_MEETING_CASE_ASYNC_PENDING, $7bb90deaac5c565c$export$940ad36ad8f52411);
}
function* $7bb90deaac5c565c$export$9459fe47cc7e09cc(action) {
    yield (0, $k6WuE.Z)((0, $7HZDe.fetchCaseAssetsAction)(action.payload.caseId));
    yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
}
function* $7bb90deaac5c565c$export$9ed12838d360808e() {
    yield (0, $2AbXc.takeLeading)((0, $bP3DF.MeetingCaseCableActionTypes).ASSETS_CHANGED, $7bb90deaac5c565c$export$9459fe47cc7e09cc);
}

});

parcelRegister("crPZr", function(module, exports) {

$parcel$export(module.exports, "watchStartMeetingAsync", () => $5c0e8deb9065f143$export$cdd80eeb7368ec06);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $32kQ2 = parcelRequire("32kQ2");

var $1zizz = parcelRequire("1zizz");
function* $5c0e8deb9065f143$export$ccf65202e07ba97(action) {
    try {
        const meetingId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/meetings/${meetingId}/start`, {}, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $32kQ2.MeetingActionTypes).START_MEETING_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "notPossibleToStartMeeting",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $5c0e8deb9065f143$export$cdd80eeb7368ec06() {
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).START_MEETING_ASYNC_PENDING, $5c0e8deb9065f143$export$ccf65202e07ba97);
}

});

parcelRegister("fsK8M", function(module, exports) {

$parcel$export(module.exports, "watchConnectToWebRTCSessionAsync", () => $9fb3f16e312cce6f$export$2503f7a39dec1636);
$parcel$export(module.exports, "watchDisconnectFromWebRTCSessionAsync", () => $9fb3f16e312cce6f$export$c52464dba2bbf959);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $efsoN = parcelRequire("efsoN");
function* $9fb3f16e312cce6f$export$d923bf2c9e68f842(action) {
    try {
        const session = yield (0, $k6WuE.O)((0, $g7GJo.connectToSession), action.payload.apiKey, action.payload.sessionId, action.payload.meetingToken, action.payload.eventHandlers);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).CONNECT_TO_WEB_RTC_SESSION_ASYNC_SUCCESS,
            payload: session
        });
    } catch (error) {
        yield (0, $efsoN.logError)("could not connect to WebRTC session", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).CONNECT_TO_WEB_RTC_SESSION_ASYNC_ERROR, error, "connectToWebRTCSessionError");
    }
}
function* $9fb3f16e312cce6f$export$2503f7a39dec1636() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).CONNECT_TO_WEB_RTC_SESSION_ASYNC_PENDING, $9fb3f16e312cce6f$export$d923bf2c9e68f842);
}
function* $9fb3f16e312cce6f$export$16511ef477f51367(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.disconnectFromSession), action.payload.session);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_SUCCESS
        });
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_ERROR, error, "disconnectFromWebRTCSessionError");
    }
}
function* $9fb3f16e312cce6f$export$c52464dba2bbf959() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).DISCONNECT_FROM_WEB_RTC_SESSION_ASYNC_PENDING, $9fb3f16e312cce6f$export$16511ef477f51367);
}

});
parcelRegister("g7GJo", function(module, exports) {

$parcel$export(module.exports, "connectToSession", () => $8b4fc6e042e3f27d$export$dc182268e78e9ccb);
$parcel$export(module.exports, "disconnectFromSession", () => $8b4fc6e042e3f27d$export$76e38057bec5c00);
$parcel$export(module.exports, "unpublishFromSession", () => $8b4fc6e042e3f27d$export$bed91e6d8c7d6291);
$parcel$export(module.exports, "publishToSession", () => $8b4fc6e042e3f27d$export$3283e22807dea825);
$parcel$export(module.exports, "publishScreenToSession", () => $8b4fc6e042e3f27d$export$1644d4c7557d7fe6);
$parcel$export(module.exports, "stopPublishScreenToSession", () => $8b4fc6e042e3f27d$export$3b32f46aed4cf252);
$parcel$export(module.exports, "togglePublisherAudio", () => $8b4fc6e042e3f27d$export$7b0bfe758cf3ea6d);
$parcel$export(module.exports, "togglePublisherVideo", () => $8b4fc6e042e3f27d$export$16eac963182bb652);
$parcel$export(module.exports, "subscribeToStream", () => $8b4fc6e042e3f27d$export$7c0a441889edd1e9);
$parcel$export(module.exports, "getStreamUserId", () => $8b4fc6e042e3f27d$export$9bc9aaa577cb8f56);
$parcel$export(module.exports, "getAudioDevices", () => $8b4fc6e042e3f27d$export$c9c435b44f16339f);
$parcel$export(module.exports, "setAudioSource", () => $8b4fc6e042e3f27d$export$3ee7021ccd935333);
$parcel$export(module.exports, "getAudioSource", () => $8b4fc6e042e3f27d$export$9f3a03c3a88b5d01);
$parcel$export(module.exports, "cycleVideoSource", () => $8b4fc6e042e3f27d$export$53340b85cde2199b);

var $epdsR = parcelRequire("epdsR");

var $f1q41 = parcelRequire("f1q41");

var $gONkJ = parcelRequire("gONkJ");

var $j0qQC = parcelRequire("j0qQC");
const $8b4fc6e042e3f27d$export$dc182268e78e9ccb = (apiKey, sessionId, meetingToken, eventHandlers)=>{
    return new Promise((resolve, reject)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($epdsR))).checkSystemRequirements() != 1) {
            const error = {
                name: "Session Error",
                message: "The client does not support WebRTC"
            };
            reject(error);
        }
        const session = (0, (/*@__PURE__*/$parcel$interopDefault($epdsR))).initSession(apiKey, sessionId);
        session.on(eventHandlers);
        session.connect(meetingToken, (error)=>{
            if (error) reject(error);
            resolve(session);
        });
    });
};
const $8b4fc6e042e3f27d$export$76e38057bec5c00 = (session)=>{
    session.disconnect();
};
const $8b4fc6e042e3f27d$export$bed91e6d8c7d6291 = (session, publisher)=>{
    session.unpublish(publisher);
};
const $8b4fc6e042e3f27d$export$3283e22807dea825 = (session, containerRef, options, eventHandlers)=>{
    return new Promise((resolve, reject)=>{
        if (session.capabilities.publish != 1) {
            const error = {
                name: "Publish Error",
                message: "Session does not have capability to publish"
            };
            reject(error);
        }
        const element = containerRef.current;
        const publisher = (0, (/*@__PURE__*/$parcel$interopDefault($epdsR))).initPublisher(element, options, (error)=>{
            if (error) reject(error);
            publisher.on(eventHandlers);
            session.publish(publisher, (error)=>{
                if (error) reject(error);
                resolve(publisher);
            });
        });
        $8b4fc6e042e3f27d$export$12906f83db2b9000(publisher);
    });
};
const $8b4fc6e042e3f27d$export$1644d4c7557d7fe6 = (session, containerRef, options, eventHandlers)=>{
    return new Promise((resolve, reject)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($epdsR))).checkScreenSharingCapability((response)=>{
            if (!response.supported) {
                const error = {
                    name: "Publish Screen Error",
                    message: "Session does not have capability to publish screen"
                };
                reject(error);
            } else resolve($8b4fc6e042e3f27d$export$3283e22807dea825(session, containerRef, options, eventHandlers));
        });
    });
};
const $8b4fc6e042e3f27d$export$3b32f46aed4cf252 = (session, publisher)=>{
    session.unpublish(publisher);
    publisher.destroy();
    return publisher;
};
const $8b4fc6e042e3f27d$export$7b0bfe758cf3ea6d = (publisher, isSharingAudio)=>{
    publisher.publishAudio(isSharingAudio);
};
const $8b4fc6e042e3f27d$export$16eac963182bb652 = (publisher, isSharingVideo)=>{
    publisher.publishVideo(isSharingVideo);
};
const $8b4fc6e042e3f27d$export$7c0a441889edd1e9 = (session, stream, containerRef, options)=>{
    return new Promise((resolve, reject)=>{
        const element = containerRef.current;
        let subscriberOptions = options;
        if (stream?.connection?.connectionId && session?.connection?.connectionId && stream.connection.connectionId === session.connection.connectionId && subscriberOptions) {
            const { preferredFrameRate: _preferredFrameRate, preferredResolution: _preferredResolution, ...restOptions } = subscriberOptions;
            subscriberOptions = restOptions;
        }
        const subscriber = session.subscribe(stream, element, subscriberOptions, (error)=>{
            if (error) reject(error);
            resolve(subscriber);
        });
        $8b4fc6e042e3f27d$export$12906f83db2b9000(subscriber);
    });
};
const $8b4fc6e042e3f27d$export$12906f83db2b9000 = (target)=>{
    let movingAvg = null;
    let speaking = false;
    const handler = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).throttle((event)=>{
        const _event = event;
        const userId = $8b4fc6e042e3f27d$export$9bc9aaa577cb8f56(_event.target.stream);
        if (movingAvg === null || movingAvg <= _event.audioLevel) movingAvg = _event.audioLevel;
        else movingAvg = 0.7 * movingAvg + 0.3 * _event.audioLevel;
        const speakingNow = movingAvg > 0.02;
        if (speakingNow != speaking) (0, $gONkJ.store).dispatch({
            type: (0, $j0qQC.LiveMeetingActionTypes).USER_SPEAKING,
            payload: {
                userId: userId,
                speakingNow: speakingNow
            }
        });
        speaking = speakingNow;
    }, 300);
    target.on("audioLevelUpdated", handler);
};
const $8b4fc6e042e3f27d$export$9bc9aaa577cb8f56 = (stream)=>{
    if (!stream) return null;
    return stream.connection.data.split(",").map((item)=>{
        if (item.startsWith("user_id=")) return item.replace("user_id=", "");
    }).join("");
};
const $8b4fc6e042e3f27d$export$fa272b2a6b3c4ea9 = (type)=>{
    return new Promise((resolve, reject)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($epdsR))).getDevices((error, devices = [])=>{
            if (error) reject(error);
            const audioDevices = devices.filter((device)=>{
                return device.kind === type;
            });
            resolve(audioDevices);
        });
    });
};
const $8b4fc6e042e3f27d$export$c9c435b44f16339f = ()=>{
    return $8b4fc6e042e3f27d$export$fa272b2a6b3c4ea9("audioInput");
};
const $8b4fc6e042e3f27d$export$3ee7021ccd935333 = (publisher, deviceId)=>{
    publisher.setAudioSource(deviceId);
};
const $8b4fc6e042e3f27d$export$9f3a03c3a88b5d01 = async (publisher)=>{
    const source = publisher.getAudioSource();
    const allAudioDevices = await $8b4fc6e042e3f27d$export$c9c435b44f16339f();
    return allAudioDevices.find((device)=>{
        return device.label === source.label;
    });
};
const $8b4fc6e042e3f27d$export$53340b85cde2199b = (publisher)=>{
    return publisher.cycleVideo();
};

});
parcelRegister("epdsR", function(module, exports) {
/**
 * @license OpenTok.js 2.23.7 5807f4903
 *
 * Copyright (c) 2010-2022 TokBox, Inc.
 * Subject to the applicable Software Development Kit (SDK) License Agreement:
 * https://www.vonage.com/legal/communications-apis/terms-of-use/
 *
 * Date: Thu, 29 Sep 2022 21:06:15 GMT
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 329);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(process) {
                (function(global, factory) {
                    module1.exports = factory();
                })(this, function() {
                    'use strict';
                    function objectOrFunction(x) {
                        var type = typeof x;
                        return x !== null && (type === 'object' || type === 'function');
                    }
                    function isFunction(x) {
                        return typeof x === 'function';
                    }
                    var _isArray = void 0;
                    if (Array.isArray) _isArray = Array.isArray;
                    else _isArray = function(x) {
                        return Object.prototype.toString.call(x) === '[object Array]';
                    };
                    var isArray = _isArray;
                    var len = 0;
                    var vertxNext = void 0;
                    var customSchedulerFn = void 0;
                    var asap = function asap(callback, arg) {
                        queue[len] = callback;
                        queue[len + 1] = arg;
                        len += 2;
                        if (len === 2) {
                            // If len is 2, that means that we need to schedule an async flush.
                            // If additional callbacks are queued before the queue is flushed, they
                            // will be processed by this flush that we are scheduling.
                            if (customSchedulerFn) customSchedulerFn(flush);
                            else scheduleFlush();
                        }
                    };
                    function setScheduler(scheduleFn) {
                        customSchedulerFn = scheduleFn;
                    }
                    function setAsap(asapFn) {
                        asap = asapFn;
                    }
                    var browserWindow = typeof window !== 'undefined' ? window : undefined;
                    var browserGlobal = browserWindow || {};
                    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
                    var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
                    // test for web worker but not in IE10
                    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
                    // node
                    function useNextTick() {
                        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                        // see https://github.com/cujojs/when/issues/410 for details
                        return function() {
                            return process.nextTick(flush);
                        };
                    }
                    // vertx
                    function useVertxTimer() {
                        if (typeof vertxNext !== 'undefined') return function() {
                            vertxNext(flush);
                        };
                        return useSetTimeout();
                    }
                    function useMutationObserver() {
                        var iterations = 0;
                        var observer = new BrowserMutationObserver(flush);
                        var node = document.createTextNode('');
                        observer.observe(node, {
                            characterData: true
                        });
                        return function() {
                            node.data = iterations = ++iterations % 2;
                        };
                    }
                    // web worker
                    function useMessageChannel() {
                        var channel = new MessageChannel();
                        channel.port1.onmessage = flush;
                        return function() {
                            return channel.port2.postMessage(0);
                        };
                    }
                    function useSetTimeout() {
                        // Store setTimeout reference so es6-promise will be unaffected by
                        // other code modifying setTimeout (like sinon.useFakeTimers())
                        var globalSetTimeout = setTimeout;
                        return function() {
                            return globalSetTimeout(flush, 1);
                        };
                    }
                    var queue = new Array(1000);
                    function flush() {
                        for(var i = 0; i < len; i += 2){
                            var callback = queue[i];
                            var arg = queue[i + 1];
                            callback(arg);
                            queue[i] = undefined;
                            queue[i + 1] = undefined;
                        }
                        len = 0;
                    }
                    function attemptVertx() {
                        try {
                            var vertx = Function('return this')().require('vertx');
                            vertxNext = vertx.runOnLoop || vertx.runOnContext;
                            return useVertxTimer();
                        } catch (e) {
                            return useSetTimeout();
                        }
                    }
                    var scheduleFlush = void 0;
                    // Decide what async method to use to triggering processing of queued callbacks:
                    if (isNode) scheduleFlush = useNextTick();
                    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
                    else if (isWorker) scheduleFlush = useMessageChannel();
                    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
                    else scheduleFlush = useSetTimeout();
                    function then(onFulfillment, onRejection) {
                        var parent = this;
                        var child = new this.constructor(noop);
                        if (child[PROMISE_ID] === undefined) makePromise(child);
                        var _state = parent._state;
                        if (_state) {
                            var callback = arguments[_state - 1];
                            asap(function() {
                                return invokeCallback(_state, child, callback, parent._result);
                            });
                        } else subscribe(parent, child, onFulfillment, onRejection);
                        return child;
                    }
                    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
                        /*jshint validthis:true */ var Constructor = this;
                        if (object && typeof object === 'object' && object.constructor === Constructor) return object;
                        var promise = new Constructor(noop);
                        resolve(promise, object);
                        return promise;
                    }
                    var PROMISE_ID = Math.random().toString(36).substring(2);
                    function noop() {}
                    var PENDING = void 0;
                    var FULFILLED = 1;
                    var REJECTED = 2;
                    function selfFulfillment() {
                        return new TypeError("You cannot resolve a promise with itself");
                    }
                    function cannotReturnOwn() {
                        return new TypeError('A promises callback cannot return that same promise.');
                    }
                    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                        try {
                            then$$1.call(value, fulfillmentHandler, rejectionHandler);
                        } catch (e) {
                            return e;
                        }
                    }
                    function handleForeignThenable(promise, thenable, then$$1) {
                        asap(function(promise) {
                            var sealed = false;
                            var error = tryThen(then$$1, thenable, function(value) {
                                if (sealed) return;
                                sealed = true;
                                if (thenable !== value) resolve(promise, value);
                                else fulfill(promise, value);
                            }, function(reason) {
                                if (sealed) return;
                                sealed = true;
                                reject(promise, reason);
                            }, 'Settle: ' + (promise._label || ' unknown promise'));
                            if (!sealed && error) {
                                sealed = true;
                                reject(promise, error);
                            }
                        }, promise);
                    }
                    function handleOwnThenable(promise, thenable) {
                        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                        else if (thenable._state === REJECTED) reject(promise, thenable._result);
                        else subscribe(thenable, undefined, function(value) {
                            return resolve(promise, value);
                        }, function(reason) {
                            return reject(promise, reason);
                        });
                    }
                    function handleMaybeThenable(promise, maybeThenable, then$$1) {
                        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                        else {
                            if (then$$1 === undefined) fulfill(promise, maybeThenable);
                            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                            else fulfill(promise, maybeThenable);
                        }
                    }
                    function resolve(promise, value) {
                        if (promise === value) reject(promise, selfFulfillment());
                        else if (objectOrFunction(value)) {
                            var then$$1 = void 0;
                            try {
                                then$$1 = value.then;
                            } catch (error) {
                                reject(promise, error);
                                return;
                            }
                            handleMaybeThenable(promise, value, then$$1);
                        } else fulfill(promise, value);
                    }
                    function publishRejection(promise) {
                        if (promise._onerror) promise._onerror(promise._result);
                        publish(promise);
                    }
                    function fulfill(promise, value) {
                        if (promise._state !== PENDING) return;
                        promise._result = value;
                        promise._state = FULFILLED;
                        if (promise._subscribers.length !== 0) asap(publish, promise);
                    }
                    function reject(promise, reason) {
                        if (promise._state !== PENDING) return;
                        promise._state = REJECTED;
                        promise._result = reason;
                        asap(publishRejection, promise);
                    }
                    function subscribe(parent, child, onFulfillment, onRejection) {
                        var _subscribers = parent._subscribers;
                        var length = _subscribers.length;
                        parent._onerror = null;
                        _subscribers[length] = child;
                        _subscribers[length + FULFILLED] = onFulfillment;
                        _subscribers[length + REJECTED] = onRejection;
                        if (length === 0 && parent._state) asap(publish, parent);
                    }
                    function publish(promise) {
                        var subscribers = promise._subscribers;
                        var settled = promise._state;
                        if (subscribers.length === 0) return;
                        var child = void 0, callback = void 0, detail = promise._result;
                        for(var i = 0; i < subscribers.length; i += 3){
                            child = subscribers[i];
                            callback = subscribers[i + settled];
                            if (child) invokeCallback(settled, child, callback, detail);
                            else callback(detail);
                        }
                        promise._subscribers.length = 0;
                    }
                    function invokeCallback(settled, promise, callback, detail) {
                        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
                        if (hasCallback) {
                            try {
                                value = callback(detail);
                            } catch (e) {
                                succeeded = false;
                                error = e;
                            }
                            if (promise === value) {
                                reject(promise, cannotReturnOwn());
                                return;
                            }
                        } else value = detail;
                        if (promise._state !== PENDING) ;
                        else if (hasCallback && succeeded) resolve(promise, value);
                        else if (succeeded === false) reject(promise, error);
                        else if (settled === FULFILLED) fulfill(promise, value);
                        else if (settled === REJECTED) reject(promise, value);
                    }
                    function initializePromise(promise, resolver) {
                        try {
                            resolver(function resolvePromise(value) {
                                resolve(promise, value);
                            }, function rejectPromise(reason) {
                                reject(promise, reason);
                            });
                        } catch (e) {
                            reject(promise, e);
                        }
                    }
                    var id = 0;
                    function nextId() {
                        return id++;
                    }
                    function makePromise(promise) {
                        promise[PROMISE_ID] = id++;
                        promise._state = undefined;
                        promise._result = undefined;
                        promise._subscribers = [];
                    }
                    function validationError() {
                        return new Error('Array Methods must be provided an Array');
                    }
                    var Enumerator = function() {
                        function Enumerator(Constructor, input) {
                            this._instanceConstructor = Constructor;
                            this.promise = new Constructor(noop);
                            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                            if (isArray(input)) {
                                this.length = input.length;
                                this._remaining = input.length;
                                this._result = new Array(this.length);
                                if (this.length === 0) fulfill(this.promise, this._result);
                                else {
                                    this.length = this.length || 0;
                                    this._enumerate(input);
                                    if (this._remaining === 0) fulfill(this.promise, this._result);
                                }
                            } else reject(this.promise, validationError());
                        }
                        Enumerator.prototype._enumerate = function _enumerate(input) {
                            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                        };
                        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
                            var c = this._instanceConstructor;
                            var resolve$$1 = c.resolve;
                            if (resolve$$1 === resolve$1) {
                                var _then = void 0;
                                var error = void 0;
                                var didError = false;
                                try {
                                    _then = entry.then;
                                } catch (e) {
                                    didError = true;
                                    error = e;
                                }
                                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                                else if (typeof _then !== 'function') {
                                    this._remaining--;
                                    this._result[i] = entry;
                                } else if (c === Promise$1) {
                                    var promise = new c(noop);
                                    if (didError) reject(promise, error);
                                    else handleMaybeThenable(promise, entry, _then);
                                    this._willSettleAt(promise, i);
                                } else this._willSettleAt(new c(function(resolve$$1) {
                                    return resolve$$1(entry);
                                }), i);
                            } else this._willSettleAt(resolve$$1(entry), i);
                        };
                        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
                            var promise = this.promise;
                            if (promise._state === PENDING) {
                                this._remaining--;
                                if (state === REJECTED) reject(promise, value);
                                else this._result[i] = value;
                            }
                            if (this._remaining === 0) fulfill(promise, this._result);
                        };
                        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
                            var enumerator = this;
                            subscribe(promise, undefined, function(value) {
                                return enumerator._settledAt(FULFILLED, i, value);
                            }, function(reason) {
                                return enumerator._settledAt(REJECTED, i, reason);
                            });
                        };
                        return Enumerator;
                    }();
                    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
                        return new Enumerator(this, entries).promise;
                    }
                    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
                        /*jshint validthis:true */ var Constructor = this;
                        if (!isArray(entries)) return new Constructor(function(_, reject) {
                            return reject(new TypeError('You must pass an array to race.'));
                        });
                        else return new Constructor(function(resolve, reject) {
                            var length = entries.length;
                            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
                        });
                    }
                    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
                        /*jshint validthis:true */ var Constructor = this;
                        var promise = new Constructor(noop);
                        reject(promise, reason);
                        return promise;
                    }
                    function needsResolver() {
                        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
                    }
                    function needsNew() {
                        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                    }
                    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
                        function Promise(resolver) {
                            this[PROMISE_ID] = nextId();
                            this._result = this._state = undefined;
                            this._subscribers = [];
                            if (noop !== resolver) {
                                typeof resolver !== 'function' && needsResolver();
                                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
                            }
                        }
                        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
                            return this.then(null, onRejection);
                        };
                        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
                            var promise = this;
                            var constructor = promise.constructor;
                            if (isFunction(callback)) return promise.then(function(value) {
                                return constructor.resolve(callback()).then(function() {
                                    return value;
                                });
                            }, function(reason) {
                                return constructor.resolve(callback()).then(function() {
                                    throw reason;
                                });
                            });
                            return promise.then(callback, callback);
                        };
                        return Promise;
                    }();
                    Promise$1.prototype.then = then;
                    Promise$1.all = all;
                    Promise$1.race = race;
                    Promise$1.resolve = resolve$1;
                    Promise$1.reject = reject$1;
                    Promise$1._setScheduler = setScheduler;
                    Promise$1._setAsap = setAsap;
                    Promise$1._asap = asap;
                    /*global self*/ function polyfill() {
                        var local = void 0;
                        if (typeof window !== 'undefined') local = window;
                        else if (typeof self !== 'undefined') local = self;
                        else try {
                            local = Function('return this')();
                        } catch (e) {
                            throw new Error('polyfill failed because global object is unavailable in this environment');
                        }
                        var P = local.Promise;
                        if (P) {
                            var promiseToString = null;
                            try {
                                promiseToString = Object.prototype.toString.call(P.resolve());
                            } catch (e) {
                            // silently ignored
                            }
                            if (promiseToString === '[object Promise]' && !P.cast) return;
                        }
                        local.Promise = Promise$1;
                    }
                    // Strange compat..
                    Promise$1.polyfill = polyfill;
                    Promise$1.Promise = Promise$1;
                    return Promise$1;
                });
            //# sourceMappingURL=es6-promise.map
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(43));
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            module1.exports = _interopRequireDefault;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const debug = __webpack_require__(397);
            const memoize = __webpack_require__(191);
            const logLevels = __webpack_require__(119);
            /**
 * @typedef {Object} Logger
 * @property {Function} error
 * @property {Function} warn
 * @property {Function} info
 * @property {Function} log
 * @property {Function} debug
 * @property {Function} spam
 */ const createLogger = memoize((namespace)=>{
                /** @type Logger */ const API = {};
                const setMethods = ()=>{
                    Object.keys(logLevels).forEach((name)=>{
                        const method = logLevels[name].method;
                        const log = debug(`OpenTok:${namespace}:${name.toLowerCase()}`);
                        log.log = console[method].bind(console); // eslint-disable-line no-console
                        API[name.toLowerCase()] = log;
                    });
                };
                setMethods();
                return API;
            });
            createLogger.setLogLevel = (level)=>{
                let oldRules;
                try {
                    oldRules = window.localStorage.debug;
                } catch (err) {
                    // will get Uncaught DOMException: Failed to read the 'localStorage' property from 'Window':
                    // The document is sandboxed and lacks the 'allow-same-origin' flag.
                    oldRules = '';
                }
                const newDebugRules = Object.keys(logLevels).map((name)=>`${level >= logLevels[name].priority ? '' : '-'}(autogen)?OpenTok:*:${name.toLowerCase()}`);
                const debugStr = [
                    ...newDebugRules,
                    ...(oldRules || '').split(/[\s,]/).filter((rule)=>rule.indexOf('(autogen)?') === -1)
                ].filter((x)=>x).join(',');
                debug.enable(debugStr);
            };
            module1.exports = createLogger;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const envParser = __webpack_require__(539);
            const env = envParser.parse();
            module1.exports = env;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(531);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
                    try {
                        var info = gen[key](arg);
                        var value = info.value;
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (info.done) resolve(value);
                    else Promise.resolve(value).then(_next, _throw);
                }
                function _asyncToGenerator(fn) {
                    return function() {
                        var self1 = this, args = arguments;
                        return new Promise(function(resolve, reject) {
                            var gen = fn.apply(self1, args);
                            function _next(value) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                            }
                            function _throw(err) {
                                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                            }
                            _next(undefined);
                        });
                    };
                }
                module1.exports = _asyncToGenerator;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Note: Some of these descriptions here are more specific than the name would suggest, because we
            // only use them in one place. However, this shouldn't prevent us from using the error elsewhere if
            // the name fits, and we should update the description to be more general when this happens.
            module1.exports = {
                // The API key does not match the token or session.
                AUTHENTICATION_ERROR: 'OT_AUTHENTICATION_ERROR',
                // JSON response was badly formed.
                BADLY_FORMED_RESPONSE: 'OT_BADLY_FORMED_RESPONSE',
                // Unable to publish because your browser failed to get access to your microphone. You may need to
                // fully quit and restart your browser to get it to work.
                // See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.
                CHROME_MICROPHONE_ACQUISITION_ERROR: 'OT_CHROME_MICROPHONE_ACQUISITION_ERROR',
                // Failed to connect to session.
                CONNECT_FAILED: 'OT_CONNECT_FAILED',
                // The session has exceded the maximum number of simultaneous connections.
                CONNECTION_LIMIT_EXCEEDED: 'OT_CONNECTION_LIMIT_EXCEEDED',
                // The constraints for getting user media could not be satisfied.
                CONSTRAINTS_NOT_SATISFIED: 'OT_CONSTRAINTS_NOT_SATISFIED',
                // Failed to create peer connection.
                CREATE_PEER_CONNECTION_FAILED: 'OT_CREATE_PEER_CONNECTION_FAILED',
                // Action failed due to session disconnection.
                DISCONNECTED: 'OT_DISCONNECTED',
                // Received an unexpected empty response from the server.
                EMPTY_RESPONSE_BODY: 'OT_EMPTY_RESPONSE_BODY',
                // Attempted to call getRtcStatsReport in a browser that doesn't support standard getStats API.
                GET_RTC_STATS_REPORT_NOT_SUPPORTED: 'OT_GET_RTC_STATS_REPORT_NOT_SUPPORTED',
                // The hardware to fulfil the user media request appears to exist but could not be acquired. It
                // might be in use by another application.
                HARDWARE_UNAVAILABLE: 'OT_HARDWARE_UNAVAILABLE',
                // Something went wrong while establishing WebRTC connectivity.
                ICE_WORKFLOW_FAILED: 'OT_ICE_WORKFLOW_FAILED',
                // Received an invalid HTTP status. This may be considered invalid for the endpoint only and not
                // HTTP in general.
                INVALID_HTTP_STATUS: 'OT_INVALID_HTTP_STATUS',
                // One or more parameters was not valid or not provided.
                INVALID_PARAMETER: 'OT_INVALID_PARAMETER',
                // The session id was invalid.
                INVALID_SESSION_ID: 'OT_INVALID_SESSION_ID',
                // The fetching of the stream for the video element has been aborted.
                MEDIA_ERR_ABORTED: 'OT_MEDIA_ERR_ABORTED',
                // A decoding error occurred while trying to play the stream in the video element.
                MEDIA_ERR_DECODE: 'OT_MEDIA_ERR_DECODE',
                // A network error caused the stream to stop being fetched.
                MEDIA_ERR_NETWORK: 'OT_MEDIA_ERR_NETWORK',
                // The stream has been detected to be not suitable for playback.
                MEDIA_ERR_SRC_NOT_SUPPORTED: 'OT_MEDIA_ERR_SRC_NOT_SUPPORTED',
                // The ended event on the video element fired
                MEDIA_ENDED: 'OT_MEDIA_ENDED',
                // No devices were found to provide the media stream.
                NO_DEVICES_FOUND: 'OT_NO_DEVICES_FOUND',
                // Video and audio was disabled. You need to enable at least one.
                NO_VALID_CONSTRAINTS: 'OT_NO_VALID_CONSTRAINTS',
                // Couldn't perform action due to not being connected.
                NOT_CONNECTED: 'OT_NOT_CONNECTED',
                // A resource was not found.
                NOT_FOUND: 'OT_NOT_FOUND',
                // Something in the user media request is not supported.
                NOT_SUPPORTED: 'OT_NOT_SUPPORTED',
                // Couldn't perform an action because the Peer Connection is not connected.
                PEER_CONNECTION_NOT_CONNECTED: 'OT_PEER_CONNECTION_NOT_CONNECTED',
                // An action was not permitted.
                PERMISSION_DENIED: 'OT_PERMISSION_DENIED',
                // The signal could not be sent due to the rate limit.
                RATE_LIMIT_EXCEEDED: 'OT_RATE_LIMIT_EXCEEDED',
                // Error calling OT.reportIssue(). Check the client\'s network connection.
                REPORT_ISSUE_FAILED: 'OT_REPORT_ISSUE_FAILED',
                // Screen-sharing support in this browser requires an extension, but the extension is not
                // installed.
                SCREEN_SHARING_EXTENSION_NOT_INSTALLED: 'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED',
                // Screen-sharing support in this browser requires an extension, but one has not been registered.
                SCREEN_SHARING_EXTENSION_NOT_REGISTERED: 'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED',
                // Screen sharing is not supported in the browser.
                SCREEN_SHARING_NOT_SUPPORTED: 'OT_SCREEN_SHARING_NOT_SUPPORTED',
                // The WebRTC connection failed during setDescription.
                SET_REMOTE_DESCRIPTION_FAILED: 'OT_SET_REMOTE_DESCRIPTION_FAILED',
                // Setting the ICE configuration failed.
                FAILED_SET_CONFIGURATION: 'OT_FAILED_SET_CONFIGURATION',
                // Rumor.Socket cannot connect when it is already connecting or connected.
                SOCKET_ALREADY_CONNECTED_CONNECTING: 'OT_SOCKET_ALREADY_CONNECTED_CONNECTING',
                // A connection was closed abnormally (that is, with no close frame being sent) when a status code
                // is expected.
                SOCKET_CLOSE_ABNORMAL: 'OT_SOCKET_CLOSE_ABNORMAL',
                // Exception was thrown during Rumor connection, possibly because of a blocked port.
                SOCKET_CLOSE_CONNECT_EXCEPTION: 'OT_SOCKET_CLOSE_CONNECT_EXCEPTION',
                // Connectivity loss was detected as it was too long since the socket received the last PONG
                // message.
                SOCKET_CLOSE_CONNECTIVITY_LOSS: 'OT_SOCKET_CLOSE_CONNECTIVITY_LOSS',
                // Falling back on this error for socket close because a more suitable one was not found.
                SOCKET_CLOSE_FALLBACK_CODE: 'OT_SOCKET_CLOSE_FALLBACK_CODE',
                // An endpoint received data within a message that was not consistent with the type of the message
                // (e.g., non-UTF-8 [RFC3629] data within a text message)
                SOCKET_CLOSE_INCONSISTENT_DATA: 'OT_SOCKET_CLOSE_INCONSISTENT_DATA',
                // No status code was provided even though one was expected.
                SOCKET_CLOSE_NO_STATUS: 'OT_SOCKET_CLOSE_NO_STATUS',
                // An endpoint received a message that violates its policy.  This is a generic status code that
                // can be returned when there is no other more suitable status code (e.g., 1003 or 1009) or if
                // there is a need to hide specific details about the policy.
                SOCKET_CLOSE_POLICY_VIOLATION: 'OT_SOCKET_CLOSE_POLICY_VIOLATION',
                // The endpoint is going away, either because of a server failure or because the browser is
                // navigating away from the page that opened the connection.
                SOCKET_CLOSE_GOING_AWAY: 'OT_SOCKET_CLOSE_GOING_AWAY',
                // A protocol error occurred.
                SOCKET_CLOSE_PROTOCOL_ERROR: 'OT_SOCKET_CLOSE_PROTOCOL_ERROR',
                // Timed out while waiting for the Rumor socket to connect.
                SOCKET_CLOSE_TIMEOUT: 'OT_SOCKET_CLOSE_TIMEOUT',
                // An endpoint received a message that is too big for it to process
                SOCKET_CLOSE_TOO_LARGE: 'OT_SOCKET_CLOSE_TOO_LARGE',
                // An endpoint encountered an unexpected condition that prevented it from fulfilling the request.
                SOCKET_CLOSE_UNEXPECTED_CONDITION: 'OT_SOCKET_CLOSE_UNEXPECTED_CONDITION',
                // An endpoint has indicated that reconnections are not available.
                SOCKET_CLOSE_UNSUPPORTED: 'OT_SOCKET_CLOSE_UNSUPPORTED',
                // Failed to create the stream in the server model.
                STREAM_CREATE_FAILED: 'OT_STREAM_CREATE_FAILED',
                // The stream was destroyed before it could be subscribed to.
                STREAM_DESTROYED: 'OT_STREAM_DESTROYED',
                // The session has exceded the maximum number of simultaneous streams.
                STREAM_LIMIT_EXCEEDED: 'OT_STREAM_LIMIT_EXCEEDED',
                // Couldn't subscribe to the stream because it was not found.
                STREAM_NOT_FOUND: 'OT_STREAM_NOT_FOUND',
                // Couldn't subscribe to stream due to unexpected error from rumor
                UNABLE_TO_SUBSCRIBE: 'OT_UNABLE_TO_SUBSCRIBE',
                // Couldn't connect due to a terms of service violation.
                TERMS_OF_SERVICE_FAILURE: 'OT_TERMS_OF_SERVICE_FAILURE',
                // A timer expired while waiting for an action to occur.
                TIMEOUT: 'OT_TIMEOUT',
                // The operation was cancelled
                CANCEL: 'OT_CANCEL',
                // Generic media abort error
                UNABLE_TO_CAPTURE_MEDIA: 'OT_UNABLE_TO_CAPTURE_MEDIA',
                // Generic/ Unknown screen share error
                UNABLE_TO_CAPTURE_SCREEN: 'OT_UNABLE_TO_CAPTURE_SCREEN',
                // The error code received was unexpected.
                UNEXPECTED_ERROR_CODE: 'OT_UNEXPECTED_ERROR_CODE',
                // Received an unexpected HTTP status.
                UNEXPECTED_HTTP_STATUS: 'OT_UNEXPECTED_HTTP_STATUS',
                // An unexpected server response was received which could not be handled.
                UNEXPECTED_SERVER_RESPONSE: 'OT_UNEXPECTED_SERVER_RESPONSE',
                // An unknown anvil error occurred.
                UNKNOWN_HTTP_ERROR: 'OT_UNKNOWN_HTTP_ERROR',
                UNSUPPORTED_BROWSER: 'OT_UNSUPPORTED_BROWSER',
                // Access to user media was denied.
                USER_MEDIA_ACCESS_DENIED: 'OT_USER_MEDIA_ACCESS_DENIED',
                // There was a cross domain error or the server responded with invalid JSON.
                XDOMAIN_OR_PARSING_ERROR: 'OT_XDOMAIN_OR_PARSING_ERROR',
                API_KEY_DISABLED: 'OT_API_KEY_DISABLED',
                // There was an error when trying to get the list of supported codecs.
                UNABLE_TO_ACCESS_MEDIA_ENGINE: 'OT_UNABLE_TO_ACCESS_MEDIA_ENGINE',
                // The proxyUrl was set after a session or publisher were created.
                SET_PROXY_URL_TIMING_ERROR: 'OT_SET_PROXY_URL_TIMING_ERROR',
                // The proxyUrl has already been set. Setting it again will not have any effect
                PROXY_URL_ALREADY_SET_ERROR: 'OT_PROXY_URL_ALREADY_SET_ERROR',
                // You cannot reset the video source on a publisher that does not currently include a video track.
                SET_VIDEO_SOURCE_FAILURE: 'OT_SET_VIDEO_SOURCE_FAILURE',
                // Invalid video source. Video source must be a valid video input deviceId
                INVALID_VIDEO_SOURCE: 'OT_INVALID_VIDEO_SOURCE',
                // The requested audio device does not have permissions to be used.
                REQUESTED_DEVICE_PERMISSION_DENIED: 'OT_REQUESTED_DEVICE_PERMISSION_DENIED',
                // Invalid output audio device ID. It must be a valid video output deviceId.
                INVALID_AUDIO_OUTPUT_SOURCE: 'OT_INVALID_AUDIO_OUTPUT_SOURCE',
                // Invalid encryption secret. Must be a string and match length requirements.
                INVALID_ENCRYPTION_SECRET: 'OT_INVALID_ENCRYPTION_SECRET'
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Events = __webpack_require__(31);
            const isFunction = __webpack_require__(17);
            const logging = __webpack_require__(2)('Events');
            const assign = __webpack_require__(9);
            const weakMemoizeBind = __webpack_require__(402);
            /**
 * This base class defines the <code>on</code>, <code>once</code>, and <code>off</code>
 * methods of objects that can dispatch events.
 *
 * @class EventDispatcher
 */ module1.exports = function eventing(self1) {
                const ee = new Events();
                ee.on('newListener', (eventName)=>{
                    ee.emit(`${eventName}:added`);
                });
                ee.on('removeListener', (eventName)=>{
                    ee.emit(`${eventName}:removed`);
                });
                const eventingMixin = {
                    /**
     * Adds an event handler function for one or more events.
     *
     * <p>
     * The following code adds an event handler for one event:
     * </p>
     *
     * <pre>
     * obj.on("eventName", function (event) {
     *     // This is the event handler.
     * });
     * </pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is
     * registered for each of those events:</p>
     *
     * <pre>
     * obj.on("eventName1 eventName2",
     *        function (event) {
     *            // This is the event handler.
     *        });
     * </pre>
     *
     * <p>You can also pass in a third <code>context</code> parameter (which is optional) to
     * define the value of <code>this</code> in the handler method:</p>
     *
     * <pre>obj.on("eventName",
     *        function (event) {
     *            // This is the event handler.
     *        },
     *        obj);
     * </pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object
     * that is a hash map of event names and handler functions and the second parameter (optional)
     * is the context for this in each handler:
     * </p>
     * <pre>
     * obj.on(
     *    {
     *       eventName1: function (event) {
     *               // This is the handler for eventName1.
     *           },
     *       eventName2:  function (event) {
     *               // This is the handler for eventName2.
     *           }
     *    },
     *    obj);
     * </pre>
     *
     * <p>
     * If you do not add a handler for an event, the event is ignored locally.
     * </p>
     *
     * @param {String} type The string identifying the type of event. You can specify multiple event
     * names in this string, separating them with a space. The event handler will process each of
     * the events.
     * @param {Function} handler The handler function to process the event. This function takes
     * the event object as a parameter.
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @returns {EventDispatcher} The EventDispatcher object.
     *
     * @memberOf EventDispatcher
     * @method #on
     * @see <a href="#off">off()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
     */ on (eventNames, handlerOrContext, context) {
                        if (typeof eventNames === 'string' && handlerOrContext) eventNames.split(' ').forEach((eventName)=>{
                            ee.on(eventName, weakMemoizeBind(handlerOrContext, context));
                        });
                        else Object.keys(eventNames).forEach((eventName)=>{
                            ee.on(eventName, weakMemoizeBind(eventNames[eventName], handlerOrContext));
                        });
                        return this;
                    },
                    /**
     * Removes an event handler or handlers.
     *
     * <p>If you pass in one event name and a handler method, the handler is removed for that
     * event:</p>
     *
     * <pre>obj.off("eventName", eventHandler);</pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is removed for
     * those events:</p>
     *
     * <pre>obj.off("eventName1 eventName2", eventHandler);</pre>
     *
     * <p>If you pass in an event name (or names) and <i>no</i> handler method, all handlers are
     * removed for those events:</p>
     *
     * <pre>obj.off("event1Name event2Name");</pre>
     *
     * <p>If you pass in no arguments, <i>all</i> event handlers are removed for all events
     * dispatched by the object:</p>
     *
     * <pre>obj.off();</pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object that
     * is a hash map of event names and handler functions and the second parameter (optional) is
     * the context for this in each handler:
     * </p>
     * <pre>
     * obj.off(
     *    {
     *       eventName1: event1Handler,
     *       eventName2: event2Handler
     *    });
     * </pre>
     *
     * @param {String} type (Optional) The string identifying the type of event. You can
     * use a space to specify multiple events, as in "accessAllowed accessDenied
     * accessDialogClosed". If you pass in no <code>type</code> value (or other arguments),
     * all event handlers are removed for the object.
     * @param {Function} handler (Optional) The event handler function to remove. The handler
     * must be the same function object as was passed into <code>on()</code>. Be careful with
     * helpers like <code>bind()</code> that return a new function when called. If you pass in
     * no <code>handler</code>, all event handlers are removed for the specified event
     * <code>type</code>.
     * @param {Object} context (Optional) If you specify a <code>context</code>, the event handler
     * is removed for all specified events and handlers that use the specified context. (The
     * context must match the context passed into <code>on()</code>.)
     *
     * @returns {Object} The object that dispatched the event.
     *
     * @memberOf EventDispatcher
     * @method #off
     * @see <a href="#on">on()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
     */ off (eventNames, handlerOrContext, context) {
                        if (typeof eventNames === 'string') this.off(eventNames.split(' '), handlerOrContext, context);
                        else if (Array.isArray(eventNames)) eventNames.forEach((eventName)=>{
                            if (handlerOrContext && isFunction(handlerOrContext)) ee.removeListener(eventName, weakMemoizeBind(handlerOrContext, context));
                            else ee.removeAllListeners(eventName);
                        });
                        else if (!eventNames) ee.removeAllListeners();
                        else Object.keys(eventNames).forEach((eventName)=>{
                            // @todo was {foo: undefined} expected to remove all foo events?
                            ee.removeListener(eventName, weakMemoizeBind(eventNames[eventName], handlerOrContext));
                        });
                        return this;
                    },
                    /**
     * Adds an event handler function for one or more events. Once the handler is called,
     * the specified handler method is removed as a handler for this event. (When you use
     * the <code>on()</code> method to add an event handler, the handler is <i>not</i>
     * removed when it is called.) The <code>once()</code> method is the equivilent of
     * calling the <code>on()</code>
     * method and calling <code>off()</code> the first time the handler is invoked.
     *
     * <p>
     * The following code adds a one-time event handler for one event:
     * </p>
     *
     * <pre>
     * obj.once("eventName", function (event) {
     *    // This is the event handler.
     * });
     * </pre>
     *
     * <p>If you pass in multiple event names and a handler method, the handler is registered
     * for each of those events:</p>
     *
     * <pre>obj.once("eventName1 eventName2"
     *          function (event) {
     *              // This is the event handler.
     *          });
     * </pre>
     *
     * <p>You can also pass in a third <code>context</code> parameter (which is optional) to define
     * the value of
     * <code>this</code> in the handler method:</p>
     *
     * <pre>obj.once("eventName",
     *          function (event) {
     *              // This is the event handler.
     *          },
     *          obj);
     * </pre>
     *
     * <p>
     * The method also supports an alternate syntax, in which the first parameter is an object that
     * is a hash map of event names and handler functions and the second parameter (optional) is the
     * context for this in each handler:
     * </p>
     * <pre>
     * obj.once(
     *    {
     *       eventName1: function (event) {
     *                  // This is the event handler for eventName1.
     *           },
     *       eventName2:  function (event) {
     *                  // This is the event handler for eventName1.
     *           }
     *    },
     *    obj);
     * </pre>
     *
     * @param {String} type The string identifying the type of event. You can specify multiple
     * event names in this string, separating them with a space. The event handler will process
     * the first occurence of the events. After the first event, the handler is removed (for
     * all specified events).
     * @param {Function} handler The handler function to process the event. This function takes
     * the event object as a parameter.
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @returns {Object} The object that dispatched the event.
     *
     * @memberOf EventDispatcher
     * @method #once
     * @see <a href="#on">on()</a>
     * @see <a href="#off">off()</a>
     * @see <a href="#events">Events</a>
     */ once (eventNames, handlerOrContext, context) {
                        if (typeof eventNames === 'string' && handlerOrContext) eventNames.split(' ').forEach((eventName)=>{
                            ee.once(eventName, weakMemoizeBind(handlerOrContext, context));
                        });
                        else Object.keys(eventNames).forEach((eventName)=>{
                            ee.once(eventName, weakMemoizeBind(eventNames[eventName], handlerOrContext));
                        });
                        return this;
                    },
                    /**
     * Execute any listeners bound to the +event+ Event.
     *
     * Each handler will be executed.
     *
     * @param [Event] event An Event object.
     * @return this
    */ dispatchEvent (event) {
                        if (!event.type) throw new Error('dispatchEvent: Event has no type');
                        if (!event.target) event.target = this; // eslint-disable-line no-param-reassign
                        this.trigger(event.type, event);
                        return this;
                    },
                    /**
     * Execute each handler for the event called +name+.
     *
     * Each handler will be executed, and any exceptions that they throw will
     * be caught and logged
     *
     * @example
     * foo.on('bar', function(name, message) {
     *   alert("Hello " + name + ": " + message);
     * });
     *
     * foo.trigger('OpenTok', 'asdf'); // -> Hello OpenTok: asdf
     *
     * @param {String} eventName The name of this event.
     * @param {Array} arguments The arguments handlers will be called with
     *
     * @return this
     */ trigger (eventName) {
                        try {
                            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                            ee.emit(eventName, ...args);
                        } catch (e) {
                            logging.error('An error occurred in an event handler', e);
                        }
                        return this;
                    },
                    // Alias of trigger for easier node compatibility
                    emit () {
                        return self1.trigger(...arguments);
                    },
                    /**
     * @deprecated use <a href="#on">on()</a> or <a href="#once">once()</a> instead.
     * <p>
     * This method registers a method as an event listener for a specific event.
     * <p>
     *
     * <p>
     *   If a handler is not registered for an event, the event is ignored locally. If the
     *   event listener function does not exist, the event is ignored locally.
     * </p>
     * <p>
     *   Throws an exception if the <code>listener</code> name is invalid.
     * </p>
     *
     * @param {String} type The string identifying the type of event.
     *
     * @param {Function} listener The function to be invoked when the object dispatches the event.
     *
     * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
     * handler function.
     *
     * @memberOf EventDispatcher
     * @method #addEventListener
     * @see <a href="#on">on()</a>
     * @see <a href="#once">once()</a>
     * @see <a href="#events">Events</a>
    */ addEventListener (eventName, handler, context) {
                        logging.warn('The addEventListener() method is deprecated. Use on() or once() instead.');
                        return self1.on(eventName, handler, context);
                    },
                    /**
     * @deprecated use <a href="#off">off()</a> instead.
     * <p>
     * Removes an event listener for a specific event.
     * <p>
     *
     * <p>
     *   Throws an exception if the <code>listener</code> name is invalid.
     * </p>
     *
     * @param {String} type The string identifying the type of event.
     *
     * @param {Function} listener The event listener function to remove.
     *
     * @param {Object} context (Optional) If you specify a <code>context</code>, the event
     * handler is removed for all specified events and event listeners that use the specified
     context. (The context must match the context passed into
     * <code>addEventListener()</code>.)
     *
     * @memberOf EventDispatcher
     * @method #removeEventListener
     * @see <a href="#off">off()</a>
     * @see <a href="#events">Events</a>
     */ // See 'off' for usage.
                    // @depreciated will become a private helper function in the future.
                    removeEventListener (eventName, handler, context) {
                        logging.warn('The removeEventListener() method is deprecated. Use off() instead.');
                        return self1.off(eventName, handler, context);
                    },
                    listenerCount (eventName) {
                        return ee.listenerCount(eventName);
                    }
                };
                return assign(self1, eventingMixin);
            };
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-underscore-dangle */ // The top-level namespace, also performs basic DOMElement selecting.
            //
            // @example Get the DOM element with the id of 'domId'
            //   OTHelpers('#domId')
            //
            // @example Get all video elements
            //   OTHelpers('video')
            //
            // @example Get all elements with the class name of 'foo'
            //   OTHelpers('.foo')
            //
            // @example Get all elements with the class name of 'foo',
            // and do something with the first.
            //   var collection = OTHelpers('.foo');
            //   console.log(collection.first);
            //
            //
            // The second argument is the context, that is document or parent Element, to
            // select from.
            //
            // @example Get a video element within the element with the id of 'domId'
            //   OTHelpers('video', OTHelpers('#domId'))
            //
            //
            //
            // OTHelpers will accept any of the following and return a collection:
            //   OTHelpers()
            //   OTHelpers('css selector', optionalParentNode)
            //   OTHelpers(DomNode)
            //   OTHelpers([array of DomNode])
            //
            // The collection is a ElementCollection object, see the ElementCollection docs for usage info.
            //
            const OTHelpers = __webpack_require__(245);
            const setDeprecatedProperty = __webpack_require__(249);
            const eventing = __webpack_require__(7);
            const log = __webpack_require__(2);
            OTHelpers.logging = log('OT.$');
            OTHelpers.ElementCollection = __webpack_require__(246);
            OTHelpers.env = __webpack_require__(3);
            OTHelpers.ajax = __webpack_require__(244);
            OTHelpers.statable = __webpack_require__(548);
            OTHelpers.Analytics = __webpack_require__(26);
            OTHelpers.Collection = __webpack_require__(248);
            OTHelpers.domExtras = __webpack_require__(549);
            OTHelpers.Error = __webpack_require__(250);
            setDeprecatedProperty(OTHelpers, 'useLogHelpers', {
                value (mixin) {
                    const logging = log('useLogHelpersDeprecatedMixin'); // eslint-disable-next-line no-param-reassign
                    Object.keys(logging).forEach((key)=>{
                        mixin[key] = logging[key];
                    });
                    return mixin;
                },
                name: 'OT.useLogHelpers',
                getWarning: 'Please use an external library for your debugging needs'
            });
            OTHelpers.defaults = __webpack_require__(140);
            setDeprecatedProperty(OTHelpers, 'eventing', {
                value: eventing,
                name: 'OT.$.eventing',
                getWarning: 'Please use an external library to create an event emitter.'
            }); // TODO: Remove the need for this kind of bazzadry.
            Object.keys(OTHelpers).forEach((key)=>{
                const component = OTHelpers[key];
                const attachments = component._attachToOTHelpers || {};
                Object.keys(attachments).forEach((attachmentName)=>{
                    if (Object.hasOwnProperty.call(OTHelpers, attachmentName) && !(key === 'util' && attachmentName === 'bind')) // eslint-disable-next-line no-console
                    console.warn(`More than one module is trying to define ${attachmentName} on OTHelpers.`);
                    OTHelpers[attachmentName] = attachments[attachmentName];
                });
            });
            module1.exports = OTHelpers;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            var assignValue = __webpack_require__(84), copyObject = __webpack_require__(41), createAssigner = __webpack_require__(192), isArrayLike = __webpack_require__(25), isPrototype = __webpack_require__(69), keys = __webpack_require__(30);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var assign = createAssigner(function(object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                    copyObject(source, keys(source), object);
                    return;
                }
                for(var key in source)if (hasOwnProperty1.call(source, key)) assignValue(object, key, source[key]);
            });
            module1.exports = assign;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                JS_EXCEPTION: 2000,
                AUTHENTICATION_ERROR: 1004,
                INVALID_SESSION_ID: 1005,
                CONNECT_FAILED: 1006,
                CONNECT_REJECTED: 1007,
                CONNECTION_TIMEOUT: 1008,
                NOT_CONNECTED: 1010,
                INVALID_PARAMETER: 1011,
                P2P_CONNECTION_FAILED: 1013,
                API_RESPONSE_FAILURE: 1014,
                PEER_CONNECTION_NOT_CONNECTED: 1015,
                TERMS_OF_SERVICE_FAILURE: 1026,
                CONNECTION_LIMIT_EXCEEDED: 1027,
                UNABLE_TO_PUBLISH: 1500,
                UNABLE_TO_SUBSCRIBE: 1501,
                UNSUPPORTED_VIDEO_CODEC: 1502,
                UNABLE_TO_FORCE_DISCONNECT: 1520,
                UNABLE_TO_FORCE_UNPUBLISH: 1530,
                UNABLE_TO_FORCE_MUTE: 1540,
                PUBLISHER_ICE_WORKFLOW_FAILED: 1553,
                SUBSCRIBER_ICE_WORKFLOW_FAILED: 1554,
                STREAM_LIMIT_EXCEEDED: 1605,
                UNEXPECTED_SERVER_RESPONSE: 2001,
                REPORT_ISSUE_ERROR: 2011,
                SET_PROXY_URL_TIMING_ERROR: 2021,
                PROXY_URL_ALREADY_SET_ERROR: 2022,
                GET_RTC_STATS_REPORT_NOT_SUPPORTED: 2031,
                ANVIL_BADLY_FORMED_RESPONSE: 3001,
                ANVIL_INVALID_HTTP_STATUS: 3002,
                ANVIL_XDOMAIN_OR_PARSING_ERROR: 3003,
                ANVIL_UNKNOWN_HTTP_ERROR: 3004,
                ANVIL_UNEXPECTED_ERROR_CODE: 3005,
                ANVIL_EMPTY_RESPONSE_BODY: 3006,
                ANVIL_CONNECT_FAILED: 3007,
                UNABLE_TO_ACCESS_MEDIA_ENGINE: 5001
            };
        /***/ },
        /* 11 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            module1.exports = isObject;
        /***/ },
        /* 12 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
            module1.exports = isArray;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ module1.exports = function otErrorFactory(deps) {
                if (deps === void 0) deps = {};
                const Errors = deps.Errors || __webpack_require__(6);
                const OTErrorClass = deps.OTErrorClass || __webpack_require__(22);
                const names = Object.keys(Errors).map((shortName)=>Errors[shortName]);
                return function otError(name, plainError, code) {
                    if (names.indexOf(name) === -1) return new Error(`Attempt to use invalid error name (${name}). Original message: ${plainError.message}`);
                    if (!(plainError instanceof Error || /^\[object .*Error\]$/.test(Object.prototype.toString.call(plainError)))) return new Error(`Did not pass Error as second argument: ${plainError}`);
                     // OTErrorClass is the deprecated OT.Error class from the docs.
                    const error = new OTErrorClass(undefined, plainError.message);
                    error.name = name;
                    if (!plainError.stack) try {
                        throw plainError;
                    } catch (e) {}
                    error.stack = plainError.stack;
                    if (code) error.code = code;
                    return error;
                };
            };
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            var freeGlobal = __webpack_require__(174);
            /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
            /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
            module1.exports = root;
        /***/ },
        /* 15 */ /***/ function(module1, exports) {
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            module1.exports = _defineProperty;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            var v1 = __webpack_require__(533);
            var v4 = __webpack_require__(534);
            var uuid = v4;
            uuid.v1 = v1;
            uuid.v4 = v4;
            module1.exports = uuid;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isObject = __webpack_require__(11);
            /** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
            /**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
                if (!isObject(value)) return false;
                // The use of `Object#toString` avoids issues with the `typeof` operator
                // in Safari 9 which returns 'object' for typed arrays and other constructors.
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            module1.exports = isFunction;
        /***/ },
        /* 18 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            module1.exports = isObjectLike;
        /***/ },
        /* 19 */ /***/ function(module1, exports) {
            function _extends() {
                module1.exports = _extends = Object.assign || function(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = arguments[i];
                        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            module1.exports = _extends;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var bind = __webpack_require__(208);
            /*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
            var toString = Object.prototype.toString;
            /**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
                return toString.call(val) === '[object Array]';
            }
            /**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
                return typeof val === 'undefined';
            }
            /**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
                return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
            }
            /**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function isArrayBuffer(val) {
                return toString.call(val) === '[object ArrayBuffer]';
            }
            /**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(val) {
                return typeof FormData !== 'undefined' && val instanceof FormData;
            }
            /**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
                var result;
                if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
                else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
                return result;
            }
            /**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
                return typeof val === 'string';
            }
            /**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
                return typeof val === 'number';
            }
            /**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
                return val !== null && typeof val === 'object';
            }
            /**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
                if (toString.call(val) !== '[object Object]') return false;
                var prototype = Object.getPrototypeOf(val);
                return prototype === null || prototype === Object.prototype;
            }
            /**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function isDate(val) {
                return toString.call(val) === '[object Date]';
            }
            /**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function isFile(val) {
                return toString.call(val) === '[object File]';
            }
            /**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function isBlob(val) {
                return toString.call(val) === '[object Blob]';
            }
            /**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
                return toString.call(val) === '[object Function]';
            }
            /**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
                return isObject(val) && isFunction(val.pipe);
            }
            /**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function isURLSearchParams(val) {
                return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
            }
            /**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
                return str.replace(/^\s*/, '').replace(/\s*$/, '');
            }
            /**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
                if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
                return typeof window !== 'undefined' && typeof document !== 'undefined';
            }
            /**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
                // Don't bother if no value provided
                if (obj === null || typeof obj === 'undefined') return;
                // Force an array if not already something iterable
                if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
                    obj
                ];
                if (isArray(obj)) // Iterate over array values
                for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
                else {
                    // Iterate over object keys
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
                }
            }
            /**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
                var result = {};
                function assignValue(val, key) {
                    if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
                    else if (isPlainObject(val)) result[key] = merge({}, val);
                    else if (isArray(val)) result[key] = val.slice();
                    else result[key] = val;
                }
                for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
                return result;
            }
            /**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
                forEach(b, function assignValue(val, key) {
                    if (thisArg && typeof val === 'function') a[key] = bind(val, thisArg);
                    else a[key] = val;
                });
                return a;
            }
            /**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
                if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
                return content;
            }
            module1.exports = {
                isArray: isArray,
                isArrayBuffer: isArrayBuffer,
                isBuffer: isBuffer,
                isFormData: isFormData,
                isArrayBufferView: isArrayBufferView,
                isString: isString,
                isNumber: isNumber,
                isObject: isObject,
                isPlainObject: isPlainObject,
                isUndefined: isUndefined,
                isDate: isDate,
                isFile: isFile,
                isBlob: isBlob,
                isFunction: isFunction,
                isStream: isStream,
                isURLSearchParams: isURLSearchParams,
                isStandardBrowserEnv: isStandardBrowserEnv,
                forEach: forEach,
                merge: merge,
                extend: extend,
                trim: trim,
                stripBOM: stripBOM
            };
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // TODO: Eliminate the need for this module, which is globally tracking these objects.
            const Collection = __webpack_require__(248);
            const sessionObjects = {
                // Publishers are id'd by their guid
                publishers: new Collection('guid'),
                // Subscribers are id'd by their widgetId
                subscribers: new Collection('widgetId'),
                sessions: new Collection()
            };
            module1.exports = sessionObjects;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign */ const logging = __webpack_require__(2)('GlobalExceptionHandler');
            const eventing = __webpack_require__(7);
            const eventNames = __webpack_require__(27);
            const errorCodeToErrorTitleMap = __webpack_require__(547);
            const Events = __webpack_require__(23)();
            /**
 * The Error class is used to define the error object passed into completion handlers.
 * Each of the following methods, which execute asynchronously, includes a
 * <code>completionHandler</code> parameter:
 *
 * <ul>
 *   <li><a href="OT.html#initPublisher">OT.initPublisher()</a></li>
 *   <li><a href="OT.html#reportIssue">OT.reportIssue()</a></li>
 *   <li><a href="OT.html#setProxyUrl">OT.setProxyUrl()</a></li>
 *   <li><a href="Publisher.html#setVideoSource">Publisher.setVideoSource()</a></li>
 *   <li><a href="Session.html#connect">Session.connect()</a></li>
 *   <li><a href="Session.html#forceDisconnect">Session.forceDisconnect()</a></li>
 *   <li><a href="Session.html#forceUnpublish">Session.forceUnpublish()</a></li>
 *   <li><a href="Session.html#publish">Session.publish()</a></li>
 *   <li><a href="Session.html#subscribe">Session.subscribe()</a></li>
 *   <li><a href="Subscriber.html#getStats">Subscriber.getStats()</a></li>
 * </ul>
 *
 * <p>
 * The Error class also defines the Error thrown when the promise returned by one of
 * the following methods is rejected:
 *
 * <ul>
 *   <li><a href="OT.html#unblockAudio">OT.unblockAudio()</a></li>
 *   <li><a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a></li>
 *   <li><a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a></li>
 *   <li><a href="Publisher.html#getRtcStatsReport">Publisher.getRtcStatsReport()</a></li>
 *   <li><a href="Session.html#forceMuteAll">Session.forceMuteAll()</a></li>
 *   <li><a href="Session.html#forceMuteStream">Session.forceMuteStream()</a></li>
 *   <li><a href="Subscriber.html#getRtcStatsReport">Subscriber.getRtcStatsReport()</a></li>
 * </ul>
 *
 * <p>
 * The <code>completionHandler</code> parameter is a function that is called when the call to
 * the asynchronous method succeeds or fails. If the asynchronous call fails, the completion
 * handler function is passed an error object (defined by the Error class). The <code>code</code>
 * and <code>message</code> properties of the error object provide details about the error.
 *
 * <p>
 * <b>Deprecation notice:</b>
 * <code>OT.Error</code> will not be defined in an upcoming version of OpenTok. When this happens,
 * errors emitted by the SDK will simply be instances of standard <code>Error</code> objects.
 * If your code currently checks <code>if (error instanceof OT.Error)</code> please replace it
 * <code>if (/^OT_/.test(error.name))</code>. (The <code>name</code> property for all OpenTok
 * errors with begins with <code>'OT_'</code>.) Note however that this code is for the
 * purposes of smoothly upgrading, and it may be more appropriate for your code to simply compare
 * against the specific error you want to handle, such as
 * <code>if (error.name === 'OT_USER_MEDIA_ACCESS_DENIED')</code>.
 *
 * @property {Number} code Deprecated &mdash; the error code. Use the <code>name</code> property,
 * not the <code>code</code> property, to identify the error programatically.
 *
 * <p>
 *   The <code>code</code> property of the Error object can be set to one of the values
 *   listed below. This property can also be set to other values, and you may want to report
 *   this value when discussing an issue with Vonage API support.
 * </p>
 *
 * <p>Errors when calling <code>Session.connect()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1004</td>
 *   <td>Authentication error. Check the error message for details. This error can result if you
 *     pass in an expired token when trying to connect to a session. It can also occur if you pass
 *     in an invalid token or API key. Make sure that you are generating the token using the
 *     current version of one of the
 *     <a href="http://tokbox.com/opentok/libraries/server">OpenTok server SDKs</a>.</td>
 * </tr>
 * <tr>
 *   <td>1005</td>
 *   <td>Invalid Session ID. Make sure you generate the session ID using the current version of
 *     one of the <a href="http://tokbox.com/opentok/libraries/server">OpenTok server
 *     SDKs</a>.</td>
 * </tr>
 * <tr>
 *   <td>1006</td>
 *   <td>Connect Failed. Unable to connect to the session. You may want to have the client check
 *     the network connection.</td>
 * </tr>
 * <tr>
 *  <td>1026</td>
 *  <td>Terms of service violation: export compliance. See the
 *    <a href="https://tokbox.com/support/tos">Terms of Service</a>.</td>
 * </tr>
 * <tr>
 *  <td>1027</td>
 *  <td>Connection limit exceeded. The client tried to connect to a session that has exceeded
 *  limit for simultaneous connections.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Connect Failed. Unexpected response from the OpenTok server. Try connecting again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors after calling <code>Session.connect()</code>:</p>
 * <table class="docs_table"><tbody>
 *   <tr>
 *     <td><b><code>code</code></b></td>
 *     <td><b>Description</b></td>
 *   </tr>
 *   <tr>
 *     <td>3001 - 3007</td>
 *     <td>Please check error name OT_HTTP_ERROR.</td>
 *   </tr>
 *   <tr>
 *     <td>4020</td>
 *     <td>Session disconnected. It seems internet connection went down.</td>
 *   </tr>
 * </tbody></table>
 * <p>Errors when calling <code>Session.forceDisconnect()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b>
 *       <code>code</code>
 *     </b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the OpenTok session. Check that client connects
 *     successfully and has not disconnected before calling forceDisconnect().</td>
 * </tr>
 * <tr>
 *   <td>1520</td>
 *   <td>Unable to force disconnect. The client's token does not have the role set to moderator.
 *     Once the client has connected to the session, the <code>capabilities</code> property of
 *     the Session object lists the client's capabilities.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.forceUnpublish()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the OpenTok session. Check that client connects
 *     successfully and has not disconnected before calling forceUnpublish().</td>
 * </tr>
 * <tr>
 *   <td>1530</td>
 *   <td>Unable to force unpublish. The client's token does not have the role set to moderator.
 *     Once the client has connected to the session, the <code>capabilities</code> property of
 *     the Session object lists the client's capabilities.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.publish()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1010</td>
 *   <td>The client is not connected to the OpenTok session. Check that the client connects
 *     successfully before trying to publish. And check that the client has not disconnected
 *     before trying to publish.</td>
 * </tr>
 * <tr>
 *   <td>1500</td>
 *   <td>Unable to Publish. This can be caused by the following:
 *
 *   <ul>
 *     <li>The client's token does not have the role set to publish or
 *     moderator. Once the client has connected to the session, the <code>capabilities</code>
 *     property of the Session object lists the client's capabilities.</li>
 *
 *     <li>The end-user has denied access to the camera or microphone.</li>
 *
 *     <li>The page is loaded on HTTP in Chrome, which requires HTTPS to access the camera and
 *     microphone.</li>
 *   </ul>
 * </td>
 * </tr>
 * <tr>
 *   <td>1553</td>
 *   <td>WebRTC ICE workflow error. This is an error that occurs when trying to establish
 *   communication between clients in the session. Try publishing again or reconnecting to
 *   the session.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Publish Failed. Unexpected response from the OpenTok server. Try publishing again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.signal()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *     <td>400</td>
 *     <td>One of the signal properties &mdash; data, type, or to &mdash;
 *                 is invalid. Or the data cannot be parsed as JSON.</td>
 * </tr>
 * <tr>
 *   <td>404</td> <td>The to connection does not exist.</td>
 * </tr>
 * <tr>
 *   <td>413</td> <td>The type string exceeds the maximum length (128 bytes),
 *     or the data string exceeds the maximum size (8 kB).</td>
 * </tr>
 * <tr>
 *   <td>500</td>
 *   <td>The client is not connected to the OpenTok session. Check that the client connects
 *     successfully before trying to signal. And check that the client has not disconnected before
 *     trying to signal.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Signal Failed. Unexpected response from the OpenTok server. Try sending the signal again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Session.subscribe()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b>
 *       <code>code</code>
 *     </b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *  <td>0009</td>
 *  <td>Media source not supported.</td>
 * </tr>
 * <tr>
 *   <td>0011</td>
 *   <td>Error decoding.</td>
 * </tr>
 * <tr>
 *   <td>1013</td>
 *   <td>WebRTC PeerConnection error. Try republishing the stream,
 *     resubscribing to the stream, or reconnecting to the session.</td>
 * </tr>
 * <tr>
 *  <td>1501</td>
 *  <td>Unable to subscribe to stream in a reasonable amount of time.</td>
 * </tr>
 * <tr>
 *  <td>1502</td>
 *  <td>Video format not supported in this browser.</td>
 * </tr>
 * <tr>
 *   <td>1554</td>
 *   <td>WebRTC ICE workflow error. This is an error that occurs when trying to establish
 *   communication between clients in the session. Try resubscribing to the stream or
 *   reconnecting to the session.</td>
 * </tr>
 * <tr>
 *   <td>1600</td>
 *   <td>Internal error -- WebRTC subscriber error. Try resubscribing to the stream or
 *     reconnecting to the session.</td>
 * </tr>
 * <tr>
 *  <td>1605</td>
 *  <td>Stream limit exceeded. The client tried to subscribe to a stream in a session
 *  that has exceeded the limit for simultaneous streams.</td>
 * </tr>
 * <tr>
 *   <td>2001</td>
 *   <td>Subscribe Failed. Unexpected response from the OpenTok server. Try subscribing again
 *     later.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.initPublisher()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1004</td>
 *   <td>Authentication error. Check the error message for details. This error can result if you
 *     pass in an expired token when trying to connect to a session. It can also occur if you
 *     pass in an invalid token or API key. Make sure that you are generating the token using
 *     the current version of one of the
 *     <a href="http://tokbox.com/opentok/libraries/server">OpenTok server SDKs</a>.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.reportIssue()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>2011</td>
 *   <td>Error calling OT.reportIssue(). Check the client's network connection.</td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>OT.setProxyUrl()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     2021
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after initiating a Session or Publisher object.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     2022
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after it has already been set (by a previous
 *     call to <code>OT.setProxyUrl()</code>).
 *  </td>
 * </tr>
 * </tbody></table>
 *
 * <p>Errors when calling <code>Publisher.setVideoSource()</code>:</p>
 *
 * <table class="docs_table"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     1040
 *   </td>
 *   <td>
 *    Trying to change the video source for a publisher does not use a camera input.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     1041
 *   </td>
 *   <td>
 *    The <code>videoSourceId</code> parameter is not a string
 *    or the device ID for a valid video input device.
 *  </td>
 * </tr>
 * </tbody></table>
 *
 * <p>General errors that can occur when calling any method:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>code</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>1011</td>
 *   <td>Invalid Parameter. Check that you have passed valid parameter values into the method
 *     call.</td>
 * </tr>
 * <tr>
 *   <td>2000</td>
 *   <td>Internal Error. Try reconnecting to the OpenTok session and trying the action again.</td>
 * </tr>
 * </tbody></table>
 *
 * @property {String} message The message string provides details about the error.
 *
 * <p>
 * Use the <code>name</code> property (not the <code>message</code> property) to identify the error
 * programatically.
 *
 * @property {String} name A string identifying the error. Use this property (not the
 * <code>code</code> property) to identify the error.
 *
 * <p>Note that for all errors, this string starts with <code>'OT_'</code>.
 *
 * <p>
 *   The <code>name</code> property of the Error object can be set to one of the values
 *   listed below. For unexpected errors, this property can be undefined or set to other
 *   values. You may want to report this value when discussing an issue with Vonage API support.
 * </p>
 *
 * <p>Errors that can occur when calling <code>OT.initPublisher()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HARDWARE_UNAVAILABLE'</code></td>
 *   <td>The hardware to fulfill the user media request appears to exist but could not be acquired.
 *   It might be in use by another application.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *  <td><code>'OT_MEDIA_ENDED'</code></td>
 *  <td>The ended event on the video element fired.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_SUPPORTED'</code></td>
 *   <td>Something in the user media request is not supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_DEVICES_FOUND'</code></td>
 *   <td>No devices were found to provide the media stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_VALID_CONSTRAINTS'</code></td>
 *   <td>Video and audio were both disabled. You need to enable at least one.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PROXY_URL_ALREADY_SET_ERROR'</code></td>
 *   <td>The proxyUrl has already been set. Setting it again will not have any effect.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_REQUESTED_DEVICE_PERMISSION_DENIED'</code></td>
 *   <td>The requested audio device does not have permissions to be used.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_NOT_SUPPORTED'</code></td>
 *   <td>Screen sharing is not supported in the browser.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_CAPTURE_SCREEN'</code></td>
 *   <td>Screen sharing is not supported (and you set the <code>videoSource</code> property
 *     of the <code>options</code> parameter of <code>OT.initPublisher()</code> to
 *     <code>"application"</code>, <code>"screen"</code>, or <code>"window"</code>).
 *     Before calling <code>OT.initPublisher()</code>, you can call
 *     <a href="OT.html#checkScreenSharingCapability">OT.checkScreenSharingCapability()</a>
 *     to check if screen sharing is supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but one has not been
 *   registered.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but the extension is not
 *   installed.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>OT.reportIssue()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_REPORT_ISSUE_FAILED'</code></td>
 *   <td>Error calling OT.reportIssue(). Check the client\'s network connection.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling the <code>OT.setProxyUrl()</code> method:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td>
 *     <code>'SET_PROXY_URL_TIMING_ERROR'</code>
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after initiating a Session or Publisher object.
 *  </td>
 * </tr>
 * <tr>
 *   <td>
 *     <code>'PROXY_URL_ALREADY_SET_ERROR'</code>
 *   </td>
 *   <td>
 *     Attempt to set the proxy URL after it has already been set (by a previous
 *     call to <code>OT.setProxyUrl()</code>).
 *  </td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Publisher.setVideoSource()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_VIDEO_SOURCE'</code></td>
 *   <td>The <code>videoSourceId</code> parameter is not a string
 *   or the device ID for a valid video input device.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_VIDEO_SOURCE_FAILURE'</code></td>
 *   <td>Trying to change the video source for a publisher does not use
 *   a camera input.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.connect()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_AUTHENTICATION_ERROR'</code></td>
 *   <td>The API key does not match the token or session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_BADLY_FORMED_RESPONSE'</code></td>
 *   <td>The JSON response from the OpenTok server was badly formed.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONNECT_FAILED'</code></td>
 *   <td>Failed to connect to session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONNECTION_LIMIT_EXCEEDED'</code></td>
 *   <td>The client tried to connect to a session that has exceeded the limit for
 *   simultaneous connections.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_EMPTY_RESPONSE_BODY'</code></td>
 *   <td>Received an unexpected empty response from the OpenTok server.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_SESSION_ID'</code></td>
 *   <td>The session ID was invalid.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_TERMS_OF_SERVICE_FAILURE'</code></td>
 *   <td>Couldn't connect due to a terms of service violation.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_HTTP_STATUS'</code></td>
 *   <td>Received an unexpected HTTP status.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_XDOMAIN_OR_PARSING_ERROR'</code></td>
 *   <td>There was a cross domain error or the server responded with invalid JSON.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceDisconnect()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceMuteAll()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>An internal server error.</li>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceMuteStream()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_FOUND'</code></td>
 *   <td>The stream ID wasn't found in this session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>The token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>An internal server error.</li>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.forceUnpublish()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow this action. The role must be at least moderator.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.publish()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CHROME_MICROPHONE_ACQUISITION_ERROR'</code></td>
 *   <td>Chrome fails to get access to the microphone, due to a Chrome error. To work
 *   around this issue, the end-user must restart Chrome and reload your site. This is a
 *   <a href="https://bugs.chromium.org/p/webrtc/issues/detail?id=4799">known issue</a>
 *   to be fixed in Chrome.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CONSTRAINTS_NOT_SATISFIED'</code></td>
 *   <td>The constraints for getting user media could not be satisfied.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CREATE_PEER_CONNECTION_FAILED'</code></td>
 *   <td>Failed to create a connection between this client and the subscriber or the
 *   OpenTok Media Router.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HARDWARE_UNAVAILABLE'</code></td>
 *   <td>The hardware to fulfill the user media request appears to exist but could not be acquired.
 *   It might be in use by another application.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_ICE_WORKFLOW_FAILED'</code></td>
 *   <td>Something went wrong while establishing WebRTC connectivity.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_AUDIO_OUTPUT_SOURCE'</code></td>
 *   <td>Invalid output audio device ID. It must be a valid video output device ID.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_DEVICES_FOUND'</code></td>
 *   <td>No devices were found to provide the media stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NO_VALID_CONSTRAINTS'</code></td>
 *   <td>Video and audio were both disabled. You need to enable at least one.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_SUPPORTED'</code></td>
 *   <td>Something in the user media request is not supported.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PERMISSION_DENIED'</code></td>
 *   <td>This token does not allow publishing. The role must be at least publisher to enable
 *   this funcitonality.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_NOT_SUPPORTED'</code></td>
 *   <td>Screen sharing is not supported in the browser.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but one has not been
 *   registered.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED'</code></td>
 *   <td>Screen-sharing support in this browser requires an extension, but the extension is not
 *   installed.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_REMOTE_DESCRIPTION_FAILED'</code></td>
 *   <td>The WebRTC connection failed during setDescription.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_CREATE_FAILED'</code></td>
 *   <td>Failed to create the stream in the server model.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_TIMEOUT'</code></td>
 *   <td>Could not publish in a reasonable amount of time.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_USER_MEDIA_ACCESS_DENIED'</code></td>
 *   <td>The end-user denied permission to access hardware devices, or the end-user
 *   denied access to the screen (for a screen-sharing stream).</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_CAPTURE_MEDIA'</code></td>
 *   <td>Unable to capture media. Unknown error occurred.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code></td>
 *   <td>This indicates an unexpected error from the OpenTok server.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.signal()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_FOUND'</code></td>
 *   <td>A resource was not found.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_RATE_LIMIT_EXCEEDED'</code></td>
 *   <td>The signal could not be sent due to the rate limit.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Session.subscribe()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_CREATE_PEER_CONNECTION_FAILED'</code></td>
 *   <td>Failed to create a connection between this client and the stream's publisher or the
 *   OpenTok Media Router.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_DISCONNECTED'</code></td>
 *   <td>Action failed because the client is not connected to the session.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_INVALID_PARAMETER'</code></td>
 *   <td>One or more parameters was not valid or not provided.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_ICE_WORKFLOW_FAILED'</code></td>
 *   <td>Something went wrong while establishing WebRTC connectivity.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of the stream for the video element has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play the stream in the video element.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused the stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>The stream has been detected to be not suitable for playback.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_SET_REMOTE_DESCRIPTION_FAILED'</code></td>
 *   <td>The WebRTC connection failed during setDescription.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_DESTROYED'</code></td>
 *   <td>The stream was destroyed before it could be subscribed to.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_LIMIT_EXCEEDED'</code></td>
 *   <td>The client tried to subscribe to a stream in a session that has exceeded the limit
 *   for simultaneous streams.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_STREAM_NOT_FOUND'</code></td>
 *   <td>Couldn't subscribe to the stream because it was not found.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_UNABLE_TO_SUBSCRIBE'</code></td>
 *   <td>Couldn't subscribe to stream due to unexpected error.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when calling <code>Subscriber.getStats()</code>:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_HTTP_ERROR'</code></td>
 *   <td>Action failed. Received invalid response from the OpenTok server.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_NOT_CONNECTED'</code></td>
 *   <td>Couldn't perform action because you are not connected to the network.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when the Promise returned by the <code>OT.unblockAudio()</code>
 * method is rejected:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_ABORTED'</code></td>
 *   <td>The fetching of an audio stream has been aborted.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_NETWORK'</code></td>
 *   <td>A network error caused a stream to stop being fetched.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_DECODE'</code></td>
 *   <td>A decoding error occurred while trying to play a stream.</td>
 * </tr>
 * <tr>
 *   <td><code>'OT_MEDIA_ERR_SRC_NOT_SUPPORTED'</code></td>
 *   <td>A stream has been detected to be not suitable for playback.</td>
 * </tr>
 * </table>
 *
 * <p>Errors that can occur when the Promise returned by the
 * <code>Publisher.getRtcStatsReport()</code> or
 * <code>Subscriber.getRtcStatsReport()</code> method is rejected:</p>
 *
 * <table class="docs_table" style="width:100%"><tbody>
 * <tr>
 *   <td><b><code>name</code></b></td>
 *   <td><b>Description</b></td>
 * </tr>
 * <tr>
 *   <td><code>'OT_PEER_CONNECTION_NOT_CONNECTED'</code></td>
 *   <td>
 *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
 *     PeerConnection</a> for the Publisher or Subscriber is not connected.
 *   </td>
 * </tr>
 * <tr>
 *   <td><code>'OT_GET_RTC_STATS_REPORT_NOT_SUPPORTED'</code></td>
 *   <td>
 *     The browser does not support this method (for example, in Chrome version 57 and lower, which
 *     does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
 *     RTCPeerConnection.getStats()</a> standard).
 *   </td>
 * </tr>
 * </table>
 *
 * @class Error
 * @augments Event
 */ const OTErrorClass = function OTErrorClass(code, message) {
                Error.call(this);
                this.code = code;
                this.message = message;
            };
            OTErrorClass.prototype = Object.create(Error.prototype);
            OTErrorClass.prototype.constructor = OTErrorClass;
            module1.exports = OTErrorClass;
            eventing(OTErrorClass);
            /**
 * Get the title of an error by error code
 *
 * @property {Number|String} code The error code to lookup
 * @return {String} The title of the message with that code
 *
 * @example
 *
 * OTError.getTitleByCode(1006) === 'Connect Failed'
 */ OTErrorClass.getTitleByCode = function(code) {
                return errorCodeToErrorTitleMap[+code];
            }; // @todo redo this when we have time to tidy up
            //
            // @example
            //
            //  OTError.handleJsException("Descriptive error message", 2000, {
            //      session: session,
            //      target: stream|publisher|subscriber|session|etc
            //  });
            //
            OTErrorClass.handleJsException = (_ref)=>{
                let error = _ref.error, errorMsg = _ref.errorMsg, code = _ref.code, target = _ref.target, analytics = _ref.analytics;
                if (!target) throw new Error('handleJsException requires target');
                const getCode = ()=>code !== undefined ? code : error && error.code;
                const getMessage = ()=>errorMsg !== undefined ? errorMsg : error && error.message;
                const title = OTErrorClass.getTitleByCode(getCode());
                logging.error(`OT.exception :: title: ${title} (${getCode()}) msg: ${getMessage()}`);
                try {
                    const options = {
                        partnerId: target.session ? target.session.apiKey : target.apiKey,
                        sessionId: target.session ? target.session.sessionId : target.sessionId
                    };
                    analytics.logError(getCode(), 'tb.exception', title, {
                        details: getMessage()
                    }, options);
                    const event = new Events.ExceptionEvent(eventNames.EXCEPTION, getMessage(), title, getCode(), target, target, error);
                    if (error) event.stack = error.stack;
                    else // Augment the event object with a stacktrace for error reporting purposes
                    try {
                        throw new Error();
                    } catch (caughtError) {
                        event.stack = caughtError.stack;
                    }
                    OTErrorClass.dispatchEvent(event);
                } catch (err) {
                    logging.error(`OT.exception :: Failed to dispatch exception - ${err.toString()}`); // Don't throw an error because this is asynchronous
                // don't do an exceptionHandler because that would be recursive
                }
            };
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require, max-len */ const Event1 = __webpack_require__(126);
            const eventNames = __webpack_require__(27);
            module1.exports = function EventsFactory(deps) {
                if (deps === void 0) deps = {};
                const logging = deps.logging || __webpack_require__(2)('Events');
                const Events = {};
                /**
   * The Event object defines the basic OpenTok event object that is passed to
   * event listeners. Other OpenTok event classes implement the properties and methods of
   * the Event object.</p>
   *
   * <p>For example, the Stream object dispatches a <code>streamPropertyChanged</code> event when
   * the stream's properties are updated. You add a callback for an event using the
   * <code>on()</code> method of the Stream object:</p>
   *
   * <pre>
   * stream.on("streamPropertyChanged", function (event) {
   *     alert("Properties changed for stream " + event.target.streamId);
   * });</pre>
   *
   * @class Event
   * @property {Boolean} cancelable Whether the event has a default behavior that is cancelable
   * (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the Event object in the callback
   * function. (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {Object} target The object that dispatched the event.
   *
   * @property {String} type  The type of event.
   */ /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>To see whether an event has a default behavior, check the <code>cancelable</code> property
  * of the event object. </p>
  *
  * <p>Call the <code>preventDefault()</code> method in the callback function for the event.</p>
  *
  * <p>The following events have default behaviors:</p>
  *
  * <ul>
  *
  *   <li><code>sessionDisconnect</code> &#151; See
  *   <a href="SessionDisconnectEvent.html#preventDefault">
  *   SessionDisconnectEvent.preventDefault()</a>.</li>
  *
  *   <li><code>streamDestroyed</code> &#151; See <a href="StreamEvent.html#preventDefault">
  *   StreamEvent.preventDefault()</a>.</li>
  *
  *   <li><code>accessDialogOpened</code> &#151; See the
  *   <a href="Publisher.html#event:accessDialogOpened">accessDialogOpened event</a>.</li>
  *
  *   <li><code>accessDenied</code> &#151; See the <a href="Publisher.html#event:accessDenied">
  *   accessDenied event</a>.</li>
  *
  * </ul>
  *
  * @method #preventDefault
  * @memberof Event
  */ /**
  * Whether the default event behavior has been prevented via a call to
  * <code>preventDefault()</code> (<code>true</code>) or not (<code>false</code>).
  * See <a href="#preventDefault">preventDefault()</a>.
  * @method #isDefaultPrevented
  * @return {Boolean}
  * @memberof Event
  */ /**
  * The {@link OT} class dispatches <code>exception</code> events when the OpenTok API encounters
  * an exception (error). The ExceptionEvent object defines the properties of the event
  * object that is dispatched.
  *
  * <p>Note that you set up a callback for the <code>exception</code> event by calling the
  * <code>OT.on()</code> method.</p>
  *
  * @class ExceptionEvent
  * @property {Number} code The error code. The following is a list of error codes:</p>
  *
  * <table class="docs_table">
  *  <tbody><tr>
  *   <td>
  *   <b>code</b>
  *
  *   </td>
  *   <td>
  *   <b>title</b>
  *   </td>
  *  </tr>
  *
  *  <tr>
  *   <td>
  *   1004
  *
  *   </td>
  *   <td>
  *   Authentication error
  *   </td>
  *  </tr>
  *
  *  <tr>
  *   <td>
  *   1005
  *
  *   </td>
  *   <td>
  *   Invalid Session ID
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1006
  *
  *   </td>
  *   <td>
  *   Connect Failed
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1007
  *
  *   </td>
  *   <td>
  *   Connect Rejected
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1008
  *
  *   </td>
  *   <td>
  *   Connect Time-out
  *   </td>
  *  </tr>
  *  <tr>
  *   <td>
  *   1009
  *
  *   </td>
  *   <td>
  *   Security Error
  *   </td>
  *  </tr>
  *   <tr>
  *    <td>
  *    1010
  *
  *    </td>
  *    <td>
  *    Not Connected
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1011
  *
  *    </td>
  *    <td>
  *    Invalid Parameter
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1013
  *    </td>
  *    <td>
  *    Connection Failed
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1014
  *    </td>
  *    <td>
  *    API Response Failure
  *    </td>
  *   </tr>
  *   <tr>
  *    <td>
  *    1026
  *    </td>
  *    <td>
  *    Terms of Service Violation: Export Compliance
  *    </td>
  *   </tr>
  *  <tr>
  *    <td>
  *    1500
  *    </td>
  *    <td>
  *    Unable to Publish
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    1520
  *    </td>
  *    <td>
  *    Unable to Force Disconnect
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    1530
  *    </td>
  *    <td>
  *    Unable to Force Unpublish
  *    </td>
  *   </tr>
  *  <tr>
  *    <td>
  *    1535
  *    </td>
  *    <td>
  *    Force Unpublish on Invalid Stream
  *    </td>
  *   </tr>
  *
  *  <tr>
  *    <td>
  *    2000
  *
  *    </td>
  *    <td>
  *    Internal Error
  *    </td>
  *  </tr>
  *
  *  <tr>
  *    <td>
  *    2010
  *
  *    </td>
  *    <td>
  *    Report Issue Failure
  *    </td>
  *  </tr>
  *
  *
  *  </tbody></table>
  *
  *  <p>Check the <code>message</code> property for more details about the error.</p>
  *
  * @property {String} message The error message.
  *
  * @property {Object} target The object that the event pertains to. For an
  * <code>exception</code> event, this will be an object other than the OT object
  * (such as a Session object or a Publisher object).
  *
  * @property {String} title The error title.
  * @augments Event
  */ Events.ExceptionEvent = function ExceptionEvent(type, message, title, code, component, target, error) {
                    return new Event1(type, false, {
                        error: error,
                        message: message,
                        title: title,
                        code: code,
                        component: component,
                        target: target
                    });
                };
                Events.IssueReportedEvent = function IssueReportedEvent(type, issueId) {
                    return new Event1(type, false, {
                        issueId: issueId
                    });
                }; // Triggered when the JS dynamic config and the DOM have loaded.
                Events.EnvLoadedEvent = function EnvLoadedEvent(type) {
                    return new Event1(type, false);
                };
                /**
   * Defines <code>connectionCreated</code> and <code>connectionDestroyed</code> events dispatched
   * by the {@link Session} object.
   * <p>
   * The Session object dispatches a <code>connectionCreated</code> event when a client (including
   * your own) connects to a Session. It also dispatches a <code>connectionCreated</code> event for
   * every client in the session when you first connect. (when your local client connects, the
   * Session object also dispatches a <code>sessionConnected</code> event, defined by the
   * {@link SessionConnectEvent} class.)
   * <p>
   * While you are connected to the session, the Session object dispatches a
   * <code>connectionDestroyed</code> event when another client disconnects from the Session.
   * (When you disconnect, the Session object also dispatches a <code>sessionDisconnected</code>
   * event, defined by the {@link SessionDisconnectEvent} class.)
   *
   * <h5><a name="example"></a>Example</h5>
   *
   * <p>The following code keeps a running total of the number of connections to a session
   * by monitoring the <code>connections</code> property of the <code>sessionConnect</code>,
   * <code>connectionCreated</code> and <code>connectionDestroyed</code> events:</p>
   *
   * <pre>var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
   * var sessionID = ""; // Replace with your own session ID.
   *                     // See https://tokbox.com/developer/guides/create-session/.
   * var token = ""; // Replace with a generated token that has been assigned the moderator role.
   *                 // See https://tokbox.com/developer/guides/create-token/.
   * var connectionCount = 0;
   *
   * var session = OT.initSession(apiKey, sessionID);
   * session.on("connectionCreated", function(event) {
   *    connectionCount++;
   *    displayConnectionCount();
   * });
   * session.on("connectionDestroyed", function(event) {
   *    connectionCount--;
   *    displayConnectionCount();
   * });
   * session.connect(token);
   *
   * function displayConnectionCount() {
   *     document.getElementById("connectionCountField").value = connectionCount.toString();
   * }</pre>
   *
   * <p>This example assumes that there is an input text field in the HTML DOM
   * with the <code>id</code> set to <code>"connectionCountField"</code>:</p>
   *
   * <pre>&lt;input type="text" id="connectionCountField" value="0"&gt;&lt;/input&gt;</pre>
   *
   *
   * @property {Connection} connection A Connection object for the connection that was
   * created or deleted.
   *
   * @property {Array} connections Deprecated. Use the <code>connection</code> property. A
   * <code>connectionCreated</code> or <code>connectionDestroyed</code> event is dispatched
   * for each connection created and destroyed in the session.
   *
   * @property {String} reason For a <code>connectionDestroyed</code> event,
   *  a description of why the connection ended. This property can have the following values:
   * </p>
   * <ul>
   *  <li><code>"clientDisconnected"</code> &#151; A client disconnected from the session by calling
   *     the <code>disconnect()</code> method of the Session object or by closing the browser.
   *     (See <a href="Session.html#disconnect">Session.disconnect()</a>.)</li>
   *
   *  <li><code>"forceDisconnected"</code> &#151; A moderator has disconnected the publisher
   *      from the session, by calling the <code>forceDisconnect()</code> method of the Session
   *      object. (See <a href="Session.html#forceDisconnect">Session.forceDisconnect()</a>.)</li>
   *
   *  <li><code>"networkDisconnected"</code> &#151; The network connection terminated abruptly
   *      (for example, the client lost their internet connection).</li>
   * </ul>
   *
   * <p>Depending on the context, this description may allow the developer to refine
   * the course of action they take in response to an event.</p>
   *
   * <p>For a <code>connectionCreated</code> event, this string is undefined.</p>
   *
   * @class ConnectionEvent
   * @augments Event
   */ let connectionEventPluralDeprecationWarningShown = false;
                Events.ConnectionEvent = /*#__PURE__*/ function(_Event) {
                    (0, _inheritsLoose2.default)(ConnectionEvent, _Event);
                    function ConnectionEvent(type, connection, reason) {
                        return _Event.call(this, type, false, {
                            connection: connection,
                            reason: reason
                        }) || this;
                    }
                    (0, _createClass2.default)(ConnectionEvent, [
                        {
                            key: "connections",
                            get: function get() {
                                if (!connectionEventPluralDeprecationWarningShown) {
                                    logging.warn("OT.ConnectionEvent connections property is deprecated, use connection instead.");
                                    connectionEventPluralDeprecationWarningShown = true;
                                }
                                return [
                                    this.connection
                                ];
                            }
                        }
                    ]);
                    return ConnectionEvent;
                }(Event1);
                /**
   * StreamEvent is an event that can have the type "streamCreated" or "streamDestroyed".
   * These events are dispatched by the Session object when another client starts or
   * stops publishing a stream to a {@link Session}. For a local client's stream, the
   * Publisher object dispatches the event.
   *
   * <h4><a name="example_streamCreated"></a>Example &#151; streamCreated event dispatched
   * by the Session object</h4>
   *  <p>The following code connects to a session and sets up an event listener for when
   *    a stream published by another client is created:</p>
   *
   * <pre>
   * session.on("streamCreated", function(event) {
   *   subscriber = session.subscribe(event.stream, targetElement);
   * }).connect(token);
   * </pre>
   *
   *  <h4><a name="example_streamDestroyed"></a>Example &#151; streamDestroyed event dispatched
   * by the Session object</h4>
   *
   *    <p>The following code connects to a session and sets up an event listener for when
   *       other clients' streams end:</p>
   *
   * <pre>
   * session.on("streamDestroyed", function(event) {
   *     console.log("Stream " + event.stream.name + " ended. " + event.reason);
   * }).connect(token);
   * </pre>
   *
   * <h4><a name="example_streamCreated_publisher"></a>Example &#151; streamCreated event dispatched
   * by a Publisher object</h4>
   *  <p>The following code publishes a stream and adds an event listener for when the streaming
   * starts</p>
   *
   * <pre>
   * var publisher = session.publish(targetElement)
   *   .on("streamCreated", function(event) {
   *     console.log("Publisher started streaming.");
   *   });
   * </pre>
   *
   *  <h4><a name="example_streamDestroyed_publisher"></a>Example &#151; streamDestroyed event
   * dispatched by a Publisher object</h4>
   *
   *  <p>The following code publishes a stream, and leaves the Publisher in the HTML DOM
   * when the streaming stops:</p>
   *
   * <pre>
   * var publisher = session.publish(targetElement)
   *   .on("streamDestroyed", function(event) {
   *     event.preventDefault();
   *     console.log("Publisher stopped streaming.");
   *   });
   * </pre>
   *
   * @class StreamEvent
   *
   * @property {Boolean} cancelable   Whether the event has a default behavior that is cancelable
   *  (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the StreamEvent object in the event
   * listener function. The <code>streamDestroyed</code> event is cancelable.
   * (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {String} reason For a <code>streamDestroyed</code> event,
   *  a description of why the session disconnected. This property can have one of the following
   *  values:
   * </p>
   * <ul>
   *  <li><code>"clientDisconnected"</code> &#151; A client disconnected from the session by calling
   *     the <code>disconnect()</code> method of the Session object or by closing the browser.
   *     (See <a href="Session.html#disconnect">Session.disconnect()</a>.)</li>
   *
   *  <li><code>"forceDisconnected"</code> &#151; A moderator has disconnected the publisher of the
   *    stream from the session, by calling the <code>forceDisconnect()</code> method of the Session
   *     object. (See <a href="Session.html#forceDisconnect">Session.forceDisconnect()</a>.)</li>
   *
   *  <li><code>"forceUnpublished"</code> &#151; A moderator has forced the publisher of the stream
   *    to stop publishing the stream, by calling the <code>forceUnpublish()</code> method of the
   *    Session object.
   *    (See <a href="Session.html#forceUnpublish">Session.forceUnpublish()</a>.)</li>
   *
   *  <li><code>"mediaStopped"</code> &#151; The user publishing the stream has stopped sharing
   *    media. For example, the user closed the window that is a source for a screen-sharing
   *    stream. Or the user disconnected a microphone that was the audio source for an audio-only
   *    stream. Or the video and audio sources are MediaStreamTrack elements and the sources of
   *    the media are stopped or destroyed.</li>
   *
   *  <li><code>"networkDisconnected"</code> &#151; The network connection terminated abruptly (for
   *      example, the client lost their internet connection).</li>
   *
   * </ul>
   *
   * <p>Depending on the context, this description may allow the developer to refine
   * the course of action they take in response to an event.</p>
   *
   * <p>For a <code>streamCreated</code> event, this string is undefined.</p>
   *
   * @property {Stream} stream A Stream object corresponding to the stream that was added (in the
   * case of a <code>streamCreated</code> event) or deleted (in the case of a
   * <code>streamDestroyed</code> event).
   *
   * @property {Array} streams Deprecated. Use the <code>stream</code> property. A
   * <code>streamCreated</code> or <code>streamDestroyed</code> event is dispatched for
   * each stream added or destroyed.
   *
   * @augments Event
   */ let streamEventPluralDeprecationWarningShown = false;
                Events.StreamEvent = /*#__PURE__*/ function(_Event2) {
                    (0, _inheritsLoose2.default)(StreamEvent, _Event2);
                    function StreamEvent(type, stream, reason, cancelable) {
                        return _Event2.call(this, type, cancelable, {
                            stream: stream,
                            reason: reason
                        }) || this;
                    }
                    (0, _createClass2.default)(StreamEvent, [
                        {
                            key: "streams",
                            get: function get() {
                                if (!streamEventPluralDeprecationWarningShown) {
                                    logging.warn('OT.StreamEvent streams property is deprecated, use stream instead.');
                                    streamEventPluralDeprecationWarningShown = true;
                                }
                                return [
                                    this.stream
                                ];
                            }
                        }
                    ]);
                    return StreamEvent;
                }(Event1);
                /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>For the <code>streamDestroyed</code> event dispatched by the Session object,
  * the default behavior is that all Subscriber objects that are subscribed to the stream are
  * unsubscribed and removed from the HTML DOM. Each Subscriber object dispatches a
  * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
  * <code>preventDefault()</code> method in the event listener for the <code>streamDestroyed</code>
  * event, the default behavior is prevented and you can clean up Subscriber objects using your
  * own code. See
  * <a href="Session.html#getSubscribersForStream">Session.getSubscribersForStream()</a>.</p>
  * <p>
  * For the <code>streamDestroyed</code> event dispatched by a Publisher object, the default
  * behavior is that the Publisher object is removed from the HTML DOM. The Publisher object
  * dispatches a <code>destroyed</code> event when the element is removed from the HTML DOM.
  * If you call the <code>preventDefault()</code> method in the event listener for the
  * <code>streamDestroyed</code> event, the default behavior is prevented, and you can
  * retain the Publisher for reuse or clean it up using your own code.
  *</p>
  * <p>To see whether an event has a default behavior, check the <code>cancelable</code> property of
  * the event object. </p>
  *
  * <p>
  *   Call the <code>preventDefault()</code> method in the event listener function for the event.
  * </p>
  *
  * @method #preventDefault
  * @memberof StreamEvent
  */ /**
   * The Session object dispatches SessionConnectEvent object when a session has successfully
   * connected in response to a call to the <code>connect()</code> method of the Session object.
   * <p>
   * In version 2.2, the completionHandler of the <code>Session.connect()</code> method
   * indicates success or failure in connecting to the session.
   *
   * @class SessionConnectEvent
   * @property {Array} connections Deprecated in version 2.2 (and set to an empty array). In
   * version 2.2, listen for the <code>connectionCreated</code> event dispatched by the Session
   * object. In version 2.2, the Session object dispatches a <code>connectionCreated</code> event
   * for each connection (including your own). This includes connections present when you first
   * connect to the session.
   *
   * @property {Array} streams Deprecated in version 2.2 (and set to an empty array). In version
   * 2.2, listen for the <code>streamCreated</code> event dispatched by the Session object. In
   * version 2.2, the Session object dispatches a <code>streamCreated</code> event for each stream
   * other than those published by your client. This includes streams
   * present when you first connect to the session.
   *
   * @see <a href="Session.html#connect">Session.connect()</a></p>
   * @augments Event
   */ let sessionConnectedConnectionsDeprecationWarningShown = false;
                let sessionConnectedStreamsDeprecationWarningShown = false;
                let sessionConnectedArchivesDeprecationWarningShown = false;
                Events.SessionConnectEvent = /*#__PURE__*/ function(_Event3) {
                    (0, _inheritsLoose2.default)(SessionConnectEvent, _Event3);
                    function SessionConnectEvent(type) {
                        return _Event3.call(this, type, false) || this;
                    } // eslint-disable-next-line class-methods-use-this
                    (0, _createClass2.default)(SessionConnectEvent, [
                        {
                            key: "connections",
                            get: function get() {
                                if (!sessionConnectedConnectionsDeprecationWarningShown) {
                                    logging.warn("OT.SessionConnectedEvent no longer includes connections. Listen for connectionCreated events instead.");
                                    sessionConnectedConnectionsDeprecationWarningShown = true;
                                }
                                return [];
                            } // eslint-disable-next-line class-methods-use-this
                        },
                        {
                            key: "streams",
                            get: function get() {
                                if (!sessionConnectedStreamsDeprecationWarningShown) {
                                    logging.warn("OT.SessionConnectedEvent no longer includes streams. Listen for streamCreated events instead.");
                                    sessionConnectedStreamsDeprecationWarningShown = true;
                                }
                                return [];
                            } // eslint-disable-next-line class-methods-use-this
                        },
                        {
                            key: "archives",
                            get: function get() {
                                if (!sessionConnectedArchivesDeprecationWarningShown) {
                                    logging.warn("OT.SessionConnectedEvent no longer includes archives. Listen for archiveStarted events instead.");
                                    sessionConnectedArchivesDeprecationWarningShown = true;
                                }
                                return [];
                            }
                        }
                    ]);
                    return SessionConnectEvent;
                }(Event1);
                Events.SessionReconnectingEvent = function SessionReconnectedEvent() {
                    return new Event1(eventNames.SESSION_RECONNECTING, false);
                };
                Events.SessionReconnectedEvent = function SessionReconnectedEvent() {
                    return new Event1(eventNames.SESSION_RECONNECTED);
                };
                /**
   * The Session object dispatches SessionDisconnectEvent object when a session has disconnected.
   * This event may be dispatched asynchronously in response to a successful call to the
   * <code>disconnect()</code> method of the session object.
   *
   *  <h4>
   *    <a href="example"></a>Example
   *  </h4>
   *  <p>
   *    The following code initializes a session and sets up an event listener for when a session is
   * disconnected.
   *  </p>
   * <pre>var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
   *  var sessionID = ""; // Replace with your own session ID.
   *                      // See https://tokbox.com/developer/guides/create-session/
   *  var token = ""; // Replace with a generated token that has been assigned the moderator role.
   *                  // See https://tokbox.com/developer/guides/create-token/
   *
   *  var session = OT.initSession(apiKey, sessionID);
   *  session.on("sessionDisconnected", function(event) {
   *      alert("The session disconnected. " + event.reason);
   *  });
   *  session.connect(token);
   *  </pre>
   *
   * @property {String} reason A description of why the session disconnected.
   *   This property can have the following values:
   *  </p>
   *  <ul>
   *    <li>
   *      <code>"clientDisconnected"</code> &mdash; A client disconnected from the
   *      session by calling the <code>disconnect()</code> method of the Session
   *      object or by closing the browser. ( See <a href=
   *      "Session.html#disconnect">Session.disconnect()</a>.)
   *    </li>
   *
   *    <li>
   *      <code>"forceDisconnected"</code> &mdash; A moderator has disconnected you from
   *      the session by calling the <code>forceDisconnect()</code> method of the
   *      Session object. (See <a href=
   *      "Session.html#forceDisconnect">Session.forceDisconnect()</a>.)
   *    </li>
   *
   *    <li><code>"networkDisconnected"</code> &mdash; The network connection terminated
   *    abruptly (for example, the client lost its internet connection).
   *    <p>
   *    Prior to dispatching a
   *    <code>sessionDisconnected</code> event for this reason, the Session object dispatches a
   *    <code>reconnecting</code> event, and the client attempts to reconnect to the OpenTok session.
   *    If the reconnection fails, the Session object dispatches a <code>sessionDisconnected</code>
   *    event with the <code>reason</code> property set to <code>"networkDisconnected"</code>.
   *  </ul>
   *  <ul>
   *
   * @class SessionDisconnectEvent
   * @augments Event
   */ Events.SessionDisconnectEvent = function SessionDisconnectEvent(type, reason, cancelable) {
                    return new Event1(type, cancelable, {
                        reason: reason
                    });
                };
                /**
  * Prevents the default behavior associated with the event from taking place.
  *
  * <p>
  *   For the <code>sessionDisconnectEvent</code>, the default behavior is that all
  *   Subscriber objects are unsubscribed and removed from the HTML DOM. Each
  *   Subscriber object dispatches a <code>destroyed</code> event when the element
  *   is removed from the HTML DOM. If you call the <code>preventDefault()</code>
  *   method in the event listener for the <code>sessionDisconnect</code> event,
  *   the default behavior is prevented, and you can, optionally, clean up
  *   Subscriber objects using your own code).
  * </p>
  * <p>
  *   To see whether an event has a default behavior, check the
  *   <code>cancelable</code> property of the event object.
  * </p>
  * <p>
  *   Call the <code>preventDefault()</code> method in the event listener function
  *   for the event.
  * </p>
  *
  * @method #preventDefault
  * @memberof SessionDisconnectEvent
  */ /**
   * The Session object dispatches a <code>streamPropertyChanged</code> event in the
   * following circumstances:
   *
   * <ul>
   *   <li> A stream has started or stopped publishing audio or video (see
   *     <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a> and
   *     <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>).
   *     This change results from a call to the <code>publishAudio()</code> or
   *     <code>publishVideo()</code> methods of the Publish object. Note that a
   *     subscriber's video can be disabled or enabled for reasons other than the
   *     publisher disabling or enabling it. A Subscriber object dispatches
   *     <code>videoDisabled</code> and <code>videoEnabled</code> events in all
   *     conditions that cause the subscriber's stream to be disabled or enabled.
   *   </li>
   *   <li> The <code>videoDimensions</code> property of the Stream object has
   *     changed (see <a href="Stream.html#properties">Stream.videoDimensions</a>).
   *   </li>
   *   <li> The <code>videoType</code> property of the Stream object has changed.
   *     This can happen in a stream published by a mobile device. (See
   *     <a href="Stream.html#properties">Stream.videoType</a>.)
   *   </li>
   * </ul>
   *
   * @class StreamPropertyChangedEvent
   * @property {String} changedProperty The property of the stream that changed. This value
   * is either <code>"hasAudio"</code>, <code>"hasVideo"</code>, or <code>"videoDimensions"</code>.
   * @property {Object} newValue The new value of the property (after the change).
   * @property {Object} oldValue The old value of the property (before the change).
   * @property {Stream} stream The Stream object for which a property has changed.
   *
   * @see <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a></p>
   * @see <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a></p>
   * @see <a href="Stream.html#properties">Stream.videoDimensions</a></p>
   * @augments Event
   */ Events.StreamPropertyChangedEvent = function StreamPropertyChangedEvent(type, stream, changedProperty, oldValue, newValue) {
                    return new Event1(type, false, {
                        stream: stream,
                        changedProperty: changedProperty,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                };
                /**
   * Dispatched when the video dimensions of the video change for a screen-sharing
   * video stream (when the user resizes the window being captured).
   *
   * @class VideoDimensionsChangedEvent
   * @property {Object} newValue The new video dimensions (after the change). This object has two
   * properties: <code>height</code> (the height, in pixels) and <code>width</code> (the width,
   * in pixels).
   * @property {Object} oldValue The old video dimensions (before the change). This object has two
   * properties: <code>height</code> (the old height, in pixels) and <code>width</code> (the old
   * width, in pixels).
   *
   * @see <a href="Publisher.html#event:videoDimensionsChanged">Publisher videoDimensionsChanged
   *   event</a>
   * @see <a href="Subscriber.html#event:videoDimensionsChanged">Subscriber videoDimensionsChanged
   *   event</a>
   * @augments Event
   */ Events.VideoDimensionsChangedEvent = function VideoDimensionsChangedEvent(target, oldValue, newValue) {
                    return new Event1('videoDimensionsChanged', false, {
                        target: target,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                };
                /**
   * Defines event objects for the <code>archiveStarted</code> and <code>archiveStopped</code>
   * events. The Session object dispatches these events when an archive recording of the session
   * starts and stops.
   *
   * @property {String} id The archive ID.
   * @property {String} name The name of the archive. You can assign an archive a name when you
   * create it, using the <a href="http://www.tokbox.com/opentok/api">OpenTok REST API</a> or one
   * of the <a href="http://www.tokbox.com/opentok/libraries/server">OpenTok server SDKs</a>.
   *
   * @class ArchiveEvent
   * @augments Event
   */ Events.ArchiveEvent = function ArchiveEvent(type, archive) {
                    return new Event1(type, false, {
                        id: archive.id,
                        name: archive.name,
                        status: archive.status,
                        archive: archive
                    });
                };
                Events.ArchiveUpdatedEvent = function ArchiveUpdatedEvent(stream, key, oldValue, newValue) {
                    return new Event1('updated', false, {
                        target: stream,
                        changedProperty: key,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                };
                /**
   * The Session object dispatches a signal event when the client receives a signal from the
   * session.
   *
   * @class SignalEvent
   * @property {String} type The type assigned to the signal (if there is one). Use the type to
   * filter signals received (by adding an event handler for signal:type1 or signal:type2, etc.)
   * @property {String} data The data string sent with the signal (if there is one).
   * @property {Connection} from The Connection corresponding to the client that sent the
   * signal.
   *
   * @see <a href="Session.html#signal">Session.signal()</a></p>
   * @see <a href="Session.html#events">Session events (signal and signal:type)</a></p>
   * @augments Event
   */ Events.SignalEvent = function SignalEvent(type, data, from) {
                    return new Event1(type ? `signal:${type}` : eventNames.SIGNAL, false, {
                        data: data,
                        from: from
                    });
                };
                Events.CaptionReceivedEvent = function CaptionReceivedEvent(caption, streamId) {
                    return new Event1('caption', false, {
                        caption: caption,
                        streamId: streamId
                    });
                };
                Events.StreamUpdatedEvent = function StreamUpdatedEvent(stream, key, oldValue, newValue) {
                    return new Event1('updated', false, {
                        target: stream,
                        changedProperty: key,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                };
                Events.DestroyedEvent = function DestroyedEvent(type, target, reason) {
                    return new Event1(type, false, {
                        target: target,
                        reason: reason
                    });
                };
                Events.ConnectionStateChangedEvent = function ConnectionStateChangedEvent(type, target) {
                    return new Event1(type, false, {
                        target: target
                    });
                };
                /**
   * Defines the event object for the <code>videoDisabled</code> and <code>videoEnabled</code>
   * events dispatched by the Subscriber.
   *
   * @class VideoEnabledChangedEvent
   *
   * @property {Boolean} cancelable Whether the event has a default behavior that is cancelable
   * (<code>true</code>) or not (<code>false</code>). You can cancel the default behavior by
   * calling the <code>preventDefault()</code> method of the event object in the callback
   * function. (See <a href="#preventDefault">preventDefault()</a>.)
   *
   * @property {String} reason The reason the video was disabled or enabled. This can be set to one
   * of the following values:
   *
   * <ul>
   *
   *   <li><code>"publishVideo"</code> &mdash; The publisher started or stopped publishing video,
   *   by calling <code>publishVideo(true)</code> or <code>publishVideo(false)</code>.</li>
   *
   *   <li><code>"quality"</code> &mdash; The OpenTok Media Router starts or stops sending video
   *   to the subscriber based on stream quality changes. This feature of the OpenTok Media
   *   Router has a subscriber drop the video stream when connectivity degrades. (The subscriber
   *   continues to receive the audio stream, if there is one.)
   *   <p>
   *   If connectivity improves to support video again, the Subscriber object dispatches
   *   a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
   *   <p>
   *   By default, the Subscriber displays a video disabled indicator when a
   *   <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
   *   when the <code>videoEnabled</code> event with this reason is dispatched. You can control
   *   the display of this icon by calling the <code>setStyle()</code> method of the Subscriber,
   *   setting the <code>videoDisabledDisplayMode</code> property(or you can set the style when
   *   calling the <code>Session.subscribe()</code> method, setting the <code>style</code> property
   *   of the <code>properties</code> parameter).
   *   <p>
   *   This feature is only available in sessions that use the OpenTok Media Router (sessions with
   *   the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
   *   set to routed), not in sessions with the media mode set to relayed.
   *   </li>
   *
   *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
   *   video, by calling <code>subscribeToVideo(true)</code> or
   *   <code>subscribeToVideo(false)</code>.</li>
   *
   *   <li><code>"codecNotSupported"</code> &mdash; The subscriber stopped subscribing to video due
   *   to an incompatible codec.</li>
   *
   *   <li><code>"codecChanged"</code> &mdash; The subscriber video was enabled after a codec change
   *   from an incompatible codec.</li>
   *
   * </ul>
   *
   * @property {Object} target The object that dispatched the event.
   *
   * @property {String} type  The type of event: <code>"videoDisabled"</code> or
   * <code>"videoEnabled"</code>.
   *
   * @see <a href="Subscriber.html#event:videoDisabled">Subscriber videoDisabled event</a></p>
   * @see <a href="Subscriber.html#event:videoEnabled">Subscriber videoEnabled event</a></p>
   * @augments Event
   */ Events.VideoEnabledChangedEvent = function VideoEnabledChangedEvent(type, properties) {
                    return new Event1(type, false, {
                        reason: properties.reason
                    });
                };
                Events.VideoDisableWarningEvent = function VideoDisableWarningEvent(type) {
                    return new Event1(type, false);
                };
                /**
   * Dispatched periodically by a Subscriber or Publisher object to indicate the audio
   * level. This event is dispatched up to 60 times per second, depending on the browser.
   *
   * @property {Number} audioLevel The audio level, from 0 to 1.0. Adjust this value logarithmically
   * for use in adjusting a user interface element, such as a volume meter. Use a moving average
   * to smooth the data.
   *
   * @class AudioLevelUpdatedEvent
   * @augments Event
   */ Events.AudioLevelUpdatedEvent = function AudioLevelUpdatedEvent(audioLevel) {
                    return new Event1(eventNames.AUDIO_LEVEL_UPDATED, false, {
                        audioLevel: audioLevel
                    });
                };
                /**
   * Dispatched by a Publisher when the user has stopped sharing one or all media types
   * (video, audio, or screen).
   *
   * @property {MediaStreamTrack} track The media track that has ended. This property is undefined
   * if all media tracks have stopped. Check the <code>kind</code> property of this object to
   * see if the track is an audio track or a video track.
   *
   * @class MediaStoppedEvent
   * @augments Event
   * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack
   */ Events.MediaStoppedEvent = function MediaStoppedEvent(target, track) {
                    return new Event1(eventNames.MEDIA_STOPPED, true, {
                        target: target,
                        track: track
                    });
                };
                /**
   * Defines the <code>muteForced</code> event dispatched by a Session object. The Session object
   * dispatches this event when a moderator forces clients publishing streams to the session
   * to mute audio (the <code>active</code> property of the MuteForcedEvent object is set
   * to <code>true</code>), or when a moderator disables the mute audio state in the session
   * (the <code>active</code> property of the MuteForcedEvent object is set to <code>false</code>).
   *
   * @property {Boolean} active Whether the moderator has muted streams in the session (<code>true</code>)
   * or disabled the mute state in the session (<code>false</code>).
   *
   * @class MuteForcedEvent
   * @augments Event
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
   * @see <a href="Session.html#event:muteForced">Session muteForced event</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */ Events.MuteForcedEvent = function MuteForcedEvent(muteForcedInfo) {
                    return new Event1(eventNames.MUTE_FORCED, false, muteForcedInfo);
                };
                /**
   * Dispatched by a Subscriber or Publisher object to indicate the <code>video</code> element
   * (or <code>object</code> element in Internet Explorer) was created. Add a listener for this event
   * when you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
   * <a href="OT.html#initPublisher">OT.initPublisher()</a> method or the
   * <a href="Session.html#subscribe">Session.subscribe()</a> method. The <code>element</code>
   * property of the event object is a reference to the Publisher's <code>video</code> element
   * (or the <code>object</code> element in Internet Explorer). Add it to the HTML DOM to display the
   * video. (When you set the <code>insertDefaultUI</code> option to <code>false</code>, the
   * <code>video</code> element is not inserted into the DOM automatically.)
   * <p>
   * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
   * <code>false</code>. If you have not set <code>insertDefaultUI</code> option
   * to <code>false</code>, do not move the <code>video</code> element (or the <code>object</code>
   * element containing the video in Internet Explorer) in the HTML DOM. Doing so causes the
   * Publisher or Subscriber object to be destroyed.
   *
   * @property {Number} element A reference to the Publisher or Subscriber's <code>video</code>
   * element (or in Internet Explorer the <code>object</code> element containing the video).
   * Add it to the HTML DOM to display the video.
   *
   * @class VideoElementCreatedEvent
   * @augments Event
   */ Events.VideoElementCreatedEvent = function VideoElementCreatedEvent(element) {
                    return new Event1(eventNames.VIDEO_ELEMENT_CREATED, false, {
                        element: element
                    });
                };
                return Events;
            };
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable global-require */ module1.exports = function(deps) {
                    if (deps === void 0) deps = {};
                    const getNativeEnumerateDevices = deps.getNativeEnumerateDevices || __webpack_require__(287)();
                    const getNativeMediaDevices = deps.getNativeMediaDevices || __webpack_require__(637)();
                    const _ref = deps.currentAudioOutputDevice || __webpack_require__(105), getCurrentAudioOutputDeviceId = _ref.getCurrentAudioOutputDeviceId;
                    const env = deps.env || __webpack_require__(3);
                    const windowMock = deps.global || window;
                    const deviceHelpers = {}; // /
                    // Device Helpers
                    //
                    // Support functions to enumerating and querying device info
                    //
                    const deviceKindsMap = {
                        audio: 'audioInput',
                        video: 'videoInput',
                        audioinput: 'audioInput',
                        videoinput: 'videoInput',
                        audiooutput: 'audioOutput',
                        audioInput: 'audioInput',
                        videoInput: 'videoInput',
                        audioOutput: 'audioOutput'
                    };
                    const enumerateDevices = ()=>{
                        // Our mocking currently requires that this be re-evaluated each time.
                        const fn = getNativeEnumerateDevices();
                        return fn();
                    };
                    deviceHelpers.getNativeMediaDevices = ()=>getNativeMediaDevices(); // Indicates whether this browser supports the enumerateDevices (getSources) API.
                    //
                    deviceHelpers.hasEnumerateDevicesCapability = ()=>typeof getNativeEnumerateDevices() === 'function';
                    deviceHelpers.hasDeviceChangeCapability = ()=>{
                        const mediaDevices = getNativeMediaDevices();
                        return !!(mediaDevices && 'ondevicechange' in mediaDevices);
                    };
                    deviceHelpers.hasSetSinkIdCapability = ()=>'setSinkId' in (windowMock == null ? void 0 : windowMock.HTMLMediaElement.prototype);
                    deviceHelpers.hasAudioOutputApiSupport = ()=>deviceHelpers.hasSetSinkIdCapability() && deviceHelpers.hasDeviceChangeCapability(); // OPENTOK-40733, see https://bugs.webkit.org/show_bug.cgi?id=209739#c2
                    // multiple calls to enumerateDevices fail to return video devices
                    // note that this causes any devices without a camera (mac minis) to make a video gum call
                    // we believe this is worth it to prevent safari video breaking
                    deviceHelpers.hasEnumerateDevicesBug = ()=>env.isSafari && env.version === 13.1;
                    deviceHelpers.getMediaDevices = ()=>{
                        if (!deviceHelpers.hasEnumerateDevicesCapability()) return Promise.reject(new Error('This browser does not support enumerateDevices APIs'));
                        return enumerateDevices().then((devices)=>devices.map((device)=>({
                                    deviceId: device.deviceId || device.id,
                                    label: device.label,
                                    kind: deviceKindsMap[device.kind]
                                })));
                    };
                    deviceHelpers.getInputMediaDevices = ()=>deviceHelpers.getMediaDevices().then((devices)=>devices.filter((device)=>/^(audio|video)Input$/.test(device.kind)));
                    deviceHelpers.getAudioOutputMediaDevices = ()=>deviceHelpers.getMediaDevices().then((devices)=>devices.filter((device)=>device.kind === 'audioOutput').map((_ref2)=>{
                                let deviceId = _ref2.deviceId, label = _ref2.label;
                                return {
                                    deviceId: deviceId,
                                    label: label
                                };
                            }));
                    deviceHelpers.shouldAskForDevices = ()=>{
                        if (!deviceHelpers.hasEnumerateDevicesCapability()) // Assume video and audio exists if enumerateDevices is not available
                        return Promise.resolve({
                            video: true,
                            audio: true
                        });
                        return deviceHelpers.getInputMediaDevices().then((devices)=>{
                            if (devices.length === 0) // If no devices reported, might as well try anyway, maybe it was just an issue with
                            // device enumeration.
                            return {
                                video: true,
                                audio: true
                            };
                            const audioDevices = devices.filter((device)=>device.kind === 'audioInput');
                            const videoDevices = devices.filter((device)=>device.kind === 'videoInput');
                            if (deviceHelpers.hasEnumerateDevicesBug() && videoDevices.length === 0) return {
                                audio: true,
                                video: true
                            };
                            return {
                                video: videoDevices.length > 0,
                                audio: audioDevices.length > 0,
                                videoDevices: videoDevices,
                                audioDevices: audioDevices
                            };
                        }).catch(()=>// all devices exist for now.
                            ({
                                video: true,
                                audio: true
                            }));
                    };
                    deviceHelpers.getDefaultAudioOutputDeviceId = (devices)=>{
                        if (!Array.isArray(devices) || devices.length === 0) return '';
                        const _ref3 = devices.find((device)=>device.deviceId === 'default') || devices[0], deviceId = _ref3.deviceId;
                        return deviceId;
                    };
                    deviceHelpers.hasDevice = (devicesList, deviceId)=>{
                        let devices = devicesList;
                        if (!Array.isArray(devices)) devices = [];
                        return devices.some((device)=>device.deviceId === deviceId);
                    };
                    deviceHelpers.getActiveAudioOutputDevice = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                        var devices, currentDevice, defaultDeviceId;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return deviceHelpers.getAudioOutputMediaDevices();
                                case 3:
                                    devices = _context.sent;
                                    _context.next = 9;
                                    break;
                                case 6:
                                    _context.prev = 6;
                                    _context.t0 = _context["catch"](0);
                                    throw _context.t0;
                                case 9:
                                    if (!(devices.length === 0)) {
                                        _context.next = 11;
                                        break;
                                    }
                                    return _context.abrupt("return", {
                                        deviceId: null,
                                        label: null
                                    });
                                case 11:
                                    // Let's find the current output device object in the list.
                                    currentDevice = devices.find((device)=>device.deviceId === getCurrentAudioOutputDeviceId());
                                    if (!currentDevice) {
                                        // The current audio output device is not in the list, let's return the default device instead
                                        defaultDeviceId = deviceHelpers.getDefaultAudioOutputDeviceId(devices);
                                        currentDevice = devices.find((device)=>device.deviceId === defaultDeviceId);
                                    }
                                    return _context.abrupt("return", currentDevice);
                                case 14:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    }));
                    return deviceHelpers;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            var isFunction = __webpack_require__(17), isLength = __webpack_require__(112);
            /**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            module1.exports = isArrayLike;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            /* eslint-disable no-underscore-dangle */ const guidStorage = __webpack_require__(241);
            const Analytics = __webpack_require__(535);
            const SessionInfo = __webpack_require__(141);
            const StaticConfig = __webpack_require__(35)();
            const getMessagingUrl = __webpack_require__(550);
            const eventing = __webpack_require__(7);
            const sanitizeQosData = __webpack_require__(552);
            const defaultGetUserAgentClientHintData = __webpack_require__(555);
            const LOG_VERSION = '2';
            let AnalyticsHelper = /*#__PURE__*/ function() {
                function AnalyticsHelper(_temp) {
                    let _ref = _temp === void 0 ? {} : _temp, _ref$staticConfig = _ref.staticConfig, staticConfig = _ref$staticConfig === void 0 ? StaticConfig.onlyLocal() : _ref$staticConfig, _ref$sessionInfo = _ref.sessionInfo, sessionInfo = _ref$sessionInfo === void 0 ? new SessionInfo() : _ref$sessionInfo, ajax = _ref.ajax, queue = _ref.queue, _ref$getUserAgentClie = _ref.getUserAgentClientHintData, getUserAgentClientHintData = _ref$getUserAgentClie === void 0 ? defaultGetUserAgentClientHintData : _ref$getUserAgentClie, _ref$userAgentData = _ref.userAgentData, userAgentData = _ref$userAgentData === void 0 ? typeof navigator !== 'undefined' && navigator.userAgentData : _ref$userAgentData;
                    (0, _defineProperty2.default)(this, "getTurnServerName", (iceServers)=>{
                        let turnNoTLSServerName;
                        let turnTLSServerName; // In case we don't find the server name we will be returning nothing
                        // which will be ignored and relay server will not be present in the logs
                        if (!iceServers || typeof iceServers !== 'object') return turnNoTLSServerName;
                        const servers = Array.isArray(iceServers) ? iceServers : [
                            iceServers
                        ];
                        servers.forEach((server)=>{
                            const urls = server.urls || server.url;
                            const arrUrl = Array.isArray(urls) ? urls : [
                                urls
                            ];
                            arrUrl.forEach((url)=>{
                                // Index where server name value starts
                                const prefixIndex = url.indexOf(':') + 1; // Index of the port number
                                const suffixIndex = url.lastIndexOf(':'); // We assume that TLS turn, i.e. turns, is the one which contains
                                // the domain name.
                                if (url.includes('turns')) turnTLSServerName = url.substring(prefixIndex, suffixIndex);
                                else turnNoTLSServerName = url.substring(prefixIndex, suffixIndex);
                            });
                        });
                        return turnTLSServerName || turnNoTLSServerName;
                    });
                    this.ajax = ajax;
                    this.queue = queue;
                    this.sessionInfo = sessionInfo;
                    this.getUserAgentClientHintData = getUserAgentClientHintData;
                    this.userAgentData = userAgentData; // setting static config invokes the setter below and instantiates Analytics
                    // This must be called last.
                    this.staticConfig = staticConfig;
                }
                var _proto = AnalyticsHelper.prototype;
                _proto._getCachedUserAgentData = /*#__PURE__*/ function() {
                    var _getCachedUserAgentData2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (this.cachedUserAgentData) {
                                        _context.next = 4;
                                        break;
                                    }
                                    _context.next = 3;
                                    return this.getUserAgentClientHintData(this.userAgentData);
                                case 3:
                                    this.cachedUserAgentData = _context.sent;
                                case 4:
                                    return _context.abrupt("return", this.cachedUserAgentData);
                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function _getCachedUserAgentData() {
                        return _getCachedUserAgentData2.apply(this, arguments);
                    }
                    return _getCachedUserAgentData;
                }();
                _proto.commonQoSFields = function commonQoSFields() {
                    const proxyUrl = this._analytics.proxyUrl;
                    const messagingURL = this.sessionInfo.messagingURL;
                    return {
                        clientVersion: this.staticConfig.clientVersion,
                        buildHash: this.staticConfig.buildHash,
                        source: window.location && window.location.href,
                        logVersion: LOG_VERSION,
                        apiServer: this.staticConfig.apiUrl,
                        clientSystemTime: new Date().getTime(),
                        sessionId: this.sessionInfo.sessionId,
                        mediaServerName: this.sessionInfo.mediaServerName,
                        relayServer: this.getTurnServerName(this.sessionInfo.iceServers),
                        p2p: this.sessionInfo.p2pEnabled,
                        messagingServer: this.sessionInfo.messagingServer,
                        messagingUrl: getMessagingUrl(proxyUrl, messagingURL),
                        version: this.staticConfig.version,
                        partnerId: this.sessionInfo.partnerId
                    };
                };
                _proto._getCommonDataFields = /*#__PURE__*/ function() {
                    var _getCommonDataFields2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                        var guid, userAgentDataFields;
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    _context2.next = 2;
                                    return guidStorage.getAsync();
                                case 2:
                                    guid = _context2.sent;
                                    _context2.next = 5;
                                    return this._getCachedUserAgentData();
                                case 5:
                                    userAgentDataFields = _context2.sent;
                                    return _context2.abrupt("return", (0, _extends2.default)({
                                        guid: guid
                                    }, this.commonQoSFields(), userAgentDataFields));
                                case 7:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, this);
                    }));
                    function _getCommonDataFields() {
                        return _getCommonDataFields2.apply(this, arguments);
                    }
                    return _getCommonDataFields;
                }();
                _proto.logError = function logError(code, type, message, details, options) {
                    if (options === void 0) options = {};
                    this._getCommonDataFields().then((commonDataFields)=>{
                        const args = [
                            code,
                            type,
                            message,
                            details,
                            (0, _extends2.default)({}, commonDataFields, options)
                        ];
                        AnalyticsHelper.emit('logError', ...args);
                        this._analytics.logError(...args);
                    });
                };
                _proto.logEvent = function logEvent(options, throttle, completionHandler) {
                    if (options === void 0) options = {};
                    this._getCommonDataFields().then((commonDataFields)=>{
                        const logData = (0, _extends2.default)({}, commonDataFields, options);
                        AnalyticsHelper.emit('logEvent', logData);
                        this._analytics.logEvent(logData, false, throttle, completionHandler);
                    });
                };
                _proto.logQOS = function logQOS(options) {
                    if (options === void 0) options = {};
                    this._getCommonDataFields().then((commonDataFields)=>{
                        const qosData = (0, _extends2.default)({
                            duration: 0
                        }, commonDataFields, options);
                        sanitizeQosData(qosData);
                        AnalyticsHelper.emit('logQOS', qosData);
                        this._analytics.logQOS(qosData);
                    });
                };
                (0, _createClass2.default)(AnalyticsHelper, [
                    {
                        key: "staticConfig",
                        get: function get() {
                            return this._staticConfig;
                        },
                        set: function set(staticConfig) {
                            this._staticConfig = staticConfig;
                            this._analytics = new Analytics({
                                loggingUrl: this.staticConfig.loggingUrl,
                                ajax: this.ajax,
                                queue: this.queue
                            });
                        }
                    }
                ]);
                return AnalyticsHelper;
            }();
            eventing(AnalyticsHelper);
            module1.exports = AnalyticsHelper;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Event names lookup
            module1.exports = {
                // Activity Status for cams/mics
                ACTIVE: 'active',
                INACTIVE: 'inactive',
                UNKNOWN: 'unknown',
                // Archive types
                PER_SESSION: 'perSession',
                PER_STREAM: 'perStream',
                // Events
                EXCEPTION: 'exception',
                ISSUE_REPORTED: 'issueReported',
                // Session Events
                SESSION_CONNECTED: 'sessionConnected',
                SESSION_RECONNECTING: 'sessionReconnecting',
                SESSION_RECONNECTED: 'sessionReconnected',
                SESSION_DISCONNECTED: 'sessionDisconnected',
                STREAM_CREATED: 'streamCreated',
                STREAM_DESTROYED: 'streamDestroyed',
                CONNECTION_CREATED: 'connectionCreated',
                CONNECTION_DESTROYED: 'connectionDestroyed',
                SIGNAL: 'signal',
                STREAM_PROPERTY_CHANGED: 'streamPropertyChanged',
                MICROPHONE_LEVEL_CHANGED: 'microphoneLevelChanged',
                // Publisher Events
                RESIZE: 'resize',
                SETTINGS_BUTTON_CLICK: 'settingsButtonClick',
                DEVICE_INACTIVE: 'deviceInactive',
                INVALID_DEVICE_NAME: 'invalidDeviceName',
                ACCESS_ALLOWED: 'accessAllowed',
                ACCESS_DENIED: 'accessDenied',
                ACCESS_DIALOG_OPENED: 'accessDialogOpened',
                ACCESS_DIALOG_CLOSED: 'accessDialogClosed',
                ECHO_CANCELLATION_MODE_CHANGED: 'echoCancellationModeChanged',
                MEDIA_STOPPED: 'mediaStopped',
                PUBLISHER_DESTROYED: 'destroyed',
                MUTE_FORCED: 'muteForced',
                // Subscriber Events
                SUBSCRIBER_DESTROYED: 'destroyed',
                SUBSCRIBER_CONNECTED: 'connected',
                SUBSCRIBER_DISCONNECTED: 'disconnected',
                SUBSCRIBER_CAPTION_RECEIVED: 'captionReceived',
                // DeviceManager Events
                DEVICES_DETECTED: 'devicesDetected',
                // DevicePanel Events
                DEVICES_SELECTED: 'devicesSelected',
                CLOSE_BUTTON_CLICK: 'closeButtonClick',
                MICLEVEL: 'microphoneActivityLevel',
                MICGAINCHANGED: 'microphoneGainChanged',
                // Environment Loader
                ENV_LOADED: 'envLoaded',
                ENV_UNLOADED: 'envUnloaded',
                // Audio activity Events
                AUDIO_LEVEL_UPDATED: 'audioLevelUpdated',
                VIDEO_ELEMENT_CREATED: 'videoElementCreated'
            };
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var logDisabled_ = true;
            var deprecationWarnings_ = true;
            /**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */ function extractVersion(uastring, expr, pos) {
                var match = uastring.match(expr);
                return match && match.length >= pos && parseInt(match[pos], 10);
            }
            // Wraps the peerconnection event eventNameToWrap in a function
            // which returns the modified event object (or false to prevent
            // the event).
            function wrapPeerConnectionEvent(window1, eventNameToWrap, wrapper) {
                if (!window1.RTCPeerConnection) return;
                var proto = window1.RTCPeerConnection.prototype;
                var nativeAddEventListener = proto.addEventListener;
                proto.addEventListener = function(nativeEventName, cb) {
                    if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
                    var wrappedCallback = function(e) {
                        var modifiedEvent = wrapper(e);
                        if (modifiedEvent) cb(modifiedEvent);
                    };
                    this._eventMap = this._eventMap || {};
                    this._eventMap[cb] = wrappedCallback;
                    return nativeAddEventListener.apply(this, [
                        nativeEventName,
                        wrappedCallback
                    ]);
                };
                var nativeRemoveEventListener = proto.removeEventListener;
                proto.removeEventListener = function(nativeEventName, cb) {
                    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[cb]) return nativeRemoveEventListener.apply(this, arguments);
                    var unwrappedCb = this._eventMap[cb];
                    delete this._eventMap[cb];
                    return nativeRemoveEventListener.apply(this, [
                        nativeEventName,
                        unwrappedCb
                    ]);
                };
                Object.defineProperty(proto, 'on' + eventNameToWrap, {
                    get: function() {
                        return this['_on' + eventNameToWrap];
                    },
                    set: function(cb) {
                        if (this['_on' + eventNameToWrap]) {
                            this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                            delete this['_on' + eventNameToWrap];
                        }
                        if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
                    },
                    enumerable: true,
                    configurable: true
                });
            }
            // Utility methods.
            module1.exports = {
                extractVersion: extractVersion,
                wrapPeerConnectionEvent: wrapPeerConnectionEvent,
                disableLog: function(bool) {
                    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
                    logDisabled_ = bool;
                    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
                },
                /**
   * Disable or enable deprecation warnings
   * @param {!boolean} bool set to true to disable warnings.
   */ disableWarnings: function(bool) {
                    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
                    deprecationWarnings_ = !bool;
                    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
                },
                log: function() {
                    if (typeof window === 'object') {
                        if (logDisabled_) return;
                        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
                    }
                },
                /**
   * Shows a deprecation warning suggesting the modern and spec-compatible API.
   */ deprecated: function(oldMethod, newMethod) {
                    if (!deprecationWarnings_) return;
                    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
                },
                /**
   * Browser detector.
   *
   * @return {object} result containing browser and version
   *     properties.
   */ detectBrowser: function(window1) {
                    var navigator1 = window1 && window1.navigator;
                    // Returned result object.
                    var result = {};
                    result.browser = null;
                    result.version = null;
                    // Fail early if it's not a browser
                    if (typeof window1 === 'undefined' || !window1.navigator) {
                        result.browser = 'Not a browser.';
                        return result;
                    }
                    if (navigator1.mozGetUserMedia) {
                        result.browser = 'firefox';
                        result.version = extractVersion(navigator1.userAgent, /Firefox\/(\d+)\./, 1);
                    } else if (navigator1.webkitGetUserMedia) {
                        // Chrome, Chromium, Webview, Opera.
                        // Version matches Chrome/WebRTC version.
                        result.browser = 'chrome';
                        result.version = extractVersion(navigator1.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
                    } else if (navigator1.mediaDevices && navigator1.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
                        result.browser = 'edge';
                        result.version = extractVersion(navigator1.userAgent, /Edge\/(\d+).(\d+)$/, 2);
                    } else if (window1.RTCPeerConnection && navigator1.userAgent.match(/AppleWebKit\/(\d+)\./)) {
                        result.browser = 'safari';
                        result.version = extractVersion(navigator1.userAgent, /AppleWebKit\/(\d+)\./, 1);
                    } else {
                        result.browser = 'Not a supported browser.';
                        return result;
                    }
                    return result;
                }
            };
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40), getRawTag = __webpack_require__(358), objectToString = __webpack_require__(359);
            /** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
            /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
            /**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
                if (value == null) return value === undefined ? undefinedTag : nullTag;
                return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
            }
            module1.exports = baseGetTag;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayLikeKeys = __webpack_require__(178), baseKeys = __webpack_require__(114), isArrayLike = __webpack_require__(25);
            /**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            module1.exports = keys;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var R = typeof Reflect === 'object' ? Reflect : null;
                var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module1.exports = EventEmitter;
                module1.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === 'error';
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === 'function') ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit('newListener', type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === 'function') // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                            w.name = 'MaxListenersExceededWarning';
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
                        }
                    } else if (typeof list !== 'function') {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === 'removeListener') continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners('removeListener');
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === 'function') this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === 'function') return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === 'function') return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function eventListener() {
                            if (errorListener !== undefined) emitter.removeListener('error', errorListener);
                            resolve([].slice.call(arguments));
                        }
                        var errorListener;
                        // Adding an error listener is not optional because
                        // if an error is thrown on an event emitter we cannot
                        // guarantee that the actual event we are waiting will
                        // be fired. The result could be a silent way to create
                        // memory or file descriptor leaks, which is something
                        // we should avoid.
                        if (name !== 'error') {
                            errorListener = function errorListener(err) {
                                emitter.removeListener(name, eventListener);
                                reject(err);
                            };
                            emitter.once('error', errorListener);
                        }
                        emitter.once(name, eventListener);
                    });
                }
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(44);
            module1.exports = function(value) {
                if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
                return value;
            };
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(57), isPlainFunction = __webpack_require__(199), assign = __webpack_require__(125), normalizeOpts = __webpack_require__(200), contains = __webpack_require__(201);
            var d = module1.exports = function(dscr, value /*, options*/ ) {
                var c, e, w, options, desc;
                if (arguments.length < 2 || typeof dscr !== "string") {
                    options = value;
                    value = dscr;
                    dscr = null;
                } else options = arguments[2];
                if (isValue(dscr)) {
                    c = contains.call(dscr, "c");
                    e = contains.call(dscr, "e");
                    w = contains.call(dscr, "w");
                } else {
                    c = w = true;
                    e = false;
                }
                desc = {
                    value: value,
                    configurable: c,
                    enumerable: e,
                    writable: w
                };
                return !options ? desc : assign(normalizeOpts(options), desc);
            };
            d.gs = function(dscr, get, set /*, options*/ ) {
                var c, e, options, desc;
                if (typeof dscr !== "string") {
                    options = set;
                    set = get;
                    get = dscr;
                    dscr = null;
                } else options = arguments[3];
                if (!isValue(get)) get = undefined;
                else if (!isPlainFunction(get)) {
                    options = get;
                    get = set = undefined;
                } else if (!isValue(set)) set = undefined;
                else if (!isPlainFunction(set)) {
                    options = set;
                    set = undefined;
                }
                if (isValue(dscr)) {
                    c = contains.call(dscr, "c");
                    e = contains.call(dscr, "e");
                } else {
                    c = true;
                    e = false;
                }
                desc = {
                    get: get,
                    set: set,
                    configurable: c,
                    enumerable: e
                };
                return !options ? desc : assign(normalizeOpts(options), desc);
            };
        /***/ },
        /* 34 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
                var index = -1, length = array == null ? 0 : array.length, result = Array(length);
                while(++index < length)result[index] = iteratee(array[index], index, array);
                return result;
            }
            module1.exports = arrayMap;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                var _createClass2 = _interopRequireDefault(__webpack_require__(46));
                /* global __PROPERTIES__ */ const defaultAxios = __webpack_require__(207);
                const cloneDeep = __webpack_require__(58);
                const pick = __webpack_require__(476);
                const mapKeys = __webpack_require__(523);
                const logging = __webpack_require__(2)('StaticConfig');
                const _require = __webpack_require__(138), prependProxyToUrlIfNeeded = _require.prependProxyToUrlIfNeeded;
                /**
 * @typedef {Object} builtInConfig properties that are baked in and are injected through webpack
 * @property {String} version Build version (comes from package.json)
 * @property {String} buildHash Commit hash this build was built from
 * @property {Object} minimumVersion
 * @property {String} minimumVersion.firefox Minimum version of Firefox needed to support OpenTok
 * @property {String} minimumVersion.chrome Minimum version of Chrome needed to support OpenTok
 * @property {Boolean} debug If true sets logging level to DEBUG else sets it to WARN
 * @property {String} websiteURL Used to construct urls to the TokBox website
 * @property {String} loggingURL Where to send analytical events
 * @property {String} apiURL The API to talk to (Anvil)
*/ /** @type builtInConfig */ const builtInConfig = cloneDeep({
                    "version": "v2.23.7",
                    "buildHash": "5807f4903",
                    "minimumVersion": {
                        "firefox": 52,
                        "chrome": 49
                    },
                    "debug": "false",
                    "websiteURL": "http://www.tokbox.com",
                    "configURL": "https://config.opentok.com",
                    "ipWhitelistConfigURL": "",
                    "cdnURL": "https://static.opentok.com",
                    "loggingURL": "https://hlg.tokbox.com/prod",
                    "apiURL": "https://anvil.opentok.com"
                });
                const whitelistAllowedRuntimeProperties = pick([
                    'apiURL',
                    'assetURL',
                    'cdnURL',
                    'sessionInfoOverrides',
                    'loggingURL'
                ]);
                const liveConfigMap = {
                    apiUrl: 'apiURL',
                    loggingUrl: 'loggingURL'
                };
                const normalizeLiveConfig = mapKeys((key)=>liveConfigMap[key]);
                function staticConfigFactory(_temp) {
                    let _ref = _temp === void 0 ? {} : _temp, _ref$axios = _ref.axios, axios = _ref$axios === void 0 ? defaultAxios : _ref$axios;
                    /**
   * @class StaticConfig
   */ let StaticConfig = /*#__PURE__*/ function() {
                        StaticConfig.onlyLocal = function onlyLocal() {
                            const runtimeProperties = cloneDeep(window.OTProperties);
                            return new StaticConfig((0, _extends2.default)({}, builtInConfig, whitelistAllowedRuntimeProperties(runtimeProperties)));
                        };
                        StaticConfig.get = function get(_ref2) {
                            let partnerId = _ref2.partnerId, token = _ref2.token, useIpWhitelistConfigUrl = _ref2.useIpWhitelistConfigUrl, proxyUrl = _ref2.proxyUrl;
                            const getLiveConfig = ()=>{
                                const localStaticConfig = this.onlyLocal();
                                if (!localStaticConfig.configUrl) return Promise.resolve({});
                                if (useIpWhitelistConfigUrl === true && !localStaticConfig.ipWhitelistConfigUrl) return Promise.resolve({});
                                let finalConfigUrl = useIpWhitelistConfigUrl === true ? localStaticConfig.ipWhitelistConfigUrl : localStaticConfig.configUrl;
                                finalConfigUrl = prependProxyToUrlIfNeeded(finalConfigUrl, proxyUrl);
                                return axios.get(`${finalConfigUrl}/project/${partnerId}/config.json`, {
                                    headers: {
                                        'X-TB-TOKEN-AUTH': token
                                    }
                                }).then((_ref3)=>{
                                    let data = _ref3.data;
                                    return data;
                                });
                            };
                            return getLiveConfig().catch((err)=>{
                                logging.error('could not reach live config service', err);
                                return {};
                            }).then((liveConfig)=>{
                                const runtimeProperties = cloneDeep(window.OTProperties);
                                const config = (0, _extends2.default)({}, builtInConfig, whitelistAllowedRuntimeProperties(runtimeProperties), normalizeLiveConfig(liveConfig));
                                return new StaticConfig(config);
                            });
                        };
                        function StaticConfig(config) {
                            Object.defineProperty(this, 'config', {
                                value: Object.freeze(cloneDeep(config))
                            });
                        }
                        (0, _createClass2.default)(StaticConfig, [
                            {
                                key: "configUrl",
                                get: function get() {
                                    return this.config.configURL;
                                }
                            },
                            {
                                key: "ipWhitelistConfigUrl",
                                get: function get() {
                                    return this.config.ipWhitelistConfigURL;
                                }
                            },
                            {
                                key: "apiUrl",
                                get: function get() {
                                    return this.config.apiURL;
                                }
                            },
                            {
                                key: "loggingUrl",
                                get: function get() {
                                    return this.config.loggingURL;
                                }
                            },
                            {
                                key: "apiEnabled",
                                get: function get() {
                                    return typeof this.config.apiEnabled !== 'undefined' ? this.config.apiEnabled : true;
                                }
                            },
                            {
                                key: "version",
                                get: function get() {
                                    return this.config.version;
                                }
                            },
                            {
                                key: "clientVersion",
                                get: function get() {
                                    return `js-${(this.version || 'unknown').replace('v', '')}`;
                                }
                            },
                            {
                                key: "buildHash",
                                get: function get() {
                                    return this.config.buildHash;
                                }
                            },
                            {
                                key: "minimumVersion",
                                get: function get() {
                                    return this.config.minimumVersion;
                                }
                            },
                            {
                                key: "websiteUrl",
                                get: function get() {
                                    return this.config.websiteURL;
                                }
                            },
                            {
                                key: "debug",
                                get: function get() {
                                    return this.config.debug === 'true' || this.config.debug === true;
                                }
                            },
                            {
                                key: "sessionInfoOverrides",
                                get: function get() {
                                    return this.config.sessionInfoOverrides;
                                }
                            },
                            {
                                key: "cdnUrl",
                                get: function get() {
                                    return this.config.cdnURL || `${window.location.protocol}//${window.location.host}`;
                                }
                            },
                            {
                                key: "assetUrl",
                                get: function get() {
                                    return this.config.assetURL || `${this.cdnUrl}/webrtc/${this.version}`;
                                }
                            }
                        ]);
                        return StaticConfig;
                    }();
                    return StaticConfig;
                }
                module1.exports = staticConfigFactory;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            var baseMatches = __webpack_require__(502), baseMatchesProperty = __webpack_require__(508), identity = __webpack_require__(89), isArray = __webpack_require__(12), property = __webpack_require__(513);
            /**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
                // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
                // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                if (typeof value == 'function') return value;
                if (value == null) return identity;
                if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                return property(value);
            }
            module1.exports = baseIteratee;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign */ const OTHelpers = __webpack_require__(8); // A mixin to encapsulate the basic widget behaviour. This needs a better name,
            // it's not actually a widget. It's actually "Behaviour that can be applied to
            // an object to make it support the basic Chrome widget workflow"...but that would
            // probably been too long a name.
            module1.exports = function Widget(widget, options) {
                let _mode;
                const _options = options || {}; //
                // @param [String] mode
                //      'on', 'off', or 'auto'
                //
                widget.setDisplayMode = function(mode) {
                    const newMode = mode || 'auto';
                    if (_mode === newMode) return;
                    OTHelpers.removeClass(this.domElement, `OT_mode-${_mode}`);
                    OTHelpers.addClass(this.domElement, `OT_mode-${newMode}`);
                    _mode = newMode;
                };
                widget.getDisplayMode = function() {
                    return _mode;
                };
                widget.showAfterLoading = function() {
                    OTHelpers.removeClass(this.domElement, 'OT_hide-forced');
                };
                widget.hideWhileLoading = function() {
                    OTHelpers.addClass(this.domElement, 'OT_hide-forced');
                };
                widget.destroy = function() {
                    if (_options.onDestroy) _options.onDestroy(this.domElement);
                    if (this.domElement) OTHelpers.removeElement(this.domElement);
                    return widget;
                };
                widget.appendTo = function(parent) {
                    // create the element under parent
                    this.domElement = OTHelpers.createElement(_options.nodeName || 'div', _options.htmlAttributes, _options.htmlContent);
                    if (_options.onCreate) _options.onCreate(this.domElement);
                    widget.setDisplayMode(_options.mode);
                    if (_options.mode === 'auto') {
                        // if the mode is auto we hold the "on mode" for 2 seconds
                        // this will let the proper widgets nicely fade away and help discoverability
                        OTHelpers.addClass(widget.domElement, 'OT_mode-on-hold');
                        setTimeout(()=>{
                            OTHelpers.removeClass(widget.domElement, 'OT_mode-on-hold');
                        }, 2000);
                    } // add the widget to the parent
                    parent.appendChild(this.domElement);
                    return widget;
                };
            };
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            var baseClone = __webpack_require__(78);
            /** Used to compose bitmasks for cloning. */ var CLONE_SYMBOLS_FLAG = 4;
            /**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            module1.exports = clone;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsNative = __webpack_require__(357), getValue = __webpack_require__(362);
            /**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            module1.exports = getNative;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            var root = __webpack_require__(14);
            /** Built-in value references. */ var Symbol1 = root.Symbol;
            module1.exports = Symbol1;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            var assignValue = __webpack_require__(84), baseAssignValue = __webpack_require__(64);
            /**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                    if (newValue === undefined) newValue = source[key];
                    if (isNew) baseAssignValue(object, key, newValue);
                    else assignValue(object, key, newValue);
                }
                return object;
            }
            module1.exports = copyObject;
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            var DataView1 = __webpack_require__(386), Map1 = __webpack_require__(109), Promise = __webpack_require__(387), Set1 = __webpack_require__(186), WeakMap1 = __webpack_require__(187), baseGetTag = __webpack_require__(29), toSource = __webpack_require__(175);
            /** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
            var dataViewTag = '[object DataView]';
            /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView1), mapCtorString = toSource(Map1), promiseCtorString = toSource(Promise), setCtorString = toSource(Set1), weakMapCtorString = toSource(WeakMap1);
            /**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
            // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
            if (DataView1 && getTag(new DataView1(new ArrayBuffer(1))) != dataViewTag || Map1 && getTag(new Map1) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set1 && getTag(new Set1) != setTag || WeakMap1 && getTag(new WeakMap1) != weakMapTag) getTag = function(value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) switch(ctorString){
                    case dataViewCtorString:
                        return dataViewTag;
                    case mapCtorString:
                        return mapTag;
                    case promiseCtorString:
                        return promiseTag;
                    case setCtorString:
                        return setTag;
                    case weakMapCtorString:
                        return weakMapTag;
                }
                return result;
            };
            module1.exports = getTag;
        /***/ },
        /* 43 */ /***/ function(module1, exports) {
            // shim for using process in browser
            var process = module1.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
            }
            function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
            }
            (function() {
                try {
                    if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = 'browser';
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ''; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
            process.listeners = function(name) {
                return [];
            };
            process.binding = function(name) {
                throw new Error('process.binding is not supported');
            };
            process.cwd = function() {
                return '/';
            };
            process.chdir = function(dir) {
                throw new Error('process.chdir is not supported');
            };
            process.umask = function() {
                return 0;
            };
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _undefined = __webpack_require__(405)(); // Support ES3 engines
            module1.exports = function(val) {
                return val !== _undefined && val !== null;
            };
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(419)() ? __webpack_require__(92).Symbol : __webpack_require__(422);
        /***/ },
        /* 46 */ /***/ function(module1, exports) {
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            module1.exports = _createClass;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            var isSymbol = __webpack_require__(71);
            /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
            /**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) return value;
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            module1.exports = toKey;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            var basePick = __webpack_require__(520), flatRest = __webpack_require__(137);
            /**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
                return object == null ? {} : basePick(object, paths);
            });
            module1.exports = pick;
        /***/ },
        /* 49 */ /***/ function(module1, exports) {
            function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                subClass.__proto__ = superClass;
            }
            module1.exports = _inheritsLoose;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const performance1 = window.performance || {};
            /**
 * Returns the number of milliseconds since the the UNIX epoch
 *
 * When available (performance api exists), this function will not be skewed
 * by clock adjustments. Only use if you require this functionality, otherwise
 * use Date.now().
 *
 * @returns {number} Number of milliseconds since UNIX epoch
 */ module1.exports = function highResolutionNow() {
                if (performance1.now) return performance1.timing.navigationStart + performance1.now();
                return Date.now();
            };
        /***/ },
        /* 51 */ /***/ function(module1, exports, __webpack_require__) {
            var before = __webpack_require__(586);
            /**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function once(func) {
                return before(2, func);
            }
            module1.exports = once;
        /***/ },
        /* 52 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ const once = __webpack_require__(51);
            const StaticConfig = __webpack_require__(35)(); // Indicates whether this client supports WebRTC
            //
            // This is defined as: getUserMedia + PeerConnection + exceeds min browser version
            //
            exports.check = function(deps) {
                if (deps === void 0) deps = {};
                const env = deps.env || __webpack_require__(3);
                const hasGetUserMediaCapability = deps.hasGetUserMediaCapability || __webpack_require__(594);
                const hasPeerConnectionCapability = deps.hasPeerConnectionCapability || __webpack_require__(595);
                const logging = deps.logging || __webpack_require__(2)('hasOpenTokSupport');
                /** @type StaticConfig */ const staticConfig = deps.staticConfig || StaticConfig.onlyLocal();
                const minimumVersions = staticConfig.minimumVersion || {};
                const minimumVersion = minimumVersions[env.name.toLowerCase()];
                if (minimumVersion && minimumVersion > env.version) {
                    logging.debug('Support for', env.name, 'is disabled because we require', minimumVersion, 'but this is', env.version);
                    return false;
                }
                if (env.name === 'Node') // Node works, even though it doesn't have getUserMedia
                return true;
                return hasGetUserMediaCapability() && hasPeerConnectionCapability();
            };
            exports.once = once(()=>exports.check());
        /***/ },
        /* 53 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                var it;
                if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        return function() {
                            if (i >= o.length) return {
                                done: true
                            };
                            return {
                                done: false,
                                value: o[i++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                it = o[Symbol.iterator]();
                return it.next.bind(it);
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-void, one-var, prefer-const, no-shadow, vars-on-top, no-var */ /* eslint-disable no-mixed-operators */ const assign = __webpack_require__(9);
            const find = __webpack_require__(62);
            const findIndex = __webpack_require__(273);
            const intersection = __webpack_require__(127);
            const uniq = __webpack_require__(274);
            const logging = __webpack_require__(2)('SDPHelpers');
            const START_MEDIA_SSRC = 10000;
            const START_RTX_SSRC = 20000; // Here are the structure of the rtpmap attribute and the media line, most of the
            // complex Regular Expressions in this code are matching against one of these two
            // formats:
            // * a=rtpmap:<payload type> <encoding name>/<clock rate> [/<encoding parameters>]
            // * m=<media> <port>/<number of ports> <proto> <fmts>
            //
            // References:
            // * https://tools.ietf.org/html/rfc4566
            // * http://en.wikipedia.org/wiki/Session_Description_Protocol
            //
            //
            const SDPHelpers = {
                getSections (sdp) {
                    return sdp.split(/\r\n|\r|\n/).reduce((accum, line)=>{
                        const match = line.match(/^m=(\w+) \d+/);
                        if (match) accum.sections[accum.section = match[1]] = []; // eslint-disable-line no-param-reassign
                        accum.sections[accum.section].push(line);
                        return accum;
                    }, {
                        sections: {
                            header: []
                        },
                        section: 'header'
                    }).sections;
                },
                getCodecsAndCodecMap (sdp, mediaType) {
                    const section = SDPHelpers.getSections(sdp)[mediaType];
                    if (!section) throw new Error(`no mediaType ${mediaType}`);
                    const codecs = section[0].match(/m=\w+ \d+ [A-Z/]+ ([\d ]+)$/)[1].split(' ');
                    const codecMap = assign(...section.filter((line)=>line.match(/^a=rtpmap:\d+/)).map((line)=>line.match(/^a=rtpmap:(\d+) ([\w-]+)/).splice(1)).map((_ref)=>{
                        let num = _ref[0], codec = _ref[1];
                        return {
                            [num]: codec
                        };
                    }));
                    return {
                        codecs: codecs,
                        codecMap: codecMap
                    };
                },
                getCodecs (sdp, mediaType) {
                    const codecsAndCodecMap = SDPHelpers.getCodecsAndCodecMap(sdp, mediaType);
                    return codecsAndCodecMap.codecs.map((num)=>codecsAndCodecMap.codecMap[num] || 'Unknown codec');
                },
                mediaDirections: {
                    INACTIVE: 'inactive',
                    RECVONLY: 'recvonly'
                }
            };
            module1.exports = SDPHelpers; // Search through sdpLines to find the Media Line of type +mediaType+.
            SDPHelpers.getMLineIndex = function getMLineIndex(sdpLines, mediaType) {
                const targetMLine = `m=${mediaType}`; // Find the index of the media line for +type+
                return findIndex(sdpLines, (line)=>{
                    if (line.indexOf(targetMLine) !== -1) return true;
                    return false;
                });
            }; // Grab a M line of a particular +mediaType+ from sdpLines.
            SDPHelpers.getMLine = function getMLine(sdpLines, mediaType) {
                const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
                return mLineIndex > -1 ? sdpLines[mLineIndex] : void 0;
            };
            SDPHelpers.hasMediaType = (sdp, mediaType)=>{
                const mLineRegex = new RegExp(`^m=${mediaType}`);
                const sdpLines = sdp.split('\r\n');
                return findIndex(sdpLines, (line)=>mLineRegex.test(line)) >= 0;
            };
            SDPHelpers.hasMLinePayloadType = function hasMLinePayloadType(sdpLines, mediaType, payloadType) {
                const mLine = SDPHelpers.getMLine(sdpLines, mediaType);
                const payloadTypes = SDPHelpers.getMLinePayloadTypes(mLine, mediaType);
                return payloadTypes.indexOf(payloadType) > -1;
            }; // Extract the payload types for a give Media Line.
            //
            SDPHelpers.getMLinePayloadTypes = function getMLinePayloadTypes(mediaLine, mediaType) {
                const mLineSelector = new RegExp(`^m=${mediaType} \\d+(/\\d+)? [a-zA-Z0-9/]+(( [a-zA-Z0-9/]+)+)$`, 'i'); // Get all payload types that the line supports
                const payloadTypes = mediaLine.match(mLineSelector);
                if (!payloadTypes || payloadTypes.length < 2) // Error, invalid M line?
                return [];
                return payloadTypes[2].trim().split(' ');
            }; // Splits SDP into sessionpart and mediasections. Ensures CRLF.
            SDPHelpers.splitSections = function splitSections(sdp) {
                const parts = sdp.split('\nm='); // eslint-disable-next-line prefer-template
                return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
            }; // Changes the media direction
            SDPHelpers.changeMediaDirection = function changeMediaDirection(sdp, newDirection) {
                const replaceDirection = (mediaSdpPart)=>{
                    const currentDirection = newDirection === SDPHelpers.mediaDirections.RECVONLY ? 'a=inactive' : 'a=recvonly';
                    const regex = new RegExp(currentDirection, 'g');
                    return mediaSdpPart.replace(regex, `a=${newDirection}`);
                }; // Splits SDP into session part and media sections.
                const sections = SDPHelpers.splitSections(sdp); // Preserve the session part since we don't need to modify it.
                const sessionSdpPart = sections.shift();
                let newSdp = sessionSdpPart; // Replace all the recvonly by inactive or viceversa, depending the active argument
                sections.forEach((section)=>{
                    // Only video is set to inactive/recvonly
                    const mediaSection = section.includes('m=video') ? replaceDirection(section) : section;
                    newSdp += mediaSection;
                }); // Return the session and new media sections concatenated
                return newSdp;
            };
            SDPHelpers.removeTypesFromMLine = function removeTypesFromMLine(mediaLine, payloadTypes) {
                const typesSuffix = /[0-9 ]*$/.exec(mediaLine)[0];
                const newTypes = typesSuffix.split(' ').filter((type)=>type !== '' && payloadTypes.indexOf(type) === -1);
                return mediaLine.replace(typesSuffix, ` ${newTypes.join(' ')}`);
            }; // Remove all references to a particular encodingName from a particular media type
            //
            SDPHelpers.removeMediaEncoding = function removeMediaEncoding(sdp, mediaType, encodingName) {
                let payloadTypes, i, j, parts;
                let sdpLines = sdp.split('\r\n');
                const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
                const mLine = mLineIndex > -1 ? sdpLines[mLineIndex] : void 0;
                const typesToRemove = [];
                if (mLineIndex === -1) // Error, missing M line
                return sdpLines.join('\r\n');
                 // Get all payload types that the line supports
                payloadTypes = SDPHelpers.getMLinePayloadTypes(mLine, mediaType);
                if (payloadTypes.length === 0) // Error, invalid M line?
                return sdpLines.join('\r\n');
                 // Find the payloadTypes of the codecs.
                // Allows multiple matches e.g. for CN.
                for(i = mLineIndex; i < sdpLines.length; i++){
                    const codecRegex = new RegExp(encodingName, 'i');
                    if (sdpLines[i].indexOf('a=rtpmap:') === 0) {
                        parts = sdpLines[i].split(' ');
                        if (parts.length === 2 && codecRegex.test(parts[1])) typesToRemove.push(parts[0].substr(9));
                    }
                }
                if (!typesToRemove.length) // Not found.
                return sdpLines.join('\r\n');
                 // Also find any rtx which reference the removed codec.
                for(i = mLineIndex; i < sdpLines.length; i++)if (sdpLines[i].indexOf('a=fmtp:') === 0) {
                    parts = sdpLines[i].split(' ');
                    for(j = 0; j < typesToRemove.length; j++)if (parts.length === 2 && parts[1] === `apt=${typesToRemove[j]}`) typesToRemove.push(parts[0].substr(7));
                }
                 // Remove any rtpmap, fmtp or rtcp-fb.
                sdpLines = sdpLines.filter((line)=>{
                    for(let i = 0; i < typesToRemove.length; i++){
                        if (line.indexOf(`a=rtpmap:${typesToRemove[i]} `) === 0 || line.indexOf(`a=fmtp:${typesToRemove[i]} `) === 0 || line.indexOf(`a=rtcp-fb:${typesToRemove[i]} `) === 0) return false;
                    }
                    return true;
                });
                if (typesToRemove.length > 0 && mLineIndex > -1) // Remove all the payload types and we've removed from the media line
                sdpLines[mLineIndex] = SDPHelpers.removeTypesFromMLine(mLine, typesToRemove);
                return sdpLines.join('\r\n');
            };
            SDPHelpers.disableMediaType = function disableMediaType(sdp, mediaType) {
                const lines = sdp.split('\r\n');
                const blocks = [];
                let block; // Separating SDP into blocks. This usually follows the form:
                // Header block:
                //   v=0
                //   ...
                // Audio block:
                //   m=audio
                //   ...
                // Video block:
                //   m=video
                //   ...
                lines.forEach((lineParam)=>{
                    let line = lineParam;
                    if (/^m=/.test(line)) block = undefined;
                    if (!block) {
                        block = [];
                        blocks.push(block);
                    }
                    block.push(line);
                }); // Now disable the block for the specified media type
                const mLineRegex = new RegExp(`^m=${mediaType} \\d+ ([^ ]+) [0-9 ]+$`);
                const fixedBlocks = blocks.map((block)=>{
                    const match = block[0].match(mLineRegex);
                    if (match) return [
                        `m=${mediaType} 0 ${match[1]} 0`,
                        'a=inactive',
                        ...block.filter((line)=>/^c=/.test(line) || /^a=mid:/.test(line) || line === '' // This preserves the trailing newline
                        )
                    ];
                    return block;
                });
                return [].concat(...fixedBlocks).join('\r\n');
            };
            SDPHelpers.removeVideoCodec = function removeVideoCodec(sdp, codec) {
                return SDPHelpers.removeMediaEncoding(sdp, 'video', codec);
            }; // Used to identify whether Video media (for a given set of SDP) supports
            // retransmissions.
            //
            // The algorithm to do could be summarised as:
            //
            // IF ssrc-group:FID exists AND IT HAS AT LEAST TWO IDS THEN
            //    we are using RTX
            // ELSE IF "a=rtpmap: (\\d+):rtxPayloadId(/\\d+)? rtx/90000"
            //          AND SDPHelpers.hasMLinePayloadType(sdpLines, 'Video', rtxPayloadId)
            //    we are using RTX
            // ELSE
            //    we are not using RTX
            //
            // The ELSE IF clause basically covers the case where ssrc-group:FID
            // is probably malformed or missing. In that case we verify whether
            // we want RTX by looking at whether it's mentioned in the video
            // media line instead.
            //
            const isUsingRTX = function isUsingRTX(sdpLines, videoAttrs) {
                let groupFID = videoAttrs.filterByName('ssrc-group:FID');
                const missingFID = groupFID.length === 0;
                if (!missingFID) groupFID = groupFID[0].value.split(' ');
                else groupFID = [];
                switch(groupFID.length){
                    case 0:
                    case 1:
                        // possibly no RTX, double check for the RTX payload type and that
                        // the Video Media line contains that payload type
                        //
                        // Details: Look for a rtpmap line for rtx/90000
                        //  If there is one, grab the payload ID for rtx
                        //    Look to see if that payload ID is listed under the payload types for the m=Video line
                        //      If it is: RTX
                        //  else: No RTX for you
                        var rtxAttr = videoAttrs.find((attr)=>attr.name.indexOf('rtpmap:') === 0 && attr.value.indexOf('rtx/90000') > -1);
                        if (!rtxAttr) return false;
                        var rtxPayloadId = rtxAttr.name.split(':')[1];
                        if (rtxPayloadId.indexOf('/') > -1) rtxPayloadId = rtxPayloadId.split('/')[0];
                        return SDPHelpers.hasMLinePayloadType(sdpLines, 'video', rtxPayloadId);
                    default:
                        // two or more: definitely RTX
                        logging.debug('SDP Helpers: There are more than two FIDs, RTX is definitely enabled');
                        return true;
                }
            }; // This returns an Array, which is decorated with several
            // SDP specific helper methods.
            //
            SDPHelpers.getAttributesForMediaType = function getAttributesForMediaType(sdpLines, mediaType) {
                let ssrcStartIndex, ssrcEndIndex, regResult, ssrc, ssrcGroup, ssrcLine, msidMatch, msid, mid, midIndex;
                const mLineIndex = SDPHelpers.getMLineIndex(sdpLines, mediaType);
                const matchOtherMLines = new RegExp(`m=(?!${mediaType}).+ `, 'i');
                const matchSSRCLines = new RegExp('a=ssrc:\\d+ .*', 'i');
                const matchSSRCGroup = new RegExp('a=ssrc-group:(SIM|FID) (\\d+).*?', 'i');
                const matchAttrLine = new RegExp('a=([a-z0-9:/-]+) (.*)', 'i');
                const attrs = [];
                for(let i = mLineIndex + 1; i < sdpLines.length; i++){
                    // If we were inside an SSRC block and we've now reached an m-line, then
                    // tag the previous line as the end of the SSRC block
                    if (matchOtherMLines.test(sdpLines[i])) {
                        if (ssrcStartIndex !== undefined) ssrcEndIndex = i - 1;
                        break;
                    } // Get the ssrc
                    ssrcGroup = sdpLines[i].match(matchSSRCGroup);
                    ssrcLine = sdpLines[i].match(matchSSRCLines);
                    if (ssrcStartIndex === undefined && (ssrcGroup || ssrcLine)) {
                        // We found the start of an SSRC block
                        ssrcStartIndex = i;
                        if (ssrcGroup) ssrc = /^(FID|SIM)$/.test(ssrcGroup[1]) ? ssrcGroup[2] : ssrcGroup[1];
                    } // Get the msid
                    msidMatch = sdpLines[i].match(`a=ssrc:${ssrc} msid:(.+)`);
                    if (msidMatch) msid = msidMatch[1];
                     // find where the ssrc lines end
                    const isSSRCLine = matchSSRCLines.test(sdpLines[i]);
                    const isSSRCGroup = matchSSRCGroup.test(sdpLines[i]);
                    if (ssrcStartIndex !== undefined) {
                        if (ssrcEndIndex === undefined && !isSSRCLine && !isSSRCGroup) // If we were inside an SSRC block and we've now reached a non-SSRC
                        // line, then tag the previous line as the end of the SSRC block
                        ssrcEndIndex = i - 1;
                        else if (i === sdpLines.length - 1) // If we were inside an SSRC block and we've now reached the end of the
                        // offer, tag the last line as the end of the SSRC block
                        ssrcEndIndex = i;
                    }
                    const midMatch = sdpLines[i].match(/a=mid:(.+)/);
                    if (midMatch) {
                        mid = midMatch[1];
                        midIndex = i;
                    }
                    regResult = matchAttrLine.exec(sdpLines[i]);
                    if (regResult && regResult.length === 3) attrs.push({
                        lineIndex: i,
                        name: regResult[1],
                        value: regResult[2]
                    });
                } // / The next section decorates the attributes array
                // / with some useful helpers.
                // Store references to the start and end indices
                // of the media section for this mediaType
                attrs.ssrcStartIndex = ssrcStartIndex;
                attrs.ssrcEndIndex = ssrcEndIndex;
                attrs.msid = msid;
                attrs.mid = mid;
                attrs.midIndex = midIndex;
                attrs.isUsingRTX = isUsingRTX.bind(null, sdpLines, attrs);
                attrs.filterByName = function filterByName(name) {
                    return this.filter((attr)=>attr.name === name);
                };
                attrs.getRtpNumber = (mediaEncoding)=>{
                    const namePattern = new RegExp('rtpmap:(.+)');
                    return find(attrs.map((attr)=>{
                        const nameMatch = attr.name.match(namePattern);
                        if (nameMatch && attr.value.indexOf(mediaEncoding) >= 0) return nameMatch[1];
                        return null;
                    }), (attr)=>attr !== null);
                };
                return attrs;
            };
            SDPHelpers.modifyDtx = (sdp, enable)=>{
                const sdpLines = sdp.split('\r\n');
                if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
                    logging.debug('No audio m-line, not enabling dtx.');
                    return sdp;
                }
                const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
                const rtpNumber = audioAttrs.getRtpNumber('opus');
                if (!rtpNumber) {
                    logging.debug('Could not find rtp number for opus, not enabling dtx.');
                    return sdp;
                }
                const fmtpAttr = audioAttrs.find((attr)=>attr.name === `fmtp:${rtpNumber}`);
                if (!fmtpAttr) {
                    logging.debug('Could not find a=fmtp line for opus, not enabling dtx.');
                    return sdp;
                }
                let line = sdpLines[fmtpAttr.lineIndex];
                const pattern = /usedtx=\d+([\s;]*)/;
                if (pattern.test(fmtpAttr.value)) line = line.replace(pattern, enable ? 'usedtx=1$1' : '');
                else if (enable) line += '; usedtx=1';
                 // Trim any trailing whitespace and semicolons
                line = line.replace(/[;\s]*$/, '');
                sdpLines[fmtpAttr.lineIndex] = line;
                return sdpLines.join('\r\n');
            };
            const modifyStereo = (type, sdp, enable)=>{
                const sdpLines = sdp.split('\r\n');
                if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
                    logging.debug('No audio m-line, not enabling stereo.');
                    return sdp;
                }
                const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
                const rtpNumber = audioAttrs.getRtpNumber('opus');
                if (!rtpNumber) {
                    logging.debug('Could not find rtp number for opus, not enabling stereo.');
                    return sdp;
                }
                const fmtpAttr = audioAttrs.find((attr)=>attr.name === `fmtp:${rtpNumber}`);
                if (!fmtpAttr) {
                    logging.debug('Could not find a=fmtp line for opus, not enabling stereo.');
                    return sdp;
                }
                let line = sdpLines[fmtpAttr.lineIndex];
                let pattern;
                switch(type){
                    case 'send':
                        pattern = /sprop-stereo=\d+([\s;]*)/;
                        if (pattern.test(fmtpAttr.value)) line = line.replace(pattern, enable ? 'sprop-stereo=1$1' : '');
                        else if (enable) line += '; sprop-stereo=1';
                        break;
                    case 'receive':
                        pattern = /([^-])stereo=\d+([\s;]*)/;
                        if (pattern.test(fmtpAttr.value)) line = line.replace(pattern, enable ? '$1stereo=1$2' : '$1');
                        else if (enable) line += '; stereo=1';
                        break;
                    default:
                        throw new Error(`Invalid type ${type} passed into enableStereo`);
                } // Trim any trailing whitespace and semicolons
                line = line.replace(/[;\s]*$/, '');
                sdpLines[fmtpAttr.lineIndex] = line;
                return sdpLines.join('\r\n');
            };
            SDPHelpers.modifySendStereo = modifyStereo.bind(null, 'send');
            SDPHelpers.modifyReceiveStereo = modifyStereo.bind(null, 'receive');
            SDPHelpers.setAudioBitrate = (sdp, audioBitrate)=>{
                const existingValue = SDPHelpers.getAudioBitrate(sdp);
                if (existingValue !== undefined) {
                    logging.debug(`Audio bitrate already set to ${existingValue}, not setting audio bitrate`);
                    return sdp;
                }
                const sdpLines = sdp.split('\r\n');
                if (!SDPHelpers.getMLine(sdpLines, 'audio')) {
                    logging.debug('No audio m-line, not setting audio bitrate');
                    return sdp;
                }
                const audioAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'audio');
                const rtpNumber = audioAttrs.getRtpNumber('opus');
                if (!rtpNumber) {
                    logging.debug('Could not find rtp number for opus, not setting audio bitrate.');
                    return sdp;
                }
                const fmtpAttr = audioAttrs.find((attr)=>attr.name === `fmtp:${rtpNumber}`);
                if (!fmtpAttr) {
                    logging.debug('Could not find a=fmtp line for opus, not setting audio bitrate.');
                    return sdp;
                }
                let line = sdpLines[fmtpAttr.lineIndex];
                line += `; maxaveragebitrate=${audioBitrate}`; // Trim any trailing whitespace and semicolons
                line = line.replace(/[;\s]*$/, '');
                sdpLines[fmtpAttr.lineIndex] = line;
                return sdpLines.join('\r\n');
            };
            SDPHelpers.removeVideoOrientation = (sdp)=>{
                let sdpLines = sdp.split('\r\n'); // We don't bother to limit this filter to only the video m-section since
                // this attribute isn't applicable to audio.
                sdpLines = sdpLines.filter((line)=>!line.includes('urn:3gpp:video-orientation'));
                return sdpLines.join('\r\n');
            };
            SDPHelpers.hasSendStereo = (sdp)=>/[\s;]sprop-stereo=1/.test(sdp);
            SDPHelpers.hasSendDtx = (sdp)=>/[\s;]usedtx=1/.test(sdp);
            SDPHelpers.getAudioBitrate = (sdp)=>{
                const result = sdp.match(/[\s;]maxaveragebitrate=(\d+)/);
                if (result) return Number(result[1]);
                return undefined;
            }; // Safety limit of unique media SSRCs allowed in an SDP offer
            SDPHelpers.MAX_SSRCS = 10;
            SDPHelpers.getSSRCGroupType = (videoAttrs)=>{
                const TYPES = [
                    'SIM',
                    'FID'
                ]; // Note: this returns `undefined` if SDP has neither type in `TYPES`
                return TYPES.find((type)=>{
                    const _videoAttrs$filterByN = videoAttrs.filterByName(`ssrc-group:${type}`), exists = _videoAttrs$filterByN[0];
                    return exists;
                });
            };
            SDPHelpers.getSSRCGroup = (videoAttrs)=>{
                const ssrcGroupType = SDPHelpers.getSSRCGroupType(videoAttrs); // The first group takes precedence
                const _videoAttrs$filterByN2 = videoAttrs.filterByName(`ssrc-group:${ssrcGroupType}`), ssrcGroup = _videoAttrs$filterByN2[0];
                return ssrcGroup;
            };
            SDPHelpers.getSSRCGroupSSRCs = (videoAttrs)=>{
                const ssrcGroup = SDPHelpers.getSSRCGroup(videoAttrs); // If no group type was found, then there's nothing to filter
                if (!ssrcGroup) return [];
                return ssrcGroup.value.split(' ').slice(0, SDPHelpers.MAX_SSRCS);
            };
            SDPHelpers.getAllowedSSRCs = (videoAttrs, ssrcGroupSSRCs)=>{
                // All SSRCs in the ssrc-group are allowed
                const allowedSSRCs = ssrcGroupSSRCs.slice(); // We need to allow the SSRCs that belong to the same FID group
                videoAttrs.filterByName('ssrc-group:FID').forEach((fid)=>{
                    const ssrcs = fid.value.split(' ');
                    const isAllowed = intersection(allowedSSRCs, ssrcs).length;
                    if (isAllowed) Array.prototype.push.apply(allowedSSRCs, ssrcs);
                });
                return uniq(allowedSSRCs);
            };
            SDPHelpers.filterExcessSSRCs = (sdp)=>{
                const sdpLines = sdp.split('\r\n');
                const videoAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'video');
                const ssrcGroupType = SDPHelpers.getSSRCGroupType(videoAttrs);
                const ssrcGroupIndex = videoAttrs.ssrcStartIndex; // This is only possible in an audio-only session
                if (ssrcGroupIndex === undefined) return sdp;
                let allowedSSRCs; // Returns the SSRC ID from the SDP line if it exists, otherwise returns null
                const getSSRCid = (line)=>{
                    let ssrc = null;
                    if (line.match(/^a=ssrc:(\d+)/)) ssrc = RegExp.$1;
                    return ssrc;
                };
                if (ssrcGroupType) {
                    // Update ssrc-group with allowed SSRCs
                    const ssrcGroupSSRCs = SDPHelpers.getSSRCGroupSSRCs(videoAttrs);
                    const ssrcGroupLine = [
                        `a=ssrc-group:${ssrcGroupType}`,
                        ...ssrcGroupSSRCs
                    ].join(' ');
                    const indexToReplace = videoAttrs.find((attr)=>attr.name.startsWith('ssrc-group:')).lineIndex;
                    sdpLines[indexToReplace] = ssrcGroupLine;
                    allowedSSRCs = SDPHelpers.getAllowedSSRCs(videoAttrs, ssrcGroupSSRCs);
                } else {
                    // No ssrc-group was defined.  No SSRCs are allowed, so all isolated
                    // (non-audio) SSRCs will be removed.
                    allowedSSRCs = []; // We want to allow through a single, isolated, video ssrc which may occur in P2P sessions
                    const hasIsolatedSSRCs = videoAttrs.ssrcStartIndex;
                    if (hasIsolatedSSRCs) // Parse the ssrc ID
                    allowedSSRCs.push(getSSRCid(sdpLines[videoAttrs.ssrcStartIndex]));
                } // Cleans up the SDP, by removing all SSRC-related lines that aren't allowed
                const filteredSdpLines = sdpLines.filter((line, index)=>{
                    // Passthrough lines outside the SSRC block
                    if (index < ssrcGroupIndex || index > videoAttrs.ssrcEndIndex) return true;
                    if (index === ssrcGroupIndex) {
                        if (!ssrcGroupType) {
                            const ssrcID = getSSRCid(line);
                            if (ssrcID) return allowedSSRCs.includes(ssrcID);
                             // Filter out isolated SSRCs, since no ssrc-group was found
                            return !/^a=ssrc:(\d+)/.test(line);
                        }
                        return true;
                    } // Make sure SSRC is allowed
                    const ssrcID = getSSRCid(line);
                    if (ssrcID) return allowedSSRCs.includes(ssrcID);
                     // Make sure SSRCs in FID are allowed
                    if (line.match(/^a=ssrc-group:FID (\d+)/)) {
                        const ssrc = RegExp.$1;
                        return allowedSSRCs.includes(ssrc);
                    } // Avoid adding more than one sim group
                    return !line.match(/^a=ssrc-group:SIM /);
                });
                return filteredSdpLines.join('\r\n');
            }; // Modifies +sdp+ to enable Simulcast for +numberOfStreams+.
            //
            // Ok, here's the plan:
            //  - add the 'a=ssrc-group:SIM' line, it will have numberOfStreams ssrcs
            //  - if RTX then add one 'a=ssrc-group:FID', we need to add numberOfStreams lines
            //  - add numberOfStreams 'a=ssrc:...' lines for the media ssrc
            //  - if RTX then add numberOfStreams 'a=ssrc:...' lines for the RTX ssrc
            //
            // Re: media and rtx ssrcs:
            // We just generate these. The Mantis folk would like us to use sequential numbers
            // here for ease of debugging. We can use the same starting number each time as well.
            // We should confirm with Oscar/Jose that whether we need to verify that the numbers
            // that we choose don't clash with any other ones in the SDP.
            //
            // I think we do need to check but I can't remember.
            //
            // Re: The format of the 'a=ssrc:' lines
            // Just use the following pattern:
            //   a=ssrc:<Media or RTX SSRC> cname:localCname
            //   a=ssrc:<Media or RTX SSRC> msid:<MSID>
            //
            // It doesn't matter that they are all the same and are static.
            //
            //
            SDPHelpers.enableSimulcast = function enableSimulcast(sdp, numberOfStreams) {
                let linesToAdd, i;
                const sdpLines = sdp.split('\r\n');
                if (!SDPHelpers.getMLine(sdpLines, 'video')) {
                    logging.debug('No video m-line, not enabling simulcast.');
                    return sdp;
                }
                const videoAttrs = SDPHelpers.getAttributesForMediaType(sdpLines, 'video');
                if (videoAttrs.filterByName('ssrc-group:SIM').length > 0) {
                    logging.debug('Simulcast is already enabled in this SDP, not attempting to enable again.'); // We clean the SDP in case it somehow has SSRCs unrelated to the ssrc-group
                    return SDPHelpers.filterExcessSSRCs(sdp);
                }
                if (!videoAttrs.msid) {
                    logging.debug('No local stream attached, not enabling simulcast.');
                    return sdp;
                }
                const usingRTX = videoAttrs.isUsingRTX();
                const mediaSSRC = [];
                const rtxSSRC = []; // generate new media (and rtx if needed) ssrcs
                for(i = 0; i < numberOfStreams; ++i){
                    mediaSSRC.push(START_MEDIA_SSRC + i);
                    if (usingRTX) rtxSSRC.push(START_RTX_SSRC + i);
                }
                linesToAdd = [
                    `a=ssrc-group:SIM ${mediaSSRC.join(' ')}`
                ];
                if (usingRTX) for(i = 0; i < numberOfStreams; ++i)linesToAdd.push(`a=ssrc-group:FID ${mediaSSRC[i]} ${rtxSSRC[i]}`);
                for(i = 0; i < numberOfStreams; ++i)linesToAdd.push(`a=ssrc:${mediaSSRC[i]} cname:localCname`, `a=ssrc:${mediaSSRC[i]} msid:${videoAttrs.msid}`);
                if (usingRTX) for(i = 0; i < numberOfStreams; ++i)linesToAdd.push(`a=ssrc:${rtxSSRC[i]} cname:localCname`, `a=ssrc:${rtxSSRC[i]} msid:${videoAttrs.msid}`);
                 // Replace the previous video ssrc section with our new video ssrc section by
                // deleting the old ssrcs section and inserting the new lines
                linesToAdd.unshift(videoAttrs.ssrcStartIndex, videoAttrs.ssrcEndIndex - videoAttrs.ssrcStartIndex + 1);
                sdpLines.splice(...linesToAdd);
                return sdpLines.join('\r\n');
            };
            SDPHelpers.reprioritizeVideoCodec = function reprioritizeVideoCodec(sdp, codec, location1) {
                const lines = sdp.split('\r\n');
                const mLineIndex = SDPHelpers.getMLineIndex(lines, 'video');
                if (mLineIndex === -1) return sdp;
                const payloadTypes = SDPHelpers.getMLinePayloadTypes(lines[mLineIndex], 'video');
                const regex = new RegExp(`^a=rtpmap:(\\d+).* ${codec}`, 'i');
                const codecMatches = lines.map((line)=>line.match(regex)).filter((match)=>match !== null);
                if (codecMatches.length === 0) return sdp;
                const codecTypeCodes = codecMatches.map((match)=>match[1]);
                let newPayloadTypes = payloadTypes.filter((t)=>codecTypeCodes.indexOf(t) === -1);
                if (location1 === 'top') newPayloadTypes.unshift(...codecTypeCodes);
                else if (location1 === 'bottom') newPayloadTypes.push(...codecTypeCodes);
                else {
                    logging.error(`Unexpected location param: ${location1}; not changing ${codec} priority`);
                    newPayloadTypes = payloadTypes;
                }
                const newMLine = lines[mLineIndex].replace(payloadTypes.join(' '), newPayloadTypes.join(' '));
                lines[mLineIndex] = newMLine;
                return lines.join('\r\n');
            };
            SDPHelpers.getSetupRole = (sdp)=>{
                // eslint-disable-next-line no-restricted-syntax
                for(var _iterator = _createForOfIteratorHelperLoose(sdp.split(/\r\n|\r|\n/)), _step; !(_step = _iterator()).done;){
                    const line = _step.value;
                    const match = line.match(/^a=setup:(\w+)/);
                    if (match) return match[1];
                }
                return '';
            };
            SDPHelpers.setSetupRole = (sdp, setupRole)=>sdp.split(/\r\n|\r|\n/).map((line)=>{
                    if (line.match(/^a=setup:(\w+)/)) return `a=setup:${setupRole}`;
                    return line;
                }).join('\r\n');
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            /**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            module1.exports = eq;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayLikeKeys = __webpack_require__(178), baseKeysIn = __webpack_require__(381), isArrayLike = __webpack_require__(25);
            /**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            module1.exports = keysIn;
        /***/ },
        /* 56 */ /***/ function(module1, exports) {
            /**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
                var index = -1, length = source.length;
                array || (array = Array(length));
                while(++index < length)array[index] = source[index];
                return array;
            }
            module1.exports = copyArray;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // ES3 safe
            var _undefined = void 0;
            module1.exports = function(value) {
                return value !== _undefined && value !== null;
            };
        /***/ },
        /* 58 */ /***/ function(module1, exports, __webpack_require__) {
            var baseClone = __webpack_require__(78);
            /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
            /**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            module1.exports = cloneDeep;
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGet = __webpack_require__(99);
            /**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            module1.exports = get;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            var isArray = __webpack_require__(12), isKey = __webpack_require__(136), stringToPath = __webpack_require__(236), toString = __webpack_require__(61);
            /**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
                if (isArray(value)) return value;
                return isKey(value, object) ? [
                    value
                ] : stringToPath(toString(value));
            }
            module1.exports = castPath;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            var baseToString = __webpack_require__(510);
            /**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
                return value == null ? '' : baseToString(value);
            }
            module1.exports = toString;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            var createFind = __webpack_require__(609), findIndex = __webpack_require__(273);
            /**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
            module1.exports = find;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function eventHelper(object) {
                const eventHandlers = [];
                return {
                    on (eventName, handler) {
                        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                        eventHandlers.push({
                            eventName: eventName,
                            handler: handler,
                            args: args
                        });
                        if (object.on) object.on(eventName, handler);
                        else if (object.addEventListener) object.addEventListener(eventName, handler, ...args);
                        else throw new Error('Object does not support events', object);
                    },
                    off (eventName, handler) {
                        if (object.off) object.off(eventName, handler);
                        else if (object.removeEventListener) {
                            for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                            object.removeEventListener(eventName, handler, ...args);
                        } else throw new Error('Object does not support events', object);
                    },
                    once (eventName, handler) {
                        for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
                        eventHandlers.push({
                            eventName: eventName,
                            handler: handler,
                            args: args
                        });
                        object.once(eventName, handler);
                    },
                    removeAll () {
                        eventHandlers.forEach((_ref)=>{
                            let eventName = _ref.eventName, handler = _ref.handler, args = _ref.args;
                            this.off(eventName, handler, ...args);
                        });
                        eventHandlers.splice(0, eventHandlers.length);
                    }
                };
            };
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            var defineProperty = __webpack_require__(176);
            /**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            module1.exports = baseAssignValue;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsArguments = __webpack_require__(376), isObjectLike = __webpack_require__(18);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
            /**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
                return arguments;
            }()) ? baseIsArguments : function(value) {
                return isObjectLike(value) && hasOwnProperty1.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            module1.exports = isArguments;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(module1) {
                var root = __webpack_require__(14), stubFalse = __webpack_require__(377);
                /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
                /** Detect free variable `module`. */ var freeModule = freeExports && typeof module1 == 'object' && module1 && !module1.nodeType && module1;
                /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
                /** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
                /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
                /**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
                module1.exports = isBuffer;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(85)(module1));
        /***/ },
        /* 67 */ /***/ function(module1, exports) {
            /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
            /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
            /**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
                var type = typeof value;
                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            module1.exports = isIndex;
        /***/ },
        /* 68 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
                return function(value) {
                    return func(value);
                };
            }
            module1.exports = baseUnary;
        /***/ },
        /* 69 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
                var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
            }
            module1.exports = isPrototype;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(fn) {
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                return fn;
            };
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
            /**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
                return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            module1.exports = isSymbol;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const OTHelpers = __webpack_require__(8);
            if (OTHelpers.env.name === 'Node') module1.exports = {
                value: ''
            };
            else {
                var _Array$prototype$slic, _Array$prototype$slic2;
                // Script embed
                const scriptSrc = (_Array$prototype$slic = Array.prototype.slice.call(document.getElementsByTagName('script'))) == null ? void 0 : (_Array$prototype$slic2 = _Array$prototype$slic.pop()) == null ? void 0 : _Array$prototype$slic2.getAttribute('src');
                const _ref = scriptSrc && scriptSrc.match(/[?&]apikey=([^&]+)/i) || [], apiKey = _ref[1]; // TODO: The indirection here is due to the need to set APIKEY in testing. We should find a better
                // solution.
                module1.exports = {
                    value: apiKey || ''
                };
            }
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable one-var, no-underscore-dangle, no-use-before-define, no-param-reassign */ /* eslint-disable max-len, no-var, vars-on-top, global-require */ const promiseTimeout = __webpack_require__(153);
                const now = __webpack_require__(50);
                const assign = __webpack_require__(9);
                const cloneDeep = __webpack_require__(58);
                const intersection = __webpack_require__(127);
                const omit = __webpack_require__(272);
                const uuid = __webpack_require__(16);
                const eventing = __webpack_require__(7);
                const OTHelpersError = __webpack_require__(250);
                const createCleanupJobs = __webpack_require__(154);
                const SDPHelpers = __webpack_require__(53);
                const shouldUsePlanBSDP = __webpack_require__(74);
                const extractSenderId = __webpack_require__(612);
                module1.exports = function PeerConnectionFactory(deps) {
                    if (deps === void 0) deps = {};
                    const hasValidPeerConnection = deps.hasValidPeerConnection || __webpack_require__(613);
                    const applySdpTransform = deps.applySdpTransform || __webpack_require__(155);
                    const createPeerConnection = deps.createPeerConnection || __webpack_require__(614);
                    const env = deps.env || __webpack_require__(3);
                    const sdpTransformDefaults = deps.sdpTransformDefaults || __webpack_require__(616);
                    const getStatsAdapter = deps.getStatsAdapter || __webpack_require__(275);
                    const getRtcStatsReportAdapter = deps.getRtcStatsReportAdapter || __webpack_require__(278);
                    const getSynchronizationSources = deps.getSynchronizationSources || __webpack_require__(620);
                    const IceCandidateProcessor = deps.IceCandidateProcessor || __webpack_require__(621);
                    const createLog = deps.logging || __webpack_require__(2);
                    const offerProcessor = deps.offerProcessor || __webpack_require__(623);
                    const PeerConnectionChannels = deps.PeerConnectionChannels || __webpack_require__(625);
                    const subscribeProcessor = deps.subscribeProcessor || __webpack_require__(627);
                    const _ref = deps.changeMediaDirection || __webpack_require__(628), changeMediaDirectionToInactive = _ref.changeMediaDirectionToInactive, changeMediaDirectionToRecvOnly = _ref.changeMediaDirectionToRecvOnly;
                    const Qos = deps.Qos || __webpack_require__(279).default;
                    const windowMock = deps.global || window;
                    const debounce = deps.debounce || __webpack_require__(632);
                    const needsToSwapH264Profiles = deps.needsToSwapH264Profiles || __webpack_require__(634).once;
                    const futureIsPeerConnectionValid = ()=>hasValidPeerConnection(windowMock.RTCPeerConnection);
                    const NativeRTCIceCandidate = deps.NativeRTCIceCandidate || windowMock.RTCIceCandidate;
                    const NativeRTCSessionDescription = deps.NativeRTCSessionDescription || windowMock.RTCSessionDescription;
                    const Errors = deps.Errors || __webpack_require__(6);
                    const OTErrorClass = deps.OTErrorClass || __webpack_require__(22);
                    const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                    const hasPictureInPictureBug = deps.hasPictureInPictureBug || __webpack_require__(635); // Unified-plan does not transition to failed. Plan-b used to transition after 10 secs (empirically measured)
                    const DISCONNECT_TO_FAILED_TIMEOUT = 10000; // Helper function to forward Ice Candidates via +sendMessage+
                    const iceCandidateForwarder = (_ref2)=>{
                        let sendMessage = _ref2.sendMessage, logging = _ref2.logging;
                        const sdpMids = {};
                        return (event)=>{
                            if (event.candidate) {
                                // It would be better to read the mids from the SDP
                                sdpMids[event.candidate.sdpMid] = event.candidate.sdpMLineIndex;
                                sendMessage('candidate', {
                                    candidate: event.candidate.candidate,
                                    sdpMid: event.candidate.sdpMid || '',
                                    sdpMLineIndex: event.candidate.sdpMLineIndex || 0
                                });
                            } else logging.debug('IceCandidateForwarder: No more ICE candidates.');
                        };
                    };
                    const noop = ()=>{};
                    /*
  * Negotiates a WebRTC PeerConnection.
  *
  * Responsible for:
  * * offer-answer exchange
  * * iceCandidates
  * * notification of remote streams being added/removed
  *
  */ return function PeerConnection(options) {
                        if (options === void 0) options = {};
                        let hasRelayCandidates = false;
                        const _options = options, _options$iceConfig = _options.iceConfig, iceConfig = _options$iceConfig === void 0 ? {
                            servers: []
                        } : _options$iceConfig, isPublisher = _options.isPublisher, offerOverrides = _options.offerOverrides, answerOverrides = _options.answerOverrides, p2p = _options.p2p, codecFlags = _options.codecFlags, sourceStreamId = _options.sourceStreamId, keyStore = _options.keyStore, sFrameClientStore = _options.sFrameClientStore, isE2ee = _options.isE2ee; // Following block can be modified by subsequent actors when SPC. Please see: addOptions
                        // eslint-disable-next-line prefer-const
                        let _options2 = options, _options2$logAnalytic = _options2.logAnalyticsEvent, logAnalyticsEvent = _options2$logAnalytic === void 0 ? noop : _options2$logAnalytic, originalSendMessage = _options2.sendMessage, remoteConnectionId = _options2.remoteConnectionId;
                        let offerAnswerPending = false; // Whether we have an offer out and are waiting for an answer
                        let regenerateOffer = false;
                        let processingOffer = false; // Whether we are currently processing an offer
                        let pendingOfferMessage; // An offer we received that is pending waiting on a previous offer
                        const replaceBaselineProfile = needsToSwapH264Profiles();
                        let offerMessagesReceived = 0; // number of offer or generateoffer messages received
                        let renegotiationInProgress = false;
                        let sFrameReceiverClient;
                        let sFrameSenderClient;
                        let sFrameSenderId;
                        const cleanupJobs = createCleanupJobs();
                        function sendMessage(type, payload) {
                            if (!hasRelayCandidates) {
                                const shouldCheckForRelayCandidates = [
                                    'candidate',
                                    'offer',
                                    'answer',
                                    'pranswer'
                                ].indexOf(type) > -1;
                                if (shouldCheckForRelayCandidates) {
                                    const message = type === 'candidate' ? payload.candidate : payload.sdp;
                                    hasRelayCandidates = message.indexOf('typ relay') !== -1;
                                }
                            }
                            originalSendMessage(type, payload);
                        }
                        const startConnectingTime = now();
                        logAnalyticsEvent('createPeerConnection', 'Attempt');
                        const api = {};
                        api.id = uuid();
                        const logging = createLog(`PeerConnection:${api.id}`);
                        logging.debug('construct', {
                            id: api.id,
                            options: options
                        });
                        const sdpTransforms = sdpTransformDefaults;
                        const shouldFilterCandidate = (candidate)=>iceConfig.transportPolicy === 'relay' && candidate != null && candidate.candidate.indexOf('typ relay') === -1;
                        const config = omit(options, [
                            'isPublisher',
                            'logAnalyticsEvent',
                            'offerOverrides',
                            'answerOverrides',
                            'sendMessage'
                        ]);
                        let _peerConnection, _channels, _offer, _answer, _transitionToFailedTimeOut;
                        let _peerConnectionCompletionHandlers = [];
                        const _simulcastEnabled = (()=>{
                            let value = config.overrideSimulcastEnabled || false;
                            return {
                                get () {
                                    return value;
                                },
                                set (newValueParam) {
                                    const newValue = Boolean(newValueParam) && config.capableSimulcastStreams > 1;
                                    if (newValue !== value && config.overrideSimulcastEnabled === undefined) {
                                        value = newValue;
                                        api.generateOffer();
                                    }
                                }
                            };
                        })();
                        const _iceRestartNeeded = (()=>{
                            let value = false;
                            return {
                                get () {
                                    return value;
                                },
                                set (newValueParam) {
                                    const newValue = Boolean(newValueParam);
                                    if (newValue !== value) {
                                        value = newValue;
                                        if (value && !api.iceConnectionStateIsConnected()) api.generateOffer();
                                        else logging.debug('iceRestart is going to wait until we disconnect and then restart ice');
                                    }
                                }
                            };
                        })(); // OPENTOK-27106: This _readyToSendOffer mechanism is a workaround for a P2P IE->FF issue where
                        // ice candidates sometimes take an excessive amount of time (~10 seconds) to be generated by the
                        // IE plugin. FF will time out if there is a delay like this between receiving the offer and
                        // receiving ice candidates, so the workaround holds back sending the offer until an ice candidate
                        // appears.
                        const _readyToSendOffer = {
                            clean () {
                                delete this.promise;
                                delete this.resolve;
                                delete this.reject;
                            }
                        };
                        _readyToSendOffer.promise = new Promise((resolve, reject)=>{
                            _readyToSendOffer.resolve = resolve;
                            _readyToSendOffer.reject = reject;
                        });
                        let _iceProcessor = new IceCandidateProcessor();
                        let _state = 'new';
                        Object.defineProperty(api, 'signalingState', {
                            get () {
                                return _peerConnection.signalingState;
                            },
                            set (val) {
                                // obviously they should not be doing this, but we'll mimic what the browser does.
                                _peerConnection.signalingState = val;
                                return val;
                            }
                        });
                        eventing(api);
                        api.addOptions = (opt)=>{
                            originalSendMessage = opt.sendMessage;
                            remoteConnectionId = opt.remoteConnectionId;
                            logAnalyticsEvent = opt.logAnalyticsEvent;
                        };
                        api.startEncryption = /*#__PURE__*/ function() {
                            var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(connectionId) {
                                var sharedKey;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            if (isE2ee) {
                                                _context.next = 2;
                                                break;
                                            }
                                            return _context.abrupt("return");
                                        case 2:
                                            sFrameSenderId = extractSenderId(connectionId); // Create an sframe sender client, which is used for encrypting the video and audio of
                                            // a publisher before sending it to the other side.
                                            _context.next = 5;
                                            return sFrameClientStore.createSender(sFrameSenderId);
                                        case 5:
                                            sFrameSenderClient = _context.sent;
                                            _context.next = 8;
                                            return keyStore.get();
                                        case 8:
                                            sharedKey = _context.sent;
                                            _context.next = 11;
                                            return sFrameSenderClient.setSenderEncryptionKey(sharedKey);
                                        case 11:
                                            keyStore.on('keyChanged', (key)=>{
                                                sFrameSenderClient.setSenderEncryptionKey(key);
                                            }); // SFrame uses the RTCRtpSender objects (transceiver.sender) to extract the video
                                            // and audio streams from the publisher and then encrypt them.
                                            _peerConnection.getTransceivers().forEach((transceiver)=>sFrameSenderClient.encrypt(transceiver.mid, transceiver.sender));
                                        case 13:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_x) {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        api.once('iceConnected', /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                            var proxyInfo, payload;
                            return _regenerator.default.wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        proxyInfo = '';
                                        payload = {
                                            pcc: parseInt(now() - startConnectingTime, 10),
                                            hasRelayCandidates: hasRelayCandidates,
                                            proxyInfo: proxyInfo
                                        };
                                        if (_peerConnection && _peerConnection.proxyInfo) payload.proxyInfo = _peerConnection.proxyInfo;
                                        logAnalyticsEvent('createPeerConnection', 'Success', payload);
                                    case 4:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        })));
                        _readyToSendOffer.resolve();
                        const createSFrameReceiverClient = /*#__PURE__*/ function() {
                            var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3() {
                                var sharedKey;
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            _context3.next = 2;
                                            return keyStore.get();
                                        case 2:
                                            sharedKey = _context3.sent;
                                            sFrameSenderId = extractSenderId(remoteConnectionId);
                                            sFrameReceiverClient = sFrameClientStore.getReceiver(sFrameSenderId);
                                            if (sFrameReceiverClient) {
                                                _context3.next = 14;
                                                break;
                                            }
                                            _context3.next = 8;
                                            return sFrameClientStore.createReceiver(sFrameSenderId);
                                        case 8:
                                            sFrameReceiverClient = _context3.sent;
                                            sFrameReceiverClient.addReceiver(sFrameSenderId);
                                            sFrameReceiverClient.setReceiverEncryptionKey(sFrameSenderId, sharedKey);
                                            keyStore.on('keyChanged', (key)=>{
                                                sFrameReceiverClient.setReceiverEncryptionKey(sFrameSenderId, key);
                                            });
                                            sFrameReceiverClient.addEventListener('decryptFailed', ()=>{
                                                api.trigger('decryptFailed');
                                            });
                                            sFrameReceiverClient.addEventListener('decryptionRestored', ()=>{
                                                api.trigger('decryptRestored');
                                            });
                                        case 14:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3);
                            }));
                            return function createSFrameReceiverClient() {
                                return _ref5.apply(this, arguments);
                            };
                        }(); // Create and initialise the PeerConnection object. This deals with
                        // any differences between the various browser implementations and
                        // our own OTPlugin version.
                        //
                        // +completion+ is the function is call once we've either successfully
                        // created the PeerConnection or on failure.
                        //
                        const internalCreatePeerConnection = (completion)=>{
                            logging.debug('internalCreatePeerConnection: called');
                            if (_peerConnection) {
                                logging.debug('internalCreatePeerConnection: resolving synchronously');
                                completion.call(null, null, _peerConnection);
                                return;
                            }
                            _peerConnectionCompletionHandlers.push(completion);
                            if (_peerConnectionCompletionHandlers.length > 1) // The PeerConnection is already being setup, just wait for
                            // it to be ready.
                            return;
                            logging.debug(`Creating peer connection config "${JSON.stringify(config)}".`);
                            if (iceConfig.servers.length === 0) {
                                // This should never happen unless something is misconfigured
                                logging.error('No ice servers present');
                                logAnalyticsEvent('Error', 'noIceServers');
                            }
                            if (iceConfig.transportPolicy === 'relay') {
                                const isTurnUrl = (url)=>url && url.indexOf('turn') === 0;
                                iceConfig.servers = iceConfig.servers.map((providedServer)=>{
                                    const server = cloneDeep(providedServer);
                                    if (!Array.isArray(server.urls)) server.urls = [
                                        server.urls
                                    ];
                                    server.urls = server.urls.filter(isTurnUrl);
                                    return server.urls.length === 0 ? undefined : server;
                                }).filter((server)=>server !== undefined);
                            }
                            config.iceTransportPolicy = iceConfig.transportPolicy;
                            config.iceServers = iceConfig.servers;
                            if (isE2ee) {
                                // Let's activate the required properties to enable Insertable Streams.
                                config.forceEncodedVideoInsertableStreams = true;
                                config.forceEncodedAudioInsertableStreams = true;
                                config.encodedInsertableStreams = true;
                            }
                            futureIsPeerConnectionValid().then((isValid)=>{
                                if (!isValid) {
                                    logging.error('createPeerConnection: Invalid RTCPeerConnection object');
                                    throw new Error('Failed to create valid RTCPeerConnection object');
                                }
                                return createPeerConnection({
                                    window: windowMock,
                                    config: config
                                });
                            }).then(/*#__PURE__*/ function() {
                                var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(pc) {
                                    return _regenerator.default.wrap(function _callee4$(_context4) {
                                        while(true)switch(_context4.prev = _context4.next){
                                            case 0:
                                                if (!(!isPublisher && isE2ee)) {
                                                    _context4.next = 3;
                                                    break;
                                                }
                                                _context4.next = 3;
                                                return createSFrameReceiverClient();
                                            case 3:
                                                attachEventsToPeerConnection(null, pc);
                                            case 4:
                                            case "end":
                                                return _context4.stop();
                                        }
                                    }, _callee4);
                                }));
                                return function(_x2) {
                                    return _ref6.apply(this, arguments);
                                };
                            }(), (err)=>attachEventsToPeerConnection(err));
                        }; // An auxiliary function to internalCreatePeerConnection. This binds the various event
                        // callbacks once the peer connection is created.
                        //
                        // +err+ will be non-null if an err occured while creating the PeerConnection
                        // +pc+ will be the PeerConnection object itself.
                        //
                        // @todo if anything called in attachEventsToPeerConnection throws it will be
                        // silent
                        const attachEventsToPeerConnection = (err, pc)=>{
                            if (err) {
                                triggerError({
                                    reason: `Failed to create PeerConnection, exception: ${err}`,
                                    prefix: 'NewPeerConnection'
                                });
                                _peerConnectionCompletionHandlers = [];
                                return;
                            }
                            logging.debug('OT attachEventsToPeerConnection');
                            _peerConnection = pc;
                            if (_iceProcessor) _iceProcessor.setPeerConnection(pc);
                            _channels = new PeerConnectionChannels(_peerConnection);
                            if (config.channels) _channels.addMany(config.channels);
                            const forwarder = iceCandidateForwarder({
                                sendMessage: sendMessage,
                                logging: logging
                            });
                            const onIceCandidate = (event)=>{
                                _readyToSendOffer.resolve();
                                if (shouldFilterCandidate(event.candidate)) {
                                    logging.debug('Ignore candidate', event.candidate.candidate);
                                    return;
                                }
                                forwarder(event);
                            };
                            const onTrackAdded = /*#__PURE__*/ function() {
                                var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5(event) {
                                    return _regenerator.default.wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                onRemoteTrackAdded(event);
                                                if (!isPublisher && sFrameReceiverClient) sFrameReceiverClient.decrypt(event.transceiver.mid, event.receiver);
                                            case 2:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5);
                                }));
                                return function onTrackAdded(_x3) {
                                    return _ref7.apply(this, arguments);
                                };
                            }();
                            let _previousIceState = _peerConnection.iceConnectionState;
                            const onIceConnectionStateChanged = (event)=>{
                                if (_peerConnection) {
                                    logging.debug('iceconnectionstatechange', _peerConnection.iceConnectionState);
                                    if (_peerConnection.iceConnectionState === 'connected') {
                                        // Now that the iceConnectionState is connected, let's make sure the transitionToFailedTimeOut
                                        // is cleared ASAP to avoid triggering an iceConnectionStateChange event to failed.
                                        if (_previousIceState === 'disconnected') api.clearFailedTimeout();
                                        api.emit('iceConnected');
                                        _iceRestartNeeded.set(false);
                                    } else if (_peerConnection.iceConnectionState === 'completed' && env.isLegacyEdge) // Start collecting stats later in Edge because it fails if you call it sooner
                                    // This can probably be fixed better in Adapter.js
                                    setTimeout(()=>qos.startCollecting(_peerConnection), 1000);
                                } else logging.debug('iceconnectionstatechange on peerConnection that no longer exists', api);
                                const newIceState = event.target.iceConnectionState;
                                api.trigger('iceConnectionStateChange', newIceState);
                                logAnalyticsEvent('attachEventsToPeerConnection', 'iceconnectionstatechange', newIceState);
                                if (newIceState === 'disconnected') {
                                    if (_iceRestartNeeded.get()) {
                                        logging.debug('Restarting ice!');
                                        api.generateOffer();
                                    } else if (!shouldUsePlanBSDP()) // We only transition to failed in unified-plan
                                    // Plan-b will transition natively
                                    _transitionToFailedTimeOut = setTimeout(()=>{
                                        const iceState = 'failed';
                                        logAnalyticsEvent('attachEventsToPeerConnection', 'iceconnectionstatechange', iceState);
                                        _previousIceState = iceState;
                                        api.trigger('iceConnectionStateChange', iceState);
                                    }, DISCONNECT_TO_FAILED_TIMEOUT);
                                }
                                if (_previousIceState !== 'disconnected' && newIceState === 'failed') // the sequence disconnected => failure would indicate an abrupt disconnection (e.g. remote
                                // peer closed the browser) or a network problem. We don't want to log that has a connection
                                // establishment failure. This behavior is seen only in Chrome 47+
                                triggerError({
                                    reason: "The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall.",
                                    prefix: 'ICEWorkflow'
                                });
                                _previousIceState = newIceState;
                            };
                            const onNegotiationNeeded = ()=>{
                                logAnalyticsEvent('peerConnection:negotiationNeeded', 'Event');
                                if (isPublisher) api.generateOffer();
                            };
                            _peerConnection.addEventListener('track', onTrackAdded);
                            _peerConnection.addEventListener('icecandidate', onIceCandidate);
                            _peerConnection.addEventListener('signalingstatechange', routeStateChanged);
                            _peerConnection.addEventListener('negotiationneeded', onNegotiationNeeded);
                            _peerConnection.addEventListener('iceconnectionstatechange', onIceConnectionStateChanged);
                            cleanupJobs.add(()=>{
                                if (!_peerConnection) return;
                                _peerConnection.removeEventListener('track', onTrackAdded);
                                _peerConnection.removeEventListener('icecandidate', onIceCandidate);
                                _peerConnection.removeEventListener('signalingstatechange', routeStateChanged);
                                _peerConnection.removeEventListener('negotiationneeded', onNegotiationNeeded);
                                _peerConnection.removeEventListener('iceconnectionstatechange', onIceConnectionStateChanged);
                            });
                            triggerPeerConnectionCompletion(null);
                        };
                        const triggerPeerConnectionCompletion = ()=>{
                            while(_peerConnectionCompletionHandlers.length)_peerConnectionCompletionHandlers.shift().call(null);
                        }; // Clean up the Peer Connection and trigger the close event.
                        // This function can be called safely multiple times, it will
                        // only trigger the close event once (per PeerConnection object)
                        const tearDownPeerConnection = ()=>{
                            // Our connection is dead, stop processing ICE candidates
                            if (_iceProcessor) {
                                _iceProcessor.destroy();
                                _iceProcessor = null;
                            }
                            _peerConnectionCompletionHandlers = [];
                            qos.stopCollecting();
                            cleanupJobs.releaseAll();
                            _readyToSendOffer.clean();
                            if (_peerConnection !== null) {
                                if (_peerConnection.destroy) // OTPlugin defines a destroy method on PCs. This allows
                                // the plugin to release any resources that it's holding.
                                _peerConnection.destroy();
                                _peerConnection = null;
                                api.trigger('close');
                            }
                            api.off();
                        };
                        const routeStateChanged = (event)=>{
                            const newState = event.target.signalingState;
                            api.emit('signalingStateChange', newState);
                            if (newState === 'stable') api.emit('signalingStateStable');
                            if (newState && newState !== _state) {
                                _state = newState;
                                logging.debug(`stateChange: ${_state}`);
                                switch(_state){
                                    case 'closed':
                                        tearDownPeerConnection();
                                        break;
                                    default:
                                }
                            }
                        };
                        const qosCallback = (parsedStats)=>{
                            parsedStats.dataChannels = _channels.sampleQos();
                            api.trigger('qos', {
                                parsedStats: parsedStats,
                                simulcastEnabled: _simulcastEnabled.get()
                            });
                        };
                        const getRemoteStreams = ()=>{
                            let streams;
                            if (_peerConnection.getRemoteStreams) streams = _peerConnection.getRemoteStreams();
                            else if (_peerConnection.remoteStreams) streams = _peerConnection.remoteStreams;
                            else throw new Error("Invalid Peer Connection object implements no method for retrieving remote streams");
                             // Force streams to be an Array, rather than a 'Sequence' object,
                            // which is browser dependent and does not behaviour like an Array
                            // in every case.
                            return Array.prototype.slice.call(streams);
                        }; // PeerConnection signaling
                        const onRemoteTrackAdded = (event)=>{
                            var _event$streams;
                            const track = event.track, transceiver = event.transceiver; // To be safe we consider this event can be either RTCTrackEvent or MediaStreamEvent type.
                            // - RTCTrackEvent.streams => array with all the streams associated with the added track.
                            //   Only one stream should be associated to the added track.
                            // - MediaStreamEvent.stream => stream added
                            const stream = event.stream || ((_event$streams = event.streams) == null ? void 0 : _event$streams[0]);
                            logAnalyticsEvent('createPeerConnection', 'TrackAdded');
                            api.trigger('trackAdded', {
                                stream: stream,
                                track: track,
                                transceiver: transceiver
                            });
                        }; // ICE Negotiation messages
                        const reportError = (message, reason, prefix)=>{
                            processingOffer = false;
                            triggerError({
                                reason: `PeerConnection.offerProcessor ${message}: ${reason}`,
                                prefix: prefix
                            });
                        }; // Process an offer that
                        const processOffer = (message)=>{
                            if (processingOffer) {
                                // If we get multiple pending offer messages we just handle the most recent one
                                pendingOfferMessage = message;
                                return;
                            }
                            processingOffer = true;
                            logAnalyticsEvent('peerConnection:processOffer', 'Event');
                            const offer = new NativeRTCSessionDescription({
                                type: 'offer',
                                sdp: message.content.sdp
                            }); // Relays +answer+ Answer
                            const relayAnswer = (answer)=>{
                                processingOffer = false;
                                if (_iceProcessor) _iceProcessor.process();
                                sendMessage('answer', answer);
                                if (!env.isLegacyEdge) qos.startCollecting(_peerConnection, isPublisher);
                                if (pendingOfferMessage) {
                                    processOffer(pendingOfferMessage);
                                    pendingOfferMessage = null;
                                }
                            };
                            const onRemoteVideoSupported = (supported)=>api.trigger('remoteVideoSupported', supported);
                            internalCreatePeerConnection(()=>{
                                offerProcessor(_peerConnection, windowMock.RTCPeerConnection, windowMock.RTCSessionDescription, NativeRTCSessionDescription, sdpTransforms, offer, codecFlags, p2p, relayAnswer, reportError, onRemoteVideoSupported, replaceBaselineProfile, sourceStreamId);
                            });
                        };
                        const processAnswer = (message)=>{
                            logAnalyticsEvent('peerConnection:processAnswer', 'Event');
                            const failure = (errorReason)=>{
                                triggerError({
                                    reason: `Error while setting RemoteDescription ${errorReason}`,
                                    prefix: 'SetRemoteDescription'
                                });
                            };
                            if (!message.content.sdp) {
                                failure('Weird answer message, no SDP.');
                                return;
                            }
                            _answer = new NativeRTCSessionDescription({
                                type: 'answer',
                                sdp: applySdpTransform(sdpTransforms, 'remote', 'answer', assign({
                                    replaceBaselineProfile: replaceBaselineProfile
                                }, answerOverrides), message.content.sdp).local
                            });
                            (()=>{
                                const success = ()=>{
                                    logging.debug('processAnswer: setRemoteDescription Success');
                                    if (_iceProcessor) _iceProcessor.process();
                                };
                                _peerConnection.setRemoteDescription(_answer).then(success).catch(failure);
                                offerAnswerPending = false;
                                if (regenerateOffer) {
                                    regenerateOffer = false;
                                    api.generateOffer();
                                }
                            })();
                            if (!env.isLegacyEdge) qos.startCollecting(_peerConnection, isPublisher);
                        };
                        const processSubscribe = ()=>{
                            var _peerConnection2, _peerConnection2$sign;
                            if (((_peerConnection2 = _peerConnection) == null ? void 0 : (_peerConnection2$sign = _peerConnection2.signalingState) == null ? void 0 : _peerConnection2$sign.toLowerCase()) === 'closed') return;
                            offerAnswerPending = true;
                            logAnalyticsEvent('peerConnection:processSubscribe', 'Event');
                            logging.debug('processSubscribe: Sending offer to subscriber.');
                            let numSimulcastStreams = _simulcastEnabled.get() ? config.capableSimulcastStreams : 1; // When transitioning from Mantis to P2P, in order to ensure the video quality we must
                            // send only one video layer, regardless that simulcast is enabled.
                            const isAdaptiveP2pSourceStreamId = sourceStreamId === 'P2P' && !p2p;
                            if (isAdaptiveP2pSourceStreamId) numSimulcastStreams = 1;
                            internalCreatePeerConnection(()=>{
                                subscribeProcessor({
                                    peerConnection: _peerConnection,
                                    NativeRTCSessionDescription: NativeRTCSessionDescription,
                                    sdpTransforms: sdpTransforms,
                                    numSimulcastStreams: numSimulcastStreams,
                                    removeVideoOrientation: hasPictureInPictureBug(),
                                    offerOverrides: offerOverrides,
                                    offerConstraints: {
                                        iceRestart: _iceRestartNeeded.get()
                                    },
                                    replaceBaselineProfile: replaceBaselineProfile
                                }).then((offer)=>{
                                    logging.debug("processSubscribe: got offer, waiting for _readyToSendOffer");
                                    _offer = offer;
                                    _readyToSendOffer.promise.then(()=>{
                                        logging.debug('processSubscribe: sending offer');
                                        sendMessage('offer', _offer);
                                    });
                                }, (error)=>{
                                    triggerError({
                                        reason: `subscribeProcessor ${error.message}: ${error.reason}`,
                                        prefix: error.prefix
                                    });
                                });
                                _iceRestartNeeded.set(false);
                            });
                        };
                        const cleanupSFrameClients = ()=>{
                            sFrameSenderClient = null;
                            sFrameSenderId = null;
                        };
                        api.generateOffer = debounce(()=>{
                            if (!offerAnswerPending) processSubscribe();
                            else regenerateOffer = true;
                        }, 100);
                        const triggerError = (_ref8)=>{
                            let reason = _ref8.reason, prefix = _ref8.prefix;
                            logging.error(reason, 'in state', !_peerConnection ? '(none)' : {
                                connectionState: _peerConnection.connectionState,
                                iceConnectionState: _peerConnection.iceConnectionState,
                                iceGatheringState: _peerConnection.iceGatheringState,
                                signalingState: _peerConnection.signalingState
                            });
                            api.trigger('error', {
                                reason: reason,
                                prefix: prefix
                            });
                        };
                        /*
    * Add a track to the underlying PeerConnection
    *
    * @param {object} track - the track to add
    * @param {object} stream - the stream to add it to
    * @return {RTCRtpSender}
    */ api.addTrack = (track, stream)=>{
                            const promise = new Promise((resolve, reject)=>{
                                internalCreatePeerConnection((err)=>{
                                    if (err) return reject(err);
                                    resolve();
                                    return undefined;
                                });
                            }).then(()=>{
                                if (_peerConnection.addTrack) return _peerConnection.addTrack(track, stream);
                                const pcStream = _peerConnection.getLocalStreams()[0];
                                if (pcStream === undefined) throw new Error('PeerConnection has no existing streams, cannot addTrack');
                                pcStream.addTrack(track);
                                api.generateOffer();
                                return undefined;
                            }).then(()=>new Promise((resolve)=>{
                                    api.once('signalingStateStable', ()=>{
                                        resolve();
                                    });
                                }));
                            return promiseTimeout(promise, 15000, 'Renegotiation timed out');
                        };
                        function FakeRTCRtpSender(track) {
                            this.track = track;
                        }
                        api.setIceConfig = (newIceConfig)=>{
                            try {
                                // Firefox does not follow the spec laid out in MDN for attempts to change the certs
                                // after they've already been set. The documentation states the following about certificates:
                                // once the certificates have been set, this property is ignored in future calls to
                                // RTCPeerConnection.setConfiguration().
                                if (env.isFirefox) newIceConfig.certificates = _peerConnection.getConfiguration().certificates;
                                _peerConnection.setConfiguration(newIceConfig);
                            } catch (err) {
                                throw new OTHelpersError(`A peer connection failed to set configuration with ${err.message}`, Errors.FAILED_SET_CONFIGURATION);
                            }
                            _iceRestartNeeded.set(true);
                            api.generateOffer();
                            return _peerConnection;
                        };
                        /**
     * Remove a track from the underlying PeerConnection
     *
     * @param {RTCRtpSender} RTCRtpSender - the RTCRtpSender to remove
     */ api.removeTrack = (RTCRtpSender)=>{
                            const promise = Promise.resolve().then(()=>{
                                if (RTCRtpSender instanceof FakeRTCRtpSender) {
                                    _peerConnection.getLocalStreams()[0].removeTrack(RTCRtpSender.track);
                                    api.generateOffer();
                                    return undefined;
                                }
                                return _peerConnection.removeTrack(RTCRtpSender);
                            }).then(()=>new Promise((resolve)=>{
                                    api.once('signalingStateStable', ()=>{
                                        resolve();
                                    });
                                }));
                            return promiseTimeout(promise, 15000, 'Renegotiation timed out');
                        };
                        api.addLocalStream = (webRTCStream)=>new Promise((resolve, reject)=>{
                                internalCreatePeerConnection((err)=>{
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    try {
                                        // only node does not support getTracks
                                        if (webRTCStream.getTracks) webRTCStream.getTracks().forEach((track)=>_peerConnection.addTrack(track, webRTCStream));
                                    } catch (addStreamErr) {
                                        reject(addStreamErr);
                                        return;
                                    }
                                    resolve();
                                }, webRTCStream);
                            });
                        api.getLocalStreams = ()=>_peerConnection.getLocalStreams();
                        api.getSenders = ()=>{
                            if (_peerConnection.getSenders) return _peerConnection.getSenders();
                            return _peerConnection.getLocalStreams()[0].getTracks().map((track)=>new FakeRTCRtpSender(track));
                        };
                        api.disconnect = ()=>{
                            var _peerConnection3;
                            if (_iceProcessor) {
                                _iceProcessor.destroy();
                                _iceProcessor = null;
                            }
                            if (((_peerConnection3 = _peerConnection) == null ? void 0 : _peerConnection3.signalingState) && _peerConnection.signalingState.toLowerCase() !== 'closed') {
                                _peerConnection.close();
                                cleanupSFrameClients();
                                setTimeout(tearDownPeerConnection);
                            }
                        };
                        api.iceRestart = ()=>_iceRestartNeeded.set(true);
                        api.clearFailedTimeout = ()=>clearTimeout(_transitionToFailedTimeOut);
                        api.changeMediaDirectionToRecvOnly = ()=>changeMediaDirectionToRecvOnly(_peerConnection);
                        api.changeMediaDirectionToInactive = ()=>changeMediaDirectionToInactive(_peerConnection);
                        api.processMessage = (type, message)=>{
                            logging.debug(`processMessage: Received ${type} from ${message.fromAddress}`, message);
                            logging.debug(message);
                            switch(type){
                                case 'generateoffer':
                                    if (message.content && message.content.simulcastEnabled !== undefined) _simulcastEnabled.set(message.content.simulcastEnabled);
                                    api.generateOffer();
                                    trackRenegotiationAttempts();
                                    break;
                                case 'offer':
                                    processOffer(message);
                                    trackRenegotiationAttempts();
                                    break;
                                case 'answer':
                                case 'pranswer':
                                    processAnswer(message);
                                    break;
                                case 'candidate':
                                    var iceCandidate = new NativeRTCIceCandidate(message.content);
                                    if (shouldFilterCandidate(iceCandidate)) {
                                        logging.debug('Ignore candidate', iceCandidate.candidate);
                                        return api;
                                    }
                                    if (_iceProcessor) _iceProcessor.addIceCandidate(iceCandidate).catch((err)=>{
                                        // Sometimes you might get an error adding an iceCandidate
                                        // this does not mean we should fail, if we get a working candidate
                                        // later then we should let it work
                                        logging.warn(`Error while adding ICE candidate: ${JSON.stringify(iceCandidate)}: ${err.toString()}`);
                                    });
                                    break;
                                default:
                                    logging.debug(`processMessage: Received an unexpected message of type ${type} from ${message.fromAddress}: ${JSON.stringify(message)}`);
                            }
                            function trackRenegotiationAttempts() {
                                offerMessagesReceived += 1;
                                qos.handleOfferMessageReceived();
                                if (offerMessagesReceived > 1) {
                                    logAnalyticsEvent('Renegotiation', 'Attempt');
                                    renegotiationInProgress = true;
                                }
                            }
                            return api;
                        };
                        api.stopTransceivers = (transceivers)=>{
                            // transceivers provides an array of transceiver.mid. This will stop every transceiver
                            // provided in the PC.
                            _peerConnection.getTransceivers().forEach((transceiver)=>{
                                if (transceivers.includes(transceiver.mid)) transceiver.stop();
                            });
                        };
                        api.remoteStreams = ()=>_peerConnection ? getRemoteStreams() : [];
                        api.remoteTracks = ()=>{
                            if (!_peerConnection) return [];
                            if (_peerConnection.getReceivers) return Array.prototype.slice.apply(_peerConnection.getReceivers()).map((receiver)=>receiver.track);
                            return Array.prototype.concat.apply([], getRemoteStreams().map((stream)=>stream.getTracks()));
                        };
                        api.remoteDescription = ()=>_peerConnection.remoteDescription;
                        /**
     * @param {function(DOMError, Array<RTCStats>)} callback
     */ api.getStats = (callback)=>{
                            if (!_peerConnection) {
                                const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                                callback(new OTHelpersError(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                    code: errorCode
                                }));
                                return;
                            }
                            getStatsAdapter(_peerConnection, callback);
                        };
                        /**
     * @param {function(DOMError, RTCStatsReport)} callback
     */ api.getRtcStatsReport = (callback)=>{
                            if (!_peerConnection) {
                                const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                                callback(new OTHelpersError(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                    code: errorCode
                                }));
                                return;
                            }
                            getRtcStatsReportAdapter(_peerConnection, callback);
                        };
                        api.getSynchronizationSources = (callback)=>{
                            if (!isPublisher) {
                                if (!_peerConnection) {
                                    const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                                    callback(new OTHelpersError(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                        code: errorCode
                                    }));
                                    return;
                                }
                                getSynchronizationSources(_peerConnection, callback);
                            }
                        };
                        const waitForChannel = function waitForChannel(timesToWait, label, channelOptions, completion) {
                            let err;
                            const channel = _channels.get(label, channelOptions);
                            if (!channel) {
                                if (timesToWait > 0) {
                                    setTimeout(waitForChannel.bind(null, timesToWait - 1, label, channelOptions, completion), 200);
                                    return;
                                }
                                err = new OTHelpersError(`${"A channel with that label and options could not be found. Label:"}${label}. Options: ${JSON.stringify(channelOptions)}`);
                            }
                            completion(err, channel);
                        };
                        api.getDataChannel = (label, channelOptions, completion)=>{
                            if (!_peerConnection) {
                                completion(new OTHelpersError('Cannot create a DataChannel before there is a connection.'));
                                return;
                            } // Wait up to 20 sec for the channel to appear, then fail
                            waitForChannel(100, label, channelOptions, completion);
                        };
                        api.getSourceStreamId = ()=>sourceStreamId;
                        api.iceConnectionStateIsConnected = ()=>_peerConnection && [
                                'connected',
                                'completed'
                            ].indexOf(_peerConnection.iceConnectionState) > -1;
                        api.findAndReplaceTrack = (oldTrack, newTrack)=>Promise.resolve().then(()=>{
                                const sender = _peerConnection.getSenders().filter((s)=>s.track === oldTrack)[0];
                                if (!sender) // There is no video track to replace but this is OK
                                // they probably called cycleVideo on an audio only Publisher
                                // or on a Publisher that does not support the videoCodec
                                return Promise.resolve();
                                if (typeof sender.replaceTrack !== 'function') throw new Error('Sender does not support replaceTrack');
                                return sender.replaceTrack(newTrack);
                            });
                        api.hasRelayCandidates = ()=>hasRelayCandidates;
                        api.getNegotiatedCodecs = ()=>{
                            if (!_peerConnection.localDescription || !_peerConnection.remoteDescription) return null;
                            const getForMediaType = (mediaType)=>intersection(SDPHelpers.getCodecs(_peerConnection.localDescription.sdp, mediaType), SDPHelpers.getCodecs(_peerConnection.remoteDescription.sdp, mediaType));
                            return {
                                audio: getForMediaType('audio'),
                                video: getForMediaType('video')
                            };
                        };
                        api.on('signalingStateStable', ()=>{
                            if (renegotiationInProgress) {
                                renegotiationInProgress = false;
                                logAnalyticsEvent('Renegotiation', 'Success', api.getNegotiatedCodecs());
                            }
                        });
                        api.on('error', (_ref9)=>{
                            let prefix = _ref9.prefix;
                            if (renegotiationInProgress && [
                                'CreateOffer',
                                'SetRemoteDescription'
                            ].indexOf(prefix) !== -1) {
                                renegotiationInProgress = false;
                                logAnalyticsEvent('Renegotiation', 'Failure');
                            }
                        });
                        api.on('close', ()=>{
                            if (renegotiationInProgress) {
                                renegotiationInProgress = false;
                                logAnalyticsEvent('Renegotiation', 'Cancel');
                            }
                        });
                        const qos = new Qos();
                        qos.on('stats', qosCallback);
                        return api;
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const enforcesUnifiedPlan = ()=>(env.isChrome || env.isElectron) && env.version >= 90 || env.isOpera && env.version >= 76;
            module1.exports = ()=>!enforcesUnifiedPlan() && (env.isChrome && env.version > 71 || env.isChromiumEdge && env.version < 90 || env.isOpera && env.version > 58);
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
  * Executes the provided callback thanks to <code>global.setTimeout</code>.
  *
  * @param {function()} callback
  * @param {number} frequency how many times per second we want to execute the callback
  * @param {number} maxIterations the maximum amount of iterations for this runner
  * @constructor
  */ function IntervalRunner(callback, desiredFrequency, maxIterations) {
                if (maxIterations === void 0) maxIterations = Infinity;
                let timeoutId = null;
                let running = false;
                let iteration = 1;
                const timeBetween = 1000 / desiredFrequency;
                const loop = ()=>{
                    if (!running || iteration > maxIterations) return;
                    iteration += 1;
                    callback();
                    timeoutId = setTimeout(loop, timeBetween);
                };
                this.start = ()=>{
                    if (running) return;
                    running = true;
                    setTimeout(loop, timeBetween);
                };
                this.stop = ()=>{
                    window.clearTimeout(timeoutId);
                    running = false;
                };
            }
            module1.exports = IntervalRunner;
        /***/ },
        /* 76 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const pick = __webpack_require__(48);
            const mapValues = __webpack_require__(654);
            const isObject = __webpack_require__(11);
            const calculateFrameRate = __webpack_require__(157);
            const frameRateTrackers = {};
            function getFrameRate(stat) {
                return Number(stat.framerateMean || stat.googFrameRateSent || stat.googFrameRateReceived || stat.googFrameRateInput || stat.googFrameRateOutput || 0);
            }
            function getFrames(stat) {
                return Number(stat.framesEncoded || stat.framesDecoded);
            }
            function calcFrameRate(stat, startTime) {
                if (getFrameRate(stat)) return getFrameRate(stat);
                if (!getFrames(stat)) return undefined;
                let frameRate = 0;
                const prevStatFrames = frameRateTrackers[stat.id] ? frameRateTrackers[stat.id].frames : 0;
                const prevTimestamp = frameRateTrackers[stat.id] ? frameRateTrackers[stat.id].timestamp : startTime;
                frameRate = calculateFrameRate({
                    currentStatFrames: getFrames(stat),
                    currentTimestamp: stat.timestamp,
                    prevStatFrames: prevStatFrames,
                    prevTimestamp: prevTimestamp
                });
                frameRateTrackers[stat.id] = {
                    frames: getFrames(stat),
                    timestamp: stat.timestamp
                };
                return frameRate;
            }
            function getLinkedTrack(stat, allStats) {
                if (!allStats) return {};
                const linkedTrack = allStats.filter((x)=>x.id === stat.mediaTrackId);
                return linkedTrack.length ? linkedTrack[0] : {};
            }
            function totalPacketsLostReducer(totalPacketsLost, stat) {
                if ('packetsLost' in stat) return totalPacketsLost + stat.packetsLost;
                return totalPacketsLost;
            }
            const getStatsHelpers = {
                isVideoStat (stat, allStats) {
                    const linkedTrack = getLinkedTrack(stat, allStats); // When kind is 'video', we need to check the type since there are other
                    // stats with kind 'video' without the information we need.
                    const isVideoKind = stat.kind === 'video' && [
                        'outbound-rtp',
                        'inbound-rtp'
                    ].includes(stat.type);
                    return isVideoKind || stat.mediaType === 'video' || 'googFrameWidthReceived' in stat || // Old Chrome
                    'googFrameWidthInput' in stat || // Old Chrome
                    stat.type === 'inbound-rtp' && stat.id.indexOf('Video') !== -1 || // Safari
                    stat.type === 'inboundrtp' && linkedTrack.frameWidth !== 0; // Edge
                },
                isAudioStat (stat, allStats) {
                    const linkedTrack = getLinkedTrack(stat, allStats); // When kind is 'audio', we need to check the type since there are other
                    // stats with kind 'audio' without the information we need.
                    const isAudioKind = stat.kind === 'audio' && [
                        'outbound-rtp',
                        'inbound-rtp'
                    ].includes(stat.type);
                    return isAudioKind || stat.mediaType === 'audio' || 'audioInputLevel' in stat || // Old Chrome
                    'audioOutputLevel' in stat || // Old Chrome
                    stat.type === 'inbound-rtp' && stat.id.indexOf('Audio') !== -1 || // Safari
                    stat.type === 'inboundrtp' && linkedTrack.frameWidth === 0; // Edge;
                },
                isInboundStat (stat) {
                    return 'bytesReceived' in stat || 'packetsReceived' in stat;
                },
                isOutboundStat (stat) {
                    return 'bytesSent' in stat || 'packetsSent' in stat;
                },
                isVideoTrackStat (stat) {
                    return stat.type === 'track' && (stat.frameHeight > 0 || stat.frameWidth > 0 || stat.framesCorrupted > 0 || stat.framesDecoded > 0 || stat.framesPerSecond > 0 || stat.framesSent > 0 || stat.framesReceived > 0);
                },
                isVideoRemoteInboundRtpStat (stat) {
                    return stat.type === 'remote-inbound-rtp' && stat.kind === 'video';
                },
                isAudioRemoteInboundRtpStat (stat) {
                    return stat.type === 'remote-inbound-rtp' && stat.kind === 'audio';
                },
                isVideoInboundRtpStat (stat) {
                    return stat.type === 'inbound-rtp' && stat.kind === 'video';
                },
                parseStatCategory (stat) {
                    const statCategory = {
                        packetsLost: 0,
                        packetsReceived: 0,
                        bytesReceived: 0 // frameRate is only set for video stat
                    };
                    if ('packetsReceived' in stat) statCategory.packetsReceived = parseInt(stat.packetsReceived, 10);
                    if ('packetsLost' in stat) statCategory.packetsLost = parseInt(stat.packetsLost, 10);
                    if ('bytesReceived' in stat) statCategory.bytesReceived = parseInt(stat.bytesReceived, 10);
                    if (this.isVideoStat(stat)) {
                        if ('framerateMean' in stat) statCategory.frameRate = Number(stat.framerateMean);
                        else if ('googFrameRateOutput' in stat) statCategory.frameRate = Number(stat.googFrameRateOutput);
                        else if ('googFrameRateInput' in stat) statCategory.frameRate = Number(stat.googFrameRateInput);
                    }
                    return statCategory;
                },
                getVideoPacketsLost (stats) {
                    return stats.filter((stat)=>this.isVideoRemoteInboundRtpStat(stat, stats)).reduce(totalPacketsLostReducer, 0);
                },
                getAudioPacketsLost (stats) {
                    return stats.filter((stat)=>this.isAudioRemoteInboundRtpStat(stat, stats)).reduce(totalPacketsLostReducer, 0);
                },
                normalizeTimestamp (timestamp, now) {
                    if (now === void 0) now = Date.now();
                    if (isObject(timestamp) && 'getTime' in timestamp) // Chrome as of 39 delivers a "kind of Date" object for timestamps
                    // we duck check it and get the timestamp
                    return timestamp.getTime();
                    if (Math.abs(timestamp / (1000 * now) - 1) < 0.05) // If the timestamp is within 5% of 1000x now, we assume its unit is microseconds and
                    // divide by 1000 to correct for this.
                    return timestamp / 1000;
                    return timestamp;
                },
                normalizeStats (stats, inbound, startTime) {
                    if (inbound === void 0) inbound = true;
                    const videos = stats.filter((stat)=>getStatsHelpers.isVideoStat(stat, stats)).filter((stat)=>getStatsHelpers.isInboundStat(stat) === inbound);
                    const audio = stats.filter((stat)=>this.isAudioStat(stat, stats)).filter((stat)=>this.isInboundStat(stat) === inbound)[0]; // There may be more than one video stream (e.g., when simulcast is enabled)
                    // We just need to grab one of them for its id and timestamp
                    const video = videos[0];
                    if (!audio && !video) throw new Error('could not find stats for either audio or video');
                    const timestamp = getStatsHelpers.normalizeTimestamp(video ? video.timestamp : audio.timestamp);
                    const otStats = {
                        timestamp: timestamp
                    };
                    if (video && !inbound && video.packetsLost === undefined) video.packetsLost = this.getVideoPacketsLost(stats);
                    if (audio && !inbound && audio.packetsLost === undefined) audio.packetsLost = this.getAudioPacketsLost(stats);
                    const outboundStatNames = [
                        'packetsSent',
                        'packetsLost',
                        'bytesSent'
                    ];
                    const getOutboundStats = (stat)=>pick(stat, outboundStatNames);
                    const getInboundStats = (stat)=>pick(stat, [
                            'packetsReceived',
                            'packetsLost',
                            'bytesReceived'
                        ]);
                    const getCommonStats = inbound ? getInboundStats : getOutboundStats;
                    const accumulateVideoStats = (videoArray)=>{
                        // We want to accumulate all these stats, if they exist.
                        const frameStats = [
                            'framerateMean',
                            'googFrameRateSent',
                            'googFrameRateReceived',
                            'googFrameRateInput',
                            'googFrameRateOutput',
                            'framesEncoded',
                            'framesDecoded'
                        ];
                        const outboundStatNamesWithFrames = outboundStatNames.concat(frameStats);
                        const accumulatedVideo = {
                            timestamp: timestamp,
                            id: video.id
                        };
                        outboundStatNamesWithFrames.forEach((statName)=>{
                            accumulatedVideo[statName] = videoArray.map((x)=>Number(x[statName] || 0)).reduce((accumulator, stat)=>accumulator + stat, 0);
                        });
                        return accumulatedVideo;
                    };
                    if (videos && videos.length > 0) {
                        const accumulatedVideo = accumulateVideoStats(videos);
                        otStats.video = Object.assign({
                            frameRate: calcFrameRate(accumulatedVideo, startTime)
                        }, mapValues(getCommonStats(accumulatedVideo), Number));
                    }
                    if (audio) otStats.audio = mapValues(getCommonStats(audio), Number);
                    return otStats;
                }
            };
            module1.exports = getStatsHelpers;
        /***/ },
        /* 77 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.codes = exports.messages = void 0;
            // https://tools.ietf.org/html/rfc6455#section-7.4.1
            // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Close_codes
            const messages = {
                1001: "The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection.",
                1002: "The endpoint is terminating the connection due to a protocol error. (CLOSE_PROTOCOL_ERROR)",
                1003: "The connection is being terminated because the endpoint has indicated that reconnections are not available. (CLOSE_UNSUPPORTED)",
                1005: "Indicates that no status code was provided even though one was expected. (CLOSE_NO_STATUS)",
                1006: "Used to indicate that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected. (CLOSE_ABNORMAL)",
                1007: "Indicates that an endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [RFC3629] data within a text message)",
                1008: "Indicates that an endpoint is terminating the connection because it has received a message that violates its policy.  This is a generic status code that can be returned when there is no other more suitable status code (e.g., 1003 or 1009) or if there is a need to hide specific details about the policy",
                1009: "Indicates that an endpoint is terminating the connection because it has received a message that is too big for it to process (CLOSE_TOO_LARGE)",
                1011: "Indicates that a server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request",
                // ... codes in the 4000-4999 range are available for use by applications.
                4001: "Connectivity loss was detected as it was too long since the socket received the last PONG message",
                4010: 'Timed out while waiting for the Rumor socket to connect.',
                4020: 'Error code unavailable.',
                4030: 'Exception was thrown during Rumor connection, possibly because of a blocked port.'
            };
            exports.messages = messages;
            const codes = {
                CLOSE_NORMAL: 1000,
                CLOSE_GOING_AWAY: 1001,
                CLOSE_PROTOCOL_ERROR: 1002,
                CLOSE_UNSUPPORTED: 1003,
                CLOSE_NO_STATUS: 1005,
                CLOSE_ABNORMAL: 1006,
                CLOSE_INCONSISTENT_DATA: 1007,
                CLOSE_POLICY_VIOLATION: 1008,
                CLOSE_TOO_LARGE: 1009,
                CLOSE_UNEXPECTED_CONDITION: 1011,
                CLOSE_CONNECTIVITY_LOSS: 4001,
                CLOSE_TIMEOUT: 4010,
                CLOSE_FALLBACK_CODE: 4020,
                CLOSE_CONNECT_EXCEPTION: 4030,
                ALREADY_CONNECTED_CONNECTING: null
            };
            exports.codes = codes;
        /***/ },
        /* 78 */ /***/ function(module1, exports, __webpack_require__) {
            var Stack = __webpack_require__(79), arrayEach = __webpack_require__(111), assignValue = __webpack_require__(84), baseAssign = __webpack_require__(177), baseAssignIn = __webpack_require__(380), cloneBuffer = __webpack_require__(180), copyArray = __webpack_require__(56), copySymbols = __webpack_require__(383), copySymbolsIn = __webpack_require__(385), getAllKeys = __webpack_require__(183), getAllKeysIn = __webpack_require__(185), getTag = __webpack_require__(42), initCloneArray = __webpack_require__(388), initCloneByTag = __webpack_require__(389), initCloneObject = __webpack_require__(190), isArray = __webpack_require__(12), isBuffer = __webpack_require__(66), isMap = __webpack_require__(393), isObject = __webpack_require__(11), isSet = __webpack_require__(395), keys = __webpack_require__(30), keysIn = __webpack_require__(55);
            /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
            /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
            var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
            /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
            cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
            cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
            /**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
                var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
                if (result !== undefined) return result;
                if (!isObject(value)) return value;
                var isArr = isArray(value);
                if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) return copyArray(value, result);
                } else {
                    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                    if (isBuffer(value)) return cloneBuffer(value, isDeep);
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                        result = isFlat || isFunc ? {} : initCloneObject(value);
                        if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    } else {
                        if (!cloneableTags[tag]) return object ? value : {};
                        result = initCloneByTag(value, tag, isDeep);
                    }
                }
                // Check for circular references and return its corresponding clone.
                stack || (stack = new Stack);
                var stacked = stack.get(value);
                if (stacked) return stacked;
                stack.set(value, result);
                if (isSet(value)) value.forEach(function(subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                else if (isMap(value)) value.forEach(function(subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function(subValue, key) {
                    if (props) {
                        key = subValue;
                        subValue = value[key];
                    }
                    // Recursively populate clone (susceptible to call stack limits).
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
            }
            module1.exports = baseClone;
        /***/ },
        /* 79 */ /***/ function(module1, exports, __webpack_require__) {
            var ListCache = __webpack_require__(80), stackClear = __webpack_require__(352), stackDelete = __webpack_require__(353), stackGet = __webpack_require__(354), stackHas = __webpack_require__(355), stackSet = __webpack_require__(356);
            /**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
            }
            // Add methods to `Stack`.
            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            module1.exports = Stack;
        /***/ },
        /* 80 */ /***/ function(module1, exports, __webpack_require__) {
            var listCacheClear = __webpack_require__(347), listCacheDelete = __webpack_require__(348), listCacheGet = __webpack_require__(349), listCacheHas = __webpack_require__(350), listCacheSet = __webpack_require__(351);
            /**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            // Add methods to `ListCache`.
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            module1.exports = ListCache;
        /***/ },
        /* 81 */ /***/ function(module1, exports, __webpack_require__) {
            var eq = __webpack_require__(54);
            /**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
                var length = array.length;
                while(length--){
                    if (eq(array[length][0], key)) return length;
                }
                return -1;
            }
            module1.exports = assocIndexOf;
        /***/ },
        /* 82 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39);
            /* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
            module1.exports = nativeCreate;
        /***/ },
        /* 83 */ /***/ function(module1, exports, __webpack_require__) {
            var isKeyable = __webpack_require__(371);
            /**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            module1.exports = getMapData;
        /***/ },
        /* 84 */ /***/ function(module1, exports, __webpack_require__) {
            var baseAssignValue = __webpack_require__(64), eq = __webpack_require__(54);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            module1.exports = assignValue;
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = function(module1) {
                if (!module1.webpackPolyfill) {
                    module1.deprecate = function() {};
                    module1.paths = [];
                    // module.parent = undefined by default
                    if (!module1.children) module1.children = [];
                    Object.defineProperty(module1, "loaded", {
                        enumerable: true,
                        get: function() {
                            return module1.l;
                        }
                    });
                    Object.defineProperty(module1, "id", {
                        enumerable: true,
                        get: function() {
                            return module1.i;
                        }
                    });
                    module1.webpackPolyfill = 1;
                }
                return module1;
            };
        /***/ },
        /* 86 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsTypedArray = __webpack_require__(378), baseUnary = __webpack_require__(68), nodeUtil = __webpack_require__(113);
            /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
            /**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            module1.exports = isTypedArray;
        /***/ },
        /* 87 */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(11);
            /** Built-in value references. */ var objectCreate = Object.create;
            /**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
                function object() {}
                return function(proto) {
                    if (!isObject(proto)) return {};
                    if (objectCreate) return objectCreate(proto);
                    object.prototype = proto;
                    var result = new object;
                    object.prototype = undefined;
                    return result;
                };
            }();
            module1.exports = baseCreate;
        /***/ },
        /* 88 */ /***/ function(module1, exports, __webpack_require__) {
            var identity = __webpack_require__(89), overRest = __webpack_require__(193), setToString = __webpack_require__(121);
            /**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
            }
            module1.exports = baseRest;
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            /**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
                return value;
            }
            module1.exports = identity;
        /***/ },
        /* 90 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var objToString = Object.prototype.toString, id = objToString.call(function() {
                return arguments;
            }());
            module1.exports = function(value) {
                return objToString.call(value) === id;
            };
        /***/ },
        /* 91 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var objToString = Object.prototype.toString, id = objToString.call("");
            module1.exports = function(value) {
                return typeof value === "string" || value && typeof value === "object" && (value instanceof String || objToString.call(value) === id) || false;
            };
        /***/ },
        /* 92 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(420)() ? globalThis : __webpack_require__(421);
        /***/ },
        /* 93 */ /***/ function(module1, exports, __webpack_require__) {
            var MapCache = __webpack_require__(110), setCacheAdd = __webpack_require__(453), setCacheHas = __webpack_require__(454);
            /**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
                var index = -1, length = values == null ? 0 : values.length;
                this.__data__ = new MapCache;
                while(++index < length)this.add(values[index]);
            }
            // Add methods to `SetCache`.
            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            module1.exports = SetCache;
        /***/ },
        /* 94 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIndexOf = __webpack_require__(455);
            /**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
                var length = array == null ? 0 : array.length;
                return !!length && baseIndexOf(array, value, 0) > -1;
            }
            module1.exports = arrayIncludes;
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            /**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
                return cache.has(key);
            }
            module1.exports = cacheHas;
        /***/ },
        /* 96 */ /***/ function(module1, exports, __webpack_require__) {
            var baseCreate = __webpack_require__(87), isObject = __webpack_require__(11);
            /**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function createCtor(Ctor) {
                return function() {
                    // Use a `switch` statement to work with class constructors. See
                    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                    // for more details.
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return new Ctor;
                        case 1:
                            return new Ctor(args[0]);
                        case 2:
                            return new Ctor(args[0], args[1]);
                        case 3:
                            return new Ctor(args[0], args[1], args[2]);
                        case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                        case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                        case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                        case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                    }
                    var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                    // Mimic the constructor's `return` behavior.
                    // See https://es5.github.io/#x13.2.2 for more details.
                    return isObject(result) ? result : thisBinding;
                };
            }
            module1.exports = createCtor;
        /***/ },
        /* 97 */ /***/ function(module1, exports, __webpack_require__) {
            var toFinite = __webpack_require__(495);
            /**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
                var result = toFinite(value), remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
            }
            module1.exports = toInteger;
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            /**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
                var index = -1, result = Array(set.size);
                set.forEach(function(value) {
                    result[++index] = value;
                });
                return result;
            }
            module1.exports = setToArray;
        /***/ },
        /* 99 */ /***/ function(module1, exports, __webpack_require__) {
            var castPath = __webpack_require__(60), toKey = __webpack_require__(47);
            /**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0, length = path.length;
                while(object != null && index < length)object = object[toKey(path[index++])];
                return index && index == length ? object : undefined;
            }
            module1.exports = baseGet;
        /***/ },
        /* 100 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFor = __webpack_require__(239), keys = __webpack_require__(30);
            /**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            module1.exports = baseForOwn;
        /***/ },
        /* 101 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.adaptIceServers = function adaptIceServers(iceServers) {
                return iceServers.map((iceServer)=>({
                        url: iceServer.url,
                        // deprecated
                        urls: iceServer.urls || [
                            iceServer.url
                        ],
                        username: iceServer.username,
                        credential: iceServer.credential
                    }));
            };
            exports.parseIceServers = function parseIceServers(message) {
                let iceServers;
                try {
                    iceServers = JSON.parse(message.data).content.iceServers;
                } catch (e) {
                    return [];
                }
                return exports.adaptIceServers(iceServers);
            };
        /***/ },
        /* 102 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            /**
 * Firefox, Edge, Safari and Chrome v58+ will use the standard version
 * of getStats API.
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats#Browser_compatibility
 */ module1.exports = ()=>env.name === 'Chrome' && env.version >= 58 || [
                    'Firefox',
                    'Edge',
                    'Safari',
                    'Opera'
                ].indexOf(env.name) !== -1;
        /***/ },
        /* 103 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
  * Executes the provided callback before each paint (frequency is usually the monitors refresh
  * rate which is typically 60 times per second)
  *
  * @param {function()} callback
  * @constructor
  */ module1.exports = function RafRunner(callback) {
                let cancelId = null;
                let running = false;
                const loop = ()=>{
                    if (!running) return;
                    callback();
                    cancelId = window.requestAnimationFrame(loop);
                };
                this.start = ()=>{
                    if (running) return;
                    running = true;
                    window.requestAnimationFrame(loop);
                };
                this.stop = ()=>{
                    window.cancelAnimationFrame(cancelId);
                    running = false;
                };
            };
        /***/ },
        /* 104 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const assign = __webpack_require__(9);
            const generatePropertyFunction = (object, getter, setter)=>{
                if (getter && !setter) return ()=>getter.call(object);
                if (getter && setter) return (value)=>{
                    if (value !== undefined) setter.call(object, value);
                    return getter.call(object);
                };
                return (value)=>{
                    if (value !== undefined) setter.call(object, value);
                };
            };
            /**
 * @typedef getterSetterDefinition
 * @property {function(): any} get the function called when accessing the value
 * @property {function(any): void} set the function called when setting the value
 */ /**
 * Creates primitive getters/ setters on objects
 *
 * For every key in gettersSetters, a method will be added to object.
 *
 * When the method is called with no value, it will call the getter
 * When the method is called with a value, it will call the setter with the value
 *
 * @deprecated Prefer using real getters and setters
 *
 * @param {any} object
 * @param {Object.<string, getterSetterDefinition>} getterSetters
 */ module1.exports = (object, getterSetters)=>{
                const mixin = {};
                Object.keys(getterSetters).forEach((key)=>{
                    mixin[key] = generatePropertyFunction(object, getterSetters[key].get, getterSetters[key].set);
                });
                assign(object, mixin);
            };
        /***/ },
        /* 105 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            let currentAudioOutputDeviceId = '';
            const setCurrentAudioOutputDeviceId = (newDeviceId)=>{
                currentAudioOutputDeviceId = newDeviceId;
            };
            const getCurrentAudioOutputDeviceId = ()=>currentAudioOutputDeviceId;
            module1.exports = {
                getCurrentAudioOutputDeviceId: getCurrentAudioOutputDeviceId,
                setCurrentAudioOutputDeviceId: setCurrentAudioOutputDeviceId
            };
        /***/ },
        /* 106 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                module1.exports = function promiseDelay(timeoutMs) {
                    return new Promise((resolve)=>setTimeout(resolve, timeoutMs));
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 107 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const DefaultNativeVideoElementWrapperFactory = __webpack_require__(294);
            /**
 * VideoElementFacadeFactory DI Container for VideoElementFacade
 *
 * @package
 * @param {Object} [dependencies]
 * @param {typeof NativeVideoElementWrapper} [dependencies.NativeVideoElementWrapper]
 * @return {typeof VideoElementFacade}
 */ function VideoElementFacadeFactory(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$NativeVideoEleme = _ref.NativeVideoElementWrapper, NativeVideoElementWrapper = _ref$NativeVideoEleme === void 0 ? DefaultNativeVideoElementWrapperFactory() : _ref$NativeVideoEleme;
                const VideoElementWrapper = NativeVideoElementWrapper;
                const defaultAudioVolume = 50;
                /**
   * Create a new VideoElementFacade
   *
   * Was used to simplify the strategy between Plugin and Native.
   *
   * @todo This needs to go.
   *
   * Note: Could VideoElementFacade not exist? Could it just be an expected interface
   * for VideoElementWrapper which could be either PluginVideoElementWrapper or
   * NativeVideoElementWrapper
   *
   * @package
   * @class
   * @param {Object} [config]
   * @param {String} [config.fallbackText] displayed when WebRTC is not supported
   * @param {Boolean} [config.muted] initial mute setting
   * @param {String} [config.fitMode] fitMode a parameter passed to VideoElementWrapper
   * @param {Object} [config._inject] @todo use the DI system
   * @param {Function} [errorHandler=() => {}] error callback function
   */ function VideoElementFacade(_temp2) {
                    let _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$fallbackText = _ref2.fallbackText, fallbackText = _ref2$fallbackText === void 0 ? 'Sorry, Web RTC is not available in your browser' : _ref2$fallbackText, fitMode = _ref2.fitMode, muted = _ref2.muted, _inject = _ref2._inject, widgetType = _ref2.widgetType;
                    return new VideoElementWrapper({
                        fallbackText: fallbackText,
                        fitMode: fitMode,
                        muted: muted,
                        defaultAudioVolume: defaultAudioVolume,
                        _inject: _inject,
                        widgetType: widgetType
                    });
                }
                return VideoElementFacade;
            }
            module1.exports = VideoElementFacadeFactory;
        /***/ },
        /* 108 */ /***/ function(module1, exports) {
            function _interopRequireWildcard(obj) {
                if (obj && obj.__esModule) return obj;
                else {
                    var newObj = {};
                    if (obj != null) {
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                            if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                            else newObj[key] = obj[key];
                        }
                    }
                    newObj.default = obj;
                    return newObj;
                }
            }
            module1.exports = _interopRequireWildcard;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39), root = __webpack_require__(14);
            /* Built-in method references that are verified to be native. */ var Map1 = getNative(root, 'Map');
            module1.exports = Map1;
        /***/ },
        /* 110 */ /***/ function(module1, exports, __webpack_require__) {
            var mapCacheClear = __webpack_require__(363), mapCacheDelete = __webpack_require__(370), mapCacheGet = __webpack_require__(372), mapCacheHas = __webpack_require__(373), mapCacheSet = __webpack_require__(374);
            /**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            // Add methods to `MapCache`.
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            module1.exports = MapCache;
        /***/ },
        /* 111 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
                var index = -1, length = array == null ? 0 : array.length;
                while(++index < length){
                    if (iteratee(array[index], index, array) === false) break;
                }
                return array;
            }
            module1.exports = arrayEach;
        /***/ },
        /* 112 */ /***/ function(module1, exports) {
            /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
            /**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            module1.exports = isLength;
        /***/ },
        /* 113 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(module1) {
                var freeGlobal = __webpack_require__(174);
                /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
                /** Detect free variable `module`. */ var freeModule = freeExports && typeof module1 == 'object' && module1 && !module1.nodeType && module1;
                /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
                /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
                /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
                    try {
                        // Use `util.types` for Node.js 10+.
                        var types = freeModule && freeModule.require && freeModule.require('util').types;
                        if (types) return types;
                        // Legacy `process.binding('util')` for Node.js < 10.
                        return freeProcess && freeProcess.binding && freeProcess.binding('util');
                    } catch (e) {}
                }();
                module1.exports = nodeUtil;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(85)(module1));
        /***/ },
        /* 114 */ /***/ function(module1, exports, __webpack_require__) {
            var isPrototype = __webpack_require__(69), nativeKeys = __webpack_require__(379);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
                if (!isPrototype(object)) return nativeKeys(object);
                var result = [];
                for(var key in Object(object))if (hasOwnProperty1.call(object, key) && key != 'constructor') result.push(key);
                return result;
            }
            module1.exports = baseKeys;
        /***/ },
        /* 115 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayFilter = __webpack_require__(384), stubArray = __webpack_require__(181);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
            /**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
                if (object == null) return [];
                object = Object(object);
                return arrayFilter(nativeGetSymbols(object), function(symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                });
            };
            module1.exports = getSymbols;
        /***/ },
        /* 116 */ /***/ function(module1, exports) {
            /**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
                var index = -1, length = values.length, offset = array.length;
                while(++index < length)array[offset + index] = values[index];
                return array;
            }
            module1.exports = arrayPush;
        /***/ },
        /* 117 */ /***/ function(module1, exports, __webpack_require__) {
            var overArg = __webpack_require__(179);
            /** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
            module1.exports = getPrototype;
        /***/ },
        /* 118 */ /***/ function(module1, exports, __webpack_require__) {
            var Uint8Array1 = __webpack_require__(188);
            /**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array1(result).set(new Uint8Array1(arrayBuffer));
                return result;
            }
            module1.exports = cloneArrayBuffer;
        /***/ },
        /* 119 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                error: {
                    priority: 1,
                    method: 'error'
                },
                warn: {
                    priority: 2,
                    method: 'warn'
                },
                info: {
                    priority: 3,
                    method: 'info'
                },
                log: {
                    priority: 4,
                    method: 'log'
                },
                debug: {
                    priority: 5,
                    method: 'debug'
                },
                spam: {
                    priority: 6,
                    method: 'log'
                }
            };
        /***/ },
        /* 120 */ /***/ function(module1, exports) {
            /**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
                switch(args.length){
                    case 0:
                        return func.call(thisArg);
                    case 1:
                        return func.call(thisArg, args[0]);
                    case 2:
                        return func.call(thisArg, args[0], args[1]);
                    case 3:
                        return func.call(thisArg, args[0], args[1], args[2]);
                }
                return func.apply(thisArg, args);
            }
            module1.exports = apply;
        /***/ },
        /* 121 */ /***/ function(module1, exports, __webpack_require__) {
            var baseSetToString = __webpack_require__(400), shortOut = __webpack_require__(194);
            /**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
            module1.exports = setToString;
        /***/ },
        /* 122 */ /***/ function(module1, exports, __webpack_require__) {
            var eq = __webpack_require__(54), isArrayLike = __webpack_require__(25), isIndex = __webpack_require__(67), isObject = __webpack_require__(11);
            /**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
                if (!isObject(object)) return false;
                var type = typeof index;
                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
                return false;
            }
            module1.exports = isIterateeCall;
        /***/ },
        /* 123 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(196)() ? Object.setPrototypeOf : __webpack_require__(197);
        /***/ },
        /* 124 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(57);
            // prettier-ignore
            var possibleTypes = {
                "object": true,
                "function": true,
                "undefined": true
            };
            module1.exports = function(value) {
                if (!isValue(value)) return false;
                return hasOwnProperty.call(possibleTypes, typeof value);
            };
        /***/ },
        /* 125 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(411)() ? Object.assign : __webpack_require__(412);
        /***/ },
        /* 126 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-underscore-dangle */ const logging = __webpack_require__(2)('Event');
            const assign = __webpack_require__(9);
            const intersection = __webpack_require__(127);
            module1.exports = /*#__PURE__*/ function() {
                function Event1(type, cancelable, props) {
                    if (cancelable === void 0) cancelable = true;
                    if (props === void 0) props = {};
                    this.type = type;
                    this.cancelable = cancelable;
                    this._defaultPrevented = false;
                    const reservedKeys = intersection(Object.keys(this), Object.keys(props));
                    if (reservedKeys.length > 0) throw new Error(`Cannot used reserved property names: ${reservedKeys.join(',')}`);
                    assign(this, props);
                }
                var _proto = Event1.prototype;
                _proto.preventDefault = function preventDefault() {
                    if (this.cancelable) this._defaultPrevented = true;
                    else logging.warn("Event.preventDefault :: Trying to preventDefault on an event that isn't cancelable");
                };
                _proto.isDefaultPrevented = function isDefaultPrevented() {
                    return this._defaultPrevented;
                };
                return Event1;
            }();
        /***/ },
        /* 127 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayMap = __webpack_require__(34), baseIntersection = __webpack_require__(452), baseRest = __webpack_require__(88), castArrayLikeObject = __webpack_require__(458);
            /**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var intersection = baseRest(function(arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            module1.exports = intersection;
        /***/ },
        /* 128 */ /***/ function(module1, exports) {
            /**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
                var index = -1, length = array == null ? 0 : array.length;
                while(++index < length){
                    if (comparator(value, array[index])) return true;
                }
                return false;
            }
            module1.exports = arrayIncludesWith;
        /***/ },
        /* 129 */ /***/ function(module1, exports, __webpack_require__) {
            var isArrayLike = __webpack_require__(25), isObjectLike = __webpack_require__(18);
            /**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
            }
            module1.exports = isArrayLikeObject;
        /***/ },
        /* 130 */ /***/ function(module1, exports) {
            /**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module1.exports = {};
        /***/ },
        /* 131 */ /***/ function(module1, exports, __webpack_require__) {
            var baseSetData = __webpack_require__(217), createBind = __webpack_require__(481), createCurry = __webpack_require__(482), createHybrid = __webpack_require__(219), createPartial = __webpack_require__(493), getData = __webpack_require__(223), mergeData = __webpack_require__(494), setData = __webpack_require__(226), setWrapToString = __webpack_require__(227), toInteger = __webpack_require__(97);
            /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
            /**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var length = partials ? partials.length : 0;
                if (!length) {
                    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                    partials = holders = undefined;
                }
                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;
                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                    var partialsRight = partials, holdersRight = holders;
                    partials = holders = undefined;
                }
                var data = isBindKey ? undefined : getData(func);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ];
                if (data) mergeData(newData, data);
                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
                else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
                else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
                else result = createHybrid.apply(undefined, newData);
                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
            }
            module1.exports = createWrap;
        /***/ },
        /* 132 */ /***/ function(module1, exports, __webpack_require__) {
            var baseCreate = __webpack_require__(87), baseLodash = __webpack_require__(133);
            /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
            /**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
            }
            // Ensure `LazyWrapper` is an instance of `baseLodash`.
            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            module1.exports = LazyWrapper;
        /***/ },
        /* 133 */ /***/ function(module1, exports) {
            /**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
            // No operation performed.
            }
            module1.exports = baseLodash;
        /***/ },
        /* 134 */ /***/ function(module1, exports) {
            /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
            /**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function replaceHolders(array, placeholder) {
                var index = -1, length = array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (value === placeholder || value === PLACEHOLDER) {
                        array[index] = PLACEHOLDER;
                        result[resIndex++] = index;
                    }
                }
                return result;
            }
            module1.exports = replaceHolders;
        /***/ },
        /* 135 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), getPrototype = __webpack_require__(117), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var objectTag = '[object Object]';
            /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
            /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
            /**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty1.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            module1.exports = isPlainObject;
        /***/ },
        /* 136 */ /***/ function(module1, exports, __webpack_require__) {
            var isArray = __webpack_require__(12), isSymbol = __webpack_require__(71);
            /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
            /**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
                if (isArray(value)) return false;
                var type = typeof value;
                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
            }
            module1.exports = isKey;
        /***/ },
        /* 137 */ /***/ function(module1, exports, __webpack_require__) {
            var flatten = __webpack_require__(517), overRest = __webpack_require__(193), setToString = __webpack_require__(121);
            /**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
            }
            module1.exports = flatRest;
        /***/ },
        /* 138 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const urlUtil = __webpack_require__(240);
            const stripTrailingSlash = (url)=>url.replace(/\/$/, '');
            const prependProxyToUrlIfNeeded = (url, proxyUrl)=>{
                if (!proxyUrl) return url;
                const proxyUrlParsed = urlUtil.parse(proxyUrl);
                const urlParsed = urlUtil.parse(url);
                if (!proxyUrlParsed.protocol || !urlParsed.protocol) return url;
                const isSsl = proxyUrlParsed.protocol.match(/^https/);
                const isWs = urlParsed.protocol.match(/^ws/i);
                const protocol = (isWs ? 'ws' : 'http') + (isSsl ? 's' : '');
                const targetUrl = stripTrailingSlash(`${protocol}://${proxyUrlParsed.host}${proxyUrlParsed.pathname}`);
                const targetPath = stripTrailingSlash(`${urlParsed.host}${urlParsed.pathname}${urlParsed.search || ''}`);
                return `${targetUrl}/${targetPath}`;
            };
            module1.exports = {
                prependProxyToUrlIfNeeded: prependProxyToUrlIfNeeded
            };
        /***/ },
        /* 139 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ const sessionObjects = __webpack_require__(21);
            const otError = __webpack_require__(13);
            const Errors = __webpack_require__(6);
            const ExceptionCodes = __webpack_require__(10);
            const OTErrorClass = __webpack_require__(22);
            let proxyUrl;
            const errorMessages = {
                SET_PROXY_URL_TIMING_ERROR: 'The proxyUrl was set after a session or publisher was created.',
                PROXY_URL_ALREADY_SET_ERROR: 'The proxyUrl has already been set. Setting it again will not have any effect.'
            };
            /**
 * Sets the URL of the IP proxy server. With the IP proxy feature, the client
 * routes all internet traffic (except for media streams) via your proxy server.
 * <p>
 * You must call this method before calling any other OpenTok methods.
 * This ensures that the proxy server is used for OpenTok traffic. Otherwise,
 * the call fails, and the <code>OT</code> object dispatches an
 * <code>exception</code> event. The <code>OT</code> object also dispatches an
 * <code>exception</code> event if you call this method after having
 * previously called it.
 * <p>
 * This is available as an add-on feature. For more information, see the
 * <a href="https://tokbox.com/developer/guides/ip-proxy/">IP proxy developer
 * guide</a>.
 *
 * @method OT.setProxyUrl
 * @memberof OT
 */ module1.exports = {
                errorMessages: errorMessages,
                setProxyUrl: (url)=>{
                    // This is necessary to break a circular dependancy, but seems hacky and should be cleaned up
                    const AnalyticsHelper = __webpack_require__(26);
                    const apiKey = __webpack_require__(72);
                    const analytics = new AnalyticsHelper();
                    const hasSessionInitalized = sessionObjects.sessions.length() > 0;
                    const hasPublisherInitalized = sessionObjects.publishers.length() > 0;
                    let sessionId;
                    if (hasSessionInitalized) {
                        const connectedSession = sessionObjects.sessions.find((session)=>session.currentState === 'connected');
                        sessionId = connectedSession ? connectedSession.sessionId : sessionObjects.sessions.find().sessionId;
                    } else sessionId = '';
                    const target = {
                        sessionId: sessionId,
                        apiKey: apiKey.value
                    };
                    if (hasPublisherInitalized || hasSessionInitalized) {
                        const error = otError()(Errors.SET_PROXY_URL_TIMING_ERROR, new Error(errorMessages.SET_PROXY_URL_TIMING_ERROR), ExceptionCodes.SET_PROXY_URL_TIMING_ERROR);
                        OTErrorClass.handleJsException({
                            error: error,
                            target: target,
                            analytics: analytics
                        });
                    } else if (proxyUrl) {
                        const error = otError()(Errors.PROXY_URL_ALREADY_SET_ERROR, new Error(errorMessages.PROXY_URL_ALREADY_SET_ERROR), ExceptionCodes.PROXY_URL_ALREADY_SET_ERROR);
                        OTErrorClass.handleJsException({
                            error: error,
                            target: target,
                            analytics: analytics
                        });
                    } else // eslint-disable-next-line no-param-reassign
                    proxyUrl = url;
                },
                getProxyUrl: ()=>proxyUrl,
                // this method should only be exposed to tests
                clearProxyUrl: ()=>{
                    proxyUrl = null;
                }
            };
        /***/ },
        /* 140 */ /***/ function(module1, exports, __webpack_require__) {
            var baseRest = __webpack_require__(88), eq = __webpack_require__(54), isIterateeCall = __webpack_require__(122), keysIn = __webpack_require__(55);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var defaults = baseRest(function(object, sources) {
                object = Object(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
                while(++index < length){
                    var source = sources[index];
                    var props = keysIn(source);
                    var propsIndex = -1;
                    var propsLength = props.length;
                    while(++propsIndex < propsLength){
                        var key = props[propsIndex];
                        var value = object[key];
                        if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty1.call(object, key)) object[key] = source[key];
                    }
                }
                return object;
            });
            module1.exports = defaults;
        /***/ },
        /* 141 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            /* eslint-disable no-underscore-dangle */ const _get = __webpack_require__(59);
            const cloneDeep = __webpack_require__(58);
            /**
 * Provides an interface around the raw session info from Anvil
 *
 * @class SessionInfo
 * @param {Object} rawSessionInfo The raw session info from Anvil
 *
 */ let SessionInfo = /*#__PURE__*/ function() {
                function SessionInfo(rawSessionInfo) {
                    if (rawSessionInfo === void 0) rawSessionInfo = {};
                    Object.defineProperty(this, '_rawSessionInfo', {
                        value: cloneDeep(rawSessionInfo)
                    });
                }
                /**
   * @type {String}
   * @readonly
   */ (0, _createClass2.default)(SessionInfo, [
                    {
                        key: "sessionId",
                        get: function get() {
                            return this._rawSessionInfo.session_id;
                        }
                    },
                    {
                        key: "partnerId",
                        get: function get() {
                            return this._rawSessionInfo.partner_id;
                        }
                    },
                    {
                        key: "messagingServer",
                        get: function get() {
                            return this._rawSessionInfo.messaging_server_url;
                        }
                    },
                    {
                        key: "mediaServerName",
                        get: function get() {
                            return this._rawSessionInfo.media_server_hostname;
                        }
                    },
                    {
                        key: "messagingURL",
                        get: function get() {
                            return this._rawSessionInfo.messaging_url;
                        }
                    },
                    {
                        key: "symphonyAddress",
                        get: function get() {
                            return this._rawSessionInfo.symphony_address;
                        }
                    },
                    {
                        key: "iceServers",
                        get: function get() {
                            return this._rawSessionInfo.ice_servers;
                        }
                    },
                    {
                        key: "simulcast",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.simulcast');
                        }
                    },
                    {
                        key: "e2ee",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.e2ee', false);
                        }
                    },
                    {
                        key: "reconnection",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.reconnection', false);
                        }
                    },
                    {
                        key: "renegotiation",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.renegotiation', false);
                        }
                    },
                    {
                        key: "p2pEnabled",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.p2p.preference.value') === 'enabled';
                        }
                    },
                    {
                        key: "hybridSession",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.hybridSession', false);
                        }
                    },
                    {
                        key: "isAdaptiveEnabled",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.p2p.preference.value') === 'adaptive';
                        }
                    },
                    {
                        key: "priorityVideoCodec",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.priorityVideoCodec', '');
                        }
                    },
                    {
                        key: "h264",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.h264', true);
                        }
                    },
                    {
                        key: "vp8",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.vp8', true);
                        }
                    },
                    {
                        key: "vp9",
                        get: function get() {
                            return _get(this._rawSessionInfo, 'properties.vp9', true);
                        }
                    },
                    {
                        key: "clientCandidates",
                        get: function get() {
                            const rawValue = _get(this._rawSessionInfo, 'properties.clientCandidates');
                            return rawValue === 'relayed' ? 'relay' : rawValue;
                        }
                    }
                ]);
                return SessionInfo;
            }();
            module1.exports = SessionInfo;
        /***/ },
        /* 142 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const extendES5Native = __webpack_require__(559);
            const webrtcAdapter = __webpack_require__(560);
            const logging = __webpack_require__(2)('createWindowMock');
            const env = __webpack_require__(3);
            const windowKeys = [
                {
                    key: 'location',
                    type: 'object'
                },
                {
                    key: 'setTimeout',
                    type: 'function'
                },
                {
                    key: 'requestAnimationFrame',
                    type: 'function'
                },
                {
                    key: 'URL',
                    type: 'function'
                },
                {
                    key: 'MediaStream',
                    type: 'class'
                },
                {
                    key: 'webkitMediaStream',
                    type: 'class'
                },
                {
                    key: 'RTCIceCandidate',
                    type: 'class'
                },
                {
                    key: 'mozRTCIceCandidate',
                    type: 'class'
                },
                {
                    key: 'RTCSessionDescription',
                    type: 'class'
                },
                {
                    key: 'mozRTCSessionDescription',
                    type: 'class'
                },
                {
                    key: 'RTCIceGatherer',
                    type: 'class'
                },
                {
                    key: 'RTCIceTransport',
                    type: 'class'
                },
                {
                    key: 'RTCDtlsTransport',
                    type: 'class'
                },
                {
                    key: 'RTCSctpTransport',
                    type: 'class'
                },
                {
                    key: 'RTCRtpReceiver',
                    type: 'class'
                },
                {
                    key: 'HTMLMediaElement',
                    type: 'class'
                },
                {
                    key: 'RTCPeerConnection',
                    type: 'class'
                },
                {
                    key: 'webkitRTCPeerConnection',
                    type: 'class'
                },
                {
                    key: 'mozRTCPeerConnection',
                    type: 'class'
                },
                {
                    key: 'MediaStreamTrack',
                    type: 'class'
                },
                {
                    key: 'RTCRtpSender',
                    type: 'class'
                },
                {
                    key: 'RTCTrackEvent',
                    type: 'class'
                },
                {
                    key: 'RTCTransceiver',
                    type: 'class'
                },
                {
                    key: 'RTCDtmfSender',
                    type: 'class'
                },
                {
                    key: 'RTCDTMFSender',
                    type: 'class'
                },
                {
                    key: 'MediaStreamTrackEvent',
                    type: 'class'
                }
            ];
            const navigatorKeys = [
                {
                    key: 'userAgent',
                    type: 'string'
                },
                {
                    key: 'getUserMedia',
                    type: 'function'
                },
                {
                    key: 'getDisplayMedia',
                    type: 'function'
                },
                {
                    key: 'webkitGetUserMedia',
                    type: 'function'
                },
                {
                    key: 'mozGetUserMedia',
                    type: 'function'
                }
            ];
            const mediaDevicesKeys = [
                {
                    key: 'getUserMedia',
                    type: 'function'
                },
                {
                    key: 'getDisplayMedia',
                    type: 'function'
                },
                {
                    key: 'enumerateDevices',
                    type: 'function'
                },
                {
                    key: 'getSupportedConstraints',
                    type: 'function'
                },
                {
                    key: 'addEventListener',
                    type: 'function'
                },
                {
                    key: 'removeEventListener',
                    type: 'function'
                }
            ];
            const bindWithStaticProperties = (context, func)=>{
                if (typeof func !== 'function') {
                    logging.warn('Non-function passed into bindWithStaticProperties()');
                    return func;
                }
                const bound = func.bind(context);
                Object.keys(func).forEach((key)=>{
                    bound[key] = func[key];
                });
                return bound;
            };
            const extendParentClass = (ParentClass)=>{
                try {
                    // The below __proto__ hack is so we can extend RTCPeerConnection in Firefox and Safari
                    // See: https://bugs.webkit.org/show_bug.cgi?id=172867#c6
                    // eslint-disable-next-line no-eval
                    const ChildClass = eval(`
      "use strict"; // Chrome<49 requires strict mode

      const getOwnProperties = (target) => {
        const properties = {};
        Object.getOwnPropertyNames(target).forEach((key) => {
          properties[key] = Object.getOwnPropertyDescriptor(target, key);
        });
        return properties;
      };

      class ChildClass extends ParentClass {
        constructor(...args) {
          super(...args);
          try {
            this.__proto__ = ChildClass.prototype;
          } catch (e) {}
        }
      };

      Object.defineProperties(ChildClass.prototype, getOwnProperties(ParentClass.prototype));
      Object.keys(ParentClass)
        .forEach((staticKey) => {
          ChildClass[staticKey] = ParentClass[staticKey];
        });

      ChildClass; // Ensure the final statement is returned in FF
    `);
                    if (ChildClass && ChildClass.prototype instanceof ParentClass) return ChildClass;
                } catch (e) {}
                return null;
            };
            const canUseES6Class = (window1)=>{
                const RTCPeerConnection = window1.RTCPeerConnection || window1.webkitRTCPeerConnection || window1.mozRTCPeerConnection;
                const PC = extendParentClass(RTCPeerConnection);
                if (PC) try {
                    PC.prototype.foo = 'bar';
                    const instance = new PC({
                        iceServers: []
                    });
                    const result = instance.foo === 'bar';
                    try {
                        instance.close();
                    } catch (e) {} // eslint-disable-line no-empty
                    return result;
                } catch (e) {}
                return false;
            };
            const extendClass = (ParentClass, label, canUseClass)=>{
                if (typeof ParentClass !== 'function') {
                    logging.warn('Non-function passed into extendClass()');
                    return ParentClass;
                }
                let result = canUseClass && extendParentClass(ParentClass);
                if (!result) result = extendES5Native(ParentClass);
                return result;
            };
            const getCopyProperties = (canUseClass)=>(target, source, keys)=>{
                    keys.forEach((_ref)=>{
                        let key = _ref.key, type = _ref.type;
                        let value = source[key];
                        if (value !== undefined) {
                            switch(type){
                                case 'function':
                                    value = bindWithStaticProperties(source, value);
                                    break;
                                case 'class':
                                    value = extendClass(value, key, canUseClass);
                                    break;
                                case 'string':
                                case 'object':
                                    break;
                                default:
                                    throw new Error(`Invalid type of window key: ${type}`);
                            }
                            target[key] = value; // eslint-disable-line no-param-reassign
                        }
                    });
                };
            const cloneWindow = (window1)=>{
                const windowMock = {};
                const copyProperties = getCopyProperties(canUseES6Class(window1));
                copyProperties(windowMock, window1, windowKeys);
                if (window1.navigator !== undefined) {
                    windowMock.navigator = {};
                    copyProperties(windowMock.navigator, window1.navigator, navigatorKeys);
                    if (window1.navigator.mediaDevices !== undefined) {
                        windowMock.navigator.mediaDevices = {};
                        copyProperties(windowMock.navigator.mediaDevices, window1.navigator.mediaDevices, mediaDevicesKeys);
                    }
                }
                return windowMock;
            };
            module1.exports = function createWindowMock(window1) {
                // We avoid shimming twice because adapter is not idempotent.
                // Unfortunately checking for window.adapter can be used to detect
                // adapter.js but not adapter_no_global.js, there is no reliable
                // way of detecting it.
                if (window1.adapter !== undefined || env.isLegacyEdge) return window1;
                const windowMock = cloneWindow(window1);
                webrtcAdapter({
                    window: windowMock
                });
                return windowMock;
            };
        /***/ },
        /* 143 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 * Transforms a raw audio level to produce a "smoother" animation when using displaying the
 * audio level. This transformer is state-full because it needs to keep the previous average
 * value of the signal for filtering.
 *
 * It applies a low pass filter to get rid of level jumps and apply a log scale.
 *
 * @constructor
 */ module1.exports = function AudioLevelTransformer() {
                let averageAudioLevel = null;
                /*
   *
   * @param {number} audioLevel a level in the [0,1] range
   * @returns {number} a level in the [0,1] range transformed
   */ this.transform = (audioLevel)=>{
                    if (averageAudioLevel === null || audioLevel >= averageAudioLevel) averageAudioLevel = audioLevel;
                    else // a simple low pass filter with a smoothing of 70
                    averageAudioLevel = audioLevel * 0.3 + averageAudioLevel * 0.7;
                     // 1.5 scaling to map -30-0 dBm range to [0,1]
                    const logScaled = Math.log(averageAudioLevel) / Math.LN10 / 1.5 + 1;
                    return Math.min(Math.max(logScaled, 0), 1);
                };
            };
        /***/ },
        /* 144 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-underscore-dangle */ const eventing = __webpack_require__(7);
            const values = (obj)=>Object.keys(obj).map((key)=>obj[key]);
            const assign = __webpack_require__(9); // Manages N Chrome elements
            module1.exports = function Chrome(properties) {
                const _widgets = {}; // Private helper function
                const _set = (name, widget)=>{
                    assign(widget, {
                        parent: this
                    });
                    widget.appendTo(properties.parent);
                    _widgets[name] = widget;
                    this[name] = widget;
                };
                if (!properties.parent) // @todo raise an exception
                return;
                eventing(this);
                this.destroy = ()=>{
                    this.off();
                    this.hideWhileLoading();
                    values(_widgets).forEach((widget)=>widget.destroy());
                };
                this.showAfterLoading = ()=>{
                    values(_widgets).forEach((widget)=>widget.showAfterLoading());
                };
                this.hideWhileLoading = ()=>{
                    values(_widgets).forEach((widget)=>widget.hideWhileLoading());
                }; // Adds the widget to the chrome and to the DOM. Also creates a accessor
                // property for it on the chrome.
                //
                // @example
                //  chrome.set('foo', new FooWidget());
                //  chrome.foo.setDisplayMode('on');
                //
                // @example
                //  chrome.set({
                //      foo: new FooWidget(),
                //      bar: new BarWidget()
                //  });
                //  chrome.foo.setDisplayMode('on');
                //
                this.set = (widgetName, widget)=>{
                    if (typeof widgetName === 'string' && widget) _set(widgetName, widget);
                    else Object.keys(widgetName).forEach((name)=>{
                        _set(name, widgetName[name]);
                    });
                    return this;
                };
            };
        /***/ },
        /* 145 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _temp;
            /* eslint-disable no-underscore-dangle */ /*
 * An <code>AudioContext</code> based audio level sampler. It returns the maximum value in the
 * last 1024 samples.
 *
 * It is worth noting that the remote <code>MediaStream</code> audio analysis is currently only
 * available in FF.
 *
 * This implementation gracefully handles the case where the <code>MediaStream</code> has not
 * been set yet by returning a <code>null</code> value until the stream is set. It is up to the
 * call site to decide what to do with this value (most likely ignore it and retry later).
 *
 * @constructor
 * @param {AudioContext} audioContext an audio context instance to get an analyser node
 */ module1.exports = (_temp = /*#__PURE__*/ function() {
                function WebAudioAudioLevelSampler(audioContext) {
                    (0, _defineProperty2.default)(this, "_analyser", null);
                    (0, _defineProperty2.default)(this, "_timeDomainData", null);
                    (0, _defineProperty2.default)(this, "_sourceNode", null);
                    this._audioContext = audioContext;
                }
                var _proto = WebAudioAudioLevelSampler.prototype;
                _proto._initAudioAnalyser = function _initAudioAnalyser(mediaStream) {
                    this._analyser = this._audioContext.createAnalyser();
                    this._sourceNode = this._audioContext.createMediaStreamSource(mediaStream);
                    this._sourceNode.connect(this._analyser);
                    this._timeDomainData = new Uint8Array(this._analyser.frequencyBinCount);
                };
                _proto.webRTCStream = function webRTCStream(mediaStream) {
                    if (this._sourceNode) this._sourceNode.disconnect(this._analyser);
                    if (this._audioContext.state === 'suspended') this._audioContext.resume();
                    this._initAudioAnalyser(mediaStream);
                };
                _proto.destroy = function destroy() {
                    if (this._sourceNode) this._sourceNode.disconnect(this._analyser);
                    this._timeDomainData = null;
                };
                _proto.sample = function sample(done) {
                    if (typeof done === 'function') throw new Error('sample no longer takes a callback');
                    if (this._analyser && this._timeDomainData) {
                        this._analyser.getByteTimeDomainData(this._timeDomainData); // varies from 0 to 255
                        let max = 0;
                        for(let idx = this._timeDomainData.length - 1; idx >= 0; idx -= 1)max = Math.max(max, Math.abs(this._timeDomainData[idx] - 128));
                         // normalize the collected level to match the range delivered by
                        // the getStats' audioOutputLevel
                        return max / 128;
                    }
                    return null;
                };
                return WebAudioAudioLevelSampler;
            }(), _temp);
        /***/ },
        /* 146 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-use-before-define */ const domState = __webpack_require__(571);
            const eventNames = __webpack_require__(27);
            const eventing = __webpack_require__(7);
            const Events = __webpack_require__(23)(); // Helper to synchronise several startup tasks and then dispatch a unified
            // 'envLoaded' event.
            function EnvironmentLoader() {
                const environmentLoader = this;
                eventing(environmentLoader);
                function isReady() {
                    return domState.isDomLoaded() && !domState.isDomUnloaded();
                }
                function onLoaded() {
                    if (isReady()) environmentLoader.dispatchEvent(new Events.EnvLoadedEvent(eventNames.ENV_LOADED));
                }
                function onDomReady() {
                    domState.whenUnloaded.then(onDomUnload);
                    onLoaded();
                }
                function onDomUnload() {
                    environmentLoader.dispatchEvent(new Events.EnvLoadedEvent(eventNames.ENV_UNLOADED));
                }
                domState.whenLoaded.then(onDomReady);
                this.onLoad = function(cb, context) {
                    if (isReady()) {
                        cb.call(context);
                        return;
                    }
                    environmentLoader.on(eventNames.ENV_LOADED, cb, context);
                };
                this.onUnload = function(cb, context) {
                    if (this.isUnloaded()) {
                        cb.call(context);
                        return;
                    }
                    environmentLoader.on(eventNames.ENV_UNLOADED, cb, context);
                };
                this.isUnloaded = function() {
                    return domState.isDomUnloaded();
                };
            }
            module1.exports = new EnvironmentLoader();
        /***/ },
        /* 147 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var objectAssign = __webpack_require__(576);
            // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
            // original notice:
            /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
                if (a === b) return 0;
                var x = a.length;
                var y = b.length;
                for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                    x = a[i];
                    y = b[i];
                    break;
                }
                if (x < y) return -1;
                if (y < x) return 1;
                return 0;
            }
            function isBuffer(b) {
                if (window.Buffer && typeof window.Buffer.isBuffer === 'function') return window.Buffer.isBuffer(b);
                return !!(b != null && b._isBuffer);
            }
            // based on node assert, original notice:
            // NB: The URL to the CommonJS spec is kept just for tradition.
            //     node-assert has evolved a lot since then, both in API and behavior.
            // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
            //
            // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
            //
            // Originally from narwhal.js (http://narwhaljs.org)
            // Copyright (c) 2009 Thomas Robinson <280north.com>
            //
            // Permission is hereby granted, free of charge, to any person obtaining a copy
            // of this software and associated documentation files (the 'Software'), to
            // deal in the Software without restriction, including without limitation the
            // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
            // sell copies of the Software, and to permit persons to whom the Software is
            // furnished to do so, subject to the following conditions:
            //
            // The above copyright notice and this permission notice shall be included in
            // all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
            // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
            var util = __webpack_require__(577);
            var hasOwn = Object.prototype.hasOwnProperty;
            var pSlice = Array.prototype.slice;
            var functionsHaveNames = function() {
                return (function foo() {}).name === 'foo';
            }();
            function pToString(obj) {
                return Object.prototype.toString.call(obj);
            }
            function isView(arrbuf) {
                if (isBuffer(arrbuf)) return false;
                if (typeof window.ArrayBuffer !== 'function') return false;
                if (typeof ArrayBuffer.isView === 'function') return ArrayBuffer.isView(arrbuf);
                if (!arrbuf) return false;
                if (arrbuf instanceof DataView) return true;
                if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
                return false;
            }
            // 1. The assert module provides functions that throw
            // AssertionError's when particular conditions are not met. The
            // assert module must conform to the following interface.
            var assert = module1.exports = ok;
            // 2. The AssertionError is defined in assert.
            // new assert.AssertionError({ message: message,
            //                             actual: actual,
            //                             expected: expected })
            var regex = /\s*function\s+([^\(\s]*)\s*/;
            // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
            function getName(func) {
                if (!util.isFunction(func)) return;
                if (functionsHaveNames) return func.name;
                var str = func.toString();
                var match = str.match(regex);
                return match && match[1];
            }
            assert.AssertionError = function AssertionError(options) {
                this.name = 'AssertionError';
                this.actual = options.actual;
                this.expected = options.expected;
                this.operator = options.operator;
                if (options.message) {
                    this.message = options.message;
                    this.generatedMessage = false;
                } else {
                    this.message = getMessage(this);
                    this.generatedMessage = true;
                }
                var stackStartFunction = options.stackStartFunction || fail;
                if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
                else {
                    // non v8 browsers so we can have a stacktrace
                    var err = new Error();
                    if (err.stack) {
                        var out = err.stack;
                        // try to strip useless frames
                        var fn_name = getName(stackStartFunction);
                        var idx = out.indexOf('\n' + fn_name);
                        if (idx >= 0) {
                            // once we have located the function frame
                            // we need to strip out everything before it (and its line)
                            var next_line = out.indexOf('\n', idx + 1);
                            out = out.substring(next_line + 1);
                        }
                        this.stack = out;
                    }
                }
            };
            // assert.AssertionError instanceof Error
            util.inherits(assert.AssertionError, Error);
            function truncate(s, n) {
                if (typeof s === 'string') return s.length < n ? s : s.slice(0, n);
                else return s;
            }
            function inspect(something) {
                if (functionsHaveNames || !util.isFunction(something)) return util.inspect(something);
                var rawname = getName(something);
                var name = rawname ? ': ' + rawname : '';
                return '[Function' + name + ']';
            }
            function getMessage(self1) {
                return truncate(inspect(self1.actual), 128) + ' ' + self1.operator + ' ' + truncate(inspect(self1.expected), 128);
            }
            // At present only the three keys mentioned above are used and
            // understood by the spec. Implementations or sub modules can pass
            // other keys to the AssertionError's constructor - they will be
            // ignored.
            // 3. All of the following functions must throw an AssertionError
            // when a corresponding condition is not met, with a message that
            // may be undefined if not provided.  All assertion methods provide
            // both the actual and expected values to the assertion error for
            // display purposes.
            function fail(actual, expected, message, operator, stackStartFunction) {
                throw new assert.AssertionError({
                    message: message,
                    actual: actual,
                    expected: expected,
                    operator: operator,
                    stackStartFunction: stackStartFunction
                });
            }
            // EXTENSION! allows for well behaved errors defined elsewhere.
            assert.fail = fail;
            // 4. Pure assertion tests whether a value is truthy, as determined
            // by !!guard.
            // assert.ok(guard, message_opt);
            // This statement is equivalent to assert.equal(true, !!guard,
            // message_opt);. To test strictly for the value true, use
            // assert.strictEqual(true, guard, message_opt);.
            function ok(value, message) {
                if (!value) fail(value, true, message, '==', assert.ok);
            }
            assert.ok = ok;
            // 5. The equality assertion tests shallow, coercive equality with
            // ==.
            // assert.equal(actual, expected, message_opt);
            assert.equal = function equal(actual, expected, message) {
                if (actual != expected) fail(actual, expected, message, '==', assert.equal);
            };
            // 6. The non-equality assertion tests for whether two objects are not equal
            // with != assert.notEqual(actual, expected, message_opt);
            assert.notEqual = function notEqual(actual, expected, message) {
                if (actual == expected) fail(actual, expected, message, '!=', assert.notEqual);
            };
            // 7. The equivalence assertion tests a deep equality relation.
            // assert.deepEqual(actual, expected, message_opt);
            assert.deepEqual = function deepEqual(actual, expected, message) {
                if (!_deepEqual(actual, expected, false)) fail(actual, expected, message, 'deepEqual', assert.deepEqual);
            };
            assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
                if (!_deepEqual(actual, expected, true)) fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
            };
            function _deepEqual(actual, expected, strict, memos) {
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (isBuffer(actual) && isBuffer(expected)) return compare(actual, expected) === 0;
                else if (util.isDate(actual) && util.isDate(expected)) return actual.getTime() === expected.getTime();
                else if (util.isRegExp(actual) && util.isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
                else if ((actual === null || typeof actual !== 'object') && (expected === null || typeof expected !== 'object')) return strict ? actual === expected : actual == expected;
                else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
                else if (isBuffer(actual) !== isBuffer(expected)) return false;
                else {
                    memos = memos || {
                        actual: [],
                        expected: []
                    };
                    var actualIndex = memos.actual.indexOf(actual);
                    if (actualIndex !== -1) {
                        if (actualIndex === memos.expected.indexOf(expected)) return true;
                    }
                    memos.actual.push(actual);
                    memos.expected.push(expected);
                    return objEquiv(actual, expected, strict, memos);
                }
            }
            function isArguments(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
            }
            function objEquiv(a, b, strict, actualVisitedObjects) {
                if (a === null || a === undefined || b === null || b === undefined) return false;
                // if one is a primitive, the other must be same
                if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
                if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
                var aIsArgs = isArguments(a);
                var bIsArgs = isArguments(b);
                if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
                if (aIsArgs) {
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return _deepEqual(a, b, strict);
                }
                var ka = objectKeys(a);
                var kb = objectKeys(b);
                var key, i;
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length !== kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] !== kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
                }
                return true;
            }
            // 8. The non-equivalence assertion tests for any deep inequality.
            // assert.notDeepEqual(actual, expected, message_opt);
            assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
                if (_deepEqual(actual, expected, false)) fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
            };
            assert.notDeepStrictEqual = notDeepStrictEqual;
            function notDeepStrictEqual(actual, expected, message) {
                if (_deepEqual(actual, expected, true)) fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
            }
            // 9. The strict equality assertion tests strict equality, as determined by ===.
            // assert.strictEqual(actual, expected, message_opt);
            assert.strictEqual = function strictEqual(actual, expected, message) {
                if (actual !== expected) fail(actual, expected, message, '===', assert.strictEqual);
            };
            // 10. The strict non-equality assertion tests for strict inequality, as
            // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
            assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
                if (actual === expected) fail(actual, expected, message, '!==', assert.notStrictEqual);
            };
            function expectedException(actual, expected) {
                if (!actual || !expected) return false;
                if (Object.prototype.toString.call(expected) == '[object RegExp]') return expected.test(actual);
                try {
                    if (actual instanceof expected) return true;
                } catch (e) {
                // Ignore.  The instanceof check doesn't work for arrow functions.
                }
                if (Error.isPrototypeOf(expected)) return false;
                return expected.call({}, actual) === true;
            }
            function _tryBlock(block) {
                var error;
                try {
                    block();
                } catch (e) {
                    error = e;
                }
                return error;
            }
            function _throws(shouldThrow, block, expected, message) {
                var actual;
                if (typeof block !== 'function') throw new TypeError('"block" argument must be a function');
                if (typeof expected === 'string') {
                    message = expected;
                    expected = null;
                }
                actual = _tryBlock(block);
                message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');
                if (shouldThrow && !actual) fail(actual, expected, 'Missing expected exception' + message);
                var userProvidedMessage = typeof message === 'string';
                var isUnwantedException = !shouldThrow && util.isError(actual);
                var isUnexpectedException = !shouldThrow && actual && !expected;
                if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) fail(actual, expected, 'Got unwanted exception' + message);
                if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) throw actual;
            }
            // 11. Expected to throw an error:
            // assert.throws(block, Error_opt, message_opt);
            assert.throws = function(block, /*optional*/ error, /*optional*/ message) {
                _throws(true, block, error, message);
            };
            // EXTENSION! This is annoying to write outside this module.
            assert.doesNotThrow = function(block, /*optional*/ error, /*optional*/ message) {
                _throws(false, block, error, message);
            };
            assert.ifError = function(err) {
                if (err) throw err;
            };
            // Expose a strict only variant of assert
            function strict(value, message) {
                if (!value) fail(value, true, message, '==', strict);
            }
            assert.strict = objectAssign(strict, assert, {
                equal: assert.strictEqual,
                deepEqual: assert.deepStrictEqual,
                notEqual: assert.notStrictEqual,
                notDeepEqual: assert.notDeepStrictEqual
            });
            assert.strict.strict = assert.strict;
            var objectKeys = Object.keys || function(obj) {
                var keys = [];
                for(var key in obj)if (hasOwn.call(obj, key)) keys.push(key);
                return keys;
            };
        /***/ },
        /* 148 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const screenSharingSources = __webpack_require__(584);
            const isElectronScreenSharingSource = __webpack_require__(265);
            const env = __webpack_require__(3);
            module1.exports = (videoSource)=>{
                if (env.isElectron) {
                    // Electron only supports a subset of `screenSharingSources` available on
                    // other user agents
                    if (videoSource === 'screen') return true;
                     // Checks if this video source is a custom screensharing source
                    return isElectronScreenSharingSource(videoSource);
                }
                return screenSharingSources.indexOf(videoSource) > -1;
            };
        /***/ },
        /* 149 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable max-len, no-restricted-syntax, no-prototype-builtins, no-continue */ const castToBoolean = __webpack_require__(268);
            const eventing = __webpack_require__(7);
            const logging = __webpack_require__(2)('StreamChannel');
            const VideoOrientation = __webpack_require__(150)(); // id: String                           | mandatory | immutable
            // type: String {video/audio/data/...}  | mandatory | immutable
            // active: Boolean                      | mandatory | mutable
            // orientation: Integer?                | optional  | mutable
            // frameRate: Float                     | optional  | mutable
            // height: Integer                      | optional  | mutable
            // width: Integer                       | optional  | mutable
            // preferredFrameRate: Float            | optional  | mutable
            // preferredHeight: Integer             | optional  | mutable
            // preferredWidth: Integer              | optional  | mutable
            //
            module1.exports = function StreamChannel(options) {
                this.id = options.id;
                this.type = options.type;
                this.active = castToBoolean(options.active);
                this.orientation = options.orientation || VideoOrientation.ROTATED_NORMAL;
                if (options.frameRate) this.frameRate = parseFloat(options.frameRate);
                if (options.preferredFrameRate) this.preferredFrameRate = parseFloat(options.preferredFrameRate);
                if (options.preferredWidth) this.preferredWidth = parseInt(options.preferredWidth, 10);
                if (options.preferredHeight) this.preferredHeight = parseInt(options.preferredHeight, 10);
                this.width = parseInt(options.width, 10);
                this.height = parseInt(options.height, 10); // The defaults are used for incoming streams from pre 2015Q1 release clients.
                this.source = options.source || 'camera';
                this.fitMode = options.fitMode || 'cover';
                eventing(this); // Returns true if a property was updated.
                this.update = function(attributes) {
                    const videoDimensions = {};
                    const oldVideoDimensions = {};
                    for(const key in attributes){
                        if (!attributes.hasOwnProperty(key)) continue;
                         // we shouldn't really read this before we know the key is valid
                        const oldValue = this[key];
                        switch(key){
                            case 'active':
                                this.active = castToBoolean(attributes[key]);
                                break;
                            case 'disableWarning':
                                this.disableWarning = castToBoolean(attributes[key]);
                                break;
                            case 'frameRate':
                                this.frameRate = parseFloat(attributes[key], 10);
                                break;
                            case 'width':
                            case 'height':
                                this[key] = parseInt(attributes[key], 10);
                                videoDimensions[key] = this[key];
                                oldVideoDimensions[key] = oldValue;
                                break;
                            case 'orientation':
                                this[key] = attributes[key];
                                videoDimensions[key] = this[key];
                                oldVideoDimensions[key] = oldValue;
                                break;
                            case 'fitMode':
                                this[key] = attributes[key];
                                break;
                            case 'source':
                                this[key] = attributes[key];
                                break;
                            default:
                                logging.warn(`Tried to update unknown key ${key} on ${this.type} channel ${this.id}`);
                                return false;
                        }
                        this.trigger('update', this, key, oldValue, this[key]);
                    }
                    if (Object.keys(videoDimensions).length) // To make things easier for the public API, we broadcast videoDimensions changes,
                    // which is an aggregate of width, height, and orientation changes.
                    this.trigger('update', this, 'videoDimensions', oldVideoDimensions, videoDimensions);
                    return true;
                };
            };
        /***/ },
        /* 150 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function videoOrientationFactory() {
                return {
                    ROTATED_NORMAL: 0,
                    ROTATED_LEFT: 270,
                    ROTATED_RIGHT: 90,
                    ROTATED_UPSIDE_DOWN: 180
                };
            };
        /***/ },
        /* 151 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-underscore-dangle */ const fixBackgroundImageURI = __webpack_require__(592);
            const logging = __webpack_require__(2)('StylableComponent');
            const Style = __webpack_require__(593);
            const styleHashLogFilter = __webpack_require__(269);
            /* Stylable Notes
 * Some bits are controlled by multiple flags, i.e. buttonDisplayMode and nameDisplayMode.
 * When there are multiple flags how is the final setting chosen?
 * When some style bits are set updates will need to be pushed through to the Chrome
 */ // Mixes the StylableComponent behaviour into the +self+ object. It will
            // also set the default styles to +initialStyles+.
            //
            // @note This Mixin is dependent on OT.Eventing.
            //
            //
            // @example
            //
            //  function SomeObject {
            //      StylableComponent(this, {
            //          name: 'SomeObject',
            //          foo: 'bar'
            //      });
            //  }
            //
            //  var obj = new SomeObject();
            //  obj.getStyle('foo');        // => 'bar'
            //  obj.setStyle('foo', 'baz')
            //  obj.getStyle('foo');        // => 'baz'
            //  obj.getStyle();             // => {name: 'SomeObject', foo: 'baz'}
            //
            module1.exports = function StylableComponent(self1, initialStyles, showControls, logSetStyleWithPayload) {
                if (!self1.trigger) throw new Error("OT.StylableComponent is dependent on the eventing mixin. Ensure that this is included in the object before StylableComponent.");
                logSetStyleWithPayload = logSetStyleWithPayload || function() {};
                let _readOnly = false; // Broadcast style changes as the styleValueChanged event
                const onStyleChange = function onStyleChange(key, value, oldValue) {
                    if (oldValue) self1.trigger('styleValueChanged', key, value, oldValue);
                    else self1.trigger('styleValueChanged', key, value);
                };
                if (showControls === false) {
                    initialStyles = {
                        buttonDisplayMode: 'off',
                        nameDisplayMode: 'off',
                        audioLevelDisplayMode: 'off',
                        videoDisabledDisplayMode: 'off',
                        audioBlockedDisplayMode: 'off'
                    };
                    _readOnly = true;
                    logSetStyleWithPayload({
                        showControls: false
                    });
                }
                const _style = new Style(initialStyles, onStyleChange);
                /**
   * Returns an object that has the properties that define the current user interface controls of
   * the Publisher. You can modify the properties of this object and pass the object to the
   * <code>setStyle()</code> method of thePublisher object. (See the documentation for
   * <a href="#setStyle">setStyle()</a> to see the styles that define this object.)
   * @return {Object} The object that defines the styles of the Publisher.
   * @see <a href="#setStyle">setStyle()</a>
   * @method #getStyle
   * @memberOf Publisher
   */ /**
   * Returns an object that has the properties that define the current user interface controls of
   * the Subscriber. You can modify the properties of this object and pass the object to the
   * <code>setStyle()</code> method of the Subscriber object. (See the documentation for
   * <a href="#setStyle">setStyle()</a> to see the styles that define this object.)
   * @return {Object} The object that defines the styles of the Subscriber.
   * @see <a href="#setStyle">setStyle()</a>
   * @method #getStyle
   * @memberOf Subscriber
   */ // If +key+ is falsly then all styles will be returned.
                self1.getStyle = function(key) {
                    return _style.get(key);
                };
                /**
   * Sets properties that define the appearance of some user interface controls of the Publisher.
   *
   * <p>You can either pass one parameter or two parameters to this method.</p>
   *
   * <p>If you pass one parameter, <code>style</code>, it is an object that has the following
   * properties:
   *
   *     <ul>
   *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
   *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
   *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
   *       <code>"on"</code> (the indicator is always displayed).</li>
   *
   *       <li><code>archiveStatusDisplayMode</code> (String) &mdash; How to display the archive
   *       status indicator. Possible values are: <code>"auto"</code> (the indicator is displayed
   *       when the session is being recorded), <code>"off"</code> (the indicator is not displayed).
   *       If you disable the archive status display indicator, you can display your own user
   *       interface notifications based on the <code>archiveStarted</code> and
   *       <code>archiveStopped</code> events dispatched by the Session object.</li>
   *
   *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
   *       the background image when a video is not displayed. (A video may not be displayed if
   *       you call <code>publishVideo(false)</code> on the Publisher object). You can pass an http
   *       or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
   *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
   *       PNG data, such as that obtained from the <a href="Publisher.html#getImgData">
   *       Publisher.getImgData()</a> method (for example, you could call
   *       <code>myPublisher.setStyle("backgroundImageURI", myPublisher.getImgData())</code>).
   *       If the URL or the image data is invalid, the property is ignored (the attempt to set
   *       the image fails silently).</li>
   *
   *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the microphone
   *       controls. Possible values are: <code>"auto"</code> (controls are displayed when the
   *       stream is first displayed and when the user mouses over the display), <code>"off"</code>
   *       (controls are not displayed), and <code>"on"</code> (controls are always displayed).</li>
   *
   *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
   *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
   *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
   *       displayed), and <code>"on"</code> (the name is always displayed).</li>
   *   </ul>
   * </p>
   *
   * <p>For example, the following code passes one parameter to the method:</p>
   *
   * <pre>myPublisher.setStyle({nameDisplayMode: "off"});</pre>
   *
   * <p>If you pass two parameters, <code>style</code> and <code>value</code>, they are
   * key-value pair that define one property of the display style. For example, the following
   * code passes two parameter values to the method:</p>
   *
   * <pre>myPublisher.setStyle("nameDisplayMode", "off");</pre>
   *
   * <p>You can set the initial settings when you call the <code>Session.publish()</code>
   * or <code>OT.initPublisher()</code> method. Pass a <code>style</code> property as part of the
   * <code>properties</code> parameter of the method.</p>
   *
   * <p>The OT object dispatches an <code>exception</code> event if you pass in an invalid style
   * to the method. The <code>code</code> property of the ExceptionEvent object is set to 1011.</p>
   *
   * @param {Object} style Either an object containing properties that define the style, or a
   * String defining this single style property to set.
   * @param {String} value The value to set for the <code>style</code> passed in. Pass a value
   * for this parameter only if the value of the <code>style</code> parameter is a String.</p>
   *
   * @see <a href="#getStyle">getStyle()</a>
   * @return {Publisher} The Publisher object
   * @see <a href="#setStyle">setStyle()</a>
   *
   * @see <a href="Session.html#subscribe">Session.publish()</a>
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @method #setStyle
   * @memberOf Publisher
   */ /**
   * Sets properties that define the appearance of some user interface controls of the Subscriber.
   *
   * <p>You can either pass one parameter or two parameters to this method.</p>
   *
   * <p>If you pass one parameter, <code>style</code>, it is an object that has the following
   * properties:
   *
   *     <ul>
   *       <li><code>audioBlockedDisplayMode</code> (String) &mdash; Whether to display
   *       the default audio blocked icon in Subscribers (in browsers where audio
   *       autoplay is blocked). Possible values are: <code>"auto"</code> (the default,
   *       icon is displayed when the audio is disabled) and <code>"off"</code> (the icon
   *       is not displayed). Set this to <code>"off"</code> if you want to display
   *       your own UI element showing that the audio is blocked. In response to an
   *       HTML element dispatching a <code>click</code> event, you can call the
   *       <a href="OT.html#unblockAudio">OT.unblockAudio()</a> method to start audio
   *       playback in this and all other blocked subscribers.</li>
   *
   *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
   *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
   *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
   *       <code>"on"</code> (the indicator is always displayed).</li>
   *
   *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
   *       the background image when a video is not displayed. (A video may not be displayed if
   *       you call <code>subscribeToVideo(false)</code> on the Publisher object). You can pass an
   *       http or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
   *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
   *       PNG data, such as that obtained from the <a href="Subscriber.html#getImgData">
   *       Subscriber.getImgData()</a> method (for example, you could call
   *       <code>mySubscriber.setStyle("backgroundImageURI", mySubscriber.getImgData())</code>).
   *       If the URL or the image data is invalid, the property is ignored (the attempt to set
   *       the image fails silently).</li>
   *
   *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the speaker
   *       controls. Possible values are: <code>"auto"</code> (controls are displayed when the
   *       stream is first displayed and when the user mouses over the display), <code>"off"</code>
   *       (controls are not displayed), and <code>"on"</code> (controls are always displayed).</li>
   *
   *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
   *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
   *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
   *       displayed), and <code>"on"</code> (the name is always displayed).</li>
   *
   *       <li><code>videoDisabledDisplayMode</code> (String) &#151; Whether to display the video
   *       disabled indicator and video disabled warning icons for a Subscriber. These icons
   *       indicate that the video has been disabled (or is in risk of being disabled for
   *       the warning icon) due to poor stream quality. Possible values are: <code>"auto"</code>
   *       (the icons are automatically when the displayed video is disabled or in risk of being
   *       disabled due to poor stream quality), <code>"off"</code> (do not display the icons), and
   *       <code>"on"</code> (display the icons).</li>
   *   </ul>
   * </p>
   *
   * <p>For example, the following code passes one parameter to the method:</p>
   *
   * <pre>mySubscriber.setStyle({nameDisplayMode: "off"});</pre>
   *
   * <p>If you pass two parameters, <code>style</code> and <code>value</code>, they are key-value
   * pair that define one property of the display style. For example, the following code passes
   * two parameter values to the method:</p>
   *
   * <pre>mySubscriber.setStyle("nameDisplayMode", "off");</pre>
   *
   * <p>You can set the initial settings when you call the <code>Session.subscribe()</code> method.
   * Pass a <code>style</code> property as part of the <code>properties</code> parameter of the
   * method.</p>
   *
   * <p>The OT object dispatches an <code>exception</code> event if you pass in an invalid style
   * to the method. The <code>code</code> property of the ExceptionEvent object is set to 1011.</p>
   *
   * @param {Object} style Either an object containing properties that define the style, or a
   * String defining this single style property to set.
   * @param {String} value The value to set for the <code>style</code> passed in. Pass a value
   * for this parameter only if the value of the <code>style</code> parameter is a String.</p>
   *
   * @returns {Subscriber} The Subscriber object.
   *
   * @see <a href="#getStyle">getStyle()</a>
   * @see <a href="#setStyle">setStyle()</a>
   *
   * @see <a href="Session.html#subscribe">Session.subscribe()</a>
   * @method #setStyle
   * @memberOf Subscriber
   */ self1.setStyle = function(keyOrStyleHash, value, silent) {
                    if (_readOnly) {
                        logging.warn("Calling setStyle() has no effect because theshowControls option was set to false");
                        return this;
                    }
                    let styleHash;
                    if (typeof keyOrStyleHash !== 'string') styleHash = keyOrStyleHash;
                    else {
                        styleHash = {};
                        styleHash[keyOrStyleHash] = value;
                    }
                    if (styleHash.backgroundImageURI) styleHash.backgroundImageURI = fixBackgroundImageURI(styleHash.backgroundImageURI);
                    _style.setAll(styleHash, silent);
                    logSetStyleWithPayload(styleHashLogFilter(styleHash));
                    return this;
                };
            };
        /***/ },
        /* 152 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const once = __webpack_require__(51);
            const StaticConfig = __webpack_require__(35)();
            const Analytics = __webpack_require__(26);
            const APIKEY = __webpack_require__(72);
            const EnvironmentLoader = __webpack_require__(146);
            const hasOpenTokSupport = __webpack_require__(52).once;
            const isWebSocketSupported = __webpack_require__(596);
            const OTHelpers = __webpack_require__(8);
            const logging = __webpack_require__(2)('systemRequirements');
            const upgradeHtml = __webpack_require__(597);
            const Modal = __webpack_require__(598);
            const staticConfig = StaticConfig.onlyLocal(); // This will be logged before we even get the correct loggingUrl from
            // config.opentok.com.
            const analytics = new Analytics();
            const logOnce = once(()=>{
                analytics.logEvent({
                    action: 'checkSystemRequirements',
                    variation: 'notHasRequirements',
                    partnerId: APIKEY.value,
                    payload: {
                        userAgent: OTHelpers.env.userAgent
                    }
                });
            });
            const logUserAgentParsingOnce = once(()=>{
                __webpack_require__(599)(); // eslint-disable-line global-require
            });
            let isDialogOpen = false;
            module1.exports = {
                /**
   * Checks if the system supports OpenTok for WebRTC. Note that this method is called
   * automatically when you call <code>OT.initPublisher()</code> or <code>OT.initSession()</code>,
   * and if the system doesn't support OpenTok, the OpenTok.js library displays a message to
   * the user. Call the <code>OT.checkSystemRequirements()</code> method before calling
   * <code>OT.initPublisher()</code> or <code>OT.initSession()</code> if you do not want the
   * library to display that message.
   *
   * @return {Number} Whether the system supports OpenTok for WebRTC (1) or not (0).
   * @see <a href="#upgradeSystemRequirements">OT.upgradeSystemRequirements()</a>
   * @method OT.checkSystemRequirements
   * @memberof OT
   */ check () {
                    logging.debug('OT.checkSystemRequirements()'); // We use Number here to coerce a Boolean to 1 or 0
                    const systemRequirementsMet = Number(isWebSocketSupported && hasOpenTokSupport());
                    logUserAgentParsingOnce();
                    if (!systemRequirementsMet) logOnce();
                    return systemRequirementsMet;
                },
                /**
   * Displays information about system requirements for OpenTok for WebRTC. This
   * information is displayed in an iframe element that fills the browser window.
   * <p>
   * <i>Note:</i> this information is displayed automatically when you call the
   * <code>OT.initSession()</code> or the <code>OT.initPublisher()</code> method
   * if the client does not support OpenTok for WebRTC.
   * </p>
   * @see <a href="#checkSystemRequirements">OT.checkSystemRequirements()</a>
   * @method OT.upgradeSystemRequirements
   * @memberof OT
   */ upgrade (_temp) {
                    let _ref = _temp === void 0 ? {} : _temp, _ref$isSupportedButOl = _ref.isSupportedButOld, isSupportedButOld = _ref$isSupportedButOl === void 0 ? OTHelpers.env.name.toLowerCase() in staticConfig.minimumVersion : _ref$isSupportedButOl, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? navigator.userAgent : _ref$userAgent;
                    // trigger after the OT environment has loaded
                    EnvironmentLoader.onLoad(()=>{
                        if (isDialogOpen) return;
                        const modal = new Modal(upgradeHtml);
                        isDialogOpen = true;
                        modal.on('close', ()=>{
                            isDialogOpen = false;
                        });
                        modal.open();
                        let section;
                        if (userAgent.match(/(iPad|iPhone|iPod|android|webOS)/i)) section = `${isSupportedButOld ? 'supported-' : ''}mobile-browser`;
                        else section = `${isSupportedButOld ? 'upgrade' : 'normal'}-install`;
                        modal.el(`#section-${section}`).style.display = 'block';
                    });
                }
            };
        /***/ },
        /* 153 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
                var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(600));
                const pFinally = __webpack_require__(604);
                let TimeoutError = /*#__PURE__*/ function(_Error) {
                    (0, _inheritsLoose2.default)(TimeoutError, _Error);
                    function TimeoutError(message) {
                        var _this;
                        _this = _Error.call(this, message) || this;
                        _this.name = 'TimeoutError';
                        return _this;
                    }
                    return TimeoutError;
                }(/*#__PURE__*/ (0, _wrapNativeSuper2.default)(Error));
                module1.exports = (promise, ms, fallback)=>new Promise((resolve, reject)=>{
                        if (typeof ms !== 'number' || ms < 0) throw new TypeError('Expected `ms` to be a positive number');
                        const timer = setTimeout(()=>{
                            if (typeof fallback === 'function') {
                                try {
                                    resolve(fallback());
                                } catch (err) {
                                    reject(err);
                                }
                                return;
                            }
                            const message = typeof fallback === 'string' ? fallback : `Promise timed out after ${ms} milliseconds`;
                            const err = fallback instanceof Error ? fallback : new TimeoutError(message);
                            if (typeof promise.cancel === 'function') promise.cancel();
                            reject(err);
                        }, ms);
                        pFinally(promise.then(resolve, reject), ()=>{
                            clearTimeout(timer);
                        });
                    });
                module1.exports.TimeoutError = TimeoutError;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 154 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function createCleanupJobs() {
                const jobs = [];
                return {
                    add (job) {
                        jobs.push(job);
                    },
                    remove (job) {
                        const index = jobs.indexOf(job);
                        if (index >= 0) jobs.splice(index, 1);
                    },
                    releaseAll () {
                        const errors = [];
                        while(jobs.length > 0){
                            const job = jobs.pop();
                            try {
                                job();
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        const count = errors.length;
                        if (count > 0) throw new Error(`Failed to complete ${count} cleanup job${count === 1 ? '' : 's'}: ${errors.map((err)=>`<${err}>`).join(', ')}`);
                    }
                };
            }
            module1.exports = createCleanupJobs;
        /***/ },
        /* 155 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const logging = __webpack_require__(2)('applySdpTransform');
            module1.exports = (transforms, localRemote, offerAnswer, transformOptions, sdp)=>{
                const transform = transforms[localRemote][offerAnswer];
                const type = `${localRemote} ${offerAnswer}`;
                const pubSub = type === 'local offer' || type === 'remote answer' ? 'publisher' : 'subscriber';
                const logPrefix = `sdpTransforms (${pubSub}): ${localRemote} ${offerAnswer}`;
                const createdReceived = localRemote === 'local' ? 'created' : 'received';
                logging.debug(`${logPrefix}: ${createdReceived}:\n${sdp}`);
                const transformedSdps = transform(transformOptions, sdp);
                if (transformedSdps.local === sdp) logging.debug(`${logPrefix}: not modified`);
                else logging.debug(`${logPrefix}: modified to:\n${transformedSdps.local}`);
                return transformedSdps;
            };
        /***/ },
        /* 156 */ /***/ function(module1, exports) {
            function _assertThisInitialized(self1) {
                if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self1;
            }
            module1.exports = _assertThisInitialized;
        /***/ },
        /* 157 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Calculates the video framerate based on current and last frames,
 * and current and last stat timestamp.
 *
 * @typedef {Object} videoFrameStatValues
 * @property {Number} currentStatFrames Frames taken from current stats.
 * @property {Number} currentTimestamp Timestamp taken from current stats.
 * @property {Number} prevStatFrames Frames taken from previous stats.
 * @property {Number} prevTimestamp Timestamp taken from previous stats.
 *
 * @param {Stats} frameStatValues
 * @returns {Number} Video frameRate
 */ const calculateFrameRate = function calculateFrameRate(videoFrameStatValues) {
                if (videoFrameStatValues === void 0) videoFrameStatValues = {};
                if (!videoFrameStatValues) return 0;
                const _videoFrameStatValues = videoFrameStatValues, _videoFrameStatValues2 = _videoFrameStatValues.currentStatFrames, currentStatFrames = _videoFrameStatValues2 === void 0 ? 0 : _videoFrameStatValues2, _videoFrameStatValues3 = _videoFrameStatValues.prevStatFrames, prevStatFrames = _videoFrameStatValues3 === void 0 ? 0 : _videoFrameStatValues3, _videoFrameStatValues4 = _videoFrameStatValues.currentTimestamp, currentTimestamp = _videoFrameStatValues4 === void 0 ? 0 : _videoFrameStatValues4, _videoFrameStatValues5 = _videoFrameStatValues.prevTimestamp, prevTimestamp = _videoFrameStatValues5 === void 0 ? 0 : _videoFrameStatValues5;
                if (currentStatFrames >= prevStatFrames && currentTimestamp > prevTimestamp) {
                    const videoFrameRate = (currentStatFrames - prevStatFrames) / ((currentTimestamp - prevTimestamp) / 1000);
                    return Math.round(videoFrameRate * 100) / 100;
                }
                return 0;
            };
            module1.exports = calculateFrameRate;
        /***/ },
        /* 158 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign */ // TODO - Move this back within the factory once all modules have been
            // converted to DI factories. This will ensure different unit tests are
            // using distinct instances of AudioContext.
            let context;
            module1.exports = function audioContextFactory(deps) {
                if (deps === void 0) deps = {};
                const AudioContext = deps.AudioContext || window.AudioContext || window.webkitAudioContext;
                /*
   * Lazy instantiates an audio context and always return the same instance on following calls
   *
   * @returns {AudioContext}
   */ return function audioContext() {
                    context = context || AudioContext && new AudioContext(); // Safari does not throw, it simply returns null when it cannot create an
                    // audio context...
                    // @todo report this to Apple
                    if (context == null) throw new Error('AudioContext could not be created, hardware limit reached.');
                    return context;
                };
            };
        /***/ },
        /* 159 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _get = _interopRequireDefault(__webpack_require__(59));
            const getDisplayMedia = (0, _get.default)(window, 'navigator.getDisplayMedia', (0, _get.default)(window, 'navigator.mediaDevices.getDisplayMedia'));
            var _default = typeof getDisplayMedia === 'function';
            exports.default = _default;
        /***/ },
        /* 160 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ const clone = __webpack_require__(38);
            module1.exports = function generateSimpleStateMachineFactory() {
                // A Factory method for generating simple state machine classes.
                //
                // @usage
                //    var StateMachine = generateSimpleStateMachine('start', ['start', 'middle', 'end', {
                //      start: ['middle'],
                //      middle: ['end'],
                //      end: ['start']
                //    }]);
                //
                //    var states = new StateMachine();
                //    state.current;            // <-- start
                //    state.set('middle');
                //
                return function generateSimpleStateMachine(initialState, states, transitions) {
                    const validStates = states.slice();
                    const validTransitions = clone(transitions);
                    const isValidState = function isValidState(state) {
                        return validStates.indexOf(state) !== -1;
                    };
                    const isValidTransition = function isValidTransition(fromState, toState) {
                        return validTransitions[fromState] && validTransitions[fromState].indexOf(toState) !== -1;
                    };
                    return function(stateChangeFailed) {
                        let currentState = initialState;
                        let previousState = null;
                        this.current = currentState;
                        function signalChangeFailed(message, newState) {
                            stateChangeFailed({
                                message: message,
                                newState: newState,
                                currentState: currentState,
                                previousState: previousState
                            });
                        } // Validates +newState+. If it's invalid it triggers stateChangeFailed and returns false.
                        function handleInvalidStateChanges(newState) {
                            if (!isValidState(newState)) {
                                signalChangeFailed(`'${newState}' is not a valid state`, newState);
                                return false;
                            }
                            if (!isValidTransition(currentState, newState)) {
                                signalChangeFailed(`'${currentState}' cannot transition to '${newState}'`, newState);
                                return false;
                            }
                            return true;
                        }
                        this.set = function(newState) {
                            if (!handleInvalidStateChanges(newState)) return;
                            previousState = currentState;
                            this.current = newState;
                            currentState = newState;
                        };
                    };
                };
            };
        /***/ },
        /* 161 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, global-require */ const find = __webpack_require__(62);
                module1.exports = function screenSharingFactory(deps) {
                    if (deps === void 0) deps = {};
                    const chromeExtensionHelper = deps.chromeExtensionHelper || __webpack_require__(281)();
                    const electronExtensionHelper = deps.electronExtensionHelper || __webpack_require__(640)();
                    const Errors = deps.Errors || __webpack_require__(6);
                    const firefoxExtensionHelper = deps.firefoxExtensionHelper || __webpack_require__(642);
                    const getDisplayMediaExtensionHelper = deps.getDisplayMediaExtensionHelper || __webpack_require__(288);
                    const otError = deps.otError || __webpack_require__(13)();
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const screenSharing = {};
                    screenSharing.extensionByKind = {};
                    screenSharing.extensionClasses = {};
                    screenSharing.registerExtensionHelper = (kind, helper)=>{
                        screenSharing.extensionClasses[kind] = helper;
                        if (helper.autoRegisters && helper.isSupportedInThisBrowser) screenSharing.registerExtension(kind);
                    };
                    /**
   * Register an extension for screen-sharing support in an older version of Chrome or Opera.
   * <p>
   * <b>Note:</b> A screen-sharing extension is not required in Chrome 72+ or Opera 59+.
   * The end user is prompted to grant access to the screen, just as they would be when granting
   * access to a camera. You only need a screen-sharing extension for older versions
   * of Opera and Chrome.
   * <p>
   * Use the <code>OT.checkScreenSharingCapability()</code> method to check if an extension is
   * required, registered, and installed.
   * <p>
   * The OpenTok
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a>
   * repo includes code for creating an extension for screen-sharing support.
   *
   * @param {String} kind Set this parameter to <code>"chrome"</code>. Currently, you can only
   * register a screen-sharing extension for older versions of Chrome and Opera.
   *
   * @param {String} id The ID for your screen-sharing extension. You can find this ID at
   * chrome://extensions.
   *
   * @param {Number} version The version of the screen-sharing extension from the
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a> repo.
   * Set this if you are using version 2 or later. For example, if you are using version 2, set this
   * to 2. With version 2, the client can use the extension immediately after installing it, without
   * reloading the page.
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @see <a href="OT.html#checkScreenSharingCapability">OT.checkScreenSharingCapability()</a>
   * @method OT.registerScreenSharingExtension
   * @memberof OT
   */ screenSharing.registerExtension = function(kind) {
                        if (screenSharing.extensionClasses[kind] == null) throw new Error('Unsupported kind passed to OT.registerScreenSharingExtension');
                        for(var _len = arguments.length, initArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)initArgs[_key - 1] = arguments[_key];
                        const x = screenSharing.extensionClasses[kind].register(...initArgs);
                        screenSharing.extensionByKind[kind] = x;
                    };
                    const screenSharingPickHelper = ()=>{
                        const foundClass = find(Object.keys(screenSharing.extensionClasses).sort(// is exposed in electron, developers must use the electron's
                        // `desktopCapturer` instead.
                        (cls)=>cls === 'electron' ? -1 : 1), (cls)=>screenSharing.extensionClasses[cls].isSupportedInThisBrowser);
                        if (foundClass === undefined) return {};
                        return {
                            name: foundClass,
                            proto: screenSharing.extensionClasses[foundClass],
                            instance: screenSharing.extensionByKind[foundClass]
                        };
                    };
                    screenSharing.pickHelper = ()=>screenSharingPickHelper();
                    /**
   * Checks for support for publishing screen-sharing streams on the client browser. The object
   * passed to the callback function defines whether screen sharing is supported, as well as
   * which screen-sharing sources (application, screen, or window) are supported. It also indicates
   * whether an extension is required, installed, and registered (if needed).
   * <p>
   * <pre>
   * OT.checkScreenSharingCapability(function(response) {
   *   if (!response.supported || response.extensionRegistered === false) {
   *     // This browser does not support screen sharing
   *   } else if (response.extensionInstalled === false) {
   *     // Prompt to install the extension
   *   } else {
   *     // Screen sharing is available.
   *   }
   * });
   * </pre>
   * <p>
   * Chrome 72+, Firefox 52+, Safari 13+, Edge 79+, and Opera 59+ have screen-sharing
   * support built-in, with no extension required. (Note that support for the OpenTok
   * plugin for Internet Explorer is removed in OpenTok 2.17.) Screen sharing is
   * <i>not</i> supported in mobile browsers. In Electron, screen sharing is supported if
   * the <code>webPreferences.contextIsolation</code> option of the Electron BrowserWindow is
   * set to <code>false</code> or if the app uses a preload script to access the desktop capturer.
   * (The default value of <code>webPreferences.contextIsolation</code> option is <code>true</code>
   * in Electron 12 and <code>false</code> in previous versions). To publish a screen-sharing video
   * in older versions of Chrome or Opera, the client adds an extension that enables publishing a
   * screen-sharing video stream on your domain. The OpenTok
   * <a href="https://github.com/opentok/screensharing-extensions">screensharing-extensions</a>
   * sample includes code for creating an extension for screen-sharing support in
   * older versions of Chrome and Opera.
   * <p>
   * For more information, see the <a href="https://tokbox.com/developer/guides/screen-sharing/js/">
   * OpenTok Screen Sharing</a> developer guide.
   *
   * @param {function} callback The callback invoked with the support options object passed as
   * the parameter. This object has the following properties that indicate support for publishing
   * screen-sharing streams in the client:
   * <p>
   * <ul>
   *   <li>
   *     <code>extensionInstalled</code> (Boolean) &mdash;  In older versions of Chrome and Opera,
   *     this is set to <code>true</code> if the extension is installed and registered.
   *     In Chrome 72+, Firefox 52+, Safari 13+, Opera 59+, Edge 79+, and Internet Explorer,
   *     this property is undefined.
   *   </li>
   *   <li>
   *     <code>supported</code> (Boolean) &mdash; Set to <code>true</code> if screen sharing
   *     is supported in the browser. Check the <code>extensionRequired</code> property
   *     to see if the browser requires an extension for screen sharing.
   *   </li>
   *   <li>
   *     <code>supportedSources</code> (Object) &mdash; Deprecated. In older
   *     browser versions, you could select a type of screen-sharing source
   *     (such as <code>"application"</code>, <code>"browser"</code>, <code>"screen"</code>,
   *     or <code>"window"</code> by setting the <code>videoSource</code> property
   *     of the options passed into the <code>OT.initPublisher()</code> method.
   *     However, in current browsers that support screen sharing, passing in
   *     any of these values results in the same behavior &mdash; the browser
   *     displays a dialog box in which the end user selects the screen-sharing
   *     source (which can be the entire screen or a specific window). In Electron,
   *     screen sharing captures the entire screen, without prompting the user for permission.
   *   </li>
   * </ul>
   * <p> The options parameter also includes the following properties, which apply to screen-sharing
   * support in older versions of Chrome and Opera (in all other browsers these properties are
   * undefined):
   * <ul>
   *   <li>
   *     <code>extensionRequired</code> (String) &mdash; Set to <code>"chrome"</code>
   *     in older versions of Chrome and Opera, which require a screen-sharing extension
   *     to be installed. This property is undefined in other browsers.
   *   </li>
   *   <li>
   *     <code>extensionRegistered</code> (Boolean) &mdash; In older versions of Chrome and Opera,
   *     this property is set to <code>true</code> if a screen-sharing extension is registered;
   *     otherwise it is set to <code>false</code>. In other browsers (which do not require
   *     an extension), this property is undefined. Use the
   *     <code>OT.registerScreenSharingExtension()</code> method to register a screen-sharing
   *     extension in older versions of Chrome or Opera.
   *   </li>
   * </ul>
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
   * @see <a href="OT.html#registerScreenSharingExtension">OT.registerScreenSharingExtension()</a>
   * @method OT.checkScreenSharingCapability
   * @memberof OT
   */ screenSharing.checkCapability = (callback)=>{
                        const response = {
                            supported: false,
                            extensionRequired: undefined,
                            extensionRegistered: undefined,
                            extensionInstalled: undefined,
                            supportedSources: {}
                        }; // find a supported browser
                        const helper = screenSharingPickHelper();
                        if (helper.name === undefined) {
                            setTimeout(callback.bind(null, response));
                            return;
                        }
                        response.supported = true;
                        response.extensionRequired = helper.proto.extensionRequired ? helper.name : undefined;
                        response.supportedSources = {
                            screen: helper.proto.sources.screen,
                            application: helper.proto.sources.application,
                            window: helper.proto.sources.window,
                            browser: helper.proto.sources.browser
                        };
                        if (!helper.instance) {
                            response.extensionRegistered = false;
                            if (response.extensionRequired) response.extensionInstalled = false;
                            setTimeout(callback.bind(null, response));
                            return;
                        }
                        response.extensionRegistered = response.extensionRequired ? true : undefined;
                        helper.instance.isInstalled((installed)=>{
                            response.extensionInstalled = response.extensionRequired || OTHelpers.env.name === 'Firefox' ? installed : undefined;
                            callback(response);
                        });
                    };
                    screenSharing.registerExtensionHelper('electron', electronExtensionHelper);
                    screenSharing.registerExtensionHelper('getDisplayMedia', getDisplayMediaExtensionHelper);
                    screenSharing.registerExtensionHelper('chrome', chromeExtensionHelper);
                    screenSharing.registerExtensionHelper('firefox', firefoxExtensionHelper);
                    const noop = ()=>{};
                    screenSharing.getConstraints = (opt)=>{
                        const _opt$onAccessDialogOp = opt.onAccessDialogOpened, onAccessDialogOpened = _opt$onAccessDialogOp === void 0 ? noop : _opt$onAccessDialogOp, _opt$onAccessDialogCl = opt.onAccessDialogClosed, onAccessDialogClosed = _opt$onAccessDialogCl === void 0 ? noop : _opt$onAccessDialogCl, videoSource = opt.videoSource, constraints = opt.constraints;
                        return new Promise((resolve, reject)=>{
                            screenSharing.checkCapability((response)=>{
                                if (!response.supported) {
                                    let errorMessage = 'Screen Sharing is not supported in this browser';
                                    if (OTHelpers.env.isElectron) errorMessage = "Set the webPreferences.contextIsolation option of the Electron BrowserWindow to false or use a preload script to access the desktop capturer. For more information, see https://tokbox.com/developer/guides/screen-sharing/js/.";
                                    else if (OTHelpers.env.name === 'Chrome' && OTHelpers.env.version > 73 && window.location.protocol !== 'https:') errorMessage = 'https:// is required for screen sharing';
                                    reject(otError(Errors.SCREEN_SHARING_NOT_SUPPORTED, new Error(errorMessage)));
                                } else if (response.extensionRegistered === false) reject(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, new Error("Screen Sharing support in this browser requires an extension, but one has not been registered.")));
                                else if (response.extensionRequired && response.extensionInstalled === false) reject(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error("Screen Sharing support in this browser requires an extension, but the extension is not installed.")));
                                else {
                                    const helper = screenSharing.pickHelper();
                                    if (helper.proto.getConstraintsShowsPermissionUI) onAccessDialogOpened();
                                    helper.instance.getConstraints(videoSource, constraints, (err, helperConstraints)=>{
                                        if (helper.proto.getConstraintsShowsPermissionUI) onAccessDialogClosed();
                                        if (err) reject(err);
                                        else resolve(helperConstraints);
                                    });
                                }
                            });
                        });
                    };
                    return screenSharing;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 162 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable global-require */ module1.exports = function interpretPeerConnectionErrorFactory(deps) {
                if (deps === void 0) deps = {};
                const Errors = deps.Errors || __webpack_require__(6);
                const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                const otError = deps.otError || __webpack_require__(13)();
                const errorPrefixMap = {
                    ICEWorkflow: Errors.ICE_WORKFLOW_FAILED,
                    NewPeerConnection: Errors.CREATE_PEER_CONNECTION_FAILED,
                    SetRemoteDescription: Errors.SET_REMOTE_DESCRIPTION_FAILED,
                    Subscribe: {
                        404: Errors.STREAM_NOT_FOUND,
                        [ExceptionCodes.STREAM_LIMIT_EXCEEDED]: Errors.STREAM_LIMIT_EXCEEDED
                    }
                };
                return function interpretPeerConnectionError(httpCode, reason, prefix, remoteConnectionId, className) {
                    const message = `${(prefix ? `${prefix}: ` : '') + className} PeerConnection with connection ${remoteConnectionId} failed: ${reason}`;
                    const nameOrCodeMap = errorPrefixMap[prefix] || {};
                    const name = typeof nameOrCodeMap === 'string' ? nameOrCodeMap : nameOrCodeMap[httpCode];
                    const defaultCode = className === 'Publisher' ? ExceptionCodes.UNABLE_TO_PUBLISH : ExceptionCodes.UNABLE_TO_SUBSCRIBE;
                    if (!name) {
                        const error = new Error(message);
                        error.code = defaultCode;
                        return error;
                    }
                    const code = (()=>{
                        if (prefix === 'ICEWorkflow') return className === 'Publisher' ? ExceptionCodes.PUBLISHER_ICE_WORKFLOW_FAILED : ExceptionCodes.SUBSCRIBER_ICE_WORKFLOW_FAILED;
                        if (name === Errors.STREAM_LIMIT_EXCEEDED) return ExceptionCodes.STREAM_LIMIT_EXCEEDED;
                        return defaultCode;
                    })();
                    return otError(name, new Error(message), code);
                };
            };
        /***/ },
        /* 163 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable global-require, no-param-reassign */ module1.exports = function setCertificatesFactory(deps) {
                if (deps === void 0) deps = {};
                const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                const windowMock = deps.global || window;
                const RTCPeerConnection = windowMock.RTCPeerConnection;
                return function setCertificates(pcConfig, completion) {
                    if (OTHelpers.env.name === 'Firefox' && RTCPeerConnection && RTCPeerConnection.generateCertificate) RTCPeerConnection.generateCertificate({
                        name: 'RSASSA-PKCS1-v1_5',
                        hash: 'SHA-256',
                        modulusLength: 2048,
                        publicExponent: new Uint8Array([
                            1,
                            0,
                            1
                        ])
                    }).catch((err)=>{
                        completion(err);
                    }).then((cert)=>{
                        pcConfig.certificates = [
                            cert
                        ];
                        completion(undefined, pcConfig);
                    });
                    else setTimeout(()=>{
                        completion(undefined, pcConfig);
                    });
                };
            };
        /***/ },
        /* 164 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            /* eslint-disable no-underscore-dangle */ const eventing = __webpack_require__(7);
            const hasPassiveCapability = __webpack_require__(659);
            const defaultLogging = __webpack_require__(2)('WidgetView');
            const DefaultOTHelpers = __webpack_require__(8);
            const defaultEnv = __webpack_require__(3);
            const _require = __webpack_require__(165), Cancellation = _require.default, CancellationError = _require.CancellationError;
            const unblockAudio = __webpack_require__(166);
            const waitForVideoResolution = __webpack_require__(661);
            const defaultWaitForVideoToBePlaying = __webpack_require__(662);
            const fixMini = __webpack_require__(663);
            const getOrCreateContainer = __webpack_require__(664);
            const ensureCSSUnit = __webpack_require__(665);
            const eventHelper = __webpack_require__(63);
            const DefaultVideoElementFacadeFactory = __webpack_require__(107); // eslint-disable-next-line no-unused-vars
            const typeVideoElementFacade = DefaultVideoElementFacadeFactory();
            /**
 * WidgetViewFactory - DI factory for WidgetView
 *
 * @package
 * @param {Object} deps
 * @param {DefaultVideoElementFacadeFactory} deps.VideoElementFacade
 * @return WidgetView
 */ function WidgetViewFactory(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$logging = _ref.logging, logging = _ref$logging === void 0 ? defaultLogging : _ref$logging, _ref$OTHelpers = _ref.OTHelpers, OTHelpers = _ref$OTHelpers === void 0 ? DefaultOTHelpers : _ref$OTHelpers, _ref$waitForVideoToBe = _ref.waitForVideoToBePlaying, waitForVideoToBePlaying = _ref$waitForVideoToBe === void 0 ? defaultWaitForVideoToBePlaying : _ref$waitForVideoToBe, _ref$VideoElementFaca = _ref.VideoElementFacade, VideoElementFacade = _ref$VideoElementFaca === void 0 ? DefaultVideoElementFacadeFactory() : _ref$VideoElementFaca, _ref$env = _ref.env, env = _ref$env === void 0 ? defaultEnv : _ref$env;
                // We pass in the real window rather than a mock because hasPassiveCapability
                // needs to attach/remove real event listeners on the window which won't work
                // using the mock window.
                const supportsPassive = hasPassiveCapability({
                    window: window
                });
                const throwIfBindCancelled = (cancellation)=>{
                    if (cancellation.isCanceled()) {
                        logging.debug('bindVideo bailing due to cancellation');
                        throw new CancellationError('CANCEL');
                    }
                };
                /**
   * WidgetView - A standard abstraction used by Subscriber and Publisher for
   * displaying the video and it's UI.
   *
   * @package
   * @class
   * @param {Element} targetElement the element to attach this WidgetView to
   * @param {Object} properties
   */ let WidgetView = /*#__PURE__*/ function() {
                    /** @type {typeVideoElementFacade} */ /** @type {HTMLElement} */ function WidgetView(/** @type {HTMLElement} */ targetElement, _temp2) {
                        let _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$insertDefaultUI = _ref2.insertDefaultUI, insertDefaultUI = _ref2$insertDefaultUI === void 0 ? true : _ref2$insertDefaultUI, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? 264 : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? 198 : _ref2$height, _ref2$fitMode = _ref2.fitMode, fitMode = _ref2$fitMode === void 0 ? 'cover' : _ref2$fitMode, _ref2$mirror = _ref2.mirror, mirror = _ref2$mirror === void 0 ? false : _ref2$mirror, insertMode = _ref2.insertMode, classNames = _ref2.classNames, style = _ref2.style, widgetType = _ref2.widgetType;
                        (0, _defineProperty2.default)(this, "_videoElementFacade", void 0);
                        (0, _defineProperty2.default)(this, "_container", undefined);
                        (0, _defineProperty2.default)(this, "_posterContainer", document.createElement('div'));
                        (0, _defineProperty2.default)(this, "_widgetContainer", document.createElement('div'));
                        (0, _defineProperty2.default)(this, "_loading", true);
                        (0, _defineProperty2.default)(this, "_audioOnly", false);
                        (0, _defineProperty2.default)(this, "_showPoster", undefined);
                        (0, _defineProperty2.default)(this, "_poster", undefined);
                        (0, _defineProperty2.default)(this, "_cancelBind", undefined);
                        (0, _defineProperty2.default)(this, "MAX_VIDEO_LOADED", 5000);
                        eventing(this);
                        if (/^(contain|cover)$/.test(fitMode) === false) logging.warn(`Invalid fit value "${fitMode}" passed. Only "contain" and "cover" can be used.`);
                        this._widgetType = widgetType;
                        this._fitMode = fitMode;
                        this._insertDefaultUI = insertDefaultUI;
                        const userInteractionEventHandlers = eventHelper(this._widgetContainer);
                        userInteractionEventHandlers.on('click', this.userGesture.bind(this));
                        userInteractionEventHandlers.on('touchstart', this.userGesture.bind(this), supportsPassive ? {
                            passive: true
                        } : false);
                        this.once('destroy', ()=>userInteractionEventHandlers.removeAll());
                        this._widgetContainer.classList.add('OT_widget-container');
                        this._widgetContainer.style.width = '100%'; // container.style.width;
                        this._widgetContainer.style.height = '100%'; // container.style.height;
                        if (insertDefaultUI !== false) {
                            this._container = getOrCreateContainer(targetElement, insertMode);
                            if (env.isSafari && env.isiOS && env.iOSVersion && env.iOSVersion < 11.2) this._container.classList.add('OT_ForceContain');
                            this._container.style.width = ensureCSSUnit(width);
                            this._container.style.height = ensureCSSUnit(height);
                            this._container.style.overflow = 'hidden';
                            fixMini(this._container);
                            if (mirror) OTHelpers.addClass(this._container, 'OT_mirrored');
                            if (classNames) // @todo Refactor to avoid passing classNames to widgetView
                            classNames.trim().split(/\s+/).forEach((className)=>this._container.classList.add(className));
                            this._container.classList.add('OT_loading');
                            this._container.classList.add(`OT_fit-mode-${fitMode}`);
                            this._container.appendChild(this._widgetContainer); // Observe changes to the width and height and update the aspect ratio
                            const _OTHelpers$observeSiz = OTHelpers(this._container).observeSize(()=>fixMini(this._container)), sizeObserver = _OTHelpers$observeSiz[0]; // @todo observe if the video container or the video element get removed
                            // if they do we should do some cleanup
                            const videoObserver = OTHelpers.observeNodeOrChildNodeRemoval(this._container, (removedNodes)=>{
                                if (!this._videoElementFacade) return;
                                 // check if our widget container / video element was removed
                                const videoRemoved = removedNodes.some((node)=>node === this._widgetContainer || node === this._videoElementFacade.domElement());
                                if (videoRemoved) this.destroyVideo();
                            });
                            this.once('destroy', ()=>{
                                logging.debug('disconnecting observers');
                                sizeObserver.disconnect();
                                videoObserver.disconnect();
                            });
                        }
                        this._posterContainer.classList.add('OT_video-poster');
                        this._widgetContainer.appendChild(this._posterContainer);
                        const loadingContainer = document.createElement('div');
                        loadingContainer.classList.add('OT_video-loading');
                        const loadingSpinner = document.createElement('div');
                        loadingSpinner.classList.add('OT_video-loading-spinner');
                        loadingContainer.appendChild(loadingSpinner);
                        this._widgetContainer.appendChild(loadingContainer);
                        if (style && style.backgroundImageURI) this.setBackgroundImageURI(style.backgroundImageURI);
                    }
                    var _proto = WidgetView.prototype;
                    _proto.addError = function addError(errorMsg, helpMsg, classNames) {
                        if (this._container) {
                            this._container.innerHTML = `<p>${errorMsg}${helpMsg ? ` <span class="ot-help-message">${helpMsg}</span>` : ''}</p>`;
                            OTHelpers.addClass(this._container, classNames || 'OT_subscriber_error');
                            if (this._container.querySelector('p').offsetHeight > this._container.offsetHeight) this._container.querySelector('span').style.display = 'none';
                        }
                    };
                    _proto.destroy = function destroy() {
                        this.emit('destroy');
                        this.destroyVideo();
                        if (this._container) {
                            OTHelpers.removeElement(this._container);
                            this._container = null;
                        }
                    };
                    _proto.setBackgroundImageURI = function setBackgroundImageURI(bgImgURI) {
                        OTHelpers.css(this._posterContainer, 'backgroundImage', `url(${bgImgURI})`);
                        OTHelpers.css(this._posterContainer, 'backgroundSize', 'contain');
                        OTHelpers.css(this._posterContainer, 'opacity', '1.0');
                    };
                    _proto.isAudioBlocked = function isAudioBlocked() {
                        return Boolean(this._videoElementFacade && this._videoElementFacade.isAudioBlocked());
                    };
                    _proto.unblockAudio = function unblockAudio() {
                        return this._videoElementFacade.unblockAudio();
                    };
                    _proto.userGesture = function userGesture() {
                        if (this.isAudioBlocked()) unblockAudio().then(()=>logging.debug('Successfully unblocked audio'), (err)=>logging.error('Error retrying audio on user interaction:', err));
                    };
                    _proto.setAudioBlockedUi = function setAudioBlockedUi(audioBlocked) {
                        if (!this._container) return;
                        if (audioBlocked) this._container.classList.add('OT_container-audio-blocked');
                        else this._container.classList.remove('OT_container-audio-blocked');
                    };
                    _proto.rebindSrcObject = function rebindSrcObject() {
                        if (this._videoElementFacade) this._videoElementFacade._rebindSrcObject();
                    };
                    _proto.pauseAndPlayVideoElement = function pauseAndPlayVideoElement() {
                        if (this._videoElementFacade) this._videoElementFacade._pauseAndPlay();
                    };
                    // BufferVideoElement will act as pre-buffer to asure that we can play actual video/audio
                    // before the bind. For that we create a plain videoElement, add the stream, play it and
                    // wait to get the media flowing. We return the videoElement so it can be clean up once used.
                    // In case of failure we return null.
                    _proto._createBufferVideoElement = /*#__PURE__*/ function() {
                        var _createBufferVideoElement2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(stream, deps) {
                            var documentHelper, isVideoLoaded, videoElement;
                            return _regenerator.default.wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        if (deps === void 0) deps = {};
                                        documentHelper = deps.createElement ? deps : document;
                                        isVideoLoaded = false;
                                        videoElement = documentHelper.createElement('video');
                                        videoElement.srcObject = stream;
                                        _context.prev = 5;
                                        videoElement.play(); // Wait for the video to be loaded and playing for MAX_VIDEO_LOADED secs.
                                        _context.next = 9;
                                        return waitForVideoToBePlaying(videoElement, this.MAX_VIDEO_LOADED);
                                    case 9:
                                        isVideoLoaded = _context.sent;
                                        return _context.abrupt("return", isVideoLoaded ? videoElement : null);
                                    case 13:
                                        _context.prev = 13;
                                        _context.t0 = _context["catch"](5);
                                        return _context.abrupt("return", null);
                                    case 16:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, this, [
                                [
                                    5,
                                    13
                                ]
                            ]);
                        }));
                        function _createBufferVideoElement(_x, _x2) {
                            return _createBufferVideoElement2.apply(this, arguments);
                        }
                        return _createBufferVideoElement;
                    }();
                    _proto._emitAMREvent = function _emitAMREvent(action, variation, options) {
                        this.emit('amrLogEvent', action, variation, options);
                    };
                    _proto._createVideoElementFacade = function _createVideoElementFacade(_ref3) {
                        let _inject = _ref3._inject, audioVolume = _ref3.audioVolume, fallbackText = _ref3.fallbackText, muted = _ref3.muted;
                        this._videoElementFacade = new VideoElementFacade({
                            defaultAudioVolume: parseFloat(audioVolume),
                            fallbackText: fallbackText,
                            fitMode: this._fitMode,
                            _inject: _inject,
                            muted: muted,
                            widgetType: this._widgetType
                        });
                        const videoFacadeEvents = eventHelper(this._videoElementFacade);
                        this._videoFacadeEvents = videoFacadeEvents;
                        videoFacadeEvents.on('error', ()=>{
                            this.trigger('error');
                        });
                        videoFacadeEvents.on('videoDimensionsChanged', (oldValue, newValue)=>{
                            this.trigger('videoDimensionsChanged', oldValue, newValue);
                        });
                        videoFacadeEvents.on('mediaStopped', (track)=>{
                            this.trigger('mediaStopped', track);
                        });
                        videoFacadeEvents.on('audioBlocked', ()=>this.trigger('audioBlocked'));
                        videoFacadeEvents.on('audioUnblocked', ()=>this.trigger('audioUnblocked')); // makes the incoming audio streams take priority (will impact only FF OS for now)
                        this._videoElementFacade.audioChannelType('telephony');
                        logging.debug('Appending the video facade');
                        this._videoElementFacade.appendTo(this._widgetContainer); // Initialize the audio volume
                        if (typeof audioVolume !== 'undefined') try {
                            this._videoElementFacade.setAudioVolume(audioVolume);
                        } catch (e) {
                            logging.warn(`bindVideo ${e}`);
                        }
                    };
                    _proto._bindToStream = /*#__PURE__*/ function() {
                        var _bindToStream2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(webRTCStream, cancellation) {
                            return _regenerator.default.wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.prev = 0;
                                        _context2.next = 3;
                                        return this._videoElementFacade.bindToStream(webRTCStream);
                                    case 3:
                                        _context2.next = 14;
                                        break;
                                    case 5:
                                        _context2.prev = 5;
                                        _context2.t0 = _context2["catch"](0);
                                        if (!cancellation.isCanceled()) {
                                            _context2.next = 12;
                                            break;
                                        }
                                        logging.debug('Refusing to destroyVideo as bindVideo was cancelled');
                                        throw new CancellationError('CANCEL');
                                    case 12:
                                        this.destroyVideo();
                                        throw _context2.t0;
                                    case 14:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2, this, [
                                [
                                    0,
                                    5
                                ]
                            ]);
                        }));
                        function _bindToStream(_x3, _x4) {
                            return _bindToStream2.apply(this, arguments);
                        }
                        return _bindToStream;
                    }();
                    _proto._getNewBindCancellation = function _getNewBindCancellation() {
                        if (this._cancelBind) {
                            logging.debug('Cancelling last bindVideo request');
                            this._cancelBind.cancel();
                        }
                        const cancellation = new Cancellation();
                        this._cancelBind = cancellation;
                        this.once('destroy', ()=>cancellation.cancel());
                        return cancellation;
                    };
                    _proto._triggerVideoElementCreated = function _triggerVideoElementCreated() {
                        const triggerVideoElementCreated = (element)=>{
                            this.trigger('videoElementCreated', element);
                            if (this._insertDefaultUI) OTHelpers.addClass(element, 'OT_video-element');
                        };
                        if (this._videoElementFacade.domElement()) triggerVideoElementCreated(this._videoElementFacade.domElement());
                        else this._videoFacadeEvents.on('videoElementCreated', (element)=>{
                            triggerVideoElementCreated(element);
                        });
                    };
                    _proto._waitForVideoResolution = /*#__PURE__*/ function() {
                        var _waitForVideoResolution2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(webRTCStream) {
                            var subscribingToAudioOnlyStream;
                            return _regenerator.default.wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        subscribingToAudioOnlyStream = this.audioOnly() && this._widgetType === 'subscriber';
                                        if (!(!subscribingToAudioOnlyStream && webRTCStream.getVideoTracks().length > 0)) {
                                            _context3.next = 6;
                                            break;
                                        }
                                        logging.debug('Waiting for correct resolution');
                                        _context3.next = 5;
                                        return waitForVideoResolution(this._videoElementFacade, 5000);
                                    case 5:
                                        logging.debug(`Resolution: ${this._videoElementFacade.videoWidth()}x${this._videoElementFacade.videoHeight()}`);
                                    case 6:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3, this);
                        }));
                        function _waitForVideoResolution(_x5) {
                            return _waitForVideoResolution2.apply(this, arguments);
                        }
                        return _waitForVideoResolution;
                    }();
                    _proto.bindVideo = /*#__PURE__*/ function() {
                        var _bindVideo = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(webRTCStream, _ref4, throwIfBufferFails) {
                            var audioVolume, muted, fallbackText, _inject, hasExistingElement, bufferVideoElement, cancellation, whenVideoPlaying;
                            return _regenerator.default.wrap(function _callee4$(_context4) {
                                while(true)switch(_context4.prev = _context4.next){
                                    case 0:
                                        audioVolume = _ref4.audioVolume, muted = _ref4.muted, fallbackText = _ref4.fallbackText, _inject = _ref4._inject;
                                        if (throwIfBufferFails === void 0) throwIfBufferFails = false;
                                        logging.debug('bindVideo ', {
                                            webRTCStream: webRTCStream
                                        });
                                        hasExistingElement = !!this._videoElementFacade;
                                        cancellation = this._getNewBindCancellation();
                                        if (hasExistingElement) {
                                            _context4.next = 9;
                                            break;
                                        }
                                        this._createVideoElementFacade({
                                            _inject: _inject,
                                            audioVolume: audioVolume,
                                            fallbackText: fallbackText,
                                            muted: muted
                                        });
                                        _context4.next = 22;
                                        break;
                                    case 9:
                                        if (!(webRTCStream instanceof MediaStream)) {
                                            _context4.next = 22;
                                            break;
                                        }
                                        // eslint-disable-line no-undef
                                        // Temporary logging to monitor the blink: OPENTOK-46931
                                        // All the logging is done at Subscriber level, we just emit actions
                                        // to be potentially logged
                                        this._emitAMREvent('AMRLoadVideoBuffer', 'Attempt'); // For transitions, before binding we use the bufferVideoElement to make sure video
                                        // from webRTCStream is loaded and playing.
                                        _context4.next = 13;
                                        return this._createBufferVideoElement(webRTCStream);
                                    case 13:
                                        bufferVideoElement = _context4.sent;
                                        if (bufferVideoElement) {
                                            _context4.next = 20;
                                            break;
                                        }
                                        this._emitAMREvent('AMRLoadVideoBuffer', 'Failure');
                                        if (!throwIfBufferFails) {
                                            _context4.next = 18;
                                            break;
                                        }
                                        throw new Error('bufferFailed: videoBuffer failed to load or timeout');
                                    case 18:
                                        _context4.next = 21;
                                        break;
                                    case 20:
                                        this._emitAMREvent('AMRLoadVideoBuffer', 'Success');
                                    case 21:
                                        // We now want to log binding duration to monitor the blink: OPENTOK-46931
                                        // We propagate the event from videoFacade level to Subscriber
                                        this._videoFacadeEvents.on('amrLogEvent', (action, variation, options)=>{
                                            this._emitAMREvent(action, variation, options);
                                        });
                                    case 22:
                                        _context4.next = 24;
                                        return this._bindToStream(webRTCStream, cancellation);
                                    case 24:
                                        if (!hasExistingElement) this._triggerVideoElementCreated();
                                        throwIfBindCancelled(cancellation);
                                        whenVideoPlaying = waitForVideoToBePlaying(this._videoElementFacade, 5000);
                                        _context4.next = 29;
                                        return this._waitForVideoResolution(webRTCStream);
                                    case 29:
                                        logging.debug('Waiting for video to be playing');
                                        _context4.next = 32;
                                        return whenVideoPlaying;
                                    case 32:
                                        logging.debug('Video is playing');
                                        throwIfBindCancelled(cancellation);
                                        if (bufferVideoElement) {
                                            // We do not need the helper anymore, so we clean it up.
                                            if (bufferVideoElement.remove) bufferVideoElement.remove();
                                            bufferVideoElement = null;
                                        }
                                    case 35:
                                    case "end":
                                        return _context4.stop();
                                }
                            }, _callee4, this);
                        }));
                        function bindVideo(_x6, _x7, _x8) {
                            return _bindVideo.apply(this, arguments);
                        }
                        return bindVideo;
                    }();
                    _proto.bindAudioTrackOnly = function bindAudioTrackOnly() {
                        if (this._videoElementFacade) this._videoElementFacade.bindAudioTrackOnly();
                    };
                    _proto.destroyVideo = function destroyVideo() {
                        if (this._videoElementFacade) {
                            this._videoElementFacade.destroy();
                            this._videoElementFacade = null;
                        }
                    };
                    _proto.video = function video() {
                        return this._videoElementFacade;
                    };
                    _proto.showPoster = function showPoster(_showPoster) {
                        if (_showPoster === undefined) return !OTHelpers.isDisplayNone(this._posterContainer);
                        this._showPoster = _showPoster;
                        OTHelpers[_showPoster ? 'show' : 'hide'](this._posterContainer);
                        return this.showPoster();
                    };
                    _proto.poster = function poster(src) {
                        if (src === undefined) return OTHelpers.css(this._posterContainer, 'backgroundImage');
                        this._poster = src;
                        OTHelpers.css(this._posterContainer, 'backgroundImage', `url(${src})`);
                        return this.poster();
                    };
                    _proto.loading = function loading(isLoading) {
                        if (isLoading === undefined) return this._loading;
                        this._loading = Boolean(isLoading);
                        if (this._container) this._container.classList[isLoading ? 'add' : 'remove']('OT_loading');
                        return this.loading();
                    };
                    _proto.audioOnly = function audioOnly(isAudioOnly) {
                        if (isAudioOnly === undefined) return this._audioOnly;
                        this._audioOnly = isAudioOnly;
                        if (this._container) this._container.classList[isAudioOnly ? 'add' : 'remove']('OT_audio-only');
                        return this.audioOnly();
                    };
                    _proto.domId = function domId() {
                        return this._container && this._container.getAttribute('id');
                    };
                    _proto.setSinkId = function setSinkId(deviceId) {
                        if (this._videoElementFacade) return this._videoElementFacade.setSinkId(deviceId);
                        return undefined;
                    };
                    (0, _createClass2.default)(WidgetView, [
                        {
                            key: "domElement",
                            get: function get() {
                                return this._container;
                            }
                        },
                        {
                            key: "videoElement",
                            get: function get() {
                                return this._videoElementFacade && this._videoElementFacade.domElement() || undefined;
                            }
                        },
                        {
                            key: "width",
                            get: function get() {
                                return this.videoElement && this.videoElement.offsetWidth;
                            }
                        },
                        {
                            key: "height",
                            get: function get() {
                                return this.videoElement && this.videoElement.offsetHeight;
                            }
                        }
                    ]);
                    return WidgetView;
                }();
                return WidgetView;
            }
            module1.exports = WidgetViewFactory;
        /***/ },
        /* 165 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.CancellationError = exports.default = undefined;
            var _Cancellation = __webpack_require__(660);
            var _Cancellation2 = _interopRequireDefault(_Cancellation);
            var _CancellationError2 = __webpack_require__(301);
            var _CancellationError3 = _interopRequireDefault(_CancellationError2);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            exports.default = _Cancellation2.default;
            exports.CancellationError = _CancellationError3.default;
        /***/ },
        /* 166 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const sessionObjects = __webpack_require__(21);
                module1.exports = ()=>Promise.all(sessionObjects.subscribers.where().map((sub)=>{
                        if (!sub.isAudioBlocked()) return undefined;
                        /**
   * Causes subscribers' audio to play back in browsers where audio is blocked.
   * You must call this method in response to an HTML element dispaching
   * a <code>click</code> event.
   * <p>
   * You only need to call this method if you disable display of
   * the Subscriber's default audio playback icon (by setting the
   * <code>style.audioBlockedDisplayMode</code> property of the
   * <code>options</code> parameter of the
   * <a href="Session.html#subscribe">Session.subscribe()</a> method).
   * You may call this method in response to the user clicking an HTML element
   * that you display on the page.
   * <p>
   * The Subscriber dispatches an
   * <a href="Subscriber.html#event:audioBlocked">audioBlocked</a> event
   * if audio is blocked. In response to that event, you can display a UI
   * element to notify the end user to respond to playback subscriber audio.
   * Call the <code>OT.unblockAudio()</code> method in response to the user
   * clicking a DOM element.
   * <p>
   * <i>Note:</i> Subscriber audio is also unblocked automatically if
   * the local client gains access to the camera or microphone (for instance,
   * in response to a successful call to <code>OT.initPublisher()</code>).
   *
   * @returns Promise The promise resolves if audio playback succeeds
   * on all blocked subscribers. The promise is rejected if playback fails.
   * See <a href="Error.html">Error</a> for details.
   *
   * @see <a href="Subscriber.html#isAudioBlocked">Subscriber.isAudioBlocked()</a>
   * @see The <a href="Subscriber.html#event:audioBlocked">audioBlocked</a>
   * and <a href="Subscriber.html#event:audioUnblocked">audioUnblocked</a>
   * Subscriber events
   *
   * @method OT.unblockAudio
   * @memberof OT
   */ return sub._.unblockAudio();
                    }));
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 167 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (sourceStreamId)=>sourceStreamId === 'P2P' ? 'RELAYED' : 'ROUTED';
        /***/ },
        /* 168 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                /* eslint-disable global-require, func-names, max-len */ /* eslint-disable no-use-before-define, no-prototype-builtins, no-underscore-dangle */ /* global MediaStreamTrack, MediaStreamTrackGenerator */ // @todo need to ensure logging for peer disconnected, and peer failures is intact
                const get = __webpack_require__(59);
                const assert = __webpack_require__(147);
                const assign = __webpack_require__(9);
                const cloneDeep = __webpack_require__(58);
                const find = __webpack_require__(62);
                const isString = __webpack_require__(276);
                const pick = __webpack_require__(48);
                const once = __webpack_require__(51);
                const startCase = __webpack_require__(679);
                const uuid = __webpack_require__(16);
                const capitalize = __webpack_require__(259);
                const WeakMap1 = __webpack_require__(195);
                const _require = __webpack_require__(165), CancellationError = _require.CancellationError, Cancellation = _require.default;
                const env = __webpack_require__(3);
                const setEncodersActiveStateDefault = __webpack_require__(689);
                const promisify = __webpack_require__(310);
                const getStatsHelpers = __webpack_require__(76);
                const eventNames = __webpack_require__(27);
                const eventing = __webpack_require__(7);
                const promiseDelay = __webpack_require__(106);
                const Event1 = __webpack_require__(126);
                const AnalyticsHelperDefault = __webpack_require__(26);
                const IntervalRunnerDefault = __webpack_require__(75);
                const createCleanupJobs = __webpack_require__(154);
                const whitelistPublisherProperties = __webpack_require__(690);
                const defaultWidgetView = __webpack_require__(164)();
                const audioLevelBehaviour = __webpack_require__(691);
                const blockCallsUntilComplete = __webpack_require__(692);
                const unblockAudio = __webpack_require__(166);
                const _require2 = __webpack_require__(24)(), getInputMediaDevices = _require2.getInputMediaDevices;
                const createCanvasVideoTrack = __webpack_require__(693);
                const isSecureContextRequired = __webpack_require__(270);
                const isGetRtcStatsReportSupported = __webpack_require__(309);
                const getDeviceIdFromStream = __webpack_require__(694);
                const createStreamErrorMap = __webpack_require__(695);
                const _require3 = __webpack_require__(291), setVideoContentHint = _require3.setVideoContentHint, getVideoContentHint = _require3.getVideoContentHint;
                const getMediaModeBySourceStreamId = __webpack_require__(167);
                const KEEP_SENDING_MEDIA_AFTER_TRANSITIONED = 5000;
                const KEEP_SENDING_MEDIA_TO_KEEP_ALIVE = 3000;
                const KEEP_SENDING_RTCP_DELAY = 30000;
                module1.exports = function PublisherFactory(_ref) {
                    if (_ref === void 0) _ref = {};
                    let _ref2 = _ref, deps = (0, _extends2.default)({}, _ref2);
                    [
                        'processPubOptions'
                    ].forEach((key)=>{
                        assert(deps[key], `${key} dependency must be injected into Publisher`);
                    });
                    const AnalyticsHelper = deps.AnalyticsHelper || AnalyticsHelperDefault;
                    const calculateCapableSimulcastStreams = deps.calculateCapableSimulcastStreams || __webpack_require__(252);
                    const createChromeMixin = deps.createChromeMixin || __webpack_require__(282)();
                    const deviceHelpers = deps.deviceHelpers || __webpack_require__(24)();
                    const EnvironmentLoader = deps.EnvironmentLoader || __webpack_require__(146);
                    const Errors = deps.Errors || __webpack_require__(6);
                    const Events = deps.Events || __webpack_require__(23)();
                    const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                    const interpretPeerConnectionError = deps.interpretPeerConnectionError || __webpack_require__(162)();
                    const IntervalRunner = deps.IntervalRunner || IntervalRunnerDefault;
                    const logging = deps.logging || __webpack_require__(2)('Publisher');
                    const Microphone = deps.Microphone || __webpack_require__(292)();
                    const otError = deps.otError || __webpack_require__(13)();
                    const OTErrorClass = deps.OTErrorClass || __webpack_require__(22);
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const parseIceServers = deps.parseIceServers || __webpack_require__(101).parseIceServers;
                    const PUBLISH_MAX_DELAY = deps.PUBLISH_MAX_DELAY || __webpack_require__(267);
                    const PublisherPeerConnection = deps.PublisherPeerConnection || __webpack_require__(296)();
                    const PublishingState = deps.PublishingState || __webpack_require__(300)();
                    const StreamChannel = deps.StreamChannel || __webpack_require__(149);
                    const systemRequirements = deps.systemRequirements || __webpack_require__(152);
                    const VideoOrientation = deps.VideoOrientation || __webpack_require__(150)();
                    const WidgetView = deps.WidgetView || defaultWidgetView;
                    const windowMock = deps.global || window;
                    const createSendMethod = deps.createSendMethod || __webpack_require__(307);
                    const setEncodersActiveState = deps.setEncodersActiveState || setEncodersActiveStateDefault;
                    const MediaProcessor = deps.MediaProcessor || __webpack_require__(696);
                    const MediaProcessorConnector = __webpack_require__(701);
                    const shouldLogMediaProcessorEvents = deps.shouldLogMediaProcessorEvents || __webpack_require__(702);
                    const processPubOptions = deps.processPubOptions;
                    /**
   * The Publisher object  provides the mechanism through which control of the
   * published stream is accomplished. Calling the <code>OT.initPublisher()</code> method
   * creates a Publisher object. </p>
   *
   *  <p>The following code instantiates a session, and publishes an audio-video stream
   *  upon connection to the session: </p>
   *
   *  <pre>
   *  var apiKey = ''; // Replace with your API key. See https://tokbox.com/account
   *  var sessionID = ''; // Replace with your own session ID.
   *                      // See https://tokbox.com/developer/guides/create-session/.
   *  var token = ''; // Replace with a generated token that has been assigned the moderator role.
   *                  // See https://tokbox.com/developer/guides/create-token/.
   *
   *  var session = OT.initSession(apiKey, sessionID);
   *  session.connect(token, function(error) {
   *    if (error) {
   *      console.log(error.message);
   *    } else {
   *      // This example assumes that a DOM element with the ID 'publisherElement' exists
   *      var publisherProperties = {width: 400, height:300, name:"Bob's stream"};
   *      publisher = OT.initPublisher('publisherElement', publisherProperties);
   *      session.publish(publisher);
   *    }
   *  });
   *  </pre>
   *
   *      <p>This example creates a Publisher object and adds its video to a DOM element
   *      with the ID <code>publisherElement</code> by calling the <code>OT.initPublisher()</code>
   *      method. It then publishes a stream to the session by calling
   *      the <code>publish()</code> method of the Session object.</p>
   *
   * @property {Boolean} accessAllowed Whether the user has granted access to the camera
   * and microphone. The Publisher object dispatches an <code>accessAllowed</code> event when
   * the user grants access. The Publisher object dispatches an <code>accessDenied</code> event
   * when the user denies access.
   * @property {Element} element The HTML DOM element containing the Publisher. (<i>Note:</i>
   * when you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to
   * <a href="OT.html#initPublisher">OT.initPublisher</a>, the <code>element</code> property
   * is undefined.)
   * @property {String} id The DOM ID of the Publisher.
   * @property {Stream} stream The {@link Stream} object corresponding the stream of
   * the Publisher.
   * @property {Session} session The {@link Session} to which the Publisher belongs.
   *
   * @see <a href="OT.html#initPublisher">OT.initPublisher</a>
   * @see <a href="Session.html#publish">Session.publish()</a>
   *
   * @class Publisher
   * @augments EventDispatcher
   */ const Publisher = function Publisher(options) {
                        var _this = this;
                        if (options === void 0) options = {};
                        let privateEvents = eventing({});
                        const peerConnectionMetaMap = new WeakMap1();
                        /**
     * @typedef {Object} peerConnectionMeta
     * @property {String} remoteConnectionId The connection id of the remote side
     * @property {String} remoteSubscriberId The subscriber id of the remote side
     * @property {String} peerId The peerId of this peer connection
     * @property {String} peerConnectionId Our local identifier for this peer connection
     */ /**
     * Retrieve meta information for this peer connection
     * @param {PublisherPeerConnection} peerConnection
     * @returns {peerConnectionMeta} meta data regarding this peer connection
     */ const getPeerConnectionMeta = (peerConnection)=>peerConnectionMetaMap.get(peerConnection);
                        const setPeerConnectionMeta = (peerConnection, value)=>peerConnectionMetaMap.set(peerConnection, value);
                        eventing(this);
                        const streamCleanupJobs = createCleanupJobs();
                        /** @type AnalyticsHelperDefault */ let analytics = new AnalyticsHelper(); // Check that the client meets the minimum requirements, if they don't the upgrade
                        // flow will be triggered.
                        if (!systemRequirements.check()) systemRequirements.upgrade();
                        /** @type {WidgetView|null} */ let widgetView;
                        let lastRequestedStreamId;
                        let webRTCStream;
                        const mutedMantisAudioTracksInAMR = {};
                        let publishStartTime;
                        let microphone;
                        let state;
                        let rumorIceServers;
                        let attemptStartTime;
                        let audioDevices;
                        let videoDevices;
                        let selectedVideoInputDeviceId;
                        let selectedAudioInputDeviceId;
                        let _currentTrackDeviceId;
                        let didPublishComplete = false;
                        let activeSourceStreamId;
                        let _keepSendingRtcpToMantisTimeout;
                        let _restartSendingRtpToMantisCalled;
                        let _videoMediaProcessorConnector;
                        let _audioMediaProcessorConnector;
                        const hybridSessionTransitionStartTimes = {};
                        const lastIceConnectionStates = {};
                        let _streamDestroyTimeout;
                        const STREAM_DESTROY_DELAY = 5000;
                        /** @type IntervalRunnerDefault | undefined */ let connectivityAttemptPinger; // previousSession mimics the publisher.session variable except it's never set to null
                        // this allows analytics to refer to it in cases where we disconnect/destroy
                        // and go to log analytics and publisher.session has been set to null
                        let previousSession;
                        const getLastSession = ()=>this.session || previousSession || {
                                isConnected () {
                                    return false;
                                }
                            };
                        const streamChannels = [];
                        const mediaProcessor = new MediaProcessor();
                        this.once('publishComplete', (err)=>{
                            if (!err) {
                                var _this$session;
                                didPublishComplete = true;
                                activeSourceStreamId = ((_this$session = this.session) == null ? void 0 : _this$session.sessionInfo.p2pEnabled) ? 'P2P' : 'MANTIS';
                            }
                        });
                        this.on('sourceStreamIdChanged', (newSourceStreamId)=>{
                            activeSourceStreamId = newSourceStreamId;
                        });
                        this.on('audioAcquisitionProblem', (_ref3)=>{
                            let method = _ref3.method;
                            logAnalyticsEvent('publisher:audioAcquisitionProblem', 'Event', {
                                didPublishComplete: didPublishComplete,
                                method: method
                            });
                        });
                        function getCommonAnalyticsFields() {
                            return {
                                connectionId: getLastSession().isConnected() ? getLastSession().connection.connectionId : null,
                                streamId: lastRequestedStreamId,
                                widgetType: 'Publisher'
                            };
                        }
                        const onStreamAvailableError = (plainError)=>{
                            const names = Object.keys(Errors).map((shortName)=>Errors[shortName]);
                            const error = otError(names.indexOf(plainError.name) > -1 ? plainError.name : Errors.MEDIA_ERR_ABORTED, plainError, ExceptionCodes.UNABLE_TO_PUBLISH);
                            logging.error(`onStreamAvailableError ${error.name}: ${error.message}`);
                            state.set('Failed');
                            if (widgetView) {
                                widgetView.destroy();
                                widgetView = null;
                            }
                            const logOptions = {
                                failureReason: 'GetUserMedia',
                                failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
                                failureMessage: `OT.Publisher failed to access camera/mic: ${error.message}`
                            };
                            logConnectivityEvent('Failure', {}, logOptions);
                            OTErrorClass.handleJsException({
                                error: error,
                                errorMsg: logOptions.failureReason,
                                code: logOptions.failureCode,
                                target: this,
                                analytics: analytics
                            });
                            this.trigger('publishComplete', error);
                        };
                        const onScreenSharingError = (errorParam)=>{
                            const error = cloneDeep(errorParam);
                            error.code = ExceptionCodes.UNABLE_TO_PUBLISH;
                            logging.error(`OT.Publisher.onScreenSharingError ${error.message}`);
                            state.set('Failed');
                            error.message = `Screensharing: ${error.message}`;
                            this.trigger('publishComplete', error);
                            logConnectivityEvent('Failure', {}, {
                                failureReason: 'ScreenSharing',
                                failureMessage: error.message
                            });
                            if (widgetView) {
                                widgetView.destroy();
                                widgetView = null;
                            }
                        }; // The user has clicked the 'deny' button in the allow access dialog, or it's
                        // set to always deny, or the access was denied due to HTTP restrictions;
                        const onAccessDenied = (errorParam)=>{
                            const error = cloneDeep(errorParam);
                            let isIframe;
                            try {
                                isIframe = window.self !== window.top;
                            } catch (err) {}
                            if (window.location.protocol !== 'https:') {
                                if (isScreenSharing) /*
           * in http:// the browser will deny permission without asking the
           * user. There is also no way to tell if it was denied by the
           * user, or prevented from the browser.
           */ error.message += ' Note: https:// is required for screen sharing.';
                                else if (isSecureContextRequired() && OTHelpers.env.hostName !== 'localhost') error.message += ` Note: ${OTHelpers.env.name} requires HTTPS for camera and microphone access.`;
                            }
                            if (isIframe && !isScreenSharing) error.message += ' Note: Check that the iframe has the allow attribute for camera and microphone';
                            logging.error(error.message);
                            state.set('Failed'); // Note: The substring 'Publisher Access Denied:' is part of our api contract for now.
                            // https://tokbox.com/developer/guides/publish-stream/js/#troubleshooting
                            error.message = `OT.Publisher Access Denied: Permission Denied: ${error.message}`;
                            error.code = ExceptionCodes.UNABLE_TO_PUBLISH;
                            if (widgetView) {
                                widgetView.destroy();
                                widgetView = null;
                            }
                            logConnectivityEvent('Cancel', {
                                reason: 'AccessDenied'
                            });
                            this.trigger('publishComplete', error);
                            this.dispatchEvent(new Event1(eventNames.ACCESS_DENIED));
                        };
                        const userMediaError = (error)=>{
                            const isPermissionError = error.name === Errors.USER_MEDIA_ACCESS_DENIED || error.name === Errors.NOT_SUPPORTED && error.originalMessage.match(/Only secure origins/);
                            if (isPermissionError) onAccessDenied(error);
                            else if (processPubOptions.isScreenSharing) onScreenSharingError(error);
                            else onStreamAvailableError(error);
                            throw error;
                        };
                        const onAccessDialogOpened = ()=>{
                            logAnalyticsEvent('accessDialog', 'Opened');
                            this.dispatchEvent(new Event1(eventNames.ACCESS_DIALOG_OPENED, true));
                        };
                        const onAccessDialogClosed = ()=>{
                            logAnalyticsEvent('accessDialog', 'Closed');
                            this.dispatchEvent(new Event1(eventNames.ACCESS_DIALOG_CLOSED, false));
                        };
                        const guid = uuid();
                        const peerConnectionsAsync = {};
                        let loaded = false;
                        let previousAnalyticsStats = {};
                        let audioAcquisitionProblemDetected = false;
                        let processedOptions = processPubOptions(options, 'OT.Publisher', ()=>state && state.isDestroyed());
                        processedOptions.on({
                            accessDialogOpened: onAccessDialogOpened,
                            accessDialogClosed: onAccessDialogClosed
                        });
                        const _processedOptions = processedOptions, isScreenSharing = _processedOptions.isScreenSharing, isCustomAudioTrack = _processedOptions.isCustomAudioTrack, isCustomVideoTrack = _processedOptions.isCustomVideoTrack, shouldAllowAudio = _processedOptions.shouldAllowAudio, properties = _processedOptions.properties, getUserMedia = _processedOptions.getUserMedia; // start with undefined
                        Object.defineProperty(this, 'loudness', {
                            writable: false,
                            value: undefined,
                            configurable: true
                        });
                        function removeTrackListeners(trackListeners) {
                            trackListeners.forEach((off)=>off());
                        }
                        const listenWithOff = (obj, event, listener)=>{
                            if (!obj.addEventListener) // noop
                            return ()=>{};
                            obj.addEventListener(event, listener);
                            return ()=>obj.removeEventListener(event, listener);
                        };
                        (function handleAudioEnded() {
                            const trackListeners = [];
                            privateEvents.on('streamDestroy', ()=>removeTrackListeners(trackListeners));
                            privateEvents.on('streamChange', ()=>{
                                removeTrackListeners(trackListeners);
                                const newListeners = webRTCStream.getAudioTracks().map((track)=>listenWithOff(track, 'ended', ()=>{
                                        // chrome audio acquisition issue
                                        audioAcquisitionProblemDetected = true;
                                        this.trigger('audioAcquisitionProblem', {
                                            method: 'trackEndedEvent'
                                        });
                                    }));
                                trackListeners.splice(0, trackListeners.length, ...newListeners);
                            });
                        }).call(this);
                        (function handleMuteTrack() {
                            const trackListeners = [];
                            privateEvents.on('streamDestroy', ()=>removeTrackListeners(trackListeners));
                            privateEvents.on('streamChange', ()=>{
                                removeTrackListeners(trackListeners); // Check if we should ignore mute/unmute events coming from the tracks.
                                // Further info in shouldSkipMuteEventsFromTrack()
                                if (!shouldSkipMuteEventsFromTrack()) webRTCStream.getTracks().forEach((track)=>{
                                    if (track.addEventListener) {
                                        trackListeners.push(listenWithOff(track, 'mute', ()=>{
                                            refreshAudioVideoUI();
                                        }));
                                        trackListeners.push(listenWithOff(track, 'unmute', ()=>{
                                            refreshAudioVideoUI();
                                        }));
                                    }
                                });
                            });
                        })(); // / Private Methods
                        const shouldSkipMuteEventsFromTrack = ()=>{
                            // Screensharing in Chrome sometimes triggers 'mute' and 'unmute'
                            // repeatedly for no reason OPENTOK-37818
                            // https://bugs.chromium.org/p/chromium/issues/detail?id=931033
                            if (isScreenSharing) return true;
                             // On Chrome when the custom video is static, we are receiving a mute event.
                            // If videoContentHint suggests video could be static, i.e. text or detail
                            // we will ignore the mute events coming from the video track.
                            // Further info: OPENTOK-44289
                            const staticContentHints = [
                                'text',
                                'detail'
                            ];
                            const isStaticContent = staticContentHints.includes(properties.videoContentHint);
                            return isCustomVideoTrack && isStaticContent;
                        };
                        const logAnalyticsEvent = options.logAnalyticsEvent || ((action, variation, payload, logOptions, throttle)=>{
                            let stats = assign({
                                action: action,
                                variation: variation,
                                payload: payload
                            }, getCommonAnalyticsFields(), logOptions);
                            if (variation === 'Failure') stats = assign(previousAnalyticsStats, stats);
                            previousAnalyticsStats = pick(stats, 'sessionId', 'connectionId', 'partnerId');
                            analytics.logEvent(stats, throttle);
                        });
                        const enableMediaProcessorLogging = ()=>{
                            const shouldLogEvents = shouldLogMediaProcessorEvents(this.session);
                            if (!shouldLogEvents) {
                                mediaProcessor.disableLogging();
                                return;
                            } // We only log events when connected to a session so this should
                            // never throw
                            const apiKey = this.session.apiKey;
                            const proxyUrl = this.session._.getProxyUrl();
                            mediaProcessor.enableLogging(apiKey, proxyUrl);
                        };
                        const logConnectivityEvent = function logConnectivityEvent(variation, payload, logOptions) {
                            if (payload === void 0) payload = {};
                            if (logOptions === void 0) logOptions = {};
                            if (logOptions.failureReason === 'Non-fatal') // we don't want to log because it was a non-fatal failure
                            return;
                            if (variation === 'Attempt') {
                                attemptStartTime = new Date().getTime();
                                if (connectivityAttemptPinger) {
                                    connectivityAttemptPinger.stop();
                                    logging.error('_connectivityAttemptPinger should have been cleaned up');
                                }
                                connectivityAttemptPinger = new IntervalRunner(()=>{
                                    logAnalyticsEvent('Publish', 'Attempting', payload, (0, _extends2.default)({}, getCommonAnalyticsFields(), logOptions));
                                }, 0.2, 6);
                            }
                            if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') {
                                if (connectivityAttemptPinger) {
                                    connectivityAttemptPinger.stop();
                                    connectivityAttemptPinger = undefined;
                                } else logging.warn(`Received connectivity event: "${variation}" without "Attempt"`);
                                logAnalyticsEvent('Publish', variation, (0, _extends2.default)({
                                    videoInputDevices: videoDevices,
                                    audioInputDevices: audioDevices,
                                    videoInputDeviceCount: videoDevices ? videoDevices.length : undefined,
                                    audioInputDeviceCount: audioDevices ? audioDevices.length : undefined,
                                    selectedVideoInputDeviceId: selectedVideoInputDeviceId,
                                    selectedAudioInputDeviceId: selectedAudioInputDeviceId
                                }, payload), (0, _extends2.default)({
                                    attemptDuration: new Date().getTime() - attemptStartTime
                                }, logOptions));
                            } else logAnalyticsEvent('Publish', variation, payload, logOptions);
                        };
                        const logRepublish = (variation, payload)=>{
                            logAnalyticsEvent('ICERestart', variation, payload);
                        };
                        const logHybridSessionTransition = (action, variation, payload)=>{
                            if (variation === 'Attempt') {
                                hybridSessionTransitionStartTimes[action] = new Date().getTime();
                                logAnalyticsEvent(action, variation, payload);
                            } else if (variation === 'Failure' || variation === 'Success') logAnalyticsEvent(action, variation, payload, {
                                attemptDuration: new Date().getTime() - hybridSessionTransitionStartTimes[action]
                            });
                        };
                        const logRoutedToRelayedTransition = function logRoutedToRelayedTransition(variation, payload) {
                            if (payload === void 0) payload = {};
                            logHybridSessionTransition('RoutedToRelayedTransition', variation, payload);
                        };
                        const logRelayedToRoutedTransition = function logRelayedToRoutedTransition(variation, payload) {
                            if (payload === void 0) payload = {};
                            logHybridSessionTransition('RelayedToRoutedTransition', variation, payload);
                        }; // logs an analytics event for getStats on the first call
                        const notifyGetStatsCalled = once(()=>{
                            logAnalyticsEvent('GetStats', 'Called');
                        });
                        const notifyGetRtcStatsCalled = once(()=>{
                            logAnalyticsEvent('GetRtcStatsReport', 'Called');
                        });
                        const recordQOS = (_ref4)=>{
                            let parsedStats = _ref4.parsedStats, simulcastEnabled = _ref4.simulcastEnabled, remoteConnectionId = _ref4.remoteConnectionId, peerId = _ref4.peerId, sourceStreamId = _ref4.sourceStreamId;
                            const QoSBlob = {
                                peerId: peerId,
                                widgetType: 'Publisher',
                                connectionId: this.session && this.session.isConnected() ? this.session.connection.connectionId : null,
                                streamId: lastRequestedStreamId,
                                width: widgetView.width,
                                height: widgetView.height,
                                audioTrack: webRTCStream && webRTCStream.getAudioTracks().length > 0,
                                hasAudio: hasAudio(),
                                publishAudio: properties.publishAudio,
                                videoTrack: webRTCStream && webRTCStream.getVideoTracks().length > 0,
                                hasVideo: hasVideo(),
                                publishVideo: properties.publishVideo,
                                audioSource: isCustomAudioTrack ? 'Custom' : undefined,
                                duration: publishStartTime ? Math.round((new Date().getTime() - publishStartTime.getTime()) / 1000) : 0,
                                remoteConnectionId: remoteConnectionId,
                                scalableVideo: simulcastEnabled,
                                sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId)
                            };
                            let videoSource = isScreenSharing && isCustomVideoTrack && 'Screen' || isScreenSharing && options.videoSource || isCustomVideoTrack && 'Custom' || properties.constraints.video && 'Camera' || null; // Normalize videoSource so that "application" becomes "Application"
                            if (isString(videoSource)) videoSource = startCase(videoSource);
                            QoSBlob.videoSource = videoSource;
                            const videoDimensions = {
                                videoWidth: this.videoWidth(),
                                videoHeight: this.videoHeight()
                            };
                            const parsedAndQosStats = assign({}, QoSBlob, parsedStats, videoDimensions);
                            analytics.logQOS(parsedAndQosStats);
                            this.trigger('qos', parsedAndQosStats);
                        }; // Returns the video dimensions. Which could either be the ones that
                        // the developer specific in the videoDimensions property, or just
                        // whatever the video element reports.
                        //
                        // If all else fails then we'll just default to 640x480
                        //
                        const getVideoDimensions = ()=>{
                            let streamWidth;
                            let streamHeight;
                            const video = widgetView && widgetView.video(); // We set the streamWidth and streamHeight to be the minimum of the requested
                            // resolution and the actual resolution.
                            if (properties.videoDimensions) {
                                streamWidth = Math.min(properties.videoDimensions.width, video && video.videoWidth() || 640);
                                streamHeight = Math.min(properties.videoDimensions.height, video && video.videoHeight() || 480);
                            } else {
                                streamWidth = video && video.videoWidth() || 640;
                                streamHeight = video && video.videoHeight() || 480;
                            }
                            return {
                                width: streamWidth,
                                height: streamHeight
                            };
                        }; // / Private Events
                        const stateChangeFailed = (changeFailed)=>{
                            logging.error('OT.Publisher State Change Failed: ', changeFailed.message);
                            logging.debug(changeFailed);
                        };
                        const onLoaded = ()=>{
                            if (state.isDestroyed()) {
                                // The publisher was destroyed before loading finished
                                if (widgetView) widgetView.destroyVideo();
                                return;
                            }
                            logging.debug('OT.Publisher.onLoaded; resolution:', `${this.videoWidth()}x${this.videoHeight()}`);
                            state.set('MediaBound'); // Try unblock audio on all subscribers
                            unblockAudio().catch(logging.error); // If we have a session and we haven't created the stream yet then
                            // wait until that is complete before hiding the loading spinner
                            widgetView.loading(this.session ? !this.stream : false);
                            loaded = true;
                        };
                        const onLoadFailure = (plainError)=>{
                            // eslint-disable-next-line no-param-reassign
                            const err = otError(Errors.CONNECT_FAILED, plainError, ExceptionCodes.P2P_CONNECTION_FAILED);
                            err.message = `OT.Publisher PeerConnection Error: ${err.message}`;
                            logConnectivityEvent('Failure', {}, {
                                failureReason: 'PeerConnectionError',
                                failureCode: err.code,
                                failureMessage: err.message
                            });
                            state.set('Failed');
                            this.trigger('publishComplete', err);
                            OTErrorClass.handleJsException({
                                error: err,
                                target: this,
                                analytics: analytics
                            });
                        }; // Clean up our LocalMediaStream
                        const cleanupLocalStream = ()=>{
                            if (webRTCStream) {
                                privateEvents.emit('streamDestroy'); // Stop revokes our access cam and mic access for this instance
                                // of localMediaStream.
                                if (windowMock.MediaStreamTrack && windowMock.MediaStreamTrack.prototype.stop) // Newer spec
                                webRTCStream.getTracks().forEach((track)=>track.stop());
                                else // Older spec
                                webRTCStream.stop();
                            }
                        };
                        const iOSRotatedVideoFeedBugHandler = ()=>{
                            // In iOS 15+, when the page is put on background and then restored, the publisher video feed
                            // is getting rotated. A workaround is to rebind the srcObject.
                            const isBuggediOS = env.isiOS && env.iOSVersion >= 15 && env.iOSVersion < 15.2;
                            const videoTrack = webRTCStream.getVideoTracks()[0];
                            if (!isBuggediOS || !videoTrack) return;
                            const visibilityHandler = ()=>{
                                if (!document.hidden && widgetView) widgetView.rebindSrcObject();
                            };
                            document.addEventListener('visibilitychange', visibilityHandler);
                        };
                        const iOSBuggedLocalAudioTrackHandler = ()=>{
                            // see https://bugs.webkit.org/show_bug.cgi?id=208209 & https://bugs.webkit.org/show_bug.cgi?id=208516
                            // in iOS 13.3 and later, the audiotrack sometimes fails to unmute after receivng a phone call
                            // this work around relies on the visibility of the page to see if the call is over
                            const isBuggediOS = env.isiOS && env.iOSVersion >= 13.3;
                            const audioTrack = webRTCStream.getAudioTracks()[0];
                            if (isBuggediOS && audioTrack) {
                                audioTrack.onmute = ()=>handleBuggedMutedLocalAudioTrack(audioTrack); // When iOS uses compact UI for phone calls, the visibility of the page is not relevant.
                                // As a workaround for this specific case, when the track is back to unmuted
                                // we reset the audio source. See OPENTOK-42233.
                                audioTrack.onunmute = ()=>handleBuggedUnMutedLocalAudioTrack(audioTrack);
                            }
                        };
                        const bindVideo = /*#__PURE__*/ function() {
                            var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                                var videoContainerOptions;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            videoContainerOptions = {
                                                muted: true
                                            };
                                            if (widgetView) {
                                                _context.next = 3;
                                                break;
                                            }
                                            throw new Error('Cannot bind video after widget view has been destroyed');
                                        case 3:
                                            return _context.abrupt("return", widgetView.bindVideo(webRTCStream, videoContainerOptions));
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function bindVideo() {
                                return _ref5.apply(this, arguments);
                            };
                        }();
                        const onStreamAvailable = /*#__PURE__*/ function() {
                            var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(webOTStream) {
                                var findSelectedDeviceId;
                                return _regenerator.default.wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            logging.debug('OT.Publisher.onStreamAvailable');
                                            state.set('BindingMedia');
                                            if (properties.videoContentHint !== undefined) setVideoContentHint(webOTStream, properties.videoContentHint);
                                            cleanupLocalStream();
                                            webRTCStream = webOTStream;
                                            if (!properties.videoFilter) {
                                                _context2.next = 14;
                                                break;
                                            }
                                            _context2.prev = 6;
                                            _context2.next = 9;
                                            return _this.applyVideoFilter(properties.videoFilter);
                                        case 9:
                                            _context2.next = 14;
                                            break;
                                        case 11:
                                            _context2.prev = 11;
                                            _context2.t0 = _context2["catch"](6);
                                            logging.error(`Error applying video filter: ${_context2.t0}`);
                                        case 14:
                                            privateEvents.emit('streamChange');
                                            iOSBuggedLocalAudioTrackHandler();
                                            iOSRotatedVideoFeedBugHandler();
                                            findSelectedDeviceId = (tracks, devices)=>{
                                                // Store the device labels to log later
                                                let selectedDeviceId;
                                                tracks.forEach((track)=>{
                                                    if (track.deviceId) selectedDeviceId = track.deviceId.toString();
                                                    else if (track.label && devices) {
                                                        const selectedDevice = find(devices, (el)=>el.label === track.label);
                                                        if (selectedDevice) selectedDeviceId = selectedDevice.deviceId;
                                                    }
                                                });
                                                return selectedDeviceId;
                                            };
                                            selectedVideoInputDeviceId = findSelectedDeviceId(webRTCStream.getVideoTracks(), videoDevices);
                                            selectedAudioInputDeviceId = findSelectedDeviceId(webRTCStream.getAudioTracks(), audioDevices);
                                            microphone = new Microphone(webRTCStream, !properties.publishAudio);
                                            updateVideo();
                                            updateAudio();
                                            _this.accessAllowed = true;
                                            _this.dispatchEvent(new Event1(eventNames.ACCESS_ALLOWED, false));
                                        case 25:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, null, [
                                    [
                                        6,
                                        11
                                    ]
                                ]);
                            }));
                            return function onStreamAvailable(_x) {
                                return _ref6.apply(this, arguments);
                            };
                        }();
                        const onPublishingTimeout = (session)=>{
                            logging.error('OT.Publisher.onPublishingTimeout');
                            let errorName;
                            let errorMessage;
                            if (audioAcquisitionProblemDetected) {
                                errorName = Errors.CHROME_MICROPHONE_ACQUISITION_ERROR;
                                errorMessage = "Unable to publish because your browser failed to get access to your microphone. You may need to fully quit and restart your browser to get it to work. See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.";
                            } else {
                                errorName = Errors.TIMEOUT;
                                errorMessage = 'Could not publish in a reasonable amount of time';
                            }
                            const logOptions = {
                                failureReason: 'ICEWorkflow',
                                failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
                                failureMessage: 'OT.Publisher failed to publish in a reasonable amount of time (timeout)'
                            };
                            logConnectivityEvent('Failure', {}, logOptions);
                            OTErrorClass.handleJsException({
                                errorMsg: logOptions.failureReason,
                                code: logOptions.failureCode,
                                target: this,
                                analytics: analytics
                            });
                            if (session.isConnected() && this.streamId) session._.streamDestroy(this.streamId);
                             // Disconnect immediately, rather than wait for the WebSocket to
                            // reply to our destroyStream message.
                            this.disconnect();
                            this.session = null; // We're back to being a stand-alone publisher again.
                            if (!state.isDestroyed()) state.set('MediaBound');
                            this.trigger('publishComplete', otError(errorName, new Error(errorMessage), ExceptionCodes.UNABLE_TO_PUBLISH));
                        };
                        const onVideoError = (plainErr)=>{
                            // eslint-disable-next-line no-param-reassign
                            const err = otError(Errors.MEDIA_ERR_DECODE, plainErr, ExceptionCodes.UNABLE_TO_PUBLISH);
                            err.message = `OT.Publisher while playing stream: ${err.message}`;
                            logging.error('OT.Publisher.onVideoError:', err);
                            logAnalyticsEvent('stream', null, {
                                reason: err.message
                            }); // Check if attempting to publish *before* overwriting the state
                            const isAttemptingToPublish = state.isAttemptingToPublish();
                            state.set('Failed');
                            if (isAttemptingToPublish) this.trigger('publishComplete', err);
                            else // FIXME: This emits a string instead of an error here for backwards compatibility despite
                            // being undocumented. When possible we should remove access to this and other undocumented
                            // events, and restore emitting actual errors here.
                            this.trigger('error', err.message);
                            OTErrorClass.handleJsException({
                                error: err,
                                target: this,
                                analytics: analytics
                            });
                        }; // Makes it easier to unit test stuff
                        this._setWebRTCStream = (stream)=>{
                            webRTCStream = stream;
                        }; // Makes it easier to unit test stuff
                        this._setCurrentVideoFilter = (filter)=>{
                            currentVideoFilter = filter;
                        }; // Makes it easier to unit test stuff
                        this._getCurrentVideoFilter = ()=>currentVideoFilter; // Makes it easier to unit test stuff
                        this._getMediaProcessor = ()=>mediaProcessor;
                        this._removePeerConnection = (peerConnection)=>{
                            if (!peerConnection) return;
                            const _getPeerConnectionMet = getPeerConnectionMeta(peerConnection), peerConnectionId = _getPeerConnectionMet.peerConnectionId;
                            delete peerConnectionsAsync[peerConnectionId];
                            peerConnection.destroy();
                        };
                        this._removeSubscriber = (subscriberId)=>{
                            const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
                            if (isAdaptiveEnabled && activeSourceStreamId === 'P2P') this._.startRelayedToRoutedTransition();
                            getPeerConnectionsBySubscriber(subscriberId).then((peerConnections)=>{
                                peerConnections.forEach((pc)=>this._removePeerConnection(pc));
                            });
                        };
                        const onPeerDisconnected = (peerConnection)=>{
                            const _getPeerConnectionMet2 = getPeerConnectionMeta(peerConnection), remoteSubscriberId = _getPeerConnectionMet2.remoteSubscriberId, peerConnectionId = _getPeerConnectionMet2.peerConnectionId;
                            logging.debug('Subscriber has been disconnected from the Publisher\'s PeerConnection');
                            logAnalyticsEvent('disconnect', 'PeerConnection', {
                                subscriberConnection: peerConnectionId
                            });
                            this._removeSubscriber(remoteSubscriberId);
                        }; // @todo find out if we get onPeerDisconnected when a failure occurs.
                        const onPeerConnectionFailure = /*#__PURE__*/ function() {
                            var _ref8 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(peerConnection, _ref7) {
                                var reason, prefix, sessionInfo, _ref9, _ref9$remoteConnectio, remoteConnectionId, peerConnectionId, error, payload, logOptions, pc;
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            reason = _ref7.reason, prefix = _ref7.prefix;
                                            sessionInfo = _this.session && _this.session.sessionInfo;
                                            if (!(prefix === 'ICEWorkflow' && sessionInfo && sessionInfo.reconnection && loaded)) {
                                                _context3.next = 5;
                                                break;
                                            }
                                            // @todo not sure this is the right thing to do
                                            logging.debug('Ignoring peer connection failure due to possibility of reconnection.');
                                            return _context3.abrupt("return");
                                        case 5:
                                            _ref9 = getPeerConnectionMeta(peerConnection) || {}, _ref9$remoteConnectio = _ref9.remoteConnectionId, remoteConnectionId = _ref9$remoteConnectio === void 0 ? '(not found)' : _ref9$remoteConnectio, peerConnectionId = _ref9.peerConnectionId;
                                            error = interpretPeerConnectionError(undefined, reason, prefix, remoteConnectionId, 'Publisher');
                                            payload = {
                                                hasRelayCandidates: peerConnection && peerConnection.hasRelayCandidates()
                                            };
                                            logOptions = {
                                                failureReason: prefix || 'PeerConnectionError',
                                                failureCode: error.code,
                                                failureMessage: error.message
                                            };
                                            if (state.isPublishing()) // We're already publishing so this is a Non-fatal failure, must be p2p and one of our
                                            // peerconnections failed
                                            logOptions.reason = 'Non-fatal';
                                            else _this.trigger('publishComplete', error);
                                            logConnectivityEvent('Failure', payload, logOptions);
                                            OTErrorClass.handleJsException({
                                                errorMsg: `OT.Publisher PeerConnection Error: ${reason}`,
                                                code: error.code,
                                                target: _this,
                                                analytics: analytics
                                            });
                                            _context3.next = 14;
                                            return peerConnectionsAsync[peerConnectionId];
                                        case 14:
                                            pc = _context3.sent;
                                            pc.destroy();
                                            delete peerConnectionsAsync[peerConnectionId];
                                        case 17:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3);
                            }));
                            return function onPeerConnectionFailure(_x2, _x3) {
                                return _ref8.apply(this, arguments);
                            };
                        }();
                        const isRoutedToRelayedTransitionComplete = (peerConnection)=>{
                            const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
                            return isAdaptiveEnabled && peerConnection.getSourceStreamId() === 'P2P';
                        };
                        const onIceRestartSuccess = (peerConnection)=>{
                            const _getPeerConnectionMet3 = getPeerConnectionMeta(peerConnection), remoteConnectionId = _getPeerConnectionMet3.remoteConnectionId;
                            logRepublish('Success', {
                                remoteConnectionId: remoteConnectionId
                            });
                        };
                        const onIceRestartFailure = (peerConnection)=>{
                            const _getPeerConnectionMet4 = getPeerConnectionMeta(peerConnection), remoteConnectionId = _getPeerConnectionMet4.remoteConnectionId;
                            logRepublish('Failure', {
                                reason: 'ICEWorkflow',
                                message: "OT.Publisher PeerConnection Error: The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall.",
                                remoteConnectionId: remoteConnectionId
                            });
                        };
                        const onIceConnectionStateChange = /*#__PURE__*/ function() {
                            var _ref10 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(newState, peerConnection) {
                                var isAdaptiveEnabled, sourceStreamId, isMantisConnected, isP2PConnected, isSocketReconnecting, socket, isSocketConnected;
                                return _regenerator.default.wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            isAdaptiveEnabled = _this.session.sessionInfo.isAdaptiveEnabled;
                                            sourceStreamId = peerConnection.getSourceStreamId();
                                            lastIceConnectionStates[sourceStreamId] = newState;
                                            if (newState === 'disconnected') setTimeout(()=>{
                                                const isSocketReconnecting = _this.session._.isSocketReconnecting;
                                                const socket = _this.session._.getSocket();
                                                const isSocketConnected = socket.is('connected') && !isSocketReconnecting();
                                                if (lastIceConnectionStates[sourceStreamId] === 'disconnected' && isSocketConnected) {
                                                    const _getPeerConnectionMet5 = getPeerConnectionMeta(peerConnection), remoteConnectionId = _getPeerConnectionMet5.remoteConnectionId;
                                                    logRepublish('Attempt', {
                                                        remoteConnectionId: remoteConnectionId
                                                    });
                                                    peerConnection.iceRestart();
                                                }
                                            }, 2000);
                                            if (!(newState === 'connected')) {
                                                _context4.next = 14;
                                                break;
                                            }
                                            clearTimeout(_streamDestroyTimeout);
                                            if (!isAdaptiveEnabled) {
                                                _context4.next = 14;
                                                break;
                                            }
                                            _context4.next = 9;
                                            return getMantisPeerConnection();
                                        case 9:
                                            isMantisConnected = _context4.sent.iceConnectionStateIsConnected();
                                            _context4.next = 12;
                                            return getP2pPeerConnection();
                                        case 12:
                                            isP2PConnected = _context4.sent.iceConnectionStateIsConnected();
                                            if (isMantisConnected && isP2PConnected) _stopSendingRtpToMantis();
                                        case 14:
                                            if (!(newState === 'failed')) {
                                                _context4.next = 21;
                                                break;
                                            }
                                            isSocketReconnecting = _this.session._.isSocketReconnecting;
                                            socket = _this.session._.getSocket();
                                            isSocketConnected = socket.is('connected') && !isSocketReconnecting();
                                            if (isSocketConnected) {
                                                _context4.next = 20;
                                                break;
                                            }
                                            return _context4.abrupt("return");
                                        case 20:
                                            // If PC has failed and the socket is connected we will either transition to Mantis
                                            // if adaptive and P2P leg or destroy the publisher in all other cases
                                            // Instead of destroying the publisher straight away, we will destroy it after 5 secs
                                            // in order to avoid a race condition where we just got the socket connected at the
                                            // same moment PC transition to failed
                                            if (isAdaptiveEnabled && sourceStreamId === activeSourceStreamId && sourceStreamId === 'P2P') _this._.startRelayedToRoutedTransition();
                                            else _streamDestroyTimeout = setTimeout(()=>{
                                                _this.session._.streamDestroy(_this.streamId, sourceStreamId);
                                            }, STREAM_DESTROY_DELAY);
                                        case 21:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4);
                            }));
                            return function onIceConnectionStateChange(_x4, _x5) {
                                return _ref10.apply(this, arguments);
                            };
                        }();
                        const onPeerConnected = (peerConnection)=>{
                            peerConnection.setP2PMaxBitrate();
                            peerConnection.startEncryption(this.session.connection.id);
                            if (isRoutedToRelayedTransitionComplete(peerConnection)) logRoutedToRelayedTransition('Success');
                        }; // / Private Helpers
                        // Assigns +stream+ to this publisher. The publisher listens for a bunch of events on the stream
                        // so it can respond to changes.
                        const assignStream = (stream)=>{
                            // the Publisher only expects a stream in the PublishingToSession state
                            if (state.current !== 'PublishingToSession') throw new Error('assignStream called when publisher is not successfully publishing');
                            streamCleanupJobs.releaseAll();
                            this.stream = stream;
                            this.stream.on('destroyed', this.disconnect, this);
                            streamCleanupJobs.add(()=>{
                                if (this.stream) this.stream.off('destroyed', this.disconnect, this);
                            });
                            state.set('Publishing');
                            widgetView.loading(!loaded);
                            publishStartTime = new Date();
                            this.dispatchEvent(new Events.StreamEvent('streamCreated', stream, null, false));
                            logConnectivityEvent('Success');
                            this.trigger('publishComplete', null, this);
                        };
                        /**
     * Provides the peer connection associated to the given peerConnectionId.
     *
     * It there is no PC associated it creates a new one and stores it so that the next call returns
     * the same instance.
     *
     * @param {Object} configuration
     * @param {string} configuration.peerConnectionId
     * @returns {Promise<Error, PublisherPeerConnection>}
     */ const createPeerConnection = (_ref11)=>{
                            let peerConnectionId = _ref11.peerConnectionId, send = _ref11.send, log = _ref11.log, logQoS = _ref11.logQoS, sourceStreamId = _ref11.sourceStreamId;
                            if (getPeerConnectionById(peerConnectionId)) return Promise.reject(new Error('PeerConnection already exists'));
                             // Calculate the number of streams to use. 1 for normal, >1 for Simulcast
                            const capableSimulcastStreams = calculateCapableSimulcastStreams({
                                isChromiumEdge: OTHelpers.env.isChromiumEdge,
                                browserName: OTHelpers.env.name,
                                isScreenSharing: isScreenSharing,
                                isCustomVideoTrack: isCustomVideoTrack,
                                sessionInfo: this.session.sessionInfo,
                                constraints: properties.constraints,
                                videoDimensions: getVideoDimensions(),
                                capableSimulcastScreenshare: properties.capableSimulcastScreenshare
                            });
                            peerConnectionsAsync[peerConnectionId] = Promise.all([
                                this.session._.getIceConfig(),
                                this.session._.getVideoCodecsCompatible(webRTCStream)
                            ]).then((_ref12)=>{
                                let iceConfig = _ref12[0], videoCodecsCompatible = _ref12[1];
                                let pcStream = webRTCStream;
                                if (!videoCodecsCompatible) {
                                    pcStream = webRTCStream.clone();
                                    const _pcStream$getVideoTra = pcStream.getVideoTracks(), videoTrack = _pcStream$getVideoTra[0];
                                    if (videoTrack) {
                                        videoTrack.stop();
                                        pcStream.removeTrack(videoTrack);
                                    }
                                }
                                const peerConnection = new PublisherPeerConnection({
                                    iceConfig: iceConfig,
                                    sendMessage: (type, content)=>{
                                        if (type === 'offer') this.trigger('connected');
                                        send(type, content);
                                    },
                                    webRTCStream: pcStream,
                                    channels: properties.channels,
                                    capableSimulcastStreams: capableSimulcastStreams,
                                    overrideSimulcastEnabled: options._enableSimulcast,
                                    logAnalyticsEvent: log,
                                    offerOverrides: {
                                        enableDtx: properties.enableDtx,
                                        enableStereo: properties.enableStereo,
                                        audioBitrate: properties.audioBitrate,
                                        priorityVideoCodec: properties._priorityVideoCodec || this.session.sessionInfo.priorityVideoCodec,
                                        codecFlags: properties._codecFlags || this.session._.getCodecFlags()
                                    },
                                    // FIXME - Remove answerOverrides once maxaveragebitrate is supported by Mantis
                                    answerOverrides: this.session.sessionInfo.p2pEnabled ? undefined : {
                                        audioBitrate: properties.audioBitrate
                                    },
                                    sourceStreamId: sourceStreamId,
                                    isP2pEnabled: this.session.sessionInfo.p2pEnabled,
                                    sessionId: this.session.id,
                                    keyStore: this.session.keyStore,
                                    sFrameClientStore: this.session.sFrameClientStore,
                                    isE2ee: this.session._.isE2ee()
                                });
                                peerConnection.on({
                                    disconnected: ()=>onPeerDisconnected(peerConnection),
                                    error: (_ref13)=>{
                                        let reason = _ref13.reason, prefix = _ref13.prefix;
                                        return onPeerConnectionFailure(peerConnection, {
                                            reason: reason,
                                            prefix: prefix
                                        });
                                    },
                                    qos: logQoS,
                                    iceRestartSuccess: ()=>onIceRestartSuccess(peerConnection),
                                    iceRestartFailure: ()=>onIceRestartFailure(peerConnection),
                                    iceConnectionStateChange: (newState)=>onIceConnectionStateChange(newState, peerConnection),
                                    audioAcquisitionProblem: ()=>{
                                        // will be only triggered in Chrome
                                        audioAcquisitionProblemDetected = true;
                                        this.trigger('audioAcquisitionProblem', {
                                            method: 'getStats'
                                        });
                                    }
                                });
                                peerConnection.once('connected', ()=>onPeerConnected(peerConnection));
                                return new Promise((resolve, reject)=>{
                                    const rejectOnError = (err)=>{
                                        reject(err);
                                    };
                                    peerConnection.once('error', rejectOnError);
                                    peerConnection.init(rumorIceServers, (err)=>{
                                        if (err) return reject(err);
                                        peerConnection.off('error', rejectOnError);
                                        resolve(peerConnection);
                                        return undefined;
                                    });
                                });
                            });
                            return getPeerConnectionById(peerConnectionId);
                        };
                        const getAllPeerConnections = ()=>Promise.all(Object.keys(peerConnectionsAsync).map(getPeerConnectionById));
                        const getPeerConnectionsBySubscriber = (subscriberId)=>getAllPeerConnections().then((peerConnections)=>peerConnections.filter((peerConnection)=>getPeerConnectionMeta(peerConnection).remoteSubscriberId === subscriberId));
                        const getPeerConnectionById = (id)=>peerConnectionsAsync[id];
                        const getPeerConnectionBySourceStreamId = (sourceStreamId)=>{
                            // Find the peerConnectionId which includes the sourceStreamId that we're looking for.
                            const peerConnectionId = Object.keys(peerConnectionsAsync).find((key)=>key.endsWith(`~${sourceStreamId}`));
                            return peerConnectionsAsync[peerConnectionId];
                        };
                        const getMantisPeerConnection = ()=>getPeerConnectionBySourceStreamId('MANTIS');
                        const getP2pPeerConnection = ()=>getPeerConnectionBySourceStreamId('P2P');
                        let chromeMixin = createChromeMixin(this, {
                            name: properties.name,
                            publishAudio: properties.publishAudio,
                            publishVideo: properties.publishVideo,
                            audioSource: properties.audioSource,
                            showControls: properties.showControls,
                            shouldAllowAudio: shouldAllowAudio,
                            logAnalyticsEvent: logAnalyticsEvent
                        });
                        const reset = ()=>{
                            this.off('publishComplete', refreshAudioVideoUI);
                            if (chromeMixin) chromeMixin.reset();
                            streamCleanupJobs.releaseAll();
                            this.disconnect();
                            microphone = null;
                            cleanupLocalStream();
                            webRTCStream = null;
                            if (widgetView) {
                                widgetView.destroy();
                                widgetView = null;
                            }
                            if (this.session) this._.unpublishFromSession(this.session, 'reset');
                            if (mediaProcessor.getVideoFilter()) destroyMediaProcessor();
                            this.id = null;
                            this.stream = null;
                            loaded = false;
                            this.session = null;
                            if (!state.isDestroyed()) state.set('NotPublishing');
                        };
                        const hasVideo = ()=>{
                            if (!webRTCStream || webRTCStream.getVideoTracks().length === 0) return false;
                             // On Chrome when screensharing/custom video is static, it is swapping between 'mute' and
                            // 'unmute' states periodically for no reason OPENTOK-37818
                            // https://bugs.chromium.org/p/chromium/issues/detail?id=931033
                            // We will ignore track.muted when screensharing and custom when videoContentHint
                            // suggests video could be static, i.e. text or detail
                            const staticContentHints = [
                                'text',
                                'detail'
                            ];
                            const isStaticContent = staticContentHints.includes(properties.videoContentHint);
                            const isStaticCustom = isCustomVideoTrack && isStaticContent;
                            const shouldIgnoreTrackMuteState = OTHelpers.env.isChromium && (isScreenSharing || isStaticCustom);
                            return webRTCStream.getVideoTracks().reduce((isEnabled, track)=>isEnabled && (!track.muted || !!shouldIgnoreTrackMuteState) && track.enabled && track.readyState !== 'ended', properties.publishVideo);
                        };
                        const hasAudio = ()=>{
                            if (!webRTCStream || webRTCStream.getAudioTracks().length === 0) return false;
                            return webRTCStream.getAudioTracks().length > 0 && webRTCStream.getAudioTracks().reduce((isEnabled, track)=>isEnabled && !track.muted && track.enabled && track.readyState !== 'ended', properties.publishAudio);
                        };
                        const refreshAudioVideoUI = (activeReason)=>{
                            if (widgetView) {
                                widgetView.audioOnly(!hasVideo());
                                widgetView.showPoster(!hasVideo());
                            }
                            if (chromeMixin) chromeMixin.setAudioOnly(!hasVideo() && hasAudio());
                            if (this.stream) {
                                this.stream.setChannelActiveState('audio', hasAudio(), activeReason);
                                this.stream.setChannelActiveState('video', hasVideo(), activeReason);
                            } else {
                                // Make sure we add a listener for refreshAudioVideoUI only one time.
                                this.off('publishComplete', refreshAudioVideoUI);
                                this.once('publishComplete', refreshAudioVideoUI);
                            }
                        };
                        const _getStatsWrapper = (reportType, callback)=>{
                            let isRtcStatsReport = false;
                            if (typeof reportType === 'function') /* eslint-disable-next-line no-param-reassign */ callback = reportType;
                            else isRtcStatsReport = reportType === 'rtcStatsReport';
                            if (isRtcStatsReport) notifyGetRtcStatsCalled();
                            else notifyGetStatsCalled();
                            if (isRtcStatsReport && !isGetRtcStatsReportSupported) {
                                const errorCode = ExceptionCodes.GET_RTC_STATS_REPORT_NOT_SUPPORTED;
                                callback(otError(Errors.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
                                return;
                            }
                            getAllPeerConnections().then((peerConnections)=>{
                                if (peerConnections.length === 0) {
                                    const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                                    throw otError(Errors.PEER_CONNECTION_NOT_CONNECTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode);
                                }
                                return peerConnections;
                            }).then((peerConnections)=>{
                                const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
                                if (!isAdaptiveEnabled) return peerConnections;
                                 // When the session is adaptive, we only return stats for the active peer connection.
                                return peerConnections.filter((pc)=>pc.getSourceStreamId() === activeSourceStreamId);
                            }).then((peerConnections)=>Promise.all(peerConnections.map((peerConnection)=>(isRtcStatsReport ? promisify(peerConnection.getRtcStatsReport.bind(peerConnection)) : promisify(peerConnection.getStats.bind(peerConnection)))().then((stats)=>({
                                            pc: peerConnection,
                                            stats: stats
                                        }))))).then((pcsAndStats)=>{
                                // @todo this publishStartTime is going to be so wrong in P2P
                                const startTimestamp = publishStartTime ? publishStartTime.getTime() : Date.now();
                                const results = pcsAndStats.map((_ref14)=>{
                                    let pc = _ref14.pc, stats = _ref14.stats;
                                    const _getPeerConnectionMet6 = getPeerConnectionMeta(pc), remoteConnectionId = _getPeerConnectionMet6.remoteConnectionId, remoteSubscriberId = _getPeerConnectionMet6.remoteSubscriberId;
                                    return assign(remoteConnectionId.match(/^symphony\./) ? {} : {
                                        subscriberId: remoteSubscriberId,
                                        connectionId: remoteConnectionId
                                    }, isRtcStatsReport ? {
                                        rtcStatsReport: stats
                                    } : {
                                        stats: getStatsHelpers.normalizeStats(stats, false, startTimestamp)
                                    });
                                });
                                callback(null, results);
                            }).catch(callback);
                        };
                        const _getStats = (callback)=>_getStatsWrapper(callback);
                        const _getRtcStatsReport = (callback)=>_getStatsWrapper('rtcStatsReport', callback);
                        const _createStream = (sourceStreamId, completionHandler)=>{
                            this.session._.streamCreate(properties.name || '', this.streamId, properties.audioFallbackEnabled, streamChannels, properties.minVideoBitrate, sourceStreamId, this.session._.isE2ee(), completionHandler);
                        };
                        const _muteAudioInPeerConnection = (peerConnection)=>{
                            // Mute all audio tracks for the given PC. Please note we don't want
                            // to mute the stream since this can be used by another PC. Thus, we
                            // first clone the audio track, and then mute it.
                            webRTCStream.getAudioTracks().forEach(/*#__PURE__*/ function() {
                                var _ref15 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5(track) {
                                    var audioTrack;
                                    return _regenerator.default.wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                audioTrack = track.clone();
                                                audioTrack.enabled = false; // Best effort: if we fail to replace the track, we will keep the original one. In case
                                                // there is more than one track, we will try to replace as many as possible.
                                                // Potential errors: replaceTrack not supported in old browsers, negotiation required.
                                                _context5.prev = 2;
                                                _context5.next = 5;
                                                return peerConnection.findAndReplaceTrack(track, audioTrack);
                                            case 5:
                                                _context5.next = 10;
                                                break;
                                            case 7:
                                                _context5.prev = 7;
                                                _context5.t0 = _context5["catch"](2);
                                                return _context5.abrupt("return");
                                            case 10:
                                                // Save it, so it can be restored once unmuted.
                                                mutedMantisAudioTracksInAMR[track.id] = audioTrack;
                                            case 11:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5, null, [
                                        [
                                            2,
                                            7
                                        ]
                                    ]);
                                }));
                                return function(_x6) {
                                    return _ref15.apply(this, arguments);
                                };
                            }());
                        };
                        const _unmuteAudioInPeerConnection = (peerConnection)=>{
                            // Replace the cloned muted tracks by the original tracks.
                            webRTCStream.getAudioTracks().forEach(/*#__PURE__*/ function() {
                                var _ref16 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee6(track) {
                                    return _regenerator.default.wrap(function _callee6$(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                _context6.prev = 0;
                                                _context6.next = 3;
                                                return peerConnection.findAndReplaceTrack(mutedMantisAudioTracksInAMR[track.id], track);
                                            case 3:
                                                _context6.next = 8;
                                                break;
                                            case 5:
                                                _context6.prev = 5;
                                                _context6.t0 = _context6["catch"](0);
                                                return _context6.abrupt("return");
                                            case 8:
                                                delete mutedMantisAudioTracksInAMR[track.id];
                                            case 9:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6, null, [
                                        [
                                            0,
                                            5
                                        ]
                                    ]);
                                }));
                                return function(_x7) {
                                    return _ref16.apply(this, arguments);
                                };
                            }());
                        };
                        const _stopSendingRtpToMantis = /*#__PURE__*/ function() {
                            var _ref17 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee7() {
                                var peerConnection;
                                return _regenerator.default.wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _restartSendingRtpToMantisCalled = false;
                                            _context7.next = 3;
                                            return getMantisPeerConnection();
                                        case 3:
                                            peerConnection = _context7.sent;
                                            if (!peerConnection) {
                                                _context7.next = 17;
                                                break;
                                            }
                                            _this.trigger('sourceStreamIdChanged', 'P2P'); // We add this delay before stopping media to prevent MANTIS to consider this stream
                                            // as inactive after a reconnection and then destroy it.
                                            _context7.next = 8;
                                            return promiseDelay(KEEP_SENDING_MEDIA_AFTER_TRANSITIONED);
                                        case 8:
                                            if (!_restartSendingRtpToMantisCalled) {
                                                _context7.next = 11;
                                                break;
                                            }
                                            logging.debug('Cancelling stop sending RTP to MANTIS.');
                                            return _context7.abrupt("return");
                                        case 11:
                                            // Audio is muted and video is set to inactive
                                            _muteAudioInPeerConnection(peerConnection);
                                            _context7.next = 14;
                                            return peerConnection.changeMediaDirectionToInactive();
                                        case 14:
                                            if (!(OTHelpers.env.isFirefox && OTHelpers.env.version < 96)) {
                                                _context7.next = 17;
                                                break;
                                            }
                                            _context7.next = 17;
                                            return _keepSendingRtcpToMantis();
                                        case 17:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7);
                            }));
                            return function _stopSendingRtpToMantis() {
                                return _ref17.apply(this, arguments);
                            };
                        }();
                        const _restartSendingRtpToMantis = /*#__PURE__*/ function() {
                            var _ref18 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee8() {
                                var peerConnection;
                                return _regenerator.default.wrap(function _callee8$(_context8) {
                                    while(true)switch(_context8.prev = _context8.next){
                                        case 0:
                                            _restartSendingRtpToMantisCalled = true;
                                            _context8.next = 3;
                                            return getMantisPeerConnection();
                                        case 3:
                                            peerConnection = _context8.sent;
                                            if (!peerConnection) {
                                                _context8.next = 10;
                                                break;
                                            }
                                            // Audio is unmuted and video is set to recvonly
                                            _unmuteAudioInPeerConnection(peerConnection);
                                            _context8.next = 8;
                                            return peerConnection.changeMediaDirectionToRecvOnly();
                                        case 8:
                                            if (_keepSendingRtcpToMantisTimeout) clearTimeout(_keepSendingRtcpToMantisTimeout);
                                            _this.trigger('sourceStreamIdChanged', 'MANTIS');
                                        case 10:
                                        case "end":
                                            return _context8.stop();
                                    }
                                }, _callee8);
                            }));
                            return function _restartSendingRtpToMantis() {
                                return _ref18.apply(this, arguments);
                            };
                        }();
                        const _keepSendingRtcpToMantis = /*#__PURE__*/ function() {
                            var _ref19 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee10() {
                                var peerConnection;
                                return _regenerator.default.wrap(function _callee10$(_context10) {
                                    while(true)switch(_context10.prev = _context10.next){
                                        case 0:
                                            _context10.next = 2;
                                            return getMantisPeerConnection();
                                        case 2:
                                            peerConnection = _context10.sent;
                                            if (peerConnection) _keepSendingRtcpToMantisTimeout = setTimeout(/*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee9() {
                                                return _regenerator.default.wrap(function _callee9$(_context9) {
                                                    while(true)switch(_context9.prev = _context9.next){
                                                        case 0:
                                                            if (!(activeSourceStreamId === 'P2P')) {
                                                                _context9.next = 9;
                                                                break;
                                                            }
                                                            _context9.next = 3;
                                                            return peerConnection.changeMediaDirectionToRecvOnly();
                                                        case 3:
                                                            _context9.next = 5;
                                                            return promiseDelay(KEEP_SENDING_MEDIA_TO_KEEP_ALIVE);
                                                        case 5:
                                                            _context9.next = 7;
                                                            return peerConnection.changeMediaDirectionToInactive();
                                                        case 7:
                                                            _context9.next = 9;
                                                            return _keepSendingRtcpToMantis();
                                                        case 9:
                                                        case "end":
                                                            return _context9.stop();
                                                    }
                                                }, _callee9);
                                            })), KEEP_SENDING_RTCP_DELAY);
                                        case 4:
                                        case "end":
                                            return _context10.stop();
                                    }
                                }, _callee10);
                            }));
                            return function _keepSendingRtcpToMantis() {
                                return _ref19.apply(this, arguments);
                            };
                        }();
                        this.publish = (targetElement)=>{
                            logging.debug('OT.Publisher: publish');
                            if (state.isAttemptingToPublish() || state.isPublishing()) reset();
                            state.set('GetUserMedia');
                            if (properties.style) this.setStyle(properties.style, null, true);
                            properties.classNames = 'OT_root OT_publisher'; // Defer actually creating the publisher DOM nodes until we know
                            // the DOM is actually loaded.
                            EnvironmentLoader.onLoad(()=>{
                                logging.debug('OT.Publisher: publish: environment loaded'); // @note If ever replacing the widgetView with a new one elsewhere, you'll need to be
                                // mindful that audioLevelBehaviour has a reference to this one, and it will need to be
                                // updated accordingly.
                                // widgetView = new WidgetView(targetElement, properties);
                                widgetView = new WidgetView(targetElement, (0, _extends2.default)({}, properties, {
                                    widgetType: 'publisher'
                                }));
                                if (shouldAllowAudio) audioLevelBehaviour({
                                    publisher: this,
                                    widgetView: widgetView
                                });
                                widgetView.on('error', onVideoError);
                                this.id = widgetView.domId();
                                this.element = widgetView.domElement;
                                if (this.element && chromeMixin) // Only create the chrome if we have an element to insert it into
                                // for insertDefautlUI:false we don't create the chrome
                                chromeMixin.init(widgetView);
                                widgetView.on('videoDimensionsChanged', (oldValue, newValue)=>{
                                    if (this.stream) this.stream.setVideoDimensions(newValue.width, newValue.height);
                                    this.dispatchEvent(new Events.VideoDimensionsChangedEvent(this, oldValue, newValue));
                                });
                                widgetView.on('mediaStopped', (track)=>{
                                    const event = new Events.MediaStoppedEvent(this, track);
                                    this.dispatchEvent(event);
                                    if (event.isDefaultPrevented()) return;
                                    if (track) {
                                        const kind = String(track.kind).toLowerCase(); // If we are publishing this kind when the track stops then
                                        // make sure we start publishing again if we switch to a new track
                                        if (kind === 'audio') updateAudio();
                                        else if (kind === 'video') updateVideo();
                                        else logging.warn(`Track with invalid kind has ended: ${track.kind}`);
                                        return;
                                    }
                                    if (this.session) this._.unpublishFromSession(this.session, 'mediaStopped');
                                    else this.destroy('mediaStopped');
                                });
                                widgetView.on('videoElementCreated', (element)=>{
                                    const event = new Events.VideoElementCreatedEvent(element);
                                    this.dispatchEvent(event);
                                });
                                getUserMedia().catch(userMediaError).then(/*#__PURE__*/ function() {
                                    var _ref21 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee11(stream) {
                                        var hasVideoFilter;
                                        return _regenerator.default.wrap(function _callee11$(_context11) {
                                            while(true)switch(_context11.prev = _context11.next){
                                                case 0:
                                                    // this comes from deviceHelpers.shouldAskForDevices in a round-about way
                                                    audioDevices = processedOptions.audioDevices;
                                                    videoDevices = processedOptions.videoDevices;
                                                    hasVideoFilter = !!properties.videoFilter;
                                                    if (hasVideoFilter) // We need to get the device now, before the filter is applied
                                                    // else the wrong device will be returned/nonsensical
                                                    currentDeviceId = getDeviceIdFromStream(stream, videoDevices);
                                                    _context11.next = 6;
                                                    return onStreamAvailable(stream);
                                                case 6:
                                                    if (!properties.publishVideo) _this._toggleVideo(properties.publishVideo);
                                                    if (!isScreenSharing && !isCustomVideoTrack // For filtered video, we stored the currentDeviceId already.
                                                     && !hasVideoFilter) {
                                                        currentDeviceId = getDeviceIdFromStream(stream, videoDevices);
                                                        if (properties.publishVideo) setCurrentTrackDeviceId(currentDeviceId);
                                                    }
                                                    return _context11.abrupt("return", bindVideo().catch((error)=>{
                                                        if (error instanceof CancellationError) // If we get a CancellationError, it means something newer tried
                                                        // to bindVideo before the old one succeeded, perhaps they called
                                                        // switchTracks.. It should be rare, and they shouldn't be doing
                                                        // this before loaded, but we'll handle it anyway.
                                                        return undefined;
                                                        throw error;
                                                    }).then(()=>{
                                                        onLoaded();
                                                        if (!state.isDestroyed()) {
                                                            _this.trigger('initSuccess');
                                                            _this.trigger('loaded', _this);
                                                        }
                                                    }, (err)=>{
                                                        logging.error(`OT.Publisher.publish failed to bind video: ${err}`);
                                                        onLoadFailure(err);
                                                    }));
                                                case 9:
                                                case "end":
                                                    return _context11.stop();
                                            }
                                        }, _callee11);
                                    }));
                                    return function(_x8) {
                                        return _ref21.apply(this, arguments);
                                    };
                                }());
                            });
                            return this;
                        };
                        this._setScalableValues = /*#__PURE__*/ function() {
                            var _ref22 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee12(scalableParam, scalableValues) {
                                var senders, sender, sendParameters;
                                return _regenerator.default.wrap(function _callee12$(_context12) {
                                    while(true)switch(_context12.prev = _context12.next){
                                        case 0:
                                            _context12.next = 2;
                                            return getAllPeerConnections().then((peerConnections)=>peerConnections[0].getSenders().filter((_ref23)=>{
                                                    let kind = _ref23.track.kind;
                                                    return kind === 'video';
                                                }));
                                        case 2:
                                            senders = _context12.sent;
                                            sender = senders[0];
                                            sendParameters = sender.getParameters();
                                            sendParameters.encodings.forEach((encoding, index)=>{
                                                encoding[scalableParam] = scalableValues[index]; // eslint-disable-line no-param-reassign
                                            });
                                            _context12.next = 8;
                                            return sender.setParameters(sendParameters);
                                        case 8:
                                        case "end":
                                            return _context12.stop();
                                    }
                                }, _callee12);
                            }));
                            return function(_x9, _x10) {
                                return _ref22.apply(this, arguments);
                            };
                        }();
                        this._setScalableFramerates = /*#__PURE__*/ function() {
                            var _ref24 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee13(frameRates) {
                                var framerateValues;
                                return _regenerator.default.wrap(function _callee13$(_context13) {
                                    while(true)switch(_context13.prev = _context13.next){
                                        case 0:
                                            framerateValues = normalizeScalableValues(frameRates);
                                            if (!(framerateValues && areValidFramerates(framerateValues))) {
                                                _context13.next = 4;
                                                break;
                                            }
                                            _context13.next = 4;
                                            return _this._setScalableValues('maxFramerate', framerateValues);
                                        case 4:
                                        case "end":
                                            return _context13.stop();
                                    }
                                }, _callee13);
                            }));
                            return function(_x11) {
                                return _ref24.apply(this, arguments);
                            };
                        }();
                        this._setScalableVideoLayers = /*#__PURE__*/ function() {
                            var _ref25 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee14(videoLayers) {
                                var videoLayerValues;
                                return _regenerator.default.wrap(function _callee14$(_context14) {
                                    while(true)switch(_context14.prev = _context14.next){
                                        case 0:
                                            videoLayerValues = normalizeScalableValues(videoLayers);
                                            if (!(videoLayerValues && areValidResolutionScales(videoLayerValues))) {
                                                _context14.next = 4;
                                                break;
                                            }
                                            _context14.next = 4;
                                            return _this._setScalableValues('scaleResolutionDownBy', videoLayerValues);
                                        case 4:
                                        case "end":
                                            return _context14.stop();
                                    }
                                }, _callee14);
                            }));
                            return function(_x12) {
                                return _ref25.apply(this, arguments);
                            };
                        }();
                        const areValidFramerates = (framerates)=>{
                            let previousFps = 0; // Only 15 and 30 fps are valid values and it cannot decrease when upscaling resolutions
                            return framerates.every((fps)=>{
                                if (fps !== 15 && fps !== 30 || fps < previousFps) return false;
                                previousFps = fps;
                                return true;
                            });
                        };
                        const areValidResolutionScales = (scales)=>{
                            // Maximum to downscale is 16 so previous scale should not be equal or greater to 17
                            let previousScale = 17;
                            return scales.every((scale)=>{
                                // Only downscale values; i.e. <= 1 means to upscale, which is not valid
                                if (scale < 1 || scale >= previousScale) return false;
                                previousScale = scale;
                                return true;
                            });
                        };
                        const normalizeScalableValues = (scalableValues)=>{
                            let normalizedValues; // API only accepts a colon separated value string
                            if (typeof scalableValues !== 'string') return normalizedValues;
                            const scalableValuesArr = scalableValues.split(':'); // It cannot be empty nor larger than 3 values (HD, VGA and QVGA)
                            if (scalableValuesArr.length === 0 || scalableValuesArr.length > 3) return normalizedValues;
                            if (!scalableValuesArr.every((value)=>!isNaN(value))) return normalizedValues;
                            normalizedValues = scalableValuesArr.map((value)=>parseInt(value, 10)).reverse();
                            return normalizedValues;
                        };
                        const haveWorkingTracks = (type)=>webRTCStream && webRTCStream[`get${capitalize(type)}Tracks`]().length > 0 && webRTCStream[`get${capitalize(type)}Tracks`]().every((track)=>track.readyState !== 'ended');
                        const updateAudio = (activeReason)=>{
                            const shouldSendAudio = haveWorkingTracks('audio') && properties.publishAudio;
                            if (chromeMixin) chromeMixin.setMuted(!shouldSendAudio);
                            if (microphone) microphone.muted(!shouldSendAudio);
                            if (_audioMediaProcessorConnector && _audioMediaProcessorConnector.originalTrack) _audioMediaProcessorConnector.originalTrack.enabled = shouldSendAudio;
                            refreshAudioVideoUI(activeReason);
                        };
                        /**
    * Starts publishing audio (if it is currently not being published)
    * when the <code>value</code> is <code>true</code>; stops publishing audio
    * (if it is currently being published) when the <code>value</code> is <code>false</code>.
    *
    * @param {Boolean} value Whether to start publishing audio (<code>true</code>)
    * or not (<code>false</code>).
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Stream.html#hasAudio">Stream.hasAudio</a>
    * @see StreamPropertyChangedEvent
    * @method #publishAudio
    * @memberOf Publisher
    */ this.publishAudio = (value)=>{
                            logAnalyticsEvent('publishAudio', 'Attempt', {
                                publishAudio: value
                            });
                            properties.publishAudio = value;
                            try {
                                updateAudio();
                                logAnalyticsEvent('publishAudio', 'Success', {
                                    publishAudio: value
                                });
                            } catch (e) {
                                logAnalyticsEvent('publishAudio', 'Failure', {
                                    message: e.message
                                });
                            }
                            return this;
                        };
                        /*
    * Starts publishing captions (if it is currently not being published)
    * when the <code>value</code> is <code>true</code>; stops publishing captions
    * (if it is currently being published) when the <code>value</code> is <code>false</code>.
    *
    * <p>
    * <i>Note:</i> No captions will be published if the publisher does not have an audio source.
    *
    * @param {Boolean} value Whether to start publishing captions (<code>true</code>)
    * or not (<code>false</code>).
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Subscriber.html#subscribToCaptions">subscribedToCaptions()</a>
    * @see <a href="Subscriber.html#isSubscribedToCaptions">isSubscribedToCaptions()</a>
    * @memberOf Publisher
    */ this.publishCaptions = (value)=>{
                            this.stream.setChannelActiveState('data', value);
                        };
                        let updateVideoSenderParametersSentinel; // keeps track of if the client has called mediaStreamTrack.stop(), so that we don't restart
                        // the camera if they then call publishVideo(true)
                        let isTrackManuallyStopped = false;
                        const updateVideo = ()=>{
                            const shouldSendVideo = haveWorkingTracks('video') && properties.publishVideo;
                            if (env.name === 'Chrome' && env.version >= 69) (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee15() {
                                var executionSentinel, peerConnections;
                                return _regenerator.default.wrap(function _callee15$(_context15) {
                                    while(true)switch(_context15.prev = _context15.next){
                                        case 0:
                                            if (updateVideoSenderParametersSentinel) updateVideoSenderParametersSentinel.cancel();
                                            updateVideoSenderParametersSentinel = new Cancellation();
                                            executionSentinel = updateVideoSenderParametersSentinel;
                                            _context15.next = 5;
                                            return getAllPeerConnections();
                                        case 5:
                                            peerConnections = _context15.sent;
                                            if (!executionSentinel.isCanceled()) // only proceed if we weren't canceled during the async operation above
                                            peerConnections.forEach((peerConnection)=>{
                                                setEncodersActiveState(peerConnection, shouldSendVideo);
                                            });
                                        case 7:
                                        case "end":
                                            return _context15.stop();
                                    }
                                }, _callee15);
                            }))();
                            if (isCustomVideoTrack && mediaProcessor) {
                                const originalTrack = mediaProcessor.getOriginalVideoTrack();
                                if (originalTrack) originalTrack.enabled = shouldSendVideo;
                            }
                            if (isCustomVideoTrack && _videoMediaProcessorConnector) {
                                const originalTrack = _videoMediaProcessorConnector.originalTrack;
                                if (originalTrack) originalTrack.enabled = shouldSendVideo;
                            }
                            if (webRTCStream) webRTCStream.getVideoTracks().forEach((track)=>{
                                track.enabled = shouldSendVideo; // eslint-disable-line no-param-reassign
                                if (track.isCreatedCanvas) // eslint-disable-next-line no-param-reassign
                                track.enabled = false;
                            });
                            refreshAudioVideoUI();
                        };
                        const destroyMediaProcessor = /*#__PURE__*/ function() {
                            var _ref27 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee16() {
                                var videoTrack;
                                return _regenerator.default.wrap(function _callee16$(_context16) {
                                    while(true)switch(_context16.prev = _context16.next){
                                        case 0:
                                            // We need to cache this since calling the method below will
                                            // clear this value.
                                            videoTrack = mediaProcessor.getOriginalVideoTrack(); // Note: this needs to be called before the `stop` method below.  Reversing
                                            // the order may cause race conditions with the MP worker.
                                            _context16.prev = 1;
                                            _context16.next = 4;
                                            return mediaProcessor.destroy();
                                        case 4:
                                            _context16.next = 9;
                                            break;
                                        case 6:
                                            _context16.prev = 6;
                                            _context16.t0 = _context16["catch"](1);
                                            logging.warn(`Error cleaning up mediaProcessor: ${_context16.t0}`);
                                        case 9:
                                            // Since no filtering is being applied, we perform some cleanup.  We
                                            // stop the original video track here since it's not being used
                                            // anymore -- this also turns off the camera LED
                                            videoTrack.stop();
                                        case 10:
                                        case "end":
                                            return _context16.stop();
                                    }
                                }, _callee16, null, [
                                    [
                                        1,
                                        6
                                    ]
                                ]);
                            }));
                            return function destroyMediaProcessor() {
                                return _ref27.apply(this, arguments);
                            };
                        }();
                        const hasTrackFromDevice = (deviceId)=>// or clearVideoFilter has already got the track from the currentDeviceId, thus we don't
                            // need to duplicate the track from the same device.
                            // This does not apply when a videoFilter or mediaProcessorConnector is set, since we could need to get a track from
                            // the same device.
                            !currentVideoFilter && !_videoMediaProcessorConnector && deviceId === getCurrentTrackDeviceId();
                        const isNewTrackNeeded = (shouldHaveVideo, deviceId)=>{
                            if (currentVideoFilter || _videoMediaProcessorConnector) // When videoFilter or mediaProcessorConnector is applied, we will get a new track always.
                            return true;
                            if (shouldHaveVideo) // When video enabled, we only get the track from a new device.
                            return currentDeviceId !== deviceId;
                             // When video disabled, we only get the canvasTrack if video was not muted previously,
                            // i.e. when deviceId is not undefined.
                            return deviceId !== undefined;
                        };
                        let currentDeviceId;
                        let currentVideoFilter;
                        this._toggleVideo = blockCallsUntilComplete(/*#__PURE__*/ function() {
                            var _ref28 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee17(shouldHaveVideo) {
                                var _vidDevices$find;
                                var _properties$videoDime, videoDimensions, vidDevices, oldTrack, oldTrackDeviceId, newTrack, videoFilter;
                                return _regenerator.default.wrap(function _callee17$(_context17) {
                                    while(true)switch(_context17.prev = _context17.next){
                                        case 0:
                                            if (!(isScreenSharing || isCustomVideoTrack || isTrackManuallyStopped)) {
                                                _context17.next = 2;
                                                break;
                                            }
                                            return _context17.abrupt("return");
                                        case 2:
                                            _properties$videoDime = properties.videoDimensions, videoDimensions = _properties$videoDime === void 0 ? getVideoDimensions() : _properties$videoDime;
                                            _context17.next = 5;
                                            return getVideoDevices();
                                        case 5:
                                            vidDevices = _context17.sent;
                                            oldTrack = getCurrentTrack();
                                            if (oldTrack) {
                                                _context17.next = 9;
                                                break;
                                            }
                                            throw otError(Errors.NOT_SUPPORTED, new Error('Publisher._toggleVideo cannot toggleVideo when you have no video source.'));
                                        case 9:
                                            // oldTrackDeviceId is undefined when it comes from a canvasTracks, i.e.: it is currently muted
                                            oldTrackDeviceId = (_vidDevices$find = vidDevices.find((device)=>device.label === oldTrack.label)) == null ? void 0 : _vidDevices$find.deviceId;
                                            if (isNewTrackNeeded(shouldHaveVideo, oldTrackDeviceId)) {
                                                _context17.next = 12;
                                                break;
                                            }
                                            return _context17.abrupt("return");
                                        case 12:
                                            if (!(oldTrack.readyState === 'ended')) {
                                                _context17.next = 15;
                                                break;
                                            }
                                            isTrackManuallyStopped = true;
                                            return _context17.abrupt("return");
                                        case 15:
                                            if (shouldHaveVideo && OTHelpers.env.isAndroid && OTHelpers.env.isChrome) // On Chrome on Android you need to stop the previous video track OPENTOK-37206
                                            {
                                                if (oldTrack && oldTrack.stop) oldTrack.stop();
                                            }
                                            if (shouldHaveVideo) {
                                                _context17.next = 32;
                                                break;
                                            }
                                            _context17.prev = 17;
                                            newTrack = createCanvasVideoTrack(videoDimensions);
                                            _context17.next = 24;
                                            break;
                                        case 21:
                                            _context17.prev = 21;
                                            _context17.t0 = _context17["catch"](17);
                                            return _context17.abrupt("return");
                                        case 24:
                                            if (oldTrackDeviceId) // store the current deviceId to reacquire the video later
                                            currentDeviceId = oldTrackDeviceId;
                                            setCurrentTrackDeviceId(newTrack.label);
                                            videoFilter = mediaProcessor.getVideoFilter();
                                            if (!videoFilter) {
                                                _context17.next = 31;
                                                break;
                                            }
                                            // Save the current video filter because we want to make sure it
                                            // gets enabled when the user publishes video again
                                            currentVideoFilter = videoFilter;
                                            _context17.next = 31;
                                            return destroyMediaProcessor();
                                        case 31:
                                            if (_videoMediaProcessorConnector) {
                                                _videoMediaProcessorConnector.destroy();
                                                _videoMediaProcessorConnector.stopOriginalTrack();
                                            }
                                        case 32:
                                            if (!(currentDeviceId && vidDevices.findIndex((device)=>device.deviceId === currentDeviceId) === -1)) {
                                                _context17.next = 34;
                                                break;
                                            }
                                            throw otError(Errors.NO_DEVICES_FOUND, new Error('Previous device no longer available - deviceId not found'));
                                        case 34:
                                            privateEvents.emit('streamDestroy');
                                            if (!shouldHaveVideo) {
                                                _context17.next = 63;
                                                break;
                                            }
                                            if (!hasTrackFromDevice(currentDeviceId)) {
                                                _context17.next = 38;
                                                break;
                                            }
                                            return _context17.abrupt("return");
                                        case 38:
                                            _context17.prev = 38;
                                            _context17.next = 41;
                                            return getTrackFromDeviceId(currentDeviceId);
                                        case 41:
                                            newTrack = _context17.sent;
                                            _context17.next = 48;
                                            break;
                                        case 44:
                                            _context17.prev = 44;
                                            _context17.t1 = _context17["catch"](38);
                                            logging.error(`Error getting new track for current device(${currentDeviceId}): ${_context17.t1}`);
                                            return _context17.abrupt("return");
                                        case 48:
                                            if (newTrack) {
                                                _context17.next = 51;
                                                break;
                                            }
                                            logging.error('Failed to enable video. It was not possible to get a new track from the camera');
                                            return _context17.abrupt("return");
                                        case 51:
                                            if (!currentVideoFilter) {
                                                _context17.next = 59;
                                                break;
                                            }
                                            _context17.next = 54;
                                            return mediaProcessor.setVideoFilter(currentVideoFilter);
                                        case 54:
                                            _context17.next = 56;
                                            return mediaProcessor.setMediaStream(webRTCStream);
                                        case 56:
                                            _context17.next = 58;
                                            return mediaProcessor.setVideoTrack(newTrack);
                                        case 58:
                                            newTrack = _context17.sent;
                                        case 59:
                                            if (!_videoMediaProcessorConnector) {
                                                _context17.next = 63;
                                                break;
                                            }
                                            _context17.next = 62;
                                            return _videoMediaProcessorConnector.setTrack(newTrack);
                                        case 62:
                                            newTrack = _context17.sent;
                                        case 63:
                                            _context17.prev = 63;
                                            _context17.next = 66;
                                            return replaceTrackAndUpdate(oldTrack, newTrack);
                                        case 66:
                                            _context17.next = 71;
                                            break;
                                        case 68:
                                            _context17.prev = 68;
                                            _context17.t2 = _context17["catch"](63);
                                            throw _context17.t2;
                                        case 71:
                                        case "end":
                                            return _context17.stop();
                                    }
                                }, _callee17, null, [
                                    [
                                        17,
                                        21
                                    ],
                                    [
                                        38,
                                        44
                                    ],
                                    [
                                        63,
                                        68
                                    ]
                                ]);
                            }));
                            return function(_x13) {
                                return _ref28.apply(this, arguments);
                            };
                        }());
                        /**
    * Toggles video on or off for the publisher. It causes the video to be published
    * (if it is currently not being published, the client is connected,
    * and the publisher is publishing) when the <code>value</code> is <code>true</code>;
    * it stops publishing video (if it is currently being published) when the <code>value</code>
    * is <code>false</code>.
    *
    * <p>
    * <i>Note:</i> The behavior of <code>publishVideo</code> varies depending on whether
    * the publisher is currently connected and publishing:
    * </p>
    *
    * <ul>
    * <li>Calling <code>publishVideo(true)</code> when the publisher is not connected to a session
    * causes the publisher to capture and render video locally, but it does not stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is not connected to a session
    * causes the publisher to stop capturing video locally. No video is streamed.</li>
    *
    * <li>Calling <code>publishVideo(true)</code> when the publisher is connected to a session
    * but not currently publishing causes it to capture and render video locally, but it does not stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is connected to a session
    * but not currently publishing causes the publisher to stop capturing video locally. No video is streamed.</li>
    *
    * <li>Calling <code>publishVideo(true)</code> when the publisher is both connected to a session
    * and currently publishing causes the publisher to capture and render video locally and to
    * stream video.</li>
    *
    * <li>Calling <code>publishVideo(false)</code> when the publisher is both connected to a session
    * and currently publishing causes the publisher to stop capturing video and to stream empty video frames.</li>
    * </ul>
    *
    * @param {Boolean} value Whether to start publishing video (<code>true</code>)
    * or not (<code>false</code>).
    *
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @see <a href="Stream.html#hasVideo">Stream.hasVideo</a>
    * @see StreamPropertyChangedEvent
    * @method #publishVideo
    * @memberOf Publisher
    */ this.publishVideo = (value)=>{
                            logAnalyticsEvent('publishVideo', 'Attempt', {
                                publishVideo: value
                            });
                            properties.publishVideo = value;
                            try {
                                this._toggleVideo(properties.publishVideo);
                                updateVideo();
                                logAnalyticsEvent('publishVideo', 'Success', {
                                    publishVideo: value
                                });
                            } catch (e) {
                                logAnalyticsEvent('publishVideo', 'Failure', {
                                    message: e.message
                                });
                            }
                            return this;
                        };
                        /**
    * Sets the content hint for the video track of the publisher's stream. This allows browsers
    * to use encoding or processing methods more appropriate to the type of content.
    * <p>
    * Use this method to change the video content hit dynamically. Set the initial video content
    * hit by setting the <code>videoContentHint</code> property of the options passed into the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.
    * <p>
    * Chrome 60+, Safari 12.1+, Edge 79+, and Opera 47+ support video content hints.
    *
    * @param {String} videoContentHint You can set this to one of the following values:
    *    <p>
    *    <ul>
    *      <li>
    *        <code>""</code> &mdash; No hint is provided.
    *      </li>
    *      <li>
    *        <code>"motion"</code> &mdash; The track should be treated as if it contains video
    *        where motion is important. For example, you may use this setting for a screen-sharing
    *        stream that contains video.
    *      </li>
    *      <li>
    *        <code>"detail"</code> &mdash; The track should be treated as if video details
    *        are extra important. For example, you may use this setting for a screen-sharing
    *        stream that contains text content, painting, or line art.
    *      </li>
    *      <li>
    *        <code>"text"</code> &mdash; The track should be treated as if text details are
    *        extra important. For example, you may use this setting for a screen-sharing
    *        stream that contains text content.
    *      </li>
    *    </ul>
    *
    * @see <a href="#getVideoContentHint">Publisher.getVideoContentHint()</a>
    * @see <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * @method #setVideoContentHint
    * @memberOf Publisher
    */ this.setVideoContentHint = (videoContentHint)=>setVideoContentHint(webRTCStream, videoContentHint);
                        /**
    * Returns the content hint for the video track.
    *
    * @return {String} One of the following values: <code>""</code>,
    *         <code>"motion"</code>, <code>"detail</code>, or <code>"text"</code>.
    * @see <a href="#setVideoContentHint">Publisher.setVideoContentHint()</a>
    * @method #getVideoContentHint
    * @memberOf Publisher
    */ this.getVideoContentHint = ()=>getVideoContentHint(webRTCStream);
                        /**
    * Deletes the Publisher object and removes it from the HTML DOM.
    * <p>
    * The Publisher object dispatches a <code>destroyed</code> event when the DOM
    * element is removed.
    * </p>
    * @method #destroy
    * @memberOf Publisher
    * @return {Publisher} The Publisher.
    */ this.destroy = function(/* unused */ reason, quiet) {
                            // @todo OPENTOK-36652 this.session should not be needed here
                            if (state.isAttemptingToPublish() && this.session) logConnectivityEvent('Cancel', {
                                reason: 'destroy'
                            });
                            if (state.isDestroyed()) return this;
                            state.set('Destroyed');
                            reset();
                            if (processedOptions) {
                                processedOptions.off();
                                processedOptions = null;
                            }
                            if (chromeMixin) {
                                chromeMixin.destroy();
                                chromeMixin = null;
                            }
                            if (privateEvents) {
                                privateEvents.off();
                                privateEvents = null;
                            }
                            if (quiet !== true) this.dispatchEvent(new Events.DestroyedEvent(eventNames.PUBLISHER_DESTROYED, this, reason));
                            this.off();
                            if (_videoMediaProcessorConnector) {
                                _videoMediaProcessorConnector.destroy();
                                _videoMediaProcessorConnector.stopOriginalTrack();
                            }
                            if (_audioMediaProcessorConnector) {
                                _audioMediaProcessorConnector.destroy();
                                _audioMediaProcessorConnector.stopOriginalTrack();
                            }
                            return this;
                        };
                        /*
    * @methodOf Publisher
    * @private
    */ this.disconnect = ()=>{
                            Object.keys(peerConnectionsAsync).forEach((peerConnectionId)=>{
                                const futurePeerConnection = getPeerConnectionById(peerConnectionId);
                                delete peerConnectionsAsync[peerConnectionId];
                                futurePeerConnection.then((peerConnection)=>this._removePeerConnection(peerConnection));
                            }); // In case the publisher is reused we need to clear the streamchannels
                            streamChannels.length = 0;
                        };
                        this.processMessage = (type, fromConnectionId, message)=>{
                            const subscriberId = get(message, 'params.subscriber', fromConnectionId).replace(/^INVALID-STREAM$/, fromConnectionId);
                            const peerId = get(message, 'content.peerId');
                            const sourceStreamId = get(message, 'content.sourceStreamId', 'MANTIS'); // Symphony will not have a subscriberId so we'll fallback to using the connectionId for it.
                            // Also fallback to the connectionId if it is equal to 'INVALID-STREAM' (See OPENTOK-30029).
                            const peerConnectionId = `${subscriberId}~${peerId}~${sourceStreamId}`;
                            logging.debug(`OT.Publisher.processMessage: Received ${type} from ${fromConnectionId} for ${peerConnectionId}`);
                            logging.debug(message);
                            const futurePeerConnection = getPeerConnectionById(peerConnectionId);
                            const addPeerConnection = ()=>{
                                const send = createSendMethod({
                                    socket: this.session._.getSocket(),
                                    uri: message.uri,
                                    content: {
                                        peerId: peerId,
                                        sourceStreamId: sourceStreamId
                                    }
                                });
                                const log = function log(action, variation, payload, logOptions, throttle) {
                                    if (logOptions === void 0) logOptions = {};
                                    const transformedOptions = (0, _extends2.default)({
                                        peerId: peerId,
                                        sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId)
                                    }, logOptions);
                                    return logAnalyticsEvent(action, variation, payload, transformedOptions, throttle);
                                };
                                const logQoS = (qos)=>{
                                    // We only log data from the active peer connection
                                    if (sourceStreamId !== activeSourceStreamId) return;
                                    recordQOS((0, _extends2.default)({}, qos, {
                                        peerId: peerId,
                                        remoteConnectionId: fromConnectionId,
                                        sourceStreamId: sourceStreamId
                                    }));
                                };
                                createPeerConnection({
                                    peerConnectionId: peerConnectionId,
                                    send: send,
                                    log: log,
                                    logQoS: logQoS,
                                    sourceStreamId: sourceStreamId
                                }).then((peerConnection)=>{
                                    setPeerConnectionMeta(peerConnection, {
                                        remoteConnectionId: fromConnectionId,
                                        remoteSubscriberId: subscriberId,
                                        peerId: peerId,
                                        sourceStreamId: sourceStreamId,
                                        peerConnectionId: peerConnectionId
                                    });
                                    peerConnection.processMessage(type, message); // Allow this runaway promise
                                    // http://bluebirdjs.com/docs/warning-explanations.html#warning-a-promise-was-created-in-a-handler-but-was-not-returned-from-it
                                    return null;
                                }).catch((err)=>{
                                    logging.error('OT.Publisher failed to create a peerConnection', err);
                                });
                            };
                            const isAdaptiveEnabled = this.session.sessionInfo.isAdaptiveEnabled;
                            switch(type){
                                case 'unsubscribe':
                                    this._removeSubscriber(subscriberId);
                                    break;
                                default:
                                    if (!futurePeerConnection) {
                                        if (isAdaptiveEnabled && getP2pPeerConnection()) // In the case Rumor sends two generateOffers for the P2P leg,
                                        // we need to ignore the second one.
                                        return;
                                        addPeerConnection();
                                    } else futurePeerConnection.then((peerConnection)=>peerConnection.processMessage(type, message));
                                    break;
                            }
                        };
                        /**
    * Returns the base-64-encoded string of PNG data representing the Publisher video.
    *
    *   <p>You can use the string as the value for a data URL scheme passed to the src parameter of
    *   an image file, as in the following:</p>
    *
    * <pre>
    *  var imgData = publisher.getImgData();
    *
    *  var img = document.createElement("img");
    *  img.setAttribute("src", "data:image/png;base64," + imgData);
    *  var imgWin = window.open("about:blank", "Screenshot");
    *  imgWin.document.write("&lt;body&gt;&lt;/body&gt;");
    *  imgWin.document.body.appendChild(img);
    * </pre>
    *
    * @method #getImgData
    * @memberOf Publisher
    * @return {String} The base-64 encoded string. Returns an empty string if there is no video.
    */ this.getImgData = function() {
                            if (!loaded) {
                                logging.error('OT.Publisher.getImgData: Cannot getImgData before the Publisher is publishing.');
                                return null;
                            }
                            const video = widgetView && widgetView.video();
                            return video ? video.imgData() : null;
                        };
                        const setNewStream = (newStream)=>{
                            cleanupLocalStream();
                            webRTCStream = newStream;
                            privateEvents.emit('streamChange');
                            microphone = new Microphone(webRTCStream, !properties.publishAudio);
                        };
                        const defaultReplaceTrackLogic = (peerConnection)=>{
                            peerConnection.getSenders().forEach((sender)=>{
                                if (sender.track.kind === 'audio' && webRTCStream.getAudioTracks().length) return sender.replaceTrack(webRTCStream.getAudioTracks()[0]);
                                else if (sender.track.kind === 'video' && webRTCStream.getVideoTracks().length) return sender.replaceTrack(webRTCStream.getVideoTracks()[0]);
                                return undefined;
                            });
                        };
                        const replaceTracks = function replaceTracks(replaceTrackLogic) {
                            if (replaceTrackLogic === void 0) replaceTrackLogic = defaultReplaceTrackLogic;
                            return getAllPeerConnections().then((peerConnections)=>{
                                const tasks = [];
                                peerConnections.map(replaceTrackLogic);
                                return Promise.all(tasks);
                            });
                        };
                        {
                            let videoIndex = 0;
                            const cycleVideo = /*#__PURE__*/ function() {
                                var _ref29 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee18() {
                                    var oldTrack, vidDevices, hasOtherVideoDevices, newVideoDevice, deviceId;
                                    return _regenerator.default.wrap(function _callee18$(_context18) {
                                        while(true)switch(_context18.prev = _context18.next){
                                            case 0:
                                                if (!(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function')) {
                                                    _context18.next = 2;
                                                    break;
                                                }
                                                throw otError(Errors.UNSUPPORTED_BROWSER, new Error('Publisher#cycleVideo is not supported in your browser.'), ExceptionCodes.UNABLE_TO_PUBLISH);
                                            case 2:
                                                if (!(isCustomVideoTrack || isScreenSharing)) {
                                                    _context18.next = 4;
                                                    break;
                                                }
                                                throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#cycleVideo: The publisher is not using a camera video source'));
                                            case 4:
                                                oldTrack = getCurrentTrack();
                                                if (oldTrack) {
                                                    _context18.next = 7;
                                                    break;
                                                }
                                                throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#cycleVideo cannot cycleVideo when you have no video source.'));
                                            case 7:
                                                videoIndex += 1;
                                                _context18.next = 10;
                                                return getVideoDevices();
                                            case 10:
                                                vidDevices = _context18.sent;
                                                // different devices return the cameras in different orders
                                                hasOtherVideoDevices = vidDevices.filter((device)=>device.deviceId !== currentDeviceId).length > 0;
                                                if (hasOtherVideoDevices) {
                                                    _context18.next = 14;
                                                    break;
                                                }
                                                return _context18.abrupt("return", currentDeviceId);
                                            case 14:
                                                while(vidDevices[videoIndex % vidDevices.length].deviceId === currentDeviceId)videoIndex += 1;
                                                privateEvents.emit('streamDestroy');
                                                newVideoDevice = vidDevices[videoIndex % vidDevices.length];
                                                deviceId = newVideoDevice.deviceId;
                                                _context18.next = 20;
                                                return attemptToSetVideoTrack(deviceId);
                                            case 20:
                                                return _context18.abrupt("return", currentDeviceId);
                                            case 21:
                                            case "end":
                                                return _context18.stop();
                                        }
                                    }, _callee18);
                                }));
                                return function cycleVideo() {
                                    return _ref29.apply(this, arguments);
                                };
                            }();
                            /**
      * Switches the video input source used by the publisher to the next one in the list
      * of available devices.
      * <p>
      * This will result in an error (the Promise returned by the method is rejected) in the
      * following conditions:
      * <ul>
      *   <li>
      *     The user denied access to the video input device.
      *   </li>
      *   <li>
      *     The publisher is not using a camera video source. (The <code>videoSource</code>
      *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
      *     set to <code>null</code>, <code>false</code>, a MediaStreamTrack object, or
      *     <code>"screen"</code>).
      *   </li>
      *   <li>
      *     There are no video input devices (cameras) available.
      *   </li>
      *   <li>
      *     There was an error acquiring video from the video input device.
      *   </li>
      *  </ul>
      * </p>
      *
      * @method #cycleVideo
      * @memberOf Publisher
      *
      * @return {Promise} A promise that resolves when the operation completes
      * successfully. The promise resolves with an object that has a
      * <code>deviceId</code> property set to the device ID of the camera used:
      *
      * <pre>
      *   publisher.cycleVideo().then(console.log);
      *   // Output: {deviceId: "967a86e52..."}
      * </pre>
      *
      * If there is an error, the promise is rejected.
      *
      * @see <a href="#setVideoSource">Publisher.setVideoSource()</a>
      */ this.cycleVideo = blockCallsUntilComplete(/*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee19() {
                                var deviceId;
                                return _regenerator.default.wrap(function _callee19$(_context19) {
                                    while(true)switch(_context19.prev = _context19.next){
                                        case 0:
                                            _context19.prev = 0;
                                            _context19.next = 3;
                                            return cycleVideo();
                                        case 3:
                                            deviceId = _context19.sent;
                                            _context19.next = 10;
                                            break;
                                        case 6:
                                            _context19.prev = 6;
                                            _context19.t0 = _context19["catch"](0);
                                            logging.error(`Publisher#cycleVideo: could not cycle video: ${_context19.t0}`);
                                            throw _context19.t0;
                                        case 10:
                                            return _context19.abrupt("return", {
                                                deviceId: deviceId
                                            });
                                        case 11:
                                        case "end":
                                            return _context19.stop();
                                    }
                                }, _callee19, null, [
                                    [
                                        0,
                                        6
                                    ]
                                ]);
                            })));
                        }
                        const replaceTrackAndUpdate = /*#__PURE__*/ function() {
                            var _ref31 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee21(oldTrack, newTrack) {
                                var pcs, isNewTrackFiltered, video;
                                return _regenerator.default.wrap(function _callee21$(_context21) {
                                    while(true)switch(_context21.prev = _context21.next){
                                        case 0:
                                            _context21.next = 2;
                                            return getAllPeerConnections();
                                        case 2:
                                            pcs = _context21.sent;
                                            _context21.next = 5;
                                            return Promise.all(pcs.map(/*#__PURE__*/ function() {
                                                var _ref32 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee20(pc) {
                                                    return _regenerator.default.wrap(function _callee20$(_context20) {
                                                        while(true)switch(_context20.prev = _context20.next){
                                                            case 0:
                                                                _context20.next = 2;
                                                                return pc.findAndReplaceTrack(oldTrack, newTrack);
                                                            case 2:
                                                                pc.setP2PMaxBitrate();
                                                            case 3:
                                                            case "end":
                                                                return _context20.stop();
                                                        }
                                                    }, _callee20);
                                                }));
                                                return function(_x16) {
                                                    return _ref32.apply(this, arguments);
                                                };
                                            }()));
                                        case 5:
                                            webRTCStream.removeTrack(oldTrack);
                                            webRTCStream.addTrack(newTrack);
                                            if (oldTrack && oldTrack.stop) {
                                                // We "try" since this expression will throw in browsers that don't
                                                // support this API.
                                                try {
                                                    isNewTrackFiltered = newTrack instanceof MediaStreamTrackGenerator || // Check prototype string too since instanceof is false in an iframe
                                                    Object.getPrototypeOf(newTrack).toString().includes('MediaStreamTrackGenerator');
                                                } catch (err) {
                                                    isNewTrackFiltered = false;
                                                } // The oldTrack is being used as input by the MediaProcessor, so stopping
                                                // it will stop the newTrack as well.
                                                if (!isNewTrackFiltered) oldTrack.stop();
                                            }
                                            if (OTHelpers.env.name === 'Firefox' || OTHelpers.env.name === 'Safari') {
                                                // Local video freezes on old stream without this for some reason
                                                _this.videoElement().srcObject = null;
                                                _this.videoElement().srcObject = webRTCStream;
                                            }
                                            video = widgetView && widgetView.video();
                                            if (video) video.refreshTracks();
                                            privateEvents.emit('streamChange');
                                            updateVideo();
                                        case 13:
                                        case "end":
                                            return _context21.stop();
                                    }
                                }, _callee21);
                            }));
                            return function replaceTrackAndUpdate(_x14, _x15) {
                                return _ref31.apply(this, arguments);
                            };
                        }();
                        const getTrackFromDeviceId = /*#__PURE__*/ function() {
                            var _ref33 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee22(deviceId) {
                                var _newVideoStream;
                                var oldTrackDeviceId, newOptions, _processedOptions2, getUserMediaHelper, newVideoStream, _newVideoStream$getVi, track;
                                return _regenerator.default.wrap(function _callee22$(_context22) {
                                    while(true)switch(_context22.prev = _context22.next){
                                        case 0:
                                            oldTrackDeviceId = getCurrentTrackDeviceId();
                                            setCurrentTrackDeviceId(deviceId);
                                            newOptions = cloneDeep(options);
                                            newOptions.audioSource = null;
                                            newOptions.videoSource = deviceId;
                                            processedOptions = processPubOptions(newOptions, 'OT.Publisher.getTrackFromDeviceId', ()=>state && state.isDestroyed());
                                            processedOptions.on({
                                                accessDialogOpened: onAccessDialogOpened,
                                                accessDialogClosed: onAccessDialogClosed
                                            });
                                            _processedOptions2 = processedOptions, getUserMediaHelper = _processedOptions2.getUserMedia;
                                            _context22.prev = 8;
                                            _context22.next = 11;
                                            return getUserMediaHelper();
                                        case 11:
                                            newVideoStream = _context22.sent;
                                            _context22.next = 17;
                                            break;
                                        case 14:
                                            _context22.prev = 14;
                                            _context22.t0 = _context22["catch"](8);
                                            logging.error(_context22.t0); // TODO We may want to consider bubbling up the err here
                                        case 17:
                                            _newVideoStream$getVi = (_newVideoStream = newVideoStream) == null ? void 0 : _newVideoStream.getVideoTracks(), track = _newVideoStream$getVi[0];
                                            if (!track) setCurrentTrackDeviceId(oldTrackDeviceId);
                                            return _context22.abrupt("return", track);
                                        case 20:
                                        case "end":
                                            return _context22.stop();
                                    }
                                }, _callee22, null, [
                                    [
                                        8,
                                        14
                                    ]
                                ]);
                            }));
                            return function getTrackFromDeviceId(_x17) {
                                return _ref33.apply(this, arguments);
                            };
                        }();
                        const getCurrentTrack = ()=>{
                            const _webRTCStream$getVide = webRTCStream.getVideoTracks(), currentTrack = _webRTCStream$getVide[0];
                            return currentTrack;
                        };
                        const getCurrentTrackDeviceId = ()=>_currentTrackDeviceId; // _currentTrackDeviceId is the id of the device of the track already in use or being acquired
                        // by getTrackFromDeviceId. Please note this is preventing to getTrackFromDeviceId twice from
                        // the same device. Please see hasTrackFromDevice and getTrackFromDeviceId for more context.
                        const setCurrentTrackDeviceId = (deviceId)=>{
                            _currentTrackDeviceId = deviceId;
                        };
                        const getVideoDevices = /*#__PURE__*/ function() {
                            var _ref34 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee23() {
                                var devices, vidDevices;
                                return _regenerator.default.wrap(function _callee23$(_context23) {
                                    while(true)switch(_context23.prev = _context23.next){
                                        case 0:
                                            _context23.next = 2;
                                            return deviceHelpers.shouldAskForDevices();
                                        case 2:
                                            devices = _context23.sent;
                                            vidDevices = devices.videoDevices;
                                            if (!(!devices.video || !vidDevices || !vidDevices.length)) {
                                                _context23.next = 6;
                                                break;
                                            }
                                            throw otError(Errors.NO_DEVICES_FOUND, new Error('No video devices available'), ExceptionCodes.UNABLE_TO_PUBLISH);
                                        case 6:
                                            return _context23.abrupt("return", vidDevices);
                                        case 7:
                                        case "end":
                                            return _context23.stop();
                                    }
                                }, _callee23);
                            }));
                            return function getVideoDevices() {
                                return _ref34.apply(this, arguments);
                            };
                        }();
                        const replaceAudioTrack = /*#__PURE__*/ function() {
                            var _ref35 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee24(oldTrack, newTrack) {
                                var pcs, video, isFilteredTrack;
                                return _regenerator.default.wrap(function _callee24$(_context24) {
                                    while(true)switch(_context24.prev = _context24.next){
                                        case 0:
                                            _context24.next = 2;
                                            return getAllPeerConnections();
                                        case 2:
                                            pcs = _context24.sent;
                                            _context24.next = 5;
                                            return Promise.all(pcs.map((pc)=>pc.findAndReplaceTrack(oldTrack, newTrack)));
                                        case 5:
                                            if (newTrack) webRTCStream.addTrack(newTrack);
                                            if (oldTrack) webRTCStream.removeTrack(oldTrack);
                                            video = widgetView && widgetView.video();
                                            if (video) video.refreshTracks();
                                            if (chromeMixin) {
                                                if (newTrack && !oldTrack) chromeMixin.addAudioTrack();
                                                if (oldTrack && !newTrack) chromeMixin.removeAudioTrack();
                                            }
                                            // We "try" since this expression will throw in browsers that don't
                                            // support this API.
                                            try {
                                                isFilteredTrack = newTrack instanceof MediaStreamTrackGenerator // Check prototype string too since instanceof is false in an iframe
                                                 || Object.getPrototypeOf(newTrack).toString().includes('MediaStreamTrackGenerator');
                                            } catch (e) {
                                                isFilteredTrack = false;
                                            }
                                            if (oldTrack && oldTrack.stop && !isFilteredTrack) oldTrack.stop();
                                            if (newTrack) {
                                                // Turn the audio back on if the audio track stopped because it was disconnected
                                                updateAudio();
                                                microphone = new Microphone(webRTCStream, !properties.publishAudio);
                                            }
                                            privateEvents.emit('streamChange');
                                            refreshAudioVideoUI();
                                        case 15:
                                        case "end":
                                            return _context24.stop();
                                    }
                                }, _callee24);
                            }));
                            return function replaceAudioTrack(_x18, _x19) {
                                return _ref35.apply(this, arguments);
                            };
                        }();
                        const resetAudioSource = /*#__PURE__*/ function() {
                            var _ref36 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee25(audioTrack) {
                                var audioDeviceId, newAudioTrack;
                                return _regenerator.default.wrap(function _callee25$(_context25) {
                                    while(true)switch(_context25.prev = _context25.next){
                                        case 0:
                                            audioDeviceId = audioTrack.getSettings().deviceId;
                                            _context25.prev = 1;
                                            _context25.next = 4;
                                            return _this.setAudioSource(audioDeviceId);
                                        case 4:
                                            // We need to add the onmute listener to the new audio track.
                                            newAudioTrack = webRTCStream.getAudioTracks()[0];
                                            if (newAudioTrack) {
                                                newAudioTrack.onmute = ()=>handleBuggedMutedLocalAudioTrack(newAudioTrack);
                                                newAudioTrack.onunmute = ()=>handleBuggedUnMutedLocalAudioTrack(newAudioTrack);
                                            }
                                            _context25.next = 11;
                                            break;
                                        case 8:
                                            _context25.prev = 8;
                                            _context25.t0 = _context25["catch"](1);
                                            logging.error(_context25.t0);
                                        case 11:
                                        case "end":
                                            return _context25.stop();
                                    }
                                }, _callee25, null, [
                                    [
                                        1,
                                        8
                                    ]
                                ]);
                            }));
                            return function resetAudioSource(_x20) {
                                return _ref36.apply(this, arguments);
                            };
                        }(); // this should be called when we detect a mute event from a bugged device
                        const handleBuggedMutedLocalAudioTrack = (audioTrack)=>{
                            let shouldRePublishVideo = false;
                            if (properties.publishVideo && document.hidden) {
                                shouldRePublishVideo = true; // turning the video off to prevent that videotrack is ended
                                this.publishVideo(false);
                            } // trigger the handler onVisibilityChange
                            const visibilityHandler = /*#__PURE__*/ function() {
                                var _ref37 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee26() {
                                    return _regenerator.default.wrap(function _callee26$(_context26) {
                                        while(true)switch(_context26.prev = _context26.next){
                                            case 0:
                                                if (document.hidden) {
                                                    _context26.next = 5;
                                                    break;
                                                }
                                                _context26.next = 3;
                                                return resetAudioSource(audioTrack);
                                            case 3:
                                                if (shouldRePublishVideo) _this.publishVideo(true);
                                                document.removeEventListener('visibilitychange', visibilityHandler);
                                            case 5:
                                            case "end":
                                                return _context26.stop();
                                        }
                                    }, _callee26);
                                }));
                                return function visibilityHandler() {
                                    return _ref37.apply(this, arguments);
                                };
                            }();
                            document.addEventListener('visibilitychange', visibilityHandler);
                        };
                        const handleBuggedUnMutedLocalAudioTrack = (audioTrack)=>{
                            if (hasAudio()) {
                                if (!hasVideo()) // We only need to reset the audio source when the publisher is audio only.
                                resetAudioSource(audioTrack);
                                else // Inconsistenly the publisher shows a black frame after the incoming call with compact UI
                                // ends. In order to unblock the video element we added this hack that needs to be
                                // revisited.
                                // We need to call pause and play again, and since we have a listener on the onpause event
                                // that internally calls the play function, we only need to call pause(),
                                // and the play will be automatically executed.
                                this.videoElement().pause();
                            }
                            this.session.trigger('gsmCallEnded');
                        };
                        /**
    * Switches the audio input source used by the publisher. You can set the
    * <code>audioSource</code> to a device ID (string) or audio MediaStreamTrack object.
    * <p>
    * This will result in an error (the Promise returned by the method is rejected) in the
    * following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method. This method is not supported in
    *     Internet Explorer or non-Chromium versions of Edge (older than version 79).
    *   </li>
    *   <li>
    *     The publisher was not initiated with an audio source. (The <code>audioSource</code>
    *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
    *     set to <code>null</code> or <code>false</code>).
    *   </li>
    *   <li>
    *     The user denied access to the audio input device.
    *   </li>
    *   <li>
    *     There was an error acquiring audio from the audio input device or MediaStreamTrack
    *     object.
    *   </li>
    *   <li>
    *     The <code>audioSource</code> value is not a string or MediaStreamTrack object.
    *   </li>
    *   <li>
    *     The <code>audioSource</code> string is not a valid audio input device available
    *     to the browser.
    *   </li>
    *  </ul>
    * </p>
    *
    * @param {Object} audioSource The device ID (string) of an audio input device, or an audio
    * MediaStreamTrack object.
    *
    * @method #setAudioSource
    * @memberOf Publisher
    *
    * @see <a href="#getAudioSource">Publisher.getAudioSource()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */ const isSetAudioSourceSupported = !(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function');
                        const setAudioSourceNotSupportedError = ()=>otError(Errors.UNSUPPORTED_BROWSER, new Error('Publisher#setAudioSource is not supported in your browser.'));
                        const setAudioSourceCancellationError = ()=>otError(Errors.CANCEL, new Error('Operation did not succeed due to a new request.'));
                        let cancelPreviousSetAudioSourceSentinel;
                        const getSetAudioSourceCancellationSentinel = ()=>{
                            if (cancelPreviousSetAudioSourceSentinel) cancelPreviousSetAudioSourceSentinel.cancel();
                            cancelPreviousSetAudioSourceSentinel = new Cancellation();
                            return cancelPreviousSetAudioSourceSentinel;
                        };
                        const setAudioSource = /*#__PURE__*/ function() {
                            var _ref38 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee27(audioSource) {
                                var currentCancelSentinel, setStreamIfNotCancelled, prevAudioSource, newTrack, newOptions, prevLabel, prevDeviceId, _processedOptions3, getUserMediaHelper, prevOptions, previousDevice, stream;
                                return _regenerator.default.wrap(function _callee27$(_context27) {
                                    while(true)switch(_context27.prev = _context27.next){
                                        case 0:
                                            if (isSetAudioSourceSupported) {
                                                _context27.next = 2;
                                                break;
                                            }
                                            throw setAudioSourceNotSupportedError();
                                        case 2:
                                            currentCancelSentinel = getSetAudioSourceCancellationSentinel();
                                            setStreamIfNotCancelled = (stream)=>{
                                                if (currentCancelSentinel.isCanceled()) {
                                                    stream.getTracks((track)=>track.stop());
                                                    throw setAudioSourceCancellationError();
                                                }
                                                return setAudioSource(stream.getAudioTracks()[0]);
                                            };
                                            prevAudioSource = _this.getAudioSource();
                                            if (prevAudioSource) {
                                                _context27.next = 7;
                                                break;
                                            }
                                            throw otError(Errors.NOT_SUPPORTED, new Error('Publisher#setAudioSource cannot add an audio source when you started without one.'));
                                        case 7:
                                            if (!(audioSource instanceof MediaStreamTrack)) {
                                                _context27.next = 26;
                                                break;
                                            }
                                            if (!currentCancelSentinel.isCanceled()) {
                                                _context27.next = 10;
                                                break;
                                            }
                                            throw setAudioSourceCancellationError();
                                        case 10:
                                            if (!_audioMediaProcessorConnector) {
                                                _context27.next = 23;
                                                break;
                                            }
                                            _context27.prev = 11;
                                            _context27.next = 14;
                                            return _audioMediaProcessorConnector.setTrack(audioSource);
                                        case 14:
                                            newTrack = _context27.sent;
                                            _context27.next = 17;
                                            return replaceAudioTrack(prevAudioSource, newTrack);
                                        case 17:
                                            return _context27.abrupt("return", _context27.sent);
                                        case 20:
                                            _context27.prev = 20;
                                            _context27.t0 = _context27["catch"](11);
                                            logging.error(`Error setting track on audioMediaProcessorConnector: ${_context27.t0}`);
                                        case 23:
                                            return _context27.abrupt("return", replaceAudioTrack(prevAudioSource, audioSource));
                                        case 26:
                                            if (!(typeof audioSource === 'string')) {
                                                _context27.next = 73;
                                                break;
                                            }
                                            // Must be a deviceId, call getUserMedia and get the MediaStreamTrack
                                            newOptions = cloneDeep(options);
                                            newOptions.audioSource = audioSource;
                                            newOptions.videoSource = null;
                                            processedOptions = processPubOptions(newOptions, 'OT.Publisher.setAudioSource', ()=>currentCancelSentinel.isCanceled() || state && state.isDestroyed());
                                            processedOptions.on({
                                                accessDialogOpened: onAccessDialogOpened,
                                                accessDialogClosed: onAccessDialogClosed
                                            });
                                            prevLabel = prevAudioSource.label;
                                            prevDeviceId = prevAudioSource.getConstraints && prevAudioSource.getSettings().deviceId || undefined; // In firefox we have to stop the previous track before we get a new one
                                            if (prevAudioSource) prevAudioSource.stop();
                                            _processedOptions3 = processedOptions, getUserMediaHelper = _processedOptions3.getUserMedia;
                                            _context27.prev = 36;
                                            _context27.t1 = setStreamIfNotCancelled;
                                            _context27.next = 40;
                                            return getUserMediaHelper();
                                        case 40:
                                            _context27.t2 = _context27.sent;
                                            _context27.next = 43;
                                            return (0, _context27.t1)(_context27.t2);
                                        case 43:
                                            return _context27.abrupt("return", _context27.sent);
                                        case 46:
                                            _context27.prev = 46;
                                            _context27.t3 = _context27["catch"](36);
                                            if (!currentCancelSentinel.isCanceled()) {
                                                _context27.next = 50;
                                                break;
                                            }
                                            throw setAudioSourceCancellationError();
                                        case 50:
                                            prevOptions = cloneDeep(options);
                                            prevOptions.videoSource = null;
                                            prevOptions.audioSource = prevDeviceId;
                                            if (!(!prevOptions.audioSource && prevLabel)) {
                                                _context27.next = 60;
                                                break;
                                            }
                                            _context27.next = 56;
                                            return getInputMediaDevices();
                                        case 56:
                                            previousDevice = _context27.sent.find((x)=>x.label === prevLabel);
                                            if (!currentCancelSentinel.isCanceled()) {
                                                _context27.next = 59;
                                                break;
                                            }
                                            throw setAudioSourceCancellationError();
                                        case 59:
                                            if (previousDevice) prevOptions.audioSource = previousDevice.deviceId;
                                        case 60:
                                            if (prevOptions.audioSource) {
                                                _context27.next = 63;
                                                break;
                                            }
                                            _context27.t3.message += ' (could not determine previous audio device)';
                                            throw otError(Errors.NOT_FOUND, _context27.t3);
                                        case 63:
                                            processedOptions = processPubOptions(prevOptions, 'OT.Publisher.setAudioSource', ()=>currentCancelSentinel.isCanceled() || state && state.isDestroyed());
                                            _context27.next = 66;
                                            return processedOptions.getUserMedia().catch((error)=>{
                                                // eslint-disable-next-line no-param-reassign
                                                error.message += ' (could not obtain previous audio device)';
                                                throw error;
                                            });
                                        case 66:
                                            stream = _context27.sent;
                                            _context27.next = 69;
                                            return setStreamIfNotCancelled(stream);
                                        case 69:
                                            _context27.t3.message += ' (reverted to previous audio device)';
                                            throw _context27.t3;
                                        case 71:
                                            _context27.next = 74;
                                            break;
                                        case 73:
                                            throw otError(Errors.INVALID_PARAMETER, new Error('Invalid parameter passed to OT.Publisher.setAudioSource(). Expected string or MediaStreamTrack.'));
                                        case 74:
                                        case "end":
                                            return _context27.stop();
                                    }
                                }, _callee27, null, [
                                    [
                                        11,
                                        20
                                    ],
                                    [
                                        36,
                                        46
                                    ]
                                ]);
                            }));
                            return function setAudioSource(_x21) {
                                return _ref38.apply(this, arguments);
                            };
                        }();
                        this.setAudioSource = setAudioSource;
                        /**
    * Returns the MediaStreamTrack object used as the audio input source for the publisher.
    * If the publisher does not have an audio source, this method returns null.
    *
    * @method #getAudioSource
    * @memberOf Publisher
    * @see <a href="#setAudioSource">Publisher.setAudioSource()</a>
    *
    * @return {MediaStreamTrack} The audio source for the publisher (or null, if there is none).
    */ this.getAudioSource = ()=>{
                            if (webRTCStream && webRTCStream.getAudioTracks().length > 0) return webRTCStream.getAudioTracks()[0];
                            return null;
                        };
                        /**
     * This method sets the video source for a publisher that is using a camera.
     * Pass in the device ID of the new video source.
     *
     * <p>
     * The following will result in errors:
     *
     * <ul>
     * <li>If the <code>videoSourceId</code> parameter is not a string
     * or the device ID for a valid video input device, the promise
     * will reject with an error with the <code>name</code> property
     * set to <code>'OT_INVALID_VIDEO_SOURCE'</code>.
     * </li>
     *
     * <li>If the publisher does not currently use a camera input, the promise
     * will reject with an error with the <code>name</code> property
     * set to <code>'OT_SET_VIDEO_SOURCE_FAILURE'</code>.
     * </li>
     * </ul>
     *
     * @param {String} videoSourceId The device ID of a video input (camera) device.
     * @method #setVideoSource
     * @memberOf Publisher
     *
     * @see <a href="OT.html#getDevices">OT.getDevices()</a>
     * @see <a href="#getVideoSource">Publisher.getVideoSource()</a>
     * @see <a href="#cycleVideo">Publisher.cycleVideo()</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. If there is an error, the promise is rejected.
     */ const setVideoSource = /*#__PURE__*/ function() {
                            var _setVideoSource = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee28(videoSourceId) {
                                var invalidVideoSourceOtError, setVideoSourceOtError, isAudioOnly, deviceList, isValidVideoDeviceId;
                                return _regenerator.default.wrap(function _callee28$(_context28) {
                                    while(true)switch(_context28.prev = _context28.next){
                                        case 0:
                                            invalidVideoSourceOtError = otError(Errors.INVALID_VIDEO_SOURCE, new Error('Invalid video source. Video source must be a valid video input deviceId'), 1041);
                                            setVideoSourceOtError = otError(Errors.SET_VIDEO_SOURCE_FAILURE, new Error('You cannot reset the video source on a publisher that does not currently use a camera source.'), 1040);
                                            if (!(OTHelpers.env.isLegacyEdge || !windowMock.RTCRtpSender || typeof windowMock.RTCRtpSender.prototype.replaceTrack !== 'function')) {
                                                _context28.next = 4;
                                                break;
                                            }
                                            throw otError(Errors.UNSUPPORTED_BROWSER, new Error('setVideoSource is not supported in your browser.'), ExceptionCodes.UNABLE_TO_PUBLISH);
                                        case 4:
                                            if (!(typeof videoSourceId !== 'string')) {
                                                _context28.next = 6;
                                                break;
                                            }
                                            throw invalidVideoSourceOtError;
                                        case 6:
                                            // we can't use hasVideo because that only checks if the video is
                                            isAudioOnly = !webRTCStream || webRTCStream.getVideoTracks().length === 0;
                                            if (!(isCustomVideoTrack || isScreenSharing || isAudioOnly)) {
                                                _context28.next = 9;
                                                break;
                                            }
                                            throw setVideoSourceOtError;
                                        case 9:
                                            _context28.next = 11;
                                            return getInputMediaDevices();
                                        case 11:
                                            deviceList = _context28.sent;
                                            isValidVideoDeviceId = deviceList.find((device)=>device.kind === 'videoInput' && device.deviceId === videoSourceId);
                                            if (isValidVideoDeviceId) {
                                                _context28.next = 15;
                                                break;
                                            }
                                            throw invalidVideoSourceOtError;
                                        case 15:
                                            _context28.next = 17;
                                            return attemptToSetVideoTrack(videoSourceId);
                                        case 17:
                                        case "end":
                                            return _context28.stop();
                                    }
                                }, _callee28);
                            }));
                            function setVideoSource(_x22) {
                                return _setVideoSource.apply(this, arguments);
                            }
                            return setVideoSource;
                        }();
                        this.setVideoSource = setVideoSource;
                        const attemptToSetVideoTrack = /*#__PURE__*/ function() {
                            var _ref39 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee29(newVideoDeviceId) {
                                var oldDeviceID, oldTrack, newVideoTrack;
                                return _regenerator.default.wrap(function _callee29$(_context29) {
                                    while(true)switch(_context29.prev = _context29.next){
                                        case 0:
                                            oldDeviceID = currentDeviceId;
                                            currentDeviceId = newVideoDeviceId; // We shouldn't replace the track unless the video is on
                                            if (properties.publishVideo) {
                                                _context29.next = 4;
                                                break;
                                            }
                                            return _context29.abrupt("return");
                                        case 4:
                                            oldTrack = getCurrentTrack();
                                            if (properties.publishVideo && OTHelpers.env.isAndroid && (OTHelpers.env.isChrome || OTHelpers.env.isFirefox)) // On Chrome on Android you need to stop the previous video track OPENTOK-37206
                                            // In case we are not publishing video, we don't need to stop the oldTrack since
                                            // there isn't going to be a new track, once we publish video again, the oldTrack
                                            // will be properly stopped in _toggleVideo
                                            {
                                                if (oldTrack && oldTrack.stop) oldTrack.stop();
                                            }
                                            if (!hasTrackFromDevice(newVideoDeviceId)) {
                                                _context29.next = 8;
                                                break;
                                            }
                                            return _context29.abrupt("return");
                                        case 8:
                                            _context29.prev = 8;
                                            _context29.next = 11;
                                            return getTrackFromDeviceId(newVideoDeviceId);
                                        case 11:
                                            newVideoTrack = _context29.sent;
                                            _context29.next = 19;
                                            break;
                                        case 14:
                                            _context29.prev = 14;
                                            _context29.t0 = _context29["catch"](8);
                                            currentDeviceId = oldDeviceID;
                                            logging.error(_context29.t0);
                                            return _context29.abrupt("return");
                                        case 19:
                                            if (newVideoTrack) {
                                                _context29.next = 22;
                                                break;
                                            }
                                            logging.warn('Unable to aquire video track. Moving to next device.');
                                            return _context29.abrupt("return");
                                        case 22:
                                            if (!currentVideoFilter) {
                                                _context29.next = 26;
                                                break;
                                            }
                                            _context29.next = 25;
                                            return mediaProcessor.setVideoTrack(newVideoTrack);
                                        case 25:
                                            newVideoTrack = _context29.sent;
                                        case 26:
                                            if (!_videoMediaProcessorConnector) {
                                                _context29.next = 30;
                                                break;
                                            }
                                            _context29.next = 29;
                                            return _videoMediaProcessorConnector.setTrack(newVideoTrack);
                                        case 29:
                                            newVideoTrack = _context29.sent;
                                        case 30:
                                            _context29.next = 32;
                                            return replaceTrackAndUpdate(oldTrack, newVideoTrack);
                                        case 32:
                                            if (properties.publishVideo) isTrackManuallyStopped = false;
                                        case 33:
                                        case "end":
                                            return _context29.stop();
                                    }
                                }, _callee29, null, [
                                    [
                                        8,
                                        14
                                    ]
                                ]);
                            }));
                            return function attemptToSetVideoTrack(_x23) {
                                return _ref39.apply(this, arguments);
                            };
                        }();
                        /**
    * Returns an object containing properties defining the publisher's current
    * video source.
    *
    * @method #getVideoSource
    * @memberOf Publisher
    * @see <a href="#setVideoSource">Publisher.setVideoSource()</a>
    * @see <a href="#setVideoSource">OT.initPublisher()</a>
    *
    * @return {VideoSource} The return object has the following properties:
    *
    * <p>
    * <ul>
    *   <li><code>deviceId</code> (String | null) &mdash; The device ID.</li>
    *   <li><code>type</code> (String | null) &mdash; This is set to
    *   'camera' (for a  camera-based video), 'screen' (for a screen-sharing video),
    *   or 'custom' (for a video  with a MediaStreamTrack source). </li>
    *   <li><code>track</code> (MediaStreamTrack | null) &mdash; The
    *   MediaStreamTrack for the video.</li>
    * </ul>
    * <p>
    * Any inapplicable properties will be set to null.
    */ this.getVideoSource = ()=>{
                            const sourceProperties = {};
                            const isAudioOnly = !webRTCStream || webRTCStream.getVideoTracks().length === 0;
                            sourceProperties.track = webRTCStream && properties.publishVideo && webRTCStream.getVideoTracks()[0] || null;
                            sourceProperties.deviceId = !isScreenSharing && !isCustomVideoTrack && currentDeviceId ? currentDeviceId : null;
                            if (isCustomVideoTrack) sourceProperties.type = 'custom';
                            else if (isScreenSharing) sourceProperties.type = 'screen';
                            else if (!isAudioOnly) sourceProperties.type = 'camera';
                            else sourceProperties.type = null;
                            return sourceProperties;
                        }; // API Compatibility layer for Flash Publisher, this could do with some tidyup.
                        this._ = {
                            setIceConfig (newIceConfig) {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee30() {
                                    var pcs;
                                    return _regenerator.default.wrap(function _callee30$(_context30) {
                                        while(true)switch(_context30.prev = _context30.next){
                                            case 0:
                                                _context30.next = 2;
                                                return getAllPeerConnections();
                                            case 2:
                                                pcs = _context30.sent;
                                                pcs.forEach((pc)=>pc.setIceConfig(newIceConfig));
                                            case 4:
                                            case "end":
                                                return _context30.stop();
                                        }
                                    }, _callee30);
                                }))();
                            },
                            publishToSession: (session, analyticsReplacement)=>{
                                if (analyticsReplacement) analytics = analyticsReplacement;
                                 // Add session property to Publisher
                                previousSession = session;
                                this.session = session;
                                const requestedStreamId = uuid();
                                lastRequestedStreamId = requestedStreamId;
                                this.streamId = requestedStreamId;
                                logConnectivityEvent('Attempt', {
                                    dataChannels: properties.channels,
                                    properties: whitelistPublisherProperties(properties)
                                });
                                const loadedPromise = new Promise((resolve, reject)=>{
                                    if (loaded) {
                                        resolve();
                                        return;
                                    }
                                    this.once('initSuccess', resolve);
                                    this.once('destroyed', (_ref40)=>{
                                        let reason = _ref40.reason;
                                        let reasonDescription = '';
                                        if (reason) reasonDescription = ` Reason: ${reason}`;
                                        reject(new Error(`Publisher destroyed before it finished loading.${reasonDescription}`));
                                    });
                                });
                                logging.debug("publishToSession: waiting for publishComplete, which is triggered by stream#created from rumor");
                                const completedPromise = new Promise((resolve, reject)=>{
                                    this.once('publishComplete', (error)=>{
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        this._setScalableFramerates(properties.scalableFramerates);
                                        this._setScalableVideoLayers(properties.scalableVideoLayers); // See OPENTOK-45935
                                        // Some users reuse the publisher when disconnecting and reconnecting
                                        // to a session. This re-synchronizes the state of the stream channels.
                                        if (this.stream) {
                                            this.stream.setChannelActiveState('audio', hasAudio());
                                            this.stream.setChannelActiveState('video', hasVideo());
                                        }
                                        logging.debug('publishToSession: got publishComplete');
                                        resolve();
                                    });
                                });
                                const processMessagingError = (error)=>{
                                    const publicError = createStreamErrorMap(error);
                                    logConnectivityEvent('Failure', {}, {
                                        failureReason: 'Publish',
                                        failureCode: publicError.code,
                                        failureMessage: publicError.message
                                    });
                                    if (state.isAttemptingToPublish()) this.trigger('publishComplete', publicError);
                                    OTErrorClass.handleJsException({
                                        errorMsg: error.message,
                                        code: publicError.code,
                                        target: this,
                                        error: error,
                                        analytics: analytics
                                    });
                                    throw publicError;
                                };
                                logging.debug('publishToSession: waiting for loaded');
                                const streamCreatedPromise = loadedPromise.then(()=>session._.getVideoCodecsCompatible(webRTCStream)).then((videoCodecsCompatible)=>{
                                    logging.debug('publishToSession: loaded'); // Bail if this.session is gone, it means we were unpublished
                                    // before createStream could finish.
                                    if (!this.session) return undefined;
                                     // make sure we trigger an error if we are not getting any "ack" after a reasonable
                                    // amount of time
                                    const publishGuardingTo = setTimeout(()=>{
                                        onPublishingTimeout(session);
                                    }, PUBLISH_MAX_DELAY);
                                    this.once('publishComplete', ()=>{
                                        clearTimeout(publishGuardingTo);
                                    });
                                    state.set('PublishingToSession');
                                    const video = videoCodecsCompatible && widgetView && widgetView.video();
                                    const hasVideoTrack = webRTCStream.getVideoTracks().length > 0;
                                    const didRequestVideo = properties.videoSource !== null && properties.videoSource !== false;
                                    if (video && hasVideoTrack && didRequestVideo) streamChannels.push(new StreamChannel({
                                        id: 'video1',
                                        type: 'video',
                                        active: properties.publishVideo,
                                        orientation: VideoOrientation.ROTATED_NORMAL,
                                        frameRate: properties.frameRate,
                                        width: video.videoWidth(),
                                        height: video.videoHeight(),
                                        e2ee: session._.isE2ee(),
                                        source: (()=>{
                                            if (isScreenSharing) return 'screen';
                                            if (isCustomVideoTrack) return 'custom';
                                            return 'camera';
                                        })(),
                                        fitMode: properties.fitMode
                                    }));
                                    const hasAudioTrack = webRTCStream.getAudioTracks().length > 0;
                                    const didRequestAudio = properties.audioSource !== null && properties.audioSource !== false; // @todo should we just use hasAudioTrack here? if hasAudioTrack is true
                                    // then does it matter if didRequestAudio is false? we still have an audio
                                    // track for some reason!
                                    if (didRequestAudio && hasAudioTrack) streamChannels.push(new StreamChannel({
                                        id: 'audio1',
                                        type: 'audio',
                                        active: properties.publishAudio
                                    }));
                                    if (didRequestAudio && hasAudioTrack) streamChannels.push(new StreamChannel({
                                        id: 'caption1',
                                        type: 'data',
                                        active: properties.publishCaptions
                                    }));
                                     // privately expose the publisher stream channels for testing purposes
                                    this._.streamChannels = streamChannels;
                                    logging.debug('publishToSession: creating rumor stream id');
                                    return new Promise((resolve, reject)=>{
                                        _createStream(null, (messagingError, streamId, message)=>{
                                            if (messagingError) {
                                                reject(processMessagingError(messagingError));
                                                return;
                                            }
                                            resolve({
                                                streamId: streamId,
                                                message: message
                                            });
                                        });
                                    });
                                }).then((maybeStream)=>{
                                    if (maybeStream === undefined) return;
                                    const streamId = maybeStream.streamId, message = maybeStream.message;
                                    logging.debug('publishToSession: rumor stream id created:', streamId, "(this is different from stream#created, which requires media to actually be flowing for mantis sessions)");
                                    if (streamId !== requestedStreamId) throw new Error('streamId response does not match request');
                                    this.streamId = streamId;
                                    rumorIceServers = parseIceServers(message);
                                }).catch((err)=>{
                                    this.trigger('publishComplete', err);
                                    throw err;
                                });
                                return Promise.all([
                                    streamCreatedPromise,
                                    completedPromise
                                ]);
                            },
                            unpublishFromSession: (session, reason)=>{
                                if (!this.session || session.id !== this.session.id) {
                                    if (reason === 'unpublished') {
                                        const selfSessionText = this.session && this.session.id || 'no session';
                                        logging.warn(`The publisher ${guid} is trying to unpublish from a session ${session.id} it is not ` + `attached to (it is attached to ${selfSessionText})`);
                                    }
                                    return this;
                                }
                                if (session.isConnected() && (this.stream || state.isAttemptingToPublish())) session._.streamDestroy(this.streamId);
                                streamCleanupJobs.releaseAll(); // Disconnect immediately, rather than wait for the WebSocket to
                                // reply to our destroyStream message.
                                this.disconnect();
                                if (state.isAttemptingToPublish()) {
                                    logConnectivityEvent('Cancel', {
                                        reason: 'unpublish'
                                    });
                                    const createErrorFromReason = ()=>{
                                        switch(reason){
                                            case 'mediaStopped':
                                                return 'The video element fired the ended event, indicating there is an issue with the media';
                                            case 'unpublished':
                                                return 'The publisher was unpublished before it could be published';
                                            case 'reset':
                                                return 'The publisher was reset';
                                            default:
                                                return `The publisher was destroyed due to ${reason}`;
                                        }
                                    };
                                    const err = new Error(createErrorFromReason());
                                    this.trigger('publishComplete', otError(reason === 'mediaStopped' ? Errors.MEDIA_ENDED : Errors.CANCEL, err));
                                }
                                this.session = null;
                                logAnalyticsEvent('unpublish', 'Success');
                                this._.streamDestroyed(reason);
                                return this;
                            },
                            unpublishStreamFromSession: (stream, session, reason)=>{
                                if (!lastRequestedStreamId || stream.id !== lastRequestedStreamId) {
                                    logging.warn(`The publisher ${guid} is trying to destroy a stream ${stream.id} that is not attached to it (it has ${lastRequestedStreamId || 'no stream'} attached to it)`);
                                    return this;
                                }
                                return this._.unpublishFromSession(session, reason);
                            },
                            streamDestroyed: (reason)=>{
                                if ([
                                    'reset'
                                ].indexOf(reason) < 0) // We're back to being a stand-alone publisher again.
                                {
                                    if (!state.isDestroyed()) state.set('MediaBound');
                                }
                                const event = new Events.StreamEvent('streamDestroyed', this.stream, reason, true);
                                this.dispatchEvent(event);
                                if (!event.isDefaultPrevented()) this.destroy();
                            },
                            archivingStatus (status) {
                                if (chromeMixin) chromeMixin.setArchivingStatus(status);
                                return status;
                            },
                            webRtcStream () {
                                return webRTCStream;
                            },
                            switchTracks () {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee31() {
                                    var stream;
                                    return _regenerator.default.wrap(function _callee31$(_context31) {
                                        while(true)switch(_context31.prev = _context31.next){
                                            case 0:
                                                _context31.prev = 0;
                                                _context31.next = 3;
                                                return getUserMedia().catch(userMediaError);
                                            case 3:
                                                stream = _context31.sent;
                                                _context31.next = 10;
                                                break;
                                            case 6:
                                                _context31.prev = 6;
                                                _context31.t0 = _context31["catch"](0);
                                                logging.error(`OT.Publisher.switchTracks failed to getUserMedia: ${_context31.t0}`);
                                                throw _context31.t0;
                                            case 10:
                                                setNewStream(stream);
                                                _context31.prev = 11;
                                                bindVideo();
                                                _context31.next = 21;
                                                break;
                                            case 15:
                                                _context31.prev = 15;
                                                _context31.t1 = _context31["catch"](11);
                                                if (!(_context31.t1 instanceof CancellationError)) {
                                                    _context31.next = 19;
                                                    break;
                                                }
                                                return _context31.abrupt("return");
                                            case 19:
                                                logging.error('Error while binding video', _context31.t1);
                                                throw _context31.t1;
                                            case 21:
                                                _context31.prev = 21;
                                                replaceTracks();
                                                _context31.next = 29;
                                                break;
                                            case 25:
                                                _context31.prev = 25;
                                                _context31.t2 = _context31["catch"](21);
                                                logging.error('Error replacing tracks', _context31.t2);
                                                throw _context31.t2;
                                            case 29:
                                            case "end":
                                                return _context31.stop();
                                        }
                                    }, _callee31, null, [
                                        [
                                            0,
                                            6
                                        ],
                                        [
                                            11,
                                            15
                                        ],
                                        [
                                            21,
                                            25
                                        ]
                                    ]);
                                }))();
                            },
                            getDataChannel (label, getOptions, completion) {
                                const pc = getPeerConnectionById(Object.keys(peerConnectionsAsync)[0]); // @fixme this will fail if it's called before we have a PublisherPeerConnection.
                                // I.e. before we have a subscriber.
                                if (!pc) {
                                    completion(new OTHelpers.Error('Cannot create a DataChannel before there is a subscriber.'));
                                    return;
                                }
                                pc.then((peerConnection)=>{
                                    peerConnection.getDataChannel(label, getOptions, completion);
                                });
                            },
                            iceRestart () {
                                getAllPeerConnections().then((peerConnections)=>{
                                    peerConnections.forEach((peerConnection)=>{
                                        const _getPeerConnectionMet7 = getPeerConnectionMeta(peerConnection), remoteConnectionId = _getPeerConnectionMet7.remoteConnectionId;
                                        logRepublish('Attempt', {
                                            remoteConnectionId: remoteConnectionId
                                        });
                                        logging.debug('Publisher: ice restart attempt');
                                        peerConnection.iceRestart();
                                    });
                                });
                            },
                            getState () {
                                return state;
                            },
                            demoOnlyCycleVideo: this.cycleVideo,
                            testOnlyGetFramesEncoded () {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee32() {
                                    var peerConnections;
                                    return _regenerator.default.wrap(function _callee32$(_context32) {
                                        while(true)switch(_context32.prev = _context32.next){
                                            case 0:
                                                _context32.next = 2;
                                                return getAllPeerConnections();
                                            case 2:
                                                peerConnections = _context32.sent;
                                                if (peerConnections.length) {
                                                    _context32.next = 5;
                                                    break;
                                                }
                                                throw new Error('No established PeerConnections yet');
                                            case 5:
                                                return _context32.abrupt("return", peerConnections[0]._testOnlyGetFramesEncoded());
                                            case 6:
                                            case "end":
                                                return _context32.stop();
                                        }
                                    }, _callee32);
                                }))();
                            },
                            onStreamAvailable: onStreamAvailable,
                            startRoutedToRelayedTransition: ()=>{
                                logRoutedToRelayedTransition('Attempt');
                                const processMessagingError = (error)=>{
                                    const publicError = createStreamErrorMap(error);
                                    this.trigger('streamCreateForP2PComplete', publicError);
                                    logRoutedToRelayedTransition('Failure', {
                                        reason: publicError.message
                                    });
                                };
                                if (!this.session) {
                                    logRoutedToRelayedTransition('Failure', {
                                        reason: 'Not connected to the session.'
                                    });
                                    return;
                                }
                                const streamCreateForP2PCompleteTimeout = setTimeout(()=>{
                                    logRoutedToRelayedTransition('Failure', {
                                        reason: 'Timeout'
                                    });
                                }, PUBLISH_MAX_DELAY);
                                this.once('streamCreateForP2PComplete', ()=>{
                                    clearTimeout(streamCreateForP2PCompleteTimeout);
                                });
                                logging.debug('streamCreateWithSource: send a message to RUMOR for ' + `creating the stream with the sourceStreaId P2P and stream ${this.streamId}`);
                                _createStream('P2P', (messagingError)=>{
                                    if (messagingError) processMessagingError(messagingError);
                                    else this.trigger('streamCreateForP2PComplete');
                                });
                            },
                            startRelayedToRoutedTransition: function() {
                                var _startRelayedToRoutedTransition = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee33() {
                                    return _regenerator.default.wrap(function _callee33$(_context33) {
                                        while(true)switch(_context33.prev = _context33.next){
                                            case 0:
                                                if (!(activeSourceStreamId === 'MANTIS')) {
                                                    _context33.next = 2;
                                                    break;
                                                }
                                                return _context33.abrupt("return");
                                            case 2:
                                                logRelayedToRoutedTransition('Attempt');
                                                if (_this.session) {
                                                    _context33.next = 6;
                                                    break;
                                                }
                                                logRelayedToRoutedTransition('Failure', {
                                                    reason: 'Not connected to the session.'
                                                });
                                                return _context33.abrupt("return");
                                            case 6:
                                                if (_this.streamId) {
                                                    _context33.next = 9;
                                                    break;
                                                }
                                                logRelayedToRoutedTransition('Failure', {
                                                    reason: 'No streamId available'
                                                });
                                                return _context33.abrupt("return");
                                            case 9:
                                                _this.session._.streamDestroy(_this.streamId, 'P2P');
                                                _context33.t0 = _this;
                                                _context33.next = 13;
                                                return getP2pPeerConnection();
                                            case 13:
                                                _context33.t1 = _context33.sent;
                                                _context33.t0._removePeerConnection.call(_context33.t0, _context33.t1);
                                                _context33.next = 17;
                                                return _restartSendingRtpToMantis();
                                            case 17:
                                                logRelayedToRoutedTransition('Success');
                                                _this.trigger('streamDestroyForP2PComplete');
                                            case 19:
                                            case "end":
                                                return _context33.stop();
                                        }
                                    }, _callee33);
                                }));
                                function startRelayedToRoutedTransition() {
                                    return _startRelayedToRoutedTransition.apply(this, arguments);
                                }
                                return startRelayedToRoutedTransition;
                            }(),
                            forceMuteAudio: (function() {
                                logAnalyticsEvent('publishAudio', 'Attempt', {
                                    publishAudio: false
                                });
                                properties.publishAudio = false;
                                try {
                                    updateAudio('auto');
                                    this.dispatchEvent(new Events.MuteForcedEvent());
                                    logAnalyticsEvent('publishAudio', 'Success', {
                                        publishAudio: false
                                    });
                                } catch (e) {
                                    logAnalyticsEvent('publishAudio', 'Failure', {
                                        message: e.message
                                    });
                                }
                            }).bind(this)
                        };
                        this.detectDevices = function() {
                            logging.warn('Publisher.detectDevices() is not implemented.');
                        };
                        this.detectMicActivity = function() {
                            logging.warn('Publisher.detectMicActivity() is not implemented.');
                        };
                        this.getEchoCancellationMode = function() {
                            logging.warn('Publisher.getEchoCancellationMode() is not implemented.');
                            return 'fullDuplex';
                        };
                        this.setMicrophoneGain = function() {
                            logging.warn('Publisher.setMicrophoneGain() is not implemented.');
                        };
                        this.getMicrophoneGain = function() {
                            logging.warn('Publisher.getMicrophoneGain() is not implemented.');
                            return 0.5;
                        };
                        this.setCamera = function() {
                            logging.warn('Publisher.setCamera() is not implemented.');
                        };
                        this.setMicrophone = function() {
                            logging.warn('Publisher.setMicrophone() is not implemented.');
                        }; // Platform methods:
                        this.guid = function() {
                            return guid;
                        };
                        this.videoElement = function() {
                            const video = widgetView && widgetView.video();
                            return video ? video.domElement() : null;
                        };
                        this.setStream = assignStream;
                        this.isWebRTC = true;
                        this.isLoading = function() {
                            return widgetView && widgetView.loading();
                        };
                        /**
    * Returns the width, in pixels, of the Publisher video. This may differ from the
    * <code>resolution</code> property passed in as the <code>properties</code> property
    * the options passed into the <code>OT.initPublisher()</code> method, if the browser
    * does not support the requested resolution.
    *
    * @method #videoWidth
    * @memberOf Publisher
    * @return {Number} the width, in pixels, of the Publisher video.
    */ this.videoWidth = function() {
                            const video = widgetView && widgetView.video();
                            return video ? video.videoWidth() : undefined;
                        };
                        /**
    * Returns the height, in pixels, of the Publisher video. This may differ from the
    * <code>resolution</code> property passed in as the <code>properties</code> property
    * the options passed into the <code>OT.initPublisher()</code> method, if the browser
    * does not support the requested resolution.
    *
    * @method #videoHeight
    * @memberOf Publisher
    * @return {Number} the height, in pixels, of the Publisher video.
    */ this.videoHeight = function() {
                            const video = widgetView && widgetView.video();
                            return video ? video.videoHeight() : undefined;
                        };
                        /**
    *  Returns the details on the publisher's stream quality, including the following:
    *
    * <ul>
    *
    *   <li>The total number of audio and video packets lost</li>
    *   <li>The total number of audio and video packets sent</li>
    *   <li>The total number of audio and video bytes sent</li>
    *   <li>The current average video frame rate</li>
    *
    * </ul>
    *
    * You can use these stats to assess the quality of the publisher's audio-video stream.
    *
    * @param {Function} completionHandler A function that takes the following
    * parameters:
    *
    * <ul>
    *
    *   <li><code>error</code> (<a href="Error.html">Error</a>) &mdash; Upon successful completion
    *   the method, this is undefined. An error results if the publisher is not connected to a
    *   session or if it is not publishing audio or video.</li>
    *
    *   <li><code>statsArray</code> (Array) &mdash; An array of objects defining the current
    *   audio-video statistics for the publisher. For a publisher in a routed session (one that
    *   uses the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">OpenTok
    *   Media Router</a>), this array includes one object, defining the statistics for the single
    *   audio-media stream that is sent to the OpenTok Media Router. In a relayed session, the
    *   array includes an object for each subscriber to the published stream. Each object in the
    *   array contains a <code>stats</code> property that includes the following properties:
    *
    *     <p>
    *     <ul>
    *       <li><code>audio.bytesSent</code> (Number) &mdash; The total number of audio bytes
    *         sent to the subscriber (or to the OpenTok Media Router)</li>
    *
    *       <li><code>audio.packetsLost</code> (Number) &mdash; The total number audio packets
    *        that did not reach the subscriber (or to the OpenTok Media Router)</li>
    *
    *       <li><code>audio.packetsSent</code> (Number) &mdash; The total number of audio
    *        packets sent to the subscriber (or to the OpenTok Media Router)</li>
    *
    *       <li><code>timestamp</code> (Number) &mdash; The timestamp, in milliseconds since
    *         the Unix epoch, for when these stats were gathered</li>
    *
    *       <li><code>video.bytesSent</code> (Number) &mdash; The total video bytes sent to
    *         the subscriber (or to the OpenTok Media Router)</li>
    *
    *       <li><code>video.packetsLost</code> (Number) &mdash; The total number of video packets
    *         that did not reach the subscriber (or to the OpenTok Media Router)</li>
    *
    *       <li><code>video.packetsSent</code> (Number) &mdash; The total number of video
    *         packets sent to the subscriber</li>
    *
    *       <li><code>video.frameRate</code> (Number) &mdash; The current average video frame rate</li>
    *     </ul>
    *
    *     <p>Additionally, for a publisher in a relayed session, each object in the array contains
    *     the following two properties:
    *
    *     <ul>
    *       <li><code>connectionId</code> (String) &mdash; The unique ID of the client's
    *       connection, which matches the <code>id</code> property of the <code>connection</code>
    *       property of the <a href="Session.html#.event:connectionCreated">connectionCreated</a>
    *       event that the Session object dispatched for the remote client.</li>
    *
    *       <li><code>subscriberId</code> (String) &mdash; The unique ID of the subscriber, which
    *       matches the <code>id</code> property of the Subscriber object in the subscribing
    *       client's app.</li>
    *     </ul>
    *
    *     <p>These two properties are undefined for a publisher in a routed session.
    *
    *   </li>
    * </ul>
    *
    * @see <a href="Subscriber.html#getStats">Subscriber.getStats()</a>
    * @see <a href="#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @method #getStats
    * @memberOf Publisher
    */ this.getStats = function getStats(callback) {
                            _getStats((err, stats)=>{
                                if (err) callback(err);
                                else callback(null, stats);
                            });
                        };
                        /**
    * Returns a promise that, on success, resolves with an array of objects that include
    * RTCStatsReport properties for the published stream. (See
    * <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport" target="_blank">
    * RTCStatsReport</a>.)
    *
    * <p>
    * For a publisher in a routed session (one that uses the
    * <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">OpenTok
    * Media Router</a>), this array includes one object, defining the statistics for the single
    * audio-media stream that is sent to the OpenTok Media Router. In a relayed session, the
    * array includes an object for each subscriber to the published stream. Each object in the
    * array contains an <code>rtcStatsReport</code> property that is a RTCStatsReport object.
    *
    * <p>
    * Additionally, for a publisher in a relayed session, each object in the array contains
    * the following two properties:
    *
    *     <ul>
    *
    *       <li><code>connectionId</code> (String) &mdash; The unique ID of the client's
    *       connection, which matches the <code>id</code> property of the <code>connection</code>
    *       property of the <a href="Session.html#.event:connectionCreated">connectionCreated</a>
    *       event that the Session object dispatched for the remote client.</li>
    *
    *       <li><code>subscriberId</code> (String) &mdash; The unique ID of the subscriber, which
    *       matches the <code>id</code> property of the Subscriber object in the subscribing
    *       client's app.</li>
    *
    *     </ul>
    *
    * <p>
    * These two properties are undefined for a publisher in a routed session.
    *
    * <p>
    * The Promise will be rejected in the following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method (for example, in Chrome version 57 and lower,
    *     which does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
    *     RTCPeerConnection.getStats()</a> standard).
    *   </li>
    *   <li>
    *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
    *     PeerConnection</a> for the Publisher is not connected.
    *   </li>
    *  </ul>
    * </p>
    *
    * @method #getRtcStatsReport
    * @memberOf Publisher
    *
    * @see <a href="Subscriber.html#getRtcStatsReport">Subscriber.getRtcStatsReport()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */ this.getRtcStatsReport = ()=>new Promise((resolve, reject)=>{
                                _getRtcStatsReport((err, stats)=>{
                                    if (err) reject(err);
                                    else resolve(stats);
                                });
                            }); // Make read-only: element, guid, _.webRtcStream
                        state = new PublishingState(stateChangeFailed);
                        this.accessAllowed = false;
                        /**
     * Applies a video filter for the publisher. You can apply a background blur filter.  A
     * publisher can have only one (or zero) applied at one time.  When you set a new
     * filter, a previously set filter is removed.
     *
     * <p>
     * This method is incompatible with the
     * <a href="Publisher.html#setVideoMediaProcessorConnector">Publisher.setVideoMediaProcessorConnector()</a>
     * method. Calling this method after <code>Publisher.setVideoMediaProcessorConnector(connector)</code>
     * returns a promise that is rejected with an error, with the <code>name</code> property of the error
     * set to <code>'OT_NOT_SUPPORTED'</code>. You can remove the connector by calling
     * <code>Publisher.setVideoMediaProcessorConnector(null)</code>.
     * </p>
     *
     * <p>
     * <em>Note:</em> Video filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     The browser does not support this method.
     *   </li>
     *   <li>
     *     The publisher is not using a supported video source. (The <code>videoSource</code>
     *     option of the <a href="OT.html#initPublisher">OT.initPublisher()</a> method was
     *     set to <code>null</code>, <code>false</code>, or
     *     <code>"screen"</code>).
     *   </li>
     *   <li>
     *     A custom filter is already being used via the <code>Publisher.setVideoMediaProcessorConnector()</code> method.
     *   </li>
     *   <li>
     *     There are no video input devices (cameras) available.
     *   </li>
     *   <li>
     *     There was an error acquiring video from the video input device.
     *   </li>
     *   <li>
     *     There was an error applying the transformation filter.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can also set the initial video filter by setting a <code>videoFilter</code> option
     * when calling <a href="OT.html#initPublisher">OT.initPublisher()</a>.
     *
     * @param {Object} videoFilter An object defining the video filter to be applied. The following
     * filters are supported:
     * <ul>
     *   <li>
     *     <p>
     *     <em>Background blur filter:</em> &mdash; Set the <code>type</code> property of the object to
     *     <code>"backgroundBlur"</code>.
     *     <p>
     *     A background blur filter object includes an additional <code>blurStrength</code> property, which
     *     defines the blur radius and is optional. Set this to either <code>"low"</code> or
     *     <code>"high"</code> (the default).
     *   </li>
     *   <li>
     *     <p>
     *     <em>Background replacement filter</em> &mdash; Set the <code>type</code> property of the object to
     *     <code>"backgroundReplacement"</code>.
     *     <p>
     *     A background replacement filter object includes an additional <code>backgroundImgUrl</code> property,
     *     which defines the URL of the background image to use. Also accepted are image BLOBs
     *     (a Base64-encoded string of image data).
     *     The following image formats are supported: BMP, PNG, JPEG, and GIF.
     *     <p>
     *     This is a <em>beta</em> feature.
     *   </li>
     * </ul>
     *
     * @method #applyVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#getVideoFilter">Publisher.getVideoFilter()</a>
     * @see <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no new video filter is set.
     */ this.applyVideoFilter = /*#__PURE__*/ function() {
                            var _ref41 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee34(videoFilter) {
                                var isSupported, message, _webRTCStream$getVide2, originalVideoTrack, filteredVideoTrack;
                                return _regenerator.default.wrap(function _callee34$(_context34) {
                                    while(true)switch(_context34.prev = _context34.next){
                                        case 0:
                                            logAnalyticsEvent('applyVideoFilter', 'Attempt', {
                                                videoFilter: videoFilter
                                            });
                                            _context34.prev = 1;
                                            if (!_videoMediaProcessorConnector) {
                                                _context34.next = 4;
                                                break;
                                            }
                                            throw otError(Errors.NOT_SUPPORTED, new Error('Cannot apply video filter when videoMediaProcessorConnector is set.'));
                                        case 4:
                                            isSupported = MediaProcessor.isSupported();
                                            if (isSupported) {
                                                _context34.next = 7;
                                                break;
                                            }
                                            throw otError(Errors.NOT_SUPPORTED, new Error('Browser does not support video filters (Insertable Streams and Worker APIs are required)'));
                                        case 7:
                                            if (mediaProcessor.isValidVideoFilter(videoFilter)) {
                                                _context34.next = 9;
                                                break;
                                            }
                                            throw otError(Errors.INVALID_PARAMETER, new Error('Video filter has invalid configuration'));
                                        case 9:
                                            if (webRTCStream) {
                                                _context34.next = 14;
                                                break;
                                            }
                                            message = 'Ignoring. No mediaStream';
                                            logAnalyticsEvent('applyVideoFilter', 'Failure', {
                                                message: message
                                            });
                                            logging.warn(message);
                                            return _context34.abrupt("return");
                                        case 14:
                                            if (!isScreenSharing) {
                                                _context34.next = 16;
                                                break;
                                            }
                                            throw otError(Errors.INVALID_PARAMETER, new Error('Video filters can not be applied to screen share'));
                                        case 16:
                                            if (!_this.getVideoFilter()) {
                                                _context34.next = 29;
                                                break;
                                            }
                                            if (!mediaProcessor.canUpdateVideoFilter(videoFilter.type)) {
                                                _context34.next = 27;
                                                break;
                                            }
                                            _context34.prev = 18;
                                            _context34.next = 21;
                                            return mediaProcessor.updateVideoFilter(videoFilter);
                                        case 21:
                                            return _context34.abrupt("return");
                                        case 24:
                                            _context34.prev = 24;
                                            _context34.t0 = _context34["catch"](18);
                                            logging.warn(`Error updating video filter: ${_context34.t0}`);
                                        case 27:
                                            _context34.next = 29;
                                            return _this.clearVideoFilter();
                                        case 29:
                                            _webRTCStream$getVide2 = webRTCStream.getVideoTracks(), originalVideoTrack = _webRTCStream$getVide2[0];
                                            if (originalVideoTrack) {
                                                _context34.next = 35;
                                                break;
                                            }
                                            message = 'Ignoring. No video';
                                            logAnalyticsEvent('applyVideoFilter', 'Failure', {
                                                message: message
                                            });
                                            logging.warn(message);
                                            return _context34.abrupt("return");
                                        case 35:
                                            enableMediaProcessorLogging();
                                            _context34.next = 38;
                                            return mediaProcessor.setVideoFilter(videoFilter);
                                        case 38:
                                            _context34.next = 40;
                                            return mediaProcessor.setMediaStream(webRTCStream);
                                        case 40:
                                            filteredVideoTrack = _context34.sent;
                                            if (!filteredVideoTrack) {
                                                _context34.next = 44;
                                                break;
                                            }
                                            _context34.next = 44;
                                            return replaceTrackAndUpdate(originalVideoTrack, filteredVideoTrack);
                                        case 44:
                                            _context34.next = 51;
                                            break;
                                        case 46:
                                            _context34.prev = 46;
                                            _context34.t1 = _context34["catch"](1);
                                            logging.error(`Error applying video filter: ${_context34.t1}`);
                                            logAnalyticsEvent('applyVideoFilter', 'Failure', {
                                                message: _context34.t1.message
                                            });
                                            throw _context34.t1;
                                        case 51:
                                            currentVideoFilter = videoFilter;
                                            logAnalyticsEvent('applyVideoFilter', 'Success', {
                                                videoFilter: videoFilter
                                            });
                                        case 53:
                                        case "end":
                                            return _context34.stop();
                                    }
                                }, _callee34, null, [
                                    [
                                        1,
                                        46
                                    ],
                                    [
                                        18,
                                        24
                                    ]
                                ]);
                            }));
                            return function(_x24) {
                                return _ref41.apply(this, arguments);
                            };
                        }();
                        /**
     * Returns the video filter applied used by the publisher.
     *
     * @method #getVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * @see <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a>
     *
     * @return {Object} The video filter being applied to the video input source used by the publisher.
     * Check the <code>type</code> property of the object to see the video filter type. The following
     * filters are supported:
     *   <ul>
     *     <li><em>Background blur filter</em> &mdash; The <code>type</code> property of the object
     *       is set to <code>"backgroundBlur"</code>. A background blur
     *       filter object includes an additional <code>blurStrength</code> property, which
     *       defines the blur radius, set to either <code>"low"</code> or <code>"high"</code>.
     *     </li>
     *     <li><em>Background replacement filter</em> &mdash; The <code>type</code> type property
     *        of the object is set to <code>"backgroundReplacement"</code>.
     *       A background replacement filter object includes an additional <code>backgroundImgUrl</code>
     *       property, which defines the URL of the background image to use.
     *       This is a <em>beta</em> feature.
     *     </li>
     *   </ul>
     */ this.getVideoFilter = ()=>{
                            logAnalyticsEvent('getVideoFilter', 'Attempt');
                            const videoFilter = mediaProcessor.getVideoFilter();
                            logAnalyticsEvent('getVideoFilter', 'Success');
                            return videoFilter;
                        };
                        /**
     * Sets a
     * <a href="https://vonage.github.io/media-processor-docs/classes/MediaProcessorConnector.html">MediaProcessorConnector</a>
     * for the publisher video track.
     * A publisher can have only one video MediaProcessorConnector applied at one time.  When you set a new
     * connector, the previously set video connector is removed.
     *
     * <p>
     * This is a <em>beta</em> feature.
     * </p>
     *
     * <p>
     * This method is incompatible with the
     * <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * method. Calling this method after <code>Publisher.applyVideoFilter(filter)</code> returns
     * a promise rejected with an error, with the <code>name</code> property of the error set to
     * <code>'OT_NOT_SUPPORTED'</code>. You can clear the video filter by calling
     * <code>Publisher.clearVideoFilter()</code>.
     * </p>
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There are no video input devices (cameras) available.
     *   </li>
     *   <li>
     *     A video filter has already been applied via the <code>Publisher.applyVideoFilter()</code> method.
     *   </li>
     *   <li>
     *     There was an error acquiring video from the video input device.
     *   </li>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/">Media Processor</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/classes/MediaProcessorConnector.html">Vonage Media Processor library docs</a>.
     *
     * @method #setVideoMediaProcessorConnector
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */ this.setVideoMediaProcessorConnector = /*#__PURE__*/ function() {
                            var _ref42 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee35(mediaProcessorConnector) {
                                var _webRTCStream$getVide3, filteredVideoTrack, videoTrack, _webRTCStream$getVide4, originalVideoTrack, message;
                                return _regenerator.default.wrap(function _callee35$(_context35) {
                                    while(true)switch(_context35.prev = _context35.next){
                                        case 0:
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Attempt', {
                                                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
                                            });
                                            if (!_this.getVideoFilter()) {
                                                _context35.next = 4;
                                                break;
                                            }
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                                                message: 'Tried to set video MediaProcessorConnector when video filter applied.'
                                            });
                                            throw otError(Errors.NOT_SUPPORTED, new Error('setVideoMediaProcessorConnector: Cannot use this method when videoFilter is set.'));
                                        case 4:
                                            if (!_videoMediaProcessorConnector) {
                                                _context35.next = 14;
                                                break;
                                            }
                                            _webRTCStream$getVide3 = webRTCStream.getVideoTracks(), filteredVideoTrack = _webRTCStream$getVide3[0];
                                            _context35.next = 8;
                                            return getTrackFromDeviceId(currentDeviceId);
                                        case 8:
                                            videoTrack = _context35.sent;
                                            _context35.next = 11;
                                            return replaceTrackAndUpdate(filteredVideoTrack, videoTrack);
                                        case 11:
                                            _videoMediaProcessorConnector.destroy();
                                            _videoMediaProcessorConnector.stopOriginalTrack();
                                            _videoMediaProcessorConnector = null;
                                        case 14:
                                            if (mediaProcessorConnector) {
                                                _context35.next = 17;
                                                break;
                                            }
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success', {
                                                message: 'clearing the connector'
                                            });
                                            return _context35.abrupt("return");
                                        case 17:
                                            if (MediaProcessorConnector.isValidConnector(mediaProcessorConnector)) {
                                                _context35.next = 20;
                                                break;
                                            }
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                                                message: 'Invalid MediaProcessorConnector'
                                            });
                                            throw otError(Errors.INVALID_PARAMETER, new Error('setVideoMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector'));
                                        case 20:
                                            _videoMediaProcessorConnector = new MediaProcessorConnector(mediaProcessorConnector);
                                            _webRTCStream$getVide4 = webRTCStream.getVideoTracks(), originalVideoTrack = _webRTCStream$getVide4[0];
                                            if (originalVideoTrack) {
                                                _context35.next = 28;
                                                break;
                                            }
                                            message = 'Connector not set as no video track is present.';
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                                                message: message
                                            });
                                            logging.warn(`setVideoMediaProcessorConnector: ${message}`);
                                            _videoMediaProcessorConnector = null;
                                            return _context35.abrupt("return");
                                        case 28:
                                            _context35.prev = 28;
                                            _context35.next = 31;
                                            return _videoMediaProcessorConnector.setTrack(originalVideoTrack);
                                        case 31:
                                            filteredVideoTrack = _context35.sent;
                                            _context35.next = 34;
                                            return replaceTrackAndUpdate(originalVideoTrack, filteredVideoTrack);
                                        case 34:
                                            _context35.next = 42;
                                            break;
                                        case 36:
                                            _context35.prev = 36;
                                            _context35.t0 = _context35["catch"](28);
                                            _videoMediaProcessorConnector = null;
                                            logging.error(`setVideoMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${_context35.t0}`);
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Failure', {
                                                message: _context35.t0.message
                                            });
                                            throw _context35.t0;
                                        case 42:
                                            logAnalyticsEvent('setVideoMediaProcessorConnector', 'Success');
                                        case 43:
                                        case "end":
                                            return _context35.stop();
                                    }
                                }, _callee35, null, [
                                    [
                                        28,
                                        36
                                    ]
                                ]);
                            }));
                            return function(_x25) {
                                return _ref42.apply(this, arguments);
                            };
                        }();
                        /**
     * Sets a
     * <a href="https://vonage.github.io/media-processor-docs/classes/MediaProcessorConnector.html">MediaProcessorConnector</a>
     * for the publisher audio track.
     * A publisher can have only one audio MediaProcessorConnector applied at one time.  When you set a new
     * connector, the previously set audio connector is removed.
     *
     * <p>
     * This is a <em>beta</em> feature.
     * </p>
     *
     * <p>
     * <em>Note:</em> MediaProcessors are only supported in recent versions of Chrome, Electron, Opera, and Edge.
     * They are not supported in other (non-Chromium-based) browsers or on iOS.  You can check if the client
     * supports this feature by calling the
     * <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
     * </p>
     *
     * <p>
     * Calling this method results in an error (the Promise returned by the method is rejected)
     * in the following conditions:
     * <ul>
     *   <li>
     *     There are no audio input devices (microphones) available.
     *   </li>
     *   <li>
     *     There was an error acquiring audio from the audio input device.
     *   </li>
     *   <li>
     *     There was an error acquiring the processed track from the MediaProcessorConnector.
     *   </li>
     *  </ul>
     * </p>
     *
     * <p>
     * You can clear the current connector by calling this method with <code>null</code>.
     *
     * <p>
     * For more information, see the
     * <a href="https://tokbox.com/developer/guides/vonage-media-processor/js/">Media Processor</a>
     * developer guide.
     *
     * @param {MediaProcessorConnector} mediaProcessorConnector A MediaProcessorConnector instance.
     * See the <a href="https://vonage.github.io/media-processor-docs/classes/MediaProcessorConnector.html">Vonage Media Processor library docs</a>.
     *
     * @method #setAudioMediaProcessorConnector
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected and no connector is set.
     */ this.setAudioMediaProcessorConnector = /*#__PURE__*/ function() {
                            var _ref43 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee36(mediaProcessorConnector) {
                                var _webRTCStream$getAudi, filteredAudioTrack, _webRTCStream$getAudi2, originalAudioTrack, message;
                                return _regenerator.default.wrap(function _callee36$(_context36) {
                                    while(true)switch(_context36.prev = _context36.next){
                                        case 0:
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Attempt', {
                                                message: mediaProcessorConnector ? 'setting the connector' : 'clearing the connector'
                                            });
                                            if (!_audioMediaProcessorConnector) {
                                                _context36.next = 7;
                                                break;
                                            }
                                            _webRTCStream$getAudi = webRTCStream.getAudioTracks(), filteredAudioTrack = _webRTCStream$getAudi[0];
                                            _context36.next = 5;
                                            return replaceAudioTrack(filteredAudioTrack, _audioMediaProcessorConnector.originalTrack);
                                        case 5:
                                            _audioMediaProcessorConnector.destroy();
                                            _audioMediaProcessorConnector = null;
                                        case 7:
                                            if (mediaProcessorConnector) {
                                                _context36.next = 10;
                                                break;
                                            }
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success', {
                                                message: 'clearing the connector'
                                            });
                                            return _context36.abrupt("return");
                                        case 10:
                                            if (MediaProcessorConnector.isValidConnector(mediaProcessorConnector)) {
                                                _context36.next = 13;
                                                break;
                                            }
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                                                message: 'Invalid MediaProcessorConnector'
                                            });
                                            throw otError(Errors.INVALID_PARAMETER, new Error('setAudioMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector'));
                                        case 13:
                                            _webRTCStream$getAudi2 = webRTCStream.getAudioTracks(), originalAudioTrack = _webRTCStream$getAudi2[0];
                                            if (originalAudioTrack) {
                                                _context36.next = 20;
                                                break;
                                            }
                                            message = 'Connector not set as no audio track is present.';
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                                                message: message
                                            });
                                            logging.warn(`setAudioMediaProcessorConnector: ${message}`);
                                            _audioMediaProcessorConnector = null;
                                            return _context36.abrupt("return");
                                        case 20:
                                            _audioMediaProcessorConnector = new MediaProcessorConnector(mediaProcessorConnector);
                                            _context36.prev = 21;
                                            _context36.next = 24;
                                            return _audioMediaProcessorConnector.setTrack(originalAudioTrack);
                                        case 24:
                                            filteredAudioTrack = _context36.sent;
                                            _context36.next = 27;
                                            return replaceAudioTrack(_this.getAudioSource(), filteredAudioTrack);
                                        case 27:
                                            _context36.next = 35;
                                            break;
                                        case 29:
                                            _context36.prev = 29;
                                            _context36.t0 = _context36["catch"](21);
                                            _audioMediaProcessorConnector = null;
                                            logging.error(`setAudioMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${_context36.t0}`);
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Failure', {
                                                message: _context36.t0.message
                                            });
                                            throw _context36.t0;
                                        case 35:
                                            logAnalyticsEvent('setAudioMediaProcessorConnector', 'Success');
                                        case 36:
                                        case "end":
                                            return _context36.stop();
                                    }
                                }, _callee36, null, [
                                    [
                                        21,
                                        29
                                    ]
                                ]);
                            }));
                            return function(_x26) {
                                return _ref43.apply(this, arguments);
                            };
                        }();
                        /**
     * Removes the video filter being applied to the publisher.
     *
     * <p>
     * This will result in an error (the Promise returned by the method is rejected) if the
     * video filter could not be stopped.
     *
     * @method #clearVideoFilter
     * @memberOf Publisher
     *
     * @see <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a>
     * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
     * @see <a href="Publisher.html#getVideoFilter">Publisher.getVideoFilter()</a>
     *
     * @return {Promise} A promise that resolves when the operation completes successfully.
     * If there is an error, the promise is rejected.
     */ this.clearVideoFilter = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee37() {
                            var message, oldVideoFilter, _webRTCStream$getVide5, filteredVideoTrack, videoTrack;
                            return _regenerator.default.wrap(function _callee37$(_context37) {
                                while(true)switch(_context37.prev = _context37.next){
                                    case 0:
                                        logAnalyticsEvent('clearVideoFilter', 'Attempt');
                                        if (_this.getVideoFilter()) {
                                            _context37.next = 6;
                                            break;
                                        }
                                        message = 'Ignoring. No video filter applied';
                                        logAnalyticsEvent('clearVideoFilter', 'Success', {
                                            message: message
                                        });
                                        logging.debug(message);
                                        return _context37.abrupt("return");
                                    case 6:
                                        if (MediaProcessor.isSupported()) {
                                            _context37.next = 11;
                                            break;
                                        }
                                        message = 'Ignoring. "clearVideoFilter" not supported.';
                                        logAnalyticsEvent('clearVideoFilter', 'Success', {
                                            message: message
                                        });
                                        logging.warn(message);
                                        return _context37.abrupt("return");
                                    case 11:
                                        if (webRTCStream) {
                                            _context37.next = 16;
                                            break;
                                        }
                                        message = 'Ignoring. No mediaStream';
                                        logAnalyticsEvent('clearVideoFilter', 'Success', {
                                            message: message
                                        });
                                        logging.warn(message);
                                        return _context37.abrupt("return");
                                    case 16:
                                        if (!currentVideoFilter) {
                                            _context37.next = 43;
                                            break;
                                        }
                                        oldVideoFilter = currentVideoFilter;
                                        currentVideoFilter = null;
                                        _webRTCStream$getVide5 = webRTCStream.getVideoTracks(), filteredVideoTrack = _webRTCStream$getVide5[0];
                                        _context37.prev = 20;
                                        _context37.next = 23;
                                        return getTrackFromDeviceId(currentDeviceId);
                                    case 23:
                                        videoTrack = _context37.sent;
                                        _context37.next = 30;
                                        break;
                                    case 26:
                                        _context37.prev = 26;
                                        _context37.t0 = _context37["catch"](20);
                                        logging.error(_context37.t0);
                                        return _context37.abrupt("return");
                                    case 30:
                                        if (videoTrack) {
                                            _context37.next = 33;
                                            break;
                                        }
                                        logging.warn('Failed to clear filter because there is no video track.');
                                        return _context37.abrupt("return");
                                    case 33:
                                        _context37.prev = 33;
                                        _context37.next = 36;
                                        return replaceTrackAndUpdate(filteredVideoTrack, videoTrack);
                                    case 36:
                                        _context37.next = 38;
                                        return destroyMediaProcessor();
                                    case 38:
                                        _context37.next = 43;
                                        break;
                                    case 40:
                                        _context37.prev = 40;
                                        _context37.t1 = _context37["catch"](33);
                                        // Restore the previous filter since this call has failed. This way, this function can be
                                        // called again if needed.
                                        currentVideoFilter = oldVideoFilter;
                                    case 43:
                                    case "end":
                                        return _context37.stop();
                                }
                            }, _callee37, null, [
                                [
                                    20,
                                    26
                                ],
                                [
                                    33,
                                    40
                                ]
                            ]);
                        }));
                    };
                    /**
  * Dispatched when the user has clicked the Allow button, granting the
  * app access to the camera and microphone. The Publisher object has an
  * <code>accessAllowed</code> property which indicates whether the user
  * has granted access to the camera and microphone.
  * @see Event
  * @name accessAllowed
  * @event
  * @memberof Publisher
  */ /**
  * Dispatched when the user has clicked the Deny button, preventing the
  * app from having access to the camera and microphone.
  * <p>
  * <i>Note:</i> On macOS 10.15+ (Catalina), to publish a screen-sharing stream
  * the user must grant the browser access to the screen in macOS System Preferences &gt;
  * Security &amp; Privacy &gt; Privacy &gt; Screen Recording. Otherwise,
  * the Publisher will dispatch an <code>accessDenied</code> event.
  *
  * @see Event
  * @name accessDenied
  * @event
  * @memberof Publisher
  */ /**
  * Dispatched when the Allow/Deny dialog box is opened. (This is the dialog box in which
  * the user can grant the app access to the camera and microphone.)
  * @see Event
  * @name accessDialogOpened
  * @event
  * @memberof Publisher
  */ /**
  * Dispatched when the Allow/Deny box is closed. (This is the dialog box in which the
  * user can grant the app access to the camera and microphone.)
  * @see Event
  * @name accessDialogClosed
  * @event
  * @memberof Publisher
  */ /**
  * Dispatched periodically to indicate the publisher's audio level. The event is dispatched
  * up to 60 times per second, depending on the browser. The <code>audioLevel</code> property
  * of the event is audio level, from 0 to 1.0. See {@link AudioLevelUpdatedEvent} for more
  * information.
  * <p>
  * The following example adjusts the value of a meter element that shows volume of the
  * publisher. Note that the audio level is adjusted logarithmically and a moving average
  * is applied:
  * <p>
  * <pre>
  * var movingAvg = null;
  * publisher.on('audioLevelUpdated', function(event) {
  *   if (movingAvg === null || movingAvg &lt;= event.audioLevel) {
  *     movingAvg = event.audioLevel;
  *   } else {
  *     movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
  *   }
  *
  *   // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
  *   var logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
  *   logLevel = Math.min(Math.max(logLevel, 0), 1);
  *   document.getElementById('publisherMeter').value = logLevel;
  * });
  * </pre>
  * <p>This example shows the algorithm used by the default audio level indicator displayed
  * in an audio-only Publisher.
  *
  * @name audioLevelUpdated
  * @event
  * @memberof Publisher
  * @see AudioLevelUpdatedEvent
  */ /**
   * The publisher has started streaming to the session.
   * @name streamCreated
   * @event
   * @memberof Publisher
   * @see StreamEvent
   * @see <a href="Session.html#publish">Session.publish()</a>
   */ /**
   * The publisher has stopped streaming to the session. The default behavior is that
   * the Publisher object is removed from the HTML DOM. The Publisher object dispatches a
   * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
   * <code>preventDefault()</code> method of the event object in the event listener, the default
   * behavior is prevented, and you can, optionally, retain the Publisher for reuse or clean it up
   * using your own code.
   * @name streamDestroyed
   * @event
   * @memberof Publisher
   * @see StreamEvent
   */ /**
  * Dispatched when the Publisher element is removed from the HTML DOM. When this event
  * is dispatched, you may choose to adjust or remove HTML DOM elements related to the publisher.
  * @name destroyed
  * @event
  * @memberof Publisher
  */ /**
  * Dispatched when the video dimensions of the video change. This can only occur in when the
  * <code>stream.videoType</code> property is set to <code>"screen"</code> (for a screen-sharing
  * video stream), when the user resizes the window being captured. This event object has a
  * <code>newValue</code> property and an <code>oldValue</code> property, representing the new and
  * old dimensions of the video. Each of these has a <code>height</code> property and a
  * <code>width</code> property, representing the height and width, in pixels.
  * @name videoDimensionsChanged
  * @event
  * @memberof Publisher
  * @see VideoDimensionsChangedEvent
  */ /**
  * Dispatched when the Publisher's video element is created. Add a listener for this event when
  * you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. The <code>element</code>
  * property of the event object is a reference to the Publisher's <code>video</code> element
  * (or in Internet Explorer the <code>object</code> element containing the video). Add it to
  * the HTML DOM to display the video. When you set the <code>insertDefaultUI</code> option to
  * <code>false</code>, the <code>video</code> (or <code>object</code>) element is not
  * automatically inserted into the DOM.
  * <p>
  * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
  * <code>false</code>. If you have not set <code>insertDefaultUI</code> option to
  * <code>false</code>, do not move the <code>video</code> (or <code>object</code>) element in
  * in the HTML DOM. Doing so causes the Publisher object to be destroyed.
  *
  * @name videoElementCreated
  * @event
  * @memberof Publisher
  * @see VideoElementCreatedEvent
  */ /**
   * A moderator has forced this client to mute audio.
   *
   * @name muteForced
   * @event
   * @memberof Publisher
   * @see Event
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#forceMuteStream">Session.forceMuteStream()</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */ /**
   * The user publishing the stream has stopped sharing one or all media
   * types (video, audio and/or screen). This can occur when a user disconnects a camera or
   * microphone used as a media source for the Publisher. Or it can occur when a user closes
   * a when the video and audio sources of the stream are MediaStreamTrack elements and
   * tracks are stopped or destroyed.
   *
   * @name mediaStopped
   * @event
   * @memberof Publisher
   * @see MediaStoppedEvent
   */ return Publisher;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 169 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const defaultHasOpenTokSupport = __webpack_require__(52).once;
            /**
 * A class defining properties of the <code>capabilities</code> property of a
 * Session object. See <a href="Session.html#properties">Session.capabilities</a>.
 * <p>
 * All Capabilities properties are undefined until you have connected to a session
 * and the Session object has dispatched the <code>sessionConnected</code> event.
 * <p>
 * For more information on token roles, see the
 * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation Overview</a>.
 *
 * @class Capabilities
 *
 * @property {Number} forceDisconnect Specifies whether you can call
 * the <code>Session.forceDisconnect()</code> method (1) or not (0). To call the
 * <code>Session.forceDisconnect()</code> method,
 * the user must have a token that is assigned the role of moderator.
 * @property {Number} forceUnpublish Specifies whether you can call
 * the <code>Session.forceUnpublish()</code> method (1) or not (0). To call the
 * <code>Session.forceUnpublish()</code> method, the user must have a token that
 * is assigned the role of moderator.
 * @property {Number} forceMute Specifies whether you can call the
 * <code>Session.forceMuteStream()</code>, <code>Session.forceMuteAll()</code>, or
 * <code>Session.disableForceMute()</code>methods (1) or not (0). To call these methods,
 * the user must have a token that is assigned the role of moderator.
 * @property {Number} publish Specifies whether you can publish to the session (1) or not (0).
 * The ability to publish is based on a few factors. To publish, the user must have a token that
 * is assigned a role that supports publishing. There must be a connected camera and microphone.
 * @property {Number} subscribe Specifies whether you can subscribe to streams
 * in the session (1) or not (0). Currently, this capability is available for all users on all
 * platforms.
 */ module1.exports = function Capabilities(permissions, deps) {
                if (deps === void 0) deps = {};
                /* eslint-disable-next-line global-require */ const hasE2eeCapability = deps.hasE2eeCapability || __webpack_require__(170);
                const hasOpenTokSupport = deps.hasOpenTokSupport || defaultHasOpenTokSupport;
                this.publish = permissions.indexOf('publish') !== -1 ? 1 : 0;
                this.subscribe = permissions.indexOf('subscribe') !== -1 ? 1 : 0;
                this.forceUnpublish = permissions.indexOf('forceunpublish') !== -1 ? 1 : 0;
                this.forceDisconnect = permissions.indexOf('forcedisconnect') !== -1 ? 1 : 0;
                this.forceMute = permissions.indexOf('forcemute') !== -1 ? 1 : 0;
                this.supportsE2ee = hasE2eeCapability() ? 1 : 0;
                this.supportsWebRTC = hasOpenTokSupport() ? 1 : 0;
                this.permittedTo = (action)=>Object.prototype.hasOwnProperty.call(this, action) && this[action] === 1;
            };
        /***/ },
        /* 170 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Even though earlier versions of Chrome can support E2EE, let's just support
            // more recent versions for now.
            const isE2eeSupported = (env)=>!env.isIos && env.isChrome && env.version >= 99;
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                /* eslint-disable-next-line global-require */ const hasOpenTokSupport = deps.hasOpenTokSupport || __webpack_require__(52).once;
                /* eslint-disable-next-line global-require */ const env = deps.env || __webpack_require__(3);
                return hasOpenTokSupport() && isE2eeSupported(env);
            };
        /***/ },
        /* 171 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-shadow, no-underscore-dangle, max-len, no-use-before-define */ /* eslint-disable no-void, vars-on-top, no-var, no-restricted-syntax, no-prototype-builtins */ /* eslint-disable no-continue */ const logging = __webpack_require__(2)('Stream');
            const OTHelpers = __webpack_require__(8);
            const sessionObjects = __webpack_require__(21);
            const eventing = __webpack_require__(7);
            const Events = __webpack_require__(23)();
            const validPropertyNames = [
                'name',
                'archiving'
            ];
            /**
 * Specifies a stream. A stream is a representation of a published stream in a session. When a
 * client calls the <a href="Session.html#publish">Session.publish() method</a>, a new stream is
 * created. Properties of the Stream object provide information about the stream.
 *
 *  <p>When a stream is added to a session, the Session object dispatches a
 * <code>streamCreatedEvent</code>. When a stream is destroyed, the Session object dispatches a
 * <code>streamDestroyed</code> event. The StreamEvent object, which defines these event objects,
 * has a <code>stream</code> property, which is an array of Stream object. For details and a code
 * example, see {@link StreamEvent}.</p>
 *
 *  <p>When a connection to a session is made, the Session object dispatches a
 * <code>sessionConnected</code> event, defined by the SessionConnectEvent object. The
 * SessionConnectEvent object has a <code>streams</code> property, which is an array of Stream
 * objects pertaining to the streams in the session at that time. For details and a code example,
 * see {@link SessionConnectEvent}.</p>
 *
 * @class Stream
 * @property {Connection} connection The Connection object corresponding
 * to the connection that is publishing the stream. You can compare this to the
 * <code>connection</code> property of the Session object to see if the stream is being published
 * by the local web page.
 *
 * @property {Number} creationTime The timestamp for the creation
 * of the stream. This value is calculated in milliseconds. You can convert this value to a
 * Date object by calling <code>new Date(creationTime)</code>, where <code>creationTime</code> is
 * the <code>creationTime</code> property of the Stream object.
 *
 * @property {Number} frameRate The frame rate of the video stream. This property is only set if
 * the publisher of the stream specifies a frame rate when calling the
 * <code>OT.initPublisher()</code> method; otherwise, this property is undefined.
 *
 * @property {Boolean} hasAudio Whether the stream has audio. This property can change if the
 * publisher turns on or off audio (by calling
 * <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a>). When this occurs, the
 * {@link Session} object dispatches a <code>streamPropertyChanged</code> event (see
 * {@link StreamPropertyChangedEvent}).
 *
 * @property {Boolean} hasVideo Whether the stream has video. This property can change if the
 * publisher turns on or off video (by calling
 * <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>). When this occurs, the
 * {@link Session} object dispatches a <code>streamPropertyChanged</code> event (see
 * {@link StreamPropertyChangedEvent}).
 *
 * @property {String} name The name of the stream. Publishers can specify a name when publishing
 * a stream (using the <code>publish()</code> method of the publisher's Session object).
 *
 * @property {String} streamId The unique ID of the stream.
 *
 * @property {Object} videoDimensions This object has two properties: <code>width</code> and
 * <code>height</code>. Both are numbers. The <code>width</code> property is the width of the
 * encoded stream; the <code>height</code> property is the height of the encoded stream. (These
 * are independent of the actual width of Publisher and Subscriber objects corresponding to the
 * stream.) This property can change if a stream published from a mobile device resizes, based on
 * a change in the device orientation. When the video dimensions change,
 * the {@link Session} object dispatches a <code>streamPropertyChanged</code> event
 * (see {@link StreamPropertyChangedEvent}).
 *
 * @property {String} videoType The type of video &mdash; either <code>"camera"</code>,
 * <code>"screen"</code>, or <code>"custom"</code>.
 * A <code>"screen"</code> video uses screen sharing on the publisher
 * as the video source; for other videos, this property is set to <code>"camera"</code>.
 * A <code>"custom"</code> video uses a VideoTrack element as the video source on the publisher.
 * (See the <code>videoSource</code> property of the <code>options</code> parameter passed
 * into the <a href="OT.html#initPublisher">OT.initPublisher()</a> method.)
 * The <code>videoType</code> is <code>undefined</code> when a stream is voice-only
 * (see the <a href="https://tokbox.com/developer/guides/audio-video/js/#voice">Voice-only guide</a>).
 * This property can change if a stream published from a mobile device changes from a
 * camera to a screen-sharing video type. When the video type changes, the {@link Session} object
 * dispatches a <code>streamPropertyChanged</code> event (see {@link StreamPropertyChangedEvent}).
 */ module1.exports = function Stream(id, name, creationTime, connection, session, channel) {
                const self1 = this;
                let destroyedReason;
                this.id = id;
                this.streamId = id;
                this.name = name;
                this.creationTime = Number(creationTime);
                this.connection = connection;
                this.channel = channel;
                this.publisher = sessionObjects.publishers.find({
                    streamId: this.id
                });
                eventing(this);
                const onChannelUpdate = function onChannelUpdate(channel, key, oldValue, newValue) {
                    let _key = key;
                    switch(_key){
                        case 'active':
                            _key = channel.type === 'audio' ? 'hasAudio' : 'hasVideo';
                            self1[_key] = newValue;
                            break;
                        case 'disableWarning':
                            _key = channel.type === 'audio' ? 'audioDisableWarning' : 'videoDisableWarning';
                            self1[_key] = newValue;
                            if (!self1[channel.type === 'audio' ? 'hasAudio' : 'hasVideo']) return; // Do NOT event in this case.
                            break;
                        case 'fitMode':
                            _key = 'defaultFitMode';
                            self1[_key] = newValue;
                            break;
                        case 'source':
                            _key = channel.type === 'audio' ? 'audioType' : 'videoType';
                            self1[_key] = newValue;
                            break;
                        case 'videoDimensions':
                            self1.videoDimensions = newValue;
                            break;
                        case 'orientation':
                        case 'width':
                        case 'height':
                            // We dispatch this via the videoDimensions key instead so do not
                            // trigger an event for them.
                            return;
                        default:
                    }
                    if (self1.videoType === 'screen' && _key === 'hasVideo' && newValue === false) // if this stream is from a screen ignore hasVideo=false events from rumor
                    return;
                    self1.dispatchEvent(new Events.StreamUpdatedEvent(self1, _key, oldValue, newValue));
                };
                const associatedWidget = function associatedWidget() {
                    if (self1.publisher) return self1.publisher;
                    return sessionObjects.subscribers.find((subscriber)=>subscriber.stream && subscriber.stream.id === self1.id && subscriber.session.id === session.id);
                }; // Returns true if this stream is subscribe to.
                const isBeingSubscribedTo = function isBeingSubscribedTo() {
                    // @fixme This is not strictly speaking the right test as a stream
                    // can be published and subscribed by the same connection. But the
                    // update features don't handle this case properly right now anyway.
                    //
                    // The issue is that the stream needs to know whether the stream is
                    // 'owned' by a publisher or a subscriber. The reason for that is that
                    // when a Publisher updates a stream channel then we need to send the
                    // `streamChannelUpdate` message, whereas if a Subscriber does then we
                    // need to send `subscriberChannelUpdate`. The current code will always
                    // send `streamChannelUpdate`.
                    return !self1.publisher;
                }; // Returns all channels that have a type of +type+.
                this.getChannelsOfType = function getChannelsOfType(type) {
                    return self1.channel.filter((channel)=>channel.type === type);
                };
                this.getChannel = function getChannel(id) {
                    for(let i = 0; i < self1.channel.length; ++i){
                        if (self1.channel[i].id === id) return self1.channel[i];
                    }
                    return null;
                }; // implement the following using the channels
                // * hasAudio
                // * hasVideo
                // * videoDimensions
                const audioChannel = this.getChannelsOfType('audio')[0];
                const videoChannel = this.getChannelsOfType('video')[0]; // @todo this should really be: "has at least one video/audio track" instead of
                // "the first video/audio track"
                this.hasAudio = audioChannel != null && audioChannel.active;
                this.hasVideo = videoChannel != null && videoChannel.active;
                this.videoType = videoChannel && videoChannel.source;
                this.defaultFitMode = videoChannel && videoChannel.fitMode;
                this.videoDimensions = {};
                if (videoChannel) {
                    this.videoDimensions.width = videoChannel.width;
                    this.videoDimensions.height = videoChannel.height;
                    this.videoDimensions.orientation = videoChannel.orientation;
                    videoChannel.on('update', onChannelUpdate);
                    this.frameRate = videoChannel.frameRate;
                }
                if (audioChannel) audioChannel.on('update', onChannelUpdate);
                this.setChannelActiveState = function setChannelActiveState(channelType, activeState, activeReason) {
                    const attributes = {
                        active: activeState
                    };
                    if (activeReason) attributes.activeReason = activeReason;
                    updateChannelsOfType(channelType, attributes);
                };
                this.setVideoDimensions = function setVideoDimensions(width, height) {
                    updateChannelsOfType('video', {
                        width: width,
                        height: height,
                        orientation: 0
                    });
                };
                this.setRestrictFrameRate = function setRestrictFrameRate(restrict) {
                    updateChannelsOfType('video', {
                        restrictFrameRate: restrict
                    });
                };
                this.setPreferredResolution = function setPreferredResolution(resolution) {
                    if (!isBeingSubscribedTo()) {
                        logging.warn('setPreferredResolution has no affect when called by a publisher');
                        return;
                    }
                    if (session.sessionInfo.p2pEnabled) {
                        logging.warn('Stream.setPreferredResolution will not work in a P2P Session');
                        return;
                    }
                    if (resolution && resolution.width === void 0 && resolution.height === void 0) return;
                     // This duplicates some of the code in updateChannelsOfType. We do this for a
                    // couple of reasons:
                    //   1. Because most of the work that updateChannelsOfType does is in calling
                    //      getChannelsOfType, which we need to do here anyway so that we can update
                    //      the value of maxResolution in the Video Channel.
                    //   2. updateChannelsOfType on only sends a message to update the channel in
                    //      Rumor. The client then expects to receive a subsequent channel update
                    //      indicating that the update was successful. We don't receive those updates
                    //      for preferredFrameRate/maxResolution so we need to complete both tasks and it's
                    //      neater to do the related tasks right next to each other.
                    //   3. This code shouldn't be in Stream anyway. There is way too much coupling
                    //      between Stream, Session, Publisher, and Subscriber. This will eventually be
                    //      fixed, and when it is then it will be easier to exact the code if it's a
                    //      single piece.
                    //
                    const video = self1.getChannelsOfType('video')[0];
                    if (!video) return;
                    if (resolution && resolution.width) {
                        if (isNaN(parseInt(resolution.width, 10))) throw new OTHelpers.Error('stream preferred width must be an integer', 'Subscriber');
                        video.preferredWidth = parseInt(resolution.width, 10);
                    } else video.preferredWidth = void 0;
                    if (resolution && resolution.height) {
                        if (isNaN(parseInt(resolution.height, 10))) throw new OTHelpers.Error('stream preferred height must be an integer', 'Subscriber');
                        video.preferredHeight = parseInt(resolution.height, 10);
                    } else video.preferredHeight = void 0;
                    session._.subscriberChannelUpdate(self1, associatedWidget(), video, {
                        preferredWidth: video.preferredWidth || 0,
                        preferredHeight: video.preferredHeight || 0
                    });
                };
                this.getPreferredResolution = function getPreferredResolution() {
                    const videoChannel = self1.getChannelsOfType('video')[0];
                    if (!videoChannel || !videoChannel.preferredWidth && !videoChannel.preferredHeight) return void 0;
                    return {
                        width: videoChannel.preferredWidth,
                        height: videoChannel.preferredHeight
                    };
                };
                this.setPreferredFrameRate = function setPreferredFrameRate(preferredFrameRate) {
                    if (!isBeingSubscribedTo()) {
                        logging.warn('setPreferredFrameRate has no affect when called by a publisher');
                        return;
                    }
                    if (session.sessionInfo.p2pEnabled) {
                        logging.warn('Stream.setPreferredFrameRate will not work in a P2P Session');
                        return;
                    }
                    if (preferredFrameRate && isNaN(parseFloat(preferredFrameRate))) throw new OTHelpers.Error('stream preferred frameRate must be a number', 'Subscriber');
                     // This duplicates some of the code in updateChannelsOfType. We do this for a
                    // couple of reasons:
                    //   1. Because most of the work that updateChannelsOfType does is in calling
                    //      getChannelsOfType, which we need to do here anyway so that we can update
                    //      the value of preferredFrameRate in the Video Channel.
                    //   2. updateChannelsOfType on only sends a message to update the channel in
                    //      Rumor. The client then expects to receive a subsequent channel update
                    //      indicating that the update was successful. We don't receive those updates
                    //      for preferredFrameRate/maxResolution so we need to complete both tasks and it's
                    //      neater to do the related tasks right next to each other.
                    //   3. This code shouldn't be in Stream anyway. There is way too much coupling
                    //      between Stream, Session, Publisher, and Subscriber. This will eventually be
                    //      fixed, and when it is then it will be easier to exact the code if it's a
                    //      single piece.
                    //
                    const video = self1.getChannelsOfType('video')[0];
                    if (video) {
                        video.preferredFrameRate = preferredFrameRate ? parseFloat(preferredFrameRate) : null;
                        session._.subscriberChannelUpdate(self1, associatedWidget(), video, {
                            preferredFrameRate: video.preferredFrameRate || 0
                        });
                    }
                };
                this.getPreferredFrameRate = function getPreferredFrameRate() {
                    const videoChannel = self1.getChannelsOfType('video')[0];
                    return videoChannel ? videoChannel.preferredFrameRate : null;
                };
                let updateChannelsOfType = function updateChannelsOfType(channelType, attributes) {
                    let setChannelActiveState;
                    if (!self1.publisher) {
                        const subscriber = associatedWidget();
                        setChannelActiveState = (channel)=>session._.subscriberChannelUpdate(self1, subscriber, channel, attributes);
                    } else setChannelActiveState = (channel)=>session._.streamChannelUpdate(self1, channel, attributes);
                    self1.getChannelsOfType(channelType).forEach(setChannelActiveState);
                };
                this.destroyed = false;
                this.destroyedReason = void 0;
                this.destroy = function destroy(reason, quiet) {
                    if (reason === void 0) reason = 'clientDisconnected';
                    destroyedReason = reason;
                    self1.destroyed = true;
                    self1.destroyedReason = destroyedReason;
                    if (quiet !== true) self1.dispatchEvent(new Events.DestroyedEvent('destroyed', // the value of that is currently shared with Session
                    self1, destroyedReason));
                }; // PRIVATE STUFF CALLED BY Raptor.Dispatcher
                //
                // Confusingly, this should not be called when you want to change
                // the stream properties. This is used by Raptor dispatch to notify
                // the stream that it's properties have been successfully updated
                //
                // @todo make this sane. Perhaps use setters for the properties that can
                // send the appropriate Raptor message. This would require that Streams
                // have access to their session.
                this._ = {};
                this._.updateProperty = function privateUpdateProperty(key, value) {
                    if (validPropertyNames.indexOf(key) === -1) {
                        logging.warn(`Unknown stream property "${key}" was modified to "${value}".`);
                        return;
                    }
                    const oldValue = self1[key];
                    const newValue = value;
                    switch(key){
                        case 'name':
                            self1[key] = newValue;
                            break;
                        case 'archiving':
                            var widget = associatedWidget();
                            if (self1.publisher && widget) widget._.archivingStatus(newValue);
                            self1[key] = newValue;
                            break;
                        default:
                    }
                    const event = new Events.StreamUpdatedEvent(self1, key, oldValue, newValue);
                    self1.dispatchEvent(event);
                }; // Mass update, called by Raptor.Dispatcher
                this._.update = function privateUpdate(attributes) {
                    for(const key in attributes){
                        if (!attributes.hasOwnProperty(key)) continue;
                        self1._.updateProperty(key, attributes[key]);
                    }
                };
                this._.forceMute = function forceMute(content) {
                    if (content.hasOwnProperty('channels')) {
                        if (content.channels.includes('audio')) {
                            if (self1.publisher) self1.publisher._.forceMuteAudio();
                        }
                    }
                };
                this._.updateChannel = function privateUpdateChannel(channelId, attributes) {
                    const channel = self1.getChannel(channelId);
                    if (channel) channel.update(attributes);
                };
            };
        /***/ },
        /* 172 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.STATUS = exports.PONG = exports.PING = exports.DISCONNECT = exports.CONNECT = exports.MESSAGE = exports.UNSUBSCRIBE = exports.SUBSCRIBE = void 0;
            // Rumor Messaging for JS
            //
            // https://tbwiki.tokbox.com/index.php/Rumor_:_Messaging_FrameWork
            //
            // @todo Rumor {
            //     Add error codes for all the error cases
            //     Add Dependability commands
            // }
            // This is used to subscribe to address/addresses. The address/addresses the
            // client specifies here is registered on the server. Once any message is sent to
            // that address/addresses, the client receives that message.
            const SUBSCRIBE = 0; // This is used to unsubscribe to address / addresses. Once the client unsubscribe
            // to an address, it will stop getting messages sent to that address.
            exports.SUBSCRIBE = SUBSCRIBE;
            const UNSUBSCRIBE = 1; // This is used to send messages to arbitrary address/ addresses. Messages can be
            // anything and Rumor will not care about what is included.
            exports.UNSUBSCRIBE = UNSUBSCRIBE;
            const MESSAGE = 2; // This will be the first message that the client sends to the server. It includes
            // the uniqueId for that client connection and a disconnect_notify address that will
            // be notified once the client disconnects.
            exports.MESSAGE = MESSAGE;
            const CONNECT = 3; // This will be the message used by the server to notify an address that a
            // client disconnected.
            exports.CONNECT = CONNECT;
            const DISCONNECT = 4; // Enhancements to support Keepalives
            exports.DISCONNECT = DISCONNECT;
            const PING = 7;
            exports.PING = PING;
            const PONG = 8;
            exports.PONG = PONG;
            const STATUS = 9;
            exports.STATUS = STATUS;
        /***/ },
        /* 173 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const assign = __webpack_require__(9);
            const Capabilities = __webpack_require__(169);
            const eventing = __webpack_require__(7);
            const Events = __webpack_require__(23)();
            const connectionCapabilities = __webpack_require__(735);
            /**
 * The Connection object represents a connection to an OpenTok session. Each client that connects
 * to a session has a unique connection, with a unique connection ID (represented by the
 * <code>id</code> property of the Connection object for the client).
 * <p>
 * The Session object has a <code>connection</code> property that is a Connection object.
 * It represents the local client's connection. (A client only has a connection once the
 * client has successfully called the <code>connect()</code> method of the {@link Session}
 * object.)
 * <p>
 * The Session object dispatches a <code>connectionCreated</code> event when each client (including
 * your own) connects to a session (and for clients that are present in the session when you
 * connect). The <code>connectionCreated</code> event object has a <code>connection</code>
 * property, which is a Connection object corresponding to the client the event pertains to.
 * <p>
 * The Stream object has a <code>connection</code> property that is a Connection object.
 * It represents the connection of the client that is publishing the stream.
 *
 * @class Connection
 * @property {String} connectionId The ID of this connection.
 * @property {Number} creationTime The timestamp for the creation of the connection. This
 * value is calculated in milliseconds.
 * You can convert this value to a Date object by calling <code>new Date(creationTime)</code>,
 * where <code>creationTime</code>
 * is the <code>creationTime</code> property of the Connection object.
 * @property {String} data A string containing metadata describing the
 * connection. When you generate a user token, you can define connection data (see the
 * <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
 */ function Connection(id, creationTime, data, capabilitiesHash, permissionsHash) {
                let destroyedReason;
                this.id = id;
                this.connectionId = id;
                this.creationTime = creationTime ? Number(creationTime) : null;
                this.data = data;
                this.capabilities = connectionCapabilities(capabilitiesHash);
                this.permissions = new Capabilities(permissionsHash);
                this.quality = null;
                eventing(this);
                this.destroy = (reason, quiet)=>{
                    destroyedReason = reason || 'clientDisconnected';
                    if (quiet !== true) this.dispatchEvent(new Events.DestroyedEvent(// the value of that is currently shared with Session
                    'destroyed', this, destroyedReason));
                };
                this.destroyed = ()=>destroyedReason !== undefined;
                this.destroyedReason = ()=>destroyedReason;
            }
            Connection.fromHash = (_ref)=>{
                let id = _ref.id, creationTime = _ref.creationTime, data = _ref.data, capablities = _ref.capablities, permissions = _ref.permissions;
                return new Connection(id, creationTime, data, assign(capablities || {}, {
                    supportsWebRTC: true
                }), permissions || []);
            };
            module1.exports = Connection;
        /***/ },
        /* 174 */ /***/ function(module1, exports) {
            /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof window == 'object' && window && window.Object === Object && window;
            module1.exports = freeGlobal;
        /***/ },
        /* 175 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var funcProto = Function.prototype;
            /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
            /**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + '';
                    } catch (e) {}
                }
                return '';
            }
            module1.exports = toSource;
        /***/ },
        /* 176 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39);
            var defineProperty = function() {
                try {
                    var func = getNative(Object, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            module1.exports = defineProperty;
        /***/ },
        /* 177 */ /***/ function(module1, exports, __webpack_require__) {
            var copyObject = __webpack_require__(41), keys = __webpack_require__(30);
            /**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
            }
            module1.exports = baseAssign;
        /***/ },
        /* 178 */ /***/ function(module1, exports, __webpack_require__) {
            var baseTimes = __webpack_require__(375), isArguments = __webpack_require__(65), isArray = __webpack_require__(12), isBuffer = __webpack_require__(66), isIndex = __webpack_require__(67), isTypedArray = __webpack_require__(86);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                for(var key in value)if ((inherited || hasOwnProperty1.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
                (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
                isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
                isIndex(key, length)))) result.push(key);
                return result;
            }
            module1.exports = arrayLikeKeys;
        /***/ },
        /* 179 */ /***/ function(module1, exports) {
            /**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
                return function(arg) {
                    return func(transform(arg));
                };
            }
            module1.exports = overArg;
        /***/ },
        /* 180 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(module1) {
                var root = __webpack_require__(14);
                /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
                /** Detect free variable `module`. */ var freeModule = freeExports && typeof module1 == 'object' && module1 && !module1.nodeType && module1;
                /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
                /** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
                /**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
                    if (isDeep) return buffer.slice();
                    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                    buffer.copy(result);
                    return result;
                }
                module1.exports = cloneBuffer;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(85)(module1));
        /***/ },
        /* 181 */ /***/ function(module1, exports) {
            /**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
                return [];
            }
            module1.exports = stubArray;
        /***/ },
        /* 182 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayPush = __webpack_require__(116), getPrototype = __webpack_require__(117), getSymbols = __webpack_require__(115), stubArray = __webpack_require__(181);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
            /**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
                var result = [];
                while(object){
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                }
                return result;
            };
            module1.exports = getSymbolsIn;
        /***/ },
        /* 183 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetAllKeys = __webpack_require__(184), getSymbols = __webpack_require__(115), keys = __webpack_require__(30);
            /**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
            }
            module1.exports = getAllKeys;
        /***/ },
        /* 184 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayPush = __webpack_require__(116), isArray = __webpack_require__(12);
            /**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            module1.exports = baseGetAllKeys;
        /***/ },
        /* 185 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetAllKeys = __webpack_require__(184), getSymbolsIn = __webpack_require__(182), keysIn = __webpack_require__(55);
            /**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            module1.exports = getAllKeysIn;
        /***/ },
        /* 186 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39), root = __webpack_require__(14);
            /* Built-in method references that are verified to be native. */ var Set1 = getNative(root, 'Set');
            module1.exports = Set1;
        /***/ },
        /* 187 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39), root = __webpack_require__(14);
            /* Built-in method references that are verified to be native. */ var WeakMap1 = getNative(root, 'WeakMap');
            module1.exports = WeakMap1;
        /***/ },
        /* 188 */ /***/ function(module1, exports, __webpack_require__) {
            var root = __webpack_require__(14);
            /** Built-in value references. */ var Uint8Array1 = root.Uint8Array;
            module1.exports = Uint8Array1;
        /***/ },
        /* 189 */ /***/ function(module1, exports, __webpack_require__) {
            var cloneArrayBuffer = __webpack_require__(118);
            /**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            module1.exports = cloneTypedArray;
        /***/ },
        /* 190 */ /***/ function(module1, exports, __webpack_require__) {
            var baseCreate = __webpack_require__(87), getPrototype = __webpack_require__(117), isPrototype = __webpack_require__(69);
            /**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            module1.exports = initCloneObject;
        /***/ },
        /* 191 */ /***/ function(module1, exports, __webpack_require__) {
            var MapCache = __webpack_require__(110);
            /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
            /**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) return cache.get(key);
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache);
                return memoized;
            }
            // Expose `MapCache`.
            memoize.Cache = MapCache;
            module1.exports = memoize;
        /***/ },
        /* 192 */ /***/ function(module1, exports, __webpack_require__) {
            var baseRest = __webpack_require__(88), isIterateeCall = __webpack_require__(122);
            /**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
                return baseRest(function(object, sources) {
                    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                        customizer = length < 3 ? undefined : customizer;
                        length = 1;
                    }
                    object = Object(object);
                    while(++index < length){
                        var source = sources[index];
                        if (source) assigner(object, source, index, customizer);
                    }
                    return object;
                });
            }
            module1.exports = createAssigner;
        /***/ },
        /* 193 */ /***/ function(module1, exports, __webpack_require__) {
            var apply = __webpack_require__(120);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
            /**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function() {
                    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
                    while(++index < length)array[index] = args[start + index];
                    index = -1;
                    var otherArgs = Array(start + 1);
                    while(++index < start)otherArgs[index] = args[index];
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                };
            }
            module1.exports = overRest;
        /***/ },
        /* 194 */ /***/ function(module1, exports) {
            /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
            /**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
                var count = 0, lastCalled = 0;
                return function() {
                    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                    lastCalled = stamp;
                    if (remaining > 0) {
                        if (++count >= HOT_COUNT) return arguments[0];
                    } else count = 0;
                    return func.apply(undefined, arguments);
                };
            }
            module1.exports = shortOut;
        /***/ },
        /* 195 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(403)() ? WeakMap : __webpack_require__(404);
        /***/ },
        /* 196 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};
            module1.exports = function() {
                var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
                if (typeof setPrototypeOf !== "function") return false;
                return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
            };
        /***/ },
        /* 197 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint no-proto: "off" */ // Big thanks to @WebReflection for sorting this out
            // https://gist.github.com/WebReflection/5593554
            var isObject = __webpack_require__(198), value = __webpack_require__(32), objIsPrototypeOf = Object.prototype.isPrototypeOf, defineProperty = Object.defineProperty, nullDesc = {
                configurable: true,
                enumerable: false,
                writable: true,
                value: undefined
            }, validate;
            validate = function(obj, prototype) {
                value(obj);
                if (prototype === null || isObject(prototype)) return obj;
                throw new TypeError("Prototype must be null or an object");
            };
            module1.exports = function(status) {
                var fn, set;
                if (!status) return null;
                if (status.level === 2) {
                    if (status.set) {
                        set = status.set;
                        fn = function(obj, prototype) {
                            set.call(validate(obj, prototype), prototype);
                            return obj;
                        };
                    } else fn = function(obj, prototype) {
                        validate(obj, prototype).__proto__ = prototype;
                        return obj;
                    };
                } else fn = function self1(obj, prototype) {
                    var isNullBase;
                    validate(obj, prototype);
                    isNullBase = objIsPrototypeOf.call(self1.nullPolyfill, obj);
                    if (isNullBase) delete self1.nullPolyfill.__proto__;
                    if (prototype === null) prototype = self1.nullPolyfill;
                    obj.__proto__ = prototype;
                    if (isNullBase) defineProperty(self1.nullPolyfill, "__proto__", nullDesc);
                    return obj;
                };
                return Object.defineProperty(fn, "level", {
                    configurable: false,
                    enumerable: false,
                    writable: false,
                    value: status.level
                });
            }(function() {
                var tmpObj1 = Object.create(null), tmpObj2 = {}, set, desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
                if (desc) {
                    try {
                        set = desc.set; // Opera crashes at this point
                        set.call(tmpObj1, tmpObj2);
                    } catch (ignore) {}
                    if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
                        set: set,
                        level: 2
                    };
                }
                tmpObj1.__proto__ = tmpObj2;
                if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
                    level: 2
                };
                tmpObj1 = {};
                tmpObj1.__proto__ = tmpObj2;
                if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return {
                    level: 1
                };
                return false;
            }());
            __webpack_require__(406);
        /***/ },
        /* 198 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(44);
            var map = {
                function: true,
                object: true
            };
            module1.exports = function(value) {
                return isValue(value) && map[typeof value] || false;
            };
        /***/ },
        /* 199 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isFunction = __webpack_require__(409);
            var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;
            module1.exports = function(value) {
                if (!isFunction(value)) return false;
                if (classRe.test(functionToString.call(value))) return false;
                return true;
            };
        /***/ },
        /* 200 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(44);
            var forEach = Array.prototype.forEach, create = Object.create;
            var process = function(src, obj) {
                var key;
                for(key in src)obj[key] = src[key];
            };
            // eslint-disable-next-line no-unused-vars
            module1.exports = function(opts1 /*, …options*/ ) {
                var result = create(null);
                forEach.call(arguments, function(options) {
                    if (!isValue(options)) return;
                    process(Object(options), result);
                });
                return result;
            };
        /***/ },
        /* 201 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(416)() ? String.prototype.contains : __webpack_require__(417);
        /***/ },
        /* 202 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isArguments = __webpack_require__(90), isString = __webpack_require__(91), ArrayIterator = __webpack_require__(418), StringIterator = __webpack_require__(447), iterable = __webpack_require__(448), iteratorSymbol = __webpack_require__(45).iterator;
            module1.exports = function(obj) {
                if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
                if (isArguments(obj)) return new ArrayIterator(obj);
                if (isString(obj)) return new StringIterator(obj);
                return new ArrayIterator(obj);
            };
        /***/ },
        /* 203 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isSymbol = __webpack_require__(423);
            module1.exports = function(value) {
                if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
                return value;
            };
        /***/ },
        /* 204 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var clear = __webpack_require__(427), assign = __webpack_require__(125), callable = __webpack_require__(70), value = __webpack_require__(32), d = __webpack_require__(33), autoBind = __webpack_require__(428), Symbol1 = __webpack_require__(45);
            var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;
            module1.exports = Iterator = function(list, context) {
                if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
                defineProperties(this, {
                    __list__: d("w", value(list)),
                    __context__: d("w", context),
                    __nextIndex__: d("w", 0)
                });
                if (!context) return;
                callable(context.on);
                context.on("_add", this._onAdd);
                context.on("_delete", this._onDelete);
                context.on("_clear", this._onClear);
            };
            // Internal %IteratorPrototype% doesn't expose its constructor
            delete Iterator.prototype.constructor;
            defineProperties(Iterator.prototype, assign({
                _next: d(function() {
                    var i;
                    if (!this.__list__) return undefined;
                    if (this.__redo__) {
                        i = this.__redo__.shift();
                        if (i !== undefined) return i;
                    }
                    if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
                    this._unBind();
                    return undefined;
                }),
                next: d(function() {
                    return this._createResult(this._next());
                }),
                _createResult: d(function(i) {
                    if (i === undefined) return {
                        done: true,
                        value: undefined
                    };
                    return {
                        done: false,
                        value: this._resolve(i)
                    };
                }),
                _resolve: d(function(i) {
                    return this.__list__[i];
                }),
                _unBind: d(function() {
                    this.__list__ = null;
                    delete this.__redo__;
                    if (!this.__context__) return;
                    this.__context__.off("_add", this._onAdd);
                    this.__context__.off("_delete", this._onDelete);
                    this.__context__.off("_clear", this._onClear);
                    this.__context__ = null;
                }),
                toString: d(function() {
                    return "[object " + (this[Symbol1.toStringTag] || "Object") + "]";
                })
            }, autoBind({
                _onAdd: d(function(index) {
                    if (index >= this.__nextIndex__) return;
                    ++this.__nextIndex__;
                    if (!this.__redo__) {
                        defineProperty(this, "__redo__", d("c", [
                            index
                        ]));
                        return;
                    }
                    this.__redo__.forEach(function(redo, i) {
                        if (redo >= index) this.__redo__[i] = ++redo;
                    }, this);
                    this.__redo__.push(index);
                }),
                _onDelete: d(function(index) {
                    var i;
                    if (index >= this.__nextIndex__) return;
                    --this.__nextIndex__;
                    if (!this.__redo__) return;
                    i = this.__redo__.indexOf(index);
                    if (i !== -1) this.__redo__.splice(i, 1);
                    this.__redo__.forEach(function(redo, j) {
                        if (redo > index) this.__redo__[j] = --redo;
                    }, this);
                }),
                _onClear: d(function() {
                    if (this.__redo__) clear.call(this.__redo__);
                    this.__nextIndex__ = 0;
                })
            })));
            defineProperty(Iterator.prototype, Symbol1.iterator, d(function() {
                return this;
            }));
        /***/ },
        /* 205 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(57), isObject = __webpack_require__(124), stringCoerce = __webpack_require__(430), toShortString = __webpack_require__(431);
            var resolveMessage = function(message, value) {
                return message.replace("%v", toShortString(value));
            };
            module1.exports = function(value, defaultMessage, inputOptions) {
                if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
                if (!isValue(value)) {
                    if ("default" in inputOptions) return inputOptions["default"];
                    if (inputOptions.isOptional) return null;
                }
                var errorMessage = stringCoerce(inputOptions.errorMessage);
                if (!isValue(errorMessage)) errorMessage = defaultMessage;
                throw new TypeError(resolveMessage(errorMessage, value));
            };
        /***/ },
        /* 206 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
                var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
                while(fromRight ? index-- : ++index < length){
                    if (predicate(array[index], index, array)) return index;
                }
                return -1;
            }
            module1.exports = baseFindIndex;
        /***/ },
        /* 207 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(459);
        /***/ },
        /* 208 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function bind(fn, thisArg) {
                return function wrap() {
                    var args = new Array(arguments.length);
                    for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                    return fn.apply(thisArg, args);
                };
            };
        /***/ },
        /* 209 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            function encode(val) {
                return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
            }
            /**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module1.exports = function buildURL(url, params, paramsSerializer) {
                /*eslint no-param-reassign:0*/ if (!params) return url;
                var serializedParams;
                if (paramsSerializer) serializedParams = paramsSerializer(params);
                else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
                else {
                    var parts = [];
                    utils.forEach(params, function serialize(val, key) {
                        if (val === null || typeof val === 'undefined') return;
                        if (utils.isArray(val)) key = key + '[]';
                        else val = [
                            val
                        ];
                        utils.forEach(val, function parseValue(v) {
                            if (utils.isDate(v)) v = v.toISOString();
                            else if (utils.isObject(v)) v = JSON.stringify(v);
                            parts.push(encode(key) + '=' + encode(v));
                        });
                    });
                    serializedParams = parts.join('&');
                }
                if (serializedParams) {
                    var hashmarkIndex = url.indexOf('#');
                    if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
                    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
                }
                return url;
            };
        /***/ },
        /* 210 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function isCancel(value) {
                return !!(value && value.__CANCEL__);
            };
        /***/ },
        /* 211 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(process) {
                var utils = __webpack_require__(20);
                var normalizeHeaderName = __webpack_require__(464);
                var DEFAULT_CONTENT_TYPE = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
                function setContentTypeIfUnset(headers, value) {
                    if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
                }
                function getDefaultAdapter() {
                    var adapter;
                    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
                    adapter = __webpack_require__(212);
                    else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') // For node use HTTP adapter
                    adapter = __webpack_require__(212);
                    return adapter;
                }
                var defaults = {
                    adapter: getDefaultAdapter(),
                    transformRequest: [
                        function transformRequest(data, headers) {
                            normalizeHeaderName(headers, 'Accept');
                            normalizeHeaderName(headers, 'Content-Type');
                            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
                            if (utils.isArrayBufferView(data)) return data.buffer;
                            if (utils.isURLSearchParams(data)) {
                                setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                                return data.toString();
                            }
                            if (utils.isObject(data)) {
                                setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                                return JSON.stringify(data);
                            }
                            return data;
                        }
                    ],
                    transformResponse: [
                        function transformResponse(data) {
                            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                                data = JSON.parse(data);
                            } catch (e) {}
                            return data;
                        }
                    ],
                    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
                    xsrfCookieName: 'XSRF-TOKEN',
                    xsrfHeaderName: 'X-XSRF-TOKEN',
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function validateStatus(status) {
                        return status >= 200 && status < 300;
                    }
                };
                defaults.headers = {
                    common: {
                        'Accept': 'application/json, text/plain, */*'
                    }
                };
                utils.forEach([
                    'delete',
                    'get',
                    'head'
                ], function forEachMethodNoData(method) {
                    defaults.headers[method] = {};
                });
                utils.forEach([
                    'post',
                    'put',
                    'patch'
                ], function forEachMethodWithData(method) {
                    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
                });
                module1.exports = defaults;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(43));
        /***/ },
        /* 212 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var utils = __webpack_require__(20);
                var settle = __webpack_require__(465);
                var cookies = __webpack_require__(467);
                var buildURL = __webpack_require__(209);
                var buildFullPath = __webpack_require__(468);
                var parseHeaders = __webpack_require__(471);
                var isURLSameOrigin = __webpack_require__(472);
                var createError = __webpack_require__(213);
                module1.exports = function xhrAdapter(config) {
                    return new Promise(function dispatchXhrRequest(resolve, reject) {
                        var requestData = config.data;
                        var requestHeaders = config.headers;
                        if (utils.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
                        var request = new XMLHttpRequest();
                        // HTTP basic authentication
                        if (config.auth) {
                            var username = config.auth.username || '';
                            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
                            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
                        }
                        var fullPath = buildFullPath(config.baseURL, config.url);
                        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
                        // Set the request timeout in MS
                        request.timeout = config.timeout;
                        // Listen for ready state
                        request.onreadystatechange = function handleLoad() {
                            if (!request || request.readyState !== 4) return;
                            // The request errored out and we didn't get a response, this will be
                            // handled by onerror instead
                            // With one exception: request that using file: protocol, most browsers
                            // will return status as 0 even though it's a successful request
                            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
                            // Prepare the response
                            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
                            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
                            var response = {
                                data: responseData,
                                status: request.status,
                                statusText: request.statusText,
                                headers: responseHeaders,
                                config: config,
                                request: request
                            };
                            settle(resolve, reject, response);
                            // Clean up request
                            request = null;
                        };
                        // Handle browser request cancellation (as opposed to a manual cancellation)
                        request.onabort = function handleAbort() {
                            if (!request) return;
                            reject(createError('Request aborted', config, 'ECONNABORTED', request));
                            // Clean up request
                            request = null;
                        };
                        // Handle low level network errors
                        request.onerror = function handleError() {
                            // Real errors are hidden from us by the browser
                            // onerror should only fire if it's a network error
                            reject(createError('Network Error', config, null, request));
                            // Clean up request
                            request = null;
                        };
                        // Handle timeout
                        request.ontimeout = function handleTimeout() {
                            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
                            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
                            reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));
                            // Clean up request
                            request = null;
                        };
                        // Add xsrf header
                        // This is only done if running in a standard browser environment.
                        // Specifically not if we're in a web worker, or react-native.
                        if (utils.isStandardBrowserEnv()) {
                            // Add xsrf header
                            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
                            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
                        }
                        // Add headers to the request
                        if ('setRequestHeader' in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
                            delete requestHeaders[key];
                            else // Otherwise add header to the request
                            request.setRequestHeader(key, val);
                        });
                        // Add withCredentials to request if needed
                        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
                        // Add responseType to request if needed
                        if (config.responseType) try {
                            request.responseType = config.responseType;
                        } catch (e) {
                            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                            if (config.responseType !== 'json') throw e;
                        }
                        // Handle progress if needed
                        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
                        // Not all browsers support upload events
                        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
                        if (config.cancelToken) // Handle cancellation
                        config.cancelToken.promise.then(function onCanceled(cancel) {
                            if (!request) return;
                            request.abort();
                            reject(cancel);
                            // Clean up request
                            request = null;
                        });
                        if (!requestData) requestData = null;
                        // Send the request
                        request.send(requestData);
                    });
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 213 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var enhanceError = __webpack_require__(466);
            /**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module1.exports = function createError(message, config, code, request, response) {
                var error = new Error(message);
                return enhanceError(error, config, code, request, response);
            };
        /***/ },
        /* 214 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            /**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module1.exports = function mergeConfig(config1, config2) {
                // eslint-disable-next-line no-param-reassign
                config2 = config2 || {};
                var config = {};
                var valueFromConfig2Keys = [
                    'url',
                    'method',
                    'data'
                ];
                var mergeDeepPropertiesKeys = [
                    'headers',
                    'auth',
                    'proxy',
                    'params'
                ];
                var defaultToConfig2Keys = [
                    'baseURL',
                    'transformRequest',
                    'transformResponse',
                    'paramsSerializer',
                    'timeout',
                    'timeoutMessage',
                    'withCredentials',
                    'adapter',
                    'responseType',
                    'xsrfCookieName',
                    'xsrfHeaderName',
                    'onUploadProgress',
                    'onDownloadProgress',
                    'decompress',
                    'maxContentLength',
                    'maxBodyLength',
                    'maxRedirects',
                    'transport',
                    'httpAgent',
                    'httpsAgent',
                    'cancelToken',
                    'socketPath',
                    'responseEncoding'
                ];
                var directMergeKeys = [
                    'validateStatus'
                ];
                function getMergedValue(target, source) {
                    if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
                    else if (utils.isPlainObject(source)) return utils.merge({}, source);
                    else if (utils.isArray(source)) return source.slice();
                    return source;
                }
                function mergeDeepProperties(prop) {
                    if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
                    else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                }
                utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
                    if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                });
                utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
                utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
                    if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                    else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                });
                utils.forEach(directMergeKeys, function merge(prop) {
                    if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
                    else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
                });
                var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
                var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
                    return axiosKeys.indexOf(key) === -1;
                });
                utils.forEach(otherKeys, mergeDeepProperties);
                return config;
            };
        /***/ },
        /* 215 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function Cancel(message) {
                this.message = message;
            }
            Cancel.prototype.toString = function toString() {
                return 'Cancel' + (this.message ? ': ' + this.message : '');
            };
            Cancel.prototype.__CANCEL__ = true;
            module1.exports = Cancel;
        /***/ },
        /* 216 */ /***/ function(module1, exports, __webpack_require__) {
            var baseConvert = __webpack_require__(477), util = __webpack_require__(479);
            /**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function convert(name, func, options) {
                return baseConvert(util, name, func, options);
            }
            module1.exports = convert;
        /***/ },
        /* 217 */ /***/ function(module1, exports, __webpack_require__) {
            var identity = __webpack_require__(89), metaMap = __webpack_require__(218);
            /**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var baseSetData = !metaMap ? identity : function(func, data) {
                metaMap.set(func, data);
                return func;
            };
            module1.exports = baseSetData;
        /***/ },
        /* 218 */ /***/ function(module1, exports, __webpack_require__) {
            var WeakMap1 = __webpack_require__(187);
            /** Used to store function metadata. */ var metaMap = WeakMap1 && new WeakMap1;
            module1.exports = metaMap;
        /***/ },
        /* 219 */ /***/ function(module1, exports, __webpack_require__) {
            var composeArgs = __webpack_require__(220), composeArgsRight = __webpack_require__(221), countHolders = __webpack_require__(483), createCtor = __webpack_require__(96), createRecurry = __webpack_require__(222), getHolder = __webpack_require__(228), reorder = __webpack_require__(492), replaceHolders = __webpack_require__(134), root = __webpack_require__(14);
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_ARY_FLAG = 128, WRAP_FLIP_FLAG = 512;
            /**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array(length), index = length;
                    while(index--)args[index] = arguments[index];
                    if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                    if (partials) args = composeArgs(args, partials, holders, isCurried);
                    if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                    length -= holdersCount;
                    if (isCurried && length < arity) {
                        var newHolders = replaceHolders(args, placeholder);
                        return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                    }
                    var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                    length = args.length;
                    if (argPos) args = reorder(args, argPos);
                    else if (isFlip && length > 1) args.reverse();
                    if (isAry && ary < length) args.length = ary;
                    if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                    return fn.apply(thisBinding, args);
                }
                return wrapper;
            }
            module1.exports = createHybrid;
        /***/ },
        /* 220 */ /***/ function(module1, exports) {
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
            /**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
                while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
                while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
                while(rangeLength--)result[leftIndex++] = args[argsIndex++];
                return result;
            }
            module1.exports = composeArgs;
        /***/ },
        /* 221 */ /***/ function(module1, exports) {
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
            /**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
                while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
                var offset = argsIndex;
                while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
                while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
                return result;
            }
            module1.exports = composeArgsRight;
        /***/ },
        /* 222 */ /***/ function(module1, exports, __webpack_require__) {
            var isLaziable = __webpack_require__(484), setData = __webpack_require__(226), setWrapToString = __webpack_require__(227);
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
            /**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newHolders,
                    newPartialsRight,
                    newHoldersRight,
                    argPos,
                    ary,
                    arity
                ];
                var result = wrapFunc.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
            }
            module1.exports = createRecurry;
        /***/ },
        /* 223 */ /***/ function(module1, exports, __webpack_require__) {
            var metaMap = __webpack_require__(218), noop = __webpack_require__(224);
            /**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
                return metaMap.get(func);
            };
            module1.exports = getData;
        /***/ },
        /* 224 */ /***/ function(module1, exports) {
            /**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
            // No operation performed.
            }
            module1.exports = noop;
        /***/ },
        /* 225 */ /***/ function(module1, exports, __webpack_require__) {
            var baseCreate = __webpack_require__(87), baseLodash = __webpack_require__(133);
            /**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
            }
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            module1.exports = LodashWrapper;
        /***/ },
        /* 226 */ /***/ function(module1, exports, __webpack_require__) {
            var baseSetData = __webpack_require__(217), shortOut = __webpack_require__(194);
            /**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var setData = shortOut(baseSetData);
            module1.exports = setData;
        /***/ },
        /* 227 */ /***/ function(module1, exports, __webpack_require__) {
            var getWrapDetails = __webpack_require__(489), insertWrapDetails = __webpack_require__(490), setToString = __webpack_require__(121), updateWrapDetails = __webpack_require__(491);
            /**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            module1.exports = setWrapToString;
        /***/ },
        /* 228 */ /***/ function(module1, exports) {
            /**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function getHolder(func) {
                var object = func;
                return object.placeholder;
            }
            module1.exports = getHolder;
        /***/ },
        /* 229 */ /***/ function(module1, exports, __webpack_require__) {
            var baseTrim = __webpack_require__(496), isObject = __webpack_require__(11), isSymbol = __webpack_require__(71);
            /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
            /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
            /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
            /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
            /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
            /**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                }
                if (typeof value != 'string') return value === 0 ? value : +value;
                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            module1.exports = toNumber;
        /***/ },
        /* 230 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsEqualDeep = __webpack_require__(504), isObjectLike = __webpack_require__(18);
            /**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) return true;
                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            module1.exports = baseIsEqual;
        /***/ },
        /* 231 */ /***/ function(module1, exports, __webpack_require__) {
            var SetCache = __webpack_require__(93), arraySome = __webpack_require__(232), cacheHas = __webpack_require__(95);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
            /**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
                // Check that cyclic values are equal.
                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);
                if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
                var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
                stack.set(array, other);
                stack.set(other, array);
                // Ignore non-index properties.
                while(++index < arrLength){
                    var arrValue = array[index], othValue = other[index];
                    if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    if (compared !== undefined) {
                        if (compared) continue;
                        result = false;
                        break;
                    }
                    // Recursively compare arrays (susceptible to call stack limits).
                    if (seen) {
                        if (!arraySome(other, function(othValue, othIndex) {
                            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                        })) {
                            result = false;
                            break;
                        }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        result = false;
                        break;
                    }
                }
                stack['delete'](array);
                stack['delete'](other);
                return result;
            }
            module1.exports = equalArrays;
        /***/ },
        /* 232 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
                var index = -1, length = array == null ? 0 : array.length;
                while(++index < length){
                    if (predicate(array[index], index, array)) return true;
                }
                return false;
            }
            module1.exports = arraySome;
        /***/ },
        /* 233 */ /***/ function(module1, exports) {
            /**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
                var index = -1, result = Array(map.size);
                map.forEach(function(value, key) {
                    result[++index] = [
                        key,
                        value
                    ];
                });
                return result;
            }
            module1.exports = mapToArray;
        /***/ },
        /* 234 */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(11);
            /**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
                return value === value && !isObject(value);
            }
            module1.exports = isStrictComparable;
        /***/ },
        /* 235 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
                return function(object) {
                    if (object == null) return false;
                    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
                };
            }
            module1.exports = matchesStrictComparable;
        /***/ },
        /* 236 */ /***/ function(module1, exports, __webpack_require__) {
            var memoizeCapped = __webpack_require__(509);
            /** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
            /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
            /**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
                var result = [];
                if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
                string.replace(rePropName, function(match, number, quote, subString) {
                    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
            });
            module1.exports = stringToPath;
        /***/ },
        /* 237 */ /***/ function(module1, exports, __webpack_require__) {
            var baseHasIn = __webpack_require__(511), hasPath = __webpack_require__(512);
            /**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
            }
            module1.exports = hasIn;
        /***/ },
        /* 238 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayPush = __webpack_require__(116), isFlattenable = __webpack_require__(518);
            /**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1, length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);
                while(++index < length){
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                        if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                        baseFlatten(value, depth - 1, predicate, isStrict, result);
                        else arrayPush(result, value);
                    } else if (!isStrict) result[result.length] = value;
                }
                return result;
            }
            module1.exports = baseFlatten;
        /***/ },
        /* 239 */ /***/ function(module1, exports, __webpack_require__) {
            var createBaseFor = __webpack_require__(525);
            /**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
            module1.exports = baseFor;
        /***/ },
        /* 240 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            var punycode = __webpack_require__(526);
            var util = __webpack_require__(527);
            exports.parse = urlParse;
            exports.resolve = urlResolve;
            exports.resolveObject = urlResolveObject;
            exports.format = urlFormat;
            exports.Url = Url;
            function Url() {
                this.protocol = null;
                this.slashes = null;
                this.auth = null;
                this.host = null;
                this.port = null;
                this.hostname = null;
                this.hash = null;
                this.search = null;
                this.query = null;
                this.pathname = null;
                this.path = null;
                this.href = null;
            }
            // Reference: RFC 3986, RFC 1808, RFC 2396
            // define these here so at least they only have to be
            // compiled once on the first module load.
            var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
            simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
            // We actually just auto-escape these.
            delims = [
                '<',
                '>',
                '"',
                '`',
                ' ',
                '\r',
                '\n',
                '\t'
            ], // RFC 2396: characters not allowed for various reasons.
            unwise = [
                '{',
                '}',
                '|',
                '\\',
                '^',
                '`'
            ].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
            autoEscape = [
                '\''
            ].concat(unwise), // Characters that are never ever allowed in a hostname.
            // Note that any invalid chars are also handled, but these
            // are the ones that are *expected* to be seen, so we fast-path
            // them.
            nonHostChars = [
                '%',
                '/',
                '?',
                ';',
                '#'
            ].concat(autoEscape), hostEndingChars = [
                '/',
                '?',
                '#'
            ], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
            unsafeProtocol = {
                'javascript': true,
                'javascript:': true
            }, // protocols that never have a hostname.
            hostlessProtocol = {
                'javascript': true,
                'javascript:': true
            }, // protocols that always contain a // bit.
            slashedProtocol = {
                'http': true,
                'https': true,
                'ftp': true,
                'gopher': true,
                'file': true,
                'http:': true,
                'https:': true,
                'ftp:': true,
                'gopher:': true,
                'file:': true
            }, querystring = __webpack_require__(528);
            function urlParse(url, parseQueryString, slashesDenoteHost) {
                if (url && util.isObject(url) && url instanceof Url) return url;
                var u = new Url;
                u.parse(url, parseQueryString, slashesDenoteHost);
                return u;
            }
            Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                // Copy chrome, IE, opera backslash-handling behavior.
                // Back slashes before the query string get converted to forward slashes
                // See: https://code.google.com/p/chromium/issues/detail?id=25916
                var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
                uSplit[0] = uSplit[0].replace(slashRegex, '/');
                url = uSplit.join(splitter);
                var rest = url;
                // trim before proceeding.
                // This is to support parse stuff like "  http://foo.com  \n"
                rest = rest.trim();
                if (!slashesDenoteHost && url.split('#').length === 1) {
                    // Try fast path regexp
                    var simplePath = simplePathPattern.exec(rest);
                    if (simplePath) {
                        this.path = rest;
                        this.href = rest;
                        this.pathname = simplePath[1];
                        if (simplePath[2]) {
                            this.search = simplePath[2];
                            if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                            else this.query = this.search.substr(1);
                        } else if (parseQueryString) {
                            this.search = '';
                            this.query = {};
                        }
                        return this;
                    }
                }
                var proto = protocolPattern.exec(rest);
                if (proto) {
                    proto = proto[0];
                    var lowerProto = proto.toLowerCase();
                    this.protocol = lowerProto;
                    rest = rest.substr(proto.length);
                }
                // figure out if it's got a host
                // user@server is *always* interpreted as a hostname, and url
                // resolution will treat //foo/bar as host=foo,path=bar because that's
                // how the browser resolves relative URLs.
                if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                    var slashes = rest.substr(0, 2) === '//';
                    if (slashes && !(proto && hostlessProtocol[proto])) {
                        rest = rest.substr(2);
                        this.slashes = true;
                    }
                }
                if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                    // there's a hostname.
                    // the first instance of /, ?, ;, or # ends the host.
                    //
                    // If there is an @ in the hostname, then non-host chars *are* allowed
                    // to the left of the last @ sign, unless some host-ending character
                    // comes *before* the @-sign.
                    // URLs are obnoxious.
                    //
                    // ex:
                    // http://a@b@c/ => user:a@b host:c
                    // http://a@b?@c => user:a host:c path:/?@c
                    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
                    // Review our test case against browsers more comprehensively.
                    // find the first instance of any hostEndingChars
                    var hostEnd = -1;
                    for(var i = 0; i < hostEndingChars.length; i++){
                        var hec = rest.indexOf(hostEndingChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                    }
                    // at this point, either we have an explicit point where the
                    // auth portion cannot go past, or the last @ char is the decider.
                    var auth, atSign;
                    if (hostEnd === -1) // atSign can be anywhere.
                    atSign = rest.lastIndexOf('@');
                    else // atSign must be in auth portion.
                    // http://a@b/c@d => host:b auth:a path:/c@d
                    atSign = rest.lastIndexOf('@', hostEnd);
                    // Now we have a portion which is definitely the auth.
                    // Pull that off.
                    if (atSign !== -1) {
                        auth = rest.slice(0, atSign);
                        rest = rest.slice(atSign + 1);
                        this.auth = decodeURIComponent(auth);
                    }
                    // the host is the remaining to the left of the first non-host char
                    hostEnd = -1;
                    for(var i = 0; i < nonHostChars.length; i++){
                        var hec = rest.indexOf(nonHostChars[i]);
                        if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                    }
                    // if we still have not hit it, then the entire thing is a host.
                    if (hostEnd === -1) hostEnd = rest.length;
                    this.host = rest.slice(0, hostEnd);
                    rest = rest.slice(hostEnd);
                    // pull out port.
                    this.parseHost();
                    // we've indicated that there is a hostname,
                    // so even if it's empty, it has to be present.
                    this.hostname = this.hostname || '';
                    // if hostname begins with [ and ends with ]
                    // assume that it's an IPv6 address.
                    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
                    // validate a little.
                    if (!ipv6Hostname) {
                        var hostparts = this.hostname.split(/\./);
                        for(var i = 0, l = hostparts.length; i < l; i++){
                            var part = hostparts[i];
                            if (!part) continue;
                            if (!part.match(hostnamePartPattern)) {
                                var newpart = '';
                                for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                                // we need this to make sure size of hostname is not
                                // broken by replacing non-ASCII by nothing
                                newpart += 'x';
                                else newpart += part[j];
                                // we test again with ASCII char only
                                if (!newpart.match(hostnamePartPattern)) {
                                    var validParts = hostparts.slice(0, i);
                                    var notHost = hostparts.slice(i + 1);
                                    var bit = part.match(hostnamePartStart);
                                    if (bit) {
                                        validParts.push(bit[1]);
                                        notHost.unshift(bit[2]);
                                    }
                                    if (notHost.length) rest = '/' + notHost.join('.') + rest;
                                    this.hostname = validParts.join('.');
                                    break;
                                }
                            }
                        }
                    }
                    if (this.hostname.length > hostnameMaxLen) this.hostname = '';
                    else // hostnames are always lower case.
                    this.hostname = this.hostname.toLowerCase();
                    if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
                    // It only converts parts of the domain name that
                    // have non-ASCII characters, i.e. it doesn't matter if
                    // you call it with a domain that already is ASCII-only.
                    this.hostname = punycode.toASCII(this.hostname);
                    var p = this.port ? ':' + this.port : '';
                    var h = this.hostname || '';
                    this.host = h + p;
                    this.href += this.host;
                    // strip [ and ] from the hostname
                    // the host field still retains them, though
                    if (ipv6Hostname) {
                        this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                        if (rest[0] !== '/') rest = '/' + rest;
                    }
                }
                // now rest is set to the post-host stuff.
                // chop off any delim chars.
                if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
                // escaped, even if encodeURIComponent doesn't think they
                // need to be.
                for(var i = 0, l = autoEscape.length; i < l; i++){
                    var ae = autoEscape[i];
                    if (rest.indexOf(ae) === -1) continue;
                    var esc = encodeURIComponent(ae);
                    if (esc === ae) esc = escape(ae);
                    rest = rest.split(ae).join(esc);
                }
                // chop off from the tail first.
                var hash = rest.indexOf('#');
                if (hash !== -1) {
                    // got a fragment string.
                    this.hash = rest.substr(hash);
                    rest = rest.slice(0, hash);
                }
                var qm = rest.indexOf('?');
                if (qm !== -1) {
                    this.search = rest.substr(qm);
                    this.query = rest.substr(qm + 1);
                    if (parseQueryString) this.query = querystring.parse(this.query);
                    rest = rest.slice(0, qm);
                } else if (parseQueryString) {
                    // no query string, but parseQueryString still requested
                    this.search = '';
                    this.query = {};
                }
                if (rest) this.pathname = rest;
                if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
                //to support http.request
                if (this.pathname || this.search) {
                    var p = this.pathname || '';
                    var s = this.search || '';
                    this.path = p + s;
                }
                // finally, reconstruct the href based on what has been validated.
                this.href = this.format();
                return this;
            };
            // format a parsed object into a url string
            function urlFormat(obj) {
                // ensure it's an object, and not a string url.
                // If it's an obj, this is a no-op.
                // this way, you can call url_format() on strings
                // to clean up potentially wonky urls.
                if (util.isString(obj)) obj = urlParse(obj);
                if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                return obj.format();
            }
            Url.prototype.format = function() {
                var auth = this.auth || '';
                if (auth) {
                    auth = encodeURIComponent(auth);
                    auth = auth.replace(/%3A/i, ':');
                    auth += '@';
                }
                var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
                if (this.host) host = auth + this.host;
                else if (this.hostname) {
                    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
                    if (this.port) host += ':' + this.port;
                }
                if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                var search = this.search || query && '?' + query || '';
                if (protocol && protocol.substr(-1) !== ':') protocol += ':';
                // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                // unless they had them to begin with.
                if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                    host = '//' + (host || '');
                    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
                } else if (!host) host = '';
                if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
                if (search && search.charAt(0) !== '?') search = '?' + search;
                pathname = pathname.replace(/[?#]/g, function(match) {
                    return encodeURIComponent(match);
                });
                search = search.replace('#', '%23');
                return protocol + host + pathname + search + hash;
            };
            function urlResolve(source, relative) {
                return urlParse(source, false, true).resolve(relative);
            }
            Url.prototype.resolve = function(relative) {
                return this.resolveObject(urlParse(relative, false, true)).format();
            };
            function urlResolveObject(source, relative) {
                if (!source) return relative;
                return urlParse(source, false, true).resolveObject(relative);
            }
            Url.prototype.resolveObject = function(relative) {
                if (util.isString(relative)) {
                    var rel = new Url();
                    rel.parse(relative, false, true);
                    relative = rel;
                }
                var result = new Url();
                var tkeys = Object.keys(this);
                for(var tk = 0; tk < tkeys.length; tk++){
                    var tkey = tkeys[tk];
                    result[tkey] = this[tkey];
                }
                // hash is always overridden, no matter what.
                // even href="" will remove it.
                result.hash = relative.hash;
                // if the relative url is empty, then there's nothing left to do here.
                if (relative.href === '') {
                    result.href = result.format();
                    return result;
                }
                // hrefs like //foo/bar always cut to the protocol.
                if (relative.slashes && !relative.protocol) {
                    // take everything except the protocol from relative
                    var rkeys = Object.keys(relative);
                    for(var rk = 0; rk < rkeys.length; rk++){
                        var rkey = rkeys[rk];
                        if (rkey !== 'protocol') result[rkey] = relative[rkey];
                    }
                    //urlParse appends trailing / to urls like http://www.example.com
                    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
                    result.href = result.format();
                    return result;
                }
                if (relative.protocol && relative.protocol !== result.protocol) {
                    // if it's a known url protocol, then changing
                    // the protocol does weird things
                    // first, if it's not file:, then we MUST have a host,
                    // and if there was a path
                    // to begin with, then we MUST have a path.
                    // if it is file:, then the host is dropped,
                    // because that's known to be hostless.
                    // anything else is assumed to be absolute.
                    if (!slashedProtocol[relative.protocol]) {
                        var keys = Object.keys(relative);
                        for(var v = 0; v < keys.length; v++){
                            var k = keys[v];
                            result[k] = relative[k];
                        }
                        result.href = result.format();
                        return result;
                    }
                    result.protocol = relative.protocol;
                    if (!relative.host && !hostlessProtocol[relative.protocol]) {
                        var relPath = (relative.pathname || '').split('/');
                        while(relPath.length && !(relative.host = relPath.shift()));
                        if (!relative.host) relative.host = '';
                        if (!relative.hostname) relative.hostname = '';
                        if (relPath[0] !== '') relPath.unshift('');
                        if (relPath.length < 2) relPath.unshift('');
                        result.pathname = relPath.join('/');
                    } else result.pathname = relative.pathname;
                    result.search = relative.search;
                    result.query = relative.query;
                    result.host = relative.host || '';
                    result.auth = relative.auth;
                    result.hostname = relative.hostname || relative.host;
                    result.port = relative.port;
                    // to support http.request
                    if (result.pathname || result.search) {
                        var p = result.pathname || '';
                        var s = result.search || '';
                        result.path = p + s;
                    }
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                }
                var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                // if the url is a non-slashed url, then relative
                // links like ../.. should be able
                // to crawl up to the hostname, as well.  This is strange.
                // result.protocol has already been set by now.
                // Later on, put the first path part into the host field.
                if (psychotic) {
                    result.hostname = '';
                    result.port = null;
                    if (result.host) {
                        if (srcPath[0] === '') srcPath[0] = result.host;
                        else srcPath.unshift(result.host);
                    }
                    result.host = '';
                    if (relative.protocol) {
                        relative.hostname = null;
                        relative.port = null;
                        if (relative.host) {
                            if (relPath[0] === '') relPath[0] = relative.host;
                            else relPath.unshift(relative.host);
                        }
                        relative.host = null;
                    }
                    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
                }
                if (isRelAbs) {
                    // it's absolute.
                    result.host = relative.host || relative.host === '' ? relative.host : result.host;
                    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
                    result.search = relative.search;
                    result.query = relative.query;
                    srcPath = relPath;
                // fall through to the dot-handling below.
                } else if (relPath.length) {
                    // it's relative
                    // throw away the existing file, and take the new path instead.
                    if (!srcPath) srcPath = [];
                    srcPath.pop();
                    srcPath = srcPath.concat(relPath);
                    result.search = relative.search;
                    result.query = relative.query;
                } else if (!util.isNullOrUndefined(relative.search)) {
                    // just pull out the search.
                    // like href='?foo'.
                    // Put this after the other two cases because it simplifies the booleans
                    if (psychotic) {
                        result.hostname = result.host = srcPath.shift();
                        //occationaly the auth can get stuck only in host
                        //this especially happens in cases like
                        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.host = result.hostname = authInHost.shift();
                        }
                    }
                    result.search = relative.search;
                    result.query = relative.query;
                    //to support http.request
                    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                    result.href = result.format();
                    return result;
                }
                if (!srcPath.length) {
                    // no path at all.  easy.
                    // we've already handled the other stuff above.
                    result.pathname = null;
                    //to support http.request
                    if (result.search) result.path = '/' + result.search;
                    else result.path = null;
                    result.href = result.format();
                    return result;
                }
                // if a url ENDs in . or .., then it must get a trailing slash.
                // however, if it ends in anything else non-slashy,
                // then it must NOT get a trailing slash.
                var last = srcPath.slice(-1)[0];
                var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
                // strip single dots, resolve double dots to parent dir
                // if the path tries to go above the root, `up` ends up > 0
                var up = 0;
                for(var i = srcPath.length; i >= 0; i--){
                    last = srcPath[i];
                    if (last === '.') srcPath.splice(i, 1);
                    else if (last === '..') {
                        srcPath.splice(i, 1);
                        up++;
                    } else if (up) {
                        srcPath.splice(i, 1);
                        up--;
                    }
                }
                // if the path is allowed to go above the root, restore leading ..s
                if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
                if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
                if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
                var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
                // put the host back
                if (psychotic) {
                    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
                    //occationaly the auth can get stuck only in host
                    //this especially happens in cases like
                    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                    if (authInHost) {
                        result.auth = authInHost.shift();
                        result.host = result.hostname = authInHost.shift();
                    }
                }
                mustEndAbs = mustEndAbs || result.host && srcPath.length;
                if (mustEndAbs && !isAbsolute) srcPath.unshift('');
                if (!srcPath.length) {
                    result.pathname = null;
                    result.path = null;
                } else result.pathname = srcPath.join('/');
                //to support request.http
                if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                result.auth = relative.auth || result.auth;
                result.slashes = result.slashes || relative.slashes;
                result.href = result.format();
                return result;
            };
            Url.prototype.parseHost = function() {
                var host = this.host;
                var port = portPattern.exec(host);
                if (port) {
                    port = port[0];
                    if (port !== ':') this.port = port.substr(1);
                    host = host.substr(0, host.length - port.length);
                }
                if (host) this.hostname = host;
            };
        /***/ },
        /* 241 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, no-shadow */ const isFunction = __webpack_require__(17);
                const uuid = __webpack_require__(16);
                const logging = __webpack_require__(2)('guidStorage');
                const guidStorage = {};
                module1.exports = guidStorage;
                let currentGuidStorage;
                let currentGuid;
                const isInvalidStorage = function isInvalidStorage(storageInterface) {
                    return !(isFunction(storageInterface.get) && isFunction(storageInterface.set));
                };
                const getClientGuid = function getClientGuid(completion) {
                    if (currentGuid) {
                        completion(null, currentGuid);
                        return;
                    } // It's the first time that getClientGuid has been called
                    // in this page lifetime. Attempt to load any existing Guid
                    // from the storage
                    currentGuidStorage.get(completion);
                };
                /*
* Sets the methods for storing and retrieving client GUIDs persistently
* across sessions. By default, OpenTok.js attempts to use browser cookies to
* store GUIDs.
* <p>
* Pass in an object that has a <code>get()</code> method and
* a <code>set()</code> method.
* <p>
* The <code>get()</code> method must take one parameter: the callback
* method to invoke. The callback method is passed two parameters &mdash;
* the first parameter is an error object or null if the call is successful;
* and the second parameter is the GUID (a string) if successful.
* <p>
* The <code>set()</code> method must include two parameters: the GUID to set
* (a string) and the callback method to invoke. The callback method is
* passed an error object on error, or it is passed no parameter if the call is
* successful.
* <p>
* Here is an example:
* <p>
* <pre>
* var ComplexStorage = function() {
*   this.set = function(guid, completion) {
*     AwesomeBackendService.set(guid, function(response) {
*       completion(response.error || null);
*     });
*   };
*   this.get = function(completion) {
*     AwesomeBackendService.get(function(response, guid) {
*       completion(response.error || null, guid);
*     });
*   };
* };
*
* OT.overrideGuidStorage(new ComplexStorage());
* </pre>
*/ guidStorage.override = (storageInterface)=>{
                    if (isInvalidStorage(storageInterface)) throw new Error("The storageInterface argument does not seem to be valid, it must implement get and set methods");
                    if (currentGuidStorage === storageInterface) return;
                    currentGuidStorage = storageInterface; // If a client Guid has already been assigned to this client then
                    // let the new storage know about it so that it's in sync.
                    if (currentGuid) currentGuidStorage.set(currentGuid, (error)=>{
                        if (error) logging.error(`Failed to send initial Guid value (${currentGuid}) to the newly assigned Guid Storage. The error was: ${error}`); // @todo error
                    });
                };
                guidStorage.get = (completion)=>{
                    getClientGuid((error, guid)=>{
                        if (error) {
                            completion(error);
                            return;
                        }
                        if (!guid) {
                            // Nothing came back, this client is entirely new.
                            // generate a new Guid and persist it
                            guid = uuid();
                            currentGuidStorage.set(guid, (error)=>{
                                if (error) {
                                    completion(error);
                                    return;
                                }
                                currentGuid = guid;
                            });
                        } else if (!currentGuid) currentGuid = guid;
                        completion(null, currentGuid);
                    });
                };
                guidStorage.getAsync = ()=>new Promise((resolve, reject)=>{
                        guidStorage.get((error, guid)=>{
                            if (error) return reject(error);
                            return resolve(guid);
                        });
                    }); // Implement our default storage mechanism, which sets/gets a cookie
                // called 'opentok_client_id'
                guidStorage.override({
                    get (completion) {
                        let clientId;
                        try {
                            clientId = window.localStorage.getItem('opentok_client_id');
                        } catch (err) {
                            // will get Uncaught DOMException: Failed to read the 'localStorage' property from 'Window':
                            // The document is sandboxed and lacks the 'allow-same-origin' flag.
                            if (!clientId) clientId = uuid();
                        }
                        completion(null, clientId);
                    },
                    set (guid, completion) {
                        try {
                            window.localStorage.setItem('opentok_client_id', guid);
                        } catch (err) {
                        // The document is sandboxed and lacks the 'allow-same-origin' flag.
                        }
                        completion(null);
                    }
                }); // Test only
                guidStorage.set = (guid)=>{
                    currentGuid = guid;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 242 */ /***/ function(module1, exports) {
            // Unique ID creation requires a high quality random # generator.  In the
            // browser this is a little complicated due to unknown quality of Math.random()
            // and inconsistent support for the `crypto` API.  We do the best we can via
            // feature-detection
            // getRandomValues needs to be invoked in a context where "this" is a Crypto
            // implementation. Also, find the complete implementation of crypto on IE11.
            var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
            if (getRandomValues) {
                // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
                var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
                module1.exports = function whatwgRNG() {
                    getRandomValues(rnds8);
                    return rnds8;
                };
            } else {
                // Math.random()-based (RNG)
                //
                // If all else fails, use Math.random().  It's fast, but is of unspecified
                // quality.
                var rnds = new Array(16);
                module1.exports = function mathRNG() {
                    for(var i = 0, r; i < 16; i++){
                        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
                        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
                    }
                    return rnds;
                };
            }
        /***/ },
        /* 243 */ /***/ function(module1, exports) {
            /**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
            for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
            function bytesToUuid(buf, offset) {
                var i = offset || 0;
                var bth = byteToHex;
                // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
                return [
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]],
                    '-',
                    bth[buf[i++]],
                    bth[buf[i++]],
                    '-',
                    bth[buf[i++]],
                    bth[buf[i++]],
                    '-',
                    bth[buf[i++]],
                    bth[buf[i++]],
                    '-',
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]],
                    bth[buf[i++]]
                ].join('');
            }
            module1.exports = bytesToUuid;
        /***/ },
        /* 244 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-void, no-param-reassign */ /* eslint-disable no-restricted-syntax, no-continue */ const $ = __webpack_require__(245);
            const env = __webpack_require__(3);
            const makeEverythingAttachToOTHelpers = __webpack_require__(247);
            const assign = __webpack_require__(9);
            const browserAjax = {};
            module1.exports = browserAjax;
            function formatPostData(data) {
                // , contentType
                // If it's a string, we assume it's properly encoded
                if (typeof data === 'string') return data;
                const queryString = [];
                Object.keys(data).forEach((key)=>{
                    queryString.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
                });
                return queryString.join('&').replace(/\+/g, '%20');
            }
            if (env.name !== 'Node') {
                browserAjax.request = function(url, options, callback) {
                    const request = new window.XMLHttpRequest();
                    const _options = options || {};
                    const _method = _options.method;
                    if (!_method) {
                        callback(new Error('No HTTP method specified in options'));
                        return;
                    }
                    if (options.overrideMimeType) {
                        if (request.overrideMimeType) request.overrideMimeType(options.overrideMimeType);
                        delete options.overrideMimeType;
                    } // Setup callbacks to correctly respond to success and error callbacks. This includes
                    // interpreting the responses HTTP status, which XmlHttpRequest seems to ignore
                    // by default.
                    if (callback) {
                        $(request).on('load', (event)=>{
                            const status = event.target.status; // We need to detect things that XMLHttpRequest considers a success,
                            // but we consider to be failures.
                            if (status >= 200 && (status < 300 || status === 304)) callback(null, event);
                            else callback(event);
                        });
                        $(request).on('error', callback);
                    }
                    request.open(options.method, url, true);
                    if (!_options.headers) _options.headers = {};
                    for(const name in _options.headers){
                        if (!Object.prototype.hasOwnProperty.call(_options.headers, name)) continue;
                        request.setRequestHeader(name, _options.headers[name]);
                    }
                    request.send(options.body && formatPostData(options.body));
                };
                browserAjax.get = function(url, options, callback) {
                    const _options = assign(options || {}, {
                        method: 'GET'
                    });
                    browserAjax.request(url, _options, callback);
                };
                browserAjax.post = function(url, options, callback) {
                    const _options = assign(options || {}, {
                        method: 'POST'
                    });
                    browserAjax.request(url, _options, callback);
                };
                browserAjax.getJSON = function(url, options, callback) {
                    options = options || {};
                    const done = function done(error, event) {
                        if (error) callback(error, event && event.target && event.target.responseText);
                        else {
                            let response;
                            try {
                                response = JSON.parse(event.target.responseText);
                            } catch (e) {
                                // Badly formed JSON
                                callback(e, event && event.target && event.target.responseText);
                                return;
                            }
                            callback(null, response, event);
                        }
                    };
                    const extendedHeaders = assign({
                        Accept: 'application/json'
                    }, options.headers || {});
                    browserAjax.get(url, assign(options || {}, {
                        headers: extendedHeaders
                    }), done);
                };
                makeEverythingAttachToOTHelpers(browserAjax);
            }
        /***/ },
        /* 245 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ElementCollection = __webpack_require__(246);
            module1.exports = function(selector, context) {
                return new ElementCollection(selector, context);
            };
        /***/ },
        /* 246 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable global-require, no-param-reassign,  no-void */ /* eslint-disable no-underscore-dangle, prefer-rest-params, prefer-const */ const isFunction = __webpack_require__(17);
            const extensions = {
                attributes: __webpack_require__(537),
                css: __webpack_require__(538),
                classNames: __webpack_require__(543),
                observers: __webpack_require__(545)
            };
            const idRegex = /^#([\w-]*)$/; // A helper for converting a NodeList to a JS Array
            const nodeListToArray = function nodeListToArray(nodes) {
                return Array.prototype.slice.call(nodes);
            };
            const selectorToElementArray = function selectorToElementArray(selector, context) {
                let elements;
                if (typeof selector === 'undefined') return [];
                if (typeof selector === 'string') {
                    elements = [];
                    const idSelector = idRegex.exec(selector);
                    context = context || document;
                    if (idSelector && idSelector[1]) {
                        const element = context.getElementById(idSelector[1]);
                        if (element) elements.push(element);
                    } else elements = context.querySelectorAll(selector);
                } else if (selector && (selector.nodeType || window.XMLHttpRequest && selector instanceof window.XMLHttpRequest || selector === window)) {
                    // allow OTHelpers(DOMNode) and OTHelpers(xmlHttpRequest)
                    elements = [
                        selector
                    ];
                    context = selector;
                } else if (Array.isArray(selector)) {
                    elements = selector.slice();
                    context = null;
                } else elements = nodeListToArray(elements);
                return elements;
            }; // ElementCollection contains the result of calling OTHelpers.
            //
            // It has the following properties:
            //   length
            //   first
            //   last
            //
            // It also has a get method that can be used to access elements in the collection
            //
            //   var videos = OTHelpers('video');
            //   var firstElement = videos.get(0);               // identical to videos.first
            //   var lastElement = videos.get(videos.length-1);  // identical to videos.last
            //   var allVideos = videos.get();
            //
            //
            // The collection also implements the following helper methods:
            //   some, forEach, map, filter, find,
            //   appendTo, after, before, remove, empty,
            //   attr, center, width, height,
            //   addClass, removeClass, hasClass, toggleClass,
            //   on, off, once,
            //   observeStyleChanges, observeNodeOrChildNodeRemoval
            //
            // Mostly the usage should be obvious. When in doubt, assume it functions like
            // the jQuery equivalent.
            //
            const ElementCollection = function ElementCollection(selector, context) {
                const elements = selectorToElementArray(selector, context);
                this.context = context;
                this.toArray = function() {
                    return elements;
                };
                this.length = elements.length;
                this.first = elements[0];
                this.last = elements[elements.length - 1];
                this.get = function(index) {
                    if (index === void 0) return elements;
                    return elements[index];
                };
            };
            module1.exports = ElementCollection;
            ElementCollection._attachToOTHelpers = {}; // @remove
            ElementCollection._attachToOTHelpers.removeElement = function(element) {
                return new ElementCollection(element).remove();
            };
            ElementCollection.prototype.getAsArray = function() {
                let _collection = this.get();
                if (!isFunction(_collection.forEach)) // It's possibly something Array-ish that isn't quite an
                // Array. Something like arguments or a NodeList
                _collection = nodeListToArray(_collection);
                return _collection;
            };
            ElementCollection.prototype.some = function(iter, context) {
                return this.getAsArray().some(iter, context);
            };
            ElementCollection.prototype.forEach = function(fn, context) {
                this.getAsArray().forEach(fn, context);
                return this;
            };
            ElementCollection.prototype.map = function(fn, context) {
                return new ElementCollection(this.getAsArray().map(fn, context), this.context);
            };
            ElementCollection.prototype.filter = function(fn, context) {
                return new ElementCollection(this.getAsArray().filter(fn, context), this.context);
            };
            ElementCollection.prototype.find = function(selector) {
                return new ElementCollection(selector, this.first);
            }; // Helper function for adding event listeners to dom elements.
            // WARNING: This doesn't preserve event types, your handler could
            // be getting all kinds of different parameters depending on the browser.
            // You also may have different scopes depending on the browser and bubbling
            // and cancelable are not supported.
            ElementCollection.prototype.on = function(eventName, handler) {
                return this.forEach((element)=>{
                    element.addEventListener(eventName, handler, false);
                });
            }; // Helper function for removing event listeners from dom elements.
            ElementCollection.prototype.off = function(eventName, handler) {
                return this.forEach((element)=>{
                    element.removeEventListener(eventName, handler, false);
                });
            };
            ElementCollection.prototype.once = function(eventName, handler) {
                const removeAfterTrigger = (function() {
                    this.off(eventName, removeAfterTrigger);
                    handler(...arguments);
                }).bind(this);
                return this.on(eventName, removeAfterTrigger);
            };
            ElementCollection.prototype.appendTo = function(parentElement) {
                if (!parentElement) throw new Error('appendTo requires a DOMElement to append to.');
                return this.forEach((child)=>{
                    parentElement.appendChild(child);
                });
            };
            ElementCollection.prototype.append = function() {
                const parentElement = this.first;
                if (!parentElement) return this;
                Array.prototype.forEach.call(arguments, (child)=>{
                    parentElement.appendChild(child);
                });
                return this;
            };
            ElementCollection.prototype.prepend = function() {
                if (arguments.length === 0) return this;
                const parentElement = this.first;
                let elementsToPrepend;
                if (!parentElement) return this;
                elementsToPrepend = Array.prototype.slice.call(arguments);
                if (!parentElement.firstElementChild) parentElement.appendChild(elementsToPrepend.shift());
                elementsToPrepend.forEach((element)=>{
                    parentElement.insertBefore(element, parentElement.firstElementChild);
                });
                return this;
            };
            ElementCollection.prototype.after = function(prevElement) {
                if (!prevElement) throw new Error('after requires a DOMElement to insert after');
                return this.forEach((element)=>{
                    if (element.parentElement) {
                        if (prevElement !== element.parentNode.lastChild) element.parentElement.insertBefore(element, prevElement);
                        else element.parentElement.appendChild(element);
                    }
                });
            };
            ElementCollection.prototype.before = function(nextElement) {
                if (!nextElement) throw new Error('before requires a DOMElement to insert before');
                return this.forEach((element)=>{
                    if (element.parentElement) element.parentElement.insertBefore(element, nextElement);
                });
            };
            ElementCollection.prototype.remove = function() {
                return this.forEach((element)=>{
                    if (element.parentNode) element.parentNode.removeChild(element);
                });
            };
            ElementCollection.prototype.empty = function() {
                return this.forEach((element)=>{
                    // elements is a "live" NodesList collection. Meaning that the collection
                    // itself will be mutated as we remove elements from the DOM. This means
                    // that "while there are still elements" is safer than "iterate over each
                    // element" as the collection length and the elements indices will be modified
                    // with each iteration.
                    while(element.firstChild)element.removeChild(element.firstChild);
                });
            }; // Detects when an element is not part of the document flow because
            // it or one of it's ancesters has display:none.
            ElementCollection.prototype.isDisplayNone = function() {
                return this.some((element)=>{
                    if ((element.offsetWidth === 0 || element.offsetHeight === 0) && new ElementCollection(element).css('display') === 'none') return true;
                    if (element.parentNode && element.parentNode.style) return new ElementCollection(element.parentNode).isDisplayNone();
                    return false;
                });
            };
            const findElementWithDisplayNone = function findElementWithDisplayNone(element) {
                if ((element.offsetWidth === 0 || element.offsetHeight === 0) && new ElementCollection(element).css('display') === 'none') return element;
                if (element.parentNode && element.parentNode.style) return findElementWithDisplayNone(element.parentNode);
                return null;
            }; // @remove
            ElementCollection._attachToOTHelpers.emptyElement = function(element) {
                return new ElementCollection(element).empty();
            };
            ElementCollection._attachToOTHelpers._findElementWithDisplayNone = findElementWithDisplayNone;
            extensions.css(ElementCollection, findElementWithDisplayNone);
            extensions.attributes(ElementCollection);
            extensions.classNames(ElementCollection);
            extensions.observers(ElementCollection); // TODO: Deprecation logging?
            // @remove
            [
                'on',
                'off',
                'isDisplayNone',
                'show',
                'hide',
                'css',
                'makeVisibleAndYield',
                'addClass',
                'removeClass'
            ].forEach((methodName)=>{
                ElementCollection._attachToOTHelpers[methodName] = function() /* arguments */ {
                    const args = Array.prototype.slice.apply(arguments);
                    const element = args.shift();
                    const collection = new ElementCollection(element);
                    return ElementCollection.prototype[methodName].apply(collection, args);
                };
            });
        /***/ },
        /* 247 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign */ module1.exports = function(mod) {
                const attachments = {};
                Object.keys(mod).forEach((key)=>{
                    attachments[key] = mod[key];
                });
                mod._attachToOTHelpers = attachments;
            };
        /***/ },
        /* 248 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-void, no-restricted-syntax, no-prototype-builtins */ /* eslint-disable no-continue, prefer-spread, prefer-rest-params */ const isFunction = __webpack_require__(17);
            const eventing = __webpack_require__(7);
            const logging = __webpack_require__(2)('Collection');
            module1.exports = function Collection(idField) {
                let _models = [];
                let _byId = {};
                const _idField = idField || 'id';
                eventing(this);
                const modelProperty = function modelProperty(model, property) {
                    if (isFunction(model[property])) return model[property]();
                    return model[property];
                };
                const onModelUpdate = (function onModelUpdate(event) {
                    this.trigger('update', event);
                    this.trigger(`update:${event.target.id}`, event);
                }).bind(this);
                const onModelDestroy = (function onModelDestroyed(event) {
                    this.remove(event.target, event.reason);
                }).bind(this);
                this.reset = function() {
                    // Stop listening on the models, they are no longer our problem
                    _models.forEach(function(model) {
                        model.off('updated', onModelUpdate, this);
                        model.off('destroyed', onModelDestroy, this);
                    }, this);
                    _models = [];
                    _byId = {};
                };
                this.destroy = function(reason) {
                    _models.forEach((model)=>{
                        if (model && typeof model.destroy === 'function') model.destroy(reason, true);
                    });
                    this.reset();
                    this.off();
                };
                this.get = function(id) {
                    return id && _byId[id] !== void 0 ? _models[_byId[id]] : void 0;
                };
                this.has = function(id) {
                    return id && _byId[id] !== void 0;
                };
                this.toString = function() {
                    return _models.toString();
                }; // Return only models filtered by either a dict of properties
                // or a filter function.
                //
                // @example Return all publishers with a streamId of 1
                //   OT.publishers.where({streamId: 1})
                //
                // @example The same thing but filtering using a filter function
                //   OT.publishers.where(function(publisher) {
                //     return publisher.stream.id === 4;
                //   });
                //
                // @example The same thing but filtering using a filter function
                //          executed with a specific this
                //   OT.publishers.where(function(publisher) {
                //     return publisher.stream.id === 4;
                //   }, self);
                //
                this.where = function(attrsOrFilterFn, context) {
                    if (isFunction(attrsOrFilterFn)) return _models.filter(attrsOrFilterFn, context);
                    return _models.filter((model)=>{
                        for(const key in attrsOrFilterFn){
                            if (!attrsOrFilterFn.hasOwnProperty(key)) continue;
                            if (modelProperty(model, key) !== attrsOrFilterFn[key]) return false;
                        }
                        return true;
                    });
                }; // Similar to where in behaviour, except that it only returns
                // the first match.
                this.find = function(attrsOrFilterFn, context) {
                    let filterFn;
                    if (isFunction(attrsOrFilterFn)) filterFn = attrsOrFilterFn;
                    else filterFn = function filterFn(model) {
                        for(const key in attrsOrFilterFn){
                            if (!attrsOrFilterFn.hasOwnProperty(key)) continue;
                            if (modelProperty(model, key) !== attrsOrFilterFn[key]) return false;
                        }
                        return true;
                    };
                    filterFn = filterFn.bind(context);
                    for(let i = 0; i < _models.length; ++i){
                        if (filterFn(_models[i]) === true) return _models[i];
                    }
                    return null;
                };
                this.forEach = function(fn, context) {
                    _models.forEach(fn, context);
                    return this;
                };
                this.map = function(fn) {
                    return _models.map(fn);
                };
                this.add = function(model) {
                    const id = modelProperty(model, _idField);
                    if (this.has(id)) {
                        logging.warn(`Model ${id} is already in the collection`, _models);
                        return this;
                    }
                    _byId[id] = _models.push(model) - 1;
                    model.on('updated', onModelUpdate, this);
                    model.on('destroyed', onModelDestroy, this);
                    this.trigger('add', model);
                    this.trigger(`add:${id}`, model);
                    return this;
                };
                this.remove = function(model, reason) {
                    const id = modelProperty(model, _idField);
                    _models.splice(_byId[id], 1); // Shuffle everyone down one
                    for(let i = _byId[id]; i < _models.length; ++i)_byId[modelProperty(_models[i], _idField)] = i;
                    delete _byId[id];
                    model.off('updated', onModelUpdate, this);
                    model.off('destroyed', onModelDestroy, this);
                    this.trigger('remove', model, reason);
                    this.trigger(`remove:${id}`, model, reason);
                    return this;
                }; // Retrigger the add event behaviour for each model. You can also
                // select a subset of models to trigger using the same arguments
                // as the #where method.
                this._triggerAddEvents = function() {
                    this.where.apply(this, arguments).forEach(function(model) {
                        this.trigger('add', model);
                        this.trigger(`add:${modelProperty(model, _idField)}`, model);
                    }, this);
                };
                this.length = function() {
                    return _models.length;
                };
            };
        /***/ },
        /* 249 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const logging = __webpack_require__(2)('deprecation');
            module1.exports = function setDeprecatedProperty(object, key, _temp) {
                let _ref = _temp === void 0 ? {} : _temp, defaultValue = _ref.value, _ref$name = _ref.name, name = _ref$name === void 0 ? `${key}` : _ref$name, _ref$getWarning = _ref.getWarning, getWarning = _ref$getWarning === void 0 ? '' : _ref$getWarning, _ref$setWarning = _ref.setWarning, setWarning = _ref$setWarning === void 0 ? '' : _ref$setWarning, _ref$canSet = _ref.canSet, canSet = _ref$canSet === void 0 ? false : _ref$canSet, _ref$warnOnSet = _ref.warnOnSet, warnOnSet = _ref$warnOnSet === void 0 ? false : _ref$warnOnSet;
                let value = defaultValue;
                let hasWarnedOnGet = false;
                let hasWarnedOnSet = !warnOnSet;
                const propertyDescriptor = {
                    get () {
                        if (!hasWarnedOnGet) {
                            hasWarnedOnGet = true;
                            logging.warn(`${name} is deprecated, and will be removed in the future. ${getWarning}`.trim());
                        }
                        return value;
                    },
                    set (newValue) {
                        if (canSet) value = newValue;
                        if (!hasWarnedOnSet) {
                            hasWarnedOnSet = true;
                            if (canSet) logging.warn(`${name} is deprecated. ${setWarning}`.trim());
                            else logging.warn(`${name} is deprecated, and will be removed in the future. ${setWarning}`.trim());
                        }
                    }
                };
                Object.defineProperty(object, key, propertyDescriptor);
            };
        /***/ },
        /* 250 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign, no-void */ /* eslint-disable no-restricted-syntax, no-prototype-builtins, no-shadow, one-var, vars-on-top */ /* eslint-disable no-var */ const env = __webpack_require__(3);
            const isObject = __webpack_require__(11);
            let getErrorLocation; // Properties that we'll acknowledge from the JS Error object
            const safeErrorProps = [
                'description',
                'fileName',
                'lineNumber',
                'message',
                'name',
                'number',
                'stack'
            ]; // OTHelpers.Error
            //
            // A construct to contain error information that also helps with extracting error
            // context, such as stack trace.
            //
            // @constructor
            // @memberof OTHelpers
            // @method Error
            //
            // @param {String} message
            //      Optional. The error message
            //
            // @param {Object} props
            //      Optional. A dictionary of properties containing extra Error info.
            //
            //
            // @example Create a simple error with juts a custom message
            //   var error = new OTHelpers.Error('Something Broke!');
            //   error.message === 'Something Broke!';
            //
            // @example Create an Error with a message and a name
            //   var error = new OTHelpers.Error('Something Broke!', 'FooError');
            //   error.message === 'Something Broke!';
            //   error.name === 'FooError';
            //
            // @example Create an Error with a message, name, and custom properties
            //   var error = new OTHelpers.Error('Something Broke!', 'FooError', {
            //     foo: 'bar',
            //     listOfImportantThings: [1,2,3,4]
            //   });
            //   error.message === 'Something Broke!';
            //   error.name === 'FooError';
            //   error.foo === 'bar';
            //   error.listOfImportantThings == [1,2,3,4];
            //
            // @example Create an Error from a Javascript Error
            //   var error = new OTHelpers.Error(domSyntaxError);
            //   error.message === domSyntaxError.message;
            //   error.name === domSyntaxError.name === 'SyntaxError';
            //   // ...continues for each properties of domSyntaxError
            //
            // @references
            // * https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
            // * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
            // * http://www.w3.org/TR/dom/#interface-domerror
            //
            //
            // @todo
            // * update usage in OTMedia
            // * replace error handling in OT.js
            // * normalise stack behaviour under Chrome/Node/Safari with other browsers
            // * unit test for stack parsing
            //
            const Error_ = function Error_(message, name, props) {
                switch(arguments.length){
                    case 1:
                        if (isObject(message)) {
                            props = message;
                            name = void 0;
                            message = void 0;
                        } // Otherwise it's the message
                        break;
                    case 2:
                        if (isObject(name)) {
                            props = name;
                            name = void 0;
                        } // Otherwise name is actually the name
                        break;
                    default:
                }
                if (props instanceof Error) // Special handling of this due to Chrome weirdness. It seems that
                // properties of the Error object, and it's children, are not
                // enumerable in Chrome?
                for(let i = 0, num = safeErrorProps.length; i < num; ++i)this[safeErrorProps[i]] = props[safeErrorProps[i]];
                else if (isObject(props)) {
                    // Use an custom properties that are provided
                    for(const key in props)if (props.hasOwnProperty(key)) this[key] = props[key];
                } // If any of the fundamental properties are missing then try and
                // extract them.
                if (!(this.fileName && this.lineNumber && this.columnNumber && this.stack)) {
                    const err = getErrorLocation();
                    if (!this.fileName && err.fileName) this.fileName = err.fileName;
                    if (!this.lineNumber && err.lineNumber) this.lineNumber = err.lineNumber;
                    if (!this.columnNumber && err.columnNumber) this.columnNumber = err.columnNumber;
                    if (!this.stack && err.stack) this.stack = err.stack;
                }
                if (!this.message && message) this.message = message;
                if ((!this.name || this.name === 'Error') && name) this.name = name;
            };
            module1.exports = Error_;
            Error_.prototype = Object.create(Error.prototype);
            Error_.prototype.toString = function() {
                let locationDetails = '';
                if (this.fileName) locationDetails += ` ${this.fileName}`;
                if (this.lineNumber) {
                    locationDetails += ` ${this.lineNumber}`;
                    if (this.columnNumber) locationDetails += `:${this.columnNumber}`;
                }
                return `<${this.name ? `${this.name} ` : ''}${this.message}${locationDetails}>`;
            };
            Error_.prototype.valueOf = Error_.prototype.toString; // Normalise err.stack so that it is the same format as the other browsers
            // We skip the first two frames so that we don't capture getErrorLocation() and
            // the callee.
            //
            // Used by Environments that support the StackTrace API. (Chrome, Node, Opera)
            //
            const prepareStackTrace = function prepareStackTrace(_, stack) {
                return stack.slice(2).map((frame)=>{
                    const _f = {
                        fileName: frame.getFileName(),
                        linenumber: frame.getLineNumber(),
                        columnNumber: frame.getColumnNumber()
                    };
                    if (frame.getFunctionName()) _f.functionName = frame.getFunctionName();
                    if (frame.getMethodName()) _f.methodName = frame.getMethodName();
                    if (frame.getThis()) _f.self = frame.getThis();
                    return _f;
                });
            }; // Black magic to retrieve error location info for various environments
            getErrorLocation = function getErrorLocation() {
                const info = {};
                let callstack, errLocation, err;
                switch(env.name){
                    case 'Firefox':
                    case 'Safari':
                        try {
                            window.call.js.is.explody();
                        } catch (e) {
                            err = e;
                        }
                        callstack = (err.stack || '').split('\n'); // Remove call to getErrorLocation() and the callee
                        callstack.shift();
                        callstack.shift();
                        info.stack = callstack;
                        errLocation = /@(.+?):([0-9]+)(:([0-9]+))?$/.exec(callstack[0]);
                        if (errLocation) {
                            info.fileName = errLocation[1];
                            info.lineNumber = parseInt(errLocation[2], 10);
                            if (errLocation.length > 3) info.columnNumber = parseInt(errLocation[4], 10);
                        }
                        break;
                    case 'Chrome':
                    case 'Node':
                    case 'Opera':
                        var currentPST = Error.prepareStackTrace;
                        Error.prepareStackTrace = prepareStackTrace;
                        err = new Error();
                        info.stack = err.stack;
                        Error.prepareStackTrace = currentPST;
                        var topFrame = info.stack[0];
                        info.lineNumber = topFrame.lineNumber;
                        info.columnNumber = topFrame.columnNumber;
                        info.fileName = topFrame.fileName;
                        if (topFrame.functionName) info.functionName = topFrame.functionName;
                        if (topFrame.methodName) info.methodName = topFrame.methodName;
                        if (topFrame.self) info.self = topFrame.self;
                        break;
                    default:
                        err = new Error();
                        if (err.stack) info.stack = err.stack.split('\n');
                        break;
                }
                if (err.message) info.message = err.message;
                return info;
            };
        /***/ },
        /* 251 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-env node */ // SDP helpers.
            var SDPUtils = {};
            // Generate an alphanumeric identifier for cname or mids.
            // TODO: use UUIDs instead? https://gist.github.com/jed/982883
            SDPUtils.generateIdentifier = function() {
                return Math.random().toString(36).substr(2, 10);
            };
            // The RTCP CNAME used by all peerconnections from the same JS.
            SDPUtils.localCName = SDPUtils.generateIdentifier();
            // Splits SDP into lines, dealing with both CRLF and LF.
            SDPUtils.splitLines = function(blob) {
                return blob.trim().split('\n').map(function(line) {
                    return line.trim();
                });
            };
            // Splits SDP into sessionpart and mediasections. Ensures CRLF.
            SDPUtils.splitSections = function(blob) {
                var parts = blob.split('\nm=');
                return parts.map(function(part, index) {
                    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
                });
            };
            // returns the session description.
            SDPUtils.getDescription = function(blob) {
                var sections = SDPUtils.splitSections(blob);
                return sections && sections[0];
            };
            // returns the individual media sections.
            SDPUtils.getMediaSections = function(blob) {
                var sections = SDPUtils.splitSections(blob);
                sections.shift();
                return sections;
            };
            // Returns lines that start with a certain prefix.
            SDPUtils.matchPrefix = function(blob, prefix) {
                return SDPUtils.splitLines(blob).filter(function(line) {
                    return line.indexOf(prefix) === 0;
                });
            };
            // Parses an ICE candidate line. Sample input:
            // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
            // rport 55996"
            SDPUtils.parseCandidate = function(line) {
                var parts;
                // Parse both variants.
                if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
                else parts = line.substring(10).split(' ');
                var candidate = {
                    foundation: parts[0],
                    component: parseInt(parts[1], 10),
                    protocol: parts[2].toLowerCase(),
                    priority: parseInt(parts[3], 10),
                    ip: parts[4],
                    address: parts[4],
                    port: parseInt(parts[5], 10),
                    // skip parts[6] == 'typ'
                    type: parts[7]
                };
                for(var i = 8; i < parts.length; i += 2)switch(parts[i]){
                    case 'raddr':
                        candidate.relatedAddress = parts[i + 1];
                        break;
                    case 'rport':
                        candidate.relatedPort = parseInt(parts[i + 1], 10);
                        break;
                    case 'tcptype':
                        candidate.tcpType = parts[i + 1];
                        break;
                    case 'ufrag':
                        candidate.ufrag = parts[i + 1]; // for backward compability.
                        candidate.usernameFragment = parts[i + 1];
                        break;
                    default:
                        candidate[parts[i]] = parts[i + 1];
                        break;
                }
                return candidate;
            };
            // Translates a candidate object into SDP candidate attribute.
            SDPUtils.writeCandidate = function(candidate) {
                var sdp = [];
                sdp.push(candidate.foundation);
                sdp.push(candidate.component);
                sdp.push(candidate.protocol.toUpperCase());
                sdp.push(candidate.priority);
                sdp.push(candidate.address || candidate.ip);
                sdp.push(candidate.port);
                var type = candidate.type;
                sdp.push('typ');
                sdp.push(type);
                if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
                    sdp.push('raddr');
                    sdp.push(candidate.relatedAddress);
                    sdp.push('rport');
                    sdp.push(candidate.relatedPort);
                }
                if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
                    sdp.push('tcptype');
                    sdp.push(candidate.tcpType);
                }
                if (candidate.usernameFragment || candidate.ufrag) {
                    sdp.push('ufrag');
                    sdp.push(candidate.usernameFragment || candidate.ufrag);
                }
                return 'candidate:' + sdp.join(' ');
            };
            // Parses an ice-options line, returns an array of option tags.
            // a=ice-options:foo bar
            SDPUtils.parseIceOptions = function(line) {
                return line.substr(14).split(' ');
            };
            // Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
            // a=rtpmap:111 opus/48000/2
            SDPUtils.parseRtpMap = function(line) {
                var parts = line.substr(9).split(' ');
                var parsed = {
                    payloadType: parseInt(parts.shift(), 10) // was: id
                };
                parts = parts[0].split('/');
                parsed.name = parts[0];
                parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
                parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
                // legacy alias, got renamed back to channels in ORTC.
                parsed.numChannels = parsed.channels;
                return parsed;
            };
            // Generate an a=rtpmap line from RTCRtpCodecCapability or
            // RTCRtpCodecParameters.
            SDPUtils.writeRtpMap = function(codec) {
                var pt = codec.payloadType;
                if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
                var channels = codec.channels || codec.numChannels || 1;
                return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
            };
            // Parses an a=extmap line (headerextension from RFC 5285). Sample input:
            // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
            // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
            SDPUtils.parseExtmap = function(line) {
                var parts = line.substr(9).split(' ');
                return {
                    id: parseInt(parts[0], 10),
                    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
                    uri: parts[1]
                };
            };
            // Generates a=extmap line from RTCRtpHeaderExtensionParameters or
            // RTCRtpHeaderExtension.
            SDPUtils.writeExtmap = function(headerExtension) {
                return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + '\r\n';
            };
            // Parses an ftmp line, returns dictionary. Sample input:
            // a=fmtp:96 vbr=on;cng=on
            // Also deals with vbr=on; cng=on
            SDPUtils.parseFmtp = function(line) {
                var parsed = {};
                var kv;
                var parts = line.substr(line.indexOf(' ') + 1).split(';');
                for(var j = 0; j < parts.length; j++){
                    kv = parts[j].trim().split('=');
                    parsed[kv[0].trim()] = kv[1];
                }
                return parsed;
            };
            // Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
            SDPUtils.writeFmtp = function(codec) {
                var line = '';
                var pt = codec.payloadType;
                if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
                if (codec.parameters && Object.keys(codec.parameters).length) {
                    var params = [];
                    Object.keys(codec.parameters).forEach(function(param) {
                        if (codec.parameters[param]) params.push(param + '=' + codec.parameters[param]);
                        else params.push(param);
                    });
                    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
                }
                return line;
            };
            // Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
            // a=rtcp-fb:98 nack rpsi
            SDPUtils.parseRtcpFb = function(line) {
                var parts = line.substr(line.indexOf(' ') + 1).split(' ');
                return {
                    type: parts.shift(),
                    parameter: parts.join(' ')
                };
            };
            // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
            SDPUtils.writeRtcpFb = function(codec) {
                var lines = '';
                var pt = codec.payloadType;
                if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
                if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
                codec.rtcpFeedback.forEach(function(fb) {
                    lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
                });
                return lines;
            };
            // Parses an RFC 5576 ssrc media attribute. Sample input:
            // a=ssrc:3735928559 cname:something
            SDPUtils.parseSsrcMedia = function(line) {
                var sp = line.indexOf(' ');
                var parts = {
                    ssrc: parseInt(line.substr(7, sp - 7), 10)
                };
                var colon = line.indexOf(':', sp);
                if (colon > -1) {
                    parts.attribute = line.substr(sp + 1, colon - sp - 1);
                    parts.value = line.substr(colon + 1);
                } else parts.attribute = line.substr(sp + 1);
                return parts;
            };
            SDPUtils.parseSsrcGroup = function(line) {
                var parts = line.substr(13).split(' ');
                return {
                    semantics: parts.shift(),
                    ssrcs: parts.map(function(ssrc) {
                        return parseInt(ssrc, 10);
                    })
                };
            };
            // Extracts the MID (RFC 5888) from a media section.
            // returns the MID or undefined if no mid line was found.
            SDPUtils.getMid = function(mediaSection) {
                var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
                if (mid) return mid.substr(6);
            };
            SDPUtils.parseFingerprint = function(line) {
                var parts = line.substr(14).split(' ');
                return {
                    algorithm: parts[0].toLowerCase(),
                    value: parts[1]
                };
            };
            // Extracts DTLS parameters from SDP media section or sessionpart.
            // FIXME: for consistency with other functions this should only
            //   get the fingerprint line as input. See also getIceParameters.
            SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
                var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
                // Note: a=setup line is ignored since we use the 'auto' role.
                // Note2: 'algorithm' is not case sensitive except in Edge.
                return {
                    role: 'auto',
                    fingerprints: lines.map(SDPUtils.parseFingerprint)
                };
            };
            // Serializes DTLS parameters to SDP.
            SDPUtils.writeDtlsParameters = function(params, setupType) {
                var sdp = 'a=setup:' + setupType + '\r\n';
                params.fingerprints.forEach(function(fp) {
                    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
                });
                return sdp;
            };
            // Parses a=crypto lines into
            //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
            SDPUtils.parseCryptoLine = function(line) {
                var parts = line.substr(9).split(' ');
                return {
                    tag: parseInt(parts[0], 10),
                    cryptoSuite: parts[1],
                    keyParams: parts[2],
                    sessionParams: parts.slice(3)
                };
            };
            SDPUtils.writeCryptoLine = function(parameters) {
                return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
            };
            // Parses the crypto key parameters into
            //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
            SDPUtils.parseCryptoKeyParams = function(keyParams) {
                if (keyParams.indexOf('inline:') !== 0) return null;
                var parts = keyParams.substr(7).split('|');
                return {
                    keyMethod: 'inline',
                    keySalt: parts[0],
                    lifeTime: parts[1],
                    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
                    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
                };
            };
            SDPUtils.writeCryptoKeyParams = function(keyParams) {
                return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
            };
            // Extracts all SDES paramters.
            SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
                var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
                return lines.map(SDPUtils.parseCryptoLine);
            };
            // Parses ICE information from SDP media section or sessionpart.
            // FIXME: for consistency with other functions this should only
            //   get the ice-ufrag and ice-pwd lines as input.
            SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
                var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
                var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
                if (!(ufrag && pwd)) return null;
                return {
                    usernameFragment: ufrag.substr(12),
                    password: pwd.substr(10)
                };
            };
            // Serializes ICE parameters to SDP.
            SDPUtils.writeIceParameters = function(params) {
                return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
            };
            // Parses the SDP media section and returns RTCRtpParameters.
            SDPUtils.parseRtpParameters = function(mediaSection) {
                var description = {
                    codecs: [],
                    headerExtensions: [],
                    fecMechanisms: [],
                    rtcp: []
                };
                var lines = SDPUtils.splitLines(mediaSection);
                var mline = lines[0].split(' ');
                for(var i = 3; i < mline.length; i++){
                    var pt = mline[i];
                    var rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
                    if (rtpmapline) {
                        var codec = SDPUtils.parseRtpMap(rtpmapline);
                        var fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
                        // Only the first a=fmtp:<pt> is considered.
                        codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
                        codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
                        description.codecs.push(codec);
                        // parse FEC mechanisms from rtpmap lines.
                        switch(codec.name.toUpperCase()){
                            case 'RED':
                            case 'ULPFEC':
                                description.fecMechanisms.push(codec.name.toUpperCase());
                                break;
                            default:
                                break;
                        }
                    }
                }
                SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
                    description.headerExtensions.push(SDPUtils.parseExtmap(line));
                });
                // FIXME: parse rtcp.
                return description;
            };
            // Generates parts of the SDP media section describing the capabilities /
            // parameters.
            SDPUtils.writeRtpDescription = function(kind, caps) {
                var sdp = '';
                // Build the mline.
                sdp += 'm=' + kind + ' ';
                sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
                sdp += ' UDP/TLS/RTP/SAVPF ';
                sdp += caps.codecs.map(function(codec) {
                    if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
                    return codec.payloadType;
                }).join(' ') + '\r\n';
                sdp += 'c=IN IP4 0.0.0.0\r\n';
                sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
                // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
                caps.codecs.forEach(function(codec) {
                    sdp += SDPUtils.writeRtpMap(codec);
                    sdp += SDPUtils.writeFmtp(codec);
                    sdp += SDPUtils.writeRtcpFb(codec);
                });
                var maxptime = 0;
                caps.codecs.forEach(function(codec) {
                    if (codec.maxptime > maxptime) maxptime = codec.maxptime;
                });
                if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
                sdp += 'a=rtcp-mux\r\n';
                if (caps.headerExtensions) caps.headerExtensions.forEach(function(extension) {
                    sdp += SDPUtils.writeExtmap(extension);
                });
                // FIXME: write fecMechanisms.
                return sdp;
            };
            // Parses the SDP media section and returns an array of
            // RTCRtpEncodingParameters.
            SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
                var encodingParameters = [];
                var description = SDPUtils.parseRtpParameters(mediaSection);
                var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
                var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
                // filter a=ssrc:... cname:, ignore PlanB-msid
                var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
                    return SDPUtils.parseSsrcMedia(line);
                }).filter(function(parts) {
                    return parts.attribute === 'cname';
                });
                var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
                var secondarySsrc;
                var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map(function(line) {
                    var parts = line.substr(17).split(' ');
                    return parts.map(function(part) {
                        return parseInt(part, 10);
                    });
                });
                if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
                description.codecs.forEach(function(codec) {
                    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
                        var encParam = {
                            ssrc: primarySsrc,
                            codecPayloadType: parseInt(codec.parameters.apt, 10)
                        };
                        if (primarySsrc && secondarySsrc) encParam.rtx = {
                            ssrc: secondarySsrc
                        };
                        encodingParameters.push(encParam);
                        if (hasRed) {
                            encParam = JSON.parse(JSON.stringify(encParam));
                            encParam.fec = {
                                ssrc: primarySsrc,
                                mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                            };
                            encodingParameters.push(encParam);
                        }
                    }
                });
                if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
                    ssrc: primarySsrc
                });
                // we support both b=AS and b=TIAS but interpret AS as TIAS.
                var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
                if (bandwidth.length) {
                    if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substr(7), 10);
                    else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
                    bandwidth = parseInt(bandwidth[0].substr(5), 10) * 950 - 16000;
                    else bandwidth = undefined;
                    encodingParameters.forEach(function(params) {
                        params.maxBitrate = bandwidth;
                    });
                }
                return encodingParameters;
            };
            // parses http://draft.ortc.org/#rtcrtcpparameters*
            SDPUtils.parseRtcpParameters = function(mediaSection) {
                var rtcpParameters = {};
                // Gets the first SSRC. Note tha with RTX there might be multiple
                // SSRCs.
                var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
                    return SDPUtils.parseSsrcMedia(line);
                }).filter(function(obj) {
                    return obj.attribute === 'cname';
                })[0];
                if (remoteSsrc) {
                    rtcpParameters.cname = remoteSsrc.value;
                    rtcpParameters.ssrc = remoteSsrc.ssrc;
                }
                // Edge uses the compound attribute instead of reducedSize
                // compound is !reducedSize
                var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
                rtcpParameters.reducedSize = rsize.length > 0;
                rtcpParameters.compound = rsize.length === 0;
                // parses the rtcp-mux attrіbute.
                // Note that Edge does not support unmuxed RTCP.
                var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
                rtcpParameters.mux = mux.length > 0;
                return rtcpParameters;
            };
            // parses either a=msid: or a=ssrc:... msid lines and returns
            // the id of the MediaStream and MediaStreamTrack.
            SDPUtils.parseMsid = function(mediaSection) {
                var parts;
                var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
                if (spec.length === 1) {
                    parts = spec[0].substr(7).split(' ');
                    return {
                        stream: parts[0],
                        track: parts[1]
                    };
                }
                var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
                    return SDPUtils.parseSsrcMedia(line);
                }).filter(function(msidParts) {
                    return msidParts.attribute === 'msid';
                });
                if (planB.length > 0) {
                    parts = planB[0].value.split(' ');
                    return {
                        stream: parts[0],
                        track: parts[1]
                    };
                }
            };
            // SCTP
            // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
            // to draft-ietf-mmusic-sctp-sdp-05
            SDPUtils.parseSctpDescription = function(mediaSection) {
                var mline = SDPUtils.parseMLine(mediaSection);
                var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
                var maxMessageSize;
                if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
                if (isNaN(maxMessageSize)) maxMessageSize = 65536;
                var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
                if (sctpPort.length > 0) return {
                    port: parseInt(sctpPort[0].substr(12), 10),
                    protocol: mline.fmt,
                    maxMessageSize: maxMessageSize
                };
                var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
                if (sctpMapLines.length > 0) {
                    var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0].substr(10).split(' ');
                    return {
                        port: parseInt(parts[0], 10),
                        protocol: parts[1],
                        maxMessageSize: maxMessageSize
                    };
                }
            };
            // SCTP
            // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
            // support by now receiving in this format, unless we originally parsed
            // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
            // protocol of DTLS/SCTP -- without UDP/ or TCP/)
            SDPUtils.writeSctpDescription = function(media, sctp) {
                var output = [];
                if (media.protocol !== 'DTLS/SCTP') output = [
                    'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
                    'c=IN IP4 0.0.0.0\r\n',
                    'a=sctp-port:' + sctp.port + '\r\n'
                ];
                else output = [
                    'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
                    'c=IN IP4 0.0.0.0\r\n',
                    'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
                ];
                if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
                return output.join('');
            };
            // Generate a session ID for SDP.
            // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
            // recommends using a cryptographically random +ve 64-bit value
            // but right now this should be acceptable and within the right range
            SDPUtils.generateSessionId = function() {
                return Math.random().toString().substr(2, 21);
            };
            // Write boilder plate for start of SDP
            // sessId argument is optional - if not supplied it will
            // be generated randomly
            // sessVersion is optional and defaults to 2
            // sessUser is optional and defaults to 'thisisadapterortc'
            SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
                var sessionId;
                var version = sessVer !== undefined ? sessVer : 2;
                if (sessId) sessionId = sessId;
                else sessionId = SDPUtils.generateSessionId();
                var user = sessUser || 'thisisadapterortc';
                // FIXME: sess-id should be an NTP timestamp.
                return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
            };
            SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
                var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
                // Map ICE parameters (ufrag, pwd) to SDP.
                sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
                // Map DTLS parameters to SDP.
                sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : 'active');
                sdp += 'a=mid:' + transceiver.mid + '\r\n';
                if (transceiver.direction) sdp += 'a=' + transceiver.direction + '\r\n';
                else if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += 'a=sendrecv\r\n';
                else if (transceiver.rtpSender) sdp += 'a=sendonly\r\n';
                else if (transceiver.rtpReceiver) sdp += 'a=recvonly\r\n';
                else sdp += 'a=inactive\r\n';
                if (transceiver.rtpSender) {
                    // spec.
                    var msid = 'msid:' + stream.id + ' ' + transceiver.rtpSender.track.id + '\r\n';
                    sdp += 'a=' + msid;
                    // for Chrome.
                    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;
                    if (transceiver.sendEncodingParameters[0].rtx) {
                        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
                        sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
                    }
                }
                // FIXME: this should be written by writeRtpDescription.
                sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
                if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
                return sdp;
            };
            // Gets the direction from the mediaSection or the sessionpart.
            SDPUtils.getDirection = function(mediaSection, sessionpart) {
                // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
                var lines = SDPUtils.splitLines(mediaSection);
                for(var i = 0; i < lines.length; i++)switch(lines[i]){
                    case 'a=sendrecv':
                    case 'a=sendonly':
                    case 'a=recvonly':
                    case 'a=inactive':
                        return lines[i].substr(2);
                    default:
                }
                if (sessionpart) return SDPUtils.getDirection(sessionpart);
                return 'sendrecv';
            };
            SDPUtils.getKind = function(mediaSection) {
                var lines = SDPUtils.splitLines(mediaSection);
                var mline = lines[0].split(' ');
                return mline[0].substr(2);
            };
            SDPUtils.isRejected = function(mediaSection) {
                return mediaSection.split(' ', 2)[1] === '0';
            };
            SDPUtils.parseMLine = function(mediaSection) {
                var lines = SDPUtils.splitLines(mediaSection);
                var parts = lines[0].substr(2).split(' ');
                return {
                    kind: parts[0],
                    port: parseInt(parts[1], 10),
                    protocol: parts[2],
                    fmt: parts.slice(3).join(' ')
                };
            };
            SDPUtils.parseOLine = function(mediaSection) {
                var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
                var parts = line.substr(2).split(' ');
                return {
                    username: parts[0],
                    sessionId: parts[1],
                    sessionVersion: parseInt(parts[2], 10),
                    netType: parts[3],
                    addressType: parts[4],
                    address: parts[5]
                };
            };
            // a very naive interpretation of a valid SDP.
            SDPUtils.isValidSDP = function(blob) {
                if (typeof blob !== 'string' || blob.length === 0) return false;
                var lines = SDPUtils.splitLines(blob);
                for(var i = 0; i < lines.length; i++){
                    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
                // TODO: check the modifier a bit more.
                }
                return true;
            };
            module1.exports = SDPUtils;
        /***/ },
        /* 252 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Returns the number of streams allowed for simulcast
 * @param {Boolean} isChromiumEdge
 * @param {String} browserName
 * @param {Boolean} isScreenSharing
 * @param {Boolean} isCustomVideoTrack
 * @param {Object} sessionInfo
 * @param {Object} constraints
 * @param {Object} videoDimensions
 * @return {Number}
*/ module1.exports = function calculateCapableSimulcastStreams(opt) {
                const supportedBrowsers = [
                    'Chrome',
                    'Safari',
                    'Edge',
                    'Opera'
                ];
                if (supportedBrowsers.indexOf(opt.browserName) === -1 || opt.browserName === 'Edge' && !opt.isChromiumEdge || opt.isScreenSharing && !opt.capableSimulcastScreenshare || opt.sessionInfo.p2pEnabled || !opt.constraints.video && !opt.isCustomVideoTrack) // We only support simulcast on Chromium browsers and Safari for routed sessions
                return 1;
                 // HD and above gets three streams. Otherwise they get 2.
                if (opt.videoDimensions.width > 640 && opt.videoDimensions.height > 480) return 3;
                return 2;
            };
        /***/ },
        /* 253 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _temp;
            /* eslint-disable no-underscore-dangle */ const now = __webpack_require__(50);
            /*
 * A <code>RTCPeerConnection.getStats</code> based audio level sampler.
 *
 * It uses the <code>getStats</code> method to get the <code>audioOutputLevel</code>.
 * This implementation expects the single parameter version of the <code>getStats</code> method.
 *
 * Currently the <code>audioOutputLevel</code> stats is only supported in Chrome.
 *
 * @param {function} "getStats" function or "getSynchronizationSources" function
 * @constructor
 */ module1.exports = (_temp = /*#__PURE__*/ function() {
                function GetAudioLevelSampler(getAudioLevel, _temp2) {
                    var _context;
                    let _ref = _temp2 === void 0 ? {} : _temp2, _ref$requestAnimation = _ref.requestAnimationFrame, requestAnimationFrame = _ref$requestAnimation === void 0 ? (_context = window).requestAnimationFrame.bind(_context) : _ref$requestAnimation;
                    (0, _defineProperty2.default)(this, "_lastCalled", now());
                    (0, _defineProperty2.default)(this, "_audioLevel", undefined);
                    (0, _defineProperty2.default)(this, "_running", false);
                    this._requestAnimationFrame = requestAnimationFrame;
                    this._getAudioLevel = getAudioLevel;
                    this._startLoop();
                }
                var _proto = GetAudioLevelSampler.prototype;
                _proto._startLoop = function _startLoop() {
                    if (this._running) return;
                    this._running = true;
                    this._requestAnimationFrame(this._loop.bind(this));
                };
                _proto._loop = function _loop() {
                    this._getAudioLevel((error, stats)=>{
                        // @todo we should measure how long the getStats so that we can determine
                        // our impact on the render loop, and skip frames if need to reduce our
                        // CPU utilization
                        // Stat entries without audio can have audioLevel 0 so we just look for the max level
                        let maxLevel = null;
                        if (!error) {
                            for(let idx = 0; idx < stats.length; idx += 1){
                                const stat = stats[idx];
                                let level = null;
                                if (stat.audioOutputLevel !== undefined) {
                                    // the max value delivered by getStats via audioOutputLevel is 2^15
                                    const audioOutputLevel = parseFloat(stat.audioOutputLevel) / 32768;
                                    if (!isNaN(audioOutputLevel)) level = audioOutputLevel;
                                } else if (stat.audioLevel !== undefined) level = stat.audioLevel;
                                if (level !== null && (maxLevel === null || level > maxLevel)) maxLevel = level;
                            }
                            this._audioLevel = maxLevel;
                            if (this._running && now() - this._lastCalled < 10000) this._requestAnimationFrame(this._loop.bind(this));
                            else this._running = false;
                        }
                    });
                };
                _proto.destroy = function destroy() {
                    this._running = false;
                };
                _proto.sample = function sample(done) {
                    if (typeof done === 'function') throw new Error('sample no longer takes a callback');
                    this._startLoop();
                    this._lastCalled = now();
                    return this._audioLevel;
                };
                return GetAudioLevelSampler;
            }(), _temp);
        /***/ },
        /* 254 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const merge = __webpack_require__(255);
            const normalizeConstraintInput = __webpack_require__(575);
            const isScreenSharingSource = __webpack_require__(148);
            function createSourceConstraint(media, enableRenegotiation, usingOptionalMandatoryStyle) {
                if (!media.publish && enableRenegotiation) // FIXME: I'm still not quite happy with how this works. With renegotiation, when publish
                // changes to true we shouldn't have to recalculate constraints. I think Publisher should handle
                // this override instead and this component shouldn't know anything about renegotiation.
                // Related: OPENTOK-31082
                return false;
                if (typeof media.source === 'boolean') return media.source;
                if (usingOptionalMandatoryStyle) return {
                    mandatory: {
                        sourceId: media.source
                    }
                };
                 // getDisplayMedia doesn't support exact constraints
                if (isScreenSharingSource(media.source)) return {};
                return {
                    deviceId: {
                        exact: media.source
                    }
                };
            }
            function generateAudioConstraints(opt) {
                let constraints = createSourceConstraint(opt.audio, opt.enableRenegotiation, opt.usingOptionalMandatoryStyle);
                if (constraints === false) return false;
                const usingOptionalMandatoryStyle = opt.usingOptionalMandatoryStyle, enableStereo = opt.enableStereo, echoCancellation = opt.echoCancellation, noiseSuppression = opt.noiseSuppression, autoGainControl = opt.autoGainControl, disableAudioProcessing = opt.disableAudioProcessing;
                const addConstraint = (constraint)=>{
                    if (typeof constraints !== 'object') return; // Chrome<61 uses optional/mandatory style because a boolean is equivalent to an ideal value
                    // See https://bugs.chromium.org/p/chromium/issues/detail?id=700223#c3
                    if (usingOptionalMandatoryStyle) {
                        merge(constraints, {
                            optional: []
                        });
                        constraints.optional.push(constraint);
                    } else merge(constraints, constraint);
                };
                if ((enableStereo || disableAudioProcessing || !echoCancellation || !noiseSuppression || !autoGainControl) && constraints === true) constraints = {};
                if (enableStereo) addConstraint({
                    channelCount: 2
                });
                [
                    'echoCancellation',
                    'autoGainControl',
                    'noiseSuppression'
                ].forEach((audioConstraintName)=>{
                    const constraintValue = !disableAudioProcessing && opt[audioConstraintName];
                    addConstraint({
                        [audioConstraintName]: constraintValue
                    });
                });
                return constraints;
            }
            function generateVideoConstraints(opt) {
                let constraints = createSourceConstraint(opt.video, opt.enableRenegotiation, opt.usingOptionalMandatoryStyle);
                if (constraints === false) return false;
                const videoDimensions = opt.videoDimensions, frameRate = opt.frameRate, maxResolution = opt.maxResolution, facingMode = opt.facingMode, usingOptionalMandatoryStyle = opt.usingOptionalMandatoryStyle;
                if ((videoDimensions || frameRate || maxResolution || facingMode) && constraints === true) constraints = {};
                if (videoDimensions) {
                    const width = videoDimensions.width;
                    const height = videoDimensions.height;
                    if (usingOptionalMandatoryStyle) {
                        merge(constraints, {
                            optional: []
                        });
                        constraints.optional.push({
                            minWidth: width
                        }, {
                            maxWidth: width
                        }, {
                            minHeight: height
                        }, {
                            maxHeight: height
                        });
                    } else merge(constraints, {
                        width: {
                            ideal: width
                        },
                        height: {
                            ideal: height
                        }
                    });
                }
                if (frameRate) {
                    if (usingOptionalMandatoryStyle) {
                        merge(constraints, {
                            optional: []
                        });
                        constraints.optional.push({
                            minFrameRate: frameRate
                        }, {
                            maxFrameRate: frameRate
                        });
                    } else merge(constraints, {
                        frameRate: {
                            ideal: frameRate
                        }
                    });
                }
                if (maxResolution) {
                    if (usingOptionalMandatoryStyle) merge(constraints, {
                        mandatory: {
                            maxWidth: maxResolution.width,
                            maxHeight: maxResolution.height
                        }
                    });
                    else merge(constraints, {
                        width: {
                            max: maxResolution.width
                        },
                        height: {
                            max: maxResolution.height
                        }
                    });
                }
                if (facingMode) {
                    if (usingOptionalMandatoryStyle) {
                        merge(constraints, {
                            optional: []
                        });
                        constraints.optional.push({
                            facingMode: facingMode
                        });
                    } else merge(constraints, {
                        facingMode: {
                            ideal: facingMode
                        }
                    });
                }
                return constraints;
            }
            function generateConstraints(opt) {
                return {
                    audio: generateAudioConstraints(opt),
                    video: generateVideoConstraints(opt)
                };
            }
            module1.exports = function generateConstraintInfo(opt) {
                const normOpt = normalizeConstraintInput(opt);
                const constraints = generateConstraints(normOpt);
                return {
                    constraints: constraints,
                    publishAudio: normOpt.audio.publish,
                    publishVideo: normOpt.video.publish,
                    frameRate: normOpt.frameRate,
                    videoDimensions: normOpt.videoDimensions,
                    audioDeviceId: typeof normOpt.audio.source === 'string' ? normOpt.audio.source : undefined,
                    videoDeviceId: typeof normOpt.video.source === 'string' ? normOpt.video.source : undefined
                };
            };
        /***/ },
        /* 255 */ /***/ function(module1, exports, __webpack_require__) {
            var baseMerge = __webpack_require__(572), createAssigner = __webpack_require__(192);
            /**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
            });
            module1.exports = merge;
        /***/ },
        /* 256 */ /***/ function(module1, exports, __webpack_require__) {
            var baseAssignValue = __webpack_require__(64), eq = __webpack_require__(54);
            /**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            module1.exports = assignMergeValue;
        /***/ },
        /* 257 */ /***/ function(module1, exports) {
            /**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') return;
                if (key == '__proto__') return;
                return object[key];
            }
            module1.exports = safeGet;
        /***/ },
        /* 258 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(3), name = _require.name, version = _require.version, isChromiumEdge = _require.isChromiumEdge;
            module1.exports = isChromiumEdge || name === 'Chrome' && version >= 72 || name === 'Firefox' && version >= 66 || name === 'Opera' && version >= 60 || name === 'Safari';
        /***/ },
        /* 259 */ /***/ function(module1, exports, __webpack_require__) {
            var toString = __webpack_require__(61), upperFirst = __webpack_require__(260);
            /**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
            }
            module1.exports = capitalize;
        /***/ },
        /* 260 */ /***/ function(module1, exports, __webpack_require__) {
            var createCaseFirst = __webpack_require__(580);
            /**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst('toUpperCase');
            module1.exports = upperFirst;
        /***/ },
        /* 261 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            module1.exports = baseSlice;
        /***/ },
        /* 262 */ /***/ function(module1, exports) {
            /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
            /** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
            /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
            /**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
                return reHasUnicode.test(string);
            }
            module1.exports = hasUnicode;
        /***/ },
        /* 263 */ /***/ function(module1, exports, __webpack_require__) {
            var asciiToArray = __webpack_require__(582), hasUnicode = __webpack_require__(262), unicodeToArray = __webpack_require__(583);
            /**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
                return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
            }
            module1.exports = stringToArray;
        /***/ },
        /* 264 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            /*
the capture screen share with audio is only avaible for Chrome >= 74 & Chromium Edge >= 79, see
https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#browser_compatibility

Also note that capture audio is only avaible for the user via the checkmark in tab selection
*/ module1.exports = Boolean(env.isChrome && env.version >= 74 || env.isEdge && env.version >= 79);
        /***/ },
        /* 265 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* global MediaStreamTrack */ const env = __webpack_require__(3);
            module1.exports = (videoSource)=>{
                if (!env.isElectron) return false;
                 // ElectronJS sets the label to the same value for screensharing sources,
                // regardless of the DesktopCapturer source type
                return videoSource instanceof MediaStreamTrack && videoSource.label === 'Screen';
            };
        /***/ },
        /* 266 */ /***/ function(module1, exports, __webpack_require__) {
            var baseForOwn = __webpack_require__(100), createBaseEach = __webpack_require__(589);
            /**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
            module1.exports = baseEach;
        /***/ },
        /* 267 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = 15000;
        /***/ },
        /* 268 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * castToBoolean
 *
 * @param {any} The value to cast
 * @returns {Boolean} True if value === 'true' or value === true, otherwise false.
 */ module1.exports = function(value, defaultValue) {
                if (defaultValue === void 0) defaultValue = false;
                return value === undefined ? defaultValue : value === 'true' || value === true;
            };
        /***/ },
        /* 269 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const cloneDeep = __webpack_require__(58); // The backgroundImageURI of the styleHash object that we log to analytics needs to be stripped down
            // because base64 data blobs are often very large and can be a privacy issue if taken from the
            // user's camera.
            module1.exports = function styleHashLogFilter(styleHashInput) {
                const styleHash = cloneDeep(styleHashInput);
                if (styleHash.backgroundImageURI) {
                    const protocol = styleHash.backgroundImageURI.split(':')[0];
                    styleHash.backgroundImageURI = [
                        'http',
                        'https',
                        'data'
                    ].indexOf(protocol) !== -1 ? protocol : 'other';
                }
                return styleHash;
            };
        /***/ },
        /* 270 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            module1.exports = ()=>{
                const isBrowser = !env.isNode && !env.isElectron;
                if (!isBrowser) return false;
                 // More recent browsers don't expose GUM when called in insecure context
                // From https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
                const isSecureContextRequired = (env.isChrome || env.isOpera || env.isChromiumEdge) && env.version >= 74 || env.isFirefox && env.version >= 68 || // See https://webkit.org/blog/7763/a-closer-look-into-webrtc/
                env.isSafari && env.version >= 11;
                return isSecureContextRequired;
            };
        /***/ },
        /* 271 */ /***/ function(module1, exports) {
            function _setPrototypeOf(o, p) {
                module1.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            module1.exports = _setPrototypeOf;
        /***/ },
        /* 272 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayMap = __webpack_require__(34), baseClone = __webpack_require__(78), baseUnset = __webpack_require__(605), castPath = __webpack_require__(60), copyObject = __webpack_require__(41), customOmitClone = __webpack_require__(608), flatRest = __webpack_require__(137), getAllKeysIn = __webpack_require__(185);
            /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
            /**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
                var result = {};
                if (object == null) return result;
                var isDeep = false;
                paths = arrayMap(paths, function(path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                });
                copyObject(object, getAllKeysIn(object), result);
                if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                var length = paths.length;
                while(length--)baseUnset(result, paths[length]);
                return result;
            });
            module1.exports = omit;
        /***/ },
        /* 273 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFindIndex = __webpack_require__(206), baseIteratee = __webpack_require__(36), toInteger = __webpack_require__(97);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
            /**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseFindIndex(array, baseIteratee(predicate, 3), index);
            }
            module1.exports = findIndex;
        /***/ },
        /* 274 */ /***/ function(module1, exports, __webpack_require__) {
            var baseUniq = __webpack_require__(610);
            /**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
            }
            module1.exports = uniq;
        /***/ },
        /* 275 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const toArray = __webpack_require__(617);
            const getRtcStatsReportAdapter = __webpack_require__(278);
            const shouldUseStandardGetStats = __webpack_require__(102)(); // This returns the array-ified list of stats our users are accustomed to
            module1.exports = (peerConnection, completion)=>{
                getRtcStatsReportAdapter(peerConnection, (err, rtcStatsReport)=>{
                    let stats = [];
                    if (shouldUseStandardGetStats) {
                        // Firefox <= 45 can't use rtcStatsReport.values OPENTOK-32755
                        if (typeof rtcStatsReport.values === 'function') stats = toArray(rtcStatsReport.values());
                        else if (typeof rtcStatsReport.forEach !== 'function') stats = Object.keys(rtcStatsReport).map((key)=>rtcStatsReport[key]);
                        else rtcStatsReport.forEach((rtcStats)=>{
                            stats.push(rtcStats);
                        });
                    } else rtcStatsReport.result().forEach((rtcStat)=>{
                        const stat = {};
                        rtcStat.names().forEach((name)=>{
                            stat[name] = rtcStat.stat(name);
                        }); // fake the structure of the "new" RTC stat object
                        stat.id = rtcStat.id;
                        stat.type = rtcStat.type;
                        stat.timestamp = rtcStat.timestamp;
                        stats.push(stat);
                    });
                    completion(null, stats);
                });
            };
        /***/ },
        /* 276 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isArray = __webpack_require__(12), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var stringTag = '[object String]';
            /**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            module1.exports = isString;
        /***/ },
        /* 277 */ /***/ function(module1, exports, __webpack_require__) {
            var baseValues = __webpack_require__(619), keys = __webpack_require__(30);
            /**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
            }
            module1.exports = values;
        /***/ },
        /* 278 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const shouldUseStandardGetStats = __webpack_require__(102)();
            const getRtcStats = (peerConnection, completion)=>{
                peerConnection.getStats(null).then((stats)=>completion(null, stats)).catch(completion);
            };
            const getRtcStatsLegacy = (peerConnection, completion)=>{
                peerConnection.getStats((stats)=>{
                    completion(null, stats);
                }, completion);
            }; // This returns the native or "raw" RtcStatsReport object
            const getRtcStatsReportAdapter = (peerConnection, completion)=>{
                const getRtcStatsReport = shouldUseStandardGetStats ? getRtcStats : getRtcStatsLegacy;
                getRtcStatsReport(peerConnection, completion);
            };
            module1.exports = getRtcStatsReportAdapter;
        /***/ },
        /* 279 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(156));
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _events = __webpack_require__(31);
            var _clone = _interopRequireDefault(__webpack_require__(38));
            var _parseQOS = _interopRequireDefault(__webpack_require__(629));
            var _TruthyChangeCounter = _interopRequireDefault(__webpack_require__(631));
            var _now = _interopRequireDefault(__webpack_require__(50));
            var _log = _interopRequireDefault(__webpack_require__(2));
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-void, no-use-before-define, one-var */ /* eslint-disable no-restricted-syntax, no-prototype-builtins, no-underscore-dangle */ const logging = (0, _log.default)('QoS');
            let Qos = /*#__PURE__*/ function(_EventEmitter) {
                (0, _inheritsLoose2.default)(Qos, _EventEmitter);
                function Qos() {
                    var _this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    _this = _EventEmitter.call(this, ...args) || this;
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_peerConnection", void 0);
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isPublisher", void 0);
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeoutId", void 0);
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_creationTime", (0, _now.default)());
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "offerMessagesReceived", 0);
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prevStats", {
                        timeStamp: (0, _now.default)()
                    });
                    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeCounters", {
                        videoCodec: new _TruthyChangeCounter.default(),
                        audioCodec: new _TruthyChangeCounter.default()
                    });
                    return _this;
                }
                var _proto = Qos.prototype;
                _proto.startCollecting = function startCollecting(peerConnection, isPublisher) {
                    if (!peerConnection || !peerConnection.getStats) // this peerConnection doesn't support getStats, bail
                    return;
                    this._isPublisher = isPublisher;
                    const hadPeerConnection = Boolean(this._peerConnection);
                    this._peerConnection = peerConnection;
                    if (hadPeerConnection) return;
                    const collectionLoop = (interval)=>{
                        const currentTime = (0, _now.default)(); // parseQOS pushes properties onto this object and gives it back
                        const blankStats = {
                            timeStamp: currentTime,
                            duration: Math.round((currentTime - this._creationTime) / 1000),
                            period: Math.round((currentTime - this.prevStats.timeStamp) / 1000)
                        };
                        (0, _parseQOS.default)(this._peerConnection, this.prevStats, blankStats, this._isPublisher, (err, parsedStats)=>{
                            if (err) {
                                logging.error('Failed to Parse QOS Stats:', err);
                                return;
                            }
                            this.handleParsedStats(parsedStats); // Recalculate the stats
                            clearTimeout(this.timeoutId);
                            this.timeoutId = setTimeout(()=>collectionLoop(Qos.INTERVAL), interval);
                        });
                    };
                    this.timeoutId = setTimeout(()=>collectionLoop(Qos.INTERVAL - Qos.INITIAL_INTERVAL), Qos.INITIAL_INTERVAL);
                };
                _proto.stopCollecting = function stopCollecting() {
                    if (this.timeoutId) {
                        clearTimeout(this.timeoutId);
                        this.timeoutId = null;
                    }
                    this._peerConnection = null;
                };
                _proto.handleOfferMessageReceived = function handleOfferMessageReceived() {
                    this.offerMessagesReceived += 1;
                };
                _proto.handleParsedStats = function handleParsedStats(parsedStats) {
                    Object.keys(this.changeCounters).forEach((key)=>{
                        this.changeCounters[key].onValue(parsedStats[key]); // audioCodecChangeCount, videoCodecChangeCount
                        parsedStats[`${key}ChangeCount`] = this.changeCounters[key].changeCount;
                    });
                    parsedStats.offerMessagesReceived = this.offerMessagesReceived;
                    const periodicStats = (0, _clone.default)(parsedStats); // The following stats are reported with cumulative values:
                    const periodicDataKeys = [
                        'audioSentBytes',
                        'audioSentPackets',
                        'audioSentPacketsLost',
                        'videoSentBytes',
                        'videoSentPackets',
                        'videoSentPacketsLost',
                        'audioRecvBytes',
                        'audioRecvPackets',
                        'audioRecvPacketsLost',
                        'videoRecvBytes',
                        'videoRecvPackets',
                        'videoRecvPacketsLost'
                    ]; // This adjusts the QoS values to be periodic, rather than cumulative:
                    periodicDataKeys.forEach((dataKey)=>{
                        periodicStats[dataKey] = this.prevStats && this.prevStats[dataKey] ? parsedStats[dataKey] - this.prevStats[dataKey] : parsedStats[dataKey];
                    });
                    if (this.prevStats && this.prevStats.videoFramesReceived) {
                        const framesReceived = parsedStats.videoFramesReceived - this.prevStats.videoFramesReceived;
                        const period = parsedStats.period;
                        periodicStats.videoFrameRateReceived = Math.round(framesReceived / period);
                    }
                    this.prevStats = parsedStats; // We only need framesDecoded and framesEncoded in prevStats for calculating the video framerate
                    // in Firefox 96+. So we can safely delete it from periodicStats to avoid putting it in the
                    // QOS log.
                    delete periodicStats.framesDecoded;
                    delete periodicStats.framesEncoded;
                    this.emit('stats', periodicStats);
                };
                return Qos;
            }(_events.EventEmitter); // Send stats after 1 sec
            Qos.INITIAL_INTERVAL = 1000; // Recalculate the stats every 30 sec
            Qos.INTERVAL = 30000;
            var _default = Qos;
            exports.default = _default;
        /***/ },
        /* 280 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (priority)=>{
                switch(priority >> 24){
                    // eslint-disable-line no-bitwise
                    case 0:
                        return 'TURN/TLS';
                    case 1:
                        return 'TURN/TCP';
                    case 2:
                        return 'TURN/UDP';
                    default:
                        return '';
                }
            };
        /***/ },
        /* 281 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require, no-void, prefer-rest-params, no-shadow */ const uuid = __webpack_require__(16);
            const _require = __webpack_require__(159), haveGetDisplayMediaDefault = _require.default;
            const ErrorsDefault = __webpack_require__(6);
            const otErrorDefault = __webpack_require__(13);
            module1.exports = function chromeExtensionHelperFactory(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$haveGetDisplayMe = _ref.haveGetDisplayMedia, haveGetDisplayMedia = _ref$haveGetDisplayMe === void 0 ? haveGetDisplayMediaDefault : _ref$haveGetDisplayMe, _ref$global = _ref.global, context = _ref$global === void 0 ? window : _ref$global, _ref$Errors = _ref.Errors, Errors = _ref$Errors === void 0 ? ErrorsDefault : _ref$Errors, _ref$otError = _ref.otError, otError = _ref$otError === void 0 ? otErrorDefault() : _ref$otError;
                const isSupportedInThisBrowser = !haveGetDisplayMedia && !!context.navigator.webkitGetUserMedia && !context.navigator.userAgent.match(/android/i) && typeof context.chrome !== 'undefined';
                return {
                    isSupportedInThisBrowser: isSupportedInThisBrowser,
                    autoRegisters: false,
                    extensionRequired: true,
                    getConstraintsShowsPermissionUI: true,
                    sources: {
                        screen: true,
                        application: false,
                        window: true,
                        browser: true
                    },
                    register (extensionID, version) {
                        if (version === 2) return this.registerVersion2(extensionID);
                        return this.registerVersion1(extensionID);
                    },
                    registerVersion1 (extensionID) {
                        if (!extensionID) throw new Error('initChromeScreenSharingExtensionHelper: extensionID is required.');
                        const isChrome = isSupportedInThisBrowser;
                        const callbackRegistry = {};
                        let isInstalled = void 0;
                        const prefix = `com.tokbox.screenSharing.${extensionID}`;
                        const request = function request(method, payload) {
                            const res = {
                                payload: payload,
                                from: 'jsapi'
                            };
                            res[prefix] = method;
                            return res;
                        };
                        const addCallback = function addCallback(fn, timeToWait) {
                            let timeout;
                            const requestId = uuid();
                            callbackRegistry[requestId] = function() {
                                clearTimeout(timeout);
                                timeout = null;
                                fn(...arguments);
                            };
                            if (timeToWait) timeout = setTimeout(()=>{
                                delete callbackRegistry[requestId];
                                fn(otError(Errors.TIMEOUT, new Error('Timeout waiting for response to screensharing request.')));
                            }, timeToWait);
                            return requestId;
                        };
                        const isAvailable = function isAvailable(callback) {
                            if (!callback) throw new Error('isAvailable: callback is required.');
                            if (!isChrome) {
                                setTimeout(callback.bind(null, false));
                                return;
                            }
                            if (isInstalled !== void 0) setTimeout(callback.bind(null, isInstalled));
                            else {
                                const requestId = addCallback((event)=>{
                                    if (isInstalled !== true) isInstalled = event === 'extensionLoaded';
                                    callback(isInstalled);
                                }, 2000);
                                const post = request('isExtensionInstalled', {
                                    requestId: requestId
                                });
                                context.postMessage(post, '*');
                            }
                        };
                        const getConstraints = function getConstraints(source, constraints, callback) {
                            if (!callback) throw new Error('getSourceId: callback is required');
                            isAvailable((isInstalled)=>{
                                if (!isInstalled) return callback(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error('Extension is not installed')));
                                const requestId = addCallback((event, payload)=>{
                                    if (typeof event === 'object' && event.name && event.stack) {
                                        // FIXME: The callback shouldn't be overloaded like this ('event' is actually an
                                        // error), but I'm adding tests and don't want to refactor right now without testing
                                        // more thorougly.
                                        const error = event;
                                        callback(error);
                                    } else if (event === 'permissionDenied') callback(otError(Errors.USER_MEDIA_ACCESS_DENIED, new Error('User denied access to screensharing')));
                                    else {
                                        if (!constraints.video) constraints.video = {};
                                        if (!constraints.video.mandatory) constraints.video.mandatory = {};
                                        constraints.video.mandatory.chromeMediaSource = 'desktop';
                                        constraints.video.mandatory.chromeMediaSourceId = payload.sourceId;
                                        callback(void 0, constraints);
                                    }
                                });
                                context.postMessage(request('getSourceId', {
                                    requestId: requestId,
                                    source: source
                                }), '*');
                                return undefined;
                            });
                        };
                        context.addEventListener('message', (event)=>{
                            if (event.origin !== context.location.origin) return;
                            if (!(event.data != null && typeof event.data === 'object')) return;
                            if (event.data.from !== 'extension') return;
                            const method = event.data[prefix];
                            const payload = event.data.payload;
                            if (payload && payload.requestId) {
                                const callback = callbackRegistry[payload.requestId];
                                delete callbackRegistry[payload.requestId];
                                if (callback) callback(method, payload);
                            }
                            if (method === 'extensionLoaded') isInstalled = true;
                        });
                        return {
                            extensionAPIVersion: 1,
                            extensionID: extensionID,
                            isInstalled: isAvailable,
                            getConstraints: getConstraints
                        };
                    },
                    registerVersion2 (extensionID) {
                        const isChrome = isSupportedInThisBrowser && typeof context.chrome.runtime !== 'undefined';
                        const isInstalled = function isInstalled(callback) {
                            if (!callback) throw new Error('isAvailable: callback is required.');
                            if (!isChrome) {
                                setTimeout(callback.bind(null, false));
                                return;
                            }
                            context.chrome.runtime.sendMessage(extensionID, {
                                type: 'isInstalled'
                            }, null, (response)=>{
                                setTimeout(callback.bind(null, !!response));
                            });
                        };
                        const getConstraints = function getConstraints(source, constraints, callback) {
                            if (!callback) throw new Error('getSourceId: callback is required');
                            isInstalled((installed)=>{
                                if (!installed) return callback(otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error('Extension is not installed')));
                                context.chrome.runtime.sendMessage(extensionID, {
                                    type: 'getSourceId',
                                    source: source
                                }, null, (data)=>{
                                    if (data.error === 'permissionDenied') callback(otError(Errors.USER_MEDIA_ACCESS_DENIED, new Error('User denied access to screensharing')));
                                    else if (data.error) callback(new Error(`UnexpectError: ${data.error}`));
                                    else {
                                        if (!constraints.video) constraints.video = {};
                                        if (!constraints.video.mandatory) constraints.video.mandatory = {};
                                        constraints.video.mandatory.chromeMediaSource = 'desktop';
                                        constraints.video.mandatory.chromeMediaSourceId = data.sourceId;
                                        callback(void 0, constraints);
                                    }
                                });
                                return undefined;
                            });
                        };
                        return {
                            extensionAPIVersion: 2,
                            extensionID: extensionID,
                            isInstalled: isInstalled,
                            getConstraints: getConstraints
                        };
                    }
                };
            };
        /***/ },
        /* 282 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable global-require */ const createCleanupJobs = __webpack_require__(154);
                const RafRunner = __webpack_require__(103);
                module1.exports = function createChromeMixinFactory(deps) {
                    if (deps === void 0) deps = {};
                    const Archiving = deps.Archiving || __webpack_require__(636);
                    const AudioLevelMeter = deps.AudioLevelMeter || __webpack_require__(283);
                    const AudioLevelTransformer = deps.AudioLevelTransformer || __webpack_require__(143);
                    const BackingBar = deps.BackingBar || __webpack_require__(284);
                    const Chrome = deps.Chrome || __webpack_require__(144);
                    const MuteButton = deps.MuteButton || __webpack_require__(285)();
                    const NamePanel = deps.NamePanel || __webpack_require__(286);
                    const StylableComponent = deps.StylableComponent || __webpack_require__(151);
                    const logging = deps.logging || __webpack_require__(2)('createChromeMixin');
                    return function createChromeMixin(publisher, _temp) {
                        let _ref = _temp === void 0 ? {} : _temp, name = _ref.name, publishAudio = _ref.publishAudio, publishVideo = _ref.publishVideo, audioSource = _ref.audioSource, showControls = _ref.showControls, shouldAllowAudio = _ref.shouldAllowAudio, logAnalyticsEvent = _ref.logAnalyticsEvent;
                        let audioLevelMeter;
                        let chrome;
                        let widgetView;
                        const chromeMixin = {};
                        const cleanupJobs = createCleanupJobs(); // If mode is false, then that is the mode. If mode is true then we'll
                        // definitely display  the button, but we'll defer the model to the
                        // Publishers buttonDisplayMode style property.
                        const chromeButtonMode = (mode)=>{
                            if (mode === false) return 'off';
                            const defaultMode = publisher.getStyle('buttonDisplayMode'); // The default model is false, but it's overridden by +mode+ being true
                            if (defaultMode === false) return 'on';
                             // defaultMode is either true or auto.
                            return defaultMode;
                        };
                        let uiPromise = new Promise((resolve, reject)=>{
                            chromeMixin.init = (widgetViewParam)=>{
                                if (!publisher.getStyle('showArchiveStatus')) logAnalyticsEvent('showArchiveStatus', 'createChrome', {
                                    mode: 'off'
                                });
                                const widgets = {
                                    backingBar: new BackingBar({
                                        nameMode: !name ? 'off' : publisher.getStyle('nameDisplayMode'),
                                        muteMode: chromeButtonMode(publisher.getStyle('buttonDisplayMode'))
                                    }),
                                    name: new NamePanel({
                                        name: name,
                                        mode: publisher.getStyle('nameDisplayMode')
                                    }),
                                    archive: new Archiving({
                                        show: Boolean(publisher.getStyle('showArchiveStatus')) && publisher.getStyle('archiveStatusDisplayMode') !== 'off',
                                        archiving: false
                                    }),
                                    muteButton: new MuteButton({
                                        muted: publishAudio === false,
                                        mode: chromeButtonMode.call(null, publisher.getStyle('buttonDisplayMode'))
                                    })
                                };
                                audioLevelMeter = new AudioLevelMeter({
                                    mode: publisher.getStyle('audioLevelDisplayMode')
                                });
                                const audioLevelTransformer = new AudioLevelTransformer();
                                const audioWatcher = new RafRunner(()=>{
                                    // @FIXME
                                    // We force the audio level value to be zero here if audio is disabled
                                    // because the AudioLevelMeter cannot currently differentiate
                                    // between video being disabled and audio being disabled.
                                    // To be fixed as part of OPENTOK-29865
                                    const audioLevel = !publishAudio ? 0 : audioLevelTransformer.transform(publisher.loudness);
                                    audioLevelMeter.setValue(audioLevel);
                                });
                                audioLevelMeter.watchVisibilityChanged((visible)=>{
                                    if (visible) audioWatcher.start();
                                    else audioWatcher.stop();
                                });
                                audioLevelMeter.audioOnly(!publishVideo && publishAudio);
                                widgets.audioLevel = audioLevelMeter;
                                if (widgetViewParam && widgetViewParam.domElement) {
                                    widgetView = widgetViewParam;
                                    chrome = new Chrome({
                                        parent: widgetView.domElement
                                    }).set(widgets).on({
                                        muted: ()=>publisher.publishAudio(false),
                                        unmuted: ()=>publisher.publishAudio(true)
                                    });
                                    if (audioSource === null || audioSource === false) chromeMixin.removeAudioTrack();
                                    resolve();
                                }
                            };
                            chromeMixin.reset = ()=>{
                                // reject in case the chrome creating was still pending
                                reject(new Error('Chrome still being created'));
                                if (chrome) {
                                    chrome.destroy();
                                    chrome = null;
                                }
                            };
                            chromeMixin.destroy = ()=>{
                                chromeMixin.reset();
                                cleanupJobs.releaseAll();
                                uiPromise = null;
                            };
                        });
                        uiPromise.catch((err)=>{
                            // Only log unexpected rejections
                            if (!err || err.message !== 'Chrome still being created') logging.error('createChromeMixin failed to setup UI', err);
                        });
                        chromeMixin.setAudioOnly = (value)=>{
                            if (audioLevelMeter) audioLevelMeter.audioOnly(value);
                        };
                        chromeMixin.setArchivingStatus = (status)=>{
                            if (chrome) chrome.archive.setArchiving(status);
                        };
                        chromeMixin.setMuted = (muted)=>{
                            if (chrome && chrome.muteButton) chrome.muteButton.muted(muted);
                        };
                        chromeMixin.removeAudioTrack = ()=>{
                            if (chrome && chrome.muteButton) chrome.muteButton.remove();
                        };
                        chromeMixin.addAudioTrack = ()=>{
                            if (chrome && chrome.muteButton) chrome.muteButton.add();
                        };
                        StylableComponent(publisher, {
                            showArchiveStatus: true,
                            nameDisplayMode: 'auto',
                            buttonDisplayMode: 'auto',
                            audioLevelDisplayMode: shouldAllowAudio ? 'auto' : 'off',
                            archiveStatusDisplayMode: 'auto',
                            backgroundImageURI: null
                        }, showControls, (payload)=>{
                            logAnalyticsEvent('SetStyle', 'Publisher', payload, null, 0.1);
                        });
                        const onStyleValueChanged = (key, value)=>{
                            // enlist style change for when the the chrome is created
                            uiPromise.then(()=>{
                                switch(key){
                                    case 'nameDisplayMode':
                                        chrome.name.setDisplayMode(value);
                                        chrome.backingBar.setNameMode(value);
                                        break;
                                    case 'showArchiveStatus':
                                        logAnalyticsEvent('showArchiveStatus', 'styleChange', {
                                            mode: value ? 'on' : 'off'
                                        });
                                        chrome.archive.setShowArchiveStatus(Boolean(value));
                                        break;
                                    case 'archiveStatusDisplayMode':
                                        chrome.archive.setShowArchiveStatus(value !== 'off');
                                        break;
                                    case 'buttonDisplayMode':
                                        chrome.muteButton.setDisplayMode(value);
                                        chrome.backingBar.setMuteMode(value);
                                        break;
                                    case 'audioLevelDisplayMode':
                                        chrome.audioLevel.setDisplayMode(value);
                                        break;
                                    case 'backgroundImageURI':
                                        widgetView.setBackgroundImageURI(value);
                                        break;
                                    default:
                                }
                            });
                        };
                        publisher.on('styleValueChanged', onStyleValueChanged);
                        cleanupJobs.add(()=>publisher.off('styleValueChanged', onStyleValueChanged));
                        return chromeMixin;
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 283 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-underscore-dangle, one-var, no-mixed-operators */ const defineProperties = __webpack_require__(104);
                const Widget = __webpack_require__(37);
                const OTHelpers = __webpack_require__(8);
                const EventEmitter = __webpack_require__(31);
                module1.exports = function AudioLevelMeter(options) {
                    const _audioLevelMeter = this;
                    const _eventEmitter = new EventEmitter();
                    let _voiceOnlyIconElement;
                    let _meterValueElement;
                    let _value;
                    let _lastComputedVisibility; // display the widget by default but can be hidden when calling hideWhileLoading
                    let _displayAroundLoading = true;
                    let _audioOnly = false;
                    let _displayMode = 'auto';
                    const _maxValue = options.maxValue || 1;
                    const _minValue = options.minValue || 0;
                    function onCreate() {
                        _meterValueElement = OTHelpers.createElement('div', {
                            className: 'OT_audio-level-meter__value'
                        }, '');
                        _voiceOnlyIconElement = OTHelpers.createElement('div', {
                            className: 'OT_audio-level-meter__audio-only-img'
                        }, '');
                        const domElement = _audioLevelMeter.domElement;
                        domElement.appendChild(_voiceOnlyIconElement);
                        domElement.appendChild(_meterValueElement);
                        _audioLevelMeter.watchVisibilityChanged((visible)=>{
                            if (visible) OTHelpers.removeClass(_audioLevelMeter.domElement, 'OT_hide-forced');
                            else OTHelpers.addClass(_audioLevelMeter.domElement, 'OT_hide-forced');
                        });
                    }
                    function onDestroy() {
                        _eventEmitter.removeAllListeners('visibilityChanged');
                    }
                    function updateView() {
                        const percentSize = (_value - _minValue) / (_maxValue - _minValue);
                        _meterValueElement.style.transform = `scale(${Math.sqrt(percentSize)})`;
                    } // computes the visibility value from the different "inputs" variables and asynchronously triggers
                    // the internal "visibilityChanged" events if the value changed from last time it was computed
                    function computeVisibility() {
                        const computedVisibility = (_audioOnly && _displayMode === 'auto' || _displayMode === 'on') && _displayAroundLoading;
                        if (_lastComputedVisibility !== computedVisibility) {
                            _lastComputedVisibility = computedVisibility;
                            _eventEmitter.emit('visibilityChanged', computedVisibility);
                        }
                    }
                    defineProperties(_audioLevelMeter, {
                        audioOnly: {
                            get () {
                                return _audioOnly;
                            },
                            set (audioOnly) {
                                _audioOnly = audioOnly;
                                computeVisibility();
                            }
                        }
                    });
                    _audioLevelMeter.setValue = function(value) {
                        _value = value;
                        updateView();
                    };
                    /**
   * Registers an callback to be executed when the visibility of the audio level meter changes.
   * "true" means the widget is shown.
   * The contracts is that the handlers should not try to change the visibility of the widget by
   * changing the value of visibility "inputs" (setting "audioOnly", "displayMode" or calling
   * "hideWhileLoading" and "showAfterLoading")
   *
   * @param {function(boolean)} cb the callback to be executed when the display value changes.
   * The callback is also executed with the last computed value when registered.
   * @returns {function} a callback to unregister the handler
   */ _audioLevelMeter.watchVisibilityChanged = function(cb) {
                        _eventEmitter.on('visibilityChanged', cb);
                        Promise.resolve().then(()=>{
                            cb(_lastComputedVisibility);
                        });
                        return function stopWatching() {
                            _eventEmitter.removeListener('visibilityChanged', cb);
                        };
                    }; // Mixin common widget behaviour
                    const widgetOptions = {
                        mode: options ? options.mode : 'auto',
                        nodeName: 'div',
                        htmlAttributes: {
                            className: 'OT_audio-level-meter'
                        },
                        onCreate: onCreate,
                        onDestroy: onDestroy
                    };
                    Widget(this, widgetOptions); // The methods underneath are mixed in by "Widget" but overridden
                    // Doing so, we can bypass it and compute the display value ourselves without relying on CSS
                    _audioLevelMeter.setDisplayMode = function(mode) {
                        _displayMode = mode;
                        computeVisibility();
                    };
                    _audioLevelMeter.getDisplayMode = function() {
                        return _displayMode;
                    };
                    _audioLevelMeter.showAfterLoading = function() {
                        _displayAroundLoading = true;
                        computeVisibility();
                    };
                    _audioLevelMeter.hideWhileLoading = function() {
                        _displayAroundLoading = false;
                        computeVisibility();
                    }; // compute the initial visibility value
                    computeVisibility();
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 284 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle */ const Widget = __webpack_require__(37); // BackingBar Chrome Widget
            //
            // nameMode (String)
            // Whether or not the name panel is being displayed
            // Possible values are: "auto" (the name is displayed
            // when the stream is first displayed and when the user mouses over the display),
            // "off" (the name is not displayed), and "on" (the name is displayed).
            //
            // muteMode (String)
            // Whether or not the mute button is being displayed
            // Possible values are: "auto" (the mute button is displayed
            // when the stream is first displayed and when the user mouses over the display),
            // "off" (the mute button is not displayed), and "on" (the mute button is displayed).
            //
            // displays a backing bar
            // can be shown/hidden
            // can be destroyed
            module1.exports = function BackingBar(options) {
                let _nameMode = options.nameMode;
                let _muteMode = options.muteMode;
                function getDisplayMode() {
                    if (_nameMode === 'on' || _muteMode === 'on') return 'on';
                    else if (_nameMode === 'mini' || _muteMode === 'mini') return 'mini';
                    else if (_nameMode === 'mini-auto' || _muteMode === 'mini-auto') return 'mini-auto';
                    else if (_nameMode === 'auto' || _muteMode === 'auto') return 'auto';
                    return 'off';
                } // Mixin common widget behaviour
                Widget(this, {
                    mode: getDisplayMode(),
                    nodeName: 'div',
                    htmlContent: '',
                    htmlAttributes: {
                        className: 'OT_bar OT_edge-bar-item'
                    }
                });
                this.setNameMode = function(nameMode) {
                    _nameMode = nameMode;
                    this.setDisplayMode(getDisplayMode());
                };
                this.setMuteMode = function(muteMode) {
                    _muteMode = muteMode;
                    this.setDisplayMode(getDisplayMode());
                };
            };
        /***/ },
        /* 285 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const globalOTHelpers = __webpack_require__(8);
            const globalWidget = __webpack_require__(37);
            const defineProperties = __webpack_require__(104);
            module1.exports = function MuteButtonFactory(deps) {
                if (deps === void 0) deps = {};
                const OTHelpers = deps.OTHelpers || globalOTHelpers;
                const Widget = deps.Widget || globalWidget;
                return function MuteButton(options) {
                    let muted = options.muted || false;
                    const updateClasses = ()=>{
                        if (muted) OTHelpers.addClass(this.domElement, 'OT_active');
                        else OTHelpers.removeClass(this.domElement, 'OT_active ');
                    };
                    const onClick = ()=>{
                        muted = !muted;
                        updateClasses();
                        if (muted) this.parent.trigger('muted', this);
                        else this.parent.trigger('unmuted', this);
                        return false;
                    }; // Private Event Callbacks
                    const attachEvents = (elem)=>{
                        OTHelpers.on(elem, 'click', onClick);
                    };
                    const detachEvents = (elem)=>{
                        OTHelpers.off(elem, 'click', onClick);
                    };
                    defineProperties(this, {
                        muted: {
                            get () {
                                return muted;
                            },
                            set (m) {
                                muted = m;
                                updateClasses();
                            }
                        }
                    }); // Mixin common widget behaviour
                    const classNames = muted ? 'OT_edge-bar-item OT_mute OT_active' : 'OT_edge-bar-item OT_mute';
                    Widget(this, {
                        mode: options.mode,
                        nodeName: 'button',
                        htmlContent: 'Mute',
                        htmlAttributes: {
                            className: classNames,
                            type: 'button'
                        },
                        onCreate: attachEvents,
                        onDestroy: detachEvents
                    });
                    let parentNode;
                    this.remove = ()=>{
                        if (this.domElement && this.domElement.parentNode) {
                            parentNode = this.domElement.parentNode; // store in case we want to add it again
                            this.domElement.parentNode.removeChild(this.domElement);
                        }
                    };
                    this.add = ()=>{
                        if (parentNode && this.domElement && !this.domElement.parentNode) parentNode.appendChild(this.domElement);
                    };
                };
            };
        /***/ },
        /* 286 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign */ const Widget = __webpack_require__(37); // The "name" that we receive (e.g., from RUMOR) may actually be malicious HTML
            // so we need to sanitize it before it gets rendered.
            // See: OPENTOK-41141.
            const sanitizeName = (name)=>{
                const temp = document.createElement('div');
                temp.textContent = name;
                return temp.innerHTML;
            }; // NamePanel Chrome Widget
            //
            // mode (String)
            // Whether to display the name. Possible values are: "auto" (the name is displayed
            // when the stream is first displayed and when the user mouses over the display),
            // "off" (the name is not displayed), and "on" (the name is displayed).
            //
            // displays a name
            // can be shown/hidden
            // can be destroyed
            module1.exports = function NamePanel(options) {
                let _name = options.name;
                if (!_name || _name.trim().length === '') {
                    _name = null; // THere's no name, just flip the mode off
                    options.mode = 'off';
                }
                this.setName = (function(name) {
                    if (!_name) this.setDisplayMode('auto');
                    _name = sanitizeName(name); // The "name" is initially rendered as `innerHTML` when instantiated (as a
                    // `Widget`).  That's why we don't use `textContent` here, instead.
                    this.domElement.innerHTML = _name;
                }).bind(this);
                _name = sanitizeName(_name); // Mixin common widget behaviour
                Widget(this, {
                    mode: options.mode,
                    nodeName: 'h1',
                    htmlContent: _name,
                    htmlAttributes: {
                        className: 'OT_name OT_edge-bar-item'
                    }
                });
            };
        /***/ },
        /* 287 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ module1.exports = function getNativeEnumerateDevicesFactory(deps) {
                if (deps === void 0) deps = {};
                const windowMock = deps.global || window;
                return function getNativeEnumerateDevices() {
                    if (windowMock.navigator.mediaDevices) {
                        const mediaDevices = windowMock.navigator.mediaDevices;
                        return mediaDevices.enumerateDevices && mediaDevices.enumerateDevices.bind(mediaDevices);
                    } // @todo perhaps we should throw here?
                    return undefined;
                };
            };
        /***/ },
        /* 288 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const haveDisplayMedia = __webpack_require__(159).default;
            const isSupportedInThisBrowser = ()=>// to work with our SDK
                !env.isLegacyEdge && // Even though getDisplayMedia is exposed in Electron, devs need to use
                // desktopCapturer instead
                !env.isElectron && haveDisplayMedia && // getDisplayMedia is not supported in Android
                !env.isAndroid;
            module1.exports = {
                isSupportedInThisBrowser: isSupportedInThisBrowser(),
                autoRegisters: true,
                extensionRequired: false,
                getConstraintsShowsPermissionUI: false,
                sources: {
                    screen: true,
                    application: false,
                    window: env.name !== 'Safari',
                    browser: env.name !== 'Safari'
                },
                register () {
                    return {
                        isInstalled (callback) {
                            callback(undefined);
                        },
                        getConstraints (source, constraints, callback) {
                            callback(undefined, {
                                video: constraints.video,
                                audio: constraints.audio
                            });
                        }
                    };
                }
            };
        /***/ },
        /* 289 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const isMediaStreamTrack = (source)=>source && typeof source === 'object' && typeof source.kind === 'string' && typeof source.stop === 'function' && typeof source.enabled === 'boolean';
            exports.isMediaStreamTrack = isMediaStreamTrack;
        /***/ },
        /* 290 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var __awaiter = function(thisArg, _arguments, P, generator) {
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : new P(function(resolve) {
                                resolve(result.value);
                            }).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                0,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                function getGlobal() {
                    return typeof window !== 'undefined' ? window : window;
                }
                var CALLBACK_INVALID_RETURN = 'onFailure must return boolean, or delay in ms';
                /**
 * Retry a promise
 *
 * Uses promiseFactory to construct promises and calls onFailure when the
 * promise rejects.
 *
 * onFailure is called with error and attempt.
 *
 * You may inspect error to decide whether to retry or not. You may use attempt
 * to control the delay/ decide how many times to retry.
 *
 * To retry: A numeric delay in milliseconds can be returned to control how long
 * between retries.
 *
 * To stop retrying: Return false/ undefined/ null.
 *
 * The returned promise will be the final promise from promiseFactory once
 * fulfilled or in the case of errors, once no longer retrying.
 *
 * @example
 *
 * const promiseEndeavour = require('../dist/promiseEndeavour.js');
 * const fetch = require('node-fetch');
 *
 * async function getDogs() {
 *   const response = await fetch('https://dog.ceo/api/breeds/list/all');
 *   return response.json();
 * }
 *
 * const retries = [100, 500, 1000];
 *
 * function retry(error, attempt) {
 *   return retries[attempt - 1] || false;
 * }
 *
 * promiseEndeavour(getDogs, retry)()
 *   .then(dogs => console.log(dogs));
 *
 * @param promiseFactory A promise returning function
 * @param onFailure A function to be called when the promise returned by promiseFactory is rejected
 * @param maxAttempts Maximum number of attempts regardless of onFailure
 * @return A function with the same interface to promiseFactory
 */ function promiseEndeavour(promiseFactory, onFailure, maxAttempts) {
                    if (maxAttempts === void 0) maxAttempts = 10;
                    return function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        return __awaiter(this, void 0, void 0, function() {
                            var attempt, _loop_1, state_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        attempt = 0;
                                        _loop_1 = function() {
                                            var _a, error_1, delay_1;
                                            return __generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        _b.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            6
                                                        ]);
                                                        _a = {};
                                                        return [
                                                            4 /*yield*/ ,
                                                            promiseFactory.apply(void 0, args)
                                                        ];
                                                    case 1:
                                                        return [
                                                            2 /*return*/ ,
                                                            (_a.value = _b.sent(), _a)
                                                        ];
                                                    case 2:
                                                        error_1 = _b.sent();
                                                        delay_1 = onFailure(error_1, attempt);
                                                        if (delay_1 === false || delay_1 == null || attempt >= maxAttempts) throw error_1;
                                                        if (!(typeof delay_1 === 'number')) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            new Promise(function(resolve) {
                                                                return getGlobal().setTimeout(resolve, delay_1);
                                                            })
                                                        ];
                                                    case 3:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                    case 4:
                                                        if (delay_1 !== true) throw new Error(CALLBACK_INVALID_RETURN);
                                                        _b.label = 5;
                                                    case 5:
                                                        return [
                                                            3 /*break*/ ,
                                                            6
                                                        ];
                                                    case 6:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        };
                                        _a.label = 1;
                                    case 1:
                                        if (!(attempt += 1)) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            5 /*yield**/ ,
                                            _loop_1()
                                        ];
                                    case 2:
                                        state_1 = _a.sent();
                                        if (typeof state_1 === "object") return [
                                            2 /*return*/ ,
                                            state_1.value
                                        ];
                                        return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                }
                /* harmony default export */ __webpack_exports__["default"] = promiseEndeavour;
            //# sourceMappingURL=promiseEndeavour.js.map
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 291 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const logging = __webpack_require__(2)('videoContentHint');
            const videoContentHints = [
                '',
                'text',
                'motion',
                'detail'
            ];
            const isValidVideoContentHint = (hint)=>videoContentHints.includes(hint);
            const getVideoTrackForStream = (mediaStream)=>{
                var _mediaStream$getVideo;
                return mediaStream == null ? void 0 : (_mediaStream$getVideo = mediaStream.getVideoTracks()) == null ? void 0 : _mediaStream$getVideo[0];
            };
            /**
 * Sets contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @param {String} contentHint, one of "", "motion", "detail" or "text"
 */ const setVideoContentHint = (mediaStream, contentHint)=>{
                if (!isValidVideoContentHint(contentHint)) {
                    logging.warn('Invalid content hint. Valid content hints are "text", "detail", "motion", or ""');
                    return;
                }
                const videoTrack = getVideoTrackForStream(mediaStream);
                if (!videoTrack) {
                    logging.warn('Tried to set contentHint but no video track is present');
                    return;
                }
                if (videoTrack.contentHint === undefined) {
                    logging.warn('contentHint not supported by this browser');
                    return;
                }
                videoTrack.contentHint = contentHint;
            };
            /**
 * Returns contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @returns {String} contentHint, one of "", "motion", "detail" or "text"

 */ const getVideoContentHint = (mediaStream)=>{
                const videoTrack = getVideoTrackForStream(mediaStream);
                return (videoTrack == null ? void 0 : videoTrack.contentHint) || '';
            };
            module1.exports = {
                isValidVideoContentHint: isValidVideoContentHint,
                setVideoContentHint: setVideoContentHint,
                getVideoContentHint: getVideoContentHint
            };
        /***/ },
        /* 292 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require, no-underscore-dangle, no-shadow */ const defineProperties = __webpack_require__(104);
            module1.exports = function MicrophoneFactory() {
                /*
   * A Publishers Microphone.
   *
   * TODO
   * * bind to changes in mute/unmute/volume/etc and respond to them
   */ return function Microphone(webRTCStream, muted) {
                    let _muted;
                    defineProperties(this, {
                        muted: {
                            get () {
                                return _muted;
                            },
                            set (muted) {
                                if (_muted === muted) return;
                                _muted = muted;
                                const audioTracks = webRTCStream.getAudioTracks();
                                for(let i = 0, num = audioTracks.length; i < num; ++i)audioTracks[i].enabled = !_muted;
                            }
                        }
                    }); // Set the initial value
                    if (muted !== undefined) this.muted(muted === true);
                    else if (webRTCStream.getAudioTracks().length) this.muted(!webRTCStream.getAudioTracks()[0].enabled);
                    else this.muted(false);
                };
            };
        /***/ },
        /* 293 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ module1.exports = function videoElementErrorMapFactory(deps) {
                if (deps === void 0) deps = {};
                const Errors = deps.Errors || __webpack_require__(6);
                const otError = deps.otError || __webpack_require__(13)(); // See http://www.w3.org/TR/2010/WD-html5-20101019/video.html#error-codes
                const videoErrorDetails = {}; // Checking for global.MediaError for IE compatibility, just so we don't throw
                // exceptions when the script is included
                if (window.MediaError) {
                    videoErrorDetails[window.MediaError.MEDIA_ERR_ABORTED] = {
                        name: Errors.MEDIA_ERR_ABORTED,
                        message: "The fetching process for the media resource was aborted by the user agent at the user's request."
                    };
                    videoErrorDetails[window.MediaError.MEDIA_ERR_NETWORK] = {
                        name: Errors.MEDIA_ERR_NETWORK,
                        message: "A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable."
                    };
                    videoErrorDetails[window.MediaError.MEDIA_ERR_DECODE] = {
                        name: Errors.MEDIA_ERR_DECODE,
                        message: "An error of some description occurred while decoding the media resource, after the resource was established to be usable."
                    };
                    videoErrorDetails[window.MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED] = {
                        name: Errors.MEDIA_ERR_SRC_NOT_SUPPORTED,
                        message: "The media resource indicated by the src attribute was not suitable."
                    };
                }
                return function videoElementErrorMap(error) {
                    const errorDetails = videoErrorDetails[error.code];
                    if (!errorDetails) return new Error(`An unknown error occurred${error.message ? `: ${error.message}` : '.'}`);
                    return otError(errorDetails.name, new Error(`There was an unexpected problem with the Video Stream: ${errorDetails.message}`));
                };
            };
        /***/ },
        /* 294 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, global-require, one-var, no-underscore-dangle */ /* eslint-disable no-cond-assign,  max-len, no-void, prefer-const */ const eventing = __webpack_require__(7);
                const eventHelper = __webpack_require__(63);
                const destroyObj = __webpack_require__(647);
                const patchSrcObject = __webpack_require__(648);
                const isDomElementVisible = __webpack_require__(649);
                const promiseDelay = __webpack_require__(106);
                const env = __webpack_require__(3);
                const _require = __webpack_require__(24)(), hasAudioOutputApiSupport = _require.hasAudioOutputApiSupport;
                const noop = __webpack_require__(295);
                const _require2 = __webpack_require__(105), getCurrentAudioOutputDeviceId = _require2.getCurrentAudioOutputDeviceId;
                function createDomVideoElement(fallbackText, muted) {
                    const videoElement = document.createElement('video');
                    patchSrcObject(videoElement);
                    videoElement.autoplay = true;
                    videoElement.playsinline = true;
                    videoElement.innerHTML = fallbackText; // Safari on iOS requires setAttribute OPENTOK-37229
                    videoElement.setAttribute('autoplay', '');
                    videoElement.setAttribute('playsinline', '');
                    if (muted === true) videoElement.muted = 'true';
                    return videoElement;
                }
                function createDomAudioOnlyVideoElement() {
                    const audioOnlyVideoElement = createDomVideoElement('');
                    audioOnlyVideoElement.setAttribute('style', 'display:none');
                    return audioOnlyVideoElement;
                }
                /**
 * NativeVideoElementWrapperFactory DI container
 *
 * @package
 * @param {any} [deps={}]
 */ function NativeVideoElementWrapperFactory(deps) {
                    if (deps === void 0) deps = {};
                    const audioContextProvider = deps.audioContext || __webpack_require__(158)();
                    const canBeOrientatedMixin = deps.canBeOrientatedMixin || __webpack_require__(650);
                    /** @type {Document} */ const document1 = deps.document || window.document;
                    const listenForTracksEnded = deps.listenForTracksEnded || __webpack_require__(651)();
                    const createLog = deps.logging || __webpack_require__(2);
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const videoElementErrorMap = deps.videoElementErrorMap || __webpack_require__(293)();
                    const WebAudioLevelSampler = deps.WebaudioAudioLevelSampler || __webpack_require__(145);
                    const windowMock = deps.global || window;
                    let id = 1;
                    /**
   * NativeVideoElementWrapper
   *
   * @package
   * @class
   * @param {Object} options
   * @param {Object} [options._inject] injected variables @todo move to DI
   * @param {Function} [options._inject.createVideoElement] function used to create video element
   * @param {Function} [options._inject.createAudioOnlyVideoElement] function used to create audio only video element
   * @param {Boolean} [options.muted] initial mute state
   * @param {String} [options.fallbackText] text to display when not supported
   * @param {Function} errorHandler callback for when there are errors
   * @param {Number} defaultAudioVolume the initial audio volume
   */ let NativeVideoElementWrapper = /*#__PURE__*/ function() {
                        /** @type {HTMLVideoElement|undefined} */ /** @type {number|undefined} */ function NativeVideoElementWrapper(_ref, defaultAudioVolume) {
                            var _this = this;
                            let _ref$_inject = _ref._inject, _ref$_inject2 = _ref$_inject === void 0 ? {} : _ref$_inject, _ref$_inject2$createV = _ref$_inject2.createVideoElement, _createVideoElement = _ref$_inject2$createV === void 0 ? createDomVideoElement : _ref$_inject2$createV, _ref$_inject2$createA = _ref$_inject2.createAudioOnlyVideoElement, _createAudioOnlyVideoElement = _ref$_inject2$createA === void 0 ? createDomAudioOnlyVideoElement : _ref$_inject2$createA, muted = _ref.muted, fallbackText = _ref.fallbackText, widgetType = _ref.widgetType;
                            (0, _defineProperty2.default)(this, "_domElement", void 0);
                            (0, _defineProperty2.default)(this, "_domAudioOnlyVideoElement", void 0);
                            (0, _defineProperty2.default)(this, "_blockedVolume", void 0);
                            (0, _defineProperty2.default)(this, "_mediaStoppedListener", void 0);
                            (0, _defineProperty2.default)(this, "_audioLevelSampler", void 0);
                            (0, _defineProperty2.default)(this, "_playInterrupts", 0);
                            (0, _defineProperty2.default)(this, "_isVideoLoadedMetaData", false);
                            (0, _defineProperty2.default)(this, "_audioOnlyVideoElementWatcher", void 0);
                            (0, _defineProperty2.default)(this, "_blinkStartTime", null);
                            this.logging = createLog(`NativeVideoElementWrapper:${id}`);
                            id += 1;
                            eventing(this);
                            this._defaultAudioVolume = defaultAudioVolume;
                            this._widgetType = widgetType;
                            this._emitVideoPlayAttempt = ()=>{
                                this._blinkStartTime = new Date().getTime();
                                this.trigger('amrLogEvent', 'AMRTransitionVideo', 'Attempt');
                            };
                            this._emitVideoPlaySuccess = ()=>{
                                const attemptDuration = new Date().getTime() - this._blinkStartTime;
                                this.trigger('amrLogEvent', 'AMRTransitionVideo', 'Success', {
                                    attemptDuration: attemptDuration
                                });
                                this._blinkStartTime = null;
                            };
                            this._emitVideoPlayFailure = ()=>{
                                this.trigger('amrLogEvent', 'AMRTransitionVideo', 'Failure');
                            };
                            let _videoElementMovedWarning = false; // / Private API
                            // The video element pauses itself when it's reparented, this is
                            // unfortunate. This function plays the video again and is triggered
                            // on the pause event.
                            const _playVideoOnPause = ()=>{
                                if (!_videoElementMovedWarning) {
                                    this.logging.warn("Video element paused, auto-resuming. If you intended to do this, use publishVideo(false) or subscribeToVideo(false) instead.");
                                    _videoElementMovedWarning = true;
                                }
                                this.play();
                            };
                            this._domElement = _createVideoElement(fallbackText, muted);
                            this.trigger('videoElementCreated', this._domElement);
                            this._domElementEvents = eventHelper(this._domElement);
                            this._domElementEvents.on('loadstart', ()=>this._onDomElementLoadStart());
                            this._domElementEvents.on('timeupdate', function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                return _this.trigger('timeupdate', ...args);
                            });
                            this._domElementEvents.on('loadedmetadata', /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                                var _len2, args, _key2, hasSrcObject, _args = arguments;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            _this._isVideoLoadedMetaData = true;
                                            for(_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = _args[_key2];
                                            _this.trigger('loadedmetadata', ...args); // We can safely remove the audio only element since the video element
                                            // could trigger the loadedmetada, meaning it can start playing video.
                                            // For more info, see OPENTOK-41739.
                                            if (!_this._domAudioOnlyVideoElement) {
                                                _context.next = 10;
                                                break;
                                            }
                                            hasSrcObject = _this._domAudioOnlyVideoElement.srcObject;
                                            _this._removeAudioOnlyVideoElement(); // We need to call play only if _domAudioOnlyVideoElement had
                                            // a srcObject, meaning it was used for audio.
                                            if (!hasSrcObject) {
                                                _context.next = 10;
                                                break;
                                            }
                                            _context.next = 9;
                                            return noop();
                                        case 9:
                                            _this.play();
                                        case 10:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            })));
                            const onError = (event)=>{
                                this.trigger('error', videoElementErrorMap(event.target.error));
                            };
                            this._domElementEvents.on('error', onError, false);
                            this._domElementEvents.on('pause', _playVideoOnPause);
                            this.on('destroyed', ()=>{
                                this._domElementEvents.removeAll();
                                if (this._domAudioOnlyVideoElementEvents) this._domAudioOnlyVideoElementEvents.removeAll();
                            });
                            canBeOrientatedMixin(this, ()=>this._domElement); // Safari subscribers needs special handling for audio-only video
                            // https://bugs.webkit.org/show_bug.cgi?id=174152
                            if (env.isSafari && this._widgetType === 'subscriber') {
                                this._domAudioOnlyVideoElement = _createAudioOnlyVideoElement();
                                this._bindAudioOnlyVideoElementEvents();
                            }
                        }
                        var _proto = NativeVideoElementWrapper.prototype;
                        _proto._onDomElementLoadStart = /*#__PURE__*/ function() {
                            var _onDomElementLoadStart2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                                return _regenerator.default.wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            if (!(this._widgetType === 'subscriber' && hasAudioOutputApiSupport())) {
                                                _context2.next = 3;
                                                break;
                                            }
                                            _context2.next = 3;
                                            return this._setActiveAudioOutputDevice();
                                        case 3:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, this);
                            }));
                            function _onDomElementLoadStart() {
                                return _onDomElementLoadStart2.apply(this, arguments);
                            }
                            return _onDomElementLoadStart;
                        }();
                        _proto._setActiveAudioOutputDevice = /*#__PURE__*/ function() {
                            var _setActiveAudioOutputDevice2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3() {
                                var deviceId;
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            deviceId = getCurrentAudioOutputDeviceId();
                                            if (!(deviceId === '' || deviceId === 'default')) {
                                                _context3.next = 3;
                                                break;
                                            }
                                            return _context3.abrupt("return");
                                        case 3:
                                            _context3.next = 5;
                                            return this.setSinkId(deviceId);
                                        case 5:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, this);
                            }));
                            function _setActiveAudioOutputDevice() {
                                return _setActiveAudioOutputDevice2.apply(this, arguments);
                            }
                            return _setActiveAudioOutputDevice;
                        }();
                        _proto._rebindSrcObject = function _rebindSrcObject() {
                            if (this._domElement) this._domElement.srcObject = this._domElement.srcObject;
                        };
                        _proto._pauseAndPlay = function _pauseAndPlay() {
                            if (this._domElement) {
                                this._domElement.pause();
                                this._domElement.play();
                            }
                        };
                        _proto._startAudioOnlyVideoElementWatcher = /*#__PURE__*/ function() {
                            var _startAudioOnlyVideoElementWatcher2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4() {
                                var watcherIntervalTimeout, shouldPlay;
                                return _regenerator.default.wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            // In Safari, after setting the srcObject the video element gets paused.
                                            // Calling play() is not sufficient to unpause it.
                                            // A workaround for this is to rebind when we detect that the video gets paused.
                                            // Notice that if it's iOS we need to call play() after the rebind, otherwise
                                            // it won't play.
                                            watcherIntervalTimeout = 1000;
                                            shouldPlay = env.isiOS;
                                            this._audioOnlyVideoElementWatcher = setInterval(()=>{
                                                if (this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.paused) {
                                                    this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject;
                                                    if (shouldPlay) this._domAudioOnlyVideoElement.play();
                                                }
                                            }, 100);
                                            _context4.next = 5;
                                            return promiseDelay(watcherIntervalTimeout);
                                        case 5:
                                            clearInterval(this._audioOnlyVideoElementWatcher);
                                            this._audioOnlyVideoElementWatcher = null;
                                        case 7:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4, this);
                            }));
                            function _startAudioOnlyVideoElementWatcher() {
                                return _startAudioOnlyVideoElementWatcher2.apply(this, arguments);
                            }
                            return _startAudioOnlyVideoElementWatcher;
                        }();
                        _proto._removeAudioOnlyVideoElement = /*#__PURE__*/ function() {
                            var _removeAudioOnlyVideoElement2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5() {
                                return _regenerator.default.wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            this._domAudioOnlyVideoElement.srcObject = null;
                                            this._domAudioOnlyVideoElement.parentNode.removeChild(this._domAudioOnlyVideoElement);
                                            if (this._domAudioOnlyVideoElementEvents) this._domAudioOnlyVideoElementEvents.removeAll();
                                            this._domAudioOnlyVideoElement = null;
                                        case 4:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5, this);
                            }));
                            function _removeAudioOnlyVideoElement() {
                                return _removeAudioOnlyVideoElement2.apply(this, arguments);
                            }
                            return _removeAudioOnlyVideoElement;
                        }();
                        _proto.bindAudioTrackOnly = /*#__PURE__*/ function() {
                            var _bindAudioTrackOnly = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee6() {
                                var videoTracks, audioTracks, _videoTracks$, videoTrack, _audioTracks$, audioTrack, isAudioOnlyVideo;
                                return _regenerator.default.wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            videoTracks = this._stream.getVideoTracks();
                                            audioTracks = this._stream.getAudioTracks();
                                            _videoTracks$ = videoTracks[0], videoTrack = _videoTracks$ === void 0 ? {} : _videoTracks$;
                                            _audioTracks$ = audioTracks[0], audioTrack = _audioTracks$ === void 0 ? {} : _audioTracks$;
                                            _context6.next = 6;
                                            return noop();
                                        case 6:
                                            isAudioOnlyVideo = !videoTrack.enabled && audioTrack.enabled;
                                            if (!this._isVideoLoadedMetaData && isAudioOnlyVideo && this._domAudioOnlyVideoElement) {
                                                this._domAudioOnlyVideoElement.srcObject = new windowMock.MediaStream(audioTracks);
                                                this._startAudioOnlyVideoElementWatcher();
                                            }
                                        case 8:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, this);
                            }));
                            function bindAudioTrackOnly() {
                                return _bindAudioTrackOnly.apply(this, arguments);
                            }
                            return bindAudioTrackOnly;
                        }();
                        _proto._bindAudioOnlyVideoElementEvents = function _bindAudioOnlyVideoElementEvents() {
                            var _this2 = this;
                            this._domAudioOnlyVideoElementEvents = eventHelper(this._domAudioOnlyVideoElement); // Safari may stop playing audio if the browser is not visible or losses
                            // focus.  When it does, continue playing it.
                            this._domAudioOnlyVideoElementEvents.on('pause', ()=>this.play());
                            this._domAudioOnlyVideoElementEvents.on('timeupdate', function() {
                                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                                return _this2.trigger('timeupdate', ...args);
                            });
                            this._domAudioOnlyVideoElementEvents.on('loadedmetadata', function() {
                                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                                return _this2.trigger('loadedmetadata', ...args);
                            });
                        };
                        _proto.whenTimeIncrements = function whenTimeIncrements(callback, context) {
                            this.once('timeupdate', ()=>{
                                callback.call(context, this);
                            });
                        };
                        _proto.domElement = function domElement() {
                            return this._domElement;
                        };
                        _proto.videoWidth = function videoWidth() {
                            return this._domElement ? Number(this._domElement[`video${this.isRotated() ? 'Height' : 'Width'}`]) : 0;
                        };
                        _proto.videoHeight = function videoHeight() {
                            return this._domElement ? Number(this._domElement[`video${this.isRotated() ? 'Width' : 'Height'}`]) : 0;
                        };
                        _proto.aspectRatio = function aspectRatio() {
                            return this.videoWidth() / this.videoHeight();
                        };
                        _proto.imgData = function imgData() {
                            const canvas = OTHelpers.createElement('canvas', {
                                width: this.videoWidth(),
                                height: this.videoHeight(),
                                style: {
                                    display: 'none'
                                }
                            });
                            document1.body.appendChild(canvas);
                            let imgData = null;
                            try {
                                canvas.getContext('2d').drawImage(this._domElement, 0, 0, canvas.width, canvas.height);
                                imgData = canvas.toDataURL('image/png');
                            } catch (err) {}
                            OTHelpers.removeElement(canvas);
                            if (imgData === null || imgData === 'data:,') {
                                // 'data:,' is sometimes returned by canvas.toDataURL when one cannot be
                                // generated.
                                this.logging.warn('Cannot get image data yet');
                                return null;
                            }
                            return imgData.replace('data:image/png;base64,', '').trim();
                        } // Append the Video DOM element to a parent node
                        ;
                        _proto.appendTo = function appendTo(parentDomElement) {
                            parentDomElement.appendChild(this._domElement);
                            if (this._domAudioOnlyVideoElement) parentDomElement.appendChild(this._domAudioOnlyVideoElement);
                            return this;
                        };
                        _proto.isAudioBlocked = function isAudioBlocked() {
                            return this._blockedVolume !== undefined;
                        };
                        _proto.unblockAudio = /*#__PURE__*/ function() {
                            var _unblockAudio = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee7() {
                                var blockedVolume;
                                return _regenerator.default.wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            if (this.isAudioBlocked()) {
                                                _context7.next = 3;
                                                break;
                                            }
                                            this.logging.warn('Unexpected call to unblockAudio() without blocked audio');
                                            return _context7.abrupt("return");
                                        case 3:
                                            blockedVolume = this._blockedVolume;
                                            this._blockedVolume = undefined;
                                            this.setAudioVolume(blockedVolume);
                                            _context7.prev = 6;
                                            _context7.next = 9;
                                            return this.play();
                                        case 9:
                                            _context7.next = 16;
                                            break;
                                        case 11:
                                            _context7.prev = 11;
                                            _context7.t0 = _context7["catch"](6);
                                            this._blockedVolume = blockedVolume;
                                            this._domElement.muted = true;
                                            throw _context7.t0;
                                        case 16:
                                            this.trigger('audioUnblocked');
                                        case 17:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7, this, [
                                    [
                                        6,
                                        11
                                    ]
                                ]);
                            }));
                            function unblockAudio() {
                                return _unblockAudio.apply(this, arguments);
                            }
                            return unblockAudio;
                        }() // useful for some browsers (old chrome) that show black when a peer connection
                        ;
                        _proto.rebind = /*#__PURE__*/ function() {
                            var _rebind = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee8() {
                                return _regenerator.default.wrap(function _callee8$(_context8) {
                                    while(true)switch(_context8.prev = _context8.next){
                                        case 0:
                                            if (this._domElement) {
                                                _context8.next = 2;
                                                break;
                                            }
                                            throw new Error('Can\'t rebind because _domElement no longer exists');
                                        case 2:
                                            this._playInterrupts++;
                                            this._domElement.srcObject = this._domElement.srcObject;
                                            if (this._hasAudioOnlyVideoElement()) this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject;
                                        case 5:
                                        case "end":
                                            return _context8.stop();
                                    }
                                }, _callee8, this);
                            }));
                            function rebind() {
                                return _rebind.apply(this, arguments);
                            }
                            return rebind;
                        }();
                        _proto._createAudioLevelSampler = function _createAudioLevelSampler() {
                            this._removeAudioLevelSampler();
                            if (this._stream.getAudioTracks().length > 0) {
                                try {
                                    this._audioContext = audioContextProvider();
                                } catch (e) {
                                    this.logging.warn('Failed to get AudioContext(), audio level visualisation will not work', e);
                                }
                                if (this._audioContext) {
                                    this._audioLevelSampler = new WebAudioLevelSampler(this._audioContext);
                                    this._audioLevelSampler.webRTCStream(this._stream);
                                }
                            }
                        };
                        _proto._removeAudioLevelSampler = function _removeAudioLevelSampler() {
                            if (this._audioContext) {
                                delete this._audioContext;
                                delete this._audioLevelSampler;
                            }
                        } // For MediaStreams with multiple tracks, video tracks are disabled and
                        ;
                        _proto._toggleVideoTracks = /*#__PURE__*/ function() {
                            var _toggleVideoTracks2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee9() {
                                var enabledTracks, hasMultipleTracks, videoTracks;
                                return _regenerator.default.wrap(function _callee9$(_context9) {
                                    while(true)switch(_context9.prev = _context9.next){
                                        case 0:
                                            enabledTracks = this._domElement.srcObject.getTracks().filter((track)=>track.enabled);
                                            hasMultipleTracks = enabledTracks.length > 1;
                                            if (!hasMultipleTracks) {
                                                _context9.next = 8;
                                                break;
                                            }
                                            videoTracks = enabledTracks.filter((track)=>track.kind === 'video');
                                            videoTracks.forEach((track)=>{
                                                track.enabled = false;
                                            });
                                            _context9.next = 7;
                                            return noop();
                                        case 7:
                                            videoTracks.forEach((track)=>{
                                                track.enabled = true;
                                            });
                                        case 8:
                                        case "end":
                                            return _context9.stop();
                                    }
                                }, _callee9, this);
                            }));
                            function _toggleVideoTracks() {
                                return _toggleVideoTracks2.apply(this, arguments);
                            }
                            return _toggleVideoTracks;
                        }();
                        _proto._hasAudioOnlyVideoElement = function _hasAudioOnlyVideoElement() {
                            return this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.srcObject;
                        };
                        _proto.play = /*#__PURE__*/ function() {
                            var _play = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee10() {
                                var playInterruptsOnStart, domElement, isBuggediOS, _this$_stream$getVide, _this$_stream$getVide2, videoTrack, _this$_stream$getAudi, _this$_stream$getAudi2, audioTrack, _ref3, errorName, isAbortError;
                                return _regenerator.default.wrap(function _callee10$(_context10) {
                                    while(true)switch(_context10.prev = _context10.next){
                                        case 0:
                                            playInterruptsOnStart = this._playInterrupts; // Which element do we try to play?  The `audio` or `video` element?
                                            domElement = this._hasAudioOnlyVideoElement() ? this._domAudioOnlyVideoElement : this._domElement; // In Safari, if a HTMLMediaElement property is mutated or if the element is moved,
                                            // a delay is needed else element may fail to play
                                            if (!env.isSafari) {
                                                _context10.next = 5;
                                                break;
                                            }
                                            _context10.next = 5;
                                            return noop();
                                        case 5:
                                            if (!(env.isiOS && env.isSafari)) {
                                                _context10.next = 15;
                                                break;
                                            }
                                            if (!(this._widgetType === 'publisher')) {
                                                _context10.next = 14;
                                                break;
                                            }
                                            isBuggediOS = env.iOSVersion >= 14 && env.iOSVersion <= 14.2;
                                            _this$_stream$getVide = this._stream.getVideoTracks(), _this$_stream$getVide2 = _this$_stream$getVide[0], videoTrack = _this$_stream$getVide2 === void 0 ? {} : _this$_stream$getVide2;
                                            _this$_stream$getAudi = this._stream.getAudioTracks(), _this$_stream$getAudi2 = _this$_stream$getAudi[0], audioTrack = _this$_stream$getAudi2 === void 0 ? {} : _this$_stream$getAudi2;
                                            /**
               * OPENTOK-41742: Prevent to call play() on a hidden video element. Otherwise the
               * readyState of the MediaStreamTrack will be ended and the publisher will stop
               * publishing video.
               * This issue happens only on iOS Safari >= 14.0 and <= 14.2
               * */ if (!(isBuggediOS && !isDomElementVisible(domElement) && videoTrack.enabled)) {
                                                _context10.next = 12;
                                                break;
                                            }
                                            return _context10.abrupt("return");
                                        case 12:
                                            if (!audioTrack.muted) {
                                                _context10.next = 14;
                                                break;
                                            }
                                            return _context10.abrupt("return");
                                        case 14:
                                            // OPENTOK-39347: Toggle video tracks, else audio maybe garbled
                                            this._toggleVideoTracks();
                                        case 15:
                                            _context10.prev = 15;
                                            // We want to measure the duration of the blink: OPENTOK-46931
                                            this._emitVideoPlayAttempt();
                                            _context10.next = 19;
                                            return domElement.play();
                                        case 19:
                                            this._emitVideoPlaySuccess();
                                            return _context10.abrupt("return");
                                        case 23:
                                            _context10.prev = 23;
                                            _context10.t0 = _context10["catch"](15);
                                            this._emitVideoPlayFailure();
                                            _ref3 = _context10.t0 || {}, errorName = _ref3.name;
                                            isAbortError = errorName === 'AbortError'; // Play request was interrupted
                                            if (isAbortError) this._playInterrupts++;
                                            if (!(this._playInterrupts > playInterruptsOnStart)) {
                                                _context10.next = 33;
                                                break;
                                            }
                                            _context10.next = 32;
                                            return this.play();
                                        case 32:
                                            return _context10.abrupt("return");
                                        case 33:
                                            throw _context10.t0;
                                        case 34:
                                        case "end":
                                            return _context10.stop();
                                    }
                                }, _callee10, this, [
                                    [
                                        15,
                                        23
                                    ]
                                ]);
                            }));
                            function play() {
                                return _play.apply(this, arguments);
                            }
                            return play;
                        }();
                        _proto._bindToStream = function _bindToStream(webRtcStream) {
                            this._stream = webRtcStream;
                            this._domElement.srcObject = webRtcStream; // Audio-only video won't play in Safari since the browser won't dispatch
                            // the `loadedmetadata` event (since the video has unknown dimensions)
                            // https://bugs.webkit.org/show_bug.cgi?id=174152
                            if (this._domAudioOnlyVideoElement) this.bindAudioTrackOnly();
                        };
                        _proto.bindToStream = /*#__PURE__*/ function() {
                            var _bindToStream2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee12(webRtcStream) {
                                var _this3 = this;
                                var currentVideoSize, onAllEnded, onSingleEnded;
                                return _regenerator.default.wrap(function _callee12$(_context12) {
                                    while(true)switch(_context12.prev = _context12.next){
                                        case 0:
                                            if (this._domElement) {
                                                _context12.next = 2;
                                                break;
                                            }
                                            throw new Error('Can\'t bind because _domElement no longer exists');
                                        case 2:
                                            this._bindToStream(webRtcStream);
                                            (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee11() {
                                                var hasAudio;
                                                return _regenerator.default.wrap(function _callee11$(_context11) {
                                                    while(true)switch(_context11.prev = _context11.next){
                                                        case 0:
                                                            _context11.prev = 0;
                                                            _context11.next = 3;
                                                            return _this3.play();
                                                        case 3:
                                                            _context11.next = 26;
                                                            break;
                                                        case 5:
                                                            _context11.prev = 5;
                                                            _context11.t0 = _context11["catch"](0);
                                                            hasAudio = !!webRtcStream.getAudioTracks().length;
                                                            if (!(_this3._hasAudioOnlyVideoElement() && _context11.t0.name === 'NotAllowedError')) {
                                                                _context11.next = 15;
                                                                break;
                                                            }
                                                            // Audio-only video failed to play.  Mute audio and try again.
                                                            _this3._domAudioOnlyVideoElement.muted = true;
                                                            _context11.next = 12;
                                                            return _this3.play();
                                                        case 12:
                                                            // Now that audio-only stream is playing, unmute it.
                                                            _this3._domAudioOnlyVideoElement.muted = false;
                                                            _context11.next = 26;
                                                            break;
                                                        case 15:
                                                            if (!hasAudio) {
                                                                _context11.next = 23;
                                                                break;
                                                            }
                                                            // Media (with audio) failed to play.  Mute audio and try again.
                                                            _this3._blockedVolume = _this3.getAudioVolume();
                                                            _this3._domElement.muted = true;
                                                            _context11.next = 20;
                                                            return _this3.play();
                                                        case 20:
                                                            _this3.trigger('audioBlocked');
                                                            _context11.next = 26;
                                                            break;
                                                        case 23:
                                                            // Media failed to play.  Mute audio, even though there's no audio
                                                            // track (e.g., a screenshare), and try again.
                                                            _this3._domElement.muted = true;
                                                            _context11.next = 26;
                                                            return _this3.play();
                                                        case 26:
                                                        case "end":
                                                            return _context11.stop();
                                                    }
                                                }, _callee11, null, [
                                                    [
                                                        0,
                                                        5
                                                    ]
                                                ]);
                                            }))().catch((err)=>{
                                                this.logging.debug('.play() failed: ', err);
                                            });
                                            currentVideoSize = {
                                                width: this._domElement.videoWidth,
                                                height: this._domElement.videoHeight
                                            };
                                            this.trigger('videoDimensionsChanged', (0, _extends2.default)({}, currentVideoSize), (0, _extends2.default)({}, currentVideoSize));
                                            this._domElementEvents.on('resize', ()=>{
                                                const _this$_domElement = this._domElement, width = _this$_domElement.videoWidth, height = _this$_domElement.videoHeight;
                                                const widthChanged = width !== currentVideoSize.width;
                                                const heightChanged = height !== currentVideoSize.height;
                                                if (widthChanged || heightChanged) {
                                                    this.trigger('videoDimensionsChanged', (0, _extends2.default)({}, currentVideoSize), {
                                                        width: width,
                                                        height: height
                                                    });
                                                    currentVideoSize.width = width;
                                                    currentVideoSize.height = height;
                                                }
                                            });
                                            onAllEnded = ()=>{
                                                this._mediaStoppedListener.stop();
                                                if (this._domElement) this._domElement.onended = null;
                                                this.trigger('mediaStopped');
                                            };
                                            onSingleEnded = (track)=>{
                                                this.trigger('mediaStopped', track);
                                            };
                                            this._domElement.onended = ()=>onAllEnded();
                                            this._mediaStoppedListener = listenForTracksEnded(webRtcStream, onAllEnded, onSingleEnded);
                                            this._createAudioLevelSampler();
                                            return _context12.abrupt("return", undefined);
                                        case 13:
                                        case "end":
                                            return _context12.stop();
                                    }
                                }, _callee12, this);
                            }));
                            function bindToStream(_x) {
                                return _bindToStream2.apply(this, arguments);
                            }
                            return bindToStream;
                        }() // Unbind the currently bound stream from the video element.
                        ;
                        _proto.unbindStream = function unbindStream() {
                            if (this._domElement) this._domElement.srcObject = null;
                            if (this._domAudioOnlyVideoElement) this._domAudioOnlyVideoElement.srcObject = null;
                            this._removeAudioLevelSampler();
                            return this;
                        };
                        _proto.setAudioVolume = function setAudioVolume(rawValue) {
                            if (this.isAudioBlocked()) {
                                this._blockedVolume = rawValue;
                                return;
                            }
                            const value = parseFloat(rawValue) / 100;
                            const domElements = [
                                this.domElement()
                            ];
                            if (this._domAudioOnlyVideoElement) domElements.push(this._domAudioOnlyVideoElement);
                            domElements.forEach((domElement)=>{
                                if (domElement) {
                                    domElement.volume = value; // In Safari on iOS setting the volume does not work but setting muted does so at
                                    // least this will mute when you click the mute icon
                                    // https://bugs.webkit.org/show_bug.cgi?id=176045
                                    domElement.muted = value === 0;
                                }
                            });
                        };
                        _proto.getAudioVolume = function getAudioVolume() {
                            if (this.isAudioBlocked()) return this._blockedVolume;
                             // Return the actual volume of the DOM element
                            const domElement = this.domElement();
                            if (domElement) return domElement.muted ? 0 : domElement.volume * 100;
                            return this._defaultAudioVolume;
                        } // see https://wiki.mozilla.org/WebAPI/AudioChannels
                        ;
                        _proto.audioChannelType = function audioChannelType(type) {
                            const domElement = this.domElement();
                            if (type !== void 0) domElement.mozAudioChannelType = type;
                            if ('mozAudioChannelType' in this._domElement) return domElement.mozAudioChannelType;
                            return 'unknown';
                        };
                        _proto.getAudioInputLevel = function getAudioInputLevel() {
                            return this._audioLevelSampler.sample();
                        };
                        _proto.refreshTracks = function refreshTracks() {
                            if (this._mediaStoppedListener) this._mediaStoppedListener.refresh();
                            this._createAudioLevelSampler();
                        };
                        _proto.destroy = function destroy() {
                            // Unbind events first, otherwise 'pause' will trigger when the
                            // video element is removed from the DOM.
                            if (this._mediaStoppedListener) this._mediaStoppedListener.stop();
                            this.logging.debug('removing domElementEvents');
                            this._domElementEvents.removeAll();
                            if (this._domAudioOnlyVideoElementEvents) this._domAudioOnlyVideoElementEvents.removeAll();
                            if (this._audioOnlyVideoElementWatcher) clearInterval(this._audioOnlyVideoElementWatcher);
                            this.unbindStream();
                            if (this._domElement) {
                                OTHelpers.removeElement(this._domElement);
                                this._domElement = null;
                            }
                            if (this._domAudioOnlyVideoElement) {
                                OTHelpers.removeElement(this._domAudioOnlyVideoElement);
                                this._domAudioOnlyVideoElement = null;
                            }
                            this.trigger('destroyed');
                            destroyObj('NativeVideoElementWrapper', this);
                            return void 0;
                        };
                        _proto.setSinkId = function setSinkId(deviceId) {
                            const videoElements = [
                                this._domElement,
                                this._domAudioOnlyVideoElement
                            ];
                            const setSinkIdPromises = videoElements.map((videoElement)=>{
                                if (!videoElement) return undefined;
                                return videoElement.setSinkId(deviceId);
                            });
                            return Promise.all(setSinkIdPromises);
                        };
                        return NativeVideoElementWrapper;
                    }();
                    return NativeVideoElementWrapper;
                }
                module1.exports = NativeVideoElementWrapperFactory;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 295 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                module1.exports = ()=>new Promise((resolve)=>setTimeout(resolve));
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 296 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, global-require, no-underscore-dangle, func-names */ const assign = __webpack_require__(9);
                const pick = __webpack_require__(48);
                const find = __webpack_require__(62);
                const eventing = __webpack_require__(7);
                const shouldForceTurn = __webpack_require__(297);
                const setICEConfigWithForcedTurn = __webpack_require__(298);
                const getMaxBitrateForResolution = __webpack_require__(653);
                module1.exports = function PublisherPeerConnectionFactory(deps) {
                    if (deps === void 0) deps = {};
                    const getStatsHelpers = deps.getStatsHelpers || __webpack_require__(76);
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const PeerConnection = deps.PeerConnection || __webpack_require__(73)();
                    const setCertificates = deps.setCertificates || __webpack_require__(163)();
                    const watchAudioAcquisition = deps.watchAudioAcquisition || __webpack_require__(655);
                    /**
   * @typedef {object} PublisherPeerConnectionConfig
   * @property {function(string, string=, object=, object=, boolean=)} logAnalyticsEvent
   * @property {Connection} remoteConnection
   * @property {boolean} reconnection
   * @property {MediaStream} webRTCStream
   * @property {object<string, object>} channels
   * @property {boolean} capableSimulcastStreams
   * @property {boolean} overrideSimulcastEnabled
   * @property {string} subscriberUri
   * @property {object<string, object>} offerOverrides
   * @property {object<string, object>} answerOverrides
   * @property {string} sourceStreamId
   * @property {string} isP2pEnabled
   */ /**
   * Abstracts PeerConnection related stuff away from Publisher.
   *
   * Responsible for:
   * * setting up the underlying PeerConnection (delegates to PeerConnections)
   * * triggering a connected event when the Peer connection is opened
   * * triggering a disconnected event when the Peer connection is closed
   * * providing a destroy method
   * * providing a processMessage method
   *
   * Once the PeerConnection is connected and the video element playing it triggers
   * the connected event
   *
   * Triggers the following events
   * * connected
   * * disconnected
   *
   * @class PublisherPeerConnection
   * @constructor
   *
   * @param {PublisherPeerConnectionConfig} config
   */ return function PublisherPeerConnection(_ref) {
                        var _this = this;
                        let iceConfig = _ref.iceConfig, webRTCStream = _ref.webRTCStream, channels = _ref.channels, sendMessage = _ref.sendMessage, capableSimulcastStreams = _ref.capableSimulcastStreams, overrideSimulcastEnabled = _ref.overrideSimulcastEnabled, logAnalyticsEvent = _ref.logAnalyticsEvent, offerOverrides = _ref.offerOverrides, answerOverrides = _ref.answerOverrides, sourceStreamId = _ref.sourceStreamId, isP2pEnabled = _ref.isP2pEnabled, sessionId = _ref.sessionId, keyStore = _ref.keyStore, sFrameClientStore = _ref.sFrameClientStore, isE2ee = _ref.isE2ee;
                        let _peerConnection;
                        let _awaitingIceRestart = false;
                        let _cancelWatchAudioAcquisition; // Private
                        const _onPeerClosed = function _onPeerClosed() {
                            this.destroy();
                            if (_awaitingIceRestart) {
                                _awaitingIceRestart = false;
                                this.trigger('iceRestartFailure');
                            }
                            this.trigger('disconnected');
                        };
                        const _onPeerError = function _onPeerError(_ref2) {
                            let reason = _ref2.reason, prefix = _ref2.prefix;
                            this.trigger('error', {
                                reason: reason,
                                prefix: prefix
                            });
                        };
                        const _onIceConnectionStateChange = function _onIceConnectionStateChange(state) {
                            if (_awaitingIceRestart && _peerConnection.iceConnectionStateIsConnected()) {
                                _awaitingIceRestart = false;
                                this.trigger('iceRestartSuccess');
                            } // watch for the Chrome bug where audio can't be acquired
                            // can not use iceConnectionStateIsConnected since it is too broad
                            if (state === 'connected') {
                                if (OTHelpers.env.name === 'Chrome') {
                                    // cancel any pending watcher (in case of ice restart for example)
                                    if (_cancelWatchAudioAcquisition) _cancelWatchAudioAcquisition();
                                    _cancelWatchAudioAcquisition = watchAudioAcquisition(_peerConnection.getStats.bind(_peerConnection), ()=>this.trigger('audioAcquisitionProblem'));
                                }
                                this.trigger('connected');
                            }
                            this.trigger('iceConnectionStateChange', state);
                        };
                        eventing(this); // / Public API
                        this.startEncryption = (connectionId)=>{
                            if (_peerConnection) _peerConnection.startEncryption(connectionId);
                        };
                        this.changeMediaDirectionToInactive = ()=>{
                            if (_peerConnection) _peerConnection.changeMediaDirectionToInactive();
                        };
                        this.changeMediaDirectionToRecvOnly = ()=>{
                            if (_peerConnection) _peerConnection.changeMediaDirectionToRecvOnly();
                        };
                        this.getDataChannel = function(label, options, completion) {
                            _peerConnection.getDataChannel(label, options, completion);
                        };
                        this.getSourceStreamId = ()=>_peerConnection.getSourceStreamId();
                        this.destroy = function() {
                            if (_cancelWatchAudioAcquisition) {
                                _cancelWatchAudioAcquisition();
                                _cancelWatchAudioAcquisition = null;
                            } // Clean up our PeerConnection
                            if (_peerConnection) {
                                _peerConnection.disconnect();
                                _peerConnection = null;
                            }
                            this.off();
                        };
                        this.processMessage = function(type, message) {
                            _peerConnection.processMessage(type, message);
                        };
                        this.addTrack = function(track, stream, callback) {
                            return _peerConnection.addTrack(track, stream, callback);
                        };
                        this.removeTrack = function(RTCRtpSender) {
                            return _peerConnection.removeTrack(RTCRtpSender);
                        };
                        this.getLocalStreams = function() {
                            return _peerConnection.getLocalStreams();
                        }; // Init
                        this.init = function(rumorIceServers, completion) {
                            if (shouldForceTurn(sourceStreamId)) setICEConfigWithForcedTurn(iceConfig);
                            const pcConfig = {
                                iceConfig: !iceConfig.needRumorIceServersFallback ? iceConfig : assign(iceConfig, {
                                    servers: [
                                        ...rumorIceServers,
                                        ...iceConfig.servers
                                    ]
                                }),
                                channels: channels,
                                capableSimulcastStreams: capableSimulcastStreams,
                                overrideSimulcastEnabled: overrideSimulcastEnabled
                            };
                            setCertificates(pcConfig, (err, pcConfigWithCerts)=>{
                                if (err) {
                                    completion(err);
                                    return;
                                }
                                const peerConnectionConfig = assign({
                                    logAnalyticsEvent: logAnalyticsEvent,
                                    isPublisher: true,
                                    offerOverrides: offerOverrides,
                                    answerOverrides: answerOverrides,
                                    sourceStreamId: sourceStreamId,
                                    p2p: isP2pEnabled,
                                    sessionId: sessionId,
                                    keyStore: keyStore,
                                    sFrameClientStore: sFrameClientStore,
                                    isE2ee: isE2ee
                                }, pcConfigWithCerts);
                                _peerConnection = new PeerConnection(assign({
                                    sendMessage: sendMessage
                                }, peerConnectionConfig));
                                _peerConnection.on({
                                    close: _onPeerClosed,
                                    error: _onPeerError,
                                    qos: (_qos)=>this.trigger('qos', _qos),
                                    iceConnectionStateChange: _onIceConnectionStateChange
                                }, this);
                                _peerConnection.addLocalStream(webRTCStream).then(()=>{
                                    completion(undefined);
                                }).catch(completion);
                            });
                        };
                        this.setIceConfig = (newIceConfig)=>{
                            _peerConnection.setIceConfig(newIceConfig);
                        };
                        this.getSenders = function() {
                            return _peerConnection.getSenders();
                        };
                        this.iceRestart = function() {
                            if (_peerConnection) {
                                _awaitingIceRestart = true;
                                _peerConnection.iceRestart();
                            }
                        };
                        this.hasRelayCandidates = ()=>_peerConnection.hasRelayCandidates();
                        this.iceConnectionStateIsConnected = function() {
                            return _peerConnection.iceConnectionStateIsConnected();
                        };
                        this.findAndReplaceTrack = (oldTrack, newTrack)=>_peerConnection.findAndReplaceTrack(oldTrack, newTrack);
                        this._testOnlyGetFramesEncoded = ()=>new Promise((resolve, reject)=>{
                                _peerConnection.getStats((err, stats)=>{
                                    if (err) {
                                        reject(err);
                                        return;
                                    }
                                    const videoStat = find(stats, (stat)=>getStatsHelpers.isVideoStat(stat, stats) && getStatsHelpers.isOutboundStat(stat));
                                    if (!videoStat) {
                                        reject(new Error('Could not find framesEncoded in getStats report'));
                                        return;
                                    }
                                    resolve(pick(videoStat, [
                                        'timestamp',
                                        'framesEncoded'
                                    ]));
                                });
                            });
                        this.getStats = (callback)=>_peerConnection.getStats(callback);
                        this.getRtcStatsReport = (callback)=>_peerConnection.getRtcStatsReport(callback);
                        this.setP2PMaxBitrate = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                            var _sender$track;
                            var sender, _ref5, width, height, maxBitrate, sendParameters;
                            return _regenerator.default.wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        if (!(_this.getSourceStreamId() !== 'P2P')) {
                                            _context.next = 2;
                                            break;
                                        }
                                        return _context.abrupt("return");
                                    case 2:
                                        sender = _this.getSenders().find((_ref4)=>{
                                            let kind = _ref4.track.kind;
                                            return kind === 'video';
                                        });
                                        if (sender) {
                                            _context.next = 5;
                                            break;
                                        }
                                        return _context.abrupt("return");
                                    case 5:
                                        _ref5 = (sender == null ? void 0 : (_sender$track = sender.track) == null ? void 0 : _sender$track.getSettings == null ? void 0 : _sender$track.getSettings()) || {}, width = _ref5.width, height = _ref5.height;
                                        maxBitrate = getMaxBitrateForResolution(width, height);
                                        sendParameters = sender.getParameters();
                                        sendParameters.encodings.forEach((encoding)=>{
                                            encoding.maxBitrate = maxBitrate; // eslint-disable-line no-param-reassign
                                        });
                                        _context.prev = 9;
                                        _context.next = 12;
                                        return sender.setParameters(sendParameters);
                                    case 12:
                                        _context.next = 16;
                                        break;
                                    case 14:
                                        _context.prev = 14;
                                        _context.t0 = _context["catch"](9);
                                    case 16:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, null, [
                                [
                                    9,
                                    14
                                ]
                            ]);
                        }));
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 297 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const hasServerReflexiveCandidatesBug = __webpack_require__(652); // https://jira.vonage.com/browse/OPENTOK-45642
            // should force TURN for bugged iOS and Safari versions
            module1.exports = (sourceStreamId)=>{
                // We should only force TURN for relayed participants
                if (sourceStreamId !== 'P2P') return false;
                return hasServerReflexiveCandidatesBug();
            };
        /***/ },
        /* 298 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-param-reassign */ module1.exports = (iceConfig)=>{
                // to force use TURN
                iceConfig.transportPolicy = 'relay'; // this needs to be present since it is mandatory prop, but it can be an empty array
                iceConfig.customServers = iceConfig.customServers || [];
            };
        /***/ },
        /* 299 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable global-require, no-underscore-dangle, no-param-reassign, no-void, no-shadow */ /* eslint-disable func-names */ const assign = __webpack_require__(9);
            const eventing = __webpack_require__(7);
            const shouldForceTurn = __webpack_require__(297);
            const setICEConfigWithForcedTurn = __webpack_require__(298);
            module1.exports = function SubscriberPeerConnectionFactory(deps) {
                if (deps === void 0) deps = {};
                const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                const PeerConnection = deps.PeerConnection || __webpack_require__(73)();
                const SinglePeerConnection = deps.SinglePeerConnection || __webpack_require__(656)();
                const setCertificates = deps.setCertificates || __webpack_require__(163)();
                const Errors = deps.Errors || __webpack_require__(6);
                const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                const OTErrorClass = deps.OTErrorClass || __webpack_require__(22);
                const watchSubscriberAudio = deps.watchSubscriberAudio || __webpack_require__(657);
                /*
   * Abstracts PeerConnection related stuff away from Subscriber.
   *
   * Responsible for:
   * * setting up the underlying PeerConnection (delegates to PeerConnections)
   * * triggering a connected event when the Peer connection is opened
   * * triggering a disconnected event when the Peer connection is closed
   * * creating a video element when a stream is added
   * * responding to stream removed intelligently
   * * providing a destroy method
   * * providing a processMessage method
   *
   * Once the PeerConnection is connected and the video element playing it
   * triggers the connected event
   *
   * Triggers the following events
   * * connected
   * * disconnected
   * * remoteTrackAdded
   * * remoteStreamRemoved
   * * error
   *
   */ return function SubscriberPeerConnection(_ref) {
                    let clientCandidates = _ref.clientCandidates, iceConfig = _ref.iceConfig, send = _ref.send, logAnalyticsEvent = _ref.logAnalyticsEvent, p2p = _ref.p2p, codecFlags = _ref.codecFlags, sourceStreamId = _ref.sourceStreamId, remoteConnectionId = _ref.remoteConnectionId, _singlePeerConnectionController = _ref._singlePeerConnectionController, keyStore = _ref.keyStore, sFrameClientStore = _ref.sFrameClientStore, isE2ee = _ref.isE2ee;
                    const _subscriberPeerConnection = this;
                    let _peerConnection;
                    let _destroyed = false;
                    let _awaitingIceRestart = false;
                    let _subscriberAudioWatcher = null; // _singlePeerConnectionController is also used as a flag.
                    const _isSpcEnabled = !!_singlePeerConnectionController;
                    let _isTrackListenerAdded = false;
                    const _videoTracks = [];
                    const _audioTracks = []; // Private
                    const _onPeerClosed = function _onPeerClosed() {
                        this.destroy();
                        if (_awaitingIceRestart) this.trigger('iceRestartFailure', this);
                        this.trigger('disconnected', this);
                    };
                    const _onRemoteStreamRemoved = (remoteRTCStream)=>{
                        this.trigger('remoteStreamRemoved', remoteRTCStream, this);
                    };
                    const _removeTrack = (track)=>{
                        const tracks = track.kind === 'video' ? _videoTracks : _audioTracks;
                        const trackIndex = tracks.indexOf(track);
                        if (trackIndex > -1) tracks.splice(trackIndex, 1);
                    };
                    const _addTrack = (track)=>{
                        const tracks = track.kind === 'video' ? _videoTracks : _audioTracks; // Don't add the same track twice
                        if (!tracks.includes(track)) tracks.push(track);
                    };
                    const STREAM_REMOVED_DELAY = 100;
                    const _addRemoveTrackListener = (webRTCStream)=>{
                        if (_isTrackListenerAdded) // Do not add the listener twice.
                        return;
                         // We do not have onRemoteStreamRemoved anymore, so we listen to removeTrack instead.
                        // Once a track has been removed from the Stream, we will check if there are more tracks
                        // in the stream. If we dont have any other, we consider this stream as removed, then we
                        // proceed to destroy its respective Subscriber.
                        // This is done with a custom delay due to the unlikey event where a removedTrack is
                        // triggered right before addedTrack. FYI: replaceTrack does not trigger either of them.
                        webRTCStream.onremovetrack = (track)=>{
                            _removeTrack(track);
                            if (_isSpcEnabled && _peerConnection) _peerConnection.removeTrack(track);
                            setTimeout(()=>{
                                if (!_videoTracks.length && !_audioTracks.length) _onRemoteStreamRemoved(webRTCStream, this);
                                 // Custom delay of STREAM_REMOVED_DELAY msecs. We pace subscriber creation per 100 msecs,
                            // we consider an alteration of it should not exceed that. This will prevent to destroy
                            // the subscriber when all tracks have been replaced, i.e. all tracks removed and then
                            // new ones added.
                            }, STREAM_REMOVED_DELAY);
                        };
                        _isTrackListenerAdded = true;
                    };
                    const _onRemoteTrackAdded = (remoteRTCStream)=>{
                        const stream = remoteRTCStream.stream, track = remoteRTCStream.track; // Add track to the tracks list.
                        _addTrack(track); // Add remove track listener to the stream.
                        _addRemoveTrackListener(stream);
                        this.trigger('remoteTrackAdded', remoteRTCStream, this);
                    };
                    const _onRemoteVideoSupported = (supported)=>{
                        this.trigger('remoteVideoSupported', supported);
                    };
                    const _onDecryptFailed = ()=>{
                        this.trigger('decryptFailed');
                    };
                    const _onDecryptRestored = ()=>{
                        this.trigger('decryptRestored');
                    }; // Note: All Peer errors are fatal right now.
                    const _onPeerError = function _onPeerError(_ref2) {
                        let reason = _ref2.reason, prefix = _ref2.prefix;
                        this.trigger('error', null, reason, this, prefix);
                    };
                    const _onIceConnectionStateChange = function _onIceConnectionStateChange(state) {
                        if (_awaitingIceRestart && (state === 'connected' || state === 'completed')) {
                            _awaitingIceRestart = false;
                            this.trigger('iceRestartSuccess');
                        }
                        if (state === 'connected') this.trigger('connected');
                        this.trigger('iceConnectionStateChange', state);
                    };
                    const _onsignalingStateChange = function _onsignalingStateChange(state) {
                        this.trigger('signalingStateChange', state);
                    };
                    const _onsignalingStateStable = function _onsignalingStateStable(state) {
                        this.trigger('signalingStateStable', state);
                    };
                    const _relayMessageToPeer = (type, content)=>{
                        if (type === 'answer' || type === 'pranswer') this.trigger('connected');
                        send(type, content);
                    };
                    eventing(this); // Public
                    this._hasAudioTracks = ()=>_audioTracks.length > 0;
                    this._hasVideoTracks = ()=>_videoTracks.length > 0;
                    this._getVideoTracks = ()=>_videoTracks;
                    this._getAudioTracks = ()=>_audioTracks;
                    this._getTracks = ()=>[
                            ..._audioTracks,
                            ..._videoTracks
                        ];
                    this.close = function() {
                        if (_destroyed) return;
                        _destroyed = true;
                        if (_peerConnection) {
                            _peerConnection.disconnect();
                            _peerConnection = null;
                        }
                        this.off();
                    };
                    this.destroy = function() {
                        this.stopAudioStatsWatcher();
                        if (_destroyed) return;
                        this.close();
                    };
                    this.getDataChannel = function(label, options, completion) {
                        _peerConnection.getDataChannel(label, options, completion);
                    };
                    this.getSourceStreamId = ()=>_peerConnection.getSourceStreamId();
                    this.processMessage = function(type, message) {
                        _peerConnection.processMessage(type, message);
                    };
                    this.remoteDescription = function() {
                        return _peerConnection.remoteDescription();
                    };
                    this.getStats = function(callback) {
                        if (_peerConnection) _peerConnection.getStats(callback);
                        else {
                            const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                            callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                code: errorCode
                            }));
                        }
                    };
                    this.getSynchronizationSources = function(callback) {
                        if (!_peerConnection) {
                            const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                            callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                code: errorCode
                            }));
                            return;
                        }
                        _peerConnection.getSynchronizationSources(callback);
                    };
                    this.getRtcStatsReport = function(callback) {
                        if (_peerConnection) _peerConnection.getRtcStatsReport(callback);
                        else {
                            const errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                            callback(new OTHelpers.Error(OTErrorClass.getTitleByCode(errorCode), Errors.PEER_CONNECTION_NOT_CONNECTED, {
                                code: errorCode
                            }));
                        }
                    };
                    this.setIceConfig = (iceConfig)=>{
                        _peerConnection.setIceConfig(iceConfig);
                    };
                    this.startAudioStatsWatcher = function(disableAudioLevelStuckAt0) {
                        if (!_subscriberAudioWatcher) _subscriberAudioWatcher = watchSubscriberAudio(_peerConnection.getStats.bind(_peerConnection), (reason)=>{
                            this.stopAudioStatsWatcher();
                            this.trigger('audioLevelStuckWarning', reason);
                        }, disableAudioLevelStuckAt0);
                    };
                    this.stopAudioStatsWatcher = function() {
                        if (_subscriberAudioWatcher) _subscriberAudioWatcher.stop();
                        _subscriberAudioWatcher = null;
                    }; // Helper method used by subscribeToAudio/subscribeToVideo
                    const _createSetEnabledForTracks = function _createSetEnabledForTracks(kind) {
                        return function(enabled) {
                            const tracks = kind === 'video' ? _videoTracks : _audioTracks;
                            if (!_peerConnection) // We haven't created the peer connection yet, so there are no remote streams right now.
                            // Subscriber will try again after onRemoteStreamAdded so this works out ok.
                            return;
                            _peerConnection.remoteTracks().forEach((track)=>{
                                if (track.kind === kind && track.enabled !== enabled && tracks.includes(track)) track.enabled = enabled;
                            });
                        };
                    };
                    this.subscribeToAudio = _createSetEnabledForTracks('audio');
                    this.subscribeToVideo = _createSetEnabledForTracks('video');
                    this.hasRelayCandidates = function() {
                        return _peerConnection.hasRelayCandidates();
                    };
                    this.iceRestart = function() {
                        _awaitingIceRestart = true;
                        return _peerConnection.iceRestart();
                    };
                    this.iceConnectionStateIsConnected = function() {
                        return _peerConnection.iceConnectionStateIsConnected();
                    }; // Init
                    this.init = function(completion) {
                        if (shouldForceTurn(sourceStreamId)) setICEConfigWithForcedTurn(iceConfig);
                        const pcConfig = {
                            iceConfig: iceConfig
                        };
                        setCertificates(pcConfig, (err, pcConfigWithCerts)=>{
                            if (err) {
                                completion(err);
                                return;
                            }
                            const peerConnectionConfig = assign({
                                logAnalyticsEvent: logAnalyticsEvent,
                                clientCandidates: clientCandidates,
                                codecFlags: codecFlags,
                                sourceStreamId: sourceStreamId,
                                keyStore: keyStore,
                                sFrameClientStore: sFrameClientStore,
                                isE2ee: isE2ee
                            }, pcConfigWithCerts);
                            const options = assign({
                                sendMessage: _relayMessageToPeer,
                                p2p: p2p
                            }, peerConnectionConfig, {
                                remoteConnectionId: remoteConnectionId
                            });
                            if (_isSpcEnabled) // SinglePeerConnection is the interface of PeerConnection to use when SPC.
                            _peerConnection = new SinglePeerConnection(options, _singlePeerConnectionController);
                            else _peerConnection = new PeerConnection(options);
                            _peerConnection.on({
                                iceConnected: ()=>_subscriberPeerConnection.emit('iceConnected'),
                                close: _onPeerClosed,
                                trackAdded: _onRemoteTrackAdded,
                                signalingStateChange: _onsignalingStateChange,
                                signalingStateStable: _onsignalingStateStable,
                                error: _onPeerError,
                                qos: (_qos)=>this.trigger('qos', _qos),
                                iceConnectionStateChange: _onIceConnectionStateChange,
                                remoteVideoSupported: _onRemoteVideoSupported,
                                decryptFailed: _onDecryptFailed,
                                decryptRestored: _onDecryptRestored
                            }, _subscriberPeerConnection); // If there are already remoteStreams, add them immediately
                            // (Using .remoteTracks to avoid deprecated .remoteStreams where possible.
                            // FIXME: Is this even possible anyway? How could we already have remote streams in the same
                            // tick the peer connection was created?)
                            if (!_isSpcEnabled && _peerConnection.remoteTracks().length > 0) // @todo i really don't think this branch is ever entered, it might be an artifact of the
                            // unit tests
                            // @todo ahh maybe reconnections?
                            _peerConnection.remoteStreams().forEach((stream)=>{
                                stream.getTracks().forEach((track)=>_onRemoteTrackAdded({
                                        stream: stream,
                                        track: track
                                    }));
                            });
                            else completion(undefined, _subscriberPeerConnection);
                        });
                    };
                };
            };
        /***/ },
        /* 300 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ module1.exports = function PublishingStateFactory(deps) {
                if (deps === void 0) deps = {};
                const generateSimpleStateMachine = deps.generateSimpleStateMachine || __webpack_require__(160)(); // Models a Publisher's publishing State
                //
                // Valid States:
                //    NotPublishing
                //    GetUserMedia
                //    BindingMedia
                //    MediaBound
                //    PublishingToSession
                //    Publishing
                //    Failed
                //    Destroyed
                //
                //
                // Valid Transitions:
                //    NotPublishing ->
                //        GetUserMedia
                //
                //    GetUserMedia ->
                //        BindingMedia
                //      | Failed                     (Failure Reasons -> stream error, constraints,
                //                                   (permission denied
                //      | NotPublishing              (destroy()
                //
                //
                //    BindingMedia ->
                //        MediaBound
                //      | Failed                     (Failure Reasons -> Anything to do with the media
                //                                   (being invalid, the media never plays
                //      | NotPublishing              (destroy()
                //
                //    MediaBound ->
                //        PublishingToSession        (MediaBound could transition to PublishingToSession
                //                                   (if a stand-alone publish is bound to a session
                //      | Failed                     (Failure Reasons -> media issues with a stand-alone publisher
                //      | NotPublishing              (destroy()
                //
                //    PublishingToSession
                //        Publishing
                //      | Failed
                //      | NotPublishing              (destroy()
                //      | MediaBound                 (disconnect()
                //
                //
                //    Publishing ->
                //        NotPublishing              (Unpublish
                //      | Failed                     (Failure Reasons -> loss of network, media error, anything
                //                                   (that causes *all* Peer Connections to fail (less than all
                //                                   (failing is just an error, all is failure)
                //      | NotPublishing              (destroy()
                //
                //    Failed ->
                //       Destroyed
                //
                //    Destroyed ->                   (Terminal state
                //
                //
                const validStates = [
                    'NotPublishing',
                    'GetUserMedia',
                    'BindingMedia',
                    'MediaBound',
                    'PublishingToSession',
                    'Publishing',
                    'Failed',
                    'Destroyed'
                ];
                const validTransitions = {
                    NotPublishing: [
                        'NotPublishing',
                        'GetUserMedia',
                        'Destroyed'
                    ],
                    GetUserMedia: [
                        'BindingMedia',
                        'Failed',
                        'NotPublishing',
                        'Destroyed'
                    ],
                    BindingMedia: [
                        'MediaBound',
                        'Failed',
                        'NotPublishing',
                        'Destroyed'
                    ],
                    MediaBound: [
                        'NotPublishing',
                        'PublishingToSession',
                        'Failed',
                        'Destroyed'
                    ],
                    PublishingToSession: [
                        'NotPublishing',
                        'Publishing',
                        'Failed',
                        'Destroyed',
                        'MediaBound'
                    ],
                    Publishing: [
                        'NotPublishing',
                        'MediaBound',
                        'Failed',
                        'Destroyed'
                    ],
                    Failed: [
                        'Destroyed'
                    ],
                    Destroyed: []
                };
                const initialState = 'NotPublishing';
                const PublishingState = generateSimpleStateMachine(initialState, validStates, validTransitions);
                PublishingState.prototype.isDestroyed = function() {
                    return this.current === 'Destroyed';
                };
                PublishingState.prototype.isAttemptingToPublish = function() {
                    return [
                        'GetUserMedia',
                        'BindingMedia',
                        'MediaBound',
                        'PublishingToSession'
                    ].indexOf(this.current) !== -1;
                };
                PublishingState.prototype.isPublishing = function() {
                    return this.current === 'Publishing';
                };
                return PublishingState;
            };
        /***/ },
        /* 301 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = CancellationError;
            // Note: Babel does not support extending builtin types like error:
            // https://phabricator.babeljs.io/T3083
            /**
 * The error that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The error message.
 * @extends Error
 */ function CancellationError(message) {
                this.message = message || 'Operation has been canceled.';
                this.name = 'CancellationError';
                if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
            }
            CancellationError.prototype = Object.create(Error.prototype);
            CancellationError.prototype.constructor = CancellationError;
        /***/ },
        /* 302 */ /***/ function(module1, exports, __webpack_require__) {
            /*** IMPORTS FROM imports-loader ***/ var Promise = __webpack_require__(0);
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function promiseFinally(value, cb) {
                return Promise.resolve(value).then((value)=>Promise.resolve(cb()).then(()=>value), (reason)=>Promise.resolve(cb()).then(()=>Promise.reject(reason)));
            }
            exports.default = promiseFinally;
        //# sourceMappingURL=index.js.map
        /***/ },
        /* 303 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                /* global MediaStream */ // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, no-underscore-dangle */ /* eslint-disable no-use-before-define, no-shadow, max-len */ const defaults = __webpack_require__(140);
                const merge = __webpack_require__(255);
                const assign = __webpack_require__(9);
                const values = __webpack_require__(277);
                const get = __webpack_require__(59);
                const once = __webpack_require__(51);
                const _require = __webpack_require__(165), CancellationError = _require.CancellationError;
                const uuid = __webpack_require__(16);
                const EventEmitter = __webpack_require__(31);
                const now = __webpack_require__(50);
                const castToBoolean = __webpack_require__(268);
                const eventNames = __webpack_require__(27);
                const eventing = __webpack_require__(7);
                const waitUntil = __webpack_require__(666);
                const RafRunner = __webpack_require__(103);
                const eventHelper = __webpack_require__(63);
                const interpretSubscriberCreateError = __webpack_require__(667);
                const Errors = __webpack_require__(6);
                const defaultWidgetView = __webpack_require__(164)();
                const audioLevelBehaviour = __webpack_require__(668);
                const AudioLevelMeterDefault = __webpack_require__(283);
                const AudioLevelTransformerDefault = __webpack_require__(143);
                const BackingBarDefault = __webpack_require__(284);
                const ChromeDefault = __webpack_require__(144);
                const envDefault = __webpack_require__(3);
                const errorsDefault = __webpack_require__(6);
                const EventsDefault = __webpack_require__(23)();
                const ExceptionCodesDefault = __webpack_require__(10);
                const getStatsHelpersDefault = __webpack_require__(76);
                const hasAudioOutputLevelStatCapabilityDefault = __webpack_require__(304);
                const hasRemoteStreamsWithWebAudioDefault = __webpack_require__(305);
                const audioLevelSamplerDefault = __webpack_require__(669);
                const interpretPeerConnectionErrorDefault = __webpack_require__(162)();
                const loggingDefault = __webpack_require__(2)('Subscriber');
                const MuteButtonDefault = __webpack_require__(285)();
                const NamePanelDefault = __webpack_require__(286);
                const otErrorDefault = __webpack_require__(13)();
                const OTErrorClassDefault = __webpack_require__(22);
                const OTHelpersDefault = __webpack_require__(8);
                const StylableComponentDefault = __webpack_require__(151);
                const windowMock = __webpack_require__(142)(window);
                const PeerConnection = __webpack_require__(73)({
                    global: windowMock
                });
                const SubscriberPeerConnectionDefault = __webpack_require__(299)({
                    PeerConnection: PeerConnection
                });
                const SubscribingStateDefault = __webpack_require__(306);
                const VideoDisabledIndicatorDefault = __webpack_require__(672);
                const AudioBlockedIndicatorDefault = __webpack_require__(673);
                const VideoUnsupportedIndicatorDefault = __webpack_require__(674);
                const watchFrameRateDefault = __webpack_require__(675);
                const createSendMethodDefault = __webpack_require__(307);
                const parseIceServersDefault = __webpack_require__(101).parseIceServers;
                const overallTimeout = __webpack_require__(676);
                const createConnectivityState = __webpack_require__(677);
                const createConnectivityAttemptPinger = __webpack_require__(678);
                const isGetRtcStatsReportSupported = __webpack_require__(309);
                const getMediaModeBySourceStreamId = __webpack_require__(167);
                const DEFAULT_AUDIO_VOLUME = 100;
                const isLocalStream = (stream, session)=>stream.connection.id === session.connection.id;
                const constructSubscriberUri = (_ref)=>{
                    let apiKey = _ref.apiKey, sessionId = _ref.sessionId, streamId = _ref.streamId, subscriberId = _ref.subscriberId;
                    return [
                        '/v2/partner',
                        apiKey,
                        'session',
                        sessionId,
                        'stream',
                        streamId,
                        'subscriber',
                        subscriberId
                    ].join('/');
                };
                function normalizeAudioVolume(volume) {
                    return Math.max(0, Math.min(100, parseInt(volume, 10)));
                }
                function determineAudioVolume(props) {
                    if (props.audioVolume !== undefined) return props.audioVolume;
                    else if (props.subscribeToAudio === false) return 0;
                    return DEFAULT_AUDIO_VOLUME;
                }
                module1.exports = function SubscriberFactory(_temp) {
                    let _ref2 = _temp === void 0 ? {} : _temp, _ref2$AudioLevelMeter = _ref2.AudioLevelMeter, AudioLevelMeter = _ref2$AudioLevelMeter === void 0 ? AudioLevelMeterDefault : _ref2$AudioLevelMeter, _ref2$AudioLevelTrans = _ref2.AudioLevelTransformer, AudioLevelTransformer = _ref2$AudioLevelTrans === void 0 ? AudioLevelTransformerDefault : _ref2$AudioLevelTrans, _ref2$BackingBar = _ref2.BackingBar, BackingBar = _ref2$BackingBar === void 0 ? BackingBarDefault : _ref2$BackingBar, _ref2$Chrome = _ref2.Chrome, Chrome = _ref2$Chrome === void 0 ? ChromeDefault : _ref2$Chrome, _ref2$env = _ref2.env, env = _ref2$env === void 0 ? envDefault : _ref2$env, _ref2$Errors = _ref2.Errors, errors = _ref2$Errors === void 0 ? errorsDefault : _ref2$Errors, _ref2$Events = _ref2.Events, Events = _ref2$Events === void 0 ? EventsDefault : _ref2$Events, _ref2$ExceptionCodes = _ref2.ExceptionCodes, ExceptionCodes = _ref2$ExceptionCodes === void 0 ? ExceptionCodesDefault : _ref2$ExceptionCodes, _ref2$audioLevelSampl = _ref2.audioLevelSampler, audioLevelSampler = _ref2$audioLevelSampl === void 0 ? audioLevelSamplerDefault : _ref2$audioLevelSampl, _ref2$getStatsHelpers = _ref2.getStatsHelpers, getStatsHelpers = _ref2$getStatsHelpers === void 0 ? getStatsHelpersDefault : _ref2$getStatsHelpers, _ref2$hasAudioOutputL = _ref2.hasAudioOutputLevelStatCapability, hasAudioOutputLevelStatCapability = _ref2$hasAudioOutputL === void 0 ? hasAudioOutputLevelStatCapabilityDefault : _ref2$hasAudioOutputL, _ref2$hasRemoteStream = _ref2.hasRemoteStreamsWithWebAudio, hasRemoteStreamsWithWebAudio = _ref2$hasRemoteStream === void 0 ? hasRemoteStreamsWithWebAudioDefault : _ref2$hasRemoteStream, _ref2$interpretPeerCo = _ref2.interpretPeerConnectionError, interpretPeerConnectionError = _ref2$interpretPeerCo === void 0 ? interpretPeerConnectionErrorDefault : _ref2$interpretPeerCo, _ref2$logging = _ref2.logging, logging = _ref2$logging === void 0 ? loggingDefault : _ref2$logging, _ref2$MuteButton = _ref2.MuteButton, MuteButton = _ref2$MuteButton === void 0 ? MuteButtonDefault : _ref2$MuteButton, _ref2$NamePanel = _ref2.NamePanel, NamePanel = _ref2$NamePanel === void 0 ? NamePanelDefault : _ref2$NamePanel, _ref2$otError = _ref2.otError, otError = _ref2$otError === void 0 ? otErrorDefault : _ref2$otError, _ref2$OTErrorClass = _ref2.OTErrorClass, OTErrorClass = _ref2$OTErrorClass === void 0 ? OTErrorClassDefault : _ref2$OTErrorClass, _ref2$OTHelpers = _ref2.OTHelpers, OTHelpers = _ref2$OTHelpers === void 0 ? OTHelpersDefault : _ref2$OTHelpers, _ref2$StylableCompone = _ref2.StylableComponent, StylableComponent = _ref2$StylableCompone === void 0 ? StylableComponentDefault : _ref2$StylableCompone, _ref2$SubscriberPeerC = _ref2.SubscriberPeerConnection, SubscriberPeerConnection = _ref2$SubscriberPeerC === void 0 ? SubscriberPeerConnectionDefault : _ref2$SubscriberPeerC, _ref2$SubscribingStat = _ref2.SubscribingState, SubscribingState = _ref2$SubscribingStat === void 0 ? SubscribingStateDefault : _ref2$SubscribingStat, _ref2$VideoDisabledIn = _ref2.VideoDisabledIndicator, VideoDisabledIndicator = _ref2$VideoDisabledIn === void 0 ? VideoDisabledIndicatorDefault : _ref2$VideoDisabledIn, _ref2$AudioBlockedInd = _ref2.AudioBlockedIndicator, AudioBlockedIndicator = _ref2$AudioBlockedInd === void 0 ? AudioBlockedIndicatorDefault : _ref2$AudioBlockedInd, _ref2$VideoUnsupporte = _ref2.VideoUnsupportedIndicator, VideoUnsupportedIndicator = _ref2$VideoUnsupporte === void 0 ? VideoUnsupportedIndicatorDefault : _ref2$VideoUnsupporte, _ref2$watchFrameRate = _ref2.watchFrameRate, watchFrameRate = _ref2$watchFrameRate === void 0 ? watchFrameRateDefault : _ref2$watchFrameRate, _ref2$createSendMetho = _ref2.createSendMethod, createSendMethod = _ref2$createSendMetho === void 0 ? createSendMethodDefault : _ref2$createSendMetho, _ref2$parseIceServers = _ref2.parseIceServers, parseIceServers = _ref2$parseIceServers === void 0 ? parseIceServersDefault : _ref2$parseIceServers, _ref2$document = _ref2.document, document1 = _ref2$document === void 0 ? window.document : _ref2$document, _ref2$WidgetView = _ref2.WidgetView, WidgetView = _ref2$WidgetView === void 0 ? defaultWidgetView : _ref2$WidgetView;
                    const BIND_VIDEO_DELAY_MAX = 30000;
                    const BIND_VIDEO_DELAY_WARNING = 15000;
                    /**
   * The Subscriber object is a representation of the local video element that is playing back
   * a remote stream. The Subscriber object includes methods that let you disable and enable
   * local audio playback for the subscribed stream. The <code>subscribe()</code> method of the
   * {@link Session} object returns a Subscriber object.
   *
   * @property {Element} element The HTML DOM element containing the Subscriber.
   * @property {String} id The DOM ID of the Subscriber.
   * @property {Stream} stream The stream to which you are subscribing.
   *
   * @class Subscriber
   * @augments EventDispatcher
   */ const Subscriber = function Subscriber(targetElement, options, completionHandler) {
                        var _this = this;
                        if (options === void 0) options = {};
                        if (completionHandler === void 0) completionHandler = ()=>{};
                        if (options.analytics === undefined) // @todo does anyone instantiate a Subscriber outside of `session.subscribe`?
                        // it might be best to instantiate an analytics object and replace it on subscribe like
                        // we do in the publisher.
                        throw new Error('Subscriber requires an instance of analytics');
                        /** @type AnalyticsHelperDefault */ const analytics = options.analytics;
                        const _widgetId = uuid();
                        const _audioLevelCapable = Subscriber.hasAudioOutputLevelStatCapability() || hasRemoteStreamsWithWebAudio();
                        const _subscriber = this;
                        const _pcConnected = {};
                        const peerConnectionsAsync = {};
                        const webRTCStreams = {};
                        const hybridSessionTransitionStartTimes = {};
                        const _peerConnectionEvents = {};
                        /** @type {defaultWidgetView|null} */ let _widgetView;
                        let _chrome;
                        let _muteDisplayMode;
                        let _audioLevelMeter;
                        let _subscribeStartTime;
                        let _state;
                        let _audioLevelSampler;
                        let _audioLevelBehaviour;
                        let _webRTCStream;
                        let _videoEnabled;
                        let _lastSubscribeToVideoReason;
                        let _attemptStartTime;
                        /** @type IntervalRunnerDefault | undefined */ let _streamEventHandlers;
                        let _isSubscribingToAudio;
                        let _loaded = false;
                        let _domId = targetElement || _widgetId;
                        let _session = options.session;
                        let _stream = options.stream;
                        const _options = options, _singlePeerConnectionController = _options._singlePeerConnectionController;
                        let _shouldUseSpc;
                        let _mediaStream;
                        let _audioVolume;
                        let _latestPositiveVolume;
                        let _frameRateRestricted = false;
                        let _frameRateWatcher;
                        let _preDisconnectStats = {};
                        let _congestionLevel = null;
                        let _hasLoadedAtLeastOnce = false;
                        let _isVideoSupported = true;
                        let fallbackIceServers = [];
                        let _properties = defaults({}, options, {
                            showControls: true,
                            testNetwork: false,
                            fitMode: _stream.defaultFitMode || 'cover',
                            insertDefaultUI: true
                        });
                        let _activeSourceStreamId;
                        const _isAdaptiveEnabled = _session.sessionInfo.isAdaptiveEnabled;
                        const _lastConnectionStatesMap = {
                            P2P: eventNames.SUBSCRIBER_DISCONNECTED,
                            MANTIS: eventNames.SUBSCRIBER_DISCONNECTED
                        }; // The audio stats watcher is only supported on chromium-based browsers that supports
                        // the standard version of the getStats API.
                        const _supportsAudioStatsWatcher = env.name === 'Chrome' && env.version >= 58 || env.isChromiumEdge || env.isOpera;
                        const socket = _session._.getSocket();
                        const getAllPeerConnections = ()=>values(peerConnectionsAsync);
                        const getPeerConnectionBySourceStreamId = (sourceStreamId)=>peerConnectionsAsync[sourceStreamId];
                        const getCurrentPeerConnection = ()=>peerConnectionsAsync[_activeSourceStreamId];
                        const removePeerConnectionBySourceStreamId = /*#__PURE__*/ function() {
                            var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(sourceStreamId) {
                                var peerConnection;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            _context.next = 2;
                                            return peerConnectionsAsync[sourceStreamId];
                                        case 2:
                                            peerConnection = _context.sent;
                                            peerConnection.close();
                                            delete peerConnectionsAsync[sourceStreamId];
                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function removePeerConnectionBySourceStreamId(_x) {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        const removeWebRTCStream = (sourceStreamId)=>{
                            delete webRTCStreams[sourceStreamId];
                        };
                        const removeAllPeerConnections = ()=>{
                            // @todo check peer connection destroy triggers disconnect, and then gets logged...
                            getAllPeerConnections().forEach(/*#__PURE__*/ function() {
                                var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(peerConnection) {
                                    return _regenerator.default.wrap(function _callee2$(_context2) {
                                        while(true)switch(_context2.prev = _context2.next){
                                            case 0:
                                                _context2.next = 2;
                                                return peerConnection;
                                            case 2:
                                                _context2.sent.destroy();
                                            case 3:
                                            case "end":
                                                return _context2.stop();
                                        }
                                    }, _callee2);
                                }));
                                return function(_x2) {
                                    return _ref4.apply(this, arguments);
                                };
                            }());
                            Object.keys(peerConnectionsAsync).forEach((key)=>{
                                delete peerConnectionsAsync[key];
                            });
                        };
                        const bindWebRTCStream = /*#__PURE__*/ function() {
                            var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(webRTCStream) {
                                var videoContainerOptions, throwIfBufferFails;
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            if (webRTCStream) {
                                                _context3.next = 2;
                                                break;
                                            }
                                            return _context3.abrupt("return");
                                        case 2:
                                            videoContainerOptions = {
                                                error: onVideoError,
                                                audioVolume: _audioVolume
                                            }; // We want to catch any error in the prebuffering when transition to P2P.
                                            // Otherwise, we ignore it.
                                            throwIfBufferFails = _isAdaptiveEnabled && _activeSourceStreamId === 'P2P';
                                            _context3.prev = 4;
                                            _context3.next = 7;
                                            return _widgetView.bindVideo(webRTCStream, videoContainerOptions, throwIfBufferFails);
                                        case 7:
                                            _context3.next = 18;
                                            break;
                                        case 9:
                                            _context3.prev = 9;
                                            _context3.t0 = _context3["catch"](4);
                                            if (!(_context3.t0 instanceof CancellationError || _state.isDestroyed())) {
                                                _context3.next = 13;
                                                break;
                                            }
                                            return _context3.abrupt("return");
                                        case 13:
                                            if (!_context3.t0.message.includes('bufferFailed')) {
                                                _context3.next = 16;
                                                break;
                                            }
                                            // We only cancel the bind for the P2P leg in AMR when no video is playing from its
                                            // stream, thus we transition back to Mantis.
                                            _this._.startRelayedToRoutedTransition();
                                            return _context3.abrupt("return");
                                        case 16:
                                            onVideoError(_context3.t0);
                                            throw _context3.t0;
                                        case 18:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, null, [
                                    [
                                        4,
                                        9
                                    ]
                                ]);
                            }));
                            return function bindWebRTCStream(_x3) {
                                return _ref5.apply(this, arguments);
                            };
                        }();
                        const _getStatsWrapper = /*#__PURE__*/ function() {
                            var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(reportType, callback) {
                                var isRtcStatsReport, errorCode, pc, getStats;
                                return _regenerator.default.wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            isRtcStatsReport = false;
                                            if (typeof reportType === 'function') /* eslint-disable-next-line no-param-reassign */ callback = reportType;
                                            else isRtcStatsReport = reportType === 'rtcStatsReport';
                                            if (isRtcStatsReport) notifyGetRtcStatsReportCalled();
                                            else notifyGetStatsCalled();
                                            if (!(isRtcStatsReport && !isGetRtcStatsReportSupported)) {
                                                _context4.next = 7;
                                                break;
                                            }
                                            errorCode = ExceptionCodes.GET_RTC_STATS_REPORT_NOT_SUPPORTED;
                                            callback(otError(Errors.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
                                            return _context4.abrupt("return");
                                        case 7:
                                            if (getCurrentPeerConnection()) {
                                                _context4.next = 11;
                                                break;
                                            }
                                            errorCode = ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED;
                                            callback(otError(errors.PEER_CONNECTION_NOT_CONNECTED, new Error(OTErrorClass.getTitleByCode(errorCode)), errorCode));
                                            return _context4.abrupt("return");
                                        case 11:
                                            _context4.next = 13;
                                            return getCurrentPeerConnection();
                                        case 13:
                                            pc = _context4.sent;
                                            getStats = isRtcStatsReport ? pc.getRtcStatsReport : pc.getStats;
                                            getStats((error, stats)=>{
                                                if (error) {
                                                    if (error.code === ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED) error = otError(errors.PEER_CONNECTION_NOT_CONNECTED, error, ExceptionCodes.PEER_CONNECTION_NOT_CONNECTED);
                                                    callback(error);
                                                } else callback(null, stats);
                                            });
                                        case 16:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4);
                            }));
                            return function _getStatsWrapper(_x4, _x5) {
                                return _ref6.apply(this, arguments);
                            };
                        }();
                        const _getStats = (callback)=>_getStatsWrapper(callback);
                        const _getRtcStatsReport = (callback)=>_getStatsWrapper('rtcStatsReport', callback);
                        const _streamHasTracks = (kind)=>{
                            if (!_webRTCStream || !_mediaStream) return false;
                            if (kind === 'video') return _webRTCStream.getVideoTracks().length > 0 && _mediaStream.getVideoTracks().length > 0;
                            return _webRTCStream.getAudioTracks().length > 0 && _mediaStream.getAudioTracks().length > 0;
                        };
                        const logAnalyticsEvent = (action, variation, payload, options, throttle)=>{
                            let stats = assign({
                                action: action,
                                variation: variation,
                                payload: payload,
                                streamId: _stream ? _stream.id : null,
                                sessionId: _session ? _session.sessionId : null,
                                connectionId: _session && _session.isConnected() ? _session.connection.connectionId : null,
                                partnerId: _session && _session.sessionInfo ? _session.sessionInfo.partnerId : null,
                                subscriberId: _widgetId,
                                widgetType: 'Subscriber'
                            }, options);
                            if (variation === 'Failure' || variation === 'iceconnectionstatechange' && payload === 'closed') stats = assign(stats, _preDisconnectStats);
                            const args = [
                                stats
                            ];
                            if (throttle) args.push(throttle);
                            analytics.logEvent(...args);
                        };
                        const logHybridSessionTransition = (action, variation, payload)=>{
                            if (variation === 'Attempt') {
                                hybridSessionTransitionStartTimes[action] = new Date().getTime();
                                logAnalyticsEvent(action, variation, payload);
                            } else if (variation === 'Failure' || variation === 'Success') logAnalyticsEvent(action, variation, payload, {
                                attemptDuration: new Date().getTime() - hybridSessionTransitionStartTimes[action]
                            });
                        };
                        const logRoutedToRelayedTransition = function logRoutedToRelayedTransition(variation, payload) {
                            if (payload === void 0) payload = {};
                            logHybridSessionTransition('RoutedToRelayedTransition', variation, payload);
                        };
                        const logRelayedToRoutedTransition = function logRelayedToRoutedTransition(variation, payload) {
                            if (payload === void 0) payload = {};
                            logHybridSessionTransition('RelayedToRoutedTransition', variation, payload);
                        };
                        const connectivityState = createConnectivityState({
                            onInvalidTransition (transition, from) {
                                const err = `Invalid state transition: Event '${transition}' not possible in state '${from}'`;
                                logging.error(err);
                                logAnalyticsEvent('Subscriber:InvalidStateTransition', 'Event', {
                                    details: err
                                });
                            }
                        });
                        {
                            const errMessage = 'Unable to subscribe to stream in a reasonable amount of time'; // make sure we trigger an error if we are not getting any "data" after a reasonable
                            // amount of time
                            overallTimeout({
                                connectivityState: connectivityState,
                                onWarning () {
                                    logConnectivityEvent('Warning', {});
                                },
                                onTimeout: ()=>{
                                    if (_widgetView) _widgetView.addError(errMessage);
                                    if (_state.isAttemptingToSubscribe()) {
                                        _state.set('Failed');
                                        this._disconnect({
                                            noStateTransition: true
                                        });
                                        const error = otError(Errors.TIMEOUT, new Error(errMessage), ExceptionCodes.UNABLE_TO_SUBSCRIBE);
                                        connectivityState.fail({
                                            options: {
                                                failureReason: 'Subscribe',
                                                failureMessage: errMessage,
                                                failureCode: ExceptionCodes.UNABLE_TO_SUBSCRIBE
                                            },
                                            error: error
                                        });
                                    }
                                },
                                warningMs: BIND_VIDEO_DELAY_WARNING,
                                timeoutMs: BIND_VIDEO_DELAY_MAX
                            });
                        }
                        _pcConnected.promise = new Promise((resolve, reject)=>{
                            _pcConnected.resolve = resolve;
                            _pcConnected.reject = reject;
                        });
                        if (_properties.testNetwork && _session.sessionInfo.p2pEnabled) logging.warn('You cannot test your network with a relayed session. Use a routed session.');
                        this.id = _domId;
                        this.widgetId = _widgetId;
                        this.session = _session;
                        this.stream = _properties.stream;
                        _stream = _properties.stream;
                        this.streamId = _stream.id;
                        if (!_session) {
                            OTErrorClass.handleJsException({
                                errorMsg: 'OT.Subscriber must be passed a session option',
                                code: 2000,
                                target: this,
                                analytics: analytics
                            });
                            return null;
                        }
                        eventing(this);
                        _subscriber.once('subscribeComplete', function() {
                            try {
                                completionHandler(...arguments);
                            } catch (err) {
                                logging.error('Completion handler threw an exception', err);
                            }
                        });
                        _session.on('captionReceived', (event)=>{
                            if (event.streamId === _subscriber.streamId) {
                                this.dispatchEvent(event);
                                this.trigger(eventNames.SUBSCRIBER_CAPTION_RECEIVED, event);
                            }
                        });
                        const getVariationFromState = (_ref7)=>{
                            let transition = _ref7.transition, from = _ref7.from;
                            if (transition === 'fail') {
                                if (from === 'connected') return 'Disconnect';
                                return 'Failure';
                            }
                            if (transition === 'disconnect' && from === 'connected') return 'Disconnect';
                            return 'Cancel';
                        };
                        connectivityState.observe({
                            onEnterConnecting () {
                                logConnectivityEvent('Attempt', null, {});
                            },
                            onEnterConnected () {
                                logConnectivityEvent('Success', null, {});
                            },
                            onEnterDisconnected (state, _temp2) {
                                let _ref8 = _temp2 === void 0 ? {} : _temp2, _ref8$options = _ref8.options, options = _ref8$options === void 0 ? {} : _ref8$options, _ref8$payload = _ref8.payload, payload = _ref8$payload === void 0 ? null : _ref8$payload;
                                logConnectivityEvent(getVariationFromState(state), payload, options);
                            }
                        });
                        connectivityState.observe({
                            onEnterConnected: ()=>{
                                this.trigger('subscribeComplete', undefined, this);
                            },
                            onEnterDisconnected: function onEnterDisconnected(_ref9, _temp3) {
                                let from = _ref9.from;
                                let _ref10 = _temp3 === void 0 ? {} : _temp3, error = _ref10.error;
                                if (from === 'connecting') _this.trigger('subscribeComplete', error || new Error('An unknown error occurred'), _this);
                            }
                        });
                        createConnectivityAttemptPinger({
                            connectivityState: connectivityState,
                            logAttempt () {
                                logAnalyticsEvent('Subscribe', 'Attempting', null, {
                                    connectionId: _session && _session.isConnected() ? _session.connection.connectionId : null
                                });
                            }
                        });
                        const logConnectivityEvent = (variation, payload, options)=>{
                            if (variation === 'Attempt') _attemptStartTime = new Date().getTime();
                            if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') logAnalyticsEvent('Subscribe', variation, payload, (0, _extends2.default)({}, options, {
                                attemptDuration: new Date().getTime() - _attemptStartTime
                            }));
                            else logAnalyticsEvent('Subscribe', variation, payload, options);
                        };
                        const logResubscribe = (variation, payload)=>{
                            logAnalyticsEvent('ICERestart', variation, payload);
                        };
                        const recordQOS = (_ref11)=>{
                            var _properties$preferred, _properties$preferred2;
                            let parsedStats = _ref11.parsedStats, remoteConnectionId = _ref11.remoteConnectionId, peerId = _ref11.peerId, sourceStreamId = _ref11.sourceStreamId;
                            const QoSBlob = {
                                widgetType: 'Subscriber',
                                width: _widgetView.width,
                                height: _widgetView.height,
                                audioTrack: _streamHasTracks('audio'),
                                hasAudio: _stream && _stream.hasAudio,
                                subscribeToAudio: _isSubscribingToAudio,
                                audioVolume: this.getAudioVolume(),
                                videoTrack: _streamHasTracks('video'),
                                connectionId: _session ? _session.connection.connectionId : null,
                                hasVideo: _stream && _stream.hasVideo,
                                subscribeToVideo: _properties.subscribeToVideo,
                                congestionLevel: _congestionLevel,
                                streamId: _stream.id,
                                subscriberId: _widgetId,
                                duration: Math.round((now() - _subscribeStartTime) / 1000),
                                remoteConnectionId: remoteConnectionId,
                                peerId: peerId,
                                sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId),
                                preferredResolutionHeight: (_properties$preferred = _properties.preferredResolution) == null ? void 0 : _properties$preferred.height,
                                preferredResolutionWidth: (_properties$preferred2 = _properties.preferredResolution) == null ? void 0 : _properties$preferred2.width,
                                preferredFrameRate: _properties.preferredFrameRate,
                                audioFallback: !_videoEnabled && _lastSubscribeToVideoReason === 'auto'
                            };
                            const combinedStats = assign(QoSBlob, parsedStats);
                            analytics.logQOS(combinedStats);
                            this.trigger('qos', (0, _extends2.default)({}, analytics.commonQoSFields(), combinedStats));
                        };
                        const stateChangeFailed = (changeFailed)=>{
                            logging.error('OT.Subscriber State Change Failed: ', changeFailed.message);
                            logging.debug(changeFailed);
                        };
                        const onLoaded = ()=>{
                            if (_state.isSubscribing() || !_widgetView || !_widgetView.video()) return;
                            _loaded = true;
                            if (!_hasLoadedAtLeastOnce) {
                                connectivityState.connect();
                                _hasLoadedAtLeastOnce = true;
                            }
                            logging.debug('OT.Subscriber.onLoaded');
                            _state.set('Subscribing');
                            _subscribeStartTime = now();
                            _widgetView.loading(false);
                            if (_chrome) _chrome.showAfterLoading();
                            if (_frameRateRestricted) _stream.setRestrictFrameRate(true);
                            if (_audioLevelMeter) _audioLevelMeter.audioOnly(_widgetView.audioOnly());
                            this.setAudioVolume(_audioVolume);
                            this.trigger('loaded', this);
                        };
                        const isAudioOn = ()=>_stream && _stream.hasAudio && _isSubscribingToAudio && this.getAudioVolume() > 0 && !this.isAudioBlocked();
                        const isVideoOn = ()=>_stream && _stream.hasVideo;
                        const onAudioLevelStuckWarning = (reason)=>{
                            // `audioLevelStuckAt0` warning will be ignored either because the video is ON or audio is OFF
                            const shouldIgnoreWarning = reason === 'audioLevelStuckAt0' && (!isAudioOn() || isVideoOn());
                            let disableAudioLevelStuckAt0 = false;
                            if (!shouldIgnoreWarning) {
                                logAnalyticsEvent('subscriber:onAudioWarning', 'Event', {
                                    reason: reason
                                });
                                if (_widgetView) {
                                    _widgetView.rebindSrcObject();
                                    logAnalyticsEvent('subscriber:rebindSrcObject', 'Called');
                                    if (reason === 'audioLevelStuck') // Since 'audioLevelStuck' anomally was detected and the rebind already happened,
                                    // we don't need to do future rebinds. We can do a return here so that the watcher
                                    // is not restarted.
                                    return;
                                     // This is to ignore future warnings of this type in order to prevent
                                    // periodical rebindings.
                                    disableAudioLevelStuckAt0 = true;
                                }
                            }
                            startAudioStatsWatcher(disableAudioLevelStuckAt0);
                        };
                        const startAudioStatsWatcher = /*#__PURE__*/ function() {
                            var _ref12 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5(disableAudioLevelStuckAt0) {
                                var peerConnection;
                                return _regenerator.default.wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            if (disableAudioLevelStuckAt0 === void 0) disableAudioLevelStuckAt0 = false;
                                            if (!_supportsAudioStatsWatcher) {
                                                _context5.next = 6;
                                                break;
                                            }
                                            _context5.next = 4;
                                            return getCurrentPeerConnection();
                                        case 4:
                                            peerConnection = _context5.sent;
                                            peerConnection.startAudioStatsWatcher(disableAudioLevelStuckAt0);
                                        case 6:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5);
                            }));
                            return function startAudioStatsWatcher(_x6) {
                                return _ref12.apply(this, arguments);
                            };
                        }();
                        const onPeerConnected = (peerConnection)=>{
                            const isAdaptiveP2pSourceStreamId = _isAdaptiveEnabled && peerConnection.getSourceStreamId() === 'P2P';
                            if (isAdaptiveP2pSourceStreamId) logRoutedToRelayedTransition('Success');
                        };
                        const onPeerDisconnected = ()=>{
                            logging.debug('OT.Subscriber has been disconnected from the Publisher\'s PeerConnection');
                            connectivityState.fail({
                                options: {
                                    failureReason: 'PeerConnectionError',
                                    failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
                                    failureMessage: 'PeerConnection disconnected'
                                },
                                error: otError(errors.DISCONNECTED, new Error('ClientDisconnected'))
                            });
                            this._disconnect({
                                noStateTransition: true
                            });
                            if (_state.isAttemptingToSubscribe() || _state.isSubscribing()) _state.set('Failed');
                        };
                        const onVideoError = (plainErr)=>{
                            const err = otError(errors.MEDIA_ERR_DECODE, plainErr, plainErr.code || ExceptionCodes.P2P_CONNECTION_FAILED);
                            err.message = `OT.Subscriber while playing stream: ${err.message}`;
                            logging.error('OT.Subscriber.onVideoError');
                            connectivityState.fail({
                                options: {
                                    failureReason: 'VideoElement',
                                    failureMessage: err.message,
                                    failureCode: err.code || ExceptionCodes.P2P_CONNECTION_FAILED
                                },
                                error: err
                            });
                            const isAttemptingToSubscribe = _state.isAttemptingToSubscribe();
                            _state.set('Failed');
                            if (!isAttemptingToSubscribe) // FIXME: This emits a string instead of an error here for backwards compatibility despite
                            // being undocumented. When possible we should remove access to this and other undocumented
                            // events, and restore emitting actual errors here.
                            _subscriber.trigger('error', err.message);
                            OTErrorClass.handleJsException({
                                error: err,
                                code: ExceptionCodes.UNABLE_TO_SUBSCRIBE,
                                // @todo why do we override the code?
                                target: _subscriber,
                                analytics: analytics
                            });
                        };
                        const onSubscriberCreateError = (rawError)=>{
                            // @todo v3 These errors used to come from the peer connection hence the mention
                            // of peer connection in the logs/ errors. However they actually have nothing to do
                            // with the peer connection. I have chosen to keep the messages / errors the same for
                            // now, but we should consider changing them
                            const err = interpretSubscriberCreateError(rawError);
                            OTErrorClass.handleJsException({
                                error: err,
                                code: err.code,
                                target: _subscriber,
                                analytics: analytics
                            });
                            this._disconnect({
                                noStateTransition: true
                            });
                            const options = {
                                failureReason: 'Subscribe',
                                failureMessage: `OT.Subscriber PeerConnection Error: ${err.message}`,
                                failureCode: ExceptionCodes.P2P_CONNECTION_FAILED
                            };
                            _showError(err.code, err.message);
                            connectivityState.fail({
                                options: options,
                                error: otError(err.name, new Error('Subscribe: Subscriber PeerConnection with connection (not found) ' + `failed: ${err.message}`), err.code)
                            });
                            if (err.name === Errors.STREAM_NOT_FOUND) // Usually, the subscriber should be kept in an error state when the peer connection fails
                            // because it still exists in the session. But when we get a 404 that means it doesn't
                            // exist, even if the session still thinks it does.
                            this._destroy({
                                reason: 'streamNotFound',
                                noStateTransition: true
                            });
                        };
                        const onPeerConnectionFailure = (code, reason, peerConnection, prefix)=>{
                            if (prefix === 'SetRemoteDescription' && !_isVideoSupported && reason.match(/Unsupported video without audio for fallback/)) {
                                if (_widgetView) _widgetView.addError('The stream is unable to be played.', 'Your browser does not support the video format.');
                                let err;
                                if (OTHelpers.env.name === 'Safari') err = new Error("VP8 is not supported in this version of Safari. You might want to consider switching to an H264 project. See https://tokbox.com/safari for more information.");
                                else err = new Error('Video format not supported in this browser.');
                                err.code = ExceptionCodes.UNSUPPORTED_VIDEO_CODEC;
                                onVideoError(err);
                                return;
                            }
                            if (prefix === 'ICEWorkflow' && _session.sessionInfo.reconnection && _loaded) {
                                logging.debug('Ignoring peer connection failure due to possibility of reconnection.');
                                return;
                            }
                            let errorCode;
                            if (prefix === 'ICEWorkflow') errorCode = ExceptionCodes.SUBSCRIBER_ICE_WORKFLOW_FAILED;
                            else if (code === ExceptionCodes.STREAM_LIMIT_EXCEEDED) errorCode = code;
                            else errorCode = ExceptionCodes.P2P_CONNECTION_FAILED;
                            const options = {
                                failureReason: prefix || 'PeerConnectionError',
                                failureMessage: `OT.Subscriber PeerConnection Error: ${reason}`,
                                failureCode: errorCode
                            };
                            const error = interpretPeerConnectionError(code, reason, prefix, '(not found)', 'Subscriber');
                            connectivityState.fail({
                                options: options,
                                error: error
                            });
                            if (_state.isAttemptingToSubscribe()) {
                                // We weren't subscribing yet so this was a failure in setting
                                // up the PeerConnection or receiving the initial stream.
                                const payload = {
                                    hasRelayCandidates: peerConnection && peerConnection.hasRelayCandidates()
                                };
                                logAnalyticsEvent('createPeerConnection', 'Failure', payload, options);
                                _state.set('Failed');
                            } else if (_state.isSubscribing()) {
                                // we were disconnected after we were already subscribing
                                _state.set('Failed');
                                this.trigger('error', reason);
                            }
                            this._disconnect({
                                noStateTransition: true
                            });
                            if (Number(code) === 404) // Usually, the subscriber should be kept in an error state when the peer connection fails
                            // because it still exists in the session. But when we get a 404 that means it doesn't
                            // exist, even if the session still thinks it does.
                            this._destroy({
                                noStateTransition: true
                            });
                            OTErrorClass.handleJsException({
                                error: error,
                                errorMsg: `OT.Subscriber PeerConnection Error: ${reason}`,
                                code: errorCode,
                                target: this,
                                analytics: analytics
                            });
                            _showError(code);
                        };
                        const hasExpectedTracks = (peerConnection)=>{
                            const hasVideoTracks = peerConnection._hasVideoTracks();
                            const hasAudioTracks = peerConnection._hasAudioTracks();
                            const isMissingVideo = _stream && _stream.hasVideo && !hasVideoTracks;
                            const isMissingAudio = _stream && _stream.hasAudio && !hasAudioTracks;
                            return !(isMissingVideo || isMissingAudio);
                        };
                        const onTrackAdded = /*#__PURE__*/ function() {
                            var _ref13 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee6(webRTCStream, peerConnection) {
                                return _regenerator.default.wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            _context6.prev = 0;
                                            _context6.next = 3;
                                            return waitUntil(()=>hasExpectedTracks(peerConnection));
                                        case 3:
                                            _context6.next = 12;
                                            break;
                                        case 5:
                                            _context6.prev = 5;
                                            _context6.t0 = _context6["catch"](0);
                                            if (!(_context6.t0.message === 'TIMEOUT')) {
                                                _context6.next = 11;
                                                break;
                                            }
                                            // If it timeouts, let's log the error but no throw. This will allow us to be more fault
                                            // tolerant when video fails, e.g. video codecs incompatibility or any other reason.
                                            logging.error('The expected tracks never arrived');
                                            _context6.next = 12;
                                            break;
                                        case 11:
                                            throw _context6.t0;
                                        case 12:
                                            _context6.next = 14;
                                            return onRemoteStreamAdded(webRTCStream.stream, peerConnection);
                                        case 14:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, null, [
                                    [
                                        0,
                                        5
                                    ]
                                ]);
                            }));
                            return function onTrackAdded(_x7, _x8) {
                                return _ref13.apply(this, arguments);
                            };
                        }();
                        const onRemoteStreamAdded = /*#__PURE__*/ function() {
                            var _ref14 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee7(webRTCStream, peerConnection) {
                                var isSwappingStreams, sourceStreamId, _session2, sessionInfo, video, videoIndicator, videoElementCreated, env;
                                return _regenerator.default.wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _mediaStream = webRTCStream;
                                            if (_shouldUseSpc) // We create a new Stream locally, since webRTCStream contains all the tracks for the
                                            // session.
                                            _mediaStream = new MediaStream(peerConnection._getTracks());
                                            isSwappingStreams = Object.keys(webRTCStreams).length === 1;
                                            sourceStreamId = peerConnection == null ? void 0 : peerConnection.getSourceStreamId();
                                            _session2 = _session, sessionInfo = _session2.sessionInfo;
                                            _webRTCStream = webRTCStream; // save a copy of the WebRTCStream
                                            if (sourceStreamId) webRTCStreams[sourceStreamId] = webRTCStream;
                                            logging.debug('OT.Subscriber.onRemoteStreamAdded with sourceStreamId', sourceStreamId);
                                            _state.set('BindingRemoteStream'); // Disable the audio/video, if needed
                                            _this.subscribeToAudio(_isSubscribingToAudio);
                                            _lastSubscribeToVideoReason = 'loading';
                                            _this.subscribeToVideo(_properties.subscribeToVideo, 'loading'); // setting resolution and frame rate doesn't work in P2P
                                            if (!sessionInfo.p2pEnabled && sourceStreamId !== 'P2P') {
                                                _this.setPreferredResolution(_properties.preferredResolution);
                                                _this.setPreferredFrameRate(_properties.preferredFrameRate);
                                            } // This is a workaround for a bug in Chrome where a track disabled on
                                            // the remote end doesn't fire loadedmetadata causing the subscriber to timeout
                                            // https://jira.tokbox.com/browse/OPENTOK-15605
                                            // Also https://jira.tokbox.com/browse/OPENTOK-16425
                                            // Also https://jira.vonage.com/browse/OPENTOK-27112
                                            if (peerConnection) // No peer connection if subscribingToSelf
                                            peerConnection._getVideoTracks().forEach((track)=>{
                                                if (window.webkitMediaStream) track.enabled = false;
                                                else track.enabled = _stream.hasVideo && _properties.subscribeToVideo;
                                            });
                                             // Binding the new stream with only its respective tracks
                                            _context7.next = 16;
                                            return bindWebRTCStream(_mediaStream);
                                        case 16:
                                            startAudioStatsWatcher();
                                            if (!_state.isDestroyed()) {
                                                _context7.next = 19;
                                                break;
                                            }
                                            throw new Error('Subscriber destroyed');
                                        case 19:
                                            if (peerConnection && window.webkitMediaStream) // Enable any video streams that we previously disabled for OPENTOK-27112
                                            peerConnection._getVideoTracks().forEach((track)=>{
                                                track.enabled = _stream.hasVideo && _properties.subscribeToVideo;
                                            });
                                            video = _widgetView && _widgetView.video();
                                            if (video) video.orientation({
                                                width: _stream.videoDimensions.width,
                                                height: _stream.videoDimensions.height,
                                                videoOrientation: _stream.videoDimensions.orientation
                                            });
                                            videoIndicator = _chrome && _chrome.videoUnsupportedIndicator;
                                            if (videoIndicator) videoIndicator.setVideoUnsupported(!_isVideoSupported);
                                            videoElementCreated = new Promise((resolve, reject)=>{
                                                const video = _widgetView && _widgetView.video();
                                                if (video && video.domElement()) {
                                                    resolve();
                                                    return;
                                                }
                                                _widgetView.once('videoElementCreated', resolve);
                                                _subscriber.once('destroyed', reject);
                                            });
                                            _context7.next = 27;
                                            return videoElementCreated;
                                        case 27:
                                            _context7.next = 29;
                                            return _pcConnected.promise;
                                        case 29:
                                            if (!isSwappingStreams) onLoaded();
                                            else _state.set('Subscribing');
                                             // if the audioLevelSampler implementation requires a stream we need to set it now
                                            if (_audioLevelSampler && 'webRTCStream' in _audioLevelSampler && peerConnection._hasAudioTracks()) _audioLevelSampler.webRTCStream(webRTCStream);
                                            /**
               * We need frame rate watcher in Safari because framesPerSecond is
               * always zero so we need to rely on calculating the difference of
               * framesDecoded across multiple getStats invocations.
               * See https://bugs.webkit.org/show_bug.cgi?id=172682
               * In addition, we need to calculate it in Chrome v58+ and chromium based browsers
               * since framesPerSecond is not implemented in the standard getStats API.
               * In the case of Firefox 96+, the field 'frameRateMean' was removed so we need
               * to use the frame watchet to get the frameRate.
               */ env = OTHelpers.env;
                                            if (env.isSafari || env.isChromiumEdge || env.isOpera || env.name === 'Chrome' && env.version >= 58 || env.isFirefox && env.version >= 96) {
                                                if (_frameRateWatcher) {
                                                    _frameRateWatcher.destroy();
                                                    _frameRateWatcher = null;
                                                }
                                                if (peerConnection) _frameRateWatcher = watchFrameRate(peerConnection.getStats.bind(peerConnection));
                                            } // @todo We should revisit this event that is not public and seems to be not used anywhere.
                                            // Just to maintain the previous behavior, we'll avoid triggering twice in adaptive sessions.
                                            if (!isSwappingStreams) _this.trigger('streamAdded', _this);
                                        case 34:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7);
                            }));
                            return function onRemoteStreamAdded(_x9, _x10) {
                                return _ref14.apply(this, arguments);
                            };
                        }();
                        const onRemoteStreamRemoved = (webRTCStream)=>{
                            logging.debug('OT.Subscriber.onStreamRemoved');
                            const video = _widgetView && _widgetView.video();
                            if (video && video.stream === webRTCStream) _widgetView.destroyVideo();
                            removeWebRTCStream(_activeSourceStreamId);
                            _mediaStream = null;
                            this.trigger('streamRemoved', this);
                        };
                        const onRemoteVideoSupported = (supported)=>{
                            // as _isVideoSupported is true by default, this will only ever be hit if we receive
                            // a onRemoteVideoSupported false, and then a onRemoteVideoSupported true. In other words
                            // it will not trigger an event if video is enabled and is never disabled due to codec issues.
                            if (_isVideoSupported !== supported) this.dispatchEvent(new Events.VideoEnabledChangedEvent(supported ? 'videoEnabled' : 'videoDisabled', {
                                reason: supported ? 'codecChanged' : 'codecNotSupported'
                            }));
                            _isVideoSupported = supported;
                        };
                        const audioBlockedStateChange = (value)=>{
                            _widgetView.setAudioBlockedUi(value);
                            const indicator = _chrome && _chrome.audioBlockedIndicator;
                            if (indicator) indicator.setAudioBlocked(value);
                            const videoIndicator = _chrome && _chrome.videoUnsupportedIndicator;
                            if (videoIndicator) videoIndicator.setVideoUnsupported(!value && !_isVideoSupported);
                        };
                        this.on('audioBlocked', ()=>{
                            audioBlockedStateChange(true);
                        });
                        this.on('audioUnblocked', ()=>{
                            audioBlockedStateChange(false);
                        });
                        const connectionStateMap = {
                            new: eventNames.SUBSCRIBER_DISCONNECTED,
                            checking: eventNames.SUBSCRIBER_DISCONNECTED,
                            connected: eventNames.SUBSCRIBER_CONNECTED,
                            completed: eventNames.SUBSCRIBER_CONNECTED,
                            disconnected: eventNames.SUBSCRIBER_DISCONNECTED
                        };
                        const onIceConnectionStateChange = (state, peerConnection)=>{
                            const currentConnectionState = connectionStateMap[state];
                            const sourceStreamId = peerConnection.getSourceStreamId();
                            const lastConnectionState = _lastConnectionStatesMap[sourceStreamId]; // check if the last mapped state changed
                            const isConnectionStateChanged = currentConnectionState && currentConnectionState !== lastConnectionState;
                            if (isConnectionStateChanged) {
                                _lastConnectionStatesMap[sourceStreamId] = currentConnectionState;
                                if (state === 'disconnected' && sourceStreamId !== 'P2P') // This block of code initiates an iceRestart when a peer connection is disconnected
                                // and the socket is still connected.
                                setTimeout(/*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee8() {
                                    var isSocketReconnecting;
                                    return _regenerator.default.wrap(function _callee8$(_context8) {
                                        while(true)switch(_context8.prev = _context8.next){
                                            case 0:
                                                isSocketReconnecting = _session._.isSocketReconnecting;
                                                if (!(_lastConnectionStatesMap[sourceStreamId] === 'disconnected' && socket.is('connected') && !isSocketReconnecting())) {
                                                    _context8.next = 4;
                                                    break;
                                                }
                                                _context8.next = 4;
                                                return _this._.iceRestart('peer connection disconnected');
                                            case 4:
                                            case "end":
                                                return _context8.stop();
                                        }
                                    }, _callee8);
                                })), 2000);
                                if (_widgetView) _widgetView.loading(currentConnectionState !== eventNames.SUBSCRIBER_CONNECTED);
                                logging.debug(`OT.Subscriber.connectionStateChanged to ${state}`);
                                this.dispatchEvent(new Events.ConnectionStateChangedEvent(currentConnectionState, this));
                            }
                        };
                        const onIceRestartSuccess = ()=>{
                            logResubscribe('Success');
                        };
                        const onIceRestartFailure = ()=>{
                            logResubscribe('Failure', {
                                reason: 'ICEWorkflow',
                                message: "OT.Subscriber PeerConnection Error: The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall."
                            });
                        };
                        const streamUpdated = (event)=>{
                            const video = _widgetView && _widgetView.video();
                            switch(event.changedProperty){
                                case 'videoDimensions':
                                    if (!video) break;
                                    video.orientation({
                                        width: event.newValue.width,
                                        height: event.newValue.height,
                                        videoOrientation: event.newValue.orientation
                                    });
                                    this.dispatchEvent(new Events.VideoDimensionsChangedEvent(this, event.oldValue, event.newValue));
                                    break;
                                case 'videoDisableWarning':
                                    if (_chrome) _chrome.videoDisabledIndicator.setWarning(event.newValue);
                                    this.dispatchEvent(new Events.VideoDisableWarningEvent(event.newValue ? 'videoDisableWarning' : 'videoDisableWarningLifted'));
                                    _congestionLevel = event.newValue === 'videoDisableWarning' ? 1 : null;
                                    break;
                                case 'hasVideo':
                                    // @todo setAudioOnly affects peer connections, what happens with new ones?
                                    setAudioOnly(!_stream.hasVideo || !_properties.subscribeToVideo); // Makes sure that the audio workaround for Safari is executed.
                                    if (env.isSafari && !_stream.hasVideo && _widgetView) _widgetView.bindAudioTrackOnly();
                                    this.dispatchEvent(new Events.VideoEnabledChangedEvent(_stream.hasVideo ? 'videoEnabled' : 'videoDisabled', {
                                        reason: 'publishVideo'
                                    }));
                                    break;
                                case 'hasAudio':
                                    _muteDisplayMode.update();
                                    break;
                                default:
                            }
                        }; // Use _stream.getChannelsOfType instead of _webRTCStream.getAudioTracks
                        // because its available as soon as Subscriber is instantiated.
                        const _hasAudioTracks = ()=>_stream.getChannelsOfType('audio').length > 0; // / Chrome
                        _muteDisplayMode = {
                            get () {
                                // Use buttonDisplayMode if we have an audio track, even if its muted
                                return _hasAudioTracks() ? _subscriber.getStyle('buttonDisplayMode') : 'off';
                            },
                            update () {
                                const mode = _muteDisplayMode.get();
                                if (_chrome) {
                                    _chrome.muteButton.setDisplayMode(mode);
                                    _chrome.backingBar.setMuteMode(mode);
                                }
                            }
                        };
                        const updateChromeForStyleChange = (key, value)=>{
                            if (!_chrome) return;
                            switch(key){
                                case 'nameDisplayMode':
                                    _chrome.name.setDisplayMode(value);
                                    _chrome.backingBar.setNameMode(value);
                                    break;
                                case 'videoUnsupportedDisplayMode':
                                    _chrome.videoUnsupportedIndicator.setDisplayMode(value);
                                    break;
                                case 'videoDisabledDisplayMode':
                                    _chrome.videoDisabledIndicator.setDisplayMode(value);
                                    break;
                                case 'audioBlockedDisplayMode':
                                    _chrome.audioBlockedIndicator.setDisplayMode(value);
                                    break;
                                case 'showArchiveStatus':
                                    _chrome.archive.setShowArchiveStatus(value);
                                    break;
                                case 'buttonDisplayMode':
                                    _muteDisplayMode.update();
                                    break;
                                case 'audioLevelDisplayMode':
                                    _chrome.audioLevel.setDisplayMode(value);
                                    break;
                                case 'bugDisplayMode':
                                    break;
                                case 'backgroundImageURI':
                                    _widgetView.setBackgroundImageURI(value);
                                    break;
                                default:
                            }
                        };
                        const _createChrome = ()=>{
                            const widgets = {
                                backingBar: new BackingBar({
                                    nameMode: !_properties.name ? 'off' : this.getStyle('nameDisplayMode'),
                                    muteMode: _muteDisplayMode.get()
                                }),
                                name: new NamePanel({
                                    name: _properties.name,
                                    mode: this.getStyle('nameDisplayMode')
                                }),
                                muteButton: new MuteButton({
                                    muted: _audioVolume === 0,
                                    mode: _muteDisplayMode.get()
                                })
                            };
                            if (_audioLevelCapable) {
                                const audioLevelTransformer = new AudioLevelTransformer();
                                _audioLevelMeter = new AudioLevelMeter({
                                    mode: _subscriber.getStyle('audioLevelDisplayMode')
                                });
                                const updateAudioLevel = new RafRunner(()=>{
                                    _audioLevelMeter.setValue(audioLevelTransformer.transform(this.loudness));
                                });
                                _audioLevelMeter.watchVisibilityChanged((visible)=>{
                                    if (visible) updateAudioLevel.start();
                                    else updateAudioLevel.stop();
                                });
                                _audioLevelMeter.setDisplayMode(this.getStyle('audioLevelDisplayMode'));
                                _audioLevelMeter.audioOnly(false);
                                widgets.audioLevel = _audioLevelMeter;
                            }
                            widgets.videoDisabledIndicator = new VideoDisabledIndicator({
                                mode: this.getStyle('videoDisabledDisplayMode')
                            });
                            widgets.audioBlockedIndicator = new AudioBlockedIndicator({
                                mode: this.getStyle('audioBlockedDisplayMode')
                            });
                            widgets.videoUnsupportedIndicator = new VideoUnsupportedIndicator({
                                mode: this.getStyle('videoUnsupportedDisplayMode')
                            });
                            if (_widgetView && _widgetView.domElement) {
                                _chrome = new Chrome({
                                    parent: _widgetView.domElement
                                }).set(widgets).on({
                                    muted () {
                                        _subscriber.setAudioVolume(0);
                                    },
                                    unmuted () {
                                        _subscriber.setAudioVolume(_latestPositiveVolume);
                                    }
                                }, this); // Hide the chrome until we explicitly show it
                                _chrome.hideWhileLoading();
                            }
                        };
                        const _showError = (code, message)=>{
                            let errorMessage;
                            let helpMessage; // Display the error message inside the container, assuming it's
                            // been created by now.
                            if (_widgetView) {
                                if (code === ExceptionCodes.STREAM_LIMIT_EXCEEDED) {
                                    errorMessage = 'The stream was unable to connect.';
                                    helpMessage = 'The limit for the number of media streams has been reached.';
                                } else if (message === 'Tried to subscribe to an encrypted stream without enabling encryption') {
                                    errorMessage = 'Unable to subscribe to an encrypted stream without enabling encryption.';
                                    helpMessage = '';
                                } else {
                                    errorMessage = 'The stream was unable to connect due to a network error.';
                                    if (_hasLoadedAtLeastOnce) helpMessage = 'Ensure you have a stable connection and try again.';
                                    else helpMessage = "Make sure you have a stable network connection and that it isn't blocked by a firewall.";
                                }
                                _widgetView.addError(errorMessage, helpMessage);
                            }
                        };
                        StylableComponent(this, {
                            nameDisplayMode: 'auto',
                            buttonDisplayMode: 'auto',
                            audioLevelDisplayMode: 'auto',
                            videoDisabledDisplayMode: 'auto',
                            audioBlockedDisplayMode: 'auto',
                            backgroundImageURI: null,
                            showArchiveStatus: true,
                            showMicButton: true
                        }, _properties.showControls, (payload)=>{
                            logAnalyticsEvent('SetStyle', 'Subscriber', payload, null, 0.1);
                        });
                        function setAudioOnly(audioOnly) {
                            getAllPeerConnections().forEach(/*#__PURE__*/ function() {
                                var _ref16 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee9(peerConnection) {
                                    return _regenerator.default.wrap(function _callee9$(_context9) {
                                        while(true)switch(_context9.prev = _context9.next){
                                            case 0:
                                                _context9.next = 2;
                                                return peerConnection;
                                            case 2:
                                                _context9.sent.subscribeToVideo(!audioOnly);
                                            case 3:
                                            case "end":
                                                return _context9.stop();
                                        }
                                    }, _callee9);
                                }));
                                return function(_x11) {
                                    return _ref16.apply(this, arguments);
                                };
                            }()); // Default to audioFallback if no mediaStream or no video tracks.
                            const audioFallback = audioOnly || !_mediaStream || !_mediaStream.getVideoTracks().length;
                            if (_widgetView) {
                                _widgetView.audioOnly(audioFallback);
                                _widgetView.showPoster(audioFallback);
                            }
                            if (_audioLevelMeter) _audioLevelMeter.audioOnly(audioFallback);
                        } // logs an analytics event for getStats on the first call
                        const notifyGetStatsCalled = once(()=>{
                            logAnalyticsEvent('GetStats', 'Called');
                        });
                        const notifyGetRtcStatsReportCalled = once(()=>{
                            logAnalyticsEvent('GetRtcStatsReport', 'Called');
                        });
                        const createAudioLevelSampler = /*#__PURE__*/ function() {
                            var _ref17 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee10(peerConnection) {
                                return _regenerator.default.wrap(function _callee10$(_context10) {
                                    while(true)switch(_context10.prev = _context10.next){
                                        case 0:
                                            if (_audioLevelBehaviour) {
                                                _audioLevelBehaviour.destroy();
                                                _audioLevelBehaviour = undefined;
                                            }
                                            _context10.prev = 1;
                                            _context10.next = 4;
                                            return waitUntil(()=>peerConnection._hasAudioTracks());
                                        case 4:
                                            _context10.next = 9;
                                            break;
                                        case 6:
                                            _context10.prev = 6;
                                            _context10.t0 = _context10["catch"](1);
                                            return _context10.abrupt("return");
                                        case 9:
                                            // prefer the audioLevelSampler (more efficient and better responsiveness)
                                            _audioLevelSampler = audioLevelSampler(peerConnection);
                                            if (_audioLevelSampler) _audioLevelBehaviour = audioLevelBehaviour({
                                                subscriber: _this,
                                                audioLevelSampler: _audioLevelSampler
                                            });
                                            else if (!Object.prototype.hasOwnProperty.call(_this, 'loudness')) {
                                                Object.defineProperty(_this, 'loudness', {
                                                    value: undefined,
                                                    configurable: true,
                                                    writable: false
                                                });
                                                logging.error('No suitable audio level samplers found, audio level visualisation will not work');
                                            }
                                        case 11:
                                        case "end":
                                            return _context10.stop();
                                    }
                                }, _callee10, null, [
                                    [
                                        1,
                                        6
                                    ]
                                ]);
                            }));
                            return function createAudioLevelSampler(_x12) {
                                return _ref17.apply(this, arguments);
                            };
                        }();
                        const setPeerConnectionEvents = (peerConnection, sourceStreamId)=>{
                            if (_peerConnectionEvents[sourceStreamId]) {
                                _peerConnectionEvents[sourceStreamId].removeAll();
                                const onDisconnected = ()=>{
                                    peerConnection.off('error', onDisconnected);
                                    peerConnection.off('disconnected', onDisconnected);
                                };
                                peerConnection.on('error', onDisconnected);
                                peerConnection.on('disconnected', onDisconnected);
                            }
                            const peerConnectionEvents = eventHelper(peerConnection);
                            peerConnectionEvents.once('connected', ()=>onPeerConnected(peerConnection));
                            peerConnectionEvents.on('disconnected', onPeerDisconnected);
                            peerConnectionEvents.on('error', onPeerConnectionFailure);
                            peerConnectionEvents.once('remoteTrackAdded', /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee11() {
                                var _args11 = arguments;
                                return _regenerator.default.wrap(function _callee11$(_context11) {
                                    while(true)switch(_context11.prev = _context11.next){
                                        case 0:
                                            _context11.next = 2;
                                            return createAudioLevelSampler(peerConnection);
                                        case 2:
                                            _context11.prev = 2;
                                            _context11.next = 5;
                                            return onTrackAdded(..._args11);
                                        case 5:
                                            _context11.next = 10;
                                            break;
                                        case 7:
                                            _context11.prev = 7;
                                            _context11.t0 = _context11["catch"](2);
                                            logging.error(_context11.t0);
                                        case 10:
                                        case "end":
                                            return _context11.stop();
                                    }
                                }, _callee11, null, [
                                    [
                                        2,
                                        7
                                    ]
                                ]);
                            })));
                            peerConnectionEvents.on('audioLevelStuckWarning', onAudioLevelStuckWarning);
                            peerConnectionEvents.on('signalingStateStable', /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee12() {
                                var video;
                                return _regenerator.default.wrap(function _callee12$(_context12) {
                                    while(true)switch(_context12.prev = _context12.next){
                                        case 0:
                                            _subscriber.trigger('signalingStateStable');
                                            video = _widgetView && _widgetView.video();
                                            if (video && _webRTCStream) {
                                                if (_audioLevelSampler && 'webRTCStream' in _audioLevelSampler && peerConnection._hasAudioTracks()) _audioLevelSampler.webRTCStream(_webRTCStream);
                                            }
                                        case 3:
                                        case "end":
                                            return _context12.stop();
                                    }
                                }, _callee12);
                            })));
                            peerConnectionEvents.on('iceConnectionStateChange', (state)=>onIceConnectionStateChange(state, peerConnection));
                            peerConnectionEvents.on('iceRestartSuccess', onIceRestartSuccess);
                            peerConnectionEvents.on('iceRestartFailure', onIceRestartFailure);
                            peerConnectionEvents.on('remoteVideoSupported', onRemoteVideoSupported);
                            peerConnectionEvents.on('remoteStreamRemoved', onRemoteStreamRemoved);
                            peerConnectionEvents.on('decryptFailed', ()=>this.trigger('encryptionSecretMismatch'));
                            peerConnectionEvents.on('decryptRestored', ()=>this.trigger('encryptionSecretMatch'));
                            _peerConnectionEvents[sourceStreamId] = _peerConnectionEvents;
                        };
                        this._destroy = (_ref20)=>{
                            let _ref20$reason = _ref20.reason, reason = _ref20$reason === void 0 ? 'Unknown' : _ref20$reason, quiet = _ref20.quiet, _ref20$noStateTransit = _ref20.noStateTransition, noStateTransition = _ref20$noStateTransit === void 0 ? false : _ref20$noStateTransit;
                            if (_state.isDestroyed()) return this;
                            _state.set('Destroyed');
                            if (_frameRateWatcher) {
                                _frameRateWatcher.destroy();
                                _frameRateWatcher = null;
                            }
                            _preDisconnectStats = {
                                sessionId: _session.sessionId,
                                connectionId: _session && _session.isConnected() ? _session.connection.connectionId : null,
                                partnerId: _session && _session.sessionInfo ? _session.sessionInfo.partnerId : null,
                                streamId: _stream && !_stream.destroyed ? _stream.id : null
                            };
                            this._disconnect({
                                reason: reason,
                                noStateTransition: noStateTransition
                            });
                            if (_chrome) {
                                _chrome.destroy();
                                _chrome = null;
                            }
                            if (_widgetView) {
                                _widgetView.destroy();
                                _widgetView.off();
                                _widgetView = null;
                                this.element = null;
                            }
                            if (_stream && !_stream.destroyed) logAnalyticsEvent('unsubscribe', null, {
                                streamId: _stream.id
                            });
                            _stream.off(_streamEventHandlers, this);
                            this.id = null;
                            _domId = null;
                            this.stream = null;
                            _stream = null;
                            this.streamId = null;
                            this.session = null;
                            _session = null;
                            _properties = null;
                            if (quiet !== true) {
                                this.dispatchEvent(new Events.DestroyedEvent(eventNames.SUBSCRIBER_DESTROYED, this, reason));
                                this.off();
                            }
                            return this;
                        };
                        this.destroy = function(reason, quiet) {
                            if (reason === void 0) reason = 'Unsubscribe';
                            logging.warn('Subscriber#destroy is deprecated and will be removed. Please use Session#unsubscribe instead');
                            _this._destroy({
                                reason: reason,
                                quiet: quiet
                            });
                        };
                        this._disconnect = function(_temp4) {
                            let _ref21 = _temp4 === void 0 ? {} : _temp4, _ref21$reason = _ref21.reason, reason = _ref21$reason === void 0 ? 'Unknown' : _ref21$reason, noStateTransition = _ref21.noStateTransition;
                            // known reasons:
                            // forceUnpublished (publisher stream was destroyed by forceUnpublish)
                            // clientDisconnected (publisher unpublished)
                            // Unsubscribe (when calling session.unsubscribe)
                            // Unknown (when reason is not determined)
                            if (!noStateTransition && !connectivityState.is('disconnected')) {
                                const error = reason === 'Unsubscribe' ? undefined : otError(errors.STREAM_DESTROYED, new Error('Stream was destroyed before it could be subscribed to'));
                                connectivityState.disconnect({
                                    payload: {
                                        reason: reason
                                    },
                                    error: error
                                });
                            }
                            if (!_state.isDestroyed() && !_state.isFailed()) // If we are already in the destroyed state then disconnect
                            // has been called after (or from within) destroy.
                            _state.set('NotSubscribing');
                            if (_widgetView) _widgetView.destroyVideo();
                             // Unsubscribe us from the stream, if it hasn't already been destroyed
                            if (socket.is('connected') && _stream && !_stream.destroyed) // Notify the server components
                            // @todo I assume we don't want to send this message, but is there anything
                            // we need to do in p2p->mantis for when a peer conn is destroyed?
                            socket.subscriberDestroy(_stream.id, _this.widgetId);
                            removeAllPeerConnections();
                        };
                        this.disconnect = ()=>{
                            logging.warn('Subscriber#disconnect is deprecated and will be removed. Please use Session#unsubscribe instead');
                            this._disconnect({
                                reason: 'Unsubscribe'
                            });
                        };
                        const processOffer = /*#__PURE__*/ function() {
                            var _ref23 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee13(_ref22) {
                                var peerId, fromConnectionId, sourceStreamId, uri, send, log, logQoS;
                                return _regenerator.default.wrap(function _callee13$(_context13) {
                                    while(true)switch(_context13.prev = _context13.next){
                                        case 0:
                                            peerId = _ref22.peerId, fromConnectionId = _ref22.fromConnectionId, sourceStreamId = _ref22.sourceStreamId;
                                            uri = constructSubscriberUri({
                                                apiKey: _session.apiKey,
                                                sessionId: _session.sessionId,
                                                streamId: _stream.id,
                                                subscriberId: _this.widgetId
                                            });
                                            send = createSendMethod({
                                                socket: _this.session._.getSocket(),
                                                uri: uri,
                                                content: {
                                                    peerId: peerId,
                                                    sourceStreamId: sourceStreamId
                                                }
                                            });
                                            log = function log(action, variation, payload, options, throttle) {
                                                if (options === void 0) options = {};
                                                const transformedOptions = (0, _extends2.default)({
                                                    peerId: peerId,
                                                    sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId)
                                                }, options);
                                                return logAnalyticsEvent(action, variation, payload, transformedOptions, throttle);
                                            };
                                            logQoS = (qos)=>{
                                                // We only log data from the active peer connection
                                                if (_activeSourceStreamId !== sourceStreamId) return;
                                                recordQOS((0, _extends2.default)({}, qos, {
                                                    peerId: peerId,
                                                    remoteConnectionId: fromConnectionId,
                                                    sourceStreamId: sourceStreamId
                                                }));
                                            };
                                            return _context13.abrupt("return", _this._setupPeerConnection({
                                                send: send,
                                                log: log,
                                                logQoS: logQoS,
                                                sourceStreamId: sourceStreamId
                                            }));
                                        case 6:
                                        case "end":
                                            return _context13.stop();
                                    }
                                }, _callee13);
                            }));
                            return function processOffer(_x13) {
                                return _ref23.apply(this, arguments);
                            };
                        }();
                        this.processMessage = /*#__PURE__*/ function() {
                            var _ref24 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee14(type, fromConnectionId, message) {
                                var peerId, sourceStreamId, peerConnection;
                                return _regenerator.default.wrap(function _callee14$(_context14) {
                                    while(true)switch(_context14.prev = _context14.next){
                                        case 0:
                                            logging.debug(`OT.Subscriber.processMessage: Received ${type} message from ${fromConnectionId}`);
                                            logging.debug(message);
                                            peerId = get(message, 'content.peerId');
                                            sourceStreamId = get(message, 'content.sourceStreamId');
                                            _context14.next = 6;
                                            return getPeerConnectionBySourceStreamId(sourceStreamId);
                                        case 6:
                                            peerConnection = _context14.sent;
                                            if (!peerConnection) {
                                                _context14.next = 11;
                                                break;
                                            }
                                            peerConnection.processMessage(type, message);
                                            _context14.next = 16;
                                            break;
                                        case 11:
                                            if (!(type === 'offer')) {
                                                _context14.next = 16;
                                                break;
                                            }
                                            _context14.next = 14;
                                            return processOffer({
                                                peerId: peerId,
                                                fromConnectionId: fromConnectionId,
                                                sourceStreamId: sourceStreamId
                                            });
                                        case 14:
                                            peerConnection = _context14.sent;
                                            _this.session._.addSubscriberToPeerConnectionsQueue(peerConnection, message);
                                        case 16:
                                        case "end":
                                            return _context14.stop();
                                    }
                                }, _callee14);
                            }));
                            return function(_x14, _x15, _x16) {
                                return _ref24.apply(this, arguments);
                            };
                        }();
                        this.disableVideo = (active)=>{
                            if (!active) logging.warn('Due to high packet loss and low bandwidth, video has been disabled');
                            else if (_lastSubscribeToVideoReason === 'auto') logging.info('Video has been re-enabled');
                            else {
                                logging.info('Video was not re-enabled because it was manually disabled');
                                return;
                            }
                            this.subscribeToVideo(active, 'auto');
                            const payload = active ? {
                                videoEnabled: true
                            } : {
                                videoDisabled: true
                            };
                            logAnalyticsEvent('updateQuality', 'video', payload);
                        };
                        /**
     * Returns the base-64-encoded string of PNG data representing the Subscriber video.
     *
     *  <p>You can use the string as the value for a data URL scheme passed to the src parameter of
     *  an image file, as in the following:</p>
     *
     *  <pre>
     *  var imgData = subscriber.getImgData();
     *
     *  var img = document.createElement("img");
     *  img.setAttribute("src", "data:image/png;base64," + imgData);
     *  var imgWin = window.open("about:blank", "Screenshot");
     *  imgWin.document.write("&lt;body&gt;&lt;/body&gt;");
     *  imgWin.document.body.appendChild(img);
     *  </pre>
     * @method #getImgData
     * @memberOf Subscriber
     * @return {String} The base-64 encoded string. Returns an empty string if there is no video.
     */ this.getImgData = ()=>{
                            if (!this.isSubscribing()) {
                                logging.error("OT.Subscriber.getImgData: Cannot getImgData before the Subscriber is subscribing.");
                                return null;
                            }
                            const video = _widgetView && _widgetView.video();
                            return video ? video.imgData() : null;
                        };
                        /**
    *  Returns the details on the subscriber stream quality, including the following:
    *
    * <ul>
    *
    *   <li>Total audio and video packets lost</li>
    *   <li>Total audio and video packets received</li>
    *   <li>Total audio and video bytes received</li>
    *   <li>Current average video frame rate</li>
    *
    * </ul>
    *
    * You can publish a test stream, subscribe to it (on the publishing client), and use this method
    * to check its quality. Based on the stream's quality, you can determine what video resolution is
    * supported and whether conditions support video or audio. You can then publish an appropriate
    * stream, based on the results. When using this method to test a stream published by your
    * own client, set the <code>testNetwork</code> property to <code>true</code> in the options you
    * pass into the <a href="Session.html#subscribe">Session.subscribe()</a> method. For an example,
    * see the <a href="https://github.com/opentok/opentok-network-test">opentok-network-test</a>
    * project on GitHub.
    * <p>
    * You may also use these statistics to have a Subscriber subscribe to audio-only if the audio
    * packet loss reaches a certain threshold. If you choose to do this, you should set the
    * <code>audioFallbackEnabled</code> setting to <code>false</code> when you initialize Publisher
    * objects for the session. This prevents the OpenTok Media Router from using its own audio-only
    * toggling implementation. (See the documentation for the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.)
    *
    * @param {Function} completionHandler A function that takes the following
    * parameters:
    *
    * <ul>
    *
    *   <li><code>error</code> (<a href="Error.html">Error</a>) &mdash; The error property is
    *   set if the client is not connected. Upon completion of a successful call to the method,
    *   this property is undefined.</li>
    *
    *   <li><code>stats</code> (Object) &mdash; An object with the following properties:
    *     <p>
    *     <ul>
    *       <li><code>audio.bytesReceived</code> (Number) &mdash; The total number of audio bytes
    *         received by the subscriber</li>
    *       <li><code>audio.packetsLost</code> (Number) &mdash; Total audio packets that did not reach
    *         the subscriber</li>
    *       <li><code>audio.packetsReceived</code> (Number) &mdash; The total number of audio packets
    *         received by the subscriber</li>
    *       <li><code>timestamp</code> (Number) &mdash; The timestamp, in milliseconds since the Unix
    *         epoch, for when these stats were gathered</li>
    *       <li><code>video.bytesReceived</code> (Number) &mdash; The total video bytes received by
    *         the subscriber</li>
    *       <li><code>video.packetsLost</code> (Number) &mdash; The total number of video packets that
    *         did not reach the subscriber</li>
    *       <li><code>video.packetsReceived</code> (Number) &mdash; The total number of video packets
    *         received by the subscriber</li>
    *       <li><code>video.frameRate</code> (Number) &mdash; The current average video frame rate</li>
    *     </ul>
    *   </li>
    * </ul>
    *
    * @see <a href="Publisher.html#getStats">Publisher.getStats()</a>
    * @see <a href="#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @method #getStats
    * @memberOf Subscriber
    */ this.getStats = (callback)=>{
                            _getStats((error, stats)=>{
                                if (error) {
                                    callback(error);
                                    return;
                                }
                                const otStats = {
                                    timestamp: 0
                                };
                                stats.forEach((stat)=>{
                                    if (getStatsHelpers.isInboundStat(stat)) {
                                        const video = getStatsHelpers.isVideoStat(stat, stats);
                                        const audio = getStatsHelpers.isAudioStat(stat, stats); // it is safe to override the timestamp of one by another
                                        // if they are from the same getStats "batch" video and audio ts have the same value
                                        if (audio || video) otStats.timestamp = getStatsHelpers.normalizeTimestamp(stat.timestamp);
                                        if (video) {
                                            merge(otStats, {
                                                video: getStatsHelpers.parseStatCategory(stat)
                                            });
                                            if (_frameRateWatcher) merge(otStats, {
                                                video: {
                                                    frameRate: _frameRateWatcher.getFrameRateFromStat(stat)
                                                }
                                            });
                                        } else if (audio) merge(otStats, {
                                            audio: getStatsHelpers.parseStatCategory(stat)
                                        });
                                    }
                                });
                                callback(null, otStats);
                            });
                        };
                        /**
    * Returns a promise that, on success, resolves with an RtcStatsReport object
    * for the subscribed stream. (See
    * <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport" target="_blank">
    * RTCStatsReport</a>.)
    * <p>
    * The Promise will be rejected in the following conditions:
    * <ul>
    *   <li>
    *     The browser does not support this method (for example, in Chrome version 57 and lower,
    *     which does not support the <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats" target="_blank">
    *     RTCPeerConnection.getStats()</a> standard).
    *   </li>
    *   <li>
    *     The <a href="https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection" target="_blank">
    *     PeerConnection</a> for the Subscriber is not connected.
    *   </li>
    *  </ul>
    * </p>
    *
    * @method #getRtcStatsReport
    * @memberOf Subscriber
    *
    * @see <a href="Publisher.html#getRtcStatsReport">Publisher.getRtcStatsReport()</a>
    *
    * @return {Promise} A promise that resolves when the operation completes successfully.
    * If there is an error, the promise is rejected.
    */ this.getRtcStatsReport = ()=>new Promise((resolve, reject)=>{
                                _getRtcStatsReport((error, rtcStatsReport)=>{
                                    if (error) reject(error);
                                    else resolve(rtcStatsReport);
                                });
                            });
                        function setAudioVolume(audioVolume) {
                            const video = _widgetView && _widgetView.video();
                            if (video) try {
                                video.setAudioVolume(audioVolume);
                            } catch (e) {
                                logging.warn(`setAudioVolume: ${e}`);
                                if (_audioVolume === 0) {
                                    logging.info('Using subscribeToAudio to mute Audio because setAudioVolume(0) failed'); // If we can't set the audioVolume to 0 then at least mute by setting subscribeToAudio(false)
                                    _subscriber.subscribeToAudio(false);
                                }
                            }
                            if (_chrome) _chrome.muteButton.muted(audioVolume === 0);
                        }
                        /**
     * Sets the audio volume, between 0 and 100, of the Subscriber.
     *
     * <p>You can set the initial volume when you call the <code>Session.subscribe()</code>
     * method. Pass a <code>audioVolume</code> property of the <code>properties</code> parameter
     * of the method.</p>
     *
     * @param {Number} value The audio volume, between 0 and 100.
     *
     * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
     * following:
     *
     * <pre>mySubscriber.setAudioVolume(50).setStyle(newStyle);</pre>
     *
     * @see <a href="#getAudioVolume">getAudioVolume()</a>
     * @see <a href="Session.html#subscribe">Session.subscribe()</a>
     * @method #setAudioVolume
     * @memberOf Subscriber
     */ this.setAudioVolume = (requestedVolume)=>{
                            const volume = normalizeAudioVolume(requestedVolume);
                            logAnalyticsEvent('setAudioVolume', 'Attempt', {
                                audioVolume: volume
                            });
                            if (isNaN(volume)) {
                                logging.error('OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100');
                                logAnalyticsEvent('setAudioVolume', 'Failure', {
                                    message: 'value should be an integer between 0 and 100'
                                });
                                return this;
                            }
                            if (volume !== requestedVolume) logging.warn('OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100');
                            if (volume === _audioVolume) {
                                setAudioVolume(_audioVolume);
                                logAnalyticsEvent('setAudioVolume', 'Success', {
                                    audioVolume: _audioVolume,
                                    message: 'Requested volume is same as already set audioVolume'
                                });
                                return this;
                            }
                            if (_audioVolume > 0) _latestPositiveVolume = _audioVolume;
                            _audioVolume = volume;
                            setAudioVolume(_audioVolume);
                            if (_audioVolume > 0 && !_isSubscribingToAudio) {
                                // in Firefox (and others) we don't stop subscribing to audio when muted, however if we are 'unmuting' and in
                                // the subscribeToAudio: false state we should subscribe to audio again
                                // subscribeToAudio is going to call us with _latestPositiveVolume so we'll update it here
                                _latestPositiveVolume = _audioVolume;
                                this.subscribeToAudio(true);
                            }
                            logAnalyticsEvent('setAudioVolume', 'Success', {
                                audioVolume: _audioVolume
                            });
                            return this;
                        };
                        /**
    * Returns the audio volume, between 0 and 100, of the Subscriber.
    *
    * <p>Generally you use this method in conjunction with the <code>setAudioVolume()</code>
    * method.</p>
    *
    * @return {Number} The audio volume, between 0 and 100, of the Subscriber.
    * @see <a href="#setAudioVolume">setAudioVolume()</a>
    * @method #getAudioVolume
    * @memberOf Subscriber
    */ this.getAudioVolume = ()=>{
                            const video = _widgetView && _widgetView.video();
                            if (video) try {
                                return video.getAudioVolume();
                            } catch (e) {
                                logging.warn(`getAudioVolume ${e}`);
                            }
                            return _audioVolume;
                        };
                        /**
    * Toggles audio on and off. Starts subscribing to audio (if it is available and currently
    * not being subscribed to) when the <code>value</code> is <code>true</code>; stops
    * subscribing to audio (if it is currently being subscribed to) when the <code>value</code>
    * is <code>false</code>.
    * <p>
    * <i>Note:</i> This method only affects the local playback of audio. It has no impact on the
    * audio for other connections subscribing to the same stream. If the Publisher is not
    * publishing audio, enabling the Subscriber audio will have no practical effect.
    * </p>
    *
    * @param {Boolean} value Whether to start subscribing to audio (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.subscribeToAudio(true).subscribeToVideo(false);</pre>
    *
    * @see <a href="#subscribeToVideo">subscribeToVideo()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    * @see <a href="StreamPropertyChangedEvent.html">StreamPropertyChangedEvent</a>
    *
    * @method #subscribeToAudio
    * @memberOf Subscriber
    */ this.subscribeToAudio = (pValue)=>{
                            const value = castToBoolean(pValue, true);
                            getAllPeerConnections().forEach(/*#__PURE__*/ function() {
                                var _ref25 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee15(peerConnection) {
                                    return _regenerator.default.wrap(function _callee15$(_context15) {
                                        while(true)switch(_context15.prev = _context15.next){
                                            case 0:
                                                _context15.next = 2;
                                                return peerConnection;
                                            case 2:
                                                _context15.sent.subscribeToAudio(value);
                                            case 3:
                                            case "end":
                                                return _context15.stop();
                                        }
                                    }, _callee15);
                                }));
                                return function(_x17) {
                                    return _ref25.apply(this, arguments);
                                };
                            }());
                            if (_stream && getAllPeerConnections().length !== 0) _stream.setChannelActiveState('audio', value);
                            const changed = _isSubscribingToAudio !== value;
                            _isSubscribingToAudio = value;
                            if (changed) this.setAudioVolume(value ? _latestPositiveVolume : 0);
                            logAnalyticsEvent('subscribeToAudio', 'Event', {
                                subscribeToAudio: value
                            });
                            return this;
                        };
                        const reasonMap = {
                            auto: 'quality',
                            publishVideo: 'publishVideo',
                            subscribeToVideo: 'subscribeToVideo'
                        };
                        if (env.name === 'Safari') {
                            const onVisibilityChange = ()=>{
                                if (!document1.hidden && _properties.subscribeToVideo) {
                                    logging.debug('document visibility restored in Safari - resubscribing to video');
                                    this.subscribeToVideo(false);
                                    this.subscribeToVideo(true);
                                }
                            };
                            document1.addEventListener('visibilitychange', onVisibilityChange);
                            this.once('destroyed', ()=>{
                                document1.removeEventListener('visibilitychange', onVisibilityChange);
                            });
                        }
                        /**
    * Toggles video on and off. Starts subscribing to video (if it is available and
    * currently not being subscribed to) when the <code>value</code> is <code>true</code>;
    * stops subscribing to video (if it is currently being subscribed to) when the
    * <code>value</code> is <code>false</code>.
    * <p>
    * <i>Note:</i> This method only affects the local playback of video. It has no impact on
    * the video for other connections subscribing to the same stream. If the Publisher is not
    * publishing video, enabling the Subscriber video will have no practical effect.
    * </p>
    *
    * @param {Boolean} value Whether to start subscribing to video (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.subscribeToVideo(true).subscribeToAudio(false);</pre>
    *
    * @see <a href="#subscribeToAudio">subscribeToAudio()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    * @see <a href="StreamPropertyChangedEvent.html">StreamPropertyChangedEvent</a>
    *
    * @method #subscribeToVideo
    * @memberOf Subscriber
    */ this.subscribeToVideo = (pValue, reason)=>{
                            const value = castToBoolean(pValue, true);
                            logAnalyticsEvent('subscribeToVideo', 'Attempt', {
                                subscribeToVideo: value,
                                reason: reason
                            });
                            setAudioOnly(!value || !_stream.hasVideo || !_webRTCStream);
                            if (_stream.hasVideo && !_streamHasTracks('video')) {
                                if (value) logging.info('Subscriber is audio-only due to incompatibility, can\'t subscribeToVideo.');
                                _properties.subscribeToVideo = false;
                                logAnalyticsEvent('subscribeToVideo', 'Failure', {
                                    message: 'No video tracks available'
                                });
                                return this;
                            }
                            if (_chrome && _chrome.videoDisabledIndicator) // If this is an auto disableVideo then we want to show the indicator, otherwise hide it again
                            _chrome.videoDisabledIndicator.disableVideo(reason === 'auto' && !value);
                            if (getAllPeerConnections().length > 0) {
                                if (_session && _stream && (value !== _properties.subscribeToVideo || reason !== _lastSubscribeToVideoReason)) _stream.setChannelActiveState('video', value, reason);
                            }
                            _properties.subscribeToVideo = value;
                            _lastSubscribeToVideoReason = reason;
                            _videoEnabled = value;
                            logAnalyticsEvent('subscribeToVideo', 'Success', {
                                subscribeToVideo: value,
                                reason: reason
                            });
                            if (reason !== 'loading') {
                                this.dispatchEvent(new Events.VideoEnabledChangedEvent(value ? 'videoEnabled' : 'videoDisabled', {
                                    reason: reasonMap[reason] || 'subscribeToVideo'
                                }));
                                if (value === 'videoDisabled' && reason === 'auto') _congestionLevel = 2;
                            }
                            return this;
                        };
                        /**
    * Sets the preferred resolution of the subscriber's video.
    * <p>
    * Lowering the preferred resolution
    * lowers video quality on the subscribing client, but it also reduces network and CPU usage.
    * You may want to use a lower resolution based on the dimensions of subscriber's video on
    * the web page. You may want to use a resolution rate for a subscriber to a stream that is less
    * important (and smaller) than other streams.
    * <p>
    * <p>
    * This method only applies when subscribing to a stream that uses the
    * <a href="https://tokbox.com/developer/guides/scalable-video">
    * scalable video feature</a>. Scalable video is available:
    * <ul>
    *   <li>
    *     Only in sessions that use the OpenTok Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the OpenTok iOS SDK (on certain devices), the OpenTok
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    * </ul>
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * <b>Note:</b> The resolution for scalable video streams automatically adjusts for each
    * subscriber, based on network conditions and CPU usage, even if you do not call this method.
    * Call this method if you want to set a maximum resolution for this subscriber.
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * Not every frame rate is available to a subscriber. When you set the preferred resolution for
    * the subscriber, OpenTok.js picks the best resolution available that matches your setting.
    * The resolutions available are based on the value of the Subscriber object's
    * <code>stream.resolution</code> property, which represents the maximum resolution available for
    * the stream. The actual resolutions available depend, dynamically, on network and CPU resources
    * available to the publisher and subscriber.
    * <p>
    * You can set the initial preferred resolution used by setting the
    * <code>preferredResolution</code> property of the <code>options</code> object you pass into the
    * <code>Session.subscribe()</code> method.
    *
    * @param {Object} resolution Set this to an object with two properties: <code>width</code> and
    * <code>height</code> (both numbers), such as <code>{width: 320, height: 240}</code>. Set this to
    * <code>null</code> to remove the preferred resolution, and the client will use the highest
    * resolution available.
    *
    * @see <a href="#setPreferredFrameRate">Subscriber.setPreferredFrameRate()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    *
    * @method #setPreferredResolution
    * @memberOf Subscriber
    */ this.setPreferredResolution = (preferredResolution)=>{
                            if (_state.isDestroyed() || getAllPeerConnections().length === 0 && (_state.current, false)) {
                                logging.warn('Cannot set the max Resolution when not subscribing to a publisher');
                                return;
                            }
                            _properties.preferredResolution = preferredResolution;
                            if (_session.sessionInfo.p2pEnabled) {
                                logging.warn('OT.Subscriber.setPreferredResolution will not work in a P2P Session');
                                return;
                            } // We can only setPreferredResolution once the remote stream has been added. Otherwise we will save
                            // the preferred resolution, and then it will be requested once the stream has been added.
                            if (!_state.isStreamAdded()) return;
                            const curMaxResolution = _stream.getPreferredResolution();
                            const isUnchanged = curMaxResolution && preferredResolution && curMaxResolution.width === preferredResolution.width && curMaxResolution.height === preferredResolution.height || !curMaxResolution && !preferredResolution;
                            if (isUnchanged) return;
                            _stream.setPreferredResolution(preferredResolution);
                        };
                        /**
    * Sets the preferred frame rate of the subscriber's video.
    * <p>
    * Lowering the preferred frame rate
    * lowers video quality on the subscribing client, but it also reduces network and CPU usage.
    * You may want to use a lower frame rate for a subscriber to a stream that is less important
    * than other streams.
    * <p>
    * <p>
    * This method only applies when subscribing to a stream that uses the
    * <a href="https://tokbox.com/developer/guides/scalable-video">
    * scalable video feature</a>. Scalable video is available:
    * <ul>
    *   <li>
    *     Only in sessions that use the OpenTok Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the OpenTok iOS SDK (on certain devices), the OpenTok
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    * </ul>
    * <p>
    * In streams that do not use scalable video, calling this method has no effect.
    * <p>
    * <b>Note:</b> The frame rate for scalable video streams automatically adjusts for each
    * subscriber, based on network conditions and CPU usage, even if you do not call this method.
    * Call this method if you want to set a maximum frame rate for this subscriber.
    * <p>
    * Not every frame rate is available to a subscriber. When you set the preferred frame rate for
    * the subscriber, OpenTok.js picks the best frame rate available that matches your setting.
    * The frame rates available are based on the value of the Subscriber object's
    * <code>stream.frameRate</code> property, which represents the maximum value available for the
    * stream. The actual frame rates available depend, dynamically, on network and CPU resources
    * available to the publisher and subscriber.
    * <p>
    * You can set the initial preferred frame rate used by setting the <code>preferredFrameRate</code>
    * property of the <code>options</code> object you pass into the <code>Session.subscribe()</code>
    * method.
    *
    * @param {Number} frameRate Set this to the desired frame rate (in frames per second). Set this to
    * <code>null</code> to remove the preferred frame rate, and the client will use the highest
    * frame rate available.
    *
    * @see <a href="#setPreferredResolution">Subscriber.setPreferredResolution()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    *
    * @method #setPreferredFrameRate
    * @memberOf Subscriber
    */ this.setPreferredFrameRate = (preferredFrameRate)=>{
                            if (_state.isDestroyed() || getAllPeerConnections().length === 0 && (_state.current, false)) {
                                logging.warn('Cannot set the max frameRate when not subscribing to a publisher');
                                return;
                            }
                            _properties.preferredFrameRate = preferredFrameRate;
                            if (_session.sessionInfo.p2pEnabled) {
                                logging.warn('OT.Subscriber.setPreferredFrameRate will not work in a P2P Session');
                                return;
                            }
                            const currentPreferredFrameRate = _stream.getPreferredFrameRate();
                            const isUnchangedFrameRate = preferredFrameRate && currentPreferredFrameRate && currentPreferredFrameRate === preferredFrameRate || !currentPreferredFrameRate && !preferredFrameRate;
                            if (isUnchangedFrameRate) return;
                            _stream.setPreferredFrameRate(preferredFrameRate);
                        };
                        this.isSubscribing = ()=>_state.isSubscribing();
                        this.isWebRTC = true;
                        this.isLoading = ()=>_widgetView && _widgetView.loading();
                        /**
     * Indicates whether the subscriber's audio is blocked because of
     * the browser's audio autoplay policy.
     *
     * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
     * @see The <a href="#event:audioBlocked">audioBlocked</a>
     * and <a href="#event:audioUnblocked">audioUnblocked</a>
     * Subscriber events
     * @see The <code>style.audioBlockedDisplayMode</code> property of the
     * <code>options</code> parameter of the
     * <a href="Session.html#subscribe">Session.subscribe()</a> method
     *
     * @method #isAudioBlocked
     * @memberof Subscriber
     */ this.isAudioBlocked = ()=>Boolean(_widgetView && _widgetView.isAudioBlocked());
                        this.videoElement = ()=>{
                            const video = _widgetView && _widgetView.video();
                            return video ? video.domElement() : null;
                        };
                        /**
    * Returns the width, in pixels, of the Subscriber video.
    *
    * @method #videoWidth
    * @memberOf Subscriber
    * @return {Number} the width, in pixels, of the Subscriber video.
    */ this.videoWidth = ()=>{
                            const video = _widgetView && _widgetView.video();
                            return video ? video.videoWidth() : undefined;
                        };
                        /**
    * Returns the height, in pixels, of the Subscriber video.
    *
    * @method #videoHeight
    * @memberOf Subscriber
    * @return {Number} the width, in pixels, of the Subscriber video.
    */ this.videoHeight = ()=>{
                            const video = _widgetView && _widgetView.video();
                            return video ? video.videoHeight() : undefined;
                        };
                        this._subscribeToSelf = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee16() {
                            var publisher;
                            return _regenerator.default.wrap(function _callee16$(_context16) {
                                while(true)switch(_context16.prev = _context16.next){
                                    case 0:
                                        publisher = _session.getPublisherForStream(_stream);
                                        if (publisher && publisher._.webRtcStream()) {
                                            _context16.next = 5;
                                            break;
                                        }
                                        connectivityState.fail({
                                            payload: {
                                                reason: 'streamNotFound'
                                            },
                                            error: otError(errors.STREAM_DESTROYED, new Error('Tried to subscribe to a local publisher, but its stream no longer exists'))
                                        });
                                        _context16.next = 14;
                                        break;
                                    case 5:
                                        _pcConnected.resolve();
                                        _context16.prev = 6;
                                        _context16.next = 9;
                                        return onRemoteStreamAdded(publisher._.webRtcStream());
                                    case 9:
                                        _context16.next = 14;
                                        break;
                                    case 11:
                                        _context16.prev = 11;
                                        _context16.t0 = _context16["catch"](6);
                                        logging.error(_context16.t0);
                                    case 14:
                                    case "end":
                                        return _context16.stop();
                                }
                            }, _callee16, null, [
                                [
                                    6,
                                    11
                                ]
                            ]);
                        }));
                        this._setupPeerConnection = /*#__PURE__*/ function() {
                            var _ref28 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee17(_ref27) {
                                var send, log, logQoS, sourceStreamId;
                                return _regenerator.default.wrap(function _callee17$(_context17) {
                                    while(true)switch(_context17.prev = _context17.next){
                                        case 0:
                                            send = _ref27.send, log = _ref27.log, logQoS = _ref27.logQoS, sourceStreamId = _ref27.sourceStreamId;
                                            if (_properties.testNetwork) _this.setAudioVolume(0);
                                            if (getAllPeerConnections().length === 0) // @todo The subscribers states should be something like:
                                            // disconnected || connecting || reconnecting || connected || destroyed
                                            // the state of peer connections belong to the peer connection itself
                                            _state.set('Connecting');
                                            _activeSourceStreamId = sourceStreamId;
                                            peerConnectionsAsync[sourceStreamId] = new Promise((resolve, reject)=>{
                                                _session._.getIceConfig().then((iceConfig)=>{
                                                    if (iceConfig.needRumorIceServersFallback) iceConfig.servers = [
                                                        ...fallbackIceServers || [],
                                                        ...iceConfig.servers || []
                                                    ];
                                                    const props = {
                                                        iceConfig: iceConfig,
                                                        subscriberId: _this.widgetId,
                                                        send: send,
                                                        logAnalyticsEvent: log,
                                                        p2p: _session.sessionInfo.p2pEnabled,
                                                        sourceStreamId: sourceStreamId,
                                                        remoteConnectionId: _stream.connection.id,
                                                        // We force to use the SPC only for Mantis leg.
                                                        _singlePeerConnectionController: sourceStreamId === 'MANTIS' && _singlePeerConnectionController,
                                                        keyStore: _session.keyStore,
                                                        sFrameClientStore: _session.sFrameClientStore,
                                                        isE2ee: _session._.isE2ee()
                                                    };
                                                    if (Object.prototype.hasOwnProperty.call(_properties, 'codecFlags')) props.codecFlags = _properties.codecFlags;
                                                    const peerConnection = new Subscriber.SubscriberPeerConnection(props);
                                                    peerConnection.once('iceConnected', _pcConnected.resolve);
                                                    peerConnection.once('error', _pcConnected.reject);
                                                    peerConnection.on('qos', logQoS);
                                                    setPeerConnectionEvents(peerConnection, sourceStreamId); // initialize the peer connection AFTER we've added the event listeners
                                                    peerConnection.init((err)=>{
                                                        if (err) reject(err);
                                                        else resolve(peerConnection);
                                                    });
                                                });
                                            });
                                            return _context17.abrupt("return", peerConnectionsAsync[sourceStreamId]);
                                        case 6:
                                        case "end":
                                            return _context17.stop();
                                    }
                                }, _callee17);
                            }));
                            return function(_x18) {
                                return _ref28.apply(this, arguments);
                            };
                        }();
                        /**
    * Restricts the frame rate of the Subscriber's video stream, when you pass in
    * <code>true</code>. When you pass in <code>false</code>, the frame rate of the video stream
    * is not restricted.
    * <p>
    * When the frame rate is restricted, the Subscriber video frame will update once or less per
    * second.
    * <p>
    * This feature is only available in sessions that use the OpenTok Media Router (sessions with
    * the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed. In relayed sessions,
    * calling this method has no effect.
    * <p>
    * Restricting the subscriber frame rate has the following benefits:
    * <ul>
    *    <li>It reduces CPU usage.</li>
    *    <li>It reduces the network bandwidth consumed.</li>
    *    <li>It lets you subscribe to more streams simultaneously.</li>
    * </ul>
    * <p>
    * Reducing a subscriber's frame rate has no effect on the frame rate of the video in
    * other clients.
    *
    * @param {Boolean} value Whether to restrict the Subscriber's video frame rate
    * (<code>true</code>) or not (<code>false</code>).
    *
    * @return {Subscriber} The Subscriber object. This lets you chain method calls, as in the
    * following:
    *
    * <pre>mySubscriber.restrictFrameRate(false).subscribeToAudio(true);</pre>
    *
    * @method #restrictFrameRate
    * @memberOf Subscriber
    */ this.restrictFrameRate = (val)=>{
                            logging.debug(`OT.Subscriber.restrictFrameRate(${val})`);
                            logAnalyticsEvent('restrictFrameRate', val.toString(), {
                                streamId: _stream.id
                            });
                            if (_session.sessionInfo.p2pEnabled) logging.warn('OT.Subscriber.restrictFrameRate: Cannot restrictFrameRate on a P2P session');
                            if (typeof val !== 'boolean') logging.error(`OT.Subscriber.restrictFrameRate: expected a boolean value got a ${typeof val}`);
                            else {
                                _frameRateRestricted = val;
                                _stream.setRestrictFrameRate(val);
                            }
                            return this;
                        };
                        this.on('styleValueChanged', updateChromeForStyleChange, this);
                        this._ = {
                            getDataChannel (label, options, completion) {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee18() {
                                    return _regenerator.default.wrap(function _callee18$(_context18) {
                                        while(true)switch(_context18.prev = _context18.next){
                                            case 0:
                                                if (getCurrentPeerConnection()) {
                                                    _context18.next = 3;
                                                    break;
                                                }
                                                completion(new OTHelpers.Error('Cannot create a DataChannel before there is a publisher connection.'));
                                                return _context18.abrupt("return");
                                            case 3:
                                                _context18.next = 5;
                                                return getCurrentPeerConnection();
                                            case 5:
                                                _context18.sent.getDataChannel(label, options, completion);
                                            case 6:
                                            case "end":
                                                return _context18.stop();
                                        }
                                    }, _callee18);
                                }))();
                            },
                            iceRestart (reason) {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee19() {
                                    var peerConnection;
                                    return _regenerator.default.wrap(function _callee19$(_context19) {
                                        while(true)switch(_context19.prev = _context19.next){
                                            case 0:
                                                _context19.next = 2;
                                                return getPeerConnectionBySourceStreamId('MANTIS');
                                            case 2:
                                                peerConnection = _context19.sent;
                                                if (!peerConnection) logging.debug('Subscriber: Skipping ice restart, we have no peer connection');
                                                else {
                                                    logResubscribe('Attempt', {
                                                        reason: reason
                                                    });
                                                    logging.debug('Subscriber: iceRestart attempt');
                                                    peerConnection.iceRestart();
                                                }
                                            case 4:
                                            case "end":
                                                return _context19.stop();
                                        }
                                    }, _callee19);
                                }))();
                            },
                            unblockAudio: ()=>_widgetView && _widgetView.unblockAudio(),
                            webRtcStream: ()=>_webRTCStream,
                            setIceConfig: function() {
                                var _setIceConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee21(iceConfig) {
                                    return _regenerator.default.wrap(function _callee21$(_context21) {
                                        while(true)switch(_context21.prev = _context21.next){
                                            case 0:
                                                getAllPeerConnections().forEach(/*#__PURE__*/ function() {
                                                    var _ref29 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee20(pc) {
                                                        return _regenerator.default.wrap(function _callee20$(_context20) {
                                                            while(true)switch(_context20.prev = _context20.next){
                                                                case 0:
                                                                    _context20.next = 2;
                                                                    return pc;
                                                                case 2:
                                                                    return _context20.abrupt("return", _context20.sent.setIceConfig(iceConfig));
                                                                case 3:
                                                                case "end":
                                                                    return _context20.stop();
                                                            }
                                                        }, _callee20);
                                                    }));
                                                    return function(_x20) {
                                                        return _ref29.apply(this, arguments);
                                                    };
                                                }());
                                            case 1:
                                            case "end":
                                                return _context21.stop();
                                        }
                                    }, _callee21);
                                }));
                                function setIceConfig(_x19) {
                                    return _setIceConfig.apply(this, arguments);
                                }
                                return setIceConfig;
                            }(),
                            privateEvents: new EventEmitter(),
                            startRoutedToRelayedTransition () {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee22() {
                                    var mantisPeerConnection;
                                    return _regenerator.default.wrap(function _callee22$(_context22) {
                                        while(true)switch(_context22.prev = _context22.next){
                                            case 0:
                                                if (!(_properties.testNetwork || isLocalStream(_stream, _session))) {
                                                    _context22.next = 2;
                                                    break;
                                                }
                                                return _context22.abrupt("return");
                                            case 2:
                                                logRoutedToRelayedTransition('Attempt');
                                                _context22.next = 5;
                                                return getPeerConnectionBySourceStreamId('MANTIS');
                                            case 5:
                                                mantisPeerConnection = _context22.sent;
                                                if (mantisPeerConnection == null ? void 0 : mantisPeerConnection.iceConnectionStateIsConnected()) {
                                                    _context22.next = 9;
                                                    break;
                                                }
                                                // This is for avoiding corner cases, e.g. two subscribers that join concurrently.
                                                // The first one will connect first to MANTIS and then receive a stream created
                                                // signal from RUMOR for the new P2P stream, so it will transition to Relayed.
                                                // The second one - that joined a few ms later - will also receive the stream created signal
                                                // from RUMOR, but is not connected to MANTIS yet, so this second one shouldn't attempt
                                                // to transition to Relayed, because 1) this means there's another subscriber that did
                                                // the transition, and 2) our model is MANTIS first, so we shouldn't transition to
                                                // Relayed in this case.
                                                logRoutedToRelayedTransition('Failure', {
                                                    reason: 'Attempted to transition to Relayed without being connected in Routed mode.'
                                                });
                                                return _context22.abrupt("return");
                                            case 9:
                                                socket.subscriberCreate(_stream.id, _widgetId, channelsToSubscribeTo, 'P2P', _session._.isE2ee(), (err, message)=>{
                                                    if (err && !connectivityState.is('disconnected')) logRoutedToRelayedTransition('Failure', err);
                                                    logging.debug('message received when created a subscriber with source', message);
                                                });
                                            case 10:
                                            case "end":
                                                return _context22.stop();
                                        }
                                    }, _callee22);
                                }))();
                            },
                            startRelayedToRoutedTransition () {
                                return (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee23() {
                                    var webRTCStream, mantisPc, peerConnection;
                                    return _regenerator.default.wrap(function _callee23$(_context23) {
                                        while(true)switch(_context23.prev = _context23.next){
                                            case 0:
                                                if (!(_properties.testNetwork || isLocalStream(_stream, _session))) {
                                                    _context23.next = 2;
                                                    break;
                                                }
                                                return _context23.abrupt("return");
                                            case 2:
                                                logRelayedToRoutedTransition('Attempt');
                                                webRTCStream = webRTCStreams.MANTIS;
                                                _webRTCStream = webRTCStream;
                                                _mediaStream = _webRTCStream;
                                                if (!_shouldUseSpc) {
                                                    _context23.next = 11;
                                                    break;
                                                }
                                                _context23.next = 9;
                                                return getPeerConnectionBySourceStreamId('MANTIS');
                                            case 9:
                                                mantisPc = _context23.sent;
                                                _mediaStream = new MediaStream(mantisPc._getTracks());
                                            case 11:
                                                _context23.next = 13;
                                                return bindWebRTCStream(_mediaStream);
                                            case 13:
                                                // Keep the loading spinner hidden so that the transition looks transparent.
                                                _widgetView.loading(false); // remove and close p2p connection
                                                removePeerConnectionBySourceStreamId('P2P');
                                                _activeSourceStreamId = 'MANTIS'; // remove webRTCStream
                                                removeWebRTCStream('P2P');
                                                _context23.next = 19;
                                                return getCurrentPeerConnection();
                                            case 19:
                                                peerConnection = _context23.sent;
                                                _context23.next = 22;
                                                return createAudioLevelSampler(peerConnection);
                                            case 22:
                                                logRelayedToRoutedTransition('Success');
                                            case 23:
                                            case "end":
                                                return _context23.stop();
                                        }
                                    }, _callee23);
                                }))();
                            },
                            setSinkId (deviceId) {
                                const video = _widgetView && _widgetView.video();
                                if (video) return _widgetView.setSinkId(deviceId);
                                logging.debug('Called setAudioOutputDevice on a subscriber without a video element');
                                return undefined;
                            },
                            pauseAndPlayVideoElement () {
                                if (_widgetView) _widgetView.pauseAndPlayVideoElement();
                            }
                        };
                        _state = new SubscribingState(stateChangeFailed);
                        logging.debug(`OT.Subscriber: subscribe to ${_stream.id}`);
                        _state.set('Init');
                        if (!_stream) {
                            // @todo error
                            logging.error('OT.Subscriber: No stream parameter.');
                            return false;
                        }
                        _streamEventHandlers = {
                            updated: streamUpdated
                        };
                        _stream.on(_streamEventHandlers, this);
                        _properties.name = _properties.name || _stream.name;
                        _properties.classNames = 'OT_root OT_subscriber';
                        if (_properties.style) this.setStyle(_properties.style, null, true);
                        _latestPositiveVolume = DEFAULT_AUDIO_VOLUME;
                        _properties.subscribeToVideo = castToBoolean(_properties.subscribeToVideo, true);
                        _properties.subscribeToAudio = castToBoolean(_properties.subscribeToAudio, true);
                        this.subscribeToAudio(_properties.subscribeToAudio);
                        this.setAudioVolume(determineAudioVolume(_properties));
                        _widgetView = new Subscriber.WidgetView(targetElement, (0, _extends2.default)({}, _properties, {
                            widgetType: 'subscriber'
                        }));
                        _widgetView.on('error', onVideoError);
                        _widgetView.on('audioBlocked', ()=>this.trigger('audioBlocked'));
                        _widgetView.on('audioUnblocked', ()=>this.trigger('audioUnblocked')); // We now log video transitions for AMR. These action are being triggered and logged
                        // at this level.
                        _widgetView.on('amrLogEvent', (action, variation, options)=>{
                            logAnalyticsEvent(action, variation, {}, options);
                        });
                        this.id = _widgetView.domId();
                        _domId = _widgetView.domId();
                        this.element = _widgetView.domElement;
                        _widgetView.on('videoElementCreated', (element)=>{
                            const event = new Events.VideoElementCreatedEvent(element);
                            const self1 = this;
                            if (!_loaded) this.once('loaded', ()=>{
                                self1.dispatchEvent(event);
                            });
                            else this.dispatchEvent(event);
                        });
                        if (this.element) // Only create the chrome if there is an element to insert it in
                        // for insertDefautlUI:false we don't create the chrome
                        _createChrome.call(this);
                        const audio = _stream.getChannelsOfType('audio');
                        const video = _stream.getChannelsOfType('video');
                        const data = _stream.getChannelsOfType('data'); // We're initalizing the flag here based on the data channel because we won't know the inital state otherwise.
                        // The flag can then be mutated by subscribeToCaptions()
                        let _isSubscribedToCaptions = data.some((channel)=>channel.id === 'caption1' && channel.active);
                        /*
    * Toggles captions on and off. Starts subscribing to captions (if it is available and currently
    * not being subscribed to) when the <code>value</code> is <code>true</code>; stops
    * subscribing to captions (if it is currently being subscribed to) when the <code>value</code>
    * is <code>false</code>.
    *
    * @param {Boolean} value Whether to start subscribing to captions (<code>true</code>) or not
    * (<code>false</code>).
    *
    * @see <a href="#isSubscribedToCaptions">isSubscribedToCaptions()</a>
    * @see <a href="Session.html#subscribe">Session.subscribe()</a>
    * @see <a href="#captionEvent">captionEvent</a>
    *
    * @method #subscribeToCaptions
    * @memberOf Subscriber
    */ this.subscribeToCaptions = /*#__PURE__*/ function() {
                            var _ref30 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee24(value) {
                                var active, attributes;
                                return _regenerator.default.wrap(function _callee24$(_context24) {
                                    while(true)switch(_context24.prev = _context24.next){
                                        case 0:
                                            active = castToBoolean(value, true);
                                            attributes = {
                                                active: active
                                            };
                                            _isSubscribedToCaptions = active;
                                            logAnalyticsEvent('subscribeToCaptions', 'Attempt', {
                                                subscribeToCaptions: active
                                            });
                                            socket.subscriberChannelUpdate(_stream.id, _this.widgetId, 'caption1', attributes);
                                            logAnalyticsEvent('subscribeToCaptions', 'Success', {
                                                subscribeToCaptions: active
                                            });
                                        case 6:
                                        case "end":
                                            return _context24.stop();
                                    }
                                }, _callee24);
                            }));
                            return function(_x21) {
                                return _ref30.apply(this, arguments);
                            };
                        }();
                        /*
     * Whether the subscriber is receiving captions. This property can change if the subscriber turns on
     * or off captioning (by calling Subscriber.subscribeToCaptions()).
     *
     * @class Subscriber
     * @see <a href="#subscribeToCaptions">Subscriber.subscribeToCaptions()</a>
     *
     * @method #isSubscribedToCaptions
     * @memberOf Subscriber
     */ this.isSubscribedToCaptions = ()=>_isSubscribedToCaptions;
                        const channelsToSubscribeTo = audio.map((channel)=>({
                                id: channel.id,
                                type: channel.type,
                                active: _properties.subscribeToAudio
                            })).concat(video.map((channel)=>{
                            const props = {
                                id: channel.id,
                                type: channel.type,
                                active: _properties.subscribeToVideo,
                                restrictFrameRate: _properties.restrictFrameRate !== undefined ? _properties.restrictFrameRate : false
                            };
                            if (_properties.preferredFrameRate !== undefined) props.preferredFrameRate = parseFloat(_properties.preferredFrameRate);
                            if (_properties.preferredHeight !== undefined) props.preferredHeight = parseInt(_properties.preferredHeight, 10);
                            if (_properties.preferredWidth !== undefined) props.preferredWidth = parseInt(_properties.preferredWidth, 10);
                            return props;
                        })).concat(data.map((channel)=>({
                                id: channel.id,
                                type: channel.type,
                                active: channel.active
                            })));
                        const shouldSubscribeToSelf = !_properties.testNetwork && isLocalStream(_stream, _session);
                        connectivityState.beginConnect();
                        if (shouldSubscribeToSelf) {
                            // bypass rumor etc and just subscribe locally
                            this._subscribeToSelf();
                            return this;
                        }
                        socket.subscriberCreate(_stream.id, _widgetId, channelsToSubscribeTo, null, _session._.isE2ee(), (err, message)=>{
                            // when the publisher is destroyed before we subscribe, chances are we have been told about
                            // before we get the subscriberCreate error, so this can be ignored.
                            if (err && !connectivityState.is('disconnected')) onSubscriberCreateError(err);
                            fallbackIceServers = parseIceServers(message);
                        });
                        /**
    * Dispatched when the subscriber's audio is blocked because of the
    * browser's autoplay policy.
    *
    * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    * @see <a href="Subscriber.html#isAudioBlocked">Subscriber.isAudioBlocked()</a>
    * @see The <a href="#event:audioUnblocked">audioUnblocked</a> event
    * @see The <code>style.audioBlockedDisplayMode</code> property of the
    * <code>options</code> parameter of the
    * <a href="Session.html#subscribe">Session.subscribe()</a> method)
    *
    * @name audioBlocked
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched when the subscriber's audio is unblocked after
    * being paused because of the browser's autoplay policy.
    * <p>
    * Subscriber audio is unblocked when any of the following occurs:
    * <ul>
    *  <li>
    *    The user clicks the default Subscriber audio playback icon
    *  </li>
    *  <li>
    *     The <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    *     method is called in response to an HTML element dispatching
    *     a <code>click</code> event (if you have disabled the default
    *     audio playback icon)
    *  </li>
    *  <li>
    *     The local client gains access to the camera or microphone
    *     (for instance, in response to a successful call to
    *     <code>OT.initPublisher()</code>).
    *  </li>
    * </ul>
    *
    * @see <a href="OT.html#unblockAudio">OT.unblockAudio()</a>
    * @see The <a href="l#event:audioBlocked">audioBlocked</a> event
    * @see The <code>style.audioBlockedDisplayMode</code> property of the
    * <code>options</code> parameter of the
    * <a href="Session.html#subscribe">Session#subscribe()</a> method)
    *
    * @name audioUnblocked
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched periodically to indicate the subscriber's audio level. The event is dispatched
    * up to 60 times per second, depending on the browser. The <code>audioLevel</code> property
    * of the event is audio level, from 0 to 1.0. See {@link AudioLevelUpdatedEvent} for more
    * information.
    * <p>
    * The following example adjusts the value of a meter element that shows volume of the
    * subscriber. Note that the audio level is adjusted logarithmically and a moving average
    * is applied:
    * <pre>
    * var movingAvg = null;
    * subscriber.on('audioLevelUpdated', function(event) {
    *   if (movingAvg === null || movingAvg &lt;= event.audioLevel) {
    *     movingAvg = event.audioLevel;
    *   } else {
    *     movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
    *   }
    *
    *   // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
    *   var logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
    *   logLevel = Math.min(Math.max(logLevel, 0), 1);
    *   document.getElementById('subscriberMeter').value = logLevel;
    * });
    * </pre>
    * <p>This example shows the algorithm used by the default audio level indicator displayed
    * in an audio-only Subscriber.
    *
    * @name audioLevelUpdated
    * @event
    * @memberof Subscriber
    * @see AudioLevelUpdatedEvent
    */ /**
    * Dispatched when the video for the subscriber is disabled.
    * <p>
    * The <code>reason</code> property defines the reason the video was disabled. This can be set to
    * one of the following values:
    * <p>
    *
    * <ul>
    *
    *   <li><code>"codecNotSupported"</code> &mdash; The client's browser does not support the
    *   video codec used by the stream. For example, in Safari if you connect to a
    *   <a href="https://tokbox.com/developer/guides/create-session/#media-mode">routed session</a>
    *   in a <a href="https://tokbox.com/developer/sdks/js/safari/#step1">non-Safari OpenTok
    *   project</a>, and you try to subscribe to a stream that includes video, the Subscriber
    *   will dispatch a <code>videoDisabled</code> event with the <code>reason</code> property
    *   set to <code>"codecNotSupported"</code>. (In routed sessions in a non-Safari project,
    *   streams use the VP8 video codec, which is not supported in Safari.) The subscriber
    *   element will also display a "Video format not supported" message. (See
    *   <a href="OT.html#getSupportedCodecs">OT.getSupportedCodecs()</a>.)</li>
    *
    *   <li><code>"publishVideo"</code> &mdash; The publisher stopped publishing video by calling
    *   <code>publishVideo(false)</code>.</li>
    *
    *   <li><code>"quality"</code> &mdash; The OpenTok Media Router stopped sending video
    *   to the subscriber based on stream quality changes. This feature of the OpenTok Media
    *   Router has a subscriber drop the video stream when connectivity degrades. (The subscriber
    *   continues to receive the audio stream, if there is one.)
    *   <p>
    *   Before sending this event, when the Subscriber's stream quality deteriorates to a level
    *   that is low enough that the video stream is at risk of being disabled, the Subscriber
    *   dispatches a <code>videoDisableWarning</code> event.
    *   <p>
    *   If connectivity improves to support video again, the Subscriber object dispatches
    *   a <code>videoEnabled</code> event, and the Subscriber resumes receiving video.
    *   <p>
    *   By default, the Subscriber displays a video disabled indicator when a
    *   <code>videoDisabled</code> event with this reason is dispatched and removes the indicator
    *   when the <code>videoEnabled</code> event with this reason is dispatched. You can control
    *   the display of this icon by calling the <code>setStyle()</code> method of the Subscriber,
    *   setting the <code>videoDisabledDisplayMode</code> property(or you can set the style when
    *   calling the <code>Session.subscribe()</code> method, setting the <code>style</code> property
    *   of the <code>properties</code> parameter).
    *   <p>
    *   This feature is only available in sessions that use the OpenTok Media Router (sessions with
    *   the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    *   set to routed), not in sessions with the media mode set to relayed.
    *   <p>
    *   You can disable this audio-only fallback feature, by setting the
    *   <code>audioFallbackEnabled</code> property to <code>false</code> in the options you pass
    *   into the <code>OT.initPublisher()</code> method on the publishing client. (See
    *   <a href="OT.html#initPublisher">OT.initPublisher()</a>.)
    *   </li>
    *
    *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
    *   video, by calling <code>subscribeToVideo(false)</code>.
    *   </li>
    *
    * </ul>
    *
    * @see VideoEnabledChangedEvent
    * @see <a href="Subscriber.html#event:videoDisableWarning">videoDisableWarning</a> event
    * @see <a href="Subscriber.html#event:videoEnabled">videoEnabled</a> event
    * @name videoDisabled
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched when the OpenTok Media Router determines that the stream quality has degraded
    * and the video will be disabled if the quality degrades more. If the quality degrades further,
    * the Subscriber disables the video and dispatches a <code>videoDisabled</code> event.
    * <p>
    * By default, the Subscriber displays a video disabled warning indicator when this event
    * is dispatched (and the video is disabled). You can control the display of this icon by
    * calling the <code>setStyle()</code> method and setting the
    * <code>videoDisabledDisplayMode</code> property (or you can set the style when calling
    * the <code>Session.subscribe()</code> method and setting the <code>style</code> property
    * of the <code>properties</code> parameter).
    * <p>
    * This feature is only available in sessions that use the OpenTok Media Router (sessions with
    * the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @see <a href="Subscriber.html#event:videoDisableWarningLifted">videoDisableWarningLifted</a> event
    * @name videoDisableWarning
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched when the Subscriber's video element is created. Add a listener for this event when
    * you set the <code>insertDefaultUI</code> option to <code>false</code> in the call to the
    * <a href="Session.html#subscribe">Session.subscribe()</a> method. The <code>element</code>
    * property of the event object is a reference to the Subscriber's <code>video</code> element
    * (or in Internet Explorer the <code>object</code> element containing the video). Add it to
    * the HTML DOM to display the video. When you set the <code>insertDefaultUI</code> option to
    * <code>false</code>, the <code>video</code> (or <code>object</code>) element is not automatically
    * inserted into the DOM.
    * <p>
    * Add a listener for this event only if you have set the <code>insertDefaultUI</code> option to
    * <code>false</code>. If you have not set <code>insertDefaultUI</code> option to
    * <code>false</code>, do not move the <code>video</code> (or <code>object</code>) element in
    * in the HTML DOM. Doing so causes the Subscriber object to be destroyed.
    *
    * @name videoElementCreated
    * @event
    * @memberof Subscriber
    * @see VideoElementCreatedEvent
    */ /**
    * Dispatched when the OpenTok Media Router determines that the stream quality has improved
    * to the point at which the video being disabled is not an immediate risk. This event is
    * dispatched after the Subscriber object dispatches a <code>videoDisableWarning</code> event.
    * <p>
    * This feature is only available in sessions that use the OpenTok Media Router (sessions with
    * the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    * set to routed), not in sessions with the media mode set to relayed.
    *
    * @see Event
    * @see <a href="Subscriber.html#event:videoDisableWarning">videoDisableWarning</a> event
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @name videoDisableWarningLifted
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched when the OpenTok Media Router resumes sending video to the subscriber
    * after video was previously disabled.
    * <p>
    * The <code>reason</code> property defines the reason the video was enabled. This can be set to
    * one of the following values:
    * <p>
    *
    * <ul>
    *
    *   <li><code>"codecChanged"</code> &mdash; The subscriber video was enabled after
    *   a codec change from an incompatible codec.</li>
    *
    *   <li><code>"publishVideo"</code> &mdash; The publisher started publishing video by calling
    *   <code>publishVideo(true)</code>.</li>
    *
    *   <li><code>"quality"</code> &mdash; The OpenTok Media Router resumed sending video
    *   to the subscriber based on stream quality changes. This feature of the OpenTok Media
    *   Router has a subscriber drop the video stream when connectivity degrades and then resume
    *   the video stream if the stream quality improves.
    *   <p>
    *   This feature is only available in sessions that use the OpenTok Media Router (sessions with
    *   the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    *   set to routed), not in sessions with the media mode set to relayed.
    *   </li>
    *
    *   <li><code>"subscribeToVideo"</code> &mdash; The subscriber started or stopped subscribing to
    *   video, by calling <code>subscribeToVideo(false)</code>.
    *   </li>
    *
    * </ul>
    *
    * <p>
    * To prevent video from resuming, in the <code>videoEnabled</code> event listener,
    * call <code>subscribeToVideo(false)</code> on the Subscriber object.
    *
    * @see VideoEnabledChangedEvent
    * @see <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event
    * @name videoEnabled
    * @event
    * @memberof Subscriber
    */ /**
    * Sent when the subscriber's stream has been interrupted.
    * <p>
    * In response to this event, you may want to provide a user interface notification, to let the
    * user know that the audio-video stream is temporarily disconnected and that the app is trying
    * to reconnect to it.
    * <p>
    * If the client reconnects to the stream, the Subscriber object dispatches a
    * <code>connected</code> event. Otherwise, if the client cannot reconnect to the stream,
    * the Subscriber object dispatches a <code>destroyed</code> event.
    *
    * @name disconnected
    * @event
    * @memberof Subscriber
    * @see <a href="Subscriber.html#event:connected">connected event</a>
    * @see Event
    */ /**
    * Sent when the subscriber's stream has resumed, after the Subscriber dispatches a
    * <code>disconnected</code> event.
    *
    * @name connected
    * @event
    * @memberof Subscriber
    * @see <a href="Subscriber.html#event:disconnected">disconnected event</a>
    * @see Event
    */ /**
    * Dispatched when the Subscriber element is removed from the HTML DOM. When this event is
    * dispatched, you may choose to adjust or remove HTML DOM elements related to the subscriber.
    * <p>
    * To prevent the Subscriber from being removed from the DOM when the stream is destroyed,
    * listen for the <a href="Session.html#event:streamDestroyed">streamDestroyed event</a>
    * dispatched by the Session object. The <code>streamDestroyed</code> event dispatched by the
    * Session object is cancelable, and calling the <code>preventDefault()</code> method of the
    * event object prevents Subscribers of the stream from being removed from the HTML DOM.
    *
    * @see Event
    * @name destroyed
    * @event
    * @memberof Subscriber
    */ /**
    * Dispatched when the video dimensions of the video change. This can occur when the
    * <code>stream.videoType</code> property is set to <code>"screen"</code> (for a screen-sharing
    * video stream), when the user resizes the window being captured. It can also occur if the video
    * is being published by a mobile device and the user rotates the device (causing the camera
    * orientation to change). This event object has a <code>newValue</code> property and an
    * <code>oldValue</code> property, representing the new and old dimensions of the video.
    * Each of these has a <code>height</code> property and a <code>width</code> property,
    * representing the height and width, in pixels.
    * @name videoDimensionsChanged
    * @event
    * @memberof Subscriber
    * @see VideoDimensionsChangedEvent
    */ return this;
                    };
                    Subscriber.hasAudioOutputLevelStatCapability = hasAudioOutputLevelStatCapability;
                    Subscriber.WidgetView = WidgetView;
                    Subscriber.SubscriberPeerConnection = SubscriberPeerConnection;
                    return Subscriber;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 304 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3); // @todo can we test for this instead?
            module1.exports = ()=>[
                    'Chrome',
                    'Opera',
                    'Safari'
                ].indexOf(env.name) > -1;
        /***/ },
        /* 305 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(3), name = _require.name; // @todo can we test for these?
            module1.exports = ()=>[
                    'Firefox',
                    'Safari',
                    'Edge',
                    'Chrome',
                    'Opera'
                ].indexOf(name) > -1;
        /***/ },
        /* 306 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const generateSimpleStateMachine = __webpack_require__(160)(); // Models a Subscriber's subscribing State
            //
            // Valid States:
            //     NotSubscribing            (the initial state
            //     Init                      (basic setup of DOM
            //     Connecting                (Failure Cases -> No Route, Bad Offer, Bad Answer
            //     BindingRemoteStream       (Failure Cases -> Anything to do with the media being
            //                               (invalid, the media never plays
            //     Subscribing               (this is 'onLoad'
            //     Failed                    (terminal state, with a reason that maps to one of the
            //                               (failure cases above
            //     Destroyed                 (The subscriber has been cleaned up, terminal state
            //
            //
            // Valid Transitions:
            //     NotSubscribing ->
            //         Init
            //
            //     Init ->
            //             Connecting
            //           | BindingRemoteStream         (if we are subscribing to ourselves and we alreay
            //                                         (have a stream
            //           | NotSubscribing              (destroy()
            //
            //     Connecting ->
            //             BindingRemoteStream
            //           | NotSubscribing
            //           | Failed
            //           | NotSubscribing              (destroy()
            //
            //     BindingRemoteStream ->
            //             Subscribing
            //           | Failed
            //           | NotSubscribing              (destroy()
            //
            //     Subscribing ->
            //             NotSubscribing              (unsubscribe
            //           | Failed                      (probably a peer connection failure after we began
            //                                         (subscribing
            //
            //     Failed ->
            //             Destroyed
            //
            //     Destroyed ->                        (terminal state)
            //
            //
            // @example
            //     var state = new SubscribingState(function(change) {
            //       console.log(change.message);
            //     });
            //
            //     state.set('Init');
            //     state.current;                 -> 'Init'
            //
            //     state.set('Subscribing');      -> triggers stateChangeFailed and logs out the error message
            //
            //
            const initialState = 'NotSubscribing';
            const validStates = [
                'NotSubscribing',
                'Init',
                'Connecting',
                'BindingRemoteStream',
                'Subscribing',
                'Failed',
                'Destroyed'
            ];
            const validTransitions = {
                NotSubscribing: [
                    'NotSubscribing',
                    'Init',
                    'Destroyed'
                ],
                Init: [
                    'NotSubscribing',
                    'Connecting',
                    'BindingRemoteStream',
                    'Destroyed'
                ],
                Connecting: [
                    'NotSubscribing',
                    'BindingRemoteStream',
                    'Failed',
                    'Destroyed'
                ],
                BindingRemoteStream: [
                    'NotSubscribing',
                    'Subscribing',
                    'Failed',
                    'Destroyed',
                    'BindingRemoteStream'
                ],
                Subscribing: [
                    'NotSubscribing',
                    'Failed',
                    'Destroyed',
                    'BindingRemoteStream'
                ],
                Failed: [
                    'Destroyed'
                ],
                Destroyed: []
            };
            const SubscribingState = generateSimpleStateMachine(initialState, validStates, validTransitions);
            SubscribingState.prototype.isDestroyed = function() {
                return this.current === 'Destroyed';
            };
            SubscribingState.prototype.isFailed = function() {
                return this.current === 'Failed';
            };
            SubscribingState.prototype.isSubscribing = function() {
                return this.current === 'Subscribing';
            };
            SubscribingState.prototype.isAttemptingToSubscribe = function() {
                return [
                    'Init',
                    'Connecting',
                    'BindingRemoteStream'
                ].indexOf(this.current) !== -1;
            };
            SubscribingState.prototype.isStreamAdded = function() {
                return this.current === 'BindingRemoteStream' || this.isSubscribing();
            };
            module1.exports = SubscribingState;
        /***/ },
        /* 307 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            module1.exports = (_ref)=>{
                let socket = _ref.socket, uri = _ref.uri, defaultContent = _ref.content;
                return (method, content)=>socket.send({
                        uri: uri,
                        method: method,
                        content: (0, _extends2.default)({}, defaultContent, content)
                    });
            };
        /***/ },
        /* 308 */ /***/ function(module1, exports, __webpack_require__) {
            (function webpackUniversalModuleDefinition(root, factory) {
                module1.exports = factory();
            })(this, function() {
                return /******/ function(modules) {
                    /******/ // The module cache
                    /******/ var installedModules = {};
                    /******/ /******/ // The require function
                    /******/ function __webpack_require__(moduleId) {
                        /******/ /******/ // Check if module is in cache
                        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                        /******/ // Create a new module (and put it into the cache)
                        /******/ var module1 = installedModules[moduleId] = {
                            /******/ i: moduleId,
                            /******/ l: false,
                            /******/ exports: {}
                        };
                        /******/ /******/ // Execute the module function
                        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                        /******/ /******/ // Flag the module as loaded
                        /******/ module1.l = true;
                        /******/ /******/ // Return the exports of the module
                        /******/ return module1.exports;
                    /******/ }
                    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
                    /******/ __webpack_require__.m = modules;
                    /******/ /******/ // expose the module cache
                    /******/ __webpack_require__.c = installedModules;
                    /******/ /******/ // identity function for calling harmony imports with the correct context
                    /******/ __webpack_require__.i = function(value) {
                        return value;
                    };
                    /******/ /******/ // define getter function for harmony exports
                    /******/ __webpack_require__.d = function(exports, name, getter) {
                        /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                            /******/ configurable: false,
                            /******/ enumerable: true,
                            /******/ get: getter
                        });
                    /******/ };
                    /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
                    /******/ __webpack_require__.n = function(module1) {
                        /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                            return module1['default'];
                        } : /******/ function getModuleExports() {
                            return module1;
                        };
                        /******/ __webpack_require__.d(getter, 'a', getter);
                        /******/ return getter;
                    /******/ };
                    /******/ /******/ // Object.prototype.hasOwnProperty.call
                    /******/ __webpack_require__.o = function(object, property) {
                        return Object.prototype.hasOwnProperty.call(object, property);
                    };
                    /******/ /******/ // __webpack_public_path__
                    /******/ __webpack_require__.p = "";
                    /******/ /******/ // Load entry module and return exports
                    /******/ return __webpack_require__(__webpack_require__.s = 5);
                /******/ }([
                    /* 0 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        module1.exports = function(target, sources) {
                            var n, source, key;
                            for(n = 1; n < arguments.length; n++){
                                source = arguments[n];
                                for(key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
                            }
                            return target;
                        };
                    /***/ },
                    /* 1 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        //-------------------------------------------------------------------------------------------------
                        var mixin = __webpack_require__(0);
                        //-------------------------------------------------------------------------------------------------
                        module1.exports = {
                            build: function(target, config) {
                                var n, max, plugin, plugins = config.plugins;
                                for(n = 0, max = plugins.length; n < max; n++){
                                    plugin = plugins[n];
                                    if (plugin.methods) mixin(target, plugin.methods);
                                    if (plugin.properties) Object.defineProperties(target, plugin.properties);
                                }
                            },
                            hook: function(fsm, name, additional) {
                                var n, max, method, plugin, plugins = fsm.config.plugins, args = [
                                    fsm.context
                                ];
                                if (additional) args = args.concat(additional);
                                for(n = 0, max = plugins.length; n < max; n++){
                                    plugin = plugins[n];
                                    method = plugins[n][name];
                                    if (method) method.apply(plugin, args);
                                }
                            }
                        };
                    //-------------------------------------------------------------------------------------------------
                    /***/ },
                    /* 2 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        //-------------------------------------------------------------------------------------------------
                        function camelize(label) {
                            if (label.length === 0) return label;
                            var n, result, word, words = label.split(/[_-]/);
                            // single word with first character already lowercase, return untouched
                            if (words.length === 1 && words[0][0].toLowerCase() === words[0][0]) return label;
                            result = words[0].toLowerCase();
                            for(n = 1; n < words.length; n++)result = result + words[n].charAt(0).toUpperCase() + words[n].substring(1).toLowerCase();
                            return result;
                        }
                        //-------------------------------------------------------------------------------------------------
                        camelize.prepended = function(prepend, label) {
                            label = camelize(label);
                            return prepend + label[0].toUpperCase() + label.substring(1);
                        };
                        //-------------------------------------------------------------------------------------------------
                        module1.exports = camelize;
                    /***/ },
                    /* 3 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        //-------------------------------------------------------------------------------------------------
                        var mixin = __webpack_require__(0), camelize = __webpack_require__(2);
                        //-------------------------------------------------------------------------------------------------
                        function Config(options, StateMachine) {
                            options = options || {};
                            this.options = options; // preserving original options can be useful (e.g visualize plugin)
                            this.defaults = StateMachine.defaults;
                            this.states = [];
                            this.transitions = [];
                            this.map = {};
                            this.lifecycle = this.configureLifecycle();
                            this.init = this.configureInitTransition(options.init);
                            this.data = this.configureData(options.data);
                            this.methods = this.configureMethods(options.methods);
                            this.map[this.defaults.wildcard] = {};
                            this.configureTransitions(options.transitions || []);
                            this.plugins = this.configurePlugins(options.plugins, StateMachine.plugin);
                        }
                        //-------------------------------------------------------------------------------------------------
                        mixin(Config.prototype, {
                            addState: function(name) {
                                if (!this.map[name]) {
                                    this.states.push(name);
                                    this.addStateLifecycleNames(name);
                                    this.map[name] = {};
                                }
                            },
                            addStateLifecycleNames: function(name) {
                                this.lifecycle.onEnter[name] = camelize.prepended('onEnter', name);
                                this.lifecycle.onLeave[name] = camelize.prepended('onLeave', name);
                                this.lifecycle.on[name] = camelize.prepended('on', name);
                            },
                            addTransition: function(name) {
                                if (this.transitions.indexOf(name) < 0) {
                                    this.transitions.push(name);
                                    this.addTransitionLifecycleNames(name);
                                }
                            },
                            addTransitionLifecycleNames: function(name) {
                                this.lifecycle.onBefore[name] = camelize.prepended('onBefore', name);
                                this.lifecycle.onAfter[name] = camelize.prepended('onAfter', name);
                                this.lifecycle.on[name] = camelize.prepended('on', name);
                            },
                            mapTransition: function(transition) {
                                var name = transition.name, from = transition.from, to = transition.to;
                                this.addState(from);
                                if (typeof to !== 'function') this.addState(to);
                                this.addTransition(name);
                                this.map[from][name] = transition;
                                return transition;
                            },
                            configureLifecycle: function() {
                                return {
                                    onBefore: {
                                        transition: 'onBeforeTransition'
                                    },
                                    onAfter: {
                                        transition: 'onAfterTransition'
                                    },
                                    onEnter: {
                                        state: 'onEnterState'
                                    },
                                    onLeave: {
                                        state: 'onLeaveState'
                                    },
                                    on: {
                                        transition: 'onTransition'
                                    }
                                };
                            },
                            configureInitTransition: function(init) {
                                if (typeof init === 'string') return this.mapTransition(mixin({}, this.defaults.init, {
                                    to: init,
                                    active: true
                                }));
                                else if (typeof init === 'object') return this.mapTransition(mixin({}, this.defaults.init, init, {
                                    active: true
                                }));
                                else {
                                    this.addState(this.defaults.init.from);
                                    return this.defaults.init;
                                }
                            },
                            configureData: function(data) {
                                if (typeof data === 'function') return data;
                                else if (typeof data === 'object') return function() {
                                    return data;
                                };
                                else return function() {
                                    return {};
                                };
                            },
                            configureMethods: function(methods) {
                                return methods || {};
                            },
                            configurePlugins: function(plugins, builtin) {
                                plugins = plugins || [];
                                var n, max, plugin;
                                for(n = 0, max = plugins.length; n < max; n++){
                                    plugin = plugins[n];
                                    if (typeof plugin === 'function') plugins[n] = plugin = plugin();
                                    if (plugin.configure) plugin.configure(this);
                                }
                                return plugins;
                            },
                            configureTransitions: function(transitions) {
                                var i, n, transition, from, to, wildcard = this.defaults.wildcard;
                                for(n = 0; n < transitions.length; n++){
                                    transition = transitions[n];
                                    from = Array.isArray(transition.from) ? transition.from : [
                                        transition.from || wildcard
                                    ];
                                    to = transition.to || wildcard;
                                    for(i = 0; i < from.length; i++)this.mapTransition({
                                        name: transition.name,
                                        from: from[i],
                                        to: to
                                    });
                                }
                            },
                            transitionFor: function(state, transition) {
                                var wildcard = this.defaults.wildcard;
                                return this.map[state][transition] || this.map[wildcard][transition];
                            },
                            transitionsFor: function(state) {
                                var wildcard = this.defaults.wildcard;
                                return Object.keys(this.map[state]).concat(Object.keys(this.map[wildcard]));
                            },
                            allStates: function() {
                                return this.states;
                            },
                            allTransitions: function() {
                                return this.transitions;
                            }
                        });
                        //-------------------------------------------------------------------------------------------------
                        module1.exports = Config;
                    //-------------------------------------------------------------------------------------------------
                    /***/ },
                    /* 4 */ /***/ function(module1, exports, __webpack_require__) {
                        var mixin = __webpack_require__(0), Exception = __webpack_require__(6), plugin = __webpack_require__(1), UNOBSERVED = [
                            null,
                            []
                        ];
                        //-------------------------------------------------------------------------------------------------
                        function JSM(context, config) {
                            this.context = context;
                            this.config = config;
                            this.state = config.init.from;
                            this.observers = [
                                context
                            ];
                        }
                        //-------------------------------------------------------------------------------------------------
                        mixin(JSM.prototype, {
                            init: function(args) {
                                mixin(this.context, this.config.data.apply(this.context, args));
                                plugin.hook(this, 'init');
                                if (this.config.init.active) return this.fire(this.config.init.name, []);
                            },
                            is: function(state) {
                                return Array.isArray(state) ? state.indexOf(this.state) >= 0 : this.state === state;
                            },
                            isPending: function() {
                                return this.pending;
                            },
                            can: function(transition) {
                                return !this.isPending() && !!this.seek(transition);
                            },
                            cannot: function(transition) {
                                return !this.can(transition);
                            },
                            allStates: function() {
                                return this.config.allStates();
                            },
                            allTransitions: function() {
                                return this.config.allTransitions();
                            },
                            transitions: function() {
                                return this.config.transitionsFor(this.state);
                            },
                            seek: function(transition, args) {
                                var wildcard = this.config.defaults.wildcard, entry = this.config.transitionFor(this.state, transition), to = entry && entry.to;
                                if (typeof to === 'function') return to.apply(this.context, args);
                                else if (to === wildcard) return this.state;
                                else return to;
                            },
                            fire: function(transition, args) {
                                return this.transit(transition, this.state, this.seek(transition, args), args);
                            },
                            transit: function(transition, from, to, args) {
                                var lifecycle = this.config.lifecycle, changed = this.config.options.observeUnchangedState || from !== to;
                                if (!to) return this.context.onInvalidTransition(transition, from, to);
                                if (this.isPending()) return this.context.onPendingTransition(transition, from, to);
                                this.config.addState(to); // might need to add this state if it's unknown (e.g. conditional transition or goto)
                                this.beginTransit();
                                args.unshift({
                                    transition: transition,
                                    from: from,
                                    to: to,
                                    fsm: this.context
                                });
                                return this.observeEvents([
                                    this.observersForEvent(lifecycle.onBefore.transition),
                                    this.observersForEvent(lifecycle.onBefore[transition]),
                                    changed ? this.observersForEvent(lifecycle.onLeave.state) : UNOBSERVED,
                                    changed ? this.observersForEvent(lifecycle.onLeave[from]) : UNOBSERVED,
                                    this.observersForEvent(lifecycle.on.transition),
                                    changed ? [
                                        'doTransit',
                                        [
                                            this
                                        ]
                                    ] : UNOBSERVED,
                                    changed ? this.observersForEvent(lifecycle.onEnter.state) : UNOBSERVED,
                                    changed ? this.observersForEvent(lifecycle.onEnter[to]) : UNOBSERVED,
                                    changed ? this.observersForEvent(lifecycle.on[to]) : UNOBSERVED,
                                    this.observersForEvent(lifecycle.onAfter.transition),
                                    this.observersForEvent(lifecycle.onAfter[transition]),
                                    this.observersForEvent(lifecycle.on[transition])
                                ], args);
                            },
                            beginTransit: function() {
                                this.pending = true;
                            },
                            endTransit: function(result) {
                                this.pending = false;
                                return result;
                            },
                            failTransit: function(result) {
                                this.pending = false;
                                throw result;
                            },
                            doTransit: function(lifecycle) {
                                this.state = lifecycle.to;
                            },
                            observe: function(args) {
                                if (args.length === 2) {
                                    var observer = {};
                                    observer[args[0]] = args[1];
                                    this.observers.push(observer);
                                } else this.observers.push(args[0]);
                            },
                            observersForEvent: function(event) {
                                var n = 0, max = this.observers.length, observer, result = [];
                                for(; n < max; n++){
                                    observer = this.observers[n];
                                    if (observer[event]) result.push(observer);
                                }
                                return [
                                    event,
                                    result,
                                    true
                                ];
                            },
                            observeEvents: function(events, args, previousEvent, previousResult) {
                                if (events.length === 0) return this.endTransit(previousResult === undefined ? true : previousResult);
                                var event = events[0][0], observers = events[0][1], pluggable = events[0][2];
                                args[0].event = event;
                                if (event && pluggable && event !== previousEvent) plugin.hook(this, 'lifecycle', args);
                                if (observers.length === 0) {
                                    events.shift();
                                    return this.observeEvents(events, args, event, previousResult);
                                } else {
                                    var observer = observers.shift(), result = observer[event].apply(observer, args);
                                    if (result && typeof result.then === 'function') return result.then(this.observeEvents.bind(this, events, args, event)).catch(this.failTransit.bind(this));
                                    else if (result === false) return this.endTransit(false);
                                    else return this.observeEvents(events, args, event, result);
                                }
                            },
                            onInvalidTransition: function(transition, from, to) {
                                throw new Exception("transition is invalid in current state", transition, from, to, this.state);
                            },
                            onPendingTransition: function(transition, from, to) {
                                throw new Exception("transition is invalid while previous transition is still in progress", transition, from, to, this.state);
                            }
                        });
                        //-------------------------------------------------------------------------------------------------
                        module1.exports = JSM;
                    //-------------------------------------------------------------------------------------------------
                    /***/ },
                    /* 5 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        //-----------------------------------------------------------------------------------------------
                        var mixin = __webpack_require__(0), camelize = __webpack_require__(2), plugin = __webpack_require__(1), Config = __webpack_require__(3), JSM = __webpack_require__(4);
                        //-----------------------------------------------------------------------------------------------
                        var PublicMethods = {
                            is: function(state) {
                                return this._fsm.is(state);
                            },
                            can: function(transition) {
                                return this._fsm.can(transition);
                            },
                            cannot: function(transition) {
                                return this._fsm.cannot(transition);
                            },
                            observe: function() {
                                return this._fsm.observe(arguments);
                            },
                            transitions: function() {
                                return this._fsm.transitions();
                            },
                            allTransitions: function() {
                                return this._fsm.allTransitions();
                            },
                            allStates: function() {
                                return this._fsm.allStates();
                            },
                            onInvalidTransition: function(t, from, to) {
                                return this._fsm.onInvalidTransition(t, from, to);
                            },
                            onPendingTransition: function(t, from, to) {
                                return this._fsm.onPendingTransition(t, from, to);
                            }
                        };
                        var PublicProperties = {
                            state: {
                                configurable: false,
                                enumerable: true,
                                get: function() {
                                    return this._fsm.state;
                                },
                                set: function(state) {
                                    throw Error('use transitions to change state');
                                }
                            }
                        };
                        //-----------------------------------------------------------------------------------------------
                        function StateMachine(options) {
                            return apply(this || {}, options);
                        }
                        function factory() {
                            var cstor, options;
                            if (typeof arguments[0] === 'function') {
                                cstor = arguments[0];
                                options = arguments[1] || {};
                            } else {
                                cstor = function() {
                                    this._fsm.apply(this, arguments);
                                };
                                options = arguments[0] || {};
                            }
                            var config = new Config(options, StateMachine);
                            build(cstor.prototype, config);
                            cstor.prototype._fsm.config = config; // convenience access to shared config without needing an instance
                            return cstor;
                        }
                        //-------------------------------------------------------------------------------------------------
                        function apply(instance, options) {
                            var config = new Config(options, StateMachine);
                            build(instance, config);
                            instance._fsm();
                            return instance;
                        }
                        function build(target, config) {
                            if (typeof target !== 'object' || Array.isArray(target)) throw Error('StateMachine can only be applied to objects');
                            plugin.build(target, config);
                            Object.defineProperties(target, PublicProperties);
                            mixin(target, PublicMethods);
                            mixin(target, config.methods);
                            config.allTransitions().forEach(function(transition) {
                                target[camelize(transition)] = function() {
                                    return this._fsm.fire(transition, [].slice.call(arguments));
                                };
                            });
                            target._fsm = function() {
                                this._fsm = new JSM(this, config);
                                this._fsm.init(arguments);
                            };
                        }
                        //-----------------------------------------------------------------------------------------------
                        StateMachine.version = '3.0.1';
                        StateMachine.factory = factory;
                        StateMachine.apply = apply;
                        StateMachine.defaults = {
                            wildcard: '*',
                            init: {
                                name: 'init',
                                from: 'none'
                            }
                        };
                        //===============================================================================================
                        module1.exports = StateMachine;
                    /***/ },
                    /* 6 */ /***/ function(module1, exports, __webpack_require__) {
                        "use strict";
                        module1.exports = function(message, transition, from, to, current) {
                            this.message = message;
                            this.transition = transition;
                            this.from = from;
                            this.to = to;
                            this.current = current;
                        };
                    /***/ }
                ]);
            });
        /***/ },
        /* 309 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const shouldUseStandardGetStats = __webpack_require__(102)(); // getRtcStatsReport is only supported on browsers that support the standard getStats API.
            module1.exports = shouldUseStandardGetStats;
        /***/ },
        /* 310 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /**
 * promisify - Promisify a node style callback function into a promise
 *
 * Returns a promisifed version of the function, if it's callback is called
 * with a truthy error parameter the promise will be rejected. If the callback
 * is called with one argument, it's value will be resolved. If the callback
 * is called with multiple arguments, the promise will resolve to an array
 * of those arguments.
 *
 * @param {function} fn Function to promisify
 * @returns {function} Promise returning function
 */ module1.exports = function promisify(fn) {
                    return function promisified() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return new Promise((resolve, reject)=>{
                            fn(...args, function(err) {
                                if (err) {
                                    reject(err);
                                    return;
                                }
                                for(var _len2 = arguments.length, callbackArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)callbackArgs[_key2 - 1] = arguments[_key2];
                                if (callbackArgs.length === 1) {
                                    resolve(callbackArgs[0]);
                                    return;
                                }
                                resolve(callbackArgs);
                            });
                        });
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 311 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(697), setVonageMetadata = _require.setVonageMetadata;
            const _require2 = __webpack_require__(312), createVonageMediaProcessorConnector = _require2.createVonageMediaProcessorConnector, setBackgroundOptions = _require2.setBackgroundOptions; // This is copy pasta from @vonage/media-processor, basically.  The only
            // difference is their's is an async call, whereas this one is synchronous.
            const isSupported = ()=>typeof MediaStreamTrackProcessor !== 'undefined' && typeof MediaStreamTrackGenerator !== 'undefined'; // Vonage's low-level machine-learning-based media processor libraries
            const ML = {
                isSupported: isSupported,
                setMetadata: setVonageMetadata,
                createConnector: createVonageMediaProcessorConnector,
                setBackgroundOptions: // Allows users to change background options in real-time, without having to
                // create destroy an MP connector
                setBackgroundOptions
            };
            module1.exports = ML;
        /***/ },
        /* 312 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* WEBPACK VAR INJECTION */ (function(Promise, process) {
                __webpack_require__.d(__webpack_exports__, "BlurRadius", function() {
                    return BlurRadius;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediapipeHelper", function() {
                    return MediapipeHelper;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageFacedetection", function() {
                    return VonageFacedetection;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageFacemash", function() {
                    return VonageFacemash;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageHands", function() {
                    return VonageHands;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageHolistic", function() {
                    return VonageHolistic;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageObjectron", function() {
                    return VonageObjectron;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonagePose", function() {
                    return VonagePose;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VonageSelfiesegmentation", function() {
                    return VonageSelfiesegmentation;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVonageMediaProcessorConnector", function() {
                    return createVonageMediaProcessorConnector;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVonageEventEmitter", function() {
                    return getVonageEventEmitter;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSupported", function() {
                    return isSupported;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBackgroundOptions", function() {
                    return setBackgroundOptions;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTrackExpectedRate", function() {
                    return setTrackExpectedRate;
                });
                function isSupported$1() {
                    return new Promise((resolve, reject)=>{
                        if (typeof MediaStreamTrackProcessor === "undefined" || typeof MediaStreamTrackGenerator === "undefined") reject("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.");
                        else resolve();
                    });
                }
                var axios$2 = {
                    exports: {}
                };
                var bind$2 = function bind(fn, thisArg) {
                    return function wrap() {
                        var args = new Array(arguments.length);
                        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                        return fn.apply(thisArg, args);
                    };
                };
                var bind$1 = bind$2;
                var toString = Object.prototype.toString;
                function isArray(val) {
                    return Array.isArray(val);
                }
                function isUndefined(val) {
                    return typeof val === "undefined";
                }
                function isBuffer(val) {
                    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
                }
                function isArrayBuffer(val) {
                    return toString.call(val) === "[object ArrayBuffer]";
                }
                function isFormData(val) {
                    return toString.call(val) === "[object FormData]";
                }
                function isArrayBufferView(val) {
                    var result;
                    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
                    else result = val && val.buffer && isArrayBuffer(val.buffer);
                    return result;
                }
                function isString(val) {
                    return typeof val === "string";
                }
                function isNumber(val) {
                    return typeof val === "number";
                }
                function isObject(val) {
                    return val !== null && typeof val === "object";
                }
                function isPlainObject(val) {
                    if (toString.call(val) !== "[object Object]") return false;
                    var prototype = Object.getPrototypeOf(val);
                    return prototype === null || prototype === Object.prototype;
                }
                function isDate(val) {
                    return toString.call(val) === "[object Date]";
                }
                function isFile(val) {
                    return toString.call(val) === "[object File]";
                }
                function isBlob(val) {
                    return toString.call(val) === "[object Blob]";
                }
                function isFunction(val) {
                    return toString.call(val) === "[object Function]";
                }
                function isStream(val) {
                    return isObject(val) && isFunction(val.pipe);
                }
                function isURLSearchParams(val) {
                    return toString.call(val) === "[object URLSearchParams]";
                }
                function trim(str) {
                    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
                }
                function isStandardBrowserEnv() {
                    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
                    return typeof window !== "undefined" && typeof document !== "undefined";
                }
                function forEach(obj, fn) {
                    if (obj === null || typeof obj === "undefined") return;
                    if (typeof obj !== "object") obj = [
                        obj
                    ];
                    if (isArray(obj)) for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
                    else {
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
                    }
                }
                function merge() {
                    var result = {};
                    function assignValue(val, key) {
                        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
                        else if (isPlainObject(val)) result[key] = merge({}, val);
                        else if (isArray(val)) result[key] = val.slice();
                        else result[key] = val;
                    }
                    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
                    return result;
                }
                function extend(a, b, thisArg) {
                    forEach(b, function assignValue(val, key) {
                        if (thisArg && typeof val === "function") a[key] = bind$1(val, thisArg);
                        else a[key] = val;
                    });
                    return a;
                }
                function stripBOM(content) {
                    if (content.charCodeAt(0) === 65279) content = content.slice(1);
                    return content;
                }
                var utils$e = {
                    isArray: isArray,
                    isArrayBuffer: isArrayBuffer,
                    isBuffer: isBuffer,
                    isFormData: isFormData,
                    isArrayBufferView: isArrayBufferView,
                    isString: isString,
                    isNumber: isNumber,
                    isObject: isObject,
                    isPlainObject: isPlainObject,
                    isUndefined: isUndefined,
                    isDate: isDate,
                    isFile: isFile,
                    isBlob: isBlob,
                    isFunction: isFunction,
                    isStream: isStream,
                    isURLSearchParams: isURLSearchParams,
                    isStandardBrowserEnv: isStandardBrowserEnv,
                    forEach: forEach,
                    merge: merge,
                    extend: extend,
                    trim: trim,
                    stripBOM: stripBOM
                };
                var utils$d = utils$e;
                function encode(val) {
                    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                }
                var buildURL$2 = function buildURL(url, params, paramsSerializer) {
                    if (!params) return url;
                    var serializedParams;
                    if (paramsSerializer) serializedParams = paramsSerializer(params);
                    else if (utils$d.isURLSearchParams(params)) serializedParams = params.toString();
                    else {
                        var parts = [];
                        utils$d.forEach(params, function serialize(val, key) {
                            if (val === null || typeof val === "undefined") return;
                            if (utils$d.isArray(val)) key = key + "[]";
                            else val = [
                                val
                            ];
                            utils$d.forEach(val, function parseValue(v) {
                                if (utils$d.isDate(v)) v = v.toISOString();
                                else if (utils$d.isObject(v)) v = JSON.stringify(v);
                                parts.push(encode(key) + "=" + encode(v));
                            });
                        });
                        serializedParams = parts.join("&");
                    }
                    if (serializedParams) {
                        var hashmarkIndex = url.indexOf("#");
                        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
                        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    }
                    return url;
                };
                var utils$c = utils$e;
                function InterceptorManager$1() {
                    this.handlers = [];
                }
                InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
                    this.handlers.push({
                        fulfilled: fulfilled,
                        rejected: rejected,
                        synchronous: options ? options.synchronous : false,
                        runWhen: options ? options.runWhen : null
                    });
                    return this.handlers.length - 1;
                };
                InterceptorManager$1.prototype.eject = function eject(id) {
                    if (this.handlers[id]) this.handlers[id] = null;
                };
                InterceptorManager$1.prototype.forEach = function forEach2(fn) {
                    utils$c.forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                };
                var InterceptorManager_1 = InterceptorManager$1;
                var utils$b = utils$e;
                var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
                    utils$b.forEach(headers, function processHeader(value, name) {
                        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                            headers[normalizedName] = value;
                            delete headers[name];
                        }
                    });
                };
                var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
                    error.config = config;
                    if (code) error.code = code;
                    error.request = request2;
                    error.response = response;
                    error.isAxiosError = true;
                    error.toJSON = function toJSON() {
                        return {
                            message: this.message,
                            name: this.name,
                            description: this.description,
                            number: this.number,
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            config: this.config,
                            code: this.code,
                            status: this.response && this.response.status ? this.response.status : null
                        };
                    };
                    return error;
                };
                var enhanceError$1 = enhanceError$2;
                var createError$2 = function createError(message, config, code, request2, response) {
                    var error = new Error(message);
                    return enhanceError$1(error, config, code, request2, response);
                };
                var createError$1 = createError$2;
                var settle$1 = function settle(resolve, reject, response) {
                    var validateStatus2 = response.config.validateStatus;
                    if (!response.status || !validateStatus2 || validateStatus2(response.status)) resolve(response);
                    else reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
                };
                var utils$a = utils$e;
                var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
                    return {
                        write: function write(name, value, expires, path, domain, secure) {
                            var cookie = [];
                            cookie.push(name + "=" + encodeURIComponent(value));
                            if (utils$a.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
                            if (utils$a.isString(path)) cookie.push("path=" + path);
                            if (utils$a.isString(domain)) cookie.push("domain=" + domain);
                            if (secure === true) cookie.push("secure");
                            document.cookie = cookie.join("; ");
                        },
                        read: function read(name) {
                            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
                            return match ? decodeURIComponent(match[3]) : null;
                        },
                        remove: function remove(name) {
                            this.write(name, "", Date.now() - 864e5);
                        }
                    };
                }() : function nonStandardBrowserEnv() {
                    return {
                        write: function write() {},
                        read: function read() {
                            return null;
                        },
                        remove: function remove() {}
                    };
                }();
                var isAbsoluteURL$1 = function isAbsoluteURL(url) {
                    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
                };
                var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
                    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
                };
                var isAbsoluteURL2 = isAbsoluteURL$1;
                var combineURLs2 = combineURLs$1;
                var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
                    if (baseURL && !isAbsoluteURL2(requestedURL)) return combineURLs2(baseURL, requestedURL);
                    return requestedURL;
                };
                var utils$9 = utils$e;
                var ignoreDuplicateOf = [
                    "age",
                    "authorization",
                    "content-length",
                    "content-type",
                    "etag",
                    "expires",
                    "from",
                    "host",
                    "if-modified-since",
                    "if-unmodified-since",
                    "last-modified",
                    "location",
                    "max-forwards",
                    "proxy-authorization",
                    "referer",
                    "retry-after",
                    "user-agent"
                ];
                var parseHeaders$1 = function parseHeaders(headers) {
                    var parsed = {};
                    var key;
                    var val;
                    var i;
                    if (!headers) return parsed;
                    utils$9.forEach(headers.split("\n"), function parser(line) {
                        i = line.indexOf(":");
                        key = utils$9.trim(line.substr(0, i)).toLowerCase();
                        val = utils$9.trim(line.substr(i + 1));
                        if (key) {
                            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                                val
                            ]);
                            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
                        }
                    });
                    return parsed;
                };
                var utils$8 = utils$e;
                var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
                    var msie = /(msie|trident)/i.test(navigator.userAgent);
                    var urlParsingNode = document.createElement("a");
                    var originURL;
                    function resolveURL(url) {
                        var href = url;
                        if (msie) {
                            urlParsingNode.setAttribute("href", href);
                            href = urlParsingNode.href;
                        }
                        urlParsingNode.setAttribute("href", href);
                        return {
                            href: urlParsingNode.href,
                            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
                            host: urlParsingNode.host,
                            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
                            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
                            hostname: urlParsingNode.hostname,
                            port: urlParsingNode.port,
                            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
                        };
                    }
                    originURL = resolveURL(window.location.href);
                    return function isURLSameOrigin2(requestURL) {
                        var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                    };
                }() : function nonStandardBrowserEnv2() {
                    return function isURLSameOrigin2() {
                        return true;
                    };
                }();
                function Cancel$3(message) {
                    this.message = message;
                }
                Cancel$3.prototype.toString = function toString2() {
                    return "Cancel" + (this.message ? ": " + this.message : "");
                };
                Cancel$3.prototype.__CANCEL__ = true;
                var Cancel_1 = Cancel$3;
                var utils$7 = utils$e;
                var settle2 = settle$1;
                var cookies = cookies$1;
                var buildURL$1 = buildURL$2;
                var buildFullPath2 = buildFullPath$1;
                var parseHeaders2 = parseHeaders$1;
                var isURLSameOrigin = isURLSameOrigin$1;
                var createError2 = createError$2;
                var defaults$4 = defaults_1;
                var Cancel$2 = Cancel_1;
                var xhr = function xhrAdapter(config) {
                    return new Promise(function dispatchXhrRequest(resolve, reject) {
                        var requestData = config.data;
                        var requestHeaders = config.headers;
                        var responseType = config.responseType;
                        var onCanceled;
                        function done() {
                            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
                            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
                        }
                        if (utils$7.isFormData(requestData)) delete requestHeaders["Content-Type"];
                        var request2 = new XMLHttpRequest();
                        if (config.auth) {
                            var username = config.auth.username || "";
                            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
                            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
                        }
                        var fullPath = buildFullPath2(config.baseURL, config.url);
                        request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
                        request2.timeout = config.timeout;
                        function onloadend() {
                            if (!request2) return;
                            var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
                            var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
                            var response = {
                                data: responseData,
                                status: request2.status,
                                statusText: request2.statusText,
                                headers: responseHeaders,
                                config: config,
                                request: request2
                            };
                            settle2(function _resolve(value) {
                                resolve(value);
                                done();
                            }, function _reject(err) {
                                reject(err);
                                done();
                            }, response);
                            request2 = null;
                        }
                        if ("onloadend" in request2) request2.onloadend = onloadend;
                        else request2.onreadystatechange = function handleLoad() {
                            if (!request2 || request2.readyState !== 4) return;
                            if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) return;
                            setTimeout(onloadend);
                        };
                        request2.onabort = function handleAbort() {
                            if (!request2) return;
                            reject(createError2("Request aborted", config, "ECONNABORTED", request2));
                            request2 = null;
                        };
                        request2.onerror = function handleError() {
                            reject(createError2("Network Error", config, null, request2));
                            request2 = null;
                        };
                        request2.ontimeout = function handleTimeout() {
                            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
                            var transitional2 = config.transitional || defaults$4.transitional;
                            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
                            reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
                            request2 = null;
                        };
                        if (utils$7.isStandardBrowserEnv()) {
                            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
                            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
                        }
                        if ("setRequestHeader" in request2) utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
                            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") delete requestHeaders[key];
                            else request2.setRequestHeader(key, val);
                        });
                        if (!utils$7.isUndefined(config.withCredentials)) request2.withCredentials = !!config.withCredentials;
                        if (responseType && responseType !== "json") request2.responseType = config.responseType;
                        if (typeof config.onDownloadProgress === "function") request2.addEventListener("progress", config.onDownloadProgress);
                        if (typeof config.onUploadProgress === "function" && request2.upload) request2.upload.addEventListener("progress", config.onUploadProgress);
                        if (config.cancelToken || config.signal) {
                            onCanceled = function(cancel) {
                                if (!request2) return;
                                reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
                                request2.abort();
                                request2 = null;
                            };
                            config.cancelToken && config.cancelToken.subscribe(onCanceled);
                            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
                        }
                        if (!requestData) requestData = null;
                        request2.send(requestData);
                    });
                };
                var utils$6 = utils$e;
                var normalizeHeaderName2 = normalizeHeaderName$1;
                var enhanceError2 = enhanceError$2;
                var DEFAULT_CONTENT_TYPE = {
                    "Content-Type": "application/x-www-form-urlencoded"
                };
                function setContentTypeIfUnset(headers, value) {
                    if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
                }
                function getDefaultAdapter() {
                    var adapter;
                    if (typeof XMLHttpRequest !== "undefined") adapter = xhr;
                    else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") adapter = xhr;
                    return adapter;
                }
                function stringifySafely(rawValue, parser, encoder) {
                    if (utils$6.isString(rawValue)) try {
                        (parser || JSON.parse)(rawValue);
                        return utils$6.trim(rawValue);
                    } catch (e) {
                        if (e.name !== "SyntaxError") throw e;
                    }
                    return (encoder || JSON.stringify)(rawValue);
                }
                var defaults$3 = {
                    transitional: {
                        silentJSONParsing: true,
                        forcedJSONParsing: true,
                        clarifyTimeoutError: false
                    },
                    adapter: getDefaultAdapter(),
                    transformRequest: [
                        function transformRequest(data2, headers) {
                            normalizeHeaderName2(headers, "Accept");
                            normalizeHeaderName2(headers, "Content-Type");
                            if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) return data2;
                            if (utils$6.isArrayBufferView(data2)) return data2.buffer;
                            if (utils$6.isURLSearchParams(data2)) {
                                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                                return data2.toString();
                            }
                            if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
                                setContentTypeIfUnset(headers, "application/json");
                                return stringifySafely(data2);
                            }
                            return data2;
                        }
                    ],
                    transformResponse: [
                        function transformResponse(data2) {
                            var transitional2 = this.transitional || defaults$3.transitional;
                            var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
                            var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
                            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
                            if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) try {
                                return JSON.parse(data2);
                            } catch (e) {
                                if (strictJSONParsing) {
                                    if (e.name === "SyntaxError") throw enhanceError2(e, this, "E_JSON_PARSE");
                                    throw e;
                                }
                            }
                            return data2;
                        }
                    ],
                    timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function validateStatus(status) {
                        return status >= 200 && status < 300;
                    },
                    headers: {
                        common: {
                            "Accept": "application/json, text/plain, */*"
                        }
                    }
                };
                utils$6.forEach([
                    "delete",
                    "get",
                    "head"
                ], function forEachMethodNoData(method) {
                    defaults$3.headers[method] = {};
                });
                utils$6.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
                });
                var defaults_1 = defaults$3;
                var utils$5 = utils$e;
                var defaults$2 = defaults_1;
                var transformData$1 = function transformData(data2, headers, fns) {
                    var context = this || defaults$2;
                    utils$5.forEach(fns, function transform(fn) {
                        data2 = fn.call(context, data2, headers);
                    });
                    return data2;
                };
                var isCancel$1 = function isCancel(value) {
                    return !!(value && value.__CANCEL__);
                };
                var utils$4 = utils$e;
                var transformData2 = transformData$1;
                var isCancel2 = isCancel$1;
                var defaults$1 = defaults_1;
                var Cancel$1 = Cancel_1;
                function throwIfCancellationRequested(config) {
                    if (config.cancelToken) config.cancelToken.throwIfRequested();
                    if (config.signal && config.signal.aborted) throw new Cancel$1("canceled");
                }
                var dispatchRequest$1 = function dispatchRequest(config) {
                    throwIfCancellationRequested(config);
                    config.headers = config.headers || {};
                    config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
                    config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
                    utils$4.forEach([
                        "delete",
                        "get",
                        "head",
                        "post",
                        "put",
                        "patch",
                        "common"
                    ], function cleanHeaderConfig(method) {
                        delete config.headers[method];
                    });
                    var adapter = config.adapter || defaults$1.adapter;
                    return adapter(config).then(function onAdapterResolution(response) {
                        throwIfCancellationRequested(config);
                        response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
                        return response;
                    }, function onAdapterRejection(reason) {
                        if (!isCancel2(reason)) {
                            throwIfCancellationRequested(config);
                            if (reason && reason.response) reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
                        }
                        return Promise.reject(reason);
                    });
                };
                var utils$3 = utils$e;
                var mergeConfig$2 = function mergeConfig(config1, config2) {
                    config2 = config2 || {};
                    var config = {};
                    function getMergedValue(target, source2) {
                        if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) return utils$3.merge(target, source2);
                        else if (utils$3.isPlainObject(source2)) return utils$3.merge({}, source2);
                        else if (utils$3.isArray(source2)) return source2.slice();
                        return source2;
                    }
                    function mergeDeepProperties(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
                        else if (!utils$3.isUndefined(config1[prop])) return getMergedValue(void 0, config1[prop]);
                    }
                    function valueFromConfig2(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(void 0, config2[prop]);
                    }
                    function defaultToConfig2(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(void 0, config2[prop]);
                        else if (!utils$3.isUndefined(config1[prop])) return getMergedValue(void 0, config1[prop]);
                    }
                    function mergeDirectKeys(prop) {
                        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
                        else if (prop in config1) return getMergedValue(void 0, config1[prop]);
                    }
                    var mergeMap = {
                        "url": valueFromConfig2,
                        "method": valueFromConfig2,
                        "data": valueFromConfig2,
                        "baseURL": defaultToConfig2,
                        "transformRequest": defaultToConfig2,
                        "transformResponse": defaultToConfig2,
                        "paramsSerializer": defaultToConfig2,
                        "timeout": defaultToConfig2,
                        "timeoutMessage": defaultToConfig2,
                        "withCredentials": defaultToConfig2,
                        "adapter": defaultToConfig2,
                        "responseType": defaultToConfig2,
                        "xsrfCookieName": defaultToConfig2,
                        "xsrfHeaderName": defaultToConfig2,
                        "onUploadProgress": defaultToConfig2,
                        "onDownloadProgress": defaultToConfig2,
                        "decompress": defaultToConfig2,
                        "maxContentLength": defaultToConfig2,
                        "maxBodyLength": defaultToConfig2,
                        "transport": defaultToConfig2,
                        "httpAgent": defaultToConfig2,
                        "httpsAgent": defaultToConfig2,
                        "cancelToken": defaultToConfig2,
                        "socketPath": defaultToConfig2,
                        "responseEncoding": defaultToConfig2,
                        "validateStatus": mergeDirectKeys
                    };
                    utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
                        var merge2 = mergeMap[prop] || mergeDeepProperties;
                        var configValue = merge2(prop);
                        utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
                    });
                    return config;
                };
                var data = {
                    "version": "0.25.0"
                };
                var VERSION = data.version;
                var validators$1 = {};
                [
                    "object",
                    "boolean",
                    "number",
                    "function",
                    "string",
                    "symbol"
                ].forEach(function(type, i) {
                    validators$1[type] = function validator2(thing) {
                        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
                    };
                });
                var deprecatedWarnings = {};
                validators$1.transitional = function transitional(validator2, version2, message) {
                    function formatMessage(opt, desc) {
                        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
                    }
                    return function(value, opt, opts) {
                        if (validator2 === false) throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
                        if (version2 && !deprecatedWarnings[opt]) {
                            deprecatedWarnings[opt] = true;
                            console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
                        }
                        return validator2 ? validator2(value, opt, opts) : true;
                    };
                };
                function assertOptions(options, schema, allowUnknown) {
                    if (typeof options !== "object") throw new TypeError("options must be an object");
                    var keys = Object.keys(options);
                    var i = keys.length;
                    while(i-- > 0){
                        var opt = keys[i];
                        var validator2 = schema[opt];
                        if (validator2) {
                            var value = options[opt];
                            var result = value === void 0 || validator2(value, opt, options);
                            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
                            continue;
                        }
                        if (allowUnknown !== true) throw Error("Unknown option " + opt);
                    }
                }
                var validator$1 = {
                    assertOptions: assertOptions,
                    validators: validators$1
                };
                var utils$2 = utils$e;
                var buildURL2 = buildURL$2;
                var InterceptorManager = InterceptorManager_1;
                var dispatchRequest2 = dispatchRequest$1;
                var mergeConfig$1 = mergeConfig$2;
                var validator = validator$1;
                var validators = validator.validators;
                function Axios$1(instanceConfig) {
                    this.defaults = instanceConfig;
                    this.interceptors = {
                        request: new InterceptorManager(),
                        response: new InterceptorManager()
                    };
                }
                Axios$1.prototype.request = function request(configOrUrl, config) {
                    if (typeof configOrUrl === "string") {
                        config = config || {};
                        config.url = configOrUrl;
                    } else config = configOrUrl || {};
                    if (!config.url) throw new Error("Provided config url is not valid");
                    config = mergeConfig$1(this.defaults, config);
                    if (config.method) config.method = config.method.toLowerCase();
                    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
                    else config.method = "get";
                    var transitional2 = config.transitional;
                    if (transitional2 !== void 0) validator.assertOptions(transitional2, {
                        silentJSONParsing: validators.transitional(validators.boolean),
                        forcedJSONParsing: validators.transitional(validators.boolean),
                        clarifyTimeoutError: validators.transitional(validators.boolean)
                    }, false);
                    var requestInterceptorChain = [];
                    var synchronousRequestInterceptors = true;
                    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                    });
                    var responseInterceptorChain = [];
                    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                    });
                    var promise;
                    if (!synchronousRequestInterceptors) {
                        var chain = [
                            dispatchRequest2,
                            void 0
                        ];
                        Array.prototype.unshift.apply(chain, requestInterceptorChain);
                        chain = chain.concat(responseInterceptorChain);
                        promise = Promise.resolve(config);
                        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
                        return promise;
                    }
                    var newConfig = config;
                    while(requestInterceptorChain.length){
                        var onFulfilled = requestInterceptorChain.shift();
                        var onRejected = requestInterceptorChain.shift();
                        try {
                            newConfig = onFulfilled(newConfig);
                        } catch (error) {
                            onRejected(error);
                            break;
                        }
                    }
                    try {
                        promise = dispatchRequest2(newConfig);
                    } catch (error) {
                        return Promise.reject(error);
                    }
                    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
                    return promise;
                };
                Axios$1.prototype.getUri = function getUri(config) {
                    if (!config.url) throw new Error("Provided config url is not valid");
                    config = mergeConfig$1(this.defaults, config);
                    return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
                };
                utils$2.forEach([
                    "delete",
                    "get",
                    "head",
                    "options"
                ], function forEachMethodNoData2(method) {
                    Axios$1.prototype[method] = function(url, config) {
                        return this.request(mergeConfig$1(config || {}, {
                            method: method,
                            url: url,
                            data: (config || {}).data
                        }));
                    };
                });
                utils$2.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData2(method) {
                    Axios$1.prototype[method] = function(url, data2, config) {
                        return this.request(mergeConfig$1(config || {}, {
                            method: method,
                            url: url,
                            data: data2
                        }));
                    };
                });
                var Axios_1 = Axios$1;
                var Cancel = Cancel_1;
                function CancelToken(executor) {
                    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
                    var resolvePromise;
                    this.promise = new Promise(function promiseExecutor(resolve) {
                        resolvePromise = resolve;
                    });
                    var token = this;
                    this.promise.then(function(cancel) {
                        if (!token._listeners) return;
                        var i;
                        var l = token._listeners.length;
                        for(i = 0; i < l; i++)token._listeners[i](cancel);
                        token._listeners = null;
                    });
                    this.promise.then = function(onfulfilled) {
                        var _resolve;
                        var promise = new Promise(function(resolve) {
                            token.subscribe(resolve);
                            _resolve = resolve;
                        }).then(onfulfilled);
                        promise.cancel = function reject() {
                            token.unsubscribe(_resolve);
                        };
                        return promise;
                    };
                    executor(function cancel(message) {
                        if (token.reason) return;
                        token.reason = new Cancel(message);
                        resolvePromise(token.reason);
                    });
                }
                CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                    if (this.reason) throw this.reason;
                };
                CancelToken.prototype.subscribe = function subscribe(listener) {
                    if (this.reason) {
                        listener(this.reason);
                        return;
                    }
                    if (this._listeners) this._listeners.push(listener);
                    else this._listeners = [
                        listener
                    ];
                };
                CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
                    if (!this._listeners) return;
                    var index = this._listeners.indexOf(listener);
                    if (index !== -1) this._listeners.splice(index, 1);
                };
                CancelToken.source = function source() {
                    var cancel;
                    var token = new CancelToken(function executor(c) {
                        cancel = c;
                    });
                    return {
                        token: token,
                        cancel: cancel
                    };
                };
                var CancelToken_1 = CancelToken;
                var spread = function spread2(callback) {
                    return function wrap(arr) {
                        return callback.apply(null, arr);
                    };
                };
                var utils$1 = utils$e;
                var isAxiosError = function isAxiosError2(payload) {
                    return utils$1.isObject(payload) && payload.isAxiosError === true;
                };
                var utils = utils$e;
                var bind2 = bind$2;
                var Axios = Axios_1;
                var mergeConfig2 = mergeConfig$2;
                var defaults = defaults_1;
                function createInstance(defaultConfig) {
                    var context = new Axios(defaultConfig);
                    var instance = bind2(Axios.prototype.request, context);
                    utils.extend(instance, Axios.prototype, context);
                    utils.extend(instance, context);
                    instance.create = function create(instanceConfig) {
                        return createInstance(mergeConfig2(defaultConfig, instanceConfig));
                    };
                    return instance;
                }
                var axios$1 = createInstance(defaults);
                axios$1.Axios = Axios;
                axios$1.Cancel = Cancel_1;
                axios$1.CancelToken = CancelToken_1;
                axios$1.isCancel = isCancel$1;
                axios$1.VERSION = data.version;
                axios$1.all = function all(promises) {
                    return Promise.all(promises);
                };
                axios$1.spread = spread;
                axios$1.isAxiosError = isAxiosError;
                axios$2.exports = axios$1;
                axios$2.exports.default = axios$1;
                function getVonageMetadata() {
                    return globalThis._vonageMediaProcessorMetadata;
                }
                var byteToHex = [];
                for(var i = 0; i < 256; ++i)byteToHex.push((i + 256).toString(16).substr(1));
                const anyMap$1 = /* @__PURE__ */ new WeakMap();
                const eventsMap$1 = /* @__PURE__ */ new WeakMap();
                const producersMap$1 = /* @__PURE__ */ new WeakMap();
                const anyProducer$1 = Symbol("anyProducer");
                const resolvedPromise$1 = Promise.resolve();
                const listenerAdded$1 = Symbol("listenerAdded");
                const listenerRemoved$1 = Symbol("listenerRemoved");
                let isGlobalDebugEnabled$1 = false;
                function assertEventName$1(eventName) {
                    if (typeof eventName !== "string" && typeof eventName !== "symbol") throw new TypeError("eventName must be a string or a symbol");
                }
                function assertListener$1(listener) {
                    if (typeof listener !== "function") throw new TypeError("listener must be a function");
                }
                function getListeners$1(instance, eventName) {
                    const events = eventsMap$1.get(instance);
                    if (!events.has(eventName)) events.set(eventName, /* @__PURE__ */ new Set());
                    return events.get(eventName);
                }
                function getEventProducers$1(instance, eventName) {
                    const key = typeof eventName === "string" || typeof eventName === "symbol" ? eventName : anyProducer$1;
                    const producers = producersMap$1.get(instance);
                    if (!producers.has(key)) producers.set(key, /* @__PURE__ */ new Set());
                    return producers.get(key);
                }
                function enqueueProducers$1(instance, eventName, eventData) {
                    const producers = producersMap$1.get(instance);
                    if (producers.has(eventName)) for (const producer of producers.get(eventName))producer.enqueue(eventData);
                    if (producers.has(anyProducer$1)) {
                        const item = Promise.all([
                            eventName,
                            eventData
                        ]);
                        for (const producer of producers.get(anyProducer$1))producer.enqueue(item);
                    }
                }
                function iterator$1(instance, eventNames) {
                    eventNames = Array.isArray(eventNames) ? eventNames : [
                        eventNames
                    ];
                    let isFinished = false;
                    let flush = ()=>{};
                    let queue = [];
                    const producer = {
                        enqueue (item) {
                            queue.push(item);
                            flush();
                        },
                        finish () {
                            isFinished = true;
                            flush();
                        }
                    };
                    for (const eventName of eventNames)getEventProducers$1(instance, eventName).add(producer);
                    return {
                        async next () {
                            if (!queue) return {
                                done: true
                            };
                            if (queue.length === 0) {
                                if (isFinished) {
                                    queue = void 0;
                                    return this.next();
                                }
                                await new Promise((resolve)=>{
                                    flush = resolve;
                                });
                                return this.next();
                            }
                            return {
                                done: false,
                                value: await queue.shift()
                            };
                        },
                        async return (value) {
                            queue = void 0;
                            for (const eventName of eventNames)getEventProducers$1(instance, eventName).delete(producer);
                            flush();
                            return arguments.length > 0 ? {
                                done: true,
                                value: await value
                            } : {
                                done: true
                            };
                        },
                        [Symbol.asyncIterator] () {
                            return this;
                        }
                    };
                }
                function defaultMethodNamesOrAssert$1(methodNames) {
                    if (methodNames === void 0) return allEmitteryMethods$1;
                    if (!Array.isArray(methodNames)) throw new TypeError("`methodNames` must be an array of strings");
                    for (const methodName of methodNames)if (!allEmitteryMethods$1.includes(methodName)) {
                        if (typeof methodName !== "string") throw new TypeError("`methodNames` element must be a string");
                        throw new Error(`${methodName} is not Emittery method`);
                    }
                    return methodNames;
                }
                const isListenerSymbol$1 = (symbol)=>symbol === listenerAdded$1 || symbol === listenerRemoved$1;
                class Emittery$1 {
                    static mixin(emitteryPropertyName, methodNames) {
                        methodNames = defaultMethodNamesOrAssert$1(methodNames);
                        return (target)=>{
                            if (typeof target !== "function") throw new TypeError("`target` must be function");
                            for (const methodName of methodNames){
                                if (target.prototype[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            }
                            function getEmitteryProperty() {
                                Object.defineProperty(this, emitteryPropertyName, {
                                    enumerable: false,
                                    value: new Emittery$1()
                                });
                                return this[emitteryPropertyName];
                            }
                            Object.defineProperty(target.prototype, emitteryPropertyName, {
                                enumerable: false,
                                get: getEmitteryProperty
                            });
                            const emitteryMethodCaller = (methodName)=>function(...args) {
                                    return this[emitteryPropertyName][methodName](...args);
                                };
                            for (const methodName of methodNames)Object.defineProperty(target.prototype, methodName, {
                                enumerable: false,
                                value: emitteryMethodCaller(methodName)
                            });
                            return target;
                        };
                    }
                    static get isDebugEnabled() {
                        if (typeof process !== "object") return isGlobalDebugEnabled$1;
                        const { env } = process || {
                            env: {}
                        };
                        return env.DEBUG === "emittery" || env.DEBUG === "*" || isGlobalDebugEnabled$1;
                    }
                    static set isDebugEnabled(newValue) {
                        isGlobalDebugEnabled$1 = newValue;
                    }
                    constructor(options = {}){
                        anyMap$1.set(this, /* @__PURE__ */ new Set());
                        eventsMap$1.set(this, /* @__PURE__ */ new Map());
                        producersMap$1.set(this, /* @__PURE__ */ new Map());
                        this.debug = options.debug || {};
                        if (this.debug.enabled === void 0) this.debug.enabled = false;
                        if (!this.debug.logger) this.debug.logger = (type, debugName, eventName, eventData)=>{
                            eventData = JSON.stringify(eventData);
                            if (typeof eventName === "symbol") eventName = eventName.toString();
                            const currentTime = new Date();
                            const logTime = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;
                            console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);
                        };
                    }
                    logIfDebugEnabled(type, eventName, eventData) {
                        if (Emittery$1.isDebugEnabled || this.debug.enabled) this.debug.logger(type, this.debug.name, eventName, eventData);
                    }
                    on(eventNames, listener) {
                        assertListener$1(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName$1(eventName);
                            getListeners$1(this, eventName).add(listener);
                            this.logIfDebugEnabled("subscribe", eventName, void 0);
                            if (!isListenerSymbol$1(eventName)) this.emit(listenerAdded$1, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                        return this.off.bind(this, eventNames, listener);
                    }
                    off(eventNames, listener) {
                        assertListener$1(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName$1(eventName);
                            getListeners$1(this, eventName).delete(listener);
                            this.logIfDebugEnabled("unsubscribe", eventName, void 0);
                            if (!isListenerSymbol$1(eventName)) this.emit(listenerRemoved$1, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                    }
                    once(eventNames) {
                        return new Promise((resolve)=>{
                            const off = this.on(eventNames, (data2)=>{
                                off();
                                resolve(data2);
                            });
                        });
                    }
                    events(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames)assertEventName$1(eventName);
                        return iterator$1(this, eventNames);
                    }
                    async emit(eventName, eventData) {
                        assertEventName$1(eventName);
                        this.logIfDebugEnabled("emit", eventName, eventData);
                        enqueueProducers$1(this, eventName, eventData);
                        const listeners = getListeners$1(this, eventName);
                        const anyListeners = anyMap$1.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = isListenerSymbol$1(eventName) ? [] : [
                            ...anyListeners
                        ];
                        await resolvedPromise$1;
                        await Promise.all([
                            ...staticListeners.map(async (listener)=>{
                                if (listeners.has(listener)) return listener(eventData);
                            }),
                            ...staticAnyListeners.map(async (listener)=>{
                                if (anyListeners.has(listener)) return listener(eventName, eventData);
                            })
                        ]);
                    }
                    async emitSerial(eventName, eventData) {
                        assertEventName$1(eventName);
                        this.logIfDebugEnabled("emitSerial", eventName, eventData);
                        const listeners = getListeners$1(this, eventName);
                        const anyListeners = anyMap$1.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = [
                            ...anyListeners
                        ];
                        await resolvedPromise$1;
                        for (const listener of staticListeners)if (listeners.has(listener)) await listener(eventData);
                        for (const listener of staticAnyListeners)if (anyListeners.has(listener)) await listener(eventName, eventData);
                    }
                    onAny(listener) {
                        assertListener$1(listener);
                        this.logIfDebugEnabled("subscribeAny", void 0, void 0);
                        anyMap$1.get(this).add(listener);
                        this.emit(listenerAdded$1, {
                            listener: listener
                        });
                        return this.offAny.bind(this, listener);
                    }
                    anyEvent() {
                        return iterator$1(this);
                    }
                    offAny(listener) {
                        assertListener$1(listener);
                        this.logIfDebugEnabled("unsubscribeAny", void 0, void 0);
                        this.emit(listenerRemoved$1, {
                            listener: listener
                        });
                        anyMap$1.get(this).delete(listener);
                    }
                    clearListeners(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            this.logIfDebugEnabled("clear", eventName, void 0);
                            if (typeof eventName === "string" || typeof eventName === "symbol") {
                                getListeners$1(this, eventName).clear();
                                const producers = getEventProducers$1(this, eventName);
                                for (const producer of producers)producer.finish();
                                producers.clear();
                            } else {
                                anyMap$1.get(this).clear();
                                for (const listeners of eventsMap$1.get(this).values())listeners.clear();
                                for (const producers of producersMap$1.get(this).values()){
                                    for (const producer of producers)producer.finish();
                                    producers.clear();
                                }
                            }
                        }
                    }
                    listenerCount(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        let count = 0;
                        for (const eventName of eventNames){
                            if (typeof eventName === "string") {
                                count += anyMap$1.get(this).size + getListeners$1(this, eventName).size + getEventProducers$1(this, eventName).size + getEventProducers$1(this).size;
                                continue;
                            }
                            if (typeof eventName !== "undefined") assertEventName$1(eventName);
                            count += anyMap$1.get(this).size;
                            for (const value of eventsMap$1.get(this).values())count += value.size;
                            for (const value of producersMap$1.get(this).values())count += value.size;
                        }
                        return count;
                    }
                    bindMethods(target, methodNames) {
                        if (typeof target !== "object" || target === null) throw new TypeError("`target` must be an object");
                        methodNames = defaultMethodNamesOrAssert$1(methodNames);
                        for (const methodName of methodNames){
                            if (target[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            Object.defineProperty(target, methodName, {
                                enumerable: false,
                                value: this[methodName].bind(this)
                            });
                        }
                    }
                }
                const allEmitteryMethods$1 = Object.getOwnPropertyNames(Emittery$1.prototype).filter((v)=>v !== "constructor");
                Object.defineProperty(Emittery$1, "listenerAdded", {
                    value: listenerAdded$1,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                Object.defineProperty(Emittery$1, "listenerRemoved", {
                    value: listenerRemoved$1,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                var WarningType;
                (function(WarningType2) {
                    WarningType2["FPS_DROP"] = "fps_drop";
                })(WarningType || (WarningType = {}));
                class InsertableStreamHelper {
                    constructor(){
                        this.processor_ = null;
                        this.generator_ = null;
                    }
                    init(track) {
                        return new Promise((resolve, reject)=>{
                            try {
                                this.processor_ = new MediaStreamTrackProcessor(track);
                            } catch (e) {
                                console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${e}`);
                                reject(e);
                            }
                            try {
                                if (track.kind === "audio") this.generator_ = new MediaStreamTrackGenerator({
                                    kind: "audio"
                                });
                                else if (track.kind === "video") this.generator_ = new MediaStreamTrackGenerator({
                                    kind: "video"
                                });
                                else reject("kind not supported");
                            } catch (e) {
                                console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${e}`);
                                reject(e);
                            }
                            resolve();
                        });
                    }
                    getReadable() {
                        return this.processor_.readable;
                    }
                    getWriteable() {
                        return this.generator_.writable;
                    }
                    getProccesorTrack() {
                        return this.generator_;
                    }
                }
                class MediaProcessorConnector {
                    constructor(vonageMediaProcessor){
                        this.insertableStreamHelper_ = new InsertableStreamHelper();
                        this.mediaProcessor_ = vonageMediaProcessor;
                    }
                    setTrack(track) {
                        return new Promise((resolve, reject)=>{
                            this.insertableStreamHelper_.init(track).then(()=>{
                                this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(()=>{
                                    resolve(this.insertableStreamHelper_.getProccesorTrack());
                                }).catch((e)=>{
                                    reject(e);
                                });
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    destroy() {
                        return new Promise((resolve, reject)=>{
                            if (this.mediaProcessor_) this.mediaProcessor_.destroy().then(()=>{
                                resolve();
                            }).catch((e)=>{
                                reject(e);
                            });
                            else reject("no processor");
                        });
                    }
                }
                const encodedJs = "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";
                const blob = typeof window !== "undefined" && window.Blob && new Blob([
                    atob(encodedJs)
                ], {
                    type: "text/javascript;charset=utf-8"
                });
                function WorkerWrapper() {
                    const objURL = blob && (window.URL || window.webkitURL).createObjectURL(blob);
                    try {
                        return objURL ? new Worker(objURL, {}) : new Worker("data:application/javascript;base64," + encodedJs, {
                            type: "module"
                        });
                    } finally{
                        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
                    }
                }
                const anyMap = /* @__PURE__ */ new WeakMap();
                const eventsMap = /* @__PURE__ */ new WeakMap();
                const producersMap = /* @__PURE__ */ new WeakMap();
                const anyProducer = Symbol("anyProducer");
                const resolvedPromise = Promise.resolve();
                const listenerAdded = Symbol("listenerAdded");
                const listenerRemoved = Symbol("listenerRemoved");
                let isGlobalDebugEnabled = false;
                function assertEventName(eventName) {
                    if (typeof eventName !== "string" && typeof eventName !== "symbol") throw new TypeError("eventName must be a string or a symbol");
                }
                function assertListener(listener) {
                    if (typeof listener !== "function") throw new TypeError("listener must be a function");
                }
                function getListeners(instance, eventName) {
                    const events = eventsMap.get(instance);
                    if (!events.has(eventName)) events.set(eventName, /* @__PURE__ */ new Set());
                    return events.get(eventName);
                }
                function getEventProducers(instance, eventName) {
                    const key = typeof eventName === "string" || typeof eventName === "symbol" ? eventName : anyProducer;
                    const producers = producersMap.get(instance);
                    if (!producers.has(key)) producers.set(key, /* @__PURE__ */ new Set());
                    return producers.get(key);
                }
                function enqueueProducers(instance, eventName, eventData) {
                    const producers = producersMap.get(instance);
                    if (producers.has(eventName)) for (const producer of producers.get(eventName))producer.enqueue(eventData);
                    if (producers.has(anyProducer)) {
                        const item = Promise.all([
                            eventName,
                            eventData
                        ]);
                        for (const producer of producers.get(anyProducer))producer.enqueue(item);
                    }
                }
                function iterator(instance, eventNames) {
                    eventNames = Array.isArray(eventNames) ? eventNames : [
                        eventNames
                    ];
                    let isFinished = false;
                    let flush = ()=>{};
                    let queue = [];
                    const producer = {
                        enqueue (item) {
                            queue.push(item);
                            flush();
                        },
                        finish () {
                            isFinished = true;
                            flush();
                        }
                    };
                    for (const eventName of eventNames)getEventProducers(instance, eventName).add(producer);
                    return {
                        async next () {
                            if (!queue) return {
                                done: true
                            };
                            if (queue.length === 0) {
                                if (isFinished) {
                                    queue = void 0;
                                    return this.next();
                                }
                                await new Promise((resolve)=>{
                                    flush = resolve;
                                });
                                return this.next();
                            }
                            return {
                                done: false,
                                value: await queue.shift()
                            };
                        },
                        async return (value) {
                            queue = void 0;
                            for (const eventName of eventNames)getEventProducers(instance, eventName).delete(producer);
                            flush();
                            return arguments.length > 0 ? {
                                done: true,
                                value: await value
                            } : {
                                done: true
                            };
                        },
                        [Symbol.asyncIterator] () {
                            return this;
                        }
                    };
                }
                function defaultMethodNamesOrAssert(methodNames) {
                    if (methodNames === void 0) return allEmitteryMethods;
                    if (!Array.isArray(methodNames)) throw new TypeError("`methodNames` must be an array of strings");
                    for (const methodName of methodNames)if (!allEmitteryMethods.includes(methodName)) {
                        if (typeof methodName !== "string") throw new TypeError("`methodNames` element must be a string");
                        throw new Error(`${methodName} is not Emittery method`);
                    }
                    return methodNames;
                }
                const isListenerSymbol = (symbol)=>symbol === listenerAdded || symbol === listenerRemoved;
                class Emittery {
                    static mixin(emitteryPropertyName, methodNames) {
                        methodNames = defaultMethodNamesOrAssert(methodNames);
                        return (target)=>{
                            if (typeof target !== "function") throw new TypeError("`target` must be function");
                            for (const methodName of methodNames){
                                if (target.prototype[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            }
                            function getEmitteryProperty() {
                                Object.defineProperty(this, emitteryPropertyName, {
                                    enumerable: false,
                                    value: new Emittery()
                                });
                                return this[emitteryPropertyName];
                            }
                            Object.defineProperty(target.prototype, emitteryPropertyName, {
                                enumerable: false,
                                get: getEmitteryProperty
                            });
                            const emitteryMethodCaller = (methodName)=>function(...args) {
                                    return this[emitteryPropertyName][methodName](...args);
                                };
                            for (const methodName of methodNames)Object.defineProperty(target.prototype, methodName, {
                                enumerable: false,
                                value: emitteryMethodCaller(methodName)
                            });
                            return target;
                        };
                    }
                    static get isDebugEnabled() {
                        if (typeof process !== "object") return isGlobalDebugEnabled;
                        const { env } = process || {
                            env: {}
                        };
                        return env.DEBUG === "emittery" || env.DEBUG === "*" || isGlobalDebugEnabled;
                    }
                    static set isDebugEnabled(newValue) {
                        isGlobalDebugEnabled = newValue;
                    }
                    constructor(options = {}){
                        anyMap.set(this, /* @__PURE__ */ new Set());
                        eventsMap.set(this, /* @__PURE__ */ new Map());
                        producersMap.set(this, /* @__PURE__ */ new Map());
                        this.debug = options.debug || {};
                        if (this.debug.enabled === void 0) this.debug.enabled = false;
                        if (!this.debug.logger) this.debug.logger = (type, debugName, eventName, eventData)=>{
                            try {
                                eventData = JSON.stringify(eventData);
                            } catch  {
                                eventData = `Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;
                            }
                            if (typeof eventName === "symbol") eventName = eventName.toString();
                            const currentTime = new Date();
                            const logTime = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;
                            console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);
                        };
                    }
                    logIfDebugEnabled(type, eventName, eventData) {
                        if (Emittery.isDebugEnabled || this.debug.enabled) this.debug.logger(type, this.debug.name, eventName, eventData);
                    }
                    on(eventNames, listener) {
                        assertListener(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName(eventName);
                            getListeners(this, eventName).add(listener);
                            this.logIfDebugEnabled("subscribe", eventName, void 0);
                            if (!isListenerSymbol(eventName)) this.emit(listenerAdded, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                        return this.off.bind(this, eventNames, listener);
                    }
                    off(eventNames, listener) {
                        assertListener(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName(eventName);
                            getListeners(this, eventName).delete(listener);
                            this.logIfDebugEnabled("unsubscribe", eventName, void 0);
                            if (!isListenerSymbol(eventName)) this.emit(listenerRemoved, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                    }
                    once(eventNames) {
                        return new Promise((resolve)=>{
                            const off = this.on(eventNames, (data2)=>{
                                off();
                                resolve(data2);
                            });
                        });
                    }
                    events(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames)assertEventName(eventName);
                        return iterator(this, eventNames);
                    }
                    async emit(eventName, eventData) {
                        assertEventName(eventName);
                        this.logIfDebugEnabled("emit", eventName, eventData);
                        enqueueProducers(this, eventName, eventData);
                        const listeners = getListeners(this, eventName);
                        const anyListeners = anyMap.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = isListenerSymbol(eventName) ? [] : [
                            ...anyListeners
                        ];
                        await resolvedPromise;
                        await Promise.all([
                            ...staticListeners.map(async (listener)=>{
                                if (listeners.has(listener)) return listener(eventData);
                            }),
                            ...staticAnyListeners.map(async (listener)=>{
                                if (anyListeners.has(listener)) return listener(eventName, eventData);
                            })
                        ]);
                    }
                    async emitSerial(eventName, eventData) {
                        assertEventName(eventName);
                        this.logIfDebugEnabled("emitSerial", eventName, eventData);
                        const listeners = getListeners(this, eventName);
                        const anyListeners = anyMap.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = [
                            ...anyListeners
                        ];
                        await resolvedPromise;
                        for (const listener of staticListeners)if (listeners.has(listener)) await listener(eventData);
                        for (const listener of staticAnyListeners)if (anyListeners.has(listener)) await listener(eventName, eventData);
                    }
                    onAny(listener) {
                        assertListener(listener);
                        this.logIfDebugEnabled("subscribeAny", void 0, void 0);
                        anyMap.get(this).add(listener);
                        this.emit(listenerAdded, {
                            listener: listener
                        });
                        return this.offAny.bind(this, listener);
                    }
                    anyEvent() {
                        return iterator(this);
                    }
                    offAny(listener) {
                        assertListener(listener);
                        this.logIfDebugEnabled("unsubscribeAny", void 0, void 0);
                        this.emit(listenerRemoved, {
                            listener: listener
                        });
                        anyMap.get(this).delete(listener);
                    }
                    clearListeners(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            this.logIfDebugEnabled("clear", eventName, void 0);
                            if (typeof eventName === "string" || typeof eventName === "symbol") {
                                getListeners(this, eventName).clear();
                                const producers = getEventProducers(this, eventName);
                                for (const producer of producers)producer.finish();
                                producers.clear();
                            } else {
                                anyMap.get(this).clear();
                                for (const listeners of eventsMap.get(this).values())listeners.clear();
                                for (const producers of producersMap.get(this).values()){
                                    for (const producer of producers)producer.finish();
                                    producers.clear();
                                }
                            }
                        }
                    }
                    listenerCount(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        let count = 0;
                        for (const eventName of eventNames){
                            if (typeof eventName === "string") {
                                count += anyMap.get(this).size + getListeners(this, eventName).size + getEventProducers(this, eventName).size + getEventProducers(this).size;
                                continue;
                            }
                            if (typeof eventName !== "undefined") assertEventName(eventName);
                            count += anyMap.get(this).size;
                            for (const value of eventsMap.get(this).values())count += value.size;
                            for (const value of producersMap.get(this).values())count += value.size;
                        }
                        return count;
                    }
                    bindMethods(target, methodNames) {
                        if (typeof target !== "object" || target === null) throw new TypeError("`target` must be an object");
                        methodNames = defaultMethodNamesOrAssert(methodNames);
                        for (const methodName of methodNames){
                            if (target[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            Object.defineProperty(target, methodName, {
                                enumerable: false,
                                value: this[methodName].bind(this)
                            });
                        }
                    }
                }
                const allEmitteryMethods = Object.getOwnPropertyNames(Emittery.prototype).filter((v)=>v !== "constructor");
                Object.defineProperty(Emittery, "listenerAdded", {
                    value: listenerAdded,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                Object.defineProperty(Emittery, "listenerRemoved", {
                    value: listenerRemoved,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                var emittery = Emittery;
                const VonageSelfiesegmentation = {};
                (function() {
                    var D;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var H = ca(this);
                    function J(a, b) {
                        if (b) a: {
                            var c = H;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var f = a[d];
                                if (!(f in c)) break a;
                                c = c[f];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    J("Symbol", function(a) {
                        function b(h) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (h || "") + "_" + f++, h);
                        }
                        function c(h, e) {
                            this.g = h;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: e
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", f = 0;
                        return b;
                    });
                    J("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = H[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function M(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function ea(a) {
                        if (!(a instanceof Array)) {
                            a = M(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var fa = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, ha;
                    if (typeof Object.setPrototypeOf == "function") ha = Object.setPrototypeOf;
                    else {
                        var ia;
                        a: {
                            var ja = {
                                a: true
                            }, ka = {};
                            try {
                                ka.__proto__ = ja;
                                ia = ka.a;
                                break a;
                            } catch (a) {}
                            ia = false;
                        }
                        ha = ia ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var la = ha;
                    function ma(a, b) {
                        a.prototype = fa(b.prototype);
                        a.prototype.constructor = a;
                        if (la) la(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.ea = b.prototype;
                    }
                    function na() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.s = this.m = 0;
                        this.j = null;
                    }
                    function oa(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    na.prototype.o = function(a) {
                        this.h = a;
                    };
                    function pa(a, b) {
                        a.j = {
                            U: b,
                            V: true
                        };
                        a.g = a.m || a.s;
                    }
                    na.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.s;
                    };
                    function N(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function qa(a) {
                        this.g = new na();
                        this.h = a;
                    }
                    function ra(a, b) {
                        oa(a.g);
                        var c = a.g.i;
                        if (c) return sa(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return ta(a);
                    }
                    function sa(a, b, c, d) {
                        try {
                            var f = b.call(a.g.i, c);
                            if (!(f instanceof Object)) throw new TypeError("Iterator result " + f + " is not an object");
                            if (!f.done) return a.g.l = false, f;
                            var h = f.value;
                        } catch (e) {
                            return a.g.i = null, pa(a.g, e), ta(a);
                        }
                        a.g.i = null;
                        d.call(a.g, h);
                        return ta(a);
                    }
                    function ta(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, pa(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.V) throw b.U;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function ua(a) {
                        this.next = function(b) {
                            oa(a.g);
                            a.g.i ? b = sa(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = ta(a));
                            return b;
                        };
                        this.throw = function(b) {
                            oa(a.g);
                            a.g.i ? b = sa(a, a.g.i["throw"], b, a.g.o) : (pa(a.g, b), b = ta(a));
                            return b;
                        };
                        this.return = function(b) {
                            return ra(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function O(a, b) {
                        b = new ua(new qa(b));
                        la && a.prototype && la(b, a.prototype);
                        return b;
                    }
                    function va(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, f = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var h = c++;
                                    return {
                                        value: b(h, a[h]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        f[Symbol.iterator] = function() {
                            return f;
                        };
                        return f;
                    }
                    var wa = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var f in d)Object.prototype.hasOwnProperty.call(d, f) && (a[f] = d[f]);
                        }
                        return a;
                    };
                    J("Object.assign", function(a) {
                        return a || wa;
                    });
                    J("Promise", function(a) {
                        function b(e) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.o = false;
                            var g = this.j();
                            try {
                                e(g.resolve, g.reject);
                            } catch (k) {
                                g.reject(k);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(e) {
                            return e instanceof b ? e : new b(function(g) {
                                g(e);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(e) {
                            if (this.g == null) {
                                this.g = [];
                                var g = this;
                                this.i(function() {
                                    g.l();
                                });
                            }
                            this.g.push(e);
                        };
                        var f = H.setTimeout;
                        c.prototype.i = function(e) {
                            f(e, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var e = this.g;
                                this.g = [];
                                for(var g = 0; g < e.length; ++g){
                                    var k = e[g];
                                    e[g] = null;
                                    try {
                                        k();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(e) {
                            this.i(function() {
                                throw e;
                            });
                        };
                        b.prototype.j = function() {
                            function e(l) {
                                return function(q) {
                                    k || (k = true, l.call(g, q));
                                };
                            }
                            var g = this, k = false;
                            return {
                                resolve: e(this.C),
                                reject: e(this.l)
                            };
                        };
                        b.prototype.C = function(e) {
                            if (e === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (e instanceof b) this.F(e);
                            else {
                                a: switch(typeof e){
                                    case "object":
                                        var g = e != null;
                                        break a;
                                    case "function":
                                        g = true;
                                        break a;
                                    default:
                                        g = false;
                                }
                                g ? this.u(e) : this.m(e);
                            }
                        };
                        b.prototype.u = function(e) {
                            var g = void 0;
                            try {
                                g = e.then;
                            } catch (k) {
                                this.l(k);
                                return;
                            }
                            typeof g == "function" ? this.G(g, e) : this.m(e);
                        };
                        b.prototype.l = function(e) {
                            this.s(2, e);
                        };
                        b.prototype.m = function(e) {
                            this.s(1, e);
                        };
                        b.prototype.s = function(e, g) {
                            if (this.h != 0) throw Error("Cannot settle(" + e + ", " + g + "): Promise already settled in state" + this.h);
                            this.h = e;
                            this.i = g;
                            this.h === 2 && this.D();
                            this.A();
                        };
                        b.prototype.D = function() {
                            var e = this;
                            f(function() {
                                if (e.B()) {
                                    var g = H.console;
                                    typeof g !== "undefined" && g.error(e.i);
                                }
                            }, 1);
                        };
                        b.prototype.B = function() {
                            if (this.o) return false;
                            var e = H.CustomEvent, g = H.Event, k = H.dispatchEvent;
                            if (typeof k === "undefined") return true;
                            typeof e === "function" ? e = new e("unhandledrejection", {
                                cancelable: true
                            }) : typeof g === "function" ? e = new g("unhandledrejection", {
                                cancelable: true
                            }) : (e = H.document.createEvent("CustomEvent"), e.initCustomEvent("unhandledrejection", false, true, e));
                            e.promise = this;
                            e.reason = this.i;
                            return k(e);
                        };
                        b.prototype.A = function() {
                            if (this.g != null) {
                                for(var e = 0; e < this.g.length; ++e)h.h(this.g[e]);
                                this.g = null;
                            }
                        };
                        var h = new c();
                        b.prototype.F = function(e) {
                            var g = this.j();
                            e.J(g.resolve, g.reject);
                        };
                        b.prototype.G = function(e, g) {
                            var k = this.j();
                            try {
                                e.call(g, k.resolve, k.reject);
                            } catch (l) {
                                k.reject(l);
                            }
                        };
                        b.prototype.then = function(e, g) {
                            function k(w, t) {
                                return typeof w == "function" ? function(y) {
                                    try {
                                        l(w(y));
                                    } catch (m) {
                                        q(m);
                                    }
                                } : t;
                            }
                            var l, q, v = new b(function(w, t) {
                                l = w;
                                q = t;
                            });
                            this.J(k(e, l), k(g, q));
                            return v;
                        };
                        b.prototype.catch = function(e) {
                            return this.then(void 0, e);
                        };
                        b.prototype.J = function(e, g) {
                            function k() {
                                switch(l.h){
                                    case 1:
                                        e(l.i);
                                        break;
                                    case 2:
                                        g(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? h.h(k) : this.g.push(k);
                            this.o = true;
                        };
                        b.resolve = d;
                        b.reject = function(e) {
                            return new b(function(g, k) {
                                k(e);
                            });
                        };
                        b.race = function(e) {
                            return new b(function(g, k) {
                                for(var l = M(e), q = l.next(); !q.done; q = l.next())d(q.value).J(g, k);
                            });
                        };
                        b.all = function(e) {
                            var g = M(e), k = g.next();
                            return k.done ? d([]) : new b(function(l, q) {
                                function v(y) {
                                    return function(m) {
                                        w[y] = m;
                                        t--;
                                        t == 0 && l(w);
                                    };
                                }
                                var w = [], t = 0;
                                do w.push(void 0), t++, d(k.value).J(v(w.length - 1), q), k = g.next();
                                while (!k.done);
                            });
                        };
                        return b;
                    });
                    J("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    J("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var f = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + f, 0)); c < f; c++){
                                var h = d[c];
                                if (h === b || Object.is(h, b)) return true;
                            }
                            return false;
                        };
                    });
                    J("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    J("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return va(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var xa = this || self;
                    function ya(a, b) {
                        a = a.split(".");
                        var c = xa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function za(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var Aa, Ba = typeof TextDecoder !== "undefined", Ca, Da = typeof TextEncoder !== "undefined";
                    function Ea(a) {
                        if (Da) a = (Ca || (Ca = new TextEncoder())).encode(a);
                        else {
                            var b = void 0;
                            b = b === void 0 ? false : b;
                            for(var c = 0, d = new Uint8Array(3 * a.length), f = 0; f < a.length; f++){
                                var h = a.charCodeAt(f);
                                if (128 > h) d[c++] = h;
                                else {
                                    if (2048 > h) d[c++] = h >> 6 | 192;
                                    else {
                                        if (55296 <= h && 57343 >= h) {
                                            if (56319 >= h && f < a.length) {
                                                var e = a.charCodeAt(++f);
                                                if (56320 <= e && 57343 >= e) {
                                                    h = 1024 * (h - 55296) + e - 56320 + 65536;
                                                    d[c++] = h >> 18 | 240;
                                                    d[c++] = h >> 12 & 63 | 128;
                                                    d[c++] = h >> 6 & 63 | 128;
                                                    d[c++] = h & 63 | 128;
                                                    continue;
                                                } else f--;
                                            }
                                            if (b) throw Error("Found an unpaired surrogate");
                                            h = 65533;
                                        }
                                        d[c++] = h >> 12 | 224;
                                        d[c++] = h >> 6 & 63 | 128;
                                    }
                                    d[c++] = h & 63 | 128;
                                }
                            }
                            a = d.subarray(0, c);
                        }
                        return a;
                    }
                    var Fa = {}, Ga = null;
                    function Ha(a, b) {
                        b === void 0 && (b = 0);
                        Ja();
                        b = Fa[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", f = 0, h = 0; f < a.length - 2; f += 3){
                            var e = a[f], g = a[f + 1], k = a[f + 2], l = b[e >> 2];
                            e = b[(e & 3) << 4 | g >> 4];
                            g = b[(g & 15) << 2 | k >> 6];
                            k = b[k & 63];
                            c[h++] = l + e + g + k;
                        }
                        l = 0;
                        k = d;
                        switch(a.length - f){
                            case 2:
                                l = a[f + 1], k = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[f], c[h] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
                        }
                        return c.join("");
                    }
                    function Ka(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), f = 0;
                        La(a, function(h) {
                            d[f++] = h;
                        });
                        return d.subarray(0, f);
                    }
                    function La(a, b) {
                        function c(k) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), q = Ga[l];
                                if (q != null) return q;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return k;
                        }
                        Ja();
                        for(var d = 0;;){
                            var f = c(-1), h = c(0), e = c(64), g = c(64);
                            if (g === 64 && f === -1) break;
                            b(f << 2 | h >> 4);
                            e != 64 && (b(h << 4 & 240 | e >> 2), g != 64 && b(e << 6 & 192 | g));
                        }
                    }
                    function Ja() {
                        if (!Ga) {
                            Ga = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Fa[c] = d;
                                for(var f = 0; f < d.length; f++){
                                    var h = d[f];
                                    Ga[h] === void 0 && (Ga[h] = f);
                                }
                            }
                        }
                    }
                    var Ma = typeof Uint8Array.prototype.slice === "function", Na;
                    function Oa(a, b, c) {
                        return b === c ? Na || (Na = new Uint8Array(0)) : Ma ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
                    }
                    var P = 0, Q = 0;
                    function Pa(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.v === void 0 ? false : b.v;
                        this.h = null;
                        this.g = this.i = this.j = 0;
                        this.l = false;
                        this.v = b;
                        a && Qa(this, a);
                    }
                    function Qa(a, b) {
                        b = b.constructor === Uint8Array ? b : b.constructor === ArrayBuffer ? new Uint8Array(b) : b.constructor === Array ? new Uint8Array(b) : b.constructor === String ? Ka(b) : b instanceof Uint8Array ? new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : new Uint8Array(0);
                        a.h = b;
                        a.j = 0;
                        a.i = a.h.length;
                        a.g = a.j;
                    }
                    Pa.prototype.reset = function() {
                        this.g = this.j;
                    };
                    function Ra(a) {
                        var b = a.h, c = b[a.g], d = c & 127;
                        if (128 > c) return a.g += 1, d;
                        c = b[a.g + 1];
                        d |= (c & 127) << 7;
                        if (128 > c) return a.g += 2, d;
                        c = b[a.g + 2];
                        d |= (c & 127) << 14;
                        if (128 > c) return a.g += 3, d;
                        c = b[a.g + 3];
                        d |= (c & 127) << 21;
                        if (128 > c) return a.g += 4, d;
                        c = b[a.g + 4];
                        d |= (c & 15) << 28;
                        if (128 > c) return a.g += 5, d >>> 0;
                        a.g += 5;
                        128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && a.g++;
                        return d;
                    }
                    function R(a) {
                        var b = a.h[a.g];
                        var c = a.h[a.g + 1];
                        var d = a.h[a.g + 2], f = a.h[a.g + 3];
                        a.g += 4;
                        c = (b << 0 | c << 8 | d << 16 | f << 24) >>> 0;
                        a = 2 * (c >> 31) + 1;
                        b = c >>> 23 & 255;
                        c &= 8388607;
                        return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
                    }
                    var Sa = [];
                    function Ta() {
                        this.g = new Uint8Array(64);
                        this.h = 0;
                    }
                    Ta.prototype.push = function(a) {
                        if (!(this.h + 1 < this.g.length)) {
                            var b = this.g;
                            this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length));
                            this.g.set(b);
                        }
                        this.g[this.h++] = a;
                    };
                    Ta.prototype.length = function() {
                        return this.h;
                    };
                    Ta.prototype.end = function() {
                        var a = this.g, b = this.h;
                        this.h = 0;
                        return Oa(a, 0, b);
                    };
                    function S(a, b) {
                        for(; 127 < b;)a.push(b & 127 | 128), b >>>= 7;
                        a.push(b);
                    }
                    function Ua(a) {
                        var b = {}, c = b.N === void 0 ? false : b.N;
                        this.o = {
                            v: b.v === void 0 ? false : b.v
                        };
                        this.N = c;
                        b = this.o;
                        Sa.length ? (c = Sa.pop(), b && (c.v = b.v), a && Qa(c, a), a = c) : a = new Pa(a, b);
                        this.g = a;
                        this.m = this.g.g;
                        this.h = this.i = this.l = -1;
                        this.j = false;
                    }
                    Ua.prototype.reset = function() {
                        this.g.reset();
                        this.h = this.l = -1;
                    };
                    function Va(a) {
                        var b = a.g;
                        (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.l || 0 > b.g || b.g > b.i);
                        if (b) return false;
                        a.m = a.g.g;
                        b = Ra(a.g);
                        var c = b & 7;
                        if (c != 0 && c != 5 && c != 1 && c != 2 && c != 3 && c != 4) return a.j = true, false;
                        a.i = b;
                        a.l = b >>> 3;
                        a.h = c;
                        return true;
                    }
                    function Wa(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Wa(a);
                                else {
                                    for(a = a.g; a.h[a.g] & 128;)a.g++;
                                    a.g++;
                                }
                                break;
                            case 1:
                                a.h != 1 ? Wa(a) : (a = a.g, a.g += 8);
                                break;
                            case 2:
                                if (a.h != 2) Wa(a);
                                else {
                                    var b = Ra(a.g);
                                    a = a.g;
                                    a.g += b;
                                }
                                break;
                            case 5:
                                a.h != 5 ? Wa(a) : (a = a.g, a.g += 4);
                                break;
                            case 3:
                                b = a.l;
                                do {
                                    if (!Va(a)) {
                                        a.j = true;
                                        break;
                                    }
                                    if (a.h == 4) {
                                        a.l != b && (a.j = true);
                                        break;
                                    }
                                    Wa(a);
                                }while (1);
                                break;
                            default:
                                a.j = true;
                        }
                    }
                    function Xa(a, b, c) {
                        var d = a.g.i, f = Ra(a.g);
                        f = a.g.g + f;
                        a.g.i = f;
                        c(b, a);
                        a.g.g = f;
                        a.g.i = d;
                        return b;
                    }
                    function Ya(a) {
                        var b = Ra(a.g);
                        a = a.g;
                        var c = a.g;
                        a.g += b;
                        a = a.h;
                        var d;
                        if (Ba) (d = Aa) || (d = Aa = new TextDecoder("utf-8", {
                            fatal: false
                        })), d = d.decode(a.subarray(c, c + b));
                        else {
                            b = c + b;
                            for(var f = [], h = null, e, g, k; c < b;)e = a[c++], 128 > e ? f.push(e) : 224 > e ? c >= b ? f.push(65533) : (g = a[c++], 194 > e || (g & 192) !== 128 ? (c--, f.push(65533)) : f.push((e & 31) << 6 | g & 63)) : 240 > e ? c >= b - 1 ? f.push(65533) : (g = a[c++], (g & 192) !== 128 || e === 224 && 160 > g || e === 237 && 160 <= g || ((d = a[c++]) & 192) !== 128 ? (c--, f.push(65533)) : f.push((e & 15) << 12 | (g & 63) << 6 | d & 63)) : 244 >= e ? c >= b - 2 ? f.push(65533) : (g = a[c++], (g & 192) !== 128 || (e << 28) + (g - 144) >> 30 !== 0 || ((d = a[c++]) & 192) !== 128 || ((k = a[c++]) & 192) !== 128 ? (c--, f.push(65533)) : (e = (e & 7) << 18 | (g & 63) << 12 | (d & 63) << 6 | k & 63, e -= 65536, f.push((e >> 10 & 1023) + 55296, (e & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (h = za(h, f), f.length = 0);
                            d = za(h, f);
                        }
                        return d;
                    }
                    function Za() {
                        this.h = [];
                        this.i = 0;
                        this.g = new Ta();
                    }
                    function $a(a, b) {
                        b.length !== 0 && (a.h.push(b), a.i += b.length);
                    }
                    function ab(a) {
                        var b = a.i + a.g.length();
                        if (b === 0) return new Uint8Array(0);
                        b = new Uint8Array(b);
                        for(var c = a.h, d = c.length, f = 0, h = 0; h < d; h++){
                            var e = c[h];
                            e.length !== 0 && (b.set(e, f), f += e.length);
                        }
                        c = a.g;
                        d = c.h;
                        d !== 0 && (b.set(c.g.subarray(0, d), f), c.h = 0);
                        a.h = [
                            b
                        ];
                        return b;
                    }
                    function T(a, b, c) {
                        if (c != null) {
                            S(a.g, 8 * b + 5);
                            a = a.g;
                            var d = c;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? P = Q = 0 : (Q = 0, P = 2147483648) : isNaN(d) ? (Q = 0, P = 2147483647) : 34028234663852886e22 < d ? (Q = 0, P = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), Q = 0, P = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d) & 8388607, Q = 0, P = (c << 31 | b + 127 << 23 | d) >>> 0);
                            c = P;
                            a.push(c >>> 0 & 255);
                            a.push(c >>> 8 & 255);
                            a.push(c >>> 16 & 255);
                            a.push(c >>> 24 & 255);
                        }
                    }
                    var bb = typeof Uint8Array === "function";
                    function cb(a, b, c) {
                        if (a != null) return typeof a === "object" ? bb && a instanceof Uint8Array ? c(a) : db(a, b, c) : b(a);
                    }
                    function db(a, b, c) {
                        if (Array.isArray(a)) {
                            for(var d = Array(a.length), f = 0; f < a.length; f++)d[f] = cb(a[f], b, c);
                            Array.isArray(a) && a.W && eb(d);
                            return d;
                        }
                        d = {};
                        for(f in a)d[f] = cb(a[f], b, c);
                        return d;
                    }
                    function fb(a) {
                        return typeof a === "number" ? isFinite(a) ? a : String(a) : a;
                    }
                    var gb = {
                        W: {
                            value: true,
                            configurable: true
                        }
                    };
                    function eb(a) {
                        Array.isArray(a) && !Object.isFrozen(a) && Object.defineProperties(a, gb);
                        return a;
                    }
                    var hb;
                    function U(a, b, c) {
                        var d = hb;
                        hb = null;
                        a || (a = d);
                        d = this.constructor.ca;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.j = d ? 0 : -1;
                        this.i = null;
                        this.g = a;
                        a: {
                            d = this.g.length;
                            a = d - 1;
                            if (d && (d = this.g[a], d !== null && typeof d === "object" && d.constructor === Object)) {
                                this.l = a - this.j;
                                this.h = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)a = c[b], a < this.l ? (a += this.j, (d = this.g[a]) ? eb(d) : this.g[a] = ib) : (jb(this), (d = this.h[a]) ? eb(d) : this.h[a] = ib);
                    }
                    var ib = Object.freeze(eb([]));
                    function jb(a) {
                        var b = a.l + a.j;
                        a.g[b] || (a.h = a.g[b] = {});
                    }
                    function V(a, b, c) {
                        return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.h ? a.h[b] : void 0 : a.g[b + a.j];
                    }
                    function kb(a) {
                        var b = b === void 0 ? false : b;
                        var c = V(a, 1, b);
                        c == null && (c = ib);
                        c === ib && (c = eb([]), W(a, 1, c, b));
                        return c;
                    }
                    function X(a, b, c) {
                        a = V(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function W(a, b, c, d) {
                        (d === void 0 ? 0 : d) || b >= a.l ? (jb(a), a.h[b] = c) : a.g[b + a.j] = c;
                    }
                    function lb(a, b) {
                        a.i || (a.i = {});
                        var c = a.i[1];
                        if (!c) {
                            var d = kb(a);
                            c = [];
                            for(var f = 0; f < d.length; f++)c[f] = new b(d[f]);
                            a.i[1] = c;
                        }
                        return c;
                    }
                    function mb(a, b, c, d) {
                        var f = lb(a, c);
                        b = b ? b : new c();
                        a = kb(a);
                        d != void 0 ? (f.splice(d, 0, b), a.splice(d, 0, nb(b))) : (f.push(b), a.push(nb(b)));
                    }
                    U.prototype.toJSON = function() {
                        var a = nb(this);
                        return db(a, fb, Ha);
                    };
                    function nb(a, b) {
                        if (a.i) for(var c in a.i){
                            var d = a.i[c];
                            if (Array.isArray(d)) for(var f = 0; f < d.length; f++)d[f] && nb(d[f]);
                            else d && nb(d);
                        }
                        return a.g;
                    }
                    U.prototype.toString = function() {
                        return nb(this).toString();
                    };
                    function ob(a, b) {
                        a = V(a, b);
                        return a == null ? 0 : a;
                    }
                    function pb(a, b) {
                        a = V(a, b);
                        return a == null ? "" : a;
                    }
                    function qb(a, b) {
                        if (a = a.m) {
                            $a(b, b.g.end());
                            for(var c = 0; c < a.length; c++)$a(b, a[c]);
                        }
                    }
                    function rb(a, b) {
                        if (b.h == 4) return false;
                        var c = b.m;
                        Wa(b);
                        b.N || (b = Oa(b.g.h, c, b.g.g), (c = a.m) ? c.push(b) : a.m = [
                            b
                        ]);
                        return true;
                    }
                    function Y(a, b) {
                        var c = void 0;
                        return new (c || (c = Promise))(function(d, f) {
                            function h(k) {
                                try {
                                    g(b.next(k));
                                } catch (l) {
                                    f(l);
                                }
                            }
                            function e(k) {
                                try {
                                    g(b["throw"](k));
                                } catch (l) {
                                    f(l);
                                }
                            }
                            function g(k) {
                                k.done ? d(k.value) : new c(function(l) {
                                    l(k.value);
                                }).then(h, e);
                            }
                            g((b = b.apply(a, void 0)).next());
                        });
                    }
                    function sb(a) {
                        U.call(this, a);
                    }
                    ma(sb, U);
                    function tb(a, b) {
                        for(; Va(b);)switch(b.i){
                            case 8:
                                var c = Ra(b.g);
                                W(a, 1, c);
                                break;
                            case 21:
                                c = R(b.g);
                                W(a, 2, c);
                                break;
                            case 26:
                                c = Ya(b);
                                W(a, 3, c);
                                break;
                            case 34:
                                c = Ya(b);
                                W(a, 4, c);
                                break;
                            default:
                                if (!rb(a, b)) return a;
                        }
                        return a;
                    }
                    function ub(a) {
                        U.call(this, a, -1, vb);
                    }
                    ma(ub, U);
                    ub.prototype.addClassification = function(a, b) {
                        mb(this, a, sb, b);
                    };
                    var vb = [
                        1
                    ];
                    function wb(a) {
                        U.call(this, a);
                    }
                    ma(wb, U);
                    function xb(a, b) {
                        for(; Va(b);)switch(b.i){
                            case 13:
                                var c = R(b.g);
                                W(a, 1, c);
                                break;
                            case 21:
                                c = R(b.g);
                                W(a, 2, c);
                                break;
                            case 29:
                                c = R(b.g);
                                W(a, 3, c);
                                break;
                            case 37:
                                c = R(b.g);
                                W(a, 4, c);
                                break;
                            case 45:
                                c = R(b.g);
                                W(a, 5, c);
                                break;
                            default:
                                if (!rb(a, b)) return a;
                        }
                        return a;
                    }
                    function yb(a) {
                        U.call(this, a, -1, zb);
                    }
                    ma(yb, U);
                    var zb = [
                        1
                    ];
                    function Ab(a) {
                        U.call(this, a);
                    }
                    ma(Ab, U);
                    function Bb(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function Cb(a) {
                        return lb(a, sb).map(function(b) {
                            return {
                                index: ob(b, 1),
                                Y: X(b, 2),
                                label: V(b, 3) != null ? pb(b, 3) : void 0,
                                displayName: V(b, 4) != null ? pb(b, 4) : void 0
                            };
                        });
                    }
                    function Db(a) {
                        return {
                            x: X(a, 1),
                            y: X(a, 2),
                            z: X(a, 3),
                            visibility: V(a, 4) != null ? X(a, 4) : void 0
                        };
                    }
                    function Eb(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function Fb(a, b, c) {
                        Gb(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function Gb(a, b) {
                        var c = a.g;
                        if (a.m === void 0) {
                            var d = Bb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), f = Bb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), h = c.createProgram();
                            c.attachShader(h, d);
                            c.attachShader(h, f);
                            c.linkProgram(h);
                            if (!c.getProgramParameter(h, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(h));
                            d = a.m = h;
                            c.useProgram(d);
                            f = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                I: c.getAttribLocation(d, "aVertex"),
                                H: c.getAttribLocation(d, "aTex"),
                                da: f
                            };
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.I);
                            c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.o = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.o);
                            c.enableVertexAttribArray(a.j.H);
                            c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(f, 0);
                        }
                        d = a.j;
                        c.useProgram(a.m);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, a.o);
                        c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.I);
                        c.disableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function Hb(a) {
                        this.g = a;
                    }
                    var Ib = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function Jb(a, b) {
                        return b + a;
                    }
                    function Kb(a, b) {
                        window[a] = b;
                    }
                    function Lb(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function Mb() {
                        return Y(this, function b() {
                            return O(b, function(c) {
                                switch(c.g){
                                    case 1:
                                        return c.m = 2, N(c, WebAssembly.instantiate(Ib), 4);
                                    case 4:
                                        c.g = 3;
                                        c.m = 0;
                                        break;
                                    case 2:
                                        return c.m = 0, c.j = null, c.return(false);
                                    case 3:
                                        return c.return(true);
                                }
                            });
                        });
                    }
                    function Nb(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.F = {};
                        this.m = {};
                        this.s = {};
                        this.G = this.o = this.R = true;
                        this.C = Promise.resolve();
                        this.P = "";
                        this.B = {};
                        this.locateFile = a && a.locateFile || Jb;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.S = b;
                        if (a.options) {
                            b = M(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    D = Nb.prototype;
                    D.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Ob(a, b) {
                        return a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(b) : a.g.files;
                    }
                    function Pb(a) {
                        return Y(a, function c() {
                            var d = this, f, h, e, g, k, l, q, v, w, t, y;
                            return O(c, function(m) {
                                switch(m.g){
                                    case 1:
                                        f = d;
                                        if (!d.R) return m.return();
                                        h = Ob(d, d.j);
                                        return N(m, Mb(), 2);
                                    case 2:
                                        e = m.h;
                                        if (typeof window === "object") return Kb("createMediapipeSolutionsWasm", {
                                            locateFile: d.locateFile
                                        }), Kb("createMediapipeSolutionsPackedAssets", {
                                            locateFile: d.locateFile
                                        }), l = h.filter(function(u) {
                                            return u.data !== void 0;
                                        }), q = h.filter(function(u) {
                                            return u.data === void 0;
                                        }), v = Promise.all(l.map(function(u) {
                                            var x = Qb(f, u.url);
                                            if (u.path !== void 0) {
                                                var z = u.path;
                                                x = x.then(function(E) {
                                                    f.overrideFile(z, E);
                                                    return Promise.resolve(E);
                                                });
                                            }
                                            return x;
                                        })), w = Promise.all(q.map(function(u) {
                                            return u.simd === void 0 || u.simd && e || !u.simd && !e ? Lb(f.locateFile(u.url, f.S)) : Promise.resolve();
                                        })).then(function() {
                                            return Y(f, function x() {
                                                var z, E, F = this;
                                                return O(x, function(K) {
                                                    if (K.g == 1) return z = window.createMediapipeSolutionsWasm, E = window.createMediapipeSolutionsPackedAssets, N(K, z(E), 2);
                                                    F.h = K.h;
                                                    K.g = 0;
                                                });
                                            });
                                        }), t = function() {
                                            return Y(f, function x() {
                                                var z = this;
                                                return O(x, function(E) {
                                                    z.g.graph && z.g.graph.url ? E = N(E, Qb(z, z.g.graph.url), 0) : (E.g = 0, E = void 0);
                                                    return E;
                                                });
                                            });
                                        }(), N(m, Promise.all([
                                            w,
                                            v,
                                            t
                                        ]), 7);
                                        if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                        g = h.filter(function(u) {
                                            return u.simd === void 0 || u.simd && e || !u.simd && !e;
                                        }).map(function(u) {
                                            return f.locateFile(u.url, f.S);
                                        });
                                        importScripts.apply(null, ea(g));
                                        return N(m, createMediapipeSolutionsWasm(Module), 6);
                                    case 6:
                                        d.h = m.h;
                                        d.l = new OffscreenCanvas(1, 1);
                                        d.h.canvas = d.l;
                                        k = d.h.GL.createContext(d.l, {
                                            antialias: false,
                                            alpha: false,
                                            ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                        });
                                        d.h.GL.makeContextCurrent(k);
                                        m.g = 4;
                                        break;
                                    case 7:
                                        d.l = document.createElement("canvas");
                                        y = d.l.getContext("webgl2", {});
                                        if (!y && (y = d.l.getContext("webgl", {}), !y)) return alert("Failed to create WebGL canvas context when passing video frame."), m.return();
                                        d.D = y;
                                        d.h.canvas = d.l;
                                        d.h.createContext(d.l, true, true, {});
                                    case 4:
                                        d.i = new d.h.SolutionWasm(), d.R = false, m.g = 0;
                                }
                            });
                        });
                    }
                    function Rb(a) {
                        return Y(a, function c() {
                            var d = this, f, h, e, g, k, l, q, v;
                            return O(c, function(w) {
                                if (w.g == 1) {
                                    if (d.g.graph && d.g.graph.url && d.P === d.g.graph.url) return w.return();
                                    d.o = true;
                                    if (!d.g.graph || !d.g.graph.url) {
                                        w.g = 2;
                                        return;
                                    }
                                    d.P = d.g.graph.url;
                                    return N(w, Qb(d, d.g.graph.url), 3);
                                }
                                w.g != 2 && (f = w.h, d.i.loadGraph(f));
                                h = M(Object.keys(d.B));
                                for(e = h.next(); !e.done; e = h.next())g = e.value, d.i.overrideFile(g, d.B[g]);
                                d.B = {};
                                if (d.g.listeners) for(k = M(d.g.listeners), l = k.next(); !l.done; l = k.next())q = l.value, Sb(d, q);
                                v = d.j;
                                d.j = {};
                                d.setOptions(v);
                                w.g = 0;
                            });
                        });
                    }
                    D.reset = function() {
                        return Y(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                c.i && (c.i.reset(), c.m = {}, c.s = {});
                                d.g = 0;
                            });
                        });
                    };
                    D.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], f = [], h = {}, e = M(Object.keys(a)), g = e.next(); !g.done; h = {
                                K: h.K,
                                L: h.L
                            }, g = e.next()){
                                var k = g.value;
                                k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], g = b[k], g !== void 0 && (g.onChange && (h.K = g.onChange, h.L = a[k], d.push(function(l) {
                                    return function() {
                                        return Y(c, function v() {
                                            var w, t = this;
                                            return O(v, function(y) {
                                                if (y.g == 1) return N(y, l.K(l.L), 2);
                                                w = y.h;
                                                w === true && (t.o = true);
                                                y.g = 0;
                                            });
                                        });
                                    };
                                }(h))), g.graphOptionXref && (k = {
                                    valueNumber: g.type === 1 ? a[k] : 0,
                                    valueBoolean: g.type === 0 ? a[k] : false,
                                    valueString: g.type === 2 ? a[k] : ""
                                }, g = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), g.graphOptionXref), k), f.push(g))));
                            }
                            if (d.length !== 0 || f.length !== 0) this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(f), this.u = (this.u === void 0 ? [] : this.u).concat(d);
                        }
                    };
                    function Tb(a) {
                        return Y(a, function c() {
                            var d = this, f, h, e, g, k, l, q;
                            return O(c, function(v) {
                                switch(v.g){
                                    case 1:
                                        if (!d.o) return v.return();
                                        if (!d.u) {
                                            v.g = 2;
                                            break;
                                        }
                                        f = M(d.u);
                                        h = f.next();
                                    case 3:
                                        if (h.done) {
                                            v.g = 5;
                                            break;
                                        }
                                        e = h.value;
                                        return N(v, e(), 4);
                                    case 4:
                                        h = f.next();
                                        v.g = 3;
                                        break;
                                    case 5:
                                        d.u = void 0;
                                    case 2:
                                        if (d.A) {
                                            g = new d.h.GraphOptionChangeRequestList();
                                            k = M(d.A);
                                            for(l = k.next(); !l.done; l = k.next())q = l.value, g.push_back(q);
                                            d.i.changeOptions(g);
                                            g.delete();
                                            d.A = void 0;
                                        }
                                        d.o = false;
                                        v.g = 0;
                                }
                            });
                        });
                    }
                    D.initialize = function() {
                        return Y(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                return d.g == 1 ? N(d, Pb(c), 2) : d.g != 3 ? N(d, Rb(c), 3) : N(d, Tb(c), 0);
                            });
                        });
                    };
                    function Qb(a, b) {
                        return Y(a, function d() {
                            var f = this, h, e;
                            return O(d, function(g) {
                                if (b in f.F) return g.return(f.F[b]);
                                h = f.locateFile(b, "");
                                e = fetch(h).then(function(k) {
                                    return k.arrayBuffer();
                                });
                                f.F[b] = e;
                                return g.return(e);
                            });
                        });
                    }
                    D.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
                    };
                    D.clearOverriddenFiles = function() {
                        this.B = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    D.send = function(a, b) {
                        return Y(this, function d() {
                            var f = this, h, e, g, k, l, q, v, w, t;
                            return O(d, function(y) {
                                switch(y.g){
                                    case 1:
                                        if (!f.g.inputs) return y.return();
                                        h = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                        return N(y, f.C, 2);
                                    case 2:
                                        return N(y, f.initialize(), 3);
                                    case 3:
                                        e = new f.h.PacketDataList();
                                        g = M(Object.keys(a));
                                        for(k = g.next(); !k.done; k = g.next())if (l = k.value, q = f.g.inputs[l]) {
                                            a: {
                                                var m = f;
                                                var u = a[l];
                                                switch(q.type){
                                                    case "video":
                                                        var x = m.m[q.stream];
                                                        x || (x = new Eb(m.h, m.D), m.m[q.stream] = x);
                                                        m = x;
                                                        m.l === 0 && (m.l = m.h.createTexture());
                                                        if (typeof HTMLVideoElement !== "undefined" && u instanceof HTMLVideoElement) {
                                                            var z = u.videoWidth;
                                                            x = u.videoHeight;
                                                        } else typeof HTMLImageElement !== "undefined" && u instanceof HTMLImageElement ? (z = u.naturalWidth, x = u.naturalHeight) : (z = u.width, x = u.height);
                                                        x = {
                                                            glName: m.l,
                                                            width: z,
                                                            height: x
                                                        };
                                                        z = m.g;
                                                        z.canvas.width = x.width;
                                                        z.canvas.height = x.height;
                                                        z.activeTexture(z.TEXTURE0);
                                                        m.h.bindTexture2d(m.l);
                                                        z.texImage2D(z.TEXTURE_2D, 0, z.RGBA, z.RGBA, z.UNSIGNED_BYTE, u);
                                                        m.h.bindTexture2d(0);
                                                        m = x;
                                                        break a;
                                                    case "detections":
                                                        x = m.m[q.stream];
                                                        x || (x = new Hb(m.h), m.m[q.stream] = x);
                                                        m = x;
                                                        m.data || (m.data = new m.g.DetectionListData());
                                                        m.data.reset(u.length);
                                                        for(x = 0; x < u.length; ++x){
                                                            z = u[x];
                                                            var E = m.data, F = E.setBoundingBox, K = x;
                                                            var I = z.T;
                                                            var r = new Ab();
                                                            W(r, 1, I.Z);
                                                            W(r, 2, I.$);
                                                            W(r, 3, I.height);
                                                            W(r, 4, I.width);
                                                            W(r, 5, I.rotation);
                                                            W(r, 6, I.X);
                                                            var A = I = new Za();
                                                            T(A, 1, V(r, 1));
                                                            T(A, 2, V(r, 2));
                                                            T(A, 3, V(r, 3));
                                                            T(A, 4, V(r, 4));
                                                            T(A, 5, V(r, 5));
                                                            var C = V(r, 6);
                                                            if (C != null && C != null) {
                                                                S(A.g, 48);
                                                                var p = A.g, B = C;
                                                                C = 0 > B;
                                                                B = Math.abs(B);
                                                                var n = B >>> 0;
                                                                B = Math.floor((B - n) / 4294967296);
                                                                B >>>= 0;
                                                                C && (B = ~B >>> 0, n = (~n >>> 0) + 1, 4294967295 < n && (n = 0, B++, 4294967295 < B && (B = 0)));
                                                                P = n;
                                                                Q = B;
                                                                C = P;
                                                                for(n = Q; 0 < n || 127 < C;)p.push(C & 127 | 128), C = (C >>> 7 | n << 25) >>> 0, n >>>= 7;
                                                                p.push(C);
                                                            }
                                                            qb(r, A);
                                                            I = ab(I);
                                                            F.call(E, K, I);
                                                            if (z.O) for(E = 0; E < z.O.length; ++E)r = z.O[E], A = r.visibility ? true : false, F = m.data, K = F.addNormalizedLandmark, I = x, r = Object.assign(Object.assign({}, r), {
                                                                visibility: A ? r.visibility : 0
                                                            }), A = new wb(), W(A, 1, r.x), W(A, 2, r.y), W(A, 3, r.z), r.visibility && W(A, 4, r.visibility), p = r = new Za(), T(p, 1, V(A, 1)), T(p, 2, V(A, 2)), T(p, 3, V(A, 3)), T(p, 4, V(A, 4)), T(p, 5, V(A, 5)), qb(A, p), r = ab(r), K.call(F, I, r);
                                                            if (z.M) for(E = 0; E < z.M.length; ++E){
                                                                F = m.data;
                                                                K = F.addClassification;
                                                                I = x;
                                                                r = z.M[E];
                                                                A = new sb();
                                                                W(A, 2, r.Y);
                                                                r.index && W(A, 1, r.index);
                                                                r.label && W(A, 3, r.label);
                                                                r.displayName && W(A, 4, r.displayName);
                                                                p = r = new Za();
                                                                n = V(A, 1);
                                                                if (n != null && n != null) {
                                                                    if (S(p.g, 8), C = p.g, 0 <= n) S(C, n);
                                                                    else {
                                                                        for(B = 0; 9 > B; B++)C.push(n & 127 | 128), n >>= 7;
                                                                        C.push(1);
                                                                    }
                                                                }
                                                                T(p, 2, V(A, 2));
                                                                C = V(A, 3);
                                                                C != null && (C = Ea(C), S(p.g, 26), S(p.g, C.length), $a(p, p.g.end()), $a(p, C));
                                                                C = V(A, 4);
                                                                C != null && (C = Ea(C), S(p.g, 34), S(p.g, C.length), $a(p, p.g.end()), $a(p, C));
                                                                qb(A, p);
                                                                r = ab(r);
                                                                K.call(F, I, r);
                                                            }
                                                        }
                                                        m = m.data;
                                                        break a;
                                                    default:
                                                        m = {};
                                                }
                                            }
                                            v = m;
                                            w = q.stream;
                                            switch(q.type){
                                                case "video":
                                                    e.pushTexture2d(Object.assign(Object.assign({}, v), {
                                                        stream: w,
                                                        timestamp: h
                                                    }));
                                                    break;
                                                case "detections":
                                                    t = v;
                                                    t.stream = w;
                                                    t.timestamp = h;
                                                    e.pushDetectionList(t);
                                                    break;
                                                default:
                                                    throw Error("Unknown input config type: '" + q.type + "'");
                                            }
                                        }
                                        f.i.send(e);
                                        return N(y, f.C, 4);
                                    case 4:
                                        e.delete(), y.g = 0;
                                }
                            });
                        });
                    };
                    function Ub(a, b, c) {
                        return Y(a, function f() {
                            var h, e, g, k, l, q, v = this, w, t, y, m, u, x, z, E;
                            return O(f, function(F) {
                                switch(F.g){
                                    case 1:
                                        if (!c) return F.return(b);
                                        h = {};
                                        e = 0;
                                        g = M(Object.keys(c));
                                        for(k = g.next(); !k.done; k = g.next())l = k.value, q = c[l], typeof q !== "string" && q.type === "texture" && b[q.stream] !== void 0 && ++e;
                                        1 < e && (v.G = false);
                                        w = M(Object.keys(c));
                                        k = w.next();
                                    case 2:
                                        if (k.done) {
                                            F.g = 4;
                                            break;
                                        }
                                        t = k.value;
                                        y = c[t];
                                        if (typeof y === "string") return z = h, E = t, N(F, Vb(v, t, b[y]), 14);
                                        m = b[y.stream];
                                        if (y.type === "detection_list") {
                                            if (m) {
                                                var K = m.getRectList();
                                                for(var I = m.getLandmarksList(), r = m.getClassificationsList(), A = [], C = 0; C < K.size(); ++C){
                                                    var p = K.get(C);
                                                    a: {
                                                        var B = new Ab();
                                                        for(p = new Ua(p); Va(p);)switch(p.i){
                                                            case 13:
                                                                var n = R(p.g);
                                                                W(B, 1, n);
                                                                break;
                                                            case 21:
                                                                n = R(p.g);
                                                                W(B, 2, n);
                                                                break;
                                                            case 29:
                                                                n = R(p.g);
                                                                W(B, 3, n);
                                                                break;
                                                            case 37:
                                                                n = R(p.g);
                                                                W(B, 4, n);
                                                                break;
                                                            case 45:
                                                                n = R(p.g);
                                                                W(B, 5, n);
                                                                break;
                                                            case 48:
                                                                for(var G = p.g, L = 128, Ia = 0, Z = n = 0; 4 > Z && 128 <= L; Z++)L = G.h[G.g++], Ia |= (L & 127) << 7 * Z;
                                                                128 <= L && (L = G.h[G.g++], Ia |= (L & 127) << 28, n |= (L & 127) >> 4);
                                                                if (128 <= L) for(Z = 0; 5 > Z && 128 <= L; Z++)L = G.h[G.g++], n |= (L & 127) << 7 * Z + 3;
                                                                if (128 > L) {
                                                                    G = Ia >>> 0;
                                                                    L = n >>> 0;
                                                                    if (n = L & 2147483648) G = ~G + 1 >>> 0, L = ~L >>> 0, G == 0 && (L = L + 1 >>> 0);
                                                                    G = 4294967296 * L + (G >>> 0);
                                                                    n = n ? -G : G;
                                                                } else G.l = true, n = void 0;
                                                                W(B, 6, n);
                                                                break;
                                                            default:
                                                                if (!rb(B, p)) break a;
                                                        }
                                                    }
                                                    B = {
                                                        Z: X(B, 1),
                                                        $: X(B, 2),
                                                        height: X(B, 3),
                                                        width: X(B, 4),
                                                        rotation: X(B, 5, 0),
                                                        X: ob(B, 6)
                                                    };
                                                    n = I.get(C);
                                                    a: for(p = new yb(), n = new Ua(n); Va(n);)switch(n.i){
                                                        case 10:
                                                            G = Xa(n, new wb(), xb);
                                                            mb(p, G, wb, void 0);
                                                            break;
                                                        default:
                                                            if (!rb(p, n)) break a;
                                                    }
                                                    p = lb(p, wb).map(Db);
                                                    G = r.get(C);
                                                    a: for(n = new ub(), G = new Ua(G); Va(G);)switch(G.i){
                                                        case 10:
                                                            n.addClassification(Xa(G, new sb(), tb));
                                                            break;
                                                        default:
                                                            if (!rb(n, G)) break a;
                                                    }
                                                    B = {
                                                        T: B,
                                                        O: p,
                                                        M: Cb(n)
                                                    };
                                                    A.push(B);
                                                }
                                                K = A;
                                            } else K = [];
                                            h[t] = K;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type === "proto_list") {
                                            if (m) {
                                                K = Array(m.size());
                                                for(I = 0; I < m.size(); I++)K[I] = m.get(I);
                                                m.delete();
                                            } else K = [];
                                            h[t] = K;
                                            F.g = 7;
                                            break;
                                        }
                                        if (m === void 0) {
                                            F.g = 3;
                                            break;
                                        }
                                        if (y.type === "float_list") {
                                            h[t] = m;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type === "proto") {
                                            h[t] = m;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type !== "texture") throw Error("Unknown output config type: '" + y.type + "'");
                                        u = v.s[t];
                                        u || (u = new Eb(v.h, v.D), v.s[t] = u);
                                        return N(F, Fb(u, m, v.G), 13);
                                    case 13:
                                        x = F.h, h[t] = x;
                                    case 7:
                                        y.transform && h[t] && (h[t] = y.transform(h[t]));
                                        F.g = 3;
                                        break;
                                    case 14:
                                        z[E] = F.h;
                                    case 3:
                                        k = w.next();
                                        F.g = 2;
                                        break;
                                    case 4:
                                        return F.return(h);
                                }
                            });
                        });
                    }
                    function Vb(a, b, c) {
                        return Y(a, function f() {
                            var h = this, e;
                            return O(f, function(g) {
                                return typeof c === "number" || c instanceof Uint8Array || c instanceof h.h.Uint8BlobList ? g.return(c) : c instanceof h.h.Texture2dDataOut ? (e = h.s[b], e || (e = new Eb(h.h, h.D), h.s[b] = e), g.return(Fb(e, c, h.G))) : g.return(void 0);
                            });
                        });
                    }
                    function Sb(a, b) {
                        for(var c = b.name || "$", d = [].concat(ea(b.wants)), f = new a.h.StringList(), h = M(b.wants), e = h.next(); !e.done; e = h.next())f.push_back(e.value);
                        h = a.h.PacketListener.implement({
                            onResults: function(g) {
                                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = g.get(l);
                                var q = a.listeners[c];
                                q && (a.C = Ub(a, k, b.outs).then(function(v) {
                                    v = q(v);
                                    for(var w = 0; w < b.wants.length; ++w){
                                        var t = k[d[w]];
                                        typeof t === "object" && t.hasOwnProperty && t.hasOwnProperty("delete") && t.delete();
                                    }
                                    v && (a.C = v);
                                }));
                            }
                        });
                        a.i.attachMultiListener(f, h);
                        f.delete();
                    }
                    D.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    ya("Solution", Nb);
                    ya("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        aa: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function Wb(a) {
                        a === void 0 && (a = 0);
                        switch(a){
                            case 1:
                                return "selfie_segmentation_landscape.tflite";
                            default:
                                return "selfie_segmentation.tflite";
                        }
                    }
                    function Xb(a) {
                        var b = this;
                        a = a || {};
                        this.g = new Nb({
                            locateFile: a.locateFile,
                            files: function(c) {
                                return [
                                    {
                                        simd: true,
                                        url: "selfie_segmentation_solution_simd_wasm_bin.js"
                                    },
                                    {
                                        simd: false,
                                        url: "selfie_segmentation_solution_wasm_bin.js"
                                    },
                                    {
                                        data: true,
                                        url: Wb(c.modelSelection)
                                    }
                                ];
                            },
                            graph: {
                                url: "selfie_segmentation.binarypb"
                            },
                            listeners: [
                                {
                                    wants: [
                                        "segmentation_mask",
                                        "image_transformed"
                                    ],
                                    outs: {
                                        image: {
                                            type: "texture",
                                            stream: "image_transformed"
                                        },
                                        segmentationMask: {
                                            type: "texture",
                                            stream: "segmentation_mask"
                                        }
                                    }
                                }
                            ],
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                selfieMode: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                modelSelection: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorModelSelection",
                                        fieldName: "int_value"
                                    },
                                    onChange: function(c) {
                                        return Y(b, function f() {
                                            var h, e, g = this, k;
                                            return O(f, function(l) {
                                                if (l.g == 1) return h = Wb(c), e = "third_party/mediapipe/modules/selfie_segmentation/" + h, N(l, Qb(g.g, h), 2);
                                                k = l.h;
                                                g.g.overrideFile(e, k);
                                                return l.return(true);
                                            });
                                        });
                                    }
                                }
                            }
                        });
                    }
                    D = Xb.prototype;
                    D.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    D.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    D.initialize = function() {
                        return Y(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                return N(d, c.g.initialize(), 0);
                            });
                        });
                    };
                    D.reset = function() {
                        this.g.reset();
                    };
                    D.send = function(a) {
                        return Y(this, function c() {
                            var d = this;
                            return O(c, function(f) {
                                return N(f, d.g.send(a), 0);
                            });
                        });
                    };
                    D.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    ya("SelfieSegmentation", Xb);
                    ya("VERSION", "0.1.1632777926");
                }).call(VonageSelfiesegmentation);
                const VonageHands = {};
                (function() {
                    var x;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var y = ca(this);
                    function B(a, b) {
                        if (b) a: {
                            var c = y;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    B("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    B("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = y[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function C(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function ea(a) {
                        if (!(a instanceof Array)) {
                            a = C(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var fa = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, ha;
                    if (typeof Object.setPrototypeOf == "function") ha = Object.setPrototypeOf;
                    else {
                        var ia;
                        a: {
                            var ja = {
                                a: true
                            }, ka = {};
                            try {
                                ka.__proto__ = ja;
                                ia = ka.a;
                                break a;
                            } catch (a) {}
                            ia = false;
                        }
                        ha = ia ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var la = ha;
                    function D(a, b) {
                        a.prototype = fa(b.prototype);
                        a.prototype.constructor = a;
                        if (la) la(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.ra = b.prototype;
                    }
                    function ma() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.u = this.o = 0;
                        this.j = null;
                    }
                    function na(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    ma.prototype.s = function(a) {
                        this.h = a;
                    };
                    function oa(a, b) {
                        a.j = {
                            fa: b,
                            ga: true
                        };
                        a.g = a.o || a.u;
                    }
                    ma.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.u;
                    };
                    function F(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function pa(a) {
                        this.g = new ma();
                        this.h = a;
                    }
                    function qa(a, b) {
                        na(a.g);
                        var c = a.g.i;
                        if (c) return ra(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return G(a);
                    }
                    function ra(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, oa(a.g, f), G(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return G(a);
                    }
                    function G(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, oa(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.ga) throw b.fa;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function sa(a) {
                        this.next = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i.next, b, a.g.s) : (a.g.s(b), b = G(a));
                            return b;
                        };
                        this.throw = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.s) : (oa(a.g, b), b = G(a));
                            return b;
                        };
                        this.return = function(b) {
                            return qa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function ta(a) {
                        function b(d) {
                            return a.next(d);
                        }
                        function c(d) {
                            return a.throw(d);
                        }
                        return new Promise(function(d, e) {
                            function g(f) {
                                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                            }
                            g(a.next());
                        });
                    }
                    function I(a) {
                        return ta(new sa(new pa(a)));
                    }
                    B("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.s = false;
                            var h = this.j();
                            try {
                                f(h.resolve, h.reject);
                            } catch (k) {
                                h.reject(k);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(h) {
                                h(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var h = this;
                                this.i(function() {
                                    h.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = y.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var h = 0; h < f.length; ++h){
                                    var k = f[h];
                                    f[h] = null;
                                    try {
                                        k();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(m) {
                                    k || (k = true, l.call(h, m));
                                };
                            }
                            var h = this, k = false;
                            return {
                                resolve: f(this.D),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.D = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.H(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var h = f != null;
                                        break a;
                                    case "function":
                                        h = true;
                                        break a;
                                    default:
                                        h = false;
                                }
                                h ? this.A(f) : this.o(f);
                            }
                        };
                        b.prototype.A = function(f) {
                            var h = void 0;
                            try {
                                h = f.then;
                            } catch (k) {
                                this.l(k);
                                return;
                            }
                            typeof h == "function" ? this.I(h, f) : this.o(f);
                        };
                        b.prototype.l = function(f) {
                            this.u(2, f);
                        };
                        b.prototype.o = function(f) {
                            this.u(1, f);
                        };
                        b.prototype.u = function(f, h) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = h;
                            this.h === 2 && this.G();
                            this.B();
                        };
                        b.prototype.G = function() {
                            var f = this;
                            e(function() {
                                if (f.C()) {
                                    var h = y.console;
                                    typeof h !== "undefined" && h.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.C = function() {
                            if (this.s) return false;
                            var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
                            if (typeof k === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof h === "function" ? f = new h("unhandledrejection", {
                                cancelable: true
                            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return k(f);
                        };
                        b.prototype.B = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.H = function(f) {
                            var h = this.j();
                            f.M(h.resolve, h.reject);
                        };
                        b.prototype.I = function(f, h) {
                            var k = this.j();
                            try {
                                f.call(h, k.resolve, k.reject);
                            } catch (l) {
                                k.reject(l);
                            }
                        };
                        b.prototype.then = function(f, h) {
                            function k(p, n) {
                                return typeof p == "function" ? function(q) {
                                    try {
                                        l(p(q));
                                    } catch (t) {
                                        m(t);
                                    }
                                } : n;
                            }
                            var l, m, r = new b(function(p, n) {
                                l = p;
                                m = n;
                            });
                            this.M(k(f, l), k(h, m));
                            return r;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.M = function(f, h) {
                            function k() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        h(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(k) : this.g.push(k);
                            this.s = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(h, k) {
                                k(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(h, k) {
                                for(var l = C(f), m = l.next(); !m.done; m = l.next())d(m.value).M(h, k);
                            });
                        };
                        b.all = function(f) {
                            var h = C(f), k = h.next();
                            return k.done ? d([]) : new b(function(l, m) {
                                function r(q) {
                                    return function(t) {
                                        p[q] = t;
                                        n--;
                                        n == 0 && l(p);
                                    };
                                }
                                var p = [], n = 0;
                                do p.push(void 0), n++, d(k.value).M(r(p.length - 1), m), k = h.next();
                                while (!k.done);
                            });
                        };
                        return b;
                    });
                    function ua(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    B("Object.assign", function(a) {
                        return a || va;
                    });
                    B("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    B("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    B("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    B("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ua(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var wa = this || self;
                    function J(a, b) {
                        a = a.split(".");
                        var c = wa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function K() {
                        throw Error("Invalid UTF8");
                    }
                    function xa(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var ya, za = typeof TextDecoder !== "undefined", Aa, Ba = typeof TextEncoder !== "undefined";
                    var Ca = {}, L = null;
                    function Da(a) {
                        var b;
                        b === void 0 && (b = 0);
                        Ea();
                        b = Ca[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | h >> 4];
                            h = b[(h & 15) << 2 | k >> 6];
                            k = b[k & 63];
                            c[g++] = l + f + h + k;
                        }
                        l = 0;
                        k = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], k = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
                        }
                        return c.join("");
                    }
                    function Fa(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Ga(a, function(g) {
                            d[e++] = g;
                        });
                        return e !== c ? d.subarray(0, e) : d;
                    }
                    function Ga(a, b) {
                        function c(k) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), m = L[l];
                                if (m != null) return m;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return k;
                        }
                        Ea();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), h = c(64);
                            if (h === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
                        }
                    }
                    function Ea() {
                        if (!L) {
                            L = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Ca[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    L[g] === void 0 && (L[g] = e);
                                }
                            }
                        }
                    }
                    var Ha = typeof Uint8Array === "function";
                    function Ia(a) {
                        return Ha && a != null && a instanceof Uint8Array;
                    }
                    var Ja;
                    function Ka(a) {
                        this.L = a;
                        if (a !== null && a.length === 0) throw Error("ByteString should be constructed with non-empty values");
                    }
                    var La = typeof Uint8Array.prototype.slice === "function", M = 0, N = 0;
                    function Ma(a, b) {
                        if (a.constructor === Uint8Array) return a;
                        if (a.constructor === ArrayBuffer) return new Uint8Array(a);
                        if (a.constructor === Array) return new Uint8Array(a);
                        if (a.constructor === String) return Fa(a);
                        if (a.constructor === Ka) {
                            if (!b && (b = a.L) && b.constructor === Uint8Array) return b;
                            b = a.L;
                            b = b == null || Ia(b) ? b : typeof b === "string" ? Fa(b) : null;
                            return (a = a.L = b) ? new Uint8Array(a) : Ja || (Ja = new Uint8Array(0));
                        }
                        if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
                    }
                    function Na(a, b) {
                        return Error("Invalid wire type: " + a + " (at position " + b + ")");
                    }
                    function Oa() {
                        return Error("Failed to read varint, encoding is invalid.");
                    }
                    function Pa(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.v === void 0 ? false : b.v;
                        this.h = null;
                        this.g = this.i = this.j = 0;
                        this.v = b;
                        a && Qa(this, a);
                    }
                    function Qa(a, b) {
                        a.h = Ma(b, a.v);
                        a.j = 0;
                        a.i = a.h.length;
                        a.g = a.j;
                    }
                    Pa.prototype.reset = function() {
                        this.g = this.j;
                    };
                    function O(a) {
                        if (a.g > a.i) throw Error("Tried to read past the end of the data " + a.g + " > " + a.i);
                    }
                    function Q(a) {
                        var b = a.h, c = b[a.g], d = c & 127;
                        if (128 > c) return a.g += 1, O(a), d;
                        c = b[a.g + 1];
                        d |= (c & 127) << 7;
                        if (128 > c) return a.g += 2, O(a), d;
                        c = b[a.g + 2];
                        d |= (c & 127) << 14;
                        if (128 > c) return a.g += 3, O(a), d;
                        c = b[a.g + 3];
                        d |= (c & 127) << 21;
                        if (128 > c) return a.g += 4, O(a), d;
                        c = b[a.g + 4];
                        a.g += 5;
                        d |= (c & 15) << 28;
                        if (128 > c) return O(a), d;
                        if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++]) throw Oa();
                        O(a);
                        return d;
                    }
                    var Ra = [];
                    function Sa() {
                        this.g = [];
                    }
                    Sa.prototype.length = function() {
                        return this.g.length;
                    };
                    Sa.prototype.end = function() {
                        var a = this.g;
                        this.g = [];
                        return a;
                    };
                    function R(a, b) {
                        for(; 127 < b;)a.g.push(b & 127 | 128), b >>>= 7;
                        a.g.push(b);
                    }
                    function Ta(a) {
                        var b = {}, c = b.W === void 0 ? false : b.W;
                        this.l = {
                            v: b.v === void 0 ? false : b.v
                        };
                        this.W = c;
                        b = this.l;
                        Ra.length ? (c = Ra.pop(), b && (c.v = b.v), a && Qa(c, a), a = c) : a = new Pa(a, b);
                        this.g = a;
                        this.j = this.g.g;
                        this.h = this.i = -1;
                    }
                    Ta.prototype.reset = function() {
                        this.g.reset();
                        this.j = this.g.g;
                        this.h = this.i = -1;
                    };
                    function Ua(a) {
                        var b = a.g;
                        if (b.g == b.i) return false;
                        a.j = a.g.g;
                        var c = Q(a.g) >>> 0;
                        b = c >>> 3;
                        c &= 7;
                        if (!(0 <= c && 5 >= c)) throw Na(c, a.j);
                        if (1 > b) throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
                        a.i = b;
                        a.h = c;
                        return true;
                    }
                    function Va(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Va(a);
                                else a: {
                                    a = a.g;
                                    for(var b = a.g, c = b + 10; b < c;)if ((a.h[b++] & 128) === 0) {
                                        a.g = b;
                                        O(a);
                                        break a;
                                    }
                                    throw Oa();
                                }
                                break;
                            case 1:
                                a = a.g;
                                a.g += 8;
                                O(a);
                                break;
                            case 2:
                                a.h != 2 ? Va(a) : (b = Q(a.g) >>> 0, a = a.g, a.g += b, O(a));
                                break;
                            case 5:
                                a = a.g;
                                a.g += 4;
                                O(a);
                                break;
                            case 3:
                                b = a.i;
                                do {
                                    if (!Ua(a)) throw Error("Unmatched start-group tag: stream EOF");
                                    if (a.h == 4) {
                                        if (a.i != b) throw Error("Unmatched end-group tag");
                                        break;
                                    }
                                    Va(a);
                                }while (1);
                                break;
                            default:
                                throw Na(a.h, a.j);
                        }
                    }
                    var Wa = [];
                    function Xa() {
                        this.i = [];
                        this.h = 0;
                        this.g = new Sa();
                    }
                    function S(a, b) {
                        b.length !== 0 && (a.i.push(b), a.h += b.length);
                    }
                    function Ya(a, b) {
                        if (b = b.ca) {
                            S(a, a.g.end());
                            for(var c = 0; c < b.length; c++)S(a, b[c]);
                        }
                    }
                    var T = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
                    function Za(a, b) {
                        Object.isFrozen(a) || (T ? a[T] |= b : a.N !== void 0 ? a.N |= b : Object.defineProperties(a, {
                            N: {
                                value: b,
                                configurable: true,
                                writable: true,
                                enumerable: false
                            }
                        }));
                    }
                    function $a(a) {
                        var b;
                        T ? b = a[T] : b = a.N;
                        return b == null ? 0 : b;
                    }
                    function U(a) {
                        Za(a, 1);
                        return a;
                    }
                    function ab(a) {
                        return Array.isArray(a) ? !!($a(a) & 2) : false;
                    }
                    function bb(a) {
                        if (!Array.isArray(a)) throw Error("cannot mark non-array as immutable");
                        Za(a, 2);
                    }
                    function cb(a) {
                        return a !== null && typeof a === "object" && !Array.isArray(a) && a.constructor === Object;
                    }
                    var db = Object.freeze(U([]));
                    function eb(a) {
                        if (ab(a.m)) throw Error("Cannot mutate an immutable Message");
                    }
                    var fb = typeof Symbol != "undefined" && typeof Symbol.hasInstance != "undefined";
                    function gb(a) {
                        return {
                            value: a,
                            configurable: false,
                            writable: false,
                            enumerable: false
                        };
                    }
                    function V(a, b, c) {
                        return b === -1 ? null : b >= a.i ? a.g ? a.g[b] : void 0 : (c === void 0 ? 0 : c) && a.g && (c = a.g[b], c != null) ? c : a.m[b + a.h];
                    }
                    function W(a, b, c, d) {
                        d = d === void 0 ? false : d;
                        eb(a);
                        b < a.i && !d ? a.m[b + a.h] = c : (a.g || (a.g = a.m[a.i + a.h] = {}))[b] = c;
                    }
                    function hb(a, b, c, d) {
                        c = c === void 0 ? true : c;
                        d = d === void 0 ? false : d;
                        var e = V(a, b, d);
                        e == null && (e = db);
                        if (ab(a.m)) c && (bb(e), Object.freeze(e));
                        else if (e === db || ab(e)) e = U(e.slice()), W(a, b, e, d);
                        return e;
                    }
                    function X(a, b, c) {
                        a = V(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function ib(a, b, c, d) {
                        a.j || (a.j = {});
                        var e = ab(a.m), g = a.j[c];
                        if (!g) {
                            d = hb(a, c, true, d === void 0 ? false : d);
                            g = [];
                            e = e || ab(d);
                            for(var f = 0; f < d.length; f++)g[f] = new b(d[f]), e && bb(g[f].m);
                            e && (bb(g), Object.freeze(g));
                            a.j[c] = g;
                        }
                        return g;
                    }
                    function jb(a, b, c, d, e) {
                        var g = g === void 0 ? false : g;
                        eb(a);
                        g = ib(a, c, b, g);
                        c = d ? d : new c();
                        a = hb(a, b);
                        e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.m)) : (g.push(c), a.push(c.m));
                        return c;
                    }
                    function kb(a, b) {
                        a = V(a, b);
                        return a == null ? 0 : a;
                    }
                    function lb(a, b) {
                        a = V(a, b);
                        return a == null ? "" : a;
                    }
                    function mb(a) {
                        switch(typeof a){
                            case "number":
                                return isFinite(a) ? a : String(a);
                            case "object":
                                if (a && !Array.isArray(a)) {
                                    if (Ia(a)) return Da(a);
                                    if (a instanceof Ka) {
                                        var b = a.L;
                                        b = b == null || typeof b === "string" ? b : Ha && b instanceof Uint8Array ? Da(b) : null;
                                        return (a.L = b) || "";
                                    }
                                }
                        }
                        return a;
                    }
                    function nb(a) {
                        var b = ob;
                        b = b === void 0 ? pb : b;
                        return qb(a, b);
                    }
                    function rb(a, b) {
                        if (a != null) {
                            if (Array.isArray(a)) a = qb(a, b);
                            else if (cb(a)) {
                                var c = {}, d;
                                for(d in a)c[d] = rb(a[d], b);
                                a = c;
                            } else a = b(a);
                            return a;
                        }
                    }
                    function qb(a, b) {
                        for(var c = a.slice(), d = 0; d < c.length; d++)c[d] = rb(c[d], b);
                        Array.isArray(a) && $a(a) & 1 && U(c);
                        return c;
                    }
                    function ob(a) {
                        if (a && typeof a == "object" && a.toJSON) return a.toJSON();
                        a = mb(a);
                        return Array.isArray(a) ? nb(a) : a;
                    }
                    function pb(a) {
                        return Ia(a) ? new Uint8Array(a) : a;
                    }
                    function sb(a, b, c) {
                        a || (a = tb);
                        tb = null;
                        var d = this.constructor.h;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.h = (d ? 0 : -1) - (this.constructor.g || 0);
                        this.j = void 0;
                        this.m = a;
                        a: {
                            d = this.m.length;
                            a = d - 1;
                            if (d && (d = this.m[a], cb(d))) {
                                this.i = a - this.h;
                                this.g = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.i = Math.max(b, a + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)if (a = c[b], a < this.i) a += this.h, (d = this.m[a]) ? Array.isArray(d) && U(d) : this.m[a] = db;
                        else {
                            d = this.g || (this.g = this.m[this.i + this.h] = {});
                            var e = d[a];
                            e ? Array.isArray(e) && U(e) : d[a] = db;
                        }
                    }
                    sb.prototype.toJSON = function() {
                        return nb(this.m);
                    };
                    sb.prototype.toString = function() {
                        return this.m.toString();
                    };
                    var tb;
                    function ub() {
                        sb.apply(this, arguments);
                    }
                    D(ub, sb);
                    if (fb) {
                        var vb = {};
                        Object.defineProperties(ub, (vb[Symbol.hasInstance] = gb(function() {
                            throw Error("Cannot perform instanceof checks for MutableMessage");
                        }), vb));
                    }
                    function wb(a, b, c) {
                        if (c) {
                            var d = {}, e;
                            for(e in c){
                                var g = c[e], f = g.ja;
                                f || (d.F = g.pa || g.ha.P, g.ba ? (d.U = xb(g.ba), f = function(h) {
                                    return function(k, l, m) {
                                        return h.F(k, l, m, h.U);
                                    };
                                }(d)) : g.da ? (d.T = yb(g.X.g, g.da), f = function(h) {
                                    return function(k, l, m) {
                                        return h.F(k, l, m, h.T);
                                    };
                                }(d)) : f = d.F, g.ja = f);
                                f(b, a, g.X);
                                d = {
                                    F: d.F,
                                    U: d.U,
                                    T: d.T
                                };
                            }
                        }
                        Ya(b, a);
                    }
                    var zb = Symbol();
                    function Ab(a, b, c) {
                        return a[zb] || (a[zb] = function(d, e) {
                            return b(d, e, c);
                        });
                    }
                    function Bb(a) {
                        var b = a[zb];
                        if (!b) {
                            var c = Cb(a);
                            b = function(d, e) {
                                return Db(d, e, c);
                            };
                            a[zb] = b;
                        }
                        return b;
                    }
                    function Eb(a) {
                        var b = a.ba;
                        if (b) return Bb(b);
                        if (b = a.oa) return Ab(a.X.g, b, a.da);
                    }
                    function Fb(a) {
                        var b = Eb(a), c = a.X, d = a.ha.O;
                        return b ? function(e, g) {
                            return d(e, g, c, b);
                        } : function(e, g) {
                            return d(e, g, c);
                        };
                    }
                    function Gb(a, b, c, d, e, g) {
                        a = a();
                        var f = 0;
                        a.length && typeof a[0] !== "number" && (c(b, a[0]), f++);
                        for(; f < a.length;){
                            c = a[f++];
                            for(var h = f + 1; h < a.length && typeof a[h] !== "number";)h++;
                            var k = a[f++];
                            h -= f;
                            switch(h){
                                case 0:
                                    d(b, c, k);
                                    break;
                                case 1:
                                    d(b, c, k, a[f++]);
                                    break;
                                case 2:
                                    e(b, c, k, a[f++], a[f++]);
                                    break;
                                case 3:
                                    h = a[f++];
                                    var l = a[f++], m = a[f++];
                                    Array.isArray(m) ? e(b, c, k, h, l, m) : g(b, c, k, h, l, m);
                                    break;
                                case 4:
                                    g(b, c, k, a[f++], a[f++], a[f++], a[f++]);
                                    break;
                                default:
                                    throw Error("unexpected number of binary field arguments: " + h);
                            }
                        }
                        return b;
                    }
                    var Hb = Symbol();
                    function xb(a) {
                        var b = a[Hb];
                        if (!b) {
                            var c = Ib(a);
                            b = function(d, e) {
                                return Jb(d, e, c);
                            };
                            a[Hb] = b;
                        }
                        return b;
                    }
                    function yb(a, b) {
                        var c = a[Hb];
                        c || (c = function(d, e) {
                            return wb(d, e, b);
                        }, a[Hb] = c);
                        return c;
                    }
                    var Kb = Symbol();
                    function Lb(a, b) {
                        a.push(b);
                    }
                    function Mb(a, b, c) {
                        a.push(b, c.P);
                    }
                    function Nb(a, b, c, d, e) {
                        var g = xb(e), f = c.P;
                        a.push(b, function(h, k, l) {
                            return f(h, k, l, d, g);
                        });
                    }
                    function Ob(a, b, c, d, e, g) {
                        var f = yb(d, g), h = c.P;
                        a.push(b, function(k, l, m) {
                            return h(k, l, m, d, f);
                        });
                    }
                    function Ib(a) {
                        var b = a[Kb];
                        return b ? b : Gb(a, a[Kb] = [], Lb, Mb, Nb, Ob);
                    }
                    var Pb = Symbol();
                    function Qb(a, b) {
                        a[0] = b;
                    }
                    function Rb(a, b, c, d) {
                        var e = c.O;
                        a[b] = d ? function(g, f, h) {
                            return e(g, f, h, d);
                        } : e;
                    }
                    function Sb(a, b, c, d, e, g) {
                        var f = c.O, h = Bb(e);
                        a[b] = function(k, l, m) {
                            return f(k, l, m, d, h, g);
                        };
                    }
                    function Tb(a, b, c, d, e, g, f) {
                        var h = c.O, k = Ab(d, e, g);
                        a[b] = function(l, m, r) {
                            return h(l, m, r, d, k, f);
                        };
                    }
                    function Cb(a) {
                        var b = a[Pb];
                        return b ? b : Gb(a, a[Pb] = {}, Qb, Rb, Sb, Tb);
                    }
                    function Db(a, b, c) {
                        for(; Ua(b) && b.h != 4;){
                            var d = b.i, e = c[d];
                            if (!e) {
                                var g = c[0];
                                g && (g = g[d]) && (e = c[d] = Fb(g));
                            }
                            if (!e || !e(b, a, d)) {
                                if (e = b, d = a, g = e.j, Va(e), !e.W) {
                                    var f = e.g.h;
                                    e = e.g.g;
                                    e = g === e ? Ja || (Ja = new Uint8Array(0)) : La ? f.slice(g, e) : new Uint8Array(f.subarray(g, e));
                                    (g = d.ca) ? g.push(e) : d.ca = [
                                        e
                                    ];
                                }
                            }
                        }
                        return a;
                    }
                    function Ub(a, b, c) {
                        if (Wa.length) {
                            var d = Wa.pop();
                            a && (Qa(d.g, a), d.i = -1, d.h = -1);
                            a = d;
                        } else a = new Ta(a);
                        try {
                            return Db(new b(), a, Cb(c));
                        } finally{
                            b = a.g, b.h = null, b.j = 0, b.i = 0, b.g = 0, b.v = false, a.i = -1, a.h = -1, 100 > Wa.length && Wa.push(a);
                        }
                    }
                    function Jb(a, b, c) {
                        for(var d = c.length, e = d % 2 == 1, g = e ? 1 : 0; g < d; g += 2)(0, c[g + 1])(b, a, c[g]);
                        wb(a, b, e ? c[0] : void 0);
                    }
                    function Vb(a, b) {
                        var c = new Xa();
                        Jb(a, c, Ib(b));
                        S(c, c.g.end());
                        a = new Uint8Array(c.h);
                        b = c.i;
                        for(var d = b.length, e = 0, g = 0; g < d; g++){
                            var f = b[g];
                            a.set(f, e);
                            e += f.length;
                        }
                        c.i = [
                            a
                        ];
                        return a;
                    }
                    function Wb(a, b) {
                        return {
                            O: a,
                            P: b
                        };
                    }
                    var Y = Wb(function(a, b, c) {
                        if (a.h !== 5) return false;
                        a = a.g;
                        var d = a.h[a.g];
                        var e = a.h[a.g + 1];
                        var g = a.h[a.g + 2], f = a.h[a.g + 3];
                        a.g += 4;
                        O(a);
                        e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
                        a = 2 * (e >> 31) + 1;
                        d = e >>> 23 & 255;
                        e &= 8388607;
                        W(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null) {
                            R(a.g, 8 * c + 5);
                            a = a.g;
                            var d = b;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? M = N = 0 : (N = 0, M = 2147483648) : isNaN(d) ? (N = 0, M = 2147483647) : 34028234663852886e22 < d ? (N = 0, M = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), N = 0, M = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, N = 0, M = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = M;
                            a.g.push(c >>> 0 & 255);
                            a.g.push(c >>> 8 & 255);
                            a.g.push(c >>> 16 & 255);
                            a.g.push(c >>> 24 & 255);
                        }
                    }), Xb = Wb(function(a, b, c) {
                        if (a.h !== 0) return false;
                        for(var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)e = d.h[d.g++], O(d), g |= (e & 127) << 7 * f;
                        128 <= e && (e = d.h[d.g++], O(d), g |= (e & 127) << 28, a |= (e & 127) >> 4);
                        if (128 <= e) for(f = 0; 5 > f && 128 <= e; f++)e = d.h[d.g++], O(d), a |= (e & 127) << 7 * f + 3;
                        if (128 > e) {
                            d = g >>> 0;
                            e = a >>> 0;
                            if (a = e & 2147483648) d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
                            d = 4294967296 * e + (d >>> 0);
                        } else throw Oa();
                        W(b, c, a ? -d : d);
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null && b != null) {
                            R(a.g, 8 * c);
                            a = a.g;
                            var d = b;
                            c = 0 > d;
                            d = Math.abs(d);
                            b = d >>> 0;
                            d = Math.floor((d - b) / 4294967296);
                            d >>>= 0;
                            c && (d = ~d >>> 0, b = (~b >>> 0) + 1, 4294967295 < b && (b = 0, d++, 4294967295 < d && (d = 0)));
                            M = b;
                            N = d;
                            c = M;
                            for(b = N; 0 < b || 127 < c;)a.g.push(c & 127 | 128), c = (c >>> 7 | b << 25) >>> 0, b >>>= 7;
                            a.g.push(c);
                        }
                    }), Yb = Wb(function(a, b, c) {
                        if (a.h !== 0) return false;
                        W(b, c, Q(a.g));
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null && b != null) {
                            if (R(a.g, 8 * c), a = a.g, c = b, 0 <= c) R(a, c);
                            else {
                                for(b = 0; 9 > b; b++)a.g.push(c & 127 | 128), c >>= 7;
                                a.g.push(1);
                            }
                        }
                    }), Zb = Wb(function(a, b, c) {
                        if (a.h !== 2) return false;
                        var d = Q(a.g) >>> 0;
                        a = a.g;
                        var e = a.g;
                        a.g += d;
                        O(a);
                        a = a.h;
                        var g;
                        if (za) (g = ya) || (g = ya = new TextDecoder("utf-8", {
                            fatal: true
                        })), g = g.decode(a.subarray(e, e + d));
                        else {
                            d = e + d;
                            for(var f = [], h = null, k, l, m; e < d;)k = a[e++], 128 > k ? f.push(k) : 224 > k ? e >= d ? K() : (l = a[e++], 194 > k || (l & 192) !== 128 ? (e--, K()) : f.push((k & 31) << 6 | l & 63)) : 240 > k ? e >= d - 1 ? K() : (l = a[e++], (l & 192) !== 128 || k === 224 && 160 > l || k === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, K()) : f.push((k & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= k ? e >= d - 2 ? K() : (l = a[e++], (l & 192) !== 128 || (k << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((m = a[e++]) & 192) !== 128 ? (e--, K()) : (k = (k & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | m & 63, k -= 65536, f.push((k >> 10 & 1023) + 55296, (k & 1023) + 56320))) : K(), 8192 <= f.length && (h = xa(h, f), f.length = 0);
                            g = xa(h, f);
                        }
                        W(b, c, g);
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null) {
                            var d = false;
                            d = d === void 0 ? false : d;
                            if (Ba) {
                                if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b)) throw Error("Found an unpaired surrogate");
                                b = (Aa || (Aa = new TextEncoder())).encode(b);
                            } else {
                                for(var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++){
                                    var h = b.charCodeAt(f);
                                    if (128 > h) g[e++] = h;
                                    else {
                                        if (2048 > h) g[e++] = h >> 6 | 192;
                                        else {
                                            if (55296 <= h && 57343 >= h) {
                                                if (56319 >= h && f < b.length) {
                                                    var k = b.charCodeAt(++f);
                                                    if (56320 <= k && 57343 >= k) {
                                                        h = 1024 * (h - 55296) + k - 56320 + 65536;
                                                        g[e++] = h >> 18 | 240;
                                                        g[e++] = h >> 12 & 63 | 128;
                                                        g[e++] = h >> 6 & 63 | 128;
                                                        g[e++] = h & 63 | 128;
                                                        continue;
                                                    } else f--;
                                                }
                                                if (d) throw Error("Found an unpaired surrogate");
                                                h = 65533;
                                            }
                                            g[e++] = h >> 12 | 224;
                                            g[e++] = h >> 6 & 63 | 128;
                                        }
                                        g[e++] = h & 63 | 128;
                                    }
                                }
                                b = g.subarray(0, e);
                            }
                            R(a.g, 8 * c + 2);
                            R(a.g, b.length);
                            S(a, a.g.end());
                            S(a, b);
                        }
                    }), $b = Wb(function(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        b = jb(b, c, d);
                        c = a.g.i;
                        d = Q(a.g) >>> 0;
                        var g = a.g.g + d, f = g - c;
                        0 >= f && (a.g.i = g, e(b, a), f = g - a.g.g);
                        if (f) throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                        a.g.g = g;
                        a.g.i = c;
                        return true;
                    }, function(a, b, c, d, e) {
                        b = ib(b, d, c);
                        if (b != null) for(d = 0; d < b.length; d++){
                            var g = a;
                            R(g.g, 8 * c + 2);
                            var f = g.g.end();
                            S(g, f);
                            f.push(g.h);
                            g = f;
                            e(b[d], a);
                            f = a;
                            var h = g.pop();
                            for(h = f.h + f.g.length() - h; 127 < h;)g.push(h & 127 | 128), h >>>= 7, f.h++;
                            g.push(h);
                            f.h++;
                        }
                    });
                    function Z() {
                        ub.apply(this, arguments);
                    }
                    D(Z, ub);
                    if (fb) {
                        var ac = {};
                        Object.defineProperties(Z, (ac[Symbol.hasInstance] = gb(Object[Symbol.hasInstance]), ac));
                    }
                    function bc(a) {
                        Z.call(this, a);
                    }
                    D(bc, Z);
                    function cc() {
                        return [
                            1,
                            Yb,
                            2,
                            Y,
                            3,
                            Zb,
                            4,
                            Zb
                        ];
                    }
                    function dc(a) {
                        Z.call(this, a, -1, ec);
                    }
                    D(dc, Z);
                    dc.prototype.addClassification = function(a, b) {
                        jb(this, 1, bc, a, b);
                        return this;
                    };
                    function fc() {
                        return [
                            1,
                            $b,
                            bc,
                            cc
                        ];
                    }
                    var ec = [
                        1
                    ];
                    function gc(a) {
                        Z.call(this, a);
                    }
                    D(gc, Z);
                    function hc() {
                        return [
                            1,
                            Y,
                            2,
                            Y,
                            3,
                            Y,
                            4,
                            Y,
                            5,
                            Y
                        ];
                    }
                    function ic(a) {
                        Z.call(this, a, -1, jc);
                    }
                    D(ic, Z);
                    function kc() {
                        return [
                            1,
                            $b,
                            gc,
                            hc
                        ];
                    }
                    var jc = [
                        1
                    ];
                    function lc(a) {
                        Z.call(this, a);
                    }
                    D(lc, Z);
                    function mc() {
                        return [
                            1,
                            Y,
                            2,
                            Y,
                            3,
                            Y,
                            4,
                            Y,
                            5,
                            Y,
                            6,
                            Xb
                        ];
                    }
                    function nc(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function oc(a) {
                        return ib(a, bc, 1).map(function(b) {
                            return {
                                index: kb(b, 1),
                                score: X(b, 2),
                                label: V(b, 3) != null ? lb(b, 3) : void 0,
                                displayName: V(b, 4) != null ? lb(b, 4) : void 0
                            };
                        });
                    }
                    function pc(a) {
                        return {
                            x: X(a, 1),
                            y: X(a, 2),
                            z: X(a, 3),
                            visibility: V(a, 4) != null ? X(a, 4) : void 0
                        };
                    }
                    function qc(a) {
                        return a.map(function(b) {
                            return ib(Ub(b, ic, kc), gc, 1).map(pc);
                        });
                    }
                    function rc(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function sc(a, b, c) {
                        tc(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function tc(a, b) {
                        var c = a.g;
                        if (a.o === void 0) {
                            var d = nc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = nc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.o = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                K: c.getAttribLocation(d, "aVertex"),
                                J: c.getAttribLocation(d, "aTex"),
                                qa: e
                            };
                            a.u = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.u);
                            c.enableVertexAttribArray(a.j.K);
                            c.vertexAttribPointer(a.j.K, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.J);
                            c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.o);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.K);
                        c.bindBuffer(c.ARRAY_BUFFER, a.u);
                        c.vertexAttribPointer(d.K, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.J);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.K);
                        c.disableVertexAttribArray(d.J);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function uc(a) {
                        this.g = a;
                    }
                    var vc = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function wc(a, b) {
                        return b + a;
                    }
                    function xc(a, b) {
                        window[a] = b;
                    }
                    function yc(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function zc() {
                        return I(function(a) {
                            switch(a.g){
                                case 1:
                                    return a.o = 2, F(a, WebAssembly.instantiate(vc), 4);
                                case 4:
                                    a.g = 3;
                                    a.o = 0;
                                    break;
                                case 2:
                                    return a.o = 0, a.j = null, a.return(false);
                                case 3:
                                    return a.return(true);
                            }
                        });
                    }
                    function Ac(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.H = {};
                        this.o = {};
                        this.u = {};
                        this.I = this.s = this.$ = true;
                        this.D = Promise.resolve();
                        this.Z = "";
                        this.C = {};
                        this.locateFile = a && a.locateFile || wc;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.aa = b;
                        if (a.options) {
                            b = C(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    x = Ac.prototype;
                    x.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Bc(a) {
                        var b, c, d, e, g, f, h, k, l, m, r;
                        return I(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!a.$) return p.return();
                                    b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
                                    return F(p, zc(), 2);
                                case 2:
                                    c = p.h;
                                    if (typeof window === "object") return xc("createMediapipeSolutionsWasm", {
                                        locateFile: a.locateFile
                                    }), xc("createMediapipeSolutionsPackedAssets", {
                                        locateFile: a.locateFile
                                    }), f = b.filter(function(n) {
                                        return n.data !== void 0;
                                    }), h = b.filter(function(n) {
                                        return n.data === void 0;
                                    }), k = Promise.all(f.map(function(n) {
                                        var q = Cc(a, n.url);
                                        if (n.path !== void 0) {
                                            var t = n.path;
                                            q = q.then(function(w) {
                                                a.overrideFile(t, w);
                                                return Promise.resolve(w);
                                            });
                                        }
                                        return q;
                                    })), l = Promise.all(h.map(function(n) {
                                        return n.simd === void 0 || n.simd && c || !n.simd && !c ? yc(a.locateFile(n.url, a.aa)) : Promise.resolve();
                                    })).then(function() {
                                        var n, q, t;
                                        return I(function(w) {
                                            if (w.g == 1) return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, n(q), 2);
                                            t.h = w.h;
                                            w.g = 0;
                                        });
                                    }), m = function() {
                                        return I(function(n) {
                                            a.g.graph && a.g.graph.url ? n = F(n, Cc(a, a.g.graph.url), 0) : (n.g = 0, n = void 0);
                                            return n;
                                        });
                                    }(), F(p, Promise.all([
                                        l,
                                        k,
                                        m
                                    ]), 7);
                                    if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                    d = b.filter(function(n) {
                                        return n.simd === void 0 || n.simd && c || !n.simd && !c;
                                    }).map(function(n) {
                                        return a.locateFile(n.url, a.aa);
                                    });
                                    importScripts.apply(null, ea(d));
                                    e = a;
                                    return F(p, createMediapipeSolutionsWasm(Module), 6);
                                case 6:
                                    e.h = p.h;
                                    a.l = new OffscreenCanvas(1, 1);
                                    a.h.canvas = a.l;
                                    g = a.h.GL.createContext(a.l, {
                                        antialias: false,
                                        alpha: false,
                                        na: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                    });
                                    a.h.GL.makeContextCurrent(g);
                                    p.g = 4;
                                    break;
                                case 7:
                                    a.l = document.createElement("canvas");
                                    r = a.l.getContext("webgl2", {});
                                    if (!r && (r = a.l.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                                    a.G = r;
                                    a.h.canvas = a.l;
                                    a.h.createContext(a.l, true, true, {});
                                case 4:
                                    a.i = new a.h.SolutionWasm(), a.$ = false, p.g = 0;
                            }
                        });
                    }
                    function Dc(a) {
                        var b, c, d, e, g, f, h, k;
                        return I(function(l) {
                            if (l.g == 1) {
                                if (a.g.graph && a.g.graph.url && a.Z === a.g.graph.url) return l.return();
                                a.s = true;
                                if (!a.g.graph || !a.g.graph.url) {
                                    l.g = 2;
                                    return;
                                }
                                a.Z = a.g.graph.url;
                                return F(l, Cc(a, a.g.graph.url), 3);
                            }
                            l.g != 2 && (b = l.h, a.i.loadGraph(b));
                            c = C(Object.keys(a.C));
                            for(d = c.next(); !d.done; d = c.next())e = d.value, a.i.overrideFile(e, a.C[e]);
                            a.C = {};
                            if (a.g.listeners) for(g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())h = f.value, Ec(a, h);
                            k = a.j;
                            a.j = {};
                            a.setOptions(k);
                            l.g = 0;
                        });
                    }
                    x.reset = function() {
                        var a = this;
                        return I(function(b) {
                            a.i && (a.i.reset(), a.o = {}, a.u = {});
                            b.g = 0;
                        });
                    };
                    x.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = C(Object.keys(a)), h = f.next(); !h.done; g = {
                                R: g.R,
                                S: g.S
                            }, h = f.next()){
                                var k = h.value;
                                k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.R = h.onChange, g.S = a[k], d.push(function(l) {
                                    return function() {
                                        var m;
                                        return I(function(r) {
                                            if (r.g == 1) return F(r, l.R(l.S), 2);
                                            m = r.h;
                                            m === true && (c.s = true);
                                            r.g = 0;
                                        });
                                    };
                                }(g))), h.graphOptionXref && (k = {
                                    valueNumber: h.type === 1 ? a[k] : 0,
                                    valueBoolean: h.type === 0 ? a[k] : false,
                                    valueString: h.type === 2 ? a[k] : ""
                                }, h = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), h.graphOptionXref), k), e.push(h))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.s = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
                        }
                    };
                    function Fc(a) {
                        var b, c, d, e, g, f, h;
                        return I(function(k) {
                            switch(k.g){
                                case 1:
                                    if (!a.s) return k.return();
                                    if (!a.A) {
                                        k.g = 2;
                                        break;
                                    }
                                    b = C(a.A);
                                    c = b.next();
                                case 3:
                                    if (c.done) {
                                        k.g = 5;
                                        break;
                                    }
                                    d = c.value;
                                    return F(k, d(), 4);
                                case 4:
                                    c = b.next();
                                    k.g = 3;
                                    break;
                                case 5:
                                    a.A = void 0;
                                case 2:
                                    if (a.B) {
                                        e = new a.h.GraphOptionChangeRequestList();
                                        g = C(a.B);
                                        for(f = g.next(); !f.done; f = g.next())h = f.value, e.push_back(h);
                                        a.i.changeOptions(e);
                                        e.delete();
                                        a.B = void 0;
                                    }
                                    a.s = false;
                                    k.g = 0;
                            }
                        });
                    }
                    x.initialize = function() {
                        var a = this;
                        return I(function(b) {
                            return b.g == 1 ? F(b, Bc(a), 2) : b.g != 3 ? F(b, Dc(a), 3) : F(b, Fc(a), 0);
                        });
                    };
                    function Cc(a, b) {
                        var c, d;
                        return I(function(e) {
                            if (b in a.H) return e.return(a.H[b]);
                            c = a.locateFile(b, "");
                            d = fetch(c).then(function(g) {
                                return g.arrayBuffer();
                            });
                            a.H[b] = d;
                            return e.return(d);
                        });
                    }
                    x.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
                    };
                    x.clearOverriddenFiles = function() {
                        this.C = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    x.send = function(a, b) {
                        var c = this, d, e, g, f, h, k, l, m, r;
                        return I(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!c.g.inputs) return p.return();
                                    d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                    return F(p, c.D, 2);
                                case 2:
                                    return F(p, c.initialize(), 3);
                                case 3:
                                    e = new c.h.PacketDataList();
                                    g = C(Object.keys(a));
                                    for(f = g.next(); !f.done; f = g.next())if (h = f.value, k = c.g.inputs[h]) {
                                        a: {
                                            var n = a[h];
                                            switch(k.type){
                                                case "video":
                                                    var q = c.o[k.stream];
                                                    q || (q = new rc(c.h, c.G), c.o[k.stream] = q);
                                                    q.l === 0 && (q.l = q.h.createTexture());
                                                    if (typeof HTMLVideoElement !== "undefined" && n instanceof HTMLVideoElement) {
                                                        var t = n.videoWidth;
                                                        var w = n.videoHeight;
                                                    } else typeof HTMLImageElement !== "undefined" && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                                                    w = {
                                                        glName: q.l,
                                                        width: t,
                                                        height: w
                                                    };
                                                    t = q.g;
                                                    t.canvas.width = w.width;
                                                    t.canvas.height = w.height;
                                                    t.activeTexture(t.TEXTURE0);
                                                    q.h.bindTexture2d(q.l);
                                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                                                    q.h.bindTexture2d(0);
                                                    q = w;
                                                    break a;
                                                case "detections":
                                                    q = c.o[k.stream];
                                                    q || (q = new uc(c.h), c.o[k.stream] = q);
                                                    q.data || (q.data = new q.g.DetectionListData());
                                                    q.data.reset(n.length);
                                                    for(w = 0; w < n.length; ++w){
                                                        t = n[w];
                                                        var v = q.data, A = v.setBoundingBox, H = w;
                                                        var E = t.ea;
                                                        var u = new lc();
                                                        W(u, 1, E.ka);
                                                        W(u, 2, E.la);
                                                        W(u, 3, E.height);
                                                        W(u, 4, E.width);
                                                        W(u, 5, E.rotation);
                                                        W(u, 6, E.ia);
                                                        E = Vb(u, mc);
                                                        A.call(v, H, E);
                                                        if (t.Y) for(v = 0; v < t.Y.length; ++v){
                                                            u = t.Y[v];
                                                            var z = u.visibility ? true : false;
                                                            A = q.data;
                                                            H = A.addNormalizedLandmark;
                                                            E = w;
                                                            u = Object.assign(Object.assign({}, u), {
                                                                visibility: z ? u.visibility : 0
                                                            });
                                                            z = new gc();
                                                            W(z, 1, u.x);
                                                            W(z, 2, u.y);
                                                            W(z, 3, u.z);
                                                            u.visibility && W(z, 4, u.visibility);
                                                            u = Vb(z, hc);
                                                            H.call(A, E, u);
                                                        }
                                                        if (t.V) for(v = 0; v < t.V.length; ++v)A = q.data, H = A.addClassification, E = w, u = t.V[v], z = new bc(), W(z, 2, u.score), u.index && W(z, 1, u.index), u.label && W(z, 3, u.label), u.displayName && W(z, 4, u.displayName), u = Vb(z, cc), H.call(A, E, u);
                                                    }
                                                    q = q.data;
                                                    break a;
                                                default:
                                                    q = {};
                                            }
                                        }
                                        l = q;
                                        m = k.stream;
                                        switch(k.type){
                                            case "video":
                                                e.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                    stream: m,
                                                    timestamp: d
                                                }));
                                                break;
                                            case "detections":
                                                r = l;
                                                r.stream = m;
                                                r.timestamp = d;
                                                e.pushDetectionList(r);
                                                break;
                                            default:
                                                throw Error("Unknown input config type: '" + k.type + "'");
                                        }
                                    }
                                    c.i.send(e);
                                    return F(p, c.D, 4);
                                case 4:
                                    e.delete(), p.g = 0;
                            }
                        });
                    };
                    function Gc(a, b, c) {
                        var d, e, g, f, h, k, l, m, r, p, n, q, t, w;
                        return I(function(v) {
                            switch(v.g){
                                case 1:
                                    if (!c) return v.return(b);
                                    d = {};
                                    e = 0;
                                    g = C(Object.keys(c));
                                    for(f = g.next(); !f.done; f = g.next())h = f.value, k = c[h], typeof k !== "string" && k.type === "texture" && b[k.stream] !== void 0 && ++e;
                                    1 < e && (a.I = false);
                                    l = C(Object.keys(c));
                                    f = l.next();
                                case 2:
                                    if (f.done) {
                                        v.g = 4;
                                        break;
                                    }
                                    m = f.value;
                                    r = c[m];
                                    if (typeof r === "string") return t = d, w = m, F(v, Hc(a, m, b[r]), 14);
                                    p = b[r.stream];
                                    if (r.type === "detection_list") {
                                        if (p) {
                                            var A = p.getRectList();
                                            for(var H = p.getLandmarksList(), E = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z){
                                                var P = Ub(A.get(z), lc, mc);
                                                P = {
                                                    ea: {
                                                        ka: X(P, 1),
                                                        la: X(P, 2),
                                                        height: X(P, 3),
                                                        width: X(P, 4),
                                                        rotation: X(P, 5, 0),
                                                        ia: kb(P, 6)
                                                    },
                                                    Y: ib(Ub(H.get(z), ic, kc), gc, 1).map(pc),
                                                    V: oc(Ub(E.get(z), dc, fc))
                                                };
                                                u.push(P);
                                            }
                                            A = u;
                                        } else A = [];
                                        d[m] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto_list") {
                                        if (p) {
                                            A = Array(p.size());
                                            for(H = 0; H < p.size(); H++)A[H] = p.get(H);
                                            p.delete();
                                        } else A = [];
                                        d[m] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (p === void 0) {
                                        v.g = 3;
                                        break;
                                    }
                                    if (r.type === "float_list") {
                                        d[m] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto") {
                                        d[m] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type !== "texture") throw Error("Unknown output config type: '" + r.type + "'");
                                    n = a.u[m];
                                    n || (n = new rc(a.h, a.G), a.u[m] = n);
                                    return F(v, sc(n, p, a.I), 13);
                                case 13:
                                    q = v.h, d[m] = q;
                                case 7:
                                    r.transform && d[m] && (d[m] = r.transform(d[m]));
                                    v.g = 3;
                                    break;
                                case 14:
                                    t[w] = v.h;
                                case 3:
                                    f = l.next();
                                    v.g = 2;
                                    break;
                                case 4:
                                    return v.return(d);
                            }
                        });
                    }
                    function Hc(a, b, c) {
                        var d;
                        return I(function(e) {
                            return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.u[b], d || (d = new rc(a.h, a.G), a.u[b] = d), e.return(sc(d, c, a.I))) : e.return(void 0);
                        });
                    }
                    function Ec(a, b) {
                        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(h) {
                                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                                var m = a.listeners[c];
                                m && (a.D = Gc(a, k, b.outs).then(function(r) {
                                    r = m(r);
                                    for(var p = 0; p < b.wants.length; ++p){
                                        var n = k[d[p]];
                                        typeof n === "object" && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
                                    }
                                    r && (a.D = r);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    x.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    J("Solution", Ac);
                    J("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        ma: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function Ic(a) {
                        a === void 0 && (a = 0);
                        return a === 1 ? "hand_landmark_full.tflite" : "hand_landmark_lite.tflite";
                    }
                    function Jc(a) {
                        var b = this;
                        a = a || {};
                        this.g = new Ac({
                            locateFile: a.locateFile,
                            files: function(c) {
                                return [
                                    {
                                        url: "hands_solution_packed_assets_loader.js"
                                    },
                                    {
                                        simd: false,
                                        url: "hands_solution_wasm_bin.js"
                                    },
                                    {
                                        simd: true,
                                        url: "hands_solution_simd_wasm_bin.js"
                                    },
                                    {
                                        data: true,
                                        url: Ic(c.modelComplexity)
                                    }
                                ];
                            },
                            graph: {
                                url: "hands.binarypb"
                            },
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            listeners: [
                                {
                                    wants: [
                                        "multi_hand_landmarks",
                                        "multi_hand_world_landmarks",
                                        "image_transformed",
                                        "multi_handedness"
                                    ],
                                    outs: {
                                        image: "image_transformed",
                                        multiHandLandmarks: {
                                            type: "proto_list",
                                            stream: "multi_hand_landmarks",
                                            transform: qc
                                        },
                                        multiHandWorldLandmarks: {
                                            type: "proto_list",
                                            stream: "multi_hand_world_landmarks",
                                            transform: qc
                                        },
                                        multiHandedness: {
                                            type: "proto_list",
                                            stream: "multi_handedness",
                                            transform: function(c) {
                                                return c.map(function(d) {
                                                    return oc(Ub(d, dc, fc))[0];
                                                });
                                            }
                                        }
                                    }
                                }
                            ],
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                selfieMode: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                maxNumHands: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculator",
                                        fieldName: "int_value"
                                    }
                                },
                                modelComplexity: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorModelComplexity",
                                        fieldName: "int_value"
                                    },
                                    onChange: function(c) {
                                        var d, e, g;
                                        return I(function(f) {
                                            if (f.g == 1) return d = Ic(c), e = "third_party/mediapipe/modules/hand_landmark/" + d, F(f, Cc(b.g, d), 2);
                                            g = f.h;
                                            b.g.overrideFile(e, g);
                                            return f.return(true);
                                        });
                                    }
                                },
                                minDetectionConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "TensorsToDetectionsCalculator",
                                        calculatorName: "handlandmarktrackinggpu__palmdetectiongpu__TensorsToDetectionsCalculator",
                                        fieldName: "min_score_thresh"
                                    }
                                },
                                minTrackingConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ThresholdingCalculator",
                                        calculatorName: "handlandmarktrackinggpu__handlandmarkgpu__ThresholdingCalculator",
                                        fieldName: "threshold"
                                    }
                                }
                            }
                        });
                    }
                    x = Jc.prototype;
                    x.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    x.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    x.initialize = function() {
                        var a = this;
                        return I(function(b) {
                            return F(b, a.g.initialize(), 0);
                        });
                    };
                    x.reset = function() {
                        this.g.reset();
                    };
                    x.send = function(a) {
                        var b = this;
                        return I(function(c) {
                            return F(c, b.g.send(a), 0);
                        });
                    };
                    x.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    J("Hands", Jc);
                    J("HAND_CONNECTIONS", [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            2
                        ],
                        [
                            2,
                            3
                        ],
                        [
                            3,
                            4
                        ],
                        [
                            0,
                            5
                        ],
                        [
                            5,
                            6
                        ],
                        [
                            6,
                            7
                        ],
                        [
                            7,
                            8
                        ],
                        [
                            5,
                            9
                        ],
                        [
                            9,
                            10
                        ],
                        [
                            10,
                            11
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            9,
                            13
                        ],
                        [
                            13,
                            14
                        ],
                        [
                            14,
                            15
                        ],
                        [
                            15,
                            16
                        ],
                        [
                            13,
                            17
                        ],
                        [
                            0,
                            17
                        ],
                        [
                            17,
                            18
                        ],
                        [
                            18,
                            19
                        ],
                        [
                            19,
                            20
                        ]
                    ]);
                    J("VERSION", "0.4.1646424915");
                }).call(VonageHands);
                var VonageHolistic = {};
                (function() {
                    var x;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var y = ca(this);
                    function z(a, b) {
                        if (b) a: {
                            var c = y;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    z("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    z("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = y[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function B(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function D(a) {
                        if (!(a instanceof Array)) {
                            a = B(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var ea = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, fa;
                    if (typeof Object.setPrototypeOf == "function") fa = Object.setPrototypeOf;
                    else {
                        var ha;
                        a: {
                            var ia = {
                                a: true
                            }, ja = {};
                            try {
                                ja.__proto__ = ia;
                                ha = ja.a;
                                break a;
                            } catch (a) {}
                            ha = false;
                        }
                        fa = ha ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var ka = fa;
                    function E(a, b) {
                        a.prototype = ea(b.prototype);
                        a.prototype.constructor = a;
                        if (ka) ka(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.da = b.prototype;
                    }
                    function la() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.s = this.m = 0;
                        this.j = null;
                    }
                    function ma(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    la.prototype.o = function(a) {
                        this.h = a;
                    };
                    function na(a, b) {
                        a.j = {
                            U: b,
                            V: true
                        };
                        a.g = a.m || a.s;
                    }
                    la.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.s;
                    };
                    function F(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function oa(a) {
                        this.g = new la();
                        this.h = a;
                    }
                    function pa(a, b) {
                        ma(a.g);
                        var c = a.g.i;
                        if (c) return qa(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return ra(a);
                    }
                    function qa(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, na(a.g, f), ra(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return ra(a);
                    }
                    function ra(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, na(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.V) throw b.U;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function sa(a) {
                        this.next = function(b) {
                            ma(a.g);
                            a.g.i ? b = qa(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = ra(a));
                            return b;
                        };
                        this.throw = function(b) {
                            ma(a.g);
                            a.g.i ? b = qa(a, a.g.i["throw"], b, a.g.o) : (na(a.g, b), b = ra(a));
                            return b;
                        };
                        this.return = function(b) {
                            return pa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function ta(a) {
                        function b(d) {
                            return a.next(d);
                        }
                        function c(d) {
                            return a.throw(d);
                        }
                        return new Promise(function(d, e) {
                            function g(f) {
                                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                            }
                            g(a.next());
                        });
                    }
                    function H(a) {
                        return ta(new sa(new oa(a)));
                    }
                    z("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.o = false;
                            var k = this.j();
                            try {
                                f(k.resolve, k.reject);
                            } catch (h) {
                                k.reject(h);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(k) {
                                k(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var k = this;
                                this.i(function() {
                                    k.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = y.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var k = 0; k < f.length; ++k){
                                    var h = f[k];
                                    f[k] = null;
                                    try {
                                        h();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(n) {
                                    h || (h = true, l.call(k, n));
                                };
                            }
                            var k = this, h = false;
                            return {
                                resolve: f(this.C),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.C = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.F(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var k = f != null;
                                        break a;
                                    case "function":
                                        k = true;
                                        break a;
                                    default:
                                        k = false;
                                }
                                k ? this.v(f) : this.m(f);
                            }
                        };
                        b.prototype.v = function(f) {
                            var k = void 0;
                            try {
                                k = f.then;
                            } catch (h) {
                                this.l(h);
                                return;
                            }
                            typeof k == "function" ? this.G(k, f) : this.m(f);
                        };
                        b.prototype.l = function(f) {
                            this.s(2, f);
                        };
                        b.prototype.m = function(f) {
                            this.s(1, f);
                        };
                        b.prototype.s = function(f, k) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = k;
                            this.h === 2 && this.D();
                            this.A();
                        };
                        b.prototype.D = function() {
                            var f = this;
                            e(function() {
                                if (f.B()) {
                                    var k = y.console;
                                    typeof k !== "undefined" && k.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.B = function() {
                            if (this.o) return false;
                            var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
                            if (typeof h === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof k === "function" ? f = new k("unhandledrejection", {
                                cancelable: true
                            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return h(f);
                        };
                        b.prototype.A = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.F = function(f) {
                            var k = this.j();
                            f.J(k.resolve, k.reject);
                        };
                        b.prototype.G = function(f, k) {
                            var h = this.j();
                            try {
                                f.call(k, h.resolve, h.reject);
                            } catch (l) {
                                h.reject(l);
                            }
                        };
                        b.prototype.then = function(f, k) {
                            function h(p, m) {
                                return typeof p == "function" ? function(q) {
                                    try {
                                        l(p(q));
                                    } catch (t) {
                                        n(t);
                                    }
                                } : m;
                            }
                            var l, n, r = new b(function(p, m) {
                                l = p;
                                n = m;
                            });
                            this.J(h(f, l), h(k, n));
                            return r;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.J = function(f, k) {
                            function h() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        k(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(h) : this.g.push(h);
                            this.o = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(k, h) {
                                h(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(k, h) {
                                for(var l = B(f), n = l.next(); !n.done; n = l.next())d(n.value).J(k, h);
                            });
                        };
                        b.all = function(f) {
                            var k = B(f), h = k.next();
                            return h.done ? d([]) : new b(function(l, n) {
                                function r(q) {
                                    return function(t) {
                                        p[q] = t;
                                        m--;
                                        m == 0 && l(p);
                                    };
                                }
                                var p = [], m = 0;
                                do p.push(void 0), m++, d(h.value).J(r(p.length - 1), n), h = k.next();
                                while (!h.done);
                            });
                        };
                        return b;
                    });
                    function ua(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    z("Object.assign", function(a) {
                        return a || va;
                    });
                    z("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    z("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    z("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    z("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ua(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var wa = this || self;
                    function I(a, b) {
                        a = a.split(".");
                        var c = wa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function xa(a) {
                        wa.setTimeout(function() {
                            throw a;
                        }, 0);
                    }
                    function ya(a) {
                        xa(a);
                        return;
                    }
                    function za(a, b) {
                        ya(Error("Invalid wire type: " + a + " (at position " + b + ")"));
                    }
                    function Aa() {
                        ya(Error("Failed to read varint, encoding is invalid."));
                    }
                    function Ba(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var Ca, Da = typeof TextDecoder !== "undefined", Ea, Fa = typeof TextEncoder !== "undefined";
                    function Ga(a) {
                        if (Fa) a = (Ea || (Ea = new TextEncoder())).encode(a);
                        else {
                            var b = void 0;
                            b = b === void 0 ? false : b;
                            for(var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++){
                                var g = a.charCodeAt(e);
                                if (128 > g) d[c++] = g;
                                else {
                                    if (2048 > g) d[c++] = g >> 6 | 192;
                                    else {
                                        if (55296 <= g && 57343 >= g) {
                                            if (56319 >= g && e < a.length) {
                                                var f = a.charCodeAt(++e);
                                                if (56320 <= f && 57343 >= f) {
                                                    g = 1024 * (g - 55296) + f - 56320 + 65536;
                                                    d[c++] = g >> 18 | 240;
                                                    d[c++] = g >> 12 & 63 | 128;
                                                    d[c++] = g >> 6 & 63 | 128;
                                                    d[c++] = g & 63 | 128;
                                                    continue;
                                                } else e--;
                                            }
                                            if (b) throw Error("Found an unpaired surrogate");
                                            g = 65533;
                                        }
                                        d[c++] = g >> 12 | 224;
                                        d[c++] = g >> 6 & 63 | 128;
                                    }
                                    d[c++] = g & 63 | 128;
                                }
                            }
                            a = d.subarray(0, c);
                        }
                        return a;
                    }
                    var Ha = {}, Ia = null;
                    function Ja(a) {
                        var b;
                        b === void 0 && (b = 0);
                        Ka();
                        b = Ha[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | k >> 4];
                            k = b[(k & 15) << 2 | h >> 6];
                            h = b[h & 63];
                            c[g++] = l + f + k + h;
                        }
                        l = 0;
                        h = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], h = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
                        }
                        return c.join("");
                    }
                    function La(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Ma(a, function(g) {
                            d[e++] = g;
                        });
                        return d.subarray(0, e);
                    }
                    function Ma(a, b) {
                        function c(h) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), n = Ia[l];
                                if (n != null) return n;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return h;
                        }
                        Ka();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), k = c(64);
                            if (k === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
                        }
                    }
                    function Ka() {
                        if (!Ia) {
                            Ia = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Ha[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    Ia[g] === void 0 && (Ia[g] = e);
                                }
                            }
                        }
                    }
                    var Na = typeof Uint8Array === "function", Oa;
                    function Pa(a) {
                        this.g = a;
                        if (a !== null && a.length === 0) throw Error("ByteString should be constructed with non-empty values");
                    }
                    Pa.prototype.toJSON = function() {
                        if (this.g == null) var a = "";
                        else a = this.g, a = this.g = a == null || typeof a === "string" ? a : Na && a instanceof Uint8Array ? Ja(a) : null;
                        return a;
                    };
                    var Qa = typeof Uint8Array.prototype.slice === "function";
                    function Ra(a, b, c) {
                        return b === c ? Oa || (Oa = new Uint8Array(0)) : Qa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
                    }
                    var K = 0, L = 0;
                    function Sa(a) {
                        if (a.constructor === Uint8Array) return a;
                        if (a.constructor === ArrayBuffer) return new Uint8Array(a);
                        if (a.constructor === Array) return new Uint8Array(a);
                        if (a.constructor === String) return La(a);
                        if (a.constructor === Pa) {
                            if (a.g == null) var b = Oa || (Oa = new Uint8Array(0));
                            else {
                                b = Uint8Array;
                                var c = a.g;
                                c = c == null || Na && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? La(c) : null;
                                a = a.g = c;
                                b = new b(a);
                            }
                            return b;
                        }
                        if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
                    }
                    function Ta(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.u === void 0 ? false : b.u;
                        this.h = null;
                        this.g = this.i = this.m = 0;
                        this.l = false;
                        this.u = b;
                        a && Ua(this, a);
                    }
                    function Ua(a, b) {
                        a.h = Sa(b);
                        a.m = 0;
                        a.i = a.h.length;
                        a.g = a.m;
                    }
                    Ta.prototype.reset = function() {
                        this.g = this.m;
                    };
                    function Va(a) {
                        for(var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)b = a.h[a.g++], c |= (b & 127) << 7 * e;
                        128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
                        if (128 <= b) for(e = 0; 5 > e && 128 <= b; e++)b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
                        if (128 > b) {
                            a = c >>> 0;
                            b = d >>> 0;
                            if (d = b & 2147483648) a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
                            a = 4294967296 * b + (a >>> 0);
                            return d ? -a : a;
                        }
                        a.l = true;
                        Aa();
                    }
                    function M(a) {
                        a.g > a.i && (a.l = true, ya(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
                    }
                    Ta.prototype.j = function() {
                        var a = this.h, b = a[this.g], c = b & 127;
                        if (128 > b) return this.g += 1, M(this), c;
                        b = a[this.g + 1];
                        c |= (b & 127) << 7;
                        if (128 > b) return this.g += 2, M(this), c;
                        b = a[this.g + 2];
                        c |= (b & 127) << 14;
                        if (128 > b) return this.g += 3, M(this), c;
                        b = a[this.g + 3];
                        c |= (b & 127) << 21;
                        if (128 > b) return this.g += 4, M(this), c;
                        b = a[this.g + 4];
                        c |= (b & 15) << 28;
                        if (128 > b) return this.g += 5, M(this), c >>> 0;
                        this.g += 5;
                        if (128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++]) return this.l = true, Aa(), c;
                        M(this);
                        return c;
                    };
                    Ta.prototype.o = function() {
                        var a = this.h[this.g], b = this.h[this.g + 1];
                        var c = this.h[this.g + 2];
                        var d = this.h[this.g + 3];
                        this.g += 4;
                        M(this);
                        c = (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
                        a = 2 * (c >> 31) + 1;
                        b = c >>> 23 & 255;
                        c &= 8388607;
                        return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
                    };
                    var Wa = [];
                    function Xa() {
                        this.g = new Uint8Array(64);
                        this.h = 0;
                    }
                    function N(a, b) {
                        if (!(a.h + 1 < a.g.length)) {
                            var c = a.g;
                            a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
                            a.g.set(c);
                        }
                        a.g[a.h++] = b;
                    }
                    Xa.prototype.length = function() {
                        return this.h;
                    };
                    Xa.prototype.end = function() {
                        var a = this.g, b = this.h;
                        this.h = 0;
                        return Ra(a, 0, b);
                    };
                    function Ya(a, b) {
                        for(; 127 < b;)N(a, b & 127 | 128), b >>>= 7;
                        N(a, b);
                    }
                    function Za(a) {
                        var b = {}, c = b.N === void 0 ? false : b.N;
                        this.m = {
                            u: b.u === void 0 ? false : b.u
                        };
                        this.N = c;
                        b = this.m;
                        Wa.length ? (c = Wa.pop(), b && (c.u = b.u), a && Ua(c, a), a = c) : a = new Ta(a, b);
                        this.g = a;
                        this.l = this.g.g;
                        this.h = this.i = -1;
                        this.j = false;
                    }
                    Za.prototype.reset = function() {
                        this.g.reset();
                        this.h = this.i = -1;
                    };
                    function $a(a) {
                        var b = a.g;
                        (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.l || 0 > b.g || b.g > b.i);
                        if (b) return false;
                        a.l = a.g.g;
                        var c = a.g.j();
                        b = c >>> 3;
                        c &= 7;
                        if (!(0 <= c && 5 >= c)) return a.j = true, za(c, a.l), false;
                        a.i = b;
                        a.h = c;
                        return true;
                    }
                    function ab(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) ab(a);
                                else a: {
                                    a = a.g;
                                    for(var b = a.g, c = 0; 10 > c; c++){
                                        if ((a.h[b] & 128) === 0) {
                                            a.g = b + 1;
                                            M(a);
                                            break a;
                                        }
                                        b++;
                                    }
                                    a.l = true;
                                    Aa();
                                }
                                break;
                            case 1:
                                a = a.g;
                                a.g += 8;
                                M(a);
                                break;
                            case 2:
                                a.h != 2 ? ab(a) : (b = a.g.j(), a = a.g, a.g += b, M(a));
                                break;
                            case 5:
                                a = a.g;
                                a.g += 4;
                                M(a);
                                break;
                            case 3:
                                b = a.i;
                                do {
                                    if (!$a(a)) {
                                        a.j = true;
                                        ya(Error("Unmatched start-group tag: stream EOF"));
                                        break;
                                    }
                                    if (a.h == 4) {
                                        a.i != b && (a.j = true, ya(Error("Unmatched end-group tag")));
                                        break;
                                    }
                                    ab(a);
                                }while (1);
                                break;
                            default:
                                a.j = true, za(a.h, a.l);
                        }
                    }
                    function bb(a, b, c) {
                        a.N || (a = Ra(a.g.h, c, a.g.g), (c = b.o) ? c.push(a) : b.o = [
                            a
                        ]);
                    }
                    function cb(a, b, c) {
                        var d = a.g.i, e = a.g.j(), g = a.g.g + e;
                        a.g.i = g;
                        c(b, a);
                        c = g - a.g.g;
                        if (c !== 0) throw Error("Message parsing ended unexpectedly. Expected to read " + (e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                        a.g.g = g;
                        a.g.i = d;
                        return b;
                    }
                    function db(a, b, c) {
                        var d = a.g.j();
                        for(d = a.g.g + d; a.g.g < d;)c.push(b.call(a.g));
                    }
                    var eb = [];
                    function fb() {
                        this.h = [];
                        this.i = 0;
                        this.g = new Xa();
                    }
                    function gb(a, b) {
                        b.length !== 0 && (a.h.push(b), a.i += b.length);
                    }
                    function hb(a, b, c) {
                        Ya(a.g, 8 * b + 2);
                        Ya(a.g, c.length);
                        gb(a, a.g.end());
                        gb(a, c);
                    }
                    var ib = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
                    function jb(a, b) {
                        Object.isFrozen(a) || (ib ? a[ib] |= b : a.g !== void 0 ? a.g |= b : Object.defineProperties(a, {
                            g: {
                                value: b,
                                configurable: true,
                                writable: true,
                                enumerable: false
                            }
                        }));
                    }
                    function kb(a) {
                        if (!a) return 0;
                        var b;
                        ib ? b = a[ib] : b = a.g;
                        return b == null ? 0 : b;
                    }
                    function lb(a) {
                        if (!Array.isArray(a)) return a;
                        jb(a, 1);
                        return a;
                    }
                    function mb(a) {
                        if (!Array.isArray(a)) throw Error("cannot mark non-array as immutable");
                        jb(a, 2);
                    }
                    function nb(a) {
                        return a !== null && typeof a === "object" && a.constructor === Object;
                    }
                    function ob(a) {
                        switch(typeof a){
                            case "number":
                                return isFinite(a) ? a : String(a);
                            case "object":
                                return Na && a != null && a instanceof Uint8Array ? Ja(a) : a;
                            default:
                                return a;
                        }
                    }
                    function pb(a, b) {
                        if (a != null) return Array.isArray(a) || nb(a) ? qb(a, b) : b(a);
                    }
                    function qb(a, b) {
                        if (Array.isArray(a)) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = pb(a[d], b);
                            kb(a) & 1 && lb(c);
                            return c;
                        }
                        c = {};
                        for(d in a)c[d] = pb(a[d], b);
                        return c;
                    }
                    var rb;
                    function O(a, b, c) {
                        var d = rb;
                        rb = null;
                        a || (a = d);
                        d = this.constructor.ba;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.j = (d ? 0 : -1) - (this.constructor.$ || 0);
                        this.m = this.g = null;
                        this.h = a;
                        a: {
                            d = this.h.length;
                            a = d - 1;
                            if (d && (d = this.h[a], nb(d))) {
                                this.l = a - this.j;
                                this.i = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)a = c[b], a < this.l ? (a += this.j, (d = this.h[a]) ? lb(d) : this.h[a] = sb) : (tb(this), (d = this.i[a]) ? lb(d) : this.i[a] = sb);
                    }
                    var sb = Object.freeze(lb([]));
                    function tb(a) {
                        var b = a.l + a.j;
                        a.h[b] || (a.i = a.h[b] = {});
                    }
                    function P(a, b, c) {
                        return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.i ? a.i[b] : void 0 : a.h[b + a.j];
                    }
                    function ub(a, b, c) {
                        c = c === void 0 ? true : c;
                        var d = d === void 0 ? false : d;
                        var e = P(a, b, d);
                        e == null && (e = sb);
                        e === sb ? (e = lb([]), Q(a, b, e, d)) : c && Array.isArray(e) && kb(e) & 2 && (e = e.slice(), Q(a, b, e, d));
                        return e;
                    }
                    function vb(a) {
                        var b = ub(a, 3, false);
                        a.m || (a.m = {});
                        if (!a.m[3]) {
                            for(var c = 0; c < b.length; c++)b[c] = +b[c];
                            a.m[3] = true;
                        }
                        return b;
                    }
                    function R(a, b, c) {
                        a = P(a, b);
                        return a == null ? c : a;
                    }
                    function S(a, b, c) {
                        a = P(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function Q(a, b, c, d) {
                        (d === void 0 ? 0 : d) || b >= a.l ? (tb(a), a.i[b] = c) : a.h[b + a.j] = c;
                    }
                    function wb(a, b, c) {
                        if (c === -1) return null;
                        a.g || (a.g = {});
                        var d = a.g[c];
                        if (d) return d;
                        var e = P(a, c, false);
                        if (e == null) return d;
                        b = new b(e);
                        return a.g[c] = b;
                    }
                    function xb(a, b, c) {
                        a.g || (a.g = {});
                        var d = a.g[c];
                        if (!d) {
                            var e = ub(a, c, false);
                            d = [];
                            for(var g = Array.isArray(e) ? !!(kb(e) & 2) : false, f = 0; f < e.length; f++)d[f] = new b(e[f]), g && mb(d[f].h);
                            g && (mb(d), Object.freeze(d));
                            a.g[c] = d;
                        }
                        return d;
                    }
                    function yb(a, b, c, d, e) {
                        var g = xb(a, d, b);
                        c = c ? c : new d();
                        a = ub(a, b);
                        e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, T(c))) : (g.push(c), a.push(T(c)));
                    }
                    O.prototype.toJSON = function() {
                        var a = T(this);
                        return qb(a, ob);
                    };
                    function T(a) {
                        if (a.g) for(var b in a.g){
                            var c = a.g[b];
                            if (Array.isArray(c)) for(var d = 0; d < c.length; d++)c[d] && T(c[d]);
                            else c && T(c);
                        }
                        return a.h;
                    }
                    O.prototype.toString = function() {
                        return T(this).toString();
                    };
                    function zb(a, b) {
                        if (a = a.o) {
                            gb(b, b.g.end());
                            for(var c = 0; c < a.length; c++)gb(b, a[c]);
                        }
                    }
                    function Ab(a) {
                        var b = a[0];
                        switch(a.length){
                            case 2:
                                var c = a[1];
                                return function(h, l, n) {
                                    return b(h, l, n, c);
                                };
                            case 3:
                                var d = a[1], e = a[2];
                                return function(h, l, n) {
                                    return b(h, l, n, d, e);
                                };
                            case 4:
                                var g = a[1], f = a[2], k = a[3];
                                return function(h, l, n) {
                                    return b(h, l, n, g, f, k);
                                };
                            default:
                                throw Error("unsupported number of parameters, expected [2-4], got " + a.length);
                        }
                    }
                    function U(a, b, c) {
                        for(; $a(b) && b.h != 4;){
                            var d = b.i, e = c[d];
                            if (e) {
                                if (Array.isArray(e) && (e = c[d] = Ab(e)), !e(b, a, d)) {
                                    d = b;
                                    e = a;
                                    var g = d.l;
                                    ab(d);
                                    bb(d, e, g);
                                }
                            } else d = b, e = a, g = d.l, ab(d), bb(d, e, g);
                        }
                        return a;
                    }
                    function Bb(a, b) {
                        var c = new fb();
                        b(a, c);
                        a = c.i + c.g.length();
                        if (a === 0) c = new Uint8Array(0);
                        else {
                            a = new Uint8Array(a);
                            for(var d = c.h, e = d.length, g = b = 0; g < e; g++){
                                var f = d[g];
                                f.length !== 0 && (a.set(f, b), b += f.length);
                            }
                            d = c.g;
                            e = d.h;
                            e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
                            c.h = [
                                a
                            ];
                            c = a;
                        }
                        return c;
                    }
                    function Cb(a, b, c) {
                        if (eb.length) {
                            var d = eb.pop();
                            a && (Ua(d.g, a), d.i = -1, d.h = -1);
                            a = d;
                        } else a = new Za(a);
                        try {
                            return c(new b(), a);
                        } finally{
                            b = a.g, b.h = null, b.m = 0, b.i = 0, b.g = 0, b.l = false, b.u = false, a.i = -1, a.h = -1, a.j = false, 100 > eb.length && eb.push(a);
                        }
                    }
                    function W(a, b, c) {
                        b = P(b, c);
                        if (b != null) {
                            Ya(a.g, 8 * c + 5);
                            a = a.g;
                            var d = b;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? K = L = 0 : (L = 0, K = 2147483648) : isNaN(d) ? (L = 0, K = 2147483647) : 34028234663852886e22 < d ? (L = 0, K = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), L = 0, K = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, L = 0, K = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = K;
                            N(a, c >>> 0 & 255);
                            N(a, c >>> 8 & 255);
                            N(a, c >>> 16 & 255);
                            N(a, c >>> 24 & 255);
                        }
                    }
                    function X(a, b, c) {
                        if (a.h !== 5) return false;
                        Q(b, c, a.g.o());
                        return true;
                    }
                    function Db(a, b, c) {
                        if (a.h !== 5 && a.h !== 2) return false;
                        b = ub(b, c);
                        a.h == 2 ? db(a, Ta.prototype.o, b) : b.push(a.g.o());
                        return true;
                    }
                    function Eb(a, b, c) {
                        if (a.h !== 0) return false;
                        Q(b, c, Va(a.g));
                        return true;
                    }
                    function Fb(a, b, c) {
                        if (a.h !== 0) return false;
                        Q(b, c, a.g.j());
                        return true;
                    }
                    function Gb(a, b, c) {
                        if (a.h !== 2) return false;
                        var d = a.g.j();
                        a = a.g;
                        var e = a.g;
                        a.g += d;
                        M(a);
                        a = a.h;
                        var g;
                        if (Da) (g = Ca) || (g = Ca = new TextDecoder("utf-8", {
                            fatal: false
                        })), g = g.decode(a.subarray(e, e + d));
                        else {
                            d = e + d;
                            for(var f = [], k = null, h, l, n; e < d;)h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((n = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | n & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = Ba(k, f), f.length = 0);
                            g = Ba(k, f);
                        }
                        Q(b, c, g);
                        return true;
                    }
                    function Hb(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        a = cb(a, new d(), e);
                        var g = g === void 0 ? false : g;
                        b.g || (b.g = {});
                        d = a ? T(a) : a;
                        b.g[c] = a;
                        Q(b, c, d, g);
                        return true;
                    }
                    function Ib(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        a = cb(a, new d(), e);
                        yb(b, c, a, d, void 0);
                        return true;
                    }
                    function Jb(a, b, c) {
                        if (a.h !== 0 && a.h !== 2) return false;
                        b = ub(b, c);
                        a.h == 2 ? db(a, Ta.prototype.j, b) : b.push(a.g.j());
                        return true;
                    }
                    function Kb(a, b, c) {
                        if (a.h !== 0) return false;
                        Q(b, c, Va(a.g));
                        return true;
                    }
                    function Y(a) {
                        O.call(this, a, -1, Lb);
                    }
                    var Mb;
                    E(Y, O);
                    Y.prototype.getRows = function() {
                        return P(this, 1);
                    };
                    Y.prototype.getCols = function() {
                        return P(this, 2);
                    };
                    Y.prototype.getPackedDataList = function() {
                        return vb(this);
                    };
                    Y.prototype.getLayout = function() {
                        return R(this, 4, 0);
                    };
                    function Nb(a, b) {
                        return U(a, b, Mb || (Mb = {
                            1: Fb,
                            2: Fb,
                            3: Db,
                            4: Kb
                        }));
                    }
                    var Lb = [
                        3
                    ];
                    function Ob(a) {
                        O.call(this, a);
                    }
                    var Pb;
                    E(Ob, O);
                    function Qb(a, b) {
                        var c = P(a, 1);
                        if (c != null && c != null) {
                            Ya(b.g, 8);
                            var d = b.g;
                            if (0 <= c) Ya(d, c);
                            else {
                                for(var e = 0; 9 > e; e++)N(d, c & 127 | 128), c >>= 7;
                                N(d, 1);
                            }
                        }
                        W(b, a, 2);
                        d = P(a, 3);
                        d != null && hb(b, 3, Ga(d));
                        d = P(a, 4);
                        d != null && hb(b, 4, Ga(d));
                        zb(a, b);
                    }
                    function Rb(a, b) {
                        return U(a, b, Pb || (Pb = {
                            1: Fb,
                            2: X,
                            3: Gb,
                            4: Gb
                        }));
                    }
                    function Sb(a) {
                        O.call(this, a, -1, Tb);
                    }
                    var Ub;
                    E(Sb, O);
                    Sb.prototype.addClassification = function(a, b) {
                        yb(this, 1, a, Ob, b);
                        return this;
                    };
                    function Vb(a, b) {
                        return U(a, b, Ub || (Ub = {
                            1: [
                                Ib,
                                Ob,
                                Rb
                            ]
                        }));
                    }
                    var Tb = [
                        1
                    ];
                    function Wb(a) {
                        O.call(this, a);
                    }
                    var Xb;
                    E(Wb, O);
                    function Yb(a, b) {
                        W(b, a, 1);
                        W(b, a, 2);
                        W(b, a, 3);
                        W(b, a, 4);
                        W(b, a, 5);
                        zb(a, b);
                    }
                    function Zb(a, b) {
                        return U(a, b, Xb || (Xb = {
                            1: X,
                            2: X,
                            3: X,
                            4: X,
                            5: X
                        }));
                    }
                    function $b(a) {
                        O.call(this, a, -1, ac);
                    }
                    var bc;
                    E($b, O);
                    function cc(a, b) {
                        return U(a, b, bc || (bc = {
                            1: [
                                Ib,
                                Wb,
                                Zb
                            ]
                        }));
                    }
                    var ac = [
                        1
                    ];
                    function dc(a) {
                        O.call(this, a);
                    }
                    var ec;
                    E(dc, O);
                    function fc(a, b) {
                        W(b, a, 1);
                        W(b, a, 2);
                        W(b, a, 3);
                        W(b, a, 4);
                        W(b, a, 5);
                        var c = P(a, 6);
                        if (c != null && c != null) {
                            Ya(b.g, 48);
                            var d = b.g, e = c;
                            c = 0 > e;
                            e = Math.abs(e);
                            var g = e >>> 0;
                            e = Math.floor((e - g) / 4294967296);
                            e >>>= 0;
                            c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
                            K = g;
                            L = e;
                            c = K;
                            for(g = L; 0 < g || 127 < c;)N(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
                            N(d, c);
                        }
                        zb(a, b);
                    }
                    function gc(a, b) {
                        return U(a, b, ec || (ec = {
                            1: X,
                            2: X,
                            3: X,
                            4: X,
                            5: X,
                            6: Eb
                        }));
                    }
                    function Z(a) {
                        O.call(this, a, -1, hc);
                    }
                    var ic;
                    E(Z, O);
                    Z.prototype.getVertexType = function() {
                        return R(this, 1, 0);
                    };
                    Z.prototype.getPrimitiveType = function() {
                        return R(this, 2, 0);
                    };
                    Z.prototype.getVertexBufferList = function() {
                        return vb(this);
                    };
                    Z.prototype.getIndexBufferList = function() {
                        return ub(this, 4);
                    };
                    function jc(a, b) {
                        return U(a, b, ic || (ic = {
                            1: Kb,
                            2: Kb,
                            3: Db,
                            4: Jb
                        }));
                    }
                    var hc = [
                        3,
                        4
                    ];
                    function kc(a) {
                        O.call(this, a);
                    }
                    var lc;
                    E(kc, O);
                    kc.prototype.getMesh = function() {
                        return wb(this, Z, 1);
                    };
                    kc.prototype.getPoseTransformMatrix = function() {
                        return wb(this, Y, 2);
                    };
                    function mc(a, b) {
                        return U(a, b, lc || (lc = {
                            1: [
                                Hb,
                                Z,
                                jc
                            ],
                            2: [
                                Hb,
                                Y,
                                Nb
                            ]
                        }));
                    }
                    var nc = [
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            78,
                            95
                        ],
                        [
                            95,
                            88
                        ],
                        [
                            88,
                            178
                        ],
                        [
                            178,
                            87
                        ],
                        [
                            87,
                            14
                        ],
                        [
                            14,
                            317
                        ],
                        [
                            317,
                            402
                        ],
                        [
                            402,
                            318
                        ],
                        [
                            318,
                            324
                        ],
                        [
                            324,
                            308
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            308
                        ]
                    ], oc = [
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            263,
                            466
                        ],
                        [
                            466,
                            388
                        ],
                        [
                            388,
                            387
                        ],
                        [
                            387,
                            386
                        ],
                        [
                            386,
                            385
                        ],
                        [
                            385,
                            384
                        ],
                        [
                            384,
                            398
                        ],
                        [
                            398,
                            362
                        ]
                    ], pc = [
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            336
                        ]
                    ], qc = [
                        [
                            33,
                            7
                        ],
                        [
                            7,
                            163
                        ],
                        [
                            163,
                            144
                        ],
                        [
                            144,
                            145
                        ],
                        [
                            145,
                            153
                        ],
                        [
                            153,
                            154
                        ],
                        [
                            154,
                            155
                        ],
                        [
                            155,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            133
                        ]
                    ], rc = [
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            107
                        ]
                    ], sc = [
                        [
                            10,
                            338
                        ],
                        [
                            338,
                            297
                        ],
                        [
                            297,
                            332
                        ],
                        [
                            332,
                            284
                        ],
                        [
                            284,
                            251
                        ],
                        [
                            251,
                            389
                        ],
                        [
                            389,
                            356
                        ],
                        [
                            356,
                            454
                        ],
                        [
                            454,
                            323
                        ],
                        [
                            323,
                            361
                        ],
                        [
                            361,
                            288
                        ],
                        [
                            288,
                            397
                        ],
                        [
                            397,
                            365
                        ],
                        [
                            365,
                            379
                        ],
                        [
                            379,
                            378
                        ],
                        [
                            378,
                            400
                        ],
                        [
                            400,
                            377
                        ],
                        [
                            377,
                            152
                        ],
                        [
                            152,
                            148
                        ],
                        [
                            148,
                            176
                        ],
                        [
                            176,
                            149
                        ],
                        [
                            149,
                            150
                        ],
                        [
                            150,
                            136
                        ],
                        [
                            136,
                            172
                        ],
                        [
                            172,
                            58
                        ],
                        [
                            58,
                            132
                        ],
                        [
                            132,
                            93
                        ],
                        [
                            93,
                            234
                        ],
                        [
                            234,
                            127
                        ],
                        [
                            127,
                            162
                        ],
                        [
                            162,
                            21
                        ],
                        [
                            21,
                            54
                        ],
                        [
                            54,
                            103
                        ],
                        [
                            103,
                            67
                        ],
                        [
                            67,
                            109
                        ],
                        [
                            109,
                            10
                        ]
                    ], tc = [].concat(D(nc), D(oc), D(pc), D(qc), D(rc), D(sc));
                    function uc(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function vc(a) {
                        return xb(a, Ob, 1).map(function(b) {
                            return {
                                index: R(b, 1, 0),
                                score: S(b, 2),
                                label: P(b, 3) != null ? R(b, 3, "") : void 0,
                                displayName: P(b, 4) != null ? R(b, 4, "") : void 0
                            };
                        });
                    }
                    function wc(a) {
                        return {
                            x: S(a, 1),
                            y: S(a, 2),
                            z: S(a, 3),
                            visibility: P(a, 4) != null ? S(a, 4) : void 0
                        };
                    }
                    function xc(a) {
                        return xb(Cb(a, $b, cc), Wb, 1).map(wc);
                    }
                    function yc(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function zc(a, b, c) {
                        Ac(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function Ac(a, b) {
                        var c = a.g;
                        if (a.m === void 0) {
                            var d = uc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = uc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.m = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                I: c.getAttribLocation(d, "aVertex"),
                                H: c.getAttribLocation(d, "aTex"),
                                ca: e
                            };
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.I);
                            c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.o = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.o);
                            c.enableVertexAttribArray(a.j.H);
                            c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.m);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, a.o);
                        c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.I);
                        c.disableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function Bc(a) {
                        this.g = a;
                    }
                    var Cc = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function Dc(a, b) {
                        return b + a;
                    }
                    function Ec(a, b) {
                        window[a] = b;
                    }
                    function Fc(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function Gc() {
                        return H(function(a) {
                            switch(a.g){
                                case 1:
                                    return a.m = 2, F(a, WebAssembly.instantiate(Cc), 4);
                                case 4:
                                    a.g = 3;
                                    a.m = 0;
                                    break;
                                case 2:
                                    return a.m = 0, a.j = null, a.return(false);
                                case 3:
                                    return a.return(true);
                            }
                        });
                    }
                    function Hc(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.F = {};
                        this.m = {};
                        this.s = {};
                        this.G = this.o = this.R = true;
                        this.C = Promise.resolve();
                        this.P = "";
                        this.B = {};
                        this.locateFile = a && a.locateFile || Dc;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.S = b;
                        if (a.options) {
                            b = B(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    x = Hc.prototype;
                    x.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Ic(a) {
                        var b, c, d, e, g, f, k, h, l, n, r;
                        return H(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!a.R) return p.return();
                                    b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
                                    return F(p, Gc(), 2);
                                case 2:
                                    c = p.h;
                                    if (typeof window === "object") return Ec("createMediapipeSolutionsWasm", {
                                        locateFile: a.locateFile
                                    }), Ec("createMediapipeSolutionsPackedAssets", {
                                        locateFile: a.locateFile
                                    }), f = b.filter(function(m) {
                                        return m.data !== void 0;
                                    }), k = b.filter(function(m) {
                                        return m.data === void 0;
                                    }), h = Promise.all(f.map(function(m) {
                                        var q = Jc(a, m.url);
                                        if (m.path !== void 0) {
                                            var t = m.path;
                                            q = q.then(function(w) {
                                                a.overrideFile(t, w);
                                                return Promise.resolve(w);
                                            });
                                        }
                                        return q;
                                    })), l = Promise.all(k.map(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c ? Fc(a.locateFile(m.url, a.S)) : Promise.resolve();
                                    })).then(function() {
                                        var m, q, t;
                                        return H(function(w) {
                                            if (w.g == 1) return m = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, m(q), 2);
                                            t.h = w.h;
                                            w.g = 0;
                                        });
                                    }), n = function() {
                                        return H(function(m) {
                                            a.g.graph && a.g.graph.url ? m = F(m, Jc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                                            return m;
                                        });
                                    }(), F(p, Promise.all([
                                        l,
                                        h,
                                        n
                                    ]), 7);
                                    if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                    d = b.filter(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c;
                                    }).map(function(m) {
                                        return a.locateFile(m.url, a.S);
                                    });
                                    importScripts.apply(null, D(d));
                                    e = a;
                                    return F(p, createMediapipeSolutionsWasm(Module), 6);
                                case 6:
                                    e.h = p.h;
                                    a.l = new OffscreenCanvas(1, 1);
                                    a.h.canvas = a.l;
                                    g = a.h.GL.createContext(a.l, {
                                        antialias: false,
                                        alpha: false,
                                        aa: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                    });
                                    a.h.GL.makeContextCurrent(g);
                                    p.g = 4;
                                    break;
                                case 7:
                                    a.l = document.createElement("canvas");
                                    r = a.l.getContext("webgl2", {});
                                    if (!r && (r = a.l.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                                    a.D = r;
                                    a.h.canvas = a.l;
                                    a.h.createContext(a.l, true, true, {});
                                case 4:
                                    a.i = new a.h.SolutionWasm(), a.R = false, p.g = 0;
                            }
                        });
                    }
                    function Kc(a) {
                        var b, c, d, e, g, f, k, h;
                        return H(function(l) {
                            if (l.g == 1) {
                                if (a.g.graph && a.g.graph.url && a.P === a.g.graph.url) return l.return();
                                a.o = true;
                                if (!a.g.graph || !a.g.graph.url) {
                                    l.g = 2;
                                    return;
                                }
                                a.P = a.g.graph.url;
                                return F(l, Jc(a, a.g.graph.url), 3);
                            }
                            l.g != 2 && (b = l.h, a.i.loadGraph(b));
                            c = B(Object.keys(a.B));
                            for(d = c.next(); !d.done; d = c.next())e = d.value, a.i.overrideFile(e, a.B[e]);
                            a.B = {};
                            if (a.g.listeners) for(g = B(a.g.listeners), f = g.next(); !f.done; f = g.next())k = f.value, Lc(a, k);
                            h = a.j;
                            a.j = {};
                            a.setOptions(h);
                            l.g = 0;
                        });
                    }
                    x.reset = function() {
                        var a = this;
                        return H(function(b) {
                            a.i && (a.i.reset(), a.m = {}, a.s = {});
                            b.g = 0;
                        });
                    };
                    x.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = B(Object.keys(a)), k = f.next(); !k.done; g = {
                                K: g.K,
                                L: g.L
                            }, k = f.next()){
                                var h = k.value;
                                h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.K = k.onChange, g.L = a[h], d.push(function(l) {
                                    return function() {
                                        var n;
                                        return H(function(r) {
                                            if (r.g == 1) return F(r, l.K(l.L), 2);
                                            n = r.h;
                                            n === true && (c.o = true);
                                            r.g = 0;
                                        });
                                    };
                                }(g))), k.graphOptionXref && (h = {
                                    valueNumber: k.type === 1 ? a[h] : 0,
                                    valueBoolean: k.type === 0 ? a[h] : false,
                                    valueString: k.type === 2 ? a[h] : ""
                                }, k = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), k.graphOptionXref), h), e.push(k))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.v = (this.v === void 0 ? [] : this.v).concat(d);
                        }
                    };
                    function Mc(a) {
                        var b, c, d, e, g, f, k;
                        return H(function(h) {
                            switch(h.g){
                                case 1:
                                    if (!a.o) return h.return();
                                    if (!a.v) {
                                        h.g = 2;
                                        break;
                                    }
                                    b = B(a.v);
                                    c = b.next();
                                case 3:
                                    if (c.done) {
                                        h.g = 5;
                                        break;
                                    }
                                    d = c.value;
                                    return F(h, d(), 4);
                                case 4:
                                    c = b.next();
                                    h.g = 3;
                                    break;
                                case 5:
                                    a.v = void 0;
                                case 2:
                                    if (a.A) {
                                        e = new a.h.GraphOptionChangeRequestList();
                                        g = B(a.A);
                                        for(f = g.next(); !f.done; f = g.next())k = f.value, e.push_back(k);
                                        a.i.changeOptions(e);
                                        e.delete();
                                        a.A = void 0;
                                    }
                                    a.o = false;
                                    h.g = 0;
                            }
                        });
                    }
                    x.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return b.g == 1 ? F(b, Ic(a), 2) : b.g != 3 ? F(b, Kc(a), 3) : F(b, Mc(a), 0);
                        });
                    };
                    function Jc(a, b) {
                        var c, d;
                        return H(function(e) {
                            if (b in a.F) return e.return(a.F[b]);
                            c = a.locateFile(b, "");
                            d = fetch(c).then(function(g) {
                                return g.arrayBuffer();
                            });
                            a.F[b] = d;
                            return e.return(d);
                        });
                    }
                    x.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
                    };
                    x.clearOverriddenFiles = function() {
                        this.B = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    x.send = function(a, b) {
                        var c = this, d, e, g, f, k, h, l, n, r;
                        return H(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!c.g.inputs) return p.return();
                                    d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                    return F(p, c.C, 2);
                                case 2:
                                    return F(p, c.initialize(), 3);
                                case 3:
                                    e = new c.h.PacketDataList();
                                    g = B(Object.keys(a));
                                    for(f = g.next(); !f.done; f = g.next())if (k = f.value, h = c.g.inputs[k]) {
                                        a: {
                                            var m = a[k];
                                            switch(h.type){
                                                case "video":
                                                    var q = c.m[h.stream];
                                                    q || (q = new yc(c.h, c.D), c.m[h.stream] = q);
                                                    q.l === 0 && (q.l = q.h.createTexture());
                                                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                                                        var t = m.videoWidth;
                                                        var w = m.videoHeight;
                                                    } else typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (t = m.naturalWidth, w = m.naturalHeight) : (t = m.width, w = m.height);
                                                    w = {
                                                        glName: q.l,
                                                        width: t,
                                                        height: w
                                                    };
                                                    t = q.g;
                                                    t.canvas.width = w.width;
                                                    t.canvas.height = w.height;
                                                    t.activeTexture(t.TEXTURE0);
                                                    q.h.bindTexture2d(q.l);
                                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, m);
                                                    q.h.bindTexture2d(0);
                                                    q = w;
                                                    break a;
                                                case "detections":
                                                    q = c.m[h.stream];
                                                    q || (q = new Bc(c.h), c.m[h.stream] = q);
                                                    q.data || (q.data = new q.g.DetectionListData());
                                                    q.data.reset(m.length);
                                                    for(w = 0; w < m.length; ++w){
                                                        t = m[w];
                                                        var v = q.data, C = v.setBoundingBox, J = w;
                                                        var G = t.T;
                                                        var u = new dc();
                                                        Q(u, 1, G.X);
                                                        Q(u, 2, G.Y);
                                                        Q(u, 3, G.height);
                                                        Q(u, 4, G.width);
                                                        Q(u, 5, G.rotation);
                                                        Q(u, 6, G.W);
                                                        G = Bb(u, fc);
                                                        C.call(v, J, G);
                                                        if (t.O) for(v = 0; v < t.O.length; ++v){
                                                            u = t.O[v];
                                                            var A = u.visibility ? true : false;
                                                            C = q.data;
                                                            J = C.addNormalizedLandmark;
                                                            G = w;
                                                            u = Object.assign(Object.assign({}, u), {
                                                                visibility: A ? u.visibility : 0
                                                            });
                                                            A = new Wb();
                                                            Q(A, 1, u.x);
                                                            Q(A, 2, u.y);
                                                            Q(A, 3, u.z);
                                                            u.visibility && Q(A, 4, u.visibility);
                                                            u = Bb(A, Yb);
                                                            J.call(C, G, u);
                                                        }
                                                        if (t.M) for(v = 0; v < t.M.length; ++v)C = q.data, J = C.addClassification, G = w, u = t.M[v], A = new Ob(), Q(A, 2, u.score), u.index && Q(A, 1, u.index), u.label && Q(A, 3, u.label), u.displayName && Q(A, 4, u.displayName), u = Bb(A, Qb), J.call(C, G, u);
                                                    }
                                                    q = q.data;
                                                    break a;
                                                default:
                                                    q = {};
                                            }
                                        }
                                        l = q;
                                        n = h.stream;
                                        switch(h.type){
                                            case "video":
                                                e.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                    stream: n,
                                                    timestamp: d
                                                }));
                                                break;
                                            case "detections":
                                                r = l;
                                                r.stream = n;
                                                r.timestamp = d;
                                                e.pushDetectionList(r);
                                                break;
                                            default:
                                                throw Error("Unknown input config type: '" + h.type + "'");
                                        }
                                    }
                                    c.i.send(e);
                                    return F(p, c.C, 4);
                                case 4:
                                    e.delete(), p.g = 0;
                            }
                        });
                    };
                    function Nc(a, b, c) {
                        var d, e, g, f, k, h, l, n, r, p, m, q, t, w;
                        return H(function(v) {
                            switch(v.g){
                                case 1:
                                    if (!c) return v.return(b);
                                    d = {};
                                    e = 0;
                                    g = B(Object.keys(c));
                                    for(f = g.next(); !f.done; f = g.next())k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
                                    1 < e && (a.G = false);
                                    l = B(Object.keys(c));
                                    f = l.next();
                                case 2:
                                    if (f.done) {
                                        v.g = 4;
                                        break;
                                    }
                                    n = f.value;
                                    r = c[n];
                                    if (typeof r === "string") return t = d, w = n, F(v, Oc(a, n, b[r]), 14);
                                    p = b[r.stream];
                                    if (r.type === "detection_list") {
                                        if (p) {
                                            var C = p.getRectList();
                                            for(var J = p.getLandmarksList(), G = p.getClassificationsList(), u = [], A = 0; A < C.size(); ++A){
                                                var V = Cb(C.get(A), dc, gc);
                                                V = {
                                                    T: {
                                                        X: S(V, 1),
                                                        Y: S(V, 2),
                                                        height: S(V, 3),
                                                        width: S(V, 4),
                                                        rotation: S(V, 5, 0),
                                                        W: R(V, 6, 0)
                                                    },
                                                    O: xc(J.get(A)),
                                                    M: vc(Cb(G.get(A), Sb, Vb))
                                                };
                                                u.push(V);
                                            }
                                            C = u;
                                        } else C = [];
                                        d[n] = C;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto_list") {
                                        if (p) {
                                            C = Array(p.size());
                                            for(J = 0; J < p.size(); J++)C[J] = p.get(J);
                                            p.delete();
                                        } else C = [];
                                        d[n] = C;
                                        v.g = 7;
                                        break;
                                    }
                                    if (p === void 0) {
                                        v.g = 3;
                                        break;
                                    }
                                    if (r.type === "float_list") {
                                        d[n] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto") {
                                        d[n] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type !== "texture") throw Error("Unknown output config type: '" + r.type + "'");
                                    m = a.s[n];
                                    m || (m = new yc(a.h, a.D), a.s[n] = m);
                                    return F(v, zc(m, p, a.G), 13);
                                case 13:
                                    q = v.h, d[n] = q;
                                case 7:
                                    r.transform && d[n] && (d[n] = r.transform(d[n]));
                                    v.g = 3;
                                    break;
                                case 14:
                                    t[w] = v.h;
                                case 3:
                                    f = l.next();
                                    v.g = 2;
                                    break;
                                case 4:
                                    return v.return(d);
                            }
                        });
                    }
                    function Oc(a, b, c) {
                        var d;
                        return H(function(e) {
                            return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new yc(a.h, a.D), a.s[b] = d), e.return(zc(d, c, a.G))) : e.return(void 0);
                        });
                    }
                    function Lc(a, b) {
                        for(var c = b.name || "$", d = [].concat(D(b.wants)), e = new a.h.StringList(), g = B(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(k) {
                                for(var h = {}, l = 0; l < b.wants.length; ++l)h[d[l]] = k.get(l);
                                var n = a.listeners[c];
                                n && (a.C = Nc(a, h, b.outs).then(function(r) {
                                    r = n(r);
                                    for(var p = 0; p < b.wants.length; ++p){
                                        var m = h[d[p]];
                                        typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
                                    }
                                    r && (a.C = r);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    x.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    I("Solution", Hc);
                    I("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        Z: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function Pc(a) {
                        return a.map(Qc);
                    }
                    function Qc(a) {
                        a = Cb(a, kc, mc);
                        var b = a.getMesh();
                        if (!b) return a;
                        var c = new Float32Array(b.getVertexBufferList());
                        b.getVertexBufferList = function() {
                            return c;
                        };
                        var d = new Uint32Array(b.getIndexBufferList());
                        b.getIndexBufferList = function() {
                            return d;
                        };
                        return a;
                    }
                    function Rc(a) {
                        var b = this;
                        a = a || {};
                        this.g = new Hc({
                            locateFile: a.locateFile,
                            files: [
                                {
                                    url: "holistic_solution_packed_assets_loader.js"
                                },
                                {
                                    simd: false,
                                    url: "holistic_solution_wasm_bin.js"
                                },
                                {
                                    simd: true,
                                    url: "holistic_solution_simd_wasm_bin.js"
                                }
                            ],
                            graph: {
                                url: "holistic.binarypb"
                            },
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            listeners: [
                                {
                                    wants: "left_hand_landmarks right_hand_landmarks face_landmarks pose_landmarks world_landmarks segmentation_mask image_transformed multi_face_geometry".split(" "),
                                    outs: {
                                        image: {
                                            type: "texture",
                                            stream: "image_transformed"
                                        },
                                        leftHandLandmarks: {
                                            type: "proto",
                                            stream: "left_hand_landmarks",
                                            transform: xc
                                        },
                                        rightHandLandmarks: {
                                            type: "proto",
                                            stream: "right_hand_landmarks",
                                            transform: xc
                                        },
                                        faceLandmarks: {
                                            type: "proto",
                                            stream: "face_landmarks",
                                            transform: xc
                                        },
                                        poseLandmarks: {
                                            type: "proto",
                                            stream: "pose_landmarks",
                                            transform: xc
                                        },
                                        ea: {
                                            type: "proto",
                                            stream: "world_landmarks",
                                            transform: xc
                                        },
                                        segmentationMask: {
                                            type: "texture",
                                            stream: "segmentation_mask"
                                        },
                                        multiFaceGeometry: {
                                            type: "proto_list",
                                            stream: "multi_face_geometry",
                                            transform: Pc
                                        }
                                    }
                                }
                            ],
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                enableFaceGeometry: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorName: "EnableFaceGeometryConstant",
                                        calculatorType: "ConstantSidePacketCalculator",
                                        fieldName: "bool_value"
                                    }
                                },
                                selfieMode: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                modelComplexity: {
                                    type: 1,
                                    default: 1,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorModelComplexity",
                                        fieldName: "int_value"
                                    },
                                    onChange: function(c) {
                                        var d, e, g, f;
                                        return H(function(k) {
                                            if (k.g == 1) {
                                                d = "";
                                                switch(c){
                                                    case 1:
                                                        d = "pose_landmark_full.tflite";
                                                        break;
                                                    case 2:
                                                        d = "pose_landmark_heavy.tflite";
                                                        break;
                                                    default:
                                                        d = "pose_landmark_lite.tflite";
                                                }
                                                e = "third_party/mediapipe/modules/pose_landmark/" + d;
                                                g = b.g.locateFile(d, "");
                                                return F(k, fetch(g), 3);
                                            }
                                            if (k.g != 2) return F(k, k.h.arrayBuffer(), 2);
                                            f = k.h;
                                            b.g.overrideFile(e, f);
                                            return F(k, b.g.reset(), 0);
                                        });
                                    }
                                },
                                smoothLandmarks: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks",
                                        fieldName: "bool_value"
                                    }
                                },
                                enableSegmentation: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorEnableSegmentation",
                                        fieldName: "bool_value"
                                    }
                                },
                                smoothSegmentation: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation",
                                        fieldName: "bool_value"
                                    }
                                },
                                refineFaceLandmarks: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorRefineFaceLandmarks",
                                        fieldName: "bool_value"
                                    }
                                },
                                minDetectionConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "TensorsToDetectionsCalculator",
                                        calculatorName: "holisticlandmarkgpu__poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
                                        fieldName: "min_score_thresh"
                                    }
                                },
                                minTrackingConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ThresholdingCalculator",
                                        calculatorName: "holisticlandmarkgpu__poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",
                                        fieldName: "threshold"
                                    }
                                },
                                cameraNear: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                        fieldName: "near"
                                    }
                                },
                                cameraFar: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                        fieldName: "far"
                                    }
                                },
                                cameraVerticalFovDegrees: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                        fieldName: "vertical_fov_degrees"
                                    }
                                }
                            }
                        });
                    }
                    x = Rc.prototype;
                    x.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    x.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    x.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return F(b, a.g.initialize(), 0);
                        });
                    };
                    x.reset = function() {
                        this.g.reset();
                    };
                    x.send = function(a) {
                        var b = this;
                        return H(function(c) {
                            return F(c, b.g.send(a), 0);
                        });
                    };
                    x.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    I("Holistic", Rc);
                    I("FACE_GEOMETRY", {
                        Layout: {
                            COLUMN_MAJOR: 0,
                            ROW_MAJOR: 1,
                            0: "COLUMN_MAJOR",
                            1: "ROW_MAJOR"
                        },
                        PrimitiveType: {
                            TRIANGLE: 0,
                            0: "TRIANGLE"
                        },
                        VertexType: {
                            VERTEX_PT: 0,
                            0: "VERTEX_PT"
                        },
                        DEFAULT_CAMERA_PARAMS: {
                            verticalFovDegrees: 63,
                            near: 1,
                            far: 1e4
                        }
                    });
                    I("FACEMESH_LIPS", nc);
                    I("FACEMESH_LEFT_EYE", oc);
                    I("FACEMESH_LEFT_EYEBROW", pc);
                    I("FACEMESH_LEFT_IRIS", [
                        [
                            474,
                            475
                        ],
                        [
                            475,
                            476
                        ],
                        [
                            476,
                            477
                        ],
                        [
                            477,
                            474
                        ]
                    ]);
                    I("FACEMESH_RIGHT_EYE", qc);
                    I("FACEMESH_RIGHT_EYEBROW", rc);
                    I("FACEMESH_RIGHT_IRIS", [
                        [
                            469,
                            470
                        ],
                        [
                            470,
                            471
                        ],
                        [
                            471,
                            472
                        ],
                        [
                            472,
                            469
                        ]
                    ]);
                    I("FACEMESH_FACE_OVAL", sc);
                    I("FACEMESH_CONTOURS", tc);
                    I("FACEMESH_TESSELATION", [
                        [
                            127,
                            34
                        ],
                        [
                            34,
                            139
                        ],
                        [
                            139,
                            127
                        ],
                        [
                            11,
                            0
                        ],
                        [
                            0,
                            37
                        ],
                        [
                            37,
                            11
                        ],
                        [
                            232,
                            231
                        ],
                        [
                            231,
                            120
                        ],
                        [
                            120,
                            232
                        ],
                        [
                            72,
                            37
                        ],
                        [
                            37,
                            39
                        ],
                        [
                            39,
                            72
                        ],
                        [
                            128,
                            121
                        ],
                        [
                            121,
                            47
                        ],
                        [
                            47,
                            128
                        ],
                        [
                            232,
                            121
                        ],
                        [
                            121,
                            128
                        ],
                        [
                            128,
                            232
                        ],
                        [
                            104,
                            69
                        ],
                        [
                            69,
                            67
                        ],
                        [
                            67,
                            104
                        ],
                        [
                            175,
                            171
                        ],
                        [
                            171,
                            148
                        ],
                        [
                            148,
                            175
                        ],
                        [
                            118,
                            50
                        ],
                        [
                            50,
                            101
                        ],
                        [
                            101,
                            118
                        ],
                        [
                            73,
                            39
                        ],
                        [
                            39,
                            40
                        ],
                        [
                            40,
                            73
                        ],
                        [
                            9,
                            151
                        ],
                        [
                            151,
                            108
                        ],
                        [
                            108,
                            9
                        ],
                        [
                            48,
                            115
                        ],
                        [
                            115,
                            131
                        ],
                        [
                            131,
                            48
                        ],
                        [
                            194,
                            204
                        ],
                        [
                            204,
                            211
                        ],
                        [
                            211,
                            194
                        ],
                        [
                            74,
                            40
                        ],
                        [
                            40,
                            185
                        ],
                        [
                            185,
                            74
                        ],
                        [
                            80,
                            42
                        ],
                        [
                            42,
                            183
                        ],
                        [
                            183,
                            80
                        ],
                        [
                            40,
                            92
                        ],
                        [
                            92,
                            186
                        ],
                        [
                            186,
                            40
                        ],
                        [
                            230,
                            229
                        ],
                        [
                            229,
                            118
                        ],
                        [
                            118,
                            230
                        ],
                        [
                            202,
                            212
                        ],
                        [
                            212,
                            214
                        ],
                        [
                            214,
                            202
                        ],
                        [
                            83,
                            18
                        ],
                        [
                            18,
                            17
                        ],
                        [
                            17,
                            83
                        ],
                        [
                            76,
                            61
                        ],
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            76
                        ],
                        [
                            160,
                            29
                        ],
                        [
                            29,
                            30
                        ],
                        [
                            30,
                            160
                        ],
                        [
                            56,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            56
                        ],
                        [
                            106,
                            204
                        ],
                        [
                            204,
                            194
                        ],
                        [
                            194,
                            106
                        ],
                        [
                            135,
                            214
                        ],
                        [
                            214,
                            192
                        ],
                        [
                            192,
                            135
                        ],
                        [
                            203,
                            165
                        ],
                        [
                            165,
                            98
                        ],
                        [
                            98,
                            203
                        ],
                        [
                            21,
                            71
                        ],
                        [
                            71,
                            68
                        ],
                        [
                            68,
                            21
                        ],
                        [
                            51,
                            45
                        ],
                        [
                            45,
                            4
                        ],
                        [
                            4,
                            51
                        ],
                        [
                            144,
                            24
                        ],
                        [
                            24,
                            23
                        ],
                        [
                            23,
                            144
                        ],
                        [
                            77,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            77
                        ],
                        [
                            205,
                            50
                        ],
                        [
                            50,
                            187
                        ],
                        [
                            187,
                            205
                        ],
                        [
                            201,
                            200
                        ],
                        [
                            200,
                            18
                        ],
                        [
                            18,
                            201
                        ],
                        [
                            91,
                            106
                        ],
                        [
                            106,
                            182
                        ],
                        [
                            182,
                            91
                        ],
                        [
                            90,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            90
                        ],
                        [
                            85,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            85
                        ],
                        [
                            206,
                            203
                        ],
                        [
                            203,
                            36
                        ],
                        [
                            36,
                            206
                        ],
                        [
                            148,
                            171
                        ],
                        [
                            171,
                            140
                        ],
                        [
                            140,
                            148
                        ],
                        [
                            92,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            92
                        ],
                        [
                            193,
                            189
                        ],
                        [
                            189,
                            244
                        ],
                        [
                            244,
                            193
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            28
                        ],
                        [
                            28,
                            159
                        ],
                        [
                            247,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            247
                        ],
                        [
                            236,
                            3
                        ],
                        [
                            3,
                            196
                        ],
                        [
                            196,
                            236
                        ],
                        [
                            54,
                            68
                        ],
                        [
                            68,
                            104
                        ],
                        [
                            104,
                            54
                        ],
                        [
                            193,
                            168
                        ],
                        [
                            168,
                            8
                        ],
                        [
                            8,
                            193
                        ],
                        [
                            117,
                            228
                        ],
                        [
                            228,
                            31
                        ],
                        [
                            31,
                            117
                        ],
                        [
                            189,
                            193
                        ],
                        [
                            193,
                            55
                        ],
                        [
                            55,
                            189
                        ],
                        [
                            98,
                            97
                        ],
                        [
                            97,
                            99
                        ],
                        [
                            99,
                            98
                        ],
                        [
                            126,
                            47
                        ],
                        [
                            47,
                            100
                        ],
                        [
                            100,
                            126
                        ],
                        [
                            166,
                            79
                        ],
                        [
                            79,
                            218
                        ],
                        [
                            218,
                            166
                        ],
                        [
                            155,
                            154
                        ],
                        [
                            154,
                            26
                        ],
                        [
                            26,
                            155
                        ],
                        [
                            209,
                            49
                        ],
                        [
                            49,
                            131
                        ],
                        [
                            131,
                            209
                        ],
                        [
                            135,
                            136
                        ],
                        [
                            136,
                            150
                        ],
                        [
                            150,
                            135
                        ],
                        [
                            47,
                            126
                        ],
                        [
                            126,
                            217
                        ],
                        [
                            217,
                            47
                        ],
                        [
                            223,
                            52
                        ],
                        [
                            52,
                            53
                        ],
                        [
                            53,
                            223
                        ],
                        [
                            45,
                            51
                        ],
                        [
                            51,
                            134
                        ],
                        [
                            134,
                            45
                        ],
                        [
                            211,
                            170
                        ],
                        [
                            170,
                            140
                        ],
                        [
                            140,
                            211
                        ],
                        [
                            67,
                            69
                        ],
                        [
                            69,
                            108
                        ],
                        [
                            108,
                            67
                        ],
                        [
                            43,
                            106
                        ],
                        [
                            106,
                            91
                        ],
                        [
                            91,
                            43
                        ],
                        [
                            230,
                            119
                        ],
                        [
                            119,
                            120
                        ],
                        [
                            120,
                            230
                        ],
                        [
                            226,
                            130
                        ],
                        [
                            130,
                            247
                        ],
                        [
                            247,
                            226
                        ],
                        [
                            63,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            63
                        ],
                        [
                            238,
                            20
                        ],
                        [
                            20,
                            242
                        ],
                        [
                            242,
                            238
                        ],
                        [
                            46,
                            70
                        ],
                        [
                            70,
                            156
                        ],
                        [
                            156,
                            46
                        ],
                        [
                            78,
                            62
                        ],
                        [
                            62,
                            96
                        ],
                        [
                            96,
                            78
                        ],
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            63
                        ],
                        [
                            63,
                            46
                        ],
                        [
                            143,
                            34
                        ],
                        [
                            34,
                            227
                        ],
                        [
                            227,
                            143
                        ],
                        [
                            123,
                            117
                        ],
                        [
                            117,
                            111
                        ],
                        [
                            111,
                            123
                        ],
                        [
                            44,
                            125
                        ],
                        [
                            125,
                            19
                        ],
                        [
                            19,
                            44
                        ],
                        [
                            236,
                            134
                        ],
                        [
                            134,
                            51
                        ],
                        [
                            51,
                            236
                        ],
                        [
                            216,
                            206
                        ],
                        [
                            206,
                            205
                        ],
                        [
                            205,
                            216
                        ],
                        [
                            154,
                            153
                        ],
                        [
                            153,
                            22
                        ],
                        [
                            22,
                            154
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            167
                        ],
                        [
                            167,
                            39
                        ],
                        [
                            200,
                            201
                        ],
                        [
                            201,
                            208
                        ],
                        [
                            208,
                            200
                        ],
                        [
                            36,
                            142
                        ],
                        [
                            142,
                            100
                        ],
                        [
                            100,
                            36
                        ],
                        [
                            57,
                            212
                        ],
                        [
                            212,
                            202
                        ],
                        [
                            202,
                            57
                        ],
                        [
                            20,
                            60
                        ],
                        [
                            60,
                            99
                        ],
                        [
                            99,
                            20
                        ],
                        [
                            28,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            28
                        ],
                        [
                            35,
                            226
                        ],
                        [
                            226,
                            113
                        ],
                        [
                            113,
                            35
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            27
                        ],
                        [
                            27,
                            160
                        ],
                        [
                            204,
                            202
                        ],
                        [
                            202,
                            210
                        ],
                        [
                            210,
                            204
                        ],
                        [
                            113,
                            225
                        ],
                        [
                            225,
                            46
                        ],
                        [
                            46,
                            113
                        ],
                        [
                            43,
                            202
                        ],
                        [
                            202,
                            204
                        ],
                        [
                            204,
                            43
                        ],
                        [
                            62,
                            76
                        ],
                        [
                            76,
                            77
                        ],
                        [
                            77,
                            62
                        ],
                        [
                            137,
                            123
                        ],
                        [
                            123,
                            116
                        ],
                        [
                            116,
                            137
                        ],
                        [
                            41,
                            38
                        ],
                        [
                            38,
                            72
                        ],
                        [
                            72,
                            41
                        ],
                        [
                            203,
                            129
                        ],
                        [
                            129,
                            142
                        ],
                        [
                            142,
                            203
                        ],
                        [
                            64,
                            98
                        ],
                        [
                            98,
                            240
                        ],
                        [
                            240,
                            64
                        ],
                        [
                            49,
                            102
                        ],
                        [
                            102,
                            64
                        ],
                        [
                            64,
                            49
                        ],
                        [
                            41,
                            73
                        ],
                        [
                            73,
                            74
                        ],
                        [
                            74,
                            41
                        ],
                        [
                            212,
                            216
                        ],
                        [
                            216,
                            207
                        ],
                        [
                            207,
                            212
                        ],
                        [
                            42,
                            74
                        ],
                        [
                            74,
                            184
                        ],
                        [
                            184,
                            42
                        ],
                        [
                            169,
                            170
                        ],
                        [
                            170,
                            211
                        ],
                        [
                            211,
                            169
                        ],
                        [
                            170,
                            149
                        ],
                        [
                            149,
                            176
                        ],
                        [
                            176,
                            170
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            69
                        ],
                        [
                            69,
                            105
                        ],
                        [
                            122,
                            6
                        ],
                        [
                            6,
                            168
                        ],
                        [
                            168,
                            122
                        ],
                        [
                            123,
                            147
                        ],
                        [
                            147,
                            187
                        ],
                        [
                            187,
                            123
                        ],
                        [
                            96,
                            77
                        ],
                        [
                            77,
                            90
                        ],
                        [
                            90,
                            96
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            55,
                            107
                        ],
                        [
                            107,
                            65
                        ],
                        [
                            89,
                            90
                        ],
                        [
                            90,
                            180
                        ],
                        [
                            180,
                            89
                        ],
                        [
                            101,
                            100
                        ],
                        [
                            100,
                            120
                        ],
                        [
                            120,
                            101
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            104
                        ],
                        [
                            104,
                            63
                        ],
                        [
                            93,
                            137
                        ],
                        [
                            137,
                            227
                        ],
                        [
                            227,
                            93
                        ],
                        [
                            15,
                            86
                        ],
                        [
                            86,
                            85
                        ],
                        [
                            85,
                            15
                        ],
                        [
                            129,
                            102
                        ],
                        [
                            102,
                            49
                        ],
                        [
                            49,
                            129
                        ],
                        [
                            14,
                            87
                        ],
                        [
                            87,
                            86
                        ],
                        [
                            86,
                            14
                        ],
                        [
                            55,
                            8
                        ],
                        [
                            8,
                            9
                        ],
                        [
                            9,
                            55
                        ],
                        [
                            100,
                            47
                        ],
                        [
                            47,
                            121
                        ],
                        [
                            121,
                            100
                        ],
                        [
                            145,
                            23
                        ],
                        [
                            23,
                            22
                        ],
                        [
                            22,
                            145
                        ],
                        [
                            88,
                            89
                        ],
                        [
                            89,
                            179
                        ],
                        [
                            179,
                            88
                        ],
                        [
                            6,
                            122
                        ],
                        [
                            122,
                            196
                        ],
                        [
                            196,
                            6
                        ],
                        [
                            88,
                            95
                        ],
                        [
                            95,
                            96
                        ],
                        [
                            96,
                            88
                        ],
                        [
                            138,
                            172
                        ],
                        [
                            172,
                            136
                        ],
                        [
                            136,
                            138
                        ],
                        [
                            215,
                            58
                        ],
                        [
                            58,
                            172
                        ],
                        [
                            172,
                            215
                        ],
                        [
                            115,
                            48
                        ],
                        [
                            48,
                            219
                        ],
                        [
                            219,
                            115
                        ],
                        [
                            42,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            42
                        ],
                        [
                            195,
                            3
                        ],
                        [
                            3,
                            51
                        ],
                        [
                            51,
                            195
                        ],
                        [
                            43,
                            146
                        ],
                        [
                            146,
                            61
                        ],
                        [
                            61,
                            43
                        ],
                        [
                            171,
                            175
                        ],
                        [
                            175,
                            199
                        ],
                        [
                            199,
                            171
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            38
                        ],
                        [
                            38,
                            81
                        ],
                        [
                            53,
                            46
                        ],
                        [
                            46,
                            225
                        ],
                        [
                            225,
                            53
                        ],
                        [
                            144,
                            163
                        ],
                        [
                            163,
                            110
                        ],
                        [
                            110,
                            144
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            66
                        ],
                        [
                            66,
                            52
                        ],
                        [
                            229,
                            228
                        ],
                        [
                            228,
                            117
                        ],
                        [
                            117,
                            229
                        ],
                        [
                            34,
                            127
                        ],
                        [
                            127,
                            234
                        ],
                        [
                            234,
                            34
                        ],
                        [
                            107,
                            108
                        ],
                        [
                            108,
                            69
                        ],
                        [
                            69,
                            107
                        ],
                        [
                            109,
                            108
                        ],
                        [
                            108,
                            151
                        ],
                        [
                            151,
                            109
                        ],
                        [
                            48,
                            64
                        ],
                        [
                            64,
                            235
                        ],
                        [
                            235,
                            48
                        ],
                        [
                            62,
                            78
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            62
                        ],
                        [
                            129,
                            209
                        ],
                        [
                            209,
                            126
                        ],
                        [
                            126,
                            129
                        ],
                        [
                            111,
                            35
                        ],
                        [
                            35,
                            143
                        ],
                        [
                            143,
                            111
                        ],
                        [
                            117,
                            123
                        ],
                        [
                            123,
                            50
                        ],
                        [
                            50,
                            117
                        ],
                        [
                            222,
                            65
                        ],
                        [
                            65,
                            52
                        ],
                        [
                            52,
                            222
                        ],
                        [
                            19,
                            125
                        ],
                        [
                            125,
                            141
                        ],
                        [
                            141,
                            19
                        ],
                        [
                            221,
                            55
                        ],
                        [
                            55,
                            65
                        ],
                        [
                            65,
                            221
                        ],
                        [
                            3,
                            195
                        ],
                        [
                            195,
                            197
                        ],
                        [
                            197,
                            3
                        ],
                        [
                            25,
                            7
                        ],
                        [
                            7,
                            33
                        ],
                        [
                            33,
                            25
                        ],
                        [
                            220,
                            237
                        ],
                        [
                            237,
                            44
                        ],
                        [
                            44,
                            220
                        ],
                        [
                            70,
                            71
                        ],
                        [
                            71,
                            139
                        ],
                        [
                            139,
                            70
                        ],
                        [
                            122,
                            193
                        ],
                        [
                            193,
                            245
                        ],
                        [
                            245,
                            122
                        ],
                        [
                            247,
                            130
                        ],
                        [
                            130,
                            33
                        ],
                        [
                            33,
                            247
                        ],
                        [
                            71,
                            21
                        ],
                        [
                            21,
                            162
                        ],
                        [
                            162,
                            71
                        ],
                        [
                            170,
                            169
                        ],
                        [
                            169,
                            150
                        ],
                        [
                            150,
                            170
                        ],
                        [
                            188,
                            174
                        ],
                        [
                            174,
                            196
                        ],
                        [
                            196,
                            188
                        ],
                        [
                            216,
                            186
                        ],
                        [
                            186,
                            92
                        ],
                        [
                            92,
                            216
                        ],
                        [
                            2,
                            97
                        ],
                        [
                            97,
                            167
                        ],
                        [
                            167,
                            2
                        ],
                        [
                            141,
                            125
                        ],
                        [
                            125,
                            241
                        ],
                        [
                            241,
                            141
                        ],
                        [
                            164,
                            167
                        ],
                        [
                            167,
                            37
                        ],
                        [
                            37,
                            164
                        ],
                        [
                            72,
                            38
                        ],
                        [
                            38,
                            12
                        ],
                        [
                            12,
                            72
                        ],
                        [
                            38,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            38
                        ],
                        [
                            63,
                            68
                        ],
                        [
                            68,
                            71
                        ],
                        [
                            71,
                            63
                        ],
                        [
                            226,
                            35
                        ],
                        [
                            35,
                            111
                        ],
                        [
                            111,
                            226
                        ],
                        [
                            101,
                            50
                        ],
                        [
                            50,
                            205
                        ],
                        [
                            205,
                            101
                        ],
                        [
                            206,
                            92
                        ],
                        [
                            92,
                            165
                        ],
                        [
                            165,
                            206
                        ],
                        [
                            209,
                            198
                        ],
                        [
                            198,
                            217
                        ],
                        [
                            217,
                            209
                        ],
                        [
                            165,
                            167
                        ],
                        [
                            167,
                            97
                        ],
                        [
                            97,
                            165
                        ],
                        [
                            220,
                            115
                        ],
                        [
                            115,
                            218
                        ],
                        [
                            218,
                            220
                        ],
                        [
                            133,
                            112
                        ],
                        [
                            112,
                            243
                        ],
                        [
                            243,
                            133
                        ],
                        [
                            239,
                            238
                        ],
                        [
                            238,
                            241
                        ],
                        [
                            241,
                            239
                        ],
                        [
                            214,
                            135
                        ],
                        [
                            135,
                            169
                        ],
                        [
                            169,
                            214
                        ],
                        [
                            190,
                            173
                        ],
                        [
                            173,
                            133
                        ],
                        [
                            133,
                            190
                        ],
                        [
                            171,
                            208
                        ],
                        [
                            208,
                            32
                        ],
                        [
                            32,
                            171
                        ],
                        [
                            125,
                            44
                        ],
                        [
                            44,
                            237
                        ],
                        [
                            237,
                            125
                        ],
                        [
                            86,
                            87
                        ],
                        [
                            87,
                            178
                        ],
                        [
                            178,
                            86
                        ],
                        [
                            85,
                            86
                        ],
                        [
                            86,
                            179
                        ],
                        [
                            179,
                            85
                        ],
                        [
                            84,
                            85
                        ],
                        [
                            85,
                            180
                        ],
                        [
                            180,
                            84
                        ],
                        [
                            83,
                            84
                        ],
                        [
                            84,
                            181
                        ],
                        [
                            181,
                            83
                        ],
                        [
                            201,
                            83
                        ],
                        [
                            83,
                            182
                        ],
                        [
                            182,
                            201
                        ],
                        [
                            137,
                            93
                        ],
                        [
                            93,
                            132
                        ],
                        [
                            132,
                            137
                        ],
                        [
                            76,
                            62
                        ],
                        [
                            62,
                            183
                        ],
                        [
                            183,
                            76
                        ],
                        [
                            61,
                            76
                        ],
                        [
                            76,
                            184
                        ],
                        [
                            184,
                            61
                        ],
                        [
                            57,
                            61
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            57
                        ],
                        [
                            212,
                            57
                        ],
                        [
                            57,
                            186
                        ],
                        [
                            186,
                            212
                        ],
                        [
                            214,
                            207
                        ],
                        [
                            207,
                            187
                        ],
                        [
                            187,
                            214
                        ],
                        [
                            34,
                            143
                        ],
                        [
                            143,
                            156
                        ],
                        [
                            156,
                            34
                        ],
                        [
                            79,
                            239
                        ],
                        [
                            239,
                            237
                        ],
                        [
                            237,
                            79
                        ],
                        [
                            123,
                            137
                        ],
                        [
                            137,
                            177
                        ],
                        [
                            177,
                            123
                        ],
                        [
                            44,
                            1
                        ],
                        [
                            1,
                            4
                        ],
                        [
                            4,
                            44
                        ],
                        [
                            201,
                            194
                        ],
                        [
                            194,
                            32
                        ],
                        [
                            32,
                            201
                        ],
                        [
                            64,
                            102
                        ],
                        [
                            102,
                            129
                        ],
                        [
                            129,
                            64
                        ],
                        [
                            213,
                            215
                        ],
                        [
                            215,
                            138
                        ],
                        [
                            138,
                            213
                        ],
                        [
                            59,
                            166
                        ],
                        [
                            166,
                            219
                        ],
                        [
                            219,
                            59
                        ],
                        [
                            242,
                            99
                        ],
                        [
                            99,
                            97
                        ],
                        [
                            97,
                            242
                        ],
                        [
                            2,
                            94
                        ],
                        [
                            94,
                            141
                        ],
                        [
                            141,
                            2
                        ],
                        [
                            75,
                            59
                        ],
                        [
                            59,
                            235
                        ],
                        [
                            235,
                            75
                        ],
                        [
                            24,
                            110
                        ],
                        [
                            110,
                            228
                        ],
                        [
                            228,
                            24
                        ],
                        [
                            25,
                            130
                        ],
                        [
                            130,
                            226
                        ],
                        [
                            226,
                            25
                        ],
                        [
                            23,
                            24
                        ],
                        [
                            24,
                            229
                        ],
                        [
                            229,
                            23
                        ],
                        [
                            22,
                            23
                        ],
                        [
                            23,
                            230
                        ],
                        [
                            230,
                            22
                        ],
                        [
                            26,
                            22
                        ],
                        [
                            22,
                            231
                        ],
                        [
                            231,
                            26
                        ],
                        [
                            112,
                            26
                        ],
                        [
                            26,
                            232
                        ],
                        [
                            232,
                            112
                        ],
                        [
                            189,
                            190
                        ],
                        [
                            190,
                            243
                        ],
                        [
                            243,
                            189
                        ],
                        [
                            221,
                            56
                        ],
                        [
                            56,
                            190
                        ],
                        [
                            190,
                            221
                        ],
                        [
                            28,
                            56
                        ],
                        [
                            56,
                            221
                        ],
                        [
                            221,
                            28
                        ],
                        [
                            27,
                            28
                        ],
                        [
                            28,
                            222
                        ],
                        [
                            222,
                            27
                        ],
                        [
                            29,
                            27
                        ],
                        [
                            27,
                            223
                        ],
                        [
                            223,
                            29
                        ],
                        [
                            30,
                            29
                        ],
                        [
                            29,
                            224
                        ],
                        [
                            224,
                            30
                        ],
                        [
                            247,
                            30
                        ],
                        [
                            30,
                            225
                        ],
                        [
                            225,
                            247
                        ],
                        [
                            238,
                            79
                        ],
                        [
                            79,
                            20
                        ],
                        [
                            20,
                            238
                        ],
                        [
                            166,
                            59
                        ],
                        [
                            59,
                            75
                        ],
                        [
                            75,
                            166
                        ],
                        [
                            60,
                            75
                        ],
                        [
                            75,
                            240
                        ],
                        [
                            240,
                            60
                        ],
                        [
                            147,
                            177
                        ],
                        [
                            177,
                            215
                        ],
                        [
                            215,
                            147
                        ],
                        [
                            20,
                            79
                        ],
                        [
                            79,
                            166
                        ],
                        [
                            166,
                            20
                        ],
                        [
                            187,
                            147
                        ],
                        [
                            147,
                            213
                        ],
                        [
                            213,
                            187
                        ],
                        [
                            112,
                            233
                        ],
                        [
                            233,
                            244
                        ],
                        [
                            244,
                            112
                        ],
                        [
                            233,
                            128
                        ],
                        [
                            128,
                            245
                        ],
                        [
                            245,
                            233
                        ],
                        [
                            128,
                            114
                        ],
                        [
                            114,
                            188
                        ],
                        [
                            188,
                            128
                        ],
                        [
                            114,
                            217
                        ],
                        [
                            217,
                            174
                        ],
                        [
                            174,
                            114
                        ],
                        [
                            131,
                            115
                        ],
                        [
                            115,
                            220
                        ],
                        [
                            220,
                            131
                        ],
                        [
                            217,
                            198
                        ],
                        [
                            198,
                            236
                        ],
                        [
                            236,
                            217
                        ],
                        [
                            198,
                            131
                        ],
                        [
                            131,
                            134
                        ],
                        [
                            134,
                            198
                        ],
                        [
                            177,
                            132
                        ],
                        [
                            132,
                            58
                        ],
                        [
                            58,
                            177
                        ],
                        [
                            143,
                            35
                        ],
                        [
                            35,
                            124
                        ],
                        [
                            124,
                            143
                        ],
                        [
                            110,
                            163
                        ],
                        [
                            163,
                            7
                        ],
                        [
                            7,
                            110
                        ],
                        [
                            228,
                            110
                        ],
                        [
                            110,
                            25
                        ],
                        [
                            25,
                            228
                        ],
                        [
                            356,
                            389
                        ],
                        [
                            389,
                            368
                        ],
                        [
                            368,
                            356
                        ],
                        [
                            11,
                            302
                        ],
                        [
                            302,
                            267
                        ],
                        [
                            267,
                            11
                        ],
                        [
                            452,
                            350
                        ],
                        [
                            350,
                            349
                        ],
                        [
                            349,
                            452
                        ],
                        [
                            302,
                            303
                        ],
                        [
                            303,
                            269
                        ],
                        [
                            269,
                            302
                        ],
                        [
                            357,
                            343
                        ],
                        [
                            343,
                            277
                        ],
                        [
                            277,
                            357
                        ],
                        [
                            452,
                            453
                        ],
                        [
                            453,
                            357
                        ],
                        [
                            357,
                            452
                        ],
                        [
                            333,
                            332
                        ],
                        [
                            332,
                            297
                        ],
                        [
                            297,
                            333
                        ],
                        [
                            175,
                            152
                        ],
                        [
                            152,
                            377
                        ],
                        [
                            377,
                            175
                        ],
                        [
                            347,
                            348
                        ],
                        [
                            348,
                            330
                        ],
                        [
                            330,
                            347
                        ],
                        [
                            303,
                            304
                        ],
                        [
                            304,
                            270
                        ],
                        [
                            270,
                            303
                        ],
                        [
                            9,
                            336
                        ],
                        [
                            336,
                            337
                        ],
                        [
                            337,
                            9
                        ],
                        [
                            278,
                            279
                        ],
                        [
                            279,
                            360
                        ],
                        [
                            360,
                            278
                        ],
                        [
                            418,
                            262
                        ],
                        [
                            262,
                            431
                        ],
                        [
                            431,
                            418
                        ],
                        [
                            304,
                            408
                        ],
                        [
                            408,
                            409
                        ],
                        [
                            409,
                            304
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            407
                        ],
                        [
                            407,
                            310
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            410
                        ],
                        [
                            410,
                            270
                        ],
                        [
                            450,
                            348
                        ],
                        [
                            348,
                            347
                        ],
                        [
                            347,
                            450
                        ],
                        [
                            422,
                            430
                        ],
                        [
                            430,
                            434
                        ],
                        [
                            434,
                            422
                        ],
                        [
                            313,
                            314
                        ],
                        [
                            314,
                            17
                        ],
                        [
                            17,
                            313
                        ],
                        [
                            306,
                            307
                        ],
                        [
                            307,
                            375
                        ],
                        [
                            375,
                            306
                        ],
                        [
                            387,
                            388
                        ],
                        [
                            388,
                            260
                        ],
                        [
                            260,
                            387
                        ],
                        [
                            286,
                            414
                        ],
                        [
                            414,
                            398
                        ],
                        [
                            398,
                            286
                        ],
                        [
                            335,
                            406
                        ],
                        [
                            406,
                            418
                        ],
                        [
                            418,
                            335
                        ],
                        [
                            364,
                            367
                        ],
                        [
                            367,
                            416
                        ],
                        [
                            416,
                            364
                        ],
                        [
                            423,
                            358
                        ],
                        [
                            358,
                            327
                        ],
                        [
                            327,
                            423
                        ],
                        [
                            251,
                            284
                        ],
                        [
                            284,
                            298
                        ],
                        [
                            298,
                            251
                        ],
                        [
                            281,
                            5
                        ],
                        [
                            5,
                            4
                        ],
                        [
                            4,
                            281
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            253
                        ],
                        [
                            253,
                            373
                        ],
                        [
                            307,
                            320
                        ],
                        [
                            320,
                            321
                        ],
                        [
                            321,
                            307
                        ],
                        [
                            425,
                            427
                        ],
                        [
                            427,
                            411
                        ],
                        [
                            411,
                            425
                        ],
                        [
                            421,
                            313
                        ],
                        [
                            313,
                            18
                        ],
                        [
                            18,
                            421
                        ],
                        [
                            321,
                            405
                        ],
                        [
                            405,
                            406
                        ],
                        [
                            406,
                            321
                        ],
                        [
                            320,
                            404
                        ],
                        [
                            404,
                            405
                        ],
                        [
                            405,
                            320
                        ],
                        [
                            315,
                            16
                        ],
                        [
                            16,
                            17
                        ],
                        [
                            17,
                            315
                        ],
                        [
                            426,
                            425
                        ],
                        [
                            425,
                            266
                        ],
                        [
                            266,
                            426
                        ],
                        [
                            377,
                            400
                        ],
                        [
                            400,
                            369
                        ],
                        [
                            369,
                            377
                        ],
                        [
                            322,
                            391
                        ],
                        [
                            391,
                            269
                        ],
                        [
                            269,
                            322
                        ],
                        [
                            417,
                            465
                        ],
                        [
                            465,
                            464
                        ],
                        [
                            464,
                            417
                        ],
                        [
                            386,
                            257
                        ],
                        [
                            257,
                            258
                        ],
                        [
                            258,
                            386
                        ],
                        [
                            466,
                            260
                        ],
                        [
                            260,
                            388
                        ],
                        [
                            388,
                            466
                        ],
                        [
                            456,
                            399
                        ],
                        [
                            399,
                            419
                        ],
                        [
                            419,
                            456
                        ],
                        [
                            284,
                            332
                        ],
                        [
                            332,
                            333
                        ],
                        [
                            333,
                            284
                        ],
                        [
                            417,
                            285
                        ],
                        [
                            285,
                            8
                        ],
                        [
                            8,
                            417
                        ],
                        [
                            346,
                            340
                        ],
                        [
                            340,
                            261
                        ],
                        [
                            261,
                            346
                        ],
                        [
                            413,
                            441
                        ],
                        [
                            441,
                            285
                        ],
                        [
                            285,
                            413
                        ],
                        [
                            327,
                            460
                        ],
                        [
                            460,
                            328
                        ],
                        [
                            328,
                            327
                        ],
                        [
                            355,
                            371
                        ],
                        [
                            371,
                            329
                        ],
                        [
                            329,
                            355
                        ],
                        [
                            392,
                            439
                        ],
                        [
                            439,
                            438
                        ],
                        [
                            438,
                            392
                        ],
                        [
                            382,
                            341
                        ],
                        [
                            341,
                            256
                        ],
                        [
                            256,
                            382
                        ],
                        [
                            429,
                            420
                        ],
                        [
                            420,
                            360
                        ],
                        [
                            360,
                            429
                        ],
                        [
                            364,
                            394
                        ],
                        [
                            394,
                            379
                        ],
                        [
                            379,
                            364
                        ],
                        [
                            277,
                            343
                        ],
                        [
                            343,
                            437
                        ],
                        [
                            437,
                            277
                        ],
                        [
                            443,
                            444
                        ],
                        [
                            444,
                            283
                        ],
                        [
                            283,
                            443
                        ],
                        [
                            275,
                            440
                        ],
                        [
                            440,
                            363
                        ],
                        [
                            363,
                            275
                        ],
                        [
                            431,
                            262
                        ],
                        [
                            262,
                            369
                        ],
                        [
                            369,
                            431
                        ],
                        [
                            297,
                            338
                        ],
                        [
                            338,
                            337
                        ],
                        [
                            337,
                            297
                        ],
                        [
                            273,
                            375
                        ],
                        [
                            375,
                            321
                        ],
                        [
                            321,
                            273
                        ],
                        [
                            450,
                            451
                        ],
                        [
                            451,
                            349
                        ],
                        [
                            349,
                            450
                        ],
                        [
                            446,
                            342
                        ],
                        [
                            342,
                            467
                        ],
                        [
                            467,
                            446
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            282
                        ],
                        [
                            282,
                            293
                        ],
                        [
                            458,
                            461
                        ],
                        [
                            461,
                            462
                        ],
                        [
                            462,
                            458
                        ],
                        [
                            276,
                            353
                        ],
                        [
                            353,
                            383
                        ],
                        [
                            383,
                            276
                        ],
                        [
                            308,
                            324
                        ],
                        [
                            324,
                            325
                        ],
                        [
                            325,
                            308
                        ],
                        [
                            276,
                            300
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            276
                        ],
                        [
                            372,
                            345
                        ],
                        [
                            345,
                            447
                        ],
                        [
                            447,
                            372
                        ],
                        [
                            352,
                            345
                        ],
                        [
                            345,
                            340
                        ],
                        [
                            340,
                            352
                        ],
                        [
                            274,
                            1
                        ],
                        [
                            1,
                            19
                        ],
                        [
                            19,
                            274
                        ],
                        [
                            456,
                            248
                        ],
                        [
                            248,
                            281
                        ],
                        [
                            281,
                            456
                        ],
                        [
                            436,
                            427
                        ],
                        [
                            427,
                            425
                        ],
                        [
                            425,
                            436
                        ],
                        [
                            381,
                            256
                        ],
                        [
                            256,
                            252
                        ],
                        [
                            252,
                            381
                        ],
                        [
                            269,
                            391
                        ],
                        [
                            391,
                            393
                        ],
                        [
                            393,
                            269
                        ],
                        [
                            200,
                            199
                        ],
                        [
                            199,
                            428
                        ],
                        [
                            428,
                            200
                        ],
                        [
                            266,
                            330
                        ],
                        [
                            330,
                            329
                        ],
                        [
                            329,
                            266
                        ],
                        [
                            287,
                            273
                        ],
                        [
                            273,
                            422
                        ],
                        [
                            422,
                            287
                        ],
                        [
                            250,
                            462
                        ],
                        [
                            462,
                            328
                        ],
                        [
                            328,
                            250
                        ],
                        [
                            258,
                            286
                        ],
                        [
                            286,
                            384
                        ],
                        [
                            384,
                            258
                        ],
                        [
                            265,
                            353
                        ],
                        [
                            353,
                            342
                        ],
                        [
                            342,
                            265
                        ],
                        [
                            387,
                            259
                        ],
                        [
                            259,
                            257
                        ],
                        [
                            257,
                            387
                        ],
                        [
                            424,
                            431
                        ],
                        [
                            431,
                            430
                        ],
                        [
                            430,
                            424
                        ],
                        [
                            342,
                            353
                        ],
                        [
                            353,
                            276
                        ],
                        [
                            276,
                            342
                        ],
                        [
                            273,
                            335
                        ],
                        [
                            335,
                            424
                        ],
                        [
                            424,
                            273
                        ],
                        [
                            292,
                            325
                        ],
                        [
                            325,
                            307
                        ],
                        [
                            307,
                            292
                        ],
                        [
                            366,
                            447
                        ],
                        [
                            447,
                            345
                        ],
                        [
                            345,
                            366
                        ],
                        [
                            271,
                            303
                        ],
                        [
                            303,
                            302
                        ],
                        [
                            302,
                            271
                        ],
                        [
                            423,
                            266
                        ],
                        [
                            266,
                            371
                        ],
                        [
                            371,
                            423
                        ],
                        [
                            294,
                            455
                        ],
                        [
                            455,
                            460
                        ],
                        [
                            460,
                            294
                        ],
                        [
                            279,
                            278
                        ],
                        [
                            278,
                            294
                        ],
                        [
                            294,
                            279
                        ],
                        [
                            271,
                            272
                        ],
                        [
                            272,
                            304
                        ],
                        [
                            304,
                            271
                        ],
                        [
                            432,
                            434
                        ],
                        [
                            434,
                            427
                        ],
                        [
                            427,
                            432
                        ],
                        [
                            272,
                            407
                        ],
                        [
                            407,
                            408
                        ],
                        [
                            408,
                            272
                        ],
                        [
                            394,
                            430
                        ],
                        [
                            430,
                            431
                        ],
                        [
                            431,
                            394
                        ],
                        [
                            395,
                            369
                        ],
                        [
                            369,
                            400
                        ],
                        [
                            400,
                            395
                        ],
                        [
                            334,
                            333
                        ],
                        [
                            333,
                            299
                        ],
                        [
                            299,
                            334
                        ],
                        [
                            351,
                            417
                        ],
                        [
                            417,
                            168
                        ],
                        [
                            168,
                            351
                        ],
                        [
                            352,
                            280
                        ],
                        [
                            280,
                            411
                        ],
                        [
                            411,
                            352
                        ],
                        [
                            325,
                            319
                        ],
                        [
                            319,
                            320
                        ],
                        [
                            320,
                            325
                        ],
                        [
                            295,
                            296
                        ],
                        [
                            296,
                            336
                        ],
                        [
                            336,
                            295
                        ],
                        [
                            319,
                            403
                        ],
                        [
                            403,
                            404
                        ],
                        [
                            404,
                            319
                        ],
                        [
                            330,
                            348
                        ],
                        [
                            348,
                            349
                        ],
                        [
                            349,
                            330
                        ],
                        [
                            293,
                            298
                        ],
                        [
                            298,
                            333
                        ],
                        [
                            333,
                            293
                        ],
                        [
                            323,
                            454
                        ],
                        [
                            454,
                            447
                        ],
                        [
                            447,
                            323
                        ],
                        [
                            15,
                            16
                        ],
                        [
                            16,
                            315
                        ],
                        [
                            315,
                            15
                        ],
                        [
                            358,
                            429
                        ],
                        [
                            429,
                            279
                        ],
                        [
                            279,
                            358
                        ],
                        [
                            14,
                            15
                        ],
                        [
                            15,
                            316
                        ],
                        [
                            316,
                            14
                        ],
                        [
                            285,
                            336
                        ],
                        [
                            336,
                            9
                        ],
                        [
                            9,
                            285
                        ],
                        [
                            329,
                            349
                        ],
                        [
                            349,
                            350
                        ],
                        [
                            350,
                            329
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            252
                        ],
                        [
                            252,
                            374
                        ],
                        [
                            318,
                            402
                        ],
                        [
                            402,
                            403
                        ],
                        [
                            403,
                            318
                        ],
                        [
                            6,
                            197
                        ],
                        [
                            197,
                            419
                        ],
                        [
                            419,
                            6
                        ],
                        [
                            318,
                            319
                        ],
                        [
                            319,
                            325
                        ],
                        [
                            325,
                            318
                        ],
                        [
                            367,
                            364
                        ],
                        [
                            364,
                            365
                        ],
                        [
                            365,
                            367
                        ],
                        [
                            435,
                            367
                        ],
                        [
                            367,
                            397
                        ],
                        [
                            397,
                            435
                        ],
                        [
                            344,
                            438
                        ],
                        [
                            438,
                            439
                        ],
                        [
                            439,
                            344
                        ],
                        [
                            272,
                            271
                        ],
                        [
                            271,
                            311
                        ],
                        [
                            311,
                            272
                        ],
                        [
                            195,
                            5
                        ],
                        [
                            5,
                            281
                        ],
                        [
                            281,
                            195
                        ],
                        [
                            273,
                            287
                        ],
                        [
                            287,
                            291
                        ],
                        [
                            291,
                            273
                        ],
                        [
                            396,
                            428
                        ],
                        [
                            428,
                            199
                        ],
                        [
                            199,
                            396
                        ],
                        [
                            311,
                            271
                        ],
                        [
                            271,
                            268
                        ],
                        [
                            268,
                            311
                        ],
                        [
                            283,
                            444
                        ],
                        [
                            444,
                            445
                        ],
                        [
                            445,
                            283
                        ],
                        [
                            373,
                            254
                        ],
                        [
                            254,
                            339
                        ],
                        [
                            339,
                            373
                        ],
                        [
                            282,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            282
                        ],
                        [
                            449,
                            347
                        ],
                        [
                            347,
                            346
                        ],
                        [
                            346,
                            449
                        ],
                        [
                            264,
                            447
                        ],
                        [
                            447,
                            454
                        ],
                        [
                            454,
                            264
                        ],
                        [
                            336,
                            296
                        ],
                        [
                            296,
                            299
                        ],
                        [
                            299,
                            336
                        ],
                        [
                            338,
                            10
                        ],
                        [
                            10,
                            151
                        ],
                        [
                            151,
                            338
                        ],
                        [
                            278,
                            439
                        ],
                        [
                            439,
                            455
                        ],
                        [
                            455,
                            278
                        ],
                        [
                            292,
                            407
                        ],
                        [
                            407,
                            415
                        ],
                        [
                            415,
                            292
                        ],
                        [
                            358,
                            371
                        ],
                        [
                            371,
                            355
                        ],
                        [
                            355,
                            358
                        ],
                        [
                            340,
                            345
                        ],
                        [
                            345,
                            372
                        ],
                        [
                            372,
                            340
                        ],
                        [
                            346,
                            347
                        ],
                        [
                            347,
                            280
                        ],
                        [
                            280,
                            346
                        ],
                        [
                            442,
                            443
                        ],
                        [
                            443,
                            282
                        ],
                        [
                            282,
                            442
                        ],
                        [
                            19,
                            94
                        ],
                        [
                            94,
                            370
                        ],
                        [
                            370,
                            19
                        ],
                        [
                            441,
                            442
                        ],
                        [
                            442,
                            295
                        ],
                        [
                            295,
                            441
                        ],
                        [
                            248,
                            419
                        ],
                        [
                            419,
                            197
                        ],
                        [
                            197,
                            248
                        ],
                        [
                            263,
                            255
                        ],
                        [
                            255,
                            359
                        ],
                        [
                            359,
                            263
                        ],
                        [
                            440,
                            275
                        ],
                        [
                            275,
                            274
                        ],
                        [
                            274,
                            440
                        ],
                        [
                            300,
                            383
                        ],
                        [
                            383,
                            368
                        ],
                        [
                            368,
                            300
                        ],
                        [
                            351,
                            412
                        ],
                        [
                            412,
                            465
                        ],
                        [
                            465,
                            351
                        ],
                        [
                            263,
                            467
                        ],
                        [
                            467,
                            466
                        ],
                        [
                            466,
                            263
                        ],
                        [
                            301,
                            368
                        ],
                        [
                            368,
                            389
                        ],
                        [
                            389,
                            301
                        ],
                        [
                            395,
                            378
                        ],
                        [
                            378,
                            379
                        ],
                        [
                            379,
                            395
                        ],
                        [
                            412,
                            351
                        ],
                        [
                            351,
                            419
                        ],
                        [
                            419,
                            412
                        ],
                        [
                            436,
                            426
                        ],
                        [
                            426,
                            322
                        ],
                        [
                            322,
                            436
                        ],
                        [
                            2,
                            164
                        ],
                        [
                            164,
                            393
                        ],
                        [
                            393,
                            2
                        ],
                        [
                            370,
                            462
                        ],
                        [
                            462,
                            461
                        ],
                        [
                            461,
                            370
                        ],
                        [
                            164,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            164
                        ],
                        [
                            302,
                            11
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            12,
                            302
                        ],
                        [
                            268,
                            12
                        ],
                        [
                            12,
                            13
                        ],
                        [
                            13,
                            268
                        ],
                        [
                            293,
                            300
                        ],
                        [
                            300,
                            301
                        ],
                        [
                            301,
                            293
                        ],
                        [
                            446,
                            261
                        ],
                        [
                            261,
                            340
                        ],
                        [
                            340,
                            446
                        ],
                        [
                            330,
                            266
                        ],
                        [
                            266,
                            425
                        ],
                        [
                            425,
                            330
                        ],
                        [
                            426,
                            423
                        ],
                        [
                            423,
                            391
                        ],
                        [
                            391,
                            426
                        ],
                        [
                            429,
                            355
                        ],
                        [
                            355,
                            437
                        ],
                        [
                            437,
                            429
                        ],
                        [
                            391,
                            327
                        ],
                        [
                            327,
                            326
                        ],
                        [
                            326,
                            391
                        ],
                        [
                            440,
                            457
                        ],
                        [
                            457,
                            438
                        ],
                        [
                            438,
                            440
                        ],
                        [
                            341,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            362,
                            341
                        ],
                        [
                            459,
                            457
                        ],
                        [
                            457,
                            461
                        ],
                        [
                            461,
                            459
                        ],
                        [
                            434,
                            430
                        ],
                        [
                            430,
                            394
                        ],
                        [
                            394,
                            434
                        ],
                        [
                            414,
                            463
                        ],
                        [
                            463,
                            362
                        ],
                        [
                            362,
                            414
                        ],
                        [
                            396,
                            369
                        ],
                        [
                            369,
                            262
                        ],
                        [
                            262,
                            396
                        ],
                        [
                            354,
                            461
                        ],
                        [
                            461,
                            457
                        ],
                        [
                            457,
                            354
                        ],
                        [
                            316,
                            403
                        ],
                        [
                            403,
                            402
                        ],
                        [
                            402,
                            316
                        ],
                        [
                            315,
                            404
                        ],
                        [
                            404,
                            403
                        ],
                        [
                            403,
                            315
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            404
                        ],
                        [
                            404,
                            314
                        ],
                        [
                            313,
                            406
                        ],
                        [
                            406,
                            405
                        ],
                        [
                            405,
                            313
                        ],
                        [
                            421,
                            418
                        ],
                        [
                            418,
                            406
                        ],
                        [
                            406,
                            421
                        ],
                        [
                            366,
                            401
                        ],
                        [
                            401,
                            361
                        ],
                        [
                            361,
                            366
                        ],
                        [
                            306,
                            408
                        ],
                        [
                            408,
                            407
                        ],
                        [
                            407,
                            306
                        ],
                        [
                            291,
                            409
                        ],
                        [
                            409,
                            408
                        ],
                        [
                            408,
                            291
                        ],
                        [
                            287,
                            410
                        ],
                        [
                            410,
                            409
                        ],
                        [
                            409,
                            287
                        ],
                        [
                            432,
                            436
                        ],
                        [
                            436,
                            410
                        ],
                        [
                            410,
                            432
                        ],
                        [
                            434,
                            416
                        ],
                        [
                            416,
                            411
                        ],
                        [
                            411,
                            434
                        ],
                        [
                            264,
                            368
                        ],
                        [
                            368,
                            383
                        ],
                        [
                            383,
                            264
                        ],
                        [
                            309,
                            438
                        ],
                        [
                            438,
                            457
                        ],
                        [
                            457,
                            309
                        ],
                        [
                            352,
                            376
                        ],
                        [
                            376,
                            401
                        ],
                        [
                            401,
                            352
                        ],
                        [
                            274,
                            275
                        ],
                        [
                            275,
                            4
                        ],
                        [
                            4,
                            274
                        ],
                        [
                            421,
                            428
                        ],
                        [
                            428,
                            262
                        ],
                        [
                            262,
                            421
                        ],
                        [
                            294,
                            327
                        ],
                        [
                            327,
                            358
                        ],
                        [
                            358,
                            294
                        ],
                        [
                            433,
                            416
                        ],
                        [
                            416,
                            367
                        ],
                        [
                            367,
                            433
                        ],
                        [
                            289,
                            455
                        ],
                        [
                            455,
                            439
                        ],
                        [
                            439,
                            289
                        ],
                        [
                            462,
                            370
                        ],
                        [
                            370,
                            326
                        ],
                        [
                            326,
                            462
                        ],
                        [
                            2,
                            326
                        ],
                        [
                            326,
                            370
                        ],
                        [
                            370,
                            2
                        ],
                        [
                            305,
                            460
                        ],
                        [
                            460,
                            455
                        ],
                        [
                            455,
                            305
                        ],
                        [
                            254,
                            449
                        ],
                        [
                            449,
                            448
                        ],
                        [
                            448,
                            254
                        ],
                        [
                            255,
                            261
                        ],
                        [
                            261,
                            446
                        ],
                        [
                            446,
                            255
                        ],
                        [
                            253,
                            450
                        ],
                        [
                            450,
                            449
                        ],
                        [
                            449,
                            253
                        ],
                        [
                            252,
                            451
                        ],
                        [
                            451,
                            450
                        ],
                        [
                            450,
                            252
                        ],
                        [
                            256,
                            452
                        ],
                        [
                            452,
                            451
                        ],
                        [
                            451,
                            256
                        ],
                        [
                            341,
                            453
                        ],
                        [
                            453,
                            452
                        ],
                        [
                            452,
                            341
                        ],
                        [
                            413,
                            464
                        ],
                        [
                            464,
                            463
                        ],
                        [
                            463,
                            413
                        ],
                        [
                            441,
                            413
                        ],
                        [
                            413,
                            414
                        ],
                        [
                            414,
                            441
                        ],
                        [
                            258,
                            442
                        ],
                        [
                            442,
                            441
                        ],
                        [
                            441,
                            258
                        ],
                        [
                            257,
                            443
                        ],
                        [
                            443,
                            442
                        ],
                        [
                            442,
                            257
                        ],
                        [
                            259,
                            444
                        ],
                        [
                            444,
                            443
                        ],
                        [
                            443,
                            259
                        ],
                        [
                            260,
                            445
                        ],
                        [
                            445,
                            444
                        ],
                        [
                            444,
                            260
                        ],
                        [
                            467,
                            342
                        ],
                        [
                            342,
                            445
                        ],
                        [
                            445,
                            467
                        ],
                        [
                            459,
                            458
                        ],
                        [
                            458,
                            250
                        ],
                        [
                            250,
                            459
                        ],
                        [
                            289,
                            392
                        ],
                        [
                            392,
                            290
                        ],
                        [
                            290,
                            289
                        ],
                        [
                            290,
                            328
                        ],
                        [
                            328,
                            460
                        ],
                        [
                            460,
                            290
                        ],
                        [
                            376,
                            433
                        ],
                        [
                            433,
                            435
                        ],
                        [
                            435,
                            376
                        ],
                        [
                            250,
                            290
                        ],
                        [
                            290,
                            392
                        ],
                        [
                            392,
                            250
                        ],
                        [
                            411,
                            416
                        ],
                        [
                            416,
                            433
                        ],
                        [
                            433,
                            411
                        ],
                        [
                            341,
                            463
                        ],
                        [
                            463,
                            464
                        ],
                        [
                            464,
                            341
                        ],
                        [
                            453,
                            464
                        ],
                        [
                            464,
                            465
                        ],
                        [
                            465,
                            453
                        ],
                        [
                            357,
                            465
                        ],
                        [
                            465,
                            412
                        ],
                        [
                            412,
                            357
                        ],
                        [
                            343,
                            412
                        ],
                        [
                            412,
                            399
                        ],
                        [
                            399,
                            343
                        ],
                        [
                            360,
                            363
                        ],
                        [
                            363,
                            440
                        ],
                        [
                            440,
                            360
                        ],
                        [
                            437,
                            399
                        ],
                        [
                            399,
                            456
                        ],
                        [
                            456,
                            437
                        ],
                        [
                            420,
                            456
                        ],
                        [
                            456,
                            363
                        ],
                        [
                            363,
                            420
                        ],
                        [
                            401,
                            435
                        ],
                        [
                            435,
                            288
                        ],
                        [
                            288,
                            401
                        ],
                        [
                            372,
                            383
                        ],
                        [
                            383,
                            353
                        ],
                        [
                            353,
                            372
                        ],
                        [
                            339,
                            255
                        ],
                        [
                            255,
                            249
                        ],
                        [
                            249,
                            339
                        ],
                        [
                            448,
                            261
                        ],
                        [
                            261,
                            255
                        ],
                        [
                            255,
                            448
                        ],
                        [
                            133,
                            243
                        ],
                        [
                            243,
                            190
                        ],
                        [
                            190,
                            133
                        ],
                        [
                            133,
                            155
                        ],
                        [
                            155,
                            112
                        ],
                        [
                            112,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            247
                        ],
                        [
                            247,
                            33
                        ],
                        [
                            33,
                            130
                        ],
                        [
                            130,
                            25
                        ],
                        [
                            25,
                            33
                        ],
                        [
                            398,
                            384
                        ],
                        [
                            384,
                            286
                        ],
                        [
                            286,
                            398
                        ],
                        [
                            362,
                            398
                        ],
                        [
                            398,
                            414
                        ],
                        [
                            414,
                            362
                        ],
                        [
                            362,
                            463
                        ],
                        [
                            463,
                            341
                        ],
                        [
                            341,
                            362
                        ],
                        [
                            263,
                            359
                        ],
                        [
                            359,
                            467
                        ],
                        [
                            467,
                            263
                        ],
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            255
                        ],
                        [
                            255,
                            263
                        ],
                        [
                            466,
                            467
                        ],
                        [
                            467,
                            260
                        ],
                        [
                            260,
                            466
                        ],
                        [
                            75,
                            60
                        ],
                        [
                            60,
                            166
                        ],
                        [
                            166,
                            75
                        ],
                        [
                            238,
                            239
                        ],
                        [
                            239,
                            79
                        ],
                        [
                            79,
                            238
                        ],
                        [
                            162,
                            127
                        ],
                        [
                            127,
                            139
                        ],
                        [
                            139,
                            162
                        ],
                        [
                            72,
                            11
                        ],
                        [
                            11,
                            37
                        ],
                        [
                            37,
                            72
                        ],
                        [
                            121,
                            232
                        ],
                        [
                            232,
                            120
                        ],
                        [
                            120,
                            121
                        ],
                        [
                            73,
                            72
                        ],
                        [
                            72,
                            39
                        ],
                        [
                            39,
                            73
                        ],
                        [
                            114,
                            128
                        ],
                        [
                            128,
                            47
                        ],
                        [
                            47,
                            114
                        ],
                        [
                            233,
                            232
                        ],
                        [
                            232,
                            128
                        ],
                        [
                            128,
                            233
                        ],
                        [
                            103,
                            104
                        ],
                        [
                            104,
                            67
                        ],
                        [
                            67,
                            103
                        ],
                        [
                            152,
                            175
                        ],
                        [
                            175,
                            148
                        ],
                        [
                            148,
                            152
                        ],
                        [
                            119,
                            118
                        ],
                        [
                            118,
                            101
                        ],
                        [
                            101,
                            119
                        ],
                        [
                            74,
                            73
                        ],
                        [
                            73,
                            40
                        ],
                        [
                            40,
                            74
                        ],
                        [
                            107,
                            9
                        ],
                        [
                            9,
                            108
                        ],
                        [
                            108,
                            107
                        ],
                        [
                            49,
                            48
                        ],
                        [
                            48,
                            131
                        ],
                        [
                            131,
                            49
                        ],
                        [
                            32,
                            194
                        ],
                        [
                            194,
                            211
                        ],
                        [
                            211,
                            32
                        ],
                        [
                            184,
                            74
                        ],
                        [
                            74,
                            185
                        ],
                        [
                            185,
                            184
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            183
                        ],
                        [
                            183,
                            191
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            186
                        ],
                        [
                            186,
                            185
                        ],
                        [
                            119,
                            230
                        ],
                        [
                            230,
                            118
                        ],
                        [
                            118,
                            119
                        ],
                        [
                            210,
                            202
                        ],
                        [
                            202,
                            214
                        ],
                        [
                            214,
                            210
                        ],
                        [
                            84,
                            83
                        ],
                        [
                            83,
                            17
                        ],
                        [
                            17,
                            84
                        ],
                        [
                            77,
                            76
                        ],
                        [
                            76,
                            146
                        ],
                        [
                            146,
                            77
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            30
                        ],
                        [
                            30,
                            161
                        ],
                        [
                            190,
                            56
                        ],
                        [
                            56,
                            173
                        ],
                        [
                            173,
                            190
                        ],
                        [
                            182,
                            106
                        ],
                        [
                            106,
                            194
                        ],
                        [
                            194,
                            182
                        ],
                        [
                            138,
                            135
                        ],
                        [
                            135,
                            192
                        ],
                        [
                            192,
                            138
                        ],
                        [
                            129,
                            203
                        ],
                        [
                            203,
                            98
                        ],
                        [
                            98,
                            129
                        ],
                        [
                            54,
                            21
                        ],
                        [
                            21,
                            68
                        ],
                        [
                            68,
                            54
                        ],
                        [
                            5,
                            51
                        ],
                        [
                            51,
                            4
                        ],
                        [
                            4,
                            5
                        ],
                        [
                            145,
                            144
                        ],
                        [
                            144,
                            23
                        ],
                        [
                            23,
                            145
                        ],
                        [
                            90,
                            77
                        ],
                        [
                            77,
                            91
                        ],
                        [
                            91,
                            90
                        ],
                        [
                            207,
                            205
                        ],
                        [
                            205,
                            187
                        ],
                        [
                            187,
                            207
                        ],
                        [
                            83,
                            201
                        ],
                        [
                            201,
                            18
                        ],
                        [
                            18,
                            83
                        ],
                        [
                            181,
                            91
                        ],
                        [
                            91,
                            182
                        ],
                        [
                            182,
                            181
                        ],
                        [
                            180,
                            90
                        ],
                        [
                            90,
                            181
                        ],
                        [
                            181,
                            180
                        ],
                        [
                            16,
                            85
                        ],
                        [
                            85,
                            17
                        ],
                        [
                            17,
                            16
                        ],
                        [
                            205,
                            206
                        ],
                        [
                            206,
                            36
                        ],
                        [
                            36,
                            205
                        ],
                        [
                            176,
                            148
                        ],
                        [
                            148,
                            140
                        ],
                        [
                            140,
                            176
                        ],
                        [
                            165,
                            92
                        ],
                        [
                            92,
                            39
                        ],
                        [
                            39,
                            165
                        ],
                        [
                            245,
                            193
                        ],
                        [
                            193,
                            244
                        ],
                        [
                            244,
                            245
                        ],
                        [
                            27,
                            159
                        ],
                        [
                            159,
                            28
                        ],
                        [
                            28,
                            27
                        ],
                        [
                            30,
                            247
                        ],
                        [
                            247,
                            161
                        ],
                        [
                            161,
                            30
                        ],
                        [
                            174,
                            236
                        ],
                        [
                            236,
                            196
                        ],
                        [
                            196,
                            174
                        ],
                        [
                            103,
                            54
                        ],
                        [
                            54,
                            104
                        ],
                        [
                            104,
                            103
                        ],
                        [
                            55,
                            193
                        ],
                        [
                            193,
                            8
                        ],
                        [
                            8,
                            55
                        ],
                        [
                            111,
                            117
                        ],
                        [
                            117,
                            31
                        ],
                        [
                            31,
                            111
                        ],
                        [
                            221,
                            189
                        ],
                        [
                            189,
                            55
                        ],
                        [
                            55,
                            221
                        ],
                        [
                            240,
                            98
                        ],
                        [
                            98,
                            99
                        ],
                        [
                            99,
                            240
                        ],
                        [
                            142,
                            126
                        ],
                        [
                            126,
                            100
                        ],
                        [
                            100,
                            142
                        ],
                        [
                            219,
                            166
                        ],
                        [
                            166,
                            218
                        ],
                        [
                            218,
                            219
                        ],
                        [
                            112,
                            155
                        ],
                        [
                            155,
                            26
                        ],
                        [
                            26,
                            112
                        ],
                        [
                            198,
                            209
                        ],
                        [
                            209,
                            131
                        ],
                        [
                            131,
                            198
                        ],
                        [
                            169,
                            135
                        ],
                        [
                            135,
                            150
                        ],
                        [
                            150,
                            169
                        ],
                        [
                            114,
                            47
                        ],
                        [
                            47,
                            217
                        ],
                        [
                            217,
                            114
                        ],
                        [
                            224,
                            223
                        ],
                        [
                            223,
                            53
                        ],
                        [
                            53,
                            224
                        ],
                        [
                            220,
                            45
                        ],
                        [
                            45,
                            134
                        ],
                        [
                            134,
                            220
                        ],
                        [
                            32,
                            211
                        ],
                        [
                            211,
                            140
                        ],
                        [
                            140,
                            32
                        ],
                        [
                            109,
                            67
                        ],
                        [
                            67,
                            108
                        ],
                        [
                            108,
                            109
                        ],
                        [
                            146,
                            43
                        ],
                        [
                            43,
                            91
                        ],
                        [
                            91,
                            146
                        ],
                        [
                            231,
                            230
                        ],
                        [
                            230,
                            120
                        ],
                        [
                            120,
                            231
                        ],
                        [
                            113,
                            226
                        ],
                        [
                            226,
                            247
                        ],
                        [
                            247,
                            113
                        ],
                        [
                            105,
                            63
                        ],
                        [
                            63,
                            52
                        ],
                        [
                            52,
                            105
                        ],
                        [
                            241,
                            238
                        ],
                        [
                            238,
                            242
                        ],
                        [
                            242,
                            241
                        ],
                        [
                            124,
                            46
                        ],
                        [
                            46,
                            156
                        ],
                        [
                            156,
                            124
                        ],
                        [
                            95,
                            78
                        ],
                        [
                            78,
                            96
                        ],
                        [
                            96,
                            95
                        ],
                        [
                            70,
                            46
                        ],
                        [
                            46,
                            63
                        ],
                        [
                            63,
                            70
                        ],
                        [
                            116,
                            143
                        ],
                        [
                            143,
                            227
                        ],
                        [
                            227,
                            116
                        ],
                        [
                            116,
                            123
                        ],
                        [
                            123,
                            111
                        ],
                        [
                            111,
                            116
                        ],
                        [
                            1,
                            44
                        ],
                        [
                            44,
                            19
                        ],
                        [
                            19,
                            1
                        ],
                        [
                            3,
                            236
                        ],
                        [
                            236,
                            51
                        ],
                        [
                            51,
                            3
                        ],
                        [
                            207,
                            216
                        ],
                        [
                            216,
                            205
                        ],
                        [
                            205,
                            207
                        ],
                        [
                            26,
                            154
                        ],
                        [
                            154,
                            22
                        ],
                        [
                            22,
                            26
                        ],
                        [
                            165,
                            39
                        ],
                        [
                            39,
                            167
                        ],
                        [
                            167,
                            165
                        ],
                        [
                            199,
                            200
                        ],
                        [
                            200,
                            208
                        ],
                        [
                            208,
                            199
                        ],
                        [
                            101,
                            36
                        ],
                        [
                            36,
                            100
                        ],
                        [
                            100,
                            101
                        ],
                        [
                            43,
                            57
                        ],
                        [
                            57,
                            202
                        ],
                        [
                            202,
                            43
                        ],
                        [
                            242,
                            20
                        ],
                        [
                            20,
                            99
                        ],
                        [
                            99,
                            242
                        ],
                        [
                            56,
                            28
                        ],
                        [
                            28,
                            157
                        ],
                        [
                            157,
                            56
                        ],
                        [
                            124,
                            35
                        ],
                        [
                            35,
                            113
                        ],
                        [
                            113,
                            124
                        ],
                        [
                            29,
                            160
                        ],
                        [
                            160,
                            27
                        ],
                        [
                            27,
                            29
                        ],
                        [
                            211,
                            204
                        ],
                        [
                            204,
                            210
                        ],
                        [
                            210,
                            211
                        ],
                        [
                            124,
                            113
                        ],
                        [
                            113,
                            46
                        ],
                        [
                            46,
                            124
                        ],
                        [
                            106,
                            43
                        ],
                        [
                            43,
                            204
                        ],
                        [
                            204,
                            106
                        ],
                        [
                            96,
                            62
                        ],
                        [
                            62,
                            77
                        ],
                        [
                            77,
                            96
                        ],
                        [
                            227,
                            137
                        ],
                        [
                            137,
                            116
                        ],
                        [
                            116,
                            227
                        ],
                        [
                            73,
                            41
                        ],
                        [
                            41,
                            72
                        ],
                        [
                            72,
                            73
                        ],
                        [
                            36,
                            203
                        ],
                        [
                            203,
                            142
                        ],
                        [
                            142,
                            36
                        ],
                        [
                            235,
                            64
                        ],
                        [
                            64,
                            240
                        ],
                        [
                            240,
                            235
                        ],
                        [
                            48,
                            49
                        ],
                        [
                            49,
                            64
                        ],
                        [
                            64,
                            48
                        ],
                        [
                            42,
                            41
                        ],
                        [
                            41,
                            74
                        ],
                        [
                            74,
                            42
                        ],
                        [
                            214,
                            212
                        ],
                        [
                            212,
                            207
                        ],
                        [
                            207,
                            214
                        ],
                        [
                            183,
                            42
                        ],
                        [
                            42,
                            184
                        ],
                        [
                            184,
                            183
                        ],
                        [
                            210,
                            169
                        ],
                        [
                            169,
                            211
                        ],
                        [
                            211,
                            210
                        ],
                        [
                            140,
                            170
                        ],
                        [
                            170,
                            176
                        ],
                        [
                            176,
                            140
                        ],
                        [
                            104,
                            105
                        ],
                        [
                            105,
                            69
                        ],
                        [
                            69,
                            104
                        ],
                        [
                            193,
                            122
                        ],
                        [
                            122,
                            168
                        ],
                        [
                            168,
                            193
                        ],
                        [
                            50,
                            123
                        ],
                        [
                            123,
                            187
                        ],
                        [
                            187,
                            50
                        ],
                        [
                            89,
                            96
                        ],
                        [
                            96,
                            90
                        ],
                        [
                            90,
                            89
                        ],
                        [
                            66,
                            65
                        ],
                        [
                            65,
                            107
                        ],
                        [
                            107,
                            66
                        ],
                        [
                            179,
                            89
                        ],
                        [
                            89,
                            180
                        ],
                        [
                            180,
                            179
                        ],
                        [
                            119,
                            101
                        ],
                        [
                            101,
                            120
                        ],
                        [
                            120,
                            119
                        ],
                        [
                            68,
                            63
                        ],
                        [
                            63,
                            104
                        ],
                        [
                            104,
                            68
                        ],
                        [
                            234,
                            93
                        ],
                        [
                            93,
                            227
                        ],
                        [
                            227,
                            234
                        ],
                        [
                            16,
                            15
                        ],
                        [
                            15,
                            85
                        ],
                        [
                            85,
                            16
                        ],
                        [
                            209,
                            129
                        ],
                        [
                            129,
                            49
                        ],
                        [
                            49,
                            209
                        ],
                        [
                            15,
                            14
                        ],
                        [
                            14,
                            86
                        ],
                        [
                            86,
                            15
                        ],
                        [
                            107,
                            55
                        ],
                        [
                            55,
                            9
                        ],
                        [
                            9,
                            107
                        ],
                        [
                            120,
                            100
                        ],
                        [
                            100,
                            121
                        ],
                        [
                            121,
                            120
                        ],
                        [
                            153,
                            145
                        ],
                        [
                            145,
                            22
                        ],
                        [
                            22,
                            153
                        ],
                        [
                            178,
                            88
                        ],
                        [
                            88,
                            179
                        ],
                        [
                            179,
                            178
                        ],
                        [
                            197,
                            6
                        ],
                        [
                            6,
                            196
                        ],
                        [
                            196,
                            197
                        ],
                        [
                            89,
                            88
                        ],
                        [
                            88,
                            96
                        ],
                        [
                            96,
                            89
                        ],
                        [
                            135,
                            138
                        ],
                        [
                            138,
                            136
                        ],
                        [
                            136,
                            135
                        ],
                        [
                            138,
                            215
                        ],
                        [
                            215,
                            172
                        ],
                        [
                            172,
                            138
                        ],
                        [
                            218,
                            115
                        ],
                        [
                            115,
                            219
                        ],
                        [
                            219,
                            218
                        ],
                        [
                            41,
                            42
                        ],
                        [
                            42,
                            81
                        ],
                        [
                            81,
                            41
                        ],
                        [
                            5,
                            195
                        ],
                        [
                            195,
                            51
                        ],
                        [
                            51,
                            5
                        ],
                        [
                            57,
                            43
                        ],
                        [
                            43,
                            61
                        ],
                        [
                            61,
                            57
                        ],
                        [
                            208,
                            171
                        ],
                        [
                            171,
                            199
                        ],
                        [
                            199,
                            208
                        ],
                        [
                            41,
                            81
                        ],
                        [
                            81,
                            38
                        ],
                        [
                            38,
                            41
                        ],
                        [
                            224,
                            53
                        ],
                        [
                            53,
                            225
                        ],
                        [
                            225,
                            224
                        ],
                        [
                            24,
                            144
                        ],
                        [
                            144,
                            110
                        ],
                        [
                            110,
                            24
                        ],
                        [
                            105,
                            52
                        ],
                        [
                            52,
                            66
                        ],
                        [
                            66,
                            105
                        ],
                        [
                            118,
                            229
                        ],
                        [
                            229,
                            117
                        ],
                        [
                            117,
                            118
                        ],
                        [
                            227,
                            34
                        ],
                        [
                            34,
                            234
                        ],
                        [
                            234,
                            227
                        ],
                        [
                            66,
                            107
                        ],
                        [
                            107,
                            69
                        ],
                        [
                            69,
                            66
                        ],
                        [
                            10,
                            109
                        ],
                        [
                            109,
                            151
                        ],
                        [
                            151,
                            10
                        ],
                        [
                            219,
                            48
                        ],
                        [
                            48,
                            235
                        ],
                        [
                            235,
                            219
                        ],
                        [
                            183,
                            62
                        ],
                        [
                            62,
                            191
                        ],
                        [
                            191,
                            183
                        ],
                        [
                            142,
                            129
                        ],
                        [
                            129,
                            126
                        ],
                        [
                            126,
                            142
                        ],
                        [
                            116,
                            111
                        ],
                        [
                            111,
                            143
                        ],
                        [
                            143,
                            116
                        ],
                        [
                            118,
                            117
                        ],
                        [
                            117,
                            50
                        ],
                        [
                            50,
                            118
                        ],
                        [
                            223,
                            222
                        ],
                        [
                            222,
                            52
                        ],
                        [
                            52,
                            223
                        ],
                        [
                            94,
                            19
                        ],
                        [
                            19,
                            141
                        ],
                        [
                            141,
                            94
                        ],
                        [
                            222,
                            221
                        ],
                        [
                            221,
                            65
                        ],
                        [
                            65,
                            222
                        ],
                        [
                            196,
                            3
                        ],
                        [
                            3,
                            197
                        ],
                        [
                            197,
                            196
                        ],
                        [
                            45,
                            220
                        ],
                        [
                            220,
                            44
                        ],
                        [
                            44,
                            45
                        ],
                        [
                            156,
                            70
                        ],
                        [
                            70,
                            139
                        ],
                        [
                            139,
                            156
                        ],
                        [
                            188,
                            122
                        ],
                        [
                            122,
                            245
                        ],
                        [
                            245,
                            188
                        ],
                        [
                            139,
                            71
                        ],
                        [
                            71,
                            162
                        ],
                        [
                            162,
                            139
                        ],
                        [
                            149,
                            170
                        ],
                        [
                            170,
                            150
                        ],
                        [
                            150,
                            149
                        ],
                        [
                            122,
                            188
                        ],
                        [
                            188,
                            196
                        ],
                        [
                            196,
                            122
                        ],
                        [
                            206,
                            216
                        ],
                        [
                            216,
                            92
                        ],
                        [
                            92,
                            206
                        ],
                        [
                            164,
                            2
                        ],
                        [
                            2,
                            167
                        ],
                        [
                            167,
                            164
                        ],
                        [
                            242,
                            141
                        ],
                        [
                            141,
                            241
                        ],
                        [
                            241,
                            242
                        ],
                        [
                            0,
                            164
                        ],
                        [
                            164,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            11,
                            72
                        ],
                        [
                            72,
                            12
                        ],
                        [
                            12,
                            11
                        ],
                        [
                            12,
                            38
                        ],
                        [
                            38,
                            13
                        ],
                        [
                            13,
                            12
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            71
                        ],
                        [
                            71,
                            70
                        ],
                        [
                            31,
                            226
                        ],
                        [
                            226,
                            111
                        ],
                        [
                            111,
                            31
                        ],
                        [
                            36,
                            101
                        ],
                        [
                            101,
                            205
                        ],
                        [
                            205,
                            36
                        ],
                        [
                            203,
                            206
                        ],
                        [
                            206,
                            165
                        ],
                        [
                            165,
                            203
                        ],
                        [
                            126,
                            209
                        ],
                        [
                            209,
                            217
                        ],
                        [
                            217,
                            126
                        ],
                        [
                            98,
                            165
                        ],
                        [
                            165,
                            97
                        ],
                        [
                            97,
                            98
                        ],
                        [
                            237,
                            220
                        ],
                        [
                            220,
                            218
                        ],
                        [
                            218,
                            237
                        ],
                        [
                            237,
                            239
                        ],
                        [
                            239,
                            241
                        ],
                        [
                            241,
                            237
                        ],
                        [
                            210,
                            214
                        ],
                        [
                            214,
                            169
                        ],
                        [
                            169,
                            210
                        ],
                        [
                            140,
                            171
                        ],
                        [
                            171,
                            32
                        ],
                        [
                            32,
                            140
                        ],
                        [
                            241,
                            125
                        ],
                        [
                            125,
                            237
                        ],
                        [
                            237,
                            241
                        ],
                        [
                            179,
                            86
                        ],
                        [
                            86,
                            178
                        ],
                        [
                            178,
                            179
                        ],
                        [
                            180,
                            85
                        ],
                        [
                            85,
                            179
                        ],
                        [
                            179,
                            180
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            180
                        ],
                        [
                            180,
                            181
                        ],
                        [
                            182,
                            83
                        ],
                        [
                            83,
                            181
                        ],
                        [
                            181,
                            182
                        ],
                        [
                            194,
                            201
                        ],
                        [
                            201,
                            182
                        ],
                        [
                            182,
                            194
                        ],
                        [
                            177,
                            137
                        ],
                        [
                            137,
                            132
                        ],
                        [
                            132,
                            177
                        ],
                        [
                            184,
                            76
                        ],
                        [
                            76,
                            183
                        ],
                        [
                            183,
                            184
                        ],
                        [
                            185,
                            61
                        ],
                        [
                            61,
                            184
                        ],
                        [
                            184,
                            185
                        ],
                        [
                            186,
                            57
                        ],
                        [
                            57,
                            185
                        ],
                        [
                            185,
                            186
                        ],
                        [
                            216,
                            212
                        ],
                        [
                            212,
                            186
                        ],
                        [
                            186,
                            216
                        ],
                        [
                            192,
                            214
                        ],
                        [
                            214,
                            187
                        ],
                        [
                            187,
                            192
                        ],
                        [
                            139,
                            34
                        ],
                        [
                            34,
                            156
                        ],
                        [
                            156,
                            139
                        ],
                        [
                            218,
                            79
                        ],
                        [
                            79,
                            237
                        ],
                        [
                            237,
                            218
                        ],
                        [
                            147,
                            123
                        ],
                        [
                            123,
                            177
                        ],
                        [
                            177,
                            147
                        ],
                        [
                            45,
                            44
                        ],
                        [
                            44,
                            4
                        ],
                        [
                            4,
                            45
                        ],
                        [
                            208,
                            201
                        ],
                        [
                            201,
                            32
                        ],
                        [
                            32,
                            208
                        ],
                        [
                            98,
                            64
                        ],
                        [
                            64,
                            129
                        ],
                        [
                            129,
                            98
                        ],
                        [
                            192,
                            213
                        ],
                        [
                            213,
                            138
                        ],
                        [
                            138,
                            192
                        ],
                        [
                            235,
                            59
                        ],
                        [
                            59,
                            219
                        ],
                        [
                            219,
                            235
                        ],
                        [
                            141,
                            242
                        ],
                        [
                            242,
                            97
                        ],
                        [
                            97,
                            141
                        ],
                        [
                            97,
                            2
                        ],
                        [
                            2,
                            141
                        ],
                        [
                            141,
                            97
                        ],
                        [
                            240,
                            75
                        ],
                        [
                            75,
                            235
                        ],
                        [
                            235,
                            240
                        ],
                        [
                            229,
                            24
                        ],
                        [
                            24,
                            228
                        ],
                        [
                            228,
                            229
                        ],
                        [
                            31,
                            25
                        ],
                        [
                            25,
                            226
                        ],
                        [
                            226,
                            31
                        ],
                        [
                            230,
                            23
                        ],
                        [
                            23,
                            229
                        ],
                        [
                            229,
                            230
                        ],
                        [
                            231,
                            22
                        ],
                        [
                            22,
                            230
                        ],
                        [
                            230,
                            231
                        ],
                        [
                            232,
                            26
                        ],
                        [
                            26,
                            231
                        ],
                        [
                            231,
                            232
                        ],
                        [
                            233,
                            112
                        ],
                        [
                            112,
                            232
                        ],
                        [
                            232,
                            233
                        ],
                        [
                            244,
                            189
                        ],
                        [
                            189,
                            243
                        ],
                        [
                            243,
                            244
                        ],
                        [
                            189,
                            221
                        ],
                        [
                            221,
                            190
                        ],
                        [
                            190,
                            189
                        ],
                        [
                            222,
                            28
                        ],
                        [
                            28,
                            221
                        ],
                        [
                            221,
                            222
                        ],
                        [
                            223,
                            27
                        ],
                        [
                            27,
                            222
                        ],
                        [
                            222,
                            223
                        ],
                        [
                            224,
                            29
                        ],
                        [
                            29,
                            223
                        ],
                        [
                            223,
                            224
                        ],
                        [
                            225,
                            30
                        ],
                        [
                            30,
                            224
                        ],
                        [
                            224,
                            225
                        ],
                        [
                            113,
                            247
                        ],
                        [
                            247,
                            225
                        ],
                        [
                            225,
                            113
                        ],
                        [
                            99,
                            60
                        ],
                        [
                            60,
                            240
                        ],
                        [
                            240,
                            99
                        ],
                        [
                            213,
                            147
                        ],
                        [
                            147,
                            215
                        ],
                        [
                            215,
                            213
                        ],
                        [
                            60,
                            20
                        ],
                        [
                            20,
                            166
                        ],
                        [
                            166,
                            60
                        ],
                        [
                            192,
                            187
                        ],
                        [
                            187,
                            213
                        ],
                        [
                            213,
                            192
                        ],
                        [
                            243,
                            112
                        ],
                        [
                            112,
                            244
                        ],
                        [
                            244,
                            243
                        ],
                        [
                            244,
                            233
                        ],
                        [
                            233,
                            245
                        ],
                        [
                            245,
                            244
                        ],
                        [
                            245,
                            128
                        ],
                        [
                            128,
                            188
                        ],
                        [
                            188,
                            245
                        ],
                        [
                            188,
                            114
                        ],
                        [
                            114,
                            174
                        ],
                        [
                            174,
                            188
                        ],
                        [
                            134,
                            131
                        ],
                        [
                            131,
                            220
                        ],
                        [
                            220,
                            134
                        ],
                        [
                            174,
                            217
                        ],
                        [
                            217,
                            236
                        ],
                        [
                            236,
                            174
                        ],
                        [
                            236,
                            198
                        ],
                        [
                            198,
                            134
                        ],
                        [
                            134,
                            236
                        ],
                        [
                            215,
                            177
                        ],
                        [
                            177,
                            58
                        ],
                        [
                            58,
                            215
                        ],
                        [
                            156,
                            143
                        ],
                        [
                            143,
                            124
                        ],
                        [
                            124,
                            156
                        ],
                        [
                            25,
                            110
                        ],
                        [
                            110,
                            7
                        ],
                        [
                            7,
                            25
                        ],
                        [
                            31,
                            228
                        ],
                        [
                            228,
                            25
                        ],
                        [
                            25,
                            31
                        ],
                        [
                            264,
                            356
                        ],
                        [
                            356,
                            368
                        ],
                        [
                            368,
                            264
                        ],
                        [
                            0,
                            11
                        ],
                        [
                            11,
                            267
                        ],
                        [
                            267,
                            0
                        ],
                        [
                            451,
                            452
                        ],
                        [
                            452,
                            349
                        ],
                        [
                            349,
                            451
                        ],
                        [
                            267,
                            302
                        ],
                        [
                            302,
                            269
                        ],
                        [
                            269,
                            267
                        ],
                        [
                            350,
                            357
                        ],
                        [
                            357,
                            277
                        ],
                        [
                            277,
                            350
                        ],
                        [
                            350,
                            452
                        ],
                        [
                            452,
                            357
                        ],
                        [
                            357,
                            350
                        ],
                        [
                            299,
                            333
                        ],
                        [
                            333,
                            297
                        ],
                        [
                            297,
                            299
                        ],
                        [
                            396,
                            175
                        ],
                        [
                            175,
                            377
                        ],
                        [
                            377,
                            396
                        ],
                        [
                            280,
                            347
                        ],
                        [
                            347,
                            330
                        ],
                        [
                            330,
                            280
                        ],
                        [
                            269,
                            303
                        ],
                        [
                            303,
                            270
                        ],
                        [
                            270,
                            269
                        ],
                        [
                            151,
                            9
                        ],
                        [
                            9,
                            337
                        ],
                        [
                            337,
                            151
                        ],
                        [
                            344,
                            278
                        ],
                        [
                            278,
                            360
                        ],
                        [
                            360,
                            344
                        ],
                        [
                            424,
                            418
                        ],
                        [
                            418,
                            431
                        ],
                        [
                            431,
                            424
                        ],
                        [
                            270,
                            304
                        ],
                        [
                            304,
                            409
                        ],
                        [
                            409,
                            270
                        ],
                        [
                            272,
                            310
                        ],
                        [
                            310,
                            407
                        ],
                        [
                            407,
                            272
                        ],
                        [
                            322,
                            270
                        ],
                        [
                            270,
                            410
                        ],
                        [
                            410,
                            322
                        ],
                        [
                            449,
                            450
                        ],
                        [
                            450,
                            347
                        ],
                        [
                            347,
                            449
                        ],
                        [
                            432,
                            422
                        ],
                        [
                            422,
                            434
                        ],
                        [
                            434,
                            432
                        ],
                        [
                            18,
                            313
                        ],
                        [
                            313,
                            17
                        ],
                        [
                            17,
                            18
                        ],
                        [
                            291,
                            306
                        ],
                        [
                            306,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            259,
                            387
                        ],
                        [
                            387,
                            260
                        ],
                        [
                            260,
                            259
                        ],
                        [
                            424,
                            335
                        ],
                        [
                            335,
                            418
                        ],
                        [
                            418,
                            424
                        ],
                        [
                            434,
                            364
                        ],
                        [
                            364,
                            416
                        ],
                        [
                            416,
                            434
                        ],
                        [
                            391,
                            423
                        ],
                        [
                            423,
                            327
                        ],
                        [
                            327,
                            391
                        ],
                        [
                            301,
                            251
                        ],
                        [
                            251,
                            298
                        ],
                        [
                            298,
                            301
                        ],
                        [
                            275,
                            281
                        ],
                        [
                            281,
                            4
                        ],
                        [
                            4,
                            275
                        ],
                        [
                            254,
                            373
                        ],
                        [
                            373,
                            253
                        ],
                        [
                            253,
                            254
                        ],
                        [
                            375,
                            307
                        ],
                        [
                            307,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            280,
                            425
                        ],
                        [
                            425,
                            411
                        ],
                        [
                            411,
                            280
                        ],
                        [
                            200,
                            421
                        ],
                        [
                            421,
                            18
                        ],
                        [
                            18,
                            200
                        ],
                        [
                            335,
                            321
                        ],
                        [
                            321,
                            406
                        ],
                        [
                            406,
                            335
                        ],
                        [
                            321,
                            320
                        ],
                        [
                            320,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            314,
                            315
                        ],
                        [
                            315,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            423,
                            426
                        ],
                        [
                            426,
                            266
                        ],
                        [
                            266,
                            423
                        ],
                        [
                            396,
                            377
                        ],
                        [
                            377,
                            369
                        ],
                        [
                            369,
                            396
                        ],
                        [
                            270,
                            322
                        ],
                        [
                            322,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            413,
                            417
                        ],
                        [
                            417,
                            464
                        ],
                        [
                            464,
                            413
                        ],
                        [
                            385,
                            386
                        ],
                        [
                            386,
                            258
                        ],
                        [
                            258,
                            385
                        ],
                        [
                            248,
                            456
                        ],
                        [
                            456,
                            419
                        ],
                        [
                            419,
                            248
                        ],
                        [
                            298,
                            284
                        ],
                        [
                            284,
                            333
                        ],
                        [
                            333,
                            298
                        ],
                        [
                            168,
                            417
                        ],
                        [
                            417,
                            8
                        ],
                        [
                            8,
                            168
                        ],
                        [
                            448,
                            346
                        ],
                        [
                            346,
                            261
                        ],
                        [
                            261,
                            448
                        ],
                        [
                            417,
                            413
                        ],
                        [
                            413,
                            285
                        ],
                        [
                            285,
                            417
                        ],
                        [
                            326,
                            327
                        ],
                        [
                            327,
                            328
                        ],
                        [
                            328,
                            326
                        ],
                        [
                            277,
                            355
                        ],
                        [
                            355,
                            329
                        ],
                        [
                            329,
                            277
                        ],
                        [
                            309,
                            392
                        ],
                        [
                            392,
                            438
                        ],
                        [
                            438,
                            309
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            256
                        ],
                        [
                            256,
                            381
                        ],
                        [
                            279,
                            429
                        ],
                        [
                            429,
                            360
                        ],
                        [
                            360,
                            279
                        ],
                        [
                            365,
                            364
                        ],
                        [
                            364,
                            379
                        ],
                        [
                            379,
                            365
                        ],
                        [
                            355,
                            277
                        ],
                        [
                            277,
                            437
                        ],
                        [
                            437,
                            355
                        ],
                        [
                            282,
                            443
                        ],
                        [
                            443,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            281,
                            275
                        ],
                        [
                            275,
                            363
                        ],
                        [
                            363,
                            281
                        ],
                        [
                            395,
                            431
                        ],
                        [
                            431,
                            369
                        ],
                        [
                            369,
                            395
                        ],
                        [
                            299,
                            297
                        ],
                        [
                            297,
                            337
                        ],
                        [
                            337,
                            299
                        ],
                        [
                            335,
                            273
                        ],
                        [
                            273,
                            321
                        ],
                        [
                            321,
                            335
                        ],
                        [
                            348,
                            450
                        ],
                        [
                            450,
                            349
                        ],
                        [
                            349,
                            348
                        ],
                        [
                            359,
                            446
                        ],
                        [
                            446,
                            467
                        ],
                        [
                            467,
                            359
                        ],
                        [
                            283,
                            293
                        ],
                        [
                            293,
                            282
                        ],
                        [
                            282,
                            283
                        ],
                        [
                            250,
                            458
                        ],
                        [
                            458,
                            462
                        ],
                        [
                            462,
                            250
                        ],
                        [
                            300,
                            276
                        ],
                        [
                            276,
                            383
                        ],
                        [
                            383,
                            300
                        ],
                        [
                            292,
                            308
                        ],
                        [
                            308,
                            325
                        ],
                        [
                            325,
                            292
                        ],
                        [
                            283,
                            276
                        ],
                        [
                            276,
                            293
                        ],
                        [
                            293,
                            283
                        ],
                        [
                            264,
                            372
                        ],
                        [
                            372,
                            447
                        ],
                        [
                            447,
                            264
                        ],
                        [
                            346,
                            352
                        ],
                        [
                            352,
                            340
                        ],
                        [
                            340,
                            346
                        ],
                        [
                            354,
                            274
                        ],
                        [
                            274,
                            19
                        ],
                        [
                            19,
                            354
                        ],
                        [
                            363,
                            456
                        ],
                        [
                            456,
                            281
                        ],
                        [
                            281,
                            363
                        ],
                        [
                            426,
                            436
                        ],
                        [
                            436,
                            425
                        ],
                        [
                            425,
                            426
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            252
                        ],
                        [
                            252,
                            380
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            393
                        ],
                        [
                            393,
                            267
                        ],
                        [
                            421,
                            200
                        ],
                        [
                            200,
                            428
                        ],
                        [
                            428,
                            421
                        ],
                        [
                            371,
                            266
                        ],
                        [
                            266,
                            329
                        ],
                        [
                            329,
                            371
                        ],
                        [
                            432,
                            287
                        ],
                        [
                            287,
                            422
                        ],
                        [
                            422,
                            432
                        ],
                        [
                            290,
                            250
                        ],
                        [
                            250,
                            328
                        ],
                        [
                            328,
                            290
                        ],
                        [
                            385,
                            258
                        ],
                        [
                            258,
                            384
                        ],
                        [
                            384,
                            385
                        ],
                        [
                            446,
                            265
                        ],
                        [
                            265,
                            342
                        ],
                        [
                            342,
                            446
                        ],
                        [
                            386,
                            387
                        ],
                        [
                            387,
                            257
                        ],
                        [
                            257,
                            386
                        ],
                        [
                            422,
                            424
                        ],
                        [
                            424,
                            430
                        ],
                        [
                            430,
                            422
                        ],
                        [
                            445,
                            342
                        ],
                        [
                            342,
                            276
                        ],
                        [
                            276,
                            445
                        ],
                        [
                            422,
                            273
                        ],
                        [
                            273,
                            424
                        ],
                        [
                            424,
                            422
                        ],
                        [
                            306,
                            292
                        ],
                        [
                            292,
                            307
                        ],
                        [
                            307,
                            306
                        ],
                        [
                            352,
                            366
                        ],
                        [
                            366,
                            345
                        ],
                        [
                            345,
                            352
                        ],
                        [
                            268,
                            271
                        ],
                        [
                            271,
                            302
                        ],
                        [
                            302,
                            268
                        ],
                        [
                            358,
                            423
                        ],
                        [
                            423,
                            371
                        ],
                        [
                            371,
                            358
                        ],
                        [
                            327,
                            294
                        ],
                        [
                            294,
                            460
                        ],
                        [
                            460,
                            327
                        ],
                        [
                            331,
                            279
                        ],
                        [
                            279,
                            294
                        ],
                        [
                            294,
                            331
                        ],
                        [
                            303,
                            271
                        ],
                        [
                            271,
                            304
                        ],
                        [
                            304,
                            303
                        ],
                        [
                            436,
                            432
                        ],
                        [
                            432,
                            427
                        ],
                        [
                            427,
                            436
                        ],
                        [
                            304,
                            272
                        ],
                        [
                            272,
                            408
                        ],
                        [
                            408,
                            304
                        ],
                        [
                            395,
                            394
                        ],
                        [
                            394,
                            431
                        ],
                        [
                            431,
                            395
                        ],
                        [
                            378,
                            395
                        ],
                        [
                            395,
                            400
                        ],
                        [
                            400,
                            378
                        ],
                        [
                            296,
                            334
                        ],
                        [
                            334,
                            299
                        ],
                        [
                            299,
                            296
                        ],
                        [
                            6,
                            351
                        ],
                        [
                            351,
                            168
                        ],
                        [
                            168,
                            6
                        ],
                        [
                            376,
                            352
                        ],
                        [
                            352,
                            411
                        ],
                        [
                            411,
                            376
                        ],
                        [
                            307,
                            325
                        ],
                        [
                            325,
                            320
                        ],
                        [
                            320,
                            307
                        ],
                        [
                            285,
                            295
                        ],
                        [
                            295,
                            336
                        ],
                        [
                            336,
                            285
                        ],
                        [
                            320,
                            319
                        ],
                        [
                            319,
                            404
                        ],
                        [
                            404,
                            320
                        ],
                        [
                            329,
                            330
                        ],
                        [
                            330,
                            349
                        ],
                        [
                            349,
                            329
                        ],
                        [
                            334,
                            293
                        ],
                        [
                            293,
                            333
                        ],
                        [
                            333,
                            334
                        ],
                        [
                            366,
                            323
                        ],
                        [
                            323,
                            447
                        ],
                        [
                            447,
                            366
                        ],
                        [
                            316,
                            15
                        ],
                        [
                            15,
                            315
                        ],
                        [
                            315,
                            316
                        ],
                        [
                            331,
                            358
                        ],
                        [
                            358,
                            279
                        ],
                        [
                            279,
                            331
                        ],
                        [
                            317,
                            14
                        ],
                        [
                            14,
                            316
                        ],
                        [
                            316,
                            317
                        ],
                        [
                            8,
                            285
                        ],
                        [
                            285,
                            9
                        ],
                        [
                            9,
                            8
                        ],
                        [
                            277,
                            329
                        ],
                        [
                            329,
                            350
                        ],
                        [
                            350,
                            277
                        ],
                        [
                            253,
                            374
                        ],
                        [
                            374,
                            252
                        ],
                        [
                            252,
                            253
                        ],
                        [
                            319,
                            318
                        ],
                        [
                            318,
                            403
                        ],
                        [
                            403,
                            319
                        ],
                        [
                            351,
                            6
                        ],
                        [
                            6,
                            419
                        ],
                        [
                            419,
                            351
                        ],
                        [
                            324,
                            318
                        ],
                        [
                            318,
                            325
                        ],
                        [
                            325,
                            324
                        ],
                        [
                            397,
                            367
                        ],
                        [
                            367,
                            365
                        ],
                        [
                            365,
                            397
                        ],
                        [
                            288,
                            435
                        ],
                        [
                            435,
                            397
                        ],
                        [
                            397,
                            288
                        ],
                        [
                            278,
                            344
                        ],
                        [
                            344,
                            439
                        ],
                        [
                            439,
                            278
                        ],
                        [
                            310,
                            272
                        ],
                        [
                            272,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            248,
                            195
                        ],
                        [
                            195,
                            281
                        ],
                        [
                            281,
                            248
                        ],
                        [
                            375,
                            273
                        ],
                        [
                            273,
                            291
                        ],
                        [
                            291,
                            375
                        ],
                        [
                            175,
                            396
                        ],
                        [
                            396,
                            199
                        ],
                        [
                            199,
                            175
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            268
                        ],
                        [
                            268,
                            312
                        ],
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            445
                        ],
                        [
                            445,
                            276
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            339
                        ],
                        [
                            339,
                            390
                        ],
                        [
                            295,
                            282
                        ],
                        [
                            282,
                            296
                        ],
                        [
                            296,
                            295
                        ],
                        [
                            448,
                            449
                        ],
                        [
                            449,
                            346
                        ],
                        [
                            346,
                            448
                        ],
                        [
                            356,
                            264
                        ],
                        [
                            264,
                            454
                        ],
                        [
                            454,
                            356
                        ],
                        [
                            337,
                            336
                        ],
                        [
                            336,
                            299
                        ],
                        [
                            299,
                            337
                        ],
                        [
                            337,
                            338
                        ],
                        [
                            338,
                            151
                        ],
                        [
                            151,
                            337
                        ],
                        [
                            294,
                            278
                        ],
                        [
                            278,
                            455
                        ],
                        [
                            455,
                            294
                        ],
                        [
                            308,
                            292
                        ],
                        [
                            292,
                            415
                        ],
                        [
                            415,
                            308
                        ],
                        [
                            429,
                            358
                        ],
                        [
                            358,
                            355
                        ],
                        [
                            355,
                            429
                        ],
                        [
                            265,
                            340
                        ],
                        [
                            340,
                            372
                        ],
                        [
                            372,
                            265
                        ],
                        [
                            352,
                            346
                        ],
                        [
                            346,
                            280
                        ],
                        [
                            280,
                            352
                        ],
                        [
                            295,
                            442
                        ],
                        [
                            442,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            354,
                            19
                        ],
                        [
                            19,
                            370
                        ],
                        [
                            370,
                            354
                        ],
                        [
                            285,
                            441
                        ],
                        [
                            441,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            195,
                            248
                        ],
                        [
                            248,
                            197
                        ],
                        [
                            197,
                            195
                        ],
                        [
                            457,
                            440
                        ],
                        [
                            440,
                            274
                        ],
                        [
                            274,
                            457
                        ],
                        [
                            301,
                            300
                        ],
                        [
                            300,
                            368
                        ],
                        [
                            368,
                            301
                        ],
                        [
                            417,
                            351
                        ],
                        [
                            351,
                            465
                        ],
                        [
                            465,
                            417
                        ],
                        [
                            251,
                            301
                        ],
                        [
                            301,
                            389
                        ],
                        [
                            389,
                            251
                        ],
                        [
                            394,
                            395
                        ],
                        [
                            395,
                            379
                        ],
                        [
                            379,
                            394
                        ],
                        [
                            399,
                            412
                        ],
                        [
                            412,
                            419
                        ],
                        [
                            419,
                            399
                        ],
                        [
                            410,
                            436
                        ],
                        [
                            436,
                            322
                        ],
                        [
                            322,
                            410
                        ],
                        [
                            326,
                            2
                        ],
                        [
                            2,
                            393
                        ],
                        [
                            393,
                            326
                        ],
                        [
                            354,
                            370
                        ],
                        [
                            370,
                            461
                        ],
                        [
                            461,
                            354
                        ],
                        [
                            393,
                            164
                        ],
                        [
                            164,
                            267
                        ],
                        [
                            267,
                            393
                        ],
                        [
                            268,
                            302
                        ],
                        [
                            302,
                            12
                        ],
                        [
                            12,
                            268
                        ],
                        [
                            312,
                            268
                        ],
                        [
                            268,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            298,
                            293
                        ],
                        [
                            293,
                            301
                        ],
                        [
                            301,
                            298
                        ],
                        [
                            265,
                            446
                        ],
                        [
                            446,
                            340
                        ],
                        [
                            340,
                            265
                        ],
                        [
                            280,
                            330
                        ],
                        [
                            330,
                            425
                        ],
                        [
                            425,
                            280
                        ],
                        [
                            322,
                            426
                        ],
                        [
                            426,
                            391
                        ],
                        [
                            391,
                            322
                        ],
                        [
                            420,
                            429
                        ],
                        [
                            429,
                            437
                        ],
                        [
                            437,
                            420
                        ],
                        [
                            393,
                            391
                        ],
                        [
                            391,
                            326
                        ],
                        [
                            326,
                            393
                        ],
                        [
                            344,
                            440
                        ],
                        [
                            440,
                            438
                        ],
                        [
                            438,
                            344
                        ],
                        [
                            458,
                            459
                        ],
                        [
                            459,
                            461
                        ],
                        [
                            461,
                            458
                        ],
                        [
                            364,
                            434
                        ],
                        [
                            434,
                            394
                        ],
                        [
                            394,
                            364
                        ],
                        [
                            428,
                            396
                        ],
                        [
                            396,
                            262
                        ],
                        [
                            262,
                            428
                        ],
                        [
                            274,
                            354
                        ],
                        [
                            354,
                            457
                        ],
                        [
                            457,
                            274
                        ],
                        [
                            317,
                            316
                        ],
                        [
                            316,
                            402
                        ],
                        [
                            402,
                            317
                        ],
                        [
                            316,
                            315
                        ],
                        [
                            315,
                            403
                        ],
                        [
                            403,
                            316
                        ],
                        [
                            315,
                            314
                        ],
                        [
                            314,
                            404
                        ],
                        [
                            404,
                            315
                        ],
                        [
                            314,
                            313
                        ],
                        [
                            313,
                            405
                        ],
                        [
                            405,
                            314
                        ],
                        [
                            313,
                            421
                        ],
                        [
                            421,
                            406
                        ],
                        [
                            406,
                            313
                        ],
                        [
                            323,
                            366
                        ],
                        [
                            366,
                            361
                        ],
                        [
                            361,
                            323
                        ],
                        [
                            292,
                            306
                        ],
                        [
                            306,
                            407
                        ],
                        [
                            407,
                            292
                        ],
                        [
                            306,
                            291
                        ],
                        [
                            291,
                            408
                        ],
                        [
                            408,
                            306
                        ],
                        [
                            291,
                            287
                        ],
                        [
                            287,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            287,
                            432
                        ],
                        [
                            432,
                            410
                        ],
                        [
                            410,
                            287
                        ],
                        [
                            427,
                            434
                        ],
                        [
                            434,
                            411
                        ],
                        [
                            411,
                            427
                        ],
                        [
                            372,
                            264
                        ],
                        [
                            264,
                            383
                        ],
                        [
                            383,
                            372
                        ],
                        [
                            459,
                            309
                        ],
                        [
                            309,
                            457
                        ],
                        [
                            457,
                            459
                        ],
                        [
                            366,
                            352
                        ],
                        [
                            352,
                            401
                        ],
                        [
                            401,
                            366
                        ],
                        [
                            1,
                            274
                        ],
                        [
                            274,
                            4
                        ],
                        [
                            4,
                            1
                        ],
                        [
                            418,
                            421
                        ],
                        [
                            421,
                            262
                        ],
                        [
                            262,
                            418
                        ],
                        [
                            331,
                            294
                        ],
                        [
                            294,
                            358
                        ],
                        [
                            358,
                            331
                        ],
                        [
                            435,
                            433
                        ],
                        [
                            433,
                            367
                        ],
                        [
                            367,
                            435
                        ],
                        [
                            392,
                            289
                        ],
                        [
                            289,
                            439
                        ],
                        [
                            439,
                            392
                        ],
                        [
                            328,
                            462
                        ],
                        [
                            462,
                            326
                        ],
                        [
                            326,
                            328
                        ],
                        [
                            94,
                            2
                        ],
                        [
                            2,
                            370
                        ],
                        [
                            370,
                            94
                        ],
                        [
                            289,
                            305
                        ],
                        [
                            305,
                            455
                        ],
                        [
                            455,
                            289
                        ],
                        [
                            339,
                            254
                        ],
                        [
                            254,
                            448
                        ],
                        [
                            448,
                            339
                        ],
                        [
                            359,
                            255
                        ],
                        [
                            255,
                            446
                        ],
                        [
                            446,
                            359
                        ],
                        [
                            254,
                            253
                        ],
                        [
                            253,
                            449
                        ],
                        [
                            449,
                            254
                        ],
                        [
                            253,
                            252
                        ],
                        [
                            252,
                            450
                        ],
                        [
                            450,
                            253
                        ],
                        [
                            252,
                            256
                        ],
                        [
                            256,
                            451
                        ],
                        [
                            451,
                            252
                        ],
                        [
                            256,
                            341
                        ],
                        [
                            341,
                            452
                        ],
                        [
                            452,
                            256
                        ],
                        [
                            414,
                            413
                        ],
                        [
                            413,
                            463
                        ],
                        [
                            463,
                            414
                        ],
                        [
                            286,
                            441
                        ],
                        [
                            441,
                            414
                        ],
                        [
                            414,
                            286
                        ],
                        [
                            286,
                            258
                        ],
                        [
                            258,
                            441
                        ],
                        [
                            441,
                            286
                        ],
                        [
                            258,
                            257
                        ],
                        [
                            257,
                            442
                        ],
                        [
                            442,
                            258
                        ],
                        [
                            257,
                            259
                        ],
                        [
                            259,
                            443
                        ],
                        [
                            443,
                            257
                        ],
                        [
                            259,
                            260
                        ],
                        [
                            260,
                            444
                        ],
                        [
                            444,
                            259
                        ],
                        [
                            260,
                            467
                        ],
                        [
                            467,
                            445
                        ],
                        [
                            445,
                            260
                        ],
                        [
                            309,
                            459
                        ],
                        [
                            459,
                            250
                        ],
                        [
                            250,
                            309
                        ],
                        [
                            305,
                            289
                        ],
                        [
                            289,
                            290
                        ],
                        [
                            290,
                            305
                        ],
                        [
                            305,
                            290
                        ],
                        [
                            290,
                            460
                        ],
                        [
                            460,
                            305
                        ],
                        [
                            401,
                            376
                        ],
                        [
                            376,
                            435
                        ],
                        [
                            435,
                            401
                        ],
                        [
                            309,
                            250
                        ],
                        [
                            250,
                            392
                        ],
                        [
                            392,
                            309
                        ],
                        [
                            376,
                            411
                        ],
                        [
                            411,
                            433
                        ],
                        [
                            433,
                            376
                        ],
                        [
                            453,
                            341
                        ],
                        [
                            341,
                            464
                        ],
                        [
                            464,
                            453
                        ],
                        [
                            357,
                            453
                        ],
                        [
                            453,
                            465
                        ],
                        [
                            465,
                            357
                        ],
                        [
                            343,
                            357
                        ],
                        [
                            357,
                            412
                        ],
                        [
                            412,
                            343
                        ],
                        [
                            437,
                            343
                        ],
                        [
                            343,
                            399
                        ],
                        [
                            399,
                            437
                        ],
                        [
                            344,
                            360
                        ],
                        [
                            360,
                            440
                        ],
                        [
                            440,
                            344
                        ],
                        [
                            420,
                            437
                        ],
                        [
                            437,
                            456
                        ],
                        [
                            456,
                            420
                        ],
                        [
                            360,
                            420
                        ],
                        [
                            420,
                            363
                        ],
                        [
                            363,
                            360
                        ],
                        [
                            361,
                            401
                        ],
                        [
                            401,
                            288
                        ],
                        [
                            288,
                            361
                        ],
                        [
                            265,
                            372
                        ],
                        [
                            372,
                            353
                        ],
                        [
                            353,
                            265
                        ],
                        [
                            390,
                            339
                        ],
                        [
                            339,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            339,
                            448
                        ],
                        [
                            448,
                            255
                        ],
                        [
                            255,
                            339
                        ]
                    ]);
                    I("HAND_CONNECTIONS", [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            2
                        ],
                        [
                            2,
                            3
                        ],
                        [
                            3,
                            4
                        ],
                        [
                            0,
                            5
                        ],
                        [
                            5,
                            6
                        ],
                        [
                            6,
                            7
                        ],
                        [
                            7,
                            8
                        ],
                        [
                            5,
                            9
                        ],
                        [
                            9,
                            10
                        ],
                        [
                            10,
                            11
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            9,
                            13
                        ],
                        [
                            13,
                            14
                        ],
                        [
                            14,
                            15
                        ],
                        [
                            15,
                            16
                        ],
                        [
                            13,
                            17
                        ],
                        [
                            0,
                            17
                        ],
                        [
                            17,
                            18
                        ],
                        [
                            18,
                            19
                        ],
                        [
                            19,
                            20
                        ]
                    ]);
                    I("POSE_CONNECTIONS", [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            2
                        ],
                        [
                            2,
                            3
                        ],
                        [
                            3,
                            7
                        ],
                        [
                            0,
                            4
                        ],
                        [
                            4,
                            5
                        ],
                        [
                            5,
                            6
                        ],
                        [
                            6,
                            8
                        ],
                        [
                            9,
                            10
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            11,
                            13
                        ],
                        [
                            13,
                            15
                        ],
                        [
                            15,
                            17
                        ],
                        [
                            15,
                            19
                        ],
                        [
                            15,
                            21
                        ],
                        [
                            17,
                            19
                        ],
                        [
                            12,
                            14
                        ],
                        [
                            14,
                            16
                        ],
                        [
                            16,
                            18
                        ],
                        [
                            16,
                            20
                        ],
                        [
                            16,
                            22
                        ],
                        [
                            18,
                            20
                        ],
                        [
                            11,
                            23
                        ],
                        [
                            12,
                            24
                        ],
                        [
                            23,
                            24
                        ],
                        [
                            23,
                            25
                        ],
                        [
                            24,
                            26
                        ],
                        [
                            25,
                            27
                        ],
                        [
                            26,
                            28
                        ],
                        [
                            27,
                            29
                        ],
                        [
                            28,
                            30
                        ],
                        [
                            29,
                            31
                        ],
                        [
                            30,
                            32
                        ],
                        [
                            27,
                            31
                        ],
                        [
                            28,
                            32
                        ]
                    ]);
                    I("POSE_LANDMARKS", {
                        NOSE: 0,
                        LEFT_EYE_INNER: 1,
                        LEFT_EYE: 2,
                        LEFT_EYE_OUTER: 3,
                        RIGHT_EYE_INNER: 4,
                        RIGHT_EYE: 5,
                        RIGHT_EYE_OUTER: 6,
                        LEFT_EAR: 7,
                        RIGHT_EAR: 8,
                        LEFT_RIGHT: 9,
                        RIGHT_LEFT: 10,
                        LEFT_SHOULDER: 11,
                        RIGHT_SHOULDER: 12,
                        LEFT_ELBOW: 13,
                        RIGHT_ELBOW: 14,
                        LEFT_WRIST: 15,
                        RIGHT_WRIST: 16,
                        LEFT_PINKY: 17,
                        RIGHT_PINKY: 18,
                        LEFT_INDEX: 19,
                        RIGHT_INDEX: 20,
                        LEFT_THUMB: 21,
                        RIGHT_THUMB: 22,
                        LEFT_HIP: 23,
                        RIGHT_HIP: 24,
                        LEFT_KNEE: 25,
                        RIGHT_KNEE: 26,
                        LEFT_ANKLE: 27,
                        RIGHT_ANKLE: 28,
                        LEFT_HEEL: 29,
                        RIGHT_HEEL: 30,
                        LEFT_FOOT_INDEX: 31,
                        RIGHT_FOOT_INDEX: 32
                    });
                    I("POSE_LANDMARKS_LEFT", {
                        LEFT_EYE_INNER: 1,
                        LEFT_EYE: 2,
                        LEFT_EYE_OUTER: 3,
                        LEFT_EAR: 7,
                        LEFT_RIGHT: 9,
                        LEFT_SHOULDER: 11,
                        LEFT_ELBOW: 13,
                        LEFT_WRIST: 15,
                        LEFT_PINKY: 17,
                        LEFT_INDEX: 19,
                        LEFT_THUMB: 21,
                        LEFT_HIP: 23,
                        LEFT_KNEE: 25,
                        LEFT_ANKLE: 27,
                        LEFT_HEEL: 29,
                        LEFT_FOOT_INDEX: 31
                    });
                    I("POSE_LANDMARKS_RIGHT", {
                        RIGHT_EYE_INNER: 4,
                        RIGHT_EYE: 5,
                        RIGHT_EYE_OUTER: 6,
                        RIGHT_EAR: 8,
                        RIGHT_LEFT: 10,
                        RIGHT_SHOULDER: 12,
                        RIGHT_ELBOW: 14,
                        RIGHT_WRIST: 16,
                        RIGHT_PINKY: 18,
                        RIGHT_INDEX: 20,
                        RIGHT_THUMB: 22,
                        RIGHT_HIP: 24,
                        RIGHT_KNEE: 26,
                        RIGHT_ANKLE: 28,
                        RIGHT_HEEL: 30,
                        RIGHT_FOOT_INDEX: 32
                    });
                    I("POSE_LANDMARKS_NEUTRAL", {
                        NOSE: 0
                    });
                    I("matrixDataToMatrix", function(a) {
                        for(var b = a.getCols(), c = a.getRows(), d = a.getPackedDataList(), e = [], g = 0; g < c; g++)e.push(Array(b));
                        for(g = 0; g < c; g++)for(var f = 0; f < b; f++){
                            var k = a.getLayout() === 1 ? g * b + f : f * c + g;
                            e[g][f] = d[k];
                        }
                        return e;
                    });
                    I("VERSION", "0.5.1635989137");
                }).call(VonageHolistic);
                const VonageFacedetection = {};
                (function() {
                    var x;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var y = ca(this);
                    function B(a, b) {
                        if (b) a: {
                            var c = y;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    B("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    B("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = y[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function C(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function D(a) {
                        if (!(a instanceof Array)) {
                            a = C(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var ea = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, fa;
                    if (typeof Object.setPrototypeOf == "function") fa = Object.setPrototypeOf;
                    else {
                        var ha;
                        a: {
                            var ia = {
                                a: true
                            }, ja = {};
                            try {
                                ja.__proto__ = ia;
                                ha = ja.a;
                                break a;
                            } catch (a) {}
                            ha = false;
                        }
                        fa = ha ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var ka = fa;
                    function E(a, b) {
                        a.prototype = ea(b.prototype);
                        a.prototype.constructor = a;
                        if (ka) ka(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.na = b.prototype;
                    }
                    function la() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.u = this.o = 0;
                        this.j = null;
                    }
                    function ma(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    la.prototype.s = function(a) {
                        this.h = a;
                    };
                    function na(a, b) {
                        a.j = {
                            da: b,
                            ea: true
                        };
                        a.g = a.o || a.u;
                    }
                    la.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.u;
                    };
                    function G(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function oa(a) {
                        this.g = new la();
                        this.h = a;
                    }
                    function pa(a, b) {
                        ma(a.g);
                        var c = a.g.i;
                        if (c) return qa(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return H(a);
                    }
                    function qa(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, na(a.g, f), H(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return H(a);
                    }
                    function H(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, na(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.ea) throw b.da;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function ra(a) {
                        this.next = function(b) {
                            ma(a.g);
                            a.g.i ? b = qa(a, a.g.i.next, b, a.g.s) : (a.g.s(b), b = H(a));
                            return b;
                        };
                        this.throw = function(b) {
                            ma(a.g);
                            a.g.i ? b = qa(a, a.g.i["throw"], b, a.g.s) : (na(a.g, b), b = H(a));
                            return b;
                        };
                        this.return = function(b) {
                            return pa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function sa(a) {
                        function b(d) {
                            return a.next(d);
                        }
                        function c(d) {
                            return a.throw(d);
                        }
                        return new Promise(function(d, e) {
                            function g(f) {
                                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                            }
                            g(a.next());
                        });
                    }
                    function J(a) {
                        return sa(new ra(new oa(a)));
                    }
                    B("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.s = false;
                            var h = this.j();
                            try {
                                f(h.resolve, h.reject);
                            } catch (k) {
                                h.reject(k);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(h) {
                                h(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var h = this;
                                this.i(function() {
                                    h.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = y.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var h = 0; h < f.length; ++h){
                                    var k = f[h];
                                    f[h] = null;
                                    try {
                                        k();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(m) {
                                    k || (k = true, l.call(h, m));
                                };
                            }
                            var h = this, k = false;
                            return {
                                resolve: f(this.D),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.D = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.H(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var h = f != null;
                                        break a;
                                    case "function":
                                        h = true;
                                        break a;
                                    default:
                                        h = false;
                                }
                                h ? this.A(f) : this.o(f);
                            }
                        };
                        b.prototype.A = function(f) {
                            var h = void 0;
                            try {
                                h = f.then;
                            } catch (k) {
                                this.l(k);
                                return;
                            }
                            typeof h == "function" ? this.I(h, f) : this.o(f);
                        };
                        b.prototype.l = function(f) {
                            this.u(2, f);
                        };
                        b.prototype.o = function(f) {
                            this.u(1, f);
                        };
                        b.prototype.u = function(f, h) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = h;
                            this.h === 2 && this.G();
                            this.B();
                        };
                        b.prototype.G = function() {
                            var f = this;
                            e(function() {
                                if (f.C()) {
                                    var h = y.console;
                                    typeof h !== "undefined" && h.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.C = function() {
                            if (this.s) return false;
                            var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
                            if (typeof k === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof h === "function" ? f = new h("unhandledrejection", {
                                cancelable: true
                            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return k(f);
                        };
                        b.prototype.B = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.H = function(f) {
                            var h = this.j();
                            f.M(h.resolve, h.reject);
                        };
                        b.prototype.I = function(f, h) {
                            var k = this.j();
                            try {
                                f.call(h, k.resolve, k.reject);
                            } catch (l) {
                                k.reject(l);
                            }
                        };
                        b.prototype.then = function(f, h) {
                            function k(p, n) {
                                return typeof p == "function" ? function(r) {
                                    try {
                                        l(p(r));
                                    } catch (t) {
                                        m(t);
                                    }
                                } : n;
                            }
                            var l, m, q = new b(function(p, n) {
                                l = p;
                                m = n;
                            });
                            this.M(k(f, l), k(h, m));
                            return q;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.M = function(f, h) {
                            function k() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        h(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(k) : this.g.push(k);
                            this.s = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(h, k) {
                                k(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(h, k) {
                                for(var l = C(f), m = l.next(); !m.done; m = l.next())d(m.value).M(h, k);
                            });
                        };
                        b.all = function(f) {
                            var h = C(f), k = h.next();
                            return k.done ? d([]) : new b(function(l, m) {
                                function q(r) {
                                    return function(t) {
                                        p[r] = t;
                                        n--;
                                        n == 0 && l(p);
                                    };
                                }
                                var p = [], n = 0;
                                do p.push(void 0), n++, d(k.value).M(q(p.length - 1), m), k = h.next();
                                while (!k.done);
                            });
                        };
                        return b;
                    });
                    function ta(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var ua = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    B("Object.assign", function(a) {
                        return a || ua;
                    });
                    B("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    B("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    B("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    B("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ta(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var va = this || self;
                    function K(a, b) {
                        a = a.split(".");
                        var c = va;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function L() {
                        throw Error("Invalid UTF8");
                    }
                    function wa(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var xa, ya = typeof TextDecoder !== "undefined", za, Aa = typeof TextEncoder !== "undefined";
                    var Ba = {}, M = null;
                    function Ca(a) {
                        var b;
                        b === void 0 && (b = 0);
                        Da();
                        b = Ba[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | h >> 4];
                            h = b[(h & 15) << 2 | k >> 6];
                            k = b[k & 63];
                            c[g++] = l + f + h + k;
                        }
                        l = 0;
                        k = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], k = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
                        }
                        return c.join("");
                    }
                    function Ea(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Fa(a, function(g) {
                            d[e++] = g;
                        });
                        return e !== c ? d.subarray(0, e) : d;
                    }
                    function Fa(a, b) {
                        function c(k) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), m = M[l];
                                if (m != null) return m;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return k;
                        }
                        Da();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), h = c(64);
                            if (h === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
                        }
                    }
                    function Da() {
                        if (!M) {
                            M = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Ba[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    M[g] === void 0 && (M[g] = e);
                                }
                            }
                        }
                    }
                    var Ga = typeof Uint8Array === "function";
                    function Ha(a) {
                        return Ga && a != null && a instanceof Uint8Array;
                    }
                    var Ia;
                    function Ja(a) {
                        this.L = a;
                        if (a !== null && a.length === 0) throw Error("ByteString should be constructed with non-empty values");
                    }
                    var Ka = typeof Uint8Array.prototype.slice === "function", N = 0, O = 0;
                    function La(a, b) {
                        if (a.constructor === Uint8Array) return a;
                        if (a.constructor === ArrayBuffer) return new Uint8Array(a);
                        if (a.constructor === Array) return new Uint8Array(a);
                        if (a.constructor === String) return Ea(a);
                        if (a.constructor === Ja) {
                            if (!b && (b = a.L) && b.constructor === Uint8Array) return b;
                            b = a.L;
                            b = b == null || Ha(b) ? b : typeof b === "string" ? Ea(b) : null;
                            return (a = a.L = b) ? new Uint8Array(a) : Ia || (Ia = new Uint8Array(0));
                        }
                        if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
                    }
                    function Ma(a, b) {
                        return Error("Invalid wire type: " + a + " (at position " + b + ")");
                    }
                    function Na() {
                        return Error("Failed to read varint, encoding is invalid.");
                    }
                    function Oa(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.v === void 0 ? false : b.v;
                        this.h = null;
                        this.g = this.i = this.j = 0;
                        this.v = b;
                        a && Pa(this, a);
                    }
                    function Pa(a, b) {
                        a.h = La(b, a.v);
                        a.j = 0;
                        a.i = a.h.length;
                        a.g = a.j;
                    }
                    Oa.prototype.reset = function() {
                        this.g = this.j;
                    };
                    function P(a) {
                        if (a.g > a.i) throw Error("Tried to read past the end of the data " + a.g + " > " + a.i);
                    }
                    function Q(a) {
                        var b = a.h, c = b[a.g], d = c & 127;
                        if (128 > c) return a.g += 1, P(a), d;
                        c = b[a.g + 1];
                        d |= (c & 127) << 7;
                        if (128 > c) return a.g += 2, P(a), d;
                        c = b[a.g + 2];
                        d |= (c & 127) << 14;
                        if (128 > c) return a.g += 3, P(a), d;
                        c = b[a.g + 3];
                        d |= (c & 127) << 21;
                        if (128 > c) return a.g += 4, P(a), d;
                        c = b[a.g + 4];
                        a.g += 5;
                        d |= (c & 15) << 28;
                        if (128 > c) return P(a), d;
                        if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++]) throw Na();
                        P(a);
                        return d;
                    }
                    var Qa = [];
                    function Ra() {
                        this.g = [];
                    }
                    Ra.prototype.length = function() {
                        return this.g.length;
                    };
                    Ra.prototype.end = function() {
                        var a = this.g;
                        this.g = [];
                        return a;
                    };
                    function S(a, b) {
                        for(; 127 < b;)a.g.push(b & 127 | 128), b >>>= 7;
                        a.g.push(b);
                    }
                    function Sa(a) {
                        var b = {}, c = b.W === void 0 ? false : b.W;
                        this.l = {
                            v: b.v === void 0 ? false : b.v
                        };
                        this.W = c;
                        b = this.l;
                        Qa.length ? (c = Qa.pop(), b && (c.v = b.v), a && Pa(c, a), a = c) : a = new Oa(a, b);
                        this.g = a;
                        this.j = this.g.g;
                        this.h = this.i = -1;
                    }
                    Sa.prototype.reset = function() {
                        this.g.reset();
                        this.j = this.g.g;
                        this.h = this.i = -1;
                    };
                    function Ta(a) {
                        var b = a.g;
                        if (b.g == b.i) return false;
                        a.j = a.g.g;
                        var c = Q(a.g) >>> 0;
                        b = c >>> 3;
                        c &= 7;
                        if (!(0 <= c && 5 >= c)) throw Ma(c, a.j);
                        if (1 > b) throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
                        a.i = b;
                        a.h = c;
                        return true;
                    }
                    function Ua(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Ua(a);
                                else a: {
                                    a = a.g;
                                    for(var b = a.g, c = b + 10; b < c;)if ((a.h[b++] & 128) === 0) {
                                        a.g = b;
                                        P(a);
                                        break a;
                                    }
                                    throw Na();
                                }
                                break;
                            case 1:
                                a = a.g;
                                a.g += 8;
                                P(a);
                                break;
                            case 2:
                                a.h != 2 ? Ua(a) : (b = Q(a.g) >>> 0, a = a.g, a.g += b, P(a));
                                break;
                            case 5:
                                a = a.g;
                                a.g += 4;
                                P(a);
                                break;
                            case 3:
                                b = a.i;
                                do {
                                    if (!Ta(a)) throw Error("Unmatched start-group tag: stream EOF");
                                    if (a.h == 4) {
                                        if (a.i != b) throw Error("Unmatched end-group tag");
                                        break;
                                    }
                                    Ua(a);
                                }while (1);
                                break;
                            default:
                                throw Ma(a.h, a.j);
                        }
                    }
                    var Va = [];
                    function Wa() {
                        this.i = [];
                        this.h = 0;
                        this.g = new Ra();
                    }
                    function T(a, b) {
                        b.length !== 0 && (a.i.push(b), a.h += b.length);
                    }
                    function Xa(a, b) {
                        if (b = b.ba) {
                            T(a, a.g.end());
                            for(var c = 0; c < b.length; c++)T(a, b[c]);
                        }
                    }
                    var U = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
                    function Ya(a, b) {
                        Object.isFrozen(a) || (U ? a[U] |= b : a.N !== void 0 ? a.N |= b : Object.defineProperties(a, {
                            N: {
                                value: b,
                                configurable: true,
                                writable: true,
                                enumerable: false
                            }
                        }));
                    }
                    function Za(a) {
                        var b;
                        U ? b = a[U] : b = a.N;
                        return b == null ? 0 : b;
                    }
                    function $a(a) {
                        Ya(a, 1);
                        return a;
                    }
                    function ab(a) {
                        return Array.isArray(a) ? !!(Za(a) & 2) : false;
                    }
                    function bb(a) {
                        if (!Array.isArray(a)) throw Error("cannot mark non-array as immutable");
                        Ya(a, 2);
                    }
                    function cb(a) {
                        return a !== null && typeof a === "object" && !Array.isArray(a) && a.constructor === Object;
                    }
                    var db = Object.freeze($a([]));
                    function eb(a) {
                        if (ab(a.m)) throw Error("Cannot mutate an immutable Message");
                    }
                    var fb = typeof Symbol != "undefined" && typeof Symbol.hasInstance != "undefined";
                    function gb(a) {
                        return {
                            value: a,
                            configurable: false,
                            writable: false,
                            enumerable: false
                        };
                    }
                    function V(a, b, c) {
                        return b === -1 ? null : b >= a.i ? a.g ? a.g[b] : void 0 : (c === void 0 ? 0 : c) && a.g && (c = a.g[b], c != null) ? c : a.m[b + a.h];
                    }
                    function W(a, b, c, d) {
                        d = d === void 0 ? false : d;
                        eb(a);
                        b < a.i && !d ? a.m[b + a.h] = c : (a.g || (a.g = a.m[a.i + a.h] = {}))[b] = c;
                    }
                    function hb(a, b, c, d) {
                        c = c === void 0 ? true : c;
                        d = d === void 0 ? false : d;
                        var e = V(a, b, d);
                        e == null && (e = db);
                        if (ab(a.m)) c && (bb(e), Object.freeze(e));
                        else if (e === db || ab(e)) e = $a(e.slice()), W(a, b, e, d);
                        return e;
                    }
                    function X(a, b, c) {
                        a = V(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function ib(a, b, c, d) {
                        a.j || (a.j = {});
                        var e = ab(a.m), g = a.j[c];
                        if (!g) {
                            d = hb(a, c, true, d === void 0 ? false : d);
                            g = [];
                            e = e || ab(d);
                            for(var f = 0; f < d.length; f++)g[f] = new b(d[f]), e && bb(g[f].m);
                            e && (bb(g), Object.freeze(g));
                            a.j[c] = g;
                        }
                        return g;
                    }
                    function jb(a, b, c, d, e) {
                        var g = g === void 0 ? false : g;
                        eb(a);
                        g = ib(a, c, b, g);
                        c = d ? d : new c();
                        a = hb(a, b);
                        e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.m)) : (g.push(c), a.push(c.m));
                        return c;
                    }
                    function kb(a, b) {
                        a = V(a, b);
                        return a == null ? 0 : a;
                    }
                    function lb(a, b) {
                        a = V(a, b);
                        return a == null ? "" : a;
                    }
                    function mb(a) {
                        switch(typeof a){
                            case "number":
                                return isFinite(a) ? a : String(a);
                            case "object":
                                if (a && !Array.isArray(a)) {
                                    if (Ha(a)) return Ca(a);
                                    if (a instanceof Ja) {
                                        var b = a.L;
                                        b = b == null || typeof b === "string" ? b : Ga && b instanceof Uint8Array ? Ca(b) : null;
                                        return (a.L = b) || "";
                                    }
                                }
                        }
                        return a;
                    }
                    function nb(a) {
                        var b = ob;
                        b = b === void 0 ? pb : b;
                        return qb(a, b);
                    }
                    function rb(a, b) {
                        if (a != null) {
                            if (Array.isArray(a)) a = qb(a, b);
                            else if (cb(a)) {
                                var c = {}, d;
                                for(d in a)c[d] = rb(a[d], b);
                                a = c;
                            } else a = b(a);
                            return a;
                        }
                    }
                    function qb(a, b) {
                        for(var c = a.slice(), d = 0; d < c.length; d++)c[d] = rb(c[d], b);
                        Array.isArray(a) && Za(a) & 1 && $a(c);
                        return c;
                    }
                    function ob(a) {
                        if (a && typeof a == "object" && a.toJSON) return a.toJSON();
                        a = mb(a);
                        return Array.isArray(a) ? nb(a) : a;
                    }
                    function pb(a) {
                        return Ha(a) ? new Uint8Array(a) : a;
                    }
                    function sb(a, b, c) {
                        a || (a = tb);
                        tb = null;
                        var d = this.constructor.h;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.h = (d ? 0 : -1) - (this.constructor.g || 0);
                        this.j = void 0;
                        this.m = a;
                        a: {
                            d = this.m.length;
                            a = d - 1;
                            if (d && (d = this.m[a], cb(d))) {
                                this.i = a - this.h;
                                this.g = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.i = Math.max(b, a + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)if (a = c[b], a < this.i) a += this.h, (d = this.m[a]) ? Array.isArray(d) && $a(d) : this.m[a] = db;
                        else {
                            d = this.g || (this.g = this.m[this.i + this.h] = {});
                            var e = d[a];
                            e ? Array.isArray(e) && $a(e) : d[a] = db;
                        }
                    }
                    sb.prototype.toJSON = function() {
                        return nb(this.m);
                    };
                    sb.prototype.toString = function() {
                        return this.m.toString();
                    };
                    var tb;
                    function ub() {
                        sb.apply(this, arguments);
                    }
                    E(ub, sb);
                    if (fb) {
                        var vb = {};
                        Object.defineProperties(ub, (vb[Symbol.hasInstance] = gb(function() {
                            throw Error("Cannot perform instanceof checks for MutableMessage");
                        }), vb));
                    }
                    function wb(a, b, c) {
                        if (c) {
                            var d = {}, e;
                            for(e in c){
                                var g = c[e], f = g.ha;
                                f || (d.F = g.la || g.fa.P, g.aa ? (d.U = xb(g.aa), f = function(h) {
                                    return function(k, l, m) {
                                        return h.F(k, l, m, h.U);
                                    };
                                }(d)) : g.ca ? (d.T = yb(g.X.g, g.ca), f = function(h) {
                                    return function(k, l, m) {
                                        return h.F(k, l, m, h.T);
                                    };
                                }(d)) : f = d.F, g.ha = f);
                                f(b, a, g.X);
                                d = {
                                    F: d.F,
                                    U: d.U,
                                    T: d.T
                                };
                            }
                        }
                        Xa(b, a);
                    }
                    var zb = Symbol();
                    function Ab(a, b, c) {
                        return a[zb] || (a[zb] = function(d, e) {
                            return b(d, e, c);
                        });
                    }
                    function Bb(a) {
                        var b = a[zb];
                        if (!b) {
                            var c = Cb(a);
                            b = function(d, e) {
                                return Db(d, e, c);
                            };
                            a[zb] = b;
                        }
                        return b;
                    }
                    function Eb(a) {
                        var b = a.aa;
                        if (b) return Bb(b);
                        if (b = a.ka) return Ab(a.X.g, b, a.ca);
                    }
                    function Fb(a) {
                        var b = Eb(a), c = a.X, d = a.fa.O;
                        return b ? function(e, g) {
                            return d(e, g, c, b);
                        } : function(e, g) {
                            return d(e, g, c);
                        };
                    }
                    function Gb(a, b, c, d, e, g) {
                        a = a();
                        var f = 0;
                        a.length && typeof a[0] !== "number" && (c(b, a[0]), f++);
                        for(; f < a.length;){
                            c = a[f++];
                            for(var h = f + 1; h < a.length && typeof a[h] !== "number";)h++;
                            var k = a[f++];
                            h -= f;
                            switch(h){
                                case 0:
                                    d(b, c, k);
                                    break;
                                case 1:
                                    d(b, c, k, a[f++]);
                                    break;
                                case 2:
                                    e(b, c, k, a[f++], a[f++]);
                                    break;
                                case 3:
                                    h = a[f++];
                                    var l = a[f++], m = a[f++];
                                    Array.isArray(m) ? e(b, c, k, h, l, m) : g(b, c, k, h, l, m);
                                    break;
                                case 4:
                                    g(b, c, k, a[f++], a[f++], a[f++], a[f++]);
                                    break;
                                default:
                                    throw Error("unexpected number of binary field arguments: " + h);
                            }
                        }
                        return b;
                    }
                    var Hb = Symbol();
                    function xb(a) {
                        var b = a[Hb];
                        if (!b) {
                            var c = Ib(a);
                            b = function(d, e) {
                                return Jb(d, e, c);
                            };
                            a[Hb] = b;
                        }
                        return b;
                    }
                    function yb(a, b) {
                        var c = a[Hb];
                        c || (c = function(d, e) {
                            return wb(d, e, b);
                        }, a[Hb] = c);
                        return c;
                    }
                    var Kb = Symbol();
                    function Lb(a, b) {
                        a.push(b);
                    }
                    function Mb(a, b, c) {
                        a.push(b, c.P);
                    }
                    function Nb(a, b, c, d, e) {
                        var g = xb(e), f = c.P;
                        a.push(b, function(h, k, l) {
                            return f(h, k, l, d, g);
                        });
                    }
                    function Ob(a, b, c, d, e, g) {
                        var f = yb(d, g), h = c.P;
                        a.push(b, function(k, l, m) {
                            return h(k, l, m, d, f);
                        });
                    }
                    function Ib(a) {
                        var b = a[Kb];
                        return b ? b : Gb(a, a[Kb] = [], Lb, Mb, Nb, Ob);
                    }
                    var Pb = Symbol();
                    function Qb(a, b) {
                        a[0] = b;
                    }
                    function Rb(a, b, c, d) {
                        var e = c.O;
                        a[b] = d ? function(g, f, h) {
                            return e(g, f, h, d);
                        } : e;
                    }
                    function Sb(a, b, c, d, e, g) {
                        var f = c.O, h = Bb(e);
                        a[b] = function(k, l, m) {
                            return f(k, l, m, d, h, g);
                        };
                    }
                    function Tb(a, b, c, d, e, g, f) {
                        var h = c.O, k = Ab(d, e, g);
                        a[b] = function(l, m, q) {
                            return h(l, m, q, d, k, f);
                        };
                    }
                    function Cb(a) {
                        var b = a[Pb];
                        return b ? b : Gb(a, a[Pb] = {}, Qb, Rb, Sb, Tb);
                    }
                    function Db(a, b, c) {
                        for(; Ta(b) && b.h != 4;){
                            var d = b.i, e = c[d];
                            if (!e) {
                                var g = c[0];
                                g && (g = g[d]) && (e = c[d] = Fb(g));
                            }
                            if (!e || !e(b, a, d)) {
                                if (e = b, d = a, g = e.j, Ua(e), !e.W) {
                                    var f = e.g.h;
                                    e = e.g.g;
                                    e = g === e ? Ia || (Ia = new Uint8Array(0)) : Ka ? f.slice(g, e) : new Uint8Array(f.subarray(g, e));
                                    (g = d.ba) ? g.push(e) : d.ba = [
                                        e
                                    ];
                                }
                            }
                        }
                        return a;
                    }
                    function Ub(a, b, c) {
                        if (Va.length) {
                            var d = Va.pop();
                            a && (Pa(d.g, a), d.i = -1, d.h = -1);
                            a = d;
                        } else a = new Sa(a);
                        try {
                            return Db(new b(), a, Cb(c));
                        } finally{
                            b = a.g, b.h = null, b.j = 0, b.i = 0, b.g = 0, b.v = false, a.i = -1, a.h = -1, 100 > Va.length && Va.push(a);
                        }
                    }
                    function Jb(a, b, c) {
                        for(var d = c.length, e = d % 2 == 1, g = e ? 1 : 0; g < d; g += 2)(0, c[g + 1])(b, a, c[g]);
                        wb(a, b, e ? c[0] : void 0);
                    }
                    function Vb(a, b) {
                        var c = new Wa();
                        Jb(a, c, Ib(b));
                        T(c, c.g.end());
                        a = new Uint8Array(c.h);
                        b = c.i;
                        for(var d = b.length, e = 0, g = 0; g < d; g++){
                            var f = b[g];
                            a.set(f, e);
                            e += f.length;
                        }
                        c.i = [
                            a
                        ];
                        return a;
                    }
                    function Wb(a, b) {
                        return {
                            O: a,
                            P: b
                        };
                    }
                    var Y = Wb(function(a, b, c) {
                        if (a.h !== 5) return false;
                        a = a.g;
                        var d = a.h[a.g];
                        var e = a.h[a.g + 1];
                        var g = a.h[a.g + 2], f = a.h[a.g + 3];
                        a.g += 4;
                        P(a);
                        e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
                        a = 2 * (e >> 31) + 1;
                        d = e >>> 23 & 255;
                        e &= 8388607;
                        W(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null) {
                            S(a.g, 8 * c + 5);
                            a = a.g;
                            var d = b;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? N = O = 0 : (O = 0, N = 2147483648) : isNaN(d) ? (O = 0, N = 2147483647) : 34028234663852886e22 < d ? (O = 0, N = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), O = 0, N = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, O = 0, N = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = N;
                            a.g.push(c >>> 0 & 255);
                            a.g.push(c >>> 8 & 255);
                            a.g.push(c >>> 16 & 255);
                            a.g.push(c >>> 24 & 255);
                        }
                    }), Xb = Wb(function(a, b, c) {
                        if (a.h !== 0) return false;
                        for(var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)e = d.h[d.g++], P(d), g |= (e & 127) << 7 * f;
                        128 <= e && (e = d.h[d.g++], P(d), g |= (e & 127) << 28, a |= (e & 127) >> 4);
                        if (128 <= e) for(f = 0; 5 > f && 128 <= e; f++)e = d.h[d.g++], P(d), a |= (e & 127) << 7 * f + 3;
                        if (128 > e) {
                            d = g >>> 0;
                            e = a >>> 0;
                            if (a = e & 2147483648) d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
                            d = 4294967296 * e + (d >>> 0);
                        } else throw Na();
                        W(b, c, a ? -d : d);
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null && b != null) {
                            S(a.g, 8 * c);
                            a = a.g;
                            var d = b;
                            c = 0 > d;
                            d = Math.abs(d);
                            b = d >>> 0;
                            d = Math.floor((d - b) / 4294967296);
                            d >>>= 0;
                            c && (d = ~d >>> 0, b = (~b >>> 0) + 1, 4294967295 < b && (b = 0, d++, 4294967295 < d && (d = 0)));
                            N = b;
                            O = d;
                            c = N;
                            for(b = O; 0 < b || 127 < c;)a.g.push(c & 127 | 128), c = (c >>> 7 | b << 25) >>> 0, b >>>= 7;
                            a.g.push(c);
                        }
                    }), Yb = Wb(function(a, b, c) {
                        if (a.h !== 0) return false;
                        W(b, c, Q(a.g));
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null && b != null) {
                            if (S(a.g, 8 * c), a = a.g, c = b, 0 <= c) S(a, c);
                            else {
                                for(b = 0; 9 > b; b++)a.g.push(c & 127 | 128), c >>= 7;
                                a.g.push(1);
                            }
                        }
                    }), Zb = Wb(function(a, b, c) {
                        if (a.h !== 2) return false;
                        var d = Q(a.g) >>> 0;
                        a = a.g;
                        var e = a.g;
                        a.g += d;
                        P(a);
                        a = a.h;
                        var g;
                        if (ya) (g = xa) || (g = xa = new TextDecoder("utf-8", {
                            fatal: true
                        })), g = g.decode(a.subarray(e, e + d));
                        else {
                            d = e + d;
                            for(var f = [], h = null, k, l, m; e < d;)k = a[e++], 128 > k ? f.push(k) : 224 > k ? e >= d ? L() : (l = a[e++], 194 > k || (l & 192) !== 128 ? (e--, L()) : f.push((k & 31) << 6 | l & 63)) : 240 > k ? e >= d - 1 ? L() : (l = a[e++], (l & 192) !== 128 || k === 224 && 160 > l || k === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, L()) : f.push((k & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= k ? e >= d - 2 ? L() : (l = a[e++], (l & 192) !== 128 || (k << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((m = a[e++]) & 192) !== 128 ? (e--, L()) : (k = (k & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | m & 63, k -= 65536, f.push((k >> 10 & 1023) + 55296, (k & 1023) + 56320))) : L(), 8192 <= f.length && (h = wa(h, f), f.length = 0);
                            g = wa(h, f);
                        }
                        W(b, c, g);
                        return true;
                    }, function(a, b, c) {
                        b = V(b, c);
                        if (b != null) {
                            var d = false;
                            d = d === void 0 ? false : d;
                            if (Aa) {
                                if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b)) throw Error("Found an unpaired surrogate");
                                b = (za || (za = new TextEncoder())).encode(b);
                            } else {
                                for(var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++){
                                    var h = b.charCodeAt(f);
                                    if (128 > h) g[e++] = h;
                                    else {
                                        if (2048 > h) g[e++] = h >> 6 | 192;
                                        else {
                                            if (55296 <= h && 57343 >= h) {
                                                if (56319 >= h && f < b.length) {
                                                    var k = b.charCodeAt(++f);
                                                    if (56320 <= k && 57343 >= k) {
                                                        h = 1024 * (h - 55296) + k - 56320 + 65536;
                                                        g[e++] = h >> 18 | 240;
                                                        g[e++] = h >> 12 & 63 | 128;
                                                        g[e++] = h >> 6 & 63 | 128;
                                                        g[e++] = h & 63 | 128;
                                                        continue;
                                                    } else f--;
                                                }
                                                if (d) throw Error("Found an unpaired surrogate");
                                                h = 65533;
                                            }
                                            g[e++] = h >> 12 | 224;
                                            g[e++] = h >> 6 & 63 | 128;
                                        }
                                        g[e++] = h & 63 | 128;
                                    }
                                }
                                b = g.subarray(0, e);
                            }
                            S(a.g, 8 * c + 2);
                            S(a.g, b.length);
                            T(a, a.g.end());
                            T(a, b);
                        }
                    }), $b = Wb(function(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        b = jb(b, c, d);
                        c = a.g.i;
                        d = Q(a.g) >>> 0;
                        var g = a.g.g + d, f = g - c;
                        0 >= f && (a.g.i = g, e(b, a), f = g - a.g.g);
                        if (f) throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                        a.g.g = g;
                        a.g.i = c;
                        return true;
                    }, function(a, b, c, d, e) {
                        b = ib(b, d, c);
                        if (b != null) for(d = 0; d < b.length; d++){
                            var g = a;
                            S(g.g, 8 * c + 2);
                            var f = g.g.end();
                            T(g, f);
                            f.push(g.h);
                            g = f;
                            e(b[d], a);
                            f = a;
                            var h = g.pop();
                            for(h = f.h + f.g.length() - h; 127 < h;)g.push(h & 127 | 128), h >>>= 7, f.h++;
                            g.push(h);
                            f.h++;
                        }
                    });
                    function Z() {
                        ub.apply(this, arguments);
                    }
                    E(Z, ub);
                    if (fb) {
                        var ac = {};
                        Object.defineProperties(Z, (ac[Symbol.hasInstance] = gb(Object[Symbol.hasInstance]), ac));
                    }
                    function bc(a) {
                        Z.call(this, a);
                    }
                    E(bc, Z);
                    function cc() {
                        return [
                            1,
                            Yb,
                            2,
                            Y,
                            3,
                            Zb,
                            4,
                            Zb
                        ];
                    }
                    function dc(a) {
                        Z.call(this, a, -1, ec);
                    }
                    E(dc, Z);
                    dc.prototype.addClassification = function(a, b) {
                        jb(this, 1, bc, a, b);
                        return this;
                    };
                    function fc() {
                        return [
                            1,
                            $b,
                            bc,
                            cc
                        ];
                    }
                    var ec = [
                        1
                    ];
                    function gc(a) {
                        Z.call(this, a);
                    }
                    E(gc, Z);
                    function hc() {
                        return [
                            1,
                            Y,
                            2,
                            Y,
                            3,
                            Y,
                            4,
                            Y,
                            5,
                            Y
                        ];
                    }
                    function ic(a) {
                        Z.call(this, a, -1, jc);
                    }
                    E(ic, Z);
                    function kc() {
                        return [
                            1,
                            $b,
                            gc,
                            hc
                        ];
                    }
                    var jc = [
                        1
                    ];
                    function lc(a) {
                        Z.call(this, a);
                    }
                    E(lc, Z);
                    function mc() {
                        return [
                            1,
                            Y,
                            2,
                            Y,
                            3,
                            Y,
                            4,
                            Y,
                            5,
                            Y,
                            6,
                            Xb
                        ];
                    }
                    var nc = [
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            78,
                            95
                        ],
                        [
                            95,
                            88
                        ],
                        [
                            88,
                            178
                        ],
                        [
                            178,
                            87
                        ],
                        [
                            87,
                            14
                        ],
                        [
                            14,
                            317
                        ],
                        [
                            317,
                            402
                        ],
                        [
                            402,
                            318
                        ],
                        [
                            318,
                            324
                        ],
                        [
                            324,
                            308
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            308
                        ]
                    ], oc = [
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            263,
                            466
                        ],
                        [
                            466,
                            388
                        ],
                        [
                            388,
                            387
                        ],
                        [
                            387,
                            386
                        ],
                        [
                            386,
                            385
                        ],
                        [
                            385,
                            384
                        ],
                        [
                            384,
                            398
                        ],
                        [
                            398,
                            362
                        ]
                    ], pc = [
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            336
                        ]
                    ], qc = [
                        [
                            33,
                            7
                        ],
                        [
                            7,
                            163
                        ],
                        [
                            163,
                            144
                        ],
                        [
                            144,
                            145
                        ],
                        [
                            145,
                            153
                        ],
                        [
                            153,
                            154
                        ],
                        [
                            154,
                            155
                        ],
                        [
                            155,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            133
                        ]
                    ], rc = [
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            107
                        ]
                    ], sc = [
                        [
                            10,
                            338
                        ],
                        [
                            338,
                            297
                        ],
                        [
                            297,
                            332
                        ],
                        [
                            332,
                            284
                        ],
                        [
                            284,
                            251
                        ],
                        [
                            251,
                            389
                        ],
                        [
                            389,
                            356
                        ],
                        [
                            356,
                            454
                        ],
                        [
                            454,
                            323
                        ],
                        [
                            323,
                            361
                        ],
                        [
                            361,
                            288
                        ],
                        [
                            288,
                            397
                        ],
                        [
                            397,
                            365
                        ],
                        [
                            365,
                            379
                        ],
                        [
                            379,
                            378
                        ],
                        [
                            378,
                            400
                        ],
                        [
                            400,
                            377
                        ],
                        [
                            377,
                            152
                        ],
                        [
                            152,
                            148
                        ],
                        [
                            148,
                            176
                        ],
                        [
                            176,
                            149
                        ],
                        [
                            149,
                            150
                        ],
                        [
                            150,
                            136
                        ],
                        [
                            136,
                            172
                        ],
                        [
                            172,
                            58
                        ],
                        [
                            58,
                            132
                        ],
                        [
                            132,
                            93
                        ],
                        [
                            93,
                            234
                        ],
                        [
                            234,
                            127
                        ],
                        [
                            127,
                            162
                        ],
                        [
                            162,
                            21
                        ],
                        [
                            21,
                            54
                        ],
                        [
                            54,
                            103
                        ],
                        [
                            103,
                            67
                        ],
                        [
                            67,
                            109
                        ],
                        [
                            109,
                            10
                        ]
                    ], tc = [].concat(D(nc), D(oc), D(pc), D(qc), D(rc), D(sc));
                    function uc(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function vc(a) {
                        return ib(a, bc, 1).map(function(b) {
                            return {
                                index: kb(b, 1),
                                ga: X(b, 2),
                                label: V(b, 3) != null ? lb(b, 3) : void 0,
                                displayName: V(b, 4) != null ? lb(b, 4) : void 0
                            };
                        });
                    }
                    function wc(a) {
                        return {
                            x: X(a, 1),
                            y: X(a, 2),
                            z: X(a, 3),
                            visibility: V(a, 4) != null ? X(a, 4) : void 0
                        };
                    }
                    function xc(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function yc(a, b, c) {
                        zc(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function zc(a, b) {
                        var c = a.g;
                        if (a.o === void 0) {
                            var d = uc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = uc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.o = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                K: c.getAttribLocation(d, "aVertex"),
                                J: c.getAttribLocation(d, "aTex"),
                                ma: e
                            };
                            a.u = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.u);
                            c.enableVertexAttribArray(a.j.K);
                            c.vertexAttribPointer(a.j.K, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.J);
                            c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.o);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.K);
                        c.bindBuffer(c.ARRAY_BUFFER, a.u);
                        c.vertexAttribPointer(d.K, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.J);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.K);
                        c.disableVertexAttribArray(d.J);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function Ac(a) {
                        this.g = a;
                    }
                    var Bc = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function Cc(a, b) {
                        return b + a;
                    }
                    function Dc(a, b) {
                        window[a] = b;
                    }
                    function Ec(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function Fc() {
                        return J(function(a) {
                            switch(a.g){
                                case 1:
                                    return a.o = 2, G(a, WebAssembly.instantiate(Bc), 4);
                                case 4:
                                    a.g = 3;
                                    a.o = 0;
                                    break;
                                case 2:
                                    return a.o = 0, a.j = null, a.return(false);
                                case 3:
                                    return a.return(true);
                            }
                        });
                    }
                    function Gc(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.H = {};
                        this.o = {};
                        this.u = {};
                        this.I = this.s = this.Z = true;
                        this.D = Promise.resolve();
                        this.Y = "";
                        this.C = {};
                        this.locateFile = a && a.locateFile || Cc;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.$ = b;
                        if (a.options) {
                            b = C(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    x = Gc.prototype;
                    x.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Hc(a) {
                        var b, c, d, e, g, f, h, k, l, m, q;
                        return J(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!a.Z) return p.return();
                                    b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
                                    return G(p, Fc(), 2);
                                case 2:
                                    c = p.h;
                                    if (typeof window === "object") return Dc("createMediapipeSolutionsWasm", {
                                        locateFile: a.locateFile
                                    }), Dc("createMediapipeSolutionsPackedAssets", {
                                        locateFile: a.locateFile
                                    }), f = b.filter(function(n) {
                                        return n.data !== void 0;
                                    }), h = b.filter(function(n) {
                                        return n.data === void 0;
                                    }), k = Promise.all(f.map(function(n) {
                                        var r = Ic(a, n.url);
                                        if (n.path !== void 0) {
                                            var t = n.path;
                                            r = r.then(function(w) {
                                                a.overrideFile(t, w);
                                                return Promise.resolve(w);
                                            });
                                        }
                                        return r;
                                    })), l = Promise.all(h.map(function(n) {
                                        return n.simd === void 0 || n.simd && c || !n.simd && !c ? Ec(a.locateFile(n.url, a.$)) : Promise.resolve();
                                    })).then(function() {
                                        var n, r, t;
                                        return J(function(w) {
                                            if (w.g == 1) return n = window.createMediapipeSolutionsWasm, r = window.createMediapipeSolutionsPackedAssets, t = a, G(w, n(r), 2);
                                            t.h = w.h;
                                            w.g = 0;
                                        });
                                    }), m = function() {
                                        return J(function(n) {
                                            a.g.graph && a.g.graph.url ? n = G(n, Ic(a, a.g.graph.url), 0) : (n.g = 0, n = void 0);
                                            return n;
                                        });
                                    }(), G(p, Promise.all([
                                        l,
                                        k,
                                        m
                                    ]), 7);
                                    if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                    d = b.filter(function(n) {
                                        return n.simd === void 0 || n.simd && c || !n.simd && !c;
                                    }).map(function(n) {
                                        return a.locateFile(n.url, a.$);
                                    });
                                    importScripts.apply(null, D(d));
                                    e = a;
                                    return G(p, createMediapipeSolutionsWasm(Module), 6);
                                case 6:
                                    e.h = p.h;
                                    a.l = new OffscreenCanvas(1, 1);
                                    a.h.canvas = a.l;
                                    g = a.h.GL.createContext(a.l, {
                                        antialias: false,
                                        alpha: false,
                                        ja: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                    });
                                    a.h.GL.makeContextCurrent(g);
                                    p.g = 4;
                                    break;
                                case 7:
                                    a.l = document.createElement("canvas");
                                    q = a.l.getContext("webgl2", {});
                                    if (!q && (q = a.l.getContext("webgl", {}), !q)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                                    a.G = q;
                                    a.h.canvas = a.l;
                                    a.h.createContext(a.l, true, true, {});
                                case 4:
                                    a.i = new a.h.SolutionWasm(), a.Z = false, p.g = 0;
                            }
                        });
                    }
                    function Jc(a) {
                        var b, c, d, e, g, f, h, k;
                        return J(function(l) {
                            if (l.g == 1) {
                                if (a.g.graph && a.g.graph.url && a.Y === a.g.graph.url) return l.return();
                                a.s = true;
                                if (!a.g.graph || !a.g.graph.url) {
                                    l.g = 2;
                                    return;
                                }
                                a.Y = a.g.graph.url;
                                return G(l, Ic(a, a.g.graph.url), 3);
                            }
                            l.g != 2 && (b = l.h, a.i.loadGraph(b));
                            c = C(Object.keys(a.C));
                            for(d = c.next(); !d.done; d = c.next())e = d.value, a.i.overrideFile(e, a.C[e]);
                            a.C = {};
                            if (a.g.listeners) for(g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())h = f.value, Kc(a, h);
                            k = a.j;
                            a.j = {};
                            a.setOptions(k);
                            l.g = 0;
                        });
                    }
                    x.reset = function() {
                        var a = this;
                        return J(function(b) {
                            a.i && (a.i.reset(), a.o = {}, a.u = {});
                            b.g = 0;
                        });
                    };
                    x.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = C(Object.keys(a)), h = f.next(); !h.done; g = {
                                R: g.R,
                                S: g.S
                            }, h = f.next()){
                                var k = h.value;
                                k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.R = h.onChange, g.S = a[k], d.push(function(l) {
                                    return function() {
                                        var m;
                                        return J(function(q) {
                                            if (q.g == 1) return G(q, l.R(l.S), 2);
                                            m = q.h;
                                            m === true && (c.s = true);
                                            q.g = 0;
                                        });
                                    };
                                }(g))), h.graphOptionXref && (k = {
                                    valueNumber: h.type === 1 ? a[k] : 0,
                                    valueBoolean: h.type === 0 ? a[k] : false,
                                    valueString: h.type === 2 ? a[k] : ""
                                }, h = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), h.graphOptionXref), k), e.push(h))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.s = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
                        }
                    };
                    function Lc(a) {
                        var b, c, d, e, g, f, h;
                        return J(function(k) {
                            switch(k.g){
                                case 1:
                                    if (!a.s) return k.return();
                                    if (!a.A) {
                                        k.g = 2;
                                        break;
                                    }
                                    b = C(a.A);
                                    c = b.next();
                                case 3:
                                    if (c.done) {
                                        k.g = 5;
                                        break;
                                    }
                                    d = c.value;
                                    return G(k, d(), 4);
                                case 4:
                                    c = b.next();
                                    k.g = 3;
                                    break;
                                case 5:
                                    a.A = void 0;
                                case 2:
                                    if (a.B) {
                                        e = new a.h.GraphOptionChangeRequestList();
                                        g = C(a.B);
                                        for(f = g.next(); !f.done; f = g.next())h = f.value, e.push_back(h);
                                        a.i.changeOptions(e);
                                        e.delete();
                                        a.B = void 0;
                                    }
                                    a.s = false;
                                    k.g = 0;
                            }
                        });
                    }
                    x.initialize = function() {
                        var a = this;
                        return J(function(b) {
                            return b.g == 1 ? G(b, Hc(a), 2) : b.g != 3 ? G(b, Jc(a), 3) : G(b, Lc(a), 0);
                        });
                    };
                    function Ic(a, b) {
                        var c, d;
                        return J(function(e) {
                            if (b in a.H) return e.return(a.H[b]);
                            c = a.locateFile(b, "");
                            d = fetch(c).then(function(g) {
                                return g.arrayBuffer();
                            });
                            a.H[b] = d;
                            return e.return(d);
                        });
                    }
                    x.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
                    };
                    x.clearOverriddenFiles = function() {
                        this.C = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    x.send = function(a, b) {
                        var c = this, d, e, g, f, h, k, l, m, q;
                        return J(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!c.g.inputs) return p.return();
                                    d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                    return G(p, c.D, 2);
                                case 2:
                                    return G(p, c.initialize(), 3);
                                case 3:
                                    e = new c.h.PacketDataList();
                                    g = C(Object.keys(a));
                                    for(f = g.next(); !f.done; f = g.next())if (h = f.value, k = c.g.inputs[h]) {
                                        a: {
                                            var n = a[h];
                                            switch(k.type){
                                                case "video":
                                                    var r = c.o[k.stream];
                                                    r || (r = new xc(c.h, c.G), c.o[k.stream] = r);
                                                    r.l === 0 && (r.l = r.h.createTexture());
                                                    if (typeof HTMLVideoElement !== "undefined" && n instanceof HTMLVideoElement) {
                                                        var t = n.videoWidth;
                                                        var w = n.videoHeight;
                                                    } else typeof HTMLImageElement !== "undefined" && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                                                    w = {
                                                        glName: r.l,
                                                        width: t,
                                                        height: w
                                                    };
                                                    t = r.g;
                                                    t.canvas.width = w.width;
                                                    t.canvas.height = w.height;
                                                    t.activeTexture(t.TEXTURE0);
                                                    r.h.bindTexture2d(r.l);
                                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                                                    r.h.bindTexture2d(0);
                                                    r = w;
                                                    break a;
                                                case "detections":
                                                    r = c.o[k.stream];
                                                    r || (r = new Ac(c.h), c.o[k.stream] = r);
                                                    r.data || (r.data = new r.g.DetectionListData());
                                                    r.data.reset(n.length);
                                                    for(w = 0; w < n.length; ++w){
                                                        t = n[w];
                                                        var v = r.data, A = v.setBoundingBox, I = w;
                                                        var F = t.boundingBox;
                                                        var u = new lc();
                                                        W(u, 1, F.xCenter);
                                                        W(u, 2, F.yCenter);
                                                        W(u, 3, F.height);
                                                        W(u, 4, F.width);
                                                        W(u, 5, F.rotation);
                                                        W(u, 6, F.rectId);
                                                        F = Vb(u, mc);
                                                        A.call(v, I, F);
                                                        if (t.landmarks) for(v = 0; v < t.landmarks.length; ++v){
                                                            u = t.landmarks[v];
                                                            var z = u.visibility ? true : false;
                                                            A = r.data;
                                                            I = A.addNormalizedLandmark;
                                                            F = w;
                                                            u = Object.assign(Object.assign({}, u), {
                                                                visibility: z ? u.visibility : 0
                                                            });
                                                            z = new gc();
                                                            W(z, 1, u.x);
                                                            W(z, 2, u.y);
                                                            W(z, 3, u.z);
                                                            u.visibility && W(z, 4, u.visibility);
                                                            u = Vb(z, hc);
                                                            I.call(A, F, u);
                                                        }
                                                        if (t.V) for(v = 0; v < t.V.length; ++v)A = r.data, I = A.addClassification, F = w, u = t.V[v], z = new bc(), W(z, 2, u.ga), u.index && W(z, 1, u.index), u.label && W(z, 3, u.label), u.displayName && W(z, 4, u.displayName), u = Vb(z, cc), I.call(A, F, u);
                                                    }
                                                    r = r.data;
                                                    break a;
                                                default:
                                                    r = {};
                                            }
                                        }
                                        l = r;
                                        m = k.stream;
                                        switch(k.type){
                                            case "video":
                                                e.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                    stream: m,
                                                    timestamp: d
                                                }));
                                                break;
                                            case "detections":
                                                q = l;
                                                q.stream = m;
                                                q.timestamp = d;
                                                e.pushDetectionList(q);
                                                break;
                                            default:
                                                throw Error("Unknown input config type: '" + k.type + "'");
                                        }
                                    }
                                    c.i.send(e);
                                    return G(p, c.D, 4);
                                case 4:
                                    e.delete(), p.g = 0;
                            }
                        });
                    };
                    function Mc(a, b, c) {
                        var d, e, g, f, h, k, l, m, q, p, n, r, t, w;
                        return J(function(v) {
                            switch(v.g){
                                case 1:
                                    if (!c) return v.return(b);
                                    d = {};
                                    e = 0;
                                    g = C(Object.keys(c));
                                    for(f = g.next(); !f.done; f = g.next())h = f.value, k = c[h], typeof k !== "string" && k.type === "texture" && b[k.stream] !== void 0 && ++e;
                                    1 < e && (a.I = false);
                                    l = C(Object.keys(c));
                                    f = l.next();
                                case 2:
                                    if (f.done) {
                                        v.g = 4;
                                        break;
                                    }
                                    m = f.value;
                                    q = c[m];
                                    if (typeof q === "string") return t = d, w = m, G(v, Nc(a, m, b[q]), 14);
                                    p = b[q.stream];
                                    if (q.type === "detection_list") {
                                        if (p) {
                                            var A = p.getRectList();
                                            for(var I = p.getLandmarksList(), F = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z){
                                                var R = Ub(A.get(z), lc, mc);
                                                R = {
                                                    boundingBox: {
                                                        xCenter: X(R, 1),
                                                        yCenter: X(R, 2),
                                                        height: X(R, 3),
                                                        width: X(R, 4),
                                                        rotation: X(R, 5, 0),
                                                        rectId: kb(R, 6)
                                                    },
                                                    landmarks: ib(Ub(I.get(z), ic, kc), gc, 1).map(wc),
                                                    V: vc(Ub(F.get(z), dc, fc))
                                                };
                                                u.push(R);
                                            }
                                            A = u;
                                        } else A = [];
                                        d[m] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (q.type === "proto_list") {
                                        if (p) {
                                            A = Array(p.size());
                                            for(I = 0; I < p.size(); I++)A[I] = p.get(I);
                                            p.delete();
                                        } else A = [];
                                        d[m] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (p === void 0) {
                                        v.g = 3;
                                        break;
                                    }
                                    if (q.type === "float_list") {
                                        d[m] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (q.type === "proto") {
                                        d[m] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (q.type !== "texture") throw Error("Unknown output config type: '" + q.type + "'");
                                    n = a.u[m];
                                    n || (n = new xc(a.h, a.G), a.u[m] = n);
                                    return G(v, yc(n, p, a.I), 13);
                                case 13:
                                    r = v.h, d[m] = r;
                                case 7:
                                    q.transform && d[m] && (d[m] = q.transform(d[m]));
                                    v.g = 3;
                                    break;
                                case 14:
                                    t[w] = v.h;
                                case 3:
                                    f = l.next();
                                    v.g = 2;
                                    break;
                                case 4:
                                    return v.return(d);
                            }
                        });
                    }
                    function Nc(a, b, c) {
                        var d;
                        return J(function(e) {
                            return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.u[b], d || (d = new xc(a.h, a.G), a.u[b] = d), e.return(yc(d, c, a.I))) : e.return(void 0);
                        });
                    }
                    function Kc(a, b) {
                        for(var c = b.name || "$", d = [].concat(D(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(h) {
                                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                                var m = a.listeners[c];
                                m && (a.D = Mc(a, k, b.outs).then(function(q) {
                                    q = m(q);
                                    for(var p = 0; p < b.wants.length; ++p){
                                        var n = k[d[p]];
                                        typeof n === "object" && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
                                    }
                                    q && (a.D = q);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    x.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    K("Solution", Gc);
                    K("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        ia: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function Oc(a) {
                        var b = this;
                        a = a || {};
                        var c = {
                            url: "face_detection_short.binarypb"
                        }, d = {
                            type: 1,
                            graphOptionXref: {
                                calculatorType: "TensorsToDetectionsCalculator",
                                calculatorName: "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator",
                                fieldName: "min_score_thresh"
                            }
                        };
                        this.g = new Gc({
                            locateFile: a.locateFile,
                            files: [
                                {
                                    data: true,
                                    url: "face_detection_short.binarypb"
                                },
                                {
                                    data: true,
                                    url: "face_detection_short_range.tflite"
                                },
                                {
                                    simd: true,
                                    url: "face_detection_solution_simd_wasm_bin.js"
                                },
                                {
                                    simd: false,
                                    url: "face_detection_solution_wasm_bin.js"
                                }
                            ],
                            graph: c,
                            listeners: [
                                {
                                    wants: [
                                        "detections",
                                        "image_transformed"
                                    ],
                                    outs: {
                                        image: "image_transformed",
                                        detections: {
                                            type: "detection_list",
                                            stream: "detections"
                                        }
                                    }
                                }
                            ],
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                selfieMode: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                model: {
                                    type: 0,
                                    onChange: function(e) {
                                        var g, f, h, k, l, m;
                                        return J(function(q) {
                                            switch(q.g){
                                                case 1:
                                                    g = e === "short" ? [
                                                        "face_detection_short_range.tflite"
                                                    ] : [
                                                        "face_detection_full_range_sparse.tflite"
                                                    ], f = C(g), h = f.next();
                                                case 2:
                                                    if (h.done) {
                                                        q.g = 4;
                                                        break;
                                                    }
                                                    k = h.value;
                                                    l = "third_party/mediapipe/modules/face_detection/" + k;
                                                    return G(q, Ic(b.g, k), 5);
                                                case 5:
                                                    m = q.h;
                                                    b.g.overrideFile(l, m);
                                                    h = f.next();
                                                    q.g = 2;
                                                    break;
                                                case 4:
                                                    return c.url = e === "short" ? "face_detection_short.binarypb" : "face_detection_full.binarypb", d.graphOptionXref.calculatorName = e === "short" ? "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator" : "facedetectionfullrangegpu__facedetectionfullrangecommon__TensorsToDetectionsCalculator", q.return(true);
                                            }
                                        });
                                    }
                                },
                                minDetectionConfidence: d
                            }
                        });
                    }
                    x = Oc.prototype;
                    x.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    x.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    x.initialize = function() {
                        var a = this;
                        return J(function(b) {
                            return G(b, a.g.initialize(), 0);
                        });
                    };
                    x.reset = function() {
                        this.g.reset();
                    };
                    x.send = function(a) {
                        var b = this;
                        return J(function(c) {
                            return G(c, b.g.send(a), 0);
                        });
                    };
                    x.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    K("FaceDetection", Oc);
                    K("FACEDETECTION_LIPS", nc);
                    K("FACEDETECTION_LEFT_EYE", oc);
                    K("FACEDETECTION_LEFT_EYEBROW", pc);
                    K("FACEDETECTION_RIGHT_EYE", qc);
                    K("FACEDETECTION_RIGHT_EYEBROW", rc);
                    K("FACEDETECTION_FACE_OVAL", sc);
                    K("FACEDETECTION_CONTOURS", tc);
                    K("FACEDETECTION_TESSELATION", [
                        [
                            127,
                            34
                        ],
                        [
                            34,
                            139
                        ],
                        [
                            139,
                            127
                        ],
                        [
                            11,
                            0
                        ],
                        [
                            0,
                            37
                        ],
                        [
                            37,
                            11
                        ],
                        [
                            232,
                            231
                        ],
                        [
                            231,
                            120
                        ],
                        [
                            120,
                            232
                        ],
                        [
                            72,
                            37
                        ],
                        [
                            37,
                            39
                        ],
                        [
                            39,
                            72
                        ],
                        [
                            128,
                            121
                        ],
                        [
                            121,
                            47
                        ],
                        [
                            47,
                            128
                        ],
                        [
                            232,
                            121
                        ],
                        [
                            121,
                            128
                        ],
                        [
                            128,
                            232
                        ],
                        [
                            104,
                            69
                        ],
                        [
                            69,
                            67
                        ],
                        [
                            67,
                            104
                        ],
                        [
                            175,
                            171
                        ],
                        [
                            171,
                            148
                        ],
                        [
                            148,
                            175
                        ],
                        [
                            118,
                            50
                        ],
                        [
                            50,
                            101
                        ],
                        [
                            101,
                            118
                        ],
                        [
                            73,
                            39
                        ],
                        [
                            39,
                            40
                        ],
                        [
                            40,
                            73
                        ],
                        [
                            9,
                            151
                        ],
                        [
                            151,
                            108
                        ],
                        [
                            108,
                            9
                        ],
                        [
                            48,
                            115
                        ],
                        [
                            115,
                            131
                        ],
                        [
                            131,
                            48
                        ],
                        [
                            194,
                            204
                        ],
                        [
                            204,
                            211
                        ],
                        [
                            211,
                            194
                        ],
                        [
                            74,
                            40
                        ],
                        [
                            40,
                            185
                        ],
                        [
                            185,
                            74
                        ],
                        [
                            80,
                            42
                        ],
                        [
                            42,
                            183
                        ],
                        [
                            183,
                            80
                        ],
                        [
                            40,
                            92
                        ],
                        [
                            92,
                            186
                        ],
                        [
                            186,
                            40
                        ],
                        [
                            230,
                            229
                        ],
                        [
                            229,
                            118
                        ],
                        [
                            118,
                            230
                        ],
                        [
                            202,
                            212
                        ],
                        [
                            212,
                            214
                        ],
                        [
                            214,
                            202
                        ],
                        [
                            83,
                            18
                        ],
                        [
                            18,
                            17
                        ],
                        [
                            17,
                            83
                        ],
                        [
                            76,
                            61
                        ],
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            76
                        ],
                        [
                            160,
                            29
                        ],
                        [
                            29,
                            30
                        ],
                        [
                            30,
                            160
                        ],
                        [
                            56,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            56
                        ],
                        [
                            106,
                            204
                        ],
                        [
                            204,
                            194
                        ],
                        [
                            194,
                            106
                        ],
                        [
                            135,
                            214
                        ],
                        [
                            214,
                            192
                        ],
                        [
                            192,
                            135
                        ],
                        [
                            203,
                            165
                        ],
                        [
                            165,
                            98
                        ],
                        [
                            98,
                            203
                        ],
                        [
                            21,
                            71
                        ],
                        [
                            71,
                            68
                        ],
                        [
                            68,
                            21
                        ],
                        [
                            51,
                            45
                        ],
                        [
                            45,
                            4
                        ],
                        [
                            4,
                            51
                        ],
                        [
                            144,
                            24
                        ],
                        [
                            24,
                            23
                        ],
                        [
                            23,
                            144
                        ],
                        [
                            77,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            77
                        ],
                        [
                            205,
                            50
                        ],
                        [
                            50,
                            187
                        ],
                        [
                            187,
                            205
                        ],
                        [
                            201,
                            200
                        ],
                        [
                            200,
                            18
                        ],
                        [
                            18,
                            201
                        ],
                        [
                            91,
                            106
                        ],
                        [
                            106,
                            182
                        ],
                        [
                            182,
                            91
                        ],
                        [
                            90,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            90
                        ],
                        [
                            85,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            85
                        ],
                        [
                            206,
                            203
                        ],
                        [
                            203,
                            36
                        ],
                        [
                            36,
                            206
                        ],
                        [
                            148,
                            171
                        ],
                        [
                            171,
                            140
                        ],
                        [
                            140,
                            148
                        ],
                        [
                            92,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            92
                        ],
                        [
                            193,
                            189
                        ],
                        [
                            189,
                            244
                        ],
                        [
                            244,
                            193
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            28
                        ],
                        [
                            28,
                            159
                        ],
                        [
                            247,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            247
                        ],
                        [
                            236,
                            3
                        ],
                        [
                            3,
                            196
                        ],
                        [
                            196,
                            236
                        ],
                        [
                            54,
                            68
                        ],
                        [
                            68,
                            104
                        ],
                        [
                            104,
                            54
                        ],
                        [
                            193,
                            168
                        ],
                        [
                            168,
                            8
                        ],
                        [
                            8,
                            193
                        ],
                        [
                            117,
                            228
                        ],
                        [
                            228,
                            31
                        ],
                        [
                            31,
                            117
                        ],
                        [
                            189,
                            193
                        ],
                        [
                            193,
                            55
                        ],
                        [
                            55,
                            189
                        ],
                        [
                            98,
                            97
                        ],
                        [
                            97,
                            99
                        ],
                        [
                            99,
                            98
                        ],
                        [
                            126,
                            47
                        ],
                        [
                            47,
                            100
                        ],
                        [
                            100,
                            126
                        ],
                        [
                            166,
                            79
                        ],
                        [
                            79,
                            218
                        ],
                        [
                            218,
                            166
                        ],
                        [
                            155,
                            154
                        ],
                        [
                            154,
                            26
                        ],
                        [
                            26,
                            155
                        ],
                        [
                            209,
                            49
                        ],
                        [
                            49,
                            131
                        ],
                        [
                            131,
                            209
                        ],
                        [
                            135,
                            136
                        ],
                        [
                            136,
                            150
                        ],
                        [
                            150,
                            135
                        ],
                        [
                            47,
                            126
                        ],
                        [
                            126,
                            217
                        ],
                        [
                            217,
                            47
                        ],
                        [
                            223,
                            52
                        ],
                        [
                            52,
                            53
                        ],
                        [
                            53,
                            223
                        ],
                        [
                            45,
                            51
                        ],
                        [
                            51,
                            134
                        ],
                        [
                            134,
                            45
                        ],
                        [
                            211,
                            170
                        ],
                        [
                            170,
                            140
                        ],
                        [
                            140,
                            211
                        ],
                        [
                            67,
                            69
                        ],
                        [
                            69,
                            108
                        ],
                        [
                            108,
                            67
                        ],
                        [
                            43,
                            106
                        ],
                        [
                            106,
                            91
                        ],
                        [
                            91,
                            43
                        ],
                        [
                            230,
                            119
                        ],
                        [
                            119,
                            120
                        ],
                        [
                            120,
                            230
                        ],
                        [
                            226,
                            130
                        ],
                        [
                            130,
                            247
                        ],
                        [
                            247,
                            226
                        ],
                        [
                            63,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            63
                        ],
                        [
                            238,
                            20
                        ],
                        [
                            20,
                            242
                        ],
                        [
                            242,
                            238
                        ],
                        [
                            46,
                            70
                        ],
                        [
                            70,
                            156
                        ],
                        [
                            156,
                            46
                        ],
                        [
                            78,
                            62
                        ],
                        [
                            62,
                            96
                        ],
                        [
                            96,
                            78
                        ],
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            63
                        ],
                        [
                            63,
                            46
                        ],
                        [
                            143,
                            34
                        ],
                        [
                            34,
                            227
                        ],
                        [
                            227,
                            143
                        ],
                        [
                            123,
                            117
                        ],
                        [
                            117,
                            111
                        ],
                        [
                            111,
                            123
                        ],
                        [
                            44,
                            125
                        ],
                        [
                            125,
                            19
                        ],
                        [
                            19,
                            44
                        ],
                        [
                            236,
                            134
                        ],
                        [
                            134,
                            51
                        ],
                        [
                            51,
                            236
                        ],
                        [
                            216,
                            206
                        ],
                        [
                            206,
                            205
                        ],
                        [
                            205,
                            216
                        ],
                        [
                            154,
                            153
                        ],
                        [
                            153,
                            22
                        ],
                        [
                            22,
                            154
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            167
                        ],
                        [
                            167,
                            39
                        ],
                        [
                            200,
                            201
                        ],
                        [
                            201,
                            208
                        ],
                        [
                            208,
                            200
                        ],
                        [
                            36,
                            142
                        ],
                        [
                            142,
                            100
                        ],
                        [
                            100,
                            36
                        ],
                        [
                            57,
                            212
                        ],
                        [
                            212,
                            202
                        ],
                        [
                            202,
                            57
                        ],
                        [
                            20,
                            60
                        ],
                        [
                            60,
                            99
                        ],
                        [
                            99,
                            20
                        ],
                        [
                            28,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            28
                        ],
                        [
                            35,
                            226
                        ],
                        [
                            226,
                            113
                        ],
                        [
                            113,
                            35
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            27
                        ],
                        [
                            27,
                            160
                        ],
                        [
                            204,
                            202
                        ],
                        [
                            202,
                            210
                        ],
                        [
                            210,
                            204
                        ],
                        [
                            113,
                            225
                        ],
                        [
                            225,
                            46
                        ],
                        [
                            46,
                            113
                        ],
                        [
                            43,
                            202
                        ],
                        [
                            202,
                            204
                        ],
                        [
                            204,
                            43
                        ],
                        [
                            62,
                            76
                        ],
                        [
                            76,
                            77
                        ],
                        [
                            77,
                            62
                        ],
                        [
                            137,
                            123
                        ],
                        [
                            123,
                            116
                        ],
                        [
                            116,
                            137
                        ],
                        [
                            41,
                            38
                        ],
                        [
                            38,
                            72
                        ],
                        [
                            72,
                            41
                        ],
                        [
                            203,
                            129
                        ],
                        [
                            129,
                            142
                        ],
                        [
                            142,
                            203
                        ],
                        [
                            64,
                            98
                        ],
                        [
                            98,
                            240
                        ],
                        [
                            240,
                            64
                        ],
                        [
                            49,
                            102
                        ],
                        [
                            102,
                            64
                        ],
                        [
                            64,
                            49
                        ],
                        [
                            41,
                            73
                        ],
                        [
                            73,
                            74
                        ],
                        [
                            74,
                            41
                        ],
                        [
                            212,
                            216
                        ],
                        [
                            216,
                            207
                        ],
                        [
                            207,
                            212
                        ],
                        [
                            42,
                            74
                        ],
                        [
                            74,
                            184
                        ],
                        [
                            184,
                            42
                        ],
                        [
                            169,
                            170
                        ],
                        [
                            170,
                            211
                        ],
                        [
                            211,
                            169
                        ],
                        [
                            170,
                            149
                        ],
                        [
                            149,
                            176
                        ],
                        [
                            176,
                            170
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            69
                        ],
                        [
                            69,
                            105
                        ],
                        [
                            122,
                            6
                        ],
                        [
                            6,
                            168
                        ],
                        [
                            168,
                            122
                        ],
                        [
                            123,
                            147
                        ],
                        [
                            147,
                            187
                        ],
                        [
                            187,
                            123
                        ],
                        [
                            96,
                            77
                        ],
                        [
                            77,
                            90
                        ],
                        [
                            90,
                            96
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            55,
                            107
                        ],
                        [
                            107,
                            65
                        ],
                        [
                            89,
                            90
                        ],
                        [
                            90,
                            180
                        ],
                        [
                            180,
                            89
                        ],
                        [
                            101,
                            100
                        ],
                        [
                            100,
                            120
                        ],
                        [
                            120,
                            101
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            104
                        ],
                        [
                            104,
                            63
                        ],
                        [
                            93,
                            137
                        ],
                        [
                            137,
                            227
                        ],
                        [
                            227,
                            93
                        ],
                        [
                            15,
                            86
                        ],
                        [
                            86,
                            85
                        ],
                        [
                            85,
                            15
                        ],
                        [
                            129,
                            102
                        ],
                        [
                            102,
                            49
                        ],
                        [
                            49,
                            129
                        ],
                        [
                            14,
                            87
                        ],
                        [
                            87,
                            86
                        ],
                        [
                            86,
                            14
                        ],
                        [
                            55,
                            8
                        ],
                        [
                            8,
                            9
                        ],
                        [
                            9,
                            55
                        ],
                        [
                            100,
                            47
                        ],
                        [
                            47,
                            121
                        ],
                        [
                            121,
                            100
                        ],
                        [
                            145,
                            23
                        ],
                        [
                            23,
                            22
                        ],
                        [
                            22,
                            145
                        ],
                        [
                            88,
                            89
                        ],
                        [
                            89,
                            179
                        ],
                        [
                            179,
                            88
                        ],
                        [
                            6,
                            122
                        ],
                        [
                            122,
                            196
                        ],
                        [
                            196,
                            6
                        ],
                        [
                            88,
                            95
                        ],
                        [
                            95,
                            96
                        ],
                        [
                            96,
                            88
                        ],
                        [
                            138,
                            172
                        ],
                        [
                            172,
                            136
                        ],
                        [
                            136,
                            138
                        ],
                        [
                            215,
                            58
                        ],
                        [
                            58,
                            172
                        ],
                        [
                            172,
                            215
                        ],
                        [
                            115,
                            48
                        ],
                        [
                            48,
                            219
                        ],
                        [
                            219,
                            115
                        ],
                        [
                            42,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            42
                        ],
                        [
                            195,
                            3
                        ],
                        [
                            3,
                            51
                        ],
                        [
                            51,
                            195
                        ],
                        [
                            43,
                            146
                        ],
                        [
                            146,
                            61
                        ],
                        [
                            61,
                            43
                        ],
                        [
                            171,
                            175
                        ],
                        [
                            175,
                            199
                        ],
                        [
                            199,
                            171
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            38
                        ],
                        [
                            38,
                            81
                        ],
                        [
                            53,
                            46
                        ],
                        [
                            46,
                            225
                        ],
                        [
                            225,
                            53
                        ],
                        [
                            144,
                            163
                        ],
                        [
                            163,
                            110
                        ],
                        [
                            110,
                            144
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            66
                        ],
                        [
                            66,
                            52
                        ],
                        [
                            229,
                            228
                        ],
                        [
                            228,
                            117
                        ],
                        [
                            117,
                            229
                        ],
                        [
                            34,
                            127
                        ],
                        [
                            127,
                            234
                        ],
                        [
                            234,
                            34
                        ],
                        [
                            107,
                            108
                        ],
                        [
                            108,
                            69
                        ],
                        [
                            69,
                            107
                        ],
                        [
                            109,
                            108
                        ],
                        [
                            108,
                            151
                        ],
                        [
                            151,
                            109
                        ],
                        [
                            48,
                            64
                        ],
                        [
                            64,
                            235
                        ],
                        [
                            235,
                            48
                        ],
                        [
                            62,
                            78
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            62
                        ],
                        [
                            129,
                            209
                        ],
                        [
                            209,
                            126
                        ],
                        [
                            126,
                            129
                        ],
                        [
                            111,
                            35
                        ],
                        [
                            35,
                            143
                        ],
                        [
                            143,
                            111
                        ],
                        [
                            117,
                            123
                        ],
                        [
                            123,
                            50
                        ],
                        [
                            50,
                            117
                        ],
                        [
                            222,
                            65
                        ],
                        [
                            65,
                            52
                        ],
                        [
                            52,
                            222
                        ],
                        [
                            19,
                            125
                        ],
                        [
                            125,
                            141
                        ],
                        [
                            141,
                            19
                        ],
                        [
                            221,
                            55
                        ],
                        [
                            55,
                            65
                        ],
                        [
                            65,
                            221
                        ],
                        [
                            3,
                            195
                        ],
                        [
                            195,
                            197
                        ],
                        [
                            197,
                            3
                        ],
                        [
                            25,
                            7
                        ],
                        [
                            7,
                            33
                        ],
                        [
                            33,
                            25
                        ],
                        [
                            220,
                            237
                        ],
                        [
                            237,
                            44
                        ],
                        [
                            44,
                            220
                        ],
                        [
                            70,
                            71
                        ],
                        [
                            71,
                            139
                        ],
                        [
                            139,
                            70
                        ],
                        [
                            122,
                            193
                        ],
                        [
                            193,
                            245
                        ],
                        [
                            245,
                            122
                        ],
                        [
                            247,
                            130
                        ],
                        [
                            130,
                            33
                        ],
                        [
                            33,
                            247
                        ],
                        [
                            71,
                            21
                        ],
                        [
                            21,
                            162
                        ],
                        [
                            162,
                            71
                        ],
                        [
                            170,
                            169
                        ],
                        [
                            169,
                            150
                        ],
                        [
                            150,
                            170
                        ],
                        [
                            188,
                            174
                        ],
                        [
                            174,
                            196
                        ],
                        [
                            196,
                            188
                        ],
                        [
                            216,
                            186
                        ],
                        [
                            186,
                            92
                        ],
                        [
                            92,
                            216
                        ],
                        [
                            2,
                            97
                        ],
                        [
                            97,
                            167
                        ],
                        [
                            167,
                            2
                        ],
                        [
                            141,
                            125
                        ],
                        [
                            125,
                            241
                        ],
                        [
                            241,
                            141
                        ],
                        [
                            164,
                            167
                        ],
                        [
                            167,
                            37
                        ],
                        [
                            37,
                            164
                        ],
                        [
                            72,
                            38
                        ],
                        [
                            38,
                            12
                        ],
                        [
                            12,
                            72
                        ],
                        [
                            38,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            38
                        ],
                        [
                            63,
                            68
                        ],
                        [
                            68,
                            71
                        ],
                        [
                            71,
                            63
                        ],
                        [
                            226,
                            35
                        ],
                        [
                            35,
                            111
                        ],
                        [
                            111,
                            226
                        ],
                        [
                            101,
                            50
                        ],
                        [
                            50,
                            205
                        ],
                        [
                            205,
                            101
                        ],
                        [
                            206,
                            92
                        ],
                        [
                            92,
                            165
                        ],
                        [
                            165,
                            206
                        ],
                        [
                            209,
                            198
                        ],
                        [
                            198,
                            217
                        ],
                        [
                            217,
                            209
                        ],
                        [
                            165,
                            167
                        ],
                        [
                            167,
                            97
                        ],
                        [
                            97,
                            165
                        ],
                        [
                            220,
                            115
                        ],
                        [
                            115,
                            218
                        ],
                        [
                            218,
                            220
                        ],
                        [
                            133,
                            112
                        ],
                        [
                            112,
                            243
                        ],
                        [
                            243,
                            133
                        ],
                        [
                            239,
                            238
                        ],
                        [
                            238,
                            241
                        ],
                        [
                            241,
                            239
                        ],
                        [
                            214,
                            135
                        ],
                        [
                            135,
                            169
                        ],
                        [
                            169,
                            214
                        ],
                        [
                            190,
                            173
                        ],
                        [
                            173,
                            133
                        ],
                        [
                            133,
                            190
                        ],
                        [
                            171,
                            208
                        ],
                        [
                            208,
                            32
                        ],
                        [
                            32,
                            171
                        ],
                        [
                            125,
                            44
                        ],
                        [
                            44,
                            237
                        ],
                        [
                            237,
                            125
                        ],
                        [
                            86,
                            87
                        ],
                        [
                            87,
                            178
                        ],
                        [
                            178,
                            86
                        ],
                        [
                            85,
                            86
                        ],
                        [
                            86,
                            179
                        ],
                        [
                            179,
                            85
                        ],
                        [
                            84,
                            85
                        ],
                        [
                            85,
                            180
                        ],
                        [
                            180,
                            84
                        ],
                        [
                            83,
                            84
                        ],
                        [
                            84,
                            181
                        ],
                        [
                            181,
                            83
                        ],
                        [
                            201,
                            83
                        ],
                        [
                            83,
                            182
                        ],
                        [
                            182,
                            201
                        ],
                        [
                            137,
                            93
                        ],
                        [
                            93,
                            132
                        ],
                        [
                            132,
                            137
                        ],
                        [
                            76,
                            62
                        ],
                        [
                            62,
                            183
                        ],
                        [
                            183,
                            76
                        ],
                        [
                            61,
                            76
                        ],
                        [
                            76,
                            184
                        ],
                        [
                            184,
                            61
                        ],
                        [
                            57,
                            61
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            57
                        ],
                        [
                            212,
                            57
                        ],
                        [
                            57,
                            186
                        ],
                        [
                            186,
                            212
                        ],
                        [
                            214,
                            207
                        ],
                        [
                            207,
                            187
                        ],
                        [
                            187,
                            214
                        ],
                        [
                            34,
                            143
                        ],
                        [
                            143,
                            156
                        ],
                        [
                            156,
                            34
                        ],
                        [
                            79,
                            239
                        ],
                        [
                            239,
                            237
                        ],
                        [
                            237,
                            79
                        ],
                        [
                            123,
                            137
                        ],
                        [
                            137,
                            177
                        ],
                        [
                            177,
                            123
                        ],
                        [
                            44,
                            1
                        ],
                        [
                            1,
                            4
                        ],
                        [
                            4,
                            44
                        ],
                        [
                            201,
                            194
                        ],
                        [
                            194,
                            32
                        ],
                        [
                            32,
                            201
                        ],
                        [
                            64,
                            102
                        ],
                        [
                            102,
                            129
                        ],
                        [
                            129,
                            64
                        ],
                        [
                            213,
                            215
                        ],
                        [
                            215,
                            138
                        ],
                        [
                            138,
                            213
                        ],
                        [
                            59,
                            166
                        ],
                        [
                            166,
                            219
                        ],
                        [
                            219,
                            59
                        ],
                        [
                            242,
                            99
                        ],
                        [
                            99,
                            97
                        ],
                        [
                            97,
                            242
                        ],
                        [
                            2,
                            94
                        ],
                        [
                            94,
                            141
                        ],
                        [
                            141,
                            2
                        ],
                        [
                            75,
                            59
                        ],
                        [
                            59,
                            235
                        ],
                        [
                            235,
                            75
                        ],
                        [
                            24,
                            110
                        ],
                        [
                            110,
                            228
                        ],
                        [
                            228,
                            24
                        ],
                        [
                            25,
                            130
                        ],
                        [
                            130,
                            226
                        ],
                        [
                            226,
                            25
                        ],
                        [
                            23,
                            24
                        ],
                        [
                            24,
                            229
                        ],
                        [
                            229,
                            23
                        ],
                        [
                            22,
                            23
                        ],
                        [
                            23,
                            230
                        ],
                        [
                            230,
                            22
                        ],
                        [
                            26,
                            22
                        ],
                        [
                            22,
                            231
                        ],
                        [
                            231,
                            26
                        ],
                        [
                            112,
                            26
                        ],
                        [
                            26,
                            232
                        ],
                        [
                            232,
                            112
                        ],
                        [
                            189,
                            190
                        ],
                        [
                            190,
                            243
                        ],
                        [
                            243,
                            189
                        ],
                        [
                            221,
                            56
                        ],
                        [
                            56,
                            190
                        ],
                        [
                            190,
                            221
                        ],
                        [
                            28,
                            56
                        ],
                        [
                            56,
                            221
                        ],
                        [
                            221,
                            28
                        ],
                        [
                            27,
                            28
                        ],
                        [
                            28,
                            222
                        ],
                        [
                            222,
                            27
                        ],
                        [
                            29,
                            27
                        ],
                        [
                            27,
                            223
                        ],
                        [
                            223,
                            29
                        ],
                        [
                            30,
                            29
                        ],
                        [
                            29,
                            224
                        ],
                        [
                            224,
                            30
                        ],
                        [
                            247,
                            30
                        ],
                        [
                            30,
                            225
                        ],
                        [
                            225,
                            247
                        ],
                        [
                            238,
                            79
                        ],
                        [
                            79,
                            20
                        ],
                        [
                            20,
                            238
                        ],
                        [
                            166,
                            59
                        ],
                        [
                            59,
                            75
                        ],
                        [
                            75,
                            166
                        ],
                        [
                            60,
                            75
                        ],
                        [
                            75,
                            240
                        ],
                        [
                            240,
                            60
                        ],
                        [
                            147,
                            177
                        ],
                        [
                            177,
                            215
                        ],
                        [
                            215,
                            147
                        ],
                        [
                            20,
                            79
                        ],
                        [
                            79,
                            166
                        ],
                        [
                            166,
                            20
                        ],
                        [
                            187,
                            147
                        ],
                        [
                            147,
                            213
                        ],
                        [
                            213,
                            187
                        ],
                        [
                            112,
                            233
                        ],
                        [
                            233,
                            244
                        ],
                        [
                            244,
                            112
                        ],
                        [
                            233,
                            128
                        ],
                        [
                            128,
                            245
                        ],
                        [
                            245,
                            233
                        ],
                        [
                            128,
                            114
                        ],
                        [
                            114,
                            188
                        ],
                        [
                            188,
                            128
                        ],
                        [
                            114,
                            217
                        ],
                        [
                            217,
                            174
                        ],
                        [
                            174,
                            114
                        ],
                        [
                            131,
                            115
                        ],
                        [
                            115,
                            220
                        ],
                        [
                            220,
                            131
                        ],
                        [
                            217,
                            198
                        ],
                        [
                            198,
                            236
                        ],
                        [
                            236,
                            217
                        ],
                        [
                            198,
                            131
                        ],
                        [
                            131,
                            134
                        ],
                        [
                            134,
                            198
                        ],
                        [
                            177,
                            132
                        ],
                        [
                            132,
                            58
                        ],
                        [
                            58,
                            177
                        ],
                        [
                            143,
                            35
                        ],
                        [
                            35,
                            124
                        ],
                        [
                            124,
                            143
                        ],
                        [
                            110,
                            163
                        ],
                        [
                            163,
                            7
                        ],
                        [
                            7,
                            110
                        ],
                        [
                            228,
                            110
                        ],
                        [
                            110,
                            25
                        ],
                        [
                            25,
                            228
                        ],
                        [
                            356,
                            389
                        ],
                        [
                            389,
                            368
                        ],
                        [
                            368,
                            356
                        ],
                        [
                            11,
                            302
                        ],
                        [
                            302,
                            267
                        ],
                        [
                            267,
                            11
                        ],
                        [
                            452,
                            350
                        ],
                        [
                            350,
                            349
                        ],
                        [
                            349,
                            452
                        ],
                        [
                            302,
                            303
                        ],
                        [
                            303,
                            269
                        ],
                        [
                            269,
                            302
                        ],
                        [
                            357,
                            343
                        ],
                        [
                            343,
                            277
                        ],
                        [
                            277,
                            357
                        ],
                        [
                            452,
                            453
                        ],
                        [
                            453,
                            357
                        ],
                        [
                            357,
                            452
                        ],
                        [
                            333,
                            332
                        ],
                        [
                            332,
                            297
                        ],
                        [
                            297,
                            333
                        ],
                        [
                            175,
                            152
                        ],
                        [
                            152,
                            377
                        ],
                        [
                            377,
                            175
                        ],
                        [
                            347,
                            348
                        ],
                        [
                            348,
                            330
                        ],
                        [
                            330,
                            347
                        ],
                        [
                            303,
                            304
                        ],
                        [
                            304,
                            270
                        ],
                        [
                            270,
                            303
                        ],
                        [
                            9,
                            336
                        ],
                        [
                            336,
                            337
                        ],
                        [
                            337,
                            9
                        ],
                        [
                            278,
                            279
                        ],
                        [
                            279,
                            360
                        ],
                        [
                            360,
                            278
                        ],
                        [
                            418,
                            262
                        ],
                        [
                            262,
                            431
                        ],
                        [
                            431,
                            418
                        ],
                        [
                            304,
                            408
                        ],
                        [
                            408,
                            409
                        ],
                        [
                            409,
                            304
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            407
                        ],
                        [
                            407,
                            310
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            410
                        ],
                        [
                            410,
                            270
                        ],
                        [
                            450,
                            348
                        ],
                        [
                            348,
                            347
                        ],
                        [
                            347,
                            450
                        ],
                        [
                            422,
                            430
                        ],
                        [
                            430,
                            434
                        ],
                        [
                            434,
                            422
                        ],
                        [
                            313,
                            314
                        ],
                        [
                            314,
                            17
                        ],
                        [
                            17,
                            313
                        ],
                        [
                            306,
                            307
                        ],
                        [
                            307,
                            375
                        ],
                        [
                            375,
                            306
                        ],
                        [
                            387,
                            388
                        ],
                        [
                            388,
                            260
                        ],
                        [
                            260,
                            387
                        ],
                        [
                            286,
                            414
                        ],
                        [
                            414,
                            398
                        ],
                        [
                            398,
                            286
                        ],
                        [
                            335,
                            406
                        ],
                        [
                            406,
                            418
                        ],
                        [
                            418,
                            335
                        ],
                        [
                            364,
                            367
                        ],
                        [
                            367,
                            416
                        ],
                        [
                            416,
                            364
                        ],
                        [
                            423,
                            358
                        ],
                        [
                            358,
                            327
                        ],
                        [
                            327,
                            423
                        ],
                        [
                            251,
                            284
                        ],
                        [
                            284,
                            298
                        ],
                        [
                            298,
                            251
                        ],
                        [
                            281,
                            5
                        ],
                        [
                            5,
                            4
                        ],
                        [
                            4,
                            281
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            253
                        ],
                        [
                            253,
                            373
                        ],
                        [
                            307,
                            320
                        ],
                        [
                            320,
                            321
                        ],
                        [
                            321,
                            307
                        ],
                        [
                            425,
                            427
                        ],
                        [
                            427,
                            411
                        ],
                        [
                            411,
                            425
                        ],
                        [
                            421,
                            313
                        ],
                        [
                            313,
                            18
                        ],
                        [
                            18,
                            421
                        ],
                        [
                            321,
                            405
                        ],
                        [
                            405,
                            406
                        ],
                        [
                            406,
                            321
                        ],
                        [
                            320,
                            404
                        ],
                        [
                            404,
                            405
                        ],
                        [
                            405,
                            320
                        ],
                        [
                            315,
                            16
                        ],
                        [
                            16,
                            17
                        ],
                        [
                            17,
                            315
                        ],
                        [
                            426,
                            425
                        ],
                        [
                            425,
                            266
                        ],
                        [
                            266,
                            426
                        ],
                        [
                            377,
                            400
                        ],
                        [
                            400,
                            369
                        ],
                        [
                            369,
                            377
                        ],
                        [
                            322,
                            391
                        ],
                        [
                            391,
                            269
                        ],
                        [
                            269,
                            322
                        ],
                        [
                            417,
                            465
                        ],
                        [
                            465,
                            464
                        ],
                        [
                            464,
                            417
                        ],
                        [
                            386,
                            257
                        ],
                        [
                            257,
                            258
                        ],
                        [
                            258,
                            386
                        ],
                        [
                            466,
                            260
                        ],
                        [
                            260,
                            388
                        ],
                        [
                            388,
                            466
                        ],
                        [
                            456,
                            399
                        ],
                        [
                            399,
                            419
                        ],
                        [
                            419,
                            456
                        ],
                        [
                            284,
                            332
                        ],
                        [
                            332,
                            333
                        ],
                        [
                            333,
                            284
                        ],
                        [
                            417,
                            285
                        ],
                        [
                            285,
                            8
                        ],
                        [
                            8,
                            417
                        ],
                        [
                            346,
                            340
                        ],
                        [
                            340,
                            261
                        ],
                        [
                            261,
                            346
                        ],
                        [
                            413,
                            441
                        ],
                        [
                            441,
                            285
                        ],
                        [
                            285,
                            413
                        ],
                        [
                            327,
                            460
                        ],
                        [
                            460,
                            328
                        ],
                        [
                            328,
                            327
                        ],
                        [
                            355,
                            371
                        ],
                        [
                            371,
                            329
                        ],
                        [
                            329,
                            355
                        ],
                        [
                            392,
                            439
                        ],
                        [
                            439,
                            438
                        ],
                        [
                            438,
                            392
                        ],
                        [
                            382,
                            341
                        ],
                        [
                            341,
                            256
                        ],
                        [
                            256,
                            382
                        ],
                        [
                            429,
                            420
                        ],
                        [
                            420,
                            360
                        ],
                        [
                            360,
                            429
                        ],
                        [
                            364,
                            394
                        ],
                        [
                            394,
                            379
                        ],
                        [
                            379,
                            364
                        ],
                        [
                            277,
                            343
                        ],
                        [
                            343,
                            437
                        ],
                        [
                            437,
                            277
                        ],
                        [
                            443,
                            444
                        ],
                        [
                            444,
                            283
                        ],
                        [
                            283,
                            443
                        ],
                        [
                            275,
                            440
                        ],
                        [
                            440,
                            363
                        ],
                        [
                            363,
                            275
                        ],
                        [
                            431,
                            262
                        ],
                        [
                            262,
                            369
                        ],
                        [
                            369,
                            431
                        ],
                        [
                            297,
                            338
                        ],
                        [
                            338,
                            337
                        ],
                        [
                            337,
                            297
                        ],
                        [
                            273,
                            375
                        ],
                        [
                            375,
                            321
                        ],
                        [
                            321,
                            273
                        ],
                        [
                            450,
                            451
                        ],
                        [
                            451,
                            349
                        ],
                        [
                            349,
                            450
                        ],
                        [
                            446,
                            342
                        ],
                        [
                            342,
                            467
                        ],
                        [
                            467,
                            446
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            282
                        ],
                        [
                            282,
                            293
                        ],
                        [
                            458,
                            461
                        ],
                        [
                            461,
                            462
                        ],
                        [
                            462,
                            458
                        ],
                        [
                            276,
                            353
                        ],
                        [
                            353,
                            383
                        ],
                        [
                            383,
                            276
                        ],
                        [
                            308,
                            324
                        ],
                        [
                            324,
                            325
                        ],
                        [
                            325,
                            308
                        ],
                        [
                            276,
                            300
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            276
                        ],
                        [
                            372,
                            345
                        ],
                        [
                            345,
                            447
                        ],
                        [
                            447,
                            372
                        ],
                        [
                            352,
                            345
                        ],
                        [
                            345,
                            340
                        ],
                        [
                            340,
                            352
                        ],
                        [
                            274,
                            1
                        ],
                        [
                            1,
                            19
                        ],
                        [
                            19,
                            274
                        ],
                        [
                            456,
                            248
                        ],
                        [
                            248,
                            281
                        ],
                        [
                            281,
                            456
                        ],
                        [
                            436,
                            427
                        ],
                        [
                            427,
                            425
                        ],
                        [
                            425,
                            436
                        ],
                        [
                            381,
                            256
                        ],
                        [
                            256,
                            252
                        ],
                        [
                            252,
                            381
                        ],
                        [
                            269,
                            391
                        ],
                        [
                            391,
                            393
                        ],
                        [
                            393,
                            269
                        ],
                        [
                            200,
                            199
                        ],
                        [
                            199,
                            428
                        ],
                        [
                            428,
                            200
                        ],
                        [
                            266,
                            330
                        ],
                        [
                            330,
                            329
                        ],
                        [
                            329,
                            266
                        ],
                        [
                            287,
                            273
                        ],
                        [
                            273,
                            422
                        ],
                        [
                            422,
                            287
                        ],
                        [
                            250,
                            462
                        ],
                        [
                            462,
                            328
                        ],
                        [
                            328,
                            250
                        ],
                        [
                            258,
                            286
                        ],
                        [
                            286,
                            384
                        ],
                        [
                            384,
                            258
                        ],
                        [
                            265,
                            353
                        ],
                        [
                            353,
                            342
                        ],
                        [
                            342,
                            265
                        ],
                        [
                            387,
                            259
                        ],
                        [
                            259,
                            257
                        ],
                        [
                            257,
                            387
                        ],
                        [
                            424,
                            431
                        ],
                        [
                            431,
                            430
                        ],
                        [
                            430,
                            424
                        ],
                        [
                            342,
                            353
                        ],
                        [
                            353,
                            276
                        ],
                        [
                            276,
                            342
                        ],
                        [
                            273,
                            335
                        ],
                        [
                            335,
                            424
                        ],
                        [
                            424,
                            273
                        ],
                        [
                            292,
                            325
                        ],
                        [
                            325,
                            307
                        ],
                        [
                            307,
                            292
                        ],
                        [
                            366,
                            447
                        ],
                        [
                            447,
                            345
                        ],
                        [
                            345,
                            366
                        ],
                        [
                            271,
                            303
                        ],
                        [
                            303,
                            302
                        ],
                        [
                            302,
                            271
                        ],
                        [
                            423,
                            266
                        ],
                        [
                            266,
                            371
                        ],
                        [
                            371,
                            423
                        ],
                        [
                            294,
                            455
                        ],
                        [
                            455,
                            460
                        ],
                        [
                            460,
                            294
                        ],
                        [
                            279,
                            278
                        ],
                        [
                            278,
                            294
                        ],
                        [
                            294,
                            279
                        ],
                        [
                            271,
                            272
                        ],
                        [
                            272,
                            304
                        ],
                        [
                            304,
                            271
                        ],
                        [
                            432,
                            434
                        ],
                        [
                            434,
                            427
                        ],
                        [
                            427,
                            432
                        ],
                        [
                            272,
                            407
                        ],
                        [
                            407,
                            408
                        ],
                        [
                            408,
                            272
                        ],
                        [
                            394,
                            430
                        ],
                        [
                            430,
                            431
                        ],
                        [
                            431,
                            394
                        ],
                        [
                            395,
                            369
                        ],
                        [
                            369,
                            400
                        ],
                        [
                            400,
                            395
                        ],
                        [
                            334,
                            333
                        ],
                        [
                            333,
                            299
                        ],
                        [
                            299,
                            334
                        ],
                        [
                            351,
                            417
                        ],
                        [
                            417,
                            168
                        ],
                        [
                            168,
                            351
                        ],
                        [
                            352,
                            280
                        ],
                        [
                            280,
                            411
                        ],
                        [
                            411,
                            352
                        ],
                        [
                            325,
                            319
                        ],
                        [
                            319,
                            320
                        ],
                        [
                            320,
                            325
                        ],
                        [
                            295,
                            296
                        ],
                        [
                            296,
                            336
                        ],
                        [
                            336,
                            295
                        ],
                        [
                            319,
                            403
                        ],
                        [
                            403,
                            404
                        ],
                        [
                            404,
                            319
                        ],
                        [
                            330,
                            348
                        ],
                        [
                            348,
                            349
                        ],
                        [
                            349,
                            330
                        ],
                        [
                            293,
                            298
                        ],
                        [
                            298,
                            333
                        ],
                        [
                            333,
                            293
                        ],
                        [
                            323,
                            454
                        ],
                        [
                            454,
                            447
                        ],
                        [
                            447,
                            323
                        ],
                        [
                            15,
                            16
                        ],
                        [
                            16,
                            315
                        ],
                        [
                            315,
                            15
                        ],
                        [
                            358,
                            429
                        ],
                        [
                            429,
                            279
                        ],
                        [
                            279,
                            358
                        ],
                        [
                            14,
                            15
                        ],
                        [
                            15,
                            316
                        ],
                        [
                            316,
                            14
                        ],
                        [
                            285,
                            336
                        ],
                        [
                            336,
                            9
                        ],
                        [
                            9,
                            285
                        ],
                        [
                            329,
                            349
                        ],
                        [
                            349,
                            350
                        ],
                        [
                            350,
                            329
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            252
                        ],
                        [
                            252,
                            374
                        ],
                        [
                            318,
                            402
                        ],
                        [
                            402,
                            403
                        ],
                        [
                            403,
                            318
                        ],
                        [
                            6,
                            197
                        ],
                        [
                            197,
                            419
                        ],
                        [
                            419,
                            6
                        ],
                        [
                            318,
                            319
                        ],
                        [
                            319,
                            325
                        ],
                        [
                            325,
                            318
                        ],
                        [
                            367,
                            364
                        ],
                        [
                            364,
                            365
                        ],
                        [
                            365,
                            367
                        ],
                        [
                            435,
                            367
                        ],
                        [
                            367,
                            397
                        ],
                        [
                            397,
                            435
                        ],
                        [
                            344,
                            438
                        ],
                        [
                            438,
                            439
                        ],
                        [
                            439,
                            344
                        ],
                        [
                            272,
                            271
                        ],
                        [
                            271,
                            311
                        ],
                        [
                            311,
                            272
                        ],
                        [
                            195,
                            5
                        ],
                        [
                            5,
                            281
                        ],
                        [
                            281,
                            195
                        ],
                        [
                            273,
                            287
                        ],
                        [
                            287,
                            291
                        ],
                        [
                            291,
                            273
                        ],
                        [
                            396,
                            428
                        ],
                        [
                            428,
                            199
                        ],
                        [
                            199,
                            396
                        ],
                        [
                            311,
                            271
                        ],
                        [
                            271,
                            268
                        ],
                        [
                            268,
                            311
                        ],
                        [
                            283,
                            444
                        ],
                        [
                            444,
                            445
                        ],
                        [
                            445,
                            283
                        ],
                        [
                            373,
                            254
                        ],
                        [
                            254,
                            339
                        ],
                        [
                            339,
                            373
                        ],
                        [
                            282,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            282
                        ],
                        [
                            449,
                            347
                        ],
                        [
                            347,
                            346
                        ],
                        [
                            346,
                            449
                        ],
                        [
                            264,
                            447
                        ],
                        [
                            447,
                            454
                        ],
                        [
                            454,
                            264
                        ],
                        [
                            336,
                            296
                        ],
                        [
                            296,
                            299
                        ],
                        [
                            299,
                            336
                        ],
                        [
                            338,
                            10
                        ],
                        [
                            10,
                            151
                        ],
                        [
                            151,
                            338
                        ],
                        [
                            278,
                            439
                        ],
                        [
                            439,
                            455
                        ],
                        [
                            455,
                            278
                        ],
                        [
                            292,
                            407
                        ],
                        [
                            407,
                            415
                        ],
                        [
                            415,
                            292
                        ],
                        [
                            358,
                            371
                        ],
                        [
                            371,
                            355
                        ],
                        [
                            355,
                            358
                        ],
                        [
                            340,
                            345
                        ],
                        [
                            345,
                            372
                        ],
                        [
                            372,
                            340
                        ],
                        [
                            346,
                            347
                        ],
                        [
                            347,
                            280
                        ],
                        [
                            280,
                            346
                        ],
                        [
                            442,
                            443
                        ],
                        [
                            443,
                            282
                        ],
                        [
                            282,
                            442
                        ],
                        [
                            19,
                            94
                        ],
                        [
                            94,
                            370
                        ],
                        [
                            370,
                            19
                        ],
                        [
                            441,
                            442
                        ],
                        [
                            442,
                            295
                        ],
                        [
                            295,
                            441
                        ],
                        [
                            248,
                            419
                        ],
                        [
                            419,
                            197
                        ],
                        [
                            197,
                            248
                        ],
                        [
                            263,
                            255
                        ],
                        [
                            255,
                            359
                        ],
                        [
                            359,
                            263
                        ],
                        [
                            440,
                            275
                        ],
                        [
                            275,
                            274
                        ],
                        [
                            274,
                            440
                        ],
                        [
                            300,
                            383
                        ],
                        [
                            383,
                            368
                        ],
                        [
                            368,
                            300
                        ],
                        [
                            351,
                            412
                        ],
                        [
                            412,
                            465
                        ],
                        [
                            465,
                            351
                        ],
                        [
                            263,
                            467
                        ],
                        [
                            467,
                            466
                        ],
                        [
                            466,
                            263
                        ],
                        [
                            301,
                            368
                        ],
                        [
                            368,
                            389
                        ],
                        [
                            389,
                            301
                        ],
                        [
                            395,
                            378
                        ],
                        [
                            378,
                            379
                        ],
                        [
                            379,
                            395
                        ],
                        [
                            412,
                            351
                        ],
                        [
                            351,
                            419
                        ],
                        [
                            419,
                            412
                        ],
                        [
                            436,
                            426
                        ],
                        [
                            426,
                            322
                        ],
                        [
                            322,
                            436
                        ],
                        [
                            2,
                            164
                        ],
                        [
                            164,
                            393
                        ],
                        [
                            393,
                            2
                        ],
                        [
                            370,
                            462
                        ],
                        [
                            462,
                            461
                        ],
                        [
                            461,
                            370
                        ],
                        [
                            164,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            164
                        ],
                        [
                            302,
                            11
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            12,
                            302
                        ],
                        [
                            268,
                            12
                        ],
                        [
                            12,
                            13
                        ],
                        [
                            13,
                            268
                        ],
                        [
                            293,
                            300
                        ],
                        [
                            300,
                            301
                        ],
                        [
                            301,
                            293
                        ],
                        [
                            446,
                            261
                        ],
                        [
                            261,
                            340
                        ],
                        [
                            340,
                            446
                        ],
                        [
                            330,
                            266
                        ],
                        [
                            266,
                            425
                        ],
                        [
                            425,
                            330
                        ],
                        [
                            426,
                            423
                        ],
                        [
                            423,
                            391
                        ],
                        [
                            391,
                            426
                        ],
                        [
                            429,
                            355
                        ],
                        [
                            355,
                            437
                        ],
                        [
                            437,
                            429
                        ],
                        [
                            391,
                            327
                        ],
                        [
                            327,
                            326
                        ],
                        [
                            326,
                            391
                        ],
                        [
                            440,
                            457
                        ],
                        [
                            457,
                            438
                        ],
                        [
                            438,
                            440
                        ],
                        [
                            341,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            362,
                            341
                        ],
                        [
                            459,
                            457
                        ],
                        [
                            457,
                            461
                        ],
                        [
                            461,
                            459
                        ],
                        [
                            434,
                            430
                        ],
                        [
                            430,
                            394
                        ],
                        [
                            394,
                            434
                        ],
                        [
                            414,
                            463
                        ],
                        [
                            463,
                            362
                        ],
                        [
                            362,
                            414
                        ],
                        [
                            396,
                            369
                        ],
                        [
                            369,
                            262
                        ],
                        [
                            262,
                            396
                        ],
                        [
                            354,
                            461
                        ],
                        [
                            461,
                            457
                        ],
                        [
                            457,
                            354
                        ],
                        [
                            316,
                            403
                        ],
                        [
                            403,
                            402
                        ],
                        [
                            402,
                            316
                        ],
                        [
                            315,
                            404
                        ],
                        [
                            404,
                            403
                        ],
                        [
                            403,
                            315
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            404
                        ],
                        [
                            404,
                            314
                        ],
                        [
                            313,
                            406
                        ],
                        [
                            406,
                            405
                        ],
                        [
                            405,
                            313
                        ],
                        [
                            421,
                            418
                        ],
                        [
                            418,
                            406
                        ],
                        [
                            406,
                            421
                        ],
                        [
                            366,
                            401
                        ],
                        [
                            401,
                            361
                        ],
                        [
                            361,
                            366
                        ],
                        [
                            306,
                            408
                        ],
                        [
                            408,
                            407
                        ],
                        [
                            407,
                            306
                        ],
                        [
                            291,
                            409
                        ],
                        [
                            409,
                            408
                        ],
                        [
                            408,
                            291
                        ],
                        [
                            287,
                            410
                        ],
                        [
                            410,
                            409
                        ],
                        [
                            409,
                            287
                        ],
                        [
                            432,
                            436
                        ],
                        [
                            436,
                            410
                        ],
                        [
                            410,
                            432
                        ],
                        [
                            434,
                            416
                        ],
                        [
                            416,
                            411
                        ],
                        [
                            411,
                            434
                        ],
                        [
                            264,
                            368
                        ],
                        [
                            368,
                            383
                        ],
                        [
                            383,
                            264
                        ],
                        [
                            309,
                            438
                        ],
                        [
                            438,
                            457
                        ],
                        [
                            457,
                            309
                        ],
                        [
                            352,
                            376
                        ],
                        [
                            376,
                            401
                        ],
                        [
                            401,
                            352
                        ],
                        [
                            274,
                            275
                        ],
                        [
                            275,
                            4
                        ],
                        [
                            4,
                            274
                        ],
                        [
                            421,
                            428
                        ],
                        [
                            428,
                            262
                        ],
                        [
                            262,
                            421
                        ],
                        [
                            294,
                            327
                        ],
                        [
                            327,
                            358
                        ],
                        [
                            358,
                            294
                        ],
                        [
                            433,
                            416
                        ],
                        [
                            416,
                            367
                        ],
                        [
                            367,
                            433
                        ],
                        [
                            289,
                            455
                        ],
                        [
                            455,
                            439
                        ],
                        [
                            439,
                            289
                        ],
                        [
                            462,
                            370
                        ],
                        [
                            370,
                            326
                        ],
                        [
                            326,
                            462
                        ],
                        [
                            2,
                            326
                        ],
                        [
                            326,
                            370
                        ],
                        [
                            370,
                            2
                        ],
                        [
                            305,
                            460
                        ],
                        [
                            460,
                            455
                        ],
                        [
                            455,
                            305
                        ],
                        [
                            254,
                            449
                        ],
                        [
                            449,
                            448
                        ],
                        [
                            448,
                            254
                        ],
                        [
                            255,
                            261
                        ],
                        [
                            261,
                            446
                        ],
                        [
                            446,
                            255
                        ],
                        [
                            253,
                            450
                        ],
                        [
                            450,
                            449
                        ],
                        [
                            449,
                            253
                        ],
                        [
                            252,
                            451
                        ],
                        [
                            451,
                            450
                        ],
                        [
                            450,
                            252
                        ],
                        [
                            256,
                            452
                        ],
                        [
                            452,
                            451
                        ],
                        [
                            451,
                            256
                        ],
                        [
                            341,
                            453
                        ],
                        [
                            453,
                            452
                        ],
                        [
                            452,
                            341
                        ],
                        [
                            413,
                            464
                        ],
                        [
                            464,
                            463
                        ],
                        [
                            463,
                            413
                        ],
                        [
                            441,
                            413
                        ],
                        [
                            413,
                            414
                        ],
                        [
                            414,
                            441
                        ],
                        [
                            258,
                            442
                        ],
                        [
                            442,
                            441
                        ],
                        [
                            441,
                            258
                        ],
                        [
                            257,
                            443
                        ],
                        [
                            443,
                            442
                        ],
                        [
                            442,
                            257
                        ],
                        [
                            259,
                            444
                        ],
                        [
                            444,
                            443
                        ],
                        [
                            443,
                            259
                        ],
                        [
                            260,
                            445
                        ],
                        [
                            445,
                            444
                        ],
                        [
                            444,
                            260
                        ],
                        [
                            467,
                            342
                        ],
                        [
                            342,
                            445
                        ],
                        [
                            445,
                            467
                        ],
                        [
                            459,
                            458
                        ],
                        [
                            458,
                            250
                        ],
                        [
                            250,
                            459
                        ],
                        [
                            289,
                            392
                        ],
                        [
                            392,
                            290
                        ],
                        [
                            290,
                            289
                        ],
                        [
                            290,
                            328
                        ],
                        [
                            328,
                            460
                        ],
                        [
                            460,
                            290
                        ],
                        [
                            376,
                            433
                        ],
                        [
                            433,
                            435
                        ],
                        [
                            435,
                            376
                        ],
                        [
                            250,
                            290
                        ],
                        [
                            290,
                            392
                        ],
                        [
                            392,
                            250
                        ],
                        [
                            411,
                            416
                        ],
                        [
                            416,
                            433
                        ],
                        [
                            433,
                            411
                        ],
                        [
                            341,
                            463
                        ],
                        [
                            463,
                            464
                        ],
                        [
                            464,
                            341
                        ],
                        [
                            453,
                            464
                        ],
                        [
                            464,
                            465
                        ],
                        [
                            465,
                            453
                        ],
                        [
                            357,
                            465
                        ],
                        [
                            465,
                            412
                        ],
                        [
                            412,
                            357
                        ],
                        [
                            343,
                            412
                        ],
                        [
                            412,
                            399
                        ],
                        [
                            399,
                            343
                        ],
                        [
                            360,
                            363
                        ],
                        [
                            363,
                            440
                        ],
                        [
                            440,
                            360
                        ],
                        [
                            437,
                            399
                        ],
                        [
                            399,
                            456
                        ],
                        [
                            456,
                            437
                        ],
                        [
                            420,
                            456
                        ],
                        [
                            456,
                            363
                        ],
                        [
                            363,
                            420
                        ],
                        [
                            401,
                            435
                        ],
                        [
                            435,
                            288
                        ],
                        [
                            288,
                            401
                        ],
                        [
                            372,
                            383
                        ],
                        [
                            383,
                            353
                        ],
                        [
                            353,
                            372
                        ],
                        [
                            339,
                            255
                        ],
                        [
                            255,
                            249
                        ],
                        [
                            249,
                            339
                        ],
                        [
                            448,
                            261
                        ],
                        [
                            261,
                            255
                        ],
                        [
                            255,
                            448
                        ],
                        [
                            133,
                            243
                        ],
                        [
                            243,
                            190
                        ],
                        [
                            190,
                            133
                        ],
                        [
                            133,
                            155
                        ],
                        [
                            155,
                            112
                        ],
                        [
                            112,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            247
                        ],
                        [
                            247,
                            33
                        ],
                        [
                            33,
                            130
                        ],
                        [
                            130,
                            25
                        ],
                        [
                            25,
                            33
                        ],
                        [
                            398,
                            384
                        ],
                        [
                            384,
                            286
                        ],
                        [
                            286,
                            398
                        ],
                        [
                            362,
                            398
                        ],
                        [
                            398,
                            414
                        ],
                        [
                            414,
                            362
                        ],
                        [
                            362,
                            463
                        ],
                        [
                            463,
                            341
                        ],
                        [
                            341,
                            362
                        ],
                        [
                            263,
                            359
                        ],
                        [
                            359,
                            467
                        ],
                        [
                            467,
                            263
                        ],
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            255
                        ],
                        [
                            255,
                            263
                        ],
                        [
                            466,
                            467
                        ],
                        [
                            467,
                            260
                        ],
                        [
                            260,
                            466
                        ],
                        [
                            75,
                            60
                        ],
                        [
                            60,
                            166
                        ],
                        [
                            166,
                            75
                        ],
                        [
                            238,
                            239
                        ],
                        [
                            239,
                            79
                        ],
                        [
                            79,
                            238
                        ],
                        [
                            162,
                            127
                        ],
                        [
                            127,
                            139
                        ],
                        [
                            139,
                            162
                        ],
                        [
                            72,
                            11
                        ],
                        [
                            11,
                            37
                        ],
                        [
                            37,
                            72
                        ],
                        [
                            121,
                            232
                        ],
                        [
                            232,
                            120
                        ],
                        [
                            120,
                            121
                        ],
                        [
                            73,
                            72
                        ],
                        [
                            72,
                            39
                        ],
                        [
                            39,
                            73
                        ],
                        [
                            114,
                            128
                        ],
                        [
                            128,
                            47
                        ],
                        [
                            47,
                            114
                        ],
                        [
                            233,
                            232
                        ],
                        [
                            232,
                            128
                        ],
                        [
                            128,
                            233
                        ],
                        [
                            103,
                            104
                        ],
                        [
                            104,
                            67
                        ],
                        [
                            67,
                            103
                        ],
                        [
                            152,
                            175
                        ],
                        [
                            175,
                            148
                        ],
                        [
                            148,
                            152
                        ],
                        [
                            119,
                            118
                        ],
                        [
                            118,
                            101
                        ],
                        [
                            101,
                            119
                        ],
                        [
                            74,
                            73
                        ],
                        [
                            73,
                            40
                        ],
                        [
                            40,
                            74
                        ],
                        [
                            107,
                            9
                        ],
                        [
                            9,
                            108
                        ],
                        [
                            108,
                            107
                        ],
                        [
                            49,
                            48
                        ],
                        [
                            48,
                            131
                        ],
                        [
                            131,
                            49
                        ],
                        [
                            32,
                            194
                        ],
                        [
                            194,
                            211
                        ],
                        [
                            211,
                            32
                        ],
                        [
                            184,
                            74
                        ],
                        [
                            74,
                            185
                        ],
                        [
                            185,
                            184
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            183
                        ],
                        [
                            183,
                            191
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            186
                        ],
                        [
                            186,
                            185
                        ],
                        [
                            119,
                            230
                        ],
                        [
                            230,
                            118
                        ],
                        [
                            118,
                            119
                        ],
                        [
                            210,
                            202
                        ],
                        [
                            202,
                            214
                        ],
                        [
                            214,
                            210
                        ],
                        [
                            84,
                            83
                        ],
                        [
                            83,
                            17
                        ],
                        [
                            17,
                            84
                        ],
                        [
                            77,
                            76
                        ],
                        [
                            76,
                            146
                        ],
                        [
                            146,
                            77
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            30
                        ],
                        [
                            30,
                            161
                        ],
                        [
                            190,
                            56
                        ],
                        [
                            56,
                            173
                        ],
                        [
                            173,
                            190
                        ],
                        [
                            182,
                            106
                        ],
                        [
                            106,
                            194
                        ],
                        [
                            194,
                            182
                        ],
                        [
                            138,
                            135
                        ],
                        [
                            135,
                            192
                        ],
                        [
                            192,
                            138
                        ],
                        [
                            129,
                            203
                        ],
                        [
                            203,
                            98
                        ],
                        [
                            98,
                            129
                        ],
                        [
                            54,
                            21
                        ],
                        [
                            21,
                            68
                        ],
                        [
                            68,
                            54
                        ],
                        [
                            5,
                            51
                        ],
                        [
                            51,
                            4
                        ],
                        [
                            4,
                            5
                        ],
                        [
                            145,
                            144
                        ],
                        [
                            144,
                            23
                        ],
                        [
                            23,
                            145
                        ],
                        [
                            90,
                            77
                        ],
                        [
                            77,
                            91
                        ],
                        [
                            91,
                            90
                        ],
                        [
                            207,
                            205
                        ],
                        [
                            205,
                            187
                        ],
                        [
                            187,
                            207
                        ],
                        [
                            83,
                            201
                        ],
                        [
                            201,
                            18
                        ],
                        [
                            18,
                            83
                        ],
                        [
                            181,
                            91
                        ],
                        [
                            91,
                            182
                        ],
                        [
                            182,
                            181
                        ],
                        [
                            180,
                            90
                        ],
                        [
                            90,
                            181
                        ],
                        [
                            181,
                            180
                        ],
                        [
                            16,
                            85
                        ],
                        [
                            85,
                            17
                        ],
                        [
                            17,
                            16
                        ],
                        [
                            205,
                            206
                        ],
                        [
                            206,
                            36
                        ],
                        [
                            36,
                            205
                        ],
                        [
                            176,
                            148
                        ],
                        [
                            148,
                            140
                        ],
                        [
                            140,
                            176
                        ],
                        [
                            165,
                            92
                        ],
                        [
                            92,
                            39
                        ],
                        [
                            39,
                            165
                        ],
                        [
                            245,
                            193
                        ],
                        [
                            193,
                            244
                        ],
                        [
                            244,
                            245
                        ],
                        [
                            27,
                            159
                        ],
                        [
                            159,
                            28
                        ],
                        [
                            28,
                            27
                        ],
                        [
                            30,
                            247
                        ],
                        [
                            247,
                            161
                        ],
                        [
                            161,
                            30
                        ],
                        [
                            174,
                            236
                        ],
                        [
                            236,
                            196
                        ],
                        [
                            196,
                            174
                        ],
                        [
                            103,
                            54
                        ],
                        [
                            54,
                            104
                        ],
                        [
                            104,
                            103
                        ],
                        [
                            55,
                            193
                        ],
                        [
                            193,
                            8
                        ],
                        [
                            8,
                            55
                        ],
                        [
                            111,
                            117
                        ],
                        [
                            117,
                            31
                        ],
                        [
                            31,
                            111
                        ],
                        [
                            221,
                            189
                        ],
                        [
                            189,
                            55
                        ],
                        [
                            55,
                            221
                        ],
                        [
                            240,
                            98
                        ],
                        [
                            98,
                            99
                        ],
                        [
                            99,
                            240
                        ],
                        [
                            142,
                            126
                        ],
                        [
                            126,
                            100
                        ],
                        [
                            100,
                            142
                        ],
                        [
                            219,
                            166
                        ],
                        [
                            166,
                            218
                        ],
                        [
                            218,
                            219
                        ],
                        [
                            112,
                            155
                        ],
                        [
                            155,
                            26
                        ],
                        [
                            26,
                            112
                        ],
                        [
                            198,
                            209
                        ],
                        [
                            209,
                            131
                        ],
                        [
                            131,
                            198
                        ],
                        [
                            169,
                            135
                        ],
                        [
                            135,
                            150
                        ],
                        [
                            150,
                            169
                        ],
                        [
                            114,
                            47
                        ],
                        [
                            47,
                            217
                        ],
                        [
                            217,
                            114
                        ],
                        [
                            224,
                            223
                        ],
                        [
                            223,
                            53
                        ],
                        [
                            53,
                            224
                        ],
                        [
                            220,
                            45
                        ],
                        [
                            45,
                            134
                        ],
                        [
                            134,
                            220
                        ],
                        [
                            32,
                            211
                        ],
                        [
                            211,
                            140
                        ],
                        [
                            140,
                            32
                        ],
                        [
                            109,
                            67
                        ],
                        [
                            67,
                            108
                        ],
                        [
                            108,
                            109
                        ],
                        [
                            146,
                            43
                        ],
                        [
                            43,
                            91
                        ],
                        [
                            91,
                            146
                        ],
                        [
                            231,
                            230
                        ],
                        [
                            230,
                            120
                        ],
                        [
                            120,
                            231
                        ],
                        [
                            113,
                            226
                        ],
                        [
                            226,
                            247
                        ],
                        [
                            247,
                            113
                        ],
                        [
                            105,
                            63
                        ],
                        [
                            63,
                            52
                        ],
                        [
                            52,
                            105
                        ],
                        [
                            241,
                            238
                        ],
                        [
                            238,
                            242
                        ],
                        [
                            242,
                            241
                        ],
                        [
                            124,
                            46
                        ],
                        [
                            46,
                            156
                        ],
                        [
                            156,
                            124
                        ],
                        [
                            95,
                            78
                        ],
                        [
                            78,
                            96
                        ],
                        [
                            96,
                            95
                        ],
                        [
                            70,
                            46
                        ],
                        [
                            46,
                            63
                        ],
                        [
                            63,
                            70
                        ],
                        [
                            116,
                            143
                        ],
                        [
                            143,
                            227
                        ],
                        [
                            227,
                            116
                        ],
                        [
                            116,
                            123
                        ],
                        [
                            123,
                            111
                        ],
                        [
                            111,
                            116
                        ],
                        [
                            1,
                            44
                        ],
                        [
                            44,
                            19
                        ],
                        [
                            19,
                            1
                        ],
                        [
                            3,
                            236
                        ],
                        [
                            236,
                            51
                        ],
                        [
                            51,
                            3
                        ],
                        [
                            207,
                            216
                        ],
                        [
                            216,
                            205
                        ],
                        [
                            205,
                            207
                        ],
                        [
                            26,
                            154
                        ],
                        [
                            154,
                            22
                        ],
                        [
                            22,
                            26
                        ],
                        [
                            165,
                            39
                        ],
                        [
                            39,
                            167
                        ],
                        [
                            167,
                            165
                        ],
                        [
                            199,
                            200
                        ],
                        [
                            200,
                            208
                        ],
                        [
                            208,
                            199
                        ],
                        [
                            101,
                            36
                        ],
                        [
                            36,
                            100
                        ],
                        [
                            100,
                            101
                        ],
                        [
                            43,
                            57
                        ],
                        [
                            57,
                            202
                        ],
                        [
                            202,
                            43
                        ],
                        [
                            242,
                            20
                        ],
                        [
                            20,
                            99
                        ],
                        [
                            99,
                            242
                        ],
                        [
                            56,
                            28
                        ],
                        [
                            28,
                            157
                        ],
                        [
                            157,
                            56
                        ],
                        [
                            124,
                            35
                        ],
                        [
                            35,
                            113
                        ],
                        [
                            113,
                            124
                        ],
                        [
                            29,
                            160
                        ],
                        [
                            160,
                            27
                        ],
                        [
                            27,
                            29
                        ],
                        [
                            211,
                            204
                        ],
                        [
                            204,
                            210
                        ],
                        [
                            210,
                            211
                        ],
                        [
                            124,
                            113
                        ],
                        [
                            113,
                            46
                        ],
                        [
                            46,
                            124
                        ],
                        [
                            106,
                            43
                        ],
                        [
                            43,
                            204
                        ],
                        [
                            204,
                            106
                        ],
                        [
                            96,
                            62
                        ],
                        [
                            62,
                            77
                        ],
                        [
                            77,
                            96
                        ],
                        [
                            227,
                            137
                        ],
                        [
                            137,
                            116
                        ],
                        [
                            116,
                            227
                        ],
                        [
                            73,
                            41
                        ],
                        [
                            41,
                            72
                        ],
                        [
                            72,
                            73
                        ],
                        [
                            36,
                            203
                        ],
                        [
                            203,
                            142
                        ],
                        [
                            142,
                            36
                        ],
                        [
                            235,
                            64
                        ],
                        [
                            64,
                            240
                        ],
                        [
                            240,
                            235
                        ],
                        [
                            48,
                            49
                        ],
                        [
                            49,
                            64
                        ],
                        [
                            64,
                            48
                        ],
                        [
                            42,
                            41
                        ],
                        [
                            41,
                            74
                        ],
                        [
                            74,
                            42
                        ],
                        [
                            214,
                            212
                        ],
                        [
                            212,
                            207
                        ],
                        [
                            207,
                            214
                        ],
                        [
                            183,
                            42
                        ],
                        [
                            42,
                            184
                        ],
                        [
                            184,
                            183
                        ],
                        [
                            210,
                            169
                        ],
                        [
                            169,
                            211
                        ],
                        [
                            211,
                            210
                        ],
                        [
                            140,
                            170
                        ],
                        [
                            170,
                            176
                        ],
                        [
                            176,
                            140
                        ],
                        [
                            104,
                            105
                        ],
                        [
                            105,
                            69
                        ],
                        [
                            69,
                            104
                        ],
                        [
                            193,
                            122
                        ],
                        [
                            122,
                            168
                        ],
                        [
                            168,
                            193
                        ],
                        [
                            50,
                            123
                        ],
                        [
                            123,
                            187
                        ],
                        [
                            187,
                            50
                        ],
                        [
                            89,
                            96
                        ],
                        [
                            96,
                            90
                        ],
                        [
                            90,
                            89
                        ],
                        [
                            66,
                            65
                        ],
                        [
                            65,
                            107
                        ],
                        [
                            107,
                            66
                        ],
                        [
                            179,
                            89
                        ],
                        [
                            89,
                            180
                        ],
                        [
                            180,
                            179
                        ],
                        [
                            119,
                            101
                        ],
                        [
                            101,
                            120
                        ],
                        [
                            120,
                            119
                        ],
                        [
                            68,
                            63
                        ],
                        [
                            63,
                            104
                        ],
                        [
                            104,
                            68
                        ],
                        [
                            234,
                            93
                        ],
                        [
                            93,
                            227
                        ],
                        [
                            227,
                            234
                        ],
                        [
                            16,
                            15
                        ],
                        [
                            15,
                            85
                        ],
                        [
                            85,
                            16
                        ],
                        [
                            209,
                            129
                        ],
                        [
                            129,
                            49
                        ],
                        [
                            49,
                            209
                        ],
                        [
                            15,
                            14
                        ],
                        [
                            14,
                            86
                        ],
                        [
                            86,
                            15
                        ],
                        [
                            107,
                            55
                        ],
                        [
                            55,
                            9
                        ],
                        [
                            9,
                            107
                        ],
                        [
                            120,
                            100
                        ],
                        [
                            100,
                            121
                        ],
                        [
                            121,
                            120
                        ],
                        [
                            153,
                            145
                        ],
                        [
                            145,
                            22
                        ],
                        [
                            22,
                            153
                        ],
                        [
                            178,
                            88
                        ],
                        [
                            88,
                            179
                        ],
                        [
                            179,
                            178
                        ],
                        [
                            197,
                            6
                        ],
                        [
                            6,
                            196
                        ],
                        [
                            196,
                            197
                        ],
                        [
                            89,
                            88
                        ],
                        [
                            88,
                            96
                        ],
                        [
                            96,
                            89
                        ],
                        [
                            135,
                            138
                        ],
                        [
                            138,
                            136
                        ],
                        [
                            136,
                            135
                        ],
                        [
                            138,
                            215
                        ],
                        [
                            215,
                            172
                        ],
                        [
                            172,
                            138
                        ],
                        [
                            218,
                            115
                        ],
                        [
                            115,
                            219
                        ],
                        [
                            219,
                            218
                        ],
                        [
                            41,
                            42
                        ],
                        [
                            42,
                            81
                        ],
                        [
                            81,
                            41
                        ],
                        [
                            5,
                            195
                        ],
                        [
                            195,
                            51
                        ],
                        [
                            51,
                            5
                        ],
                        [
                            57,
                            43
                        ],
                        [
                            43,
                            61
                        ],
                        [
                            61,
                            57
                        ],
                        [
                            208,
                            171
                        ],
                        [
                            171,
                            199
                        ],
                        [
                            199,
                            208
                        ],
                        [
                            41,
                            81
                        ],
                        [
                            81,
                            38
                        ],
                        [
                            38,
                            41
                        ],
                        [
                            224,
                            53
                        ],
                        [
                            53,
                            225
                        ],
                        [
                            225,
                            224
                        ],
                        [
                            24,
                            144
                        ],
                        [
                            144,
                            110
                        ],
                        [
                            110,
                            24
                        ],
                        [
                            105,
                            52
                        ],
                        [
                            52,
                            66
                        ],
                        [
                            66,
                            105
                        ],
                        [
                            118,
                            229
                        ],
                        [
                            229,
                            117
                        ],
                        [
                            117,
                            118
                        ],
                        [
                            227,
                            34
                        ],
                        [
                            34,
                            234
                        ],
                        [
                            234,
                            227
                        ],
                        [
                            66,
                            107
                        ],
                        [
                            107,
                            69
                        ],
                        [
                            69,
                            66
                        ],
                        [
                            10,
                            109
                        ],
                        [
                            109,
                            151
                        ],
                        [
                            151,
                            10
                        ],
                        [
                            219,
                            48
                        ],
                        [
                            48,
                            235
                        ],
                        [
                            235,
                            219
                        ],
                        [
                            183,
                            62
                        ],
                        [
                            62,
                            191
                        ],
                        [
                            191,
                            183
                        ],
                        [
                            142,
                            129
                        ],
                        [
                            129,
                            126
                        ],
                        [
                            126,
                            142
                        ],
                        [
                            116,
                            111
                        ],
                        [
                            111,
                            143
                        ],
                        [
                            143,
                            116
                        ],
                        [
                            118,
                            117
                        ],
                        [
                            117,
                            50
                        ],
                        [
                            50,
                            118
                        ],
                        [
                            223,
                            222
                        ],
                        [
                            222,
                            52
                        ],
                        [
                            52,
                            223
                        ],
                        [
                            94,
                            19
                        ],
                        [
                            19,
                            141
                        ],
                        [
                            141,
                            94
                        ],
                        [
                            222,
                            221
                        ],
                        [
                            221,
                            65
                        ],
                        [
                            65,
                            222
                        ],
                        [
                            196,
                            3
                        ],
                        [
                            3,
                            197
                        ],
                        [
                            197,
                            196
                        ],
                        [
                            45,
                            220
                        ],
                        [
                            220,
                            44
                        ],
                        [
                            44,
                            45
                        ],
                        [
                            156,
                            70
                        ],
                        [
                            70,
                            139
                        ],
                        [
                            139,
                            156
                        ],
                        [
                            188,
                            122
                        ],
                        [
                            122,
                            245
                        ],
                        [
                            245,
                            188
                        ],
                        [
                            139,
                            71
                        ],
                        [
                            71,
                            162
                        ],
                        [
                            162,
                            139
                        ],
                        [
                            149,
                            170
                        ],
                        [
                            170,
                            150
                        ],
                        [
                            150,
                            149
                        ],
                        [
                            122,
                            188
                        ],
                        [
                            188,
                            196
                        ],
                        [
                            196,
                            122
                        ],
                        [
                            206,
                            216
                        ],
                        [
                            216,
                            92
                        ],
                        [
                            92,
                            206
                        ],
                        [
                            164,
                            2
                        ],
                        [
                            2,
                            167
                        ],
                        [
                            167,
                            164
                        ],
                        [
                            242,
                            141
                        ],
                        [
                            141,
                            241
                        ],
                        [
                            241,
                            242
                        ],
                        [
                            0,
                            164
                        ],
                        [
                            164,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            11,
                            72
                        ],
                        [
                            72,
                            12
                        ],
                        [
                            12,
                            11
                        ],
                        [
                            12,
                            38
                        ],
                        [
                            38,
                            13
                        ],
                        [
                            13,
                            12
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            71
                        ],
                        [
                            71,
                            70
                        ],
                        [
                            31,
                            226
                        ],
                        [
                            226,
                            111
                        ],
                        [
                            111,
                            31
                        ],
                        [
                            36,
                            101
                        ],
                        [
                            101,
                            205
                        ],
                        [
                            205,
                            36
                        ],
                        [
                            203,
                            206
                        ],
                        [
                            206,
                            165
                        ],
                        [
                            165,
                            203
                        ],
                        [
                            126,
                            209
                        ],
                        [
                            209,
                            217
                        ],
                        [
                            217,
                            126
                        ],
                        [
                            98,
                            165
                        ],
                        [
                            165,
                            97
                        ],
                        [
                            97,
                            98
                        ],
                        [
                            237,
                            220
                        ],
                        [
                            220,
                            218
                        ],
                        [
                            218,
                            237
                        ],
                        [
                            237,
                            239
                        ],
                        [
                            239,
                            241
                        ],
                        [
                            241,
                            237
                        ],
                        [
                            210,
                            214
                        ],
                        [
                            214,
                            169
                        ],
                        [
                            169,
                            210
                        ],
                        [
                            140,
                            171
                        ],
                        [
                            171,
                            32
                        ],
                        [
                            32,
                            140
                        ],
                        [
                            241,
                            125
                        ],
                        [
                            125,
                            237
                        ],
                        [
                            237,
                            241
                        ],
                        [
                            179,
                            86
                        ],
                        [
                            86,
                            178
                        ],
                        [
                            178,
                            179
                        ],
                        [
                            180,
                            85
                        ],
                        [
                            85,
                            179
                        ],
                        [
                            179,
                            180
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            180
                        ],
                        [
                            180,
                            181
                        ],
                        [
                            182,
                            83
                        ],
                        [
                            83,
                            181
                        ],
                        [
                            181,
                            182
                        ],
                        [
                            194,
                            201
                        ],
                        [
                            201,
                            182
                        ],
                        [
                            182,
                            194
                        ],
                        [
                            177,
                            137
                        ],
                        [
                            137,
                            132
                        ],
                        [
                            132,
                            177
                        ],
                        [
                            184,
                            76
                        ],
                        [
                            76,
                            183
                        ],
                        [
                            183,
                            184
                        ],
                        [
                            185,
                            61
                        ],
                        [
                            61,
                            184
                        ],
                        [
                            184,
                            185
                        ],
                        [
                            186,
                            57
                        ],
                        [
                            57,
                            185
                        ],
                        [
                            185,
                            186
                        ],
                        [
                            216,
                            212
                        ],
                        [
                            212,
                            186
                        ],
                        [
                            186,
                            216
                        ],
                        [
                            192,
                            214
                        ],
                        [
                            214,
                            187
                        ],
                        [
                            187,
                            192
                        ],
                        [
                            139,
                            34
                        ],
                        [
                            34,
                            156
                        ],
                        [
                            156,
                            139
                        ],
                        [
                            218,
                            79
                        ],
                        [
                            79,
                            237
                        ],
                        [
                            237,
                            218
                        ],
                        [
                            147,
                            123
                        ],
                        [
                            123,
                            177
                        ],
                        [
                            177,
                            147
                        ],
                        [
                            45,
                            44
                        ],
                        [
                            44,
                            4
                        ],
                        [
                            4,
                            45
                        ],
                        [
                            208,
                            201
                        ],
                        [
                            201,
                            32
                        ],
                        [
                            32,
                            208
                        ],
                        [
                            98,
                            64
                        ],
                        [
                            64,
                            129
                        ],
                        [
                            129,
                            98
                        ],
                        [
                            192,
                            213
                        ],
                        [
                            213,
                            138
                        ],
                        [
                            138,
                            192
                        ],
                        [
                            235,
                            59
                        ],
                        [
                            59,
                            219
                        ],
                        [
                            219,
                            235
                        ],
                        [
                            141,
                            242
                        ],
                        [
                            242,
                            97
                        ],
                        [
                            97,
                            141
                        ],
                        [
                            97,
                            2
                        ],
                        [
                            2,
                            141
                        ],
                        [
                            141,
                            97
                        ],
                        [
                            240,
                            75
                        ],
                        [
                            75,
                            235
                        ],
                        [
                            235,
                            240
                        ],
                        [
                            229,
                            24
                        ],
                        [
                            24,
                            228
                        ],
                        [
                            228,
                            229
                        ],
                        [
                            31,
                            25
                        ],
                        [
                            25,
                            226
                        ],
                        [
                            226,
                            31
                        ],
                        [
                            230,
                            23
                        ],
                        [
                            23,
                            229
                        ],
                        [
                            229,
                            230
                        ],
                        [
                            231,
                            22
                        ],
                        [
                            22,
                            230
                        ],
                        [
                            230,
                            231
                        ],
                        [
                            232,
                            26
                        ],
                        [
                            26,
                            231
                        ],
                        [
                            231,
                            232
                        ],
                        [
                            233,
                            112
                        ],
                        [
                            112,
                            232
                        ],
                        [
                            232,
                            233
                        ],
                        [
                            244,
                            189
                        ],
                        [
                            189,
                            243
                        ],
                        [
                            243,
                            244
                        ],
                        [
                            189,
                            221
                        ],
                        [
                            221,
                            190
                        ],
                        [
                            190,
                            189
                        ],
                        [
                            222,
                            28
                        ],
                        [
                            28,
                            221
                        ],
                        [
                            221,
                            222
                        ],
                        [
                            223,
                            27
                        ],
                        [
                            27,
                            222
                        ],
                        [
                            222,
                            223
                        ],
                        [
                            224,
                            29
                        ],
                        [
                            29,
                            223
                        ],
                        [
                            223,
                            224
                        ],
                        [
                            225,
                            30
                        ],
                        [
                            30,
                            224
                        ],
                        [
                            224,
                            225
                        ],
                        [
                            113,
                            247
                        ],
                        [
                            247,
                            225
                        ],
                        [
                            225,
                            113
                        ],
                        [
                            99,
                            60
                        ],
                        [
                            60,
                            240
                        ],
                        [
                            240,
                            99
                        ],
                        [
                            213,
                            147
                        ],
                        [
                            147,
                            215
                        ],
                        [
                            215,
                            213
                        ],
                        [
                            60,
                            20
                        ],
                        [
                            20,
                            166
                        ],
                        [
                            166,
                            60
                        ],
                        [
                            192,
                            187
                        ],
                        [
                            187,
                            213
                        ],
                        [
                            213,
                            192
                        ],
                        [
                            243,
                            112
                        ],
                        [
                            112,
                            244
                        ],
                        [
                            244,
                            243
                        ],
                        [
                            244,
                            233
                        ],
                        [
                            233,
                            245
                        ],
                        [
                            245,
                            244
                        ],
                        [
                            245,
                            128
                        ],
                        [
                            128,
                            188
                        ],
                        [
                            188,
                            245
                        ],
                        [
                            188,
                            114
                        ],
                        [
                            114,
                            174
                        ],
                        [
                            174,
                            188
                        ],
                        [
                            134,
                            131
                        ],
                        [
                            131,
                            220
                        ],
                        [
                            220,
                            134
                        ],
                        [
                            174,
                            217
                        ],
                        [
                            217,
                            236
                        ],
                        [
                            236,
                            174
                        ],
                        [
                            236,
                            198
                        ],
                        [
                            198,
                            134
                        ],
                        [
                            134,
                            236
                        ],
                        [
                            215,
                            177
                        ],
                        [
                            177,
                            58
                        ],
                        [
                            58,
                            215
                        ],
                        [
                            156,
                            143
                        ],
                        [
                            143,
                            124
                        ],
                        [
                            124,
                            156
                        ],
                        [
                            25,
                            110
                        ],
                        [
                            110,
                            7
                        ],
                        [
                            7,
                            25
                        ],
                        [
                            31,
                            228
                        ],
                        [
                            228,
                            25
                        ],
                        [
                            25,
                            31
                        ],
                        [
                            264,
                            356
                        ],
                        [
                            356,
                            368
                        ],
                        [
                            368,
                            264
                        ],
                        [
                            0,
                            11
                        ],
                        [
                            11,
                            267
                        ],
                        [
                            267,
                            0
                        ],
                        [
                            451,
                            452
                        ],
                        [
                            452,
                            349
                        ],
                        [
                            349,
                            451
                        ],
                        [
                            267,
                            302
                        ],
                        [
                            302,
                            269
                        ],
                        [
                            269,
                            267
                        ],
                        [
                            350,
                            357
                        ],
                        [
                            357,
                            277
                        ],
                        [
                            277,
                            350
                        ],
                        [
                            350,
                            452
                        ],
                        [
                            452,
                            357
                        ],
                        [
                            357,
                            350
                        ],
                        [
                            299,
                            333
                        ],
                        [
                            333,
                            297
                        ],
                        [
                            297,
                            299
                        ],
                        [
                            396,
                            175
                        ],
                        [
                            175,
                            377
                        ],
                        [
                            377,
                            396
                        ],
                        [
                            280,
                            347
                        ],
                        [
                            347,
                            330
                        ],
                        [
                            330,
                            280
                        ],
                        [
                            269,
                            303
                        ],
                        [
                            303,
                            270
                        ],
                        [
                            270,
                            269
                        ],
                        [
                            151,
                            9
                        ],
                        [
                            9,
                            337
                        ],
                        [
                            337,
                            151
                        ],
                        [
                            344,
                            278
                        ],
                        [
                            278,
                            360
                        ],
                        [
                            360,
                            344
                        ],
                        [
                            424,
                            418
                        ],
                        [
                            418,
                            431
                        ],
                        [
                            431,
                            424
                        ],
                        [
                            270,
                            304
                        ],
                        [
                            304,
                            409
                        ],
                        [
                            409,
                            270
                        ],
                        [
                            272,
                            310
                        ],
                        [
                            310,
                            407
                        ],
                        [
                            407,
                            272
                        ],
                        [
                            322,
                            270
                        ],
                        [
                            270,
                            410
                        ],
                        [
                            410,
                            322
                        ],
                        [
                            449,
                            450
                        ],
                        [
                            450,
                            347
                        ],
                        [
                            347,
                            449
                        ],
                        [
                            432,
                            422
                        ],
                        [
                            422,
                            434
                        ],
                        [
                            434,
                            432
                        ],
                        [
                            18,
                            313
                        ],
                        [
                            313,
                            17
                        ],
                        [
                            17,
                            18
                        ],
                        [
                            291,
                            306
                        ],
                        [
                            306,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            259,
                            387
                        ],
                        [
                            387,
                            260
                        ],
                        [
                            260,
                            259
                        ],
                        [
                            424,
                            335
                        ],
                        [
                            335,
                            418
                        ],
                        [
                            418,
                            424
                        ],
                        [
                            434,
                            364
                        ],
                        [
                            364,
                            416
                        ],
                        [
                            416,
                            434
                        ],
                        [
                            391,
                            423
                        ],
                        [
                            423,
                            327
                        ],
                        [
                            327,
                            391
                        ],
                        [
                            301,
                            251
                        ],
                        [
                            251,
                            298
                        ],
                        [
                            298,
                            301
                        ],
                        [
                            275,
                            281
                        ],
                        [
                            281,
                            4
                        ],
                        [
                            4,
                            275
                        ],
                        [
                            254,
                            373
                        ],
                        [
                            373,
                            253
                        ],
                        [
                            253,
                            254
                        ],
                        [
                            375,
                            307
                        ],
                        [
                            307,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            280,
                            425
                        ],
                        [
                            425,
                            411
                        ],
                        [
                            411,
                            280
                        ],
                        [
                            200,
                            421
                        ],
                        [
                            421,
                            18
                        ],
                        [
                            18,
                            200
                        ],
                        [
                            335,
                            321
                        ],
                        [
                            321,
                            406
                        ],
                        [
                            406,
                            335
                        ],
                        [
                            321,
                            320
                        ],
                        [
                            320,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            314,
                            315
                        ],
                        [
                            315,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            423,
                            426
                        ],
                        [
                            426,
                            266
                        ],
                        [
                            266,
                            423
                        ],
                        [
                            396,
                            377
                        ],
                        [
                            377,
                            369
                        ],
                        [
                            369,
                            396
                        ],
                        [
                            270,
                            322
                        ],
                        [
                            322,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            413,
                            417
                        ],
                        [
                            417,
                            464
                        ],
                        [
                            464,
                            413
                        ],
                        [
                            385,
                            386
                        ],
                        [
                            386,
                            258
                        ],
                        [
                            258,
                            385
                        ],
                        [
                            248,
                            456
                        ],
                        [
                            456,
                            419
                        ],
                        [
                            419,
                            248
                        ],
                        [
                            298,
                            284
                        ],
                        [
                            284,
                            333
                        ],
                        [
                            333,
                            298
                        ],
                        [
                            168,
                            417
                        ],
                        [
                            417,
                            8
                        ],
                        [
                            8,
                            168
                        ],
                        [
                            448,
                            346
                        ],
                        [
                            346,
                            261
                        ],
                        [
                            261,
                            448
                        ],
                        [
                            417,
                            413
                        ],
                        [
                            413,
                            285
                        ],
                        [
                            285,
                            417
                        ],
                        [
                            326,
                            327
                        ],
                        [
                            327,
                            328
                        ],
                        [
                            328,
                            326
                        ],
                        [
                            277,
                            355
                        ],
                        [
                            355,
                            329
                        ],
                        [
                            329,
                            277
                        ],
                        [
                            309,
                            392
                        ],
                        [
                            392,
                            438
                        ],
                        [
                            438,
                            309
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            256
                        ],
                        [
                            256,
                            381
                        ],
                        [
                            279,
                            429
                        ],
                        [
                            429,
                            360
                        ],
                        [
                            360,
                            279
                        ],
                        [
                            365,
                            364
                        ],
                        [
                            364,
                            379
                        ],
                        [
                            379,
                            365
                        ],
                        [
                            355,
                            277
                        ],
                        [
                            277,
                            437
                        ],
                        [
                            437,
                            355
                        ],
                        [
                            282,
                            443
                        ],
                        [
                            443,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            281,
                            275
                        ],
                        [
                            275,
                            363
                        ],
                        [
                            363,
                            281
                        ],
                        [
                            395,
                            431
                        ],
                        [
                            431,
                            369
                        ],
                        [
                            369,
                            395
                        ],
                        [
                            299,
                            297
                        ],
                        [
                            297,
                            337
                        ],
                        [
                            337,
                            299
                        ],
                        [
                            335,
                            273
                        ],
                        [
                            273,
                            321
                        ],
                        [
                            321,
                            335
                        ],
                        [
                            348,
                            450
                        ],
                        [
                            450,
                            349
                        ],
                        [
                            349,
                            348
                        ],
                        [
                            359,
                            446
                        ],
                        [
                            446,
                            467
                        ],
                        [
                            467,
                            359
                        ],
                        [
                            283,
                            293
                        ],
                        [
                            293,
                            282
                        ],
                        [
                            282,
                            283
                        ],
                        [
                            250,
                            458
                        ],
                        [
                            458,
                            462
                        ],
                        [
                            462,
                            250
                        ],
                        [
                            300,
                            276
                        ],
                        [
                            276,
                            383
                        ],
                        [
                            383,
                            300
                        ],
                        [
                            292,
                            308
                        ],
                        [
                            308,
                            325
                        ],
                        [
                            325,
                            292
                        ],
                        [
                            283,
                            276
                        ],
                        [
                            276,
                            293
                        ],
                        [
                            293,
                            283
                        ],
                        [
                            264,
                            372
                        ],
                        [
                            372,
                            447
                        ],
                        [
                            447,
                            264
                        ],
                        [
                            346,
                            352
                        ],
                        [
                            352,
                            340
                        ],
                        [
                            340,
                            346
                        ],
                        [
                            354,
                            274
                        ],
                        [
                            274,
                            19
                        ],
                        [
                            19,
                            354
                        ],
                        [
                            363,
                            456
                        ],
                        [
                            456,
                            281
                        ],
                        [
                            281,
                            363
                        ],
                        [
                            426,
                            436
                        ],
                        [
                            436,
                            425
                        ],
                        [
                            425,
                            426
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            252
                        ],
                        [
                            252,
                            380
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            393
                        ],
                        [
                            393,
                            267
                        ],
                        [
                            421,
                            200
                        ],
                        [
                            200,
                            428
                        ],
                        [
                            428,
                            421
                        ],
                        [
                            371,
                            266
                        ],
                        [
                            266,
                            329
                        ],
                        [
                            329,
                            371
                        ],
                        [
                            432,
                            287
                        ],
                        [
                            287,
                            422
                        ],
                        [
                            422,
                            432
                        ],
                        [
                            290,
                            250
                        ],
                        [
                            250,
                            328
                        ],
                        [
                            328,
                            290
                        ],
                        [
                            385,
                            258
                        ],
                        [
                            258,
                            384
                        ],
                        [
                            384,
                            385
                        ],
                        [
                            446,
                            265
                        ],
                        [
                            265,
                            342
                        ],
                        [
                            342,
                            446
                        ],
                        [
                            386,
                            387
                        ],
                        [
                            387,
                            257
                        ],
                        [
                            257,
                            386
                        ],
                        [
                            422,
                            424
                        ],
                        [
                            424,
                            430
                        ],
                        [
                            430,
                            422
                        ],
                        [
                            445,
                            342
                        ],
                        [
                            342,
                            276
                        ],
                        [
                            276,
                            445
                        ],
                        [
                            422,
                            273
                        ],
                        [
                            273,
                            424
                        ],
                        [
                            424,
                            422
                        ],
                        [
                            306,
                            292
                        ],
                        [
                            292,
                            307
                        ],
                        [
                            307,
                            306
                        ],
                        [
                            352,
                            366
                        ],
                        [
                            366,
                            345
                        ],
                        [
                            345,
                            352
                        ],
                        [
                            268,
                            271
                        ],
                        [
                            271,
                            302
                        ],
                        [
                            302,
                            268
                        ],
                        [
                            358,
                            423
                        ],
                        [
                            423,
                            371
                        ],
                        [
                            371,
                            358
                        ],
                        [
                            327,
                            294
                        ],
                        [
                            294,
                            460
                        ],
                        [
                            460,
                            327
                        ],
                        [
                            331,
                            279
                        ],
                        [
                            279,
                            294
                        ],
                        [
                            294,
                            331
                        ],
                        [
                            303,
                            271
                        ],
                        [
                            271,
                            304
                        ],
                        [
                            304,
                            303
                        ],
                        [
                            436,
                            432
                        ],
                        [
                            432,
                            427
                        ],
                        [
                            427,
                            436
                        ],
                        [
                            304,
                            272
                        ],
                        [
                            272,
                            408
                        ],
                        [
                            408,
                            304
                        ],
                        [
                            395,
                            394
                        ],
                        [
                            394,
                            431
                        ],
                        [
                            431,
                            395
                        ],
                        [
                            378,
                            395
                        ],
                        [
                            395,
                            400
                        ],
                        [
                            400,
                            378
                        ],
                        [
                            296,
                            334
                        ],
                        [
                            334,
                            299
                        ],
                        [
                            299,
                            296
                        ],
                        [
                            6,
                            351
                        ],
                        [
                            351,
                            168
                        ],
                        [
                            168,
                            6
                        ],
                        [
                            376,
                            352
                        ],
                        [
                            352,
                            411
                        ],
                        [
                            411,
                            376
                        ],
                        [
                            307,
                            325
                        ],
                        [
                            325,
                            320
                        ],
                        [
                            320,
                            307
                        ],
                        [
                            285,
                            295
                        ],
                        [
                            295,
                            336
                        ],
                        [
                            336,
                            285
                        ],
                        [
                            320,
                            319
                        ],
                        [
                            319,
                            404
                        ],
                        [
                            404,
                            320
                        ],
                        [
                            329,
                            330
                        ],
                        [
                            330,
                            349
                        ],
                        [
                            349,
                            329
                        ],
                        [
                            334,
                            293
                        ],
                        [
                            293,
                            333
                        ],
                        [
                            333,
                            334
                        ],
                        [
                            366,
                            323
                        ],
                        [
                            323,
                            447
                        ],
                        [
                            447,
                            366
                        ],
                        [
                            316,
                            15
                        ],
                        [
                            15,
                            315
                        ],
                        [
                            315,
                            316
                        ],
                        [
                            331,
                            358
                        ],
                        [
                            358,
                            279
                        ],
                        [
                            279,
                            331
                        ],
                        [
                            317,
                            14
                        ],
                        [
                            14,
                            316
                        ],
                        [
                            316,
                            317
                        ],
                        [
                            8,
                            285
                        ],
                        [
                            285,
                            9
                        ],
                        [
                            9,
                            8
                        ],
                        [
                            277,
                            329
                        ],
                        [
                            329,
                            350
                        ],
                        [
                            350,
                            277
                        ],
                        [
                            253,
                            374
                        ],
                        [
                            374,
                            252
                        ],
                        [
                            252,
                            253
                        ],
                        [
                            319,
                            318
                        ],
                        [
                            318,
                            403
                        ],
                        [
                            403,
                            319
                        ],
                        [
                            351,
                            6
                        ],
                        [
                            6,
                            419
                        ],
                        [
                            419,
                            351
                        ],
                        [
                            324,
                            318
                        ],
                        [
                            318,
                            325
                        ],
                        [
                            325,
                            324
                        ],
                        [
                            397,
                            367
                        ],
                        [
                            367,
                            365
                        ],
                        [
                            365,
                            397
                        ],
                        [
                            288,
                            435
                        ],
                        [
                            435,
                            397
                        ],
                        [
                            397,
                            288
                        ],
                        [
                            278,
                            344
                        ],
                        [
                            344,
                            439
                        ],
                        [
                            439,
                            278
                        ],
                        [
                            310,
                            272
                        ],
                        [
                            272,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            248,
                            195
                        ],
                        [
                            195,
                            281
                        ],
                        [
                            281,
                            248
                        ],
                        [
                            375,
                            273
                        ],
                        [
                            273,
                            291
                        ],
                        [
                            291,
                            375
                        ],
                        [
                            175,
                            396
                        ],
                        [
                            396,
                            199
                        ],
                        [
                            199,
                            175
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            268
                        ],
                        [
                            268,
                            312
                        ],
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            445
                        ],
                        [
                            445,
                            276
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            339
                        ],
                        [
                            339,
                            390
                        ],
                        [
                            295,
                            282
                        ],
                        [
                            282,
                            296
                        ],
                        [
                            296,
                            295
                        ],
                        [
                            448,
                            449
                        ],
                        [
                            449,
                            346
                        ],
                        [
                            346,
                            448
                        ],
                        [
                            356,
                            264
                        ],
                        [
                            264,
                            454
                        ],
                        [
                            454,
                            356
                        ],
                        [
                            337,
                            336
                        ],
                        [
                            336,
                            299
                        ],
                        [
                            299,
                            337
                        ],
                        [
                            337,
                            338
                        ],
                        [
                            338,
                            151
                        ],
                        [
                            151,
                            337
                        ],
                        [
                            294,
                            278
                        ],
                        [
                            278,
                            455
                        ],
                        [
                            455,
                            294
                        ],
                        [
                            308,
                            292
                        ],
                        [
                            292,
                            415
                        ],
                        [
                            415,
                            308
                        ],
                        [
                            429,
                            358
                        ],
                        [
                            358,
                            355
                        ],
                        [
                            355,
                            429
                        ],
                        [
                            265,
                            340
                        ],
                        [
                            340,
                            372
                        ],
                        [
                            372,
                            265
                        ],
                        [
                            352,
                            346
                        ],
                        [
                            346,
                            280
                        ],
                        [
                            280,
                            352
                        ],
                        [
                            295,
                            442
                        ],
                        [
                            442,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            354,
                            19
                        ],
                        [
                            19,
                            370
                        ],
                        [
                            370,
                            354
                        ],
                        [
                            285,
                            441
                        ],
                        [
                            441,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            195,
                            248
                        ],
                        [
                            248,
                            197
                        ],
                        [
                            197,
                            195
                        ],
                        [
                            457,
                            440
                        ],
                        [
                            440,
                            274
                        ],
                        [
                            274,
                            457
                        ],
                        [
                            301,
                            300
                        ],
                        [
                            300,
                            368
                        ],
                        [
                            368,
                            301
                        ],
                        [
                            417,
                            351
                        ],
                        [
                            351,
                            465
                        ],
                        [
                            465,
                            417
                        ],
                        [
                            251,
                            301
                        ],
                        [
                            301,
                            389
                        ],
                        [
                            389,
                            251
                        ],
                        [
                            394,
                            395
                        ],
                        [
                            395,
                            379
                        ],
                        [
                            379,
                            394
                        ],
                        [
                            399,
                            412
                        ],
                        [
                            412,
                            419
                        ],
                        [
                            419,
                            399
                        ],
                        [
                            410,
                            436
                        ],
                        [
                            436,
                            322
                        ],
                        [
                            322,
                            410
                        ],
                        [
                            326,
                            2
                        ],
                        [
                            2,
                            393
                        ],
                        [
                            393,
                            326
                        ],
                        [
                            354,
                            370
                        ],
                        [
                            370,
                            461
                        ],
                        [
                            461,
                            354
                        ],
                        [
                            393,
                            164
                        ],
                        [
                            164,
                            267
                        ],
                        [
                            267,
                            393
                        ],
                        [
                            268,
                            302
                        ],
                        [
                            302,
                            12
                        ],
                        [
                            12,
                            268
                        ],
                        [
                            312,
                            268
                        ],
                        [
                            268,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            298,
                            293
                        ],
                        [
                            293,
                            301
                        ],
                        [
                            301,
                            298
                        ],
                        [
                            265,
                            446
                        ],
                        [
                            446,
                            340
                        ],
                        [
                            340,
                            265
                        ],
                        [
                            280,
                            330
                        ],
                        [
                            330,
                            425
                        ],
                        [
                            425,
                            280
                        ],
                        [
                            322,
                            426
                        ],
                        [
                            426,
                            391
                        ],
                        [
                            391,
                            322
                        ],
                        [
                            420,
                            429
                        ],
                        [
                            429,
                            437
                        ],
                        [
                            437,
                            420
                        ],
                        [
                            393,
                            391
                        ],
                        [
                            391,
                            326
                        ],
                        [
                            326,
                            393
                        ],
                        [
                            344,
                            440
                        ],
                        [
                            440,
                            438
                        ],
                        [
                            438,
                            344
                        ],
                        [
                            458,
                            459
                        ],
                        [
                            459,
                            461
                        ],
                        [
                            461,
                            458
                        ],
                        [
                            364,
                            434
                        ],
                        [
                            434,
                            394
                        ],
                        [
                            394,
                            364
                        ],
                        [
                            428,
                            396
                        ],
                        [
                            396,
                            262
                        ],
                        [
                            262,
                            428
                        ],
                        [
                            274,
                            354
                        ],
                        [
                            354,
                            457
                        ],
                        [
                            457,
                            274
                        ],
                        [
                            317,
                            316
                        ],
                        [
                            316,
                            402
                        ],
                        [
                            402,
                            317
                        ],
                        [
                            316,
                            315
                        ],
                        [
                            315,
                            403
                        ],
                        [
                            403,
                            316
                        ],
                        [
                            315,
                            314
                        ],
                        [
                            314,
                            404
                        ],
                        [
                            404,
                            315
                        ],
                        [
                            314,
                            313
                        ],
                        [
                            313,
                            405
                        ],
                        [
                            405,
                            314
                        ],
                        [
                            313,
                            421
                        ],
                        [
                            421,
                            406
                        ],
                        [
                            406,
                            313
                        ],
                        [
                            323,
                            366
                        ],
                        [
                            366,
                            361
                        ],
                        [
                            361,
                            323
                        ],
                        [
                            292,
                            306
                        ],
                        [
                            306,
                            407
                        ],
                        [
                            407,
                            292
                        ],
                        [
                            306,
                            291
                        ],
                        [
                            291,
                            408
                        ],
                        [
                            408,
                            306
                        ],
                        [
                            291,
                            287
                        ],
                        [
                            287,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            287,
                            432
                        ],
                        [
                            432,
                            410
                        ],
                        [
                            410,
                            287
                        ],
                        [
                            427,
                            434
                        ],
                        [
                            434,
                            411
                        ],
                        [
                            411,
                            427
                        ],
                        [
                            372,
                            264
                        ],
                        [
                            264,
                            383
                        ],
                        [
                            383,
                            372
                        ],
                        [
                            459,
                            309
                        ],
                        [
                            309,
                            457
                        ],
                        [
                            457,
                            459
                        ],
                        [
                            366,
                            352
                        ],
                        [
                            352,
                            401
                        ],
                        [
                            401,
                            366
                        ],
                        [
                            1,
                            274
                        ],
                        [
                            274,
                            4
                        ],
                        [
                            4,
                            1
                        ],
                        [
                            418,
                            421
                        ],
                        [
                            421,
                            262
                        ],
                        [
                            262,
                            418
                        ],
                        [
                            331,
                            294
                        ],
                        [
                            294,
                            358
                        ],
                        [
                            358,
                            331
                        ],
                        [
                            435,
                            433
                        ],
                        [
                            433,
                            367
                        ],
                        [
                            367,
                            435
                        ],
                        [
                            392,
                            289
                        ],
                        [
                            289,
                            439
                        ],
                        [
                            439,
                            392
                        ],
                        [
                            328,
                            462
                        ],
                        [
                            462,
                            326
                        ],
                        [
                            326,
                            328
                        ],
                        [
                            94,
                            2
                        ],
                        [
                            2,
                            370
                        ],
                        [
                            370,
                            94
                        ],
                        [
                            289,
                            305
                        ],
                        [
                            305,
                            455
                        ],
                        [
                            455,
                            289
                        ],
                        [
                            339,
                            254
                        ],
                        [
                            254,
                            448
                        ],
                        [
                            448,
                            339
                        ],
                        [
                            359,
                            255
                        ],
                        [
                            255,
                            446
                        ],
                        [
                            446,
                            359
                        ],
                        [
                            254,
                            253
                        ],
                        [
                            253,
                            449
                        ],
                        [
                            449,
                            254
                        ],
                        [
                            253,
                            252
                        ],
                        [
                            252,
                            450
                        ],
                        [
                            450,
                            253
                        ],
                        [
                            252,
                            256
                        ],
                        [
                            256,
                            451
                        ],
                        [
                            451,
                            252
                        ],
                        [
                            256,
                            341
                        ],
                        [
                            341,
                            452
                        ],
                        [
                            452,
                            256
                        ],
                        [
                            414,
                            413
                        ],
                        [
                            413,
                            463
                        ],
                        [
                            463,
                            414
                        ],
                        [
                            286,
                            441
                        ],
                        [
                            441,
                            414
                        ],
                        [
                            414,
                            286
                        ],
                        [
                            286,
                            258
                        ],
                        [
                            258,
                            441
                        ],
                        [
                            441,
                            286
                        ],
                        [
                            258,
                            257
                        ],
                        [
                            257,
                            442
                        ],
                        [
                            442,
                            258
                        ],
                        [
                            257,
                            259
                        ],
                        [
                            259,
                            443
                        ],
                        [
                            443,
                            257
                        ],
                        [
                            259,
                            260
                        ],
                        [
                            260,
                            444
                        ],
                        [
                            444,
                            259
                        ],
                        [
                            260,
                            467
                        ],
                        [
                            467,
                            445
                        ],
                        [
                            445,
                            260
                        ],
                        [
                            309,
                            459
                        ],
                        [
                            459,
                            250
                        ],
                        [
                            250,
                            309
                        ],
                        [
                            305,
                            289
                        ],
                        [
                            289,
                            290
                        ],
                        [
                            290,
                            305
                        ],
                        [
                            305,
                            290
                        ],
                        [
                            290,
                            460
                        ],
                        [
                            460,
                            305
                        ],
                        [
                            401,
                            376
                        ],
                        [
                            376,
                            435
                        ],
                        [
                            435,
                            401
                        ],
                        [
                            309,
                            250
                        ],
                        [
                            250,
                            392
                        ],
                        [
                            392,
                            309
                        ],
                        [
                            376,
                            411
                        ],
                        [
                            411,
                            433
                        ],
                        [
                            433,
                            376
                        ],
                        [
                            453,
                            341
                        ],
                        [
                            341,
                            464
                        ],
                        [
                            464,
                            453
                        ],
                        [
                            357,
                            453
                        ],
                        [
                            453,
                            465
                        ],
                        [
                            465,
                            357
                        ],
                        [
                            343,
                            357
                        ],
                        [
                            357,
                            412
                        ],
                        [
                            412,
                            343
                        ],
                        [
                            437,
                            343
                        ],
                        [
                            343,
                            399
                        ],
                        [
                            399,
                            437
                        ],
                        [
                            344,
                            360
                        ],
                        [
                            360,
                            440
                        ],
                        [
                            440,
                            344
                        ],
                        [
                            420,
                            437
                        ],
                        [
                            437,
                            456
                        ],
                        [
                            456,
                            420
                        ],
                        [
                            360,
                            420
                        ],
                        [
                            420,
                            363
                        ],
                        [
                            363,
                            360
                        ],
                        [
                            361,
                            401
                        ],
                        [
                            401,
                            288
                        ],
                        [
                            288,
                            361
                        ],
                        [
                            265,
                            372
                        ],
                        [
                            372,
                            353
                        ],
                        [
                            353,
                            265
                        ],
                        [
                            390,
                            339
                        ],
                        [
                            339,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            339,
                            448
                        ],
                        [
                            448,
                            255
                        ],
                        [
                            255,
                            339
                        ]
                    ]);
                    K("VERSION", "0.4.1646425229");
                }).call(VonageFacedetection);
                const VonageFacemash = {};
                (function() {
                    var v;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var G = ca(this);
                    function J(a, b) {
                        if (b) a: {
                            var c = G;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    J("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    J("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = G[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function K(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function L(a) {
                        if (!(a instanceof Array)) {
                            a = K(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var ea = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, fa;
                    if (typeof Object.setPrototypeOf == "function") fa = Object.setPrototypeOf;
                    else {
                        var ha;
                        a: {
                            var ia = {
                                a: true
                            }, ja = {};
                            try {
                                ja.__proto__ = ia;
                                ha = ja.a;
                                break a;
                            } catch (a) {}
                            ha = false;
                        }
                        fa = ha ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var ka = fa;
                    function M(a, b) {
                        a.prototype = ea(b.prototype);
                        a.prototype.constructor = a;
                        if (ka) ka(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.ea = b.prototype;
                    }
                    function ma() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.s = this.m = 0;
                        this.j = null;
                    }
                    function na(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    ma.prototype.o = function(a) {
                        this.h = a;
                    };
                    function oa(a, b) {
                        a.j = {
                            U: b,
                            V: true
                        };
                        a.g = a.m || a.s;
                    }
                    ma.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.s;
                    };
                    function N(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function pa(a) {
                        this.g = new ma();
                        this.h = a;
                    }
                    function qa(a, b) {
                        na(a.g);
                        var c = a.g.i;
                        if (c) return ra(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return sa(a);
                    }
                    function ra(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, oa(a.g, f), sa(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return sa(a);
                    }
                    function sa(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, oa(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.V) throw b.U;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function ta(a) {
                        this.next = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = sa(a));
                            return b;
                        };
                        this.throw = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = sa(a));
                            return b;
                        };
                        this.return = function(b) {
                            return qa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function O(a, b) {
                        b = new ta(new pa(b));
                        ka && a.prototype && ka(b, a.prototype);
                        return b;
                    }
                    function ua(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    J("Object.assign", function(a) {
                        return a || va;
                    });
                    J("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.o = false;
                            var h = this.j();
                            try {
                                f(h.resolve, h.reject);
                            } catch (k) {
                                h.reject(k);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(h) {
                                h(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var h = this;
                                this.i(function() {
                                    h.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = G.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var h = 0; h < f.length; ++h){
                                    var k = f[h];
                                    f[h] = null;
                                    try {
                                        k();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(n) {
                                    k || (k = true, l.call(h, n));
                                };
                            }
                            var h = this, k = false;
                            return {
                                resolve: f(this.C),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.C = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.F(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var h = f != null;
                                        break a;
                                    case "function":
                                        h = true;
                                        break a;
                                    default:
                                        h = false;
                                }
                                h ? this.u(f) : this.m(f);
                            }
                        };
                        b.prototype.u = function(f) {
                            var h = void 0;
                            try {
                                h = f.then;
                            } catch (k) {
                                this.l(k);
                                return;
                            }
                            typeof h == "function" ? this.G(h, f) : this.m(f);
                        };
                        b.prototype.l = function(f) {
                            this.s(2, f);
                        };
                        b.prototype.m = function(f) {
                            this.s(1, f);
                        };
                        b.prototype.s = function(f, h) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = h;
                            this.h === 2 && this.D();
                            this.A();
                        };
                        b.prototype.D = function() {
                            var f = this;
                            e(function() {
                                if (f.B()) {
                                    var h = G.console;
                                    typeof h !== "undefined" && h.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.B = function() {
                            if (this.o) return false;
                            var f = G.CustomEvent, h = G.Event, k = G.dispatchEvent;
                            if (typeof k === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof h === "function" ? f = new h("unhandledrejection", {
                                cancelable: true
                            }) : (f = G.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return k(f);
                        };
                        b.prototype.A = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.F = function(f) {
                            var h = this.j();
                            f.J(h.resolve, h.reject);
                        };
                        b.prototype.G = function(f, h) {
                            var k = this.j();
                            try {
                                f.call(h, k.resolve, k.reject);
                            } catch (l) {
                                k.reject(l);
                            }
                        };
                        b.prototype.then = function(f, h) {
                            function k(w, r) {
                                return typeof w == "function" ? function(y) {
                                    try {
                                        l(w(y));
                                    } catch (m) {
                                        n(m);
                                    }
                                } : r;
                            }
                            var l, n, u = new b(function(w, r) {
                                l = w;
                                n = r;
                            });
                            this.J(k(f, l), k(h, n));
                            return u;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.J = function(f, h) {
                            function k() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        h(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(k) : this.g.push(k);
                            this.o = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(h, k) {
                                k(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(h, k) {
                                for(var l = K(f), n = l.next(); !n.done; n = l.next())d(n.value).J(h, k);
                            });
                        };
                        b.all = function(f) {
                            var h = K(f), k = h.next();
                            return k.done ? d([]) : new b(function(l, n) {
                                function u(y) {
                                    return function(m) {
                                        w[y] = m;
                                        r--;
                                        r == 0 && l(w);
                                    };
                                }
                                var w = [], r = 0;
                                do w.push(void 0), r++, d(k.value).J(u(w.length - 1), n), k = h.next();
                                while (!k.done);
                            });
                        };
                        return b;
                    });
                    J("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    J("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    J("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    J("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ua(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var wa = this || self;
                    function P(a, b) {
                        a = a.split(".");
                        var c = wa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function xa(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var ya, za = typeof TextDecoder !== "undefined", Aa, Ba = typeof TextEncoder !== "undefined";
                    function Ca(a) {
                        if (Ba) a = (Aa || (Aa = new TextEncoder())).encode(a);
                        else {
                            var b = void 0;
                            b = b === void 0 ? false : b;
                            for(var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++){
                                var g = a.charCodeAt(e);
                                if (128 > g) d[c++] = g;
                                else {
                                    if (2048 > g) d[c++] = g >> 6 | 192;
                                    else {
                                        if (55296 <= g && 57343 >= g) {
                                            if (56319 >= g && e < a.length) {
                                                var f = a.charCodeAt(++e);
                                                if (56320 <= f && 57343 >= f) {
                                                    g = 1024 * (g - 55296) + f - 56320 + 65536;
                                                    d[c++] = g >> 18 | 240;
                                                    d[c++] = g >> 12 & 63 | 128;
                                                    d[c++] = g >> 6 & 63 | 128;
                                                    d[c++] = g & 63 | 128;
                                                    continue;
                                                } else e--;
                                            }
                                            if (b) throw Error("Found an unpaired surrogate");
                                            g = 65533;
                                        }
                                        d[c++] = g >> 12 | 224;
                                        d[c++] = g >> 6 & 63 | 128;
                                    }
                                    d[c++] = g & 63 | 128;
                                }
                            }
                            a = d.subarray(0, c);
                        }
                        return a;
                    }
                    var Da = {}, Ea = null;
                    function Fa(a, b) {
                        b === void 0 && (b = 0);
                        Ga();
                        b = Da[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | h >> 4];
                            h = b[(h & 15) << 2 | k >> 6];
                            k = b[k & 63];
                            c[g++] = l + f + h + k;
                        }
                        l = 0;
                        k = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], k = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
                        }
                        return c.join("");
                    }
                    function Ha(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Ia(a, function(g) {
                            d[e++] = g;
                        });
                        return d.subarray(0, e);
                    }
                    function Ia(a, b) {
                        function c(k) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), n = Ea[l];
                                if (n != null) return n;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return k;
                        }
                        Ga();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), h = c(64);
                            if (h === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
                        }
                    }
                    function Ga() {
                        if (!Ea) {
                            Ea = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Da[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    Ea[g] === void 0 && (Ea[g] = e);
                                }
                            }
                        }
                    }
                    var Ja = typeof Uint8Array.prototype.slice === "function", Ka;
                    function La(a, b, c) {
                        return b === c ? Ka || (Ka = new Uint8Array(0)) : Ja ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
                    }
                    var Q = 0, R = 0;
                    function Ma(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.v === void 0 ? false : b.v;
                        this.h = null;
                        this.g = this.j = this.l = 0;
                        this.m = false;
                        this.v = b;
                        a && Na(this, a);
                    }
                    function Na(a, b) {
                        b = b.constructor === Uint8Array ? b : b.constructor === ArrayBuffer ? new Uint8Array(b) : b.constructor === Array ? new Uint8Array(b) : b.constructor === String ? Ha(b) : b instanceof Uint8Array ? new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : new Uint8Array(0);
                        a.h = b;
                        a.l = 0;
                        a.j = a.h.length;
                        a.g = a.l;
                    }
                    Ma.prototype.reset = function() {
                        this.g = this.l;
                    };
                    function Oa(a) {
                        for(var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)b = a.h[a.g++], c |= (b & 127) << 7 * e;
                        128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
                        if (128 <= b) for(e = 0; 5 > e && 128 <= b; e++)b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
                        if (128 > b) {
                            a = c >>> 0;
                            b = d >>> 0;
                            if (d = b & 2147483648) a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
                            a = 4294967296 * b + (a >>> 0);
                            return d ? -a : a;
                        }
                        a.m = true;
                    }
                    Ma.prototype.i = function() {
                        var a = this.h, b = a[this.g], c = b & 127;
                        if (128 > b) return this.g += 1, c;
                        b = a[this.g + 1];
                        c |= (b & 127) << 7;
                        if (128 > b) return this.g += 2, c;
                        b = a[this.g + 2];
                        c |= (b & 127) << 14;
                        if (128 > b) return this.g += 3, c;
                        b = a[this.g + 3];
                        c |= (b & 127) << 21;
                        if (128 > b) return this.g += 4, c;
                        b = a[this.g + 4];
                        c |= (b & 15) << 28;
                        if (128 > b) return this.g += 5, c >>> 0;
                        this.g += 5;
                        128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && this.g++;
                        return c;
                    };
                    Ma.prototype.o = function() {
                        var a = this.h[this.g], b = this.h[this.g + 1];
                        var c = this.h[this.g + 2];
                        var d = this.h[this.g + 3];
                        this.g += 4;
                        c = (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
                        a = 2 * (c >> 31) + 1;
                        b = c >>> 23 & 255;
                        c &= 8388607;
                        return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
                    };
                    var Pa = [];
                    function Qa() {
                        this.g = new Uint8Array(64);
                        this.h = 0;
                    }
                    Qa.prototype.push = function(a) {
                        if (!(this.h + 1 < this.g.length)) {
                            var b = this.g;
                            this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length));
                            this.g.set(b);
                        }
                        this.g[this.h++] = a;
                    };
                    Qa.prototype.length = function() {
                        return this.h;
                    };
                    Qa.prototype.end = function() {
                        var a = this.g, b = this.h;
                        this.h = 0;
                        return La(a, 0, b);
                    };
                    function Ra(a, b) {
                        for(; 127 < b;)a.push(b & 127 | 128), b >>>= 7;
                        a.push(b);
                    }
                    function Sa(a) {
                        var b = {}, c = b.N === void 0 ? false : b.N;
                        this.o = {
                            v: b.v === void 0 ? false : b.v
                        };
                        this.N = c;
                        b = this.o;
                        Pa.length ? (c = Pa.pop(), b && (c.v = b.v), a && Na(c, a), a = c) : a = new Ma(a, b);
                        this.g = a;
                        this.m = this.g.g;
                        this.h = this.i = this.l = -1;
                        this.j = false;
                    }
                    Sa.prototype.reset = function() {
                        this.g.reset();
                        this.h = this.l = -1;
                    };
                    function S(a) {
                        var b = a.g;
                        (b = b.g == b.j) || (b = a.j) || (b = a.g, b = b.m || 0 > b.g || b.g > b.j);
                        if (b) return false;
                        a.m = a.g.g;
                        b = a.g.i();
                        var c = b & 7;
                        if (c != 0 && c != 5 && c != 1 && c != 2 && c != 3 && c != 4) return a.j = true, false;
                        a.i = b;
                        a.l = b >>> 3;
                        a.h = c;
                        return true;
                    }
                    function Ta(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Ta(a);
                                else {
                                    for(a = a.g; a.h[a.g] & 128;)a.g++;
                                    a.g++;
                                }
                                break;
                            case 1:
                                a.h != 1 ? Ta(a) : (a = a.g, a.g += 8);
                                break;
                            case 2:
                                if (a.h != 2) Ta(a);
                                else {
                                    var b = a.g.i();
                                    a = a.g;
                                    a.g += b;
                                }
                                break;
                            case 5:
                                a.h != 5 ? Ta(a) : (a = a.g, a.g += 4);
                                break;
                            case 3:
                                b = a.l;
                                do {
                                    if (!S(a)) {
                                        a.j = true;
                                        break;
                                    }
                                    if (a.h == 4) {
                                        a.l != b && (a.j = true);
                                        break;
                                    }
                                    Ta(a);
                                }while (1);
                                break;
                            default:
                                a.j = true;
                        }
                    }
                    function Ua(a, b, c) {
                        var d = a.g.j, e = a.g.i(), g = a.g.g + e;
                        a.g.j = g;
                        c(b, a);
                        c = g - a.g.g;
                        if (c !== 0) throw Error("Message parsing ended unexpectedly. Expected to read " + e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length");
                        a.g.g = g;
                        a.g.j = d;
                        return b;
                    }
                    function T(a) {
                        return a.g.o();
                    }
                    function Va(a) {
                        var b = a.g.i();
                        a = a.g;
                        var c = a.g;
                        a.g += b;
                        a = a.h;
                        var d;
                        if (za) (d = ya) || (d = ya = new TextDecoder("utf-8", {
                            fatal: false
                        })), d = d.decode(a.subarray(c, c + b));
                        else {
                            b = c + b;
                            for(var e = [], g = null, f, h, k; c < b;)f = a[c++], 128 > f ? e.push(f) : 224 > f ? c >= b ? e.push(65533) : (h = a[c++], 194 > f || (h & 192) !== 128 ? (c--, e.push(65533)) : e.push((f & 31) << 6 | h & 63)) : 240 > f ? c >= b - 1 ? e.push(65533) : (h = a[c++], (h & 192) !== 128 || f === 224 && 160 > h || f === 237 && 160 <= h || ((d = a[c++]) & 192) !== 128 ? (c--, e.push(65533)) : e.push((f & 15) << 12 | (h & 63) << 6 | d & 63)) : 244 >= f ? c >= b - 2 ? e.push(65533) : (h = a[c++], (h & 192) !== 128 || (f << 28) + (h - 144) >> 30 !== 0 || ((d = a[c++]) & 192) !== 128 || ((k = a[c++]) & 192) !== 128 ? (c--, e.push(65533)) : (f = (f & 7) << 18 | (h & 63) << 12 | (d & 63) << 6 | k & 63, f -= 65536, e.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320))) : e.push(65533), 8192 <= e.length && (g = xa(g, e), e.length = 0);
                            d = xa(g, e);
                        }
                        return d;
                    }
                    function Wa(a, b, c) {
                        var d = a.g.i();
                        for(d = a.g.g + d; a.g.g < d;)c.push(b.call(a.g));
                    }
                    function Xa(a, b) {
                        a.h == 2 ? Wa(a, Ma.prototype.o, b) : b.push(T(a));
                    }
                    function Ya() {
                        this.h = [];
                        this.i = 0;
                        this.g = new Qa();
                    }
                    function Za(a, b) {
                        b.length !== 0 && (a.h.push(b), a.i += b.length);
                    }
                    function $a(a) {
                        var b = a.i + a.g.length();
                        if (b === 0) return new Uint8Array(0);
                        b = new Uint8Array(b);
                        for(var c = a.h, d = c.length, e = 0, g = 0; g < d; g++){
                            var f = c[g];
                            f.length !== 0 && (b.set(f, e), e += f.length);
                        }
                        c = a.g;
                        d = c.h;
                        d !== 0 && (b.set(c.g.subarray(0, d), e), c.h = 0);
                        a.h = [
                            b
                        ];
                        return b;
                    }
                    function U(a, b, c) {
                        if (c != null) {
                            Ra(a.g, 8 * b + 5);
                            a = a.g;
                            var d = c;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? Q = R = 0 : (R = 0, Q = 2147483648) : isNaN(d) ? (R = 0, Q = 2147483647) : 34028234663852886e22 < d ? (R = 0, Q = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), R = 0, Q = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, R = 0, Q = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = Q;
                            a.push(c >>> 0 & 255);
                            a.push(c >>> 8 & 255);
                            a.push(c >>> 16 & 255);
                            a.push(c >>> 24 & 255);
                        }
                    }
                    var ab = typeof Uint8Array === "function";
                    function bb(a, b, c) {
                        if (a != null) return typeof a === "object" ? ab && a instanceof Uint8Array ? c(a) : cb(a, b, c) : b(a);
                    }
                    function cb(a, b, c) {
                        if (Array.isArray(a)) {
                            for(var d = Array(a.length), e = 0; e < a.length; e++)d[e] = bb(a[e], b, c);
                            Array.isArray(a) && a.W && db(d);
                            return d;
                        }
                        d = {};
                        for(e in a)d[e] = bb(a[e], b, c);
                        return d;
                    }
                    function eb(a) {
                        return typeof a === "number" ? isFinite(a) ? a : String(a) : a;
                    }
                    var fb = {
                        W: {
                            value: true,
                            configurable: true
                        }
                    };
                    function db(a) {
                        Array.isArray(a) && !Object.isFrozen(a) && Object.defineProperties(a, fb);
                        return a;
                    }
                    var gb;
                    function V(a, b, c) {
                        var d = gb;
                        gb = null;
                        a || (a = d);
                        d = this.constructor.ca;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.j = d ? 0 : -1;
                        this.m = this.g = null;
                        this.h = a;
                        a: {
                            d = this.h.length;
                            a = d - 1;
                            if (d && (d = this.h[a], !(d === null || typeof d != "object" || Array.isArray(d) || ab && d instanceof Uint8Array))) {
                                this.l = a - this.j;
                                this.i = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)a = c[b], a < this.l ? (a += this.j, (d = this.h[a]) ? db(d) : this.h[a] = hb) : (ib(this), (d = this.i[a]) ? db(d) : this.i[a] = hb);
                    }
                    var hb = Object.freeze(db([]));
                    function ib(a) {
                        var b = a.l + a.j;
                        a.h[b] || (a.i = a.h[b] = {});
                    }
                    function W(a, b, c) {
                        return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.i ? a.i[b] : void 0 : a.h[b + a.j];
                    }
                    function jb(a, b) {
                        var c = c === void 0 ? false : c;
                        var d = W(a, b, c);
                        d == null && (d = hb);
                        d === hb && (d = db([]), X(a, b, d, c));
                        return d;
                    }
                    function kb(a) {
                        var b = jb(a, 3);
                        a.m || (a.m = {});
                        if (!a.m[3]) {
                            for(var c = 0; c < b.length; c++)b[c] = +b[c];
                            a.m[3] = true;
                        }
                        return b;
                    }
                    function lb(a, b, c) {
                        a = W(a, b);
                        return a == null ? c : a;
                    }
                    function Y(a, b, c) {
                        a = W(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function X(a, b, c, d) {
                        (d === void 0 ? 0 : d) || b >= a.l ? (ib(a), a.i[b] = c) : a.h[b + a.j] = c;
                    }
                    function mb(a, b, c) {
                        if (c === -1) return null;
                        a.g || (a.g = {});
                        if (!a.g[c]) {
                            var d = W(a, c, false);
                            d && (a.g[c] = new b(d));
                        }
                        return a.g[c];
                    }
                    function nb(a, b) {
                        a.g || (a.g = {});
                        var c = a.g[1];
                        if (!c) {
                            var d = jb(a, 1);
                            c = [];
                            for(var e = 0; e < d.length; e++)c[e] = new b(d[e]);
                            a.g[1] = c;
                        }
                        return c;
                    }
                    function ob(a, b, c) {
                        var d = d === void 0 ? false : d;
                        a.g || (a.g = {});
                        var e = c ? pb(c) : c;
                        a.g[b] = c;
                        X(a, b, e, d);
                    }
                    function qb(a, b, c, d) {
                        var e = nb(a, c);
                        b = b ? b : new c();
                        a = jb(a, 1);
                        d != void 0 ? (e.splice(d, 0, b), a.splice(d, 0, pb(b))) : (e.push(b), a.push(pb(b)));
                    }
                    V.prototype.toJSON = function() {
                        var a = pb(this);
                        return cb(a, eb, Fa);
                    };
                    function pb(a, b) {
                        if (a.g) for(var c in a.g){
                            var d = a.g[c];
                            if (Array.isArray(d)) for(var e = 0; e < d.length; e++)d[e] && pb(d[e]);
                            else d && pb(d);
                        }
                        return a.h;
                    }
                    V.prototype.toString = function() {
                        return pb(this).toString();
                    };
                    function rb(a, b) {
                        if (a = a.o) {
                            Za(b, b.g.end());
                            for(var c = 0; c < a.length; c++)Za(b, a[c]);
                        }
                    }
                    function sb(a, b) {
                        if (b.h == 4) return false;
                        var c = b.m;
                        Ta(b);
                        b.N || (b = La(b.g.h, c, b.g.g), (c = a.o) ? c.push(b) : a.o = [
                            b
                        ]);
                        return true;
                    }
                    function tb(a) {
                        V.call(this, a, -1, ub);
                    }
                    M(tb, V);
                    tb.prototype.getRows = function() {
                        return W(this, 1);
                    };
                    tb.prototype.getCols = function() {
                        return W(this, 2);
                    };
                    tb.prototype.getPackedDataList = function() {
                        return kb(this);
                    };
                    tb.prototype.getLayout = function() {
                        return lb(this, 4, 0);
                    };
                    function vb(a, b) {
                        for(; S(b);)switch(b.i){
                            case 8:
                                var c = b.g.i();
                                X(a, 1, c);
                                break;
                            case 16:
                                c = b.g.i();
                                X(a, 2, c);
                                break;
                            case 29:
                            case 26:
                                Xa(b, a.getPackedDataList());
                                break;
                            case 32:
                                c = Oa(b.g);
                                X(a, 4, c);
                                break;
                            default:
                                if (!sb(a, b)) return a;
                        }
                        return a;
                    }
                    var ub = [
                        3
                    ];
                    function Z(a, b) {
                        var c = void 0;
                        return new (c || (c = Promise))(function(d, e) {
                            function g(k) {
                                try {
                                    h(b.next(k));
                                } catch (l) {
                                    e(l);
                                }
                            }
                            function f(k) {
                                try {
                                    h(b["throw"](k));
                                } catch (l) {
                                    e(l);
                                }
                            }
                            function h(k) {
                                k.done ? d(k.value) : new c(function(l) {
                                    l(k.value);
                                }).then(g, f);
                            }
                            h((b = b.apply(a, void 0)).next());
                        });
                    }
                    function wb(a) {
                        V.call(this, a);
                    }
                    M(wb, V);
                    function xb(a, b) {
                        for(; S(b);)switch(b.i){
                            case 8:
                                var c = b.g.i();
                                X(a, 1, c);
                                break;
                            case 21:
                                c = T(b);
                                X(a, 2, c);
                                break;
                            case 26:
                                c = Va(b);
                                X(a, 3, c);
                                break;
                            case 34:
                                c = Va(b);
                                X(a, 4, c);
                                break;
                            default:
                                if (!sb(a, b)) return a;
                        }
                        return a;
                    }
                    function yb(a) {
                        V.call(this, a, -1, zb);
                    }
                    M(yb, V);
                    yb.prototype.addClassification = function(a, b) {
                        qb(this, a, wb, b);
                        return this;
                    };
                    var zb = [
                        1
                    ];
                    function Ab(a) {
                        V.call(this, a);
                    }
                    M(Ab, V);
                    function Bb(a, b) {
                        for(; S(b);)switch(b.i){
                            case 13:
                                var c = T(b);
                                X(a, 1, c);
                                break;
                            case 21:
                                c = T(b);
                                X(a, 2, c);
                                break;
                            case 29:
                                c = T(b);
                                X(a, 3, c);
                                break;
                            case 37:
                                c = T(b);
                                X(a, 4, c);
                                break;
                            case 45:
                                c = T(b);
                                X(a, 5, c);
                                break;
                            default:
                                if (!sb(a, b)) return a;
                        }
                        return a;
                    }
                    function Cb(a) {
                        V.call(this, a, -1, Db);
                    }
                    M(Cb, V);
                    function Eb(a) {
                        a: {
                            var b = new Cb();
                            for(a = new Sa(a); S(a);)switch(a.i){
                                case 10:
                                    var c = Ua(a, new Ab(), Bb);
                                    qb(b, c, Ab, void 0);
                                    break;
                                default:
                                    if (!sb(b, a)) break a;
                            }
                        }
                        return b;
                    }
                    var Db = [
                        1
                    ];
                    function Fb(a) {
                        V.call(this, a);
                    }
                    M(Fb, V);
                    function Gb(a) {
                        V.call(this, a, -1, Hb);
                    }
                    M(Gb, V);
                    Gb.prototype.getVertexType = function() {
                        return lb(this, 1, 0);
                    };
                    Gb.prototype.getPrimitiveType = function() {
                        return lb(this, 2, 0);
                    };
                    Gb.prototype.getVertexBufferList = function() {
                        return kb(this);
                    };
                    Gb.prototype.getIndexBufferList = function() {
                        return jb(this, 4);
                    };
                    function Ib(a, b) {
                        for(; S(b);)switch(b.i){
                            case 8:
                                var c = Oa(b.g);
                                X(a, 1, c);
                                break;
                            case 16:
                                c = Oa(b.g);
                                X(a, 2, c);
                                break;
                            case 29:
                            case 26:
                                Xa(b, a.getVertexBufferList());
                                break;
                            case 32:
                            case 34:
                                c = b;
                                var d = a.getIndexBufferList();
                                c.h == 2 ? Wa(c, Ma.prototype.i, d) : d.push(c.g.i());
                                break;
                            default:
                                if (!sb(a, b)) return a;
                        }
                        return a;
                    }
                    var Hb = [
                        3,
                        4
                    ];
                    function Jb(a) {
                        V.call(this, a);
                    }
                    M(Jb, V);
                    Jb.prototype.getMesh = function() {
                        return mb(this, Gb, 1);
                    };
                    Jb.prototype.getPoseTransformMatrix = function() {
                        return mb(this, tb, 2);
                    };
                    function Kb(a) {
                        a: {
                            var b = new Jb();
                            for(a = new Sa(a); S(a);)switch(a.i){
                                case 10:
                                    var c = Ua(a, new Gb(), Ib);
                                    ob(b, 1, c);
                                    break;
                                case 18:
                                    c = Ua(a, new tb(), vb);
                                    ob(b, 2, c);
                                    break;
                                default:
                                    if (!sb(b, a)) break a;
                            }
                        }
                        return b;
                    }
                    function Lb(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function Mb(a) {
                        return nb(a, wb).map(function(b) {
                            return {
                                index: lb(b, 1, 0),
                                Y: Y(b, 2),
                                label: W(b, 3) != null ? lb(b, 3, "") : void 0,
                                displayName: W(b, 4) != null ? lb(b, 4, "") : void 0
                            };
                        });
                    }
                    function Nb(a) {
                        return {
                            x: Y(a, 1),
                            y: Y(a, 2),
                            z: Y(a, 3),
                            visibility: W(a, 4) != null ? Y(a, 4) : void 0
                        };
                    }
                    function Ob(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function Pb(a, b, c) {
                        Qb(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function Qb(a, b) {
                        var c = a.g;
                        if (a.m === void 0) {
                            var d = Lb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Lb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.m = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                I: c.getAttribLocation(d, "aVertex"),
                                H: c.getAttribLocation(d, "aTex"),
                                da: e
                            };
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.I);
                            c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.o = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.o);
                            c.enableVertexAttribArray(a.j.H);
                            c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.m);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, a.o);
                        c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.I);
                        c.disableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function Rb(a) {
                        this.g = a;
                    }
                    var Sb = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function Tb(a, b) {
                        return b + a;
                    }
                    function Ub(a, b) {
                        window[a] = b;
                    }
                    function Vb(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function Wb() {
                        return Z(this, function b() {
                            return O(b, function(c) {
                                switch(c.g){
                                    case 1:
                                        return c.m = 2, N(c, WebAssembly.instantiate(Sb), 4);
                                    case 4:
                                        c.g = 3;
                                        c.m = 0;
                                        break;
                                    case 2:
                                        return c.m = 0, c.j = null, c.return(false);
                                    case 3:
                                        return c.return(true);
                                }
                            });
                        });
                    }
                    function Xb(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.F = {};
                        this.m = {};
                        this.s = {};
                        this.G = this.o = this.R = true;
                        this.C = Promise.resolve();
                        this.P = "";
                        this.B = {};
                        this.locateFile = a && a.locateFile || Tb;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.S = b;
                        if (a.options) {
                            b = K(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    v = Xb.prototype;
                    v.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Yb(a, b) {
                        return a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(b) : a.g.files;
                    }
                    function Zb(a) {
                        return Z(a, function c() {
                            var d = this, e, g, f, h, k, l, n, u, w, r, y;
                            return O(c, function(m) {
                                switch(m.g){
                                    case 1:
                                        e = d;
                                        if (!d.R) return m.return();
                                        g = Yb(d, d.j);
                                        return N(m, Wb(), 2);
                                    case 2:
                                        f = m.h;
                                        if (typeof window === "object") return Ub("createMediapipeSolutionsWasm", {
                                            locateFile: d.locateFile
                                        }), Ub("createMediapipeSolutionsPackedAssets", {
                                            locateFile: d.locateFile
                                        }), l = g.filter(function(t) {
                                            return t.data !== void 0;
                                        }), n = g.filter(function(t) {
                                            return t.data === void 0;
                                        }), u = Promise.all(l.map(function(t) {
                                            var x = $b(e, t.url);
                                            if (t.path !== void 0) {
                                                var z = t.path;
                                                x = x.then(function(E) {
                                                    e.overrideFile(z, E);
                                                    return Promise.resolve(E);
                                                });
                                            }
                                            return x;
                                        })), w = Promise.all(n.map(function(t) {
                                            return t.simd === void 0 || t.simd && f || !t.simd && !f ? Vb(e.locateFile(t.url, e.S)) : Promise.resolve();
                                        })).then(function() {
                                            return Z(e, function x() {
                                                var z, E, F = this;
                                                return O(x, function(I) {
                                                    if (I.g == 1) return z = window.createMediapipeSolutionsWasm, E = window.createMediapipeSolutionsPackedAssets, N(I, z(E), 2);
                                                    F.h = I.h;
                                                    I.g = 0;
                                                });
                                            });
                                        }), r = function() {
                                            return Z(e, function x() {
                                                var z = this;
                                                return O(x, function(E) {
                                                    z.g.graph && z.g.graph.url ? E = N(E, $b(z, z.g.graph.url), 0) : (E.g = 0, E = void 0);
                                                    return E;
                                                });
                                            });
                                        }(), N(m, Promise.all([
                                            w,
                                            u,
                                            r
                                        ]), 7);
                                        if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                        h = g.filter(function(t) {
                                            return t.simd === void 0 || t.simd && f || !t.simd && !f;
                                        }).map(function(t) {
                                            return e.locateFile(t.url, e.S);
                                        });
                                        importScripts.apply(null, L(h));
                                        return N(m, createMediapipeSolutionsWasm(Module), 6);
                                    case 6:
                                        d.h = m.h;
                                        d.l = new OffscreenCanvas(1, 1);
                                        d.h.canvas = d.l;
                                        k = d.h.GL.createContext(d.l, {
                                            antialias: false,
                                            alpha: false,
                                            ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                        });
                                        d.h.GL.makeContextCurrent(k);
                                        m.g = 4;
                                        break;
                                    case 7:
                                        d.l = document.createElement("canvas");
                                        y = d.l.getContext("webgl2", {});
                                        if (!y && (y = d.l.getContext("webgl", {}), !y)) return alert("Failed to create WebGL canvas context when passing video frame."), m.return();
                                        d.D = y;
                                        d.h.canvas = d.l;
                                        d.h.createContext(d.l, true, true, {});
                                    case 4:
                                        d.i = new d.h.SolutionWasm(), d.R = false, m.g = 0;
                                }
                            });
                        });
                    }
                    function ac(a) {
                        return Z(a, function c() {
                            var d = this, e, g, f, h, k, l, n, u;
                            return O(c, function(w) {
                                if (w.g == 1) {
                                    if (d.g.graph && d.g.graph.url && d.P === d.g.graph.url) return w.return();
                                    d.o = true;
                                    if (!d.g.graph || !d.g.graph.url) {
                                        w.g = 2;
                                        return;
                                    }
                                    d.P = d.g.graph.url;
                                    return N(w, $b(d, d.g.graph.url), 3);
                                }
                                w.g != 2 && (e = w.h, d.i.loadGraph(e));
                                g = K(Object.keys(d.B));
                                for(f = g.next(); !f.done; f = g.next())h = f.value, d.i.overrideFile(h, d.B[h]);
                                d.B = {};
                                if (d.g.listeners) for(k = K(d.g.listeners), l = k.next(); !l.done; l = k.next())n = l.value, bc(d, n);
                                u = d.j;
                                d.j = {};
                                d.setOptions(u);
                                w.g = 0;
                            });
                        });
                    }
                    v.reset = function() {
                        return Z(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                c.i && (c.i.reset(), c.m = {}, c.s = {});
                                d.g = 0;
                            });
                        });
                    };
                    v.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = K(Object.keys(a)), h = f.next(); !h.done; g = {
                                K: g.K,
                                L: g.L
                            }, h = f.next()){
                                var k = h.value;
                                k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.K = h.onChange, g.L = a[k], d.push(function(l) {
                                    return function() {
                                        return Z(c, function u() {
                                            var w, r = this;
                                            return O(u, function(y) {
                                                if (y.g == 1) return N(y, l.K(l.L), 2);
                                                w = y.h;
                                                w === true && (r.o = true);
                                                y.g = 0;
                                            });
                                        });
                                    };
                                }(g))), h.graphOptionXref && (k = {
                                    valueNumber: h.type === 1 ? a[k] : 0,
                                    valueBoolean: h.type === 0 ? a[k] : false,
                                    valueString: h.type === 2 ? a[k] : ""
                                }, h = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), h.graphOptionXref), k), e.push(h))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.u = (this.u === void 0 ? [] : this.u).concat(d);
                        }
                    };
                    function cc(a) {
                        return Z(a, function c() {
                            var d = this, e, g, f, h, k, l, n;
                            return O(c, function(u) {
                                switch(u.g){
                                    case 1:
                                        if (!d.o) return u.return();
                                        if (!d.u) {
                                            u.g = 2;
                                            break;
                                        }
                                        e = K(d.u);
                                        g = e.next();
                                    case 3:
                                        if (g.done) {
                                            u.g = 5;
                                            break;
                                        }
                                        f = g.value;
                                        return N(u, f(), 4);
                                    case 4:
                                        g = e.next();
                                        u.g = 3;
                                        break;
                                    case 5:
                                        d.u = void 0;
                                    case 2:
                                        if (d.A) {
                                            h = new d.h.GraphOptionChangeRequestList();
                                            k = K(d.A);
                                            for(l = k.next(); !l.done; l = k.next())n = l.value, h.push_back(n);
                                            d.i.changeOptions(h);
                                            h.delete();
                                            d.A = void 0;
                                        }
                                        d.o = false;
                                        u.g = 0;
                                }
                            });
                        });
                    }
                    v.initialize = function() {
                        return Z(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                return d.g == 1 ? N(d, Zb(c), 2) : d.g != 3 ? N(d, ac(c), 3) : N(d, cc(c), 0);
                            });
                        });
                    };
                    function $b(a, b) {
                        return Z(a, function d() {
                            var e = this, g, f;
                            return O(d, function(h) {
                                if (b in e.F) return h.return(e.F[b]);
                                g = e.locateFile(b, "");
                                f = fetch(g).then(function(k) {
                                    return k.arrayBuffer();
                                });
                                e.F[b] = f;
                                return h.return(f);
                            });
                        });
                    }
                    v.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
                    };
                    v.clearOverriddenFiles = function() {
                        this.B = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    v.send = function(a, b) {
                        return Z(this, function d() {
                            var e = this, g, f, h, k, l, n, u, w, r;
                            return O(d, function(y) {
                                switch(y.g){
                                    case 1:
                                        if (!e.g.inputs) return y.return();
                                        g = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                        return N(y, e.C, 2);
                                    case 2:
                                        return N(y, e.initialize(), 3);
                                    case 3:
                                        f = new e.h.PacketDataList();
                                        h = K(Object.keys(a));
                                        for(k = h.next(); !k.done; k = h.next())if (l = k.value, n = e.g.inputs[l]) {
                                            a: {
                                                var m = e;
                                                var t = a[l];
                                                switch(n.type){
                                                    case "video":
                                                        var x = m.m[n.stream];
                                                        x || (x = new Ob(m.h, m.D), m.m[n.stream] = x);
                                                        m = x;
                                                        m.l === 0 && (m.l = m.h.createTexture());
                                                        if (typeof HTMLVideoElement !== "undefined" && t instanceof HTMLVideoElement) {
                                                            var z = t.videoWidth;
                                                            x = t.videoHeight;
                                                        } else typeof HTMLImageElement !== "undefined" && t instanceof HTMLImageElement ? (z = t.naturalWidth, x = t.naturalHeight) : (z = t.width, x = t.height);
                                                        x = {
                                                            glName: m.l,
                                                            width: z,
                                                            height: x
                                                        };
                                                        z = m.g;
                                                        z.canvas.width = x.width;
                                                        z.canvas.height = x.height;
                                                        z.activeTexture(z.TEXTURE0);
                                                        m.h.bindTexture2d(m.l);
                                                        z.texImage2D(z.TEXTURE_2D, 0, z.RGBA, z.RGBA, z.UNSIGNED_BYTE, t);
                                                        m.h.bindTexture2d(0);
                                                        m = x;
                                                        break a;
                                                    case "detections":
                                                        x = m.m[n.stream];
                                                        x || (x = new Rb(m.h), m.m[n.stream] = x);
                                                        m = x;
                                                        m.data || (m.data = new m.g.DetectionListData());
                                                        m.data.reset(t.length);
                                                        for(x = 0; x < t.length; ++x){
                                                            z = t[x];
                                                            var E = m.data, F = E.setBoundingBox, I = x;
                                                            var H = z.T;
                                                            var p = new Fb();
                                                            X(p, 1, H.Z);
                                                            X(p, 2, H.$);
                                                            X(p, 3, H.height);
                                                            X(p, 4, H.width);
                                                            X(p, 5, H.rotation);
                                                            X(p, 6, H.X);
                                                            var A = H = new Ya();
                                                            U(A, 1, W(p, 1));
                                                            U(A, 2, W(p, 2));
                                                            U(A, 3, W(p, 3));
                                                            U(A, 4, W(p, 4));
                                                            U(A, 5, W(p, 5));
                                                            var C = W(p, 6);
                                                            if (C != null && C != null) {
                                                                Ra(A.g, 48);
                                                                var q = A.g, B = C;
                                                                C = 0 > B;
                                                                B = Math.abs(B);
                                                                var D = B >>> 0;
                                                                B = Math.floor((B - D) / 4294967296);
                                                                B >>>= 0;
                                                                C && (B = ~B >>> 0, D = (~D >>> 0) + 1, 4294967295 < D && (D = 0, B++, 4294967295 < B && (B = 0)));
                                                                Q = D;
                                                                R = B;
                                                                C = Q;
                                                                for(D = R; 0 < D || 127 < C;)q.push(C & 127 | 128), C = (C >>> 7 | D << 25) >>> 0, D >>>= 7;
                                                                q.push(C);
                                                            }
                                                            rb(p, A);
                                                            H = $a(H);
                                                            F.call(E, I, H);
                                                            if (z.O) for(E = 0; E < z.O.length; ++E)p = z.O[E], A = p.visibility ? true : false, F = m.data, I = F.addNormalizedLandmark, H = x, p = Object.assign(Object.assign({}, p), {
                                                                visibility: A ? p.visibility : 0
                                                            }), A = new Ab(), X(A, 1, p.x), X(A, 2, p.y), X(A, 3, p.z), p.visibility && X(A, 4, p.visibility), q = p = new Ya(), U(q, 1, W(A, 1)), U(q, 2, W(A, 2)), U(q, 3, W(A, 3)), U(q, 4, W(A, 4)), U(q, 5, W(A, 5)), rb(A, q), p = $a(p), I.call(F, H, p);
                                                            if (z.M) for(E = 0; E < z.M.length; ++E){
                                                                F = m.data;
                                                                I = F.addClassification;
                                                                H = x;
                                                                p = z.M[E];
                                                                A = new wb();
                                                                X(A, 2, p.Y);
                                                                p.index && X(A, 1, p.index);
                                                                p.label && X(A, 3, p.label);
                                                                p.displayName && X(A, 4, p.displayName);
                                                                q = p = new Ya();
                                                                D = W(A, 1);
                                                                if (D != null && D != null) {
                                                                    if (Ra(q.g, 8), C = q.g, 0 <= D) Ra(C, D);
                                                                    else {
                                                                        for(B = 0; 9 > B; B++)C.push(D & 127 | 128), D >>= 7;
                                                                        C.push(1);
                                                                    }
                                                                }
                                                                U(q, 2, W(A, 2));
                                                                C = W(A, 3);
                                                                C != null && (C = Ca(C), Ra(q.g, 26), Ra(q.g, C.length), Za(q, q.g.end()), Za(q, C));
                                                                C = W(A, 4);
                                                                C != null && (C = Ca(C), Ra(q.g, 34), Ra(q.g, C.length), Za(q, q.g.end()), Za(q, C));
                                                                rb(A, q);
                                                                p = $a(p);
                                                                I.call(F, H, p);
                                                            }
                                                        }
                                                        m = m.data;
                                                        break a;
                                                    default:
                                                        m = {};
                                                }
                                            }
                                            u = m;
                                            w = n.stream;
                                            switch(n.type){
                                                case "video":
                                                    f.pushTexture2d(Object.assign(Object.assign({}, u), {
                                                        stream: w,
                                                        timestamp: g
                                                    }));
                                                    break;
                                                case "detections":
                                                    r = u;
                                                    r.stream = w;
                                                    r.timestamp = g;
                                                    f.pushDetectionList(r);
                                                    break;
                                                default:
                                                    throw Error("Unknown input config type: '" + n.type + "'");
                                            }
                                        }
                                        e.i.send(f);
                                        return N(y, e.C, 4);
                                    case 4:
                                        f.delete(), y.g = 0;
                                }
                            });
                        });
                    };
                    function dc(a, b, c) {
                        return Z(a, function e() {
                            var g, f, h, k, l, n, u = this, w, r, y, m, t, x, z, E;
                            return O(e, function(F) {
                                switch(F.g){
                                    case 1:
                                        if (!c) return F.return(b);
                                        g = {};
                                        f = 0;
                                        h = K(Object.keys(c));
                                        for(k = h.next(); !k.done; k = h.next())l = k.value, n = c[l], typeof n !== "string" && n.type === "texture" && b[n.stream] !== void 0 && ++f;
                                        1 < f && (u.G = false);
                                        w = K(Object.keys(c));
                                        k = w.next();
                                    case 2:
                                        if (k.done) {
                                            F.g = 4;
                                            break;
                                        }
                                        r = k.value;
                                        y = c[r];
                                        if (typeof y === "string") return z = g, E = r, N(F, ec(u, r, b[y]), 14);
                                        m = b[y.stream];
                                        if (y.type === "detection_list") {
                                            if (m) {
                                                var I = m.getRectList();
                                                for(var H = m.getLandmarksList(), p = m.getClassificationsList(), A = [], C = 0; C < I.size(); ++C){
                                                    var q = I.get(C);
                                                    a: {
                                                        var B = new Fb();
                                                        for(q = new Sa(q); S(q);)switch(q.i){
                                                            case 13:
                                                                var D = T(q);
                                                                X(B, 1, D);
                                                                break;
                                                            case 21:
                                                                D = T(q);
                                                                X(B, 2, D);
                                                                break;
                                                            case 29:
                                                                D = T(q);
                                                                X(B, 3, D);
                                                                break;
                                                            case 37:
                                                                D = T(q);
                                                                X(B, 4, D);
                                                                break;
                                                            case 45:
                                                                D = T(q);
                                                                X(B, 5, D);
                                                                break;
                                                            case 48:
                                                                D = Oa(q.g);
                                                                X(B, 6, D);
                                                                break;
                                                            default:
                                                                if (!sb(B, q)) break a;
                                                        }
                                                    }
                                                    B = {
                                                        Z: Y(B, 1),
                                                        $: Y(B, 2),
                                                        height: Y(B, 3),
                                                        width: Y(B, 4),
                                                        rotation: Y(B, 5, 0),
                                                        X: lb(B, 6, 0)
                                                    };
                                                    q = nb(Eb(H.get(C)), Ab).map(Nb);
                                                    var la = p.get(C);
                                                    a: for(D = new yb(), la = new Sa(la); S(la);)switch(la.i){
                                                        case 10:
                                                            D.addClassification(Ua(la, new wb(), xb));
                                                            break;
                                                        default:
                                                            if (!sb(D, la)) break a;
                                                    }
                                                    B = {
                                                        T: B,
                                                        O: q,
                                                        M: Mb(D)
                                                    };
                                                    A.push(B);
                                                }
                                                I = A;
                                            } else I = [];
                                            g[r] = I;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type === "proto_list") {
                                            if (m) {
                                                I = Array(m.size());
                                                for(H = 0; H < m.size(); H++)I[H] = m.get(H);
                                                m.delete();
                                            } else I = [];
                                            g[r] = I;
                                            F.g = 7;
                                            break;
                                        }
                                        if (m === void 0) {
                                            F.g = 3;
                                            break;
                                        }
                                        if (y.type === "float_list") {
                                            g[r] = m;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type === "proto") {
                                            g[r] = m;
                                            F.g = 7;
                                            break;
                                        }
                                        if (y.type !== "texture") throw Error("Unknown output config type: '" + y.type + "'");
                                        t = u.s[r];
                                        t || (t = new Ob(u.h, u.D), u.s[r] = t);
                                        return N(F, Pb(t, m, u.G), 13);
                                    case 13:
                                        x = F.h, g[r] = x;
                                    case 7:
                                        y.transform && g[r] && (g[r] = y.transform(g[r]));
                                        F.g = 3;
                                        break;
                                    case 14:
                                        z[E] = F.h;
                                    case 3:
                                        k = w.next();
                                        F.g = 2;
                                        break;
                                    case 4:
                                        return F.return(g);
                                }
                            });
                        });
                    }
                    function ec(a, b, c) {
                        return Z(a, function e() {
                            var g = this, f;
                            return O(e, function(h) {
                                return typeof c === "number" || c instanceof Uint8Array || c instanceof g.h.Uint8BlobList ? h.return(c) : c instanceof g.h.Texture2dDataOut ? (f = g.s[b], f || (f = new Ob(g.h, g.D), g.s[b] = f), h.return(Pb(f, c, g.G))) : h.return(void 0);
                            });
                        });
                    }
                    function bc(a, b) {
                        for(var c = b.name || "$", d = [].concat(L(b.wants)), e = new a.h.StringList(), g = K(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(h) {
                                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                                var n = a.listeners[c];
                                n && (a.C = dc(a, k, b.outs).then(function(u) {
                                    u = n(u);
                                    for(var w = 0; w < b.wants.length; ++w){
                                        var r = k[d[w]];
                                        typeof r === "object" && r.hasOwnProperty && r.hasOwnProperty("delete") && r.delete();
                                    }
                                    u && (a.C = u);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    v.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    P("Solution", Xb);
                    P("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        aa: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function fc(a) {
                        a = Kb(a);
                        var b = a.getMesh();
                        if (!b) return a;
                        var c = new Float32Array(b.getVertexBufferList());
                        b.getVertexBufferList = function() {
                            return c;
                        };
                        var d = new Uint32Array(b.getIndexBufferList());
                        b.getIndexBufferList = function() {
                            return d;
                        };
                        return a;
                    }
                    var gc = {
                        files: [
                            {
                                url: "face_mesh_solution_packed_assets_loader.js"
                            },
                            {
                                simd: true,
                                url: "face_mesh_solution_simd_wasm_bin.js"
                            },
                            {
                                simd: false,
                                url: "face_mesh_solution_wasm_bin.js"
                            }
                        ],
                        graph: {
                            url: "face_mesh.binarypb"
                        },
                        listeners: [
                            {
                                wants: [
                                    "multi_face_geometry",
                                    "image_transformed",
                                    "multi_face_landmarks"
                                ],
                                outs: {
                                    image: "image_transformed",
                                    multiFaceGeometry: {
                                        type: "proto_list",
                                        stream: "multi_face_geometry",
                                        transform: function(a) {
                                            return a.map(fc);
                                        }
                                    },
                                    multiFaceLandmarks: {
                                        type: "proto_list",
                                        stream: "multi_face_landmarks",
                                        transform: function(a) {
                                            return a.map(function(b) {
                                                return nb(Eb(b), Ab).map(Nb);
                                            });
                                        }
                                    }
                                }
                            }
                        ],
                        inputs: {
                            image: {
                                type: "video",
                                stream: "input_frames_gpu"
                            }
                        },
                        options: {
                            useCpuInference: {
                                type: 0,
                                graphOptionXref: {
                                    calculatorType: "InferenceCalculator",
                                    fieldName: "use_cpu_inference"
                                },
                                default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                            },
                            enableFaceGeometry: {
                                type: 0,
                                graphOptionXref: {
                                    calculatorName: "EnableFaceGeometryConstant",
                                    calculatorType: "ConstantSidePacketCalculator",
                                    fieldName: "bool_value"
                                }
                            },
                            selfieMode: {
                                type: 0,
                                graphOptionXref: {
                                    calculatorType: "GlScalerCalculator",
                                    calculatorIndex: 1,
                                    fieldName: "flip_horizontal"
                                }
                            },
                            maxNumFaces: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "ConstantSidePacketCalculator",
                                    calculatorName: "ConstantSidePacketCalculatorNumFaces",
                                    fieldName: "int_value"
                                }
                            },
                            refineLandmarks: {
                                type: 0,
                                graphOptionXref: {
                                    calculatorType: "ConstantSidePacketCalculator",
                                    calculatorName: "ConstantSidePacketCalculatorRefineLandmarks",
                                    fieldName: "bool_value"
                                }
                            },
                            minDetectionConfidence: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "TensorsToDetectionsCalculator",
                                    calculatorName: "facelandmarkfrontgpu__facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator",
                                    fieldName: "min_score_thresh"
                                }
                            },
                            minTrackingConfidence: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "ThresholdingCalculator",
                                    calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator",
                                    fieldName: "threshold"
                                }
                            },
                            cameraNear: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                    fieldName: "near"
                                }
                            },
                            cameraFar: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                    fieldName: "far"
                                }
                            },
                            cameraVerticalFovDegrees: {
                                type: 1,
                                graphOptionXref: {
                                    calculatorType: "FaceGeometryEnvGeneratorCalculator",
                                    fieldName: "vertical_fov_degrees"
                                }
                            }
                        }
                    };
                    var hc = [
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            78,
                            95
                        ],
                        [
                            95,
                            88
                        ],
                        [
                            88,
                            178
                        ],
                        [
                            178,
                            87
                        ],
                        [
                            87,
                            14
                        ],
                        [
                            14,
                            317
                        ],
                        [
                            317,
                            402
                        ],
                        [
                            402,
                            318
                        ],
                        [
                            318,
                            324
                        ],
                        [
                            324,
                            308
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            308
                        ]
                    ], ic = [
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            263,
                            466
                        ],
                        [
                            466,
                            388
                        ],
                        [
                            388,
                            387
                        ],
                        [
                            387,
                            386
                        ],
                        [
                            386,
                            385
                        ],
                        [
                            385,
                            384
                        ],
                        [
                            384,
                            398
                        ],
                        [
                            398,
                            362
                        ]
                    ], jc = [
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            336
                        ]
                    ], kc = [
                        [
                            33,
                            7
                        ],
                        [
                            7,
                            163
                        ],
                        [
                            163,
                            144
                        ],
                        [
                            144,
                            145
                        ],
                        [
                            145,
                            153
                        ],
                        [
                            153,
                            154
                        ],
                        [
                            154,
                            155
                        ],
                        [
                            155,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            133
                        ]
                    ], lc = [
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            107
                        ]
                    ], mc = [
                        [
                            10,
                            338
                        ],
                        [
                            338,
                            297
                        ],
                        [
                            297,
                            332
                        ],
                        [
                            332,
                            284
                        ],
                        [
                            284,
                            251
                        ],
                        [
                            251,
                            389
                        ],
                        [
                            389,
                            356
                        ],
                        [
                            356,
                            454
                        ],
                        [
                            454,
                            323
                        ],
                        [
                            323,
                            361
                        ],
                        [
                            361,
                            288
                        ],
                        [
                            288,
                            397
                        ],
                        [
                            397,
                            365
                        ],
                        [
                            365,
                            379
                        ],
                        [
                            379,
                            378
                        ],
                        [
                            378,
                            400
                        ],
                        [
                            400,
                            377
                        ],
                        [
                            377,
                            152
                        ],
                        [
                            152,
                            148
                        ],
                        [
                            148,
                            176
                        ],
                        [
                            176,
                            149
                        ],
                        [
                            149,
                            150
                        ],
                        [
                            150,
                            136
                        ],
                        [
                            136,
                            172
                        ],
                        [
                            172,
                            58
                        ],
                        [
                            58,
                            132
                        ],
                        [
                            132,
                            93
                        ],
                        [
                            93,
                            234
                        ],
                        [
                            234,
                            127
                        ],
                        [
                            127,
                            162
                        ],
                        [
                            162,
                            21
                        ],
                        [
                            21,
                            54
                        ],
                        [
                            54,
                            103
                        ],
                        [
                            103,
                            67
                        ],
                        [
                            67,
                            109
                        ],
                        [
                            109,
                            10
                        ]
                    ], nc = [].concat(L(hc), L(ic), L(jc), L(kc), L(lc), L(mc));
                    function oc(a) {
                        a = a || {};
                        a = Object.assign(Object.assign({}, gc), a);
                        this.g = new Xb(a);
                    }
                    v = oc.prototype;
                    v.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    v.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    v.initialize = function() {
                        return Z(this, function b() {
                            var c = this;
                            return O(b, function(d) {
                                return N(d, c.g.initialize(), 0);
                            });
                        });
                    };
                    v.reset = function() {
                        this.g.reset();
                    };
                    v.send = function(a) {
                        return Z(this, function c() {
                            var d = this;
                            return O(c, function(e) {
                                return N(e, d.g.send(a), 0);
                            });
                        });
                    };
                    v.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    P("FACE_GEOMETRY", {
                        Layout: {
                            COLUMN_MAJOR: 0,
                            ROW_MAJOR: 1,
                            0: "COLUMN_MAJOR",
                            1: "ROW_MAJOR"
                        },
                        PrimitiveType: {
                            TRIANGLE: 0,
                            0: "TRIANGLE"
                        },
                        VertexType: {
                            VERTEX_PT: 0,
                            0: "VERTEX_PT"
                        },
                        DEFAULT_CAMERA_PARAMS: {
                            verticalFovDegrees: 63,
                            near: 1,
                            far: 1e4
                        }
                    });
                    P("FaceMesh", oc);
                    P("FACEMESH_LIPS", hc);
                    P("FACEMESH_LEFT_EYE", ic);
                    P("FACEMESH_LEFT_EYEBROW", jc);
                    P("FACEMESH_LEFT_IRIS", [
                        [
                            474,
                            475
                        ],
                        [
                            475,
                            476
                        ],
                        [
                            476,
                            477
                        ],
                        [
                            477,
                            474
                        ]
                    ]);
                    P("FACEMESH_RIGHT_EYE", kc);
                    P("FACEMESH_RIGHT_EYEBROW", lc);
                    P("FACEMESH_RIGHT_IRIS", [
                        [
                            469,
                            470
                        ],
                        [
                            470,
                            471
                        ],
                        [
                            471,
                            472
                        ],
                        [
                            472,
                            469
                        ]
                    ]);
                    P("FACEMESH_FACE_OVAL", mc);
                    P("FACEMESH_CONTOURS", nc);
                    P("FACEMESH_TESSELATION", [
                        [
                            127,
                            34
                        ],
                        [
                            34,
                            139
                        ],
                        [
                            139,
                            127
                        ],
                        [
                            11,
                            0
                        ],
                        [
                            0,
                            37
                        ],
                        [
                            37,
                            11
                        ],
                        [
                            232,
                            231
                        ],
                        [
                            231,
                            120
                        ],
                        [
                            120,
                            232
                        ],
                        [
                            72,
                            37
                        ],
                        [
                            37,
                            39
                        ],
                        [
                            39,
                            72
                        ],
                        [
                            128,
                            121
                        ],
                        [
                            121,
                            47
                        ],
                        [
                            47,
                            128
                        ],
                        [
                            232,
                            121
                        ],
                        [
                            121,
                            128
                        ],
                        [
                            128,
                            232
                        ],
                        [
                            104,
                            69
                        ],
                        [
                            69,
                            67
                        ],
                        [
                            67,
                            104
                        ],
                        [
                            175,
                            171
                        ],
                        [
                            171,
                            148
                        ],
                        [
                            148,
                            175
                        ],
                        [
                            118,
                            50
                        ],
                        [
                            50,
                            101
                        ],
                        [
                            101,
                            118
                        ],
                        [
                            73,
                            39
                        ],
                        [
                            39,
                            40
                        ],
                        [
                            40,
                            73
                        ],
                        [
                            9,
                            151
                        ],
                        [
                            151,
                            108
                        ],
                        [
                            108,
                            9
                        ],
                        [
                            48,
                            115
                        ],
                        [
                            115,
                            131
                        ],
                        [
                            131,
                            48
                        ],
                        [
                            194,
                            204
                        ],
                        [
                            204,
                            211
                        ],
                        [
                            211,
                            194
                        ],
                        [
                            74,
                            40
                        ],
                        [
                            40,
                            185
                        ],
                        [
                            185,
                            74
                        ],
                        [
                            80,
                            42
                        ],
                        [
                            42,
                            183
                        ],
                        [
                            183,
                            80
                        ],
                        [
                            40,
                            92
                        ],
                        [
                            92,
                            186
                        ],
                        [
                            186,
                            40
                        ],
                        [
                            230,
                            229
                        ],
                        [
                            229,
                            118
                        ],
                        [
                            118,
                            230
                        ],
                        [
                            202,
                            212
                        ],
                        [
                            212,
                            214
                        ],
                        [
                            214,
                            202
                        ],
                        [
                            83,
                            18
                        ],
                        [
                            18,
                            17
                        ],
                        [
                            17,
                            83
                        ],
                        [
                            76,
                            61
                        ],
                        [
                            61,
                            146
                        ],
                        [
                            146,
                            76
                        ],
                        [
                            160,
                            29
                        ],
                        [
                            29,
                            30
                        ],
                        [
                            30,
                            160
                        ],
                        [
                            56,
                            157
                        ],
                        [
                            157,
                            173
                        ],
                        [
                            173,
                            56
                        ],
                        [
                            106,
                            204
                        ],
                        [
                            204,
                            194
                        ],
                        [
                            194,
                            106
                        ],
                        [
                            135,
                            214
                        ],
                        [
                            214,
                            192
                        ],
                        [
                            192,
                            135
                        ],
                        [
                            203,
                            165
                        ],
                        [
                            165,
                            98
                        ],
                        [
                            98,
                            203
                        ],
                        [
                            21,
                            71
                        ],
                        [
                            71,
                            68
                        ],
                        [
                            68,
                            21
                        ],
                        [
                            51,
                            45
                        ],
                        [
                            45,
                            4
                        ],
                        [
                            4,
                            51
                        ],
                        [
                            144,
                            24
                        ],
                        [
                            24,
                            23
                        ],
                        [
                            23,
                            144
                        ],
                        [
                            77,
                            146
                        ],
                        [
                            146,
                            91
                        ],
                        [
                            91,
                            77
                        ],
                        [
                            205,
                            50
                        ],
                        [
                            50,
                            187
                        ],
                        [
                            187,
                            205
                        ],
                        [
                            201,
                            200
                        ],
                        [
                            200,
                            18
                        ],
                        [
                            18,
                            201
                        ],
                        [
                            91,
                            106
                        ],
                        [
                            106,
                            182
                        ],
                        [
                            182,
                            91
                        ],
                        [
                            90,
                            91
                        ],
                        [
                            91,
                            181
                        ],
                        [
                            181,
                            90
                        ],
                        [
                            85,
                            84
                        ],
                        [
                            84,
                            17
                        ],
                        [
                            17,
                            85
                        ],
                        [
                            206,
                            203
                        ],
                        [
                            203,
                            36
                        ],
                        [
                            36,
                            206
                        ],
                        [
                            148,
                            171
                        ],
                        [
                            171,
                            140
                        ],
                        [
                            140,
                            148
                        ],
                        [
                            92,
                            40
                        ],
                        [
                            40,
                            39
                        ],
                        [
                            39,
                            92
                        ],
                        [
                            193,
                            189
                        ],
                        [
                            189,
                            244
                        ],
                        [
                            244,
                            193
                        ],
                        [
                            159,
                            158
                        ],
                        [
                            158,
                            28
                        ],
                        [
                            28,
                            159
                        ],
                        [
                            247,
                            246
                        ],
                        [
                            246,
                            161
                        ],
                        [
                            161,
                            247
                        ],
                        [
                            236,
                            3
                        ],
                        [
                            3,
                            196
                        ],
                        [
                            196,
                            236
                        ],
                        [
                            54,
                            68
                        ],
                        [
                            68,
                            104
                        ],
                        [
                            104,
                            54
                        ],
                        [
                            193,
                            168
                        ],
                        [
                            168,
                            8
                        ],
                        [
                            8,
                            193
                        ],
                        [
                            117,
                            228
                        ],
                        [
                            228,
                            31
                        ],
                        [
                            31,
                            117
                        ],
                        [
                            189,
                            193
                        ],
                        [
                            193,
                            55
                        ],
                        [
                            55,
                            189
                        ],
                        [
                            98,
                            97
                        ],
                        [
                            97,
                            99
                        ],
                        [
                            99,
                            98
                        ],
                        [
                            126,
                            47
                        ],
                        [
                            47,
                            100
                        ],
                        [
                            100,
                            126
                        ],
                        [
                            166,
                            79
                        ],
                        [
                            79,
                            218
                        ],
                        [
                            218,
                            166
                        ],
                        [
                            155,
                            154
                        ],
                        [
                            154,
                            26
                        ],
                        [
                            26,
                            155
                        ],
                        [
                            209,
                            49
                        ],
                        [
                            49,
                            131
                        ],
                        [
                            131,
                            209
                        ],
                        [
                            135,
                            136
                        ],
                        [
                            136,
                            150
                        ],
                        [
                            150,
                            135
                        ],
                        [
                            47,
                            126
                        ],
                        [
                            126,
                            217
                        ],
                        [
                            217,
                            47
                        ],
                        [
                            223,
                            52
                        ],
                        [
                            52,
                            53
                        ],
                        [
                            53,
                            223
                        ],
                        [
                            45,
                            51
                        ],
                        [
                            51,
                            134
                        ],
                        [
                            134,
                            45
                        ],
                        [
                            211,
                            170
                        ],
                        [
                            170,
                            140
                        ],
                        [
                            140,
                            211
                        ],
                        [
                            67,
                            69
                        ],
                        [
                            69,
                            108
                        ],
                        [
                            108,
                            67
                        ],
                        [
                            43,
                            106
                        ],
                        [
                            106,
                            91
                        ],
                        [
                            91,
                            43
                        ],
                        [
                            230,
                            119
                        ],
                        [
                            119,
                            120
                        ],
                        [
                            120,
                            230
                        ],
                        [
                            226,
                            130
                        ],
                        [
                            130,
                            247
                        ],
                        [
                            247,
                            226
                        ],
                        [
                            63,
                            53
                        ],
                        [
                            53,
                            52
                        ],
                        [
                            52,
                            63
                        ],
                        [
                            238,
                            20
                        ],
                        [
                            20,
                            242
                        ],
                        [
                            242,
                            238
                        ],
                        [
                            46,
                            70
                        ],
                        [
                            70,
                            156
                        ],
                        [
                            156,
                            46
                        ],
                        [
                            78,
                            62
                        ],
                        [
                            62,
                            96
                        ],
                        [
                            96,
                            78
                        ],
                        [
                            46,
                            53
                        ],
                        [
                            53,
                            63
                        ],
                        [
                            63,
                            46
                        ],
                        [
                            143,
                            34
                        ],
                        [
                            34,
                            227
                        ],
                        [
                            227,
                            143
                        ],
                        [
                            123,
                            117
                        ],
                        [
                            117,
                            111
                        ],
                        [
                            111,
                            123
                        ],
                        [
                            44,
                            125
                        ],
                        [
                            125,
                            19
                        ],
                        [
                            19,
                            44
                        ],
                        [
                            236,
                            134
                        ],
                        [
                            134,
                            51
                        ],
                        [
                            51,
                            236
                        ],
                        [
                            216,
                            206
                        ],
                        [
                            206,
                            205
                        ],
                        [
                            205,
                            216
                        ],
                        [
                            154,
                            153
                        ],
                        [
                            153,
                            22
                        ],
                        [
                            22,
                            154
                        ],
                        [
                            39,
                            37
                        ],
                        [
                            37,
                            167
                        ],
                        [
                            167,
                            39
                        ],
                        [
                            200,
                            201
                        ],
                        [
                            201,
                            208
                        ],
                        [
                            208,
                            200
                        ],
                        [
                            36,
                            142
                        ],
                        [
                            142,
                            100
                        ],
                        [
                            100,
                            36
                        ],
                        [
                            57,
                            212
                        ],
                        [
                            212,
                            202
                        ],
                        [
                            202,
                            57
                        ],
                        [
                            20,
                            60
                        ],
                        [
                            60,
                            99
                        ],
                        [
                            99,
                            20
                        ],
                        [
                            28,
                            158
                        ],
                        [
                            158,
                            157
                        ],
                        [
                            157,
                            28
                        ],
                        [
                            35,
                            226
                        ],
                        [
                            226,
                            113
                        ],
                        [
                            113,
                            35
                        ],
                        [
                            160,
                            159
                        ],
                        [
                            159,
                            27
                        ],
                        [
                            27,
                            160
                        ],
                        [
                            204,
                            202
                        ],
                        [
                            202,
                            210
                        ],
                        [
                            210,
                            204
                        ],
                        [
                            113,
                            225
                        ],
                        [
                            225,
                            46
                        ],
                        [
                            46,
                            113
                        ],
                        [
                            43,
                            202
                        ],
                        [
                            202,
                            204
                        ],
                        [
                            204,
                            43
                        ],
                        [
                            62,
                            76
                        ],
                        [
                            76,
                            77
                        ],
                        [
                            77,
                            62
                        ],
                        [
                            137,
                            123
                        ],
                        [
                            123,
                            116
                        ],
                        [
                            116,
                            137
                        ],
                        [
                            41,
                            38
                        ],
                        [
                            38,
                            72
                        ],
                        [
                            72,
                            41
                        ],
                        [
                            203,
                            129
                        ],
                        [
                            129,
                            142
                        ],
                        [
                            142,
                            203
                        ],
                        [
                            64,
                            98
                        ],
                        [
                            98,
                            240
                        ],
                        [
                            240,
                            64
                        ],
                        [
                            49,
                            102
                        ],
                        [
                            102,
                            64
                        ],
                        [
                            64,
                            49
                        ],
                        [
                            41,
                            73
                        ],
                        [
                            73,
                            74
                        ],
                        [
                            74,
                            41
                        ],
                        [
                            212,
                            216
                        ],
                        [
                            216,
                            207
                        ],
                        [
                            207,
                            212
                        ],
                        [
                            42,
                            74
                        ],
                        [
                            74,
                            184
                        ],
                        [
                            184,
                            42
                        ],
                        [
                            169,
                            170
                        ],
                        [
                            170,
                            211
                        ],
                        [
                            211,
                            169
                        ],
                        [
                            170,
                            149
                        ],
                        [
                            149,
                            176
                        ],
                        [
                            176,
                            170
                        ],
                        [
                            105,
                            66
                        ],
                        [
                            66,
                            69
                        ],
                        [
                            69,
                            105
                        ],
                        [
                            122,
                            6
                        ],
                        [
                            6,
                            168
                        ],
                        [
                            168,
                            122
                        ],
                        [
                            123,
                            147
                        ],
                        [
                            147,
                            187
                        ],
                        [
                            187,
                            123
                        ],
                        [
                            96,
                            77
                        ],
                        [
                            77,
                            90
                        ],
                        [
                            90,
                            96
                        ],
                        [
                            65,
                            55
                        ],
                        [
                            55,
                            107
                        ],
                        [
                            107,
                            65
                        ],
                        [
                            89,
                            90
                        ],
                        [
                            90,
                            180
                        ],
                        [
                            180,
                            89
                        ],
                        [
                            101,
                            100
                        ],
                        [
                            100,
                            120
                        ],
                        [
                            120,
                            101
                        ],
                        [
                            63,
                            105
                        ],
                        [
                            105,
                            104
                        ],
                        [
                            104,
                            63
                        ],
                        [
                            93,
                            137
                        ],
                        [
                            137,
                            227
                        ],
                        [
                            227,
                            93
                        ],
                        [
                            15,
                            86
                        ],
                        [
                            86,
                            85
                        ],
                        [
                            85,
                            15
                        ],
                        [
                            129,
                            102
                        ],
                        [
                            102,
                            49
                        ],
                        [
                            49,
                            129
                        ],
                        [
                            14,
                            87
                        ],
                        [
                            87,
                            86
                        ],
                        [
                            86,
                            14
                        ],
                        [
                            55,
                            8
                        ],
                        [
                            8,
                            9
                        ],
                        [
                            9,
                            55
                        ],
                        [
                            100,
                            47
                        ],
                        [
                            47,
                            121
                        ],
                        [
                            121,
                            100
                        ],
                        [
                            145,
                            23
                        ],
                        [
                            23,
                            22
                        ],
                        [
                            22,
                            145
                        ],
                        [
                            88,
                            89
                        ],
                        [
                            89,
                            179
                        ],
                        [
                            179,
                            88
                        ],
                        [
                            6,
                            122
                        ],
                        [
                            122,
                            196
                        ],
                        [
                            196,
                            6
                        ],
                        [
                            88,
                            95
                        ],
                        [
                            95,
                            96
                        ],
                        [
                            96,
                            88
                        ],
                        [
                            138,
                            172
                        ],
                        [
                            172,
                            136
                        ],
                        [
                            136,
                            138
                        ],
                        [
                            215,
                            58
                        ],
                        [
                            58,
                            172
                        ],
                        [
                            172,
                            215
                        ],
                        [
                            115,
                            48
                        ],
                        [
                            48,
                            219
                        ],
                        [
                            219,
                            115
                        ],
                        [
                            42,
                            80
                        ],
                        [
                            80,
                            81
                        ],
                        [
                            81,
                            42
                        ],
                        [
                            195,
                            3
                        ],
                        [
                            3,
                            51
                        ],
                        [
                            51,
                            195
                        ],
                        [
                            43,
                            146
                        ],
                        [
                            146,
                            61
                        ],
                        [
                            61,
                            43
                        ],
                        [
                            171,
                            175
                        ],
                        [
                            175,
                            199
                        ],
                        [
                            199,
                            171
                        ],
                        [
                            81,
                            82
                        ],
                        [
                            82,
                            38
                        ],
                        [
                            38,
                            81
                        ],
                        [
                            53,
                            46
                        ],
                        [
                            46,
                            225
                        ],
                        [
                            225,
                            53
                        ],
                        [
                            144,
                            163
                        ],
                        [
                            163,
                            110
                        ],
                        [
                            110,
                            144
                        ],
                        [
                            52,
                            65
                        ],
                        [
                            65,
                            66
                        ],
                        [
                            66,
                            52
                        ],
                        [
                            229,
                            228
                        ],
                        [
                            228,
                            117
                        ],
                        [
                            117,
                            229
                        ],
                        [
                            34,
                            127
                        ],
                        [
                            127,
                            234
                        ],
                        [
                            234,
                            34
                        ],
                        [
                            107,
                            108
                        ],
                        [
                            108,
                            69
                        ],
                        [
                            69,
                            107
                        ],
                        [
                            109,
                            108
                        ],
                        [
                            108,
                            151
                        ],
                        [
                            151,
                            109
                        ],
                        [
                            48,
                            64
                        ],
                        [
                            64,
                            235
                        ],
                        [
                            235,
                            48
                        ],
                        [
                            62,
                            78
                        ],
                        [
                            78,
                            191
                        ],
                        [
                            191,
                            62
                        ],
                        [
                            129,
                            209
                        ],
                        [
                            209,
                            126
                        ],
                        [
                            126,
                            129
                        ],
                        [
                            111,
                            35
                        ],
                        [
                            35,
                            143
                        ],
                        [
                            143,
                            111
                        ],
                        [
                            117,
                            123
                        ],
                        [
                            123,
                            50
                        ],
                        [
                            50,
                            117
                        ],
                        [
                            222,
                            65
                        ],
                        [
                            65,
                            52
                        ],
                        [
                            52,
                            222
                        ],
                        [
                            19,
                            125
                        ],
                        [
                            125,
                            141
                        ],
                        [
                            141,
                            19
                        ],
                        [
                            221,
                            55
                        ],
                        [
                            55,
                            65
                        ],
                        [
                            65,
                            221
                        ],
                        [
                            3,
                            195
                        ],
                        [
                            195,
                            197
                        ],
                        [
                            197,
                            3
                        ],
                        [
                            25,
                            7
                        ],
                        [
                            7,
                            33
                        ],
                        [
                            33,
                            25
                        ],
                        [
                            220,
                            237
                        ],
                        [
                            237,
                            44
                        ],
                        [
                            44,
                            220
                        ],
                        [
                            70,
                            71
                        ],
                        [
                            71,
                            139
                        ],
                        [
                            139,
                            70
                        ],
                        [
                            122,
                            193
                        ],
                        [
                            193,
                            245
                        ],
                        [
                            245,
                            122
                        ],
                        [
                            247,
                            130
                        ],
                        [
                            130,
                            33
                        ],
                        [
                            33,
                            247
                        ],
                        [
                            71,
                            21
                        ],
                        [
                            21,
                            162
                        ],
                        [
                            162,
                            71
                        ],
                        [
                            170,
                            169
                        ],
                        [
                            169,
                            150
                        ],
                        [
                            150,
                            170
                        ],
                        [
                            188,
                            174
                        ],
                        [
                            174,
                            196
                        ],
                        [
                            196,
                            188
                        ],
                        [
                            216,
                            186
                        ],
                        [
                            186,
                            92
                        ],
                        [
                            92,
                            216
                        ],
                        [
                            2,
                            97
                        ],
                        [
                            97,
                            167
                        ],
                        [
                            167,
                            2
                        ],
                        [
                            141,
                            125
                        ],
                        [
                            125,
                            241
                        ],
                        [
                            241,
                            141
                        ],
                        [
                            164,
                            167
                        ],
                        [
                            167,
                            37
                        ],
                        [
                            37,
                            164
                        ],
                        [
                            72,
                            38
                        ],
                        [
                            38,
                            12
                        ],
                        [
                            12,
                            72
                        ],
                        [
                            38,
                            82
                        ],
                        [
                            82,
                            13
                        ],
                        [
                            13,
                            38
                        ],
                        [
                            63,
                            68
                        ],
                        [
                            68,
                            71
                        ],
                        [
                            71,
                            63
                        ],
                        [
                            226,
                            35
                        ],
                        [
                            35,
                            111
                        ],
                        [
                            111,
                            226
                        ],
                        [
                            101,
                            50
                        ],
                        [
                            50,
                            205
                        ],
                        [
                            205,
                            101
                        ],
                        [
                            206,
                            92
                        ],
                        [
                            92,
                            165
                        ],
                        [
                            165,
                            206
                        ],
                        [
                            209,
                            198
                        ],
                        [
                            198,
                            217
                        ],
                        [
                            217,
                            209
                        ],
                        [
                            165,
                            167
                        ],
                        [
                            167,
                            97
                        ],
                        [
                            97,
                            165
                        ],
                        [
                            220,
                            115
                        ],
                        [
                            115,
                            218
                        ],
                        [
                            218,
                            220
                        ],
                        [
                            133,
                            112
                        ],
                        [
                            112,
                            243
                        ],
                        [
                            243,
                            133
                        ],
                        [
                            239,
                            238
                        ],
                        [
                            238,
                            241
                        ],
                        [
                            241,
                            239
                        ],
                        [
                            214,
                            135
                        ],
                        [
                            135,
                            169
                        ],
                        [
                            169,
                            214
                        ],
                        [
                            190,
                            173
                        ],
                        [
                            173,
                            133
                        ],
                        [
                            133,
                            190
                        ],
                        [
                            171,
                            208
                        ],
                        [
                            208,
                            32
                        ],
                        [
                            32,
                            171
                        ],
                        [
                            125,
                            44
                        ],
                        [
                            44,
                            237
                        ],
                        [
                            237,
                            125
                        ],
                        [
                            86,
                            87
                        ],
                        [
                            87,
                            178
                        ],
                        [
                            178,
                            86
                        ],
                        [
                            85,
                            86
                        ],
                        [
                            86,
                            179
                        ],
                        [
                            179,
                            85
                        ],
                        [
                            84,
                            85
                        ],
                        [
                            85,
                            180
                        ],
                        [
                            180,
                            84
                        ],
                        [
                            83,
                            84
                        ],
                        [
                            84,
                            181
                        ],
                        [
                            181,
                            83
                        ],
                        [
                            201,
                            83
                        ],
                        [
                            83,
                            182
                        ],
                        [
                            182,
                            201
                        ],
                        [
                            137,
                            93
                        ],
                        [
                            93,
                            132
                        ],
                        [
                            132,
                            137
                        ],
                        [
                            76,
                            62
                        ],
                        [
                            62,
                            183
                        ],
                        [
                            183,
                            76
                        ],
                        [
                            61,
                            76
                        ],
                        [
                            76,
                            184
                        ],
                        [
                            184,
                            61
                        ],
                        [
                            57,
                            61
                        ],
                        [
                            61,
                            185
                        ],
                        [
                            185,
                            57
                        ],
                        [
                            212,
                            57
                        ],
                        [
                            57,
                            186
                        ],
                        [
                            186,
                            212
                        ],
                        [
                            214,
                            207
                        ],
                        [
                            207,
                            187
                        ],
                        [
                            187,
                            214
                        ],
                        [
                            34,
                            143
                        ],
                        [
                            143,
                            156
                        ],
                        [
                            156,
                            34
                        ],
                        [
                            79,
                            239
                        ],
                        [
                            239,
                            237
                        ],
                        [
                            237,
                            79
                        ],
                        [
                            123,
                            137
                        ],
                        [
                            137,
                            177
                        ],
                        [
                            177,
                            123
                        ],
                        [
                            44,
                            1
                        ],
                        [
                            1,
                            4
                        ],
                        [
                            4,
                            44
                        ],
                        [
                            201,
                            194
                        ],
                        [
                            194,
                            32
                        ],
                        [
                            32,
                            201
                        ],
                        [
                            64,
                            102
                        ],
                        [
                            102,
                            129
                        ],
                        [
                            129,
                            64
                        ],
                        [
                            213,
                            215
                        ],
                        [
                            215,
                            138
                        ],
                        [
                            138,
                            213
                        ],
                        [
                            59,
                            166
                        ],
                        [
                            166,
                            219
                        ],
                        [
                            219,
                            59
                        ],
                        [
                            242,
                            99
                        ],
                        [
                            99,
                            97
                        ],
                        [
                            97,
                            242
                        ],
                        [
                            2,
                            94
                        ],
                        [
                            94,
                            141
                        ],
                        [
                            141,
                            2
                        ],
                        [
                            75,
                            59
                        ],
                        [
                            59,
                            235
                        ],
                        [
                            235,
                            75
                        ],
                        [
                            24,
                            110
                        ],
                        [
                            110,
                            228
                        ],
                        [
                            228,
                            24
                        ],
                        [
                            25,
                            130
                        ],
                        [
                            130,
                            226
                        ],
                        [
                            226,
                            25
                        ],
                        [
                            23,
                            24
                        ],
                        [
                            24,
                            229
                        ],
                        [
                            229,
                            23
                        ],
                        [
                            22,
                            23
                        ],
                        [
                            23,
                            230
                        ],
                        [
                            230,
                            22
                        ],
                        [
                            26,
                            22
                        ],
                        [
                            22,
                            231
                        ],
                        [
                            231,
                            26
                        ],
                        [
                            112,
                            26
                        ],
                        [
                            26,
                            232
                        ],
                        [
                            232,
                            112
                        ],
                        [
                            189,
                            190
                        ],
                        [
                            190,
                            243
                        ],
                        [
                            243,
                            189
                        ],
                        [
                            221,
                            56
                        ],
                        [
                            56,
                            190
                        ],
                        [
                            190,
                            221
                        ],
                        [
                            28,
                            56
                        ],
                        [
                            56,
                            221
                        ],
                        [
                            221,
                            28
                        ],
                        [
                            27,
                            28
                        ],
                        [
                            28,
                            222
                        ],
                        [
                            222,
                            27
                        ],
                        [
                            29,
                            27
                        ],
                        [
                            27,
                            223
                        ],
                        [
                            223,
                            29
                        ],
                        [
                            30,
                            29
                        ],
                        [
                            29,
                            224
                        ],
                        [
                            224,
                            30
                        ],
                        [
                            247,
                            30
                        ],
                        [
                            30,
                            225
                        ],
                        [
                            225,
                            247
                        ],
                        [
                            238,
                            79
                        ],
                        [
                            79,
                            20
                        ],
                        [
                            20,
                            238
                        ],
                        [
                            166,
                            59
                        ],
                        [
                            59,
                            75
                        ],
                        [
                            75,
                            166
                        ],
                        [
                            60,
                            75
                        ],
                        [
                            75,
                            240
                        ],
                        [
                            240,
                            60
                        ],
                        [
                            147,
                            177
                        ],
                        [
                            177,
                            215
                        ],
                        [
                            215,
                            147
                        ],
                        [
                            20,
                            79
                        ],
                        [
                            79,
                            166
                        ],
                        [
                            166,
                            20
                        ],
                        [
                            187,
                            147
                        ],
                        [
                            147,
                            213
                        ],
                        [
                            213,
                            187
                        ],
                        [
                            112,
                            233
                        ],
                        [
                            233,
                            244
                        ],
                        [
                            244,
                            112
                        ],
                        [
                            233,
                            128
                        ],
                        [
                            128,
                            245
                        ],
                        [
                            245,
                            233
                        ],
                        [
                            128,
                            114
                        ],
                        [
                            114,
                            188
                        ],
                        [
                            188,
                            128
                        ],
                        [
                            114,
                            217
                        ],
                        [
                            217,
                            174
                        ],
                        [
                            174,
                            114
                        ],
                        [
                            131,
                            115
                        ],
                        [
                            115,
                            220
                        ],
                        [
                            220,
                            131
                        ],
                        [
                            217,
                            198
                        ],
                        [
                            198,
                            236
                        ],
                        [
                            236,
                            217
                        ],
                        [
                            198,
                            131
                        ],
                        [
                            131,
                            134
                        ],
                        [
                            134,
                            198
                        ],
                        [
                            177,
                            132
                        ],
                        [
                            132,
                            58
                        ],
                        [
                            58,
                            177
                        ],
                        [
                            143,
                            35
                        ],
                        [
                            35,
                            124
                        ],
                        [
                            124,
                            143
                        ],
                        [
                            110,
                            163
                        ],
                        [
                            163,
                            7
                        ],
                        [
                            7,
                            110
                        ],
                        [
                            228,
                            110
                        ],
                        [
                            110,
                            25
                        ],
                        [
                            25,
                            228
                        ],
                        [
                            356,
                            389
                        ],
                        [
                            389,
                            368
                        ],
                        [
                            368,
                            356
                        ],
                        [
                            11,
                            302
                        ],
                        [
                            302,
                            267
                        ],
                        [
                            267,
                            11
                        ],
                        [
                            452,
                            350
                        ],
                        [
                            350,
                            349
                        ],
                        [
                            349,
                            452
                        ],
                        [
                            302,
                            303
                        ],
                        [
                            303,
                            269
                        ],
                        [
                            269,
                            302
                        ],
                        [
                            357,
                            343
                        ],
                        [
                            343,
                            277
                        ],
                        [
                            277,
                            357
                        ],
                        [
                            452,
                            453
                        ],
                        [
                            453,
                            357
                        ],
                        [
                            357,
                            452
                        ],
                        [
                            333,
                            332
                        ],
                        [
                            332,
                            297
                        ],
                        [
                            297,
                            333
                        ],
                        [
                            175,
                            152
                        ],
                        [
                            152,
                            377
                        ],
                        [
                            377,
                            175
                        ],
                        [
                            347,
                            348
                        ],
                        [
                            348,
                            330
                        ],
                        [
                            330,
                            347
                        ],
                        [
                            303,
                            304
                        ],
                        [
                            304,
                            270
                        ],
                        [
                            270,
                            303
                        ],
                        [
                            9,
                            336
                        ],
                        [
                            336,
                            337
                        ],
                        [
                            337,
                            9
                        ],
                        [
                            278,
                            279
                        ],
                        [
                            279,
                            360
                        ],
                        [
                            360,
                            278
                        ],
                        [
                            418,
                            262
                        ],
                        [
                            262,
                            431
                        ],
                        [
                            431,
                            418
                        ],
                        [
                            304,
                            408
                        ],
                        [
                            408,
                            409
                        ],
                        [
                            409,
                            304
                        ],
                        [
                            310,
                            415
                        ],
                        [
                            415,
                            407
                        ],
                        [
                            407,
                            310
                        ],
                        [
                            270,
                            409
                        ],
                        [
                            409,
                            410
                        ],
                        [
                            410,
                            270
                        ],
                        [
                            450,
                            348
                        ],
                        [
                            348,
                            347
                        ],
                        [
                            347,
                            450
                        ],
                        [
                            422,
                            430
                        ],
                        [
                            430,
                            434
                        ],
                        [
                            434,
                            422
                        ],
                        [
                            313,
                            314
                        ],
                        [
                            314,
                            17
                        ],
                        [
                            17,
                            313
                        ],
                        [
                            306,
                            307
                        ],
                        [
                            307,
                            375
                        ],
                        [
                            375,
                            306
                        ],
                        [
                            387,
                            388
                        ],
                        [
                            388,
                            260
                        ],
                        [
                            260,
                            387
                        ],
                        [
                            286,
                            414
                        ],
                        [
                            414,
                            398
                        ],
                        [
                            398,
                            286
                        ],
                        [
                            335,
                            406
                        ],
                        [
                            406,
                            418
                        ],
                        [
                            418,
                            335
                        ],
                        [
                            364,
                            367
                        ],
                        [
                            367,
                            416
                        ],
                        [
                            416,
                            364
                        ],
                        [
                            423,
                            358
                        ],
                        [
                            358,
                            327
                        ],
                        [
                            327,
                            423
                        ],
                        [
                            251,
                            284
                        ],
                        [
                            284,
                            298
                        ],
                        [
                            298,
                            251
                        ],
                        [
                            281,
                            5
                        ],
                        [
                            5,
                            4
                        ],
                        [
                            4,
                            281
                        ],
                        [
                            373,
                            374
                        ],
                        [
                            374,
                            253
                        ],
                        [
                            253,
                            373
                        ],
                        [
                            307,
                            320
                        ],
                        [
                            320,
                            321
                        ],
                        [
                            321,
                            307
                        ],
                        [
                            425,
                            427
                        ],
                        [
                            427,
                            411
                        ],
                        [
                            411,
                            425
                        ],
                        [
                            421,
                            313
                        ],
                        [
                            313,
                            18
                        ],
                        [
                            18,
                            421
                        ],
                        [
                            321,
                            405
                        ],
                        [
                            405,
                            406
                        ],
                        [
                            406,
                            321
                        ],
                        [
                            320,
                            404
                        ],
                        [
                            404,
                            405
                        ],
                        [
                            405,
                            320
                        ],
                        [
                            315,
                            16
                        ],
                        [
                            16,
                            17
                        ],
                        [
                            17,
                            315
                        ],
                        [
                            426,
                            425
                        ],
                        [
                            425,
                            266
                        ],
                        [
                            266,
                            426
                        ],
                        [
                            377,
                            400
                        ],
                        [
                            400,
                            369
                        ],
                        [
                            369,
                            377
                        ],
                        [
                            322,
                            391
                        ],
                        [
                            391,
                            269
                        ],
                        [
                            269,
                            322
                        ],
                        [
                            417,
                            465
                        ],
                        [
                            465,
                            464
                        ],
                        [
                            464,
                            417
                        ],
                        [
                            386,
                            257
                        ],
                        [
                            257,
                            258
                        ],
                        [
                            258,
                            386
                        ],
                        [
                            466,
                            260
                        ],
                        [
                            260,
                            388
                        ],
                        [
                            388,
                            466
                        ],
                        [
                            456,
                            399
                        ],
                        [
                            399,
                            419
                        ],
                        [
                            419,
                            456
                        ],
                        [
                            284,
                            332
                        ],
                        [
                            332,
                            333
                        ],
                        [
                            333,
                            284
                        ],
                        [
                            417,
                            285
                        ],
                        [
                            285,
                            8
                        ],
                        [
                            8,
                            417
                        ],
                        [
                            346,
                            340
                        ],
                        [
                            340,
                            261
                        ],
                        [
                            261,
                            346
                        ],
                        [
                            413,
                            441
                        ],
                        [
                            441,
                            285
                        ],
                        [
                            285,
                            413
                        ],
                        [
                            327,
                            460
                        ],
                        [
                            460,
                            328
                        ],
                        [
                            328,
                            327
                        ],
                        [
                            355,
                            371
                        ],
                        [
                            371,
                            329
                        ],
                        [
                            329,
                            355
                        ],
                        [
                            392,
                            439
                        ],
                        [
                            439,
                            438
                        ],
                        [
                            438,
                            392
                        ],
                        [
                            382,
                            341
                        ],
                        [
                            341,
                            256
                        ],
                        [
                            256,
                            382
                        ],
                        [
                            429,
                            420
                        ],
                        [
                            420,
                            360
                        ],
                        [
                            360,
                            429
                        ],
                        [
                            364,
                            394
                        ],
                        [
                            394,
                            379
                        ],
                        [
                            379,
                            364
                        ],
                        [
                            277,
                            343
                        ],
                        [
                            343,
                            437
                        ],
                        [
                            437,
                            277
                        ],
                        [
                            443,
                            444
                        ],
                        [
                            444,
                            283
                        ],
                        [
                            283,
                            443
                        ],
                        [
                            275,
                            440
                        ],
                        [
                            440,
                            363
                        ],
                        [
                            363,
                            275
                        ],
                        [
                            431,
                            262
                        ],
                        [
                            262,
                            369
                        ],
                        [
                            369,
                            431
                        ],
                        [
                            297,
                            338
                        ],
                        [
                            338,
                            337
                        ],
                        [
                            337,
                            297
                        ],
                        [
                            273,
                            375
                        ],
                        [
                            375,
                            321
                        ],
                        [
                            321,
                            273
                        ],
                        [
                            450,
                            451
                        ],
                        [
                            451,
                            349
                        ],
                        [
                            349,
                            450
                        ],
                        [
                            446,
                            342
                        ],
                        [
                            342,
                            467
                        ],
                        [
                            467,
                            446
                        ],
                        [
                            293,
                            334
                        ],
                        [
                            334,
                            282
                        ],
                        [
                            282,
                            293
                        ],
                        [
                            458,
                            461
                        ],
                        [
                            461,
                            462
                        ],
                        [
                            462,
                            458
                        ],
                        [
                            276,
                            353
                        ],
                        [
                            353,
                            383
                        ],
                        [
                            383,
                            276
                        ],
                        [
                            308,
                            324
                        ],
                        [
                            324,
                            325
                        ],
                        [
                            325,
                            308
                        ],
                        [
                            276,
                            300
                        ],
                        [
                            300,
                            293
                        ],
                        [
                            293,
                            276
                        ],
                        [
                            372,
                            345
                        ],
                        [
                            345,
                            447
                        ],
                        [
                            447,
                            372
                        ],
                        [
                            352,
                            345
                        ],
                        [
                            345,
                            340
                        ],
                        [
                            340,
                            352
                        ],
                        [
                            274,
                            1
                        ],
                        [
                            1,
                            19
                        ],
                        [
                            19,
                            274
                        ],
                        [
                            456,
                            248
                        ],
                        [
                            248,
                            281
                        ],
                        [
                            281,
                            456
                        ],
                        [
                            436,
                            427
                        ],
                        [
                            427,
                            425
                        ],
                        [
                            425,
                            436
                        ],
                        [
                            381,
                            256
                        ],
                        [
                            256,
                            252
                        ],
                        [
                            252,
                            381
                        ],
                        [
                            269,
                            391
                        ],
                        [
                            391,
                            393
                        ],
                        [
                            393,
                            269
                        ],
                        [
                            200,
                            199
                        ],
                        [
                            199,
                            428
                        ],
                        [
                            428,
                            200
                        ],
                        [
                            266,
                            330
                        ],
                        [
                            330,
                            329
                        ],
                        [
                            329,
                            266
                        ],
                        [
                            287,
                            273
                        ],
                        [
                            273,
                            422
                        ],
                        [
                            422,
                            287
                        ],
                        [
                            250,
                            462
                        ],
                        [
                            462,
                            328
                        ],
                        [
                            328,
                            250
                        ],
                        [
                            258,
                            286
                        ],
                        [
                            286,
                            384
                        ],
                        [
                            384,
                            258
                        ],
                        [
                            265,
                            353
                        ],
                        [
                            353,
                            342
                        ],
                        [
                            342,
                            265
                        ],
                        [
                            387,
                            259
                        ],
                        [
                            259,
                            257
                        ],
                        [
                            257,
                            387
                        ],
                        [
                            424,
                            431
                        ],
                        [
                            431,
                            430
                        ],
                        [
                            430,
                            424
                        ],
                        [
                            342,
                            353
                        ],
                        [
                            353,
                            276
                        ],
                        [
                            276,
                            342
                        ],
                        [
                            273,
                            335
                        ],
                        [
                            335,
                            424
                        ],
                        [
                            424,
                            273
                        ],
                        [
                            292,
                            325
                        ],
                        [
                            325,
                            307
                        ],
                        [
                            307,
                            292
                        ],
                        [
                            366,
                            447
                        ],
                        [
                            447,
                            345
                        ],
                        [
                            345,
                            366
                        ],
                        [
                            271,
                            303
                        ],
                        [
                            303,
                            302
                        ],
                        [
                            302,
                            271
                        ],
                        [
                            423,
                            266
                        ],
                        [
                            266,
                            371
                        ],
                        [
                            371,
                            423
                        ],
                        [
                            294,
                            455
                        ],
                        [
                            455,
                            460
                        ],
                        [
                            460,
                            294
                        ],
                        [
                            279,
                            278
                        ],
                        [
                            278,
                            294
                        ],
                        [
                            294,
                            279
                        ],
                        [
                            271,
                            272
                        ],
                        [
                            272,
                            304
                        ],
                        [
                            304,
                            271
                        ],
                        [
                            432,
                            434
                        ],
                        [
                            434,
                            427
                        ],
                        [
                            427,
                            432
                        ],
                        [
                            272,
                            407
                        ],
                        [
                            407,
                            408
                        ],
                        [
                            408,
                            272
                        ],
                        [
                            394,
                            430
                        ],
                        [
                            430,
                            431
                        ],
                        [
                            431,
                            394
                        ],
                        [
                            395,
                            369
                        ],
                        [
                            369,
                            400
                        ],
                        [
                            400,
                            395
                        ],
                        [
                            334,
                            333
                        ],
                        [
                            333,
                            299
                        ],
                        [
                            299,
                            334
                        ],
                        [
                            351,
                            417
                        ],
                        [
                            417,
                            168
                        ],
                        [
                            168,
                            351
                        ],
                        [
                            352,
                            280
                        ],
                        [
                            280,
                            411
                        ],
                        [
                            411,
                            352
                        ],
                        [
                            325,
                            319
                        ],
                        [
                            319,
                            320
                        ],
                        [
                            320,
                            325
                        ],
                        [
                            295,
                            296
                        ],
                        [
                            296,
                            336
                        ],
                        [
                            336,
                            295
                        ],
                        [
                            319,
                            403
                        ],
                        [
                            403,
                            404
                        ],
                        [
                            404,
                            319
                        ],
                        [
                            330,
                            348
                        ],
                        [
                            348,
                            349
                        ],
                        [
                            349,
                            330
                        ],
                        [
                            293,
                            298
                        ],
                        [
                            298,
                            333
                        ],
                        [
                            333,
                            293
                        ],
                        [
                            323,
                            454
                        ],
                        [
                            454,
                            447
                        ],
                        [
                            447,
                            323
                        ],
                        [
                            15,
                            16
                        ],
                        [
                            16,
                            315
                        ],
                        [
                            315,
                            15
                        ],
                        [
                            358,
                            429
                        ],
                        [
                            429,
                            279
                        ],
                        [
                            279,
                            358
                        ],
                        [
                            14,
                            15
                        ],
                        [
                            15,
                            316
                        ],
                        [
                            316,
                            14
                        ],
                        [
                            285,
                            336
                        ],
                        [
                            336,
                            9
                        ],
                        [
                            9,
                            285
                        ],
                        [
                            329,
                            349
                        ],
                        [
                            349,
                            350
                        ],
                        [
                            350,
                            329
                        ],
                        [
                            374,
                            380
                        ],
                        [
                            380,
                            252
                        ],
                        [
                            252,
                            374
                        ],
                        [
                            318,
                            402
                        ],
                        [
                            402,
                            403
                        ],
                        [
                            403,
                            318
                        ],
                        [
                            6,
                            197
                        ],
                        [
                            197,
                            419
                        ],
                        [
                            419,
                            6
                        ],
                        [
                            318,
                            319
                        ],
                        [
                            319,
                            325
                        ],
                        [
                            325,
                            318
                        ],
                        [
                            367,
                            364
                        ],
                        [
                            364,
                            365
                        ],
                        [
                            365,
                            367
                        ],
                        [
                            435,
                            367
                        ],
                        [
                            367,
                            397
                        ],
                        [
                            397,
                            435
                        ],
                        [
                            344,
                            438
                        ],
                        [
                            438,
                            439
                        ],
                        [
                            439,
                            344
                        ],
                        [
                            272,
                            271
                        ],
                        [
                            271,
                            311
                        ],
                        [
                            311,
                            272
                        ],
                        [
                            195,
                            5
                        ],
                        [
                            5,
                            281
                        ],
                        [
                            281,
                            195
                        ],
                        [
                            273,
                            287
                        ],
                        [
                            287,
                            291
                        ],
                        [
                            291,
                            273
                        ],
                        [
                            396,
                            428
                        ],
                        [
                            428,
                            199
                        ],
                        [
                            199,
                            396
                        ],
                        [
                            311,
                            271
                        ],
                        [
                            271,
                            268
                        ],
                        [
                            268,
                            311
                        ],
                        [
                            283,
                            444
                        ],
                        [
                            444,
                            445
                        ],
                        [
                            445,
                            283
                        ],
                        [
                            373,
                            254
                        ],
                        [
                            254,
                            339
                        ],
                        [
                            339,
                            373
                        ],
                        [
                            282,
                            334
                        ],
                        [
                            334,
                            296
                        ],
                        [
                            296,
                            282
                        ],
                        [
                            449,
                            347
                        ],
                        [
                            347,
                            346
                        ],
                        [
                            346,
                            449
                        ],
                        [
                            264,
                            447
                        ],
                        [
                            447,
                            454
                        ],
                        [
                            454,
                            264
                        ],
                        [
                            336,
                            296
                        ],
                        [
                            296,
                            299
                        ],
                        [
                            299,
                            336
                        ],
                        [
                            338,
                            10
                        ],
                        [
                            10,
                            151
                        ],
                        [
                            151,
                            338
                        ],
                        [
                            278,
                            439
                        ],
                        [
                            439,
                            455
                        ],
                        [
                            455,
                            278
                        ],
                        [
                            292,
                            407
                        ],
                        [
                            407,
                            415
                        ],
                        [
                            415,
                            292
                        ],
                        [
                            358,
                            371
                        ],
                        [
                            371,
                            355
                        ],
                        [
                            355,
                            358
                        ],
                        [
                            340,
                            345
                        ],
                        [
                            345,
                            372
                        ],
                        [
                            372,
                            340
                        ],
                        [
                            346,
                            347
                        ],
                        [
                            347,
                            280
                        ],
                        [
                            280,
                            346
                        ],
                        [
                            442,
                            443
                        ],
                        [
                            443,
                            282
                        ],
                        [
                            282,
                            442
                        ],
                        [
                            19,
                            94
                        ],
                        [
                            94,
                            370
                        ],
                        [
                            370,
                            19
                        ],
                        [
                            441,
                            442
                        ],
                        [
                            442,
                            295
                        ],
                        [
                            295,
                            441
                        ],
                        [
                            248,
                            419
                        ],
                        [
                            419,
                            197
                        ],
                        [
                            197,
                            248
                        ],
                        [
                            263,
                            255
                        ],
                        [
                            255,
                            359
                        ],
                        [
                            359,
                            263
                        ],
                        [
                            440,
                            275
                        ],
                        [
                            275,
                            274
                        ],
                        [
                            274,
                            440
                        ],
                        [
                            300,
                            383
                        ],
                        [
                            383,
                            368
                        ],
                        [
                            368,
                            300
                        ],
                        [
                            351,
                            412
                        ],
                        [
                            412,
                            465
                        ],
                        [
                            465,
                            351
                        ],
                        [
                            263,
                            467
                        ],
                        [
                            467,
                            466
                        ],
                        [
                            466,
                            263
                        ],
                        [
                            301,
                            368
                        ],
                        [
                            368,
                            389
                        ],
                        [
                            389,
                            301
                        ],
                        [
                            395,
                            378
                        ],
                        [
                            378,
                            379
                        ],
                        [
                            379,
                            395
                        ],
                        [
                            412,
                            351
                        ],
                        [
                            351,
                            419
                        ],
                        [
                            419,
                            412
                        ],
                        [
                            436,
                            426
                        ],
                        [
                            426,
                            322
                        ],
                        [
                            322,
                            436
                        ],
                        [
                            2,
                            164
                        ],
                        [
                            164,
                            393
                        ],
                        [
                            393,
                            2
                        ],
                        [
                            370,
                            462
                        ],
                        [
                            462,
                            461
                        ],
                        [
                            461,
                            370
                        ],
                        [
                            164,
                            0
                        ],
                        [
                            0,
                            267
                        ],
                        [
                            267,
                            164
                        ],
                        [
                            302,
                            11
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            12,
                            302
                        ],
                        [
                            268,
                            12
                        ],
                        [
                            12,
                            13
                        ],
                        [
                            13,
                            268
                        ],
                        [
                            293,
                            300
                        ],
                        [
                            300,
                            301
                        ],
                        [
                            301,
                            293
                        ],
                        [
                            446,
                            261
                        ],
                        [
                            261,
                            340
                        ],
                        [
                            340,
                            446
                        ],
                        [
                            330,
                            266
                        ],
                        [
                            266,
                            425
                        ],
                        [
                            425,
                            330
                        ],
                        [
                            426,
                            423
                        ],
                        [
                            423,
                            391
                        ],
                        [
                            391,
                            426
                        ],
                        [
                            429,
                            355
                        ],
                        [
                            355,
                            437
                        ],
                        [
                            437,
                            429
                        ],
                        [
                            391,
                            327
                        ],
                        [
                            327,
                            326
                        ],
                        [
                            326,
                            391
                        ],
                        [
                            440,
                            457
                        ],
                        [
                            457,
                            438
                        ],
                        [
                            438,
                            440
                        ],
                        [
                            341,
                            382
                        ],
                        [
                            382,
                            362
                        ],
                        [
                            362,
                            341
                        ],
                        [
                            459,
                            457
                        ],
                        [
                            457,
                            461
                        ],
                        [
                            461,
                            459
                        ],
                        [
                            434,
                            430
                        ],
                        [
                            430,
                            394
                        ],
                        [
                            394,
                            434
                        ],
                        [
                            414,
                            463
                        ],
                        [
                            463,
                            362
                        ],
                        [
                            362,
                            414
                        ],
                        [
                            396,
                            369
                        ],
                        [
                            369,
                            262
                        ],
                        [
                            262,
                            396
                        ],
                        [
                            354,
                            461
                        ],
                        [
                            461,
                            457
                        ],
                        [
                            457,
                            354
                        ],
                        [
                            316,
                            403
                        ],
                        [
                            403,
                            402
                        ],
                        [
                            402,
                            316
                        ],
                        [
                            315,
                            404
                        ],
                        [
                            404,
                            403
                        ],
                        [
                            403,
                            315
                        ],
                        [
                            314,
                            405
                        ],
                        [
                            405,
                            404
                        ],
                        [
                            404,
                            314
                        ],
                        [
                            313,
                            406
                        ],
                        [
                            406,
                            405
                        ],
                        [
                            405,
                            313
                        ],
                        [
                            421,
                            418
                        ],
                        [
                            418,
                            406
                        ],
                        [
                            406,
                            421
                        ],
                        [
                            366,
                            401
                        ],
                        [
                            401,
                            361
                        ],
                        [
                            361,
                            366
                        ],
                        [
                            306,
                            408
                        ],
                        [
                            408,
                            407
                        ],
                        [
                            407,
                            306
                        ],
                        [
                            291,
                            409
                        ],
                        [
                            409,
                            408
                        ],
                        [
                            408,
                            291
                        ],
                        [
                            287,
                            410
                        ],
                        [
                            410,
                            409
                        ],
                        [
                            409,
                            287
                        ],
                        [
                            432,
                            436
                        ],
                        [
                            436,
                            410
                        ],
                        [
                            410,
                            432
                        ],
                        [
                            434,
                            416
                        ],
                        [
                            416,
                            411
                        ],
                        [
                            411,
                            434
                        ],
                        [
                            264,
                            368
                        ],
                        [
                            368,
                            383
                        ],
                        [
                            383,
                            264
                        ],
                        [
                            309,
                            438
                        ],
                        [
                            438,
                            457
                        ],
                        [
                            457,
                            309
                        ],
                        [
                            352,
                            376
                        ],
                        [
                            376,
                            401
                        ],
                        [
                            401,
                            352
                        ],
                        [
                            274,
                            275
                        ],
                        [
                            275,
                            4
                        ],
                        [
                            4,
                            274
                        ],
                        [
                            421,
                            428
                        ],
                        [
                            428,
                            262
                        ],
                        [
                            262,
                            421
                        ],
                        [
                            294,
                            327
                        ],
                        [
                            327,
                            358
                        ],
                        [
                            358,
                            294
                        ],
                        [
                            433,
                            416
                        ],
                        [
                            416,
                            367
                        ],
                        [
                            367,
                            433
                        ],
                        [
                            289,
                            455
                        ],
                        [
                            455,
                            439
                        ],
                        [
                            439,
                            289
                        ],
                        [
                            462,
                            370
                        ],
                        [
                            370,
                            326
                        ],
                        [
                            326,
                            462
                        ],
                        [
                            2,
                            326
                        ],
                        [
                            326,
                            370
                        ],
                        [
                            370,
                            2
                        ],
                        [
                            305,
                            460
                        ],
                        [
                            460,
                            455
                        ],
                        [
                            455,
                            305
                        ],
                        [
                            254,
                            449
                        ],
                        [
                            449,
                            448
                        ],
                        [
                            448,
                            254
                        ],
                        [
                            255,
                            261
                        ],
                        [
                            261,
                            446
                        ],
                        [
                            446,
                            255
                        ],
                        [
                            253,
                            450
                        ],
                        [
                            450,
                            449
                        ],
                        [
                            449,
                            253
                        ],
                        [
                            252,
                            451
                        ],
                        [
                            451,
                            450
                        ],
                        [
                            450,
                            252
                        ],
                        [
                            256,
                            452
                        ],
                        [
                            452,
                            451
                        ],
                        [
                            451,
                            256
                        ],
                        [
                            341,
                            453
                        ],
                        [
                            453,
                            452
                        ],
                        [
                            452,
                            341
                        ],
                        [
                            413,
                            464
                        ],
                        [
                            464,
                            463
                        ],
                        [
                            463,
                            413
                        ],
                        [
                            441,
                            413
                        ],
                        [
                            413,
                            414
                        ],
                        [
                            414,
                            441
                        ],
                        [
                            258,
                            442
                        ],
                        [
                            442,
                            441
                        ],
                        [
                            441,
                            258
                        ],
                        [
                            257,
                            443
                        ],
                        [
                            443,
                            442
                        ],
                        [
                            442,
                            257
                        ],
                        [
                            259,
                            444
                        ],
                        [
                            444,
                            443
                        ],
                        [
                            443,
                            259
                        ],
                        [
                            260,
                            445
                        ],
                        [
                            445,
                            444
                        ],
                        [
                            444,
                            260
                        ],
                        [
                            467,
                            342
                        ],
                        [
                            342,
                            445
                        ],
                        [
                            445,
                            467
                        ],
                        [
                            459,
                            458
                        ],
                        [
                            458,
                            250
                        ],
                        [
                            250,
                            459
                        ],
                        [
                            289,
                            392
                        ],
                        [
                            392,
                            290
                        ],
                        [
                            290,
                            289
                        ],
                        [
                            290,
                            328
                        ],
                        [
                            328,
                            460
                        ],
                        [
                            460,
                            290
                        ],
                        [
                            376,
                            433
                        ],
                        [
                            433,
                            435
                        ],
                        [
                            435,
                            376
                        ],
                        [
                            250,
                            290
                        ],
                        [
                            290,
                            392
                        ],
                        [
                            392,
                            250
                        ],
                        [
                            411,
                            416
                        ],
                        [
                            416,
                            433
                        ],
                        [
                            433,
                            411
                        ],
                        [
                            341,
                            463
                        ],
                        [
                            463,
                            464
                        ],
                        [
                            464,
                            341
                        ],
                        [
                            453,
                            464
                        ],
                        [
                            464,
                            465
                        ],
                        [
                            465,
                            453
                        ],
                        [
                            357,
                            465
                        ],
                        [
                            465,
                            412
                        ],
                        [
                            412,
                            357
                        ],
                        [
                            343,
                            412
                        ],
                        [
                            412,
                            399
                        ],
                        [
                            399,
                            343
                        ],
                        [
                            360,
                            363
                        ],
                        [
                            363,
                            440
                        ],
                        [
                            440,
                            360
                        ],
                        [
                            437,
                            399
                        ],
                        [
                            399,
                            456
                        ],
                        [
                            456,
                            437
                        ],
                        [
                            420,
                            456
                        ],
                        [
                            456,
                            363
                        ],
                        [
                            363,
                            420
                        ],
                        [
                            401,
                            435
                        ],
                        [
                            435,
                            288
                        ],
                        [
                            288,
                            401
                        ],
                        [
                            372,
                            383
                        ],
                        [
                            383,
                            353
                        ],
                        [
                            353,
                            372
                        ],
                        [
                            339,
                            255
                        ],
                        [
                            255,
                            249
                        ],
                        [
                            249,
                            339
                        ],
                        [
                            448,
                            261
                        ],
                        [
                            261,
                            255
                        ],
                        [
                            255,
                            448
                        ],
                        [
                            133,
                            243
                        ],
                        [
                            243,
                            190
                        ],
                        [
                            190,
                            133
                        ],
                        [
                            133,
                            155
                        ],
                        [
                            155,
                            112
                        ],
                        [
                            112,
                            133
                        ],
                        [
                            33,
                            246
                        ],
                        [
                            246,
                            247
                        ],
                        [
                            247,
                            33
                        ],
                        [
                            33,
                            130
                        ],
                        [
                            130,
                            25
                        ],
                        [
                            25,
                            33
                        ],
                        [
                            398,
                            384
                        ],
                        [
                            384,
                            286
                        ],
                        [
                            286,
                            398
                        ],
                        [
                            362,
                            398
                        ],
                        [
                            398,
                            414
                        ],
                        [
                            414,
                            362
                        ],
                        [
                            362,
                            463
                        ],
                        [
                            463,
                            341
                        ],
                        [
                            341,
                            362
                        ],
                        [
                            263,
                            359
                        ],
                        [
                            359,
                            467
                        ],
                        [
                            467,
                            263
                        ],
                        [
                            263,
                            249
                        ],
                        [
                            249,
                            255
                        ],
                        [
                            255,
                            263
                        ],
                        [
                            466,
                            467
                        ],
                        [
                            467,
                            260
                        ],
                        [
                            260,
                            466
                        ],
                        [
                            75,
                            60
                        ],
                        [
                            60,
                            166
                        ],
                        [
                            166,
                            75
                        ],
                        [
                            238,
                            239
                        ],
                        [
                            239,
                            79
                        ],
                        [
                            79,
                            238
                        ],
                        [
                            162,
                            127
                        ],
                        [
                            127,
                            139
                        ],
                        [
                            139,
                            162
                        ],
                        [
                            72,
                            11
                        ],
                        [
                            11,
                            37
                        ],
                        [
                            37,
                            72
                        ],
                        [
                            121,
                            232
                        ],
                        [
                            232,
                            120
                        ],
                        [
                            120,
                            121
                        ],
                        [
                            73,
                            72
                        ],
                        [
                            72,
                            39
                        ],
                        [
                            39,
                            73
                        ],
                        [
                            114,
                            128
                        ],
                        [
                            128,
                            47
                        ],
                        [
                            47,
                            114
                        ],
                        [
                            233,
                            232
                        ],
                        [
                            232,
                            128
                        ],
                        [
                            128,
                            233
                        ],
                        [
                            103,
                            104
                        ],
                        [
                            104,
                            67
                        ],
                        [
                            67,
                            103
                        ],
                        [
                            152,
                            175
                        ],
                        [
                            175,
                            148
                        ],
                        [
                            148,
                            152
                        ],
                        [
                            119,
                            118
                        ],
                        [
                            118,
                            101
                        ],
                        [
                            101,
                            119
                        ],
                        [
                            74,
                            73
                        ],
                        [
                            73,
                            40
                        ],
                        [
                            40,
                            74
                        ],
                        [
                            107,
                            9
                        ],
                        [
                            9,
                            108
                        ],
                        [
                            108,
                            107
                        ],
                        [
                            49,
                            48
                        ],
                        [
                            48,
                            131
                        ],
                        [
                            131,
                            49
                        ],
                        [
                            32,
                            194
                        ],
                        [
                            194,
                            211
                        ],
                        [
                            211,
                            32
                        ],
                        [
                            184,
                            74
                        ],
                        [
                            74,
                            185
                        ],
                        [
                            185,
                            184
                        ],
                        [
                            191,
                            80
                        ],
                        [
                            80,
                            183
                        ],
                        [
                            183,
                            191
                        ],
                        [
                            185,
                            40
                        ],
                        [
                            40,
                            186
                        ],
                        [
                            186,
                            185
                        ],
                        [
                            119,
                            230
                        ],
                        [
                            230,
                            118
                        ],
                        [
                            118,
                            119
                        ],
                        [
                            210,
                            202
                        ],
                        [
                            202,
                            214
                        ],
                        [
                            214,
                            210
                        ],
                        [
                            84,
                            83
                        ],
                        [
                            83,
                            17
                        ],
                        [
                            17,
                            84
                        ],
                        [
                            77,
                            76
                        ],
                        [
                            76,
                            146
                        ],
                        [
                            146,
                            77
                        ],
                        [
                            161,
                            160
                        ],
                        [
                            160,
                            30
                        ],
                        [
                            30,
                            161
                        ],
                        [
                            190,
                            56
                        ],
                        [
                            56,
                            173
                        ],
                        [
                            173,
                            190
                        ],
                        [
                            182,
                            106
                        ],
                        [
                            106,
                            194
                        ],
                        [
                            194,
                            182
                        ],
                        [
                            138,
                            135
                        ],
                        [
                            135,
                            192
                        ],
                        [
                            192,
                            138
                        ],
                        [
                            129,
                            203
                        ],
                        [
                            203,
                            98
                        ],
                        [
                            98,
                            129
                        ],
                        [
                            54,
                            21
                        ],
                        [
                            21,
                            68
                        ],
                        [
                            68,
                            54
                        ],
                        [
                            5,
                            51
                        ],
                        [
                            51,
                            4
                        ],
                        [
                            4,
                            5
                        ],
                        [
                            145,
                            144
                        ],
                        [
                            144,
                            23
                        ],
                        [
                            23,
                            145
                        ],
                        [
                            90,
                            77
                        ],
                        [
                            77,
                            91
                        ],
                        [
                            91,
                            90
                        ],
                        [
                            207,
                            205
                        ],
                        [
                            205,
                            187
                        ],
                        [
                            187,
                            207
                        ],
                        [
                            83,
                            201
                        ],
                        [
                            201,
                            18
                        ],
                        [
                            18,
                            83
                        ],
                        [
                            181,
                            91
                        ],
                        [
                            91,
                            182
                        ],
                        [
                            182,
                            181
                        ],
                        [
                            180,
                            90
                        ],
                        [
                            90,
                            181
                        ],
                        [
                            181,
                            180
                        ],
                        [
                            16,
                            85
                        ],
                        [
                            85,
                            17
                        ],
                        [
                            17,
                            16
                        ],
                        [
                            205,
                            206
                        ],
                        [
                            206,
                            36
                        ],
                        [
                            36,
                            205
                        ],
                        [
                            176,
                            148
                        ],
                        [
                            148,
                            140
                        ],
                        [
                            140,
                            176
                        ],
                        [
                            165,
                            92
                        ],
                        [
                            92,
                            39
                        ],
                        [
                            39,
                            165
                        ],
                        [
                            245,
                            193
                        ],
                        [
                            193,
                            244
                        ],
                        [
                            244,
                            245
                        ],
                        [
                            27,
                            159
                        ],
                        [
                            159,
                            28
                        ],
                        [
                            28,
                            27
                        ],
                        [
                            30,
                            247
                        ],
                        [
                            247,
                            161
                        ],
                        [
                            161,
                            30
                        ],
                        [
                            174,
                            236
                        ],
                        [
                            236,
                            196
                        ],
                        [
                            196,
                            174
                        ],
                        [
                            103,
                            54
                        ],
                        [
                            54,
                            104
                        ],
                        [
                            104,
                            103
                        ],
                        [
                            55,
                            193
                        ],
                        [
                            193,
                            8
                        ],
                        [
                            8,
                            55
                        ],
                        [
                            111,
                            117
                        ],
                        [
                            117,
                            31
                        ],
                        [
                            31,
                            111
                        ],
                        [
                            221,
                            189
                        ],
                        [
                            189,
                            55
                        ],
                        [
                            55,
                            221
                        ],
                        [
                            240,
                            98
                        ],
                        [
                            98,
                            99
                        ],
                        [
                            99,
                            240
                        ],
                        [
                            142,
                            126
                        ],
                        [
                            126,
                            100
                        ],
                        [
                            100,
                            142
                        ],
                        [
                            219,
                            166
                        ],
                        [
                            166,
                            218
                        ],
                        [
                            218,
                            219
                        ],
                        [
                            112,
                            155
                        ],
                        [
                            155,
                            26
                        ],
                        [
                            26,
                            112
                        ],
                        [
                            198,
                            209
                        ],
                        [
                            209,
                            131
                        ],
                        [
                            131,
                            198
                        ],
                        [
                            169,
                            135
                        ],
                        [
                            135,
                            150
                        ],
                        [
                            150,
                            169
                        ],
                        [
                            114,
                            47
                        ],
                        [
                            47,
                            217
                        ],
                        [
                            217,
                            114
                        ],
                        [
                            224,
                            223
                        ],
                        [
                            223,
                            53
                        ],
                        [
                            53,
                            224
                        ],
                        [
                            220,
                            45
                        ],
                        [
                            45,
                            134
                        ],
                        [
                            134,
                            220
                        ],
                        [
                            32,
                            211
                        ],
                        [
                            211,
                            140
                        ],
                        [
                            140,
                            32
                        ],
                        [
                            109,
                            67
                        ],
                        [
                            67,
                            108
                        ],
                        [
                            108,
                            109
                        ],
                        [
                            146,
                            43
                        ],
                        [
                            43,
                            91
                        ],
                        [
                            91,
                            146
                        ],
                        [
                            231,
                            230
                        ],
                        [
                            230,
                            120
                        ],
                        [
                            120,
                            231
                        ],
                        [
                            113,
                            226
                        ],
                        [
                            226,
                            247
                        ],
                        [
                            247,
                            113
                        ],
                        [
                            105,
                            63
                        ],
                        [
                            63,
                            52
                        ],
                        [
                            52,
                            105
                        ],
                        [
                            241,
                            238
                        ],
                        [
                            238,
                            242
                        ],
                        [
                            242,
                            241
                        ],
                        [
                            124,
                            46
                        ],
                        [
                            46,
                            156
                        ],
                        [
                            156,
                            124
                        ],
                        [
                            95,
                            78
                        ],
                        [
                            78,
                            96
                        ],
                        [
                            96,
                            95
                        ],
                        [
                            70,
                            46
                        ],
                        [
                            46,
                            63
                        ],
                        [
                            63,
                            70
                        ],
                        [
                            116,
                            143
                        ],
                        [
                            143,
                            227
                        ],
                        [
                            227,
                            116
                        ],
                        [
                            116,
                            123
                        ],
                        [
                            123,
                            111
                        ],
                        [
                            111,
                            116
                        ],
                        [
                            1,
                            44
                        ],
                        [
                            44,
                            19
                        ],
                        [
                            19,
                            1
                        ],
                        [
                            3,
                            236
                        ],
                        [
                            236,
                            51
                        ],
                        [
                            51,
                            3
                        ],
                        [
                            207,
                            216
                        ],
                        [
                            216,
                            205
                        ],
                        [
                            205,
                            207
                        ],
                        [
                            26,
                            154
                        ],
                        [
                            154,
                            22
                        ],
                        [
                            22,
                            26
                        ],
                        [
                            165,
                            39
                        ],
                        [
                            39,
                            167
                        ],
                        [
                            167,
                            165
                        ],
                        [
                            199,
                            200
                        ],
                        [
                            200,
                            208
                        ],
                        [
                            208,
                            199
                        ],
                        [
                            101,
                            36
                        ],
                        [
                            36,
                            100
                        ],
                        [
                            100,
                            101
                        ],
                        [
                            43,
                            57
                        ],
                        [
                            57,
                            202
                        ],
                        [
                            202,
                            43
                        ],
                        [
                            242,
                            20
                        ],
                        [
                            20,
                            99
                        ],
                        [
                            99,
                            242
                        ],
                        [
                            56,
                            28
                        ],
                        [
                            28,
                            157
                        ],
                        [
                            157,
                            56
                        ],
                        [
                            124,
                            35
                        ],
                        [
                            35,
                            113
                        ],
                        [
                            113,
                            124
                        ],
                        [
                            29,
                            160
                        ],
                        [
                            160,
                            27
                        ],
                        [
                            27,
                            29
                        ],
                        [
                            211,
                            204
                        ],
                        [
                            204,
                            210
                        ],
                        [
                            210,
                            211
                        ],
                        [
                            124,
                            113
                        ],
                        [
                            113,
                            46
                        ],
                        [
                            46,
                            124
                        ],
                        [
                            106,
                            43
                        ],
                        [
                            43,
                            204
                        ],
                        [
                            204,
                            106
                        ],
                        [
                            96,
                            62
                        ],
                        [
                            62,
                            77
                        ],
                        [
                            77,
                            96
                        ],
                        [
                            227,
                            137
                        ],
                        [
                            137,
                            116
                        ],
                        [
                            116,
                            227
                        ],
                        [
                            73,
                            41
                        ],
                        [
                            41,
                            72
                        ],
                        [
                            72,
                            73
                        ],
                        [
                            36,
                            203
                        ],
                        [
                            203,
                            142
                        ],
                        [
                            142,
                            36
                        ],
                        [
                            235,
                            64
                        ],
                        [
                            64,
                            240
                        ],
                        [
                            240,
                            235
                        ],
                        [
                            48,
                            49
                        ],
                        [
                            49,
                            64
                        ],
                        [
                            64,
                            48
                        ],
                        [
                            42,
                            41
                        ],
                        [
                            41,
                            74
                        ],
                        [
                            74,
                            42
                        ],
                        [
                            214,
                            212
                        ],
                        [
                            212,
                            207
                        ],
                        [
                            207,
                            214
                        ],
                        [
                            183,
                            42
                        ],
                        [
                            42,
                            184
                        ],
                        [
                            184,
                            183
                        ],
                        [
                            210,
                            169
                        ],
                        [
                            169,
                            211
                        ],
                        [
                            211,
                            210
                        ],
                        [
                            140,
                            170
                        ],
                        [
                            170,
                            176
                        ],
                        [
                            176,
                            140
                        ],
                        [
                            104,
                            105
                        ],
                        [
                            105,
                            69
                        ],
                        [
                            69,
                            104
                        ],
                        [
                            193,
                            122
                        ],
                        [
                            122,
                            168
                        ],
                        [
                            168,
                            193
                        ],
                        [
                            50,
                            123
                        ],
                        [
                            123,
                            187
                        ],
                        [
                            187,
                            50
                        ],
                        [
                            89,
                            96
                        ],
                        [
                            96,
                            90
                        ],
                        [
                            90,
                            89
                        ],
                        [
                            66,
                            65
                        ],
                        [
                            65,
                            107
                        ],
                        [
                            107,
                            66
                        ],
                        [
                            179,
                            89
                        ],
                        [
                            89,
                            180
                        ],
                        [
                            180,
                            179
                        ],
                        [
                            119,
                            101
                        ],
                        [
                            101,
                            120
                        ],
                        [
                            120,
                            119
                        ],
                        [
                            68,
                            63
                        ],
                        [
                            63,
                            104
                        ],
                        [
                            104,
                            68
                        ],
                        [
                            234,
                            93
                        ],
                        [
                            93,
                            227
                        ],
                        [
                            227,
                            234
                        ],
                        [
                            16,
                            15
                        ],
                        [
                            15,
                            85
                        ],
                        [
                            85,
                            16
                        ],
                        [
                            209,
                            129
                        ],
                        [
                            129,
                            49
                        ],
                        [
                            49,
                            209
                        ],
                        [
                            15,
                            14
                        ],
                        [
                            14,
                            86
                        ],
                        [
                            86,
                            15
                        ],
                        [
                            107,
                            55
                        ],
                        [
                            55,
                            9
                        ],
                        [
                            9,
                            107
                        ],
                        [
                            120,
                            100
                        ],
                        [
                            100,
                            121
                        ],
                        [
                            121,
                            120
                        ],
                        [
                            153,
                            145
                        ],
                        [
                            145,
                            22
                        ],
                        [
                            22,
                            153
                        ],
                        [
                            178,
                            88
                        ],
                        [
                            88,
                            179
                        ],
                        [
                            179,
                            178
                        ],
                        [
                            197,
                            6
                        ],
                        [
                            6,
                            196
                        ],
                        [
                            196,
                            197
                        ],
                        [
                            89,
                            88
                        ],
                        [
                            88,
                            96
                        ],
                        [
                            96,
                            89
                        ],
                        [
                            135,
                            138
                        ],
                        [
                            138,
                            136
                        ],
                        [
                            136,
                            135
                        ],
                        [
                            138,
                            215
                        ],
                        [
                            215,
                            172
                        ],
                        [
                            172,
                            138
                        ],
                        [
                            218,
                            115
                        ],
                        [
                            115,
                            219
                        ],
                        [
                            219,
                            218
                        ],
                        [
                            41,
                            42
                        ],
                        [
                            42,
                            81
                        ],
                        [
                            81,
                            41
                        ],
                        [
                            5,
                            195
                        ],
                        [
                            195,
                            51
                        ],
                        [
                            51,
                            5
                        ],
                        [
                            57,
                            43
                        ],
                        [
                            43,
                            61
                        ],
                        [
                            61,
                            57
                        ],
                        [
                            208,
                            171
                        ],
                        [
                            171,
                            199
                        ],
                        [
                            199,
                            208
                        ],
                        [
                            41,
                            81
                        ],
                        [
                            81,
                            38
                        ],
                        [
                            38,
                            41
                        ],
                        [
                            224,
                            53
                        ],
                        [
                            53,
                            225
                        ],
                        [
                            225,
                            224
                        ],
                        [
                            24,
                            144
                        ],
                        [
                            144,
                            110
                        ],
                        [
                            110,
                            24
                        ],
                        [
                            105,
                            52
                        ],
                        [
                            52,
                            66
                        ],
                        [
                            66,
                            105
                        ],
                        [
                            118,
                            229
                        ],
                        [
                            229,
                            117
                        ],
                        [
                            117,
                            118
                        ],
                        [
                            227,
                            34
                        ],
                        [
                            34,
                            234
                        ],
                        [
                            234,
                            227
                        ],
                        [
                            66,
                            107
                        ],
                        [
                            107,
                            69
                        ],
                        [
                            69,
                            66
                        ],
                        [
                            10,
                            109
                        ],
                        [
                            109,
                            151
                        ],
                        [
                            151,
                            10
                        ],
                        [
                            219,
                            48
                        ],
                        [
                            48,
                            235
                        ],
                        [
                            235,
                            219
                        ],
                        [
                            183,
                            62
                        ],
                        [
                            62,
                            191
                        ],
                        [
                            191,
                            183
                        ],
                        [
                            142,
                            129
                        ],
                        [
                            129,
                            126
                        ],
                        [
                            126,
                            142
                        ],
                        [
                            116,
                            111
                        ],
                        [
                            111,
                            143
                        ],
                        [
                            143,
                            116
                        ],
                        [
                            118,
                            117
                        ],
                        [
                            117,
                            50
                        ],
                        [
                            50,
                            118
                        ],
                        [
                            223,
                            222
                        ],
                        [
                            222,
                            52
                        ],
                        [
                            52,
                            223
                        ],
                        [
                            94,
                            19
                        ],
                        [
                            19,
                            141
                        ],
                        [
                            141,
                            94
                        ],
                        [
                            222,
                            221
                        ],
                        [
                            221,
                            65
                        ],
                        [
                            65,
                            222
                        ],
                        [
                            196,
                            3
                        ],
                        [
                            3,
                            197
                        ],
                        [
                            197,
                            196
                        ],
                        [
                            45,
                            220
                        ],
                        [
                            220,
                            44
                        ],
                        [
                            44,
                            45
                        ],
                        [
                            156,
                            70
                        ],
                        [
                            70,
                            139
                        ],
                        [
                            139,
                            156
                        ],
                        [
                            188,
                            122
                        ],
                        [
                            122,
                            245
                        ],
                        [
                            245,
                            188
                        ],
                        [
                            139,
                            71
                        ],
                        [
                            71,
                            162
                        ],
                        [
                            162,
                            139
                        ],
                        [
                            149,
                            170
                        ],
                        [
                            170,
                            150
                        ],
                        [
                            150,
                            149
                        ],
                        [
                            122,
                            188
                        ],
                        [
                            188,
                            196
                        ],
                        [
                            196,
                            122
                        ],
                        [
                            206,
                            216
                        ],
                        [
                            216,
                            92
                        ],
                        [
                            92,
                            206
                        ],
                        [
                            164,
                            2
                        ],
                        [
                            2,
                            167
                        ],
                        [
                            167,
                            164
                        ],
                        [
                            242,
                            141
                        ],
                        [
                            141,
                            241
                        ],
                        [
                            241,
                            242
                        ],
                        [
                            0,
                            164
                        ],
                        [
                            164,
                            37
                        ],
                        [
                            37,
                            0
                        ],
                        [
                            11,
                            72
                        ],
                        [
                            72,
                            12
                        ],
                        [
                            12,
                            11
                        ],
                        [
                            12,
                            38
                        ],
                        [
                            38,
                            13
                        ],
                        [
                            13,
                            12
                        ],
                        [
                            70,
                            63
                        ],
                        [
                            63,
                            71
                        ],
                        [
                            71,
                            70
                        ],
                        [
                            31,
                            226
                        ],
                        [
                            226,
                            111
                        ],
                        [
                            111,
                            31
                        ],
                        [
                            36,
                            101
                        ],
                        [
                            101,
                            205
                        ],
                        [
                            205,
                            36
                        ],
                        [
                            203,
                            206
                        ],
                        [
                            206,
                            165
                        ],
                        [
                            165,
                            203
                        ],
                        [
                            126,
                            209
                        ],
                        [
                            209,
                            217
                        ],
                        [
                            217,
                            126
                        ],
                        [
                            98,
                            165
                        ],
                        [
                            165,
                            97
                        ],
                        [
                            97,
                            98
                        ],
                        [
                            237,
                            220
                        ],
                        [
                            220,
                            218
                        ],
                        [
                            218,
                            237
                        ],
                        [
                            237,
                            239
                        ],
                        [
                            239,
                            241
                        ],
                        [
                            241,
                            237
                        ],
                        [
                            210,
                            214
                        ],
                        [
                            214,
                            169
                        ],
                        [
                            169,
                            210
                        ],
                        [
                            140,
                            171
                        ],
                        [
                            171,
                            32
                        ],
                        [
                            32,
                            140
                        ],
                        [
                            241,
                            125
                        ],
                        [
                            125,
                            237
                        ],
                        [
                            237,
                            241
                        ],
                        [
                            179,
                            86
                        ],
                        [
                            86,
                            178
                        ],
                        [
                            178,
                            179
                        ],
                        [
                            180,
                            85
                        ],
                        [
                            85,
                            179
                        ],
                        [
                            179,
                            180
                        ],
                        [
                            181,
                            84
                        ],
                        [
                            84,
                            180
                        ],
                        [
                            180,
                            181
                        ],
                        [
                            182,
                            83
                        ],
                        [
                            83,
                            181
                        ],
                        [
                            181,
                            182
                        ],
                        [
                            194,
                            201
                        ],
                        [
                            201,
                            182
                        ],
                        [
                            182,
                            194
                        ],
                        [
                            177,
                            137
                        ],
                        [
                            137,
                            132
                        ],
                        [
                            132,
                            177
                        ],
                        [
                            184,
                            76
                        ],
                        [
                            76,
                            183
                        ],
                        [
                            183,
                            184
                        ],
                        [
                            185,
                            61
                        ],
                        [
                            61,
                            184
                        ],
                        [
                            184,
                            185
                        ],
                        [
                            186,
                            57
                        ],
                        [
                            57,
                            185
                        ],
                        [
                            185,
                            186
                        ],
                        [
                            216,
                            212
                        ],
                        [
                            212,
                            186
                        ],
                        [
                            186,
                            216
                        ],
                        [
                            192,
                            214
                        ],
                        [
                            214,
                            187
                        ],
                        [
                            187,
                            192
                        ],
                        [
                            139,
                            34
                        ],
                        [
                            34,
                            156
                        ],
                        [
                            156,
                            139
                        ],
                        [
                            218,
                            79
                        ],
                        [
                            79,
                            237
                        ],
                        [
                            237,
                            218
                        ],
                        [
                            147,
                            123
                        ],
                        [
                            123,
                            177
                        ],
                        [
                            177,
                            147
                        ],
                        [
                            45,
                            44
                        ],
                        [
                            44,
                            4
                        ],
                        [
                            4,
                            45
                        ],
                        [
                            208,
                            201
                        ],
                        [
                            201,
                            32
                        ],
                        [
                            32,
                            208
                        ],
                        [
                            98,
                            64
                        ],
                        [
                            64,
                            129
                        ],
                        [
                            129,
                            98
                        ],
                        [
                            192,
                            213
                        ],
                        [
                            213,
                            138
                        ],
                        [
                            138,
                            192
                        ],
                        [
                            235,
                            59
                        ],
                        [
                            59,
                            219
                        ],
                        [
                            219,
                            235
                        ],
                        [
                            141,
                            242
                        ],
                        [
                            242,
                            97
                        ],
                        [
                            97,
                            141
                        ],
                        [
                            97,
                            2
                        ],
                        [
                            2,
                            141
                        ],
                        [
                            141,
                            97
                        ],
                        [
                            240,
                            75
                        ],
                        [
                            75,
                            235
                        ],
                        [
                            235,
                            240
                        ],
                        [
                            229,
                            24
                        ],
                        [
                            24,
                            228
                        ],
                        [
                            228,
                            229
                        ],
                        [
                            31,
                            25
                        ],
                        [
                            25,
                            226
                        ],
                        [
                            226,
                            31
                        ],
                        [
                            230,
                            23
                        ],
                        [
                            23,
                            229
                        ],
                        [
                            229,
                            230
                        ],
                        [
                            231,
                            22
                        ],
                        [
                            22,
                            230
                        ],
                        [
                            230,
                            231
                        ],
                        [
                            232,
                            26
                        ],
                        [
                            26,
                            231
                        ],
                        [
                            231,
                            232
                        ],
                        [
                            233,
                            112
                        ],
                        [
                            112,
                            232
                        ],
                        [
                            232,
                            233
                        ],
                        [
                            244,
                            189
                        ],
                        [
                            189,
                            243
                        ],
                        [
                            243,
                            244
                        ],
                        [
                            189,
                            221
                        ],
                        [
                            221,
                            190
                        ],
                        [
                            190,
                            189
                        ],
                        [
                            222,
                            28
                        ],
                        [
                            28,
                            221
                        ],
                        [
                            221,
                            222
                        ],
                        [
                            223,
                            27
                        ],
                        [
                            27,
                            222
                        ],
                        [
                            222,
                            223
                        ],
                        [
                            224,
                            29
                        ],
                        [
                            29,
                            223
                        ],
                        [
                            223,
                            224
                        ],
                        [
                            225,
                            30
                        ],
                        [
                            30,
                            224
                        ],
                        [
                            224,
                            225
                        ],
                        [
                            113,
                            247
                        ],
                        [
                            247,
                            225
                        ],
                        [
                            225,
                            113
                        ],
                        [
                            99,
                            60
                        ],
                        [
                            60,
                            240
                        ],
                        [
                            240,
                            99
                        ],
                        [
                            213,
                            147
                        ],
                        [
                            147,
                            215
                        ],
                        [
                            215,
                            213
                        ],
                        [
                            60,
                            20
                        ],
                        [
                            20,
                            166
                        ],
                        [
                            166,
                            60
                        ],
                        [
                            192,
                            187
                        ],
                        [
                            187,
                            213
                        ],
                        [
                            213,
                            192
                        ],
                        [
                            243,
                            112
                        ],
                        [
                            112,
                            244
                        ],
                        [
                            244,
                            243
                        ],
                        [
                            244,
                            233
                        ],
                        [
                            233,
                            245
                        ],
                        [
                            245,
                            244
                        ],
                        [
                            245,
                            128
                        ],
                        [
                            128,
                            188
                        ],
                        [
                            188,
                            245
                        ],
                        [
                            188,
                            114
                        ],
                        [
                            114,
                            174
                        ],
                        [
                            174,
                            188
                        ],
                        [
                            134,
                            131
                        ],
                        [
                            131,
                            220
                        ],
                        [
                            220,
                            134
                        ],
                        [
                            174,
                            217
                        ],
                        [
                            217,
                            236
                        ],
                        [
                            236,
                            174
                        ],
                        [
                            236,
                            198
                        ],
                        [
                            198,
                            134
                        ],
                        [
                            134,
                            236
                        ],
                        [
                            215,
                            177
                        ],
                        [
                            177,
                            58
                        ],
                        [
                            58,
                            215
                        ],
                        [
                            156,
                            143
                        ],
                        [
                            143,
                            124
                        ],
                        [
                            124,
                            156
                        ],
                        [
                            25,
                            110
                        ],
                        [
                            110,
                            7
                        ],
                        [
                            7,
                            25
                        ],
                        [
                            31,
                            228
                        ],
                        [
                            228,
                            25
                        ],
                        [
                            25,
                            31
                        ],
                        [
                            264,
                            356
                        ],
                        [
                            356,
                            368
                        ],
                        [
                            368,
                            264
                        ],
                        [
                            0,
                            11
                        ],
                        [
                            11,
                            267
                        ],
                        [
                            267,
                            0
                        ],
                        [
                            451,
                            452
                        ],
                        [
                            452,
                            349
                        ],
                        [
                            349,
                            451
                        ],
                        [
                            267,
                            302
                        ],
                        [
                            302,
                            269
                        ],
                        [
                            269,
                            267
                        ],
                        [
                            350,
                            357
                        ],
                        [
                            357,
                            277
                        ],
                        [
                            277,
                            350
                        ],
                        [
                            350,
                            452
                        ],
                        [
                            452,
                            357
                        ],
                        [
                            357,
                            350
                        ],
                        [
                            299,
                            333
                        ],
                        [
                            333,
                            297
                        ],
                        [
                            297,
                            299
                        ],
                        [
                            396,
                            175
                        ],
                        [
                            175,
                            377
                        ],
                        [
                            377,
                            396
                        ],
                        [
                            280,
                            347
                        ],
                        [
                            347,
                            330
                        ],
                        [
                            330,
                            280
                        ],
                        [
                            269,
                            303
                        ],
                        [
                            303,
                            270
                        ],
                        [
                            270,
                            269
                        ],
                        [
                            151,
                            9
                        ],
                        [
                            9,
                            337
                        ],
                        [
                            337,
                            151
                        ],
                        [
                            344,
                            278
                        ],
                        [
                            278,
                            360
                        ],
                        [
                            360,
                            344
                        ],
                        [
                            424,
                            418
                        ],
                        [
                            418,
                            431
                        ],
                        [
                            431,
                            424
                        ],
                        [
                            270,
                            304
                        ],
                        [
                            304,
                            409
                        ],
                        [
                            409,
                            270
                        ],
                        [
                            272,
                            310
                        ],
                        [
                            310,
                            407
                        ],
                        [
                            407,
                            272
                        ],
                        [
                            322,
                            270
                        ],
                        [
                            270,
                            410
                        ],
                        [
                            410,
                            322
                        ],
                        [
                            449,
                            450
                        ],
                        [
                            450,
                            347
                        ],
                        [
                            347,
                            449
                        ],
                        [
                            432,
                            422
                        ],
                        [
                            422,
                            434
                        ],
                        [
                            434,
                            432
                        ],
                        [
                            18,
                            313
                        ],
                        [
                            313,
                            17
                        ],
                        [
                            17,
                            18
                        ],
                        [
                            291,
                            306
                        ],
                        [
                            306,
                            375
                        ],
                        [
                            375,
                            291
                        ],
                        [
                            259,
                            387
                        ],
                        [
                            387,
                            260
                        ],
                        [
                            260,
                            259
                        ],
                        [
                            424,
                            335
                        ],
                        [
                            335,
                            418
                        ],
                        [
                            418,
                            424
                        ],
                        [
                            434,
                            364
                        ],
                        [
                            364,
                            416
                        ],
                        [
                            416,
                            434
                        ],
                        [
                            391,
                            423
                        ],
                        [
                            423,
                            327
                        ],
                        [
                            327,
                            391
                        ],
                        [
                            301,
                            251
                        ],
                        [
                            251,
                            298
                        ],
                        [
                            298,
                            301
                        ],
                        [
                            275,
                            281
                        ],
                        [
                            281,
                            4
                        ],
                        [
                            4,
                            275
                        ],
                        [
                            254,
                            373
                        ],
                        [
                            373,
                            253
                        ],
                        [
                            253,
                            254
                        ],
                        [
                            375,
                            307
                        ],
                        [
                            307,
                            321
                        ],
                        [
                            321,
                            375
                        ],
                        [
                            280,
                            425
                        ],
                        [
                            425,
                            411
                        ],
                        [
                            411,
                            280
                        ],
                        [
                            200,
                            421
                        ],
                        [
                            421,
                            18
                        ],
                        [
                            18,
                            200
                        ],
                        [
                            335,
                            321
                        ],
                        [
                            321,
                            406
                        ],
                        [
                            406,
                            335
                        ],
                        [
                            321,
                            320
                        ],
                        [
                            320,
                            405
                        ],
                        [
                            405,
                            321
                        ],
                        [
                            314,
                            315
                        ],
                        [
                            315,
                            17
                        ],
                        [
                            17,
                            314
                        ],
                        [
                            423,
                            426
                        ],
                        [
                            426,
                            266
                        ],
                        [
                            266,
                            423
                        ],
                        [
                            396,
                            377
                        ],
                        [
                            377,
                            369
                        ],
                        [
                            369,
                            396
                        ],
                        [
                            270,
                            322
                        ],
                        [
                            322,
                            269
                        ],
                        [
                            269,
                            270
                        ],
                        [
                            413,
                            417
                        ],
                        [
                            417,
                            464
                        ],
                        [
                            464,
                            413
                        ],
                        [
                            385,
                            386
                        ],
                        [
                            386,
                            258
                        ],
                        [
                            258,
                            385
                        ],
                        [
                            248,
                            456
                        ],
                        [
                            456,
                            419
                        ],
                        [
                            419,
                            248
                        ],
                        [
                            298,
                            284
                        ],
                        [
                            284,
                            333
                        ],
                        [
                            333,
                            298
                        ],
                        [
                            168,
                            417
                        ],
                        [
                            417,
                            8
                        ],
                        [
                            8,
                            168
                        ],
                        [
                            448,
                            346
                        ],
                        [
                            346,
                            261
                        ],
                        [
                            261,
                            448
                        ],
                        [
                            417,
                            413
                        ],
                        [
                            413,
                            285
                        ],
                        [
                            285,
                            417
                        ],
                        [
                            326,
                            327
                        ],
                        [
                            327,
                            328
                        ],
                        [
                            328,
                            326
                        ],
                        [
                            277,
                            355
                        ],
                        [
                            355,
                            329
                        ],
                        [
                            329,
                            277
                        ],
                        [
                            309,
                            392
                        ],
                        [
                            392,
                            438
                        ],
                        [
                            438,
                            309
                        ],
                        [
                            381,
                            382
                        ],
                        [
                            382,
                            256
                        ],
                        [
                            256,
                            381
                        ],
                        [
                            279,
                            429
                        ],
                        [
                            429,
                            360
                        ],
                        [
                            360,
                            279
                        ],
                        [
                            365,
                            364
                        ],
                        [
                            364,
                            379
                        ],
                        [
                            379,
                            365
                        ],
                        [
                            355,
                            277
                        ],
                        [
                            277,
                            437
                        ],
                        [
                            437,
                            355
                        ],
                        [
                            282,
                            443
                        ],
                        [
                            443,
                            283
                        ],
                        [
                            283,
                            282
                        ],
                        [
                            281,
                            275
                        ],
                        [
                            275,
                            363
                        ],
                        [
                            363,
                            281
                        ],
                        [
                            395,
                            431
                        ],
                        [
                            431,
                            369
                        ],
                        [
                            369,
                            395
                        ],
                        [
                            299,
                            297
                        ],
                        [
                            297,
                            337
                        ],
                        [
                            337,
                            299
                        ],
                        [
                            335,
                            273
                        ],
                        [
                            273,
                            321
                        ],
                        [
                            321,
                            335
                        ],
                        [
                            348,
                            450
                        ],
                        [
                            450,
                            349
                        ],
                        [
                            349,
                            348
                        ],
                        [
                            359,
                            446
                        ],
                        [
                            446,
                            467
                        ],
                        [
                            467,
                            359
                        ],
                        [
                            283,
                            293
                        ],
                        [
                            293,
                            282
                        ],
                        [
                            282,
                            283
                        ],
                        [
                            250,
                            458
                        ],
                        [
                            458,
                            462
                        ],
                        [
                            462,
                            250
                        ],
                        [
                            300,
                            276
                        ],
                        [
                            276,
                            383
                        ],
                        [
                            383,
                            300
                        ],
                        [
                            292,
                            308
                        ],
                        [
                            308,
                            325
                        ],
                        [
                            325,
                            292
                        ],
                        [
                            283,
                            276
                        ],
                        [
                            276,
                            293
                        ],
                        [
                            293,
                            283
                        ],
                        [
                            264,
                            372
                        ],
                        [
                            372,
                            447
                        ],
                        [
                            447,
                            264
                        ],
                        [
                            346,
                            352
                        ],
                        [
                            352,
                            340
                        ],
                        [
                            340,
                            346
                        ],
                        [
                            354,
                            274
                        ],
                        [
                            274,
                            19
                        ],
                        [
                            19,
                            354
                        ],
                        [
                            363,
                            456
                        ],
                        [
                            456,
                            281
                        ],
                        [
                            281,
                            363
                        ],
                        [
                            426,
                            436
                        ],
                        [
                            436,
                            425
                        ],
                        [
                            425,
                            426
                        ],
                        [
                            380,
                            381
                        ],
                        [
                            381,
                            252
                        ],
                        [
                            252,
                            380
                        ],
                        [
                            267,
                            269
                        ],
                        [
                            269,
                            393
                        ],
                        [
                            393,
                            267
                        ],
                        [
                            421,
                            200
                        ],
                        [
                            200,
                            428
                        ],
                        [
                            428,
                            421
                        ],
                        [
                            371,
                            266
                        ],
                        [
                            266,
                            329
                        ],
                        [
                            329,
                            371
                        ],
                        [
                            432,
                            287
                        ],
                        [
                            287,
                            422
                        ],
                        [
                            422,
                            432
                        ],
                        [
                            290,
                            250
                        ],
                        [
                            250,
                            328
                        ],
                        [
                            328,
                            290
                        ],
                        [
                            385,
                            258
                        ],
                        [
                            258,
                            384
                        ],
                        [
                            384,
                            385
                        ],
                        [
                            446,
                            265
                        ],
                        [
                            265,
                            342
                        ],
                        [
                            342,
                            446
                        ],
                        [
                            386,
                            387
                        ],
                        [
                            387,
                            257
                        ],
                        [
                            257,
                            386
                        ],
                        [
                            422,
                            424
                        ],
                        [
                            424,
                            430
                        ],
                        [
                            430,
                            422
                        ],
                        [
                            445,
                            342
                        ],
                        [
                            342,
                            276
                        ],
                        [
                            276,
                            445
                        ],
                        [
                            422,
                            273
                        ],
                        [
                            273,
                            424
                        ],
                        [
                            424,
                            422
                        ],
                        [
                            306,
                            292
                        ],
                        [
                            292,
                            307
                        ],
                        [
                            307,
                            306
                        ],
                        [
                            352,
                            366
                        ],
                        [
                            366,
                            345
                        ],
                        [
                            345,
                            352
                        ],
                        [
                            268,
                            271
                        ],
                        [
                            271,
                            302
                        ],
                        [
                            302,
                            268
                        ],
                        [
                            358,
                            423
                        ],
                        [
                            423,
                            371
                        ],
                        [
                            371,
                            358
                        ],
                        [
                            327,
                            294
                        ],
                        [
                            294,
                            460
                        ],
                        [
                            460,
                            327
                        ],
                        [
                            331,
                            279
                        ],
                        [
                            279,
                            294
                        ],
                        [
                            294,
                            331
                        ],
                        [
                            303,
                            271
                        ],
                        [
                            271,
                            304
                        ],
                        [
                            304,
                            303
                        ],
                        [
                            436,
                            432
                        ],
                        [
                            432,
                            427
                        ],
                        [
                            427,
                            436
                        ],
                        [
                            304,
                            272
                        ],
                        [
                            272,
                            408
                        ],
                        [
                            408,
                            304
                        ],
                        [
                            395,
                            394
                        ],
                        [
                            394,
                            431
                        ],
                        [
                            431,
                            395
                        ],
                        [
                            378,
                            395
                        ],
                        [
                            395,
                            400
                        ],
                        [
                            400,
                            378
                        ],
                        [
                            296,
                            334
                        ],
                        [
                            334,
                            299
                        ],
                        [
                            299,
                            296
                        ],
                        [
                            6,
                            351
                        ],
                        [
                            351,
                            168
                        ],
                        [
                            168,
                            6
                        ],
                        [
                            376,
                            352
                        ],
                        [
                            352,
                            411
                        ],
                        [
                            411,
                            376
                        ],
                        [
                            307,
                            325
                        ],
                        [
                            325,
                            320
                        ],
                        [
                            320,
                            307
                        ],
                        [
                            285,
                            295
                        ],
                        [
                            295,
                            336
                        ],
                        [
                            336,
                            285
                        ],
                        [
                            320,
                            319
                        ],
                        [
                            319,
                            404
                        ],
                        [
                            404,
                            320
                        ],
                        [
                            329,
                            330
                        ],
                        [
                            330,
                            349
                        ],
                        [
                            349,
                            329
                        ],
                        [
                            334,
                            293
                        ],
                        [
                            293,
                            333
                        ],
                        [
                            333,
                            334
                        ],
                        [
                            366,
                            323
                        ],
                        [
                            323,
                            447
                        ],
                        [
                            447,
                            366
                        ],
                        [
                            316,
                            15
                        ],
                        [
                            15,
                            315
                        ],
                        [
                            315,
                            316
                        ],
                        [
                            331,
                            358
                        ],
                        [
                            358,
                            279
                        ],
                        [
                            279,
                            331
                        ],
                        [
                            317,
                            14
                        ],
                        [
                            14,
                            316
                        ],
                        [
                            316,
                            317
                        ],
                        [
                            8,
                            285
                        ],
                        [
                            285,
                            9
                        ],
                        [
                            9,
                            8
                        ],
                        [
                            277,
                            329
                        ],
                        [
                            329,
                            350
                        ],
                        [
                            350,
                            277
                        ],
                        [
                            253,
                            374
                        ],
                        [
                            374,
                            252
                        ],
                        [
                            252,
                            253
                        ],
                        [
                            319,
                            318
                        ],
                        [
                            318,
                            403
                        ],
                        [
                            403,
                            319
                        ],
                        [
                            351,
                            6
                        ],
                        [
                            6,
                            419
                        ],
                        [
                            419,
                            351
                        ],
                        [
                            324,
                            318
                        ],
                        [
                            318,
                            325
                        ],
                        [
                            325,
                            324
                        ],
                        [
                            397,
                            367
                        ],
                        [
                            367,
                            365
                        ],
                        [
                            365,
                            397
                        ],
                        [
                            288,
                            435
                        ],
                        [
                            435,
                            397
                        ],
                        [
                            397,
                            288
                        ],
                        [
                            278,
                            344
                        ],
                        [
                            344,
                            439
                        ],
                        [
                            439,
                            278
                        ],
                        [
                            310,
                            272
                        ],
                        [
                            272,
                            311
                        ],
                        [
                            311,
                            310
                        ],
                        [
                            248,
                            195
                        ],
                        [
                            195,
                            281
                        ],
                        [
                            281,
                            248
                        ],
                        [
                            375,
                            273
                        ],
                        [
                            273,
                            291
                        ],
                        [
                            291,
                            375
                        ],
                        [
                            175,
                            396
                        ],
                        [
                            396,
                            199
                        ],
                        [
                            199,
                            175
                        ],
                        [
                            312,
                            311
                        ],
                        [
                            311,
                            268
                        ],
                        [
                            268,
                            312
                        ],
                        [
                            276,
                            283
                        ],
                        [
                            283,
                            445
                        ],
                        [
                            445,
                            276
                        ],
                        [
                            390,
                            373
                        ],
                        [
                            373,
                            339
                        ],
                        [
                            339,
                            390
                        ],
                        [
                            295,
                            282
                        ],
                        [
                            282,
                            296
                        ],
                        [
                            296,
                            295
                        ],
                        [
                            448,
                            449
                        ],
                        [
                            449,
                            346
                        ],
                        [
                            346,
                            448
                        ],
                        [
                            356,
                            264
                        ],
                        [
                            264,
                            454
                        ],
                        [
                            454,
                            356
                        ],
                        [
                            337,
                            336
                        ],
                        [
                            336,
                            299
                        ],
                        [
                            299,
                            337
                        ],
                        [
                            337,
                            338
                        ],
                        [
                            338,
                            151
                        ],
                        [
                            151,
                            337
                        ],
                        [
                            294,
                            278
                        ],
                        [
                            278,
                            455
                        ],
                        [
                            455,
                            294
                        ],
                        [
                            308,
                            292
                        ],
                        [
                            292,
                            415
                        ],
                        [
                            415,
                            308
                        ],
                        [
                            429,
                            358
                        ],
                        [
                            358,
                            355
                        ],
                        [
                            355,
                            429
                        ],
                        [
                            265,
                            340
                        ],
                        [
                            340,
                            372
                        ],
                        [
                            372,
                            265
                        ],
                        [
                            352,
                            346
                        ],
                        [
                            346,
                            280
                        ],
                        [
                            280,
                            352
                        ],
                        [
                            295,
                            442
                        ],
                        [
                            442,
                            282
                        ],
                        [
                            282,
                            295
                        ],
                        [
                            354,
                            19
                        ],
                        [
                            19,
                            370
                        ],
                        [
                            370,
                            354
                        ],
                        [
                            285,
                            441
                        ],
                        [
                            441,
                            295
                        ],
                        [
                            295,
                            285
                        ],
                        [
                            195,
                            248
                        ],
                        [
                            248,
                            197
                        ],
                        [
                            197,
                            195
                        ],
                        [
                            457,
                            440
                        ],
                        [
                            440,
                            274
                        ],
                        [
                            274,
                            457
                        ],
                        [
                            301,
                            300
                        ],
                        [
                            300,
                            368
                        ],
                        [
                            368,
                            301
                        ],
                        [
                            417,
                            351
                        ],
                        [
                            351,
                            465
                        ],
                        [
                            465,
                            417
                        ],
                        [
                            251,
                            301
                        ],
                        [
                            301,
                            389
                        ],
                        [
                            389,
                            251
                        ],
                        [
                            394,
                            395
                        ],
                        [
                            395,
                            379
                        ],
                        [
                            379,
                            394
                        ],
                        [
                            399,
                            412
                        ],
                        [
                            412,
                            419
                        ],
                        [
                            419,
                            399
                        ],
                        [
                            410,
                            436
                        ],
                        [
                            436,
                            322
                        ],
                        [
                            322,
                            410
                        ],
                        [
                            326,
                            2
                        ],
                        [
                            2,
                            393
                        ],
                        [
                            393,
                            326
                        ],
                        [
                            354,
                            370
                        ],
                        [
                            370,
                            461
                        ],
                        [
                            461,
                            354
                        ],
                        [
                            393,
                            164
                        ],
                        [
                            164,
                            267
                        ],
                        [
                            267,
                            393
                        ],
                        [
                            268,
                            302
                        ],
                        [
                            302,
                            12
                        ],
                        [
                            12,
                            268
                        ],
                        [
                            312,
                            268
                        ],
                        [
                            268,
                            13
                        ],
                        [
                            13,
                            312
                        ],
                        [
                            298,
                            293
                        ],
                        [
                            293,
                            301
                        ],
                        [
                            301,
                            298
                        ],
                        [
                            265,
                            446
                        ],
                        [
                            446,
                            340
                        ],
                        [
                            340,
                            265
                        ],
                        [
                            280,
                            330
                        ],
                        [
                            330,
                            425
                        ],
                        [
                            425,
                            280
                        ],
                        [
                            322,
                            426
                        ],
                        [
                            426,
                            391
                        ],
                        [
                            391,
                            322
                        ],
                        [
                            420,
                            429
                        ],
                        [
                            429,
                            437
                        ],
                        [
                            437,
                            420
                        ],
                        [
                            393,
                            391
                        ],
                        [
                            391,
                            326
                        ],
                        [
                            326,
                            393
                        ],
                        [
                            344,
                            440
                        ],
                        [
                            440,
                            438
                        ],
                        [
                            438,
                            344
                        ],
                        [
                            458,
                            459
                        ],
                        [
                            459,
                            461
                        ],
                        [
                            461,
                            458
                        ],
                        [
                            364,
                            434
                        ],
                        [
                            434,
                            394
                        ],
                        [
                            394,
                            364
                        ],
                        [
                            428,
                            396
                        ],
                        [
                            396,
                            262
                        ],
                        [
                            262,
                            428
                        ],
                        [
                            274,
                            354
                        ],
                        [
                            354,
                            457
                        ],
                        [
                            457,
                            274
                        ],
                        [
                            317,
                            316
                        ],
                        [
                            316,
                            402
                        ],
                        [
                            402,
                            317
                        ],
                        [
                            316,
                            315
                        ],
                        [
                            315,
                            403
                        ],
                        [
                            403,
                            316
                        ],
                        [
                            315,
                            314
                        ],
                        [
                            314,
                            404
                        ],
                        [
                            404,
                            315
                        ],
                        [
                            314,
                            313
                        ],
                        [
                            313,
                            405
                        ],
                        [
                            405,
                            314
                        ],
                        [
                            313,
                            421
                        ],
                        [
                            421,
                            406
                        ],
                        [
                            406,
                            313
                        ],
                        [
                            323,
                            366
                        ],
                        [
                            366,
                            361
                        ],
                        [
                            361,
                            323
                        ],
                        [
                            292,
                            306
                        ],
                        [
                            306,
                            407
                        ],
                        [
                            407,
                            292
                        ],
                        [
                            306,
                            291
                        ],
                        [
                            291,
                            408
                        ],
                        [
                            408,
                            306
                        ],
                        [
                            291,
                            287
                        ],
                        [
                            287,
                            409
                        ],
                        [
                            409,
                            291
                        ],
                        [
                            287,
                            432
                        ],
                        [
                            432,
                            410
                        ],
                        [
                            410,
                            287
                        ],
                        [
                            427,
                            434
                        ],
                        [
                            434,
                            411
                        ],
                        [
                            411,
                            427
                        ],
                        [
                            372,
                            264
                        ],
                        [
                            264,
                            383
                        ],
                        [
                            383,
                            372
                        ],
                        [
                            459,
                            309
                        ],
                        [
                            309,
                            457
                        ],
                        [
                            457,
                            459
                        ],
                        [
                            366,
                            352
                        ],
                        [
                            352,
                            401
                        ],
                        [
                            401,
                            366
                        ],
                        [
                            1,
                            274
                        ],
                        [
                            274,
                            4
                        ],
                        [
                            4,
                            1
                        ],
                        [
                            418,
                            421
                        ],
                        [
                            421,
                            262
                        ],
                        [
                            262,
                            418
                        ],
                        [
                            331,
                            294
                        ],
                        [
                            294,
                            358
                        ],
                        [
                            358,
                            331
                        ],
                        [
                            435,
                            433
                        ],
                        [
                            433,
                            367
                        ],
                        [
                            367,
                            435
                        ],
                        [
                            392,
                            289
                        ],
                        [
                            289,
                            439
                        ],
                        [
                            439,
                            392
                        ],
                        [
                            328,
                            462
                        ],
                        [
                            462,
                            326
                        ],
                        [
                            326,
                            328
                        ],
                        [
                            94,
                            2
                        ],
                        [
                            2,
                            370
                        ],
                        [
                            370,
                            94
                        ],
                        [
                            289,
                            305
                        ],
                        [
                            305,
                            455
                        ],
                        [
                            455,
                            289
                        ],
                        [
                            339,
                            254
                        ],
                        [
                            254,
                            448
                        ],
                        [
                            448,
                            339
                        ],
                        [
                            359,
                            255
                        ],
                        [
                            255,
                            446
                        ],
                        [
                            446,
                            359
                        ],
                        [
                            254,
                            253
                        ],
                        [
                            253,
                            449
                        ],
                        [
                            449,
                            254
                        ],
                        [
                            253,
                            252
                        ],
                        [
                            252,
                            450
                        ],
                        [
                            450,
                            253
                        ],
                        [
                            252,
                            256
                        ],
                        [
                            256,
                            451
                        ],
                        [
                            451,
                            252
                        ],
                        [
                            256,
                            341
                        ],
                        [
                            341,
                            452
                        ],
                        [
                            452,
                            256
                        ],
                        [
                            414,
                            413
                        ],
                        [
                            413,
                            463
                        ],
                        [
                            463,
                            414
                        ],
                        [
                            286,
                            441
                        ],
                        [
                            441,
                            414
                        ],
                        [
                            414,
                            286
                        ],
                        [
                            286,
                            258
                        ],
                        [
                            258,
                            441
                        ],
                        [
                            441,
                            286
                        ],
                        [
                            258,
                            257
                        ],
                        [
                            257,
                            442
                        ],
                        [
                            442,
                            258
                        ],
                        [
                            257,
                            259
                        ],
                        [
                            259,
                            443
                        ],
                        [
                            443,
                            257
                        ],
                        [
                            259,
                            260
                        ],
                        [
                            260,
                            444
                        ],
                        [
                            444,
                            259
                        ],
                        [
                            260,
                            467
                        ],
                        [
                            467,
                            445
                        ],
                        [
                            445,
                            260
                        ],
                        [
                            309,
                            459
                        ],
                        [
                            459,
                            250
                        ],
                        [
                            250,
                            309
                        ],
                        [
                            305,
                            289
                        ],
                        [
                            289,
                            290
                        ],
                        [
                            290,
                            305
                        ],
                        [
                            305,
                            290
                        ],
                        [
                            290,
                            460
                        ],
                        [
                            460,
                            305
                        ],
                        [
                            401,
                            376
                        ],
                        [
                            376,
                            435
                        ],
                        [
                            435,
                            401
                        ],
                        [
                            309,
                            250
                        ],
                        [
                            250,
                            392
                        ],
                        [
                            392,
                            309
                        ],
                        [
                            376,
                            411
                        ],
                        [
                            411,
                            433
                        ],
                        [
                            433,
                            376
                        ],
                        [
                            453,
                            341
                        ],
                        [
                            341,
                            464
                        ],
                        [
                            464,
                            453
                        ],
                        [
                            357,
                            453
                        ],
                        [
                            453,
                            465
                        ],
                        [
                            465,
                            357
                        ],
                        [
                            343,
                            357
                        ],
                        [
                            357,
                            412
                        ],
                        [
                            412,
                            343
                        ],
                        [
                            437,
                            343
                        ],
                        [
                            343,
                            399
                        ],
                        [
                            399,
                            437
                        ],
                        [
                            344,
                            360
                        ],
                        [
                            360,
                            440
                        ],
                        [
                            440,
                            344
                        ],
                        [
                            420,
                            437
                        ],
                        [
                            437,
                            456
                        ],
                        [
                            456,
                            420
                        ],
                        [
                            360,
                            420
                        ],
                        [
                            420,
                            363
                        ],
                        [
                            363,
                            360
                        ],
                        [
                            361,
                            401
                        ],
                        [
                            401,
                            288
                        ],
                        [
                            288,
                            361
                        ],
                        [
                            265,
                            372
                        ],
                        [
                            372,
                            353
                        ],
                        [
                            353,
                            265
                        ],
                        [
                            390,
                            339
                        ],
                        [
                            339,
                            249
                        ],
                        [
                            249,
                            390
                        ],
                        [
                            339,
                            448
                        ],
                        [
                            448,
                            255
                        ],
                        [
                            255,
                            339
                        ]
                    ]);
                    P("matrixDataToMatrix", function(a) {
                        for(var b = a.getCols(), c = a.getRows(), d = a.getPackedDataList(), e = [], g = 0; g < c; g++)e.push(Array(b));
                        for(g = 0; g < c; g++)for(var f = 0; f < b; f++){
                            var h = a.getLayout() === 1 ? g * b + f : f * c + g;
                            e[g][f] = d[h];
                        }
                        return e;
                    });
                    P("VERSION", "0.4.1633559619");
                }).call(VonageFacemash);
                const VonageObjectron = {};
                (function() {
                    var v;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var y = ca(this);
                    function z(a, b) {
                        if (b) a: {
                            var c = y;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    z("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    z("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = y[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function A(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function ea(a) {
                        if (!(a instanceof Array)) {
                            a = A(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var fa = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, ha;
                    if (typeof Object.setPrototypeOf == "function") ha = Object.setPrototypeOf;
                    else {
                        var ia;
                        a: {
                            var ja = {
                                a: true
                            }, ka = {};
                            try {
                                ka.__proto__ = ja;
                                ia = ka.a;
                                break a;
                            } catch (a) {}
                            ia = false;
                        }
                        ha = ia ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var la = ha;
                    function C(a, b) {
                        a.prototype = fa(b.prototype);
                        a.prototype.constructor = a;
                        if (la) la(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.ka = b.prototype;
                    }
                    function ma() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.s = this.m = 0;
                        this.j = null;
                    }
                    function na(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    ma.prototype.o = function(a) {
                        this.h = a;
                    };
                    function oa(a, b) {
                        a.j = {
                            V: b,
                            X: true
                        };
                        a.g = a.m || a.s;
                    }
                    ma.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.s;
                    };
                    function E(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function pa(a) {
                        this.g = new ma();
                        this.h = a;
                    }
                    function qa(a, b) {
                        na(a.g);
                        var c = a.g.i;
                        if (c) return ra(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return F(a);
                    }
                    function ra(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, oa(a.g, f), F(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return F(a);
                    }
                    function F(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, oa(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.X) throw b.V;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function sa(a) {
                        this.next = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = F(a));
                            return b;
                        };
                        this.throw = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = F(a));
                            return b;
                        };
                        this.return = function(b) {
                            return qa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function ta(a) {
                        function b(d) {
                            return a.next(d);
                        }
                        function c(d) {
                            return a.throw(d);
                        }
                        return new Promise(function(d, e) {
                            function g(f) {
                                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                            }
                            g(a.next());
                        });
                    }
                    function H(a) {
                        return ta(new sa(new pa(a)));
                    }
                    z("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.o = false;
                            var k = this.j();
                            try {
                                f(k.resolve, k.reject);
                            } catch (h) {
                                k.reject(h);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(k) {
                                k(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var k = this;
                                this.i(function() {
                                    k.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = y.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var k = 0; k < f.length; ++k){
                                    var h = f[k];
                                    f[k] = null;
                                    try {
                                        h();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(p) {
                                    h || (h = true, l.call(k, p));
                                };
                            }
                            var k = this, h = false;
                            return {
                                resolve: f(this.D),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.D = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.G(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var k = f != null;
                                        break a;
                                    case "function":
                                        k = true;
                                        break a;
                                    default:
                                        k = false;
                                }
                                k ? this.A(f) : this.m(f);
                            }
                        };
                        b.prototype.A = function(f) {
                            var k = void 0;
                            try {
                                k = f.then;
                            } catch (h) {
                                this.l(h);
                                return;
                            }
                            typeof k == "function" ? this.H(k, f) : this.m(f);
                        };
                        b.prototype.l = function(f) {
                            this.s(2, f);
                        };
                        b.prototype.m = function(f) {
                            this.s(1, f);
                        };
                        b.prototype.s = function(f, k) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = k;
                            this.h === 2 && this.F();
                            this.B();
                        };
                        b.prototype.F = function() {
                            var f = this;
                            e(function() {
                                if (f.C()) {
                                    var k = y.console;
                                    typeof k !== "undefined" && k.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.C = function() {
                            if (this.o) return false;
                            var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
                            if (typeof h === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof k === "function" ? f = new k("unhandledrejection", {
                                cancelable: true
                            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return h(f);
                        };
                        b.prototype.B = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.G = function(f) {
                            var k = this.j();
                            f.K(k.resolve, k.reject);
                        };
                        b.prototype.H = function(f, k) {
                            var h = this.j();
                            try {
                                f.call(k, h.resolve, h.reject);
                            } catch (l) {
                                h.reject(l);
                            }
                        };
                        b.prototype.then = function(f, k) {
                            function h(q, m) {
                                return typeof q == "function" ? function(n) {
                                    try {
                                        l(q(n));
                                    } catch (r) {
                                        p(r);
                                    }
                                } : m;
                            }
                            var l, p, t = new b(function(q, m) {
                                l = q;
                                p = m;
                            });
                            this.K(h(f, l), h(k, p));
                            return t;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.K = function(f, k) {
                            function h() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        k(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(h) : this.g.push(h);
                            this.o = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(k, h) {
                                h(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(k, h) {
                                for(var l = A(f), p = l.next(); !p.done; p = l.next())d(p.value).K(k, h);
                            });
                        };
                        b.all = function(f) {
                            var k = A(f), h = k.next();
                            return h.done ? d([]) : new b(function(l, p) {
                                function t(n) {
                                    return function(r) {
                                        q[n] = r;
                                        m--;
                                        m == 0 && l(q);
                                    };
                                }
                                var q = [], m = 0;
                                do q.push(void 0), m++, d(h.value).K(t(q.length - 1), p), h = k.next();
                                while (!h.done);
                            });
                        };
                        return b;
                    });
                    function ua(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    z("Object.assign", function(a) {
                        return a || va;
                    });
                    z("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    z("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    z("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    z("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ua(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var wa = this || self;
                    function I(a, b) {
                        a = a.split(".");
                        var c = wa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function J(a) {
                        throw a;
                    }
                    function xa(a, b) {
                        J(Error("Invalid wire type: " + a + " (at position " + b + ")"));
                    }
                    function ya() {
                        J(Error("Failed to read varint, encoding is invalid."));
                    }
                    function za(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var Aa, Ba = typeof TextDecoder !== "undefined", Ca, Da = typeof TextEncoder !== "undefined";
                    function Ea(a) {
                        if (Da) a = (Ca || (Ca = new TextEncoder())).encode(a);
                        else {
                            var b = void 0;
                            b = b === void 0 ? false : b;
                            for(var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++){
                                var g = a.charCodeAt(e);
                                if (128 > g) d[c++] = g;
                                else {
                                    if (2048 > g) d[c++] = g >> 6 | 192;
                                    else {
                                        if (55296 <= g && 57343 >= g) {
                                            if (56319 >= g && e < a.length) {
                                                var f = a.charCodeAt(++e);
                                                if (56320 <= f && 57343 >= f) {
                                                    g = 1024 * (g - 55296) + f - 56320 + 65536;
                                                    d[c++] = g >> 18 | 240;
                                                    d[c++] = g >> 12 & 63 | 128;
                                                    d[c++] = g >> 6 & 63 | 128;
                                                    d[c++] = g & 63 | 128;
                                                    continue;
                                                } else e--;
                                            }
                                            if (b) throw Error("Found an unpaired surrogate");
                                            g = 65533;
                                        }
                                        d[c++] = g >> 12 | 224;
                                        d[c++] = g >> 6 & 63 | 128;
                                    }
                                    d[c++] = g & 63 | 128;
                                }
                            }
                            a = d.subarray(0, c);
                        }
                        return a;
                    }
                    var Fa = {}, Ga = null;
                    function Ha(a) {
                        var b;
                        b === void 0 && (b = 0);
                        Ia();
                        b = Fa[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | k >> 4];
                            k = b[(k & 15) << 2 | h >> 6];
                            h = b[h & 63];
                            c[g++] = l + f + k + h;
                        }
                        l = 0;
                        h = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], h = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
                        }
                        return c.join("");
                    }
                    function Ja(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Ka(a, function(g) {
                            d[e++] = g;
                        });
                        return d.subarray(0, e);
                    }
                    function Ka(a, b) {
                        function c(h) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), p = Ga[l];
                                if (p != null) return p;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return h;
                        }
                        Ia();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), k = c(64);
                            if (k === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
                        }
                    }
                    function Ia() {
                        if (!Ga) {
                            Ga = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Fa[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    Ga[g] === void 0 && (Ga[g] = e);
                                }
                            }
                        }
                    }
                    var La = typeof Uint8Array === "function", Ma;
                    function Na(a) {
                        this.g = a;
                        if (a !== null && a.length === 0) throw Error("ByteString should be constructed with non-empty values");
                    }
                    var Oa = typeof Uint8Array.prototype.slice === "function";
                    function Pa(a, b, c) {
                        return b === c ? Ma || (Ma = new Uint8Array(0)) : Oa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
                    }
                    var K = 0, M = 0;
                    function Qa(a) {
                        if (a.constructor === Uint8Array) return a;
                        if (a.constructor === ArrayBuffer) return new Uint8Array(a);
                        if (a.constructor === Array) return new Uint8Array(a);
                        if (a.constructor === String) return Ja(a);
                        if (a.constructor === Na) {
                            if (a.g == null) var b = Ma || (Ma = new Uint8Array(0));
                            else {
                                b = Uint8Array;
                                var c = a.g;
                                c = c == null || La && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? Ja(c) : null;
                                a = a.g = c;
                                b = new b(a);
                            }
                            return b;
                        }
                        if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
                    }
                    function Ra(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.v === void 0 ? false : b.v;
                        this.h = null;
                        this.g = this.i = this.l = 0;
                        this.j = false;
                        this.v = b;
                        a && Sa(this, a);
                    }
                    function Sa(a, b) {
                        a.h = Qa(b);
                        a.l = 0;
                        a.i = a.h.length;
                        a.g = a.l;
                    }
                    Ra.prototype.reset = function() {
                        this.g = this.l;
                    };
                    function Ta(a) {
                        for(var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)b = a.h[a.g++], c |= (b & 127) << 7 * e;
                        128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
                        if (128 <= b) for(e = 0; 5 > e && 128 <= b; e++)b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
                        if (128 > b) {
                            a = c >>> 0;
                            b = d >>> 0;
                            if (d = b & 2147483648) a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
                            a = 4294967296 * b + (a >>> 0);
                            return d ? -a : a;
                        }
                        a.j = true;
                        ya();
                    }
                    function N(a) {
                        a.g > a.i && (a.j = true, J(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
                    }
                    function O(a) {
                        var b = a.h, c = b[a.g], d = c & 127;
                        if (128 > c) return a.g += 1, N(a), d;
                        c = b[a.g + 1];
                        d |= (c & 127) << 7;
                        if (128 > c) return a.g += 2, N(a), d;
                        c = b[a.g + 2];
                        d |= (c & 127) << 14;
                        if (128 > c) return a.g += 3, N(a), d;
                        c = b[a.g + 3];
                        d |= (c & 127) << 21;
                        if (128 > c) return a.g += 4, N(a), d;
                        c = b[a.g + 4];
                        d |= (c & 15) << 28;
                        if (128 > c) return a.g += 5, N(a), d >>> 0;
                        a.g += 5;
                        if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++]) return a.j = true, ya(), d;
                        N(a);
                        return d;
                    }
                    function Ua(a) {
                        var b = a.h[a.g], c = a.h[a.g + 1], d = a.h[a.g + 2], e = a.h[a.g + 3];
                        a.g += 4;
                        N(a);
                        return (b << 0 | c << 8 | d << 16 | e << 24) >>> 0;
                    }
                    Ra.prototype.m = function() {
                        var a = Ua(this), b = 2 * (a >> 31) + 1, c = a >>> 23 & 255;
                        a &= 8388607;
                        return c == 255 ? a ? NaN : Infinity * b : c == 0 ? b * Math.pow(2, -149) * a : b * Math.pow(2, c - 150) * (a + Math.pow(2, 23));
                    };
                    var Va = [];
                    function Wa() {
                        this.g = new Uint8Array(64);
                        this.h = 0;
                    }
                    function P(a, b) {
                        if (!(a.h + 1 < a.g.length)) {
                            var c = a.g;
                            a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
                            a.g.set(c);
                        }
                        a.g[a.h++] = b;
                    }
                    Wa.prototype.length = function() {
                        return this.h;
                    };
                    Wa.prototype.end = function() {
                        var a = this.g, b = this.h;
                        this.h = 0;
                        return Pa(a, 0, b);
                    };
                    function Q(a, b) {
                        for(; 127 < b;)P(a, b & 127 | 128), b >>>= 7;
                        P(a, b);
                    }
                    function Xa(a) {
                        var b = {}, c = b.O === void 0 ? false : b.O;
                        this.m = {
                            v: b.v === void 0 ? false : b.v
                        };
                        this.O = c;
                        b = this.m;
                        Va.length ? (c = Va.pop(), b && (c.v = b.v), a && Sa(c, a), a = c) : a = new Ra(a, b);
                        this.g = a;
                        this.l = this.g.g;
                        this.h = this.i = -1;
                        this.j = false;
                    }
                    Xa.prototype.reset = function() {
                        this.g.reset();
                        this.h = this.i = -1;
                    };
                    function Ya(a) {
                        var b = a.g;
                        (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.j || 0 > b.g || b.g > b.i);
                        if (b) return false;
                        a.l = a.g.g;
                        var c = O(a.g);
                        b = c >>> 3;
                        c &= 7;
                        if (!(0 <= c && 5 >= c)) return a.j = true, xa(c, a.l), false;
                        a.i = b;
                        a.h = c;
                        return true;
                    }
                    function Za(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Za(a);
                                else a: {
                                    a = a.g;
                                    for(var b = a.g, c = 0; 10 > c; c++){
                                        if ((a.h[b] & 128) === 0) {
                                            a.g = b + 1;
                                            N(a);
                                            break a;
                                        }
                                        b++;
                                    }
                                    a.j = true;
                                    ya();
                                }
                                break;
                            case 1:
                                a = a.g;
                                a.g += 8;
                                N(a);
                                break;
                            case 2:
                                a.h != 2 ? Za(a) : (b = O(a.g), a = a.g, a.g += b, N(a));
                                break;
                            case 5:
                                a = a.g;
                                a.g += 4;
                                N(a);
                                break;
                            case 3:
                                b = a.i;
                                do {
                                    if (!Ya(a)) {
                                        a.j = true;
                                        J(Error("Unmatched start-group tag: stream EOF"));
                                        break;
                                    }
                                    if (a.h == 4) {
                                        a.i != b && (a.j = true, J(Error("Unmatched end-group tag")));
                                        break;
                                    }
                                    Za(a);
                                }while (1);
                                break;
                            default:
                                a.j = true, xa(a.h, a.l);
                        }
                    }
                    function $a(a, b, c) {
                        var d = a.g.i, e = O(a.g), g = a.g.g + e;
                        a.g.i = g;
                        c(b, a);
                        c = g - a.g.g;
                        if (c !== 0) throw Error("Message parsing ended unexpectedly. Expected to read " + (e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                        a.g.g = g;
                        a.g.i = d;
                        return b;
                    }
                    var ab = [];
                    function bb() {
                        this.h = [];
                        this.i = 0;
                        this.g = new Wa();
                    }
                    function cb(a, b) {
                        b.length !== 0 && (a.h.push(b), a.i += b.length);
                    }
                    function db(a, b, c) {
                        Q(a.g, 8 * b + 2);
                        Q(a.g, c.length);
                        cb(a, a.g.end());
                        cb(a, c);
                    }
                    var eb = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
                    function fb(a) {
                        Object.isFrozen(a) || (eb ? a[eb] |= 1 : a.g !== void 0 ? a.g |= 1 : Object.defineProperties(a, {
                            g: {
                                value: 1,
                                configurable: true,
                                writable: true,
                                enumerable: false
                            }
                        }));
                        return a;
                    }
                    function gb(a) {
                        return a !== null && typeof a === "object" && a.constructor === Object;
                    }
                    function hb(a) {
                        switch(typeof a){
                            case "number":
                                return isFinite(a) ? a : String(a);
                            case "object":
                                if (La && a != null && a instanceof Uint8Array) return Ha(a);
                                if (a instanceof Na) {
                                    if (a.g == null) a = "";
                                    else {
                                        var b = a.g;
                                        b = b == null || typeof b === "string" ? b : La && b instanceof Uint8Array ? Ha(b) : null;
                                        a = a.g = b;
                                    }
                                    return a;
                                }
                        }
                        return a;
                    }
                    function ib(a, b) {
                        if (a != null) return Array.isArray(a) || gb(a) ? jb(a, b) : b(a);
                    }
                    function jb(a, b) {
                        if (Array.isArray(a)) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = ib(a[d], b);
                            if (b = Array.isArray(a)) {
                                var e;
                                eb ? e = a[eb] : e = a.g;
                                b = (e == null ? 0 : e) & 1;
                            }
                            b && fb(c);
                            return c;
                        }
                        e = {};
                        for(c in a)e[c] = ib(a[c], b);
                        return e;
                    }
                    function kb(a) {
                        a = hb(a);
                        return Array.isArray(a) ? jb(a, kb) : a;
                    }
                    var lb;
                    function R(a, b, c) {
                        var d = lb;
                        lb = null;
                        a || (a = d);
                        d = this.constructor.ha;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.i = (d ? 0 : -1) - (this.constructor.fa || 0);
                        this.l = this.g = null;
                        this.u = a;
                        a: {
                            d = this.u.length;
                            a = d - 1;
                            if (d && (d = this.u[a], gb(d))) {
                                this.j = a - this.i;
                                this.h = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.j = Math.max(b, a + 1 - this.i), this.h = null) : this.j = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)a = c[b], a < this.j ? (a += this.i, (d = this.u[a]) ? Array.isArray(d) && fb(d) : this.u[a] = mb) : (nb(this), (d = this.h[a]) ? Array.isArray(d) && fb(d) : this.h[a] = mb);
                    }
                    var mb = Object.freeze(fb([]));
                    function nb(a) {
                        var b = a.j + a.i;
                        a.u[b] || (a.h = a.u[b] = {});
                    }
                    function S(a, b, c) {
                        return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.j ? a.h ? a.h[b] : void 0 : a.u[b + a.i];
                    }
                    function ob(a, b, c) {
                        c = c === void 0 ? false : c;
                        var d = S(a, b, c);
                        d == null && (d = mb);
                        d === mb && (d = fb(d.slice()), T(a, b, d, c));
                        return d;
                    }
                    function pb(a, b) {
                        var c = ob(a, b);
                        a.l || (a.l = {});
                        if (!a.l[b]) {
                            for(var d = 0; d < c.length; d++)c[d] = +c[d];
                            a.l[b] = true;
                        }
                        return c;
                    }
                    function V(a, b, c) {
                        a = S(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function T(a, b, c, d) {
                        (d === void 0 ? 0 : d) || b >= a.j ? (nb(a), a.h[b] = c) : a.u[b + a.i] = c;
                    }
                    function qb(a, b, c, d) {
                        c !== d ? T(a, b, c) : T(a, b, void 0, false);
                    }
                    function rb(a, b, c) {
                        if (c === -1) return null;
                        a.g || (a.g = {});
                        var d = a.g[c];
                        if (d) return d;
                        var e = S(a, c, false);
                        if (e == null) return d;
                        b = new b(e);
                        return a.g[c] = b;
                    }
                    function sb(a, b, c) {
                        a.g || (a.g = {});
                        var d = a.g[c];
                        if (!d) {
                            var e = ob(a, c, false);
                            d = [];
                            for(var g = 0; g < e.length; g++)d[g] = new b(e[g]);
                            a.g[c] = d;
                        }
                        return d;
                    }
                    function tb(a, b, c, d, e) {
                        var g = sb(a, d, b);
                        c = c ? c : new d();
                        a = ob(a, b);
                        e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.u)) : (g.push(c), a.push(c.u));
                    }
                    R.prototype.toJSON = function() {
                        return jb(this.u, kb);
                    };
                    R.prototype.toString = function() {
                        return this.u.toString();
                    };
                    function ub(a, b) {
                        a = S(a, b);
                        return a == null ? 0 : a;
                    }
                    function vb(a, b) {
                        a = S(a, b);
                        return a == null ? "" : a;
                    }
                    function wb(a, b) {
                        if (a = a.m) {
                            cb(b, b.g.end());
                            for(var c = 0; c < a.length; c++)cb(b, a[c]);
                        }
                    }
                    var xb = Symbol();
                    function yb(a, b, c) {
                        return a[xb] || (a[xb] = function(d, e) {
                            return b(d, e, c);
                        });
                    }
                    function zb(a) {
                        var b = a[xb];
                        if (!b) {
                            var c = a[Ab] || (a[Ab] = a());
                            b = function(d, e) {
                                return Bb(d, e, c);
                            };
                            a[xb] = b;
                        }
                        return b;
                    }
                    function Cb(a) {
                        var b = a.da;
                        if (b) return zb(b);
                        if (b = a.ia) {
                            var c = a.Y;
                            delete a.Y;
                            return yb(a.W.g, b, c);
                        }
                    }
                    function Db(a) {
                        var b = Cb(a), c = a.W, d = a.ea;
                        return b ? function(e, g) {
                            return d(e, g, c, b);
                        } : function(e, g) {
                            return d(e, g, c);
                        };
                    }
                    function Eb(a) {
                        var b = a[0];
                        switch(a.length){
                            case 2:
                                var c = a[1];
                                return function(m, n, r) {
                                    return b(m, n, r, c);
                                };
                            case 3:
                                var d = a[1], e = zb(a[2]);
                                return function(m, n, r) {
                                    return b(m, n, r, d, e);
                                };
                            case 4:
                                var g = a[1], f = a[3], k = zb(a[2]);
                                return function(m, n, r) {
                                    return b(m, n, r, g, k, f);
                                };
                            case 5:
                                var h = a[1], l = yb(h, a[3], a[4]);
                                return function(m, n, r) {
                                    return b(m, n, r, h, l);
                                };
                            case 6:
                                var p = a[1], t = a[5], q = yb(p, a[3], a[4]);
                                return function(m, n, r) {
                                    return b(m, n, r, p, q, t);
                                };
                            default:
                                throw Error("Unsupported number of parameters, expected [2-6], got " + a.length);
                        }
                    }
                    var Ab = Symbol();
                    function Bb(a, b, c) {
                        for(; Ya(b) && b.h != 4;){
                            var d = b.i, e = c[d];
                            if (e) Array.isArray(e) && (e = c[d] = Eb(e));
                            else {
                                var g = c[0];
                                g && (g = g[d]) && (e = c[d] = Db(g));
                            }
                            e && e(b, a, d) || (e = b, d = a, g = e.l, Za(e), e.O || (e = Pa(e.g.h, g, e.g.g), (g = d.m) ? g.push(e) : d.m = [
                                e
                            ]));
                        }
                        return a;
                    }
                    function Fb(a, b) {
                        var c = new bb();
                        b(a, c);
                        a = c.i + c.g.length();
                        if (a === 0) c = new Uint8Array(0);
                        else {
                            a = new Uint8Array(a);
                            for(var d = c.h, e = d.length, g = b = 0; g < e; g++){
                                var f = d[g];
                                f.length !== 0 && (a.set(f, b), b += f.length);
                            }
                            d = c.g;
                            e = d.h;
                            e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
                            c.h = [
                                a
                            ];
                            c = a;
                        }
                        return c;
                    }
                    function Gb(a, b, c) {
                        if (ab.length) {
                            var d = ab.pop();
                            a && (Sa(d.g, a), d.i = -1, d.h = -1);
                            a = d;
                        } else a = new Xa(a);
                        try {
                            var e = new b();
                            return Bb(e, a, c[Ab] || (c[Ab] = c()));
                        } finally{
                            b = a.g, b.h = null, b.l = 0, b.i = 0, b.g = 0, b.j = false, b.v = false, a.i = -1, a.h = -1, a.j = false, 100 > ab.length && ab.push(a);
                        }
                    }
                    function W(a, b, c) {
                        b = S(b, c);
                        if (b != null) {
                            Q(a.g, 8 * c + 5);
                            a = a.g;
                            var d = b;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? K = M = 0 : (M = 0, K = 2147483648) : isNaN(d) ? (M = 0, K = 2147483647) : 34028234663852886e22 < d ? (M = 0, K = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), M = 0, K = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, M = 0, K = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = K;
                            P(a, c >>> 0 & 255);
                            P(a, c >>> 8 & 255);
                            P(a, c >>> 16 & 255);
                            P(a, c >>> 24 & 255);
                        }
                    }
                    function Hb(a, b, c) {
                        if (a.h !== 1) return false;
                        var d = a.g;
                        a = Ua(d);
                        var e = Ua(d);
                        d = 2 * (e >> 31) + 1;
                        var g = e >>> 20 & 2047;
                        a = 4294967296 * (e & 1048575) + a;
                        qb(b, c, g == 2047 ? a ? NaN : Infinity * d : g == 0 ? d * Math.pow(2, -1074) * a : d * Math.pow(2, g - 1075) * (a + 4503599627370496), 0);
                        return true;
                    }
                    function X(a, b, c) {
                        if (a.h !== 5) return false;
                        T(b, c, a.g.m());
                        return true;
                    }
                    function Y(a, b, c) {
                        if (a.h !== 5 && a.h !== 2) return false;
                        b = ob(b, c);
                        if (a.h == 2) {
                            c = Ra.prototype.m;
                            var d = O(a.g);
                            for(d = a.g.g + d; a.g.g < d;)b.push(c.call(a.g));
                        } else b.push(a.g.m());
                        return true;
                    }
                    function Z(a, b, c) {
                        if (a.h !== 5) return false;
                        a = a.g.m();
                        qb(b, c, a, 0);
                        return true;
                    }
                    function Ib(a, b, c) {
                        if (a.h !== 0) return false;
                        T(b, c, Ta(a.g));
                        return true;
                    }
                    function Jb(a, b, c) {
                        if (a.h !== 0) return false;
                        T(b, c, O(a.g));
                        return true;
                    }
                    function Kb(a, b, c) {
                        if (a.h !== 0) return false;
                        a = O(a.g);
                        qb(b, c, a, 0);
                        return true;
                    }
                    function Lb(a, b, c) {
                        if (a.h !== 0) return false;
                        a = !!O(a.g);
                        qb(b, c, a, false);
                        return true;
                    }
                    function Mb(a, b, c) {
                        if (a.h !== 2) return false;
                        var d = O(a.g);
                        a = a.g;
                        var e = a.g;
                        a.g += d;
                        N(a);
                        a = a.h;
                        var g;
                        if (Ba) (g = Aa) || (g = Aa = new TextDecoder("utf-8", {
                            fatal: false
                        })), g = g.decode(a.subarray(e, e + d));
                        else {
                            d = e + d;
                            for(var f = [], k = null, h, l, p; e < d;)h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((p = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | p & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = za(k, f), f.length = 0);
                            g = za(k, f);
                        }
                        T(b, c, g);
                        return true;
                    }
                    function Nb(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        a = $a(a, new d(), e);
                        b.g || (b.g = {});
                        d = a ? a.u : a;
                        b.g[c] = a;
                        T(b, c, d, false);
                        return true;
                    }
                    function Ob(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        a = $a(a, new d(), e);
                        tb(b, c, a, d, void 0);
                        return true;
                    }
                    function Pb(a, b, c) {
                        if (a.h !== 0) return false;
                        T(b, c, Ta(a.g));
                        return true;
                    }
                    function Qb(a) {
                        R.call(this, a);
                    }
                    C(Qb, R);
                    function Rb() {
                        return {
                            1: Jb,
                            2: X,
                            3: Mb,
                            4: Mb
                        };
                    }
                    function Sb(a, b) {
                        var c = S(a, 1);
                        if (c != null && c != null) {
                            Q(b.g, 8);
                            var d = b.g;
                            if (0 <= c) Q(d, c);
                            else {
                                for(var e = 0; 9 > e; e++)P(d, c & 127 | 128), c >>= 7;
                                P(d, 1);
                            }
                        }
                        W(b, a, 2);
                        d = S(a, 3);
                        d != null && db(b, 3, Ea(d));
                        d = S(a, 4);
                        d != null && db(b, 4, Ea(d));
                        wb(a, b);
                    }
                    function Tb(a) {
                        R.call(this, a, -1, Ub);
                    }
                    C(Tb, R);
                    Tb.prototype.addClassification = function(a, b) {
                        tb(this, 1, a, Qb, b);
                        return this;
                    };
                    function Vb() {
                        return {
                            1: [
                                Ob,
                                Qb,
                                Rb
                            ]
                        };
                    }
                    var Ub = [
                        1
                    ];
                    function Wb(a) {
                        R.call(this, a);
                    }
                    C(Wb, R);
                    function Xb() {
                        return {
                            1: X,
                            2: X,
                            3: X,
                            4: X,
                            5: X
                        };
                    }
                    function Yb(a, b) {
                        W(b, a, 1);
                        W(b, a, 2);
                        W(b, a, 3);
                        W(b, a, 4);
                        W(b, a, 5);
                        wb(a, b);
                    }
                    function Zb(a) {
                        R.call(this, a, -1, $b);
                    }
                    C(Zb, R);
                    function ac() {
                        return {
                            1: [
                                Ob,
                                Wb,
                                Xb
                            ]
                        };
                    }
                    var $b = [
                        1
                    ];
                    function bc(a) {
                        R.call(this, a);
                    }
                    C(bc, R);
                    function cc() {
                        return {
                            1: X,
                            2: X,
                            3: X,
                            4: X,
                            5: X,
                            6: Ib
                        };
                    }
                    function dc(a, b) {
                        W(b, a, 1);
                        W(b, a, 2);
                        W(b, a, 3);
                        W(b, a, 4);
                        W(b, a, 5);
                        var c = S(a, 6);
                        if (c != null && c != null) {
                            Q(b.g, 48);
                            var d = b.g, e = c;
                            c = 0 > e;
                            e = Math.abs(e);
                            var g = e >>> 0;
                            e = Math.floor((e - g) / 4294967296);
                            e >>>= 0;
                            c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
                            K = g;
                            M = e;
                            c = K;
                            for(g = M; 0 < g || 127 < c;)P(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
                            P(d, c);
                        }
                        wb(a, b);
                    }
                    function ec(a) {
                        R.call(this, a, -1, fc);
                    }
                    C(ec, R);
                    function gc() {
                        return {
                            1: Pb,
                            2: Pb,
                            3: Y,
                            4: [
                                Nb,
                                hc,
                                ic
                            ],
                            5: Jb,
                            6: Jb,
                            7: Y,
                            8: Y,
                            9: Y
                        };
                    }
                    function hc(a) {
                        R.call(this, a);
                    }
                    C(hc, R);
                    function ic() {
                        return {
                            1: X,
                            2: X,
                            3: X
                        };
                    }
                    var fc = [
                        3,
                        7,
                        8,
                        9
                    ];
                    function jc(a) {
                        R.call(this, a);
                    }
                    C(jc, R);
                    function kc() {
                        return {
                            1: Z,
                            2: Z,
                            3: Z
                        };
                    }
                    function lc(a) {
                        R.call(this, a);
                    }
                    C(lc, R);
                    function mc() {
                        return {
                            1: Z,
                            2: Z,
                            3: Z
                        };
                    }
                    function nc(a) {
                        R.call(this, a);
                    }
                    C(nc, R);
                    function oc() {
                        return {
                            1: Kb,
                            2: [
                                Nb,
                                lc,
                                mc
                            ],
                            3: [
                                Nb,
                                jc,
                                kc
                            ],
                            4: Lb
                        };
                    }
                    function pc(a) {
                        R.call(this, a, -1, qc);
                    }
                    C(pc, R);
                    function rc() {
                        return {
                            1: Kb,
                            2: [
                                Ob,
                                nc,
                                oc
                            ],
                            3: Z,
                            4: Y,
                            5: Y,
                            6: Y
                        };
                    }
                    var qc = [
                        2,
                        4,
                        5,
                        6
                    ];
                    function sc(a) {
                        R.call(this, a, -1, tc);
                    }
                    C(sc, R);
                    function uc() {
                        return {
                            1: Kb,
                            2: [
                                Ob,
                                pc,
                                rc
                            ],
                            3: [
                                Nb,
                                ec,
                                gc
                            ],
                            4: Hb,
                            5: Y,
                            6: Y
                        };
                    }
                    var tc = [
                        2,
                        5,
                        6
                    ];
                    function vc(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function wc(a) {
                        return sb(a, Qb, 1).map(function(b) {
                            return {
                                index: ub(b, 1),
                                $: V(b, 2),
                                label: S(b, 3) != null ? vb(b, 3) : void 0,
                                displayName: S(b, 4) != null ? vb(b, 4) : void 0
                            };
                        });
                    }
                    function xc(a) {
                        return {
                            x: V(a, 1),
                            y: V(a, 2),
                            z: V(a, 3),
                            visibility: S(a, 4) != null ? V(a, 4) : void 0
                        };
                    }
                    function yc(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function zc(a, b, c) {
                        Ac(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function Ac(a, b) {
                        var c = a.g;
                        if (a.m === void 0) {
                            var d = vc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = vc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.m = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                J: c.getAttribLocation(d, "aVertex"),
                                I: c.getAttribLocation(d, "aTex"),
                                ja: e
                            };
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.J);
                            c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.o = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.o);
                            c.enableVertexAttribArray(a.j.I);
                            c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.m);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.J);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, a.o);
                        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.J);
                        c.disableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function Bc(a) {
                        this.g = a;
                    }
                    var Cc = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function Dc(a, b) {
                        return b + a;
                    }
                    function Ec(a, b) {
                        window[a] = b;
                    }
                    function Fc(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function Gc() {
                        return H(function(a) {
                            switch(a.g){
                                case 1:
                                    return a.m = 2, E(a, WebAssembly.instantiate(Cc), 4);
                                case 4:
                                    a.g = 3;
                                    a.m = 0;
                                    break;
                                case 2:
                                    return a.m = 0, a.j = null, a.return(false);
                                case 3:
                                    return a.return(true);
                            }
                        });
                    }
                    function Hc(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.G = {};
                        this.m = {};
                        this.s = {};
                        this.H = this.o = this.S = true;
                        this.D = Promise.resolve();
                        this.R = "";
                        this.C = {};
                        this.locateFile = a && a.locateFile || Dc;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.T = b;
                        if (a.options) {
                            b = A(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    v = Hc.prototype;
                    v.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function Ic(a) {
                        var b, c, d, e, g, f, k, h, l, p, t;
                        return H(function(q) {
                            switch(q.g){
                                case 1:
                                    if (!a.S) return q.return();
                                    b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
                                    return E(q, Gc(), 2);
                                case 2:
                                    c = q.h;
                                    if (typeof window === "object") return Ec("createMediapipeSolutionsWasm", {
                                        locateFile: a.locateFile
                                    }), Ec("createMediapipeSolutionsPackedAssets", {
                                        locateFile: a.locateFile
                                    }), f = b.filter(function(m) {
                                        return m.data !== void 0;
                                    }), k = b.filter(function(m) {
                                        return m.data === void 0;
                                    }), h = Promise.all(f.map(function(m) {
                                        var n = Jc(a, m.url);
                                        if (m.path !== void 0) {
                                            var r = m.path;
                                            n = n.then(function(x) {
                                                a.overrideFile(r, x);
                                                return Promise.resolve(x);
                                            });
                                        }
                                        return n;
                                    })), l = Promise.all(k.map(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c ? Fc(a.locateFile(m.url, a.T)) : Promise.resolve();
                                    })).then(function() {
                                        var m, n, r;
                                        return H(function(x) {
                                            if (x.g == 1) return m = window.createMediapipeSolutionsWasm, n = window.createMediapipeSolutionsPackedAssets, r = a, E(x, m(n), 2);
                                            r.h = x.h;
                                            x.g = 0;
                                        });
                                    }), p = function() {
                                        return H(function(m) {
                                            a.g.graph && a.g.graph.url ? m = E(m, Jc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                                            return m;
                                        });
                                    }(), E(q, Promise.all([
                                        l,
                                        h,
                                        p
                                    ]), 7);
                                    if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                    d = b.filter(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c;
                                    }).map(function(m) {
                                        return a.locateFile(m.url, a.T);
                                    });
                                    importScripts.apply(null, ea(d));
                                    e = a;
                                    return E(q, createMediapipeSolutionsWasm(Module), 6);
                                case 6:
                                    e.h = q.h;
                                    a.l = new OffscreenCanvas(1, 1);
                                    a.h.canvas = a.l;
                                    g = a.h.GL.createContext(a.l, {
                                        antialias: false,
                                        alpha: false,
                                        ga: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                    });
                                    a.h.GL.makeContextCurrent(g);
                                    q.g = 4;
                                    break;
                                case 7:
                                    a.l = document.createElement("canvas");
                                    t = a.l.getContext("webgl2", {});
                                    if (!t && (t = a.l.getContext("webgl", {}), !t)) return alert("Failed to create WebGL canvas context when passing video frame."), q.return();
                                    a.F = t;
                                    a.h.canvas = a.l;
                                    a.h.createContext(a.l, true, true, {});
                                case 4:
                                    a.i = new a.h.SolutionWasm(), a.S = false, q.g = 0;
                            }
                        });
                    }
                    function Kc(a) {
                        var b, c, d, e, g, f, k, h;
                        return H(function(l) {
                            if (l.g == 1) {
                                if (a.g.graph && a.g.graph.url && a.R === a.g.graph.url) return l.return();
                                a.o = true;
                                if (!a.g.graph || !a.g.graph.url) {
                                    l.g = 2;
                                    return;
                                }
                                a.R = a.g.graph.url;
                                return E(l, Jc(a, a.g.graph.url), 3);
                            }
                            l.g != 2 && (b = l.h, a.i.loadGraph(b));
                            c = A(Object.keys(a.C));
                            for(d = c.next(); !d.done; d = c.next())e = d.value, a.i.overrideFile(e, a.C[e]);
                            a.C = {};
                            if (a.g.listeners) for(g = A(a.g.listeners), f = g.next(); !f.done; f = g.next())k = f.value, Lc(a, k);
                            h = a.j;
                            a.j = {};
                            a.setOptions(h);
                            l.g = 0;
                        });
                    }
                    v.reset = function() {
                        var a = this;
                        return H(function(b) {
                            a.i && (a.i.reset(), a.m = {}, a.s = {});
                            b.g = 0;
                        });
                    };
                    v.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = A(Object.keys(a)), k = f.next(); !k.done; g = {
                                L: g.L,
                                M: g.M
                            }, k = f.next()){
                                var h = k.value;
                                h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.L = k.onChange, g.M = a[h], d.push(function(l) {
                                    return function() {
                                        var p;
                                        return H(function(t) {
                                            if (t.g == 1) return E(t, l.L(l.M), 2);
                                            p = t.h;
                                            p === true && (c.o = true);
                                            t.g = 0;
                                        });
                                    };
                                }(g))), k.graphOptionXref && (h = {
                                    valueNumber: k.type === 1 ? a[h] : 0,
                                    valueBoolean: k.type === 0 ? a[h] : false,
                                    valueString: k.type === 2 ? a[h] : ""
                                }, k = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), k.graphOptionXref), h), e.push(k))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.o = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
                        }
                    };
                    function Mc(a) {
                        var b, c, d, e, g, f, k;
                        return H(function(h) {
                            switch(h.g){
                                case 1:
                                    if (!a.o) return h.return();
                                    if (!a.A) {
                                        h.g = 2;
                                        break;
                                    }
                                    b = A(a.A);
                                    c = b.next();
                                case 3:
                                    if (c.done) {
                                        h.g = 5;
                                        break;
                                    }
                                    d = c.value;
                                    return E(h, d(), 4);
                                case 4:
                                    c = b.next();
                                    h.g = 3;
                                    break;
                                case 5:
                                    a.A = void 0;
                                case 2:
                                    if (a.B) {
                                        e = new a.h.GraphOptionChangeRequestList();
                                        g = A(a.B);
                                        for(f = g.next(); !f.done; f = g.next())k = f.value, e.push_back(k);
                                        a.i.changeOptions(e);
                                        e.delete();
                                        a.B = void 0;
                                    }
                                    a.o = false;
                                    h.g = 0;
                            }
                        });
                    }
                    v.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return b.g == 1 ? E(b, Ic(a), 2) : b.g != 3 ? E(b, Kc(a), 3) : E(b, Mc(a), 0);
                        });
                    };
                    function Jc(a, b) {
                        var c, d;
                        return H(function(e) {
                            if (b in a.G) return e.return(a.G[b]);
                            c = a.locateFile(b, "");
                            d = fetch(c).then(function(g) {
                                return g.arrayBuffer();
                            });
                            a.G[b] = d;
                            return e.return(d);
                        });
                    }
                    v.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
                    };
                    v.clearOverriddenFiles = function() {
                        this.C = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    v.send = function(a, b) {
                        var c = this, d, e, g, f, k, h, l, p, t;
                        return H(function(q) {
                            switch(q.g){
                                case 1:
                                    if (!c.g.inputs) return q.return();
                                    d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                    return E(q, c.D, 2);
                                case 2:
                                    return E(q, c.initialize(), 3);
                                case 3:
                                    e = new c.h.PacketDataList();
                                    g = A(Object.keys(a));
                                    for(f = g.next(); !f.done; f = g.next())if (k = f.value, h = c.g.inputs[k]) {
                                        a: {
                                            var m = a[k];
                                            switch(h.type){
                                                case "video":
                                                    var n = c.m[h.stream];
                                                    n || (n = new yc(c.h, c.F), c.m[h.stream] = n);
                                                    n.l === 0 && (n.l = n.h.createTexture());
                                                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                                                        var r = m.videoWidth;
                                                        var x = m.videoHeight;
                                                    } else typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (r = m.naturalWidth, x = m.naturalHeight) : (r = m.width, x = m.height);
                                                    x = {
                                                        glName: n.l,
                                                        width: r,
                                                        height: x
                                                    };
                                                    r = n.g;
                                                    r.canvas.width = x.width;
                                                    r.canvas.height = x.height;
                                                    r.activeTexture(r.TEXTURE0);
                                                    n.h.bindTexture2d(n.l);
                                                    r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, m);
                                                    n.h.bindTexture2d(0);
                                                    n = x;
                                                    break a;
                                                case "detections":
                                                    n = c.m[h.stream];
                                                    n || (n = new Bc(c.h), c.m[h.stream] = n);
                                                    n.data || (n.data = new n.g.DetectionListData());
                                                    n.data.reset(m.length);
                                                    for(x = 0; x < m.length; ++x){
                                                        r = m[x];
                                                        var w = n.data, D = w.setBoundingBox, L = x;
                                                        var G = r.U;
                                                        var u = new bc();
                                                        T(u, 1, G.aa);
                                                        T(u, 2, G.ba);
                                                        T(u, 3, G.height);
                                                        T(u, 4, G.width);
                                                        T(u, 5, G.rotation);
                                                        T(u, 6, G.Z);
                                                        G = Fb(u, dc);
                                                        D.call(w, L, G);
                                                        if (r.P) for(w = 0; w < r.P.length; ++w){
                                                            u = r.P[w];
                                                            var B = u.visibility ? true : false;
                                                            D = n.data;
                                                            L = D.addNormalizedLandmark;
                                                            G = x;
                                                            u = Object.assign(Object.assign({}, u), {
                                                                visibility: B ? u.visibility : 0
                                                            });
                                                            B = new Wb();
                                                            T(B, 1, u.x);
                                                            T(B, 2, u.y);
                                                            T(B, 3, u.z);
                                                            u.visibility && T(B, 4, u.visibility);
                                                            u = Fb(B, Yb);
                                                            L.call(D, G, u);
                                                        }
                                                        if (r.N) for(w = 0; w < r.N.length; ++w)D = n.data, L = D.addClassification, G = x, u = r.N[w], B = new Qb(), T(B, 2, u.$), u.index && T(B, 1, u.index), u.label && T(B, 3, u.label), u.displayName && T(B, 4, u.displayName), u = Fb(B, Sb), L.call(D, G, u);
                                                    }
                                                    n = n.data;
                                                    break a;
                                                default:
                                                    n = {};
                                            }
                                        }
                                        l = n;
                                        p = h.stream;
                                        switch(h.type){
                                            case "video":
                                                e.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                    stream: p,
                                                    timestamp: d
                                                }));
                                                break;
                                            case "detections":
                                                t = l;
                                                t.stream = p;
                                                t.timestamp = d;
                                                e.pushDetectionList(t);
                                                break;
                                            default:
                                                throw Error("Unknown input config type: '" + h.type + "'");
                                        }
                                    }
                                    c.i.send(e);
                                    return E(q, c.D, 4);
                                case 4:
                                    e.delete(), q.g = 0;
                            }
                        });
                    };
                    function Nc(a, b, c) {
                        var d, e, g, f, k, h, l, p, t, q, m, n, r, x;
                        return H(function(w) {
                            switch(w.g){
                                case 1:
                                    if (!c) return w.return(b);
                                    d = {};
                                    e = 0;
                                    g = A(Object.keys(c));
                                    for(f = g.next(); !f.done; f = g.next())k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
                                    1 < e && (a.H = false);
                                    l = A(Object.keys(c));
                                    f = l.next();
                                case 2:
                                    if (f.done) {
                                        w.g = 4;
                                        break;
                                    }
                                    p = f.value;
                                    t = c[p];
                                    if (typeof t === "string") return r = d, x = p, E(w, Oc(a, p, b[t]), 14);
                                    q = b[t.stream];
                                    if (t.type === "detection_list") {
                                        if (q) {
                                            var D = q.getRectList();
                                            for(var L = q.getLandmarksList(), G = q.getClassificationsList(), u = [], B = 0; B < D.size(); ++B){
                                                var U = Gb(D.get(B), bc, cc);
                                                U = {
                                                    U: {
                                                        aa: V(U, 1),
                                                        ba: V(U, 2),
                                                        height: V(U, 3),
                                                        width: V(U, 4),
                                                        rotation: V(U, 5, 0),
                                                        Z: ub(U, 6)
                                                    },
                                                    P: sb(Gb(L.get(B), Zb, ac), Wb, 1).map(xc),
                                                    N: wc(Gb(G.get(B), Tb, Vb))
                                                };
                                                u.push(U);
                                            }
                                            D = u;
                                        } else D = [];
                                        d[p] = D;
                                        w.g = 7;
                                        break;
                                    }
                                    if (t.type === "proto_list") {
                                        if (q) {
                                            D = Array(q.size());
                                            for(L = 0; L < q.size(); L++)D[L] = q.get(L);
                                            q.delete();
                                        } else D = [];
                                        d[p] = D;
                                        w.g = 7;
                                        break;
                                    }
                                    if (q === void 0) {
                                        w.g = 3;
                                        break;
                                    }
                                    if (t.type === "float_list") {
                                        d[p] = q;
                                        w.g = 7;
                                        break;
                                    }
                                    if (t.type === "proto") {
                                        d[p] = q;
                                        w.g = 7;
                                        break;
                                    }
                                    if (t.type !== "texture") throw Error("Unknown output config type: '" + t.type + "'");
                                    m = a.s[p];
                                    m || (m = new yc(a.h, a.F), a.s[p] = m);
                                    return E(w, zc(m, q, a.H), 13);
                                case 13:
                                    n = w.h, d[p] = n;
                                case 7:
                                    t.transform && d[p] && (d[p] = t.transform(d[p]));
                                    w.g = 3;
                                    break;
                                case 14:
                                    r[x] = w.h;
                                case 3:
                                    f = l.next();
                                    w.g = 2;
                                    break;
                                case 4:
                                    return w.return(d);
                            }
                        });
                    }
                    function Oc(a, b, c) {
                        var d;
                        return H(function(e) {
                            return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new yc(a.h, a.F), a.s[b] = d), e.return(zc(d, c, a.H))) : e.return(void 0);
                        });
                    }
                    function Lc(a, b) {
                        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = A(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(k) {
                                for(var h = {}, l = 0; l < b.wants.length; ++l)h[d[l]] = k.get(l);
                                var p = a.listeners[c];
                                p && (a.D = Nc(a, h, b.outs).then(function(t) {
                                    t = p(t);
                                    for(var q = 0; q < b.wants.length; ++q){
                                        var m = h[d[q]];
                                        typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
                                    }
                                    t && (a.D = t);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    v.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    I("Solution", Hc);
                    I("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        ca: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function Pc(a) {
                        var b = ub(a, 1);
                        var c = rb(a, jc, 3);
                        c = {
                            x: V(c, 1),
                            y: V(c, 2),
                            depth: V(c, 3)
                        };
                        a = rb(a, lc, 2);
                        return {
                            id: b,
                            point2d: c,
                            point3d: {
                                x: V(a, 1),
                                y: V(a, 2),
                                z: V(a, 3)
                            }
                        };
                    }
                    function Qc(a) {
                        var b = Gb(a, sc, uc);
                        a = [];
                        b = sb(b, pc, 2);
                        for(var c = 0; c < b.length; c++)a.push({
                            id: ub(b[c], 1),
                            keypoints: sb(b[c], nc, 2).map(Pc),
                            visibility: V(b[c], 3),
                            scale: pb(b[c], 6),
                            translation: pb(b[c], 5),
                            rotation: pb(b[c], 4)
                        });
                        return a;
                    }
                    function Rc(a) {
                        switch(a){
                            case "Camera":
                                return "object_detection_3d_camera.tflite";
                            case "Chair":
                                return "object_detection_3d_chair.tflite";
                            case "Cup":
                                return "object_detection_3d_cup.tflite";
                            default:
                                return "object_detection_3d_sneakers.tflite";
                        }
                    }
                    function Sc(a) {
                        switch(a){
                            case "Camera":
                                return "Camera";
                            case "Chair":
                                return "Chair";
                            case "Cup":
                                return "Coffee cup, Mug";
                            default:
                                return "Footwear";
                        }
                    }
                    var Tc = {
                        focalX: {
                            type: 1,
                            graphOptionXref: {
                                calculatorType: "Lift2DFrameAnnotationTo3DCalculator",
                                fieldName: "normalized_focal_x"
                            }
                        },
                        focalY: {
                            type: 1,
                            graphOptionXref: {
                                calculatorType: "Lift2DFrameAnnotationTo3DCalculator",
                                fieldName: "normalized_focal_y"
                            }
                        },
                        principalX: {
                            type: 1,
                            graphOptionXref: {
                                calculatorType: "Lift2DFrameAnnotationTo3DCalculator",
                                fieldName: "normalized_principal_point_x"
                            }
                        },
                        principalY: {
                            type: 1,
                            graphOptionXref: {
                                calculatorType: "Lift2DFrameAnnotationTo3DCalculator",
                                fieldName: "normalized_principal_point_y"
                            }
                        },
                        allowedLabels: {
                            type: 2,
                            graphOptionXref: {
                                calculatorName: "ConstantSidePacketCalculatorAllowedLabels",
                                calculatorType: "ConstantSidePacketCalculator",
                                fieldName: "string_value"
                            }
                        }
                    };
                    function Uc(a) {
                        var b = this;
                        a = a || {};
                        this.g = new Hc({
                            locateFile: a.locateFile,
                            files: [
                                {
                                    url: "objectron_solution_packed_assets_loader.js"
                                },
                                {
                                    simd: false,
                                    url: "objectron_solution_wasm_bin.js"
                                },
                                {
                                    simd: true,
                                    url: "objectron_solution_simd_wasm_bin.js"
                                }
                            ],
                            graph: {
                                url: "objectron.binarypb"
                            },
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            listeners: [
                                {
                                    wants: [
                                        "lifted_objects",
                                        "image_transformed"
                                    ],
                                    outs: {
                                        image: "image_transformed",
                                        objectDetections: {
                                            type: "proto",
                                            stream: "lifted_objects",
                                            transform: Qc
                                        }
                                    }
                                }
                            ],
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                selfieMode: {
                                    type: 0,
                                    default: false,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                maxNumObjects: {
                                    type: 1,
                                    default: 5,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorMaxNumObjects",
                                        fieldName: "int_value"
                                    }
                                },
                                staticImageMode: {
                                    type: 0,
                                    default: true,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "objectrongpusubgraph__ConstantSidePacketCalculator",
                                        fieldName: "bool_value"
                                    }
                                },
                                minDetectionConfidence: {
                                    type: 1,
                                    default: 0.5,
                                    graphOptionXref: {
                                        calculatorType: "TensorsToDetectionsCalculator",
                                        calculatorName: "objectrongpusubgraph__objectdetectionoidv4subgraph__TensorsToDetectionsCalculator",
                                        fieldName: "min_score_thresh"
                                    }
                                },
                                minTrackingConfidence: {
                                    type: 1,
                                    default: 0.99,
                                    graphOptionXref: {
                                        calculatorType: "ThresholdingCalculator",
                                        calculatorName: "objectrongpusubgraph__boxlandmarksubgraph__ThresholdingCalculator",
                                        fieldName: "threshold"
                                    }
                                },
                                modelName: {
                                    default: "Shoe",
                                    onChange: function(c) {
                                        var d, e, g, f;
                                        return H(function(k) {
                                            if (k.g == 1) return d = c, b.g.setOptions({
                                                allowedLabels: Sc(d)
                                            }, Tc), e = Rc(d), g = "object_detection_3d.tflite", E(k, Jc(b.g, e), 2);
                                            f = k.h;
                                            b.g.overrideFile(g, f);
                                            return k.return(true);
                                        });
                                    }
                                },
                                focalLength: {
                                    default: [
                                        1,
                                        1
                                    ],
                                    onChange: function(c) {
                                        var d;
                                        return H(function(e) {
                                            d = c;
                                            b.h = d;
                                            b.g.setOptions({
                                                focalX: d[0],
                                                focalY: d[1]
                                            }, Tc);
                                            return e.return(true);
                                        });
                                    }
                                },
                                principalPoint: {
                                    default: [
                                        0,
                                        0
                                    ],
                                    onChange: function(c) {
                                        var d;
                                        return H(function(e) {
                                            d = c;
                                            b.i = d;
                                            b.g.setOptions({
                                                principalX: d[0],
                                                principalY: d[1]
                                            }, Tc);
                                            return e.return(true);
                                        });
                                    }
                                },
                                imageSize: {
                                    onChange: function(c) {
                                        var d, e, g, f;
                                        return H(function(k) {
                                            if (b.h === void 0 || b.i === void 0) return console.error('"focalLength" and "principalPoint" must be set if setting image size'), k.return();
                                            d = c;
                                            e = [
                                                d[0] / 2,
                                                d[1] / 2
                                            ];
                                            g = [
                                                b.h[0] / e[0],
                                                b.h[1] / e[1]
                                            ];
                                            f = [
                                                b.i[0] / e[0],
                                                b.i[1] / e[1]
                                            ];
                                            b.setOptions({
                                                focalLength: g,
                                                principalPoint: f
                                            });
                                            k.g = 0;
                                        });
                                    }
                                }
                            }
                        });
                    }
                    v = Uc.prototype;
                    v.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    v.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    v.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return E(b, a.g.initialize(), 0);
                        });
                    };
                    v.reset = function() {
                        this.g.reset();
                    };
                    v.send = function(a) {
                        var b = this;
                        return H(function(c) {
                            return E(c, b.g.send(a), 0);
                        });
                    };
                    v.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    I("Objectron", Uc);
                    I("BOX_CONNECTIONS", [
                        [
                            1,
                            2
                        ],
                        [
                            2,
                            4
                        ],
                        [
                            4,
                            3
                        ],
                        [
                            3,
                            1
                        ],
                        [
                            5,
                            6
                        ],
                        [
                            6,
                            8
                        ],
                        [
                            8,
                            7
                        ],
                        [
                            7,
                            5
                        ],
                        [
                            1,
                            5
                        ],
                        [
                            2,
                            6
                        ],
                        [
                            3,
                            7
                        ],
                        [
                            4,
                            8
                        ]
                    ]);
                    I("BOX_KEYPOINTS", {
                        CENTER: 0,
                        BACK_BOTTOM_LEFT: 1,
                        FRONT_BOTTOM_LEFT: 2,
                        BACK_TOP_LEFT: 3,
                        FRONT_TOP_LEFT: 4,
                        BACK_BOTTOM_RIGHT: 5,
                        FRONT_BOTTOM_RIGHT: 6,
                        BACK_TOP_RIGHT: 7,
                        FRONT_TOP_RIGHT: 8
                    });
                    I("VERSION", "0.4.1636596145");
                }).call(VonageObjectron);
                const VonagePose = {};
                (function() {
                    var x;
                    function aa(a) {
                        var b = 0;
                        return function() {
                            return b < a.length ? {
                                done: false,
                                value: a[b++]
                            } : {
                                done: true
                            };
                        };
                    }
                    var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
                        if (a == Array.prototype || a == Object.prototype) return a;
                        a[b] = c.value;
                        return a;
                    };
                    function ca(a) {
                        a = [
                            typeof globalThis == "object" && globalThis,
                            a,
                            typeof window == "object" && window,
                            typeof self == "object" && self,
                            typeof window == "object" && window
                        ];
                        for(var b = 0; b < a.length; ++b){
                            var c = a[b];
                            if (c && c.Math == Math) return c;
                        }
                        throw Error("Cannot find global object");
                    }
                    var y = ca(this);
                    function B(a, b) {
                        if (b) a: {
                            var c = y;
                            a = a.split(".");
                            for(var d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) break a;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && b != null && ba(c, a, {
                                configurable: true,
                                writable: true,
                                value: b
                            });
                        }
                    }
                    B("Symbol", function(a) {
                        function b(g) {
                            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                            return new c(d + (g || "") + "_" + e++, g);
                        }
                        function c(g, f) {
                            this.g = g;
                            ba(this, "description", {
                                configurable: true,
                                writable: true,
                                value: f
                            });
                        }
                        if (a) return a;
                        c.prototype.toString = function() {
                            return this.g;
                        };
                        var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
                        return b;
                    });
                    B("Symbol.iterator", function(a) {
                        if (a) return a;
                        a = Symbol("Symbol.iterator");
                        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                            var d = y[b[c]];
                            typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, {
                                configurable: true,
                                writable: true,
                                value: function() {
                                    return da(aa(this));
                                }
                            });
                        }
                        return a;
                    });
                    function da(a) {
                        a = {
                            next: a
                        };
                        a[Symbol.iterator] = function() {
                            return this;
                        };
                        return a;
                    }
                    function C(a) {
                        var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
                        return b ? b.call(a) : {
                            next: aa(a)
                        };
                    }
                    function ea(a) {
                        if (!(a instanceof Array)) {
                            a = C(a);
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            a = c;
                        }
                        return a;
                    }
                    var fa = typeof Object.create == "function" ? Object.create : function(a) {
                        function b() {}
                        b.prototype = a;
                        return new b();
                    }, ha;
                    if (typeof Object.setPrototypeOf == "function") ha = Object.setPrototypeOf;
                    else {
                        var ia;
                        a: {
                            var ja = {
                                a: true
                            }, ka = {};
                            try {
                                ka.__proto__ = ja;
                                ia = ka.a;
                                break a;
                            } catch (a) {}
                            ia = false;
                        }
                        ha = ia ? function(a, b) {
                            a.__proto__ = b;
                            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                            return a;
                        } : null;
                    }
                    var la = ha;
                    function E(a, b) {
                        a.prototype = fa(b.prototype);
                        a.prototype.constructor = a;
                        if (la) la(a, b);
                        else for(var c in b)if (c != "prototype") {
                            if (Object.defineProperties) {
                                var d = Object.getOwnPropertyDescriptor(b, c);
                                d && Object.defineProperty(a, c, d);
                            } else a[c] = b[c];
                        }
                        a.ea = b.prototype;
                    }
                    function ma() {
                        this.l = false;
                        this.i = null;
                        this.h = void 0;
                        this.g = 1;
                        this.s = this.m = 0;
                        this.j = null;
                    }
                    function na(a) {
                        if (a.l) throw new TypeError("Generator is already running");
                        a.l = true;
                    }
                    ma.prototype.o = function(a) {
                        this.h = a;
                    };
                    function oa(a, b) {
                        a.j = {
                            U: b,
                            V: true
                        };
                        a.g = a.m || a.s;
                    }
                    ma.prototype.return = function(a) {
                        this.j = {
                            return: a
                        };
                        this.g = this.s;
                    };
                    function F(a, b, c) {
                        a.g = c;
                        return {
                            value: b
                        };
                    }
                    function pa(a) {
                        this.g = new ma();
                        this.h = a;
                    }
                    function qa(a, b) {
                        na(a.g);
                        var c = a.g.i;
                        if (c) return ra(a, "return" in c ? c["return"] : function(d) {
                            return {
                                value: d,
                                done: true
                            };
                        }, b, a.g.return);
                        a.g.return(b);
                        return G(a);
                    }
                    function ra(a, b, c, d) {
                        try {
                            var e = b.call(a.g.i, c);
                            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                            if (!e.done) return a.g.l = false, e;
                            var g = e.value;
                        } catch (f) {
                            return a.g.i = null, oa(a.g, f), G(a);
                        }
                        a.g.i = null;
                        d.call(a.g, g);
                        return G(a);
                    }
                    function G(a) {
                        for(; a.g.g;)try {
                            var b = a.h(a.g);
                            if (b) return a.g.l = false, {
                                value: b.value,
                                done: false
                            };
                        } catch (c) {
                            a.g.h = void 0, oa(a.g, c);
                        }
                        a.g.l = false;
                        if (a.g.j) {
                            b = a.g.j;
                            a.g.j = null;
                            if (b.V) throw b.U;
                            return {
                                value: b.return,
                                done: true
                            };
                        }
                        return {
                            value: void 0,
                            done: true
                        };
                    }
                    function sa(a) {
                        this.next = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = G(a));
                            return b;
                        };
                        this.throw = function(b) {
                            na(a.g);
                            a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = G(a));
                            return b;
                        };
                        this.return = function(b) {
                            return qa(a, b);
                        };
                        this[Symbol.iterator] = function() {
                            return this;
                        };
                    }
                    function ta(a) {
                        function b(d) {
                            return a.next(d);
                        }
                        function c(d) {
                            return a.throw(d);
                        }
                        return new Promise(function(d, e) {
                            function g(f) {
                                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                            }
                            g(a.next());
                        });
                    }
                    function H(a) {
                        return ta(new sa(new pa(a)));
                    }
                    B("Promise", function(a) {
                        function b(f) {
                            this.h = 0;
                            this.i = void 0;
                            this.g = [];
                            this.o = false;
                            var k = this.j();
                            try {
                                f(k.resolve, k.reject);
                            } catch (h) {
                                k.reject(h);
                            }
                        }
                        function c() {
                            this.g = null;
                        }
                        function d(f) {
                            return f instanceof b ? f : new b(function(k) {
                                k(f);
                            });
                        }
                        if (a) return a;
                        c.prototype.h = function(f) {
                            if (this.g == null) {
                                this.g = [];
                                var k = this;
                                this.i(function() {
                                    k.l();
                                });
                            }
                            this.g.push(f);
                        };
                        var e = y.setTimeout;
                        c.prototype.i = function(f) {
                            e(f, 0);
                        };
                        c.prototype.l = function() {
                            for(; this.g && this.g.length;){
                                var f = this.g;
                                this.g = [];
                                for(var k = 0; k < f.length; ++k){
                                    var h = f[k];
                                    f[k] = null;
                                    try {
                                        h();
                                    } catch (l) {
                                        this.j(l);
                                    }
                                }
                            }
                            this.g = null;
                        };
                        c.prototype.j = function(f) {
                            this.i(function() {
                                throw f;
                            });
                        };
                        b.prototype.j = function() {
                            function f(l) {
                                return function(n) {
                                    h || (h = true, l.call(k, n));
                                };
                            }
                            var k = this, h = false;
                            return {
                                resolve: f(this.C),
                                reject: f(this.l)
                            };
                        };
                        b.prototype.C = function(f) {
                            if (f === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                            else if (f instanceof b) this.F(f);
                            else {
                                a: switch(typeof f){
                                    case "object":
                                        var k = f != null;
                                        break a;
                                    case "function":
                                        k = true;
                                        break a;
                                    default:
                                        k = false;
                                }
                                k ? this.v(f) : this.m(f);
                            }
                        };
                        b.prototype.v = function(f) {
                            var k = void 0;
                            try {
                                k = f.then;
                            } catch (h) {
                                this.l(h);
                                return;
                            }
                            typeof k == "function" ? this.G(k, f) : this.m(f);
                        };
                        b.prototype.l = function(f) {
                            this.s(2, f);
                        };
                        b.prototype.m = function(f) {
                            this.s(1, f);
                        };
                        b.prototype.s = function(f, k) {
                            if (this.h != 0) throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
                            this.h = f;
                            this.i = k;
                            this.h === 2 && this.D();
                            this.A();
                        };
                        b.prototype.D = function() {
                            var f = this;
                            e(function() {
                                if (f.B()) {
                                    var k = y.console;
                                    typeof k !== "undefined" && k.error(f.i);
                                }
                            }, 1);
                        };
                        b.prototype.B = function() {
                            if (this.o) return false;
                            var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
                            if (typeof h === "undefined") return true;
                            typeof f === "function" ? f = new f("unhandledrejection", {
                                cancelable: true
                            }) : typeof k === "function" ? f = new k("unhandledrejection", {
                                cancelable: true
                            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
                            f.promise = this;
                            f.reason = this.i;
                            return h(f);
                        };
                        b.prototype.A = function() {
                            if (this.g != null) {
                                for(var f = 0; f < this.g.length; ++f)g.h(this.g[f]);
                                this.g = null;
                            }
                        };
                        var g = new c();
                        b.prototype.F = function(f) {
                            var k = this.j();
                            f.J(k.resolve, k.reject);
                        };
                        b.prototype.G = function(f, k) {
                            var h = this.j();
                            try {
                                f.call(k, h.resolve, h.reject);
                            } catch (l) {
                                h.reject(l);
                            }
                        };
                        b.prototype.then = function(f, k) {
                            function h(p, m) {
                                return typeof p == "function" ? function(q) {
                                    try {
                                        l(p(q));
                                    } catch (t) {
                                        n(t);
                                    }
                                } : m;
                            }
                            var l, n, r = new b(function(p, m) {
                                l = p;
                                n = m;
                            });
                            this.J(h(f, l), h(k, n));
                            return r;
                        };
                        b.prototype.catch = function(f) {
                            return this.then(void 0, f);
                        };
                        b.prototype.J = function(f, k) {
                            function h() {
                                switch(l.h){
                                    case 1:
                                        f(l.i);
                                        break;
                                    case 2:
                                        k(l.i);
                                        break;
                                    default:
                                        throw Error("Unexpected state: " + l.h);
                                }
                            }
                            var l = this;
                            this.g == null ? g.h(h) : this.g.push(h);
                            this.o = true;
                        };
                        b.resolve = d;
                        b.reject = function(f) {
                            return new b(function(k, h) {
                                h(f);
                            });
                        };
                        b.race = function(f) {
                            return new b(function(k, h) {
                                for(var l = C(f), n = l.next(); !n.done; n = l.next())d(n.value).J(k, h);
                            });
                        };
                        b.all = function(f) {
                            var k = C(f), h = k.next();
                            return h.done ? d([]) : new b(function(l, n) {
                                function r(q) {
                                    return function(t) {
                                        p[q] = t;
                                        m--;
                                        m == 0 && l(p);
                                    };
                                }
                                var p = [], m = 0;
                                do p.push(void 0), m++, d(h.value).J(r(p.length - 1), n), h = k.next();
                                while (!h.done);
                            });
                        };
                        return b;
                    });
                    function ua(a, b) {
                        a instanceof String && (a += "");
                        var c = 0, d = false, e = {
                            next: function() {
                                if (!d && c < a.length) {
                                    var g = c++;
                                    return {
                                        value: b(g, a[g]),
                                        done: false
                                    };
                                }
                                d = true;
                                return {
                                    done: true,
                                    value: void 0
                                };
                            }
                        };
                        e[Symbol.iterator] = function() {
                            return e;
                        };
                        return e;
                    }
                    var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
                        for(var c = 1; c < arguments.length; c++){
                            var d = arguments[c];
                            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
                        }
                        return a;
                    };
                    B("Object.assign", function(a) {
                        return a || va;
                    });
                    B("Object.is", function(a) {
                        return a ? a : function(b, c) {
                            return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
                        };
                    });
                    B("Array.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            var d = this;
                            d instanceof String && (d = String(d));
                            var e = d.length;
                            c = c || 0;
                            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                var g = d[c];
                                if (g === b || Object.is(g, b)) return true;
                            }
                            return false;
                        };
                    });
                    B("String.prototype.includes", function(a) {
                        return a ? a : function(b, c) {
                            if (this == null) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                            return this.indexOf(b, c || 0) !== -1;
                        };
                    });
                    B("Array.prototype.keys", function(a) {
                        return a ? a : function() {
                            return ua(this, function(b) {
                                return b;
                            });
                        };
                    });
                    var wa = this || self;
                    function J(a, b) {
                        a = a.split(".");
                        var c = wa;
                        a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
                        for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
                    }
                    function xa(a) {
                        wa.setTimeout(function() {
                            throw a;
                        }, 0);
                    }
                    function K(a) {
                        xa(a);
                        return;
                    }
                    function ya(a, b) {
                        K(Error("Invalid wire type: " + a + " (at position " + b + ")"));
                    }
                    function za() {
                        K(Error("Failed to read varint, encoding is invalid."));
                    }
                    function Aa(a, b) {
                        b = String.fromCharCode.apply(null, b);
                        return a == null ? b : a + b;
                    }
                    var Ba, Ca = typeof TextDecoder !== "undefined", Da, Ea = typeof TextEncoder !== "undefined";
                    function Fa(a) {
                        if (Ea) a = (Da || (Da = new TextEncoder())).encode(a);
                        else {
                            var b = void 0;
                            b = b === void 0 ? false : b;
                            for(var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++){
                                var g = a.charCodeAt(e);
                                if (128 > g) d[c++] = g;
                                else {
                                    if (2048 > g) d[c++] = g >> 6 | 192;
                                    else {
                                        if (55296 <= g && 57343 >= g) {
                                            if (56319 >= g && e < a.length) {
                                                var f = a.charCodeAt(++e);
                                                if (56320 <= f && 57343 >= f) {
                                                    g = 1024 * (g - 55296) + f - 56320 + 65536;
                                                    d[c++] = g >> 18 | 240;
                                                    d[c++] = g >> 12 & 63 | 128;
                                                    d[c++] = g >> 6 & 63 | 128;
                                                    d[c++] = g & 63 | 128;
                                                    continue;
                                                } else e--;
                                            }
                                            if (b) throw Error("Found an unpaired surrogate");
                                            g = 65533;
                                        }
                                        d[c++] = g >> 12 | 224;
                                        d[c++] = g >> 6 & 63 | 128;
                                    }
                                    d[c++] = g & 63 | 128;
                                }
                            }
                            a = d.subarray(0, c);
                        }
                        return a;
                    }
                    var Ga = {}, L = null;
                    function Ha(a) {
                        var b;
                        b === void 0 && (b = 0);
                        Ia();
                        b = Ga[b];
                        for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                            var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
                            f = b[(f & 3) << 4 | k >> 4];
                            k = b[(k & 15) << 2 | h >> 6];
                            h = b[h & 63];
                            c[g++] = l + f + k + h;
                        }
                        l = 0;
                        h = d;
                        switch(a.length - e){
                            case 2:
                                l = a[e + 1], h = b[(l & 15) << 2] || d;
                            case 1:
                                a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
                        }
                        return c.join("");
                    }
                    function Ja(a) {
                        var b = a.length, c = 3 * b / 4;
                        c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
                        var d = new Uint8Array(c), e = 0;
                        Ka(a, function(g) {
                            d[e++] = g;
                        });
                        return d.subarray(0, e);
                    }
                    function Ka(a, b) {
                        function c(h) {
                            for(; d < a.length;){
                                var l = a.charAt(d++), n = L[l];
                                if (n != null) return n;
                                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
                            }
                            return h;
                        }
                        Ia();
                        for(var d = 0;;){
                            var e = c(-1), g = c(0), f = c(64), k = c(64);
                            if (k === 64 && e === -1) break;
                            b(e << 2 | g >> 4);
                            f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
                        }
                    }
                    function Ia() {
                        if (!L) {
                            L = {};
                            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                                "+/=",
                                "+/",
                                "-_=",
                                "-_.",
                                "-_"
                            ], c = 0; 5 > c; c++){
                                var d = a.concat(b[c].split(""));
                                Ga[c] = d;
                                for(var e = 0; e < d.length; e++){
                                    var g = d[e];
                                    L[g] === void 0 && (L[g] = e);
                                }
                            }
                        }
                    }
                    var La = typeof Uint8Array === "function", Ma;
                    function Na(a) {
                        this.g = a;
                        if (a !== null && a.length === 0) throw Error("ByteString should be constructed with non-empty values");
                    }
                    Na.prototype.toJSON = function() {
                        if (this.g == null) var a = "";
                        else a = this.g, a = this.g = a == null || typeof a === "string" ? a : La && a instanceof Uint8Array ? Ha(a) : null;
                        return a;
                    };
                    var Oa = typeof Uint8Array.prototype.slice === "function";
                    function Pa(a, b, c) {
                        return b === c ? Ma || (Ma = new Uint8Array(0)) : Oa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
                    }
                    var M = 0, N = 0;
                    function Qa(a) {
                        if (a.constructor === Uint8Array) return a;
                        if (a.constructor === ArrayBuffer) return new Uint8Array(a);
                        if (a.constructor === Array) return new Uint8Array(a);
                        if (a.constructor === String) return Ja(a);
                        if (a.constructor === Na) {
                            if (a.g == null) var b = Ma || (Ma = new Uint8Array(0));
                            else {
                                b = Uint8Array;
                                var c = a.g;
                                c = c == null || La && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? Ja(c) : null;
                                a = a.g = c;
                                b = new b(a);
                            }
                            return b;
                        }
                        if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
                    }
                    function Ra(a, b) {
                        b = b === void 0 ? {} : b;
                        b = b.u === void 0 ? false : b.u;
                        this.h = null;
                        this.g = this.i = this.l = 0;
                        this.j = false;
                        this.u = b;
                        a && Sa(this, a);
                    }
                    function Sa(a, b) {
                        a.h = Qa(b);
                        a.l = 0;
                        a.i = a.h.length;
                        a.g = a.l;
                    }
                    Ra.prototype.reset = function() {
                        this.g = this.l;
                    };
                    function O(a) {
                        a.g > a.i && (a.j = true, K(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
                    }
                    function P(a) {
                        var b = a.h, c = b[a.g], d = c & 127;
                        if (128 > c) return a.g += 1, O(a), d;
                        c = b[a.g + 1];
                        d |= (c & 127) << 7;
                        if (128 > c) return a.g += 2, O(a), d;
                        c = b[a.g + 2];
                        d |= (c & 127) << 14;
                        if (128 > c) return a.g += 3, O(a), d;
                        c = b[a.g + 3];
                        d |= (c & 127) << 21;
                        if (128 > c) return a.g += 4, O(a), d;
                        c = b[a.g + 4];
                        d |= (c & 15) << 28;
                        if (128 > c) return a.g += 5, O(a), d >>> 0;
                        a.g += 5;
                        if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++]) return a.j = true, za(), d;
                        O(a);
                        return d;
                    }
                    var Ta = [];
                    function Ua() {
                        this.g = new Uint8Array(64);
                        this.h = 0;
                    }
                    function Q(a, b) {
                        if (!(a.h + 1 < a.g.length)) {
                            var c = a.g;
                            a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
                            a.g.set(c);
                        }
                        a.g[a.h++] = b;
                    }
                    Ua.prototype.length = function() {
                        return this.h;
                    };
                    Ua.prototype.end = function() {
                        var a = this.g, b = this.h;
                        this.h = 0;
                        return Pa(a, 0, b);
                    };
                    function R(a, b) {
                        for(; 127 < b;)Q(a, b & 127 | 128), b >>>= 7;
                        Q(a, b);
                    }
                    function Va(a) {
                        var b = {}, c = b.N === void 0 ? false : b.N;
                        this.m = {
                            u: b.u === void 0 ? false : b.u
                        };
                        this.N = c;
                        b = this.m;
                        Ta.length ? (c = Ta.pop(), b && (c.u = b.u), a && Sa(c, a), a = c) : a = new Ra(a, b);
                        this.g = a;
                        this.l = this.g.g;
                        this.h = this.i = -1;
                        this.j = false;
                    }
                    Va.prototype.reset = function() {
                        this.g.reset();
                        this.h = this.i = -1;
                    };
                    function Wa(a) {
                        var b = a.g;
                        (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.j || 0 > b.g || b.g > b.i);
                        if (b) return false;
                        a.l = a.g.g;
                        var c = P(a.g);
                        b = c >>> 3;
                        c &= 7;
                        if (!(0 <= c && 5 >= c)) return a.j = true, ya(c, a.l), false;
                        a.i = b;
                        a.h = c;
                        return true;
                    }
                    function Xa(a) {
                        switch(a.h){
                            case 0:
                                if (a.h != 0) Xa(a);
                                else a: {
                                    a = a.g;
                                    for(var b = a.g, c = 0; 10 > c; c++){
                                        if ((a.h[b] & 128) === 0) {
                                            a.g = b + 1;
                                            O(a);
                                            break a;
                                        }
                                        b++;
                                    }
                                    a.j = true;
                                    za();
                                }
                                break;
                            case 1:
                                a = a.g;
                                a.g += 8;
                                O(a);
                                break;
                            case 2:
                                a.h != 2 ? Xa(a) : (b = P(a.g), a = a.g, a.g += b, O(a));
                                break;
                            case 5:
                                a = a.g;
                                a.g += 4;
                                O(a);
                                break;
                            case 3:
                                b = a.i;
                                do {
                                    if (!Wa(a)) {
                                        a.j = true;
                                        K(Error("Unmatched start-group tag: stream EOF"));
                                        break;
                                    }
                                    if (a.h == 4) {
                                        a.i != b && (a.j = true, K(Error("Unmatched end-group tag")));
                                        break;
                                    }
                                    Xa(a);
                                }while (1);
                                break;
                            default:
                                a.j = true, ya(a.h, a.l);
                        }
                    }
                    function Ya(a, b, c) {
                        a.N || (a = Pa(a.g.h, c, a.g.g), (c = b.m) ? c.push(a) : b.m = [
                            a
                        ]);
                    }
                    var Za = [];
                    function $a() {
                        this.h = [];
                        this.i = 0;
                        this.g = new Ua();
                    }
                    function ab(a, b) {
                        b.length !== 0 && (a.h.push(b), a.i += b.length);
                    }
                    function bb(a, b, c) {
                        R(a.g, 8 * b + 2);
                        R(a.g, c.length);
                        ab(a, a.g.end());
                        ab(a, c);
                    }
                    var cb = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
                    function db(a, b) {
                        Object.isFrozen(a) || (cb ? a[cb] |= b : a.g !== void 0 ? a.g |= b : Object.defineProperties(a, {
                            g: {
                                value: b,
                                configurable: true,
                                writable: true,
                                enumerable: false
                            }
                        }));
                    }
                    function eb(a) {
                        if (!a) return 0;
                        var b;
                        cb ? b = a[cb] : b = a.g;
                        return b == null ? 0 : b;
                    }
                    function fb(a) {
                        if (!Array.isArray(a)) return a;
                        db(a, 1);
                        return a;
                    }
                    function gb(a) {
                        if (!Array.isArray(a)) throw Error("cannot mark non-array as immutable");
                        db(a, 2);
                    }
                    function hb(a) {
                        return a !== null && typeof a === "object" && a.constructor === Object;
                    }
                    function ib(a) {
                        switch(typeof a){
                            case "number":
                                return isFinite(a) ? a : String(a);
                            case "object":
                                return La && a != null && a instanceof Uint8Array ? Ha(a) : a;
                            default:
                                return a;
                        }
                    }
                    function jb(a, b) {
                        if (a != null) return Array.isArray(a) || hb(a) ? kb(a, b) : b(a);
                    }
                    function kb(a, b) {
                        if (Array.isArray(a)) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = jb(a[d], b);
                            eb(a) & 1 && fb(c);
                            return c;
                        }
                        c = {};
                        for(d in a)c[d] = jb(a[d], b);
                        return c;
                    }
                    var lb;
                    function T(a, b, c) {
                        var d = lb;
                        lb = null;
                        a || (a = d);
                        d = this.constructor.ca;
                        a || (a = d ? [
                            d
                        ] : []);
                        this.j = (d ? 0 : -1) - (this.constructor.aa || 0);
                        this.i = null;
                        this.g = a;
                        a: {
                            d = this.g.length;
                            a = d - 1;
                            if (d && (d = this.g[a], hb(d))) {
                                this.l = a - this.j;
                                this.h = d;
                                break a;
                            }
                            b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
                        }
                        if (c) for(b = 0; b < c.length; b++)a = c[b], a < this.l ? (a += this.j, (d = this.g[a]) ? fb(d) : this.g[a] = mb) : (nb(this), (d = this.h[a]) ? fb(d) : this.h[a] = mb);
                    }
                    var mb = Object.freeze(fb([]));
                    function nb(a) {
                        var b = a.l + a.j;
                        a.g[b] || (a.h = a.g[b] = {});
                    }
                    function U(a, b, c) {
                        return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.h ? a.h[b] : void 0 : a.g[b + a.j];
                    }
                    function ob(a, b, c) {
                        c = c === void 0 ? true : c;
                        var d = d === void 0 ? false : d;
                        var e = U(a, b, d);
                        e == null && (e = mb);
                        e === mb ? (e = fb([]), V(a, b, e, d)) : c && Array.isArray(e) && eb(e) & 2 && (e = e.slice(), V(a, b, e, d));
                        return e;
                    }
                    function W(a, b, c) {
                        a = U(a, b);
                        a = a == null ? a : +a;
                        return a == null ? c === void 0 ? 0 : c : a;
                    }
                    function V(a, b, c, d) {
                        (d === void 0 ? 0 : d) || b >= a.l ? (nb(a), a.h[b] = c) : a.g[b + a.j] = c;
                    }
                    function pb(a, b, c) {
                        a.i || (a.i = {});
                        var d = a.i[c];
                        if (!d) {
                            var e = ob(a, c, false);
                            d = [];
                            for(var g = Array.isArray(e) ? !!(eb(e) & 2) : false, f = 0; f < e.length; f++)d[f] = new b(e[f]), g && gb(d[f].g);
                            g && (gb(d), Object.freeze(d));
                            a.i[c] = d;
                        }
                        return d;
                    }
                    function qb(a, b, c, d, e) {
                        var g = pb(a, d, b);
                        c = c ? c : new d();
                        a = ob(a, b);
                        e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, X(c))) : (g.push(c), a.push(X(c)));
                    }
                    T.prototype.toJSON = function() {
                        var a = X(this);
                        return kb(a, ib);
                    };
                    function X(a) {
                        if (a.i) for(var b in a.i){
                            var c = a.i[b];
                            if (Array.isArray(c)) for(var d = 0; d < c.length; d++)c[d] && X(c[d]);
                            else c && X(c);
                        }
                        return a.g;
                    }
                    T.prototype.toString = function() {
                        return X(this).toString();
                    };
                    function rb(a, b) {
                        a = U(a, b);
                        return a == null ? 0 : a;
                    }
                    function sb(a, b) {
                        a = U(a, b);
                        return a == null ? "" : a;
                    }
                    function tb(a, b) {
                        if (a = a.m) {
                            ab(b, b.g.end());
                            for(var c = 0; c < a.length; c++)ab(b, a[c]);
                        }
                    }
                    function ub(a) {
                        var b = a[0];
                        switch(a.length){
                            case 2:
                                var c = a[1];
                                return function(h, l, n) {
                                    return b(h, l, n, c);
                                };
                            case 3:
                                var d = a[1], e = a[2];
                                return function(h, l, n) {
                                    return b(h, l, n, d, e);
                                };
                            case 4:
                                var g = a[1], f = a[2], k = a[3];
                                return function(h, l, n) {
                                    return b(h, l, n, g, f, k);
                                };
                            default:
                                throw Error("unsupported number of parameters, expected [2-4], got " + a.length);
                        }
                    }
                    function vb(a, b, c) {
                        for(; Wa(b) && b.h != 4;){
                            var d = b.i, e = c[d];
                            if (e) {
                                if (Array.isArray(e) && (e = c[d] = ub(e)), !e(b, a, d)) {
                                    d = b;
                                    e = a;
                                    var g = d.l;
                                    Xa(d);
                                    Ya(d, e, g);
                                }
                            } else d = b, e = a, g = d.l, Xa(d), Ya(d, e, g);
                        }
                        return a;
                    }
                    function wb(a, b) {
                        var c = new $a();
                        b(a, c);
                        a = c.i + c.g.length();
                        if (a === 0) c = new Uint8Array(0);
                        else {
                            a = new Uint8Array(a);
                            for(var d = c.h, e = d.length, g = b = 0; g < e; g++){
                                var f = d[g];
                                f.length !== 0 && (a.set(f, b), b += f.length);
                            }
                            d = c.g;
                            e = d.h;
                            e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
                            c.h = [
                                a
                            ];
                            c = a;
                        }
                        return c;
                    }
                    function xb(a, b, c) {
                        if (Za.length) {
                            var d = Za.pop();
                            a && (Sa(d.g, a), d.i = -1, d.h = -1);
                            a = d;
                        } else a = new Va(a);
                        try {
                            return c(new b(), a);
                        } finally{
                            b = a.g, b.h = null, b.l = 0, b.i = 0, b.g = 0, b.j = false, b.u = false, a.i = -1, a.h = -1, a.j = false, 100 > Za.length && Za.push(a);
                        }
                    }
                    function Y(a, b, c) {
                        b = U(b, c);
                        if (b != null) {
                            R(a.g, 8 * c + 5);
                            a = a.g;
                            var d = b;
                            d = (c = 0 > d ? 1 : 0) ? -d : d;
                            d === 0 ? 0 < 1 / d ? M = N = 0 : (N = 0, M = 2147483648) : isNaN(d) ? (N = 0, M = 2147483647) : 34028234663852886e22 < d ? (N = 0, M = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), N = 0, M = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, N = 0, M = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
                            c = M;
                            Q(a, c >>> 0 & 255);
                            Q(a, c >>> 8 & 255);
                            Q(a, c >>> 16 & 255);
                            Q(a, c >>> 24 & 255);
                        }
                    }
                    function Z(a, b, c) {
                        if (a.h !== 5) return false;
                        a = a.g;
                        var d = a.h[a.g];
                        var e = a.h[a.g + 1];
                        var g = a.h[a.g + 2], f = a.h[a.g + 3];
                        a.g += 4;
                        O(a);
                        e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
                        a = 2 * (e >> 31) + 1;
                        d = e >>> 23 & 255;
                        e &= 8388607;
                        V(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
                        return true;
                    }
                    function yb(a, b, c) {
                        if (a.h !== 0) return false;
                        for(var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)e = d.h[d.g++], g |= (e & 127) << 7 * f;
                        128 <= e && (e = d.h[d.g++], g |= (e & 127) << 28, a |= (e & 127) >> 4);
                        if (128 <= e) for(f = 0; 5 > f && 128 <= e; f++)e = d.h[d.g++], a |= (e & 127) << 7 * f + 3;
                        if (128 > e) {
                            d = g >>> 0;
                            e = a >>> 0;
                            if (a = e & 2147483648) d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
                            d = 4294967296 * e + (d >>> 0);
                            a = a ? -d : d;
                        } else d.j = true, za(), a = void 0;
                        V(b, c, a);
                        return true;
                    }
                    function zb(a, b, c) {
                        if (a.h !== 0) return false;
                        V(b, c, P(a.g));
                        return true;
                    }
                    function Ab(a, b, c) {
                        if (a.h !== 2) return false;
                        var d = P(a.g);
                        a = a.g;
                        var e = a.g;
                        a.g += d;
                        O(a);
                        a = a.h;
                        var g;
                        if (Ca) (g = Ba) || (g = Ba = new TextDecoder("utf-8", {
                            fatal: false
                        })), g = g.decode(a.subarray(e, e + d));
                        else {
                            d = e + d;
                            for(var f = [], k = null, h, l, n; e < d;)h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((n = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | n & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = Aa(k, f), f.length = 0);
                            g = Aa(k, f);
                        }
                        V(b, c, g);
                        return true;
                    }
                    function Bb(a, b, c, d, e) {
                        if (a.h !== 2) return false;
                        var g = new d(), f = a.g.i, k = P(a.g), h = a.g.g + k;
                        a.g.i = h;
                        e(g, a);
                        e = h - a.g.g;
                        if (e !== 0) throw Error("Message parsing ended unexpectedly. Expected to read " + (k + " bytes, instead read " + (k - e) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                        a.g.g = h;
                        a.g.i = f;
                        qb(b, c, g, d, void 0);
                        return true;
                    }
                    function Cb(a) {
                        T.call(this, a);
                    }
                    var Db;
                    E(Cb, T);
                    function Eb(a, b) {
                        var c = U(a, 1);
                        if (c != null && c != null) {
                            R(b.g, 8);
                            var d = b.g;
                            if (0 <= c) R(d, c);
                            else {
                                for(var e = 0; 9 > e; e++)Q(d, c & 127 | 128), c >>= 7;
                                Q(d, 1);
                            }
                        }
                        Y(b, a, 2);
                        d = U(a, 3);
                        d != null && bb(b, 3, Fa(d));
                        d = U(a, 4);
                        d != null && bb(b, 4, Fa(d));
                        tb(a, b);
                    }
                    function Fb(a, b) {
                        return vb(a, b, Db || (Db = {
                            1: zb,
                            2: Z,
                            3: Ab,
                            4: Ab
                        }));
                    }
                    function Gb(a) {
                        T.call(this, a, -1, Hb);
                    }
                    var Ib;
                    E(Gb, T);
                    Gb.prototype.addClassification = function(a, b) {
                        qb(this, 1, a, Cb, b);
                        return this;
                    };
                    function Jb(a, b) {
                        return vb(a, b, Ib || (Ib = {
                            1: [
                                Bb,
                                Cb,
                                Fb
                            ]
                        }));
                    }
                    var Hb = [
                        1
                    ];
                    function Kb(a) {
                        T.call(this, a);
                    }
                    var Lb;
                    E(Kb, T);
                    function Mb(a, b) {
                        Y(b, a, 1);
                        Y(b, a, 2);
                        Y(b, a, 3);
                        Y(b, a, 4);
                        Y(b, a, 5);
                        tb(a, b);
                    }
                    function Nb(a, b) {
                        return vb(a, b, Lb || (Lb = {
                            1: Z,
                            2: Z,
                            3: Z,
                            4: Z,
                            5: Z
                        }));
                    }
                    function Ob(a) {
                        T.call(this, a, -1, Pb);
                    }
                    var Qb;
                    E(Ob, T);
                    function Rb(a, b) {
                        return vb(a, b, Qb || (Qb = {
                            1: [
                                Bb,
                                Kb,
                                Nb
                            ]
                        }));
                    }
                    var Pb = [
                        1
                    ];
                    function Sb(a) {
                        T.call(this, a);
                    }
                    var Tb;
                    E(Sb, T);
                    function Ub(a, b) {
                        Y(b, a, 1);
                        Y(b, a, 2);
                        Y(b, a, 3);
                        Y(b, a, 4);
                        Y(b, a, 5);
                        var c = U(a, 6);
                        if (c != null && c != null) {
                            R(b.g, 48);
                            var d = b.g, e = c;
                            c = 0 > e;
                            e = Math.abs(e);
                            var g = e >>> 0;
                            e = Math.floor((e - g) / 4294967296);
                            e >>>= 0;
                            c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
                            M = g;
                            N = e;
                            c = M;
                            for(g = N; 0 < g || 127 < c;)Q(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
                            Q(d, c);
                        }
                        tb(a, b);
                    }
                    function Vb(a, b) {
                        return vb(a, b, Tb || (Tb = {
                            1: Z,
                            2: Z,
                            3: Z,
                            4: Z,
                            5: Z,
                            6: yb
                        }));
                    }
                    function Wb(a, b, c) {
                        c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
                        a.shaderSource(c, b);
                        a.compileShader(c);
                        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
                        return c;
                    }
                    function Xb(a) {
                        return pb(a, Cb, 1).map(function(b) {
                            return {
                                index: rb(b, 1),
                                X: W(b, 2),
                                label: U(b, 3) != null ? sb(b, 3) : void 0,
                                displayName: U(b, 4) != null ? sb(b, 4) : void 0
                            };
                        });
                    }
                    function Yb(a) {
                        return {
                            x: W(a, 1),
                            y: W(a, 2),
                            z: W(a, 3),
                            visibility: U(a, 4) != null ? W(a, 4) : void 0
                        };
                    }
                    function Zb(a) {
                        return pb(xb(a, Ob, Rb), Kb, 1).map(Yb);
                    }
                    function $b(a, b) {
                        this.h = a;
                        this.g = b;
                        this.l = 0;
                    }
                    function ac(a, b, c) {
                        bc(a, b);
                        if (typeof a.g.canvas.transferToImageBitmap === "function") return Promise.resolve(a.g.canvas.transferToImageBitmap());
                        if (c) return Promise.resolve(a.g.canvas);
                        if (typeof createImageBitmap === "function") return createImageBitmap(a.g.canvas);
                        a.i === void 0 && (a.i = document.createElement("canvas"));
                        return new Promise(function(d) {
                            a.i.height = a.g.canvas.height;
                            a.i.width = a.g.canvas.width;
                            a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
                            d(a.i);
                        });
                    }
                    function bc(a, b) {
                        var c = a.g;
                        if (a.m === void 0) {
                            var d = Wb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Wb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
                            c.attachShader(g, d);
                            c.attachShader(g, e);
                            c.linkProgram(g);
                            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
                            d = a.m = g;
                            c.useProgram(d);
                            e = c.getUniformLocation(d, "sampler0");
                            a.j = {
                                I: c.getAttribLocation(d, "aVertex"),
                                H: c.getAttribLocation(d, "aTex"),
                                da: e
                            };
                            a.s = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.s);
                            c.enableVertexAttribArray(a.j.I);
                            c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                -1,
                                -1,
                                -1,
                                1,
                                1,
                                1,
                                1,
                                -1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            a.o = c.createBuffer();
                            c.bindBuffer(c.ARRAY_BUFFER, a.o);
                            c.enableVertexAttribArray(a.j.H);
                            c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
                            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                1,
                                1
                            ]), c.STATIC_DRAW);
                            c.bindBuffer(c.ARRAY_BUFFER, null);
                            c.uniform1i(e, 0);
                        }
                        d = a.j;
                        c.useProgram(a.m);
                        c.canvas.width = b.width;
                        c.canvas.height = b.height;
                        c.viewport(0, 0, b.width, b.height);
                        c.activeTexture(c.TEXTURE0);
                        a.h.bindTexture2d(b.glName);
                        c.enableVertexAttribArray(d.I);
                        c.bindBuffer(c.ARRAY_BUFFER, a.s);
                        c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
                        c.enableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, a.o);
                        c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
                        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
                        c.clearColor(0, 0, 0, 0);
                        c.clear(c.COLOR_BUFFER_BIT);
                        c.colorMask(true, true, true, true);
                        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
                        c.disableVertexAttribArray(d.I);
                        c.disableVertexAttribArray(d.H);
                        c.bindBuffer(c.ARRAY_BUFFER, null);
                        a.h.bindTexture2d(0);
                    }
                    function cc(a) {
                        this.g = a;
                    }
                    var dc = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        2,
                        1,
                        0,
                        10,
                        9,
                        1,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    function ec(a, b) {
                        return b + a;
                    }
                    function fc(a, b) {
                        window[a] = b;
                    }
                    function gc(a) {
                        var b = document.createElement("script");
                        b.setAttribute("src", a);
                        b.setAttribute("crossorigin", "anonymous");
                        return new Promise(function(c) {
                            b.addEventListener("load", function() {
                                c();
                            }, false);
                            b.addEventListener("error", function() {
                                c();
                            }, false);
                            document.body.appendChild(b);
                        });
                    }
                    function hc() {
                        return H(function(a) {
                            switch(a.g){
                                case 1:
                                    return a.m = 2, F(a, WebAssembly.instantiate(dc), 4);
                                case 4:
                                    a.g = 3;
                                    a.m = 0;
                                    break;
                                case 2:
                                    return a.m = 0, a.j = null, a.return(false);
                                case 3:
                                    return a.return(true);
                            }
                        });
                    }
                    function ic(a) {
                        this.g = a;
                        this.listeners = {};
                        this.j = {};
                        this.F = {};
                        this.m = {};
                        this.s = {};
                        this.G = this.o = this.R = true;
                        this.C = Promise.resolve();
                        this.P = "";
                        this.B = {};
                        this.locateFile = a && a.locateFile || ec;
                        if (typeof window === "object") var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                        else if (typeof location !== "undefined") b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                        else throw Error("solutions can only be loaded on a web page or in a web worker");
                        this.S = b;
                        if (a.options) {
                            b = C(Object.keys(a.options));
                            for(var c = b.next(); !c.done; c = b.next()){
                                c = c.value;
                                var d = a.options[c].default;
                                d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
                            }
                        }
                    }
                    x = ic.prototype;
                    x.close = function() {
                        this.i && this.i.delete();
                        return Promise.resolve();
                    };
                    function jc(a) {
                        var b, c, d, e, g, f, k, h, l, n, r;
                        return H(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!a.R) return p.return();
                                    b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
                                    return F(p, hc(), 2);
                                case 2:
                                    c = p.h;
                                    if (typeof window === "object") return fc("createMediapipeSolutionsWasm", {
                                        locateFile: a.locateFile
                                    }), fc("createMediapipeSolutionsPackedAssets", {
                                        locateFile: a.locateFile
                                    }), f = b.filter(function(m) {
                                        return m.data !== void 0;
                                    }), k = b.filter(function(m) {
                                        return m.data === void 0;
                                    }), h = Promise.all(f.map(function(m) {
                                        var q = kc(a, m.url);
                                        if (m.path !== void 0) {
                                            var t = m.path;
                                            q = q.then(function(w) {
                                                a.overrideFile(t, w);
                                                return Promise.resolve(w);
                                            });
                                        }
                                        return q;
                                    })), l = Promise.all(k.map(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c ? gc(a.locateFile(m.url, a.S)) : Promise.resolve();
                                    })).then(function() {
                                        var m, q, t;
                                        return H(function(w) {
                                            if (w.g == 1) return m = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, m(q), 2);
                                            t.h = w.h;
                                            w.g = 0;
                                        });
                                    }), n = function() {
                                        return H(function(m) {
                                            a.g.graph && a.g.graph.url ? m = F(m, kc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                                            return m;
                                        });
                                    }(), F(p, Promise.all([
                                        l,
                                        h,
                                        n
                                    ]), 7);
                                    if (typeof importScripts !== "function") throw Error("solutions can only be loaded on a web page or in a web worker");
                                    d = b.filter(function(m) {
                                        return m.simd === void 0 || m.simd && c || !m.simd && !c;
                                    }).map(function(m) {
                                        return a.locateFile(m.url, a.S);
                                    });
                                    importScripts.apply(null, ea(d));
                                    e = a;
                                    return F(p, createMediapipeSolutionsWasm(Module), 6);
                                case 6:
                                    e.h = p.h;
                                    a.l = new OffscreenCanvas(1, 1);
                                    a.h.canvas = a.l;
                                    g = a.h.GL.createContext(a.l, {
                                        antialias: false,
                                        alpha: false,
                                        ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
                                    });
                                    a.h.GL.makeContextCurrent(g);
                                    p.g = 4;
                                    break;
                                case 7:
                                    a.l = document.createElement("canvas");
                                    r = a.l.getContext("webgl2", {});
                                    if (!r && (r = a.l.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                                    a.D = r;
                                    a.h.canvas = a.l;
                                    a.h.createContext(a.l, true, true, {});
                                case 4:
                                    a.i = new a.h.SolutionWasm(), a.R = false, p.g = 0;
                            }
                        });
                    }
                    function lc(a) {
                        var b, c, d, e, g, f, k, h;
                        return H(function(l) {
                            if (l.g == 1) {
                                if (a.g.graph && a.g.graph.url && a.P === a.g.graph.url) return l.return();
                                a.o = true;
                                if (!a.g.graph || !a.g.graph.url) {
                                    l.g = 2;
                                    return;
                                }
                                a.P = a.g.graph.url;
                                return F(l, kc(a, a.g.graph.url), 3);
                            }
                            l.g != 2 && (b = l.h, a.i.loadGraph(b));
                            c = C(Object.keys(a.B));
                            for(d = c.next(); !d.done; d = c.next())e = d.value, a.i.overrideFile(e, a.B[e]);
                            a.B = {};
                            if (a.g.listeners) for(g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())k = f.value, mc(a, k);
                            h = a.j;
                            a.j = {};
                            a.setOptions(h);
                            l.g = 0;
                        });
                    }
                    x.reset = function() {
                        var a = this;
                        return H(function(b) {
                            a.i && (a.i.reset(), a.m = {}, a.s = {});
                            b.g = 0;
                        });
                    };
                    x.setOptions = function(a, b) {
                        var c = this;
                        if (b = b || this.g.options) {
                            for(var d = [], e = [], g = {}, f = C(Object.keys(a)), k = f.next(); !k.done; g = {
                                K: g.K,
                                L: g.L
                            }, k = f.next()){
                                var h = k.value;
                                h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.K = k.onChange, g.L = a[h], d.push(function(l) {
                                    return function() {
                                        var n;
                                        return H(function(r) {
                                            if (r.g == 1) return F(r, l.K(l.L), 2);
                                            n = r.h;
                                            n === true && (c.o = true);
                                            r.g = 0;
                                        });
                                    };
                                }(g))), k.graphOptionXref && (h = {
                                    valueNumber: k.type === 1 ? a[h] : 0,
                                    valueBoolean: k.type === 0 ? a[h] : false,
                                    valueString: k.type === 2 ? a[h] : ""
                                }, k = Object.assign(Object.assign(Object.assign({}, {
                                    calculatorName: "",
                                    calculatorIndex: 0
                                }), k.graphOptionXref), h), e.push(k))));
                            }
                            if (d.length !== 0 || e.length !== 0) this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.v = (this.v === void 0 ? [] : this.v).concat(d);
                        }
                    };
                    function nc(a) {
                        var b, c, d, e, g, f, k;
                        return H(function(h) {
                            switch(h.g){
                                case 1:
                                    if (!a.o) return h.return();
                                    if (!a.v) {
                                        h.g = 2;
                                        break;
                                    }
                                    b = C(a.v);
                                    c = b.next();
                                case 3:
                                    if (c.done) {
                                        h.g = 5;
                                        break;
                                    }
                                    d = c.value;
                                    return F(h, d(), 4);
                                case 4:
                                    c = b.next();
                                    h.g = 3;
                                    break;
                                case 5:
                                    a.v = void 0;
                                case 2:
                                    if (a.A) {
                                        e = new a.h.GraphOptionChangeRequestList();
                                        g = C(a.A);
                                        for(f = g.next(); !f.done; f = g.next())k = f.value, e.push_back(k);
                                        a.i.changeOptions(e);
                                        e.delete();
                                        a.A = void 0;
                                    }
                                    a.o = false;
                                    h.g = 0;
                            }
                        });
                    }
                    x.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return b.g == 1 ? F(b, jc(a), 2) : b.g != 3 ? F(b, lc(a), 3) : F(b, nc(a), 0);
                        });
                    };
                    function kc(a, b) {
                        var c, d;
                        return H(function(e) {
                            if (b in a.F) return e.return(a.F[b]);
                            c = a.locateFile(b, "");
                            d = fetch(c).then(function(g) {
                                return g.arrayBuffer();
                            });
                            a.F[b] = d;
                            return e.return(d);
                        });
                    }
                    x.overrideFile = function(a, b) {
                        this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
                    };
                    x.clearOverriddenFiles = function() {
                        this.B = {};
                        this.i && this.i.clearOverriddenFiles();
                    };
                    x.send = function(a, b) {
                        var c = this, d, e, g, f, k, h, l, n, r;
                        return H(function(p) {
                            switch(p.g){
                                case 1:
                                    if (!c.g.inputs) return p.return();
                                    d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
                                    return F(p, c.C, 2);
                                case 2:
                                    return F(p, c.initialize(), 3);
                                case 3:
                                    e = new c.h.PacketDataList();
                                    g = C(Object.keys(a));
                                    for(f = g.next(); !f.done; f = g.next())if (k = f.value, h = c.g.inputs[k]) {
                                        a: {
                                            var m = a[k];
                                            switch(h.type){
                                                case "video":
                                                    var q = c.m[h.stream];
                                                    q || (q = new $b(c.h, c.D), c.m[h.stream] = q);
                                                    q.l === 0 && (q.l = q.h.createTexture());
                                                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                                                        var t = m.videoWidth;
                                                        var w = m.videoHeight;
                                                    } else typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (t = m.naturalWidth, w = m.naturalHeight) : (t = m.width, w = m.height);
                                                    w = {
                                                        glName: q.l,
                                                        width: t,
                                                        height: w
                                                    };
                                                    t = q.g;
                                                    t.canvas.width = w.width;
                                                    t.canvas.height = w.height;
                                                    t.activeTexture(t.TEXTURE0);
                                                    q.h.bindTexture2d(q.l);
                                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, m);
                                                    q.h.bindTexture2d(0);
                                                    q = w;
                                                    break a;
                                                case "detections":
                                                    q = c.m[h.stream];
                                                    q || (q = new cc(c.h), c.m[h.stream] = q);
                                                    q.data || (q.data = new q.g.DetectionListData());
                                                    q.data.reset(m.length);
                                                    for(w = 0; w < m.length; ++w){
                                                        t = m[w];
                                                        var v = q.data, A = v.setBoundingBox, I = w;
                                                        var D = t.T;
                                                        var u = new Sb();
                                                        V(u, 1, D.Y);
                                                        V(u, 2, D.Z);
                                                        V(u, 3, D.height);
                                                        V(u, 4, D.width);
                                                        V(u, 5, D.rotation);
                                                        V(u, 6, D.W);
                                                        D = wb(u, Ub);
                                                        A.call(v, I, D);
                                                        if (t.O) for(v = 0; v < t.O.length; ++v){
                                                            u = t.O[v];
                                                            var z = u.visibility ? true : false;
                                                            A = q.data;
                                                            I = A.addNormalizedLandmark;
                                                            D = w;
                                                            u = Object.assign(Object.assign({}, u), {
                                                                visibility: z ? u.visibility : 0
                                                            });
                                                            z = new Kb();
                                                            V(z, 1, u.x);
                                                            V(z, 2, u.y);
                                                            V(z, 3, u.z);
                                                            u.visibility && V(z, 4, u.visibility);
                                                            u = wb(z, Mb);
                                                            I.call(A, D, u);
                                                        }
                                                        if (t.M) for(v = 0; v < t.M.length; ++v)A = q.data, I = A.addClassification, D = w, u = t.M[v], z = new Cb(), V(z, 2, u.X), u.index && V(z, 1, u.index), u.label && V(z, 3, u.label), u.displayName && V(z, 4, u.displayName), u = wb(z, Eb), I.call(A, D, u);
                                                    }
                                                    q = q.data;
                                                    break a;
                                                default:
                                                    q = {};
                                            }
                                        }
                                        l = q;
                                        n = h.stream;
                                        switch(h.type){
                                            case "video":
                                                e.pushTexture2d(Object.assign(Object.assign({}, l), {
                                                    stream: n,
                                                    timestamp: d
                                                }));
                                                break;
                                            case "detections":
                                                r = l;
                                                r.stream = n;
                                                r.timestamp = d;
                                                e.pushDetectionList(r);
                                                break;
                                            default:
                                                throw Error("Unknown input config type: '" + h.type + "'");
                                        }
                                    }
                                    c.i.send(e);
                                    return F(p, c.C, 4);
                                case 4:
                                    e.delete(), p.g = 0;
                            }
                        });
                    };
                    function oc(a, b, c) {
                        var d, e, g, f, k, h, l, n, r, p, m, q, t, w;
                        return H(function(v) {
                            switch(v.g){
                                case 1:
                                    if (!c) return v.return(b);
                                    d = {};
                                    e = 0;
                                    g = C(Object.keys(c));
                                    for(f = g.next(); !f.done; f = g.next())k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
                                    1 < e && (a.G = false);
                                    l = C(Object.keys(c));
                                    f = l.next();
                                case 2:
                                    if (f.done) {
                                        v.g = 4;
                                        break;
                                    }
                                    n = f.value;
                                    r = c[n];
                                    if (typeof r === "string") return t = d, w = n, F(v, pc(a, n, b[r]), 14);
                                    p = b[r.stream];
                                    if (r.type === "detection_list") {
                                        if (p) {
                                            var A = p.getRectList();
                                            for(var I = p.getLandmarksList(), D = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z){
                                                var S = xb(A.get(z), Sb, Vb);
                                                S = {
                                                    T: {
                                                        Y: W(S, 1),
                                                        Z: W(S, 2),
                                                        height: W(S, 3),
                                                        width: W(S, 4),
                                                        rotation: W(S, 5, 0),
                                                        W: rb(S, 6)
                                                    },
                                                    O: Zb(I.get(z)),
                                                    M: Xb(xb(D.get(z), Gb, Jb))
                                                };
                                                u.push(S);
                                            }
                                            A = u;
                                        } else A = [];
                                        d[n] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto_list") {
                                        if (p) {
                                            A = Array(p.size());
                                            for(I = 0; I < p.size(); I++)A[I] = p.get(I);
                                            p.delete();
                                        } else A = [];
                                        d[n] = A;
                                        v.g = 7;
                                        break;
                                    }
                                    if (p === void 0) {
                                        v.g = 3;
                                        break;
                                    }
                                    if (r.type === "float_list") {
                                        d[n] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type === "proto") {
                                        d[n] = p;
                                        v.g = 7;
                                        break;
                                    }
                                    if (r.type !== "texture") throw Error("Unknown output config type: '" + r.type + "'");
                                    m = a.s[n];
                                    m || (m = new $b(a.h, a.D), a.s[n] = m);
                                    return F(v, ac(m, p, a.G), 13);
                                case 13:
                                    q = v.h, d[n] = q;
                                case 7:
                                    r.transform && d[n] && (d[n] = r.transform(d[n]));
                                    v.g = 3;
                                    break;
                                case 14:
                                    t[w] = v.h;
                                case 3:
                                    f = l.next();
                                    v.g = 2;
                                    break;
                                case 4:
                                    return v.return(d);
                            }
                        });
                    }
                    function pc(a, b, c) {
                        var d;
                        return H(function(e) {
                            return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new $b(a.h, a.D), a.s[b] = d), e.return(ac(d, c, a.G))) : e.return(void 0);
                        });
                    }
                    function mc(a, b) {
                        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
                        g = a.h.PacketListener.implement({
                            onResults: function(k) {
                                for(var h = {}, l = 0; l < b.wants.length; ++l)h[d[l]] = k.get(l);
                                var n = a.listeners[c];
                                n && (a.C = oc(a, h, b.outs).then(function(r) {
                                    r = n(r);
                                    for(var p = 0; p < b.wants.length; ++p){
                                        var m = h[d[p]];
                                        typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
                                    }
                                    r && (a.C = r);
                                }));
                            }
                        });
                        a.i.attachMultiListener(e, g);
                        e.delete();
                    }
                    x.onResults = function(a, b) {
                        this.listeners[b || "$"] = a;
                    };
                    J("Solution", ic);
                    J("OptionType", {
                        BOOL: 0,
                        NUMBER: 1,
                        $: 2,
                        0: "BOOL",
                        1: "NUMBER",
                        2: "STRING"
                    });
                    function qc(a) {
                        a === void 0 && (a = 0);
                        switch(a){
                            case 1:
                                return "pose_landmark_full.tflite";
                            case 2:
                                return "pose_landmark_heavy.tflite";
                            default:
                                return "pose_landmark_lite.tflite";
                        }
                    }
                    function rc(a) {
                        var b = this;
                        a = a || {};
                        this.g = new ic({
                            locateFile: a.locateFile,
                            files: function(c) {
                                return [
                                    {
                                        url: "pose_solution_packed_assets_loader.js"
                                    },
                                    {
                                        simd: false,
                                        url: "pose_solution_wasm_bin.js"
                                    },
                                    {
                                        simd: true,
                                        url: "pose_solution_simd_wasm_bin.js"
                                    },
                                    {
                                        data: true,
                                        url: qc(c.modelComplexity)
                                    }
                                ];
                            },
                            graph: {
                                url: "pose_web.binarypb"
                            },
                            listeners: [
                                {
                                    wants: [
                                        "pose_landmarks",
                                        "world_landmarks",
                                        "segmentation_mask",
                                        "image_transformed"
                                    ],
                                    outs: {
                                        image: {
                                            type: "texture",
                                            stream: "image_transformed"
                                        },
                                        poseLandmarks: {
                                            type: "proto",
                                            stream: "pose_landmarks",
                                            transform: Zb
                                        },
                                        poseWorldLandmarks: {
                                            type: "proto",
                                            stream: "world_landmarks",
                                            transform: Zb
                                        },
                                        segmentationMask: {
                                            type: "texture",
                                            stream: "segmentation_mask"
                                        }
                                    }
                                }
                            ],
                            inputs: {
                                image: {
                                    type: "video",
                                    stream: "input_frames_gpu"
                                }
                            },
                            options: {
                                useCpuInference: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "InferenceCalculator",
                                        fieldName: "use_cpu_inference"
                                    },
                                    default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                                },
                                selfieMode: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "GlScalerCalculator",
                                        calculatorIndex: 1,
                                        fieldName: "flip_horizontal"
                                    }
                                },
                                modelComplexity: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorModelComplexity",
                                        fieldName: "int_value"
                                    },
                                    onChange: function(c) {
                                        var d, e, g;
                                        return H(function(f) {
                                            if (f.g == 1) return d = qc(c), e = "third_party/mediapipe/modules/pose_landmark/" + d, F(f, kc(b.g, d), 2);
                                            g = f.h;
                                            b.g.overrideFile(e, g);
                                            return f.return(true);
                                        });
                                    }
                                },
                                smoothLandmarks: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks",
                                        fieldName: "bool_value"
                                    }
                                },
                                enableSegmentation: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorEnableSegmentation",
                                        fieldName: "bool_value"
                                    }
                                },
                                smoothSegmentation: {
                                    type: 0,
                                    graphOptionXref: {
                                        calculatorType: "ConstantSidePacketCalculator",
                                        calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation",
                                        fieldName: "bool_value"
                                    }
                                },
                                minDetectionConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "TensorsToDetectionsCalculator",
                                        calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
                                        fieldName: "min_score_thresh"
                                    }
                                },
                                minTrackingConfidence: {
                                    type: 1,
                                    graphOptionXref: {
                                        calculatorType: "ThresholdingCalculator",
                                        calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator",
                                        fieldName: "threshold"
                                    }
                                }
                            }
                        });
                    }
                    x = rc.prototype;
                    x.reset = function() {
                        this.g.reset();
                    };
                    x.close = function() {
                        this.g.close();
                        return Promise.resolve();
                    };
                    x.onResults = function(a) {
                        this.g.onResults(a);
                    };
                    x.initialize = function() {
                        var a = this;
                        return H(function(b) {
                            return F(b, a.g.initialize(), 0);
                        });
                    };
                    x.send = function(a, b) {
                        var c = this;
                        return H(function(d) {
                            return F(d, c.g.send(a, b), 0);
                        });
                    };
                    x.setOptions = function(a) {
                        this.g.setOptions(a);
                    };
                    J("Pose", rc);
                    J("POSE_CONNECTIONS", [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            2
                        ],
                        [
                            2,
                            3
                        ],
                        [
                            3,
                            7
                        ],
                        [
                            0,
                            4
                        ],
                        [
                            4,
                            5
                        ],
                        [
                            5,
                            6
                        ],
                        [
                            6,
                            8
                        ],
                        [
                            9,
                            10
                        ],
                        [
                            11,
                            12
                        ],
                        [
                            11,
                            13
                        ],
                        [
                            13,
                            15
                        ],
                        [
                            15,
                            17
                        ],
                        [
                            15,
                            19
                        ],
                        [
                            15,
                            21
                        ],
                        [
                            17,
                            19
                        ],
                        [
                            12,
                            14
                        ],
                        [
                            14,
                            16
                        ],
                        [
                            16,
                            18
                        ],
                        [
                            16,
                            20
                        ],
                        [
                            16,
                            22
                        ],
                        [
                            18,
                            20
                        ],
                        [
                            11,
                            23
                        ],
                        [
                            12,
                            24
                        ],
                        [
                            23,
                            24
                        ],
                        [
                            23,
                            25
                        ],
                        [
                            24,
                            26
                        ],
                        [
                            25,
                            27
                        ],
                        [
                            26,
                            28
                        ],
                        [
                            27,
                            29
                        ],
                        [
                            28,
                            30
                        ],
                        [
                            29,
                            31
                        ],
                        [
                            30,
                            32
                        ],
                        [
                            27,
                            31
                        ],
                        [
                            28,
                            32
                        ]
                    ]);
                    J("POSE_LANDMARKS", {
                        NOSE: 0,
                        LEFT_EYE_INNER: 1,
                        LEFT_EYE: 2,
                        LEFT_EYE_OUTER: 3,
                        RIGHT_EYE_INNER: 4,
                        RIGHT_EYE: 5,
                        RIGHT_EYE_OUTER: 6,
                        LEFT_EAR: 7,
                        RIGHT_EAR: 8,
                        LEFT_RIGHT: 9,
                        RIGHT_LEFT: 10,
                        LEFT_SHOULDER: 11,
                        RIGHT_SHOULDER: 12,
                        LEFT_ELBOW: 13,
                        RIGHT_ELBOW: 14,
                        LEFT_WRIST: 15,
                        RIGHT_WRIST: 16,
                        LEFT_PINKY: 17,
                        RIGHT_PINKY: 18,
                        LEFT_INDEX: 19,
                        RIGHT_INDEX: 20,
                        LEFT_THUMB: 21,
                        RIGHT_THUMB: 22,
                        LEFT_HIP: 23,
                        RIGHT_HIP: 24,
                        LEFT_KNEE: 25,
                        RIGHT_KNEE: 26,
                        LEFT_ANKLE: 27,
                        RIGHT_ANKLE: 28,
                        LEFT_HEEL: 29,
                        RIGHT_HEEL: 30,
                        LEFT_FOOT_INDEX: 31,
                        RIGHT_FOOT_INDEX: 32
                    });
                    J("POSE_LANDMARKS_LEFT", {
                        LEFT_EYE_INNER: 1,
                        LEFT_EYE: 2,
                        LEFT_EYE_OUTER: 3,
                        LEFT_EAR: 7,
                        LEFT_RIGHT: 9,
                        LEFT_SHOULDER: 11,
                        LEFT_ELBOW: 13,
                        LEFT_WRIST: 15,
                        LEFT_PINKY: 17,
                        LEFT_INDEX: 19,
                        LEFT_THUMB: 21,
                        LEFT_HIP: 23,
                        LEFT_KNEE: 25,
                        LEFT_ANKLE: 27,
                        LEFT_HEEL: 29,
                        LEFT_FOOT_INDEX: 31
                    });
                    J("POSE_LANDMARKS_RIGHT", {
                        RIGHT_EYE_INNER: 4,
                        RIGHT_EYE: 5,
                        RIGHT_EYE_OUTER: 6,
                        RIGHT_EAR: 8,
                        RIGHT_LEFT: 10,
                        RIGHT_SHOULDER: 12,
                        RIGHT_ELBOW: 14,
                        RIGHT_WRIST: 16,
                        RIGHT_PINKY: 18,
                        RIGHT_INDEX: 20,
                        RIGHT_THUMB: 22,
                        RIGHT_HIP: 24,
                        RIGHT_KNEE: 26,
                        RIGHT_ANKLE: 28,
                        RIGHT_HEEL: 30,
                        RIGHT_FOOT_INDEX: 32
                    });
                    J("POSE_LANDMARKS_NEUTRAL", {
                        NOSE: 0
                    });
                    J("VERSION", "0.5.1635988162");
                }).call(VonagePose);
                const _MediapipeHelper = class {
                    constructor(){
                        this.mediapipeMap_ = /* @__PURE__ */ new Map();
                    }
                    getVersion(modelType) {
                        switch(modelType){
                            case "face_detection":
                                return VonageFacedetection.VERSION;
                            case "face_mesh":
                                return VonageFacemash.VERSION;
                            case "hands":
                                return VonageHands.VERSION;
                            case "holistic":
                                return VonageHolistic.VERSION;
                            case "objectron":
                                return VonageObjectron.VERSION;
                            case "selfie_segmentation":
                                return VonageSelfiesegmentation.VERSION;
                            case "pose":
                                return VonagePose.VERSION;
                            default:
                                return "";
                        }
                    }
                    initialize(config) {
                        return new Promise(async (resolve, reject)=>{
                            if (config.mediaPipeModelConfigArray.length == 0) {
                                reject("no model was selected");
                                return;
                            }
                            for(let index = 0; index < config.mediaPipeModelConfigArray.length; index++){
                                const mediaPipeModelConfig = config.mediaPipeModelConfigArray[index];
                                if (this.mediapipeMap_.has(mediaPipeModelConfig.modelType)) {
                                    reject("setting same type is not supported");
                                    return;
                                }
                                if (typeof mediaPipeModelConfig.listener != "function") {
                                    reject(`[${mediaPipeModelConfig.modelType}] ResultsListener must be provided`);
                                    return;
                                }
                                let tempMediaPipe;
                                switch(mediaPipeModelConfig.modelType){
                                    case "face_mesh":
                                        tempMediaPipe = new VonageFacemash.FaceMesh({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "face_mesh/" + this.getVersion("face_mesh");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "face_detection":
                                        tempMediaPipe = new VonageFacedetection.FaceDetection({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "face_detection/" + this.getVersion("face_detection");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "hands":
                                        tempMediaPipe = new VonageHands.Hands({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "hands/" + this.getVersion("hands");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "holistic":
                                        tempMediaPipe = new VonageHolistic.Holistic({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "holistic/" + this.getVersion("holistic");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "objectron":
                                        tempMediaPipe = new VonageObjectron.Objectron({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "objectron/" + this.getVersion("objectron");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "selfie_segmentation":
                                        tempMediaPipe = new VonageSelfiesegmentation.SelfieSegmentation({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "selfie_segmentation/" + this.getVersion("selfie_segmentation");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    case "pose":
                                        tempMediaPipe = new VonagePose.Pose({
                                            locateFile: (path, prefix)=>{
                                                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "pose/" + this.getVersion("pose");
                                                return baseUrl + "/" + path;
                                            }
                                        });
                                        break;
                                    default:
                                        reject("unknown model type");
                                        return;
                                }
                                tempMediaPipe.onResults(mediaPipeModelConfig.listener);
                                if (mediaPipeModelConfig.options) tempMediaPipe.setOptions(mediaPipeModelConfig.options);
                                try {
                                    await tempMediaPipe.initialize();
                                    this.mediapipeMap_.set(mediaPipeModelConfig.modelType, tempMediaPipe);
                                } catch (e) {
                                    reject(e);
                                    return;
                                }
                            }
                            resolve();
                        });
                    }
                    close(modelType) {
                        return new Promise((resolve, reject)=>{
                            let promises = [];
                            if (modelType) {
                                let tempMediaPipe = this.mediapipeMap_.get(modelType);
                                if (tempMediaPipe) {
                                    this.mediapipeMap_.delete(modelType);
                                    promises.push(tempMediaPipe.close());
                                } else {
                                    reject("model not exit");
                                    return;
                                }
                            } else {
                                for (const [key, tempMediaPipe] of this.mediapipeMap_.entries())promises.push(tempMediaPipe.close());
                                this.mediapipeMap_.clear();
                            }
                            Promise.all(promises).then(()=>{
                                resolve();
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    send(image, modelType) {
                        return new Promise((resolve, reject)=>{
                            let promises = [];
                            if (modelType) {
                                let tempMediaPipe = this.mediapipeMap_.get(modelType);
                                if (tempMediaPipe) promises.push(tempMediaPipe.send({
                                    image: image
                                }));
                                else {
                                    reject("model not exit");
                                    return;
                                }
                            } else for (const [key, tempMediaPipe] of this.mediapipeMap_.entries())promises.push(tempMediaPipe.send({
                                image: image
                            }));
                            Promise.all(promises).then(()=>{
                                resolve();
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    reset(modelType) {
                        if (modelType) {
                            let tempMediaPipe = this.mediapipeMap_.get(modelType);
                            if (tempMediaPipe && typeof tempMediaPipe.reset === "function") tempMediaPipe.reset();
                        } else {
                            for (const [key, tempMediaPipe] of this.mediapipeMap_.entries())if (tempMediaPipe && typeof tempMediaPipe.reset === "function") tempMediaPipe.reset();
                        }
                    }
                };
                let MediapipeHelper = _MediapipeHelper;
                MediapipeHelper.defaultAssetsBaseUrl = "https://d3opqjmqzxf057.cloudfront.net/ml/mediapipe/";
                class VonageAssetsLoaderHelper {
                    static createVideoReadable(videoUri) {
                        return new Promise((resolve, reject)=>{
                            const bgvideo = document.createElement("video");
                            let errorAbortSignal = new AbortController();
                            let canplayAbortSignal = new AbortController();
                            bgvideo.addEventListener("canplay", ()=>{
                                errorAbortSignal.abort();
                                bgvideo.muted = true;
                                bgvideo.loop = true;
                                bgvideo.play().then(()=>{
                                    try {
                                        const bgMediaStream = bgvideo.captureStream();
                                        const processor = new MediaStreamTrackProcessor(bgMediaStream.getVideoTracks()[0]);
                                        resolve(processor.readable);
                                    } catch (e) {
                                        reject(e);
                                    }
                                });
                            }, {
                                once: true,
                                signal: canplayAbortSignal.signal
                            });
                            bgvideo.addEventListener("error", (e)=>{
                                canplayAbortSignal.abort();
                                reject("loading error:" + e);
                            }, {
                                once: true,
                                signal: errorAbortSignal.signal
                            });
                            bgvideo.crossOrigin = "anonymous";
                            bgvideo.src = videoUri;
                        });
                    }
                    static createImageCanvas(imageUri) {
                        return new Promise((resolve, reject)=>{
                            var img = new Image();
                            img.onload = function() {
                                createImageBitmap(img).then((image)=>{
                                    img.remove();
                                    resolve(image);
                                }).catch((e)=>{
                                    reject(e);
                                });
                            };
                            img.onerror = function(e) {
                                reject(e);
                            };
                            img.crossOrigin = "anonymous";
                            img.src = imageUri;
                        });
                    }
                }
                class VonageMediaProcessorWorker extends emittery {
                    constructor(){
                        super();
                        this.worker_ = new WorkerWrapper();
                        this.trackExpectedRate_ = -1;
                        this.workerInited_ = false;
                        this.mediapipeHelper_ = new MediapipeHelper();
                        this.innerEmitty_ = new emittery();
                        this.worker_.addEventListener("message", (msg)=>{
                            if (msg.data instanceof ImageBitmap) this.mediapipeHelper_.send(msg.data).then(()=>{
                                msg.data.close();
                            }).catch((e)=>{
                                let error = {
                                    error: e,
                                    eventMetaData: {
                                        transformerIndex: -1
                                    },
                                    function: "transform"
                                };
                                this.emit("error", error);
                            });
                            else {
                                let inputData = JSON.parse(msg.data);
                                if (inputData.callbackType === "success" || inputData.callbackType === "error") {
                                    if (inputData.message === "init") this.innerEmitty_.emit("initResults", msg.data);
                                    else if (inputData.message === "transform") this.innerEmitty_.emit("transformResults", msg.data);
                                    else if (inputData.message === "destroy") this.innerEmitty_.emit("destroyResults", msg.data);
                                    else if (inputData.message === "setBackgroundOptions") this.innerEmitty_.emit("setBackgroundOptionsResults", msg.data);
                                    else if (inputData.message === "setVideoBGReadable") this.innerEmitty_.emit("setVideoBGReadableResults", msg.data);
                                    else if (inputData.message === "setVirtualBGImage") this.innerEmitty_.emit("setVirtualBGImageResults", msg.data);
                                } else if (inputData.callbackType === "media_processor_error_event") this.emit("error", inputData.message);
                                else if (inputData.callbackType === "media_processor_warn_event") this.emit("warn", inputData.message);
                                else if (inputData.callbackType === "media_processor_pipeline_event") {
                                    this.emit("pipelineInfo", inputData.message);
                                    let msg2 = inputData.message;
                                    if (msg2.message === "pipeline_ended" || msg2.message === "pipeline_ended_with_error") this.mediapipeHelper_.close().finally(()=>{
                                        if (this.worker_) {
                                            this.cleanInnerEmitty();
                                            this.worker_.terminate();
                                            this.workerInited_ = false;
                                            this.worker_ = void 0;
                                        }
                                    });
                                }
                            }
                        });
                    }
                    cleanInnerEmitty() {
                        let error = "Worker ended";
                        if (this.innerEmitty_.listenerCount("initResults")) this.innerEmitty_.emit("initResults", JSON.stringify({
                            error: error
                        }));
                        if (this.innerEmitty_.listenerCount("destroyResults")) this.innerEmitty_.emit("destroyResults", JSON.stringify({
                            error: error
                        }));
                        if (this.innerEmitty_.listenerCount("setBackgroundOptionsResults")) this.innerEmitty_.emit("setBackgroundOptionsResults", JSON.stringify({
                            error: error
                        }));
                        if (this.innerEmitty_.listenerCount("setVideoBGReadableResults")) this.innerEmitty_.emit("setVideoBGReadableResults", JSON.stringify({
                            error: error
                        }));
                        if (this.innerEmitty_.listenerCount("setVirtualBGImageResults")) this.innerEmitty_.emit("setVirtualBGImageResults", JSON.stringify({
                            error: error
                        }));
                        if (this.innerEmitty_.listenerCount("transformResults")) this.innerEmitty_.emit("transformResults", JSON.stringify({
                            error: error
                        }));
                    }
                    init(config) {
                        return new Promise((resolve, reject)=>{
                            if (!this.worker_) {
                                reject("worker is off");
                                return;
                            }
                            let modelOptions = {
                                modelSelection: 1,
                                selfieMode: false
                            };
                            this.mediapipeHelper_.initialize({
                                mediaPipeModelConfigArray: [
                                    {
                                        assetsUri: config.mediapipeBaseAssetsUri,
                                        modelType: "selfie_segmentation",
                                        options: modelOptions,
                                        listener: (results)=>{
                                            let result = results;
                                            if (this.worker_) this.worker_.postMessage(result.segmentationMask, [
                                                result.segmentationMask
                                            ]);
                                        }
                                    }
                                ]
                            }).then(()=>{
                                let metaDataStr = JSON.stringify(getVonageMetadata());
                                if (typeof metaDataStr != "string") metaDataStr = JSON.stringify({});
                                if (!this.worker_) {
                                    reject("worker is off");
                                    return;
                                }
                                this.worker_.postMessage({
                                    operation: "init",
                                    metaData: metaDataStr
                                });
                                this.innerEmitty_.once("initResults").then((eventData)=>{
                                    let inputData = JSON.parse(eventData);
                                    if (inputData.callbackType === "success") {
                                        this.workerInited_ = true;
                                        if (this.trackExpectedRate_ != -1) this.postTrackExpectedRate();
                                        this.setBackgroundOptions(config).then(()=>{
                                            resolve();
                                        }).catch((e)=>{
                                            reject(e);
                                        });
                                    } else reject(inputData.error);
                                }).catch((e)=>{
                                    reject(e);
                                });
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    transform(readable, writable) {
                        return new Promise(async (resolve, reject)=>{
                            if (!this.worker_) {
                                reject("worker is off");
                                return;
                            }
                            this.worker_.postMessage({
                                operation: "transform",
                                readable: readable,
                                writable: writable
                            }, [
                                readable,
                                writable
                            ]);
                            this.innerEmitty_.once("transformResults").then((eventData)=>{
                                let inputData = JSON.parse(eventData);
                                if (inputData.callbackType === "success") resolve();
                                else reject(inputData.error);
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    destroy() {
                        return new Promise(async (resolve, reject)=>{
                            if (!this.worker_) {
                                resolve();
                                return;
                            }
                            this.worker_.postMessage({
                                operation: "destroy"
                            });
                            this.innerEmitty_.once("destroyResults").then((eventData)=>{
                                let inputData = JSON.parse(eventData);
                                if (inputData.callbackType === "success") this.mediapipeHelper_.close().then(()=>{
                                    resolve();
                                }).catch((e)=>{
                                    reject(e);
                                });
                                else reject(inputData.error);
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    setTrackExpectedRate(trackExpectedRate) {
                        this.trackExpectedRate_ = trackExpectedRate;
                        this.postTrackExpectedRate();
                    }
                    postTrackExpectedRate() {
                        if (this.workerInited_) this.worker_.postMessage({
                            operation: "setTrackExpectedRate",
                            rate: this.trackExpectedRate_
                        });
                    }
                    setBackgroundOptions(backgroundOptions) {
                        return new Promise((resolve, reject)=>{
                            if (!this.worker_) {
                                reject("worker is off");
                                return;
                            }
                            this.worker_.postMessage({
                                operation: "setBackgroundOptions",
                                backgroundOptions: JSON.stringify(backgroundOptions)
                            });
                            this.innerEmitty_.once("setBackgroundOptionsResults").then((eventData)=>{
                                let inputData = JSON.parse(eventData);
                                if (inputData.callbackType === "success") {
                                    if (backgroundOptions.transformerType === "VideoBackground") VonageAssetsLoaderHelper.createVideoReadable(backgroundOptions.backgroundAssetUri).then((res)=>{
                                        if (!this.worker_) {
                                            reject("worker is off");
                                            return;
                                        }
                                        this.worker_.postMessage({
                                            operation: "setVideoBGReadable",
                                            readable: res
                                        }, [
                                            res
                                        ]);
                                        this.innerEmitty_.once("setVideoBGReadableResults").then((eventData2)=>{
                                            let inputData2 = JSON.parse(eventData2);
                                            if (inputData2.callbackType === "success") resolve();
                                            else reject(inputData2.error);
                                        }).catch((e)=>{
                                            reject(e);
                                        });
                                    }).catch((e)=>{
                                        reject(e);
                                    });
                                    else if (backgroundOptions.transformerType === "VirtualBackground") VonageAssetsLoaderHelper.createImageCanvas(backgroundOptions.backgroundAssetUri).then((res)=>{
                                        if (!this.worker_) {
                                            reject("worker is off");
                                            return;
                                        }
                                        this.worker_.postMessage({
                                            operation: "setVirtualBGImage",
                                            image: res
                                        }, [
                                            res
                                        ]);
                                        this.innerEmitty_.once("setVirtualBGImageResults").then((eventData2)=>{
                                            let inputData2 = JSON.parse(eventData2);
                                            if (inputData2.callbackType === "success") resolve();
                                            else reject(inputData2.error);
                                        }).catch((e)=>{
                                            reject(e);
                                        });
                                    }).catch((e)=>{
                                        reject(e);
                                    });
                                    else resolve();
                                } else reject(inputData.error);
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                }
                var BlurRadius = /* @__PURE__ */ ((BlurRadius2)=>{
                    BlurRadius2["Low"] = "Low";
                    BlurRadius2["High"] = "High";
                    return BlurRadius2;
                })(BlurRadius || {});
                const simd = async ()=>WebAssembly.validate(new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        5,
                        1,
                        96,
                        0,
                        1,
                        123,
                        3,
                        2,
                        1,
                        0,
                        10,
                        10,
                        1,
                        8,
                        0,
                        65,
                        0,
                        253,
                        15,
                        253,
                        98,
                        11
                    ]));
                function isSupported() {
                    return new Promise(async (resolve, reject)=>{
                        try {
                            await isSupported$1();
                        } catch (e) {
                            reject(e);
                            return;
                        }
                        simd().then((isSIMDSupported)=>{
                            if (isSIMDSupported === false) {
                                reject("Your browser does not support WebAssembly features.");
                                return;
                            }
                            resolve();
                        }).catch((e)=>{
                            reject(e);
                        });
                    });
                }
                let vonageMediaProcessor_;
                let trackExpectedRate_ = -1;
                function getVonageEventEmitter() {
                    return vonageMediaProcessor_;
                }
                function setTrackExpectedRate(trackExpectedRate) {
                    trackExpectedRate_ = trackExpectedRate;
                    if (typeof vonageMediaProcessor_ != "undefined") vonageMediaProcessor_.setTrackExpectedRate(trackExpectedRate_);
                }
                function createVonageMediaProcessorConnector(config) {
                    return new Promise(async (resolve, reject)=>{
                        vonageMediaProcessor_ = new VonageMediaProcessorWorker();
                        if (trackExpectedRate_ != -1) vonageMediaProcessor_.setTrackExpectedRate(trackExpectedRate_);
                        vonageMediaProcessor_.init(config).then(()=>{
                            const connector = new MediaProcessorConnector(vonageMediaProcessor_);
                            resolve(connector);
                        }).catch((e)=>{
                            reject(e);
                        });
                    });
                }
                function setBackgroundOptions(backgroundOptions) {
                    return new Promise((resolve, reject)=>{
                        if (vonageMediaProcessor_) vonageMediaProcessor_.setBackgroundOptions(backgroundOptions).then(()=>{
                            resolve();
                        }).catch((e)=>{
                            reject(e);
                        });
                        else reject("media processor is not set");
                    });
                }
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0), __webpack_require__(43));
        /***/ },
        /* 313 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const defaultStaticConfig = __webpack_require__(35)().onlyLocal(); // Returns URL of CDN on which ML assets are hosted
            const getCdnUrl = (staticConfig)=>{
                const apiUrl = staticConfig.apiUrl;
                const isProd = apiUrl.includes('anvil.opentok.com');
                const host = isProd ? 'https://static.opentok.com' : 'https://www.dev.tokbox.com';
                return `${host}/ml-transformers/v3.0.0`;
            }; // Default configuration that may be shared by all ML transforms
            const DefaultConfig = {
                getConfig: function getConfig(deps) {
                    if (deps === void 0) deps = {};
                    const _deps = deps, _deps$staticConfig = _deps.staticConfig, staticConfig = _deps$staticConfig === void 0 ? defaultStaticConfig : _deps$staticConfig;
                    const cdnUrl = getCdnUrl(staticConfig);
                    return {
                        mediapipeBaseAssetsUri: `${cdnUrl}`
                    };
                }
            };
            module1.exports = DefaultConfig;
        /***/ },
        /* 314 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require, max-len,  prefer-rest-params */ /* eslint-disable no-use-before-define */ const isFunction = __webpack_require__(17);
            const isObject = __webpack_require__(11);
            const isNullOrFalse = __webpack_require__(703);
            const setVideoContentHintIfCanvas = __webpack_require__(704);
            const setScalableScreenshare = __webpack_require__(705);
            module1.exports = function initPublisherFactory(deps) {
                if (deps === void 0) deps = {};
                const Errors = deps.Errors || __webpack_require__(6);
                const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                const logging = deps.logging || __webpack_require__(2)('publisherInit');
                const otError = deps.otError || __webpack_require__(13)();
                const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                const Publisher = deps.Publisher || __webpack_require__(168)();
                const sessionObjects = deps.sessionObjects || __webpack_require__(21);
                /**
  * <p class="mSummary">
  *   Initializes and returns a Publisher object. You can then pass this Publisher
  *   object to <code>Session.publish()</code> to publish a stream to a session.
  * </p>
  * <p>
  *   <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
  *   (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
  *   event dispatched by the Publisher object (when it stops publishing). In the event listener,
  *   call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
  *   video from being removed from the page.
  * </p>
  *
  * @param {Object} targetElement (Optional) The DOM element or the <code>id</code> attribute of the
  * existing DOM element used to determine the location of the Publisher video in the HTML DOM. See
  * the <code>insertMode</code> property of the <code>properties</code> parameter. If you do not
  * specify a <code>targetElement</code>, the application appends a new DOM element to the HTML
  * <code>body</code>.
  *
  * <p>
  *       The application throws an error if an element with an ID set to the
  *       <code>targetElement</code> value does not exist in the HTML DOM.
  * </p>
  *
  * @param {Object} properties (Optional) This object contains the following properties (each of which
  * are optional):
  * </p>
  * <ul>
  * <li>
  *   <strong>audioBitrate</strong> (Number) &#151; The desired bitrate for the published audio,
  *   in bits per second. The supported range of values is 6,000 - 510,000. (Invalid values are
  *   ignored.) Set this value to enable high-quality audio (or to reduce bandwidth usage with
  *   lower-quality audio).
  *   <p>
  *   The following are recommended settings:
  *   <ul>
  *     <li>8,000 - 12,000 for narrowband (NB) speech</li>
  *     <li>16,000 - 20,000 for wideband (WB) speech</li>
  *     <li>28,000 - 40,000 for full-band (FB) speech</li>
  *     <li>48,000 - 64,000 for full-band (FB) music</li>
  *   </ul>
  *   </p>
  *   <p>
  *   The default value is 40,000.
  *   </p>
  *   <p>
  *     Currently, this setting is not supported in streams published in Firefox.
  *   </p>
  * </li>
  * <li>
  *   <strong>audioFallbackEnabled</strong> (Boolean) &#151; Whether the stream will use the
  *   audio-fallback feature (<code>true</code>) or not (<code>false</code>). The audio-fallback
  *   feature is available in sessions that use the OpenTok Media Router. With the audio-fallback
  *   feature enabled (the default), when the server determines that a stream's quality has degraded
  *   significantly for a specific subscriber, it disables the video in that subscriber in order to
  *   preserve audio quality. For streams that use a camera as a video source, the default setting is
  *   <code>true</code> (the audio-fallback feature is enabled). The default setting is
  *   <code>false</code> (the audio-fallback feature is disabled) for screen-sharing streams, which
  *   have the <code>videoSource</code> property set to <code>"application"</code>,
  *   <code>"screen"</code>, or <code>"window"</code> in the <code>OT.initPublisher()</code>
  *   options. For more information, see the Subscriber
  *   <a href="Subscriber.html#event:videoDisabled">videoDisabled</a> event and
  *   <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">the OpenTok Media
  *   Router and media modes</a>.
  * </li>
  * <li>
  *   <strong>audioSource</strong> (String, MediaStreamTrack, Boolean, or null) &#151;
  *    The ID of the audio input device (such as a
  *    microphone) to be used by the publisher. You can obtain a list of available devices, including
  *    audio input devices, by calling the <a href="#getDevices">OT.getDevices()</a> method. Each
  *    device listed by the method has a unique device ID. If you pass in a device ID that does not
  *    match an existing audio input device, the call to <code>OT.initPublisher()</code> fails with an
  *    error (error code 1500, "Unable to Publish") passed to the completion handler function.
  *    <p>
  *    If you set this property to <code>null</code> or <code>false</code>, the browser does not
  *    request access to the microphone, and no audio is published.
  *    </p>
  *    <p>
  *    You can also set this property to an audio
  *    <a href="https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack">
  *    MediaStreamTrack</a> object. This lets you use the object as the audio source for
  *    the published stream. For example, you can get an array of audio MediaStreamTrack objects
  *    from the <code>audioTracks</code> property of an HTMLMediaElement object. Or you can call
  *    the <code>getLocalStreams()</code> or <code>getRemoteStreams()</code> method of an
  *    RTCPeerConnection object to get an array of MediaStream objects, and then call the
  *    <code>getAudioTracks()</code> method of one of the MediaStream objects to get an audio
  *    MediaStreamTrack object.
  *    </p>
  * </li>
  * <li>
  *   <strong>autoGainControl</strong> (Boolean) &#151; Whether to enable automatic gain control
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>false</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>disableAudioProcessing</strong> (Boolean) &#151; Whether to disable echo cancellation,
  *   automatic gain control, and noise suppression for the published audio. You may want to set
  *   this to <code>true</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>false</code>.
  * </li>
  * <li>
  *   <strong>echoCancellation</strong> (Boolean) &#151; Whether to enable echo cancellation
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>false</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>enableStereo</strong> (Boolean) &#151; Whether to publish stereo audio. The default
  *   value is <code>false</code>.
  *   <p>
  *   <i>Note:</i> Some browsers (such as Chome 73+) do not support
  *   echo cancellation for stereo audio (see <a target="_blank"
  *   href="https://bugs.chromium.org/p/webrtc/issues/detail?id=10465">this
  *   Chrome issue report</a>).
  * </li>
  * <li>
  *   <strong>enableDtx</strong> (Boolean) &#151; Whether to enable
  *   <a target="_blank" href="https://datatracker.ietf.org/doc/html/rfc7587#section-3.1.3">Opus DTX</a>. The default
  *   value is <code>false</code>. Setting this to <code>true</code> can reduce bandwidth usage
  *   in streams that have long periods of silence.
  * </li>
  * <li>
  *   <strong>facingMode</strong> (String) &#151; The preferred camera position to use for the
  *   video source. Generally, this setting only applies to mobile devices. This can be set to
  *   one of the following values:
  *   <p>
  *     <ul>
  *       <li>
  *         <code>"user"</code> &mdash; The front-facing camera.
  *       </li>
  *       <li>
  *         <code>"environment"</code> &mdash; The back camera.
  *       </li>
  *       <li>
  *         <code>"left"</code> &mdash; The camera facing the user but to the left
  *         (uncommon).
  *       </li>
  *       <li>
  *         <code>"right"</code> &mdash; The camera facing the user but to the right
  *         (uncommon).
  *       </li>
  *     </ul>
  *   </p>
  * </li>
  * <li>
  *   <strong>fitMode</strong> (String) &#151; Determines how the video is displayed if the its
  *     dimensions do not match those of the DOM element. You can set this property to one of the
  *     following values:
  *     <p>
  *     <ul>
  *       <li>
  *         <code>"cover"</code> &mdash; The video is cropped if its dimensions do not match those of
  *         the DOM element. This is the default setting for videos publishing a camera feed.
  *       </li>
  *       <li>
  *         <code>"contain"</code> &mdash; The video is letterboxed if its dimensions do not match
  *         those of the DOM element. This is the default setting for screen-sharing videos.
  *       </li>
  *     </ul>
  * </li>
  * <li>
  *   <strong>frameRate</strong> (Number) &#151; The desired frame rate, in frames per second,
  *   of the video. Valid values are 30, 15, 7, and 1. The published stream will use the closest
  *   value supported on the publishing client. The frame rate can differ slightly from the value
  *   you set, depending on the browser of the client. And the video will only use the desired
  *   frame rate if the client configuration supports it.
  *   <br><br><p>If the publisher specifies a frame rate, the actual frame rate of the video stream
  *   is set as the <code>frameRate</code> property of the Stream object, though the actual frame rate
  *   will vary based on changing network and system conditions. If the developer does not specify a
  *   frame rate, this property is undefined. Also, if the video source is a video MediaStreamTrack
  *   object (see the <code>videoSource</code>), this value is ignored and the frame rate is
  *   defined by the MediaStreamTrack object, which you can get by calling the
  *   <code>getConstraints()</code> method of the MediaStreamTrack object.
  *   </p>
  *   <p>
  *   For sessions that use the OpenTok Media Router (sessions with
  *   the <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
  *   set to routed, lowering the frame rate proportionally reduces the maximum bandwidth the stream
  *   uses. However, in sessions with the media mode set to relayed, lowering the frame rate does not
  *   reduce the stream's bandwidth.
  *   </p>
  *   <p>
  *   You can also restrict the frame rate of a Subscriber's video stream. To restrict the frame rate
  *   a Subscriber, call the <code>restrictFrameRate()</code> method of the subscriber, passing in
  *   <code>true</code>.
  *   (See <a href="Subscriber.html#restrictFrameRate">Subscriber.restrictFrameRate()</a>.)
  *   </p>
  * </li>
  * <li>
  *   <strong>height</strong> (Number or String) &#151; The desired initial height of the displayed Publisher
  *   video in the HTML page (default: 198 pixels). You can specify the number of pixels as either
  *   a number (such as 300) or a string ending in "px" (such as "300px"). Or you can specify a
  *   percentage of the size of the parent element, with a string ending in "%" (such as "100%").
  *   <i>Note:</i> To resize the publisher video, adjust the CSS of the publisher's DOM element
  *   (the <code>element</code> property of the Publisher object) or (if the height is specified as
  *   a percentage) its parent DOM element (see
  *   <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">Resizing
  *   or repositioning a video</a>).
  * </li>
  * <li>
  *   <strong>insertDefaultUI</strong> (Boolean) &#151; Whether to use the default OpenTok UI
  *   (<code>true</code>, the default) or not (<code>false</code>). The default UI element contains
  *   user interface controls, a video loading indicator, and automatic video cropping or
  *   letterboxing, in addition to the video. (If you leave <code>insertDefaultUI</code> set to
  *   <code>true</code>, you can control individual UI settings using the <code>fitMode</code>,
  *   <code>showControls</code>, and <code>style</code> options.)
  *   <p>
  *   If you set this option to <code>false</code>, OpenTok.js does not insert a default UI element
  *   in the HTML DOM, and the <code>element</code> property of the Publisher object is undefined.
  *   Instead, the Publisher object dispatches a
  *   <a href="Publisher.html#event:videoElementCreated">videoElementCreated</a> event when
  *   the <code>video</code> element (or in Internet Explorer the <code>object</code> element
  *   containing the video) is created. The <code>element</code> property of the event object is a
  *   reference to the Publisher's <code>video</code> (or <code>object</code>) element. Add it to
  *   the HTML DOM to display the video.
  *   <p>
  *   Set this option to <code>false</code> if you want to move the Publisher's <code>video</code>
  *   (or <code>object</code>) element in the HTML DOM.
  *   <p>
  *   If you set this to <code>false</code>, do not set the <code>targetElement</code> parameter.
  *   (This results in an error passed into to the <code>OT.initPublisher()</code> callback
  *   function.) To add the video to the HTML DOM, add an event listener for the
  *   <code>videoElementCreated</code> event, and then add the <code>element</code> property of
  *   the event object into the HTML DOM.
  * </li>
  * <li>
  *   <strong>insertMode</strong> (String) &#151; Specifies how the Publisher object will be
  *   inserted in the HTML DOM. See the <code>targetElement</code> parameter. This string can
  *   have the following values:
  *   <p>
  *   <ul>
  *     <li><code>"replace"</code> &#151; The Publisher object replaces contents of the
  *       targetElement. This is the default.</li>
  *     <li><code>"after"</code> &#151; The Publisher object is a new element inserted after
  *       the targetElement in the HTML DOM. (Both the Publisher and targetElement have the
  *       same parent element.)</li>
  *     <li><code>"before"</code> &#151; The Publisher object is a new element inserted before
  *       the targetElement in the HTML DOM. (Both the Publisher and targetElement have the same
  *       parent element.)</li>
  *     <li><code>"append"</code> &#151; The Publisher object is a new element added as a child
  *       of the targetElement. If there are other child elements, the Publisher is appended as
  *       the last child element of the targetElement.</li>
  *   </ul></p>
  * <li>
  *   <strong>maxResolution</strong> (Object) &#151; Sets the maximum resolution to stream.
  *   This setting only applies to when the <code>videoSource</code> property is set to
  *   <code>"application"</code>, <code>"screen"</code>, or <code>"window"</code>
  *   (when the publisher is screen-sharing). The resolution of the
  *   stream will match the captured screen region unless the region is greater than the
  *   <code>maxResolution</code> setting. Set this to an object that has two properties:
  *   <code>width</code> and <code>height</code> (both numbers). The maximum value for each of
  *   the <code>width</code> and <code>height</code> properties is 1920, and the minimum value
  *   is 10.
  * </li>
  * <li>
  *   <strong>mirror</strong> (Boolean) &#151; Whether the publisher's video image
  *   is mirrored in the publisher's page. The default value is <code>true</code>
  *   (the video image is mirrored), except for a screen-sharing video (when the
  *   <code>videoSource</code> property is set to <code>"application"</code>,
  *   <code>"screen"</code>, or <code>"window"</code>
  *   (in which case the default is <code>false</code>). This property
  *   does not affect the display on subscribers' views of the video.
  * </li>
  * <li>
  *   <strong>name</strong> (String) &#151; The name for this stream. The name appears at
  *   the bottom of Subscriber videos. The default value is "" (an empty string). Setting
  *   this to a string longer than 1000 characters results in an runtime exception.
  * </li>
  * <li>
  *   <strong>noiseSuppression</strong> (Boolean) &#151; Whether to enable noise suppression
  *   for the published audio. You may want to set
  *   this to <code>false</code> when publishing high-quality audio (by setting the
  *   <code>audioBitrate</code> property of the <code>OT.initPublisher()</code> options). The
  *   default value is <code>true</code>. This setting is ignored if you set <code>disableAudioProcessing</code>
  *   to <code>false</code> (which disables echo cancellation, automatic gain control, and noise suppression for
  *   the published stream).
  * </li>
  * <li>
  *   <strong>publishAudio</strong> (Boolean) &#151; Whether to initially publish audio
  *   for the stream (default: <code>true</code>). This setting applies when you pass
  *   the Publisher object in a call to the <code>Session.publish()</code> method.
  * </li>
  * <li>
  *   <strong>publishVideo</strong> (Boolean) &#151; Whether to initially publish video
  *   for the stream (default: <code>true</code>). This setting applies when you pass
  *   the Publisher object in a call to the <code>Session.publish()</code> method.
  * </li>
  * <li>
  *   <strong>resolution</strong> (String) &#151; The desired resolution of the video. The format
  *   of the string is <code>"widthxheight"</code>, where the width and height are represented in
  *   pixels. Valid values are <code>"1920x1080"</code>, <code>"1280x720"</code>, <code>"640x480"</code>,
  *   and <code>"320x240"</code>. The published video will only use the desired resolution if the
  *   client configuration supports it. Some browsers and clients do not support each of these
  *   resolution settings.
  *   <br><br><p>
  *   The requested resolution of a video stream is set as the <code>videoDimensions.width</code> and
  *   <code>videoDimensions.height</code> properties of the Stream object.
  *   </p>
  *   <p>
  *   The default resolution for a stream (if you do not specify a resolution) is 640x480 pixels.
  *   If the client system cannot support the resolution you requested, the stream will use the
  *   next largest setting supported.
  *   </p>
  *   <p>
  *   The actual resolution used by the Publisher is returned by the <code>videoHeight()</code> and
  *   <code>videoWidth()</code> methods of the Publisher object. The actual resolution of a
  *   Subscriber video stream is returned by the <code>videoHeight()</code> and
  *   <code>videoWidth()</code> properties of the Subscriber object. These may differ from the values
  *   of the <code>resolution</code> property passed in as the <code>properties</code> property of the
  *   <code>OT.initPublisher()</code> method, if the browser does not support the requested
  *   resolution, this value is ignored. Also, if the video source is a video MediaStreamTrack
  *   object (see the <code>videoSource</code>), this value is ignored and the resolution
  *   is defined by the MediaStreamTrack object, which you can get by calling the
  *   <code>getConstraints()</code> method of the MediaStreamTrack object.
  *   </p>
  * </li>
  * <li>
  *   <strong>scalableScreenshare</strong> (Boolean) &#151; Whether to allow use of
  *   <a href="https://tokbox.com/developer/guides/scalable-video/">scalable video</a>
  *   for a publisher that has the <code>videoSource</code> set to <code>"screen"</code> (<code>true</code>)
  *   or not (<code>false</code>, the default).
  * </li>
  * <li>
  *   <strong>showControls</strong> (Boolean) &#151; Whether to display the built-in user interface
  *   controls (default: <code>true</code>) for the Publisher. These controls include the name
  *   display, the audio level indicator, and the microphone control button. You can turn off all user
  *   interface controls by setting this property to <code>false</code>. You can control the display
  *   of individual user interface controls by leaving this property set to <code>true</code> (the
  *   default) and setting individual properties of the <code>style</code> property.
  * </li>
  * <li>
  *   <strong>style</strong> (Object) &#151; An object containing properties that define the initial
  *   appearance of user interface controls of the Publisher. The <code>style</code> object includes
  *   the following properties:
  *     <ul>
  *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
  *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
  *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
  *       <code>"on"</code> (the indicator is always displayed).</li>
  *
  *       <li><code>archiveStatusDisplayMode</code> (String) &mdash; How to display the archive status
  *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
  *       session is being recorded), <code>"off"</code> (the indicator is not displayed). If you
  *       disable the archive status display indicator, you can display your own user interface
  *       notifications based on the <code>archiveStarted</code> and <code>archiveStopped</code>
  *       events dispatched by the Session object.</li>
  *
  *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
  *       the background image when a video is not displayed. (A video may not be displayed if
  *       you call <code>publishVideo(false)</code> on the Publisher object). You can pass an http
  *       or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
  *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
  *       PNG data, such as that obtained from the
  *       <a href="Publisher.html#getImgData">Publisher.getImgData()</a> method. (For example,
  *       you could set the property to a value returned by calling <code>getImgData()</code> on
  *       a previous Publisher object.) If the URL or the image data is invalid, the property
  *       is ignored (the attempt to set the image fails silently).</li>
  *
  *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the microphone controls
  *       Possible values are: <code>"auto"</code> (controls are displayed when the stream is first
  *       displayed and when the user mouses over the display), <code>"off"</code> (controls are not
  *       displayed), and <code>"on"</code> (controls are always displayed).</li>
  *
  *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
  *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
  *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
  *       displayed), and <code>"on"</code> (the name is always displayed).</li>
  *   </ul>
  * </li>
  * <li>
  *   <strong>videoContentHint</strong> (String) &#151; Sets the content hint of
  *    the the video track of the publisher's stream. This allows browsers to use encoding
  *    or processing methods more appropriate to the type of content. You can set this to one of
  *    the following values:
  *    <p>
  *    <ul>
  *      <li>
  *        <code>""</code> &mdash; No hint is provided (the default).
  *      </li>
  *      <li>
  *        <code>"motion"</code> &mdash; The track should be treated as if it contains video
  *        where motion is important. For example, you may use this setting for a screen-sharing
  *        stream that contains video.
  *      </li>
  *      <li>
  *        <code>"detail"</code> &mdash; The track should be treated as if video details
  *        are extra important. For example, you may use this setting for a screen-sharing
  *        stream that contains text content, painting, or line art.
  *      </li>
  *      <li>
  *        <code>"text"</code> &mdash; The track should be treated as if text details are
  *        extra important. For example, you may use this setting for a screen-sharing
  *        stream that contains text content.
  *      </li>
  *    </ul>
  *    </p>
  *    <p>
  *      With the &quot;text&quot; and &quot;detailed&quot; content hints, the browser attempts to maintain
  *      high resolution, even if it must reduce the video frame rate. For the &quot;motion&quot; content hint,
  *      the browser reduces resolution to prevent the frame rate from stalling.
  *    </p>
  *    <p>
  *    You can read more about these options in the
  *    <a href="https://www.w3.org/TR/mst-content-hint/#video-content-hints">W3C Working Draft</a>.
  *    You may want to set the video content hint to optimize performance for screen-sharing
  *    videos. For example, you can set it to <code>"text"</code> when sharing a screen that contains
  *    a lot of text (such as a slideshow).
  *    </p>
  *    <p>
  *    Chrome 60+, Safari 12.1+, Edge 79+, and Opera 47+ support video content hints.
  *    </p>
  *    <p>
  *      Also see the <a href="Publisher.html#setVideoContentHint">Publisher.setVideoContentHint()</a> method
  *      and the <a href="http://tokbox.com/developer/guides/publish-stream/js/#video-content-hint">developer
  *      guide topic on this feature</a>.
  *    </p>
  * </li>
  * <li>
  *   <strong>videoFilter</strong> (Object) &#151; An object containing properties that define the
  *   video filter to be applied to the Publisher's video stream. The following
  *   filters are supported:
  *   <ul>
  *     <li>
  *       <p>
  *       <em>Background blur filter</em> &mdash; Set the <code>type</code> property of the object to
  *       <code>"backgroundBlur"</code>.
  *       <p>
  *       A background blur filter object includes an additional <code>blurStrength</code> property, which
  *       defines the blur radius and is optional. Set this to either <code>"low"</code> or
  *       <code>"high"</code> (the default).
  *     </li>
  *     <li>
  *       <p>
  *       <em>Background replacement filter</em> &mdash; Set the <code>type</code> property of the object to
  *       <code>"backgroundReplacement"</code>.
  *       <p>
  *       A background replacement filter object includes an additional <code>backgroundImgUrl</code>
  *       property, which defines the URL of the background image to use. Also accepted are image BLOBs
  *       (a Base64-encoded string of image data).
  *       The following image formats are supported: BMP, PNG, JPEG, and GIF.
  *       <p>
  *       This is a <em>beta</em> feature.
  *     </li>
  *   </ul>
  *   <em>Note:</em> Video filters are only supported in recent versions of Chrome, Electron, Opera, and Edge.
  *   They are not supported in other (non-Chromium-based) browsers or on iOS. You can check if the client
  *   supports this feature by calling the
  *   <a href="OT.html#hasMediaProcessorSupport">OT.hasMediaProcessorSupport()</a> method.
  *   <p>
  *   You can change the video filter by calling the
  *   <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a> method.
  *   You can remove the video filter by calling the
  *   <a href="Publisher.html#clearVideoFilter">Publisher.clearVideoFilter()</a> method.
  * </li>
  * <li>
  *   <strong>videoSource</strong> (String, MediaStreamTrack, Boolean, or null) &#151;
  *    The ID of the video input device (such as a
  *    camera) to be used by the publisher. You can obtain a list of available devices, including
  *    video input devices, by calling the <a href="#getDevices">OT.getDevices()</a> method. Each
  *    device listed by the method has a unique device ID. If you pass in a device ID that does not
  *    match an existing video input device, the call to <code>OT.initPublisher()</code> fails with an
  *    error (error code 1500, "Unable to Publish") passed to the completion handler function.
  *    <p>
  *    If you set this property to <code>null</code> or <code>false</code>, the browser does not
  *    request access to the camera, and no video is published. In a voice-only call, set this
  *    property to <code>null</code> or <code>false</code> for each Publisher.
  *    </p>
  *   <p>
  *    To publish a screen-sharing stream, set this property to <code>"screen"</code>.
  *    In older browser versions, you could also pass in <code>"application"</code> or
  *    <code>"window"</code> to specify a type of screen-sharing source. However, in current
  *    browsers that support screen sharing, passing in any of these values results in
  *    the same behavior &mdash; the browser displays a dialog box in which the end user
  *    selects the screen-sharing source (which can be the entire screen or a specific window).
  *    In Electron, screen sharing captures the entire screen, without prompting
  *    the user for permission. For screen-sharing streams, the following are
  *    default values for other properties: <code>audioFallbackEnabled == false</code>,
  *    <code>maxResolution == {width: 1920, height: 1920}</code>, <code>mirror == false</code>,
  *    <code>scaleMode == "fit"</code>. Also, the default <code>scaleMode</code> setting for
  *    subscribers to the stream is <code>"fit"</code>.
  *   </p>
  *   <p>
  *    You can also set this property to a video
  *    <a href="https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamTrack">
  *    MediaStreamTrack</a> object. This lets you use the MediaStreamTrack object as the
  *    video source for the published stream. For example, you can get a CanvasCaptureMediaStream
  *    object by calling the <code>captureStream()</code> method of a HTMLCanvasElement, and then
  *    you can call the <code>getVideoTracks()</code> method of the CanvasCaptureMediaStream object
  *    to get a video MediaStreamTrack object. Or you can get an array of video MediaStreamTrack
  *    object from the <code>videoTracks</code> property of an HTMLMediaElement object. Or you can
  *    call the <code>getLocalStreams()</code> or <code>getRemoteStreams()</code> method of an
  *    RTCPeerConnection object to get an array of MediaStream objects, and then call the
  *    <code>getVideoTracks()</code> method of one of the MediaStream objects to get an array
  *    of video MediaStreamTrack objects. Note that by default the publisher uses a microphone
  *    as the audio source, so be sure to set the <code>audioSource</code> option if you want
  *    to use a MediaStreamTrack as the audio source or if you do not want to publish an audio
  *    track. The default <code>mirror</code> setting for a Publisher with a MediaStreamTrack video
  *    source is <code>false</code>. You can also call
  *    <a href="OT.html#getUserMedia">OT.getUserMedia()</a> to get a MediaStream object that uses
  *    the microphone and camera as the audio and video sources.
  *   </p>
  * </li>
  * <li>
  *   <strong>width</strong> (Number or String) &#151; The desired initial width of the displayed Publisher
  *   video in the HTML page (default: 264 pixels). You can specify the number of pixels as either
  *   a number (such as 400) or a string ending in "px" (such as "400px"). Or you can specify a
  *   percentage of the size of the parent element, with a string ending in "%" (such as "100%").
  *   <i>Note:</i> To resize the publisher video, adjust the CSS of the publisher's DOM element
  *   (the <code>element</code> property of the Publisher object) or (if the width is specified as
  *   a percentage) its parent DOM element (see
  *   <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">Resizing
  *   or repositioning a video</a>).
  * </li>
  * </ul>
  * @param {Function} completionHandler (Optional) A function to be called when the method succeeds
  * or fails in initializing a Publisher object. This function takes one parameter &mdash;
  * <code>error</code>. On success, the <code>error</code> object is set to <code>null</code>. On
  * failure, the <code>error</code> object has two properties: <code>code</code> (an integer) and
  * <code>message</code> (a string), which identify the cause of the failure. The method succeeds
  * when the user grants access to the camera and microphone. The method fails if the user denies
  * access to the camera and microphone. The <code>completionHandler</code> function is called
  * before the Publisher dispatches an <code>accessAllowed</code> (success) event or an
  * <code>accessDenied</code> (failure) event.
  * <p>
  * The following code adds a <code>completionHandler</code> when calling the
  * <code>OT.initPublisher()</code> method:
  * </p>
  * <pre>
  * var publisher = OT.initPublisher('publisher', null, function (error) {
  *   if (error) {
  *     console.log(error);
  *   } else {
  *     console.log("Publisher initialized.");
  *   }
  * });
  * </pre>
  *
  * @returns {Publisher} The Publisher object.
  * @see <a href="Session.html#publish">Session.publish()</a>
  * @method OT.initPublisher
  * @memberof OT
  */ return function initPublisher(targetElement, properties, completionHandler) {
                    logging.debug(`OT.initPublisher(${targetElement})`); // To support legacy (apikey, targetElement, properties) users
                    // we check to see if targetElement is actually an apikey. Which we ignore.
                    if (typeof targetElement === 'string' && !document.getElementById(targetElement)) {
                        targetElement = properties;
                        properties = completionHandler;
                        completionHandler = arguments[3];
                    }
                    if (typeof targetElement === 'function') {
                        completionHandler = targetElement;
                        properties = undefined;
                        targetElement = undefined;
                    } else if (isObject(targetElement) && !OTHelpers.isElementNode(targetElement)) {
                        completionHandler = properties;
                        properties = targetElement;
                        targetElement = undefined;
                    }
                    if (typeof properties === 'function') {
                        completionHandler = properties;
                        properties = undefined;
                    }
                    let errMsg;
                    if (properties) {
                        if (!isObject(properties)) {
                            errMsg = 'properties argument to Publisher constructor, if provided, should be an object';
                            properties = undefined;
                        } else if (properties.insertDefaultUI === false && targetElement) errMsg = 'You cannot specify a target element if insertDefaultUI is false';
                        else if (isNullOrFalse(properties.audioSource) && isNullOrFalse(properties.videoSource)) errMsg = 'You cannot specify both audioSource and videoSource as null or false';
                    }
                    setVideoContentHintIfCanvas(properties);
                    setScalableScreenshare(properties);
                    const publisher = new Publisher(properties || {});
                    sessionObjects.publishers.add(publisher);
                    const triggerCallback = function triggerCallback() {
                        if (completionHandler && isFunction(completionHandler)) {
                            completionHandler(...arguments);
                            completionHandler = undefined;
                        }
                    };
                    if (errMsg !== undefined) {
                        logging.error(errMsg);
                        triggerCallback(otError(Errors.INVALID_PARAMETER, new Error(errMsg), ExceptionCodes.INVALID_PARAMETER));
                    }
                    const removeInitSuccessAndCallComplete = function removeInitSuccessAndCallComplete(err) {
                        publisher.off('publishComplete', removeHandlersAndCallComplete);
                        triggerCallback(err);
                    };
                    let removeHandlersAndCallComplete = function removeHandlersAndCallComplete(err) {
                        publisher.off('initSuccess', removeInitSuccessAndCallComplete); // We're only handling the error case here as we're just
                        // initing the publisher, not actually attempting to publish.
                        if (err) triggerCallback(err);
                    };
                    publisher.once('initSuccess', removeInitSuccessAndCallComplete);
                    publisher.once('publishComplete', removeHandlersAndCallComplete);
                    publisher.publish(targetElement);
                    return publisher;
                };
            };
        /***/ },
        /* 315 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                /* eslint-disable no-param-reassign, global-require, no-underscore-dangle, func-names */ /* eslint-disable max-len */ const EventEmitter = __webpack_require__(31);
                const findKey = __webpack_require__(706);
                const isObject = __webpack_require__(11);
                const isFunction = __webpack_require__(17);
                const assign = __webpack_require__(9);
                const eventNames = __webpack_require__(27);
                const eventing = __webpack_require__(7);
                const AnalyticsHelperDefault = __webpack_require__(26);
                const StaticConfigDefault = __webpack_require__(35)();
                const IntervalRunner = __webpack_require__(75);
                const promisify = __webpack_require__(310);
                const testRemovingVideoCodecs = __webpack_require__(708);
                const validateIceConfigFactory = __webpack_require__(709);
                const shouldUseSinglePeerConnection = __webpack_require__(710);
                const _require = __webpack_require__(138), prependProxyToUrlIfNeeded = _require.prependProxyToUrlIfNeeded;
                const _require2 = __webpack_require__(139), getProxyUrl = _require2.getProxyUrl;
                const validateSecret = __webpack_require__(711);
                module1.exports = function SessionFactory(deps) {
                    if (deps === void 0) deps = {};
                    const adaptIceServers = deps.adaptIceServers || __webpack_require__(101).adaptIceServers;
                    /** @type {AnalyticsHelper} */ const AnalyticsHelper = deps.AnalyticsHelper || AnalyticsHelperDefault;
                    const APIKEY = deps.APIKEY || __webpack_require__(72);
                    const Capabilities = deps.Capabilities || __webpack_require__(169);
                    const convertAnvilErrorCode = deps.convertAnvilErrorCode || __webpack_require__(712);
                    const convertRumorError = deps.convertRumorError || __webpack_require__(316);
                    const errors = deps.Errors || __webpack_require__(6);
                    const Events = deps.Events || __webpack_require__(23)();
                    const Stream = deps.Stream || __webpack_require__(171);
                    const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                    const hasIceRestartsCapability = deps.hasIceRestartsCapability || __webpack_require__(317);
                    const hasE2eeCapability = deps.hasE2eeCapability || __webpack_require__(170);
                    const logging = deps.logging || __webpack_require__(2)('Session');
                    const otError = deps.otError || __webpack_require__(13)();
                    const OTErrorClass = deps.OTErrorClass || __webpack_require__(22);
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const forceMuteErrors = __webpack_require__(713);
                    /** @type {typeof StaticConfigDefault} */ const StaticConfig = deps.StaticConfig || StaticConfigDefault;
                    /** @type {StaticConfigDefault} */ const localStaticConfig = deps.staticConfig || StaticConfig.onlyLocal();
                    const Publisher = deps.Publisher || __webpack_require__(168)();
                    const RaptorSocket = deps.RaptorSocket || __webpack_require__(714).default();
                    const SessionDispatcher = deps.SessionDispatcher || __webpack_require__(324);
                    const sessionObjects = deps.sessionObjects || __webpack_require__(21);
                    const sessionTag = deps.sessionTag || __webpack_require__(323);
                    const socketCloseCodes = deps.socketCloseCodes || __webpack_require__(77);
                    const Subscriber = deps.Subscriber || __webpack_require__(303)();
                    const systemRequirements = deps.systemRequirements || __webpack_require__(152);
                    const uuid = deps.uuid || __webpack_require__(16);
                    const validateIceConfig = validateIceConfigFactory({
                        otError: otError
                    });
                    const windowMock = deps.global || window;
                    const getSessionInfo = deps.getSessionInfo || __webpack_require__(738)();
                    const SessionInfo = __webpack_require__(141);
                    const KeyStore = deps.KeyStore || __webpack_require__(741);
                    const SFrameClientStore = deps.SFrameClientStore || __webpack_require__(743);
                    const SinglePeerConnectionController = deps.SinglePeerConnectionController || __webpack_require__(745);
                    const initPublisher = deps.initPublisher || __webpack_require__(314)({
                        Publisher: Publisher
                    });
                    /**
   * The Session object returned by the <code>OT.initSession()</code> method provides access to
   * much of the OpenTok functionality.
   *
   * @class Session
   * @augments EventDispatcher
   *
   * @property {Capabilities} capabilities A {@link Capabilities} object that includes information
   * about the capabilities of the client. All properties of the <code>capabilities</code> object
   * are undefined until you have connected to a session and the completion handler for the
   * <code>Session.connect()</code> method has been called without error.
   * @property {Connection} connection The {@link Connection} object for this session. The
   * connection property is only available once the completion handler for the
   * <code>Session.connect()</code> method has been called successfully. See the
   * <a href="#connect">Session.connect()</a> method and the {@link Connection} class.
   * @property {String} sessionId The session ID for this session. You pass this value into the
   * <code>OT.initSession()</code> method when you create the Session object. (Note: a Session
   * object is not connected to the OpenTok server until you call the connect() method of the
   * object and its completion handler is called without error. See the
   * <a href="OT.html#initSession">OT.initSession()</a> and
   * the <a href="#connect">Session.connect()</a>
   * methods.) For more information on sessions and session IDs, see
   * <a href="https://tokbox.com/opentok/tutorials/create-session/">Session creation</a>.
   */ const Session = function Session(apiKey, sessionId, _temp) {
                        var _this = this;
                        let _ref = _temp === void 0 ? {} : _temp, iceConfig = _ref.iceConfig, connectionEventsSuppressed = _ref.connectionEventsSuppressed, _ref$ipWhitelist = _ref.ipWhitelist, ipWhitelist = _ref$ipWhitelist === void 0 ? false : _ref$ipWhitelist, initialEncryptionSecret = _ref.encryptionSecret, _enableSinglePeerConnection = _ref._enableSinglePeerConnection;
                        const proxyUrl = getProxyUrl();
                        /** @type AnalyticsHelperDefault */ const analytics = new AnalyticsHelper();
                        const getStream = (stream)=>typeof stream === 'string' ? this.streams.get(stream) || {
                                id: stream
                            } : stream;
                        eventing(this);
                        this._tag = sessionTag; // Check that the client meets the minimum requirements, if they don't the upgrade
                        // flow will be triggered.
                        if (!systemRequirements.check()) systemRequirements.upgrade();
                        if (sessionId == null) {
                            sessionId = apiKey;
                            apiKey = null;
                        }
                        validateIceConfig(iceConfig);
                        this.id = sessionId;
                        this.sessionId = sessionId;
                        this.keyStore = new KeyStore();
                        this.sFrameClientStore = new SFrameClientStore();
                        let _socket;
                        /** @type IntervalRunner | undefined */ let _connectivityAttemptPinger;
                        let _token;
                        let _p2p;
                        let _messagingServer;
                        let _attemptStartTime;
                        let _configurationAttemptStartTime;
                        let _iceServerDetails;
                        let _initialConnection = true;
                        let _isSocketReconnecting = false;
                        let _apiKey = apiKey;
                        const _session = this;
                        let _sessionId = sessionId;
                        let _widgetId = uuid();
                        let _connectionId = uuid();
                        let _logging = logging;
                        let _muteOnEntry = false;
                        const _subscribersQueue = [];
                        let _subscribersQueueInterval = null;
                        let _e2eeSecretSet = false;
                        let _useSinglePeerConnection = false;
                        let disconnectComponents;
                        let reset;
                        let destroyPublishers;
                        let destroySubscribers;
                        const setState = OTHelpers.statable(this, [
                            'disconnected',
                            'connecting',
                            'connected',
                            'disconnecting'
                        ], 'disconnected');
                        this.connection = null;
                        this.connections = new OTHelpers.Collection();
                        this.streams = new OTHelpers.Collection();
                        this.archives = new OTHelpers.Collection();
                        let _singlePeerConnectionController; //--------------------------------------
                        //  MESSAGE HANDLERS
                        //--------------------------------------
                        /*
     * The sessionConnectFailed event handler
     * @param {Error}
     */ const sessionConnectFailed = function sessionConnectFailed(error) {
                            setState('disconnected');
                            if (!error.code) error.code = ExceptionCodes.CONNECT_FAILED;
                            _logging.error(`${error.name || 'Unknown Error'}: ${error.message}`);
                            OTErrorClass.handleJsException({
                                error: error,
                                target: this,
                                analytics: analytics
                            });
                            this.trigger('sessionConnectFailed', error);
                        };
                        const sessionDisconnectedHandler = function sessionDisconnectedHandler(event) {
                            _isSocketReconnecting = false;
                            const reason = event.reason;
                            this.logEvent('Connect', 'Disconnected', {
                                reason: event.reason
                            });
                            const publicEvent = new Events.SessionDisconnectEvent('sessionDisconnected', reason.replace('networkTimedout', 'networkDisconnected'));
                            if (this.isConnected()) this.disconnect();
                            reset();
                            disconnectComponents.call(this, reason);
                            setTimeout(()=>{
                                this.dispatchEvent(publicEvent); // Although part of the defaultAction for sessionDisconnected we have
                                // chosen to still destroy Publishers within the session as there is
                                // another mechanism to stop a Publisher from being destroyed.
                                // Publishers use preventDefault on the Publisher streamDestroyed event
                                destroyPublishers.call(this, publicEvent.reason);
                                if (!publicEvent.isDefaultPrevented()) destroySubscribers.call(this, publicEvent.reason);
                            });
                        };
                        const connectionCreatedHandler = function connectionCreatedHandler(connection) {
                            // With connectionEventsSuppressed, connections objects are still added internally, but they
                            // don't come from rumor messages, and can't have corresponding delete events, so we don't
                            // emit created events.
                            if (connectionEventsSuppressed) return;
                             // We don't broadcast events for the symphony connection
                            if (connection.id.match(/^symphony\./)) return;
                            this.dispatchEvent(new Events.ConnectionEvent(eventNames.CONNECTION_CREATED, connection));
                        };
                        const connectionDestroyedHandler = function connectionDestroyedHandler(connection, reason) {
                            // We don't broadcast events for the symphony connection
                            if (connection.id.match(/^symphony\./)) return;
                             // Don't delete the connection if it's ours. This only happens when
                            // we're about to receive a session disconnected and session disconnected
                            // will also clean up our connection.
                            if (_socket && connection.id === _socket.id()) return;
                            this.dispatchEvent(new Events.ConnectionEvent(eventNames.CONNECTION_DESTROYED, connection, reason));
                        };
                        const streamCreatedHandler = function streamCreatedHandler(stream) {
                            if (stream && stream.connection && (!this.connection || stream.connection.id !== this.connection.id)) this.dispatchEvent(new Events.StreamEvent(eventNames.STREAM_CREATED, stream, null, false));
                        };
                        const streamPropertyModifiedHandler = function streamPropertyModifiedHandler(event) {
                            const stream = event.target;
                            const propertyName = event.changedProperty;
                            let newValue = event.newValue;
                            if (propertyName === 'videoDisableWarning' || propertyName === 'audioDisableWarning') return; // These are not public properties, skip top level event for them.
                            if (propertyName === 'videoDimensions') newValue = {
                                width: newValue.width,
                                height: newValue.height
                            };
                            this.dispatchEvent(new Events.StreamPropertyChangedEvent(eventNames.STREAM_PROPERTY_CHANGED, stream, propertyName, event.oldValue, newValue));
                        };
                        const streamDestroyedHandler = function streamDestroyedHandler(stream, reason) {
                            if (reason === void 0) reason = 'clientDisconnected';
                            const event = new Events.StreamEvent('streamDestroyed', stream, reason, true);
                            const disconnectAndDestroySubscribers = ()=>{
                                // If we are subscribed to any of the streams we should unsubscribe
                                sessionObjects.subscribers.where({
                                    streamId: stream.id
                                }).filter((subscriber)=>subscriber.session.id === this.id && subscriber.stream).forEach((subscriber)=>{
                                    subscriber._disconnect({
                                        reason: reason
                                    });
                                    if (!event.isDefaultPrevented()) subscriber._destroy({
                                        reason: reason,
                                        noStateTransition: true
                                    });
                                });
                            }; // if the stream is one of ours we delegate handling to the publisher itself.
                            if (stream.connection.id === this.connection.id) sessionObjects.publishers.where({
                                streamId: stream.id
                            }).forEach(function(publisher) {
                                publisher._.unpublishStreamFromSession(stream, this, reason);
                            }, this);
                            else // The streamDestroyed event is only dispatched by the session when the stream is not one of ours.
                            // In the case the stream is ours, the streamDestroyed is dispatched by the publisher.
                            this.dispatchEvent(event);
                            disconnectAndDestroySubscribers(); // @TODO Add a else with a one time warning that this no longer cleans up the publisher
                        };
                        const archiveCreatedHandler = function archiveCreatedHandler(archive) {
                            this.dispatchEvent(new Events.ArchiveEvent('archiveStarted', archive));
                        };
                        const archiveDestroyedHandler = function archiveDestroyedHandler(archive) {
                            this.dispatchEvent(new Events.ArchiveEvent('archiveDestroyed', archive));
                        };
                        const archiveUpdatedHandler = function archiveUpdatedHandler(event) {
                            const archive = event.target;
                            const propertyName = event.changedProperty;
                            const newValue = event.newValue;
                            if (propertyName === 'status' && newValue === 'stopped') this.dispatchEvent(new Events.ArchiveEvent('archiveStopped', archive));
                            else this.dispatchEvent(new Events.ArchiveEvent('archiveUpdated', archive));
                        }; // OPENTOK-42152: When a GSM call is ended, the subscribers might have an issue
                        // in which a black frame is displayed instead of video.
                        // A workaround is to pause and play the subscriber's video element.
                        const gsmCallEndedHandler = ()=>sessionObjects.subscribers.forEach((subscriber)=>subscriber._.pauseAndPlayVideoElement());
                        const init = function init() {
                            _session.token = null;
                            _token = null;
                            setState('disconnected');
                            _socket = null;
                            if (_connectivityAttemptPinger) {
                                _connectivityAttemptPinger.stop();
                                _connectivityAttemptPinger = null;
                            }
                            _session.connection = null;
                            _session.capabilities = new Capabilities([], {
                                hasE2eeCapability: hasE2eeCapability
                            });
                            _session.connections.destroy();
                            _session.streams.destroy();
                            _session.archives.destroy();
                        }; // Put ourselves into a pristine state
                        reset = function reset() {
                            // reset connection id now so that following calls to testNetwork and connect will share
                            // the same new session id. We need to reset here because testNetwork might be call after
                            // and it is always called before the session is connected
                            // on initial connection we don't reset
                            _connectionId = uuid();
                            init();
                        };
                        disconnectComponents = function disconnectComponents(reason) {
                            sessionObjects.publishers.where({
                                session: this
                            }).forEach((publisher)=>{
                                publisher.disconnect(reason);
                            });
                            sessionObjects.subscribers.where({
                                session: this
                            }).forEach((subscriber)=>{
                                subscriber._disconnect();
                            });
                        };
                        destroyPublishers = function destroyPublishers(reason) {
                            sessionObjects.publishers.where({
                                session: this
                            }).forEach((publisher)=>{
                                publisher._.streamDestroyed(reason);
                            });
                        };
                        destroySubscribers = function destroySubscribers(reason) {
                            sessionObjects.subscribers.where({
                                session: this
                            }).forEach((subscriber)=>{
                                subscriber._destroy({
                                    reason: reason
                                });
                            });
                        };
                        const connectMessenger = function connectMessenger() {
                            _logging.debug('OT.Session: connecting to Raptor');
                            const messagingUrl = prependProxyToUrlIfNeeded(this.sessionInfo.messagingURL, proxyUrl); // capabilities supported by default.
                            const capabilities = [
                                'forceMute',
                                'adaptive'
                            ]; // Add SPC capability if forced, otherwise we don't add it to force not to use it.
                            if (_useSinglePeerConnection) capabilities.push('spc');
                            _socket = new RaptorSocket(_connectionId, _widgetId, messagingUrl, this.sessionInfo.symphonyAddress, SessionDispatcher(this, {
                                connectionEventsSuppressed: connectionEventsSuppressed
                            }), analytics, capabilities);
                            /**
       * Maps an error from RaptorSocket.connect to its corresponding name
       * @param {string} reason - Failure reason
       * @param {number} code - Error code
       * @return {string|undefined} Error name
       */ function getErrorNameFromCode(reason, code) {
                                let name;
                                switch(reason){
                                    case 'WebSocketConnection':
                                        name = findKey(socketCloseCodes.codes, (x)=>x === code);
                                        if (name) return errors[`SOCKET_${name}`];
                                        break;
                                    case 'ConnectToSession':
                                    case 'GetSessionState':
                                        switch(code){
                                            case ExceptionCodes.CONNECT_FAILED:
                                                return errors.CONNECT_FAILED;
                                            case ExceptionCodes.UNEXPECTED_SERVER_RESPONSE:
                                                return errors.UNEXPECTED_SERVER_RESPONSE;
                                            case ExceptionCodes.CONNECTION_LIMIT_EXCEEDED:
                                                return errors.CONNECTION_LIMIT_EXCEEDED;
                                            default:
                                                break;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                                return undefined;
                            }
                            _socket.connect(_token, this.sessionInfo, {
                                connectionEventsSuppressed: connectionEventsSuppressed
                            }, (error, sessionState)=>{
                                if (error) {
                                    const payload = {};
                                    let options;
                                    if (error.reason === 'ConnectToSession' || error.reason === 'GetSessionState') {
                                        const converted = convertRumorError(error);
                                        assign(payload, {
                                            originalMessage: error.message,
                                            originalCode: error.code
                                        });
                                        error.code = converted.code;
                                        error.message = converted.message;
                                    }
                                    if (error.code || error.message || error.reason) options = {
                                        failureCode: error.code,
                                        failureMessage: error.message,
                                        failureReason: error.reason,
                                        socketId: _socket.socketId
                                    };
                                    _socket = null;
                                    this.logConnectivityEvent('Failure', payload, options);
                                    const errorName = getErrorNameFromCode(error.reason, error.code);
                                    if (errorName) error = otError(errorName, new Error(error.message), error.code);
                                    sessionConnectFailed.call(this, error);
                                    return;
                                }
                                _logging.debug('OT.Session: Received session state from Raptor', sessionState);
                                this.connection = this.connections.get(_socket.id());
                                if (this.connection) this.capabilities = this.connection.permissions;
                                setState('connected');
                                this.logConnectivityEvent('Success', {
                                    connectionId: this.connection.id
                                }); // Listen for our own connection's destroyed event so we know when we've been disconnected.
                                this.connection.on('destroyed', sessionDisconnectedHandler, this);
                                this.dispatchEvent(new Events.SessionConnectEvent(eventNames.SESSION_CONNECTED)); // Listen for connection updates
                                this.connections.on({
                                    add: connectionCreatedHandler,
                                    remove: connectionDestroyedHandler
                                }, this); // Listen for stream updates
                                this.streams.on({
                                    add: streamCreatedHandler,
                                    remove: streamDestroyedHandler,
                                    update: streamPropertyModifiedHandler
                                }, this);
                                this.archives.on({
                                    add: archiveCreatedHandler,
                                    remove: archiveDestroyedHandler,
                                    update: archiveUpdatedHandler
                                }, this);
                                this.connections._triggerAddEvents(); // { id: this.connection.id }
                                this.streams._triggerAddEvents(); // { id: this.stream.id }
                                this.archives._triggerAddEvents(); // Listen for the gsmCallEnded event triggered by the publisher when a GSM call ends.
                                const isBuggediOS = OTHelpers.env.isiOS && OTHelpers.env.iOSVersion >= 13.3;
                                if (isBuggediOS) this.on('gsmCallEnded', gsmCallEndedHandler);
                            });
                        }; // Check whether we have permissions to perform the action.
                        const permittedTo = (action)=>this.capabilities.permittedTo(action);
                        const dispatchOTError = (error, completionHandler)=>{
                            logging.error(`${error.name}: ${error.message}`);
                            if (typeof completionHandler === 'function') completionHandler(error);
                            OTErrorClass.handleJsException({
                                error: error,
                                target: this,
                                analytics: analytics
                            });
                        };
                        const dispatchMuteError = (err)=>{
                            const error = otError(err.code, new Error(err.message), err.exceptionCode);
                            dispatchOTError(error);
                            return error;
                        };
                        const checkMuteCapabilities = ()=>{
                            if (this.isNot('connected')) return dispatchMuteError(forceMuteErrors.NOT_CONNECTED);
                            if (!permittedTo('forceMute')) // if this throws an error the handleJsException won't occur
                            return dispatchMuteError(forceMuteErrors.PERMISSION_DENIED);
                            return null;
                        };
                        const handleMuteServerError = (err)=>{
                            if (err.code === '404') return dispatchMuteError(forceMuteErrors.NOT_FOUND);
                            else if (err.code === '403') return dispatchMuteError(forceMuteErrors.PERMISSION_DENIED);
                            return dispatchMuteError(forceMuteErrors.UNEXPECTED_SERVER_RESPONSE);
                        };
                        this.reportIssue = (_ref2)=>{
                            let id = _ref2.id;
                            return promisify(analytics.logEvent.bind(analytics))({
                                action: 'ReportIssue',
                                variation: 'Event',
                                connectionId: _connectionId,
                                payload: {
                                    reportIssueId: id
                                }
                            }, null);
                        };
                        this.logEvent = function(action, variation, payload, options) {
                            let event = {
                                action: action,
                                variation: variation,
                                payload: payload,
                                sessionId: _sessionId,
                                messagingServer: _messagingServer,
                                p2p: _p2p,
                                partnerId: _apiKey,
                                connectionId: _connectionId
                            };
                            if (options) event = assign(options, event);
                            analytics.logEvent(event);
                        };
                        this.logConfigurationFileEvent = function(variation, payload, options) {
                            if (payload === void 0) payload = null;
                            if (options === void 0) options = {};
                            if (variation === 'Attempt') _configurationAttemptStartTime = new Date().getTime();
                            else if (variation === 'Failure' || variation === 'Success') {
                                const attemptDuration = new Date().getTime() - _configurationAttemptStartTime;
                                assign(options, {
                                    attemptDuration: attemptDuration
                                });
                            }
                            if (proxyUrl) options.proxyUrl = proxyUrl;
                            this.logEvent('ConfigurationFile', variation, payload, (0, _extends2.default)({}, options));
                        };
                        this.logConnectivityEvent = function(variation, payload, options) {
                            if (payload === void 0) payload = null;
                            if (options === void 0) options = {};
                            if (proxyUrl) options.proxyUrl = proxyUrl;
                            if (variation === 'Attempt') {
                                if (_connectivityAttemptPinger) {
                                    _connectivityAttemptPinger.stop();
                                    logging.error('_connectivityAttemptPinger should have been cleaned up');
                                }
                                _attemptStartTime = new Date().getTime();
                                _connectivityAttemptPinger = new IntervalRunner(()=>{
                                    this.logEvent('Connect', 'Attempting', payload, (0, _extends2.default)({}, options));
                                }, 0.2, 6);
                                _connectivityAttemptPinger.start();
                            }
                            if (variation === 'Failure' || variation === 'Success' || variation === 'Cancel') {
                                const logConnect = (_iceConfig)=>{
                                    if (_connectivityAttemptPinger) {
                                        _connectivityAttemptPinger.stop();
                                        _connectivityAttemptPinger = undefined;
                                    }
                                    this.logEvent('Connect', variation, payload, (0, _extends2.default)({}, options, {
                                        attemptDuration: new Date().getTime() - _attemptStartTime,
                                        iceConfig: _iceConfig,
                                        ipWhitelist: ipWhitelist
                                    }));
                                };
                                if (variation === 'Success') this._.getIceConfig().then((config)=>{
                                    const _iceConfig = {
                                        includeServers: iceConfig && iceConfig.includeServers || 'all',
                                        transportPolicy: config.transportPolicy
                                    };
                                    _iceConfig.servers = config.servers ? config.servers.map((server)=>({
                                            url: server.urls
                                        })) : [];
                                    logConnect(_iceConfig);
                                });
                                else logConnect();
                            } else this.logEvent('Connect', variation, payload, options);
                        };
                        /**
    * Connects to an OpenTok session.
    * <p>
    *  Upon a successful connection, the completion handler (the second parameter of the method) is
    *  invoked without an error object passed in. (If there is an error connecting, the completion
    *  handler is invoked with an error object.) Make sure that you have successfully connected to the
    *  session before calling other methods of the Session object.
    * </p>
    *  <p>
    *    The Session object dispatches a <code>connectionCreated</code> event when any client
    *    (including your own) connects to the session.
    *  </p>
    *
    *  <h5>
    *  Example
    *  </h5>
    *  <p>
    *  The following code initializes a session and sets up an event listener for when the session
    *  connects:
    *  </p>
    *  <pre>
    *  var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    *  var sessionID = ""; // Replace with your own session ID.
    *                      // See https://tokbox.com/developer/guides/create-session/.
    *  var token = ""; // Replace with a generated token.
    *                  // See https://tokbox.com/developer/guides/create-token/.
    *
    *  var session = OT.initSession(apiKey, sessionID);
    *  session.connect(token, function(error) {
    *    if (error) {
    *      console.log(error.message);
    *    } else {
    *      // You have connected to the session. You could publish a stream now.
    *    }
    *  });
    *  </pre>
    *  <p>
    *
    *  <h5>
    *  Events dispatched:
    *  </h5>
    *
    *  <p>
    *    <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151; Dispatched
    *    by the OT class locally in the event of an error.
    *  </p>
    *  <p>
    *    <code>connectionCreated</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    *      Dispatched by the Session object on all clients connected to the session.
    *  </p>
    *  <p>
    *    <code>sessionConnected</code> (<a href="SessionConnectEvent.html">SessionConnectEvent</a>)
    *      &#151; Dispatched locally by the Session object when the connection is established. However,
    *      you can pass a completion handler function in as the second parameter of the
    *      <code>connect()</code> and use this function instead of a listener for the
    *      <code>sessionConnected</code> event.
    *  </p>
    *
    * @param {String} token The session token. You generate a session token using our
    * <a href="https://tokbox.com/opentok/libraries/server/">server-side libraries</a> or at your
    * <a href="https://tokbox.com/account">Vonage Video API account</a> page. For more information, see
    * <a href="https://tokbox.com/opentok/tutorials/create-token/">Connection token creation</a>.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>connect()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code> (see the <a href="Error.html">Error</a> object).
    * On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object parameter
    * (see the <a href="Error.html">Error</a> object). The
    * <code>error</code> object has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. The following
    * code adds a <code>completionHandler</code> when calling the <code>connect()</code> method:
    * <pre>
    * session.connect(token, function (error) {
    *   if (error) {
    *       console.log(error.message);
    *   } else {
    *     console.log("Connected to session.");
    *   }
    * });
    * </pre>
    * <p>
    * Note that upon connecting to the session, the Session object dispatches a
    * <code>sessionConnected</code> event in addition to calling the <code>completionHandler</code>.
    * The SessionConnectEvent object, which defines the <code>sessionConnected</code> event,
    * includes <code>connections</code> and <code>streams</code> properties, which
    * list the connections and streams in the session when you connect.
    * </p>
    *
    * @see SessionConnectEvent
    * @method #connect
    * @memberOf Session
    */ this.connect = function() {
                            let token;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            if (args.length > 1 && (typeof args[0] === 'string' || typeof args[0] === 'number') && typeof args[1] === 'string') {
                                if (apiKey == null) _apiKey = args[0].toString();
                                token = args[1];
                            } else token = args[0];
                             // The completion handler is always the last argument.
                            const completionHandler = args[args.length - 1];
                            if (_this.is('connecting', 'connected')) {
                                _logging.warn(`OT.Session: Cannot connect, the session is already ${_this.state}`);
                                return _this;
                            } // On disconnects, GSI fields may be unintentionally cached and logged so we instantiate a new instance.
                            analytics.sessionInfo = new SessionInfo();
                            init();
                            setState('connecting');
                            const currentConnectionId = _connectionId;
                            function checkInterrupted() {
                                const interrupted = _connectionId !== currentConnectionId;
                                if (interrupted) logging.debug('Connection was interrupted');
                                return interrupted;
                            }
                            _this.token = !isFunction(token) && token;
                            _token = !isFunction(token) && token; // Get a new widget ID when reconnecting.
                            if (_initialConnection) _initialConnection = false;
                            else _widgetId = uuid();
                            if (completionHandler && isFunction(completionHandler)) {
                                let cleanup;
                                const onCompleteSuccess = function onCompleteSuccess() {
                                    cleanup();
                                    for(var _len2 = arguments.length, cbArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)cbArgs[_key2] = arguments[_key2];
                                    completionHandler(undefined, ...cbArgs);
                                };
                                const onCompleteFailure = function onCompleteFailure() {
                                    cleanup();
                                    completionHandler(...arguments);
                                };
                                cleanup = ()=>{
                                    _this.off('sessionConnected', onCompleteSuccess);
                                    _this.off('sessionConnectFailed', onCompleteFailure);
                                };
                                _this.once('sessionConnected', onCompleteSuccess);
                                _this.once('sessionConnectFailed', onCompleteFailure);
                            }
                            if (_apiKey == null || isFunction(_apiKey)) {
                                setTimeout(sessionConnectFailed.bind(_this, otError(errors.AUTHENTICATION_ERROR, new Error('API Key is undefined. You must pass an API Key to initSession.'), ExceptionCodes.AUTHENTICATION_ERROR)));
                                return _this;
                            }
                            if (!_sessionId || isObject(_sessionId) || Array.isArray(_sessionId)) {
                                let errorMsg;
                                if (!_sessionId) errorMsg = 'SessionID is undefined. You must pass a sessionID to initSession.';
                                else {
                                    errorMsg = "SessionID is not a string. You must use string as the session ID passed into OT.initSession().";
                                    _sessionId = _sessionId.toString();
                                }
                                setTimeout(sessionConnectFailed.bind(_this, otError(errors.INVALID_SESSION_ID, new Error(errorMsg), ExceptionCodes.INVALID_SESSION_ID)));
                                _this.logConnectivityEvent('Attempt');
                                _this.logConnectivityEvent('Failure', null, {
                                    failureReason: 'ConnectToSession',
                                    failureCode: ExceptionCodes.INVALID_SESSION_ID,
                                    failureMessage: errorMsg
                                });
                                return _this;
                            }
                            _this.apiKey = _apiKey.toString();
                            _apiKey = _apiKey.toString();
                            if (initialEncryptionSecret) {
                                if (!hasE2eeCapability()) {
                                    setTimeout(sessionConnectFailed.bind(_this, otError(errors.UNSUPPORTED_BROWSER, new Error('E2E Encryption is not supported in your browser.'))));
                                    return _this;
                                }
                                try {
                                    validateSecret(initialEncryptionSecret);
                                    _this.keyStore.set(sessionId, initialEncryptionSecret);
                                    _e2eeSecretSet = true;
                                } catch (e) {
                                    setTimeout(sessionConnectFailed.bind(_this, otError(errors.INVALID_ENCRYPTION_SECRET, new Error(`Invalid encryptionSecret: ${e.message}`))));
                                    return _this;
                                }
                            } // TODO: Ugly hack, make sure APIKEY is set
                            if (APIKEY.value.length === 0) APIKEY.value = _apiKey;
                            const hasStaticConfigUrl = Boolean(StaticConfig.onlyLocal().configUrl);
                            const useIpWhitelistConfigUrl = ipWhitelist === true && Boolean(StaticConfig.onlyLocal().ipWhitelistConfigUrl);
                            if (!hasStaticConfigUrl && !useIpWhitelistConfigUrl) _this.logConfigurationFileEvent('Event', {
                                message: 'No configUrl, using local config only'
                            });
                            else _this.logConfigurationFileEvent('Attempt');
                            const futureStaticConfig = hasStaticConfigUrl || useIpWhitelistConfigUrl ? StaticConfig.get({
                                partnerId: _apiKey,
                                token: token,
                                useIpWhitelistConfigUrl: useIpWhitelistConfigUrl,
                                proxyUrl: proxyUrl
                            }) : Promise.resolve(StaticConfig.onlyLocal());
                            futureStaticConfig.then((staticConfig)=>{
                                if (hasStaticConfigUrl || useIpWhitelistConfigUrl) _this.logConfigurationFileEvent('Success');
                                return staticConfig;
                            }, (err)=>{
                                if (hasStaticConfigUrl || useIpWhitelistConfigUrl) _this.logConfigurationFileEvent('Failure', {
                                    failureMessage: err.message,
                                    failureStack: err.stack
                                });
                                return StaticConfig.onlyLocal();
                            }).then((staticConfig)=>{
                                _this.staticConfig = staticConfig;
                                analytics.staticConfig = staticConfig;
                                if (staticConfig.apiEnabled === false) throw otError(errors.API_KEY_DISABLED, new Error("The API KEY has been disabled. Access to the service is currently being restricted. Please contact support."));
                                if (checkInterrupted()) return undefined;
                                _this.logConnectivityEvent('Attempt');
                                if (proxyUrl) _this.logEvent('SessionInfo', 'Attempt', null, {
                                    proxyUrl: proxyUrl
                                });
                                else _this.logEvent('SessionInfo', 'Attempt');
                                const onSessionInfoError = (error)=>{
                                    // @todo I think we should move convertAnvilErrorCode to after we log the Failure. It's
                                    // a lossy process, and the more information we have in our logged failure, the better
                                    // we can understand the failures.
                                    error.code = convertAnvilErrorCode(error.code);
                                    _this.logConnectivityEvent('Failure', null, {
                                        failureReason: 'GetSessionInfo',
                                        failureCode: error.code || 'No code',
                                        failureMessage: error.message,
                                        failureName: error.name
                                    });
                                    if (error.name) error = otError(error.name, new Error(`${error.message}${error.code ? ` (${error.code})` : ''}`), error.code);
                                    sessionConnectFailed.call(_this, error);
                                };
                                const onSessionInfoSuccess = (sessionInfo)=>{
                                    if (checkInterrupted()) return;
                                    if (sessionInfo.partnerId && sessionInfo.partnerId !== _apiKey) {
                                        // The apiKey does not match, this is an error
                                        const reason = 'Authentication Error: The API key does not match the token or session.';
                                        onSessionInfoError(otError(errors.AUTHENTICATION_ERROR, new Error(reason), ExceptionCodes.AUTHENTICATION_ERROR));
                                        return;
                                    } // Force SPC if set by either sessionInfo or forced by initSession.
                                    _useSinglePeerConnection = shouldUseSinglePeerConnection(sessionInfo, _enableSinglePeerConnection);
                                    if (_useSinglePeerConnection) _singlePeerConnectionController = new SinglePeerConnectionController(_this);
                                    analytics.sessionInfo = sessionInfo;
                                    const sessionInfoSuccessLogPayload = {
                                        features: {
                                            reconnection: sessionInfo.reconnection,
                                            renegotiation: hasIceRestartsCapability() && sessionInfo.renegotiation,
                                            simulcast: sessionInfo.simulcast === undefined ? false : sessionInfo.simulcast && OTHelpers.env.name === 'Chrome'
                                        }
                                    };
                                    if (proxyUrl) sessionInfoSuccessLogPayload.proxyUrl = proxyUrl;
                                    if (_this.is('connecting')) {
                                        _this.sessionInfo = sessionInfo;
                                        _this._.setIceServers(_this.sessionInfo.iceServers);
                                        _p2p = sessionInfo.p2pEnabled;
                                        _messagingServer = sessionInfo.messagingServer;
                                        _this.logEvent('SessionInfo', 'Success', null, sessionInfoSuccessLogPayload, {
                                            messagingServer: sessionInfo.messagingServer
                                        });
                                        /**
             * The only sessionInfo overrides that was being used is
             */ const overrides = staticConfig.sessionInfoOverrides;
                                        if (overrides != null && typeof overrides === 'object') Object.keys(overrides).forEach((key)=>{
                                            Object.defineProperty(_this.sessionInfo, key, {
                                                value: overrides[key]
                                            });
                                        });
                                        connectMessenger.call(_this);
                                    }
                                };
                                const targetUrl = prependProxyToUrlIfNeeded(staticConfig.apiUrl, proxyUrl);
                                return getSessionInfo({
                                    anvilUrl: targetUrl,
                                    sessionId: sessionId,
                                    token: _token,
                                    connectionId: _connectionId,
                                    clientVersion: staticConfig.clientVersion
                                }).then(onSessionInfoSuccess, onSessionInfoError);
                            }).catch((err)=>{
                                sessionConnectFailed.call(_this, err);
                            });
                            return _this;
                        };
                        /**
    * Disconnects from the OpenTok session.
    *
    * <p>
    * Calling the <code>disconnect()</code> method ends your connection with the session. In the
    * course of terminating your connection, it also ceases publishing any stream(s) you were
    * publishing.
    * </p>
    * <p>
    * Session objects on remote clients dispatch <code>streamDestroyed</code> events for any
    * stream you were publishing. The Session object dispatches a <code>sessionDisconnected</code>
    * event locally. The Session objects on remote clients dispatch <code>connectionDestroyed</code>
    * events, letting other connections know you have left the session. The
    * {@link SessionDisconnectEvent} and {@link StreamEvent} objects that define the
    * <code>sessionDisconnect</code> and <code>connectionDestroyed</code> events each have a
    * <code>reason</code> property. The <code>reason</code> property lets the developer determine
    * whether the connection is being terminated voluntarily and whether any streams are being
    * destroyed as a byproduct of the underlying connection's voluntary destruction.
    * </p>
    * <p>
    * If the session is not currently connected, calling this method causes a warning to be logged.
    * See <a href="OT.html#setLogLevel">OT.setLogLevel()</a>.
    * </p>
    *
    * <p>
    * <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
    * (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
    * event dispatched by the Publisher object (when it stops publishing). In the event listener,
    * call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
    * video from being removed from the page.
    * </p>
    *
    * <h5>
    * Events dispatched:
    * </h5>
    * <p>
    * <code>sessionDisconnected</code>
    * (<a href="SessionDisconnectEvent.html">SessionDisconnectEvent</a>)
    * &#151; Dispatched locally when the connection is disconnected.
    * </p>
    * <p>
    * <code>connectionDestroyed</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    * Dispatched on other clients, along with the <code>streamDestroyed</code> event (as warranted).
    * </p>
    *
    * <p>
    * <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * Dispatched on other clients if streams are lost as a result of the session disconnecting.
    * </p>
    *
    * @method #disconnect
    * @memberOf Session
    */ this.disconnect = function() {
                            if (_singlePeerConnectionController) {
                                _singlePeerConnectionController.destroy();
                                _singlePeerConnectionController = null;
                            }
                            if (_socket && _socket.isNot('disconnected')) {
                                if (_socket.isNot('disconnecting')) {
                                    if (!_socket.isNot('connecting')) this.logConnectivityEvent('Cancel');
                                    setState('disconnecting');
                                    _socket.disconnect();
                                    this.off('gsmCallEnded', gsmCallEndedHandler);
                                }
                            } else reset();
                        };
                        this.destroy = function() {
                            this.streams.destroy();
                            this.connections.destroy();
                            this.archives.destroy();
                            this.disconnect();
                        };
                        /**
    * The <code>publish()</code> method starts publishing an audio-video stream to the session.
    * The audio-video stream is captured from a local microphone and webcam. Upon successful
    * publishing, the Session objects on all connected clients dispatch the
    * <code>streamCreated</code> event.
    * </p>
    *
    * <!--JS-ONLY-->
    * <p>You pass a Publisher object as the one parameter of the method. You can initialize a
    * Publisher object by calling the <a href="OT.html#initPublisher">OT.initPublisher()</a>
    * method. Before calling <code>Session.publish()</code>.
    * </p>
    *
    * <p>This method takes an alternate form: <code>publish(targetElement: String | HTMLElement,
    * properties: Object, completionHandler: Function): Publisher</code> &#151; In this form, you do
    <i>not</i> pass a Publisher object into the function. Instead, you pass in a <code>targetElement</code>
    (the target HTML element or the ID of the target HTML element for the Publisher), an optional
    <code>properties</code> object that defines options for the Publisher (see
    <a href="OT.html#initPublisher">OT.initPublisher()</a>), and an optional completion handler function.
    * The method returns a new Publisher object, which starts sending an audio-video stream to the
    * session. The remainder of this documentation describes the form that takes a single Publisher
    * object as a parameter.
    *
    * <p>
    *   A local display of the published stream is created on the web page by replacing
    *         the specified element in the DOM with a streaming video display. The video stream
    *         is automatically mirrored horizontally so that users see themselves and movement
    *         in their stream in a natural way. If the width and height of the display do not match
    *         the 4:3 aspect ratio of the video signal, the video stream is cropped to fit the
    *         display.
    * </p>
    *
    * <p>
    *   If calling this method creates a new Publisher object and the OpenTok library does not
    *   have access to the camera or microphone, the web page alerts the user to grant access
    *   to the camera and microphone.
    * </p>
    *
    * <p>
    * The OT object dispatches an <code>exception</code> event if the user's role does not
    * include permissions required to publish. For example, if the user's role is set to subscriber,
    * then they cannot publish. You define a user's role when you create the user token
    * (see <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    * You pass the token string as a parameter of the <code>connect()</code> method of the Session
    * object. See <a href="ExceptionEvent.html">ExceptionEvent</a> and
    * <a href="OT.html#on">OT.on()</a>.
    * </p>
    *     <p>
    *     The application throws an error if the session is not connected.
    *     </p>
    *
    * <h5>Events dispatched:</h5>
    * <p>
    * <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151; Dispatched
    * by the OT object. This can occur when user's role does not allow publishing (the
    * <code>code</code> property of event object is set to 1500); it can also occur if the
    * connection fails to connect (the <code>code</code> property of event object is set to 1013).
    * WebRTC is a peer-to-peer protocol, and it is possible that connections will fail to connect.
    * The most common cause for failure is a firewall that the protocol cannot traverse.</li>
    * </p>
    * <p>
    * <code>streamCreated</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * The stream has been published. The Session object dispatches this on all clients
    * subscribed to the stream, as well as on the publisher's client.
    * </p>
    *
    * <h5>Example</h5>
    *
    * <p>
    *   The following example publishes a video once the session connects:
    * </p>
    * <pre>
    * var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    * var sessionId = ""; // Replace with your own session ID.
    *                     // https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token that has been assigned the publish role.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    * var session = OT.initSession(apiKey, sessionID);
    * session.connect(token, function(error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     var publisherOptions = {width: 400, height:300, name:"Bob's stream"};
    *     // This assumes that there is a DOM element with the ID 'publisher':
    *     publisher = OT.initPublisher('publisher', publisherOptions);
    *     session.publish(publisher);
    *   }
    * });
    * </pre>
    *
    * @param {Publisher} publisher A Publisher object, which you initialize by calling the
    * <a href="OT.html#initPublisher">OT.initPublisher()</a> method.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>publish()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code>. On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object parameter
    * (see the <a href="Error.html">Error</a> object). The
    * <code>error</code> object has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. Calling
    * <code>publish()</code> fails if the role assigned to your token is not "publisher" or
    * "moderator"; in this case the <code>error.name</code> property is set to
    * <code>"OT_PERMISSION_DENIED"</code>. Calling <code>publish()</code> also fails if the
    * client fails to connect; in this case the <code>error.name</code> property is set to
    * <code>"OT_NOT_CONNECTED"</code>. The following code adds a completion handler when
    * calling the <code>publish()</code> method:
    * <pre>
    * session.publish(publisher, null, function (error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     console.log("Publishing a stream.");
    *   }
    * });
    * </pre>
    *
    * @returns The Publisher object for this stream.
    *
    * @method #publish
    * @memberOf Session
    */ this.publish = function(publisher, properties, completionHandler) {
                            if (typeof publisher === 'function') {
                                completionHandler = publisher;
                                publisher = undefined;
                            }
                            if (typeof properties === 'function') {
                                completionHandler = properties;
                                properties = undefined;
                            }
                            completionHandler = completionHandler || function() {};
                            if (this.isNot('connected')) {
                                analytics.logError(1010, 'OT.exception', 'We need to be connected before you can publish', null, {
                                    action: 'Publish',
                                    variation: 'Failure',
                                    failureReason: 'unconnected',
                                    failureCode: ExceptionCodes.NOT_CONNECTED,
                                    failureMessage: 'We need to be connected before you can publish',
                                    sessionId: _sessionId,
                                    streamId: publisher && publisher.stream ? publisher.stream.id : null,
                                    p2p: this.sessionInfo ? this.sessionInfo.p2pEnabled : undefined,
                                    messagingServer: this.sessionInfo ? this.sessionInfo.messagingServer : null,
                                    partnerId: _apiKey
                                });
                                dispatchOTError(otError(errors.NOT_CONNECTED, new Error('We need to be connected before you can publish'), ExceptionCodes.NOT_CONNECTED), completionHandler);
                                return null;
                            }
                            if (!permittedTo('publish')) {
                                const errorMessage = "This token does not allow publishing. The role must be at least `publisher` to enable this functionality";
                                const options = {
                                    failureReason: 'Permission',
                                    failureCode: ExceptionCodes.UNABLE_TO_PUBLISH,
                                    failureMessage: errorMessage
                                };
                                this.logEvent('Publish', 'Failure', null, options);
                                dispatchOTError(otError(errors.PERMISSION_DENIED, new Error(errorMessage), ExceptionCodes.UNABLE_TO_PUBLISH), completionHandler);
                                return null;
                            } // If the user has passed in an ID of a element then we create a new publisher.
                            if (!publisher || typeof publisher === 'string' || OTHelpers.isElementNode(publisher)) // Initiate a new Publisher with the new session credentials
                            publisher = initPublisher(publisher, properties);
                            else if (publisher instanceof Publisher) // If the publisher already has a session attached to it we can
                            {
                                if ('session' in publisher && publisher.session && 'sessionId' in publisher.session) {
                                    // send a warning message that we can't publish again.
                                    if (publisher.session.sessionId === this.sessionId) _logging.warn(`Cannot publish ${publisher.guid()} again to ${this.sessionId}. Please call session.unpublish(publisher) first.`);
                                    else _logging.warn(`Cannot publish ${publisher.guid()} publisher already attached to ${publisher.session.sessionId}. Please call session.unpublish(publisher) first.`);
                                }
                            } else {
                                dispatchOTError(otError(errors.INVALID_PARAMETER, new Error("Session.publish :: First parameter passed in is neither a string nor an instance of the Publisher"), ExceptionCodes.UNABLE_TO_PUBLISH), completionHandler);
                                return undefined;
                            }
                            if (_muteOnEntry) publisher._.forceMuteAudio();
                             // Add publisher reference to the session
                            publisher._.publishToSession(this, analytics).catch((err)=>{
                                err.message = `Session.publish :: ${err.message}`;
                                _logging.error(err.code, err.message);
                                throw err;
                            }).then(()=>publisher).then(function() {
                                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                                return completionHandler(null, ...args);
                            }, (err)=>completionHandler(err)); // return the embed publisher
                            return publisher;
                        };
                        /**
    * Ceases publishing the specified publisher's audio-video stream
    * to the session. By default, the local representation of the audio-video stream is
    * removed from the web page. Upon successful termination, the Session object on every
    * connected web page dispatches
    * a <code>streamDestroyed</code> event.
    * </p>
    *
    * <p>
    * To prevent the Publisher from being removed from the DOM, add an event listener for the
    * <code>streamDestroyed</code> event dispatched by the Publisher object and call the
    * <code>preventDefault()</code> method of the event object.
    * </p>
    *
    * <p>
    * <i>Note:</i> If you intend to reuse a Publisher object to publish to different sessions
    * (or the same session) sequentially, add an event listener for the <code>streamDestroyed</code>
    * event dispatched by the Publisher object (when it stops publishing). In the event listener,
    * call the <code>preventDefault()</code> method of the event object to prevent the Publisher's
    * video from being removed from the page.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    * <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    * The stream associated with the Publisher has been destroyed. Dispatched on by the
    * Publisher on on the Publisher's browser. Dispatched by the Session object on
    * all other connections subscribing to the publisher's stream.
    * </p>
    *
    * <h5>Example</h5>
    *
    * The following example publishes a stream to a session and adds a Disconnect link to the
    * web page. Clicking this link causes the stream to stop being published.
    *
    * <pre>
    * &lt;script&gt;
    *   var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    *   var sessionID = ""; // Replace with your own session ID.
    *                    // See https://tokbox.com/developer/guides/create-session/.
    *   var token = ""; // Replace with a generated token.
    *                   // See https://tokbox.com/developer/guides/create-token/.
    *   var publisher;
    *   var session = OT.initSession(apiKey, sessionID);
    *   session.connect(token, function(error) {
    *     if (error) {
    *       console.log(error.message);
    *     } else {
    *       // This assumes that there is a DOM element with the ID 'publisher':
    *       publisher = OT.initPublisher('publisher');
    *       session.publish(publisher);
    *     }
    *   });
    *
    *   function unpublish() {
    *     session.unpublish(publisher);
    *   }
    * &lt;/script&gt;
    *
    * &lt;body&gt;
    *
    *     &lt;div id="publisherContainer/&gt;
    *     &lt;br/&gt;
    *
    *     &lt;a href="javascript:unpublish()"&gt;Stop Publishing&lt;/a&gt;
    *
    * &lt;/body&gt;
    *
    * </pre>
    *
    * @see <a href="#publish">publish()</a>
    *
    * @see <a href="StreamEvent.html">streamDestroyed event</a>
    *
    * @param {Publisher} publisher</span> The Publisher object to stop streaming.
    *
    * @method #unpublish
    * @memberOf Session
    */ this.unpublish = function(publisher) {
                            if (!publisher) {
                                _logging.error('OT.Session.unpublish: publisher parameter missing.');
                                return;
                            } // Unpublish the localMedia publisher
                            publisher._.unpublishFromSession(this, 'unpublished');
                        };
                        /**
      * Sets the ICE configuration for all connections in a session. This replaces any previously
      * set ICE configurations.
      *
      * <p>
      * This is a <em>beta</em> feature. It is available for projects that use the
      * <a href="https://tokbox.com/developer/guides/configurable-turn-servers/">configurable
      * TURN server add-on</a>.
      *
      * @see <a href="OT.html#initSession">OT.initSession()</a>
      *
      * @param {IceConfig} newIceConfig This object defines the ICE configuration. It has the
      * following propoerties;
      *
      * <p>
      * <ul>
      *   <li>
      *     <code>includeServers</code></code> (String) — Set this to 'custom' and client will use
      *     only the custom TURN servers you provide in the <code>customServers</code> property
      *     of the <code>newIceConfig</code> parameter. Set this to 'all' and the client will use
      *     both the custom TURN servers you provide along with OpenTok TURN servers.
      *   </li>
      *
      *   <li>
      *     <code>transportPolicy</code></code> (String) — Set this to 'all' (the default) and
      *     the client will use all ICE transport types (such as host, srflx, and TURN) to establish
      *     media connectivity. Set this to 'relay' to force connectivity through TURN always
      *     and ignore all other ICE candidates.
      *   </li>
      *
      *   <li>
      *     <p>
      *     <code>customServers</code></code> (Array) — Set this to an array of objects defining
      *     your custom TURN servers. Each object corresponds to one custom TURN server, and it
      *     includes the following properties:
      *     </p>
      *     <p>
      *     <ul>
      *       <li>
      *         <code>urls</code> (String or Array of Strings) — A string or an array of strings,
      *         where each string is a URL supported by the TURN server (and this may be only one URL).
      *       </li>
      *
      *       <li>
      *         <code>username</code> (String, optional) — The username for the TURN server defined
      *         in this object.
      *       </li>
      *
      *       <li>
      *         <code>credential</code> (String, optional) — The credential string for the TURN server
      *         defined in this object.
      *       </li>
      *     </ul>
      *     </p>
      *  </li>
      *
      * </ul>
      * </p>
      *
      * @method #setIceConfig
      *
      * @memberOf Session
    */ this.setIceConfig = /*#__PURE__*/ function() {
                            var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(newIceConfig) {
                                var extractServersFromIceConfig, processedIceServers;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            validateIceConfig(newIceConfig);
                                            analytics.logEvent({
                                                action: 'setIceConfig',
                                                variation: 'Attempt',
                                                payload: {
                                                    newIceConfig: newIceConfig
                                                }
                                            }); // future publishers will need the new iceConfig
                                            iceConfig = newIceConfig;
                                            extractServersFromIceConfig = (iceConfigObject)=>({
                                                    iceServers: iceConfigObject.customServers,
                                                    iceTransportPolicy: iceConfigObject.transportPolicy
                                                });
                                            processedIceServers = extractServersFromIceConfig(newIceConfig);
                                            _context.prev = 5;
                                            _context.next = 8;
                                            return Promise.all(sessionObjects.publishers.map((pub)=>pub._.setIceConfig(processedIceServers)).concat(sessionObjects.subscribers.map((sub)=>sub._.setIceConfig(processedIceServers))));
                                        case 8:
                                            _context.next = 14;
                                            break;
                                        case 10:
                                            _context.prev = 10;
                                            _context.t0 = _context["catch"](5);
                                            analytics.logEvent({
                                                action: 'setIceConfig',
                                                variation: 'Failure',
                                                payload: {
                                                    newIceConfig: newIceConfig
                                                }
                                            });
                                            throw _context.t0;
                                        case 14:
                                            analytics.logEvent({
                                                action: 'setIceConfig',
                                                variation: 'Success',
                                                payload: {
                                                    newIceConfig: newIceConfig
                                                }
                                            });
                                        case 15:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        5,
                                        10
                                    ]
                                ]);
                            }));
                            return function(_x) {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        /**
    * Subscribes to a stream that is available to the session. You can get an array of
    * available streams from the <code>streams</code> property of the <code>sessionConnected</code>
    * and <code>streamCreated</code> events (see
    * <a href="SessionConnectEvent.html">SessionConnectEvent</a> and
    * <a href="StreamEvent.html">StreamEvent</a>).
    * </p>
    * <p>
    * The subscribed stream is displayed on the local web page by replacing the specified element
    * in the DOM with a streaming video display. If the width and height of the display do not
    * match the 4:3 aspect ratio of the video signal, the video stream is cropped to fit
    * the display. If the stream lacks a video component, a blank screen with an audio indicator
    * is displayed in place of the video stream.
    * </p>
    *
    * <p>
    * The application throws an error if the session is not connected<!--JS-ONLY--> or if the
    * <code>targetElement</code> does not exist in the HTML DOM<!--/JS-ONLY-->.
    * </p>
    *
    * <h5>Example</h5>
    *
    * The following code subscribes to other clients' streams:
    *
    * <pre>
    * var apiKey = ""; // Replace with your API key. See https://tokbox.com/account
    * var sessionID = ""; // Replace with your own session ID.
    *                     // See https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    *
    * var session = OT.initSession(apiKey, sessionID);
    * session.on("streamCreated", function(event) {
    *   subscriber = session.subscribe(event.stream, targetElement);
    * });
    * session.connect(token);
    * </pre>
    *
    * @param {Stream} stream The Stream object representing the stream to which we are trying to
    * subscribe.
    *
    * @param {Object} targetElement (Optional) The DOM element or the <code>id</code> attribute of
    * the existing DOM element used to determine the location of the Subscriber video in the HTML
    * DOM. See the <code>insertMode</code> property of the <code>properties</code> parameter. If
    * you do not specify a <code>targetElement</code>, the application appends a new DOM element
    * to the HTML <code>body</code>.
    *
    * @param {Object} properties This is an object that contains the following properties:
    *    <ul>
    *       <li><code>audioVolume</code> (Number) &#151; The desired audio volume, between 0 and
    *       100, when the Subscriber is first opened (default: 50). After you subscribe to the
    *       stream, you can adjust the volume by calling the
    *       <a href="Subscriber.html#setAudioVolume"><code>setAudioVolume()</code> method</a> of the
    *       Subscriber object. This volume setting affects local playback only; it does not affect
    *       the stream's volume on other clients.</li>
    *
    *       <li>
    *         <code>fitMode</code> (String) &#151; Determines how the video is displayed if the its
    *           dimensions do not match those of the DOM element. You can set this property to one of
    *           the following values:
    *           <p>
    *           <ul>
    *             <li>
    *               <code>"cover"</code> &mdash; The video is cropped if its dimensions do not match
    *               those of the DOM element. This is the default setting for videos that have a
    *               camera as the source (for Stream objects with the <code>videoType</code> property
    *               set to <code>"camera"</code>).
    *             </li>
    *             <li>
    *               <code>"contain"</code> &mdash; The video is letterboxed if its dimensions do not
    *               match those of the DOM element. This is the default setting for screen-sharing
    *               videos (for Stream objects with the <code>videoType</code> property set to
    *               <code>"screen"</code>).
    *             </li>
    *           </ul>
    *       </li>
    *
    *       <li>
    *       <code>height</code> (Number or String) &#151; The desired initial height of the displayed
    *       video in the HTML page (default: 198 pixels). You can specify the number of pixels as
    *       either a number (such as 300) or a string ending in "px" (such as "300px"). Or you can
    *       specify a percentage of the size of the parent element, with a string ending in "%"
    *       (such as "100%"). <i>Note:</i> To resize the video, adjust the CSS of the subscriber's
    *       DOM element (the <code>element</code> property of the Subscriber object) or (if the
    *       height is specified as a percentage) its parent DOM element (see
    *       <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">
    *       Resizing or repositioning a video</a>).
    *       </li>
    *       <li>
    *       <strong>insertDefaultUI</strong> (Boolean) &#151; Whether to use the default OpenTok UI
    *       (<code>true</code>, the default) or not (<code>false</code>). The default UI element
    *       contains user interface controls, a video loading indicator, and automatic video cropping
    *       or letterboxing, in addition to the video. (If you leave <code>insertDefaultUI</code>
    *       set to <code>true</code>, you can control individual UI settings using the
    *       <code>fitMode</code>, <code>showControls</code>, and <code>style</code> options.)
    *       <p>
    *       If you set this option to <code>false</code>, OpenTok.js does not insert a default UI
    *       element in the HTML DOM, and the <code>element</code> property of the Subscriber object is
    *       undefined. The Subscriber object dispatches a
    *       <a href="Subscriber.html#event:videoElementCreated">videoElementCreated</a> event when
    *       the <code>video</code> element (or in Internet Explorer the <code>object</code> element
    *       containing the video) is created. The <code>element</code> property of the event object
    *       is a reference to the Subscriber's <code>video</code> (or <code>object</code>) element.
    *       Add it to the HTML DOM to display the video.
    *       <p>
    *       Set this option to <code>false</code> if you want to move the Publisher's
    *       <code>video</code> element (or its <code>object</code> element in Internet Explorer) in
    *       the HTML DOM.
    *       <p>
    *       If you set this to <code>false</code>, do not set the <code>targetElement</code>
    *       parameter. (This results in an error passed into to the <code>OT.initPublisher()</code>
    *       callback function.) To add the video to the HTML DOM, add an event listener for the
    *       <code>videoElementCreated</code> event, and then add the <code>element</code> property of
    *       the event object into the HTML DOM.
    *       </li>
    *       <li>
    *         <code>insertMode</code> (String) &#151; Specifies how the Subscriber object will
    *         be inserted in the HTML DOM. See the <code>targetElement</code> parameter. This
    *         string can have the following values:
    *         <p>
    *         <ul>
    *           <li><code>"replace"</code> &#151; The Subscriber object replaces contents of the
    *             targetElement. This is the default.</li>
    *           <li><code>"after"</code> &#151; The Subscriber object is a new element inserted
    *             after the targetElement in the HTML DOM. (Both the Subscriber and targetElement
    *             have the same parent element.)</li>
    *           <li><code>"before"</code> &#151; The Subscriber object is a new element inserted
    *             before the targetElement in the HTML DOM. (Both the Subscriber and targetElement
    *             have the same parent element.)</li>
    *           <li><code>"append"</code> &#151; The Subscriber object is a new element added as a
    *             child of the targetElement. If there are other child elements, the Subscriber is
    *             appended as the last child element of the targetElement.</li>
    *         </ul></p>
    *   <li>
    *   <code>preferredFrameRate</code> (Number) &#151; The preferred frame rate of the subscriber's
    *   video. Lowering the preferred frame rate lowers video quality on the subscribing client,
    *   but it also reduces network and CPU usage. You may want to use a lower frame rate for
    *   subscribers to a stream that is less important than other streams.
    *   <p>
    *   This property only applies when subscribing to a stream that uses the
    *   <a href="https://tokbox.com/developer/guides/scalable-video">
    *   scalable video feature</a>. Scalable video is available:
    *   <ul>
    *   <li>
    *     Only in sessions that use the OpenTok Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the OpenTok iOS SDK (on certain devices), the OpenTok
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    *   </ul>
    *   <p>
    *   In streams that do not use scalable video, setting this property has no effect.
    *   <p>
    *   <b>Note:</b> The frame rate for scalable video streams automatically adjusts for each
    *   subscriber, based on network conditions and CPU usage, even if you do not call this method.
    *   Call this method if you want to set a maximum frame rate for this subscriber.
    *   <p>
    *   <p>
    *   Not every frame rate is available to a subscriber. When you set the preferred frame rate for
    *   the subscriber, OpenTok.js picks the best frame rate available that matches your setting.
    *   The frame rates available are based on the value of the Subscriber object's
    *   <code>stream.frameRate</code> property, which represents the maximum value available for the
    *   stream. The actual frame rates available depend, dynamically, on network and CPU resources
    *   available to the publisher and subscriber.
    *   <p>
    *   You can dynamically change the preferred frame rate used by calling the
    *   <code>setPreferredFrameRate()</code> method of the Subscriber object.
    *   </li>
    *   <li>
    *   <code>preferredResolution</code> (Object) &#151; The preferred resolution of the subscriber's
    *   video. Set this to an object with two properties: <code>width</code> and <code>height</code>
    *   (both numbers), such as <code>{width: 320, height: 240}</code>. Lowering the preferred video
    *   resolution lowers video quality on the subscribing client, but it also reduces network and CPU
    *   usage. You may want to use a lower resolution based on the dimensions of subscriber's video on
    *   the web page. You may want to use a resolution for subscribers to a stream that is less
    *   important (and smaller) than other streams.
    *   <p>
    *   This property only applies when subscribing to a stream that uses the
    *   <a href="https://tokbox.com/developer/guides/scalable-video">
    *   scalable video feature</a>. Scalable video is available:
    *   <ul>
    *   <li>
    *     Only in sessions that use the OpenTok Media Router (sessions with the
    *     <a href="https://tokbox.com/developer/guides/create-session/#media-mode">media
    *     mode</a> set to routed).
    *   </li>
    *   <li>
    *     Only for streams published by clients that support scalable video:
    *     clients that use the OpenTok iOS SDK (on certain devices), the OpenTok
    *     Android SDK (on certain devices), or OpenTok.js in Chrome and Safari.
    *   </li>
    *   </ul>
    *   <p>
    *   In streams that do not use scalable video, setting this property has no effect.
    *   <p>
    *   Not every resolution is available to a subscriber. When you set the preferred resolution,
    *   OpenTok.js and the video encoder pick the best resolution available that matches your
    *   setting. The resolutions available depend on the resolution of the published stream.
    *   The Subscriber object's <code>stream.resolution</code> property  represents the highest
    *   resolution available for the stream. Each of the resolutions available for a stream will use
    *   the same aspect ratio. The actual resolutions available depend, dynamically, on network
    *   and CPU resources available to the publisher and subscriber.
    *   <p>
    *   You can dynamically change the preferred video resolution used by calling the
    *   <code>setPreferredResolution()</code> method of the Subscriber object.
    *   </li>
    *   <li>
    *   <code>showControls</code> (Boolean) &#151; Whether to display the built-in user interface
    *   controls for the Subscriber (default: <code>true</code>). These controls include the name
    *   display, the audio level indicator, the speaker control button, the video disabled indicator,
    *   and the video disabled warning icon. You can turn off all user interface controls by setting
    *   this property to <code>false</code>. You can control the display of individual user interface
    *   controls by leaving this property set to <code>true</code> (the default) and setting
    *   individual properties of the <code>style</code> property.
    *   </li>
    *   <li>
    *   <code>style</code> (Object) &#151; An object containing properties that define the initial
    *   appearance of user interface controls of the Subscriber. The <code>style</code> object
    *   includes the following properties:
    *     <ul>
    *       <li><code>audioBlockedDisplayMode</code> (String) &mdash; Whether to display
    *       the default audio blocked icon in Subscribers (in browsers where audio
    *       autoplay is blocked). Possible values are: <code>"auto"</code> (the default,
    *       icon is displayed when the audio is disabled) and <code>"off"</code> (the icon
    *       is not displayed). Set this to <code>"off"</code> if you want to display
    *       your own UI element showing that the audio is blocked. In response to an
    *       HTML element dispatching a <code>click</code> event, you can call the
    *       <a href="OT.html#unblockAudio">OT.unblockAudio()</a> method to start audio
    *       playback in this and all other blocked subscribers.</li>
    *
    *       <li><code>audioLevelDisplayMode</code> (String) &mdash; How to display the audio level
    *       indicator. Possible values are: <code>"auto"</code> (the indicator is displayed when the
    *       video is disabled), <code>"off"</code> (the indicator is not displayed), and
    *       <code>"on"</code> (the indicator is always displayed).</li>
    *
    *       <li><code>backgroundImageURI</code> (String) &mdash; A URI for an image to display as
    *       the background image when a video is not displayed. (A video may not be displayed if
    *       you call <code>subscribeToVideo(false)</code> on the Subscriber object). You can pass an
    *       http or https URI to a PNG, JPEG, or non-animated GIF file location. You can also use the
    *       <code>data</code> URI scheme (instead of http or https) and pass in base-64-encrypted
    *       PNG data, such as that obtained from the
    *       <a href="Subscriber.html#getImgData">Subscriber.getImgData()</a> method. (For example,
    *       you could set the property to a value returned by calling <code>getImgData()</code> on
    *       a previous Subscriber object.) If the URL or the image data is invalid, the
    *       property is ignored (the attempt to set the image fails silently).</li>
    *
    *       <li><code>buttonDisplayMode</code> (String) &mdash; How to display the speaker controls
    *       Possible values are: <code>"auto"</code> (controls are displayed when the stream is first
    *       displayed and when the user mouses over the display), <code>"off"</code> (controls are not
    *       displayed), and <code>"on"</code> (controls are always displayed).</li>
    *
    *       <li><code>nameDisplayMode</code> (String) &#151; Whether to display the stream name.
    *       Possible values are: <code>"auto"</code> (the name is displayed when the stream is first
    *       displayed and when the user mouses over the display), <code>"off"</code> (the name is not
    *       displayed), and <code>"on"</code> (the name is always displayed).</li>
    *
    *       <li><code>videoDisabledDisplayMode</code> (String) &#151; Whether to display the video
    *       disabled indicator and video disabled warning icons for a Subscriber. These icons
    *       indicate that the video has been disabled (or is in risk of being disabled for
    *       the warning icon) due to poor stream quality. This style only applies to the Subscriber
    *       object. Possible values are: <code>"auto"</code> (the icons are automatically when the
    *       displayed video is disabled or in risk of being disabled due to poor stream quality),
    *       <code>"off"</code> (do not display the icons), and <code>"on"</code> (display the
    *       icons). The default setting is <code>"auto"</code></li>
    *   </ul>
    *   </li>
    *
    *       <li><code>subscribeToAudio</code> (Boolean) &#151; Whether to initially subscribe to audio
    *       (if available) for the stream (default: <code>true</code>).</li>
    *
    *       <li><code>subscribeToVideo</code> (Boolean) &#151; Whether to initially subscribe to video
    *       (if available) for the stream (default: <code>true</code>).</li>
    *
    *       <li><code>testNetwork</code> (Boolean) &#151; Whether, when subscribing to a stream
    *       published by the local client, you want to have the stream come from the OpenTok Media
    *       Router (<code>true</code>) or if you want the DOM to simply to display the local camera's
    *       video (<code>false</code>). Set this to <code>true</code> when you want to use the
    *       <a href="Subscriber.html#getStats">Subscriber.getStats()</a> method to check statistics
    *       for a stream you publish. This setting only applies to streams published by the local
    *       client in a session that uses the OpenTok Media Router (sessions with the
    *       <a href="http://tokbox.com/opentok/tutorials/create-session/#media-mode">media mode</a>
    *       set to routed), not in sessions with the media mode set to relayed. The default value is
    *       <code>false</code>.</li>
    *
    *       <li>
    *       <code>width</code> (Number or String) &#151; The desired initial width of the displayed
    *       video in the HTML page (default: 264 pixels). You can specify the number of pixels as
    *       either a number (such as 400) or a string ending in "px" (such as "400px"). Or you can
    *       specify a percentage of the size of the parent element, with a string ending in "%"
    *       (such as "100%"). <i>Note:</i> To resize the video, adjust the CSS of the subscriber's
    *       DOM element (the <code>element</code> property of the Subscriber object) or (if the
    *       width is specified as a percentage) its parent DOM element (see
    *       <a href="https://tokbox.com/developer/guides/customize-ui/js/#video_resize_reposition">
    *       Resizing or repositioning a video</a>).
    *       </li>
    *
    *    </ul>
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>subscribe()</code> method succeeds or fails. This function takes one parameter &mdash;
    * <code>error</code>. On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object, defined by the
    * <a href="Error.html">Error</a> class, has two properties: <code>code</code> (an integer) and
    * <code>message</code> (a string), which identify the cause of the failure. The following
    * code adds a <code>completionHandler</code> when calling the <code>subscribe()</code> method:
    * <pre>
    * session.subscribe(stream, "subscriber", null, function (error) {
    *   if (error) {
    *     console.log(error.message);
    *   } else {
    *     console.log("Subscribed to stream: " + stream.id);
    *   }
    * });
    * </pre>
    *
    * @signature subscribe(stream, targetElement, properties, completionHandler)
    * @returns {Subscriber} The Subscriber object for this stream. Stream control functions
    * are exposed through the Subscriber object.
    * @method #subscribe
    * @memberOf Session
    */ this.subscribe = function(stream, targetElement, properties, completionHandler) {
                            if (typeof targetElement === 'function') {
                                completionHandler = targetElement;
                                targetElement = undefined;
                                properties = undefined;
                            }
                            if (typeof properties === 'function') {
                                completionHandler = properties;
                                properties = undefined;
                            }
                            completionHandler = completionHandler || function() {};
                            if (!this.connection || !this.connection.connectionId) {
                                dispatchOTError(otError(errors.NOT_CONNECTED, new Error('Session.subscribe :: Connection required to subscribe'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
                                return undefined;
                            }
                            if (!stream) {
                                dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('Session.subscribe :: stream cannot be null'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
                                return undefined;
                            }
                            if (!Object.prototype.hasOwnProperty.call(stream, 'streamId')) {
                                dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('Session.subscribe :: invalid stream object'), ExceptionCodes.UNABLE_TO_SUBSCRIBE), completionHandler);
                                return undefined;
                            }
                            if (properties && properties.insertDefaultUI === false && targetElement) {
                                dispatchOTError(otError(errors.INVALID_PARAMETER, new Error('You cannot specify a target element if insertDefaultUI is false'), ExceptionCodes.INVALID_PARAMETER), completionHandler);
                                return undefined;
                            }
                            if (targetElement && targetElement.insertDefaultUI === false) {
                                // You can omit the targetElement property if you set insertDefaultUI to false
                                properties = targetElement;
                                targetElement = undefined;
                            }
                            const subscriber = new Subscriber(targetElement, assign(properties || {}, {
                                stream: stream,
                                session: this,
                                analytics: // @todo this needs to go.
                                analytics,
                                _singlePeerConnectionController: _singlePeerConnectionController
                            }), (err)=>{
                                if (err) {
                                    dispatchOTError(err, completionHandler);
                                    return;
                                }
                                completionHandler(null, subscriber);
                            });
                            sessionObjects.subscribers.add(subscriber);
                            return subscriber;
                        };
                        /**
    * Stops subscribing to a stream in the session. the display of the audio-video stream is
    * removed from the local web page.
    *
    * <h5>Example</h5>
    * <p>
    * The following code subscribes to other clients' streams. For each stream, the code also
    * adds an Unsubscribe link.
    * </p>
    * <pre>
    * var apiKey = ""; // Replace with your API key. See See https://tokbox.com/account
    * var sessionID = ""; // Replace with your own session ID.
    *                     // See https://tokbox.com/developer/guides/create-session/.
    * var token = ""; // Replace with a generated token.
    *                 // See https://tokbox.com/developer/guides/create-token/.
    * var streams = [];
    *
    * var session = OT.initSession(apiKey, sessionID);
    * session.on("streamCreated", function(event) {
    *     var stream = event.stream;
    *     displayStream(stream);
    * });
    * session.connect(token);
    *
    * function displayStream(stream) {
    *     var div = document.createElement('div');
    *     div.setAttribute('id', 'stream' + stream.streamId);
    *
    *     var subscriber = session.subscribe(stream, div);
    *     subscribers.push(subscriber);
    *
    *     var aLink = document.createElement('a');
    *     aLink.setAttribute('href', 'javascript: unsubscribe("' + subscriber.id + '")');
    *     aLink.innerHTML = "Unsubscribe";
    *
    *     var streamsContainer = document.getElementById('streamsContainer');
    *     streamsContainer.appendChild(div);
    *     streamsContainer.appendChild(aLink);
    *
    *     streams = event.streams;
    * }
    *
    * function unsubscribe(subscriberId) {
    *     console.log("unsubscribe called");
    *     for (var i = 0; i &lt; subscribers.length; i++) {
    *         var subscriber = subscribers[i];
    *         if (subscriber.id == subscriberId) {
    *             session.unsubscribe(subscriber);
    *         }
    *     }
    * }
    * </pre>
    *
    * @param {Subscriber} subscriber The Subscriber object to unsubcribe.
    *
    * @see <a href="#subscribe">subscribe()</a>
    *
    * @method #unsubscribe
    * @memberOf Session
    */ this.unsubscribe = function(subscriber) {
                            if (!subscriber) {
                                const errorMsg = 'OT.Session.unsubscribe: subscriber cannot be null';
                                _logging.error(errorMsg);
                                throw new Error(errorMsg);
                            }
                            if (!subscriber.stream) {
                                _logging.warn('OT.Session.unsubscribe:: tried to unsubscribe a subscriber that had no stream');
                                return false;
                            }
                            _logging.debug(`OT.Session.unsubscribe: subscriber ${subscriber.id}`);
                            subscriber._destroy({
                                reason: 'Unsubscribe'
                            });
                            return true;
                        };
                        /**
    * Returns an array of local Subscriber objects for a given stream.
    *
    * @param {Stream} stream The stream for which you want to find subscribers.
    *
    * @returns {Array} An array of {@link Subscriber} objects for the specified stream.
    *
    * @see <a href="#unsubscribe">unsubscribe()</a>
    * @see <a href="Subscriber.html">Subscriber</a>
    * @see <a href="StreamEvent.html">StreamEvent</a>
    * @method #getSubscribersForStream
    * @memberOf Session
    */ this.getSubscribersForStream = function(stream) {
                            return sessionObjects.subscribers.where({
                                streamId: stream.id
                            });
                        };
                        /**
    * Returns the local Publisher object for a given stream.
    *
    * @param { Stream } stream The stream for which you want to find the Publisher.
    *
    * @returns { Publisher } A Publisher object for the specified stream. Returns
    * <code>null</code> if there is no local Publisher object
    * for the specified stream.
    *
    * @see <a href="#forceUnpublish">forceUnpublish()</a>
    * @see <a href="Subscriber.html">Subscriber</a>
    * @see <a href="StreamEvent.html">StreamEvent</a>
    *
    * @method #getPublisherForStream
    * @memberOf Session
    */ this.getPublisherForStream = function(stream) {
                            let streamId;
                            let errorMsg;
                            if (typeof stream === 'string') streamId = stream;
                            else if (typeof stream === 'object' && stream && Object.hasOwnProperty.call(stream, 'id')) streamId = stream.id;
                            else {
                                errorMsg = 'Session.getPublisherForStream :: Invalid stream type';
                                _logging.error(errorMsg);
                                throw new Error(errorMsg);
                            }
                            return sessionObjects.publishers.where({
                                streamId: streamId
                            })[0];
                        }; // Private Session API: for internal OT use only
                        this._ = {
                            getProxyUrl () {
                                return proxyUrl;
                            },
                            isE2ee () {
                                return _session.sessionInfo.e2ee && _e2eeSecretSet && !!_session.capabilities.supportsE2ee;
                            },
                            isSocketReconnecting () {
                                return _isSocketReconnecting;
                            },
                            getSocket () {
                                return _socket;
                            },
                            reconnecting: (function() {
                                _isSocketReconnecting = true;
                                this.dispatchEvent(new Events.SessionReconnectingEvent());
                            }).bind(this),
                            reconnected: (function() {
                                _isSocketReconnecting = false;
                                this.dispatchEvent(new Events.SessionReconnectedEvent());
                                if (this.sessionInfo.reconnection) {
                                    sessionObjects.publishers.where({
                                        session: this
                                    }).forEach((publisher)=>{
                                        publisher._.iceRestart();
                                    });
                                    if (!this.sessionInfo.p2pEnabled) sessionObjects.subscribers.where({
                                        session: this
                                    }).forEach((subscriber)=>{
                                        subscriber._.iceRestart('socket reconnected');
                                    });
                                }
                            }).bind(this),
                            // session.on("signal", function(SignalEvent))
                            // session.on("signal:{type}", function(SignalEvent))
                            dispatchSignal: (function(fromConnection, type, data) {
                                const event = new Events.SignalEvent(type, data, fromConnection);
                                event.target = this; // signal a "signal" event
                                // NOTE: trigger doesn't support defaultAction, and therefore preventDefault.
                                this.trigger(eventNames.SIGNAL, event); // signal an "signal:{type}" event" if there was a custom type
                                if (type) this.dispatchEvent(event);
                            }).bind(this),
                            dispatchCaption: (function(fromConnection, data) {
                                let caption;
                                let streamId;
                                try {
                                    const parsedData = JSON.parse(data.data);
                                    caption = parsedData.caption.text;
                                    streamId = parsedData.streamId;
                                } catch (error) {
                                    _logging.error(`Caption parsing failed: ${error.message}`);
                                    return;
                                }
                                const event = new Events.CaptionReceivedEvent(caption, streamId);
                                event.target = this;
                                this.trigger(eventNames.SUBSCRIBER_CAPTION_RECEIVED, event);
                                this.dispatchEvent(event);
                            }).bind(this),
                            subscriberChannelUpdate (stream, subscriber, channel, attributes) {
                                if (!_socket) {
                                    _logging.warn('You are disconnected, cannot update subscriber properties ', attributes);
                                    return null;
                                }
                                return _socket.subscriberChannelUpdate(stream.id, subscriber.widgetId, channel.id, attributes);
                            },
                            streamCreate (name, streamId, audioFallbackEnabled, channels, minBitrate, sourceStreamId, e2ee, completion) {
                                if (!_socket) {
                                    _logging.warn('You are disconnected, cannot create stream ', streamId);
                                    return;
                                }
                                _socket.streamCreate(name, streamId, audioFallbackEnabled, channels, minBitrate, undefined, sourceStreamId, e2ee, completion);
                            },
                            streamDestroy (streamId, sourceStreamId) {
                                if (!_socket) {
                                    _logging.warn('You are disconnected, cannot destroy stream ', streamId);
                                    return;
                                }
                                _socket.streamDestroy(streamId, sourceStreamId);
                            },
                            streamChannelUpdate (stream, channel, attributes) {
                                if (!_socket) {
                                    _logging.warn('You are disconnected, cannot update stream properties ', attributes);
                                    return;
                                }
                                _socket.streamChannelUpdate(stream.id, channel.id, attributes);
                            },
                            // allow these variables to be overridden in unit tests
                            // it's dirty, but I figure it can be cleaned up when we implement proper DI for our unit tests
                            setSocket (newSocket) {
                                _socket = newSocket;
                            },
                            setLogging (newLogging) {
                                _logging = newLogging;
                            },
                            setState: setState,
                            setIceServers (iceServers) {
                                if (!iceServers) return;
                                _iceServerDetails = {
                                    iceServers: adaptIceServers(iceServers),
                                    timestamp: Date.now()
                                };
                            },
                            getOtIceServerInfo () {
                                const timeElapsed = !_iceServerDetails ? Infinity : Date.now() - _iceServerDetails.timestamp;
                                const validDuration = 86400000; // 24 hours
                                const validTimeRemaining = validDuration - timeElapsed;
                                const fiveMinutes = 300000;
                                if (validTimeRemaining > fiveMinutes) return Promise.resolve({
                                    transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
                                    servers: _iceServerDetails && _iceServerDetails.iceServers
                                });
                                if (!_token) // @todo why would this happen before connect() where a token is set?
                                // Need a token for getting ICE servers from GSI
                                return Promise.resolve({
                                    transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
                                    servers: [],
                                    needRumorIceServersFallback: true
                                });
                                const clientVersion = localStaticConfig.clientVersion;
                                return getSessionInfo({
                                    anvilUrl: (this.staticConfig || localStaticConfig).apiUrl,
                                    sessionId: sessionId,
                                    token: _token,
                                    connectionId: _connectionId,
                                    clientVersion: clientVersion
                                }).then((sessionInfo)=>{
                                    _session._.setIceServers(sessionInfo.iceServers);
                                    if (!_iceServerDetails) // No ICE servers provided by GSI
                                    return {
                                        transportPolicy: _session.sessionInfo.clientCandidates,
                                        servers: [],
                                        needRumorIceServersFallback: true
                                    };
                                    return {
                                        transportPolicy: _session && _session.sessionInfo && _session.sessionInfo.clientCandidates,
                                        servers: _iceServerDetails && _iceServerDetails.iceServers
                                    };
                                });
                            },
                            getCodecFlags: ()=>({
                                    h264: _session.sessionInfo.h264,
                                    vp9: _session.sessionInfo.vp9,
                                    vp8: _session.sessionInfo.vp8
                                }),
                            getVideoCodecsCompatible: (webRTCStream)=>testRemovingVideoCodecs({
                                    RTCPeerConnection: windowMock.RTCPeerConnection,
                                    env: OTHelpers.env,
                                    stream: webRTCStream,
                                    codecFlags: _session._.getCodecFlags()
                                }),
                            getIceConfig: ()=>{
                                if (!iceConfig) return _session._.getOtIceServerInfo();
                                const transportPolicy = (()=>{
                                    if (iceConfig && iceConfig.transportPolicy === 'relay') return 'relay';
                                    return _session.sessionInfo.clientCandidates;
                                })();
                                const otIceServersInfoPromise = iceConfig.includeServers === 'custom' ? Promise.resolve({
                                    servers: []
                                }) : _session._.getOtIceServerInfo();
                                return otIceServersInfoPromise.then((otIceServerInfo)=>assign(otIceServerInfo, {
                                        transportPolicy: transportPolicy,
                                        servers: [
                                            ...otIceServerInfo.servers,
                                            ...iceConfig.customServers
                                        ]
                                    }));
                            },
                            forceMute: (function(muteForcedInfo) {
                                this.dispatchEvent(new Events.MuteForcedEvent(muteForcedInfo));
                            }).bind(this),
                            enableMuteOnEntry: ()=>{
                                _muteOnEntry = true;
                            },
                            addSubscriberToPeerConnectionsQueue: (pc, message)=>{
                                _subscribersQueue.push({
                                    pc: pc,
                                    message: message
                                });
                                if (!_subscribersQueueInterval) _subscribersQueueInterval = setInterval(()=>{
                                    const offer = _subscribersQueue.pop();
                                    if (offer) offer.pc.processMessage('offer', offer.message);
                                    else {
                                        clearInterval(_subscribersQueueInterval);
                                        _subscribersQueueInterval = null;
                                    }
                                }, 100);
                            },
                            disableMuteOnEntry: ()=>{
                                _muteOnEntry = false;
                            },
                            privateEvents: new EventEmitter()
                        };
                        /**
    * Sends a signal to each client or a specified client in the session. Specify a
    * <code>to</code> property of the <code>signal</code> parameter to limit the signal to
    * be sent to a specific client; otherwise the signal is sent to each client connected to
    * the session.
    * <p>
    * The following example sends a signal of type "foo" with a specified data payload ("hello")
    * to all clients connected to the session:
    * <pre>
    * session.signal({
    *     type: "foo",
    *     data: "hello"
    *   },
    *   function(error) {
    *     if (error) {
    *       console.log("signal error: " + error.message);
    *     } else {
    *       console.log("signal sent");
    *     }
    *   }
    * );
    * </pre>
    * <p>
    * Calling this method without specifying a recipient client (by setting the <code>to</code>
    * property of the <code>signal</code> parameter) results in multiple signals sent (one to each
    * client in the session). For information on charges for signaling, see the
    * <a href="http://tokbox.com/pricing">OpenTok pricing</a> page.
    * <p>
    * The following example sends a signal of type "foo" with a data payload ("hello") to a
    * specific client connected to the session:
    * <pre>
    * session.signal({
    *     type: "foo",
    *     to: recipientConnection; // a Connection object
    *     data: "hello"
    *   },
    *   function(error) {
    *     if (error) {
    *       console.log("signal error: " + error.message);
    *     } else {
    *       console.log("signal sent");
    *     }
    *   }
    * );
    * </pre>
    * <p>
    * Add an event handler for the <code>signal</code> event to listen for all signals sent in
    * the session. Add an event handler for the <code>signal:type</code> event to listen for
    * signals of a specified type only (replace <code>type</code>, in <code>signal:type</code>,
    * with the type of signal to listen for). The Session object dispatches these events. (See
    * <a href="#events">events</a>.)
    *
    * @param {Object} signal An object that contains the following properties defining the signal:
    * <ul>
    *   <li><code>data</code> &mdash; (String) The data to send. The limit to the length of data
    *     string is 8kB. Do not set the data string to <code>null</code> or
    *     <code>undefined</code>.</li>
    *   <li><code>retryAfterReconnect</code>&mdash; (Boolean) Upon reconnecting to the session,
    *     whether to send any signals that were initiated while disconnected. If your client loses its
    *     connection to the OpenTok session, due to a drop in network connectivity, the client
    *     attempts to reconnect to the session, and the Session object dispatches a
    *     <code>reconnecting</code> event. By default, signals initiated while disconnected are
    *     sent when (and if) the client reconnects to the OpenTok session. You can prevent this by
    *     setting the <code>retryAfterReconnect</code> property to <code>false</code>. (The default
    *     value is <code>true</code>.)
    *   <li><code>to</code> &mdash; (Connection) A <a href="Connection.html">Connection</a>
    *      object corresponding to the client that the message is to be sent to. If you do not
    *      specify this property, the signal is sent to all clients connected to the session.</li>
    *   <li><code>type</code> &mdash; (String) The type of the signal. You can use the type to
    *     filter signals when setting an event handler for the <code>signal:type</code> event
    *     (where you replace <code>type</code> with the type string). The maximum length of the
    *     <code>type</code> string is 128 characters, and it must contain only letters (A-Z and a-z),
    *     numbers (0-9), '-', '_', and '~'.</li>
    *   </li>
    * </ul>
    *
    * <p>Each property is optional. If you set none of the properties, you will send a signal
    * with no data or type to each client connected to the session.</p>
    *
    * @param {Function} completionHandler (Optional) A function that is called when sending the signal
    * succeeds or fails. This function takes one parameter &mdash; <code>error</code>.
    * On success, the <code>completionHandler</code> function is not passed any
    * arguments. On error, the function is passed an <code>error</code> object, defined by the
    * <a href="Error.html">Error</a> class. The <code>error</code> object has the following
    * properties:
    *
    * <ul>
    *   <li><code>code</code> &mdash; (Number) An error code, which can be one of the following:
    *     <table class="docs_table">
    *         <tr>
    *           <td>400</td> <td>One of the signal properties is invalid.</td>
    *         </tr>
    *         <tr>
    *           <td>404</td> <td>The client specified by the <code>to</code> property is not connected
    *                        to the session.</td>
    *         </tr>
    *         <tr>
    *           <td>413</td> <td>The <code>type</code> string exceeds the maximum length (128 bytes),
    *                        or the <code>data</code> string exceeds the maximum size (8 kB).</td>
    *         </tr>
    *         <tr>
    *           <td>500</td> <td>You are not connected to the OpenTok session.</td>
    *         </tr>
    *      </table>
    *   </li>
    *   <li><code>message</code> &mdash; (String) A description of the error.</li>
    * </ul>
    *
    * <p>Note that the <code>completionHandler</code> success result (<code>error == null</code>)
    * indicates that the options passed into the <code>Session.signal()</code> method are valid
    * and the signal was sent. It does <i>not</i> indicate that the signal was successfully
    * received by any of the intended recipients.
    *
    * @method #signal
    * @memberOf Session
    * @see <a href="#event:signal">signal</a> and <a href="#event:signal:type">signal:type</a> events
    */ this.signal = function(options, completion) {
                            let _options = options;
                            let _completion = completion || function() {};
                            if (isFunction(_options)) {
                                _completion = _options;
                                _options = null;
                            }
                            if (this.isNot('connected')) {
                                const notConnectedErrorMsg = 'Unable to send signal - you are not connected to the session.';
                                dispatchOTError(otError(errors.NOT_CONNECTED, new Error(notConnectedErrorMsg), 500), _completion);
                                return;
                            }
                            function getErrorNameFromCode(code) {
                                switch(code){
                                    case 400:
                                    case 413:
                                        return errors.INVALID_PARAMETER;
                                    case 429:
                                        return errors.RATE_LIMIT_EXCEEDED;
                                    case 404:
                                        return errors.NOT_FOUND;
                                    case 500:
                                        return errors.NOT_CONNECTED;
                                    case 403:
                                        return errors.PERMISSION_DENIED;
                                    case 2001:
                                        return errors.UNEXPECTED_SERVER_RESPONSE;
                                    default:
                                        return undefined;
                                }
                            }
                            _socket.signal(_options, function(error) {
                                if (error) {
                                    const errorName = getErrorNameFromCode(error.code);
                                    if (errorName) error = otError(errorName, new Error(error.message), error.code);
                                    _completion(error);
                                    return;
                                }
                                for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                                _completion(error, ...args);
                            }, this.logEvent);
                            if (options && options.data && typeof options.data !== 'string') _logging.warn("Signaling of anything other than Strings is deprecated. Please update the data property to be a string.");
                        };
                        /**
    *   Forces a remote connection to leave the session.
    *
    * <p>
    *   The <code>forceDisconnect()</code> method is normally used as a moderation tool
    *        to remove users from an ongoing session.
    * </p>
    * <p>
    *   When a connection is terminated using the <code>forceDisconnect()</code>,
    *        <code>sessionDisconnected</code>, <code>connectionDestroyed</code> and
    *        <code>streamDestroyed</code> events are dispatched in the same way as they
    *        would be if the connection had terminated itself using the <code>disconnect()</code>
    *        method. However, the <code>reason</code> property of a {@link ConnectionEvent} or
    *        {@link StreamEvent} object specifies <code>"forceDisconnected"</code> as the reason
    *        for the destruction of the connection and stream(s).
    * </p>
    * <p>
    *   While you can use the <code>forceDisconnect()</code> method to terminate your own connection,
    *        calling the <code>disconnect()</code> method is simpler.
    * </p>
    * <p>
    *   The OT object dispatches an <code>exception</code> event if the user's role
    *   does not include permissions required to force other users to disconnect.
    *   You define a user's role when you create the user token (see the
    *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    *   See <a href="ExceptionEvent.html">ExceptionEvent</a> and <a href="OT.html#on">OT.on()</a>.
    * </p>
    * <p>
    *   The application throws an error if the session is not connected.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    *   <code>connectionDestroyed</code> (<a href="ConnectionEvent.html">ConnectionEvent</a>) &#151;
    *     On clients other than which had the connection terminated.
    * </p>
    * <p>
    *   <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151;
    *     The user's role does not allow forcing other user's to disconnect (<code>event.code =
    *     1530</code>),
    *   or the specified stream is not publishing to the session (<code>event.code = 1535</code>).
    * </p>
    * <p>
    *   <code>sessionDisconnected</code>
    *   (<a href="SessionDisconnectEvent.html">SessionDisconnectEvent</a>) &#151;
    *     On the client which has the connection terminated.
    * </p>
    * <p>
    *   <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    *     If streams are stopped as a result of the connection ending.
    * </p>
    *
    * @param {Connection} connection The connection to be disconnected from the session.
    * This value can either be a <a href="Connection.html">Connection</a> object or a connection
    * ID (which can be obtained from the <code>connectionId</code> property of the Connection object).
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>forceDiscononnect()</code> method succeeds or fails. This function takes one parameter
    * &mdash; <code>error</code>. On success, the <code>completionHandler</code> function is
    * not passed any arguments. On error, the function is passed an <code>error</code> object
    * parameter. The <code>error</code> object, defined by the <a href="Error.html">Error</a>
    * class, has two properties: <code>code</code> (an integer)
    * and <code>message</code> (a string), which identify the cause of the failure.
    * Calling <code>forceDisconnect()</code> fails if the role assigned to your
    * token is not "moderator"; in this case the <code>error.name</code> property is set to
    * <code>"OT_PERMISSION_DENIED"</code>. The following code adds a <code>completionHandler</code>
    * when calling the <code>forceDisconnect()</code> method:
    * <pre>
    * session.forceDisconnect(connection, function (error) {
    *   if (error) {
    *     console.log(error);
    *   } else {
    *     console.log("Connection forced to disconnect: " + connection.id);
    *   }
    * });
    * </pre>
    *
    * @method #forceDisconnect
    * @memberOf Session
    */ this.forceDisconnect = function(connectionOrConnectionId, completionHandler) {
                            if (this.isNot('connected')) {
                                const notConnectedErrorMsg = "Cannot call forceDisconnect(). You are not connected to the session.";
                                dispatchOTError(otError(errors.NOT_CONNECTED, new Error(notConnectedErrorMsg), ExceptionCodes.NOT_CONNECTED), completionHandler);
                                return;
                            }
                            const connectionId = typeof connectionOrConnectionId === 'string' ? connectionOrConnectionId : connectionOrConnectionId.id;
                            const invalidParameterErrorMsg = 'Invalid Parameter. Check that you have passed valid parameter values into the method call.';
                            if (!connectionId) {
                                dispatchOTError(otError(errors.INVALID_PARAMETER, new Error(invalidParameterErrorMsg), ExceptionCodes.INVALID_PARAMETER), completionHandler);
                                return;
                            }
                            const notPermittedErrorMsg = "This token does not allow forceDisconnect. The role must be at least `moderator` to enable this functionality";
                            if (!permittedTo('forceDisconnect')) {
                                dispatchOTError(otError(errors.PERMISSION_DENIED, new Error(notPermittedErrorMsg), ExceptionCodes.UNABLE_TO_FORCE_DISCONNECT), completionHandler);
                                return;
                            }
                            _socket.forceDisconnect(connectionId, function(err) {
                                if (err) dispatchOTError(otError(errors.INVALID_PARAMETER, new Error(invalidParameterErrorMsg), ExceptionCodes.INVALID_PARAMETER), completionHandler);
                                else if (completionHandler && isFunction(completionHandler)) {
                                    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
                                    completionHandler(err, ...args);
                                }
                            });
                        };
                        /**
    * Forces the publisher of the specified stream to stop publishing the stream.
    *
    * <p>
    * Calling this method causes the Session object to dispatch a <code>streamDestroyed</code>
    * event on all clients that are subscribed to the stream (including the client that is
    * publishing the stream). The <code>reason</code> property of the StreamEvent object is
    * set to <code>"forceUnpublished"</code>.
    * </p>
    * <p>
    * The OT object dispatches an <code>exception</code> event if the user's role
    * does not include permissions required to force other users to unpublish.
    * You define a user's role when you create the user token (see the
    * <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    * You pass the token string as a parameter of the <code>connect()</code> method of the Session
    * object. See <a href="ExceptionEvent.html">ExceptionEvent</a> and
    * <a href="OT.html#on">OT.on()</a>.
    * </p>
    *
    * <h5>Events dispatched:</h5>
    *
    * <p>
    *   <code>exception</code> (<a href="ExceptionEvent.html">ExceptionEvent</a>) &#151;
    *     The user's role does not allow forcing other users to unpublish.
    * </p>
    * <p>
    *   <code>streamDestroyed</code> (<a href="StreamEvent.html">StreamEvent</a>) &#151;
    *     The stream has been unpublished. The Session object dispatches this on all clients
    *     subscribed to the stream, as well as on the publisher's client.
    * </p>
    *
    * @param {Stream} stream The stream to be unpublished.
    *
    * @param {Function} completionHandler (Optional) A function to be called when the call to the
    * <code>forceUnpublish()</code> method succeeds or fails. This function takes one parameter
    * &mdash; <code>error</code>. On success, the <code>completionHandler</code> function is
    * not passed any arguments. On error, the function is passed an <code>error</code> object
    * parameter. The <code>error</code> object, defined by the <a href="Error.html">Error</a>
    * class, has two properties: <code>code</code> (an integer)
    * and <code>message</code> (a string), which identify the cause of the failure. Calling
    * <code>forceUnpublish()</code> fails if the role assigned to your token is not "moderator";
    * in this case the <code>error.name</code> property is set to <code>"OT_PERMISSION_DENIED"</code>.
    * The following code adds a completion handler when calling the <code>forceUnpublish()</code>
    * method:
    * <pre>
    * session.forceUnpublish(stream, function (error) {
    *   if (error) {
    *       console.log(error);
    *     } else {
    *       console.log("Connection forced to disconnect: " + connection.id);
    *     }
    *   });
    * </pre>
    *
    * @method #forceUnpublish
    * @memberOf Session
    */ this.forceUnpublish = function(streamOrStreamId, completionHandler) {
                            if (completionHandler === void 0) completionHandler = ()=>{};
                            const dispatchError = (err)=>dispatchOTError(otError(err.name, new Error(err.msg), err.code), completionHandler);
                            const invalidParameterError = {
                                msg: 'Invalid Parameter. Check that you have passed valid parameter values into the method call.',
                                code: ExceptionCodes.INVALID_PARAMETER,
                                name: errors.INVALID_PARAMETER
                            };
                            const notConnectedError = {
                                msg: 'Cannot call forceUnpublish(). You are not connected to the session.',
                                code: ExceptionCodes.NOT_CONNECTED,
                                name: errors.NOT_CONNECTED
                            };
                            const notPermittedError = {
                                msg: "This token does not allow forceUnpublish. The role must be at least `moderator` to enable this functionality",
                                code: ExceptionCodes.UNABLE_TO_FORCE_UNPUBLISH,
                                name: errors.PERMISSION_DENIED
                            };
                            const notFoundError = {
                                msg: 'The stream does not exist.',
                                name: errors.NOT_FOUND
                            };
                            const unexpectedError = {
                                msg: 'An unexpected error occurred.',
                                name: errors.UNEXPECTED_SERVER_RESPONSE,
                                code: ExceptionCodes.UNEXPECTED_SERVER_RESPONSE
                            };
                            if (!streamOrStreamId) {
                                dispatchError(invalidParameterError);
                                return;
                            }
                            if (_this.isNot('connected')) {
                                dispatchError(notConnectedError);
                                return;
                            }
                            const stream = getStream(streamOrStreamId);
                            if (!permittedTo('forceUnpublish')) {
                                // if this throws an error the handleJsException won't occur
                                dispatchError(notPermittedError);
                                return;
                            }
                            _socket.forceUnpublish(stream.id, (err)=>{
                                if (!err) {
                                    completionHandler(null);
                                    return;
                                }
                                if (err.code === '404') dispatchError(notFoundError);
                                else if (err.code === '403') dispatchError(notPermittedError);
                                else dispatchError(unexpectedError);
                            });
                        };
                        /**
    * Forces a the publisher of a specified stream to mute its audio.
    *
    * <p>
    * Calling this method causes the Publisher object in the client publishing the
    * stream to dispatch a <code>muteForced</code> event.
    * </p>
    *
    * <p>
    * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
    * you can call this function successfully. This is reserved for clients that have connected
    * with a token that has been assigned the moderator role (see the
    * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
    * documentation).
    *
    * @param { Stream } stream The stream to be muted.
    *
    * @method #forceMuteStream
    * @memberOf Session
    * @see <a href="Session.html#properties">Session.capabilities</a>
    * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
    * @see <a href="Publisher.html#event:muteForced">Publisher muteForced event</a>
    * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
    * of streams in a session</a>
    *
    * @return {Promise} A promise that resolves with no value when the operation
    * completes successfully. The promise is rejected if there is an error. The
    * <code>name</code> property of the Error object is set to one of the following
    * values, depending the type of error:
    *
    * <p>
    * <ul>
    *
    *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
    *
    *   <li><code>'OT_INVALID_PARAMETER'</code> &mdash; if one or more of the passed parameters are invalid.</li>
    *
    *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
    *   include permissions required to force other users to mute.
    *   You define a user's role when you create the user token (see the
    *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
    *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
    *   object.
    *   </li>
    *
    *   <li><code>'OT_NOT_FOUND'</code> &mdash; The stream wasn't found in this session.</li>
    *
    *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; In case of an internal server error.</li>
    *
    * <ul>
    * </p>
    */ this.forceMuteStream = (stream)=>new Promise((resolve, reject)=>{
                                const error = checkMuteCapabilities();
                                if (error) {
                                    reject(error);
                                    return;
                                }
                                if (!stream || !stream.id) {
                                    reject(dispatchMuteError(forceMuteErrors.INVALID_PARAMETER));
                                    return;
                                }
                                _socket.forceMuteStream(stream.id, (err)=>{
                                    if (err) reject(handleMuteServerError(err));
                                    else resolve();
                                });
                            });
                        /**
     * Forces all publishers in the session (except for those publishing excluded streams)
     * to mute audio.
     *
     * <p>
     * A stream published by the moderator calling the <code>forceMuteAll()</code> method is muted
     * along with other streams in the session, unless you add the moderator&apos;s stream (or streams) to
     * the excluded streams array.
     * </p>
     *
     * <p>
     * If you leave out the <code>excludedStreams</code> parameter, all streams in the session
     * (including those of the moderator) will stop publishing audio:
     * </p>
     *
     * <pre><code class="js">session.forceMuteAll();
     * </code></pre>
     *
     * <p>
     * Also, any streams that are published after the call to the <code>forceMuteAll()</code> method
     * are published with audio muted. You can remove the mute state of a session by calling the
     * <code>disableForceMute()</code> method of the Session object.
     * </p>
     *
     * <pre><code class="js">session.disableForceMute();
     * </code></pre>
     *
     * <p>After you call the <code>Session.disableForceMute()</code> method, new streams published
     * to the session will no longer have audio muted.</p>
     *
     * <p>
     * Calling this method causes the Publisher objects in the clients publishing
     * the streams to dispatch <code>muteForced</code> events. Also, the Session object
     * in each client connected to the session dispatches the <code>muteForced</code>
     * event (with the <code>active</code> property of the event object set to <code>true</code>).
     * </p>
     *
     * <p>
     * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
     * you can call this function successfully. This is reserved for clients that have connected
     * with a token that has been assigned the moderator role (see the
     * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
     * documentation).
     *
     * @param {Array} excludedStreams An array of Stream objects to be excluded from
     * being muted. Note that if you want to prevent the local client's published stream(s)
     * from being muted, include the Stream object(s) for those stream(s) in this array.
     *
     * @method #forceMuteAll
     * @memberOf Session
     *
     * @see <a href="Session.html#properties">Session.capabilities</a>
     * @see <a href="Session.html#forceMuteStream">Session.forceMuteStream()</a>
     * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
     * @see <a href="#event:muteForced">Session muteForced event</a>
     * @see <a href="Publisher.html#event:muteForced">Publisher muteForced event</a>
     * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
     * of streams in a session</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. The promise is rejected if there is an error. The
     * <code>name</code> property of the Error object is set to one of the following
     * values, depending the type of error:
     *
     * <p>
     * <ul>
     *
     *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
     *
     *   <li><code>'INVALID_PARAMETER'</code> &mdash; if one or more of the passed parameters are invalid.</li>
     *
     *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
     *   include permissions required to force other users to mute.
     *   You define a user's role when you create the user token (see the
     *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
     *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
     *   object.
     *   </li>
     *
     *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; in case of an internal server error.</li>
     * <ul>
     * </p>
     */ this.forceMuteAll = (excludedStreams)=>new Promise((resolve, reject)=>{
                                const error = checkMuteCapabilities();
                                if (error) {
                                    reject(error);
                                    return;
                                } // Invalid parameter error should occur when an array of elements is passed where 1 or more of these elements is not
                                // an instanceof OT.Stream. excludedStreams can be undefined, null or an empty array and this just means all streams
                                // in the session need to be muted
                                if (Array.isArray(excludedStreams) && !excludedStreams.every((stream)=>stream instanceof Stream) || excludedStreams && !Array.isArray(excludedStreams)) {
                                    reject(dispatchMuteError(forceMuteErrors.INVALID_PARAMETER));
                                    return;
                                }
                                const excludedStreamIds = (excludedStreams || []).map((stream)=>stream.id);
                                _socket.forceMuteAll(excludedStreamIds, true, (err)=>{
                                    if (err) reject(handleMuteServerError(err));
                                    else resolve();
                                });
                            });
                        /**
     * Disables the active mute state of the session. After you call this method, new streams
     * published to the session will no longer have audio muted.
     *
     * <p>
     * After you call to the <code>Session.forceMuteAll()</code> method (or a moderator in another
     * client makes a call to mute all streams), any streams published after the moderation call are
     * published with audio muted. Call the <code>disableForceMute()</code> method to remove
     * the mute state of a session (so that new published streams are not automatically muted).
     * </p>
     *
     * <p>
     * Calling this method causes the Session object in each connected clients to dispatch a
     * <code>muteForced</code> event, with the <code>active</code> flag set to <code>false</code>.
     * </p>
     *
     * <p>
     * Check the <code>capabilities.canForceMute</code> property of the Session object to see if
     * you can call this function successfully. This is reserved for clients that have connected
     * with a token that has been assigned the moderator role (see the
     * <a href="https://tokbox.com/developer/guides/create-token/">Token Creation</a>
     * documentation).
     *
     * @method #disableForceMute
     * @memberOf Session
     *
     * @see <a href="Session.html#properties">Session.capabilities</a>
     * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
     * @see <a href="#event:muteForced">muteForced event</a>
     *
     * @return {Promise} A promise that resolves with no value when the operation
     * completes successfully. The promise is rejected if there is an error. The
     * <code>name</code> property of the Error object is set to one of the following
     * values, depending the type of error:
     *
     * <p>
     * <ul>
     *
     *   <li><code>'OT_NOT_CONNECTED'</code> &mdash; The client is not connect to the session.</li>
     *
     *   <li><code>'OT_PERMISSION_DENIED'</code> &mdash; The user's role does not
     *   include permissions required to force other users to mute.
     *   You define a user's role when you create the user token (see the
     *   <a href="https://tokbox.com/developer/guides/create-token/">Token creation overview</a>).
     *   You pass the token string as a parameter of the <code>connect()</code> method of the Session
     *   object.
     *   </li>
     *
     *   <li><code>'OT_UNEXPECTED_SERVER_RESPONSE'</code> &mdash; In case of an internal server error.</li>
     * <ul>
     * </p>
     */ this.disableForceMute = ()=>new Promise((resolve, reject)=>{
                                const error = checkMuteCapabilities();
                                if (error) {
                                    reject(error);
                                    return;
                                }
                                _socket.forceMuteAll([], false, (err)=>{
                                    if (err) reject(handleMuteServerError(err));
                                    else resolve();
                                });
                            });
                        this.setEncryptionSecret = /*#__PURE__*/ function() {
                            var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(secret) {
                                return _regenerator.default.wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            if (initialEncryptionSecret) {
                                                _context2.next = 3;
                                                break;
                                            }
                                            logging.error('Encryption secret must first be set in initSession.');
                                            return _context2.abrupt("return");
                                        case 3:
                                            _context2.prev = 3;
                                            validateSecret(secret);
                                            _context2.next = 10;
                                            break;
                                        case 7:
                                            _context2.prev = 7;
                                            _context2.t0 = _context2["catch"](3);
                                            throw otError(errors.INVALID_ENCRYPTION_SECRET, new Error(`setEncryptionSecret: ${_context2.t0.message}`));
                                        case 10:
                                            _context2.prev = 10;
                                            _context2.next = 13;
                                            return _this.keyStore.set(sessionId, secret);
                                        case 13:
                                            _context2.next = 18;
                                            break;
                                        case 15:
                                            _context2.prev = 15;
                                            _context2.t1 = _context2["catch"](10);
                                            _logging.error(`Error in setEncryptionSecret}: ${_context2.t1.message}`);
                                        case 18:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, null, [
                                    [
                                        3,
                                        7
                                    ],
                                    [
                                        10,
                                        15
                                    ]
                                ]);
                            }));
                            return function(_x2) {
                                return _ref4.apply(this, arguments);
                            };
                        }();
                        this.isConnected = ()=>this.is('connected');
                        this.capabilities = new Capabilities([], {
                            hasE2eeCapability: hasE2eeCapability
                        });
                    };
                    /**
   * Dispatched when an archive recording of the session starts.
   *
   * @name archiveStarted
   * @event
   * @memberof Session
   * @see ArchiveEvent
   * @see <a href="http://www.tokbox.com/opentok/tutorials/archiving">Archiving overview</a>
   */ /**
   * Dispatched when an archive recording of the session stops.
   *
   * @name archiveStopped
   * @event
   * @memberof Session
   * @see ArchiveEvent
   * @see <a href="http://www.tokbox.com/opentok/tutorials/archiving">Archiving overview</a>
   */ /**
   * Dispatched when a new client (including your own) has connected to the session, and for
   * every client in the session when you first connect. (The Session object also dispatches
   * a <code>sessionConnected</code> event when your local client connects.)
   *
   * @name connectionCreated
   * @event
   * @memberof Session
   * @see ConnectionEvent
   * @see <a href="OT.html#initSession">OT.initSession()</a>
   */ /**
   * A client, other than your own, has disconnected from the session.
   * @name connectionDestroyed
   * @event
   * @memberof Session
   * @see ConnectionEvent
   */ /**
   * A moderator has forced clients publishing streams to the session to mute audio (the
   * <code>active</code> property of this MuteForcedEvent object is set to <code>true</code>), or
   * a moderator has disabled the mute audio state in the session (the <code>active</code>
   * property of this MuteForcedEvent object is set to <code>false</code>).
   *
   * @name muteForced
   * @event
   * @memberof Session
   * @see MuteForcedEvent
   * @see <a href="Session.html#forceMuteAll">Session.forceMuteAll()</a>
   * @see <a href="Session.html#disableForceMute">Session.disableForceMute()</a>
   * @see <a href="https://tokbox.com/developer/guides/moderation/js/#force_mute">Muting the audio
   * of streams in a session</a>
   */ /**
   * The client has connected to an OpenTok session. This event is dispatched asynchronously
   * in response to a successful call to the <code>connect()</code> method of a Session
   * object. Before calling the <code>connect()</code> method, initialize the session by
   * calling the <code>OT.initSession()</code> method. For a code example and more details,
   * see <a href="#connect">Session.connect()</a>.
   * @name sessionConnected
   * @event
   * @memberof Session
   * @see SessionConnectEvent
   * @see <a href="#connect">Session.connect()</a>
   * @see <a href="OT.html#initSession">OT.initSession()</a>
   */ /**
   * The client has disconnected from the session. This event may be dispatched asynchronously
   * in response to a successful call to the <code>disconnect()</code> method of the Session object.
   * The event may also be disptached if a session connection is lost inadvertantly, as in the case
   * of a lost network connection.
   * <p>
   * The default behavior is that all Subscriber objects are unsubscribed and removed from the
   * HTML DOM. Each Subscriber object dispatches a <code>destroyed</code> event when the element is
   * removed from the HTML DOM. If you call the <code>preventDefault()</code> method in the event
   * listener for the <code>sessionDisconnect</code> event, the default behavior is prevented, and
   * you can, optionally, clean up Subscriber objects using your own code.
   * <p> The <code>reason</code> property of the event object indicates the reason for the client
   * being disconnected.
   * @name sessionDisconnected
   * @event
   * @memberof Session
   * @see <a href="#disconnect">Session.disconnect()</a>
   * @see <a href="#forceDisconnect">Session.forceDisconnect()</a>
   * @see SessionDisconnectEvent
   */ /**
   * The local client has lost its connection to an OpenTok session and is trying to reconnect.
   * This results from a loss in network connectivity. If the client can reconnect to the session,
   * the Session object dispatches a <code>sessionReconnected</code> event. Otherwise, if the client
   * cannot reconnect, the Session object dispatches a <code>sessionDisconnected</code> event.
   * <p>
   * In response to this event, you may want to provide a user interface notification, to let
   * the user know that the app is trying to reconnect to the session and that audio-video streams
   * are temporarily disconnected.
   *
   * @name sessionReconnecting
   * @event
   * @memberof Session
   * @see Event
   * @see <a href="#event:sessionReconnected">sessionReconnected event</a>
   * @see <a href="#event:sessionDisconnected">sessionDisconnected event</a>
   */ /**
   * The local client has reconnected to the OpenTok session after its connection was lost
   * temporarily. When the connection is lost, the Session object dispatches a
   * <code>sessionReconnecting</code> event, prior to the <code>sessionReconnected</code>
   * event. If the client cannot reconnect to the session, the Session object dispatches a
   * <code>sessionDisconnected</code> event instead of this event.
   * <p>
   * Any existing publishers and subscribers are automatically reconnected when client reconnects
   * and the Session object dispatches this event.
   * <p>
   * Any signals sent by other clients while your client was disconnected are received upon
   * reconnecting. By default, signals initiated by the local client while disconnected
   * (by calling the <code>Session.signal()</code> method) are sent when the client reconnects
   * to the OpenTok session. You can prevent this by setting the <code>retryAfterReconnect</code>
   * property to <code>false</code> in the <code>signal</code> object you pass into the
   * <a href="#signal">Session.signal()</a> method.
   *
   * @name sessionReconnected
   * @event
   * @memberof Session
   * @see Event
   * @see <a href="#event:sessionReconnecting">sessionReconnecting event</a>
   * @see <a href="#event:sessionDisconnected">sessionDisconnected event</a>
   */ /**
   * A new stream, published by another client, has been created on this session. For streams
   * published by your own client, the Publisher object dispatches a <code>streamCreated</code>
   * event. For a code example and more details, see {@link StreamEvent}.
   * @name streamCreated
   * @event
   * @memberof Session
   * @see StreamEvent
   * @see <a href="Session.html#publish">Session.publish()</a>
   */ /**
   * A stream from another client has stopped publishing to the session.
   * <p>
   * The default behavior is that all Subscriber objects that are subscribed to the stream are
   * unsubscribed and removed from the HTML DOM. Each Subscriber object dispatches a
   * <code>destroyed</code> event when the element is removed from the HTML DOM. If you call the
   * <code>preventDefault()</code> method in the event listener for the
   * <code>streamDestroyed</code> event, the default behavior is prevented and you can clean up
   * a Subscriber object for the stream by calling its <code>destroy()</code> method. See
   * <a href="Session.html#getSubscribersForStream">Session.getSubscribersForStream()</a>.
   * <p>
   * For streams published by your own client, the Publisher object dispatches a
   * <code>streamDestroyed</code> event.
   * <p>
   * For a code example and more details, see {@link StreamEvent}.
   * @name streamDestroyed
   * @event
   * @memberof Session
   * @see StreamEvent
   */ /**
   * Defines an event dispatched when property of a stream has changed. This can happen in
   * in the following conditions:
   * <p>
   * <ul>
   *   <li> A stream has started or stopped publishing audio or video (see
   *     <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a> and
   *     <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>). Note
   *     that a subscriber's video can be disabled or enabled for reasons other than
   *     the publisher disabling or enabling it. A Subscriber object dispatches
   *     <code>videoDisabled</code> and <code>videoEnabled</code> events in all
   *     conditions that cause the subscriber's stream to be disabled or enabled.
   *   </li>
   *   <li> The <code>videoDimensions</code> property of the Stream object has
   *     changed (see <a href="Stream.html#properties">Stream.videoDimensions</a>).
   *   </li>
   *   <li> The <code>videoType</code> property of the Stream object has changed.
   *     This can happen in a stream published by a mobile device. (See
   *     <a href="Stream.html#properties">Stream.videoType</a>.)
   *   </li>
   * </ul>
   *
   * @name streamPropertyChanged
   * @event
   * @memberof Session
   * @see StreamPropertyChangedEvent
   * @see <a href="Publisher.html#publishAudio">Publisher.publishAudio()</a>
   * @see <a href="Publisher.html#publishVideo">Publisher.publishVideo()</a>
   * @see <a href="Stream.html#hasAudio">Stream.hasAudio</a>
   * @see <a href="Stream.html#hasVideo">Stream.hasVideo</a>
   * @see <a href="Stream.html#videoDimensions">Stream.videoDimensions</a>
   * @see <a href="Subscriber.html#event:videoDisabled">Subscriber videoDisabled event</a>
   * @see <a href="Subscriber.html#event:videoEnabled">Subscriber videoEnabled event</a>
   */ /**
   * A signal was received from the session. The <a href="SignalEvent.html">SignalEvent</a>
   * class defines this event object. It includes the following properties:
   * <ul>
   *   <li><code>data</code> &mdash; (String) The data string sent with the signal (if there
   *       is one).</li>
   *   <li><code>from</code> &mdash; (<a href="Connection.html">Connection</a>) The Connection
   *       corresponding to the client that sent the signal.</li>
   *   <li><code>type</code> &mdash; (String) The type assigned to the signal (if there is
   *       one).</li>
   * </ul>
   * <p>
   * You can register to receive all signals sent in the session, by adding an event handler
   * for the <code>signal</code> event. For example, the following code adds an event handler
   * to process all signals sent in the session:
   * <pre>
   * session.on("signal", function(event) {
   *   console.log("Signal sent from connection: " + event.from.id);
   *   console.log("Signal data: " + event.data);
   * });
   * </pre>
   * <p>You can register for signals of a specfied type by adding an event handler for the
   * <code>signal:type</code> event (replacing <code>type</code> with the actual type string
   * to filter on).
   *
   * @name signal
   * @event
   * @memberof Session
   * @see <a href="Session.html#signal">Session.signal()</a>
   * @see SignalEvent
   * @see <a href="#event:signal:type">signal:type</a> event
   */ /**
   * A signal of the specified type was received from the session. The
   * <a href="SignalEvent.html">SignalEvent</a> class defines this event object.
   * It includes the following properties:
   * <ul>
   *   <li><code>data</code> &mdash; (String) The data string sent with the signal.</li>
   *   <li><code>from</code> &mdash; (<a href="Connection.html">Connection</a>) The Connection
   *   corresponding to the client that sent the signal.</li>
   *   <li><code>type</code> &mdash; (String) The type assigned to the signal (if there is one).
   *   </li>
   * </ul>
   * <p>
   * You can register for signals of a specfied type by adding an event handler for the
   * <code>signal:type</code> event (replacing <code>type</code> with the actual type string
   * to filter on). For example, the following code adds an event handler for signals of
   * type "foo":
   * <pre>
   * session.on("signal:foo", function(event) {
   *   console.log("foo signal sent from connection " + event.from.id);
   *   console.log("Signal data: " + event.data);
   * });
   * </pre>
   * <p>
   * You can register to receive <i>all</i> signals sent in the session, by adding an event
   * handler for the <code>signal</code> event.
   *
   * @name signal:type
   * @event
   * @memberof Session
   * @see <a href="Session.html#signal">Session.signal()</a>
   * @see SignalEvent
   * @see <a href="#event:signal">signal</a> event
   */ return Session;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 316 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ExceptionCodes = __webpack_require__(10);
            const OTErrorClass = __webpack_require__(22);
            const knownErrorCodes = [
                400,
                403,
                409,
                ExceptionCodes.CONNECTION_LIMIT_EXCEEDED
            ];
            const reasons = {
                CONNECT: 'ConnectToSession',
                SESSION_STATE: 'GetSessionState'
            };
            /*
 * Converts an error from RumorSocket to use generic exception codes
 * @param {Error} error - Error object with reason property
 * @return {Object} The converted error code and message
 * @property {number} code
 * @property {string} message
 */ module1.exports = function convertRumorError(error) {
                let code;
                let message;
                if (error.reason === reasons.CONNECT && error.code === ExceptionCodes.CONNECT_FAILED) {
                    code = error.code;
                    message = OTErrorClass.getTitleByCode(error.code);
                } else if (error.code && knownErrorCodes.indexOf(Number(error.code)) > -1) {
                    code = ExceptionCodes.CONNECT_FAILED;
                    switch(error.reason){
                        case reasons.CONNECT:
                            switch(error.code){
                                case ExceptionCodes.CONNECTION_LIMIT_EXCEEDED:
                                    code = error.code;
                                    message = "Cannot connect -- the limit for concurrent connections to the session has been reached";
                                    break;
                                default:
                                    message = 'Received error response to connection create message.';
                                    break;
                            }
                            break;
                        case reasons.SESSION_STATE:
                            message = 'Received error response to session read';
                            break;
                        default:
                            message = '';
                            break;
                    }
                } else {
                    code = ExceptionCodes.UNEXPECTED_SERVER_RESPONSE;
                    message = 'Unexpected server response. Try this operation again later.';
                }
                return {
                    code: code,
                    message: message
                };
            };
        /***/ },
        /* 317 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const hasOpenTokSupport = __webpack_require__(52).once;
            module1.exports = ()=>hasOpenTokSupport() && (env.isChromiumEdge || [
                    'Chrome',
                    'Safari',
                    'Firefox',
                    'Opera'
                ].includes(env.name));
        /***/ },
        /* 318 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function serializeMessage(message) {
                return JSON.stringify(message);
            };
        /***/ },
        /* 319 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.default = void 0;
            var _default = (_ref)=>{
                let logger = _ref.logger, obj = _ref.obj, eventNames = _ref.eventNames;
                eventNames.forEach((eventName)=>{
                    obj.on(eventName, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return logger.spam('emitted', eventName, args);
                    });
                });
            };
            exports.default = _default;
        /***/ },
        /* 320 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable prefer-rest-params */ const isFunction = __webpack_require__(17);
            const OTErrorClass = __webpack_require__(22);
            const eventing = __webpack_require__(7);
            const logging = __webpack_require__(2)('Dispatcher');
            const RumorMessageTypes = __webpack_require__(172);
            const unboxFromRumorMessage = __webpack_require__(729);
            const Dispatcher = function Dispatcher() {
                eventing(this);
                this.callbacks = {};
            };
            module1.exports = Dispatcher;
            Dispatcher.prototype.registerCallback = function(transactionId, completion) {
                this.callbacks[transactionId] = completion;
            };
            Dispatcher.prototype.triggerCallback = function(transactionId) {
                /* , arg1, arg2, argN-1, argN */ if (!transactionId) return;
                const completion = this.callbacks[transactionId];
                if (completion && isFunction(completion)) {
                    const args = Array.prototype.slice.call(arguments);
                    args.shift();
                    completion(...args);
                }
                delete this.callbacks[transactionId];
            };
            Dispatcher.prototype.onClose = function(reason) {
                this.emit('close', reason);
            };
            Dispatcher.prototype.onReconnected = function() {
                this.emit('reconnected');
            };
            Dispatcher.prototype.onReconnecting = function() {
                this.emit('reconnecting');
            };
            Dispatcher.prototype.dispatch = function(rumorMessage) {
                // The special casing of STATUS messages is ugly. Need to think about
                // how to better integrate this.
                if (rumorMessage.type === RumorMessageTypes.STATUS) {
                    var _data$mute;
                    logging.debug(rumorMessage);
                    let error;
                    if (rumorMessage.isError) {
                        let message;
                        if (typeof rumorMessage.data === 'string') try {
                            const data = JSON.parse(rumorMessage.data);
                            if (data && typeof data === 'object') message = data.reason;
                        } catch (e) {
                            logging.warn('Failed to parse rumorMessage.data', e);
                        }
                        error = new OTErrorClass(rumorMessage.status, message);
                    }
                    const data = rumorMessage.data ? JSON.parse(rumorMessage.data) : '';
                    if (data == null ? void 0 : (_data$mute = data.mute) == null ? void 0 : _data$mute.active) this.dispatchMuteOnEntry();
                    this.triggerCallback(rumorMessage.transactionId, error, rumorMessage);
                    return;
                }
                const message = unboxFromRumorMessage(rumorMessage);
                logging.debug(`${message.signature}:`, message);
                switch(message.resource){
                    case 'session':
                        this.dispatchSession(message);
                        break;
                    case 'connection':
                        this.dispatchConnection(message);
                        break;
                    case 'stream':
                        this.dispatchStream(message);
                        break;
                    case 'stream_channel':
                        this.dispatchStreamChannel(message);
                        break;
                    case 'subscriber':
                        this.dispatchSubscriber(message);
                        break;
                    case 'subscriber_channel':
                        this.dispatchSubscriberChannel(message);
                        break;
                    case 'signal':
                        this.dispatchSignal(message);
                        break;
                    // Data may at some point in the future be used for non caption purposes
                    case 'data':
                        this.dispatchCaption(message);
                        break;
                    case 'archive':
                        this.dispatchArchive(message);
                        break;
                    case 'source':
                        this.dispatchSource(message);
                        break;
                    default:
                        logging.debug(`Type ${message.resource} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchSession = function(message) {
                switch(message.method){
                    case 'read':
                        this.emit('session#read', message.content, message.transactionId);
                        break;
                    case 'update':
                        this.emit('session#update', message.content);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchMuteOnEntry = function() {
                this.emit('session#muted');
            };
            Dispatcher.prototype.dispatchConnection = function(message) {
                switch(message.method){
                    case 'created':
                        this.emit('connection#created', message.content);
                        break;
                    case 'deleted':
                        this.emit('connection#deleted', message.params.connection, message.reason);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchStream = function(message) {
                switch(message.method){
                    case 'created':
                        this.emit('stream#created', message.content, message.transactionId);
                        break;
                    case 'deleted':
                        this.emit('stream#deleted', message.params.stream, message.reason, message.content);
                        break;
                    case 'updated':
                        this.emit('stream#updated', message.params.stream, message.content);
                        break;
                    case 'update':
                        this.emit('stream#update', message.params.stream, message.content);
                        break;
                    // The JSEP process
                    case 'generateoffer':
                    case 'answer':
                    case 'pranswer':
                    case 'offer':
                    case 'candidate':
                        this.dispatchJsep(message.method, message);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchStreamChannel = function(message) {
                switch(message.method){
                    case 'updated':
                        this.emit('streamChannel#updated', message.params.stream, message.params.channel, message.content);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            }; // Dispatch JSEP messages
            //
            // generateoffer:
            // Request to generate a offer for another Peer (or Prism). This kicks
            // off the JSEP process.
            //
            // answer:
            // generate a response to another peers offer, this contains our constraints
            // and requirements.
            //
            // pranswer:
            // a provisional answer, i.e. not the final one.
            //
            // candidate
            //
            //
            Dispatcher.prototype.dispatchJsep = function(method, message) {
                this.emit(`jsep#${method}`, message.params.stream, message.fromAddress, message);
            };
            Dispatcher.prototype.dispatchSubscriberChannel = function(message) {
                switch(message.method){
                    case 'updated':
                        this.emit('subscriberChannel#updated', message.params.stream, message.params.channel, message.content);
                        break;
                    case 'update':
                        // subscriberId, streamId, content
                        this.emit('subscriberChannel#update', message.params.subscriber, message.params.stream, message.content);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchSubscriber = function(message) {
                switch(message.method){
                    case 'created':
                        this.emit('subscriber#created', message.params.stream, message.fromAddress, message.content.id);
                        break;
                    case 'deleted':
                        this.dispatchJsep('unsubscribe', message);
                        this.emit('subscriber#deleted', message.params.stream, message.fromAddress);
                        break;
                    // The JSEP process
                    case 'generateoffer':
                    case 'answer':
                    case 'pranswer':
                    case 'offer':
                    case 'candidate':
                        this.dispatchJsep(message.method, message);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
            Dispatcher.prototype.dispatchSignal = function(message) {
                if (message.method !== 'signal') {
                    logging.debug(`${message.signature} is not currently implemented`);
                    return;
                }
                this.emit('signal', message.fromAddress, message.content);
            };
            Dispatcher.prototype.dispatchCaption = function(message) {
                this.emit('caption', message.fromAddress, message.content);
            };
            Dispatcher.prototype.dispatchArchive = function(message) {
                switch(message.method){
                    case 'created':
                        this.emit('archive#created', message.content);
                        break;
                    case 'updated':
                        this.emit('archive#updated', message.params.archive, message.content);
                        break;
                    default:
                }
            };
            Dispatcher.prototype.dispatchSource = function(message) {
                switch(message.method){
                    case 'create':
                        this.emit('source#create', message.params.source, message.params.stream, message.reason);
                        break;
                    case 'delete':
                        this.emit('source#delete', message.params.source, message.params.stream, message.reason);
                        break;
                    default:
                        logging.debug(`${message.signature} is not currently implemented`);
                }
            };
        /***/ },
        /* 321 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-void */ const uuid = __webpack_require__(16);
            const OTHelpers = __webpack_require__(8);
            const hasBundleCapability = __webpack_require__(732);
            const hasRTCPMuxCapability = __webpack_require__(733);
            const serializeMessage = __webpack_require__(318);
            const supportedCryptoScheme = __webpack_require__(734);
            const staticConfig = __webpack_require__(35)().onlyLocal();
            const Message = {};
            module1.exports = Message;
            Message.connections = {};
            Message.connections.create = function(opt) {
                const apiKey = opt.apiKey;
                const sessionId = opt.sessionId;
                const connectionId = opt.connectionId;
                const connectionEventsSuppressed = opt.connectionEventsSuppressed;
                const capabilities = opt.capabilities;
                return serializeMessage({
                    method: 'create',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/connection/${connectionId}`,
                    content: {
                        userAgent: OTHelpers.env.userAgent,
                        clientVersion: staticConfig.clientVersion,
                        capabilities: capabilities || [],
                        connectionEventsSuppressed: connectionEventsSuppressed
                    }
                });
            };
            Message.connections.destroy = function(opt) {
                const apiKey = opt.apiKey;
                const sessionId = opt.sessionId;
                const connectionId = opt.connectionId;
                return serializeMessage({
                    method: 'delete',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/connection/${connectionId}`,
                    content: {}
                });
            };
            Message.sessions = {};
            Message.sessions.get = function(apiKey, sessionId) {
                return serializeMessage({
                    method: 'read',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}`,
                    content: {}
                });
            };
            Message.streams = {};
            Message.streams.get = function(apiKey, sessionId, streamId) {
                return serializeMessage({
                    method: 'read',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
                    content: {}
                });
            };
            Message.streams.channelFromOTChannel = function(channel) {
                const raptorChannel = {
                    id: channel.id,
                    type: channel.type,
                    active: channel.active
                };
                if (channel.type === 'video') {
                    raptorChannel.width = channel.width;
                    raptorChannel.height = channel.height;
                    raptorChannel.orientation = channel.orientation;
                    raptorChannel.frameRate = channel.frameRate;
                    if (channel.source !== 'default') raptorChannel.source = channel.source;
                    raptorChannel.fitMode = channel.fitMode;
                }
                return raptorChannel;
            };
            Message.streams.create = function(opt) {
                if (opt === void 0) opt = {};
                const _opt = opt, apiKey = _opt.apiKey, sessionId = _opt.sessionId, streamId = _opt.streamId, name = _opt.name, audioFallbackEnabled = _opt.audioFallbackEnabled, channels = _opt.channels, minBitrate = _opt.minBitrate, maxBitrate = _opt.maxBitrate, sourceStreamId = _opt.sourceStreamId, e2ee = _opt.e2ee;
                const messageContent = {
                    id: streamId,
                    name: name,
                    audioFallbackEnabled: audioFallbackEnabled,
                    channel: channels.map((channel)=>Message.streams.channelFromOTChannel(channel)),
                    e2ee: e2ee
                };
                if (minBitrate) messageContent.minBitrate = Math.round(minBitrate);
                if (maxBitrate) messageContent.maxBitrate = Math.round(maxBitrate);
                if (sourceStreamId) messageContent.sourceStreamId = sourceStreamId;
                if (typeof e2ee === 'boolean') messageContent.e2ee = e2ee;
                return serializeMessage({
                    method: 'create',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
                    content: messageContent
                });
            };
            Message.streams.destroy = function(apiKey, sessionId, streamId, sourceStreamId) {
                const messageContent = {};
                if (sourceStreamId) messageContent.sourceStreamId = sourceStreamId;
                return serializeMessage({
                    method: 'delete',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}`,
                    content: messageContent
                });
            };
            Message.streamChannels = {};
            Message.streamChannels.update = function(apiKey, sessionId, streamId, channelId, attributes) {
                return serializeMessage({
                    method: 'update',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/channel/${channelId}`,
                    content: attributes
                });
            };
            Message.subscribers = {};
            Message.subscribers.create = function(opt) {
                if (opt === void 0) opt = {};
                const _opt2 = opt, apiKey = _opt2.apiKey, sessionId = _opt2.sessionId, streamId = _opt2.streamId, subscriberId = _opt2.subscriberId, connectionId = _opt2.connectionId, channelsToSubscribeTo = _opt2.channelsToSubscribeTo, sourceStreamId = _opt2.sourceStreamId, e2ee = _opt2.e2ee;
                const content = {
                    id: subscriberId,
                    connection: connectionId,
                    keyManagementMethod: supportedCryptoScheme,
                    bundleSupport: hasBundleCapability(),
                    rtcpMuxSupport: hasRTCPMuxCapability(),
                    e2ee: e2ee
                };
                if (channelsToSubscribeTo) content.channel = channelsToSubscribeTo;
                if (sourceStreamId) content.sourceStreamId = sourceStreamId;
                return serializeMessage({
                    method: 'create',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
                    content: content
                });
            };
            Message.subscribers.destroy = function(apiKey, sessionId, streamId, subscriberId) {
                return serializeMessage({
                    method: 'delete',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
                    content: {}
                });
            };
            Message.subscribers.update = function(apiKey, sessionId, streamId, subscriberId, attributes) {
                return serializeMessage({
                    method: 'update',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}`,
                    content: attributes
                });
            };
            Message.subscriberChannels = {};
            Message.subscriberChannels.update = function(apiKey, sessionId, streamId, subscriberId, channelId, attributes) {
                return serializeMessage({
                    method: 'update',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}/stream/${streamId}/subscriber/${subscriberId}/channel/${channelId}`,
                    content: attributes
                });
            };
            Message.signals = {};
            Message.signals.create = function(apiKey, sessionId, toAddress, type, data) {
                const content = {};
                if (type !== void 0) content.type = type;
                if (data !== void 0) content.data = data;
                return serializeMessage({
                    method: 'signal',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}${toAddress !== void 0 ? `/connection/${toAddress}` : ''}/signal/${uuid()}`,
                    content: content
                });
            };
            Message.forceMute = {};
            Message.forceMute.update = (options)=>{
                const apiKey = options.apiKey, sessionId = options.sessionId, streamId = options.streamId, active = options.active, excludedStreamIds = options.excludedStreamIds;
                const content = {
                    reason: 'mute',
                    channels: [
                        'audio'
                    ],
                    active: active,
                    locked: false
                };
                if (excludedStreamIds) content.exclusion = excludedStreamIds;
                return serializeMessage({
                    method: 'update',
                    uri: `/v2/partner/${apiKey}/session/${sessionId}${streamId ? `/stream/${streamId}` : ''}`,
                    content: content
                });
            };
        /***/ },
        /* 322 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-useless-escape, no-underscore-dangle, no-void, no-prototype-builtins */ const clone = __webpack_require__(38);
            const APIKEY = __webpack_require__(72);
            const Connection = __webpack_require__(173);
            const RaptorMessage = __webpack_require__(321);
            const sessionTag = __webpack_require__(323);
            const MAX_SIGNAL_DATA_LENGTH = 8192;
            const MAX_SIGNAL_TYPE_LENGTH = 128; //
            // Error Codes:
            // 413 - Type too long
            // 400 - Type is invalid
            // 413 - Data too long
            // 400 - Data is invalid (can't be parsed as JSON)
            // 429 - Rate limit exceeded
            // 500 - Websocket connection is down
            // 404 - To connection does not exist
            // 400 - To is invalid
            //
            module1.exports = function Signal(sessionId, fromConnectionId, options) {
                const isInvalidType = function isInvalidType(type) {
                    // Our format matches the unreserved characters from the URI RFC:
                    // http://www.ietf.org/rfc/rfc3986
                    return !/^[a-zA-Z0-9\-\._~]+$/.exec(type);
                };
                const validateTo = function validateTo(toAddress) {
                    if (!toAddress) return {
                        code: 400,
                        reason: "The signal to field was invalid. Either set it to a OT.Connection, OT.Session, or omit it entirely"
                    };
                    if (!(toAddress instanceof Connection || toAddress._tag === sessionTag)) return {
                        code: 400,
                        reason: 'The To field was invalid'
                    };
                    return null;
                };
                const validateType = function validateType(type) {
                    let error = null;
                    if (type === null || type === void 0) error = {
                        code: 400,
                        reason: "The signal type was null or undefined. Either set it to a String value or omit it"
                    };
                    else if (type.length > MAX_SIGNAL_TYPE_LENGTH) error = {
                        code: 413,
                        reason: `The signal type was too long, the maximum length of it is ${MAX_SIGNAL_TYPE_LENGTH} characters`
                    };
                    else if (isInvalidType(type)) error = {
                        code: 400,
                        reason: "The signal type was invalid, it can only contain letters, numbers, '-', '_', and '~'."
                    };
                    return error;
                };
                const validateData = function validateData(data) {
                    let error = null;
                    if (data === null || data === void 0) error = {
                        code: 400,
                        reason: "The signal data was null or undefined. Either set it to a String value or omit it"
                    };
                    else try {
                        if (JSON.stringify(data).length > MAX_SIGNAL_DATA_LENGTH) error = {
                            code: 413,
                            reason: `The data field was too long, the maximum size of it is ${MAX_SIGNAL_DATA_LENGTH} characters`
                        };
                    } catch (e) {
                        error = {
                            code: 400,
                            reason: 'The data field was not valid JSON'
                        };
                    }
                    return error;
                };
                const validateRetryAfterReconnect = function validateRetryAfterReconnect(retryAfterReconnect) {
                    let error = null;
                    if (!(retryAfterReconnect === true || retryAfterReconnect === false)) error = {
                        code: 400,
                        reason: "The signal retryAfterReconnect was not true or false. Either set it to a Boolean value or omit it"
                    };
                    return error;
                };
                this.toRaptorMessage = function() {
                    let to = this.to;
                    if (to && typeof to !== 'string') to = to.id;
                    return RaptorMessage.signals.create(APIKEY.value, sessionId, to, this.type, this.data);
                };
                this.toHash = function() {
                    return options;
                };
                this.error = null;
                this.retryAfterReconnect = true;
                if (options) {
                    if (options.hasOwnProperty('data')) {
                        this.data = clone(options.data);
                        this.error = validateData(this.data);
                    }
                    if (options.hasOwnProperty('to')) {
                        this.to = options.to;
                        if (!this.error) this.error = validateTo(this.to);
                    }
                    if (options.hasOwnProperty('type')) {
                        if (!this.error) this.error = validateType(options.type);
                        this.type = options.type;
                    }
                    if (options.hasOwnProperty('retryAfterReconnect')) {
                        if (!this.error) this.error = validateRetryAfterReconnect(options.retryAfterReconnect);
                        this.retryAfterReconnect = options.retryAfterReconnect;
                    }
                }
                this.valid = this.error === null;
            };
        /***/ },
        /* 323 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // This is used to break the dependency Raptor had on Session. It only needs to be able to know
            // whether an object is an instanceof a Session. The dependency was an issue for node because
            // Session depends on get_user_media.js which doesn't work in node.
            module1.exports = {};
        /***/ },
        /* 324 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-shadow, prefer-rest-params, prefer-spread, no-param-reassign */ /* eslint-disable no-mixed-operators, no-cond-assign, one-var */ const Archive = __webpack_require__(325);
            const now = __webpack_require__(50);
            const Connection = __webpack_require__(173);
            const DelayedEventQueue = __webpack_require__(737);
            const Dispatcher = __webpack_require__(320);
            const logging = __webpack_require__(2)('SessionDispatcher');
            const sessionObjects = __webpack_require__(21);
            const Stream = __webpack_require__(171);
            const StreamChannel = __webpack_require__(149);
            const getMediaModeBySourceStreamId = __webpack_require__(167);
            function constructBareConnection(fromAddress) {
                return {
                    id: fromAddress,
                    creationTime: new Date().getTime(),
                    data: {},
                    capablities: {},
                    permissions: []
                };
            }
            function parseStream(dict, session) {
                const channel = dict.channel.map((channel)=>new StreamChannel(channel));
                const connectionId = dict.connectionId ? dict.connectionId : dict.connection.id;
                return new Stream(dict.id, dict.name, dict.creationTime, session.connections.get(connectionId), session, channel);
            }
            function parseAndAddStreamToSession(streamParams, session) {
                if (session.streams.has(streamParams.id)) return undefined;
                const stream = parseStream(streamParams, session);
                session.streams.add(stream);
                return stream;
            }
            function parseArchive(archiveParams) {
                return new Archive(archiveParams.id, archiveParams.name, archiveParams.status);
            }
            function parseAndAddArchiveToSession(archiveParams, session) {
                if (session.archives.has(archiveParams.id)) return undefined;
                const archive = parseArchive(archiveParams);
                session.archives.add(archive);
                return archive;
            }
            const DelayedSessionEvents = function DelayedSessionEvents(dispatcher) {
                const eventQueues = {};
                this.enqueue = function enqueue() /* key, arg1, arg2, ..., argN */ {
                    const key = arguments[0];
                    const eventArgs = Array.prototype.slice.call(arguments, 1);
                    if (!eventQueues[key]) eventQueues[key] = new DelayedEventQueue(dispatcher);
                    eventQueues[key].enqueue.apply(eventQueues[key], eventArgs);
                };
                this.triggerConnectionCreated = function triggerConnectionCreated(connection) {
                    if (eventQueues[`connectionCreated${connection.id}`]) eventQueues[`connectionCreated${connection.id}`].triggerAll();
                };
                this.triggerSessionConnected = function triggerSessionConnected(connections) {
                    if (eventQueues.sessionConnected) eventQueues.sessionConnected.triggerAll();
                    connections.forEach(function(connection) {
                        this.triggerConnectionCreated(connection);
                    }, this);
                };
            };
            const unconnectedStreams = {};
            module1.exports = function SessionDispatcher(session, _temp) {
                let _ref = _temp === void 0 ? {} : _temp, connectionEventsSuppressed = _ref.connectionEventsSuppressed;
                const dispatcher = new Dispatcher();
                let sessionStateReceived = false;
                const delayedSessionEvents = new DelayedSessionEvents(dispatcher);
                dispatcher.on('reconnecting', ()=>{
                    session._.reconnecting();
                });
                dispatcher.on('reconnected', ()=>{
                    session._.reconnected();
                });
                dispatcher.on('close', (reason)=>{
                    const connection = session.connection;
                    if (!connection) return;
                    if (connection.destroyedReason()) {
                        logging.debug(`${"Socket was closed but the connection had already been destroyed. Reason: "}${connection.destroyedReason()}`);
                        return;
                    }
                    connection.destroy(reason);
                }); // This method adds connections to the session both on a connection#created and
                // on a session#read. In the case of session#read sessionRead is set to true and
                // we include our own connection.
                const addConnection = function addConnection(connection, sessionRead) {
                    if (session.connections.has(connection.id)) // Don't add a duplicate connection, since we add them not only on connection#created, but
                    // also when stream#created or signal has an associated connection.
                    return session.connections.get(connection.id);
                    connection = Connection.fromHash(connection);
                    if (sessionRead || session.connection && connection.id !== session.connection.id) {
                        session.connections.add(connection);
                        delayedSessionEvents.triggerConnectionCreated(connection);
                    }
                    Object.keys(unconnectedStreams).forEach((streamId)=>{
                        const stream = unconnectedStreams[streamId];
                        if (stream && connection.id === stream.connection.id) {
                            // dispatch streamCreated event now that the connectionCreated has been dispatched
                            parseAndAddStreamToSession(stream, session);
                            delete unconnectedStreams[stream.id];
                            const payload = {
                                debug: sessionRead ? 'connection came in session#read' : 'connection came in connection#created',
                                streamId: stream.id,
                                connectionId: connection.id
                            };
                            session.logEvent('streamCreated', 'warning', payload);
                        }
                    });
                    return connection;
                };
                dispatcher.on('session#read', (content, transactionId)=>{
                    let connection;
                    const state = {};
                    state.streams = [];
                    state.connections = [];
                    state.archives = [];
                    content.connection.forEach((connectionParams)=>{
                        connection = addConnection(connectionParams, true);
                        state.connections.push(connection);
                    });
                    content.stream.forEach((streamParams)=>{
                        state.streams.push(parseAndAddStreamToSession(streamParams, session));
                    });
                    (content.archive || content.archives).forEach((archiveParams)=>{
                        state.archives.push(parseAndAddArchiveToSession(archiveParams, session));
                    });
                    dispatcher.triggerCallback(transactionId, null, state);
                    sessionStateReceived = true;
                    delayedSessionEvents.triggerSessionConnected(session.connections);
                });
                dispatcher.on('session#update', (content)=>{
                    if (content.reason !== 'mute') {
                        logging.debug('session#update that handle this reason is not currently implemented');
                        return;
                    }
                    const active = content.active === true;
                    session._.forceMute({
                        active: active
                    });
                    if (active) session._.enableMuteOnEntry();
                    else session._.disableMuteOnEntry();
                });
                dispatcher.on('session#muted', ()=>{
                    session._.enableMuteOnEntry();
                    session._.forceMute({
                        active: true
                    });
                });
                dispatcher.on('connection#created', (connection)=>{
                    addConnection(connection);
                });
                dispatcher.on('connection#deleted', (connection, reason)=>{
                    connection = session.connections.get(connection);
                    if (!connection) {
                        logging.warn('A connection was deleted that we do not know about');
                        return;
                    }
                    connection.destroy(reason);
                });
                dispatcher.on('stream#created', (content, transactionId)=>{
                    const streamId = content.id, sourceStreamId = content.sourceStreamId, connection = content.connection;
                    let stream;
                    if (connectionEventsSuppressed) {
                        if (connection == null || connection.id == null) {
                            session.logEvent('SessionDispatcher:stream#created', 'Event', {
                                connection: connection,
                                info: 'Stream did not contain a connection object. Event ignored'
                            });
                            return;
                        }
                        addConnection(connection);
                    }
                    const connectionId = content.connectionId || connection.id;
                    if (session.connections.has(connectionId)) stream = parseAndAddStreamToSession(content, session);
                    else {
                        unconnectedStreams[streamId] = content;
                        const payload = {
                            debug: 'eventOrderError -- streamCreated event before connectionCreated',
                            streamId: streamId,
                            sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId)
                        };
                        session.logEvent('streamCreated', 'warning', payload);
                    }
                    if (stream) {
                        if (stream.publisher) stream.publisher.setStream(stream);
                        dispatcher.triggerCallback(transactionId, null, stream);
                    } else if (session.sessionInfo.isAdaptiveEnabled && sourceStreamId === 'P2P') // A P2P stream was created in an adaptive session, so let's request a new subscriber for it
                    sessionObjects.subscribers.where({
                        streamId: streamId
                    }).forEach((subscriber)=>{
                        subscriber._.startRoutedToRelayedTransition();
                    });
                });
                dispatcher.on('stream#deleted', (streamId, reason, content)=>{
                    const stream = session.streams.get(streamId);
                    const sourceStreamId = content.sourceStreamId;
                    const subscribers = sessionObjects.subscribers;
                    const isAdaptiveEnabled = session.sessionInfo.isAdaptiveEnabled;
                    const isAdaptiveP2pStream = isAdaptiveEnabled && sourceStreamId === 'P2P';
                    if (!stream && !isAdaptiveP2pStream) // Stream has been previously deleted
                    return;
                    if (isAdaptiveP2pStream) // In adaptive sessions, when the P2P stream is destroyed we need to start the transition
                    // from relayed to routed.
                    subscribers.where({
                        streamId: streamId
                    }).forEach((subscriber)=>{
                        subscriber._.startRelayedToRoutedTransition();
                    });
                    else stream.destroy(reason);
                });
                dispatcher.on('stream#updated', (streamId, content)=>{
                    const stream = session.streams.get(streamId);
                    if (!stream) {
                        logging.error(`A stream does not exist with the id of ${streamId}, for stream#updated message!`); // @todo error
                        return;
                    }
                    stream._.update(content);
                });
                dispatcher.on('stream#update', (streamId, content)=>{
                    const stream = session.streams.get(streamId);
                    const reason = content.reason, active = content.active;
                    if (!stream) {
                        logging.error(`A stream does not exist with the id of ${streamId}, for stream#updated message!`); // @todo error
                        return;
                    }
                    if (reason !== 'mute') {
                        logging.debug('stream#update that handle this reason is not currently implemented');
                        return;
                    }
                    if (active) stream._.forceMute(content);
                });
                dispatcher.on('streamChannel#updated', (streamId, channelId, content)=>{
                    let stream;
                    if (!(streamId && (stream = session.streams.get(streamId)))) {
                        logging.error("Unable to determine streamId, or the stream does not exist, for streamChannel message!"); // @todo error
                        return;
                    }
                    stream._.updateChannel(channelId, content);
                }); // Dispatch JSEP messages
                //
                // generateoffer:
                // Request to generate a offer for another Peer (or Prism). This kicks
                // off the JSEP process.
                //
                // answer:
                // generate a response to another peers offer, this contains our constraints
                // and requirements.
                //
                // pranswer:
                // a provisional answer, i.e. not the final one.
                //
                // candidate
                //
                //
                const jsepHandler = (method, streamId, fromAddress, message)=>{
                    let subscriberFilter;
                    let actors;
                    const hasStreamId = {
                        streamId: streamId
                    };
                    const subscribers = sessionObjects.subscribers;
                    const publishers = sessionObjects.publishers;
                    if (message.params.subscriber) subscriberFilter = {
                        widgetId: message.params.subscriber
                    };
                    else // if we don't know the subscriber, we will just match the stream id
                    subscriberFilter = hasStreamId;
                     // Determine which subscriber/publisher objects should receive this message.
                    switch(method){
                        case 'offer':
                            actors = [].concat(subscribers.where(subscriberFilter), publishers.where(hasStreamId)).slice(0, 1);
                            break;
                        case 'answer':
                        case 'pranswer':
                            actors = [].concat(publishers.where(hasStreamId), subscribers.where(subscriberFilter)).slice(0, 1);
                            break;
                        case 'generateoffer':
                        case 'unsubscribe':
                            actors = publishers.where(hasStreamId);
                            break;
                        case 'candidate':
                            actors = [].concat(subscribers.where(subscriberFilter), publishers.where(hasStreamId));
                            break;
                        default:
                            logging.debug(`jsep#${method} is not currently implemented`);
                            return;
                    }
                    if (actors.length === 0) return;
                    let fromConnection = session.connections.get(fromAddress);
                    if (!fromConnection && fromAddress.match(/^symphony\./)) {
                        fromConnection = Connection.fromHash({
                            id: fromAddress,
                            creationTime: Math.floor(now())
                        });
                        session.connections.add(fromConnection);
                    }
                    actors.forEach(/*#__PURE__*/ function() {
                        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(actor) {
                            return _regenerator.default.wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.prev = 0;
                                        _context.next = 3;
                                        return actor.processMessage(method, fromAddress, message);
                                    case 3:
                                        _context.next = 8;
                                        break;
                                    case 5:
                                        _context.prev = 5;
                                        _context.t0 = _context["catch"](0);
                                        logging.error('Error occurred during processMessage', _context.t0);
                                    case 8:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    5
                                ]
                            ]);
                        }));
                        return function(_x) {
                            return _ref2.apply(this, arguments);
                        };
                    }());
                };
                dispatcher.on('jsep#offer', jsepHandler.bind(null, 'offer'));
                dispatcher.on('jsep#answer', jsepHandler.bind(null, 'answer'));
                dispatcher.on('jsep#pranswer', jsepHandler.bind(null, 'pranswer'));
                dispatcher.on('jsep#generateoffer', jsepHandler.bind(null, 'generateoffer'));
                dispatcher.on('jsep#unsubscribe', jsepHandler.bind(null, 'unsubscribe'));
                dispatcher.on('jsep#candidate', jsepHandler.bind(null, 'candidate'));
                dispatcher.on('subscriberChannel#updated', (streamId, channelId, content)=>{
                    if (!streamId || !session.streams.has(streamId)) {
                        logging.error("Unable to determine streamId, or the stream does not exist, for subscriberChannel#updated message!"); // @todo error
                        return;
                    }
                    session.streams.get(streamId)._.updateChannel(channelId, content);
                });
                dispatcher.on('subscriberChannel#update', (subscriberId, streamId, content)=>{
                    if (!streamId || !session.streams.has(streamId)) {
                        logging.error("Unable to determine streamId, or the stream does not exist, for subscriberChannel#update message!"); // @todo error
                        return;
                    } // Hint to update for congestion control from the Media Server
                    if (!sessionObjects.subscribers.has(subscriberId)) {
                        logging.error("Unable to determine subscriberId, or the subscriber does not exist, for subscriberChannel#update message!"); // @todo error
                        return;
                    } // We assume that an update on a Subscriber channel is to disableVideo
                    // we may need to be more specific in the future
                    sessionObjects.subscribers.get(subscriberId).disableVideo(content.active);
                }); // Note: subscriber#created and subscriber#deleted messages are available but we currently
                // don't have a use for them.
                dispatcher.on('signal', (fromAddress, content)=>{
                    if (connectionEventsSuppressed) {
                        let connection = content.connection || content.fromConnection;
                        if (connection == null || connection.id == null) {
                            connection = constructBareConnection(fromAddress);
                            session.logEvent('SessionDispatcher:Signal', 'Event', {
                                fromAddress: fromAddress,
                                connection: content.connection,
                                fromConnection: content.fromConnection,
                                info: 'Signal did not contain a connection object. One has been constructed',
                                constructedConnection: connection
                            });
                        }
                        addConnection(connection);
                    }
                    const signalType = content.type;
                    const data = content.data;
                    const fromConnection = session.connections.get(fromAddress);
                    if (session.connection && fromAddress === session.connection.connectionId) {
                        if (sessionStateReceived) session._.dispatchSignal(fromConnection, signalType, data);
                        else delayedSessionEvents.enqueue('sessionConnected', 'signal', fromAddress, signalType, data);
                    } else if (session.connections.get(fromAddress)) session._.dispatchSignal(fromConnection, signalType, data);
                    else if (fromAddress === '') // Server originated signal
                    session._.dispatchSignal(null, signalType, data);
                    else delayedSessionEvents.enqueue(`connectionCreated${fromAddress}`, 'signal', fromAddress, signalType, data);
                });
                dispatcher.on('caption', (fromAddress, content)=>{
                    session._.dispatchCaption(fromAddress, content);
                });
                dispatcher.on('archive#created', (archive)=>{
                    parseAndAddArchiveToSession(archive, session);
                });
                dispatcher.on('archive#updated', (archiveId, update)=>{
                    const archive = session.archives.get(archiveId);
                    if (!archive) {
                        logging.error(`An archive does not exist with the id of ${archiveId}, for archive#updated message!`); // @todo error
                        return;
                    }
                    archive._.update(update);
                });
                dispatcher.on('source#create', (sourceStreamId, streamId, reason)=>{
                    const mediaMode = getMediaModeBySourceStreamId(sourceStreamId);
                    session.logEvent('SessionDispatcher:source#create', 'Event', {
                        sourceStreamId: mediaMode,
                        streamId: streamId,
                        reason: reason
                    });
                    logging.debug('Received a request from RUMOR to start a transition to ' + `${sourceStreamId} for the stream ID ${streamId} with the reason: ${reason}`);
                    sessionObjects.publishers.where({
                        streamId: streamId
                    }).forEach((publisher)=>{
                        publisher._.startRoutedToRelayedTransition();
                    });
                });
                dispatcher.on('source#delete', (sourceStreamId, streamId, reason)=>{
                    session.logEvent('SessionDispatcher:source#delete', 'Event', {
                        sourceStreamId: getMediaModeBySourceStreamId(sourceStreamId),
                        streamId: streamId,
                        reason: reason
                    });
                    logging.debug('Received a request from RUMOR to start a transition from P2P ' + `to MANTIS for the stream ID ${streamId} with the reason: ${reason}`);
                    sessionObjects.publishers.where({
                        streamId: streamId
                    }).forEach((publisher)=>{
                        publisher._.startRelayedToRoutedTransition();
                    });
                });
                return dispatcher;
            };
        /***/ },
        /* 325 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Events = __webpack_require__(23)();
            const eventing = __webpack_require__(7);
            module1.exports = function Archive(id, name, status) {
                this.id = id;
                this.name = name;
                this.status = status;
                this._ = {};
                eventing(this); // Mass update, called by Raptor.Dispatcher
                this._.update = (attributes)=>{
                    Object.keys(attributes).forEach((key)=>{
                        const oldValue = this[key];
                        this[key] = attributes[key];
                        const event = new Events.ArchiveUpdatedEvent(this, key, oldValue, this[key]);
                        this.dispatchEvent(event);
                    });
                };
                this.destroy = ()=>{};
            };
        /***/ },
        /* 326 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(24)(), getAudioOutputMediaDevices = _require.getAudioOutputMediaDevices;
            /**
 * Enumerates the audio output devices (such as speakers) available to the browser.
 * <p>
 *   The method returns a Promise which resolves an array of objects corresponding to
 *   available audio output devices. Each object has two properties: <code>deviceId</code>
 *   and <code>label</code>, each of which are strings.
 * </p>
 * <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> as the parameter of the <a href="#setAudioOutputDevice">
 *   OT.setAudioOutputDevice()</a> method. The <code>deviceId</code>
 *   property is set to undefined if the user has not previously granted access to
 *   a camera and microphone. In the case there are no audio output devices available, the property
 *   is set to `null`.
 * <p>
 * </p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </p>
 * <i>Note:</i> The browser may limit the number of returned audio output devices
 * to one before the user has granted access to a camera or microphone.
 *
 * @see <a href="#setAudioOutputDevice">OT.setAudioOutputDevice()</a>
 * @see <a href="#getActiveAudioOutputDevice">OT.getActiveAudioOutputDevice()</a>
 * @method OT.getAudioOutputDevices
 * @memberof OT
 */ module1.exports = ()=>getAudioOutputMediaDevices();
        /***/ },
        /* 327 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(24)(), getActiveAudioOutputDevice = _require.getActiveAudioOutputDevice;
            /**
 * Returns a Promise that resolves the current audio output device.
 * <p>
 *   The method returns a Promise which resolves an object that has two properties:
 *   <code>deviceId</code> and <code>label</code>, each of which are strings.
 * </p>
 * <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> as the parameter of the <a href="#setAudioOutputDevice">
 *   OT.setAudioOutputDevice()</a> method. The <code>deviceId</code>
 *   property is set to undefined if the user has not previously granted access to
 *   a camera and microphone.
 * <p>
 * </p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </p>
 *
 * @see <a href="#getAudioOutputDevices">OT.getAudioOutputDevices()</a>
 * @see <a href="#setAudioOutputDevice">OT.setAudioOutputDevice()</a>
 * @method OT.getActiveAudioOutputDevice
 * @memberof OT
 */ module1.exports = ()=>getActiveAudioOutputDevice();
        /***/ },
        /* 328 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                const sessionObjects = __webpack_require__(21);
                const _require = __webpack_require__(105), setCurrentAudioOutputDeviceId = _require.setCurrentAudioOutputDeviceId;
                const getActiveAudioOutputDevice = __webpack_require__(327);
                const _require2 = __webpack_require__(24)(), getDefaultAudioOutputDeviceId = _require2.getDefaultAudioOutputDeviceId, getAudioOutputMediaDevices = _require2.getAudioOutputMediaDevices;
                const noop = __webpack_require__(295);
                const AnalyticsHelper = __webpack_require__(26);
                const analytics = new AnalyticsHelper();
                const logUpdateSubscriberSinkId = (variation, payload)=>{
                    analytics.logEvent({
                        action: 'updateSubscribersSinkId',
                        variation: variation,
                        payload: payload
                    });
                };
                const updateSinkId = (newDeviceId)=>{
                    const updateSubscribersSinkId = sessionObjects.subscribers.map((subscriber)=>subscriber._.setSinkId(newDeviceId));
                    return Promise.all(updateSubscribersSinkId);
                };
                const rollbackToDevice = /*#__PURE__*/ function() {
                    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(rollbackDeviceId) {
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return noop();
                                case 2:
                                    _context.prev = 2;
                                    logUpdateSubscriberSinkId('Attempt', {
                                        deviceId: rollbackDeviceId
                                    });
                                    _context.next = 6;
                                    return updateSinkId(rollbackDeviceId);
                                case 6:
                                    logUpdateSubscriberSinkId('Success', {
                                        deviceId: rollbackDeviceId
                                    });
                                    _context.next = 13;
                                    break;
                                case 9:
                                    _context.prev = 9;
                                    _context.t0 = _context["catch"](2);
                                    logUpdateSubscriberSinkId('Failure', {
                                        deviceId: rollbackDeviceId,
                                        error: _context.t0 == null ? void 0 : _context.t0.message
                                    });
                                    throw _context.t0;
                                case 13:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                2,
                                9
                            ]
                        ]);
                    }));
                    return function rollbackToDevice(_x) {
                        return _ref.apply(this, arguments);
                    };
                }();
                const rollbackToDefaultDevice = /*#__PURE__*/ function() {
                    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                        var devices, defaultDeviceId;
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    _context2.next = 2;
                                    return getAudioOutputMediaDevices();
                                case 2:
                                    devices = _context2.sent;
                                    defaultDeviceId = getDefaultAudioOutputDeviceId(devices);
                                    _context2.prev = 4;
                                    _context2.next = 7;
                                    return rollbackToDevice(defaultDeviceId);
                                case 7:
                                    setCurrentAudioOutputDeviceId(defaultDeviceId);
                                    _context2.next = 12;
                                    break;
                                case 10:
                                    _context2.prev = 10;
                                    _context2.t0 = _context2["catch"](4);
                                case 12:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, null, [
                            [
                                4,
                                10
                            ]
                        ]);
                    }));
                    return function rollbackToDefaultDevice() {
                        return _ref2.apply(this, arguments);
                    };
                }();
                const onUpdateSubscriberSinkIdError = /*#__PURE__*/ function() {
                    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3() {
                        var currentDevice;
                        return _regenerator.default.wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    _context3.next = 2;
                                    return getActiveAudioOutputDevice();
                                case 2:
                                    currentDevice = _context3.sent;
                                    _context3.prev = 3;
                                    _context3.next = 6;
                                    return rollbackToDevice(currentDevice.deviceId);
                                case 6:
                                    _context3.next = 12;
                                    break;
                                case 8:
                                    _context3.prev = 8;
                                    _context3.t0 = _context3["catch"](3);
                                    _context3.next = 12;
                                    return rollbackToDefaultDevice();
                                case 12:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3, null, [
                            [
                                3,
                                8
                            ]
                        ]);
                    }));
                    return function onUpdateSubscriberSinkIdError() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                module1.exports = /*#__PURE__*/ function() {
                    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(deviceId) {
                        return _regenerator.default.wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    _context4.prev = 0;
                                    logUpdateSubscriberSinkId('Attempt', {
                                        deviceId: deviceId
                                    });
                                    _context4.next = 4;
                                    return updateSinkId(deviceId);
                                case 4:
                                    logUpdateSubscriberSinkId('Success', {
                                        deviceId: deviceId
                                    });
                                    setCurrentAudioOutputDeviceId(deviceId);
                                    _context4.next = 14;
                                    break;
                                case 8:
                                    _context4.prev = 8;
                                    _context4.t0 = _context4["catch"](0);
                                    logUpdateSubscriberSinkId('Failure', {
                                        deviceId: deviceId,
                                        error: _context4.t0 == null ? void 0 : _context4.t0.message
                                    });
                                    _context4.next = 13;
                                    return onUpdateSubscriberSinkIdError();
                                case 13:
                                    throw _context4.t0;
                                case 14:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4, null, [
                            [
                                0,
                                8
                            ]
                        ]);
                    }));
                    return function(_x2) {
                        return _ref4.apply(this, arguments);
                    };
                }();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 329 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable  import/newline-after-import, no-param-reassign */ __webpack_require__(330);
            const clone = __webpack_require__(38);
            const eventNames = __webpack_require__(27);
            const eventing = __webpack_require__(7);
            const Event1 = __webpack_require__(126);
            const StaticConfig = __webpack_require__(35)();
            const AnalyticsHelper = __webpack_require__(26);
            const setDeprecatedProperty = __webpack_require__(249);
            const runtimeProperties = __webpack_require__(556);
            const mutableRuntimeProperties = __webpack_require__(557);
            const staticConfig = StaticConfig.onlyLocal(); // We need to do this first because of circular dependency issues with otplugin.js. @TODO: fix this.
            const OT = {}; // noConflict is constructed before we override global.OT so we keep the original value
            OT.noConflict = __webpack_require__(558)();
            window.OT = OT;
            module1.exports = OT;
            (()=>{
                let TB = OT;
                Object.defineProperty(window, 'TB', {
                    get: ()=>{
                        if (TB === OT) // eslint-disable-next-line no-console
                        console.warn('window.TB is deprecated, and will be removed in the future. Please access via window.OT');
                        return TB;
                    },
                    set: (_TB)=>{
                        TB = _TB;
                    },
                    // We provide a setter so noConflict works
                    configurable: true
                });
            })();
            const windowMock = __webpack_require__(142)(window);
            const OTHelpers = __webpack_require__(8);
            const APIKEY = __webpack_require__(72);
            const AudioLevelTransformer = __webpack_require__(143);
            const calculateCapableSimulcastStreams = __webpack_require__(252);
            const Chrome = __webpack_require__(144);
            const WebAudioAudioLevelSampler = __webpack_require__(145);
            const GetAudioLevelSampler = __webpack_require__(253);
            const EnvironmentLoader = __webpack_require__(146);
            const Errors = __webpack_require__(6);
            const ExceptionCodes = __webpack_require__(10);
            const generateConstraintInfo = __webpack_require__(254);
            const guidStorage = __webpack_require__(241);
            const logging = __webpack_require__(2)('OT');
            const logLevels = __webpack_require__(119);
            const setLogLevel = __webpack_require__(585);
            const OTErrorClass = __webpack_require__(22);
            const _require = __webpack_require__(101), parseIceServers = _require.parseIceServers;
            const PUBLISH_MAX_DELAY = __webpack_require__(267);
            const sessionObjects = __webpack_require__(21);
            const StreamChannel = __webpack_require__(149);
            const StylableComponent = __webpack_require__(151);
            const systemRequirements = __webpack_require__(152);
            const PeerConnection = __webpack_require__(73)({
                global: windowMock
            });
            const otError = __webpack_require__(13)({});
            const audioContext = __webpack_require__(158)();
            const chromeExtensionHelper = __webpack_require__(281)({
                otError: otError
            });
            const createChromeMixin = __webpack_require__(282)();
            const getNativeEnumerateDevices = __webpack_require__(287)({
                global: windowMock
            });
            const deviceHelpers = __webpack_require__(24)({
                getNativeEnumerateDevices: getNativeEnumerateDevices
            });
            const Events = __webpack_require__(23)();
            const generateSimpleStateMachine = __webpack_require__(160)();
            const getUserMediaHelper = __webpack_require__(638)({
                otError: otError,
                global: windowMock
            });
            const screenSharing = __webpack_require__(161)({
                chromeExtensionHelper: chromeExtensionHelper,
                otError: otError
            });
            const processPubOptions = __webpack_require__(643)({
                deviceHelpers: deviceHelpers,
                generateConstraintInfo: generateConstraintInfo,
                getUserMediaHelper: getUserMediaHelper,
                global: windowMock,
                OTHelpers: OTHelpers,
                screenSharing: screenSharing
            });
            const getUserMedia = __webpack_require__(646)({
                otError: otError,
                processPubOptions: processPubOptions
            });
            const interpretPeerConnectionError = __webpack_require__(162)({
                otError: otError
            });
            const IntervalRunner = __webpack_require__(75);
            const Microphone = __webpack_require__(292)();
            const videoElementErrorMap = __webpack_require__(293)({
                otError: otError
            });
            const NativeVideoElementWrapper = __webpack_require__(294)({
                global: windowMock,
                videoElementErrorMap: videoElementErrorMap
            });
            const setCertificates = __webpack_require__(163)({
                global: windowMock
            });
            const PublisherPeerConnection = __webpack_require__(296)({
                PeerConnection: PeerConnection,
                setCertificates: setCertificates
            });
            const SubscriberPeerConnection = __webpack_require__(299)({
                PeerConnection: PeerConnection,
                setCertificates: setCertificates
            });
            const PublishingState = __webpack_require__(300)();
            const reportIssue = __webpack_require__(658)({
                otError: otError
            });
            const VideoElementFacade = __webpack_require__(107)({
                NativeVideoElementWrapper: NativeVideoElementWrapper
            });
            const VideoOrientation = __webpack_require__(150)();
            const WidgetView = __webpack_require__(164)({
                VideoElementFacade: VideoElementFacade
            });
            const Subscriber = __webpack_require__(303)({
                interpretPeerConnectionError: interpretPeerConnectionError,
                otError: otError,
                SubscriberPeerConnection: SubscriberPeerConnection,
                WidgetView: WidgetView
            });
            const Publisher = __webpack_require__(168)({
                APIKEY: APIKEY,
                createChromeMixin: createChromeMixin,
                deviceHelpers: deviceHelpers,
                EnvironmentLoader: EnvironmentLoader,
                Errors: Errors,
                Events: Events,
                ExceptionCodes: ExceptionCodes,
                calculateCapableSimulcastStreams: calculateCapableSimulcastStreams,
                global: windowMock,
                interpretPeerConnectionError: interpretPeerConnectionError,
                IntervalRunner: IntervalRunner,
                Microphone: Microphone,
                otError: otError,
                OTErrorClass: OTErrorClass,
                OTHelpers: OTHelpers,
                parseIceServers: parseIceServers,
                processPubOptions: processPubOptions,
                PUBLISH_MAX_DELAY: PUBLISH_MAX_DELAY,
                PublisherPeerConnection: PublisherPeerConnection,
                PublishingState: PublishingState,
                StreamChannel: StreamChannel,
                systemRequirements: systemRequirements,
                VideoOrientation: VideoOrientation,
                WidgetView: WidgetView
            });
            const initPublisher = __webpack_require__(314)({
                otError: otError,
                Publisher: Publisher
            });
            const Session = __webpack_require__(315)({
                global: windowMock,
                initPublisher: initPublisher,
                otError: otError,
                Publisher: Publisher,
                Subscriber: Subscriber
            });
            const initSession = __webpack_require__(746)({
                Session: Session
            }); // Allow events to be bound on OT
            eventing(OT);
            const getSupportedCodecs = __webpack_require__(747);
            const hasMediaProcessorSupport = __webpack_require__(750);
            setDeprecatedProperty(OT, '$', {
                name: 'OT.$',
                getMessage: 'Please use an external library like jQuery to select elements from the page.',
                value: OTHelpers
            }); // Define the APIKEY this is a global parameter which should not change
            OT.APIKEY = APIKEY.value;
            OT.AnalyserAudioLevelSampler = WebAudioAudioLevelSampler;
            OT.Archive = __webpack_require__(325);
            OT.ArchiveEvent = Events.ArchiveEvent;
            OT.ArchiveUpdatedEvent = Events.ArchiveUpdatedEvent;
            OT.AudioLevelTransformer = AudioLevelTransformer;
            OT.AudioLevelUpdatedEvent = Events.AudioLevelUpdatedEvent;
            OT.Capabilities = __webpack_require__(169);
            OT.Chrome = Chrome;
            OT.Connection = __webpack_require__(173);
            OT.ConnectionCapabilities = OT.Connection.Capabilities;
            OT.ConnectionEvent = Events.ConnectionEvent;
            Object.keys(logLevels).forEach((name)=>{
                OT[name.toUpperCase()] = logLevels[name].priority;
            });
            OT.NONE = 0;
            OT.debug = logging.debug;
            OT.error = logging.error;
            OT.info = logging.info;
            OT.log = logging.log;
            OT.warn = logging.warn;
            OT.DestroyedEvent = Events.DestroyedEvent;
            OT.EnvLoadedEvent = Events.EnvLoadedEvent; // TODO: re-expose old screenSharing api
            OT.Error = OTErrorClass;
            OT.Error.on(eventNames.EXCEPTION, (exceptionEvent)=>{
                if (exceptionEvent.target === OT.Error) {
                    // Rebind target to OT if it's set to OT.Error to preserve old behaviour.
                    const exceptionEventClone = clone(exceptionEvent);
                    exceptionEventClone.target = OT;
                    OT.dispatchEvent(exceptionEventClone);
                } else OT.dispatchEvent(exceptionEvent);
            });
            OT.Event = Event1;
            OT.ExceptionCodes = ExceptionCodes;
            OT.ExceptionEvent = Events.ExceptionEvent;
            OT.getDevices = __webpack_require__(751);
            OT.getAudioOutputDevices = __webpack_require__(326);
            OT.getActiveAudioOutputDevice = __webpack_require__(327);
            OT.setAudioOutputDevice = __webpack_require__(752)();
            OT.GetAudioLevelSampler = GetAudioLevelSampler;
            OT.HAS_REQUIREMENTS = 1;
            OT.IntervalRunner = IntervalRunner;
            OT.IssueReportedEvent = Events.IssueReportedEvent;
            OT.MediaStoppedEvent = Events.MediaStoppedEvent;
            OT.Microphone = Microphone;
            OT.NOT_HAS_REQUIREMENTS = 0;
            OT.PeerConnection = PeerConnection; // TODO: this is here for repel, but it doesn't belong here
            OT.PeerConnection.QOS = __webpack_require__(279).default;
            OT.Publisher = Publisher;
            OT.PublisherPeerConnection = PublisherPeerConnection;
            OT.PublishingState = PublishingState;
            OT.MuteForcedEvent = Events.MuteForcedEvent;
            OT.Session = Session;
            OT.SessionConnectEvent = Events.SessionConnectEvent;
            OT.SessionDisconnectEvent = Events.SessionDisconnectEvent;
            OT.SessionDispatcher = __webpack_require__(324);
            OT.Signal = __webpack_require__(322);
            OT.SignalEvent = Events.SignalEvent;
            OT.Stream = __webpack_require__(171);
            OT.StreamChannel = StreamChannel;
            OT.StreamEvent = Events.StreamEvent;
            OT.StreamPropertyChangedEvent = Events.StreamPropertyChangedEvent;
            OT.StreamUpdatedEvent = Events.StreamUpdatedEvent;
            OT.StylableComponent = StylableComponent;
            OT.Subscriber = Subscriber;
            OT.SubscriberPeerConnection = SubscriberPeerConnection;
            OT.SubscribingState = __webpack_require__(306);
            OT.VideoDimensionsChangedEvent = Events.VideoDimensionsChangedEvent;
            OT.VideoDisableWarningEvent = Events.VideoDisableWarningEvent;
            OT.VideoElement = VideoElementFacade;
            OT.VideoEnabledChangedEvent = Events.VideoEnabledChangedEvent;
            OT.VideoOrientation = VideoOrientation;
            OT.WidgetView = WidgetView;
            OT.getSupportedCodecs = getSupportedCodecs;
            OT.hasMediaProcessorSupport = hasMediaProcessorSupport;
            OT._ = {
                AnalyticsHelper: AnalyticsHelper,
                getClientGuid: guidStorage.get,
                StaticConfig: StaticConfig
            };
            /**
 *
 * The currently loaded version of OpenTok.js.
 *
 * @property {string} version
 * @readonly
 * @memberof OT
 */ Object.defineProperty(OT, 'version', {
                value: staticConfig.version
            });
            const properties = {};
            const canPropertyBeMutated = (property)=>mutableRuntimeProperties.includes(property);
            setDeprecatedProperty(properties, 'version', {
                value: staticConfig.version,
                name: 'OT.properties.version',
                getWarning: 'Please use OT.version instead',
                warnOnSet: true,
                setWarning: 'Mutating version has no effect'
            });
            runtimeProperties.forEach((keyMap)=>{
                let value;
                let key;
                if (Array.isArray(keyMap)) {
                    const propKey = keyMap[0], staticConfigKey = keyMap[1];
                    key = propKey;
                    value = staticConfig[staticConfigKey] || staticConfigKey;
                } else {
                    value = staticConfig[keyMap];
                    key = keyMap;
                }
                const isPropertyMutable = canPropertyBeMutated(key);
                setDeprecatedProperty(properties, key, {
                    value: value,
                    name: `OT.properties.${key}`,
                    warnOnSet: true,
                    canSet: isPropertyMutable,
                    setWarning: isPropertyMutable ? `Mutating ${key} can cause side effects` : `Mutating ${key} has no effect`
                });
            });
            OT.properties = properties; // OT.addEventListener comes from eventing(OT)
            OT.audioContext = audioContext;
            OT.checkScreenSharingCapability = screenSharing.checkCapability;
            OT.checkSystemRequirements = systemRequirements.check;
            OT.components = {}; // OT.dispatchEvent comes from eventing(OT)
            // OT.emit comes from eventing(OT)
            OT.generateSimpleStateMachine = generateSimpleStateMachine;
            OT.getErrorTitleByCode = OTErrorClass.getTitleByCode;
            OT.getLogs = logging.getLogs; // This is misspelled in production too, being compatible here.
            OT.getStatsAdpater = __webpack_require__(275);
            OT.getStatsHelpers = __webpack_require__(76);
            OT.getUserMedia = getUserMedia;
            OT.handleJsException = OTErrorClass.handleJsException;
            OT.initPublisher = initPublisher;
            OT.setProxyUrl = __webpack_require__(139).setProxyUrl;
            OT.initSession = function(apiKey, sessionId, opt) {
                if (sessionId == null) {
                    sessionId = apiKey;
                    apiKey = null;
                } // Ugly hack, make sure OT.APIKEY is set
                // TODO: Yep, sure is ugly. It appears to be needed by raptor. We should fix this situation.
                // UPDATE: This hack is the only reason why we need to wrap the actual initSession.
                if (APIKEY.value.length === 0 && apiKey) {
                    APIKEY.value = apiKey;
                    OT.APIKEY = apiKey;
                }
                return initSession(apiKey, sessionId, opt);
            };
            const deprecatedMessage = (key)=>`${key} is deprecated and will be removed in a future version of OpenTok`;
            const warnAndReturn = (name, value)=>()=>{
                    // eslint-disable-next-line no-console
                    console.warn(deprecatedMessage(name));
                    return value;
                }; // discourage us and others from using these OT methods
            Object.defineProperties(OT, {
                isUnloaded: {
                    get: warnAndReturn('OT.isUnloaded', EnvironmentLoader.isUnloaded)
                },
                onLoad: {
                    get: warnAndReturn('OT.onLoad', EnvironmentLoader.onLoad)
                },
                onUnload: {
                    get: warnAndReturn('OT.onUnload', EnvironmentLoader.onUnload)
                },
                overrideGuidStorage: {
                    get: warnAndReturn('OT.overrideGuidStorage', guidStorage.override)
                }
            }); // OT.off comes from eventing(OT)
            // OT.on comes from eventing(OT)
            // OT.once comes from eventing(OT)
            // OT.removeEventListener comes from eventing(OT)
            // OT.trigger comes from eventing(OT)
            // Exposed here for partner usage.
            OT.pickScreenSharingHelper = screenSharing.pickHelper;
            OT.publishers = sessionObjects.publishers;
            OT.registerScreenSharingExtension = screenSharing.registerExtension;
            OT.registerScreenSharingExtensionHelper = screenSharing.registerExtensionHelper;
            OT.reportIssue = reportIssue;
            OT.sessions = sessionObjects.sessions;
            OT.setLogLevel = setLogLevel;
            OT.shouldLog = logging.shouldLog;
            OT.subscribers = sessionObjects.subscribers;
            OT.unblockAudio = __webpack_require__(166);
            OT.upgradeSystemRequirements = systemRequirements.upgrade; // Tidy up everything on unload
            EnvironmentLoader.onUnload(()=>{
                sessionObjects.publishers.destroy();
                sessionObjects.subscribers.destroy();
                sessionObjects.sessions.destroy('unloaded');
            });
            __webpack_require__(753)();
        /**
 * This method is deprecated. Use <a href="#on">on()</a> or <a href="#once">once()</a> instead.
 *
 * <p>
 * Registers a method as an event listener for a specific event.
 * </p>
 *
 * <p>
 * The OT object dispatches one type of event &#151; an <code>exception</code> event. The
 * following code adds an event listener for the <code>exception</code> event:
 * </p>
 *
 * <pre>
 * OT.addEventListener("exception", exceptionHandler);
 *
 * function exceptionHandler(event) {
 *    alert("exception event. \n  code == " + event.code + "\n  message == " + event.message);
 * }
 * </pre>
 *
 * <p>
 *   If a handler is not registered for an event, the event is ignored locally. If the event
 *   listener function does not exist, the event is ignored locally.
 * </p>
 * <p>
 *   Throws an exception if the <code>listener</code> name is invalid.
 * </p>
 *
 * @param {String} type The string identifying the type of event.
 *
 * @param {Function} listener The function to be invoked when the OT object dispatches the event.
 * @see <a href="#on">on()</a>
 * @see <a href="#once">once()</a>
 * @memberof OT
 * @method addEventListener
 *
 */ /**
 * This method is deprecated. Use <a href="#off">off()</a> instead.
 *
 * <p>
 * Removes an event listener for a specific event.
 * </p>
 *
 * <p>
 *   Throws an exception if the <code>listener</code> name is invalid.
 * </p>
 *
 * @param {String} type The string identifying the type of event.
 *
 * @param {Function} listener The event listener function to remove.
 *
 * @see <a href="#off">off()</a>
 * @memberof OT
 * @method removeEventListener
 */ /**
* Adds an event handler function for one or more events.
*
* <p>
* The OT object dispatches one type of event &#151; an <code>exception</code> event. The following
* code adds an event
* listener for the <code>exception</code> event:
* </p>
*
* <pre>
* OT.on("exception", function (event) {
*   // This is the event handler.
* });
* </pre>
*
* <p>You can also pass in a third <code>context</code> parameter (which is optional) to define the
* value of
* <code>this</code> in the handler method:</p>
*
* <pre>
* OT.on("exception",
*   function (event) {
*     // This is the event handler.
*   }),
*   session
* );
* </pre>
*
* <p>
* If you do not add a handler for an event, the event is ignored locally.
* </p>
*
* @param {String} type The string identifying the type of event.
* @param {Function} handler The handler function to process the event. This function takes the event
* object as a parameter.
* @param {Object} context (Optional) Defines the value of <code>this</code> in the event handler
* function.
*
* @memberof OT
* @method on
* @see <a href="#off">off()</a>
* @see <a href="#once">once()</a>
* @see <a href="#events">Events</a>
*/ /**
* Adds an event handler function for an event. Once the handler is called, the specified handler
* method is
* removed as a handler for this event. (When you use the <code>OT.on()</code> method to add an event
* handler, the handler
* is <i>not</i> removed when it is called.) The <code>OT.once()</code> method is the equivilent of
* calling the <code>OT.on()</code>
* method and calling <code>OT.off()</code> the first time the handler is invoked.
*
* <p>
* The following code adds a one-time event handler for the <code>exception</code> event:
* </p>
*
* <pre>
* OT.once("exception", function (event) {
*   console.log(event);
* }
* </pre>
*
* <p>You can also pass in a third <code>context</code> parameter (which is optional) to define the
* value of
* <code>this</code> in the handler method:</p>
*
* <pre>
* OT.once("exception",
*   function (event) {
*     // This is the event handler.
*   },
*   session
* );
* </pre>
*
* <p>
* The method also supports an alternate syntax, in which the first parameter is an object that is a
* hash map of
* event names and handler functions and the second parameter (optional) is the context for this in
* each handler:
* </p>
* <pre>
* OT.once(
*   {exeption: function (event) {
*     // This is the event handler.
*     }
*   },
*   session
* );
* </pre>
*
* @param {String} type The string identifying the type of event. You can specify multiple event
* names in this string,
* separating them with a space. The event handler will process the first occurence of the events.
* After the first event,
* the handler is removed (for all specified events).
* @param {Function} handler The handler function to process the event. This function takes the event
* object as a parameter.
* @param {Object} context (Optional) Defines the value of <code>this</code> in the event handler
* function.
*
* @memberof OT
* @method once
* @see <a href="#on">on()</a>
* @see <a href="#once">once()</a>
* @see <a href="#events">Events</a>
*/ /**
 * Removes an event handler.
 *
 * <p>Pass in an event name and a handler method, the handler is removed for that event:</p>
 *
 * <pre>OT.off("exceptionEvent", exceptionEventHandler);</pre>
 *
 * <p>If you pass in an event name and <i>no</i> handler method, all handlers are removed for that
 * events:</p>
 *
 * <pre>OT.off("exceptionEvent");</pre>
 *
 * <p>
 * The method also supports an alternate syntax, in which the first parameter is an object that is a
 * hash map of
 * event names and handler functions and the second parameter (optional) is the context for matching
 * handlers:
 * </p>
 * <pre>
 * OT.off(
 *   {
 *     exceptionEvent: exceptionEventHandler
 *   },
 *   this
 * );
 * </pre>
 *
 * @param {String} type (Optional) The string identifying the type of event. You can use a space to
 * specify multiple events, as in "eventName1 eventName2 eventName3". If you pass in no
 * <code>type</code> value (or other arguments), all event handlers are removed for the object.
 * @param {Function} handler (Optional) The event handler function to remove. If you pass in no
 * <code>handler</code>, all event handlers are removed for the specified event <code>type</code>.
 * @param {Object} context (Optional) If you specify a <code>context</code>, the event handler is
 * removed for all specified events and handlers that use the specified context.
 *
 * @memberof OT
 * @method off
 * @see <a href="#on">on()</a>
 * @see <a href="#once">once()</a>
 * @see <a href="#events">Events</a>
 */ /**
 * Dispatched by the OT class when the app encounters an exception.
 * Note that you set up an event handler for the <code>exception</code> event by calling the
 * <code>OT.on()</code> method.
 *
 * @name exception
 * @event
 * @borrows ExceptionEvent#message as this.message
 * @memberof OT
 * @see ExceptionEvent
 */ /***/ },
        /* 330 */ /***/ function(module1, exports, __webpack_require__) {
            var content = __webpack_require__(331);
            if (typeof content === 'string') content = [
                [
                    module1.i,
                    content,
                    ''
                ]
            ];
            var transform;
            var insertInto;
            var options = {
                "hmr": true
            };
            options.transform = transform;
            options.insertInto = undefined;
            var update = __webpack_require__(345)(content, options);
            if (content.locals) module1.exports = content.locals;
        /***/ },
        /* 331 */ /***/ function(module1, exports, __webpack_require__) {
            exports = module1.exports = __webpack_require__(332)(false);
            // Imports
            var urlEscape = __webpack_require__(333);
            var ___CSS_LOADER_URL___0___ = urlEscape(__webpack_require__(334));
            var ___CSS_LOADER_URL___1___ = urlEscape(__webpack_require__(335));
            var ___CSS_LOADER_URL___2___ = urlEscape(__webpack_require__(336));
            var ___CSS_LOADER_URL___3___ = urlEscape(__webpack_require__(337));
            var ___CSS_LOADER_URL___4___ = urlEscape(__webpack_require__(338));
            var ___CSS_LOADER_URL___5___ = urlEscape(__webpack_require__(339));
            var ___CSS_LOADER_URL___6___ = urlEscape(__webpack_require__(340));
            var ___CSS_LOADER_URL___7___ = urlEscape(__webpack_require__(341));
            var ___CSS_LOADER_URL___8___ = urlEscape(__webpack_require__(342));
            var ___CSS_LOADER_URL___9___ = urlEscape(__webpack_require__(343));
            var ___CSS_LOADER_URL___10___ = urlEscape(__webpack_require__(344));
            // Module
            exports.push([
                module1.i,
                "/*!\n * Copyright (c) 2017 TokBox, Inc.\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n */\n\n/**\n * OT Base styles\n */\n\n/* Root OT object, this is where our CSS reset happens */\n.OT_root,\n.OT_root * {\n  color: #ffffff;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: Arial, Helvetica, sans-serif;\n  vertical-align: baseline;\n}\n\n/**\n * Specific Element Reset\n */\n\n.OT_root h1,\n.OT_root h2,\n.OT_root h3,\n.OT_root h4,\n.OT_root h5,\n.OT_root h6 {\n  color: #ffffff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 100%;\n  font-weight: bold;\n}\n\n.OT_root header {\n\n}\n\n.OT_root footer {\n\n}\n\n.OT_root div {\n\n}\n\n.OT_root section {\n\n}\n\n.OT_root video {\n\n}\n\n.OT_root button {\n\n}\n\n.OT_root strong {\n  font-weight: bold;\n}\n\n.OT_root em {\n  font-style: italic;\n}\n\n.OT_root a,\n.OT_root a:link,\n.OT_root a:visited,\n.OT_root a:hover,\n.OT_root a:active {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.OT_root ul, .OT_root ol {\n  margin: 1em 1em 1em 2em;\n}\n\n.OT_root ol {\n  list-style: decimal outside;\n}\n\n.OT_root ul {\n  list-style: disc outside;\n}\n\n.OT_root dl {\n  margin: 4px;\n}\n\n.OT_root dl dt,\n.OT_root dl dd {\n  float: left;\n  margin: 0;\n  padding: 0;\n}\n\n.OT_root dl dt {\n  clear: left;\n  text-align: right;\n  width: 50px;\n}\n\n.OT_root dl dd {\n  margin-left: 10px;\n}\n\n.OT_root img {\n  border: 0 none;\n}\n\n/* Modal dialog styles */\n\n/* Modal dialog styles */\n\n.OT_dialog-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_dialog-centering-child {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_dialog {\n  position: relative;\n\n  box-sizing: border-box;\n  max-width: 576px;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 36px;\n  text-align: center; /* centers all the inline content */\n\n  background-color: #363636;\n  color: #fff;\n  box-shadow: 2px 4px 6px #999;\n  font-family: 'Didact Gothic', sans-serif;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.OT_dialog * {\n  font-family: inherit;\n  box-sizing: inherit;\n}\n\n.OT_closeButton {\n  color: #999999;\n  cursor: pointer;\n  font-size: 32px;\n  line-height: 36px;\n  position: absolute;\n  right: 18px;\n  top: 0;\n}\n\n.OT_dialog-messages {\n  text-align: center;\n}\n\n.OT_dialog-messages-main {\n  margin-bottom: 36px;\n  line-height: 36px;\n\n  font-weight: 300;\n  font-size: 24px;\n}\n\n.OT_dialog-messages-minor {\n  margin-bottom: 18px;\n\n  font-size: 13px;\n  line-height: 18px;\n  color: #A4A4A4;\n}\n\n.OT_dialog-messages-minor strong {\n  color: #ffffff;\n}\n\n.OT_dialog-actions-card {\n  display: inline-block;\n}\n\n.OT_dialog-button-title {\n  margin-bottom: 18px;\n  line-height: 18px;\n\n  font-weight: 300;\n  text-align: center;\n  font-size: 14px;\n  color: #999999;\n}\n.OT_dialog-button-title label {\n  color: #999999;\n}\n\n.OT_dialog-button-title a,\n.OT_dialog-button-title a:link,\n.OT_dialog-button-title a:active {\n  color: #02A1DE;\n}\n\n.OT_dialog-button-title strong {\n  color: #ffffff;\n  font-weight: 100;\n  display: block;\n}\n\n.OT_dialog-button {\n  display: inline-block;\n\n  margin-bottom: 18px;\n  padding: 0 1em;\n\n  background-color: #1CA3DC;\n  text-align: center;\n  cursor: pointer;\n}\n\n.OT_dialog-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.OT_dialog-button-large {\n  line-height: 36px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  font-weight: 100;\n  font-size: 24px;\n}\n\n.OT_dialog-button-small {\n  line-height: 18px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n\n  background-color: #444444;\n  color: #999999;\n  font-size: 16px;\n}\n\n.OT_dialog-progress-bar {\n  display: inline-block; /* prevents margin collapse */\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 41px;\n\n  border: 1px solid #4E4E4E;\n  height: 8px;\n}\n\n.OT_dialog-progress-bar-fill {\n  height: 100%;\n\n  background-color: #29A4DA;\n}\n\n/* Helpers */\n\n.OT_centered {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin: 0;\n}\n\n.OT_dialog-hidden {\n  display: none;\n}\n\n.OT_dialog-button-block {\n  display: block;\n}\n\n.OT_dialog-no-natural-margin {\n  margin-bottom: 0;\n}\n\n/* Publisher and Subscriber styles */\n\n.OT_publisher, .OT_subscriber {\n  position: relative;\n  min-width: 48px;\n  min-height: 48px;\n}\n\n.OT_publisher .OT_video-element,\n.OT_subscriber .OT_video-element {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  transform-origin: 0 0;\n}\n\n/* Styles that are applied when the video element should be mirrored */\n.OT_publisher.OT_mirrored .OT_video-element {\n  transform: scale(-1, 1);\n  transform-origin: 50% 50%;\n}\n\n.OT_subscriber_error {\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n}\n\n.OT_subscriber_error > p {\n  padding: 20px;\n}\n\n/* The publisher/subscriber name/mute background */\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar,\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name,\n.OT_publisher .OT_archiving,\n.OT_subscriber .OT_archiving,\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status,\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  -ms-box-sizing: border-box;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: block;\n  height: 34px;\n  position: absolute;\n}\n\n.OT_publisher .OT_bar,\n.OT_subscriber .OT_bar {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  z-index: 1; /* required to get audio level meter underneath */\n}\n\n/* The publisher/subscriber name panel/archiving status bar */\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n  background-color: transparent;\n  color: #ffffff;\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  padding: 0 4px 0 36px;\n  letter-spacing: normal;\n}\n\n.OT_publisher .OT_archiving-status,\n.OT_subscriber .OT_archiving-status {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  left: 34px;\n  padding: 0 4px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 15px;\n  line-height: 34px;\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n.OT_micro .OT_archiving-status,\n.OT_micro:hover .OT_archiving-status,\n.OT_mini .OT_archiving-status,\n.OT_mini:hover .OT_archiving-status {\n  display: none;\n}\n\n.OT_publisher .OT_archiving-light-box,\n.OT_subscriber .OT_archiving-light-box {\n  background: rgba(0, 0, 0, 0.4);\n  top: auto;\n  bottom: 0;\n  right: auto;\n  width: 34px;\n  height: 34px;\n}\n\n.OT_archiving-light {\n  width: 7px;\n  height: 7px;\n  border-radius: 30px;\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  background-color: #575757;\n  box-shadow: 0 0 5px 1px #575757;\n}\n\n.OT_archiving-light.OT_active {\n  background-color: #970d13;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -moz-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation: OT_pulse 1.3s ease-in;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -webkit-animation-iteration-count: infinite;\n}\n\n.OT_mini .OT_bar,\n.OT_bar.OT_mode-mini,\n.OT_bar.OT_mode-mini-auto {\n  bottom: 0;\n  height: auto;\n}\n\n.OT_mini .OT_name.OT_mode-off,\n.OT_mini .OT_name.OT_mode-on,\n.OT_mini .OT_name.OT_mode-auto,\n.OT_mini:hover .OT_name.OT_mode-auto {\n  display: none;\n}\n\n.OT_publisher .OT_name,\n.OT_subscriber .OT_name {\n    left: 10px;\n    right: 37px;\n    height: 34px;\n    padding-left: 0;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n    border: none;\n    cursor: pointer;\n    display: block;\n    position: absolute;\n    text-align: center;\n    text-indent: -9999em;\n    background-color: transparent;\n    background-repeat: no-repeat;\n}\n\n.OT_publisher .OT_mute,\n.OT_subscriber .OT_mute {\n  right: 0;\n  top: 0;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  height: 36px;\n  width: 37px;\n}\n\n.OT_mini .OT_mute,\n.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold {\n  top: 50%;\n  left: 50%;\n  right: auto;\n  margin-top: -18px;\n  margin-left: -18.5px;\n  border-left: none;\n}\n\n.OT_publisher .OT_mute {\n  background-image: url(" + ___CSS_LOADER_URL___0___ + ");\n  background-position: 9px 5px;\n}\n\n.OT_publisher .OT_mute.OT_active {\n  background-image: url(" + ___CSS_LOADER_URL___1___ + ");\n  background-position: 9px 4px;\n}\n\n.OT_subscriber .OT_mute {\n  background-image: url(" + ___CSS_LOADER_URL___2___ + ");\n  background-position: 8px 7px;\n}\n\n.OT_subscriber .OT_mute.OT_active {\n  background-image: url(" + ___CSS_LOADER_URL___3___ + ");\n  background-position: 7px 7px;\n}\n\n/**\n * Styles for display modes\n *\n * Note: It's important that these completely control the display and opacity\n * attributes, no other selectors should atempt to change them.\n */\n\n/* Default display mode transitions for various chrome elements */\n.OT_publisher .OT_edge-bar-item,\n.OT_subscriber .OT_edge-bar-item {\n  transition-property: top, bottom, opacity;\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {\n  top: -25px;\n  opacity: 0;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_mode-off {\n  display: none;\n}\n\n.OT_mini .OT_mute.OT_mode-auto,\n.OT_publisher .OT_mute.OT_mode-mini-auto,\n.OT_subscriber .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto {\n  top: auto;\n  bottom: -25px;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_mode-on,\n.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,\n.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto {\n  top: 0;\n  opacity: 1;\n}\n\n.OT_mini .OT_mute.OT_mode-on,\n.OT_mini:hover .OT_mute.OT_mode-auto,\n.OT_mute.OT_mode-mini,\n.OT_root:hover .OT_mute.OT_mode-mini-auto {\n  top: 50%;\n}\n\n.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,\n.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,\n.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto {\n  top: auto;\n  bottom: 0;\n  opacity: 1;\n}\n\n\n/* Contains the video element, used to fix video letter-boxing */\n.OT_widget-container {\n  position: absolute;\n  background-color: #000000;\n  overflow: hidden;\n}\n\n.OT_hidden-audio {\n  position: absolute !important;\n  height: 1px !important;\n  width: 1px !important;\n}\n\n/* Load animation */\n.OT_root .OT_video-loading {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  background-color: rgba(0, 0, 0, .75);\n}\n\n.OT_root .OT_video-loading .OT_video-loading-spinner {\n  background: url(" + ___CSS_LOADER_URL___4___ + ") no-repeat;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  left: 50%;\n  top: 50%;\n  margin-left: -16px;\n  margin-top: -16px;\n  animation: OT_spin 2s linear infinite;\n}\n@keyframes OT_spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.OT_publisher.OT_loading .OT_video-loading,\n.OT_subscriber.OT_loading .OT_video-loading {\n  display: block;\n}\n\n.OT_publisher.OT_loading .OT_video-element,\n.OT_subscriber.OT_loading .OT_video-element {\n  /*display: none;*/\n}\n\n.OT_video-centering {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n.OT_video-container {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.OT_video-poster {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: none;\n\n  opacity: .25;\n\n  background-repeat: no-repeat;\n  background-image: url(" + ___CSS_LOADER_URL___5___ + ");\n  background-size: auto 76%;\n}\n\n.OT_fit-mode-cover .OT_video-element {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n/* Workaround for iOS freezing issue when cropping videos */\n/* https://bugs.webkit.org/show_bug.cgi?id=176439 */\n@media only screen\n  and (orientation: portrait) {\n  .OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element {\n    -o-object-fit: contain !important;\n       object-fit: contain !important;\n  }\n}\n\n.OT_fit-mode-contain .OT_video-element {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n.OT_fit-mode-cover .OT_video-poster {\n  background-position: center bottom;\n}\n\n.OT_fit-mode-contain .OT_video-poster {\n  background-position: center;\n}\n\n.OT_audio-level-meter {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.OT_audio-level-meter:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__audio-only-img {\n  position: absolute;\n  top: 22%;\n  right: 15%;\n  width: 40%;\n\n  opacity: .7;\n\n  background: url(" + ___CSS_LOADER_URL___6___ + ") no-repeat center;\n}\n\n.OT_audio-level-meter__audio-only-img:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_audio-level-meter__value {\n  will-change: transform;\n  position: absolute;\n  top: -100%;\n  right: -100%;\n  width: 200%;\n  height: 200%;\n  transform: scale(0);\n  border-radius: 50%;\n  background-image: radial-gradient(circle, rgba(151, 206, 0, 1) 0%, rgba(151, 206, 0, 0) 100%);\n}\n\n.OT_audio-level-meter.OT_mode-off {\n    display: none;\n}\n\n.OT_audio-level-meter.OT_mode-on,\n.OT_audio-only .OT_audio-level-meter.OT_mode-auto {\n  display: block;\n}\n\n.OT_audio-only.OT_publisher .OT_video-element,\n.OT_audio-only.OT_subscriber .OT_video-element {\n  display: none;\n}\n\n\n.OT_video-disabled-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 3px;\n  right: 3px;\n}\n\n.OT_video-disabled {\n  background-image: url(" + ___CSS_LOADER_URL___7___ + ");\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-warning {\n  background-image: url(" + ___CSS_LOADER_URL___8___ + ");\n  background-size: 33px auto;\n}\n\n.OT_video-disabled-indicator.OT_active {\n  display: block;\n}\n\n.OT_audio-blocked-indicator {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.OT_audio-blocked {\n  background-image: url(" + ___CSS_LOADER_URL___9___ + ");\n  background-size: 90px auto;\n}\n\n.OT_container-audio-blocked {\n  cursor: pointer;\n}\n\n.OT_container-audio-blocked.OT_mini .OT_edge-bar-item {\n  display: none;\n}\n\n.OT_container-audio-blocked .OT_mute {\n  display: none;\n}\n\n.OT_audio-blocked-indicator.OT_active {\n  display: block;\n}\n\n.OT_video-unsupported {\n  opacity: 1;\n  border: none;\n  display: none;\n  position: absolute;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(" + ___CSS_LOADER_URL___10___ + ");\n  background-size: 58px auto;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin-top: -30px;\n}\n\n.OT_video-unsupported-bar {\n  display: none;\n  position: absolute;\n  width: 192%; /* copy the size of the audio meter bar for symmetry */\n  height: 192%;\n  top: -96% /* half of the size */;\n  left: -96%;\n  border-radius: 50%;\n\n  background-color: rgba(0, 0, 0, .8);\n}\n\n.OT_video-unsupported-img {\n  display: none;\n  position: absolute;\n  top: 11%;\n  left: 15%;\n  width: 70%;\n  opacity: .7;\n  background-image: url(" + ___CSS_LOADER_URL___10___ + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% auto;\n}\n\n.OT_video-unsupported-img:before {\n  /* makes the height of the container 93% of its width (90/97 px) */\n  content: '';\n  display: block;\n  padding-top: 93%;\n}\n\n.OT_video-unsupported-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  margin-top: 40px;\n}\n\n.OT_video-unsupported.OT_active {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported,\n.OT_micro .OT_video-unsupported {\n  position: absolute;\n  width: 25%;\n  max-width: 224px;\n  min-width: 21px;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  background: none;\n  bottom: auto;\n  right: auto;\n  margin: auto;\n}\n\n.OT_mini .OT_video-unsupported:before,\n.OT_micro .OT_video-unsupported:before {\n  /* makes the height of the container equals its width */\n  content: '';\n  display: block;\n  padding-top: 100%;\n}\n\n.OT_mini .OT_video-unsupported-bar,\n.OT_micro .OT_video-unsupported-bar,\n.OT_mini .OT_video-unsupported-img,\n.OT_micro .OT_video-unsupported-img {\n  display: block;\n}\n\n.OT_mini .OT_video-unsupported-text,\n.OT_micro .OT_video-unsupported-text {\n  display: none;\n}\n\n.OT_hide-forced {\n  display: none;\n}\n\n.OT_ModalDialog {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n#tb_alert {\n  position: fixed;\n  width: 570px;\n  font-family: \"Lucida Grande\", Arial;\n  top: 50%;\n  left: 50%;\n  margin-top: -75px;\n  margin-left: -285px;\n}\n\n#tb_alert * {\n  box-sizing: border-box;\n}\n\n#tb_alert .OT_alert {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  background-color: #333;\n  position: relative;\n  padding: 30px;\n  overflow: visible;\n  margin-left: 70px;\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n  border-left-color: rgba(255, 255, 255, 0.1);\n\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-image: -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));\n\n  background-size: 4px 4px;\n  background-position: 0 0, 2px 2px;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n#tb_alert .OT_alert-exclamation {\n  background-color: #9c1408;\n  background-image: linear-gradient(0deg, #dd0c0a 0%, #9c1408 100%);\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n\n  margin: -1px 0;\n\n  font-family: MS Trebuchet;\n  font-weight: bold;\n  font-size: 60px;\n  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);\n\n  color: white;\n  width: 65px;\n  position: absolute;\n  padding: 42px 0;\n  text-align: center;\n  left: -70px;\n  top: 0;\n  bottom: 0;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n\n  border-bottom-color: transparent;\n  border-left: none;\n  border-right: none;\n}\n\n#tb_alert .OT_alert-exclamation:after,\n#tb_alert .OT_alert-exclamation:before {\n  content: \" \";\n  position: absolute;\n  right: -24px;\n  top: 40%;\n  border: 12px solid transparent;\n  border-left-color: #9c1408;\n}\n\n#tb_alert .OT_alert-exclamation:before {\n  border-left-color: #bc3428;\n  top: 39%;\n}\n\n#tb_alert .OT_alert-body {\n  color: #c8c5c5;\n  margin: 0;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  line-height: 1.3em;\n}\n\n#tb_alert .continue-text {\n  margin-top: 12px\n}\n\n#tb_alert > * a {\n  color: #a7d8df;\n  text-decoration: none;\n}\n\n#tb_alert .OT_alert-header {\n  font-size: 24px;\n  padding-bottom: 5px;\n  color: #aaa;\n  font-weight: bold;\n  position: relative;\n  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);\n  margin: 0;\n}\n\n#tb_alert .OT_alert-header::before {\n  content: attr(data-text);\n  position: absolute;\n  left: 0;\n  color: white;\n  -webkit-mask-image: -webkit-gradient(\n    linear,\n    left top, left bottom,\n    from(rgba(0, 0, 0, 1)),\n    color-stop(60%, rgba(0, 0, 0, 0)),\n    to(rgba(0, 0, 0, 0))\n  );\n}\n\n#tb_alert .OT_alert-close-button {\n  position: absolute;\n  right: 8px;\n  top: 5px;\n  background-color: #000;\n  color: #666;\n  border: none;\n  font-size: 20px;\n  /** Hack to bring it up to the proper line top */\n  line-height: 14px;\n  padding: 0;\n  padding-bottom: 3px;\n  cursor: pointer;\n}\n\n#tb_alert #section-mobile-browser,\n#tb_alert #section-supported-mobile-browser {\n  width: 200px;\n  top: 0px;\n  left: 25%;\n  margin-top: 0;\n  margin-left: 0;\n}\n\n@media all and (max-height: 300px) {\n  #tb_alert {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    margin-left: 0;\n    margin-top: 0;\n  }\n  #tb_alert #section-mobile-browser,\n  #tb_alert #section-supported-mobile-browser {\n    margin-left: 0;\n    margin-top: 10px;\n    left: 0;\n  }\n}\n\n#tb_alert #section-normal-install,\n#tb_alert #section-upgrade-install,\n#tb_alert #section-mobile-browser,\n#tb_alert #section-supported-mobile-browser {\n  display: none;\n}\n",
                ""
            ]);
        /***/ },
        /* 332 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/ // css base code, injected by the css-loader
            module1.exports = function(useSourceMap) {
                var list = []; // return the list of modules as css string
                list.toString = function toString() {
                    return this.map(function(item) {
                        var content = cssWithMappingToString(item, useSourceMap);
                        if (item[2]) return '@media ' + item[2] + '{' + content + '}';
                        else return content;
                    }).join('');
                }; // import a list of modules into the list
                list.i = function(modules, mediaQuery) {
                    if (typeof modules === 'string') modules = [
                        [
                            null,
                            modules,
                            ''
                        ]
                    ];
                    var alreadyImportedModules = {};
                    for(var i = 0; i < this.length; i++){
                        var id = this[i][0];
                        if (id != null) alreadyImportedModules[id] = true;
                    }
                    for(i = 0; i < modules.length; i++){
                        var item = modules[i]; // skip already imported module
                        // this implementation is not 100% perfect for weird media query combinations
                        // when a module is imported multiple times with different media queries.
                        // I hope this will never occur (Hey this way we have smaller bundles)
                        if (item[0] == null || !alreadyImportedModules[item[0]]) {
                            if (mediaQuery && !item[2]) item[2] = mediaQuery;
                            else if (mediaQuery) item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
                            list.push(item);
                        }
                    }
                };
                return list;
            };
            function cssWithMappingToString(item, useSourceMap) {
                var content = item[1] || '';
                var cssMapping = item[3];
                if (!cssMapping) return content;
                if (useSourceMap && typeof btoa === 'function') {
                    var sourceMapping = toComment(cssMapping);
                    var sourceURLs = cssMapping.sources.map(function(source) {
                        return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
                    });
                    return [
                        content
                    ].concat(sourceURLs).concat([
                        sourceMapping
                    ]).join('\n');
                }
                return [
                    content
                ].join('\n');
            } // Adapted from convert-source-map (MIT)
            function toComment(sourceMap) {
                // eslint-disable-next-line no-undef
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
                var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
                return '/*# ' + data + ' */';
            }
        /***/ },
        /* 333 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function escape1(url, needQuotes) {
                if (typeof url !== 'string') return url;
                 // If url is already wrapped in quotes, remove them
                if (/^['"].*['"]$/.test(url)) url = url.slice(1, -1);
                 // Should url be wrapped?
                // See https://drafts.csswg.org/css-values-3/#urls
                if (/["'() \t\n]/.test(url) || needQuotes) return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
                return url;
            };
        /***/ },
        /* 334 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAA1VBMVEUAAAD3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj39/j3+Pj3+Pn4+Pk/JRMlAAAAQ3RSTlMABAUHCQoLDhAQERwdHiAjLjAxOD9ASFBRVl1mbnZ6fH2LjI+QkaWqrrC1uLzAwcXJycrL1NXj5Ofo6u3w9fr7/P3+d4M3+QAAAQBJREFUGBlVwYdCglAABdCLlr5Unijm3hMUtBzlBLSr//9JgUToOQgVJgceJgU8aHgMeA38K50ZOpcQmTPwcyXn+JM8M3JJIqQypiIkeXelTyIkGZPwKS1NMia1lgKTVkaE3oQQGYsmHNqSMWnTgUFbMiZtGlD2dpaxrL1XgM0i4ZK8MeAmFhsAs29MGZniawagS63oMOQUNXYB5D0D1RMDpyoMLw/fiE2og/V+PVDR5AiBl0/2Uwik+vx4xV3a5G5Ye68Nd1czjUjZckm6VhmPciRzeCZICjwTJAViQq+3e+St167rAoHK8sLYZVkBYPCZAZ/eGa+2R5LH7Wrc0YFf/O9J3yBDFaoAAAAASUVORK5CYII=";
        /***/ },
        /* 335 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAADcElEQVRIiaWVXWhcRRTHf7NNd2aDtUKMIjTpg4ufFIuiUOmDEWm0Vi3VYhXRqIggQh4sWJFSig9+oOhTKSpIRUWMIBIr2kptoTbgU6ooxCiIjR+14kcJmf9sNceHnd3ebnc3Uv9wuXfOzPzmnDMz5zozGwdWAbc65w5RUJQ8cC2wDJgFJioh/MJCMrNxq2vOzK4HmIvRRemxKP0RJWt53o7S+d2Yzsx6gQ+AIUDAnUqpBLzXZd4RYFUlhB/bdZacc3PAOmAcCMC7wfvFwLNdoAPAyx09bXyYWRl4E7gDmAdGlNKFwLYu8GolhO9O87RJd64GbMrgEvB68P4osMWdXLtVV7czlooNpVRWSs8DO7NpR/B+3rBHsvetCgtCMTxwQCm9BbyQrc8F7/uBex3uRCeXO0PrUZ4NfKyUPgWeyj3bg/crDNsIRGwBaJQGorQ3Svdn2wHgc2BUKb0DPJHtjwfvbwRucc7tz+N+i9LFUdoXpfVN36I0CVwBTFI/q9e1LPxT8P4qYEdu70q12mYzWw1MYQzjeJF6zq+shHC4B7jklOBPP/TzSunh4P0DwKvAfb5c9krpe+CcwsEoZdbhEvBM9wxRAl5RShcA9wAngE3B+8tLpdLuwrhp4MNmK0pfRWkySr7NXS8+L5nZbWZWy/Vin1IaitJnUTqvwevJ71lgSSWEFKUfHG7Q2m/xqFJaGry/GXgfGPLl8mJgrXPur2JoUC8Qy3OpG+sAbGhEKT0ErAWOA6uBPWbW1wr9BOgFbgKezot0kAPYqJQA1gC/A9cA+82svzksSn1R+jNKX0SpnM/e1x3yqig92JhrZivM7FjO8bSZLSuCR/Ok16K0KMNHojQWpYko7Y7S1igN5PE3ROl4lNaZ2UVmNpPBU01orvZvZPCeKFXbBR+lEKVtUapFaSZKg9njqpl9aWYTrmXCImA7sCWb9lK/jj9TrwkrgA1AH3AQuKsSwkzbrLfxpgpsBtYDxf/R3xm2ExirhNCuHHZXTsmRwiat+S/zSt06eysVA/4pmGr/G3qm6ik28v29FKgCg8BS6pvS0KNRGgZ+Bb4FpsxsOkfUlMuwDcBWYOUZOHYM2AU8WQmhBifDv70O7PjX7KZ+4G7g3FM8zd6uBIaBy4AqxnIcZwFLCovPAhE4Sj38b4BDwEeVEFKD9S94Khjn486v3QAAAABJRU5ErkJggg==";
        /***/ },
        /* 336 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABx0lEQVQ4jaWUv48NURiGn3ONmCs32ZBd28ht1gqyZAkF21ylQkEiSp2ehpDlD1BoFGqqVdJohYKI7MaPxMoVNghCWMF+7ybLUewnOXfcMWO9yeQ857zne8+XmZOBGjJpr0kvTIomvTZpS526UCO4DUwD64FjwCFgqZnnR+oc8LfgzKQ73vGsr42ZtGjSQFV9o8KfBCacZwCaef4YmAf2rzjcpN3A2WSpm/AssKcqPDNpDBjs410CViXzTwk/A7b1C4wxDgOngAsZcAXY2buDfp/6S4F3lDS8DjgBzDWAjX/Y/e/QgYS/AhsKHa+OMQ6GEJ4Cj4BOAxgq6aCowyZtdf4OtAr+FHDO+R4wWnVbihr3cQnICt4boO38GWj9a/icjwOACt4m4K3zEPA+AxaAtTWCnwN3lzHkEL8V/OPAGud9wK2GF9XR1Wae/1zG2AI+pGYI4VUIoRtjHAc2A9cz4LRPevYCZ+i9/4sJt4GXJU10gaPAzdI2TTro/5Tfz8XEe2LSZGmxq/SDNvP8BnA5WRrx4BwYBe6vONx1EnjovGvBLAAd4Adwuyq8UiaNmDTvr+a8SQ9MuvbfwckBHZPe+QEfTdpep+4XZmPBHiHgz74AAAAASUVORK5CYII=";
        /***/ },
        /* 337 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAACtklEQVQ4jZ2VSYiURxTHf+/T9Nc9iRrBuYySmIsXUU9iFMEFERRBvAjJLUQi5ioiHvSScfTmgqC4XAT1ZIgLuJHkICaaQAgKI2hAUBT30bjUq7bbv4eukXK029F3+eqtv/fqK6qQdEnSNUmT6CDB/bvgfjO4N9zj2RD8007xg1IABkwEzkma0qb4PGAPMBZYLtSD8eNwAEjqTlNI0gNJM4YU7w7ut4O7gvuhZFsR3C8NC5BBLiTIY0mzM8AvqbiC++pk+zLpE95XuwAws3vAQuBPYDRwWtL84P4tsDSLv5oaug4EYOawAMF9jMdoLxqNZcDvQA04UVYqL4G/svj7AF21mhJscrvCksYBFO7xc2AAGGg2mrdjvf4rcAyomNn+slLZmUEGBgsYdh945xZJmgvckDSrEJpK6ySBgV6q12O8ABwGPjGzfWWlsjdN9rpjoSfA+DYDXARGAksK4Is3XC1Ub4z1f4CDQGFmu6tleQSYk0U+p7WVeefLJc00s4fAeWB6Qeunvj0m2ugx9gO7kmlrtSxvBfcy6fXUZS6rgG/S+jLQUwCVNmMC9HqM14EtSe+rluWazN8YEv8IqKZ1E1qnaIDO0ucx3gX6kv6TpM3AM+D/IbGjgP60/gq4WQA33gMA2OQxPgHWJX1ttSwL4FAeZGYLgB2SasBs4A8L7qOBf9M0uXQB3a+TMYSmVctyDrA9mfcBK82smSdKWgCcAaa1bTm4fxbc/8uuCQX3RanAD5Ka6Wo5IGnE0HxJPZ03pQX5Org3MsD3AO5xXLPZXJ9BjkrqdFg6QjZkgG3Jtsw93pG0VFI9QU5K6voYQBHcTydAfwheBI9HgvvPAJIWS3qeIL9JGvUxkO7gfi1BrqTvwkG/pPmSnibIqTzXPgAyEVgBjAEu1qrVPbk/PVTHgb/NbPGg/RVIzOQqzSTBaQAAAABJRU5ErkJggg==";
        /***/ },
        /* 338 */ /***/ function(module1, exports) {
            module1.exports = "data:image/svg+xml;base64,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";
        /***/ },
        /* 339 */ /***/ function(module1, exports) {
            module1.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcxIDQ2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIwIiB4Mj0iMCIgeTE9IjAiIHkyPSIxIj48c3RvcCBvZmZzZXQ9IjY2LjY2JSIgc3RvcC1jb2xvcj0iI2ZmZiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJNNzkgMzA4YzE0LjI1LTYuNSA1NC4yNS0xOS43NSA3MS0yOSA5LTMuMjUgMjUtMjEgMjUtMjFzMy43NS0xMyAzLTIyYy0xLjc1LTYuNzUtMTUtNDMtMTUtNDMtMi41IDMtNC43NDEgMy4yNTktNyAxLTMuMjUtNy41LTIwLjUtNDQuNS0xNi01NyAxLjI1LTcuNSAxMC02IDEwLTYtMTEuMjUtMzMuNzUtOC02Ny04LTY3cy4wNzMtNy4zNDYgNi0xNWMtMy40OC42MzctOSA0LTkgNCAyLjU2My0xMS43MjcgMTUtMjEgMTUtMjEgLjE0OC0uMzEyLTEuMzIxLTEuNDU0LTEwIDEgMS41LTIuNzggMTYuNjc1LTguNjU0IDMwLTExIDMuNzg3LTkuMzYxIDEyLjc4Mi0xNy4zOTggMjItMjItMi4zNjUgMy4xMzMtMyA2LTMgNnMxNS42NDctOC4wODggNDEtNmMtMTkuNzUgMi0yNCA2LTI0IDZzNzQuNS0xMC43NSAxMDQgMzdjNy41IDkuNSAyNC43NSA1NS43NSAxMCA4OSAzLjc1LTEuNSA0LjUtNC41IDkgMSAuMjUgMTQuNzUtMTEuNSA2My0xOSA2Mi0yLjc1IDEtNC0zLTQtMy0xMC43NSAyOS41LTE0IDM4LTE0IDM4LTIgNC4yNS0zLjc1IDE4LjUtMSAyMiAxLjI1IDQuNSAyMyAyMyAyMyAyM2wxMjcgNTNjMzcgMzUgMjMgMTM1IDIzIDEzNUwwIDQ2NHMtMy05Ni43NSAxNC0xMjBjNS4yNS02LjI1IDIxLjc1LTE5Ljc1IDY1LTM2eiIvPjwvc3ZnPg==";
        /***/ },
        /* 340 */ /***/ function(module1, exports) {
            module1.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzkgODYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTkuNzU3IDQwLjkyNGMzLjczOC01LjE5MSAxMi43MTEtNC4zMDggMTIuNzExLTQuMzA4IDIuMjIzIDMuMDE0IDUuMTI2IDI0LjU4NiAzLjYyNCAyOC43MTgtMS40MDEgMS4zMDEtMTEuNjExIDEuNjI5LTEzLjM4LTEuNDM2LTEuMjI2LTguODA0LTIuOTU1LTIyLjk3NS0yLjk1NS0yMi45NzV6bTU4Ljc4NSAwYy0zLjczNy01LjE5MS0xMi43MTEtNC4zMDgtMTIuNzExLTQuMzA4LTIuMjIzIDMuMDE0LTUuMTI2IDI0LjU4Ni0zLjYyNCAyOC43MTggMS40MDEgMS4zMDEgMTEuNjExIDEuNjI5IDEzLjM4LTEuNDM2IDEuMjI2LTguODA0IDIuOTU1LTIyLjk3NSAyLjk1NS0yMi45NzV6Ii8+PHBhdGggZD0iTTY4LjY0NyA1OC42Yy43MjktNC43NTMgMi4zOC05LjU2MSAyLjM4LTE0LjgwNCAwLTIxLjQxMi0xNC4xMTUtMzguNzctMzEuNTI4LTM4Ljc3LTE3LjQxMiAwLTMxLjUyNyAxNy4zNTgtMzEuNTI3IDM4Ljc3IDAgNC41NDEuNTE1IDguOTM2IDEuODAyIDEyLjk1IDEuNjk4IDUuMjk1LTUuNTQyIDYuOTkxLTYuNjE2IDIuMDczQzIuNDEgNTUuMzk0IDAgNTEuNzg3IDAgNDguMTAzIDAgMjEuNTM2IDE3LjY4NSAwIDM5LjUgMCA2MS4zMTYgMCA3OSAyMS41MzYgNzkgNDguMTAzYzAgLjcxOC0yLjg5OSA5LjY5My0zLjI5MiAxMS40MDgtLjc1NCAzLjI5My03Ljc1MSAzLjU4OS03LjA2MS0uOTEyeiIvPjxwYXRoIGQ9Ik01LjA4NCA1MS4zODVjLS44MDQtMy43ODIuNTY5LTcuMzM1IDMuMTM0LTcuOTIxIDIuNjM2LS42MDMgNS40ODUgMi4xNSA2LjI4OSA2LjEzMi43OTcgMy45NDgtLjc1MiA3LjQ1Ny0zLjM4OCA3Ljg1OS0yLjU2Ni4zOTEtNS4yMzctMi4zMTgtNi4wMzQtNi4wN3ptNjguODM0IDBjLjgwNC0zLjc4Mi0uNTY4LTcuMzM1LTMuMTMzLTcuOTIxLTIuNjM2LS42MDMtNS40ODUgMi4xNS02LjI4OSA2LjEzMi0uNzk3IDMuOTQ4Ljc1MiA3LjQ1NyAzLjM4OSA3Ljg1OSAyLjU2NS4zOTEgNS4yMzctMi4zMTggNi4wMzQtNi4wN3ptLTIuMDM4IDguMjg4Yy0uOTI2IDE5LjY1OS0xNS4xMTIgMjQuNzU5LTI1Ljg1OSAyMC40NzUtNS40MDUtLjYwNi0zLjAzNCAxLjI2Mi0zLjAzNCAxLjI2MiAxMy42NjEgMy41NjIgMjYuMTY4IDMuNDk3IDMxLjI3My0yMC41NDktLjU4NS00LjUxMS0yLjM3OS0xLjE4Ny0yLjM3OS0xLjE4N3oiLz48cGF0aCBkPSJNNDEuNjYyIDc4LjQyMmw3LjU1My41NWMxLjE5Mi4xMDcgMi4xMiAxLjE1MyAyLjA3MiAyLjMzNWwtLjEwOSAyLjczOGMtLjA0NyAxLjE4Mi0xLjA1MSAyLjA1NC0yLjI0MyAxLjk0NmwtNy41NTMtLjU1Yy0xLjE5MS0uMTA3LTIuMTE5LTEuMTUzLTIuMDcyLTIuMzM1bC4xMDktMi43MzdjLjA0Ny0xLjE4MiAxLjA1Mi0yLjA1NCAyLjI0My0xLjk0N3oiLz48L2c+PC9zdmc+";
        /***/ },
        /* 341 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,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";
        /***/ },
        /* 342 */ /***/ function(module1, exports) {
            module1.exports = "data:image/png;base64,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";
        /***/ },
        /* 343 */ /***/ function(module1, exports) {
            module1.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUwIiBoZWlnaHQ9IjkwIj48ZGVmcz48cGF0aCBkPSJNNjcgMTJMNi40NDggNzIuNTUyIDAgMzFWMThMMjYgMGw0MSAxMnptMyA3bDYgNDctMjkgMTgtMzUuNTAyLTYuNDk4TDcwIDE5eiIgaWQ9ImEiLz48L2RlZnM+PHJlY3Qgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5MCIgcng9IjM1IiByeT0iNDUiIG9wYWNpdHk9Ii41Ii8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNikiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zOS4yNDkgNTEuMzEyYy42OTcgMTAuMzcgMi43ODUgMTcuODk3IDUuMjUxIDE3Ljg5NyAzLjAzOCAwIDUuNS0xMS40MTcgNS41LTI1LjVzLTIuNDYyLTI1LjUtNS41LTI1LjVjLTIuNTEgMC00LjYyOCA3Ljc5Ny01LjI4NyAxOC40NTNBOC45ODkgOC45ODkgMCAwMTQzIDQ0YTguOTg4IDguOTg4IDAgMDEtMy43NTEgNy4zMTJ6TTIwLjk4NSAzMi4yMjRsMTUuNzQ2LTE2Ljg3N2E3LjM4NSA3LjM4NSAwIDAxMTAuMzc0LS40MkM1MS43MDIgMTkuMTE0IDU0IDI5LjIwOCA1NCA0NS4yMDhjMCAxNC41MjctMi4zNDMgMjMuODgtNy4wMyAyOC4wNThhNy4yOCA3LjI4IDAgMDEtMTAuMTY4LS40NjhMMjAuNDA1IDU1LjIyNEgxMmE1IDUgMCAwMS01LTV2LTEzYTUgNSAwIDAxNS01aDguOTg1eiIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMTA2LjUgMTMuNUw0NC45OTggNzUuMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==";
        /***/ },
        /* 344 */ /***/ function(module1, exports) {
            module1.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMDE1IDVWNTguMThhNSA1IDAgMDEtNSA1SDkuMTFhNSA1IDAgMDEtNS01VjI1Ljk3YTUgNSAwIDAxNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwMTQuMzA0IDIuNzAydjI2LjgzNWEzIDMgMCAwMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==";
        /***/ },
        /* 345 */ /***/ function(module1, exports, __webpack_require__) {
            /*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ var stylesInDom = {};
            var memoize = function(fn) {
                var memo;
                return function() {
                    if (typeof memo === "undefined") memo = fn.apply(this, arguments);
                    return memo;
                };
            };
            var isOldIE = memoize(function() {
                // Test for IE <= 9 as proposed by Browserhacks
                // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
                // Tests for existence of standard globals is to allow style-loader
                // to operate correctly into non-standard environments
                // @see https://github.com/webpack-contrib/style-loader/issues/177
                return window && document && document.all && !window.atob;
            });
            var getTarget = function(target, parent) {
                if (parent) return parent.querySelector(target);
                return document.querySelector(target);
            };
            var getElement = function(fn) {
                var memo = {};
                return function(target, parent) {
                    // If passing function in options, then use it for resolve "head" element.
                    // Useful for Shadow Root style i.e
                    // {
                    //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                    // }
                    if (typeof target === 'function') return target();
                    if (typeof memo[target] === "undefined") {
                        var styleTarget = getTarget.call(this, target, parent);
                        // Special case to return head of iframe instead of iframe itself
                        if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) try {
                            // This will throw an exception if access to iframe is blocked
                            // due to cross-origin restrictions
                            styleTarget = styleTarget.contentDocument.head;
                        } catch (e) {
                            styleTarget = null;
                        }
                        memo[target] = styleTarget;
                    }
                    return memo[target];
                };
            }();
            var singleton = null;
            var singletonCounter = 0;
            var stylesInsertedAtTop = [];
            var fixUrls = __webpack_require__(346);
            module1.exports = function(list, options) {
                if (typeof DEBUG !== "undefined" && DEBUG) {
                    if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                }
                options = options || {};
                options.attrs = typeof options.attrs === "object" ? options.attrs : {};
                // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
                // tags it will allow on a page
                if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();
                // By default, add <style> tags to the <head> element
                if (!options.insertInto) options.insertInto = "head";
                // By default, add <style> tags to the bottom of the target
                if (!options.insertAt) options.insertAt = "bottom";
                var styles = listToStyles(list, options);
                addStylesToDom(styles, options);
                return function update(newList) {
                    var mayRemove = [];
                    for(var i = 0; i < styles.length; i++){
                        var item = styles[i];
                        var domStyle = stylesInDom[item.id];
                        domStyle.refs--;
                        mayRemove.push(domStyle);
                    }
                    if (newList) {
                        var newStyles = listToStyles(newList, options);
                        addStylesToDom(newStyles, options);
                    }
                    for(var i = 0; i < mayRemove.length; i++){
                        var domStyle = mayRemove[i];
                        if (domStyle.refs === 0) {
                            for(var j = 0; j < domStyle.parts.length; j++)domStyle.parts[j]();
                            delete stylesInDom[domStyle.id];
                        }
                    }
                };
            };
            function addStylesToDom(styles, options) {
                for(var i = 0; i < styles.length; i++){
                    var item = styles[i];
                    var domStyle = stylesInDom[item.id];
                    if (domStyle) {
                        domStyle.refs++;
                        for(var j = 0; j < domStyle.parts.length; j++)domStyle.parts[j](item.parts[j]);
                        for(; j < item.parts.length; j++)domStyle.parts.push(addStyle(item.parts[j], options));
                    } else {
                        var parts = [];
                        for(var j = 0; j < item.parts.length; j++)parts.push(addStyle(item.parts[j], options));
                        stylesInDom[item.id] = {
                            id: item.id,
                            refs: 1,
                            parts: parts
                        };
                    }
                }
            }
            function listToStyles(list, options) {
                var styles = [];
                var newStyles = {};
                for(var i = 0; i < list.length; i++){
                    var item = list[i];
                    var id = options.base ? item[0] + options.base : item[0];
                    var css = item[1];
                    var media = item[2];
                    var sourceMap = item[3];
                    var part = {
                        css: css,
                        media: media,
                        sourceMap: sourceMap
                    };
                    if (!newStyles[id]) styles.push(newStyles[id] = {
                        id: id,
                        parts: [
                            part
                        ]
                    });
                    else newStyles[id].parts.push(part);
                }
                return styles;
            }
            function insertStyleElement(options, style) {
                var target = getElement(options.insertInto);
                if (!target) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];
                if (options.insertAt === "top") {
                    if (!lastStyleElementInsertedAtTop) target.insertBefore(style, target.firstChild);
                    else if (lastStyleElementInsertedAtTop.nextSibling) target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
                    else target.appendChild(style);
                    stylesInsertedAtTop.push(style);
                } else if (options.insertAt === "bottom") target.appendChild(style);
                else if (typeof options.insertAt === "object" && options.insertAt.before) {
                    var nextSibling = getElement(options.insertAt.before, target);
                    target.insertBefore(style, nextSibling);
                } else throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
            }
            function removeStyleElement(style) {
                if (style.parentNode === null) return false;
                style.parentNode.removeChild(style);
                var idx = stylesInsertedAtTop.indexOf(style);
                if (idx >= 0) stylesInsertedAtTop.splice(idx, 1);
            }
            function createStyleElement(options) {
                var style = document.createElement("style");
                if (options.attrs.type === undefined) options.attrs.type = "text/css";
                if (options.attrs.nonce === undefined) {
                    var nonce = getNonce();
                    if (nonce) options.attrs.nonce = nonce;
                }
                addAttrs(style, options.attrs);
                insertStyleElement(options, style);
                return style;
            }
            function createLinkElement(options) {
                var link = document.createElement("link");
                if (options.attrs.type === undefined) options.attrs.type = "text/css";
                options.attrs.rel = "stylesheet";
                addAttrs(link, options.attrs);
                insertStyleElement(options, link);
                return link;
            }
            function addAttrs(el, attrs) {
                Object.keys(attrs).forEach(function(key) {
                    el.setAttribute(key, attrs[key]);
                });
            }
            function getNonce() {
                return __webpack_require__.nc;
            }
            function addStyle(obj, options) {
                var style, update, remove, result;
                // If a transform function was defined, run it on the css
                if (options.transform && obj.css) {
                    result = typeof options.transform === 'function' ? options.transform(obj.css) : options.transform.default(obj.css);
                    if (result) // If transform returns a value, use that instead of the original css.
                    // This allows running runtime transformations on the css.
                    obj.css = result;
                    else // If the transform function returns a falsy value, don't add this css.
                    // This allows conditional loading of css
                    return function() {
                    // noop
                    };
                }
                if (options.singleton) {
                    var styleIndex = singletonCounter++;
                    style = singleton || (singleton = createStyleElement(options));
                    update = applyToSingletonTag.bind(null, style, styleIndex, false);
                    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
                } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
                    style = createLinkElement(options);
                    update = updateLink.bind(null, style, options);
                    remove = function() {
                        removeStyleElement(style);
                        if (style.href) URL.revokeObjectURL(style.href);
                    };
                } else {
                    style = createStyleElement(options);
                    update = applyToTag.bind(null, style);
                    remove = function() {
                        removeStyleElement(style);
                    };
                }
                update(obj);
                return function updateStyle(newObj) {
                    if (newObj) {
                        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                        update(obj = newObj);
                    } else remove();
                };
            }
            var replaceText = function() {
                var textStore = [];
                return function(index, replacement) {
                    textStore[index] = replacement;
                    return textStore.filter(Boolean).join('\n');
                };
            }();
            function applyToSingletonTag(style, index, remove, obj) {
                var css = remove ? "" : obj.css;
                if (style.styleSheet) style.styleSheet.cssText = replaceText(index, css);
                else {
                    var cssNode = document.createTextNode(css);
                    var childNodes = style.childNodes;
                    if (childNodes[index]) style.removeChild(childNodes[index]);
                    if (childNodes.length) style.insertBefore(cssNode, childNodes[index]);
                    else style.appendChild(cssNode);
                }
            }
            function applyToTag(style, obj) {
                var css = obj.css;
                var media = obj.media;
                if (media) style.setAttribute("media", media);
                if (style.styleSheet) style.styleSheet.cssText = css;
                else {
                    while(style.firstChild)style.removeChild(style.firstChild);
                    style.appendChild(document.createTextNode(css));
                }
            }
            function updateLink(link, options, obj) {
                var css = obj.css;
                var sourceMap = obj.sourceMap;
                /*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/ var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
                if (options.convertToAbsoluteUrls || autoFixUrls) css = fixUrls(css);
                if (sourceMap) // http://stackoverflow.com/a/26603875
                css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
                var blob = new Blob([
                    css
                ], {
                    type: "text/css"
                });
                var oldSrc = link.href;
                link.href = URL.createObjectURL(blob);
                if (oldSrc) URL.revokeObjectURL(oldSrc);
            }
        /***/ },
        /* 346 */ /***/ function(module1, exports) {
            /**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */ module1.exports = function(css) {
                // get current location
                var location1 = typeof window !== "undefined" && window.location;
                if (!location1) throw new Error("fixUrls requires window.location");
                // blank or null?
                if (!css || typeof css !== "string") return css;
                var baseUrl = location1.protocol + "//" + location1.host;
                var currentDir = baseUrl + location1.pathname.replace(/\/[^\/]*$/, "/");
                // convert each url(...)
                /*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */ var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
                    // strip quotes (if they exist)
                    var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function(o, $1) {
                        return $1;
                    }).replace(/^'(.*)'$/, function(o, $1) {
                        return $1;
                    });
                    // already a full url? no change
                    if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) return fullMatch;
                    // convert the url to a full url
                    var newUrl;
                    if (unquotedOrigUrl.indexOf("//") === 0) //TODO: should we add protocol?
                    newUrl = unquotedOrigUrl;
                    else if (unquotedOrigUrl.indexOf("/") === 0) // path should be relative to the base url
                    newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
                    else // path should be relative to current directory
                    newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
                    // send back the fixed url(...)
                    return "url(" + JSON.stringify(newUrl) + ")";
                });
                // send back the fixed css
                return fixedCss;
            };
        /***/ },
        /* 347 */ /***/ function(module1, exports) {
            /**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
            }
            module1.exports = listCacheClear;
        /***/ },
        /* 348 */ /***/ function(module1, exports, __webpack_require__) {
            var assocIndexOf = __webpack_require__(81);
            /** Used for built-in method references. */ var arrayProto = Array.prototype;
            /** Built-in value references. */ var splice = arrayProto.splice;
            /**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) return false;
                var lastIndex = data.length - 1;
                if (index == lastIndex) data.pop();
                else splice.call(data, index, 1);
                --this.size;
                return true;
            }
            module1.exports = listCacheDelete;
        /***/ },
        /* 349 */ /***/ function(module1, exports, __webpack_require__) {
            var assocIndexOf = __webpack_require__(81);
            /**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            module1.exports = listCacheGet;
        /***/ },
        /* 350 */ /***/ function(module1, exports, __webpack_require__) {
            var assocIndexOf = __webpack_require__(81);
            /**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            module1.exports = listCacheHas;
        /***/ },
        /* 351 */ /***/ function(module1, exports, __webpack_require__) {
            var assocIndexOf = __webpack_require__(81);
            /**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    ++this.size;
                    data.push([
                        key,
                        value
                    ]);
                } else data[index][1] = value;
                return this;
            }
            module1.exports = listCacheSet;
        /***/ },
        /* 352 */ /***/ function(module1, exports, __webpack_require__) {
            var ListCache = __webpack_require__(80);
            /**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
                this.__data__ = new ListCache;
                this.size = 0;
            }
            module1.exports = stackClear;
        /***/ },
        /* 353 */ /***/ function(module1, exports) {
            /**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
                var data = this.__data__, result = data['delete'](key);
                this.size = data.size;
                return result;
            }
            module1.exports = stackDelete;
        /***/ },
        /* 354 */ /***/ function(module1, exports) {
            /**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
                return this.__data__.get(key);
            }
            module1.exports = stackGet;
        /***/ },
        /* 355 */ /***/ function(module1, exports) {
            /**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
                return this.__data__.has(key);
            }
            module1.exports = stackHas;
        /***/ },
        /* 356 */ /***/ function(module1, exports, __webpack_require__) {
            var ListCache = __webpack_require__(80), Map1 = __webpack_require__(109), MapCache = __webpack_require__(110);
            /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
            /**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
                var data = this.__data__;
                if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
                        pairs.push([
                            key,
                            value
                        ]);
                        this.size = ++data.size;
                        return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                }
                data.set(key, value);
                this.size = data.size;
                return this;
            }
            module1.exports = stackSet;
        /***/ },
        /* 357 */ /***/ function(module1, exports, __webpack_require__) {
            var isFunction = __webpack_require__(17), isMasked = __webpack_require__(360), isObject = __webpack_require__(11), toSource = __webpack_require__(175);
            /**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
            /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
            /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
            /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            /**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) return false;
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            module1.exports = baseIsNative;
        /***/ },
        /* 358 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
            /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
            /**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
                var isOwn = hasOwnProperty1.call(value, symToStringTag), tag = value[symToStringTag];
                try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                } catch (e) {}
                var result = nativeObjectToString.call(value);
                if (unmasked) {
                    if (isOwn) value[symToStringTag] = tag;
                    else delete value[symToStringTag];
                }
                return result;
            }
            module1.exports = getRawTag;
        /***/ },
        /* 359 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
            /**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            module1.exports = objectToString;
        /***/ },
        /* 360 */ /***/ function(module1, exports, __webpack_require__) {
            var coreJsData = __webpack_require__(361);
            /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            /**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            module1.exports = isMasked;
        /***/ },
        /* 361 */ /***/ function(module1, exports, __webpack_require__) {
            var root = __webpack_require__(14);
            /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
            module1.exports = coreJsData;
        /***/ },
        /* 362 */ /***/ function(module1, exports) {
            /**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
                return object == null ? undefined : object[key];
            }
            module1.exports = getValue;
        /***/ },
        /* 363 */ /***/ function(module1, exports, __webpack_require__) {
            var Hash = __webpack_require__(364), ListCache = __webpack_require__(80), Map1 = __webpack_require__(109);
            /**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                    'hash': new Hash,
                    'map': new (Map1 || ListCache),
                    'string': new Hash
                };
            }
            module1.exports = mapCacheClear;
        /***/ },
        /* 364 */ /***/ function(module1, exports, __webpack_require__) {
            var hashClear = __webpack_require__(365), hashDelete = __webpack_require__(366), hashGet = __webpack_require__(367), hashHas = __webpack_require__(368), hashSet = __webpack_require__(369);
            /**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            // Add methods to `Hash`.
            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            module1.exports = Hash;
        /***/ },
        /* 365 */ /***/ function(module1, exports, __webpack_require__) {
            var nativeCreate = __webpack_require__(82);
            /**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
            }
            module1.exports = hashClear;
        /***/ },
        /* 366 */ /***/ function(module1, exports) {
            /**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
            }
            module1.exports = hashDelete;
        /***/ },
        /* 367 */ /***/ function(module1, exports, __webpack_require__) {
            var nativeCreate = __webpack_require__(82);
            /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty1.call(data, key) ? data[key] : undefined;
            }
            module1.exports = hashGet;
        /***/ },
        /* 368 */ /***/ function(module1, exports, __webpack_require__) {
            var nativeCreate = __webpack_require__(82);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty1.call(data, key);
            }
            module1.exports = hashHas;
        /***/ },
        /* 369 */ /***/ function(module1, exports, __webpack_require__) {
            var nativeCreate = __webpack_require__(82);
            /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
            /**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            module1.exports = hashSet;
        /***/ },
        /* 370 */ /***/ function(module1, exports, __webpack_require__) {
            var getMapData = __webpack_require__(83);
            /**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
            }
            module1.exports = mapCacheDelete;
        /***/ },
        /* 371 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
                var type = typeof value;
                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            module1.exports = isKeyable;
        /***/ },
        /* 372 */ /***/ function(module1, exports, __webpack_require__) {
            var getMapData = __webpack_require__(83);
            /**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            module1.exports = mapCacheGet;
        /***/ },
        /* 373 */ /***/ function(module1, exports, __webpack_require__) {
            var getMapData = __webpack_require__(83);
            /**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            module1.exports = mapCacheHas;
        /***/ },
        /* 374 */ /***/ function(module1, exports, __webpack_require__) {
            var getMapData = __webpack_require__(83);
            /**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
                var data = getMapData(this, key), size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
            }
            module1.exports = mapCacheSet;
        /***/ },
        /* 375 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
                var index = -1, result = Array(n);
                while(++index < n)result[index] = iteratee(index);
                return result;
            }
            module1.exports = baseTimes;
        /***/ },
        /* 376 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var argsTag = '[object Arguments]';
            /**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            module1.exports = baseIsArguments;
        /***/ },
        /* 377 */ /***/ function(module1, exports) {
            /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
                return false;
            }
            module1.exports = stubFalse;
        /***/ },
        /* 378 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isLength = __webpack_require__(112), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
            var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
            /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
            typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
            typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
            /**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            module1.exports = baseIsTypedArray;
        /***/ },
        /* 379 */ /***/ function(module1, exports, __webpack_require__) {
            var overArg = __webpack_require__(179);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
            module1.exports = nativeKeys;
        /***/ },
        /* 380 */ /***/ function(module1, exports, __webpack_require__) {
            var copyObject = __webpack_require__(41), keysIn = __webpack_require__(55);
            /**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
            }
            module1.exports = baseAssignIn;
        /***/ },
        /* 381 */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(11), isPrototype = __webpack_require__(69), nativeKeysIn = __webpack_require__(382);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
                if (!isObject(object)) return nativeKeysIn(object);
                var isProto = isPrototype(object), result = [];
                for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty1.call(object, key)))) result.push(key);
                return result;
            }
            module1.exports = baseKeysIn;
        /***/ },
        /* 382 */ /***/ function(module1, exports) {
            /**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
                var result = [];
                if (object != null) for(var key in Object(object))result.push(key);
                return result;
            }
            module1.exports = nativeKeysIn;
        /***/ },
        /* 383 */ /***/ function(module1, exports, __webpack_require__) {
            var copyObject = __webpack_require__(41), getSymbols = __webpack_require__(115);
            /**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
            }
            module1.exports = copySymbols;
        /***/ },
        /* 384 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
                var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (predicate(value, index, array)) result[resIndex++] = value;
                }
                return result;
            }
            module1.exports = arrayFilter;
        /***/ },
        /* 385 */ /***/ function(module1, exports, __webpack_require__) {
            var copyObject = __webpack_require__(41), getSymbolsIn = __webpack_require__(182);
            /**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
            }
            module1.exports = copySymbolsIn;
        /***/ },
        /* 386 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39), root = __webpack_require__(14);
            /* Built-in method references that are verified to be native. */ var DataView1 = getNative(root, 'DataView');
            module1.exports = DataView1;
        /***/ },
        /* 387 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39), root = __webpack_require__(14);
            /* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
            module1.exports = Promise;
        /***/ },
        /* 388 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
                var length = array.length, result = new array.constructor(length);
                // Add properties assigned by `RegExp#exec`.
                if (length && typeof array[0] == 'string' && hasOwnProperty1.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                }
                return result;
            }
            module1.exports = initCloneArray;
        /***/ },
        /* 389 */ /***/ function(module1, exports, __webpack_require__) {
            var cloneArrayBuffer = __webpack_require__(118), cloneDataView = __webpack_require__(390), cloneRegExp = __webpack_require__(391), cloneSymbol = __webpack_require__(392), cloneTypedArray = __webpack_require__(189);
            /** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
            var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
            /**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;
                switch(tag){
                    case arrayBufferTag:
                        return cloneArrayBuffer(object);
                    case boolTag:
                    case dateTag:
                        return new Ctor(+object);
                    case dataViewTag:
                        return cloneDataView(object, isDeep);
                    case float32Tag:
                    case float64Tag:
                    case int8Tag:
                    case int16Tag:
                    case int32Tag:
                    case uint8Tag:
                    case uint8ClampedTag:
                    case uint16Tag:
                    case uint32Tag:
                        return cloneTypedArray(object, isDeep);
                    case mapTag:
                        return new Ctor;
                    case numberTag:
                    case stringTag:
                        return new Ctor(object);
                    case regexpTag:
                        return cloneRegExp(object);
                    case setTag:
                        return new Ctor;
                    case symbolTag:
                        return cloneSymbol(object);
                }
            }
            module1.exports = initCloneByTag;
        /***/ },
        /* 390 */ /***/ function(module1, exports, __webpack_require__) {
            var cloneArrayBuffer = __webpack_require__(118);
            /**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            module1.exports = cloneDataView;
        /***/ },
        /* 391 */ /***/ function(module1, exports) {
            /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
            /**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
            }
            module1.exports = cloneRegExp;
        /***/ },
        /* 392 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40);
            /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
            /**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
                return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
            }
            module1.exports = cloneSymbol;
        /***/ },
        /* 393 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsMap = __webpack_require__(394), baseUnary = __webpack_require__(68), nodeUtil = __webpack_require__(113);
            /* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
            /**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            module1.exports = isMap;
        /***/ },
        /* 394 */ /***/ function(module1, exports, __webpack_require__) {
            var getTag = __webpack_require__(42), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var mapTag = '[object Map]';
            /**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
            }
            module1.exports = baseIsMap;
        /***/ },
        /* 395 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsSet = __webpack_require__(396), baseUnary = __webpack_require__(68), nodeUtil = __webpack_require__(113);
            /* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
            /**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            module1.exports = isSet;
        /***/ },
        /* 396 */ /***/ function(module1, exports, __webpack_require__) {
            var getTag = __webpack_require__(42), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var setTag = '[object Set]';
            /**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
            }
            module1.exports = baseIsSet;
        /***/ },
        /* 397 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(process) {
                exports.log = log;
                exports.formatArgs = formatArgs;
                exports.save = save;
                exports.load = load;
                exports.useColors = useColors;
                exports.storage = localstorage();
                /**
 * Colors.
 */ exports.colors = [
                    '#0000CC',
                    '#0000FF',
                    '#0033CC',
                    '#0033FF',
                    '#0066CC',
                    '#0066FF',
                    '#0099CC',
                    '#0099FF',
                    '#00CC00',
                    '#00CC33',
                    '#00CC66',
                    '#00CC99',
                    '#00CCCC',
                    '#00CCFF',
                    '#3300CC',
                    '#3300FF',
                    '#3333CC',
                    '#3333FF',
                    '#3366CC',
                    '#3366FF',
                    '#3399CC',
                    '#3399FF',
                    '#33CC00',
                    '#33CC33',
                    '#33CC66',
                    '#33CC99',
                    '#33CCCC',
                    '#33CCFF',
                    '#6600CC',
                    '#6600FF',
                    '#6633CC',
                    '#6633FF',
                    '#66CC00',
                    '#66CC33',
                    '#9900CC',
                    '#9900FF',
                    '#9933CC',
                    '#9933FF',
                    '#99CC00',
                    '#99CC33',
                    '#CC0000',
                    '#CC0033',
                    '#CC0066',
                    '#CC0099',
                    '#CC00CC',
                    '#CC00FF',
                    '#CC3300',
                    '#CC3333',
                    '#CC3366',
                    '#CC3399',
                    '#CC33CC',
                    '#CC33FF',
                    '#CC6600',
                    '#CC6633',
                    '#CC9900',
                    '#CC9933',
                    '#CCCC00',
                    '#CCCC33',
                    '#FF0000',
                    '#FF0033',
                    '#FF0066',
                    '#FF0099',
                    '#FF00CC',
                    '#FF00FF',
                    '#FF3300',
                    '#FF3333',
                    '#FF3366',
                    '#FF3399',
                    '#FF33CC',
                    '#FF33FF',
                    '#FF6600',
                    '#FF6633',
                    '#FF9900',
                    '#FF9933',
                    '#FFCC00',
                    '#FFCC33'
                ];
                /**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 */ function useColors() {
                    // NB: In an Electron preload script, document will be defined but not fully
                    // initialized. Since we know we're in Chrome, we'll just detect this case
                    // explicitly
                    var useColorsOption = getOption('colors');
                    if (/^(no|off|false|disabled)$/i.test(useColorsOption)) return false;
                    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
                    // Internet Explorer and Edge do not support colors.
                    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
                    // is webkit? http://stackoverflow.com/a/16459606/376773
                    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
                    return Boolean(typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
                    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
                    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
                    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
                    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
                }
                /**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
                    var useColors = this.useColors;
                    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + module1.exports.humanize(this.diff);
                    if (!useColors) return;
                    var c = 'color: ' + this.color;
                    args.splice(1, 0, c, 'color: inherit');
                    // the final "%c" is somewhat tricky, because there could be other
                    // arguments passed either before or after the %c, so we need to
                    // figure out the correct index to insert the CSS into
                    var index = 0;
                    var lastC = 0;
                    args[0].replace(/%[a-zA-Z%]/g, function(match) {
                        if ('%%' === match) return;
                        index++;
                        if ('%c' === match) // we only are interested in the *last* %c
                        // (the user may have provided their own)
                        lastC = index;
                    });
                    args.splice(lastC, 0, c);
                }
                /**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
                    // this hackery is required for IE8/9, where
                    // the `console.log` function doesn't have 'apply'
                    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
                }
                /**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
                    try {
                        if (null == namespaces) exports.storage.removeItem('debug');
                        else exports.storage.setItem('debug', namespaces);
                    } catch (e) {}
                }
                /**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
                    var r;
                    try {
                        r = exports.storage.getItem('debug');
                    } catch (e) {}
                    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
                    if (!r && typeof process !== 'undefined' && 'env' in process) r = process.env.DEBUG;
                    return r;
                }
                function getOption(key) {
                    var storageKey = 'debug_' + key.toLowerCase();
                    try {
                        return exports.storage.getItem(storageKey);
                    } catch (err) {
                        if (typeof process !== 'undefined' && 'env' in process) return process.env[storageKey.toUpperCase()];
                        return undefined;
                    }
                }
                /**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
                    try {
                        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
                        // The Browser also has localStorage in the global context.
                        return localStorage;
                    } catch (e) {}
                }
                module1.exports = __webpack_require__(398)(exports);
                var formatters = module1.exports.formatters;
                /**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
                    try {
                        return JSON.stringify(v);
                    } catch (err) {
                        return '[UnexpectedJSONParseError]: ' + err.message;
                    }
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(43));
        /***/ },
        /* 398 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ module1.exports = function setup(env) {
                createDebug.debug = createDebug['default'] = createDebug;
                createDebug.coerce = coerce;
                createDebug.disable = disable;
                createDebug.enable = enable;
                createDebug.enabled = enabled;
                createDebug.humanize = __webpack_require__(399);
                Object.keys(env).forEach(function(key) {
                    createDebug[key] = env[key];
                });
                /**
   * Active `debug` instances.
   */ createDebug.instances = [];
                /**
   * The currently active debug mode names, and names to skip.
   */ createDebug.names = [];
                createDebug.skips = [];
                /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */ createDebug.formatters = {};
                /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */ function selectColor(namespace) {
                    var hash = 0, i;
                    for(i in namespace){
                        hash = (hash << 5) - hash + namespace.charCodeAt(i);
                        hash |= 0; // Convert to 32bit integer
                    }
                    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
                }
                createDebug.selectColor = selectColor;
                /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */ function createDebug(namespace) {
                    var prevTime;
                    function debug() {
                        // disabled?
                        if (!debug.enabled) return;
                        var self1 = debug;
                        // set `diff` timestamp
                        var curr = +new Date();
                        var ms = curr - (prevTime || curr);
                        self1.diff = ms;
                        self1.prev = prevTime;
                        self1.curr = curr;
                        prevTime = curr;
                        // turn the `arguments` into a proper Array
                        var args = new Array(arguments.length);
                        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                        args[0] = createDebug.coerce(args[0]);
                        if ('string' !== typeof args[0]) // anything else let's inspect with %O
                        args.unshift('%O');
                        // apply any `formatters` transformations
                        var index = 0;
                        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
                            // if we encounter an escaped % then don't increase the array index
                            if (match === '%%') return match;
                            index++;
                            var formatter = createDebug.formatters[format];
                            if ('function' === typeof formatter) {
                                var val = args[index];
                                match = formatter.call(self1, val);
                                // now we need to remove `args[index]` since it's inlined in the `format`
                                args.splice(index, 1);
                                index--;
                            }
                            return match;
                        });
                        // apply env-specific formatting (colors, etc.)
                        createDebug.formatArgs.call(self1, args);
                        var logFn = self1.log || createDebug.log;
                        logFn.apply(self1, args);
                    }
                    debug.namespace = namespace;
                    debug.enabled = createDebug.enabled(namespace);
                    debug.useColors = createDebug.useColors();
                    debug.color = selectColor(namespace);
                    debug.destroy = destroy;
                    //debug.formatArgs = formatArgs;
                    //debug.rawLog = rawLog;
                    // env-specific initialization logic for debug instances
                    if ('function' === typeof createDebug.init) createDebug.init(debug);
                    createDebug.instances.push(debug);
                    return debug;
                }
                function destroy() {
                    var index = createDebug.instances.indexOf(this);
                    if (index !== -1) {
                        createDebug.instances.splice(index, 1);
                        return true;
                    } else return false;
                }
                /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */ function enable(namespaces) {
                    createDebug.save(namespaces);
                    createDebug.names = [];
                    createDebug.skips = [];
                    var i;
                    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
                    var len = split.length;
                    for(i = 0; i < len; i++){
                        if (!split[i]) continue; // ignore empty strings
                        namespaces = split[i].replace(/\*/g, '.*?');
                        if (namespaces[0] === '-') createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
                        else createDebug.names.push(new RegExp('^' + namespaces + '$'));
                    }
                    for(i = 0; i < createDebug.instances.length; i++){
                        var instance = createDebug.instances[i];
                        instance.enabled = createDebug.enabled(instance.namespace);
                    }
                }
                /**
   * Disable debug output.
   *
   * @api public
   */ function disable() {
                    createDebug.enable('');
                }
                /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */ function enabled(name) {
                    if (name[name.length - 1] === '*') return true;
                    var i, len;
                    for(i = 0, len = createDebug.skips.length; i < len; i++){
                        if (createDebug.skips[i].test(name)) return false;
                    }
                    for(i = 0, len = createDebug.names.length; i < len; i++){
                        if (createDebug.names[i].test(name)) return true;
                    }
                    return false;
                }
                /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */ function coerce(val) {
                    if (val instanceof Error) return val.stack || val.message;
                    return val;
                }
                createDebug.enable(createDebug.load());
                return createDebug;
            };
        /***/ },
        /* 399 */ /***/ function(module1, exports) {
            /**
 * Helpers.
 */ var s = 1000;
            var m = s * 60;
            var h = m * 60;
            var d = h * 24;
            var w = d * 7;
            var y = d * 365.25;
            /**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module1.exports = function(val, options) {
                options = options || {};
                var type = typeof val;
                if (type === 'string' && val.length > 0) return parse(val);
                else if (type === 'number' && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
                throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
            };
            /**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function parse(str) {
                str = String(str);
                if (str.length > 100) return;
                var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
                if (!match) return;
                var n = parseFloat(match[1]);
                var type = (match[2] || 'ms').toLowerCase();
                switch(type){
                    case 'years':
                    case 'year':
                    case 'yrs':
                    case 'yr':
                    case 'y':
                        return n * y;
                    case 'weeks':
                    case 'week':
                    case 'w':
                        return n * w;
                    case 'days':
                    case 'day':
                    case 'd':
                        return n * d;
                    case 'hours':
                    case 'hour':
                    case 'hrs':
                    case 'hr':
                    case 'h':
                        return n * h;
                    case 'minutes':
                    case 'minute':
                    case 'mins':
                    case 'min':
                    case 'm':
                        return n * m;
                    case 'seconds':
                    case 'second':
                    case 'secs':
                    case 'sec':
                    case 's':
                        return n * s;
                    case 'milliseconds':
                    case 'millisecond':
                    case 'msecs':
                    case 'msec':
                    case 'ms':
                        return n;
                    default:
                        return undefined;
                }
            }
            /**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtShort(ms) {
                var msAbs = Math.abs(ms);
                if (msAbs >= d) return Math.round(ms / d) + 'd';
                if (msAbs >= h) return Math.round(ms / h) + 'h';
                if (msAbs >= m) return Math.round(ms / m) + 'm';
                if (msAbs >= s) return Math.round(ms / s) + 's';
                return ms + 'ms';
            }
            /**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtLong(ms) {
                var msAbs = Math.abs(ms);
                if (msAbs >= d) return plural(ms, msAbs, d, 'day');
                if (msAbs >= h) return plural(ms, msAbs, h, 'hour');
                if (msAbs >= m) return plural(ms, msAbs, m, 'minute');
                if (msAbs >= s) return plural(ms, msAbs, s, 'second');
                return ms + ' ms';
            }
            /**
 * Pluralization helper.
 */ function plural(ms, msAbs, n, name) {
                var isPlural = msAbs >= n * 1.5;
                return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
            }
        /***/ },
        /* 400 */ /***/ function(module1, exports, __webpack_require__) {
            var constant = __webpack_require__(401), defineProperty = __webpack_require__(176), identity = __webpack_require__(89);
            /**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
                return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                });
            };
            module1.exports = baseSetToString;
        /***/ },
        /* 401 */ /***/ function(module1, exports) {
            /**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
                return function() {
                    return value;
                };
            }
            module1.exports = constant;
        /***/ },
        /* 402 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const WeakMap1 = __webpack_require__(195);
            const contexts = new WeakMap1();
            /**
 * This method needs to memoize fns with their context, this is
 * so that calls to off will have the same identity to the calls
 * to on.
 * @param {function} fn
 * @param {object} context
 */ function weakMemoizeBind(fn, context) {
                if (context === undefined) return fn;
                if (!contexts.has(context)) contexts.set(context, new WeakMap1());
                const fnMap = contexts.get(context);
                if (!fnMap.has(fn)) fnMap.set(fn, fn.bind(context));
                return fnMap.get(fn);
            }
            module1.exports = weakMemoizeBind;
        /***/ },
        /* 403 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                var weakMap, obj;
                if (typeof WeakMap !== "function") return false;
                try {
                    // WebKit doesn't support arguments and crashes
                    weakMap = new WeakMap([
                        [
                            obj = {},
                            "one"
                        ],
                        [
                            {},
                            "two"
                        ],
                        [
                            {},
                            "three"
                        ]
                    ]);
                } catch (e) {
                    return false;
                }
                if (String(weakMap) !== "[object WeakMap]") return false;
                if (typeof weakMap.set !== "function") return false;
                if (weakMap.set({}, 1) !== weakMap) return false;
                if (typeof weakMap.delete !== "function") return false;
                if (typeof weakMap.has !== "function") return false;
                if (weakMap.get(obj) !== "one") return false;
                return true;
            };
        /***/ },
        /* 404 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(44), setPrototypeOf = __webpack_require__(123), object = __webpack_require__(407), ensureValue = __webpack_require__(32), randomUniq = __webpack_require__(408), d = __webpack_require__(33), getIterator = __webpack_require__(202), forOf = __webpack_require__(450), toStringTagSymbol = __webpack_require__(45).toStringTag, isNative = __webpack_require__(451), isArray = Array.isArray, defineProperty = Object.defineProperty, objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf, WeakMapPoly;
            module1.exports = WeakMapPoly = function() {
                var iterable = arguments[0], self1;
                if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
                self1 = isNative && setPrototypeOf && WeakMap !== WeakMapPoly ? setPrototypeOf(new WeakMap(), getPrototypeOf(this)) : this;
                if (isValue(iterable)) {
                    if (!isArray(iterable)) iterable = getIterator(iterable);
                }
                defineProperty(self1, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
                if (!iterable) return self1;
                forOf(iterable, function(val) {
                    ensureValue(val);
                    self1.set(val[0], val[1]);
                });
                return self1;
            };
            if (isNative) {
                if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
                WeakMapPoly.prototype = Object.create(WeakMap.prototype, {
                    constructor: d(WeakMapPoly)
                });
            }
            Object.defineProperties(WeakMapPoly.prototype, {
                delete: d(function(key) {
                    if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
                        delete key[this.__weakMapData__];
                        return true;
                    }
                    return false;
                }),
                get: d(function(key) {
                    if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
                    return key[this.__weakMapData__];
                }),
                has: d(function(key) {
                    return objHasOwnProperty.call(object(key), this.__weakMapData__);
                }),
                set: d(function(key, value) {
                    defineProperty(object(key), this.__weakMapData__, d("c", value));
                    return this;
                }),
                toString: d(function() {
                    return "[object WeakMap]";
                })
            });
            defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));
        /***/ },
        /* 405 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // eslint-disable-next-line no-empty-function
            module1.exports = function() {};
        /***/ },
        /* 406 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Workaround for http://code.google.com/p/v8/issues/detail?id=2804
            var create = Object.create, shim;
            if (!__webpack_require__(196)()) shim = __webpack_require__(197);
            module1.exports = function() {
                var nullObject, polyProps, desc;
                if (!shim) return create;
                if (shim.level !== 1) return create;
                nullObject = {};
                polyProps = {};
                desc = {
                    configurable: false,
                    enumerable: false,
                    writable: true,
                    value: undefined
                };
                Object.getOwnPropertyNames(Object.prototype).forEach(function(name) {
                    if (name === "__proto__") {
                        polyProps[name] = {
                            configurable: true,
                            enumerable: false,
                            writable: true,
                            value: undefined
                        };
                        return;
                    }
                    polyProps[name] = desc;
                });
                Object.defineProperties(nullObject, polyProps);
                Object.defineProperty(shim, "nullPolyfill", {
                    configurable: false,
                    enumerable: false,
                    writable: false,
                    value: nullObject
                });
                return function(prototype, props) {
                    return create(prototype === null ? nullObject : prototype, props);
                };
            }();
        /***/ },
        /* 407 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isObject = __webpack_require__(198);
            module1.exports = function(value) {
                if (!isObject(value)) throw new TypeError(value + " is not an Object");
                return value;
            };
        /***/ },
        /* 408 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var generated = Object.create(null), random = Math.random;
            module1.exports = function() {
                var str;
                do str = random().toString(36).slice(2);
                while (generated[str]);
                return str;
            };
        /***/ },
        /* 409 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isPrototype = __webpack_require__(410);
            module1.exports = function(value) {
                if (typeof value !== "function") return false;
                if (!hasOwnProperty.call(value, "length")) return false;
                try {
                    if (typeof value.length !== "number") return false;
                    if (typeof value.call !== "function") return false;
                    if (typeof value.apply !== "function") return false;
                } catch (error) {
                    return false;
                }
                return !isPrototype(value);
            };
        /***/ },
        /* 410 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isObject = __webpack_require__(124);
            module1.exports = function(value) {
                if (!isObject(value)) return false;
                try {
                    if (!value.constructor) return false;
                    return value.constructor.prototype === value;
                } catch (error) {
                    return false;
                }
            };
        /***/ },
        /* 411 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                var assign = Object.assign, obj;
                if (typeof assign !== "function") return false;
                obj = {
                    foo: "raz"
                };
                assign(obj, {
                    bar: "dwa"
                }, {
                    trzy: "trzy"
                });
                return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
            };
        /***/ },
        /* 412 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var keys = __webpack_require__(413), value = __webpack_require__(32), max = Math.max;
            module1.exports = function(dest, src /*, …srcn*/ ) {
                var error, i, length = max(arguments.length, 2), assign;
                dest = Object(value(dest));
                assign = function(key) {
                    try {
                        dest[key] = src[key];
                    } catch (e) {
                        if (!error) error = e;
                    }
                };
                for(i = 1; i < length; ++i){
                    src = arguments[i];
                    keys(src).forEach(assign);
                }
                if (error !== undefined) throw error;
                return dest;
            };
        /***/ },
        /* 413 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(414)() ? Object.keys : __webpack_require__(415);
        /***/ },
        /* 414 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                try {
                    Object.keys("primitive");
                    return true;
                } catch (e) {
                    return false;
                }
            };
        /***/ },
        /* 415 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(44);
            var keys = Object.keys;
            module1.exports = function(object) {
                return keys(isValue(object) ? Object(object) : object);
            };
        /***/ },
        /* 416 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var str = "razdwatrzy";
            module1.exports = function() {
                if (typeof str.contains !== "function") return false;
                return str.contains("dwa") === true && str.contains("foo") === false;
            };
        /***/ },
        /* 417 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var indexOf = String.prototype.indexOf;
            module1.exports = function(searchString /*, position*/ ) {
                return indexOf.call(this, searchString, arguments[1]) > -1;
            };
        /***/ },
        /* 418 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var setPrototypeOf = __webpack_require__(123), contains = __webpack_require__(201), d = __webpack_require__(33), Symbol1 = __webpack_require__(45), Iterator = __webpack_require__(204);
            var defineProperty = Object.defineProperty, ArrayIterator;
            ArrayIterator = module1.exports = function(arr, kind) {
                if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
                Iterator.call(this, arr);
                if (!kind) kind = "value";
                else if (contains.call(kind, "key+value")) kind = "key+value";
                else if (contains.call(kind, "key")) kind = "key";
                else kind = "value";
                defineProperty(this, "__kind__", d("", kind));
            };
            if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);
            // Internal %ArrayIteratorPrototype% doesn't expose its constructor
            delete ArrayIterator.prototype.constructor;
            ArrayIterator.prototype = Object.create(Iterator.prototype, {
                _resolve: d(function(i) {
                    if (this.__kind__ === "value") return this.__list__[i];
                    if (this.__kind__ === "key+value") return [
                        i,
                        this.__list__[i]
                    ];
                    return i;
                })
            });
            defineProperty(ArrayIterator.prototype, Symbol1.toStringTag, d("c", "Array Iterator"));
        /***/ },
        /* 419 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var global = __webpack_require__(92), validTypes = {
                object: true,
                symbol: true
            };
            module1.exports = function() {
                var Symbol1 = global.Symbol;
                var symbol;
                if (typeof Symbol1 !== "function") return false;
                symbol = Symbol1("test symbol");
                try {
                    String(symbol);
                } catch (e) {
                    return false;
                }
                // Return 'true' also for polyfills
                if (!validTypes[typeof Symbol1.iterator]) return false;
                if (!validTypes[typeof Symbol1.toPrimitive]) return false;
                if (!validTypes[typeof Symbol1.toStringTag]) return false;
                return true;
            };
        /***/ },
        /* 420 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                if (typeof globalThis !== "object") return false;
                if (!globalThis) return false;
                return globalThis.Array === Array;
            };
        /***/ },
        /* 421 */ /***/ function(module1, exports) {
            var naiveFallback = function() {
                if (typeof self === "object" && self) return self;
                if (typeof window === "object" && window) return window;
                throw new Error("Unable to resolve global `this`");
            };
            module1.exports = function() {
                if (this) return this;
                // Unexpected strict mode (may happen if e.g. bundled into ESM module)
                // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
                // In all ES5+ engines global object inherits from Object.prototype
                // (if you approached one that doesn't please report)
                try {
                    Object.defineProperty(Object.prototype, "__global__", {
                        get: function() {
                            return this;
                        },
                        configurable: true
                    });
                } catch (error) {
                    // Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
                    return naiveFallback();
                }
                try {
                    // Safari case (window.__global__ is resolved with global context, but __global__ does not)
                    if (!__global__) return naiveFallback();
                    return __global__;
                } finally{
                    delete Object.prototype.__global__;
                }
            }();
        /***/ },
        /* 422 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // ES2015 Symbol polyfill for environments that do not (or partially) support it
            var d = __webpack_require__(33), validateSymbol = __webpack_require__(203), NativeSymbol = __webpack_require__(92).Symbol, generateName = __webpack_require__(424), setupStandardSymbols = __webpack_require__(425), setupSymbolRegistry = __webpack_require__(426);
            var create = Object.create, defineProperties = Object.defineProperties, defineProperty = Object.defineProperty;
            var SymbolPolyfill, HiddenSymbol, isNativeSafe;
            if (typeof NativeSymbol === "function") try {
                String(NativeSymbol());
                isNativeSafe = true;
            } catch (ignore) {}
            else NativeSymbol = null;
            // Internal constructor (not one exposed) for creating Symbol instances.
            // This one is used to ensure that `someSymbol instanceof Symbol` always return false
            HiddenSymbol = function Symbol1(description) {
                if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
                return SymbolPolyfill(description);
            };
            // Exposed `Symbol` constructor
            // (returns instances of HiddenSymbol)
            module1.exports = SymbolPolyfill = function Symbol1(description) {
                var symbol;
                if (this instanceof Symbol1) throw new TypeError("Symbol is not a constructor");
                if (isNativeSafe) return NativeSymbol(description);
                symbol = create(HiddenSymbol.prototype);
                description = description === undefined ? "" : String(description);
                return defineProperties(symbol, {
                    __description__: d("", description),
                    __name__: d("", generateName(description))
                });
            };
            setupStandardSymbols(SymbolPolyfill);
            setupSymbolRegistry(SymbolPolyfill);
            // Internal tweaks for real symbol producer
            defineProperties(HiddenSymbol.prototype, {
                constructor: d(SymbolPolyfill),
                toString: d("", function() {
                    return this.__name__;
                })
            });
            // Proper implementation of methods exposed on Symbol.prototype
            // They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
            defineProperties(SymbolPolyfill.prototype, {
                toString: d(function() {
                    return "Symbol (" + validateSymbol(this).__description__ + ")";
                }),
                valueOf: d(function() {
                    return validateSymbol(this);
                })
            });
            defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d("", function() {
                var symbol = validateSymbol(this);
                if (typeof symbol === "symbol") return symbol;
                return symbol.toString();
            }));
            defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));
            // Proper implementaton of toPrimitive and toStringTag for returned symbol instances
            defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag, d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
            // Note: It's important to define `toPrimitive` as last one, as some implementations
            // implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
            // And that may invoke error in definition flow:
            // See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
            defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive, d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));
        /***/ },
        /* 423 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(value) {
                if (!value) return false;
                if (typeof value === "symbol") return true;
                if (!value.constructor) return false;
                if (value.constructor.name !== "Symbol") return false;
                return value[value.constructor.toStringTag] === "Symbol";
            };
        /***/ },
        /* 424 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var d = __webpack_require__(33);
            var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;
            var created = create(null);
            module1.exports = function(desc) {
                var postfix = 0, name, ie11BugWorkaround;
                while(created[desc + (postfix || "")])++postfix;
                desc += postfix || "";
                created[desc] = true;
                name = "@@" + desc;
                defineProperty(objPrototype, name, d.gs(null, function(value) {
                    // For IE11 issue see:
                    // https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
                    //    ie11-broken-getters-on-dom-objects
                    // https://github.com/medikoo/es6-symbol/issues/12
                    if (ie11BugWorkaround) return;
                    ie11BugWorkaround = true;
                    defineProperty(this, name, d(value));
                    ie11BugWorkaround = false;
                }));
                return name;
            };
        /***/ },
        /* 425 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var d = __webpack_require__(33), NativeSymbol = __webpack_require__(92).Symbol;
            module1.exports = function(SymbolPolyfill) {
                return Object.defineProperties(SymbolPolyfill, {
                    // To ensure proper interoperability with other native functions (e.g. Array.from)
                    // fallback to eventual native implementation of given symbol
                    hasInstance: d("", NativeSymbol && NativeSymbol.hasInstance || SymbolPolyfill("hasInstance")),
                    isConcatSpreadable: d("", NativeSymbol && NativeSymbol.isConcatSpreadable || SymbolPolyfill("isConcatSpreadable")),
                    iterator: d("", NativeSymbol && NativeSymbol.iterator || SymbolPolyfill("iterator")),
                    match: d("", NativeSymbol && NativeSymbol.match || SymbolPolyfill("match")),
                    replace: d("", NativeSymbol && NativeSymbol.replace || SymbolPolyfill("replace")),
                    search: d("", NativeSymbol && NativeSymbol.search || SymbolPolyfill("search")),
                    species: d("", NativeSymbol && NativeSymbol.species || SymbolPolyfill("species")),
                    split: d("", NativeSymbol && NativeSymbol.split || SymbolPolyfill("split")),
                    toPrimitive: d("", NativeSymbol && NativeSymbol.toPrimitive || SymbolPolyfill("toPrimitive")),
                    toStringTag: d("", NativeSymbol && NativeSymbol.toStringTag || SymbolPolyfill("toStringTag")),
                    unscopables: d("", NativeSymbol && NativeSymbol.unscopables || SymbolPolyfill("unscopables"))
                });
            };
        /***/ },
        /* 426 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var d = __webpack_require__(33), validateSymbol = __webpack_require__(203);
            var registry = Object.create(null);
            module1.exports = function(SymbolPolyfill) {
                return Object.defineProperties(SymbolPolyfill, {
                    for: d(function(key) {
                        if (registry[key]) return registry[key];
                        return registry[key] = SymbolPolyfill(String(key));
                    }),
                    keyFor: d(function(symbol) {
                        var key;
                        validateSymbol(symbol);
                        for(key in registry){
                            if (registry[key] === symbol) return key;
                        }
                        return undefined;
                    })
                });
            };
        /***/ },
        /* 427 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Inspired by Google Closure:
            // http://closure-library.googlecode.com/svn/docs/
            // closure_goog_array_array.js.html#goog.array.clear
            var value = __webpack_require__(32);
            module1.exports = function() {
                value(this).length = 0;
                return this;
            };
        /***/ },
        /* 428 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(57), ensureValue = __webpack_require__(429), ensurePlainFunction = __webpack_require__(433), copy = __webpack_require__(434), normalizeOptions = __webpack_require__(200), map = __webpack_require__(444);
            var bind = Function.prototype.bind, defineProperty = Object.defineProperty, hasOwnProperty1 = Object.prototype.hasOwnProperty, define;
            define = function(name, desc, options) {
                var value = ensureValue(desc) && ensurePlainFunction(desc.value), dgs;
                dgs = copy(desc);
                delete dgs.writable;
                delete dgs.value;
                dgs.get = function() {
                    if (!options.overwriteDefinition && hasOwnProperty1.call(this, name)) return value;
                    desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
                    defineProperty(this, name, desc);
                    return this[name];
                };
                return dgs;
            };
            module1.exports = function(props /*, options*/ ) {
                var options = normalizeOptions(arguments[1]);
                if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
                return map(props, function(desc, name) {
                    return define(name, desc, options);
                });
            };
        /***/ },
        /* 429 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var resolveException = __webpack_require__(205), is = __webpack_require__(57);
            module1.exports = function(value /*, options*/ ) {
                if (is(value)) return value;
                return resolveException(value, "Cannot use %v", arguments[1]);
            };
        /***/ },
        /* 430 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isValue = __webpack_require__(57), isObject = __webpack_require__(124);
            var objectToString = Object.prototype.toString;
            module1.exports = function(value) {
                if (!isValue(value)) return null;
                if (isObject(value)) {
                    // Reject Object.prototype.toString coercion
                    var valueToString = value.toString;
                    if (typeof valueToString !== "function") return null;
                    if (valueToString === objectToString) return null;
                // Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
                // way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
                }
                try {
                    return "" + value; // Ensure implicit coercion
                } catch (error) {
                    return null;
                }
            };
        /***/ },
        /* 431 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var safeToString = __webpack_require__(432);
            var reNewLine = /[\n\r\u2028\u2029]/g;
            module1.exports = function(value) {
                var string = safeToString(value);
                if (string === null) return "<Non-coercible to string value>";
                // Trim if too long
                if (string.length > 100) string = string.slice(0, 99) + "\u2026";
                // Replace eventual new lines
                string = string.replace(reNewLine, function(char) {
                    switch(char){
                        case "\n":
                            return "\\n";
                        case "\r":
                            return "\\r";
                        case "\u2028":
                            return "\\u2028";
                        case "\u2029":
                            return "\\u2029";
                        /* istanbul ignore next */ default:
                            throw new Error("Unexpected character");
                    }
                });
                return string;
            };
        /***/ },
        /* 432 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(value) {
                try {
                    return value.toString();
                } catch (error) {
                    try {
                        return String(value);
                    } catch (error2) {
                        return null;
                    }
                }
            };
        /***/ },
        /* 433 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var resolveException = __webpack_require__(205), is = __webpack_require__(199);
            module1.exports = function(value /*, options*/ ) {
                if (is(value)) return value;
                return resolveException(value, "%v is not a plain function", arguments[1]);
            };
        /***/ },
        /* 434 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var aFrom = __webpack_require__(435), assign = __webpack_require__(125), value = __webpack_require__(32);
            module1.exports = function(obj /*, propertyNames, options*/ ) {
                var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
                if (copy !== obj && !propertyNames) return copy;
                var result = {};
                if (propertyNames) aFrom(propertyNames, function(propertyName) {
                    if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
                });
                else assign(result, obj);
                return result;
            };
        /***/ },
        /* 435 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(436)() ? Array.from : __webpack_require__(437);
        /***/ },
        /* 436 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                var from = Array.from, arr, result;
                if (typeof from !== "function") return false;
                arr = [
                    "raz",
                    "dwa"
                ];
                result = from(arr);
                return Boolean(result && result !== arr && result[1] === "dwa");
            };
        /***/ },
        /* 437 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var iteratorSymbol = __webpack_require__(45).iterator, isArguments = __webpack_require__(90), isFunction = __webpack_require__(438), toPosInt = __webpack_require__(439), callable = __webpack_require__(70), validValue = __webpack_require__(32), isValue = __webpack_require__(44), isString = __webpack_require__(91), isArray = Array.isArray, call = Function.prototype.call, desc = {
                configurable: true,
                enumerable: true,
                writable: true,
                value: null
            }, defineProperty = Object.defineProperty;
            // eslint-disable-next-line complexity, max-lines-per-function
            module1.exports = function(arrayLike /*, mapFn, thisArg*/ ) {
                var mapFn = arguments[1], thisArg = arguments[2], Context, i, j, arr, length, code, iterator, result, getIterator, value;
                arrayLike = Object(validValue(arrayLike));
                if (isValue(mapFn)) callable(mapFn);
                if (!this || this === Array || !isFunction(this)) {
                    // Result: Plain array
                    if (!mapFn) {
                        if (isArguments(arrayLike)) {
                            // Source: Arguments
                            length = arrayLike.length;
                            if (length !== 1) return Array.apply(null, arrayLike);
                            arr = new Array(1);
                            arr[0] = arrayLike[0];
                            return arr;
                        }
                        if (isArray(arrayLike)) {
                            // Source: Array
                            arr = new Array(length = arrayLike.length);
                            for(i = 0; i < length; ++i)arr[i] = arrayLike[i];
                            return arr;
                        }
                    }
                    arr = [];
                } else // Result: Non plain array
                Context = this;
                if (!isArray(arrayLike)) {
                    if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
                        // Source: Iterator
                        iterator = callable(getIterator).call(arrayLike);
                        if (Context) arr = new Context();
                        result = iterator.next();
                        i = 0;
                        while(!result.done){
                            value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
                            if (Context) {
                                desc.value = value;
                                defineProperty(arr, i, desc);
                            } else arr[i] = value;
                            result = iterator.next();
                            ++i;
                        }
                        length = i;
                    } else if (isString(arrayLike)) {
                        // Source: String
                        length = arrayLike.length;
                        if (Context) arr = new Context();
                        for(i = 0, j = 0; i < length; ++i){
                            value = arrayLike[i];
                            if (i + 1 < length) {
                                code = value.charCodeAt(0);
                                // eslint-disable-next-line max-depth
                                if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
                            }
                            value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
                            if (Context) {
                                desc.value = value;
                                defineProperty(arr, j, desc);
                            } else arr[j] = value;
                            ++j;
                        }
                        length = j;
                    }
                }
                if (length === undefined) {
                    // Source: array or array-like
                    length = toPosInt(arrayLike.length);
                    if (Context) arr = new Context(length);
                    for(i = 0; i < length; ++i){
                        value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
                        if (Context) {
                            desc.value = value;
                            defineProperty(arr, i, desc);
                        } else arr[i] = value;
                    }
                }
                if (Context) {
                    desc.value = null;
                    arr.length = length;
                }
                return arr;
            };
        /***/ },
        /* 438 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var objToString = Object.prototype.toString, isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
            module1.exports = function(value) {
                return typeof value === "function" && isFunctionStringTag(objToString.call(value));
            };
        /***/ },
        /* 439 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var toInteger = __webpack_require__(440), max = Math.max;
            module1.exports = function(value) {
                return max(0, toInteger(value));
            };
        /***/ },
        /* 440 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var sign = __webpack_require__(441), abs = Math.abs, floor = Math.floor;
            module1.exports = function(value) {
                if (isNaN(value)) return 0;
                value = Number(value);
                if (value === 0 || !isFinite(value)) return value;
                return sign(value) * floor(abs(value));
            };
        /***/ },
        /* 441 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(442)() ? Math.sign : __webpack_require__(443);
        /***/ },
        /* 442 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                var sign = Math.sign;
                if (typeof sign !== "function") return false;
                return sign(10) === 1 && sign(-20) === -1;
            };
        /***/ },
        /* 443 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(value) {
                value = Number(value);
                if (isNaN(value) || value === 0) return value;
                return value > 0 ? 1 : -1;
            };
        /***/ },
        /* 444 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var callable = __webpack_require__(70), forEach = __webpack_require__(445), call = Function.prototype.call;
            module1.exports = function(obj, cb /*, thisArg*/ ) {
                var result = {}, thisArg = arguments[2];
                callable(cb);
                forEach(obj, function(value, key, targetObj, index) {
                    result[key] = call.call(cb, thisArg, value, key, targetObj, index);
                });
                return result;
            };
        /***/ },
        /* 445 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = __webpack_require__(446)("forEach");
        /***/ },
        /* 446 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Internal method, used by iteration functions.
            // Calls a function for each key-value pair found in object
            // Optionally takes compareFn to iterate object in specific order
            var callable = __webpack_require__(70), value = __webpack_require__(32), bind = Function.prototype.bind, call = Function.prototype.call, keys = Object.keys, objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
            module1.exports = function(method, defVal) {
                return function(obj, cb /*, thisArg, compareFn*/ ) {
                    var list, thisArg = arguments[2], compareFn = arguments[3];
                    obj = Object(value(obj));
                    callable(cb);
                    list = keys(obj);
                    if (compareFn) list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
                    if (typeof method !== "function") method = list[method];
                    return call.call(method, list, function(key, index) {
                        if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
                        return call.call(cb, thisArg, obj[key], key, obj, index);
                    });
                };
            };
        /***/ },
        /* 447 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Thanks @mathiasbynens
            // http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols
            var setPrototypeOf = __webpack_require__(123), d = __webpack_require__(33), Symbol1 = __webpack_require__(45), Iterator = __webpack_require__(204);
            var defineProperty = Object.defineProperty, StringIterator;
            StringIterator = module1.exports = function(str) {
                if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
                str = String(str);
                Iterator.call(this, str);
                defineProperty(this, "__length__", d("", str.length));
            };
            if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);
            // Internal %ArrayIteratorPrototype% doesn't expose its constructor
            delete StringIterator.prototype.constructor;
            StringIterator.prototype = Object.create(Iterator.prototype, {
                _next: d(function() {
                    if (!this.__list__) return undefined;
                    if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
                    this._unBind();
                    return undefined;
                }),
                _resolve: d(function(i) {
                    var char = this.__list__[i], code;
                    if (this.__nextIndex__ === this.__length__) return char;
                    code = char.charCodeAt(0);
                    if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
                    return char;
                })
            });
            defineProperty(StringIterator.prototype, Symbol1.toStringTag, d("c", "String Iterator"));
        /***/ },
        /* 448 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isIterable = __webpack_require__(449);
            module1.exports = function(value) {
                if (!isIterable(value)) throw new TypeError(value + " is not iterable");
                return value;
            };
        /***/ },
        /* 449 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isArguments = __webpack_require__(90), isValue = __webpack_require__(44), isString = __webpack_require__(91);
            var iteratorSymbol = __webpack_require__(45).iterator, isArray = Array.isArray;
            module1.exports = function(value) {
                if (!isValue(value)) return false;
                if (isArray(value)) return true;
                if (isString(value)) return true;
                if (isArguments(value)) return true;
                return typeof value[iteratorSymbol] === "function";
            };
        /***/ },
        /* 450 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isArguments = __webpack_require__(90), callable = __webpack_require__(70), isString = __webpack_require__(91), get = __webpack_require__(202);
            var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;
            module1.exports = function(iterable, cb /*, thisArg*/ ) {
                var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
                if (isArray(iterable) || isArguments(iterable)) mode = "array";
                else if (isString(iterable)) mode = "string";
                else iterable = get(iterable);
                callable(cb);
                doBreak = function() {
                    broken = true;
                };
                if (mode === "array") {
                    some.call(iterable, function(value) {
                        call.call(cb, thisArg, value, doBreak);
                        return broken;
                    });
                    return;
                }
                if (mode === "string") {
                    length = iterable.length;
                    for(i = 0; i < length; ++i){
                        char = iterable[i];
                        if (i + 1 < length) {
                            code = char.charCodeAt(0);
                            if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
                        }
                        call.call(cb, thisArg, char, doBreak);
                        if (broken) break;
                    }
                    return;
                }
                result = iterable.next();
                while(!result.done){
                    call.call(cb, thisArg, result.value, doBreak);
                    if (broken) return;
                    result = iterable.next();
                }
            };
        /***/ },
        /* 451 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Exports true if environment provides native `WeakMap` implementation, whatever that is.
            module1.exports = function() {
                if (typeof WeakMap !== "function") return false;
                return Object.prototype.toString.call(new WeakMap()) === "[object WeakMap]";
            }();
        /***/ },
        /* 452 */ /***/ function(module1, exports, __webpack_require__) {
            var SetCache = __webpack_require__(93), arrayIncludes = __webpack_require__(94), arrayIncludesWith = __webpack_require__(128), arrayMap = __webpack_require__(34), baseUnary = __webpack_require__(68), cacheHas = __webpack_require__(95);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
            /**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
                while(othIndex--){
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }
                array = arrays[0];
                var index = -1, seen = caches[0];
                outer: while(++index < length && result.length < maxLength){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                        othIndex = othLength;
                        while(--othIndex){
                            var cache = caches[othIndex];
                            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                        }
                        if (seen) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            module1.exports = baseIntersection;
        /***/ },
        /* 453 */ /***/ function(module1, exports) {
            /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
            /**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);
                return this;
            }
            module1.exports = setCacheAdd;
        /***/ },
        /* 454 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
                return this.__data__.has(value);
            }
            module1.exports = setCacheHas;
        /***/ },
        /* 455 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFindIndex = __webpack_require__(206), baseIsNaN = __webpack_require__(456), strictIndexOf = __webpack_require__(457);
            /**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
                return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
            }
            module1.exports = baseIndexOf;
        /***/ },
        /* 456 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
                return value !== value;
            }
            module1.exports = baseIsNaN;
        /***/ },
        /* 457 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
                var index = fromIndex - 1, length = array.length;
                while(++index < length){
                    if (array[index] === value) return index;
                }
                return -1;
            }
            module1.exports = strictIndexOf;
        /***/ },
        /* 458 */ /***/ function(module1, exports, __webpack_require__) {
            var isArrayLikeObject = __webpack_require__(129);
            /**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
            }
            module1.exports = castArrayLikeObject;
        /***/ },
        /* 459 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var utils = __webpack_require__(20);
                var bind = __webpack_require__(208);
                var Axios = __webpack_require__(460);
                var mergeConfig = __webpack_require__(214);
                var defaults = __webpack_require__(211);
                /**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
                    var context = new Axios(defaultConfig);
                    var instance = bind(Axios.prototype.request, context);
                    // Copy axios.prototype to instance
                    utils.extend(instance, Axios.prototype, context);
                    // Copy context to instance
                    utils.extend(instance, context);
                    return instance;
                }
                // Create the default instance to be exported
                var axios = createInstance(defaults);
                // Expose Axios class to allow class inheritance
                axios.Axios = Axios;
                // Factory for creating new instances
                axios.create = function create(instanceConfig) {
                    return createInstance(mergeConfig(axios.defaults, instanceConfig));
                };
                // Expose Cancel & CancelToken
                axios.Cancel = __webpack_require__(215);
                axios.CancelToken = __webpack_require__(473);
                axios.isCancel = __webpack_require__(210);
                // Expose all/spread
                axios.all = function all(promises) {
                    return Promise.all(promises);
                };
                axios.spread = __webpack_require__(474);
                // Expose isAxiosError
                axios.isAxiosError = __webpack_require__(475);
                module1.exports = axios;
                // Allow use of default import syntax in TypeScript
                module1.exports.default = axios;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 460 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var utils = __webpack_require__(20);
                var buildURL = __webpack_require__(209);
                var InterceptorManager = __webpack_require__(461);
                var dispatchRequest = __webpack_require__(462);
                var mergeConfig = __webpack_require__(214);
                /**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
                    this.defaults = instanceConfig;
                    this.interceptors = {
                        request: new InterceptorManager(),
                        response: new InterceptorManager()
                    };
                }
                /**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(config) {
                    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                    if (typeof config === 'string') {
                        config = arguments[1] || {};
                        config.url = arguments[0];
                    } else config = config || {};
                    config = mergeConfig(this.defaults, config);
                    // Set config.method
                    if (config.method) config.method = config.method.toLowerCase();
                    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
                    else config.method = 'get';
                    // Hook up interceptors middleware
                    var chain = [
                        dispatchRequest,
                        undefined
                    ];
                    var promise = Promise.resolve(config);
                    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                        chain.unshift(interceptor.fulfilled, interceptor.rejected);
                    });
                    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                        chain.push(interceptor.fulfilled, interceptor.rejected);
                    });
                    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
                    return promise;
                };
                Axios.prototype.getUri = function getUri(config) {
                    config = mergeConfig(this.defaults, config);
                    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
                };
                // Provide aliases for supported request methods
                utils.forEach([
                    'delete',
                    'get',
                    'head',
                    'options'
                ], function forEachMethodNoData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: (config || {}).data
                        }));
                    };
                });
                utils.forEach([
                    'post',
                    'put',
                    'patch'
                ], function forEachMethodWithData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, data, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: data
                        }));
                    };
                });
                module1.exports = Axios;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 461 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            function InterceptorManager() {
                this.handlers = [];
            }
            /**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected
                });
                return this.handlers.length - 1;
            };
            /**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            };
            /**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
                utils.forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            };
            module1.exports = InterceptorManager;
        /***/ },
        /* 462 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var utils = __webpack_require__(20);
                var transformData = __webpack_require__(463);
                var isCancel = __webpack_require__(210);
                var defaults = __webpack_require__(211);
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
                    if (config.cancelToken) config.cancelToken.throwIfRequested();
                }
                /**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module1.exports = function dispatchRequest(config) {
                    throwIfCancellationRequested(config);
                    // Ensure headers exist
                    config.headers = config.headers || {};
                    // Transform request data
                    config.data = transformData(config.data, config.headers, config.transformRequest);
                    // Flatten headers
                    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
                    utils.forEach([
                        'delete',
                        'get',
                        'head',
                        'post',
                        'put',
                        'patch',
                        'common'
                    ], function cleanHeaderConfig(method) {
                        delete config.headers[method];
                    });
                    var adapter = config.adapter || defaults.adapter;
                    return adapter(config).then(function onAdapterResolution(response) {
                        throwIfCancellationRequested(config);
                        // Transform response data
                        response.data = transformData(response.data, response.headers, config.transformResponse);
                        return response;
                    }, function onAdapterRejection(reason) {
                        if (!isCancel(reason)) {
                            throwIfCancellationRequested(config);
                            // Transform response data
                            if (reason && reason.response) reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
                        }
                        return Promise.reject(reason);
                    });
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 463 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            /**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module1.exports = function transformData(data, headers, fns) {
                /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
                    data = fn(data, headers);
                });
                return data;
            };
        /***/ },
        /* 464 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            module1.exports = function normalizeHeaderName(headers, normalizedName) {
                utils.forEach(headers, function processHeader(value, name) {
                    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                        headers[normalizedName] = value;
                        delete headers[name];
                    }
                });
            };
        /***/ },
        /* 465 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var createError = __webpack_require__(213);
            /**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module1.exports = function settle(resolve, reject, response) {
                var validateStatus = response.config.validateStatus;
                if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
                else reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
            };
        /***/ },
        /* 466 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module1.exports = function enhanceError(error, config, code, request, response) {
                error.config = config;
                if (code) error.code = code;
                error.request = request;
                error.response = response;
                error.isAxiosError = true;
                error.toJSON = function toJSON() {
                    return {
                        // Standard
                        message: this.message,
                        name: this.name,
                        // Microsoft
                        description: this.description,
                        number: this.number,
                        // Mozilla
                        fileName: this.fileName,
                        lineNumber: this.lineNumber,
                        columnNumber: this.columnNumber,
                        stack: this.stack,
                        // Axios
                        config: this.config,
                        code: this.code
                    };
                };
                return error;
            };
        /***/ },
        /* 467 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
            function standardBrowserEnv() {
                return {
                    write: function write(name, value, expires, path, domain, secure) {
                        var cookie = [];
                        cookie.push(name + '=' + encodeURIComponent(value));
                        if (utils.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
                        if (utils.isString(path)) cookie.push('path=' + path);
                        if (utils.isString(domain)) cookie.push('domain=' + domain);
                        if (secure === true) cookie.push('secure');
                        document.cookie = cookie.join('; ');
                    },
                    read: function read(name) {
                        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                        return match ? decodeURIComponent(match[3]) : null;
                    },
                    remove: function remove(name) {
                        this.write(name, '', Date.now() - 86400000);
                    }
                };
            }() : // Non standard browser env (web workers, react-native) lack needed support.
            function nonStandardBrowserEnv() {
                return {
                    write: function write() {},
                    read: function read() {
                        return null;
                    },
                    remove: function remove() {}
                };
            }();
        /***/ },
        /* 468 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isAbsoluteURL = __webpack_require__(469);
            var combineURLs = __webpack_require__(470);
            /**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module1.exports = function buildFullPath(baseURL, requestedURL) {
                if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
                return requestedURL;
            };
        /***/ },
        /* 469 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module1.exports = function isAbsoluteURL(url) {
                // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
                // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
                // by any combination of letters, digits, plus, period, or hyphen.
                return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
            };
        /***/ },
        /* 470 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module1.exports = function combineURLs(baseURL, relativeURL) {
                return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
            };
        /***/ },
        /* 471 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            // Headers whose duplicates are ignored by node
            // c.f. https://nodejs.org/api/http.html#http_message_headers
            var ignoreDuplicateOf = [
                'age',
                'authorization',
                'content-length',
                'content-type',
                'etag',
                'expires',
                'from',
                'host',
                'if-modified-since',
                'if-unmodified-since',
                'last-modified',
                'location',
                'max-forwards',
                'proxy-authorization',
                'referer',
                'retry-after',
                'user-agent'
            ];
            /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module1.exports = function parseHeaders(headers) {
                var parsed = {};
                var key;
                var val;
                var i;
                if (!headers) return parsed;
                utils.forEach(headers.split('\n'), function parser(line) {
                    i = line.indexOf(':');
                    key = utils.trim(line.substr(0, i)).toLowerCase();
                    val = utils.trim(line.substr(i + 1));
                    if (key) {
                        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                        if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                            val
                        ]);
                        else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
                    }
                });
                return parsed;
            };
        /***/ },
        /* 472 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var utils = __webpack_require__(20);
            module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
            // whether the request URL is of the same origin as current location.
            function standardBrowserEnv() {
                var msie = /(msie|trident)/i.test(navigator.userAgent);
                var urlParsingNode = document.createElement('a');
                var originURL;
                /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
                    var href = url;
                    if (msie) {
                        // IE needs attribute set twice to normalize properties
                        urlParsingNode.setAttribute('href', href);
                        href = urlParsingNode.href;
                    }
                    urlParsingNode.setAttribute('href', href);
                    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                    return {
                        href: urlParsingNode.href,
                        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                        host: urlParsingNode.host,
                        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                        hostname: urlParsingNode.hostname,
                        port: urlParsingNode.port,
                        pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
                    };
                }
                originURL = resolveURL(window.location.href);
                /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
                    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                };
            }() : // Non standard browser envs (web workers, react-native) lack needed support.
            function nonStandardBrowserEnv() {
                return function isURLSameOrigin() {
                    return true;
                };
            }();
        /***/ },
        /* 473 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var Cancel = __webpack_require__(215);
                /**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
                    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
                    var resolvePromise;
                    this.promise = new Promise(function promiseExecutor(resolve) {
                        resolvePromise = resolve;
                    });
                    var token = this;
                    executor(function cancel(message) {
                        if (token.reason) // Cancellation has already been requested
                        return;
                        token.reason = new Cancel(message);
                        resolvePromise(token.reason);
                    });
                }
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                    if (this.reason) throw this.reason;
                };
                /**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
                    var cancel;
                    var token = new CancelToken(function executor(c) {
                        cancel = c;
                    });
                    return {
                        token: token,
                        cancel: cancel
                    };
                };
                module1.exports = CancelToken;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 474 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module1.exports = function spread(callback) {
                return function wrap(arr) {
                    return callback.apply(null, arr);
                };
            };
        /***/ },
        /* 475 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module1.exports = function isAxiosError(payload) {
                return typeof payload === 'object' && payload.isAxiosError === true;
            };
        /***/ },
        /* 476 */ /***/ function(module1, exports, __webpack_require__) {
            var convert = __webpack_require__(216), func = convert('pick', __webpack_require__(48));
            func.placeholder = __webpack_require__(130);
            module1.exports = func;
        /***/ },
        /* 477 */ /***/ function(module1, exports, __webpack_require__) {
            var mapping = __webpack_require__(478), fallbackHolder = __webpack_require__(130);
            /** Built-in value reference. */ var push = Array.prototype.push;
            /**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function baseArity(func, n) {
                return n == 2 ? function(a, b) {
                    return func.apply(undefined, arguments);
                } : function(a) {
                    return func.apply(undefined, arguments);
                };
            }
            /**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function baseAry(func, n) {
                return n == 2 ? function(a, b) {
                    return func(a, b);
                } : function(a) {
                    return func(a);
                };
            }
            /**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function cloneArray(array) {
                var length = array ? array.length : 0, result = Array(length);
                while(length--)result[length] = array[length];
                return result;
            }
            /**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function createCloner(func) {
                return function(object) {
                    return func({}, object);
                };
            }
            /**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function flatSpread(func, start) {
                return function() {
                    var length = arguments.length, lastIndex = length - 1, args = Array(length);
                    while(length--)args[length] = arguments[length];
                    var array = args[start], otherArgs = args.slice(0, start);
                    if (array) push.apply(otherArgs, array);
                    if (start != lastIndex) push.apply(otherArgs, args.slice(start + 1));
                    return func.apply(this, otherArgs);
                };
            }
            /**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function wrapImmutable(func, cloner) {
                return function() {
                    var length = arguments.length;
                    if (!length) return;
                    var args = Array(length);
                    while(length--)args[length] = arguments[length];
                    var result = args[0] = cloner.apply(undefined, args);
                    func.apply(undefined, args);
                    return result;
                };
            }
            /**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function baseConvert(util, name, func, options) {
                var isLib = typeof name == 'function', isObj = name === Object(name);
                if (isObj) {
                    options = func;
                    func = name;
                    name = undefined;
                }
                if (func == null) throw new TypeError;
                options || (options = {});
                var config = {
                    'cap': 'cap' in options ? options.cap : true,
                    'curry': 'curry' in options ? options.curry : true,
                    'fixed': 'fixed' in options ? options.fixed : true,
                    'immutable': 'immutable' in options ? options.immutable : true,
                    'rearg': 'rearg' in options ? options.rearg : true
                };
                var defaultHolder = isLib ? func : fallbackHolder, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
                var helpers = isLib ? func : {
                    'ary': util.ary,
                    'assign': util.assign,
                    'clone': util.clone,
                    'curry': util.curry,
                    'forEach': util.forEach,
                    'isArray': util.isArray,
                    'isError': util.isError,
                    'isFunction': util.isFunction,
                    'isWeakMap': util.isWeakMap,
                    'iteratee': util.iteratee,
                    'keys': util.keys,
                    'rearg': util.rearg,
                    'toInteger': util.toInteger,
                    'toPath': util.toPath
                };
                var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
                var aryMethodKeys = keys(mapping.aryMethod);
                var wrappers = {
                    'castArray': function(castArray) {
                        return function() {
                            var value = arguments[0];
                            return isArray(value) ? castArray(cloneArray(value)) : castArray.apply(undefined, arguments);
                        };
                    },
                    'iteratee': function(iteratee) {
                        return function() {
                            var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                            if (config.cap && typeof arity == 'number') {
                                arity = arity > 2 ? arity - 2 : 1;
                                return length && length <= arity ? result : baseAry(result, arity);
                            }
                            return result;
                        };
                    },
                    'mixin': function(mixin) {
                        return function(source) {
                            var func = this;
                            if (!isFunction(func)) return mixin(func, Object(source));
                            var pairs = [];
                            each(keys(source), function(key) {
                                if (isFunction(source[key])) pairs.push([
                                    key,
                                    func.prototype[key]
                                ]);
                            });
                            mixin(func, Object(source));
                            each(pairs, function(pair) {
                                var value = pair[1];
                                if (isFunction(value)) func.prototype[pair[0]] = value;
                                else delete func.prototype[pair[0]];
                            });
                            return func;
                        };
                    },
                    'nthArg': function(nthArg) {
                        return function(n) {
                            var arity = n < 0 ? 1 : toInteger(n) + 1;
                            return curry(nthArg(n), arity);
                        };
                    },
                    'rearg': function(rearg) {
                        return function(func, indexes) {
                            var arity = indexes ? indexes.length : 0;
                            return curry(rearg(func, indexes), arity);
                        };
                    },
                    'runInContext': function(runInContext) {
                        return function(context) {
                            return baseConvert(util, runInContext(context), options);
                        };
                    }
                };
                /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
                    if (config.cap) {
                        var indexes = mapping.iterateeRearg[name];
                        if (indexes) return iterateeRearg(func, indexes);
                        var n = !isLib && mapping.iterateeAry[name];
                        if (n) return iterateeAry(func, n);
                    }
                    return func;
                }
                /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
                    return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
                }
                /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
                    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
                        var data = mapping.methodSpread[name], start = data && data.start;
                        return start === undefined ? ary(func, n) : flatSpread(func, start);
                    }
                    return func;
                }
                /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
                    return config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]) ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n]) : func;
                }
                /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
                    path = toPath(path);
                    var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
                    while(nested != null && ++index < length){
                        var key = path[index], value = nested[key];
                        if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
                        nested = nested[key];
                    }
                    return result;
                }
                /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
                    return _.runInContext.convert(options)(undefined);
                }
                /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
                    var realName = mapping.aliasToReal[name] || name, methodName = mapping.remap[realName] || realName, oldOptions = options;
                    return function(options) {
                        var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
                        return baseConvert(newUtil, realName, newFunc, newOptions);
                    };
                }
                /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
                    return overArg(func, function(func) {
                        return typeof func == 'function' ? baseAry(func, n) : func;
                    });
                }
                /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
                    return overArg(func, function(func) {
                        var n = indexes.length;
                        return baseArity(rearg(baseAry(func, n), indexes), n);
                    });
                }
                /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
                    return function() {
                        var length = arguments.length;
                        if (!length) return func();
                        var args = Array(length);
                        while(length--)args[length] = arguments[length];
                        var index = config.rearg ? 0 : length - 1;
                        args[index] = transform(args[index]);
                        return func.apply(undefined, args);
                    };
                }
                /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
                    var result, realName = mapping.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
                    if (wrapper) wrapped = wrapper(func);
                    else if (config.immutable) {
                        if (mapping.mutate.array[realName]) wrapped = wrapImmutable(func, cloneArray);
                        else if (mapping.mutate.object[realName]) wrapped = wrapImmutable(func, createCloner(func));
                        else if (mapping.mutate.set[realName]) wrapped = wrapImmutable(func, cloneByPath);
                    }
                    each(aryMethodKeys, function(aryKey) {
                        each(mapping.aryMethod[aryKey], function(otherName) {
                            if (realName == otherName) {
                                var data = mapping.methodSpread[realName], afterRearg = data && data.afterRearg;
                                result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                                result = castCap(realName, result);
                                result = castCurry(realName, result, aryKey);
                                return false;
                            }
                        });
                        return !result;
                    });
                    result || (result = wrapped);
                    if (result == func) result = forceCurry ? curry(result, 1) : function() {
                        return func.apply(this, arguments);
                    };
                    result.convert = createConverter(realName, func);
                    result.placeholder = func.placeholder = placeholder;
                    return result;
                }
                /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
                var _ = func;
                // Convert methods by ary cap.
                var pairs = [];
                each(aryMethodKeys, function(aryKey) {
                    each(mapping.aryMethod[aryKey], function(key) {
                        var func = _[mapping.remap[key] || key];
                        if (func) pairs.push([
                            key,
                            wrap(key, func, _)
                        ]);
                    });
                });
                // Convert remaining methods.
                each(keys(_), function(key) {
                    var func = _[key];
                    if (typeof func == 'function') {
                        var length = pairs.length;
                        while(length--){
                            if (pairs[length][0] == key) return;
                        }
                        func.convert = createConverter(key, func);
                        pairs.push([
                            key,
                            func
                        ]);
                    }
                });
                // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
                each(pairs, function(pair) {
                    _[pair[0]] = pair[1];
                });
                _.convert = convertLib;
                _.placeholder = _;
                // Assign aliases.
                each(keys(_), function(key) {
                    each(mapping.realToAlias[key] || [], function(alias) {
                        _[alias] = _[key];
                    });
                });
                return _;
            }
            module1.exports = baseConvert;
        /***/ },
        /* 478 */ /***/ function(module1, exports) {
            /** Used to map aliases to their real names. */ exports.aliasToReal = {
                // Lodash aliases.
                'each': 'forEach',
                'eachRight': 'forEachRight',
                'entries': 'toPairs',
                'entriesIn': 'toPairsIn',
                'extend': 'assignIn',
                'extendAll': 'assignInAll',
                'extendAllWith': 'assignInAllWith',
                'extendWith': 'assignInWith',
                'first': 'head',
                // Methods that are curried variants of others.
                'conforms': 'conformsTo',
                'matches': 'isMatch',
                'property': 'get',
                // Ramda aliases.
                '__': 'placeholder',
                'F': 'stubFalse',
                'T': 'stubTrue',
                'all': 'every',
                'allPass': 'overEvery',
                'always': 'constant',
                'any': 'some',
                'anyPass': 'overSome',
                'apply': 'spread',
                'assoc': 'set',
                'assocPath': 'set',
                'complement': 'negate',
                'compose': 'flowRight',
                'contains': 'includes',
                'dissoc': 'unset',
                'dissocPath': 'unset',
                'dropLast': 'dropRight',
                'dropLastWhile': 'dropRightWhile',
                'equals': 'isEqual',
                'identical': 'eq',
                'indexBy': 'keyBy',
                'init': 'initial',
                'invertObj': 'invert',
                'juxt': 'over',
                'omitAll': 'omit',
                'nAry': 'ary',
                'path': 'get',
                'pathEq': 'matchesProperty',
                'pathOr': 'getOr',
                'paths': 'at',
                'pickAll': 'pick',
                'pipe': 'flow',
                'pluck': 'map',
                'prop': 'get',
                'propEq': 'matchesProperty',
                'propOr': 'getOr',
                'props': 'at',
                'symmetricDifference': 'xor',
                'symmetricDifferenceBy': 'xorBy',
                'symmetricDifferenceWith': 'xorWith',
                'takeLast': 'takeRight',
                'takeLastWhile': 'takeRightWhile',
                'unapply': 'rest',
                'unnest': 'flatten',
                'useWith': 'overArgs',
                'where': 'conformsTo',
                'whereEq': 'isMatch',
                'zipObj': 'zipObject'
            };
            /** Used to map ary to method names. */ exports.aryMethod = {
                '1': [
                    'assignAll',
                    'assignInAll',
                    'attempt',
                    'castArray',
                    'ceil',
                    'create',
                    'curry',
                    'curryRight',
                    'defaultsAll',
                    'defaultsDeepAll',
                    'floor',
                    'flow',
                    'flowRight',
                    'fromPairs',
                    'invert',
                    'iteratee',
                    'memoize',
                    'method',
                    'mergeAll',
                    'methodOf',
                    'mixin',
                    'nthArg',
                    'over',
                    'overEvery',
                    'overSome',
                    'rest',
                    'reverse',
                    'round',
                    'runInContext',
                    'spread',
                    'template',
                    'trim',
                    'trimEnd',
                    'trimStart',
                    'uniqueId',
                    'words',
                    'zipAll'
                ],
                '2': [
                    'add',
                    'after',
                    'ary',
                    'assign',
                    'assignAllWith',
                    'assignIn',
                    'assignInAllWith',
                    'at',
                    'before',
                    'bind',
                    'bindAll',
                    'bindKey',
                    'chunk',
                    'cloneDeepWith',
                    'cloneWith',
                    'concat',
                    'conformsTo',
                    'countBy',
                    'curryN',
                    'curryRightN',
                    'debounce',
                    'defaults',
                    'defaultsDeep',
                    'defaultTo',
                    'delay',
                    'difference',
                    'divide',
                    'drop',
                    'dropRight',
                    'dropRightWhile',
                    'dropWhile',
                    'endsWith',
                    'eq',
                    'every',
                    'filter',
                    'find',
                    'findIndex',
                    'findKey',
                    'findLast',
                    'findLastIndex',
                    'findLastKey',
                    'flatMap',
                    'flatMapDeep',
                    'flattenDepth',
                    'forEach',
                    'forEachRight',
                    'forIn',
                    'forInRight',
                    'forOwn',
                    'forOwnRight',
                    'get',
                    'groupBy',
                    'gt',
                    'gte',
                    'has',
                    'hasIn',
                    'includes',
                    'indexOf',
                    'intersection',
                    'invertBy',
                    'invoke',
                    'invokeMap',
                    'isEqual',
                    'isMatch',
                    'join',
                    'keyBy',
                    'lastIndexOf',
                    'lt',
                    'lte',
                    'map',
                    'mapKeys',
                    'mapValues',
                    'matchesProperty',
                    'maxBy',
                    'meanBy',
                    'merge',
                    'mergeAllWith',
                    'minBy',
                    'multiply',
                    'nth',
                    'omit',
                    'omitBy',
                    'overArgs',
                    'pad',
                    'padEnd',
                    'padStart',
                    'parseInt',
                    'partial',
                    'partialRight',
                    'partition',
                    'pick',
                    'pickBy',
                    'propertyOf',
                    'pull',
                    'pullAll',
                    'pullAt',
                    'random',
                    'range',
                    'rangeRight',
                    'rearg',
                    'reject',
                    'remove',
                    'repeat',
                    'restFrom',
                    'result',
                    'sampleSize',
                    'some',
                    'sortBy',
                    'sortedIndex',
                    'sortedIndexOf',
                    'sortedLastIndex',
                    'sortedLastIndexOf',
                    'sortedUniqBy',
                    'split',
                    'spreadFrom',
                    'startsWith',
                    'subtract',
                    'sumBy',
                    'take',
                    'takeRight',
                    'takeRightWhile',
                    'takeWhile',
                    'tap',
                    'throttle',
                    'thru',
                    'times',
                    'trimChars',
                    'trimCharsEnd',
                    'trimCharsStart',
                    'truncate',
                    'union',
                    'uniqBy',
                    'uniqWith',
                    'unset',
                    'unzipWith',
                    'without',
                    'wrap',
                    'xor',
                    'zip',
                    'zipObject',
                    'zipObjectDeep'
                ],
                '3': [
                    'assignInWith',
                    'assignWith',
                    'clamp',
                    'differenceBy',
                    'differenceWith',
                    'findFrom',
                    'findIndexFrom',
                    'findLastFrom',
                    'findLastIndexFrom',
                    'getOr',
                    'includesFrom',
                    'indexOfFrom',
                    'inRange',
                    'intersectionBy',
                    'intersectionWith',
                    'invokeArgs',
                    'invokeArgsMap',
                    'isEqualWith',
                    'isMatchWith',
                    'flatMapDepth',
                    'lastIndexOfFrom',
                    'mergeWith',
                    'orderBy',
                    'padChars',
                    'padCharsEnd',
                    'padCharsStart',
                    'pullAllBy',
                    'pullAllWith',
                    'rangeStep',
                    'rangeStepRight',
                    'reduce',
                    'reduceRight',
                    'replace',
                    'set',
                    'slice',
                    'sortedIndexBy',
                    'sortedLastIndexBy',
                    'transform',
                    'unionBy',
                    'unionWith',
                    'update',
                    'xorBy',
                    'xorWith',
                    'zipWith'
                ],
                '4': [
                    'fill',
                    'setWith',
                    'updateWith'
                ]
            };
            /** Used to map ary to rearg configs. */ exports.aryRearg = {
                '2': [
                    1,
                    0
                ],
                '3': [
                    2,
                    0,
                    1
                ],
                '4': [
                    3,
                    2,
                    0,
                    1
                ]
            };
            /** Used to map method names to their iteratee ary. */ exports.iterateeAry = {
                'dropRightWhile': 1,
                'dropWhile': 1,
                'every': 1,
                'filter': 1,
                'find': 1,
                'findFrom': 1,
                'findIndex': 1,
                'findIndexFrom': 1,
                'findKey': 1,
                'findLast': 1,
                'findLastFrom': 1,
                'findLastIndex': 1,
                'findLastIndexFrom': 1,
                'findLastKey': 1,
                'flatMap': 1,
                'flatMapDeep': 1,
                'flatMapDepth': 1,
                'forEach': 1,
                'forEachRight': 1,
                'forIn': 1,
                'forInRight': 1,
                'forOwn': 1,
                'forOwnRight': 1,
                'map': 1,
                'mapKeys': 1,
                'mapValues': 1,
                'partition': 1,
                'reduce': 2,
                'reduceRight': 2,
                'reject': 1,
                'remove': 1,
                'some': 1,
                'takeRightWhile': 1,
                'takeWhile': 1,
                'times': 1,
                'transform': 2
            };
            /** Used to map method names to iteratee rearg configs. */ exports.iterateeRearg = {
                'mapKeys': [
                    1
                ],
                'reduceRight': [
                    1,
                    0
                ]
            };
            /** Used to map method names to rearg configs. */ exports.methodRearg = {
                'assignInAllWith': [
                    1,
                    0
                ],
                'assignInWith': [
                    1,
                    2,
                    0
                ],
                'assignAllWith': [
                    1,
                    0
                ],
                'assignWith': [
                    1,
                    2,
                    0
                ],
                'differenceBy': [
                    1,
                    2,
                    0
                ],
                'differenceWith': [
                    1,
                    2,
                    0
                ],
                'getOr': [
                    2,
                    1,
                    0
                ],
                'intersectionBy': [
                    1,
                    2,
                    0
                ],
                'intersectionWith': [
                    1,
                    2,
                    0
                ],
                'isEqualWith': [
                    1,
                    2,
                    0
                ],
                'isMatchWith': [
                    2,
                    1,
                    0
                ],
                'mergeAllWith': [
                    1,
                    0
                ],
                'mergeWith': [
                    1,
                    2,
                    0
                ],
                'padChars': [
                    2,
                    1,
                    0
                ],
                'padCharsEnd': [
                    2,
                    1,
                    0
                ],
                'padCharsStart': [
                    2,
                    1,
                    0
                ],
                'pullAllBy': [
                    2,
                    1,
                    0
                ],
                'pullAllWith': [
                    2,
                    1,
                    0
                ],
                'rangeStep': [
                    1,
                    2,
                    0
                ],
                'rangeStepRight': [
                    1,
                    2,
                    0
                ],
                'setWith': [
                    3,
                    1,
                    2,
                    0
                ],
                'sortedIndexBy': [
                    2,
                    1,
                    0
                ],
                'sortedLastIndexBy': [
                    2,
                    1,
                    0
                ],
                'unionBy': [
                    1,
                    2,
                    0
                ],
                'unionWith': [
                    1,
                    2,
                    0
                ],
                'updateWith': [
                    3,
                    1,
                    2,
                    0
                ],
                'xorBy': [
                    1,
                    2,
                    0
                ],
                'xorWith': [
                    1,
                    2,
                    0
                ],
                'zipWith': [
                    1,
                    2,
                    0
                ]
            };
            /** Used to map method names to spread configs. */ exports.methodSpread = {
                'assignAll': {
                    'start': 0
                },
                'assignAllWith': {
                    'start': 0
                },
                'assignInAll': {
                    'start': 0
                },
                'assignInAllWith': {
                    'start': 0
                },
                'defaultsAll': {
                    'start': 0
                },
                'defaultsDeepAll': {
                    'start': 0
                },
                'invokeArgs': {
                    'start': 2
                },
                'invokeArgsMap': {
                    'start': 2
                },
                'mergeAll': {
                    'start': 0
                },
                'mergeAllWith': {
                    'start': 0
                },
                'partial': {
                    'start': 1
                },
                'partialRight': {
                    'start': 1
                },
                'without': {
                    'start': 1
                },
                'zipAll': {
                    'start': 0
                }
            };
            /** Used to identify methods which mutate arrays or objects. */ exports.mutate = {
                'array': {
                    'fill': true,
                    'pull': true,
                    'pullAll': true,
                    'pullAllBy': true,
                    'pullAllWith': true,
                    'pullAt': true,
                    'remove': true,
                    'reverse': true
                },
                'object': {
                    'assign': true,
                    'assignAll': true,
                    'assignAllWith': true,
                    'assignIn': true,
                    'assignInAll': true,
                    'assignInAllWith': true,
                    'assignInWith': true,
                    'assignWith': true,
                    'defaults': true,
                    'defaultsAll': true,
                    'defaultsDeep': true,
                    'defaultsDeepAll': true,
                    'merge': true,
                    'mergeAll': true,
                    'mergeAllWith': true,
                    'mergeWith': true
                },
                'set': {
                    'set': true,
                    'setWith': true,
                    'unset': true,
                    'update': true,
                    'updateWith': true
                }
            };
            /** Used to map real names to their aliases. */ exports.realToAlias = function() {
                var hasOwnProperty1 = Object.prototype.hasOwnProperty, object = exports.aliasToReal, result = {};
                for(var key in object){
                    var value = object[key];
                    if (hasOwnProperty1.call(result, value)) result[value].push(key);
                    else result[value] = [
                        key
                    ];
                }
                return result;
            }();
            /** Used to map method names to other names. */ exports.remap = {
                'assignAll': 'assign',
                'assignAllWith': 'assignWith',
                'assignInAll': 'assignIn',
                'assignInAllWith': 'assignInWith',
                'curryN': 'curry',
                'curryRightN': 'curryRight',
                'defaultsAll': 'defaults',
                'defaultsDeepAll': 'defaultsDeep',
                'findFrom': 'find',
                'findIndexFrom': 'findIndex',
                'findLastFrom': 'findLast',
                'findLastIndexFrom': 'findLastIndex',
                'getOr': 'get',
                'includesFrom': 'includes',
                'indexOfFrom': 'indexOf',
                'invokeArgs': 'invoke',
                'invokeArgsMap': 'invokeMap',
                'lastIndexOfFrom': 'lastIndexOf',
                'mergeAll': 'merge',
                'mergeAllWith': 'mergeWith',
                'padChars': 'pad',
                'padCharsEnd': 'padEnd',
                'padCharsStart': 'padStart',
                'propertyOf': 'get',
                'rangeStep': 'range',
                'rangeStepRight': 'rangeRight',
                'restFrom': 'rest',
                'spreadFrom': 'spread',
                'trimChars': 'trim',
                'trimCharsEnd': 'trimEnd',
                'trimCharsStart': 'trimStart',
                'zipAll': 'zip'
            };
            /** Used to track methods that skip fixing their arity. */ exports.skipFixed = {
                'castArray': true,
                'flow': true,
                'flowRight': true,
                'iteratee': true,
                'mixin': true,
                'rearg': true,
                'runInContext': true
            };
            /** Used to track methods that skip rearranging arguments. */ exports.skipRearg = {
                'add': true,
                'assign': true,
                'assignIn': true,
                'bind': true,
                'bindKey': true,
                'concat': true,
                'difference': true,
                'divide': true,
                'eq': true,
                'gt': true,
                'gte': true,
                'isEqual': true,
                'lt': true,
                'lte': true,
                'matchesProperty': true,
                'merge': true,
                'multiply': true,
                'overArgs': true,
                'partial': true,
                'partialRight': true,
                'propertyOf': true,
                'random': true,
                'range': true,
                'rangeRight': true,
                'subtract': true,
                'zip': true,
                'zipObject': true,
                'zipObjectDeep': true
            };
        /***/ },
        /* 479 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = {
                'ary': __webpack_require__(480),
                'assign': __webpack_require__(177),
                'clone': __webpack_require__(38),
                'curry': __webpack_require__(498),
                'forEach': __webpack_require__(111),
                'isArray': __webpack_require__(12),
                'isError': __webpack_require__(499),
                'isFunction': __webpack_require__(17),
                'isWeakMap': __webpack_require__(500),
                'iteratee': __webpack_require__(501),
                'keys': __webpack_require__(114),
                'rearg': __webpack_require__(516),
                'toInteger': __webpack_require__(97),
                'toPath': __webpack_require__(519)
            };
        /***/ },
        /* 480 */ /***/ function(module1, exports, __webpack_require__) {
            var createWrap = __webpack_require__(131);
            /** Used to compose bitmasks for function metadata. */ var WRAP_ARY_FLAG = 128;
            /**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            module1.exports = ary;
        /***/ },
        /* 481 */ /***/ function(module1, exports, __webpack_require__) {
            var createCtor = __webpack_require__(96), root = __webpack_require__(14);
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
            /**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return fn.apply(isBind ? thisArg : this, arguments);
                }
                return wrapper;
            }
            module1.exports = createBind;
        /***/ },
        /* 482 */ /***/ function(module1, exports, __webpack_require__) {
            var apply = __webpack_require__(120), createCtor = __webpack_require__(96), createHybrid = __webpack_require__(219), createRecurry = __webpack_require__(222), getHolder = __webpack_require__(228), replaceHolders = __webpack_require__(134), root = __webpack_require__(14);
            /**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array(length), index = length, placeholder = getHolder(wrapper);
                    while(index--)args[index] = arguments[index];
                    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                    length -= holders.length;
                    if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return apply(fn, this, args);
                }
                return wrapper;
            }
            module1.exports = createCurry;
        /***/ },
        /* 483 */ /***/ function(module1, exports) {
            /**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function countHolders(array, placeholder) {
                var length = array.length, result = 0;
                while(length--)if (array[length] === placeholder) ++result;
                return result;
            }
            module1.exports = countHolders;
        /***/ },
        /* 484 */ /***/ function(module1, exports, __webpack_require__) {
            var LazyWrapper = __webpack_require__(132), getData = __webpack_require__(223), getFuncName = __webpack_require__(485), lodash = __webpack_require__(487);
            /**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function isLaziable(func) {
                var funcName = getFuncName(func), other = lodash[funcName];
                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
                if (func === other) return true;
                var data = getData(other);
                return !!data && func === data[0];
            }
            module1.exports = isLaziable;
        /***/ },
        /* 485 */ /***/ function(module1, exports, __webpack_require__) {
            var realNames = __webpack_require__(486);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
                var result = func.name + '', array = realNames[result], length = hasOwnProperty1.call(realNames, result) ? array.length : 0;
                while(length--){
                    var data = array[length], otherFunc = data.func;
                    if (otherFunc == null || otherFunc == func) return data.name;
                }
                return result;
            }
            module1.exports = getFuncName;
        /***/ },
        /* 486 */ /***/ function(module1, exports) {
            /** Used to lookup unminified function names. */ var realNames = {};
            module1.exports = realNames;
        /***/ },
        /* 487 */ /***/ function(module1, exports, __webpack_require__) {
            var LazyWrapper = __webpack_require__(132), LodashWrapper = __webpack_require__(225), baseLodash = __webpack_require__(133), isArray = __webpack_require__(12), isObjectLike = __webpack_require__(18), wrapperClone = __webpack_require__(488);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                    if (value instanceof LodashWrapper) return value;
                    if (hasOwnProperty1.call(value, '__wrapped__')) return wrapperClone(value);
                }
                return new LodashWrapper(value);
            }
            // Ensure wrappers are instances of `baseLodash`.
            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            module1.exports = lodash;
        /***/ },
        /* 488 */ /***/ function(module1, exports, __webpack_require__) {
            var LazyWrapper = __webpack_require__(132), LodashWrapper = __webpack_require__(225), copyArray = __webpack_require__(56);
            /**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) return wrapper.clone();
                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
            }
            module1.exports = wrapperClone;
        /***/ },
        /* 489 */ /***/ function(module1, exports) {
            /** Used to match wrap detail comments. */ var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
            /**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
            }
            module1.exports = getWrapDetails;
        /***/ },
        /* 490 */ /***/ function(module1, exports) {
            /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
            /**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function insertWrapDetails(source, details) {
                var length = details.length;
                if (!length) return source;
                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            module1.exports = insertWrapDetails;
        /***/ },
        /* 491 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayEach = __webpack_require__(111), arrayIncludes = __webpack_require__(94);
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
            /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
                [
                    'ary',
                    WRAP_ARY_FLAG
                ],
                [
                    'bind',
                    WRAP_BIND_FLAG
                ],
                [
                    'bindKey',
                    WRAP_BIND_KEY_FLAG
                ],
                [
                    'curry',
                    WRAP_CURRY_FLAG
                ],
                [
                    'curryRight',
                    WRAP_CURRY_RIGHT_FLAG
                ],
                [
                    'flip',
                    WRAP_FLIP_FLAG
                ],
                [
                    'partial',
                    WRAP_PARTIAL_FLAG
                ],
                [
                    'partialRight',
                    WRAP_PARTIAL_RIGHT_FLAG
                ],
                [
                    'rearg',
                    WRAP_REARG_FLAG
                ]
            ];
            /**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function(pair) {
                    var value = '_.' + pair[0];
                    if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
                });
                return details.sort();
            }
            module1.exports = updateWrapDetails;
        /***/ },
        /* 492 */ /***/ function(module1, exports, __webpack_require__) {
            var copyArray = __webpack_require__(56), isIndex = __webpack_require__(67);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
            /**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function reorder(array, indexes) {
                var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
                while(length--){
                    var index = indexes[length];
                    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }
                return array;
            }
            module1.exports = reorder;
        /***/ },
        /* 493 */ /***/ function(module1, exports, __webpack_require__) {
            var apply = __webpack_require__(120), createCtor = __webpack_require__(96), root = __webpack_require__(14);
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
            /**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                    while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                    return apply(fn, isBind ? thisArg : this, args);
                }
                return wrapper;
            }
            module1.exports = createPartial;
        /***/ },
        /* 494 */ /***/ function(module1, exports, __webpack_require__) {
            var composeArgs = __webpack_require__(220), composeArgsRight = __webpack_require__(221), replaceHolders = __webpack_require__(134);
            /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
            /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256;
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
            /**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function mergeData(data, source) {
                var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
                // Exit early if metadata can't be merged.
                if (!(isCommon || isCombo)) return data;
                // Use source `thisArg` if available.
                if (srcBitmask & WRAP_BIND_FLAG) {
                    data[2] = source[2];
                    // Set when currying a bound function.
                    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                }
                // Compose partial arguments.
                var value = source[3];
                if (value) {
                    var partials = data[3];
                    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                }
                // Compose partial right arguments.
                value = source[5];
                if (value) {
                    partials = data[5];
                    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                }
                // Use source `argPos` if available.
                value = source[7];
                if (value) data[7] = value;
                // Use source `ary` if it's smaller.
                if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                // Use source `arity` if one is not provided.
                if (data[9] == null) data[9] = source[9];
                // Use source `func` and merge bitmasks.
                data[0] = source[0];
                data[1] = newBitmask;
                return data;
            }
            module1.exports = mergeData;
        /***/ },
        /* 495 */ /***/ function(module1, exports, __webpack_require__) {
            var toNumber = __webpack_require__(229);
            /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
            /**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
                if (!value) return value === 0 ? value : 0;
                value = toNumber(value);
                if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                }
                return value === value ? value : 0;
            }
            module1.exports = toFinite;
        /***/ },
        /* 496 */ /***/ function(module1, exports, __webpack_require__) {
            var trimmedEndIndex = __webpack_require__(497);
            /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
            /**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
                return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
            }
            module1.exports = baseTrim;
        /***/ },
        /* 497 */ /***/ function(module1, exports) {
            /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
            /**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
                var index = string.length;
                while(index-- && reWhitespace.test(string.charAt(index)));
                return index;
            }
            module1.exports = trimmedEndIndex;
        /***/ },
        /* 498 */ /***/ function(module1, exports, __webpack_require__) {
            var createWrap = __webpack_require__(131);
            /** Used to compose bitmasks for function metadata. */ var WRAP_CURRY_FLAG = 8;
            /**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
            }
            // Assign default placeholders.
            curry.placeholder = {};
            module1.exports = curry;
        /***/ },
        /* 499 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(29), isObjectLike = __webpack_require__(18), isPlainObject = __webpack_require__(135);
            /** `Object#toString` result references. */ var domExcTag = '[object DOMException]', errorTag = '[object Error]';
            /**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function isError(value) {
                if (!isObjectLike(value)) return false;
                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            module1.exports = isError;
        /***/ },
        /* 500 */ /***/ function(module1, exports, __webpack_require__) {
            var getTag = __webpack_require__(42), isObjectLike = __webpack_require__(18);
            /** `Object#toString` result references. */ var weakMapTag = '[object WeakMap]';
            /**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            module1.exports = isWeakMap;
        /***/ },
        /* 501 */ /***/ function(module1, exports, __webpack_require__) {
            var baseClone = __webpack_require__(78), baseIteratee = __webpack_require__(36);
            /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1;
            /**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            module1.exports = iteratee;
        /***/ },
        /* 502 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsMatch = __webpack_require__(503), getMatchData = __webpack_require__(507), matchesStrictComparable = __webpack_require__(235);
            /**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
                var matchData = getMatchData(source);
                if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                return function(object) {
                    return object === source || baseIsMatch(object, source, matchData);
                };
            }
            module1.exports = baseMatches;
        /***/ },
        /* 503 */ /***/ function(module1, exports, __webpack_require__) {
            var Stack = __webpack_require__(79), baseIsEqual = __webpack_require__(230);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
            /**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length, length = index, noCustomizer = !customizer;
                if (object == null) return !length;
                object = Object(object);
                while(index--){
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
                }
                while(++index < length){
                    data = matchData[index];
                    var key = data[0], objValue = object[key], srcValue = data[1];
                    if (noCustomizer && data[2]) {
                        if (objValue === undefined && !(key in object)) return false;
                    } else {
                        var stack = new Stack;
                        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                    }
                }
                return true;
            }
            module1.exports = baseIsMatch;
        /***/ },
        /* 504 */ /***/ function(module1, exports, __webpack_require__) {
            var Stack = __webpack_require__(79), equalArrays = __webpack_require__(231), equalByTag = __webpack_require__(505), equalObjects = __webpack_require__(506), getTag = __webpack_require__(42), isArray = __webpack_require__(12), isBuffer = __webpack_require__(66), isTypedArray = __webpack_require__(86);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
            /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
                if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) return false;
                    objIsArr = true;
                    objIsObj = false;
                }
                if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack);
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }
                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty1.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty1.call(other, '__wrapped__');
                    if (objIsWrapped || othIsWrapped) {
                        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                        stack || (stack = new Stack);
                        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                }
                if (!isSameTag) return false;
                stack || (stack = new Stack);
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            module1.exports = baseIsEqualDeep;
        /***/ },
        /* 505 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40), Uint8Array1 = __webpack_require__(188), eq = __webpack_require__(54), equalArrays = __webpack_require__(231), mapToArray = __webpack_require__(233), setToArray = __webpack_require__(98);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
            /** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
            var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
            /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
            /**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch(tag){
                    case dataViewTag:
                        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                        object = object.buffer;
                        other = other.buffer;
                    case arrayBufferTag:
                        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array1(object), new Uint8Array1(other))) return false;
                        return true;
                    case boolTag:
                    case dateTag:
                    case numberTag:
                        // Coerce booleans to `1` or `0` and dates to milliseconds.
                        // Invalid dates are coerced to `NaN`.
                        return eq(+object, +other);
                    case errorTag:
                        return object.name == other.name && object.message == other.message;
                    case regexpTag:
                    case stringTag:
                        // Coerce regexes to strings and treat strings, primitives and objects,
                        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                        // for more details.
                        return object == other + '';
                    case mapTag:
                        var convert = mapToArray;
                    case setTag:
                        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                        convert || (convert = setToArray);
                        if (object.size != other.size && !isPartial) return false;
                        // Assume cyclic values are equal.
                        var stacked = stack.get(object);
                        if (stacked) return stacked == other;
                        bitmask |= COMPARE_UNORDERED_FLAG;
                        // Recursively compare objects (susceptible to call stack limits).
                        stack.set(object, other);
                        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                        stack['delete'](object);
                        return result;
                    case symbolTag:
                        if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
                return false;
            }
            module1.exports = equalByTag;
        /***/ },
        /* 506 */ /***/ function(module1, exports, __webpack_require__) {
            var getAllKeys = __webpack_require__(183);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                if (objLength != othLength && !isPartial) return false;
                var index = objLength;
                while(index--){
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty1.call(other, key))) return false;
                }
                // Check that cyclic values are equal.
                var objStacked = stack.get(object);
                var othStacked = stack.get(other);
                if (objStacked && othStacked) return objStacked == other && othStacked == object;
                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;
                while(++index < objLength){
                    key = objProps[index];
                    var objValue = object[key], othValue = other[key];
                    if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    // Recursively compare objects (susceptible to call stack limits).
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                        result = false;
                        break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                }
                if (result && !skipCtor) {
                    var objCtor = object.constructor, othCtor = other.constructor;
                    // Non `Object` object instances with different constructors are not equal.
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
                }
                stack['delete'](object);
                stack['delete'](other);
                return result;
            }
            module1.exports = equalObjects;
        /***/ },
        /* 507 */ /***/ function(module1, exports, __webpack_require__) {
            var isStrictComparable = __webpack_require__(234), keys = __webpack_require__(30);
            /**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
                var result = keys(object), length = result.length;
                while(length--){
                    var key = result[length], value = object[key];
                    result[length] = [
                        key,
                        value,
                        isStrictComparable(value)
                    ];
                }
                return result;
            }
            module1.exports = getMatchData;
        /***/ },
        /* 508 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIsEqual = __webpack_require__(230), get = __webpack_require__(59), hasIn = __webpack_require__(237), isKey = __webpack_require__(136), isStrictComparable = __webpack_require__(234), matchesStrictComparable = __webpack_require__(235), toKey = __webpack_require__(47);
            /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
            /**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
                return function(object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
            }
            module1.exports = baseMatchesProperty;
        /***/ },
        /* 509 */ /***/ function(module1, exports, __webpack_require__) {
            var memoize = __webpack_require__(191);
            /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
            /**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
                var result = memoize(func, function(key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                    return key;
                });
                var cache = result.cache;
                return result;
            }
            module1.exports = memoizeCapped;
        /***/ },
        /* 510 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40), arrayMap = __webpack_require__(34), isArray = __webpack_require__(12), isSymbol = __webpack_require__(71);
            /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
            /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            /**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
                // Exit early for strings to avoid a performance hit in some environments.
                if (typeof value == 'string') return value;
                if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
                return arrayMap(value, baseToString) + '';
                if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            module1.exports = baseToString;
        /***/ },
        /* 511 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
                return object != null && key in Object(object);
            }
            module1.exports = baseHasIn;
        /***/ },
        /* 512 */ /***/ function(module1, exports, __webpack_require__) {
            var castPath = __webpack_require__(60), isArguments = __webpack_require__(65), isArray = __webpack_require__(12), isIndex = __webpack_require__(67), isLength = __webpack_require__(112), toKey = __webpack_require__(47);
            /**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1, length = path.length, result = false;
                while(++index < length){
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) break;
                    object = object[key];
                }
                if (result || ++index != length) return result;
                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            module1.exports = hasPath;
        /***/ },
        /* 513 */ /***/ function(module1, exports, __webpack_require__) {
            var baseProperty = __webpack_require__(514), basePropertyDeep = __webpack_require__(515), isKey = __webpack_require__(136), toKey = __webpack_require__(47);
            /**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            module1.exports = property;
        /***/ },
        /* 514 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
                return function(object) {
                    return object == null ? undefined : object[key];
                };
            }
            module1.exports = baseProperty;
        /***/ },
        /* 515 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGet = __webpack_require__(99);
            /**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
                return function(object) {
                    return baseGet(object, path);
                };
            }
            module1.exports = basePropertyDeep;
        /***/ },
        /* 516 */ /***/ function(module1, exports, __webpack_require__) {
            var createWrap = __webpack_require__(131), flatRest = __webpack_require__(137);
            /** Used to compose bitmasks for function metadata. */ var WRAP_REARG_FLAG = 256;
            /**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var rearg = flatRest(function(func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            module1.exports = rearg;
        /***/ },
        /* 517 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFlatten = __webpack_require__(238);
            /**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
            }
            module1.exports = flatten;
        /***/ },
        /* 518 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40), isArguments = __webpack_require__(65), isArray = __webpack_require__(12);
            /** Built-in value references. */ var spreadableSymbol = Symbol1 ? Symbol1.isConcatSpreadable : undefined;
            /**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            module1.exports = isFlattenable;
        /***/ },
        /* 519 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayMap = __webpack_require__(34), copyArray = __webpack_require__(56), isArray = __webpack_require__(12), isSymbol = __webpack_require__(71), stringToPath = __webpack_require__(236), toKey = __webpack_require__(47), toString = __webpack_require__(61);
            /**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
                if (isArray(value)) return arrayMap(value, toKey);
                return isSymbol(value) ? [
                    value
                ] : copyArray(stringToPath(toString(value)));
            }
            module1.exports = toPath;
        /***/ },
        /* 520 */ /***/ function(module1, exports, __webpack_require__) {
            var basePickBy = __webpack_require__(521), hasIn = __webpack_require__(237);
            /**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
                return basePickBy(object, paths, function(value, path) {
                    return hasIn(object, path);
                });
            }
            module1.exports = basePick;
        /***/ },
        /* 521 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGet = __webpack_require__(99), baseSet = __webpack_require__(522), castPath = __webpack_require__(60);
            /**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
                var index = -1, length = paths.length, result = {};
                while(++index < length){
                    var path = paths[index], value = baseGet(object, path);
                    if (predicate(value, path)) baseSet(result, castPath(path, object), value);
                }
                return result;
            }
            module1.exports = basePickBy;
        /***/ },
        /* 522 */ /***/ function(module1, exports, __webpack_require__) {
            var assignValue = __webpack_require__(84), castPath = __webpack_require__(60), isIndex = __webpack_require__(67), isObject = __webpack_require__(11), toKey = __webpack_require__(47);
            /**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
                if (!isObject(object)) return object;
                path = castPath(path, object);
                var index = -1, length = path.length, lastIndex = length - 1, nested = object;
                while(nested != null && ++index < length){
                    var key = toKey(path[index]), newValue = value;
                    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                    if (index != lastIndex) {
                        var objValue = nested[key];
                        newValue = customizer ? customizer(objValue, key, nested) : undefined;
                        if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                }
                return object;
            }
            module1.exports = baseSet;
        /***/ },
        /* 523 */ /***/ function(module1, exports, __webpack_require__) {
            var convert = __webpack_require__(216), func = convert('mapKeys', __webpack_require__(524));
            func.placeholder = __webpack_require__(130);
            module1.exports = func;
        /***/ },
        /* 524 */ /***/ function(module1, exports, __webpack_require__) {
            var baseAssignValue = __webpack_require__(64), baseForOwn = __webpack_require__(100), baseIteratee = __webpack_require__(36);
            /**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function mapKeys(object, iteratee) {
                var result = {};
                iteratee = baseIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
            }
            module1.exports = mapKeys;
        /***/ },
        /* 525 */ /***/ function(module1, exports) {
            /**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            module1.exports = createBaseFor;
        /***/ },
        /* 526 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(module1) {
                var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/punycode v1.4.1 by @mathias */ 
                (function(root) {
                    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
                    var freeModule = module1 && !module1.nodeType && module1;
                    var freeGlobal = typeof window == 'object' && window;
                    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
                    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
                        'overflow': 'Overflow: input needs wider integers to process',
                        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
                        'invalid-input': 'Invalid input'
                    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
                    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
                        throw new RangeError(errors[type]);
                    }
                    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
                        var length = array.length;
                        var result = [];
                        while(length--)result[length] = fn(array[length]);
                        return result;
                    }
                    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
                        var parts = string.split('@');
                        var result = '';
                        if (parts.length > 1) {
                            // In email addresses, only the domain name should be punycoded. Leave
                            // the local part (i.e. everything up to `@`) intact.
                            result = parts[0] + '@';
                            string = parts[1];
                        }
                        // Avoid `split(regex)` for IE8 compatibility. See #17.
                        string = string.replace(regexSeparators, '\x2E');
                        var labels = string.split('.');
                        var encoded = map(labels, fn).join('.');
                        return result + encoded;
                    }
                    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
                        var output = [], counter = 0, length = string.length, value, extra;
                        while(counter < length){
                            value = string.charCodeAt(counter++);
                            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                // high surrogate, and there is a next character
                                extra = string.charCodeAt(counter++);
                                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                else {
                                    // unmatched surrogate; only append this code unit, in case the next
                                    // code unit is the high surrogate of a surrogate pair
                                    output.push(value);
                                    counter--;
                                }
                            } else output.push(value);
                        }
                        return output;
                    }
                    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
                        return map(array, function(value) {
                            var output = '';
                            if (value > 0xFFFF) {
                                value -= 0x10000;
                                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                value = 0xDC00 | value & 0x3FF;
                            }
                            output += stringFromCharCode(value);
                            return output;
                        }).join('');
                    }
                    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
                        if (codePoint - 48 < 10) return codePoint - 22;
                        if (codePoint - 65 < 26) return codePoint - 65;
                        if (codePoint - 97 < 26) return codePoint - 97;
                        return base;
                    }
                    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
                        //  0..25 map to ASCII a..z or A..Z
                        // 26..35 map to ASCII 0..9
                        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                    }
                    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
                        var k = 0;
                        delta = firstTime ? floor(delta / damp) : delta >> 1;
                        delta += floor(delta / numPoints);
                        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                    }
                    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
                        // Don't use UCS-2
                        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
                        // Handle the basic code points: let `basic` be the number of input code
                        // points before the last delimiter, or `0` if there is none, then copy
                        // the first basic code points to the output.
                        basic = input.lastIndexOf(delimiter);
                        if (basic < 0) basic = 0;
                        for(j = 0; j < basic; ++j){
                            // if it's not a basic code point
                            if (input.charCodeAt(j) >= 0x80) error('not-basic');
                            output.push(input.charCodeAt(j));
                        }
                        // Main decoding loop: start just after the last delimiter if any basic code
                        // points were copied; start at the beginning otherwise.
                        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                            // `index` is the index of the next character to be consumed.
                            // Decode a generalized variable-length integer into `delta`,
                            // which gets added to `i`. The overflow checking is easier
                            // if we increase `i` as we go, then subtract off its starting
                            // value at the end to obtain `delta`.
                            for(oldi = i, w = 1, k = base;; k += base){
                                if (index >= inputLength) error('invalid-input');
                                digit = basicToDigit(input.charCodeAt(index++));
                                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                                i += digit * w;
                                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                if (digit < t) break;
                                baseMinusT = base - t;
                                if (w > floor(maxInt / baseMinusT)) error('overflow');
                                w *= baseMinusT;
                            }
                            out = output.length + 1;
                            bias = adapt(i - oldi, out, oldi == 0);
                            // `i` was supposed to wrap around from `out` to `0`,
                            // incrementing `n` each time, so we'll fix that now:
                            if (floor(i / out) > maxInt - n) error('overflow');
                            n += floor(i / out);
                            i %= out;
                            // Insert `n` at position `i` of the output
                            output.splice(i++, 0, n);
                        }
                        return ucs2encode(output);
                    }
                    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
                        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
                        // Convert the input in UCS-2 to Unicode
                        input = ucs2decode(input);
                        // Cache the length
                        inputLength = input.length;
                        // Initialize the state
                        n = initialN;
                        delta = 0;
                        bias = initialBias;
                        // Handle the basic code points
                        for(j = 0; j < inputLength; ++j){
                            currentValue = input[j];
                            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                        }
                        handledCPCount = basicLength = output.length;
                        // `handledCPCount` is the number of code points that have been handled;
                        // `basicLength` is the number of basic code points.
                        // Finish the basic string - if it is not empty - with a delimiter
                        if (basicLength) output.push(delimiter);
                        // Main encoding loop:
                        while(handledCPCount < inputLength){
                            // All non-basic code points < n have been handled already. Find the next
                            // larger one:
                            for(m = maxInt, j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue >= n && currentValue < m) m = currentValue;
                            }
                            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                            // but guard against overflow
                            handledCPCountPlusOne = handledCPCount + 1;
                            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
                            delta += (m - n) * handledCPCountPlusOne;
                            n = m;
                            for(j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue < n && ++delta > maxInt) error('overflow');
                                if (currentValue == n) {
                                    // Represent delta as a generalized variable-length integer
                                    for(q = delta, k = base;; k += base){
                                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                        if (q < t) break;
                                        qMinusT = q - t;
                                        baseMinusT = base - t;
                                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                        q = floor(qMinusT / baseMinusT);
                                    }
                                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                    delta = 0;
                                    ++handledCPCount;
                                }
                            }
                            ++delta;
                            ++n;
                        }
                        return output.join('');
                    }
                    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
                        return mapDomain(input, function(string) {
                            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                        });
                    }
                    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
                        return mapDomain(input, function(string) {
                            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
                        });
                    }
                    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
                        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
                        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
                            'decode': ucs2decode,
                            'encode': ucs2encode
                        },
                        'decode': decode,
                        'encode': encode,
                        'toASCII': toASCII,
                        'toUnicode': toUnicode
                    };
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return punycode;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(85)(module1));
        /***/ },
        /* 527 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                isString: function(arg) {
                    return typeof arg === 'string';
                },
                isObject: function(arg) {
                    return typeof arg === 'object' && arg !== null;
                },
                isNull: function(arg) {
                    return arg === null;
                },
                isNullOrUndefined: function(arg) {
                    return arg == null;
                }
            };
        /***/ },
        /* 528 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.decode = exports.parse = __webpack_require__(529);
            exports.encode = exports.stringify = __webpack_require__(530);
        /***/ },
        /* 529 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            // If obj.hasOwnProperty has been overridden, then calling
            // obj.hasOwnProperty(prop) will break.
            // See: https://github.com/joyent/node/issues/1707
            function hasOwnProperty1(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            }
            module1.exports = function(qs, sep, eq, options) {
                sep = sep || '&';
                eq = eq || '=';
                var obj = {};
                if (typeof qs !== 'string' || qs.length === 0) return obj;
                var regexp = /\+/g;
                qs = qs.split(sep);
                var maxKeys = 1000;
                if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
                var len = qs.length;
                // maxKeys <= 0 means that we should not limit keys count
                if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                for(var i = 0; i < len; ++i){
                    var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
                    if (idx >= 0) {
                        kstr = x.substr(0, idx);
                        vstr = x.substr(idx + 1);
                    } else {
                        kstr = x;
                        vstr = '';
                    }
                    k = decodeURIComponent(kstr);
                    v = decodeURIComponent(vstr);
                    if (!hasOwnProperty1(obj, k)) obj[k] = v;
                    else if (isArray(obj[k])) obj[k].push(v);
                    else obj[k] = [
                        obj[k],
                        v
                    ];
                }
                return obj;
            };
            var isArray = Array.isArray || function(xs) {
                return Object.prototype.toString.call(xs) === '[object Array]';
            };
        /***/ },
        /* 530 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
            var stringifyPrimitive = function(v) {
                switch(typeof v){
                    case 'string':
                        return v;
                    case 'boolean':
                        return v ? 'true' : 'false';
                    case 'number':
                        return isFinite(v) ? v : '';
                    default:
                        return '';
                }
            };
            module1.exports = function(obj, sep, eq, name) {
                sep = sep || '&';
                eq = eq || '=';
                if (obj === null) obj = undefined;
                if (typeof obj === 'object') return map(objectKeys(obj), function(k) {
                    var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                    if (isArray(obj[k])) return map(obj[k], function(v) {
                        return ks + encodeURIComponent(stringifyPrimitive(v));
                    }).join(sep);
                    else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                }).join(sep);
                if (!name) return '';
                return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
            };
            var isArray = Array.isArray || function(xs) {
                return Object.prototype.toString.call(xs) === '[object Array]';
            };
            function map(xs, f) {
                if (xs.map) return xs.map(f);
                var res = [];
                for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
                return res;
            }
            var objectKeys = Object.keys || function(obj) {
                var res = [];
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
                return res;
            };
        /***/ },
        /* 531 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // This method of obtaining a reference to the global object needs to be
            // kept identical to the way it is obtained in runtime.js
            var g = function() {
                return this || typeof self === "object" && self;
            }() || Function("return this")();
            // Use `getOwnPropertyNames` because not all browsers support calling
            // `hasOwnProperty` on the global `self` object in a worker. See #183.
            var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
            // Save the old regeneratorRuntime in case it needs to be restored later.
            var oldRuntime = hadRuntime && g.regeneratorRuntime;
            // Force reevalutation of runtime.js.
            g.regeneratorRuntime = undefined;
            module1.exports = __webpack_require__(532);
            if (hadRuntime) // Restore the original runtime.
            g.regeneratorRuntime = oldRuntime;
            else // Remove the global property added by runtime.js.
            try {
                delete g.regeneratorRuntime;
            } catch (e) {
                g.regeneratorRuntime = undefined;
            }
        /***/ },
        /* 532 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                !function(global) {
                    "use strict";
                    var Op = Object.prototype;
                    var hasOwn = Op.hasOwnProperty;
                    var undefined1; // More compressible than void 0.
                    var $Symbol = typeof Symbol === "function" ? Symbol : {};
                    var iteratorSymbol = $Symbol.iterator || "@@iterator";
                    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
                    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
                    var inModule = typeof module1 === "object";
                    var runtime = global.regeneratorRuntime;
                    if (runtime) {
                        if (inModule) // If regeneratorRuntime is defined globally and we're in a module,
                        // make the exports object identical to regeneratorRuntime.
                        module1.exports = runtime;
                        // Don't bother evaluating the rest of this file if the runtime was
                        // already defined globally.
                        return;
                    }
                    // Define the runtime globally (as expected by generated code) as either
                    // module.exports (if we're in a module) or a new, empty object.
                    runtime = global.regeneratorRuntime = inModule ? module1.exports : {};
                    function wrap(innerFn, outerFn, self1, tryLocsList) {
                        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                        var generator = Object.create(protoGenerator.prototype);
                        var context = new Context(tryLocsList || []);
                        // The ._invoke method unifies the implementations of the .next,
                        // .throw, and .return methods.
                        generator._invoke = makeInvokeMethod(innerFn, self1, context);
                        return generator;
                    }
                    runtime.wrap = wrap;
                    // Try/catch helper to minimize deoptimizations. Returns a completion
                    // record like context.tryEntries[i].completion. This interface could
                    // have been (and was previously) designed to take a closure to be
                    // invoked without arguments, but in all the cases we care about we
                    // already have an existing method we want to call, so there's no need
                    // to create a new function object. We can even get away with assuming
                    // the method takes exactly one argument, since that happens to be true
                    // in every case, so we don't have to touch the arguments object. The
                    // only additional allocation required is the completion record, which
                    // has a stable shape and so hopefully should be cheap to allocate.
                    function tryCatch(fn, obj, arg) {
                        try {
                            return {
                                type: "normal",
                                arg: fn.call(obj, arg)
                            };
                        } catch (err) {
                            return {
                                type: "throw",
                                arg: err
                            };
                        }
                    }
                    var GenStateSuspendedStart = "suspendedStart";
                    var GenStateSuspendedYield = "suspendedYield";
                    var GenStateExecuting = "executing";
                    var GenStateCompleted = "completed";
                    // Returning this object from the innerFn has the same effect as
                    // breaking out of the dispatch switch statement.
                    var ContinueSentinel = {};
                    // Dummy constructor functions that we use as the .constructor and
                    // .constructor.prototype properties for functions that return Generator
                    // objects. For full spec compliance, you may wish to configure your
                    // minifier not to mangle the names of these two functions.
                    function Generator() {}
                    function GeneratorFunction() {}
                    function GeneratorFunctionPrototype() {}
                    // This is a polyfill for %IteratorPrototype% for environments that
                    // don't natively support it.
                    var IteratorPrototype = {};
                    IteratorPrototype[iteratorSymbol] = function() {
                        return this;
                    };
                    var getProto = Object.getPrototypeOf;
                    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
                    // of the polyfill.
                    IteratorPrototype = NativeIteratorPrototype;
                    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
                    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
                    GeneratorFunctionPrototype.constructor = GeneratorFunction;
                    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
                    // Helper for defining the .next, .throw, and .return methods of the
                    // Iterator interface in terms of a single ._invoke method.
                    function defineIteratorMethods(prototype) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(method) {
                            prototype[method] = function(arg) {
                                return this._invoke(method, arg);
                            };
                        });
                    }
                    runtime.isGeneratorFunction = function(genFun) {
                        var ctor = typeof genFun === "function" && genFun.constructor;
                        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
                        // do is to check its .name property.
                        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
                    };
                    runtime.mark = function(genFun) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                        else {
                            genFun.__proto__ = GeneratorFunctionPrototype;
                            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
                        }
                        genFun.prototype = Object.create(Gp);
                        return genFun;
                    };
                    // Within the body of any async function, `await x` is transformed to
                    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
                    // `hasOwn.call(value, "__await")` to determine if the yielded value is
                    // meant to be awaited.
                    runtime.awrap = function(arg) {
                        return {
                            __await: arg
                        };
                    };
                    function AsyncIterator(generator) {
                        function invoke(method, arg, resolve, reject) {
                            var record = tryCatch(generator[method], generator, arg);
                            if (record.type === "throw") reject(record.arg);
                            else {
                                var result = record.arg;
                                var value = result.value;
                                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                                    invoke("next", value, resolve, reject);
                                }, function(err) {
                                    invoke("throw", err, resolve, reject);
                                });
                                return Promise.resolve(value).then(function(unwrapped) {
                                    // When a yielded Promise is resolved, its final value becomes
                                    // the .value of the Promise<{value,done}> result for the
                                    // current iteration.
                                    result.value = unwrapped;
                                    resolve(result);
                                }, function(error) {
                                    // If a rejected Promise was yielded, throw the rejection back
                                    // into the async generator function so it can be handled there.
                                    return invoke("throw", error, resolve, reject);
                                });
                            }
                        }
                        var previousPromise;
                        function enqueue(method, arg) {
                            function callInvokeWithMethodAndArg() {
                                return new Promise(function(resolve, reject) {
                                    invoke(method, arg, resolve, reject);
                                });
                            }
                            return previousPromise = // If enqueue has been called before, then we want to wait until
                            // all previous Promises have been resolved before calling invoke,
                            // so that results are always delivered in the correct order. If
                            // enqueue has not been called before, then it is important to
                            // call invoke immediately, without waiting on a callback to fire,
                            // so that the async generator function has the opportunity to do
                            // any necessary setup in a predictable way. This predictability
                            // is why the Promise constructor synchronously invokes its
                            // executor callback, and why async functions synchronously
                            // execute code before the first await. Since we implement simple
                            // async functions in terms of async generators, it is especially
                            // important to get this right, even though it requires care.
                            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                            // invocations of the iterator.
                            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                        }
                        // Define the unified helper method that is used to implement .next,
                        // .throw, and .return (see defineIteratorMethods).
                        this._invoke = enqueue;
                    }
                    defineIteratorMethods(AsyncIterator.prototype);
                    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
                        return this;
                    };
                    runtime.AsyncIterator = AsyncIterator;
                    // Note that simple async functions are implemented on top of
                    // AsyncIterator objects; they just return a Promise for the value of
                    // the final result produced by the iterator.
                    runtime.async = function(innerFn, outerFn, self1, tryLocsList) {
                        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList));
                        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
                         : iter.next().then(function(result) {
                            return result.done ? result.value : iter.next();
                        });
                    };
                    function makeInvokeMethod(innerFn, self1, context) {
                        var state = GenStateSuspendedStart;
                        return function invoke(method, arg) {
                            if (state === GenStateExecuting) throw new Error("Generator is already running");
                            if (state === GenStateCompleted) {
                                if (method === "throw") throw arg;
                                // Be forgiving, per 25.3.3.3.3 of the spec:
                                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                                return doneResult();
                            }
                            context.method = method;
                            context.arg = arg;
                            while(true){
                                var delegate = context.delegate;
                                if (delegate) {
                                    var delegateResult = maybeInvokeDelegate(delegate, context);
                                    if (delegateResult) {
                                        if (delegateResult === ContinueSentinel) continue;
                                        return delegateResult;
                                    }
                                }
                                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                                // function.sent implementation.
                                context.sent = context._sent = context.arg;
                                else if (context.method === "throw") {
                                    if (state === GenStateSuspendedStart) {
                                        state = GenStateCompleted;
                                        throw context.arg;
                                    }
                                    context.dispatchException(context.arg);
                                } else if (context.method === "return") context.abrupt("return", context.arg);
                                state = GenStateExecuting;
                                var record = tryCatch(innerFn, self1, context);
                                if (record.type === "normal") {
                                    // If an exception is thrown from innerFn, we leave state ===
                                    // GenStateExecuting and loop back for another invocation.
                                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                                    if (record.arg === ContinueSentinel) continue;
                                    return {
                                        value: record.arg,
                                        done: context.done
                                    };
                                } else if (record.type === "throw") {
                                    state = GenStateCompleted;
                                    // Dispatch the exception by looping back around to the
                                    // context.dispatchException(context.arg) call above.
                                    context.method = "throw";
                                    context.arg = record.arg;
                                }
                            }
                        };
                    }
                    // Call delegate.iterator[context.method](context.arg) and handle the
                    // result, either by returning a { value, done } result from the
                    // delegate iterator, or by modifying context.method and context.arg,
                    // setting context.delegate to null, and returning the ContinueSentinel.
                    function maybeInvokeDelegate(delegate, context) {
                        var method = delegate.iterator[context.method];
                        if (method === undefined1) {
                            // A .throw or .return when the delegate iterator has no .throw
                            // method always terminates the yield* loop.
                            context.delegate = null;
                            if (context.method === "throw") {
                                if (delegate.iterator.return) {
                                    // If the delegate iterator has a return method, give it a
                                    // chance to clean up.
                                    context.method = "return";
                                    context.arg = undefined1;
                                    maybeInvokeDelegate(delegate, context);
                                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                                    // "return" to "throw", let that override the TypeError below.
                                    return ContinueSentinel;
                                }
                                context.method = "throw";
                                context.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return ContinueSentinel;
                        }
                        var record = tryCatch(method, delegate.iterator, context.arg);
                        if (record.type === "throw") {
                            context.method = "throw";
                            context.arg = record.arg;
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        var info = record.arg;
                        if (!info) {
                            context.method = "throw";
                            context.arg = new TypeError("iterator result is not an object");
                            context.delegate = null;
                            return ContinueSentinel;
                        }
                        if (info.done) {
                            // Assign the result of the finished delegate to the temporary
                            // variable specified by delegate.resultName (see delegateYield).
                            context[delegate.resultName] = info.value;
                            // Resume execution at the desired location (see delegateYield).
                            context.next = delegate.nextLoc;
                            // If context.method was "throw" but the delegate handled the
                            // exception, let the outer generator proceed normally. If
                            // context.method was "next", forget context.arg since it has been
                            // "consumed" by the delegate iterator. If context.method was
                            // "return", allow the original .return call to continue in the
                            // outer generator.
                            if (context.method !== "return") {
                                context.method = "next";
                                context.arg = undefined1;
                            }
                        } else // Re-yield the result returned by the delegate method.
                        return info;
                        // The delegate iterator is finished, so forget it and continue with
                        // the outer generator.
                        context.delegate = null;
                        return ContinueSentinel;
                    }
                    // Define Generator.prototype.{next,throw,return} in terms of the
                    // unified ._invoke helper method.
                    defineIteratorMethods(Gp);
                    Gp[toStringTagSymbol] = "Generator";
                    // A Generator should always return itself as the iterator object when the
                    // @@iterator function is called on it. Some browsers' implementations of the
                    // iterator prototype chain incorrectly implement this, causing the Generator
                    // object to not be returned from this call. This ensures that doesn't happen.
                    // See https://github.com/facebook/regenerator/issues/274 for more details.
                    Gp[iteratorSymbol] = function() {
                        return this;
                    };
                    Gp.toString = function() {
                        return "[object Generator]";
                    };
                    function pushTryEntry(locs) {
                        var entry = {
                            tryLoc: locs[0]
                        };
                        if (1 in locs) entry.catchLoc = locs[1];
                        if (2 in locs) {
                            entry.finallyLoc = locs[2];
                            entry.afterLoc = locs[3];
                        }
                        this.tryEntries.push(entry);
                    }
                    function resetTryEntry(entry) {
                        var record = entry.completion || {};
                        record.type = "normal";
                        delete record.arg;
                        entry.completion = record;
                    }
                    function Context(tryLocsList) {
                        // The root entry object (effectively a try statement without a catch
                        // or a finally block) gives us a place to store values thrown from
                        // locations where there is no enclosing try statement.
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ];
                        tryLocsList.forEach(pushTryEntry, this);
                        this.reset(true);
                    }
                    runtime.keys = function(object) {
                        var keys = [];
                        for(var key in object)keys.push(key);
                        keys.reverse();
                        // Rather than returning an object with a next method, we keep
                        // things simple and return the next function itself.
                        return function next() {
                            while(keys.length){
                                var key = keys.pop();
                                if (key in object) {
                                    next.value = key;
                                    next.done = false;
                                    return next;
                                }
                            }
                            // To avoid creating an additional object, we just hang the .value
                            // and .done properties off the next function object itself. This
                            // also ensures that the minifier will not anonymize the function.
                            next.done = true;
                            return next;
                        };
                    };
                    function values(iterable) {
                        if (iterable) {
                            var iteratorMethod = iterable[iteratorSymbol];
                            if (iteratorMethod) return iteratorMethod.call(iterable);
                            if (typeof iterable.next === "function") return iterable;
                            if (!isNaN(iterable.length)) {
                                var i = -1, next = function next() {
                                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                    next.value = undefined1;
                                    next.done = true;
                                    return next;
                                };
                                return next.next = next;
                            }
                        }
                        // Return an iterator with no values.
                        return {
                            next: doneResult
                        };
                    }
                    runtime.values = values;
                    function doneResult() {
                        return {
                            value: undefined1,
                            done: true
                        };
                    }
                    Context.prototype = {
                        constructor: Context,
                        reset: function(skipTempReset) {
                            this.prev = 0;
                            this.next = 0;
                            // Resetting context._sent for legacy support of Babel's
                            // function.sent implementation.
                            this.sent = this._sent = undefined1;
                            this.done = false;
                            this.delegate = null;
                            this.method = "next";
                            this.arg = undefined1;
                            this.tryEntries.forEach(resetTryEntry);
                            if (!skipTempReset) {
                                for(var name in this)// Not sure about the optimal order of these conditions:
                                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined1;
                            }
                        },
                        stop: function() {
                            this.done = true;
                            var rootEntry = this.tryEntries[0];
                            var rootRecord = rootEntry.completion;
                            if (rootRecord.type === "throw") throw rootRecord.arg;
                            return this.rval;
                        },
                        dispatchException: function(exception) {
                            if (this.done) throw exception;
                            var context = this;
                            function handle(loc, caught) {
                                record.type = "throw";
                                record.arg = exception;
                                context.next = loc;
                                if (caught) {
                                    // If the dispatched exception was caught by a catch block,
                                    // then let that catch block handle the exception normally.
                                    context.method = "next";
                                    context.arg = undefined1;
                                }
                                return !!caught;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                var record = entry.completion;
                                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                                // it, so set the completion value of the entire function to
                                // throw the exception.
                                return handle("end");
                                if (entry.tryLoc <= this.prev) {
                                    var hasCatch = hasOwn.call(entry, "catchLoc");
                                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                                    if (hasCatch && hasFinally) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else if (hasCatch) {
                                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                                    } else if (hasFinally) {
                                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                    } else throw new Error("try statement without catch or finally");
                                }
                            }
                        },
                        abrupt: function(type, arg) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                                    var finallyEntry = entry;
                                    break;
                                }
                            }
                            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
                            // location outside the try/catch block.
                            finallyEntry = null;
                            var record = finallyEntry ? finallyEntry.completion : {};
                            record.type = type;
                            record.arg = arg;
                            if (finallyEntry) {
                                this.method = "next";
                                this.next = finallyEntry.finallyLoc;
                                return ContinueSentinel;
                            }
                            return this.complete(record);
                        },
                        complete: function(record, afterLoc) {
                            if (record.type === "throw") throw record.arg;
                            if (record.type === "break" || record.type === "continue") this.next = record.arg;
                            else if (record.type === "return") {
                                this.rval = this.arg = record.arg;
                                this.method = "return";
                                this.next = "end";
                            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
                            return ContinueSentinel;
                        },
                        finish: function(finallyLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.finallyLoc === finallyLoc) {
                                    this.complete(entry.completion, entry.afterLoc);
                                    resetTryEntry(entry);
                                    return ContinueSentinel;
                                }
                            }
                        },
                        "catch": function(tryLoc) {
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var entry = this.tryEntries[i];
                                if (entry.tryLoc === tryLoc) {
                                    var record = entry.completion;
                                    if (record.type === "throw") {
                                        var thrown = record.arg;
                                        resetTryEntry(entry);
                                    }
                                    return thrown;
                                }
                            }
                            // The context.catch method must only be called with a location
                            // argument that corresponds to a known catch block.
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(iterable, resultName, nextLoc) {
                            this.delegate = {
                                iterator: values(iterable),
                                resultName: resultName,
                                nextLoc: nextLoc
                            };
                            if (this.method === "next") // Deliberately forget the last sent value so that we don't
                            // accidentally pass it on to the delegate.
                            this.arg = undefined1;
                            return ContinueSentinel;
                        }
                    };
                }(// In sloppy mode, unbound `this` refers to the global object, fallback to
                // Function constructor if we're in global strict mode. That is sadly a form
                // of indirect eval which violates Content Security Policy.
                function() {
                    return this || typeof self === "object" && self;
                }() || Function("return this")());
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 533 */ /***/ function(module1, exports, __webpack_require__) {
            var rng = __webpack_require__(242);
            var bytesToUuid = __webpack_require__(243);
            // **`v1()` - Generate time-based UUID**
            //
            // Inspired by https://github.com/LiosK/UUID.js
            // and http://docs.python.org/library/uuid.html
            var _nodeId;
            var _clockseq;
            // Previous uuid creation time
            var _lastMSecs = 0;
            var _lastNSecs = 0;
            // See https://github.com/uuidjs/uuid for API details
            function v1(options, buf, offset) {
                var i = buf && offset || 0;
                var b = buf || [];
                options = options || {};
                var node = options.node || _nodeId;
                var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
                // node and clockseq need to be initialized to random values if they're not
                // specified.  We do this lazily to minimize issues related to insufficient
                // system entropy.  See #189
                if (node == null || clockseq == null) {
                    var seedBytes = rng();
                    if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
                    node = _nodeId = [
                        seedBytes[0] | 0x01,
                        seedBytes[1],
                        seedBytes[2],
                        seedBytes[3],
                        seedBytes[4],
                        seedBytes[5]
                    ];
                    if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
                    clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
                }
                // UUID timestamps are 100 nano-second units since the Gregorian epoch,
                // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
                // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
                // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
                var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
                // Per 4.2.1.2, use count of uuid's generated during the current clock
                // cycle to simulate higher resolution clock
                var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
                // Time since last uuid creation (in msecs)
                var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
                // Per 4.2.1.2, Bump clockseq on clock regression
                if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
                // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
                // time interval
                if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
                // Per 4.2.1.2 Throw error if too many uuids are requested
                if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
                _lastMSecs = msecs;
                _lastNSecs = nsecs;
                _clockseq = clockseq;
                // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
                msecs += 12219292800000;
                // `time_low`
                var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
                b[i++] = tl >>> 24 & 0xff;
                b[i++] = tl >>> 16 & 0xff;
                b[i++] = tl >>> 8 & 0xff;
                b[i++] = tl & 0xff;
                // `time_mid`
                var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
                b[i++] = tmh >>> 8 & 0xff;
                b[i++] = tmh & 0xff;
                // `time_high_and_version`
                b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
                b[i++] = tmh >>> 16 & 0xff;
                // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
                b[i++] = clockseq >>> 8 | 0x80;
                // `clock_seq_low`
                b[i++] = clockseq & 0xff;
                // `node`
                for(var n = 0; n < 6; ++n)b[i + n] = node[n];
                return buf ? buf : bytesToUuid(b);
            }
            module1.exports = v1;
        /***/ },
        /* 534 */ /***/ function(module1, exports, __webpack_require__) {
            var rng = __webpack_require__(242);
            var bytesToUuid = __webpack_require__(243);
            function v4(options, buf, offset) {
                var i = buf && offset || 0;
                if (typeof options == 'string') {
                    buf = options === 'binary' ? new Array(16) : null;
                    options = null;
                }
                options = options || {};
                var rnds = options.random || (options.rng || rng)();
                // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
                rnds[6] = rnds[6] & 0x0f | 0x40;
                rnds[8] = rnds[8] & 0x3f | 0x80;
                // Copy bytes to buffer, if provided
                if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
                return buf || bytesToUuid(rnds);
            }
            module1.exports = v4;
        /***/ },
        /* 535 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            const assign = __webpack_require__(9);
            const logging = __webpack_require__(2)('analytics');
            const QueueRunner = __webpack_require__(536);
            const uuid = __webpack_require__(16);
            const defaultAjax = __webpack_require__(244);
            const _require = __webpack_require__(138), prependProxyToUrlIfNeeded = _require.prependProxyToUrlIfNeeded;
            const _require2 = __webpack_require__(139), getProxyUrl = _require2.getProxyUrl;
            const clientInstanceId = uuid();
            const defaultQueue = new QueueRunner();
            module1.exports = function Analytics(_ref) {
                var _this = this;
                let loggingUrl = _ref.loggingUrl, _ref$queue = _ref.queue, queue = _ref$queue === void 0 ? defaultQueue : _ref$queue, _ref$ajax = _ref.ajax, ajax = _ref$ajax === void 0 ? defaultAjax : _ref$ajax;
                this.loggingUrl = loggingUrl;
                this.updateEndPoints = ()=>{
                    if (!this.proxyUrl) {
                        this.proxyUrl = getProxyUrl();
                        const prependedUrl = prependProxyToUrlIfNeeded(this.loggingUrl, this.proxyUrl);
                        this.loggingUrl = prependedUrl;
                    }
                    this.endPoint = `${this.loggingUrl}/logging/ClientEvent`;
                    this.endPointQos = `${this.loggingUrl}/logging/ClientQos`;
                };
                this.updateEndPoints();
                const reportedErrors = {};
                const post = function post(data, onComplete, isQos) {
                    if (onComplete === void 0) onComplete = ()=>{};
                    queue.add((callback)=>{
                        logging.debug('sending analytics:', _this.loggingUrl, data);
                        ajax.post(isQos ? _this.endPointQos : _this.endPoint, {
                            body: data,
                            overrideMimeType: 'text/plain',
                            headers: {
                                Accept: 'text/plain',
                                'Content-Type': 'application/json'
                            }
                        }, (err)=>{
                            if (err) logging.debug('Failed to send ClientEvent, moving on to the next item.');
                            onComplete(err || undefined);
                            callback();
                        });
                    });
                };
                const shouldThrottleError = (code, type, partnerId)=>{
                    if (!partnerId) return false;
                    const errKey = [
                        partnerId,
                        type,
                        code
                    ].join('_');
                    const msgLimit = 100;
                    return (reportedErrors[errKey] || 0) >= msgLimit;
                }; // Log an error via ClientEvents.
                //
                // @param [String] code
                // @param [String] type
                // @param [String] message
                // @param [Hash] details additional error details
                //
                // @param [Hash] options the options to log the client event with.
                // @option options [String] action The name of the Event that we are logging. E.g.
                //  'TokShowLoaded'. Required.
                // @option options [String] variation Usually used for Split A/B testing, when you
                //  have multiple variations of the +_action+.
                // @option options [String] payload The payload. Required.
                // @option options [String] sessionId The active OpenTok session, if there is one
                // @option options [String] connectionId The active OpenTok connectionId, if there is one
                // @option options [String] partnerId
                // @option options [String] guid ...
                // @option options [String] streamId ...
                // @option options [String] section ...
                // @option options [String] clientVersion ...
                //
                // Reports will be throttled to X reports (see exceptionLogging.messageLimitPerPartner
                // from the dynamic config for X) of each error type for each partner. Reports can be
                // disabled/enabled globally or on a per partner basis (per partner settings
                // take precedence) using exceptionLogging.enabled.
                //
                this.logError = function(code, type, message, details, options) {
                    if (details === void 0) details = null;
                    if (options === void 0) options = {};
                    const _options = options, partnerId = _options.partnerId;
                    if (shouldThrottleError(code, type, partnerId)) // OT.log('ClientEvents.error has throttled an error of type ' + type + '.' +
                    // code + ' for partner ' + (partnerId || 'No Partner Id'));
                    return;
                    const errKey = [
                        partnerId,
                        type,
                        code
                    ].join('_');
                    const payload = details;
                    reportedErrors[errKey] = typeof reportedErrors[errKey] !== 'undefined' ? reportedErrors[errKey] + 1 : 1;
                    _this.logEvent(assign(options, {
                        action: `${type}.${code}`,
                        payload: payload
                    }), false);
                }; // Log a client event to the analytics backend.
                //
                // @example Logs a client event called 'foo'
                //  this.logEvent({
                //      action: 'foo',
                //      payload: 'bar',
                //      sessionId: sessionId,
                //      connectionId: connectionId
                //  }, false)
                //
                // @param [Hash] data the data to log the client event with.
                // @param [Boolean] qos Whether this is a QoS event.
                // @param [Boolean] throttle A number specifying the ratio of events to be sent
                //        out of the total number of events (other events are not ignored). If not
                //        set to a number, all events are sent.
                // @param [Number] completionHandler A completion handler function to call when the
                //                 client event POST request succeeds or fails. If it fails, an error
                //                 object is passed into the function. (See throttledPost().)
                //
                this.logEvent = function(eventData, qos, throttle, completionHandler) {
                    if (qos === void 0) qos = false;
                    if (completionHandler === void 0) completionHandler = ()=>{};
                    _this.updateEndPoints();
                    const data = (0, _extends2.default)({}, eventData, {
                        clientInstanceId: clientInstanceId
                    });
                    if (throttle && !isNaN(throttle)) {
                        if (Math.random() > throttle) {
                            logging.debug('skipping sending analytics due to throttle:', data);
                            return;
                        }
                    }
                    logging.debug('queueing analytics:', _this.loggingUrl, data);
                    let serializedData;
                    try {
                        serializedData = JSON.stringify(data);
                    } catch (err) {
                        completionHandler(err);
                        return;
                    }
                    post(serializedData, completionHandler, qos);
                }; // Log a client QOS to the analytics backend.
                // @option options [String] action The name of the Event that we are logging.
                //  E.g. 'TokShowLoaded'. Required.
                // @option options [String] variation Usually used for Split A/B testing, when
                //  you have multiple variations of the +_action+.
                // @option options [String] payload The payload. Required.
                // @option options [String] sessionId The active OpenTok session, if there is one
                // @option options [String] connectionId The active OpenTok connectionId, if there is one
                // @option options [String] partnerId
                // @option options [String] guid ...
                // @option options [String] streamId ...
                // @option options [String] section ...
                // @option options [String] clientVersion ...
                //
                this.logQOS = (options)=>this.logEvent(options, true);
            };
        /***/ },
        /* 536 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            let QueueRunner = /*#__PURE__*/ function() {
                function QueueRunner(_temp) {
                    let _ref = _temp === void 0 ? {} : _temp, _ref$waitTime = _ref.waitTime, waitTime = _ref$waitTime === void 0 ? 50 : _ref$waitTime;
                    (0, _defineProperty2.default)(this, "queue", []);
                    (0, _defineProperty2.default)(this, "running", false);
                    this.waitTime = waitTime;
                }
                var _proto = QueueRunner.prototype;
                _proto.add = function add(fn) {
                    this.queue.push(fn);
                    this.run();
                };
                _proto.run = function run() {
                    if (this.running) return;
                    this.running = true;
                    const loop = ()=>{
                        if (this.queue.length === 0) {
                            this.running = false;
                            return;
                        }
                        const fn = this.queue.shift();
                        fn(()=>{
                            setTimeout(loop, this.waitTime);
                        });
                    };
                    loop();
                };
                return QueueRunner;
            }();
            module1.exports = QueueRunner;
        /***/ },
        /* 537 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-void, no-underscore-dangle */ const isObject = __webpack_require__(11);
            const specialDomProperties = {
                for: 'htmlFor',
                class: 'className'
            };
            module1.exports = function(ElementCollection) {
                // Gets or sets the attribute called +name+ for the first element in the collection
                ElementCollection.prototype.attr = function(name, value) {
                    if (isObject(name)) {
                        let actualName;
                        Object.keys(name).forEach((key)=>{
                            actualName = specialDomProperties[key] || key;
                            this.first.setAttribute(actualName, name[key]);
                        });
                    } else if (value === void 0) return this.first.getAttribute(specialDomProperties[name] || name);
                    else this.first.setAttribute(specialDomProperties[name] || name, value);
                    return this;
                }; // Removes an attribute called +name+ for the every element in the collection.
                ElementCollection.prototype.removeAttr = function(name) {
                    const actualName = specialDomProperties[name] || name;
                    this.forEach((element)=>{
                        element.removeAttribute(actualName);
                    });
                    return this;
                }; // Gets, and optionally sets, the html body of the first element
                // in the collection. If the +html+ is provided then the first
                // element's html body will be replaced with it.
                //
                ElementCollection.prototype.html = function(html) {
                    if (html !== void 0) this.first.innerHTML = html;
                    return this.first.innerHTML;
                }; // Centers +element+ within the global. You can pass through the width and height
                // if you know it, if you don't they will be calculated for you.
                ElementCollection.prototype.center = function(width, height) {
                    let $element;
                    this.forEach((element)=>{
                        $element = new ElementCollection(element);
                        width = width || parseInt($element.width(), 10);
                        height = height || parseInt($element.height(), 10);
                        const marginLeft = `${-0.5 * width}px`;
                        const marginTop = `${-0.5 * height}px`;
                        $element.css('margin', `${marginTop} 0 0 ${marginLeft}`).addClass('OT_centered');
                    });
                    return this;
                }; // @remove
                // Centers +element+ within the global. You can pass through the width and height
                // if you know it, if you don't they will be calculated for you.
                ElementCollection._attachToOTHelpers.centerElement = function(element, width, height) {
                    return new ElementCollection(element).center(width, height);
                };
                /**
   * Methods to calculate element widths and heights.
   */ const _width = function _width(element) {
                    if (element.offsetWidth > 0) return `${element.offsetWidth}px`;
                    return new ElementCollection(element).css('width');
                };
                const _height = function _height(element) {
                    if (element.offsetHeight > 0) return `${element.offsetHeight}px`;
                    return new ElementCollection(element).css('height');
                };
                ElementCollection.prototype.width = function(newWidth) {
                    if (newWidth) {
                        this.css('width', newWidth);
                        return this;
                    }
                    if (this.isDisplayNone()) return this.makeVisibleAndYield((element)=>_width(element))[0];
                    return _width(this.get(0));
                }; // @remove
                ElementCollection._attachToOTHelpers.width = function(element, newWidth) {
                    const ret = new ElementCollection(element).width(newWidth);
                    return newWidth ? ElementCollection._attachToOTHelpers : ret;
                };
                ElementCollection.prototype.height = function(newHeight) {
                    if (newHeight) {
                        this.css('height', newHeight);
                        return this;
                    }
                    if (this.isDisplayNone()) // We can't get the height, probably since the element is hidden.
                    return this.makeVisibleAndYield((element)=>_height(element))[0];
                    return _height(this.get(0));
                }; // @remove
                ElementCollection._attachToOTHelpers.height = function(element, newHeight) {
                    const ret = new ElementCollection(element).height(newHeight);
                    return newHeight ? ElementCollection._attachToOTHelpers : ret;
                };
            };
        /***/ },
        /* 538 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable import/newline-after-import, prefer-const, no-restricted-syntax */ /* eslint-disable no-prototype-builtins, no-param-reassign, one-var, no-void */ const env = __webpack_require__(3);
            const getCompStyle = window.getComputedStyle;
            const VENDOR_PREFIXES = {
                Firefox: 'moz',
                Opera: 'O',
                Chrome: 'Webkit',
                Safari: 'Webkit'
            };
            function vendorPrefix() {
                return VENDOR_PREFIXES[env.name];
            }
            module1.exports = function(ElementCollection, findElementWithDisplayNone) {
                const displayStateCache = {};
                const defaultDisplays = {};
                const defaultDisplayValueForElement = function defaultDisplayValueForElement(element) {
                    if (defaultDisplays[element.ownerDocument] && defaultDisplays[element.ownerDocument][element.nodeName]) return defaultDisplays[element.ownerDocument][element.nodeName];
                    if (!defaultDisplays[element.ownerDocument]) defaultDisplays[element.ownerDocument] = {};
                     // We need to know what display value to use for this node. The easiest way
                    // is to actually create a node and read it out.
                    let testNode = element.ownerDocument.createElement(element.nodeName);
                    let defaultDisplay;
                    element.ownerDocument.body.appendChild(testNode);
                    defaultDisplay = new ElementCollection(testNode).css('display');
                    defaultDisplays[element.ownerDocument][element.nodeName] = defaultDisplay;
                    new ElementCollection(testNode).remove();
                    testNode = null;
                    return defaultDisplay;
                };
                const isHidden = function isHidden(element) {
                    const computedStyle = getCompStyle(element);
                    return computedStyle.getPropertyValue('display') === 'none';
                };
                const getNormalisedPropName = function getNormalisedPropName(element, name) {
                    if (name in element.style) return name;
                     // Try vendored names next
                    const prefix = vendorPrefix();
                    const capitalName = prefix + name[0].toUpperCase() + name.slice(1);
                    if (capitalName in element.style) return capitalName;
                    return name;
                };
                const setCssProperties = function setCssProperties(element, hash) {
                    const style = element.style;
                    for(const cssName in hash)if (hash.hasOwnProperty(cssName)) style[getNormalisedPropName(element, cssName)] = hash[cssName];
                };
                const setCssProperty = function setCssProperty(element, name, value) {
                    element.style[getNormalisedPropName(element, name)] = value;
                };
                const getCssProperty = function getCssProperty(element, unnormalisedName) {
                    const name = getNormalisedPropName(element, unnormalisedName);
                    const computedStyle = getCompStyle(element);
                    let currentValue = computedStyle.getPropertyValue(name);
                    if (currentValue === '') currentValue = element.style[name];
                    return currentValue;
                };
                const applyCSS = function applyCSS(element, styles, callback) {
                    const $element = new ElementCollection(element);
                    const oldStyles = {};
                    let name, ret; // Backup the old styles
                    for(name in styles)if (styles.hasOwnProperty(name)) {
                        // We intentionally read out of style here, instead of using the css
                        // helper. This is because the css helper uses querySelector and we
                        // only want to pull values out of the style (domeElement.style) hash.
                        oldStyles[name] = element.style[name];
                        $element.css(name, styles[name]);
                    }
                    ret = callback(element); // Restore the old styles
                    for(name in styles)if (styles.hasOwnProperty(name)) $element.css(name, oldStyles[name] || '');
                    return ret;
                };
                ElementCollection.prototype.show = function() {
                    return this.forEach((element)=>{
                        const display = element.style.display;
                        if (display === '' || display === 'none') {
                            element.style.display = displayStateCache[element] || '';
                            delete displayStateCache[element];
                        }
                        if (isHidden(element)) {
                            // It's still hidden so there's probably a stylesheet that declares this
                            // element as display:none;
                            displayStateCache[element] = 'none';
                            element.style.display = defaultDisplayValueForElement(element);
                        }
                    });
                };
                ElementCollection.prototype.hide = function() {
                    return this.forEach((element)=>{
                        if (element.style.display === 'none') return;
                        displayStateCache[element] = element.style.display;
                        element.style.display = 'none';
                    });
                };
                ElementCollection.prototype.css = function(nameOrHash, value) {
                    if (this.length === 0) // FIXME: I made this `return undefined` to preserve behaviour, but `return this` is probably
                    // more consistent.
                    return undefined;
                    if (typeof nameOrHash !== 'string') return this.forEach((element)=>{
                        setCssProperties(element, nameOrHash);
                    });
                    if (value !== undefined) return this.forEach((element)=>{
                        setCssProperty(element, nameOrHash, value);
                    });
                    return getCssProperty(this.first, nameOrHash, value);
                }; // Make +element+ visible while executing +callback+.
                ElementCollection.prototype.makeVisibleAndYield = function(callback) {
                    const hiddenVisually = {
                        display: 'block',
                        visibility: 'hidden'
                    };
                    const results = [];
                    this.forEach((element)=>{
                        // find whether it's the element or an ancestor that's display none and
                        // then apply to whichever it is
                        const targetElement = findElementWithDisplayNone(element);
                        if (!targetElement) results.push(void 0);
                        else results.push(applyCSS(targetElement, hiddenVisually, callback));
                    });
                    return results;
                };
            };
        /***/ },
        /* 539 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(process) {
                /*
 * Environment details
 *
 * Contains information about the current environment.
 *
 * @property name The name of the Environment (Chrome, FF, Node, etc)
 * @property version Usually a Float, except in Node which uses a String
 * @property userAgent The raw user agent
 * @property isiOS Whether the client is on iOS
 * @property isElectron Whether the client is Electron
 * @property isOpera Whether the client is Opera
 * @property isFirefox Whether the client is Firefox
 * @property isEdge Whether the client is isEdge (legacy or chromiumedge)
 * @property isChromiumEdge Whether the client is isChromiumEdge (version >= 79)
 * @property isLegacyEdge Whether the client is isLegacyEdge (version < 79)
 * @property isLegacyElectron Whether the client is isLegacyElectron,
 * used for testing purposes (version < 7)
 * @property isLegacyChrome Whether the client is isLegacyChrome,
 * used for testing purposes (version < 87)
 * @property isAndroid Whether the client is an Android device
 * @property protocol The protocol property of the URL
 * @property hostName The domain of the URL
 */ const _require = __webpack_require__(540), isiPhone = _require.isiPhone, isiPad = _require.isiPad, isiOS = _require.isiOS;
                const iOSVersion = __webpack_require__(541);
                const getElectronVersion = __webpack_require__(542);
                const isElectron = (navigator1)=>{
                    var _global, _navigator;
                    // eslint-disable-next-line no-param-reassign
                    navigator1 = navigator1 || ((_global = window) == null ? void 0 : _global.navigator);
                    return ((_navigator = navigator1) == null ? void 0 : _navigator.userAgent.toLowerCase().indexOf('electron')) >= 0;
                };
                const isNode = ()=>{
                    var _global2, _global2$process, _global2$process$vers;
                    return typeof ((_global2 = window) == null ? void 0 : (_global2$process = _global2.process) == null ? void 0 : (_global2$process$vers = _global2$process.versions) == null ? void 0 : _global2$process$vers.node) === 'string' && !isElectron();
                };
                let env;
                const resetEnv = ()=>{
                    env = {
                        // @todo why is the default -1?;
                        version: -1,
                        name: 'unknown'
                    };
                };
                const parseNode = ()=>{
                    env.name = 'Node';
                    env.isNode = true;
                    env.version = parseInt(process.versions.node, 10);
                    env.userAgent = `${env.name} ${env.version}`;
                };
                const parseBrowser = (navigator1)=>{
                    // eslint-disable-next-line global-require, no-param-reassign
                    navigator1 = navigator1 || window.navigator;
                    env.userAgent = navigator1.userAgent.toLowerCase(); // @todo why lowercase?
                    env.name = 'unknown';
                    if (env.userAgent.indexOf('opera') > -1 || env.userAgent.indexOf('opr/') > -1) {
                        env.name = 'Opera';
                        env.isOpera = true;
                        if (/opr\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) env.version = parseFloat(RegExp.$1);
                    } else if (env.userAgent.indexOf('firefox') > -1) {
                        env.name = 'Firefox';
                        env.isFirefox = true;
                        if (/firefox\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) env.version = parseFloat(RegExp.$1);
                    } else if (env.userAgent.match(/edge?\/(\d+)(?:\.\d+)+$/)) {
                        env.name = 'Edge';
                        env.isEdge = true;
                        const version = RegExp.$1;
                        env.version = parseInt(version, 10);
                    } else if (env.userAgent.indexOf('chrome') > -1) {
                        env.name = 'Chrome';
                        env.isElectron = isElectron(navigator1);
                        if (!env.isElectron) env.isChrome = true;
                        else env.electronVersion = getElectronVersion(navigator1.userAgent);
                        if (/chrome\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) env.version = parseFloat(RegExp.$1);
                    } else if (navigator1.vendor && navigator1.vendor.toLowerCase().indexOf('apple') > -1) {
                        env.name = 'Safari';
                        env.isSafari = true;
                        env.isiPhone = isiPhone(navigator1.userAgent);
                        env.isiPad = isiPad(navigator1.userAgent);
                        env.isiOS = isiOS(navigator1.userAgent);
                        if (env.isiOS) env.iOSVersion = iOSVersion(navigator1.userAgent);
                        if (/version\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) env.version = parseFloat(RegExp.$1);
                        else if (/fxios\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) // This gets the version from Firefox in iOS
                        env.version = parseFloat(RegExp.$1);
                        else if (/crios\/([0-9]{1,}[.0-9]{0,})/.exec(env.userAgent) !== null) // This gets the version from Chrome in iOS
                        env.version = parseFloat(RegExp.$1);
                    } else if (env.userAgent.indexOf('applewebkit') > -1) // From https://stackoverflow.com/questions/4460205/detect-ipad-iphone-webview-via-javascript
                    {
                        if (env.userAgent.indexOf('version') === -1) env.isIosWebView = true;
                    } // The Chromium-based Edge was released on this version
                    env.isChromiumEdge = env.name === 'Edge' && env.version >= 79; // Prior versions ofo Edge versions were based on a proprietary, non-Chromium
                    // code base
                    env.isLegacyEdge = env.name === 'Edge' && env.version < 79;
                    env.isLegacyElectron = env.isElectron && env.electronVersion < 7;
                    env.isLegacyChrome = env.isChrome && env.version < 87;
                    env.isChromium = !!(env.isChrome || env.isChromiumEdge || env.isElectron || env.isOpera);
                    env.isAndroid = env.userAgent.indexOf('android') > -1;
                    env.userAgent = navigator1.userAgent; // eslint-disable-next-line no-undef
                    env.protocol = location.protocol; // eslint-disable-next-line no-undef
                    env.hostName = location.hostName;
                    if (env.version === -1 || env.name === 'unknown' || env.isiOS && !env.iOSVersion) env.error = true;
                };
                const parse = (navigator1)=>{
                    // We clear env since we have tests which pass in mocked user agent strings.
                    resetEnv();
                    if (isNode()) parseNode();
                    else parseBrowser(navigator1);
                    return env;
                };
                module1.exports = {
                    parse: parse,
                    isNode: isNode
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(43));
        /***/ },
        /* 540 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const isiPhone = (userAgent)=>/iPhone/.test(userAgent); // This line is for detecting iPad on iOS 13+. See https://developer.apple.com/forums/thread/119186
            const isiPadOniOS13Plus = (userAgent)=>{
                try {
                    return userAgent.includes('Mac') && 'ontouchend' in document;
                } catch (err) {
                    // Silly rabbit, you're probably running in node, huh?
                    return false;
                }
            };
            const isiPad = (userAgent)=>/iPad/.test(userAgent) || isiPadOniOS13Plus(userAgent);
            const isiOS = (userAgent)=>isiPhone(userAgent) || isiPad(userAgent);
            module1.exports = {
                isiPhone: isiPhone,
                isiPad: isiPad,
                isiOS: isiOS
            };
        /***/ },
        /* 541 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function iOSVersion(userAgent) {
                // Make sure parser can handle versions like 15_4 and 15_4_1
                const match = userAgent.match(/OS (\d+_\d+).* like Mac/);
                if (match === null || !match[1]) return undefined;
                return parseFloat(match[1].replace('_', '.'));
            };
        /***/ },
        /* 542 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const electronUserAgentRegex = /(Electron)\/([0-9]{1,}[.0-9]{0,})/;
            module1.exports = (userAgent)=>{
                const matches = userAgent.match(electronUserAgentRegex);
                return matches && parseFloat(matches[2]);
            };
        /***/ },
        /* 543 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-bitwise */ const hasClassListCapability = __webpack_require__(544);
            function hasClass(element, className) {
                if (!className) return false;
                if (hasClassListCapability()) return element.classList.contains(className);
                return element.className.indexOf(className) > -1;
            }
            function toggleClasses(element, classNames) {
                if (!classNames || classNames.length === 0) return;
                 // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
                if (element.nodeType !== 1) return;
                const numClasses = classNames.length;
                let i = 0;
                if (hasClassListCapability()) {
                    for(; i < numClasses; ++i)element.classList.toggle(classNames[i]);
                    return;
                }
                let className = ` ${element.className} `.replace(/[\s+]/, ' ');
                for(; i < numClasses; ++i)if (hasClass(element, classNames[i])) className = className.replace(` ${classNames[i]} `, ' ');
                else className += `${classNames[i]} `;
                element.className = className.trim();
            }
            function addClass(element, classNames) {
                if (!classNames || classNames.length === 0) return;
                 // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
                if (element.nodeType !== 1) return;
                const numClasses = classNames.length;
                let i = 0;
                if (hasClassListCapability()) {
                    for(; i < numClasses; ++i)element.classList.add(classNames[i]);
                    return;
                } // Here's our fallback to browsers that don't support element.classList
                if (!element.className && classNames.length === 1) element.className = classNames.join(' ');
                else {
                    let setClass = ` ${element.className} `;
                    for(; i < numClasses; ++i)if (!~setClass.indexOf(` ${classNames[i]} `)) setClass += `${classNames[i]} `;
                    element.className = setClass.trim();
                }
            }
            function removeClass(element, classNames) {
                if (!classNames || classNames.length === 0) return;
                 // Only bother targeting Element nodes, ignore Text Nodes, CDATA, etc
                if (element.nodeType !== 1) return;
                const numClasses = classNames.length;
                let i = 0;
                if (hasClassListCapability()) {
                    for(; i < numClasses; ++i)element.classList.remove(classNames[i]);
                    return;
                }
                let className = ` ${element.className} `.replace(/[\s+]/, ' ');
                for(; i < numClasses; ++i)className = className.replace(` ${classNames[i]} `, ' ');
                element.className = className.trim();
            }
            module1.exports = function(ElementCollection) {
                ElementCollection.prototype.addClass = function(value) {
                    if (value) {
                        const classNames = value.trim().split(/\s+/);
                        this.forEach((element)=>{
                            addClass(element, classNames);
                        });
                    }
                    return this;
                };
                ElementCollection.prototype.removeClass = function(value) {
                    if (value) {
                        const classNames = value.trim().split(/\s+/);
                        this.forEach((element)=>{
                            removeClass(element, classNames);
                        });
                    }
                    return this;
                };
                ElementCollection.prototype.toggleClass = function(value) {
                    if (value) {
                        const classNames = value.trim().split(/\s+/);
                        this.forEach((element)=>{
                            toggleClasses(element, classNames);
                        });
                    }
                    return this;
                };
                ElementCollection.prototype.hasClass = function(value) {
                    return this.some((element)=>hasClass(element, value));
                };
            };
        /***/ },
        /* 544 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = ()=>typeof document !== 'undefined' && 'classList' in document.createElement('a');
        /***/ },
        /* 545 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable  prefer-rest-params, no-param-reassign */ /* eslint-disable no-underscore-dangle */ const isEmpty = __webpack_require__(546);
            module1.exports = function(ElementCollection) {
                let sizeObserverCount = 0;
                let nodeRemovalObserverCount = 0;
                const observeStyleChanges = function observeStyleChanges(element, stylesToObserve, onChange) {
                    const oldStyles = {};
                    const getStyle = function getStyle(style) {
                        switch(style){
                            case 'width':
                                return new ElementCollection(element).width();
                            case 'height':
                                return new ElementCollection(element).height();
                            default:
                                return new ElementCollection(element).css(style);
                        }
                    }; // get the inital values
                    stylesToObserve.forEach((style)=>{
                        oldStyles[style] = getStyle(style);
                    });
                    const observer = new window.MutationObserver((mutations)=>{
                        const changeSet = {};
                        mutations.forEach((mutation)=>{
                            if (mutation.attributeName !== 'style') return;
                            const isHidden = new ElementCollection(element).isDisplayNone();
                            stylesToObserve.forEach((style)=>{
                                if (isHidden && (style === 'width' || style === 'height')) return;
                                const newValue = getStyle(style);
                                if (newValue !== oldStyles[style]) {
                                    changeSet[style] = [
                                        oldStyles[style],
                                        newValue
                                    ];
                                    oldStyles[style] = newValue;
                                }
                            });
                        });
                        if (!isEmpty(changeSet)) // Do this after so as to help avoid infinite loops of mutations.
                        setTimeout(()=>{
                            onChange.call(null, changeSet);
                        });
                    });
                    observer.observe(element, {
                        attributes: true,
                        attributeFilter: [
                            'style'
                        ],
                        childList: false,
                        characterData: false,
                        subtree: false
                    });
                    return observer;
                };
                const observeNodeOrChildNodeRemoval = function observeNodeOrChildNodeRemoval(element, onChange) {
                    const observer = new window.MutationObserver((mutations)=>{
                        let removedNodes = [];
                        mutations.forEach((mutation)=>{
                            if (mutation.removedNodes.length) removedNodes = removedNodes.concat(Array.prototype.slice.call(mutation.removedNodes));
                        });
                        if (removedNodes.length) // Do this after so as to help avoid infinite loops of mutations.
                        setTimeout(()=>{
                            onChange(new ElementCollection(removedNodes));
                        });
                    });
                    observer.observe(element, {
                        attributes: false,
                        childList: true,
                        characterData: false,
                        subtree: true
                    });
                    nodeRemovalObserverCount++; // Intercept the native disconnect method so we can keep a valid count
                    // of the currently active node removal observers
                    const nativeDisconnect = observer.disconnect;
                    observer.disconnect = function() {
                        nativeDisconnect.apply(observer, arguments);
                        nodeRemovalObserverCount--;
                    };
                    return observer;
                };
                const observeSize = function observeSize(element, onChange) {
                    let previousSize = {
                        width: 0,
                        height: 0
                    };
                    const interval = setInterval(()=>{
                        const rect = element.getBoundingClientRect();
                        if (previousSize.width !== rect.width || previousSize.height !== rect.height) {
                            onChange(rect, previousSize);
                            previousSize = {
                                width: rect.width,
                                height: rect.height
                            };
                        }
                    }, 200);
                    sizeObserverCount++;
                    return {
                        disconnect () {
                            clearInterval(interval);
                            sizeObserverCount--;
                        }
                    };
                }; // Allows an +onChange+ callback to be triggered when specific style properties
                // of +element+ are notified. The callback accepts a single parameter, which is
                // a hash where the keys are the style property that changed and the values are
                // an array containing the old and new values ([oldValue, newValue]).
                //
                // Width and Height changes while the element is display: none will not be
                // fired until such time as the element becomes visible again.
                //
                // This function returns the MutationObserver itself. Once you no longer wish
                // to observe the element you should call disconnect on the observer.
                //
                // Observing changes:
                //  // observe changings to the width and height of object
                //  dimensionsObserver = OTHelpers(object).observeStyleChanges(,
                //                                                    ['width', 'height'], function(changeSet) {
                //      OT.debug("The new width and height are " +
                //                      changeSet.width[1] + ',' + changeSet.height[1]);
                //  });
                //
                // Cleaning up
                //  // stop observing changes
                //  dimensionsObserver.disconnect();
                //  dimensionsObserver = null;
                //
                ElementCollection.prototype.observeStyleChanges = function(stylesToObserve, onChange) {
                    const observers = [];
                    this.forEach((element)=>{
                        observers.push(observeStyleChanges(element, stylesToObserve, onChange));
                    });
                    return observers;
                }; // trigger the +onChange+ callback whenever
                // 1. +element+ is removed
                // 2. or an immediate child of +element+ is removed.
                //
                // This function returns the MutationObserver itself. Once you no longer wish
                // to observe the element you should call disconnect on the observer.
                //
                // Observing changes:
                //  // observe changings to the width and height of object
                //  nodeObserver = OTHelpers(object).observeNodeOrChildNodeRemoval(function(removedNodes) {
                //      OT.debug("Some child nodes were removed");
                //      removedNodes.forEach(function(node) {
                //          OT.debug(node);
                //      });
                //  });
                //
                // Cleaning up
                //  // stop observing changes
                //  nodeObserver.disconnect();
                //  nodeObserver = null;
                //
                ElementCollection.prototype.observeNodeOrChildNodeRemoval = function(onChange) {
                    const observers = [];
                    this.forEach((element)=>{
                        observers.push(observeNodeOrChildNodeRemoval(element, onChange));
                    });
                    return observers;
                }; // trigger the +onChange+ callback whenever the width or the height of the element changes
                //
                // Once you no longer wish to observe the element you should call disconnect on the observer.
                //
                // Observing changes:
                //  // observe changings to the width and height of object
                //  sizeObserver = OTHelpers(object).observeSize(function(newSize, previousSize) {
                //      OT.debug("The new width and height are " +
                //                      newSize.width + ',' + newSize.height);
                //  });
                //
                // Cleaning up
                //  // stop observing changes
                //  sizeObserver.disconnect();
                //  sizeObserver = null;
                //
                ElementCollection.prototype.observeSize = function(onChange) {
                    const observers = [];
                    this.forEach((element)=>{
                        observers.push(observeSize(element, onChange));
                    });
                    return observers;
                }; // @remove
                ElementCollection._attachToOTHelpers.observeStyleChanges = function(element, stylesToObserve, onChange) {
                    return new ElementCollection(element).observeStyleChanges(stylesToObserve, onChange)[0];
                }; // @remove
                ElementCollection._attachToOTHelpers.observeNodeOrChildNodeRemoval = function(element, onChange) {
                    return new ElementCollection(element).observeNodeOrChildNodeRemoval(onChange)[0];
                }; // We expose observer counts for testing purposes.
                if (!ElementCollection.__testOnly) ElementCollection.__testOnly = {};
                ElementCollection.__testOnly.sizeObserverCount = function() {
                    return sizeObserverCount;
                };
                ElementCollection.__testOnly.nodeRemovalObserverCount = function() {
                    return nodeRemovalObserverCount;
                };
            };
        /***/ },
        /* 546 */ /***/ function(module1, exports, __webpack_require__) {
            var baseKeys = __webpack_require__(114), getTag = __webpack_require__(42), isArguments = __webpack_require__(65), isArray = __webpack_require__(12), isArrayLike = __webpack_require__(25), isBuffer = __webpack_require__(66), isPrototype = __webpack_require__(69), isTypedArray = __webpack_require__(86);
            /** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty1 = objectProto.hasOwnProperty;
            /**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty1.call(value, key)) return false;
                }
                return true;
            }
            module1.exports = isEmpty;
        /***/ },
        /* 547 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Errors titles by code
            module1.exports = {
                1004: 'Authentication error',
                1005: 'Invalid Session ID',
                1006: 'Connect Failed',
                1007: 'Connect Rejected',
                1008: 'Connect Time-out',
                1009: 'Security Error',
                1010: 'Not Connected',
                1011: 'Invalid Parameter',
                1012: 'Peer-to-peer Stream Play Failed',
                1013: 'Connection Failed',
                1014: 'API Response Failure',
                1015: 'PeerConnection not connected, cannot call this method',
                1021: 'Request Timeout',
                1026: 'Terms of Service Violation: Export Compliance',
                1027: 'Connection Limit Exceeded',
                1040: 'Set Video Source Failure',
                1041: 'Invalid Video Source',
                1500: 'Unable to Publish',
                1501: 'Unable to Subscribe',
                1502: 'Unsupported Video Codec',
                1503: 'No TURN server found',
                1520: 'Unable to Force Disconnect',
                1530: 'Unable to Force Unpublish',
                1540: 'Unable to Force Mute',
                1553: 'Publisher ICEWorkflow failed',
                1554: 'Subscriber ICEWorkflow failed',
                1600: 'createOffer, createAnswer, setLocalDescription, setRemoteDescription',
                1605: 'Stream Limit Exceeded',
                2000: 'Internal Error',
                2001: 'Unexpected Server Response',
                2021: 'Proxy URL Timing Error',
                2022: 'Proxy URL Already Set Error',
                2031: 'getRtcStatsReport is not supported in this browser',
                4000: 'WebSocket Connection Failed',
                4001: 'WebSocket Network Disconnected',
                5001: 'Unable to access media engine'
            };
        /***/ },
        /* 548 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, prefer-rest-params */ const isFunction = __webpack_require__(17);
            module1.exports = function statable(self1, possibleStates, initialState, stateChanged, stateChangedFailed) {
                let previousState;
                let currentState = initialState;
                self1.currentState = initialState;
                const setState = function setState(state) {
                    if (currentState !== state) {
                        if (possibleStates.indexOf(state) === -1) {
                            if (stateChangedFailed && isFunction(stateChangedFailed)) stateChangedFailed('invalidState', state);
                            return;
                        }
                        self1.previousState = currentState;
                        previousState = currentState;
                        self1.currentState = state;
                        currentState = state;
                        if (stateChanged && isFunction(stateChanged)) stateChanged(state, previousState);
                    }
                }; // Returns a number of states and returns true if the current state
                // is any of them.
                //
                // @example
                // if (this.is('connecting', 'connected')) {
                //   // do some stuff
                // }
                //
                self1.is = function() /* state0:String, state1:String, ..., stateN:String */ {
                    return Array.prototype.indexOf.call(arguments, currentState) !== -1;
                }; // Returns a number of states and returns true if the current state
                // is none of them.
                //
                // @example
                // if (this.isNot('connecting', 'connected')) {
                //   // do some stuff
                // }
                //
                self1.isNot = function() /* state0:String, state1:String, ..., stateN:String */ {
                    return Array.prototype.indexOf.call(arguments, currentState) === -1;
                };
                return setState;
            };
        /***/ },
        /* 549 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign */ const makeEverythingAttachToOTHelpers = __webpack_require__(247);
            const domExtras = {};
            module1.exports = domExtras;
            domExtras.isElementNode = function(node) {
                return node && typeof node === 'object' && node.nodeType === 1;
            };
            domExtras.createElement = function(nodeName, attributes, children, doc) {
                const element = (doc || document).createElement(nodeName);
                attributes = attributes || {};
                Object.keys(attributes).forEach((name)=>{
                    if (typeof attributes[name] === 'object') {
                        if (!element[name]) element[name] = {};
                        const subAttrs = attributes[name];
                        Object.keys(subAttrs).forEach((n)=>{
                            element[name][n] = subAttrs[n];
                        });
                    } else if (name === 'className') element.className = attributes[name];
                    else element.setAttribute(name, attributes[name]);
                });
                const setChildren = function setChildren(child) {
                    if (typeof child === 'string') element.innerHTML += child;
                    else element.appendChild(child);
                };
                if (Array.isArray(children)) children.forEach(setChildren);
                else if (children) setChildren(children);
                return element;
            };
            makeEverythingAttachToOTHelpers(domExtras);
        /***/ },
        /* 550 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const trimProxyUrl = __webpack_require__(551); // if proxy is defined with https://brown.fox and messaging URL with 'wss://lazy.dog'
            // it updates messagingUrl to 'wss://brown.fox/lazy.dog'
            module1.exports = (proxyUrl, messagingUrl)=>{
                if (typeof proxyUrl === 'string' && typeof messagingUrl === 'string') {
                    const trimmedProxyUrl = trimProxyUrl(proxyUrl);
                    const _messagingUrl$match = messagingUrl.match(/(\w+:\/\/)(.*)/), scheme = _messagingUrl$match[1], host = _messagingUrl$match[2];
                    return `${scheme}${trimmedProxyUrl}/${host}`;
                }
                return messagingUrl;
            };
        /***/ },
        /* 551 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Given "ws://foo.vonage.com/", returns "foo.vonage.com"
            module1.exports = (proxyUrl)=>{
                const trimmedProxyUrl = proxyUrl // remove trailing slashes
                .replace(/\/+$/, '') // remove the scheme (e.g., "ws://foo.vonage.com" -> "foo.vonage.com")
                .replace(/^.*:\/+/, '');
                return trimmedProxyUrl;
            };
        /***/ },
        /* 552 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable one-var, no-underscore-dangle, no-use-before-define, no-param-reassign */ /* eslint-disable max-len, no-var, vars-on-top, global-require */ const blacklistedStats = __webpack_require__(553);
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const isSessionProxied = deps.isSessionProxied || __webpack_require__(554);
                const _deps = deps, sessionId = _deps.sessionId;
                if (!isSessionProxied(sessionId)) return;
                blacklistedStats.forEach((stat)=>{
                    if (stat in deps) deps[stat] = '';
                });
            };
        /***/ },
        /* 553 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // List of QoS to be filtered from payload if IP Proxy is enabled
            module1.exports = [
                'audioLocalAddress',
                'audioRemoteAddress',
                'videoLocalAddress',
                'videoRemoteAddress'
            ];
        /***/ },
        /* 554 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable one-var, no-underscore-dangle, no-use-before-define, no-param-reassign */ /* eslint-disable max-len, no-var, vars-on-top, global-require */ const sessionObjects = __webpack_require__(21);
            const sessions = sessionObjects.sessions;
            module1.exports = (sessionId)=>{
                const session = sessions.get(sessionId);
                return session ? !!session._.getProxyUrl() : false;
            };
        /***/ },
        /* 555 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const hintToFieldMap = {
                architecture: 'event_ua_arch',
                bitness: 'event_ua_bitness',
                model: 'event_ua_model',
                platformVersion: 'event_ua_platform_version'
            };
            const getUserAgentClientHintData = /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(userAgentData) {
                    var result, data;
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                result = {};
                                if (!(userAgentData == null ? void 0 : userAgentData.getHighEntropyValues)) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 4;
                                return userAgentData.getHighEntropyValues(Object.keys(hintToFieldMap));
                            case 4:
                                data = _context.sent;
                                if (data) Object.entries(hintToFieldMap).forEach((_ref2)=>{
                                    let hint = _ref2[0], field = _ref2[1];
                                    if (data[hint] !== undefined) result[field] = data[hint];
                                });
                            case 6:
                                return _context.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function getUserAgentClientHintData(_x) {
                    return _ref.apply(this, arguments);
                };
            }();
            module1.exports = getUserAgentClientHintData;
        /***/ },
        /* 556 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const runtimeProperties = [
                'buildHash',
                'minimumVersion',
                'debug',
                [
                    'websiteURL',
                    'websiteUrl'
                ],
                [
                    'cdnURL',
                    'cdnUrl'
                ],
                [
                    'loggingURL',
                    'loggingUrl'
                ],
                [
                    'apiURL',
                    'apiUrl'
                ],
                [
                    'supportSSL',
                    true
                ],
                [
                    'cdnURLSSL',
                    'cdnUrl'
                ],
                [
                    'loggingURLSSL',
                    'loggingUrl'
                ],
                [
                    'apiURLSSL',
                    'apiUrl'
                ],
                [
                    'assetURL',
                    'assetUrl'
                ]
            ];
            module1.exports = runtimeProperties;
        /***/ },
        /* 557 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const mutableRuntimeProperties = [
                'apiUrl',
                'apiURL',
                'apiURLSSL'
            ];
            module1.exports = mutableRuntimeProperties;
        /***/ },
        /* 558 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function noConflict() {
                const globalOT = window.OT;
                const globalTB = window.TB;
                return ()=>{
                    const OT = window.OT;
                    window.OT = globalOT;
                    window.TB = globalTB;
                    return OT;
                };
            };
        /***/ },
        /* 559 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // We can't use ES6 classes with babel because babel invokes the super
            // constructor without the new keyword. This triggers an error when used
            // with RTCPeerConnection and other native classes.
            const getOwnProperties = (target)=>{
                const properties = {};
                Object.getOwnPropertyNames(target).forEach((key)=>{
                    properties[key] = Object.getOwnPropertyDescriptor(target, key);
                });
                return properties;
            };
            module1.exports = function extendES5Native(ParentClass) {
                function ChildClass() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    const instance = new ParentClass(...args);
                    Object.setPrototypeOf(instance, ChildClass.prototype);
                    return instance;
                }
                ChildClass.prototype = Object.create(ParentClass.prototype);
                Object.defineProperties(ChildClass.prototype, getOwnProperties(ParentClass.prototype));
                Object.keys(ParentClass).forEach((staticKey)=>{
                    ChildClass[staticKey] = ParentClass[staticKey];
                });
                return ChildClass;
            };
        /***/ },
        /* 560 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var utils = __webpack_require__(28);
            // Shimming starts here.
            module1.exports = function(dependencies, opts) {
                var window1 = dependencies && dependencies.window;
                var options = {
                    shimChrome: true,
                    shimFirefox: true,
                    shimEdge: true,
                    shimSafari: true
                };
                for(var key in opts)if (hasOwnProperty.call(opts, key)) options[key] = opts[key];
                // Utils.
                var logging = utils.log;
                var browserDetails = utils.detectBrowser(window1);
                // Uncomment the line below if you want logging to occur, including logging
                // for the switch statement below. Can also be turned on in the browser via
                // adapter.disableLog(false), but then logging from the switch statement below
                // will not appear.
                // require('./utils').disableLog(false);
                // Browser shims.
                var chromeShim = __webpack_require__(561) || null;
                var edgeShim = __webpack_require__(563) || null;
                var firefoxShim = __webpack_require__(567) || null;
                var safariShim = __webpack_require__(569) || null;
                var commonShim = __webpack_require__(570) || null;
                // Export to the adapter global object visible in the browser.
                var adapter = {
                    browserDetails: browserDetails,
                    commonShim: commonShim,
                    extractVersion: utils.extractVersion,
                    disableLog: utils.disableLog,
                    disableWarnings: utils.disableWarnings
                };
                // Shim browser if found.
                switch(browserDetails.browser){
                    case 'chrome':
                        if (!chromeShim || !chromeShim.shimPeerConnection || !options.shimChrome) {
                            logging('Chrome shim is not included in this adapter release.');
                            return adapter;
                        }
                        logging('adapter.js shimming chrome.');
                        // Export to the adapter global object visible in the browser.
                        adapter.browserShim = chromeShim;
                        commonShim.shimCreateObjectURL(window1);
                        chromeShim.shimGetUserMedia(window1);
                        chromeShim.shimMediaStream(window1);
                        chromeShim.shimSourceObject(window1);
                        chromeShim.shimPeerConnection(window1);
                        chromeShim.shimOnTrack(window1);
                        chromeShim.shimAddTrackRemoveTrack(window1);
                        chromeShim.shimGetSendersWithDtmf(window1);
                        chromeShim.shimSenderReceiverGetStats(window1);
                        chromeShim.fixNegotiationNeeded(window1);
                        commonShim.shimRTCIceCandidate(window1);
                        commonShim.shimMaxMessageSize(window1);
                        commonShim.shimSendThrowTypeError(window1);
                        break;
                    case 'firefox':
                        if (!firefoxShim || !firefoxShim.shimPeerConnection || !options.shimFirefox) {
                            logging('Firefox shim is not included in this adapter release.');
                            return adapter;
                        }
                        logging('adapter.js shimming firefox.');
                        // Export to the adapter global object visible in the browser.
                        adapter.browserShim = firefoxShim;
                        commonShim.shimCreateObjectURL(window1);
                        firefoxShim.shimGetUserMedia(window1);
                        firefoxShim.shimSourceObject(window1);
                        firefoxShim.shimPeerConnection(window1);
                        firefoxShim.shimOnTrack(window1);
                        firefoxShim.shimRemoveStream(window1);
                        firefoxShim.shimSenderGetStats(window1);
                        firefoxShim.shimReceiverGetStats(window1);
                        firefoxShim.shimRTCDataChannel(window1);
                        commonShim.shimRTCIceCandidate(window1);
                        commonShim.shimMaxMessageSize(window1);
                        commonShim.shimSendThrowTypeError(window1);
                        break;
                    case 'edge':
                        if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
                            logging('MS edge shim is not included in this adapter release.');
                            return adapter;
                        }
                        logging('adapter.js shimming edge.');
                        // Export to the adapter global object visible in the browser.
                        adapter.browserShim = edgeShim;
                        commonShim.shimCreateObjectURL(window1);
                        edgeShim.shimGetUserMedia(window1);
                        edgeShim.shimPeerConnection(window1);
                        edgeShim.shimReplaceTrack(window1);
                        edgeShim.shimGetDisplayMedia(window1);
                        // the edge shim implements the full RTCIceCandidate object.
                        commonShim.shimMaxMessageSize(window1);
                        commonShim.shimSendThrowTypeError(window1);
                        break;
                    case 'safari':
                        if (!safariShim || !options.shimSafari) {
                            logging('Safari shim is not included in this adapter release.');
                            return adapter;
                        }
                        logging('adapter.js shimming safari.');
                        // Export to the adapter global object visible in the browser.
                        adapter.browserShim = safariShim;
                        commonShim.shimCreateObjectURL(window1);
                        safariShim.shimRTCIceServerUrls(window1);
                        safariShim.shimCreateOfferLegacy(window1);
                        safariShim.shimCallbacksAPI(window1);
                        safariShim.shimLocalStreamsAPI(window1);
                        safariShim.shimRemoteStreamsAPI(window1);
                        safariShim.shimTrackEventTransceiver(window1);
                        safariShim.shimGetUserMedia(window1);
                        commonShim.shimRTCIceCandidate(window1);
                        commonShim.shimMaxMessageSize(window1);
                        commonShim.shimSendThrowTypeError(window1);
                        break;
                    default:
                        logging('Unsupported browser!');
                        break;
                }
                return adapter;
            };
        /***/ },
        /* 561 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var utils = __webpack_require__(28);
                var logging = utils.log;
                /* iterates the stats graph recursively. */ function walkStats(stats, base, resultSet) {
                    if (!base || resultSet.has(base.id)) return;
                    resultSet.set(base.id, base);
                    Object.keys(base).forEach(function(name) {
                        if (name.endsWith('Id')) walkStats(stats, stats.get(base[name]), resultSet);
                        else if (name.endsWith('Ids')) base[name].forEach(function(id) {
                            walkStats(stats, stats.get(id), resultSet);
                        });
                    });
                }
                /* filter getStats for a sender/receiver track. */ function filterStats(result, track, outbound) {
                    var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
                    var filteredResult = new Map();
                    if (track === null) return filteredResult;
                    var trackStats = [];
                    result.forEach(function(value) {
                        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
                    });
                    trackStats.forEach(function(trackStat) {
                        result.forEach(function(stats) {
                            if (stats.type === streamStatsType && stats.trackId === trackStat.id) walkStats(result, stats, filteredResult);
                        });
                    });
                    return filteredResult;
                }
                module1.exports = {
                    shimGetUserMedia: __webpack_require__(562),
                    shimMediaStream: function(window1) {
                        window1.MediaStream = window1.MediaStream || window1.webkitMediaStream;
                    },
                    shimOnTrack: function(window1) {
                        if (typeof window1 === 'object' && window1.RTCPeerConnection && !('ontrack' in window1.RTCPeerConnection.prototype)) {
                            Object.defineProperty(window1.RTCPeerConnection.prototype, 'ontrack', {
                                get: function() {
                                    return this._ontrack;
                                },
                                set: function(f) {
                                    if (this._ontrack) this.removeEventListener('track', this._ontrack);
                                    this.addEventListener('track', this._ontrack = f);
                                },
                                enumerable: true,
                                configurable: true
                            });
                            var origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
                            window1.RTCPeerConnection.prototype.setRemoteDescription = function() {
                                var pc = this;
                                if (!pc._ontrackpoly) {
                                    pc._ontrackpoly = function(e) {
                                        // onaddstream does not fire when a track is added to an existing
                                        // stream. But stream.onaddtrack is implemented so we use that.
                                        e.stream.addEventListener('addtrack', function(te) {
                                            var receiver;
                                            if (window1.RTCPeerConnection.prototype.getReceivers) receiver = pc.getReceivers().find(function(r) {
                                                return r.track && r.track.id === te.track.id;
                                            });
                                            else receiver = {
                                                track: te.track
                                            };
                                            var event = new Event('track');
                                            event.track = te.track;
                                            event.receiver = receiver;
                                            event.transceiver = {
                                                receiver: receiver
                                            };
                                            event.streams = [
                                                e.stream
                                            ];
                                            pc.dispatchEvent(event);
                                        });
                                        e.stream.getTracks().forEach(function(track) {
                                            var receiver;
                                            if (window1.RTCPeerConnection.prototype.getReceivers) receiver = pc.getReceivers().find(function(r) {
                                                return r.track && r.track.id === track.id;
                                            });
                                            else receiver = {
                                                track: track
                                            };
                                            var event = new Event('track');
                                            event.track = track;
                                            event.receiver = receiver;
                                            event.transceiver = {
                                                receiver: receiver
                                            };
                                            event.streams = [
                                                e.stream
                                            ];
                                            pc.dispatchEvent(event);
                                        });
                                    };
                                    pc.addEventListener('addstream', pc._ontrackpoly);
                                }
                                return origSetRemoteDescription.apply(pc, arguments);
                            };
                        } else // even if RTCRtpTransceiver is in window, it is only used and
                        // emitted in unified-plan. Unfortunately this means we need
                        // to unconditionally wrap the event.
                        utils.wrapPeerConnectionEvent(window1, 'track', function(e) {
                            if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
                                value: {
                                    receiver: e.receiver
                                }
                            });
                            return e;
                        });
                    },
                    shimGetSendersWithDtmf: function(window1) {
                        // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
                        if (typeof window1 === 'object' && window1.RTCPeerConnection && !('getSenders' in window1.RTCPeerConnection.prototype) && 'createDTMFSender' in window1.RTCPeerConnection.prototype) {
                            var shimSenderWithDtmf = function(pc, track) {
                                return {
                                    track: track,
                                    get dtmf () {
                                        if (this._dtmf === undefined) {
                                            if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                                            else this._dtmf = null;
                                        }
                                        return this._dtmf;
                                    },
                                    _pc: pc
                                };
                            };
                            // augment addTrack when getSenders is not available.
                            if (!window1.RTCPeerConnection.prototype.getSenders) {
                                window1.RTCPeerConnection.prototype.getSenders = function() {
                                    this._senders = this._senders || [];
                                    return this._senders.slice(); // return a copy of the internal state.
                                };
                                var origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
                                window1.RTCPeerConnection.prototype.addTrack = function(track, stream) {
                                    var pc = this;
                                    var sender = origAddTrack.apply(pc, arguments);
                                    if (!sender) {
                                        sender = shimSenderWithDtmf(pc, track);
                                        pc._senders.push(sender);
                                    }
                                    return sender;
                                };
                                var origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
                                window1.RTCPeerConnection.prototype.removeTrack = function(sender) {
                                    var pc = this;
                                    origRemoveTrack.apply(pc, arguments);
                                    var idx = pc._senders.indexOf(sender);
                                    if (idx !== -1) pc._senders.splice(idx, 1);
                                };
                            }
                            var origAddStream = window1.RTCPeerConnection.prototype.addStream;
                            window1.RTCPeerConnection.prototype.addStream = function(stream) {
                                var pc = this;
                                pc._senders = pc._senders || [];
                                origAddStream.apply(pc, [
                                    stream
                                ]);
                                stream.getTracks().forEach(function(track) {
                                    pc._senders.push(shimSenderWithDtmf(pc, track));
                                });
                            };
                            var origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
                            window1.RTCPeerConnection.prototype.removeStream = function(stream) {
                                var pc = this;
                                pc._senders = pc._senders || [];
                                origRemoveStream.apply(pc, [
                                    stream
                                ]);
                                stream.getTracks().forEach(function(track) {
                                    var sender = pc._senders.find(function(s) {
                                        return s.track === track;
                                    });
                                    if (sender) pc._senders.splice(pc._senders.indexOf(sender), 1); // remove sender
                                });
                            };
                        } else if (typeof window1 === 'object' && window1.RTCPeerConnection && 'getSenders' in window1.RTCPeerConnection.prototype && 'createDTMFSender' in window1.RTCPeerConnection.prototype && window1.RTCRtpSender && !('dtmf' in window1.RTCRtpSender.prototype)) {
                            var origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
                            window1.RTCPeerConnection.prototype.getSenders = function() {
                                var pc = this;
                                var senders = origGetSenders.apply(pc, []);
                                senders.forEach(function(sender) {
                                    sender._pc = pc;
                                });
                                return senders;
                            };
                            Object.defineProperty(window1.RTCRtpSender.prototype, 'dtmf', {
                                get: function() {
                                    if (this._dtmf === undefined) {
                                        if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                                        else this._dtmf = null;
                                    }
                                    return this._dtmf;
                                }
                            });
                        }
                    },
                    shimSenderReceiverGetStats: function(window1) {
                        if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender && window1.RTCRtpReceiver)) return;
                        // shim sender stats.
                        if (!('getStats' in window1.RTCRtpSender.prototype)) {
                            var origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
                            if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function() {
                                var pc = this;
                                var senders = origGetSenders.apply(pc, []);
                                senders.forEach(function(sender) {
                                    sender._pc = pc;
                                });
                                return senders;
                            };
                            var origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
                            if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function() {
                                var sender = origAddTrack.apply(this, arguments);
                                sender._pc = this;
                                return sender;
                            };
                            window1.RTCRtpSender.prototype.getStats = function() {
                                var sender = this;
                                return this._pc.getStats().then(function(result) {
                                    /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */ return filterStats(result, sender.track, true);
                                });
                            };
                        }
                        // shim receiver stats.
                        if (!('getStats' in window1.RTCRtpReceiver.prototype)) {
                            var origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
                            if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function() {
                                var pc = this;
                                var receivers = origGetReceivers.apply(pc, []);
                                receivers.forEach(function(receiver) {
                                    receiver._pc = pc;
                                });
                                return receivers;
                            };
                            utils.wrapPeerConnectionEvent(window1, 'track', function(e) {
                                e.receiver._pc = e.srcElement;
                                return e;
                            });
                            window1.RTCRtpReceiver.prototype.getStats = function() {
                                var receiver = this;
                                return this._pc.getStats().then(function(result) {
                                    return filterStats(result, receiver.track, false);
                                });
                            };
                        }
                        if (!('getStats' in window1.RTCRtpSender.prototype && 'getStats' in window1.RTCRtpReceiver.prototype)) return;
                        // shim RTCPeerConnection.getStats(track).
                        var origGetStats = window1.RTCPeerConnection.prototype.getStats;
                        window1.RTCPeerConnection.prototype.getStats = function() {
                            var pc = this;
                            if (arguments.length > 0 && arguments[0] instanceof window1.MediaStreamTrack) {
                                var track = arguments[0];
                                var sender;
                                var receiver;
                                var err;
                                pc.getSenders().forEach(function(s) {
                                    if (s.track === track) {
                                        if (sender) err = true;
                                        else sender = s;
                                    }
                                });
                                pc.getReceivers().forEach(function(r) {
                                    if (r.track === track) {
                                        if (receiver) err = true;
                                        else receiver = r;
                                    }
                                    return r.track === track;
                                });
                                if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
                                else if (sender) return sender.getStats();
                                else if (receiver) return receiver.getStats();
                                return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
                            }
                            return origGetStats.apply(pc, arguments);
                        };
                    },
                    shimSourceObject: function(window1) {
                        var URL1 = window1 && window1.URL;
                        if (typeof window1 === 'object') {
                            if (window1.HTMLMediaElement && !('srcObject' in window1.HTMLMediaElement.prototype)) // Shim the srcObject property, once, when HTMLMediaElement is found.
                            Object.defineProperty(window1.HTMLMediaElement.prototype, 'srcObject', {
                                get: function() {
                                    return this._srcObject;
                                },
                                set: function(stream) {
                                    var self1 = this;
                                    // Use _srcObject as a private property for this shim
                                    this._srcObject = stream;
                                    if (this.src) URL1.revokeObjectURL(this.src);
                                    if (!stream) {
                                        this.src = '';
                                        return undefined;
                                    }
                                    this.src = URL1.createObjectURL(stream);
                                    // We need to recreate the blob url when a track is added or
                                    // removed. Doing it manually since we want to avoid a recursion.
                                    stream.addEventListener('addtrack', function() {
                                        if (self1.src) URL1.revokeObjectURL(self1.src);
                                        self1.src = URL1.createObjectURL(stream);
                                    });
                                    stream.addEventListener('removetrack', function() {
                                        if (self1.src) URL1.revokeObjectURL(self1.src);
                                        self1.src = URL1.createObjectURL(stream);
                                    });
                                }
                            });
                        }
                    },
                    shimAddTrackRemoveTrackWithNative: function(window1) {
                        // shim addTrack/removeTrack with native variants in order to make
                        // the interactions with legacy getLocalStreams behave as in other browsers.
                        // Keeps a mapping stream.id => [stream, rtpsenders...]
                        window1.RTCPeerConnection.prototype.getLocalStreams = function() {
                            var pc = this;
                            this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                            return Object.keys(this._shimmedLocalStreams).map(function(streamId) {
                                return pc._shimmedLocalStreams[streamId][0];
                            });
                        };
                        var origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
                        window1.RTCPeerConnection.prototype.addTrack = function(track, stream) {
                            if (!stream) return origAddTrack.apply(this, arguments);
                            this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                            var sender = origAddTrack.apply(this, arguments);
                            if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
                                stream,
                                sender
                            ];
                            else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
                            return sender;
                        };
                        var origAddStream = window1.RTCPeerConnection.prototype.addStream;
                        window1.RTCPeerConnection.prototype.addStream = function(stream) {
                            var pc = this;
                            this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                            stream.getTracks().forEach(function(track) {
                                var alreadyExists = pc.getSenders().find(function(s) {
                                    return s.track === track;
                                });
                                if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
                            });
                            var existingSenders = pc.getSenders();
                            origAddStream.apply(this, arguments);
                            var newSenders = pc.getSenders().filter(function(newSender) {
                                return existingSenders.indexOf(newSender) === -1;
                            });
                            this._shimmedLocalStreams[stream.id] = [
                                stream
                            ].concat(newSenders);
                        };
                        var origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
                        window1.RTCPeerConnection.prototype.removeStream = function(stream) {
                            this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                            delete this._shimmedLocalStreams[stream.id];
                            return origRemoveStream.apply(this, arguments);
                        };
                        var origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
                        window1.RTCPeerConnection.prototype.removeTrack = function(sender) {
                            var pc = this;
                            this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                            if (sender) Object.keys(this._shimmedLocalStreams).forEach(function(streamId) {
                                var idx = pc._shimmedLocalStreams[streamId].indexOf(sender);
                                if (idx !== -1) pc._shimmedLocalStreams[streamId].splice(idx, 1);
                                if (pc._shimmedLocalStreams[streamId].length === 1) delete pc._shimmedLocalStreams[streamId];
                            });
                            return origRemoveTrack.apply(this, arguments);
                        };
                    },
                    shimAddTrackRemoveTrack: function(window1) {
                        if (!window1.RTCPeerConnection) return;
                        var browserDetails = utils.detectBrowser(window1);
                        // shim addTrack and removeTrack.
                        if (window1.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return this.shimAddTrackRemoveTrackWithNative(window1);
                        // also shim pc.getLocalStreams when addTrack is shimmed
                        // to return the original streams.
                        var origGetLocalStreams = window1.RTCPeerConnection.prototype.getLocalStreams;
                        window1.RTCPeerConnection.prototype.getLocalStreams = function() {
                            var pc = this;
                            var nativeStreams = origGetLocalStreams.apply(this);
                            pc._reverseStreams = pc._reverseStreams || {};
                            return nativeStreams.map(function(stream) {
                                return pc._reverseStreams[stream.id];
                            });
                        };
                        var origAddStream = window1.RTCPeerConnection.prototype.addStream;
                        window1.RTCPeerConnection.prototype.addStream = function(stream) {
                            var pc = this;
                            pc._streams = pc._streams || {};
                            pc._reverseStreams = pc._reverseStreams || {};
                            stream.getTracks().forEach(function(track) {
                                var alreadyExists = pc.getSenders().find(function(s) {
                                    return s.track === track;
                                });
                                if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
                            });
                            // Add identity mapping for consistency with addTrack.
                            // Unless this is being used with a stream from addTrack.
                            if (!pc._reverseStreams[stream.id]) {
                                var newStream = new window1.MediaStream(stream.getTracks());
                                pc._streams[stream.id] = newStream;
                                pc._reverseStreams[newStream.id] = stream;
                                stream = newStream;
                            }
                            origAddStream.apply(pc, [
                                stream
                            ]);
                        };
                        var origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
                        window1.RTCPeerConnection.prototype.removeStream = function(stream) {
                            var pc = this;
                            pc._streams = pc._streams || {};
                            pc._reverseStreams = pc._reverseStreams || {};
                            origRemoveStream.apply(pc, [
                                pc._streams[stream.id] || stream
                            ]);
                            delete pc._reverseStreams[pc._streams[stream.id] ? pc._streams[stream.id].id : stream.id];
                            delete pc._streams[stream.id];
                        };
                        window1.RTCPeerConnection.prototype.addTrack = function(track, stream) {
                            var pc = this;
                            if (pc.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
                            var streams = [].slice.call(arguments, 1);
                            if (streams.length !== 1 || !streams[0].getTracks().find(function(t) {
                                return t === track;
                            })) // this is not fully correct but all we can manage without
                            // [[associated MediaStreams]] internal slot.
                            throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
                            var alreadyExists = pc.getSenders().find(function(s) {
                                return s.track === track;
                            });
                            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
                            pc._streams = pc._streams || {};
                            pc._reverseStreams = pc._reverseStreams || {};
                            var oldStream = pc._streams[stream.id];
                            if (oldStream) {
                                // this is using odd Chrome behaviour, use with caution:
                                // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
                                // Note: we rely on the high-level addTrack/dtmf shim to
                                // create the sender with a dtmf sender.
                                oldStream.addTrack(track);
                                // Trigger ONN async.
                                Promise.resolve().then(function() {
                                    pc.dispatchEvent(new Event('negotiationneeded'));
                                });
                            } else {
                                var newStream = new window1.MediaStream([
                                    track
                                ]);
                                pc._streams[stream.id] = newStream;
                                pc._reverseStreams[newStream.id] = stream;
                                pc.addStream(newStream);
                            }
                            return pc.getSenders().find(function(s) {
                                return s.track === track;
                            });
                        };
                        // replace the internal stream id with the external one and
                        // vice versa.
                        function replaceInternalStreamId(pc, description) {
                            var sdp = description.sdp;
                            Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
                                var externalStream = pc._reverseStreams[internalId];
                                var internalStream = pc._streams[externalStream.id];
                                sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
                            });
                            return new RTCSessionDescription({
                                type: description.type,
                                sdp: sdp
                            });
                        }
                        function replaceExternalStreamId(pc, description) {
                            var sdp = description.sdp;
                            Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
                                var externalStream = pc._reverseStreams[internalId];
                                var internalStream = pc._streams[externalStream.id];
                                sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
                            });
                            return new RTCSessionDescription({
                                type: description.type,
                                sdp: sdp
                            });
                        }
                        [
                            'createOffer',
                            'createAnswer'
                        ].forEach(function(method) {
                            var nativeMethod = window1.RTCPeerConnection.prototype[method];
                            window1.RTCPeerConnection.prototype[method] = function() {
                                var pc = this;
                                var args = arguments;
                                var isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                                if (isLegacyCall) return nativeMethod.apply(pc, [
                                    function(description) {
                                        var desc = replaceInternalStreamId(pc, description);
                                        args[0].apply(null, [
                                            desc
                                        ]);
                                    },
                                    function(err) {
                                        if (args[1]) args[1].apply(null, err);
                                    },
                                    arguments[2]
                                ]);
                                return nativeMethod.apply(pc, arguments).then(function(description) {
                                    return replaceInternalStreamId(pc, description);
                                });
                            };
                        });
                        var origSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
                        window1.RTCPeerConnection.prototype.setLocalDescription = function() {
                            var pc = this;
                            if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(pc, arguments);
                            arguments[0] = replaceExternalStreamId(pc, arguments[0]);
                            return origSetLocalDescription.apply(pc, arguments);
                        };
                        // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
                        var origLocalDescription = Object.getOwnPropertyDescriptor(window1.RTCPeerConnection.prototype, 'localDescription');
                        Object.defineProperty(window1.RTCPeerConnection.prototype, 'localDescription', {
                            get: function() {
                                var pc = this;
                                var description = origLocalDescription.get.apply(this);
                                if (description.type === '') return description;
                                return replaceInternalStreamId(pc, description);
                            }
                        });
                        window1.RTCPeerConnection.prototype.removeTrack = function(sender) {
                            var pc = this;
                            if (pc.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
                            // We can not yet check for sender instanceof RTCRtpSender
                            // since we shim RTPSender. So we check if sender._pc is set.
                            if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
                            var isLocal = sender._pc === pc;
                            if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
                            // Search for the native stream the senders track belongs to.
                            pc._streams = pc._streams || {};
                            var stream;
                            Object.keys(pc._streams).forEach(function(streamid) {
                                var hasTrack = pc._streams[streamid].getTracks().find(function(track) {
                                    return sender.track === track;
                                });
                                if (hasTrack) stream = pc._streams[streamid];
                            });
                            if (stream) {
                                if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
                                // takes care of any shimmed _senders.
                                pc.removeStream(pc._reverseStreams[stream.id]);
                                else // relying on the same odd chrome behaviour as above.
                                stream.removeTrack(sender.track);
                                pc.dispatchEvent(new Event('negotiationneeded'));
                            }
                        };
                    },
                    shimPeerConnection: function(window1) {
                        var browserDetails = utils.detectBrowser(window1);
                        // The RTCPeerConnection object.
                        if (!window1.RTCPeerConnection && window1.webkitRTCPeerConnection) {
                            window1.RTCPeerConnection = function(pcConfig, pcConstraints) {
                                // Translate iceTransportPolicy to iceTransports,
                                // see https://code.google.com/p/webrtc/issues/detail?id=4869
                                // this was fixed in M56 along with unprefixing RTCPeerConnection.
                                logging('PeerConnection');
                                if (pcConfig && pcConfig.iceTransportPolicy) pcConfig.iceTransports = pcConfig.iceTransportPolicy;
                                return new window1.webkitRTCPeerConnection(pcConfig, pcConstraints);
                            };
                            window1.RTCPeerConnection.prototype = window1.webkitRTCPeerConnection.prototype;
                            // wrap static methods. Currently just generateCertificate.
                            if (window1.webkitRTCPeerConnection.generateCertificate) Object.defineProperty(window1.RTCPeerConnection, 'generateCertificate', {
                                get: function() {
                                    return window1.webkitRTCPeerConnection.generateCertificate;
                                }
                            });
                        }
                        if (!window1.RTCPeerConnection) return;
                        var origGetStats = window1.RTCPeerConnection.prototype.getStats;
                        window1.RTCPeerConnection.prototype.getStats = function(selector, successCallback, errorCallback) {
                            var pc = this;
                            var args = arguments;
                            // If selector is a function then we are in the old style stats so just
                            // pass back the original getStats format to avoid breaking old users.
                            if (arguments.length > 0 && typeof selector === 'function') return origGetStats.apply(this, arguments);
                            // When spec-style getStats is supported, return those when called with
                            // either no arguments or the selector argument is null.
                            if (origGetStats.length === 0 && (arguments.length === 0 || typeof arguments[0] !== 'function')) return origGetStats.apply(this, []);
                            var fixChromeStats_ = function(response) {
                                var standardReport = {};
                                var reports = response.result();
                                reports.forEach(function(report) {
                                    var standardStats = {
                                        id: report.id,
                                        timestamp: report.timestamp,
                                        type: {
                                            localcandidate: 'local-candidate',
                                            remotecandidate: 'remote-candidate'
                                        }[report.type] || report.type
                                    };
                                    report.names().forEach(function(name) {
                                        standardStats[name] = report.stat(name);
                                    });
                                    standardReport[standardStats.id] = standardStats;
                                });
                                return standardReport;
                            };
                            // shim getStats with maplike support
                            var makeMapStats = function(stats) {
                                return new Map(Object.keys(stats).map(function(key) {
                                    return [
                                        key,
                                        stats[key]
                                    ];
                                }));
                            };
                            if (arguments.length >= 2) {
                                var successCallbackWrapper_ = function(response) {
                                    args[1](makeMapStats(fixChromeStats_(response)));
                                };
                                return origGetStats.apply(this, [
                                    successCallbackWrapper_,
                                    arguments[0]
                                ]);
                            }
                            // promise-support
                            return new Promise(function(resolve, reject) {
                                origGetStats.apply(pc, [
                                    function(response) {
                                        resolve(makeMapStats(fixChromeStats_(response)));
                                    },
                                    reject
                                ]);
                            }).then(successCallback, errorCallback);
                        };
                        // add promise support -- natively available in Chrome 51
                        if (browserDetails.version < 51) [
                            'setLocalDescription',
                            'setRemoteDescription',
                            'addIceCandidate'
                        ].forEach(function(method) {
                            var nativeMethod = window1.RTCPeerConnection.prototype[method];
                            window1.RTCPeerConnection.prototype[method] = function() {
                                var args = arguments;
                                var pc = this;
                                var promise = new Promise(function(resolve, reject) {
                                    nativeMethod.apply(pc, [
                                        args[0],
                                        resolve,
                                        reject
                                    ]);
                                });
                                if (args.length < 2) return promise;
                                return promise.then(function() {
                                    args[1].apply(null, []);
                                }, function(err) {
                                    if (args.length >= 3) args[2].apply(null, [
                                        err
                                    ]);
                                });
                            };
                        });
                        // promise support for createOffer and createAnswer. Available (without
                        // bugs) since M52: crbug/619289
                        if (browserDetails.version < 52) [
                            'createOffer',
                            'createAnswer'
                        ].forEach(function(method) {
                            var nativeMethod = window1.RTCPeerConnection.prototype[method];
                            window1.RTCPeerConnection.prototype[method] = function() {
                                var pc = this;
                                if (arguments.length < 1 || arguments.length === 1 && typeof arguments[0] === 'object') {
                                    var opts = arguments.length === 1 ? arguments[0] : undefined;
                                    return new Promise(function(resolve, reject) {
                                        nativeMethod.apply(pc, [
                                            resolve,
                                            reject,
                                            opts
                                        ]);
                                    });
                                }
                                return nativeMethod.apply(this, arguments);
                            };
                        });
                        // shim implicit creation of RTCSessionDescription/RTCIceCandidate
                        [
                            'setLocalDescription',
                            'setRemoteDescription',
                            'addIceCandidate'
                        ].forEach(function(method) {
                            var nativeMethod = window1.RTCPeerConnection.prototype[method];
                            window1.RTCPeerConnection.prototype[method] = function() {
                                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                                return nativeMethod.apply(this, arguments);
                            };
                        });
                        // support for addIceCandidate(null or undefined)
                        var nativeAddIceCandidate = window1.RTCPeerConnection.prototype.addIceCandidate;
                        window1.RTCPeerConnection.prototype.addIceCandidate = function() {
                            if (!arguments[0]) {
                                if (arguments[1]) arguments[1].apply(null);
                                return Promise.resolve();
                            }
                            return nativeAddIceCandidate.apply(this, arguments);
                        };
                    },
                    fixNegotiationNeeded: function(window1) {
                        utils.wrapPeerConnectionEvent(window1, 'negotiationneeded', function(e) {
                            var pc = e.target;
                            if (pc.signalingState !== 'stable') return;
                            return e;
                        });
                    },
                    shimGetDisplayMedia: function(window1, getSourceId) {
                        if (!window1.navigator || !window1.navigator.mediaDevices || 'getDisplayMedia' in window1.navigator.mediaDevices) return;
                        // getSourceId is a function that returns a promise resolving with
                        // the sourceId of the screen/window/tab to be shared.
                        if (typeof getSourceId !== 'function') {
                            console.error("shimGetDisplayMedia: getSourceId argument is not a function");
                            return;
                        }
                        window1.navigator.mediaDevices.getDisplayMedia = function(constraints) {
                            return getSourceId(constraints).then(function(sourceId) {
                                var widthSpecified = constraints.video && constraints.video.width;
                                var heightSpecified = constraints.video && constraints.video.height;
                                var frameRateSpecified = constraints.video && constraints.video.frameRate;
                                constraints.video = {
                                    mandatory: {
                                        chromeMediaSource: 'desktop',
                                        chromeMediaSourceId: sourceId,
                                        maxFrameRate: frameRateSpecified || 3
                                    }
                                };
                                if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
                                if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
                                return window1.navigator.mediaDevices.getUserMedia(constraints);
                            });
                        };
                        window1.navigator.getDisplayMedia = function(constraints) {
                            utils.deprecated('navigator.getDisplayMedia', 'navigator.mediaDevices.getDisplayMedia');
                            return window1.navigator.mediaDevices.getDisplayMedia(constraints);
                        };
                    }
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 562 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-env node */ var utils = __webpack_require__(28);
                var logging = utils.log;
                // Expose public methods.
                module1.exports = function(window1) {
                    var browserDetails = utils.detectBrowser(window1);
                    var navigator1 = window1 && window1.navigator;
                    var constraintsToChrome_ = function(c) {
                        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
                        var cc = {};
                        Object.keys(c).forEach(function(key) {
                            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
                            var r = typeof c[key] === 'object' ? c[key] : {
                                ideal: c[key]
                            };
                            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
                            var oldname_ = function(prefix, name) {
                                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                                return name === 'deviceId' ? 'sourceId' : name;
                            };
                            if (r.ideal !== undefined) {
                                cc.optional = cc.optional || [];
                                var oc = {};
                                if (typeof r.ideal === 'number') {
                                    oc[oldname_('min', key)] = r.ideal;
                                    cc.optional.push(oc);
                                    oc = {};
                                    oc[oldname_('max', key)] = r.ideal;
                                    cc.optional.push(oc);
                                } else {
                                    oc[oldname_('', key)] = r.ideal;
                                    cc.optional.push(oc);
                                }
                            }
                            if (r.exact !== undefined && typeof r.exact !== 'number') {
                                cc.mandatory = cc.mandatory || {};
                                cc.mandatory[oldname_('', key)] = r.exact;
                            } else [
                                'min',
                                'max'
                            ].forEach(function(mix) {
                                if (r[mix] !== undefined) {
                                    cc.mandatory = cc.mandatory || {};
                                    cc.mandatory[oldname_(mix, key)] = r[mix];
                                }
                            });
                        });
                        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
                        return cc;
                    };
                    var shimConstraints_ = function(constraints, func) {
                        if (browserDetails.version >= 61) return func(constraints);
                        constraints = JSON.parse(JSON.stringify(constraints));
                        if (constraints && typeof constraints.audio === 'object') {
                            var remap = function(obj, a, b) {
                                if (a in obj && !(b in obj)) {
                                    obj[b] = obj[a];
                                    delete obj[a];
                                }
                            };
                            constraints = JSON.parse(JSON.stringify(constraints));
                            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
                            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
                            constraints.audio = constraintsToChrome_(constraints.audio);
                        }
                        if (constraints && typeof constraints.video === 'object') {
                            // Shim facingMode for mobile & surface pro.
                            var face = constraints.video.facingMode;
                            face = face && (typeof face === 'object' ? face : {
                                ideal: face
                            });
                            var getSupportedFacingModeLies = browserDetails.version < 66;
                            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator1.mediaDevices.getSupportedConstraints && navigator1.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                                delete constraints.video.facingMode;
                                var matches;
                                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                                    'back',
                                    'rear'
                                ];
                                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                                    'front'
                                ];
                                if (matches) // Look for matches in label, or use last cam for back (typical).
                                return navigator1.mediaDevices.enumerateDevices().then(function(devices) {
                                    devices = devices.filter(function(d) {
                                        return d.kind === 'videoinput';
                                    });
                                    var dev = devices.find(function(d) {
                                        return matches.some(function(match) {
                                            return d.label.toLowerCase().indexOf(match) !== -1;
                                        });
                                    });
                                    if (!dev && devices.length && matches.indexOf('back') !== -1) dev = devices[devices.length - 1]; // more likely the back cam
                                    if (dev) constraints.video.deviceId = face.exact ? {
                                        exact: dev.deviceId
                                    } : {
                                        ideal: dev.deviceId
                                    };
                                    constraints.video = constraintsToChrome_(constraints.video);
                                    logging('chrome: ' + JSON.stringify(constraints));
                                    return func(constraints);
                                });
                            }
                            constraints.video = constraintsToChrome_(constraints.video);
                        }
                        logging('chrome: ' + JSON.stringify(constraints));
                        return func(constraints);
                    };
                    var shimError_ = function(e) {
                        if (browserDetails.version >= 64) return e;
                        return {
                            name: ({
                                PermissionDeniedError: 'NotAllowedError',
                                PermissionDismissedError: 'NotAllowedError',
                                InvalidStateError: 'NotAllowedError',
                                DevicesNotFoundError: 'NotFoundError',
                                ConstraintNotSatisfiedError: 'OverconstrainedError',
                                TrackStartError: 'NotReadableError',
                                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                                MediaDeviceKillSwitchOn: 'NotAllowedError',
                                TabCaptureError: 'AbortError',
                                ScreenCaptureError: 'AbortError',
                                DeviceCaptureError: 'AbortError'
                            })[e.name] || e.name,
                            message: e.message,
                            constraint: e.constraint || e.constraintName,
                            toString: function() {
                                return this.name + (this.message && ': ') + this.message;
                            }
                        };
                    };
                    var getUserMedia_ = function(constraints, onSuccess, onError) {
                        shimConstraints_(constraints, function(c) {
                            navigator1.webkitGetUserMedia(c, onSuccess, function(e) {
                                if (onError) onError(shimError_(e));
                            });
                        });
                    };
                    navigator1.getUserMedia = getUserMedia_;
                    // Returns the result of getUserMedia as a Promise.
                    var getUserMediaPromise_ = function(constraints) {
                        return new Promise(function(resolve, reject) {
                            navigator1.getUserMedia(constraints, resolve, reject);
                        });
                    };
                    if (!navigator1.mediaDevices) navigator1.mediaDevices = {
                        getUserMedia: getUserMediaPromise_,
                        enumerateDevices: function() {
                            return new Promise(function(resolve) {
                                var kinds = {
                                    audio: 'audioinput',
                                    video: 'videoinput'
                                };
                                return window1.MediaStreamTrack.getSources(function(devices) {
                                    resolve(devices.map(function(device) {
                                        return {
                                            label: device.label,
                                            kind: kinds[device.kind],
                                            deviceId: device.id,
                                            groupId: ''
                                        };
                                    }));
                                });
                            });
                        },
                        getSupportedConstraints: function() {
                            return {
                                deviceId: true,
                                echoCancellation: true,
                                facingMode: true,
                                frameRate: true,
                                height: true,
                                width: true
                            };
                        }
                    };
                    // A shim for getUserMedia method on the mediaDevices object.
                    // TODO(KaptenJansson) remove once implemented in Chrome stable.
                    if (!navigator1.mediaDevices.getUserMedia) navigator1.mediaDevices.getUserMedia = function(constraints) {
                        return getUserMediaPromise_(constraints);
                    };
                    else {
                        // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
                        // function which returns a Promise, it does not accept spec-style
                        // constraints.
                        var origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
                        navigator1.mediaDevices.getUserMedia = function(cs) {
                            return shimConstraints_(cs, function(c) {
                                return origGetUserMedia(c).then(function(stream) {
                                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                                        stream.getTracks().forEach(function(track) {
                                            track.stop();
                                        });
                                        throw new DOMException('', 'NotFoundError');
                                    }
                                    return stream;
                                }, function(e) {
                                    return Promise.reject(shimError_(e));
                                });
                            });
                        };
                    }
                    // Dummy devicechange event methods.
                    // TODO(KaptenJansson) remove once implemented in Chrome stable.
                    if (typeof navigator1.mediaDevices.addEventListener === 'undefined') navigator1.mediaDevices.addEventListener = function() {
                        logging('Dummy mediaDevices.addEventListener called.');
                    };
                    if (typeof navigator1.mediaDevices.removeEventListener === 'undefined') navigator1.mediaDevices.removeEventListener = function() {
                        logging('Dummy mediaDevices.removeEventListener called.');
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 563 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var utils = __webpack_require__(28);
            var filterIceServers = __webpack_require__(564);
            var shimRTCPeerConnection = __webpack_require__(565);
            module1.exports = {
                shimGetUserMedia: __webpack_require__(566),
                shimPeerConnection: function(window1) {
                    var browserDetails = utils.detectBrowser(window1);
                    if (window1.RTCIceGatherer) {
                        if (!window1.RTCIceCandidate) window1.RTCIceCandidate = function(args) {
                            return args;
                        };
                        if (!window1.RTCSessionDescription) window1.RTCSessionDescription = function(args) {
                            return args;
                        };
                        // this adds an additional event listener to MediaStrackTrack that signals
                        // when a tracks enabled property was changed. Workaround for a bug in
                        // addStream, see below. No longer required in 15025+
                        if (browserDetails.version < 15025) {
                            var origMSTEnabled = Object.getOwnPropertyDescriptor(window1.MediaStreamTrack.prototype, 'enabled');
                            Object.defineProperty(window1.MediaStreamTrack.prototype, 'enabled', {
                                set: function(value) {
                                    origMSTEnabled.set.call(this, value);
                                    var ev = new Event('enabled');
                                    ev.enabled = value;
                                    this.dispatchEvent(ev);
                                }
                            });
                        }
                    }
                    // ORTC defines the DTMF sender a bit different.
                    // https://github.com/w3c/ortc/issues/714
                    if (window1.RTCRtpSender && !('dtmf' in window1.RTCRtpSender.prototype)) Object.defineProperty(window1.RTCRtpSender.prototype, 'dtmf', {
                        get: function() {
                            if (this._dtmf === undefined) {
                                if (this.track.kind === 'audio') this._dtmf = new window1.RTCDtmfSender(this);
                                else if (this.track.kind === 'video') this._dtmf = null;
                            }
                            return this._dtmf;
                        }
                    });
                    // Edge currently only implements the RTCDtmfSender, not the
                    // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
                    if (window1.RTCDtmfSender && !window1.RTCDTMFSender) window1.RTCDTMFSender = window1.RTCDtmfSender;
                    var RTCPeerConnectionShim = shimRTCPeerConnection(window1, browserDetails.version);
                    window1.RTCPeerConnection = function(config) {
                        if (config && config.iceServers) config.iceServers = filterIceServers(config.iceServers);
                        return new RTCPeerConnectionShim(config);
                    };
                    window1.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
                },
                shimReplaceTrack: function(window1) {
                    // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
                    if (window1.RTCRtpSender && !('replaceTrack' in window1.RTCRtpSender.prototype)) window1.RTCRtpSender.prototype.replaceTrack = window1.RTCRtpSender.prototype.setTrack;
                },
                shimGetDisplayMedia: function(window1, preferredMediaSource) {
                    if (!('getDisplayMedia' in window1.navigator) || !window1.navigator.mediaDevices || 'getDisplayMedia' in window1.navigator.mediaDevices) return;
                    var origGetDisplayMedia = window1.navigator.getDisplayMedia;
                    window1.navigator.mediaDevices.getDisplayMedia = function(constraints) {
                        return origGetDisplayMedia.call(window1.navigator, constraints);
                    };
                    window1.navigator.getDisplayMedia = function(constraints) {
                        utils.deprecated('navigator.getDisplayMedia', 'navigator.mediaDevices.getDisplayMedia');
                        return origGetDisplayMedia.call(window1.navigator, constraints);
                    };
                }
            };
        /***/ },
        /* 564 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var utils = __webpack_require__(28);
            // Edge does not like
            // 1) stun: filtered after 14393 unless ?transport=udp is present
            // 2) turn: that does not have all of turn:host:port?transport=udp
            // 3) turn: with ipv6 addresses
            // 4) turn: occurring muliple times
            module1.exports = function(iceServers, edgeVersion) {
                var hasTurn = false;
                iceServers = JSON.parse(JSON.stringify(iceServers));
                return iceServers.filter(function(server) {
                    if (server && (server.urls || server.url)) {
                        var urls = server.urls || server.url;
                        if (server.url && !server.urls) utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
                        var isString = typeof urls === 'string';
                        if (isString) urls = [
                            urls
                        ];
                        urls = urls.filter(function(url) {
                            var validTurn = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !hasTurn;
                            if (validTurn) {
                                hasTurn = true;
                                return true;
                            }
                            return url.indexOf('stun:') === 0 && edgeVersion >= 14393 && url.indexOf('?transport=udp') === -1;
                        });
                        delete server.url;
                        server.urls = isString ? urls[0] : urls;
                        return !!urls.length;
                    }
                });
            };
        /***/ },
        /* 565 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-env node */ var SDPUtils = __webpack_require__(251);
                function fixStatsType(stat) {
                    return ({
                        inboundrtp: 'inbound-rtp',
                        outboundrtp: 'outbound-rtp',
                        candidatepair: 'candidate-pair',
                        localcandidate: 'local-candidate',
                        remotecandidate: 'remote-candidate'
                    })[stat.type] || stat.type;
                }
                function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
                    var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
                    // Map ICE parameters (ufrag, pwd) to SDP.
                    sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
                    // Map DTLS parameters to SDP.
                    sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : dtlsRole || 'active');
                    sdp += 'a=mid:' + transceiver.mid + '\r\n';
                    if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += 'a=sendrecv\r\n';
                    else if (transceiver.rtpSender) sdp += 'a=sendonly\r\n';
                    else if (transceiver.rtpReceiver) sdp += 'a=recvonly\r\n';
                    else sdp += 'a=inactive\r\n';
                    if (transceiver.rtpSender) {
                        var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
                        transceiver.rtpSender._initialTrackId = trackId;
                        // spec.
                        var msid = 'msid:' + (stream ? stream.id : '-') + ' ' + trackId + '\r\n';
                        sdp += 'a=' + msid;
                        // for Chrome. Legacy should no longer be required.
                        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;
                        // RTX
                        if (transceiver.sendEncodingParameters[0].rtx) {
                            sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
                            sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
                        }
                    }
                    // FIXME: this should be written by writeRtpDescription.
                    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
                    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
                    return sdp;
                }
                // Edge does not like
                // 1) stun: filtered after 14393 unless ?transport=udp is present
                // 2) turn: that does not have all of turn:host:port?transport=udp
                // 3) turn: with ipv6 addresses
                // 4) turn: occurring muliple times
                function filterIceServers(iceServers, edgeVersion) {
                    var hasTurn = false;
                    iceServers = JSON.parse(JSON.stringify(iceServers));
                    return iceServers.filter(function(server) {
                        if (server && (server.urls || server.url)) {
                            var urls = server.urls || server.url;
                            if (server.url && !server.urls) console.warn('RTCIceServer.url is deprecated! Use urls instead.');
                            var isString = typeof urls === 'string';
                            if (isString) urls = [
                                urls
                            ];
                            urls = urls.filter(function(url) {
                                var validTurn = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !hasTurn;
                                if (validTurn) {
                                    hasTurn = true;
                                    return true;
                                }
                                return url.indexOf('stun:') === 0 && edgeVersion >= 14393 && url.indexOf('?transport=udp') === -1;
                            });
                            delete server.url;
                            server.urls = isString ? urls[0] : urls;
                            return !!urls.length;
                        }
                    });
                }
                // Determines the intersection of local and remote capabilities.
                function getCommonCapabilities(localCapabilities, remoteCapabilities) {
                    var commonCapabilities = {
                        codecs: [],
                        headerExtensions: [],
                        fecMechanisms: []
                    };
                    var findCodecByPayloadType = function(pt, codecs) {
                        pt = parseInt(pt, 10);
                        for(var i = 0; i < codecs.length; i++){
                            if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) return codecs[i];
                        }
                    };
                    var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
                        var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
                        var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
                        return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
                    };
                    localCapabilities.codecs.forEach(function(lCodec) {
                        for(var i = 0; i < remoteCapabilities.codecs.length; i++){
                            var rCodec = remoteCapabilities.codecs[i];
                            if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
                                if (lCodec.name.toLowerCase() === 'rtx' && lCodec.parameters && rCodec.parameters.apt) {
                                    // for RTX we need to find the local rtx that has a apt
                                    // which points to the same local codec as the remote one.
                                    if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) continue;
                                }
                                rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
                                // number of channels is the highest common number of channels
                                rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels);
                                // push rCodec so we reply with offerer payload type
                                commonCapabilities.codecs.push(rCodec);
                                // determine common feedback mechanisms
                                rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
                                    for(var j = 0; j < lCodec.rtcpFeedback.length; j++){
                                        if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) return true;
                                    }
                                    return false;
                                });
                                break;
                            }
                        }
                    });
                    localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
                        for(var i = 0; i < remoteCapabilities.headerExtensions.length; i++){
                            var rHeaderExtension = remoteCapabilities.headerExtensions[i];
                            if (lHeaderExtension.uri === rHeaderExtension.uri) {
                                commonCapabilities.headerExtensions.push(rHeaderExtension);
                                break;
                            }
                        }
                    });
                    // FIXME: fecMechanisms
                    return commonCapabilities;
                }
                // is action=setLocalDescription with type allowed in signalingState
                function isActionAllowedInSignalingState(action, type, signalingState) {
                    return ({
                        offer: {
                            setLocalDescription: [
                                'stable',
                                'have-local-offer'
                            ],
                            setRemoteDescription: [
                                'stable',
                                'have-remote-offer'
                            ]
                        },
                        answer: {
                            setLocalDescription: [
                                'have-remote-offer',
                                'have-local-pranswer'
                            ],
                            setRemoteDescription: [
                                'have-local-offer',
                                'have-remote-pranswer'
                            ]
                        }
                    })[type][action].indexOf(signalingState) !== -1;
                }
                function maybeAddCandidate(iceTransport, candidate) {
                    // Edge's internal representation adds some fields therefore
                    // not all fieldѕ are taken into account.
                    var alreadyAdded = iceTransport.getRemoteCandidates().find(function(remoteCandidate) {
                        return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
                    });
                    if (!alreadyAdded) iceTransport.addRemoteCandidate(candidate);
                    return !alreadyAdded;
                }
                function makeError(name, description) {
                    var e = new Error(description);
                    e.name = name;
                    // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
                    e.code = ({
                        NotSupportedError: 9,
                        InvalidStateError: 11,
                        InvalidAccessError: 15,
                        TypeError: undefined,
                        OperationError: undefined
                    })[name];
                    return e;
                }
                module1.exports = function(window1, edgeVersion) {
                    // https://w3c.github.io/mediacapture-main/#mediastream
                    // Helper function to add the track to the stream and
                    // dispatch the event ourselves.
                    function addTrackToStreamAndFireEvent(track, stream) {
                        stream.addTrack(track);
                        stream.dispatchEvent(new window1.MediaStreamTrackEvent('addtrack', {
                            track: track
                        }));
                    }
                    function removeTrackFromStreamAndFireEvent(track, stream) {
                        stream.removeTrack(track);
                        stream.dispatchEvent(new window1.MediaStreamTrackEvent('removetrack', {
                            track: track
                        }));
                    }
                    function fireAddTrack(pc, track, receiver, streams) {
                        var trackEvent = new Event('track');
                        trackEvent.track = track;
                        trackEvent.receiver = receiver;
                        trackEvent.transceiver = {
                            receiver: receiver
                        };
                        trackEvent.streams = streams;
                        window1.setTimeout(function() {
                            pc._dispatchEvent('track', trackEvent);
                        });
                    }
                    var RTCPeerConnection = function(config) {
                        var pc = this;
                        var _eventTarget = document.createDocumentFragment();
                        [
                            'addEventListener',
                            'removeEventListener',
                            'dispatchEvent'
                        ].forEach(function(method) {
                            pc[method] = _eventTarget[method].bind(_eventTarget);
                        });
                        this.canTrickleIceCandidates = null;
                        this.needNegotiation = false;
                        this.localStreams = [];
                        this.remoteStreams = [];
                        this._localDescription = null;
                        this._remoteDescription = null;
                        this.signalingState = 'stable';
                        this.iceConnectionState = 'new';
                        this.connectionState = 'new';
                        this.iceGatheringState = 'new';
                        config = JSON.parse(JSON.stringify(config || {}));
                        this.usingBundle = config.bundlePolicy === 'max-bundle';
                        if (config.rtcpMuxPolicy === 'negotiate') throw makeError('NotSupportedError', 'rtcpMuxPolicy \'negotiate\' is not supported');
                        else if (!config.rtcpMuxPolicy) config.rtcpMuxPolicy = 'require';
                        switch(config.iceTransportPolicy){
                            case 'all':
                            case 'relay':
                                break;
                            default:
                                config.iceTransportPolicy = 'all';
                                break;
                        }
                        switch(config.bundlePolicy){
                            case 'balanced':
                            case 'max-compat':
                            case 'max-bundle':
                                break;
                            default:
                                config.bundlePolicy = 'balanced';
                                break;
                        }
                        config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);
                        this._iceGatherers = [];
                        if (config.iceCandidatePoolSize) for(var i = config.iceCandidatePoolSize; i > 0; i--)this._iceGatherers.push(new window1.RTCIceGatherer({
                            iceServers: config.iceServers,
                            gatherPolicy: config.iceTransportPolicy
                        }));
                        else config.iceCandidatePoolSize = 0;
                        this._config = config;
                        // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
                        // everything that is needed to describe a SDP m-line.
                        this.transceivers = [];
                        this._sdpSessionId = SDPUtils.generateSessionId();
                        this._sdpSessionVersion = 0;
                        this._dtlsRole = undefined; // role for a=setup to use in answers.
                        this._isClosed = false;
                    };
                    Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
                        configurable: true,
                        get: function() {
                            return this._localDescription;
                        }
                    });
                    Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
                        configurable: true,
                        get: function() {
                            return this._remoteDescription;
                        }
                    });
                    // set up event handlers on prototype
                    RTCPeerConnection.prototype.onicecandidate = null;
                    RTCPeerConnection.prototype.onaddstream = null;
                    RTCPeerConnection.prototype.ontrack = null;
                    RTCPeerConnection.prototype.onremovestream = null;
                    RTCPeerConnection.prototype.onsignalingstatechange = null;
                    RTCPeerConnection.prototype.oniceconnectionstatechange = null;
                    RTCPeerConnection.prototype.onconnectionstatechange = null;
                    RTCPeerConnection.prototype.onicegatheringstatechange = null;
                    RTCPeerConnection.prototype.onnegotiationneeded = null;
                    RTCPeerConnection.prototype.ondatachannel = null;
                    RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
                        if (this._isClosed) return;
                        this.dispatchEvent(event);
                        if (typeof this['on' + name] === 'function') this['on' + name](event);
                    };
                    RTCPeerConnection.prototype._emitGatheringStateChange = function() {
                        var event = new Event('icegatheringstatechange');
                        this._dispatchEvent('icegatheringstatechange', event);
                    };
                    RTCPeerConnection.prototype.getConfiguration = function() {
                        return this._config;
                    };
                    RTCPeerConnection.prototype.getLocalStreams = function() {
                        return this.localStreams;
                    };
                    RTCPeerConnection.prototype.getRemoteStreams = function() {
                        return this.remoteStreams;
                    };
                    // internal helper to create a transceiver object.
                    // (which is not yet the same as the WebRTC 1.0 transceiver)
                    RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
                        var hasBundleTransport = this.transceivers.length > 0;
                        var transceiver = {
                            track: null,
                            iceGatherer: null,
                            iceTransport: null,
                            dtlsTransport: null,
                            localCapabilities: null,
                            remoteCapabilities: null,
                            rtpSender: null,
                            rtpReceiver: null,
                            kind: kind,
                            mid: null,
                            sendEncodingParameters: null,
                            recvEncodingParameters: null,
                            stream: null,
                            associatedRemoteMediaStreams: [],
                            wantReceive: true
                        };
                        if (this.usingBundle && hasBundleTransport) {
                            transceiver.iceTransport = this.transceivers[0].iceTransport;
                            transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
                        } else {
                            var transports = this._createIceAndDtlsTransports();
                            transceiver.iceTransport = transports.iceTransport;
                            transceiver.dtlsTransport = transports.dtlsTransport;
                        }
                        if (!doNotAdd) this.transceivers.push(transceiver);
                        return transceiver;
                    };
                    RTCPeerConnection.prototype.addTrack = function(track, stream) {
                        if (this._isClosed) throw makeError('InvalidStateError', 'Attempted to call addTrack on a closed peerconnection.');
                        var alreadyExists = this.transceivers.find(function(s) {
                            return s.track === track;
                        });
                        if (alreadyExists) throw makeError('InvalidAccessError', 'Track already exists.');
                        var transceiver;
                        for(var i = 0; i < this.transceivers.length; i++)if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) transceiver = this.transceivers[i];
                        if (!transceiver) transceiver = this._createTransceiver(track.kind);
                        this._maybeFireNegotiationNeeded();
                        if (this.localStreams.indexOf(stream) === -1) this.localStreams.push(stream);
                        transceiver.track = track;
                        transceiver.stream = stream;
                        transceiver.rtpSender = new window1.RTCRtpSender(track, transceiver.dtlsTransport);
                        return transceiver.rtpSender;
                    };
                    RTCPeerConnection.prototype.addStream = function(stream) {
                        var pc = this;
                        if (edgeVersion >= 15025) stream.getTracks().forEach(function(track) {
                            pc.addTrack(track, stream);
                        });
                        else {
                            // Clone is necessary for local demos mostly, attaching directly
                            // to two different senders does not work (build 10547).
                            // Fixed in 15025 (or earlier)
                            var clonedStream = stream.clone();
                            stream.getTracks().forEach(function(track, idx) {
                                var clonedTrack = clonedStream.getTracks()[idx];
                                track.addEventListener('enabled', function(event) {
                                    clonedTrack.enabled = event.enabled;
                                });
                            });
                            clonedStream.getTracks().forEach(function(track) {
                                pc.addTrack(track, clonedStream);
                            });
                        }
                    };
                    RTCPeerConnection.prototype.removeTrack = function(sender) {
                        if (this._isClosed) throw makeError('InvalidStateError', 'Attempted to call removeTrack on a closed peerconnection.');
                        if (!(sender instanceof window1.RTCRtpSender)) throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
                        var transceiver = this.transceivers.find(function(t) {
                            return t.rtpSender === sender;
                        });
                        if (!transceiver) throw makeError('InvalidAccessError', 'Sender was not created by this connection.');
                        var stream = transceiver.stream;
                        transceiver.rtpSender.stop();
                        transceiver.rtpSender = null;
                        transceiver.track = null;
                        transceiver.stream = null;
                        // remove the stream from the set of local streams
                        var localStreams = this.transceivers.map(function(t) {
                            return t.stream;
                        });
                        if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) this.localStreams.splice(this.localStreams.indexOf(stream), 1);
                        this._maybeFireNegotiationNeeded();
                    };
                    RTCPeerConnection.prototype.removeStream = function(stream) {
                        var pc = this;
                        stream.getTracks().forEach(function(track) {
                            var sender = pc.getSenders().find(function(s) {
                                return s.track === track;
                            });
                            if (sender) pc.removeTrack(sender);
                        });
                    };
                    RTCPeerConnection.prototype.getSenders = function() {
                        return this.transceivers.filter(function(transceiver) {
                            return !!transceiver.rtpSender;
                        }).map(function(transceiver) {
                            return transceiver.rtpSender;
                        });
                    };
                    RTCPeerConnection.prototype.getReceivers = function() {
                        return this.transceivers.filter(function(transceiver) {
                            return !!transceiver.rtpReceiver;
                        }).map(function(transceiver) {
                            return transceiver.rtpReceiver;
                        });
                    };
                    RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex, usingBundle) {
                        var pc = this;
                        if (usingBundle && sdpMLineIndex > 0) return this.transceivers[0].iceGatherer;
                        else if (this._iceGatherers.length) return this._iceGatherers.shift();
                        var iceGatherer = new window1.RTCIceGatherer({
                            iceServers: this._config.iceServers,
                            gatherPolicy: this._config.iceTransportPolicy
                        });
                        Object.defineProperty(iceGatherer, 'state', {
                            value: 'new',
                            writable: true
                        });
                        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
                        this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
                            var end = !event.candidate || Object.keys(event.candidate).length === 0;
                            // polyfill since RTCIceGatherer.state is not implemented in
                            // Edge 10547 yet.
                            iceGatherer.state = end ? 'completed' : 'gathering';
                            if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
                        };
                        iceGatherer.addEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);
                        return iceGatherer;
                    };
                    // start gathering from an RTCIceGatherer.
                    RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
                        var pc = this;
                        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
                        if (iceGatherer.onlocalcandidate) return;
                        var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
                        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
                        iceGatherer.removeEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);
                        iceGatherer.onlocalcandidate = function(evt) {
                            if (pc.usingBundle && sdpMLineIndex > 0) // if we know that we use bundle we can drop candidates with
                            // ѕdpMLineIndex > 0. If we don't do this then our state gets
                            // confused since we dispose the extra ice gatherer.
                            return;
                            var event = new Event('icecandidate');
                            event.candidate = {
                                sdpMid: mid,
                                sdpMLineIndex: sdpMLineIndex
                            };
                            var cand = evt.candidate;
                            // Edge emits an empty object for RTCIceCandidateComplete‥
                            var end = !cand || Object.keys(cand).length === 0;
                            if (end) // polyfill since RTCIceGatherer.state is not implemented in
                            // Edge 10547 yet.
                            {
                                if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') iceGatherer.state = 'completed';
                            } else {
                                if (iceGatherer.state === 'new') iceGatherer.state = 'gathering';
                                // RTCIceCandidate doesn't have a component, needs to be added
                                cand.component = 1;
                                // also the usernameFragment. TODO: update SDP to take both variants.
                                cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;
                                var serializedCandidate = SDPUtils.writeCandidate(cand);
                                event.candidate = Object.assign(event.candidate, SDPUtils.parseCandidate(serializedCandidate));
                                event.candidate.candidate = serializedCandidate;
                                event.candidate.toJSON = function() {
                                    return {
                                        candidate: event.candidate.candidate,
                                        sdpMid: event.candidate.sdpMid,
                                        sdpMLineIndex: event.candidate.sdpMLineIndex,
                                        usernameFragment: event.candidate.usernameFragment
                                    };
                                };
                            }
                            // update local description.
                            var sections = SDPUtils.getMediaSections(pc._localDescription.sdp);
                            if (!end) sections[event.candidate.sdpMLineIndex] += 'a=' + event.candidate.candidate + '\r\n';
                            else sections[event.candidate.sdpMLineIndex] += 'a=end-of-candidates\r\n';
                            pc._localDescription.sdp = SDPUtils.getDescription(pc._localDescription.sdp) + sections.join('');
                            var complete = pc.transceivers.every(function(transceiver) {
                                return transceiver.iceGatherer && transceiver.iceGatherer.state === 'completed';
                            });
                            if (pc.iceGatheringState !== 'gathering') {
                                pc.iceGatheringState = 'gathering';
                                pc._emitGatheringStateChange();
                            }
                            // Emit candidate. Also emit null candidate when all gatherers are
                            // complete.
                            if (!end) pc._dispatchEvent('icecandidate', event);
                            if (complete) {
                                pc._dispatchEvent('icecandidate', new Event('icecandidate'));
                                pc.iceGatheringState = 'complete';
                                pc._emitGatheringStateChange();
                            }
                        };
                        // emit already gathered candidates.
                        window1.setTimeout(function() {
                            bufferedCandidateEvents.forEach(function(e) {
                                iceGatherer.onlocalcandidate(e);
                            });
                        }, 0);
                    };
                    // Create ICE transport and DTLS transport.
                    RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
                        var pc = this;
                        var iceTransport = new window1.RTCIceTransport(null);
                        iceTransport.onicestatechange = function() {
                            pc._updateIceConnectionState();
                            pc._updateConnectionState();
                        };
                        var dtlsTransport = new window1.RTCDtlsTransport(iceTransport);
                        dtlsTransport.ondtlsstatechange = function() {
                            pc._updateConnectionState();
                        };
                        dtlsTransport.onerror = function() {
                            // onerror does not set state to failed by itself.
                            Object.defineProperty(dtlsTransport, 'state', {
                                value: 'failed',
                                writable: true
                            });
                            pc._updateConnectionState();
                        };
                        return {
                            iceTransport: iceTransport,
                            dtlsTransport: dtlsTransport
                        };
                    };
                    // Destroy ICE gatherer, ICE transport and DTLS transport.
                    // Without triggering the callbacks.
                    RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(sdpMLineIndex) {
                        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
                        if (iceGatherer) {
                            delete iceGatherer.onlocalcandidate;
                            delete this.transceivers[sdpMLineIndex].iceGatherer;
                        }
                        var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
                        if (iceTransport) {
                            delete iceTransport.onicestatechange;
                            delete this.transceivers[sdpMLineIndex].iceTransport;
                        }
                        var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
                        if (dtlsTransport) {
                            delete dtlsTransport.ondtlsstatechange;
                            delete dtlsTransport.onerror;
                            delete this.transceivers[sdpMLineIndex].dtlsTransport;
                        }
                    };
                    // Start the RTP Sender and Receiver for a transceiver.
                    RTCPeerConnection.prototype._transceive = function(transceiver, send, recv) {
                        var params = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
                        if (send && transceiver.rtpSender) {
                            params.encodings = transceiver.sendEncodingParameters;
                            params.rtcp = {
                                cname: SDPUtils.localCName,
                                compound: transceiver.rtcpParameters.compound
                            };
                            if (transceiver.recvEncodingParameters.length) params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
                            transceiver.rtpSender.send(params);
                        }
                        if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
                            // remove RTX field in Edge 14942
                            if (transceiver.kind === 'video' && transceiver.recvEncodingParameters && edgeVersion < 15019) transceiver.recvEncodingParameters.forEach(function(p) {
                                delete p.rtx;
                            });
                            if (transceiver.recvEncodingParameters.length) params.encodings = transceiver.recvEncodingParameters;
                            else params.encodings = [
                                {}
                            ];
                            params.rtcp = {
                                compound: transceiver.rtcpParameters.compound
                            };
                            if (transceiver.rtcpParameters.cname) params.rtcp.cname = transceiver.rtcpParameters.cname;
                            if (transceiver.sendEncodingParameters.length) params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
                            transceiver.rtpReceiver.receive(params);
                        }
                    };
                    RTCPeerConnection.prototype.setLocalDescription = function(description) {
                        var pc = this;
                        // Note: pranswer is not supported.
                        if ([
                            'offer',
                            'answer'
                        ].indexOf(description.type) === -1) return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
                        if (!isActionAllowedInSignalingState('setLocalDescription', description.type, pc.signalingState) || pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not set local ' + description.type + ' in state ' + pc.signalingState));
                        var sections;
                        var sessionpart;
                        if (description.type === 'offer') {
                            // VERY limited support for SDP munging. Limited to:
                            // * changing the order of codecs
                            sections = SDPUtils.splitSections(description.sdp);
                            sessionpart = sections.shift();
                            sections.forEach(function(mediaSection, sdpMLineIndex) {
                                var caps = SDPUtils.parseRtpParameters(mediaSection);
                                pc.transceivers[sdpMLineIndex].localCapabilities = caps;
                            });
                            pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                                pc._gather(transceiver.mid, sdpMLineIndex);
                            });
                        } else if (description.type === 'answer') {
                            sections = SDPUtils.splitSections(pc._remoteDescription.sdp);
                            sessionpart = sections.shift();
                            var isIceLite = SDPUtils.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
                            sections.forEach(function(mediaSection, sdpMLineIndex) {
                                var transceiver = pc.transceivers[sdpMLineIndex];
                                var iceGatherer = transceiver.iceGatherer;
                                var iceTransport = transceiver.iceTransport;
                                var dtlsTransport = transceiver.dtlsTransport;
                                var localCapabilities = transceiver.localCapabilities;
                                var remoteCapabilities = transceiver.remoteCapabilities;
                                // treat bundle-only as not-rejected.
                                var rejected = SDPUtils.isRejected(mediaSection) && SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
                                if (!rejected && !transceiver.rejected) {
                                    var remoteIceParameters = SDPUtils.getIceParameters(mediaSection, sessionpart);
                                    var remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection, sessionpart);
                                    if (isIceLite) remoteDtlsParameters.role = 'server';
                                    if (!pc.usingBundle || sdpMLineIndex === 0) {
                                        pc._gather(transceiver.mid, sdpMLineIndex);
                                        if (iceTransport.state === 'new') iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? 'controlling' : 'controlled');
                                        if (dtlsTransport.state === 'new') dtlsTransport.start(remoteDtlsParameters);
                                    }
                                    // Calculate intersection of capabilities.
                                    var params = getCommonCapabilities(localCapabilities, remoteCapabilities);
                                    // Start the RTCRtpSender. The RTCRtpReceiver for this
                                    // transceiver has already been started in setRemoteDescription.
                                    pc._transceive(transceiver, params.codecs.length > 0, false);
                                }
                            });
                        }
                        pc._localDescription = {
                            type: description.type,
                            sdp: description.sdp
                        };
                        if (description.type === 'offer') pc._updateSignalingState('have-local-offer');
                        else pc._updateSignalingState('stable');
                        return Promise.resolve();
                    };
                    RTCPeerConnection.prototype.setRemoteDescription = function(description) {
                        var pc = this;
                        // Note: pranswer is not supported.
                        if ([
                            'offer',
                            'answer'
                        ].indexOf(description.type) === -1) return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
                        if (!isActionAllowedInSignalingState('setRemoteDescription', description.type, pc.signalingState) || pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not set remote ' + description.type + ' in state ' + pc.signalingState));
                        var streams = {};
                        pc.remoteStreams.forEach(function(stream) {
                            streams[stream.id] = stream;
                        });
                        var receiverList = [];
                        var sections = SDPUtils.splitSections(description.sdp);
                        var sessionpart = sections.shift();
                        var isIceLite = SDPUtils.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
                        var usingBundle = SDPUtils.matchPrefix(sessionpart, 'a=group:BUNDLE ').length > 0;
                        pc.usingBundle = usingBundle;
                        var iceOptions = SDPUtils.matchPrefix(sessionpart, 'a=ice-options:')[0];
                        if (iceOptions) pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ').indexOf('trickle') >= 0;
                        else pc.canTrickleIceCandidates = false;
                        sections.forEach(function(mediaSection, sdpMLineIndex) {
                            var lines = SDPUtils.splitLines(mediaSection);
                            var kind = SDPUtils.getKind(mediaSection);
                            // treat bundle-only as not-rejected.
                            var rejected = SDPUtils.isRejected(mediaSection) && SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
                            var protocol = lines[0].substr(2).split(' ')[2];
                            var direction = SDPUtils.getDirection(mediaSection, sessionpart);
                            var remoteMsid = SDPUtils.parseMsid(mediaSection);
                            var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();
                            // Reject datachannels which are not implemented yet.
                            if (rejected || kind === 'application' && (protocol === 'DTLS/SCTP' || protocol === 'UDP/DTLS/SCTP')) {
                                // TODO: this is dangerous in the case where a non-rejected m-line
                                //     becomes rejected.
                                pc.transceivers[sdpMLineIndex] = {
                                    mid: mid,
                                    kind: kind,
                                    protocol: protocol,
                                    rejected: true
                                };
                                return;
                            }
                            if (!rejected && pc.transceivers[sdpMLineIndex] && pc.transceivers[sdpMLineIndex].rejected) // recycle a rejected transceiver.
                            pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
                            var transceiver;
                            var iceGatherer;
                            var iceTransport;
                            var dtlsTransport;
                            var rtpReceiver;
                            var sendEncodingParameters;
                            var recvEncodingParameters;
                            var localCapabilities;
                            var track;
                            // FIXME: ensure the mediaSection has rtcp-mux set.
                            var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
                            var remoteIceParameters;
                            var remoteDtlsParameters;
                            if (!rejected) {
                                remoteIceParameters = SDPUtils.getIceParameters(mediaSection, sessionpart);
                                remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection, sessionpart);
                                remoteDtlsParameters.role = 'client';
                            }
                            recvEncodingParameters = SDPUtils.parseRtpEncodingParameters(mediaSection);
                            var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);
                            var isComplete = SDPUtils.matchPrefix(mediaSection, 'a=end-of-candidates', sessionpart).length > 0;
                            var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:').map(function(cand) {
                                return SDPUtils.parseCandidate(cand);
                            }).filter(function(cand) {
                                return cand.component === 1;
                            });
                            // Check if we can use BUNDLE and dispose transports.
                            if ((description.type === 'offer' || description.type === 'answer') && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
                                pc._disposeIceAndDtlsTransports(sdpMLineIndex);
                                pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
                                pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
                                pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;
                                if (pc.transceivers[sdpMLineIndex].rtpSender) pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
                                if (pc.transceivers[sdpMLineIndex].rtpReceiver) pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
                            }
                            if (description.type === 'offer' && !rejected) {
                                transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
                                transceiver.mid = mid;
                                if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
                                if (cands.length && transceiver.iceTransport.state === 'new') {
                                    if (isComplete && (!usingBundle || sdpMLineIndex === 0)) transceiver.iceTransport.setRemoteCandidates(cands);
                                    else cands.forEach(function(candidate) {
                                        maybeAddCandidate(transceiver.iceTransport, candidate);
                                    });
                                }
                                localCapabilities = window1.RTCRtpReceiver.getCapabilities(kind);
                                // filter RTX until additional stuff needed for RTX is implemented
                                // in adapter.js
                                if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                                    return codec.name !== 'rtx';
                                });
                                sendEncodingParameters = transceiver.sendEncodingParameters || [
                                    {
                                        ssrc: (2 * sdpMLineIndex + 2) * 1001
                                    }
                                ];
                                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                                var isNewTrack = false;
                                if (direction === 'sendrecv' || direction === 'sendonly') {
                                    isNewTrack = !transceiver.rtpReceiver;
                                    rtpReceiver = transceiver.rtpReceiver || new window1.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                                    if (isNewTrack) {
                                        var stream;
                                        track = rtpReceiver.track;
                                        // FIXME: does not work with Plan B.
                                        if (remoteMsid && remoteMsid.stream === '-') ;
                                        else if (remoteMsid) {
                                            if (!streams[remoteMsid.stream]) {
                                                streams[remoteMsid.stream] = new window1.MediaStream();
                                                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                                                    get: function() {
                                                        return remoteMsid.stream;
                                                    }
                                                });
                                            }
                                            Object.defineProperty(track, 'id', {
                                                get: function() {
                                                    return remoteMsid.track;
                                                }
                                            });
                                            stream = streams[remoteMsid.stream];
                                        } else {
                                            if (!streams.default) streams.default = new window1.MediaStream();
                                            stream = streams.default;
                                        }
                                        if (stream) {
                                            addTrackToStreamAndFireEvent(track, stream);
                                            transceiver.associatedRemoteMediaStreams.push(stream);
                                        }
                                        receiverList.push([
                                            track,
                                            rtpReceiver,
                                            stream
                                        ]);
                                    }
                                } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
                                    transceiver.associatedRemoteMediaStreams.forEach(function(s) {
                                        var nativeTrack = s.getTracks().find(function(t) {
                                            return t.id === transceiver.rtpReceiver.track.id;
                                        });
                                        if (nativeTrack) removeTrackFromStreamAndFireEvent(nativeTrack, s);
                                    });
                                    transceiver.associatedRemoteMediaStreams = [];
                                }
                                transceiver.localCapabilities = localCapabilities;
                                transceiver.remoteCapabilities = remoteCapabilities;
                                transceiver.rtpReceiver = rtpReceiver;
                                transceiver.rtcpParameters = rtcpParameters;
                                transceiver.sendEncodingParameters = sendEncodingParameters;
                                transceiver.recvEncodingParameters = recvEncodingParameters;
                                // Start the RTCRtpReceiver now. The RTPSender is started in
                                // setLocalDescription.
                                pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
                            } else if (description.type === 'answer' && !rejected) {
                                transceiver = pc.transceivers[sdpMLineIndex];
                                iceGatherer = transceiver.iceGatherer;
                                iceTransport = transceiver.iceTransport;
                                dtlsTransport = transceiver.dtlsTransport;
                                rtpReceiver = transceiver.rtpReceiver;
                                sendEncodingParameters = transceiver.sendEncodingParameters;
                                localCapabilities = transceiver.localCapabilities;
                                pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
                                pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
                                pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
                                if (cands.length && iceTransport.state === 'new') {
                                    if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) iceTransport.setRemoteCandidates(cands);
                                    else cands.forEach(function(candidate) {
                                        maybeAddCandidate(transceiver.iceTransport, candidate);
                                    });
                                }
                                if (!usingBundle || sdpMLineIndex === 0) {
                                    if (iceTransport.state === 'new') iceTransport.start(iceGatherer, remoteIceParameters, 'controlling');
                                    if (dtlsTransport.state === 'new') dtlsTransport.start(remoteDtlsParameters);
                                }
                                // If the offer contained RTX but the answer did not,
                                // remove RTX from sendEncodingParameters.
                                var commonCapabilities = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
                                var hasRtx = commonCapabilities.codecs.filter(function(c) {
                                    return c.name.toLowerCase() === 'rtx';
                                }).length;
                                if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
                                pc._transceive(transceiver, direction === 'sendrecv' || direction === 'recvonly', direction === 'sendrecv' || direction === 'sendonly');
                                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                                if (rtpReceiver && (direction === 'sendrecv' || direction === 'sendonly')) {
                                    track = rtpReceiver.track;
                                    if (remoteMsid) {
                                        if (!streams[remoteMsid.stream]) streams[remoteMsid.stream] = new window1.MediaStream();
                                        addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
                                        receiverList.push([
                                            track,
                                            rtpReceiver,
                                            streams[remoteMsid.stream]
                                        ]);
                                    } else {
                                        if (!streams.default) streams.default = new window1.MediaStream();
                                        addTrackToStreamAndFireEvent(track, streams.default);
                                        receiverList.push([
                                            track,
                                            rtpReceiver,
                                            streams.default
                                        ]);
                                    }
                                } else // FIXME: actually the receiver should be created later.
                                delete transceiver.rtpReceiver;
                            }
                        });
                        if (pc._dtlsRole === undefined) pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
                        pc._remoteDescription = {
                            type: description.type,
                            sdp: description.sdp
                        };
                        if (description.type === 'offer') pc._updateSignalingState('have-remote-offer');
                        else pc._updateSignalingState('stable');
                        Object.keys(streams).forEach(function(sid) {
                            var stream = streams[sid];
                            if (stream.getTracks().length) {
                                if (pc.remoteStreams.indexOf(stream) === -1) {
                                    pc.remoteStreams.push(stream);
                                    var event = new Event('addstream');
                                    event.stream = stream;
                                    window1.setTimeout(function() {
                                        pc._dispatchEvent('addstream', event);
                                    });
                                }
                                receiverList.forEach(function(item) {
                                    var track = item[0];
                                    var receiver = item[1];
                                    if (stream.id !== item[2].id) return;
                                    fireAddTrack(pc, track, receiver, [
                                        stream
                                    ]);
                                });
                            }
                        });
                        receiverList.forEach(function(item) {
                            if (item[2]) return;
                            fireAddTrack(pc, item[0], item[1], []);
                        });
                        // check whether addIceCandidate({}) was called within four seconds after
                        // setRemoteDescription.
                        window1.setTimeout(function() {
                            if (!(pc && pc.transceivers)) return;
                            pc.transceivers.forEach(function(transceiver) {
                                if (transceiver.iceTransport && transceiver.iceTransport.state === 'new' && transceiver.iceTransport.getRemoteCandidates().length > 0) {
                                    console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification");
                                    transceiver.iceTransport.addRemoteCandidate({});
                                }
                            });
                        }, 4000);
                        return Promise.resolve();
                    };
                    RTCPeerConnection.prototype.close = function() {
                        this.transceivers.forEach(function(transceiver) {
                            /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */ if (transceiver.iceTransport) transceiver.iceTransport.stop();
                            if (transceiver.dtlsTransport) transceiver.dtlsTransport.stop();
                            if (transceiver.rtpSender) transceiver.rtpSender.stop();
                            if (transceiver.rtpReceiver) transceiver.rtpReceiver.stop();
                        });
                        // FIXME: clean up tracks, local streams, remote streams, etc
                        this._isClosed = true;
                        this._updateSignalingState('closed');
                    };
                    // Update the signaling state.
                    RTCPeerConnection.prototype._updateSignalingState = function(newState) {
                        this.signalingState = newState;
                        var event = new Event('signalingstatechange');
                        this._dispatchEvent('signalingstatechange', event);
                    };
                    // Determine whether to fire the negotiationneeded event.
                    RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
                        var pc = this;
                        if (this.signalingState !== 'stable' || this.needNegotiation === true) return;
                        this.needNegotiation = true;
                        window1.setTimeout(function() {
                            if (pc.needNegotiation) {
                                pc.needNegotiation = false;
                                var event = new Event('negotiationneeded');
                                pc._dispatchEvent('negotiationneeded', event);
                            }
                        }, 0);
                    };
                    // Update the ice connection state.
                    RTCPeerConnection.prototype._updateIceConnectionState = function() {
                        var newState;
                        var states = {
                            'new': 0,
                            closed: 0,
                            checking: 0,
                            connected: 0,
                            completed: 0,
                            disconnected: 0,
                            failed: 0
                        };
                        this.transceivers.forEach(function(transceiver) {
                            if (transceiver.iceTransport && !transceiver.rejected) states[transceiver.iceTransport.state]++;
                        });
                        newState = 'new';
                        if (states.failed > 0) newState = 'failed';
                        else if (states.checking > 0) newState = 'checking';
                        else if (states.disconnected > 0) newState = 'disconnected';
                        else if (states.new > 0) newState = 'new';
                        else if (states.connected > 0) newState = 'connected';
                        else if (states.completed > 0) newState = 'completed';
                        if (newState !== this.iceConnectionState) {
                            this.iceConnectionState = newState;
                            var event = new Event('iceconnectionstatechange');
                            this._dispatchEvent('iceconnectionstatechange', event);
                        }
                    };
                    // Update the connection state.
                    RTCPeerConnection.prototype._updateConnectionState = function() {
                        var newState;
                        var states = {
                            'new': 0,
                            closed: 0,
                            connecting: 0,
                            connected: 0,
                            completed: 0,
                            disconnected: 0,
                            failed: 0
                        };
                        this.transceivers.forEach(function(transceiver) {
                            if (transceiver.iceTransport && transceiver.dtlsTransport && !transceiver.rejected) {
                                states[transceiver.iceTransport.state]++;
                                states[transceiver.dtlsTransport.state]++;
                            }
                        });
                        // ICETransport.completed and connected are the same for this purpose.
                        states.connected += states.completed;
                        newState = 'new';
                        if (states.failed > 0) newState = 'failed';
                        else if (states.connecting > 0) newState = 'connecting';
                        else if (states.disconnected > 0) newState = 'disconnected';
                        else if (states.new > 0) newState = 'new';
                        else if (states.connected > 0) newState = 'connected';
                        if (newState !== this.connectionState) {
                            this.connectionState = newState;
                            var event = new Event('connectionstatechange');
                            this._dispatchEvent('connectionstatechange', event);
                        }
                    };
                    RTCPeerConnection.prototype.createOffer = function() {
                        var pc = this;
                        if (pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not call createOffer after close'));
                        var numAudioTracks = pc.transceivers.filter(function(t) {
                            return t.kind === 'audio';
                        }).length;
                        var numVideoTracks = pc.transceivers.filter(function(t) {
                            return t.kind === 'video';
                        }).length;
                        // Determine number of audio and video tracks we need to send/recv.
                        var offerOptions = arguments[0];
                        if (offerOptions) {
                            // Reject Chrome legacy constraints.
                            if (offerOptions.mandatory || offerOptions.optional) throw new TypeError('Legacy mandatory/optional constraints not supported.');
                            if (offerOptions.offerToReceiveAudio !== undefined) {
                                if (offerOptions.offerToReceiveAudio === true) numAudioTracks = 1;
                                else if (offerOptions.offerToReceiveAudio === false) numAudioTracks = 0;
                                else numAudioTracks = offerOptions.offerToReceiveAudio;
                            }
                            if (offerOptions.offerToReceiveVideo !== undefined) {
                                if (offerOptions.offerToReceiveVideo === true) numVideoTracks = 1;
                                else if (offerOptions.offerToReceiveVideo === false) numVideoTracks = 0;
                                else numVideoTracks = offerOptions.offerToReceiveVideo;
                            }
                        }
                        pc.transceivers.forEach(function(transceiver) {
                            if (transceiver.kind === 'audio') {
                                numAudioTracks--;
                                if (numAudioTracks < 0) transceiver.wantReceive = false;
                            } else if (transceiver.kind === 'video') {
                                numVideoTracks--;
                                if (numVideoTracks < 0) transceiver.wantReceive = false;
                            }
                        });
                        // Create M-lines for recvonly streams.
                        while(numAudioTracks > 0 || numVideoTracks > 0){
                            if (numAudioTracks > 0) {
                                pc._createTransceiver('audio');
                                numAudioTracks--;
                            }
                            if (numVideoTracks > 0) {
                                pc._createTransceiver('video');
                                numVideoTracks--;
                            }
                        }
                        var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
                        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                            // For each track, create an ice gatherer, ice transport,
                            // dtls transport, potentially rtpsender and rtpreceiver.
                            var track = transceiver.track;
                            var kind = transceiver.kind;
                            var mid = transceiver.mid || SDPUtils.generateIdentifier();
                            transceiver.mid = mid;
                            if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
                            var localCapabilities = window1.RTCRtpSender.getCapabilities(kind);
                            // filter RTX until additional stuff needed for RTX is implemented
                            // in adapter.js
                            if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                                return codec.name !== 'rtx';
                            });
                            localCapabilities.codecs.forEach(function(codec) {
                                // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
                                // by adding level-asymmetry-allowed=1
                                if (codec.name === 'H264' && codec.parameters['level-asymmetry-allowed'] === undefined) codec.parameters['level-asymmetry-allowed'] = '1';
                                // for subsequent offers, we might have to re-use the payload
                                // type of the last offer.
                                if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
                                    if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) codec.preferredPayloadType = remoteCodec.payloadType;
                                });
                            });
                            localCapabilities.headerExtensions.forEach(function(hdrExt) {
                                var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
                                remoteExtensions.forEach(function(rHdrExt) {
                                    if (hdrExt.uri === rHdrExt.uri) hdrExt.id = rHdrExt.id;
                                });
                            });
                            // generate an ssrc now, to be used later in rtpSender.send
                            var sendEncodingParameters = transceiver.sendEncodingParameters || [
                                {
                                    ssrc: (2 * sdpMLineIndex + 1) * 1001
                                }
                            ];
                            if (track) // add RTX
                            {
                                if (edgeVersion >= 15019 && kind === 'video' && !sendEncodingParameters[0].rtx) sendEncodingParameters[0].rtx = {
                                    ssrc: sendEncodingParameters[0].ssrc + 1
                                };
                            }
                            if (transceiver.wantReceive) transceiver.rtpReceiver = new window1.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                            transceiver.localCapabilities = localCapabilities;
                            transceiver.sendEncodingParameters = sendEncodingParameters;
                        });
                        // always offer BUNDLE and dispose on return if not supported.
                        if (pc._config.bundlePolicy !== 'max-compat') sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
                            return t.mid;
                        }).join(' ') + '\r\n';
                        sdp += 'a=ice-options:trickle\r\n';
                        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                            sdp += writeMediaSection(transceiver, transceiver.localCapabilities, 'offer', transceiver.stream, pc._dtlsRole);
                            sdp += 'a=rtcp-rsize\r\n';
                            if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' && (sdpMLineIndex === 0 || !pc.usingBundle)) {
                                transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
                                    cand.component = 1;
                                    sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
                                });
                                if (transceiver.iceGatherer.state === 'completed') sdp += 'a=end-of-candidates\r\n';
                            }
                        });
                        var desc = new window1.RTCSessionDescription({
                            type: 'offer',
                            sdp: sdp
                        });
                        return Promise.resolve(desc);
                    };
                    RTCPeerConnection.prototype.createAnswer = function() {
                        var pc = this;
                        if (pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not call createAnswer after close'));
                        if (!(pc.signalingState === 'have-remote-offer' || pc.signalingState === 'have-local-pranswer')) return Promise.reject(makeError('InvalidStateError', 'Can not call createAnswer in signalingState ' + pc.signalingState));
                        var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
                        if (pc.usingBundle) sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
                            return t.mid;
                        }).join(' ') + '\r\n';
                        sdp += 'a=ice-options:trickle\r\n';
                        var mediaSectionsInOffer = SDPUtils.getMediaSections(pc._remoteDescription.sdp).length;
                        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                            if (sdpMLineIndex + 1 > mediaSectionsInOffer) return;
                            if (transceiver.rejected) {
                                if (transceiver.kind === 'application') {
                                    if (transceiver.protocol === 'DTLS/SCTP') sdp += 'm=application 0 DTLS/SCTP 5000\r\n';
                                    else sdp += 'm=application 0 ' + transceiver.protocol + ' webrtc-datachannel\r\n';
                                } else if (transceiver.kind === 'audio') sdp += "m=audio 0 UDP/TLS/RTP/SAVPF 0\r\na=rtpmap:0 PCMU/8000\r\n";
                                else if (transceiver.kind === 'video') sdp += "m=video 0 UDP/TLS/RTP/SAVPF 120\r\na=rtpmap:120 VP8/90000\r\n";
                                sdp += "c=IN IP4 0.0.0.0\r\na=inactive\r\na=mid:" + transceiver.mid + '\r\n';
                                return;
                            }
                            // FIXME: look at direction.
                            if (transceiver.stream) {
                                var localTrack;
                                if (transceiver.kind === 'audio') localTrack = transceiver.stream.getAudioTracks()[0];
                                else if (transceiver.kind === 'video') localTrack = transceiver.stream.getVideoTracks()[0];
                                if (localTrack) // add RTX
                                {
                                    if (edgeVersion >= 15019 && transceiver.kind === 'video' && !transceiver.sendEncodingParameters[0].rtx) transceiver.sendEncodingParameters[0].rtx = {
                                        ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
                                    };
                                }
                            }
                            // Calculate intersection of capabilities.
                            var commonCapabilities = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
                            var hasRtx = commonCapabilities.codecs.filter(function(c) {
                                return c.name.toLowerCase() === 'rtx';
                            }).length;
                            if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
                            sdp += writeMediaSection(transceiver, commonCapabilities, 'answer', transceiver.stream, pc._dtlsRole);
                            if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
                        });
                        var desc = new window1.RTCSessionDescription({
                            type: 'answer',
                            sdp: sdp
                        });
                        return Promise.resolve(desc);
                    };
                    RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
                        var pc = this;
                        var sections;
                        if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
                        // TODO: needs to go into ops queue.
                        return new Promise(function(resolve, reject) {
                            if (!pc._remoteDescription) return reject(makeError('InvalidStateError', 'Can not add ICE candidate without a remote description'));
                            else if (!candidate || candidate.candidate === '') for(var j = 0; j < pc.transceivers.length; j++){
                                if (pc.transceivers[j].rejected) continue;
                                pc.transceivers[j].iceTransport.addRemoteCandidate({});
                                sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
                                sections[j] += 'a=end-of-candidates\r\n';
                                pc._remoteDescription.sdp = SDPUtils.getDescription(pc._remoteDescription.sdp) + sections.join('');
                                if (pc.usingBundle) break;
                            }
                            else {
                                var sdpMLineIndex = candidate.sdpMLineIndex;
                                if (candidate.sdpMid) {
                                    for(var i = 0; i < pc.transceivers.length; i++)if (pc.transceivers[i].mid === candidate.sdpMid) {
                                        sdpMLineIndex = i;
                                        break;
                                    }
                                }
                                var transceiver = pc.transceivers[sdpMLineIndex];
                                if (transceiver) {
                                    if (transceiver.rejected) return resolve();
                                    var cand = Object.keys(candidate.candidate).length > 0 ? SDPUtils.parseCandidate(candidate.candidate) : {};
                                    // Ignore Chrome's invalid candidates since Edge does not like them.
                                    if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) return resolve();
                                    // Ignore RTCP candidates, we assume RTCP-MUX.
                                    if (cand.component && cand.component !== 1) return resolve();
                                    // when using bundle, avoid adding candidates to the wrong
                                    // ice transport. And avoid adding candidates added in the SDP.
                                    if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
                                        if (!maybeAddCandidate(transceiver.iceTransport, cand)) return reject(makeError('OperationError', 'Can not add ICE candidate'));
                                    }
                                    // update the remoteDescription.
                                    var candidateString = candidate.candidate.trim();
                                    if (candidateString.indexOf('a=') === 0) candidateString = candidateString.substr(2);
                                    sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
                                    sections[sdpMLineIndex] += 'a=' + (cand.type ? candidateString : 'end-of-candidates') + '\r\n';
                                    pc._remoteDescription.sdp = SDPUtils.getDescription(pc._remoteDescription.sdp) + sections.join('');
                                } else return reject(makeError('OperationError', 'Can not add ICE candidate'));
                            }
                            resolve();
                        });
                    };
                    RTCPeerConnection.prototype.getStats = function(selector) {
                        if (selector && selector instanceof window1.MediaStreamTrack) {
                            var senderOrReceiver = null;
                            this.transceivers.forEach(function(transceiver) {
                                if (transceiver.rtpSender && transceiver.rtpSender.track === selector) senderOrReceiver = transceiver.rtpSender;
                                else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track === selector) senderOrReceiver = transceiver.rtpReceiver;
                            });
                            if (!senderOrReceiver) throw makeError('InvalidAccessError', 'Invalid selector.');
                            return senderOrReceiver.getStats();
                        }
                        var promises = [];
                        this.transceivers.forEach(function(transceiver) {
                            [
                                'rtpSender',
                                'rtpReceiver',
                                'iceGatherer',
                                'iceTransport',
                                'dtlsTransport'
                            ].forEach(function(method) {
                                if (transceiver[method]) promises.push(transceiver[method].getStats());
                            });
                        });
                        return Promise.all(promises).then(function(allStats) {
                            var results = new Map();
                            allStats.forEach(function(stats) {
                                stats.forEach(function(stat) {
                                    results.set(stat.id, stat);
                                });
                            });
                            return results;
                        });
                    };
                    // fix low-level stat names and return Map instead of object.
                    var ortcObjects = [
                        'RTCRtpSender',
                        'RTCRtpReceiver',
                        'RTCIceGatherer',
                        'RTCIceTransport',
                        'RTCDtlsTransport'
                    ];
                    ortcObjects.forEach(function(ortcObjectName) {
                        var obj = window1[ortcObjectName];
                        if (obj && obj.prototype && obj.prototype.getStats) {
                            var nativeGetstats = obj.prototype.getStats;
                            obj.prototype.getStats = function() {
                                return nativeGetstats.apply(this).then(function(nativeStats) {
                                    var mapStats = new Map();
                                    Object.keys(nativeStats).forEach(function(id) {
                                        nativeStats[id].type = fixStatsType(nativeStats[id]);
                                        mapStats.set(id, nativeStats[id]);
                                    });
                                    return mapStats;
                                });
                            };
                        }
                    });
                    // legacy callback shims. Should be moved to adapter.js some days.
                    var methods = [
                        'createOffer',
                        'createAnswer'
                    ];
                    methods.forEach(function(method) {
                        var nativeMethod = RTCPeerConnection.prototype[method];
                        RTCPeerConnection.prototype[method] = function() {
                            var args = arguments;
                            if (typeof args[0] === 'function' || typeof args[1] === 'function') return nativeMethod.apply(this, [
                                arguments[2]
                            ]).then(function(description) {
                                if (typeof args[0] === 'function') args[0].apply(null, [
                                    description
                                ]);
                            }, function(error) {
                                if (typeof args[1] === 'function') args[1].apply(null, [
                                    error
                                ]);
                            });
                            return nativeMethod.apply(this, arguments);
                        };
                    });
                    methods = [
                        'setLocalDescription',
                        'setRemoteDescription',
                        'addIceCandidate'
                    ];
                    methods.forEach(function(method) {
                        var nativeMethod = RTCPeerConnection.prototype[method];
                        RTCPeerConnection.prototype[method] = function() {
                            var args = arguments;
                            if (typeof args[1] === 'function' || typeof args[2] === 'function') return nativeMethod.apply(this, arguments).then(function() {
                                if (typeof args[1] === 'function') args[1].apply(null);
                            }, function(error) {
                                if (typeof args[2] === 'function') args[2].apply(null, [
                                    error
                                ]);
                            });
                            return nativeMethod.apply(this, arguments);
                        };
                    });
                    // getStats is special. It doesn't have a spec legacy method yet we support
                    // getStats(something, cb) without error callbacks.
                    [
                        'getStats'
                    ].forEach(function(method) {
                        var nativeMethod = RTCPeerConnection.prototype[method];
                        RTCPeerConnection.prototype[method] = function() {
                            var args = arguments;
                            if (typeof args[1] === 'function') return nativeMethod.apply(this, arguments).then(function() {
                                if (typeof args[1] === 'function') args[1].apply(null);
                            });
                            return nativeMethod.apply(this, arguments);
                        };
                    });
                    return RTCPeerConnection;
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 566 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-env node */ // Expose public methods.
                module1.exports = function(window1) {
                    var navigator1 = window1 && window1.navigator;
                    var shimError_ = function(e) {
                        return {
                            name: ({
                                PermissionDeniedError: 'NotAllowedError'
                            })[e.name] || e.name,
                            message: e.message,
                            constraint: e.constraint,
                            toString: function() {
                                return this.name;
                            }
                        };
                    };
                    // getUserMedia error shim.
                    var origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
                    navigator1.mediaDevices.getUserMedia = function(c) {
                        return origGetUserMedia(c).catch(function(e) {
                            return Promise.reject(shimError_(e));
                        });
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 567 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-env node */ var utils = __webpack_require__(28);
                module1.exports = {
                    shimGetUserMedia: __webpack_require__(568),
                    shimOnTrack: function(window1) {
                        if (typeof window1 === 'object' && window1.RTCPeerConnection && !('ontrack' in window1.RTCPeerConnection.prototype)) Object.defineProperty(window1.RTCPeerConnection.prototype, 'ontrack', {
                            get: function() {
                                return this._ontrack;
                            },
                            set: function(f) {
                                if (this._ontrack) {
                                    this.removeEventListener('track', this._ontrack);
                                    this.removeEventListener('addstream', this._ontrackpoly);
                                }
                                this.addEventListener('track', this._ontrack = f);
                                this.addEventListener('addstream', this._ontrackpoly = (function(e) {
                                    e.stream.getTracks().forEach((function(track) {
                                        var event = new Event('track');
                                        event.track = track;
                                        event.receiver = {
                                            track: track
                                        };
                                        event.transceiver = {
                                            receiver: event.receiver
                                        };
                                        event.streams = [
                                            e.stream
                                        ];
                                        this.dispatchEvent(event);
                                    }).bind(this));
                                }).bind(this));
                            },
                            enumerable: true,
                            configurable: true
                        });
                        if (typeof window1 === 'object' && window1.RTCTrackEvent && 'receiver' in window1.RTCTrackEvent.prototype && !('transceiver' in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
                            get: function() {
                                return {
                                    receiver: this.receiver
                                };
                            }
                        });
                    },
                    shimSourceObject: function(window1) {
                        // Firefox has supported mozSrcObject since FF22, unprefixed in 42.
                        if (typeof window1 === 'object') {
                            if (window1.HTMLMediaElement && !('srcObject' in window1.HTMLMediaElement.prototype)) // Shim the srcObject property, once, when HTMLMediaElement is found.
                            Object.defineProperty(window1.HTMLMediaElement.prototype, 'srcObject', {
                                get: function() {
                                    return this.mozSrcObject;
                                },
                                set: function(stream) {
                                    this.mozSrcObject = stream;
                                }
                            });
                        }
                    },
                    shimPeerConnection: function(window1) {
                        var browserDetails = utils.detectBrowser(window1);
                        if (typeof window1 !== 'object' || !(window1.RTCPeerConnection || window1.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
                        // The RTCPeerConnection object.
                        if (!window1.RTCPeerConnection) {
                            window1.RTCPeerConnection = function(pcConfig, pcConstraints) {
                                if (browserDetails.version < 38) // .urls is not supported in FF < 38.
                                // create RTCIceServers with a single url.
                                {
                                    if (pcConfig && pcConfig.iceServers) {
                                        var newIceServers = [];
                                        for(var i = 0; i < pcConfig.iceServers.length; i++){
                                            var server = pcConfig.iceServers[i];
                                            if (server.hasOwnProperty('urls')) for(var j = 0; j < server.urls.length; j++){
                                                var newServer = {
                                                    url: server.urls[j]
                                                };
                                                if (server.urls[j].indexOf('turn') === 0) {
                                                    newServer.username = server.username;
                                                    newServer.credential = server.credential;
                                                }
                                                newIceServers.push(newServer);
                                            }
                                            else newIceServers.push(pcConfig.iceServers[i]);
                                        }
                                        pcConfig.iceServers = newIceServers;
                                    }
                                }
                                return new window1.mozRTCPeerConnection(pcConfig, pcConstraints);
                            };
                            window1.RTCPeerConnection.prototype = window1.mozRTCPeerConnection.prototype;
                            // wrap static methods. Currently just generateCertificate.
                            if (window1.mozRTCPeerConnection.generateCertificate) Object.defineProperty(window1.RTCPeerConnection, 'generateCertificate', {
                                get: function() {
                                    return window1.mozRTCPeerConnection.generateCertificate;
                                }
                            });
                            window1.RTCSessionDescription = window1.mozRTCSessionDescription;
                            window1.RTCIceCandidate = window1.mozRTCIceCandidate;
                        }
                        // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
                        [
                            'setLocalDescription',
                            'setRemoteDescription',
                            'addIceCandidate'
                        ].forEach(function(method) {
                            var nativeMethod = window1.RTCPeerConnection.prototype[method];
                            window1.RTCPeerConnection.prototype[method] = function() {
                                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                                return nativeMethod.apply(this, arguments);
                            };
                        });
                        // support for addIceCandidate(null or undefined)
                        var nativeAddIceCandidate = window1.RTCPeerConnection.prototype.addIceCandidate;
                        window1.RTCPeerConnection.prototype.addIceCandidate = function() {
                            if (!arguments[0]) {
                                if (arguments[1]) arguments[1].apply(null);
                                return Promise.resolve();
                            }
                            return nativeAddIceCandidate.apply(this, arguments);
                        };
                        // shim getStats with maplike support
                        var makeMapStats = function(stats) {
                            var map = new Map();
                            Object.keys(stats).forEach(function(key) {
                                map.set(key, stats[key]);
                                map[key] = stats[key];
                            });
                            return map;
                        };
                        var modernStatsTypes = {
                            inboundrtp: 'inbound-rtp',
                            outboundrtp: 'outbound-rtp',
                            candidatepair: 'candidate-pair',
                            localcandidate: 'local-candidate',
                            remotecandidate: 'remote-candidate'
                        };
                        var nativeGetStats = window1.RTCPeerConnection.prototype.getStats;
                        window1.RTCPeerConnection.prototype.getStats = function(selector, onSucc, onErr) {
                            return nativeGetStats.apply(this, [
                                selector || null
                            ]).then(function(stats) {
                                if (browserDetails.version < 48) stats = makeMapStats(stats);
                                if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
                                // Leave callback version alone; misc old uses of forEach before Map
                                try {
                                    stats.forEach(function(stat) {
                                        stat.type = modernStatsTypes[stat.type] || stat.type;
                                    });
                                } catch (e) {
                                    if (e.name !== 'TypeError') throw e;
                                    // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                                    stats.forEach(function(stat, i) {
                                        stats.set(i, Object.assign({}, stat, {
                                            type: modernStatsTypes[stat.type] || stat.type
                                        }));
                                    });
                                }
                                return stats;
                            }).then(onSucc, onErr);
                        };
                    },
                    shimSenderGetStats: function(window1) {
                        if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
                        if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpSender.prototype) return;
                        var origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
                        if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function() {
                            var pc = this;
                            var senders = origGetSenders.apply(pc, []);
                            senders.forEach(function(sender) {
                                sender._pc = pc;
                            });
                            return senders;
                        };
                        var origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
                        if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function() {
                            var sender = origAddTrack.apply(this, arguments);
                            sender._pc = this;
                            return sender;
                        };
                        window1.RTCRtpSender.prototype.getStats = function() {
                            return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
                        };
                    },
                    shimReceiverGetStats: function(window1) {
                        if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
                        if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpReceiver.prototype) return;
                        var origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
                        if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function() {
                            var pc = this;
                            var receivers = origGetReceivers.apply(pc, []);
                            receivers.forEach(function(receiver) {
                                receiver._pc = pc;
                            });
                            return receivers;
                        };
                        utils.wrapPeerConnectionEvent(window1, 'track', function(e) {
                            e.receiver._pc = e.srcElement;
                            return e;
                        });
                        window1.RTCRtpReceiver.prototype.getStats = function() {
                            return this._pc.getStats(this.track);
                        };
                    },
                    shimRemoveStream: function(window1) {
                        if (!window1.RTCPeerConnection || 'removeStream' in window1.RTCPeerConnection.prototype) return;
                        window1.RTCPeerConnection.prototype.removeStream = function(stream) {
                            var pc = this;
                            utils.deprecated('removeStream', 'removeTrack');
                            this.getSenders().forEach(function(sender) {
                                if (sender.track && stream.getTracks().indexOf(sender.track) !== -1) pc.removeTrack(sender);
                            });
                        };
                    },
                    shimRTCDataChannel: function(window1) {
                        // rename DataChannel to RTCDataChannel (native fix in FF60):
                        // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
                        if (window1.DataChannel && !window1.RTCDataChannel) window1.RTCDataChannel = window1.DataChannel;
                    },
                    shimGetDisplayMedia: function(window1, preferredMediaSource) {
                        if (!window1.navigator || !window1.navigator.mediaDevices || 'getDisplayMedia' in window1.navigator.mediaDevices) return;
                        window1.navigator.mediaDevices.getDisplayMedia = function(constraints) {
                            if (!(constraints && constraints.video)) {
                                var err = new DOMException("getDisplayMedia without video constraints is undefined");
                                err.name = 'NotFoundError';
                                // from https://heycam.github.io/webidl/#idl-DOMException-error-names
                                err.code = 8;
                                return Promise.reject(err);
                            }
                            if (constraints.video === true) constraints.video = {
                                mediaSource: preferredMediaSource
                            };
                            else constraints.video.mediaSource = preferredMediaSource;
                            return window1.navigator.mediaDevices.getUserMedia(constraints);
                        };
                        window1.navigator.getDisplayMedia = function(constraints) {
                            utils.deprecated('navigator.getDisplayMedia', 'navigator.mediaDevices.getDisplayMedia');
                            return window1.navigator.mediaDevices.getDisplayMedia(constraints);
                        };
                    }
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 568 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-env node */ var utils = __webpack_require__(28);
                var logging = utils.log;
                // Expose public methods.
                module1.exports = function(window1) {
                    var browserDetails = utils.detectBrowser(window1);
                    var navigator1 = window1 && window1.navigator;
                    var MediaStreamTrack1 = window1 && window1.MediaStreamTrack;
                    var shimError_ = function(e) {
                        return {
                            name: ({
                                InternalError: 'NotReadableError',
                                NotSupportedError: 'TypeError',
                                PermissionDeniedError: 'NotAllowedError',
                                SecurityError: 'NotAllowedError'
                            })[e.name] || e.name,
                            message: ({
                                'The operation is insecure.': "The request is not allowed by the user agent or the platform in the current context."
                            })[e.message] || e.message,
                            constraint: e.constraint,
                            toString: function() {
                                return this.name + (this.message && ': ') + this.message;
                            }
                        };
                    };
                    // getUserMedia constraints shim.
                    var getUserMedia_ = function(constraints, onSuccess, onError) {
                        var constraintsToFF37_ = function(c) {
                            if (typeof c !== 'object' || c.require) return c;
                            var _dereq_ = [];
                            Object.keys(c).forEach(function(key) {
                                if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
                                var r = c[key] = typeof c[key] === 'object' ? c[key] : {
                                    ideal: c[key]
                                };
                                if (r.min !== undefined || r.max !== undefined || r.exact !== undefined) _dereq_.push(key);
                                if (r.exact !== undefined) {
                                    if (typeof r.exact === 'number') r.min = r.max = r.exact;
                                    else c[key] = r.exact;
                                    delete r.exact;
                                }
                                if (r.ideal !== undefined) {
                                    c.advanced = c.advanced || [];
                                    var oc = {};
                                    if (typeof r.ideal === 'number') oc[key] = {
                                        min: r.ideal,
                                        max: r.ideal
                                    };
                                    else oc[key] = r.ideal;
                                    c.advanced.push(oc);
                                    delete r.ideal;
                                    if (!Object.keys(r).length) delete c[key];
                                }
                            });
                            if (_dereq_.length) c.require = _dereq_;
                            return c;
                        };
                        constraints = JSON.parse(JSON.stringify(constraints));
                        if (browserDetails.version < 38) {
                            logging('spec: ' + JSON.stringify(constraints));
                            if (constraints.audio) constraints.audio = constraintsToFF37_(constraints.audio);
                            if (constraints.video) constraints.video = constraintsToFF37_(constraints.video);
                            logging('ff37: ' + JSON.stringify(constraints));
                        }
                        return navigator1.mozGetUserMedia(constraints, onSuccess, function(e) {
                            onError(shimError_(e));
                        });
                    };
                    // Returns the result of getUserMedia as a Promise.
                    var getUserMediaPromise_ = function(constraints) {
                        return new Promise(function(resolve, reject) {
                            getUserMedia_(constraints, resolve, reject);
                        });
                    };
                    // Shim for mediaDevices on older versions.
                    if (!navigator1.mediaDevices) navigator1.mediaDevices = {
                        getUserMedia: getUserMediaPromise_,
                        addEventListener: function() {},
                        removeEventListener: function() {}
                    };
                    navigator1.mediaDevices.enumerateDevices = navigator1.mediaDevices.enumerateDevices || function() {
                        return new Promise(function(resolve) {
                            var infos = [
                                {
                                    kind: 'audioinput',
                                    deviceId: 'default',
                                    label: '',
                                    groupId: ''
                                },
                                {
                                    kind: 'videoinput',
                                    deviceId: 'default',
                                    label: '',
                                    groupId: ''
                                }
                            ];
                            resolve(infos);
                        });
                    };
                    if (browserDetails.version < 41) {
                        // Work around http://bugzil.la/1169665
                        var orgEnumerateDevices = navigator1.mediaDevices.enumerateDevices.bind(navigator1.mediaDevices);
                        navigator1.mediaDevices.enumerateDevices = function() {
                            return orgEnumerateDevices().then(undefined, function(e) {
                                if (e.name === 'NotFoundError') return [];
                                throw e;
                            });
                        };
                    }
                    if (browserDetails.version < 49) {
                        var origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
                        navigator1.mediaDevices.getUserMedia = function(c) {
                            return origGetUserMedia(c).then(function(stream) {
                                // Work around https://bugzil.la/802326
                                if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                                    stream.getTracks().forEach(function(track) {
                                        track.stop();
                                    });
                                    throw new DOMException('The object can not be found here.', 'NotFoundError');
                                }
                                return stream;
                            }, function(e) {
                                return Promise.reject(shimError_(e));
                            });
                        };
                    }
                    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator1.mediaDevices.getSupportedConstraints())) {
                        var remap = function(obj, a, b) {
                            if (a in obj && !(b in obj)) {
                                obj[b] = obj[a];
                                delete obj[a];
                            }
                        };
                        var nativeGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
                        navigator1.mediaDevices.getUserMedia = function(c) {
                            if (typeof c === 'object' && typeof c.audio === 'object') {
                                c = JSON.parse(JSON.stringify(c));
                                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
                            }
                            return nativeGetUserMedia(c);
                        };
                        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.getSettings) {
                            var nativeGetSettings = MediaStreamTrack1.prototype.getSettings;
                            MediaStreamTrack1.prototype.getSettings = function() {
                                var obj = nativeGetSettings.apply(this, arguments);
                                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                                return obj;
                            };
                        }
                        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.applyConstraints) {
                            var nativeApplyConstraints = MediaStreamTrack1.prototype.applyConstraints;
                            MediaStreamTrack1.prototype.applyConstraints = function(c) {
                                if (this.kind === 'audio' && typeof c === 'object') {
                                    c = JSON.parse(JSON.stringify(c));
                                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                                }
                                return nativeApplyConstraints.apply(this, [
                                    c
                                ]);
                            };
                        }
                    }
                    navigator1.getUserMedia = function(constraints, onSuccess, onError) {
                        if (browserDetails.version < 44) return getUserMedia_(constraints, onSuccess, onError);
                        // Replace Firefox 44+'s deprecation warning with unprefixed version.
                        utils.deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
                        navigator1.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 569 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var utils = __webpack_require__(28);
                module1.exports = {
                    shimLocalStreamsAPI: function(window1) {
                        if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
                        if (!('getLocalStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getLocalStreams = function() {
                            if (!this._localStreams) this._localStreams = [];
                            return this._localStreams;
                        };
                        if (!('getStreamById' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getStreamById = function(id) {
                            var result = null;
                            if (this._localStreams) this._localStreams.forEach(function(stream) {
                                if (stream.id === id) result = stream;
                            });
                            if (this._remoteStreams) this._remoteStreams.forEach(function(stream) {
                                if (stream.id === id) result = stream;
                            });
                            return result;
                        };
                        if (!('addStream' in window1.RTCPeerConnection.prototype)) {
                            var _addTrack = window1.RTCPeerConnection.prototype.addTrack;
                            window1.RTCPeerConnection.prototype.addStream = function(stream) {
                                if (!this._localStreams) this._localStreams = [];
                                if (this._localStreams.indexOf(stream) === -1) this._localStreams.push(stream);
                                var pc = this;
                                stream.getTracks().forEach(function(track) {
                                    _addTrack.call(pc, track, stream);
                                });
                            };
                            window1.RTCPeerConnection.prototype.addTrack = function(track, stream) {
                                if (stream) {
                                    if (!this._localStreams) this._localStreams = [
                                        stream
                                    ];
                                    else if (this._localStreams.indexOf(stream) === -1) this._localStreams.push(stream);
                                }
                                return _addTrack.call(this, track, stream);
                            };
                        }
                        if (!('removeStream' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.removeStream = function(stream) {
                            if (!this._localStreams) this._localStreams = [];
                            var index = this._localStreams.indexOf(stream);
                            if (index === -1) return;
                            this._localStreams.splice(index, 1);
                            var pc = this;
                            var tracks = stream.getTracks();
                            this.getSenders().forEach(function(sender) {
                                if (tracks.indexOf(sender.track) !== -1) pc.removeTrack(sender);
                            });
                        };
                    },
                    shimRemoteStreamsAPI: function(window1) {
                        if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
                        if (!('getRemoteStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getRemoteStreams = function() {
                            return this._remoteStreams ? this._remoteStreams : [];
                        };
                        if (!('onaddstream' in window1.RTCPeerConnection.prototype)) {
                            Object.defineProperty(window1.RTCPeerConnection.prototype, 'onaddstream', {
                                get: function() {
                                    return this._onaddstream;
                                },
                                set: function(f) {
                                    if (this._onaddstream) this.removeEventListener('addstream', this._onaddstream);
                                    this.addEventListener('addstream', this._onaddstream = f);
                                }
                            });
                            var origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
                            window1.RTCPeerConnection.prototype.setRemoteDescription = function() {
                                var pc = this;
                                if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                                    e.streams.forEach(function(stream) {
                                        if (!pc._remoteStreams) pc._remoteStreams = [];
                                        if (pc._remoteStreams.indexOf(stream) >= 0) return;
                                        pc._remoteStreams.push(stream);
                                        var event = new Event('addstream');
                                        event.stream = stream;
                                        pc.dispatchEvent(event);
                                    });
                                });
                                return origSetRemoteDescription.apply(pc, arguments);
                            };
                        }
                    },
                    shimCallbacksAPI: function(window1) {
                        if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
                        var prototype = window1.RTCPeerConnection.prototype;
                        var createOffer = prototype.createOffer;
                        var createAnswer = prototype.createAnswer;
                        var setLocalDescription = prototype.setLocalDescription;
                        var setRemoteDescription = prototype.setRemoteDescription;
                        var addIceCandidate = prototype.addIceCandidate;
                        prototype.createOffer = function(successCallback, failureCallback) {
                            var options = arguments.length >= 2 ? arguments[2] : arguments[0];
                            var promise = createOffer.apply(this, [
                                options
                            ]);
                            if (!failureCallback) return promise;
                            promise.then(successCallback, failureCallback);
                            return Promise.resolve();
                        };
                        prototype.createAnswer = function(successCallback, failureCallback) {
                            var options = arguments.length >= 2 ? arguments[2] : arguments[0];
                            var promise = createAnswer.apply(this, [
                                options
                            ]);
                            if (!failureCallback) return promise;
                            promise.then(successCallback, failureCallback);
                            return Promise.resolve();
                        };
                        var withCallback = function(description, successCallback, failureCallback) {
                            var promise = setLocalDescription.apply(this, [
                                description
                            ]);
                            if (!failureCallback) return promise;
                            promise.then(successCallback, failureCallback);
                            return Promise.resolve();
                        };
                        prototype.setLocalDescription = withCallback;
                        withCallback = function(description, successCallback, failureCallback) {
                            var promise = setRemoteDescription.apply(this, [
                                description
                            ]);
                            if (!failureCallback) return promise;
                            promise.then(successCallback, failureCallback);
                            return Promise.resolve();
                        };
                        prototype.setRemoteDescription = withCallback;
                        withCallback = function(candidate, successCallback, failureCallback) {
                            var promise = addIceCandidate.apply(this, [
                                candidate
                            ]);
                            if (!failureCallback) return promise;
                            promise.then(successCallback, failureCallback);
                            return Promise.resolve();
                        };
                        prototype.addIceCandidate = withCallback;
                    },
                    shimGetUserMedia: function(window1) {
                        var navigator1 = window1 && window1.navigator;
                        if (!navigator1.getUserMedia) {
                            if (navigator1.webkitGetUserMedia) navigator1.getUserMedia = navigator1.webkitGetUserMedia.bind(navigator1);
                            else if (navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) navigator1.getUserMedia = (function(constraints, cb, errcb) {
                                navigator1.mediaDevices.getUserMedia(constraints).then(cb, errcb);
                            }).bind(navigator1);
                        }
                    },
                    shimRTCIceServerUrls: function(window1) {
                        // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
                        var OrigPeerConnection = window1.RTCPeerConnection;
                        window1.RTCPeerConnection = function(pcConfig, pcConstraints) {
                            if (pcConfig && pcConfig.iceServers) {
                                var newIceServers = [];
                                for(var i = 0; i < pcConfig.iceServers.length; i++){
                                    var server = pcConfig.iceServers[i];
                                    if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
                                        utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
                                        server = JSON.parse(JSON.stringify(server));
                                        server.urls = server.url;
                                        delete server.url;
                                        newIceServers.push(server);
                                    } else newIceServers.push(pcConfig.iceServers[i]);
                                }
                                pcConfig.iceServers = newIceServers;
                            }
                            return new OrigPeerConnection(pcConfig, pcConstraints);
                        };
                        window1.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
                        // wrap static methods. Currently just generateCertificate.
                        if ('generateCertificate' in window1.RTCPeerConnection) Object.defineProperty(window1.RTCPeerConnection, 'generateCertificate', {
                            get: function() {
                                return OrigPeerConnection.generateCertificate;
                            }
                        });
                    },
                    shimTrackEventTransceiver: function(window1) {
                        // Add event.transceiver member over deprecated event.receiver
                        if (typeof window1 === 'object' && window1.RTCPeerConnection && 'receiver' in window1.RTCTrackEvent.prototype && // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
                        // defined for some reason even when window.RTCTransceiver is not.
                        !window1.RTCTransceiver) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
                            get: function() {
                                return {
                                    receiver: this.receiver
                                };
                            }
                        });
                    },
                    shimCreateOfferLegacy: function(window1) {
                        var origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
                        window1.RTCPeerConnection.prototype.createOffer = function(offerOptions) {
                            var pc = this;
                            if (offerOptions) {
                                if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
                                offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
                                var audioTransceiver = pc.getTransceivers().find(function(transceiver) {
                                    return transceiver.sender.track && transceiver.sender.track.kind === 'audio';
                                });
                                if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                                    if (audioTransceiver.direction === 'sendrecv') {
                                        if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                                        else audioTransceiver.direction = 'sendonly';
                                    } else if (audioTransceiver.direction === 'recvonly') {
                                        if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                                        else audioTransceiver.direction = 'inactive';
                                    }
                                } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) pc.addTransceiver('audio');
                                if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
                                offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
                                var videoTransceiver = pc.getTransceivers().find(function(transceiver) {
                                    return transceiver.sender.track && transceiver.sender.track.kind === 'video';
                                });
                                if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                                    if (videoTransceiver.direction === 'sendrecv') videoTransceiver.setDirection('sendonly');
                                    else if (videoTransceiver.direction === 'recvonly') videoTransceiver.setDirection('inactive');
                                } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) pc.addTransceiver('video');
                            }
                            return origCreateOffer.apply(pc, arguments);
                        };
                    }
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 570 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var SDPUtils = __webpack_require__(251);
            var utils = __webpack_require__(28);
            module1.exports = {
                shimRTCIceCandidate: function(window1) {
                    // foundation is arbitrarily chosen as an indicator for full support for
                    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
                    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && 'foundation' in window1.RTCIceCandidate.prototype) return;
                    var NativeRTCIceCandidate = window1.RTCIceCandidate;
                    window1.RTCIceCandidate = function(args) {
                        // Remove the a= which shouldn't be part of the candidate string.
                        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
                            args = JSON.parse(JSON.stringify(args));
                            args.candidate = args.candidate.substr(2);
                        }
                        if (args.candidate && args.candidate.length) {
                            // Augment the native candidate with the parsed fields.
                            var nativeCandidate = new NativeRTCIceCandidate(args);
                            var parsedCandidate = SDPUtils.parseCandidate(args.candidate);
                            var augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate);
                            // Add a serializer that does not serialize the extra attributes.
                            augmentedCandidate.toJSON = function() {
                                return {
                                    candidate: augmentedCandidate.candidate,
                                    sdpMid: augmentedCandidate.sdpMid,
                                    sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
                                    usernameFragment: augmentedCandidate.usernameFragment
                                };
                            };
                            return augmentedCandidate;
                        }
                        return new NativeRTCIceCandidate(args);
                    };
                    window1.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
                    // Hook up the augmented candidate in onicecandidate and
                    // addEventListener('icecandidate', ...)
                    utils.wrapPeerConnectionEvent(window1, 'icecandidate', function(e) {
                        if (e.candidate) Object.defineProperty(e, 'candidate', {
                            value: new window1.RTCIceCandidate(e.candidate),
                            writable: 'false'
                        });
                        return e;
                    });
                },
                // shimCreateObjectURL must be called before shimSourceObject to avoid loop.
                shimCreateObjectURL: function(window1) {
                    var URL1 = window1 && window1.URL;
                    if (!(typeof window1 === 'object' && window1.HTMLMediaElement && 'srcObject' in window1.HTMLMediaElement.prototype && URL1.createObjectURL && URL1.revokeObjectURL)) // Only shim CreateObjectURL using srcObject if srcObject exists.
                    return undefined;
                    var nativeCreateObjectURL = URL1.createObjectURL.bind(URL1);
                    var nativeRevokeObjectURL = URL1.revokeObjectURL.bind(URL1);
                    var streams = new Map(), newId = 0;
                    URL1.createObjectURL = function(stream) {
                        if ('getTracks' in stream) {
                            var url = 'polyblob:' + ++newId;
                            streams.set(url, stream);
                            utils.deprecated('URL.createObjectURL(stream)', 'elem.srcObject = stream');
                            return url;
                        }
                        return nativeCreateObjectURL(stream);
                    };
                    URL1.revokeObjectURL = function(url) {
                        nativeRevokeObjectURL(url);
                        streams.delete(url);
                    };
                    var dsc = Object.getOwnPropertyDescriptor(window1.HTMLMediaElement.prototype, 'src');
                    Object.defineProperty(window1.HTMLMediaElement.prototype, 'src', {
                        get: function() {
                            return dsc.get.apply(this);
                        },
                        set: function(url) {
                            this.srcObject = streams.get(url) || null;
                            return dsc.set.apply(this, [
                                url
                            ]);
                        }
                    });
                    var nativeSetAttribute = window1.HTMLMediaElement.prototype.setAttribute;
                    window1.HTMLMediaElement.prototype.setAttribute = function() {
                        if (arguments.length === 2 && ('' + arguments[0]).toLowerCase() === 'src') this.srcObject = streams.get(arguments[1]) || null;
                        return nativeSetAttribute.apply(this, arguments);
                    };
                },
                shimMaxMessageSize: function(window1) {
                    if (window1.RTCSctpTransport || !window1.RTCPeerConnection) return;
                    var browserDetails = utils.detectBrowser(window1);
                    if (!('sctp' in window1.RTCPeerConnection.prototype)) Object.defineProperty(window1.RTCPeerConnection.prototype, 'sctp', {
                        get: function() {
                            return typeof this._sctp === 'undefined' ? null : this._sctp;
                        }
                    });
                    var sctpInDescription = function(description) {
                        var sections = SDPUtils.splitSections(description.sdp);
                        sections.shift();
                        return sections.some(function(mediaSection) {
                            var mLine = SDPUtils.parseMLine(mediaSection);
                            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
                        });
                    };
                    var getRemoteFirefoxVersion = function(description) {
                        // TODO: Is there a better solution for detecting Firefox?
                        var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
                        if (match === null || match.length < 2) return -1;
                        var version = parseInt(match[1], 10);
                        // Test for NaN (yes, this is ugly)
                        return version !== version ? -1 : version;
                    };
                    var getCanSendMaxMessageSize = function(remoteIsFirefox) {
                        // Every implementation we know can send at least 64 KiB.
                        // Note: Although Chrome is technically able to send up to 256 KiB, the
                        //       data does not reach the other peer reliably.
                        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
                        var canSendMaxMessageSize = 65536;
                        if (browserDetails.browser === 'firefox') {
                            if (browserDetails.version < 57) {
                                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                                // fragmentation.
                                canSendMaxMessageSize = 16384;
                                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                                // messages. Thus, supporting ~2 GiB when sending.
                                canSendMaxMessageSize = 2147483637;
                            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
                            // to the default value when a data channel is created at a later
                            // stage. :(
                            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
                            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
                            else // FF >= 60 supports sending ~2 GiB
                            canSendMaxMessageSize = 2147483637;
                        }
                        return canSendMaxMessageSize;
                    };
                    var getMaxMessageSize = function(description, remoteIsFirefox) {
                        // Note: 65536 bytes is the default value from the SDP spec. Also,
                        //       every implementation we know supports receiving 65536 bytes.
                        var maxMessageSize = 65536;
                        // FF 57 has a slightly incorrect default remote max message size, so
                        // we need to adjust it here to avoid a failure when sending.
                        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
                        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
                        var match = SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
                        if (match.length > 0) maxMessageSize = parseInt(match[0].substr(19), 10);
                        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
                        // both local and remote are Firefox, the remote peer can receive
                        // ~2 GiB.
                        maxMessageSize = 2147483637;
                        return maxMessageSize;
                    };
                    var origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
                    window1.RTCPeerConnection.prototype.setRemoteDescription = function() {
                        var pc = this;
                        pc._sctp = null;
                        if (sctpInDescription(arguments[0])) {
                            // Check if the remote is FF.
                            var isFirefox = getRemoteFirefoxVersion(arguments[0]);
                            // Get the maximum message size the local peer is capable of sending
                            var canSendMMS = getCanSendMaxMessageSize(isFirefox);
                            // Get the maximum message size of the remote peer.
                            var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
                            // Determine final maximum message size
                            var maxMessageSize;
                            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
                            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
                            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
                            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
                            // attribute.
                            var sctp = {};
                            Object.defineProperty(sctp, 'maxMessageSize', {
                                get: function() {
                                    return maxMessageSize;
                                }
                            });
                            pc._sctp = sctp;
                        }
                        return origSetRemoteDescription.apply(pc, arguments);
                    };
                },
                shimSendThrowTypeError: function(window1) {
                    if (!(window1.RTCPeerConnection && 'createDataChannel' in window1.RTCPeerConnection.prototype)) return;
                    // Note: Although Firefox >= 57 has a native implementation, the maximum
                    //       message size can be reset for all data channels at a later stage.
                    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
                    function wrapDcSend(dc, pc) {
                        var origDataChannelSend = dc.send;
                        dc.send = function() {
                            var data = arguments[0];
                            var length = data.length || data.size || data.byteLength;
                            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
                            return origDataChannelSend.apply(dc, arguments);
                        };
                    }
                    var origCreateDataChannel = window1.RTCPeerConnection.prototype.createDataChannel;
                    window1.RTCPeerConnection.prototype.createDataChannel = function() {
                        var pc = this;
                        var dataChannel = origCreateDataChannel.apply(pc, arguments);
                        wrapDcSend(dataChannel, pc);
                        return dataChannel;
                    };
                    utils.wrapPeerConnectionEvent(window1, 'datachannel', function(e) {
                        wrapDcSend(e.channel, e.target);
                        return e;
                    });
                }
            };
        /***/ },
        /* 571 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const eventing = __webpack_require__(7);
                function isDomReady() {
                    // if there is no document, how is the document object model ready?
                    return typeof document === 'undefined' || document.readyState === 'complete' || document.readyState === 'interactive' && document.body;
                }
                let unloaded = false;
                const domState = {
                    isDomLoaded: isDomReady,
                    isDomUnloaded () {
                        return unloaded;
                    },
                    whenUnloaded: new Promise((resolve)=>{
                        if (typeof window !== 'undefined') {
                            const unload = ()=>{
                                unloaded = true;
                                domState.emit('unload');
                                resolve();
                            };
                            window.addEventListener('unload', unload);
                        }
                    }),
                    whenLoaded: new Promise((resolve)=>{
                        if (isDomReady()) {
                            resolve();
                            return;
                        }
                        const load = ()=>{
                            document.removeEventListener('DOMContentLoaded', load);
                            document.removeEventListener('load', load);
                            domState.emit('load');
                            resolve();
                        };
                        document.addEventListener('DOMContentLoaded', load);
                        document.addEventListener('load', load);
                    })
                };
                eventing(domState);
                module1.exports = domState;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 572 */ /***/ function(module1, exports, __webpack_require__) {
            var Stack = __webpack_require__(79), assignMergeValue = __webpack_require__(256), baseFor = __webpack_require__(239), baseMergeDeep = __webpack_require__(573), isObject = __webpack_require__(11), keysIn = __webpack_require__(55), safeGet = __webpack_require__(257);
            /**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) return;
                baseFor(source, function(srcValue, key) {
                    stack || (stack = new Stack);
                    if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                    else {
                        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                        if (newValue === undefined) newValue = srcValue;
                        assignMergeValue(object, key, newValue);
                    }
                }, keysIn);
            }
            module1.exports = baseMerge;
        /***/ },
        /* 573 */ /***/ function(module1, exports, __webpack_require__) {
            var assignMergeValue = __webpack_require__(256), cloneBuffer = __webpack_require__(180), cloneTypedArray = __webpack_require__(189), copyArray = __webpack_require__(56), initCloneObject = __webpack_require__(190), isArguments = __webpack_require__(65), isArray = __webpack_require__(12), isArrayLikeObject = __webpack_require__(129), isBuffer = __webpack_require__(66), isFunction = __webpack_require__(17), isObject = __webpack_require__(11), isPlainObject = __webpack_require__(135), isTypedArray = __webpack_require__(86), safeGet = __webpack_require__(257), toPlainObject = __webpack_require__(574);
            /**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                if (stacked) {
                    assignMergeValue(object, key, stacked);
                    return;
                }
                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;
                if (isCommon) {
                    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                    newValue = srcValue;
                    if (isArr || isBuff || isTyped) {
                        if (isArray(objValue)) newValue = objValue;
                        else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                        else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                        } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                        } else newValue = [];
                    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                        newValue = objValue;
                        if (isArguments(objValue)) newValue = toPlainObject(objValue);
                        else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                    } else isCommon = false;
                }
                if (isCommon) {
                    // Recursively merge objects and arrays (susceptible to call stack limits).
                    stack.set(srcValue, newValue);
                    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                    stack['delete'](srcValue);
                }
                assignMergeValue(object, key, newValue);
            }
            module1.exports = baseMergeDeep;
        /***/ },
        /* 574 */ /***/ function(module1, exports, __webpack_require__) {
            var copyObject = __webpack_require__(41), keysIn = __webpack_require__(55);
            /**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
                return copyObject(value, keysIn(value));
            }
            module1.exports = toPlainObject;
        /***/ },
        /* 575 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-confusing-arrow */ const assert = __webpack_require__(147);
            const browserRejectsOptionalMandatory = __webpack_require__(258);
            const capitalize = __webpack_require__(259);
            const hasAudioScreenSharingSupport = __webpack_require__(264);
            const defaultLogging = __webpack_require__(2)('normalizeConstraintInput');
            const validResolutions = {
                '320x240': {
                    width: 320,
                    height: 240
                },
                '320x180': {
                    width: 320,
                    height: 180
                },
                '640x480': {
                    width: 640,
                    height: 480
                },
                '640x360': {
                    width: 640,
                    height: 360
                },
                '1280x720': {
                    width: 1280,
                    height: 720
                },
                '1280x960': {
                    width: 1280,
                    height: 960
                },
                '1920x1080': {
                    width: 1920,
                    height: 1080
                }
            };
            const validFrameRates = [
                1,
                7,
                15,
                30
            ];
            function getLogging(opt) {
                return opt._inject && opt._inject.logging || defaultLogging;
            }
            function lookupParam(name, param, lookup, possibilities, logging) {
                if (param === undefined) return undefined;
                const result = lookup(param);
                if (!result) logging.warn(`Invalid ${name} passed to the Publisher. Got: ${param}, expecting one of ${possibilities}`);
                return result;
            }
            function normalizeMediaParams(mediaType, opt) {
                const logging = getLogging(opt);
                const publish = (()=>{
                    const param = opt[`publish${capitalize(mediaType)}`];
                    if (param !== undefined) return Boolean(param);
                    return true;
                })();
                let source = (()=>{
                    const param = opt[`${mediaType}Source`];
                    if (param === undefined) return true;
                    if (param === null || param === false) return false;
                    if (typeof param === 'object') {
                        if (opt[`isCustom${capitalize(mediaType)}Track`]) return false;
                        if (typeof param.deviceId !== 'string') {
                            logging.warn(`Invalid ${mediaType}Source passed to Publisher. Expected either a device ID or ` + 'device.');
                            return true;
                        }
                        return param.deviceId;
                    }
                    if (typeof param !== 'string') {
                        logging.warn(`Ignoring invalid ${mediaType}Source parameter`);
                        return true;
                    }
                    return param;
                })();
                if (mediaType === 'audio' && opt.isScreenSharing && !hasAudioScreenSharingSupport && source !== false) {
                    if (opt.audioSource) getLogging(opt).warn("Invalid audioSource passed to Publisher - when using screen sharing no audioSource may be used");
                    source = false;
                }
                return {
                    source: source,
                    publish: publish
                };
            }
            function fixChromeBug707118(env, frameRate) {
                // OPENTOK-32592: 1fps with facetime camera causes chrome to lock up intermittently. Workaround
                // is just to use 2fps instead for now.
                // https://bugs.chromium.org/p/chromium/issues/detail?id=707118
                if (env.name === 'Chrome' && env.userAgent.indexOf('Mac OS X') !== -1 && frameRate === 1) return 2;
                return frameRate;
            }
            const validFacingModes = [
                'user',
                'environment',
                'left',
                'right'
            ];
            const normaliseFacingMode = (facingMode, opt)=>{
                if (facingMode === undefined || validFacingModes.indexOf(facingMode) >= 0) return facingMode;
                const logging = getLogging(opt); // Ignore facingMode if its defined but an invalid value
                logging.warn(`Invalid facingMode passed to Publisher. Expected one of: ${validFacingModes.join(', ')}`);
                return undefined;
            };
            module1.exports = function normalizeConstraintInput(opt) {
                const logging = getLogging(opt);
                const env = opt.env || {};
                const isScreenSharing = opt.isScreenSharing, isCustomAudioTrack = opt.isCustomAudioTrack, isCustomVideoTrack = opt.isCustomVideoTrack;
                if (isScreenSharing && !browserRejectsOptionalMandatory) assert(opt.usingOptionalMandatoryStyle, 'Screensharing only uses optional-mandatory constraints right now');
                 // Defaults audio processing constraints to true
                [
                    'echoCancellation',
                    'autoGainControl',
                    'noiseSuppression'
                ].forEach((constraint)=>{
                    if (opt[constraint] !== false) Object.assign(opt, {
                        [constraint]: true
                    });
                });
                return {
                    isScreenSharing: isScreenSharing,
                    isCustomAudioTrack: isCustomAudioTrack,
                    isCustomVideoTrack: isCustomVideoTrack,
                    // These will be of the form { source: string | boolean, publish: boolean }
                    audio: normalizeMediaParams('audio', opt),
                    video: normalizeMediaParams('video', opt),
                    usingOptionalMandatoryStyle: opt.usingOptionalMandatoryStyle,
                    enableRenegotiation: opt.enableRenegotiation,
                    enableStereo: opt.enableStereo,
                    noiseSuppression: opt.noiseSuppression,
                    autoGainControl: opt.autoGainControl,
                    echoCancellation: opt.echoCancellation,
                    disableAudioProcessing: opt.disableAudioProcessing,
                    videoDimensions: lookupParam('resolution', opt.resolution, (param)=>validResolutions[param], `"${Object.keys(validResolutions).join('", "')}"`, logging),
                    frameRate: fixChromeBug707118(env, lookupParam('frameRate', opt.frameRate, (param)=>validFrameRates.indexOf(param) !== -1 ? param : undefined, validFrameRates.join(','), logging)),
                    maxResolution: function() {
                        if (opt.maxResolution === undefined) return isScreenSharing ? {
                            width: 1920,
                            height: 1920
                        } : undefined;
                        const result = {
                            width: opt.maxResolution.width,
                            height: opt.maxResolution.height
                        };
                        Object.keys(result).forEach((dimensionName)=>{
                            const dim = result[dimensionName];
                            if (typeof dim !== 'number' || dim > 1920) {
                                logging.warn(`Invalid maxResolution passed to the Publisher. maxResolution.${dimensionName} must be less than or equal to 1920`);
                                result[dimensionName] = 1920;
                            }
                        });
                        return result;
                    }(),
                    facingMode: normaliseFacingMode(opt.facingMode, opt)
                };
            };
        /***/ },
        /* 576 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
            var hasOwnProperty1 = Object.prototype.hasOwnProperty;
            var propIsEnumerable = Object.prototype.propertyIsEnumerable;
            function toObject(val) {
                if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
                return Object(val);
            }
            function shouldUseNative() {
                try {
                    if (!Object.assign) return false;
                    // Detect buggy property enumeration order in older V8 versions.
                    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
                    test1[5] = 'de';
                    if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
                    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                    var test2 = {};
                    for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
                    var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                        return test2[n];
                    });
                    if (order2.join('') !== '0123456789') return false;
                    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                    var test3 = {};
                    'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                        test3[letter] = letter;
                    });
                    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
                    return true;
                } catch (err) {
                    // We don't expect any of the above to throw, but better to be safe.
                    return false;
                }
            }
            module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                var from;
                var to = toObject(target);
                var symbols;
                for(var s = 1; s < arguments.length; s++){
                    from = Object(arguments[s]);
                    for(var key in from)if (hasOwnProperty1.call(from, key)) to[key] = from[key];
                    if (getOwnPropertySymbols) {
                        symbols = getOwnPropertySymbols(from);
                        for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                    }
                }
                return to;
            };
        /***/ },
        /* 577 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(process, Promise) {
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
                    var keys = Object.keys(obj);
                    var descriptors = {};
                    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
                    return descriptors;
                };
                var formatRegExp = /%[sdj%]/g;
                exports.format = function(f) {
                    if (!isString(f)) {
                        var objects = [];
                        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                        return objects.join(' ');
                    }
                    var i = 1;
                    var args = arguments;
                    var len = args.length;
                    var str = String(f).replace(formatRegExp, function(x) {
                        if (x === '%%') return '%';
                        if (i >= len) return x;
                        switch(x){
                            case '%s':
                                return String(args[i++]);
                            case '%d':
                                return Number(args[i++]);
                            case '%j':
                                try {
                                    return JSON.stringify(args[i++]);
                                } catch (_) {
                                    return '[Circular]';
                                }
                            default:
                                return x;
                        }
                    });
                    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += ' ' + x;
                    else str += ' ' + inspect(x);
                    return str;
                };
                // Mark that a method should not be used.
                // Returns a modified function which warns once by default.
                // If --no-deprecation is set, then it is a no-op.
                exports.deprecate = function(fn, msg) {
                    if (typeof process !== 'undefined' && process.noDeprecation === true) return fn;
                    // Allow for deprecating things in the process of starting up.
                    if (typeof process === 'undefined') return function() {
                        return exports.deprecate(fn, msg).apply(this, arguments);
                    };
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (process.throwDeprecation) throw new Error(msg);
                            else if (process.traceDeprecation) console.trace(msg);
                            else console.error(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                };
                var debugs = {};
                var debugEnviron;
                exports.debuglog = function(set) {
                    if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
                    set = set.toUpperCase();
                    if (!debugs[set]) {
                        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
                            var pid = process.pid;
                            debugs[set] = function() {
                                var msg = exports.format.apply(exports, arguments);
                                console.error('%s %d: %s', set, pid, msg);
                            };
                        } else debugs[set] = function() {};
                    }
                    return debugs[set];
                };
                /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
                    // default options
                    var ctx = {
                        seen: [],
                        stylize: stylizeNoColor
                    };
                    // legacy...
                    if (arguments.length >= 3) ctx.depth = arguments[2];
                    if (arguments.length >= 4) ctx.colors = arguments[3];
                    if (isBoolean(opts)) // legacy...
                    ctx.showHidden = opts;
                    else if (opts) // got an "options" object
                    exports._extend(ctx, opts);
                    // set default options
                    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                    if (isUndefined(ctx.depth)) ctx.depth = 2;
                    if (isUndefined(ctx.colors)) ctx.colors = false;
                    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
                    if (ctx.colors) ctx.stylize = stylizeWithColor;
                    return formatValue(ctx, obj, ctx.depth);
                }
                exports.inspect = inspect;
                // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                inspect.colors = {
                    'bold': [
                        1,
                        22
                    ],
                    'italic': [
                        3,
                        23
                    ],
                    'underline': [
                        4,
                        24
                    ],
                    'inverse': [
                        7,
                        27
                    ],
                    'white': [
                        37,
                        39
                    ],
                    'grey': [
                        90,
                        39
                    ],
                    'black': [
                        30,
                        39
                    ],
                    'blue': [
                        34,
                        39
                    ],
                    'cyan': [
                        36,
                        39
                    ],
                    'green': [
                        32,
                        39
                    ],
                    'magenta': [
                        35,
                        39
                    ],
                    'red': [
                        31,
                        39
                    ],
                    'yellow': [
                        33,
                        39
                    ]
                };
                // Don't use 'blue' not visible on cmd.exe
                inspect.styles = {
                    'special': 'cyan',
                    'number': 'yellow',
                    'boolean': 'yellow',
                    'undefined': 'grey',
                    'null': 'bold',
                    'string': 'green',
                    'date': 'magenta',
                    // "name": intentionally not styling
                    'regexp': 'red'
                };
                function stylizeWithColor(str, styleType) {
                    var style = inspect.styles[styleType];
                    if (style) return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
                    else return str;
                }
                function stylizeNoColor(str, styleType) {
                    return str;
                }
                function arrayToHash(array) {
                    var hash = {};
                    array.forEach(function(val, idx) {
                        hash[val] = true;
                    });
                    return hash;
                }
                function formatValue(ctx, value, recurseTimes) {
                    // Provide a hook for user-specified inspect functions.
                    // Check that value is an object with an inspect function on it
                    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
                    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
                    !(value.constructor && value.constructor.prototype === value)) {
                        var ret = value.inspect(recurseTimes, ctx);
                        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                        return ret;
                    }
                    // Primitive types cannot have properties
                    var primitive = formatPrimitive(ctx, value);
                    if (primitive) return primitive;
                    // Look up the keys of the object.
                    var keys = Object.keys(value);
                    var visibleKeys = arrayToHash(keys);
                    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
                    // IE doesn't make error fields non-enumerable
                    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return formatError(value);
                    // Some type of object without properties can be shortcutted.
                    if (keys.length === 0) {
                        if (isFunction(value)) {
                            var name = value.name ? ': ' + value.name : '';
                            return ctx.stylize('[Function' + name + ']', 'special');
                        }
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
                        if (isError(value)) return formatError(value);
                    }
                    var base = '', array = false, braces = [
                        '{',
                        '}'
                    ];
                    // Make Array say that they are Array
                    if (isArray(value)) {
                        array = true;
                        braces = [
                            '[',
                            ']'
                        ];
                    }
                    // Make functions say that they are functions
                    if (isFunction(value)) {
                        var n = value.name ? ': ' + value.name : '';
                        base = ' [Function' + n + ']';
                    }
                    // Make RegExps say that they are RegExps
                    if (isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
                    // Make dates with properties first say the date
                    if (isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
                    // Make error with message first say the error
                    if (isError(value)) base = ' ' + formatError(value);
                    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
                    if (recurseTimes < 0) {
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        else return ctx.stylize('[Object]', 'special');
                    }
                    ctx.seen.push(value);
                    var output;
                    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
                    else output = keys.map(function(key) {
                        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
                    });
                    ctx.seen.pop();
                    return reduceToSingleString(output, base, braces);
                }
                function formatPrimitive(ctx, value) {
                    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
                    if (isString(value)) {
                        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
                        return ctx.stylize(simple, 'string');
                    }
                    if (isNumber(value)) return ctx.stylize('' + value, 'number');
                    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
                    // For some reason typeof null is "object", so special case here.
                    if (isNull(value)) return ctx.stylize('null', 'null');
                }
                function formatError(value) {
                    return '[' + Error.prototype.toString.call(value) + ']';
                }
                function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
                    var output = [];
                    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty1(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
                    else output.push('');
                    keys.forEach(function(key) {
                        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
                    });
                    return output;
                }
                function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
                    var name, str, desc;
                    desc = Object.getOwnPropertyDescriptor(value, key) || {
                        value: value[key]
                    };
                    if (desc.get) {
                        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
                        else str = ctx.stylize('[Getter]', 'special');
                    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
                    if (!hasOwnProperty1(visibleKeys, key)) name = '[' + key + ']';
                    if (!str) {
                        if (ctx.seen.indexOf(desc.value) < 0) {
                            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                            else str = formatValue(ctx, desc.value, recurseTimes - 1);
                            if (str.indexOf('\n') > -1) {
                                if (array) str = str.split('\n').map(function(line) {
                                    return '  ' + line;
                                }).join('\n').substr(2);
                                else str = '\n' + str.split('\n').map(function(line) {
                                    return '   ' + line;
                                }).join('\n');
                            }
                        } else str = ctx.stylize('[Circular]', 'special');
                    }
                    if (isUndefined(name)) {
                        if (array && key.match(/^\d+$/)) return str;
                        name = JSON.stringify('' + key);
                        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                            name = name.substr(1, name.length - 2);
                            name = ctx.stylize(name, 'name');
                        } else {
                            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                            name = ctx.stylize(name, 'string');
                        }
                    }
                    return name + ': ' + str;
                }
                function reduceToSingleString(output, base, braces) {
                    var numLinesEst = 0;
                    var length = output.reduce(function(prev, cur) {
                        numLinesEst++;
                        if (cur.indexOf('\n') >= 0) numLinesEst++;
                        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
                    }, 0);
                    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
                    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
                }
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                function isArray(ar) {
                    return Array.isArray(ar);
                }
                exports.isArray = isArray;
                function isBoolean(arg) {
                    return typeof arg === 'boolean';
                }
                exports.isBoolean = isBoolean;
                function isNull(arg) {
                    return arg === null;
                }
                exports.isNull = isNull;
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNumber(arg) {
                    return typeof arg === 'number';
                }
                exports.isNumber = isNumber;
                function isString(arg) {
                    return typeof arg === 'string';
                }
                exports.isString = isString;
                function isSymbol(arg) {
                    return typeof arg === 'symbol';
                }
                exports.isSymbol = isSymbol;
                function isUndefined(arg) {
                    return arg === void 0;
                }
                exports.isUndefined = isUndefined;
                function isRegExp(re) {
                    return isObject(re) && objectToString(re) === '[object RegExp]';
                }
                exports.isRegExp = isRegExp;
                function isObject(arg) {
                    return typeof arg === 'object' && arg !== null;
                }
                exports.isObject = isObject;
                function isDate(d) {
                    return isObject(d) && objectToString(d) === '[object Date]';
                }
                exports.isDate = isDate;
                function isError(e) {
                    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
                }
                exports.isError = isError;
                function isFunction(arg) {
                    return typeof arg === 'function';
                }
                exports.isFunction = isFunction;
                function isPrimitive(arg) {
                    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
                    typeof arg === 'undefined';
                }
                exports.isPrimitive = isPrimitive;
                exports.isBuffer = __webpack_require__(578);
                function objectToString(o) {
                    return Object.prototype.toString.call(o);
                }
                function pad(n) {
                    return n < 10 ? '0' + n.toString(10) : n.toString(10);
                }
                var months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                // 26 Feb 16:19:34
                function timestamp() {
                    var d = new Date();
                    var time = [
                        pad(d.getHours()),
                        pad(d.getMinutes()),
                        pad(d.getSeconds())
                    ].join(':');
                    return [
                        d.getDate(),
                        months[d.getMonth()],
                        time
                    ].join(' ');
                }
                // log is just a thin wrapper to console.log that prepends a timestamp
                exports.log = function() {
                    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
                };
                /**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = __webpack_require__(579);
                exports._extend = function(origin, add) {
                    // Don't do anything if add isn't an object
                    if (!add || !isObject(add)) return origin;
                    var keys = Object.keys(add);
                    var i = keys.length;
                    while(i--)origin[keys[i]] = add[keys[i]];
                    return origin;
                };
                function hasOwnProperty1(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
                exports.promisify = function promisify(original) {
                    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
                    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                        var fn = original[kCustomPromisifiedSymbol];
                        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                            value: fn,
                            enumerable: false,
                            writable: false,
                            configurable: true
                        });
                        return fn;
                    }
                    function fn() {
                        var promiseResolve, promiseReject;
                        var promise = new Promise(function(resolve, reject) {
                            promiseResolve = resolve;
                            promiseReject = reject;
                        });
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        args.push(function(err, value) {
                            if (err) promiseReject(err);
                            else promiseResolve(value);
                        });
                        try {
                            original.apply(this, args);
                        } catch (err) {
                            promiseReject(err);
                        }
                        return promise;
                    }
                    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
                    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                        value: fn,
                        enumerable: false,
                        writable: false,
                        configurable: true
                    });
                    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
                };
                exports.promisify.custom = kCustomPromisifiedSymbol;
                function callbackifyOnRejected(reason, cb) {
                    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
                    // Because `null` is a special error value in callbacks which means "no error
                    // occurred", we error-wrap so the callback consumer can distinguish between
                    // "the promise rejected with null" or "the promise fulfilled with undefined".
                    if (!reason) {
                        var newReason = new Error('Promise was rejected with a falsy value');
                        newReason.reason = reason;
                        reason = newReason;
                    }
                    return cb(reason);
                }
                function callbackify(original) {
                    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
                    // We DO NOT return the promise as it gives the user a false sense that
                    // the promise is actually somehow related to the callback's execution
                    // and that the callback throwing will reject the promise.
                    function callbackified() {
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        var maybeCb = args.pop();
                        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
                        var self1 = this;
                        var cb = function() {
                            return maybeCb.apply(self1, arguments);
                        };
                        // In true node style we process the callback on `nextTick` with all the
                        // implications (stack, `uncaughtException`, `async_hooks`)
                        original.apply(this, args).then(function(ret) {
                            process.nextTick(cb, null, ret);
                        }, function(rej) {
                            process.nextTick(callbackifyOnRejected, rej, cb);
                        });
                    }
                    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
                    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
                    return callbackified;
                }
                exports.callbackify = callbackify;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(43), __webpack_require__(0));
        /***/ },
        /* 578 */ /***/ function(module1, exports) {
            module1.exports = function isBuffer(arg) {
                return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
            };
        /***/ },
        /* 579 */ /***/ function(module1, exports) {
            if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
            module1.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                    constructor: {
                        value: ctor,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
            };
            else // old school shim for old browsers
            module1.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
            };
        /***/ },
        /* 580 */ /***/ function(module1, exports, __webpack_require__) {
            var castSlice = __webpack_require__(581), hasUnicode = __webpack_require__(262), stringToArray = __webpack_require__(263), toString = __webpack_require__(61);
            /**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            module1.exports = createCaseFirst;
        /***/ },
        /* 581 */ /***/ function(module1, exports, __webpack_require__) {
            var baseSlice = __webpack_require__(261);
            /**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            module1.exports = castSlice;
        /***/ },
        /* 582 */ /***/ function(module1, exports) {
            /**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
                return string.split('');
            }
            module1.exports = asciiToArray;
        /***/ },
        /* 583 */ /***/ function(module1, exports) {
            /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
            /** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
            /** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
                rsNonAstral,
                rsRegional,
                rsSurrPair
            ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
                rsNonAstral + rsCombo + '?',
                rsCombo,
                rsRegional,
                rsSurrPair,
                rsAstral
            ].join('|') + ')';
            /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
            /**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
                return string.match(reUnicode) || [];
            }
            module1.exports = unicodeToArray;
        /***/ },
        /* 584 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = [
                'screen',
                'window',
                'tab',
                'browser',
                'application'
            ];
        /***/ },
        /* 585 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const log = __webpack_require__(2);
            const StaticConfig = __webpack_require__(35)();
            const once = __webpack_require__(51);
            const logLevels = __webpack_require__(119);
            const some = __webpack_require__(587);
            const map = __webpack_require__(590);
            const PATH_TO_RELEASE_NOTES = '/opentok/webrtc/docs/js/release-notes.html';
            const staticConfig = StaticConfig.onlyLocal();
            const logging = log('setLogLevel');
            const BANNER_HEADER = `
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}\u{255A}\u{2550}\u{2550}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551} \u{2588}\u{2588}\u{2554}\u{255D}
\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2588}\u{2588}\u{2557}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551} \u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}   \u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2557}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{2550}\u{2550}\u{255D}   \u{255A}\u{2550}\u{255D}    \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{255D}`;
            const printHeader = once(()=>{
                logging.info(`%c${BANNER_HEADER}`, 'font-family: "Fire Code", Courier, "Courier New", Consolas, "DejaVu Sans Mono"');
                logging.info(`OpenTok JS SDK ${staticConfig.version}`);
                logging.info(`Release notes: ${staticConfig.websiteUrl}${PATH_TO_RELEASE_NOTES}`);
                logging.info(`Known issues: ${staticConfig.websiteUrl}${PATH_TO_RELEASE_NOTES}l#knownIssues`);
            });
            function setLogLevel(level) {
                if (level === undefined || !some(logLevels, {
                    priority: level
                }) && level !== 0) {
                    const validLevelDescription = map(logLevels, (x, key)=>`OT.${key.toUpperCase()} = ${x.priority}`).join(', ');
                    logging.error(`level must be one of: OT.NONE = 0, ${validLevelDescription}`);
                    logging.warn('Using OT.WARN instead');
                    level = logLevels.warn.priority; // eslint-disable-line no-param-reassign
                }
                log.setLogLevel(level);
                if (level >= logLevels.debug.priority) printHeader();
                const link = 'https://www.npmjs.com/package/debug#browser-support';
                logging.info(`OpenTok JS SDK now uses the debug library. More info at ${link}`);
                logging.info(`Changed log level to: ${level}`);
                return level;
            } // set default level
            setLogLevel(staticConfig.debug ? logLevels.debug.priority : logLevels.warn.priority);
            module1.exports = setLogLevel;
        /**
  * Sets the API log level.
  * <p>
  * Calling <code>OT.setLogLevel()</code> sets the log level for runtime log messages that
  * are the OpenTok library generates. The default value for the log level is
  * <code>OT.ERROR</code>.
  * </p>
  * <p>
  * The OpenTok JavaScript library displays log messages in the debugger console (such as
  * Firebug), if one exists.
  * </p>
  * <p>
  * The following example logs the session ID to the console, by calling <code>OT.log()</code>.
  * The code also logs an error message when it attempts to publish a stream before you have
  * connected to the session (by calling <code>Session.connect()</code>).
  * </p>
  * <pre>
  * OT.setLogLevel(OT.LOG);
  * session = OT.initSession(sessionId);
  * OT.log(sessionId);
  * publisher = OT.initPublisher("publishContainer");
  * session.publish(publisher);
  * </pre>
  *
  * @param {Number} logLevel The degree of logging desired by the developer:
  *
  * <p>
  * <ul>
  *   <li>
  *     <code>OT.NONE</code> &#151; API logging is disabled.
  *   </li>
  *   <li>
  *     <code>OT.ERROR</code> &#151; Logging of errors only.
  *   </li>
  *   <li>
  *     <code>OT.WARN</code> &#151; Logging of warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.INFO</code> &#151; Logging of other useful information, in addition to
  *     warnings and errors.
  *   </li>
  *   <li>
  *     <code>OT.LOG</code> &#151; Logging of <code>OT.log()</code> messages, in addition
  *     to OpenTok info, warning,
  *     and error messages.
  *   </li>
  *   <li>
  *     <code>OT.DEBUG</code> &#151; Fine-grained logging of all API actions, as well as
  *     <code>OT.log()</code> messages.
  *   </li>
  * </ul>
  * </p>
  *
  * @name OT.setLogLevel
  * @memberof OT
  * @function
  * @see <a href="#log">OT.log()</a>
  */ /**
  * Sends a string to the debugger console. However, the function only logs to the console
  * if you have set the log level to <code>OT.LOG</code> or <code>OT.DEBUG</code>,
  * by calling <code>OT.setLogLevel(OT.LOG)</code> or <code>OT.setLogLevel(OT.DEBUG)</code>.
  *
  * @param {String} message The string to log.
  *
  * @name OT.log
  * @memberof OT
  * @function
  * @see <a href="#setLogLevel">OT.setLogLevel()</a>
  */ /***/ },
        /* 586 */ /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__(97);
            /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
            /**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function before(n, func) {
                var result;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n > 0) result = func.apply(this, arguments);
                    if (n <= 1) func = undefined;
                    return result;
                };
            }
            module1.exports = before;
        /***/ },
        /* 587 */ /***/ function(module1, exports, __webpack_require__) {
            var arraySome = __webpack_require__(232), baseIteratee = __webpack_require__(36), baseSome = __webpack_require__(588), isArray = __webpack_require__(12), isIterateeCall = __webpack_require__(122);
            /**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, baseIteratee(predicate, 3));
            }
            module1.exports = some;
        /***/ },
        /* 588 */ /***/ function(module1, exports, __webpack_require__) {
            var baseEach = __webpack_require__(266);
            /**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function(value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                });
                return !!result;
            }
            module1.exports = baseSome;
        /***/ },
        /* 589 */ /***/ function(module1, exports, __webpack_require__) {
            var isArrayLike = __webpack_require__(25);
            /**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
                return function(collection, iteratee) {
                    if (collection == null) return collection;
                    if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                    var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
                    while(fromRight ? index-- : ++index < length){
                        if (iteratee(iterable[index], index, iterable) === false) break;
                    }
                    return collection;
                };
            }
            module1.exports = createBaseEach;
        /***/ },
        /* 590 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayMap = __webpack_require__(34), baseIteratee = __webpack_require__(36), baseMap = __webpack_require__(591), isArray = __webpack_require__(12);
            /**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, baseIteratee(iteratee, 3));
            }
            module1.exports = map;
        /***/ },
        /* 591 */ /***/ function(module1, exports, __webpack_require__) {
            var baseEach = __webpack_require__(266), isArrayLike = __webpack_require__(25);
            /**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
                var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
                baseEach(collection, function(value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                });
                return result;
            }
            module1.exports = baseMap;
        /***/ },
        /* 592 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // When setting the background image uri of a publisher or subscriber, we allow the use of a raw
            // data blob of a png, which requires the prefix 'data:image/png;base64,'. This function
            // encapsulates that transformation.
            module1.exports = function fixBackgroundImageURI(bgImgURI) {
                if (bgImgURI.substr(0, 5) !== 'http:' && bgImgURI.substr(0, 6) !== 'https:' && bgImgURI.substr(0, 22) !== 'data:image/png;base64,') return `data:image/png;base64,${bgImgURI}`;
                return bgImgURI;
            };
        /***/ },
        /* 593 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, prefer-const */ const cloneDeep = __webpack_require__(58);
            const logging = __webpack_require__(2)('Style');
            module1.exports = function Style(initalStyles, onStyleChange) {
                const styleApi = this;
                const _styles = {}; // Styles with null here means every value is valid for that style
                const _validStyleValues = {
                    buttonDisplayMode: [
                        'auto',
                        'mini',
                        'mini-auto',
                        'off',
                        'on'
                    ],
                    nameDisplayMode: [
                        'auto',
                        'off',
                        'on'
                    ],
                    audioLevelDisplayMode: [
                        'auto',
                        'off',
                        'on'
                    ],
                    showSettingsButton: [
                        true,
                        false
                    ],
                    showSpeakerButton: null,
                    showMicButton: [
                        true,
                        false
                    ],
                    backgroundImageURI: null,
                    showControlBar: [
                        true,
                        false
                    ],
                    // 'showArchiveStatus' is kept for backwards compatibility.
                    // 'archiveStatusDisplayMode' is the documented style name.
                    showArchiveStatus: [
                        true,
                        false
                    ],
                    archiveStatusDisplayMode: [
                        'auto',
                        'off',
                        'on'
                    ],
                    videoDisabledDisplayMode: [
                        'auto',
                        'off',
                        'on'
                    ],
                    audioBlockedDisplayMode: [
                        'auto',
                        'off',
                        'on'
                    ]
                }; // Validates the style +key+ and also whether +value+ is valid for +key+
                const isValidStyle = function isValidStyle(key, value) {
                    const valueSpec = _validStyleValues[key];
                    if (valueSpec === undefined) return false;
                    if (valueSpec === null) return true;
                    return valueSpec.indexOf(value) !== -1;
                };
                const castValue = function castValue(value) {
                    switch(value){
                        case 'true':
                            return true;
                        case 'false':
                            return false;
                        default:
                            return value;
                    }
                }; // Returns a copy of the styles.
                styleApi.getAll = function() {
                    return cloneDeep(_styles);
                };
                styleApi.get = function(key) {
                    if (key) return _styles[key];
                     // We haven't been asked for any specific key, just return the lot
                    return styleApi.getAll();
                }; // *note:* this will not trigger onStyleChange if +silent+ is truthy
                styleApi.setAll = function(newStyles, silent) {
                    Object.keys(newStyles).forEach((key)=>{
                        styleApi.set(key, newStyles[key], silent);
                    });
                    return styleApi;
                }; // *note:* this will not trigger onStyleChange if +silent+ is truthy
                styleApi.set = function(key, value, silent) {
                    logging.debug(`setStyle: ${key.toString()}`);
                    let oldValue;
                    const newValue = castValue(value);
                    if (!isValidStyle(key, newValue)) {
                        logging.warn(`Style.set::Invalid style property passed ${key} : ${newValue}`);
                        return styleApi;
                    }
                    oldValue = _styles[key];
                    if (newValue !== oldValue) {
                        _styles[key] = newValue;
                        if (!silent) onStyleChange(key, value, oldValue);
                    }
                    return styleApi;
                };
                if (initalStyles) styleApi.setAll(initalStyles, true);
            };
        /***/ },
        /* 594 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const isSecureContextRequired = __webpack_require__(270);
            const hasGetUserMediaSupport = ()=>{
                // Except for Safari, iOS WebKit apps don't support GUM
                if (env.isIosWebView) return false;
                if (isSecureContextRequired()) return true;
                return window.navigator.mediaDevices && window.navigator.mediaDevices.getUserMedia || window.navigator.webkitGetUserMedia || window.navigator.mozGetUserMedia;
            }; // Indicates whether this client supports the getUserMedia API.
            module1.exports = ()=>Boolean(env.name !== 'Node' && hasGetUserMediaSupport());
        /***/ },
        /* 595 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3); // TODO Remove all PeerConnection stuff, that belongs to the messaging layer not the Media layer.
            // Indicates whether this client supports the PeerConnection
            // API.
            //
            // Chrome Issues:
            // * The explicit prototype.addStream check is because webkitRTCPeerConnection was
            // partially implemented, but not functional, in Chrome 22.
            //
            // Firefox Issues:
            // * No real support before Firefox 19
            // * Firefox 19 has issues with generating Offers.
            // * Firefox 20 doesn't interoperate with Chrome.
            //
            module1.exports = ()=>{
                if (env.name === 'Node') return false;
                else if (typeof window.webkitRTCPeerConnection === 'function' && !!window.webkitRTCPeerConnection.prototype.addTrack) return true;
                else if (typeof window.RTCPeerConnection === 'function') return true;
                else if (typeof window.mozRTCPeerConnection === 'function' && env.version > 20.0) return true;
                return false;
            };
        /***/ },
        /* 596 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Indicates if the client supports WebSockets.
            module1.exports = window.WebSocket !== undefined;
        /***/ },
        /* 597 */ /***/ function(module1, exports) {
            module1.exports = "<div id=\"tb_alert\"><div id=\"section-normal-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires <a target=\"_blank\" href=\"https://www.google.com/chrome/\">Google Chrome</a>, <a target=\"_blank\" href=\"http://www.mozilla.org/firefox\">Firefox</a>, <a target=\"_blank\" href=\"https://www.microsoft.com/en-us/edge\">Edge</a>, or <a target=\"_blank\" href=\"https://www.apple.com/safari/\">Safari</a>.</div></div><div id=\"section-upgrade-install\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires a newer version of <a target=\"_blank\" href=\"https://www.google.com/chrome/\">Google Chrome</a>, <a target=\"_blank\" href=\"http://www.mozilla.org/firefox\">Firefox</a>, <a target=\"_blank\" href=\"https://www.microsoft.com/en-us/edge\">Edge</a>, or <a target=\"_blank\" href=\"https://www.apple.com/safari/\">Safari</a>.</div><div class=\"continue-text\"><a href=\"#\" role=\"OT_close\">Continue at my own risk.</a></div></div><div id=\"section-supported-mobile-browser\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application requires a newer version of <a target=\"_blank\" href=\"https://www.google.com.au/chrome/browser/mobile/\">Google Chrome</a>.</div><div class=\"continue-text\"><a href=\"#\" role=\"OT_close\">Continue at my own risk.</a></div></div><div id=\"section-mobile-browser\" class=\"OT_alert\"><div class=\"OT_alert-exclamation\">!</div><button class=\"OT_alert-close-button\" role=\"OT_close\">&#x00D7;</button><div class=\"OT_alert-header\" data-text=\"Incompatible Browser\">Incompatible Browser</div><div class=\"OT_alert-body\">The video component of this application is not supported on your mobile device's browser at this time.</div></div></div>";
        /***/ },
        /* 598 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            const Events = __webpack_require__(31);
            module1.exports = /*#__PURE__*/ function(_Events) {
                (0, _inheritsLoose2.default)(Modal, _Events);
                function Modal(innerHTML, _temp) {
                    var _this;
                    let _ref = _temp === void 0 ? {} : _temp, _ref$destroyOnClose = _ref.destroyOnClose, destroyOnClose = _ref$destroyOnClose === void 0 ? true : _ref$destroyOnClose;
                    _this = _Events.call(this) || this;
                    _this.modalDiv = document.createElement('div');
                    _this.modalDiv.classList.add('OT_ModalDialog');
                    _this.modalDiv.innerHTML = innerHTML;
                    const closeBtnEls = _this.modalDiv.querySelectorAll('[role=OT_close]');
                    [].forEach.call(closeBtnEls, (closeBtnEl)=>closeBtnEl.addEventListener('click', (event)=>{
                            event.preventDefault();
                            _this.close();
                        }));
                    _this.close();
                    document.body.appendChild(_this.modalDiv);
                    if (destroyOnClose) _this.on('closed', ()=>_this.destroy());
                    return _this;
                }
                var _proto = Modal.prototype;
                _proto.open = function open() {
                    this.modalDiv.style.display = 'block';
                    this.emit('opened');
                };
                _proto.close = function close() {
                    this.modalDiv.style.display = 'none';
                    this.emit('closed');
                };
                _proto.destroy = function destroy() {
                    this.modalDiv.innerHTML = '';
                    this.modalDiv.parentNode.removeChild(this.modalDiv);
                    this.emit('destroyed');
                };
                _proto.el = function el(query) {
                    return this.modalDiv.querySelector(query);
                };
                return Modal;
            }(Events);
        /***/ },
        /* 599 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ const AnalyticsHelper = __webpack_require__(26);
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const env = deps.env || __webpack_require__(3);
                const analytics = deps.analytics || new AnalyticsHelper();
                analytics.logEvent({
                    action: 'UserAgentParsing',
                    variation: 'Attempt',
                    payload: {
                        userAgent: env.userAgent
                    }
                });
                analytics.logEvent({
                    action: 'UserAgentParsing',
                    variation: env.error ? 'Failure' : 'Success',
                    payload: {
                        userAgent: env.userAgent
                    }
                });
            };
        /***/ },
        /* 600 */ /***/ function(module1, exports, __webpack_require__) {
            var getPrototypeOf = __webpack_require__(601);
            var setPrototypeOf = __webpack_require__(271);
            var isNativeFunction = __webpack_require__(602);
            var construct = __webpack_require__(603);
            function _wrapNativeSuper(Class) {
                var _cache = typeof Map === "function" ? new Map() : undefined;
                module1.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
                    if (Class === null || !isNativeFunction(Class)) return Class;
                    if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                    if (typeof _cache !== "undefined") {
                        if (_cache.has(Class)) return _cache.get(Class);
                        _cache.set(Class, Wrapper);
                    }
                    function Wrapper() {
                        return construct(Class, arguments, getPrototypeOf(this).constructor);
                    }
                    Wrapper.prototype = Object.create(Class.prototype, {
                        constructor: {
                            value: Wrapper,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    return setPrototypeOf(Wrapper, Class);
                };
                return _wrapNativeSuper(Class);
            }
            module1.exports = _wrapNativeSuper;
        /***/ },
        /* 601 */ /***/ function(module1, exports) {
            function _getPrototypeOf(o) {
                module1.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            module1.exports = _getPrototypeOf;
        /***/ },
        /* 602 */ /***/ function(module1, exports) {
            function _isNativeFunction(fn) {
                return Function.toString.call(fn).indexOf("[native code]") !== -1;
            }
            module1.exports = _isNativeFunction;
        /***/ },
        /* 603 */ /***/ function(module1, exports, __webpack_require__) {
            var setPrototypeOf = __webpack_require__(271);
            function isNativeReflectConstruct() {
                if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                if (Reflect.construct.sham) return false;
                if (typeof Proxy === "function") return true;
                try {
                    Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                    return true;
                } catch (e) {
                    return false;
                }
            }
            function _construct(Parent, args, Class) {
                if (isNativeReflectConstruct()) module1.exports = _construct = Reflect.construct;
                else module1.exports = _construct = function _construct(Parent, args, Class) {
                    var a = [
                        null
                    ];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor();
                    if (Class) setPrototypeOf(instance, Class.prototype);
                    return instance;
                };
                return _construct.apply(null, arguments);
            }
            module1.exports = _construct;
        /***/ },
        /* 604 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                module1.exports = (promise, onFinally)=>{
                    onFinally = onFinally || (()=>{});
                    return promise.then((val)=>new Promise((resolve)=>{
                            resolve(onFinally());
                        }).then(()=>val), (err)=>new Promise((resolve)=>{
                            resolve(onFinally());
                        }).then(()=>{
                            throw err;
                        }));
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 605 */ /***/ function(module1, exports, __webpack_require__) {
            var castPath = __webpack_require__(60), last = __webpack_require__(606), parent = __webpack_require__(607), toKey = __webpack_require__(47);
            /**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
            }
            module1.exports = baseUnset;
        /***/ },
        /* 606 */ /***/ function(module1, exports) {
            /**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
            }
            module1.exports = last;
        /***/ },
        /* 607 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGet = __webpack_require__(99), baseSlice = __webpack_require__(261);
            /**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            module1.exports = parent;
        /***/ },
        /* 608 */ /***/ function(module1, exports, __webpack_require__) {
            var isPlainObject = __webpack_require__(135);
            /**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
            }
            module1.exports = customOmitClone;
        /***/ },
        /* 609 */ /***/ function(module1, exports, __webpack_require__) {
            var baseIteratee = __webpack_require__(36), isArrayLike = __webpack_require__(25), keys = __webpack_require__(30);
            /**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
                return function(collection, predicate, fromIndex) {
                    var iterable = Object(collection);
                    if (!isArrayLike(collection)) {
                        var iteratee = baseIteratee(predicate, 3);
                        collection = keys(collection);
                        predicate = function(key) {
                            return iteratee(iterable[key], key, iterable);
                        };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
            }
            module1.exports = createFind;
        /***/ },
        /* 610 */ /***/ function(module1, exports, __webpack_require__) {
            var SetCache = __webpack_require__(93), arrayIncludes = __webpack_require__(94), arrayIncludesWith = __webpack_require__(128), cacheHas = __webpack_require__(95), createSet = __webpack_require__(611), setToArray = __webpack_require__(98);
            /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
            /**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
                if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) return setToArray(set);
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache;
                } else seen = iteratee ? [] : result;
                outer: while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var seenIndex = seen.length;
                        while(seenIndex--){
                            if (seen[seenIndex] === computed) continue outer;
                        }
                        if (iteratee) seen.push(computed);
                        result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                        if (seen !== result) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            module1.exports = baseUniq;
        /***/ },
        /* 611 */ /***/ function(module1, exports, __webpack_require__) {
            var Set1 = __webpack_require__(186), noop = __webpack_require__(224), setToArray = __webpack_require__(98);
            /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
            /**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set1 && 1 / setToArray(new Set1([
                ,
                -0
            ]))[1] == INFINITY) ? noop : function(values) {
                return new Set1(values);
            };
            module1.exports = createSet;
        /***/ },
        /* 612 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const extractNumbers = (text)=>text ? text.replace(/\D+/g, '') || '0' : '0';
            const truncate = (text)=>text.substring(0, 9);
            const parseToInt = (text)=>parseInt(text, 10); // This function extracts the senderId, which consists in max 9 numbers.
            // Currently, the input is the connection ID.
            // For example, "5a12917d-395b-483a-bbd7-a91dfa4c2a53" -> "512917395".
            module1.exports = (text)=>parseToInt(truncate(extractNumbers(text)));
        /***/ },
        /* 613 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                var _regenerator = _interopRequireDefault(__webpack_require__(4));
                var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
                const createLogger = __webpack_require__(2);
                const logger = createLogger('hasValidPeerConnection');
                function checkPeerConnection(pc) {
                    return new Promise((resolve)=>{
                        pc.addEventListener('signalingstatechange', ()=>resolve(true));
                        pc.createOffer({
                            offerToReceiveAudio: 1
                        }).then((offer)=>pc.setLocalDescription(offer)).then(()=>setTimeout(()=>{
                                resolve(false);
                            }, 1000));
                    });
                }
                function hasValidPeerConnection(_x) {
                    return _hasValidPeerConnection.apply(this, arguments);
                }
                function _hasValidPeerConnection() {
                    _hasValidPeerConnection = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(PeerConnection) {
                        var pc;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.prev = 0;
                                    pc = new PeerConnection({
                                        iceServers: []
                                    });
                                    _context.next = 8;
                                    break;
                                case 4:
                                    _context.prev = 4;
                                    _context.t0 = _context["catch"](0);
                                    logger.error('Error occurred creating PeerConnection', _context.t0);
                                    return _context.abrupt("return", false);
                                case 8:
                                    _context.prev = 8;
                                    _context.next = 11;
                                    return checkPeerConnection(pc);
                                case 11:
                                    _context.next = 18;
                                    break;
                                case 13:
                                    _context.prev = 13;
                                    _context.t1 = _context["catch"](8);
                                    logger.error('Error occurred checking the validity of the PeerConnection', _context.t1);
                                    try {
                                        pc.close();
                                    } catch (e) {}
                                    return _context.abrupt("return", false);
                                case 18:
                                    _context.prev = 18;
                                    pc.close();
                                    _context.next = 26;
                                    break;
                                case 22:
                                    _context.prev = 22;
                                    _context.t2 = _context["catch"](18);
                                    logger.error('Error occurred closing PeerConnection', _context.t2);
                                    return _context.abrupt("return", false);
                                case 26:
                                    return _context.abrupt("return", true);
                                case 27:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                4
                            ],
                            [
                                8,
                                13
                            ],
                            [
                                18,
                                22
                            ]
                        ]);
                    }));
                    return _hasValidPeerConnection.apply(this, arguments);
                }
                module1.exports = hasValidPeerConnection;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 614 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const clone = __webpack_require__(38);
                const env = __webpack_require__(3);
                const filterIceServers = __webpack_require__(615);
                const shouldUsePlanBSDP = __webpack_require__(74);
                const logging = __webpack_require__(2)('createPeerConnection');
                module1.exports = function createPeerConnection(_ref) {
                    let window1 = _ref.window, originalConfig = _ref.config, constraints = _ref.constraints;
                    logging.debug('called');
                    const config = clone(originalConfig);
                    config.iceServers = filterIceServers(env, config.iceServers);
                    if (shouldUsePlanBSDP()) config.sdpSemantics = 'plan-b';
                    const pc = new window1.RTCPeerConnection(config, constraints);
                    return Promise.resolve(pc);
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 615 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const assign = __webpack_require__(9);
            const omit = __webpack_require__(272);
            const filters = {
                Edge (iceServers) {
                    let foundTurn = false;
                    return iceServers.map((server)=>{
                        if (!server) return undefined;
                        const urls = server.urls || server.url && [
                            server.url
                        ];
                        if (!urls) return undefined;
                        const filteredUrls = urls.filter((url)=>{
                            const turnOk = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !foundTurn;
                            if (turnOk) {
                                foundTurn = true;
                                return true;
                            }
                            return url.indexOf('stun:') === 0;
                        });
                        if (filteredUrls.length === 0) return undefined;
                        return assign(omit(server, [
                            'url',
                            'urls'
                        ]), {
                            urls: filteredUrls
                        });
                    }).filter((server)=>server !== undefined);
                },
                Safari (iceServers) {
                    return iceServers.map((server)=>{
                        if (server.urls !== undefined && server.url === undefined) return server;
                        const urls = server.urls || server.url && [
                            server.url
                        ];
                        return assign(omit(server, [
                            'url',
                            'urls'
                        ]), {
                            urls: urls
                        });
                    });
                }
            };
            module1.exports = function filterIceServers(env, iceServers) {
                let browserName = env.name;
                if (env.isEdge) browserName = env.isLegacyEdge ? 'Edge' : 'ChromiumEdge';
                const filter = filters[browserName];
                if (filter) return filter(iceServers);
                return iceServers;
            };
        /***/ },
        /* 616 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const SDPHelpers = __webpack_require__(53);
            const env = __webpack_require__(3);
            const profiles = {
                h264: {
                    baseline: '42001f',
                    constBaseline: '42e01f'
                }
            };
            const replaceProfileId = (_ref)=>{
                let sdp = _ref.sdp, from = _ref.from, to = _ref.to;
                return sdp.replace(new RegExp(`^(a=fmtp:\\d+ .*profile-level-id=)${from}`, 'gmi'), `$1${to}`);
            };
            module1.exports = {
                local: {
                    offer: function offer(_temp, sdpParam) {
                        let _ref2 = _temp === void 0 ? {} : _temp, numSimulcastStreams = _ref2.numSimulcastStreams, audioBitrate = _ref2.audioBitrate, _ref2$priorityVideoCo = _ref2.priorityVideoCodec, priorityVideoCodec = _ref2$priorityVideoCo === void 0 ? '' : _ref2$priorityVideoCo, _ref2$codecFlags = _ref2.codecFlags, codecFlags = _ref2$codecFlags === void 0 ? {} : _ref2$codecFlags, _ref2$enableStereo = _ref2.enableStereo, enableStereo = _ref2$enableStereo === void 0 ? false : _ref2$enableStereo, _ref2$enableDtx = _ref2.enableDtx, enableDtx = _ref2$enableDtx === void 0 ? false : _ref2$enableDtx, _ref2$replaceBaseline = _ref2.replaceBaselineProfile, replaceBaselineProfile = _ref2$replaceBaseline === void 0 ? false : _ref2$replaceBaseline, _ref2$removeVideoOrie = _ref2.removeVideoOrientation, removeVideoOrientation = _ref2$removeVideoOrie === void 0 ? false : _ref2$removeVideoOrie;
                        // The SDP may have excessive or stray SSRCs.  For example, SSRCs not
                        // associated with a SIM group.  We remove these before we munge, else
                        // the offer may grow too large.
                        // See OPENTOK-41253
                        let sdp = SDPHelpers.filterExcessSSRCs(sdpParam);
                        if (numSimulcastStreams > 1) sdp = SDPHelpers.enableSimulcast(sdp, numSimulcastStreams);
                        if (audioBitrate > 0) sdp = SDPHelpers.setAudioBitrate(sdp, audioBitrate);
                        if (removeVideoOrientation) sdp = SDPHelpers.removeVideoOrientation(sdp);
                        sdp = SDPHelpers.modifyReceiveStereo(sdp, false);
                        sdp = SDPHelpers.modifySendStereo(sdp, Boolean(enableStereo));
                        sdp = SDPHelpers.modifyDtx(sdp, Boolean(enableDtx));
                        if (!env.isLegacyEdge) Object.keys(codecFlags).filter((codec)=>codecFlags[codec] === false).forEach((codec)=>{
                            sdp = SDPHelpers.removeVideoCodec(sdp, codec);
                        });
                        if (priorityVideoCodec && !env.isLegacyEdge) sdp = SDPHelpers.reprioritizeVideoCodec(sdp, priorityVideoCodec, 'top');
                        else if (priorityVideoCodec !== 'h264') sdp = SDPHelpers.reprioritizeVideoCodec(sdp, 'h264', 'bottom');
                        let remoteSdp = sdp;
                        if (replaceBaselineProfile) remoteSdp = replaceProfileId({
                            sdp: remoteSdp,
                            from: profiles.h264.baseline,
                            to: profiles.h264.constBaseline
                        });
                        return {
                            local: sdp,
                            remote: remoteSdp
                        };
                    },
                    answer: function answer(_temp2, sdpParam) {
                        let _ref3 = _temp2 === void 0 ? {} : _temp2, audioBitrate = _ref3.audioBitrate, codecFlags = _ref3.codecFlags, _ref3$enableStereo = _ref3.enableStereo, enableStereo = _ref3$enableStereo === void 0 ? false : _ref3$enableStereo, _ref3$enableDtx = _ref3.enableDtx, enableDtx = _ref3$enableDtx === void 0 ? false : _ref3$enableDtx, _ref3$replaceBaseline = _ref3.replaceBaselineProfile, replaceBaselineProfile = _ref3$replaceBaseline === void 0 ? false : _ref3$replaceBaseline, sourceStreamId = _ref3.sourceStreamId;
                        let sdp = sdpParam;
                        if (audioBitrate > 0) sdp = SDPHelpers.setAudioBitrate(sdp, audioBitrate);
                        sdp = SDPHelpers.modifyReceiveStereo(sdp, Boolean(enableStereo));
                        sdp = SDPHelpers.modifySendStereo(sdp, false);
                        sdp = SDPHelpers.modifyDtx(sdp, Boolean(enableDtx));
                        if (sourceStreamId === 'MANTIS' && SDPHelpers.getSetupRole(sdp) === 'passive') sdp = SDPHelpers.setSetupRole(sdp, 'active');
                        if (codecFlags) Object.keys(codecFlags).filter((codec)=>codecFlags[codec] === false).forEach((codec)=>{
                            sdp = SDPHelpers.removeVideoCodec(sdp, codec);
                        });
                        let remoteSdp = sdp;
                        if (replaceBaselineProfile) remoteSdp = replaceProfileId({
                            sdp: remoteSdp,
                            from: profiles.h264.baseline,
                            to: profiles.h264.constBaseline
                        });
                        return {
                            local: sdp,
                            remote: remoteSdp
                        };
                    }
                },
                remote: {
                    offer: (_ref4, sdpParam)=>{
                        let _ref4$replaceBaseline = _ref4.replaceBaselineProfile, replaceBaselineProfile = _ref4$replaceBaseline === void 0 ? false : _ref4$replaceBaseline;
                        let sdp = sdpParam;
                        if (sdp.indexOf('a=rtcp-fb') === -1) {
                            const rtcpFbLine = 'a=rtcp-fb:* ccm fir\r\na=rtcp-fb:* nack ';
                            sdp = sdp.replace(/^m=video(.*)$/gmi, `m=video$1\r\n${rtcpFbLine}`);
                        }
                        if (replaceBaselineProfile) sdp = replaceProfileId({
                            sdp: sdp,
                            from: profiles.h264.constBaseline,
                            to: profiles.h264.baseline
                        });
                        return {
                            local: sdp
                        };
                    },
                    answer: function answer(_temp3, sdpParam) {
                        let _ref5 = _temp3 === void 0 ? {} : _temp3, audioBitrate = _ref5.audioBitrate, _ref5$replaceBaseline = _ref5.replaceBaselineProfile, replaceBaselineProfile = _ref5$replaceBaseline === void 0 ? false : _ref5$replaceBaseline;
                        let sdp = sdpParam;
                        if (audioBitrate > 0) sdp = SDPHelpers.setAudioBitrate(sdp, audioBitrate);
                        if (replaceBaselineProfile) sdp = replaceProfileId({
                            sdp: sdp,
                            from: profiles.h264.constBaseline,
                            to: profiles.h264.baseline
                        });
                        return {
                            local: sdp
                        };
                    }
                }
            };
        /***/ },
        /* 617 */ /***/ function(module1, exports, __webpack_require__) {
            var Symbol1 = __webpack_require__(40), copyArray = __webpack_require__(56), getTag = __webpack_require__(42), isArrayLike = __webpack_require__(25), isString = __webpack_require__(276), iteratorToArray = __webpack_require__(618), mapToArray = __webpack_require__(233), setToArray = __webpack_require__(98), stringToArray = __webpack_require__(263), values = __webpack_require__(277);
            /** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
            /** Built-in value references. */ var symIterator = Symbol1 ? Symbol1.iterator : undefined;
            /**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function toArray(value) {
                if (!value) return [];
                if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
                if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
                var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
            }
            module1.exports = toArray;
        /***/ },
        /* 618 */ /***/ function(module1, exports) {
            /**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function iteratorToArray(iterator) {
                var data, result = [];
                while(!(data = iterator.next()).done)result.push(data.value);
                return result;
            }
            module1.exports = iteratorToArray;
        /***/ },
        /* 619 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayMap = __webpack_require__(34);
            /**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
                return arrayMap(props, function(key) {
                    return object[key];
                });
            }
            module1.exports = baseValues;
        /***/ },
        /* 620 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (peerConnection, completion)=>{
                let stats = [];
                let error = null;
                if (typeof peerConnection.getReceivers === 'function') {
                    const audioTrack = peerConnection.getReceivers().find((r)=>r.track.kind === 'audio');
                    if (audioTrack) stats = audioTrack.getSynchronizationSources();
                } else error = new Error('peerConnection does not support getReceivers function');
                if (completion) completion(error, stats);
            };
        /***/ },
        /* 621 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-underscore-dangle */ const promisify = __webpack_require__(622);
                /*
 * Process incoming Ice Candidates from a remote connection.
 *
 * @constructor
 * @private
 *
 * @param {PeerConection} peerConnection The PeerConnection we want to add the
 * Ice Candidates to.
 *
 * @description The Ice Candidates cannot be processed until the PeerConnection
 * has local and remote descriptions, if candidates are added too early they
 * will be put in a pending list. Once the PeerConnection is ready the pending
 * candidates will be applied.
 *
 * **note:** We assume that the PeerConnection has implemented the promisified
 * versions of addIceCandidate.
 *
 *
 * @example
 *
 *  const iceProcessor = new IceCandidateProcessor(pc);
 *  iceProcessor.process(iceMessage1);
 *  iceProcessor.process(iceMessage2);
 *  iceProcessor.process(iceMessage3);
 *
 *
 */ const IceCandidateProcessor = function IceCandidateProcessor(peerConnection) {
                    this.pending = [];
                    this._processBinding = this.maybeProcessPending.bind(this);
                    if (peerConnection) this.setPeerConnection(peerConnection);
                };
                IceCandidateProcessor.prototype.setPeerConnection = function setPeerConnection(peerConnection) {
                    if (this.pc) throw new Error('Peer connection already set');
                    this.pc = peerConnection;
                    this._forwardIceCandidate = promisify(this.pc, 'addIceCandidate');
                    this.pc.addEventListener('signalingstatechange', this._processBinding);
                    this.maybeProcessPending();
                };
                /**
 * Returns true if the PeerConnection is ready to accept IceCandidates.
 *
 * @return {Boolean} True if IceCandidates can be applied, false otherwise
 *
 * @method #canAddCandidates
 * @memberof IceCandidateProcessor
 *
 */ IceCandidateProcessor.prototype.canAddCandidates = function canAddCandidates() {
                    // localDescription and removeDescription are nullable, so you would expect
                    // that they would be null when those descriptions have not yet been applied
                    // Chrome (as of 48) seems to instead give you a RTCSessionDescription with
                    // type and sdp properties set to "".
                    //
                    // Because of this we need to ensure that type exists and contains something.
                    //
                    // We first check that the peer connection is not closed to prevent
                    // Firefox from throwing an InvalidStateError. See OPENTOK-29358
                    //
                    return !!(this.pc && this.pc.iceConnectionState !== 'closed' && this.pc.remoteDescription && this.pc.remoteDescription.type && this.pc.localDescription && this.pc.localDescription.type);
                };
                /**
 * Add an RTCIceCandidate to the PeerConnection. If the PeerConnection is ready
 * it will be applied immediately, otherwise it will be buffered until later.
 *
 * @param {RTCIceCandidate} iceCandidate The candidate to add.
 *
 * @returns {Promise} A promise that is resolved when the candidate is applied.
 *
 * @method #addIceCandidate
 * @memberof IceCandidateProcessor
 *
 */ IceCandidateProcessor.prototype.addIceCandidate = function addIceCandidate(iceCandidate) {
                    if (this.canAddCandidates()) return this._forwardIceCandidate(iceCandidate);
                    const pending = this.pending;
                    return new Promise((resolve, reject)=>{
                        pending.push({
                            iceCandidate: iceCandidate,
                            resolve: resolve,
                            reject: reject
                        });
                    });
                };
                /**
 * Called to attempt to process any pending candidates.
 *
 * @description This will be called automatically when needed so there's no
 * reason to call it yourself. You totally could, but surely you have better
 * things to do?
 *
 * @param {RTCIceCandidate} iceCandidate The candidate to add.
 *
 * @returns {Promise} A promise that is resolved when the candidate is applied.
 *
 * @method #addIceCandidate
 * @memberof IceCandidateProcessor
 *
 */ IceCandidateProcessor.prototype.maybeProcessPending = function maybeProcessPending() {
                    if (this.canAddCandidates()) this.process();
                };
                IceCandidateProcessor.prototype.process = function process() {
                    while(this.pending.length){
                        const pending = this.pending.shift();
                        this._forwardIceCandidate(pending.iceCandidate).then(pending.resolve).catch(pending.reject);
                    }
                };
                IceCandidateProcessor.prototype.destroy = function destroy() {
                    if (this.pc) this.pc.removeEventListener('signalingstatechange', this._processBinding);
                    this._processBinding = null;
                    this.pc = null;
                };
                module1.exports = IceCandidateProcessor;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 622 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // Adapts a function that returns or promise or takes success and error
                // callbacks, and returns a function that always returns a promise.
                // This is used to provide backwards compatibility for WebRTC implementations,
                // which used to use success and error callbacks, and now return promises.
                module1.exports = function promisify(context, methodName) {
                    const method = context[methodName];
                    return function(input) {
                        return new Promise((resolve, reject)=>{
                            const result = method.apply(context, [
                                input,
                                resolve,
                                reject
                            ]);
                            if (result && typeof result.then === 'function') resolve(result);
                        });
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 623 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign */ const applySdpTransform = __webpack_require__(155);
            const env = __webpack_require__(3);
            const logging = __webpack_require__(2)('offerProcessor');
            const SDPHelpers = __webpack_require__(53);
            const testSupportVideo = __webpack_require__(624); // Attempt to completely process +offer+. This will:
            // * set the offer as the remote description
            // * create an answer and
            // * set the new answer as the location description
            //
            // If there are no issues, the +success+ callback will be executed on completion.
            // Errors during any step will result in the +failure+ callback being executed.
            //
            module1.exports = function offerProcessor(peerConnection, RTCPeerConnection, RTCSessionDescription1, NativeRTCSessionDescription, sdpTransforms, offer, codecFlags, p2p, success, failure, onVideoSupported, replaceBaselineProfile, sourceStreamId) {
                const generateErrorCallback = (message, prefix)=>(errorReason)=>{
                        logging.error(message);
                        logging.error(errorReason);
                        if (failure) failure(message, errorReason, prefix);
                    };
                const setLocalDescription = (answer)=>{
                    const enableStereo = SDPHelpers.hasSendStereo(offer.sdp);
                    const enableDtx = SDPHelpers.hasSendDtx(offer.sdp);
                    const audioBitrate = SDPHelpers.getAudioBitrate(offer.sdp);
                    const transformedSdp = applySdpTransform(sdpTransforms, 'local', 'answer', {
                        enableStereo: enableStereo,
                        enableDtx: enableDtx,
                        audioBitrate: audioBitrate,
                        replaceBaselineProfile: replaceBaselineProfile,
                        codecFlags: codecFlags,
                        sourceStreamId: sourceStreamId
                    }, answer.sdp);
                    const newLocalAnswer = new NativeRTCSessionDescription({
                        type: answer.type,
                        sdp: transformedSdp.local
                    });
                    const newRemoteAnswer = {
                        type: answer.type,
                        sdp: transformedSdp.remote
                    };
                    return peerConnection.setLocalDescription(newLocalAnswer).then(()=>success(newRemoteAnswer)).catch(generateErrorCallback('Error while setting LocalDescription', 'SetLocalDescription'));
                };
                const createAnswer = ()=>peerConnection.createAnswer().then(setLocalDescription).catch(generateErrorCallback('Error while setting createAnswer', 'CreateAnswer'));
                const newOffer = new NativeRTCSessionDescription({
                    type: offer.type,
                    sdp: applySdpTransform(sdpTransforms, 'remote', 'offer', {
                        replaceBaselineProfile: replaceBaselineProfile
                    }, offer.sdp).local
                });
                const errorCallback = generateErrorCallback('Error while setting RemoteDescription', 'SetRemoteDescription');
                const finalOfferPromise = testSupportVideo(newOffer, p2p, env, RTCPeerConnection, RTCSessionDescription1).then(()=>{
                    onVideoSupported(true);
                    return newOffer;
                }).catch((err)=>{
                    onVideoSupported(false);
                    if (!SDPHelpers.hasMediaType(newOffer.sdp, 'audio')) throw new Error('Unsupported video without audio for fallback');
                    logging.debug('Couldn\'t set remote description', newOffer, err, ', trying without video');
                    const offerWithoutVideo = new NativeRTCSessionDescription({
                        type: offer.type,
                        sdp: SDPHelpers.disableMediaType(newOffer.sdp, 'video')
                    });
                    logging.debug('offer without video', offerWithoutVideo.sdp);
                    return offerWithoutVideo;
                });
                return finalOfferPromise.then((finalOffer)=>peerConnection.setRemoteDescription(finalOffer)).then(createAnswer).catch(errorCallback);
            };
        /***/ },
        /* 624 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const shouldUsePlanBSDP = __webpack_require__(74);
                const testSupportVideo = (remoteDesc, p2p, env, RTCPeerConnection, RTCSessionDescription1)=>{
                    if (!RTCPeerConnection) return Promise.resolve(true);
                    const pcConfig = {
                        iceServers: []
                    };
                    if (shouldUsePlanBSDP()) pcConfig.sdpSemantics = 'plan-b';
                    const testPc = new RTCPeerConnection(pcConfig);
                    const cleanup = ()=>{
                        try {
                            testPc.close();
                        } catch (e) {} // eslint-disable-line no-empty
                    };
                    return testPc.setRemoteDescription(new RTCSessionDescription1(remoteDesc)).then(()=>{
                        cleanup();
                    }).catch((err)=>{
                        cleanup();
                        throw err;
                    });
                };
                module1.exports = testSupportVideo;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 625 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-restricted-syntax, no-prototype-builtins */ const find = __webpack_require__(62);
            const DataChannel = __webpack_require__(626); // Contains a collection of DataChannels for a particular RTCPeerConnection
            //
            // @param [RTCPeerConnection] pc A native peer connection object
            //
            // @constructor
            // @private
            //
            module1.exports = function PeerConnectionChannels(pc) {
                // / Private Data
                let channels = [];
                const api = {};
                let lastQos = {
                    sentMessages: 0,
                    recvMessages: 0
                }; // / Private API
                const remove = function remove(channel) {
                    channels.filter((c)=>channel !== c);
                };
                const add = function add(nativeChannel) {
                    const channel = new DataChannel(nativeChannel);
                    channels.push(channel);
                    channel.on('close', ()=>{
                        remove(channel);
                    });
                    return channel;
                }; // / Public API
                api.add = function(label, options) {
                    return add(pc.createDataChannel(label, options));
                };
                api.addMany = function(newChannels) {
                    for(const label in newChannels)if (newChannels.hasOwnProperty(label)) api.add(label, newChannels[label]);
                };
                api.get = function(label, options) {
                    return find(channels, (channel)=>channel.equals(label, options));
                };
                api.getOrAdd = function(label, options) {
                    let channel = api.get(label, options);
                    if (!channel) channel = api.add(label, options);
                    return channel;
                };
                api.getQosData = function() {
                    const qosData = {
                        sentMessages: 0,
                        recvMessages: 0
                    };
                    channels.forEach((channel)=>{
                        qosData.sentMessages += channel.getQosData().sentMessages;
                        qosData.recvMessages += channel.getQosData().recvMessages;
                    });
                    return qosData;
                };
                api.sampleQos = function() {
                    const newQos = api.getQosData();
                    const sampleQos = {
                        sentMessages: newQos.sentMessages - lastQos.sentMessages,
                        recvMessages: newQos.recvMessages - lastQos.recvMessages
                    };
                    lastQos = newQos;
                    return sampleQos;
                };
                api.destroy = function() {
                    channels.forEach((channel)=>{
                        channel.close();
                    });
                    channels = [];
                }; // / Init
                pc.addEventListener('datachannel', (event)=>{
                    add(event.channel);
                });
                return api;
            };
        /***/ },
        /* 626 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-cond-assign, no-underscore-dangle, no-restricted-syntax */ /* eslint-disable no-prototype-builtins */ const eventing = __webpack_require__(7);
            const logging = __webpack_require__(2)('DataChannel'); // Wraps up a native RTCDataChannelEvent object for the message event. This is
            // so we never accidentally leak the native DataChannel.
            //
            // @constructor
            // @private
            //
            //
            const DataChannelMessageEvent = function DataChannelMessageEvent(event) {
                this.data = event.data;
                this.source = event.source;
                this.lastEventId = event.lastEventId;
                this.origin = event.origin;
                this.timeStamp = event.timeStamp;
                this.type = event.type;
                this.ports = event.ports;
                this.path = event.path;
            }; // DataChannel is a wrapper of the native browser RTCDataChannel object.
            //
            // It exposes an interface that is very similar to the native one except
            // for the following differences:
            //  * eventing is handled in a way that is consistent with the OpenTok API
            //  * calls to the send method that occur before the channel is open will be
            //    buffered until the channel is open (as opposed to throwing an exception)
            //
            // By design, there is (almost) no direct access to the native object. This is to ensure
            // that we can control the underlying implementation as needed.
            //
            // NOTE: IT TURNS OUT THAT FF HASN'T IMPLEMENT THE LATEST PUBLISHED DATACHANNELS
            // SPEC YET, SO THE INFO ABOUT maxRetransmitTime AND maxRetransmits IS WRONG. INSTEAD
            // THERE IS A SINGLE PROPERTY YOU PROVIDE WHEN CREATING THE CHANNEL WHICH CONTROLS WHETHER
            // THE CHANNEL IS RELAIBLE OF NOT.
            //
            // Two properties that will have a large bearing on channel behaviour are maxRetransmitTime
            // and maxRetransmits. Descriptions of those properties are below. They are set when creating
            // the initial native RTCDataChannel.
            //
            // maxRetransmitTime of type unsigned short, readonly , nullable
            //   The RTCDataChannel.maxRetransmitTime attribute returns the length of the time global
            //   (in milliseconds) during which retransmissions may occur in unreliable mode, or null if
            //   unset. The attribute MUST return the value to which it was set when the RTCDataChannel was
            //   created.
            //
            // maxRetransmits of type unsigned short, readonly , nullable
            //   The RTCDataChannel.maxRetransmits attribute returns the maximum number of retransmissions
            //   that are attempted in unreliable mode, or null if unset. The attribute MUST return the value
            //   to which it was set when the RTCDataChannel was created.
            //
            // @reference http://www.w3.org/TR/webrtc/#peer-to-peer-data-api
            //
            // @param [RTCDataChannel] dataChannel A native data channel.
            //
            //
            // @constructor
            // @private
            //
            module1.exports = function DataChannel(dataChannel) {
                const api = {}; // / Private Data
                const bufferedMessages = [];
                const qosData = {
                    sentMessages: 0,
                    recvMessages: 0
                }; // / Private API
                const bufferMessage = function bufferMessage(data) {
                    bufferedMessages.push(data);
                    return api;
                };
                const sendMessage = function sendMessage(data) {
                    dataChannel.send(data);
                    qosData.sentMessages++;
                    return api;
                };
                const flushBufferedMessages = function flushBufferedMessages() {
                    let data;
                    while(data = bufferedMessages.shift())api.send(data);
                };
                const onOpen = function onOpen() {
                    api.send = sendMessage;
                    flushBufferedMessages();
                };
                const onClose = function onClose(event) {
                    api.send = bufferMessage;
                    api.trigger('close', event);
                };
                const onError = function onError(event) {
                    logging.error(event);
                };
                const onMessage = function onMessage(domEvent) {
                    const event = new DataChannelMessageEvent(domEvent);
                    qosData.recvMessages++;
                    api.trigger('message', event);
                }; // / Public API
                eventing(api, true);
                api.label = dataChannel.label;
                api.id = dataChannel.id; // api.maxRetransmitTime = dataChannel.maxRetransmitTime;
                // api.maxRetransmits = dataChannel.maxRetransmits;
                api.reliable = dataChannel.reliable;
                api.negotiated = dataChannel.negotiated;
                api.ordered = dataChannel.ordered;
                api.protocol = dataChannel.protocol;
                api._channel = dataChannel;
                api.close = function() {
                    dataChannel.close();
                };
                api.equals = function(label, options) {
                    if (api.label !== label) return false;
                    for(const key in options)if (options.hasOwnProperty(key)) {
                        if (api[key] !== options[key]) return false;
                    }
                    return true;
                };
                api.getQosData = function() {
                    return qosData;
                }; // Send initially just buffers all messages until
                // the channel is open.
                api.send = bufferMessage; // / Init
                dataChannel.addEventListener('open', onOpen, false);
                dataChannel.addEventListener('close', onClose, false);
                dataChannel.addEventListener('error', onError, false);
                dataChannel.addEventListener('message', onMessage, false);
                return api;
            };
        /***/ },
        /* 627 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign */ const assign = __webpack_require__(9);
            const applySdpTransform = __webpack_require__(155);
            const logging = __webpack_require__(2)('subscribeProcessor'); // Attempt to completely process a subscribe message. This will:
            // * create an Offer
            // * set the new offer as the location description
            //
            // If there are no issues, the Promise will resolve on completion.
            // Errors during any step will result in the Promise being rejected.
            //
            module1.exports = function subscribeProcessor(_ref) {
                let peerConnection = _ref.peerConnection, NativeRTCSessionDescription = _ref.NativeRTCSessionDescription, sdpTransforms = _ref.sdpTransforms, numSimulcastStreams = _ref.numSimulcastStreams, offerOverrides = _ref.offerOverrides, offerConstraints = _ref.offerConstraints, replaceBaselineProfile = _ref.replaceBaselineProfile, removeVideoOrientation = _ref.removeVideoOrientation;
                const generateErrorCallback = (message, prefix)=>(errorReason)=>{
                        logging.error(message, errorReason);
                        const error = new Error(message);
                        error.reason = errorReason;
                        error.prefix = prefix;
                        throw error;
                    };
                const setLocalDescription = (offer)=>{
                    logging.debug('subscribeProcessor: offer created', offer);
                    const transformedSdp = applySdpTransform(sdpTransforms, 'local', 'offer', assign({
                        numSimulcastStreams: numSimulcastStreams,
                        replaceBaselineProfile: replaceBaselineProfile,
                        removeVideoOrientation: removeVideoOrientation
                    }, offerOverrides), offer.sdp);
                    const newLocalOffer = new NativeRTCSessionDescription({
                        type: offer.type,
                        sdp: transformedSdp.local
                    });
                    const newRemoteOffer = new NativeRTCSessionDescription({
                        type: offer.type,
                        sdp: transformedSdp.remote
                    });
                    logging.debug('subscribeProcessor: setting local description');
                    return peerConnection.setLocalDescription(newLocalOffer).then(()=>newRemoteOffer, generateErrorCallback('Error while setting LocalDescription', 'SetLocalDescription'));
                };
                logging.debug('subscribeProcessor: creating offer');
                return peerConnection.createOffer(offerConstraints).then(setLocalDescription, generateErrorCallback('Error while creating Offer', 'CreateOffer')).then((offer)=>({
                        sdp: offer.sdp,
                        type: offer.type
                    }));
            };
        /***/ },
        /* 628 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const SDPHelpers = __webpack_require__(53);
            const _SDPHelpers$mediaDire = SDPHelpers.mediaDirections, RECVONLY = _SDPHelpers$mediaDire.RECVONLY, INACTIVE = _SDPHelpers$mediaDire.INACTIVE;
            const changeMediaDirection = /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(peerConnection, direction) {
                    var offer, sdp, newSdp;
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (peerConnection) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return peerConnection.createOffer();
                            case 4:
                                offer = _context.sent;
                                _context.next = 7;
                                return peerConnection.setLocalDescription(offer);
                            case 7:
                                sdp = peerConnection.remoteDescription.sdp; // replaces the 'a=recvonly' lines to 'a=inactive' or viceversa, depending on active.
                                newSdp = SDPHelpers.changeMediaDirection(sdp, direction);
                                peerConnection.setRemoteDescription({
                                    type: peerConnection.remoteDescription.type,
                                    sdp: newSdp
                                });
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function changeMediaDirection(_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }();
            /**
 * Changes the RTP media direction by SDP munging
 * @param {Object} peerConnection - the peer connection to apply the change
 * @param {('recvonly' | 'inactive')} direction - The new direction that could be recvonly or
 * inactive. If it's inactive, then the peer connection will stop sending RTP media.
 */ module1.exports = {
                changeMediaDirectionToInactive: (peerConnection)=>changeMediaDirection(peerConnection, INACTIVE),
                changeMediaDirectionToRecvOnly: (peerConnection)=>changeMediaDirection(peerConnection, RECVONLY)
            };
        /***/ },
        /* 629 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.parseStatsOldAPI = parseStatsOldAPI;
            exports.parseStatsNewAPI = parseStatsNewAPI;
            exports.default = parseQOS;
            function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                var it;
                if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        return function() {
                            if (i >= o.length) return {
                                done: true
                            };
                            return {
                                done: false,
                                value: o[i++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                it = o[Symbol.iterator]();
                return it.next.bind(it);
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-void, no-use-before-define, one-var */ /* eslint-disable no-restricted-syntax, no-prototype-builtins, no-underscore-dangle */ const env = __webpack_require__(3);
            const OTHelpers = __webpack_require__(8);
            const logging = __webpack_require__(2)('QoS');
            const sdpHelpers = __webpack_require__(53);
            const getProtocolFromPriority = __webpack_require__(280);
            const getLocalRelayProtocol = __webpack_require__(630);
            const shouldUseStandardGetStats = __webpack_require__(102)();
            const calculateFrameRate = __webpack_require__(157);
            const requiredPublisherKeys = [
                'audioCodec',
                'audioSentBytes',
                'audioSentPackets',
                'audioSentPacketsLost',
                'audioRtt',
                'videoCodec',
                'videoHeight',
                'videoHeightInput',
                'videoSentBytes',
                'videoFrameRateSent',
                'videoSentPackets',
                'videoRtt',
                'videoSentPacketsLost',
                'videoWidthInput',
                'videoWidth',
                'srtpCipher'
            ];
            const requiredSubscriberKeys = [
                'audioCodec',
                'audioRecvBytes',
                'audioRecvPackets',
                'audioRecvPacketsLost',
                'videoCodec',
                'videoHeight',
                'videoRecvBytes',
                'videoRecvPackets',
                'videoRecvPacketsLost',
                'videoFrameRateReceived',
                'videoWidth',
                'srtpCipher'
            ]; // There are two implementations of stats parsing in this file.
            // 1. For Chrome: Chrome is currently using an older version of the API
            // 2. For Firefox: FF is using a version that looks a lot closer to the
            //    current spec.
            //
            // I've attempted to keep the implementations from sharing any code,
            // accordingly you'll notice a bunch of duplication between them.
            //
            // This is acceptable as the goal is to be able to remove each implementation
            // as it's no longer needed without any risk of affecting the others. If there
            // was shared code between them then each removal would require an audit of
            // all the others.
            const rawStatsHandler = (pc, stats)=>logging.debug(`Raw stats for peer conn ${pc.id}:`, stats);
            const getAddress = (res)=>{
                const port = res.portNumber || res.port;
                const ip = res.ipAddress || res.address || res.ip;
                return `${ip}:${port}`;
            }; // Get Stats using the older API. Used by Chrome up until v58.
            function parseStatsOldAPI(peerConnection, prevStats, currentStats, isPublisher, completion) {
                /* this parses a result if there it contains the video bitrate */ const parseVideoStats = (result)=>{
                    if (Number(result.stat('googFrameRateSent')) > 0) {
                        currentStats.videoSentBytes = Number(result.stat('bytesSent'));
                        currentStats.videoSentPackets = Number(result.stat('packetsSent'));
                        currentStats.videoSentPacketsLost = Number(result.stat('packetsLost')); // googRtt is expressed in ms, and we need to log it always in seconds. See OPENTOK-42624.
                        currentStats.videoRtt = Number(result.stat('googRtt')) / 1000;
                        currentStats.videoFrameRate = Number(result.stat('googFrameRateInput'));
                        currentStats.videoWidth = Number(result.stat('googFrameWidthSent'));
                        currentStats.videoHeight = Number(result.stat('googFrameHeightSent'));
                        currentStats.videoFrameRateSent = Number(result.stat('googFrameRateSent'));
                        currentStats.videoWidthInput = Number(result.stat('googFrameWidthInput'));
                        currentStats.videoHeightInput = Number(result.stat('googFrameHeightInput'));
                        currentStats.videoCodec = result.stat('googCodecName');
                        currentStats.videoBandwidthLimitedResolution = result.stat('googBandwidthLimitedResolution') === 'true';
                        currentStats.cpuLimitedResolution = result.stat('googCpuLimitedResolution') === 'true';
                    } else if (Number(result.stat('googFrameRateReceived')) > 0) {
                        currentStats.videoRecvBytes = Number(result.stat('bytesReceived'));
                        currentStats.videoRecvPackets = Number(result.stat('packetsReceived'));
                        currentStats.videoRecvPacketsLost = Number(result.stat('packetsLost'));
                        currentStats.videoFrameRate = Number(result.stat('googFrameRateOutput'));
                        currentStats.videoFrameRateReceived = Number(result.stat('googFrameRateReceived'));
                        currentStats.videoFrameRateDecoded = Number(result.stat('googFrameRateDecoded'));
                        currentStats.videoWidth = Number(result.stat('googFrameWidthReceived'));
                        currentStats.videoHeight = Number(result.stat('googFrameHeightReceived'));
                        currentStats.videoCodec = result.stat('googCodecName');
                    }
                    return null;
                };
                const parseAudioStats = (result)=>{
                    if (Number(result.stat('audioInputLevel')) > 0) {
                        currentStats.audioSentPackets = Number(result.stat('packetsSent'));
                        currentStats.audioSentPacketsLost = Number(result.stat('packetsLost'));
                        currentStats.audioSentBytes = Number(result.stat('bytesSent'));
                        currentStats.audioCodec = result.stat('googCodecName'); // googRtt is expressed in ms, and we need to log it always in seconds. See OPENTOK-42624.
                        currentStats.audioRtt = Number(result.stat('googRtt')) / 1000;
                    } else if (Number(result.stat('audioOutputLevel')) > 0) {
                        currentStats.audioRecvPackets = Number(result.stat('packetsReceived'));
                        currentStats.audioRecvPacketsLost = Number(result.stat('packetsLost'));
                        currentStats.audioRecvBytes = Number(result.stat('bytesReceived'));
                        currentStats.audioCodec = result.stat('googCodecName');
                    }
                };
                const parseStatsReports = (stats)=>{
                    if (stats.result) {
                        const resultList = stats.result();
                        rawStatsHandler(peerConnection, resultList);
                        const getCandidate = (type, fromStat)=>resultList.filter((x)=>x.id === fromStat.stat(type))[0];
                        const getLocalCandidate = (fromStat)=>getCandidate('localCandidateId', fromStat);
                        const getRemoteCandidate = (fromStat)=>getCandidate('remoteCandidateId', fromStat);
                        for(let resultIndex = 0; resultIndex < resultList.length; resultIndex++){
                            const result = resultList[resultIndex];
                            if (result.stat) {
                                if (result.stat('googActiveConnection') === 'true') {
                                    if (result.stat('googChannelId').indexOf('audio') > -1) {
                                        currentStats.audioLocalAddress = result.stat('googLocalAddress');
                                        currentStats.audioRemoteAddress = result.stat('googRemoteAddress');
                                        currentStats.audioLocalCandidateType = result.stat('googLocalCandidateType');
                                        currentStats.audioRemoteCandidateType = result.stat('googRemoteCandidateType');
                                        currentStats.audioTransportType = result.stat('googTransportType');
                                        currentStats.audioLocalRelayProtocol = getProtocolFromPriority(getLocalCandidate(result).stat('priority'));
                                        currentStats.audioRemoteRelayProtocol = getProtocolFromPriority(getRemoteCandidate(result).stat('priority'));
                                    } else if (result.stat('googChannelId').indexOf('video') > -1) {
                                        currentStats.videoLocalAddress = result.stat('googLocalAddress');
                                        currentStats.videoRemoteAddress = result.stat('googRemoteAddress');
                                        currentStats.videoLocalCandidateType = result.stat('googLocalCandidateType');
                                        currentStats.videoRemoteCandidateType = result.stat('googRemoteCandidateType');
                                        currentStats.videoTransportType = result.stat('googTransportType');
                                        currentStats.videoLocalRelayProtocol = getProtocolFromPriority(getLocalCandidate(result).stat('priority'));
                                        currentStats.videoRemoteRelayProtocol = getProtocolFromPriority(getRemoteCandidate(result).stat('priority'));
                                    }
                                } // Video BWE
                                if (Number(result.stat('googAvailableSendBandwidth')) > 0) currentStats.videoSentEstimatedBandwidth = Number(result.stat('googAvailableSendBandwidth'));
                                if (Number(result.stat('googAvailableReceiveBandwidth')) > 0) currentStats.videoRecvEstimatedBandwidth = Number(result.stat('googAvailableReceiveBandwidth'));
                                parseAudioStats(result);
                                parseVideoStats(result);
                            }
                        } // For audio-video publishers in Chrome, there are no corresponding video reports for these
                        if ('videoCodec' in currentStats && !currentStats.videoLocalAddress) [
                            'LocalAddress',
                            'RemoteAddress',
                            'LocalCandidateType',
                            'RemoteCandidateType',
                            'TransportType',
                            'LocalRelayProtocol',
                            'RemoteRelayProtocol'
                        ].forEach((keySuffix)=>{
                            currentStats[`video${keySuffix}`] = currentStats[`audio${keySuffix}`];
                        });
                    }
                    completion(null, currentStats);
                };
                peerConnection.getStats(parseStatsReports);
            } // Get Stats using the newer API.
            function parseStatsNewAPI(peerConnection, prevStats, currentStats, isPublisher, completion) {
                const onStatsError = function onStatsError(error) {
                    completion(error);
                };
                const parseAudioStats = (result, strippedType)=>{
                    if (strippedType === 'outboundrtp') {
                        currentStats.audioSentPackets = result.packetsSent;
                        currentStats.audioSentPacketsLost = result.packetsLost;
                        currentStats.audioSentBytes = result.bytesSent;
                    } else if (strippedType === 'inboundrtp') {
                        currentStats.audioRecvPackets = result.packetsReceived;
                        currentStats.audioRecvPacketsLost = result.packetsLost;
                        currentStats.audioRecvBytes = result.bytesReceived;
                    } // OPENTOK-36308 Safari doesn't have audioCodec but on the publisher side it can be mapped
                    // to the SDP.  On the subscriber side, currentStats.audioCodec will remain undefined, and
                    // will be set (possibly incorrectly) by picking the first rtpmap line out of the SDP.
                    if (undefined === currentStats.audioCodec && [
                        'Safari'
                    ].indexOf(OTHelpers.env.name) !== -1 && undefined !== result.codecId) {
                        const _ref = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription, sdp = _ref.sdp;
                        const lastIndex = result.codecId.lastIndexOf('_');
                        const codecsAndCodecMap = sdpHelpers.getCodecsAndCodecMap(sdp, 'audio');
                        if (lastIndex !== -1 && codecsAndCodecMap !== undefined) currentStats.audioCodec = codecsAndCodecMap.codecMap[result.codecId.substring(lastIndex + 1)];
                    }
                };
                const parseOutboundVideoStats = (result)=>{
                    // Maps the stat of the (canonical) field to a more readable alias
                    const fieldToAliasMap = {
                        packetsSent: 'videoSentPackets',
                        packetsLost: 'videoSentPacketsLost',
                        bytesSent: 'videoSentBytes',
                        framesPerSecond: 'videoFrameRate',
                        framesSent: 'videoFrameRateSent',
                        framesReceived: 'videoFramesReceived',
                        frameWidth: 'videoWidth',
                        frameHeight: 'videoHeight'
                    };
                    const cummulativeStats = [
                        'videoSentPackets',
                        'videoSentBytes'
                    ]; // Stores all the defined stats
                    for(const field in fieldToAliasMap)if (field in result) {
                        const alias = fieldToAliasMap[field];
                        if (cummulativeStats.includes(alias) && Number.isSafeInteger(currentStats[alias])) currentStats[alias] += result[field];
                        else currentStats[alias] = result[field];
                    }
                };
                const parseVideoStats = (result, strippedType)=>{
                    const getVideoFrameRate = ()=>{
                        const haveBytes = 'videoSentBytes' in currentStats ? currentStats.videoSentBytes > 0 : currentStats.videoRecvBytes > 0;
                        if (!haveBytes) return 0;
                        let videoFrameRate = 0;
                        if (env.isFirefox && env.version < 96) videoFrameRate = Number(result.framerateMean);
                        else {
                            const framesStat = strippedType === 'outboundrtp' ? 'framesEncoded' : 'framesDecoded';
                            currentStats[framesStat] = result[framesStat];
                            videoFrameRate = calculateFrameRate({
                                currentStatFrames: result[framesStat],
                                currentTimestamp: result.timestamp,
                                prevStatFrames: prevStats[framesStat],
                                prevTimestamp: prevStats.timeStamp || Date.now()
                            });
                        }
                        return videoFrameRate;
                    };
                    if (strippedType === 'outboundrtp') {
                        if (result.hasOwnProperty('qualityLimitationReason')) {
                            currentStats.videoBandwidthLimitedResolution = result.qualityLimitationReason === 'bandwidth';
                            currentStats.cpuLimitedResolution = result.qualityLimitationReason === 'cpu';
                        }
                        parseOutboundVideoStats(result);
                    } else if (strippedType === 'inboundrtp') {
                        currentStats.videoRecvPackets = result.packetsReceived;
                        currentStats.videoRecvPacketsLost = result.packetsLost;
                        currentStats.videoRecvBytes = result.bytesReceived;
                    } // Calculation of videoFrameRate:
                    // - For Chromium based browsers:
                    //   -- Publisher videoFrameRate: it's calculated in parseOutboundVideoStats().
                    //   -- Subscriber videoFrameRate: it's calculated in getVideoFrameRate().
                    // - For Firefox <= 95
                    //   -- Obtained from frameRateMean stat in getVideoFrameRate() for both inbound and
                    //      outbound video reports.
                    // - For Firefox >= 96
                    //   -- it's calculated in getVideoFrameRate() calculating the frameRate using
                    //      on framesEncoded (outbound video) or framesDecoded (inbound video)
                    // - For Safari
                    //   -- Publisher videoFrameRate: it's calculated in parseOutboundVideoStats().
                    //   -- Subscriber videoFrameRate: it's calculated in getVideoFrameRate().
                    if (env.isFirefox && [
                        'outboundrtp',
                        'inboundrtp'
                    ].includes(strippedType) || !isPublisher && strippedType === 'inboundrtp') currentStats.videoFrameRate = getVideoFrameRate();
                     // OPENTOK-36308 Safari doesn't have videoCodec but on the publisher side it can be mapped
                    // to the SDP.  On the subscriber side, currentStats.videoCodec will remain undefined, and
                    // will be set (possibly incorrectly) by picking the first rtpmap line out of the SDP.
                    if (undefined === currentStats.videoCodec && [
                        'Safari'
                    ].indexOf(OTHelpers.env.name) !== -1 && undefined !== result.codecId) {
                        const _ref2 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription, sdp = _ref2.sdp;
                        const lastIndex = result.codecId.lastIndexOf('_');
                        const codecsAndCodecMap = sdpHelpers.getCodecsAndCodecMap(sdp, 'video');
                        if (lastIndex !== -1 && codecsAndCodecMap !== undefined) currentStats.videoCodec = codecsAndCodecMap.codecMap[result.codecId.substring(lastIndex + 1)];
                    }
                };
                peerConnection.getStats(null).then((stats)=>{
                    let localCandidateType, remoteCandidateType, localAddress, localRelayProtocol, remoteAddress, transportType, frameWidth, frameHeight;
                    const videoRttValues = []; // Calculates the average of all the roundTripTime values.
                    const getVideoRttAverage = ()=>{
                        if (videoRttValues.length === 0) return null;
                        const positiveVideoRtts = videoRttValues.filter((videoRtt)=>videoRtt > 0);
                        const accumulatedVideoRtt = positiveVideoRtts.reduce((acc, videoRtt)=>acc + videoRtt, 0);
                        const videoRttAverage = positiveVideoRtts.length ? accumulatedVideoRtt / positiveVideoRtts.length : 0;
                        return videoRttAverage;
                    }; // Converts `Inbound-RTP` to `inboundrtp`
                    const getStrippedType = (type)=>type.toLowerCase().replace(/[^a-z]/g, '');
                    const statsLoop = (res)=>{
                        const strippedType = getStrippedType(res.type);
                        const lowercaseId = res.id.toLowerCase();
                        if (/(in|out)boundrtp$/.test(strippedType)) {
                            // Media type may be mapped to either `id` or `kind`
                            const isRtp = /rtp/.test(lowercaseId);
                            const isAudioRtp = isRtp && /audio/.test(lowercaseId);
                            const isVideoRtp = isRtp && /video/.test(lowercaseId);
                            const isAudio = isAudioRtp || res.kind === 'audio';
                            const isVideo = isVideoRtp || res.kind === 'video';
                            if (isAudio) parseAudioStats(res, strippedType);
                            else if (isVideo) parseVideoStats(res, strippedType);
                            if (res.hasOwnProperty('roundTripTime')) {
                                const type = res.mediaType || res.kind; // roundTripTime comes on the rtcp stats and so won't be caught above
                                if (type === 'video') videoRttValues.push(res.roundTripTime);
                                else if (type === 'audio') currentStats.audioRtt = res.roundTripTime;
                            }
                            if (strippedType === 'remoteinboundrtp') {
                                if (res.hasOwnProperty('packetsLost')) {
                                    const kind = res.kind;
                                    const key = `${kind}SentPacketsLost`;
                                    if (!currentStats[key]) currentStats[key] = 0;
                                    currentStats[key] += res.packetsLost;
                                }
                            }
                        } else if (strippedType === 'transport') {
                            const selectedCandidatePairId = res.selectedCandidatePairId, srtpCipher = res.srtpCipher;
                            currentStats.srtpCipher = srtpCipher;
                            if (selectedCandidatePairId) localRelayProtocol = getLocalRelayProtocol(selectedCandidatePairId, stats);
                        } else if (strippedType === 'localcandidate') {
                            localCandidateType = res.candidateType;
                            localAddress = getAddress(res);
                            transportType = res.protocol || res.transport;
                        } else if (strippedType === 'remotecandidate') {
                            remoteCandidateType = res.candidateType;
                            remoteAddress = getAddress(res);
                        } else if (strippedType === 'track' && lowercaseId.indexOf('video') !== 0) {
                            frameWidth = res.frameWidth;
                            frameHeight = res.frameHeight;
                            parseOutboundVideoStats(res);
                        } else if (strippedType === 'mediasource') {
                            if (res.hasOwnProperty('framesPerSecond')) currentStats.videoFrameRate = res.framesPerSecond;
                            if (res.hasOwnProperty('width')) currentStats.videoWidthInput = res.width;
                            if (res.hasOwnProperty('height')) currentStats.videoHeightInput = res.height;
                        } else if (strippedType === 'candidatepair') {
                            if (res.hasOwnProperty('availableOutgoingBitrate')) {
                                const estimatedStat = `video${isPublisher ? 'Sent' : 'Recv'}EstimatedBandwidth`;
                                currentStats[estimatedStat] = parseInt(res.availableOutgoingBitrate, 10);
                            }
                        }
                    }; // Firefox <= 45 can't use for of loop OPENTOK-32755
                    if (typeof stats[Symbol.iterator] === 'function') {
                        rawStatsHandler(peerConnection, Array.from(stats));
                        for(var _iterator = _createForOfIteratorHelperLoose(stats), _step; !(_step = _iterator()).done;){
                            const el = _step.value;
                            const res = Array.isArray(el) ? el[1] : el;
                            statsLoop(res);
                        }
                    } else {
                        rawStatsHandler(peerConnection, stats);
                        for(const key in stats)if (stats.hasOwnProperty(key)) statsLoop(stats[key]);
                    }
                    if (peerConnection.currentRemoteDescription) currentStats.useDtx = sdpHelpers.hasSendDtx(peerConnection.currentRemoteDescription.sdp);
                    if (isPublisher) currentStats.videoRtt = getVideoRttAverage();
                    if (currentStats.audioRecvBytes || currentStats.audioSentBytes) {
                        currentStats.audioLocalCandidateType = localCandidateType;
                        currentStats.audioLocalAddress = localAddress;
                        currentStats.audioRemoteCandidateType = remoteCandidateType;
                        currentStats.audioRemoteAddress = remoteAddress;
                        currentStats.audioTransportType = transportType;
                        currentStats.audioLocalRelayProtocol = localRelayProtocol;
                        if (currentStats.audioCodec === undefined) {
                            const _ref3 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription, sdp = _ref3.sdp;
                            const codecs = sdpHelpers.getCodecs(sdp, 'audio');
                            currentStats.audioCodec = codecs[0];
                        }
                    }
                    if (currentStats.videoRecvBytes || currentStats.videoSentBytes) {
                        currentStats.videoLocalCandidateType = localCandidateType;
                        currentStats.videoLocalAddress = localAddress;
                        currentStats.videoRemoteCandidateType = remoteCandidateType;
                        currentStats.videoRemoteAddress = remoteAddress;
                        currentStats.videoTransportType = transportType;
                        currentStats.videoLocalRelayProtocol = localRelayProtocol;
                        if (currentStats.videoCodec === undefined) {
                            const _ref4 = peerConnection.remoteDescription.type === 'answer' ? peerConnection.remoteDescription : peerConnection.localDescription, sdp = _ref4.sdp;
                            const codecs = sdpHelpers.getCodecs(sdp, 'video');
                            currentStats.videoCodec = codecs[0];
                        }
                    }
                    extendStats(currentStats, isPublisher);
                    currentStats.videoWidth = currentStats.videoWidth || frameWidth;
                    currentStats.videoHeight = currentStats.videoHeight || frameHeight;
                    completion(null, currentStats);
                }).catch(onStatsError);
            }
            function parseQOS(peerConnection, prevStats, currentStats, isPublisher, completion) {
                if (shouldUseStandardGetStats) return parseStatsNewAPI(peerConnection, prevStats, currentStats, isPublisher, completion);
                return parseStatsOldAPI(peerConnection, prevStats, currentStats, isPublisher, completion);
            }
            function extendStats(stats, isPublisher) {
                const requiredKeys = isPublisher ? requiredPublisherKeys : requiredSubscriberKeys;
                requiredKeys.forEach((key)=>{
                    if (!stats.hasOwnProperty(key)) stats[key] = null;
                });
            }
        /***/ },
        /* 630 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const getProtocolFromPriority = __webpack_require__(280);
            module1.exports = (selectedCandidatePairId, stats)=>{
                let localRelayProtocol = '';
                if (!selectedCandidatePairId || !stats) return localRelayProtocol;
                const activeCandidatePair = stats.get(selectedCandidatePairId);
                if (activeCandidatePair) {
                    const localCandidateId = activeCandidatePair.localCandidateId;
                    if (localCandidateId) {
                        const localCandidate = stats.get(localCandidateId);
                        if (localCandidate) {
                            const relayProtocol = localCandidate.relayProtocol, priority = localCandidate.priority;
                            if (relayProtocol) {
                                const RELAY_PROTOCOL = relayProtocol.toUpperCase();
                                localRelayProtocol = `TURN/${RELAY_PROTOCOL}`;
                            } else localRelayProtocol = getProtocolFromPriority(priority);
                        }
                    }
                }
                return localRelayProtocol;
            };
        /***/ },
        /* 631 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            let TruthyChangeCounter = /*#__PURE__*/ function() {
                function TruthyChangeCounter() {
                    (0, _defineProperty2.default)(this, "value", null);
                    (0, _defineProperty2.default)(this, "changeCount", 0);
                }
                var _proto = TruthyChangeCounter.prototype;
                _proto.onValue = function onValue(newValue) {
                    if (!newValue) return;
                    if (newValue !== this.value) {
                        if (this.value) this.changeCount += 1;
                        this.value = newValue;
                    }
                };
                return TruthyChangeCounter;
            }();
            exports.default = TruthyChangeCounter;
        /***/ },
        /* 632 */ /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__(11), now = __webpack_require__(633), toNumber = __webpack_require__(229);
            /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
            /**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
                var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                wait = toNumber(wait) || 0;
                if (isObject(options)) {
                    leading = !!options.leading;
                    maxing = 'maxWait' in options;
                    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                function invokeFunc(time) {
                    var args = lastArgs, thisArg = lastThis;
                    lastArgs = lastThis = undefined;
                    lastInvokeTime = time;
                    result = func.apply(thisArg, args);
                    return result;
                }
                function leadingEdge(time) {
                    // Reset any `maxWait` timer.
                    lastInvokeTime = time;
                    // Start the timer for the trailing edge.
                    timerId = setTimeout(timerExpired, wait);
                    // Invoke the leading edge.
                    return leading ? invokeFunc(time) : result;
                }
                function remainingWait(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }
                function shouldInvoke(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                    // Either this is the first call, activity has stopped and we're at the
                    // trailing edge, the system time has gone backwards and we're treating
                    // it as the trailing edge, or we've hit the `maxWait` limit.
                    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }
                function timerExpired() {
                    var time = now();
                    if (shouldInvoke(time)) return trailingEdge(time);
                    // Restart the timer.
                    timerId = setTimeout(timerExpired, remainingWait(time));
                }
                function trailingEdge(time) {
                    timerId = undefined;
                    // Only invoke if we have `lastArgs` which means `func` has been
                    // debounced at least once.
                    if (trailing && lastArgs) return invokeFunc(time);
                    lastArgs = lastThis = undefined;
                    return result;
                }
                function cancel() {
                    if (timerId !== undefined) clearTimeout(timerId);
                    lastInvokeTime = 0;
                    lastArgs = lastCallTime = lastThis = timerId = undefined;
                }
                function flush() {
                    return timerId === undefined ? result : trailingEdge(now());
                }
                function debounced() {
                    var time = now(), isInvoking = shouldInvoke(time);
                    lastArgs = arguments;
                    lastThis = this;
                    lastCallTime = time;
                    if (isInvoking) {
                        if (timerId === undefined) return leadingEdge(lastCallTime);
                        if (maxing) {
                            // Handle invocations in a tight loop.
                            clearTimeout(timerId);
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                        }
                    }
                    if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                    return result;
                }
                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
            }
            module1.exports = debounce;
        /***/ },
        /* 633 */ /***/ function(module1, exports, __webpack_require__) {
            var root = __webpack_require__(14);
            /**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
                return root.Date.now();
            };
            module1.exports = now;
        /***/ },
        /* 634 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ const once = __webpack_require__(51); // Indicates whether this client needs its H264 profiles to be swapped
            // Currently this is just Chrome on Android (OPENTOK-34457)
            // See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8584
            exports.check = function(deps) {
                if (deps === void 0) deps = {};
                const env = deps.env || __webpack_require__(3);
                return env.name === 'Chrome' && env.userAgent.toLowerCase().indexOf('android') > -1 && env.version < 65;
            };
            exports.once = once(()=>exports.check());
        /***/ },
        /* 635 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const envDefault = __webpack_require__(3); // Video from iOS publishers are upside-down when viewed in picture-in-picture
            // mode.
            // See https://bugs.webkit.org/show_bug.cgi?id=210958
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const _deps = deps, _deps$env = _deps.env, env = _deps$env === void 0 ? envDefault : _deps$env; // Notice that we're only checking the iOS version, instead of the browser
                // version.  Reason being, browsers on iOS (e.g., Chrome and Firefox) are based
                // on webkit.  This means they'll all have this bug, regardless of their
                // version number.
                return !!(env.isiOS && env.iOSVersion > 10);
            };
        /***/ },
        /* 636 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable one-var, no-underscore-dangle, no-mixed-operators,  no-param-reassign */ const Widget = __webpack_require__(37);
            const OTHelpers = __webpack_require__(8); // Archving Chrome Widget
            //
            // mode (String)
            // Whether to display the archving widget. Possible values are: "on" (the status is displayed
            // when archiving and briefly when archving ends) and "off" (the status is not displayed)
            // Whether to display the archving widget. Possible values are: "auto" (the name is displayed
            // when the status is first displayed and when the user mouses over the display),
            // "off" (the name is not displayed), and "on" (the name is displayed).
            //
            // displays a name
            // can be shown/hidden
            // can be destroyed
            module1.exports = function Archiving(options) {
                let _lightBox, _light, _text, _textNode, renderStageDelayedAction;
                const self1 = this;
                let _archiving = options.archiving;
                const _archivingStarted = options.archivingStarted || 'Archiving on';
                const _archivingEnded = options.archivingEnded || 'Archiving off';
                let _initialState = true;
                const renderText = function renderText(text) {
                    _textNode.nodeValue = text;
                    _lightBox.setAttribute('title', text);
                };
                const renderStage = function renderStage() {
                    if (renderStageDelayedAction) {
                        clearTimeout(renderStageDelayedAction);
                        renderStageDelayedAction = null;
                    }
                    if (_archiving) OTHelpers.addClass(_light, 'OT_active');
                    else OTHelpers.removeClass(_light, 'OT_active');
                    OTHelpers.removeClass(self1.domElement, `OT_archiving-${!_archiving ? 'on' : 'off'}`);
                    OTHelpers.addClass(self1.domElement, `OT_archiving-${_archiving ? 'on' : 'off'}`);
                    if (options.show && _archiving) {
                        renderText(_archivingStarted);
                        OTHelpers.addClass(_text, 'OT_mode-on');
                        OTHelpers.removeClass(_text, 'OT_mode-auto');
                        self1.setDisplayMode('on');
                        renderStageDelayedAction = setTimeout(()=>{
                            OTHelpers.addClass(_text, 'OT_mode-auto');
                            OTHelpers.removeClass(_text, 'OT_mode-on');
                        }, 5000);
                    } else if (options.show && !_initialState) {
                        OTHelpers.addClass(_text, 'OT_mode-on');
                        OTHelpers.removeClass(_text, 'OT_mode-auto');
                        self1.setDisplayMode('on');
                        renderText(_archivingEnded);
                        renderStageDelayedAction = setTimeout(()=>{
                            self1.setDisplayMode('off');
                        }, 5000);
                    } else self1.setDisplayMode('off');
                }; // Mixin common widget behaviour
                Widget(this, {
                    mode: _archiving && options.show && 'on' || 'off',
                    nodeName: 'h1',
                    htmlAttributes: {
                        className: 'OT_archiving OT_edge-bar-item OT_edge-bottom'
                    },
                    onCreate () {
                        _lightBox = OTHelpers.createElement('div', {
                            className: 'OT_archiving-light-box'
                        }, '');
                        _light = OTHelpers.createElement('div', {
                            className: 'OT_archiving-light'
                        }, '');
                        _lightBox.appendChild(_light);
                        _text = OTHelpers.createElement('div', {
                            className: 'OT_archiving-status OT_mode-on OT_edge-bar-item OT_edge-bottom'
                        }, '');
                        _textNode = document.createTextNode('');
                        _text.appendChild(_textNode);
                        self1.domElement.appendChild(_lightBox);
                        self1.domElement.appendChild(_text);
                        renderStage();
                    }
                });
                this.setShowArchiveStatus = function(show) {
                    options.show = show;
                    if (self1.domElement) renderStage.call(self1);
                };
                this.setArchiving = function(status) {
                    _archiving = status;
                    _initialState = false;
                    if (self1.domElement) renderStage.call(self1);
                };
            };
        /***/ },
        /* 637 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const windowMock = deps.global || window;
                return ()=>windowMock.navigator && windowMock.navigator.mediaDevices;
            };
        /***/ },
        /* 638 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, global-require, one-var, prefer-const */ /* eslint-disable no-restricted-syntax, no-prototype-builtins, no-continue */ const assign = __webpack_require__(9);
                const isObject = __webpack_require__(11);
                const promiseDelay = __webpack_require__(106);
                const trackUsage = __webpack_require__(639);
                const AnalyticsHelper = __webpack_require__(26);
                const OTErrorClass = __webpack_require__(22);
                const eventing = __webpack_require__(7);
                module1.exports = function getUserMediaFactory(deps) {
                    if (deps === void 0) deps = {};
                    const env = deps.env || __webpack_require__(3);
                    const Errors = deps.Errors || __webpack_require__(6);
                    const otError = deps.otError || __webpack_require__(13)();
                    const logging = deps.logging || __webpack_require__(2)('getUserMedia');
                    const screenSharing = deps.screenSharing || __webpack_require__(161)();
                    const getDisplayMediaExtensionHelper = deps.getDisplayMediaExtensionHelper || __webpack_require__(288);
                    const customGetUserMedia = deps.customGetUserMedia;
                    const windowMock = deps.global || window;
                    /** @type {AnalyticsHelper} */ const analytics = deps.analytics || new AnalyticsHelper();
                    const navigator1 = windowMock.navigator, location1 = windowMock.location;
                    const getGetUserMediaFn = ()=>{
                        if (customGetUserMedia) return customGetUserMedia;
                        if (navigator1.mediaDevices) {
                            var _context;
                            return (_context = navigator1.mediaDevices).getUserMedia.bind(_context);
                        }
                        return undefined;
                    };
                    const getUserMedia = function getUserMedia() {
                        const getUserMediaFn = getGetUserMediaFn();
                        if (getUserMediaFn) return getUserMediaFn(...arguments);
                        return Promise.reject(new Error('Cannot find getUserMedia'));
                    };
                    const getGetDisplayMediaFn = ()=>{
                        if (customGetUserMedia) return customGetUserMedia;
                        if (navigator1.mediaDevices && navigator1.getDisplayMedia) return navigator1.getDisplayMedia.bind(navigator1);
                        if (navigator1.mediaDevices && navigator1.mediaDevices.getDisplayMedia) {
                            var _context2;
                            return (_context2 = navigator1.mediaDevices).getDisplayMedia.bind(_context2);
                        }
                        return undefined;
                    };
                    const getDisplayMedia = function getDisplayMedia() {
                        const getDisplayMediaFn = getGetDisplayMediaFn();
                        if (getDisplayMediaFn) return getDisplayMediaFn(...arguments);
                        return Promise.reject(new Error('Cannot find getDisplayMedia'));
                    };
                    const vendorToOTErrorDetails = (()=>{
                        const userMediaAccessDenied = {
                            name: Errors.USER_MEDIA_ACCESS_DENIED,
                            message: 'End-user denied permission to hardware devices'
                        };
                        const notSupported = {
                            name: Errors.NOT_SUPPORTED,
                            message: 'A constraint specified is not supported by the browser.'
                        };
                        const constraintsNotSatisfied = {
                            name: Errors.CONSTRAINTS_NOT_SATISFIED,
                            message: "It's not possible to satisfy one or more constraints passed into the getUserMedia function"
                        };
                        const noDevicesFound = {
                            name: Errors.NO_DEVICES_FOUND,
                            message: 'No voice or video input devices are available on this machine.'
                        };
                        const hardwareUnavailable = {
                            name: Errors.HARDWARE_UNAVAILABLE,
                            message: "The selected voice or video devices are unavailable. Verify that the chosen devices are not in use by another application."
                        };
                        const screenCaptureError = {
                            name: Errors.UNABLE_TO_CAPTURE_SCREEN,
                            message: 'Unable to capture screen. Unknown error occurred'
                        };
                        const abortError = {
                            name: Errors.UNABLE_TO_CAPTURE_MEDIA,
                            message: 'Unable to capture media. Unknown error occurred'
                        }; // Mozilla error strings and the equivalent W3C names. NOT_SUPPORTED_ERROR does not
                        // exist in the spec right now, so we'll include Mozilla's error description.
                        // Chrome TrackStartError is triggered when the camera is already used by another app (Windows)
                        const errorMap = {
                            // Spec:
                            AbortError: abortError,
                            NotAllowedError: userMediaAccessDenied,
                            NotFoundError: noDevicesFound,
                            NotReadableError: hardwareUnavailable,
                            OverconstrainedError: constraintsNotSatisfied,
                            SecurityError: assign({}, userMediaAccessDenied, {
                                message: "End-user denied permission to hardware devices or user media support may be disabled on this page"
                            }),
                            TypeError: constraintsNotSatisfied,
                            // Old errors, probably not used anymore. @todo log usage to be removed.
                            PermissionDeniedError: userMediaAccessDenied,
                            PermissionDismissedError: userMediaAccessDenied,
                            NotSupportedError: notSupported,
                            ConstraintNotSatisfiedError: constraintsNotSatisfied,
                            MandatoryUnsatisfiedError: constraintsNotSatisfied,
                            OverConstrainedError: constraintsNotSatisfied,
                            DevicesNotFoundError: noDevicesFound,
                            NoDevicesFoundError: noDevicesFound,
                            HardwareUnavailableError: hardwareUnavailable,
                            SourceUnavailableError: hardwareUnavailable,
                            TrackStartError: hardwareUnavailable,
                            ScreenCaptureError: screenCaptureError,
                            TabCaptureError: screenCaptureError
                        }; // track usage of the following keys so we know if they are still being used
                        // and by which browsers/ operating systems.
                        trackUsage({
                            objectToTrack: errorMap,
                            keys: [
                                'PermissionDeniedError',
                                'PermissionDismissedError',
                                'NotSupportedError',
                                'ConstraintNotSatisfiedError',
                                'MandatoryUnsatisfiedError',
                                'OverConstrainedError',
                                'DevicesNotFoundError',
                                'NoDevicesFoundError',
                                'HardwareUnavailableError',
                                'SourceUnavailableError',
                                'TrackStartError',
                                'ScreenCaptureError',
                                'TabCaptureError'
                            ],
                            onUsage (key) {
                                analytics.logEvent({
                                    action: 'DeprecatedPropertyUsage:getUserMedia:errorMap',
                                    variation: 'Event',
                                    payload: {
                                        key: key
                                    }
                                });
                            }
                        });
                        return errorMap;
                    })(); // Map vendor error strings to errors we emit
                    const errorFromVendorNameAndMessage = (vendorErrorName, message)=>{
                        let name = vendorErrorName;
                        if (name === 'AbortError' && typeof message === 'string' && message.match(/(screen|tab).?capture/i)) name = 'ScreenCaptureError';
                        const otErrorDetails = vendorToOTErrorDetails[name];
                        let error;
                        if (otErrorDetails) error = otError(otErrorDetails.name, new Error(`${otErrorDetails.message} (getUserMedia error: ${vendorErrorName})`));
                        else error = new Error(`Unknown error while getting user media: ${vendorErrorName}`);
                        error.originalMessage = message;
                        error.originalName = vendorErrorName;
                        return error;
                    }; // Parse and normalise a getUserMedia error event from Chrome or Mozilla
                    // @ref http://dev.w3.org/2011/webrtc/editor/getusermedia.html#idl-def-NavigatorUserMediaError
                    const parseErrorEvent = (event)=>{
                        if (isObject(event) && event.name) {
                            let name = event.name, message = event.message;
                            if (message === 'Cannot find getUserMedia' || message === 'Cannot find getDisplayMedia') {
                                if (env.name === 'Chrome' && env.version > 73 && windowMock.location.protocol !== 'https:') name = 'NotAllowedError';
                                else name = 'NotSupportedError';
                            } // Errors in Safari have incorrect name property
                            // See https://bugs.webkit.org/show_bug.cgi?id=180777
                            if (env.name === 'Safari' && name === 'Error') {
                                const protoName = Object.prototype.toString.call(event);
                                const matches = protoName.match(/^\[object (\w+Error)\]$/);
                                if (matches) name = matches[1];
                            }
                            const error = errorFromVendorNameAndMessage(name, message);
                            error.constraintName = event.constraint || event.constraintName;
                            if (!(error instanceof OTErrorClass)) analytics.logEvent({
                                action: 'UnexpectedError:getUserMedia:parseErrorEvent',
                                variation: 'Event',
                                payload: {
                                    name: error.name,
                                    message: error.message,
                                    originalMessage: error.originalMessage
                                }
                            });
                            return error;
                        }
                        if (typeof event === 'string') {
                            const error = errorFromVendorNameAndMessage(event);
                            analytics.logEvent({
                                action: 'CheckUnreachable:getUserMedia:parseErrorEvent',
                                variation: 'Event',
                                payload: {
                                    info: 'error is string',
                                    error: event
                                }
                            });
                            return error;
                        }
                        analytics.logEvent({
                            action: 'CheckUnreachable:getUserMedia:parseErrorEvent',
                            variation: 'Event',
                            payload: {
                                info: 'error was not string or object with name property',
                                error: event
                            }
                        });
                        return new Error('Unknown error type while getting media');
                    }; // Validates a Hash of getUserMedia constraints. Currently we only
                    // check to see if there is at least one non-false constraint.
                    const areInvalidConstraints = function areInvalidConstraints(constraints) {
                        if (!constraints || !isObject(constraints)) return true;
                        for(const key in constraints){
                            if (!constraints.hasOwnProperty(key)) continue;
                            if (constraints[key]) return false;
                        }
                        return true;
                    }; // A wrapper for the builtin navigator.getUserMedia. In addition to the usual
                    // getUserMedia behaviour, this helper method also accepts a accessDialogOpened
                    // and accessDialogClosed callback.
                    //
                    // @memberof OTHelpers
                    // @private
                    //
                    // @param {Object} constraints
                    //      A dictionary of constraints to pass to getUserMedia. See
                    //      http://dev.w3.org/2011/webrtc/editor/getusermedia.html#idl-def-MediaStreamConstraints
                    //      in the Media Capture and Streams spec for more info.
                    //
                    // @param {function} success
                    //      Called when getUserMedia completes successfully. The callback will be passed a WebRTC
                    //      Stream object.
                    //
                    // @param {function} failure
                    //      Called when getUserMedia fails to access a user stream. It will be passed an object
                    //      with a code property representing the error that occurred.
                    //
                    // @param {function} accessDialogOpened
                    //      Called when the access allow/deny dialog is opened.
                    //
                    // @param {function} accessDialogClosed
                    //      Called when the access allow/deny dialog is closed.
                    //
                    // @param {function} accessDenied
                    //      Called when access is denied to the camera/mic. This will be either because
                    //      the user has clicked deny or because a particular origin is permanently denied.
                    //
                    return function(constraints, isScreenSharing) {
                        if (isScreenSharing === void 0) isScreenSharing = false;
                        logging.debug('getUserMedia wrapper called with', constraints);
                        if (areInvalidConstraints(constraints)) {
                            // All constraints are false, we don't allow this. This may be valid later
                            // depending on how/if we integrate data channels.
                            logging.error('Couldn\'t get UserMedia: All constraints were false');
                            return eventing(Promise.reject(otError(Errors.NO_VALID_CONSTRAINTS, new Error('Video and Audio was disabled, you need to enable at least one'))));
                        }
                        const getMedia = isScreenSharing && getDisplayMediaExtensionHelper.isSupportedInThisBrowser ? getDisplayMedia : getUserMedia;
                        const throttledRequest = eventing(getMedia(constraints).catch((browserError)=>{
                            // This also restores bluebird's ability to check we handle the error since we ignored
                            // it when creating `finalized` above.
                            const error = parseErrorEvent(browserError);
                            if (error.name === Errors.UNABLE_TO_CAPTURE_SCREEN) return new Promise((resolve, reject)=>{
                                screenSharing.checkCapability((response)=>{
                                    if (response.extensionRequired === 'chrome') {
                                        if (response.extensionRegistered && !response.extensionInstalled) {
                                            const newErr = otError(Errors.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, error);
                                            newErr.message = 'Screen sharing extension not installed see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension';
                                            reject(newErr);
                                        } else if (!response.extensionRegistered) {
                                            const newErr = otError(Errors.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, error);
                                            newErr.message = 'Screen sharing extension not registered see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension';
                                            reject(newErr);
                                        }
                                    } else reject(error);
                                });
                            });
                            throw error;
                        }).then((stream)=>{
                            logging.debug('got stream:', {
                                stream: stream,
                                tracks: stream.getTracks(),
                                trackLabels: stream.getTracks().map((track)=>track.label)
                            });
                            return stream;
                        })); // The 'remember me' functionality of WebRTC only functions over HTTPS, if
                        // we aren't on HTTPS then we should definitely be displaying the access
                        // dialog.
                        //
                        // If we are on HTTPS, we'll wait 500ms to see if we get a stream
                        // immediately. If we do then the user had clicked 'remember me'. Otherwise
                        // we assume that the accessAllowed dialog is visible.
                        //
                        // Otherwise, we still wait 100ms to give the client a chance to bind to the
                        // event.
                        //
                        // @todo benchmark and see if 500ms is a reasonable number. It seems like
                        // we should know a lot quicker.
                        //
                        const dialogOpenedDelay = location1.protocol.indexOf('https') !== -1 ? 500 : 100;
                        let waitingForStream = true;
                        const setWaitingForStreamFalse = ()=>{
                            waitingForStream = false;
                        };
                        throttledRequest.then(setWaitingForStreamFalse, setWaitingForStreamFalse);
                        promiseDelay(dialogOpenedDelay).then(()=>{
                            if (!waitingForStream) return;
                            const closeDialog = ()=>{
                                throttledRequest.emit('accessDialogClosed');
                            };
                            throttledRequest.emit('accessDialogOpened');
                            throttledRequest.then(closeDialog, closeDialog);
                        });
                        return throttledRequest;
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 639 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, objectToTrack = _ref.objectToTrack, keys = _ref.keys, onUsage = _ref.onUsage;
                if (!Array.isArray(keys) && keys !== undefined) throw new Error('keys must be an array, or undefined');
                if (typeof onUsage !== 'function') throw new Error('onUsage must be a function');
                if (objectToTrack == null) throw new Error('Expected objectToTrack to be a trackable object');
                Object.keys(objectToTrack).forEach((key)=>{
                    if (keys !== undefined && keys.indexOf(key) === -1) return;
                    let value = objectToTrack[key];
                    Object.defineProperty(objectToTrack, key, {
                        get () {
                            onUsage(key);
                            return value;
                        },
                        set (newValue) {
                            value = newValue;
                            onUsage(key, value);
                        },
                        enumerable: true
                    });
                });
            };
        /***/ },
        /* 640 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const _require = __webpack_require__(641), isCallbackBasedAPI = _require.isCallbackBasedAPI;
            let isElectronScreenSharingSource = __webpack_require__(265);
            let desktopCapturer = null; // Legacy versions of Electron have a callback-based method
            const getSourcesUsingCallback = (opts, callback)=>{
                desktopCapturer.getSources(opts, callback);
            }; // More recent versions of Electron has a promise-based method
            const getSourcesUsingPromise = (opts, callback)=>{
                desktopCapturer.getSources(opts).then((sources)=>{
                    callback(undefined, sources);
                }, callback);
            };
            const getSourcesAdapter = ()=>isCallbackBasedAPI ? getSourcesUsingCallback : getSourcesUsingPromise;
            const getSourcesWrapper = (source, callback)=>{
                const getSources = getSourcesAdapter();
                getSources({
                    types: [
                        source
                    ]
                }, (error, sources)=>{
                    if (error) {
                        callback(error);
                        return;
                    } // For now just pick the first source. In future we need to implement a selection
                    // dialog.
                    const foundSource = sources[0];
                    if (!foundSource) {
                        callback(new Error('Could not find Electron source for screensharing'));
                        return;
                    }
                    const constraints = {
                        audio: false,
                        video: {
                            mandatory: {
                                chromeMediaSource: source,
                                chromeMediaSourceId: foundSource.id
                            }
                        }
                    };
                    callback(undefined, constraints);
                });
            };
            module1.exports = function electronExtensionHelperFactory(deps) {
                if (deps === void 0) deps = {};
                try {
                    // Using a dynamic require here because that's the way we get desktopCapturer in electron, and
                    // that's not something to bundle in.
                    // We are requiring electron here to see if it's available, it's intentionally not packaged
                    // and not listed in the package.json for this repository. It is expected to be found only if
                    // we are running inside an Electron application.
                    const globalContext = ()=>{
                        // We need to search for the require function either in the current
                        // global or, if its a window, one of its parents. This is necessary
                        // in case OT is used from within an iframe (like our integration
                        // tests).
                        let current = window;
                        while(typeof current.require !== 'function' && current.parent && current.parent !== current)current = current.parent;
                        return current;
                    };
                    const getDesktopCapturer = ()=>{
                        const current = globalContext(); // In case the option 'contextIsolation' is true, the require function will be undefined,
                        // so we'll expect the desktopCapturer to be exposed in window.electron.desktopCapturer by
                        // the app layer within a preload file.
                        // See https://www.electronjs.org/docs/tutorial/context-isolation
                        const electron = current.require ? current.require('electron') : current.electron;
                        return electron.desktopCapturer;
                    };
                    desktopCapturer = deps.desktopCapturer || // dispatch an error message if `electron` is not found
                    (env.isElectron ? getDesktopCapturer() : null);
                    isElectronScreenSharingSource = deps.isElectronScreenSharingSource || isElectronScreenSharingSource;
                } catch (e) {}
                return {
                    isSupportedInThisBrowser: desktopCapturer !== null,
                    autoRegisters: true,
                    extensionRequired: false,
                    getConstraintsShowsPermissionUI: false,
                    sources: {
                        screen: true,
                        application: true,
                        window: true,
                        browser: true
                    },
                    register: ()=>({
                            isInstalled: (callback)=>callback(true),
                            getConstraints (source, constraints, callback) {
                                if (isElectronScreenSharingSource(source)) // User passed in a custom screen sharing source, so no need to call
                                // "getSources" (cause we already have one).
                                callback(undefined, {
                                    audio: true,
                                    video: false
                                });
                                else getSourcesWrapper(source, callback);
                            }
                        })
                };
            };
        /***/ },
        /* 641 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3); // Callback-based API was removed in ElectronJS 7, which corresponds to
            // Chrome 78
            const isCallbackBasedAPI = env.version < 78;
            const isPromiseBasedAPI = !isCallbackBasedAPI;
            module1.exports = {
                isCallbackBasedAPI: isCallbackBasedAPI,
                isPromiseBasedAPI: isPromiseBasedAPI
            };
        /***/ },
        /* 642 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, no-void */ const env = __webpack_require__(3);
            const haveGetDisplayMedia = __webpack_require__(159).default;
            const isSupportedInThisBrowser = ()=>{
                const isFirefox = env.isFirefox;
                if (!isFirefox) return false;
                 // Don't use plugin if getDisplayMedia is supported
                return !haveGetDisplayMedia;
            };
            module1.exports = {
                isSupportedInThisBrowser: isSupportedInThisBrowser(),
                autoRegisters: true,
                extensionRequired: false,
                extensionInstalled: false,
                getConstraintsShowsPermissionUI: false,
                sources: {
                    screen: true,
                    application: false,
                    window: true,
                    browser: false
                },
                register () {
                    return {
                        isInstalled (callback) {
                            // The extension sets window.OTScreenSharing in pages loaded from a matching domain
                            callback(typeof OTScreenSharing === 'object');
                        },
                        getConstraints (source, constraints, callback) {
                            constraints.video = {
                                mediaSource: source
                            }; // copy constraints under the video object and removed them from the root constraint object
                            if (constraints.browserWindow) {
                                constraints.video.browserWindow = constraints.browserWindow;
                                delete constraints.browserWindow;
                            }
                            if (typeof constraints.scrollWithPage !== 'undefined') {
                                constraints.video.scrollWithPage = constraints.scrollWithPage;
                                delete constraints.scrollWithPage;
                            }
                            callback(void 0, constraints);
                        }
                    };
                }
            };
        /***/ },
        /* 643 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            const _require = __webpack_require__(644), normaliseOptions = _require.normaliseOptions;
            const _require2 = __webpack_require__(289), isMediaStreamTrack = _require2.isMediaStreamTrack;
            /* eslint-disable global-require */ const assert = __webpack_require__(147);
            const assign = __webpack_require__(9);
            const defaults = __webpack_require__(140);
            const promiseEndeavour = __webpack_require__(290).default;
            const Errors = __webpack_require__(6);
            const pick = __webpack_require__(48);
            const otError = __webpack_require__(13)();
            const _require3 = __webpack_require__(291), isValidVideoContentHint = _require3.isValidVideoContentHint;
            const eventing = __webpack_require__(7);
            const isScreenSharingSource = __webpack_require__(148);
            const defaultEnv = __webpack_require__(3);
            const hasAudioScreenSharingSupport = __webpack_require__(264);
            const GET_USER_ABORT_ERROR_MSG = 'getUserMedia request was aborted';
            module1.exports = function processPubOptionsFactory(deps) {
                if (deps === void 0) deps = {};
                [
                    'deviceHelpers',
                    'getUserMediaHelper'
                ].forEach((key)=>{
                    assert(deps[key], `${key} dependency must be injected into processPubOptions`);
                });
                const generateConstraintInfo = deps.generateConstraintInfo || __webpack_require__(254);
                const windowMock = deps.global || window;
                const logging = deps.logging || __webpack_require__(2)('processPubOptions');
                const navigator1 = deps.navigator || windowMock.navigator;
                const screenSharing = deps.screenSharing || __webpack_require__(161)();
                const env = deps.env || defaultEnv;
                const usingOptionalMandatoryStyle = __webpack_require__(645)({
                    navigator: navigator1 || {}
                });
                const _deps = deps, deviceHelpers = _deps.deviceHelpers, getUserMediaHelper = _deps.getUserMediaHelper;
                return (originalOptions, logPrefix, shouldStop)=>{
                    const options = normaliseOptions(originalOptions, logPrefix, logging);
                    const isScreenSharing = isScreenSharingSource(options.videoSource);
                    const isCustomAudioTrack = isMediaStreamTrack(options.audioSource);
                    const isCustomVideoTrack = isMediaStreamTrack(options.videoSource); // getUserMedia is required if either audio or video is: a) not custom and b) not disabled
                    const isAudioGumRequired = !isCustomAudioTrack && options.audioSource !== null;
                    const isVideoGumRequired = !isCustomVideoTrack && options.videoSource !== null;
                    const isGumRequired = isAudioGumRequired || isVideoGumRequired;
                    const isBoolean = (property)=>typeof property === 'boolean'; // We display audio level and allow audio fallback if we're not screensharing
                    // or if we're screensharing but with a custom audio track or if we support audio
                    // screensharing on the current browser
                    // @todo shouldn't this take into consideration if we have audio as well?
                    const shouldAllowAudio = !isScreenSharing || isCustomAudioTrack || hasAudioScreenSharingSupport;
                    const properties = defaults(options, {
                        mirror: !isScreenSharing && !isCustomVideoTrack,
                        publishAudio: true,
                        publishVideo: true,
                        showControls: true,
                        fitMode: isScreenSharing ? 'contain' : 'cover',
                        audioFallbackEnabled: shouldAllowAudio,
                        insertDefaultUI: true,
                        enableRenegotiation: false,
                        enableStereo: false,
                        enableDtx: false,
                        disableAudioProcessing: false,
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true
                    });
                    if (properties.videoContentHint !== undefined && !isValidVideoContentHint(properties.videoContentHint)) {
                        logging.warn(`${logPrefix}: Invalid content hint. Valid content hints are "text", "detail", "motion", or ""`);
                        properties.videoContentHint = '';
                    }
                    if (properties.name) properties.name = String(properties.name);
                    if (!isBoolean(properties.enableDtx)) properties.enableDtx = false;
                    if (!isBoolean(properties.enableStereo)) properties.enableStereo = false;
                    if (!properties.constraints) {
                        const constraintInfo = generateConstraintInfo((0, _extends2.default)({
                            isScreenSharing: isScreenSharing,
                            isCustomAudioTrack: isCustomAudioTrack,
                            isCustomVideoTrack: isCustomVideoTrack
                        }, pick(properties, [
                            'audioSource',
                            'publishAudio',
                            'videoSource',
                            'publishVideo',
                            'resolution',
                            'maxResolution',
                            'frameRate',
                            'facingMode',
                            'enableRenegotiation',
                            'enableStereo',
                            'disableAudioProcessing',
                            'echoCancellation',
                            'noiseSuppression',
                            'autoGainControl'
                        ]), {
                            env: env,
                            usingOptionalMandatoryStyle: usingOptionalMandatoryStyle(isScreenSharing)
                        }));
                        assign(properties, constraintInfo);
                    } else logging.warn(`${logPrefix}: You have passed your own constraints not using ours`);
                    const processedOptions = {
                        isScreenSharing: isScreenSharing,
                        isCustomAudioTrack: isCustomAudioTrack,
                        isCustomVideoTrack: isCustomVideoTrack,
                        shouldAllowAudio: shouldAllowAudio,
                        properties: properties
                    };
                    eventing(processedOptions);
                    processedOptions.getUserMedia = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                        var onAccessDialogOpened, onAccessDialogClosed, stream, devices, constraints, IOS_NEW_WINDOW_BUG, IOS_NOT_READABLE_ERROR_BUG, isNotReadableError, tryGetUserMedia;
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    onAccessDialogOpened = function onAccessDialogOpened() {
                                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                        return processedOptions.emit('accessDialogOpened', ...args);
                                    };
                                    onAccessDialogClosed = function onAccessDialogClosed() {
                                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                                        return processedOptions.emit('accessDialogClosed', ...args);
                                    };
                                    if (isGumRequired) {
                                        _context2.next = 7;
                                        break;
                                    }
                                    stream = new windowMock.MediaStream();
                                    if (isCustomAudioTrack) stream.addTrack(options.audioSource);
                                    if (isCustomVideoTrack) stream.addTrack(options.videoSource);
                                    return _context2.abrupt("return", stream);
                                case 7:
                                    if (!isScreenSharing) {
                                        _context2.next = 15;
                                        break;
                                    }
                                    _context2.next = 10;
                                    return screenSharing.getConstraints({
                                        onAccessDialogOpened: onAccessDialogOpened,
                                        onAccessDialogClosed: onAccessDialogClosed,
                                        videoSource: options.videoSource,
                                        constraints: properties.constraints
                                    });
                                case 10:
                                    properties.constraints = _context2.sent;
                                    if (!shouldStop()) {
                                        _context2.next = 13;
                                        break;
                                    }
                                    throw otError(Errors.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
                                case 13:
                                    _context2.next = 25;
                                    break;
                                case 15:
                                    _context2.next = 17;
                                    return deviceHelpers.shouldAskForDevices();
                                case 17:
                                    devices = _context2.sent;
                                    if (!shouldStop()) {
                                        _context2.next = 20;
                                        break;
                                    }
                                    throw otError(Errors.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
                                case 20:
                                    logging.debug(`${logPrefix}: shouldAskForDevices:`, devices);
                                    if (!devices.video) {
                                        logging.warn(`${logPrefix}: Setting video constraint to false, there are no video sources`);
                                        properties.constraints.video = false;
                                    }
                                    if (!devices.audio) {
                                        logging.warn(`${logPrefix}: Setting audio constraint to false, there are no audio sources`);
                                        properties.constraints.audio = false;
                                    } // @todo this side effect needs to go...
                                    processedOptions.videoDevices = devices.videoDevices;
                                    processedOptions.audioDevices = devices.audioDevices;
                                case 25:
                                    constraints = properties.constraints;
                                    logging.debug(`${logPrefix}: onConstraintsFound`, constraints);
                                    if (!shouldStop()) {
                                        _context2.next = 29;
                                        break;
                                    }
                                    throw otError(Errors.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
                                case 29:
                                    IOS_NEW_WINDOW_BUG = "Failed to acquire functional stream, this might be caused by the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=188088";
                                    IOS_NOT_READABLE_ERROR_BUG = "Failed to acquire functional stream, this might be caused by the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=204106";
                                    isNotReadableError = (err)=>err.originalName === 'NotReadableError' && err.originalMessage === 'Failed starting capture of a video track';
                                    tryGetUserMedia = /*#__PURE__*/ function() {
                                        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                                            var gumRequest, stream, error, gumAudioRequest, audioStream;
                                            return _regenerator.default.wrap(function _callee$(_context) {
                                                while(true)switch(_context.prev = _context.next){
                                                    case 0:
                                                        gumRequest = getUserMediaHelper(constraints, isScreenSharing);
                                                        gumRequest.on('accessDialogOpened', onAccessDialogOpened);
                                                        gumRequest.on('accessDialogClosed', onAccessDialogClosed);
                                                        _context.prev = 3;
                                                        _context.next = 6;
                                                        return gumRequest;
                                                    case 6:
                                                        stream = _context.sent;
                                                        if (!(env.isiOS && properties.publishVideo && stream.getVideoTracks().length && stream.getVideoTracks()[0].readyState === 'ended')) {
                                                            _context.next = 11;
                                                            break;
                                                        }
                                                        stream.getTracks().forEach((track)=>track.stop());
                                                        error = new Error(IOS_NEW_WINDOW_BUG);
                                                        throw error;
                                                    case 11:
                                                        return _context.abrupt("return", stream);
                                                    case 14:
                                                        _context.prev = 14;
                                                        _context.t0 = _context["catch"](3);
                                                        if (!env.isiOS) {
                                                            _context.next = 34;
                                                            break;
                                                        }
                                                        if (!(isNotReadableError(_context.t0) && env.iOSVersion >= 13 && env.iOSVersion < 13.4)) {
                                                            _context.next = 32;
                                                            break;
                                                        }
                                                        _context.prev = 18;
                                                        // As a workaround, we stop the remaining audio track to dispose hardware resources.
                                                        // Then promiseEndeavour will retry to invoke tryGetUserMedia.
                                                        // This bug might be related to https://bugs.webkit.org/show_bug.cgi?id=202405
                                                        gumAudioRequest = getUserMediaHelper({
                                                            audio: true,
                                                            video: false
                                                        }, false);
                                                        _context.next = 22;
                                                        return gumAudioRequest;
                                                    case 22:
                                                        audioStream = _context.sent;
                                                        audioStream.getTracks().forEach((track)=>track.stop());
                                                        _context.next = 29;
                                                        break;
                                                    case 26:
                                                        _context.prev = 26;
                                                        _context.t1 = _context["catch"](18);
                                                        logging.debug(`${logPrefix}: error disposing audio track`, _context.t1);
                                                    case 29:
                                                        throw new Error(IOS_NOT_READABLE_ERROR_BUG);
                                                    case 32:
                                                        if (!(_context.t0.name === Errors.HARDWARE_UNAVAILABLE)) {
                                                            _context.next = 34;
                                                            break;
                                                        }
                                                        throw new Error(IOS_NEW_WINDOW_BUG);
                                                    case 34:
                                                        throw _context.t0;
                                                    case 35:
                                                        _context.prev = 35;
                                                        // Wait a little bit before we clean up the event handlers
                                                        // to give 'accessDialogClosed' a chance to fire
                                                        setTimeout(()=>{
                                                            gumRequest.off('accessDialogOpened', onAccessDialogOpened);
                                                            gumRequest.off('accessDialogClosed', onAccessDialogClosed);
                                                        });
                                                        return _context.finish(35);
                                                    case 38:
                                                    case "end":
                                                        return _context.stop();
                                                }
                                            }, _callee, null, [
                                                [
                                                    3,
                                                    14,
                                                    35,
                                                    38
                                                ],
                                                [
                                                    18,
                                                    26
                                                ]
                                            ]);
                                        }));
                                        return function tryGetUserMedia() {
                                            return _ref2.apply(this, arguments);
                                        };
                                    }();
                                    _context2.next = 35;
                                    return promiseEndeavour(tryGetUserMedia, (err, attempt)=>{
                                        const errors = [
                                            // https://jira.vonage.com/browse/OPENTOK-37691
                                            // https://bugs.webkit.org/show_bug.cgi?id=188088
                                            // Fixed 4th Dec 2018 - unsure which Safari versions are fixed
                                            IOS_NEW_WINDOW_BUG,
                                            IOS_NOT_READABLE_ERROR_BUG
                                        ];
                                        if (errors.includes(err.message) && attempt === 1 && !shouldStop()) return 1000;
                                        return false;
                                    })();
                                case 35:
                                    stream = _context2.sent;
                                    if (!shouldStop()) {
                                        _context2.next = 39;
                                        break;
                                    }
                                    stream.getTracks().forEach((track)=>{
                                        track.stop();
                                    });
                                    throw otError(Errors.CANCEL, new Error(GET_USER_ABORT_ERROR_MSG));
                                case 39:
                                    if (isCustomAudioTrack) stream.addTrack(options.audioSource);
                                    if (isCustomVideoTrack) stream.addTrack(options.videoSource);
                                    return _context2.abrupt("return", stream);
                                case 42:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    }));
                    return processedOptions;
                };
            };
        /***/ },
        /* 644 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(289), isMediaStreamTrack = _require.isMediaStreamTrack;
            const clone = __webpack_require__(38);
            const env = __webpack_require__(3);
            const normaliseOptions = (originalOptions, logPrefix, logging)=>{
                const options = originalOptions && typeof originalOptions === 'object' ? clone(originalOptions) : {};
                if (options.audioSource === false) options.audioSource = null;
                if (options.videoSource === false) options.videoSource = null;
                 // Ignore minVideoBitrate if it's defined but not a positive number
                if (options.minVideoBitrate !== undefined && !(typeof options.minVideoBitrate === 'number' && options.minVideoBitrate > 0)) {
                    logging.warn(`${logPrefix}: Invalid minVideoBitrate in publisher properties. minVideoBitrate must ` + 'be a positive number');
                    delete options.minVideoBitrate;
                } // Ignore audioBitrate if it's defined but not between 6kb and 510kb
                if (options.audioBitrate !== undefined && !(options.audioBitrate >= 6000 && options.audioBitrate <= 510000)) {
                    logging.warn(`${logPrefix}: Invalid audioBitrate in publisher properties. audioBitrate must ` + `be a number between ${6000} and ${510000} bits per second`);
                    delete options.audioBitrate;
                } // Crashes in FF45-46 and fails to publish in FF47-48
                if (env.name === 'Firefox' && env.version < 49) {
                    const label = 'Firefox 48 and below';
                    if (isMediaStreamTrack(options.audioSource)) {
                        options.audioSource = null;
                        logging.warn(`${logPrefix}: Cannot use custom tracks with ${label}. Setting audioSource to null`);
                    }
                    if (isMediaStreamTrack(options.videoSource)) {
                        options.videoSource = null;
                        logging.warn(`${logPrefix}: Cannot use custom tracks with ${label}. Setting videoSource to null`);
                    }
                }
                return options;
            };
            exports.normaliseOptions = normaliseOptions;
        /***/ },
        /* 645 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(3), name = _require.name, version = _require.version;
            const browserRejectsOptionalMandatory = __webpack_require__(258);
            module1.exports = function usingOptionalMandatoryStyleFactory(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$navigator = _ref.navigator, navigator1 = _ref$navigator === void 0 ? window.navigator : _ref$navigator;
                return function usingOptionalMandatoryStyle(isScreenSharing) {
                    return(// see https://bugzilla.mozilla.org/show_bug.cgi?id=1321221 for firefox getDisplayMedia
                    // see https://w3c.github.io/mediacapture-screen-share/#displaymediastreamconstraints for updated getDisplayMedia
                    // see https://blog.addpipe.com/standards-compliant-screen-capture-in-chrome-72/ chrome constraint info
                    isScreenSharing && !browserRejectsOptionalMandatory || // Internet Explorer
                    !(navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) || // Chrome <=60 doesn't accept ideal constraints and advanced
                    // constraints are ignored by Firefox and broken by adapter.js
                    // so we revert to optional/mandatory style. This has been
                    // updated in Chrome 61.
                    // See OPENTOK-32149, OPENTOK-32129 and OPENTOK-32655
                    // Fixed in adapter.js: https://github.com/webrtc/adapter/issues/553
                    name === 'Chrome' && version < 61);
                };
            };
        /***/ },
        /* 646 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ module1.exports = function getUserMediaFactory(deps) {
                if (deps === void 0) deps = {};
                [
                    'processPubOptions'
                ].forEach((key)=>{
                    if (!deps[key]) throw new Error(`${key} dependency must be injected into OT.getUserMedia`);
                });
                const logging = deps.logging || __webpack_require__(2)('getUserMedia');
                const _deps = deps, processPubOptions = _deps.processPubOptions;
                /**
  * Gets a MediaStream object that uses a microphone and camera as the audio and video source.
  * This method returns a promise that is resolved when the user has granted permission to
  * use the camera or microphone (or both) and the MediaStream object is available. The
  * promise is rejected if there is an error in getting the media or if the end user denies
  * access to the camera or microphone.
  * <p>
  * You can use this method to get MediaStreamTrack objects to pass into the
  * <code>audioSource</code> and <code>videoSource</code> options of the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. For example, call this method
  * to get a MediaStream that uses the microphone and camera as the audio and video sources. Then
  * you can call <code>getVideoTracks()[0]</code> on the MediaStream object to get a video
  * MediaStreamTrack object for the camera's video. You can then add the video MediaStreamTrack
  * as a source for an HTML Video element, draw that Video element into an HTML Canvas element, and
  * apply video filters or effects to the Canvas. Then you can call the <code>captureStream()</code>
  * method of the HTMLCanvasElement object to get a MediaStream object and call
  * <code>getVideoTracks()[0]</code> on the MediaStream object to get a video MediaStreamTrack
  * object (with the video filters or effects applied). Finally, you can use the video
  * MediaStreamTrack object as the <code>videoSource</code> property of the options you pass
  * into <code>OT.initPublisher()</code>. The OpenTok Publisher will use the
  * video track (with the filters and effects applied) as the video source.
  * </p>
  *
  * @param {Object} options <p>(optional) Defines settings for the MediaStream object.
  * The options are the same as those defined for the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method. However, only the following
  * properties apply for <code>OT.getUserMedia()</code>:
  * </p>
  * <p>
  * <ul>
  *   <li><code>audioSource</code></li>
  *   <li><code>autoGainControl</code></li>
  *   <li><code>disableAudioProcessing</code></li>
  *   <li><code>echoCancellation</code></li>
  *   <li><code>enableStereo</code></li>
  *   <li><code>facingMode</code></li>
  *   <li><code>frameRate</code></li>
  *   <li><code>maxResolution</code></li>
  *   <li><code>noiseSuppression</code></li>
  *   <li><code>resolution</code></li>
  *   <li><code>videoSource</code></li>
  * </ul>
  * </p>
  *
  * @return {Promise} A promise that is resolved when the user has granted permission to
  * use the camera or microphone (or both) and the MediaStream object is available. The
  * promise is rejected if there is an error in getting the media, if the end user denies
  * access to the camera or microphone, or if the method is called on Internet Explorer.
  *
  * @see The options (especially <code>audioSource</code> and <code>videoSource</code>) of the
  * <a href="OT.html#initPublisher">OT.initPublisher()</a> method
  *
  * @method OT.getUserMedia
  * @memberof OT
  */ const getUserMedia = function getUserMedia(pubOptions) {
                    if (pubOptions === void 0) pubOptions = {};
                    const processedOptions = processPubOptions(pubOptions, 'OT.getUserMedia', ()=>false);
                    return processedOptions.getUserMedia().catch((err)=>{
                        logging.error(`OT.getUserMedia failed to getUserMedia: ${err}`);
                        throw err;
                    });
                };
                return getUserMedia;
            };
        /***/ },
        /* 647 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function destroyObj(name, obj) {
                const throwErr = (action, key)=>()=>{
                        throw new Error(`Cannot ${action} ${key}, ${name} is destroyed`);
                    };
                Object.keys(obj).forEach((key)=>{
                    if (typeof obj[key] === 'function') // eslint-disable-next-line no-param-reassign
                    obj[key] = throwErr('call', key);
                    else Object.defineProperty(obj, key, {
                        get: throwErr('get', key),
                        set: throwErr('set', key)
                    });
                });
            };
        /***/ },
        /* 648 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-underscore-dangle */ module1.exports = (el)=>{
                if ('srcObject' in el) return;
                const URL1 = window && window.URL;
                if ('srcObject' in window.HTMLMediaElement.prototype) return;
                 // Shim the srcObject property, once, when HTMLMediaElement is found.
                Object.defineProperty(el, 'srcObject', {
                    get () {
                        return this._srcObject;
                    },
                    set (stream) {
                        const self1 = this; // Use _srcObject as a private property for this shim
                        this._srcObject = stream;
                        if (this.src) URL1.revokeObjectURL(this.src);
                        if (!stream) {
                            this.src = '';
                            return undefined;
                        }
                        this.src = URL1.createObjectURL(stream); // We need to recreate the blob url when a track is added or
                        // removed. Doing it manually since we want to avoid a recursion.
                        stream.addEventListener('addtrack', ()=>{
                            if (self1.src) URL1.revokeObjectURL(self1.src);
                            self1.src = URL1.createObjectURL(stream);
                        });
                        stream.addEventListener('removetrack', ()=>{
                            if (self1.src) URL1.revokeObjectURL(self1.src);
                            self1.src = URL1.createObjectURL(stream);
                        });
                        return this._srcObject;
                    }
                });
            };
        /***/ },
        /* 649 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const isDomElement = (el)=>{
                if (!el || typeof el.getBoundingClientRect !== 'function') return false;
                return true;
            }; // Check if the element is partially in the ViewPort
            const isInViewPort = (el)=>{
                const rect = el.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const windowWidth = window.innerWidth || document.documentElement.clientWidth;
                const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
                const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
                return vertInView && horInView;
            }; // Check whether the element or its DOM parents are hidden
            // either by display='none' or visibility='hidden'
            const isVisible = (domElement)=>{
                const isVisibilityHidden = (el)=>{
                    if (el.style && el.style.visibility === 'hidden') return true;
                     // Check if parent has visibility=hidden
                    if (el.parentNode) return isVisibilityHidden(el.parentNode);
                    return false;
                };
                return domElement.offsetParent !== null && !isVisibilityHidden(domElement);
            };
            /** Returns whether the HTMLDomElement is visibe or not */ module1.exports = (domElement)=>isDomElement(domElement) && isInViewPort(domElement) && isVisible(domElement);
        /***/ },
        /* 650 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle, no-param-reassign */ const defineProperties = __webpack_require__(104);
            const OTHelpers = __webpack_require__(8);
            const VideoOrientationTransforms = {
                0: 'rotate(0deg)',
                270: 'rotate(90deg)',
                90: 'rotate(-90deg)',
                180: 'rotate(180deg)'
            }; // A mixin to create the orientation API implementation on +self+
            // +getDomElementCallback+ is a function that the mixin will call when it wants to
            // get the native Dom element for +self+.
            //
            // +initialOrientation+ sets the initial orientation (shockingly), it's currently unused
            // so the initial value is actually undefined.
            //
            module1.exports = function canBeOrientatedMixin(self1, getDomElementCallback, initialOrientation) {
                let _orientation = initialOrientation;
                defineProperties(self1, {
                    isRotated: {
                        get () {
                            return this.orientation() && (this.orientation().videoOrientation === 270 || this.orientation().videoOrientation === 90);
                        }
                    },
                    // @todo I don't think we need vendor prefixes at all anymore.
                    orientation: {
                        get () {
                            return _orientation;
                        },
                        set (orientation) {
                            _orientation = orientation;
                            const transform = VideoOrientationTransforms[orientation.videoOrientation] || VideoOrientationTransforms.ROTATED_NORMAL;
                            switch(OTHelpers.env.name){
                                case 'Chrome':
                                case 'Safari':
                                    getDomElementCallback().style.webkitTransform = transform;
                                    break;
                                default:
                                    // The standard version, just Firefox, Opera, and Edge
                                    getDomElementCallback().style.transform = transform;
                            }
                            self1.trigger('orientationChanged', _orientation);
                        }
                    },
                    // see https://wiki.mozilla.org/WebAPI/AudioChannels
                    // The audioChannelType is currently only available in Firefox. This property returns
                    // "unknown" in other browser. The related HTML tag attribute is "mozaudiochannel"
                    audioChannelType: {
                        get () {
                            if ('mozAudioChannelType' in this.domElement) return this.domElement.mozAudioChannelType;
                            return 'unknown';
                        },
                        set (type) {
                            if ('mozAudioChannelType' in this.domElement) this.domElement.mozAudioChannelType = type;
                        }
                    }
                });
            };
        /***/ },
        /* 651 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-use-before-define */ module1.exports = function listenForTracksEndedFactory() {
                function isEveryTrackEnded(stream) {
                    return stream.getTracks().every((track)=>track.readyState === 'ended');
                }
                return function listenForTracksEnded(stream, onAllEnded, onSingleEnded) {
                    const tracks = [];
                    function singleTrackEndedHandler(event) {
                        // We wait a fraction of a second for all ended events to be emitted before
                        // determining if all tracks have ended or just a subset of them.
                        setTimeout(()=>{
                            if (!tracks.length) return;
                            if (isEveryTrackEnded(stream)) {
                                removeAllTrackListeners();
                                if (typeof onAllEnded === 'function') onAllEnded();
                            } else {
                                const track = event.target;
                                removeTrackListener(track);
                                if (typeof onSingleEnded === 'function') onSingleEnded(track);
                            }
                        }, 100);
                    }
                    function removeTrackListener(track) {
                        if (track.onended === singleTrackEndedHandler) track.onended = null; // eslint-disable-line no-param-reassign
                        const index = tracks.indexOf(track);
                        if (index >= 0) tracks.splice(index, 1);
                    }
                    function removeAllTrackListeners() {
                        tracks.slice().forEach(removeTrackListener);
                    }
                    function addTrackListeners() {
                        stream.getTracks().forEach((track)=>{
                            tracks.push(track);
                            track.onended = singleTrackEndedHandler; // eslint-disable-line no-param-reassign
                        });
                    }
                    addTrackListeners();
                    return {
                        stop: removeAllTrackListeners,
                        refresh: ()=>{
                            removeAllTrackListeners();
                            addTrackListeners();
                        }
                    };
                };
            };
        /***/ },
        /* 652 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Some Safari users can't establish a call using server reflexive candidates
            // * https://bugs.webkit.org/show_bug.cgi?id=233752
            // * https://jira.vonage.com/browse/OPENTOK-45642
            const hasConnectivityBug = (version)=>version >= 15 && version < 15.4;
            module1.exports = (env)=>{
                // eslint-disable-next-line global-require, no-param-reassign
                env = env || __webpack_require__(3);
                if (env.isiPad) // UA varies in iPad depending on Desktop/Mobile site preferences. So we could have the
                // following scenarios:
                // - Safari iPad using mobile preferred.
                // - Safari iPad using desktop preferred.
                // - Webkit browser (e.g. Chrome|Firefox) using mobile preferred.
                // - Webkit browser (e.g. Chrome|Firefox) using desktop preferred.
                // When desktop preferred, we should check for the Safari version, otherwise check the
                // iOS version. However we do not have a Safari version for Chrome iPad using desktop
                // agent. Thus we will always force TURN in iPad to avoid an overcomplex logic
                return true;
                if (env.isiPhone) return hasConnectivityBug(env.iOSVersion);
                if (env.isSafari) return hasConnectivityBug(env.version);
                return false;
            };
        /***/ },
        /* 653 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Values taken from https://github.com/opentok/chef-rumor/blob/master/attributes/default.rb#L65
            const maxBitratePerResolution = [
                {
                    width: 320,
                    height: 180,
                    maxBitrate: 300000
                },
                {
                    width: 320,
                    height: 240,
                    maxBitrate: 400000
                },
                {
                    width: 352,
                    height: 288,
                    maxBitrate: 500000
                },
                {
                    width: 480,
                    height: 270,
                    maxBitrate: 550000
                },
                {
                    width: 640,
                    height: 360,
                    maxBitrate: 800000
                },
                {
                    width: 640,
                    height: 480,
                    maxBitrate: 800000
                },
                {
                    width: 960,
                    height: 540,
                    maxBitrate: 1100000
                },
                {
                    width: 1280,
                    height: 720,
                    maxBitrate: 2500000
                },
                {
                    width: 1920,
                    height: 1080,
                    maxBitrate: 4500000
                }
            ].sort((a, b)=>a.maxBitrate - b.maxBitrate); // ensure sorted by desc bitrate
            // Use maxBitrate for 1920x1080 as default if lookup fails.
            const defaultMaxBitrate = 4500000;
            const getMaxBitrateForResolution = (videoWidth, videoHeight)=>{
                var _maxBitratePerResolut;
                if (!videoWidth || !videoHeight) return defaultMaxBitrate; // Step function returns upper limit max bitrate for resolution area
                // using lookup table as input data.
                const bitrate = (_maxBitratePerResolut = maxBitratePerResolution.find((_ref)=>{
                    let height = _ref.height, width = _ref.width;
                    return videoHeight * videoWidth <= height * width;
                })) == null ? void 0 : _maxBitratePerResolut.maxBitrate;
                return bitrate || defaultMaxBitrate;
            };
            module1.exports = getMaxBitrateForResolution;
        /***/ },
        /* 654 */ /***/ function(module1, exports, __webpack_require__) {
            var baseAssignValue = __webpack_require__(64), baseForOwn = __webpack_require__(100), baseIteratee = __webpack_require__(36);
            /**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
                var result = {};
                iteratee = baseIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
            }
            module1.exports = mapValues;
        /***/ },
        /* 655 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 * Installs a watcher that will calls the given callback if the audio acquisition seems to not
 * work porperly.
 *
 * It waits 3 seconds and poll getStats to find any sign of audio bytes sent. If it can't find any
 * it signals the anomaly by executing the given function.
 *
 * @param {function(cb: function(DOMError, Array<RTCStats>))} getStats
 *    the function to call to get the stats
 * @param {function} warningCb to be called when a potential problem is detected
 * @returns {function} cancel the watch
 */ module1.exports = function watchAudioAcquisition(getStats, warningCb) {
                // detection of Chrome failure to acquire audio
                // inspired by https://medium.com/the-making-of-appear-in/working-around-webrtc-bugs-d4f6fdb763f
                const to = setTimeout(()=>{
                    getStats((error, stats)=>{
                        if (error) return;
                        for(let idxStats = 0; idxStats < stats.length; idxStats += 1){
                            const rtcStats = stats[idxStats];
                            if (rtcStats.id.indexOf('_send') !== -1 && rtcStats.type === 'ssrc' && (rtcStats.kind === 'audio' || rtcStats.mediaType === 'audio') && parseInt(rtcStats.bytesSent, 10) === 0) // abnormal condition detected
                            warningCb();
                        }
                    });
                }, 3000);
                return function cancel() {
                    clearTimeout(to);
                };
            };
        /***/ },
        /* 656 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require, no-underscore-dangle, no-param-reassign, no-void, no-shadow */ /* eslint-disable func-names */ const eventing = __webpack_require__(7);
            const uuid = __webpack_require__(16);
            module1.exports = function SinglePeerConnectionFactory() {
                return function SinglePeerConnection(options, controller) {
                    const _transceivers = {};
                    const _tracks = [];
                    let _iceConnectedEmitted = false;
                    this._id = uuid(); // SPC events wrapper for PeerConnection
                    const _onIceConnected = ()=>{
                        this.trigger('iceConnected');
                        _iceConnectedEmitted = true;
                    };
                    const _onClosed = ()=>this.trigger('close');
                    const _onRemoteVideoSupported = (supported)=>this.trigger('remoteVideoSupported', supported);
                    const _onPeerError = (_ref)=>{
                        let reason = _ref.reason, prefix = _ref.prefix;
                        return this.trigger('error', reason, prefix);
                    };
                    const _onIceConnectionStateChange = (state)=>this.trigger('iceConnectionStateChange', state);
                    const _onSignalingStateChange = (state)=>this.trigger('signalingStateChange', state);
                    const _onSignalingStateStable = (state)=>this.trigger('signalingStateStable', state);
                    eventing(this);
                    const _peerConnection = controller.getPeerConnection(options, this);
                    _peerConnection.on({
                        iceConnected: _onIceConnected,
                        close: _onClosed,
                        signalingStateChange: _onSignalingStateChange,
                        signalingStateStable: _onSignalingStateStable,
                        error: _onPeerError,
                        qos: (_qos)=>this.trigger('qos', _qos),
                        iceConnectionStateChange: _onIceConnectionStateChange,
                        remoteVideoSupported: _onRemoteVideoSupported
                    }, this); // Specific SPC logic
                    const shouldEmitIceConnected = ()=>_peerConnection.iceConnectionStateIsConnected() && !_iceConnectedEmitted;
                    this._onTrackAdded = (remoteRTCStream)=>{
                        const track = remoteRTCStream.track, transceiver = remoteRTCStream.transceiver;
                        _transceivers[track.id] = transceiver.mid;
                        _tracks.push(track.id);
                        if (shouldEmitIceConnected()) // Since PC is already connected, we will need to emit the event now.
                        _onIceConnected();
                        this.trigger('trackAdded', remoteRTCStream);
                    };
                    this.disconnect = ()=>{
                        controller.removeSinglePeerConnection(this._id);
                        _peerConnection.stopTransceivers(Object.values(_transceivers));
                    };
                    this.removeTrack = (track)=>{
                        if (_transceivers[track.id]) _peerConnection.stopTransceivers([
                            _transceivers[track.id]
                        ]);
                        const trackIndex = _tracks.indexOf(track.id);
                        if (trackIndex > -1) _tracks.splice(trackIndex, 1);
                        controller.removeTrack(track, this._id);
                    };
                    this.remoteTracks = ()=>_tracks; // SPC wrapper for PeerConnection
                    this.getDataChannel = (label, options, completion)=>{
                        _peerConnection.getDataChannel(label, options, completion);
                    };
                    this.getSourceStreamId = ()=>_peerConnection.getSourceStreamId();
                    this.processMessage = (type, message)=>{
                        _peerConnection.processMessage(type, message);
                    };
                    this.remoteDescription = ()=>_peerConnection.remoteDescription();
                    this.getStats = (callback)=>{
                        _peerConnection.getStats(callback);
                    };
                    this.getSynchronizationSources = (callback)=>{
                        _peerConnection.getSynchronizationSources(callback);
                    };
                    this.getRtcStatsReport = (callback)=>{
                        _peerConnection.getRtcStatsReport(callback);
                    };
                    this.remoteStreams = ()=>_peerConnection.remoteStreams();
                    this.hasRelayCandidates = ()=>_peerConnection.hasRelayCandidates();
                    this.iceRestart = ()=>_peerConnection.iceRestart();
                    this.iceConnectionStateIsConnected = ()=>_peerConnection.iceConnectionStateIsConnected();
                };
            };
        /***/ },
        /* 657 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /*
 * Installs a watcher that will call the given callback if the audio from a subscriber is
 arriving, but the output is having issues.
 *
 * It polls getStats every 500 ms to find
 * 1) any sign of audio bytes received, but no change in audioLevel, and totalSamplesReceived or
 * 2) any sign of audio bytes received, but audioLevel is 0, and totalSamplesReceived is increasing
 * If it finds the issue,
 * it signals the anomaly by executing the given function.
 *
 * @param {function(cb: function(DOMError, Array<RTCStats>))} getStats
 *    the function to call to get the stats
 * @param {function} warningCb to be called when a potential problem is detected
 * @param {function} disableAudioLevelStuckAt0 if true, it won't verify audioLevelStuckAt0 scenario
 * @returns {function} cancel the watch
 */ const AUDIO_STUCK_AT_0_WARNING_TIMEOUT = 3000;
            module1.exports = function watchSubscriberAudio(getStats, warningCb, disableAudioLevelStuckAt0) {
                if (disableAudioLevelStuckAt0 === void 0) disableAudioLevelStuckAt0 = false;
                let lastAudioLevel = null;
                let lastTotalSamplesReceived = 0;
                let inboundAudioReceiverTrackId = null;
                let isAudioLevelStuckAt0Disabled = disableAudioLevelStuckAt0;
                const isInboundAudioRTPStream = (rtcStats)=>rtcStats.type === 'inbound-rtp' && (rtcStats.kind || rtcStats.mediaType) === 'audio';
                const isInboundAudioReceiver = (rtcStats)=>rtcStats.id === inboundAudioReceiverTrackId && rtcStats.type === 'track' && (rtcStats.kind || rtcStats.mediaType) === 'audio';
                const isAudioLevelStuck = (audioLevel, totalSamplesReceived)=>audioLevel === lastAudioLevel && totalSamplesReceived === lastTotalSamplesReceived;
                const isAudioLevelStuckAt0 = (audioLevel, totalSamplesReceived)=>!isAudioLevelStuckAt0Disabled && audioLevel === 0 && lastAudioLevel === 0 && totalSamplesReceived > lastTotalSamplesReceived;
                const initAudioLevelStuckAt0Timer = ()=>{
                    setTimeout(()=>{
                        isAudioLevelStuckAt0Disabled = true;
                    }, AUDIO_STUCK_AT_0_WARNING_TIMEOUT);
                };
                const watcherInterval = setInterval(()=>{
                    getStats((error, rtcStatsItems)=>{
                        if (error) return;
                        const inboundAudioRtcStreamStat = rtcStatsItems.find(isInboundAudioRTPStream) || {};
                        inboundAudioReceiverTrackId = inboundAudioRtcStreamStat.trackId;
                        const inboundAudioReceiverStat = rtcStatsItems.find(isInboundAudioReceiver);
                        if (inboundAudioReceiverStat) {
                            const audioLevel = inboundAudioReceiverStat.audioLevel, totalSamplesReceived = inboundAudioReceiverStat.totalSamplesReceived;
                            if (audioLevel === undefined) // Let's ignore this stats in case audioLevel is undefined
                            return;
                            if (isAudioLevelStuck(audioLevel, totalSamplesReceived)) {
                                // OPENTOK-41097 - abnormal condition detected
                                clearInterval(watcherInterval);
                                warningCb('audioLevelStuck');
                            } else if (isAudioLevelStuckAt0(audioLevel, totalSamplesReceived)) {
                                // The audioLevel property should only go to 0 if a client is muted
                                // OPENTOK-41073 - abnormal condition detected
                                clearInterval(watcherInterval);
                                warningCb('audioLevelStuckAt0');
                            }
                            lastAudioLevel = audioLevel;
                            lastTotalSamplesReceived = totalSamplesReceived;
                        }
                    });
                }, 500);
                if (!disableAudioLevelStuckAt0) initAudioLevelStuckAt0Timer();
                return {
                    stop: ()=>{
                        clearInterval(watcherInterval);
                    }
                };
            };
        /***/ },
        /* 658 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                /* eslint-disable global-require */ const Analytics = __webpack_require__(26);
                const defaultAnalytics = new Analytics();
                module1.exports = function reportIssueFactory(deps) {
                    if (deps === void 0) deps = {};
                    /** @type defaultAnalytics */ const analytics = deps.analytics || defaultAnalytics;
                    const errors = deps.errors || __webpack_require__(6);
                    const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                    const otError = deps.otError || __webpack_require__(13)();
                    const sessionObjects = deps.sessionObjects || __webpack_require__(21);
                    const uuid = deps.uuid || __webpack_require__(16);
                    /**
  * Report that your app experienced an issue. You can use the issue ID with
  * <a href="http://tokbox.com/developer/tools/Inspector">Inspector</a> or when discussing
  * an issue with the Vonage API support team.
  *
  * @param completionHandler {Function} A function that is called when the call to this method
  * succeeds or fails. This function has two parameters. The first parameter is an
  * <a href="Error.html">Error</a> object that is set when the call to the
  * <code>reportIssue()</code> method fails (for example, if the client is not connected to the
  * network) or <code>null</code> when the call to the <code>reportIssue()</code> method succeeds.
  * The second parameter is set to the report ID (a unique string) when the call succeeds.
  *
  * @method OT.reportIssue
  * @memberof OT
  */ return function reportIssue(completionHandler) {
                        if (completionHandler === void 0) completionHandler = ()=>{};
                        const reportIssueId = uuid();
                        function onDone(err) {
                            if (err) completionHandler(otError(errors.REPORT_ISSUE_FAILED, new Error('Error calling OT.reportIssue(). Check the client\'s network connection.'), ExceptionCodes.REPORT_ISSUE_ERROR));
                            else completionHandler(null, reportIssueId);
                        }
                        if (sessionObjects.sessions.length() === 0) analytics.logEvent({
                            action: 'ReportIssue',
                            variation: 'Event',
                            payload: {
                                reportIssueId: reportIssueId
                            }
                        }, null, onDone);
                        else Promise.all(sessionObjects.sessions.map((session)=>session.reportIssue({
                                id: reportIssueId
                            }))).then(()=>onDone(), (err)=>onDone(err));
                    };
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 659 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Test via a getter in the options object to see if the passive property is accessed
            // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
            module1.exports = (_ref)=>{
                let window1 = _ref.window;
                let supportsPassive = false;
                try {
                    const opts = Object.defineProperty({}, 'passive', {
                        get () {
                            supportsPassive = true;
                        }
                    });
                    window1.addEventListener('testPassive', null, opts);
                    window1.removeEventListener('testPassive', null, opts);
                } catch (e) {} // eslint-disable-line no-empty
                return supportsPassive;
            };
        /***/ },
        /* 660 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _CancellationError = __webpack_require__(301);
            var _CancellationError2 = _interopRequireDefault(_CancellationError);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var noop = function noop() {};
            var Cancellation = function() {
                function Cancellation() {
                    _classCallCheck(this, Cancellation);
                    this.internalIsCanceled = false;
                    this.listeners = [];
                }
                _createClass(Cancellation, [
                    {
                        key: 'isCanceled',
                        /**
     * Returns `true` if cancellation has been requested; otherwise, returns `false`.
     */ value: function isCanceled() {
                            return this.internalIsCanceled;
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            // Return if cancellation has already been requested.
                            if (this.internalIsCanceled) return;
                            this.internalIsCanceled = true;
                            // Notify and remove listeners
                            this.listeners.forEach(function(listener) {
                                return listener();
                            });
                            this.listeners = null;
                        }
                    },
                    {
                        key: 'throwIfCanceled',
                        value: function throwIfCanceled() {
                            if (this.internalIsCanceled) throw new _CancellationError2.default('Operation has been canceled.');
                        }
                    },
                    {
                        key: 'onCancel',
                        value: function onCancel(listener) {
                            var _this = this;
                            if (this.internalIsCanceled) return noop;
                            this.listeners.push(listener);
                            return function() {
                                if (_this.listeners) {
                                    var index = _this.listeners.indexOf(listener);
                                    if (index !== -1) _this.listeners.splice(index, 1);
                                }
                            };
                        }
                    },
                    {
                        key: 'fork',
                        value: function fork() {
                            if (this.internalIsCanceled) return Cancellation.CANCELED;
                            var child = new Cancellation();
                            this.onCancel(function() {
                                return child.cancel();
                            });
                            return child;
                        }
                    }
                ]);
                return Cancellation;
            }();
            /*
 * A `Cancellation` object that is already in the canceled state.
 */ exports.default = Cancellation;
            Cancellation.CANCELED = new Cancellation();
            Cancellation.CANCELED.internalIsCanceled = true;
        /***/ },
        /* 661 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const eventHelper = __webpack_require__(63);
                const promiseFinally = __webpack_require__(302).default;
                const pTimeout = __webpack_require__(153); // eslint-disable-next-line no-unused-vars
                const typeVideoElementFacade = __webpack_require__(107)();
                /**
 * Returns a Promise that will resolve when the video resolution is greater than
 * 2 in either dimension, or a timeout occurs.
 *
 * @param {typeVideoElementFacade} videoElementFacade
 * @param {Number} timeoutMs
 *
 * @returns Promise<Boolean> true if resolution succeeded, false otherwise
 */ function waitForCorrectResolution(videoElementFacade, timeoutMs) {
                    const videoElementFacadeEvents = eventHelper(videoElementFacade);
                    const promise = new Promise((resolve)=>{
                        const checkResolution = ()=>{
                            if (videoElementFacade.videoWidth() > 2 || videoElementFacade.videoHeight() > 2) resolve(true);
                        };
                        videoElementFacadeEvents.on('videoDimensionsChanged', checkResolution);
                        checkResolution();
                    });
                    return promiseFinally(pTimeout(promise, timeoutMs, ()=>false), ()=>videoElementFacadeEvents.removeAll());
                }
                module1.exports = waitForCorrectResolution;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 662 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const eventHelper = __webpack_require__(63);
                const promiseFinally = __webpack_require__(302).default;
                const pTimeout = __webpack_require__(153); // eslint-disable-next-line no-unused-vars
                const typeVideoElementFacade = __webpack_require__(107)();
                /**
 * Wait for the video to be playing
 *
 * @param {typeVideoElementFacade} videoElementFacade
 * @param {Number} maxWaitTime
 *
 * @returns Promise<Boolean> true if we think the video is playing, false if we timeout
 */ function waitForVideoToBePlaying(videoElementFacade, maxWaitTime) {
                    if (maxWaitTime === void 0) maxWaitTime = 5000;
                    const videoElementFacadeEvents = eventHelper(videoElementFacade);
                    const promise = new Promise((resolve)=>{
                        videoElementFacadeEvents.on('timeupdate', resolve);
                        videoElementFacadeEvents.on('loadedmetadata', resolve);
                    });
                    return promiseFinally(pTimeout(promise, maxWaitTime, ()=>false), ()=>videoElementFacadeEvents.removeAll());
                }
                module1.exports = waitForVideoToBePlaying;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 663 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const log = __webpack_require__(2)('WidgetView:fixMini');
            const miniWidth = 128;
            const miniHeight = 128;
            const microWidth = 64;
            const microHeight = 64;
            module1.exports = function fixMini(/** @type {HTMLElement} */ container) {
                const clientWidth = container.clientWidth, clientHeight = container.clientHeight;
                container.classList.remove('OT_micro');
                container.classList.remove('OT_mini');
                if (clientWidth < microWidth || clientHeight < microHeight) {
                    container.classList.add('OT_micro');
                    log.debug('OT_micro class added', {
                        clientWidth: clientWidth,
                        clientHeight: clientHeight,
                        microWidth: microWidth,
                        microHeight: microHeight
                    });
                }
                if (clientWidth < miniWidth || clientHeight < miniHeight) {
                    container.classList.add('OT_mini');
                    log.debug('OT_mini class added', {
                        clientWidth: clientWidth,
                        clientHeight: clientHeight,
                        miniWidth: miniWidth,
                        miniHeight: miniHeight
                    });
                }
            };
        /***/ },
        /* 664 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const uuid = __webpack_require__(16);
            module1.exports = function getOrCreateContainer(elementOrDomId, insertMode) {
                /** @type {HTMLElement} */ let container;
                let domId;
                if (elementOrDomId && elementOrDomId.nodeName) {
                    // It looks like we were given a DOM element. Grab the id or generate
                    // one if it doesn't have one.
                    container = elementOrDomId;
                    if (!container.getAttribute('id') || container.getAttribute('id').length === 0) container.setAttribute('id', `OT_${uuid()}`);
                    domId = container.getAttribute('id');
                } else if (elementOrDomId) {
                    // We may have got an id, try and get it's DOM element.
                    container = document.getElementById(elementOrDomId);
                    if (container) domId = elementOrDomId;
                }
                if (!domId) domId = `OT_${uuid().replace(/-/g, '_')}`;
                if (!container) {
                    container = document.createElement('div');
                    container.id = domId;
                    container.setAttribute('id', domId);
                    container.style.backgroundColor = '#000000';
                    document.body.appendChild(container);
                    return container;
                }
                const placeHolder = document.createElement('div');
                placeHolder.id = `OT_${uuid()}`;
                switch(insertMode){
                    case 'append':
                        container.appendChild(placeHolder);
                        return placeHolder;
                    case 'before':
                        container.parentNode.insertBefore(placeHolder, container);
                        return placeHolder;
                    case 'after':
                        container.parentNode.insertBefore(placeHolder, container.nextSibling);
                        return placeHolder;
                    case 'replace':
                    default:
                        while(container.firstChild)container.removeChild(container.firstChild);
                        return container;
                }
            };
        /***/ },
        /* 665 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function ensureCSSUnit(measurement, defaultUnit) {
                if (defaultUnit === void 0) defaultUnit = 'px';
                if (String(parseFloat(measurement, 10)) === String(measurement).trim()) return `${String(measurement).trim()}${defaultUnit}`;
                return measurement;
            };
        /***/ },
        /* 666 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const IntervalRunner = __webpack_require__(75);
                module1.exports = function waitUntil(predicate, _temp) {
                    let _ref = _temp === void 0 ? {} : _temp, _ref$frequency = _ref.frequency, frequency = _ref$frequency === void 0 ? 60 : _ref$frequency, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout;
                    return new Promise((resolve, reject)=>{
                        let timeoutTimerId;
                        const intervalRunner = new IntervalRunner(()=>{
                            function tryPredicate() {
                                try {
                                    return predicate();
                                } catch (e) {
                                    return false;
                                }
                            }
                            if (tryPredicate()) {
                                clearTimeout(timeoutTimerId);
                                intervalRunner.stop();
                                resolve();
                            }
                        }, frequency);
                        timeoutTimerId = setTimeout(()=>{
                            intervalRunner.stop();
                            reject(new Error('TIMEOUT'));
                        }, timeout);
                        intervalRunner.start();
                    });
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 667 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const otError = __webpack_require__(13)();
            const Errors = __webpack_require__(6);
            const ExceptionCodes = __webpack_require__(10);
            module1.exports = (err)=>{
                if (String(err.code) === '404') return otError(Errors.STREAM_NOT_FOUND, new Error('stream not found'), ExceptionCodes.UNABLE_TO_SUBSCRIBE);
                if (String(err.code) === '409' && err.message === 'streamLimitExceeded') return otError(Errors.STREAM_LIMIT_EXCEEDED, new Error('The limit for concurrent streams in the session has been reached'), ExceptionCodes.STREAM_LIMIT_EXCEEDED);
                if (String(err.code) === '405' && err.message === 'IncompatibleEncryptionSettings') return otError(Errors.UNABLE_TO_SUBSCRIBE, new Error('Tried to subscribe to an encrypted stream without enabling encryption'), ExceptionCodes.UNABLE_TO_SUBSCRIBE);
                return otError(Errors.UNABLE_TO_SUBSCRIBE, new Error(`subscriberCreate failed with unexpected code ${err.code}: ${err.message}`), ExceptionCodes.UNEXPECTED_SERVER_RESPONSE);
            };
        /***/ },
        /* 668 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const eventNames = __webpack_require__(27);
            const now = __webpack_require__(50);
            const RafRunner = __webpack_require__(103);
            const Events = __webpack_require__(23)();
            module1.exports = (_ref)=>{
                let subscriber = _ref.subscriber, audioLevelSampler = _ref.audioLevelSampler;
                let loudness = 0;
                let loudnessLastAccess = 0;
                const audioLevelRunner = new RafRunner(()=>{
                    const listenerCount = subscriber.listenerCount(eventNames.AUDIO_LEVEL_UPDATED);
                    const shouldStopWatchingAudio = ()=>now() - loudnessLastAccess > 10000 && listenerCount === 0;
                    if (shouldStopWatchingAudio()) {
                        audioLevelRunner.stop();
                        return;
                    }
                    loudness = audioLevelSampler.sample();
                    if (listenerCount > 0) // dispatch this old event if someone is listening...
                    subscriber.dispatchEvent(new Events.AudioLevelUpdatedEvent(loudness));
                });
                Object.defineProperty(subscriber, 'loudness', {
                    get () {
                        audioLevelRunner.start();
                        loudnessLastAccess = now();
                        return loudness;
                    },
                    set () {
                        throw new TypeError('Cannot set readonly property loudness');
                    },
                    configurable: true
                });
                if (subscriber.listenerCount(eventNames.AUDIO_LEVEL_UPDATED)) audioLevelRunner.start();
                subscriber.on('audioLevelUpdated:added', ()=>{
                    audioLevelRunner.start();
                });
                subscriber.once(eventNames.SUBSCRIBER_DESTROYED, ()=>{
                    audioLevelRunner.stop();
                });
                return {
                    destroy () {
                        audioLevelSampler.destroy();
                        audioLevelRunner.stop();
                    }
                };
            };
        /***/ },
        /* 669 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable consistent-return */ const GetAudioLevelSampler = __webpack_require__(253);
            const WebAudioAudioLevelSampler = __webpack_require__(145);
            const hasSynchronizationSourcesCapability = __webpack_require__(670);
            const hasAudioOutputLevelStatCapability = __webpack_require__(304);
            const hasRemoteStreamsWithWebAudio = __webpack_require__(305);
            const getAudioContext = __webpack_require__(158)();
            const isAudioContext = __webpack_require__(671);
            const logging = __webpack_require__(2)('Subscriber');
            module1.exports = function(peerConnection, deps) {
                if (deps === void 0) deps = {};
                const hasGetSynchronizationSupport = deps.hasGetSynchronizationSupport;
                if (!peerConnection) return; // prefer the audioLevelSampler (more efficient and better responsiveness)
                if (hasSynchronizationSourcesCapability({
                    hasGetSynchronizationSupport: hasGetSynchronizationSupport
                })) return new GetAudioLevelSampler(peerConnection.getSynchronizationSources);
                if (hasAudioOutputLevelStatCapability()) return new GetAudioLevelSampler(peerConnection.getStats);
                if (hasRemoteStreamsWithWebAudio()) {
                    let audioContext;
                    try {
                        audioContext = deps.audioContext || getAudioContext();
                    } catch (e) {
                        logging.warn('Failed to get AudioContext()', e);
                    }
                    if (isAudioContext(audioContext)) return new WebAudioAudioLevelSampler(audioContext);
                }
            };
        /***/ },
        /* 670 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const hasGetSynchronizationSupport = ()=>window.RTCRtpReceiver && 'getSynchronizationSources' in window.RTCRtpReceiver.prototype; // Firefox also has getSynchronizationSources implemented, but we are not
            // gonna use getSynchronizationSources for audio level tracking in FF
            // as the implementation on FF is not that good. Hence the additional checks
            // for browser versions
            module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const hasGetSyncSupport = deps.hasGetSynchronizationSupport || hasGetSynchronizationSupport;
                return hasGetSyncSupport() && !env.isFirefox;
            };
        /***/ },
        /* 671 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (audioContext)=>window.AudioContext && audioContext instanceof window.AudioContext || window.webkitAudioContext && audioContext instanceof window.webkitAudioContext;
        /***/ },
        /* 672 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Widget = __webpack_require__(37);
            const OTHelpers = __webpack_require__(8);
            module1.exports = function VideoDisabledIndicator(options) {
                let videoDisabled = false;
                let warning = false;
                const updateClasses = (function(element) {
                    const shouldDisplay = [
                        'auto',
                        'on'
                    ].indexOf(this.getDisplayMode()) > -1;
                    OTHelpers.removeClass(element, 'OT_video-disabled OT_video-disabled-warning OT_active');
                    if (!shouldDisplay) return;
                    if (videoDisabled) OTHelpers.addClass(element, 'OT_video-disabled');
                    else if (warning) OTHelpers.addClass(element, 'OT_video-disabled-warning');
                    OTHelpers.addClass(element, 'OT_active');
                }).bind(this);
                this.disableVideo = function(value) {
                    videoDisabled = value;
                    if (value === true) warning = false;
                    updateClasses(this.domElement);
                };
                this.setWarning = function(value) {
                    warning = value;
                    updateClasses(this.domElement);
                }; // Mixin common widget behaviour
                Widget(this, {
                    mode: options.mode || 'auto',
                    nodeName: 'div',
                    htmlAttributes: {
                        className: 'OT_video-disabled-indicator'
                    }
                });
                const parentSetDisplayMode = this.setDisplayMode.bind(this);
                this.setDisplayMode = function(mode) {
                    parentSetDisplayMode(mode);
                    updateClasses(this.domElement);
                };
            };
        /***/ },
        /* 673 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Widget = __webpack_require__(37);
            const OTHelpers = __webpack_require__(8);
            module1.exports = function AudioBlockedIndicator(options) {
                let audioBlocked = false;
                const updateClasses = (element)=>{
                    const shouldDisplay = [
                        'auto',
                        'on'
                    ].indexOf(this.getDisplayMode()) > -1;
                    OTHelpers.removeClass(element, [
                        'OT_audio-blocked',
                        'OT_active'
                    ].join(' '));
                    if (!shouldDisplay) return;
                    if (audioBlocked) OTHelpers.addClass(element, 'OT_audio-blocked');
                    OTHelpers.addClass(element, 'OT_active');
                };
                this.setAudioBlocked = (value)=>{
                    audioBlocked = value;
                    updateClasses(this.domElement);
                }; // Mixin common widget behaviour
                Widget(this, {
                    mode: options.mode || 'auto',
                    nodeName: 'div',
                    htmlAttributes: {
                        className: 'OT_audio-blocked-indicator'
                    }
                });
                const parentSetDisplayMode = this.setDisplayMode.bind(this);
                this.setDisplayMode = (mode)=>{
                    parentSetDisplayMode(mode);
                    updateClasses(this.domElement);
                };
            };
        /***/ },
        /* 674 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Widget = __webpack_require__(37);
            const OTHelpers = __webpack_require__(8);
            module1.exports = function VideoUnsupportedIndicator(options) {
                let videoUnsupported = false;
                const updateClasses = (element)=>{
                    const shouldDisplay = [
                        'auto',
                        'on'
                    ].indexOf(this.getDisplayMode()) > -1;
                    OTHelpers.removeClass(element, [
                        'OT_active'
                    ].join(' '));
                    if (!shouldDisplay || !videoUnsupported) return;
                    OTHelpers.addClass(element, 'OT_active');
                };
                this.setVideoUnsupported = (value)=>{
                    videoUnsupported = value;
                    updateClasses(this.domElement);
                }; // Mixin common widget behaviour
                Widget(this, {
                    mode: options.mode || 'auto',
                    nodeName: 'div',
                    htmlAttributes: {
                        className: 'OT_video-unsupported'
                    },
                    htmlContent: '<div class="OT_video-unsupported-bar"></div><div class="OT_video-unsupported-img"></div><span class="OT_video-unsupported-text">Video format not supported</span>'
                });
                const parentSetDisplayMode = this.setDisplayMode.bind(this);
                this.setDisplayMode = (mode)=>{
                    parentSetDisplayMode(mode);
                    updateClasses(this.domElement);
                };
            };
        /***/ },
        /* 675 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const pick = __webpack_require__(48);
            const assign = __webpack_require__(9);
            const find = __webpack_require__(62);
            const getStatsHelpers = __webpack_require__(76);
            const calculateFrameRate = __webpack_require__(157);
            const watchFrameRate = function watchFrameRate(getStats, delay) {
                if (delay === void 0) delay = 5000;
                let timeoutId;
                let destroyed = false;
                const lastStat = {};
                const getVideoInboundStat = function getVideoInboundStat(stats) {
                    if (stats === void 0) stats = [];
                    return find(stats, (stat)=>getStatsHelpers.isVideoInboundRtpStat(stat));
                };
                const query = ()=>{
                    if (destroyed) return;
                    getStats((error, stats)=>{
                        if (destroyed) return;
                        if (!error) {
                            const stat = getVideoInboundStat(stats);
                            if (stat) assign(lastStat, pick(stat, [
                                'timestamp',
                                'framesDecoded'
                            ]));
                            else if (!lastStat.timestamp) assign(lastStat, {
                                timestamp: Date.now(),
                                framesDecoded: 0
                            });
                        }
                        timeoutId = setTimeout(query, delay);
                    });
                };
                query();
                return {
                    getFrameRateFromStat (stat) {
                        return calculateFrameRate({
                            currentStatFrames: stat.framesDecoded,
                            currentTimestamp: stat.timestamp,
                            prevStatFrames: lastStat.framesDecoded,
                            prevTimestamp: lastStat.timestamp
                        });
                    },
                    destroy () {
                        destroyed = true;
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                            timeoutId = null;
                        }
                    }
                };
            };
            module1.exports = watchFrameRate;
        /***/ },
        /* 676 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (_ref)=>{
                let connectivityState = _ref.connectivityState, onWarning = _ref.onWarning, onTimeout = _ref.onTimeout, warningMs = _ref.warningMs, timeoutMs = _ref.timeoutMs;
                const timeoutIds = [];
                const cancelBindGuards = ()=>{
                    timeoutIds.forEach((timeoutId)=>clearTimeout(timeoutId));
                };
                connectivityState.observe({
                    onEnterConnecting () {
                        timeoutIds.push(setTimeout(onWarning, warningMs), setTimeout(onTimeout, timeoutMs));
                    },
                    onEnterConnected: cancelBindGuards,
                    onEnterDisconnected: cancelBindGuards
                });
            };
        /***/ },
        /* 677 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const StateMachine = __webpack_require__(308); // @todo The big plan for connectivityState is to eventually use the state transitions to do
            // what is necessary rather than have it duplicated and possible differences and mistakes
            // around what is to occur when different states occur. Things like calling subscribeComplete
            // logging, calling disconnect or destroy, should all be driven by the state of the connection
            module1.exports = (_ref)=>{
                let onInvalidTransition = _ref.onInvalidTransition;
                return new StateMachine({
                    init: 'disconnected',
                    transitions: [
                        {
                            name: 'beginConnect',
                            from: 'disconnected',
                            to: 'connecting'
                        },
                        {
                            name: 'connect',
                            from: 'connecting',
                            to: 'connected'
                        },
                        {
                            name: 'fail',
                            from: [
                                'connecting',
                                'connected'
                            ],
                            to: 'disconnected'
                        },
                        {
                            name: 'cancel',
                            from: [
                                'connecting',
                                'connected'
                            ],
                            to: 'disconnected'
                        },
                        {
                            name: 'disconnect',
                            from: [
                                'connecting',
                                'connected'
                            ],
                            to: 'disconnected'
                        }
                    ],
                    methods: {
                        onInvalidTransition: onInvalidTransition
                    }
                });
            };
        /***/ },
        /* 678 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const IntervalRunner = __webpack_require__(75);
            module1.exports = (_ref)=>{
                let connectivityState = _ref.connectivityState, logAttempt = _ref.logAttempt;
                const connectivityAttemptPinger = new IntervalRunner(logAttempt, 0.2, 6);
                connectivityState.observe({
                    onEnterConnecting () {
                        connectivityAttemptPinger.start();
                    },
                    onEnterDisconnected () {
                        connectivityAttemptPinger.stop();
                    },
                    onEnterConnected () {
                        connectivityAttemptPinger.stop();
                    }
                });
            };
        /***/ },
        /* 679 */ /***/ function(module1, exports, __webpack_require__) {
            var createCompounder = __webpack_require__(680), upperFirst = __webpack_require__(260);
            /**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var startCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
            });
            module1.exports = startCase;
        /***/ },
        /* 680 */ /***/ function(module1, exports, __webpack_require__) {
            var arrayReduce = __webpack_require__(681), deburr = __webpack_require__(682), words = __webpack_require__(685);
            /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
            /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
            /**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
            }
            module1.exports = createCompounder;
        /***/ },
        /* 681 */ /***/ function(module1, exports) {
            /**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
                var index = -1, length = array == null ? 0 : array.length;
                if (initAccum && length) accumulator = array[++index];
                while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
                return accumulator;
            }
            module1.exports = arrayReduce;
        /***/ },
        /* 682 */ /***/ function(module1, exports, __webpack_require__) {
            var deburrLetter = __webpack_require__(683), toString = __webpack_require__(61);
            /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
            /** Used to compose unicode character classes. */ var rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
            /** Used to compose unicode capture groups. */ var rsCombo = '[' + rsComboRange + ']';
            /**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, 'g');
            /**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            module1.exports = deburr;
        /***/ },
        /* 683 */ /***/ function(module1, exports, __webpack_require__) {
            var basePropertyOf = __webpack_require__(684);
            /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
                // Latin-1 Supplement block.
                '\xc0': 'A',
                '\xc1': 'A',
                '\xc2': 'A',
                '\xc3': 'A',
                '\xc4': 'A',
                '\xc5': 'A',
                '\xe0': 'a',
                '\xe1': 'a',
                '\xe2': 'a',
                '\xe3': 'a',
                '\xe4': 'a',
                '\xe5': 'a',
                '\xc7': 'C',
                '\xe7': 'c',
                '\xd0': 'D',
                '\xf0': 'd',
                '\xc8': 'E',
                '\xc9': 'E',
                '\xca': 'E',
                '\xcb': 'E',
                '\xe8': 'e',
                '\xe9': 'e',
                '\xea': 'e',
                '\xeb': 'e',
                '\xcc': 'I',
                '\xcd': 'I',
                '\xce': 'I',
                '\xcf': 'I',
                '\xec': 'i',
                '\xed': 'i',
                '\xee': 'i',
                '\xef': 'i',
                '\xd1': 'N',
                '\xf1': 'n',
                '\xd2': 'O',
                '\xd3': 'O',
                '\xd4': 'O',
                '\xd5': 'O',
                '\xd6': 'O',
                '\xd8': 'O',
                '\xf2': 'o',
                '\xf3': 'o',
                '\xf4': 'o',
                '\xf5': 'o',
                '\xf6': 'o',
                '\xf8': 'o',
                '\xd9': 'U',
                '\xda': 'U',
                '\xdb': 'U',
                '\xdc': 'U',
                '\xf9': 'u',
                '\xfa': 'u',
                '\xfb': 'u',
                '\xfc': 'u',
                '\xdd': 'Y',
                '\xfd': 'y',
                '\xff': 'y',
                '\xc6': 'Ae',
                '\xe6': 'ae',
                '\xde': 'Th',
                '\xfe': 'th',
                '\xdf': 'ss',
                // Latin Extended-A block.
                '\u0100': 'A',
                '\u0102': 'A',
                '\u0104': 'A',
                '\u0101': 'a',
                '\u0103': 'a',
                '\u0105': 'a',
                '\u0106': 'C',
                '\u0108': 'C',
                '\u010a': 'C',
                '\u010c': 'C',
                '\u0107': 'c',
                '\u0109': 'c',
                '\u010b': 'c',
                '\u010d': 'c',
                '\u010e': 'D',
                '\u0110': 'D',
                '\u010f': 'd',
                '\u0111': 'd',
                '\u0112': 'E',
                '\u0114': 'E',
                '\u0116': 'E',
                '\u0118': 'E',
                '\u011a': 'E',
                '\u0113': 'e',
                '\u0115': 'e',
                '\u0117': 'e',
                '\u0119': 'e',
                '\u011b': 'e',
                '\u011c': 'G',
                '\u011e': 'G',
                '\u0120': 'G',
                '\u0122': 'G',
                '\u011d': 'g',
                '\u011f': 'g',
                '\u0121': 'g',
                '\u0123': 'g',
                '\u0124': 'H',
                '\u0126': 'H',
                '\u0125': 'h',
                '\u0127': 'h',
                '\u0128': 'I',
                '\u012a': 'I',
                '\u012c': 'I',
                '\u012e': 'I',
                '\u0130': 'I',
                '\u0129': 'i',
                '\u012b': 'i',
                '\u012d': 'i',
                '\u012f': 'i',
                '\u0131': 'i',
                '\u0134': 'J',
                '\u0135': 'j',
                '\u0136': 'K',
                '\u0137': 'k',
                '\u0138': 'k',
                '\u0139': 'L',
                '\u013b': 'L',
                '\u013d': 'L',
                '\u013f': 'L',
                '\u0141': 'L',
                '\u013a': 'l',
                '\u013c': 'l',
                '\u013e': 'l',
                '\u0140': 'l',
                '\u0142': 'l',
                '\u0143': 'N',
                '\u0145': 'N',
                '\u0147': 'N',
                '\u014a': 'N',
                '\u0144': 'n',
                '\u0146': 'n',
                '\u0148': 'n',
                '\u014b': 'n',
                '\u014c': 'O',
                '\u014e': 'O',
                '\u0150': 'O',
                '\u014d': 'o',
                '\u014f': 'o',
                '\u0151': 'o',
                '\u0154': 'R',
                '\u0156': 'R',
                '\u0158': 'R',
                '\u0155': 'r',
                '\u0157': 'r',
                '\u0159': 'r',
                '\u015a': 'S',
                '\u015c': 'S',
                '\u015e': 'S',
                '\u0160': 'S',
                '\u015b': 's',
                '\u015d': 's',
                '\u015f': 's',
                '\u0161': 's',
                '\u0162': 'T',
                '\u0164': 'T',
                '\u0166': 'T',
                '\u0163': 't',
                '\u0165': 't',
                '\u0167': 't',
                '\u0168': 'U',
                '\u016a': 'U',
                '\u016c': 'U',
                '\u016e': 'U',
                '\u0170': 'U',
                '\u0172': 'U',
                '\u0169': 'u',
                '\u016b': 'u',
                '\u016d': 'u',
                '\u016f': 'u',
                '\u0171': 'u',
                '\u0173': 'u',
                '\u0174': 'W',
                '\u0175': 'w',
                '\u0176': 'Y',
                '\u0177': 'y',
                '\u0178': 'Y',
                '\u0179': 'Z',
                '\u017b': 'Z',
                '\u017d': 'Z',
                '\u017a': 'z',
                '\u017c': 'z',
                '\u017e': 'z',
                '\u0132': 'IJ',
                '\u0133': 'ij',
                '\u0152': 'Oe',
                '\u0153': 'oe',
                '\u0149': "'n",
                '\u017f': 's'
            };
            /**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
            module1.exports = deburrLetter;
        /***/ },
        /* 684 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
                return function(key) {
                    return object == null ? undefined : object[key];
                };
            }
            module1.exports = basePropertyOf;
        /***/ },
        /* 685 */ /***/ function(module1, exports, __webpack_require__) {
            var asciiWords = __webpack_require__(686), hasUnicodeWord = __webpack_require__(687), toString = __webpack_require__(61), unicodeWords = __webpack_require__(688);
            /**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                return string.match(pattern) || [];
            }
            module1.exports = words;
        /***/ },
        /* 686 */ /***/ function(module1, exports) {
            /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
            /**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
                return string.match(reAsciiWord) || [];
            }
            module1.exports = asciiWords;
        /***/ },
        /* 687 */ /***/ function(module1, exports) {
            /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
            /**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
                return reHasUnicodeWord.test(string);
            }
            module1.exports = hasUnicodeWord;
        /***/ },
        /* 688 */ /***/ function(module1, exports) {
            /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
            /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
            /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
                rsNonAstral,
                rsRegional,
                rsSurrPair
            ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
                rsDingbat,
                rsRegional,
                rsSurrPair
            ].join('|') + ')' + rsSeq;
            /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
                rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
                    rsBreak,
                    rsUpper,
                    '$'
                ].join('|') + ')',
                rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
                    rsBreak,
                    rsUpper + rsMiscLower,
                    '$'
                ].join('|') + ')',
                rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
                rsUpper + '+' + rsOptContrUpper,
                rsOrdUpper,
                rsOrdLower,
                rsDigits,
                rsEmoji
            ].join('|'), 'g');
            /**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
                return string.match(reUnicodeWord) || [];
            }
            module1.exports = unicodeWords;
        /***/ },
        /* 689 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (peerConnection, activeState)=>{
                const videoSender = peerConnection.getSenders().find((_ref)=>{
                    let track = _ref.track;
                    return track.kind === 'video';
                });
                const parameters = videoSender.getParameters();
                parameters.encodings.forEach((encoding)=>{
                    // eslint-disable-next-line no-param-reassign
                    encoding.active = activeState;
                });
                videoSender.setParameters(parameters);
            };
        /***/ },
        /* 690 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // We whitelist property keys for logging purposes
            const pick = __webpack_require__(48);
            const styleHashLogFilter = __webpack_require__(269);
            module1.exports = (x)=>{
                const whitelistedProperties = pick(x, [
                    'audioDeviceId',
                    'audioFallbackEnabled',
                    'audioSource',
                    'channels',
                    'classNames',
                    'constraints',
                    'disableAudioProcessing',
                    'echoCancellation',
                    'noiseSuppression',
                    'autoGainControl',
                    'enableRenegotiation',
                    'enableStereo',
                    'facingMode',
                    'fitMode',
                    'frameRate',
                    'height',
                    'insertDefaultUI',
                    'insertMode',
                    'audioBitrate',
                    'maxResolution',
                    'minVideoBitrate',
                    'mirror',
                    'name',
                    'publishAudio',
                    'publishVideo',
                    'resolution',
                    'showControls',
                    'style',
                    'videoContentHint',
                    'videoDeviceId',
                    'videoDimensions',
                    'videoFilter',
                    'videoSource',
                    'width'
                ]);
                if (whitelistedProperties.style) whitelistedProperties.style = styleHashLogFilter(whitelistedProperties.style);
                return whitelistedProperties;
            };
        /***/ },
        /* 691 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const eventNames = __webpack_require__(27);
            const now = __webpack_require__(50);
            const RafRunner = __webpack_require__(103);
            const Events = __webpack_require__(23)();
            module1.exports = (_ref)=>{
                let publisher = _ref.publisher, widgetView = _ref.widgetView;
                let loudness = 0;
                let loudnessLastAccess = 0;
                const audioLevelRunner = new RafRunner(()=>{
                    const listenerCount = publisher.listenerCount(eventNames.AUDIO_LEVEL_UPDATED);
                    const shouldStopWatchingAudio = ()=>now() - loudnessLastAccess > 10000 && listenerCount === 0;
                    if (shouldStopWatchingAudio()) {
                        audioLevelRunner.stop();
                        return;
                    }
                    const video = widgetView && widgetView.video();
                    if (video) {
                        const audioInputLevel = video.getAudioInputLevel();
                        loudness = audioInputLevel;
                        if (listenerCount > 0) // dispatch this old event if someone is listening...
                        publisher.dispatchEvent(new Events.AudioLevelUpdatedEvent(audioInputLevel));
                    }
                });
                Object.defineProperty(publisher, 'loudness', {
                    get () {
                        audioLevelRunner.start();
                        loudnessLastAccess = now();
                        return loudness;
                    },
                    set () {
                        throw new TypeError('Cannot set readonly property loudness');
                    }
                });
                if (publisher.listenerCount(eventNames.AUDIO_LEVEL_UPDATED)) audioLevelRunner.start();
                publisher.on('audioLevelUpdated:added', ()=>{
                    audioLevelRunner.start();
                });
                publisher.once(eventNames.PUBLISHER_DESTROYED, ()=>{
                    audioLevelRunner.stop();
                });
            };
        /***/ },
        /* 692 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            // Block subsequent calls to an async function until the previous call has completed
            // Throws an error if you call the function too soon.
            module1.exports = function blockCallsUntilComplete(fn) {
                let blocked = false;
                return /*#__PURE__*/ function() {
                    var _blocker = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                        var _len, args, _key, _args = arguments;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (!blocked) {
                                        _context.next = 2;
                                        break;
                                    }
                                    throw new Error('The previous call to this function has not yet completed.');
                                case 2:
                                    blocked = true;
                                    _context.prev = 3;
                                    for(_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = _args[_key];
                                    _context.next = 7;
                                    return fn.call(this, ...args);
                                case 7:
                                    return _context.abrupt("return", _context.sent);
                                case 8:
                                    _context.prev = 8;
                                    blocked = false;
                                    return _context.finish(8);
                                case 11:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this, [
                            [
                                3,
                                ,
                                8,
                                11
                            ]
                        ]);
                    }));
                    function blocker() {
                        return _blocker.apply(this, arguments);
                    }
                    return blocker;
                }();
            };
        /***/ },
        /* 693 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const otError = __webpack_require__(13)();
            const Errors = __webpack_require__(6);
            module1.exports = function createCanvasVideoTrack(dimensions) {
                const canvas = document.createElement('canvas');
                if (!canvas.captureStream) throw otError(Errors.NOT_SUPPORTED, new Error('Your browser does not support HTMLCanvasElement.captureStream()'));
                canvas.width = dimensions.width;
                canvas.height = dimensions.height;
                canvas.getContext('2d').fillRect(0, 0, 1, 1);
                const _canvas$captureStream = canvas.captureStream().getVideoTracks(), canvasTrack = _canvas$captureStream[0];
                canvasTrack.isCreatedCanvas = true; // we never actually intend to send frames from the canvas so it gets disabled
                canvasTrack.enabled = false;
                return canvasTrack;
            };
        /***/ },
        /* 694 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // This strategy will work on modern browsers
            const getDeviceIdFromSettings = (videoTrack)=>videoTrack.getSettings && videoTrack.getSettings().deviceId; // Legacy browsers, like Firefox 52, require this strategy
            const getDeviceIdFromConstraints = (videoTrack)=>{
                let deviceId;
                if (videoTrack.getConstraints && videoTrack.getConstraints().deviceId) deviceId = videoTrack.getConstraints().deviceId.exact;
                return deviceId;
            }; // Look for the current device Id in the device list.
            const getDeviceIdFromDevicesList = (videoTrack, videoDevices)=>{
                let deviceId;
                if (videoDevices && videoDevices.length) {
                    const currentDevice = videoDevices.find((device)=>device.label === videoTrack.label);
                    if (currentDevice) deviceId = currentDevice.deviceId;
                }
                return deviceId;
            };
            const getDeviceId = (videoTrack, videoDevices)=>getDeviceIdFromSettings(videoTrack) || getDeviceIdFromConstraints(videoTrack) || getDeviceIdFromDevicesList(videoTrack, videoDevices);
            module1.exports = (stream, videoDevices)=>{
                if (!stream) return null;
                const _stream$getVideoTrack = stream.getVideoTracks(), videoTrack = _stream$getVideoTrack[0];
                if (!videoTrack) return null;
                return getDeviceId(videoTrack, videoDevices);
            };
        /***/ },
        /* 695 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const Errors = __webpack_require__(6);
            const ExceptionCodes = __webpack_require__(10);
            const otError = __webpack_require__(13)();
            module1.exports = (error)=>{
                // @todo Can we provide more specific errors for these codes? Are these still the only
                // codes that we expect?
                // Error codes: https://github.com/opentok/rumor-reloaded/blob/develop/rumor/src/main/java/com/tokbox/symphony/control/ErrorResponses.java
                const expectedErrorCodes = [
                    '403',
                    '404',
                    '409' // CONFLICT ERRORS: streamLimitExceeded
                ];
                const errorCodeStr = String(error.code);
                if (errorCodeStr === '405' && error.message === 'IncompatibleEncryptionSettings') return otError(Errors.STREAM_CREATE_FAILED, new Error('IncompatibleEncryptionSettings: Tried to publish a stream to an encrypted session without enabling encryption'), ExceptionCodes.UNABLE_TO_PUBLISH);
                return expectedErrorCodes.includes(errorCodeStr) ? otError(Errors.STREAM_CREATE_FAILED, new Error(`Failed to create stream in server model: ${error.message}`), ExceptionCodes.UNABLE_TO_PUBLISH) : otError(Errors.UNEXPECTED_SERVER_RESPONSE, new Error(`Unexpected server response: ${error.message}`), ExceptionCodes.UNEXPECTED_SERVER_RESPONSE);
            };
        /***/ },
        /* 696 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const defaultEnv = __webpack_require__(3);
            const defaultML = __webpack_require__(311);
            const defaultMediaTransform = __webpack_require__(698);
            const logging = __webpack_require__(2)('MediaProcessor');
            /* eslint-disable no-underscore-dangle */ function MediaProcessor(deps) {
                var _this = this;
                if (deps === void 0) deps = {};
                const _deps = deps, _deps$ML = _deps.ML, ML = _deps$ML === void 0 ? defaultML : _deps$ML, _deps$MediaTransform = _deps.MediaTransform, MediaTransform = _deps$MediaTransform === void 0 ? defaultMediaTransform : _deps$MediaTransform;
                let connector;
                let videoFilter;
                let originalVideoTrack;
                this.isValidVideoFilter = (filter)=>{
                    const type = filter.type;
                    return MediaTransform.isSupported(type) && MediaTransform.isValidConfig(filter);
                };
                const videoFilterUpdateMap = {
                    backgroundBlur: ML.setBackgroundOptions,
                    backgroundReplacement: ML.setBackgroundOptions
                };
                this.canUpdateVideoFilter = (filterType)=>!!videoFilterUpdateMap[filterType];
                this.updateVideoFilter = /*#__PURE__*/ function() {
                    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(filter) {
                        var type, configurator, fullConfig;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    type = filter.type;
                                    if (_this.canUpdateVideoFilter(type)) {
                                        _context.next = 4;
                                        break;
                                    }
                                    logging.warn(`Ignoring: filter "${type}" doesn't support real-time updates`);
                                    return _context.abrupt("return");
                                case 4:
                                    configurator = MediaTransform.getConfigurator(type); // The config passed in may be a simplified configuration missing URLs for static
                                    // assets, for example.  We need the "full configuration".
                                    fullConfig = configurator.getConfig(filter);
                                    _context.next = 8;
                                    return videoFilterUpdateMap[type](fullConfig);
                                case 8:
                                    videoFilter = filter;
                                case 9:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return function(_x) {
                        return _ref.apply(this, arguments);
                    };
                }();
                this.setVideoFilter = /*#__PURE__*/ function() {
                    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(newVideoFilter) {
                        var type, configurator, fullConfig, hasFilterAlready;
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    type = newVideoFilter.type;
                                    configurator = MediaTransform.getConfigurator(type);
                                    if (configurator) {
                                        _context2.next = 5;
                                        break;
                                    }
                                    logging.warn(`Ignoring: filter "${type}" isn't supported`);
                                    return _context2.abrupt("return");
                                case 5:
                                    // The config passed in may be a simplified configuration missing URLs for static
                                    // assets, for example.  We need the "full configuration".
                                    fullConfig = configurator.getConfig(newVideoFilter);
                                    if (fullConfig) {
                                        _context2.next = 9;
                                        break;
                                    }
                                    logging.warn(`Ignoring: couldn't configure filter ${type}`);
                                    return _context2.abrupt("return");
                                case 9:
                                    hasFilterAlready = !!_this.getVideoFilter();
                                    if (!hasFilterAlready) {
                                        _context2.next = 20;
                                        break;
                                    }
                                    _context2.prev = 11;
                                    _context2.next = 14;
                                    return _this.destroy();
                                case 14:
                                    _context2.next = 20;
                                    break;
                                case 16:
                                    _context2.prev = 16;
                                    _context2.t0 = _context2["catch"](11);
                                    logging.warn(`Ignoring, couldn't remove previous filter: ${_context2.t0}`);
                                    return _context2.abrupt("return");
                                case 20:
                                    _context2.next = 22;
                                    return ML.createConnector(fullConfig);
                                case 22:
                                    connector = _context2.sent;
                                    videoFilter = newVideoFilter;
                                case 24:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, null, [
                            [
                                11,
                                16
                            ]
                        ]);
                    }));
                    return function(_x2) {
                        return _ref2.apply(this, arguments);
                    };
                }();
                this.getVideoFilter = ()=>videoFilter;
                this.getOriginalVideoTrack = ()=>originalVideoTrack;
                this.setMediaStream = /*#__PURE__*/ function() {
                    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(stream) {
                        var _stream$getVideoTrack, videoTrack, filteredVideoTrack;
                        return _regenerator.default.wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    _stream$getVideoTrack = stream.getVideoTracks(), videoTrack = _stream$getVideoTrack[0];
                                    if (videoTrack) {
                                        _context3.next = 4;
                                        break;
                                    }
                                    logging.warn('Ignoring. No video track found');
                                    return _context3.abrupt("return", null);
                                case 4:
                                    // Returning null, instead of undefined, to be consistent with the case
                                    // above
                                    filteredVideoTrack = null;
                                    _context3.prev = 5;
                                    _context3.next = 8;
                                    return connector.setTrack(videoTrack);
                                case 8:
                                    filteredVideoTrack = _context3.sent;
                                    originalVideoTrack = videoTrack;
                                    _context3.next = 15;
                                    break;
                                case 12:
                                    _context3.prev = 12;
                                    _context3.t0 = _context3["catch"](5);
                                    logging.error(`Error setting media stream: ${_context3.t0}`);
                                case 15:
                                    return _context3.abrupt("return", filteredVideoTrack);
                                case 16:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3, null, [
                            [
                                5,
                                12
                            ]
                        ]);
                    }));
                    return function(_x3) {
                        return _ref3.apply(this, arguments);
                    };
                }();
                this.setVideoTrack = /*#__PURE__*/ function() {
                    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4(videoTrack) {
                        var filteredVideoTrack;
                        return _regenerator.default.wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    filteredVideoTrack = null;
                                    _context4.prev = 1;
                                    _context4.next = 4;
                                    return connector.setTrack(videoTrack);
                                case 4:
                                    filteredVideoTrack = _context4.sent;
                                    originalVideoTrack = videoTrack;
                                    _context4.next = 11;
                                    break;
                                case 8:
                                    _context4.prev = 8;
                                    _context4.t0 = _context4["catch"](1);
                                    logging.error(`Error setting video track: ${_context4.t0}`);
                                case 11:
                                    return _context4.abrupt("return", filteredVideoTrack);
                                case 12:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4, null, [
                            [
                                1,
                                8
                            ]
                        ]);
                    }));
                    return function(_x4) {
                        return _ref4.apply(this, arguments);
                    };
                }(); // Needed to make unit testing easier
                this._setConnector = (newConnector)=>{
                    connector = newConnector;
                };
                this.destroy = /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5() {
                    return _regenerator.default.wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return connector.destroy();
                            case 3:
                                _context5.next = 8;
                                break;
                            case 5:
                                _context5.prev = 5;
                                _context5.t0 = _context5["catch"](0);
                                logging.warn(`Error destroying connector: ${_context5.t0}`);
                            case 8:
                                connector = null;
                                videoFilter = null;
                                originalVideoTrack = null;
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, null, [
                        [
                            0,
                            5
                        ]
                    ]);
                }));
                this.enableLogging = (apiKey, proxyUrl)=>{
                    if (!apiKey) {
                        logging.warn('Error enabling logging: invalid API key');
                        return;
                    }
                    const metadata = {
                        appId: apiKey,
                        sourceType: 'video'
                    };
                    if (proxyUrl) metadata.proxyUrl = proxyUrl;
                    ML.setMetadata(metadata);
                };
                this.disableLogging = ()=>{
                    // ML doesn't have an explicit method to disable logging (e.g.,
                    // `ML.disableLogging`).  Instead, clearing metadata disables it.
                    ML.setMetadata();
                };
            }
            MediaProcessor.isSupported = function(deps) {
                if (deps === void 0) deps = {};
                const _deps2 = deps, _deps2$env = _deps2.env, env = _deps2$env === void 0 ? defaultEnv : _deps2$env, _deps2$ML = _deps2.ML, ML = _deps2$ML === void 0 ? defaultML : _deps2$ML; // Even though other browsers may support this API, we're going to limit it
                // to just Chromium-based browsers for now.
                return !!env.isChromium && ML.isSupported();
            };
            module1.exports = MediaProcessor;
        /***/ },
        /* 697 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* WEBPACK VAR INJECTION */ (function(Promise, process) {
                __webpack_require__.d(__webpack_exports__, "MediaProcessor", function() {
                    return MediaProcessor;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaProcessorConnector", function() {
                    return MediaProcessorConnector;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVonageMetadata", function() {
                    return getVonageMetadata;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSupported", function() {
                    return isSupported;
                });
                /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVonageMetadata", function() {
                    return setVonageMetadata;
                });
                function isSupported() {
                    return new Promise((resolve, reject)=>{
                        if (typeof MediaStreamTrackProcessor === "undefined" || typeof MediaStreamTrackGenerator === "undefined") reject("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.");
                        else resolve();
                    });
                }
                class Key {
                }
                Key.updates = {
                    "transformer_new": "New transformer",
                    "transformer_null": "Null transformer"
                };
                Key.errors = {
                    "transformer_none": "No transformers provided",
                    "transformer_start": "Cannot start transformer",
                    "transformer_transform": "Cannot transform frame",
                    "transformer_flush": "Cannot flush transformer",
                    "readable_null": "Readable is null",
                    "writable_null": "Writable is null"
                };
                var axios$2 = {
                    exports: {}
                };
                var bind$2 = function bind(fn, thisArg) {
                    return function wrap() {
                        var args = new Array(arguments.length);
                        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                        return fn.apply(thisArg, args);
                    };
                };
                var bind$1 = bind$2;
                var toString = Object.prototype.toString;
                function isArray(val) {
                    return Array.isArray(val);
                }
                function isUndefined(val) {
                    return typeof val === "undefined";
                }
                function isBuffer(val) {
                    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
                }
                function isArrayBuffer(val) {
                    return toString.call(val) === "[object ArrayBuffer]";
                }
                function isFormData(val) {
                    return toString.call(val) === "[object FormData]";
                }
                function isArrayBufferView(val) {
                    var result;
                    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
                    else result = val && val.buffer && isArrayBuffer(val.buffer);
                    return result;
                }
                function isString(val) {
                    return typeof val === "string";
                }
                function isNumber(val) {
                    return typeof val === "number";
                }
                function isObject(val) {
                    return val !== null && typeof val === "object";
                }
                function isPlainObject(val) {
                    if (toString.call(val) !== "[object Object]") return false;
                    var prototype = Object.getPrototypeOf(val);
                    return prototype === null || prototype === Object.prototype;
                }
                function isDate(val) {
                    return toString.call(val) === "[object Date]";
                }
                function isFile(val) {
                    return toString.call(val) === "[object File]";
                }
                function isBlob(val) {
                    return toString.call(val) === "[object Blob]";
                }
                function isFunction(val) {
                    return toString.call(val) === "[object Function]";
                }
                function isStream(val) {
                    return isObject(val) && isFunction(val.pipe);
                }
                function isURLSearchParams(val) {
                    return toString.call(val) === "[object URLSearchParams]";
                }
                function trim(str) {
                    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
                }
                function isStandardBrowserEnv() {
                    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
                    return typeof window !== "undefined" && typeof document !== "undefined";
                }
                function forEach(obj, fn) {
                    if (obj === null || typeof obj === "undefined") return;
                    if (typeof obj !== "object") obj = [
                        obj
                    ];
                    if (isArray(obj)) for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
                    else {
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
                    }
                }
                function merge() {
                    var result = {};
                    function assignValue(val, key) {
                        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
                        else if (isPlainObject(val)) result[key] = merge({}, val);
                        else if (isArray(val)) result[key] = val.slice();
                        else result[key] = val;
                    }
                    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
                    return result;
                }
                function extend(a, b, thisArg) {
                    forEach(b, function assignValue(val, key) {
                        if (thisArg && typeof val === "function") a[key] = bind$1(val, thisArg);
                        else a[key] = val;
                    });
                    return a;
                }
                function stripBOM(content) {
                    if (content.charCodeAt(0) === 65279) content = content.slice(1);
                    return content;
                }
                var utils$e = {
                    isArray: isArray,
                    isArrayBuffer: isArrayBuffer,
                    isBuffer: isBuffer,
                    isFormData: isFormData,
                    isArrayBufferView: isArrayBufferView,
                    isString: isString,
                    isNumber: isNumber,
                    isObject: isObject,
                    isPlainObject: isPlainObject,
                    isUndefined: isUndefined,
                    isDate: isDate,
                    isFile: isFile,
                    isBlob: isBlob,
                    isFunction: isFunction,
                    isStream: isStream,
                    isURLSearchParams: isURLSearchParams,
                    isStandardBrowserEnv: isStandardBrowserEnv,
                    forEach: forEach,
                    merge: merge,
                    extend: extend,
                    trim: trim,
                    stripBOM: stripBOM
                };
                var utils$d = utils$e;
                function encode(val) {
                    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                }
                var buildURL$2 = function buildURL(url, params, paramsSerializer) {
                    if (!params) return url;
                    var serializedParams;
                    if (paramsSerializer) serializedParams = paramsSerializer(params);
                    else if (utils$d.isURLSearchParams(params)) serializedParams = params.toString();
                    else {
                        var parts = [];
                        utils$d.forEach(params, function serialize(val, key) {
                            if (val === null || typeof val === "undefined") return;
                            if (utils$d.isArray(val)) key = key + "[]";
                            else val = [
                                val
                            ];
                            utils$d.forEach(val, function parseValue(v) {
                                if (utils$d.isDate(v)) v = v.toISOString();
                                else if (utils$d.isObject(v)) v = JSON.stringify(v);
                                parts.push(encode(key) + "=" + encode(v));
                            });
                        });
                        serializedParams = parts.join("&");
                    }
                    if (serializedParams) {
                        var hashmarkIndex = url.indexOf("#");
                        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
                        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    }
                    return url;
                };
                var utils$c = utils$e;
                function InterceptorManager$1() {
                    this.handlers = [];
                }
                InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
                    this.handlers.push({
                        fulfilled: fulfilled,
                        rejected: rejected,
                        synchronous: options ? options.synchronous : false,
                        runWhen: options ? options.runWhen : null
                    });
                    return this.handlers.length - 1;
                };
                InterceptorManager$1.prototype.eject = function eject(id) {
                    if (this.handlers[id]) this.handlers[id] = null;
                };
                InterceptorManager$1.prototype.forEach = function forEach2(fn) {
                    utils$c.forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                };
                var InterceptorManager_1 = InterceptorManager$1;
                var utils$b = utils$e;
                var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
                    utils$b.forEach(headers, function processHeader(value, name) {
                        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                            headers[normalizedName] = value;
                            delete headers[name];
                        }
                    });
                };
                var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
                    error.config = config;
                    if (code) error.code = code;
                    error.request = request2;
                    error.response = response;
                    error.isAxiosError = true;
                    error.toJSON = function toJSON() {
                        return {
                            message: this.message,
                            name: this.name,
                            description: this.description,
                            number: this.number,
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            config: this.config,
                            code: this.code,
                            status: this.response && this.response.status ? this.response.status : null
                        };
                    };
                    return error;
                };
                var enhanceError$1 = enhanceError$2;
                var createError$2 = function createError(message, config, code, request2, response) {
                    var error = new Error(message);
                    return enhanceError$1(error, config, code, request2, response);
                };
                var createError$1 = createError$2;
                var settle$1 = function settle(resolve, reject, response) {
                    var validateStatus2 = response.config.validateStatus;
                    if (!response.status || !validateStatus2 || validateStatus2(response.status)) resolve(response);
                    else reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
                };
                var utils$a = utils$e;
                var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
                    return {
                        write: function write(name, value, expires, path, domain, secure) {
                            var cookie = [];
                            cookie.push(name + "=" + encodeURIComponent(value));
                            if (utils$a.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
                            if (utils$a.isString(path)) cookie.push("path=" + path);
                            if (utils$a.isString(domain)) cookie.push("domain=" + domain);
                            if (secure === true) cookie.push("secure");
                            document.cookie = cookie.join("; ");
                        },
                        read: function read(name) {
                            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
                            return match ? decodeURIComponent(match[3]) : null;
                        },
                        remove: function remove(name) {
                            this.write(name, "", Date.now() - 864e5);
                        }
                    };
                }() : function nonStandardBrowserEnv() {
                    return {
                        write: function write() {},
                        read: function read() {
                            return null;
                        },
                        remove: function remove() {}
                    };
                }();
                var isAbsoluteURL$1 = function isAbsoluteURL(url) {
                    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
                };
                var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
                    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
                };
                var isAbsoluteURL2 = isAbsoluteURL$1;
                var combineURLs2 = combineURLs$1;
                var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
                    if (baseURL && !isAbsoluteURL2(requestedURL)) return combineURLs2(baseURL, requestedURL);
                    return requestedURL;
                };
                var utils$9 = utils$e;
                var ignoreDuplicateOf = [
                    "age",
                    "authorization",
                    "content-length",
                    "content-type",
                    "etag",
                    "expires",
                    "from",
                    "host",
                    "if-modified-since",
                    "if-unmodified-since",
                    "last-modified",
                    "location",
                    "max-forwards",
                    "proxy-authorization",
                    "referer",
                    "retry-after",
                    "user-agent"
                ];
                var parseHeaders$1 = function parseHeaders(headers) {
                    var parsed = {};
                    var key;
                    var val;
                    var i;
                    if (!headers) return parsed;
                    utils$9.forEach(headers.split("\n"), function parser(line) {
                        i = line.indexOf(":");
                        key = utils$9.trim(line.substr(0, i)).toLowerCase();
                        val = utils$9.trim(line.substr(i + 1));
                        if (key) {
                            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                                val
                            ]);
                            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
                        }
                    });
                    return parsed;
                };
                var utils$8 = utils$e;
                var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
                    var msie = /(msie|trident)/i.test(navigator.userAgent);
                    var urlParsingNode = document.createElement("a");
                    var originURL;
                    function resolveURL(url) {
                        var href = url;
                        if (msie) {
                            urlParsingNode.setAttribute("href", href);
                            href = urlParsingNode.href;
                        }
                        urlParsingNode.setAttribute("href", href);
                        return {
                            href: urlParsingNode.href,
                            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
                            host: urlParsingNode.host,
                            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
                            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
                            hostname: urlParsingNode.hostname,
                            port: urlParsingNode.port,
                            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
                        };
                    }
                    originURL = resolveURL(window.location.href);
                    return function isURLSameOrigin2(requestURL) {
                        var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                    };
                }() : function nonStandardBrowserEnv2() {
                    return function isURLSameOrigin2() {
                        return true;
                    };
                }();
                function Cancel$3(message) {
                    this.message = message;
                }
                Cancel$3.prototype.toString = function toString2() {
                    return "Cancel" + (this.message ? ": " + this.message : "");
                };
                Cancel$3.prototype.__CANCEL__ = true;
                var Cancel_1 = Cancel$3;
                var utils$7 = utils$e;
                var settle2 = settle$1;
                var cookies = cookies$1;
                var buildURL$1 = buildURL$2;
                var buildFullPath2 = buildFullPath$1;
                var parseHeaders2 = parseHeaders$1;
                var isURLSameOrigin = isURLSameOrigin$1;
                var createError2 = createError$2;
                var defaults$4 = defaults_1;
                var Cancel$2 = Cancel_1;
                var xhr = function xhrAdapter(config) {
                    return new Promise(function dispatchXhrRequest(resolve, reject) {
                        var requestData = config.data;
                        var requestHeaders = config.headers;
                        var responseType = config.responseType;
                        var onCanceled;
                        function done() {
                            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
                            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
                        }
                        if (utils$7.isFormData(requestData)) delete requestHeaders["Content-Type"];
                        var request2 = new XMLHttpRequest();
                        if (config.auth) {
                            var username = config.auth.username || "";
                            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
                            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
                        }
                        var fullPath = buildFullPath2(config.baseURL, config.url);
                        request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
                        request2.timeout = config.timeout;
                        function onloadend() {
                            if (!request2) return;
                            var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
                            var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
                            var response = {
                                data: responseData,
                                status: request2.status,
                                statusText: request2.statusText,
                                headers: responseHeaders,
                                config: config,
                                request: request2
                            };
                            settle2(function _resolve(value) {
                                resolve(value);
                                done();
                            }, function _reject(err) {
                                reject(err);
                                done();
                            }, response);
                            request2 = null;
                        }
                        if ("onloadend" in request2) request2.onloadend = onloadend;
                        else request2.onreadystatechange = function handleLoad() {
                            if (!request2 || request2.readyState !== 4) return;
                            if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) return;
                            setTimeout(onloadend);
                        };
                        request2.onabort = function handleAbort() {
                            if (!request2) return;
                            reject(createError2("Request aborted", config, "ECONNABORTED", request2));
                            request2 = null;
                        };
                        request2.onerror = function handleError() {
                            reject(createError2("Network Error", config, null, request2));
                            request2 = null;
                        };
                        request2.ontimeout = function handleTimeout() {
                            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
                            var transitional2 = config.transitional || defaults$4.transitional;
                            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
                            reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
                            request2 = null;
                        };
                        if (utils$7.isStandardBrowserEnv()) {
                            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
                            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
                        }
                        if ("setRequestHeader" in request2) utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
                            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") delete requestHeaders[key];
                            else request2.setRequestHeader(key, val);
                        });
                        if (!utils$7.isUndefined(config.withCredentials)) request2.withCredentials = !!config.withCredentials;
                        if (responseType && responseType !== "json") request2.responseType = config.responseType;
                        if (typeof config.onDownloadProgress === "function") request2.addEventListener("progress", config.onDownloadProgress);
                        if (typeof config.onUploadProgress === "function" && request2.upload) request2.upload.addEventListener("progress", config.onUploadProgress);
                        if (config.cancelToken || config.signal) {
                            onCanceled = function(cancel) {
                                if (!request2) return;
                                reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
                                request2.abort();
                                request2 = null;
                            };
                            config.cancelToken && config.cancelToken.subscribe(onCanceled);
                            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
                        }
                        if (!requestData) requestData = null;
                        request2.send(requestData);
                    });
                };
                var utils$6 = utils$e;
                var normalizeHeaderName2 = normalizeHeaderName$1;
                var enhanceError2 = enhanceError$2;
                var DEFAULT_CONTENT_TYPE = {
                    "Content-Type": "application/x-www-form-urlencoded"
                };
                function setContentTypeIfUnset(headers, value) {
                    if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
                }
                function getDefaultAdapter() {
                    var adapter;
                    if (typeof XMLHttpRequest !== "undefined") adapter = xhr;
                    else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") adapter = xhr;
                    return adapter;
                }
                function stringifySafely(rawValue, parser, encoder) {
                    if (utils$6.isString(rawValue)) try {
                        (parser || JSON.parse)(rawValue);
                        return utils$6.trim(rawValue);
                    } catch (e) {
                        if (e.name !== "SyntaxError") throw e;
                    }
                    return (encoder || JSON.stringify)(rawValue);
                }
                var defaults$3 = {
                    transitional: {
                        silentJSONParsing: true,
                        forcedJSONParsing: true,
                        clarifyTimeoutError: false
                    },
                    adapter: getDefaultAdapter(),
                    transformRequest: [
                        function transformRequest(data2, headers) {
                            normalizeHeaderName2(headers, "Accept");
                            normalizeHeaderName2(headers, "Content-Type");
                            if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) return data2;
                            if (utils$6.isArrayBufferView(data2)) return data2.buffer;
                            if (utils$6.isURLSearchParams(data2)) {
                                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                                return data2.toString();
                            }
                            if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
                                setContentTypeIfUnset(headers, "application/json");
                                return stringifySafely(data2);
                            }
                            return data2;
                        }
                    ],
                    transformResponse: [
                        function transformResponse(data2) {
                            var transitional2 = this.transitional || defaults$3.transitional;
                            var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
                            var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
                            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
                            if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) try {
                                return JSON.parse(data2);
                            } catch (e) {
                                if (strictJSONParsing) {
                                    if (e.name === "SyntaxError") throw enhanceError2(e, this, "E_JSON_PARSE");
                                    throw e;
                                }
                            }
                            return data2;
                        }
                    ],
                    timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function validateStatus(status) {
                        return status >= 200 && status < 300;
                    },
                    headers: {
                        common: {
                            "Accept": "application/json, text/plain, */*"
                        }
                    }
                };
                utils$6.forEach([
                    "delete",
                    "get",
                    "head"
                ], function forEachMethodNoData(method) {
                    defaults$3.headers[method] = {};
                });
                utils$6.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
                });
                var defaults_1 = defaults$3;
                var utils$5 = utils$e;
                var defaults$2 = defaults_1;
                var transformData$1 = function transformData(data2, headers, fns) {
                    var context = this || defaults$2;
                    utils$5.forEach(fns, function transform(fn) {
                        data2 = fn.call(context, data2, headers);
                    });
                    return data2;
                };
                var isCancel$1 = function isCancel(value) {
                    return !!(value && value.__CANCEL__);
                };
                var utils$4 = utils$e;
                var transformData2 = transformData$1;
                var isCancel2 = isCancel$1;
                var defaults$1 = defaults_1;
                var Cancel$1 = Cancel_1;
                function throwIfCancellationRequested(config) {
                    if (config.cancelToken) config.cancelToken.throwIfRequested();
                    if (config.signal && config.signal.aborted) throw new Cancel$1("canceled");
                }
                var dispatchRequest$1 = function dispatchRequest(config) {
                    throwIfCancellationRequested(config);
                    config.headers = config.headers || {};
                    config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
                    config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
                    utils$4.forEach([
                        "delete",
                        "get",
                        "head",
                        "post",
                        "put",
                        "patch",
                        "common"
                    ], function cleanHeaderConfig(method) {
                        delete config.headers[method];
                    });
                    var adapter = config.adapter || defaults$1.adapter;
                    return adapter(config).then(function onAdapterResolution(response) {
                        throwIfCancellationRequested(config);
                        response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
                        return response;
                    }, function onAdapterRejection(reason) {
                        if (!isCancel2(reason)) {
                            throwIfCancellationRequested(config);
                            if (reason && reason.response) reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
                        }
                        return Promise.reject(reason);
                    });
                };
                var utils$3 = utils$e;
                var mergeConfig$2 = function mergeConfig(config1, config2) {
                    config2 = config2 || {};
                    var config = {};
                    function getMergedValue(target, source2) {
                        if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) return utils$3.merge(target, source2);
                        else if (utils$3.isPlainObject(source2)) return utils$3.merge({}, source2);
                        else if (utils$3.isArray(source2)) return source2.slice();
                        return source2;
                    }
                    function mergeDeepProperties(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
                        else if (!utils$3.isUndefined(config1[prop])) return getMergedValue(void 0, config1[prop]);
                    }
                    function valueFromConfig2(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(void 0, config2[prop]);
                    }
                    function defaultToConfig2(prop) {
                        if (!utils$3.isUndefined(config2[prop])) return getMergedValue(void 0, config2[prop]);
                        else if (!utils$3.isUndefined(config1[prop])) return getMergedValue(void 0, config1[prop]);
                    }
                    function mergeDirectKeys(prop) {
                        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
                        else if (prop in config1) return getMergedValue(void 0, config1[prop]);
                    }
                    var mergeMap = {
                        "url": valueFromConfig2,
                        "method": valueFromConfig2,
                        "data": valueFromConfig2,
                        "baseURL": defaultToConfig2,
                        "transformRequest": defaultToConfig2,
                        "transformResponse": defaultToConfig2,
                        "paramsSerializer": defaultToConfig2,
                        "timeout": defaultToConfig2,
                        "timeoutMessage": defaultToConfig2,
                        "withCredentials": defaultToConfig2,
                        "adapter": defaultToConfig2,
                        "responseType": defaultToConfig2,
                        "xsrfCookieName": defaultToConfig2,
                        "xsrfHeaderName": defaultToConfig2,
                        "onUploadProgress": defaultToConfig2,
                        "onDownloadProgress": defaultToConfig2,
                        "decompress": defaultToConfig2,
                        "maxContentLength": defaultToConfig2,
                        "maxBodyLength": defaultToConfig2,
                        "transport": defaultToConfig2,
                        "httpAgent": defaultToConfig2,
                        "httpsAgent": defaultToConfig2,
                        "cancelToken": defaultToConfig2,
                        "socketPath": defaultToConfig2,
                        "responseEncoding": defaultToConfig2,
                        "validateStatus": mergeDirectKeys
                    };
                    utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
                        var merge2 = mergeMap[prop] || mergeDeepProperties;
                        var configValue = merge2(prop);
                        utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
                    });
                    return config;
                };
                var data = {
                    "version": "0.25.0"
                };
                var VERSION = data.version;
                var validators$1 = {};
                [
                    "object",
                    "boolean",
                    "number",
                    "function",
                    "string",
                    "symbol"
                ].forEach(function(type, i) {
                    validators$1[type] = function validator2(thing) {
                        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
                    };
                });
                var deprecatedWarnings = {};
                validators$1.transitional = function transitional(validator2, version2, message) {
                    function formatMessage(opt, desc) {
                        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
                    }
                    return function(value, opt, opts) {
                        if (validator2 === false) throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
                        if (version2 && !deprecatedWarnings[opt]) {
                            deprecatedWarnings[opt] = true;
                            console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
                        }
                        return validator2 ? validator2(value, opt, opts) : true;
                    };
                };
                function assertOptions(options, schema, allowUnknown) {
                    if (typeof options !== "object") throw new TypeError("options must be an object");
                    var keys = Object.keys(options);
                    var i = keys.length;
                    while(i-- > 0){
                        var opt = keys[i];
                        var validator2 = schema[opt];
                        if (validator2) {
                            var value = options[opt];
                            var result = value === void 0 || validator2(value, opt, options);
                            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
                            continue;
                        }
                        if (allowUnknown !== true) throw Error("Unknown option " + opt);
                    }
                }
                var validator$1 = {
                    assertOptions: assertOptions,
                    validators: validators$1
                };
                var utils$2 = utils$e;
                var buildURL2 = buildURL$2;
                var InterceptorManager = InterceptorManager_1;
                var dispatchRequest2 = dispatchRequest$1;
                var mergeConfig$1 = mergeConfig$2;
                var validator = validator$1;
                var validators = validator.validators;
                function Axios$1(instanceConfig) {
                    this.defaults = instanceConfig;
                    this.interceptors = {
                        request: new InterceptorManager(),
                        response: new InterceptorManager()
                    };
                }
                Axios$1.prototype.request = function request(configOrUrl, config) {
                    if (typeof configOrUrl === "string") {
                        config = config || {};
                        config.url = configOrUrl;
                    } else config = configOrUrl || {};
                    if (!config.url) throw new Error("Provided config url is not valid");
                    config = mergeConfig$1(this.defaults, config);
                    if (config.method) config.method = config.method.toLowerCase();
                    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
                    else config.method = "get";
                    var transitional2 = config.transitional;
                    if (transitional2 !== void 0) validator.assertOptions(transitional2, {
                        silentJSONParsing: validators.transitional(validators.boolean),
                        forcedJSONParsing: validators.transitional(validators.boolean),
                        clarifyTimeoutError: validators.transitional(validators.boolean)
                    }, false);
                    var requestInterceptorChain = [];
                    var synchronousRequestInterceptors = true;
                    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                    });
                    var responseInterceptorChain = [];
                    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                    });
                    var promise;
                    if (!synchronousRequestInterceptors) {
                        var chain = [
                            dispatchRequest2,
                            void 0
                        ];
                        Array.prototype.unshift.apply(chain, requestInterceptorChain);
                        chain = chain.concat(responseInterceptorChain);
                        promise = Promise.resolve(config);
                        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
                        return promise;
                    }
                    var newConfig = config;
                    while(requestInterceptorChain.length){
                        var onFulfilled = requestInterceptorChain.shift();
                        var onRejected = requestInterceptorChain.shift();
                        try {
                            newConfig = onFulfilled(newConfig);
                        } catch (error) {
                            onRejected(error);
                            break;
                        }
                    }
                    try {
                        promise = dispatchRequest2(newConfig);
                    } catch (error) {
                        return Promise.reject(error);
                    }
                    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
                    return promise;
                };
                Axios$1.prototype.getUri = function getUri(config) {
                    if (!config.url) throw new Error("Provided config url is not valid");
                    config = mergeConfig$1(this.defaults, config);
                    return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
                };
                utils$2.forEach([
                    "delete",
                    "get",
                    "head",
                    "options"
                ], function forEachMethodNoData2(method) {
                    Axios$1.prototype[method] = function(url, config) {
                        return this.request(mergeConfig$1(config || {}, {
                            method: method,
                            url: url,
                            data: (config || {}).data
                        }));
                    };
                });
                utils$2.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData2(method) {
                    Axios$1.prototype[method] = function(url, data2, config) {
                        return this.request(mergeConfig$1(config || {}, {
                            method: method,
                            url: url,
                            data: data2
                        }));
                    };
                });
                var Axios_1 = Axios$1;
                var Cancel = Cancel_1;
                function CancelToken(executor) {
                    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
                    var resolvePromise;
                    this.promise = new Promise(function promiseExecutor(resolve) {
                        resolvePromise = resolve;
                    });
                    var token = this;
                    this.promise.then(function(cancel) {
                        if (!token._listeners) return;
                        var i;
                        var l = token._listeners.length;
                        for(i = 0; i < l; i++)token._listeners[i](cancel);
                        token._listeners = null;
                    });
                    this.promise.then = function(onfulfilled) {
                        var _resolve;
                        var promise = new Promise(function(resolve) {
                            token.subscribe(resolve);
                            _resolve = resolve;
                        }).then(onfulfilled);
                        promise.cancel = function reject() {
                            token.unsubscribe(_resolve);
                        };
                        return promise;
                    };
                    executor(function cancel(message) {
                        if (token.reason) return;
                        token.reason = new Cancel(message);
                        resolvePromise(token.reason);
                    });
                }
                CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                    if (this.reason) throw this.reason;
                };
                CancelToken.prototype.subscribe = function subscribe(listener) {
                    if (this.reason) {
                        listener(this.reason);
                        return;
                    }
                    if (this._listeners) this._listeners.push(listener);
                    else this._listeners = [
                        listener
                    ];
                };
                CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
                    if (!this._listeners) return;
                    var index = this._listeners.indexOf(listener);
                    if (index !== -1) this._listeners.splice(index, 1);
                };
                CancelToken.source = function source() {
                    var cancel;
                    var token = new CancelToken(function executor(c) {
                        cancel = c;
                    });
                    return {
                        token: token,
                        cancel: cancel
                    };
                };
                var CancelToken_1 = CancelToken;
                var spread = function spread2(callback) {
                    return function wrap(arr) {
                        return callback.apply(null, arr);
                    };
                };
                var utils$1 = utils$e;
                var isAxiosError = function isAxiosError2(payload) {
                    return utils$1.isObject(payload) && payload.isAxiosError === true;
                };
                var utils = utils$e;
                var bind2 = bind$2;
                var Axios = Axios_1;
                var mergeConfig2 = mergeConfig$2;
                var defaults = defaults_1;
                function createInstance(defaultConfig) {
                    var context = new Axios(defaultConfig);
                    var instance = bind2(Axios.prototype.request, context);
                    utils.extend(instance, Axios.prototype, context);
                    utils.extend(instance, context);
                    instance.create = function create(instanceConfig) {
                        return createInstance(mergeConfig2(defaultConfig, instanceConfig));
                    };
                    return instance;
                }
                var axios$1 = createInstance(defaults);
                axios$1.Axios = Axios;
                axios$1.Cancel = Cancel_1;
                axios$1.CancelToken = CancelToken_1;
                axios$1.isCancel = isCancel$1;
                axios$1.VERSION = data.version;
                axios$1.all = function all(promises) {
                    return Promise.all(promises);
                };
                axios$1.spread = spread;
                axios$1.isAxiosError = isAxiosError;
                axios$2.exports = axios$1;
                axios$2.exports.default = axios$1;
                var axios = axios$2.exports;
                class Optional {
                    isEmpty() {
                        return !this.isPresent();
                    }
                    static of(value) {
                        if (value !== null && value !== void 0) return new PresentOptional(value);
                        else throw new TypeError("The passed value was null or undefined.");
                    }
                    static ofNonNull(value) {
                        return Optional.of(value);
                    }
                    static ofNullable(nullable) {
                        if (nullable !== null && nullable !== void 0) return new PresentOptional(nullable);
                        else return new EmptyOptional();
                    }
                    static empty() {
                        return new EmptyOptional();
                    }
                    static from(option) {
                        switch(option.kind){
                            case "present":
                                return Optional.of(option.value);
                            case "empty":
                                return Optional.empty();
                            default:
                                throw new TypeError("The passed value was not an Option type.");
                        }
                    }
                }
                class PresentOptional extends Optional {
                    constructor(value){
                        super();
                        this.payload = value;
                    }
                    isPresent() {
                        return true;
                    }
                    get() {
                        return this.payload;
                    }
                    ifPresent(consumer) {
                        consumer(this.payload);
                    }
                    ifPresentOrElse(consumer, emptyAction) {
                        consumer(this.payload);
                    }
                    filter(predicate) {
                        return predicate(this.payload) ? this : Optional.empty();
                    }
                    map(mapper) {
                        const result = mapper(this.payload);
                        return Optional.ofNullable(result);
                    }
                    flatMap(mapper) {
                        return mapper(this.payload);
                    }
                    or(supplier) {
                        return this;
                    }
                    orElse(another) {
                        return this.payload;
                    }
                    orElseGet(another) {
                        return this.payload;
                    }
                    orElseThrow(exception) {
                        return this.payload;
                    }
                    orNull() {
                        return this.payload;
                    }
                    orUndefined() {
                        return this.payload;
                    }
                    toOption() {
                        return {
                            kind: "present",
                            value: this.payload
                        };
                    }
                    matches(cases) {
                        return cases.present(this.payload);
                    }
                    toJSON(key) {
                        return this.payload;
                    }
                }
                class EmptyOptional extends Optional {
                    isPresent() {
                        return false;
                    }
                    constructor(){
                        super();
                    }
                    get() {
                        throw new TypeError("The optional is not present.");
                    }
                    ifPresent(consumer) {}
                    ifPresentOrElse(consumer, emptyAction) {
                        emptyAction();
                    }
                    filter(predicate) {
                        return this;
                    }
                    map(mapper) {
                        return Optional.empty();
                    }
                    flatMap(mapper) {
                        return Optional.empty();
                    }
                    or(supplier) {
                        return supplier();
                    }
                    orElse(another) {
                        return another;
                    }
                    orElseGet(another) {
                        return this.orElse(another());
                    }
                    orElseThrow(exception) {
                        throw exception();
                    }
                    orNull() {
                        return null;
                    }
                    orUndefined() {
                        return void 0;
                    }
                    toOption() {
                        return {
                            kind: "empty"
                        };
                    }
                    matches(cases) {
                        return cases.empty();
                    }
                    toJSON(key) {
                        return null;
                    }
                }
                const version = "1.2.7";
                function setVonageMetadata(metadata) {
                    globalThis._vonageMediaProcessorMetadata = metadata;
                }
                function getVonageMetadata() {
                    return globalThis._vonageMediaProcessorMetadata;
                }
                class ReportBuilder {
                    constructor(){
                        const metadata = getVonageMetadata();
                        this._report = {
                            action: Optional.empty(),
                            applicationId: Optional.ofNullable(metadata !== void 0 && metadata != null ? metadata.appId : null),
                            timestamp: Date.now(),
                            fps: Optional.empty(),
                            framesTransformed: Optional.empty(),
                            guid: Optional.empty(),
                            highestFrameTransformCpu: Optional.empty(),
                            message: Optional.empty(),
                            source: Optional.ofNullable(metadata !== void 0 && metadata != null ? metadata.sourceType : null),
                            transformedFps: Optional.empty(),
                            transformerType: Optional.empty(),
                            variation: Optional.empty(),
                            videoHeight: Optional.empty(),
                            videoWidth: Optional.empty(),
                            version: version,
                            error: Optional.empty(),
                            proxyUrl: Optional.ofNullable(metadata !== void 0 && metadata != null ? metadata.proxyUrl : null)
                        };
                    }
                    action(action) {
                        this._report.action = Optional.ofNullable(action);
                        return this;
                    }
                    framesTransformed(framesTransformed) {
                        this._report.framesTransformed = Optional.ofNullable(framesTransformed);
                        return this;
                    }
                    fps(fps) {
                        this._report.fps = Optional.ofNullable(fps);
                        return this;
                    }
                    guid(guid) {
                        this._report.guid = Optional.ofNullable(guid);
                        return this;
                    }
                    message(message) {
                        this._report.message = Optional.ofNullable(message);
                        return this;
                    }
                    transformedFps(transformedFps) {
                        this._report.transformedFps = Optional.ofNullable(transformedFps);
                        return this;
                    }
                    transformerType(transformerType) {
                        this._report.transformerType = Optional.ofNullable(transformerType);
                        return this;
                    }
                    variation(variation) {
                        this._report.variation = Optional.ofNullable(variation);
                        return this;
                    }
                    videoHeight(videoHeight) {
                        this._report.videoHeight = Optional.ofNullable(videoHeight);
                        return this;
                    }
                    videoWidth(videoWidth) {
                        this._report.videoWidth = Optional.ofNullable(videoWidth);
                        return this;
                    }
                    error(error) {
                        this._report.error = Optional.ofNullable(error);
                        return this;
                    }
                    build() {
                        return this._report;
                    }
                }
                const serializeReport = (report)=>{
                    return JSON.stringify(report, (key, value)=>{
                        if (value !== null) return value;
                    });
                };
                class Reporter {
                    static report(report) {
                        return new Promise((resolve, reject)=>{
                            if (report.applicationId.isEmpty() || report.source.isEmpty()) {
                                resolve("success");
                                return;
                            }
                            let axiosInstance = axios.create();
                            let config = {
                                timeout: 1e4,
                                timeoutErrorMessage: "Request timeout",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            };
                            let telemetryServerUrl = "hlg.tokbox.com/prod/logging/vcp_webrtc";
                            if (!report.proxyUrl.isEmpty()) {
                                let proxy;
                                if (report.proxyUrl.get().slice(report.proxyUrl.get().length - 1) !== "/") proxy = report.proxyUrl.get() + "/";
                                else proxy = report.proxyUrl.get();
                                telemetryServerUrl = proxy + telemetryServerUrl;
                            } else telemetryServerUrl = "https://" + telemetryServerUrl;
                            axiosInstance.post(telemetryServerUrl, serializeReport(report), config).then((res)=>{
                                console.log(res);
                                resolve("success");
                            }).catch((e)=>{
                                console.log(e);
                                reject(e);
                            });
                        });
                    }
                }
                var getRandomValues;
                var rnds8 = new Uint8Array(16);
                function rng() {
                    if (!getRandomValues) {
                        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
                        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    }
                    return getRandomValues(rnds8);
                }
                var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                function validate(uuid) {
                    return typeof uuid === "string" && REGEX.test(uuid);
                }
                var byteToHex = [];
                for(var i = 0; i < 256; ++i)byteToHex.push((i + 256).toString(16).substr(1));
                function stringify(arr) {
                    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
                    if (!validate(uuid)) throw TypeError("Stringified UUID is invalid");
                    return uuid;
                }
                function v4(options, buf, offset) {
                    options = options || {};
                    var rnds = options.random || (options.rng || rng)();
                    rnds[6] = rnds[6] & 15 | 64;
                    rnds[8] = rnds[8] & 63 | 128;
                    if (buf) {
                        offset = offset || 0;
                        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
                        return buf;
                    }
                    return stringify(rnds);
                }
                const anyMap = new WeakMap();
                const eventsMap = new WeakMap();
                const producersMap = new WeakMap();
                const anyProducer = Symbol("anyProducer");
                const resolvedPromise = Promise.resolve();
                const listenerAdded = Symbol("listenerAdded");
                const listenerRemoved = Symbol("listenerRemoved");
                let isGlobalDebugEnabled = false;
                function assertEventName(eventName) {
                    if (typeof eventName !== "string" && typeof eventName !== "symbol") throw new TypeError("eventName must be a string or a symbol");
                }
                function assertListener(listener) {
                    if (typeof listener !== "function") throw new TypeError("listener must be a function");
                }
                function getListeners(instance, eventName) {
                    const events = eventsMap.get(instance);
                    if (!events.has(eventName)) events.set(eventName, new Set());
                    return events.get(eventName);
                }
                function getEventProducers(instance, eventName) {
                    const key = typeof eventName === "string" || typeof eventName === "symbol" ? eventName : anyProducer;
                    const producers = producersMap.get(instance);
                    if (!producers.has(key)) producers.set(key, new Set());
                    return producers.get(key);
                }
                function enqueueProducers(instance, eventName, eventData) {
                    const producers = producersMap.get(instance);
                    if (producers.has(eventName)) for (const producer of producers.get(eventName))producer.enqueue(eventData);
                    if (producers.has(anyProducer)) {
                        const item = Promise.all([
                            eventName,
                            eventData
                        ]);
                        for (const producer of producers.get(anyProducer))producer.enqueue(item);
                    }
                }
                function iterator(instance, eventNames) {
                    eventNames = Array.isArray(eventNames) ? eventNames : [
                        eventNames
                    ];
                    let isFinished = false;
                    let flush = ()=>{};
                    let queue = [];
                    const producer = {
                        enqueue (item) {
                            queue.push(item);
                            flush();
                        },
                        finish () {
                            isFinished = true;
                            flush();
                        }
                    };
                    for (const eventName of eventNames)getEventProducers(instance, eventName).add(producer);
                    return {
                        async next () {
                            if (!queue) return {
                                done: true
                            };
                            if (queue.length === 0) {
                                if (isFinished) {
                                    queue = void 0;
                                    return this.next();
                                }
                                await new Promise((resolve)=>{
                                    flush = resolve;
                                });
                                return this.next();
                            }
                            return {
                                done: false,
                                value: await queue.shift()
                            };
                        },
                        async return (value) {
                            queue = void 0;
                            for (const eventName of eventNames)getEventProducers(instance, eventName).delete(producer);
                            flush();
                            return arguments.length > 0 ? {
                                done: true,
                                value: await value
                            } : {
                                done: true
                            };
                        },
                        [Symbol.asyncIterator] () {
                            return this;
                        }
                    };
                }
                function defaultMethodNamesOrAssert(methodNames) {
                    if (methodNames === void 0) return allEmitteryMethods;
                    if (!Array.isArray(methodNames)) throw new TypeError("`methodNames` must be an array of strings");
                    for (const methodName of methodNames)if (!allEmitteryMethods.includes(methodName)) {
                        if (typeof methodName !== "string") throw new TypeError("`methodNames` element must be a string");
                        throw new Error(`${methodName} is not Emittery method`);
                    }
                    return methodNames;
                }
                const isListenerSymbol = (symbol)=>symbol === listenerAdded || symbol === listenerRemoved;
                class Emittery {
                    static mixin(emitteryPropertyName, methodNames) {
                        methodNames = defaultMethodNamesOrAssert(methodNames);
                        return (target)=>{
                            if (typeof target !== "function") throw new TypeError("`target` must be function");
                            for (const methodName of methodNames){
                                if (target.prototype[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            }
                            function getEmitteryProperty() {
                                Object.defineProperty(this, emitteryPropertyName, {
                                    enumerable: false,
                                    value: new Emittery()
                                });
                                return this[emitteryPropertyName];
                            }
                            Object.defineProperty(target.prototype, emitteryPropertyName, {
                                enumerable: false,
                                get: getEmitteryProperty
                            });
                            const emitteryMethodCaller = (methodName)=>function(...args) {
                                    return this[emitteryPropertyName][methodName](...args);
                                };
                            for (const methodName of methodNames)Object.defineProperty(target.prototype, methodName, {
                                enumerable: false,
                                value: emitteryMethodCaller(methodName)
                            });
                            return target;
                        };
                    }
                    static get isDebugEnabled() {
                        if (typeof process !== "object") return isGlobalDebugEnabled;
                        const { env } = process || {
                            env: {}
                        };
                        return env.DEBUG === "emittery" || env.DEBUG === "*" || isGlobalDebugEnabled;
                    }
                    static set isDebugEnabled(newValue) {
                        isGlobalDebugEnabled = newValue;
                    }
                    constructor(options = {}){
                        anyMap.set(this, new Set());
                        eventsMap.set(this, new Map());
                        producersMap.set(this, new Map());
                        this.debug = options.debug || {};
                        if (this.debug.enabled === void 0) this.debug.enabled = false;
                        if (!this.debug.logger) this.debug.logger = (type, debugName, eventName, eventData)=>{
                            eventData = JSON.stringify(eventData);
                            if (typeof eventName === "symbol") eventName = eventName.toString();
                            const currentTime = new Date();
                            const logTime = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;
                            console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);
                        };
                    }
                    logIfDebugEnabled(type, eventName, eventData) {
                        if (Emittery.isDebugEnabled || this.debug.enabled) this.debug.logger(type, this.debug.name, eventName, eventData);
                    }
                    on(eventNames, listener) {
                        assertListener(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName(eventName);
                            getListeners(this, eventName).add(listener);
                            this.logIfDebugEnabled("subscribe", eventName, void 0);
                            if (!isListenerSymbol(eventName)) this.emit(listenerAdded, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                        return this.off.bind(this, eventNames, listener);
                    }
                    off(eventNames, listener) {
                        assertListener(listener);
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            assertEventName(eventName);
                            getListeners(this, eventName).delete(listener);
                            this.logIfDebugEnabled("unsubscribe", eventName, void 0);
                            if (!isListenerSymbol(eventName)) this.emit(listenerRemoved, {
                                eventName: eventName,
                                listener: listener
                            });
                        }
                    }
                    once(eventNames) {
                        return new Promise((resolve)=>{
                            const off = this.on(eventNames, (data2)=>{
                                off();
                                resolve(data2);
                            });
                        });
                    }
                    events(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames)assertEventName(eventName);
                        return iterator(this, eventNames);
                    }
                    async emit(eventName, eventData) {
                        assertEventName(eventName);
                        this.logIfDebugEnabled("emit", eventName, eventData);
                        enqueueProducers(this, eventName, eventData);
                        const listeners = getListeners(this, eventName);
                        const anyListeners = anyMap.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = isListenerSymbol(eventName) ? [] : [
                            ...anyListeners
                        ];
                        await resolvedPromise;
                        await Promise.all([
                            ...staticListeners.map(async (listener)=>{
                                if (listeners.has(listener)) return listener(eventData);
                            }),
                            ...staticAnyListeners.map(async (listener)=>{
                                if (anyListeners.has(listener)) return listener(eventName, eventData);
                            })
                        ]);
                    }
                    async emitSerial(eventName, eventData) {
                        assertEventName(eventName);
                        this.logIfDebugEnabled("emitSerial", eventName, eventData);
                        const listeners = getListeners(this, eventName);
                        const anyListeners = anyMap.get(this);
                        const staticListeners = [
                            ...listeners
                        ];
                        const staticAnyListeners = [
                            ...anyListeners
                        ];
                        await resolvedPromise;
                        for (const listener of staticListeners)if (listeners.has(listener)) await listener(eventData);
                        for (const listener of staticAnyListeners)if (anyListeners.has(listener)) await listener(eventName, eventData);
                    }
                    onAny(listener) {
                        assertListener(listener);
                        this.logIfDebugEnabled("subscribeAny", void 0, void 0);
                        anyMap.get(this).add(listener);
                        this.emit(listenerAdded, {
                            listener: listener
                        });
                        return this.offAny.bind(this, listener);
                    }
                    anyEvent() {
                        return iterator(this);
                    }
                    offAny(listener) {
                        assertListener(listener);
                        this.logIfDebugEnabled("unsubscribeAny", void 0, void 0);
                        this.emit(listenerRemoved, {
                            listener: listener
                        });
                        anyMap.get(this).delete(listener);
                    }
                    clearListeners(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        for (const eventName of eventNames){
                            this.logIfDebugEnabled("clear", eventName, void 0);
                            if (typeof eventName === "string" || typeof eventName === "symbol") {
                                getListeners(this, eventName).clear();
                                const producers = getEventProducers(this, eventName);
                                for (const producer of producers)producer.finish();
                                producers.clear();
                            } else {
                                anyMap.get(this).clear();
                                for (const listeners of eventsMap.get(this).values())listeners.clear();
                                for (const producers of producersMap.get(this).values()){
                                    for (const producer of producers)producer.finish();
                                    producers.clear();
                                }
                            }
                        }
                    }
                    listenerCount(eventNames) {
                        eventNames = Array.isArray(eventNames) ? eventNames : [
                            eventNames
                        ];
                        let count = 0;
                        for (const eventName of eventNames){
                            if (typeof eventName === "string") {
                                count += anyMap.get(this).size + getListeners(this, eventName).size + getEventProducers(this, eventName).size + getEventProducers(this).size;
                                continue;
                            }
                            if (typeof eventName !== "undefined") assertEventName(eventName);
                            count += anyMap.get(this).size;
                            for (const value of eventsMap.get(this).values())count += value.size;
                            for (const value of producersMap.get(this).values())count += value.size;
                        }
                        return count;
                    }
                    bindMethods(target, methodNames) {
                        if (typeof target !== "object" || target === null) throw new TypeError("`target` must be an object");
                        methodNames = defaultMethodNamesOrAssert(methodNames);
                        for (const methodName of methodNames){
                            if (target[methodName] !== void 0) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
                            Object.defineProperty(target, methodName, {
                                enumerable: false,
                                value: this[methodName].bind(this)
                            });
                        }
                    }
                }
                const allEmitteryMethods = Object.getOwnPropertyNames(Emittery.prototype).filter((v)=>v !== "constructor");
                Object.defineProperty(Emittery, "listenerAdded", {
                    value: listenerAdded,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                Object.defineProperty(Emittery, "listenerRemoved", {
                    value: listenerRemoved,
                    writable: false,
                    enumerable: true,
                    configurable: false
                });
                var emittery = Emittery;
                function isErrorWithMessage(error) {
                    return typeof error === "object" && error !== null && "message" in error && typeof error.message === "string";
                }
                function toErrorWithMessage(maybeError) {
                    if (isErrorWithMessage(maybeError)) return maybeError;
                    try {
                        return new Error(JSON.stringify(maybeError));
                    } catch  {
                        return new Error(String(maybeError));
                    }
                }
                function getErrorMessage(error) {
                    return toErrorWithMessage(error).message;
                }
                var WarningType;
                (function(WarningType2) {
                    WarningType2["FPS_DROP"] = "fps_drop";
                })(WarningType || (WarningType = {}));
                const TELEMETRY_MEDIA_TRANSFORMER_QOS_REPORT_INTERVAL = 500;
                const RATE_DROP_TO_PRECENT = 0.8;
                class InternalTransformer extends emittery {
                    constructor(transformer, index){
                        super();
                        this.index_ = index;
                        this.uuid_ = v4();
                        this.framesTransformed_ = 0;
                        this.transformer_ = transformer;
                        this.shouldStop_ = false;
                        this.isFlashed_ = false;
                        this.framesFromSource_ = 0;
                        this.fps_ = 0;
                        this.mediaTransformerQosReportStartTimestamp_ = 0;
                        this.videoHeight_ = 0;
                        this.videoWidth_ = 0;
                        this.trackExpectedRate_ = -1;
                        this.transformerType_ = "Custom";
                        if ("getTransformerType" in transformer) this.transformerType_ = transformer.getTransformerType();
                        const report = new ReportBuilder().action("MediaTransformer").guid(this.uuid_).transformerType(this.transformerType_).variation("Create").build();
                        Reporter.report(report);
                    }
                    setTrackExpectedRate(trackExpectedRate) {
                        this.trackExpectedRate_ = trackExpectedRate;
                    }
                    async start(controller) {
                        this.controller_ = controller;
                        if (this.transformer_ && typeof this.transformer_.start === "function") try {
                            await this.transformer_.start(controller);
                        } catch (e) {
                            const report = new ReportBuilder().action("MediaTransformer").guid(this.uuid_).message(Key.errors["transformer_start"]).transformerType(this.transformerType_).variation("Error").error(getErrorMessage(e)).build();
                            Reporter.report(report);
                            const msg = {
                                eventMetaData: {
                                    transformerIndex: this.index_
                                },
                                error: e,
                                function: "start"
                            };
                            this.emit("error", msg);
                        }
                    }
                    async transform(data2, controller) {
                        var _a, _b, _c, _d;
                        if (this.mediaTransformerQosReportStartTimestamp_ === 0) this.mediaTransformerQosReportStartTimestamp_ = Date.now();
                        if (data2 instanceof VideoFrame) {
                            this.videoHeight_ = (_a = data2 == null ? void 0 : data2.displayHeight) != null ? _a : 0;
                            this.videoWidth_ = (_b = data2 == null ? void 0 : data2.displayWidth) != null ? _b : 0;
                        }
                        ++this.framesFromSource_;
                        if (this.transformer_) {
                            if (!this.shouldStop_) try {
                                await ((_d = (_c = this.transformer_).transform) == null ? void 0 : _d.call(_c, data2, controller));
                                ++this.framesTransformed_;
                                if (this.framesTransformed_ === TELEMETRY_MEDIA_TRANSFORMER_QOS_REPORT_INTERVAL) this.mediaTransformerQosReport();
                            } catch (e) {
                                const report = new ReportBuilder().action("MediaTransformer").guid(this.uuid_).message(Key.errors["transformer_transform"]).transformerType(this.transformerType_).variation("Error").error(getErrorMessage(e)).build();
                                Reporter.report(report);
                                const msg = {
                                    eventMetaData: {
                                        transformerIndex: this.index_
                                    },
                                    error: e,
                                    function: "transform"
                                };
                                this.emit("error", msg);
                            }
                            else {
                                console.warn("[Pipeline] flush from transform");
                                data2.close();
                                this.flush(controller);
                                controller.terminate();
                            }
                        }
                    }
                    async flush(controller) {
                        if (this.transformer_ && typeof this.transformer_.flush === "function" && !this.isFlashed_) {
                            this.isFlashed_ = true;
                            try {
                                await this.transformer_.flush(controller);
                            } catch (e) {
                                const error = new ReportBuilder().action("MediaTransformer").guid(this.uuid_).message(Key.errors["transformer_flush"]).transformerType(this.transformerType_).variation("Error").error(getErrorMessage(e)).build();
                                Reporter.report(error);
                                const msg = {
                                    eventMetaData: {
                                        transformerIndex: this.index_
                                    },
                                    error: e,
                                    function: "flush"
                                };
                                this.emit("error", msg);
                            }
                        }
                        this.mediaTransformerQosReport();
                        const deleteReport = new ReportBuilder().action("MediaTransformer").guid(this.uuid_).transformerType(this.transformerType_).variation("Delete").build();
                        Reporter.report(deleteReport);
                    }
                    stop() {
                        console.log("[Pipeline] Stop stream.");
                        if (this.controller_) {
                            this.flush(this.controller_);
                            this.controller_.terminate();
                        }
                        this.shouldStop_ = true;
                    }
                    mediaTransformerQosReport() {
                        let timeElapsed_s = (Date.now() - this.mediaTransformerQosReportStartTimestamp_) / 1e3;
                        let fps = this.framesFromSource_ / timeElapsed_s;
                        let transformedFps = this.framesTransformed_ / timeElapsed_s;
                        if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * RATE_DROP_TO_PRECENT > fps) {
                            const msg = {
                                eventMetaData: {
                                    transformerIndex: this.index_
                                },
                                warningType: WarningType.FPS_DROP,
                                dropInfo: {
                                    requested: this.trackExpectedRate_,
                                    current: fps
                                }
                            };
                            this.emit("warn", msg);
                        }
                        const qos = new ReportBuilder().action("MediaTransformer").fps(fps).transformedFps(transformedFps).framesTransformed(this.framesTransformed_).guid(this.uuid_).transformerType(this.transformerType_).videoHeight(this.videoHeight_).videoWidth(this.videoWidth_).variation("QoS").build();
                        Reporter.report(qos);
                        this.mediaTransformerQosReportStartTimestamp_ = 0;
                        this.framesFromSource_ = 0;
                        this.framesTransformed_ = 0;
                    }
                }
                class Pipeline extends emittery {
                    constructor(transformers){
                        super();
                        this.transformers_ = [];
                        this.trackExpectedRate_ = -1;
                        for(let index = 0; index < transformers.length; index++){
                            let internalTransformer = new InternalTransformer(transformers[index], index);
                            internalTransformer.on("error", (eventData)=>{
                                this.emit("error", eventData);
                            });
                            internalTransformer.on("warn", (eventData)=>{
                                this.emit("warn", eventData);
                            });
                            this.transformers_.push(internalTransformer);
                        }
                    }
                    setTrackExpectedRate(trackExpectedRate) {
                        this.trackExpectedRate_ = trackExpectedRate;
                        for (let transformer of this.transformers_)transformer.setTrackExpectedRate(this.trackExpectedRate_);
                    }
                    async start(readable, writeable) {
                        if (!this.transformers_ || this.transformers_.length === 0) {
                            console.log("[Pipeline] No transformers.");
                            return;
                        }
                        try {
                            let orgReader = readable;
                            for (let transformer of this.transformers_)readable = readable.pipeThrough(new TransformStream(transformer));
                            readable.pipeTo(writeable).then(async ()=>{
                                console.log("[Pipeline] Setup.");
                                await writeable.abort();
                                await orgReader.cancel();
                                this.emit("pipelineInfo", {
                                    message: "pipeline_ended"
                                });
                            }).catch(async (e)=>{
                                readable.cancel().then(()=>{
                                    console.log("[Pipeline] Shutting down streams after abort.");
                                }).catch((e2)=>{
                                    console.error("[Pipeline] Error from stream transform:", e2);
                                });
                                await writeable.abort(e);
                                await orgReader.cancel(e);
                                this.emit("pipelineInfo", {
                                    message: "pipeline_ended_with_error"
                                });
                            });
                        } catch (e) {
                            this.emit("pipelineInfo", {
                                message: "pipeline_started_with_error"
                            });
                            this.destroy();
                            return;
                        }
                        this.emit("pipelineInfo", {
                            message: "pipeline_started"
                        });
                        console.log("[Pipeline] Pipeline started.");
                    }
                    async destroy() {
                        console.log("[Pipeline] Destroying Pipeline.");
                        for (let transformer of this.transformers_)transformer.stop();
                    }
                }
                class MediaProcessor extends emittery {
                    constructor(){
                        super();
                        this.uuid_ = v4();
                        this.trackExpectedRate_ = -1;
                        const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).variation("Create").build();
                        Reporter.report(report);
                    }
                    setTrackExpectedRate(trackExpectedRate) {
                        this.trackExpectedRate_ = trackExpectedRate;
                        if (this.pipeline_) this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
                    }
                    transform(readable, writable) {
                        this.readable_ = readable;
                        this.writable_ = writable;
                        return this.transformInternal();
                    }
                    transformInternal() {
                        return new Promise((resolve, reject)=>{
                            if (!this.transformers_ || this.transformers_.length === 0) {
                                const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).message(Key.errors["transformer_none"]).variation("Error").build();
                                Reporter.report(report);
                                reject("[MediaProcessor] Need to set transformers.");
                                return;
                            }
                            if (!this.readable_) {
                                const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).message(Key.errors["readable_null"]).variation("Error").build();
                                Reporter.report(report);
                                reject("[MediaProcessor] Readable is null.");
                                return;
                            }
                            if (!this.writable_) {
                                const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).message(Key.errors["writable_null"]).variation("Error").build();
                                Reporter.report(report);
                                reject("[MediaProcessor] Writable is null.");
                                return;
                            }
                            let isPipelineReset = false;
                            if (this.pipeline_) {
                                isPipelineReset = true;
                                this.pipeline_.clearListeners();
                                this.pipeline_.destroy();
                            }
                            this.pipeline_ = new Pipeline(this.transformers_);
                            this.pipeline_.on("warn", (eventData)=>{
                                this.emit("warn", eventData);
                            });
                            this.pipeline_.on("error", (eventData)=>{
                                this.emit("error", eventData);
                            });
                            this.pipeline_.on("pipelineInfo", (eventData)=>{
                                if (isPipelineReset) {
                                    if (eventData.message === "pipeline_started") eventData.message = "pipeline_restarted";
                                    else if (eventData.message === "pipeline_started_with_error") eventData.message = "pipeline_restarted_with_error";
                                }
                                this.emit("pipelineInfo", eventData);
                            });
                            if (this.trackExpectedRate_ != -1) this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
                            this.pipeline_.start(this.readable_, this.writable_).then(()=>{
                                resolve();
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    setTransformers(transformers) {
                        const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).message(Key.updates["transformer_new"]).variation("Update").build();
                        Reporter.report(report);
                        this.transformers_ = transformers;
                        if (this.readable_ && this.writable_) return this.transformInternal();
                        return Promise.resolve();
                    }
                    destroy() {
                        return new Promise((resolve)=>{
                            if (this.pipeline_) this.pipeline_.destroy();
                            const report = new ReportBuilder().action("MediaProcessor").guid(this.uuid_).variation("Delete").build();
                            Reporter.report(report);
                            resolve();
                        });
                    }
                }
                class InsertableStreamHelper {
                    constructor(){
                        this.processor_ = null;
                        this.generator_ = null;
                    }
                    init(track) {
                        return new Promise((resolve, reject)=>{
                            try {
                                this.processor_ = new MediaStreamTrackProcessor(track);
                            } catch (e) {
                                console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${e}`);
                                reject(e);
                            }
                            try {
                                if (track.kind === "audio") this.generator_ = new MediaStreamTrackGenerator({
                                    kind: "audio"
                                });
                                else if (track.kind === "video") this.generator_ = new MediaStreamTrackGenerator({
                                    kind: "video"
                                });
                                else reject("kind not supported");
                            } catch (e) {
                                console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${e}`);
                                reject(e);
                            }
                            resolve();
                        });
                    }
                    getReadable() {
                        return this.processor_.readable;
                    }
                    getWriteable() {
                        return this.generator_.writable;
                    }
                    getProccesorTrack() {
                        return this.generator_;
                    }
                }
                class MediaProcessorConnector {
                    constructor(vonageMediaProcessor){
                        this.insertableStreamHelper_ = new InsertableStreamHelper();
                        this.mediaProcessor_ = vonageMediaProcessor;
                    }
                    setTrack(track) {
                        return new Promise((resolve, reject)=>{
                            this.insertableStreamHelper_.init(track).then(()=>{
                                this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(()=>{
                                    resolve(this.insertableStreamHelper_.getProccesorTrack());
                                }).catch((e)=>{
                                    reject(e);
                                });
                            }).catch((e)=>{
                                reject(e);
                            });
                        });
                    }
                    destroy() {
                        return new Promise((resolve, reject)=>{
                            if (this.mediaProcessor_) this.mediaProcessor_.destroy().then(()=>{
                                resolve();
                            }).catch((e)=>{
                                reject(e);
                            });
                            else reject("no processor");
                        });
                    }
                }
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0), __webpack_require__(43));
        /***/ },
        /* 698 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable global-require */ // These are all the transformers we support
            const filterToConfiguratorMap = {
                backgroundBlur: __webpack_require__(699),
                backgroundReplacement: __webpack_require__(700)
            };
            const isSupported = (type)=>!!filterToConfiguratorMap[type];
            const getConfigurator = (type)=>{
                if (!isSupported(type)) return null;
                return filterToConfiguratorMap[type];
            };
            const isValidConfig = (config)=>{
                const type = config.type;
                if (!isSupported(type)) return false;
                return getConfigurator(type).isValidConfig(config);
            };
            const MediaTransform = {
                isSupported: isSupported,
                getConfigurator: getConfigurator,
                isValidConfig: isValidConfig
            };
            module1.exports = MediaTransform;
        /***/ },
        /* 699 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            const BlurRadius = __webpack_require__(312).BlurRadius;
            const DefaultConfig = __webpack_require__(313);
            const defaultBlurRadius = BlurRadius.High;
            const getDefaultConfig = ()=>(0, _extends2.default)({}, DefaultConfig.getConfig(), {
                    transformerType: 'BackgroundBlur',
                    radius: defaultBlurRadius
                });
            const isValidBlurStrength = (blurStrength)=>blurStrength === 'low' || blurStrength === 'high';
            const toBlurRadius = (blurStrength)=>blurStrength === 'low' ? BlurRadius.Low : BlurRadius.High;
            const isValidConfig = (config)=>{
                if ((config == null ? void 0 : config.type) !== 'backgroundBlur') return false;
                 // blurStrength is optional.  If defined, then make sure it's valid.
                const blurStrength = config.blurStrength;
                return blurStrength ? isValidBlurStrength(blurStrength) : true;
            };
            const BackgroundBlurConfig = {
                isValidConfig: isValidConfig,
                getConfig: function getConfig(opt) {
                    if (opt === void 0) opt = {};
                    const config = getDefaultConfig();
                    const _opt = opt, blurStrength = _opt.blurStrength;
                    if (isValidBlurStrength(blurStrength)) config.radius = toBlurRadius(blurStrength);
                    return config;
                }
            };
            module1.exports = BackgroundBlurConfig;
        /***/ },
        /* 700 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            const DefaultConfig = __webpack_require__(313);
            const getDefaultConfig = ()=>(0, _extends2.default)({}, DefaultConfig.getConfig(), {
                    transformerType: 'VirtualBackground'
                });
            const isSupportedImage = (url)=>/^data:image\/(?:png|jpeg|bmp|gif);base64/.test(url) || // Check if URL is a supported image type
                /\.(?:png|jpe?g|bmp|gif)$/i.test(url);
            const isValidConfig = (config)=>{
                if ((config == null ? void 0 : config.type) !== 'backgroundReplacement') return false;
                const backgroundImgUrl = config.backgroundImgUrl;
                return isSupportedImage(backgroundImgUrl);
            };
            const BackgroundReplacementConfig = {
                isValidConfig: isValidConfig,
                getConfig: function getConfig(opt) {
                    if (opt === void 0) opt = {};
                    const config = getDefaultConfig();
                    const _opt = opt, backgroundImgUrl = _opt.backgroundImgUrl;
                    if (isSupportedImage(backgroundImgUrl)) config.backgroundAssetUri = backgroundImgUrl;
                    return config;
                }
            };
            module1.exports = BackgroundReplacementConfig;
        /***/ },
        /* 701 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            const logging = __webpack_require__(2)('MediaProcessorConnector');
            let MediaProcessorConnector = function MediaProcessorConnector(connector) {
                var _this = this;
                (0, _defineProperty2.default)(this, "setTrack", /*#__PURE__*/ function() {
                    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(track) {
                        var filteredTrack;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    filteredTrack = null;
                                    _context.prev = 1;
                                    _context.next = 4;
                                    return _this.connector.setTrack(track);
                                case 4:
                                    filteredTrack = _context.sent;
                                    _this.originalTrack = track;
                                    _context.next = 11;
                                    break;
                                case 8:
                                    _context.prev = 8;
                                    _context.t0 = _context["catch"](1);
                                    logging.error(`Error setting track: ${_context.t0}`);
                                case 11:
                                    return _context.abrupt("return", filteredTrack);
                                case 12:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                1,
                                8
                            ]
                        ]);
                    }));
                    return function(_x) {
                        return _ref.apply(this, arguments);
                    };
                }());
                (0, _defineProperty2.default)(this, "destroy", /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return _this.connector.destroy();
                            case 3:
                                _context2.next = 8;
                                break;
                            case 5:
                                _context2.prev = 5;
                                _context2.t0 = _context2["catch"](0);
                                logging.warn(`Error destroying connector: ${_context2.t0}`);
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            5
                        ]
                    ]);
                })));
                (0, _defineProperty2.default)(this, "stopOriginalTrack", ()=>{
                    if (this.originalTrack) {
                        this.originalTrack.stop();
                        this.originalTrack = null;
                    }
                });
                this.connector = connector;
            };
            (0, _defineProperty2.default)(MediaProcessorConnector, "isValidConnector", (connector)=>typeof (connector == null ? void 0 : connector.setTrack) === 'function' && typeof (connector == null ? void 0 : connector.destroy) === 'function');
            module1.exports = MediaProcessorConnector;
        /***/ },
        /* 702 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (session)=>{
                if (!session) // Logs must be tagged to the API key, which we'll only know after we
                // connect to a session.
                return false;
                 // Logs must be linked the the API
                return !!session.apiKey;
            };
        /***/ },
        /* 703 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const isNullOrFalse = (value)=>value === null || value === false;
            module1.exports = isNullOrFalse;
        /***/ },
        /* 704 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (properties)=>{
                var _properties$videoSour;
                const isCanvas = !!(properties && ((_properties$videoSour = properties.videoSource) == null ? void 0 : _properties$videoSour.canvas));
                const hasVideoContentHint = !!(properties && 'videoContentHint' in properties); // eslint-disable-next-line no-param-reassign
                if (isCanvas && !hasVideoContentHint) properties.videoContentHint = 'detail';
            };
        /***/ },
        /* 705 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* eslint-disable no-param-reassign */ const isScreenSharingSource = __webpack_require__(148);
            const supportsScalableScreenShare = (properties)=>!!(properties == null ? void 0 : properties.scalableScreenshare);
            module1.exports = (properties)=>{
                var _properties;
                if (!properties) properties = {};
                const isScreenshare = !!isScreenSharingSource((_properties = properties) == null ? void 0 : _properties.videoSource); // eslint-disable-next-line no-unused-expressions
                properties.capableSimulcastScreenshare = isScreenshare && supportsScalableScreenShare(properties);
            };
        /***/ },
        /* 706 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFindKey = __webpack_require__(707), baseForOwn = __webpack_require__(100), baseIteratee = __webpack_require__(36);
            /**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function findKey(object, predicate) {
                return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
            }
            module1.exports = findKey;
        /***/ },
        /* 707 */ /***/ function(module1, exports) {
            /**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function baseFindKey(collection, predicate, eachFunc) {
                var result;
                eachFunc(collection, function(value, key, collection) {
                    if (predicate(value, key, collection)) {
                        result = key;
                        return false;
                    }
                });
                return result;
            }
            module1.exports = baseFindKey;
        /***/ },
        /* 708 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                const SDPHelpers = __webpack_require__(53);
                const shouldUsePlanBSDP = __webpack_require__(74);
                module1.exports = (_ref)=>{
                    let RTCPeerConnection = _ref.RTCPeerConnection, env = _ref.env, stream = _ref.stream, codecFlags = _ref.codecFlags;
                    if (env.isLegacyEdge) // Edge supports all codecs and the following test doesn't work
                    return true;
                    let localPc;
                    let remotePc;
                    const cleanup = ()=>{
                        try {
                            localPc.close();
                        } catch (e) {} // eslint-disable-line no-empty
                        try {
                            remotePc.close();
                        } catch (e) {} // eslint-disable-line no-empty
                        localPc = null;
                        remotePc = null;
                    };
                    try {
                        const pcConfig = {
                            iceServers: []
                        };
                        if (shouldUsePlanBSDP()) pcConfig.sdpSemantics = 'plan-b';
                        localPc = new RTCPeerConnection(pcConfig);
                        remotePc = new RTCPeerConnection(pcConfig);
                        stream.getTracks().forEach((track)=>localPc.addTrack(track, stream));
                    } catch (e) {
                        cleanup();
                        return Promise.resolve(false);
                    }
                    return localPc.createOffer().then((offer)=>{
                        const newOffer = {
                            type: offer.type,
                            sdp: offer.sdp
                        };
                        Object.keys(codecFlags).forEach((codec)=>{
                            if (!codecFlags[codec]) newOffer.sdp = SDPHelpers.removeVideoCodec(newOffer.sdp, codec);
                        });
                        return remotePc.setRemoteDescription(newOffer);
                    }).then(()=>true).catch(()=>false).then((result)=>{
                        cleanup();
                        return result;
                    });
                };
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 709 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(6), INVALID_PARAMETER = _require.INVALID_PARAMETER;
            module1.exports = (_ref)=>{
                let otError = _ref.otError;
                return (config)=>{
                    if (!config) return;
                    const check = (cond, msg)=>{
                        if (!cond) throw otError(INVALID_PARAMETER, new Error(`iceConfig invalid: ${msg}`));
                    };
                    if ('includeServers' in config) check([
                        'all',
                        'custom'
                    ].indexOf(config.includeServers) !== -1, '.includeServers must be all or custom');
                    if ('transportPolicy' in config) check([
                        'all',
                        'relay'
                    ].indexOf(config.transportPolicy) !== -1, '.transportPolicy must be all or relay');
                    check(Array.isArray(config.customServers), '.customServers must be an array');
                    config.customServers.forEach((server)=>{
                        check(server.urls || !('url' in server), 'ice servers need .urls, not .url');
                        check(typeof server.urls === 'string' || Array.isArray(server.urls), 'ice server .urls must be a string or an array');
                        check(!server.username || typeof server.username === 'string', 'ice server .username must be a string if present');
                        check(!server.credential || typeof server.credential === 'string', 'ice server .credential must be a string if present');
                    });
                };
            };
        /***/ },
        /* 710 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3); // For POC we only support Chrome 98+
            const isBrowserSupported = ()=>env.isChrome && env.version >= 98; // SPC is only available if defined by sessionInfo or forced by flag
            // and browser supports it.
            module1.exports = (sessionInfo, enableSinglePeerConnection)=>{
                // We disable SPC by default.
                let isSessionEnabled = false; // We override sessionInfo with force flag.
                if (typeof enableSinglePeerConnection === 'boolean') isSessionEnabled = enableSinglePeerConnection;
                else // Otherwise we use spc flag from GSI.
                isSessionEnabled = sessionInfo && sessionInfo.spc;
                return isSessionEnabled && isBrowserSupported();
            };
        /***/ },
        /* 711 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const minSecretLength = 8;
            const maxSecretLength = 256;
            const validateSecret = (secret)=>{
                if (typeof secret !== 'string') throw new Error('secret must be a string');
                else if (secret.length < minSecretLength) throw new Error('secret must have at least 8 characters');
                else if (secret.length > maxSecretLength) throw new Error('secret must not exceed 256 characters');
            };
            module1.exports = validateSecret;
        /***/ },
        /* 712 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ExceptionCodes = __webpack_require__(10);
            module1.exports = function convertAnvilErrorCode(code) {
                switch(code){
                    case ExceptionCodes.AUTHENTICATION_ERROR:
                    case ExceptionCodes.INVALID_SESSION_ID:
                    case ExceptionCodes.TERMS_OF_SERVICE_FAILURE:
                    case ExceptionCodes.UNEXPECTED_SERVER_RESPONSE:
                        return code;
                    case ExceptionCodes.ANVIL_EMPTY_RESPONSE_BODY:
                    case ExceptionCodes.ANVIL_CONNECT_FAILED:
                        return ExceptionCodes.CONNECT_FAILED;
                    case ExceptionCodes.ANVIL_BADLY_FORMED_RESPONSE:
                    case ExceptionCodes.ANVIL_INVALID_HTTP_STATUS:
                    case ExceptionCodes.ANVIL_XDOMAIN_OR_PARSING_ERROR:
                    case ExceptionCodes.ANVIL_UNKNOWN_HTTP_ERROR:
                    case ExceptionCodes.ANVIL_UNEXPECTED_ERROR_CODE:
                    default:
                        return ExceptionCodes.UNEXPECTED_SERVER_RESPONSE;
                }
            };
        /***/ },
        /* 713 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ExceptionCodes = __webpack_require__(10);
            const errors = __webpack_require__(6);
            module1.exports = {
                NOT_CONNECTED: {
                    code: errors.NOT_CONNECTED,
                    message: 'Cannot use forceMute functionality. You are not connected to the session.',
                    exceptionCode: ExceptionCodes.NOT_CONNECTED
                },
                PERMISSION_DENIED: {
                    code: errors.PERMISSION_DENIED,
                    message: "This token does not allow forceMute usage. The role must be at least `moderator` to enable this functionality",
                    exceptionCode: ExceptionCodes.UNABLE_TO_FORCE_MUTE
                },
                INVALID_PARAMETER: {
                    code: errors.INVALID_PARAMETER,
                    message: 'Invalid Parameter. Check that you have passed valid parameter values into the method call.',
                    exceptionCode: ExceptionCodes.INVALID_PARAMETER
                },
                NOT_FOUND: {
                    code: errors.NOT_FOUND,
                    message: 'The stream does not exist.'
                },
                UNEXPECTED_SERVER_RESPONSE: {
                    code: errors.UNEXPECTED_SERVER_RESPONSE,
                    message: 'An unexpected error occurred.',
                    exceptionCode: ExceptionCodes.UNEXPECTED_SERVER_RESPONSE
                }
            };
        /***/ },
        /* 714 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                var _interopRequireDefault = __webpack_require__(1);
                exports.__esModule = true;
                exports.default = RaptorSocketFactory;
                var _extends2 = _interopRequireDefault(__webpack_require__(19));
                var _isFunction = _interopRequireDefault(__webpack_require__(17));
                var _assign = _interopRequireDefault(__webpack_require__(9));
                var _once = _interopRequireDefault(__webpack_require__(51));
                var _uuid = _interopRequireDefault(__webpack_require__(16));
                var _serializeMessage = _interopRequireDefault(__webpack_require__(318));
                var _defaultRumorSocket = _interopRequireDefault(__webpack_require__(715));
                // @todo enable the following disabled rules see OPENTOK-31136 for more info
                /* eslint-disable no-param-reassign, global-require, one-var, no-underscore-dangle */ /* eslint-disable prefer-rest-params, prefer-const, no-shadow, max-len */ function RaptorSocketFactory(deps) {
                    if (deps === void 0) deps = {};
                    const convertRumorError = deps.convertRumorError || __webpack_require__(316);
                    const Dispatcher = deps.Dispatcher || __webpack_require__(320);
                    const ExceptionCodes = deps.ExceptionCodes || __webpack_require__(10);
                    const hasIceRestartsCapability = deps.hasIceRestartsCapability || __webpack_require__(317);
                    const hasRenegotiationCapability = deps.hasRenegotiationCapability || __webpack_require__(731);
                    const hasE2eeCapability = deps.hasE2eeCapability || __webpack_require__(170);
                    const logging = deps.logging || __webpack_require__(2)('RaptorSocket');
                    const RaptorMessage = deps.Message || __webpack_require__(321);
                    const OTHelpers = deps.OTHelpers || __webpack_require__(8);
                    const RumorSocket = deps.RumorSocket || (0, _defaultRumorSocket.default)();
                    const Signal = deps.Signal || __webpack_require__(322);
                    const SignalError = deps.SignalError || __webpack_require__(736); // The Dispatcher bit is purely to make testing simpler, it defaults to a new Dispatcher so in
                    // normal operation you would omit it.
                    const RaptorSocket = function RaptorSocket(connectionId, widgetId, messagingSocketUrl, symphonyUrl, dispatcher, analytics, requestedCapabilities) {
                        var _this = this;
                        if (requestedCapabilities === void 0) requestedCapabilities = [];
                        let _apiKey, _sessionId, _token, _sessionInfo, _completion, _p2p, _messagingServer, _rumorErrored;
                        const _states = [
                            'disconnected',
                            'connecting',
                            'connected',
                            'error',
                            'disconnecting'
                        ];
                        const _dispatcher = dispatcher || new Dispatcher(); // // Private API
                        const setState = OTHelpers.statable(this, _states, 'disconnected');
                        const logAnalyticsEvent = function logAnalyticsEvent(opt) {
                            if (!opt.action || !opt.variation) logging.debug('Expected action and variation');
                            analytics.logEvent((0, _assign.default)({
                                sessionId: _sessionId,
                                partnerId: _apiKey,
                                p2p: _p2p,
                                messagingServer: _messagingServer,
                                connectionId: connectionId
                            }, opt));
                        };
                        const onConnectComplete = function onConnectComplete() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            const error = args[0];
                            if (error) setState('error');
                            else setState('connected');
                            _completion(...args);
                        };
                        const onClose = (err)=>{
                            let reason = 'clientDisconnected';
                            if (!this.is('disconnecting') && _rumorErrored) reason = 'networkDisconnected';
                            if (err && err.code === 4001) reason = 'networkTimedout';
                            setState('disconnected');
                            _dispatcher.onClose(reason);
                        };
                        const onError = (err)=>{
                            _rumorErrored = true;
                            logging.error(err);
                        }; // @todo what does having an error mean? Are they always fatal? Are we disconnected now?
                        const onReconnecting = ()=>{
                            _dispatcher.onReconnecting();
                        };
                        const onReconnected = ()=>{
                            logAnalyticsEvent({
                                action: 'Reconnect',
                                variation: 'Success',
                                retries: this._rumor.reconnectRetriesCount(),
                                messageQueueSize: this._rumor.messageQueueSize(),
                                socketId: this.socketId
                            });
                            _dispatcher.onReconnected();
                        };
                        const onReconnectAttempt = ()=>{
                            logAnalyticsEvent({
                                action: 'Reconnect',
                                variation: 'Attempt',
                                retries: this._rumor.reconnectRetriesCount(),
                                messageQueueSize: this._rumor.messageQueueSize(),
                                socketId: this.socketId
                            });
                        };
                        const onReconnectFailure = (error)=>{
                            if (error.message === 'connectionLimitExceeded') error.code = ExceptionCodes.CONNECTION_LIMIT_EXCEEDED;
                            error.reason = 'ConnectToSession';
                            const converted = convertRumorError(error);
                            logAnalyticsEvent({
                                action: 'Reconnect',
                                variation: 'Failure',
                                failureReason: error.reason,
                                failureCode: converted.code,
                                failureMessage: converted.message,
                                messageQueueSize: this._rumor.messageQueueSize(),
                                socketId: this.socketId
                            });
                        }; // // Public API
                        Object.defineProperty(this, 'socketId', {
                            get () {
                                return this._rumor.socketID;
                            }
                        });
                        this.connect = function connect(token, sessionInfo, opt, completion) {
                            if (!this.is('disconnected', 'error')) {
                                logging.warn("Cannot connect the Raptor Socket as it is currently connected. You should disconnect first.");
                                return;
                            }
                            setState('connecting');
                            _apiKey = sessionInfo.partnerId;
                            _sessionId = sessionInfo.sessionId;
                            _p2p = sessionInfo.p2pEnabled;
                            _messagingServer = sessionInfo.messagingServer;
                            _token = token;
                            _completion = completion;
                            _sessionInfo = {
                                apiKey: _apiKey,
                                sessionId: _sessionId
                            };
                            const rumorChannel = `/v2/partner/${_apiKey}/session/${_sessionId}`;
                            this._rumor = new RaptorSocket.RumorSocket({
                                messagingURL: messagingSocketUrl,
                                notifyDisconnectAddress: symphonyUrl,
                                connectionId: connectionId,
                                enableReconnection: sessionInfo.reconnection
                            });
                            this._rumor.on('close', onClose);
                            this._rumor.on('error', onError);
                            this._rumor.on('reconnecting', onReconnecting);
                            this._rumor.on('reconnectAttempt', onReconnectAttempt);
                            this._rumor.on('reconnectFailure', onReconnectFailure);
                            this._rumor.on('reconnected', onReconnected);
                            this._rumor.on('message', _dispatcher.dispatch.bind(_dispatcher));
                            const onStartupError = (error)=>{
                                onConnectComplete({
                                    reason: 'WebSocketConnection',
                                    code: error.code,
                                    message: error.message
                                });
                            };
                            this._rumor.once('error', onStartupError);
                            this._rumor.once('open', ()=>{
                                this._rumor.removeListener('error', onStartupError);
                                logging.debug(`connected. Subscribing to ${rumorChannel} on ${messagingSocketUrl}`);
                                this._rumor.subscribe([
                                    rumorChannel
                                ]);
                                const capabilities = requestedCapabilities;
                                const supportRenegotiation = (RaptorSocket.hasIceRestartsCapability() || RaptorSocket.hasRenegotiationCapability()) && sessionInfo.renegotiation;
                                if (supportRenegotiation) capabilities.push('renegotiation');
                                const supportE2ee = RaptorSocket.hasE2eeCapability() && sessionInfo.e2ee;
                                if (supportE2ee) capabilities.push('e2ee');
                                 // connect to session
                                const connectMessage = RaptorMessage.connections.create({
                                    apiKey: _apiKey,
                                    sessionId: _sessionId,
                                    connectionId: this._rumor.id,
                                    connectionEventsSuppressed: opt.connectionEventsSuppressed,
                                    capabilities: capabilities
                                });
                                const futureOwnConnection = new Promise((resolve)=>{
                                    const processConnectionCreated = (message)=>{
                                        if (message.id === this._rumor.id) {
                                            resolve(message);
                                            dispatcher.off('connection#created', processConnectionCreated);
                                        }
                                    };
                                    dispatcher.on('connection#created', processConnectionCreated);
                                });
                                this.publish(connectMessage, {
                                    'X-TB-TOKEN-AUTH': _token
                                }, true, (error, reply)=>{
                                    if (error) {
                                        if (error.message === 'connectionLimitExceeded') error.code = ExceptionCodes.CONNECTION_LIMIT_EXCEEDED;
                                        onConnectComplete({
                                            reason: 'ConnectToSession',
                                            code: error.code,
                                            message: error.message,
                                            socketId: this.socketId
                                        });
                                        return;
                                    }
                                    const replyData = reply && reply.data ? JSON.parse(reply.data) : null;
                                    if (replyData) {
                                        if (!replyData.connection || replyData.connection.length === 0) {
                                            replyData.connection = [];
                                            if (Array.isArray(replyData.stream)) replyData.stream.forEach((_ref)=>{
                                                let connection = _ref.connection;
                                                return replyData.connection.push(connection);
                                            });
                                        }
                                    }
                                    const onSessionState = (error, sessionState)=>{
                                        if (error) onConnectComplete({
                                            reason: 'GetSessionState',
                                            code: error.code,
                                            message: error.message,
                                            socketId: this.socketId
                                        });
                                        else onConnectComplete(undefined, sessionState);
                                    };
                                    futureOwnConnection.then((ownConnection)=>{
                                        // in the case of not receiving our own connection, we add it here.
                                        // this is important under connectionEventSuppressed as rumor does
                                        // not give us our own connection in the initial ack to our connect
                                        // message
                                        if (!replyData.connection.some((conn)=>conn.id === ownConnection.id)) replyData.connection.unshift(ownConnection);
                                        const transactionId = (0, _uuid.default)();
                                        _dispatcher.registerCallback(transactionId, onSessionState);
                                        _dispatcher.emit('session#read', replyData, transactionId);
                                    });
                                });
                            });
                        };
                        this.disconnect = function() {
                            if (this.is('disconnected')) return;
                            setState('disconnecting');
                            this._rumor.disconnect();
                        }; // Publishes +message+ to the Symphony app server.
                        //
                        // The completion handler is optional, as is the headers
                        // dict, but if you provide the completion handler it must
                        // be the last argument.
                        //
                        this.publish = function(message, headers, retryAfterReconnect, completion) {
                            completion = completion || function() {};
                            const completionOnce = (0, _once.default)(completion);
                            const transactionId = (0, _uuid.default)();
                            logging.debug(`Publish (ID:${transactionId}) ${message}`);
                            if (this._rumor.readyState !== RumorSocket.OPEN || this._rumor.reconnecting && !retryAfterReconnect) {
                                // TODO: This duplicates the same logic in rumor.
                                const error = new Error('Not connected.');
                                error.code = 500;
                                completionOnce(error);
                                logging.error('cannot publish until the socket is connected.');
                                return undefined;
                            }
                            _dispatcher.registerCallback(transactionId, completionOnce);
                            this._rumor.publish([
                                symphonyUrl
                            ], message, (0, _assign.default)({}, headers, {
                                'Content-Type': 'application/x-raptor+v2',
                                'TRANSACTION-ID': transactionId,
                                'X-TB-FROM-ADDRESS': this._rumor.id
                            }), retryAfterReconnect, function(err) {
                                // We want to propagate errors from rumor here. In particular, errors
                                // related to not receiving a reply due to disconnection. However, when
                                // a reply is received, the dispatcher may transform the reply, and may
                                // generate an error that would not be recognized here. This isn't the
                                // only awkward outcome related to the dispatcher design, and there are
                                // plans to address this technical debt: OPENTOK-27994.
                                if (err) completionOnce(...arguments);
                            });
                            return transactionId;
                        };
                        /**
     * Like publish, but automaitcally serializes the message parameter
     */ this.send = function(message, headers, retryAfterReconnect, completion) {
                            if (retryAfterReconnect === void 0) retryAfterReconnect = true;
                            if (completion === void 0) completion = ()=>{};
                            _this.publish((0, _serializeMessage.default)(message), headers, retryAfterReconnect, completion);
                        }; // Register a new stream against _sessionId
                        this.streamCreate = function(name, streamId, audioFallbackEnabled, channels, minBitrate, maxBitrate, sourceStreamId, e2ee, completion) {
                            const streamCreateOpts = {
                                apiKey: _apiKey,
                                sessionId: _sessionId,
                                streamId: streamId,
                                name: name,
                                audioFallbackEnabled: audioFallbackEnabled,
                                channels: channels,
                                minBitrate: minBitrate,
                                maxBitrate: maxBitrate,
                                sourceStreamId: sourceStreamId,
                                e2ee: e2ee
                            };
                            const message = RaptorMessage.streams.create(streamCreateOpts);
                            this.publish(message, {}, true, (error, message)=>{
                                completion(error, streamId, message);
                            });
                        };
                        this.streamDestroy = function(streamId, sourceStreamId) {
                            this.publish(RaptorMessage.streams.destroy(_apiKey, _sessionId, streamId, sourceStreamId), {}, true);
                        };
                        this.streamChannelUpdate = function(streamId, channelId, attributes) {
                            this.publish(RaptorMessage.streamChannels.update(_apiKey, _sessionId, streamId, channelId, attributes), {}, true);
                        };
                        this.subscriberCreate = function(streamId, subscriberId, channelsToSubscribeTo, sourceStreamId, e2ee, completion) {
                            const subscriberCreateOpts = {
                                apiKey: _apiKey,
                                sessionId: _sessionId,
                                streamId: streamId,
                                subscriberId: subscriberId,
                                connectionId: this._rumor.id,
                                channelsToSubscribeTo: channelsToSubscribeTo,
                                sourceStreamId: sourceStreamId,
                                e2ee: e2ee
                            };
                            this.publish(RaptorMessage.subscribers.create(subscriberCreateOpts), {}, true, completion);
                        };
                        this.subscriberDestroy = function(streamId, subscriberId) {
                            this.publish(RaptorMessage.subscribers.destroy(_apiKey, _sessionId, streamId, subscriberId), {}, true);
                        };
                        this.subscriberUpdate = function(streamId, subscriberId, attributes) {
                            this.publish(RaptorMessage.subscribers.update(_apiKey, _sessionId, streamId, subscriberId, attributes), {}, true);
                        };
                        this.subscriberChannelUpdate = function(streamId, subscriberId, channelId, attributes) {
                            this.publish(RaptorMessage.subscriberChannels.update(_apiKey, _sessionId, streamId, subscriberId, channelId, attributes), {}, true);
                        };
                        this.forceDisconnect = function(connectionIdToDisconnect, completion) {
                            this.publish(RaptorMessage.connections.destroy({
                                apiKey: _apiKey,
                                sessionId: _sessionId,
                                connectionId: connectionIdToDisconnect
                            }), {}, true, completion);
                        };
                        this.forceUnpublish = function(streamIdToUnpublish, completion) {
                            this.publish(RaptorMessage.streams.destroy(_apiKey, _sessionId, streamIdToUnpublish), {}, true, completion);
                        };
                        this.forceMuteStream = function(streamId, completion) {
                            const options = {
                                streamId: streamId,
                                active: true
                            };
                            this.publish(RaptorMessage.forceMute.update((0, _extends2.default)({}, _sessionInfo, options)), {}, true, completion);
                        };
                        this.forceMuteAll = function(excludedStreamIds, active, completion) {
                            const options = {
                                excludedStreamIds: excludedStreamIds,
                                active: active
                            };
                            this.publish(RaptorMessage.forceMute.update((0, _extends2.default)({}, _sessionInfo, options)), {}, true, completion);
                        };
                        this.signal = function(options, completion, logEventFn) {
                            const signal = new Signal(_sessionId, this._rumor.id, options || {});
                            if (!signal.valid) {
                                if (completion && (0, _isFunction.default)(completion)) completion(new SignalError(signal.error.code, signal.error.reason), signal.toHash());
                                return;
                            }
                            this.publish(signal.toRaptorMessage(), {}, signal.retryAfterReconnect, (err)=>{
                                let error, errorCode, errorMessage;
                                const expectedErrorCodes = [
                                    400,
                                    403,
                                    404,
                                    413,
                                    500
                                ];
                                if (err) {
                                    const parsedErrorCode = parseInt(err.code, 10);
                                    if (expectedErrorCodes.includes(parsedErrorCode)) {
                                        errorCode = parsedErrorCode;
                                        errorMessage = err.message;
                                    } else {
                                        errorCode = ExceptionCodes.UNEXPECTED_SERVER_RESPONSE;
                                        errorMessage = 'Unexpected server response. Try this operation again later.';
                                    }
                                    error = new SignalError(errorCode, errorMessage);
                                } else {
                                    const typeStr = signal.data ? typeof signal.data : null;
                                    logEventFn('signal', 'send', {
                                        type: typeStr
                                    });
                                }
                                if (completion && (0, _isFunction.default)(completion)) completion(error, signal.toHash());
                            });
                        };
                        this.id = function() {
                            return this._rumor && this._rumor.id;
                        };
                    };
                    RaptorSocket.hasIceRestartsCapability = hasIceRestartsCapability;
                    RaptorSocket.hasRenegotiationCapability = hasRenegotiationCapability;
                    RaptorSocket.hasE2eeCapability = hasE2eeCapability;
                    RaptorSocket.RumorSocket = RumorSocket;
                    return RaptorSocket;
                }
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 715 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = defaultRumorSocket;
            var _events = _interopRequireDefault(__webpack_require__(31));
            var _createCounter = _interopRequireDefault(__webpack_require__(716));
            var _log = _interopRequireDefault(__webpack_require__(2));
            var _ReconnectableSocket = _interopRequireDefault(__webpack_require__(717));
            var _RumorSocket = _interopRequireDefault(__webpack_require__(722));
            var _WebSocket = _interopRequireDefault(__webpack_require__(727));
            /* eslint-disable no-underscore-dangle */ function defaultRumorSocket(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$WebSocket = _ref.WebSocket, WebSocket = _ref$WebSocket === void 0 ? _WebSocket.default : _ref$WebSocket;
                const allocateId = (0, _createCounter.default)();
                const ReconnectableSocket = (0, _ReconnectableSocket.default)({
                    EventEmitter: _events.default,
                    WebSocket: WebSocket,
                    logging: _log.default,
                    allocateId: allocateId
                });
                const RumorSocket = (0, _RumorSocket.default)({
                    EventEmitter: _events.default,
                    ReconnectableSocket: ReconnectableSocket,
                    logging: _log.default,
                    allocateId: allocateId
                });
                return RumorSocket;
            }
        /***/ },
        /* 716 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            exports.__esModule = true;
            exports.default = createCounter;
            function createCounter() {
                let current = 0;
                return ()=>{
                    current += 1;
                    return current;
                };
            }
        /***/ },
        /* 717 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(156));
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _logEvents = _interopRequireDefault(__webpack_require__(319));
            var _socketCloseCodes = __webpack_require__(77);
            var _Timer = _interopRequireDefault(__webpack_require__(718));
            var _eventHelper = _interopRequireDefault(__webpack_require__(63));
            var _createReadyStateMachine = _interopRequireDefault(__webpack_require__(719));
            var _drainWebSocket = _interopRequireDefault(__webpack_require__(721));
            /* eslint-disable no-underscore-dangle, no-constant-condition */ const removeReturnVal = (fn)=>function() {
                    fn(...arguments);
                };
            const isValidCode = (code)=>code === 1000 || code >= 3000 && code <= 4999;
            const CLOSE_TIMEOUT = _socketCloseCodes.codes.CLOSE_TIMEOUT;
            var _default = (_ref)=>{
                var _class, _temp;
                let EventEmitter = _ref.EventEmitter, WebSocket = _ref.WebSocket, logging = _ref.logging, allocateId = _ref.allocateId, _ref$BUFFER_DRAIN_INT = _ref.BUFFER_DRAIN_INTERVAL, BUFFER_DRAIN_INTERVAL = _ref$BUFFER_DRAIN_INT === void 0 ? 100 : _ref$BUFFER_DRAIN_INT, _ref$BUFFER_DRAIN_MAX = _ref.BUFFER_DRAIN_MAX_RETRIES, BUFFER_DRAIN_MAX_RETRIES = _ref$BUFFER_DRAIN_MAX === void 0 ? 10 : _ref$BUFFER_DRAIN_MAX;
                return _temp = _class = /*#__PURE__*/ function(_EventEmitter) {
                    (0, _inheritsLoose2.default)(ReconnectableSocket, _EventEmitter);
                    (0, _createClass2.default)(ReconnectableSocket, [
                        {
                            key: "url",
                            get: function get() {
                                return typeof this._url === 'function' ? this._url() : this._url;
                            }
                        },
                        {
                            key: "reconnecting",
                            get: function get() {
                                return this.readyStateMachine.state === 'reconnecting';
                            }
                        },
                        {
                            key: "binaryType",
                            get: function get() {
                                return this._webSocket.binaryType;
                            }
                        },
                        {
                            key: "bufferedAmount",
                            get: function get() {
                                return this._webSocket.bufferedAmount;
                            }
                        },
                        {
                            key: "protocol",
                            get: function get() {
                                return this._webSocket.protocol;
                            }
                        },
                        {
                            key: "extensions",
                            get: function get() {
                                return this._webSocket.extensions;
                            }
                        },
                        {
                            key: "readyState",
                            get: function get() {
                                const STATE_MAP = {
                                    reconnecting: ReconnectableSocket.OPEN,
                                    open: ReconnectableSocket.OPEN,
                                    closing: ReconnectableSocket.CLOSING,
                                    closed: ReconnectableSocket.CLOSED,
                                    connecting: ReconnectableSocket.CONNECTING
                                };
                                return STATE_MAP[this.readyStateMachine.state];
                            }
                        }
                    ]);
                    function ReconnectableSocket(opt) {
                        var _this;
                        const _ref2 = typeof opt === 'string' ? {
                            url: opt
                        } : opt, url = _ref2.url, _ref2$connectTimeout = _ref2.connectTimeout, connectTimeout = _ref2$connectTimeout === void 0 ? 15000 : _ref2$connectTimeout, _ref2$pingThreshold = _ref2.pingThreshold, pingThreshold = _ref2$pingThreshold === void 0 ? 3000 : _ref2$pingThreshold, _ref2$pingWarningDela = _ref2.pingWarningDelay, pingWarningDelay = _ref2$pingWarningDela === void 0 ? 100 : _ref2$pingWarningDela, _ref2$disconnectThres = _ref2.disconnectThreshold, disconnectThreshold = _ref2$disconnectThres === void 0 ? 5900 : _ref2$disconnectThres, _ref2$reconnectMaxDur = _ref2.reconnectMaxDuration, reconnectMaxDuration = _ref2$reconnectMaxDur === void 0 ? 60000 : _ref2$reconnectMaxDur;
                        if (!url) throw new Error('Must provide url');
                        _this = _EventEmitter.call(this) || this;
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_url", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_id", allocateId());
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_logger", logging(`ReconnectableSocket:${_this._id}`));
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_webSocket", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_connectTimer", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_pingTimer", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_pingWarningTimer", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_disconnectTimer", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_queuedMessages", []);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_draining", false);
                        _this.readyStateMachine = (0, _createReadyStateMachine.default)({
                            reconnectMaxDuration: reconnectMaxDuration,
                            CLOSED: ReconnectableSocket.CLOSED,
                            CLOSING: ReconnectableSocket.CLOSING
                        });
                        _this._url = url;
                        (0, _logEvents.default)({
                            logger: _this._logger,
                            obj: (0, _assertThisInitialized2.default)(_this),
                            eventNames: [
                                'error',
                                'open',
                                'message',
                                'needsPing',
                                'reconnecting',
                                'reconnectAttempt',
                                'reconnectFailure',
                                'reconnected',
                                'close'
                            ]
                        });
                        _this.readyStateMachine.observe('onEnterOpen', (_ref3)=>{
                            let from = _ref3.from;
                            _this._resetPingTimers();
                            _this._resetDisconnectTimer();
                            _this._connectTimer.clear();
                            if (from === 'reconnecting') {
                                _this._queuedMessages.forEach((msg)=>_this.send(msg, true));
                                _this._queuedMessages = [];
                                _this.emit('reconnected');
                            } else _this.emit('open');
                        });
                        _this.readyStateMachine.observe('onEnterClosed', (_, error)=>{
                            _this.emit('close', error);
                        });
                        _this.readyStateMachine.observe('onEnterClosing', removeReturnVal(/*#__PURE__*/ function() {
                            var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(_ref4, _ref5) {
                                var from, code, reason;
                                return _regenerator.default.wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            from = _ref4.from;
                                            code = _ref5.code, reason = _ref5.reason;
                                            _this._clearTimers();
                                            _context.next = 5;
                                            return _this._clearSocket({
                                                drain: from === 'open',
                                                code: code,
                                                reason: reason
                                            });
                                        case 5:
                                            if (from === 'reconnecting') _this.emit('reconnectFailure', {
                                                code: code,
                                                reason: reason
                                            });
                                            setTimeout(()=>{
                                                _this.readyStateMachine.closed({
                                                    code: code,
                                                    reason: reason
                                                });
                                            });
                                        case 7:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_x, _x2) {
                                return _ref6.apply(this, arguments);
                            };
                        }()));
                        _this.readyStateMachine.observe('onEnterReconnecting', ()=>{
                            _this.emit('reconnecting');
                        });
                        _this.readyStateMachine.observe('onDisconnect', removeReturnVal(/*#__PURE__*/ function() {
                            var _ref9 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(_ref7, _ref8) {
                                var from, to, code, reason;
                                return _regenerator.default.wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            from = _ref7.from, to = _ref7.to;
                                            code = _ref8.code, reason = _ref8.reason;
                                            if (!(to === 'reconnecting')) {
                                                _context2.next = 10;
                                                break;
                                            }
                                            if (!_this._draining) {
                                                _context2.next = 5;
                                                break;
                                            }
                                            return _context2.abrupt("return");
                                        case 5:
                                            _this._clearTimers();
                                            _this.emit('reconnectAttempt');
                                            _context2.next = 9;
                                            return _this._clearSocket({
                                                drain: from === 'open',
                                                code: code,
                                                reason: reason
                                            });
                                        case 9:
                                            _this._createSocket();
                                        case 10:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function(_x3, _x4) {
                                return _ref9.apply(this, arguments);
                            };
                        }()));
                        const createTimer = (name, duration)=>new _Timer.default({
                                name: name,
                                duration: duration,
                                logger: _this._logger
                            });
                        _this._connectTimer = createTimer('connect', connectTimeout);
                        _this._pingTimer = createTimer('ping', pingThreshold);
                        _this._pingWarningTimer = createTimer('pingWarning', pingWarningDelay);
                        _this._disconnectTimer = createTimer('disconnect', disconnectThreshold);
                        _this._createSocket();
                        return _this;
                    }
                    var _proto = ReconnectableSocket.prototype;
                    _proto._createSocket = function _createSocket() {
                        const ws = new WebSocket(this.url);
                        ws.binaryType = 'arraybuffer';
                        const wsEvents = (0, _eventHelper.default)(ws);
                        wsEvents.on('open', ()=>{
                            this.readyStateMachine.open();
                        });
                        wsEvents.on('close', (_ref10)=>{
                            let code = _ref10.code, reason = _ref10.reason;
                            this.readyStateMachine.disconnect({
                                code: code,
                                reason: reason
                            });
                        });
                        wsEvents.on('error', (event)=>{
                            this.emit('error', event);
                        });
                        wsEvents.on('message', (event)=>{
                            if (this.readyState !== ReconnectableSocket.CLOSING) // Without this you can receive a message while we are closing the socket and we end up
                            // trying to reconnect again afterwards
                            this._resetDisconnectTimer();
                            this.emit('message', event);
                        });
                        this._webSocket = ws;
                        this._webSocketEvents = wsEvents;
                        this._connectTimer.reset(()=>{
                            const closeData = {
                                code: CLOSE_TIMEOUT,
                                reason: 'Timeout while opening connection'
                            };
                            const error = new Error(closeData.reason);
                            error.code = CLOSE_TIMEOUT;
                            this.emit('error', error);
                            this.readyStateMachine.disconnect(closeData);
                        });
                    };
                    _proto._clearSocket = /*#__PURE__*/ function() {
                        var _clearSocket2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(_temp2) {
                            var _ref11, _ref11$drain, drain, code, reason;
                            return _regenerator.default.wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        _ref11 = _temp2 === void 0 ? {} : _temp2, _ref11$drain = _ref11.drain, drain = _ref11$drain === void 0 ? false : _ref11$drain, code = _ref11.code, reason = _ref11.reason;
                                        this._draining = true;
                                        if (this._webSocketEvents) this._webSocketEvents.removeAll();
                                        if (!(this._webSocket.readyState !== ReconnectableSocket.CLOSED)) {
                                            _context3.next = 8;
                                            break;
                                        }
                                        if (!drain) {
                                            _context3.next = 7;
                                            break;
                                        }
                                        _context3.next = 7;
                                        return (0, _drainWebSocket.default)(this._webSocket, {
                                            BUFFER_DRAIN_INTERVAL: BUFFER_DRAIN_INTERVAL,
                                            BUFFER_DRAIN_MAX_RETRIES: BUFFER_DRAIN_MAX_RETRIES
                                        });
                                    case 7:
                                        try {
                                            if (!isValidCode(code) || code === undefined && reason === undefined) // because IE
                                            this._webSocket.close();
                                            else this._webSocket.close(code, reason);
                                        } catch (err) {
                                            logging.error('Could not close websocket', err);
                                        }
                                    case 8:
                                        this._draining = false;
                                    case 9:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3, this);
                        }));
                        function _clearSocket(_x5) {
                            return _clearSocket2.apply(this, arguments);
                        }
                        return _clearSocket;
                    }();
                    _proto.send = function send(data, retryAfterReconnect) {
                        if (retryAfterReconnect === void 0) retryAfterReconnect = true;
                        // send deviates from WebSocket a little in that it returns a status instead of nothing.
                        if (this.readyState === ReconnectableSocket.OPEN) this._resetPingTimers();
                        const sendMessage = ()=>{
                            try {
                                this._webSocket.send(data);
                                return 'sent';
                            } catch (err) {
                                if (this._webSocket.readyState === WebSocket.OPEN) {
                                    // On the other hand, there is a known bug in Firefox where .send throws an exception
                                    // even though it's open:
                                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1204727
                                    this._logger.debug('webSocket.send threw exception even though it was open:', err);
                                    return 'dropped';
                                }
                                throw err;
                            }
                        };
                        if (this.readyStateMachine.state === 'reconnecting') {
                            // the old socket is still open, let's send the message there as well.
                            if (this._webSocket.readyState === WebSocket.OPEN) try {
                                sendMessage();
                            } catch (err) {}
                            if (retryAfterReconnect) {
                                this._queuedMessages.push(data);
                                return 'queued';
                            }
                            this._logger.debug('Dropping message during reconnection since retryAfterReconnect is false:', data);
                            return 'dropped';
                        }
                        return sendMessage();
                    };
                    _proto.close = function close(code, reason) {
                        if (this.readyState === ReconnectableSocket.CLOSING) throw new Error('Can not call close on a closing ReconnectableSocket');
                        if (this.readyState === ReconnectableSocket.CLOSED) throw new Error('Can not call close on an already closed ReconnectableSocket');
                        this.readyStateMachine.close({
                            code: code,
                            reason: reason
                        });
                    };
                    _proto._resetPingTimers = function _resetPingTimers() {
                        this._pingWarningTimer.clear();
                        this._pingTimer.reset(()=>{
                            this._pingWarningTimer.reset(()=>{
                                this._logger.warn("Did not send message after needsPing event. Other side may disconnect.");
                            });
                            this.emit('needsPing');
                        });
                    };
                    _proto._resetDisconnectTimer = function _resetDisconnectTimer() {
                        this._disconnectTimer.reset(()=>this.readyStateMachine.disconnect({
                                code: CLOSE_TIMEOUT,
                                reason: 'No activity'
                            }));
                    };
                    _proto._clearTimers = function _clearTimers() {
                        [
                            this._disconnectTimer,
                            this._connectTimer,
                            this._pingTimer,
                            this._pingWarningTimer
                        ].forEach((timer)=>timer.clear());
                    };
                    return ReconnectableSocket;
                }(EventEmitter), (0, _defineProperty2.default)(_class, "CONNECTING", WebSocket.CONNECTING), (0, _defineProperty2.default)(_class, "OPEN", WebSocket.OPEN), (0, _defineProperty2.default)(_class, "CLOSING", WebSocket.CLOSING), (0, _defineProperty2.default)(_class, "CLOSED", WebSocket.CLOSED), _temp;
            };
            exports.default = _default;
        /***/ },
        /* 718 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            // Tracks one timer so that when you reset it you can't accidentally get multiple timers.
            let Timer = /*#__PURE__*/ function() {
                function Timer(_ref) {
                    let name = _ref.name, logger = _ref.logger, duration = _ref.duration;
                    (0, _defineProperty2.default)(this, "name", void 0);
                    (0, _defineProperty2.default)(this, "logger", void 0);
                    (0, _defineProperty2.default)(this, "duration", void 0);
                    (0, _defineProperty2.default)(this, "currId", void 0);
                    this.name = name;
                    this.logger = logger;
                    this.duration = duration;
                }
                var _proto = Timer.prototype;
                _proto.reset = function reset(callback) {
                    this.clear();
                    const id = setTimeout(()=>{
                        if (this.currId === undefined) // This shouldn't be necessary, except for this bug in jasmine's fake clock:
                        // https://github.com/jasmine/jasmine/issues/1426
                        return;
                        this.logger.spam(`${this.name} timer with id ${this.currId} expired, entering callback`);
                        this.currId = undefined;
                        callback();
                    }, this.duration);
                    this.currId = id;
                    this.logger.spam(`Started ${this.name} timer with id ${this.currId}, expires in ` + `${this.duration}ms`);
                };
                _proto.clear = function clear() {
                    if (this.currId === undefined) return;
                    clearTimeout(this.currId);
                    this.logger.spam(`Cleared ${this.name} timer with id ${this.currId}`);
                    this.currId = undefined;
                };
                _proto.isRunning = function isRunning() {
                    return this.currId !== undefined;
                };
                return Timer;
            }();
            exports.default = Timer;
        /***/ },
        /* 719 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _javascriptStateMachine = _interopRequireDefault(__webpack_require__(308));
            var _elapsed = _interopRequireDefault(__webpack_require__(720));
            var _socketCloseCodes = __webpack_require__(77);
            var _log = _interopRequireDefault(__webpack_require__(2));
            const logger = (0, _log.default)('ReconnectableSocketStateMachine');
            const CLOSE_UNSUPPORTED = _socketCloseCodes.codes.CLOSE_UNSUPPORTED, CLOSE_UNEXPECTED_CONDITION = _socketCloseCodes.codes.CLOSE_UNEXPECTED_CONDITION;
            var _default = (_ref)=>{
                let reconnectMaxDuration = _ref.reconnectMaxDuration, CLOSED = _ref.CLOSED, CLOSING = _ref.CLOSING;
                let hasReconnectMaxDurationElapsed;
                function handleDisconnect(_ref2) {
                    let code = _ref2.code;
                    if (this.state === 'open' || !hasReconnectMaxDurationElapsed) hasReconnectMaxDurationElapsed = (0, _elapsed.default)(reconnectMaxDuration);
                    const shouldReconnect = reconnectMaxDuration > 0 && !hasReconnectMaxDurationElapsed() && [
                        CLOSE_UNSUPPORTED,
                        CLOSE_UNEXPECTED_CONDITION
                    ].indexOf(code) === -1 && [
                        CLOSED,
                        CLOSING
                    ].indexOf(this.readyState) === -1;
                    if (shouldReconnect) return 'reconnecting';
                    return 'closing';
                }
                return new _javascriptStateMachine.default({
                    init: 'connecting',
                    methods: {
                        onInvalidTransition (transition, from, to) {
                            logger.error('Invalid state transition', {
                                transition: transition,
                                from: from,
                                to: to
                            });
                        }
                    },
                    transitions: [
                        {
                            name: 'open',
                            from: [
                                'connecting',
                                'reconnecting'
                            ],
                            to: 'open'
                        },
                        {
                            name: 'close',
                            from: [
                                'connecting',
                                'reconnecting',
                                'open'
                            ],
                            to: 'closing'
                        },
                        {
                            name: 'closed',
                            from: 'closing',
                            to: 'closed'
                        },
                        {
                            name: 'disconnect',
                            from: [
                                'reconnecting',
                                'open',
                                'connecting'
                            ],
                            to: handleDisconnect
                        }
                    ]
                });
            };
            exports.default = _default;
        /***/ },
        /* 720 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = (timeInMilliseconds)=>{
                let hasElapsed = false;
                setTimeout(()=>{
                    hasElapsed = true;
                }, timeInMilliseconds);
                return ()=>hasElapsed;
            };
        /***/ },
        /* 721 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _promiseDelay = _interopRequireDefault(__webpack_require__(106));
            var _default = /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(webSocket, _temp) {
                    var _ref2, _ref2$BUFFER_DRAIN_IN, BUFFER_DRAIN_INTERVAL, _ref2$BUFFER_DRAIN_MA, BUFFER_DRAIN_MAX_RETRIES, attemptNo;
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _ref2 = _temp === void 0 ? {} : _temp, _ref2$BUFFER_DRAIN_IN = _ref2.BUFFER_DRAIN_INTERVAL, BUFFER_DRAIN_INTERVAL = _ref2$BUFFER_DRAIN_IN === void 0 ? 100 : _ref2$BUFFER_DRAIN_IN, _ref2$BUFFER_DRAIN_MA = _ref2.BUFFER_DRAIN_MAX_RETRIES, BUFFER_DRAIN_MAX_RETRIES = _ref2$BUFFER_DRAIN_MA === void 0 ? 10 : _ref2$BUFFER_DRAIN_MA;
                                attemptNo = 0;
                            case 2:
                                if (!(attemptNo < BUFFER_DRAIN_MAX_RETRIES)) {
                                    _context.next = 10;
                                    break;
                                }
                                if (!(webSocket.bufferedAmount === 0)) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("break", 10);
                            case 5:
                                _context.next = 7;
                                return (0, _promiseDelay.default)(BUFFER_DRAIN_INTERVAL);
                            case 7:
                                attemptNo += 1;
                                _context.next = 2;
                                break;
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function(_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }();
            exports.default = _default;
        /***/ },
        /* 722 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(108);
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(156));
            var _createClass2 = _interopRequireDefault(__webpack_require__(46));
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _uuid = _interopRequireDefault(__webpack_require__(16));
            var _logEvents = _interopRequireDefault(__webpack_require__(319));
            var _RumorMessage = _interopRequireDefault(__webpack_require__(723));
            var RumorMessageTypes = _interopRequireWildcard(__webpack_require__(172));
            var _SocketError = _interopRequireDefault(__webpack_require__(726));
            var _socketCloseCodes = __webpack_require__(77);
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-underscore-dangle */ var _default = (_ref)=>{
                var _class, _temp;
                let EventEmitter = _ref.EventEmitter, ReconnectableSocket = _ref.ReconnectableSocket, logging = _ref.logging, allocateId = _ref.allocateId;
                return _temp = _class = /*#__PURE__*/ function(_EventEmitter) {
                    (0, _inheritsLoose2.default)(RumorSocket, _EventEmitter);
                    (0, _createClass2.default)(RumorSocket, [
                        {
                            key: "readyState",
                            get: function get() {
                                return this._socket ? this._socket.readyState : ReconnectableSocket.CONNECTING;
                            }
                        },
                        {
                            key: "reconnecting",
                            get: function get() {
                                return this._opened && this._socket && this._socket.reconnecting;
                            } // Messages which have not yet been acknowledged
                        }
                    ]);
                    function RumorSocket(_ref2) {
                        var _this;
                        let messagingURL = _ref2.messagingURL, notifyDisconnectAddress = _ref2.notifyDisconnectAddress, connectionId = _ref2.connectionId, enableReconnection = _ref2.enableReconnection, _ref2$pingThreshold = _ref2.pingThreshold, pingThreshold = _ref2$pingThreshold === void 0 ? 2000 : _ref2$pingThreshold, _ref2$disconnectThres = _ref2.disconnectThreshold, disconnectThreshold = _ref2$disconnectThres === void 0 ? (enableReconnection ? 3 : 25) * pingThreshold - 100 : _ref2$disconnectThres, _ref2$reconnectMaxDur = _ref2.reconnectMaxDuration, reconnectMaxDuration = _ref2$reconnectMaxDur === void 0 ? enableReconnection ? 60000 : 0 : _ref2$reconnectMaxDur;
                        _this = _EventEmitter.call(this) || this;
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "url", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "id", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_opened", false);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_socket", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_reconnectAttempts", 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_socketID", (0, _uuid.default)());
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_receivedTransactionIDs", []);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_notifyDisconnectAddress", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_enableReconnection", void 0);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_pendingMessages", []);
                        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_logger", logging(`RumorSocket:${allocateId()}`));
                        (0, _logEvents.default)({
                            logger: _this._logger,
                            obj: (0, _assertThisInitialized2.default)(_this),
                            eventNames: [
                                'open',
                                'message',
                                'error',
                                'reconnecting',
                                'reconnectAttempt',
                                'reconnectFailure',
                                'reconnected',
                                'close'
                            ]
                        });
                        _this.url = messagingURL;
                        _this.id = connectionId;
                        _this._notifyDisconnectAddress = notifyDisconnectAddress;
                        _this._enableReconnection = enableReconnection;
                        _this.on('error', (socketError)=>{
                            _this._logger.error(socketError.message);
                        });
                        try {
                            _this._socket = new ReconnectableSocket({
                                url: ()=>!_this._enableReconnection ? _this.url : [
                                        _this.url,
                                        _this.url.indexOf('?') >= 0 ? '&' : '?',
                                        `socketId=${_this._socketID}`,
                                        _this._socket && _this._socket.reconnecting ? '&reconnect=true' : '',
                                        `&attempt=${(0, _uuid.default)()}`
                                    ].join(''),
                                pingThreshold: pingThreshold,
                                disconnectThreshold: disconnectThreshold,
                                reconnectMaxDuration: reconnectMaxDuration
                            });
                        } catch (e) {
                            _this._logger.error(e);
                            _this.emit('error', new _SocketError.default(_socketCloseCodes.codes.CLOSE_CONNECT_EXCEPTION));
                        }
                        const onOpen = ()=>{
                            _this._opened = true;
                            _this._socket.send(_RumorMessage.default.Connect(_this.id, notifyDisconnectAddress).serialize());
                            _this.emit('open', _this.id);
                        };
                        _this._socket.once('open', onOpen);
                        _this._socket.on('message', (event)=>_this._receiveMessage(event));
                        _this._socket.once('close', (closeEvent)=>{
                            _this._logger.debug(`ReconnectableSocket closed (code: ${closeEvent.code})`);
                            _this._clearPendingMessages(); // We don't emit an error for these close codes because they are normal and TIMEOUT has a
                            // dedicated error and we would duplicate it here.
                            const CLOSE_NORMAL = _socketCloseCodes.codes.CLOSE_NORMAL, CLOSE_GOING_AWAY = _socketCloseCodes.codes.CLOSE_GOING_AWAY, CLOSE_TIMEOUT = _socketCloseCodes.codes.CLOSE_TIMEOUT;
                            if ([
                                CLOSE_NORMAL,
                                CLOSE_GOING_AWAY,
                                CLOSE_TIMEOUT
                            ].indexOf(closeEvent.code) === -1) _this.emit('error', new _SocketError.default(closeEvent.code));
                            _this.emit('close', closeEvent);
                        });
                        _this._socket.on('error', (_ref3)=>{
                            let code = _ref3.code;
                            return _this.emit('error', new _SocketError.default(code));
                        });
                        _this._socket.on('needsPing', ()=>{
                            _this._socket.send(_RumorMessage.default.Ping().serialize());
                        });
                        _this._socket.on('reconnecting', ()=>{
                            if (!_this._opened) return;
                             // ignore reconnect events when we haven't opened yet
                            _this._clearPendingMessagesWhichShouldntRetry();
                            _this.emit('reconnecting');
                            _this._reconnectAttempts = 0;
                        });
                        _this._socket.on('reconnectAttempt', ()=>{
                            if (!_this._opened) return;
                             // ignore reconnect events when we haven't opened yet
                            _this._reconnectAttempts += 1; // TODO: Although this should be ok if the socket is already closed since ReconnectableSocket
                            // will just drop it due to retryAfterReconnect=false, it should be tested.
                            _this._socket.send(_RumorMessage.default.Disconnect('1').serialize(), false);
                            _this.emit('reconnectAttempt');
                        });
                        _this._socket.on('reconnected', ()=>{
                            if (!_this._opened) {
                                onOpen();
                                return;
                            } // ignore reconnect events when we haven't opened yet
                            // Resend pending messages (unacknowledged messages)
                            _this._pendingMessages.forEach((msg)=>{
                                _this._socket.send(msg.rumorMessage.serialize());
                            });
                            _this.emit('reconnected');
                        });
                        _this._socket.on('reconnectFailure', ()=>{
                            if (!_this._opened) return;
                             // ignore reconnect events when we haven't opened yet
                            _this._logger.debug('Reconnecting failed as connectivity was not restored within ' + `${reconnectMaxDuration}ms`); // TODO: This was picked when porting over the old code, but we should be able to set use a
                            // better code and message here.
                            _this.emit('reconnectFailure', new _SocketError.default());
                        });
                        return _this;
                    }
                    var _proto = RumorSocket.prototype;
                    _proto._clearPendingMessagesWhichShouldntRetry = function _clearPendingMessagesWhichShouldntRetry() {
                        const messagesToClear = this._pendingMessages.filter((message)=>!message.retryAfterReconnect);
                        this._pendingMessages = this._pendingMessages.filter((message)=>message.retryAfterReconnect);
                        messagesToClear.forEach((message)=>{
                            const error = new Error('Not connected.');
                            error.code = 500;
                            message.completion(error);
                        });
                    };
                    _proto._clearPendingMessages = function _clearPendingMessages() {
                        this._pendingMessages.forEach((message)=>{
                            const error = new Error('Not connected.');
                            error.code = 500;
                            message.completion(error);
                        });
                        this._pendingMessages = [];
                    };
                    _proto._sendAck = function _sendAck(msg) {
                        this._socket.send(_RumorMessage.default.Status([
                            msg.fromAddress
                        ], {
                            'TRANSACTION-ID': msg.headers['TRANSACTION-ID'],
                            'X-TB-FROM-ADDRESS': this.id
                        }).serialize());
                    };
                    _proto._receiveMessage = function _receiveMessage(messageEvent) {
                        const msg = _RumorMessage.default.deserialize(messageEvent.data);
                        if (msg.type === RumorMessageTypes.PONG) return;
                        this._logger.debug('Received:', msg);
                        if (msg.transactionId) // remove pending message
                        this._pendingMessages = this._pendingMessages.filter((pendingMessage)=>{
                            if (pendingMessage.rumorMessage.transactionId === msg.transactionId) {
                                this._logger.debug('Marking', msg.transactionId, ' as received');
                                pendingMessage.completion(undefined, msg);
                            }
                            return pendingMessage.rumorMessage.transactionId !== msg.transactionId;
                        });
                        if (msg.transactionId && msg.type !== RumorMessageTypes.STATUS) {
                            // 1) ack it!
                            this._sendAck(msg); // Have we seen this transaction before?
                            if (this._receivedTransactionIDs.indexOf(msg.transactionId) >= 0) // We've handled this transactionId before, but the ACK
                            // must have been lost. That's ok, we've told the server
                            // so we can just ignore this message now.
                            return;
                            this._receivedTransactionIDs.push(msg.transactionId);
                        }
                        this.emit('message', msg);
                    };
                    _proto.publish = function publish(topics, message, headers, retryAfterReconnect, completion) {
                        if (completion === void 0) completion = ()=>{};
                        // TODO: Instead of completion, sending a message should return an event emitter which emits:
                        // - sent: if connected, emitted on next tick, if reconnecting, emitted on reconnected
                        // - ack: received ack for this message from server
                        // - error: won't receive ack (not connected / dropped)
                        // Also should have .status obtained from ReconnectableSocket.send
                        const rumorMessage = _RumorMessage.default.Publish(topics, message, headers); // We always use retryAfterReconnect=false on ReconnectableSocket because rumor does additional
                        // retries based on the ack status of messages which ReconnectableSocket doesn't know about,
                        // and we don't want these retry strategies to conflict.
                        const status = this._socket.send(rumorMessage.serialize(), false);
                        if (status === 'dropped' && !retryAfterReconnect) {
                            const error = new Error('Not connected.');
                            error.code = 500;
                            completion(error);
                            return;
                        }
                        this._pendingMessages.push({
                            rumorMessage: rumorMessage,
                            retryAfterReconnect: retryAfterReconnect,
                            completion: completion
                        });
                    };
                    _proto.subscribe = function subscribe(topics) {
                        this._socket.send(_RumorMessage.default.Subscribe(topics).serialize());
                    };
                    _proto.unsubscribe = function unsubscribe(topics) {
                        this._socket.send(_RumorMessage.default.Unsubscribe(topics).serialize());
                    };
                    _proto.disconnect = function disconnect() {
                        if (this.readyState === RumorSocket.OPEN) this._socket.send(_RumorMessage.default.Disconnect().serialize());
                        if (this._socket.readyState !== ReconnectableSocket.CLOSED && this._socket.readyState !== ReconnectableSocket.CLOSING) {
                            const CLOSE_NORMAL = _socketCloseCodes.codes.CLOSE_NORMAL;
                            this._socket.close(CLOSE_NORMAL, _socketCloseCodes.messages[CLOSE_NORMAL]);
                        }
                    };
                    _proto.status = function status(toAddress, transactionId) {
                        this._socket.send(_RumorMessage.default.Status(toAddress, {
                            'TRANSACTION-ID': transactionId,
                            'X-TB-FROM-ADDRESS': this.id
                        }).serialize());
                    };
                    _proto.reconnectRetriesCount = function reconnectRetriesCount() {
                        return this._reconnectAttempts;
                    };
                    _proto.messageQueueSize = function messageQueueSize() {
                        return this._pendingMessages.length;
                    } // This could do with some reconciliation. Also with logger name now.
                    ;
                    (0, _createClass2.default)(RumorSocket, [
                        {
                            key: "socketID",
                            get: function get() {
                                return this._socketID;
                            }
                        }
                    ]);
                    return RumorSocket;
                }(EventEmitter), (0, _defineProperty2.default)(_class, "CONNECTING", ReconnectableSocket.CONNECTING), (0, _defineProperty2.default)(_class, "OPEN", ReconnectableSocket.OPEN), (0, _defineProperty2.default)(_class, "CLOSING", ReconnectableSocket.CLOSING), (0, _defineProperty2.default)(_class, "CLOSED", ReconnectableSocket.CLOSED), _temp;
            };
            exports.default = _default;
        /***/ },
        /* 723 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(108);
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var _uuid = _interopRequireDefault(__webpack_require__(16));
            var _encoding = __webpack_require__(724);
            var RumorMessageTypes = _interopRequireWildcard(__webpack_require__(172));
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable one-var, no-restricted-syntax, no-prototype-builtins */ /* eslint-disable no-continue, prefer-const, no-bitwise, no-mixed-operators, no-param-reassign */ const toArrayBuffer = (buffer)=>{
                const ab = new ArrayBuffer(buffer.length);
                const view = new Uint8Array(ab);
                for(let i = 0; i < buffer.length; ++i)view[i] = buffer[i];
                return ab;
            }; // @references
            // * https://tbwiki.tokbox.com/index.php/Rumor_Message_Packet
            // * https://tbwiki.tokbox.com/index.php/Rumor_Protocol
            //
            let RumorMessage = /*#__PURE__*/ function() {
                function RumorMessage(type, toAddress, headers, data) {
                    (0, _defineProperty2.default)(this, "type", void 0);
                    (0, _defineProperty2.default)(this, "toAddress", void 0);
                    (0, _defineProperty2.default)(this, "headers", void 0);
                    (0, _defineProperty2.default)(this, "data", void 0);
                    this.type = type;
                    this.toAddress = toAddress;
                    this.headers = headers;
                    this.data = data;
                    this.fromAddress = this.headers['X-TB-FROM-ADDRESS'];
                    this.transactionId = this.headers['TRANSACTION-ID'];
                    this.status = this.headers.STATUS; // Only status messages will have a status header. So a missing status header
                    // does not indicate an eror.
                    this.isError = this.status && this.status[0] !== '2';
                }
                var _proto = RumorMessage.prototype;
                _proto.serialize = function serialize() {
                    let strArray, dataView, i, j;
                    let offset = 8;
                    let cBuf = 7;
                    const address = [];
                    const headerKey = [];
                    const headerVal = []; // The number of addresses
                    cBuf++; // Write out the address.
                    for(i = 0; i < this.toAddress.length; i++){
                        /* jshint newcap:false */ address.push(new _encoding.TextEncoder('utf-8').encode(this.toAddress[i]));
                        cBuf += 2;
                        cBuf += address[i].length;
                    } // The number of parameters
                    cBuf++; // Write out the params
                    i = 0;
                    for(const key in this.headers){
                        // eslint-disable-line one-var
                        if (!this.headers.hasOwnProperty(key)) continue;
                        headerKey.push(new _encoding.TextEncoder('utf-8').encode(key));
                        headerVal.push(new _encoding.TextEncoder('utf-8').encode(this.headers[key]));
                        cBuf += 4;
                        cBuf += headerKey[i].length;
                        cBuf += headerVal[i].length;
                        i++;
                    }
                    dataView = new _encoding.TextEncoder('utf-8').encode(this.data);
                    cBuf += dataView.length; // Let's allocate a binary blob of this size
                    const buffer = new ArrayBuffer(cBuf);
                    const uint8View = new Uint8Array(buffer, 0, cBuf); // We don't include the header in the lenght.
                    cBuf -= 4; // Write out size (in network order)
                    uint8View[0] = (cBuf & 0xFF000000) >>> 24;
                    uint8View[1] = (cBuf & 0x00FF0000) >>> 16;
                    uint8View[2] = (cBuf & 0x0000FF00) >>> 8;
                    uint8View[3] = (cBuf & 0x000000FF) >>> 0; // Write out reserved bytes
                    uint8View[4] = 0;
                    uint8View[5] = 0; // Write out message type
                    uint8View[6] = this.type;
                    uint8View[7] = this.toAddress.length; // Now just copy over the encoded values..
                    for(i = 0; i < address.length; i++){
                        strArray = address[i];
                        uint8View[offset++] = strArray.length >> 8 & 0xFF;
                        uint8View[offset++] = strArray.length >> 0 & 0xFF;
                        for(j = 0; j < strArray.length; j++)uint8View[offset++] = strArray[j];
                    }
                    uint8View[offset++] = headerKey.length; // Write out the params
                    for(i = 0; i < headerKey.length; i++){
                        strArray = headerKey[i];
                        uint8View[offset++] = strArray.length >> 8 & 0xFF;
                        uint8View[offset++] = strArray.length >> 0 & 0xFF;
                        for(j = 0; j < strArray.length; j++)uint8View[offset++] = strArray[j];
                        strArray = headerVal[i];
                        uint8View[offset++] = strArray.length >> 8 & 0xFF;
                        uint8View[offset++] = strArray.length >> 0 & 0xFF;
                        for(j = 0; j < strArray.length; j++)uint8View[offset++] = strArray[j];
                    } // And finally the data
                    for(i = 0; i < dataView.length; i++)uint8View[offset++] = dataView[i];
                    return buffer;
                };
                RumorMessage.deserialize = function deserialize(buffer) {
                    if (window.Buffer && window.Buffer.isBuffer(buffer)) buffer = toArrayBuffer(buffer);
                    let type, strView, headerlen, headers, keyStr, valStr, length, i;
                    let offset = 8;
                    const uint8View = new Uint8Array(buffer);
                    type = uint8View[6];
                    const address = [];
                    for(i = 0; i < uint8View[7]; i++){
                        length = uint8View[offset++] << 8;
                        length += uint8View[offset++];
                        strView = new Uint8Array(buffer, offset, length);
                        /* jshint newcap:false */ address[i] = new _encoding.TextDecoder('utf-8').decode(strView);
                        offset += length;
                    }
                    headerlen = uint8View[offset++];
                    headers = {};
                    for(i = 0; i < headerlen; i++){
                        length = uint8View[offset++] << 8;
                        length += uint8View[offset++];
                        strView = new Uint8Array(buffer, offset, length);
                        keyStr = new _encoding.TextDecoder('utf-8').decode(strView);
                        offset += length;
                        length = uint8View[offset++] << 8;
                        length += uint8View[offset++];
                        strView = new Uint8Array(buffer, offset, length);
                        valStr = new _encoding.TextDecoder('utf-8').decode(strView);
                        headers[keyStr] = valStr;
                        offset += length;
                    }
                    const dataView = new Uint8Array(buffer, offset);
                    const data = new _encoding.TextDecoder('utf-8').decode(dataView);
                    return new RumorMessage(type, address, headers, data);
                };
                RumorMessage.Connect = function Connect(uniqueId, notifyDisconnectAddress) {
                    const headers = {
                        uniqueId: uniqueId,
                        'TRANSACTION-ID': (0, _uuid.default)(),
                        notifyDisconnectAddress: notifyDisconnectAddress
                    };
                    return new RumorMessage(RumorMessageTypes.CONNECT, [], headers, '');
                };
                RumorMessage.Disconnect = function Disconnect(reconnect) {
                    return new RumorMessage(RumorMessageTypes.DISCONNECT, [], {
                        reconnect: reconnect
                    }, '');
                };
                RumorMessage.Subscribe = function Subscribe(topics) {
                    return new RumorMessage(RumorMessageTypes.SUBSCRIBE, topics, {}, '');
                };
                RumorMessage.Unsubscribe = function Unsubscribe(topics) {
                    return new RumorMessage(RumorMessageTypes.UNSUBSCRIBE, topics, {}, '');
                };
                RumorMessage.Publish = function Publish(topics, message, headers) {
                    return new RumorMessage(RumorMessageTypes.MESSAGE, topics, headers || {}, message || '');
                };
                RumorMessage.Status = function Status(topics, headers) {
                    return new RumorMessage(RumorMessageTypes.STATUS, topics, headers || {}, '');
                } // This message is used to implement keepalives on the persistent
                ;
                RumorMessage.Ping = function Ping() {
                    return new RumorMessage(RumorMessageTypes.PING, [], {}, '');
                };
                return RumorMessage;
            }();
            exports.default = RumorMessage;
        /***/ },
        /* 724 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(108);
            exports.__esModule = true;
            exports.TextDecoder = exports.TextEncoder = void 0;
            var TextEncoding = _interopRequireWildcard(__webpack_require__(725));
            // Unfortunately it looks like the text-encoding module always returns its implementations of
            // TextEncoder and TextDecoder, so we wrap it here to expose the global (window) ones, if available.
            const TextEncoder1 = window.TextEncoder || TextEncoding.TextEncoder;
            exports.TextEncoder = TextEncoder1;
            const TextDecoder1 = window.TextDecoder || TextEncoding.TextDecoder;
            exports.TextDecoder = TextDecoder1;
        /***/ },
        /* 725 */ /***/ function(__webpack_module__, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextEncoder", function() {
                return TextEncoder1;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextDecoder", function() {
                return TextDecoder1;
            });
            // This is free and unencumbered software released into the public domain.
            // See LICENSE.md for more information.
            //
            // Utilities
            //
            /**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function inRange(a, min, max) {
                return min <= a && a <= max;
            }
            /**
 * @param {*} o
 * @return {Object}
 */ function ToDictionary(o) {
                if (o === undefined) return {};
                if (o === Object(o)) return o;
                throw TypeError('Could not convert argument to dictionary');
            }
            /**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function stringToCodePoints(string) {
                // https://heycam.github.io/webidl/#dfn-obtain-unicode
                // 1. Let S be the DOMString value.
                var s = String(string);
                // 2. Let n be the length of S.
                var n = s.length;
                // 3. Initialize i to 0.
                var i = 0;
                // 4. Initialize U to be an empty sequence of Unicode characters.
                var u = [];
                // 5. While i < n:
                while(i < n){
                    // 1. Let c be the code unit in S at index i.
                    var c = s.charCodeAt(i);
                    // 2. Depending on the value of c:
                    // c < 0xD800 or c > 0xDFFF
                    if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
                    u.push(c);
                    else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
                    u.push(0xFFFD);
                    else if (0xD800 <= c && c <= 0xDBFF) {
                        // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
                        // CHARACTER.
                        if (i === n - 1) u.push(0xFFFD);
                        else {
                            // 1. Let d be the code unit in S at index i+1.
                            var d = string.charCodeAt(i + 1);
                            // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                            if (0xDC00 <= d && d <= 0xDFFF) {
                                // 1. Let a be c & 0x3FF.
                                var a = c & 0x3FF;
                                // 2. Let b be d & 0x3FF.
                                var b = d & 0x3FF;
                                // 3. Append to U the Unicode character with code point
                                // 2^16+2^10*a+b.
                                u.push(0x10000 + (a << 10) + b);
                                // 4. Set i to i+1.
                                i += 1;
                            } else u.push(0xFFFD);
                        }
                    }
                    // 3. Set i to i+1.
                    i += 1;
                }
                // 6. Return U.
                return u;
            }
            /**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function codePointsToString(code_points) {
                var s = '';
                for(var i = 0; i < code_points.length; ++i){
                    var cp = code_points[i];
                    if (cp <= 0xFFFF) s += String.fromCharCode(cp);
                    else {
                        cp -= 0x10000;
                        s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
                    }
                }
                return s;
            }
            //
            // Implementation of Encoding specification
            // https://encoding.spec.whatwg.org/
            //
            //
            // 3. Terminology
            //
            /**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var end_of_stream = -1;
            /**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function Stream(tokens) {
                /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
            }
            Stream.prototype = {
                /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
                    return !this.tokens.length;
                },
                /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
                    if (!this.tokens.length) return end_of_stream;
                    return this.tokens.shift();
                },
                /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
                    if (Array.isArray(token)) {
                        var tokens = /**@type {!Array.<number>}*/ token;
                        while(tokens.length)this.tokens.unshift(tokens.pop());
                    } else this.tokens.unshift(token);
                },
                /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
                    if (Array.isArray(token)) {
                        var tokens = /**@type {!Array.<number>}*/ token;
                        while(tokens.length)this.tokens.push(tokens.shift());
                    } else this.tokens.push(token);
                }
            };
            //
            // 4. Encodings
            //
            // 4.1 Encoders and decoders
            /** @const */ var finished = -1;
            /**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function decoderError(fatal, opt_code_point) {
                if (fatal) throw TypeError('Decoder error');
                return opt_code_point || 0xFFFD;
            }
            /** @interface */ function Decoder() {}
            Decoder.prototype = {
                /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point, or |finished|.
   */ handler: function(stream, bite) {}
            };
            /** @interface */ function Encoder() {}
            Encoder.prototype = {
                /**
   * @param {Stream} stream The stream of code points being encoded.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit, or |finished|.
   */ handler: function(stream, code_point) {}
            };
            //
            // 7. API
            //
            /** @const */ var DEFAULT_ENCODING = 'utf-8';
            // 7.1 Interface TextDecoder
            /**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function TextDecoder1(encoding, options) {
                if (!(this instanceof TextDecoder1)) return new TextDecoder1(encoding, options);
                encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
                if (encoding !== DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
                options = ToDictionary(options);
                /** @private @type {boolean} */ this._streaming = false;
                /** @private @type {boolean} */ this._BOMseen = false;
                /** @private @type {?Decoder} */ this._decoder = null;
                /** @private @type {boolean} */ this._fatal = Boolean(options['fatal']);
                /** @private @type {boolean} */ this._ignoreBOM = Boolean(options['ignoreBOM']);
                Object.defineProperty(this, 'encoding', {
                    value: 'utf-8'
                });
                Object.defineProperty(this, 'fatal', {
                    value: this._fatal
                });
                Object.defineProperty(this, 'ignoreBOM', {
                    value: this._ignoreBOM
                });
            }
            TextDecoder1.prototype = {
                /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
                    var bytes;
                    if (typeof input === 'object' && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
                    else if (typeof input === 'object' && 'buffer' in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
                    else bytes = new Uint8Array(0);
                    options = ToDictionary(options);
                    if (!this._streaming) {
                        this._decoder = new UTF8Decoder({
                            fatal: this._fatal
                        });
                        this._BOMseen = false;
                    }
                    this._streaming = Boolean(options['stream']);
                    var input_stream = new Stream(bytes);
                    var code_points = [];
                    /** @type {?(number|!Array.<number>)} */ var result;
                    while(!input_stream.endOfStream()){
                        result = this._decoder.handler(input_stream, input_stream.read());
                        if (result === finished) break;
                        if (result === null) continue;
                        if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                        else code_points.push(result);
                    }
                    if (!this._streaming) {
                        do {
                            result = this._decoder.handler(input_stream, input_stream.read());
                            if (result === finished) break;
                            if (result === null) continue;
                            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                            else code_points.push(result);
                        }while (!input_stream.endOfStream());
                        this._decoder = null;
                    }
                    if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
                    // ignore BOM flag and BOM seen flag are unset, run these
                    // subsubsteps:
                    {
                        if ([
                            'utf-8'
                        ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                            // If token is U+FEFF, set BOM seen flag.
                            if (code_points[0] === 0xFEFF) {
                                this._BOMseen = true;
                                code_points.shift();
                            } else // Otherwise, if token is not end-of-stream, set BOM seen
                            // flag and append token to output.
                            this._BOMseen = true;
                        }
                    }
                    return codePointsToString(code_points);
                }
            };
            // 7.2 Interface TextEncoder
            /**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function TextEncoder1(encoding, options) {
                if (!(this instanceof TextEncoder1)) return new TextEncoder1(encoding, options);
                encoding = encoding !== undefined ? String(encoding).toLowerCase() : DEFAULT_ENCODING;
                if (encoding !== DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
                options = ToDictionary(options);
                /** @private @type {boolean} */ this._streaming = false;
                /** @private @type {?Encoder} */ this._encoder = null;
                /** @private @type {{fatal: boolean}} */ this._options = {
                    fatal: Boolean(options['fatal'])
                };
                Object.defineProperty(this, 'encoding', {
                    value: 'utf-8'
                });
            }
            TextEncoder1.prototype = {
                /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
                    opt_string = opt_string ? String(opt_string) : '';
                    options = ToDictionary(options);
                    // NOTE: This option is nonstandard. None of the encodings
                    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
                    // so streaming is not necessary.
                    if (!this._streaming) this._encoder = new UTF8Encoder(this._options);
                    this._streaming = Boolean(options['stream']);
                    var bytes = [];
                    var input_stream = new Stream(stringToCodePoints(opt_string));
                    /** @type {?(number|!Array.<number>)} */ var result;
                    while(!input_stream.endOfStream()){
                        result = this._encoder.handler(input_stream, input_stream.read());
                        if (result === finished) break;
                        if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                        else bytes.push(result);
                    }
                    if (!this._streaming) {
                        while(true){
                            result = this._encoder.handler(input_stream, input_stream.read());
                            if (result === finished) break;
                            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                            else bytes.push(result);
                        }
                        this._encoder = null;
                    }
                    return new Uint8Array(bytes);
                }
            };
            //
            // 8. The encoding
            //
            // 8.1 utf-8
            /**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function UTF8Decoder(options) {
                var fatal = options.fatal;
                // utf-8's decoder's has an associated utf-8 code point, utf-8
                // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
                // lower boundary (initially 0x80), and a utf-8 upper boundary
                // (initially 0xBF).
                var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
                /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
                    // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
                    // set utf-8 bytes needed to 0 and return error.
                    if (bite === end_of_stream && utf8_bytes_needed !== 0) {
                        utf8_bytes_needed = 0;
                        return decoderError(fatal);
                    }
                    // 2. If byte is end-of-stream, return finished.
                    if (bite === end_of_stream) return finished;
                    // 3. If utf-8 bytes needed is 0, based on byte:
                    if (utf8_bytes_needed === 0) {
                        // 0x00 to 0x7F
                        if (inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
                        return bite;
                        // 0xC2 to 0xDF
                        if (inRange(bite, 0xC2, 0xDF)) {
                            // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                            // − 0xC0.
                            utf8_bytes_needed = 1;
                            utf8_code_point = bite - 0xC0;
                        } else if (inRange(bite, 0xE0, 0xEF)) {
                            // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                            if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                            // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                            if (bite === 0xED) utf8_upper_boundary = 0x9F;
                            // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                            // byte − 0xE0.
                            utf8_bytes_needed = 2;
                            utf8_code_point = bite - 0xE0;
                        } else if (inRange(bite, 0xF0, 0xF4)) {
                            // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                            if (bite === 0xF0) utf8_lower_boundary = 0x90;
                            // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                            if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                            // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                            // byte − 0xF0.
                            utf8_bytes_needed = 3;
                            utf8_code_point = bite - 0xF0;
                        } else // Return error.
                        return decoderError(fatal);
                        // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
                        // point to utf-8 code point << (6 × utf-8 bytes needed) and
                        // return continue.
                        utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
                        return null;
                    }
                    // 4. If byte is not in the range utf-8 lower boundary to utf-8
                    // upper boundary, run these substeps:
                    if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
                        // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
                        // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
                        // utf-8 upper boundary to 0xBF.
                        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
                        utf8_lower_boundary = 0x80;
                        utf8_upper_boundary = 0xBF;
                        // 2. Prepend byte to stream.
                        stream.prepend(bite);
                        // 3. Return error.
                        return decoderError(fatal);
                    }
                    // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
                    // to 0xBF.
                    utf8_lower_boundary = 0x80;
                    utf8_upper_boundary = 0xBF;
                    // 6. Increase utf-8 bytes seen by one and set utf-8 code point
                    // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
                    // needed − utf-8 bytes seen)).
                    utf8_bytes_seen += 1;
                    utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
                    // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
                    // continue.
                    if (utf8_bytes_seen !== utf8_bytes_needed) return null;
                    // 8. Let code point be utf-8 code point.
                    var code_point = utf8_code_point;
                    // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
                    // seen to 0.
                    utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
                    // 10. Return a code point whose value is code point.
                    return code_point;
                };
            }
            /**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function UTF8Encoder(options) {
                var fatal = options.fatal;
                /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
                    // 1. If code point is end-of-stream, return finished.
                    if (code_point === end_of_stream) return finished;
                    // 2. If code point is in the range U+0000 to U+007F, return a
                    // byte whose value is code point.
                    if (inRange(code_point, 0x0000, 0x007f)) return code_point;
                    // 3. Set count and offset based on the range code point is in:
                    var count, offset;
                    // U+0080 to U+07FF:    1 and 0xC0
                    if (inRange(code_point, 0x0080, 0x07FF)) {
                        count = 1;
                        offset = 0xC0;
                    } else if (inRange(code_point, 0x0800, 0xFFFF)) {
                        count = 2;
                        offset = 0xE0;
                    } else if (inRange(code_point, 0x10000, 0x10FFFF)) {
                        count = 3;
                        offset = 0xF0;
                    }
                    // 4.Let bytes be a byte sequence whose first byte is (code
                    // point >> (6 × count)) + offset.
                    var bytes = [
                        (code_point >> 6 * count) + offset
                    ];
                    // 5. Run these substeps while count is greater than 0:
                    while(count > 0){
                        // 1. Set temp to code point >> (6 × (count − 1)).
                        var temp = code_point >> 6 * (count - 1);
                        // 2. Append to bytes 0x80 | (temp & 0x3F).
                        bytes.push(0x80 | temp & 0x3F);
                        // 3. Decrease count by one.
                        count -= 1;
                    }
                    // 6. Return bytes bytes, in order.
                    return bytes;
                };
            }
        /***/ },
        /* 726 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireWildcard = __webpack_require__(108);
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            var socketCloseCodes = _interopRequireWildcard(__webpack_require__(77));
            const errors = __webpack_require__(6);
            let SocketError = function SocketError(code) {
                (0, _defineProperty2.default)(this, "code", void 0);
                (0, _defineProperty2.default)(this, "message", void 0);
                (0, _defineProperty2.default)(this, "name", void 0);
                this.code = socketCloseCodes.codes.CLOSE_FALLBACK_CODE;
                if (Object.values(socketCloseCodes.codes).includes(code)) {
                    this.code = code;
                    switch(this.code){
                        case socketCloseCodes.codes.CLOSE_GOING_AWAY:
                        case socketCloseCodes.codes.CLOSE_PROTOCOL_ERROR:
                        case socketCloseCodes.codes.CLOSE_UNSUPPORTED:
                        case socketCloseCodes.codes.CLOSE_NO_STATUS:
                        case socketCloseCodes.codes.CLOSE_ABNORMAL:
                        case socketCloseCodes.codes.CLOSE_INCONSISTENT_DATA:
                        case socketCloseCodes.codes.CLOSE_POLICY_VIOLATION:
                        case socketCloseCodes.codes.CLOSE_TOO_LARGE:
                        case socketCloseCodes.codes.CLOSE_UNEXPECTED_CONDITION:
                        case socketCloseCodes.codes.CLOSE_CONNECTIVITY_LOSS:
                        case socketCloseCodes.codes.CLOSE_CONNECT_EXCEPTION:
                        case socketCloseCodes.codes.CLOSE_TIMEOUT:
                            this.name = errors.DISCONNECTED;
                            this.message = 'Action failed due to session disconnection.';
                            return;
                        default:
                            break;
                    }
                }
                this.message = socketCloseCodes.messages[this.code] || 'No message available from code.';
            };
            exports.default = SocketError;
        /***/ },
        /* 727 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            exports.__esModule = true;
            exports.default = void 0;
            var _ws = _interopRequireDefault(__webpack_require__(728));
            var _default = (()=>{
                if (window.WebSocket) return window.WebSocket;
                return _ws.default;
            })();
            exports.default = _default;
        /***/ },
        /* 728 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function() {
                throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
            };
        /***/ },
        /* 729 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const deserializeMessage = __webpack_require__(730);
            module1.exports = function unboxFromRumorMessage(rumorMessage) {
                const message = deserializeMessage(rumorMessage.data);
                message.transactionId = rumorMessage.transactionId;
                message.fromAddress = rumorMessage.headers['X-TB-FROM-ADDRESS'];
                return message;
            };
        /***/ },
        /* 730 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Deserialising a Raptor message mainly means doing a JSON.parse on it.
            // We do decorate the final message with a few extra helper properies though.
            //
            // These include:
            // * typeName: A human readable version of the Raptor type. E.g. STREAM instead of 102
            // * actionName: A human readable version of the Raptor action. E.g. CREATE instead of 101
            // * signature: typeName and actionName combined. This is mainly for debugging. E.g. A type
            //    of 102 and an action of 101 would result in a signature of "STREAM:CREATE"
            //
            module1.exports = function deserializeMessage(msg) {
                if (msg.length === 0) return {};
                const message = JSON.parse(msg);
                const bits = message.uri.substr(1).split('/'); // Remove the Raptor protocol version
                bits.shift();
                if (bits[bits.length - 1] === '') bits.pop();
                message.params = {};
                for(let i = 0, numBits = bits.length; i < numBits - 1; i += 2)message.params[bits[i]] = bits[i + 1];
                 // extract the resource name. We special case 'channel' slightly, as
                // 'subscriber_channel' or 'stream_channel' is more useful for us
                // than 'channel' alone.
                if (bits.length % 2 === 0) {
                    if (bits[bits.length - 2] === 'channel' && bits.length > 6) message.resource = `${bits[bits.length - 4]}_${bits[bits.length - 2]}`;
                    else message.resource = bits[bits.length - 2];
                } else if (bits[bits.length - 1] === 'channel' && bits.length > 5) message.resource = `${bits[bits.length - 3]}_${bits[bits.length - 1]}`;
                else message.resource = bits[bits.length - 1];
                message.signature = `${message.resource}#${message.method}`;
                return message;
            };
        /***/ },
        /* 731 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(3), name = _require.name;
            const hasOpenTokSupport = __webpack_require__(52).once;
            module1.exports = ()=>hasOpenTokSupport() && [
                    'Chrome',
                    'Firefox',
                    'Safari'
                ].indexOf(name) > -1;
        /***/ },
        /* 732 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const env = __webpack_require__(3);
            const hasOpenTokSupport = __webpack_require__(52).once; // TODO Remove all transport stuff, that belongs to the messaging layer not the Media layer.
            // Indicates if the browser supports bundle
            //
            // Broadly:
            // * Firefox support bundle
            // * Chrome support bundle
            // * We assume NodeJs supports bundle (e.g. 'you're on your own' mode)
            //
            module1.exports = ()=>hasOpenTokSupport() && (env.name === 'Chrome' || env.name === 'Firefox' || env.name === 'Node' || env.name === 'Safari' || env.name === 'Edge');
        /***/ },
        /* 733 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const hasOpenTokSupport = __webpack_require__(52).once; // Indicates if the browser supports RTCP Mux
            //
            // Broadly:
            // * All recent versions of WebRTC (both Chrome and Firefox) support RtcpMux
            module1.exports = ()=>hasOpenTokSupport();
        /***/ },
        /* 734 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = 'DTLS_SRTP';
        /***/ },
        /* 735 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function capabilitiesFromHash(_ref) {
                let supportsWebRTC = _ref.supportsWebRTC;
                return {
                    supportsWebRTC: supportsWebRTC === 'true' || supportsWebRTC === true
                };
            };
        /***/ },
        /* 736 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function SignalError(code, message) {
                this.code = code;
                this.message = message; // Undocumented. Left in for backwards compatibility:
                this.reason = message;
            };
        /***/ },
        /* 737 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable prefer-rest-params, no-cond-assign */ const DelayedEventQueue = function DelayedEventQueue(eventDispatcher) {
                const queue = [];
                this.enqueue = function enqueue() /* arg1, arg2, ..., argN */ {
                    queue.push(Array.prototype.slice.call(arguments));
                };
                this.triggerAll = function triggerAll() {
                    let event; // Array.prototype.shift is actually pretty inefficient for longer Arrays,
                    // this is because after the first element is removed it reshuffles every
                    // remaining element up one (1). This involves way too many allocations and
                    // deallocations as the queue size increases.
                    //
                    // A more efficient version could be written by keeping an index to the current
                    // 'first' element in the Array and increasing that by one whenever an element
                    // is removed. The elements that are infront of the index have been 'deleted'.
                    // Periodically the front of the Array could be spliced off to reclaim the space.
                    //
                    // 1. http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.9
                    //
                    //
                    // TLDR: Array.prototype.shift is O(n), where n is the array length,
                    // instead of the expected O(1). You can implement your own shift that runs
                    // in amortised constant time.
                    //
                    // @todo benchmark and see if we should actually care about shift's performance
                    // for our common queue sizes.
                    //
                    while(event = queue.shift())eventDispatcher.trigger(...event);
                };
            };
            module1.exports = DelayedEventQueue;
        /***/ },
        /* 738 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _extends2 = _interopRequireDefault(__webpack_require__(19));
            const defaultAxios = __webpack_require__(207);
            const url = __webpack_require__(240);
            const get = __webpack_require__(59);
            const assign = __webpack_require__(9);
            const SessionInfo = __webpack_require__(141);
            const ExceptionCodes = __webpack_require__(10);
            const mapErrorCodeToName = __webpack_require__(739);
            const mapStatusCodeToErrorCode = __webpack_require__(740);
            const promiseEndeavour = __webpack_require__(290).default;
            const LANGUAGE = {
                EMPTY_RESPONSE: 'Response body was empty, probably due to connectivity loss',
                BADLY_FORMED: 'Unknown error: JSON response was badly formed',
                NO_ERROR: 'No error message',
                UNEXPECTED_SERVER_RESPONSE: (details)=>`Unexpected server response (${details}). Try this operation again later.`
            };
            const RETRY_DELAYS = [
                0,
                600,
                1200
            ];
            /**
 * @typedef {Object} getSessionInfoConfig Configuration
 * @property {String} anvilUrl The base anvil url
 * @property {String} sessionId The id of the session to retrieve info for
 * @property {String} token The token used for authentication
 * @property {String} clientVersion The client version passed to Anvil
 * @property {String} connectionId The connection id passed to Anvil
 *
 * @typedef {Object} getSessionDependencies
 * @property {String=} axios
 */ /**
 * Factory for injecting dependencies into and returning a getSessionInfo function
 *
 * @param {getSessionDependencies} dependencies
 * @returns {getSessionInfo}
 */ function getSessionInfoFactory(_temp) {
                let _ref = _temp === void 0 ? {} : _temp, _ref$axios = _ref.axios, axios = _ref$axios === void 0 ? defaultAxios : _ref$axios, _ref$retryDelays = _ref.retryDelays, retryDelays = _ref$retryDelays === void 0 ? RETRY_DELAYS : _ref$retryDelays;
                /**
   * getSessionInfo - Fetch session details from Anvil and return a SessionInfo object
   *
   * @function getSessionInfo
   * @param {getSessionInfoConfig} config
   * @returns {Promise<SessionInfo>} The session info
   */ function getSessionInfo(/** @type getSessionInfoConfig */ _ref2) {
                    let anvilUrl = _ref2.anvilUrl, sessionId = _ref2.sessionId, token = _ref2.token, clientVersion = _ref2.clientVersion, connectionId = _ref2.connectionId;
                    const parts = url.parse(anvilUrl, true);
                    const targetUrl = url.format({
                        protocol: parts.protocol,
                        auth: parts.auth,
                        host: parts.host,
                        pathname: url.resolve((parts.pathname || '').replace(/\/?$/, '/'), `session/${sessionId}`),
                        query: (0, _extends2.default)({}, parts.query, {
                            extended: true
                        })
                    });
                    return axios.get(targetUrl, {
                        validateStatus: (status)=>status >= 200 && status < 300,
                        headers: {
                            'X-OPENTOK-AUTH': token,
                            'X-TB-VERSION': 1,
                            'X-TB-CLIENT-VERSION': clientVersion,
                            'X-TB-CONNECTIONID': connectionId,
                            Accept: 'application/json'
                        }
                    }) // general http connectivity and status errors from axios
                    .catch((error)=>{
                        if (error.response) {
                            const newError = new Error(LANGUAGE.UNEXPECTED_SERVER_RESPONSE(`${error.response.statusCode}${error.response.status ? ` ${error.response.status}` : ''}`));
                            newError.code = ExceptionCodes.ANVIL_INVALID_HTTP_STATUS;
                            newError.name = mapErrorCodeToName(newError.code);
                            throw newError;
                        } else if (error.request) {
                            const newError = new Error(LANGUAGE.CONNECT_FAILED);
                            newError.code = ExceptionCodes.ANVIL_CONNECT_FAILED;
                            newError.name = mapErrorCodeToName(newError.code);
                            throw newError;
                        } else {
                            const code = ExceptionCodes.ANVIL_UNKNOWN_HTTP_ERROR;
                            const name = mapErrorCodeToName(error.code);
                            assign(error, {
                                code: code,
                                name: name
                            });
                            throw error;
                        }
                    }).then((_ref3)=>{
                        let data = _ref3.data;
                        if (typeof data === 'string') {
                            // axios could not decode JSON
                            if (data.length > 0) try {
                                JSON.parse(data);
                            } catch (err) {
                                err.message = LANGUAGE.UNEXPECTED_SERVER_RESPONSE(err.toString());
                                err.code = ExceptionCodes.ANVIL_XDOMAIN_OR_PARSING_ERROR;
                                err.name = mapErrorCodeToName(err.code);
                                throw err;
                            }
                            const error = new Error(data.length === 0 ? LANGUAGE.EMPTY_RESPONSE : LANGUAGE.BADLY_FORMED);
                            error.code = data.length === 0 ? ExceptionCodes.ANVIL_EMPTY_RESPONSE_BODY : ExceptionCodes.ANVIL_BADLY_FORMED_RESPONSE;
                            error.name = mapErrorCodeToName(error.code);
                            throw error;
                        }
                        if (data === null || data.length === 0) {
                            // anvil returned empty session info
                            const error = new Error(LANGUAGE.EMPTY_RESPONSE);
                            error.code = ExceptionCodes.ANVIL_EMPTY_RESPONSE_BODY;
                            error.name = mapErrorCodeToName(error.code);
                            throw error;
                        }
                        const _data$filter = data.filter((node)=>node.error != null), errorNode = _data$filter[0];
                        if (errorNode) {
                            const code = mapStatusCodeToErrorCode(get(errorNode, 'error.code', '500'));
                            if (get(errorNode, 'error.errorMessage.message') === 'Invalid token format') errorNode.error.errorMessage.message += ` Token: ${token}`;
                            const error = new Error(get(errorNode, 'error.errorMessage.message', code === undefined ? `Unknown error: ${errorNode.error.code}` : LANGUAGE.NO_ERROR));
                            error.code = code || ExceptionCodes.ANVIL_UNEXPECTED_ERROR_CODE;
                            error.name = mapErrorCodeToName(error.code);
                            throw error;
                        }
                        return new SessionInfo(data[0]);
                    });
                }
                const getSessionInfoRetry = promiseEndeavour(getSessionInfo, (error, attempt)=>error.code && error.code >= 3000 && error.code <= 3007 && retryDelays[attempt]);
                return getSessionInfoRetry;
            }
            module1.exports = getSessionInfoFactory;
        /***/ },
        /* 739 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ExceptionCodes = __webpack_require__(10);
            const errors = __webpack_require__(6);
            const errorMap = {
                [ExceptionCodes.ANVIL_BADLY_FORMED_RESPONSE]: errors.BADLY_FORMED_RESPONSE,
                [ExceptionCodes.ANVIL_INVALID_HTTP_STATUS]: errors.INVALID_HTTP_STATUS,
                [ExceptionCodes.ANVIL_XDOMAIN_OR_PARSING_ERROR]: errors.XDOMAIN_OR_PARSING_ERROR,
                [ExceptionCodes.ANVIL_UNKNOWN_HTTP_ERROR]: errors.UNKNOWN_HTTP_ERROR,
                [ExceptionCodes.ANVIL_UNEXPECTED_ERROR_CODE]: errors.UNEXPECTED_ERROR_CODE,
                [ExceptionCodes.ANVIL_EMPTY_RESPONSE_BODY]: errors.EMPTY_RESPONSE_BODY,
                [ExceptionCodes.ANVIL_CONNECT_FAILED]: errors.CONNECT_FAILED,
                [ExceptionCodes.AUTHENTICATION_ERROR]: errors.AUTHENTICATION_ERROR,
                [ExceptionCodes.INVALID_SESSION_ID]: errors.INVALID_SESSION_ID,
                [ExceptionCodes.TERMS_OF_SERVICE_FAILURE]: errors.TERMS_OF_SERVICE_FAILURE,
                [ExceptionCodes.UNEXPECTED_SERVER_RESPONSE]: errors.UNEXPECTED_SERVER_RESPONSE
            };
            /**
 * Maps an error from SessionInfo.get to its corresponding name
 * @param {number} code - Error code
 * @return {string|undefined} Error name
 */ function mapErrorCodeToName(code) {
                return errorMap[code];
            }
            module1.exports = mapErrorCodeToName;
        /***/ },
        /* 740 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const ExceptionCodes = __webpack_require__(10);
            const statusCodeToExceptionCode = {
                400: ExceptionCodes.INVALID_SESSION_ID,
                403: ExceptionCodes.AUTHENTICATION_ERROR,
                404: ExceptionCodes.INVALID_SESSION_ID,
                409: ExceptionCodes.TERMS_OF_SERVICE_FAILURE,
                500: ExceptionCodes.UNEXPECTED_SERVER_RESPONSE
            };
            /**
 * Maps an Anvil status code error to an exception code
 * @param {number} code - Anvil status code
 * @return {string|undefined} Exception code
 */ function mapStatusCodeToErrorCode(code) {
                return statusCodeToExceptionCode[code];
            }
            module1.exports = mapStatusCodeToErrorCode;
        /***/ },
        /* 741 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(49));
            /* eslint-disable no-underscore-dangle */ const EventEmitter = __webpack_require__(31);
            const defaultGenerateKey = __webpack_require__(742);
            let KeyStore = /*#__PURE__*/ function(_EventEmitter) {
                (0, _inheritsLoose2.default)(KeyStore, _EventEmitter);
                function KeyStore(deps) {
                    var _this;
                    if (deps === void 0) deps = {};
                    _this = _EventEmitter.call(this) || this;
                    _this._generateKey = deps.generateKey || defaultGenerateKey;
                    return _this;
                }
                var _proto = KeyStore.prototype;
                _proto.set = /*#__PURE__*/ function() {
                    var _set = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(sessionId, secret) {
                        var key;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    this.keyPromise = this._generateKey(sessionId, secret);
                                    _context.next = 3;
                                    return this.keyPromise;
                                case 3:
                                    key = _context.sent;
                                    this.emit('keyChanged', key);
                                case 5:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function set(_x, _x2) {
                        return _set.apply(this, arguments);
                    }
                    return set;
                }();
                _proto.get = /*#__PURE__*/ function() {
                    var _get = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2() {
                        var key;
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    _context2.next = 2;
                                    return this.keyPromise;
                                case 2:
                                    key = _context2.sent;
                                    return _context2.abrupt("return", key);
                                case 4:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, this);
                    }));
                    function get() {
                        return _get.apply(this, arguments);
                    }
                    return get;
                }();
                _proto.clear = function clear() {
                    this.keyPromise = undefined;
                };
                return KeyStore;
            }(EventEmitter);
            module1.exports = KeyStore;
        /***/ },
        /* 742 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const generateKey = /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(sessionId, secret) {
                    var isExtractableKeyMaterial, isExtractableDerivedKey, enc, keyMaterial;
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                // isExtractableKeyMaterial and isExtractableDerivedKey indicates whether it will be possible
                                // to export the key using SubtleCrypto.exportKey() or SubtleCrypto.wrapKey().
                                isExtractableKeyMaterial = false;
                                isExtractableDerivedKey = true;
                                enc = new TextEncoder();
                                _context.next = 5;
                                return window.crypto.subtle.importKey('raw', enc.encode(secret), {
                                    name: 'PBKDF2'
                                }, isExtractableKeyMaterial, [
                                    'deriveBits',
                                    'deriveKey'
                                ]);
                            case 5:
                                keyMaterial = _context.sent;
                                return _context.abrupt("return", window.crypto.subtle.deriveKey({
                                    name: 'PBKDF2',
                                    salt: enc.encode(sessionId),
                                    iterations: 100000,
                                    hash: 'SHA-256'
                                }, keyMaterial, {
                                    name: 'AES-CTR',
                                    length: 256
                                }, isExtractableDerivedKey, [
                                    'encrypt',
                                    'decrypt'
                                ]));
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function generateKey(_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }();
            module1.exports = generateKey;
        /***/ },
        /* 743 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            /* eslint-disable no-underscore-dangle */ const env = __webpack_require__(3);
            let sframe = {
                SFrame: {}
            }; // SFrame lib uses EventTarget that is not available in Node.js, which makes travis to fail.
            // As a workaround, we only require the sframe lib if the environment is not Node.
            if (!env.isNode) // eslint-disable-next-line global-require
            sframe = __webpack_require__(744);
            const _sframe = sframe, SFrame = _sframe.SFrame;
            const createClient = (senderId)=>SFrame.createClient(senderId, {
                    skipVp8PayloadHeader: true
                });
            let SFrameClientStore = /*#__PURE__*/ function() {
                function SFrameClientStore() {
                    this._clientStore = {};
                }
                var _proto = SFrameClientStore.prototype;
                _proto.createSender = /*#__PURE__*/ function() {
                    var _createSender = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(senderId) {
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (senderId === void 0) senderId = 0;
                                    if (!this.getSender(senderId)) {
                                        _context.next = 3;
                                        break;
                                    }
                                    return _context.abrupt("return", this.getSender(senderId));
                                case 3:
                                    if (!this._clientStore[senderId]) this._clientStore[senderId] = {};
                                    _context.next = 6;
                                    return createClient(senderId);
                                case 6:
                                    this._clientStore[senderId].sender = _context.sent;
                                    return _context.abrupt("return", this.getSender(senderId));
                                case 8:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this);
                    }));
                    function createSender(_x) {
                        return _createSender.apply(this, arguments);
                    }
                    return createSender;
                }();
                _proto.createReceiver = /*#__PURE__*/ function() {
                    var _createReceiver = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(senderId) {
                        return _regenerator.default.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    if (!this.getReceiver(senderId)) {
                                        _context2.next = 2;
                                        break;
                                    }
                                    return _context2.abrupt("return", this.getReceiver(senderId));
                                case 2:
                                    if (!this._clientStore[senderId]) this._clientStore[senderId] = {};
                                    _context2.next = 5;
                                    return createClient(senderId);
                                case 5:
                                    this._clientStore[senderId].receiver = _context2.sent;
                                    return _context2.abrupt("return", this.getReceiver(senderId));
                                case 7:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, this);
                    }));
                    function createReceiver(_x2) {
                        return _createReceiver.apply(this, arguments);
                    }
                    return createReceiver;
                }();
                _proto.getSender = function getSender(senderId) {
                    var _this$_clientStore$se;
                    return (_this$_clientStore$se = this._clientStore[senderId]) == null ? void 0 : _this$_clientStore$se.sender;
                };
                _proto.getReceiver = function getReceiver(senderId) {
                    var _this$_clientStore$se2;
                    return (_this$_clientStore$se2 = this._clientStore[senderId]) == null ? void 0 : _this$_clientStore$se2.receiver;
                };
                _proto.deleteReceiver = function deleteReceiver(senderId) {
                    if (this.getReceiver(senderId)) {
                        this._clientStore[senderId].receiver.deleteReceiver(senderId);
                        delete this._clientStore[senderId].receiver;
                    }
                };
                _proto.deleteSender = function deleteSender(senderId) {
                    var _this$_clientStore$se3;
                    (_this$_clientStore$se3 = this._clientStore[senderId]) == null || delete _this$_clientStore$se3.sender;
                };
                return SFrameClientStore;
            }();
            module1.exports = SFrameClientStore;
        /***/ },
        /* 744 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(Promise) {
                (function webpackUniversalModuleDefinition(root, factory) {
                    module1.exports = factory();
                })(this, function() {
                    return /******/ function(modules) {
                        /******/ // The module cache
                        /******/ var installedModules = {};
                        /******/ /******/ // The require function
                        /******/ function __webpack_require__(moduleId) {
                            /******/ /******/ // Check if module is in cache
                            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                            /******/ // Create a new module (and put it into the cache)
                            /******/ var module1 = installedModules[moduleId] = {
                                /******/ i: moduleId,
                                /******/ l: false,
                                /******/ exports: {}
                            };
                            /******/ /******/ // Execute the module function
                            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                            /******/ /******/ // Flag the module as loaded
                            /******/ module1.l = true;
                            /******/ /******/ // Return the exports of the module
                            /******/ return module1.exports;
                        /******/ }
                        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
                        /******/ __webpack_require__.m = modules;
                        /******/ /******/ // expose the module cache
                        /******/ __webpack_require__.c = installedModules;
                        /******/ /******/ // define getter function for harmony exports
                        /******/ __webpack_require__.d = function(exports, name, getter) {
                            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                                enumerable: true,
                                get: getter
                            });
                        /******/ };
                        /******/ /******/ // define __esModule on exports
                        /******/ __webpack_require__.r = function(exports) {
                            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                                value: 'Module'
                            });
                            /******/ Object.defineProperty(exports, '__esModule', {
                                value: true
                            });
                        /******/ };
                        /******/ /******/ // create a fake namespace object
                        /******/ // mode & 1: value is a module id, require it
                        /******/ // mode & 2: merge all properties of value into the ns
                        /******/ // mode & 4: return value when already ns object
                        /******/ // mode & 8|1: behave like require
                        /******/ __webpack_require__.t = function(value, mode) {
                            /******/ if (mode & 1) value = __webpack_require__(value);
                            /******/ if (mode & 8) return value;
                            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
                            /******/ var ns = Object.create(null);
                            /******/ __webpack_require__.r(ns);
                            /******/ Object.defineProperty(ns, 'default', {
                                enumerable: true,
                                value: value
                            });
                            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                                return value[key];
                            }).bind(null, key));
                            /******/ return ns;
                        /******/ };
                        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
                        /******/ __webpack_require__.n = function(module1) {
                            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                                return module1['default'];
                            } : /******/ function getModuleExports() {
                                return module1;
                            };
                            /******/ __webpack_require__.d(getter, 'a', getter);
                            /******/ return getter;
                        /******/ };
                        /******/ /******/ // Object.prototype.hasOwnProperty.call
                        /******/ __webpack_require__.o = function(object, property) {
                            return Object.prototype.hasOwnProperty.call(object, property);
                        };
                        /******/ /******/ // __webpack_public_path__
                        /******/ __webpack_require__.p = "";
                        /******/ /******/ /******/ // Load entry module and return exports
                        /******/ return __webpack_require__(__webpack_require__.s = "./index.js");
                    /******/ }({
                        /***/ "./Client.js": /*!*******************!*\
  !*** ./Client.js ***!
  \*******************/ /*! exports provided: SFrame */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            __webpack_require__.r(__webpack_exports__);
                            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SFrame", function() {
                                return SFrame;
                            });
                            /* harmony import */ var _Worker_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Worker.js */ "./Worker.js");
                            /**
 * SFrame library
 *  @namespace Sframe
 */ const SFrame = {
                                /**
	 * Create a new SFrame client context.
	 *
	 * This method will create client which communicates with web worker in which the SFrame context will be executed.
	 * @memberof SFrame
	 * @param {Number} senderId - Numeric id for this sender.
	 * @param {Object} config - Congiguration parameters [Optional].
	 * @param {Boolean} config.skipVp8PayloadHeader - Sends the vp8 payload header in clear (Note: it will be applied to all video frames as encoded chunks does not contain codec info yet).
	 * @returns {Promise<Client>} Promise that resolves to the client object when the web worker is initialized.
	 */ createClient: async function(senderId, config) {
                                    //Create client
                                    const client = new Client();
                                    //Init worker async
                                    await client.init(senderId, config);
                                    //Return client
                                    return client;
                                }
                            };
                            async function transferKey(key) {
                                if (key instanceof CryptoKey && key.type == "private") return await crypto.subtle.exportKey("pkcs8", key);
                                if (key instanceof CryptoKey) return await crypto.subtle.exportKey("raw", key);
                                if (key instanceof Uint8Array) return key.buffer.slice(0);
                                return key.slice(0);
                            }
                            /**
 * The SFrame client object which acts as a proxy for web worker context.
 */ class Client extends EventTarget {
                                /**
	 * @ignore
	 * @hideconstructor
	 * private constructor
	 */ constructor(){
                                    super();
                                    //Create new worker
                                    this.worker = new _Worker_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
                                    //Cutrent transactions
                                    this.transId = 1;
                                    this.transactions = new Map();
                                    //Listen for worker messages
                                    this.worker.addEventListener("message", async (event)=>{
                                        //Get data
                                        const data = event.data;
                                        //If it is a transaction response
                                        if (data.transId) {
                                            //Get transaction
                                            const transaction = this.transactions.get(data.transId);
                                            //Delete transaction
                                            this.transactions.delete(data.transId);
                                            //Check result
                                            if (data.error) //Reject with error
                                            transaction.reject(new Error(data.error));
                                            else //Resolve promise
                                            transaction.resolve(data.result);
                                        } else if (data.event) {
                                            /**
				* The authenticated event will be fired when a new sender is received on the receiver.
				*
				* @name "authenticated"
				* @memberof Client
				* @kind event
				* @argument {String} id - The id for the associated RTCRtpReceiver
				* @argument {Number} senderId - The senderId of the authenticated sender received.
				*/ //Create event
                                            const event = new Event(data.event.name);
                                            //Set id and senderId
                                            event.id = data.event.data.id;
                                            event.senderId = data.event.data.senderId;
                                            //Disptach event
                                            this.dispatchEvent(event);
                                        }
                                    });
                                    //Private method
                                    this.postMessage = (cmd, args, transferList)=>{
                                        //Create new promise
                                        return new Promise((resolve, reject)=>{
                                            //Get new transaction
                                            const transId = this.transId++;
                                            //Sent to worker
                                            this.worker.postMessage({
                                                transId: transId,
                                                cmd: cmd,
                                                args: args
                                            }, transferList);
                                            //Add it to pending transactions
                                            this.transactions.set(transId, {
                                                resolve: resolve,
                                                reject: reject
                                            });
                                        });
                                    };
                                }
                                async init(senderId, config) {
                                    return this.postMessage("init", {
                                        senderId: senderId,
                                        config: config
                                    });
                                }
                                /**
	 * Set the sender encryption key.
	 *
	 * @param {ArrayBuffer|Uint8Array|CryptoKey} key - 32 bytes encryption key. If the value is a CryptoKey the algorithm must be "HKDF".
	 * @returns {Promise<void>} Promise which will be resolved when the key is set on the web worker.
	 */ async setSenderEncryptionKey(key) {
                                    const transfered = await transferKey(key);
                                    return this.postMessage("setSenderEncryptionKey", [
                                        transfered
                                    ], [
                                        transfered
                                    ]);
                                }
                                /**
	 * Ratchert the sender encryption key.
	 *
	 * @returns {Promise<void>} Promise which will be resolved when the key is ratcheted on the web worker.
	 */ async ratchetSenderEncryptionKey() {
                                    return this.postMessage("ratchetSenderEncryptionKey");
                                }
                                /**
	 * Set the sender signing key.
	 *
	 * @param {ArrayBuffer|Uint8Array|CryptoKey} key - Private key used for singing. If the value is a CryptoKey the algorithm must be "ECDSA".
	 * @returns {Promise<void>} Promise which will be resolved when the signing key is set on the web worker.
	 */ async setSenderSigningKey(key) {
                                    const transfered = await transferKey(key);
                                    return this.postMessage("setSenderSigningKey", [
                                        transfered
                                    ]);
                                }
                                /**
	 * Add receiver for a remote sender.
	 *
	 * @param {Number} receiverkKeyId - The remote senderId.
	 * @returns {Promise<void>} Promise which will be resolved when the receiver is added on the web worker.
	 */ async addReceiver(receiverkKeyId) {
                                    return this.postMessage("addReceiver", [
                                        receiverkKeyId
                                    ]);
                                }
                                /**
	 * Set the receiver encryption key associated to a remote sender.
	 *
	 * @param {Number} receiverkKeyId - The remote senderId.
	 * @param {ArrayBuffer|Uint8Array|CryptoKey} key - 32 bytes encryption key. If the value is a CryptoKey the algorithm must be "HKDF".
	 * @returns {Promise<void>} Promise which will be resolved when the key is set on the web worker.
	 */ async setReceiverEncryptionKey(receiverkKeyId, key) {
                                    const transfered = await transferKey(key);
                                    return this.postMessage("setReceiverEncryptionKey", [
                                        receiverkKeyId,
                                        transfered
                                    ], [
                                        transfered
                                    ]);
                                }
                                /**
	 * Set the receiver signing key associated to a remote sender.
	 *
	 * @param {Number} receiverkKeyId - The remote senderId.
	 * @param {ArrayBuffer|Uint8Array|CryptoKey} key - Private key used for singing. If the value is a CryptoKey the algorithm must be "ECDSA".
	 * @returns {Promise<void>} Promise which will be resolved when the signing key is set on the web worker.
	 */ async setReceiverVerifyKey(receiverkKeyId, key) {
                                    const transfered = await transferKey(key);
                                    return this.postMessage("setReceiverVerifyKey", [
                                        receiverkKeyId,
                                        transfered
                                    ], [
                                        transfered
                                    ]);
                                }
                                /**
	 * Remove receiver for a remote sender.
	 *
	 * @param {Number} receiverkKeyId - The remote senderId.
	 * @returns {Promise<void>} Promise which will be resolved when the receiver is removed on the web worker.
	 */ deleteReceiver(receiverkKeyId) {
                                    return this.postMessage("deleteReceiver", [
                                        receiverkKeyId
                                    ]);
                                }
                                /**
	 * Encrypt frames for a RTCRtpSender.
	 *
	 * @param {String} id - An unique identifier associated to this sender (for example transceiver.mid).
	 * @param {RTCRtpSender} sender - The sender object, associated track must be not null.
	 */ async encrypt(id, sender) {
                                    //We need the media kind until it is set as metadata on the chunk frame
                                    const kind = sender.track.kind;
                                    //Get the sender insertable streams
                                    const { readable: readableStream, writable: writableStream } = sender.createEncodedStreams ? sender.createEncodedStreams() : sender.createEncodedVideoStreams ? sender.createEncodedVideoStreams() : sender.createEncodedAudioStreams();
                                    //Pass to worker
                                    return this.postMessage("encrypt", {
                                        id: id,
                                        kind: kind,
                                        readableStream: readableStream,
                                        writableStream: writableStream
                                    }, [
                                        readableStream,
                                        writableStream
                                    ]);
                                }
                                /**
	 * Decrypt frames fpr a RTCPRtpReceiver.
	 *
	 * @param {String} id - An unique identifier associated to this sender (for example transceiver.mid), it will be used for the authentication and signing events.
	 * @param {RTCRtpReceiver} receiver - The receiver object.
	 */ async decrypt(id, receiver) {
                                    //We need the media kind until it is set as metadata on the chunk frame
                                    const kind = receiver.track.kind;
                                    //Get the receiver insertable streams
                                    const { readable: readableStream, writable: writableStream } = receiver.createEncodedStreams ? receiver.createEncodedStreams() : receiver.createEncodedVideoStreams ? receiver.createEncodedVideoStreams() : receiver.createEncodedAudioStreams();
                                    //Pass to worker
                                    return this.postMessage("decrypt", {
                                        id: id,
                                        kind: kind,
                                        readableStream: readableStream,
                                        writableStream: writableStream
                                    }, [
                                        readableStream,
                                        writableStream
                                    ]);
                                }
                                /**
	 * Close client and terminate web worker.
	 */ close() {
                                    //Terminate worker
                                    this.worker.terminate();
                                    //End all pending transactions
                                    for (let transaction of this.transactions.values())//Reject with terminated error
                                    transaction.reject(new Error("Client closed"));
                                    //Clear transactions
                                    this.transactions.clear();
                                }
                            }
                        /***/ },
                        /***/ "./Worker.js": /*!*******************!*\
  !*** ./Worker.js ***!
  \*******************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            __webpack_require__.r(__webpack_exports__);
                            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() {
                                return Worker_fn;
                            });
                            /* harmony import */ var _node_modules_worker_loader_dist_runtime_inline_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! !./node_modules/worker-loader/dist/runtime/inline.js */ "./node_modules/worker-loader/dist/runtime/inline.js");
                            /* harmony import */ var _node_modules_worker_loader_dist_runtime_inline_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_worker_loader_dist_runtime_inline_js__WEBPACK_IMPORTED_MODULE_0__);
                            function Worker_fn() {
                                return _node_modules_worker_loader_dist_runtime_inline_js__WEBPACK_IMPORTED_MODULE_0___default()("/******/ (function(modules) { // webpackBootstrap\n/******/ \t// The module cache\n/******/ \tvar installedModules = {};\n/******/\n/******/ \t// The require function\n/******/ \tfunction __webpack_require__(moduleId) {\n/******/\n/******/ \t\t// Check if module is in cache\n/******/ \t\tif(installedModules[moduleId]) {\n/******/ \t\t\treturn installedModules[moduleId].exports;\n/******/ \t\t}\n/******/ \t\t// Create a new module (and put it into the cache)\n/******/ \t\tvar module = installedModules[moduleId] = {\n/******/ \t\t\ti: moduleId,\n/******/ \t\t\tl: false,\n/******/ \t\t\texports: {}\n/******/ \t\t};\n/******/\n/******/ \t\t// Execute the module function\n/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n/******/\n/******/ \t\t// Flag the module as loaded\n/******/ \t\tmodule.l = true;\n/******/\n/******/ \t\t// Return the exports of the module\n/******/ \t\treturn module.exports;\n/******/ \t}\n/******/\n/******/\n/******/ \t// expose the modules object (__webpack_modules__)\n/******/ \t__webpack_require__.m = modules;\n/******/\n/******/ \t// expose the module cache\n/******/ \t__webpack_require__.c = installedModules;\n/******/\n/******/ \t// define getter function for harmony exports\n/******/ \t__webpack_require__.d = function(exports, name, getter) {\n/******/ \t\tif(!__webpack_require__.o(exports, name)) {\n/******/ \t\t\tObject.defineProperty(exports, name, { enumerable: true, get: getter });\n/******/ \t\t}\n/******/ \t};\n/******/\n/******/ \t// define __esModule on exports\n/******/ \t__webpack_require__.r = function(exports) {\n/******/ \t\tif(typeof Symbol !== 'undefined' && Symbol.toStringTag) {\n/******/ \t\t\tObject.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });\n/******/ \t\t}\n/******/ \t\tObject.defineProperty(exports, '__esModule', { value: true });\n/******/ \t};\n/******/\n/******/ \t// create a fake namespace object\n/******/ \t// mode & 1: value is a module id, require it\n/******/ \t// mode & 2: merge all properties of value into the ns\n/******/ \t// mode & 4: return value when already ns object\n/******/ \t// mode & 8|1: behave like require\n/******/ \t__webpack_require__.t = function(value, mode) {\n/******/ \t\tif(mode & 1) value = __webpack_require__(value);\n/******/ \t\tif(mode & 8) return value;\n/******/ \t\tif((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;\n/******/ \t\tvar ns = Object.create(null);\n/******/ \t\t__webpack_require__.r(ns);\n/******/ \t\tObject.defineProperty(ns, 'default', { enumerable: true, value: value });\n/******/ \t\tif(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));\n/******/ \t\treturn ns;\n/******/ \t};\n/******/\n/******/ \t// getDefaultExport function for compatibility with non-harmony modules\n/******/ \t__webpack_require__.n = function(module) {\n/******/ \t\tvar getter = module && module.__esModule ?\n/******/ \t\t\tfunction getDefault() { return module['default']; } :\n/******/ \t\t\tfunction getModuleExports() { return module; };\n/******/ \t\t__webpack_require__.d(getter, 'a', getter);\n/******/ \t\treturn getter;\n/******/ \t};\n/******/\n/******/ \t// Object.prototype.hasOwnProperty.call\n/******/ \t__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };\n/******/\n/******/ \t// __webpack_public_path__\n/******/ \t__webpack_require__.p = \"\";\n/******/\n/******/\n/******/ \t// Load entry module and return exports\n/******/ \treturn __webpack_require__(__webpack_require__.s = \"./Worker.js\");\n/******/ })\n/************************************************************************/\n/******/ ({\n\n/***/ \"./Worker.js\":\n/*!*******************!*\\\n  !*** ./Worker.js ***!\n  \\*******************/\n/*! no exports provided */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/debounce */ \"./node_modules/lodash/debounce.js\");\n/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _lib_Context_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/Context.js */ \"./lib/Context.js\");\n/* harmony import */ var _lib_VP8PayloadHeader_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lib/VP8PayloadHeader.js */ \"./lib/VP8PayloadHeader.js\");\n/* harmony import */ var _lib_Utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./lib/Utils.js */ \"./lib/Utils.js\");\n/* harmony import */ var _lib_TaskQueue_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/TaskQueue.js */ \"./lib/TaskQueue.js\");\n\n\n\n\n\n\nconst postDecryptStatusMessage = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()((message) => {\n\tpostMessage(message)\n},  1000, { leading: false, trailing: true });\n\nlet context; \n\nonmessage = async (event) => {\n\t//Get data\n\tconst {transId,cmd,args} = event.data;\n\t\n\ttry {\n\t\tlet result = true;\n\t\t\n\t\t//Depending on the cmd\n\t\tswitch(event.data.cmd)\n\t\t{\n\t\t\tcase \"init\":\n\t\t\t{\n\t\t\t\t//Get info\n\t\t\t\tconst {senderId, config} = args;\n\t\t\t\t//Crate context\n\t\t\t\tcontext = new _lib_Context_js__WEBPACK_IMPORTED_MODULE_1__[\"Context\"](senderId, config);\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tcase \"encrypt\":\n\t\t\t{\n\t\t\t\t//The recrypt queue\n\t\t\t\tconst tasks = new _lib_TaskQueue_js__WEBPACK_IMPORTED_MODULE_4__[\"TaskQueue\"]();\n\t\t\t\t//Get event data\n\t\t\t\tconst{id, kind, readableStream, writableStream} = args;\n\t\t\t\t//Create transform stream foo encrypting\n\t\t\t\tconst transformStream = new TransformStream({\n\t\t\t\t\ttransform: async (chunk, controller)=>{\n\t\t\t\t\t\t//Nothing in clear\n\t\t\t\t\t\tlet skip = 0;\n\t\t\t\t\t\t//Check if it is video and we are skipping vp8 payload header\n\t\t\t\t\t\tif (kind==\"video\" && context.isSkippingVp8PayloadHeader())\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\t//Get VP8 header\n\t\t\t\t\t\t\tconst vp8 = _lib_VP8PayloadHeader_js__WEBPACK_IMPORTED_MODULE_2__[\"VP8PayloadHeader\"].parse(chunk.data);\n\t\t\t\t\t\t\t//Skip it\n\t\t\t\t\t\t\tskip = vp8.byteLength;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t//Enqueue task\n\t\t\t\t\t\ttasks.enqueue (\n\t\t\t\t\t\t\tcontext.encrypt(kind, id, chunk.data, skip),\n\t\t\t\t\t\t\t(encrypted) => {\n\t\t\t\t\t\t\t\t//Set back encrypted payload\n\t\t\t\t\t\t\t\tchunk.data = encrypted.buffer;\n\t\t\t\t\t\t\t\t//write back\n\t\t\t\t\t\t\t\tcontroller.enqueue(chunk);\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t(error)=>{\n\t\t\t\t\t\t\t\t//TODO: handle errors\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t);\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t\t//Encrypt\n\t\t\t\treadableStream\n\t\t\t\t\t.pipeThrough(transformStream)\n\t\t\t\t\t.pipeTo(writableStream);\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tcase \"decrypt\":\n\t\t\t{\n\t\t\t\t//The recrypt queue\n\t\t\t\tconst tasks = new _lib_TaskQueue_js__WEBPACK_IMPORTED_MODULE_4__[\"TaskQueue\"]();\n\t\t\t\t//Last reveiced senderId\n\t\t\t\tlet senderId = -1;\n\t\t\t\t//Get event data\n\t\t\t\tconst{id, kind, readableStream, writableStream} = args;\n\t\t\t\t//Create transform stream for encrypting\n\t\t\t\tconst transformStream = new TransformStream({\n\t\t\t\t\ttransform: async (chunk, controller)=>{\n\t\t\t\t\t\t//Nothing in clear\n\t\t\t\t\t\tlet skip = 0;\n\t\t\t\t\t\t//Check if it is video and we are skipping vp8 payload header\n\t\t\t\t\t\tif (kind==\"video\" && context.isSkippingVp8PayloadHeader())\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\t//Get VP8 header\n\t\t\t\t\t\t\tconst vp8 = _lib_VP8PayloadHeader_js__WEBPACK_IMPORTED_MODULE_2__[\"VP8PayloadHeader\"].parse(chunk.data);\n\t\t\t\t\t\t\t//Skip it\n\t\t\t\t\t\t\tskip = vp8.byteLength;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t//Enqueue task\n\t\t\t\t\t\ttasks.enqueue(\n\t\t\t\t\t\t\tcontext.decrypt(kind, id, chunk.data, skip),\n\t\t\t\t\t\t\t(decrypted) => {\n\t\t\t\t\t\t\t\t//Set back decrypted payload\n\t\t\t\t\t\t\t\tchunk.data = decrypted.buffer;\n\t\t\t\t\t\t\t\t//write back\n\t\t\t\t\t\t\t\tcontroller.enqueue(chunk);\n\t\t\t\t\t\t\t\t//If it is a sender\n\t\t\t\t\t\t\t\tif (decrypted.senderId!=senderId)\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t//Store it\n\t\t\t\t\t\t\t\t\tsenderId = decrypted.senderId;\n\t\t\t\t\t\t\t\t\t//Launch event\n\t\t\t\t\t\t\t\t\tpostMessage ({event: {\n\t\t\t\t\t\t\t\t\t\tname\t: \"authenticated\",\n\t\t\t\t\t\t\t\t\t\tdata\t: {\n\t\t\t\t\t\t\t\t\t\t\tid\t : id,\n\t\t\t\t\t\t\t\t\t\t\tsenderId : senderId\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}});\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\tif (decrypted.decryptionRestored) {\n\t\t\t\t\t\t\t\t\tpostDecryptStatusMessage({\n\t\t\t\t\t\t\t\t\t\tevent: {\n\t\t\t\t\t\t\t\t\t\t\tname: \"decryptionRestored\",\n\t\t\t\t\t\t\t\t\t\t\tdata: {\n\t\t\t\t\t\t\t\t\t\t\t\tid,\n\t\t\t\t\t\t\t\t\t\t\t\tsenderId,\n\t\t\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t(error) => {\n\t\t\t\t\t\t\t\tif (error.message === 'decryptFailed') {\n\t\t\t\t\t\t\t\t\tpostDecryptStatusMessage({\n\t\t\t\t\t\t\t\t\t\tevent: {\n\t\t\t\t\t\t\t\t\t\t\tname: \"decryptFailed\",\n\t\t\t\t\t\t\t\t\t\t\tdata: {\n\t\t\t\t\t\t\t\t\t\t\t\tid,\n\t\t\t\t\t\t\t\t\t\t\t\tsenderId,\n\t\t\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t\t\t},\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t);\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t\t//Decrypt\n\t\t\t\treadableStream\n\t\t\t\t\t.pipeThrough(transformStream)\n\t\t\t\t\t.pipeTo(writableStream);\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tdefault:\n\t\t\t\t//Excute \"cmd\" method on context\n\t\t\t\tresult = await context[cmd](...args || []);\n\t\t}\n\t\t//Send result back\n\t\tpostMessage ({transId,result});\n\t} catch (error) {\n\t\tconsole.error(error);\n\t\t//Send error back\n\t\tpostMessage({transId,error});\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/AesCm128HmacSha256EncryptionKey.js\":\n/*!************************************************!*\\\n  !*** ./lib/AesCm128HmacSha256EncryptionKey.js ***!\n  \\************************************************/\n/*! exports provided: AesCm128HmacSha256EncryptionKey */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"AesCm128HmacSha256EncryptionKey\", function() { return AesCm128HmacSha256EncryptionKey; });\n/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Utils.js */ \"./lib/Utils.js\");\n/* harmony import */ var _Salts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Salts.js */ \"./lib/Salts.js\");\n/* harmony import */ var _IV_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./IV.js */ \"./lib/IV.js\");\n\n\n\n\nconst ratchetKey = (key) => \n\tcrypto.subtle.deriveBits(\n\t\t{\n\t\t\tname : \"HKDF\",\n\t\t\thash : \"SHA-256\",\n\t\t\tsalt : _Salts_js__WEBPACK_IMPORTED_MODULE_1__[\"Salts\"].RatchetKey,\n\t\t\tinfo : new ArrayBuffer()\n\t\t},\n\t\tkey,\n\t\t256\n\t);\n\nclass AesCm128HmacSha256EncryptionKey \n{\n\tconstructor(){\n\t\tthis.ratchets = [];\n\t}\n\n\tasync setKey(key)\n\t{\n\t\tif (key instanceof CryptoKey)\n\t\t{\n\t\t\t//Check private key algorithm\n\t\t\tif (key.algorithm.name!=\"HKDF\")\n\t\t\t\t//Error\n\t\t\t\tthrow new Error(\"Invalid key\");\n\t\t} else {\n\t\t\t//Import key\n\t\t\tkey = await crypto.subtle.importKey(\n\t\t\t\t\"raw\",\n\t\t\t\tkey,\n\t\t\t\t\"HKDF\",\n\t\t\t\tfalse,\n\t\t\t\t[\"deriveBits\", \"deriveKey\"]\n\t\t\t);\n\t\t}\n\t\tthis.key = key;\n\t\t\n\t\t//Get salt key\n\t\tthis.saltKey = new Uint8Array(await crypto.subtle.deriveBits(\n\t\t\t{\n\t\t\t\tname : \"HKDF\",\n\t\t\t\thash : \"SHA-256\",\n\t\t\t\tsalt : _Salts_js__WEBPACK_IMPORTED_MODULE_1__[\"Salts\"].SaltKey,\n\t\t\t\tinfo : new ArrayBuffer()\n\t\t\t},\n\t\t\tkey,\n\t\t\t128\n\t\t));\n\t\n\t\t//Get encryption key\n\t\tthis.encryptionKey = await crypto.subtle.deriveKey(\n\t\t\t{\n\t\t\t\tname : \"HKDF\",\n\t\t\t\thash : \"SHA-256\",\n\t\t\t\tsalt : _Salts_js__WEBPACK_IMPORTED_MODULE_1__[\"Salts\"].EncryptionKey,\n\t\t\t\tinfo : new ArrayBuffer()\n\t\t\t},\n\t\t\tkey,\n\t\t\t{\n\t\t\t\tname : \"AES-CTR\",\n\t\t\t\tlength : 128\n\t\t\t},\n\t\t\tfalse,\n\t\t\t[\"encrypt\",\"decrypt\"]\n\t\t);\n\t\n\t\t//Get authentication key\n\t\tthis.authKey = await crypto.subtle.deriveKey(\n\t\t\t{\n\t\t\t\tname : \"HKDF\",\n\t\t\t\thash : \"SHA-256\",\n\t\t\t\tsalt : _Salts_js__WEBPACK_IMPORTED_MODULE_1__[\"Salts\"].AuthenticationKey,\n\t\t\t\tinfo : new ArrayBuffer()\n\t\t\t},\n\t\t\tkey,\n\t\t\t{\n\t\t\t\tname : \"HMAC\",\n\t\t\t\thash : \"SHA-256\",\n\t\t\t\tlength : 256\n\t\t\t},\n\t\t\tfalse,\n\t\t\t[\"sign\",\"verify\"]\n\t\t);\n\t}\n\n\t\n\tasync encrypt(type,header,payload,extraBytes,skip)\n\t{\n\t\t//Encure int\n\t\tskip = skip ? skip : 0;\n\t\t\n\t\t//Create IV\n\t\tconst iv = _IV_js__WEBPACK_IMPORTED_MODULE_2__[\"IV\"].generate(header.keyId, header.counter, this.saltKey);\n\t\t\n\t\t//Encrypt\n\t\tconst encrypted = await crypto.subtle.encrypt(\n\t\t\t{\n\t\t\t\tname\t: \"AES-CTR\",\n\t\t\t\tcounter : iv,\n\t\t\t\tlength  : 128\n\t\t\t},\n\t\t\tthis.encryptionKey,\n\t\t\tpayload\n\t\t);\n\t\n\t\t//Get auth tag length from media type\n\t\tconst authTagLength = AesCm128HmacSha256EncryptionKey.getAuthTagLen(type);\n\t\t\n\t\t//Create encrypted frame\n\t\tconst encryptedFrame = new Uint8Array(header.byteLength + payload.byteLength + authTagLength + extraBytes + skip);\n\t\t\n\t\t//Set header and encrypted payolad\n\t\tencryptedFrame.set(header, skip);\n\t\tencryptedFrame.set(new Uint8Array(encrypted), skip + header.length);\n\t\t\n\t\t//Authenticate\n\t\tconst signature = new Uint8Array(await crypto.subtle.sign(\n\t\t\t\"HMAC\",\n\t\t\tthis.authKey, \n\t\t\tencryptedFrame.subarray(skip, skip + header.byteLength + encrypted.byteLength)\n\t\t));\n\t\n\t\t//Truncate\n\t\tconst authTag = signature.subarray(0, authTagLength);\n\t\n\t\t//Append authentication tag\n\t\tencryptedFrame.set(authTag, skip + encrypted.byteLength + header.byteLength );\n\t\t\n\t\t//Done\n\t\treturn [encryptedFrame,authTag];\n\t\t\n\t}\n\t\n\tasync decrypt(type, header, encryptedFrame, extrabytes, skip)\n\t{\n\t\t//Encure int\n\t\tskip = skip ? skip : 0;\n\t\t\n\t\t//Create IV\n\t\tconst iv = _IV_js__WEBPACK_IMPORTED_MODULE_2__[\"IV\"].generate(header.keyId, header.counter, this.saltKey);\n\t\t\n\t\t//Get auth tag length from media type\n\t\tconst authTagLength = AesCm128HmacSha256EncryptionKey.getAuthTagLen(type);\n\t\t\n\t\t//Get encrypted frame length (without extra bytes from signature)\n\t\tconst frameLength = encryptedFrame.byteLength - extrabytes - skip;\n\t\t\n\t\t//Get authentication tag\n\t\tconst authTag = encryptedFrame.subarray(skip + frameLength - authTagLength, skip + frameLength);\n\t\t\n\t\t//Get encrypted payload\n\t\tconst encrypted = encryptedFrame.subarray(skip + header.byteLength, skip + frameLength - authTagLength);\n\t\t\n\t\t//Calculate signature\n\t\tconst signature = new Uint8Array(await crypto.subtle.sign(\n\t\t\t\"HMAC\",\n\t\t\tthis.authKey, \n\t\t\tencryptedFrame.subarray(skip, skip + header.byteLength + encrypted.byteLength)\n\t\t));\n\t\n\t\t//Authenticate authTag\n\t\tlet authenticated = true;\n\t\t//Avoid timimg attacks by iterating over all bytes\n\t\tfor (let i=0;i<authTagLength;++i)\n\t\t\t//check signature\n\t\t\tauthenticated &= authTag[i]===signature[i];\n\t\t\n\t\t//If not all where equal\n\t\tif (!authenticated)\n\t\t\t//Authentication error\n\t\t\tthrow new Error(\"Authentication error\");\n\t\t\n\t\t//Decrypt\n\t\tconst payload = new Uint8Array (await crypto.subtle.decrypt(\n\t\t\t{\n\t\t\t\tname\t: \"AES-CTR\",\n\t\t\t\tcounter : iv,\n\t\t\t\tlength  : 128\n\t\t\t},\n\t\t\tthis.encryptionKey,\n\t\t\tencrypted\n\t\t));\n\t\t\n\t\t//Done\n\t\treturn [payload, authTag];\n\t}\n\t\n\tasync ratchet(index)\n\t{\n\t\t// return stored key if exists\n\t\tif (this.ratchets[index]) {\n\t\t\treturn this.ratchets[index];\n\t\t}\n\t\t\n\t\t//Create new key\n\t\tconst key = new AesCm128HmacSha256EncryptionKey();\n\n\t\t// Get previous ratchet\n\t\tconst previousRatchetKey = index === 0 ? this.key : this.ratchets[index - 1].key;\n\t\t\n\t\t//Set ratchet key\n\t\tawait key.setKey(await ratchetKey(previousRatchetKey));\n\t\t\n\t\tthis.ratchets[index] = key;\n\t\t//Done\n\t\treturn key;\n\t}\n\t\n\tstatic getAuthTagLen(type)\n\t{\n\t\treturn type.toLowerCase()===\"video\" ? 10 : 4;\n\t};\n\t\n\tstatic async create(raw) \n\t{\n\t\t//Create new key\n\t\tconst key = new AesCm128HmacSha256EncryptionKey();\n\t\t//Set raw key\n\t\tawait key.setKey(raw);\n\t\t//Done\n\t\treturn key;\n\t}\n};\n\n\n\n/***/ }),\n\n/***/ \"./lib/Context.js\":\n/*!************************!*\\\n  !*** ./lib/Context.js ***!\n  \\************************/\n/*! exports provided: Context */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Context\", function() { return Context; });\n/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Header.js */ \"./lib/Header.js\");\n/* harmony import */ var _Sender_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Sender.js */ \"./lib/Sender.js\");\n/* harmony import */ var _Receiver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Receiver.js */ \"./lib/Receiver.js\");\n\n\n\n\nclass Context\n{\n\t\n\tconstructor(senderId, config)\n\t{\n\t\t//Store config\n\t\tthis.config = Object.assign({}, config);\n\t\t//Only one sender per context\n\t\tthis.sender = new _Sender_js__WEBPACK_IMPORTED_MODULE_1__[\"Sender\"](senderId);\n\t\t\n\t\t//The map of known remote senders\n\t\tthis.receivers = new Map();\n\t}\n\t\n\tisSkippingVp8PayloadHeader()\n\t{\n\t\treturn !!this.config.skipVp8PayloadHeader;\n\t}\n\t\t\n\tasync setSenderEncryptionKey(key)\n\t{\n\t\t//Set it\n\t\treturn this.sender.setEncryptionKey(key);\n\t}\n\t\n\tasync ratchetSenderEncryptionKey()\n\t{\n\t\t//Set it\n\t\treturn this.sender.ratchetEncryptionKey();\n\t}\n\t\n\tasync setSenderSigningKey(key)\n\t{\n\t\t//Set it\n\t\treturn this.sender.setSigningKey(key);\n\t}\n\t\n\taddReceiver(receiverkKeyId)\n\t{\n\t\t//Check we don't have a receiver already for that id\n\t\tif(this.receivers.has(receiverkKeyId))\n\t\t\t//Error\n\t\t\tthrow new Error(\"There was already a receiver for keyId \"+receiverkKeyId);\n\t\t//Add new\n\t\tthis.receivers.set(receiverkKeyId, new _Receiver_js__WEBPACK_IMPORTED_MODULE_2__[\"Receiver\"](receiverkKeyId));\n\t}\n\t\n\tasync setReceiverEncryptionKey(receiverkKeyId, key)\n\t{\n\t\t//Get receiver for the sender\n\t\tconst receiver = this.receivers.get(receiverkKeyId);\n\t\t\n\t\t//IF not found\n\t\tif (!receiver)\n\t\t\t//Error\n\t\t\tthrow new Error(\"No receiver found for keyId \"+receiverkKeyId);\n\t\t\n\t\t//Rachet\n\t\treturn receiver.setEncryptionKey(key);\n\t}\n\t\n\tasync setReceiverVerifyKey(receiverkKeyId,key)\n\t{\n\t\t//Get receiver for the sender\n\t\tconst receiver = this.receivers.get(receiverkKeyId);\n\t\t\n\t\t//IF not found\n\t\tif (!receiver)\n\t\t\t//Error\n\t\t\tthrow new Error(\"No receiver found for keyId \"+receiverkKeyId);\n\t\t\n\t\t//Rachet\n\t\treturn receiver.setVerifyKey(key);\n\t}\n\t\n\tdeleteReceiver(receiverkKeyId)\n\t{\n\t\t//Delete receiver\n\t\treturn this.receivers.delete(receiverkKeyId);\n\t}\n\t\n\tasync encrypt(type, ssrcId, frame, skip)\n\t{\n\t\t//Encrypt it\n\t\treturn this.sender.encrypt(type, ssrcId, frame, skip);\n\t}\n\t\n\tasync decrypt(type, ssrcId, encryptedFrame, skip)\n\t{\n\t\t//convert if needed\n\t\tif (!(encryptedFrame instanceof Uint8Array))\n\t\t\tencryptedFrame = new Uint8Array (encryptedFrame);\n\t\t\n\t\t//Parse encrypted payload\n\t\tconst header = _Header_js__WEBPACK_IMPORTED_MODULE_0__[\"Header\"].parse(encryptedFrame.subarray(skip));\n\t\t\n\t\t//Get receiver for the sender\n\t\tconst receiver = this.receivers.get(header.keyId);\n\t\t\n\t\t//IF not found\n\t\tif (!receiver)\n\t\t\t//Error\n\t\t\tthrow new Error(\"No receiver found for keyId \" + header.keyId);\n\t\t\n\t\t//Decrypt it\n\t\treturn receiver.decrypt(type, ssrcId, header, encryptedFrame, skip);\n\t}\n\t\n};\n\n\n/***/ }),\n\n/***/ \"./lib/EcdsaSignKey.js\":\n/*!*****************************!*\\\n  !*** ./lib/EcdsaSignKey.js ***!\n  \\*****************************/\n/*! exports provided: EcdsaSignKey */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"EcdsaSignKey\", function() { return EcdsaSignKey; });\n//TODO: Update to Ed25519 when available\n// https://chromestatus.com/features/4913922408710144\n// https://chromium.googlesource.com/chromium/src/+log/master/components/webcrypto/algorithms/ed25519.cc\n\nclass EcdsaSignKey\n{\n\t\n\tasync setKey(privKey)\n\t{\n\t\t//If it is a crypto key already\n\t\tif (privKey instanceof CryptoKey)\n\t\t{\n\t\t\t//Check private key algorithm\n\t\t\tif (privKey.algorithm.name!=\"ECDSA\" || !privKey.usages.includes(\"sign\"))\n\t\t\t\t//Error\n\t\t\t\tthrow new Error(\"Invalid key\");\n\t\t\t//Set it\n\t\t\tthis.privKey = privKey;\n\t\t} else {\n\t\t\t//Import it\n\t\t\tthis.privKey = await crypto.subtle.importKey(\n\t\t\t\t\"pkcs8\",\n\t\t\t\tprivKey,\n\t\t\t\t{\n\t\t\t\t\tname\t\t: \"ECDSA\",\n\t\t\t\t\tnamedCurve\t: \"P-521\"\n\t\t\t\t},\n\t\t\t\tfalse,\n\t\t\t\t[\"sign\"]\n\t\t\t);\n\t\t}\n\t}\n\t\n\tasync sign(authTags)\n\t{\n\t\t//Verify\n\t\treturn new Uint8Array(await crypto.subtle.sign(\n\t\t\t{\n\t\t\t  name: \"ECDSA\",\n\t\t\t  hash: \"SHA-512\"\n\t\t\t},\n\t\t\tthis.privKey,\n\t\t\tauthTags\n\t\t));\n\t}\n\t\n\tstatic getSignatureLen()\n\t{\n\t\treturn 64;\n\t}\n\t\n\tstatic async create(privKey)\n\t{\n\t\t//Craete key\n\t\tconst key = new EcdsaSignKey();\n\t\t//Set key\n\t\tawait key.setKey(privKey);\n\t\t//Done\n\t\treturn key;\n\t\t\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/EcdsaVerifyKey.js\":\n/*!*******************************!*\\\n  !*** ./lib/EcdsaVerifyKey.js ***!\n  \\*******************************/\n/*! exports provided: EcdsaVerifyKey */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"EcdsaVerifyKey\", function() { return EcdsaVerifyKey; });\n\nclass EcdsaVerifyKey\n{\n\tasync setKey(pubKey)\n\t{\n\t\t//If it is a crypto key already\n\t\tif (pubKey instanceof CryptoKey)\n\t\t{\n\t\t\t//Check \n\t\t\tif (pubKey.algorithm.name!=\"ECDSA\" || !pubKey.usages.includes(\"verify\"))\n\t\t\t\t//Error\n\t\t\t\tthrow new Error(\"Invalid key\");\n\t\t\t//Set it\n\t\t\tthis.pubKey = pubKey;\n\t\t} else {\n\t\t\t//Import it\n\t\t\tthis.pubKey = await crypto.subtle.importKey(\n\t\t\t\t\"raw\",\n\t\t\t\tpubKey,\n\t\t\t\t{\n\t\t\t\t\tname\t\t: \"ECDSA\",\n\t\t\t\t\tnamedCurve\t: \"P-521\"\n\t\t\t\t},\n\t\t\t\tfalse,\n\t\t\t\t[\"verify\"]\n\t\t\t);\n\t\t}\n\t}\n\t\n\tasync verify(signed,signature)\n\t{\n\t\t//Verify\n\t\treturn await window.crypto.subtle.verify(\n\t\t\t{\n\t\t\t\tname: \"ECDSA\",\n\t\t\t\thash: \"SHA-512\"\n\t\t\t},\n\t\t\tthis.pubKey,\n\t\t\tsignature,\n\t\t\tsigned\n\t\t);\n\t}\n\t\n\tstatic getSignatureLen()\n\t{\n\t\treturn 64;\n\t}\n\t\n\tstatic async create(pubKey)\n\t{\n\t\t//Craete key\n\t\tconst key = new EcdsaVerifyKey();\n\t\t//Set key\n\t\tawait key.setKey(pubKey);\n\t\t//Done\n\t\treturn key;\n\t\t\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/Header.js\":\n/*!***********************!*\\\n  !*** ./lib/Header.js ***!\n  \\***********************/\n/*! exports provided: Header */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Header\", function() { return Header; });\n/*\n\t0 1 2 3 4 5 6 7\n\t+-+-+-+-+-+-+-+-+\n\t|S|LEN  |X|  K  |\n\t+-+-+-+-+-+-+-+-+\n\tSFrame header metadata\n\n\tSignature flag (S): 1 bit This field indicates the payload contains a signature of set. Counter Length (LEN): 3 bits This field indicates the length of the CTR fields in bytes. Extended Key Id Flag (X): 1 bit\n\tIndicates if the key field contains the key id or the key length. Key or Key Length: 3 bits This field contains the key id (KID) if the X flag is set to 0, or the key length (KLEN) if set to 1.\n\n\tIf X flag is 0 then the KID is in the range of 0-7 and the frame counter (CTR) is found in the next LEN bytes:\n\n\t 0 1 2 3 4 5 6 7\n\t+-+-+-+-+-+-+-+-+---------------------------------+\n\t|S|LEN  |0| KID |    CTR... (length=LEN)          |\n\t+-+-+-+-+-+-+-+-+---------------------------------+\n\tKey id (KID): 3 bits The key id (0-7). Frame counter (CTR): (Variable length) Frame counter value up to 8 bytes long.\n\n\tif X flag is 1 then KLEN is the length of the key (KID), that is found after the SFrame header metadata byte. After the key id (KID), the frame counter (CTR) will be found in the next LEN bytes:\n\n\t 0 1 2 3 4 5 6 7\n\t+-+-+-+-+-+-+-+-+---------------------------+---------------------------+\n\t|S|LEN  |1|KLEN |   KID... (length=KLEN)    |    CTR... (length=LEN)    |\n\t+-+-+-+-+-+-+-+-+---------------------------+---------------------------+\n*/\nconst Header = {\n\t\n\tparse : function(buffer) \n\t{\n\t\t//Create uint view\n\t\tconst view = new Uint8Array(buffer);\n\t\t\n\t\t//Get metadata\n\t\tconst metadata = view[0];\n\t\t\n\t\t//Get values\n\t\tconst s\t\t= !!(metadata & 0x80);\n\t\tconst len\t= (metadata >> 4) & 0x07;\n\t\tconst x\t\t= !!(metadata & 0x08);\n\t\tconst k\t\t= metadata & 0x07;\n\t\t\n\t\t//Get key id\n\t\tlet keyId = 0;\n\t\t//Check if it is the extented key format\n\t\tif (x)\n\t\t{\n\t\t\t//Read length\n\t\t\tfor (let i=0;i<k;i++)\n\t\t\t\tkeyId = (keyId * 256) + view[i+1];\n\t\t} else {\n\t\t\t//Short version\n\t\t\tkeyId = k;\n\t\t}\n\t\t\n\t\t//Get ctr\n\t\tconst ini = x ? k + 1 : 1;\n\t\tlet counter = 0;\n\t\t//Read length\n\t\tfor (let i=0;i<len;i++)\n\t\t\tcounter = (counter * 256) + view[ini+i];\n\t\t\n\t\t//Get header buffer view\n\t\tconst header = view.subarray(0, x ? k + len + 1 : len + 1);\n\t\t\n\t\t//Add parsed atributes\n\t\theader.signature   = s;\n\t\theader.keyId\t   = keyId;\n\t\theader.counter\t   = counter;\n\t\t\n\t\t//Done\n\t\treturn header; \n\t},\n\tgenerate: function(signature,keyId,counter)\n\t{\n\t\t//Check keyId\n\t\tHeader.checkKeyId(keyId);\n\t\t\n\t\t//Calcultate variavle length\n\t\tconst varlen = (x) => x ? parseInt(Math.log(x) / Math.log(256))+1 : 1;\n\t\t\n\t\t//Get key extension and length\n\t\tconst x = keyId > 7;\n\t\tconst k = x ? varlen(keyId) : keyId;\n\t\t\n\t\t//Get counter length\n\t\tconst len = varlen(counter);\n\t\t\n\t\t//Ensure counter is not huge\n\t\tif (len>7)\n\t\t\t//Error\n\t\t\tthrow new Error(\"Counter is too big\");\n\t\t\n\t\t//Generate header\n\t\tconst header = new Uint8Array( x ? 1 + k + len : 1 + len);\n\t\t\n\t\t//Set metadata header\n\t\theader[0] = !!signature;\n\t\theader[0] = header[0] << 3  | ( len & 0x07);\n\t\theader[0] = header[0] << 1  | x;\n\t\theader[0] = header[0] << 3  | ( k & 0x07);\n\t\t\n\t\t//Add parsed atributes\n\t\theader.signature   = !!signature;\n\t\theader.keyId\t   = keyId;\n\t\theader.counter\t   = counter;\n\t\t\n\t\t//If extended key\n\t\tif (x)\n\t\t\t//Add key id\n\t\t\tfor (let i=0; i<k; ++i)\n\t\t\t\theader[i+1] = (keyId >> (k-1-i)*8) & 0xff;\n\t\t//The coutner init\n\t\tconst ini = x ? k + 1 : 1;\n\t\t//Add counter\n\t\tfor (let i=0; i<len; ++i)\n\t\t\theader[ini+i] = (counter >> (len-1-i)*8) & 0xff;\n\t\t\t\n\t\t\n\t\t//Done\n\t\treturn header;\n\t}\n};\n\nHeader.MaxKeyId = 0xFFFFFFFFFF;\n\nHeader.checkKeyId = function(keyId)\n{\n\t//Check it is possitive\n\tif (keyId<0)\n\t\t//Error\n\t\tthrow new Error(\"keyId must be possitive\");\n\t//Check it is possitive\n\tif (keyId>Header.MaxKeyId)\n\t\t//Error\n\t\tthrow new Error(\"keyId must be 5 bytes long at most\");\n};\n\n\n/***/ }),\n\n/***/ \"./lib/IV.js\":\n/*!*******************!*\\\n  !*** ./lib/IV.js ***!\n  \\*******************/\n/*! exports provided: IV */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"IV\", function() { return IV; });\nconst IV = \n{\n\tgenerate : function(keyId,counter,salt)\n\t{\n\t\t//128 bits\n\t\tconst iv = new Uint8Array (16);\n\t\t//Get view\n\t\tconst view = new DataView(iv.buffer);\n\t\t//Set keyId\n\t\tview.setBigUint64(0, BigInt(counter));\n\t\t//Set coutner\n\t\tview.setBigUint64(8, BigInt(keyId));\n\t\t//Xor with salt key\n\t\tfor (let i=0; i<iv.byteLength; ++i)\n\t\t\t//xor\n\t\t\tview.setUint8(i,iv[i]^salt[i]); \n\t\t//return buffer\n\t\treturn iv;\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/Receiver.js\":\n/*!*************************!*\\\n  !*** ./lib/Receiver.js ***!\n  \\*************************/\n/*! exports provided: Receiver */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Receiver\", function() { return Receiver; });\n/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Utils.js */ \"./lib/Utils.js\");\n/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Header.js */ \"./lib/Header.js\");\n/* harmony import */ var _EcdsaVerifyKey_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EcdsaVerifyKey.js */ \"./lib/EcdsaVerifyKey.js\");\n/* harmony import */ var _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AesCm128HmacSha256EncryptionKey.js */ \"./lib/AesCm128HmacSha256EncryptionKey.js\");\n\n\n\n\n\nconst MaxRatchetAttempts = 5;\nconst ReplayWindow = 128;\nconst KeyTimeout = 1000;\n\nclass Receiver\n{\n\tconstructor(senderId)\n\t{\n\t\t//Check keyId\n\t\t_Header_js__WEBPACK_IMPORTED_MODULE_1__[\"Header\"].checkKeyId(senderId);\n\t\t\n\t\t//Store sender id\n\t\tthis.senderId = senderId;\n\t\t//Last received counter\n\t\tthis.maxReceivedCounter = -1;\n\t\t//Number or ratchets of current key\n\t\tthis.numKeyRatchets = 0;\n\t\t//Create keyring\n\t\tthis.keyring = [];\n\t\t//Pending verified tags\n\t\tthis.pending = new Map();\n\t\t// has failed decryption\n\t\tthis.keyFailing = false;\n\n\t\t//Scheduled keys\n\t\tthis.scheduledKeys = new WeakSet ();\n\n\t\t//Function to clear up keys up to given one\n\t\tthis.schedulePreviousKeysTimeout = (key) =>{\n\t\t\t//If this is the only key\n\t\t\tif (this.keyring.length==1 && this.keyring[0]===key)\n\t\t\t\t//Do nothing\n\t\t\t\treturn;\n\t\t\t//If has been already scheduled\n\t\t\tif (this.scheduledKeys.has(key))\n\t\t\t\t//Not do it twice\n\t\t\t\treturn;\n\t\t\t//Add it\n\t\t\tthis.scheduledKeys.add(key);\n\t\t\t//Schedule key timeout of previous keys\n\t\t\tsetTimeout(()=>{\n\t\t\t\t//Find key index\n\t\t\t\tconst i = this.keyring.findIndex(k=>k===key);\n\t\t\t\t//Remove previous keys\n\t\t\t\tthis.keyring = this.keyring.splice(i);\n\t\t\t}, KeyTimeout);\n\t\t};\n\t}\n\t\n\tasync decrypt(type, ssrcId, header, encryptedFrame, skip)\n\t{\n\t\tlet authTag, payload, extrabytes = 0, signature, signed;\n\t\tconst prevAuthTags = [];\n\t\t\n\t\t//convert if needed\n\t\tif (!(encryptedFrame instanceof Uint8Array))\n\t\t\tencryptedFrame = new Uint8Array (encryptedFrame);\n\n\t\t// Replay attack protection\n\t\tif (header.counter < this.maxReceivedCounter && (this.maxReceivedCounter - header.counter) > ReplayWindow) {\n\t\t\t//Error\n\t\t\tthrow new Error(\"Replay check failed, frame counter too old\");\n\t\t}\n\t\t\n\t\t//Check if frame contains signature\n\t\tif (header.signature)\n\t\t{\n\t\t\t//Start from the end\n\t\t\tlet end = encryptedFrame.byteLength;\n\t\t\t\n\t\t\t//Get lengths\n\t\t\tconst singatureLength = ECDSAVerifyKey.getSignatureLen();\n\t\t\tconst authTagLength   = _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_3__[\"AesCm128HmacSha256EncryptionKey\"].getAuthTagLen(type);\n\t\t\t\n\t\t\t//Get signature\n\t\t\tsignature = encryptedFrame.subarray(end - singatureLength, end);\n\t\t\t//Move backward\n\t\t\tend -= singatureLength;\n\t\t\t\n\t\t\t//Get number of tags\n\t\t\tconst num = encryptedFrame[end--];\n\t\t\t\n\t\t\t//Read all tags\n\t\t\tfor (let i=0; i<num; ++i)\n\t\t\t{\n\t\t\t\t//Get previous tag\n\t\t\t\tconst prevTag = encryptedFrame.subarray(end - authTagLength, end);\n\t\t\t\t//Move backward\n\t\t\t\tend -= authTagLength;\n\t\t\t\t//Add tag to previous tags in hex\n\t\t\t\tprevAuthTags.push(_Utils_js__WEBPACK_IMPORTED_MODULE_0__[\"Utils\"].toHex(prevTag))\n\t\t\t}\n\t\t\t//Get the extra bytes\n\t\t\textrabytes = encryptedFrame.byteLength - end;\n\t\t\t\n\t\t\t//Move backward to start oth current frame auth tag\n\t\t\tend -= authTagLength;\n\t\t\t\n\t\t\t//Get singed part\n\t\t\tsigned = encryptedFrame.subarray(end, encryptedFrame.byteLength - singatureLength)\n\t\t}\n\n\t\t//For each key in key ring\n\t\tfor (let i=0;i<this.keyring.length;++i)\n\t\t{\n\t\t\t//Get key from ring\n\t\t\tconst key = this.keyring[i];\n\t\t\ttry {\n\t\t\t\t//Try to decrypt payload\n\t\t\t\t[payload, authTag] = await key.decrypt(type, header, encryptedFrame, extrabytes, skip);\n\t\t\t\t//Done\n\t\t\t\tbreak;\n\t\t\t} catch(e) {\n\t\t\t\t\n\t\t\t}\n\t\t}\n\n\t\t//If not found yet\n\t\tif (!payload)\n\t\t{\n\t\t\t//Get last key\n\t\t\tconst key = this.keyring[this.keyring.length-1];\n\t\t\t//Try ratchet last key\n\t\t\tfor (let i = 0; i < MaxRatchetAttempts; ++i)\n\t\t\t{\n\t\t\t\t//Ratchet key\n\t\t\t\tconst ratchetKey = await key.ratchet(i);\n\t\t\t\ttry {\n\t\t\t\t\t//Try to decrypt payload\n\t\t\t\t\t[payload, authTag] = await ratchetKey.decrypt(type, header, encryptedFrame, extrabytes, skip);\n\t\t\t\t\t// Set working ratchet as new key\n\t\t\t\t\tthis.keyring.push(ratchetKey);\n\t\t\t\t\tthis.schedulePreviousKeysTimeout(ratchetKey);\n\t\t\t\t\t//Done\n\t\t\t\t\tbreak;\n\t\t\t\t} catch(e) {\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t//Last check\n\t\tif (!payload) {\n\t\t\t//Decryption failed\n\t\t\tif (this.keyFailing)  {\n\t\t\t\tthrow new Error('decryptStillFailing')\n\t\t\t} else {\n\t\t\t\tthis.keyFailing = true;\n\t\t\t\tthrow new Error(\"decryptFailed\");\n\t\t\t}\n\t\t}\n\n\t\t//If we are sending part of the frame in clear\n\t\tif (skip)\n\t\t\t//Copy skiped payload\n\t\t\tpayload.set(encryptedFrame.subarray(0,skip),0);\n\n\t\t//Check if have received anything from this ssrc before\n\t\tif (!this.pending.has(ssrcId))\n\t\t\t//Add it\n\t\t\tthis.pending.set(ssrcId,new Set());\n\n\t\t//Get pending list\n\t\tconst pending = this.pending.get(ssrcId);\n\n\t\t//Check if it constains signatures\n\t\tif (header.signed)\n\t\t{\n\t\t\t//try to verify list\n\t\t\tif (!await this.verifyKey.verify(signed,signature))\n\t\t\t\t//Error\n\t\t\t\tthrow new Error(\"Could not verify signature\");\n\t\t\t//For each signed tag\n\t\t\tfor (const tag in prevAuthTags)\n\t\t\t\t//Delete from pending to be verified tags\n\t\t\t\tpending.delete(tag);\n\t\t} else {\n\t\t\t//Push this tag to\n\t\t\tpending.add(_Utils_js__WEBPACK_IMPORTED_MODULE_0__[\"Utils\"].toHex(authTag));\n\t\t}\n\n\t\t//Set authenticated sender id and frame Id\n\t\tpayload.senderId = header.keyId;\n\t\tpayload.frameId  = header.counter;\n\n\t\t// inform that decryption is working after previously failing\n\t\tif (this.keyFailing) {\n\t\t\tpayload.decryptionRestored = true;\n\t\t\tthis.keyFailing = false;\n\t\t}\n\n\t\t//Store last received counter\n\t\tthis.maxReceivedCounter = Math.max(header.counter, this.maxReceivedCounter);\n\n\t\t//Return decrypted payload\n\t\treturn payload;\n\t}\n\n\tasync setVerifyKey(key)\n\t{\n\t\t//Create new singing key\n\t\tthis.verifyKey = _EcdsaVerifyKey_js__WEBPACK_IMPORTED_MODULE_2__[\"EcdsaVerifyKey\"].create(key);\n\t}\n\n\tasync setEncryptionKey(raw)\n\t{\n\t\t//Create new encryption key\n\t\tconst key = await _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_3__[\"AesCm128HmacSha256EncryptionKey\"].create(raw);\n\t\t//Append to the keyring\n\t\tthis.keyring.push(key);\n\t\t//Restart ratchet count number\n\t\tthis.numKeyRatchets = 0;\n\t\t//Activate\n\t\tthis.schedulePreviousKeysTimeout(key);\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/Salts.js\":\n/*!**********************!*\\\n  !*** ./lib/Salts.js ***!\n  \\**********************/\n/*! exports provided: Salts */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Salts\", function() { return Salts; });\nconst textEncoder = new TextEncoder()\n\nconst Salts =  {\n\t\"SaltKey\"\t\t: textEncoder.encode(\"SFrameSaltKey\"),\n\t\"EncryptionKey\"\t\t: textEncoder.encode(\"SFrameEncryptionKey\"),\n\t\"AuthenticationKey\"\t: textEncoder.encode(\"SFrameAuthenticationKey\"),\n\t\"RatchetKey\"\t\t: textEncoder.encode(\"SFrameRatchetKey\")\n};\n\n\n/***/ }),\n\n/***/ \"./lib/Sender.js\":\n/*!***********************!*\\\n  !*** ./lib/Sender.js ***!\n  \\***********************/\n/*! exports provided: Sender */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Sender\", function() { return Sender; });\n/* harmony import */ var _Header_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Header.js */ \"./lib/Header.js\");\n/* harmony import */ var _EcdsaSignKey_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EcdsaSignKey.js */ \"./lib/EcdsaSignKey.js\");\n/* harmony import */ var _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AesCm128HmacSha256EncryptionKey.js */ \"./lib/AesCm128HmacSha256EncryptionKey.js\");\n\n\n\n\n\nconst SigningFrameInterval = 10;\n\nclass Sender\n{\n\tconstructor(senderId)\n\t{\n\t\t//Check keyId\n\t\t_Header_js__WEBPACK_IMPORTED_MODULE_0__[\"Header\"].checkKeyId(senderId);\n\t\t\n\t\t//The global frame counter\n\t\tthis.counter = 0;\n\t\t\n\t\t//Store senderId/keyId\n\t\tthis.senderId = senderId;\n\t\t\n\t\t//Pending frames for signing\n\t\tthis.pending = new Map();\n\t}\n\t\n\tasync encrypt(type, ssrcId, payload, skip)\n\t{\n\t\t//Check we have a valid key\n\t\tif (!this.key)\n\t\t\tthrow Error(\"Encryption key not set\");\n\t\t\n\t\t//convert if needed\n\t\tif (!(payload instanceof Uint8Array))\n\t\t\tpayload = new Uint8Array (payload);\n\t\t\n\t\t//Encure int\n\t\tskip = skip ? skip : 0;\n\t\t\n\t\t//Get counter for frame\n\t\tconst counter = this.counter++;\n\t\t\n\t\t//If we don't have the ssrc\n\t\t// TODO FIX https://github.com/medooze/sframe/issues/15 and uncomment line below\n\t\t// if (!this.pending.has(ssrcId))\n\t\t//Create new pending frames array\n\t\t\tthis.pending.set(ssrcId,[]);\n\t\t\n\t\t//Get pending frames for signature\n\t\tconst pending = this.pending.get(ssrcId);\t\t\n\t\t\n\t\t//Do we need to sign the frames?\n\t\tconst signing = this.signingKey && pending.length > SigningFrameInterval;\n\t\t\n\t\t//Get auth tag len for type\n\t\tconst authTagLen = _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_2__[\"AesCm128HmacSha256EncryptionKey\"].getAuthTagLen(type);\n\t\t\n\t\t//Calculae extra bytes\n\t\tconst extraBytes = signing ? pending.length * _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_2__[\"AesCm128HmacSha256EncryptionKey\"].getAuthTagLen(type) + 1 + _EcdsaSignKey_js__WEBPACK_IMPORTED_MODULE_1__[\"EcdsaSignKey\"].getSignatureLen() : 0;\n\t\t\n\t\t//Generate header\n\t\tconst header = _Header_js__WEBPACK_IMPORTED_MODULE_0__[\"Header\"].generate(signing,this.senderId,counter);\n\t\t\n\t\t//Encrypt frame\n\t\tconst [encryptedFrame,authTag] = await this.key.encrypt(type, header, payload, extraBytes, skip);\n\t\t\n\t\t//If we are sending part of the frame in clear\n\t\tif (skip)\n\t\t\t//Copy skiped payload\n\t\t\tencryptedFrame.set(payload.subarray(0,skip),0);\n\t\t\n\t\t//If we need to sign the frame\n\t\tif (signing)\n\t\t{\n\t\t\t//Append after auth tag\n\t\t\tlet ini = skip + encryptedFrame.byteLength - extraBytes;\n\t\t\t\n\t\t\t//Get tag list view\n\t\t\tconst authTags = encryptedFrame.subarray(ini - authTagLen, (pending.length + 1) * authTagLen);\n\t\t\t\n\t\t\t//Add all previous tags \n\t\t\tfor (const previousTag of pending)\n\t\t\t{\n\t\t\t\t//Append to frame\n\t\t\t\tencryptedFrame.set(previousTag, ini);\n\t\t\t\t//Move\n\t\t\t\tini += authTagLen;\n\t\t\t}\n\t\t\t\n\t\t\t//Add number of bytes\n\t\t\tencryptedFrame[ini++] = pending.length;\n\t\t\t\n\t\t\t//Create signature with all auth tags (including this frame's one)\n\t\t\tconst signature = await this.signingKey.sign(authTags);\n\t\t\t\n\t\t\t//Add signature\n\t\t\tencryptedFrame.set(signature, ini);\n\t\t\t\n\t\t\t//Empty pending list \n\t\t\tthis.pending.set(ssrcId,[]);\n\t\t\t\n\t\t//If we can sign\n\t\t} else if (this.signingKey) {\n\t\t\t//Append a copy of current tag at the begining\n\t\t\tpending.unshift(authTag.slice());\n\t\t}\n\t\t\n\t\t//Set authenticated sender id and frame Id\n\t\tencryptedFrame.senderId = header.keyId;\n\t\tencryptedFrame.frameId  = header.counter;\n\t\t\n\t\t//Done\n\t\treturn encryptedFrame;\n\t}\n\t\n\tasync setSigningKey(key)\n\t{\n\t\t//Create new singing key\n\t\tthis.signingKey = await _EcdsaSignKey_js__WEBPACK_IMPORTED_MODULE_1__[\"EcdsaSignKey\"].create(key);\n\t}\n\t\n\tasync setEncryptionKey(key)\n\t{\n\t\t//Create new encryption key\n\t\tthis.key = await _AesCm128HmacSha256EncryptionKey_js__WEBPACK_IMPORTED_MODULE_2__[\"AesCm128HmacSha256EncryptionKey\"].create(key);\n\t}\n\t\n\tasync ratchetEncryptionKey()\n\t{\n\t\t//Check we have a valid key\n\t\tif (!this.key)\n\t\t\tthrow Error(\"Encryption key not set\");\n\t\t\n\t\t//Rachet the key and store it\n\t\tthis.key = await this.key.ratchet();\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/TaskQueue.js\":\n/*!**************************!*\\\n  !*** ./lib/TaskQueue.js ***!\n  \\**************************/\n/*! exports provided: TaskQueue */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"TaskQueue\", function() { return TaskQueue; });\nclass TaskQueue\n{\n\tconstructor()\n\t{\n\t\tthis.tasks = [];\n\t\tthis.running = false;\n\t}\n\t\n\tenqueue(promise,callback,error)\n\t{\n\t\t//enqueue task\n\t\tthis.tasks.push({promise,callback,error});\n\t\t//Try run \n\t\tthis.run();\n\t}\n\t\n\tasync run()\n\t{\n\t\t//If already running \n\t\tif (this.running)\n\t\t\t//Nothing\n\t\t\treturn;\n\t\t//Running\n\t\tthis.running = true;\n\t\t//Run all pending tasks\n\t\twhile(this.tasks.length)\n\t\t{\n\t\t\ttry {\n\t\t\t\t//Wait for first promise to finish\n\t\t\t\tconst result = await this.tasks[0].promise;\n\t\t\t\t//Run callback\n\t\t\t\tthis.tasks[0].callback(result); \n\t\t\t} catch(e) {\n\t\t\t\t//Run error callback\n\t\t\t\tthis.tasks[0].error(e); \n\t\t\t}\n\t\t\t//Remove task from queue\n\t\t\tthis.tasks.shift();\n\t\t}\n\t\t//Ended\n\t\tthis.running = false;\n\t}\n}\n\n\n/***/ }),\n\n/***/ \"./lib/Utils.js\":\n/*!**********************!*\\\n  !*** ./lib/Utils.js ***!\n  \\**********************/\n/*! exports provided: Utils */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"Utils\", function() { return Utils; });\nconst Utils = \n{\n\ttoHex : function(buffer)\n\t{\n\t\treturn Array.prototype.map.call(buffer instanceof Uint8Array ? buffer : new Uint8Array (buffer), x =>x.toString(16).padStart(2,\"0\")).join(\"\");\n\t},\n\tfromHex: function(str)\n\t{\n\t\tconst bytes = [];\n\t\tfor (let i=0;i<str.length/2;++i)\n\t\t\tbytes.push(parseInt(str.substring(i*2, (i+1)*2), 16));\n\n\t\treturn new Uint8Array(bytes);\n\t},\n\tequals : function(a,b)\n\t{\n\t\tif (a.byteLength != b.byteLength) return false;\n\t\tfor (let i = 0 ; i != a.byteLength ; i++)\n\t\t\tif (a[i] != b[i]) return false;\n\t\treturn true;\n\t}\n};\n\n\n/***/ }),\n\n/***/ \"./lib/VP8PayloadHeader.js\":\n/*!*********************************!*\\\n  !*** ./lib/VP8PayloadHeader.js ***!\n  \\*********************************/\n/*! exports provided: VP8PayloadHeader */\n/***/ (function(module, __webpack_exports__, __webpack_require__) {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"VP8PayloadHeader\", function() { return VP8PayloadHeader; });\n\nconst VP8PayloadHeader = {\n\t\n\tparse : function(buffer) \n\t{\n\t\t//Check size\n\t\tif (buffer.byteLength<3)\n\t\t\t//Invalid\n\t\t\treturn null;\n\t\t\n\t\t//Create uint view\n\t\tconst view = new Uint8Array(buffer);\n\t\t\n\t\t//Read comon 3 bytes\n\t\t//   0 1 2 3 4 5 6 7\n                //  +-+-+-+-+-+-+-+-+\n                //  |Size0|H| VER |P|\n                //  +-+-+-+-+-+-+-+-+\n                //  |     Size1     |\n                //  +-+-+-+-+-+-+-+-+\n                //  |     Size2     |\n                //  +-+-+-+-+-+-+-+-+\n\t\tconst firstPartitionSize\t= view[0] >> 5;\n\t\tconst showFrame\t\t\t= view[0] >> 4 & 0x01;\n\t\tconst version\t\t\t= view[0] >> 1 & 0x07;\n\t\tconst isKeyFrame\t\t= (view[0] & 0x01) == 0;\n\n\t\t//check if more\n\t\tif (isKeyFrame)\n\t\t{\n\t\t\t//Check size\n\t\t\tif (buffer.byteLength<10)\n\t\t\t\t//Invalid\n\t\t\t\treturn null;\n\t\t\t//Get size in le\n\t\t\tconst hor = view[7]<<8 | view[6];\n\t\t\tconst ver = view[9]<<8 | view[8];\n\t\t\t//Get dimensions and scale\n\t\t\tconst width\t\t= hor & 0x3fff;\n\t\t\tconst horizontalScale   = hor >> 14;\n\t\t\tconst height\t\t= ver & 0x3fff;\n\t\t\tconst verticalScale\t= ver >> 14;\n\t\t\t//Key frame\n\t\t\treturn view.subarray (0,10);\n\t\t}\n\t\t\n\t\t//No key frame\n\t\treturn view.subarray (0,3);\n\t}\n};\n\n\t\t\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_Symbol.js\":\n/*!****************************************!*\\\n  !*** ./node_modules/lodash/_Symbol.js ***!\n  \\****************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar root = __webpack_require__(/*! ./_root */ \"./node_modules/lodash/_root.js\");\n\n/** Built-in value references. */\nvar Symbol = root.Symbol;\n\nmodule.exports = Symbol;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_baseGetTag.js\":\n/*!********************************************!*\\\n  !*** ./node_modules/lodash/_baseGetTag.js ***!\n  \\********************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar Symbol = __webpack_require__(/*! ./_Symbol */ \"./node_modules/lodash/_Symbol.js\"),\n    getRawTag = __webpack_require__(/*! ./_getRawTag */ \"./node_modules/lodash/_getRawTag.js\"),\n    objectToString = __webpack_require__(/*! ./_objectToString */ \"./node_modules/lodash/_objectToString.js\");\n\n/** `Object#toString` result references. */\nvar nullTag = '[object Null]',\n    undefinedTag = '[object Undefined]';\n\n/** Built-in value references. */\nvar symToStringTag = Symbol ? Symbol.toStringTag : undefined;\n\n/**\n * The base implementation of `getTag` without fallbacks for buggy environments.\n *\n * @private\n * @param {*} value The value to query.\n * @returns {string} Returns the `toStringTag`.\n */\nfunction baseGetTag(value) {\n  if (value == null) {\n    return value === undefined ? undefinedTag : nullTag;\n  }\n  return (symToStringTag && symToStringTag in Object(value))\n    ? getRawTag(value)\n    : objectToString(value);\n}\n\nmodule.exports = baseGetTag;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_baseTrim.js\":\n/*!******************************************!*\\\n  !*** ./node_modules/lodash/_baseTrim.js ***!\n  \\******************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar trimmedEndIndex = __webpack_require__(/*! ./_trimmedEndIndex */ \"./node_modules/lodash/_trimmedEndIndex.js\");\n\n/** Used to match leading whitespace. */\nvar reTrimStart = /^\\s+/;\n\n/**\n * The base implementation of `_.trim`.\n *\n * @private\n * @param {string} string The string to trim.\n * @returns {string} Returns the trimmed string.\n */\nfunction baseTrim(string) {\n  return string\n    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')\n    : string;\n}\n\nmodule.exports = baseTrim;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_freeGlobal.js\":\n/*!********************************************!*\\\n  !*** ./node_modules/lodash/_freeGlobal.js ***!\n  \\********************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\n/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */\nvar freeGlobal = typeof global == 'object' && global && global.Object === Object && global;\n\nmodule.exports = freeGlobal;\n\n/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ \"./node_modules/webpack/buildin/global.js\")))\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_getRawTag.js\":\n/*!*******************************************!*\\\n  !*** ./node_modules/lodash/_getRawTag.js ***!\n  \\*******************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar Symbol = __webpack_require__(/*! ./_Symbol */ \"./node_modules/lodash/_Symbol.js\");\n\n/** Used for built-in method references. */\nvar objectProto = Object.prototype;\n\n/** Used to check objects for own properties. */\nvar hasOwnProperty = objectProto.hasOwnProperty;\n\n/**\n * Used to resolve the\n * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)\n * of values.\n */\nvar nativeObjectToString = objectProto.toString;\n\n/** Built-in value references. */\nvar symToStringTag = Symbol ? Symbol.toStringTag : undefined;\n\n/**\n * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.\n *\n * @private\n * @param {*} value The value to query.\n * @returns {string} Returns the raw `toStringTag`.\n */\nfunction getRawTag(value) {\n  var isOwn = hasOwnProperty.call(value, symToStringTag),\n      tag = value[symToStringTag];\n\n  try {\n    value[symToStringTag] = undefined;\n    var unmasked = true;\n  } catch (e) {}\n\n  var result = nativeObjectToString.call(value);\n  if (unmasked) {\n    if (isOwn) {\n      value[symToStringTag] = tag;\n    } else {\n      delete value[symToStringTag];\n    }\n  }\n  return result;\n}\n\nmodule.exports = getRawTag;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_objectToString.js\":\n/*!************************************************!*\\\n  !*** ./node_modules/lodash/_objectToString.js ***!\n  \\************************************************/\n/*! no static exports found */\n/***/ (function(module, exports) {\n\n/** Used for built-in method references. */\nvar objectProto = Object.prototype;\n\n/**\n * Used to resolve the\n * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)\n * of values.\n */\nvar nativeObjectToString = objectProto.toString;\n\n/**\n * Converts `value` to a string using `Object.prototype.toString`.\n *\n * @private\n * @param {*} value The value to convert.\n * @returns {string} Returns the converted string.\n */\nfunction objectToString(value) {\n  return nativeObjectToString.call(value);\n}\n\nmodule.exports = objectToString;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_root.js\":\n/*!**************************************!*\\\n  !*** ./node_modules/lodash/_root.js ***!\n  \\**************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar freeGlobal = __webpack_require__(/*! ./_freeGlobal */ \"./node_modules/lodash/_freeGlobal.js\");\n\n/** Detect free variable `self`. */\nvar freeSelf = typeof self == 'object' && self && self.Object === Object && self;\n\n/** Used as a reference to the global object. */\nvar root = freeGlobal || freeSelf || Function('return this')();\n\nmodule.exports = root;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/_trimmedEndIndex.js\":\n/*!*************************************************!*\\\n  !*** ./node_modules/lodash/_trimmedEndIndex.js ***!\n  \\*************************************************/\n/*! no static exports found */\n/***/ (function(module, exports) {\n\n/** Used to match a single whitespace character. */\nvar reWhitespace = /\\s/;\n\n/**\n * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace\n * character of `string`.\n *\n * @private\n * @param {string} string The string to inspect.\n * @returns {number} Returns the index of the last non-whitespace character.\n */\nfunction trimmedEndIndex(string) {\n  var index = string.length;\n\n  while (index-- && reWhitespace.test(string.charAt(index))) {}\n  return index;\n}\n\nmodule.exports = trimmedEndIndex;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/debounce.js\":\n/*!*****************************************!*\\\n  !*** ./node_modules/lodash/debounce.js ***!\n  \\*****************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar isObject = __webpack_require__(/*! ./isObject */ \"./node_modules/lodash/isObject.js\"),\n    now = __webpack_require__(/*! ./now */ \"./node_modules/lodash/now.js\"),\n    toNumber = __webpack_require__(/*! ./toNumber */ \"./node_modules/lodash/toNumber.js\");\n\n/** Error message constants. */\nvar FUNC_ERROR_TEXT = 'Expected a function';\n\n/* Built-in method references for those with the same name as other `lodash` methods. */\nvar nativeMax = Math.max,\n    nativeMin = Math.min;\n\n/**\n * Creates a debounced function that delays invoking `func` until after `wait`\n * milliseconds have elapsed since the last time the debounced function was\n * invoked. The debounced function comes with a `cancel` method to cancel\n * delayed `func` invocations and a `flush` method to immediately invoke them.\n * Provide `options` to indicate whether `func` should be invoked on the\n * leading and/or trailing edge of the `wait` timeout. The `func` is invoked\n * with the last arguments provided to the debounced function. Subsequent\n * calls to the debounced function return the result of the last `func`\n * invocation.\n *\n * **Note:** If `leading` and `trailing` options are `true`, `func` is\n * invoked on the trailing edge of the timeout only if the debounced function\n * is invoked more than once during the `wait` timeout.\n *\n * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred\n * until to the next tick, similar to `setTimeout` with a timeout of `0`.\n *\n * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)\n * for details over the differences between `_.debounce` and `_.throttle`.\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Function\n * @param {Function} func The function to debounce.\n * @param {number} [wait=0] The number of milliseconds to delay.\n * @param {Object} [options={}] The options object.\n * @param {boolean} [options.leading=false]\n *  Specify invoking on the leading edge of the timeout.\n * @param {number} [options.maxWait]\n *  The maximum time `func` is allowed to be delayed before it's invoked.\n * @param {boolean} [options.trailing=true]\n *  Specify invoking on the trailing edge of the timeout.\n * @returns {Function} Returns the new debounced function.\n * @example\n *\n * // Avoid costly calculations while the window size is in flux.\n * jQuery(window).on('resize', _.debounce(calculateLayout, 150));\n *\n * // Invoke `sendMail` when clicked, debouncing subsequent calls.\n * jQuery(element).on('click', _.debounce(sendMail, 300, {\n *   'leading': true,\n *   'trailing': false\n * }));\n *\n * // Ensure `batchLog` is invoked once after 1 second of debounced calls.\n * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });\n * var source = new EventSource('/stream');\n * jQuery(source).on('message', debounced);\n *\n * // Cancel the trailing debounced invocation.\n * jQuery(window).on('popstate', debounced.cancel);\n */\nfunction debounce(func, wait, options) {\n  var lastArgs,\n      lastThis,\n      maxWait,\n      result,\n      timerId,\n      lastCallTime,\n      lastInvokeTime = 0,\n      leading = false,\n      maxing = false,\n      trailing = true;\n\n  if (typeof func != 'function') {\n    throw new TypeError(FUNC_ERROR_TEXT);\n  }\n  wait = toNumber(wait) || 0;\n  if (isObject(options)) {\n    leading = !!options.leading;\n    maxing = 'maxWait' in options;\n    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;\n    trailing = 'trailing' in options ? !!options.trailing : trailing;\n  }\n\n  function invokeFunc(time) {\n    var args = lastArgs,\n        thisArg = lastThis;\n\n    lastArgs = lastThis = undefined;\n    lastInvokeTime = time;\n    result = func.apply(thisArg, args);\n    return result;\n  }\n\n  function leadingEdge(time) {\n    // Reset any `maxWait` timer.\n    lastInvokeTime = time;\n    // Start the timer for the trailing edge.\n    timerId = setTimeout(timerExpired, wait);\n    // Invoke the leading edge.\n    return leading ? invokeFunc(time) : result;\n  }\n\n  function remainingWait(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime,\n        timeWaiting = wait - timeSinceLastCall;\n\n    return maxing\n      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)\n      : timeWaiting;\n  }\n\n  function shouldInvoke(time) {\n    var timeSinceLastCall = time - lastCallTime,\n        timeSinceLastInvoke = time - lastInvokeTime;\n\n    // Either this is the first call, activity has stopped and we're at the\n    // trailing edge, the system time has gone backwards and we're treating\n    // it as the trailing edge, or we've hit the `maxWait` limit.\n    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||\n      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));\n  }\n\n  function timerExpired() {\n    var time = now();\n    if (shouldInvoke(time)) {\n      return trailingEdge(time);\n    }\n    // Restart the timer.\n    timerId = setTimeout(timerExpired, remainingWait(time));\n  }\n\n  function trailingEdge(time) {\n    timerId = undefined;\n\n    // Only invoke if we have `lastArgs` which means `func` has been\n    // debounced at least once.\n    if (trailing && lastArgs) {\n      return invokeFunc(time);\n    }\n    lastArgs = lastThis = undefined;\n    return result;\n  }\n\n  function cancel() {\n    if (timerId !== undefined) {\n      clearTimeout(timerId);\n    }\n    lastInvokeTime = 0;\n    lastArgs = lastCallTime = lastThis = timerId = undefined;\n  }\n\n  function flush() {\n    return timerId === undefined ? result : trailingEdge(now());\n  }\n\n  function debounced() {\n    var time = now(),\n        isInvoking = shouldInvoke(time);\n\n    lastArgs = arguments;\n    lastThis = this;\n    lastCallTime = time;\n\n    if (isInvoking) {\n      if (timerId === undefined) {\n        return leadingEdge(lastCallTime);\n      }\n      if (maxing) {\n        // Handle invocations in a tight loop.\n        clearTimeout(timerId);\n        timerId = setTimeout(timerExpired, wait);\n        return invokeFunc(lastCallTime);\n      }\n    }\n    if (timerId === undefined) {\n      timerId = setTimeout(timerExpired, wait);\n    }\n    return result;\n  }\n  debounced.cancel = cancel;\n  debounced.flush = flush;\n  return debounced;\n}\n\nmodule.exports = debounce;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/isObject.js\":\n/*!*****************************************!*\\\n  !*** ./node_modules/lodash/isObject.js ***!\n  \\*****************************************/\n/*! no static exports found */\n/***/ (function(module, exports) {\n\n/**\n * Checks if `value` is the\n * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)\n * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)\n *\n * @static\n * @memberOf _\n * @since 0.1.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is an object, else `false`.\n * @example\n *\n * _.isObject({});\n * // => true\n *\n * _.isObject([1, 2, 3]);\n * // => true\n *\n * _.isObject(_.noop);\n * // => true\n *\n * _.isObject(null);\n * // => false\n */\nfunction isObject(value) {\n  var type = typeof value;\n  return value != null && (type == 'object' || type == 'function');\n}\n\nmodule.exports = isObject;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/isObjectLike.js\":\n/*!*********************************************!*\\\n  !*** ./node_modules/lodash/isObjectLike.js ***!\n  \\*********************************************/\n/*! no static exports found */\n/***/ (function(module, exports) {\n\n/**\n * Checks if `value` is object-like. A value is object-like if it's not `null`\n * and has a `typeof` result of \"object\".\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is object-like, else `false`.\n * @example\n *\n * _.isObjectLike({});\n * // => true\n *\n * _.isObjectLike([1, 2, 3]);\n * // => true\n *\n * _.isObjectLike(_.noop);\n * // => false\n *\n * _.isObjectLike(null);\n * // => false\n */\nfunction isObjectLike(value) {\n  return value != null && typeof value == 'object';\n}\n\nmodule.exports = isObjectLike;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/isSymbol.js\":\n/*!*****************************************!*\\\n  !*** ./node_modules/lodash/isSymbol.js ***!\n  \\*****************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar baseGetTag = __webpack_require__(/*! ./_baseGetTag */ \"./node_modules/lodash/_baseGetTag.js\"),\n    isObjectLike = __webpack_require__(/*! ./isObjectLike */ \"./node_modules/lodash/isObjectLike.js\");\n\n/** `Object#toString` result references. */\nvar symbolTag = '[object Symbol]';\n\n/**\n * Checks if `value` is classified as a `Symbol` primitive or object.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.\n * @example\n *\n * _.isSymbol(Symbol.iterator);\n * // => true\n *\n * _.isSymbol('abc');\n * // => false\n */\nfunction isSymbol(value) {\n  return typeof value == 'symbol' ||\n    (isObjectLike(value) && baseGetTag(value) == symbolTag);\n}\n\nmodule.exports = isSymbol;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/now.js\":\n/*!************************************!*\\\n  !*** ./node_modules/lodash/now.js ***!\n  \\************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar root = __webpack_require__(/*! ./_root */ \"./node_modules/lodash/_root.js\");\n\n/**\n * Gets the timestamp of the number of milliseconds that have elapsed since\n * the Unix epoch (1 January 1970 00:00:00 UTC).\n *\n * @static\n * @memberOf _\n * @since 2.4.0\n * @category Date\n * @returns {number} Returns the timestamp.\n * @example\n *\n * _.defer(function(stamp) {\n *   console.log(_.now() - stamp);\n * }, _.now());\n * // => Logs the number of milliseconds it took for the deferred invocation.\n */\nvar now = function() {\n  return root.Date.now();\n};\n\nmodule.exports = now;\n\n\n/***/ }),\n\n/***/ \"./node_modules/lodash/toNumber.js\":\n/*!*****************************************!*\\\n  !*** ./node_modules/lodash/toNumber.js ***!\n  \\*****************************************/\n/*! no static exports found */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar baseTrim = __webpack_require__(/*! ./_baseTrim */ \"./node_modules/lodash/_baseTrim.js\"),\n    isObject = __webpack_require__(/*! ./isObject */ \"./node_modules/lodash/isObject.js\"),\n    isSymbol = __webpack_require__(/*! ./isSymbol */ \"./node_modules/lodash/isSymbol.js\");\n\n/** Used as references for various `Number` constants. */\nvar NAN = 0 / 0;\n\n/** Used to detect bad signed hexadecimal string values. */\nvar reIsBadHex = /^[-+]0x[0-9a-f]+$/i;\n\n/** Used to detect binary string values. */\nvar reIsBinary = /^0b[01]+$/i;\n\n/** Used to detect octal string values. */\nvar reIsOctal = /^0o[0-7]+$/i;\n\n/** Built-in method references without a dependency on `root`. */\nvar freeParseInt = parseInt;\n\n/**\n * Converts `value` to a number.\n *\n * @static\n * @memberOf _\n * @since 4.0.0\n * @category Lang\n * @param {*} value The value to process.\n * @returns {number} Returns the number.\n * @example\n *\n * _.toNumber(3.2);\n * // => 3.2\n *\n * _.toNumber(Number.MIN_VALUE);\n * // => 5e-324\n *\n * _.toNumber(Infinity);\n * // => Infinity\n *\n * _.toNumber('3.2');\n * // => 3.2\n */\nfunction toNumber(value) {\n  if (typeof value == 'number') {\n    return value;\n  }\n  if (isSymbol(value)) {\n    return NAN;\n  }\n  if (isObject(value)) {\n    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;\n    value = isObject(other) ? (other + '') : other;\n  }\n  if (typeof value != 'string') {\n    return value === 0 ? value : +value;\n  }\n  value = baseTrim(value);\n  var isBinary = reIsBinary.test(value);\n  return (isBinary || reIsOctal.test(value))\n    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)\n    : (reIsBadHex.test(value) ? NAN : +value);\n}\n\nmodule.exports = toNumber;\n\n\n/***/ }),\n\n/***/ \"./node_modules/webpack/buildin/global.js\":\n/*!***********************************!*\\\n  !*** (webpack)/buildin/global.js ***!\n  \\***********************************/\n/*! no static exports found */\n/***/ (function(module, exports) {\n\nvar g;\n\n// This works in non-strict mode\ng = (function() {\n\treturn this;\n})();\n\ntry {\n\t// This works if eval is allowed (see CSP)\n\tg = g || new Function(\"return this\")();\n} catch (e) {\n\t// This works if the window reference is available\n\tif (typeof window === \"object\") g = window;\n}\n\n// g can still be undefined, but nothing to do about it...\n// We return undefined, instead of nothing here, so it's\n// easier to handle this case. if(!global) { ...}\n\nmodule.exports = g;\n\n\n/***/ })\n\n/******/ });\n", "Worker", undefined, undefined);
                            }
                        /***/ },
                        /***/ "./index.js": /*!******************!*\
  !*** ./index.js ***!
  \******************/ /*! exports provided: SFrame, Utils */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            __webpack_require__.r(__webpack_exports__);
                            /* harmony import */ var _sframe_lib_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sframe/lib/Utils */ "./lib/Utils.js");
                            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Utils", function() {
                                return _sframe_lib_Utils__WEBPACK_IMPORTED_MODULE_0__["Utils"];
                            });
                            /* harmony import */ var _Client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Client */ "./Client.js");
                            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SFrame", function() {
                                return _Client__WEBPACK_IMPORTED_MODULE_1__["SFrame"];
                            });
                        /***/ },
                        /***/ "./lib/Utils.js": /*!**********************!*\
  !*** ./lib/Utils.js ***!
  \**********************/ /*! exports provided: Utils */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            __webpack_require__.r(__webpack_exports__);
                            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Utils", function() {
                                return Utils;
                            });
                            const Utils = {
                                toHex: function(buffer) {
                                    return Array.prototype.map.call(buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer), (x)=>x.toString(16).padStart(2, "0")).join("");
                                },
                                fromHex: function(str) {
                                    const bytes = [];
                                    for(let i = 0; i < str.length / 2; ++i)bytes.push(parseInt(str.substring(i * 2, (i + 1) * 2), 16));
                                    return new Uint8Array(bytes);
                                },
                                equals: function(a, b) {
                                    if (a.byteLength != b.byteLength) return false;
                                    for(let i = 0; i != a.byteLength; i++)if (a[i] != b[i]) return false;
                                    return true;
                                }
                            };
                        /***/ },
                        /***/ "./node_modules/worker-loader/dist/runtime/inline.js": /*!***********************************************************!*\
  !*** ./node_modules/worker-loader/dist/runtime/inline.js ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
                            "use strict";
                            /* eslint-env browser */ /* eslint-disable no-undef, no-use-before-define, new-cap */ module1.exports = function(content, workerConstructor, workerOptions, url) {
                                var globalScope = self || window;
                                try {
                                    try {
                                        var blob;
                                        try {
                                            // New API
                                            blob = new globalScope.Blob([
                                                content
                                            ]);
                                        } catch (e) {
                                            // BlobBuilder = Deprecated, but widely implemented
                                            var BlobBuilder = globalScope.BlobBuilder || globalScope.WebKitBlobBuilder || globalScope.MozBlobBuilder || globalScope.MSBlobBuilder;
                                            blob = new BlobBuilder();
                                            blob.append(content);
                                            blob = blob.getBlob();
                                        }
                                        var URL1 = globalScope.URL || globalScope.webkitURL;
                                        var objectURL = URL1.createObjectURL(blob);
                                        var worker = new globalScope[workerConstructor](objectURL, workerOptions);
                                        URL1.revokeObjectURL(objectURL);
                                        return worker;
                                    } catch (e) {
                                        return new globalScope[workerConstructor]("data:application/javascript,".concat(encodeURIComponent(content)), workerOptions);
                                    }
                                } catch (e) {
                                    if (!url) throw Error("Inline worker is not supported");
                                    return new globalScope[workerConstructor](url, workerOptions);
                                }
                            };
                        /***/ }
                    });
                });
            //# sourceMappingURL=main.js.map
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(0));
        /***/ },
        /* 745 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));
            /* eslint-disable no-underscore-dangle */ const PeerConnectionDefault = __webpack_require__(73)();
            let SinglePeerConnectionController = /*#__PURE__*/ function() {
                function SinglePeerConnectionController(session, deps) {
                    if (deps === void 0) deps = {};
                    (0, _defineProperty2.default)(this, "_firstSinglepeerConnection", void 0);
                    (0, _defineProperty2.default)(this, "_peerConnection", void 0);
                    (0, _defineProperty2.default)(this, "_spcToAdd", void 0);
                    (0, _defineProperty2.default)(this, "_singlePeerConnections", {});
                    (0, _defineProperty2.default)(this, "_session", void 0);
                    (0, _defineProperty2.default)(this, "_tracks", []);
                    this._session = session;
                    this.PeerConnection = deps.PeerConnection || PeerConnectionDefault;
                } // Singleton to make sure we are using only one PC when SPC. If SPC, we will add Subscriber
                // specific options to handle analytics and negotiation per Subscriber. This will take care
                // to send the answer back to Rumor by its respective Subcriber and not multiple answers.
                // It will instantiate a new regular PC for all other cases.
                var _proto = SinglePeerConnectionController.prototype;
                _proto.getPeerConnection = function getPeerConnection(opt, spc) {
                    this._spcToAdd = spc;
                    if (this._peerConnection) this._peerConnection.addOptions(opt);
                    else {
                        this._firstSinglePeerConnection = spc._id;
                        this._peerConnection = new this.PeerConnection(opt); // override the trackAdded listener so we can route the tracks to the proper subscriber.
                        this._peerConnection.on('trackAdded', (stream)=>{
                            const track = stream.track;
                            if (this._tracks.includes(track.id)) return;
                             // We store all tracks per Subscriber.
                            this._singlePeerConnections[this._spcToAdd._id].push(track); // Also store all tracks per SinglePeerConnection
                            this._tracks.push(track.id);
                            this._spcToAdd._onTrackAdded(stream);
                        });
                    }
                    this._singlePeerConnections[spc._id] = [];
                    return this._peerConnection;
                };
                _proto.removeSinglePeerConnection = function removeSinglePeerConnection(spcId) {
                    if (this._firstSinglePeerConnection === spcId) this._peerConnection.iceRestart();
                    delete this._singlePeerConnections[spcId];
                    if (!Object.keys(this._singlePeerConnections).length) {
                        this._peerConnection.disconnect();
                        this._peerConnection = null;
                    }
                };
                _proto.removeTrack = function removeTrack(track, spcId) {
                    var _this$_singlePeerConn;
                    let trackIndex = this._tracks.indexOf(track.id);
                    if (trackIndex > -1) this._tracks.splice(trackIndex, 1);
                    trackIndex = (_this$_singlePeerConn = this._singlePeerConnections[spcId]) == null ? void 0 : _this$_singlePeerConn.indexOf(track);
                    if (trackIndex > -1) this._singlePeerConnections[spcId].splice(trackIndex, 1);
                };
                _proto.destroy = function destroy() {
                    this._spcToAdd = null;
                    this._singlePeerConnections = null;
                    this._session = null;
                    this._tracks = null;
                    if (this._peerConnection) {
                        this._peerConnection.disconnect();
                        this._peerConnection = null;
                    }
                };
                return SinglePeerConnectionController;
            }();
            module1.exports = SinglePeerConnectionController;
        /***/ },
        /* 746 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // @todo enable the following disabled rules see OPENTOK-31136 for more info
            /* eslint-disable no-param-reassign, global-require */ module1.exports = function initSessionFactory(deps) {
                if (deps === void 0) deps = {};
                const Session = deps.Session || __webpack_require__(315)();
                const sessionObjects = deps.sessionObjects || __webpack_require__(21);
                /**
  * The first step in using the OpenTok API is to call the <code>OT.initSession()</code>
  * method. Other methods of the OT object check for system requirements and set up error logging.
  *
  * @class OT
  */ /**
  * <p class="mSummary">
  * Initializes and returns the local session object for a specified session ID.
  * </p>
  * <p>
  * You connect to an OpenTok session using the <code>connect()</code> method
  * of the Session object returned by the <code>OT.initSession()</code> method.
  * Note that calling <code>OT.initSession()</code> does not initiate communications
  * with the cloud. It simply initializes the Session object that you can use to
  * connect (and to perform other operations once connected).
  * </p>
  *
  * <p>
  * Note that you can initialize only one Session object per session ID. Calling
  * <code>OT.initSession()</code> a second time with the same session ID returns the
  * previously created Session object. However, you can initialize multiple Session objects
  * for different sessions (with different session IDs) to connect to multiple sessions.
  * </p>
  *
  * <p>
  * When the client disconnects from the session (and the session dispatches a
  * <code>sessionDisconnected</code> event), you can reuse the Session object to
  * reconnect to the session. However, the Session object will retain any existing
  * event handlers attached to it. You can remove all event handlers by calling the
  * <code>off()</code> method of the Session object (passing in no parameters).
  * </p>
  *
  *  <p>
  *    For an example, see <a href="Session.html#connect">Session.connect()</a>.
  *  </p>
  *
  * @method OT.initSession
  * @memberof OT
  * @param {String} apiKey Your OpenTok API key (see your <a href="https://tokbox.com/account">Vonage Video API
  * account page</a>).
  * @param {String} sessionId The session ID identifying the OpenTok session. For more
  * information, see <a href="https://tokbox.com/opentok/tutorials/create-session/">Session
  * creation</a>.
  * @param {Object} options An object that includes optional options for initializing the session.
  * This object includes the following properties:
  * <ul>
  *   <li><code>connectionEventsSuppressed</code> &mdash; (Boolean)
  *     Set this property to <code>true</code> to support large interactive video sessions.
  *     This prevents the Session object from dispatching <code>connectionCreated</code> and
  *     <code>connectionDestroyed</code> events when other clients connect to or disconnect from
  *     the session. (Also, the OpenTok server does not send these events to the web client.)
  *     For more information, see
  *     <a href="https://tokbox.com/developer/guides/broadcast/live-interactive-video/#suppressing-connection-events">
  *     Suppressing connection events</a> in the OpenTok developer guides.
  *   </li>
  *   <li><code>ipWhitelist</code> &mdash; (Boolean) This is available as an
  *     <a href="https://tokbox.com/pricing/plans" target="_blank">add-on feature</a>.
  *     Set this to <code>true</code> if IP white listing is enabled for your project.
  *     The default value is <code>false</code>.
  *   </li>
  *   <li><code>iceConfig</code> &mdash; (Object) This feature is part of the configurable TURN
  *     <a href="https://tokbox.com/pricing/plans" target="_blank">add-on feature</a>.
  *   </li>
  * </ul>
  *
  * @returns {Session} The session object through which all further interactions with
  * the session will occur.
  */ return function initSession(apiKey, sessionId, opt) {
                    if (sessionId == null) {
                        sessionId = apiKey;
                        apiKey = null;
                    } // Allow buggy legacy behavior to succeed, where the client can connect if sessionId
                    // is an array containing one element (the session ID), but fix it so that sessionId
                    // is stored as a string (not an array):
                    if (Array.isArray(sessionId) && sessionId.length === 1) sessionId = sessionId[0];
                    let session = sessionObjects.sessions.get(sessionId);
                    if (!session) {
                        session = new Session(apiKey, sessionId, opt);
                        sessionObjects.sessions.add(session);
                    }
                    return session;
                };
            };
        /***/ },
        /* 747 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const difference = __webpack_require__(748);
            const uniq = __webpack_require__(274);
            const env = __webpack_require__(3);
            const Errors = __webpack_require__(6);
            const ExceptionCodes = __webpack_require__(10);
            const otError = __webpack_require__(13)();
            const SDPHelpers = __webpack_require__(53);
            const shouldUsePlanBSDP = __webpack_require__(74);
            const windowMock = __webpack_require__(142)(window);
            function filterCodecList(codecs) {
                // Chromium uses the payload 'AV1X' pre M95 and 'AV1' after
                return uniq(difference(codecs, [
                    'AV1X',
                    'AV1',
                    'VP9',
                    'rtx',
                    'red',
                    'ulpfec',
                    'H265',
                    'X-H264UC',
                    'x-ulpfecuc'
                ]));
            }
            /**
 * Gets the list of supported codecs for encoding and decoding video streams.
 * <p>
 * The following example gets the list of supported codecs for encoding and
 * decoding video streams:
 * <pre>
 * (async () => {
 *   try {
 *     const supportedCodecs = await OT.getSupportedCodecs();
 *     if (supportedCodecs.videoEncoders.indexOf('H264') < 0 &&
 *         supportedCodecs.videoDecoders.indexOf('H264') < 0) {
 *       // The client does not support encoding or decoding H264.
 *       // Let's recommend using a different browser.
 *     }
 *   } catch(err) {
 *     console.log(err);
 *   }
 * })();
 * </pre>
 * <p>
 * You can use the lists of supported video codecs to determine whether the client
 * supports video, depending on the preferred video codec and the type of session being used.
 * You can set the preferred video codec on the Project page of your
 * <a href="https://tokbox.com/account/">Vonage Video API account</a>. In
 * <a href="https://tokbox.com/developer/guides/create-session/#media-mode">routed sessions</a>
 * (sessions that use the OpenTok Media Router), the preferred video codec is used for all
 * clients in the session. In relayed sessions, clients send streams directly to one another,
 * and each publishing-subscribing pair tries to find a common video codec that they can both use.
 * In this regard, the video codec used by the pair in a relayed session may be different from
 * the preferred video codec setting. For more information see the OpenTok
 * <a href="https://tokbox.com/developer/guides/codecs/">Video codecs</a> developer guide.
 *
 * @return {Promise} A promise that is resolved when the list of supported codecs is ready.
 * The promise is resolved (on success) with an object that has two properties:
 * <code>videoDecoders</code>, an array of supported video codecs for decoding, and
 * <code>videoEncoders</code>, an array of supported video codecs for encoding, such as:
 * <pre>
 * {
 *    videoDecoders: ['H264', 'VP8'],
 *    videoEncoders: ['H264', 'VP8']
 * }
 * </pre>
 * <p>
 * The promise is rejected if there is an error in getting the list.
 *
 * @method OT.getSupportedCodecs
 * @memberof OT
 */ const getSupportedCodecs = /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                    var RTCPeerConnection, codecs, canvas, stream, localPc, pcConfig, offer;
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(typeof window === 'undefined')) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    videoEncoders: [],
                                    videoDecoders: []
                                });
                            case 2:
                                RTCPeerConnection = windowMock.RTCPeerConnection;
                                if (!(window.RTCRtpSender && 'getCapabilities' in window.RTCRtpSender)) {
                                    _context.next = 7;
                                    break;
                                }
                                codecs = window.RTCRtpSender.getCapabilities('video').codecs.map((c)=>c.mimeType || c.name) // Edge/ORTC does not support mimeType
                                .map((mimeTypeOrName)=>mimeTypeOrName.replace('video/', ''));
                                codecs = filterCodecList(codecs);
                                return _context.abrupt("return", {
                                    videoEncoders: codecs,
                                    videoDecoders: codecs
                                });
                            case 7:
                                if (!(env.name === 'Chrome' && !('captureStream' in window.HTMLCanvasElement.prototype))) {
                                    _context.next = 9;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    videoEncoders: [
                                        'VP8'
                                    ],
                                    videoDecoders: [
                                        'VP8'
                                    ]
                                });
                            case 9:
                                if (!env.isLegacyEdge) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    videoEncoders: [
                                        'H264',
                                        'VP8'
                                    ],
                                    videoDecoders: [
                                        'H264',
                                        'VP8'
                                    ]
                                });
                            case 11:
                                canvas = window.document.createElement('canvas'); // Need to make a 2d context for captureStream to work, even though it's not used.
                                canvas.getContext('2d');
                                stream = canvas.captureStream();
                                _context.prev = 14;
                                pcConfig = {
                                    iceServers: []
                                };
                                if (shouldUsePlanBSDP()) pcConfig.sdpSemantics = 'plan-b';
                                localPc = new RTCPeerConnection(pcConfig);
                                if (localPc.addTrack) localPc.addTrack(stream.getVideoTracks()[0], stream);
                                else if (localPc.addStream) localPc.addStream(stream);
                                _context.next = 21;
                                return localPc.createOffer();
                            case 21:
                                offer = _context.sent;
                                codecs = SDPHelpers.getCodecs(offer.sdp, 'video') || [];
                                codecs = filterCodecList(codecs);
                                return _context.abrupt("return", {
                                    videoEncoders: codecs,
                                    videoDecoders: codecs
                                });
                            case 27:
                                _context.prev = 27;
                                _context.t0 = _context["catch"](14);
                                throw otError(Errors.UNABLE_TO_ACCESS_MEDIA_ENGINE, new Error('OT.getSupportedCodecs was not able to get the list of supported codecs'), ExceptionCodes.UNABLE_TO_ACCESS_MEDIA_ENGINE);
                            case 30:
                                _context.prev = 30;
                                localPc.close();
                                return _context.finish(30);
                            case 33:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            14,
                            27,
                            30,
                            33
                        ]
                    ]);
                }));
                return function getSupportedCodecs() {
                    return _ref.apply(this, arguments);
                };
            }();
            module1.exports = getSupportedCodecs;
        /***/ },
        /* 748 */ /***/ function(module1, exports, __webpack_require__) {
            var baseDifference = __webpack_require__(749), baseFlatten = __webpack_require__(238), baseRest = __webpack_require__(88), isArrayLikeObject = __webpack_require__(129);
            /**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var difference = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            module1.exports = difference;
        /***/ },
        /* 749 */ /***/ function(module1, exports, __webpack_require__) {
            var SetCache = __webpack_require__(93), arrayIncludes = __webpack_require__(94), arrayIncludesWith = __webpack_require__(128), arrayMap = __webpack_require__(34), baseUnary = __webpack_require__(68), cacheHas = __webpack_require__(95);
            /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
            /**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
                if (!length) return result;
                if (iteratee) values = arrayMap(values, baseUnary(iteratee));
                if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                }
                outer: while(++index < length){
                    var value = array[index], computed = iteratee == null ? value : iteratee(value);
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var valuesIndex = valuesLength;
                        while(valuesIndex--){
                            if (values[valuesIndex] === computed) continue outer;
                        }
                        result.push(value);
                    } else if (!includes(values, computed, comparator)) result.push(value);
                }
                return result;
            }
            module1.exports = baseDifference;
        /***/ },
        /* 750 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(311), isSupported = _require.isSupported;
            /**
 * Whether the client supports media processors, like video filters.
 *
 * <p>
 * The following example enables the background blur filter, if supported
 * by the client:
 * <pre>
 * // Add background blur, if supported
 * if (OT.hasMediaProcessorSupport()) {
 *   publisherOptions.videoFilter = {
 *     type: 'backgroundBlur',
 *   };
 * }
 *
 * const publisher = OT.initPublisher(publisherOptions);
 * </pre>
 *
 * @return {Boolean} Whether the client supports media processors (<code>true</code>), like
 * video filters, or not (<code>false</code>).
 *
 * @method OT.hasMediaProcessorSupport
 * @memberof OT
 *
 * @see <a href="#initPublisher">OT.initPublisher()</a>
 * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
 */ module1.exports = isSupported;
        /***/ },
        /* 751 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            const _require = __webpack_require__(24)(), getInputMediaDevices = _require.getInputMediaDevices;
            /**
 * Enumerates the audio input devices (such as microphones) and video input devices
 * (cameras) available to the browser.
 * <p>
 * The array of devices is passed in as the <code>devices</code> parameter of
 * the <code>callback</code> function passed into the method.
 *
 * @param callback {Function} The callback function invoked when the list of devices
 * devices is available. This function takes two parameters:
 * <ul>
 *   <li><code>error</code> &mdash; This is set to an error object when
 *   there is an error in calling this method; it is set to <code>null</code>
 *   when the call succeeds.</li>
 *
 *   <li><p><code>devices</code> &mdash; An array of objects corresponding to
 *   available microphones and cameras. Each object has three properties: <code>kind</code>,
 *   <code>deviceId</code>, and <code>label</code>, each of which are strings.
 *   <p>
 *   The <code>kind</code> property is set to <code>"audioInput"</code> for audio input
 *   devices or <code>"videoInput"</code> for video input devices.
 *   <p>
 *   The <code>deviceId</code> property is a unique ID for the device. You can pass
 *   the <code>deviceId</code> in as the <code>audioSource</code> or <code>videoSource</code>
 *   property of the <code>options</code> parameter of the
 *   <a href="#initPublisher">OT.initPublisher()</a> method.
 *   <p>
 *   The <code>label</code> property identifies the device. The <code>label</code>
 *   property is set to an empty string if the user has not previously granted access to
 *   a camera and microphone.</li>
 * </ul>
 * <i>Note:</i> The browser may limit the number of returned audio and video input devices
 * to one each before the user has granted access to a camera or microphone.
 *
 * @see <a href="#initPublisher">OT.initPublisher()</a>
 * @method OT.getDevices
 * @memberof OT
 */ module1.exports = function getDevices(callback) {
                getInputMediaDevices().then((devices)=>callback(undefined, devices), callback);
            };
        /***/ },
        /* 752 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            /* eslint-disable global-require */ module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const _ref = deps.deviceHelpers || __webpack_require__(24)(), hasAudioOutputApiSupport = _ref.hasAudioOutputApiSupport, hasDevice = _ref.hasDevice;
                const getAudioOutputDevices = deps.getAudioOutputDevices || __webpack_require__(326);
                const updateSubscribersSinkId = deps.updateSubscribersSinkId || __webpack_require__(328);
                const otError = __webpack_require__(13)();
                const Errors = __webpack_require__(6);
                /**
   * Sets the new audio output device.
   * <p>
   *   The method returns a Promise which resolves when the operation completes
   *   successfully. If there is an error, the promise is rejected.
   * </p>
   *
   * @see <a href="#getAudioOutputDevices">OT.getAudioOutputDevices()</a>
   * @see <a href="#getActiveAudioOutputDevice">OT.getActiveAudioOutputDevice()</a>
   * @method OT.setAudioOutputDevice
   * @memberof OT
   * @return {Promise} A promise that resolves when the operation completes successfully.
   * If there is an error, the promise is rejected.
   */ const setAudioOutputDevice = /*#__PURE__*/ function() {
                    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(deviceId) {
                        var devices, isValidDevice;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (hasAudioOutputApiSupport()) {
                                        _context.next = 2;
                                        break;
                                    }
                                    throw otError(Errors.UNSUPPORTED_BROWSER, new Error('setAudioOutputDevice is not supported in your browser.'));
                                case 2:
                                    _context.next = 4;
                                    return getAudioOutputDevices();
                                case 4:
                                    devices = _context.sent;
                                    isValidDevice = hasDevice(devices, deviceId);
                                    if (isValidDevice) {
                                        _context.next = 8;
                                        break;
                                    }
                                    throw otError(Errors.INVALID_AUDIO_OUTPUT_SOURCE, new Error('The requested device is not valid.'));
                                case 8:
                                    _context.prev = 8;
                                    _context.next = 11;
                                    return updateSubscribersSinkId(deviceId);
                                case 11:
                                    _context.next = 16;
                                    break;
                                case 13:
                                    _context.prev = 13;
                                    _context.t0 = _context["catch"](8);
                                    throw otError(Errors.REQUESTED_DEVICE_PERMISSION_DENIED, new Error('No permission to use the requested device.'));
                                case 16:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                8,
                                13
                            ]
                        ]);
                    }));
                    return function setAudioOutputDevice(_x) {
                        return _ref2.apply(this, arguments);
                    };
                }();
                return setAudioOutputDevice;
            };
        /***/ },
        /* 753 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            const audioOutputDevicesChangeHandler = __webpack_require__(754)();
            const _require = __webpack_require__(24)(), hasAudioOutputApiSupport = _require.hasAudioOutputApiSupport, getNativeMediaDevices = _require.getNativeMediaDevices;
            module1.exports = ()=>{
                // In order to keep the current device ID synchronized, let's listen to the device change event
                if (hasAudioOutputApiSupport()) {
                    const mediaDevices = getNativeMediaDevices();
                    let isProcessing = false;
                    mediaDevices.addEventListener('devicechange', /*#__PURE__*/ (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (!isProcessing) {
                                        _context.next = 2;
                                        break;
                                    }
                                    return _context.abrupt("return");
                                case 2:
                                    isProcessing = true;
                                    _context.next = 5;
                                    return audioOutputDevicesChangeHandler();
                                case 5:
                                    isProcessing = false;
                                case 6:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    })));
                }
            };
        /***/ },
        /* 754 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _interopRequireDefault = __webpack_require__(1);
            var _regenerator = _interopRequireDefault(__webpack_require__(4));
            var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(5));
            /* eslint-disable global-require */ module1.exports = function(deps) {
                if (deps === void 0) deps = {};
                const _ref = deps.deviceHelpers || __webpack_require__(24)(), getAudioOutputMediaDevices = _ref.getAudioOutputMediaDevices, getDefaultAudioOutputDeviceId = _ref.getDefaultAudioOutputDeviceId, hasDevice = _ref.hasDevice;
                const _ref2 = deps.currentAudioOutputDevice || __webpack_require__(105), getCurrentAudioOutputDeviceId = _ref2.getCurrentAudioOutputDeviceId, setCurrentAudioOutputDeviceId = _ref2.setCurrentAudioOutputDeviceId;
                const updateSubscribersSinkId = deps.updateSubscribersSinkId || __webpack_require__(328);
                const logging = deps.logging || __webpack_require__(2)('currentAudioOutputDevice');
                const audioOutputDevicesChangeHandler = /*#__PURE__*/ function() {
                    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee() {
                        var devices, isStillConnected, defaultDeviceId;
                        return _regenerator.default.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return getAudioOutputMediaDevices();
                                case 2:
                                    devices = _context.sent;
                                    if (!(devices.length === 0)) {
                                        _context.next = 6;
                                        break;
                                    }
                                    setCurrentAudioOutputDeviceId('');
                                    return _context.abrupt("return");
                                case 6:
                                    isStillConnected = hasDevice(devices, getCurrentAudioOutputDeviceId());
                                    if (!isStillConnected) {
                                        _context.next = 9;
                                        break;
                                    }
                                    return _context.abrupt("return");
                                case 9:
                                    // Since the current output device was removed, let's use the default device.
                                    defaultDeviceId = getDefaultAudioOutputDeviceId(devices);
                                    setCurrentAudioOutputDeviceId(defaultDeviceId); // Update the current audio output device ID
                                    _context.prev = 11;
                                    _context.next = 14;
                                    return updateSubscribersSinkId(defaultDeviceId);
                                case 14:
                                    _context.next = 19;
                                    break;
                                case 16:
                                    _context.prev = 16;
                                    _context.t0 = _context["catch"](11);
                                    logging.debug('Failed to set the default audio output device.', _context.t0);
                                case 19:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, null, [
                            [
                                11,
                                16
                            ]
                        ]);
                    }));
                    return function audioOutputDevicesChangeHandler() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                return audioOutputDevicesChangeHandler;
            };
        /***/ }
    ]);
});

});



parcelRegister("jaGaz", function(module, exports) {

$parcel$export(module.exports, "watchPublishToWebRTCSessionAsync", () => $7b07391f4975ee79$export$5972dd8cb19c6f5a);
$parcel$export(module.exports, "watchUnpublishFromWebRTCSession", () => $7b07391f4975ee79$export$5d6080dce11805ed);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $efsoN = parcelRequire("efsoN");
function* $7b07391f4975ee79$export$7df16cd52fd49cbd(action) {
    try {
        const publisher = yield (0, $k6WuE.O)((0, $g7GJo.publishToSession), action.payload.session, action.payload.containerRef, action.payload.options, action.payload.eventHandlers);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_SUCCESS,
            payload: publisher
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error publishing to session", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_ERROR, error, "publishToWebRTCSessionError");
    }
}
function* $7b07391f4975ee79$export$5972dd8cb19c6f5a() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).PUBLISH_TO_WEB_RTC_SESSION_ASYNC_PENDING, $7b07391f4975ee79$export$7df16cd52fd49cbd);
}
function* $7b07391f4975ee79$export$3bbc933e1d2d17a(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.unpublishFromSession), action.payload.session, action.payload.publisher);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).UNPUBLISH_FROM_WEB_RTC_SESSION_SUCCESS
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error publishing to session", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).UNPUBLISH_FROM_WEB_RTC_SESSION_ERROR, error, "unpublishFromWebRTCSessionError");
    }
}
function* $7b07391f4975ee79$export$5d6080dce11805ed() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).UNPUBLISH_FROM_WEB_RTC_SESSION_PENDING, $7b07391f4975ee79$export$3bbc933e1d2d17a);
}

});

parcelRegister("9K2yN", function(module, exports) {

$parcel$export(module.exports, "watchPublishScreenToWebRTCSessionAsync", () => $87267cc16ac31438$export$fa2cb4a05e1526ad);
$parcel$export(module.exports, "watchStopPublishScreenToWebRTCSessionAsync", () => $87267cc16ac31438$export$5b061e79388dae0a);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");
function* $87267cc16ac31438$export$13611644da1d0aa4(action) {
    try {
        const publisher = yield (0, $k6WuE.O)((0, $g7GJo.publishScreenToSession), action.payload.session, action.payload.containerRef, action.payload.options, action.payload.eventHandlers);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS,
            payload: publisher
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "publishScreenToWebRTCSessionError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $87267cc16ac31438$export$fa2cb4a05e1526ad() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING, $87267cc16ac31438$export$13611644da1d0aa4);
}
function* $87267cc16ac31438$export$6431d09a3175b80b(action) {
    try {
        const publisher = yield (0, $k6WuE.O)((0, $g7GJo.stopPublishScreenToSession), action.payload.session, action.payload.publisher);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_SUCCESS,
            payload: publisher
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "stopPublishScreenToWebRTCSessionError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $87267cc16ac31438$export$5b061e79388dae0a() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).STOP_PUBLISH_SCREEN_TO_WEB_RTC_SESSION_ASYNC_PENDING, $87267cc16ac31438$export$6431d09a3175b80b);
}

});

parcelRegister("2Bnvt", function(module, exports) {

$parcel$export(module.exports, "watchSubscribeToWebRTCStreamAsync", () => $171b8d738acf8ad0$export$c75abbb7e1502d5);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $efsoN = parcelRequire("efsoN");
function* $171b8d738acf8ad0$export$95a08e0f28a9078d(action) {
    try {
        const subscriber = yield (0, $k6WuE.O)((0, $g7GJo.subscribeToStream), action.payload.session, action.payload.stream, action.payload.containerRef, action.payload.options);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_SUCCESS,
            payload: subscriber
        });
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_ERROR, error, "subscribeToWebRTCStreamError");
    }
}
function* $171b8d738acf8ad0$export$c75abbb7e1502d5() {
    yield (0, $2AbXc.takeEvery)((0, $5ng6u.WebRTCActionTypes).SUBSCRIBE_TO_WEB_RTC_STREAM_ASYNC_PENDING, $171b8d738acf8ad0$export$95a08e0f28a9078d);
}

});

parcelRegister("bliaq", function(module, exports) {

$parcel$export(module.exports, "watchToggleWebRTCPublishAudioAsync", () => $11b5ef2dd896a838$export$d1c8a9fe0c48d88d);
$parcel$export(module.exports, "watchGetWebRTCAudioDevicesAsync", () => $11b5ef2dd896a838$export$ee2f752806a860bc);
$parcel$export(module.exports, "watchSetWebRTCAudioSourceAsync", () => $11b5ef2dd896a838$export$7452ebb24584a2c1);
$parcel$export(module.exports, "watchGetWebRTCAudioSourceAsync", () => $11b5ef2dd896a838$export$449b25fe22f82f01);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $efsoN = parcelRequire("efsoN");
function* $11b5ef2dd896a838$export$38aee7a48e9f30aa(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.togglePublisherAudio), action.payload.publisher, action.payload.isSharingAudio);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_AUDIO_SUCCESS
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error on toggling audio", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_AUDIO_ERROR, error, "publishWebRTCAudioError");
    }
}
function* $11b5ef2dd896a838$export$d1c8a9fe0c48d88d() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_AUDIO_PENDING, $11b5ef2dd896a838$export$38aee7a48e9f30aa);
}
function* $11b5ef2dd896a838$export$54e875e32e0537f4(_action) {
    try {
        const devices = yield (0, $k6WuE.O)((0, $g7GJo.getAudioDevices));
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_SUCCESS,
            payload: {
                devices: devices
            }
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error getting audio devices", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_ERROR, error, "getWebRTCAudioDevicesError");
    }
}
function* $11b5ef2dd896a838$export$ee2f752806a860bc() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_DEVICES_PENDING, $11b5ef2dd896a838$export$54e875e32e0537f4);
}
function* $11b5ef2dd896a838$export$7033767e9324c617(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.setAudioSource), action.payload.publisher, action.payload.deviceId);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).SET_WEB_RTC_AUDIO_SOURCE_SUCCESS,
            payload: {
                deviceId: action.payload.deviceId
            }
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error setting audio source", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).SET_WEB_RTC_AUDIO_SOURCE_ERROR, error, "setWebRTCAudioSourceError");
    }
}
function* $11b5ef2dd896a838$export$7452ebb24584a2c1() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).SET_WEB_RTC_AUDIO_SOURCE_PENDING, $11b5ef2dd896a838$export$7033767e9324c617);
}
function* $11b5ef2dd896a838$export$a39f23fa154a7e47(action) {
    try {
        const device = yield (0, $k6WuE.O)((0, $g7GJo.getAudioSource), action.payload.publisher);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_SOURCE_SUCCESS,
            payload: {
                device: device
            }
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error getting audio source", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_SOURCE_ERROR, error, "getWebRTCAudioSourceError");
    }
}
function* $11b5ef2dd896a838$export$449b25fe22f82f01() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).GET_WEB_RTC_AUDIO_SOURCE_PENDING, $11b5ef2dd896a838$export$a39f23fa154a7e47);
}

});

parcelRegister("fmC5S", function(module, exports) {

$parcel$export(module.exports, "watchToggleWebRTCPublishVideoAsync", () => $1a3a1b7f491258cf$export$e5bbaa31f39c899);
$parcel$export(module.exports, "watchCycleWebRTCVideoSourceAsync", () => $1a3a1b7f491258cf$export$f605df01bf642d80);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ng6u = parcelRequire("5ng6u");

var $g7GJo = parcelRequire("g7GJo");

var $efsoN = parcelRequire("efsoN");
function* $1a3a1b7f491258cf$export$69044bc8ce88c8e7(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.togglePublisherVideo), action.payload.publisher, action.payload.isSharingVideo);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_VIDEO_SUCCESS
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error publishing video", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_VIDEO_ERROR, error, "publishWebRTCVideoError");
    }
}
function* $1a3a1b7f491258cf$export$e5bbaa31f39c899() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).TOGGLE_WEB_RTC_PUBLISHER_VIDEO_PENDING, $1a3a1b7f491258cf$export$69044bc8ce88c8e7);
}
function* $1a3a1b7f491258cf$export$5c16d1ac6be560f8(action) {
    try {
        yield (0, $k6WuE.O)((0, $g7GJo.cycleVideoSource), action.payload.publisher);
        yield (0, $k6WuE.Z)({
            type: (0, $5ng6u.WebRTCActionTypes).CYCLE_WEB_RTC_VIDEO_SOURCE_SUCCESS
        });
    } catch (error) {
        yield (0, $efsoN.logError)("error cycling video media", error);
        yield (0, $efsoN.handleError)((0, $5ng6u.WebRTCActionTypes).CYCLE_WEB_RTC_VIDEO_SOURCE_ERROR, error, "cycleWebRTCVideoSourceError");
    }
}
function* $1a3a1b7f491258cf$export$f605df01bf642d80() {
    yield (0, $2AbXc.takeLeading)((0, $5ng6u.WebRTCActionTypes).CYCLE_WEB_RTC_VIDEO_SOURCE_PENDING, $1a3a1b7f491258cf$export$5c16d1ac6be560f8);
}

});

parcelRegister("4a4o1", function(module, exports) {

$parcel$export(module.exports, "watchFetchSpecialtiesAsync", () => $312943c155511cdd$export$251814dd41399e04);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $5yBCT = parcelRequire("5yBCT");
function* $312943c155511cdd$var$fetchSpecialtiesAsync(_action) {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/specialties", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.specialtySchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $312943c155511cdd$export$251814dd41399e04() {
    yield (0, $2AbXc.takeLeading)((0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_PENDING, $312943c155511cdd$var$fetchSpecialtiesAsync);
}

});

parcelRegister("gGw13", function(module, exports) {

$parcel$export(module.exports, "signinWatchers", () => $3e4db0e587031dfb$export$86ad40cbc4b59201);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $jSDfI = parcelRequire("jSDfI");

var $lnXep = parcelRequire("lnXep");

var $k0jcd = parcelRequire("k0jcd");

var $6ye6I = parcelRequire("6ye6I");

var $1zizz = parcelRequire("1zizz");
function* $3e4db0e587031dfb$export$86ad40cbc4b59201() {
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_PENDING, $3e4db0e587031dfb$export$f2b225977e783c02);
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_PENDING, $3e4db0e587031dfb$export$d846157fd2c1e688);
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).USER_SIGN_IN_TYPE_ASYNC_PENDING, $3e4db0e587031dfb$export$892ffea13a8221f3);
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).SIGN_IN_SWAP_OAUTH_TOKEN, $3e4db0e587031dfb$export$570c039fb3303d41);
}
function* $3e4db0e587031dfb$export$f2b225977e783c02(action) {
    try {
        const body = {
            user: {
                email: action.payload.email,
                password: action.payload.password
            }
        };
        // sending this with auth headers to get the clientId
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/signin/", body, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.user, (0, $k0jcd.userSchema));
        const token = response.headers.authorization.split(" ")[1];
        const user = response.data.user;
        (0, $jSDfI.setSession)(token, user.id, user.email);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_SUCCESS,
            payload: {
                session: {
                    id: response.data.id,
                    apiToken: token
                },
                user: normalizedResponse
            }
        });
    // ToDo:
    // If details are missing: send user to "Complete account page",
    // If T&C not agreed: send user to "T&C page"
    // Else: send user to "MEETINGS page" (Dashboard)
    } catch (error) {
        console.error(error);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_ERROR,
            payload: error
        });
        const errorInstance = error;
        if (errorInstance.response.status === 401) yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "unauthorizedSignInAttempt",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $3e4db0e587031dfb$export$570c039fb3303d41() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/session/swap_token", null, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.user, (0, $k0jcd.userSchema));
        const token = response.headers.authorization.split(" ")[1];
        const user = response.data.user;
        (0, $jSDfI.setSession)(token, user.id, user.email);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_SUCCESS,
            payload: {
                session: {
                    id: response.data.id,
                    apiToken: token
                },
                user: normalizedResponse
            }
        });
    // ToDo:
    // If details are missing: send user to "Complete account page",
    // If T&C not agreed: send user to "T&C page"
    // Else: send user to "MEETINGS page" (Dashboard)
    } catch (error) {
        console.error(error);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_ERROR,
            payload: error
        });
        const errorInstance = error;
        if (errorInstance.response.status === 401) yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "unauthorizedSignInAttempt",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $3e4db0e587031dfb$export$d846157fd2c1e688(_action) {
    console.log("signing user out");
    try {
        (0, $jSDfI.clearSession)();
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_SUCCESS
        });
    } catch (_error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_ERROR
        });
    }
}
function* $3e4db0e587031dfb$export$892ffea13a8221f3(action) {
    try {
        const response = yield (0, $5s7Tw.default).post("/user/type", {
            email: action.payload
        });
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).USER_SIGN_IN_TYPE_ASYNC_SUCCESS,
            payload: {
                ...response.data
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).USER_SIGN_IN_TYPE_ASYNC_ERROR,
            payload: error
        });
    }
}

});

parcelRegister("b1nhW", function(module, exports) {

$parcel$export(module.exports, "watchSetPasswordAsync", () => $72ecd5332fd58f4d$export$e670f65a32d875d7);
$parcel$export(module.exports, "watchSendResetPasswordLinkAsync", () => $72ecd5332fd58f4d$export$75d6c02d9ca28c74);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");

var $lnXep = parcelRequire("lnXep");
function* $72ecd5332fd58f4d$export$98f6e1e4da382e08(action) {
    try {
        const setPasswordData = {
            user: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, "/set_password", setPasswordData);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SET_PASSWORD_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "setPasswordSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).SIGN_IN);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SET_PASSWORD_ASYNC_ERROR,
            payload: error
        });
        const errorInstance = error;
        const data = errorInstance.response?.data;
        if (errorInstance.response?.status == 404 && data) {
            if (data.error == "token expired") yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
                messageKey: "resetTokenExpired",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
            if (data.error == "token invalid") yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
                messageKey: "resetTokenInvalid",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        } else yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "setPasswordFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $72ecd5332fd58f4d$export$e670f65a32d875d7() {
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).SET_PASSWORD_ASYNC_PENDING, $72ecd5332fd58f4d$export$98f6e1e4da382e08);
}
function* $72ecd5332fd58f4d$export$cd1e3e297c8a82cc(action) {
    try {
        const resetPasswordData = {
            user: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/send_reset_password_link", resetPasswordData);
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SEND_RESET_PASSWORD_LINK_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "sendResetPasswordLinkSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).SIGN_IN);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).SEND_RESET_PASSWORD_LINK_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "sendResetPasswordLinkFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $72ecd5332fd58f4d$export$75d6c02d9ca28c74() {
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).SEND_RESET_PASSWORD_LINK_ASYNC_PENDING, $72ecd5332fd58f4d$export$cd1e3e297c8a82cc);
}

});

parcelRegister("lNBNb", function(module, exports) {

$parcel$export(module.exports, "watchFetchUsersAsync", () => $eceae6025f6f4744$export$76036ee6872a4ff3);
$parcel$export(module.exports, "watchFetchAllUsers", () => $eceae6025f6f4744$export$4a946f4a78ee25c9);

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $cX1nf = parcelRequire("cX1nf");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $3Ukkm = parcelRequire("3Ukkm");

var $5ofNJ = parcelRequire("5ofNJ");
function* $eceae6025f6f4744$export$870cc4a0f49d0ff6(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/users?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.userSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                searchTerm: response.data.searchQuery.searchTerm,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                appliedFilters: response.data.searchQuery.appliedFilters,
                orderBy: response.data.searchQuery.orderBy
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "usersNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $eceae6025f6f4744$export$76036ee6872a4ff3() {
    yield (0, $2AbXc.takeLeading)((0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_PENDING, $eceae6025f6f4744$export$870cc4a0f49d0ff6);
}
function* $eceae6025f6f4744$export$beac2bb3153ee93d() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/users/all", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.userSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $eceae6025f6f4744$export$4a946f4a78ee25c9() {
    yield (0, $2AbXc.takeLeading)((0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_PENDING, $eceae6025f6f4744$export$beac2bb3153ee93d);
}

});

parcelRegister("aTJFr", function(module, exports) {

$parcel$export(module.exports, "watchUserActions", () => $e8dafefa8b03775f$export$b066a7d182ffbd40);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $8e5HJ = parcelRequire("8e5HJ");

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $1zizz = parcelRequire("1zizz");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");

var $8eh8V = parcelRequire("8eh8V");

var $efsoN = parcelRequire("efsoN");

var $6lvMC = parcelRequire("6lvMC");
function* $e8dafefa8b03775f$export$b066a7d182ffbd40() {
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_PENDING, $e8dafefa8b03775f$export$88a546ec116dc5dc);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).CREATE_GUEST_USER_ASYNC_PENDING, $e8dafefa8b03775f$export$d16601ad13f3e8af);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).ADD_USER_TO_TENANT_ASYNC_PENDING, $e8dafefa8b03775f$export$75af6fc5e301f33f);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).SET_TENANT_ASYNC_PENDING, $e8dafefa8b03775f$export$ef118d598955363a);
    yield (0, $2AbXc.takeEvery)((0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_PENDING, $e8dafefa8b03775f$export$d84f0a013434681d);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).UPDATE_USER_ASYNC_PENDING, $e8dafefa8b03775f$export$fb56416579e053f5);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).CHANGE_PASSWORD_ASYNC_PENDING, $e8dafefa8b03775f$export$38ebefa61ed657e9);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).FETCH_CURRENT_USER_ASYNC_PENDING, $e8dafefa8b03775f$export$f87331d799524277);
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_PENDING, $e8dafefa8b03775f$export$7d976b1829c282e8);
}
function* $e8dafefa8b03775f$export$88a546ec116dc5dc(action) {
    const user = {
        user: action.payload
    };
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/users", user, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_SUCCESS, response.data, "createUserSuccess");
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).USERS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_ERROR, error, "createUserFail");
    }
}
function* $e8dafefa8b03775f$export$d16601ad13f3e8af(action) {
    const user = {
        user: action.payload.guestUserData
    };
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/guest_users", user, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_SUCCESS, response.data, "createUserSuccess");
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).USERS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_ERROR, error, "createUserFail");
    }
}
function* $e8dafefa8b03775f$export$75af6fc5e301f33f(action) {
    try {
        // we don't need to handle the response: as long as it was a success, we
        // redirect to the user inde page which will reload the users regardless
        yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/tenant_users", action.payload, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).USERS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).CREATE_USER_ASYNC_ERROR, error, "addUserToTenantFail");
    }
}
function* $e8dafefa8b03775f$export$d84f0a013434681d(action) {
    try {
        const userId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/users/${userId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.userSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "userNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e8dafefa8b03775f$export$f87331d799524277() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/users/current", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.userSchema));
        // this saga actually hooks into the normal FETCH_USER_ASYNC_SUCCESS
        // reducers as it is returning the same data.
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).FETCH_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "userNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e8dafefa8b03775f$export$fb56416579e053f5(action) {
    const user = {
        user: action.payload.user
    };
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/users/${action.payload.id}`, user, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $8e5HJ.UserActionTypes).UPDATE_USER_ASYNC_SUCCESS, response.data, "updateUserSuccess");
        const abilities = yield (0, $k6WuE.a4)((0, $6lvMC.getCurrentUserAbilities));
        if (abilities.user.canList) yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).USERS);
        else yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).MEETINGS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).UPDATE_USER_ASYNC_ERROR, error, "updateUserFail");
    }
}
function* $e8dafefa8b03775f$export$38ebefa61ed657e9(action) {
    const user = {
        user: action.payload.user
    };
    try {
        yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/users/${action.payload.id}/change_password`, user, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $8e5HJ.UserActionTypes).CHANGE_PASSWORD_ASYNC_SUCCESS, {}, "changePasswordSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).CHANGE_PASSWORD_ASYNC_ERROR, error, "changePasswordFail");
    }
}
function* $e8dafefa8b03775f$export$ef118d598955363a(action) {
    try {
        yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/user/set_tenant/${action.payload.id}`, {}, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).SET_TENANT_ASYNC_SUCCESS
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "switchedTenant",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.Z)((0, $8eh8V.fetchTenantConfigAsync)());
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, action.payload.path || (0, $6QJY8.RoutePaths).MEETINGS);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).SET_TENANT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "switchTenantFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e8dafefa8b03775f$export$7d976b1829c282e8() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/users/find_external", (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $8e5HJ.UserActionTypes).FETCH_EXTERNAL_ACCOUNTS_ASYNC_ERROR, error);
    }
}

});

parcelRegister("huqcL", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseAsync", () => $7b1433274a013088$export$a1d564c963d735a0);
$parcel$export(module.exports, "watchUpdateCaseAsync", () => $7b1433274a013088$export$ba1d660b8dc1391e);
$parcel$export(module.exports, "watchUpdateCaseMembersAsync", () => $7b1433274a013088$export$aef5f8402c3a268);
$parcel$export(module.exports, "watchToggleCaseLockedAsync", () => $7b1433274a013088$export$5442bdaeec7d9ec9);
$parcel$export(module.exports, "watchCaseCableActions", () => $7b1433274a013088$export$cebff925ae5ba7e5);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $6qYxq = parcelRequire("6qYxq");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");

var $COwA0 = parcelRequire("COwA0");

var $efsoN = parcelRequire("efsoN");

var $7HZDe = parcelRequire("7HZDe");

var $2usJc = parcelRequire("2usJc");
function* $7b1433274a013088$export$434a8e3d81902c0e(action) {
    try {
        const caseId = action.payload;
        const normalizedResponse = yield (0, $efsoN.getNormalisedSingle)(`/cases/${caseId}`, (0, $k0jcd.fetchCaseSchema));
        yield (0, $efsoN.handleSuccess)((0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_SUCCESS, normalizedResponse);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_ERROR, error, "caseNotFound");
    }
}
function* $7b1433274a013088$export$a1d564c963d735a0() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_PENDING, $7b1433274a013088$export$434a8e3d81902c0e);
}
function* $7b1433274a013088$export$15f5aaa019a23273(action) {
    try {
        const data = {
            case: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/cases/${action.payload.id}`, data, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCaseSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const route = response.data.permissions.canRead ? (0, $6QJY8.RoutePaths).CASE : (0, $6QJY8.RoutePaths).CASES;
        const caseUrl = (0, $COwA0.generatePath)(route, {
            caseId: action.payload.id
        });
        yield (0, $1l1FS.default).push(caseUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCaseFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $7b1433274a013088$export$ba1d660b8dc1391e() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseActionTypes).UPDATE_CASE_ASYNC_PENDING, $7b1433274a013088$export$15f5aaa019a23273);
}
function* $7b1433274a013088$export$183e319bb8d58828(action) {
    try {
        const caseId = action.payload.id;
        const data = {
            case: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/cases/${action.payload.id}`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchCaseSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_MEMBERS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCaseMembersSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const route = response.data.permissions.canRead ? (0, $6QJY8.RoutePaths).CASE : (0, $6QJY8.RoutePaths).CASES;
        const caseUrl = (0, $COwA0.generatePath)(route, {
            caseId: action.payload.id
        });
        yield (0, $1l1FS.default).push(caseUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_MEMBERS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCaseMembersFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $7b1433274a013088$export$aef5f8402c3a268() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseActionTypes).UPDATE_CASE_MEMBERS_ASYNC_PENDING, $7b1433274a013088$export$183e319bb8d58828);
}
function* $7b1433274a013088$export$70c01fcc67c2599d(action) {
    try {
        const caseId = action.payload.id;
        const url = action.payload.locked ? `/cases/${caseId}/lock` : `/cases/${caseId}/unlock`;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, url, {}, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchCaseSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).TOGGLE_CASE_LOCKED_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: action.payload.locked ? "lockCaseSuccess" : "unlockCaseSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).TOGGLE_CASE_LOCKED_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: action.payload.locked ? "lockCaseFail" : "unlockCaseFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $7b1433274a013088$export$5442bdaeec7d9ec9() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseActionTypes).TOGGLE_CASE_LOCKED_ASYNC_PENDING, $7b1433274a013088$export$70c01fcc67c2599d);
}
function* $7b1433274a013088$export$711a3f4b514d5371(action) {
    if (yield (0, $efsoN.checkCurrentUser)(action.payload)) return;
    yield (0, $k6WuE.Z)((0, $7HZDe.fetchCaseAssetsAction)(action.payload.caseId));
}
function* $7b1433274a013088$export$87801667ec84c54e(action) {
    if (yield (0, $efsoN.checkCurrentUser)(action.payload)) return;
    yield (0, $k6WuE.Z)((0, $2usJc.fetchCaseAction)(action.payload.caseId));
}
function* $7b1433274a013088$export$cebff925ae5ba7e5() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseCableActionTypes).ASSETS_CHANGED, $7b1433274a013088$export$711a3f4b514d5371);
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseCableActionTypes).MEMBERS_CHANGED, $7b1433274a013088$export$87801667ec84c54e);
}

});
parcelRegister("2usJc", function(module, exports) {

$parcel$export(module.exports, "fetchCaseAction", () => $5b4c1f6999ffd998$export$d75891d30aed2c6d);
$parcel$export(module.exports, "updateCase", () => $5b4c1f6999ffd998$export$9849da1ee3e78320);
$parcel$export(module.exports, "updateCaseMembers", () => $5b4c1f6999ffd998$export$dff8f524ce1c8388);
$parcel$export(module.exports, "toggleCaseLocked", () => $5b4c1f6999ffd998$export$b8dedf8944caa9e);

var $6qYxq = parcelRequire("6qYxq");
const $5b4c1f6999ffd998$export$d75891d30aed2c6d = (caseId)=>{
    return {
        type: (0, $6qYxq.CaseActionTypes).FETCH_CASE_ASYNC_PENDING,
        payload: caseId
    };
};
const $5b4c1f6999ffd998$export$9849da1ee3e78320 = (caseData)=>{
    return {
        type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_ASYNC_PENDING,
        payload: caseData
    };
};
const $5b4c1f6999ffd998$export$dff8f524ce1c8388 = (caseData)=>{
    return {
        type: (0, $6qYxq.CaseActionTypes).UPDATE_CASE_MEMBERS_ASYNC_PENDING,
        payload: caseData
    };
};
const $5b4c1f6999ffd998$export$b8dedf8944caa9e = (caseData)=>{
    return {
        type: (0, $6qYxq.CaseActionTypes).TOGGLE_CASE_LOCKED_ASYNC_PENDING,
        payload: caseData
    };
};

});


parcelRegister("g65S5", function(module, exports) {

$parcel$export(module.exports, "meetingWatchers", () => $ce4fdbb008c64a99$export$974cf202e4b4dca0);
$parcel$export(module.exports, "meetingChannelWatchers", () => $ce4fdbb008c64a99$export$48ba933ea0b6bf9c);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $COwA0 = parcelRequire("COwA0");

var $32kQ2 = parcelRequire("32kQ2");

var $k0jcd = parcelRequire("k0jcd");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $4Z6GL = parcelRequire("4Z6GL");

var $efsoN = parcelRequire("efsoN");
function* $ce4fdbb008c64a99$export$974cf202e4b4dca0() {
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_PENDING, $ce4fdbb008c64a99$export$a3a55794756bffbb);
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).CREATE_MEETING_ASYNC_PENDING, $ce4fdbb008c64a99$export$d3304ba4457a9102);
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_PENDING, $ce4fdbb008c64a99$export$b4a8c370aa1d18d6);
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).END_MEETING_ASYNC_PENDING, $ce4fdbb008c64a99$export$64f393aaa35cb44f);
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingActionTypes).CANCEL_MEETING_ASYNC_PENDING, $ce4fdbb008c64a99$export$cb12f8ad6feece5f);
}
function* $ce4fdbb008c64a99$export$48ba933ea0b6bf9c() {
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingCableActionTypes).MEETING_CASES_CHANGED, $ce4fdbb008c64a99$export$27518a6be6f13442);
    yield (0, $2AbXc.takeLeading)((0, $32kQ2.MeetingCableActionTypes).MEETING_USERS_CHANGED, $ce4fdbb008c64a99$export$27518a6be6f13442);
}
function* $ce4fdbb008c64a99$export$a3a55794756bffbb(action) {
    try {
        const meetingId = action.payload;
        const normalizedData = yield (0, $k6WuE.O)((0, $efsoN.getNormalisedSingle), `/meetings/${meetingId}`, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $efsoN.handleSuccess)((0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_SUCCESS, normalizedData);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $32kQ2.MeetingActionTypes).FETCH_MEETING_ASYNC_ERROR, error, "meetingNotFound");
    }
}
function* $ce4fdbb008c64a99$export$d3304ba4457a9102(action) {
    try {
        const meeting = {
            meeting: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $efsoN.postNormalisedSingle), `/meetings`, meeting);
        yield (0, $efsoN.handleSuccess)((0, $32kQ2.MeetingActionTypes).CREATE_MEETING_ASYNC_SUCCESS, response, "createMeetingSuccess");
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).MEETINGS);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $32kQ2.MeetingActionTypes).CREATE_MEETING_ASYNC_ERROR, error, "createMeetingFail");
    }
}
function* $ce4fdbb008c64a99$export$b4a8c370aa1d18d6(action) {
    try {
        const meeting = {
            meeting: action.payload.meeting
        };
        const response = yield (0, $k6WuE.O)((0, $efsoN.patchNormalisedSingle), `/meetings/${action.payload.id}`, meeting, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $efsoN.handleSuccess)((0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_SUCCESS, response, "updateMeetingSuccess");
        const viewMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
            meetingId: action.payload.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewMeetingUrl);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $32kQ2.MeetingActionTypes).UPDATE_MEETING_ASYNC_ERROR, error, "updateMeetingFail");
    }
}
function* $ce4fdbb008c64a99$export$64f393aaa35cb44f(action) {
    try {
        const meetingId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $efsoN.postNormalisedSingle), `/meetings/${meetingId}/end`, {}, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $efsoN.handleSuccess)((0, $32kQ2.MeetingActionTypes).END_MEETING_ASYNC_SUCCESS, response, "endMeetingSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $32kQ2.MeetingActionTypes).END_MEETING_ASYNC_ERROR, error, "endMeetingFail");
    }
}
function* $ce4fdbb008c64a99$export$cb12f8ad6feece5f(action) {
    try {
        const meetingId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $efsoN.postNormalisedSingle), `/meetings/${meetingId}/cancel`, {}, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $efsoN.handleSuccess)((0, $32kQ2.MeetingActionTypes).CANCEL_MEETING_ASYNC_SUCCESS, response, "cancelMeetingSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $32kQ2.MeetingActionTypes).CANCEL_MEETING_ASYNC_ERROR, error, "cancelMeetingFail");
    }
}
function* $ce4fdbb008c64a99$export$27518a6be6f13442(action) {
    if (yield (0, $efsoN.checkCurrentUser)(action.payload)) return;
    yield (0, $k6WuE.Z)((0, $4Z6GL.fetchMeetingAction)(action.payload.meetingId));
}

});

parcelRegister("eSI7x", function(module, exports) {

$parcel$export(module.exports, "watchCreateMeetingUser", () => $fcf9337bc56f26a0$export$da7e4bd17fd9ee67);
$parcel$export(module.exports, "watchUpdateMeetingUser", () => $fcf9337bc56f26a0$export$9d92a4158381248);
$parcel$export(module.exports, "watchDestroyMeetingUser", () => $fcf9337bc56f26a0$export$1f93c78772bea1fe);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $COwA0 = parcelRequire("COwA0");

var $5xpc0 = parcelRequire("5xpc0");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $1zizz = parcelRequire("1zizz");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");
function* $fcf9337bc56f26a0$export$66831ddf4caeaf25(action) {
    try {
        const meetingUser = {
            meetingUser: action.payload
        };
        // responds with the full meeting
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/meeting_users", meetingUser, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createMeetingUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
            meetingId: action.payload.meetingId
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewMeetingUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createMeetingUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $fcf9337bc56f26a0$export$da7e4bd17fd9ee67() {
    yield (0, $2AbXc.takeLeading)((0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_PENDING, $fcf9337bc56f26a0$export$66831ddf4caeaf25);
}
function* $fcf9337bc56f26a0$export$5483fc1435feb47d(action) {
    try {
        const meetingUser = {
            meetingUser: action.payload.meetingUser
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/meeting_users/${action.payload.id}`, meetingUser, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateMeetingUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
            meetingId: response.data.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewMeetingUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateMeetingUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $fcf9337bc56f26a0$export$9d92a4158381248() {
    yield (0, $2AbXc.takeLeading)((0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_PENDING, $fcf9337bc56f26a0$export$5483fc1435feb47d);
}
function* $fcf9337bc56f26a0$export$ea53c0714d83a989(action) {
    try {
        const meetingUserId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/meeting_users/${meetingUserId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMeetingSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "destroyMeetingUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
            meetingId: response.data.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewMeetingUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "destroyMeetingUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $fcf9337bc56f26a0$export$1f93c78772bea1fe() {
    yield (0, $2AbXc.takeLeading)((0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_PENDING, $fcf9337bc56f26a0$export$ea53c0714d83a989);
}

});

parcelRegister("8TRYc", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseClassificationAsync", () => $c2ac27cbfd5a99df$export$d6851df6290ca896);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $7k78k = parcelRequire("7k78k");

var $1zizz = parcelRequire("1zizz");
function* $c2ac27cbfd5a99df$var$fetchCaseClassificationAsync(_action) {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/case_classifications/", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.caseClassificationsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $c2ac27cbfd5a99df$export$d6851df6290ca896() {
    yield (0, $2AbXc.takeLeading)((0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_PENDING, $c2ac27cbfd5a99df$var$fetchCaseClassificationAsync);
}

});

parcelRegister("9CuVR", function(module, exports) {

$parcel$export(module.exports, "watchFetchPatientsAsync", () => $36c3656a7eba16f5$export$91a9bdf9a8575b4a);
$parcel$export(module.exports, "watchFetchAllPatientsAsync", () => $36c3656a7eba16f5$export$961e03a4c1bd1ef5);
$parcel$export(module.exports, "watchUploadPatientsCSVAsync", () => $36c3656a7eba16f5$export$12225fd1ae988f9d);

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $55aym = parcelRequire("55aym");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
function* $36c3656a7eba16f5$export$ab893d255ef12b88(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/patients?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.patientsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                searchTerm: response.data.searchQuery.searchTerm,
                orderBy: response.data.searchQuery.orderBy
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "patientsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $36c3656a7eba16f5$export$91a9bdf9a8575b4a() {
    yield (0, $2AbXc.takeLeading)((0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_PENDING, $36c3656a7eba16f5$export$ab893d255ef12b88);
}
function* $36c3656a7eba16f5$export$adc134529ab9ccd7() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/patients?paged=false", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.patientsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "patientsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $36c3656a7eba16f5$export$961e03a4c1bd1ef5() {
    yield (0, $2AbXc.takeLeading)((0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_PENDING, $36c3656a7eba16f5$export$adc134529ab9ccd7);
}
const $36c3656a7eba16f5$var$valuesToFormData = (values)=>{
    const data = new FormData();
    data.append("patients[file]", values.file);
    return data;
};
function* $36c3656a7eba16f5$export$364fabeafaf3428f(action) {
    try {
        const data = $36c3656a7eba16f5$var$valuesToFormData(action.payload);
        const config = (0, $1zizz.withAuthHeader)();
        config.headers["Content-Type"] = "multipart/form-data";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadStarted",
            type: (0, $jiIfA.UserMessageTypes).MESSAGE
        }));
        yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/patients/upload_csv`, data, config);
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).UPLOAD_PATIENTS_CSV_ASYNC_SUCCESS
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "csvUploadSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $55aym.PatientsActionTypes).UPLOAD_PATIENTS_CSV_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $36c3656a7eba16f5$export$12225fd1ae988f9d() {
    yield (0, $2AbXc.takeLeading)((0, $55aym.PatientsActionTypes).UPLOAD_PATIENTS_CSV_ASYNC_PENDING, $36c3656a7eba16f5$export$364fabeafaf3428f);
}

});

parcelRegister("cPJVX", function(module, exports) {

$parcel$export(module.exports, "watchFetchCasesAsync", () => $00eec0131c3f5bf8$export$cce1c79c73c74820);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $cCibL = parcelRequire("cCibL");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
const $00eec0131c3f5bf8$var$normalizeResponseToPayload = (response)=>{
    const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
        (0, $k0jcd.fetchCaseSchema)
    ]);
    return {
        all: normalizedResponse,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        appliedFilters: response.data.searchQuery.appliedFilters,
        resultsPerPage: response.data.searchQuery.resultsPerPage,
        searchTerm: response.data.searchQuery.searchTerm,
        orderBy: response.data.searchQuery.orderBy
    };
};
function* $00eec0131c3f5bf8$export$124f0758c3d555b9(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases?${query}`, (0, $1zizz.withAuthHeader)());
        const payload = $00eec0131c3f5bf8$var$normalizeResponseToPayload(response);
        yield (0, $k6WuE.Z)({
            type: (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_SUCCESS,
            payload: payload
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "casesNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $00eec0131c3f5bf8$export$cce1c79c73c74820() {
    yield (0, $2AbXc.takeLeading)((0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_PENDING, $00eec0131c3f5bf8$export$124f0758c3d555b9);
}

});

parcelRegister("kbbQX", function(module, exports) {

$parcel$export(module.exports, "watchCreateCommentAsync", () => $f350faecfb71e556$export$6716f1fb489834d5);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $7twpo = parcelRequire("7twpo");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $6j1K3 = parcelRequire("6j1K3");
function* $f350faecfb71e556$export$6686b2cd5a9da4d7(action) {
    const caseId = action.payload.caseId;
    const comment = action.payload.comment;
    const isDecision = comment.commentType === (0, $7twpo.CommentTypes).Decision;
    const data = {
        comment: comment
    };
    let messageKey;
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/comments`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        if (action.payload.meetingCaseId) yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
        messageKey = isDecision ? "createDecisionSuccess" : "createCommentSuccess";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: messageKey,
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_ERROR,
            payload: error
        });
        messageKey = isDecision ? "createDecisionFail" : "createCommentFail";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: messageKey,
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $f350faecfb71e556$export$6716f1fb489834d5() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).CREATE_CASE_COMMENT_ASYNC_PENDING, $f350faecfb71e556$export$6686b2cd5a9da4d7);
}

});

parcelRegister("iJhw3", function(module, exports) {

$parcel$export(module.exports, "watchUploadFileAsync", () => $a4facf413478b162$export$c01c7cbd03931c02);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $7twpo = parcelRequire("7twpo");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $6j1K3 = parcelRequire("6j1K3");
const $a4facf413478b162$var$valuesToFormData = (values)=>{
    const data = new FormData();
    // we need to manually ensure the case is correct, as the FormData object doesn't get
    // de-camelized automatically
    data.append("document[file]", values.file);
    data.append("document[name]", values.name);
    if (values.meetingCaseId) data.append("document[meeting_case_id]", values.meetingCaseId);
    return data;
};
function* $a4facf413478b162$export$bd9c1ac4ca1ef7f(action) {
    try {
        const caseId = action.payload.caseId;
        const data = $a4facf413478b162$var$valuesToFormData(action.payload.values);
        const config = (0, $1zizz.withAuthHeader)();
        // the upload can't be done with JSON, it needs this content type.
        config.headers["Content-Type"] = "multipart/form-data";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadStarted",
            type: (0, $jiIfA.UserMessageTypes).MESSAGE
        }));
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/documents`, data, config);
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.assetsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        if (action.payload.meetingCaseId) yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a4facf413478b162$export$c01c7cbd03931c02() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).UPLOAD_CASE_FILE_ASYNC_PENDING, $a4facf413478b162$export$bd9c1ac4ca1ef7f);
}

});

parcelRegister("8R3hK", function(module, exports) {

$parcel$export(module.exports, "watchFetchNotificationsAsync", () => $54e1c96d3fee0264$export$8bd9cbeea198beef);

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $9VqZS = parcelRequire("9VqZS");
function* $54e1c96d3fee0264$export$956a65647fc5b562(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/notifications?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.notificationsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                unreadCount: response.data.unreadCount
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "notificationsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $54e1c96d3fee0264$export$8bd9cbeea198beef() {
    yield (0, $2AbXc.takeLeading)((0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_PENDING, $54e1c96d3fee0264$export$956a65647fc5b562);
}

});

parcelRegister("6zGCD", function(module, exports) {

$parcel$export(module.exports, "watchFetchTermsAsync", () => $7e7b9747d35c113f$export$d69b677be3900d8c);
$parcel$export(module.exports, "watchAcceptTermsAsync", () => $7e7b9747d35c113f$export$a12f1e1f5aef615a);
parcelRequire("2AbXc");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $6QJY8 = parcelRequire("6QJY8");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $lnXep = parcelRequire("lnXep");

var $1l1FS = parcelRequire("1l1FS");
function* $7e7b9747d35c113f$export$d19948852bfd00d0() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/terms", (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).FETCH_TERMS_ASYNC_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).FETCH_TERMS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $7e7b9747d35c113f$export$d69b677be3900d8c() {
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).FETCH_TERMS_ASYNC_PENDING, $7e7b9747d35c113f$export$d19948852bfd00d0);
}
function* $7e7b9747d35c113f$export$7b6d21b5663caca4(action) {
    try {
        const body = {
            version: action.payload.version
        };
        yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, "/terms/", body, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).ACCEPT_TERMS_ASYNC_SUCCESS
        });
        yield (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).ROOT);
        yield window.location.reload();
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $lnXep.AccountActionTypes).ACCEPT_TERMS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "acceptTermsFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $7e7b9747d35c113f$export$a12f1e1f5aef615a() {
    yield (0, $2AbXc.takeLeading)((0, $lnXep.AccountActionTypes).ACCEPT_TERMS_ASYNC_PENDING, $7e7b9747d35c113f$export$7b6d21b5663caca4);
}

});

parcelRegister("9Ujgr", function(module, exports) {

$parcel$export(module.exports, "watchUploadTermsFileAsync", () => $32eb79921da7506c$export$f166c4180d45cd5b);
parcelRequire("2AbXc");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6FjiM = parcelRequire("6FjiM");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $dz6fA = parcelRequire("dz6fA");
const $32eb79921da7506c$var$valuesToFormData = (values)=>{
    const data = new FormData();
    data.append("terms[file]", values.file);
    return data;
};
function* $32eb79921da7506c$export$b5cb80e9e8621d47(action) {
    try {
        const data = $32eb79921da7506c$var$valuesToFormData(action.payload.values);
        const config = (0, $1zizz.withAuthHeader)();
        // the upload can't be done with JSON, it needs this content type.
        config.headers["Content-Type"] = "multipart/form-data";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadStarted",
            type: (0, $jiIfA.UserMessageTypes).MESSAGE
        }));
        const response = yield (0, $6FjiM.call)((0, $5s7Tw.default).post, "/terms", data, config);
        yield (0, $k6WuE.Z)({
            type: (0, $dz6fA.AdminActionTypes).UPLOAD_TERMS_FILE_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dz6fA.AdminActionTypes).UPLOAD_TERMS_FILE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $32eb79921da7506c$export$f166c4180d45cd5b() {
    yield (0, $2AbXc.takeLeading)((0, $dz6fA.AdminActionTypes).UPLOAD_TERMS_FILE_ASYNC_PENDING, $32eb79921da7506c$export$b5cb80e9e8621d47);
}

});
parcelRegister("6FjiM", function(module, exports) {

module.exports = (parcelRequire("4TVpj"));

});
parcelRegister("4TVpj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.takeMaybe = module.exports.take = module.exports.spawn = module.exports.setContext = module.exports.select = module.exports.race = module.exports.putResolve = module.exports.put = module.exports.join = module.exports.fork = module.exports.getContext = module.exports.flush = module.exports.cps = module.exports.cancelled = module.exports.cancel = module.exports.call = module.exports.apply = module.exports.actionChannel = void 0;

var $3918d457f84de261$var$effects = $3918d457f84de261$var$_interopRequireWildcard((parcelRequire("cd5S4")));

var $dBnez = parcelRequire("dBnez");
function $3918d457f84de261$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $3918d457f84de261$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $3918d457f84de261$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3918d457f84de261$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $3918d457f84de261$var$actionChannel = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.actionChannel);
module.exports.actionChannel = $3918d457f84de261$var$actionChannel;
const $3918d457f84de261$var$apply = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.apply);
module.exports.apply = $3918d457f84de261$var$apply;
const $3918d457f84de261$var$call = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.call);
module.exports.call = $3918d457f84de261$var$call;
const $3918d457f84de261$var$cancel = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.cancel);
module.exports.cancel = $3918d457f84de261$var$cancel;
const $3918d457f84de261$var$cancelled = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.cancelled);
module.exports.cancelled = $3918d457f84de261$var$cancelled;
const $3918d457f84de261$var$cps = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.cps);
module.exports.cps = $3918d457f84de261$var$cps;
const $3918d457f84de261$var$flush = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.flush);
module.exports.flush = $3918d457f84de261$var$flush;
const $3918d457f84de261$var$getContext = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.getContext);
module.exports.getContext = $3918d457f84de261$var$getContext;
const $3918d457f84de261$var$fork = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.fork);
module.exports.fork = $3918d457f84de261$var$fork;
const $3918d457f84de261$var$join = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.join);
module.exports.join = $3918d457f84de261$var$join;
const $3918d457f84de261$var$put = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.put);
module.exports.put = $3918d457f84de261$var$put;
const $3918d457f84de261$var$putResolve = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.putResolve);
module.exports.putResolve = $3918d457f84de261$var$putResolve;
const $3918d457f84de261$var$race = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.race);
module.exports.race = $3918d457f84de261$var$race;
const $3918d457f84de261$var$select = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.select);
module.exports.select = $3918d457f84de261$var$select;
const $3918d457f84de261$var$setContext = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.setContext);
module.exports.setContext = $3918d457f84de261$var$setContext;
const $3918d457f84de261$var$spawn = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.spawn);
module.exports.spawn = $3918d457f84de261$var$spawn;
const $3918d457f84de261$var$take = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.take);
module.exports.take = $3918d457f84de261$var$take;
const $3918d457f84de261$var$takeMaybe = (0, $dBnez.wrapEffectCreator)($3918d457f84de261$var$effects.takeMaybe);
module.exports.takeMaybe = $3918d457f84de261$var$takeMaybe;
$3918d457f84de261$var$actionChannel.like = (0, $dBnez.like)('actionChannel');
$3918d457f84de261$var$actionChannel.pattern = (pattern)=>$3918d457f84de261$var$actionChannel.like({
        pattern: pattern
    });
$3918d457f84de261$var$apply.like = (0, $dBnez.like)('call');
$3918d457f84de261$var$apply.fn = (fn)=>$3918d457f84de261$var$apply.like({
        fn: fn
    });
$3918d457f84de261$var$call.like = (0, $dBnez.like)('call');
$3918d457f84de261$var$call.fn = (fn)=>$3918d457f84de261$var$call.like({
        fn: fn
    });
$3918d457f84de261$var$cps.like = (0, $dBnez.like)('cps');
$3918d457f84de261$var$cps.fn = (fn)=>$3918d457f84de261$var$cps.like({
        fn: fn
    });
$3918d457f84de261$var$fork.like = (0, $dBnez.like)('fork');
$3918d457f84de261$var$fork.fn = (fn)=>$3918d457f84de261$var$fork.like({
        fn: fn
    });
$3918d457f84de261$var$put.like = (0, $dBnez.like)('put');
$3918d457f84de261$var$put.actionType = (type)=>$3918d457f84de261$var$put.like({
        action: {
            type: type
        }
    });
$3918d457f84de261$var$putResolve.like = (0, $dBnez.like)('put', {
    resolve: true
});
$3918d457f84de261$var$putResolve.actionType = (type)=>$3918d457f84de261$var$putResolve.like({
        action: {
            type: type
        }
    });
$3918d457f84de261$var$select.like = (0, $dBnez.like)('select');
$3918d457f84de261$var$select.selector = (selector)=>$3918d457f84de261$var$select.like({
        selector: selector
    });
$3918d457f84de261$var$spawn.like = (0, $dBnez.like)('spawn', {
    detached: true
});
$3918d457f84de261$var$spawn.fn = (fn)=>$3918d457f84de261$var$spawn.like({
        fn: fn
    });

});
parcelRegister("dBnez", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapEffectCreator = $9e70c0da364c41ee$var$wrapEffectCreator;
module.exports.like = $9e70c0da364c41ee$var$like;
module.exports.isPartialMatcher = $9e70c0da364c41ee$var$isPartialMatcher;
const $9e70c0da364c41ee$var$PARTIAL_MATCH = '@@redux-saga-test-plan/partial-matcher';
function $9e70c0da364c41ee$var$wrapEffectCreator(effectCreator) {
    return function wrappedEffectCreator(...args) {
        return effectCreator(...args);
    };
}
function $9e70c0da364c41ee$var$like(providerKey, defaults = {}) {
    return function effectMatcher(effect) {
        return Object.assign({}, defaults, {
            effect: effect,
            providerKey: providerKey,
            [$9e70c0da364c41ee$var$PARTIAL_MATCH]: true
        });
    };
}
function $9e70c0da364c41ee$var$isPartialMatcher(effect) {
    return $9e70c0da364c41ee$var$PARTIAL_MATCH in effect;
}

});




parcelRegister("2DA70", function(module, exports) {

$parcel$export(module.exports, "watchCreateLinkAsync", () => $03472faa6a1a3a16$export$da09f8f99369de);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $7twpo = parcelRequire("7twpo");

var $k0jcd = parcelRequire("k0jcd");

var $6j1K3 = parcelRequire("6j1K3");

var $efsoN = parcelRequire("efsoN");
function* $03472faa6a1a3a16$export$da09f8f99369de() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_PENDING, $03472faa6a1a3a16$export$992088a34cdb3ad2);
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).CREATE_CASE_RADIOLOGY_LINK_ASYNC_PENDING, $03472faa6a1a3a16$export$9691facbc9b5673);
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_PENDING, $03472faa6a1a3a16$export$749d71f541a3200d);
}
function* $03472faa6a1a3a16$export$992088a34cdb3ad2(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            link: action.payload.link,
            meetingCaseId: action.payload.meetingCaseId
        };
        const normalizedResponse = yield (0, $efsoN.postNormalisedSingle)(`/cases/${caseId}/links`, data, (0, $k0jcd.assetsSchema));
        const payload = {
            all: normalizedResponse,
            caseId: caseId
        };
        yield (0, $efsoN.handleSuccess)((0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_SUCCESS, payload, "createLinkSuccess");
        if (action.payload.meetingCaseId) yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_ERROR, error, "createLinkFail");
    }
}
function* $03472faa6a1a3a16$export$749d71f541a3200d(action) {
    try {
        const { caseId: caseId } = action.payload;
        const normalizedResponse = yield (0, $efsoN.getNormalisedSingle)(`/radiology/by_case/${caseId}`, [
            (0, $k0jcd.patientRadiologyLinkSchema)
        ]);
        yield (0, $efsoN.handleSuccess)((0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_SUCCESS, normalizedResponse);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $7twpo.AssetsActionTypes).FETCH_PATIENT_RADIOLOGY_LINKS_ASYNC_ERROR, error, "fetchPatientLinksFail");
    }
}
function* $03472faa6a1a3a16$export$9691facbc9b5673(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            radiologyLink: action.payload.radiologyLink
        };
        const normalizedResponse = yield (0, $efsoN.postNormalisedSingle)(`/cases/${caseId}/radiology_links`, data, (0, $k0jcd.assetsSchema));
        const payload = {
            all: normalizedResponse,
            caseId: caseId
        };
        yield (0, $efsoN.handleSuccess)((0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_SUCCESS, payload, "createLinkSuccess");
        if (action.payload.meetingCaseId) yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $7twpo.AssetsActionTypes).CREATE_CASE_LINK_ASYNC_ERROR, error, "createLinkFail");
    }
}

});

parcelRegister("5mbCb", function(module, exports) {

$parcel$export(module.exports, "watchCreateRecommendationAsync", () => $e9720902f80ec9be$export$81e1ddb1e2aa0716);
$parcel$export(module.exports, "watchSaveCaseRecommendationAsync", () => $e9720902f80ec9be$export$3cb85808fa93f429);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $7twpo = parcelRequire("7twpo");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $6j1K3 = parcelRequire("6j1K3");
function* $e9720902f80ec9be$export$aeee9e1c25144f23(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            recommendation: action.payload.recommendation
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/recommendations`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        if (action.payload.meetingCaseId) yield (0, $k6WuE.Z)((0, $6j1K3.fetchMeetingCaseAction)(action.payload.meetingCaseId));
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createRecommendationSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createRecommendationFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e9720902f80ec9be$export$81e1ddb1e2aa0716() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).CREATE_CASE_RECOMMENDATION_ASYNC_PENDING, $e9720902f80ec9be$export$aeee9e1c25144f23);
}
function* $e9720902f80ec9be$export$b14aa8f3bb330ff7(action) {
    try {
        const recommendationId = action.payload.recommendationId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/recommendations/${recommendationId}/save`, null, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_SUCCESS,
            payload: {
                caseId: action.payload.caseId,
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "saveRecommendationSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createRecommendationFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e9720902f80ec9be$export$3cb85808fa93f429() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).SAVE_CASE_RECOMMENDATION_ASYNC_PENDING, $e9720902f80ec9be$export$b14aa8f3bb330ff7);
}

});

parcelRegister("5yqYK", function(module, exports) {

$parcel$export(module.exports, "watchAddConsentAsync", () => $e83a38794397a389$export$982edc34f63ee30b);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $7twpo = parcelRequire("7twpo");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");
function* $e83a38794397a389$export$7987c500c4569393(action) {
    try {
        const payload = action.payload;
        const data = {
            userId: payload.userId,
            response: payload.response,
            comment: payload.comment
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/recommendations/${payload.recommendationId}/consent`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).ADD_CONSENT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addConsentToRecommendationSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7twpo.AssetsActionTypes).ADD_CONSENT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addConsentToRecommendationFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e83a38794397a389$export$982edc34f63ee30b() {
    yield (0, $2AbXc.takeLeading)((0, $7twpo.AssetsActionTypes).ADD_CONSENT_ASYNC_PENDING, $e83a38794397a389$export$7987c500c4569393);
}

});

parcelRegister("diHh0", function(module, exports) {

$parcel$export(module.exports, "watchUploadTenantLogoAsync", () => $3d3e629e265af537$export$92968e6f9f828952);
parcelRequire("2AbXc");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6FjiM = parcelRequire("6FjiM");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $dz6fA = parcelRequire("dz6fA");
const $3d3e629e265af537$var$valuesToFormData = (values)=>{
    const data = new FormData();
    data.append("tenant[logo]", values.file);
    return data;
};
function* $3d3e629e265af537$export$d98ccc7e0b461a18(action) {
    try {
        const data = $3d3e629e265af537$var$valuesToFormData(action.payload.values);
        const config = (0, $1zizz.withAuthHeader)();
        // the upload can't be done with JSON, it needs this content type.
        config.headers["Content-Type"] = "multipart/form-data";
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadStarted",
            type: (0, $jiIfA.UserMessageTypes).MESSAGE
        }));
        const response = yield (0, $6FjiM.call)((0, $5s7Tw.default).patch, "/tenant_logo", data, config);
        yield (0, $k6WuE.Z)({
            type: (0, $dz6fA.AdminActionTypes).UPLOAD_TENANT_LOGO_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dz6fA.AdminActionTypes).UPLOAD_TENANT_LOGO_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fileUploadError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $3d3e629e265af537$export$92968e6f9f828952() {
    yield (0, $2AbXc.takeLeading)((0, $dz6fA.AdminActionTypes).UPLOAD_TENANT_LOGO_ASYNC_PENDING, $3d3e629e265af537$export$d98ccc7e0b461a18);
}

});

parcelRegister("acSKo", function(module, exports) {

$parcel$export(module.exports, "watchFetchCasesAddableToMeetingsAsync", () => $01f77e651d809f94$export$9929c93865bc840d);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $7YL61 = parcelRequire("7YL61");
const $01f77e651d809f94$var$normalizeResponseToPayload = (response)=>{
    const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
        (0, $k0jcd.fetchCaseSchema)
    ]);
    return {
        all: normalizedResponse,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        appliedFilters: response.data.searchQuery.appliedFilters,
        resultsPerPage: response.data.searchQuery.resultsPerPage,
        searchTerm: response.data.searchQuery.searchTerm,
        orderBy: response.data.searchQuery.orderBy
    };
};
function* $01f77e651d809f94$export$3c8ee6fc9e1f784e(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases/addable_to_meetings?${query}`, (0, $1zizz.withAuthHeader)());
        const payload = $01f77e651d809f94$var$normalizeResponseToPayload(response);
        yield (0, $k6WuE.Z)({
            type: (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_SUCCESS,
            payload: payload
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "casesNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $01f77e651d809f94$export$9929c93865bc840d() {
    yield (0, $2AbXc.takeLeading)((0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_PENDING, $01f77e651d809f94$export$3c8ee6fc9e1f784e);
}

});

parcelRegister("7Dbe5", function(module, exports) {

$parcel$export(module.exports, "watchFetchTeamsAsync", () => $add889adc2ca546b$export$2cd6236ef3bf71f0);
$parcel$export(module.exports, "watchFetchAllTeamsAsync", () => $add889adc2ca546b$export$10126e27134afb2f);

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $62Lcu = parcelRequire("62Lcu");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $3Ukkm = parcelRequire("3Ukkm");

var $5ofNJ = parcelRequire("5ofNJ");
function* $add889adc2ca546b$export$24e0f077a3efb538(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/teams?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchTeamSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                appliedFilters: response.data.searchQuery.appliedFilters,
                orderBy: response.data.searchQuery.orderBy,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                searchTerm: response.data.searchQuery.searchTerm
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "teamsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $add889adc2ca546b$export$2cd6236ef3bf71f0() {
    yield (0, $2AbXc.takeLeading)((0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_PENDING, $add889adc2ca546b$export$24e0f077a3efb538);
}
function* $add889adc2ca546b$export$b060c608f081315() {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/teams", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchTeamSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "teamsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $add889adc2ca546b$export$10126e27134afb2f() {
    yield (0, $2AbXc.takeLeading)((0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_PENDING, $add889adc2ca546b$export$b060c608f081315);
}

});

parcelRegister("hr8vc", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseTasksAsync", () => $1fe51be78410096d$export$cb5641eab3c32975);
$parcel$export(module.exports, "watchCreateTaskAsync", () => $1fe51be78410096d$export$9f18f7e89fc1da2f);
$parcel$export(module.exports, "watchDeleteCaseTaskAsync", () => $1fe51be78410096d$export$e93475310d800c3b);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $dbP5t = parcelRequire("dbP5t");
function* $1fe51be78410096d$export$8a7a0ac138572702(action) {
    try {
        const caseId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases/${caseId}/tasks`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.tasksSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $1fe51be78410096d$export$cb5641eab3c32975() {
    yield (0, $2AbXc.takeLeading)((0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_PENDING, $1fe51be78410096d$export$8a7a0ac138572702);
}
function* $1fe51be78410096d$export$d59557fb7c55b02a(action) {
    try {
        const caseId = action.payload.caseId;
        const casePathwayId = action.payload.casePathwayId;
        const data = {
            task: action.payload.task
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/tasks`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.tasksSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId,
                casePathwayId: casePathwayId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTaskSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTaskFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $1fe51be78410096d$export$9f18f7e89fc1da2f() {
    yield (0, $2AbXc.takeLeading)((0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_PENDING, $1fe51be78410096d$export$d59557fb7c55b02a);
}
function* $1fe51be78410096d$export$ab6c25570e855fd1(action) {
    try {
        const caseId = action.payload.caseId;
        const taskId = action.payload.taskId;
        const casePathwayId = action.payload.casePathwayId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/cases/${caseId}/tasks/${taskId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.tasksSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                taskId: taskId,
                casePathwayId: casePathwayId,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteTaskSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteTaskFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $1fe51be78410096d$export$e93475310d800c3b() {
    yield (0, $2AbXc.takeLeading)((0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_PENDING, $1fe51be78410096d$export$ab6c25570e855fd1);
}

});

parcelRegister("3Z0uW", function(module, exports) {

$parcel$export(module.exports, "watchCreateTaskResponseAsync", () => $d0fb1ccd5a3063f3$export$756aebce3af527a);

var $6ye6I = parcelRequire("6ye6I");

var $6tuez = parcelRequire("6tuez");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $aif7R = parcelRequire("aif7R");
function* $d0fb1ccd5a3063f3$export$58fca30cff4b7132(action) {
    try {
        const caseId = action.payload.caseId;
        const taskId = action.payload.taskId;
        const data = {
            taskResponse: action.payload.taskResponse
        };
        const fileData = data.taskResponse.caseAssetAttributes.assetAttributes.file;
        if (!fileData) // Remove asset attributes if no file attached
        delete data.taskResponse.caseAssetAttributes;
        else // We have to delete and add file data later as decamelizeKeys seems to destory the data
        delete data.taskResponse.caseAssetAttributes.assetAttributes.file;
        const decamelizedData = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(data);
        const formData = (0, $6tuez.serialize)(decamelizedData);
        if (fileData) formData.append("task_response[case_asset_attributes][asset_attributes][file]", fileData);
        const config = (0, $1zizz.withAuthHeader)();
        config.headers["Content-Type"] = "multipart/form-data";
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/tasks/${taskId}/task_responses`, formData, config);
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.tasksSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId,
                taskId: taskId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTaskResponseSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTaskResponseFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $d0fb1ccd5a3063f3$export$756aebce3af527a() {
    yield (0, $2AbXc.takeLeading)((0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_PENDING, $d0fb1ccd5a3063f3$export$58fca30cff4b7132);
}

});
parcelRegister("6tuez", function(module, exports) {
function $4b6ce75d5fa5804d$var$isUndefined(value) {
    return value === undefined;
}
function $4b6ce75d5fa5804d$var$isNull(value) {
    return value === null;
}
function $4b6ce75d5fa5804d$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $4b6ce75d5fa5804d$var$isObject(value) {
    return value === Object(value);
}
function $4b6ce75d5fa5804d$var$isArray(value) {
    return Array.isArray(value);
}
function $4b6ce75d5fa5804d$var$isDate(value) {
    return value instanceof Date;
}
function $4b6ce75d5fa5804d$var$isBlob(value, isReactNative) {
    return isReactNative ? $4b6ce75d5fa5804d$var$isObject(value) && !$4b6ce75d5fa5804d$var$isUndefined(value.uri) : $4b6ce75d5fa5804d$var$isObject(value) && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.slice === 'function';
}
function $4b6ce75d5fa5804d$var$isFile(value, isReactNative) {
    return $4b6ce75d5fa5804d$var$isBlob(value, isReactNative) && typeof value.name === 'string' && ($4b6ce75d5fa5804d$var$isObject(value.lastModifiedDate) || typeof value.lastModified === 'number');
}
function $4b6ce75d5fa5804d$var$initCfg(value) {
    return $4b6ce75d5fa5804d$var$isUndefined(value) ? false : value;
}
function $4b6ce75d5fa5804d$var$serialize(obj, cfg, fd, pre) {
    cfg = cfg || {};
    fd = fd || new FormData();
    cfg.indices = $4b6ce75d5fa5804d$var$initCfg(cfg.indices);
    cfg.nullsAsUndefineds = $4b6ce75d5fa5804d$var$initCfg(cfg.nullsAsUndefineds);
    cfg.booleansAsIntegers = $4b6ce75d5fa5804d$var$initCfg(cfg.booleansAsIntegers);
    cfg.allowEmptyArrays = $4b6ce75d5fa5804d$var$initCfg(cfg.allowEmptyArrays);
    cfg.noFilesWithArrayNotation = $4b6ce75d5fa5804d$var$initCfg(cfg.noFilesWithArrayNotation);
    cfg.dotsForObjectNotation = $4b6ce75d5fa5804d$var$initCfg(cfg.dotsForObjectNotation);
    const isReactNative = typeof fd.getParts === 'function';
    if ($4b6ce75d5fa5804d$var$isUndefined(obj)) return fd;
    else if ($4b6ce75d5fa5804d$var$isNull(obj)) {
        if (!cfg.nullsAsUndefineds) fd.append(pre, '');
    } else if ($4b6ce75d5fa5804d$var$isBoolean(obj)) {
        if (cfg.booleansAsIntegers) fd.append(pre, obj ? 1 : 0);
        else fd.append(pre, obj);
    } else if ($4b6ce75d5fa5804d$var$isArray(obj)) {
        if (obj.length) obj.forEach((value, index)=>{
            let key = pre + '[' + (cfg.indices ? index : '') + ']';
            if (cfg.noFilesWithArrayNotation && $4b6ce75d5fa5804d$var$isFile(value, isReactNative)) key = pre;
            $4b6ce75d5fa5804d$var$serialize(value, cfg, fd, key);
        });
        else if (cfg.allowEmptyArrays) fd.append(pre + '[]', '');
    } else if ($4b6ce75d5fa5804d$var$isDate(obj)) fd.append(pre, obj.toISOString());
    else if ($4b6ce75d5fa5804d$var$isObject(obj) && !$4b6ce75d5fa5804d$var$isBlob(obj, isReactNative)) Object.keys(obj).forEach((prop)=>{
        const value = obj[prop];
        if ($4b6ce75d5fa5804d$var$isArray(value)) while(prop.length > 2 && prop.lastIndexOf('[]') === prop.length - 2)prop = prop.substring(0, prop.length - 2);
        const key = pre ? cfg.dotsForObjectNotation ? pre + '.' + prop : pre + '[' + prop + ']' : prop;
        $4b6ce75d5fa5804d$var$serialize(value, cfg, fd, key);
    });
    else fd.append(pre, obj);
    return fd;
}
module.exports = {
    serialize: $4b6ce75d5fa5804d$var$serialize
};

});


parcelRegister("3Kxye", function(module, exports) {

$parcel$export(module.exports, "watchFetchTasksAsync", () => $4558c1b70045dcb3$export$f2c58df300901280);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $dbP5t = parcelRequire("dbP5t");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");
function* $4558c1b70045dcb3$export$cf6d3e318a1f206b(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/tasks?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.tasksSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                appliedFilters: response.data.searchQuery.appliedFilters,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                orderBy: response.data.searchQuery.orderBy
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "tasksNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $4558c1b70045dcb3$export$f2c58df300901280() {
    yield (0, $2AbXc.takeLeading)((0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_PENDING, $4558c1b70045dcb3$export$cf6d3e318a1f206b);
}

});

parcelRegister("8Ej42", function(module, exports) {

$parcel$export(module.exports, "watchFetchPatientAsync", () => $33b33b75bedc6570$export$4976e9d3d5342457);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");

var $el6QJ = parcelRequire("el6QJ");
function* $33b33b75bedc6570$export$34673f1c00ec78bf(action) {
    try {
        const patientId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/patients/${patientId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.patientsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "patientNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $33b33b75bedc6570$export$4976e9d3d5342457() {
    yield (0, $2AbXc.takeLeading)((0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_PENDING, $33b33b75bedc6570$export$34673f1c00ec78bf);
}

});

parcelRegister("aZIV3", function(module, exports) {

$parcel$export(module.exports, "watchCheckPatientAsync", () => $e6661dfdda9da2c8$export$91ac0f59ddf237ea);
$parcel$export(module.exports, "watchCreatePatientAsync", () => $e6661dfdda9da2c8$export$f9be440b631d1975);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $1l1FS = parcelRequire("1l1FS");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $5tA5l = parcelRequire("5tA5l");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6QJY8 = parcelRequire("6QJY8");
function* $e6661dfdda9da2c8$export$9760330467781111(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload.patientCheckData), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/patients/check?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.patientsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_FOUND,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_NOT_FOUND,
            payload: error
        });
    }
}
function* $e6661dfdda9da2c8$export$91ac0f59ddf237ea() {
    yield (0, $2AbXc.takeLeading)((0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_PENDING, $e6661dfdda9da2c8$export$9760330467781111);
}
function* $e6661dfdda9da2c8$export$f0a94092a9fd6058(action) {
    try {
        const data = {
            patient: action.payload.patient
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/patients", data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.patientsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5tA5l.PatientNewActionTypes).CREATE_PATIENT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPatientSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).PATIENTS);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5tA5l.PatientNewActionTypes).CREATE_PATIENT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPatientFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e6661dfdda9da2c8$export$f9be440b631d1975() {
    yield (0, $2AbXc.takeLeading)((0, $5tA5l.PatientNewActionTypes).CREATE_PATIENT_ASYNC_PENDING, $e6661dfdda9da2c8$export$f0a94092a9fd6058);
}

});

parcelRegister("99nwM", function(module, exports) {

$parcel$export(module.exports, "watchUpdatePatientAsync", () => $934d0e653414bbef$export$8bac3409492c9776);
$parcel$export(module.exports, "watchAddCaseForPatientAsync", () => $934d0e653414bbef$export$d4546fcf975d097c);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $1l1FS = parcelRequire("1l1FS");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6QJY8 = parcelRequire("6QJY8");

var $36FXQ = parcelRequire("36FXQ");

var $COwA0 = parcelRequire("COwA0");
function* $934d0e653414bbef$export$bd1b4ad201ff58(action) {
    try {
        const data = {
            patient: action.payload.patient
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/patients/${action.payload.id}`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.patientsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $36FXQ.PatientEditActionTypes).UPDATE_PATIENT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePatientSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const patientUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT, {
            patientId: action.payload.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, patientUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $36FXQ.PatientEditActionTypes).UPDATE_PATIENT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePatientFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $934d0e653414bbef$export$8bac3409492c9776() {
    yield (0, $2AbXc.takeLeading)((0, $36FXQ.PatientEditActionTypes).UPDATE_PATIENT_ASYNC_PENDING, $934d0e653414bbef$export$bd1b4ad201ff58);
}
function* $934d0e653414bbef$export$62484fbc30d218cd(action) {
    try {
        const data = {
            patient: action.payload.patient
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/patients/${action.payload.id}/add_case`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.patientsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $36FXQ.PatientEditActionTypes).ADD_CASE_FOR_PATIENT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addCaseForPatientSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const patientUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT, {
            patientId: action.payload.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, patientUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $36FXQ.PatientEditActionTypes).ADD_CASE_FOR_PATIENT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addCaseForPatientFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $934d0e653414bbef$export$d4546fcf975d097c() {
    yield (0, $2AbXc.takeLeading)((0, $36FXQ.PatientEditActionTypes).ADD_CASE_FOR_PATIENT_ASYNC_PENDING, $934d0e653414bbef$export$62484fbc30d218cd);
}

});
parcelRegister("36FXQ", function(module, exports) {

$parcel$export(module.exports, "PatientEditActionTypes", () => $559ba8c2b702387a$export$9a6c6fe6239b1894);
var $559ba8c2b702387a$export$9a6c6fe6239b1894 = /*#__PURE__*/ function(PatientEditActionTypes) {
    PatientEditActionTypes["UPDATE_PATIENT_ASYNC_PENDING"] = "@@patient/UPDATE_PATIENT_ASYNC_PENDING";
    PatientEditActionTypes["UPDATE_PATIENT_ASYNC_SUCCESS"] = "@@patient/UPDATE_PATIENT_ASYNC_SUCCESS";
    PatientEditActionTypes["UPDATE_PATIENT_ASYNC_ERROR"] = "@@patient/UPDATE_PATIENT_ASYNC_ERROR";
    PatientEditActionTypes["ADD_CASE_FOR_PATIENT_ASYNC_PENDING"] = "@@patient/ADD_CASE_FOR_PATIENT_ASYNC_PENDING";
    PatientEditActionTypes["ADD_CASE_FOR_PATIENT_ASYNC_SUCCESS"] = "@@patient/ADD_CASE_FOR_PATIENT_ASYNC_SUCCESS";
    PatientEditActionTypes["ADD_CASE_FOR_PATIENT_ASYNC_ERROR"] = "@@patient/ADD_CASE_FOR_PATIENT_ASYNC_ERROR";
    return PatientEditActionTypes;
}({});

});


parcelRegister("idlfx", function(module, exports) {

$parcel$export(module.exports, "teamWatchers", () => $a9f6f12fe9a50d9e$export$8ec1510ea0b1c2df);

var $5s7Tw = parcelRequire("5s7Tw");

var $1WoI7 = parcelRequire("1WoI7");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");

var $6ye6I = parcelRequire("6ye6I");

var $k0jcd = parcelRequire("k0jcd");

var $COwA0 = parcelRequire("COwA0");
function* $a9f6f12fe9a50d9e$export$8ec1510ea0b1c2df() {
    yield (0, $2AbXc.takeLeading)((0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_PENDING, $a9f6f12fe9a50d9e$export$cd2f547d21eda36b);
    yield (0, $2AbXc.takeLeading)((0, $1WoI7.TeamActionTypes).CREATE_TEAM_ASYNC_PENDING, $a9f6f12fe9a50d9e$export$58c43f2edea81ff1);
    yield (0, $2AbXc.takeLeading)((0, $1WoI7.TeamActionTypes).DELETE_TEAM_ASYNC_PENDING, $a9f6f12fe9a50d9e$export$c59ca162ad682829);
    yield (0, $2AbXc.takeLeading)((0, $1WoI7.TeamActionTypes).UPDATE_TEAM_USERS_ASYNC_PENDING, $a9f6f12fe9a50d9e$export$7fb61dc4aebcd066);
    yield (0, $2AbXc.takeLeading)((0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_PENDING, $a9f6f12fe9a50d9e$export$68d4bdfb0c3cc217);
}
function* $a9f6f12fe9a50d9e$export$cd2f547d21eda36b(action) {
    try {
        const teamId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/teams/${teamId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchTeamSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "teamNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a9f6f12fe9a50d9e$export$58c43f2edea81ff1(action) {
    try {
        const team = {
            team: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/teams", team, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).CREATE_TEAM_ASYNC_SUCCESS,
            payload: response.data
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTeamSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).TEAMS);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).CREATE_TEAM_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTeamFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a9f6f12fe9a50d9e$export$68d4bdfb0c3cc217(action) {
    try {
        const team = {
            team: action.payload.team
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/teams/${action.payload.id}`, team, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchTeamSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateTeamSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
            teamId: action.payload.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewTeamUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateTeamFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a9f6f12fe9a50d9e$export$7fb61dc4aebcd066(action) {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/teams/${action.payload.id}/update_team_members`, {
            team: action.payload.data
        }, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchTeamSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateTeamSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
            teamId: action.payload.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewTeamUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateTeamFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a9f6f12fe9a50d9e$export$c59ca162ad682829(action) {
    try {
        const teamId = action.payload;
        yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/teams/${teamId}`, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).DELETE_TEAM_ASYNC_SUCCESS
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteTeamSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAMS);
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewTeamUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $1WoI7.TeamActionTypes).DELETE_TEAM_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteTeamFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}

});

parcelRegister("6pkbE", function(module, exports) {

$parcel$export(module.exports, "watchCreateTeamUser", () => $4bb8c4edc1b181d6$export$11c86cc3469c1969);
$parcel$export(module.exports, "watchDestroyTeamUser", () => $4bb8c4edc1b181d6$export$ed5f551d9c93d032);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $COwA0 = parcelRequire("COwA0");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $1zizz = parcelRequire("1zizz");

var $1l1FS = parcelRequire("1l1FS");

var $hflQv = parcelRequire("hflQv");

var $6QJY8 = parcelRequire("6QJY8");
function* $4bb8c4edc1b181d6$export$9e328b47fb393700(action) {
    try {
        const teamUser = {
            teamUser: action.payload
        };
        // responds with the full team
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/team_users", teamUser, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchTeamSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTeamUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
            teamId: action.payload.teamId
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewTeamUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTeamUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $4bb8c4edc1b181d6$export$11c86cc3469c1969() {
    yield (0, $2AbXc.takeLatest)((0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_PENDING, $4bb8c4edc1b181d6$export$9e328b47fb393700);
}
function* $4bb8c4edc1b181d6$export$637ede7758953beb(action) {
    try {
        const teamUserId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/team_users/${teamUserId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchTeamSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "destroyTeamUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
            teamId: response.data.id
        });
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, viewTeamUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "destroyTeamUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $4bb8c4edc1b181d6$export$ed5f551d9c93d032() {
    yield (0, $2AbXc.takeLatest)((0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_PENDING, $4bb8c4edc1b181d6$export$637ede7758953beb);
}

});

parcelRegister("8UrmS", function(module, exports) {

$parcel$export(module.exports, "meetingCaseAssetWatchers", () => $d63814ab86824665$export$a39211aff1632a9e);
parcelRequire("cd5S4");
var $2AbXc = parcelRequire("2AbXc");

var $b9HAQ = parcelRequire("b9HAQ");

var $k0jcd = parcelRequire("k0jcd");

var $efsoN = parcelRequire("efsoN");
function* $d63814ab86824665$export$a39211aff1632a9e() {
    yield (0, $2AbXc.takeLeading)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_MEETING_CASE_ASSET_ASYNC_PENDING, $d63814ab86824665$export$33fe69ec409036c9);
    yield (0, $2AbXc.takeLeading)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_PENDING, $d63814ab86824665$export$3f24bf9f4f130228);
    yield (0, $2AbXc.takeLeading)((0, $b9HAQ.MeetingCaseAssetsActionTypes).DELETE_MEETING_CASE_ASSET_ASYNC_PENDING, $d63814ab86824665$export$558c100ca2e4b291);
}
function* $d63814ab86824665$export$33fe69ec409036c9(action) {
    try {
        const meetingCaseId = action.payload.meetingCaseId;
        const caseAssetId = action.payload.caseAssetId;
        const data = {
            meetingCaseAsset: {
                caseAssetId: caseAssetId
            }
        };
        const response = yield (0, $efsoN.postNormalisedSingle)(`/meeting_cases/${meetingCaseId}/meeting_case_assets`, data, (0, $k0jcd.fetchMeetingCaseSchema));
        yield (0, $efsoN.handleSuccess)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_MEETING_CASE_ASSET_ASYNC_SUCCESS, response, "createMeetingCaseAssetSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_MEETING_CASE_ASSET_ASYNC_ERROR, error, "createMeetingCaseAssetFail");
    }
}
function* $d63814ab86824665$export$3f24bf9f4f130228(action) {
    try {
        const meetingCaseId = action.payload.meetingCaseId;
        const response = yield (0, $efsoN.postNormalisedSingle)(`/meeting_cases/${meetingCaseId}/meeting_case_assets/all`, {}, (0, $k0jcd.fetchMeetingCaseSchema));
        yield (0, $efsoN.handleSuccess)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_SUCCESS, response, "createMeetingCaseAssetSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_ERROR, error, "createMeetingCaseAssetFail");
    }
}
function* $d63814ab86824665$export$558c100ca2e4b291(action) {
    try {
        const meetingCaseId = action.payload.meetingCaseId;
        const meetingCaseAssetId = action.payload.meetingCaseAssetId;
        const response = yield (0, $efsoN.deleteNormalisedSingle)(`/meeting_cases/${meetingCaseId}/meeting_case_assets/${meetingCaseAssetId}`, (0, $k0jcd.fetchMeetingCaseSchema));
        yield (0, $efsoN.handleSuccess)((0, $b9HAQ.MeetingCaseAssetsActionTypes).DELETE_MEETING_CASE_ASSET_ASYNC_SUCCESS, response, "deleteMeetingCaseAssetSuccess");
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $b9HAQ.MeetingCaseAssetsActionTypes).DELETE_MEETING_CASE_ASSET_ASYNC_ERROR, error, "deleteMeetingCaseAssetFail");
    }
}

});

parcelRegister("bYwoy", function(module, exports) {

$parcel$export(module.exports, "watchCreateTenantAsync", () => $50cef3537b0a5115$export$4eb4d6c44ebc095f);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $i78re = parcelRequire("i78re");

var $k0jcd = parcelRequire("k0jcd");
function* $50cef3537b0a5115$export$d9840ef7149703d1(action) {
    try {
        const data = {
            tenant: action.payload.tenant
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/tenants", data, (0, $1zizz.withAuthHeader)());
        // returns full user that includes tenants
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.userSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $i78re.TenantActionTypes).CREATE_TENANT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTenantSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $i78re.TenantActionTypes).CREATE_TENANT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createTenantFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $50cef3537b0a5115$export$4eb4d6c44ebc095f() {
    yield (0, $2AbXc.takeLeading)((0, $i78re.TenantActionTypes).CREATE_TENANT_ASYNC_PENDING, $50cef3537b0a5115$export$d9840ef7149703d1);
}

});

parcelRegister("hzIUn", function(module, exports) {

$parcel$export(module.exports, "watchFetchChatsAsync", () => $6aa91980de59918b$export$a757060b0b1ce5d3);

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $4VdtH = parcelRequire("4VdtH");
function* $6aa91980de59918b$export$565802b5378d578f(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/chats?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchChatsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                resultsPerPage: response.data.searchQuery.resultsPerPage
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "chatsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $6aa91980de59918b$export$a757060b0b1ce5d3() {
    yield (0, $2AbXc.takeLeading)((0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_PENDING, $6aa91980de59918b$export$565802b5378d578f);
}

});

parcelRegister("gOH3n", function(module, exports) {

$parcel$export(module.exports, "watchFetchChatMessagesAsync", () => $031dcf00627438cf$export$8d6f1023ae86b2a7);

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $1zizz = parcelRequire("1zizz");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $5Ah2h = parcelRequire("5Ah2h");

var $k0jcd = parcelRequire("k0jcd");
function* $031dcf00627438cf$export$afc72f46442ad4d8(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload.searchQuery), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/chats/${action.payload.chatId}/messages?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.fetchMessagesSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_SUCCESS,
            payload: {
                chatId: action.payload.chatId,
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                resultsPerPage: response.data.searchQuery.resultsPerPage
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "messagesNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $031dcf00627438cf$export$8d6f1023ae86b2a7() {
    yield (0, $2AbXc.takeLeading)((0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_PENDING, $031dcf00627438cf$export$afc72f46442ad4d8);
}

});

parcelRegister("dlQwf", function(module, exports) {

$parcel$export(module.exports, "watchCreateChatMessageAsync", () => $a34e1cdb683a936b$export$b2d782969aea75c7);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $3Ukkm = parcelRequire("3Ukkm");

var $6tuez = parcelRequire("6tuez");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $dJ0hQ = parcelRequire("dJ0hQ");
function* $a34e1cdb683a936b$export$a7d3974ad1e9be45(action) {
    try {
        const chatId = action.payload.chatId;
        const data = {
            message: action.payload.message
        };
        const decamelizedData = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(data);
        const formData = (0, $6tuez.serialize)(decamelizedData, {
            indices: true
        });
        const filesData = data.message.assetsAttributes?.map((a)=>a.file);
        if (filesData) filesData.forEach((fileData, index)=>{
            formData.append(`message[assets_attributes][${index}][asset_attributes][file]`, fileData);
        });
        const config = (0, $1zizz.withAuthHeader)();
        config.headers["Content-Type"] = "multipart/form-data";
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/chats/${chatId}/messages`, formData, config);
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchMessagesSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $dJ0hQ.ChatMessageActionTypes).CREATE_CHAT_MESSAGE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                chatId: chatId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dJ0hQ.ChatMessageActionTypes).CREATE_CHAT_MESSAGE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createMessageFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $a34e1cdb683a936b$export$b2d782969aea75c7() {
    yield (0, $2AbXc.takeLeading)((0, $dJ0hQ.ChatMessageActionTypes).CREATE_CHAT_MESSAGE_ASYNC_PENDING, $a34e1cdb683a936b$export$a7d3974ad1e9be45);
}

});
parcelRegister("dJ0hQ", function(module, exports) {

$parcel$export(module.exports, "ChatMessageActionTypes", () => $d5228fe5959ea51a$export$5051e39f23af98ac);
var $d5228fe5959ea51a$export$5051e39f23af98ac = /*#__PURE__*/ function(ChatMessageActionTypes) {
    ChatMessageActionTypes["CREATE_CHAT_MESSAGE_ASYNC_PENDING"] = "@@messages/CREATE_CHAT_MESSAGE_ASYNC_PENDING";
    ChatMessageActionTypes["CREATE_CHAT_MESSAGE_ASYNC_SUCCESS"] = "@@messages/CREATE_CHAT_MESSAGE_ASYNC_SUCCESS";
    ChatMessageActionTypes["CREATE_CHAT_MESSAGE_ASYNC_ERROR"] = "@@messages/CREATE_CHAT_MESSAGE_ASYNC_ERROR";
    return ChatMessageActionTypes;
}({});

});


parcelRegister("bi37B", function(module, exports) {

$parcel$export(module.exports, "watchCreateChatAsync", () => $301cdd2194062ed1$export$9a72ab092a83f466);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $gyfTN = parcelRequire("gyfTN");

var $k0jcd = parcelRequire("k0jcd");

var $4VdtH = parcelRequire("4VdtH");
function* $301cdd2194062ed1$export$706b7dbbfb06f1b7(action) {
    try {
        const data = {
            chat: action.payload.chat
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/chats", data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchChatsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)({
            type: (0, $4VdtH.ChatsActionTypes).UPDATED_SELECTED_CHAT_ID,
            payload: normalizedResponse.result
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createChatFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $301cdd2194062ed1$export$9a72ab092a83f466() {
    yield (0, $2AbXc.takeLeading)((0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_PENDING, $301cdd2194062ed1$export$706b7dbbfb06f1b7);
}

});

parcelRegister("lIh5L", function(module, exports) {

$parcel$export(module.exports, "watchFetchChatAsync", () => $ace473e158bb13de$export$98ea82f40a3bbd0f);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $fpLIl = parcelRequire("fpLIl");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
function* $ace473e158bb13de$export$41ac94d66fa5abc6(action) {
    try {
        const chatId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/chats/${chatId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchChatsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "chatNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $ace473e158bb13de$export$98ea82f40a3bbd0f() {
    yield (0, $2AbXc.takeLeading)((0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASYNC_PENDING, $ace473e158bb13de$export$41ac94d66fa5abc6);
}

});

parcelRegister("hlvWF", function(module, exports) {

$parcel$export(module.exports, "watchFetchAuditEventsAsync", () => $7b9cea457ff617ee$export$e3931e3164df5b7a);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $aBwAi = parcelRequire("aBwAi");

var $3Ukkm = parcelRequire("3Ukkm");

var $5ofNJ = parcelRequire("5ofNJ");
function* $7b9cea457ff617ee$export$71737308c710d24d(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/audit_events?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.auditEventsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                entityId: action.payload.entityId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $7b9cea457ff617ee$export$e3931e3164df5b7a() {
    yield (0, $2AbXc.takeLeading)((0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_PENDING, $7b9cea457ff617ee$export$71737308c710d24d);
}

});

parcelRegister("cTdOQ", function(module, exports) {

$parcel$export(module.exports, "watchEndChatAsync", () => $0040071a8774bcdc$export$91798e021dea7b23);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $fpLIl = parcelRequire("fpLIl");
function* $0040071a8774bcdc$export$6af52510add45f72(action) {
    try {
        const chatId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/chats/${chatId}/end`, {}, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchChatsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).END_CHAT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "endChatSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).END_CHAT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "endChatFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $0040071a8774bcdc$export$91798e021dea7b23() {
    yield (0, $2AbXc.takeLeading)((0, $fpLIl.ChatActionTypes).END_CHAT_ASYNC_PENDING, $0040071a8774bcdc$export$6af52510add45f72);
}

});

parcelRegister("5Qhwh", function(module, exports) {

$parcel$export(module.exports, "watchToggleMutedChatAsync", () => $4e96ad4549be585d$export$5b148f5d3c95f60a);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $fpLIl = parcelRequire("fpLIl");
function* $4e96ad4549be585d$export$c4883f0f1d5d6537(action) {
    try {
        const chatId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/chats/${chatId}/toggle_muted`, {}, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchChatsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).TOGGLE_MUTED_CHAT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).TOGGLE_MUTED_CHAT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "toggleMutedChatFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $4e96ad4549be585d$export$5b148f5d3c95f60a() {
    yield (0, $2AbXc.takeLeading)((0, $fpLIl.ChatActionTypes).TOGGLE_MUTED_CHAT_ASYNC_PENDING, $4e96ad4549be585d$export$c4883f0f1d5d6537);
}

});

parcelRegister("ap7AJ", function(module, exports) {

$parcel$export(module.exports, "watchFetchPathways", () => $4869e875405be3c7$export$9d48f8713bfba756);

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $eCmSQ = parcelRequire("eCmSQ");
function* $4869e875405be3c7$export$640f3aacfc398485(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/pathways?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.pathwaysSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                appliedFilters: response.data.searchQuery.appliedFilters,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                searchTerm: response.data.searchQuery.searchTerm,
                orderBy: response.data.searchQuery.orderBy
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "pathwaysNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $4869e875405be3c7$export$9d48f8713bfba756() {
    yield (0, $2AbXc.takeLeading)((0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_PENDING, $4869e875405be3c7$export$640f3aacfc398485);
}

});

parcelRegister("ir3DA", function(module, exports) {

$parcel$export(module.exports, "watchFetchPathwayAsync", () => $d32c675285785613$export$b4889c4c668c07c7);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $d32c675285785613$export$ae81e91eb38ff4a1(action) {
    try {
        const pathwayId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/pathways/${pathwayId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "pathwayNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $d32c675285785613$export$b4889c4c668c07c7() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_PENDING, $d32c675285785613$export$ae81e91eb38ff4a1);
}

});

parcelRegister("6wWHW", function(module, exports) {

$parcel$export(module.exports, "watchCreatePathwayAsync", () => $03465a93020f5a6e$export$e4e10e5437e0be00);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $COwA0 = parcelRequire("COwA0");
function* $03465a93020f5a6e$export$b48e376fe09d3072(action) {
    try {
        const pathway = {
            pathway: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, "/pathways", pathway, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        const pathwayDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATHWAY, {
            pathwayId: response.data.id
        });
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPathwaySuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, pathwayDetailsUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPathwayFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $03465a93020f5a6e$export$e4e10e5437e0be00() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_PENDING, $03465a93020f5a6e$export$b48e376fe09d3072);
}

});

parcelRegister("41iOM", function(module, exports) {

$parcel$export(module.exports, "watchUpdatePathwayAsync", () => $0d70e070c612ad55$export$f62da4f856c67bf0);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $COwA0 = parcelRequire("COwA0");
function* $0d70e070c612ad55$export$5884db13191861d1(action) {
    try {
        const pathway = {
            pathway: action.payload
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/pathways/${action.payload.id}`, pathway, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        const pathwayDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATHWAY, {
            pathwayId: response.data.id
        });
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePathwaySuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, pathwayDetailsUrl);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePathwayFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $0d70e070c612ad55$export$f62da4f856c67bf0() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_ASYNC_PENDING, $0d70e070c612ad55$export$5884db13191861d1);
}

});

parcelRegister("dP85u", function(module, exports) {

$parcel$export(module.exports, "watchCreatePathwayStepAsync", () => $ebce783543c3afa6$export$8524b7cefca0d5db);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $ebce783543c3afa6$export$1402cf8fcb816c7c(action) {
    try {
        const pathwayId = action.payload.pathwayId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/pathways/${pathwayId}/pathway_steps`, action.payload.values, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_STEP_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPathwayStepSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_STEP_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createPathwayStepFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $ebce783543c3afa6$export$8524b7cefca0d5db() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_STEP_ASYNC_PENDING, $ebce783543c3afa6$export$1402cf8fcb816c7c);
}

});

parcelRegister("3YWdJ", function(module, exports) {

$parcel$export(module.exports, "watchUpdatePathwayStepAsync", () => $f8318f88408a28a8$export$8f08176694461673);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $f8318f88408a28a8$export$7622178621be6e3(action) {
    try {
        const pathwayId = action.payload.pathwayId;
        const stepId = action.payload.values.id;
        const data = action.payload.values;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/pathways/${pathwayId}/pathway_steps/${stepId}`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_STEP_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePathwayStepSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_STEP_ASYNC_ERROR
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updatePathwayStepFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $f8318f88408a28a8$export$8f08176694461673() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_STEP_ASYNC_PENDING, $f8318f88408a28a8$export$7622178621be6e3);
}

});

parcelRegister("ajhjw", function(module, exports) {

$parcel$export(module.exports, "watchDeletePathwayStepAsync", () => $689258a9a5aa1a5f$export$1c89800b83366db5);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $689258a9a5aa1a5f$export$1e6395231c88ecd0(action) {
    try {
        const pathwayId = action.payload.pathwayId;
        const stepId = action.payload.stepId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/pathways/${pathwayId}/pathway_steps/${stepId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_STEP_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deletePathwayStepSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_STEP_ASYNC_ERROR
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deletePathwayStepFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $689258a9a5aa1a5f$export$1c89800b83366db5() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_STEP_ASYNC_PENDING, $689258a9a5aa1a5f$export$1e6395231c88ecd0);
}

});

parcelRegister("az88Y", function(module, exports) {

$parcel$export(module.exports, "watchAddPathwayUsersAsync", () => $e8844cd1326748e5$export$4bedcd8e7e1849bc);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $e8844cd1326748e5$export$def0e50bb6daa7ee(action) {
    try {
        const pathwayId = action.payload.pathwayId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/pathways/${pathwayId}/users`, {
            users: action.payload.users
        }, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).ADD_PATHWAY_USERS_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addPathwayUsersSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).ADD_PATHWAY_USERS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "addPathwayUsersFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e8844cd1326748e5$export$4bedcd8e7e1849bc() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).ADD_PATHWAY_USERS_ASYNC_PENDING, $e8844cd1326748e5$export$def0e50bb6daa7ee);
}

});

parcelRegister("3YlN4", function(module, exports) {

$parcel$export(module.exports, "watchRemovePathwayUserAsync", () => $67e6cbb3e1738c05$export$624a13520834c8af);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $67e6cbb3e1738c05$export$5aa2a83e47fcdd20(action) {
    try {
        const { user: user, pathwayId: pathwayId } = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/pathways/${pathwayId}/users/${user}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.pathwaysSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).REMOVE_PATHWAY_USER_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "removePathwayUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).REMOVE_PATHWAY_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "removePathwayUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $67e6cbb3e1738c05$export$624a13520834c8af() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).REMOVE_PATHWAY_USER_ASYNC_PENDING, $67e6cbb3e1738c05$export$5aa2a83e47fcdd20);
}

});

parcelRegister("2Cl6B", function(module, exports) {

$parcel$export(module.exports, "watchFetchChatAssetsAsync", () => $cb2273d8b4b46104$export$1dd15d142465e184);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $fpLIl = parcelRequire("fpLIl");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $cb2273d8b4b46104$export$69b527b529aab52b(action) {
    try {
        const chatId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/chats/${chatId}/assets`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.messageAssetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                chatId: chatId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "chatAssetsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $cb2273d8b4b46104$export$1dd15d142465e184() {
    yield (0, $2AbXc.takeLeading)((0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_PENDING, $cb2273d8b4b46104$export$69b527b529aab52b);
}

});

parcelRegister("afJyW", function(module, exports) {

$parcel$export(module.exports, "watchExportChatAsync", () => $aefc36474a175445$export$88ecd8d419103df3);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $fpLIl = parcelRequire("fpLIl");
function* $aefc36474a175445$export$df43f45055190160(action) {
    try {
        const chatId = action.payload.chatId;
        const exportChatData = action.payload.exportChatData;
        const data = {
            chat: exportChatData
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).patch, `/chats/${chatId}/assets/export`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchChatsSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).EXPORT_CHAT_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "exportChatSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $fpLIl.ChatActionTypes).EXPORT_CHAT_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "exportChatFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $aefc36474a175445$export$88ecd8d419103df3() {
    yield (0, $2AbXc.takeLeading)((0, $fpLIl.ChatActionTypes).EXPORT_CHAT_ASYNC_PENDING, $aefc36474a175445$export$df43f45055190160);
}

});

parcelRegister("5A7aD", function(module, exports) {

$parcel$export(module.exports, "watchFetchPathwaysAddableToCase", () => $670c70c4836412f1$export$49c76af6e07426);

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $cmXxm = parcelRequire("cmXxm");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
function* $670c70c4836412f1$export$5f1d8034631c59d(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/pathways?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.pathwaysSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages,
                resultsPerPage: response.data.searchQuery.resultsPerPage,
                searchTerm: response.data.searchQuery.searchTerm,
                appliedFilters: response.data.searchQuery.appliedFilters,
                orderBy: response.data.searchQuery.orderBy
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "pathwaysNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $670c70c4836412f1$export$49c76af6e07426() {
    yield (0, $2AbXc.takeLeading)((0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_PENDING, $670c70c4836412f1$export$5f1d8034631c59d);
}

});

parcelRegister("daslz", function(module, exports) {

$parcel$export(module.exports, "watchFetchCasePathwaysAsync", () => $2a45e6d614c53309$export$41a5b96c7a029b31);
$parcel$export(module.exports, "watchCreateCasePathwayAsync", () => $2a45e6d614c53309$export$82f48e333a635937);
$parcel$export(module.exports, "watchUpdateCasePathwayAsync", () => $2a45e6d614c53309$export$33243706837f89f4);
$parcel$export(module.exports, "watchUpdateCasePathwayTaskAsync", () => $2a45e6d614c53309$export$d89109831da57e25);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $5dOcp = parcelRequire("5dOcp");
function* $2a45e6d614c53309$export$ba860cffbe9ff46e(action) {
    try {
        const caseId = action.payload;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases/${caseId}/case_pathways`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.casePathwaySchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $2a45e6d614c53309$export$41a5b96c7a029b31() {
    yield (0, $2AbXc.takeLeading)((0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_PENDING, $2a45e6d614c53309$export$ba860cffbe9ff46e);
}
function* $2a45e6d614c53309$export$d4f2a1121c5164d8(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            casePathway: {
                pathwayId: action.payload.pathwayId
            }
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/case_pathways`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.casePathwaySchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCasePathwaySuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCasePathwayFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $2a45e6d614c53309$export$82f48e333a635937() {
    yield (0, $2AbXc.takeLeading)((0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_PENDING, $2a45e6d614c53309$export$d4f2a1121c5164d8);
}
function* $2a45e6d614c53309$export$a5dc8fa788e02246(action) {
    try {
        const caseId = action.payload.caseId;
        const casePathwayId = action.payload.casePathwayId;
        const data = {
            casePathway: action.payload.casePathway
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/cases/${caseId}/case_pathways/${casePathwayId}`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.casePathwaySchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCasePathwaySuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCasePathwayFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $2a45e6d614c53309$export$33243706837f89f4() {
    yield (0, $2AbXc.takeLeading)((0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_PENDING, $2a45e6d614c53309$export$a5dc8fa788e02246);
}
function* $2a45e6d614c53309$export$9b99e636efb4a21b(action) {
    try {
        const taskId = action.payload.taskId;
        const caseId = action.payload.caseId;
        const data = {
            task: action.payload.task
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).put, `/cases/${caseId}/tasks/${taskId}`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.tasksSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_TASK_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCasePathwayTaskSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_TASK_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "updateCasePathwayTaskFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $2a45e6d614c53309$export$d89109831da57e25() {
    yield (0, $2AbXc.takeLeading)((0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_TASK_ASYNC_PENDING, $2a45e6d614c53309$export$9b99e636efb4a21b);
}

});

parcelRegister("gMltz", function(module, exports) {

$parcel$export(module.exports, "watchDeletePathwayAsync", () => $edec8f94777ca367$export$52dda8e6bdb61801);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $eGEsd = parcelRequire("eGEsd");

var $5s7Tw = parcelRequire("5s7Tw");

var $1l1FS = parcelRequire("1l1FS");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $6QJY8 = parcelRequire("6QJY8");
function* $edec8f94777ca367$export$c23bfe1927915440(action) {
    try {
        const pathwayId = action.payload.pathwayId;
        yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/pathways/${pathwayId}`, (0, $1zizz.withAuthHeader)());
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_SUCCESS,
            payload: {
                pathwayId: pathwayId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deletePathwaySuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
        yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).PATHWAYS);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deletePathwayFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $edec8f94777ca367$export$52dda8e6bdb61801() {
    yield (0, $2AbXc.takeLeading)((0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_PENDING, $edec8f94777ca367$export$c23bfe1927915440);
}

});

parcelRegister("hxfav", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseSourceAsync", () => $3666f9e8bd04eb68$export$1b5aa93319b33d49);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $g7ibY = parcelRequire("g7ibY");
function* $3666f9e8bd04eb68$export$df8847daa5d7064a(_action) {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/sources/", (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.caseSourcesSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_SUCCESS,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $3666f9e8bd04eb68$export$1b5aa93319b33d49() {
    yield (0, $2AbXc.takeLeading)((0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_PENDING, $3666f9e8bd04eb68$export$df8847daa5d7064a);
}

});

parcelRegister("5Fqa8", function(module, exports) {

$parcel$export(module.exports, "watchCreateCaseGuestUserAsync", () => $e970c9e3b8e9cc6a$export$ee362d14ac30781d);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $6qYxq = parcelRequire("6qYxq");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $k0jcd = parcelRequire("k0jcd");
function* $e970c9e3b8e9cc6a$export$15797725357747b8(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            user: action.payload.guestUserData
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/guest_users`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, (0, $k0jcd.fetchCaseSchema));
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCaseGuestUserSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCaseGuestUserFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $e970c9e3b8e9cc6a$export$ee362d14ac30781d() {
    yield (0, $2AbXc.takeLeading)((0, $6qYxq.CaseActionTypes).CREATE_CASE_GUEST_USER_ASYNC_PENDING, $e970c9e3b8e9cc6a$export$15797725357747b8);
}

});

parcelRegister("9wRwq", function(module, exports) {

$parcel$export(module.exports, "watchFetchCaseAssetsCanBeSharedWithUser", () => $52db46f1dcf67aa0$export$d41fa58b0b3e6a73);

var $6ye6I = parcelRequire("6ye6I");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $dUFb6 = parcelRequire("dUFb6");
function* $52db46f1dcf67aa0$export$18d392f88ce9cbcd(action) {
    try {
        const caseId = action.payload.caseId;
        const userId = action.payload.userId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/cases/${caseId}/shared_assets?user_id=${userId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId,
                userId: userId
            }
        });
    } catch (error) {
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "fetchCaseAssetsCanBeSharedWithUserError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_ERROR,
            payload: error
        });
    }
}
function* $52db46f1dcf67aa0$export$d41fa58b0b3e6a73() {
    yield (0, $2AbXc.takeLeading)((0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_PENDING, $52db46f1dcf67aa0$export$18d392f88ce9cbcd);
}

});

parcelRegister("eekTo", function(module, exports) {

$parcel$export(module.exports, "watchCreateCaseSharedAssetAsync", () => $6f748ee6a6d85dc3$export$4b82804c88f4df93);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $arZQw = parcelRequire("arZQw");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $dUFb6 = parcelRequire("dUFb6");

var $jiIfA = parcelRequire("jiIfA");
function* $6f748ee6a6d85dc3$export$b774d9ac5215bd6c(action) {
    try {
        const caseId = action.payload.caseId;
        const caseAssetId = action.payload.caseAssetId;
        const userId = action.payload.userId;
        const data = {
            userSharedAsset: {
                caseAssetId: caseAssetId,
                userId: userId
            }
        };
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).post, `/cases/${caseId}/shared_assets`, data, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId,
                userId: userId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCaseSharedAssetSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "createCaseSharedAssetFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $6f748ee6a6d85dc3$export$4b82804c88f4df93() {
    yield (0, $2AbXc.takeLatest)((0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_PENDING, $6f748ee6a6d85dc3$export$b774d9ac5215bd6c);
}

});

parcelRegister("dPkhY", function(module, exports) {

$parcel$export(module.exports, "watchDeleteCaseSharedAssetAsync", () => $d3e2aba70000d4f6$export$52e695ceb74cd832);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $arZQw = parcelRequire("arZQw");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $k0jcd = parcelRequire("k0jcd");

var $dUFb6 = parcelRequire("dUFb6");

var $jiIfA = parcelRequire("jiIfA");
function* $d3e2aba70000d4f6$export$240fa8b5309868d1(action) {
    try {
        const caseId = action.payload.caseId;
        const userSharedAssetId = action.payload.userSharedAssetId;
        const userId = action.payload.userId;
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).delete, `/cases/${caseId}/shared_assets/${userSharedAssetId}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data.all, [
            (0, $k0jcd.assetsSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS,
            payload: {
                all: normalizedResponse,
                caseId: caseId,
                userId: userId
            }
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteCaseSharedAssetSuccess",
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        }));
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "deleteCaseSharedAssetFail",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $d3e2aba70000d4f6$export$52e695ceb74cd832() {
    yield (0, $2AbXc.takeLatest)((0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_PENDING, $d3e2aba70000d4f6$export$240fa8b5309868d1);
}

});

parcelRegister("ecK25", function(module, exports) {

$parcel$export(module.exports, "watchCheckUserAsync", () => $874081d59e6ff686$export$113d7860f2c16fd2);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");

var $1zizz = parcelRequire("1zizz");

var $5s7Tw = parcelRequire("5s7Tw");

var $8e5HJ = parcelRequire("8e5HJ");

var $k0jcd = parcelRequire("k0jcd");
function* $874081d59e6ff686$export$634dace8b6cdf12a(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload.userCheckData), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/users/check?${query}`, (0, $1zizz.withAuthHeader)());
        const normalizedResponse = (0, $6ye6I.normalize)(response.data, [
            (0, $k0jcd.userSchema)
        ]);
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_FOUND,
            payload: normalizedResponse
        });
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_NOT_FOUND,
            payload: error
        });
    }
}
function* $874081d59e6ff686$export$113d7860f2c16fd2() {
    yield (0, $2AbXc.takeLeading)((0, $8e5HJ.UserActionTypes).CHECK_USER_ASYNC_PENDING, $874081d59e6ff686$export$634dace8b6cdf12a);
}

});

parcelRegister("3Lz9Y", function(module, exports) {

$parcel$export(module.exports, "watchAnalyticsActions", () => $e2b136f5710b900e$export$95d2b0e18ab70f64);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $efsoN = parcelRequire("efsoN");

var $6cmjs = parcelRequire("6cmjs");
function* $e2b136f5710b900e$export$95d2b0e18ab70f64() {
    yield (0, $2AbXc.takeLeading)((0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_PENDING, $e2b136f5710b900e$export$60960dd0607dfeac);
    yield (0, $2AbXc.takeLeading)((0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_PENDING, $e2b136f5710b900e$export$1b2474068ca80b61);
}
function* $e2b136f5710b900e$export$60960dd0607dfeac(action) {
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/analytics/hospital/${action.payload}`, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $6cmjs.AnalyticsActionTypes).FETCH_HOSPITAL_DATA_ERROR, error);
    }
}
function* $e2b136f5710b900e$export$1b2474068ca80b61(action) {
    const { userId: userId, year: year } = action.payload;
    try {
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/analytics/user/${userId}/${year}`, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_SUCCESS, response.data);
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $6cmjs.AnalyticsActionTypes).FETCH_USER_DATA_ERROR, error);
    }
}

});

parcelRegister("egaCo", function(module, exports) {

$parcel$export(module.exports, "watchAppActions", () => $e756443ea3321815$export$ccda15dd035885a2);
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $6QJY8 = parcelRequire("6QJY8");

var $4NV2o = parcelRequire("4NV2o");

var $1l1FS = parcelRequire("1l1FS");

var $5YAlZ = parcelRequire("5YAlZ");
function* $e756443ea3321815$export$ccda15dd035885a2() {
    yield (0, $2AbXc.takeLeading)((0, $4NV2o.AppActionTypes).CHECK_SESSION_ACTIVE_PENDING, $e756443ea3321815$export$542d0bdbdb619c3d);
}
function* $e756443ea3321815$export$542d0bdbdb619c3d(_action) {
    try {
        yield (0, $k6WuE.O)((0, $5s7Tw.default).get, "/status/session", (0, $1zizz.withAuthHeader)());
    } catch (_error) {
        const error = _error;
        if (error.response?.status == 401) {
            yield (0, $k6WuE.Z)((0, $5YAlZ.signOutUserAction)());
            yield (0, $k6WuE.O)((0, $1l1FS.default).push, (0, $6QJY8.RoutePaths).SIGN_IN);
        }
    }
}

});
parcelRegister("5YAlZ", function(module, exports) {

$parcel$export(module.exports, "setPasswordAction", () => $64131b5c1d7ca1ed$export$49b1673f267bf4f2);
$parcel$export(module.exports, "sendResetPasswordLinkAction", () => $64131b5c1d7ca1ed$export$6eee9411098b1a63);
$parcel$export(module.exports, "signInUserAction", () => $64131b5c1d7ca1ed$export$9021889682d58dcf);
$parcel$export(module.exports, "signOutUserAction", () => $64131b5c1d7ca1ed$export$11ce0a60aecc3d41);
$parcel$export(module.exports, "userSignInTypeAction", () => $64131b5c1d7ca1ed$export$fc2d8d3bc642e240);
$parcel$export(module.exports, "fetchTermsAction", () => $64131b5c1d7ca1ed$export$55ba67b9c45e3d92);
$parcel$export(module.exports, "acceptTermsAction", () => $64131b5c1d7ca1ed$export$caa9c6d46ec695a6);

var $lnXep = parcelRequire("lnXep");
const $64131b5c1d7ca1ed$export$49b1673f267bf4f2 = (setPasswordData)=>{
    return {
        type: (0, $lnXep.AccountActionTypes).SET_PASSWORD_ASYNC_PENDING,
        payload: setPasswordData
    };
};
const $64131b5c1d7ca1ed$export$6eee9411098b1a63 = (email)=>{
    return {
        type: (0, $lnXep.AccountActionTypes).SEND_RESET_PASSWORD_LINK_ASYNC_PENDING,
        payload: {
            email: email
        }
    };
};
const $64131b5c1d7ca1ed$export$9021889682d58dcf = (email, password)=>{
    return {
        type: (0, $lnXep.AccountActionTypes).SIGN_IN_USER_ASYNC_PENDING,
        payload: {
            email: email,
            password: password
        }
    };
};
const $64131b5c1d7ca1ed$export$11ce0a60aecc3d41 = ()=>{
    return {
        type: (0, $lnXep.AccountActionTypes).SIGN_OUT_USER_ASYNC_PENDING
    };
};
const $64131b5c1d7ca1ed$export$fc2d8d3bc642e240 = (email)=>{
    return {
        type: (0, $lnXep.AccountActionTypes).USER_SIGN_IN_TYPE_ASYNC_PENDING,
        payload: email
    };
};
const $64131b5c1d7ca1ed$export$55ba67b9c45e3d92 = ()=>{
    return {
        type: (0, $lnXep.AccountActionTypes).FETCH_TERMS_ASYNC_PENDING
    };
};
const $64131b5c1d7ca1ed$export$caa9c6d46ec695a6 = (acceptTermsData)=>{
    return {
        type: (0, $lnXep.AccountActionTypes).ACCEPT_TERMS_ASYNC_PENDING,
        payload: acceptTermsData
    };
};

});


parcelRegister("3mrfe", function(module, exports) {

$parcel$export(module.exports, "watchFormsActions", () => $152efc0a58145a38$export$ff9fb9a5e637abeb);

var $6ye6I = parcelRequire("6ye6I");

var $5ofNJ = parcelRequire("5ofNJ");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("cd5S4");
var $k6WuE = parcelRequire("k6WuE");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $k0jcd = parcelRequire("k0jcd");

var $udwHW = parcelRequire("udwHW");

var $efsoN = parcelRequire("efsoN");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
function* $152efc0a58145a38$export$ff9fb9a5e637abeb() {
    yield (0, $2AbXc.takeLeading)((0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING, $152efc0a58145a38$export$f82131477a7587d);
    yield (0, $2AbXc.takeLeading)((0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_PENDING, $152efc0a58145a38$export$ba51fe5acb7cdb83);
    yield (0, $2AbXc.takeLeading)((0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_PENDING, $152efc0a58145a38$export$bb5ab97fd9d2c01c);
}
function* $152efc0a58145a38$export$f82131477a7587d(action) {
    try {
        const query = (0, $5ofNJ.default).stringify((0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelizeKeys(action.payload), {
            arrayFormat: "bracket"
        });
        const response = yield (0, $k6WuE.O)((0, $5s7Tw.default).get, `/form_templates?${query}`, (0, $1zizz.withAuthHeader)());
        const normalisedResponse = (0, $6ye6I.normalize)(response.data.formTemplates.all, [
            (0, $k0jcd.contextFormTemplatesSchema)
        ]);
        const data = {
            all: normalisedResponse,
            totalItems: response.data.formTemplates.totalItems,
            totalPages: response.data.formTemplates.totalPages,
            searchTerm: response.data.formTemplates.searchTerm,
            resultsPerPage: response.data.formTemplates.resultsPerPage
        };
        yield (0, $efsoN.handleSuccess)((0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS, data);
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "formsNotFound",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $152efc0a58145a38$export$ba51fe5acb7cdb83(action) {
    try {
        const caseId = action.payload.caseId;
        const data = {
            form: action.payload
        };
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "generatingForm",
            type: (0, $jiIfA.UserMessageTypes).MESSAGE
        }));
        const normalisedResponse = yield (0, $efsoN.postNormalisedMultiple)(`/cases/${caseId}/forms`, data, [
            (0, $k0jcd.assetsSchema)
        ]);
        const payload = {
            all: normalisedResponse,
            caseId: caseId
        };
        yield (0, $efsoN.handleSuccess)((0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_SUCCESS, payload, "addFormToCaseSuccess");
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "formsError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}
function* $152efc0a58145a38$export$bb5ab97fd9d2c01c(action) {
    try {
        const { caseId: caseId, formId: formId } = action.payload;
        const normalisedResponse = yield (0, $efsoN.patchNormalisedMultiple)(`/cases/${caseId}/forms/${formId}/complete`, {}, [
            (0, $k0jcd.assetsSchema)
        ]);
        const payload = {
            all: normalisedResponse,
            caseId: caseId
        };
        yield (0, $efsoN.handleSuccess)((0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_SUCCESS, payload, 'formFinalised');
    } catch (error) {
        yield (0, $k6WuE.Z)({
            type: (0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_ERROR,
            payload: error
        });
        yield (0, $k6WuE.Z)((0, $arZQw.displayUserMessageAction)({
            messageKey: "formsError",
            type: (0, $jiIfA.UserMessageTypes).ERROR
        }));
    }
}

});

parcelRegister("bQbFW", function(module, exports) {

$parcel$export(module.exports, "mfaWatchers", () => $2e69210b8c8d2b65$export$f1d66cf7b77eb6c1);
parcelRequire("cd5S4");
var $2AbXc = parcelRequire("2AbXc");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $efsoN = parcelRequire("efsoN");

var $iLVpj = parcelRequire("iLVpj");
function* $2e69210b8c8d2b65$export$f1d66cf7b77eb6c1() {
    yield (0, $2AbXc.takeLeading)((0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_PENDING, $2e69210b8c8d2b65$export$901df18a394334da);
}
function* $2e69210b8c8d2b65$export$901df18a394334da() {
    try {
        console.log('requesting sms');
        yield (0, $5s7Tw.default).post("/user/mfa/request_sms", {}, (0, $1zizz.withAuthHeader)());
        yield (0, $efsoN.handleSuccess)((0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_SUCCESS, {});
    } catch (error) {
        yield (0, $efsoN.handleError)((0, $iLVpj.MfaActionTypes).REQUEST_SMS_ASYNC_ERROR, {}, "failed to request sms");
    }
}

});



parcelRegister("iChsq", function(module, exports) {

$parcel$export(module.exports, "CableContext", () => $6d4415edb5370dad$export$783f4ea5e98b1646);

var $acw62 = parcelRequire("acw62");
const $6d4415edb5370dad$export$2d13e8d3de5c86c5 = {
    apiToken: null,
    consumer: null
};
const $6d4415edb5370dad$export$783f4ea5e98b1646 = /*#__PURE__*/ (0, $acw62.createContext)($6d4415edb5370dad$export$2d13e8d3de5c86c5);

});


parcelRegister("e5EhV", function(module, exports) {

$parcel$export(module.exports, "useBeforeunload", () => $a420c8ac9aa89d16$export$13d79309672339b7);


var $acw62 = parcelRequire("acw62");

var $bv4qN = parcelRequire("bv4qN");
var $a420c8ac9aa89d16$export$13d79309672339b7 = function useBeforeunload(handler) {
    !(handler == null || typeof handler === 'function') && (0, $bv4qN.default)(false);
    var eventListenerRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        eventListenerRef.current = function(event) {
            var returnValue = handler === null || handler === void 0 ? void 0 : handler(event); // Handle legacy `event.returnValue` property
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
            if (typeof returnValue === 'string') return event.returnValue = returnValue;
             // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`,
            // instead it requires `event.returnValue` to be set
            // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#browser_compatibility
            if (event.defaultPrevented) return event.returnValue = '';
        };
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(function() {
        var eventListener = function eventListener(event) {
            return eventListenerRef.current(event);
        };
        window.addEventListener('beforeunload', eventListener);
        return function() {
            window.removeEventListener('beforeunload', eventListener);
        };
    }, []);
};
var $a420c8ac9aa89d16$export$5e7abcec81feb406 = function Beforeunload(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, onBeforeunload = _ref.onBeforeunload;
    $a420c8ac9aa89d16$export$13d79309672339b7(onBeforeunload);
    return children;
};
$a420c8ac9aa89d16$export$5e7abcec81feb406.propTypes = {};

});
parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});



parcelRegister("hFs6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $990800ce7e5f5453$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $5phYc = parcelRequire("5phYc");

var $4VtCQ = parcelRequire("4VtCQ");
const $990800ce7e5f5453$var$LiveMeetingCaseSelect = ({ meetingId: meetingId, closeModal: closeModal })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const meetingCaseIds = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseIds)(state, {
            meetingId: meetingId
        }));
    if (!meetingCaseIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: t("case:noCases")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "p-2 border-ch-gray-300 border",
        children: meetingCaseIds.map((meetingCaseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5phYc.default), {
                closeModal: closeModal,
                meetingCaseId: meetingCaseId
            }, meetingCaseId);
        })
    });
};
var $990800ce7e5f5453$export$2e2bcd8739ae039 = $990800ce7e5f5453$var$LiveMeetingCaseSelect;

});
parcelRegister("5phYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b442c878699620$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $rDKvs = parcelRequire("rDKvs");

var $jF0Xa = parcelRequire("jF0Xa");

var $5v6Bi = parcelRequire("5v6Bi");

var $50NSH = parcelRequire("50NSH");

var $4VtCQ = parcelRequire("4VtCQ");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $3mOhS = parcelRequire("3mOhS");
const $e3b442c878699620$var$LiveMeetingCaseSelectItem = ({ closeModal: closeModal, meetingCaseId: meetingCaseId })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const onMeetingCaseSelected = (meetingCaseId)=>dispatch((0, $rDKvs.selectMeetingCaseAction)(meetingCaseId));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, {
            meetingCaseId: meetingCaseId
        }));
    const selectedMeetingCaseId = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseId));
    const onClickSelectMeetingCase = (meetingCaseId)=>{
        closeModal();
        onMeetingCaseSelected(meetingCaseId);
    };
    const renderButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>onClickSelectMeetingCase(meetingCase.id),
            className: "self-center self-end",
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            isChunky: true,
            isDisabled: selectedMeetingCaseId == meetingCaseId,
            children: t("shared:select")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: "flex flex-1 mb-2 bg-ch-gray-300 rounded-md p-4 justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                className: "mr-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                    className: "fill-current w-6 h-6",
                    title: t("shared:case")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 mr-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50NSH.default), {
                    meetingCaseId: meetingCaseId
                })
            }),
            renderButton()
        ]
    });
};
var $e3b442c878699620$export$2e2bcd8739ae039 = $e3b442c878699620$var$LiveMeetingCaseSelectItem;

});
parcelRegister("5v6Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c77daaf294cf477$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1c77daaf294cf477$var$IconCircleContainer = (props)=>{
    const defaultClasses = [
        "flex",
        "items-center",
        "justify-center",
        "p-1",
        "bg-white",
        "border",
        "border-ch-gray-500",
        "rounded-full"
    ];
    const sizeClasses = props.sizeClasses ? props.sizeClasses : [
        "w-12",
        "h-12"
    ];
    const colour = props.colour || "text-ch-purple-500";
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses,
        colour,
        ...sizeClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: props.children
    });
};
var $1c77daaf294cf477$export$2e2bcd8739ae039 = $1c77daaf294cf477$var$IconCircleContainer;

});

parcelRegister("50NSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac57e83a0ae8daa9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");

var $bP3DF = parcelRequire("bP3DF");

var $4VtCQ = parcelRequire("4VtCQ");

var $kon2z = parcelRequire("kon2z");

var $QwmFv = parcelRequire("QwmFv");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $7hl6H = parcelRequire("7hl6H");

var $6ic8I = parcelRequire("6ic8I");

var $2qME2 = parcelRequire("2qME2");

var $aEgqS = parcelRequire("aEgqS");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $ljbUa = parcelRequire("ljbUa");

var $3Ukkm = parcelRequire("3Ukkm");
const $ac57e83a0ae8daa9$var$MeetingCaseDetails = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, props));
    const caseData = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: meetingCase.case
        }));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getLeadCareUserByCaseId)(state, {
            caseId: meetingCase.case
        }));
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const meetingCaseDetailsPath = ()=>(0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_CASE, {
            meetingCaseId: props.meetingCaseId
        });
    if (!caseData) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const caseDetailsPath = ()=>(0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
            caseId: caseData.id
        });
    const renderPatientName = ()=>{
        const renderRecommendationLabel = ()=>{
            const status = meetingCase.recommendationStatus;
            if (!status) return null;
            if (status == (0, $bP3DF.MeetingCaseRecommendationStatus).RECOMMENDED) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-sm text-white px-1 rounded bg-ch-green-300 ml-2 flex content-center",
                children: t("case:recommended")
            });
            if (status == (0, $bP3DF.MeetingCaseRecommendationStatus).DEFERRED) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-sm text-white px-1 rounded bg-ch-blue-500 ml-2 flex content-center",
                children: t("case:deferred")
            });
            if (status == (0, $bP3DF.MeetingCaseRecommendationStatus).RECOMMENDATION_PENDING) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-sm text-white px-1 rounded bg-ch-yellow-500 ml-2 flex content-center",
                children: t("case:recommendationPending")
            });
            return null;
        };
        let link = "";
        if (props.hasLink) link = meetingCaseDetailsPath();
        else if (props.hasCaseLink) link = caseDetailsPath();
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "flex flex-row items-baseline",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ljbUa.default), {
                case: caseData,
                hasLink: !!props.hasCaseLink || !!props.hasLink,
                link: link,
                children: renderRecommendationLabel()
            })
        });
    };
    const renderGender = ()=>{
        if (!caseData.gender) return null;
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(caseData.gender);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:gender"),
                ": ",
                t(`shared:${translationKey}`)
            ]
        });
    };
    const renderDateOfBirth = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:dateOfBirth"),
                ":",
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                    utcTime: caseData.dateOfBirth
                })
            ]
        });
    };
    const renderPatientHealthcareId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                healthcareIdLabel,
                ": ",
                caseData.healthcareId
            ]
        });
    };
    const renderPatientCareProviderId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                careProviderIdLabel,
                ": ",
                caseData.careProviderId
            ]
        });
    };
    const renderCaseType = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:type"),
                ":",
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                    caseType: caseData.caseType
                })
            ]
        });
    };
    const renderLeadCare = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ":",
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    const renderClassification = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": ",
                caseData.classification
            ]
        });
    };
    const renderSourceName = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:source"),
                ": ",
                caseData.sourceName
            ]
        });
    };
    const renderSignedOffBy = ()=>{
        if (!caseData.signedOffBy) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:signedOffBy"),
                ": ",
                caseData.signedOffBy
            ]
        });
    };
    const renderLastUpdated = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:lastUpdated"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: caseData.updatedAt
                })
            ]
        });
    };
    const renderCondensedDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
            children: [
                renderPatientName(),
                renderDateOfBirth(),
                renderPatientHealthcareId(),
                renderPatientCareProviderId()
            ]
        });
    };
    const renderFullDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-grow flex-1 lg:grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderPatientName(),
                                renderGender(),
                                renderDateOfBirth(),
                                renderPatientHealthcareId(),
                                renderPatientCareProviderId(),
                                renderSourceName()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderLeadCare(),
                                renderCaseType(),
                                renderClassification(),
                                renderLastUpdated(),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ic8I.default), {
                                    caseId: caseData.id
                                }),
                                renderSignedOffBy()
                            ]
                        })
                    ]
                }),
                props.renderLockCase ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2qME2.default), {
                    caseId: meetingCase.case
                }) : null
            ]
        });
    };
    return props.isCondensed ? renderCondensedDetails() : renderFullDetails();
};
var $ac57e83a0ae8daa9$export$2e2bcd8739ae039 = $ac57e83a0ae8daa9$var$MeetingCaseDetails;

});
parcelRegister("QwmFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e993604186ae0002$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");
const $e993604186ae0002$var$TextCaseType = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.caseType);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: t(`case:${translationKey}`)
    });
};
var $e993604186ae0002$export$2e2bcd8739ae039 = $e993604186ae0002$var$TextCaseType;

});

parcelRegister("6ic8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $127a7521779d286f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kon2z = parcelRequire("kon2z");

var $6OX6Q = parcelRequire("6OX6Q");
var $baBa1 = parcelRequire("baBa1");
var $bFCxg = parcelRequire("bFCxg");
parcelRequire("jitSV");
var $9IdeF = parcelRequire("9IdeF");
var $lHtgo = parcelRequire("lHtgo");

var $8g1PZ = parcelRequire("8g1PZ");

var $eUISl = parcelRequire("eUISl");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $127a7521779d286f$var$TargetDate = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const targetDate = new Date(theCase.targetDate);
    const today = new Date;
    const targetDateIsDue = (0, $baBa1.default)((0, $6OX6Q.default)(today, 3), targetDate);
    const targetDateIsOverdue = (0, $bFCxg.default)(targetDate);
    const renderTargetDateFulfilled = ()=>{
        if (!theCase.targetDateFulfilledOn) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:targetDateFulfilledOn"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                    utcTime: theCase.targetDateFulfilledOn
                }),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lHtgo.default), {
                    className: "w-4 h-4 text-ch-green-300 inline-block -mt-1"
                })
            ]
        });
    };
    const renderTargetDateAlertIcon = ()=>{
        if (!targetDateIsDue && !targetDateIsOverdue) return null;
        const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-5 h-5 inline-block -mt-2", {
            "text-ch-blue-500": targetDateIsDue && !targetDateIsOverdue,
            "text-ch-orange-500": targetDateIsOverdue
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9IdeF.default), {
            className: iconClassNames
        });
    };
    if (!theCase) return null;
    if (!theCase.targetDate) return null;
    if (theCase.targetDateFulfilledOn) return renderTargetDateFulfilled();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        children: [
            t("case:targetDate"),
            ": ",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "font-semibold": targetDateIsOverdue
                }),
                utcTime: theCase.targetDate
            }),
            " ",
            renderTargetDateAlertIcon()
        ]
    });
};
var $127a7521779d286f$export$2e2bcd8739ae039 = $127a7521779d286f$var$TargetDate;

});
parcelRegister("baBa1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $821d7431eba4c146$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("bFCxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $87f16a64cc24b14f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $87f16a64cc24b14f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $gdr0J.default)(dirtyDate).getTime() < Date.now();
}

});

parcelRegister("eUISl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5733e0ee8b83dc3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");

var $1Lj4p = parcelRequire("1Lj4p");
const $c5733e0ee8b83dc3$var$TimeDateOnly = ({ utcTime: utcTime, className: className })=>{
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    if (!utcTime) return null;
    const formattedDate = (0, $ahLi9.dateOnly)(utcTime, timezone);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: className,
        children: formattedDate
    });
};
var $c5733e0ee8b83dc3$export$2e2bcd8739ae039 = $c5733e0ee8b83dc3$var$TimeDateOnly;

});


parcelRegister("2qME2", function(module, exports) {

$parcel$export(module.exports, "default", () => $eac6fd617b013502$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $4KSAX = parcelRequire("4KSAX");

var $kon2z = parcelRequire("kon2z");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $2usJc = parcelRequire("2usJc");

var $7jD0k = parcelRequire("7jD0k");

var $32kQ2 = parcelRequire("32kQ2");

var $f1q41 = parcelRequire("f1q41");
const $eac6fd617b013502$var$LockCaseButton = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const [confirmIsOpen, setConfirmIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [caseHasScheduledMeetings, setCaseHasScheduledMeetings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const caseMeetings = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getMeetingsForCase)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const toggleLocked = (caseData)=>dispatch((0, $2usJc.toggleCaseLocked)(caseData));
    (0, $acw62.useEffect)(()=>{
        if (!theCase || !caseMeetings) return;
        // TODO: remove filtering here and only return meeting options from
        // the api that should be visible
        const nonEndedCaseMeetings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(caseMeetings, (meeting)=>{
            // if the meeting is not available, we'll have to assume it is not ended
            if (!meeting || !meeting?.status) return true;
            return meeting.status !== (0, $32kQ2.MeetingStatuses).Ended && meeting.status !== (0, $32kQ2.MeetingStatuses).Cancelled;
        });
        setCaseHasScheduledMeetings(nonEndedCaseMeetings.length > 0 ? true : false);
    }, [
        caseMeetings
    ]);
    const renderCaseLockedMessage = ()=>{
        if (!theCase.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-gray-alt-500",
            children: t("case:caseIsLocked")
        });
    };
    const openConfirm = ()=>{
        setConfirmIsOpen(true);
    };
    const closeConfirm = ()=>{
        setConfirmIsOpen(false);
    };
    const confirmModalText = ()=>{
        if (theCase.locked) return t("case:unlockCaseDesc");
        else if (caseHasScheduledMeetings) return t("case:cannotLockCaseWithScheduledMeetings");
        else return t("case:lockCaseDesc");
    };
    const toggleLockHandler = ()=>{
        const caseData = {
            id: props.caseId,
            locked: !theCase.locked
        };
        toggleLocked(caseData);
        closeConfirm();
    };
    if (theCase.permissions?.canEdit) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: openConfirm,
                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                children: theCase.locked ? t("case:unlockCase") : t("case:lockCase")
            }, "1"),
            renderCaseLockedMessage(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: confirmIsOpen,
                onRequestClose: closeConfirm,
                style: (0, $jF0Xa.dialogueModalStyle),
                overlayClassName: "ReactModal__Overlay flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeConfirm,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: theCase.locked ? t("case:unlockCaseTitle") : t("case:lockCaseTitle")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600 mb-3",
                            children: confirmModalText()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: closeConfirm,
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: caseHasScheduledMeetings,
                                    action: ()=>toggleLockHandler(),
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    children: theCase.locked ? t("case:unlockCase") : t("case:lockCase")
                                }, "2")
                            ]
                        })
                    ]
                })
            })
        ]
    });
    else return renderCaseLockedMessage();
};
var $eac6fd617b013502$export$2e2bcd8739ae039 = $eac6fd617b013502$var$LockCaseButton;

});

parcelRegister("ljbUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d9bba47b978f82$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $6t04b = parcelRequire("6t04b");

var $1DXYh = parcelRequire("1DXYh");
parcelRequire("jitSV");
var $8lynw = parcelRequire("8lynw");
const $d6d9bba47b978f82$var$PatientNameWithLock = ({ hasLink: hasLink = true, ...props })=>{
    if (!props.case) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    // this is the fallback path if not provided. Previously this was the default behaviour
    const caseLinkPath = ()=>(0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
            caseId: props.case.id
        });
    const patientNameText = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
        firstName: props.case.firstName,
        lastName: props.case.lastName,
        title: props.case.title
    });
    const renderText = ()=>{
        if (!hasLink) return patientNameText;
        const link = props.link || caseLinkPath();
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
            href: link,
            children: patientNameText
        });
    };
    const renderLockIcon = ()=>{
        if (!props.case.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-purple-500 ml-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8lynw.default), {
                className: "w-4 h-4",
                title: t("case:lockedIconTitle")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: renderText()
            }),
            renderLockIcon(),
            props.children
        ]
    });
};
var $d6d9bba47b978f82$export$2e2bcd8739ae039 = $d6d9bba47b978f82$var$PatientNameWithLock;

});
parcelRegister("1DXYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06702366b47455f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $jF0Xa = parcelRequire("jF0Xa");
const $c06702366b47455f$var$TextLink = ({ variant: variant = (0, $jF0Xa.StyleVariants).BLUE, targetBlank: targetBlank = false, className: className, href: href, linkProps: linkProps, children: children, action: action })=>{
    const defaultClasses = [
        `text-${variant}-500`,
        `hover:text-${variant}-600`
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    if (href && targetBlank) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        ...linkProps,
        href: href,
        className: allClasses,
        target: "_blank",
        rel: "noreferrer",
        children: children
    });
    if (href) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Link), {
        ...linkProps,
        to: href,
        className: allClasses,
        children: children
    });
    if (action) return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "button",
        onClick: action,
        className: allClasses,
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        type: "submit",
        className: allClasses,
        children: children
    });
};
var $c06702366b47455f$export$2e2bcd8739ae039 = $c06702366b47455f$var$TextLink;

});





parcelRegister("dQiiy", function(module, exports) {

$parcel$export(module.exports, "getLiveMeetingConfig", () => $ab434f5a916e3a16$export$4f51420b459ee94d);
const $ab434f5a916e3a16$export$4f51420b459ee94d = (state)=>state.liveMeetingConfig;

});


parcelRegister("KCPBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a1de35baaa78f4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kGUIk = parcelRequire("kGUIk");

var $g7GJo = parcelRequire("g7GJo");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $rDKvs = parcelRequire("rDKvs");

var $6lvMC = parcelRequire("6lvMC");

var $dyeCj = parcelRequire("dyeCj");
// stream.videoType will be 'screen' when the screen share button is initiated.
// For the PACS, we set the media stream outside TokBox and videoType gets set
// to 'custom'
const $77a1de35baaa78f4$var$streamIsScreen = (stream)=>stream.videoType == "screen" || stream.videoType == "custom";
const $77a1de35baaa78f4$var$WebRTCSession = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const session = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCSession));
    const displayUserMessage = (messageKey, type)=>{
        dispatch((0, $arZQw.displayUserMessageAction)({
            messageKey: messageKey,
            type: type
        }));
    };
    const eventHandlers = {
        streamCreated: (event)=>{
            // Another user has joined the session
            const userId = (0, $g7GJo.getStreamUserId)(event.stream);
            if ($77a1de35baaa78f4$var$streamIsScreen(event.stream)) dispatch((0, $kGUIk.updateWebRTCScreenStreamAction)(event.stream));
            else dispatch((0, $kGUIk.addWebRTCStreamAction)(userId, event.stream));
        },
        streamDestroyed: (event)=>{
            // Another user has left the session
            const userId = (0, $g7GJo.getStreamUserId)(event.stream);
            if ($77a1de35baaa78f4$var$streamIsScreen(event.stream)) dispatch((0, $kGUIk.updateWebRTCScreenStreamAction)(null));
            else dispatch((0, $kGUIk.removeWebRTCStreamAction)(userId));
        },
        streamPropertyChanged: (event)=>{
            // A user has toggled their audio or video
            if ($77a1de35baaa78f4$var$streamIsScreen(event.stream)) return;
            const userId = (0, $g7GJo.getStreamUserId)(event.stream);
            dispatch((0, $kGUIk.updateWebRTCStreamAction)(userId, event.stream));
            const isCurrentUserStream = userId == currentUser.id;
            const valueHasChanged = event.newValue !== event.oldValue;
            if (!isCurrentUserStream || !valueHasChanged) return;
            switch(event.changedProperty){
                case "hasAudio":
                    dispatch((0, $rDKvs.toggleIsSharingAudioAction)(userId, event.newValue));
                    break;
                case "hasVideo":
                    dispatch((0, $rDKvs.toggleIsSharingVideoAction)(userId, event.newValue));
                    break;
            }
        },
        sessionReconnecting: (event)=>{
            dispatch((0, $kGUIk.updateWebRTCSessionAction)(event.target));
            displayUserMessage("webRTCSessionReconnecting", (0, $jiIfA.UserMessageTypes).MESSAGE);
        },
        sessionReconnected: (event)=>{
            dispatch((0, $kGUIk.updateWebRTCSessionAction)(event.target));
            displayUserMessage("webRTCSessionReconnected", (0, $jiIfA.UserMessageTypes).SUCCESS);
        },
        sessionDisconnected: (event)=>{
            if (event.reason == "networkDisconnected") displayUserMessage("webRTCSessionDisconnected", (0, $jiIfA.UserMessageTypes).ERROR);
        }
    };
    (0, $acw62.useEffect)(()=>{
        // Connect to the webRTC session when sessionId is provided
        if (!props.sessionId) return;
        dispatch((0, $kGUIk.connectToWebRTCSessionAction)(props.webRtcApiKey, props.sessionId, props.meetingToken, eventHandlers));
    }, [
        props.sessionId
    ]);
    (0, $acw62.useEffect)(()=>{
        // Disconnect from the webRTC session when component unmounts and there is an existing connection
        if (!session?.connection) return;
        return ()=>{
            dispatch((0, $kGUIk.disconnectFromWebRTCSessionAction)(session));
        };
    }, [
        session
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $rDKvs.toggleIsPresentAction)(currentUser.id, true));
        return ()=>{
            dispatch((0, $rDKvs.toggleIsPresentAction)(currentUser.id, false));
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: props.children
    });
};
var $77a1de35baaa78f4$export$2e2bcd8739ae039 = $77a1de35baaa78f4$var$WebRTCSession;

});

parcelRegister("xQehV", function(module, exports) {

$parcel$export(module.exports, "userStreamPublisherOptions", () => $a07b6bf87dded263$export$d12ec75954a1823d);
$parcel$export(module.exports, "userStreamSubscriberOptions", () => $a07b6bf87dded263$export$cad9b827ffeffe4a);
$parcel$export(module.exports, "currentUserStreamSubscriberOptions", () => $a07b6bf87dded263$export$7dbdf22bb90ff492);
$parcel$export(module.exports, "screenshareStreamPublisherOptions", () => $a07b6bf87dded263$export$6e1737c355f4c1ac);
$parcel$export(module.exports, "screenshareStreamSubscriberOptions", () => $a07b6bf87dded263$export$d66adba3f476f83);
const $a07b6bf87dded263$export$d12ec75954a1823d = {
    insertMode: "append",
    resolution: "320x240",
    frameRate: 7,
    width: "100%",
    height: "100%",
    fitMode: "cover",
    audioBitrate: 28000,
    publishAudio: false,
    publishVideo: false,
    showControls: false
};
const $a07b6bf87dded263$export$cad9b827ffeffe4a = {
    insertMode: "append",
    preferredResolution: {
        width: 320,
        height: 240
    },
    preferredFrameRate: 7,
    width: "100%",
    height: "100%",
    fitMode: "cover",
    showControls: false
};
const $a07b6bf87dded263$export$7dbdf22bb90ff492 = {
    insertMode: "append",
    width: "100%",
    height: "100%",
    fitMode: "cover",
    showControls: false,
    subscribeToAudio: false
};
const $a07b6bf87dded263$export$6e1737c355f4c1ac = {
    insertMode: "append",
    resolution: "1280x720",
    frameRate: 15,
    width: "100%",
    height: "100%",
    fitMode: "contain",
    videoSource: "window",
    publishVideo: true,
    publishAudio: false,
    showControls: false
};
const $a07b6bf87dded263$export$d66adba3f476f83 = {
    insertMode: "append",
    preferredResolution: {
        width: 1280,
        height: 720
    },
    preferredFrameRate: 15,
    width: "100%",
    height: "100%",
    fitMode: "contain"
};

});

parcelRegister("3TcXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b97e19d92689293$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kGUIk = parcelRequire("kGUIk");

var $g7GJo = parcelRequire("g7GJo");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $rDKvs = parcelRequire("rDKvs");

var $dyeCj = parcelRequire("dyeCj");
const $6b97e19d92689293$var$WebRTCPublisher = (props)=>{
    const [hasPublished, setHasPublished] = (0, $acw62.useState)(false);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const publisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCPublisher));
    const session = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCSession));
    const connection = publisher?.session?.connection;
    const dispatch = (0, $2OPjR.useDispatch)();
    const eventHandlers = {
        streamCreated: (event)=>{
            // current user local stream published to session
            // user considered online
            const stream = event.stream;
            const publisher = event.target;
            const userId = (0, $g7GJo.getStreamUserId)(stream);
            dispatch((0, $kGUIk.updateWebRTCPublisherAction)(publisher));
            dispatch((0, $kGUIk.addWebRTCStreamAction)(userId, stream));
            dispatch((0, $rDKvs.toggleIsOnlineAction)(userId, true));
            dispatch((0, $rDKvs.toggleIsSharingAudioAction)(userId, stream.hasAudio));
            dispatch((0, $rDKvs.toggleIsSharingVideoAction)(userId, stream.hasVideo));
        },
        streamDestroyed: (event)=>{
            // current user local stream unpublished from session
            // user considered offline
            const publisher = event.target;
            const userId = (0, $g7GJo.getStreamUserId)(event.stream);
            dispatch((0, $kGUIk.updateWebRTCPublisherAction)(publisher));
            dispatch((0, $kGUIk.removeWebRTCStreamAction)(userId));
            dispatch((0, $rDKvs.toggleIsOnlineAction)(userId, false));
        },
        accessDenied: (_event)=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "webRTCAccessDenied",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        }
    };
    (0, $acw62.useEffect)(()=>{
        // Publish to session after connection has been established
        if (!session?.connection && !hasPublished) return;
        dispatch((0, $kGUIk.publishToWebRTCSessionAction)(session, containerRef, props.publisherOptions, eventHandlers));
        setHasPublished(true);
    }, [
        session
    ]);
    (0, $acw62.useEffect)(()=>{
        // If connection to session is destroyed unpublish
        // Streams will then in turn be destroyed
        if (!connection) return;
        return ()=>{
            dispatch((0, $kGUIk.unpublishFromWebRTCSessionAction)(publisher.session, publisher));
        };
    }, [
        connection
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: containerRef,
        className: "hidden"
    });
};
var $6b97e19d92689293$export$2e2bcd8739ae039 = $6b97e19d92689293$var$WebRTCPublisher;

});

parcelRegister("cYRvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfeeb623675bc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9d16U = parcelRequire("9d16U");

var $xQehV = parcelRequire("xQehV");

var $5MrNT = parcelRequire("5MrNT");

var $kN4w7 = parcelRequire("kN4w7");

var $6lvMC = parcelRequire("6lvMC");

var $jf12H = parcelRequire("jf12H");

var $3FWaP = parcelRequire("3FWaP");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $beedfeeb623675bc$var$LiveMeetingSharedView = (props)=>{
    const presenter = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getLiveMeetingPresenter)(state, props));
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const isPresenter = user?.config?.isPresenter;
    const [ref, setRef] = (0, $acw62.useState)();
    const renderSharedView = ()=>{
        if (isPresenter) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jf12H.default), {
            meetingId: props.meetingId
        });
        if (presenter?.config?.isSharingScreen) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d16U.default), {
            setRef: setRef,
            userId: user.id,
            subscriberOptions: (0, $xQehV.screenshareStreamSubscriberOptions),
            isScreenShareStream: true
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3FWaP.default), {
            meetingId: props.meetingId
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MrNT.default), {
                presenter: presenter,
                fullScreenRef: ref
            }),
            renderSharedView()
        ]
    });
};
var $beedfeeb623675bc$export$2e2bcd8739ae039 = $beedfeeb623675bc$var$LiveMeetingSharedView;

});
parcelRegister("9d16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $abc0be7c29b02e3b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $kGUIk = parcelRequire("kGUIk");

var $dyeCj = parcelRequire("dyeCj");

var $g7GJo = parcelRequire("g7GJo");

var $6lvMC = parcelRequire("6lvMC");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jitSV");
var $l8Ars = parcelRequire("l8Ars");

var $4KSAX = parcelRequire("4KSAX");

var $jF0Xa = parcelRequire("jF0Xa");

var $3mOhS = parcelRequire("3mOhS");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");
const $abc0be7c29b02e3b$var$WebRTCSubscriber = (props)=>{
    const [subscribedStream, setSubscribedStream] = (0, $acw62.useState)(null);
    const streamContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const fullScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUserId = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserId));
    const session = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCSession));
    const stream = props.isScreenShareStream ? (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCScreenShareStream)) : (0, $iD0SF.useSelector)((state)=>(0, $dyeCj.getWebRTCStreamByUserId)(state, props));
    const [showFullScreenHeader, setShowFullScreenHeader] = (0, $acw62.useState)(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "liveMeeting"
    ]);
    const caseData = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseDetails));
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    (0, $acw62.useEffect)(()=>{
        // When session is connected and the provided stream is set, subscribe to it
        // This will show the user's webcam stream or screenshare in the browser
        if (!stream || !session?.connection || subscribedStream && subscribedStream.streamId == stream.streamId) return;
        let subscriberOptions = props.subscriberOptions;
        // When subscribing to one's own stream, remove some of the options
        const isPublisher = stream.connection?.connectionId && session.connection?.connectionId && stream.connection.connectionId === session.connection.connectionId;
        if (isPublisher && subscriberOptions) {
            const { preferredFrameRate: _preferredFrameRate, preferredResolution: _preferredResolution, ...restOptions } = subscriberOptions;
            subscriberOptions = restOptions;
        }
        dispatch((0, $kGUIk.subscribeToWebRTCStreamAction)(session, stream, streamContainerRef, subscriberOptions));
        // we record the last stream that we subscribed to. If it changes, we will resubscribe
        setSubscribedStream(stream);
    }, [
        stream,
        session
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!props.setRef) return;
        props.setRef(fullScreenRef);
    }, [
        streamContainerRef.current
    ]);
    (0, $acw62.useEffect)(()=>{
        const listener = ()=>{
            setShowFullScreenHeader(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", listener);
        return ()=>{
            document.removeEventListener("fullscreenchange", listener);
        };
    });
    const streamUserId = (0, $g7GJo.getStreamUserId)(subscribedStream);
    // tailwind 2 doesn't support negative scale values, so using inline style for this
    // if you read this and we have updated to tailwind 3, please put this in the classNames
    // (something like "-scale-x-100": streamUserId == currentUserId)
    const style = {};
    if (streamUserId == currentUserId) style["transform"] = "scaleX(-1)";
    const renderFullScreenHeader = ()=>{
        if (!showFullScreenHeader) return;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "absolute flex justify-between items-center top-0 w-full h-10 z-10 bg-white px-5",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                            firstName: caseData.firstName,
                            lastName: caseData.lastName,
                            title: caseData.title,
                            gender: caseData.gender
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                            utcTime: caseData.dateOfBirth
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                careProviderIdLabel,
                                ": ",
                                caseData.careProviderId
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    action: ()=>document.exitFullscreen(),
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            t("liveMeeting:leaveFullscreen"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l8Ars.default), {}),
                            " "
                        ]
                    })
                })
            ]
        });
    };
    if (!stream) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: fullScreenRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("relative h-full", {
            "hidden": !stream.hasVideo
        }),
        children: [
            renderFullScreenHeader(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: streamContainerRef,
                style: style,
                className: "h-full"
            })
        ]
    });
};
var $abc0be7c29b02e3b$export$2e2bcd8739ae039 = $abc0be7c29b02e3b$var$WebRTCSubscriber;

});

parcelRegister("5MrNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bccafb4eb9789edf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $18DPn = parcelRequire("18DPn");
const $bccafb4eb9789edf$var$LiveMeetingSharedViewBar = ({ presenter: presenter, fullScreenRef: fullScreenRef })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const renderFullScreenButton = ()=>{
        if (!fullScreenRef?.current) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            className: "flex gap-3 uppercase items-center mx-3 my-auto px-3 rounded-full text-ch-gray-300 h-7 leading-none text-white bg-ch-blue-500",
            onClick: ()=>fullScreenRef.current.requestFullscreen(),
            children: [
                t("liveMeeting:fullscreen"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18DPn.default), {})
            ]
        });
    };
    const presentingUser = ()=>{
        if (!presenter) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "text-sm font-thin",
            children: [
                "\xa0|\xa0",
                t("liveMeeting:presenting"),
                " ",
                presenter.firstName,
                " ",
                presenter.lastName,
                " "
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-ch-blue-200 flex w-full place-content-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: " p-2",
                children: [
                    t("liveMeeting:sharedView"),
                    presentingUser()
                ]
            }),
            renderFullScreenButton()
        ]
    });
};
var $bccafb4eb9789edf$export$2e2bcd8739ae039 = $bccafb4eb9789edf$var$LiveMeetingSharedViewBar;

});

parcelRegister("kN4w7", function(module, exports) {

$parcel$export(module.exports, "getMeetingUsersWithConfigAsArray", () => $0da2f00ebe371f28$export$68124682eb257c77);
$parcel$export(module.exports, "getActiveMeetingUsersWithConfig", () => $0da2f00ebe371f28$export$c8efbe5d4d533b6b);
$parcel$export(module.exports, "getMeetingUsersWithConfig", () => $0da2f00ebe371f28$export$fce018129eb78711);
$parcel$export(module.exports, "getUserWithConfigById", () => $0da2f00ebe371f28$export$ee0eeb6b5d9efe4d);
$parcel$export(module.exports, "getMeetingCoordinator", () => $0da2f00ebe371f28$export$fa81e2bae74d442e);
$parcel$export(module.exports, "getLiveMeetingPresenter", () => $0da2f00ebe371f28$export$b89b7db1394b7b71);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $dQiiy = parcelRequire("dQiiy");

var $4VtCQ = parcelRequire("4VtCQ");

var $6lvMC = parcelRequire("6lvMC");
const $0da2f00ebe371f28$export$1e595f5a24117dba = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), (liveMeetingConfig)=>{
    return liveMeetingConfig.userConfigs;
});
const $0da2f00ebe371f28$export$68124682eb257c77 = (0, $6SpLG.createSelector)((0, $4VtCQ.getMeetingUserIds), (0, $6lvMC.getAllUsers), $0da2f00ebe371f28$export$1e595f5a24117dba, (meetingUserIds, allUsers, userConfigs)=>{
    if (!meetingUserIds) return [];
    return meetingUserIds.map((userId)=>{
        return {
            ...allUsers[userId],
            config: userConfigs?.[userId]
        };
    });
});
const $0da2f00ebe371f28$export$c8efbe5d4d533b6b = (0, $6SpLG.createSelector)($0da2f00ebe371f28$export$68124682eb257c77, (users)=>{
    if (!users) return [];
    return users.filter((u)=>u?.activeInCurrentTenant);
});
const $0da2f00ebe371f28$export$fce018129eb78711 = (0, $6SpLG.createSelector)($0da2f00ebe371f28$export$68124682eb257c77, (usersWithConfig)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(usersWithConfig, "id");
});
const $0da2f00ebe371f28$export$ee0eeb6b5d9efe4d = (0, $6SpLG.createSelector)((0, $6lvMC.getUserByHasUserId), $0da2f00ebe371f28$export$1e595f5a24117dba, (user, userConfigs)=>{
    return {
        ...user,
        config: userConfigs[user.id]
    };
});
const $0da2f00ebe371f28$export$fa81e2bae74d442e = (0, $6SpLG.createSelector)((0, $4VtCQ.getMeetingById), $0da2f00ebe371f28$export$fce018129eb78711, (meeting, meetingUsersWithConfig)=>{
    return meetingUsersWithConfig[meeting.coordinatorId];
});
const $0da2f00ebe371f28$export$b89b7db1394b7b71 = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), $0da2f00ebe371f28$export$fce018129eb78711, (liveMeetingConfig, meetingUsersWithConfig)=>{
    return meetingUsersWithConfig[liveMeetingConfig.presenterId];
});
const $0da2f00ebe371f28$export$631bec2cf75c97c = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), $0da2f00ebe371f28$export$fce018129eb78711, (liveMeetingConfig, meetingUsersWithConfig)=>{
    return meetingUsersWithConfig[liveMeetingConfig.coordinatorId];
});
const $0da2f00ebe371f28$export$a3cd1ea3bf8e80c4 = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), $0da2f00ebe371f28$export$fce018129eb78711, (liveMeetingConfig, meetingUsersWithConfig)=>{
    return meetingUsersWithConfig[liveMeetingConfig.scribeId];
});

});

parcelRegister("jf12H", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03cdd3478ee6464$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $rDKvs = parcelRequire("rDKvs");

var $j0qQC = parcelRequire("j0qQC");

var $13yNX = parcelRequire("13yNX");

var $4bQ8f = parcelRequire("4bQ8f");

var $6gEUE = parcelRequire("6gEUE");

var $8ra4f = parcelRequire("8ra4f");

var $fp9J8 = parcelRequire("fp9J8");

var $4cduv = parcelRequire("4cduv");

var $1p6nT = parcelRequire("1p6nT");

var $kN4w7 = parcelRequire("kN4w7");

var $5UvqD = parcelRequire("5UvqD");

var $ccihY = parcelRequire("ccihY");

var $bdmN8 = parcelRequire("bdmN8");

var $3mOhS = parcelRequire("3mOhS");

var $2jvQG = parcelRequire("2jvQG");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $hVO2M = parcelRequire("hVO2M");

var $7twpo = parcelRequire("7twpo");

var $lxTgp = parcelRequire("lxTgp");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $6sHZH = parcelRequire("6sHZH");

var $lCZwG = parcelRequire("lCZwG");

var $hgRGJ = parcelRequire("hgRGJ");

var $kGUIk = parcelRequire("kGUIk");
const $f03cdd3478ee6464$var$LiveMeetingSharedViewPresenter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const clearSharedViewSelectedAsset = (assetTypeFilters)=>()=>dispatch((0, $rDKvs.updateSharedViewSelectedAssetAction)(null, assetTypeFilters));
    const cancelRecommendation = ()=>dispatch((0, $rDKvs.cancelRecommendationAction)());
    const deferCurrentCase = ()=>dispatch((0, $rDKvs.deferCurrentCaseAction)());
    const shareRecommendation = ()=>dispatch((0, $rDKvs.shareRecommendationAction)());
    const requestApproval = ()=>dispatch((0, $rDKvs.requestApprovalAction)());
    const saveRecommendation = ()=>dispatch((0, $rDKvs.saveRecommendationAction)());
    const [assetTypeFilters, setAssetTypeFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const selectedAssetId = (0, $iD0SF.useSelector)((0, $6gEUE.getLiveMeetingSharedViewSelectedAssetId));
    const caseStage = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig.caseStage);
    const users = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getActiveMeetingUsersWithConfig)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCase));
    const meetingCaseId = meetingCase?.id;
    const publishAssetTypeFilters = (filters)=>{
        setAssetTypeFilters(filters);
        dispatch((0, $rDKvs.updateSharedViewSelectedAssetAction)(null, filters));
    };
    const selectedAsset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, {
            assetId: selectedAssetId
        }));
    const [isSelectAssetModalOpen, setIsSelectAssetModalOpen] = (0, $acw62.useState)(false);
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(selectedAsset);
    const isOpen = selectedAsset && assetComponentType == (0, $7twpo.AssetComponentTypes).RadiologyLink;
    const clearSelectedAsset = ()=>dispatch((0, $rDKvs.updateSharedViewSelectedAssetAction)(null, assetTypeFilters));
    const startSharingScreen = ()=>dispatch((0, $kGUIk.webRTCScreenShareCurrentAction)());
    const stopSharingScreen = ()=>dispatch((0, $kGUIk.toggleWebRTCScreenShareIsOnAction)(false));
    const renderSelectAssetModal = ()=>{
        if (!meetingCase) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
            isOpen: isSelectAssetModalOpen,
            onRequestClose: ()=>setIsSelectAssetModalOpen(false),
            style: (0, $jF0Xa.bottomModalStyle),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                handleClose: ()=>setIsSelectAssetModalOpen(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6sHZH.default), {
                    meetingId: props.meetingId,
                    caseId: meetingCase.case,
                    meetingCaseId: meetingCaseId,
                    openViewAssetModal: ()=>setIsSelectAssetModalOpen(true)
                })
            })
        });
    };
    const renderRadiologyModal = ()=>{
        if (!meetingCase) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
            isOpen: isOpen,
            onAfterOpen: startSharingScreen,
            onAfterClose: stopSharingScreen,
            onRequestClose: clearSelectedAsset,
            style: (0, $jF0Xa.bottomModalStyle),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                handleClose: clearSelectedAsset,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hgRGJ.default), {
                    assetId: selectedAsset?.id
                })
            })
        });
    };
    const renderSelectAssetButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            className: "hidden sm:block text-sm",
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            action: ()=>setIsSelectAssetModalOpen(true),
            children: t("asset:selectMeetingAssets")
        });
    };
    const renderAssetSelect = ()=>{
        if (!meetingCaseId) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-2 w-full",
            children: [
                t("liveMeeting:yourViewAssetsInstructions"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {
                    className: "-mt-10"
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            hasDarkBackground: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13yNX.default), {
                            openText: t("liveMeeting:selectItemToViewAndShare")
                        }),
                        renderRadiologyModal(),
                        renderSelectAssetModal(),
                        renderSelectAssetButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4bQ8f.default), {
                        selectAction: (0, $rDKvs.updateSharedViewSelectedAssetAction),
                        assetTypeFilters: assetTypeFilters,
                        setAssetTypeFilters: publishAssetTypeFilters
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdmN8.default), {
                    meetingId: props.meetingId,
                    buttonsOnly: true
                })
            ]
        });
    };
    const assetViewer = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1p6nT.default), {
                            assetId: selectedAssetId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fp9J8.default), {
                            clearSelectedAsset: clearSharedViewSelectedAsset(assetTypeFilters)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cduv.default), {
                        assetId: selectedAssetId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdmN8.default), {
                    meetingId: props.meetingId,
                    buttonsOnly: true
                })
            ]
        });
    const decideWhatToRender = ()=>{
        switch(caseStage){
            case (0, $j0qQC.CaseStage).PRESENTING:
                if ((0, $hVO2M.doesAssetUseViewer)(selectedAsset)) return assetViewer();
                return renderAssetSelect();
            case (0, $j0qQC.CaseStage).DEFERRING:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5UvqD.default), {
                    cancelRecommendation: cancelRecommendation,
                    users: users,
                    requestApproval: requestApproval,
                    deferCurrentCase: deferCurrentCase,
                    caseStage: caseStage,
                    meetingId: props.meetingId
                });
            case (0, $j0qQC.CaseStage).RECOMMENDING:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5UvqD.default), {
                    cancelRecommendation: cancelRecommendation,
                    users: users,
                    requestApproval: requestApproval,
                    deferCurrentCase: deferCurrentCase,
                    caseStage: caseStage,
                    meetingId: props.meetingId
                });
            case (0, $j0qQC.CaseStage).APPROVING:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccihY.default), {
                    users: users,
                    saveRecommendation: saveRecommendation,
                    shareRecommendation: shareRecommendation
                });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-1 overflow-hidden",
        children: decideWhatToRender()
    });
};
var $f03cdd3478ee6464$export$2e2bcd8739ae039 = $f03cdd3478ee6464$var$LiveMeetingSharedViewPresenter;

});
parcelRegister("13yNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f667b6d27076431$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4f667b6d27076431$var$LiveMeetingAssetSelectHeading = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "flex items-center",
        children: props.openText
    });
};
var $4f667b6d27076431$export$2e2bcd8739ae039 = $4f667b6d27076431$var$LiveMeetingAssetSelectHeading;

});

parcelRegister("4bQ8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f32ebaa9ddf702e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lOYBW = parcelRequire("lOYBW");

var $3mOhS = parcelRequire("3mOhS");

var $buMa2 = parcelRequire("buMa2");

var $f1q41 = parcelRequire("f1q41");

var $rDKvs = parcelRequire("rDKvs");
const $8f32ebaa9ddf702e$var$LiveMeetingAssetList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case",
        "liveMeeting",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const updateSelectedAsset = (assetId)=>{
        dispatch(props.selectAction(assetId, props.assetTypeFilters));
    };
    const selectedMeetingCase = (0, $iD0SF.useSelector)((state)=>(0, $3mOhS.getSelectedMeetingCase)(state));
    const updateHoveredAsset = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((assetId)=>{
        dispatch((0, $rDKvs.updateSharedViewHoveredAssetAction)(assetId));
    }, 400);
    (0, $acw62.useEffect)(()=>{
        props.setAssetTypeFilters(null);
    }, [
        selectedMeetingCase?.case
    ]);
    if (!selectedMeetingCase?.meetingCaseAssets?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-center text-ch-blue-alt-400",
        children: t("liveMeeting:noAssetsOnMeetingCase")
    });
    if (!selectedMeetingCase?.case) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $buMa2.default), {
                initialValues: props.assetTypeFilters,
                setFilters: props.setAssetTypeFilters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: selectedMeetingCase?.meetingCaseAssets.map((meetingCaseAsset)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOYBW.default), {
                        action: ()=>updateSelectedAsset(meetingCaseAsset.caseAssetId),
                        assetId: meetingCaseAsset.caseAssetId,
                        caseId: selectedMeetingCase.case,
                        assetTypeFilters: props.assetTypeFilters,
                        onMouseEnter: ()=>updateHoveredAsset(meetingCaseAsset.caseAssetId),
                        onMouseLeave: ()=>updateHoveredAsset(null)
                    }, meetingCaseAsset.caseAssetId);
                })
            })
        ]
    });
};
var $8f32ebaa9ddf702e$export$2e2bcd8739ae039 = $8f32ebaa9ddf702e$var$LiveMeetingAssetList;

});
parcelRegister("lOYBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ad8a3a7e8f7535$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7twpo = parcelRequire("7twpo");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");

var $3mOhS = parcelRequire("3mOhS");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $49ad8a3a7e8f7535$var$AssetListItem = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCase));
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (props.isSelected && ref.current) ref.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
    if (!asset) return null;
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponentType];
    const action = assetComponentType !== (0, $7twpo.AssetComponentTypes).Link ? props.action : undefined;
    // we're hiding the component, not ruturning null, because this way the
    // image components don't need to reload their images.
    const hidden = (0, $hVO2M.isAssetFiltered)(Asset, props.assetTypeFilters);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-1", {
            hidden: hidden
        }),
        ref: ref,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
            assetId: props.assetId,
            action: action,
            isSelected: props.isSelected || props.isHovered,
            caseId: meetingCase.case,
            noAction: props.noAction,
            liveMeeting: true
        })
    });
};
var $49ad8a3a7e8f7535$export$2e2bcd8739ae039 = $49ad8a3a7e8f7535$var$AssetListItem;

});
parcelRegister("hVO2M", function(module, exports) {

$parcel$export(module.exports, "getComponentTypeForAsset", () => $9f70a67b5d01367e$export$f1b86fae69cb6761);
$parcel$export(module.exports, "componentLookup", () => $9f70a67b5d01367e$export$f1dce6983cfc2519);
$parcel$export(module.exports, "clickableComponentAction", () => $9f70a67b5d01367e$export$16a7c3e14f9a39c0);
$parcel$export(module.exports, "lookupLiveMeetingViewerForAsset", () => $9f70a67b5d01367e$export$1012232ff6f2a39);
$parcel$export(module.exports, "doesAssetUseViewer", () => $9f70a67b5d01367e$export$14b96140f08475db);
$parcel$export(module.exports, "isAssetFiltered", () => $9f70a67b5d01367e$export$7d5865df1a13368);

var $7twpo = parcelRequire("7twpo");

var $jvXUv = parcelRequire("jvXUv");

var $drK1X = parcelRequire("drK1X");

var $pxpMr = parcelRequire("pxpMr");

var $7rDh7 = parcelRequire("7rDh7");

var $5QwAy = parcelRequire("5QwAy");

var $dncl0 = parcelRequire("dncl0");

var $d3Bwo = parcelRequire("d3Bwo");

var $43Pe3 = parcelRequire("43Pe3");

var $bw1cx = parcelRequire("bw1cx");

var $iaOm3 = parcelRequire("iaOm3");

var $huFHr = parcelRequire("huFHr");

var $jlnhJ = parcelRequire("jlnhJ");
const $9f70a67b5d01367e$var$getCommentType = (comment)=>{
    switch(comment.commentType){
        case (0, $7twpo.CommentTypes).Comment:
            return (0, $7twpo.AssetComponentTypes).Comment;
        case (0, $7twpo.CommentTypes).Decision:
            return (0, $7twpo.AssetComponentTypes).Decision;
        case (0, $7twpo.CommentTypes).Deferral:
            return (0, $7twpo.AssetComponentTypes).Deferral;
        case (0, $7twpo.CommentTypes).Recommendation:
            return (0, $7twpo.AssetComponentTypes).Recommendation;
    }
};
const $9f70a67b5d01367e$var$getDocumentType = (document)=>{
    switch(document.contentType){
        case "application/pdf":
            return (0, $7twpo.AssetComponentTypes).Pdf;
        default:
            return (0, $7twpo.AssetComponentTypes).Image;
    }
};
const $9f70a67b5d01367e$export$f1b86fae69cb6761 = (asset)=>{
    switch(asset?.assetType){
        case (0, $7twpo.AssetTypes).Comment:
            return $9f70a67b5d01367e$var$getCommentType(asset.asset);
        case (0, $7twpo.AssetTypes).Link:
            return (0, $7twpo.AssetComponentTypes).Link;
        case (0, $7twpo.AssetTypes).RadiologyLink:
            return (0, $7twpo.AssetComponentTypes).RadiologyLink;
        case (0, $7twpo.AssetTypes).Document:
            return $9f70a67b5d01367e$var$getDocumentType(asset.asset);
        case (0, $7twpo.AssetTypes).MessageDocument:
            return $9f70a67b5d01367e$var$getDocumentType(asset.asset);
        case (0, $7twpo.AssetTypes).CaseReport:
            return (0, $7twpo.AssetComponentTypes).CaseReport;
        case (0, $7twpo.AssetTypes).Form:
            return (0, $7twpo.AssetComponentTypes).Form;
        default:
            return null;
    }
};
const $9f70a67b5d01367e$export$f1dce6983cfc2519 = {
    [(0, $7twpo.AssetComponentTypes).Link]: (0, $jvXUv.default),
    [(0, $7twpo.AssetComponentTypes).RadiologyLink]: (0, $huFHr.default),
    [(0, $7twpo.AssetComponentTypes).Comment]: (0, $7rDh7.default),
    [(0, $7twpo.AssetComponentTypes).Deferral]: (0, $drK1X.default),
    [(0, $7twpo.AssetComponentTypes).Recommendation]: (0, $pxpMr.default),
    [(0, $7twpo.AssetComponentTypes).Decision]: (0, $5QwAy.default),
    [(0, $7twpo.AssetComponentTypes).Pdf]: (0, $dncl0.default),
    [(0, $7twpo.AssetComponentTypes).Image]: (0, $d3Bwo.default),
    [(0, $7twpo.AssetComponentTypes).CaseReport]: (0, $43Pe3.default),
    [(0, $7twpo.AssetComponentTypes).Form]: (0, $jlnhJ.default)
};
const $9f70a67b5d01367e$var$clickableComponents = [
    (0, $7twpo.AssetComponentTypes).Pdf,
    (0, $7twpo.AssetComponentTypes).Image,
    (0, $7twpo.AssetComponentTypes).CaseReport,
    (0, $7twpo.AssetComponentTypes).RadiologyLink,
    (0, $7twpo.AssetComponentTypes).Form
];
function $9f70a67b5d01367e$export$16a7c3e14f9a39c0(action, assetComponentType) {
    return $9f70a67b5d01367e$var$clickableComponents.includes(assetComponentType) ? action : undefined;
}
const $9f70a67b5d01367e$var$componentViewerLookupTable = {
    [(0, $7twpo.AssetComponentTypes).Pdf]: (0, $bw1cx.default),
    [(0, $7twpo.AssetComponentTypes).Form]: (0, $bw1cx.default),
    [(0, $7twpo.AssetComponentTypes).CaseReport]: (0, $bw1cx.default),
    [(0, $7twpo.AssetComponentTypes).Image]: (0, $iaOm3.default)
};
const $9f70a67b5d01367e$export$1012232ff6f2a39 = (asset)=>{
    const assetComponetType = $9f70a67b5d01367e$export$f1b86fae69cb6761(asset);
    if (asset.assetType == "Form" && asset.asset.state == (0, $7twpo.FormState).draft) return null;
    return $9f70a67b5d01367e$var$componentViewerLookupTable[assetComponetType];
};
const $9f70a67b5d01367e$export$14b96140f08475db = (asset)=>{
    if (!asset) return false;
    const selectedAssetComponetType = $9f70a67b5d01367e$export$f1b86fae69cb6761(asset);
    const componentsUsingViewer = Object.keys($9f70a67b5d01367e$var$componentViewerLookupTable);
    // forms depend on their state how they are viewed
    if (selectedAssetComponetType == (0, $7twpo.AssetComponentTypes).Form && !asset.asset.path) return false;
    return componentsUsingViewer.includes(selectedAssetComponetType);
};
const $9f70a67b5d01367e$export$7d5865df1a13368 = (asset, filters)=>{
    if (!filters) return false;
    switch(asset){
        case 0, $43Pe3.default:
        case 0, $dncl0.default:
            if (!filters.showAll && !filters.showPdfs) return true;
            break;
        case 0, $d3Bwo.default:
            if (!filters.showAll && !filters.showImages) return true;
            break;
        case 0, $jvXUv.default:
            if (!filters.showAll && !filters.showLinks) return true;
            break;
        case 0, $7rDh7.default:
            if (!filters.showAll && !filters.showComments) return true;
            break;
        case 0, $drK1X.default:
        case 0, $pxpMr.default:
            if (!filters.showAll && !filters.showRecommendations) return true;
            break;
        case 0, $5QwAy.default:
            if (!filters.showAll && !filters.showDecisions) return true;
            break;
        default:
            return false;
    }
};

});
parcelRegister("jvXUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $420330944199949b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $e11eN = parcelRequire("e11eN");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aDoxy = parcelRequire("aDoxy");
const $420330944199949b$var$Link = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const link = asset.asset;
    const linkProps = {
        href: props.noAction ? null : link.link,
        target: "_blank",
        rel: "noreferrer"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-white p-2 flex rounded-md border-2", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": linkProps.href,
            "cursor-pointer": linkProps.href,
            "cursor-default": !linkProps.href
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                ...linkProps,
                onClick: props.action ? ()=>props.action() : null,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-grow"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-ch-blue-alt-400 mr-2 mt-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e11eN.default), {
                            className: "w-5 h-5",
                            title: link.title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 min-w-0 grid",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "font-semibold text-lg",
                                children: link.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                                meetingCaseAsset: props.meetingCaseAsset,
                                meetingId: props.meetingId,
                                asset: asset
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "block overflow-hidden overflow-ellipsis whitespace-nowrap",
                                children: link.link
                            })
                        ]
                    })
                ]
            }),
            props.children
        ]
    });
};
var $420330944199949b$export$2e2bcd8739ae039 = $420330944199949b$var$Link;

});
parcelRegister("aDoxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $742d228032389a61$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $k5WIK = parcelRequire("k5WIK");

var $1sh4P = parcelRequire("1sh4P");

var $7tQ5n = parcelRequire("7tQ5n");

var $7JW9V = parcelRequire("7JW9V");

var $fLQ4L = parcelRequire("fLQ4L");
const $742d228032389a61$var$AssetSubHeader = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k5WIK.default), {
                firstName: props.asset.createdBy.firstName,
                lastName: props.asset.createdBy.lastName,
                createdAt: props.asset.createdAt
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tQ5n.default), {
                meeting: props.asset.asset.meeting
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7JW9V.default), {
                taskId: props.asset.taskId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sh4P.default), {
                summary: props.asset.asset.summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fLQ4L.default), {
                meetingCaseAsset: props.meetingCaseAsset,
                meetingId: props.meetingId
            })
        ]
    });
};
var $742d228032389a61$export$2e2bcd8739ae039 = $742d228032389a61$var$AssetSubHeader;

});
parcelRegister("k5WIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c999de3388ac44$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7hl6H = parcelRequire("7hl6H");
const $53c999de3388ac44$var$TextAuthorDetails = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "font-thin",
        children: [
            t("shared:by"),
            "\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "uppercase",
                children: props.lastName
            }),
            ", ",
            props.firstName,
            "\xa0",
            t("shared:on"),
            "\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                utcTime: props.createdAt
            })
        ]
    });
};
var $53c999de3388ac44$export$2e2bcd8739ae039 = $53c999de3388ac44$var$TextAuthorDetails;

});

parcelRegister("1sh4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ef30b38d436c3ed$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $5AYDs = parcelRequire("5AYDs");
const $5ef30b38d436c3ed$var$ChatDetail = (props)=>{
    if (!props.summary) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center my-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                    className: "w-5 h-5",
                    title: props.summary
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "font-thin",
                children: props.summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
        ]
    });
};
var $5ef30b38d436c3ed$export$2e2bcd8739ae039 = $5ef30b38d436c3ed$var$ChatDetail;

});

parcelRegister("7tQ5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d42634e53b8b19b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $7hl6H = parcelRequire("7hl6H");
const $5d42634e53b8b19b$var$MeetingDetail = ({ meeting: meeting })=>{
    if (meeting == null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center my-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                    className: "w-5 h-5",
                    title: meeting.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "font-thin",
                children: [
                    meeting.name,
                    " - ",
                    meeting.specialtyName,
                    " - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                        utcTime: meeting.startDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
        ]
    });
};
var $5d42634e53b8b19b$export$2e2bcd8739ae039 = $5d42634e53b8b19b$var$MeetingDetail;

});

parcelRegister("7JW9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $321874cde34044f5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $9mz9n = parcelRequire("9mz9n");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");
var $dIfKX = parcelRequire("dIfKX");
const $321874cde34044f5$var$TaskDetail = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    if (task == null) return null;
    const Icon = task.casePathwayId ? (0, $k6suX.default) : (0, $dIfKX.default);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center my-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                    className: "w-5 h-5",
                    title: task.action
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "font-thin",
                children: task.action
            })
        ]
    });
};
var $321874cde34044f5$export$2e2bcd8739ae039 = $321874cde34044f5$var$TaskDetail;

});
parcelRegister("9mz9n", function(module, exports) {

$parcel$export(module.exports, "getAllTaskIds", () => $445d4e2640a4149d$export$c6c051f75e8a1a5a);
$parcel$export(module.exports, "getTaskById", () => $445d4e2640a4149d$export$79bdce95949f2d95);
$parcel$export(module.exports, "getTasksById", () => $445d4e2640a4149d$export$1480dfd22fd3d8fe);
$parcel$export(module.exports, "getTaskResponseById", () => $445d4e2640a4149d$export$4c3b1fce676f9f95);
$parcel$export(module.exports, "getAllCaseTaskIds", () => $445d4e2640a4149d$export$955e5afcf435217e);
$parcel$export(module.exports, "getTaskUsers", () => $445d4e2640a4149d$export$841125b57493e6ae);
$parcel$export(module.exports, "getAllCaseTaskResponseIds", () => $445d4e2640a4149d$export$5ea9d9da6aa952dc);
$parcel$export(module.exports, "getLatestTaskResponse", () => $445d4e2640a4149d$export$7a21c4040c86abf0);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $kon2z = parcelRequire("kon2z");

var $6lvMC = parcelRequire("6lvMC");
const $445d4e2640a4149d$export$c6c051f75e8a1a5a = (state)=>state.entities.tasks.allIds;
const $445d4e2640a4149d$export$d1f442602a91e7cc = (state)=>state.entities.tasks.byId;
const $445d4e2640a4149d$export$d61e7b60d9e859fb = (state)=>state.entities.taskResponses.byId;
const $445d4e2640a4149d$export$79bdce95949f2d95 = (state, ownProps)=>state.entities.tasks.byId[ownProps.taskId];
const $445d4e2640a4149d$export$1480dfd22fd3d8fe = (0, $6SpLG.createSelector)([
    $445d4e2640a4149d$export$d1f442602a91e7cc,
    (_state, taskIds)=>taskIds
], (allTasks, taskIds)=>{
    if (!taskIds) return [];
    return taskIds.map((id)=>allTasks[id]);
});
const $445d4e2640a4149d$export$4c3b1fce676f9f95 = (state, ownProps)=>state.entities.taskResponses.byId[ownProps.taskResponseId];
const $445d4e2640a4149d$export$955e5afcf435217e = (0, $6SpLG.createSelector)((0, $kon2z.getCaseById), (caseData)=>{
    if (!caseData) return [];
    return caseData.tasks;
});
const $445d4e2640a4149d$export$2eae03dc9269bd93 = (0, $6SpLG.createSelector)($445d4e2640a4149d$export$79bdce95949f2d95, (task)=>{
    if (!task) return [];
    return task.users;
});
const $445d4e2640a4149d$export$841125b57493e6ae = (0, $6SpLG.createSelector)((0, $6lvMC.getAllUsers), $445d4e2640a4149d$export$2eae03dc9269bd93, (allUsers, taskUserIds)=>{
    if (!taskUserIds) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pick(allUsers, taskUserIds);
});
const $445d4e2640a4149d$export$5ea9d9da6aa952dc = (0, $6SpLG.createSelector)($445d4e2640a4149d$export$79bdce95949f2d95, (task)=>{
    if (!task) return [];
    return task.taskResponses;
});
const $445d4e2640a4149d$export$7a21c4040c86abf0 = (0, $6SpLG.createSelector)($445d4e2640a4149d$export$79bdce95949f2d95, $445d4e2640a4149d$export$d61e7b60d9e859fb, (task, allTaskResponses)=>{
    if (!task || !allTaskResponses) return null;
    return allTaskResponses[task.taskResponses[0]];
});

});


parcelRegister("fLQ4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $12640083843c54bb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7hl6H = parcelRequire("7hl6H");

var $lxTgp = parcelRequire("lxTgp");
const $12640083843c54bb$var$MeetingCaseAssetSelectedByText = (props)=>{
    if (!props.meetingCaseAsset) return null;
    const caseAsset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, {
            assetId: props.meetingCaseAsset.caseAssetId
        }));
    // do not render selected text if original meeting asset from the current meeting
    if (caseAsset?.asset?.meetingId == props.meetingId) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "block",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "font-semibold text-ch-blue-alt-500 ",
                children: t("shared:selectedBy")
            }),
            "\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "font-thin",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "uppercase",
                        children: props.meetingCaseAsset.createdBy.lastName
                    }),
                    ", ",
                    props.meetingCaseAsset.createdBy.firstName,
                    "\xa0",
                    t("shared:on"),
                    "\xa0",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                        utcTime: props.meetingCaseAsset.createdAt
                    })
                ]
            })
        ]
    });
};
var $12640083843c54bb$export$2e2bcd8739ae039 = $12640083843c54bb$var$MeetingCaseAssetSelectedByText;

});



parcelRegister("drK1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0f4719d31394d4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");

var $biuvr = parcelRequire("biuvr");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jitSV");
var $2D4bH = parcelRequire("2D4bH");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $5f0f4719d31394d4$var$Deferral = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const comment = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2 flex rounded-md border-2 bg-ch-blue-200", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2D4bH.default), {
                    className: "w-5 h-5",
                    title: comment.title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: comment.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                        value: comment.body,
                        users: users
                    })
                ]
            }),
            props.children
        ]
    });
};
var $5f0f4719d31394d4$export$2e2bcd8739ae039 = $5f0f4719d31394d4$var$Deferral;

});
parcelRegister("biuvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c34484538acf0b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cmpry = parcelRequire("cmpry");

var $90eUZ = parcelRequire("90eUZ");

var $aSzjr = parcelRequire("aSzjr");
const $84c34484538acf0b$var$MentionFieldReadOnly = ({ className: className, textColorClass: textColorClass = "text-ch-gray-600", value: value, users: users, isSingleLine: isSingleLine = false })=>{
    const prefixClass = "mentions-read-only";
    const defaultClasses = [
        prefixClass,
        textColorClass
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    const renderMentionText = (id, _display)=>{
        if (id == "all") return (0, $90eUZ.formatUserMentionString)((0, $aSzjr.allUser));
        if (!users[id]) return "";
        return (0, $90eUZ.formatUserMentionString)(users[id]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cmpry.MentionsInput), {
        value: value,
        className: allClasses,
        singleLine: isSingleLine,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cmpry.Mention), {
            className: "bg-ch-blue-alt-200",
            trigger: "@",
            markup: "@[__display__](__id__)",
            displayTransform: (id, display)=>renderMentionText(id, display),
            data: []
        })
    });
};
var $84c34484538acf0b$export$2e2bcd8739ae039 = $84c34484538acf0b$var$MentionFieldReadOnly;

});
parcelRegister("cmpry", function(module, exports) {

$parcel$export(module.exports, "MentionsInput", () => $8ffb46a819a74219$export$6952d9a604a4da5e);
$parcel$export(module.exports, "Mention", () => $8ffb46a819a74219$export$e891316fea657d90);

var $jwUkK = parcelRequire("jwUkK");

var $2AARm = parcelRequire("2AARm");

var $igh35 = parcelRequire("igh35");

var $brrhu = parcelRequire("brrhu");

var $baNBs = parcelRequire("baNBs");

var $1Apoc = parcelRequire("1Apoc");

var $cYBMK = parcelRequire("cYBMK");

var $5HlHN = parcelRequire("5HlHN");

var $jRhPI = parcelRequire("jRhPI");

var $acw62 = parcelRequire("acw62");

var $aaXwj = parcelRequire("aaXwj");

var $8yC0U = parcelRequire("8yC0U");

var $2PtM8 = parcelRequire("2PtM8");

var $gkmFh = parcelRequire("gkmFh");
var $9UQB7 = parcelRequire("9UQB7");

var $c9Z8w = parcelRequire("c9Z8w");

var $1u0KT = parcelRequire("1u0KT");
// escape RegExp special characters https://stackoverflow.com/a/9310752/5142490
var $8ffb46a819a74219$var$escapeRegex = function escapeRegex(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
var $8ffb46a819a74219$var$PLACEHOLDERS = {
    id: '__id__',
    display: '__display__'
};
var $8ffb46a819a74219$var$findPositionOfCapturingGroup = function findPositionOfCapturingGroup(markup, parameterName) {
    (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(parameterName === 'id' || parameterName === 'display', "Second arg must be either \"id\" or \"display\", got: \"".concat(parameterName, "\"")); // find positions of placeholders in the markup
    var indexDisplay = markup.indexOf($8ffb46a819a74219$var$PLACEHOLDERS.display);
    var indexId = markup.indexOf($8ffb46a819a74219$var$PLACEHOLDERS.id); // set indices to null if not found
    if (indexDisplay < 0) indexDisplay = null;
    if (indexId < 0) indexId = null; // markup must contain one of the mandatory placeholders
    (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(indexDisplay !== null || indexId !== null, "The markup '".concat(markup, "' does not contain either of the placeholders '__id__' or '__display__'"));
    if (indexDisplay !== null && indexId !== null) // both placeholders are used, return 0 or 1 depending on the position of the requested parameter
    return parameterName === 'id' && indexId <= indexDisplay || parameterName === 'display' && indexDisplay <= indexId ? 0 : 1;
     // just one placeholder is being used, we'll use the captured string for both parameters
    return 0;
};
var $8ffb46a819a74219$var$combineRegExps = function combineRegExps(regExps) {
    var serializedRegexParser = /^\/(.+)\/(\w+)?$/;
    return new RegExp(regExps.map(function(regex) {
        var _serializedRegexParse = serializedRegexParser.exec(regex.toString()), _serializedRegexParse2 = (0, $8yC0U.default)(_serializedRegexParse, 3), regexString = _serializedRegexParse2[1], regexFlags = _serializedRegexParse2[2];
        (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(!regexFlags, "RegExp flags are not supported. Change /".concat(regexString, "/").concat(regexFlags, " into /").concat(regexString, "/"));
        return "(".concat(regexString, ")");
    }).join('|'), 'g');
};
var $8ffb46a819a74219$var$countPlaceholders = function countPlaceholders(markup) {
    var count = 0;
    if (markup.indexOf('__id__') >= 0) count++;
    if (markup.indexOf('__display__') >= 0) count++;
    return count;
};
var $8ffb46a819a74219$var$emptyFn = function emptyFn() {}; // Finds all occurrences of the markup in the value and calls the `markupIteratee` callback for each of them.
// The optional `textIteratee` callback is called for each plain text ranges in between these markup occurrences.
var $8ffb46a819a74219$var$iterateMentionsMarkup = function iterateMentionsMarkup(value, config, markupIteratee) {
    var textIteratee = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $8ffb46a819a74219$var$emptyFn;
    var regex = $8ffb46a819a74219$var$combineRegExps(config.map(function(c) {
        return c.regex;
    }));
    var accOffset = 2; // first is whole match, second is the for the capturing group of first regexp component
    var captureGroupOffsets = config.map(function(_ref) {
        var markup = _ref.markup;
        var result = accOffset; // + 1 is for the capturing group we add around each regexp component in combineRegExps
        accOffset += $8ffb46a819a74219$var$countPlaceholders(markup) + 1;
        return result;
    });
    var match;
    var start = 0;
    var currentPlainTextIndex = 0; // detect all mention markup occurrences in the value and iterate the matches
    while((match = regex.exec(value)) !== null){
        var offset = captureGroupOffsets.find(function(o) {
            return !!match[o];
        }); // eslint-disable-line no-loop-func
        var mentionChildIndex = captureGroupOffsets.indexOf(offset);
        var _config$mentionChildI = config[mentionChildIndex], markup = _config$mentionChildI.markup, displayTransform = _config$mentionChildI.displayTransform;
        var idPos = offset + $8ffb46a819a74219$var$findPositionOfCapturingGroup(markup, 'id');
        var displayPos = offset + $8ffb46a819a74219$var$findPositionOfCapturingGroup(markup, 'display');
        var id = match[idPos];
        var display = displayTransform(id, match[displayPos]);
        var substr = value.substring(start, match.index);
        textIteratee(substr, start, currentPlainTextIndex);
        currentPlainTextIndex += substr.length;
        markupIteratee(match[0], match.index, currentPlainTextIndex, id, display, mentionChildIndex, start);
        currentPlainTextIndex += display.length;
        start = regex.lastIndex;
    }
    if (start < value.length) textIteratee(value.substring(start), start, currentPlainTextIndex);
};
var $8ffb46a819a74219$var$getPlainText = function getPlainText(value, config) {
    var result = '';
    $8ffb46a819a74219$var$iterateMentionsMarkup(value, config, function(match, index, plainTextIndex, id, display) {
        result += display;
    }, function(plainText) {
        result += plainText;
    });
    return result;
};
// in the marked up value string.
// If the passed character index lies inside a mention, the value of `inMarkupCorrection` defines the
// correction to apply:
//   - 'START' to return the index of the mention markup's first char (default)
//   - 'END' to return the index after its last char
//   - 'NULL' to return null
var $8ffb46a819a74219$var$mapPlainTextIndex = function mapPlainTextIndex(value, config, indexInPlainText) {
    var inMarkupCorrection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'START';
    if (typeof indexInPlainText !== 'number') return indexInPlainText;
    var result;
    var textIteratee = function textIteratee(substr, index, substrPlainTextIndex) {
        if (result !== undefined) return;
        if (substrPlainTextIndex + substr.length >= indexInPlainText) // found the corresponding position in the current plain text range
        result = index + indexInPlainText - substrPlainTextIndex;
    };
    var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, childIndex, lastMentionEndIndex) {
        if (result !== undefined) return;
        if (mentionPlainTextIndex + display.length > indexInPlainText) {
            // found the corresponding position inside current match,
            // return the index of the first or after the last char of the matching markup
            // depending on whether the `inMarkupCorrection`
            if (inMarkupCorrection === 'NULL') result = null;
            else result = index + (inMarkupCorrection === 'END' ? markup.length : 0);
        }
    };
    $8ffb46a819a74219$var$iterateMentionsMarkup(value, config, markupIteratee, textIteratee); // when a mention is at the end of the value and we want to get the caret position
    // at the end of the string, result is undefined
    return result === undefined ? value.length : result;
};
var $8ffb46a819a74219$var$spliceString = function spliceString(str, start, end, insert) {
    return str.substring(0, start) + insert + str.substring(end);
};
// guided by the textarea text selection ranges before and after the change
var $8ffb46a819a74219$var$applyChangeToValue = function applyChangeToValue(value, plainTextValue, _ref, config) {
    var selectionStartBefore = _ref.selectionStartBefore, selectionEndBefore = _ref.selectionEndBefore, selectionEndAfter = _ref.selectionEndAfter;
    var oldPlainTextValue = $8ffb46a819a74219$var$getPlainText(value, config);
    var lengthDelta = oldPlainTextValue.length - plainTextValue.length;
    if (selectionStartBefore === 'undefined') selectionStartBefore = selectionEndAfter + lengthDelta;
    if (selectionEndBefore === 'undefined') selectionEndBefore = selectionStartBefore;
     // Fixes an issue with replacing combined characters for complex input. Eg like acented letters on OSX
    if (selectionStartBefore === selectionEndBefore && selectionEndBefore === selectionEndAfter && oldPlainTextValue.length === plainTextValue.length) selectionStartBefore = selectionStartBefore - 1;
     // extract the insertion from the new plain text value
    var insert = plainTextValue.slice(selectionStartBefore, selectionEndAfter); // handling for Backspace key with no range selection
    var spliceStart = Math.min(selectionStartBefore, selectionEndAfter);
    var spliceEnd = selectionEndBefore;
    if (selectionStartBefore === selectionEndAfter) // handling for Delete key with no range selection
    spliceEnd = Math.max(selectionEndBefore, selectionStartBefore + lengthDelta);
    var mappedSpliceStart = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceStart, 'START');
    var mappedSpliceEnd = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceEnd, 'END');
    var controlSpliceStart = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceStart, 'NULL');
    var controlSpliceEnd = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceEnd, 'NULL');
    var willRemoveMention = controlSpliceStart === null || controlSpliceEnd === null;
    var newValue = $8ffb46a819a74219$var$spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);
    if (!willRemoveMention) {
        // test for auto-completion changes
        var controlPlainTextValue = $8ffb46a819a74219$var$getPlainText(newValue, config);
        if (controlPlainTextValue !== plainTextValue) {
            // some auto-correction is going on
            // find start of diff
            spliceStart = 0;
            while(plainTextValue[spliceStart] === controlPlainTextValue[spliceStart])spliceStart++;
             // extract auto-corrected insertion
            insert = plainTextValue.slice(spliceStart, selectionEndAfter); // find index of the unchanged remainder
            spliceEnd = oldPlainTextValue.lastIndexOf(plainTextValue.substring(selectionEndAfter)); // re-map the corrected indices
            mappedSpliceStart = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceStart, 'START');
            mappedSpliceEnd = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, spliceEnd, 'END');
            newValue = $8ffb46a819a74219$var$spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);
        }
    }
    return newValue;
};
// returns a the index of of the first char of the mention in the plain text.
// If indexInPlainText does not lie inside a mention, returns indexInPlainText.
var $8ffb46a819a74219$var$findStartOfMentionInPlainText = function findStartOfMentionInPlainText(value, config, indexInPlainText) {
    var result = indexInPlainText;
    var foundMention = false;
    var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, childIndex, lastMentionEndIndex) {
        if (mentionPlainTextIndex <= indexInPlainText && mentionPlainTextIndex + display.length > indexInPlainText) {
            result = mentionPlainTextIndex;
            foundMention = true;
        }
    };
    $8ffb46a819a74219$var$iterateMentionsMarkup(value, config, markupIteratee);
    if (foundMention) return result;
};
var $8ffb46a819a74219$var$getMentions = function getMentions(value, config) {
    var mentions = [];
    $8ffb46a819a74219$var$iterateMentionsMarkup(value, config, function(match, index, plainTextIndex, id, display, childIndex, start) {
        mentions.push({
            id: id,
            display: display,
            childIndex: childIndex,
            index: index,
            plainTextIndex: plainTextIndex
        });
    });
    return mentions;
};
var $8ffb46a819a74219$var$getSuggestionHtmlId = function getSuggestionHtmlId(prefix, id) {
    return "".concat(prefix, "-").concat(id);
};
var $8ffb46a819a74219$var$countSuggestions = function countSuggestions(suggestions) {
    return Object.values(suggestions).reduce(function(acc, _ref) {
        var results = _ref.results;
        return acc + results.length;
    }, 0);
};
var $8ffb46a819a74219$var$getEndOfLastMention = function getEndOfLastMention(value, config) {
    var mentions = $8ffb46a819a74219$var$getMentions(value, config);
    var lastMention = mentions[mentions.length - 1];
    return lastMention ? lastMention.plainTextIndex + lastMention.display.length : 0;
};
var $8ffb46a819a74219$var$markupToRegex = function markupToRegex(markup) {
    var escapedMarkup = $8ffb46a819a74219$var$escapeRegex(markup);
    var charAfterDisplay = markup[markup.indexOf($8ffb46a819a74219$var$PLACEHOLDERS.display) + $8ffb46a819a74219$var$PLACEHOLDERS.display.length];
    var charAfterId = markup[markup.indexOf($8ffb46a819a74219$var$PLACEHOLDERS.id) + $8ffb46a819a74219$var$PLACEHOLDERS.id.length];
    return new RegExp(escapedMarkup.replace($8ffb46a819a74219$var$PLACEHOLDERS.display, "([^".concat($8ffb46a819a74219$var$escapeRegex(charAfterDisplay || ''), "]+?)")).replace($8ffb46a819a74219$var$PLACEHOLDERS.id, "([^".concat($8ffb46a819a74219$var$escapeRegex(charAfterId || ''), "]+?)")));
};
var $8ffb46a819a74219$var$readConfigFromChildren = function readConfigFromChildren(children) {
    return (0, $acw62.Children).toArray(children).map(function(_ref) {
        var _ref$props = _ref.props, markup = _ref$props.markup, regex = _ref$props.regex, displayTransform = _ref$props.displayTransform;
        return {
            markup: markup,
            regex: regex ? $8ffb46a819a74219$var$coerceCapturingGroups(regex, markup) : $8ffb46a819a74219$var$markupToRegex(markup),
            displayTransform: displayTransform || function(id, display) {
                return display || id;
            }
        };
    });
}; // make sure that the custom regex defines the correct number of capturing groups
var $8ffb46a819a74219$var$coerceCapturingGroups = function coerceCapturingGroups(regex, markup) {
    var numberOfGroups = new RegExp(regex.toString() + '|').exec('').length - 1;
    var numberOfPlaceholders = $8ffb46a819a74219$var$countPlaceholders(markup);
    (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(numberOfGroups === numberOfPlaceholders, "Number of capturing groups in RegExp ".concat(regex.toString(), " (").concat(numberOfGroups, ") does not match the number of placeholders in the markup '").concat(markup, "' (").concat(numberOfPlaceholders, ")"));
    return regex;
};
var $8ffb46a819a74219$var$makeMentionsMarkup = function makeMentionsMarkup(markup, id, display) {
    return markup.replace($8ffb46a819a74219$var$PLACEHOLDERS.id, id).replace($8ffb46a819a74219$var$PLACEHOLDERS.display, display);
};
// This contains all the latin letters and the regex that match these letters with diacritics
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
var $8ffb46a819a74219$var$lettersDiacritics = [
    {
        base: 'A',
        letters: /(&#65;|&#9398;|&#65313;|&#192;|&#193;|&#194;|&#7846;|&#7844;|&#7850;|&#7848;|&#195;|&#256;|&#258;|&#7856;|&#7854;|&#7860;|&#7858;|&#550;|&#480;|&#196;|&#478;|&#7842;|&#197;|&#506;|&#461;|&#512;|&#514;|&#7840;|&#7852;|&#7862;|&#7680;|&#260;|&#570;|&#11375;|[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F])/g
    },
    {
        base: 'AA',
        letters: /(&#42802;|[\uA732])/g
    },
    {
        base: 'AE',
        letters: /(&#198;|&#508;|&#482;|[\u00C6\u01FC\u01E2])/g
    },
    {
        base: 'AO',
        letters: /(&#42804;|[\uA734])/g
    },
    {
        base: 'AU',
        letters: /(&#42806;|[\uA736])/g
    },
    {
        base: 'AV',
        letters: /(&#42808;|&#42810;|[\uA738\uA73A])/g
    },
    {
        base: 'AY',
        letters: /(&#42812;|[\uA73C])/g
    },
    {
        base: 'B',
        letters: /(&#66;|&#9399;|&#65314;|&#7682;|&#7684;|&#7686;|&#579;|&#386;|&#385;|[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181])/g
    },
    {
        base: 'C',
        letters: /(&#67;|&#9400;|&#65315;|&#262;|&#264;|&#266;|&#268;|&#199;|&#7688;|&#391;|&#571;|&#42814;|[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E])/g
    },
    {
        base: 'D',
        letters: /(&#68;|&#9401;|&#65316;|&#7690;|&#270;|&#7692;|&#7696;|&#7698;|&#7694;|&#272;|&#395;|&#394;|&#393;|&#42873;|&#208;|[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0])/g
    },
    {
        base: 'DZ',
        letters: /(&#497;|&#452;|[\u01F1\u01C4])/g
    },
    {
        base: 'Dz',
        letters: /(&#498;|&#453;|[\u01F2\u01C5])/g
    },
    {
        base: 'E',
        letters: /(&#69;|&#9402;|&#65317;|&#200;|&#201;|&#202;|&#7872;|&#7870;|&#7876;|&#7874;|&#7868;|&#274;|&#7700;|&#7702;|&#276;|&#278;|&#203;|&#7866;|&#282;|&#516;|&#518;|&#7864;|&#7878;|&#552;|&#7708;|&#280;|&#7704;|&#7706;|&#400;|&#398;|[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E])/g
    },
    {
        base: 'F',
        letters: /(&#70;|&#9403;|&#65318;|&#7710;|&#401;|&#42875;|[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B])/g
    },
    {
        base: 'G',
        letters: /(&#71;|&#9404;|&#65319;|&#500;|&#284;|&#7712;|&#286;|&#288;|&#486;|&#290;|&#484;|&#403;|&#42912;|&#42877;|&#42878;|[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E])/g
    },
    {
        base: 'H',
        letters: /(&#72;|&#9405;|&#65320;|&#292;|&#7714;|&#7718;|&#542;|&#7716;|&#7720;|&#7722;|&#294;|&#11367;|&#11381;|&#42893;|[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D])/g
    },
    {
        base: 'I',
        letters: /(&#73;|&#9406;|&#65321;|&#204;|&#205;|&#206;|&#296;|&#298;|&#300;|&#304;|&#207;|&#7726;|&#7880;|&#463;|&#520;|&#522;|&#7882;|&#302;|&#7724;|&#407;|[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197])/g
    },
    {
        base: 'J',
        letters: /(&#74;|&#9407;|&#65322;|&#308;|&#584;|[\u004A\u24BF\uFF2A\u0134\u0248])/g
    },
    {
        base: 'K',
        letters: /(&#75;|&#9408;|&#65323;|&#7728;|&#488;|&#7730;|&#310;|&#7732;|&#408;|&#11369;|&#42816;|&#42818;|&#42820;|&#42914;|[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2])/g
    },
    {
        base: 'L',
        letters: /(&#76;|&#9409;|&#65324;|&#319;|&#313;|&#317;|&#7734;|&#7736;|&#315;|&#7740;|&#7738;|&#321;|&#573;|&#11362;|&#11360;|&#42824;|&#42822;|&#42880;|[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780])/g
    },
    {
        base: 'LJ',
        letters: /(&#455;|[\u01C7])/g
    },
    {
        base: 'Lj',
        letters: /(&#456;|[\u01C8])/g
    },
    {
        base: 'M',
        letters: /(&#77;|&#9410;|&#65325;|&#7742;|&#7744;|&#7746;|&#11374;|&#412;|[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C])/g
    },
    {
        base: 'N',
        letters: /(&#78;|&#9411;|&#65326;|&#504;|&#323;|&#209;|&#7748;|&#327;|&#7750;|&#325;|&#7754;|&#7752;|&#544;|&#413;|&#42896;|&#42916;|&#330;|[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4\u014A])/g
    },
    {
        base: 'NJ',
        letters: /(&#458;|[\u01CA])/g
    },
    {
        base: 'Nj',
        letters: /(&#459;|[\u01CB])/g
    },
    {
        base: 'O',
        letters: /(&#79;|&#9412;|&#65327;|&#210;|&#211;|&#212;|&#7890;|&#7888;|&#7894;|&#7892;|&#213;|&#7756;|&#556;|&#7758;|&#332;|&#7760;|&#7762;|&#334;|&#558;|&#560;|&#214;|&#554;|&#7886;|&#336;|&#465;|&#524;|&#526;|&#416;|&#7900;|&#7898;|&#7904;|&#7902;|&#7906;|&#7884;|&#7896;|&#490;|&#492;|&#216;|&#510;|&#390;|&#415;|&#42826;|&#42828;|[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C])/g
    },
    {
        base: 'OE',
        letters: /(&#338;|[\u0152])/g
    },
    {
        base: 'OI',
        letters: /(&#418;|[\u01A2])/g
    },
    {
        base: 'OO',
        letters: /(&#42830;|[\uA74E])/g
    },
    {
        base: 'OU',
        letters: /(&#546;|[\u0222])/g
    },
    {
        base: 'P',
        letters: /(&#80;|&#9413;|&#65328;|&#7764;|&#7766;|&#420;|&#11363;|&#42832;|&#42834;|&#42836;|[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754])/g
    },
    {
        base: 'Q',
        letters: /(&#81;|&#9414;|&#65329;|&#42838;|&#42840;|&#586;|[\u0051\u24C6\uFF31\uA756\uA758\u024A])/g
    },
    {
        base: 'R',
        letters: /(&#82;|&#9415;|&#65330;|&#340;|&#7768;|&#344;|&#528;|&#530;|&#7770;|&#7772;|&#342;|&#7774;|&#588;|&#11364;|&#42842;|&#42918;|&#42882;|[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782])/g
    },
    {
        base: 'S',
        letters: /(&#83;|&#9416;|&#65331;|&#7838;|&#346;|&#7780;|&#348;|&#7776;|&#352;|&#7782;|&#7778;|&#7784;|&#536;|&#350;|&#11390;|&#42920;|&#42884;|[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784])/g
    },
    {
        base: 'T',
        letters: /(&#84;|&#9417;|&#65332;|&#7786;|&#356;|&#7788;|&#538;|&#354;|&#7792;|&#7790;|&#358;|&#428;|&#430;|&#574;|&#42886;|[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786])/g
    },
    {
        base: 'TH',
        letters: /(&#222;|[\u00DE])/g
    },
    {
        base: 'TZ',
        letters: /(&#42792;|[\uA728])/g
    },
    {
        base: 'U',
        letters: /(&#85;|&#9418;|&#65333;|&#217;|&#218;|&#219;|&#360;|&#7800;|&#362;|&#7802;|&#364;|&#220;|&#475;|&#471;|&#469;|&#473;|&#7910;|&#366;|&#368;|&#467;|&#532;|&#534;|&#431;|&#7914;|&#7912;|&#7918;|&#7916;|&#7920;|&#7908;|&#7794;|&#370;|&#7798;|&#7796;|&#580;|[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244])/g
    },
    {
        base: 'V',
        letters: /(&#86;|&#9419;|&#65334;|&#7804;|&#7806;|&#434;|&#42846;|&#581;|[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245])/g
    },
    {
        base: 'VY',
        letters: /(&#42848;|[\uA760])/g
    },
    {
        base: 'W',
        letters: /(&#87;|&#9420;|&#65335;|&#7808;|&#7810;|&#372;|&#7814;|&#7812;|&#7816;|&#11378;|[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72])/g
    },
    {
        base: 'X',
        letters: /(&#88;|&#9421;|&#65336;|&#7818;|&#7820;|[\u0058\u24CD\uFF38\u1E8A\u1E8C])/g
    },
    {
        base: 'Y',
        letters: /(&#89;|&#9422;|&#65337;|&#7922;|&#221;|&#374;|&#7928;|&#562;|&#7822;|&#376;|&#7926;|&#7924;|&#435;|&#590;|&#7934;|[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE])/g
    },
    {
        base: 'Z',
        letters: /(&#90;|&#9423;|&#65338;|&#377;|&#7824;|&#379;|&#381;|&#7826;|&#7828;|&#437;|&#548;|&#11391;|&#11371;|&#42850;|[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762])/g
    },
    {
        base: 'a',
        letters: /(&#97;|&#9424;|&#65345;|&#7834;|&#224;|&#225;|&#226;|&#7847;|&#7845;|&#7851;|&#7849;|&#227;|&#257;|&#259;|&#7857;|&#7855;|&#7861;|&#7859;|&#551;|&#481;|&#228;|&#479;|&#7843;|&#229;|&#507;|&#462;|&#513;|&#515;|&#7841;|&#7853;|&#7863;|&#7681;|&#261;|&#11365;|&#592;|[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250])/g
    },
    {
        base: 'aa',
        letters: /(&#42803;|[\uA733])/g
    },
    {
        base: 'ae',
        letters: /(&#230;|&#509;|&#483;|[\u00E6\u01FD\u01E3])/g
    },
    {
        base: 'ao',
        letters: /(&#42805;|[\uA735])/g
    },
    {
        base: 'au',
        letters: /(&#42807;|[\uA737])/g
    },
    {
        base: 'av',
        letters: /(&#42809;|&#42811;|[\uA739\uA73B])/g
    },
    {
        base: 'ay',
        letters: /(&#42813;|[\uA73D])/g
    },
    {
        base: 'b',
        letters: /(&#98;|&#9425;|&#65346;|&#7683;|&#7685;|&#7687;|&#384;|&#387;|&#595;|[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253])/g
    },
    {
        base: 'c',
        letters: /(&#99;|&#9426;|&#65347;|&#263;|&#265;|&#267;|&#269;|&#231;|&#7689;|&#392;|&#572;|&#42815;|&#8580;|[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184])/g
    },
    {
        base: 'd',
        letters: /(&#100;|&#9427;|&#65348;|&#7691;|&#271;|&#7693;|&#7697;|&#7699;|&#7695;|&#273;|&#396;|&#598;|&#599;|&#42874;|&#240;|[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A\u00F0])/g
    },
    {
        base: 'dz',
        letters: /(&#499;|&#454;|[\u01F3\u01C6])/g
    },
    {
        base: 'e',
        letters: /(&#101;|&#9428;|&#65349;|&#232;|&#233;|&#234;|&#7873;|&#7871;|&#7877;|&#7875;|&#7869;|&#275;|&#7701;|&#7703;|&#277;|&#279;|&#235;|&#7867;|&#283;|&#517;|&#519;|&#7865;|&#7879;|&#553;|&#7709;|&#281;|&#7705;|&#7707;|&#583;|&#603;|&#477;|[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD])/g
    },
    {
        base: 'f',
        letters: /(&#102;|&#9429;|&#65350;|&#7711;|&#402;|&#42876;|[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C])/g
    },
    {
        base: 'g',
        letters: /(&#103;|&#9430;|&#65351;|&#501;|&#285;|&#7713;|&#287;|&#289;|&#487;|&#291;|&#485;|&#608;|&#42913;|&#7545;|&#42879;|[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F])/g
    },
    {
        base: 'h',
        letters: /(&#104;|&#9431;|&#65352;|&#293;|&#7715;|&#7719;|&#543;|&#7717;|&#7721;|&#7723;|&#7830;|&#295;|&#11368;|&#11382;|&#613;|[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265])/g
    },
    {
        base: 'hv',
        letters: /(&#405;|[\u0195])/g
    },
    {
        base: 'i',
        letters: /(&#105;|&#9432;|&#65353;|&#236;|&#237;|&#238;|&#297;|&#299;|&#301;|&#239;|&#7727;|&#7881;|&#464;|&#521;|&#523;|&#7883;|&#303;|&#7725;|&#616;|&#305;|[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131])/g
    },
    {
        base: 'ij',
        letters: /(&#307;|[\u0133])/g
    },
    {
        base: 'j',
        letters: /(&#106;|&#9433;|&#65354;|&#309;|&#496;|&#585;|[\u006A\u24D9\uFF4A\u0135\u01F0\u0249])/g
    },
    {
        base: 'k',
        letters: /(&#107;|&#9434;|&#65355;|&#7729;|&#489;|&#7731;|&#311;|&#7733;|&#409;|&#11370;|&#42817;|&#42819;|&#42821;|&#42915;|[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3])/g
    },
    {
        base: 'l',
        letters: /(&#108;|&#9435;|&#65356;|&#320;|&#314;|&#318;|&#7735;|&#7737;|&#316;|&#7741;|&#7739;|&#322;|&#410;|&#619;|&#11361;|&#42825;|&#42881;|&#42823;|[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u0142\u019A\u026B\u2C61\uA749\uA781\uA747])/g
    },
    {
        base: 'lj',
        letters: /(&#457;|[\u01C9])/g
    },
    {
        base: 'm',
        letters: /(&#109;|&#9436;|&#65357;|&#7743;|&#7745;|&#7747;|&#625;|&#623;|[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F])/g
    },
    {
        base: 'n',
        letters: /(&#110;|&#9437;|&#65358;|&#505;|&#324;|&#241;|&#7749;|&#328;|&#7751;|&#326;|&#7755;|&#7753;|&#414;|&#626;|&#329;|&#42897;|&#42917;|&#331;|[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u014B])/g
    },
    {
        base: 'nj',
        letters: /(&#460;|[\u01CC])/g
    },
    {
        base: 'o',
        letters: /(&#111;|&#9438;|&#65359;|&#242;|&#243;|&#244;|&#7891;|&#7889;|&#7895;|&#7893;|&#245;|&#7757;|&#557;|&#7759;|&#333;|&#7761;|&#7763;|&#335;|&#559;|&#561;|&#246;|&#555;|&#7887;|&#337;|&#466;|&#525;|&#527;|&#417;|&#7901;|&#7899;|&#7905;|&#7903;|&#7907;|&#7885;|&#7897;|&#491;|&#493;|&#248;|&#511;|&#596;|&#42827;|&#42829;|&#629;|[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275])/g
    },
    {
        base: 'oe',
        letters: /(&#339;|[\u0153])/g
    },
    {
        base: 'oi',
        letters: /(&#419;|[\u01A3])/g
    },
    {
        base: 'ou',
        letters: /(&#547;|[\u0223])/g
    },
    {
        base: 'oo',
        letters: /(&#42831;|[\uA74F])/g
    },
    {
        base: 'p',
        letters: /(&#112;|&#9439;|&#65360;|&#7765;|&#7767;|&#421;|&#7549;|&#42833;|&#42835;|&#42837;|[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755])/g
    },
    {
        base: 'q',
        letters: /(&#113;|&#9440;|&#65361;|&#587;|&#42839;|&#42841;|[\u0071\u24E0\uFF51\u024B\uA757\uA759])/g
    },
    {
        base: 'r',
        letters: /(&#114;|&#9441;|&#65362;|&#341;|&#7769;|&#345;|&#529;|&#531;|&#7771;|&#7773;|&#343;|&#7775;|&#589;|&#637;|&#42843;|&#42919;|&#42883;|[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783])/g
    },
    {
        base: 's',
        letters: /(&#115;|&#9442;|&#65363;|&#347;|&#7781;|&#349;|&#7777;|&#353;|&#7783;|&#7779;|&#7785;|&#537;|&#351;|&#575;|&#42921;|&#42885;|&#7835;|&#383;|[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u017F])/g
    },
    {
        base: 'ss',
        letters: /(&#223;|[\u00DF])/g
    },
    {
        base: 't',
        letters: /(&#116;|&#9443;|&#65364;|&#7787;|&#7831;|&#357;|&#7789;|&#539;|&#355;|&#7793;|&#7791;|&#359;|&#429;|&#648;|&#11366;|&#42887;|[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787])/g
    },
    {
        base: 'th',
        letters: /(&#254;|[\u00FE])/g
    },
    {
        base: 'tz',
        letters: /(&#42793;|[\uA729])/g
    },
    {
        base: 'u',
        letters: /(&#117;|&#9444;|&#65365;|&#249;|&#250;|&#251;|&#361;|&#7801;|&#363;|&#7803;|&#365;|&#252;|&#476;|&#472;|&#470;|&#474;|&#7911;|&#367;|&#369;|&#468;|&#533;|&#535;|&#432;|&#7915;|&#7913;|&#7919;|&#7917;|&#7921;|&#7909;|&#7795;|&#371;|&#7799;|&#7797;|&#649;|[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289])/g
    },
    {
        base: 'v',
        letters: /(&#118;|&#9445;|&#65366;|&#7805;|&#7807;|&#651;|&#42847;|&#652;|[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C])/g
    },
    {
        base: 'vy',
        letters: /(&#42849;|[\uA761])/g
    },
    {
        base: 'w',
        letters: /(&#119;|&#9446;|&#65367;|&#7809;|&#7811;|&#373;|&#7815;|&#7813;|&#7832;|&#7817;|&#11379;|[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73])/g
    },
    {
        base: 'x',
        letters: /(&#120;|&#9447;|&#65368;|&#7819;|&#7821;|[\u0078\u24E7\uFF58\u1E8B\u1E8D])/g
    },
    {
        base: 'y',
        letters: /(&#121;|&#9448;|&#65369;|&#7923;|&#253;|&#375;|&#7929;|&#563;|&#7823;|&#255;|&#7927;|&#7833;|&#7925;|&#436;|&#591;|&#7935;|[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF])/g
    },
    {
        base: 'z',
        letters: /(&#122;|&#9449;|&#65370;|&#378;|&#7825;|&#380;|&#382;|&#7827;|&#7829;|&#438;|&#549;|&#576;|&#11372;|&#42851;|[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763])/g
    }
];
var $8ffb46a819a74219$var$removeAccents = function removeAccents(str) {
    var formattedStr = str;
    $8ffb46a819a74219$var$lettersDiacritics.forEach(function(letterDiacritics) {
        formattedStr = formattedStr.replace(letterDiacritics.letters, letterDiacritics.base);
    });
    return formattedStr;
};
var $8ffb46a819a74219$var$normalizeString = function normalizeString(str) {
    return $8ffb46a819a74219$var$removeAccents(str).toLowerCase();
};
var $8ffb46a819a74219$var$getSubstringIndex = function getSubstringIndex(str, substr, ignoreAccents) {
    if (!ignoreAccents) return str.toLowerCase().indexOf(substr.toLowerCase());
    return $8ffb46a819a74219$var$normalizeString(str).indexOf($8ffb46a819a74219$var$normalizeString(substr));
};
var $8ffb46a819a74219$var$isIE = function isIE() {
    return !!document.documentMode;
};
var $8ffb46a819a74219$var$isNumber = function isNumber(val) {
    return typeof val === 'number';
};
var $8ffb46a819a74219$var$keys = function keys(obj) {
    return obj === Object(obj) ? Object.keys(obj) : [];
};
var $8ffb46a819a74219$var$omit = function omit(obj) {
    var _ref;
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    var keys = (_ref = []).concat.apply(_ref, rest);
    return Object.keys(obj).reduce(function(acc, k) {
        if (obj.hasOwnProperty(k) && !keys.includes(k) && obj[k] !== undefined) acc[k] = obj[k];
        return acc;
    }, {});
};
var $8ffb46a819a74219$var$_excluded = [
    "style",
    "className",
    "classNames"
];
function $8ffb46a819a74219$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ffb46a819a74219$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8ffb46a819a74219$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $jRhPI.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8ffb46a819a74219$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ffb46a819a74219$var$createDefaultStyle(defaultStyle, getModifiers) {
    var enhance = function enhance(ComponentToWrap) {
        var DefaultStyleEnhancer = function DefaultStyleEnhancer(_ref) {
            var style = _ref.style, className = _ref.className, classNames = _ref.classNames, rest = (0, $2PtM8.default)(_ref, $8ffb46a819a74219$var$_excluded);
            var modifiers = getModifiers ? getModifiers(rest) : undefined;
            var styles = (0, $gkmFh.default)(defaultStyle, {
                style: style,
                className: className,
                classNames: classNames
            }, modifiers);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ComponentToWrap, (0, $2AARm.default)({}, rest, {
                style: styles
            }));
        };
        var displayName = ComponentToWrap.displayName || ComponentToWrap.name || 'Component';
        DefaultStyleEnhancer.displayName = "defaultStyle(".concat(displayName, ")"); // return DefaultStyleEnhancer
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return DefaultStyleEnhancer($8ffb46a819a74219$var$_objectSpread($8ffb46a819a74219$var$_objectSpread({}, props), {}, {
                ref: ref
            }));
        });
    };
    return enhance;
}
var $8ffb46a819a74219$var$_generateComponentKey = function _generateComponentKey(usedKeys, id) {
    if (!usedKeys.hasOwnProperty(id)) usedKeys[id] = 0;
    else usedKeys[id]++;
    return id + '_' + usedKeys[id];
};
function $8ffb46a819a74219$var$Highlighter(_ref) {
    var selectionStart = _ref.selectionStart, selectionEnd = _ref.selectionEnd, _ref$value = _ref.value, value = _ref$value === void 0 ? '' : _ref$value, onCaretPositionChange = _ref.onCaretPositionChange, containerRef = _ref.containerRef, children = _ref.children, singleLine = _ref.singleLine, style = _ref.style;
    var _useState = (0, $acw62.useState)({
        left: undefined,
        top: undefined
    }), _useState2 = (0, $8yC0U.default)(_useState, 2), position = _useState2[0], setPosition = _useState2[1];
    var _useState3 = (0, $acw62.useState)(), _useState4 = (0, $8yC0U.default)(_useState3, 2), caretElement = _useState4[0], setCaretElement = _useState4[1];
    (0, $acw62.useEffect)(function() {
        notifyCaretPosition();
    });
    var notifyCaretPosition = function notifyCaretPosition() {
        if (!caretElement) return;
        var offsetLeft = caretElement.offsetLeft, offsetTop = caretElement.offsetTop;
        if (position.left === offsetLeft && position.top === offsetTop) return;
        var newPosition = {
            left: offsetLeft,
            top: offsetTop
        };
        setPosition(newPosition);
        onCaretPositionChange(newPosition);
    };
    var config = $8ffb46a819a74219$var$readConfigFromChildren(children);
    var caretPositionInMarkup;
    if (selectionEnd === selectionStart) caretPositionInMarkup = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionStart, 'START');
    var resultComponents = [];
    var componentKeys = {};
    var components = resultComponents;
    var substringComponentKey = 0;
    var textIteratee = function textIteratee(substr, index, indexInPlainText) {
        // check whether the caret element has to be inserted inside the current plain substring
        if ($8ffb46a819a74219$var$isNumber(caretPositionInMarkup) && caretPositionInMarkup >= index && caretPositionInMarkup <= index + substr.length) {
            // if yes, split substr at the caret position and insert the caret component
            var splitIndex = caretPositionInMarkup - index;
            components.push(renderSubstring(substr.substring(0, splitIndex), substringComponentKey)); // add all following substrings and mention components as children of the caret component
            components = [
                renderSubstring(substr.substring(splitIndex), substringComponentKey)
            ];
        } else components.push(renderSubstring(substr, substringComponentKey));
        substringComponentKey++;
    };
    var mentionIteratee = function mentionIteratee(markup, index, indexInPlainText, id, display, mentionChildIndex, lastMentionEndIndex) {
        var key = $8ffb46a819a74219$var$_generateComponentKey(componentKeys, id);
        components.push(getMentionComponentForMatch(id, display, mentionChildIndex, key));
    };
    var renderSubstring = function renderSubstring(string, key) {
        // set substring span to hidden, so that Emojis are not shown double in Mobile Safari
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $2AARm.default)({}, style('substring'), {
            key: key
        }), string);
    };
    var getMentionComponentForMatch = function getMentionComponentForMatch(id, display, mentionChildIndex, key) {
        var props = {
            id: id,
            display: display,
            key: key
        };
        var child = (0, $acw62.Children).toArray(children)[mentionChildIndex];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, props);
    };
    var renderHighlighterCaret = function renderHighlighterCaret(children) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $2AARm.default)({}, style('caret'), {
            ref: setCaretElement,
            key: "caret"
        }), children);
    };
    $8ffb46a819a74219$var$iterateMentionsMarkup(value, config, mentionIteratee, textIteratee); // append a span containing a space, to ensure the last text line has the correct height
    components.push(' ');
    if (components !== resultComponents) // if a caret component is to be rendered, add all components that followed as its children
    resultComponents.push(renderHighlighterCaret(components));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $2AARm.default)({}, style, {
        ref: containerRef
    }), resultComponents);
}
$8ffb46a819a74219$var$Highlighter.propTypes = {
    selectionStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    selectionEnd: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onCaretPositionChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    containerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element)
    ]).isRequired
};
var $8ffb46a819a74219$var$styled = $8ffb46a819a74219$var$createDefaultStyle({
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    color: 'transparent',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    border: '1px solid transparent',
    textAlign: 'start',
    '&singleLine': {
        whiteSpace: 'pre',
        wordWrap: null
    },
    substring: {
        visibility: 'hidden'
    }
}, function(props) {
    return {
        '&singleLine': props.singleLine
    };
});
var $8ffb46a819a74219$var$Highlighter$1 = $8ffb46a819a74219$var$styled($8ffb46a819a74219$var$Highlighter);
function $8ffb46a819a74219$var$Suggestion(_ref) {
    var id = _ref.id, focused = _ref.focused, ignoreAccents = _ref.ignoreAccents, index = _ref.index, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, query = _ref.query, renderSuggestion = _ref.renderSuggestion, suggestion = _ref.suggestion, style = _ref.style, className = _ref.className, classNames = _ref.classNames;
    var rest = {
        onClick: onClick,
        onMouseEnter: onMouseEnter
    };
    var renderContent = function renderContent() {
        var display = getDisplay();
        var highlightedDisplay = renderHighlightedDisplay(display);
        if (renderSuggestion) return renderSuggestion(suggestion, query, highlightedDisplay, index, focused);
        return highlightedDisplay;
    };
    var getDisplay = function getDisplay() {
        if (typeof suggestion === 'string') return suggestion;
        var id = suggestion.id, display = suggestion.display;
        if (id === undefined || !display) return id;
        return display;
    };
    var renderHighlightedDisplay = function renderHighlightedDisplay(display) {
        var i = $8ffb46a819a74219$var$getSubstringIndex(display, query, ignoreAccents);
        if (i === -1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", style('display'), display);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", style('display'), display.substring(0, i), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("b", style('highlight'), display.substring(i, i + query.length)), display.substring(i + query.length));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", (0, $2AARm.default)({
        id: id,
        role: "option",
        "aria-selected": focused
    }, rest, style), renderContent());
}
$8ffb46a819a74219$var$Suggestion.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    query: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    ignoreAccents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    suggestion: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
            ]).isRequired,
            display: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        })
    ]).isRequired,
    renderSuggestion: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    focused: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $8ffb46a819a74219$var$styled$1 = $8ffb46a819a74219$var$createDefaultStyle({
    cursor: 'pointer'
}, function(props) {
    return {
        '&focused': props.focused
    };
});
var $8ffb46a819a74219$var$Suggestion$1 = $8ffb46a819a74219$var$styled$1($8ffb46a819a74219$var$Suggestion);
function $8ffb46a819a74219$var$LoadingIndicator(_ref) {
    var style = _ref.style, className = _ref.className, classNames = _ref.classNames;
    var styles = (0, $gkmFh.default)($8ffb46a819a74219$var$defaultstyle, {
        style: style,
        className: className,
        classNames: classNames
    });
    var spinnerStyles = styles('spinner');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", styles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles([
        'element',
        'element1'
    ])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles([
        'element',
        'element2'
    ])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles([
        'element',
        'element3'
    ])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles([
        'element',
        'element4'
    ])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", spinnerStyles([
        'element',
        'element5'
    ]))));
}
var $8ffb46a819a74219$var$defaultstyle = {};
function $8ffb46a819a74219$var$SuggestionsOverlay(_ref) {
    var id = _ref.id, _ref$suggestions = _ref.suggestions, suggestions = _ref$suggestions === void 0 ? {} : _ref$suggestions, a11ySuggestionsListLabel = _ref.a11ySuggestionsListLabel, focusIndex = _ref.focusIndex, position = _ref.position, left = _ref.left, right = _ref.right, top = _ref.top, scrollFocusedIntoView = _ref.scrollFocusedIntoView, isLoading = _ref.isLoading, isOpened = _ref.isOpened, _ref$onSelect = _ref.onSelect, onSelect = _ref$onSelect === void 0 ? function() {
        return null;
    } : _ref$onSelect, ignoreAccents = _ref.ignoreAccents, containerRef = _ref.containerRef, children = _ref.children, style = _ref.style, customSuggestionsContainer = _ref.customSuggestionsContainer, onMouseDown = _ref.onMouseDown, onMouseEnter = _ref.onMouseEnter;
    var _useState = (0, $acw62.useState)(undefined), _useState2 = (0, $8yC0U.default)(_useState, 2), ulElement = _useState2[0], setUlElement = _useState2[1];
    (0, $acw62.useEffect)(function() {
        if (!ulElement || ulElement.offsetHeight >= ulElement.scrollHeight || !scrollFocusedIntoView) return;
        var scrollTop = ulElement.scrollTop;
        var _ulElement$children$f = ulElement.children[focusIndex].getBoundingClientRect(), top = _ulElement$children$f.top, bottom = _ulElement$children$f.bottom;
        var _ulElement$getBoundin = ulElement.getBoundingClientRect(), topContainer = _ulElement$getBoundin.top;
        top = top - topContainer + scrollTop;
        bottom = bottom - topContainer + scrollTop;
        if (top < scrollTop) ulElement.scrollTop = top;
        else if (bottom > ulElement.offsetHeight) ulElement.scrollTop = bottom - ulElement.offsetHeight;
    }, [
        focusIndex,
        scrollFocusedIntoView,
        ulElement
    ]);
    var renderSuggestions = function renderSuggestions() {
        var suggestionsToRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", (0, $2AARm.default)({
            ref: setUlElement,
            id: id,
            role: "listbox",
            "aria-label": a11ySuggestionsListLabel
        }, style('list')), Object.values(suggestions).reduce(function(accResults, _ref2) {
            var results = _ref2.results, queryInfo = _ref2.queryInfo;
            return [].concat((0, $jwUkK.default)(accResults), (0, $jwUkK.default)(results.map(function(result, index) {
                return renderSuggestion(result, queryInfo, accResults.length + index);
            })));
        }, []));
        if (customSuggestionsContainer) return customSuggestionsContainer(suggestionsToRender);
        return suggestionsToRender;
    };
    var renderSuggestion = function renderSuggestion(result, queryInfo, index) {
        var isFocused = index === focusIndex;
        var childIndex = queryInfo.childIndex, query = queryInfo.query;
        var renderSuggestion = (0, $acw62.Children).toArray(children)[childIndex].props.renderSuggestion;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ffb46a819a74219$var$Suggestion$1, {
            style: style('item'),
            key: "".concat(childIndex, "-").concat(getID(result)),
            id: $8ffb46a819a74219$var$getSuggestionHtmlId(id, index),
            query: query,
            index: index,
            ignoreAccents: ignoreAccents,
            renderSuggestion: renderSuggestion,
            suggestion: result,
            focused: isFocused,
            onClick: function onClick() {
                return select(result, queryInfo);
            },
            onMouseEnter: function onMouseEnter() {
                return handleMouseEnter(index);
            }
        });
    };
    var renderLoadingIndicator = function renderLoadingIndicator() {
        if (!isLoading) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ffb46a819a74219$var$LoadingIndicator, {
            style: style('loadingIndicator')
        });
    };
    var handleMouseEnter = function handleMouseEnter(index, ev) {
        if (onMouseEnter) onMouseEnter(index);
    };
    var select = function select(suggestion, queryInfo) {
        onSelect(suggestion, queryInfo);
    };
    var getID = function getID(suggestion) {
        if (typeof suggestion === 'string') return suggestion;
        return suggestion.id;
    };
    if (!isOpened) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $2AARm.default)({}, (0, $9UQB7.default)({
        position: position || 'absolute',
        left: left,
        right: right,
        top: top
    }, style), {
        onMouseDown: onMouseDown,
        ref: containerRef
    }), renderSuggestions(), renderLoadingIndicator());
}
$8ffb46a819a74219$var$SuggestionsOverlay.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    suggestions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    a11ySuggestionsListLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    focusIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    scrollFocusedIntoView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isOpened: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    ignoreAccents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    customSuggestionsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    containerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ])
};
var $8ffb46a819a74219$var$styled$2 = $8ffb46a819a74219$var$createDefaultStyle({
    zIndex: 1,
    backgroundColor: 'white',
    marginTop: 14,
    minWidth: 100,
    list: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
    }
});
var $8ffb46a819a74219$var$SuggestionsOverlay$1 = $8ffb46a819a74219$var$styled$2($8ffb46a819a74219$var$SuggestionsOverlay);
function $8ffb46a819a74219$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ffb46a819a74219$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8ffb46a819a74219$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $jRhPI.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8ffb46a819a74219$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ffb46a819a74219$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ffb46a819a74219$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $5HlHN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5HlHN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cYBMK.default)(this, result);
    };
}
function $8ffb46a819a74219$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ffb46a819a74219$var$makeTriggerRegex = function makeTriggerRegex(trigger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (trigger instanceof RegExp) return trigger;
    else {
        var allowSpaceInQuery = options.allowSpaceInQuery;
        var escapedTriggerChar = $8ffb46a819a74219$var$escapeRegex(trigger); // first capture group is the part to be replaced on completion
        // second capture group is for extracting the search query
        return new RegExp("(?:^|\\s)(".concat(escapedTriggerChar, "([^").concat(allowSpaceInQuery ? '' : '\\s').concat(escapedTriggerChar, "]*))$"));
    }
};
var $8ffb46a819a74219$var$getDataProvider = function getDataProvider(data, ignoreAccents) {
    if (data instanceof Array) // if data is an array, create a function to query that
    return function(query, callback) {
        var results = [];
        for(var i = 0, l = data.length; i < l; ++i){
            var display = data[i].display || data[i].id;
            if ($8ffb46a819a74219$var$getSubstringIndex(display, query, ignoreAccents) >= 0) results.push(data[i]);
        }
        return results;
    };
    else // expect data to be a query function
    return data;
};
var $8ffb46a819a74219$var$KEY = {
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    UP: 38,
    DOWN: 40
};
var $8ffb46a819a74219$var$isComposing = false;
var $8ffb46a819a74219$var$propTypes = {
    /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */ singleLine: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    allowSpaceInQuery: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    allowSuggestionsAboveCursor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    forceSuggestionsAboveCursor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ignoreAccents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    a11ySuggestionsListLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    customSuggestionsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    suggestionsPortalHost: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).PropTypes.instanceOf(Element),
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Element)
        })
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element)
    ]).isRequired
};
var $8ffb46a819a74219$var$MentionsInput = /*#__PURE__*/ function(_React$Component) {
    (0, $1Apoc.default)(MentionsInput, _React$Component);
    var _super = $8ffb46a819a74219$var$_createSuper(MentionsInput);
    function MentionsInput(_props) {
        var _this;
        (0, $igh35.default)(this, MentionsInput);
        _this = _super.call(this, _props);
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "setContainerElement", function(el) {
            _this.containerElement = el;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "getInputProps", function() {
            var _this$props = _this.props, readOnly = _this$props.readOnly, disabled = _this$props.disabled, style = _this$props.style; // pass all props that neither we, nor substyle, consume through to the input control
            var props = $8ffb46a819a74219$var$omit(_this.props, [
                'style',
                'classNames',
                'className'
            ], $8ffb46a819a74219$var$keys($8ffb46a819a74219$var$propTypes));
            return $8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1({}, props), style('input')), {}, {
                value: _this.getPlainText(),
                onScroll: _this.updateHighlighterScroll
            }, !readOnly && !disabled && {
                onChange: _this.handleChange,
                onSelect: _this.handleSelect,
                onKeyDown: _this.handleKeyDown,
                onBlur: _this.handleBlur,
                onCompositionStart: _this.handleCompositionStart,
                onCompositionEnd: _this.handleCompositionEnd
            }), _this.isOpened() && {
                role: 'combobox',
                'aria-controls': _this.uuidSuggestionsOverlay,
                'aria-expanded': true,
                'aria-autocomplete': 'list',
                'aria-haspopup': 'listbox',
                'aria-activedescendant': $8ffb46a819a74219$var$getSuggestionHtmlId(_this.uuidSuggestionsOverlay, _this.state.focusIndex)
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "renderControl", function() {
            var _this$props2 = _this.props, singleLine = _this$props2.singleLine, style = _this$props2.style;
            var inputProps = _this.getInputProps();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", style('control'), _this.renderHighlighter(), singleLine ? _this.renderInput(inputProps) : _this.renderTextarea(inputProps));
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "renderInput", function(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $2AARm.default)({
                type: "text",
                ref: _this.setInputRef
            }, props));
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "renderTextarea", function(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", (0, $2AARm.default)({
                ref: _this.setInputRef
            }, props));
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "setInputRef", function(el) {
            _this.inputElement = el;
            var inputRef = _this.props.inputRef;
            if (typeof inputRef === 'function') inputRef(el);
            else if (inputRef) inputRef.current = el;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "setSuggestionsElement", function(el) {
            _this.suggestionsElement = el;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "renderSuggestionsOverlay", function() {
            if (!$8ffb46a819a74219$var$isNumber(_this.state.selectionStart)) // do not show suggestions when the input does not have the focus
            return null;
            var _this$state$suggestio = _this.state.suggestionsPosition, position = _this$state$suggestio.position, left = _this$state$suggestio.left, top = _this$state$suggestio.top, right = _this$state$suggestio.right;
            var suggestionsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ffb46a819a74219$var$SuggestionsOverlay$1, {
                id: _this.uuidSuggestionsOverlay,
                style: _this.props.style('suggestions'),
                position: position,
                left: left,
                top: top,
                right: right,
                focusIndex: _this.state.focusIndex,
                scrollFocusedIntoView: _this.state.scrollFocusedIntoView,
                containerRef: _this.setSuggestionsElement,
                suggestions: _this.state.suggestions,
                customSuggestionsContainer: _this.props.customSuggestionsContainer,
                onSelect: _this.addMention,
                onMouseDown: _this.handleSuggestionsMouseDown,
                onMouseEnter: _this.handleSuggestionsMouseEnter,
                isLoading: _this.isLoading(),
                isOpened: _this.isOpened(),
                ignoreAccents: _this.props.ignoreAccents,
                a11ySuggestionsListLabel: _this.props.a11ySuggestionsListLabel
            }, _this.props.children);
            if (_this.props.suggestionsPortalHost) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(suggestionsNode, _this.props.suggestionsPortalHost);
            else return suggestionsNode;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "renderHighlighter", function() {
            var _this$state = _this.state, selectionStart = _this$state.selectionStart, selectionEnd = _this$state.selectionEnd;
            var _this$props3 = _this.props, singleLine = _this$props3.singleLine, children = _this$props3.children, value = _this$props3.value, style = _this$props3.style;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ffb46a819a74219$var$Highlighter$1, {
                containerRef: _this.setHighlighterElement,
                style: style('highlighter'),
                value: value,
                singleLine: singleLine,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
                onCaretPositionChange: _this.handleCaretPositionChange
            }, children);
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "setHighlighterElement", function(el) {
            _this.highlighterElement = el;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleCaretPositionChange", function(position) {
            _this.setState({
                caretPosition: position
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "getPlainText", function() {
            return $8ffb46a819a74219$var$getPlainText(_this.props.value || '', $8ffb46a819a74219$var$readConfigFromChildren(_this.props.children));
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "executeOnChange", function(event) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (_this.props.onChange) {
                var _this$props4;
                return (_this$props4 = _this.props).onChange.apply(_this$props4, [
                    event
                ].concat(args));
            }
            if (_this.props.valueLink) {
                var _this$props$valueLink;
                return (_this$props$valueLink = _this.props.valueLink).requestChange.apply(_this$props$valueLink, [
                    event.target.value
                ].concat(args));
            }
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleChange", function(ev) {
            $8ffb46a819a74219$var$isComposing = false;
            if ($8ffb46a819a74219$var$isIE()) {
                // if we are inside iframe, we need to find activeElement within its contentDocument
                var currentDocument = document.activeElement && document.activeElement.contentDocument || document;
                if (currentDocument.activeElement !== ev.target) // fix an IE bug (blur from empty input element with placeholder attribute trigger "input" event)
                return;
            }
            var value = _this.props.value || '';
            var config = $8ffb46a819a74219$var$readConfigFromChildren(_this.props.children);
            var newPlainTextValue = ev.target.value;
            var selectionStartBefore = _this.state.selectionStart;
            if (selectionStartBefore == null) selectionStartBefore = ev.target.selectionStart;
            var selectionEndBefore = _this.state.selectionEnd;
            if (selectionEndBefore == null) selectionEndBefore = ev.target.selectionEnd;
             // Derive the new value to set by applying the local change in the textarea's plain text
            var newValue = $8ffb46a819a74219$var$applyChangeToValue(value, newPlainTextValue, {
                selectionStartBefore: selectionStartBefore,
                selectionEndBefore: selectionEndBefore,
                selectionEndAfter: ev.target.selectionEnd
            }, config); // In case a mention is deleted, also adjust the new plain text value
            newPlainTextValue = $8ffb46a819a74219$var$getPlainText(newValue, config); // Save current selection after change to be able to restore caret position after rerendering
            var selectionStart = ev.target.selectionStart;
            var selectionEnd = ev.target.selectionEnd;
            var setSelectionAfterMentionChange = false; // Adjust selection range in case a mention will be deleted by the characters outside of the
            // selection range that are automatically deleted
            var startOfMention = $8ffb46a819a74219$var$findStartOfMentionInPlainText(value, config, selectionStart);
            if (startOfMention !== undefined && _this.state.selectionEnd > startOfMention) {
                // only if a deletion has taken place
                selectionStart = startOfMention + (ev.nativeEvent.data ? ev.nativeEvent.data.length : 0);
                selectionEnd = selectionStart;
                setSelectionAfterMentionChange = true;
            }
            _this.setState({
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
                setSelectionAfterMentionChange: setSelectionAfterMentionChange
            });
            var mentions = $8ffb46a819a74219$var$getMentions(newValue, config);
            if (ev.nativeEvent.isComposing && selectionStart === selectionEnd) _this.updateMentionsQueries(_this.inputElement.value, selectionStart);
             // Propagate change
            // let handleChange = this.getOnChange(this.props) || emptyFunction;
            var eventMock = {
                target: {
                    value: newValue
                }
            }; // this.props.onChange.call(this, eventMock, newValue, newPlainTextValue, mentions);
            _this.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleSelect", function(ev) {
            // keep track of selection range / caret position
            _this.setState({
                selectionStart: ev.target.selectionStart,
                selectionEnd: ev.target.selectionEnd
            }); // do nothing while a IME composition session is active
            if ($8ffb46a819a74219$var$isComposing) return; // refresh suggestions queries
            var el = _this.inputElement;
            if (ev.target.selectionStart === ev.target.selectionEnd) _this.updateMentionsQueries(el.value, ev.target.selectionStart);
            else _this.clearSuggestions();
             // sync highlighters scroll position
            _this.updateHighlighterScroll();
            _this.props.onSelect(ev);
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleKeyDown", function(ev) {
            // do not intercept key events if the suggestions overlay is not shown
            var suggestionsCount = $8ffb46a819a74219$var$countSuggestions(_this.state.suggestions);
            if (suggestionsCount === 0 || !_this.suggestionsElement) {
                _this.props.onKeyDown(ev);
                return;
            }
            if (Object.values($8ffb46a819a74219$var$KEY).indexOf(ev.keyCode) >= 0) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            switch(ev.keyCode){
                case $8ffb46a819a74219$var$KEY.ESC:
                    _this.clearSuggestions();
                    return;
                case $8ffb46a819a74219$var$KEY.DOWN:
                    _this.shiftFocus(1);
                    return;
                case $8ffb46a819a74219$var$KEY.UP:
                    _this.shiftFocus(-1);
                    return;
                case $8ffb46a819a74219$var$KEY.RETURN:
                    _this.selectFocused();
                    return;
                case $8ffb46a819a74219$var$KEY.TAB:
                    _this.selectFocused();
                    return;
                default:
                    return;
            }
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "shiftFocus", function(delta) {
            var suggestionsCount = $8ffb46a819a74219$var$countSuggestions(_this.state.suggestions);
            _this.setState({
                focusIndex: (suggestionsCount + _this.state.focusIndex + delta) % suggestionsCount,
                scrollFocusedIntoView: true
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "selectFocused", function() {
            var _this$state2 = _this.state, suggestions = _this$state2.suggestions, focusIndex = _this$state2.focusIndex;
            var _Object$values$reduce = Object.values(suggestions).reduce(function(acc, _ref) {
                var results = _ref.results, queryInfo = _ref.queryInfo;
                return [].concat((0, $jwUkK.default)(acc), (0, $jwUkK.default)(results.map(function(result) {
                    return {
                        result: result,
                        queryInfo: queryInfo
                    };
                })));
            }, [])[focusIndex], result = _Object$values$reduce.result, queryInfo = _Object$values$reduce.queryInfo;
            _this.addMention(result, queryInfo);
            _this.setState({
                focusIndex: 0
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleBlur", function(ev) {
            var clickedSuggestion = _this._suggestionsMouseDown;
            _this._suggestionsMouseDown = false; // only reset selection if the mousedown happened on an element
            // other than the suggestions overlay
            if (!clickedSuggestion) _this.setState({
                selectionStart: null,
                selectionEnd: null
            });
            window.setTimeout(function() {
                _this.updateHighlighterScroll();
            }, 1);
            _this.props.onBlur(ev, clickedSuggestion);
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleSuggestionsMouseDown", function(ev) {
            _this._suggestionsMouseDown = true;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleSuggestionsMouseEnter", function(focusIndex) {
            _this.setState({
                focusIndex: focusIndex,
                scrollFocusedIntoView: false
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "updateSuggestionsPosition", function() {
            var caretPosition = _this.state.caretPosition;
            var _this$props5 = _this.props, suggestionsPortalHost = _this$props5.suggestionsPortalHost, allowSuggestionsAboveCursor = _this$props5.allowSuggestionsAboveCursor, forceSuggestionsAboveCursor = _this$props5.forceSuggestionsAboveCursor;
            if (!caretPosition || !_this.suggestionsElement) return;
            var suggestions = _this.suggestionsElement;
            var highlighter = _this.highlighterElement; // first get viewport-relative position (highlighter is offsetParent of caret):
            var caretOffsetParentRect = highlighter.getBoundingClientRect();
            var caretHeight = $8ffb46a819a74219$var$getComputedStyleLengthProp(highlighter, 'font-size');
            var viewportRelative = {
                left: caretOffsetParentRect.left + caretPosition.left,
                top: caretOffsetParentRect.top + caretPosition.top + caretHeight
            };
            var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            if (!suggestions) return;
            var position = {}; // if suggestions menu is in a portal, update position to be releative to its portal node
            if (suggestionsPortalHost) {
                position.position = 'fixed';
                var left = viewportRelative.left;
                var top = viewportRelative.top; // absolute/fixed positioned elements are positioned according to their entire box including margins; so we remove margins here:
                left -= $8ffb46a819a74219$var$getComputedStyleLengthProp(suggestions, 'margin-left');
                top -= $8ffb46a819a74219$var$getComputedStyleLengthProp(suggestions, 'margin-top'); // take into account highlighter/textinput scrolling:
                left -= highlighter.scrollLeft;
                top -= highlighter.scrollTop; // guard for mentions suggestions list clipped by right edge of window
                var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                if (left + suggestions.offsetWidth > viewportWidth) position.left = Math.max(0, viewportWidth - suggestions.offsetWidth);
                else position.left = left;
                 // guard for mentions suggestions list clipped by bottom edge of window if allowSuggestionsAboveCursor set to true.
                // Move the list up above the caret if it's getting cut off by the bottom of the window, provided that the list height
                // is small enough to NOT cover up the caret
                if (allowSuggestionsAboveCursor && top + suggestions.offsetHeight > viewportHeight && suggestions.offsetHeight < top - caretHeight || forceSuggestionsAboveCursor) position.top = Math.max(0, top - suggestions.offsetHeight - caretHeight);
                else position.top = top;
            } else {
                var _left = caretPosition.left - highlighter.scrollLeft;
                var _top = caretPosition.top - highlighter.scrollTop; // guard for mentions suggestions list clipped by right edge of window
                if (_left + suggestions.offsetWidth > _this.containerElement.offsetWidth) position.right = 0;
                else position.left = _left;
                 // guard for mentions suggestions list clipped by bottom edge of window if allowSuggestionsAboveCursor set to true.
                // move the list up above the caret if it's getting cut off by the bottom of the window, provided that the list height
                // is small enough to NOT cover up the caret
                if (allowSuggestionsAboveCursor && viewportRelative.top - highlighter.scrollTop + suggestions.offsetHeight > viewportHeight && suggestions.offsetHeight < caretOffsetParentRect.top - caretHeight - highlighter.scrollTop || forceSuggestionsAboveCursor) position.top = _top - suggestions.offsetHeight - caretHeight;
                else position.top = _top;
            }
            if (position.left === _this.state.suggestionsPosition.left && position.top === _this.state.suggestionsPosition.top && position.position === _this.state.suggestionsPosition.position) return;
            _this.setState({
                suggestionsPosition: position
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "updateHighlighterScroll", function() {
            var input = _this.inputElement;
            var highlighter = _this.highlighterElement;
            if (!input || !highlighter) // since the invocation of this function is deferred,
            // the whole component may have been unmounted in the meanwhile
            return;
            highlighter.scrollLeft = input.scrollLeft;
            highlighter.scrollTop = input.scrollTop;
            highlighter.height = input.height;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleCompositionStart", function() {
            $8ffb46a819a74219$var$isComposing = true;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "handleCompositionEnd", function() {
            $8ffb46a819a74219$var$isComposing = false;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "setSelection", function(selectionStart, selectionEnd) {
            if (selectionStart === null || selectionEnd === null) return;
            var el = _this.inputElement;
            if (el.setSelectionRange) el.setSelectionRange(selectionStart, selectionEnd);
            else if (el.createTextRange) {
                var range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', selectionEnd);
                range.moveStart('character', selectionStart);
                range.select();
            }
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "updateMentionsQueries", function(plainTextValue, caretPosition) {
            // Invalidate previous queries. Async results for previous queries will be neglected.
            _this._queryId++;
            _this.suggestions = {};
            _this.setState({
                suggestions: {}
            });
            var value = _this.props.value || '';
            var children = _this.props.children;
            var config = $8ffb46a819a74219$var$readConfigFromChildren(children);
            var positionInValue = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, caretPosition, 'NULL'); // If caret is inside of mention, do not query
            if (positionInValue === null) return;
             // Extract substring in between the end of the previous mention and the caret
            var substringStartIndex = $8ffb46a819a74219$var$getEndOfLastMention(value.substring(0, positionInValue), config);
            var substring = plainTextValue.substring(substringStartIndex, caretPosition); // Check if suggestions have to be shown:
            // Match the trigger patterns of all Mention children on the extracted substring
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child, childIndex) {
                if (!child) return;
                var regex = $8ffb46a819a74219$var$makeTriggerRegex(child.props.trigger, _this.props);
                var match = substring.match(regex);
                if (match) {
                    var querySequenceStart = substringStartIndex + substring.indexOf(match[1], match.index);
                    _this.queryData(match[2], childIndex, querySequenceStart, querySequenceStart + match[1].length, plainTextValue);
                }
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "clearSuggestions", function() {
            // Invalidate previous queries. Async results for previous queries will be neglected.
            _this._queryId++;
            _this.suggestions = {};
            _this.setState({
                suggestions: {},
                focusIndex: 0
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "queryData", function(query, childIndex, querySequenceStart, querySequenceEnd, plainTextValue) {
            var _this$props6 = _this.props, children = _this$props6.children, ignoreAccents = _this$props6.ignoreAccents;
            var mentionChild = (0, $acw62.Children).toArray(children)[childIndex];
            var provideData = $8ffb46a819a74219$var$getDataProvider(mentionChild.props.data, ignoreAccents);
            var syncResult = provideData(query, _this.updateSuggestions.bind(null, _this._queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue));
            if (syncResult instanceof Array) _this.updateSuggestions(_this._queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue, syncResult);
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "updateSuggestions", function(queryId, childIndex, query, querySequenceStart, querySequenceEnd, plainTextValue, results) {
            // neglect async results from previous queries
            if (queryId !== _this._queryId) return; // save in property so that multiple sync state updates from different mentions sources
            // won't overwrite each other
            _this.suggestions = $8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1({}, _this.suggestions), {}, (0, $jRhPI.default)({}, childIndex, {
                queryInfo: {
                    childIndex: childIndex,
                    query: query,
                    querySequenceStart: querySequenceStart,
                    querySequenceEnd: querySequenceEnd,
                    plainTextValue: plainTextValue
                },
                results: results
            }));
            var focusIndex = _this.state.focusIndex;
            var suggestionsCount = $8ffb46a819a74219$var$countSuggestions(_this.suggestions);
            _this.setState({
                suggestions: _this.suggestions,
                focusIndex: focusIndex >= suggestionsCount ? Math.max(suggestionsCount - 1, 0) : focusIndex
            });
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "addMention", function(_ref2, _ref3) {
            var id = _ref2.id, display = _ref2.display;
            var childIndex = _ref3.childIndex, querySequenceStart = _ref3.querySequenceStart, querySequenceEnd = _ref3.querySequenceEnd, plainTextValue = _ref3.plainTextValue;
            // Insert mention in the marked up value at the correct position
            var value = _this.props.value || '';
            var config = $8ffb46a819a74219$var$readConfigFromChildren(_this.props.children);
            var mentionsChild = (0, $acw62.Children).toArray(_this.props.children)[childIndex];
            var _mentionsChild$props = mentionsChild.props, markup = _mentionsChild$props.markup, displayTransform = _mentionsChild$props.displayTransform, appendSpaceOnAdd = _mentionsChild$props.appendSpaceOnAdd, onAdd = _mentionsChild$props.onAdd;
            var start = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, querySequenceStart, 'START');
            var end = start + querySequenceEnd - querySequenceStart;
            var insert = $8ffb46a819a74219$var$makeMentionsMarkup(markup, id, display);
            if (appendSpaceOnAdd) insert += ' ';
            var newValue = $8ffb46a819a74219$var$spliceString(value, start, end, insert); // Refocus input and set caret position to end of mention
            _this.inputElement.focus();
            var displayValue = displayTransform(id, display);
            if (appendSpaceOnAdd) displayValue += ' ';
            var newCaretPosition = querySequenceStart + displayValue.length;
            _this.setState({
                selectionStart: newCaretPosition,
                selectionEnd: newCaretPosition,
                setSelectionAfterMentionChange: true
            }); // Propagate change
            var eventMock = {
                target: {
                    value: newValue
                }
            };
            var mentions = $8ffb46a819a74219$var$getMentions(newValue, config);
            var newPlainTextValue = $8ffb46a819a74219$var$spliceString(plainTextValue, querySequenceStart, querySequenceEnd, displayValue);
            _this.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);
            if (onAdd) onAdd(id, display, start, end);
             // Make sure the suggestions overlay is closed
            _this.clearSuggestions();
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "isLoading", function() {
            var isLoading = false;
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                isLoading = isLoading || child && child.props.isLoading;
            });
            return isLoading;
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "isOpened", function() {
            return $8ffb46a819a74219$var$isNumber(_this.state.selectionStart) && ($8ffb46a819a74219$var$countSuggestions(_this.state.suggestions) !== 0 || _this.isLoading());
        });
        (0, $jRhPI.default)((0, $baNBs.default)(_this), "_queryId", 0);
        _this.suggestions = {};
        _this.uuidSuggestionsOverlay = Math.random().toString(16).substring(2);
        _this.handleCopy = _this.handleCopy.bind((0, $baNBs.default)(_this));
        _this.handleCut = _this.handleCut.bind((0, $baNBs.default)(_this));
        _this.handlePaste = _this.handlePaste.bind((0, $baNBs.default)(_this));
        _this.state = {
            focusIndex: 0,
            selectionStart: null,
            selectionEnd: null,
            suggestions: {},
            caretPosition: null,
            suggestionsPosition: {},
            setSelectionAfterHandlePaste: false
        };
        return _this;
    }
    (0, $brrhu.default)(MentionsInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('copy', this.handleCopy);
                document.addEventListener('cut', this.handleCut);
                document.addEventListener('paste', this.handlePaste);
                this.updateSuggestionsPosition();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // Update position of suggestions unless this componentDidUpdate was
                // triggered by an update to suggestionsPosition.
                if (prevState.suggestionsPosition === this.state.suggestionsPosition) this.updateSuggestionsPosition();
                 // maintain selection in case a mention is added/removed causing
                // the cursor to jump to the end
                if (this.state.setSelectionAfterMentionChange) {
                    this.setState({
                        setSelectionAfterMentionChange: false
                    });
                    this.setSelection(this.state.selectionStart, this.state.selectionEnd);
                }
                if (this.state.setSelectionAfterHandlePaste) {
                    this.setState({
                        setSelectionAfterHandlePaste: false
                    });
                    this.setSelection(this.state.selectionStart, this.state.selectionEnd);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('copy', this.handleCopy);
                document.removeEventListener('cut', this.handleCut);
                document.removeEventListener('paste', this.handlePaste);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $2AARm.default)({
                    ref: this.setContainerElement
                }, this.props.style), this.renderControl(), this.renderSuggestionsOverlay());
            }
        },
        {
            key: "handlePaste",
            value: function handlePaste(event) {
                if (event.target !== this.inputElement) return;
                if (!this.supportsClipboardActions(event)) return;
                event.preventDefault();
                var _this$state3 = this.state, selectionStart = _this$state3.selectionStart, selectionEnd = _this$state3.selectionEnd;
                var _this$props7 = this.props, value = _this$props7.value, children = _this$props7.children;
                var config = $8ffb46a819a74219$var$readConfigFromChildren(children);
                var markupStartIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionStart, 'START');
                var markupEndIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionEnd, 'END');
                var pastedMentions = event.clipboardData.getData('text/react-mentions');
                var pastedData = event.clipboardData.getData('text/plain');
                var newValue = $8ffb46a819a74219$var$spliceString(value, markupStartIndex, markupEndIndex, pastedMentions || pastedData).replace(/\r/g, '');
                var newPlainTextValue = $8ffb46a819a74219$var$getPlainText(newValue, config);
                var eventMock = {
                    target: $8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1({}, event.target), {}, {
                        value: newValue
                    })
                };
                this.executeOnChange(eventMock, newValue, newPlainTextValue, $8ffb46a819a74219$var$getMentions(newValue, config)); // Move the cursor position to the end of the pasted data
                var startOfMention = $8ffb46a819a74219$var$findStartOfMentionInPlainText(value, config, selectionStart);
                var nextPos = (startOfMention || selectionStart) + $8ffb46a819a74219$var$getPlainText(pastedMentions || pastedData, config).length;
                this.setState({
                    selectionStart: nextPos,
                    selectionEnd: nextPos,
                    setSelectionAfterHandlePaste: true
                });
            }
        },
        {
            key: "saveSelectionToClipboard",
            value: function saveSelectionToClipboard(event) {
                // use the actual selectionStart & selectionEnd instead of the one stored
                // in state to ensure copy & paste also works on disabled inputs & textareas
                var selectionStart = this.inputElement.selectionStart;
                var selectionEnd = this.inputElement.selectionEnd;
                var _this$props8 = this.props, children = _this$props8.children, value = _this$props8.value;
                var config = $8ffb46a819a74219$var$readConfigFromChildren(children);
                var markupStartIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionStart, 'START');
                var markupEndIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionEnd, 'END');
                event.clipboardData.setData('text/plain', event.target.value.slice(selectionStart, selectionEnd));
                event.clipboardData.setData('text/react-mentions', value.slice(markupStartIndex, markupEndIndex));
            }
        },
        {
            key: "supportsClipboardActions",
            value: function supportsClipboardActions(event) {
                return !!event.clipboardData;
            }
        },
        {
            key: "handleCopy",
            value: function handleCopy(event) {
                if (event.target !== this.inputElement) return;
                if (!this.supportsClipboardActions(event)) return;
                event.preventDefault();
                this.saveSelectionToClipboard(event);
            }
        },
        {
            key: "handleCut",
            value: function handleCut(event) {
                if (event.target !== this.inputElement) return;
                if (!this.supportsClipboardActions(event)) return;
                event.preventDefault();
                this.saveSelectionToClipboard(event);
                var _this$state4 = this.state, selectionStart = _this$state4.selectionStart, selectionEnd = _this$state4.selectionEnd;
                var _this$props9 = this.props, children = _this$props9.children, value = _this$props9.value;
                var config = $8ffb46a819a74219$var$readConfigFromChildren(children);
                var markupStartIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionStart, 'START');
                var markupEndIndex = $8ffb46a819a74219$var$mapPlainTextIndex(value, config, selectionEnd, 'END');
                var newValue = [
                    value.slice(0, markupStartIndex),
                    value.slice(markupEndIndex)
                ].join('');
                var newPlainTextValue = $8ffb46a819a74219$var$getPlainText(newValue, config);
                var eventMock = {
                    target: $8ffb46a819a74219$var$_objectSpread$1($8ffb46a819a74219$var$_objectSpread$1({}, event.target), {}, {
                        value: newPlainTextValue
                    })
                };
                this.executeOnChange(eventMock, newValue, newPlainTextValue, $8ffb46a819a74219$var$getMentions(value, config));
            } // Handle input element's change event
        }
    ]);
    return MentionsInput;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * Returns the computed length property value for the provided element.
 * Note: According to spec and testing, can count on length values coming back in pixels. See https://developer.mozilla.org/en-US/docs/Web/CSS/used_value#Difference_from_computed_value
 */ (0, $jRhPI.default)($8ffb46a819a74219$var$MentionsInput, "propTypes", $8ffb46a819a74219$var$propTypes);
(0, $jRhPI.default)($8ffb46a819a74219$var$MentionsInput, "defaultProps", {
    ignoreAccents: false,
    singleLine: false,
    allowSuggestionsAboveCursor: false,
    onKeyDown: function onKeyDown() {
        return null;
    },
    onSelect: function onSelect() {
        return null;
    },
    onBlur: function onBlur() {
        return null;
    }
});
var $8ffb46a819a74219$var$getComputedStyleLengthProp = function getComputedStyleLengthProp(forElement, propertyName) {
    var length = parseFloat(window.getComputedStyle(forElement, null).getPropertyValue(propertyName));
    return isFinite(length) ? length : 0;
};
var $8ffb46a819a74219$var$isMobileSafari = typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);
var $8ffb46a819a74219$var$styled$3 = $8ffb46a819a74219$var$createDefaultStyle({
    position: 'relative',
    overflowY: 'visible',
    input: {
        display: 'block',
        width: '100%',
        position: 'absolute',
        margin: 0,
        top: 0,
        left: 0,
        boxSizing: 'border-box',
        backgroundColor: 'transparent',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        letterSpacing: 'inherit'
    },
    '&multiLine': {
        input: $8ffb46a819a74219$var$_objectSpread$1({
            height: '100%',
            bottom: 0,
            overflow: 'hidden',
            resize: 'none'
        }, $8ffb46a819a74219$var$isMobileSafari ? {
            marginTop: 1,
            marginLeft: -3
        } : null)
    }
}, function(_ref4) {
    var singleLine = _ref4.singleLine;
    return {
        '&singleLine': singleLine,
        '&multiLine': !singleLine
    };
});
var $8ffb46a819a74219$export$6952d9a604a4da5e = $8ffb46a819a74219$var$styled$3($8ffb46a819a74219$var$MentionsInput);
var $8ffb46a819a74219$var$defaultStyle = {
    fontWeight: 'inherit'
};
var $8ffb46a819a74219$export$e891316fea657d90 = function Mention(_ref) {
    var display = _ref.display, style = _ref.style, className = _ref.className, classNames = _ref.classNames;
    var styles = (0, $gkmFh.default)($8ffb46a819a74219$var$defaultStyle, {
        style: style,
        className: className,
        classNames: classNames
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", styles, display);
};
$8ffb46a819a74219$export$e891316fea657d90.propTypes = {
    /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */ onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    renderSuggestion: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    trigger: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(RegExp)
    ]),
    markup: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayTransform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If set to `true` spaces will not interrupt matching suggestions
   */ allowSpaceInQuery: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$8ffb46a819a74219$export$e891316fea657d90.defaultProps = {
    trigger: '@',
    markup: '@[__display__](__id__)',
    displayTransform: function displayTransform(id, display) {
        return display || id;
    },
    onAdd: function onAdd() {
        return null;
    },
    onRemove: function onRemove() {
        return null;
    },
    renderSuggestion: null,
    isLoading: false,
    appendSpaceOnAdd: false
};

});
parcelRegister("jwUkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37cb429e82a8fb2$export$2e2bcd8739ae039);

var $6nRjw = parcelRequire("6nRjw");

var $6v0UX = parcelRequire("6v0UX");

var $4neTb = parcelRequire("4neTb");
function $e37cb429e82a8fb2$export$2e2bcd8739ae039(arr) {
    return (0, $6nRjw.default)(arr) || (0, $6v0UX.default)(arr) || (0, $4neTb.default)();
}

});
parcelRegister("6nRjw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5e3f1667d5c33a$export$2e2bcd8739ae039);
function $4a5e3f1667d5c33a$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}

});

parcelRegister("6v0UX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb6598a6a4119a3$export$2e2bcd8739ae039);
function $4bb6598a6a4119a3$export$2e2bcd8739ae039(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

});

parcelRegister("4neTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f4dc14e935feae$export$2e2bcd8739ae039);
function $32f4dc14e935feae$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}

});


parcelRegister("2AARm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e2b891e2666be7a$export$2e2bcd8739ae039);
function $1e2b891e2666be7a$export$2e2bcd8739ae039() {
    $1e2b891e2666be7a$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e2b891e2666be7a$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("igh35", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b6f2230f7c9031$export$2e2bcd8739ae039);
function $d4b6f2230f7c9031$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("brrhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $854760c88743fb3c$export$2e2bcd8739ae039);
function $854760c88743fb3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $854760c88743fb3c$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $854760c88743fb3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $854760c88743fb3c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("baNBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $82271b0773b79172$export$2e2bcd8739ae039);
function $82271b0773b79172$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("1Apoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $127cd909b06e5a86$export$2e2bcd8739ae039);

var $fyIFT = parcelRequire("fyIFT");
function $127cd909b06e5a86$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fyIFT.default)(subClass, superClass);
}

});
parcelRegister("fyIFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53caf76ffc5bf14$export$2e2bcd8739ae039);
function $b53caf76ffc5bf14$export$2e2bcd8739ae039(o, p) {
    $b53caf76ffc5bf14$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b53caf76ffc5bf14$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("cYBMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $972865fb361b2da6$export$2e2bcd8739ae039);

var $2p6si = parcelRequire("2p6si");

var $baNBs = parcelRequire("baNBs");
function $972865fb361b2da6$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $2p6si.default)(call) === "object" || typeof call === "function")) return call;
    return (0, $baNBs.default)(self);
}

});
parcelRegister("2p6si", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c02ec75bc8e0595$export$2e2bcd8739ae039);
function $1c02ec75bc8e0595$var$_typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1c02ec75bc8e0595$var$_typeof2 = function _typeof2(obj) {
        return typeof obj;
    };
    else $1c02ec75bc8e0595$var$_typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1c02ec75bc8e0595$var$_typeof2(obj);
}
function $1c02ec75bc8e0595$export$2e2bcd8739ae039(obj) {
    if (typeof Symbol === "function" && $1c02ec75bc8e0595$var$_typeof2(Symbol.iterator) === "symbol") $1c02ec75bc8e0595$export$2e2bcd8739ae039 = function _typeof(obj) {
        return $1c02ec75bc8e0595$var$_typeof2(obj);
    };
    else $1c02ec75bc8e0595$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : $1c02ec75bc8e0595$var$_typeof2(obj);
    };
    return $1c02ec75bc8e0595$export$2e2bcd8739ae039(obj);
}

});


parcelRegister("5HlHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4261ce2953553e50$export$2e2bcd8739ae039);
function $4261ce2953553e50$export$2e2bcd8739ae039(o) {
    $4261ce2953553e50$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4261ce2953553e50$export$2e2bcd8739ae039(o);
}

});

parcelRegister("jRhPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e750ccd5d7b4a83f$export$2e2bcd8739ae039);
function $e750ccd5d7b4a83f$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("aaXwj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $768901fea8dbe440$var$invariant;

});

parcelRegister("8yC0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $63aefc6d883e0365$export$2e2bcd8739ae039);

var $9vaMs = parcelRequire("9vaMs");

var $eiwMx = parcelRequire("eiwMx");

var $k45G7 = parcelRequire("k45G7");
function $63aefc6d883e0365$export$2e2bcd8739ae039(arr, i) {
    return (0, $9vaMs.default)(arr) || (0, $eiwMx.default)(arr, i) || (0, $k45G7.default)();
}

});
parcelRegister("9vaMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaf5f1bd111d122$export$2e2bcd8739ae039);
function $6eaf5f1bd111d122$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("eiwMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68c2cf070abd9e4$export$2e2bcd8739ae039);
function $a68c2cf070abd9e4$export$2e2bcd8739ae039(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("k45G7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b895f8168cdb11$export$2e2bcd8739ae039);
function $e9b895f8168cdb11$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

});


parcelRegister("2PtM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f770fb7ddbb59d$export$2e2bcd8739ae039);

var $eOM2b = parcelRequire("eOM2b");
function $20f770fb7ddbb59d$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $eOM2b.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("eOM2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9afec94ab72a5f$export$2e2bcd8739ae039);
function $ac9afec94ab72a5f$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("gkmFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $be301856be96b63d$export$2e2bcd8739ae039);




var $9UQB7 = parcelRequire("9UQB7");

var $8pmuk = parcelRequire("8pmuk");
var $be301856be96b63d$export$2e2bcd8739ae039 = (0, $8pmuk.default);

});
parcelRegister("9UQB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $738224d6bf0f6039$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");
function $738224d6bf0f6039$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $738224d6bf0f6039$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $738224d6bf0f6039$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $738224d6bf0f6039$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $738224d6bf0f6039$var$inline = function inline() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args.reduce(function(result, arg) {
        return $738224d6bf0f6039$var$_objectSpread($738224d6bf0f6039$var$_objectSpread($738224d6bf0f6039$var$_objectSpread({}, result), typeof arg === 'function' ? arg : {}), {}, {
            style: $738224d6bf0f6039$var$_objectSpread($738224d6bf0f6039$var$_objectSpread({}, result.style), typeof arg === 'function' ? arg.style : arg)
        });
    }, {});
};
var $738224d6bf0f6039$export$2e2bcd8739ae039 = $738224d6bf0f6039$var$inline;

});

parcelRegister("8pmuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f21a30a19a9b84$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9qaSP = parcelRequire("9qaSP");

var $dTtZO = parcelRequire("dTtZO");
var $61f21a30a19a9b84$var$useStyles = function useStyles(defaultStyle, _ref, modifiers) {
    var style = _ref.style, className = _ref.className, classNames = _ref.classNames;
    var propsDecorator = (0, $acw62.useContext)((0, $9qaSP.PropsDecoratorContext));
    var substyle = (0, $acw62.useMemo)(function() {
        return (0, $dTtZO.default)({
            style: style,
            className: className,
            classNames: classNames
        }, propsDecorator);
    }, [
        style,
        className,
        classNames,
        propsDecorator
    ]);
    return substyle(modifiers, defaultStyle);
};
var $61f21a30a19a9b84$export$2e2bcd8739ae039 = $61f21a30a19a9b84$var$useStyles;

});
parcelRegister("9qaSP", function(module, exports) {

$parcel$export(module.exports, "PropsDecoratorContext", () => $6dbefbf11febdb92$export$aa24f593b0d41726);

var $acw62 = parcelRequire("acw62");

var $l69jB = parcelRequire("l69jB");
var $6dbefbf11febdb92$export$aa24f593b0d41726 = /*#__PURE__*/ (0, $acw62.createContext)((0, $l69jB.default));
var $6dbefbf11febdb92$export$2e2bcd8739ae039 = $6dbefbf11febdb92$export$aa24f593b0d41726.Provider;

});
parcelRegister("l69jB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c16255e6c6a082$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $lck4y = parcelRequire("lck4y");
function $f5c16255e6c6a082$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f5c16255e6c6a082$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f5c16255e6c6a082$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f5c16255e6c6a082$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// many css-in-js libs process keyframes objects as the value for `animationName`
var $f5c16255e6c6a082$var$defaultObjectPropsWhitelist = [
    'animationName'
];
var $f5c16255e6c6a082$var$defaultPropsDecorator = function defaultPropsDecorator(_ref) {
    var style = _ref.style, className = _ref.className;
    return $f5c16255e6c6a082$var$_objectSpread($f5c16255e6c6a082$var$_objectSpread({}, style ? {
        style: (0, $lck4y.pickDirectStyles)(style, $f5c16255e6c6a082$var$defaultObjectPropsWhitelist)
    } : {}), className ? {
        className: className
    } : {});
};
var $f5c16255e6c6a082$export$2e2bcd8739ae039 = $f5c16255e6c6a082$var$defaultPropsDecorator;

});
parcelRegister("lck4y", function(module, exports) {

$parcel$export(module.exports, "pickDirectStyles", () => $f6ea49eb802b18c9$export$3ff7aaef965177a8);
$parcel$export(module.exports, "pickNestedStyles", () => $f6ea49eb802b18c9$export$9f9f1e0369d0936);
$parcel$export(module.exports, "hoistModifierStylesRecursive", () => $f6ea49eb802b18c9$export$44e501cb3f1770cf);

var $fUHKi = parcelRequire("fUHKi");

var $eZwjj = parcelRequire("eZwjj");

var $egQkv = parcelRequire("egQkv");
var $f6ea49eb802b18c9$var$camelize = function camelize(key) {
    return key.replace(/-(\w)/g, function(m, c) {
        return c.toUpperCase();
    });
};
var $f6ea49eb802b18c9$export$3ff7aaef965177a8 = function pickDirectStyles(style) {
    var objectPropertiesWhitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styleKeys = (0, $eZwjj.keys)(style);
    var result = {};
    for(var i = 0, l = styleKeys.length; i < l; i += 1){
        var key = styleKeys[i];
        var isDirect = Object.prototype.toString.call(style[key]) !== '[object Object]' || // style defs
        key[0] === ':' || // pseudo selectors
        key[0] === '@' || // @media / @keyframes / @supports / @font-face
        objectPropertiesWhitelist.indexOf(key) >= 0; // whitelisted object-type properties
        if (isDirect) result[key] = style[key];
    }
    return result;
};
var $f6ea49eb802b18c9$export$9f9f1e0369d0936 = function pickNestedStyles(style, keysToPick) {
    var camelizedKeysToPick = keysToPick.map($f6ea49eb802b18c9$var$camelize);
    var styleKeys = (0, $eZwjj.keys)(style);
    var result = {};
    for(var i = 0, l = styleKeys.length; i < l; i += 1){
        var key = styleKeys[i];
        if (keysToPick.indexOf(key) >= 0 || camelizedKeysToPick.indexOf($f6ea49eb802b18c9$var$camelize(key)) >= 0) result[key] = style[key];
    }
    return result;
}; // breadth-first hoisting of selected modifier style subtrees
var $f6ea49eb802b18c9$export$44e501cb3f1770cf = function hoistModifierStylesRecursive(style, modifierKeysToPick) {
    // hoist styles for selected modifiers on current level
    var result = (0, $eZwjj.merge).apply(void 0, [
        {},
        (0, $eZwjj.omit)(style, modifierKeysToPick)
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $eZwjj.values)($f6ea49eb802b18c9$export$9f9f1e0369d0936(style, modifierKeysToPick))))); // traverse nested styled for ALL modifiers
    var modifierKeys = (0, $eZwjj.keys)(result).filter((0, $egQkv.isModifier));
    for(var i = 0, l = modifierKeys.length; i < l; i += 1){
        var key = modifierKeys[i];
        var subresult = hoistModifierStylesRecursive(result[key], modifierKeysToPick);
        if (modifierKeysToPick.indexOf(key) >= 0) {
            // selected modifier: hoist subresult
            delete result[key];
            result = (0, $eZwjj.merge)({}, result, subresult);
        } else // non-selected modifier: replace with subresult
        result[key] = subresult;
    }
    return result;
};

});
parcelRegister("eZwjj", function(module, exports) {

$parcel$export(module.exports, "keys", () => $ae9fd367aa320325$export$ed97f33186d4b816);
$parcel$export(module.exports, "values", () => $ae9fd367aa320325$export$68c286be0e7e55b7);
$parcel$export(module.exports, "isPlainObject", () => $ae9fd367aa320325$export$53b83ca8eaab0383);
$parcel$export(module.exports, "merge", () => $ae9fd367aa320325$export$4950aa0f605343fb);
$parcel$export(module.exports, "omit", () => $ae9fd367aa320325$export$30a06c8d3562193f);
$parcel$export(module.exports, "compact", () => $ae9fd367aa320325$export$8e16b83750b44988);

var $g5Zhu = parcelRequire("g5Zhu");
var $ae9fd367aa320325$export$ed97f33186d4b816 = function keys(obj) {
    return obj === Object(obj) ? Object.keys(obj) : [];
};
var $ae9fd367aa320325$export$68c286be0e7e55b7 = function values(obj) {
    return obj === Object(obj) ? Object.values(obj) : [];
};
function $ae9fd367aa320325$var$mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if ($ae9fd367aa320325$export$53b83ca8eaab0383(target) && $ae9fd367aa320325$export$53b83ca8eaab0383(source)) $ae9fd367aa320325$export$ed97f33186d4b816(source).forEach(function(key) {
        if ($ae9fd367aa320325$export$53b83ca8eaab0383(source[key])) {
            if (!(key in target)) Object.assign(output, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, key, source[key]));
            else output[key] = $ae9fd367aa320325$var$mergeDeep(target[key], source[key]);
        } else Object.assign(output, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, key, source[key]));
    });
    return output;
}
var $ae9fd367aa320325$export$4950aa0f605343fb = function merge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    return sources.reduce(function(t, s) {
        return $ae9fd367aa320325$var$mergeDeep(t, s);
    }, target);
};
var $ae9fd367aa320325$export$f0954fd7d5368655 = function identity(value) {
    return value;
};
var $ae9fd367aa320325$export$30a06c8d3562193f = function omit(obj, keys) {
    var other = Object.assign({}, obj);
    if (keys) for(var i = 0; i < keys.length; i++)delete other[keys[i]];
    return other;
};
var $ae9fd367aa320325$export$53b83ca8eaab0383 = function isPlainObject(obj) {
    return obj === Object(obj) && !(obj instanceof Date) && !Array.isArray(obj);
};
var $ae9fd367aa320325$export$8e16b83750b44988 = function compact(arr) {
    return (arr || []).filter(Boolean);
};

});

parcelRegister("egQkv", function(module, exports) {

$parcel$export(module.exports, "isModifier", () => $a63b26e2d5101dc0$export$b77dd3d9c23dc2ef);
$parcel$export(module.exports, "isElement", () => $a63b26e2d5101dc0$export$45a5e7f76e0caa8d);
var $a63b26e2d5101dc0$export$b77dd3d9c23dc2ef = function isModifier(key) {
    return key[0] === '&';
};
var $a63b26e2d5101dc0$export$45a5e7f76e0caa8d = function isElement(key) {
    return !$a63b26e2d5101dc0$export$b77dd3d9c23dc2ef(key);
};

});




parcelRegister("dTtZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d7adff33aba94a$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $fUHKi = parcelRequire("fUHKi");

var $aaXwj = parcelRequire("aaXwj");

var $4FYFc = parcelRequire("4FYFc");

var $l69jB = parcelRequire("l69jB");

var $egQkv = parcelRequire("egQkv");

var $cllbE = parcelRequire("cllbE");

var $lck4y = parcelRequire("lck4y");

var $eZwjj = parcelRequire("eZwjj");
function $a1d7adff33aba94a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a1d7adff33aba94a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a1d7adff33aba94a$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a1d7adff33aba94a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a1d7adff33aba94a$var$guessBaseClassName = function guessBaseClassName(classNames) {
    // all class names must start with the same prefix: the component's base class name
    // which will finally go to the container element
    var firstKey = classNames && (0, $eZwjj.keys)(classNames)[0];
    return firstKey && firstKey.split('__')[0].split('--')[0];
};
var $a1d7adff33aba94a$var$deriveClassNames = function deriveClassNames(className, elementKeys, modifierKeys) {
    // do not derive class names, if the user did not specify any class name
    if (!className) return undefined;
     // derive class names based using the passed modifier/element keys
    var firstClassName = className.split(' ')[0];
    var derivedClassNames = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(elementKeys.length === 0 ? modifierKeys.map(function(key) {
        return "".concat(firstClassName, "--").concat(key.substring(1));
    }) : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(elementKeys.map(function(key) {
        return "".concat(firstClassName, "__").concat(key);
    }))); // also use the provided `className` if there is no sub-element selection
    return elementKeys.length === 0 ? [
        className
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(derivedClassNames)) : derivedClassNames;
};
function $a1d7adff33aba94a$var$createSubstyle(_ref) {
    var style = _ref.style, className = _ref.className, classNames = _ref.classNames;
    var propsDecorator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $l69jB.default);
    var baseClassName = className || $a1d7adff33aba94a$var$guessBaseClassName(classNames) || (style === null || style === void 0 ? void 0 : style.className);
    var substyle = typeof style === 'function' ? style : (0, $cllbE.default)(function(select, defaultStyle) {
        var selectedKeys = (0, $4FYFc.default)(select);
        (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(Array.isArray(selectedKeys), "First parameter must be a string, an array of strings, a plain object with boolean values, or a falsy value.");
        (0, (/*@__PURE__*/$parcel$interopDefault($aaXwj)))(!defaultStyle || (0, $eZwjj.isPlainObject)(defaultStyle), 'Optional second parameter must be a plain object.');
        var modifierKeys = selectedKeys.filter((0, $egQkv.isModifier));
        var elementKeys = selectedKeys.filter((0, $egQkv.isElement));
        var collectElementStyles = elementKeys.length > 0 ? function(fromStyle) {
            return (0, $eZwjj.values)((0, $lck4y.pickNestedStyles)(fromStyle, elementKeys));
        } : function(fromStyle) {
            return [
                fromStyle
            ];
        };
        var collectSelectedStyles = function collectSelectedStyles() {
            var fromStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return collectElementStyles((0, $lck4y.hoistModifierStylesRecursive)(fromStyle, modifierKeys));
        };
        var derivedClassNames = $a1d7adff33aba94a$var$deriveClassNames(baseClassName, elementKeys, modifierKeys);
        return $a1d7adff33aba94a$var$createSubstyle($a1d7adff33aba94a$var$_objectSpread($a1d7adff33aba94a$var$_objectSpread($a1d7adff33aba94a$var$_objectSpread({}, (style || defaultStyle) && {
            style: (0, $eZwjj.merge).apply(void 0, [
                {}
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(collectSelectedStyles(defaultStyle)), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(collectSelectedStyles(style))))
        }), derivedClassNames && {
            className: derivedClassNames.join(' ')
        }), classNames && {
            classNames: classNames
        }), propsDecorator);
    });
    var styleProps = $a1d7adff33aba94a$var$_objectSpread({}, typeof style === 'function' ? style : {
        style: style
    });
    var classNameSplit = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(styleProps.className ? styleProps.className.split(' ') : []), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(baseClassName ? baseClassName.split(' ') : []))));
    var mappedClassNames = classNames ? (0, $eZwjj.compact)(classNameSplit.map(function(singleClassName) {
        return classNames[singleClassName];
    })) : classNameSplit;
    var propsForSpread = propsDecorator($a1d7adff33aba94a$var$_objectSpread($a1d7adff33aba94a$var$_objectSpread({}, styleProps), mappedClassNames.length > 0 ? {
        className: mappedClassNames.join(' ')
    } : {})); // assign `style`, `className`, and/or any props added by the decorator to the return function object
    Object.assign(substyle, propsForSpread);
    return substyle;
}
var $a1d7adff33aba94a$export$2e2bcd8739ae039 = $a1d7adff33aba94a$var$createSubstyle;

});
parcelRegister("4FYFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $367a0c46a9cd7fca$export$2e2bcd8739ae039);

var $eZwjj = parcelRequire("eZwjj");
var $367a0c46a9cd7fca$var$coerceSelection = function coerceSelection(select) {
    if (!select) return [];
    else if (typeof select === 'string') return [
        select
    ];
    else if (!Array.isArray(select)) {
        var objSelect = select; // workaround for https://github.com/facebook/flow/issues/5781
        return (0, $eZwjj.keys)(select).reduce(function(acc, key) {
            return acc.concat(objSelect[key] ? [
                key
            ] : []);
        }, []);
    }
    return select;
};
var $367a0c46a9cd7fca$export$2e2bcd8739ae039 = $367a0c46a9cd7fca$var$coerceSelection;

});

parcelRegister("cllbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc7e17a5a212967$export$2e2bcd8739ae039);

var $4FYFc = parcelRequire("4FYFc");
var $8fc7e17a5a212967$var$EMPTY = {};
var $8fc7e17a5a212967$var$memoize = function memoize(substyle) {
    return function(select, defaultStyle) {
        var cacheKey = defaultStyle || $8fc7e17a5a212967$var$EMPTY;
        substyle.memoize = substyle.memoize || new WeakMap();
        var mapEntry;
        if (!substyle.memoize.has(cacheKey)) {
            mapEntry = {};
            substyle.memoize.set(cacheKey, mapEntry);
        } else mapEntry = substyle.memoize.get(cacheKey);
        var selectHash = (0, $4FYFc.default)(select).join(' ');
        return selectHash in mapEntry ? mapEntry[selectHash] : mapEntry[selectHash] = substyle(select || [], defaultStyle);
    };
};
var $8fc7e17a5a212967$export$2e2bcd8739ae039 = $8fc7e17a5a212967$var$memoize;

});





parcelRegister("90eUZ", function(module, exports) {

$parcel$export(module.exports, "formatUserMentionString", () => $c3f3874774ce9ab2$export$57bddee8f9ab7f02);
const $c3f3874774ce9ab2$export$57bddee8f9ab7f02 = (user)=>{
    return `@${user.firstName} ${user.lastName}`.trim();
};
const $c3f3874774ce9ab2$export$caa049caa00f92a1 = (text)=>{
    // Remove format around database @mentions
    // eg. repalce @[@George Clobney](d885ad40-b2b4-4b85-846b-1fe06225c1f6)
    // with @George Clobney
    const mentionRegEx = /@\[(.*?)]\(([A-Za-z0-9-]+)\)/gm;
    return text.replace(mentionRegEx, (_a, b)=>{
        return b;
    });
};
const $c3f3874774ce9ab2$export$73bda83cddbc7187 = (text)=>{
    return text.replace(/ +/g, "-").replace(":", "-").toLowerCase();
};

});

parcelRegister("aSzjr", function(module, exports) {

$parcel$export(module.exports, "allUser", () => $1474cb40d7a4f8f7$export$857b8f645770525c);
$parcel$export(module.exports, "default", () => $1474cb40d7a4f8f7$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");

var $8g1PZ = parcelRequire("8g1PZ");

var $cmpry = parcelRequire("cmpry");

var $90eUZ = parcelRequire("90eUZ");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $4KSAX = parcelRequire("4KSAX");
const $1474cb40d7a4f8f7$export$857b8f645770525c = {
    id: "all",
    firstName: "all",
    lastName: ""
};
const $1474cb40d7a4f8f7$var$MentionField = ({ height: height = 250, ...props })=>{
    const [mentionOptions, setMentionOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    // assigned to styles object to prevent stylint warning
    const styles = {
        input: {
            overflow: "auto",
            height: height
        },
        highlighter: {
            boxSizing: "border-box",
            overflow: "hidden",
            height: height
        }
    };
    const scrollStyle = styles;
    (0, $acw62.useEffect)(()=>{
        if (!props.users) return;
        const filteredUsers = Object.values(props.users).filter((u)=>u.activeInCurrentTenant);
        filteredUsers.unshift($1474cb40d7a4f8f7$export$857b8f645770525c);
        const options = filteredUsers.map((user)=>{
            return {
                id: user.id,
                display: (0, $90eUZ.formatUserMentionString)(user)
            };
        });
        setMentionOptions(options);
    }, [
        props.users
    ]);
    const renderMentionSuggestion = (suggestion, _search, _highlightedDisplay, index, focused)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-white", "p-2", "text-ch-blue-alt-400", "border-b", "mr-2", {
                "bg-ch-blue-alt-200": focused,
                "border-ch-blue-alt-400": index !== mentionOptions.length - 1
            }),
            children: suggestion.display
        });
    };
    const prefixClass = "mentions";
    const defaultClasses = [
        prefixClass,
        "mb-1",
        "text-ch-gray-600"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    const renderMentionText = (id, _display)=>{
        if (id == $1474cb40d7a4f8f7$export$857b8f645770525c.id) return (0, $90eUZ.formatUserMentionString)($1474cb40d7a4f8f7$export$857b8f645770525c);
        if (!props.users[id]) return "";
        return (0, $90eUZ.formatUserMentionString)(props.users[id]);
    };
    const addHandler = (id, _display)=>{
        if (id == $1474cb40d7a4f8f7$export$857b8f645770525c.id) openModal();
    };
    const undoAddAll = ()=>{
        // we need double \\ in the string here because we'll convert from to regex
        const regexString = ` *@\\[@${$1474cb40d7a4f8f7$export$857b8f645770525c.firstName}\\]\\(${$1474cb40d7a4f8f7$export$857b8f645770525c.id}\\) *`;
        const newValue = props.value.replace(new RegExp(regexString, "g"), "");
        props.setValue(newValue);
        closeModal();
    };
    const changeHandler = props.onChange ? props.onChange : (_e, newValue, _plainTextValue, _mentions)=>{
        props.setValue(newValue);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cmpry.MentionsInput), {
                style: scrollStyle,
                className: allClasses,
                autoFocus: props.autoFocus,
                name: props.name,
                id: props.name,
                onChange: changeHandler,
                onBlur: props.onBlur,
                onFocus: props.onFocus,
                value: props.value,
                autoComplete: props.autoComplete,
                maxLength: props.maxLength,
                allowSuggestionsAboveCursor: true,
                onKeyDown: props.onKeyDown,
                onKeyUp: props.onKeyUp,
                disabled: props.isDisabled,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cmpry.Mention), {
                    className: "bg-ch-blue-alt-200",
                    trigger: "@",
                    markup: "@[__display__](__id__)",
                    displayTransform: (id, display)=>renderMentionText(id, display),
                    data: mentionOptions,
                    renderSuggestion: renderMentionSuggestion,
                    appendSpaceOnAdd: true,
                    onAdd: addHandler
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.dialogueModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("mentionAllWarningHeader")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "list-disc ml-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: t("mentionAllWarningCase")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: t("mentionAllWarningMeeting")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            className: "mt-6",
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    action: undoAddAll,
                                    children: t("undo")
                                }, 1),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    action: closeModal,
                                    children: t("continue")
                                }, 2)
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $1474cb40d7a4f8f7$export$2e2bcd8739ae039 = $1474cb40d7a4f8f7$var$MentionField;

});



parcelRegister("pxpMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf59f63dcd0ba98$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $9c2AV = parcelRequire("9c2AV");
var $lx7Y0 = parcelRequire("lx7Y0");

var $biuvr = parcelRequire("biuvr");

var $6lvMC = parcelRequire("6lvMC");

var $c9ItC = parcelRequire("c9ItC");

var $7hl6H = parcelRequire("7hl6H");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $j0qQC = parcelRequire("j0qQC");

var $7HZDe = parcelRequire("7HZDe");

var $jF0Xa = parcelRequire("jF0Xa");

var $f1q41 = parcelRequire("f1q41");

var $aDoxy = parcelRequire("aDoxy");

var $a4BnF = parcelRequire("a4BnF");
const $dbf59f63dcd0ba98$var$Recommendation = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset",
        "shared"
    ]);
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const dispatch = (0, $2OPjR.useDispatch)();
    const saveRecommendation = (recommendationId)=>dispatch((0, $7HZDe.saveCaseRecommendationAction)(recommendationId, props.caseId));
    if (!currentUser) return null;
    const recommendation = asset.asset;
    const isPending = recommendation.recommendationStatus == (0, $j0qQC.RecommendationStatus).PENDING;
    const allowedToSave = isPending && currentUser.id == recommendation.createdBy.id;
    const readyToSave = recommendation.consents.filter(({ response: response })=>response == (0, $j0qQC.ConsentResponse).PENDING).length == 0;
    const saveButton = allowedToSave ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        variant: (0, $jF0Xa.StyleVariants).PURPLE,
        isDisabled: !readyToSave,
        action: ()=>{
            saveRecommendation(recommendation.id);
        },
        children: t("shared:saveRecommendation")
    }) : null;
    const consentList = ()=>{
        if (props.hideConsentList) return null;
        const orderedConsents = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).orderBy(recommendation.consents, [
            (c)=>c.user.lastName,
            (c)=>c.user.firstName
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: orderedConsents.map((consent)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9ItC.default), {
                    caseId: props.caseId,
                    mentionableUsers: props.mentionableUsers,
                    consent: consent,
                    recommendation: recommendation
                }, consent.user.id))
        });
    };
    const deadline = ()=>{
        if (recommendation.deadline == null || !isPending) return null;
        const date = recommendation.deadline;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                    className: "text-ch-blue-600 mx-2 w-5 h-5"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        t("approvalDeadline"),
                        ": ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                            utcTime: date
                        })
                    ]
                }),
                saveButton
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            onClick: props.action ? ()=>props.action() : null,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2", "rounded-md", "border-2", {
                "bg-ch-blue-200": !isPending,
                "border-ch-blue-200": !props.isSelected,
                "border-ch-blue-500": props.isSelected,
                "hover:border-ch-blue-500": props.action,
                "cursor-pointer": props.action,
                "cursor-default": !props.action
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-ch-purple-500 mr-2 mt-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lx7Y0.default), {
                            className: "w-5 h-5",
                            title: recommendation.title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "font-semibold text-lg flex-1",
                                        children: recommendation.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4BnF.default), {
                                        isVisible: isPending,
                                        children: t("asset:pending")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                                meetingCaseAsset: props.meetingCaseAsset,
                                meetingId: props.meetingId,
                                asset: asset
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                                value: recommendation.body,
                                users: users
                            }),
                            consentList(),
                            deadline()
                        ]
                    }),
                    props.children
                ]
            })
        })
    });
};
var $dbf59f63dcd0ba98$export$2e2bcd8739ae039 = $dbf59f63dcd0ba98$var$Recommendation;

});
parcelRegister("c9ItC", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ce0bf98b261bc3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6t04b = parcelRequire("6t04b");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
var $6Hpf8 = parcelRequire("6Hpf8");
var $8tyXr = parcelRequire("8tyXr");
var $4e1aD = parcelRequire("4e1aD");

var $j0qQC = parcelRequire("j0qQC");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $biuvr = parcelRequire("biuvr");

var $6lvMC = parcelRequire("6lvMC");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $hSW3P = parcelRequire("hSW3P");

var $7YFi7 = parcelRequire("7YFi7");

var $aREbg = parcelRequire("aREbg");

var $7UN5R = parcelRequire("7UN5R");

var $aSzjr = parcelRequire("aSzjr");

var $eTqMc = parcelRequire("eTqMc");

var $04A9g = parcelRequire("04A9g");

var $7HZDe = parcelRequire("7HZDe");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $kYqkq = parcelRequire("kYqkq");
const $66ce0bf98b261bc3$var$RecommendationConsentItem = (props)=>{
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const users = (0, $kYqkq.useAppSelector)((0, $6lvMC.getAllUsers));
    const dispatch = (0, $2OPjR.useDispatch)();
    const addResponse = (recommendationId, userId)=>{
        return (response)=>()=>dispatch((0, $7HZDe.addConsentAction)(recommendationId, userId, response, null));
    };
    const addComment = (recommendationId, userId)=>(comment)=>dispatch((0, $7HZDe.addConsentAction)(recommendationId, userId, null, comment));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset",
        "consentComment"
    ]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const closeModal = ()=>setIsOpen(false);
    const openModal = ()=>setIsOpen(true);
    const consentByUser = props.consent.consentBy;
    const user = props.consent.user;
    // const recommendation = props.asset.asset as IRecommendationAsset
    const recommendationPending = props.recommendation.recommendationStatus == (0, $j0qQC.RecommendationStatus).PENDING;
    const consentPending = props.consent.response == (0, $j0qQC.ConsentResponse).PENDING;
    if (!recommendationPending && props.consent.response == (0, $j0qQC.ConsentResponse).NA) return null;
    const handleResponseForUser = (userId)=>addResponse(props.recommendation.id, userId);
    const handleResponse = addResponse(props.recommendation.id, currentUser.id);
    const handleComment = addComment(props.recommendation.id, currentUser.id);
    const consentOnBehalf = props.consent.consentBy && props.consent.user.id != props.consent.consentBy.id;
    const canConsentOnBehalf = props.consent.permissions.canUpdate;
    const isCurrentUser = currentUser.id == user.id;
    const isCursorPointerEnabled = recommendationPending && isCurrentUser ? true : canConsentOnBehalf;
    // TODO: refactor this into some helper function that help us pick the right
    // colour. This is also used in the sharedView/consentListItem
    const pendingColor = !canConsentOnBehalf ? "hidden" : consentPending ? "text-ch-blue-500" : "text-ch-blue-300";
    const approved = props.consent.response == (0, $j0qQC.ConsentResponse).APPROVE;
    const rejected = props.consent.response == (0, $j0qQC.ConsentResponse).REJECT;
    const na = props.consent.response == (0, $j0qQC.ConsentResponse).NA;
    const approveColor = approved ? "text-green-500" : pendingColor;
    const rejectColor = rejected ? "text-red-500" : pendingColor;
    const naColor = na ? "text-ch-gray-600" : pendingColor;
    const yourConsentComment = props.consent.consentComment;
    const wrapperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-sm p-2 rounded-md my-2 bg-ch-gray-200 flex justify-between items-center", {
        "border-2 border-ch-blue-400": isCurrentUser
    });
    const renderCurrentUser = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                props.consent.response == (0, $j0qQC.ConsentResponse).PENDING ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 mt-1 text-ch-orange-500 font-bold",
                    children: t("consentRequired")
                }) : null,
                recommendationPending ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    className: "ml-2",
                    action: openModal,
                    children: yourConsentComment != null ? t("asset:edit") : t("asset:addComment")
                }) : null
            ]
        });
    };
    const renderUserIcon = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current", "w-6", "h-6", "ml-3", approveColor, {
                        "cursor-pointer": isCursorPointerEnabled
                    }),
                    onClick: recommendationPending && isCurrentUser ? handleResponse((0, $j0qQC.ConsentResponse).APPROVE) : actualHandler((0, $j0qQC.ConsentResponse).APPROVE)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e1aD.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current", "w-6", "h-6", "ml-3", rejectColor, {
                        "cursor-pointer": isCursorPointerEnabled
                    }),
                    onClick: recommendationPending && isCurrentUser ? handleResponse((0, $j0qQC.ConsentResponse).REJECT) : actualHandler((0, $j0qQC.ConsentResponse).REJECT)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8tyXr.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current", "w-6", "h-6", "ml-3", naColor, {
                        "cursor-pointer": isCursorPointerEnabled
                    }),
                    onClick: recommendationPending && isCurrentUser ? handleResponse((0, $j0qQC.ConsentResponse).NA) : actualHandler((0, $j0qQC.ConsentResponse).NA)
                })
            ]
        });
    };
    const actualHandler = canConsentOnBehalf ? handleResponseForUser(user.id) : (_)=>()=>{};
    const renderConsentOnBehalf = ()=>{
        if (!consentOnBehalf) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mx-1 font-small text-ch-gray-500",
            children: [
                " ",
                t("asset:consentBy"),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: consentByUser.firstName,
                    lastName: consentByUser.lastName
                })
            ]
        });
    };
    const renderComment = ()=>{
        const comment = yourConsentComment;
        if (!comment) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "font-semibold",
                    children: t("shared:consentComment")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                        value: comment,
                        users: users
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: wrapperClasses,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                    firstName: user.firstName,
                                    lastName: user.lastName,
                                    isPending: user.pending
                                }),
                                renderConsentOnBehalf()
                            ]
                        }),
                        renderComment()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        isCurrentUser ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex",
                            children: [
                                " ",
                                renderCurrentUser(),
                                " "
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex",
                            children: renderUserIcon()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                    isOpen: modalIsOpen,
                    onRequestClose: closeModal,
                    style: (0, $jF0Xa.defaultModalStyle),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                        handleClose: closeModal,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: t("asset:addConsentCommentHeader")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex my-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                                    className: "fill-current w-6 h-6 mr-3 text-ch-purple-500"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSW3P.default), {
                                                    caseId: props.caseId
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                                            initialValues: {
                                                body: yourConsentComment || ""
                                            },
                                            validationSchema: (0, $aREbg.default),
                                            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                                                handleComment(values.body);
                                                setSubmitting(false);
                                                setIsOpen(false);
                                            },
                                            children: ({ isSubmitting: isSubmitting, setFieldValue: setFieldValue, errors: errors, values: values, touched: touched, handleBlur: handleBlur, isValid: isValid, dirty: dirty })=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                                    className: "w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mb-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                                    name: "body",
                                                                    required: true,
                                                                    children: t("asset:comment")
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                                                    name: "body",
                                                                    onBlur: handleBlur,
                                                                    users: props.mentionableUsers,
                                                                    value: values.body,
                                                                    setValue: (body)=>setFieldValue("body", body)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                                    errorMessage: errors.body,
                                                                    isVisible: errors.body && touched.body
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                                            className: "mb-2",
                                                            buttons: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                                    action: closeModal,
                                                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                                                    children: t("shared:cancel")
                                                                }, "1"),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                                    isDisabled: isSubmitting || !isValid || !dirty,
                                                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                                                    isSubmit: true,
                                                                    children: t("asset:saveComment")
                                                                }, "2")
                                                            ]
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $66ce0bf98b261bc3$export$2e2bcd8739ae039 = $66ce0bf98b261bc3$var$RecommendationConsentItem;

});
parcelRegister("hSW3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $76bb1765a8cd141e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $aeos3 = parcelRequire("aeos3");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $kon2z = parcelRequire("kon2z");

var $QwmFv = parcelRequire("QwmFv");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $76bb1765a8cd141e$var$CaseDetailsSimple = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getLeadCareUserByCaseId)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const renderPatientName = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: theCase.firstName,
                    lastName: theCase.lastName,
                    title: theCase.title,
                    gender: theCase.gender
                })
            })
        });
    const renderDateOfBirth = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:dateOfBirth"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                    utcTime: theCase.dateOfBirth
                })
            ]
        });
    };
    const renderPatientHealthcareId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                healthcareIdLabel,
                ": ",
                theCase.healthcareId || "-"
            ]
        });
    };
    const renderPatientCareProviderId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                careProviderIdLabel,
                ": ",
                theCase.careProviderId || "-"
            ]
        });
    };
    const renderCaseType = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:type"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                    caseType: theCase.caseType
                })
            ]
        });
    };
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle
                })
            ]
        });
    };
    const renderClassification = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": ",
                theCase.classification
            ]
        });
    };
    if (!theCase || !theCase.id) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderPatientName(),
                    renderDateOfBirth(),
                    renderPatientHealthcareId(),
                    renderPatientCareProviderId()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderCaseType(),
                    renderLeadCare(),
                    renderClassification()
                ]
            })
        ]
    });
};
var $76bb1765a8cd141e$export$2e2bcd8739ae039 = $76bb1765a8cd141e$var$CaseDetailsSimple;

});

parcelRegister("aREbg", function(module, exports) {

$parcel$export(module.exports, "default", () => $173cea730a948df9$export$2e2bcd8739ae039);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $173cea730a948df9$var$YourConsentValidation = ()=>{
    return $hDGtv.create().shape({
        body: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(1500, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 1500
        }))
    });
};
var $173cea730a948df9$export$2e2bcd8739ae039 = $173cea730a948df9$var$YourConsentValidation;

});


parcelRegister("a4BnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b9bd3c2e3404195$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0b9bd3c2e3404195$var$CaseAssetLabel = ({ isVisible: isVisible = true, children: children })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "font-bold text-ch-blue-600 uppercase",
        children: [
            " ",
            children,
            " "
        ]
    });
};
var $0b9bd3c2e3404195$export$2e2bcd8739ae039 = $0b9bd3c2e3404195$var$CaseAssetLabel;

});


parcelRegister("7rDh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $52982ed657649dd8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");

var $hHsFn = parcelRequire("hHsFn");

var $6lvMC = parcelRequire("6lvMC");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $biuvr = parcelRequire("biuvr");
const $52982ed657649dd8$var$Comment = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const comment = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2 flex rounded-md border-2 bg-ch-blue-100", {
            "border-ch-blue-100": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHsFn.default), {
                    className: "w-5 h-5",
                    title: comment.title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: comment.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                        value: comment.body,
                        users: users
                    })
                ]
            }),
            props.children
        ]
    });
};
var $52982ed657649dd8$export$2e2bcd8739ae039 = $52982ed657649dd8$var$Comment;

});

parcelRegister("5QwAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06a04fa08297f95$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $fllUo = parcelRequire("fllUo");
var $8lynw = parcelRequire("8lynw");

var $biuvr = parcelRequire("biuvr");

var $6lvMC = parcelRequire("6lvMC");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $d06a04fa08297f95$var$Decision = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const decision = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2 rounded-md border-2 bg-ch-blue-200", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-ch-purple-500 mr-2 mt-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fllUo.default), {
                            className: "w-5 h-5",
                            title: decision.title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "font-semibold text-lg",
                                children: `${t("asset:decision")} ${decision.title}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                                meetingCaseAsset: props.meetingCaseAsset,
                                meetingId: props.meetingId,
                                asset: asset
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                                value: decision.body,
                                users: users
                            })
                        ]
                    }),
                    props.children
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 flex justify-center my-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8lynw.default), {
                    className: "w-5 h-5",
                    title: t("asset:decisionLockedText")
                })
            })
        ]
    });
};
var $d06a04fa08297f95$export$2e2bcd8739ae039 = $d06a04fa08297f95$var$Decision;

});

parcelRegister("dncl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $20223f67947655ad$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");

var $k7EMY = parcelRequire("k7EMY");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $20223f67947655ad$var$Pdf = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const pdf = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-white p-2 flex rounded-md border-2", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-alt-400 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                    className: "w-5 h-5",
                    title: pdf.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: `${pdf.name} (${(0, $k7EMY.bytesToSize)(pdf.bytes)})`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    })
                ]
            }),
            props.children
        ]
    });
};
var $20223f67947655ad$export$2e2bcd8739ae039 = $20223f67947655ad$var$Pdf;

});
parcelRegister("k7EMY", function(module, exports) {

$parcel$export(module.exports, "fileUploadOptions", () => $b515dfd8c4b31f00$export$4ed8ef8a14ed262);
$parcel$export(module.exports, "bytesToSize", () => $b515dfd8c4b31f00$export$aa86822bccdac75d);
$parcel$export(module.exports, "isFilesSizeUnderMaximum", () => $b515dfd8c4b31f00$export$58b878385a4f2d1f);
$parcel$export(module.exports, "isFileAcceptedType", () => $b515dfd8c4b31f00$export$2919773f8a2e8ec2);
$parcel$export(module.exports, "isCSVAcceptedType", () => $b515dfd8c4b31f00$export$95602f99d8f79fb9);
const $b515dfd8c4b31f00$export$4ed8ef8a14ed262 = {
    acceptedFileTypes: [
        "image/jpeg",
        "image/png",
        "application/pdf"
    ],
    acceptedCSVTypes: [
        "text/csv"
    ],
    maxFileSizeMB: 15,
    maxFileSize: 15728640,
    maxNameLength: 50
};
const $b515dfd8c4b31f00$export$aa86822bccdac75d = (bytes)=>{
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB"
    ];
    if (bytes == 0) return "n/a";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
    if (i == 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
};
const $b515dfd8c4b31f00$export$58b878385a4f2d1f = (value)=>{
    if (!value) return true;
    return value.size < $b515dfd8c4b31f00$export$4ed8ef8a14ed262.maxFileSize;
};
const $b515dfd8c4b31f00$export$2919773f8a2e8ec2 = (value)=>{
    if (!value) return true;
    return value.type && $b515dfd8c4b31f00$export$4ed8ef8a14ed262.acceptedFileTypes.includes(value.type);
};
const $b515dfd8c4b31f00$export$95602f99d8f79fb9 = (value)=>{
    if (!value) return true;
    return value.type && $b515dfd8c4b31f00$export$4ed8ef8a14ed262.acceptedCSVTypes.includes(value.type);
};

});


parcelRegister("d3Bwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff44269a098e7c68$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");

var $k7EMY = parcelRequire("k7EMY");

var $irINt = parcelRequire("irINt");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $ff44269a098e7c68$var$Image = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const image = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-white p-2 flex rounded-md border-2", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-16 h-16 p-1 flex items-center justify-center mr-2 overflow-hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irINt.default), {
                    path: image.path,
                    title: image.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: `${image.name} (${(0, $k7EMY.bytesToSize)(image.bytes)})`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    })
                ]
            }),
            props.children
        ]
    });
};
var $ff44269a098e7c68$export$2e2bcd8739ae039 = $ff44269a098e7c68$var$Image;

});
parcelRegister("irINt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f646e70ebf30f39$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jUk5c = parcelRequire("jUk5c");

var $aEgqS = parcelRequire("aEgqS");
const $3f646e70ebf30f39$var$ImageThumb = (props)=>{
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (!props.path) return;
        (0, $jUk5c.default)(props.path, setBlobUrl);
    }, [
        props.path
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: blobUrl,
        title: props.title
    });
};
var $3f646e70ebf30f39$export$2e2bcd8739ae039 = $3f646e70ebf30f39$var$ImageThumb;

});


parcelRegister("43Pe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a810c4e17c90a415$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $7twpo = parcelRequire("7twpo");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");

var $4KSAX = parcelRequire("4KSAX");

var $k7EMY = parcelRequire("k7EMY");

var $aDoxy = parcelRequire("aDoxy");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $2ghAH = parcelRequire("2ghAH");

var $a4BnF = parcelRequire("a4BnF");
const $a810c4e17c90a415$var$CaseReport = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const caseReport = asset.asset;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset",
        "shared"
    ]);
    const isClickable = props.action && caseReport.status == (0, $7twpo.CaseReportStatuses).DONE;
    const isPending = caseReport.status == (0, $7twpo.CaseReportStatuses).PENDING;
    const renderTitle = ()=>{
        if (isPending) return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
            className: "flex-1 font-semibold text-lg",
            children: caseReport.name
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
            className: "flex-1 font-semibold text-lg",
            children: `${caseReport.name} (${(0, $k7EMY.bytesToSize)(caseReport.bytes)})`
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: isClickable ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-ch-green-200 p-2 flex rounded-md border-2", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": isClickable,
            "cursor-pointer": isClickable,
            "cursor-default": !isClickable
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-alt-400 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                    className: "w-5 h-5",
                    title: caseReport.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            renderTitle(),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a4BnF.default), {
                                isVisible: isPending,
                                children: [
                                    t("asset:generatingReport"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ghAH.default), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    })
                ]
            }),
            props.children
        ]
    });
};
var $a810c4e17c90a415$export$2e2bcd8739ae039 = $a810c4e17c90a415$var$CaseReport;

});

parcelRegister("bw1cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e069232371343b28$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jUk5c = parcelRequire("jUk5c");

var $lxTgp = parcelRequire("lxTgp");

var $aEgqS = parcelRequire("aEgqS");

var $3Npjv = parcelRequire("3Npjv");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $rDKvs = parcelRequire("rDKvs");
const $e069232371343b28$var$LiveMeetingPdfViewer = ({ rotation: rotation = 0, ...props })=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const pdf = asset.asset;
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const updateSharedPdfState = (pdfState)=>dispatch((0, $rDKvs.updateSharedPdfStateAction)(pdfState));
    (0, $acw62.useEffect)(()=>{
        if (!pdf.path) return;
        (0, $jUk5c.default)(pdf.path, setBlobUrl);
    }, [
        pdf.path
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Npjv.default), {
        url: blobUrl,
        isDownloadable: false,
        rotateCallback: updateSharedPdfState,
        rotation: rotation,
        hideRotateButton: props.hideRotateButton
    });
};
var $e069232371343b28$export$2e2bcd8739ae039 = $e069232371343b28$var$LiveMeetingPdfViewer;

});
parcelRegister("3Npjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $29938112b31e0379$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $2sEsz = parcelRequire("2sEsz");
var $hlSVJ = parcelRequire("hlSVJ");
var $j1W2m = parcelRequire("j1W2m");

var $kugBo = parcelRequire("kugBo");
parcelRequire("jitSV");
var $1xXym = parcelRequire("1xXym");
var $ls9xE = parcelRequire("ls9xE");

var $lCZwG = parcelRequire("lCZwG");

var $aEgqS = parcelRequire("aEgqS");

var $aaRo7 = parcelRequire("aaRo7");


(0, $j1W2m).GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
const $29938112b31e0379$var$addExtensionToFilename = (filename)=>{
    if (!filename) return "document.pdf";
    else if (!filename.toLowerCase().endsWith(".pdf")) return filename + ".pdf";
    return filename;
};
const $29938112b31e0379$var$PdfViewer = ({ isDownloadable: isDownloadable = true, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const [numPages, setNumPages] = (0, $acw62.useState)(null);
    const [pageWidth, setPageWidth] = (0, $acw62.useState)(null);
    const [pageScale, setPageScale] = (0, $acw62.useState)(0.8);
    const [rotationState, setRotationState] = (0, $acw62.useState)(props.rotation || 0);
    const onResize = (0, $acw62.useCallback)((width, _height)=>{
        setPageWidth(width);
    }, []);
    const { ref: ref } = (0, $kugBo.useResizeDetector)({
        onResize: onResize
    });
    const onLoadSuccess = ({ numPages: numPages })=>{
        setNumPages(numPages);
    };
    // when hiding the rotate button, we are relying on the prop to control the
    // rotation, otherwise it's the component itself that maintains the state
    const rotation = props.hideRotateButton ? props.rotation : rotationState;
    const renderPages = ()=>{
        return Array.from(new Array(numPages), (_element, index)=>{
            const pageNumber = index + 1;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hlSVJ.default), {
                        pageNumber: pageNumber,
                        loading: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {}),
                        width: pageWidth,
                        scale: pageScale
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute bottom-8 text-ch-gray-400",
                        style: {
                            fontSize: `${pageScale}em`,
                            textShadow: "#FFF 1px 1px 1px"
                        },
                        children: `Page ${pageNumber}`
                    })
                ]
            }, `page_${pageNumber}`);
        });
    };
    const renderDownloadButton = ()=>{
        if (!isDownloadable) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sm:absolute right-0",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: props.url,
                download: $29938112b31e0379$var$addExtensionToFilename(props.filename),
                className: "text-ch-blue-500 hover:text-ch-blue-600 p-2 flex items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1xXym.default), {
                    className: "w-6 h-6",
                    title: t("shared:download")
                })
            })
        });
    };
    const rotateButtonAction = ()=>{
        const newRotation = (rotation + 90) % 360;
        setRotationState(newRotation);
        if (props.rotateCallback) props.rotateCallback({
            rotation: newRotation
        });
    };
    const renderContent = ()=>{
        if (!props.url) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2sEsz.default), {
            loading: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {}),
            file: props.url,
            onLoadSuccess: onLoadSuccess,
            rotate: rotation,
            children: renderPages()
        });
    };
    const renderRotateButton = ()=>{
        if (props.hideRotateButton) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: rotateButtonAction,
            className: "ml-2 bg-ch-gray-600 flex justify-center w-20",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ls9xE.default), {
                className: "w-6 h-8"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col w-full h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: ref,
                className: "flex overflow-auto w-full flex-1 justify-center bg-ch-gray-200 mb-3",
                children: renderContent()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-center relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-64",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aaRo7.default), {
                            onChange: (value)=>setPageScale(value / 100),
                            value: pageScale * 100,
                            min: 30,
                            max: 200
                        })
                    }),
                    renderRotateButton(),
                    renderDownloadButton()
                ]
            })
        ]
    });
};
var $29938112b31e0379$export$2e2bcd8739ae039 = $29938112b31e0379$var$PdfViewer;

});
parcelRegister("2sEsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cad94c188232b88$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $fimmU = parcelRequire("fimmU");

var $e2Tlf = parcelRequire("e2Tlf");

var $hMZkZ = parcelRequire("hMZkZ");

var $j1W2m = parcelRequire("j1W2m");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $cFw5p = parcelRequire("cFw5p");

var $5rpzA = parcelRequire("5rpzA");

var $bC4Qw = parcelRequire("bC4Qw");

var $3YeDD = parcelRequire("3YeDD");

var $j7H4Y = parcelRequire("j7H4Y");

var $oH8OY = parcelRequire("oH8OY");
'use client';
const { PDFDataRangeTransport: $1cad94c188232b88$var$PDFDataRangeTransport } = $j1W2m;
const $1cad94c188232b88$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $3YeDD.default).NEED_PASSWORD:
            {
                const password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            }
        case (0, $3YeDD.default).INCORRECT_PASSWORD:
            {
                const password = prompt('Invalid password. Please try again.');
                callback(password);
                break;
            }
        default:
    }
};
function $1cad94c188232b88$var$isParameterObject(file) {
    return typeof file === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */ const $1cad94c188232b88$var$Document = (0, $acw62.forwardRef)(function Document({ children: children, className: className, error: error = 'Failed to load PDF file.', externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = 'No PDF file specified.', onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $1cad94c188232b88$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate, scale: scale, ...otherProps }, ref) {
    const [sourceState, sourceDispatch] = (0, $j7H4Y.default)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $j7H4Y.default)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $acw62.useRef)(new (0, $5rpzA.default)());
    const pages = (0, $acw62.useRef)([]);
    const prevFile = (0, $acw62.useRef)(undefined);
    const prevOptions = (0, $acw62.useRef)(undefined);
    if (file && file !== prevFile.current && $1cad94c188232b88$var$isParameterObject(file)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!(0, $fimmU.dequal)(file, prevFile.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`);
        prevFile.current = file;
    }
    // Detect non-memoized changes in options prop
    if (options && options !== prevOptions.current) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!(0, $fimmU.dequal)(options, prevOptions.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`);
        prevOptions.current = options;
    }
    const viewer = (0, $acw62.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: 'RESET'
        });
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: See https://github.com/biomejs/biome/issues/3080
    (0, $acw62.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $acw62.useCallback)(async ()=>{
        if (!file) return null;
        // File is a string
        if (typeof file === 'string') {
            if ((0, $oH8OY.isDataURI)(file)) {
                const fileByteString = (0, $oH8OY.dataURItoByteString)(file);
                return {
                    data: fileByteString
                };
            }
            (0, $oH8OY.displayCORSWarning)();
            return {
                url: file
            };
        }
        // File is PDFDataRangeTransport
        if (file instanceof $1cad94c188232b88$var$PDFDataRangeTransport) return {
            range: file
        };
        // File is an ArrayBuffer
        if ((0, $oH8OY.isArrayBuffer)(file)) return {
            data: file
        };
        /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $oH8OY.isBrowser) // File is a Blob
        {
            if ((0, $oH8OY.isBlob)(file)) {
                const data = await (0, $oH8OY.loadFromFile)(file);
                return {
                    data: data
                };
            }
        }
        // At this point, file must be an object
        (0, $bv4qN.default)(typeof file === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
        (0, $bv4qN.default)($1cad94c188232b88$var$isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url');
        // File .url is a string
        if ('url' in file && typeof file.url === 'string') {
            if ((0, $oH8OY.isDataURI)(file.url)) {
                const { url: url, ...otherParams } = file;
                const fileByteString = (0, $oH8OY.dataURItoByteString)(url);
                return {
                    data: fileByteString,
                    ...otherParams
                };
            }
            (0, $oH8OY.displayCORSWarning)();
        }
        return file;
    }, [
        file
    ]);
    (0, $acw62.useEffect)(()=>{
        const cancellable = (0, $e2Tlf.default)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: 'RESOLVE',
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $oH8OY.cancelRunningTask)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (typeof source === 'undefined') return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on source change
    (0, $acw62.useEffect)(function resetDocument() {
        pdfDispatch({
            type: 'RESET'
        });
    }, [
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? {
            ...source,
            ...options
        } : source;
        const destroyable = $j1W2m.getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        loadingTask.promise.then((nextPdf)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'RESOLVE',
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            loadingTask.destroy();
            // Destroyed loading task leaves behind a dead PDFDocumentProxy
            pdfDispatch({
                type: 'RESET'
            });
        };
    }, [
        options,
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (typeof pdf === 'undefined') return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        pdf
    ]);
    (0, $acw62.useEffect)(function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }, [
        externalLinkRel,
        externalLinkTarget
    ]);
    const registerPage = (0, $acw62.useCallback)((pageIndex, ref)=>{
        pages.current[pageIndex] = ref;
    }, []);
    const unregisterPage = (0, $acw62.useCallback)((pageIndex)=>{
        delete pages.current[pageIndex];
    }, []);
    const childContext = (0, $acw62.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            scale: scale,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        registerPage,
        renderMode,
        rotate,
        scale,
        unregisterPage
    ]);
    const eventProps = (0, $acw62.useMemo)(()=>(0, $hMZkZ.default)(otherProps, ()=>pdf), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        function isFulfilledContext(context) {
            return Boolean(context === null || context === void 0 ? void 0 : context.pdf);
        }
        if (!isFulfilledContext(childContext)) // Impossible, but TypeScript doesn't know that
        throw new Error('pdf is undefined');
        const resolvedChildren = typeof children === 'function' ? children(childContext) : children;
        return (0, $ayMG0.jsx)((0, $cFw5p.default).Provider, {
            value: childContext,
            children: resolvedChildren
        });
    }
    function renderContent() {
        if (!file) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === undefined || pdf === null) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('react-pdf__Document', className),
        // Assertion is needed for React 18 compatibility
        ref: inputRef,
        ...eventProps,
        children: renderContent()
    });
});
var $1cad94c188232b88$export$2e2bcd8739ae039 = $1cad94c188232b88$var$Document;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("fimmU", function(module, exports) {

$parcel$export(module.exports, "dequal", () => $371d31aa64efa655$export$de8294bb3be0322f);
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("e2Tlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39c2e4b20567961$export$2e2bcd8739ae039);
function $a39c2e4b20567961$export$2e2bcd8739ae039(promise) {
    let isCancelled = false;
    const wrappedPromise = new Promise((resolve, reject)=>{
        promise.then((value)=>!isCancelled && resolve(value)).catch((error)=>!isCancelled && reject(error));
    });
    return {
        promise: wrappedPromise,
        cancel () {
            isCancelled = true;
        }
    };
}

});

parcelRegister("hMZkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf367fbdb65bc7ed$export$2e2bcd8739ae039);
// As defined on the list of supported events: https://reactjs.org/docs/events.html
const $cf367fbdb65bc7ed$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
const $cf367fbdb65bc7ed$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
const $cf367fbdb65bc7ed$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
const $cf367fbdb65bc7ed$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
const $cf367fbdb65bc7ed$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
const $cf367fbdb65bc7ed$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
const $cf367fbdb65bc7ed$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
const $cf367fbdb65bc7ed$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
const $cf367fbdb65bc7ed$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
const $cf367fbdb65bc7ed$export$d93346aa7735a637 = [
    'onSelect'
];
const $cf367fbdb65bc7ed$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
const $cf367fbdb65bc7ed$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
const $cf367fbdb65bc7ed$export$bac3087b5cb826f6 = [
    'onScroll'
];
const $cf367fbdb65bc7ed$export$28298837799e00e8 = [
    'onWheel'
];
const $cf367fbdb65bc7ed$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
const $cf367fbdb65bc7ed$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
const $cf367fbdb65bc7ed$export$477a88c5b93a108d = [
    'onToggle'
];
const $cf367fbdb65bc7ed$export$7212b61f9f58bd1 = [
    'onChange'
];
const $cf367fbdb65bc7ed$export$59ef7197c4d7b9dc = [
    ...$cf367fbdb65bc7ed$export$84fe03429ed1b6d6,
    ...$cf367fbdb65bc7ed$export$dbc46161504615f7,
    ...$cf367fbdb65bc7ed$export$fb6351c2666f0875,
    ...$cf367fbdb65bc7ed$export$4e58c1a9761ed81a,
    ...$cf367fbdb65bc7ed$export$3bf7402f2a4eb3af,
    ...$cf367fbdb65bc7ed$export$409c4891d97f97cf,
    ...$cf367fbdb65bc7ed$export$6be5aa2386088264,
    ...$cf367fbdb65bc7ed$export$3a6e2b8954613992,
    ...$cf367fbdb65bc7ed$export$6c96379d5b8a2df7,
    ...$cf367fbdb65bc7ed$export$d93346aa7735a637,
    ...$cf367fbdb65bc7ed$export$fa367689c659e65c,
    ...$cf367fbdb65bc7ed$export$c731eab7619e00a0,
    ...$cf367fbdb65bc7ed$export$bac3087b5cb826f6,
    ...$cf367fbdb65bc7ed$export$28298837799e00e8,
    ...$cf367fbdb65bc7ed$export$6ff45424014e7407,
    ...$cf367fbdb65bc7ed$export$78878fc7bd50dc3e,
    ...$cf367fbdb65bc7ed$export$7212b61f9f58bd1,
    ...$cf367fbdb65bc7ed$export$477a88c5b93a108d
];
function $cf367fbdb65bc7ed$export$2e2bcd8739ae039(props, getArgs) {
    const eventProps = {};
    for (const eventName of $cf367fbdb65bc7ed$export$59ef7197c4d7b9dc){
        const eventHandler = props[eventName];
        if (!eventHandler) continue;
        if (getArgs) eventProps[eventName] = (event)=>eventHandler(event, getArgs(eventName));
        else eventProps[eventName] = eventHandler;
    }
    return eventProps;
}

});

parcelRegister("j1W2m", function(module, exports) {

$parcel$export(module.exports, "AnnotationMode", () => $5942e8eb8ca60ef8$export$5a7af0c07e33392e);
$parcel$export(module.exports, "AnnotationEditorType", () => $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf);
$parcel$export(module.exports, "AnnotationEditorParamsType", () => $5942e8eb8ca60ef8$export$cf3df2a6ecc26692);
$parcel$export(module.exports, "PermissionFlag", () => $5942e8eb8ca60ef8$export$bb99a5b8411e07d8);
$parcel$export(module.exports, "ImageKind", () => $5942e8eb8ca60ef8$export$b890e9c15247e0b3);
$parcel$export(module.exports, "AnnotationType", () => $5942e8eb8ca60ef8$export$f50c3066a53a6f2c);
$parcel$export(module.exports, "VerbosityLevel", () => $5942e8eb8ca60ef8$export$b18df09d23c244c4);
$parcel$export(module.exports, "OPS", () => $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b);
$parcel$export(module.exports, "PasswordResponses", () => $5942e8eb8ca60ef8$export$5e72215208e4d9ad);
$parcel$export(module.exports, "createValidAbsoluteUrl", () => $5942e8eb8ca60ef8$export$e076b47f5805ca0b);
$parcel$export(module.exports, "updateUrlHash", () => $5942e8eb8ca60ef8$export$e1e4297c21ab9d13);
$parcel$export(module.exports, "shadow", () => $5942e8eb8ca60ef8$export$b8972b998723d602);
$parcel$export(module.exports, "InvalidPDFException", () => $5942e8eb8ca60ef8$export$e3d0f4ce5b91e9f1);
$parcel$export(module.exports, "ResponseException", () => $5942e8eb8ca60ef8$export$ea8e9c34f66e603);
$parcel$export(module.exports, "AbortException", () => $5942e8eb8ca60ef8$export$d0e978393d193d1a);
$parcel$export(module.exports, "FeatureTest", () => $5942e8eb8ca60ef8$export$5fb8891d35c36978);
$parcel$export(module.exports, "Util", () => $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd);
$parcel$export(module.exports, "normalizeUnicode", () => $5942e8eb8ca60ef8$export$1fa1e6b1a06bd7fa);
$parcel$export(module.exports, "getUuid", () => $5942e8eb8ca60ef8$export$75f13a91ebdf8eb3);
$parcel$export(module.exports, "MathClamp", () => $5942e8eb8ca60ef8$export$b8106b171181a554);
$parcel$export(module.exports, "XfaLayer", () => $5942e8eb8ca60ef8$export$f6af20c312d4b9a2);
$parcel$export(module.exports, "PixelsPerInch", () => $5942e8eb8ca60ef8$export$6ef3b6b69e65342c);
$parcel$export(module.exports, "fetchData", () => $5942e8eb8ca60ef8$export$8134c072fddab6a5);
$parcel$export(module.exports, "RenderingCancelledException", () => $5942e8eb8ca60ef8$export$245847d31c09154f);
$parcel$export(module.exports, "isDataScheme", () => $5942e8eb8ca60ef8$export$f67aae4532d8295b);
$parcel$export(module.exports, "isPdfFile", () => $5942e8eb8ca60ef8$export$61b52d3570d24719);
$parcel$export(module.exports, "getFilenameFromUrl", () => $5942e8eb8ca60ef8$export$b1c11df0696253ae);
$parcel$export(module.exports, "getPdfFilenameFromUrl", () => $5942e8eb8ca60ef8$export$9de51790aa4bc73a);
$parcel$export(module.exports, "noContextMenu", () => $5942e8eb8ca60ef8$export$455b7811f904cadc);
$parcel$export(module.exports, "stopEvent", () => $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "PDFDateString", () => $5942e8eb8ca60ef8$export$66cbc314498fffc);
$parcel$export(module.exports, "getXfaPageViewport", () => $5942e8eb8ca60ef8$export$dd5d6edf3fc80aae);
$parcel$export(module.exports, "getRGB", () => $5942e8eb8ca60ef8$export$2a2e9b507863ddda);
$parcel$export(module.exports, "setLayerDimensions", () => $5942e8eb8ca60ef8$export$af0a15a86e590226);
$parcel$export(module.exports, "OutputScale", () => $5942e8eb8ca60ef8$export$f16a99f63bccd50b);
$parcel$export(module.exports, "SupportedImageMimeTypes", () => $5942e8eb8ca60ef8$export$3234c88e9de64a88);
$parcel$export(module.exports, "CSSConstants", () => $5942e8eb8ca60ef8$export$cec677744f6a5015);
$parcel$export(module.exports, "applyOpacity", () => $5942e8eb8ca60ef8$export$f8d1472813e87bf9);
$parcel$export(module.exports, "findContrastColor", () => $5942e8eb8ca60ef8$export$7a96203b1fdebe8d);
$parcel$export(module.exports, "renderRichText", () => $5942e8eb8ca60ef8$export$611c480766035c4);
$parcel$export(module.exports, "AnnotationEditorUIManager", () => $5942e8eb8ca60ef8$export$26cb16552a82cf63);
$parcel$export(module.exports, "TouchManager", () => $5942e8eb8ca60ef8$export$9ae7542b430d543e);
$parcel$export(module.exports, "isValidExplicitDest", () => $5942e8eb8ca60ef8$export$b5acece0a447dcdc);
$parcel$export(module.exports, "GlobalWorkerOptions", () => $5942e8eb8ca60ef8$export$edf38ba293eb934);
$parcel$export(module.exports, "TextLayer", () => $5942e8eb8ca60ef8$export$fdbdc423a78c5262);
$parcel$export(module.exports, "getDocument", () => $5942e8eb8ca60ef8$export$f65ca476c09acec0);
$parcel$export(module.exports, "PDFDataRangeTransport", () => $5942e8eb8ca60ef8$export$c06899d9d7bce9ab);
$parcel$export(module.exports, "PDFWorker", () => $5942e8eb8ca60ef8$export$84e2e9f37426b265);
$parcel$export(module.exports, "version", () => $5942e8eb8ca60ef8$export$83d89fbfd8236492);
$parcel$export(module.exports, "build", () => $5942e8eb8ca60ef8$export$3f8fe6489e95757d);
$parcel$export(module.exports, "ColorPicker", () => $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3);
$parcel$export(module.exports, "DOMSVGFactory", () => $5942e8eb8ca60ef8$export$425e69f00724e63a);
$parcel$export(module.exports, "AnnotationLayer", () => $5942e8eb8ca60ef8$export$3e7f45c326d9366c);
$parcel$export(module.exports, "SignatureExtractor", () => $5942e8eb8ca60ef8$export$cc4fe8633f466b4a);
$parcel$export(module.exports, "AnnotationEditorLayer", () => $5942e8eb8ca60ef8$export$47948c9fe1adbf1b);
$parcel$export(module.exports, "DrawLayer", () => $5942e8eb8ca60ef8$export$3eb4521511f02450);
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /**
 * pdfjsVersion = 5.4.296
 * pdfjsBuild = f56dc8601
 */ /******/ // The require scope
/******/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $5942e8eb8ca60ef8$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
var $5942e8eb8ca60ef8$var$__webpack_require__ = {};
/******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $5942e8eb8ca60ef8$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($5942e8eb8ca60ef8$var$__webpack_require__.o(definition, key) && !$5942e8eb8ca60ef8$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $5942e8eb8ca60ef8$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /************************************************************************/ var $5942e8eb8ca60ef8$var$__webpack_exports__ = {};
const $5942e8eb8ca60ef8$var$isNodeJS = false;
const $5942e8eb8ca60ef8$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $5942e8eb8ca60ef8$var$LINE_FACTOR = 1.35;
const $5942e8eb8ca60ef8$var$LINE_DESCENT_FACTOR = 0.35;
const $5942e8eb8ca60ef8$var$BASELINE_FACTOR = $5942e8eb8ca60ef8$var$LINE_DESCENT_FACTOR / $5942e8eb8ca60ef8$var$LINE_FACTOR;
const $5942e8eb8ca60ef8$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
const $5942e8eb8ca60ef8$export$5a7af0c07e33392e = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $5942e8eb8ca60ef8$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102
};
const $5942e8eb8ca60ef8$export$cf3df2a6ecc26692 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41
};
const $5942e8eb8ca60ef8$export$bb99a5b8411e07d8 = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $5942e8eb8ca60ef8$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $5942e8eb8ca60ef8$export$b890e9c15247e0b3 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $5942e8eb8ca60ef8$export$f50c3066a53a6f2c = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $5942e8eb8ca60ef8$var$AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
const $5942e8eb8ca60ef8$var$AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
const $5942e8eb8ca60ef8$var$AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
const $5942e8eb8ca60ef8$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $5942e8eb8ca60ef8$var$AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
const $5942e8eb8ca60ef8$var$DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
const $5942e8eb8ca60ef8$var$PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
const $5942e8eb8ca60ef8$export$b18df09d23c244c4 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
const $5942e8eb8ca60ef8$var$DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    closePath: 3
};
const $5942e8eb8ca60ef8$export$5e72215208e4d9ad = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $5942e8eb8ca60ef8$var$verbosity = $5942e8eb8ca60ef8$export$b18df09d23c244c4.WARNINGS;
function $5942e8eb8ca60ef8$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $5942e8eb8ca60ef8$var$verbosity = level;
}
function $5942e8eb8ca60ef8$var$getVerbosityLevel() {
    return $5942e8eb8ca60ef8$var$verbosity;
}
function $5942e8eb8ca60ef8$var$info(msg) {
    if ($5942e8eb8ca60ef8$var$verbosity >= $5942e8eb8ca60ef8$export$b18df09d23c244c4.INFOS) console.info(`Info: ${msg}`);
}
function $5942e8eb8ca60ef8$var$warn(msg) {
    if ($5942e8eb8ca60ef8$var$verbosity >= $5942e8eb8ca60ef8$export$b18df09d23c244c4.WARNINGS) console.warn(`Warning: ${msg}`);
}
function $5942e8eb8ca60ef8$var$unreachable(msg) {
    throw new Error(msg);
}
function $5942e8eb8ca60ef8$var$assert(cond, msg) {
    if (!cond) $5942e8eb8ca60ef8$var$unreachable(msg);
}
function $5942e8eb8ca60ef8$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $5942e8eb8ca60ef8$export$e076b47f5805ca0b(url, baseUrl = null, options = null) {
    if (!url) return null;
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            const dots = url.match(/\./g);
            if (dots?.length >= 2) url = `http://${url}`;
        }
        if (options.tryConvertEncoding) try {
            url = $5942e8eb8ca60ef8$var$stringToUTF8String(url);
        } catch  {}
    }
    const absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return $5942e8eb8ca60ef8$var$_isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function $5942e8eb8ca60ef8$export$e1e4297c21ab9d13(url, hash, allowRel = false) {
    const res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && $5942e8eb8ca60ef8$export$e076b47f5805ca0b(url, "http://example.com")) return url.split("#", 1)[0] + `${hash ? `#${hash}` : ""}`;
    return "";
}
function $5942e8eb8ca60ef8$export$b8972b998723d602(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $5942e8eb8ca60ef8$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $5942e8eb8ca60ef8$var$PasswordException extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $5942e8eb8ca60ef8$var$UnknownErrorException extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $5942e8eb8ca60ef8$export$e3d0f4ce5b91e9f1 extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $5942e8eb8ca60ef8$export$ea8e9c34f66e603 extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg, status, missing){
        super(msg, "ResponseException");
        this.status = status;
        this.missing = missing;
    }
}
class $5942e8eb8ca60ef8$var$FormatError extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $5942e8eb8ca60ef8$export$d0e978393d193d1a extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $5942e8eb8ca60ef8$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $5942e8eb8ca60ef8$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $5942e8eb8ca60ef8$var$stringToBytes(str) {
    if (typeof str !== "string") $5942e8eb8ca60ef8$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $5942e8eb8ca60ef8$var$string32(value) {
    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function $5942e8eb8ca60ef8$var$objectSize(obj) {
    return Object.keys(obj).length;
}
function $5942e8eb8ca60ef8$var$isLittleEndian() {
    const buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
function $5942e8eb8ca60ef8$var$isEvalSupported() {
    try {
        new Function("");
        return true;
    } catch  {
        return false;
    }
}
class $5942e8eb8ca60ef8$export$5fb8891d35c36978 {
    static get isLittleEndian() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isLittleEndian", $5942e8eb8ca60ef8$var$isLittleEndian());
    }
    static get isEvalSupported() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isEvalSupported", $5942e8eb8ca60ef8$var$isEvalSupported());
    }
    static get isOffscreenCanvasSupported() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get isImageDecoderSupported() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
    }
    static get platform() {
        const { platform: platform, userAgent: userAgent } = navigator;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "platform", {
            isAndroid: userAgent.includes("Android"),
            isLinux: platform.includes("Linux"),
            isMac: platform.includes("Mac"),
            isWindows: platform.includes("Win"),
            isFirefox: userAgent.includes("Firefox")
        });
    }
    static get isCSSRoundSupported() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
    }
}
const $5942e8eb8ca60ef8$var$hexNumbers = Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0"));
class $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd {
    static makeHexColor(r, g, b) {
        return `#${$5942e8eb8ca60ef8$var$hexNumbers[r]}${$5942e8eb8ca60ef8$var$hexNumbers[g]}${$5942e8eb8ca60ef8$var$hexNumbers[b]}`;
    }
    static domMatrixToTransform(dm) {
        return [
            dm.a,
            dm.b,
            dm.c,
            dm.d,
            dm.e,
            dm.f
        ];
    }
    static scaleMinMax(transform, minMax) {
        let temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        } else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static multiplyByDOMMatrix(m, md) {
        return [
            m[0] * md.a + m[2] * md.b,
            m[1] * md.a + m[3] * md.b,
            m[0] * md.c + m[2] * md.d,
            m[1] * md.c + m[3] * md.d,
            m[0] * md.e + m[2] * md.f + m[4],
            m[1] * md.e + m[3] * md.f + m[5]
        ];
    }
    static applyTransform(p, m, pos = 0) {
        const p0 = p[pos];
        const p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    }
    static applyTransformToBezier(p, transform, pos = 0) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        for(let i = 0; i < 6; i += 2){
            const pI = p[pos + i];
            const pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    }
    static applyInverseTransform(p, m) {
        const p0 = p[0];
        const p1 = p[1];
        const d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    }
    static axialAlignedBoundingBox(rect, transform, output) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        const r0 = rect[0];
        const r1 = rect[1];
        const r2 = rect[2];
        const r3 = rect[3];
        let a0 = m0 * r0 + m4;
        let a2 = a0;
        let a1 = m0 * r2 + m4;
        let a3 = a1;
        let b0 = m3 * r1 + m5;
        let b2 = b0;
        let b1 = m3 * r3 + m5;
        let b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            const m1r0 = m1 * r0;
            const m1r2 = m1 * r2;
            const m2r1 = m2 * r1;
            const m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(matrix, output) {
        const m0 = matrix[0];
        const m1 = matrix[1];
        const m2 = matrix[2];
        const m3 = matrix[3];
        const a = m0 ** 2 + m1 ** 2;
        const b = m0 * m2 + m1 * m3;
        const c = m2 ** 2 + m3 ** 2;
        const first = (a + c) / 2;
        const second = Math.sqrt(first ** 2 - (a * c - b ** 2));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static pointBoundingBox(x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static rectBoundingBox(x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    }
}
const $5942e8eb8ca60ef8$var$PDFStringTranslateTable = /* unused pure expression or super */ null;
function $5942e8eb8ca60ef8$var$stringToPDFString(str, keepEscapeSequence = false) {
    if (str[0] >= "\xEF") {
        let encoding;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
        if (encoding) try {
            const decoder = new TextDecoder(encoding, {
                fatal: true
            });
            const buffer = $5942e8eb8ca60ef8$var$stringToBytes(str);
            const decoded = decoder.decode(buffer);
            if (keepEscapeSequence || !decoded.includes("\x1b")) return decoded;
            return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
        } catch (ex) {
            $5942e8eb8ca60ef8$var$warn(`stringToPDFString: "${ex}".`);
        }
    }
    const strBuf = [];
    for(let i = 0, ii = str.length; i < ii; i++){
        const charCode = str.charCodeAt(i);
        if (!keepEscapeSequence && charCode === 0x1b) {
            while(++i < ii && str.charCodeAt(i) !== 0x1b);
            continue;
        }
        const code = $5942e8eb8ca60ef8$var$PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function $5942e8eb8ca60ef8$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $5942e8eb8ca60ef8$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $5942e8eb8ca60ef8$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $5942e8eb8ca60ef8$var$getModificationDate(date = new Date()) {
    if (!(date instanceof Date)) date = new Date(date);
    const buffer = [
        date.getUTCFullYear().toString(),
        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
        date.getUTCDate().toString().padStart(2, "0"),
        date.getUTCHours().toString().padStart(2, "0"),
        date.getUTCMinutes().toString().padStart(2, "0"),
        date.getUTCSeconds().toString().padStart(2, "0")
    ];
    return buffer.join("");
}
let $5942e8eb8ca60ef8$var$NormalizeRegex = null;
let $5942e8eb8ca60ef8$var$NormalizationMap = null;
function $5942e8eb8ca60ef8$export$1fa1e6b1a06bd7fa(str) {
    if (!$5942e8eb8ca60ef8$var$NormalizeRegex) {
        $5942e8eb8ca60ef8$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $5942e8eb8ca60ef8$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($5942e8eb8ca60ef8$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $5942e8eb8ca60ef8$var$NormalizationMap.get(p2));
}
function $5942e8eb8ca60ef8$export$75f13a91ebdf8eb3() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return $5942e8eb8ca60ef8$var$bytesToString(buf);
}
const $5942e8eb8ca60ef8$var$AnnotationPrefix = "pdfjs_internal_id_";
function $5942e8eb8ca60ef8$var$_isValidExplicitDest(validRef, validName, dest) {
    if (!Array.isArray(dest) || dest.length < 2) return false;
    const [page, zoom, ...args] = dest;
    if (!validRef(page) && !Number.isInteger(page)) return false;
    if (!validName(zoom)) return false;
    const argsLen = args.length;
    let allowNull = true;
    switch(zoom.name){
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) return false;
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) return false;
            break;
        case "FitR":
            if (argsLen !== 4) return false;
            allowNull = false;
            break;
        default:
            return false;
    }
    for (const arg of args){
        if (typeof arg === "number" || allowNull && arg === null) continue;
        return false;
    }
    return true;
}
function $5942e8eb8ca60ef8$export$b8106b171181a554(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
function $5942e8eb8ca60ef8$var$toHexUtil(arr) {
    if (Uint8Array.prototype.toHex) return arr.toHex();
    return Array.from(arr, (num)=>$5942e8eb8ca60ef8$var$hexNumbers[num]).join("");
}
function $5942e8eb8ca60ef8$var$toBase64Util(arr) {
    if (Uint8Array.prototype.toBase64) return arr.toBase64();
    return btoa($5942e8eb8ca60ef8$var$bytesToString(arr));
}
function $5942e8eb8ca60ef8$var$fromBase64Util(str) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(str);
    return $5942e8eb8ca60ef8$var$stringToBytes(atob(str));
}
if (typeof Promise.try !== "function") Promise.try = function(fn, ...args) {
    return new Promise((resolve)=>{
        resolve(fn(...args));
    });
};
if (typeof Math.sumPrecise !== "function") Math.sumPrecise = function(numbers) {
    return numbers.reduce((a, b)=>a + b, 0);
};
class $5942e8eb8ca60ef8$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$5942e8eb8ca60ef8$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
class $5942e8eb8ca60ef8$export$f6af20c312d4b9a2 {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $5942e8eb8ca60ef8$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $5942e8eb8ca60ef8$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
}
const $5942e8eb8ca60ef8$var$SVG_NS = "http://www.w3.org/2000/svg";
class $5942e8eb8ca60ef8$export$6ef3b6b69e65342c {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
async function $5942e8eb8ca60ef8$export$8134c072fddab6a5(url, type = "text") {
    if ($5942e8eb8ca60ef8$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "arraybuffer":
                return response.arrayBuffer();
            case "blob":
                return response.blob();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "arraybuffer":
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $5942e8eb8ca60ef8$var$PageViewport {
    constructor({ viewBox: viewBox, userUnit: userUnit, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const dims = this.viewBox;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "rawDims", {
            pageWidth: dims[2] - dims[0],
            pageHeight: dims[3] - dims[1],
            pageX: dims[0],
            pageY: dims[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $5942e8eb8ca60ef8$var$PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        const p = [
            x,
            y
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.applyTransform(p, this.transform);
        return p;
    }
    convertToViewportRectangle(rect) {
        const topLeft = [
            rect[0],
            rect[1]
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.applyTransform(topLeft, this.transform);
        const bottomRight = [
            rect[2],
            rect[3]
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.applyTransform(bottomRight, this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        const p = [
            x,
            y
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.applyInverseTransform(p, this.transform);
        return p;
    }
}
class $5942e8eb8ca60ef8$export$245847d31c09154f extends $5942e8eb8ca60ef8$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $5942e8eb8ca60ef8$export$f67aae4532d8295b(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $5942e8eb8ca60ef8$export$61b52d3570d24719(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $5942e8eb8ca60ef8$export$b1c11df0696253ae(url) {
    [url] = url.split(/[#?]/, 1);
    return url.substring(url.lastIndexOf("/") + 1);
}
function $5942e8eb8ca60ef8$export$9de51790aa4bc73a(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($5942e8eb8ca60ef8$export$f67aae4532d8295b(url)) {
        $5942e8eb8ca60ef8$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const getURL = (urlString)=>{
        try {
            return new URL(urlString);
        } catch  {
            try {
                return new URL(decodeURIComponent(urlString));
            } catch  {
                try {
                    return new URL(urlString, "https://foo.bar");
                } catch  {
                    try {
                        return new URL(decodeURIComponent(urlString), "https://foo.bar");
                    } catch  {
                        return null;
                    }
                }
            }
        }
    };
    const newURL = getURL(url);
    if (!newURL) return defaultFilename;
    const decode = (name)=>{
        try {
            let decoded = decodeURIComponent(name);
            if (decoded.includes("/")) {
                decoded = decoded.split("/").at(-1);
                if (decoded.test(/^\.pdf$/i)) return decoded;
                return name;
            }
            return decoded;
        } catch  {
            return name;
        }
    };
    const pdfRegex = /\.pdf$/i;
    const filename = newURL.pathname.split("/").at(-1);
    if (pdfRegex.test(filename)) return decode(filename);
    if (newURL.searchParams.size > 0) {
        const values = Array.from(newURL.searchParams.values()).reverse();
        for (const value of values){
            if (pdfRegex.test(value)) return decode(value);
        }
        const keys = Array.from(newURL.searchParams.keys()).reverse();
        for (const key of keys){
            if (pdfRegex.test(key)) return decode(key);
        }
    }
    if (newURL.hash) {
        const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        const hashFilename = reFilename.exec(newURL.hash);
        if (hashFilename) return decode(hashFilename[0]);
    }
    return defaultFilename;
}
class $5942e8eb8ca60ef8$var$StatTimer {
    started = Object.create(null);
    times = [];
    time(name) {
        if (name in this.started) $5942e8eb8ca60ef8$var$warn(`Timer is already running for ${name}`);
        this.started[name] = Date.now();
    }
    timeEnd(name) {
        if (!(name in this.started)) $5942e8eb8ca60ef8$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.started[name],
            end: Date.now()
        });
        delete this.started[name];
    }
    toString() {
        const outBuf = [];
        let longest = 0;
        for (const { name: name } of this.times)longest = Math.max(name.length, longest);
        for (const { name: name, start: start, end: end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
        return outBuf.join("");
    }
}
function $5942e8eb8ca60ef8$var$isValidFetchUrl(url, baseUrl) {
    const res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return res?.protocol === "http:" || res?.protocol === "https:";
}
function $5942e8eb8ca60ef8$export$455b7811f904cadc(e) {
    e.preventDefault();
}
function $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $5942e8eb8ca60ef8$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
class $5942e8eb8ca60ef8$export$66cbc314498fffc {
    static #regex;
    static toDateObject(input) {
        if (input instanceof Date) return input;
        if (!input || typeof input !== "string") return null;
        this.#regex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = this.#regex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $5942e8eb8ca60ef8$export$dd5d6edf3fc80aae(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
    const { width: width, height: height } = xfaPage.attributes.style;
    const viewBox = [
        0,
        0,
        parseInt(width),
        parseInt(height)
    ];
    return new $5942e8eb8ca60ef8$var$PageViewport({
        viewBox: viewBox,
        userUnit: 1,
        scale: scale,
        rotation: rotation
    });
}
function $5942e8eb8ca60ef8$export$2a2e9b507863ddda(color) {
    if (color.startsWith("#")) {
        const colorRGB = parseInt(color.slice(1), 16);
        return [
            (colorRGB & 0xff0000) >> 16,
            (colorRGB & 0x00ff00) >> 8,
            colorRGB & 0x0000ff
        ];
    }
    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
    $5942e8eb8ca60ef8$var$warn(`Not a valid color format: "${color}"`);
    return [
        0,
        0,
        0
    ];
}
function $5942e8eb8ca60ef8$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $5942e8eb8ca60ef8$export$2a2e9b507863ddda(computedColor));
    }
    span.remove();
}
function $5942e8eb8ca60ef8$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $5942e8eb8ca60ef8$export$af0a15a86e590226(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $5942e8eb8ca60ef8$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const useRound = $5942e8eb8ca60ef8$export$5fb8891d35c36978.isCSSRoundSupported;
        const w = `var(--total-scale-factor) * ${pageWidth}px`, h = `var(--total-scale-factor) * ${pageHeight}px`;
        const widthStr = useRound ? `round(down, ${w}, var(--scale-round-x))` : `calc(${w})`, heightStr = useRound ? `round(down, ${h}, var(--scale-round-y))` : `calc(${h})`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $5942e8eb8ca60ef8$export$f16a99f63bccd50b {
    constructor(){
        const { pixelRatio: pixelRatio } = $5942e8eb8ca60ef8$export$f16a99f63bccd50b;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    get scaled() {
        return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
        return this.sx === this.sy;
    }
    limitCanvas(width, height, maxPixels, maxDim, capAreaFactor = -1) {
        let maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        maxPixels = $5942e8eb8ca60ef8$export$f16a99f63bccd50b.capPixels(maxPixels, capAreaFactor);
        if (maxPixels > 0) maxAreaScale = Math.sqrt(maxPixels / (width * height));
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        const maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    }
    static get pixelRatio() {
        return globalThis.devicePixelRatio || 1;
    }
    static capPixels(maxPixels, capAreaFactor) {
        if (capAreaFactor >= 0) {
            const winPixels = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + capAreaFactor / 100));
            return maxPixels > 0 ? Math.min(maxPixels, winPixels) : winPixels;
        }
        return maxPixels;
    }
}
const $5942e8eb8ca60ef8$export$3234c88e9de64a88 = [
    "image/apng",
    "image/avif",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "image/x-icon"
];
class $5942e8eb8ca60ef8$var$ColorScheme {
    static get isDarkMode() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isDarkMode", !!window?.matchMedia?.("(prefers-color-scheme: dark)").matches);
    }
}
class $5942e8eb8ca60ef8$export$cec677744f6a5015 {
    static get commentForegroundColor() {
        const element = document.createElement("span");
        element.classList.add("comment", "sidebar");
        const { style: style } = element;
        style.width = style.height = "0";
        style.display = "none";
        style.color = "var(--comment-fg-color)";
        document.body.append(element);
        const { color: color } = window.getComputedStyle(element);
        element.remove();
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "commentForegroundColor", $5942e8eb8ca60ef8$export$2a2e9b507863ddda(color));
    }
}
function $5942e8eb8ca60ef8$export$f8d1472813e87bf9(r, g, b, opacity) {
    opacity = Math.min(Math.max(opacity ?? 1, 0), 1);
    const white = 255 * (1 - opacity);
    r = Math.round(r * opacity + white);
    g = Math.round(g * opacity + white);
    b = Math.round(b * opacity + white);
    return [
        r,
        g,
        b
    ];
}
function $5942e8eb8ca60ef8$var$RGBToHSL(rgb, output) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) output[0] = output[1] = 0;
    else {
        const d = max - min;
        output[1] = l < 0.5 ? d / (max + min) : d / (2 - max - min);
        switch(max){
            case r:
                output[0] = ((g - b) / d + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                output[0] = ((b - r) / d + 2) * 60;
                break;
            case b:
                output[0] = ((r - g) / d + 4) * 60;
                break;
        }
    }
    output[2] = l;
}
function $5942e8eb8ca60ef8$var$HSLToRGB(hsl, output) {
    const h = hsl[0];
    const s = hsl[1];
    const l = hsl[2];
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    switch(Math.floor(h / 60)){
        case 0:
            output[0] = c + m;
            output[1] = x + m;
            output[2] = m;
            break;
        case 1:
            output[0] = x + m;
            output[1] = c + m;
            output[2] = m;
            break;
        case 2:
            output[0] = m;
            output[1] = c + m;
            output[2] = x + m;
            break;
        case 3:
            output[0] = m;
            output[1] = x + m;
            output[2] = c + m;
            break;
        case 4:
            output[0] = x + m;
            output[1] = m;
            output[2] = c + m;
            break;
        case 5:
        case 6:
            output[0] = c + m;
            output[1] = m;
            output[2] = x + m;
            break;
    }
}
function $5942e8eb8ca60ef8$var$computeLuminance(x) {
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
}
function $5942e8eb8ca60ef8$var$contrastRatio(hsl1, hsl2, output) {
    $5942e8eb8ca60ef8$var$HSLToRGB(hsl1, output);
    output.map($5942e8eb8ca60ef8$var$computeLuminance);
    const lum1 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    $5942e8eb8ca60ef8$var$HSLToRGB(hsl2, output);
    output.map($5942e8eb8ca60ef8$var$computeLuminance);
    const lum2 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    return lum1 > lum2 ? (lum1 + 0.05) / (lum2 + 0.05) : (lum2 + 0.05) / (lum1 + 0.05);
}
const $5942e8eb8ca60ef8$var$contrastCache = new Map();
function $5942e8eb8ca60ef8$export$7a96203b1fdebe8d(baseColor, fixedColor) {
    const key = baseColor[0] + baseColor[1] * 0x100 + baseColor[2] * 0x10000 + fixedColor[0] * 0x1000000 + fixedColor[1] * 0x100000000 + fixedColor[2] * 0x10000000000;
    let cachedValue = $5942e8eb8ca60ef8$var$contrastCache.get(key);
    if (cachedValue) return cachedValue;
    const array = new Float32Array(9);
    const output = array.subarray(0, 3);
    const baseHSL = array.subarray(3, 6);
    $5942e8eb8ca60ef8$var$RGBToHSL(baseColor, baseHSL);
    const fixedHSL = array.subarray(6, 9);
    $5942e8eb8ca60ef8$var$RGBToHSL(fixedColor, fixedHSL);
    const isFixedColorDark = fixedHSL[2] < 0.5;
    const minContrast = isFixedColorDark ? 12 : 4.5;
    baseHSL[2] = isFixedColorDark ? Math.sqrt(baseHSL[2]) : 1 - Math.sqrt(1 - baseHSL[2]);
    if ($5942e8eb8ca60ef8$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) {
        let start, end;
        if (isFixedColorDark) {
            start = baseHSL[2];
            end = 1;
        } else {
            start = 0;
            end = baseHSL[2];
        }
        const PRECISION = 0.005;
        while(end - start > PRECISION){
            const mid = baseHSL[2] = (start + end) / 2;
            if (isFixedColorDark === $5942e8eb8ca60ef8$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) start = mid;
            else end = mid;
        }
        baseHSL[2] = isFixedColorDark ? end : start;
    }
    $5942e8eb8ca60ef8$var$HSLToRGB(baseHSL, output);
    cachedValue = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(Math.round(output[0] * 255), Math.round(output[1] * 255), Math.round(output[2] * 255));
    $5942e8eb8ca60ef8$var$contrastCache.set(key, cachedValue);
    return cachedValue;
}
function $5942e8eb8ca60ef8$export$611c480766035c4({ html: html, dir: dir, className: className }, container) {
    const fragment = document.createDocumentFragment();
    if (typeof html === "string") {
        const p = document.createElement("p");
        p.dir = dir || "auto";
        const lines = html.split(/(?:\r\n?|\n)/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        fragment.append(p);
    } else $5942e8eb8ca60ef8$export$f6af20c312d4b9a2.render({
        xfaHtml: html,
        div: fragment,
        intent: "richText"
    });
    fragment.firstChild.classList.add("richText", className);
    container.append(fragment);
}
class $5942e8eb8ca60ef8$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    #altText = null;
    #comment = null;
    #commentButtonDivider = null;
    #signatureDescriptionButton = null;
    static #l10nRemove = null;
    constructor(editor){
        this.#editor = editor;
        $5942e8eb8ca60ef8$var$EditorToolbar.#l10nRemove ||= Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        });
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            editToolbar.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
                signal: signal
            });
            editToolbar.addEventListener("pointerdown", $5942e8eb8ca60ef8$var$EditorToolbar.#pointerDown, {
                signal: signal
            });
        }
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        return editToolbar;
    }
    get div() {
        return this.#toolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return false;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        return true;
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
        this.#altText?.shown();
        this.#comment?.shown();
    }
    addDeleteButton() {
        const { editorType: editorType, _uiManager: _uiManager } = this.#editor;
        const button = document.createElement("button");
        button.classList.add("basic", "deleteButton");
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$EditorToolbar.#l10nRemove[editorType]);
        if (this.#addListenersToElement(button)) button.addEventListener("click", (e)=>{
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    async addAltText(altText) {
        const button = await altText.render();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
        this.#altText = altText;
    }
    addComment(comment, beforeElement = null) {
        if (this.#comment) return;
        const button = comment.renderForToolbar();
        if (!button) return;
        this.#addListenersToElement(button);
        const divider = this.#commentButtonDivider = this.#divider;
        if (!beforeElement) this.#buttons.append(button, divider);
        else {
            this.#buttons.insertBefore(button, beforeElement);
            this.#buttons.insertBefore(divider, beforeElement);
        }
        this.#comment = comment;
        comment.toolbar = this;
    }
    addColorPicker(colorPicker) {
        if (this.#colorPicker) return;
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    async addEditSignatureButton(signatureManager) {
        const button = this.#signatureDescriptionButton = await signatureManager.renderEditButton(this.#editor);
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    removeButton(name) {
        switch(name){
            case "comment":
                this.#comment?.removeToolbarCommentButton();
                this.#comment = null;
                this.#commentButtonDivider?.remove();
                this.#commentButtonDivider = null;
                break;
        }
    }
    async addButton(name, tool) {
        switch(name){
            case "colorPicker":
                this.addColorPicker(tool);
                break;
            case "altText":
                await this.addAltText(tool);
                break;
            case "editSignature":
                await this.addEditSignatureButton(tool);
                break;
            case "delete":
                this.addDeleteButton();
                break;
            case "comment":
                this.addComment(tool);
                break;
        }
    }
    async addButtonBefore(name, tool, beforeSelector) {
        const beforeElement = this.#buttons.querySelector(beforeSelector);
        if (!beforeElement) return;
        if (name === "comment") this.addComment(tool, beforeElement);
    }
    updateEditSignatureButton(description) {
        if (this.#signatureDescriptionButton) this.#signatureDescriptionButton.title = description;
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $5942e8eb8ca60ef8$var$FloatingToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) editToolbar.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        if (this.#uiManager.hasCommentManager()) this.#makeButton("commentButton", `pdfjs-comment-floating-button`, "pdfjs-comment-floating-button-label", ()=>{
            this.#uiManager.commentSelection("floating_button");
        });
        this.#makeButton("highlightButton", `pdfjs-highlight-floating-button1`, "pdfjs-highlight-floating-button-label", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        });
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #makeButton(buttonClass, l10nId, labelL10nId, clickHandler) {
        const button = document.createElement("button");
        button.classList.add("basic", buttonClass);
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", l10nId);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", labelL10nId);
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            button.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
                signal: signal
            });
            button.addEventListener("click", clickHandler, {
                signal: signal
            });
        }
        this.#buttons.append(button);
    }
}
function $5942e8eb8ca60ef8$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
class $5942e8eb8ca60ef8$var$IdManager {
    #id = 0;
    get id() {
        return `${$5942e8eb8ca60ef8$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $5942e8eb8ca60ef8$var$ImageManager {
    #baseId = $5942e8eb8ca60ef8$export$75f13a91ebdf8eb3();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $5942e8eb8ca60ef8$export$8134c072fddab6a5(rawData, "blob");
            } else if (rawData instanceof File) image = data.file = rawData;
            else if (rawData instanceof Blob) image = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $5942e8eb8ca60ef8$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            $5942e8eb8ca60ef8$var$warn(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromBlob(id, blobPromise) {
        const blob = await blobPromise;
        return this.#get(id, blob);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        if (data.blobPromise) {
            const { blobPromise: blobPromise } = data;
            delete data.blobPromise;
            return this.getFromBlob(data.id, blobPromise);
        }
        return this.getFromUrl(data.url);
    }
    getFromCanvas(id, canvas) {
        this.#cache ||= new Map();
        let data = this.#cache.get(id);
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        const ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: `image_${this.#baseId}_${this.#id++}`,
            refCounter: 1,
            isSvg: false
        };
        this.#cache.set(id, data);
        this.#cache.set(data.id, data);
        return data;
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        const { bitmap: bitmap } = data;
        if (!data.url && !data.file) {
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            const ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        bitmap.close?.();
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $5942e8eb8ca60ef8$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    cleanType(type) {
        if (this.#position === -1) return;
        for(let i = this.#position; i >= 0; i--)if (this.#commands[i].type !== type) {
            this.#commands.splice(i + 1, this.#position - i);
            this.#position = i;
            return;
        }
        this.#commands.length = 0;
        this.#position = -1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $5942e8eb8ca60ef8$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(event);
    }
}
class $5942e8eb8ca60ef8$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $5942e8eb8ca60ef8$var$getColorValues(colors);
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $5942e8eb8ca60ef8$export$2a2e9b507863ddda(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $5942e8eb8ca60ef8$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...rgb);
    }
}
class $5942e8eb8ca60ef8$export$26cb16552a82cf63 {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditableAnnotations = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $5942e8eb8ca60ef8$var$CommandManager();
    #commentManager = null;
    #copyPasteAC = null;
    #currentDrawingSession = null;
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    _editorUndoBar = null;
    #enableHighlightFloatingButton = false;
    #enableUpdatedAddImage = false;
    #enableNewAltTextWhenAddingImage = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #focusManagerAC = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #floatingToolbar = null;
    #idManager = new $5942e8eb8ca60ef8$var$IdManager();
    #isEnabled = false;
    #isPointerDown = false;
    #isWaiting = false;
    #keyboardManagerAC = null;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #missingCanvases = null;
    #mlManager = null;
    #mode = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #signatureManager = null;
    #pageColors = null;
    #showAllStates = null;
    #pdfDocument = null;
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    #viewerAlert = null;
    #updateModeCapability = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $5942e8eb8ca60ef8$export$26cb16552a82cf63.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_keyboardManager", new $5942e8eb8ca60ef8$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, viewerAlert, altTextManager, commentManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom){
        const signal = this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#viewerAlert = viewerAlert;
        this.#altTextManager = altTextManager;
        this.#commentManager = commentManager;
        this.#signatureManager = signatureManager;
        this.#pdfDocument = pdfDocument;
        this._eventBus = eventBus;
        eventBus._on("editingaction", this.onEditingAction.bind(this), {
            signal: signal
        });
        eventBus._on("pagechanging", this.onPageChanging.bind(this), {
            signal: signal
        });
        eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
            signal: signal
        });
        eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
            signal: signal
        });
        eventBus._on("setpreference", this.onSetPreference.bind(this), {
            signal: signal
        });
        eventBus._on("switchannotationeditorparams", (evt)=>this.updateParams(evt.type, evt.value), {
            signal: signal
        });
        window.addEventListener("pointerdown", ()=>{
            this.#isPointerDown = true;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("pointerup", ()=>{
            this.#isPointerDown = false;
        }, {
            capture: true,
            signal: signal
        });
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#enableUpdatedAddImage = enableUpdatedAddImage;
        this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $5942e8eb8ca60ef8$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
        commentManager?.setSidebarUiManager(this);
    }
    destroy() {
        this.#updateModeCapability?.resolve();
        this.#updateModeCapability = null;
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#missingCanvases?.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#commentManager?.destroy();
        this.#signatureManager?.destroy();
        this.#floatingToolbar?.hide();
        this.#floatingToolbar = null;
        this.#mainHighlightColorPicker?.destroy();
        this.#mainHighlightColorPicker = null;
        this.#allEditableAnnotations = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
        this._editorUndoBar?.destroy();
        this.#pdfDocument = null;
    }
    combinedSignal(ac) {
        return AbortSignal.any([
            this._signal,
            ac.signal
        ]);
    }
    get mlManager() {
        return this.#mlManager;
    }
    get useNewAltTextFlow() {
        return this.#enableUpdatedAddImage;
    }
    get useNewAltTextWhenAddingImage() {
        return this.#enableNewAltTextWhenAddingImage;
    }
    get hcmFilter() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "direction", getComputedStyle(this.#container).direction);
    }
    get _highlightColors() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>{
            pair = pair.split("=").map((x)=>x.trim());
            pair[1] = pair[1].toUpperCase();
            return pair;
        })) : null);
    }
    get highlightColors() {
        const { _highlightColors: _highlightColors } = this;
        if (!_highlightColors) return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "highlightColors", null);
        const map = new Map();
        const hasHCM = !!this.#pageColors;
        for (const [name, color] of _highlightColors){
            const isNameForHCM = name.endsWith("_HCM");
            if (hasHCM && isNameForHCM) {
                map.set(name.replace("_HCM", ""), color);
                continue;
            }
            if (!hasHCM && !isNameForHCM) map.set(name, color);
        }
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "highlightColors", map);
    }
    get highlightColorNames() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    getNonHCMColor(color) {
        if (!this._highlightColors) return color;
        const colorName = this.highlightColorNames.get(color);
        return this._highlightColors.get(colorName) || color;
    }
    getNonHCMColorName(color) {
        return this.highlightColorNames.get(color) || color;
    }
    setCurrentDrawingSession(layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        } else this.disableUserSelect(false);
        this.#currentDrawingSession = layer;
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor, firstTime = false) {
        this.#altTextManager?.editAltText(this, editor, firstTime);
    }
    hasCommentManager() {
        return !!this.#commentManager;
    }
    editComment(editor, posX, posY, options) {
        this.#commentManager?.showDialog(this, editor, posX, posY, options);
    }
    selectComment(pageIndex, uid) {
        const layer = this.#allLayers.get(pageIndex);
        const editor = layer?.getEditorByUID(uid);
        editor?.toggleComment(true, true);
    }
    updateComment(editor) {
        this.#commentManager?.updateComment(editor.getData());
    }
    updatePopupColor(editor) {
        this.#commentManager?.updatePopupColor(editor);
    }
    removeComment(editor) {
        this.#commentManager?.removeComments([
            editor.uid
        ]);
    }
    toggleComment(editor, isSelected, visibility) {
        this.#commentManager?.toggleCommentPopup(editor, isSelected, visibility);
    }
    makeCommentColor(color, opacity) {
        return color && this.#commentManager?.makeCommentColor(color, opacity) || null;
    }
    getCommentDialogElement() {
        return this.#commentManager?.dialogElement || null;
    }
    async waitForEditorsRendered(pageNumber) {
        if (this.#allLayers.has(pageNumber - 1)) return;
        const { resolve: resolve, promise: promise } = Promise.withResolvers();
        const onEditorsRendered = (evt)=>{
            if (evt.pageNumber === pageNumber) {
                this._eventBus._off("editorsrendered", onEditorsRendered);
                resolve();
            }
        };
        this._eventBus.on("editorsrendered", onEditorsRendered);
        await promise;
    }
    getSignature(editor) {
        this.#signatureManager?.getSignature({
            uiManager: this,
            editor: editor
        });
    }
    get signatureManager() {
        return this.#signatureManager;
    }
    switchToMode(mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    }
    setPreference(name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    }
    onSetPreference({ name: name, value: value }) {
        switch(name){
            case "enableNewAltTextWhenAddingImage":
                this.#enableNewAltTextWhenAddingImage = value;
                break;
        }
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $5942e8eb8ca60ef8$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
        this.#currentDrawingSession?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    #getLayerForTextLayer(textLayer) {
        const { currentLayer: currentLayer } = this;
        if (currentLayer.hasTextLayer(textLayer)) return currentLayer;
        for (const layer of this.#allLayers.values()){
            if (layer.hasTextLayer(textLayer)) return layer;
        }
        return null;
    }
    highlightSelection(methodOfCreation = "", comment = false) {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        const layer = this.#getLayerForTextLayer(textLayer);
        const isNoneMode = this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE;
        const callback = ()=>{
            const editor = layer?.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) this.showAllEditors("highlight", true, true);
            if (comment) editor?.editComment();
        };
        if (isNoneMode) {
            this.switchToMode($5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT, callback);
            return;
        }
        callback();
    }
    commentSelection(methodOfCreation = "") {
        this.highlightSelection(methodOfCreation, true);
    }
    #displayFloatingToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#floatingToolbar ||= new $5942e8eb8ca60ef8$var$FloatingToolbar(this);
        this.#floatingToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    getAndRemoveDataFromAnnotationStorage(annotationId) {
        if (!this.#annotationStorage) return null;
        const key = `${$5942e8eb8ca60ef8$var$AnnotationEditorPrefix}${annotationId}`;
        const storedValue = this.#annotationStorage.getRawValue(key);
        if (storedValue) this.#annotationStorage.remove(key);
        return storedValue;
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    a11yAlert(messageId, args = null) {
        const viewerAlert = this.#viewerAlert;
        if (!viewerAlert) return;
        viewerAlert.setAttribute("data-l10n-id", messageId);
        if (args) viewerAlert.setAttribute("data-l10n-args", JSON.stringify(args));
        else viewerAlert.removeAttribute("data-l10n-args");
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#floatingToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT && this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE) return;
        if (this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const activeLayer = this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT ? this.#getLayerForTextLayer(textLayer) : null;
            activeLayer?.toggleDrawing();
            if (this.#isPointerDown) {
                const ac = new AbortController();
                const signal = this.combinedSignal(ac);
                const pointerup = (e)=>{
                    if (e.type === "pointerup" && e.button !== 0) return;
                    ac.abort();
                    activeLayer?.toggleDrawing(true);
                    if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
                };
                window.addEventListener("pointerup", pointerup, {
                    signal: signal
                });
                window.addEventListener("blur", pointerup, {
                    signal: signal
                });
            } else {
                activeLayer?.toggleDrawing(true);
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayFloatingToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        if (this.#focusManagerAC) return;
        this.#focusManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#focusManagerAC);
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }
    #removeFocusManager() {
        this.#focusManagerAC?.abort();
        this.#focusManagerAC = null;
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        if (this.#keyboardManagerAC) return;
        this.#keyboardManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#keyboardManagerAC);
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        this.#keyboardManagerAC?.abort();
        this.#keyboardManagerAC = null;
    }
    #addCopyPasteListeners() {
        if (this.#copyPasteAC) return;
        this.#copyPasteAC = new AbortController();
        const signal = this.combinedSignal(this.#copyPasteAC);
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        this.#copyPasteAC?.abort();
        this.#copyPasteAC = null;
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.#addCopyPasteListeners();
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.#removeCopyPasteListeners();
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    async paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $5942e8eb8ca60ef8$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = await layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $5942e8eb8ca60ef8$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE && !this.isEditorHandlingKeyboard) $5942e8eb8ca60ef8$export$26cb16552a82cf63._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
            case "commentSelection":
                this.commentSelection("context_menu");
                break;
        }
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    async updateMode(mode, editId = null, isFromKeyboard = false, mustEnterInEditMode = false, editComment = false) {
        if (this.#mode === mode) return;
        if (this.#updateModeCapability) {
            await this.#updateModeCapability.promise;
            if (!this.#updateModeCapability) return;
        }
        this.#updateModeCapability = Promise.withResolvers();
        this.#currentDrawingSession?.commitOrRemove();
        if (this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.POPUP) this.#commentManager?.hideSidebar();
        this.#commentManager?.destroyPopup();
        this.#mode = mode;
        if (mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            for (const editor of this.#allEditors.values())editor.hideStandaloneCommentButton();
            this._editorUndoBar?.hide();
            this.toggleComment(null);
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())editor.addStandaloneCommentButton();
        if (mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.SIGNATURE) await this.#signatureManager?.loadSignatures();
        this.setEditingState(true);
        await this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.POPUP) {
            this.#allEditableAnnotations ||= await this.#pdfDocument.getAnnotationsByType(new Set(this.#editorTypes.map((editorClass)=>editorClass._editorType)));
            const elementIds = new Set();
            const allComments = [];
            for (const editor of this.#allEditors.values()){
                const { annotationElementId: annotationElementId, hasComment: hasComment, deleted: deleted } = editor;
                if (annotationElementId) elementIds.add(annotationElementId);
                if (hasComment && !deleted) allComments.push(editor.getData());
            }
            for (const annotation of this.#allEditableAnnotations){
                const { id: id, popupRef: popupRef, contentsObj: contentsObj } = annotation;
                if (popupRef && contentsObj?.str && !elementIds.has(id) && !this.#deletedAnnotationsElementIds.has(id)) allComments.push(annotation);
            }
            this.#commentManager?.showSidebar(allComments);
        }
        if (!editId) {
            if (isFromKeyboard) this.addNewEditorFromKeyboard();
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())if (editor.uid === editId) {
            this.setSelected(editor);
            if (editComment) editor.editComment();
            else if (mustEnterInEditMode) editor.enterInEditMode();
            else editor.focus();
        } else editor.unselect();
        this.#updateModeCapability.resolve();
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(options) {
        if (options.mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            ...options
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        if (this.hasSelection) for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        else for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    async #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            const promises = [];
            for (const layer of this.#allLayers.values())promises.push(layer.enable());
            await Promise.all(promises);
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    *getEditors(pageIndex) {
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) yield editor;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        if (editor.annotationElementId) this.#missingCanvases?.delete(editor.annotationElementId);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    updateUIForDefaultProperties(editorType) {
        this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        this.updateToolbar({
            mode: editor.mode,
            editId: editor.id
        });
        this.#currentDrawingSession?.commitOrRemove();
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
        this._editorUndoBar?.hide();
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    cleanUndoStack(type) {
        this.#commandManager.cleanType(type);
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        const drawingEditor = this.currentLayer?.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) return;
        const editors = drawingEditor ? [
            drawingEditor
        ] : [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE) return;
        }
        if (this.#currentDrawingSession?.commitOrRemove()) return;
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(totalX, totalY);
                        editor.translationDone();
                    }
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(-totalX, -totalY);
                        editor.translationDone();
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors){
            editor.translateInPage(x, y);
            editor.translationDone();
        }
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    isEditingMode() {
        return this.#mode !== $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE;
    }
    get imageManager() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "imageManager", new $5942e8eb8ca60ef8$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
    setMissingCanvas(annotationId, annotationElementId, canvas) {
        const editor = this.#missingCanvases?.get(annotationId);
        if (!editor) return;
        editor.setCanvas(annotationElementId, canvas);
        this.#missingCanvases.delete(annotationId);
    }
    addMissingCanvas(annotationId, editor) {
        (this.#missingCanvases ||= new Map()).set(annotationId, editor);
    }
}
class $5942e8eb8ca60ef8$var$AltText {
    #altText = null;
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextButtonLabel = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #badge = null;
    #editor = null;
    #guessedText = null;
    #textWithDisclaimer = null;
    #useNewAltTextFlow = false;
    static #l10nNewButton = null;
    static _l10n = null;
    constructor(editor){
        this.#editor = editor;
        this.#useNewAltTextFlow = editor._uiManager.useNewAltTextFlow;
        $5942e8eb8ca60ef8$var$AltText.#l10nNewButton ||= Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        });
    }
    static initialize(l10n) {
        $5942e8eb8ca60ef8$var$AltText._l10n ??= l10n;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        altText.tabIndex = "0";
        const label = this.#altTextButtonLabel = document.createElement("span");
        altText.append(label);
        if (this.#useNewAltTextFlow) {
            altText.classList.add("new");
            altText.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AltText.#l10nNewButton.missing);
            label.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AltText.#l10nNewButton["missing-label"]);
        } else {
            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
        }
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
            if (this.#useNewAltTextFlow) this.#editor._reportTelemetry({
                action: "pdfjs.image.alt_text.image_status_label_clicked",
                data: {
                    label: this.#label
                }
            });
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    get #label() {
        return this.#altText && "added" || this.#altText === null && this.guessedText && "review" || "missing";
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        if (this.#useNewAltTextFlow) return this.#altText === null;
        return !this.#altText && !this.#altTextDecorative;
    }
    hasData() {
        if (this.#useNewAltTextFlow) return this.#altText !== null || !!this.#guessedText;
        return this.isEmpty();
    }
    get guessedText() {
        return this.#guessedText;
    }
    async setGuessedText(guessedText) {
        if (this.#altText !== null) return;
        this.#guessedText = guessedText;
        this.#textWithDisclaimer = await $5942e8eb8ca60ef8$var$AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
            generatedAltText: guessedText
        });
        this.#setState();
    }
    toggleAltTextBadge(visibility = false) {
        if (!this.#useNewAltTextFlow || this.#altText) {
            this.#badge?.remove();
            this.#badge = null;
            return;
        }
        if (!this.#badge) {
            const badge = this.#badge = document.createElement("div");
            badge.className = "noAltTextBadge";
            this.#editor.div.append(badge);
        }
        this.#badge.classList.toggle("hidden", !visibility);
    }
    serialize(isForCopying) {
        let altText = this.#altText;
        if (!isForCopying && this.#guessedText === altText) altText = this.#textWithDisclaimer;
        return {
            altText: altText,
            decorative: this.#altTextDecorative,
            guessedText: this.#guessedText,
            textWithDisclaimer: this.#textWithDisclaimer
        };
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative, guessedText: guessedText, textWithDisclaimer: textWithDisclaimer, cancel: cancel = false }) {
        if (guessedText) {
            this.#guessedText = guessedText;
            this.#textWithDisclaimer = textWithDisclaimer;
        }
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        if (!cancel) {
            this.#altText = altText;
            this.#altTextDecorative = decorative;
        }
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    shown() {
        this.#editor._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: this.#label
            }
        });
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextButtonLabel = null;
        this.#altTextTooltip = null;
        this.#badge?.remove();
        this.#badge = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (this.#useNewAltTextFlow) {
            button.classList.toggle("done", !!this.#altText);
            button.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AltText.#l10nNewButton[this.#label]);
            this.#altTextButtonLabel?.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AltText.#l10nNewButton[`${this.#label}-label`]);
            if (!this.#altText) {
                this.#altTextTooltip?.remove();
                return;
            }
        } else {
            if (!this.#altText && !this.#altTextDecorative) {
                button.classList.remove("done");
                this.#altTextTooltip?.remove();
                return;
            }
            button.classList.add("done");
            button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        }
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        if (this.#altTextDecorative) tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
        else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = this.#altText;
        }
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getElementForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $5942e8eb8ca60ef8$var$Comment {
    #commentStandaloneButton = null;
    #commentToolbarButton = null;
    #commentWasFromKeyBoard = false;
    #editor = null;
    #initialText = null;
    #richText = null;
    #text = null;
    #date = null;
    #deleted = false;
    #popupPosition = null;
    constructor(editor){
        this.#editor = editor;
    }
    renderForToolbar() {
        const button = this.#commentToolbarButton = document.createElement("button");
        button.className = "comment";
        return this.#render(button, false);
    }
    renderForStandalone() {
        const button = this.#commentStandaloneButton = document.createElement("button");
        button.className = "annotationCommentButton";
        const position = this.#editor.commentButtonPosition;
        if (position) {
            const { style: style } = button;
            style.insetInlineEnd = `calc(${100 * (this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0])}% - var(--comment-button-dim))`;
            style.top = `calc(${100 * position[1]}% - var(--comment-button-dim))`;
            const color = this.#editor.commentButtonColor;
            if (color) style.backgroundColor = color;
        }
        return this.#render(button, true);
    }
    focusButton() {
        setTimeout(()=>{
            (this.#commentStandaloneButton ?? this.#commentToolbarButton)?.focus();
        }, 0);
    }
    onUpdatedColor() {
        if (!this.#commentStandaloneButton) return;
        const color = this.#editor.commentButtonColor;
        if (color) this.#commentStandaloneButton.style.backgroundColor = color;
        this.#editor._uiManager.updatePopupColor(this.#editor);
    }
    get commentButtonWidth() {
        return (this.#commentStandaloneButton?.getBoundingClientRect().width ?? 0) / this.#editor.parent.boundingClientRect.width;
    }
    get commentPopupPositionInLayer() {
        if (this.#popupPosition) return this.#popupPosition;
        if (!this.#commentStandaloneButton) return null;
        const { x: x, y: y, height: height } = this.#commentStandaloneButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#editor.parent.boundingClientRect;
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPositionInLayer(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    removeStandaloneCommentButton() {
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
    }
    removeToolbarCommentButton() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentStandaloneButton) return;
        this.#commentStandaloneButton.classList.toggle("selected", selected);
        this.#commentStandaloneButton.ariaExpanded = hasPopup;
    }
    #render(comment, isStandalone) {
        if (!this.#editor._uiManager.hasCommentManager()) return null;
        comment.tabIndex = "0";
        comment.ariaHasPopup = "dialog";
        if (isStandalone) {
            comment.ariaControls = "commentPopup";
            comment.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
        } else {
            comment.ariaControlsElements = [
                this.#editor._uiManager.getCommentDialogElement()
            ];
            comment.setAttribute("data-l10n-id", "pdfjs-editor-edit-comment-button");
        }
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return comment;
        comment.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        if (isStandalone) {
            comment.addEventListener("focusin", (e)=>{
                this.#editor._focusEventsAllowed = false;
                $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
            comment.addEventListener("focusout", (e)=>{
                this.#editor._focusEventsAllowed = true;
                $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
        }
        comment.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            if (comment === this.#commentToolbarButton) this.edit();
            else this.#editor.toggleComment(true);
        };
        comment.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        comment.addEventListener("keydown", (event)=>{
            if (event.target === comment && event.key === "Enter") {
                this.#commentWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        comment.addEventListener("pointerenter", ()=>{
            this.#editor.toggleComment(false, true);
        }, {
            signal: signal
        });
        comment.addEventListener("pointerleave", ()=>{
            this.#editor.toggleComment(false, false);
        }, {
            signal: signal
        });
        return comment;
    }
    edit(options) {
        const position = this.commentPopupPositionInLayer;
        let posX, posY;
        if (position) [posX, posY] = position;
        else {
            [posX, posY] = this.#editor.commentButtonPosition;
            const { width: width, height: height, x: x, y: y } = this.#editor;
            posX = x + posX * width;
            posY = y + posY * height;
        }
        const parentDimensions = this.#editor.parent.boundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#editor._uiManager.editComment(this.#editor, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    finish() {
        if (!this.#commentToolbarButton) return;
        this.#commentToolbarButton.focus({
            focusVisible: this.#commentWasFromKeyBoard
        });
        this.#commentWasFromKeyBoard = false;
    }
    isDeleted() {
        return this.#deleted || this.#text === "";
    }
    isEmpty() {
        return this.#text === null;
    }
    hasBeenEdited() {
        return this.isDeleted() || this.#text !== this.#initialText;
    }
    serialize() {
        return this.data;
    }
    get data() {
        return {
            text: this.#text,
            richText: this.#richText,
            date: this.#date,
            deleted: this.isDeleted()
        };
    }
    set data(text) {
        if (text !== this.#text) this.#richText = null;
        if (text === null) {
            this.#text = "";
            this.#deleted = true;
            return;
        }
        this.#text = text;
        this.#date = new Date();
        this.#deleted = false;
    }
    setInitialText(text, richText = null) {
        this.#initialText = text;
        this.data = text;
        this.#date = null;
        this.#richText = richText;
    }
    shown() {}
    destroy() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
        this.#text = "";
        this.#richText = null;
        this.#date = null;
        this.#editor = null;
        this.#commentWasFromKeyBoard = false;
        this.#deleted = false;
    }
}
class $5942e8eb8ca60ef8$export$9ae7542b430d543e {
    #container;
    #isPinching = false;
    #isPinchingStopped = null;
    #isPinchingDisabled;
    #onPinchStart;
    #onPinching;
    #onPinchEnd;
    #pointerDownAC = null;
    #signal;
    #touchInfo = null;
    #touchManagerAC;
    #touchMoveAC = null;
    constructor({ container: container, isPinchingDisabled: isPinchingDisabled = null, isPinchingStopped: isPinchingStopped = null, onPinchStart: onPinchStart = null, onPinching: onPinching = null, onPinchEnd: onPinchEnd = null, signal: signal }){
        this.#container = container;
        this.#isPinchingStopped = isPinchingStopped;
        this.#isPinchingDisabled = isPinchingDisabled;
        this.#onPinchStart = onPinchStart;
        this.#onPinching = onPinching;
        this.#onPinchEnd = onPinchEnd;
        this.#touchManagerAC = new AbortController();
        this.#signal = AbortSignal.any([
            signal,
            this.#touchManagerAC.signal
        ]);
        container.addEventListener("touchstart", this.#onTouchStart.bind(this), {
            passive: false,
            signal: this.#signal
        });
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
        return 35 / $5942e8eb8ca60ef8$export$f16a99f63bccd50b.pixelRatio;
    }
    #onTouchStart(evt) {
        if (this.#isPinchingDisabled?.()) return;
        if (evt.touches.length === 1) {
            if (this.#pointerDownAC) return;
            const pointerDownAC = this.#pointerDownAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                pointerDownAC.signal
            ]);
            const container = this.#container;
            const opts = {
                capture: true,
                signal: signal,
                passive: false
            };
            const cancelPointerDown = (e)=>{
                if (e.pointerType === "touch") {
                    this.#pointerDownAC?.abort();
                    this.#pointerDownAC = null;
                }
            };
            container.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === "touch") {
                    $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
                    cancelPointerDown(e);
                }
            }, opts);
            container.addEventListener("pointerup", cancelPointerDown, opts);
            container.addEventListener("pointercancel", cancelPointerDown, opts);
            return;
        }
        if (!this.#touchMoveAC) {
            this.#touchMoveAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                this.#touchMoveAC.signal
            ]);
            const container = this.#container;
            const opt = {
                signal: signal,
                capture: false,
                passive: false
            };
            container.addEventListener("touchmove", this.#onTouchMove.bind(this), opt);
            const onTouchEnd = this.#onTouchEnd.bind(this);
            container.addEventListener("touchend", onTouchEnd, opt);
            container.addEventListener("touchcancel", onTouchEnd, opt);
            opt.capture = true;
            container.addEventListener("pointerdown", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointermove", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointercancel", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointerup", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, opt);
            this.#onPinchStart?.();
        }
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(evt);
        if (evt.touches.length !== 2 || this.#isPinchingStopped?.()) {
            this.#touchInfo = null;
            return;
        }
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        this.#touchInfo = {
            touch0X: touch0.screenX,
            touch0Y: touch0.screenY,
            touch1X: touch1.screenX,
            touch1Y: touch1.screenY
        };
    }
    #onTouchMove(evt) {
        if (!this.#touchInfo || evt.touches.length !== 2) return;
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(evt);
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        const { screenX: screen0X, screenY: screen0Y } = touch0;
        const { screenX: screen1X, screenY: screen1Y } = touch1;
        const touchInfo = this.#touchInfo;
        const { touch0X: pTouch0X, touch0Y: pTouch0Y, touch1X: pTouch1X, touch1Y: pTouch1Y } = touchInfo;
        const prevGapX = pTouch1X - pTouch0X;
        const prevGapY = pTouch1Y - pTouch0Y;
        const currGapX = screen1X - screen0X;
        const currGapY = screen1Y - screen0Y;
        const distance = Math.hypot(currGapX, currGapY) || 1;
        const pDistance = Math.hypot(prevGapX, prevGapY) || 1;
        if (!this.#isPinching && Math.abs(pDistance - distance) <= $5942e8eb8ca60ef8$export$9ae7542b430d543e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
        touchInfo.touch0X = screen0X;
        touchInfo.touch0Y = screen0Y;
        touchInfo.touch1X = screen1X;
        touchInfo.touch1Y = screen1Y;
        if (!this.#isPinching) {
            this.#isPinching = true;
            return;
        }
        const origin = [
            (screen0X + screen1X) / 2,
            (screen0Y + screen1Y) / 2
        ];
        this.#onPinching?.(origin, pDistance, distance);
    }
    #onTouchEnd(evt) {
        if (evt.touches.length >= 2) return;
        if (this.#touchMoveAC) {
            this.#touchMoveAC.abort();
            this.#touchMoveAC = null;
            this.#onPinchEnd?.();
        }
        if (!this.#touchInfo) return;
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(evt);
        this.#touchInfo = null;
        this.#isPinching = false;
    }
    destroy() {
        this.#touchManagerAC?.abort();
        this.#touchManagerAC = null;
        this.#pointerDownAC?.abort();
        this.#pointerDownAC = null;
    }
}
class $5942e8eb8ca60ef8$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #comment = null;
    #commentStandaloneButton = null;
    #disabled = false;
    #dragPointerId = null;
    #dragPointerType = "";
    #resizersDiv = null;
    #lastPointerCoords = null;
    #savedDimensions = null;
    #fakeAnnotation = null;
    #focusAC = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialRect = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    #touchManager = null;
    isSelected = false;
    _isCopy = false;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    static _l10n = null;
    static _l10nResizer = null;
    #isDraggable = false;
    #zIndex = $5942e8eb8ca60ef8$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $5942e8eb8ca60ef8$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $5942e8eb8ca60ef8$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $5942e8eb8ca60ef8$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $5942e8eb8ca60ef8$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_resizerKeyboardManager", new $5942e8eb8ca60ef8$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $5942e8eb8ca60ef8$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        this.annotationElementId = parameters.annotationElementId || null;
        this.creationDate = parameters.creationDate || new Date();
        this.modificationDate = parameters.modificationDate || null;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
        return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
        return false;
    }
    static get _defaultLineColor() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $5942e8eb8ca60ef8$var$FakeEditor({
            id: editor.parent.getNextId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor._l10n ??= l10n;
        $5942e8eb8ca60ef8$var$AnnotationEditor._l10nResizer ||= Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        });
        if ($5942e8eb8ca60ef8$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $5942e8eb8ca60ef8$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get uid() {
        return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else {
            this.#stopResizing();
            this.#fakeAnnotation?.remove();
            this.#fakeAnnotation = null;
        }
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        if (!this.isInEditMode()) return;
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    _moveAfterPaste(baseX, baseY) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    translationDone() {
        this._onTranslated(this.x, this.y);
    }
    drag(tx, ty) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        const { div: div, parentDimensions: [parentWidth, parentHeight] } = this;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    }
    _onTranslating(x, y) {}
    _onTranslated(x, y) {}
    get _hasBeenMoved() {
        return !!this.#initialRect && (this.#initialRect[0] !== this.x || this.#initialRect[1] !== this.y);
    }
    get _hasBeenResized() {
        return !!this.#initialRect && (this.#initialRect[2] !== this.width || this.#initialRect[3] !== this.height);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $5942e8eb8ca60ef8$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const { div: { style: style }, pageDimensions: [pageWidth, pageHeight] } = this;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = $5942e8eb8ca60ef8$export$b8106b171181a554(x, 0, pageWidth - width);
                y = $5942e8eb8ca60ef8$export$b8106b171181a554(y, 0, pageHeight - height);
                break;
            case 90:
                x = $5942e8eb8ca60ef8$export$b8106b171181a554(x, 0, pageWidth - height);
                y = $5942e8eb8ca60ef8$export$b8106b171181a554(y, width, pageHeight);
                break;
            case 180:
                x = $5942e8eb8ca60ef8$export$b8106b171181a554(x, width, pageWidth);
                y = $5942e8eb8ca60ef8$export$b8106b171181a554(y, height, pageHeight);
                break;
            case 270:
                x = $5942e8eb8ca60ef8$export$b8106b171181a554(x, height, pageWidth);
                y = $5942e8eb8ca60ef8$export$b8106b171181a554(y, 0, pageHeight - width);
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $5942e8eb8ca60ef8$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $5942e8eb8ca60ef8$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        return [
            pageWidth * parentScale,
            pageHeight * parentScale
        ];
    }
    setDims() {
        const { div: { style: style }, width: width, height: height } = this;
        style.width = `${(100 * width).toFixed(2)}%`;
        style.height = `${(100 * height).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        this.#lastPointerCoords = [
            event.screenX,
            event.screenY
        ];
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", this.#resizerPointermove.bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            ac.abort();
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack();
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.setDims();
        this.fixAndSetPosition();
        this._onResized();
    }
    _onResized() {}
    #addResizeToUndoStack() {
        if (!this.#savedDimensions) return;
        const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
        this.#savedDimensions = null;
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: this.#resize.bind(this, newX, newY, newWidth, newHeight),
            undo: this.#resize.bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }
    static _round(x) {
        return Math.round(x * 10000) / 10000;
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $5942e8eb8ca60ef8$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $5942e8eb8ca60ef8$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedX + transfOppositePoint[0]);
        const oppositeY = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let deltaX, deltaY;
        if (!event.fromKeyboard) {
            const { screenX: screenX, screenY: screenY } = event;
            const [lastScreenX, lastScreenY] = this.#lastPointerCoords;
            [deltaX, deltaY] = this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY);
            this.#lastPointerCoords[0] = screenX;
            this.#lastPointerCoords[1] = screenY;
        } else ({ deltaX: deltaX, deltaY: deltaY } = event);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = $5942e8eb8ca60ef8$export$b8106b171181a554(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        else ratioY = $5942e8eb8ca60ef8$export$b8106b171181a554(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        const newWidth = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedWidth * ratioX);
        const newHeight = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    _onResizing() {}
    altTextFinish() {
        this.#altText?.finish();
    }
    get toolbarButtons() {
        return null;
    }
    async addEditToolbar() {
        if (this._editToolbar || this.#isInEditMode) return this._editToolbar;
        this._editToolbar = new $5942e8eb8ca60ef8$var$EditorToolbar(this);
        this.div.append(this._editToolbar.render());
        const { toolbarButtons: toolbarButtons } = this;
        if (toolbarButtons) for (const [name, tool] of toolbarButtons)await this._editToolbar.addButton(name, tool);
        if (!this.hasComment) this._editToolbar.addButton("comment", this.addCommentButton());
        this._editToolbar.addButton("delete");
        return this._editToolbar;
    }
    addCommentButtonInToolbar() {
        this._editToolbar?.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
    }
    removeCommentButtonFromToolbar() {
        this._editToolbar?.removeButton("comment");
    }
    removeEditToolbar() {
        this._editToolbar?.remove();
        this._editToolbar = null;
        this.#altText?.destroy();
    }
    addContainer(container) {
        const editToolbarDiv = this._editToolbar?.div;
        if (editToolbarDiv) editToolbarDiv.before(container);
        else this.div.append(container);
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    createAltText() {
        if (!this.#altText) {
            $5942e8eb8ca60ef8$var$AltText.initialize($5942e8eb8ca60ef8$var$AnnotationEditor._l10n);
            this.#altText = new $5942e8eb8ca60ef8$var$AltText(this);
            if (this.#accessibilityData) {
                this.#altText.data = this.#accessibilityData;
                this.#accessibilityData = null;
            }
        }
        return this.#altText;
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    get guessedAltText() {
        return this.#altText?.guessedText;
    }
    async setGuessedAltText(text) {
        await this.#altText?.setGuessedText(text);
    }
    serializeAltText(isForCopying) {
        return this.#altText?.serialize(isForCopying);
    }
    hasAltText() {
        return !!this.#altText && !this.#altText.isEmpty();
    }
    hasAltTextData() {
        return this.#altText?.hasData() ?? false;
    }
    focusCommentButton() {
        this.#comment?.focusButton();
    }
    addCommentButton() {
        return this.#comment ||= new $5942e8eb8ca60ef8$var$Comment(this);
    }
    addStandaloneCommentButton() {
        if (this.#commentStandaloneButton) {
            if (this._uiManager.isEditingMode()) this.#commentStandaloneButton.classList.remove("hidden");
            return;
        }
        if (!this.hasComment) return;
        this.#commentStandaloneButton = this.#comment.renderForStandalone();
        this.div.append(this.#commentStandaloneButton);
    }
    removeStandaloneCommentButton() {
        this.#comment.removeStandaloneCommentButton();
        this.#commentStandaloneButton = null;
    }
    hideStandaloneCommentButton() {
        this.#commentStandaloneButton?.classList.add("hidden");
    }
    get comment() {
        const { data: { richText: richText, text: text, date: date, deleted: deleted } } = this.#comment;
        return {
            text: text,
            richText: richText,
            date: date,
            deleted: deleted,
            color: this.getNonHCMColor(),
            opacity: this.opacity ?? 1
        };
    }
    set comment(text) {
        this.#comment ||= new $5942e8eb8ca60ef8$var$Comment(this);
        this.#comment.data = text;
        if (this.hasComment) {
            this.removeCommentButtonFromToolbar();
            this.addStandaloneCommentButton();
            this._uiManager.updateComment(this);
        } else {
            this.addCommentButtonInToolbar();
            this.removeStandaloneCommentButton();
            this._uiManager.removeComment(this);
        }
    }
    setCommentData({ comment: comment, popupRef: popupRef, richText: richText }) {
        if (!popupRef) return;
        this.#comment ||= new $5942e8eb8ca60ef8$var$Comment(this);
        this.#comment.setInitialText(comment, richText);
        if (!this.annotationElementId) return;
        const storedData = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
        if (storedData) this.updateFromAnnotationLayer(storedData);
    }
    get hasEditedComment() {
        return this.#comment?.hasBeenEdited();
    }
    get hasDeletedComment() {
        return this.#comment?.isDeleted();
    }
    get hasComment() {
        return !!this.#comment && !this.#comment.isEmpty() && !this.#comment.isDeleted();
    }
    async editComment(options) {
        this.#comment ||= new $5942e8eb8ca60ef8$var$Comment(this);
        this.#comment.edit(options);
    }
    toggleComment(isSelected, visibility) {
        if (this.hasComment) this._uiManager.toggleComment(this, isSelected, visibility);
    }
    setSelectedCommentButton(selected) {
        this.#comment.setSelectedButton(selected);
    }
    addComment(serialized) {
        if (this.hasEditedComment) {
            const DEFAULT_POPUP_WIDTH = 180;
            const DEFAULT_POPUP_HEIGHT = 100;
            const [, , , trY] = serialized.rect;
            const [pageWidth] = this.pageDimensions;
            const [pageX] = this.pageTranslation;
            const blX = pageX + pageWidth + 1;
            const blY = trY - DEFAULT_POPUP_HEIGHT;
            const trX = blX + DEFAULT_POPUP_WIDTH;
            serialized.popup = {
                contents: this.comment.text,
                deleted: this.comment.deleted,
                rect: [
                    blX,
                    blY,
                    trX,
                    trY
                ]
            };
        }
    }
    updateFromAnnotationLayer({ popup: { contents: contents, deleted: deleted } }) {
        this.#comment.data = deleted ? null : contents;
    }
    get parentBoundingClientRect() {
        return this.parent.boundingClientRect;
    }
    render() {
        const div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = this.#disabled ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) div.setAttribute("data-l10n-id", this.defaultL10nId);
        if (!this._isVisible) div.classList.add("hidden");
        this.setInForeground();
        this.#addFocusListeners();
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $5942e8eb8ca60ef8$var$bindEvents(this, div, [
            "keydown",
            "pointerdown",
            "dblclick"
        ]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) this.#touchManager ||= new $5942e8eb8ca60ef8$export$9ae7542b430d543e({
            container: div,
            isPinchingDisabled: ()=>!this.isSelected,
            onPinchStart: this.#touchPinchStartCallback.bind(this),
            onPinching: this.#touchPinchCallback.bind(this),
            onPinchEnd: this.#touchPinchEndCallback.bind(this),
            signal: this._uiManager._signal
        });
        this.addStandaloneCommentButton();
        this._uiManager._editorUndoBar?.hide();
        return div;
    }
    #touchPinchStartCallback() {
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        this.#altText?.toggle(false);
        this.parent.togglePointerEvents(false);
    }
    #touchPinchCallback(_origin, prevDistance, distance) {
        const slowDownFactor = 0.7;
        let factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) return;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $5942e8eb8ca60ef8$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $5942e8eb8ca60ef8$var$AnnotationEditor.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        const newWidth = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedWidth * factor);
        const newHeight = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) return;
        this.#initialRect ||= [
            savedX,
            savedY,
            savedWidth,
            savedHeight
        ];
        const transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        const centerX = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedX + transfCenterPoint[0]);
        const centerY = $5942e8eb8ca60ef8$var$AnnotationEditor._round(savedY + transfCenterPoint[1]);
        const newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    #touchPinchEndCallback() {
        this.#altText?.toggle(true);
        this.parent.togglePointerEvents(true);
        this.#addResizeToUndoStack();
    }
    pointerdown(event) {
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const { isSelected: isSelected } = this;
        this._uiManager.setUpDragSession();
        let hasDraggingStarted = false;
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        const opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        const cancelDrag = (e)=>{
            ac.abort();
            this.#dragPointerId = null;
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(e);
            if (hasDraggingStarted) this._onStopDragging();
        };
        if (isSelected) {
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            this.#dragPointerId = event.pointerId;
            this.#dragPointerType = event.pointerType;
            window.addEventListener("pointermove", (e)=>{
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    this._uiManager.toggleComment(this, true, false);
                    this._onStartDragging();
                }
                const { clientX: x, clientY: y, pointerId: pointerId } = e;
                if (pointerId !== this.#dragPointerId) {
                    $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
                    return;
                }
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, opts);
            window.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === this.#dragPointerType) {
                    if (this.#touchManager || e.isPrimary) cancelDrag(e);
                }
                $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
            }, opts);
        }
        const pointerUpCallback = (e)=>{
            if (!this.#dragPointerId || this.#dragPointerId === e.pointerId) {
                cancelDrag(e);
                return;
            }
            $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getPDFRect() {
        return this.getRect(0, 0);
    }
    getNonHCMColor() {
        return this.color && $5942e8eb8ca60ef8$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
        this.#comment?.onUpdatedColor();
    }
    getData() {
        const { comment: { text: str, color: color, date: date, opacity: opacity, deleted: deleted, richText: richText }, uid: id, pageIndex: pageIndex, creationDate: creationDate, modificationDate: modificationDate } = this;
        return {
            id: id,
            pageIndex: pageIndex,
            rect: this.getPDFRect(),
            richText: richText,
            contentsObj: {
                str: str
            },
            creationDate: creationDate,
            modificationDate: date || modificationDate,
            popupRef: !deleted,
            color: color,
            opacity: opacity
        };
    }
    onceAdded(focus) {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        if (this.isInEditMode()) return false;
        this.parent.setEditingState(false);
        this.#isInEditMode = true;
        return true;
    }
    disableEditMode() {
        if (!this.isInEditMode()) return false;
        this.parent.setEditingState(true);
        this.#isInEditMode = false;
        return true;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
        const { top: top, left: left, bottom: bottom, right: right } = this.getClientDimensions();
        const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
        return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
    }
    #addFocusListeners() {
        if (this.#focusAC || !this.div) return;
        this.#focusAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#focusAC);
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }
    rebuild() {
        this.#addFocusListeners();
    }
    rotate(_angle) {}
    resize() {}
    serializeDeleted() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    serialize(isForCopying = false, context = null) {
        return {
            annotationType: this.mode,
            pageIndex: this.pageIndex,
            rect: this.getPDFRect(),
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    static async deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: parent.getNextId(),
            uiManager: uiManager,
            annotationElementId: data.annotationElementId,
            creationDate: data.creationDate,
            modificationDate: data.modificationDate
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        editor._isCopy = data.isCopy || false;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.#focusAC?.abort();
        this.#focusAC = null;
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
        this.#touchManager?.destroy();
        this.#touchManager = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
        }
    }
    get toolbarPosition() {
        return null;
    }
    get commentButtonPosition() {
        return this._uiManager.direction === "ltr" ? [
            1,
            0
        ] : [
            0,
            0
        ];
    }
    get commentButtonPositionInPage() {
        const { commentButtonPosition: [posX, posY] } = this;
        const [blX, blY, trX, trY] = this.getPDFRect();
        return [
            $5942e8eb8ca60ef8$var$AnnotationEditor._round(blX + (trX - blX) * posX),
            $5942e8eb8ca60ef8$var$AnnotationEditor._round(blY + (trY - blY) * (1 - posY))
        ];
    }
    get commentButtonColor() {
        return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
        return this.#comment.commentPopupPositionInLayer;
    }
    set commentPopupPosition(pos) {
        this.#comment.commentPopupPositionInLayer = pos;
    }
    hasDefaultPopupPosition() {
        return this.#comment.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
        return this.#comment.commentButtonWidth;
    }
    get elementBeforePopup() {
        return this.div;
    }
    setCommentButtonStates(options) {
        this.#comment.setCommentButtonStates(options);
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                div.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstChild.before(this.#resizersDiv.lastChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                child.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $5942e8eb8ca60ef8$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        this.#addResizeToUndoStack();
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        if (this.isSelected && this._editToolbar) {
            this._editToolbar.show();
            return;
        }
        this.isSelected = true;
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this._editToolbar?.show();
            });
            return;
        }
        this._editToolbar?.show();
        this.#altText?.toggleAltTextBadge(false);
    }
    focus() {
        if (this.div && !this.div.contains(document.activeElement)) setTimeout(()=>this.div?.focus({
                preventScroll: true
            }), 0);
    }
    unselect() {
        if (!this.isSelected) return;
        this.isSelected = false;
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this._editToolbar?.hide();
        this.#altText?.toggleAltTextBadge(true);
        if (this.hasComment) this._uiManager.toggleComment(this, false, false);
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
        return false;
    }
    enterInEditMode() {
        if (!this.canChangeContent) return;
        this.enableEditMode();
        this.div.focus();
    }
    dblclick(event) {
        if (event.target.nodeName === "BUTTON") return;
        this.enterInEditMode();
        this.parent.updateToolbar({
            mode: this.constructor._editorType,
            editId: this.id
        });
    }
    getElementForAltText() {
        return this.div;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $5942e8eb8ca60ef8$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    updateFakeAnnotationElement(annotationLayer) {
        if (!this.#fakeAnnotation && !this.deleted) {
            this.#fakeAnnotation = annotationLayer.addFakeAnnotation(this);
            return;
        }
        if (this.deleted) {
            this.#fakeAnnotation.remove();
            this.#fakeAnnotation = null;
            return;
        }
        if (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) this.#fakeAnnotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstChild: firstChild } = annotation.container;
        if (firstChild?.nodeName === "DIV" && firstChild.classList.contains("annotationContent")) firstChild.remove();
    }
}
class $5942e8eb8ca60ef8$var$FakeEditor extends $5942e8eb8ca60ef8$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return this.serializeDeleted();
    }
}
const $5942e8eb8ca60ef8$var$SEED = 0xc3d2e1f0;
const $5942e8eb8ca60ef8$var$MASK_HIGH = 0xffff0000;
const $5942e8eb8ca60ef8$var$MASK_LOW = 0xffff;
class $5942e8eb8ca60ef8$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $5942e8eb8ca60ef8$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $5942e8eb8ca60ef8$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $5942e8eb8ca60ef8$var$MASK_LOW, C2_LOW = C2 & $5942e8eb8ca60ef8$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $5942e8eb8ca60ef8$var$MASK_HIGH | k1 * C1_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $5942e8eb8ca60ef8$var$MASK_HIGH | k1 * C2_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $5942e8eb8ca60ef8$var$MASK_HIGH | k2 * C1_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $5942e8eb8ca60ef8$var$MASK_HIGH | k2 * C2_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $5942e8eb8ca60ef8$var$MASK_HIGH | k1 * C1_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $5942e8eb8ca60ef8$var$MASK_HIGH | k1 * C2_LOW & $5942e8eb8ca60ef8$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $5942e8eb8ca60ef8$var$MASK_HIGH | h1 * 0x8ccd & $5942e8eb8ca60ef8$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $5942e8eb8ca60ef8$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $5942e8eb8ca60ef8$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $5942e8eb8ca60ef8$var$MASK_HIGH | h1 * 0xec53 & $5942e8eb8ca60ef8$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $5942e8eb8ca60ef8$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $5942e8eb8ca60ef8$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $5942e8eb8ca60ef8$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $5942e8eb8ca60ef8$var$AnnotationStorage {
    #modified = false;
    #modifiedIds = null;
    #editorsMap = null;
    #storage = new Map();
    constructor(){
        this.onSetModified = null;
        this.onResetModified = null;
        this.onAnnotationEditor = null;
    }
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        const storedValue = this.#storage.get(key);
        if (storedValue === undefined) return;
        if (storedValue instanceof $5942e8eb8ca60ef8$var$AnnotationEditor) this.#editorsMap.delete(storedValue.annotationElementId);
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (typeof this.onAnnotationEditor === "function") {
            for (const value of this.#storage.values()){
                if (value instanceof $5942e8eb8ca60ef8$var$AnnotationEditor) return;
            }
            this.onAnnotationEditor(null);
        }
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $5942e8eb8ca60ef8$var$AnnotationEditor) {
            (this.#editorsMap ||= new Map()).set(value.annotationElementId, value);
            if (typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
        }
    }
    has(key) {
        return this.#storage.has(key);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            if (typeof this.onSetModified === "function") this.onSetModified();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            if (typeof this.onResetModified === "function") this.onResetModified();
        }
    }
    get print() {
        return new $5942e8eb8ca60ef8$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $5942e8eb8ca60ef8$var$SerializableEmpty;
        const map = new Map(), hash = new $5942e8eb8ca60ef8$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $5942e8eb8ca60ef8$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $5942e8eb8ca60ef8$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        let numberOfEditedComments = 0;
        let numberOfDeletedComments = 0;
        for (const value of this.#storage.values()){
            if (!(value instanceof $5942e8eb8ca60ef8$var$AnnotationEditor)) {
                if (value.popup) {
                    if (value.popup.deleted) numberOfDeletedComments += 1;
                    else numberOfEditedComments += 1;
                }
                continue;
            }
            if (value.isCommentDeleted) numberOfDeletedComments += 1;
            else if (value.hasEditedComment) numberOfEditedComments += 1;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                let counters = map.get(key);
                if (!counters) {
                    counters = new Map();
                    map.set(key, counters);
                }
                const count = counters.get(val) ?? 0;
                counters.set(val, count + 1);
            }
        }
        if (numberOfDeletedComments > 0 || numberOfEditedComments > 0) {
            stats ||= Object.create(null);
            stats.comments = {
                deleted: numberOfDeletedComments,
                edited: numberOfEditedComments
            };
        }
        if (!stats) return null;
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
    resetModifiedIds() {
        this.#modifiedIds = null;
    }
    updateEditor(annotationId, data) {
        const value = this.#editorsMap?.get(annotationId);
        if (value) {
            value.updateFromAnnotationLayer(data);
            return true;
        }
        return false;
    }
    getEditor(annotationId) {
        return this.#editorsMap?.get(annotationId) || null;
    }
    get modifiedIds() {
        if (this.#modifiedIds) return this.#modifiedIds;
        const ids = [];
        if (this.#editorsMap) for (const value of this.#editorsMap.values()){
            if (!value.serialize()) continue;
            ids.push(value.annotationElementId);
        }
        return this.#modifiedIds = {
            ids: new Set(ids),
            hash: ids.join(",")
        };
    }
    [Symbol.iterator]() {
        return this.#storage.entries();
    }
}
class $5942e8eb8ca60ef8$var$PrintAnnotationStorage extends $5942e8eb8ca60ef8$var$AnnotationStorage {
    #serializable;
    constructor(parent){
        super();
        const { map: map, hash: hash, transfer: transfer } = parent.serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: transfer
        };
    }
    get print() {
        $5942e8eb8ca60ef8$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
    get modifiedIds() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "modifiedIds", {
            ids: new Set(),
            hash: ""
        });
    }
}
class $5942e8eb8ca60ef8$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, disableFontFace: disableFontFace, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $5942e8eb8ca60ef8$var$assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $5942e8eb8ca60ef8$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $5942e8eb8ca60ef8$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $5942e8eb8ca60ef8$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isSyncFontLoadingSupported", $5942e8eb8ca60ef8$var$isNodeJS || $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform.isFirefox);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $5942e8eb8ca60ef8$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $5942e8eb8ca60ef8$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, $5942e8eb8ca60ef8$var$string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $5942e8eb8ca60ef8$var$FontFaceObject {
    #fontData;
    constructor(translatedData, inspectFont = null, extra, charProcOperatorList){
        this.compiledGlyphs = Object.create(null);
        this.#fontData = translatedData;
        this._inspectFont = inspectFont;
        if (extra) Object.assign(this, extra);
        if (charProcOperatorList) this.charProcOperatorList = charProcOperatorList;
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const url = `url(data:${this.mimetype};base64,${$5942e8eb8ca60ef8$var$toBase64Util(this.data)});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        const objId = this.loadedName + "_path_" + character;
        let cmds;
        try {
            cmds = objs.get(objId);
        } catch (ex) {
            $5942e8eb8ca60ef8$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        const path = new Path2D(cmds || "");
        if (!this.fontExtraProperties) objs.delete(objId);
        return this.compiledGlyphs[character] = path;
    }
    get black() {
        return this.#fontData.black;
    }
    get bold() {
        return this.#fontData.bold;
    }
    get disableFontFace() {
        return this.#fontData.disableFontFace ?? false;
    }
    get fontExtraProperties() {
        return this.#fontData.fontExtraProperties ?? false;
    }
    get isInvalidPDFjsFont() {
        return this.#fontData.isInvalidPDFjsFont;
    }
    get isType3Font() {
        return this.#fontData.isType3Font;
    }
    get italic() {
        return this.#fontData.italic;
    }
    get missingFile() {
        return this.#fontData.missingFile;
    }
    get remeasure() {
        return this.#fontData.remeasure;
    }
    get vertical() {
        return this.#fontData.vertical;
    }
    get ascent() {
        return this.#fontData.ascent;
    }
    get defaultWidth() {
        return this.#fontData.defaultWidth;
    }
    get descent() {
        return this.#fontData.descent;
    }
    get bbox() {
        return this.#fontData.bbox;
    }
    get fontMatrix() {
        return this.#fontData.fontMatrix;
    }
    get fallbackName() {
        return this.#fontData.fallbackName;
    }
    get loadedName() {
        return this.#fontData.loadedName;
    }
    get mimetype() {
        return this.#fontData.mimetype;
    }
    get name() {
        return this.#fontData.name;
    }
    get data() {
        return this.#fontData.data;
    }
    clearData() {
        this.#fontData.clearData();
    }
    get cssFontInfo() {
        return this.#fontData.cssFontInfo;
    }
    get systemFontInfo() {
        return this.#fontData.systemFontInfo;
    }
    get defaultVMetrics() {
        return this.#fontData.defaultVMetrics;
    }
}
function $5942e8eb8ca60ef8$var$getUrlProp(val) {
    if (val instanceof URL) return val.href;
    if (typeof val === "string") {
        if ($5942e8eb8ca60ef8$var$isNodeJS) return val;
        const url = URL.parse(val, window.location);
        if (url) return url.href;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $5942e8eb8ca60ef8$var$getDataProp(val) {
    if ($5942e8eb8ca60ef8$var$isNodeJS && typeof $5942e8eb8ca60ef8$require$Buffer !== "undefined" && val instanceof $5942e8eb8ca60ef8$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $5942e8eb8ca60ef8$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $5942e8eb8ca60ef8$var$getFactoryUrlProp(val) {
    if (typeof val !== "string") return null;
    if (val.endsWith("/")) return val;
    throw new Error(`Invalid factory url: "${val}" must include trailing slash.`);
}
const $5942e8eb8ca60ef8$var$isRefProxy = (v)=>typeof v === "object" && Number.isInteger(v?.num) && v.num >= 0 && Number.isInteger(v?.gen) && v.gen >= 0;
const $5942e8eb8ca60ef8$var$isNameProxy = (v)=>typeof v === "object" && typeof v?.name === "string";
const $5942e8eb8ca60ef8$export$b5acece0a447dcdc = $5942e8eb8ca60ef8$var$_isValidExplicitDest.bind(null, $5942e8eb8ca60ef8$var$isRefProxy, $5942e8eb8ca60ef8$var$isNameProxy);
class $5942e8eb8ca60ef8$var$LoopbackPort {
    #listeners = new Map();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const [listener] of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener, options = null) {
        let rmAbort = null;
        if (options?.signal instanceof AbortSignal) {
            const { signal: signal } = options;
            if (signal.aborted) {
                $5942e8eb8ca60ef8$var$warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            const onAbort = ()=>this.removeEventListener(name, listener);
            rmAbort = ()=>signal.removeEventListener("abort", onAbort);
            signal.addEventListener("abort", onAbort);
        }
        this.#listeners.set(listener, rmAbort);
    }
    removeEventListener(name, listener) {
        const rmAbort = this.#listeners.get(listener);
        rmAbort?.();
        this.#listeners.delete(listener);
    }
    terminate() {
        for (const [, rmAbort] of this.#listeners)rmAbort?.();
        this.#listeners.clear();
    }
}
const $5942e8eb8ca60ef8$var$CallbackKind = {
    DATA: 1,
    ERROR: 2
};
const $5942e8eb8ca60ef8$var$StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $5942e8eb8ca60ef8$var$onFn() {}
function $5942e8eb8ca60ef8$var$wrapReason(ex) {
    if (ex instanceof $5942e8eb8ca60ef8$export$d0e978393d193d1a || ex instanceof $5942e8eb8ca60ef8$export$e3d0f4ce5b91e9f1 || ex instanceof $5942e8eb8ca60ef8$var$PasswordException || ex instanceof $5942e8eb8ca60ef8$export$ea8e9c34f66e603 || ex instanceof $5942e8eb8ca60ef8$var$UnknownErrorException) return ex;
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) $5942e8eb8ca60ef8$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(ex.name){
        case "AbortException":
            return new $5942e8eb8ca60ef8$export$d0e978393d193d1a(ex.message);
        case "InvalidPDFException":
            return new $5942e8eb8ca60ef8$export$e3d0f4ce5b91e9f1(ex.message);
        case "PasswordException":
            return new $5942e8eb8ca60ef8$var$PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new $5942e8eb8ca60ef8$export$ea8e9c34f66e603(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new $5942e8eb8ca60ef8$var$UnknownErrorException(ex.message, ex.details);
    }
    return new $5942e8eb8ca60ef8$var$UnknownErrorException(ex.message, ex.toString());
}
class $5942e8eb8ca60ef8$var$MessageHandler {
    #messageAC = new AbortController();
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", this.#onMessage.bind(this), {
            signal: this.#messageAC.signal
        });
    }
    #onMessage({ data: data }) {
        if (data.targetName !== this.sourceName) return;
        if (data.stream) {
            this.#processStreamMessage(data);
            return;
        }
        if (data.callback) {
            const callbackId = data.callbackId;
            const capability = this.callbackCapabilities[callbackId];
            if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
            delete this.callbackCapabilities[callbackId];
            if (data.callback === $5942e8eb8ca60ef8$var$CallbackKind.DATA) capability.resolve(data.data);
            else if (data.callback === $5942e8eb8ca60ef8$var$CallbackKind.ERROR) capability.reject($5942e8eb8ca60ef8$var$wrapReason(data.reason));
            else throw new Error("Unexpected callback case");
            return;
        }
        const action = this.actionHandler[data.action];
        if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
        if (data.callbackId) {
            const sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
            Promise.try(action, data.data).then(function(result) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $5942e8eb8ca60ef8$var$CallbackKind.DATA,
                    callbackId: data.callbackId,
                    data: result
                });
            }, function(reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $5942e8eb8ca60ef8$var$CallbackKind.ERROR,
                    callbackId: data.callbackId,
                    reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
                });
            });
            return;
        }
        if (data.streamId) {
            this.#createStreamSink(data);
            return;
        }
        action(data.data);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $5942e8eb8ca60ef8$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $5942e8eb8ca60ef8$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $5942e8eb8ca60ef8$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $5942e8eb8ca60ef8$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $5942e8eb8ca60ef8$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $5942e8eb8ca60ef8$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $5942e8eb8ca60ef8$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        Promise.try(action, data.data, streamSink).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $5942e8eb8ca60ef8$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $5942e8eb8ca60ef8$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $5942e8eb8ca60ef8$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($5942e8eb8ca60ef8$var$wrapReason(data.reason));
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($5942e8eb8ca60ef8$var$wrapReason(data.reason));
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $5942e8eb8ca60ef8$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                Promise.try(streamSink.onPull || $5942e8eb8ca60ef8$var$onFn).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $5942e8eb8ca60ef8$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $5942e8eb8ca60ef8$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
                    });
                });
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.ENQUEUE:
                $5942e8eb8ca60ef8$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.CLOSE:
                $5942e8eb8ca60ef8$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.ERROR:
                $5942e8eb8ca60ef8$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($5942e8eb8ca60ef8$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($5942e8eb8ca60ef8$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $5942e8eb8ca60ef8$var$StreamKind.CANCEL:
                if (!streamSink) break;
                const dataReason = $5942e8eb8ca60ef8$var$wrapReason(data.reason);
                Promise.try(streamSink.onCancel || $5942e8eb8ca60ef8$var$onFn, dataReason).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $5942e8eb8ca60ef8$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $5942e8eb8ca60ef8$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $5942e8eb8ca60ef8$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject(dataReason);
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.#messageAC?.abort();
        this.#messageAC = null;
    }
}
class $5942e8eb8ca60ef8$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false }){
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset(canvasAndContext, width, height) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvasAndContext.canvas.width = width;
        canvasAndContext.canvas.height = height;
    }
    destroy(canvasAndContext) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        canvasAndContext.canvas.width = 0;
        canvasAndContext.canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $5942e8eb8ca60ef8$var$DOMCanvasFactory extends $5942e8eb8ca60ef8$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false }){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
class $5942e8eb8ca60ef8$var$BaseCMapReaderFactory {
    constructor({ baseUrl: baseUrl = null, isCompressed: isCompressed = true }){
        this.baseUrl = baseUrl;
        this.isCompressed = isCompressed;
    }
    async fetch({ name: name }) {
        if (!this.baseUrl) throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
        if (!name) throw new Error("CMap name must be specified.");
        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
        return this._fetch(url).then((cMapData)=>({
                cMapData: cMapData,
                isCompressed: this.isCompressed
            })).catch((reason)=>{
            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
        });
    }
    async _fetch(url) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $5942e8eb8ca60ef8$var$DOMCMapReaderFactory extends $5942e8eb8ca60ef8$var$BaseCMapReaderFactory {
    async _fetch(url) {
        const data = await $5942e8eb8ca60ef8$export$8134c072fddab6a5(url, this.isCompressed ? "arraybuffer" : "text");
        return data instanceof ArrayBuffer ? new Uint8Array(data) : $5942e8eb8ca60ef8$var$stringToBytes(data);
    }
}
class $5942e8eb8ca60ef8$var$BaseFilterFactory {
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    destroy(keepHCM = false) {}
}
class $5942e8eb8ca60ef8$var$DOMFilterFactory extends $5942e8eb8ca60ef8$var$BaseFilterFactory {
    #baseUrl;
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document }){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    #createUrl(id) {
        if (this.#baseUrl === undefined) {
            this.#baseUrl = "";
            const url = this.#document.URL;
            if (url !== this.#document.baseURI) {
                if ($5942e8eb8ca60ef8$export$f67aae4532d8295b(url)) $5942e8eb8ca60ef8$var$warn('#createUrl: ignore "data:"-URL for performance reasons.');
                else this.#baseUrl = $5942e8eb8ca60ef8$export$e1e4297c21ab9d13(url, "");
            }
        }
        return `url(${this.#baseUrl}#${id})`;
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getRGB.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#_hcmCache?.size) return;
        this.#_defs?.parentNode.parentNode.remove();
        this.#_defs = null;
        this.#_cache?.clear();
        this.#_cache = null;
        this.#_hcmCache?.clear();
        this.#_hcmCache = null;
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $5942e8eb8ca60ef8$export$2a2e9b507863ddda(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
}
class $5942e8eb8ca60ef8$var$BaseStandardFontDataFactory {
    constructor({ baseUrl: baseUrl = null }){
        this.baseUrl = baseUrl;
    }
    async fetch({ filename: filename }) {
        if (!this.baseUrl) throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
        if (!filename) throw new Error("Font filename must be specified.");
        const url = `${this.baseUrl}${filename}`;
        return this._fetch(url).catch((reason)=>{
            throw new Error(`Unable to load font data at: ${url}`);
        });
    }
    async _fetch(url) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $5942e8eb8ca60ef8$var$DOMStandardFontDataFactory extends $5942e8eb8ca60ef8$var$BaseStandardFontDataFactory {
    async _fetch(url) {
        const data = await $5942e8eb8ca60ef8$export$8134c072fddab6a5(url, "arraybuffer");
        return new Uint8Array(data);
    }
}
class $5942e8eb8ca60ef8$var$BaseWasmFactory {
    constructor({ baseUrl: baseUrl = null }){
        this.baseUrl = baseUrl;
    }
    async fetch({ filename: filename }) {
        if (!this.baseUrl) throw new Error("Ensure that the `wasmUrl` API parameter is provided.");
        if (!filename) throw new Error("Wasm filename must be specified.");
        const url = `${this.baseUrl}${filename}`;
        return this._fetch(url).catch((reason)=>{
            throw new Error(`Unable to load wasm data at: ${url}`);
        });
    }
    async _fetch(url) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $5942e8eb8ca60ef8$var$DOMWasmFactory extends $5942e8eb8ca60ef8$var$BaseWasmFactory {
    async _fetch(url) {
        const data = await $5942e8eb8ca60ef8$export$8134c072fddab6a5(url, "arraybuffer");
        return new Uint8Array(data);
    }
}
if ($5942e8eb8ca60ef8$var$isNodeJS) $5942e8eb8ca60ef8$var$warn("Please use the `legacy` build in Node.js environments.");
async function $5942e8eb8ca60ef8$var$node_utils_fetchData(url) {
    const fs = $hPtJY.getBuiltinModule("fs");
    const data = await fs.promises.readFile(url);
    return new Uint8Array(data);
}
class $5942e8eb8ca60ef8$var$NodeFilterFactory extends $5942e8eb8ca60ef8$var$BaseFilterFactory {
}
class $5942e8eb8ca60ef8$var$NodeCanvasFactory extends $5942e8eb8ca60ef8$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const require1 = $hPtJY.getBuiltinModule("module").createRequire("file:///node_modules/pdfjs-dist/build/pdf.mjs");
        const canvas = require1("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    }
}
class $5942e8eb8ca60ef8$var$NodeCMapReaderFactory extends $5942e8eb8ca60ef8$var$BaseCMapReaderFactory {
    async _fetch(url) {
        return $5942e8eb8ca60ef8$var$node_utils_fetchData(url);
    }
}
class $5942e8eb8ca60ef8$var$NodeStandardFontDataFactory extends $5942e8eb8ca60ef8$var$BaseStandardFontDataFactory {
    async _fetch(url) {
        return $5942e8eb8ca60ef8$var$node_utils_fetchData(url);
    }
}
class $5942e8eb8ca60ef8$var$NodeWasmFactory extends $5942e8eb8ca60ef8$var$BaseWasmFactory {
    async _fetch(url) {
        return $5942e8eb8ca60ef8$var$node_utils_fetchData(url);
    }
}
const $5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL = "__forcedDependency";
const { floor: $5942e8eb8ca60ef8$var$floor, ceil: $5942e8eb8ca60ef8$var$ceil } = Math;
function $5942e8eb8ca60ef8$var$expandBBox(array, index, minX, minY, maxX, maxY) {
    array[index * 4 + 0] = Math.min(array[index * 4 + 0], minX);
    array[index * 4 + 1] = Math.min(array[index * 4 + 1], minY);
    array[index * 4 + 2] = Math.max(array[index * 4 + 2], maxX);
    array[index * 4 + 3] = Math.max(array[index * 4 + 3], maxY);
}
const $5942e8eb8ca60ef8$var$EMPTY_BBOX = new Uint32Array(new Uint8Array([
    255,
    255,
    0,
    0
]).buffer)[0];
class $5942e8eb8ca60ef8$var$BBoxReader {
    #bboxes;
    #coords;
    constructor(bboxes, coords){
        this.#bboxes = bboxes;
        this.#coords = coords;
    }
    get length() {
        return this.#bboxes.length;
    }
    isEmpty(i) {
        return this.#bboxes[i] === $5942e8eb8ca60ef8$var$EMPTY_BBOX;
    }
    minX(i) {
        return this.#coords[i * 4 + 0] / 256;
    }
    minY(i) {
        return this.#coords[i * 4 + 1] / 256;
    }
    maxX(i) {
        return (this.#coords[i * 4 + 2] + 1) / 256;
    }
    maxY(i) {
        return (this.#coords[i * 4 + 3] + 1) / 256;
    }
}
const $5942e8eb8ca60ef8$var$ensureDebugMetadata = (map, key)=>{
    if (!map) return undefined;
    let value = map.get(key);
    if (!value) {
        value = {
            dependencies: new Set(),
            isRenderingOperation: false
        };
        map.set(key, value);
    }
    return value;
};
class $5942e8eb8ca60ef8$var$CanvasDependencyTracker {
    #simple = {
        __proto__: null
    };
    #incremental = {
        __proto__: null,
        transform: [],
        moveText: [],
        sameLineText: [],
        [$5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL]: []
    };
    #namedDependencies = new Map();
    #savesStack = [];
    #markedContentStack = [];
    #baseTransformStack = [
        [
            1,
            0,
            0,
            1,
            0,
            0
        ]
    ];
    #clipBox = [
        -Infinity,
        -Infinity,
        Infinity,
        Infinity
    ];
    #pendingBBox = new Float64Array([
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ]);
    #pendingBBoxIdx = -1;
    #pendingDependencies = new Set();
    #operations = new Map();
    #fontBBoxTrustworthy = new Map();
    #canvasWidth;
    #canvasHeight;
    #bboxesCoords;
    #bboxes;
    #debugMetadata;
    constructor(canvas, operationsCount, recordDebugMetadata = false){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
        this.#initializeBBoxes(operationsCount);
        if (recordDebugMetadata) this.#debugMetadata = new Map();
    }
    growOperationsCount(operationsCount) {
        if (operationsCount >= this.#bboxes.length) this.#initializeBBoxes(operationsCount, this.#bboxes);
    }
    #initializeBBoxes(operationsCount, oldBBoxes) {
        const buffer = new ArrayBuffer(operationsCount * 4);
        this.#bboxesCoords = new Uint8ClampedArray(buffer);
        this.#bboxes = new Uint32Array(buffer);
        if (oldBBoxes && oldBBoxes.length > 0) {
            this.#bboxes.set(oldBBoxes);
            this.#bboxes.fill($5942e8eb8ca60ef8$var$EMPTY_BBOX, oldBBoxes.length);
        } else this.#bboxes.fill($5942e8eb8ca60ef8$var$EMPTY_BBOX);
    }
    save(opIdx) {
        this.#simple = {
            __proto__: this.#simple
        };
        this.#incremental = {
            __proto__: this.#incremental,
            transform: {
                __proto__: this.#incremental.transform
            },
            moveText: {
                __proto__: this.#incremental.moveText
            },
            sameLineText: {
                __proto__: this.#incremental.sameLineText
            },
            [$5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL]: {
                __proto__: this.#incremental[$5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL]
            }
        };
        this.#clipBox = {
            __proto__: this.#clipBox
        };
        this.#savesStack.push(opIdx);
        return this;
    }
    restore(opIdx) {
        const previous = Object.getPrototypeOf(this.#simple);
        if (previous === null) return this;
        this.#simple = previous;
        this.#incremental = Object.getPrototypeOf(this.#incremental);
        this.#clipBox = Object.getPrototypeOf(this.#clipBox);
        const lastSave = this.#savesStack.pop();
        if (lastSave !== undefined) {
            $5942e8eb8ca60ef8$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#savesStack.push(idx);
        return this;
    }
    getOpenMarker() {
        if (this.#savesStack.length === 0) return null;
        return this.#savesStack.at(-1);
    }
    recordCloseMarker(opIdx) {
        const lastSave = this.#savesStack.pop();
        if (lastSave !== undefined) {
            $5942e8eb8ca60ef8$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    beginMarkedContent(opIdx) {
        this.#markedContentStack.push(opIdx);
        return this;
    }
    endMarkedContent(opIdx) {
        const lastSave = this.#markedContentStack.pop();
        if (lastSave !== undefined) {
            $5942e8eb8ca60ef8$var$ensureDebugMetadata(this.#debugMetadata, opIdx)?.dependencies.add(lastSave);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    pushBaseTransform(ctx) {
        this.#baseTransformStack.push($5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform()));
        return this;
    }
    popBaseTransform() {
        if (this.#baseTransformStack.length > 1) this.#baseTransformStack.pop();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#simple[name] = idx;
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#incremental[name].push(idx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#incremental[name].length = 0;
        return this;
    }
    recordNamedData(name, idx) {
        this.#namedDependencies.set(name, idx);
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#simple[name] = this.#namedDependencies.get(depName) ?? fallbackIdx;
    }
    recordFutureForcedDependency(name, idx) {
        this.recordIncrementalData($5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL, idx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        for (const name of names)if (name in this.#simple) this.recordFutureForcedDependency(name, this.#simple[name]);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        for (const dep of this.#pendingDependencies)this.recordFutureForcedDependency($5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL, dep);
        return this;
    }
    resetBBox(idx) {
        if (this.#pendingBBoxIdx !== idx) {
            this.#pendingBBoxIdx = idx;
            this.#pendingBBox[0] = Infinity;
            this.#pendingBBox[1] = Infinity;
            this.#pendingBBox[2] = -Infinity;
            this.#pendingBBox[3] = -Infinity;
        }
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        const transform = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        const clipBox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, clipBox);
        const intersection = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.intersect(this.#clipBox, clipBox);
        if (intersection) {
            this.#clipBox[0] = intersection[0];
            this.#clipBox[1] = intersection[1];
            this.#clipBox[2] = intersection[2];
            this.#clipBox[3] = intersection[3];
        } else {
            this.#clipBox[0] = this.#clipBox[1] = Infinity;
            this.#clipBox[2] = this.#clipBox[3] = -Infinity;
        }
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        const clipBox = this.#clipBox;
        if (clipBox[0] === Infinity) return this;
        const transform = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        if (clipBox[0] === -Infinity) {
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                minX,
                minY,
                maxX,
                maxY
            ], transform, this.#pendingBBox);
            return this;
        }
        const bbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, bbox);
        this.#pendingBBox[0] = Math.min(this.#pendingBBox[0], Math.max(bbox[0], clipBox[0]));
        this.#pendingBBox[1] = Math.min(this.#pendingBBox[1], Math.max(bbox[1], clipBox[1]));
        this.#pendingBBox[2] = Math.max(this.#pendingBBox[2], Math.min(bbox[2], clipBox[2]));
        this.#pendingBBox[3] = Math.max(this.#pendingBBox[3], Math.min(bbox[3], clipBox[3]));
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        const fontBBox = font.bbox;
        let isBBoxTrustworthy;
        let computedBBox;
        if (fontBBox) {
            isBBoxTrustworthy = fontBBox[2] !== fontBBox[0] && fontBBox[3] !== fontBBox[1] && this.#fontBBoxTrustworthy.get(font);
            if (isBBoxTrustworthy !== false) {
                computedBBox = [
                    0,
                    0,
                    0,
                    0
                ];
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(fontBBox, font.fontMatrix, computedBBox);
                if (scale !== 1 || x !== 0 || y !== 0) $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.scaleMinMax([
                    scale,
                    0,
                    0,
                    -scale,
                    x,
                    y
                ], computedBBox);
                if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
            }
        }
        if (!getMeasure) return this.recordFullPageBBox(idx);
        const measure = getMeasure();
        if (fontBBox && computedBBox && isBBoxTrustworthy === undefined) {
            isBBoxTrustworthy = computedBBox[0] <= x - measure.actualBoundingBoxLeft && computedBBox[2] >= x + measure.actualBoundingBoxRight && computedBBox[1] <= y - measure.actualBoundingBoxAscent && computedBBox[3] >= y + measure.actualBoundingBoxDescent;
            this.#fontBBoxTrustworthy.set(font, isBBoxTrustworthy);
            if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
        }
        return this.recordBBox(idx, ctx, x - measure.actualBoundingBoxLeft, x + measure.actualBoundingBoxRight, y - measure.actualBoundingBoxAscent, y + measure.actualBoundingBoxDescent);
    }
    recordFullPageBBox(idx) {
        this.#pendingBBox[0] = Math.max(0, this.#clipBox[0]);
        this.#pendingBBox[1] = Math.max(0, this.#clipBox[1]);
        this.#pendingBBox[2] = Math.min(this.#canvasWidth, this.#clipBox[2]);
        this.#pendingBBox[3] = Math.min(this.#canvasHeight, this.#clipBox[3]);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#simple[dependencyName];
    }
    recordDependencies(idx, dependencyNames) {
        const pendingDependencies = this.#pendingDependencies;
        const simple = this.#simple;
        const incremental = this.#incremental;
        for (const name of dependencyNames){
            if (name in this.#simple) pendingDependencies.add(simple[name]);
            else if (name in incremental) incremental[name].forEach(pendingDependencies.add, pendingDependencies);
        }
        return this;
    }
    recordNamedDependency(idx, name) {
        if (this.#namedDependencies.has(name)) this.#pendingDependencies.add(this.#namedDependencies.get(name));
        return this;
    }
    recordOperation(idx, preserve = false) {
        this.recordDependencies(idx, [
            $5942e8eb8ca60ef8$var$FORCED_DEPENDENCY_LABEL
        ]);
        if (this.#debugMetadata) {
            const metadata = $5942e8eb8ca60ef8$var$ensureDebugMetadata(this.#debugMetadata, idx);
            const { dependencies: dependencies } = metadata;
            this.#pendingDependencies.forEach(dependencies.add, dependencies);
            this.#savesStack.forEach(dependencies.add, dependencies);
            this.#markedContentStack.forEach(dependencies.add, dependencies);
            dependencies.delete(idx);
            metadata.isRenderingOperation = true;
        }
        if (this.#pendingBBoxIdx === idx) {
            const minX = $5942e8eb8ca60ef8$var$floor(this.#pendingBBox[0] * 256 / this.#canvasWidth);
            const minY = $5942e8eb8ca60ef8$var$floor(this.#pendingBBox[1] * 256 / this.#canvasHeight);
            const maxX = $5942e8eb8ca60ef8$var$ceil(this.#pendingBBox[2] * 256 / this.#canvasWidth);
            const maxY = $5942e8eb8ca60ef8$var$ceil(this.#pendingBBox[3] * 256 / this.#canvasHeight);
            $5942e8eb8ca60ef8$var$expandBBox(this.#bboxesCoords, idx, minX, minY, maxX, maxY);
            for (const depIdx of this.#pendingDependencies)if (depIdx !== idx) $5942e8eb8ca60ef8$var$expandBBox(this.#bboxesCoords, depIdx, minX, minY, maxX, maxY);
            for (const saveIdx of this.#savesStack)if (saveIdx !== idx) $5942e8eb8ca60ef8$var$expandBBox(this.#bboxesCoords, saveIdx, minX, minY, maxX, maxY);
            for (const saveIdx of this.#markedContentStack)if (saveIdx !== idx) $5942e8eb8ca60ef8$var$expandBBox(this.#bboxesCoords, saveIdx, minX, minY, maxX, maxY);
            if (!preserve) {
                this.#pendingDependencies.clear();
                this.#pendingBBoxIdx = -1;
            }
        }
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        const deps = Array.from(this.#pendingDependencies);
        this.recordOperation(idx, preserve);
        this.recordIncrementalData("sameLineText", idx);
        for (const dep of deps)this.recordIncrementalData("sameLineText", dep);
        return this;
    }
    bboxToClipBoxDropOperation(idx, preserve = false) {
        if (this.#pendingBBoxIdx === idx) {
            this.#pendingBBoxIdx = -1;
            this.#clipBox[0] = Math.max(this.#clipBox[0], this.#pendingBBox[0]);
            this.#clipBox[1] = Math.max(this.#clipBox[1], this.#pendingBBox[1]);
            this.#clipBox[2] = Math.min(this.#clipBox[2], this.#pendingBBox[2]);
            this.#clipBox[3] = Math.min(this.#clipBox[3], this.#pendingBBox[3]);
            if (!preserve) this.#pendingDependencies.clear();
        }
        return this;
    }
    _takePendingDependencies() {
        const pendingDependencies = this.#pendingDependencies;
        this.#pendingDependencies = new Set();
        return pendingDependencies;
    }
    _extractOperation(idx) {
        const operation = this.#operations.get(idx);
        this.#operations.delete(idx);
        return operation;
    }
    _pushPendingDependencies(dependencies) {
        for (const dep of dependencies)this.#pendingDependencies.add(dep);
    }
    take() {
        this.#fontBBoxTrustworthy.clear();
        return new $5942e8eb8ca60ef8$var$BBoxReader(this.#bboxes, this.#bboxesCoords);
    }
    takeDebugMetadata() {
        return this.#debugMetadata;
    }
}
class $5942e8eb8ca60ef8$var$CanvasNestedDependencyTracker {
    #dependencyTracker;
    #opIdx;
    #ignoreBBoxes;
    #nestingLevel = 0;
    #savesLevel = 0;
    constructor(dependencyTracker, opIdx, ignoreBBoxes){
        if (dependencyTracker instanceof $5942e8eb8ca60ef8$var$CanvasNestedDependencyTracker && dependencyTracker.#ignoreBBoxes === !!ignoreBBoxes) return dependencyTracker;
        this.#dependencyTracker = dependencyTracker;
        this.#opIdx = opIdx;
        this.#ignoreBBoxes = !!ignoreBBoxes;
    }
    growOperationsCount() {
        throw new Error("Unreachable");
    }
    save(opIdx) {
        this.#savesLevel++;
        this.#dependencyTracker.save(this.#opIdx);
        return this;
    }
    restore(opIdx) {
        if (this.#savesLevel > 0) {
            this.#dependencyTracker.restore(this.#opIdx);
            this.#savesLevel--;
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#nestingLevel++;
        return this;
    }
    getOpenMarker() {
        return this.#nestingLevel > 0 ? this.#opIdx : this.#dependencyTracker.getOpenMarker();
    }
    recordCloseMarker(idx) {
        this.#nestingLevel--;
        return this;
    }
    beginMarkedContent(opIdx) {
        return this;
    }
    endMarkedContent(opIdx) {
        return this;
    }
    pushBaseTransform(ctx) {
        this.#dependencyTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#dependencyTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#dependencyTracker.recordSimpleData(name, this.#opIdx);
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#dependencyTracker.recordIncrementalData(name, this.#opIdx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#dependencyTracker.resetIncrementalData(name, this.#opIdx);
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#dependencyTracker.recordSimpleDataFromNamed(name, depName, this.#opIdx);
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        this.#dependencyTracker.recordFutureForcedDependency(name, this.#opIdx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        this.#dependencyTracker.inheritSimpleDataAsFutureForcedDependencies(names);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        this.#dependencyTracker.inheritPendingDependenciesAsFutureForcedDependencies();
        return this;
    }
    resetBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.resetBBox(this.#opIdx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordClipBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordBBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale, x, y, getMeasure) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordCharacterBBox(this.#opIdx, ctx, font, scale, x, y, getMeasure);
        return this;
    }
    recordFullPageBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordFullPageBBox(this.#opIdx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#dependencyTracker.getSimpleIndex(dependencyName);
    }
    recordDependencies(idx, dependencyNames) {
        this.#dependencyTracker.recordDependencies(this.#opIdx, dependencyNames);
        return this;
    }
    recordNamedDependency(idx, name) {
        this.#dependencyTracker.recordNamedDependency(this.#opIdx, name);
        return this;
    }
    recordOperation(idx) {
        this.#dependencyTracker.recordOperation(this.#opIdx, true);
        return this;
    }
    recordShowTextOperation(idx) {
        this.#dependencyTracker.recordShowTextOperation(this.#opIdx, true);
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.bboxToClipBoxDropOperation(this.#opIdx, true);
        return this;
    }
    take() {
        throw new Error("Unreachable");
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
}
const $5942e8eb8ca60ef8$var$Dependencies = {
    stroke: [
        "path",
        "transform",
        "filter",
        "strokeColor",
        "strokeAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "dash"
    ],
    fill: [
        "path",
        "transform",
        "filter",
        "fillColor",
        "fillAlpha",
        "globalCompositeOperation",
        "SMask"
    ],
    imageXObject: [
        "transform",
        "SMask",
        "filter",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation"
    ],
    rawFillPath: [
        "filter",
        "fillColor",
        "fillAlpha"
    ],
    showText: [
        "transform",
        "leading",
        "charSpacing",
        "wordSpacing",
        "hScale",
        "textRise",
        "moveText",
        "textMatrix",
        "font",
        "fontObj",
        "filter",
        "fillColor",
        "textRenderingMode",
        "SMask",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation",
        "sameLineText"
    ],
    transform: [
        "transform"
    ],
    transformAndFill: [
        "transform",
        "fillColor"
    ]
};
const $5942e8eb8ca60ef8$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $5942e8eb8ca60ef8$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $5942e8eb8ca60ef8$var$BaseShadingPattern {
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern() {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $5942e8eb8ca60ef8$var$RadialAxialShadingPattern extends $5942e8eb8ca60ef8$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    _createGradient(ctx) {
        let grad;
        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $5942e8eb8ca60ef8$var$PathType.STROKE || pathType === $5942e8eb8ca60ef8$var$PathType.FILL) {
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $5942e8eb8ca60ef8$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $5942e8eb8ca60ef8$var$applyBoundingBox(tmpCtx, this._bbox);
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            $5942e8eb8ca60ef8$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $5942e8eb8ca60ef8$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
function $5942e8eb8ca60ef8$var$drawFigure(data, figure, context) {
    const ps = figure.coords;
    const cs = figure.colors;
    let i, ii;
    switch(figure.type){
        case "lattice":
            const verticesPerRow = figure.verticesPerRow;
            const rows = Math.floor(ps.length / verticesPerRow) - 1;
            const cols = verticesPerRow - 1;
            for(i = 0; i < rows; i++){
                let q = i * verticesPerRow;
                for(let j = 0; j < cols; j++, q++){
                    $5942e8eb8ca60ef8$var$drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                    $5942e8eb8ca60ef8$var$drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
            }
            break;
        case "triangles":
            for(i = 0, ii = ps.length; i < ii; i += 3)$5942e8eb8ca60ef8$var$drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            break;
        default:
            throw new Error("illegal figure");
    }
}
class $5942e8eb8ca60ef8$var$MeshShadingPattern extends $5942e8eb8ca60ef8$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._coords = IR[2];
        this._colors = IR[3];
        this._figures = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[6];
        this._background = IR[7];
        this.matrix = null;
    }
    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const scaleX = boundsWidth / width;
        const scaleY = boundsHeight / height;
        const context = {
            coords: this._coords,
            colors: this._colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight);
        const tmpCtx = tmpCanvas.context;
        const data = tmpCtx.createImageData(width, height);
        if (backgroundColor) {
            const bytes = data.data;
            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
            }
        }
        for (const figure of this._figures)$5942e8eb8ca60ef8$var$drawFigure(data, figure, context);
        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        const canvas = tmpCanvas.canvas;
        return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    isModifyingCurrentTransform() {
        return true;
    }
    getPattern(ctx, owner, inverse, pathType) {
        $5942e8eb8ca60ef8$var$applyBoundingBox(ctx, this._bbox);
        const scale = new Float32Array(2);
        if (pathType === $5942e8eb8ca60ef8$var$PathType.SHADING) $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($5942e8eb8ca60ef8$var$getCurrentTransform(ctx), scale);
        else if (this.matrix) {
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
            const [matrixScaleX, matrixScaleY] = scale;
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        } else $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $5942e8eb8ca60ef8$var$PathType.SHADING ? null : this._background, owner.cachedCanvases);
        if (pathType !== $5942e8eb8ca60ef8$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
    }
}
class $5942e8eb8ca60ef8$var$DummyShadingPattern extends $5942e8eb8ca60ef8$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $5942e8eb8ca60ef8$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $5942e8eb8ca60ef8$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $5942e8eb8ca60ef8$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $5942e8eb8ca60ef8$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $5942e8eb8ca60ef8$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $5942e8eb8ca60ef8$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, ctx, canvasGraphicsFactory, baseTransform){
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
    }
    createPatternCanvas(owner, opIdx) {
        const { bbox: bbox, operatorList: operatorList, paintType: paintType, tilingType: tilingType, color: color, canvasGraphicsFactory: canvasGraphicsFactory } = this;
        let { xstep: xstep, ystep: ystep } = this;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        $5942e8eb8ca60ef8$var$info("TilingType: " + tilingType);
        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
        const width = x1 - x0;
        const height = y1 - y0;
        const scale = new Float32Array(2);
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
        const [matrixScaleX, matrixScaleY] = scale;
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.baseTransform, scale);
        const combinedScaleX = matrixScaleX * scale[0];
        const combinedScaleY = matrixScaleY * scale[1];
        let canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        const xScaledStep = Math.ceil(xstep * combinedScaleX);
        const yScaledStep = Math.ceil(ystep * combinedScaleY);
        const xScaledWidth = Math.ceil(width * combinedScaleX);
        const yScaledHeight = Math.ceil(height * combinedScaleY);
        if (xScaledStep >= xScaledWidth) canvasWidth = xstep;
        else redrawHorizontally = true;
        if (yScaledStep >= yScaledHeight) canvasHeight = ystep;
        else redrawVertically = true;
        const dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        const dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size);
        const tmpCtx = tmpCanvas.context;
        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx, opIdx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(0, dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        graphics.dependencyTracker?.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(operatorList);
        graphics.endDrawing();
        graphics.dependencyTracker?.restore();
        tmpCtx.restore();
        if (redrawHorizontally || redrawVertically) {
            const image = tmpCanvas.canvas;
            if (redrawHorizontally) canvasWidth = xstep;
            if (redrawVertically) canvasHeight = ystep;
            const dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            const xSize = dimx2.size;
            const ySize = dimy2.size;
            const tmpCanvas2 = owner.cachedCanvases.getCanvas("pattern-workaround", xSize, ySize);
            const tmpCtx2 = tmpCanvas2.context;
            const ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            const jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for(let i = 0; i <= ii; i++)for(let j = 0; j <= jj; j++)tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
            return {
                canvas: tmpCanvas2.canvas,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        const maxSize = Math.max($5942e8eb8ca60ef8$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            x0,
            y0,
            x1,
            y1
        ], $5942e8eb8ca60ef8$var$getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.clip();
        graphics.endPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        switch(paintType){
            case $5942e8eb8ca60ef8$var$PaintType.COLORED:
                const { fillStyle: fillStyle, strokeStyle: strokeStyle } = this.ctx;
                context.fillStyle = current.fillColor = fillStyle;
                context.strokeStyle = current.strokeColor = strokeStyle;
                break;
            case $5942e8eb8ca60ef8$var$PaintType.UNCOLORED:
                context.fillStyle = context.strokeStyle = color;
                current.fillColor = current.strokeColor = color;
                break;
            default:
                throw new $5942e8eb8ca60ef8$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern(ctx, owner, inverse, pathType, opIdx) {
        let matrix = inverse;
        if (pathType !== $5942e8eb8ca60ef8$var$PathType.SHADING) {
            matrix = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(matrix, owner.baseTransform);
            if (this.matrix) matrix = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(matrix, this.matrix);
        }
        const temporaryPatternCanvas = this.createPatternCanvas(owner, opIdx);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
function $5942e8eb8ca60ef8$var$convertToRGBA(params) {
    switch(params.kind){
        case ImageKind.GRAYSCALE_1BPP:
            return $5942e8eb8ca60ef8$var$convertBlackAndWhiteToRGBA(params);
        case ImageKind.RGB_24BPP:
            return $5942e8eb8ca60ef8$var$convertRGBToRGBA(params);
    }
    return null;
}
function $5942e8eb8ca60ef8$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $5942e8eb8ca60ef8$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; i++){
        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
            const elem = srcPos < srcLength ? src[srcPos] : 255;
            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $5942e8eb8ca60ef8$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len = width * height * 3;
    const len32 = len >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    if (FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff000000;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
            dest[destPos + 3] = s3 << 8 | 0xff;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function $5942e8eb8ca60ef8$var$grayToRGBA(src, dest) {
    if (FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $5942e8eb8ca60ef8$var$MIN_FONT_SIZE = 16;
const $5942e8eb8ca60ef8$var$MAX_FONT_SIZE = 100;
const $5942e8eb8ca60ef8$var$EXECUTION_TIME = 15;
const $5942e8eb8ca60ef8$var$EXECUTION_STEPS = 10;
const $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT = 16;
const $5942e8eb8ca60ef8$var$SCALE_MATRIX = new DOMMatrix();
const $5942e8eb8ca60ef8$var$XY = new Float32Array(2);
const $5942e8eb8ca60ef8$var$MIN_MAX_INIT = new Float32Array([
    Infinity,
    Infinity,
    -Infinity,
    -Infinity
]);
function $5942e8eb8ca60ef8$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = ()=>{
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function() {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function() {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function(x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function(x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function(a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function(a, b, c, d, e, f) {
        destCtx.setTransform(a, b, c, d, e, f);
        this.__originalSetTransform(a, b, c, d, e, f);
    };
    ctx.resetTransform = function() {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function(angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function(rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function(x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function(x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function(x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function() {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function() {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
class $5942e8eb8ca60ef8$var$CachedCanvases {
    constructor(canvasFactory){
        this.canvasFactory = canvasFactory;
        this.cache = Object.create(null);
    }
    getCanvas(id, width, height) {
        let canvasEntry;
        if (this.cache[id] !== undefined) {
            canvasEntry = this.cache[id];
            this.canvasFactory.reset(canvasEntry, width, height);
        } else {
            canvasEntry = this.canvasFactory.create(width, height);
            this.cache[id] = canvasEntry;
        }
        return canvasEntry;
    }
    delete(id) {
        delete this.cache[id];
    }
    clear() {
        for(const id in this.cache){
            const canvasEntry = this.cache[id];
            this.canvasFactory.destroy(canvasEntry);
            delete this.cache[id];
        }
    }
}
function $5942e8eb8ca60ef8$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $5942e8eb8ca60ef8$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
class $5942e8eb8ca60ef8$var$CanvasExtraState {
    alphaIsShape = false;
    fontSize = 0;
    fontSizeScale = 1;
    textMatrix = null;
    textMatrixScale = 1;
    fontMatrix = $5942e8eb8ca60ef8$var$FONT_IDENTITY_MATRIX;
    leading = 0;
    x = 0;
    y = 0;
    lineX = 0;
    lineY = 0;
    charSpacing = 0;
    wordSpacing = 0;
    textHScale = 1;
    textRenderingMode = $5942e8eb8ca60ef8$var$TextRenderingMode.FILL;
    textRise = 0;
    fillColor = "#000000";
    strokeColor = "#000000";
    patternFill = false;
    patternStroke = false;
    fillAlpha = 1;
    strokeAlpha = 1;
    lineWidth = 1;
    activeSMask = null;
    transferMaps = "none";
    constructor(width, height, preInit){
        preInit?.(this);
        this.clipBox = new Float32Array([
            0,
            0,
            width,
            height
        ]);
        this.minMax = $5942e8eb8ca60ef8$var$MIN_MAX_INIT.slice();
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        return clone;
    }
    getPathBoundingBox(pathType = $5942e8eb8ca60ef8$var$PathType.FILL, transform = null) {
        const box = this.minMax.slice();
        if (pathType === $5942e8eb8ca60ef8$var$PathType.STROKE) {
            if (!transform) $5942e8eb8ca60ef8$var$unreachable("Stroke bounding box must include transform.");
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $5942e8eb8ca60ef8$var$XY);
            const xStrokePad = $5942e8eb8ca60ef8$var$XY[0] * this.lineWidth / 2;
            const yStrokePad = $5942e8eb8ca60ef8$var$XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minMax[0] === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox.set(box, 0);
        this.minMax.set($5942e8eb8ca60ef8$var$MIN_MAX_INIT, 0);
    }
    getClippedPathBoundingBox(pathType = $5942e8eb8ca60ef8$var$PathType.FILL, transform = null) {
        return $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $5942e8eb8ca60ef8$var$putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $5942e8eb8ca60ef8$export$b890e9c15247e0b3.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $5942e8eb8ca60ef8$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $5942e8eb8ca60ef8$export$b890e9c15247e0b3.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $5942e8eb8ca60ef8$export$b890e9c15247e0b3.RGB_24BPP) {
        thisChunkHeight = $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $5942e8eb8ca60ef8$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $5942e8eb8ca60ef8$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $5942e8eb8ca60ef8$var$FULL_CHUNK_HEIGHT);
    }
}
function $5942e8eb8ca60ef8$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $5942e8eb8ca60ef8$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    const { filter: filter } = ctx;
    if (filter !== "none" && filter !== "") ctx.filter = "none";
}
function $5942e8eb8ca60ef8$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $5942e8eb8ca60ef8$var$XY);
    const actualScale = Math.fround($5942e8eb8ca60ef8$export$f16a99f63bccd50b.pixelRatio * $5942e8eb8ca60ef8$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
    return $5942e8eb8ca60ef8$var$XY[0] <= actualScale && $5942e8eb8ca60ef8$var$XY[1] <= actualScale;
}
const $5942e8eb8ca60ef8$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $5942e8eb8ca60ef8$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $5942e8eb8ca60ef8$var$NORMAL_CLIP = {};
const $5942e8eb8ca60ef8$var$EO_CLIP = {};
class $5942e8eb8ca60ef8$var$CanvasGraphics {
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors, dependencyTracker){
        this.ctx = canvasCtx;
        this.current = new $5942e8eb8ca60ef8$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.res = null;
        this.xobjs = null;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.smaskCounter = 0;
        this.tempSMask = null;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedCanvases = new $5942e8eb8ca60ef8$var$CachedCanvases(this.canvasFactory);
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
        this.dependencyTracker = dependencyTracker ?? null;
    }
    getObject(opIdx, data, fallback = null) {
        if (typeof data === "string") {
            this.dependencyTracker?.recordNamedDependency(opIdx, data);
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
            this.compositeCtx = this.ctx;
            this.transparentCanvas = transparentCanvas.canvas;
            this.ctx = transparentCanvas.context;
            this.ctx.save();
            this.ctx.transform(...$5942e8eb8ca60ef8$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $5942e8eb8ca60ef8$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[0];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper, operationsFilter) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $5942e8eb8ca60ef8$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $5942e8eb8ca60ef8$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId, fnArgs;
        while(true){
            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
            }
            if (!operationsFilter || operationsFilter(i)) {
                fnId = fnArray[i];
                fnArgs = argsArray[i] ?? null;
                if (fnId !== $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b.dependency) {
                    if (fnArgs === null) this[fnId](i);
                    else this[fnId](i, ...fnArgs);
                } else for (const depObjId of fnArgs){
                    this.dependencyTracker?.recordNamedData(depObjId, i);
                    const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                    }
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $5942e8eb8ca60ef8$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.current.activeSMask = null;
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.transparentCanvas = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        this.cachedCanvases.clear();
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width ?? img.displayWidth;
        const height = img.height ?? img.displayHeight;
        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        let paintWidth = width, paintHeight = height;
        let tmpCanvasId = "prescale1";
        let tmpCanvas, tmpCtx;
        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
            let newWidth = paintWidth, newHeight = paintHeight;
            if (widthScale > 2 && paintWidth > 1) {
                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
            }
            if (heightScale > 2 && paintHeight > 1) {
                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                heightScale /= paintHeight / newHeight;
            }
            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
            tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, newWidth, newHeight);
            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            img = tmpCanvas.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
        }
        return {
            img: img,
            paintWidth: paintWidth,
            paintHeight: paintHeight
        };
    }
    _createMaskCanvas(opIdx, img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.get(mainKey);
            if (!cache) {
                cache = new Map();
                this._cachedBitmapsMap.set(mainKey, cache);
            }
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                this.dependencyTracker?.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.transformAndFill);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            $5942e8eb8ca60ef8$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const minMax = $5942e8eb8ca60ef8$var$MIN_MAX_INIT.slice();
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas, minMax);
        const [minX, minY, maxX, maxY] = minMax;
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        if (!scaled) {
            scaled = this._scaleImage(maskCanvas.canvas, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(fillCtx));
            scaled = scaled.img;
            if (cache && isPatternFill) cache.set(cacheKey, scaled);
        }
        fillCtx.imageSmoothingEnabled = $5942e8eb8ca60ef8$var$getImageSmoothingEnabled($5942e8eb8ca60ef8$var$getCurrentTransform(fillCtx), img.interpolate);
        $5942e8eb8ca60ef8$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform($5942e8eb8ca60ef8$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $5942e8eb8ca60ef8$var$PathType.FILL, opIdx) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) {
            this.cachedCanvases.delete("fillCanvas");
            cache.set(cacheKey, fillCanvas.canvas);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.transformAndFill);
        return {
            canvas: fillCanvas.canvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(opIdx, width) {
        this.dependencyTracker?.recordSimpleData("lineWidth", opIdx);
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineCap", opIdx);
        this.ctx.lineCap = $5942e8eb8ca60ef8$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineJoin", opIdx);
        this.ctx.lineJoin = $5942e8eb8ca60ef8$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(opIdx, limit) {
        this.dependencyTracker?.recordSimpleData("miterLimit", opIdx);
        this.ctx.miterLimit = limit;
    }
    setDash(opIdx, dashArray, dashPhase) {
        this.dependencyTracker?.recordSimpleData("dash", opIdx);
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(opIdx, intent) {}
    setFlatness(opIdx, flatness) {}
    setGState(opIdx, states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(opIdx, value);
                break;
            case "LC":
                this.setLineCap(opIdx, value);
                break;
            case "LJ":
                this.setLineJoin(opIdx, value);
                break;
            case "ML":
                this.setMiterLimit(opIdx, value);
                break;
            case "D":
                this.setDash(opIdx, value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(opIdx, value);
                break;
            case "FL":
                this.setFlatness(opIdx, value);
                break;
            case "Font":
                this.setFont(opIdx, value[0], value[1]);
                break;
            case "CA":
                this.dependencyTracker?.recordSimpleData("strokeAlpha", opIdx);
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.dependencyTracker?.recordSimpleData("fillAlpha", opIdx);
                this.ctx.globalAlpha = this.current.fillAlpha = value;
                break;
            case "BM":
                this.dependencyTracker?.recordSimpleData("globalCompositeOperation", opIdx);
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.dependencyTracker?.recordSimpleData("SMask", opIdx);
                this.current.activeSMask = value ? this.tempSMask : null;
                this.tempSMask = null;
                this.checkSMaskState();
                break;
            case "TR":
                this.dependencyTracker?.recordSimpleData("filter", opIdx);
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    checkSMaskState() {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
    }
    beginSMaskMode(opIdx) {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const drawnWidth = this.ctx.canvas.width;
        const drawnHeight = this.ctx.canvas.height;
        const cacheId = "smaskGroupAt" + this.groupLevel;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        this.suspendedCtx = this.ctx;
        const ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        $5942e8eb8ca60ef8$var$copyCtxState(this.suspendedCtx, ctx);
        $5942e8eb8ca60ef8$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $5942e8eb8ca60ef8$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        if (!dirtyBox) dirtyBox = [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
    }
    genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        let maskCanvas = maskCtx.canvas;
        let maskX = layerOffsetX - maskOffsetX;
        let maskY = layerOffsetY - maskOffsetY;
        if (backdrop) {
            if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
                const canvas = this.cachedCanvases.getCanvas("maskExtension", width, height);
                const ctx = canvas.context;
                ctx.drawImage(maskCanvas, -maskX, -maskY);
                ctx.globalCompositeOperation = "destination-atop";
                ctx.fillStyle = backdrop;
                ctx.fillRect(0, 0, width, height);
                ctx.globalCompositeOperation = "source-over";
                maskCanvas = canvas.canvas;
                maskX = maskY = 0;
            } else {
                maskCtx.save();
                maskCtx.globalAlpha = 1;
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                const clip = new Path2D();
                clip.rect(maskX, maskY, width, height);
                maskCtx.clip(clip);
                maskCtx.globalCompositeOperation = "destination-atop";
                maskCtx.fillStyle = backdrop;
                maskCtx.fillRect(maskX, maskY, width, height);
                maskCtx.restore();
            }
        }
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        if (subtype === "Alpha" && transferMap) layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
        else if (subtype === "Luminosity") layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    }
    save(opIdx) {
        if (this.inSMaskMode) $5942e8eb8ca60ef8$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
        this.dependencyTracker?.save(opIdx);
    }
    restore(opIdx) {
        this.dependencyTracker?.restore(opIdx);
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) this.endSMaskMode();
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) $5942e8eb8ca60ef8$var$copyCtxState(this.suspendedCtx, this.ctx);
        this.checkSMaskState();
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    transform(opIdx, a, b, c, d, e, f) {
        this.dependencyTracker?.recordIncrementalData("transform", opIdx);
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(opIdx, op, data, minMax) {
        let [path] = data;
        if (!minMax) {
            path ||= data[0] = new Path2D();
            this[op](opIdx, path);
            return;
        }
        if (this.dependencyTracker !== null) {
            const outerExtraSize = op === $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b.stroke ? this.current.lineWidth / 2 : 0;
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, this.ctx, minMax[0] - outerExtraSize, minMax[2] + outerExtraSize, minMax[1] - outerExtraSize, minMax[3] + outerExtraSize).recordDependencies(opIdx, [
                "transform"
            ]);
        }
        if (!(path instanceof Path2D)) {
            const path2d = data[0] = new Path2D();
            for(let i = 0, ii = path.length; i < ii;)switch(path[i++]){
                case $5942e8eb8ca60ef8$var$DrawOPS.moveTo:
                    path2d.moveTo(path[i++], path[i++]);
                    break;
                case $5942e8eb8ca60ef8$var$DrawOPS.lineTo:
                    path2d.lineTo(path[i++], path[i++]);
                    break;
                case $5942e8eb8ca60ef8$var$DrawOPS.curveTo:
                    path2d.bezierCurveTo(path[i++], path[i++], path[i++], path[i++], path[i++], path[i++]);
                    break;
                case $5942e8eb8ca60ef8$var$DrawOPS.closePath:
                    path2d.closePath();
                    break;
                default:
                    $5942e8eb8ca60ef8$var$warn(`Unrecognized drawing path operator: ${path[i - 1]}`);
                    break;
            }
            path = path2d;
        }
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(minMax, $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx), this.current.minMax);
        this[op](opIdx, path);
        this._pathStartIdx = opIdx;
    }
    closePath(opIdx) {
        this.ctx.closePath();
    }
    stroke(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                const baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.STROKE, opIdx);
                if (baseTransform) {
                    const newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            } else this.rescaleAndStroke(path, true);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.stroke);
        if (consumePath) this.consumePath(opIdx, path, this.current.getClippedPathBoundingBox($5942e8eb8ca60ef8$var$PathType.STROKE, $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx)));
        ctx.globalAlpha = this.current.fillAlpha;
    }
    closeStroke(opIdx, path) {
        this.stroke(opIdx, path);
    }
    fill(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        if (isPatternFill) {
            const baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            this.dependencyTracker?.save(opIdx);
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.FILL, opIdx);
            if (baseTransform) {
                const newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        const intersect = this.current.getClippedPathBoundingBox();
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            } else ctx.fill(path);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.fill);
        if (needRestore) {
            ctx.restore();
            this.dependencyTracker?.restore(opIdx);
        }
        if (consumePath) this.consumePath(opIdx, path, intersect);
    }
    eoFill(opIdx, path) {
        this.pendingEOFill = true;
        this.fill(opIdx, path);
    }
    fillStroke(opIdx, path) {
        this.fill(opIdx, path, false);
        this.stroke(opIdx, path, false);
        this.consumePath(opIdx, path);
    }
    eoFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    closeFillStroke(opIdx, path) {
        this.fillStroke(opIdx, path);
    }
    closeEOFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    endPath(opIdx, path) {
        this.consumePath(opIdx, path);
    }
    rawFillPath(opIdx, path) {
        this.ctx.fill(path);
        this.dependencyTracker?.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.rawFillPath).recordOperation(opIdx);
    }
    clip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $5942e8eb8ca60ef8$var$NORMAL_CLIP;
    }
    eoClip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $5942e8eb8ca60ef8$var$EO_CLIP;
    }
    beginText(opIdx) {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.dependencyTracker?.recordOpenMarker(opIdx).resetIncrementalData("sameLineText").resetIncrementalData("moveText", opIdx);
    }
    endText(opIdx) {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (this.dependencyTracker) {
            const { dependencyTracker: dependencyTracker } = this;
            if (paths !== undefined) dependencyTracker.recordFutureForcedDependency("textClip", dependencyTracker.getOpenMarker()).recordFutureForcedDependency("textClip", opIdx);
            dependencyTracker.recordCloseMarker(opIdx);
        }
        if (paths !== undefined) {
            const newPath = new Path2D();
            const invTransf = ctx.getTransform().invertSelf();
            for (const { transform: transform, x: x, y: y, fontSize: fontSize, path: path } of paths){
                if (!path) continue;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
            ctx.clip(newPath);
        }
        delete this.pendingTextPaths;
    }
    setCharSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("charSpacing", opIdx);
        this.current.charSpacing = spacing;
    }
    setWordSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("wordSpacing", opIdx);
        this.current.wordSpacing = spacing;
    }
    setHScale(opIdx, scale) {
        this.dependencyTracker?.recordSimpleData("hScale", opIdx);
        this.current.textHScale = scale / 100;
    }
    setLeading(opIdx, leading) {
        this.dependencyTracker?.recordSimpleData("leading", opIdx);
        this.current.leading = -leading;
    }
    setFont(opIdx, fontRefName, size) {
        this.dependencyTracker?.recordSimpleData("font", opIdx).recordSimpleDataFromNamed("fontObj", fontRefName, opIdx);
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $5942e8eb8ca60ef8$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $5942e8eb8ca60ef8$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $5942e8eb8ca60ef8$var$MIN_FONT_SIZE) browserFontSize = $5942e8eb8ca60ef8$var$MIN_FONT_SIZE;
        else if (size > $5942e8eb8ca60ef8$var$MAX_FONT_SIZE) browserFontSize = $5942e8eb8ca60ef8$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(opIdx, mode) {
        this.dependencyTracker?.recordSimpleData("textRenderingMode", opIdx);
        this.current.textRenderingMode = mode;
    }
    setTextRise(opIdx, rise) {
        this.dependencyTracker?.recordSimpleData("textRise", opIdx);
        this.current.textRise = rise;
    }
    moveText(opIdx, x, y) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordIncrementalData("moveText", opIdx);
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(opIdx, x, y) {
        this.setLeading(opIdx, -y);
        this.moveText(opIdx, x, y);
    }
    setTextMatrix(opIdx, matrix) {
        this.dependencyTracker?.recordSimpleData("textMatrix", opIdx);
        const { current: current } = this;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    }
    nextLine(opIdx) {
        this.moveText(opIdx, 0, this.current.leading);
        this.dependencyTracker?.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? opIdx);
    }
    #getScaledPath(path, currentTransform, transform) {
        const newPath = new Path2D();
        newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
        return newPath;
    }
    paintChar(opIdx, character, x, y, patternFillTransform, patternStrokeTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $5942e8eb8ca60ef8$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        const patternStroke = current.patternStroke && !font.missingFile;
        let path;
        if ((font.disableFontFace || isAddToPathSet || patternFill || patternStroke) && !font.missingFile) path = font.getPathGenerator(this.commonObjs, character);
        if (path && (font.disableFontFace || patternFill || patternStroke)) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font);
            let currentTransform;
            if (fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL || fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform(...patternFillTransform);
                    const scaledPath = this.#getScaledPath(path, currentTransform, patternFillTransform);
                    ctx.fill(scaledPath);
                } else ctx.fill(path);
            }
            if (fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.STROKE || fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform ||= ctx.getTransform();
                    ctx.setTransform(...patternStrokeTransform);
                    const { a: a, b: b, c: c, d: d } = currentTransform;
                    const invPatternTransform = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.inverseTransform(patternStrokeTransform);
                    const transf = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform([
                        a,
                        b,
                        c,
                        d,
                        0,
                        0
                    ], invPatternTransform);
                    $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transf, $5942e8eb8ca60ef8$var$XY);
                    ctx.lineWidth *= Math.max($5942e8eb8ca60ef8$var$XY[0], $5942e8eb8ca60ef8$var$XY[1]) / fontSize;
                    ctx.stroke(this.#getScaledPath(path, currentTransform, patternStrokeTransform));
                } else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        } else {
            if (fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL || fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
                this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character));
            }
            if (fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.STROKE || fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE) {
                if (this.dependencyTracker) this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character)).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.stroke);
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $5942e8eb8ca60ef8$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y);
        }
    }
    get isFontSubpixelAAEnabled() {
        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(opIdx, glyphs) {
        if (this.dependencyTracker) {
            this.dependencyTracker.recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.showText).resetBBox(opIdx);
            if (this.current.textRenderingMode & $5942e8eb8ca60ef8$var$TextRenderingMode.ADD_TO_PATH_FLAG) this.dependencyTracker.recordFutureForcedDependency("textClip", opIdx).inheritPendingDependenciesAsFutureForcedDependencies();
        }
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) {
            this.showType3Text(opIdx, glyphs);
            this.dependencyTracker?.recordShowTextOperation(opIdx);
            return undefined;
        }
        const fontSize = current.fontSize;
        if (fontSize === 0) {
            this.dependencyTracker?.recordOperation(opIdx);
            return undefined;
        }
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternFillTransform, patternStrokeTransform;
        if (current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.FILL, opIdx);
            patternFillTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (current.patternStroke) {
            ctx.save();
            const pattern = current.strokeColor.getPattern(ctx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.STROKE, opIdx);
            patternStrokeTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            const fillStrokeMode = current.textRenderingMode & $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE_MASK;
            if (fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.STROKE || fillStrokeMode === $5942e8eb8ca60ef8$var$TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            const joinedChars = chars.join("");
            ctx.fillText(joinedChars, 0, 0);
            if (this.dependencyTracker !== null) {
                const measure = ctx.measureText(joinedChars);
                this.dependencyTracker.recordBBox(opIdx, this.ctx, -measure.actualBoundingBoxLeft, measure.actualBoundingBoxRight, -measure.actualBoundingBoxAscent, measure.actualBoundingBoxDescent).recordShowTextOperation(opIdx);
            }
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            let measure;
            if (font.remeasure && width > 0) {
                measure = ctx.measureText(character);
                const measuredWidth = measure.width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                    this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, measure ? {
                        bbox: null
                    } : font, fontSize / fontSizeScale, scaledX, scaledY, ()=>measure ?? ctx.measureText(character));
                } else {
                    this.paintChar(opIdx, character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(opIdx, accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordShowTextOperation(opIdx);
        return undefined;
    }
    showType3Text(opIdx, glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $5942e8eb8ca60ef8$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $5942e8eb8ca60ef8$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        const dependencyTracker = this.dependencyTracker;
        this.dependencyTracker = dependencyTracker ? new $5942e8eb8ca60ef8$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx) : null;
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) $5942e8eb8ca60ef8$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const p = [
                glyph.width,
                0
            ];
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        if (dependencyTracker) this.dependencyTracker = dependencyTracker;
    }
    setCharWidth(opIdx, xWidth, yWidth) {}
    setCharWidthAndBounds(opIdx, xWidth, yWidth, llx, lly, urx, ury) {
        const clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.dependencyTracker?.recordBBox(opIdx, this.ctx, llx, urx, lly, ury).recordClipBox(opIdx, this.ctx, llx, urx, lly, ury);
        this.endPath(opIdx);
    }
    getColorN_Pattern(opIdx, IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const baseTransform = this.baseTransform || $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx, renderingOpIdx)=>new $5942e8eb8ca60ef8$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    }, undefined, undefined, this.dependencyTracker ? new $5942e8eb8ca60ef8$var$CanvasNestedDependencyTracker(this.dependencyTracker, renderingOpIdx, true) : null)
            };
            pattern = new $5942e8eb8ca60ef8$var$TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(opIdx, IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.current.strokeColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternStroke = true;
    }
    setFillColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.current.fillColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternFill = true;
    }
    setStrokeRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = color;
        this.current.patternStroke = false;
    }
    setStrokeTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    }
    setFillRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = color;
        this.current.patternFill = false;
    }
    setFillTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
    }
    _getPattern(opIdx, objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $5942e8eb8ca60ef8$var$getShadingPattern(this.getObject(opIdx, objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(opIdx, objId) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        this.save(opIdx);
        const pattern = this._getPattern(opIdx, objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.SHADING, opIdx);
        const inv = $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const minMax = $5942e8eb8ca60ef8$var$MIN_MAX_INIT.slice();
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv, minMax);
            const [x0, y0, x1, y1] = minMax;
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.dependencyTracker?.resetBBox(opIdx).recordFullPageBBox(opIdx).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.transform).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.fill).recordOperation(opIdx);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore(opIdx);
    }
    beginInlineImage() {
        $5942e8eb8ca60ef8$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $5942e8eb8ca60ef8$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(opIdx, matrix, bbox) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(opIdx, ...matrix);
        this.baseTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx);
        if (bbox) {
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            const [x0, y0, x1, y1] = bbox;
            const clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.dependencyTracker?.recordClipBox(opIdx, this.ctx, x0, x1, y0, y1);
            this.endPath(opIdx);
        }
    }
    paintFormXObjectEnd(opIdx) {
        if (!this.contentVisible) return;
        this.restore(opIdx);
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        if (this.inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated) $5942e8eb8ca60ef8$var$info("TODO: Support non-isolated groups.");
        if (group.knockout) $5942e8eb8ca60ef8$var$warn("Knockout groups not supported.");
        const currentTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        if (!group.bbox) throw new Error("Bounding box is required.");
        let bounds = $5942e8eb8ca60ef8$var$MIN_MAX_INIT.slice();
        $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(group.bbox, $5942e8eb8ca60ef8$var$getCurrentTransform(currentCtx), bounds);
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        bounds = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.intersect(bounds, canvasBounds) || [
            0,
            0,
            0,
            0
        ];
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        let cacheId = "groupAt" + this.groupLevel;
        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        const groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        let clip = new Path2D();
        const [x0, y0, x1, y1] = group.bbox;
        clip.rect(x0, y0, x1 - x0, y1 - y0);
        if (group.matrix) {
            const path = new Path2D();
            path.addPath(clip, new DOMMatrix(group.matrix));
            clip = path;
        }
        groupCtx.clip(clip);
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null,
            startTransformInverse: null
        });
        if (!group.smask || this.dependencyTracker) {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $5942e8eb8ca60ef8$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.dependencyTracker?.inheritSimpleDataAsFutureForcedDependencies([
            "fillAlpha",
            "strokeAlpha",
            "globalCompositeOperation"
        ]).pushBaseTransform(currentCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    }
    endGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        this.dependencyTracker?.popBaseTransform();
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore(opIdx);
            if (this.dependencyTracker) this.ctx.restore();
        } else {
            this.ctx.restore();
            const currentMtx = $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx);
            this.restore(opIdx);
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $5942e8eb8ca60ef8$var$MIN_MAX_INIT.slice();
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx, dirtyBox);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.compose(dirtyBox);
        }
    }
    beginAnnotation(opIdx, id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $5942e8eb8ca60ef8$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save(opIdx);
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx), $5942e8eb8ca60ef8$var$XY);
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform($5942e8eb8ca60ef8$var$XY[0], 0, 0, -$5942e8eb8ca60ef8$var$XY[1], 0, height * $5942e8eb8ca60ef8$var$XY[1]);
                $5942e8eb8ca60ef8$var$resetCtxToDefault(this.ctx);
            } else {
                $5942e8eb8ca60ef8$var$resetCtxToDefault(this.ctx);
                this.endPath(opIdx);
                const clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new $5942e8eb8ca60ef8$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.transform(opIdx, ...transform);
        this.transform(opIdx, ...matrix);
    }
    endAnnotation(opIdx) {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
    }
    paintImageMaskXObject(opIdx, img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(opIdx, img.data, img);
        img.count = count;
        const ctx = this.ctx;
        const mask = this._createMaskCanvas(opIdx, img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, mask.offsetX, mask.offsetX + maskCanvas.width, mask.offsetY, mask.offsetY + maskCanvas.height).recordOperation(opIdx);
        ctx.restore();
        this.compose();
    }
    paintImageMaskXObjectRepeat(opIdx, img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(opIdx, img.data, img);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $5942e8eb8ca60ef8$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(opIdx, img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        this.dependencyTracker?.resetBBox(opIdx);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
            this.dependencyTracker?.recordBBox(opIdx, this.ctx, trans[4], trans[4] + mask.canvas.width, trans[5], trans[5] + mask.canvas.height);
        }
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageMaskXObjectGroup(opIdx, images) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        this.dependencyTracker?.resetBBox(opIdx).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.transformAndFill);
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(opIdx, data, image);
            $5942e8eb8ca60ef8$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx), $5942e8eb8ca60ef8$var$PathType.FILL, opIdx) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $5942e8eb8ca60ef8$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, width, 0, height);
            ctx.restore();
        }
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageXObject(opIdx, objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $5942e8eb8ca60ef8$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(opIdx, imgData);
    }
    paintImageXObjectRepeat(opIdx, objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $5942e8eb8ca60ef8$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(opIdx, imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return imgData.bitmap;
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return tmpCanvas.canvas;
    }
    paintInlineImageXObject(opIdx, imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const ctx = this.ctx;
        this.save(opIdx);
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
            const tmpCtx = tmpCanvas.context;
            $5942e8eb8ca60ef8$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        const scaled = this._scaleImage(imgToPaint, $5942e8eb8ca60ef8$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $5942e8eb8ca60ef8$var$getImageSmoothingEnabled($5942e8eb8ca60ef8$var$getCurrentTransform(ctx), imgData.interpolate);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, ctx, 0, width, -height, 0).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.imageXObject).recordOperation(opIdx);
        $5942e8eb8ca60ef8$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        this.compose();
        this.restore(opIdx);
    }
    paintInlineImageXObjectGroup(opIdx, imgData, map) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            const tmpCtx = tmpCanvas.context;
            $5942e8eb8ca60ef8$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        this.dependencyTracker?.resetBBox(opIdx);
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $5942e8eb8ca60ef8$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, 1, -1, 0);
            ctx.restore();
        }
        this.dependencyTracker?.recordOperation(opIdx);
        this.compose();
    }
    paintSolidColorImageMask(opIdx) {
        if (!this.contentVisible) return;
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, 0, 1, 0, 1).recordDependencies(opIdx, $5942e8eb8ca60ef8$var$Dependencies.fill).recordOperation(opIdx);
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    }
    markPoint(opIdx, tag) {}
    markPointProps(opIdx, tag, properties) {}
    beginMarkedContent(opIdx, tag) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(opIdx, tag, properties) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent(opIdx) {
        this.dependencyTracker?.endMarkedContent(opIdx);
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat(opIdx) {}
    endCompat(opIdx) {}
    consumePath(opIdx, path, clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $5942e8eb8ca60ef8$var$EO_CLIP) ctx.clip(path, "evenodd");
                else ctx.clip(path);
            }
            this.pendingClip = null;
            this.dependencyTracker?.bboxToClipBoxDropOperation(opIdx).recordFutureForcedDependency("clipPath", opIdx);
        } else this.dependencyTracker?.recordOperation(opIdx);
        this.current.startNewPathAndClipBox(this.current.clipBox);
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $5942e8eb8ca60ef8$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(path, saveRestore) {
        const { ctx: ctx, current: { lineWidth: lineWidth } } = this;
        const [scaleX, scaleY] = this.getScaleForStroking();
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        $5942e8eb8ca60ef8$var$SCALE_MATRIX.a = 1 / scaleX;
        $5942e8eb8ca60ef8$var$SCALE_MATRIX.d = 1 / scaleY;
        const newPath = new Path2D();
        newPath.addPath(path, $5942e8eb8ca60ef8$var$SCALE_MATRIX);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b)if ($5942e8eb8ca60ef8$var$CanvasGraphics.prototype[op] !== undefined) $5942e8eb8ca60ef8$var$CanvasGraphics.prototype[$5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b[op]] = $5942e8eb8ca60ef8$var$CanvasGraphics.prototype[op];
class $5942e8eb8ca60ef8$var$CssFontInfo {
    #buffer;
    #view;
    #decoder;
    static strings = [
        "fontFamily",
        "fontWeight",
        "italicAngle"
    ];
    static write(info) {
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $5942e8eb8ca60ef8$var$CssFontInfo.strings){
            const encoded = encoder.encode(info[prop]);
            encodedStrings[prop] = encoded;
            stringsLength += 4 + encoded.length;
        }
        const buffer = new ArrayBuffer(stringsLength);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        for (const prop of $5942e8eb8ca60ef8$var$CssFontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        $5942e8eb8ca60ef8$var$assert(offset === buffer.byteLength, "CssFontInfo.write: Buffer overflow");
        return buffer;
    }
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(this.#buffer);
        this.#decoder = new TextDecoder();
    }
    #readString(index) {
        $5942e8eb8ca60ef8$var$assert(index < $5942e8eb8ca60ef8$var$CssFontInfo.strings.length, "Invalid string index");
        let offset = 0;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fontFamily() {
        return this.#readString(0);
    }
    get fontWeight() {
        return this.#readString(1);
    }
    get italicAngle() {
        return this.#readString(2);
    }
}
class $5942e8eb8ca60ef8$var$SystemFontInfo {
    #buffer;
    #view;
    #decoder;
    static strings = [
        "css",
        "loadedName",
        "baseFontName",
        "src"
    ];
    static write(info) {
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $5942e8eb8ca60ef8$var$SystemFontInfo.strings){
            const encoded = encoder.encode(info[prop]);
            encodedStrings[prop] = encoded;
            stringsLength += 4 + encoded.length;
        }
        stringsLength += 4;
        let encodedStyleStyle, encodedStyleWeight, lengthEstimate = 1 + stringsLength;
        if (info.style) {
            encodedStyleStyle = encoder.encode(info.style.style);
            encodedStyleWeight = encoder.encode(info.style.weight);
            lengthEstimate += 4 + encodedStyleStyle.length + 4 + encodedStyleWeight.length;
        }
        const buffer = new ArrayBuffer(lengthEstimate);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        view.setUint8(offset++, info.guessFallback ? 1 : 0);
        view.setUint32(offset, 0);
        offset += 4;
        stringsLength = 0;
        for (const prop of $5942e8eb8ca60ef8$var$SystemFontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            stringsLength += 4 + length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        view.setUint32(offset - stringsLength - 4, stringsLength);
        if (info.style) {
            view.setUint32(offset, encodedStyleStyle.length);
            data.set(encodedStyleStyle, offset + 4);
            offset += 4 + encodedStyleStyle.length;
            view.setUint32(offset, encodedStyleWeight.length);
            data.set(encodedStyleWeight, offset + 4);
            offset += 4 + encodedStyleWeight.length;
        }
        $5942e8eb8ca60ef8$var$assert(offset <= buffer.byteLength, "SubstitionInfo.write: Buffer overflow");
        return buffer.transferToFixedLength(offset);
    }
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(this.#buffer);
        this.#decoder = new TextDecoder();
    }
    get guessFallback() {
        return this.#view.getUint8(0) !== 0;
    }
    #readString(index) {
        $5942e8eb8ca60ef8$var$assert(index < $5942e8eb8ca60ef8$var$SystemFontInfo.strings.length, "Invalid string index");
        let offset = 5;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get css() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get baseFontName() {
        return this.#readString(2);
    }
    get src() {
        return this.#readString(3);
    }
    get style() {
        let offset = 1;
        offset += 4 + this.#view.getUint32(offset);
        const styleLength = this.#view.getUint32(offset);
        const style = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, styleLength));
        offset += 4 + styleLength;
        const weightLength = this.#view.getUint32(offset);
        const weight = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, weightLength));
        return {
            style: style,
            weight: weight
        };
    }
}
class $5942e8eb8ca60ef8$var$FontInfo {
    static bools = [
        "black",
        "bold",
        "disableFontFace",
        "fontExtraProperties",
        "isInvalidPDFjsFont",
        "isType3Font",
        "italic",
        "missingFile",
        "remeasure",
        "vertical"
    ];
    static numbers = [
        "ascent",
        "defaultWidth",
        "descent"
    ];
    static strings = [
        "fallbackName",
        "loadedName",
        "mimetype",
        "name"
    ];
    static #OFFSET_NUMBERS = Math.ceil(this.bools.length * 2 / 8);
    static #OFFSET_BBOX = this.#OFFSET_NUMBERS + this.numbers.length * 8;
    static #OFFSET_FONT_MATRIX = this.#OFFSET_BBOX + 1 + 8;
    static #OFFSET_DEFAULT_VMETRICS = this.#OFFSET_FONT_MATRIX + 1 + 48;
    static #OFFSET_STRINGS = this.#OFFSET_DEFAULT_VMETRICS + 1 + 6;
    #buffer;
    #decoder;
    #view;
    constructor({ data: data, extra: extra }){
        this.#buffer = data;
        this.#decoder = new TextDecoder();
        this.#view = new DataView(this.#buffer);
        if (extra) Object.assign(this, extra);
    }
    #readBoolean(index) {
        $5942e8eb8ca60ef8$var$assert(index < $5942e8eb8ca60ef8$var$FontInfo.bools.length, "Invalid boolean index");
        const byteOffset = Math.floor(index / 4);
        const bitOffset = index * 2 % 8;
        const value = this.#view.getUint8(byteOffset) >> bitOffset & 0x03;
        return value === 0x00 ? undefined : value === 0x02;
    }
    get black() {
        return this.#readBoolean(0);
    }
    get bold() {
        return this.#readBoolean(1);
    }
    get disableFontFace() {
        return this.#readBoolean(2);
    }
    get fontExtraProperties() {
        return this.#readBoolean(3);
    }
    get isInvalidPDFjsFont() {
        return this.#readBoolean(4);
    }
    get isType3Font() {
        return this.#readBoolean(5);
    }
    get italic() {
        return this.#readBoolean(6);
    }
    get missingFile() {
        return this.#readBoolean(7);
    }
    get remeasure() {
        return this.#readBoolean(8);
    }
    get vertical() {
        return this.#readBoolean(9);
    }
    #readNumber(index) {
        $5942e8eb8ca60ef8$var$assert(index < $5942e8eb8ca60ef8$var$FontInfo.numbers.length, "Invalid number index");
        return this.#view.getFloat64($5942e8eb8ca60ef8$var$FontInfo.#OFFSET_NUMBERS + index * 8);
    }
    get ascent() {
        return this.#readNumber(0);
    }
    get defaultWidth() {
        return this.#readNumber(1);
    }
    get descent() {
        return this.#readNumber(2);
    }
    get bbox() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_BBOX;
        const numCoords = this.#view.getUint8(offset);
        if (numCoords === 0) return undefined;
        offset += 1;
        const bbox = [];
        for(let i = 0; i < 4; i++){
            bbox.push(this.#view.getInt16(offset, true));
            offset += 2;
        }
        return bbox;
    }
    get fontMatrix() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_FONT_MATRIX;
        const numPoints = this.#view.getUint8(offset);
        if (numPoints === 0) return undefined;
        offset += 1;
        const fontMatrix = [];
        for(let i = 0; i < 6; i++){
            fontMatrix.push(this.#view.getFloat64(offset, true));
            offset += 8;
        }
        return fontMatrix;
    }
    get defaultVMetrics() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_DEFAULT_VMETRICS;
        const numMetrics = this.#view.getUint8(offset);
        if (numMetrics === 0) return undefined;
        offset += 1;
        const defaultVMetrics = [];
        for(let i = 0; i < 3; i++){
            defaultVMetrics.push(this.#view.getInt16(offset, true));
            offset += 2;
        }
        return defaultVMetrics;
    }
    #readString(index) {
        $5942e8eb8ca60ef8$var$assert(index < $5942e8eb8ca60ef8$var$FontInfo.strings.length, "Invalid string index");
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS + 4;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        const stringData = new Uint8Array(length);
        stringData.set(new Uint8Array(this.#buffer, offset + 4, length));
        return this.#decoder.decode(stringData);
    }
    get fallbackName() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get mimetype() {
        return this.#readString(2);
    }
    get name() {
        return this.#readString(3);
    }
    get data() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        if (length === 0) return undefined;
        return new Uint8Array(this.#buffer, offset + 4, length);
    }
    clearData() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        const data = new Uint8Array(this.#buffer, offset + 4, length);
        data.fill(0);
        this.#view.setUint32(offset, 0);
    }
    get cssFontInfo() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        if (cssFontInfoLength === 0) return null;
        const cssFontInfoData = new Uint8Array(cssFontInfoLength);
        cssFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, cssFontInfoLength));
        return new $5942e8eb8ca60ef8$var$CssFontInfo(cssFontInfoData.buffer);
    }
    get systemFontInfo() {
        let offset = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        if (systemFontInfoLength === 0) return null;
        const systemFontInfoData = new Uint8Array(systemFontInfoLength);
        systemFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, systemFontInfoLength));
        return new $5942e8eb8ca60ef8$var$SystemFontInfo(systemFontInfoData.buffer);
    }
    static write(font) {
        const systemFontInfoBuffer = font.systemFontInfo ? $5942e8eb8ca60ef8$var$SystemFontInfo.write(font.systemFontInfo) : null;
        const cssFontInfoBuffer = font.cssFontInfo ? $5942e8eb8ca60ef8$var$CssFontInfo.write(font.cssFontInfo) : null;
        const encoder = new TextEncoder();
        const encodedStrings = {};
        let stringsLength = 0;
        for (const prop of $5942e8eb8ca60ef8$var$FontInfo.strings){
            encodedStrings[prop] = encoder.encode(font[prop]);
            stringsLength += 4 + encodedStrings[prop].length;
        }
        const lengthEstimate = $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS + 4 + stringsLength + 4 + (systemFontInfoBuffer ? systemFontInfoBuffer.byteLength : 0) + 4 + (cssFontInfoBuffer ? cssFontInfoBuffer.byteLength : 0) + 4 + (font.data ? font.data.length : 0);
        const buffer = new ArrayBuffer(lengthEstimate);
        const data = new Uint8Array(buffer);
        const view = new DataView(buffer);
        let offset = 0;
        const numBools = $5942e8eb8ca60ef8$var$FontInfo.bools.length;
        let boolByte = 0, boolBit = 0;
        for(let i = 0; i < numBools; i++){
            const value = font[$5942e8eb8ca60ef8$var$FontInfo.bools[i]];
            const bits = value === undefined ? 0x00 : value ? 0x02 : 0x01;
            boolByte |= bits << boolBit;
            boolBit += 2;
            if (boolBit === 8 || i === numBools - 1) {
                view.setUint8(offset++, boolByte);
                boolByte = 0;
                boolBit = 0;
            }
        }
        $5942e8eb8ca60ef8$var$assert(offset === $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_NUMBERS, "FontInfo.write: Boolean properties offset mismatch");
        for (const prop of $5942e8eb8ca60ef8$var$FontInfo.numbers){
            view.setFloat64(offset, font[prop]);
            offset += 8;
        }
        $5942e8eb8ca60ef8$var$assert(offset === $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_BBOX, "FontInfo.write: Number properties offset mismatch");
        if (font.bbox) {
            view.setUint8(offset++, 4);
            for (const coord of font.bbox){
                view.setInt16(offset, coord, true);
                offset += 2;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 8;
        }
        $5942e8eb8ca60ef8$var$assert(offset === $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_FONT_MATRIX, "FontInfo.write: BBox properties offset mismatch");
        if (font.fontMatrix) {
            view.setUint8(offset++, 6);
            for (const point of font.fontMatrix){
                view.setFloat64(offset, point, true);
                offset += 8;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 48;
        }
        $5942e8eb8ca60ef8$var$assert(offset === $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_DEFAULT_VMETRICS, "FontInfo.write: FontMatrix properties offset mismatch");
        if (font.defaultVMetrics) {
            view.setUint8(offset++, 1);
            for (const metric of font.defaultVMetrics){
                view.setInt16(offset, metric, true);
                offset += 2;
            }
        } else {
            view.setUint8(offset++, 0);
            offset += 6;
        }
        $5942e8eb8ca60ef8$var$assert(offset === $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS, "FontInfo.write: DefaultVMetrics properties offset mismatch");
        view.setUint32($5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS, 0);
        offset += 4;
        for (const prop of $5942e8eb8ca60ef8$var$FontInfo.strings){
            const encoded = encodedStrings[prop];
            const length = encoded.length;
            view.setUint32(offset, length);
            data.set(encoded, offset + 4);
            offset += 4 + length;
        }
        view.setUint32($5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS, offset - $5942e8eb8ca60ef8$var$FontInfo.#OFFSET_STRINGS - 4);
        if (!systemFontInfoBuffer) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            const length = systemFontInfoBuffer.byteLength;
            view.setUint32(offset, length);
            $5942e8eb8ca60ef8$var$assert(offset + 4 + length <= buffer.byteLength, "FontInfo.write: Buffer overflow at systemFontInfo");
            data.set(new Uint8Array(systemFontInfoBuffer), offset + 4);
            offset += 4 + length;
        }
        if (!cssFontInfoBuffer) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            const length = cssFontInfoBuffer.byteLength;
            view.setUint32(offset, length);
            $5942e8eb8ca60ef8$var$assert(offset + 4 + length <= buffer.byteLength, "FontInfo.write: Buffer overflow at cssFontInfo");
            data.set(new Uint8Array(cssFontInfoBuffer), offset + 4);
            offset += 4 + length;
        }
        if (font.data === undefined) {
            view.setUint32(offset, 0);
            offset += 4;
        } else {
            view.setUint32(offset, font.data.length);
            data.set(font.data, offset + 4);
            offset += 4 + font.data.length;
        }
        $5942e8eb8ca60ef8$var$assert(offset <= buffer.byteLength, "FontInfo.write: Buffer overflow");
        return buffer.transferToFixedLength(offset);
    }
}
class $5942e8eb8ca60ef8$export$edf38ba293eb934 {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
class $5942e8eb8ca60ef8$var$Metadata {
    #map;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#map = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#map.get(name) ?? null;
    }
    [Symbol.iterator]() {
        return this.#map.entries();
    }
}
const $5942e8eb8ca60ef8$var$INTERNAL = Symbol("INTERNAL");
class $5942e8eb8ca60ef8$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage, rbGroups: rbGroups }){
        this.#isDisplay = !!(renderingIntent & $5942e8eb8ca60ef8$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $5942e8eb8ca60ef8$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $5942e8eb8ca60ef8$var$INTERNAL) $5942e8eb8ca60ef8$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $5942e8eb8ca60ef8$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $5942e8eb8ca60ef8$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $5942e8eb8ca60ef8$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($5942e8eb8ca60ef8$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($5942e8eb8ca60ef8$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($5942e8eb8ca60ef8$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $5942e8eb8ca60ef8$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $5942e8eb8ca60ef8$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $5942e8eb8ca60ef8$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true, preserveRB = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $5942e8eb8ca60ef8$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) for (const rbGroup of group.rbGroups){
            for (const otherId of rbGroup)if (otherId !== id) this.#groups.get(otherId)?._setVisible($5942e8eb8ca60ef8$var$INTERNAL, false, true);
        }
        group._setVisible($5942e8eb8ca60ef8$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    this.setVisibility(elem, true, preserveRB);
                    break;
                case "OFF":
                    this.setVisibility(elem, false, preserveRB);
                    break;
                case "Toggle":
                    this.setVisibility(elem, !group.visible, preserveRB);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $5942e8eb8ca60ef8$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
    [Symbol.iterator]() {
        return this.#groups.entries();
    }
}
class $5942e8eb8ca60ef8$var$PDFDataTransportStream {
    constructor(pdfDataRangeTransport, { disableRange: disableRange = false, disableStream: disableStream = false }){
        $5942e8eb8ca60ef8$var$assert(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
        const { length: length, initialData: initialData, progressiveDone: progressiveDone, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = [];
        this._progressiveDone = progressiveDone;
        this._contentDispositionFilename = contentDispositionFilename;
        if (initialData?.length > 0) {
            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
        }
        this._pdfDataRangeTransport = pdfDataRangeTransport;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        this._contentLength = length;
        this._fullRequestReader = null;
        this._rangeReaders = [];
        pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
            this._onReceiveData({
                begin: begin,
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressListener((loaded, total)=>{
            this._onProgress({
                loaded: loaded,
                total: total
            });
        });
        pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
            this._onReceiveData({
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressiveDoneListener(()=>{
            this._onProgressiveDone();
        });
        pdfDataRangeTransport.transportReady();
    }
    _onReceiveData({ begin: begin, chunk: chunk }) {
        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
        if (begin === undefined) {
            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const found = this._rangeReaders.some(function(rangeReader) {
                if (rangeReader._begin !== begin) return false;
                rangeReader._enqueue(buffer);
                return true;
            });
            $5942e8eb8ca60ef8$var$assert(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
        }
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    _onProgress(evt) {
        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
            loaded: evt.loaded
        });
        else this._fullRequestReader?.onProgress?.({
            loaded: evt.loaded,
            total: evt.total
        });
    }
    _onProgressiveDone() {
        this._fullRequestReader?.progressiveDone();
        this._progressiveDone = true;
    }
    _removeRangeReader(reader) {
        const i = this._rangeReaders.indexOf(reader);
        if (i >= 0) this._rangeReaders.splice(i, 1);
    }
    getFullReader() {
        $5942e8eb8ca60ef8$var$assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
        const queuedChunks = this._queuedChunks;
        this._queuedChunks = null;
        return new $5942e8eb8ca60ef8$var$PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $5942e8eb8ca60ef8$var$PDFDataTransportStreamRangeReader(this, begin, end);
        this._pdfDataRangeTransport.requestDataRange(begin, end);
        this._rangeReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
        this._pdfDataRangeTransport.abort();
    }
}
class $5942e8eb8ca60ef8$var$PDFDataTransportStreamReader {
    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
        this._stream = stream;
        this._done = progressiveDone || false;
        this._filename = $5942e8eb8ca60ef8$export$61b52d3570d24719(contentDispositionFilename) ? contentDispositionFilename : null;
        this._queuedChunks = queuedChunks || [];
        this._loaded = 0;
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._requests = [];
        this._headersReady = Promise.resolve();
        stream._fullRequestReader = this;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
    }
    get headersReady() {
        return this._headersReady;
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._stream._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._stream._isStreamingSupported;
    }
    get contentLength() {
        return this._stream._contentLength;
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    progressiveDone() {
        if (this._done) return;
        this._done = true;
    }
}
class $5942e8eb8ca60ef8$var$PDFDataTransportStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._begin = begin;
        this._end = end;
        this._queuedChunk = null;
        this._requests = [];
        this._done = false;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const requestsCapability = this._requests.shift();
            requestsCapability.resolve({
                value: chunk,
                done: false
            });
            for (const requestCapability of this._requests)requestCapability.resolve({
                value: undefined,
                done: true
            });
            this._requests.length = 0;
        }
        this._done = true;
        this._stream._removeRangeReader(this);
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._stream._removeRangeReader(this);
    }
}
function $5942e8eb8ca60ef8$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $5942e8eb8ca60ef8$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $5942e8eb8ca60ef8$var$createHeaders(isHttp, httpHeaders) {
    const headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") return headers;
    for(const key in httpHeaders){
        const val = httpHeaders[key];
        if (val !== undefined) headers.append(key, val);
    }
    return headers;
}
function $5942e8eb8ca60ef8$var$getResponseOrigin(url) {
    return URL.parse(url)?.origin ?? null;
}
function $5942e8eb8ca60ef8$var$validateRangeRequestCapabilities({ responseHeaders: responseHeaders, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const returnValues = {
        allowRangeRequests: false,
        suggestedLength: undefined
    };
    const length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) return returnValues;
    returnValues.suggestedLength = length;
    if (length <= 2 * rangeChunkSize) return returnValues;
    if (disableRange || !isHttp) return returnValues;
    if (responseHeaders.get("Accept-Ranges") !== "bytes") return returnValues;
    const contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding !== "identity") return returnValues;
    returnValues.allowRangeRequests = true;
    return returnValues;
}
function $5942e8eb8ca60ef8$var$extractFilenameFromHeader(responseHeaders) {
    const contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        let filename = $5942e8eb8ca60ef8$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($5942e8eb8ca60ef8$export$61b52d3570d24719(filename)) return filename;
    }
    return null;
}
function $5942e8eb8ca60ef8$var$createResponseError(status, url) {
    return new $5942e8eb8ca60ef8$export$ea8e9c34f66e603(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status, status === 404 || status === 0 && url.startsWith("file:"));
}
function $5942e8eb8ca60ef8$var$validateResponseStatus(status) {
    return status === 200 || status === 206;
}
function $5942e8eb8ca60ef8$var$createFetchOptions(headers, withCredentials, abortController) {
    return {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    };
}
function $5942e8eb8ca60ef8$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    $5942e8eb8ca60ef8$var$warn(`getArrayBuffer - unexpected data format: ${val}`);
    return new Uint8Array(val).buffer;
}
class $5942e8eb8ca60ef8$var$PDFFetchStream {
    _responseOrigin = null;
    constructor(source){
        this.source = source;
        this.isHttp = /^https?:/i.test(source.url);
        this.headers = $5942e8eb8ca60ef8$var$createHeaders(this.isHttp, source.httpHeaders);
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $5942e8eb8ca60ef8$var$assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
        this._fullRequestReader = new $5942e8eb8ca60ef8$var$PDFFetchStreamReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $5942e8eb8ca60ef8$var$PDFFetchStreamRangeReader(this, begin, end);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $5942e8eb8ca60ef8$var$PDFFetchStreamReader {
    constructor(stream){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        this._filename = null;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._contentLength = source.length;
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._abortController = new AbortController();
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        const headers = new Headers(stream.headers);
        const url = source.url;
        fetch(url, $5942e8eb8ca60ef8$var$createFetchOptions(headers, this._withCredentials, this._abortController)).then((response)=>{
            stream._responseOrigin = $5942e8eb8ca60ef8$var$getResponseOrigin(response.url);
            if (!$5942e8eb8ca60ef8$var$validateResponseStatus(response.status)) throw $5942e8eb8ca60ef8$var$createResponseError(response.status, url);
            this._reader = response.body.getReader();
            this._headersCapability.resolve();
            const responseHeaders = response.headers;
            const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $5942e8eb8ca60ef8$var$validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: stream.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
            });
            this._isRangeSupported = allowRangeRequests;
            this._contentLength = suggestedLength || this._contentLength;
            this._filename = $5942e8eb8ca60ef8$var$extractFilenameFromHeader(responseHeaders);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $5942e8eb8ca60ef8$export$d0e978393d193d1a("Streaming is disabled."));
        }).catch(this._headersCapability.reject);
        this.onProgress = null;
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        return {
            value: $5942e8eb8ca60ef8$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $5942e8eb8ca60ef8$var$PDFFetchStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._readCapability = Promise.withResolvers();
        this._isStreamingSupported = !source.disableStream;
        this._abortController = new AbortController();
        const headers = new Headers(stream.headers);
        headers.append("Range", `bytes=${begin}-${end - 1}`);
        const url = source.url;
        fetch(url, $5942e8eb8ca60ef8$var$createFetchOptions(headers, this._withCredentials, this._abortController)).then((response)=>{
            const responseOrigin = $5942e8eb8ca60ef8$var$getResponseOrigin(response.url);
            if (responseOrigin !== stream._responseOrigin) throw new Error(`Expected range response-origin "${responseOrigin}" to match "${stream._responseOrigin}".`);
            if (!$5942e8eb8ca60ef8$var$validateResponseStatus(response.status)) throw $5942e8eb8ca60ef8$var$createResponseError(response.status, url);
            this._readCapability.resolve();
            this._reader = response.body.getReader();
        }).catch(this._readCapability.reject);
        this.onProgress = null;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded
        });
        return {
            value: $5942e8eb8ca60ef8$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
const $5942e8eb8ca60ef8$var$OK_RESPONSE = 200;
const $5942e8eb8ca60ef8$var$PARTIAL_CONTENT_RESPONSE = 206;
function $5942e8eb8ca60ef8$var$network_getArrayBuffer(xhr) {
    const data = xhr.response;
    if (typeof data !== "string") return data;
    return $5942e8eb8ca60ef8$var$stringToBytes(data).buffer;
}
class $5942e8eb8ca60ef8$var$NetworkManager {
    _responseOrigin = null;
    constructor({ url: url, httpHeaders: httpHeaders, withCredentials: withCredentials }){
        this.url = url;
        this.isHttp = /^https?:/i.test(url);
        this.headers = $5942e8eb8ca60ef8$var$createHeaders(this.isHttp, httpHeaders);
        this.withCredentials = withCredentials || false;
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
    }
    request(args) {
        const xhr = new XMLHttpRequest();
        const xhrId = this.currXhrId++;
        const pendingRequest = this.pendingRequests[xhrId] = {
            xhr: xhr
        };
        xhr.open("GET", this.url);
        xhr.withCredentials = this.withCredentials;
        for (const [key, val] of this.headers)xhr.setRequestHeader(key, val);
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.expectedStatus = $5942e8eb8ca60ef8$var$PARTIAL_CONTENT_RESPONSE;
        } else pendingRequest.expectedStatus = $5942e8eb8ca60ef8$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        $5942e8eb8ca60ef8$var$assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = ()=>{
            args.onError(xhr.status);
        };
        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
        xhr.onprogress = this.onProgress.bind(this, xhrId);
        pendingRequest.onHeadersReceived = args.onHeadersReceived;
        pendingRequest.onDone = args.onDone;
        pendingRequest.onError = args.onError;
        pendingRequest.onProgress = args.onProgress;
        xhr.send(null);
        return xhrId;
    }
    onProgress(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        pendingRequest.onProgress?.(evt);
    }
    onStateChange(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        const xhr = pendingRequest.xhr;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!(xhrId in this.pendingRequests)) return;
        delete this.pendingRequests[xhrId];
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $5942e8eb8ca60ef8$var$OK_RESPONSE;
        const ok_response_on_range_request = xhrStatus === $5942e8eb8ca60ef8$var$OK_RESPONSE && pendingRequest.expectedStatus === $5942e8eb8ca60ef8$var$PARTIAL_CONTENT_RESPONSE;
        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const chunk = $5942e8eb8ca60ef8$var$network_getArrayBuffer(xhr);
        if (xhrStatus === $5942e8eb8ca60ef8$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
            if (matches) pendingRequest.onDone({
                begin: parseInt(matches[1], 10),
                chunk: chunk
            });
            else {
                $5942e8eb8ca60ef8$var$warn(`Missing or invalid "Content-Range" header.`);
                pendingRequest.onError(0);
            }
        } else if (chunk) pendingRequest.onDone({
            begin: 0,
            chunk: chunk
        });
        else pendingRequest.onError(xhr.status);
    }
    getRequestXhr(xhrId) {
        return this.pendingRequests[xhrId].xhr;
    }
    isPendingRequest(xhrId) {
        return xhrId in this.pendingRequests;
    }
    abortRequest(xhrId) {
        const xhr = this.pendingRequests[xhrId].xhr;
        delete this.pendingRequests[xhrId];
        xhr.abort();
    }
}
class $5942e8eb8ca60ef8$var$PDFNetworkStream {
    constructor(source){
        this._source = source;
        this._manager = new $5942e8eb8ca60ef8$var$NetworkManager(source);
        this._rangeChunkSize = source.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    _onRangeRequestReaderClosed(reader) {
        const i = this._rangeRequestReaders.indexOf(reader);
        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
    }
    getFullReader() {
        $5942e8eb8ca60ef8$var$assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
        this._fullRequestReader = new $5942e8eb8ca60ef8$var$PDFNetworkStreamFullRequestReader(this._manager, this._source);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        const reader = new $5942e8eb8ca60ef8$var$PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $5942e8eb8ca60ef8$var$PDFNetworkStreamFullRequestReader {
    constructor(manager, source){
        this._manager = manager;
        this._url = source.url;
        this._fullRequestId = manager.request({
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._contentLength = source.length;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = false;
        this._isRangeSupported = false;
        this._cachedChunks = [];
        this._requests = [];
        this._done = false;
        this._storedError = undefined;
        this._filename = null;
        this.onProgress = null;
    }
    _onHeadersReceived() {
        const fullRequestXhrId = this._fullRequestId;
        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
        this._manager._responseOrigin = $5942e8eb8ca60ef8$var$getResponseOrigin(fullRequestXhr.responseURL);
        const rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        const responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((x)=>{
            const [key, ...val] = x.split(": ");
            return [
                key,
                val.join(": ")
            ];
        }) : []);
        const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $5942e8eb8ca60ef8$var$validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: this._manager.isHttp,
            rangeChunkSize: this._rangeChunkSize,
            disableRange: this._disableRange
        });
        if (allowRangeRequests) this._isRangeSupported = true;
        this._contentLength = suggestedLength || this._contentLength;
        this._filename = $5942e8eb8ca60ef8$var$extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
        this._headersCapability.resolve();
    }
    _onDone(data) {
        if (data) {
            if (this._requests.length > 0) {
                const requestCapability = this._requests.shift();
                requestCapability.resolve({
                    value: data.chunk,
                    done: false
                });
            } else this._cachedChunks.push(data.chunk);
        }
        this._done = true;
        if (this._cachedChunks.length > 0) return;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    _onError(status) {
        this._storedError = $5942e8eb8ca60ef8$var$createResponseError(status, this._url);
        this._headersCapability.reject(this._storedError);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    _onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    get contentLength() {
        return this._contentLength;
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    async read() {
        await this._headersCapability.promise;
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersCapability.reject(reason);
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
        this._fullRequestReader = null;
    }
}
class $5942e8eb8ca60ef8$var$PDFNetworkStreamRangeRequestReader {
    constructor(manager, begin, end){
        this._manager = manager;
        this._url = manager.url;
        this._requestId = manager.request({
            begin: begin,
            end: end,
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._requests = [];
        this._queuedChunk = null;
        this._done = false;
        this._storedError = undefined;
        this.onProgress = null;
        this.onClosed = null;
    }
    _onHeadersReceived() {
        const responseOrigin = $5942e8eb8ca60ef8$var$getResponseOrigin(this._manager.getRequestXhr(this._requestId)?.responseURL);
        if (responseOrigin !== this._manager._responseOrigin) {
            this._storedError = new Error(`Expected range response-origin "${responseOrigin}" to match "${this._manager._responseOrigin}".`);
            this._onError(0);
        }
    }
    _close() {
        this.onClosed?.(this);
    }
    _onDone(data) {
        const chunk = data.chunk;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._close();
    }
    _onError(status) {
        this._storedError ??= $5942e8eb8ca60ef8$var$createResponseError(status, this._url);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    _onProgress(evt) {
        if (!this.isStreamingSupported) this.onProgress?.({
            loaded: evt.loaded
        });
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
        this._close();
    }
}
const $5942e8eb8ca60ef8$var$urlRegex = /^[a-z][a-z0-9\-+.]+:/i;
function $5942e8eb8ca60ef8$var$parseUrlOrPath(sourceUrl) {
    if ($5942e8eb8ca60ef8$var$urlRegex.test(sourceUrl)) return new URL(sourceUrl);
    const url = $hPtJY.getBuiltinModule("url");
    return new URL(url.pathToFileURL(sourceUrl));
}
class $5942e8eb8ca60ef8$var$PDFNodeStream {
    constructor(source){
        this.source = source;
        this.url = $5942e8eb8ca60ef8$var$parseUrlOrPath(source.url);
        $5942e8eb8ca60ef8$var$assert(this.url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $5942e8eb8ca60ef8$var$assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
        this._fullRequestReader = new $5942e8eb8ca60ef8$var$PDFNodeStreamFsFullReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(start, end) {
        if (end <= this._progressiveDataLength) return null;
        const rangeReader = new $5942e8eb8ca60ef8$var$PDFNodeStreamFsRangeReader(this, start, end);
        this._rangeRequestReaders.push(rangeReader);
        return rangeReader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $5942e8eb8ca60ef8$var$PDFNodeStreamFsFullReader {
    constructor(stream){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        const source = stream.source;
        this._contentLength = source.length;
        this._loaded = 0;
        this._filename = null;
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        this._headersCapability = Promise.withResolvers();
        const fs = $hPtJY.getBuiltinModule("fs");
        fs.promises.lstat(this._url).then((stat)=>{
            this._contentLength = stat.size;
            this._setReadableStream(fs.createReadStream(this._url));
            this._headersCapability.resolve();
        }, (error)=>{
            if (error.code === "ENOENT") error = $5942e8eb8ca60ef8$var$createResponseError(0, this._url.href);
            this._storedError = error;
            this._headersCapability.reject(error);
        });
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new $5942e8eb8ca60ef8$export$d0e978393d193d1a("streaming is disabled"));
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
class $5942e8eb8ca60ef8$var$PDFNodeStreamFsRangeReader {
    constructor(stream, start, end){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        this._loaded = 0;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        const source = stream.source;
        this._isStreamingSupported = !source.disableStream;
        const fs = $hPtJY.getBuiltinModule("fs");
        this._setReadableStream(fs.createReadStream(this._url, {
            start: start,
            end: end - 1
        }));
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
const $5942e8eb8ca60ef8$var$INITIAL_DATA = Symbol("INITIAL_DATA");
class $5942e8eb8ca60ef8$var$PDFObjects {
    #objs = Object.create(null);
    #ensureObj(objId) {
        return this.#objs[objId] ||= {
            ...Promise.withResolvers(),
            data: $5942e8eb8ca60ef8$var$INITIAL_DATA
        };
    }
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#ensureObj(objId);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs[objId];
        if (!obj || obj.data === $5942e8eb8ca60ef8$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs[objId];
        return !!obj && obj.data !== $5942e8eb8ca60ef8$var$INITIAL_DATA;
    }
    delete(objId) {
        const obj = this.#objs[objId];
        if (!obj || obj.data === $5942e8eb8ca60ef8$var$INITIAL_DATA) return false;
        delete this.#objs[objId];
        return true;
    }
    resolve(objId, data = null) {
        const obj = this.#ensureObj(objId);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            data?.bitmap?.close();
        }
        this.#objs = Object.create(null);
    }
    *[Symbol.iterator]() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            if (data === $5942e8eb8ca60ef8$var$INITIAL_DATA) continue;
            yield [
                objId,
                data
            ];
        }
    }
}
const $5942e8eb8ca60ef8$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $5942e8eb8ca60ef8$var$DEFAULT_FONT_SIZE = 30;
class $5942e8eb8ca60ef8$export$fdbdc423a78c5262 {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #canvasCtxFonts = new WeakMap();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#scale = viewport.scale * $5942e8eb8ca60ef8$export$f16a99f63bccd50b.pixelRatio;
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#ensureMinFontSizeComputed();
        $5942e8eb8ca60ef8$export$af0a15a86e590226(container, viewport);
        this.#capability.promise.finally(()=>{
            $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        }).catch(()=>{});
    }
    static get fontFamilyMap() {
        const { isWindows: isWindows, isFirefox: isFirefox } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "fontFamilyMap", new Map([
            [
                "sans-serif",
                `${isWindows && isFirefox ? "Calibri, " : ""}sans-serif`
            ],
            [
                "monospace",
                `${isWindows && isFirefox ? "Lucida Console, " : ""}monospace`
            ]
        ]));
    }
    render() {
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * $5942e8eb8ca60ef8$export$f16a99f63bccd50b.pixelRatio;
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $5942e8eb8ca60ef8$export$af0a15a86e590226(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                div: null,
                properties: null,
                ctx: $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $5942e8eb8ca60ef8$export$d0e978393d193d1a("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $5942e8eb8ca60ef8$var$MAX_TEXT_DIVS_TO_RENDER) {
                $5942e8eb8ca60ef8$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id) this.#container.setAttribute("id", `${item.id}`);
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        let fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        fontFamily = $5942e8eb8ca60ef8$export$fdbdc423a78c5262.fontFamilyMap.get(fontFamily) || fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#getAscent(fontFamily, style, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const scaleFactorStr = "calc(var(--total-scale-factor) *";
        const divStyle = textDiv.style;
        if (this.#container === this.#rootContainer) {
            divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
            divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        } else {
            divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
            divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
        }
        divStyle.fontSize = `${scaleFactorStr}${($5942e8eb8ca60ef8$export$fdbdc423a78c5262.#minFontSize * fontHeight).toFixed(2)}px)`;
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx } = params;
        const { style: style } = div;
        let transform = "";
        if ($5942e8eb8ca60ef8$export$fdbdc423a78c5262.#minFontSize > 1) transform = `scale(${1 / $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#minFontSize})`;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            $5942e8eb8ca60ef8$export$fdbdc423a78c5262.#ensureCtxFont(ctx, fontSize * this.#scale, fontFamily);
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) transform = `scaleX(${canvasWidth * this.#scale / width}) ${transform}`;
        }
        if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
        if (transform.length > 0) style.transform = transform;
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let ctx = this.#canvasContexts.get(lang ||= "");
        if (!ctx) {
            const canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, ctx);
            this.#canvasCtxFonts.set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }
    static #ensureCtxFont(ctx, size, family) {
        const cached = this.#canvasCtxFonts.get(ctx);
        if (size === cached.size && family === cached.family) return;
        ctx.font = `${size}px ${family}`;
        cached.size = size;
        cached.family = family;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, style, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        ctx.canvas.width = ctx.canvas.height = $5942e8eb8ca60ef8$var$DEFAULT_FONT_SIZE;
        this.#ensureCtxFont(ctx, $5942e8eb8ca60ef8$var$DEFAULT_FONT_SIZE, fontFamily);
        const metrics = ctx.measureText("");
        const ascent = metrics.fontBoundingBoxAscent;
        const descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        let ratio = 0.8;
        if (ascent) ratio = ascent / (ascent + descent);
        else {
            if ($5942e8eb8ca60ef8$export$5fb8891d35c36978.platform.isFirefox) $5942e8eb8ca60ef8$var$warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.");
            if (style.ascent) ratio = style.ascent;
            else if (style.descent) ratio = 1 + style.descent;
        }
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
const $5942e8eb8ca60ef8$var$RENDERING_CANCELLED_TIMEOUT = 100;
function $5942e8eb8ca60ef8$export$f65ca476c09acec0(src = {}) {
    if (typeof src === "string" || src instanceof URL) src = {
        url: src
    };
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = {
        data: src
    };
    const task = new $5942e8eb8ca60ef8$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $5942e8eb8ca60ef8$var$getUrlProp(src.url) : null;
    const data = src.data ? $5942e8eb8ca60ef8$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $5942e8eb8ca60ef8$export$c06899d9d7bce9ab ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : 2 ** 16;
    let worker = src.worker instanceof $5942e8eb8ca60ef8$export$84e2e9f37426b265 ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$5942e8eb8ca60ef8$export$f67aae4532d8295b(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = $5942e8eb8ca60ef8$var$getFactoryUrlProp(src.cMapUrl);
    const cMapPacked = src.cMapPacked !== false;
    const CMapReaderFactory = src.CMapReaderFactory || ($5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$NodeCMapReaderFactory : $5942e8eb8ca60ef8$var$DOMCMapReaderFactory);
    const iccUrl = $5942e8eb8ca60ef8$var$getFactoryUrlProp(src.iccUrl);
    const standardFontDataUrl = $5942e8eb8ca60ef8$var$getFactoryUrlProp(src.standardFontDataUrl);
    const StandardFontDataFactory = src.StandardFontDataFactory || ($5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$NodeStandardFontDataFactory : $5942e8eb8ca60ef8$var$DOMStandardFontDataFactory);
    const wasmUrl = $5942e8eb8ca60ef8$var$getFactoryUrlProp(src.wasmUrl);
    const WasmFactory = src.WasmFactory || ($5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$NodeWasmFactory : $5942e8eb8ca60ef8$var$DOMWasmFactory);
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isEvalSupported = src.isEvalSupported !== false;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$5942e8eb8ca60ef8$var$isNodeJS;
    const isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !$5942e8eb8ca60ef8$var$isNodeJS && ($5942e8eb8ca60ef8$export$5fb8891d35c36978.platform.isFirefox || !globalThis.chrome);
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $5942e8eb8ca60ef8$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const CanvasFactory = src.CanvasFactory || ($5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$NodeCanvasFactory : $5942e8eb8ca60ef8$var$DOMCanvasFactory);
    const FilterFactory = src.FilterFactory || ($5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$NodeFilterFactory : $5942e8eb8ca60ef8$var$DOMFilterFactory);
    const enableHWA = src.enableHWA === true;
    const useWasm = src.useWasm !== false;
    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$5942e8eb8ca60ef8$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(CMapReaderFactory === $5942e8eb8ca60ef8$var$DOMCMapReaderFactory && StandardFontDataFactory === $5942e8eb8ca60ef8$var$DOMStandardFontDataFactory && WasmFactory === $5942e8eb8ca60ef8$var$DOMWasmFactory && cMapUrl && standardFontDataUrl && wasmUrl && $5942e8eb8ca60ef8$var$isValidFetchUrl(cMapUrl, document.baseURI) && $5942e8eb8ca60ef8$var$isValidFetchUrl(standardFontDataUrl, document.baseURI) && $5942e8eb8ca60ef8$var$isValidFetchUrl(wasmUrl, document.baseURI));
    const styleElement = null;
    $5942e8eb8ca60ef8$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        cMapReaderFactory: useWorkerFetch ? null : new CMapReaderFactory({
            baseUrl: cMapUrl,
            isCompressed: cMapPacked
        }),
        standardFontDataFactory: useWorkerFetch ? null : new StandardFontDataFactory({
            baseUrl: standardFontDataUrl
        }),
        wasmFactory: useWorkerFetch ? null : new WasmFactory({
            baseUrl: wasmUrl
        })
    };
    if (!worker) {
        worker = $5942e8eb8ca60ef8$export$84e2e9f37426b265.create({
            verbosity: verbosity,
            port: $5942e8eb8ca60ef8$export$edf38ba293eb934.workerPort
        });
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "5.4.296",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        length: length,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        }
    };
    const transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    worker.promise.then(function() {
        if (task.destroyed) throw new Error("Loading aborted");
        if (worker.destroyed) throw new Error("Worker was destroyed");
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (rangeTransport) networkStream = new $5942e8eb8ca60ef8$var$PDFDataTransportStream(rangeTransport, {
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (!data) {
            if (!url) throw new Error("getDocument - no `url` parameter provided.");
            const NetworkStream = $5942e8eb8ca60ef8$var$isValidFetchUrl(url) ? $5942e8eb8ca60ef8$var$PDFFetchStream : $5942e8eb8ca60ef8$var$isNodeJS ? $5942e8eb8ca60ef8$var$PDFNodeStream : $5942e8eb8ca60ef8$var$PDFNetworkStream;
            networkStream = new NetworkStream({
                url: url,
                length: length,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        }
        return workerIdPromise.then((workerId)=>{
            if (task.destroyed) throw new Error("Loading aborted");
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $5942e8eb8ca60ef8$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $5942e8eb8ca60ef8$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory, enableHWA);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
class $5942e8eb8ca60ef8$var$PDFDocumentLoadingTask {
    static #docId = 0;
    _capability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${$5942e8eb8ca60ef8$var$PDFDocumentLoadingTask.#docId++}`;
    destroyed = false;
    onPassword = null;
    onProgress = null;
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        this._worker?.destroy();
        this._worker = null;
    }
    async getData() {
        return this._transport.getData();
    }
}
class $5942e8eb8ca60ef8$export$c06899d9d7bce9ab {
    #capability = Promise.withResolvers();
    #progressiveDoneListeners = [];
    #progressiveReadListeners = [];
    #progressListeners = [];
    #rangeListeners = [];
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
    }
    addRangeListener(listener) {
        this.#rangeListeners.push(listener);
    }
    addProgressListener(listener) {
        this.#progressListeners.push(listener);
    }
    addProgressiveReadListener(listener) {
        this.#progressiveReadListeners.push(listener);
    }
    addProgressiveDoneListener(listener) {
        this.#progressiveDoneListeners.push(listener);
    }
    onDataRange(begin, chunk) {
        for (const listener of this.#rangeListeners)listener(begin, chunk);
    }
    onDataProgress(loaded, total) {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressListeners)listener(loaded, total);
        });
    }
    onDataProgressiveRead(chunk) {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveReadListeners)listener(chunk);
        });
    }
    onDataProgressiveDone() {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveDoneListeners)listener();
        });
    }
    transportReady() {
        this.#capability.resolve();
    }
    requestDataRange(begin, end) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $5942e8eb8ca60ef8$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get canvasFactory() {
        return this._transport.canvasFactory;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this._transport.getAnnotationsByType(types, pageIndexesToSkip);
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    destroy() {
        return this.loadingTask.destroy();
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $5942e8eb8ca60ef8$var$PDFPageProxy {
    #pendingCleanup = false;
    constructor(pageIndex, pageInfo, transport, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $5942e8eb8ca60ef8$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $5942e8eb8ca60ef8$var$PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
        this.recordedBBoxes = null;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $5942e8eb8ca60ef8$var$PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, canvas: canvas = canvasContext.canvas, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false, recordOperations: recordOperations = false, operationsFilter: operationsFilter = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        let intentState = this._intentStates.get(cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(cacheKey, intentState);
        }
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $5942e8eb8ca60ef8$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const recordForDebugger = Boolean(this._pdfBug && globalThis.StepperManager?.enabled);
        const shouldRecordOperations = !this.recordedBBoxes && (recordOperations || recordForDebugger);
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (shouldRecordOperations) {
                const recordedBBoxes = internalRenderTask.gfx?.dependencyTracker.take();
                if (recordedBBoxes) {
                    if (internalRenderTask.stepper) internalRenderTask.stepper.setOperatorBBoxes(recordedBBoxes, internalRenderTask.gfx.dependencyTracker.takeDebugMetadata());
                    if (recordOperations) this.recordedBBoxes = recordedBBoxes;
                }
            }
            if (intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup();
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        const internalRenderTask = new $5942e8eb8ca60ef8$var$InternalRenderTask({
            callback: complete,
            params: {
                canvas: canvas,
                canvasContext: canvasContext,
                dependencyTracker: shouldRecordOperations ? new $5942e8eb8ca60ef8$var$CanvasDependencyTracker(canvas, intentState.operatorList.length, recordForDebugger) : null,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors,
            enableHWA: this._transport.enableHWA,
            operationsFilter: operationsFilter
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        let intentState = this._intentStates.get(intentArgs.cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(intentArgs.cacheKey, intentState);
        }
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$5942e8eb8ca60ef8$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        return new Promise(function(resolve, reject) {
            function pump() {
                reader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        resolve(textContent);
                        return;
                    }
                    textContent.lang ??= value.lang;
                    Object.assign(textContent.styles, value.styles);
                    textContent.items.push(...value.items);
                    pump();
                }, reject);
            }
            const reader = readableStream.getReader();
            const textContent = {
                items: [],
                styles: Object.create(null),
                lang: null
            };
            pump();
        });
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup();
        if (resetStats && success) this._stats &&= new $5942e8eb8ca60ef8$var$StatTimer();
        return success;
    }
    #tryCleanup() {
        if (!this.#pendingCleanup || this.destroyed) return false;
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup();
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable, modifiedIds: modifiedIds }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup();
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $5942e8eb8ca60ef8$export$245847d31c09154f) {
                let delay = $5942e8eb8ca60ef8$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $5942e8eb8ca60ef8$export$d0e978393d193d1a(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $5942e8eb8ca60ef8$export$84e2e9f37426b265 {
    #capability = Promise.withResolvers();
    #messageHandler = null;
    #port = null;
    #webWorker = null;
    static #fakeWorkerId = 0;
    static #isWorkerDisabled = false;
    static #workerPorts = new WeakMap();
    static{
        if ($5942e8eb8ca60ef8$var$isNodeJS) {
            this.#isWorkerDisabled = true;
            $5942e8eb8ca60ef8$export$edf38ba293eb934.workerSrc ||= "./pdf.worker.mjs";
        }
        this._isSameOrigin = (baseUrl, otherUrl)=>{
            const base = URL.parse(baseUrl);
            if (!base?.origin || base.origin === "null") return false;
            const other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        this._createCDNWrapper = (url)=>{
            const wrapper = `await import("${url}");`;
            return URL.createObjectURL(new Blob([
                wrapper
            ], {
                type: "text/javascript"
            }));
        };
        this.fromPort = (params)=>{
            $5942e8eb8ca60ef8$var$deprecated("`PDFWorker.fromPort` - please use `PDFWorker.create` instead.");
            if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
            return this.create(params);
        };
    }
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $5942e8eb8ca60ef8$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        if (port) {
            if ($5942e8eb8ca60ef8$export$84e2e9f37426b265.#workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            $5942e8eb8ca60ef8$export$84e2e9f37426b265.#workerPorts.set(port, this);
            this.#initializeFromPort(port);
        } else this.#initialize();
    }
    get promise() {
        return this.#capability.promise;
    }
    #resolve() {
        this.#capability.resolve();
        this.#messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this.#port;
    }
    get messageHandler() {
        return this.#messageHandler;
    }
    #initializeFromPort(port) {
        this.#port = port;
        this.#messageHandler = new $5942e8eb8ca60ef8$var$MessageHandler("main", "worker", port);
        this.#messageHandler.on("ready", ()=>{});
        this.#resolve();
    }
    #initialize() {
        if ($5942e8eb8ca60ef8$export$84e2e9f37426b265.#isWorkerDisabled || $5942e8eb8ca60ef8$export$84e2e9f37426b265.#mainThreadWorkerMessageHandler) {
            this.#setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $5942e8eb8ca60ef8$export$84e2e9f37426b265;
        try {
            if (!$5942e8eb8ca60ef8$export$84e2e9f37426b265._isSameOrigin(window.location, workerSrc)) workerSrc = $5942e8eb8ca60ef8$export$84e2e9f37426b265._createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $5942e8eb8ca60ef8$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this.#capability.reject(new Error("Worker was destroyed"));
                else this.#setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this.#webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this.#messageHandler = messageHandler;
                this.#port = worker;
                this.#webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this.#setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $5942e8eb8ca60ef8$var$info("The worker has been disabled.");
        }
        this.#setupFakeWorker();
    }
    #setupFakeWorker() {
        if (!$5942e8eb8ca60ef8$export$84e2e9f37426b265.#isWorkerDisabled) {
            $5942e8eb8ca60ef8$var$warn("Setting up fake worker.");
            $5942e8eb8ca60ef8$export$84e2e9f37426b265.#isWorkerDisabled = true;
        }
        $5942e8eb8ca60ef8$export$84e2e9f37426b265._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this.#capability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $5942e8eb8ca60ef8$var$LoopbackPort();
            this.#port = port;
            const id = `fake${$5942e8eb8ca60ef8$export$84e2e9f37426b265.#fakeWorkerId++}`;
            const workerHandler = new $5942e8eb8ca60ef8$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this.#messageHandler = new $5942e8eb8ca60ef8$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this.#capability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        this.#webWorker?.terminate();
        this.#webWorker = null;
        $5942e8eb8ca60ef8$export$84e2e9f37426b265.#workerPorts.delete(this.#port);
        this.#port = null;
        this.#messageHandler?.destroy();
        this.#messageHandler = null;
    }
    static create(params) {
        const cachedPort = this.#workerPorts.get(params?.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $5942e8eb8ca60ef8$export$84e2e9f37426b265(params);
    }
    static get workerSrc() {
        if ($5942e8eb8ca60ef8$export$edf38ba293eb934.workerSrc) return $5942e8eb8ca60ef8$export$edf38ba293eb934.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ /*@vite-ignore*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $5942e8eb8ca60ef8$var$WorkerTransport {
    #methodPromises = new Map();
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory, enableHWA){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.commonObjs = new $5942e8eb8ca60ef8$var$PDFObjects();
        this.fontLoader = new $5942e8eb8ca60ef8$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.cMapReaderFactory = factory.cMapReaderFactory;
        this.standardFontDataFactory = factory.standardFontDataFactory;
        this.wasmFactory = factory.wasmFactory;
        this.destroyed = false;
        this.destroyCapability = null;
        this._networkStream = networkStream;
        this._fullReader = null;
        this._lastProgress = null;
        this.downloadInfoCapability = Promise.withResolvers();
        this.enableHWA = enableHWA;
        this.setupMessageHandler();
    }
    #cacheSimpleMethod(name, data = null) {
        const cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, data);
        this.#methodPromises.set(name, promise);
        return promise;
    }
    get annotationStorage() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "annotationStorage", new $5942e8eb8ca60ef8$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage = null, isEditing = false, isOpList = false) {
        let renderingIntent = $5942e8eb8ca60ef8$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $5942e8eb8ca60ef8$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $5942e8eb8ca60ef8$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $5942e8eb8ca60ef8$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $5942e8eb8ca60ef8$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        const annotationStorage = renderingIntent & $5942e8eb8ca60ef8$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $5942e8eb8ca60ef8$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch(annotationMode){
            case $5942e8eb8ca60ef8$export$5a7af0c07e33392e.DISABLE:
                renderingIntent += $5942e8eb8ca60ef8$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE:
                break;
            case $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE_FORMS:
                renderingIntent += $5942e8eb8ca60ef8$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $5942e8eb8ca60ef8$export$5a7af0c07e33392e.ENABLE_STORAGE:
                renderingIntent += $5942e8eb8ca60ef8$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $5942e8eb8ca60ef8$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isEditing) renderingIntent += $5942e8eb8ca60ef8$var$RenderingIntentFlag.IS_EDITING;
        if (isOpList) renderingIntent += $5942e8eb8ca60ef8$var$RenderingIntentFlag.OPLIST;
        const { ids: modifiedIds, hash: modifiedIdsHash } = annotationStorage.modifiedIds;
        const cacheKeyBuf = [
            renderingIntent,
            annotationStorageSerializable.hash,
            modifiedIdsHash
        ];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $5942e8eb8ca60ef8$export$fdbdc423a78c5262.cleanup();
            this._networkStream?.cancelAllRequests(new $5942e8eb8ca60ef8$export$d0e978393d193d1a("Worker was terminated."));
            this.messageHandler?.destroy();
            this.messageHandler = null;
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $5942e8eb8ca60ef8$var$assert(this._networkStream, "GetReader - no `IPDFStream` instance available.");
            this._fullReader = this._networkStream.getFullReader();
            this._fullReader.onProgress = (evt)=>{
                this._lastProgress = {
                    loaded: evt.loaded,
                    total: evt.total
                };
            };
            sink.onPull = ()=>{
                this._fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $5942e8eb8ca60ef8$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this._fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", async (data)=>{
            await this._fullReader.headersReady;
            const { isStreamingSupported: isStreamingSupported, isRangeSupported: isRangeSupported, contentLength: contentLength } = this._fullReader;
            if (!isStreamingSupported || !isRangeSupported) {
                if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                this._fullReader.onProgress = (evt)=>{
                    loadingTask.onProgress?.({
                        loaded: evt.loaded,
                        total: evt.total
                    });
                };
            }
            return {
                isStreamingSupported: isStreamingSupported,
                isRangeSupported: isRangeSupported,
                contentLength: contentLength
            };
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $5942e8eb8ca60ef8$var$assert(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $5942e8eb8ca60ef8$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $5942e8eb8ca60ef8$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", (ex)=>{
            loadingTask._capability.reject($5942e8eb8ca60ef8$var$wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", (ex)=>{
            this.#passwordCapability = Promise.withResolvers();
            try {
                if (!loadingTask.onPassword) throw $5942e8eb8ca60ef8$var$wrapReason(ex);
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                loadingTask.onPassword(updatePassword, ex.code);
            } catch (err) {
                this.#passwordCapability.reject(err);
            }
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            loadingTask.onProgress?.({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $5942e8eb8ca60ef8$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const fontData = new $5942e8eb8ca60ef8$var$FontInfo(exportedData);
                    const inspectFont = this._params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $5942e8eb8ca60ef8$var$FontFaceObject(fontData, inspectFont, exportedData.extra, exportedData.charProcOperatorList);
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!font.fontExtraProperties && font.data) font.clearData();
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $5942e8eb8ca60ef8$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        this.commonObjs.resolve(id, structuredClone(data));
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                case "Image":
                case "Pattern":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            loadingTask.onProgress?.({
                loaded: data.loaded,
                total: data.total
            });
        });
        messageHandler.on("FetchBinaryData", async (data)=>{
            if (this.destroyed) throw new Error("Worker was destroyed.");
            const factory = this[data.type];
            if (!factory) throw new Error(`${data.type} not initialized, see the \`useWorkerFetch\` parameter.`);
            return factory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $5942e8eb8ca60ef8$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this._fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: pageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, pageNumber);
            const page = new $5942e8eb8ca60ef8$var$PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    getPageIndex(ref) {
        if (!$5942e8eb8ca60ef8$var$isRefProxy(ref)) return Promise.reject(new Error("Invalid pageIndex request."));
        return this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: pageIndex,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
            types: types,
            pageIndexesToSkip: pageIndexesToSkip
        });
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: pageIndex
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: pageIndex
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $5942e8eb8ca60ef8$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>({
                info: results[0],
                metadata: results[1] ? new $5942e8eb8ca60ef8$var$Metadata(results[1]) : null,
                contentDispositionFilename: this._fullReader?.filename ?? null,
                contentLength: this._fullReader?.contentLength ?? null
            }));
        this.#methodPromises.set(name, promise);
        return promise;
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $5942e8eb8ca60ef8$export$fdbdc423a78c5262.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$5942e8eb8ca60ef8$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        return this.#pageRefCache.get(refStr) ?? null;
    }
}
class $5942e8eb8ca60ef8$var$RenderTask {
    #internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(internalRenderTask){
        this.#internalRenderTask = internalRenderTask;
    }
    get promise() {
        return this.#internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this.#internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this.#internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this.#internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
}
class $5942e8eb8ca60ef8$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null, enableHWA: enableHWA = false, operationsFilter: operationsFilter = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $5942e8eb8ca60ef8$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvas;
        this._canvasContext = params.canvas ? null : params.canvasContext;
        this._enableHWA = enableHWA;
        this._dependencyTracker = params.dependencyTracker;
        this._operationsFilter = operationsFilter;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($5942e8eb8ca60ef8$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $5942e8eb8ca60ef8$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { viewport: viewport, transform: transform, background: background, dependencyTracker: dependencyTracker } = this.params;
        const canvasContext = this._canvasContext || this._canvas.getContext("2d", {
            alpha: false,
            willReadFrequently: !this._enableHWA
        });
        this.gfx = new $5942e8eb8ca60ef8$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors, dependencyTracker);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $5942e8eb8ca60ef8$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        error ||= new $5942e8eb8ca60ef8$export$245847d31c09154f(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay);
        this.callback(error);
        this.task.onError?.(error);
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length);
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $5942e8eb8ca60ef8$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $5942e8eb8ca60ef8$export$83d89fbfd8236492 = "5.4.296";
const $5942e8eb8ca60ef8$export$3f8fe6489e95757d = "f56dc8601";
class $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3 {
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #openDropdownAC = null;
    #uiManager = null;
    static #l10nColor = null;
    static get _keyboardManager() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_keyboardManager", new $5942e8eb8ca60ef8$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#editor = editor;
        } else this.#isMainColorPicker = true;
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color?.toUpperCase() || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
        $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.#l10nColor ||= Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        });
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.ariaHasPopup = "true";
        if (this.#editor) button.ariaControls = `${this.#editor.id}_colorpicker_dropdown`;
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.ariaHidden = "true";
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.ariaOrientation = "horizontal";
        dropdown.ariaLabelledBy = "highlightColorPickerLabel";
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.ariaMultiSelectable = "false";
        div.ariaOrientation = "vertical";
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        if (this.#editor) div.id = `${this.#editor.id}_colorpicker_dropdown`;
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3.#l10nColor[name]);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.ariaSelected = color === this.#defaultColor;
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            value: color
        });
        this.updateColor(color);
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastChild?.focus();
    }
    #keyDown(event) {
        $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        if (!this.#openDropdownAC) {
            this.#openDropdownAC = new AbortController();
            window.addEventListener("pointerdown", this.#pointerDown.bind(this), {
                signal: this.#uiManager.combinedSignal(this.#openDropdownAC)
            });
        }
        this.#button.ariaExpanded = "true";
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        this.#button.ariaExpanded = "false";
        this.#openDropdownAC?.abort();
        this.#openDropdownAC = null;
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.ariaSelected = i.next().value === color.toUpperCase();
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $5942e8eb8ca60ef8$var$BasicColorPicker {
    #input = null;
    #editor = null;
    #uiManager = null;
    static #l10nColor = null;
    constructor(editor){
        this.#editor = editor;
        this.#uiManager = editor._uiManager;
        $5942e8eb8ca60ef8$var$BasicColorPicker.#l10nColor ||= Object.freeze({
            freetext: "pdfjs-editor-color-picker-free-text-input",
            ink: "pdfjs-editor-color-picker-ink-input"
        });
    }
    renderButton() {
        if (this.#input) return this.#input;
        const { editorType: editorType, colorType: colorType, colorValue: colorValue } = this.#editor;
        const input = this.#input = document.createElement("input");
        input.type = "color";
        input.value = colorValue || "#000000";
        input.className = "basicColorPicker";
        input.tabIndex = 0;
        input.setAttribute("data-l10n-id", $5942e8eb8ca60ef8$var$BasicColorPicker.#l10nColor[editorType]);
        input.addEventListener("input", ()=>{
            this.#uiManager.updateParams(colorType, input.value);
        }, {
            signal: this.#uiManager._signal
        });
        return input;
    }
    update(value) {
        if (!this.#input) return;
        this.#input.value = value;
    }
    destroy() {
        this.#input?.remove();
        this.#input = null;
    }
    hideDropdown() {}
}
function $5942e8eb8ca60ef8$var$makeColorComp(n) {
    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function $5942e8eb8ca60ef8$var$scaleAndClamp(x) {
    return Math.max(0, Math.min(255, 255 * x));
}
class $5942e8eb8ca60ef8$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $5942e8eb8ca60ef8$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $5942e8eb8ca60ef8$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($5942e8eb8ca60ef8$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($5942e8eb8ca60ef8$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $5942e8eb8ca60ef8$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $5942e8eb8ca60ef8$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $5942e8eb8ca60ef8$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
const $5942e8eb8ca60ef8$var$DateFormats = /* unused pure expression or super */ null;
const $5942e8eb8ca60ef8$var$TimeFormats = /* unused pure expression or super */ null;
class $5942e8eb8ca60ef8$var$BaseSVGFactory {
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `_createSVG` called.");
    }
}
class $5942e8eb8ca60ef8$export$425e69f00724e63a extends $5942e8eb8ca60ef8$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($5942e8eb8ca60ef8$var$SVG_NS, type);
    }
}
const $5942e8eb8ca60ef8$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $5942e8eb8ca60ef8$var$GetElementsByNameSet = new WeakSet();
const $5942e8eb8ca60ef8$var$TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60000;
class $5942e8eb8ca60ef8$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.LINK:
                return new $5942e8eb8ca60ef8$var$LinkAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.TEXT:
                return new $5942e8eb8ca60ef8$var$TextAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $5942e8eb8ca60ef8$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $5942e8eb8ca60ef8$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $5942e8eb8ca60ef8$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $5942e8eb8ca60ef8$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $5942e8eb8ca60ef8$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $5942e8eb8ca60ef8$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $5942e8eb8ca60ef8$var$WidgetAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.POPUP:
                return new $5942e8eb8ca60ef8$var$PopupAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.FREETEXT:
                return new $5942e8eb8ca60ef8$var$FreeTextAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.LINE:
                return new $5942e8eb8ca60ef8$var$LineAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.SQUARE:
                return new $5942e8eb8ca60ef8$var$SquareAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.CIRCLE:
                return new $5942e8eb8ca60ef8$var$CircleAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.POLYLINE:
                return new $5942e8eb8ca60ef8$var$PolylineAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.CARET:
                return new $5942e8eb8ca60ef8$var$CaretAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.INK:
                return new $5942e8eb8ca60ef8$var$InkAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.POLYGON:
                return new $5942e8eb8ca60ef8$var$PolygonAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.HIGHLIGHT:
                return new $5942e8eb8ca60ef8$var$HighlightAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.UNDERLINE:
                return new $5942e8eb8ca60ef8$var$UnderlineAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.SQUIGGLY:
                return new $5942e8eb8ca60ef8$var$SquigglyAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.STRIKEOUT:
                return new $5942e8eb8ca60ef8$var$StrikeOutAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.STAMP:
                return new $5942e8eb8ca60ef8$var$StampAnnotationElement(parameters);
            case $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.FILEATTACHMENT:
                return new $5942e8eb8ca60ef8$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $5942e8eb8ca60ef8$var$AnnotationElement(parameters);
        }
    }
}
class $5942e8eb8ca60ef8$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableComment = parameters.enableComment;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        if (isRenderable) this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ contentsObj: contentsObj, richText: richText }) {
        return !!(contentsObj?.str || richText?.str);
    }
    get _isEditable() {
        return this.data.isEditable;
    }
    get hasPopupData() {
        return $5942e8eb8ca60ef8$var$AnnotationElement._hasPopupData(this.data) || this.enableComment && !!this.commentText;
    }
    get commentData() {
        const { data: data } = this;
        const editor = this.annotationStorage?.getEditor(data.id);
        if (editor) return editor.getData();
        return data;
    }
    get hasCommentButton() {
        return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
        const editor = this.annotationStorage?.getEditor(this.data.id);
        if (editor) return editor.commentButtonPositionInPage;
        const { quadPoints: quadPoints, inkLists: inkLists, rect: rect } = this.data;
        let maxX = -Infinity;
        let maxY = -Infinity;
        if (quadPoints?.length >= 8) {
            for(let i = 0; i < quadPoints.length; i += 8){
                if (quadPoints[i + 1] > maxY) {
                    maxY = quadPoints[i + 1];
                    maxX = quadPoints[i + 2];
                } else if (quadPoints[i + 1] === maxY) maxX = Math.max(maxX, quadPoints[i + 2]);
            }
            return [
                maxX,
                maxY
            ];
        }
        if (inkLists?.length >= 1) {
            for (const inkList of inkLists)for(let i = 0, ii = inkList.length; i < ii; i += 2){
                if (inkList[i + 1] > maxY) {
                    maxY = inkList[i + 1];
                    maxX = inkList[i];
                } else if (inkList[i + 1] === maxY) maxX = Math.max(maxX, inkList[i]);
            }
            if (maxX !== Infinity) return [
                maxX,
                maxY
            ];
        }
        if (rect) return [
            rect[2],
            rect[3]
        ];
        return null;
    }
    _normalizePoint(point) {
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.parent;
        point[1] = view[3] - point[1] + view[1];
        point[0] = 100 * (point[0] - pageX) / pageWidth;
        point[1] = 100 * (point[1] - pageY) / pageHeight;
        return point;
    }
    get commentText() {
        const { data: data } = this;
        return this.annotationStorage.getRawValue(`${$5942e8eb8ca60ef8$var$AnnotationEditorPrefix}${data.id}`)?.popup?.contents || data.contentsObj?.str || "";
    }
    set commentText(text) {
        const { data: data } = this;
        const popup = {
            deleted: !text,
            contents: text || ""
        };
        if (!this.annotationStorage.updateEditor(data.id, {
            popup: popup
        })) this.annotationStorage.setValue(`${$5942e8eb8ca60ef8$var$AnnotationEditorPrefix}${data.id}`, {
            id: data.id,
            annotationType: data.annotationType,
            pageIndex: this.parent.page._pageIndex,
            popup: popup,
            popupRef: data.popupRef,
            modificationDate: new Date()
        });
        if (!text) this.removePopup();
    }
    removePopup() {
        (this.#popupElement?.popup || this.popup)?.remove();
        this.#popupElement = this.popup = null;
    }
    updateEdited(params) {
        if (!this.container) return;
        if (params.rect) this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect, popup: newPopup } = params;
        if (rect) this.#setRectEdited(rect);
        let popup = this.#popupElement?.popup || this.popup;
        if (!popup && newPopup?.text) {
            this._createPopup(newPopup);
            popup = this.#popupElement.popup;
        }
        if (!popup) return;
        popup.updateEdited(params);
        if (newPopup?.deleted) {
            popup.remove();
            this.#popupElement = null;
            this.popup = null;
        }
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * (rect[2] - rect[0]) / pageWidth}%`;
            style.height = `${100 * (rect[3] - rect[1]) / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $5942e8eb8ca60ef8$var$WidgetAnnotationElement) && !(this instanceof $5942e8eb8ca60ef8$var$LinkAnnotationElement)) container.tabIndex = 0;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex;
        this.parent.zIndex += 2;
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $5942e8eb8ca60ef8$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = this;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--total-scale-factor)) / calc(${verticalRadius}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $5942e8eb8ca60ef8$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--total-scale-factor)) / calc(${height}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.BEVELED:
                    $5942e8eb8ca60ef8$var$warn("Unimplemented border style: beveled");
                    break;
                case $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.INSET:
                    $5942e8eb8ca60ef8$var$warn("Unimplemented border style: inset");
                    break;
                case $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
            } else style.borderWidth = 0;
        }
        const rect = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        let { width: width, height: height } = this;
        if (angle % 180 !== 0) [width, height] = [
            height,
            width
        ];
        container.style.width = `${100 * width / pageWidth}%`;
        container.style.height = `${100 * height / pageHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $5942e8eb8ca60ef8$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $5942e8eb8ca60ef8$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="http://www.w3.org/2000/svg"`,
                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        svg.role = "none";
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup(popupData = null) {
        const { data: data } = this;
        let contentsObj, modificationDate;
        if (popupData) {
            contentsObj = {
                str: popupData.text
            };
            modificationDate = popupData.date;
        } else {
            contentsObj = data.contentsObj;
            modificationDate = data.modificationDate;
        }
        const popup = this.#popupElement = new $5942e8eb8ca60ef8$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: modificationDate,
                contentsObj: contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation,
                noRotate: true
            },
            linkService: this.linkService,
            parent: this.parent,
            elements: [
                this
            ]
        });
        if (!this.parent._commentManager) this.parent.div.append(popup.render());
    }
    get hasPopupElement() {
        return !!(this.#popupElement || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
        return this.#popupElement;
    }
    render() {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$5942e8eb8ca60ef8$var$GetElementsByNameSet.has(domElement)) {
                    $5942e8eb8ca60ef8$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$5942e8eb8ca60ef8$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId,
                mustEnterInEditMode: true
            });
        });
    }
    get width() {
        return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
        return this.data.rect[3] - this.data.rect[1];
    }
}
class $5942e8eb8ca60ef8$var$EditorAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.editor = parameters.editor;
    }
    render() {
        this.container.className = "editorAnnotation";
        return this.container;
    }
    createOrUpdatePopup() {
        const { editor: editor } = this;
        if (!editor.hasComment) return;
        this._createPopup(editor.comment);
        this.extraPopupElement.popup.renderCommentButton();
    }
    get hasCommentButton() {
        return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
        return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
        return this.editor.comment.text;
    }
    set commentText(text) {
        this.editor.comment = text;
        if (!text) this.removePopup();
    }
    get commentData() {
        return this.editor.getData();
    }
    remove() {
        this.container.remove();
        this.container = null;
        this.removePopup();
    }
}
class $5942e8eb8ca60ef8$var$LinkAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action, data.overlaidText);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.overlaidText, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState, data.overlaidText);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest, data.overlaidText);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) this.container.append(link);
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination, overlaidText = "") {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
        if (overlaidText) link.title = overlaidText;
    }
    _bindNamedAction(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, overlaidText = "", dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        else if (overlaidText) link.title = overlaidText;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (data.overlaidText) link.title = data.overlaidText;
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $5942e8eb8ca60ef8$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$5942e8eb8ca60ef8$var$GetElementsByNameSet.has(domElement)) {
                    $5942e8eb8ca60ef8$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $5942e8eb8ca60ef8$var$TextAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.append(image);
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$WidgetAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(color[0], color[1], color[2]);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $5942e8eb8ca60ef8$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($5942e8eb8ca60ef8$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $5942e8eb8ca60ef8$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $5942e8eb8ca60ef8$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--total-scale-factor))`;
        style.color = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $5942e8eb8ca60ef8$var$TextWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $5942e8eb8ca60ef8$var$GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = 0;
            const { datetimeFormat: datetimeFormat, datetimeType: datetimeType, timeStep: timeStep } = this.data;
            const hasDateOrTime = !!datetimeType && this.enableScripting;
            if (datetimeFormat) element.title = datetimeFormat;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (hasDateOrTime) {
                        target.type = datetimeType;
                        if (timeStep) target.step = timeStep;
                    }
                    if (elementData.userValue) {
                        const value = elementData.userValue;
                        if (hasDateOrTime) {
                            if (datetimeType === "time") {
                                const date = new Date(value);
                                const parts = [
                                    date.getHours(),
                                    date.getMinutes(),
                                    date.getSeconds()
                                ];
                                target.value = parts.map((v)=>v.toString().padStart(2, "0")).join(":");
                            } else target.value = new Date(value - $5942e8eb8ca60ef8$var$TIMEZONE_OFFSET).toISOString().split(datetimeType === "date" ? "T" : ".", 1)[0];
                        } else target.value = value;
                    }
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            if (!hasDateOrTime) storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            const data = {
                                formattedValue: formattedValue
                            };
                            if (hasDateOrTime) data.value = formattedValue;
                            storage.setValue(id, data);
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { target: target } = event;
                    let { value: value } = target;
                    if (hasDateOrTime) {
                        if (value && datetimeType === "time") {
                            const parts = value.split(":").map((v)=>parseInt(v, 10));
                            value = new Date(2000, 0, 1, parts[0], parts[1], parts[2] || 0).valueOf();
                            target.step = "";
                        } else {
                            if (!value.includes("T")) value = `${value}T00:00`;
                            value = new Date(value).valueOf();
                        }
                        target.type = "text";
                    }
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--total-scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$SignatureWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $5942e8eb8ca60ef8$var$CheckboxWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $5942e8eb8ca60ef8$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$RadioButtonWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $5942e8eb8ca60ef8$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$PushButtonWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $5942e8eb8ca60ef8$var$ChoiceWidgetAnnotationElement extends $5942e8eb8ca60ef8$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $5942e8eb8ca60ef8$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = 0;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            optionElement.textContent = option.displayValue;
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            optionElement.textContent = displayValue;
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$PopupAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements, parent: parent } = parameters;
        const hasCommentManager = !!parent._commentManager;
        super(parameters, {
            isRenderable: !hasCommentManager && $5942e8eb8ca60ef8$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        if (hasCommentManager && $5942e8eb8ca60ef8$var$AnnotationElement._hasPopupData(data)) {
            const popup = this.popup = this.#createPopup();
            for (const element of elements)element.popup = popup;
        } else this.popup = null;
    }
    #createPopup() {
        return new $5942e8eb8ca60ef8$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate || this.data.creationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open,
            commentManager: this.parent._commentManager
        });
    }
    render() {
        const { container: container } = this;
        container.classList.add("popupAnnotation");
        container.role = "comment";
        const popup = this.popup = this.#createPopup();
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            element.container.ariaHasPopup = "dialog";
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$5942e8eb8ca60ef8$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$PopupElement {
    #commentManager = null;
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #popupAbortController = null;
    #position = null;
    #commentButton = null;
    #commentButtonPosition = null;
    #popupPosition = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    #firstElement = null;
    #commentText = null;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open, commentManager: commentManager = null }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#commentManager = commentManager;
        this.#firstElement = elements[0];
        this.#dateObj = $5942e8eb8ca60ef8$export$66cbc314498fffc.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        if (commentManager) this.renderCommentButton();
        else {
            this.#addEventListeners();
            this.#container.hidden = true;
            if (open) this.#toggle();
        }
    }
    #addEventListeners() {
        if (this.#popupAbortController) return;
        this.#popupAbortController = new AbortController();
        const { signal: signal } = this.#popupAbortController;
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle, {
                signal: signal
            });
            element.addEventListener("pointerenter", this.#boundShow, {
                signal: signal
            });
            element.addEventListener("pointerleave", this.#boundHide, {
                signal: signal
            });
            element.classList.add("popupTriggerArea");
        }
        for (const element of this.#elements)element.container?.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
    }
    #setCommentButtonPosition() {
        const element = this.#elements.find((e)=>e.hasCommentButton);
        if (!element) return;
        this.#commentButtonPosition = element._normalizePoint(element.commentButtonPosition);
    }
    renderCommentButton() {
        if (this.#commentButton) return;
        if (!this.#commentButtonPosition) this.#setCommentButtonPosition();
        if (!this.#commentButtonPosition) return;
        const { signal: signal } = this.#popupAbortController = new AbortController();
        const hasOwnButton = !!this.#firstElement.extraPopupElement;
        const togglePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, true, undefined, !hasOwnButton);
        };
        const showPopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, true, !hasOwnButton);
        };
        const hidePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, false);
        };
        if (!hasOwnButton) {
            const button = this.#commentButton = document.createElement("button");
            button.className = "annotationCommentButton";
            const parentContainer = this.#firstElement.container;
            button.style.zIndex = parentContainer.style.zIndex + 1;
            button.tabIndex = 0;
            button.ariaHasPopup = "dialog";
            button.ariaControls = "commentPopup";
            button.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
            this.#updateColor();
            this.#updateCommentButtonPosition();
            button.addEventListener("keydown", this.#boundKeyDown, {
                signal: signal
            });
            button.addEventListener("click", togglePopup, {
                signal: signal
            });
            button.addEventListener("pointerenter", showPopup, {
                signal: signal
            });
            button.addEventListener("pointerleave", hidePopup, {
                signal: signal
            });
            parentContainer.after(button);
        } else {
            this.#commentButton = this.#firstElement.container;
            for (const element of this.trigger){
                element.ariaHasPopup = "dialog";
                element.ariaControls = "commentPopup";
                element.addEventListener("keydown", this.#boundKeyDown, {
                    signal: signal
                });
                element.addEventListener("click", togglePopup, {
                    signal: signal
                });
                element.addEventListener("pointerenter", showPopup, {
                    signal: signal
                });
                element.addEventListener("pointerleave", hidePopup, {
                    signal: signal
                });
                element.classList.add("popupTriggerArea");
            }
        }
    }
    #updateCommentButtonPosition() {
        if (this.#firstElement.extraPopupElement && !this.#firstElement.editor) return;
        this.renderCommentButton();
        const [x, y] = this.#commentButtonPosition;
        const { style: style } = this.#commentButton;
        style.left = `calc(${x}%)`;
        style.top = `calc(${y}% - var(--comment-button-dim))`;
    }
    #updateColor() {
        if (this.#firstElement.extraPopupElement) return;
        this.renderCommentButton();
        this.#commentButton.style.backgroundColor = this.commentButtonColor || "";
    }
    get commentButtonColor() {
        const { color: color, opacity: opacity } = this.#firstElement.commentData;
        if (!color) return null;
        return this.#parent._commentManager.makeCommentColor(color, opacity);
    }
    focusCommentButton() {
        setTimeout(()=>{
            this.#commentButton?.focus();
        }, 0);
    }
    getData() {
        const { richText: richText, color: color, opacity: opacity, creationDate: creationDate, modificationDate: modificationDate } = this.#firstElement.commentData;
        return {
            contentsObj: {
                str: this.comment
            },
            richText: richText,
            color: color,
            opacity: opacity,
            creationDate: creationDate,
            modificationDate: modificationDate
        };
    }
    get elementBeforePopup() {
        return this.#commentButton;
    }
    get comment() {
        this.#commentText ||= this.#firstElement.commentText;
        return this.#commentText;
    }
    set comment(text) {
        if (text === this.comment) return;
        this.#firstElement.commentText = this.#commentText = text;
    }
    get parentBoundingClientRect() {
        return this.#firstElement.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentButton) return;
        this.#commentButton.classList.toggle("selected", selected);
        this.#commentButton.ariaExpanded = hasPopup;
    }
    setSelectedCommentButton(selected) {
        this.#commentButton.classList.toggle("selected", selected);
    }
    get commentPopupPosition() {
        if (this.#popupPosition) return this.#popupPosition;
        const { x: x, y: y, height: height } = this.#commentButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#firstElement.layer.getBoundingClientRect();
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPosition(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    get commentButtonPosition() {
        return this.#commentButtonPosition;
    }
    get commentButtonWidth() {
        return this.#commentButton.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(options) {
        const [posX, posY] = this.#popupPosition || this.commentButtonPosition.map((x)=>x / 100);
        const parentDimensions = this.parentBoundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#commentManager.showDialog(null, this, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...this.#color);
            popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
        }
        const header = document.createElement("span");
        header.className = "header";
        if (this.#titleObj?.str) {
            const title = document.createElement("span");
            title.className = "title";
            header.append(title);
            ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        }
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("time");
            modificationDate.className = "popupDate";
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: this.#dateObj.valueOf()
            }));
            modificationDate.dateTime = this.#dateObj.toISOString();
            header.append(modificationDate);
        }
        $5942e8eb8ca60ef8$export$611c480766035c4({
            html: this.#html || this.#contentsObj.str,
            dir: this.#contentsObj?.dir,
            className: "popupContent"
        }, popup);
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--total-scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popup: popup, deleted: deleted }) {
        if (this.#commentManager) {
            if (deleted) {
                this.remove();
                this.#commentText = null;
            } else if (popup) {
                if (popup.deleted) this.remove();
                else {
                    this.#updateColor();
                    this.#commentText = popup.text;
                }
            }
            if (rect) {
                this.#commentButtonPosition = null;
                this.#setCommentButtonPosition();
                this.#updateCommentButtonPosition();
            }
            return;
        }
        if (deleted || popup?.deleted) {
            this.remove();
            return;
        }
        this.#addEventListeners();
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popup && popup.text) {
            this.#richText = this.#makePopupContent(popup.text);
            this.#dateObj = $5942e8eb8ca60ef8$export$66cbc314498fffc.toDateObject(popup.date);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    remove() {
        this.#popupAbortController?.abort();
        this.#popupAbortController = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#wasVisible = false;
        this.#pinned = false;
        this.#commentButton?.remove();
        this.#commentButton = null;
        if (this.trigger) for (const element of this.trigger)element.classList.remove("popupTriggerArea");
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        if (this.#commentManager) {
            this.#commentManager.toggleCommentPopup(this, false);
            return;
        }
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (this.#commentManager) return;
        this.#addEventListeners();
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        if (this.#commentManager) return false;
        return this.#container.hidden === false;
    }
}
class $5942e8eb8ca60ef8$var$FreeTextAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this._editOnDoubleClick();
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$LineAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $5942e8eb8ca60ef8$var$SquareAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $5942e8eb8ca60ef8$var$CircleAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $5942e8eb8ca60ef8$var$PolylineAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef }, width: width, height: height } = this;
        if (!vertices) return this.container;
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $5942e8eb8ca60ef8$var$PolygonAnnotationElement extends $5942e8eb8ca60ef8$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $5942e8eb8ca60ef8$var$CaretAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$InkAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #polylinesGroupElement = null;
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = this.data.it === "InkHighlight" ? $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT : $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.INK;
    }
    #getTransform(rotation, rect) {
        switch(rotation){
            case 90:
                return {
                    transform: `rotate(90) translate(${-rect[0]},${rect[1]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            case 180:
                return {
                    transform: `rotate(180) translate(${-rect[2]},${rect[1]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
            case 270:
                return {
                    transform: `rotate(270) translate(${-rect[2]},${rect[3]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            default:
                return {
                    transform: `translate(${-rect[0]},${rect[3]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
        }
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, rotation: rotation, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { transform: transform, width: width, height: height } = this.#getTransform(rotation, rect);
        const svg = this.svgFactory.create(width, height, true);
        const g = this.#polylinesGroupElement = this.svgFactory.createElement("svg:g");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for(let i = 0, ii = inkLists.length; i < ii; i++){
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    }
    updateEdited(params) {
        super.updateEdited(params);
        const { thickness: thickness, points: points, rect: rect } = params;
        const g = this.#polylinesGroupElement;
        if (thickness >= 0) g.setAttribute("stroke-width", thickness || 1);
        if (points) for(let i = 0, ii = this.#polylines.length; i < ii; i++)this.#polylines[i].setAttribute("points", points[i].join(","));
        if (rect) {
            const { transform: transform, width: width, height: height } = this.#getTransform(this.data.rotation, rect);
            const root = g.parentElement;
            root.setAttribute("viewBox", `0 0 ${width} ${height}`);
            g.setAttribute("transform", transform);
        }
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $5942e8eb8ca60ef8$var$HighlightAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
        this.annotationEditorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT;
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        if (overlaidText) {
            const mark = document.createElement("mark");
            mark.classList.add("overlaidText");
            mark.textContent = overlaidText;
            this.container.append(mark);
        }
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$UnderlineAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("underlineAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$SquigglyAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("squigglyAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$StrikeOutAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("strikeoutAnnotation");
        if (overlaidText) {
            const strikeout = document.createElement("s");
            strikeout.classList.add("overlaidText");
            strikeout.textContent = overlaidText;
            this.container.append(strikeout);
        }
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$StampAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.annotationEditorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.STAMP;
    }
    render() {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this._editOnDoubleClick();
        return this.container;
    }
}
class $5942e8eb8ca60ef8$var$FileAttachmentAnnotationElement extends $5942e8eb8ca60ef8$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $5942e8eb8ca60ef8$export$3e7f45c326d9366c {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #annotationStorage = null;
    #editableAnnotations = new Map();
    #structTreeLayer = null;
    #linkService = null;
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport, structTreeLayer: structTreeLayer, commentManager: commentManager, linkService: linkService, annotationStorage: annotationStorage }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.#structTreeLayer = structTreeLayer || null;
        this.#linkService = linkService || null;
        this.#annotationStorage = annotationStorage || new $5942e8eb8ca60ef8$var$AnnotationStorage();
        this.page = page;
        this.viewport = viewport;
        this.zIndex = 0;
        this._annotationEditorUIManager = annotationEditorUIManager;
        this._commentManager = commentManager || null;
    }
    hasEditableAnnotations() {
        return this.#editableAnnotations.size > 0;
    }
    async #appendElement(element, id, popupElements) {
        const contentElement = element.firstChild || element;
        const annotationId = contentElement.id = `${$5942e8eb8ca60ef8$var$AnnotationPrefix}${id}`;
        const ariaAttributes = await this.#structTreeLayer?.getAriaAttributes(annotationId);
        if (ariaAttributes) for (const [key, value] of ariaAttributes)contentElement.setAttribute(key, value);
        if (popupElements) popupElements.at(-1).container.after(element);
        else {
            this.div.append(element);
            this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
        }
    }
    async render(params) {
        const { annotations: annotations } = params;
        const layer = this.div;
        $5942e8eb8ca60ef8$export$af0a15a86e590226(layer, this.viewport);
        const popupToElements = new Map();
        const elementParams = {
            data: null,
            layer: layer,
            linkService: this.#linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $5942e8eb8ca60ef8$export$425e69f00724e63a(),
            annotationStorage: this.#annotationStorage,
            enableComment: params.enableComment === true,
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $5942e8eb8ca60ef8$export$f50c3066a53a6f2c.POPUP;
            if (!isPopupAnnotation) {
                if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $5942e8eb8ca60ef8$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation && data.popupRef) {
                const elements = popupToElements.get(data.popupRef);
                if (!elements) popupToElements.set(data.popupRef, [
                    element
                ]);
                else elements.push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            await this.#appendElement(rendered, data.id, elementParams.elements);
            element.extraPopupElement?.popup?.renderCommentButton();
            if (element._isEditable) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        this.#setAnnotationCanvasMap();
    }
    async addLinkAnnotations(annotations) {
        const elementParams = {
            data: null,
            layer: this.div,
            linkService: this.#linkService,
            svgFactory: new $5942e8eb8ca60ef8$export$425e69f00724e63a(),
            parent: this
        };
        for (const data of annotations){
            data.borderStyle ||= $5942e8eb8ca60ef8$export$3e7f45c326d9366c._defaultBorderStyle;
            elementParams.data = data;
            const element = $5942e8eb8ca60ef8$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            const rendered = element.render();
            await this.#appendElement(rendered, data.id, null);
        }
    }
    update({ viewport: viewport }) {
        const layer = this.div;
        this.viewport = viewport;
        $5942e8eb8ca60ef8$export$af0a15a86e590226(layer, {
            rotation: viewport.rotation
        });
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
            const editableAnnotation = this.#editableAnnotations.get(id);
            if (!editableAnnotation) continue;
            if (editableAnnotation._hasNoCanvas) {
                this._annotationEditorUIManager?.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            } else editableAnnotation.canvas = canvas;
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return Array.from(this.#editableAnnotations.values());
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
    addFakeAnnotation(editor) {
        const { div: div } = this;
        const { id: id, rotation: rotation } = editor;
        const element = new $5942e8eb8ca60ef8$var$EditorAnnotationElement({
            data: {
                id: id,
                rect: editor.getPDFRect(),
                rotation: rotation
            },
            editor: editor,
            layer: div,
            parent: this,
            enableComment: !!this._commentManager,
            linkService: this.#linkService,
            annotationStorage: this.#annotationStorage
        });
        const htmlElement = element.render();
        div.append(htmlElement);
        this.#accessibilityManager?.moveElementInDOM(div, htmlElement, htmlElement, false);
        element.createOrUpdatePopup();
        return element;
    }
    static get _defaultBorderStyle() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_defaultBorderStyle", Object.freeze({
            width: 1,
            rawWidth: 1,
            style: $5942e8eb8ca60ef8$var$AnnotationBorderStyleType.SOLID,
            dashArray: [
                3
            ],
            horizontalCornerRadius: 0,
            verticalCornerRadius: 0
        }));
    }
}
const $5942e8eb8ca60ef8$var$EOL_PATTERN = /\r\n?|\n/g;
class $5942e8eb8ca60ef8$var$FreeTextEditor extends $5942e8eb8ca60ef8$var$AnnotationEditor {
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #editModeAC = null;
    #fontSize;
    _colorPicker = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $5942e8eb8ca60ef8$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $5942e8eb8ca60ef8$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $5942e8eb8ca60ef8$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_keyboardManager", new $5942e8eb8ca60ef8$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.color = params.color || $5942e8eb8ca60ef8$var$FreeTextEditor._defaultColor || $5942e8eb8ca60ef8$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $5942e8eb8ca60ef8$var$FreeTextEditor._defaultFontSize;
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
    }
    static initialize(l10n, uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor.initialize(l10n, uiManager);
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                $5942e8eb8ca60ef8$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                $5942e8eb8ca60ef8$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                $5942e8eb8ca60ef8$var$FreeTextEditor._defaultFontSize
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                $5942e8eb8ca60ef8$var$FreeTextEditor._defaultColor || $5942e8eb8ca60ef8$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                this.color
            ]
        ];
    }
    get toolbarButtons() {
        this._colorPicker ||= new $5942e8eb8ca60ef8$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR;
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--total-scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    onUpdatedColor() {
        this.editorDiv.style.color = this.color;
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$5942e8eb8ca60ef8$var$FreeTextEditor._internalPadding * scale,
            -($5942e8eb8ca60ef8$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (!super.enableEditMode()) return false;
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        this.#editModeAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#editModeAC);
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
        return true;
    }
    disableEditMode() {
        if (!super.disableEditMode()) return false;
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.#editModeAC?.abort();
        this.#editModeAC = null;
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
        return true;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded(focus) {
        if (this.width) return;
        this.enableEditMode();
        if (focus) this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        let prevChild = null;
        for (const child of this.editorDiv.childNodes){
            if (prevChild?.nodeType === Node.TEXT_NODE && child.nodeName === "BR") continue;
            buffer.push($5942e8eb8ca60ef8$var$FreeTextEditor.#getNodeContent(child));
            prevChild = child;
        }
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $5942e8eb8ca60ef8$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    get canChangeContent() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        if (this._isCopy || this.annotationElementId) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this._initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this._moveAfterPaste(baseX, baseY);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($5942e8eb8ca60ef8$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $5942e8eb8ca60ef8$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($5942e8eb8ca60ef8$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($5942e8eb8ca60ef8$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($5942e8eb8ca60ef8$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($5942e8eb8ca60ef8$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($5942e8eb8ca60ef8$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = Math.sumPrecise(bufferBefore.map((line)=>line.length));
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    getPDFRect() {
        const padding = $5942e8eb8ca60ef8$var$FreeTextEditor._internalPadding * this.parentScale;
        return this.getRect(padding, padding);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $5942e8eb8ca60ef8$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                comment: contentsObj?.str || null,
                richText: richText,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.color = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...data.color);
        editor.#content = $5942e8eb8ca60ef8$var$FreeTextEditor.#deserializeContent(data.value);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $5942e8eb8ca60ef8$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color);
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent()
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (!content) return null;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
                text: this.#content
            }
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $5942e8eb8ca60ef8$var$Outline {
    static PRECISION = 1e-4;
    toSVGPath() {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        $5942e8eb8ca60ef8$var$unreachable("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        $5942e8eb8ca60ef8$var$unreachable("Abstract method `serialize` must be implemented.");
    }
    static _rescale(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    static _rescaleAndSwap(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    static _translate(src, tx, ty, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    }
    static svgRound(x) {
        return Math.round(x * 10000);
    }
    static _normalizePoint(x, y, parentWidth, parentHeight, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y / parentWidth,
                    x / parentHeight
                ];
            case 180:
                return [
                    1 - x / parentWidth,
                    1 - y / parentHeight
                ];
            case 270:
                return [
                    y / parentWidth,
                    1 - x / parentHeight
                ];
            default:
                return [
                    x / parentWidth,
                    y / parentHeight
                ];
        }
    }
    static _normalizePagePoint(x, y, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x
                ];
            case 180:
                return [
                    1 - x,
                    1 - y
                ];
            case 270:
                return [
                    y,
                    1 - x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    static createBezierPoints(x1, y1, x2, y2, x3, y3) {
        return [
            (x1 + 5 * x2) / 6,
            (y1 + 5 * y2) / 6,
            (5 * x2 + x3) / 6,
            (5 * y2 + y3) / 6,
            (x2 + x3) / 2,
            (y2 + y3) / 2
        ];
    }
}
class $5942e8eb8ca60ef8$var$FreeDrawOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float32Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $5942e8eb8ca60ef8$var$FreeDrawOutliner.#MIN_DIST + $5942e8eb8ca60ef8$var$FreeDrawOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $5942e8eb8ca60ef8$var$FreeDrawOutliner.#MIN_DIST * scaleFactor;
        this.#min = $5942e8eb8ca60ef8$var$FreeDrawOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        if (isNaN(this.#last[6]) && !this.isEmpty()) return this.#toSVGPathTwoPoints();
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        this.#toSVGPathEnd(buffer);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        this.#toSVGPathStart(buffer);
        return buffer.join(" ");
    }
    #toSVGPathTwoPoints() {
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
    }
    #toSVGPathStart(buffer) {
        const bottom = this.#bottom;
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
    }
    #toSVGPathEnd(buffer) {
        const [x, y, width, height] = this.#box;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
    }
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $5942e8eb8ca60ef8$var$FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float32Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) return this.#getOutlineTwoPoints(points);
        const outline = new Float32Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = this.#getOutlineEnd(outline, N);
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        this.#getOutlineStart(outline, N);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineTwoPoints(points) {
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        const outline = new Float32Array(36);
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (last[2] - layerX) / layerWidth,
            (last[3] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[4] - layerX) / layerWidth,
            (last[5] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[16] - layerX) / layerWidth,
            (last[17] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[14] - layerX) / layerWidth,
            (last[15] - layerY) / layerHeight
        ], 0);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineStart(outline, pos) {
        const bottom = this.#bottom;
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], pos);
        return pos += 6;
    }
    #getOutlineEnd(outline, pos) {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], pos);
        return pos += 24;
    }
}
class $5942e8eb8ca60ef8$var$FreeDrawOutline extends $5942e8eb8ca60ef8$var$Outline {
    #box;
    #bbox = new Float32Array(4);
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.firstPoint = [
            NaN,
            NaN
        ];
        this.lastPoint = [
            NaN,
            NaN
        ];
        this.#computeMinMax(isLTR);
        const [x, y, width, height] = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = $5942e8eb8ca60ef8$var$Outline._rescale(this.#outline, blX, trY, width, -height);
                points = $5942e8eb8ca60ef8$var$Outline._rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = $5942e8eb8ca60ef8$var$Outline._rescale(this.#outline, trX, blY, -width, height);
                points = $5942e8eb8ca60ef8$var$Outline._rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        const minMax = [
            lastX,
            lastY,
            lastX,
            lastY
        ];
        let firstPointX = lastX;
        let firstPointY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        const bezierBbox = new Float32Array(4);
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            const x = outline[i + 4], y = outline[i + 5];
            if (isNaN(outline[i])) {
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.pointBoundingBox(x, y, minMax);
                if (firstPointY > y) {
                    firstPointX = x;
                    firstPointY = y;
                } else if (firstPointY === y) firstPointX = ltrCallback(firstPointX, x);
                if (lastPointY < y) {
                    lastPointX = x;
                    lastPointY = y;
                } else if (lastPointY === y) lastPointX = ltrCallback(lastPointX, x);
            } else {
                bezierBbox[0] = bezierBbox[1] = Infinity;
                bezierBbox[2] = bezierBbox[3] = -Infinity;
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6), bezierBbox);
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.rectBoundingBox(bezierBbox[0], bezierBbox[1], bezierBbox[2], bezierBbox[3], minMax);
                if (firstPointY > bezierBbox[1]) {
                    firstPointX = bezierBbox[0];
                    firstPointY = bezierBbox[1];
                } else if (firstPointY === bezierBbox[1]) firstPointX = ltrCallback(firstPointX, bezierBbox[0]);
                if (lastPointY < bezierBbox[3]) {
                    lastPointX = bezierBbox[2];
                    lastPointY = bezierBbox[3];
                } else if (lastPointY === bezierBbox[3]) lastPointX = ltrCallback(lastPointX, bezierBbox[2]);
            }
            lastX = x;
            lastY = y;
        }
        const bbox = this.#bbox;
        bbox[0] = minMax[0] - this.#innerMargin;
        bbox[1] = minMax[1] - this.#innerMargin;
        bbox[2] = minMax[2] - minMax[0] + 2 * this.#innerMargin;
        bbox[3] = minMax[3] - minMax[1] + 2 * this.#innerMargin;
        this.firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.lastPoint = [
            lastPointX,
            lastPointY
        ];
    }
    get box() {
        return this.#bbox;
    }
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $5942e8eb8ca60ef8$var$FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
    getNewOutline(thickness, innerMargin) {
        const [x, y, width, height] = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = this.newOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $5942e8eb8ca60ef8$var$HighlightOutliner {
    #box;
    #firstPoint;
    #lastPoint;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        const minMax = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.rectBoundingBox(x1, y1, x2, y2, minMax);
        }
        const bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        const bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        const shiftedMinX = minMax[0] - innerMargin;
        const shiftedMinY = minMax[1] - innerMargin;
        let firstPointX = isLTR ? -Infinity : Infinity;
        let firstPointY = Infinity;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2, left] = edge;
            if (!left && isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.max(firstPointX, x);
            } else if (left && !isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.min(firstPointX, x);
            }
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = new Float32Array([
            shiftedMinX,
            shiftedMinY,
            bboxWidth,
            bboxHeight
        ]);
        this.#firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.#lastPoint = lastPoint;
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $5942e8eb8ca60ef8$var$HighlightOutline(outlines, this.#box, this.#firstPoint, this.#lastPoint);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $5942e8eb8ca60ef8$var$HighlightOutline extends $5942e8eb8ca60ef8$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box, firstPoint, lastPoint){
        super();
        this.#outlines = outlines;
        this.#box = box;
        this.firstPoint = firstPoint;
        this.lastPoint = lastPoint;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
    get classNamesForOutlining() {
        return [
            "highlightOutline"
        ];
    }
}
class $5942e8eb8ca60ef8$var$FreeHighlightOutliner extends $5942e8eb8ca60ef8$var$FreeDrawOutliner {
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $5942e8eb8ca60ef8$var$FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
}
class $5942e8eb8ca60ef8$var$FreeHighlightOutline extends $5942e8eb8ca60ef8$var$FreeDrawOutline {
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $5942e8eb8ca60ef8$var$FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
}
class $5942e8eb8ca60ef8$var$HighlightEditor extends $5942e8eb8ca60ef8$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #firstPoint = null;
    #lastPoint = null;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = "highlight";
    static _editorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $5942e8eb8ca60ef8$var$HighlightEditor.prototype;
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_keyboardManager", new $5942e8eb8ca60ef8$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $5942e8eb8ca60ef8$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $5942e8eb8ca60ef8$var$HighlightEditor._defaultThickness;
        this.opacity = params.opacity || $5942e8eb8ca60ef8$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else if (this.#boxes) {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.getNonHCMColorName(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.getNonHCMColorName(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $5942e8eb8ca60ef8$var$HighlightOutliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        [this.x, this.y, this.width, this.height] = this.#highlightOutlines.box;
        const outlinerForOutline = new $5942e8eb8ca60ef8$var$HighlightOutliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { firstPoint: firstPoint } = this.#highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - this.x) / this.width,
            (firstPoint[1] - this.y) / this.height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.#outlineId = this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: this.#focusOutlines.box,
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            }, true);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(this.#id, {
                bbox: $5942e8eb8ca60ef8$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                bbox: $5942e8eb8ca60ef8$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            });
        }
        const [x, y, width, height] = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { firstPoint: firstPoint } = highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - x) / width,
            (firstPoint[1] - y) / height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor.initialize(l10n, uiManager);
        $5942e8eb8ca60ef8$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                $5942e8eb8ca60ef8$var$HighlightEditor._defaultColor = value;
                break;
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                $5942e8eb8ca60ef8$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    get commentButtonPosition() {
        return this.#firstPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                $5942e8eb8ca60ef8$var$HighlightEditor._defaultColor
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                $5942e8eb8ca60ef8$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                this.color || $5942e8eb8ca60ef8$var$HighlightEditor._defaultColor
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                this.#thickness || $5942e8eb8ca60ef8$var$HighlightEditor._defaultThickness
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    onUpdatedColor() {
        this.parent?.drawLayer.updateProperties(this.#id, {
            root: {
                fill: this.color,
                "fill-opacity": this.opacity
            }
        });
        this.#colorPicker?.updateColor(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColorAndOpacity = (col, opa)=>{
            this.color = col;
            this.opacity = opa;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, $5942e8eb8ca60ef8$var$HighlightEditor._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.getNonHCMColorName(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    get toolbarButtons() {
        if (this._uiManager.highlightColors) {
            const colorPicker = this.#colorPicker = new $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3({
                editor: this
            });
            return [
                [
                    "colorPicker",
                    colorPicker
                ]
            ];
        }
        return super.toolbarButtons;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        if (focus) this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        this.setDims(this.width, this.height);
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.draw({
            bbox: this.#highlightOutlines.box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": this.opacity
            },
            rootClass: {
                highlight: true,
                free: this.#isFreeHighlight
            },
            path: {
                d: this.#highlightOutlines.toSVGPath()
            }
        }, false, true));
        this.#outlineId = parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: this.#isFreeHighlight
            },
            bbox: this.#focusOutlines.box,
            path: {
                d: this.#focusOutlines.toSVGPath()
            }
        }, this.#isFreeHighlight);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox([x, y, width, height], angle) {
        switch(angle){
            case 90:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 180:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
        }
        return [
            x,
            y,
            width,
            height
        ];
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $5942e8eb8ca60ef8$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $5942e8eb8ca60ef8$var$HighlightEditor.#rotateBbox([
            this.x,
            this.y,
            this.width,
            this.height
        ], angle);
        drawLayer.updateProperties(this.#id, {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(this.#outlineId, {
            bbox: $5942e8eb8ca60ef8$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#keydown.bind(this), {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        this.setDims(this.width, this.height);
        $5942e8eb8ca60ef8$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: true
            }
        });
    }
    pointerleave() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false
            }
        });
    }
    #keydown(event) {
        $5942e8eb8ca60ef8$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                selected: false
            }
        });
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(this.#id, {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth + pageX;
            const sy = (1 - y) * pageHeight + pageY;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const ac = new AbortController();
        const signal = parent.combinedSignal(ac);
        const pointerUpCallback = (e)=>{
            ac.abort();
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", this.#highlightMove.bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new $5942e8eb8ca60ef8$var$FreeHighlightOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.draw({
            bbox: [
                0,
                0,
                1,
                1
            ],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updateProperties(this._freeHighlightId, {
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        });
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.remove(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $5942e8eb8ca60ef8$var$HighlightAnnotationElement) {
            const { data: { quadPoints: quadPoints, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                opacity: opacity,
                quadPoints: quadPoints,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        } else if (data instanceof $5942e8eb8ca60ef8$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                thickness: thickness,
                inkLists: inkLists,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const { color: color, quadPoints: quadPoints, inkLists: inkLists, opacity: opacity } = data;
        const editor = await super.deserialize(data, parent, uiManager);
        editor.color = $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...color);
        editor.opacity = opacity || 1;
        if (inkLists) editor.#thickness = data.thickness;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [pageX, pageY] = editor.pageTranslation;
        if (quadPoints) {
            const boxes = editor.#boxes = [];
            for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
                x: (quadPoints[i] - pageX) / pageWidth,
                y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
            });
            editor.#createOutlines();
            editor.#addToDrawLayer();
            editor.rotate(editor.rotation);
        } else if (inkLists) {
            editor.#isFreeHighlight = true;
            const points = inkLists[0];
            const point = {
                x: points[0] - pageX,
                y: pageHeight - (points[1] - pageY)
            };
            const outliner = new $5942e8eb8ca60ef8$var$FreeHighlightOutliner(point, [
                0,
                0,
                pageWidth,
                pageHeight
            ], 1, editor.#thickness / 2, true, 0.001);
            for(let i = 0, ii = points.length; i < ii; i += 2){
                point.x = points[i] - pageX;
                point.y = pageHeight - (points[i + 1] - pageY);
                outliner.add(point);
            }
            const { id: id, clipPathId: clipPathId } = parent.drawLayer.draw({
                bbox: [
                    0,
                    0,
                    1,
                    1
                ],
                root: {
                    viewBox: "0 0 1 1",
                    fill: editor.color,
                    "fill-opacity": editor._defaultOpacity
                },
                rootClass: {
                    highlight: true,
                    free: true
                },
                path: {
                    d: outliner.toSVGPath()
                }
            }, true, true);
            editor.#createFreeOutlines({
                highlightOutlines: outliner.getOutlines(),
                highlightId: id,
                clipPathId: clipPathId
            });
            editor.#addToDrawLayer();
            editor.rotate(editor.parentRotation);
        }
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $5942e8eb8ca60ef8$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
        const serialized = super.serialize(isForCopying);
        Object.assign(serialized, {
            color: color,
            opacity: this.opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(serialized.rect)
        });
        this.addComment(serialized);
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color } = this._initialData;
        return this.hasEditedComment || serialized.color.some((c, i)=>c !== color[i]);
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $5942e8eb8ca60ef8$var$DrawingOptions {
    #svgProperties = Object.create(null);
    updateProperty(name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    }
    updateProperties(properties) {
        if (!properties) return;
        for (const [name, value] of Object.entries(properties))if (!name.startsWith("_")) this.updateProperty(name, value);
    }
    updateSVGProperty(name, value) {
        this.#svgProperties[name] = value;
    }
    toSVGProperties() {
        const root = this.#svgProperties;
        this.#svgProperties = Object.create(null);
        return {
            root: root
        };
    }
    reset() {
        this.#svgProperties = Object.create(null);
    }
    updateAll(options = this) {
        this.updateProperties(options);
    }
    clone() {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
}
class $5942e8eb8ca60ef8$var$DrawingEditor extends $5942e8eb8ca60ef8$var$AnnotationEditor {
    #drawOutlines = null;
    #mustBeCommitted;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #currentDraw = null;
    static #currentDrawingAC = null;
    static #currentDrawingOptions = null;
    static #currentPointerId = NaN;
    static #currentPointerType = null;
    static #currentPointerIds = null;
    static #currentMoveTimestamp = NaN;
    static _INNER_MARGIN = 3;
    constructor(params){
        super(params);
        this.#mustBeCommitted = params.mustBeCommitted || false;
        this._addOutlines(params);
    }
    onUpdatedColor() {
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    _addOutlines(params) {
        if (params.drawOutlines) {
            this.#createDrawOutlines(params);
            this.#addToDrawLayer();
        }
    }
    #createDrawOutlines({ drawOutlines: drawOutlines, drawId: drawId, drawingOptions: drawingOptions }) {
        this.#drawOutlines = drawOutlines;
        this._drawingOptions ||= drawingOptions;
        if (!this.annotationElementId) this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        } else this._drawId = this.#createDrawing(drawOutlines, this.parent);
        this.#updateBbox(drawOutlines.box);
    }
    #createDrawing(drawOutlines, parent) {
        const { id: id } = parent.drawLayer.draw($5942e8eb8ca60ef8$var$DrawingEditor._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false);
        return id;
    }
    static _mergeSVGProperties(p1, p2) {
        const p1Keys = new Set(Object.keys(p1));
        for (const [key, value] of Object.entries(p2))if (p1Keys.has(key)) Object.assign(p1[key], value);
        else p1[key] = value;
        return p1;
    }
    static getDefaultDrawingOptions(_options) {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
    static get typesMap() {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
    static get isDrawer() {
        return true;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static updateDefaultParams(type, value) {
        const propertyName = this.typesMap.get(type);
        if (propertyName) this._defaultDrawingOptions.updateProperty(propertyName, value);
        if (this._currentParent) {
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    }
    updateParams(type, value) {
        const propertyName = this.constructor.typesMap.get(type);
        if (propertyName) this._updateProperty(type, propertyName, value);
    }
    static get defaultPropertiesToUpdate() {
        const properties = [];
        const options = this._defaultDrawingOptions;
        for (const [type, name] of this.typesMap)properties.push([
            type,
            options[name]
        ]);
        return properties;
    }
    get propertiesToUpdate() {
        const properties = [];
        const { _drawingOptions: _drawingOptions } = this;
        for (const [type, name] of this.constructor.typesMap)properties.push([
            type,
            _drawingOptions[name]
        ]);
        return properties;
    }
    _updateProperty(type, name, value) {
        const options = this._drawingOptions;
        const savedValue = options[name];
        const setter = (val)=>{
            options.updateProperty(name, val);
            const bbox = this.#drawOutlines.updateProperty(name, val);
            if (bbox) this.#updateBbox(bbox);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            if (type === this.colorType) this.onUpdatedColor();
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _onResizing() {
        this.parent?.drawLayer.updateProperties(this._drawId, $5942e8eb8ca60ef8$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizingSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onResized() {
        this.parent?.drawLayer.updateProperties(this._drawId, $5942e8eb8ca60ef8$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizedSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onTranslating(_x, _y) {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            bbox: this.#rotateBox()
        });
    }
    _onTranslated() {
        this.parent?.drawLayer.updateProperties(this._drawId, $5942e8eb8ca60ef8$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathTranslatedSVGProperties(this.#convertToDrawSpace(), this.parentDimensions), {
            bbox: this.#rotateBox()
        }));
    }
    _onStartDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    }
    _onStopDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    }
    commit() {
        super.commit();
        this.disableEditMode();
        this.disableEditing();
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    get isResizable() {
        return true;
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        this._isDraggable = true;
        if (this.#mustBeCommitted) {
            this.#mustBeCommitted = false;
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) this.div.focus();
        }
    }
    remove() {
        this.#cleanDrawLayer();
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        this.#updateBbox(this.#drawOutlines.box);
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            this.#cleanDrawLayer();
        } else if (parent) {
            this._uiManager.addShouldRescale(this);
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        if (mustBeSelected) this.select();
    }
    #cleanDrawLayer() {
        if (this._drawId === null || !this.parent) return;
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }
    #addToDrawLayer(parent = this.parent) {
        if (this._drawId !== null && this.parent === parent) return;
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = this.#createDrawing(this.#drawOutlines, parent);
    }
    #convertToParentSpace([x, y, width, height]) {
        const { parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    y,
                    1 - x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    1 - y,
                    x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #convertToDrawSpace() {
        const { x: x, y: y, width: width, height: height, parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #updateBbox(bbox) {
        [this.x, this.y, this.width, this.height] = this.#convertToParentSpace(bbox);
        if (this.div) {
            this.fixAndSetPosition();
            this.setDims();
        }
        this._onResized();
    }
    #rotateBox() {
        const { x: x, y: y, width: width, height: height, rotation: rotation, parentRotation: parentRotation, parentDimensions: [pW, pH] } = this;
        switch((rotation * 4 + parentRotation) / 90){
            case 1:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 2:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 3:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
            case 4:
                return [
                    x,
                    y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 5:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 6:
                return [
                    1 - x - height * (pH / pW),
                    1 - y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 7:
                return [
                    y - width * (pW / pH),
                    1 - x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 8:
                return [
                    x - width,
                    y - height,
                    width,
                    height
                ];
            case 9:
                return [
                    1 - y,
                    x - width,
                    height,
                    width
                ];
            case 10:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 11:
                return [
                    y - height,
                    1 - x,
                    height,
                    width
                ];
            case 12:
                return [
                    x - height * (pH / pW),
                    y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 13:
                return [
                    1 - y - width * (pW / pH),
                    x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 14:
                return [
                    1 - x,
                    1 - y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 15:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    rotate() {
        if (!this.parent) return;
        this.parent.drawLayer.updateProperties(this._drawId, $5942e8eb8ca60ef8$var$DrawingEditor._mergeSVGProperties({
            bbox: this.#rotateBox()
        }, this.#drawOutlines.updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    }
    onScaleChanging() {
        if (!this.parent) return;
        this.#updateBbox(this.#drawOutlines.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        const div = super.render();
        div.classList.add("draw");
        const drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        this.setDims();
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        return div;
    }
    static createDrawerInstance(_x, _y, _parentWidth, _parentHeight, _rotation) {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
    static startDrawing(parent, uiManager, _isLTR, event) {
        const { target: target, offsetX: x, offsetY: y, pointerId: pointerId, pointerType: pointerType } = event;
        if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerType && $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerType !== pointerType) return;
        const { viewport: { rotation: rotation } } = parent;
        const { width: parentWidth, height: parentHeight } = target.getBoundingClientRect();
        const ac = $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingAC = new AbortController();
        const signal = parent.combinedSignal(ac);
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerId ||= pointerId;
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerType ??= pointerType;
        window.addEventListener("pointerup", (e)=>{
            if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerId === e.pointerId) this._endDraw(e);
            else $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerIds?.delete(e.pointerId);
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", (e)=>{
            if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerId === e.pointerId) this._currentParent.endDrawingSession();
            else $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerIds?.delete(e.pointerId);
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", (e)=>{
            if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerType !== e.pointerType) return;
            ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerIds ||= new Set()).add(e.pointerId);
            if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.isCancellable()) {
                $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.removeLastElement();
                if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.isEmpty()) this._currentParent.endDrawingSession(true);
                else this._endDraw(null);
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $5942e8eb8ca60ef8$export$455b7811f904cadc, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", (e)=>{
            if (e.timeStamp === $5942e8eb8ca60ef8$var$DrawingEditor.#currentMoveTimestamp) $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(e);
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        uiManager._editorUndoBar?.hide();
        if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw) {
            parent.drawLayer.updateProperties(this._currentDrawId, $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw = this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation);
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingOptions = this.getDefaultDrawingOptions();
        this._currentParent = parent;
        ({ id: this._currentDrawId } = parent.drawLayer.draw(this._mergeSVGProperties($5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingOptions.toSVGProperties(), $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.defaultSVGProperties), true, false));
    }
    static _drawMove(event) {
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentMoveTimestamp = -1;
        if (!$5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw) return;
        const { offsetX: offsetX, offsetY: offsetY, pointerId: pointerId } = event;
        if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerId !== pointerId) return;
        if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerIds?.size >= 1) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.add(offsetX, offsetY));
        $5942e8eb8ca60ef8$var$DrawingEditor.#currentMoveTimestamp = event.timeStamp;
        $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050(event);
    }
    static _cleanup(all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw = null;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingOptions = null;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerType = null;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentMoveTimestamp = NaN;
        }
        if ($5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingAC) {
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingAC.abort();
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingAC = null;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerId = NaN;
            $5942e8eb8ca60ef8$var$DrawingEditor.#currentPointerIds = null;
        }
    }
    static _endDraw(event) {
        const parent = this._currentParent;
        if (!parent) return;
        parent.toggleDrawing(true);
        this._cleanup(false);
        if (event?.target === parent.div) parent.drawLayer.updateProperties(this._currentDrawId, $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.end(event.offsetX, event.offsetY));
        if (this.supportMultipleDrawings) {
            const draw = $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw;
            const drawId = this._currentDrawId;
            const lastElement = draw.getLastElement();
            parent.addCommands({
                cmd: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.setLastElement(lastElement));
                },
                undo: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.removeLastElement());
                },
                mustExec: false,
                type: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    }
    static endDrawing(isAborted) {
        const parent = this._currentParent;
        if (!parent) return null;
        parent.toggleDrawing(true);
        parent.cleanUndoStack($5942e8eb8ca60ef8$export$cf3df2a6ecc26692.DRAW_STEP);
        if (!$5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.isEmpty()) {
            const { pageDimensions: [pageWidth, pageHeight], scale: scale } = parent;
            const editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: $5942e8eb8ca60ef8$var$DrawingEditor.#currentDraw.getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: $5942e8eb8ca60ef8$var$DrawingEditor.#currentDrawingOptions,
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    }
    createDrawingOptions(_data) {}
    static deserializeDraw(_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        $5942e8eb8ca60ef8$var$unreachable("Not implemented");
    }
    static async deserialize(data, parent, uiManager) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = parent.viewport;
        const drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
        const editor = await super.deserialize(data, parent, uiManager);
        editor.createDrawingOptions(data);
        editor.#createDrawOutlines({
            drawOutlines: drawOutlines
        });
        editor.#addToDrawLayer();
        editor.onScaleChanging();
        editor.rotate();
        return editor;
    }
    serializeDraw(isForCopying) {
        const [pageX, pageY] = this.pageTranslation;
        const [pageWidth, pageHeight] = this.pageDimensions;
        return this.#drawOutlines.serialize([
            pageX,
            pageY,
            pageWidth,
            pageHeight
        ], isForCopying);
    }
    renderAnnotationElement(annotation) {
        annotation.updateEdited({
            rect: this.getPDFRect()
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $5942e8eb8ca60ef8$var$InkDrawOutliner {
    #last = new Float64Array(6);
    #line;
    #lines;
    #rotation;
    #thickness;
    #points;
    #lastSVGPath = "";
    #lastIndex = 0;
    #outlines = new $5942e8eb8ca60ef8$var$InkDrawOutline();
    #parentWidth;
    #parentHeight;
    constructor(x, y, parentWidth, parentHeight, rotation, thickness){
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        this.#thickness = thickness;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        this.#lines = [
            {
                line: line,
                points: this.#points
            }
        ];
        this.#last.set(line, 0);
    }
    updateProperty(name, value) {
        if (name === "stroke-width") this.#thickness = value;
    }
    #normalizePoint(x, y) {
        return $5942e8eb8ca60ef8$var$Outline._normalizePoint(x, y, this.#parentWidth, this.#parentHeight, this.#rotation);
    }
    isEmpty() {
        return !this.#lines || this.#lines.length === 0;
    }
    isCancellable() {
        return this.#points.length <= 10;
    }
    add(x, y) {
        [x, y] = this.#normalizePoint(x, y);
        const [x1, y1, x2, y2] = this.#last.subarray(2, 6);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(this.#parentWidth * diffX, this.#parentHeight * diffY);
        if (d <= 2) return null;
        this.#points.push(x, y);
        if (isNaN(x1)) {
            this.#last.set([
                x2,
                y2,
                x,
                y
            ], 2);
            this.#line.push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(this.#last[0])) this.#line.splice(6, 6);
        this.#last.set([
            x1,
            y1,
            x2,
            y2,
            x,
            y
        ], 0);
        this.#line.push(...$5942e8eb8ca60ef8$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    end(x, y) {
        const change = this.add(x, y);
        if (change) return change;
        if (this.#points.length === 2) return {
            path: {
                d: this.toSVGPath()
            }
        };
        return null;
    }
    startNew(x, y, parentWidth, parentHeight, rotation) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        const last = this.#lines.at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        this.#lines.push({
            line: line,
            points: this.#points
        });
        this.#last.set(line, 0);
        this.#lastIndex = 0;
        this.toSVGPath();
        return null;
    }
    getLastElement() {
        return this.#lines.at(-1);
    }
    setLastElement(element) {
        if (!this.#lines) return this.#outlines.setLastElement(element);
        this.#lines.push(element);
        this.#line = element.line;
        this.#points = element.points;
        this.#lastIndex = 0;
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        if (!this.#lines) return this.#outlines.removeLastElement();
        this.#lines.pop();
        this.#lastSVGPath = "";
        for(let i = 0, ii = this.#lines.length; i < ii; i++){
            const { line: line, points: points } = this.#lines[i];
            this.#line = line;
            this.#points = points;
            this.#lastIndex = 0;
            this.toSVGPath();
        }
        return {
            path: {
                d: this.#lastSVGPath
            }
        };
    }
    toSVGPath() {
        const firstX = $5942e8eb8ca60ef8$var$Outline.svgRound(this.#line[4]);
        const firstY = $5942e8eb8ca60ef8$var$Outline.svgRound(this.#line[5]);
        if (this.#points.length === 2) {
            this.#lastSVGPath = `${this.#lastSVGPath} M ${firstX} ${firstY} Z`;
            return this.#lastSVGPath;
        }
        if (this.#points.length <= 6) {
            const i = this.#lastSVGPath.lastIndexOf("M");
            this.#lastSVGPath = `${this.#lastSVGPath.slice(0, i)} M ${firstX} ${firstY}`;
            this.#lastIndex = 6;
        }
        if (this.#points.length === 4) {
            const secondX = $5942e8eb8ca60ef8$var$Outline.svgRound(this.#line[10]);
            const secondY = $5942e8eb8ca60ef8$var$Outline.svgRound(this.#line[11]);
            this.#lastSVGPath = `${this.#lastSVGPath} L ${secondX} ${secondY}`;
            this.#lastIndex = 12;
            return this.#lastSVGPath;
        }
        const buffer = [];
        if (this.#lastIndex === 0) {
            buffer.push(`M ${firstX} ${firstY}`);
            this.#lastIndex = 6;
        }
        for(let i = this.#lastIndex, ii = this.#line.length; i < ii; i += 6){
            const [c1x, c1y, c2x, c2y, x, y] = this.#line.slice(i, i + 6).map($5942e8eb8ca60ef8$var$Outline.svgRound);
            buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
        }
        this.#lastSVGPath += buffer.join(" ");
        this.#lastIndex = this.#line.length;
        return this.#lastSVGPath;
    }
    getOutlines(parentWidth, parentHeight, scale, innerMargin) {
        const last = this.#lines.at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        this.#outlines.build(this.#lines, parentWidth, parentHeight, scale, this.#rotation, this.#thickness, innerMargin);
        this.#last = null;
        this.#line = null;
        this.#lines = null;
        this.#lastSVGPath = null;
        return this.#outlines;
    }
    get defaultSVGProperties() {
        return {
            root: {
                viewBox: "0 0 10000 10000"
            },
            rootClass: {
                draw: true
            },
            bbox: [
                0,
                0,
                1,
                1
            ]
        };
    }
}
class $5942e8eb8ca60ef8$var$InkDrawOutline extends $5942e8eb8ca60ef8$var$Outline {
    #bbox;
    #currentRotation = 0;
    #innerMargin;
    #lines;
    #parentWidth;
    #parentHeight;
    #parentScale;
    #rotation;
    #thickness;
    build(lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#parentScale = parentScale;
        this.#rotation = rotation;
        this.#thickness = thickness;
        this.#innerMargin = innerMargin ?? 0;
        this.#lines = lines;
        this.#computeBbox();
    }
    get thickness() {
        return this.#thickness;
    }
    setLastElement(element) {
        this.#lines.push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        this.#lines.pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    toSVGPath() {
        const buffer = [];
        for (const { line: line } of this.#lines){
            buffer.push(`M${$5942e8eb8ca60ef8$var$Outline.svgRound(line[4])} ${$5942e8eb8ca60ef8$var$Outline.svgRound(line[5])}`);
            if (line.length === 6) {
                buffer.push("Z");
                continue;
            }
            if (line.length === 12 && isNaN(line[6])) {
                buffer.push(`L${$5942e8eb8ca60ef8$var$Outline.svgRound(line[10])} ${$5942e8eb8ca60ef8$var$Outline.svgRound(line[11])}`);
                continue;
            }
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6).map($5942e8eb8ca60ef8$var$Outline.svgRound);
                buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
            }
        }
        return buffer.join("");
    }
    serialize([pageX, pageY, pageWidth, pageHeight], isForCopying) {
        const serializedLines = [];
        const serializedPoints = [];
        const [x, y, width, height] = this.#getBBoxWithNoMargin();
        let tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch(this.#rotation){
            case 0:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        for (const { line: line, points: points } of this.#lines){
            serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
            serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [
                x1,
                y1,
                x2,
                y2
            ]
        };
    }
    static deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, { paths: { lines: lines, points: points }, rotation: rotation, thickness: thickness }) {
        const newLines = [];
        let tx, ty, sx, sy, rescaleFn;
        switch(rotation){
            case 0:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = $5942e8eb8ca60ef8$var$Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            for (const point of points){
                const len = point.length;
                if (len === 2) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1]
                    ]));
                    continue;
                }
                if (len === 4) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1],
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[2],
                        point[3]
                    ]));
                    continue;
                }
                const line = new Float32Array(3 * (len - 2));
                lines.push(line);
                let [x1, y1, x2, y2] = point.subarray(0, 4);
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    x1,
                    y1
                ], 0);
                for(let i = 4; i < len; i += 2){
                    const x = point[i];
                    const y = point[i + 1];
                    line.set($5942e8eb8ca60ef8$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    [x1, y1, x2, y2] = [
                        x2,
                        y2,
                        x,
                        y
                    ];
                }
            }
        }
        for(let i = 0, ii = lines.length; i < ii; i++)newLines.push({
            line: rescaleFn(lines[i].map((x)=>x ?? NaN), tx, ty, sx, sy),
            points: rescaleFn(points[i].map((x)=>x ?? NaN), tx, ty, sx, sy)
        });
        const outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    }
    #getMarginComponents(thickness = this.#thickness) {
        const margin = this.#innerMargin + thickness / 2 * this.#parentScale;
        return this.#rotation % 180 === 0 ? [
            margin / this.#parentWidth,
            margin / this.#parentHeight
        ] : [
            margin / this.#parentHeight,
            margin / this.#parentWidth
        ];
    }
    #getBBoxWithNoMargin() {
        const [x, y, width, height] = this.#bbox;
        const [marginX, marginY] = this.#getMarginComponents(0);
        return [
            x + marginX,
            y + marginY,
            width - 2 * marginX,
            height - 2 * marginY
        ];
    }
    #computeBbox() {
        const bbox = this.#bbox = new Float32Array([
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ]);
        for (const { line: line } of this.#lines){
            if (line.length <= 12) {
                for(let i = 4, ii = line.length; i < ii; i += 6)$5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.pointBoundingBox(line[i], line[i + 1], bbox);
                continue;
            }
            let lastX = line[4], lastY = line[5];
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6);
                $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
        const [marginX, marginY] = this.#getMarginComponents();
        bbox[0] = $5942e8eb8ca60ef8$export$b8106b171181a554(bbox[0] - marginX, 0, 1);
        bbox[1] = $5942e8eb8ca60ef8$export$b8106b171181a554(bbox[1] - marginY, 0, 1);
        bbox[2] = $5942e8eb8ca60ef8$export$b8106b171181a554(bbox[2] + marginX, 0, 1);
        bbox[3] = $5942e8eb8ca60ef8$export$b8106b171181a554(bbox[3] + marginY, 0, 1);
        bbox[2] -= bbox[0];
        bbox[3] -= bbox[1];
    }
    get box() {
        return this.#bbox;
    }
    updateProperty(name, value) {
        if (name === "stroke-width") return this.#updateThickness(value);
        return null;
    }
    #updateThickness(thickness) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#thickness = thickness;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const [diffMarginX, diffMarginY] = [
            newMarginX - oldMarginX,
            newMarginY - oldMarginY
        ];
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateParentDimensions([width, height], scale) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#parentWidth = width;
        this.#parentHeight = height;
        this.#parentScale = scale;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const diffMarginX = newMarginX - oldMarginX;
        const diffMarginY = newMarginY - oldMarginY;
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateRotation(rotation) {
        this.#currentRotation = rotation;
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    }
    get viewBox() {
        return this.#bbox.map($5942e8eb8ca60ef8$var$Outline.svgRound).join(" ");
    }
    get defaultProperties() {
        const [x, y] = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(x)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(y)}`
            }
        };
    }
    get rotationTransform() {
        const [, , width, height] = this.#bbox;
        let a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
        switch(this.#currentRotation){
            case 90:
                b = height / width;
                c = -width / height;
                e = width;
                break;
            case 180:
                a = -1;
                d = -1;
                e = width;
                f = height;
                break;
            case 270:
                b = -height / width;
                c = width / height;
                f = height;
                break;
            default:
                return "";
        }
        return `matrix(${a} ${b} ${c} ${d} ${$5942e8eb8ca60ef8$var$Outline.svgRound(e)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(f)})`;
    }
    getPathResizingSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const [x, y, width, height] = this.#bbox;
        if (Math.abs(width - marginX) <= $5942e8eb8ca60ef8$var$Outline.PRECISION || Math.abs(height - marginY) <= $5942e8eb8ca60ef8$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(newX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(newY)}`,
                    transform: `${this.rotationTransform} translate(${tx} ${ty})`
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const s2x = width / newWidth;
        const s2y = height / newHeight;
        return {
            path: {
                "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(x)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(y)}`,
                transform: `${this.rotationTransform} scale(${s2x} ${s2y}) ` + `translate(${$5942e8eb8ca60ef8$var$Outline.svgRound(marginX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(marginY)}) scale(${s1x} ${s1y}) ` + `translate(${$5942e8eb8ca60ef8$var$Outline.svgRound(-marginX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(-marginY)})`
            }
        };
    }
    getPathResizedSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const bbox = this.#bbox;
        const [x, y, width, height] = bbox;
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= $5942e8eb8ca60ef8$var$Outline.PRECISION || Math.abs(height - marginY) <= $5942e8eb8ca60ef8$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            for (const { line: line, points: points } of this.#lines){
                $5942e8eb8ca60ef8$var$Outline._translate(line, tx, ty, line);
                $5942e8eb8ca60ef8$var$Outline._translate(points, tx, ty, points);
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(newX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(newY)}`,
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const tx = -s1x * (x + marginX) + newX + marginX;
        const ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) for (const { line: line, points: points } of this.#lines){
            $5942e8eb8ca60ef8$var$Outline._rescale(line, tx, ty, s1x, s1y, line);
            $5942e8eb8ca60ef8$var$Outline._rescale(points, tx, ty, s1x, s1y, points);
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(newX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(newY)}`,
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    }
    getPathTranslatedSVGProperties([newX, newY], parentDimensions) {
        const [newParentWidth, newParentHeight] = parentDimensions;
        const bbox = this.#bbox;
        const tx = newX - bbox[0];
        const ty = newY - bbox[1];
        if (this.#parentWidth === newParentWidth && this.#parentHeight === newParentHeight) for (const { line: line, points: points } of this.#lines){
            $5942e8eb8ca60ef8$var$Outline._translate(line, tx, ty, line);
            $5942e8eb8ca60ef8$var$Outline._translate(points, tx, ty, points);
        }
        else {
            const sx = this.#parentWidth / newParentWidth;
            const sy = this.#parentHeight / newParentHeight;
            this.#parentWidth = newParentWidth;
            this.#parentHeight = newParentHeight;
            for (const { line: line, points: points } of this.#lines){
                $5942e8eb8ca60ef8$var$Outline._rescale(line, tx, ty, sx, sy, line);
                $5942e8eb8ca60ef8$var$Outline._rescale(points, tx, ty, sx, sy, points);
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(newX)} ${$5942e8eb8ca60ef8$var$Outline.svgRound(newY)}`
            }
        };
    }
    get defaultSVGProperties() {
        const bbox = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            rootClass: {
                draw: true
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$5942e8eb8ca60ef8$var$Outline.svgRound(bbox[0])} ${$5942e8eb8ca60ef8$var$Outline.svgRound(bbox[1])}`,
                transform: this.rotationTransform || null
            },
            bbox: bbox
        };
    }
}
class $5942e8eb8ca60ef8$var$InkDrawingOptions extends $5942e8eb8ca60ef8$var$DrawingOptions {
    constructor(viewerParameters){
        super();
        this._viewParameters = viewerParameters;
        super.updateProperties({
            fill: "none",
            stroke: $5942e8eb8ca60ef8$var$AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
    }
    updateSVGProperty(name, value) {
        if (name === "stroke-width") {
            value ??= this["stroke-width"];
            value *= this._viewParameters.realScale;
        }
        super.updateSVGProperty(name, value);
    }
    clone() {
        const clone = new $5942e8eb8ca60ef8$var$InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $5942e8eb8ca60ef8$var$InkEditor extends $5942e8eb8ca60ef8$var$DrawingEditor {
    static _type = "ink";
    static _editorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.INK;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this._willKeepAspectRatio = true;
        this.defaultL10nId = "pdfjs-editor-ink-editor";
    }
    static initialize(l10n, uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $5942e8eb8ca60ef8$var$InkDrawingOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return true;
    }
    static get typesMap() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "typesMap", new Map([
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.INK_THICKNESS,
                "stroke-width"
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.INK_COLOR,
                "stroke"
            ],
            [
                $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.INK_OPACITY,
                "stroke-opacity"
            ]
        ]));
    }
    static createDrawerInstance(x, y, parentWidth, parentHeight, rotation) {
        return new $5942e8eb8ca60ef8$var$InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return $5942e8eb8ca60ef8$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $5942e8eb8ca60ef8$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.INK,
                color: Array.from(color),
                thickness: thickness,
                opacity: opacity,
                paths: {
                    points: inkLists
                },
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    get toolbarButtons() {
        this._colorPicker ||= new $5942e8eb8ca60ef8$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $5942e8eb8ca60ef8$export$cf3df2a6ecc26692.INK_COLOR;
    }
    get color() {
        return this._drawingOptions.stroke;
    }
    get opacity() {
        return this._drawingOptions["stroke-opacity"];
    }
    onScaleChanging() {
        if (!this.parent) return;
        super.onScaleChanging();
        const { _drawId: _drawId, _drawingOptions: _drawingOptions, parent: parent } = this;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    }
    static onScaleChangingWhenDrawing() {
        const parent = this._currentParent;
        if (!parent) return;
        super.onScaleChangingWhenDrawing();
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    }
    createDrawingOptions({ color: color, thickness: thickness, opacity: opacity }) {
        this._drawingOptions = $5942e8eb8ca60ef8$var$InkEditor.getDefaultDrawingOptions({
            stroke: $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd.makeHexColor(...color),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { stroke: stroke, "stroke-opacity": opacity, "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: $5942e8eb8ca60ef8$var$AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            }
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color, thickness: thickness, opacity: opacity, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || serialized.color.some((c, i)=>c !== color[i]) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        const { points: points, rect: rect } = this.serializeDraw(false);
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points,
            popup: this.comment
        });
        return null;
    }
}
class $5942e8eb8ca60ef8$var$ContourDrawOutline extends $5942e8eb8ca60ef8$var$InkDrawOutline {
    toSVGPath() {
        let path = super.toSVGPath();
        if (!path.endsWith("Z")) path += "Z";
        return path;
    }
}
const $5942e8eb8ca60ef8$var$BASE_HEADER_LENGTH = 8;
const $5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER = 3;
class $5942e8eb8ca60ef8$export$cc4fe8633f466b4a {
    static #PARAMETERS = {
        maxDim: 512,
        sigmaSFactor: 0.02,
        sigmaR: 25,
        kernelSize: 16
    };
    static #neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) return j > 0 ? 0 : 4;
        if (i === 1) return j + 6;
        return 2 - j;
    }
    static #neighborIdToIndex = new Int32Array([
        0,
        1,
        -1,
        1,
        -1,
        0,
        -1,
        -1,
        0,
        -1,
        1,
        -1,
        1,
        0,
        1,
        1
    ]);
    static #clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (-k + id - offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (k + id + offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #findContours(buf, width, height, threshold) {
        const N = buf.length;
        const types = new Int32Array(N);
        for(let i = 0; i < N; i++)types[i] = buf[i] <= threshold ? 1 : 0;
        for(let i = 1; i < height - 1; i++)types[i * width] = types[i * width + width - 1] = 0;
        for(let i = 0; i < width; i++)types[i] = types[width * height - 1 - i] = 0;
        let nbd = 1;
        let lnbd;
        const contours = [];
        for(let i = 1; i < height - 1; i++){
            lnbd = 1;
            for(let j = 1; j < width - 1; j++){
                const ij = i * width + j;
                const pix = types[ij];
                if (pix === 0) continue;
                let i2 = i;
                let j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                } else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) lnbd = pix;
                } else {
                    if (pix !== 1) lnbd = Math.abs(pix);
                    continue;
                }
                const points = [
                    j,
                    i
                ];
                const isHole = j2 === j + 1;
                const contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                let contour0;
                for (const c of contours)if (c.id === lnbd) {
                    contour0 = c;
                    break;
                }
                if (!contour0) contour.parent = isHole ? lnbd : 0;
                else if (contour0.isHole) contour.parent = isHole ? contour0.parent : lnbd;
                else contour.parent = isHole ? lnbd : contour0.parent;
                const k = this.#clockwiseNonZero(types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                    continue;
                }
                let shiftI = this.#neighborIdToIndex[2 * k];
                let shiftJ = this.#neighborIdToIndex[2 * k + 1];
                const i1 = i + shiftI;
                const j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                let i3 = i;
                let j3 = j;
                while(true){
                    const kk = this.#counterClockwiseNonZero(types, width, i3, j3, i2, j2, 1);
                    shiftI = this.#neighborIdToIndex[2 * kk];
                    shiftJ = this.#neighborIdToIndex[2 * kk + 1];
                    const i4 = i3 + shiftI;
                    const j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    const ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) types[ij3] = -nbd;
                    else if (types[ij3] === 1) types[ij3] = nbd;
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                        break;
                    } else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }
    static #douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for(let i = start; i < end - 2; i += 2)output.push(points[i], points[i + 1]);
            return;
        }
        const ax = points[start];
        const ay = points[start + 1];
        const abx = points[end - 4] - ax;
        const aby = points[end - 3] - ay;
        const dist = Math.hypot(abx, aby);
        const nabx = abx / dist;
        const naby = aby / dist;
        const aa = nabx * ay - naby * ax;
        const m = aby / abx;
        const invS = 1 / dist;
        const phi = Math.atan(m);
        const cosPhi = Math.cos(phi);
        const sinPhi = Math.sin(phi);
        const tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        const poly = invS * (1 - tmax + tmax ** 2);
        const partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        let dmax = 0;
        let index = start;
        for(let i = start + 2; i < end - 2; i += 2){
            const d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > (dist * partialPhi) ** 2) {
            this.#douglasPeuckerHelper(points, start, index + 2, output);
            this.#douglasPeuckerHelper(points, index, end, output);
        } else output.push(ax, ay);
    }
    static #douglasPeucker(points) {
        const output = [];
        const len = points.length;
        this.#douglasPeuckerHelper(points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }
    static #bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        const kernel = new Float32Array(kernelSize ** 2);
        const sigmaS2 = -2 * sigmaS ** 2;
        const halfSize = kernelSize >> 1;
        for(let i = 0; i < kernelSize; i++){
            const x = (i - halfSize) ** 2;
            for(let j = 0; j < kernelSize; j++)kernel[i * kernelSize + j] = Math.exp((x + (j - halfSize) ** 2) / sigmaS2);
        }
        const rangeValues = new Float32Array(256);
        const sigmaR2 = -2 * sigmaR ** 2;
        for(let i = 0; i < 256; i++)rangeValues[i] = Math.exp(i ** 2 / sigmaR2);
        const N = buf.length;
        const out = new Uint8Array(N);
        const histogram = new Uint32Array(256);
        for(let i = 0; i < height; i++)for(let j = 0; j < width; j++){
            const ij = i * width + j;
            const center = buf[ij];
            let sum = 0;
            let norm = 0;
            for(let k = 0; k < kernelSize; k++){
                const y = i + k - halfSize;
                if (y < 0 || y >= height) continue;
                for(let l = 0; l < kernelSize; l++){
                    const x = j + l - halfSize;
                    if (x < 0 || x >= width) continue;
                    const neighbour = buf[y * width + x];
                    const w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                    sum += neighbour * w;
                    norm += w;
                }
            }
            const pix = out[ij] = Math.round(sum / norm);
            histogram[pix]++;
        }
        return [
            out,
            histogram
        ];
    }
    static #getHistogram(buf) {
        const histogram = new Uint32Array(256);
        for (const g of buf)histogram[g]++;
        return histogram;
    }
    static #toUint8(buf) {
        const N = buf.length;
        const out = new Uint8ClampedArray(N >> 2);
        let max = -Infinity;
        let min = Infinity;
        for(let i = 0, ii = out.length; i < ii; i++){
            const pix = out[i] = buf[i << 2];
            max = Math.max(max, pix);
            min = Math.min(min, pix);
        }
        const ratio = 255 / (max - min);
        for(let i = 0, ii = out.length; i < ii; i++)out[i] = (out[i] - min) * ratio;
        return out;
    }
    static #guessThreshold(histogram) {
        let i;
        let M = -Infinity;
        let L = -Infinity;
        const min = histogram.findIndex((v)=>v !== 0);
        let pos = min;
        let spos = min;
        for(i = min; i < 256; i++){
            const v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for(i = spos - 1; i >= 0; i--){
            if (histogram[i] > histogram[i + 1]) break;
        }
        return i;
    }
    static #getGrayPixels(bitmap) {
        const originalBitmap = bitmap;
        const { width: width, height: height } = bitmap;
        const { maxDim: maxDim } = this.#PARAMETERS;
        let newWidth = width;
        let newHeight = height;
        if (width > maxDim || height > maxDim) {
            let prevWidth = width;
            let prevHeight = height;
            let steps = Math.log2(Math.max(width, height) / maxDim);
            const isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for(let i = 0; i < steps; i++){
                newWidth = Math.ceil(prevWidth / 2);
                newHeight = Math.ceil(prevHeight / 2);
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx = offscreen.getContext("2d");
                ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) bitmap.close();
                bitmap = offscreen.transferToImageBitmap();
            }
            const ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        const offscreen = new OffscreenCanvas(newWidth, newHeight);
        const ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, newWidth, newHeight);
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        const grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        const uint8Buf = this.#toUint8(grayImage);
        return [
            uint8Buf,
            newWidth,
            newHeight
        ];
    }
    static extractContoursFromText(text, { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }, pageWidth, pageHeight, rotation, innerMargin) {
        let canvas = new OffscreenCanvas(1, 1);
        let ctx = canvas.getContext("2d", {
            alpha: false
        });
        const fontSize = 200;
        const font = ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, fontBoundingBoxAscent: fontBoundingBoxAscent, fontBoundingBoxDescent: fontBoundingBoxDescent, width: width } = ctx.measureText(text);
        const SCALE = 1.5;
        const canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        const canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        const uint8Buf = this.#toUint8(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        const histogram = this.#getHistogram(uint8Buf);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static process(bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        const [uint8Buf, width, height] = this.#getGrayPixels(bitmap);
        const [buffer, histogram] = this.#bilateralFilter(uint8Buf, width, height, Math.hypot(width, height) * this.#PARAMETERS.sigmaSFactor, this.#PARAMETERS.sigmaR, this.#PARAMETERS.kernelSize);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static processDrawnLines({ lines: lines, pageWidth: pageWidth, pageHeight: pageHeight, rotation: rotation, innerMargin: innerMargin, mustSmooth: mustSmooth, areContours: areContours }) {
        if (rotation % 180 !== 0) [pageWidth, pageHeight] = [
            pageHeight,
            pageWidth
        ];
        const { curves: curves, width: width, height: height } = lines;
        const thickness = lines.thickness ?? 0;
        const linesAndPoints = [];
        const ratio = Math.min(pageWidth / width, pageHeight / height);
        const xScale = ratio / pageWidth;
        const yScale = ratio / pageHeight;
        const newCurves = [];
        for (const { points: points } of curves){
            const reducedPoints = mustSmooth ? this.#douglasPeucker(points) : points;
            if (!reducedPoints) continue;
            newCurves.push(reducedPoints);
            const len = reducedPoints.length;
            const newPoints = new Float32Array(len);
            const line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
            linesAndPoints.push({
                line: line,
                points: newPoints
            });
            if (len === 2) {
                newPoints[0] = reducedPoints[0] * xScale;
                newPoints[1] = reducedPoints[1] * yScale;
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    newPoints[0],
                    newPoints[1]
                ], 0);
                continue;
            }
            let [x1, y1, x2, y2] = reducedPoints;
            x1 *= xScale;
            y1 *= yScale;
            x2 *= xScale;
            y2 *= yScale;
            newPoints.set([
                x1,
                y1,
                x2,
                y2
            ], 0);
            line.set([
                NaN,
                NaN,
                NaN,
                NaN,
                x1,
                y1
            ], 0);
            for(let i = 4; i < len; i += 2){
                const x = newPoints[i] = reducedPoints[i] * xScale;
                const y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                line.set($5942e8eb8ca60ef8$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                [x1, y1, x2, y2] = [
                    x2,
                    y2,
                    x,
                    y
                ];
            }
        }
        if (linesAndPoints.length === 0) return null;
        const outline = areContours ? new $5942e8eb8ca60ef8$var$ContourDrawOutline() : new $5942e8eb8ca60ef8$var$InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    }
    static async compressSignature({ outlines: outlines, areContours: areContours, thickness: thickness, width: width, height: height }) {
        let minDiff = Infinity;
        let maxDiff = -Infinity;
        let outlinesLength = 0;
        for (const points of outlines){
            outlinesLength += points.length;
            for(let i = 2, ii = points.length; i < ii; i++){
                const dx = points[i] - points[i - 2];
                minDiff = Math.min(minDiff, dx);
                maxDiff = Math.max(maxDiff, dx);
            }
        }
        let bufferType;
        if (minDiff >= -128 && maxDiff <= 127) bufferType = Int8Array;
        else if (minDiff >= -32768 && maxDiff <= 32767) bufferType = Int16Array;
        else bufferType = Int32Array;
        const len = outlines.length;
        const headerLength = $5942e8eb8ca60ef8$var$BASE_HEADER_LENGTH + $5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER * len;
        const header = new Uint32Array(headerLength);
        let offset = 0;
        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
        header[offset++] = 0;
        header[offset++] = width;
        header[offset++] = height;
        header[offset++] = areContours ? 0 : 1;
        header[offset++] = Math.max(0, Math.floor(thickness ?? 0));
        header[offset++] = len;
        header[offset++] = bufferType.BYTES_PER_ELEMENT;
        for (const points of outlines){
            header[offset++] = points.length - 2;
            header[offset++] = points[0];
            header[offset++] = points[1];
        }
        const cs = new CompressionStream("deflate-raw");
        const writer = cs.writable.getWriter();
        await writer.ready;
        writer.write(header);
        const BufferCtor = bufferType.prototype.constructor;
        for (const points of outlines){
            const diffs = new BufferCtor(points.length - 2);
            for(let i = 2, ii = points.length; i < ii; i++)diffs[i - 2] = points[i] - points[i - 2];
            writer.write(diffs);
        }
        writer.close();
        const buf = await new Response(cs.readable).arrayBuffer();
        const bytes = new Uint8Array(buf);
        return $5942e8eb8ca60ef8$var$toBase64Util(bytes);
    }
    static async decompressSignature(signatureData) {
        try {
            const bytes = $5942e8eb8ca60ef8$var$fromBase64Util(signatureData);
            const { readable: readable, writable: writable } = new DecompressionStream("deflate-raw");
            const writer = writable.getWriter();
            await writer.ready;
            writer.write(bytes).then(async ()=>{
                await writer.ready;
                await writer.close();
            }).catch(()=>{});
            let data = null;
            let offset = 0;
            for await (const chunk of readable){
                data ||= new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]);
                data.set(chunk, offset);
                offset += chunk.length;
            }
            const header = new Uint32Array(data.buffer, 0, data.length >> 2);
            const version = header[1];
            if (version !== 0) throw new Error(`Invalid version: ${version}`);
            const width = header[2];
            const height = header[3];
            const areContours = header[4] === 0;
            const thickness = header[5];
            const numberOfDrawings = header[6];
            const bufferType = header[7];
            const outlines = [];
            const diffsOffset = ($5942e8eb8ca60ef8$var$BASE_HEADER_LENGTH + $5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
            let diffs;
            switch(bufferType){
                case Int8Array.BYTES_PER_ELEMENT:
                    diffs = new Int8Array(data.buffer, diffsOffset);
                    break;
                case Int16Array.BYTES_PER_ELEMENT:
                    diffs = new Int16Array(data.buffer, diffsOffset);
                    break;
                case Int32Array.BYTES_PER_ELEMENT:
                    diffs = new Int32Array(data.buffer, diffsOffset);
                    break;
            }
            offset = 0;
            for(let i = 0; i < numberOfDrawings; i++){
                const len = header[$5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER * i + $5942e8eb8ca60ef8$var$BASE_HEADER_LENGTH];
                const points = new Float32Array(len + 2);
                outlines.push(points);
                for(let j = 0; j < $5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER - 1; j++)points[j] = header[$5942e8eb8ca60ef8$var$POINTS_PROPERTIES_NUMBER * i + $5942e8eb8ca60ef8$var$BASE_HEADER_LENGTH + j + 1];
                for(let j = 0; j < len; j++)points[j + 2] = points[j] + diffs[offset++];
            }
            return {
                areContours: areContours,
                thickness: thickness,
                outlines: outlines,
                width: width,
                height: height
            };
        } catch (e) {
            $5942e8eb8ca60ef8$var$warn(`decompressSignature: ${e}`);
            return null;
        }
    }
}
class $5942e8eb8ca60ef8$var$SignatureOptions extends $5942e8eb8ca60ef8$var$DrawingOptions {
    constructor(){
        super();
        super.updateProperties({
            fill: $5942e8eb8ca60ef8$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
    }
    clone() {
        const clone = new $5942e8eb8ca60ef8$var$SignatureOptions();
        clone.updateAll(this);
        return clone;
    }
}
class $5942e8eb8ca60ef8$var$DrawnSignatureOptions extends $5942e8eb8ca60ef8$var$InkDrawingOptions {
    constructor(viewerParameters){
        super(viewerParameters);
        super.updateProperties({
            stroke: $5942e8eb8ca60ef8$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
    }
    clone() {
        const clone = new $5942e8eb8ca60ef8$var$DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $5942e8eb8ca60ef8$var$SignatureEditor extends $5942e8eb8ca60ef8$var$DrawingEditor {
    #isExtracted = false;
    #description = null;
    #signatureData = null;
    #signatureUUID = null;
    static _type = "signature";
    static _editorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            mustBeCommitted: true,
            name: "signatureEditor"
        });
        this._willKeepAspectRatio = true;
        this.#signatureData = params.signatureData || null;
        this.#description = null;
        this.defaultL10nId = "pdfjs-editor-signature-editor1";
    }
    static initialize(l10n, uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $5942e8eb8ca60ef8$var$SignatureOptions();
        this._defaultDrawnSignatureOptions = new $5942e8eb8ca60ef8$var$DrawnSignatureOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static get typesMap() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "typesMap", new Map());
    }
    static get isDrawer() {
        return false;
    }
    get telemetryFinalData() {
        return {
            type: "signature",
            hasDescription: !!this.#description
        };
    }
    static computeTelemetryFinalData(data) {
        const hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: hasDescriptionStats.get(true) ?? 0,
            hasNoAltText: hasDescriptionStats.get(false) ?? 0
        };
    }
    get isResizable() {
        return true;
    }
    onScaleChanging() {
        if (this._drawId === null) return;
        super.onScaleChanging();
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        const { _isCopy: _isCopy } = this;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        if (this._drawId === null) {
            if (this.#signatureData) {
                const { lines: lines, mustSmooth: mustSmooth, areContours: areContours, description: description, uuid: uuid, heightInPage: heightInPage } = this.#signatureData;
                const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
                const outline = $5942e8eb8ca60ef8$export$cc4fe8633f466b4a.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: $5942e8eb8ca60ef8$var$SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            } else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        } else this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: this.#description || ""
        }));
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    }
    setUuid(uuid) {
        this.#signatureUUID = uuid;
        this.addEditToolbar();
    }
    getUuid() {
        return this.#signatureUUID;
    }
    get description() {
        return this.#description;
    }
    set description(description) {
        this.#description = description;
        if (!this.div) return;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        super.addEditToolbar().then((toolbar)=>{
            toolbar?.updateEditSignatureButton(description);
        });
    }
    getSignaturePreview() {
        const { newCurves: newCurves, areContours: areContours, thickness: thickness, width: width, height: height } = this.#signatureData;
        const maxDim = Math.max(width, height);
        const outlineData = $5942e8eb8ca60ef8$export$cc4fe8633f466b4a.processDrawnLines({
            lines: {
                curves: newCurves.map((points)=>({
                        points: points
                    })),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    }
    get toolbarButtons() {
        if (this._uiManager.signatureManager) return [
            [
                "editSignature",
                this._uiManager.signatureManager
            ]
        ];
        return super.toolbarButtons;
    }
    addSignature(data, heightInPage, description, uuid) {
        const { x: savedX, y: savedY } = this;
        const { outline: outline } = this.#signatureData = data;
        this.#isExtracted = outline instanceof $5942e8eb8ca60ef8$var$ContourDrawOutline;
        this.description = description;
        let drawingOptions;
        if (this.#isExtracted) drawingOptions = $5942e8eb8ca60ef8$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            drawingOptions = $5942e8eb8ca60ef8$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        const [, pageHeight] = this.pageDimensions;
        let newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims();
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    }
    getFromImage(bitmap) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $5942e8eb8ca60ef8$export$cc4fe8633f466b4a.process(bitmap, pageWidth, pageHeight, rotation, $5942e8eb8ca60ef8$var$SignatureEditor._INNER_MARGIN);
    }
    getFromText(text, fontInfo) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $5942e8eb8ca60ef8$export$cc4fe8633f466b4a.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, $5942e8eb8ca60ef8$var$SignatureEditor._INNER_MARGIN);
    }
    getDrawnSignature(curves) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $5942e8eb8ca60ef8$export$cc4fe8633f466b4a.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: $5942e8eb8ca60ef8$var$SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    }
    createDrawingOptions({ areContours: areContours, thickness: thickness }) {
        if (areContours) this._drawingOptions = $5942e8eb8ca60ef8$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            this._drawingOptions = $5942e8eb8ca60ef8$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            isSignature: true,
            areContours: this.#isExtracted,
            color: [
                0,
                0,
                0
            ],
            thickness: this.#isExtracted ? 0 : thickness
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = this.#signatureUUID;
            serialized.isCopy = true;
        } else serialized.lines = lines;
        if (this.#description) serialized.accessibilityData = {
            type: "Figure",
            alt: this.#description
        };
        return serialized;
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) return $5942e8eb8ca60ef8$var$ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        return $5942e8eb8ca60ef8$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#isExtracted = data.areContours;
        editor.description = data.accessibilityData?.alt || "";
        editor.#signatureUUID = data.uuid;
        return editor;
    }
}
class $5942e8eb8ca60ef8$var$StampEditor extends $5942e8eb8ca60ef8$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #missingCanvas = false;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
        this.defaultL10nId = "pdfjs-editor-stamp-editor";
    }
    static initialize(l10n, uiManager) {
        $5942e8eb8ca60ef8$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static isHandlingMimeForPasting(mime) {
        return $5942e8eb8ca60ef8$export$3234c88e9de64a88.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor({
            mode: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.STAMP
        }, {
            bitmapFile: item.getAsFile()
        });
    }
    altTextFinish() {
        if (this._uiManager.useNewAltTextFlow) this.div.hidden = false;
        super.altTextFinish();
    }
    get telemetryFinalData() {
        return {
            type: "stamp",
            hasAltText: !!this.altTextData?.altText
        };
    }
    static computeTelemetryFinalData(data) {
        const hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: hasAltTextStats.get(true) ?? 0,
            hasNoAltText: hasAltTextStats.get(false) ?? 0
        };
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (!this.#canvas) return;
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this.addEditToolbar().then(()=>{
                this._editToolbar.hide();
                this._uiManager.editAltText(this, true);
            });
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            } catch  {}
        }
        this.div.focus();
    }
    async mlGuessAltText(imageData = null, updateAltTextData = true) {
        if (this.hasAltTextData()) return null;
        const { mlManager: mlManager } = this._uiManager;
        if (!mlManager) throw new Error("No ML.");
        if (!await mlManager.isEnabledFor("altText")) throw new Error("ML isn't enabled for alt text.");
        const { data: data, width: width, height: height } = imageData || this.copyCanvas(null, null, true).imageData;
        const response = await mlManager.guess({
            name: "altText",
            request: {
                data: data,
                width: width,
                height: height,
                channels: data.length / (width * height)
            }
        });
        if (!response) throw new Error("No response from the AI service.");
        if (response.error) throw new Error("Error from the AI service.");
        if (response.cancel) return null;
        if (!response.output) throw new Error("No valid response from the AI service.");
        const altText = response.output;
        await this.setGuessedAltText(altText);
        if (updateAltTextData && !this.hasAltTextData()) this.altTextData = {
            alt: altText,
            decorative: false
        };
        return altText;
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $5942e8eb8ca60ef8$export$3234c88e9de64a88.join(",");
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this._reportTelemetry({
                        action: "pdfjs.image.image_selected",
                        data: {
                            alt_text_modal: this._uiManager.useNewAltTextFlow
                        }
                    });
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded(focus) {
        this._isDraggable = true;
        if (focus) this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId || this.#missingCanvas);
    }
    get toolbarButtons() {
        return [
            [
                "altText",
                this.createAltText()
            ]
        ];
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.createAltText();
        if (!this.#missingCanvas) {
            if (this.#bitmap) this.#createCanvas();
            else this.#getBitmap();
        }
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        this._uiManager.addShouldRescale(this);
        return this.div;
    }
    setCanvas(annotationElementId, canvas) {
        const { id: bitmapId, bitmap: bitmap } = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas);
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            this.#bitmapId = bitmapId;
            if (bitmap) this.#bitmap = bitmap;
            this.#missingCanvas = false;
            this.#createCanvas();
        }
    }
    _onResized() {
        this.onScaleChanging();
    }
    onScaleChanging() {
        if (!this.parent) return;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap();
        }, TIME_TO_WAIT);
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        this.setDims();
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) div.hidden = false;
        this.#drawBitmap();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) this.div.setAttribute("aria-description", this.#bitmapFileName);
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
    }
    copyCanvas(maxDataDimension, maxPreviewDimension, createImageData = false) {
        if (!maxDataDimension) maxDataDimension = 224;
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        const outputScale = new $5942e8eb8ca60ef8$export$f16a99f63bccd50b();
        let bitmap = this.#bitmap;
        let width = bitmapWidth, height = bitmapHeight;
        let canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                const ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            const scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            const scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!this.#isSvg) bitmap = this.#scaleBitmap(scaledWidth, scaledHeight);
            const ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            let white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") black = "black";
            else if ($5942e8eb8ca60ef8$var$ColorScheme.isDarkMode) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            const boxDim = 15;
            const boxDimWidth = boxDim * outputScale.sx;
            const boxDimHeight = boxDim * outputScale.sy;
            const pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            const patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        let imageData = null;
        if (createImageData) {
            let dataWidth, dataHeight;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            } else {
                bitmap = this.#bitmap;
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    const ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!this.#isSvg) bitmap = this.#scaleBitmap(dataWidth, dataHeight);
                }
            }
            const offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            const offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { width: width, height: height } = this;
        const outputScale = new $5942e8eb8ca60ef8$export$f16a99f63bccd50b();
        const scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        const scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) return;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(scaledWidth, scaledHeight);
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $5942e8eb8ca60ef8$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $5942e8eb8ca60ef8$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        let missingCanvas = false;
        if (data instanceof $5942e8eb8ca60ef8$var$StampAnnotationElement) {
            const { data: { rect: rect, rotation: rotation, id: id, structParent: structParent, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, container: container, parent: { page: { pageNumber: pageNumber } }, canvas: canvas } = data;
            let bitmapId, bitmap;
            if (canvas) {
                delete data.canvas;
                ({ id: bitmapId, bitmap: bitmap } = uiManager.imageManager.getFromCanvas(container.id, canvas));
                canvas.remove();
            } else {
                missingCanvas = true;
                data._hasNoCanvas = true;
            }
            const altText = (await parent._structTree.getAriaAttributes(`${$5942e8eb8ca60ef8$var$AnnotationPrefix}${id}`))?.get("aria-label") || "";
            initialData = data = {
                annotationType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.STAMP,
                bitmapId: bitmapId,
                bitmap: bitmap,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                accessibilityData: {
                    decorative: false,
                    altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmap: bitmap, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (missingCanvas) {
            uiManager.addMissingCanvas(data.id, editor);
            editor.#missingCanvas = true;
        } else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
            editor.#bitmapId = bitmapId;
            if (bitmap) editor.#bitmap = bitmap;
        } else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        editor.#hasBeenAddedInUndoStack = !!initialData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const serialized = Object.assign(super.serialize(isForCopying), {
            bitmapId: this.#bitmapId,
            isSvg: this.#isSvg
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.serializeAltText(false);
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (this.annotationElementId) {
            const changes = this.#hasElementChanged(serialized);
            if (changes.isSame) return null;
            if (changes.isSameAltText) delete serialized.accessibilityData;
            else serialized.accessibilityData.structParent = this._initialData.structParent ?? -1;
            serialized.id = this.annotationElementId;
            delete serialized.bitmapId;
            return serialized;
        }
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { pageIndex: pageIndex, accessibilityData: { altText: altText } } = this._initialData;
        const isSamePageIndex = serialized.pageIndex === pageIndex;
        const isSameAltText = (serialized.accessibilityData?.alt || "") === altText;
        return {
            isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
}
class $5942e8eb8ca60ef8$export$47948c9fe1adbf1b {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #clickAC = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isDisabling = false;
    #isEnabling = false;
    #drawingAC = null;
    #focusedElement = null;
    #textLayer = null;
    #textSelectionAC = null;
    #textLayerDblClickAC = null;
    #lastPointerDownTimestamp = -1;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $5942e8eb8ca60ef8$var$FreeTextEditor,
        $5942e8eb8ca60ef8$var$InkEditor,
        $5942e8eb8ca60ef8$var$StampEditor,
        $5942e8eb8ca60ef8$var$HighlightEditor,
        $5942e8eb8ca60ef8$var$SignatureEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, structTreeLayer: structTreeLayer, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$5942e8eb8ca60ef8$export$47948c9fe1adbf1b.#editorTypes.values()
        ];
        if (!$5942e8eb8ca60ef8$export$47948c9fe1adbf1b._initialized) {
            $5942e8eb8ca60ef8$export$47948c9fe1adbf1b._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE;
    }
    updateToolbar(options) {
        this.#uiManager.updateToolbar(options);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.NONE:
                this.div.classList.toggle("nonEditing", true);
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        classList.toggle("nonEditing", false);
        if (mode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.POPUP) classList.toggle("commentEditing", true);
        else {
            classList.toggle("commentEditing", false);
            for (const editorType of $5942e8eb8ca60ef8$export$47948c9fe1adbf1b.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        }
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    cleanUndoStack(type) {
        this.#uiManager.cleanUndoStack(type);
    }
    toggleDrawing(enabled = false) {
        this.div.classList.toggle("drawing", !enabled);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.div.classList.toggle("disabled", !enabled);
    }
    get #allEditorsIterator() {
        return this.#editors.size !== 0 ? this.#editors.values() : this.#uiManager.getEditors(this.pageIndex);
    }
    async enable() {
        this.#isEnabling = true;
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        this.div.classList.toggle("nonEditing", false);
        this.#textLayerDblClickAC?.abort();
        this.#textLayerDblClickAC = null;
        const annotationElementIds = new Set();
        for (const editor of this.#allEditorsIterator){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) for (const editable of annotationLayer.getEditableAnnotations()){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = await this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
        this.#isEnabling = false;
        this.#uiManager._eventBus.dispatch("editorsrendered", {
            source: this,
            pageNumber: this.pageIndex + 1
        });
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        this.div.classList.toggle("nonEditing", true);
        if (this.#textLayer && !this.#textLayerDblClickAC) {
            this.#textLayerDblClickAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textLayerDblClickAC);
            this.#textLayer.div.addEventListener("pointerdown", (e)=>{
                const DBL_CLICK_THRESHOLD = 500;
                const { clientX: clientX, clientY: clientY, timeStamp: timeStamp } = e;
                const lastPointerDownTimestamp = this.#lastPointerDownTimestamp;
                if (timeStamp - lastPointerDownTimestamp > DBL_CLICK_THRESHOLD) {
                    this.#lastPointerDownTimestamp = timeStamp;
                    return;
                }
                this.#lastPointerDownTimestamp = -1;
                const { classList: classList } = this.div;
                classList.toggle("getElements", true);
                const elements = document.elementsFromPoint(clientX, clientY);
                classList.toggle("getElements", false);
                if (!this.div.contains(elements[0])) return;
                let id;
                const regex = new RegExp(`^${$5942e8eb8ca60ef8$var$AnnotationEditorPrefix}[0-9]+$`);
                for (const element of elements)if (regex.test(element.id)) {
                    id = element.id;
                    break;
                }
                if (!id) return;
                const editor = this.#editors.get(id);
                if (editor?.annotationElementId === null) {
                    e.stopPropagation();
                    e.preventDefault();
                    editor.dblclick(e);
                }
            }, {
                signal: signal,
                capture: true
            });
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) {
            const changedAnnotations = new Map();
            const resetAnnotations = new Map();
            for (const editor of this.#allEditorsIterator){
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    editor.updateFakeAnnotationElement(annotationLayer);
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                } else resetAnnotations.set(editor.annotationElementId, editor);
                this.getEditableAnnotation(editor.annotationElementId)?.show();
                editor.remove();
            }
            const editables = annotationLayer.getEditableAnnotations();
            for (const editable of editables){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) {
                    editable.updateEdited({
                        deleted: true
                    });
                    continue;
                }
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    if (editor.renderAnnotationElement(editable)) editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $5942e8eb8ca60ef8$export$47948c9fe1adbf1b.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#textSelectionAC) {
            this.#textSelectionAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textSelectionAC);
            this.#textLayer.div.addEventListener("pointerdown", this.#textLayerPointerDown.bind(this), {
                signal: signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#textSelectionAC) {
            this.#textSelectionAC.abort();
            this.#textSelectionAC = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        const { target: target } = event;
        if (target === this.#textLayer.div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent")) && this.#textLayer.div.contains(target)) {
            const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            this.toggleDrawing();
            $5942e8eb8ca60ef8$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", {
                target: this.#textLayer.div,
                x: event.x,
                y: event.y
            });
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
                this.toggleDrawing(true);
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#clickAC) return;
        this.#clickAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#clickAC);
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        const pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    }
    disableClick() {
        this.#clickAC?.abort();
        this.#clickAC = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
            $5942e8eb8ca60ef8$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!this.#isEnabling);
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getEditorByUID(uid) {
        for (const editor of this.#editors.values()){
            if (editor.uid === uid) return editor;
        }
        return null;
    }
    getNextId() {
        return this.#uiManager.getId();
    }
    get #currentEditorType() {
        return $5942e8eb8ca60ef8$export$47948c9fe1adbf1b.#editorTypes.get(this.#uiManager.getMode());
    }
    combinedSignal(ac) {
        return this.#uiManager.combinedSignal(ac);
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    async pasteEditor(options, params) {
        this.updateToolbar(options);
        await this.#uiManager.updateMode(options.mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    async deserialize(data) {
        return await $5942e8eb8ca60ef8$export$47948c9fe1adbf1b.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    get boundingClientRect() {
        return this.div.getBoundingClientRect();
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.boundingClientRect;
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor(data = {}) {
        this.createAndAddNewEditor(this.#getCenterPoint(), true, data);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (this.#currentEditorType?.isDrawer && this.#currentEditorType.supportMultipleDrawings) return;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        const currentMode = this.#uiManager.getMode();
        if (currentMode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.STAMP || currentMode === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.SIGNATURE) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $5942e8eb8ca60ef8$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        if (this.#currentEditorType?.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    startDrawingSession(event) {
        this.div.focus({
            preventScroll: true
        });
        if (this.#drawingAC) {
            this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
            return;
        }
        this.#uiManager.setCurrentDrawingSession(this);
        this.#drawingAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#drawingAC);
        this.div.addEventListener("blur", ({ relatedTarget: relatedTarget })=>{
            if (relatedTarget && !this.div.contains(relatedTarget)) {
                this.#focusedElement = null;
                this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
    }
    pause(on) {
        if (on) {
            const { activeElement: activeElement } = document;
            if (this.div.contains(activeElement)) this.#focusedElement = activeElement;
            return;
        }
        if (this.#focusedElement) setTimeout(()=>{
            this.#focusedElement?.focus();
            this.#focusedElement = null;
        }, 0);
    }
    endDrawingSession(isAborted = false) {
        if (!this.#drawingAC) return null;
        this.#uiManager.setCurrentDrawingSession(null);
        this.#drawingAC.abort();
        this.#drawingAC = null;
        this.#focusedElement = null;
        return this.#currentEditorType.endDrawing(isAborted);
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    commitOrRemove() {
        if (this.#drawingAC) {
            this.endDrawingSession();
            return true;
        }
        return false;
    }
    onScaleChanging() {
        if (!this.#drawingAC) return;
        this.#currentEditorType.onScaleChangingWhenDrawing(this);
    }
    destroy() {
        this.commitOrRemove();
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
    }
    render({ viewport: viewport }) {
        this.viewport = viewport;
        $5942e8eb8ca60ef8$export$af0a15a86e590226(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $5942e8eb8ca60ef8$export$af0a15a86e590226(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
class $5942e8eb8ca60ef8$export$3eb4521511f02450 {
    #parent = null;
    #mapping = new Map();
    #toUpdate = new Map();
    static #id = 0;
    constructor({ pageIndex: pageIndex }){
        this.pageIndex = pageIndex;
    }
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static get _svgFactory() {
        return $5942e8eb8ca60ef8$export$b8972b998723d602(this, "_svgFactory", new $5942e8eb8ca60ef8$export$425e69f00724e63a());
    }
    static #setBox(element, [x, y, width, height]) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG() {
        const svg = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", true);
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    #updateProperties(element, properties) {
        for (const [key, value] of Object.entries(properties))if (value === null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
    draw(properties, isPathUpdatable = false, hasClip = false) {
        const id = $5942e8eb8ca60ef8$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = hasClip ? this.#createClipPath(defs, pathId) : null;
        const use = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", `#${pathId}`);
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    drawOutline(properties, mustRemoveSelfIntersections) {
        const id = $5942e8eb8ca60ef8$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (mustRemoveSelfIntersections) {
            const mask = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_p${this.pageIndex}_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $5942e8eb8ca60ef8$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return id;
    }
    finalizeDraw(id, properties) {
        this.#toUpdate.delete(id);
        this.updateProperties(id, properties);
    }
    updateProperties(elementOrId, properties) {
        if (!properties) return;
        const { root: root, bbox: bbox, rootClass: rootClass, path: path } = properties;
        const element = typeof elementOrId === "number" ? this.#mapping.get(elementOrId) : elementOrId;
        if (!element) return;
        if (root) this.#updateProperties(element, root);
        if (bbox) $5942e8eb8ca60ef8$export$3eb4521511f02450.#setBox(element, bbox);
        if (rootClass) {
            const { classList: classList } = element;
            for (const [className, value] of Object.entries(rootClass))classList.toggle(className, value);
        }
        if (path) {
            const defs = element.firstChild;
            const pathElement = defs.firstChild;
            this.#updateProperties(pathElement, path);
        }
    }
    updateParent(id, layer) {
        if (layer === this) return;
        const root = this.#mapping.get(id);
        if (!root) return;
        layer.#parent.append(root);
        this.#mapping.delete(id);
        layer.#mapping.set(id, root);
    }
    remove(id) {
        this.#toUpdate.delete(id);
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
        this.#toUpdate.clear();
    }
}
globalThis._pdfjsTestingUtils = {
    HighlightOutliner: $5942e8eb8ca60ef8$var$HighlightOutliner
};
globalThis.pdfjsLib = {
    AbortException: $5942e8eb8ca60ef8$export$d0e978393d193d1a,
    AnnotationEditorLayer: $5942e8eb8ca60ef8$export$47948c9fe1adbf1b,
    AnnotationEditorParamsType: $5942e8eb8ca60ef8$export$cf3df2a6ecc26692,
    AnnotationEditorType: $5942e8eb8ca60ef8$export$72ea3bfdd9a725bf,
    AnnotationEditorUIManager: $5942e8eb8ca60ef8$export$26cb16552a82cf63,
    AnnotationLayer: $5942e8eb8ca60ef8$export$3e7f45c326d9366c,
    AnnotationMode: $5942e8eb8ca60ef8$export$5a7af0c07e33392e,
    AnnotationType: $5942e8eb8ca60ef8$export$f50c3066a53a6f2c,
    applyOpacity: $5942e8eb8ca60ef8$export$f8d1472813e87bf9,
    build: $5942e8eb8ca60ef8$export$3f8fe6489e95757d,
    ColorPicker: $5942e8eb8ca60ef8$export$9feb1bc2e5f1ccb3,
    createValidAbsoluteUrl: $5942e8eb8ca60ef8$export$e076b47f5805ca0b,
    CSSConstants: $5942e8eb8ca60ef8$export$cec677744f6a5015,
    DOMSVGFactory: $5942e8eb8ca60ef8$export$425e69f00724e63a,
    DrawLayer: $5942e8eb8ca60ef8$export$3eb4521511f02450,
    FeatureTest: $5942e8eb8ca60ef8$export$5fb8891d35c36978,
    fetchData: $5942e8eb8ca60ef8$export$8134c072fddab6a5,
    findContrastColor: $5942e8eb8ca60ef8$export$7a96203b1fdebe8d,
    getDocument: $5942e8eb8ca60ef8$export$f65ca476c09acec0,
    getFilenameFromUrl: $5942e8eb8ca60ef8$export$b1c11df0696253ae,
    getPdfFilenameFromUrl: $5942e8eb8ca60ef8$export$9de51790aa4bc73a,
    getRGB: $5942e8eb8ca60ef8$export$2a2e9b507863ddda,
    getUuid: $5942e8eb8ca60ef8$export$75f13a91ebdf8eb3,
    getXfaPageViewport: $5942e8eb8ca60ef8$export$dd5d6edf3fc80aae,
    GlobalWorkerOptions: $5942e8eb8ca60ef8$export$edf38ba293eb934,
    ImageKind: $5942e8eb8ca60ef8$export$b890e9c15247e0b3,
    InvalidPDFException: $5942e8eb8ca60ef8$export$e3d0f4ce5b91e9f1,
    isDataScheme: $5942e8eb8ca60ef8$export$f67aae4532d8295b,
    isPdfFile: $5942e8eb8ca60ef8$export$61b52d3570d24719,
    isValidExplicitDest: $5942e8eb8ca60ef8$export$b5acece0a447dcdc,
    MathClamp: $5942e8eb8ca60ef8$export$b8106b171181a554,
    noContextMenu: $5942e8eb8ca60ef8$export$455b7811f904cadc,
    normalizeUnicode: $5942e8eb8ca60ef8$export$1fa1e6b1a06bd7fa,
    OPS: $5942e8eb8ca60ef8$export$3a0f7f7a8a0b306b,
    OutputScale: $5942e8eb8ca60ef8$export$f16a99f63bccd50b,
    PasswordResponses: $5942e8eb8ca60ef8$export$5e72215208e4d9ad,
    PDFDataRangeTransport: $5942e8eb8ca60ef8$export$c06899d9d7bce9ab,
    PDFDateString: $5942e8eb8ca60ef8$export$66cbc314498fffc,
    PDFWorker: $5942e8eb8ca60ef8$export$84e2e9f37426b265,
    PermissionFlag: $5942e8eb8ca60ef8$export$bb99a5b8411e07d8,
    PixelsPerInch: $5942e8eb8ca60ef8$export$6ef3b6b69e65342c,
    RenderingCancelledException: $5942e8eb8ca60ef8$export$245847d31c09154f,
    renderRichText: $5942e8eb8ca60ef8$export$611c480766035c4,
    ResponseException: $5942e8eb8ca60ef8$export$ea8e9c34f66e603,
    setLayerDimensions: $5942e8eb8ca60ef8$export$af0a15a86e590226,
    shadow: $5942e8eb8ca60ef8$export$b8972b998723d602,
    SignatureExtractor: $5942e8eb8ca60ef8$export$cc4fe8633f466b4a,
    stopEvent: $5942e8eb8ca60ef8$export$7ae4cd3a66c1e050,
    SupportedImageMimeTypes: $5942e8eb8ca60ef8$export$3234c88e9de64a88,
    TextLayer: $5942e8eb8ca60ef8$export$fdbdc423a78c5262,
    TouchManager: $5942e8eb8ca60ef8$export$9ae7542b430d543e,
    updateUrlHash: $5942e8eb8ca60ef8$export$e1e4297c21ab9d13,
    Util: $5942e8eb8ca60ef8$export$f8f26dd395d7e1bd,
    VerbosityLevel: $5942e8eb8ca60ef8$export$b18df09d23c244c4,
    version: $5942e8eb8ca60ef8$export$83d89fbfd8236492,
    XfaLayer: $5942e8eb8ca60ef8$export$f6af20c312d4b9a2
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("cFw5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9392340957048029$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $9392340957048029$var$documentContext = (0, $acw62.createContext)(null);
var $9392340957048029$export$2e2bcd8739ae039 = $9392340957048029$var$documentContext;

});

parcelRegister("5rpzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f634fa589229b85$export$2e2bcd8739ae039);
/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bv4qN = parcelRequire("bv4qN");
const $3f634fa589229b85$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
class $3f634fa589229b85$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHash() {
    // Intentionally empty
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $bv4qN.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $bv4qN.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        this.pdfViewer.currentPageNumber = value;
    }
    get rotation() {
        return 0;
    }
    set rotation(_value) {
    // Intentionally empty
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $3f634fa589229b85$var$DEFAULT_LINK_REL;
        link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $bv4qN.default)(this.pdfDocument, 'PDF document not loaded.');
            (0, $bv4qN.default)(dest, 'Destination is not specified.');
            if (typeof dest === 'string') this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $bv4qN.default)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $bv4qN.default)(this.pdfDocument, 'PDF document not loaded.');
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $bv4qN.default)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === 'number') resolve(destRef);
                else (0, $bv4qN.default)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $bv4qN.default)(this.pdfViewer, 'PDF viewer is not initialized.');
                (0, $bv4qN.default)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $bv4qN.default)(this.pdfViewer, 'PDF viewer is not initialized.');
        (0, $bv4qN.default)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    goToXY() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    getDestinationHash() {
        return '#';
    }
    getAnchorUrl() {
        return '#';
    }
    executeNamedAction() {
    // Intentionally empty
    }
    executeSetOCGState() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
}

});

parcelRegister("bC4Qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $874700aa52f70dcf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
function $874700aa52f70dcf$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, $ayMG0.jsx)("div", {
        className: `react-pdf__message react-pdf__message--${type}`,
        children: children
    });
}

});

parcelRegister("3YeDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4254877f0aa15f$export$2e2bcd8739ae039);
// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $2e4254877f0aa15f$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $2e4254877f0aa15f$export$2e2bcd8739ae039 = $2e4254877f0aa15f$var$PasswordResponses;

});

parcelRegister("j7H4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec0166c1c39245e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $dec0166c1c39245e$var$reducer(state, action) {
    switch(action.type){
        case 'RESOLVE':
            return {
                value: action.value,
                error: undefined
            };
        case 'REJECT':
            return {
                value: false,
                error: action.error
            };
        case 'RESET':
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $dec0166c1c39245e$export$2e2bcd8739ae039() {
    return (0, $acw62.useReducer)($dec0166c1c39245e$var$reducer, {
        value: undefined,
        error: undefined
    });
}

});

parcelRegister("oH8OY", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $04a3b4f6e6c7b06d$export$4e09c449d6c407f7);
$parcel$export(module.exports, "isProvided", () => $04a3b4f6e6c7b06d$export$ef8866826b0b1f6d);
$parcel$export(module.exports, "isArrayBuffer", () => $04a3b4f6e6c7b06d$export$9dd3754ae86f0017);
$parcel$export(module.exports, "isBlob", () => $04a3b4f6e6c7b06d$export$5bcd6e94ed871c88);
$parcel$export(module.exports, "isDataURI", () => $04a3b4f6e6c7b06d$export$4d82193ef6a8d75c);
$parcel$export(module.exports, "dataURItoByteString", () => $04a3b4f6e6c7b06d$export$c1553384119518c3);
$parcel$export(module.exports, "getDevicePixelRatio", () => $04a3b4f6e6c7b06d$export$cf4a949e5ad681d);
$parcel$export(module.exports, "displayCORSWarning", () => $04a3b4f6e6c7b06d$export$84884c3182d1bdda);
$parcel$export(module.exports, "cancelRunningTask", () => $04a3b4f6e6c7b06d$export$b8c3f1dffc289352);
$parcel$export(module.exports, "makePageCallback", () => $04a3b4f6e6c7b06d$export$8cc3f6b8d58bdda0);
$parcel$export(module.exports, "isAbortException", () => $04a3b4f6e6c7b06d$export$ed392050f3fc5849);
$parcel$export(module.exports, "loadFromFile", () => $04a3b4f6e6c7b06d$export$21fedb3a7a137f3d);

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");
const $04a3b4f6e6c7b06d$export$4e09c449d6c407f7 = typeof window !== 'undefined';
const $04a3b4f6e6c7b06d$export$d528e4159a0e221e = $04a3b4f6e6c7b06d$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $04a3b4f6e6c7b06d$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $04a3b4f6e6c7b06d$export$ef8866826b0b1f6d(variable) {
    return $04a3b4f6e6c7b06d$export$4e62c701997796c1(variable) && variable !== null;
}
function $04a3b4f6e6c7b06d$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $04a3b4f6e6c7b06d$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $04a3b4f6e6c7b06d$export$5bcd6e94ed871c88(variable) {
    (0, $bv4qN.default)($04a3b4f6e6c7b06d$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $04a3b4f6e6c7b06d$export$4d82193ef6a8d75c(variable) {
    return $04a3b4f6e6c7b06d$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $04a3b4f6e6c7b06d$export$c1553384119518c3(dataURI) {
    (0, $bv4qN.default)($04a3b4f6e6c7b06d$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    const [headersString = '', dataString = ''] = dataURI.split(',');
    const headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $04a3b4f6e6c7b06d$export$cf4a949e5ad681d() {
    return $04a3b4f6e6c7b06d$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $04a3b4f6e6c7b06d$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $04a3b4f6e6c7b06d$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!$04a3b4f6e6c7b06d$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$04a3b4f6e6c7b06d$var$allowFileAccessFromFilesTip}`);
}
function $04a3b4f6e6c7b06d$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(!$04a3b4f6e6c7b06d$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$04a3b4f6e6c7b06d$var$allowFileAccessFromFilesTip}`);
}
function $04a3b4f6e6c7b06d$export$b8c3f1dffc289352(runningTask) {
    if (runningTask === null || runningTask === void 0 ? void 0 : runningTask.cancel) runningTask.cancel();
}
function $04a3b4f6e6c7b06d$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get () {
            return this.getViewport({
                scale: scale
            }).width;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get () {
            return this.getViewport({
                scale: scale
            }).height;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get () {
            return this.getViewport({
                scale: 1
            }).width;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get () {
            return this.getViewport({
                scale: 1
            }).height;
        },
        configurable: true
    });
    return page;
}
function $04a3b4f6e6c7b06d$export$ed392050f3fc5849(error) {
    return error.name === 'AbortException' || error.name === 'RenderingCancelledException';
}
function $04a3b4f6e6c7b06d$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error('Error while reading a file.'));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error('Error while reading a file.'));
            const { error: error } = event.target;
            if (!error) return reject(new Error('Error while reading a file.'));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}

});


parcelRegister("hlSVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1f01cb0aad6788$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $e2Tlf = parcelRequire("e2Tlf");

var $hMZkZ = parcelRequire("hMZkZ");

var $gVmF6 = parcelRequire("gVmF6");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $bC4Qw = parcelRequire("bC4Qw");

var $9TMjk = parcelRequire("9TMjk");

var $9NK7U = parcelRequire("9NK7U");

var $4AYCf = parcelRequire("4AYCf");

var $4emzA = parcelRequire("4emzA");

var $elQGK = parcelRequire("elQGK");

var $j7H4Y = parcelRequire("j7H4Y");

var $oH8OY = parcelRequire("oH8OY");
'use client';
const $ca1f01cb0aad6788$var$defaultScale = 1;
function $ca1f01cb0aad6788$export$2e2bcd8739ae039(props) {
    const documentContext = (0, $elQGK.default)();
    const mergedProps = {
        ...documentContext,
        ...props
    };
    const { _className: _className = 'react-pdf__Page', _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = 'Failed to load the page.', filterAnnotations: filterAnnotations, height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = 'No page specified.', onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageColors: pageColors, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = 'canvas', renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $ca1f01cb0aad6788$var$defaultScale, unregisterPage: unregisterPage, width: width, ...otherProps } = mergedProps;
    const [pageState, pageDispatch] = (0, $j7H4Y.default)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $acw62.useRef)(null);
    (0, $bv4qN.default)(pdf, 'Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    const pageIndex = (0, $oH8OY.isProvided)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $oH8OY.isProvided)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $acw62.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $ca1f01cb0aad6788$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf change
    (0, $acw62.useEffect)(function hook() {
        return ()=>{
            if (!(0, $oH8OY.isProvided)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $oH8OY.makePageCallback)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $oH8OY.isProvided)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf and pageIndex change
    (0, $acw62.useEffect)(function resetPage() {
        pageDispatch({
            type: 'RESET'
        });
    }, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    (0, $acw62.useEffect)(function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $e2Tlf.default)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: 'RESOLVE',
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $oH8OY.cancelRunningTask)(runningTask);
    }, [
        pageDispatch,
        pdf,
        pageNumber
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        page,
        scale
    ]);
    const childContext = (0, $acw62.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        (0, $oH8OY.isProvided)(pageIndex) && pageNumber && (0, $oH8OY.isProvided)(rotate) && (0, $oH8OY.isProvided)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            filterAnnotations: filterAnnotations,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageColors: pageColors,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        filterAnnotations,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageColors,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $acw62.useMemo)(()=>(0, $hMZkZ.default)(otherProps, ()=>page ? scale ? (0, $oH8OY.makePageCallback)(page, scale) : undefined : page), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case 'custom':
                (0, $bv4qN.default)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, $ayMG0.jsx)(CustomRenderer, {}, `${pageKey}_custom`);
            case 'none':
                return null;
            case 'canvas':
            default:
                return (0, $ayMG0.jsx)((0, $9NK7U.default), {
                    canvasRef: canvasRef
                }, `${pageKey}_canvas`);
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, $ayMG0.jsx)((0, $4AYCf.default), {}, `${pageKey}_text`);
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        return (0, $ayMG0.jsx)((0, $9TMjk.default), {}, `${pageKey}_annotations`);
    }
    function renderChildren() {
        function isFulfilledContext(context) {
            return Boolean(context === null || context === void 0 ? void 0 : context.page);
        }
        if (!isFulfilledContext(childContext)) // Impossible, but TypeScript doesn't know that
        throw new Error('page is undefined');
        const resolvedChildren = typeof children === 'function' ? children(childContext) : children;
        return (0, $ayMG0.jsxs)((0, $4emzA.default).Provider, {
            value: childContext,
            children: [
                renderMainLayer(),
                renderTextLayer(),
                renderAnnotationLayer(),
                resolvedChildren
            ]
        });
    }
    function renderContent() {
        if (!pageNumber) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === null || page === undefined || page === null) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false || page === false) return (0, $ayMG0.jsx)((0, $bC4Qw.default), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(_className, className),
        "data-page-number": pageNumber,
        // Assertion is needed for React 18 compatibility
        ref: (0, $gVmF6.default)(inputRef, pageElement),
        style: {
            '--scale-round-x': '1px',
            '--scale-round-y': '1px',
            '--scale-factor': '1',
            '--user-unit': `${scale}`,
            '--total-scale-factor': 'calc(var(--scale-factor) * var(--user-unit))',
            backgroundColor: canvasBackground || 'white',
            position: 'relative',
            minWidth: 'min-content',
            minHeight: 'min-content'
        },
        ...eventProps,
        children: renderContent()
    });
}

});
parcelRegister("gVmF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5238c6191a6c066$export$2e2bcd8739ae039);
/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $c5238c6191a6c066$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        for(var _i = 0, filteredInputRefs_1 = filteredInputRefs; _i < filteredInputRefs_1.length; _i++){
            var inputRef = filteredInputRefs_1[_i];
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        }
    };
}

});

parcelRegister("9TMjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $734eb9a0d27595d6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $e2Tlf = parcelRequire("e2Tlf");

var $j1W2m = parcelRequire("j1W2m");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $elQGK = parcelRequire("elQGK");

var $1lT3D = parcelRequire("1lT3D");

var $j7H4Y = parcelRequire("j7H4Y");

var $oH8OY = parcelRequire("oH8OY");
'use client';
function $734eb9a0d27595d6$export$2e2bcd8739ae039() {
    const documentContext = (0, $elQGK.default)();
    const pageContext = (0, $1lT3D.default)();
    (0, $bv4qN.default)(pageContext, 'Unable to find Page context.');
    const mergedProps = {
        ...documentContext,
        ...pageContext
    };
    const { filterAnnotations: filterAnnotations, imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $bv4qN.default)(pdf, 'Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    (0, $bv4qN.default)(page, 'Attempted to load page annotations, but no page was specified.');
    (0, $bv4qN.default)(linkService, 'Attempted to load page annotations, but no linkService was specified.');
    const [annotationsState, annotationsDispatch] = (0, $j7H4Y.default)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-annotation-layer'), 10) === 1, 'AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations');
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $acw62.useEffect)(function resetAnnotations() {
        annotationsDispatch({
            type: 'RESET'
        });
    }, [
        annotationsDispatch,
        page
    ]);
    (0, $acw62.useEffect)(function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $e2Tlf.default)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: 'RESOLVE',
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $oH8OY.cancelRunningTask)(runningTask);
        };
    }, [
        annotationsDispatch,
        page
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $acw62.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(function renderAnnotationLayer() {
        if (!pdf || !page || !linkService || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            annotationEditorUIManager: null,
            annotationStorage: pdf.annotationStorage,
            commentManager: null,
            div: layer,
            l10n: null,
            linkService: linkService,
            page: page,
            structTreeLayer: null,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: filterAnnotations ? filterAnnotations({
                annotations: annotations
            }) : annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = '';
        try {
            new $j1W2m.AnnotationLayer(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }, [
        annotations,
        filterAnnotations,
        imageResourcesPath,
        linkService,
        page,
        pdf,
        renderForms,
        viewport
    ]);
    return (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('react-pdf__Page__annotations', 'annotationLayer'),
        ref: layerElement
    });
}

});
parcelRegister("elQGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72be5acb2417f39$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $cFw5p = parcelRequire("cFw5p");
function $a72be5acb2417f39$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)((0, $cFw5p.default));
}

});

parcelRegister("1lT3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc275ebc1544973$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $4emzA = parcelRequire("4emzA");
function $0fc275ebc1544973$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)((0, $4emzA.default));
}

});
parcelRegister("4emzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3149fac0e18b10c2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $3149fac0e18b10c2$var$pageContext = (0, $acw62.createContext)(null);
var $3149fac0e18b10c2$export$2e2bcd8739ae039 = $3149fac0e18b10c2$var$pageContext;

});



parcelRegister("9NK7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $722c786dee3836e7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gVmF6 = parcelRequire("gVmF6");

var $j1W2m = parcelRequire("j1W2m");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $7BIRy = parcelRequire("7BIRy");

var $1lT3D = parcelRequire("1lT3D");

var $oH8OY = parcelRequire("oH8OY");
'use client';
const $722c786dee3836e7$var$ANNOTATION_MODE = $j1W2m.AnnotationMode;
function $722c786dee3836e7$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $1lT3D.default)();
    (0, $bv4qN.default)(pageContext, 'Unable to find Page context.');
    const mergedProps = {
        ...pageContext,
        ...props
    };
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $oH8OY.getDevicePixelRatio)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, pageColors: pageColors, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $bv4qN.default)(page, 'Attempted to render page canvas, but no page was specified.');
    const canvasElement = (0, $acw62.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $oH8OY.makePageCallback)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $oH8OY.isAbortException)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $acw62.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $acw62.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = 'hidden';
        const renderContext = {
            annotationMode: renderForms ? $722c786dee3836e7$var$ANNOTATION_MODE.ENABLE_FORMS : $722c786dee3836e7$var$ANNOTATION_MODE.ENABLE,
            canvas: canvas,
            canvasContext: canvas.getContext('2d', {
                alpha: false
            }),
            pageColors: pageColors,
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = '';
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $oH8OY.cancelRunningTask)(runningTask);
    }, [
        canvasBackground,
        page,
        pageColors,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $acw62.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, []);
    (0, $acw62.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, $ayMG0.jsx)("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $gVmF6.default)(canvasRef, canvasElement),
        style: {
            display: 'block',
            userSelect: 'none'
        },
        children: renderTextLayer ? (0, $ayMG0.jsx)((0, $7BIRy.default), {}) : null
    });
}

});
parcelRegister("7BIRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $589ec9e53ead248d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $e2Tlf = parcelRequire("e2Tlf");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $d5es2 = parcelRequire("d5es2");

var $1lT3D = parcelRequire("1lT3D");

var $j7H4Y = parcelRequire("j7H4Y");

var $oH8OY = parcelRequire("oH8OY");
function $589ec9e53ead248d$export$2e2bcd8739ae039() {
    const pageContext = (0, $1lT3D.default)();
    (0, $bv4qN.default)(pageContext, 'Unable to find Page context.');
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $j7H4Y.default)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $acw62.useEffect)(function resetStructTree() {
        structTreeDispatch({
            type: 'RESET'
        });
    }, [
        structTreeDispatch,
        page
    ]);
    (0, $acw62.useEffect)(function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $e2Tlf.default)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: 'RESOLVE',
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $oH8OY.cancelRunningTask)(runningTask);
    }, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        structTree
    ]);
    if (!structTree) return null;
    return (0, $ayMG0.jsx)((0, $d5es2.default), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}

});
parcelRegister("d5es2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9866f3b781e7dca6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $e2Ojx = parcelRequire("e2Ojx");
function $9866f3b781e7dca6$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $acw62.useMemo)(()=>(0, $e2Ojx.getAttributes)(node), [
        node
    ]);
    const children = (0, $acw62.useMemo)(()=>{
        if (!(0, $e2Ojx.isStructTreeNode)(node)) return null;
        if ((0, $e2Ojx.isStructTreeNodeWithOnlyContentChild)(node)) return null;
        return node.children.map((child, index)=>{
            return (0, $ayMG0.jsx)($9866f3b781e7dca6$export$2e2bcd8739ae039, {
                node: child
            }, index);
        });
    }, [
        node
    ]);
    return (0, $ayMG0.jsx)("span", {
        className: className,
        ...attributes,
        children: children
    });
}

});
parcelRegister("e2Ojx", function(module, exports) {

$parcel$export(module.exports, "isStructTreeNode", () => $a39847f17cf9d6f4$export$9eeaf208d22fae4f);
$parcel$export(module.exports, "isStructTreeNodeWithOnlyContentChild", () => $a39847f17cf9d6f4$export$3b7840712ba182f3);
$parcel$export(module.exports, "getAttributes", () => $a39847f17cf9d6f4$export$fe94072fee8a6976);

var $lG7HJ = parcelRequire("lG7HJ");
function $a39847f17cf9d6f4$export$80a007e7cc9dad0d(role) {
    return role in (0, $lG7HJ.PDF_ROLE_TO_HTML_ROLE);
}
function $a39847f17cf9d6f4$export$9eeaf208d22fae4f(node) {
    return 'children' in node;
}
function $a39847f17cf9d6f4$export$3b7840712ba182f3(node) {
    if (!$a39847f17cf9d6f4$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && 'id' in node.children[0];
}
function $a39847f17cf9d6f4$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($a39847f17cf9d6f4$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $lG7HJ.HEADING_PATTERN));
        if (matches) {
            attributes.role = 'heading';
            attributes['aria-level'] = Number(matches[1]);
        } else if ($a39847f17cf9d6f4$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $lG7HJ.PDF_ROLE_TO_HTML_ROLE)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $a39847f17cf9d6f4$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($a39847f17cf9d6f4$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes['aria-label'] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($a39847f17cf9d6f4$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $a39847f17cf9d6f4$export$e86e6c9c68c5154c(child);
                return {
                    ...attributes,
                    ...childAttributes
                };
            }
        }
    } else if ('id' in node) attributes['aria-owns'] = node.id;
    return attributes;
}
function $a39847f17cf9d6f4$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return {
        ...$a39847f17cf9d6f4$export$aa440a09c67191c2(node),
        ...$a39847f17cf9d6f4$export$e86e6c9c68c5154c(node)
    };
}

});
parcelRegister("lG7HJ", function(module, exports) {

$parcel$export(module.exports, "PDF_ROLE_TO_HTML_ROLE", () => $fc837f215573515b$export$789cd800273ee71a);
$parcel$export(module.exports, "HEADING_PATTERN", () => $fc837f215573515b$export$4921bbe0701579e4);
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $fc837f215573515b$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: 'group',
    Sect: 'group',
    Div: 'group',
    Aside: 'note',
    NonStruct: 'none',
    // Block level structure types
    P: null,
    // H<n>,
    H: 'heading',
    Title: null,
    FENote: 'note',
    // Sub-block level structure type
    Sub: 'group',
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: 'link',
    Annot: 'note',
    Form: 'form',
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: 'list',
    LI: 'listitem',
    LBody: null,
    // Table standard structure types
    Table: 'table',
    TR: 'row',
    TH: 'columnheader',
    TD: 'cell',
    THead: 'columnheader',
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: 'figure',
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $fc837f215573515b$export$4921bbe0701579e4 = /^H(\d+)$/;

});





parcelRegister("4AYCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $35898b4acddcf672$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $e2Tlf = parcelRequire("e2Tlf");

var $j1W2m = parcelRequire("j1W2m");

var $bv4qN = parcelRequire("bv4qN");

var $kg9aN = parcelRequire("kg9aN");

var $1lT3D = parcelRequire("1lT3D");

var $j7H4Y = parcelRequire("j7H4Y");

var $oH8OY = parcelRequire("oH8OY");
'use client';
function $35898b4acddcf672$var$isTextItem(item) {
    return 'str' in item;
}
const $35898b4acddcf672$var$BLOCKED_CUSTOM_TEXT_TAGS = new Set([
    'base',
    'embed',
    'iframe',
    'link',
    'meta',
    'object',
    'script',
    'style',
    'template'
]);
const $35898b4acddcf672$var$URL_ATTRIBUTES = new Set([
    'action',
    'formaction',
    'href',
    'poster',
    'src',
    'xlink:href'
]);
function $35898b4acddcf672$var$isDangerousUrl(value) {
    let normalizedValue = '';
    for (const char of value){
        const charCode = char.charCodeAt(0);
        if (charCode <= 32 || charCode === 127) continue;
        normalizedValue += char.toLowerCase();
    }
    return normalizedValue.startsWith('data:') || normalizedValue.startsWith('javascript:') || normalizedValue.startsWith('vbscript:');
}
function $35898b4acddcf672$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $35898b4acddcf672$var$isHtmlElement(node) {
    return $35898b4acddcf672$var$isElementNode(node) && node instanceof HTMLElement;
}
function $35898b4acddcf672$var$isBlockedCustomTextElement(node) {
    return $35898b4acddcf672$var$isHtmlElement(node) && $35898b4acddcf672$var$BLOCKED_CUSTOM_TEXT_TAGS.has(node.tagName.toLowerCase());
}
function $35898b4acddcf672$var$sanitizeCustomHtmlElement(element) {
    const sanitizedElement = document.createElement(element.tagName.toLowerCase());
    Array.from(element.attributes).forEach((attribute)=>{
        const attributeName = attribute.name.toLowerCase();
        if (attributeName.startsWith('on') || attributeName === 'srcdoc') return;
        if ($35898b4acddcf672$var$URL_ATTRIBUTES.has(attributeName) && $35898b4acddcf672$var$isDangerousUrl(attribute.value)) return;
        sanitizedElement.setAttribute(attribute.name, attribute.value);
    });
    Array.from(element.childNodes).forEach((child)=>{
        sanitizedElement.append($35898b4acddcf672$var$sanitizeCustomTextNode(child));
    });
    return sanitizedElement;
}
function $35898b4acddcf672$var$sanitizeCustomTextNode(node) {
    var _a;
    if ($35898b4acddcf672$var$isHtmlElement(node) && !$35898b4acddcf672$var$isBlockedCustomTextElement(node)) return $35898b4acddcf672$var$sanitizeCustomHtmlElement(node);
    return document.createTextNode((_a = node.textContent) !== null && _a !== void 0 ? _a : '');
}
function $35898b4acddcf672$var$renderSafeCustomText(target, content) {
    const template = document.createElement('template');
    template.innerHTML = content;
    const sanitizedFragment = document.createDocumentFragment();
    Array.from(template.content.childNodes).forEach((child)=>{
        sanitizedFragment.append($35898b4acddcf672$var$sanitizeCustomTextNode(child));
    });
    target.replaceChildren(sanitizedFragment);
}
function $35898b4acddcf672$export$2e2bcd8739ae039() {
    const pageContext = (0, $1lT3D.default)();
    (0, $bv4qN.default)(pageContext, 'Unable to find Page context.');
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $bv4qN.default)(page, 'Attempted to load page text content, but no page was specified.');
    const [textContentState, textContentDispatch] = (0, $j7H4Y.default)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-text-layer'), 10) === 1, 'TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer');
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $acw62.useEffect)(function resetTextContent() {
        textContentDispatch({
            type: 'RESET'
        });
    }, [
        page,
        textContentDispatch
    ]);
    (0, $acw62.useEffect)(function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $e2Tlf.default)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: 'RESOLVE',
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $oH8OY.cancelRunningTask)(runningTask);
    }, [
        page,
        textContentDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Omitted callbacks so they are not called every time they change
    (0, $acw62.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $acw62.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $acw62.useCallback)((error)=>{
        if ((0, $oH8OY.isAbortException)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const layer = layerElement.current;
        if (!layer) return;
        layer.classList.add('selecting');
    }
    function onMouseUp() {
        const layer = layerElement.current;
        if (!layer) return;
        layer.classList.remove('selecting');
    }
    const viewport = (0, $acw62.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    (0, $acw62.useLayoutEffect)(function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = '';
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = new $j1W2m.TextLayer(parameters);
        const runningTask = cancellable;
        cancellable.render().then(()=>{
            const end = document.createElement('div');
            end.className = 'endOfContent';
            layer.append(end);
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$35898b4acddcf672$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex,
                        ...item
                    });
                    $35898b4acddcf672$var$renderSafeCustomText(child, content);
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $oH8OY.cancelRunningTask)(runningTask);
    }, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)('react-pdf__Page__textContent', 'textLayer'),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    });
}

});


parcelRegister("kugBo", function(module, exports) {

$parcel$export(module.exports, "useResizeDetector", () => $eea37cd791c1b1c3$export$453c3d1cba18d800);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/* global Reflect, Promise */ var $eea37cd791c1b1c3$var$extendStatics = function(d, b) {
    $eea37cd791c1b1c3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $eea37cd791c1b1c3$var$extendStatics(d, b);
};
function $eea37cd791c1b1c3$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $eea37cd791c1b1c3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $eea37cd791c1b1c3$var$__assign = function() {
    $eea37cd791c1b1c3$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eea37cd791c1b1c3$var$__assign.apply(this, arguments);
};
function $eea37cd791c1b1c3$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $eea37cd791c1b1c3$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {}; /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
function $eea37cd791c1b1c3$var$isObject$3(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $eea37cd791c1b1c3$var$isObject_1 = $eea37cd791c1b1c3$var$isObject$3; /** Detect free variable `global` from Node.js. */ 
var $eea37cd791c1b1c3$var$freeGlobal$1 = typeof $eea37cd791c1b1c3$var$commonjsGlobal == 'object' && $eea37cd791c1b1c3$var$commonjsGlobal && $eea37cd791c1b1c3$var$commonjsGlobal.Object === Object && $eea37cd791c1b1c3$var$commonjsGlobal;
var $eea37cd791c1b1c3$var$_freeGlobal = $eea37cd791c1b1c3$var$freeGlobal$1;
var $eea37cd791c1b1c3$var$freeGlobal = $eea37cd791c1b1c3$var$_freeGlobal;
/** Detect free variable `self`. */ var $eea37cd791c1b1c3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $eea37cd791c1b1c3$var$root$2 = $eea37cd791c1b1c3$var$freeGlobal || $eea37cd791c1b1c3$var$freeSelf || Function('return this')();
var $eea37cd791c1b1c3$var$_root = $eea37cd791c1b1c3$var$root$2;
var $eea37cd791c1b1c3$var$root$1 = $eea37cd791c1b1c3$var$_root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $eea37cd791c1b1c3$var$now$1 = function() {
    return $eea37cd791c1b1c3$var$root$1.Date.now();
};
var $eea37cd791c1b1c3$var$now_1 = $eea37cd791c1b1c3$var$now$1; /** Used to match a single whitespace character. */ 
var $eea37cd791c1b1c3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $eea37cd791c1b1c3$var$trimmedEndIndex$1(string) {
    var index = string.length;
    while(index-- && $eea37cd791c1b1c3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $eea37cd791c1b1c3$var$_trimmedEndIndex = $eea37cd791c1b1c3$var$trimmedEndIndex$1;
var $eea37cd791c1b1c3$var$trimmedEndIndex = $eea37cd791c1b1c3$var$_trimmedEndIndex;
/** Used to match leading whitespace. */ var $eea37cd791c1b1c3$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $eea37cd791c1b1c3$var$baseTrim$1(string) {
    return string ? string.slice(0, $eea37cd791c1b1c3$var$trimmedEndIndex(string) + 1).replace($eea37cd791c1b1c3$var$reTrimStart, '') : string;
}
var $eea37cd791c1b1c3$var$_baseTrim = $eea37cd791c1b1c3$var$baseTrim$1;
var $eea37cd791c1b1c3$var$root = $eea37cd791c1b1c3$var$_root;
/** Built-in value references. */ var $eea37cd791c1b1c3$var$Symbol$2 = $eea37cd791c1b1c3$var$root.Symbol;
var $eea37cd791c1b1c3$var$_Symbol = $eea37cd791c1b1c3$var$Symbol$2;
var $eea37cd791c1b1c3$var$Symbol$1 = $eea37cd791c1b1c3$var$_Symbol;
/** Used for built-in method references. */ var $eea37cd791c1b1c3$var$objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var $eea37cd791c1b1c3$var$hasOwnProperty = $eea37cd791c1b1c3$var$objectProto$1.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $eea37cd791c1b1c3$var$nativeObjectToString$1 = $eea37cd791c1b1c3$var$objectProto$1.toString;
/** Built-in value references. */ var $eea37cd791c1b1c3$var$symToStringTag$1 = $eea37cd791c1b1c3$var$Symbol$1 ? $eea37cd791c1b1c3$var$Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $eea37cd791c1b1c3$var$getRawTag$1(value) {
    var isOwn = $eea37cd791c1b1c3$var$hasOwnProperty.call(value, $eea37cd791c1b1c3$var$symToStringTag$1), tag = value[$eea37cd791c1b1c3$var$symToStringTag$1];
    try {
        value[$eea37cd791c1b1c3$var$symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $eea37cd791c1b1c3$var$nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[$eea37cd791c1b1c3$var$symToStringTag$1] = tag;
        else delete value[$eea37cd791c1b1c3$var$symToStringTag$1];
    }
    return result;
}
var $eea37cd791c1b1c3$var$_getRawTag = $eea37cd791c1b1c3$var$getRawTag$1; /** Used for built-in method references. */ 
var $eea37cd791c1b1c3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $eea37cd791c1b1c3$var$nativeObjectToString = $eea37cd791c1b1c3$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $eea37cd791c1b1c3$var$objectToString$1(value) {
    return $eea37cd791c1b1c3$var$nativeObjectToString.call(value);
}
var $eea37cd791c1b1c3$var$_objectToString = $eea37cd791c1b1c3$var$objectToString$1;
var $eea37cd791c1b1c3$var$Symbol = $eea37cd791c1b1c3$var$_Symbol, $eea37cd791c1b1c3$var$getRawTag = $eea37cd791c1b1c3$var$_getRawTag, $eea37cd791c1b1c3$var$objectToString = $eea37cd791c1b1c3$var$_objectToString;
/** `Object#toString` result references. */ var $eea37cd791c1b1c3$var$nullTag = '[object Null]', $eea37cd791c1b1c3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $eea37cd791c1b1c3$var$symToStringTag = $eea37cd791c1b1c3$var$Symbol ? $eea37cd791c1b1c3$var$Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $eea37cd791c1b1c3$var$baseGetTag$1(value) {
    if (value == null) return value === undefined ? $eea37cd791c1b1c3$var$undefinedTag : $eea37cd791c1b1c3$var$nullTag;
    return $eea37cd791c1b1c3$var$symToStringTag && $eea37cd791c1b1c3$var$symToStringTag in Object(value) ? $eea37cd791c1b1c3$var$getRawTag(value) : $eea37cd791c1b1c3$var$objectToString(value);
}
var $eea37cd791c1b1c3$var$_baseGetTag = $eea37cd791c1b1c3$var$baseGetTag$1; /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
function $eea37cd791c1b1c3$var$isObjectLike$1(value) {
    return value != null && typeof value == 'object';
}
var $eea37cd791c1b1c3$var$isObjectLike_1 = $eea37cd791c1b1c3$var$isObjectLike$1;
var $eea37cd791c1b1c3$var$baseGetTag = $eea37cd791c1b1c3$var$_baseGetTag, $eea37cd791c1b1c3$var$isObjectLike = $eea37cd791c1b1c3$var$isObjectLike_1;
/** `Object#toString` result references. */ var $eea37cd791c1b1c3$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $eea37cd791c1b1c3$var$isSymbol$1(value) {
    return typeof value == 'symbol' || $eea37cd791c1b1c3$var$isObjectLike(value) && $eea37cd791c1b1c3$var$baseGetTag(value) == $eea37cd791c1b1c3$var$symbolTag;
}
var $eea37cd791c1b1c3$var$isSymbol_1 = $eea37cd791c1b1c3$var$isSymbol$1;
var $eea37cd791c1b1c3$var$baseTrim = $eea37cd791c1b1c3$var$_baseTrim, $eea37cd791c1b1c3$var$isObject$2 = $eea37cd791c1b1c3$var$isObject_1, $eea37cd791c1b1c3$var$isSymbol = $eea37cd791c1b1c3$var$isSymbol_1;
/** Used as references for various `Number` constants. */ var $eea37cd791c1b1c3$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $eea37cd791c1b1c3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $eea37cd791c1b1c3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $eea37cd791c1b1c3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $eea37cd791c1b1c3$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $eea37cd791c1b1c3$var$toNumber$1(value) {
    if (typeof value == 'number') return value;
    if ($eea37cd791c1b1c3$var$isSymbol(value)) return $eea37cd791c1b1c3$var$NAN;
    if ($eea37cd791c1b1c3$var$isObject$2(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $eea37cd791c1b1c3$var$isObject$2(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $eea37cd791c1b1c3$var$baseTrim(value);
    var isBinary = $eea37cd791c1b1c3$var$reIsBinary.test(value);
    return isBinary || $eea37cd791c1b1c3$var$reIsOctal.test(value) ? $eea37cd791c1b1c3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $eea37cd791c1b1c3$var$reIsBadHex.test(value) ? $eea37cd791c1b1c3$var$NAN : +value;
}
var $eea37cd791c1b1c3$var$toNumber_1 = $eea37cd791c1b1c3$var$toNumber$1;
var $eea37cd791c1b1c3$var$isObject$1 = $eea37cd791c1b1c3$var$isObject_1, $eea37cd791c1b1c3$var$now = $eea37cd791c1b1c3$var$now_1, $eea37cd791c1b1c3$var$toNumber = $eea37cd791c1b1c3$var$toNumber_1;
/** Error message constants. */ var $eea37cd791c1b1c3$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $eea37cd791c1b1c3$var$nativeMax = Math.max, $eea37cd791c1b1c3$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $eea37cd791c1b1c3$var$debounce$1(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($eea37cd791c1b1c3$var$FUNC_ERROR_TEXT$1);
    wait = $eea37cd791c1b1c3$var$toNumber(wait) || 0;
    if ($eea37cd791c1b1c3$var$isObject$1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $eea37cd791c1b1c3$var$nativeMax($eea37cd791c1b1c3$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $eea37cd791c1b1c3$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $eea37cd791c1b1c3$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($eea37cd791c1b1c3$var$now());
    }
    function debounced() {
        var time = $eea37cd791c1b1c3$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $eea37cd791c1b1c3$var$debounce_1 = $eea37cd791c1b1c3$var$debounce$1;
var $eea37cd791c1b1c3$var$debounce = $eea37cd791c1b1c3$var$debounce_1, $eea37cd791c1b1c3$var$isObject = $eea37cd791c1b1c3$var$isObject_1;
/** Error message constants. */ var $eea37cd791c1b1c3$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $eea37cd791c1b1c3$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($eea37cd791c1b1c3$var$FUNC_ERROR_TEXT);
    if ($eea37cd791c1b1c3$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $eea37cd791c1b1c3$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $eea37cd791c1b1c3$var$throttle_1 = $eea37cd791c1b1c3$var$throttle;
var $eea37cd791c1b1c3$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case 'debounce':
            return $eea37cd791c1b1c3$var$debounce_1(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return $eea37cd791c1b1c3$var$throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $eea37cd791c1b1c3$var$isFunction = function(fn) {
    return typeof fn === 'function';
};
var $eea37cd791c1b1c3$var$isSSR = function() {
    return typeof window === 'undefined';
};
var $eea37cd791c1b1c3$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $eea37cd791c1b1c3$var$createNotifier = function(onResize, setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            if (onResize && $eea37cd791c1b1c3$var$isFunction(onResize)) onResize(width, height);
            return {
                width: width,
                height: height
            };
        });
    };
};
var $eea37cd791c1b1c3$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $eea37cd791c1b1c3$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($eea37cd791c1b1c3$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($eea37cd791c1b1c3$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $eea37cd791c1b1c3$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $eea37cd791c1b1c3$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $1u0KT.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $eea37cd791c1b1c3$var$createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$eea37cd791c1b1c3$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($eea37cd791c1b1c3$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return 'renderProp';
            if ($eea37cd791c1b1c3$var$isFunction(children)) return 'childFunction';
            if ((0, $acw62.isValidElement)(children)) return 'child';
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return 'childArray';
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $acw62.createRef)();
        _this.observableElement = null;
        if ($eea37cd791c1b1c3$var$isSSR()) return _this;
        _this.resizeHandler = $eea37cd791c1b1c3$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($eea37cd791c1b1c3$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        var typedChildren;
        switch(renderType){
            case 'renderProp':
                return render && render(childProps);
            case 'childFunction':
                typedChildren = children;
                return typedChildren(childProps);
            case 'child':
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef;
                    var nativeProps = $eea37cd791c1b1c3$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $acw62.cloneElement)(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return (0, $acw62.cloneElement)(typedChildren, childProps);
            case 'childArray':
                typedChildren = children;
                return typedChildren.map(function(el) {
                    return !!el && (0, $acw62.cloneElement)(el, childProps);
                });
            default:
                return $acw62.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $acw62.PureComponent));
function $eea37cd791c1b1c3$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $eea37cd791c1b1c3$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $acw62.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $eea37cd791c1b1c3$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return $acw62.createElement($eea37cd791c1b1c3$export$2e2bcd8739ae039, $eea37cd791c1b1c3$var$__assign({}, options, {
                targetRef: targetRef
            }), $acw62.createElement(ComponentInner, $eea37cd791c1b1c3$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $acw62.Component));
    function forwardRefWrapper(props, ref) {
        return $acw62.createElement(ResizeDetectorHOC, $eea37cd791c1b1c3$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $acw62.forwardRef)(forwardRefWrapper);
}
var $eea37cd791c1b1c3$var$useEnhancedEffect = $eea37cd791c1b1c3$var$isSSR() ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
function $eea37cd791c1b1c3$export$453c3d1cba18d800(props) {
    if (props === void 0) props = {};
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = (0, $acw62.useRef)(skipOnMount);
    var localRef = (0, $acw62.useRef)(null);
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var resizeHandler = (0, $acw62.useRef)();
    var _e = (0, $acw62.useState)({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    $eea37cd791c1b1c3$var$useEnhancedEffect(function() {
        if ($eea37cd791c1b1c3$var$isSSR()) return;
        var notifyResize = $eea37cd791c1b1c3$var$createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !$eea37cd791c1b1c3$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $eea37cd791c1b1c3$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) // Something wrong with typings here...
        resizeObserver.observe(ref.current, observerOptions);
        return function() {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) patchedResizeHandler.cancel();
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        onResize,
        observerOptions,
        ref.current
    ]);
    return $eea37cd791c1b1c3$var$__assign({
        ref: ref
    }, size);
}

});

parcelRegister("aaRo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4554d646a17cef3a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");

var $1cKF4 = parcelRequire("1cKF4");
const $4554d646a17cef3a$var$Slider = ({ value: value, onChange: onChange, min: min = 0, max: max = 100 })=>{
    const renderTrack = (trackProps, state)=>{
        const { key: key, ...restProps } = trackProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...restProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("h-1", "rounded-full", {
                "bg-white": state.index == 1,
                "bg-ch-blue-500": state.index == 0
            })
        }, key);
    };
    const renderThumb = (thumbProps)=>{
        const { key: key, ...restProps } = thumbProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...restProps,
            className: "w-6 h-6 rounded-full bg-white cursor-pointer outline-none focus:bg-ch-blue-400"
        }, key);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "slider w-full py-2 px-3 bg-ch-gray-600 rounded-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1cKF4))), {
            className: "slider w-full h-6 overflow-hidden flex items-center",
            renderTrack: renderTrack,
            renderThumb: renderThumb,
            value: value,
            onChange: (val)=>onChange(val),
            max: max,
            min: min
        })
    });
};
var $4554d646a17cef3a$export$2e2bcd8739ae039 = $4554d646a17cef3a$var$Slider;

});
parcelRegister("1cKF4", function(module, exports) {

module.exports = (parcelRequire("bj1uL"));

});
parcelRegister("bj1uL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $jbp7R = parcelRequire("jbp7R");
module.exports.default = $jbp7R.default;

});
parcelRegister("jbp7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $6r4zt = parcelRequire("6r4zt");

var $acw62 = parcelRequire("acw62");
function $df7288dd743e035f$var$s(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $df7288dd743e035f$var$n = $df7288dd743e035f$var$s($6r4zt), $df7288dd743e035f$var$i = $df7288dd743e035f$var$s($acw62);
function $df7288dd743e035f$var$o(e) {
    return e && e.stopPropagation && e.stopPropagation(), e && e.preventDefault && e.preventDefault(), !1;
}
function $df7288dd743e035f$var$r(e) {
    return null == e ? [] : Array.isArray(e) ? e.slice() : [
        e
    ];
}
function $df7288dd743e035f$var$a(e) {
    return null !== e && 1 === e.length ? e[0] : e.slice();
}
function $df7288dd743e035f$var$p(e) {
    Object.keys(e).forEach((t)=>{
        "undefined" != typeof document && document.addEventListener(t, e[t], !1);
    });
}
function $df7288dd743e035f$var$u(e, t) {
    return $df7288dd743e035f$var$l(function(e, t) {
        let s = e;
        s <= t.min && (s = t.min);
        s >= t.max && (s = t.max);
        return s;
    }(e, t), t);
}
function $df7288dd743e035f$var$l(e, t) {
    const s = (e - t.min) % t.step;
    let n = e - s;
    return 2 * Math.abs(s) >= t.step && (n += s > 0 ? t.step : -t.step), parseFloat(n.toFixed(5));
}
let $df7288dd743e035f$var$h = function(e) {
    function t(t) {
        var s;
        (s = e.call(this, t) || this).onKeyUp = ()=>{
            s.onEnd();
        }, s.onMouseUp = ()=>{
            s.onEnd(s.getMouseEventMap());
        }, s.onTouchEnd = (e)=>{
            e.preventDefault(), s.onEnd(s.getTouchEventMap());
        }, s.onBlur = ()=>{
            s.setState({
                index: -1
            }, s.onEnd(s.getKeyDownEventMap()));
        }, s.onMouseMove = (e)=>{
            s.setState({
                pending: !0
            });
            const t = s.getMousePosition(e), n = s.getDiffPosition(t[0]), i = s.getValueFromPosition(n);
            s.move(i);
        }, s.onTouchMove = (e)=>{
            if (e.touches.length > 1) return;
            s.setState({
                pending: !0
            });
            const t = s.getTouchPosition(e);
            if (void 0 === s.isScrolling) {
                const e = t[0] - s.startPosition[0], n = t[1] - s.startPosition[1];
                s.isScrolling = Math.abs(n) > Math.abs(e);
            }
            if (s.isScrolling) return void s.setState({
                index: -1
            });
            const n = s.getDiffPosition(t[0]), i = s.getValueFromPosition(n);
            s.move(i);
        }, s.onKeyDown = (e)=>{
            if (!(e.ctrlKey || e.shiftKey || e.altKey || e.metaKey)) switch(s.setState({
                pending: !0
            }), e.key){
                case "ArrowLeft":
                case "ArrowDown":
                case "Left":
                case "Down":
                    e.preventDefault(), s.moveDownByStep();
                    break;
                case "ArrowRight":
                case "ArrowUp":
                case "Right":
                case "Up":
                    e.preventDefault(), s.moveUpByStep();
                    break;
                case "Home":
                    e.preventDefault(), s.move(s.props.min);
                    break;
                case "End":
                    e.preventDefault(), s.move(s.props.max);
                    break;
                case "PageDown":
                    e.preventDefault(), s.moveDownByStep(s.props.pageFn(s.props.step));
                    break;
                case "PageUp":
                    e.preventDefault(), s.moveUpByStep(s.props.pageFn(s.props.step));
            }
        }, s.onSliderMouseDown = (e)=>{
            if (!s.props.disabled && 2 !== e.button) {
                if (s.setState({
                    pending: !0
                }), !s.props.snapDragDisabled) {
                    const t = s.getMousePosition(e);
                    s.forceValueFromPosition(t[0], (e)=>{
                        s.start(e, t[0]), $df7288dd743e035f$var$p(s.getMouseEventMap());
                    });
                }
                $df7288dd743e035f$var$o(e);
            }
        }, s.onSliderClick = (e)=>{
            if (!s.props.disabled && s.props.onSliderClick && !s.hasMoved) {
                const t = s.getMousePosition(e), n = $df7288dd743e035f$var$u(s.calcValue(s.calcOffsetFromPosition(t[0])), s.props);
                s.props.onSliderClick(n);
            }
        }, s.createOnKeyDown = (e)=>(t)=>{
                s.props.disabled || (s.start(e), $df7288dd743e035f$var$p(s.getKeyDownEventMap()), $df7288dd743e035f$var$o(t));
            }, s.createOnMouseDown = (e)=>(t)=>{
                if (s.props.disabled || 2 === t.button) return;
                s.setState({
                    pending: !0
                });
                const n = s.getMousePosition(t);
                s.start(e, n[0]), $df7288dd743e035f$var$p(s.getMouseEventMap()), $df7288dd743e035f$var$o(t);
            }, s.createOnTouchStart = (e)=>(t)=>{
                if (s.props.disabled || t.touches.length > 1) return;
                s.setState({
                    pending: !0
                });
                const n = s.getTouchPosition(t);
                s.startPosition = n, s.isScrolling = void 0, s.start(e, n[0]), $df7288dd743e035f$var$p(s.getTouchEventMap()), function(e) {
                    e.stopPropagation && e.stopPropagation();
                }(t);
            }, s.handleResize = ()=>{
            const e = window.setTimeout(()=>{
                s.pendingResizeTimeouts.shift(), s.resize();
            }, 0);
            s.pendingResizeTimeouts.push(e);
        }, s.renderThumb = (e, t)=>{
            const n = s.props.thumbClassName + " " + s.props.thumbClassName + "-" + t + " " + (s.state.index === t ? s.props.thumbActiveClassName : ""), i = {
                ref: (e)=>{
                    s["thumb" + t] = e;
                },
                key: s.props.thumbClassName + "-" + t,
                className: n,
                style: e,
                onMouseDown: s.createOnMouseDown(t),
                onTouchStart: s.createOnTouchStart(t),
                onFocus: s.createOnKeyDown(t),
                tabIndex: 0,
                role: "slider",
                "aria-orientation": s.props.orientation,
                "aria-valuenow": s.state.value[t],
                "aria-valuemin": s.props.min,
                "aria-valuemax": s.props.max,
                "aria-label": Array.isArray(s.props.ariaLabel) ? s.props.ariaLabel[t] : s.props.ariaLabel,
                "aria-labelledby": Array.isArray(s.props.ariaLabelledby) ? s.props.ariaLabelledby[t] : s.props.ariaLabelledby,
                "aria-disabled": s.props.disabled
            }, o = {
                index: t,
                value: $df7288dd743e035f$var$a(s.state.value),
                valueNow: s.state.value[t]
            };
            return s.props.ariaValuetext && (i["aria-valuetext"] = "string" == typeof s.props.ariaValuetext ? s.props.ariaValuetext : s.props.ariaValuetext(o)), s.props.renderThumb(i, o);
        }, s.renderTrack = (e, t, n)=>{
            const i = {
                key: s.props.trackClassName + "-" + e,
                className: s.props.trackClassName + " " + s.props.trackClassName + "-" + e,
                style: s.buildTrackStyle(t, s.state.upperBound - n)
            }, o = {
                index: e,
                value: $df7288dd743e035f$var$a(s.state.value)
            };
            return s.props.renderTrack(i, o);
        };
        let n = $df7288dd743e035f$var$r(t.value);
        n.length || (n = $df7288dd743e035f$var$r(t.defaultValue)), s.pendingResizeTimeouts = [];
        const l = [];
        for(let e = 0; e < n.length; e += 1)n[e] = $df7288dd743e035f$var$u(n[e], t), l.push(e);
        return s.resizeObserver = null, s.resizeElementRef = $df7288dd743e035f$var$i.default.createRef(), s.state = {
            index: -1,
            upperBound: 0,
            sliderLength: 0,
            value: n,
            zIndices: l
        }, s;
    }
    $df7288dd743e035f$var$n.default(t, e);
    var s = t.prototype;
    return s.componentDidMount = function() {
        "undefined" != typeof window && (this.resizeObserver = new ResizeObserver(this.handleResize), this.resizeObserver.observe(this.resizeElementRef.current), this.resize());
    }, t.getDerivedStateFromProps = function(e, t) {
        const s = $df7288dd743e035f$var$r(e.value);
        return s.length ? t.pending ? null : {
            value: s.map((t)=>$df7288dd743e035f$var$u(t, e))
        } : null;
    }, s.componentDidUpdate = function() {
        0 === this.state.upperBound && this.resize();
    }, s.componentWillUnmount = function() {
        this.clearPendingResizeTimeouts(), this.resizeObserver && this.resizeObserver.disconnect();
    }, s.onEnd = function(e) {
        e && function(e) {
            Object.keys(e).forEach((t)=>{
                "undefined" != typeof document && document.removeEventListener(t, e[t], !1);
            });
        }(e), this.hasMoved && this.fireChangeEvent("onAfterChange"), this.setState({
            pending: !1
        }), this.hasMoved = !1;
    }, s.getValue = function() {
        return $df7288dd743e035f$var$a(this.state.value);
    }, s.getClosestIndex = function(e) {
        let t = Number.MAX_VALUE, s = -1;
        const { value: n } = this.state, i = n.length;
        for(let o = 0; o < i; o += 1){
            const i = this.calcOffset(n[o]), r = Math.abs(e - i);
            r < t && (t = r, s = o);
        }
        return s;
    }, s.getMousePosition = function(e) {
        return [
            e["page" + this.axisKey()],
            e["page" + this.orthogonalAxisKey()]
        ];
    }, s.getTouchPosition = function(e) {
        const t = e.touches[0];
        return [
            t["page" + this.axisKey()],
            t["page" + this.orthogonalAxisKey()]
        ];
    }, s.getKeyDownEventMap = function() {
        return {
            keydown: this.onKeyDown,
            keyup: this.onKeyUp,
            focusout: this.onBlur
        };
    }, s.getMouseEventMap = function() {
        return {
            mousemove: this.onMouseMove,
            mouseup: this.onMouseUp
        };
    }, s.getTouchEventMap = function() {
        return {
            touchmove: this.onTouchMove,
            touchend: this.onTouchEnd
        };
    }, s.getValueFromPosition = function(e) {
        const t = e / (this.state.sliderLength - this.state.thumbSize) * (this.props.max - this.props.min);
        return $df7288dd743e035f$var$u(this.state.startValue + t, this.props);
    }, s.getDiffPosition = function(e) {
        let t = e - this.state.startPosition;
        return this.props.invert && (t *= -1), t;
    }, s.resize = function() {
        const { slider: e, thumb0: t } = this;
        if (!e || !t) return;
        const s = this.sizeKey(), n = e.getBoundingClientRect(), i = e[s], o = n[this.posMaxKey()], r = n[this.posMinKey()], a = t.getBoundingClientRect()[s.replace("client", "").toLowerCase()], p = i - a, u = Math.abs(o - r);
        this.state.upperBound === p && this.state.sliderLength === u && this.state.thumbSize === a || this.setState({
            upperBound: p,
            sliderLength: u,
            thumbSize: a
        });
    }, s.calcOffset = function(e) {
        const t = this.props.max - this.props.min;
        if (0 === t) return 0;
        return (e - this.props.min) / t * this.state.upperBound;
    }, s.calcValue = function(e) {
        return e / this.state.upperBound * (this.props.max - this.props.min) + this.props.min;
    }, s.calcOffsetFromPosition = function(e) {
        const { slider: t } = this, s = t.getBoundingClientRect(), n = s[this.posMaxKey()], i = s[this.posMinKey()];
        let o = e - (window["page" + this.axisKey() + "Offset"] + (this.props.invert ? n : i));
        return this.props.invert && (o = this.state.sliderLength - o), o -= this.state.thumbSize / 2, o;
    }, s.forceValueFromPosition = function(e, t) {
        const s = this.calcOffsetFromPosition(e), n = this.getClosestIndex(s), i = $df7288dd743e035f$var$u(this.calcValue(s), this.props), o = this.state.value.slice();
        o[n] = i;
        for(let e = 0; e < o.length - 1; e += 1)if (o[e + 1] - o[e] < this.props.minDistance) return;
        this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0, this.setState({
            value: o
        }, ()=>{
            t(n), this.fireChangeEvent("onChange");
        });
    }, s.clearPendingResizeTimeouts = function() {
        do {
            const e = this.pendingResizeTimeouts.shift();
            clearTimeout(e);
        }while (this.pendingResizeTimeouts.length);
    }, s.start = function(e, t) {
        const s = this["thumb" + e];
        s && s.focus();
        const { zIndices: n } = this.state;
        n.splice(n.indexOf(e), 1), n.push(e), this.setState((s)=>({
                startValue: s.value[e],
                startPosition: void 0 !== t ? t : s.startPosition,
                index: e,
                zIndices: n
            }));
    }, s.moveUpByStep = function(e) {
        void 0 === e && (e = this.props.step);
        const t = this.state.value[this.state.index], s = $df7288dd743e035f$var$u(this.props.invert && "horizontal" === this.props.orientation ? t - e : t + e, this.props);
        this.move(Math.min(s, this.props.max));
    }, s.moveDownByStep = function(e) {
        void 0 === e && (e = this.props.step);
        const t = this.state.value[this.state.index], s = $df7288dd743e035f$var$u(this.props.invert && "horizontal" === this.props.orientation ? t + e : t - e, this.props);
        this.move(Math.max(s, this.props.min));
    }, s.move = function(e) {
        const t = this.state.value.slice(), { index: s } = this.state, { length: n } = t, i = t[s];
        if (e === i) return;
        this.hasMoved || this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0;
        const { pearling: o, max: r, min: a, minDistance: p } = this.props;
        if (!o) {
            if (s > 0) {
                const n = t[s - 1];
                e < n + p && (e = n + p);
            }
            if (s < n - 1) {
                const n = t[s + 1];
                e > n - p && (e = n - p);
            }
        }
        t[s] = e, o && n > 1 && (e > i ? (this.pushSucceeding(t, p, s), function(e, t, s, n) {
            for(let i = 0; i < e; i += 1){
                const o = n - i * s;
                t[e - 1 - i] > o && (t[e - 1 - i] = o);
            }
        }(n, t, p, r)) : e < i && (this.pushPreceding(t, p, s), function(e, t, s, n) {
            for(let i = 0; i < e; i += 1){
                const e = n + i * s;
                t[i] < e && (t[i] = e);
            }
        }(n, t, p, a))), this.setState({
            value: t
        }, this.fireChangeEvent.bind(this, "onChange"));
    }, s.pushSucceeding = function(e, t, s) {
        let n, i;
        for(n = s, i = e[n] + t; null !== e[n + 1] && i > e[n + 1]; n += 1, i = e[n] + t)e[n + 1] = $df7288dd743e035f$var$l(i, this.props);
    }, s.pushPreceding = function(e, t, s) {
        for(let n = s, i = e[n] - t; null !== e[n - 1] && i < e[n - 1]; n -= 1, i = e[n] - t)e[n - 1] = $df7288dd743e035f$var$l(i, this.props);
    }, s.axisKey = function() {
        return "vertical" === this.props.orientation ? "Y" : "X";
    }, s.orthogonalAxisKey = function() {
        return "vertical" === this.props.orientation ? "X" : "Y";
    }, s.posMinKey = function() {
        return "vertical" === this.props.orientation ? this.props.invert ? "bottom" : "top" : this.props.invert ? "right" : "left";
    }, s.posMaxKey = function() {
        return "vertical" === this.props.orientation ? this.props.invert ? "top" : "bottom" : this.props.invert ? "left" : "right";
    }, s.sizeKey = function() {
        return "vertical" === this.props.orientation ? "clientHeight" : "clientWidth";
    }, s.fireChangeEvent = function(e) {
        this.props[e] && this.props[e]($df7288dd743e035f$var$a(this.state.value), this.state.index);
    }, s.buildThumbStyle = function(e, t) {
        const s = {
            position: "absolute",
            touchAction: "none",
            willChange: this.state.index >= 0 ? this.posMinKey() : void 0,
            zIndex: this.state.zIndices.indexOf(t) + 1
        };
        return s[this.posMinKey()] = e + "px", s;
    }, s.buildTrackStyle = function(e, t) {
        const s = {
            position: "absolute",
            willChange: this.state.index >= 0 ? this.posMinKey() + "," + this.posMaxKey() : void 0
        };
        return s[this.posMinKey()] = e, s[this.posMaxKey()] = t, s;
    }, s.buildMarkStyle = function(e) {
        var t;
        return (t = {
            position: "absolute"
        })[this.posMinKey()] = e, t;
    }, s.renderThumbs = function(e) {
        const { length: t } = e, s = [];
        for(let n = 0; n < t; n += 1)s[n] = this.buildThumbStyle(e[n], n);
        const n = [];
        for(let e = 0; e < t; e += 1)n[e] = this.renderThumb(s[e], e);
        return n;
    }, s.renderTracks = function(e) {
        const t = [], s = e.length - 1;
        t.push(this.renderTrack(0, 0, e[0]));
        for(let n = 0; n < s; n += 1)t.push(this.renderTrack(n + 1, e[n], e[n + 1]));
        return t.push(this.renderTrack(s + 1, e[s], this.state.upperBound)), t;
    }, s.renderMarks = function() {
        let { marks: e } = this.props;
        const t = this.props.max - this.props.min + 1;
        return "boolean" == typeof e ? e = Array.from({
            length: t
        }).map((e, t)=>t) : "number" == typeof e && (e = Array.from({
            length: t
        }).map((e, t)=>t).filter((t)=>t % e == 0)), e.map(parseFloat).sort((e, t)=>e - t).map((e)=>{
            const t = this.calcOffset(e), s = {
                key: e,
                className: this.props.markClassName,
                style: this.buildMarkStyle(t)
            };
            return this.props.renderMark(s);
        });
    }, s.render = function() {
        const e = [], { value: t } = this.state, s = t.length;
        for(let n = 0; n < s; n += 1)e[n] = this.calcOffset(t[n], n);
        const n = this.props.withTracks ? this.renderTracks(e) : null, o = this.renderThumbs(e), r = this.props.marks ? this.renderMarks() : null;
        return $df7288dd743e035f$var$i.default.createElement("div", {
            ref: (e)=>{
                this.slider = e, this.resizeElementRef.current = e;
            },
            style: {
                position: "relative"
            },
            className: this.props.className + (this.props.disabled ? " disabled" : ""),
            onMouseDown: this.onSliderMouseDown,
            onClick: this.onSliderClick
        }, n, o, r);
    }, t;
}($df7288dd743e035f$var$i.default.Component);
$df7288dd743e035f$var$h.displayName = "ReactSlider", $df7288dd743e035f$var$h.defaultProps = {
    min: 0,
    max: 100,
    step: 1,
    pageFn: (e)=>10 * e,
    minDistance: 0,
    defaultValue: 0,
    orientation: "horizontal",
    className: "slider",
    thumbClassName: "thumb",
    thumbActiveClassName: "active",
    trackClassName: "track",
    markClassName: "mark",
    withTracks: !0,
    pearling: !1,
    disabled: !1,
    snapDragDisabled: !1,
    invert: !1,
    marks: [],
    renderThumb: (e)=>$df7288dd743e035f$var$i.default.createElement("div", e),
    renderTrack: (e)=>$df7288dd743e035f$var$i.default.createElement("div", e),
    renderMark: (e)=>$df7288dd743e035f$var$i.default.createElement("span", e)
};
var $df7288dd743e035f$var$c = $df7288dd743e035f$var$h;
module.exports.default = $df7288dd743e035f$var$c;

});
parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aAhot(t, o);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});







parcelRegister("iaOm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e18cee1a0613dc8f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lxTgp = parcelRequire("lxTgp");

var $aEgqS = parcelRequire("aEgqS");

var $eoSy7 = parcelRequire("eoSy7");

var $rDKvs = parcelRequire("rDKvs");
const $e18cee1a0613dc8f$var$LiveMeetingSharedViewImageViewer = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const updateSharedImageZoomState = (shareImageZoomState)=>dispatch((0, $rDKvs.updateSharedImageZoomStateAction)(shareImageZoomState));
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const image = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eoSy7.default), {
        imageSrc: image.path,
        updateCallback: updateSharedImageZoomState
    });
};
var $e18cee1a0613dc8f$export$2e2bcd8739ae039 = $e18cee1a0613dc8f$var$LiveMeetingSharedViewImageViewer;

});
parcelRegister("eoSy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a303dc2a1851389$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aaRo7 = parcelRequire("aaRo7");

var $60Xm0 = parcelRequire("60Xm0");

var $5QIbQ = parcelRequire("5QIbQ");
const $0a303dc2a1851389$var$ImageZoom = (props)=>{
    const defaultState = {
        zoom: 1,
        posX: 0,
        posY: 0
    };
    const [state, setState] = (0, $acw62.useState)(defaultState);
    const [throttle, setThrottle] = (0, $acw62.useState)(0);
    const [prevState, setPrevState] = (0, $acw62.useState)({});
    const defaultValues = {
        zoom: 5,
        minZoom: 1,
        maxZoom: 5,
        scrollVelocity: 0.2
    };
    const imageRef = (0, $acw62.useRef)(null);
    const parentRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // reset server state when loading for first time or when page reloads
        if (!props.updateCallback) return;
        props.updateCallback(defaultState);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            setThrottle((s)=>s + 1);
        }, 1500);
        return ()=>clearInterval(intervalId);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (props.imageSrc && prevState !== state) {
            if (props.updateCallback && imageRef.current) {
                const rect = imageRef.current.getBoundingClientRect();
                const relativePosX = state.posX / rect.width;
                const relativePosY = state.posY / rect.height;
                const updateSharedImageZoomState = {
                    zoom: state.zoom,
                    posX: relativePosX,
                    posY: relativePosY
                };
                props.updateCallback(updateSharedImageZoomState);
            }
            setPrevState(state);
        } else if (!props.imageSrc && state !== defaultState) setState(defaultState);
    }, [
        throttle
    ]);
    const handleMouseWheel = (event)=>{
        const { zoom: zoom } = state;
        const { scrollVelocity: scrollVelocity, maxZoom: maxZoom, minZoom: minZoom } = defaultValues;
        // Determine if we are increasing or decreasing the zoom
        const increaseZoom = event.deltaY < 0;
        let newZoom;
        if (increaseZoom) newZoom = zoom + scrollVelocity < maxZoom ? zoom + scrollVelocity : maxZoom;
        else newZoom = zoom - scrollVelocity > minZoom ? zoom - scrollVelocity : minZoom;
        const newPos = newZoom !== zoom ? (0, $60Xm0.getNewPosition)({
            posX: event.pageX,
            posY: event.pageY
        }, newZoom, state, imageRef.current.getBoundingClientRect()) : {
            posX: state.posX,
            posY: state.posY
        };
        setState({
            ...state,
            ...newPos,
            zoom: newZoom,
            transitionDuration: 0.5
        });
    };
    const onDoubleClick = (event)=>{
        if (state.zoom !== defaultValues.minZoom) {
            setState({
                ...state,
                zoom: 1,
                posX: 0,
                posY: 0
            });
            return;
        }
        const newPos = (0, $60Xm0.getNewPosition)({
            posX: event.pageX,
            posY: event.pageY
        }, defaultValues.zoom, {
            zoom: state.zoom,
            posX: state.posX,
            posY: state.posY ?? 0
        }, imageRef.current.getBoundingClientRect());
        setState({
            ...state,
            zoom: defaultValues.zoom,
            ...newPos
        });
    };
    const handleMouseStart = (event)=>{
        event.preventDefault();
        if (state.lastRequestAnimationId) cancelAnimationFrame(state.lastRequestAnimationId);
        const lastCursor = {
            posX: event.pageX,
            posY: event.pageY
        };
        setState({
            ...state,
            cursor: "move",
            lastCursor: lastCursor
        });
    };
    const handleMouseStop = (event)=>{
        event.preventDefault();
        setState({
            ...state,
            cursor: "auto",
            lastCursor: null,
            lastShift: null
        });
    };
    const handleMouseMove = (event)=>{
        event.preventDefault();
        if (!state.lastCursor) return;
        const lastCursor = {
            posX: event.pageX,
            posY: event.pageY
        };
        const lastShift = {
            x: lastCursor.posX - state.lastCursor.posX,
            y: lastCursor.posY - state.lastCursor.posY
        };
        const rects = {
            img: imageRef.current.getBoundingClientRect(),
            parent: parentRef.current.getBoundingClientRect()
        };
        const moveState = (0, $60Xm0.move)(lastShift, state, rects);
        setState({
            ...state,
            ...moveState,
            lastShift: lastShift,
            lastCursor: lastCursor,
            transitionDuration: 0
        });
    };
    const handleSliderChange = (value)=>{
        const newZoom = value / 100;
        const newPosX = newZoom === defaultValues.minZoom ? 0 : state.posX;
        const newPosY = newZoom === defaultValues.minZoom ? 0 : state.posY;
        setState({
            ...state,
            zoom: newZoom,
            posX: newPosX,
            posY: newPosY
        });
    };
    const attr = {
        zoom: state.zoom,
        posX: state.posX,
        posY: state.posY,
        cursor: state.cursor,
        transitionDuration: state.transitionDuration,
        imageRef: imageRef,
        parentRef: parentRef,
        imageSrc: props.imageSrc,
        attr: {
            onWheel: handleMouseWheel,
            onDoubleClick: onDoubleClick,
            onMouseDown: handleMouseStart,
            onMouseUp: handleMouseStop,
            onMouseLeave: handleMouseStop,
            onMouseMove: handleMouseMove
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col w-full h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 mb-3 overflow-hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5QIbQ.default), {
                    ...attr
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-center relative",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-64",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aaRo7.default), {
                        onChange: handleSliderChange,
                        value: state.zoom * 100,
                        min: defaultValues.minZoom * 100,
                        max: defaultValues.maxZoom * 100
                    })
                })
            })
        ]
    });
};
var $0a303dc2a1851389$export$2e2bcd8739ae039 = $0a303dc2a1851389$var$ImageZoom;

});
parcelRegister("60Xm0", function(module, exports) {

$parcel$export(module.exports, "getNewPosition", () => $4d6af24ff32ed458$export$15adbf836b6aba15);
$parcel$export(module.exports, "move", () => $4d6af24ff32ed458$export$d947e5f4f4c48d48);
const $4d6af24ff32ed458$var$calculateNewPos = (pageX, pageY, prevData, zoom, rect)=>{
    // Get container coordinates
    // Retrieve rectangle dimensions and mouse position
    const [centerX, centerY] = [
        rect.width / 2,
        rect.height / 2
    ];
    const [relativeX, relativeY] = [
        pageX - rect.left - window.pageXOffset,
        pageY - rect.top - window.pageYOffset
    ];
    // If we are zooming down, we must try to center to mouse position
    const [absX, absY] = [
        (centerX - relativeX) / prevData.zoom,
        (centerY - relativeY) / prevData.zoom
    ];
    const ratio = zoom - prevData.zoom;
    return {
        posX: prevData.posX + absX * ratio,
        posY: prevData.posY + absY * ratio
    };
};
const $4d6af24ff32ed458$export$15adbf836b6aba15 = (newPos, zoom, prevData, rect)=>{
    if (zoom === 1) return {
        posX: 0,
        posY: 0
    };
    if (zoom > prevData.zoom) return $4d6af24ff32ed458$var$calculateNewPos(newPos.posX, newPos.posY, prevData, zoom, rect);
    else // If we are zooming down, we shall re-center the element
    return {
        posX: prevData.posX * (zoom - 1) / (prevData.zoom - 1),
        posY: prevData.posY * (zoom - 1) / (prevData.zoom - 1)
    };
};
const $4d6af24ff32ed458$export$d947e5f4f4c48d48 = (shift, state, rects)=>{
    let { posX: posX, posY: posY } = state;
    const { img: img, parent: parent } = rects;
    const canMoveOnX = shift.x > 0 && img.left - parent.left < 0 || shift.x < 0 && img.right - parent.right > 0;
    if (canMoveOnX) posX += shift.x;
    const canMoveOnY = shift.y > 0 && img.top - parent.top < 0 || shift.y < 0 && img.bottom - parent.bottom > 0;
    if (canMoveOnY) posY += shift.y;
    return {
        posX: posX,
        posY: posY
    };
};

});

parcelRegister("5QIbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d22714f775ab20f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jUk5c = parcelRequire("jUk5c");

var $aEgqS = parcelRequire("aEgqS");
const $1d22714f775ab20f$var$ImageZoomImage = (props)=>{
    const style = {
        cursor: props.cursor ?? "auto",
        transform: `translate3d(${props.posX}px, ${props.posY}px, 0)scale(${props.zoom})`,
        transition: `transform ease-out ${props.transitionDuration}s`,
        willChange: "transform"
    };
    const attr = {
        style: style,
        ...props.attr
    };
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        (0, $jUk5c.default)(props.imageSrc, setBlobUrl);
    }, [
        props.imageSrc
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex w-full h-full overflow-hidden bg-ch-gray-200 p-2",
        ref: props.parentRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...attr,
            className: "flex flex-1 w-full h-full overflow-hidden justify-center items-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                ref: props.imageRef,
                src: blobUrl,
                style: {
                    transition: "transform ease-out 0.05s",
                    objectFit: "contain",
                    height: "100%",
                    maxWidth: "100%"
                }
            })
        })
    });
};
var $1d22714f775ab20f$export$2e2bcd8739ae039 = $1d22714f775ab20f$var$ImageZoomImage;

});



parcelRegister("huFHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $488e6f609dba44b6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $57bqY = parcelRequire("57bqY");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aDoxy = parcelRequire("aDoxy");
const $488e6f609dba44b6$var$RadiologyLink = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const link = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: props.action ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2 flex rounded-md border-2 bg-ch-blue-100", {
            "border-ch-blue-100": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": props.action,
            "cursor-pointer": props.action,
            "cursor-default": !props.action
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-alt-400 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57bqY.default), {
                    className: "w-5 h-5",
                    title: link.title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 min-w-0 grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold text-lg",
                        children: link.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "block overflow-hidden overflow-ellipsis whitespace-nowrap",
                        children: link.originalFileName
                    })
                ]
            }),
            props.children
        ]
    });
};
var $488e6f609dba44b6$export$2e2bcd8739ae039 = $488e6f609dba44b6$var$RadiologyLink;

});

parcelRegister("jlnhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8e8a18e6a1a125$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7twpo = parcelRequire("7twpo");

var $aDoxy = parcelRequire("aDoxy");

var $a4BnF = parcelRequire("a4BnF");

var $4KSAX = parcelRequire("4KSAX");

var $2ghAH = parcelRequire("2ghAH");
const $6a8e8a18e6a1a125$var$Form = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const form = asset.asset;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const isDraft = form.state != (0, $7twpo.FormState).complete;
    const isPendingPdfDownload = form.state == (0, $7twpo.FormState).complete && !form.path;
    const isClickable = !props.noAction && props.action && (isDraft || !isPendingPdfDownload) && !(isDraft && props.liveMeeting);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: isClickable ? ()=>props.action() : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("bg-white p-2 flex rounded-md border-2", {
            "border-ch-blue-200": !props.isSelected,
            "border-ch-blue-500": props.isSelected,
            "hover:border-ch-blue-500": isClickable,
            "cursor-pointer": isClickable,
            "cursor-default": !isClickable
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2 mt-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                    className: "w-5 h-5",
                    title: form.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "font-semibold text-lg flex-1",
                                children: form.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4BnF.default), {
                                isVisible: isDraft,
                                children: t("asset:draft")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a4BnF.default), {
                                isVisible: isPendingPdfDownload,
                                children: [
                                    t("asset:generatingForm"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ghAH.default), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDoxy.default), {
                        meetingCaseAsset: props.meetingCaseAsset,
                        meetingId: props.meetingId,
                        asset: asset
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: form.description
                    })
                ]
            }),
            props.children
        ]
    });
};
var $6a8e8a18e6a1a125$export$2e2bcd8739ae039 = $6a8e8a18e6a1a125$var$Form;

});



parcelRegister("buMa2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2898fe16fae858$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kAnkg = parcelRequire("kAnkg");

var $04A9g = parcelRequire("04A9g");

var $4KSAX = parcelRequire("4KSAX");
const $0e2898fe16fae858$var$AssetTypeFilter = ({ setFilters: setFilters, initialValues: initialValues })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const [showPdfs, setShowPdfs] = (0, $acw62.useState)(initialValues?.showPdfs || false);
    const [showImages, setShowImages] = (0, $acw62.useState)(initialValues?.showImages || false);
    const [showLinks, setShowLinks] = (0, $acw62.useState)(initialValues?.showLinks || false);
    const [showComments, setShowComments] = (0, $acw62.useState)(initialValues?.showComments || false);
    const [showDecisions, setShowDecisions] = (0, $acw62.useState)(initialValues?.showDecisions || false);
    const [showRecommendations, setShowRecommendations] = (0, $acw62.useState)(initialValues?.showRecommendations || false);
    const setShowAll = ()=>{
        setShowPdfs(false);
        setShowImages(false);
        setShowLinks(false);
        setShowComments(false);
        setShowDecisions(false);
        setShowRecommendations(false);
    };
    const showAll = !(showPdfs || showImages || showLinks || showComments || showDecisions || showRecommendations);
    const filters = {
        showAll: showAll,
        showPdfs: showPdfs,
        showImages: showImages,
        showLinks: showLinks,
        showComments: showComments,
        showDecisions: showDecisions,
        showRecommendations: showRecommendations
    };
    (0, $acw62.useEffect)(()=>{
        setFilters(filters);
    }, [
        showPdfs,
        showImages,
        showLinks,
        showComments,
        showDecisions,
        showRecommendations
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
        className: "text-sm",
        buttons: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showAll,
                action: ()=>setShowAll(),
                children: t("filterAll")
            }, 0),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showPdfs,
                action: ()=>setShowPdfs(!showPdfs),
                children: t("filterPdfs")
            }, 1),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showImages,
                action: ()=>setShowImages(!showImages),
                children: t("filterImages")
            }, 2),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showLinks,
                action: ()=>setShowLinks(!showLinks),
                children: t("filterLinks")
            }, 3),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showComments,
                action: ()=>setShowComments(!showComments),
                children: t("filterComments")
            }, 4),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showDecisions,
                action: ()=>setShowDecisions(!showDecisions),
                children: t("filterDecisions")
            }, 5),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showRecommendations,
                action: ()=>setShowRecommendations(!showRecommendations),
                children: t("filterRecommendations")
            }, 6)
        ]
    });
};
const $0e2898fe16fae858$export$e8278b378d3d419b = {
    showAll: true,
    showPdfs: true,
    showImages: true,
    showLinks: true,
    showComments: true,
    showDecisions: true,
    showRecommendations: true
};
var $0e2898fe16fae858$export$2e2bcd8739ae039 = $0e2898fe16fae858$var$AssetTypeFilter;

});
parcelRegister("kAnkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0b2e9d9c3c5e85$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $lHtgo = parcelRequire("lHtgo");
const $ba0b2e9d9c3c5e85$var$ButtonFilter = ({ className: className, action: action, variant: variant, altVariant: altVariant, children: children, isChunky: isChunky, isOn: isOn })=>{
    if (!variant) {
        variant = (0, $jF0Xa.StyleVariants).GRAY;
        altVariant = (0, $jF0Xa.StyleVariants).BLUE;
    }
    const defaultClasses = [
        "flex",
        "items-center",
        `bg-${variant}-450`,
        `hover:bg-${variant}-500`,
        "text-white",
        "px-4",
        "rounded-full",
        "cursor-pointer"
    ];
    const chunkyClasses = [
        "font-semibold",
        "py-2"
    ];
    const thinClasses = [
        "font-light",
        "py-1"
    ];
    const additionalClasses = isChunky ? chunkyClasses : thinClasses;
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...additionalClasses,
        ...propClasses
    ].join(" ");
    if (isOn) return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        onClick: action,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(allClasses, [
            `bg-${altVariant}-800`,
            `hover:bg-${altVariant}-800`
        ]),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lHtgo.default), {
                className: "fill-current w-4 h-4 mr-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: children
            })
        ]
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        onClick: action,
        className: allClasses,
        children: children
    });
};
var $ba0b2e9d9c3c5e85$export$2e2bcd8739ae039 = $ba0b2e9d9c3c5e85$var$ButtonFilter;

});



parcelRegister("6gEUE", function(module, exports) {

$parcel$export(module.exports, "getLiveMeetingSharedViewSelectedAssetId", () => $cf3b19b86253e85f$export$a56de44b141ca9ab);
$parcel$export(module.exports, "getLiveMeetingSharedViewSelectedAssetTypeFilters", () => $cf3b19b86253e85f$export$9b874794d84b9da4);
$parcel$export(module.exports, "getLiveMeetingSharedImageZoomState", () => $cf3b19b86253e85f$export$c3d415a1dda69e7f);

var $6SpLG = parcelRequire("6SpLG");

var $dQiiy = parcelRequire("dQiiy");
const $cf3b19b86253e85f$export$a56de44b141ca9ab = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), (liveMeetingConfig)=>{
    return liveMeetingConfig.sharedViewSelectedAssetId;
});
const $cf3b19b86253e85f$export$9b874794d84b9da4 = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), (liveMeetingConfig)=>{
    return liveMeetingConfig.sharedViewSelectedAssetTypeFilters;
});
const $cf3b19b86253e85f$export$c3d415a1dda69e7f = (0, $6SpLG.createSelector)((0, $dQiiy.getLiveMeetingConfig), (liveMeetingConfig)=>{
    return liveMeetingConfig.sharedImageZoomState;
});

});

parcelRegister("8ra4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80d2af155e7fb7f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
const $f80d2af155e7fb7f$var$LiveMeetingAssetsContainer = ({ hasDarkBackground: hasDarkBackground = false, children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-col flex-1 p-2 overflow-hidden", {
            "bg-ch-gray-200": hasDarkBackground
        }),
        children: children
    });
};
var $f80d2af155e7fb7f$export$2e2bcd8739ae039 = $f80d2af155e7fb7f$var$LiveMeetingAssetsContainer;

});

parcelRegister("fp9J8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd4224cc7133a867$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $chuvC = parcelRequire("chuvC");
const $dd4224cc7133a867$var$LiveMeetingAssetViewerCloseButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        className: "block text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer -mr-2",
        onClick: ()=>props.clearSelectedAsset(),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chuvC.default), {
                className: "fill-current w-6 h-6",
                title: t("shared:close")
            })
        })
    });
};
var $dd4224cc7133a867$export$2e2bcd8739ae039 = $dd4224cc7133a867$var$LiveMeetingAssetViewerCloseButton;

});

parcelRegister("4cduv", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c3cf12bce0c5eb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $rDKvs = parcelRequire("rDKvs");
const $27c3cf12bce0c5eb$var$LiveMeetingSharedViewAssetViewer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const updateSharedViewSelectedAsset = (assetId, assetTypeFilters)=>dispatch((0, $rDKvs.updateSharedViewSelectedAssetAction)(assetId, assetTypeFilters));
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:assetNotFound")
    });
    const AssetViewer = (0, $hVO2M.lookupLiveMeetingViewerForAsset)(asset);
    if (!AssetViewer) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:couldNotDisplayAsset")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(AssetViewer, {
        assetId: props.assetId,
        onSelectAsset: updateSharedViewSelectedAsset
    });
};
var $27c3cf12bce0c5eb$export$2e2bcd8739ae039 = $27c3cf12bce0c5eb$var$LiveMeetingSharedViewAssetViewer;

});

parcelRegister("1p6nT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee05ac9eedc3840$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");

var $7twpo = parcelRequire("7twpo");
const $7ee05ac9eedc3840$var$LiveMeetingSelectedAssetHeading = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    if (!asset) return null;
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const headingLookup = {
        [(0, $7twpo.AssetComponentTypes).Comment]: asset.asset.title,
        [(0, $7twpo.AssetComponentTypes).Decision]: asset.asset.title,
        [(0, $7twpo.AssetComponentTypes).Deferral]: asset.asset.title,
        [(0, $7twpo.AssetComponentTypes).Recommendation]: asset.asset.title,
        [(0, $7twpo.AssetComponentTypes).Pdf]: asset.asset.name,
        [(0, $7twpo.AssetComponentTypes).Image]: asset.asset.name
    };
    // we need to set some fallback content for the heading, otherwise the close button will end up in the wrong place
    const headingText = headingLookup[assetComponetType] || "\u00A0" // that's a nbsp
    ;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "flex items-center justify-center flex-1 font-thin",
        children: headingText
    });
};
var $7ee05ac9eedc3840$export$2e2bcd8739ae039 = $7ee05ac9eedc3840$var$LiveMeetingSelectedAssetHeading;

});

parcelRegister("5UvqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe099407de32bd09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $88nWC = parcelRequire("88nWC");

var $8g1PZ = parcelRequire("8g1PZ");

var $4KSAX = parcelRequire("4KSAX");

var $j0qQC = parcelRequire("j0qQC");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $jpKnx = parcelRequire("jpKnx");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $3mOhS = parcelRequire("3mOhS");
const $fe099407de32bd09$var$RecommendationAreaWrapper = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const selectedMeetingCaseId = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseId));
    const recommendations = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig?.recommendations);
    const currentCaseRecommendation = (recommendations ? recommendations[selectedMeetingCaseId] : "") || "";
    const actionButtonDisabled = currentCaseRecommendation.length < 1;
    let actionButton;
    let userList;
    if (props.caseStage == (0, $j0qQC.CaseStage).DEFERRING) {
        actionButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            action: props.deferCurrentCase,
            isDisabled: actionButtonDisabled,
            children: t("shared:defer")
        });
        userList = null;
    } else {
        actionButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            action: props.requestApproval,
            isDisabled: actionButtonDisabled,
            children: t("shared:requestApproval")
        });
        userList = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88nWC.default), {
            users: props.users
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "flex-1", "p-2", "overflow-y-auto"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2", "rounded-md", "mt-2"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpKnx.default), {
                    meetingId: props.meetingId,
                    readOnly: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-wrap flex-1 gap-1 justify-center my-6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            action: props.cancelRecommendation,
                            children: t("shared:cancel")
                        }),
                        actionButton
                    ]
                }),
                userList
            ]
        })
    });
};
var $fe099407de32bd09$export$2e2bcd8739ae039 = $fe099407de32bd09$var$RecommendationAreaWrapper;

});
parcelRegister("88nWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba7c54df41a0695$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ldSCI = parcelRequire("ldSCI");

var $f1q41 = parcelRequire("f1q41");

var $8g1PZ = parcelRequire("8g1PZ");
const $eba7c54df41a0695$var$UserConsentList = (props)=>{
    const sortedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(props.users, [
        "lastName",
        "firstName"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            "hidden sm:block": props.readOnly
        }),
        children: sortedUsers.map((user)=>{
            // we were seeing a bug where sometimes a user could be blank. not sure what was causing that.
            if (user == undefined) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "bg-ch-gray-200 mb-1 p-2 rounded-md",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldSCI.default), {
                    user: user
                })
            }, user.id);
        })
    });
};
var $eba7c54df41a0695$export$2e2bcd8739ae039 = $eba7c54df41a0695$var$UserConsentList;

});
parcelRegister("ldSCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e9d3dcb7accf8c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
var $8tyXr = parcelRequire("8tyXr");
var $4e1aD = parcelRequire("4e1aD");

var $j0qQC = parcelRequire("j0qQC");

var $rDKvs = parcelRequire("rDKvs");

var $6lvMC = parcelRequire("6lvMC");

var $gJ54A = parcelRequire("gJ54A");

var $6t04b = parcelRequire("6t04b");

var $f4qfv = parcelRequire("f4qfv");

var $kN4w7 = parcelRequire("kN4w7");

var $biuvr = parcelRequire("biuvr");

var $dQiiy = parcelRequire("dQiiy");

var $8g1PZ = parcelRequire("8g1PZ");
const $37e9d3dcb7accf8c$var$ConsentListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "liveMeeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const caseStage = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).caseStage;
    const consent = (0, $iD0SF.useSelector)((state)=>(0, $f4qfv.getLiveMeetingUserConsent)(state, props.user.id));
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, {
            userId: (0, $6lvMC.getCurrentUser)(state).id
        }));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const consentOnBehalf = (response, userId)=>dispatch((0, $rDKvs.giveConsentOnBehalfAction)(response, userId));
    const response = consent ? consent.response : "";
    const pending = response == (0, $j0qQC.ConsentResponse).PENDING || response == undefined || response == "";
    const approved = response == (0, $j0qQC.ConsentResponse).APPROVE;
    const rejected = response == (0, $j0qQC.ConsentResponse).REJECT;
    const na = response == (0, $j0qQC.ConsentResponse).NA;
    const canConsentOnBehalf = // these permissions are different fromt the permission for async recommendations!!
    caseStage == (0, $j0qQC.CaseStage).APPROVING && currentUser.config.isPresenter && !props.readOnly && (!consent || consent.consentById == currentUser.id || consent.consentById != props.user.id);
    const coloursForResponse = (thisResponse, colour)=>{
        return {
            [colour]: thisResponse,
            "hidden": !thisResponse && !canConsentOnBehalf,
            "text-ch-blue-400": !thisResponse && canConsentOnBehalf && pending,
            "text-ch-blue-200": !thisResponse && canConsentOnBehalf && !pending,
            "cursor-pointer": canConsentOnBehalf
        };
    };
    const handler = (consent)=>{
        if (canConsentOnBehalf) consentOnBehalf(consent, props.user.id);
    };
    const pickApprove = ()=>handler((0, $j0qQC.ConsentResponse).APPROVE);
    const pickReject = ()=>handler((0, $j0qQC.ConsentResponse).REJECT);
    const pickNa = ()=>handler((0, $j0qQC.ConsentResponse).NA);
    const renderComment = ()=>{
        const comment = consent?.comment;
        if (!comment) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "font-semibold",
                    children: t("shared:consentComment")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                        value: comment,
                        users: users
                    })
                })
            ]
        });
    };
    const responseOnBehalf = ()=>{
        if (!props.user || !consent) return;
        if (props.user?.id != consent?.consentById) return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
            className: "text-sm font-thin uppercase",
            children: [
                "(",
                t("liveMeeting:consentOnBehalf"),
                ")"
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJ54A.default), {
                        userId: props.user.id
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "mr-1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                            firstName: props.user.firstName,
                                            lastName: props.user.lastName,
                                            professionalTitle: props.user.professionalTitle
                                        })
                                    }),
                                    responseOnBehalf()
                                ]
                            }),
                            renderComment()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current w-8 h-8 ml-3 ", coloursForResponse(approved, "text-green-500")),
                        onClick: pickApprove
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e1aD.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current w-8 h-8 ml-3  cursor-pointer", coloursForResponse(rejected, "text-red-500")),
                        onClick: pickReject
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8tyXr.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current w-8 h-8 ml-3 cursor-pointer", coloursForResponse(na, "text-ch-gray-600")),
                        onClick: pickNa
                    })
                ]
            })
        ]
    });
};
var $37e9d3dcb7accf8c$export$2e2bcd8739ae039 = $37e9d3dcb7accf8c$var$ConsentListItem;

});
parcelRegister("gJ54A", function(module, exports) {

$parcel$export(module.exports, "default", () => $341b96fb61b70cd1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $kN4w7 = parcelRequire("kN4w7");
const $341b96fb61b70cd1$var$LiveMeetingUserOnlineStatus = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    const isOnline = user.config?.isOnline;
    const isPresent = user.config?.isPresent;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-4", "h-4", "mr-2", "rounded-full", {
            "bg-ch-blue-500": isOnline || isPresent,
            // "bg-ch-orange-500": (isOnline && !isPresent) || (isPresent && !isOnline),
            // "bg-ch-gray-400": !isOnline && !isPresent
            "bg-ch-gray-400": !isOnline && !isPresent
        })
    });
};
var $341b96fb61b70cd1$export$2e2bcd8739ae039 = $341b96fb61b70cd1$var$LiveMeetingUserOnlineStatus;

});

parcelRegister("f4qfv", function(module, exports) {

$parcel$export(module.exports, "getLiveMeetingUserConsent", () => $b28f73476be28e4d$export$84056a7f63b4c969);
const $b28f73476be28e4d$export$84056a7f63b4c969 = (state, userId)=>state.liveMeetingConfig.consents[userId];
const $b28f73476be28e4d$export$aedcc0c368d09cc6 = (state)=>state.liveMeetingConfig.consents;

});



parcelRegister("jpKnx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9685c3aae9f258dc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $6vE8S = parcelRequire("6vE8S");

var $1GBuz = parcelRequire("1GBuz");

var $j0qQC = parcelRequire("j0qQC");

var $dQiiy = parcelRequire("dQiiy");
const $9685c3aae9f258dc$var$RecommendationArea = (props)=>{
    const currentUserConfig = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig)).config;
    const caseStage = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).caseStage;
    const isPresenting = caseStage == (0, $j0qQC.CaseStage).PRESENTING;
    const headerKey = caseStage == (0, $j0qQC.CaseStage).DEFERRING ? "shared:deferHeader" : "shared:recommendationHeader";
    if (!props.readOnly && isPresenting && currentUserConfig.isScribe || !isPresenting && currentUserConfig.isPresenter) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6vE8S.default), {
        headerKey: headerKey,
        meetingId: props.meetingId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GBuz.default), {
        headerKey: headerKey,
        ...props
    });
};
var $9685c3aae9f258dc$export$2e2bcd8739ae039 = $9685c3aae9f258dc$var$RecommendationArea;

});
parcelRegister("6vE8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $78222d52e77e9429$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7YFi7 = parcelRequire("7YFi7");

var $4KSAX = parcelRequire("4KSAX");

var $f1q41 = parcelRequire("f1q41");

var $7UN5R = parcelRequire("7UN5R");

var $rDKvs = parcelRequire("rDKvs");

var $9Hgc1 = parcelRequire("9Hgc1");

var $3mOhS = parcelRequire("3mOhS");

var $dQiiy = parcelRequire("dQiiy");
const $78222d52e77e9429$var$RecommendationForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const _updateRecommendation = (text, caseId)=>dispatch((0, $rDKvs.updateRecommendationAction)(text, caseId));
    const throttled = (0, $acw62.useCallback)((0, $f1q41.debounce)(_updateRecommendation, 1000, {
        maxWait: 2000
    }), []);
    const updateRecommendation = (text, caseId)=>throttled(text, caseId);
    const selectedMeetingCase = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCase));
    const recommendations = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).recommendations;
    const currentCaseRecommendation = (recommendations ? recommendations[selectedMeetingCase.id] : "") || "";
    const handleUpdateRecommendation = (text)=>{
        updateRecommendation(text, selectedMeetingCase.id);
    };
    const headerKey = props.headerKey;
    const initialValues = {
        recommendation: currentCaseRecommendation
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: null,
        children: ({ setFieldValue: setFieldValue, handleChange: handleChange, handleBlur: handleBlur })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                className: "flex-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                            name: "recommendation",
                            className: "mb-2",
                            required: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    t(headerKey),
                                    ":"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Hgc1.default), {
                            meetingId: props.meetingId,
                            handleChange: handleChange,
                            handleBlur: handleBlur,
                            handleUpdateRecommendation: handleUpdateRecommendation,
                            setFieldValue: setFieldValue,
                            serverText: currentCaseRecommendation || ""
                        })
                    ]
                })
            });
        }
    });
};
var $78222d52e77e9429$export$2e2bcd8739ae039 = $78222d52e77e9429$var$RecommendationForm;

});
parcelRegister("9Hgc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff102d5593e1036$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7YFi7 = parcelRequire("7YFi7");

var $lHtgo = parcelRequire("lHtgo");

var $aSzjr = parcelRequire("aSzjr");

var $4VtCQ = parcelRequire("4VtCQ");
const $9ff102d5593e1036$var$RecommendationInputField = (props)=>{
    const [isDirty, setIsDirty] = (0, $acw62.useState)(false);
    const [field] = (0, $7YFi7.useField)("recommendation");
    const currentRecommendationBlank = props.serverText == "" || props.serverText == undefined;
    const mentionableUsers = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUsers)(state, props));
    (0, $acw62.useEffect)(()=>{
        if (field.value == props.serverText) setIsDirty(false);
        else setIsDirty(true);
    }, [
        field.value,
        props.serverText
    ]);
    const renderCheckMarkIcon = ()=>{
        if (isDirty || currentRecommendationBlank) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "absolute right-2 bottom-2 p-2 bg-ch-green-300 z-10 rounded-full",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lHtgo.default), {
                className: "text-white w-3 h-3"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mb-2 relative",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                maxLength: 5000,
                height: 140,
                name: "recommendation",
                onChange: (_e, newValue)=>{
                    setIsDirty(true);
                    props.setFieldValue("recommendation", newValue);
                    props.handleUpdateRecommendation(newValue);
                },
                onBlur: props.handleBlur,
                users: mentionableUsers,
                value: field.value == undefined ? props.serverText : field.value,
                setValue: (body)=>props.setFieldValue("body", body)
            }),
            renderCheckMarkIcon()
        ]
    });
};
var $9ff102d5593e1036$export$2e2bcd8739ae039 = $9ff102d5593e1036$var$RecommendationInputField;

});


parcelRegister("1GBuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3388e30536cbf5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $biuvr = parcelRequire("biuvr");

var $6lvMC = parcelRequire("6lvMC");

var $ff5Vv = parcelRequire("ff5Vv");
const $5e3388e30536cbf5$var$RecommendationDisplay = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "liveMeeting"
    ]);
    const currentCaseRecommendation = (0, $iD0SF.useSelector)((0, $ff5Vv.getCurrentCaseRecommendation));
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUsers));
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-2", "overflow-y-auto", "max-h-full", "sm:max-h-40", "bg-ch-gray-200", "p-2", "rounded");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    t(props.headerKey),
                    " (",
                    t("liveMeeting:readOnly"),
                    "):"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classes,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                    value: currentCaseRecommendation,
                    users: users
                })
            })
        ]
    });
};
var $5e3388e30536cbf5$export$2e2bcd8739ae039 = $5e3388e30536cbf5$var$RecommendationDisplay;

});
parcelRegister("ff5Vv", function(module, exports) {

$parcel$export(module.exports, "getCurrentCaseRecommendation", () => $483c8431ec02f287$export$bfd4fe40a6c8ad50);

var $6SpLG = parcelRequire("6SpLG");

var $3mOhS = parcelRequire("3mOhS");
const $483c8431ec02f287$export$358779cacf74ee7a = (state)=>state.liveMeetingConfig?.recommendations;
const $483c8431ec02f287$export$bfd4fe40a6c8ad50 = (0, $6SpLG.createSelector)($483c8431ec02f287$export$358779cacf74ee7a, (0, $3mOhS.getSelectedMeetingCaseId), (recommendations, selectedMeetingCaseId)=>{
    return recommendations[selectedMeetingCaseId] || "";
});

});




parcelRegister("ccihY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6269b23df48688d4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $88nWC = parcelRequire("88nWC");

var $4KSAX = parcelRequire("4KSAX");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");

var $1GBuz = parcelRequire("1GBuz");

var $04A9g = parcelRequire("04A9g");

var $1qvB8 = parcelRequire("1qvB8");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $dQiiy = parcelRequire("dQiiy");
const $6269b23df48688d4$var$ApprovalAreaWrapper = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const currentUserConfig = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUserWithConfig)(state).config);
    const consents = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).consents;
    const allConsentsGiven = props.users.length == Object.keys(consents).length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "flex-1", "p-2", "overflow-y-auto"),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2", "rounded-md", "mt-2"),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GBuz.default), {
                        headerKey: "shared:recommendationHeader"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                        className: "my-4",
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: props.shareRecommendation,
                                variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                children: t("liveMeeting:changeRecommendation")
                            }, "1"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: props.saveRecommendation,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isDisabled: !allConsentsGiven,
                                children: t("shared:saveRecommendation")
                            }, "2")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm mb-4",
                        children: t("liveMeeting:approvalInstructions")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-sm mb-4",
                        children: t("liveMeeting:changeRecommendationInstructions")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88nWC.default), {
                        users: props.users
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1qvB8.default), {
                isEnabled: currentUserConfig.isPresenter || currentUserConfig.isScribe
            })
        ]
    });
};
var $6269b23df48688d4$export$2e2bcd8739ae039 = $6269b23df48688d4$var$ApprovalAreaWrapper;

});
parcelRegister("1qvB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8c64d3d2714cb5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $COwA0 = parcelRequire("COwA0");

var $e5EhV = parcelRequire("e5EhV");
const $1b8c64d3d2714cb5$var$UnsavedChangesBlocker = ({ isEnabled: isEnabled, message: message })=>{
    const blocker = (0, $COwA0.useBlocker)(!!isEnabled);
    (0, $acw62.useEffect)(()=>{
        if (blocker.state === "blocked") {
            const proceed = window.confirm(message);
            if (proceed) blocker.proceed();
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    return null;
};
const $1b8c64d3d2714cb5$var$UnsavedChangesPrompt = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const message = t("shared:unsavedChangesPrompt");
    const inDataRouter = Boolean((0, $acw62.useContext)((0, $COwA0.DataRouterContext)));
    (0, $e5EhV.useBeforeunload)((event)=>{
        if (props.isEnabled) event.preventDefault();
    });
    if (!inDataRouter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b8c64d3d2714cb5$var$UnsavedChangesBlocker, {
        isEnabled: props.isEnabled,
        message: message
    });
};
var $1b8c64d3d2714cb5$export$2e2bcd8739ae039 = $1b8c64d3d2714cb5$var$UnsavedChangesPrompt;

});


parcelRegister("bdmN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4de29ad0c039d75$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $6lvMC = parcelRequire("6lvMC");

var $rDKvs = parcelRequire("rDKvs");

var $jF0Xa = parcelRequire("jF0Xa");

var $j0qQC = parcelRequire("j0qQC");

var $jpKnx = parcelRequire("jpKnx");

var $kGUIk = parcelRequire("kGUIk");
const $d4de29ad0c039d75$var$ScribeRecommendation = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentCaseId = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig?.selectedMeetingCaseId);
    const currentUserConfig = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUserWithConfig)(state).config);
    const caseStage = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig?.caseStage);
    const shareOrRecommend = ()=>{
        dispatch((0, $kGUIk.toggleWebRTCScreenShareIsOnAction)(false));
        dispatch((0, $rDKvs.shareRecommendationAction)());
    };
    if (currentCaseId == undefined) return null;
    if (caseStage != (0, $j0qQC.CaseStage).PRESENTING) return null;
    const shareOrDefer = ()=>{
        if (!currentUserConfig.isPresenter) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-wrap flex-1 gap-1 justify-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                    action: ()=>dispatch((0, $rDKvs.deferRecommendationAction)()),
                    children: t("shared:defer")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    action: ()=>shareOrRecommend(),
                    children: t("shared:shareAndRecommend")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "p-2 rounded-md bg-ch-yellow-200 mt-2 text-ch-gray-600",
        children: [
            props.buttonsOnly ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpKnx.default), {
                meetingId: props.meetingId,
                readOnly: false
            }),
            shareOrDefer()
        ]
    }, currentCaseId);
};
var $d4de29ad0c039d75$export$2e2bcd8739ae039 = $d4de29ad0c039d75$var$ScribeRecommendation;

});

parcelRegister("2jvQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07921755a4dd224$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("cIYPX");
var $hcnin = parcelRequire("hcnin");

var $4KSAX = parcelRequire("4KSAX");
const $a07921755a4dd224$var$ListBackground = ({ className: className, isHidden: isHidden = false })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const defaultClasses = [
        "flex",
        "flex-col",
        "justify-center",
        "opacity-30",
        "h-full",
        "mt-2"
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full flex justify-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hcnin.default), {
                        className: "w-1/4 opacity-25 mb-2"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w-full flex justify-center text-xl font-thin text-ch-gray-500",
                    children: [
                        t("poweredBy"),
                        " CONTEXT Meeting\u2122"
                    ]
                })
            ]
        })
    });
};
var $a07921755a4dd224$export$2e2bcd8739ae039 = $a07921755a4dd224$var$ListBackground;

});

parcelRegister("6sHZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bdd29e7927f9f78$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $g91zf = parcelRequire("g91zf");

var $kon2z = parcelRequire("kon2z");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $9c2AV = parcelRequire("9c2AV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $3QK3n = parcelRequire("3QK3n");

var $5wJjW = parcelRequire("5wJjW");

var $32kQ2 = parcelRequire("32kQ2");

var $50NSH = parcelRequire("50NSH");

var $c41te = parcelRequire("c41te");

var $2AKZG = parcelRequire("2AKZG");
const $1bdd29e7927f9f78$var$SelectMeetingAssets = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const selectAll = ()=>dispatch((0, $c41te.createAllMeetingCaseAssetsAction)(props.meetingCaseId));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: t("case:selectingAssetsForCaseInMeeting")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g91zf.default), {
                className: "flex-col",
                noBorder: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                        hasBorder: false,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "md:flex md:text-lg flex-row font-semibold mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                                            className: "text-ch-purple-500 self-center mr-1 w-5 h-5"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            children: [
                                                meeting.name,
                                                " ",
                                                t("shared:on"),
                                                "\xa0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                                            startDate: meeting.startDate,
                                            endDate: meeting.endDate
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "text-center lg:text-right mb-2",
                                    children: meeting.status == (0, $32kQ2.MeetingStatuses).Ended ? t("meeting:meetingEnded") : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                                        startDate: meeting.startDate
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                        isDark: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                            width: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                    className: "sm:mr-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                        className: "fill-current w-6 h-6",
                                        title: t("shared:case")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50NSH.default), {
                                    meetingCaseId: props.meetingCaseId
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full md:mb-3 flex justify-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    action: selectAll,
                    children: t("case:selectAllAssets")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: theCase.assets.map((assetId)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2AKZG.default), {
                        action: ()=>props.openViewAssetModal(assetId),
                        assetId: assetId,
                        caseId: props.caseId,
                        meetingId: props.meetingId,
                        meetingCaseId: props.meetingCaseId,
                        hideConsentList: true,
                        openAssetModal: props.openViewAssetModal
                    }, assetId);
                })
            })
        ]
    });
};
var $1bdd29e7927f9f78$export$2e2bcd8739ae039 = $1bdd29e7927f9f78$var$SelectMeetingAssets;

});
parcelRegister("1Cmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9024e1d6ba4e05c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $c9024e1d6ba4e05c$var$DetailsCard = ({ children: children, className: className, isDark: isDark = false, hasBorder: hasBorder = true })=>{
    const defaultClasses = [
        "flex",
        "flex-1",
        "flex-col sm:flex-row",
        "mb-2",
        "items-center",
        "flex-wrap",
        "justify-center",
        "lg:justify-between",
        "md:flex-nowrap"
    ];
    const borderClasses = [
        "border",
        "border-ch-gray-400",
        "rounded-md",
        "p-4"
    ];
    const backgroundColourClass = isDark ? "bg-ch-gray-300" : "bg-white";
    const propClasses = className ? className.split(" ") : [];
    let allClasses = [
        ...defaultClasses,
        backgroundColourClass,
        ...propClasses
    ];
    if (hasBorder) allClasses = [
        ...allClasses,
        ...borderClasses
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses.join(" "),
        children: children
    });
};
var $c9024e1d6ba4e05c$export$2e2bcd8739ae039 = $c9024e1d6ba4e05c$var$DetailsCard;

});

parcelRegister("eEtn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1026f269e3f665c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f1026f269e3f665c$var$DetailsCardInner = ({ children: children, className: className, width: width = "w-2/3" })=>{
    const defaultClasses = [
        "flex-1",
        "flex",
        "flex-col",
        "sm:flex-row",
        "mb-2",
        "text-center",
        "sm:text-left",
        "sm:w-full",
        `md:${width}`,
        "md:mb-0",
        "md:mr-4",
        "items-center"
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: children
    });
};
var $f1026f269e3f665c$export$2e2bcd8739ae039 = $f1026f269e3f665c$var$DetailsCardInner;

});

parcelRegister("3Rc9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $803c38ce6cf9ac66$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $803c38ce6cf9ac66$var$DetailsCardRight = (props)=>{
    const defaultClasses = [
        "flex",
        "flex-wrap",
        "justify-center",
        "lg:justify-end",
        "flex-col",
        "mb-2",
        "md:w-1/3 lg:w-1/4"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: props.children
    });
};
var $803c38ce6cf9ac66$export$2e2bcd8739ae039 = $803c38ce6cf9ac66$var$DetailsCardRight;

});

parcelRegister("g91zf", function(module, exports) {

$parcel$export(module.exports, "default", () => $880805838ddb4122$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $880805838ddb4122$var$DetailsCardWithNested = ({ children: children, className: className, isDark: isDark = false, noBorder: noBorder })=>{
    const defaultClasses = [
        "flex",
        "flex-col",
        "mb-2",
        "rounded-md",
        "p-4",
        {
            "border border-ch-gray-400": !noBorder
        }
    ];
    const backgroundColourClass = isDark ? "bg-ch-gray-300" : "bg-white";
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        backgroundColourClass,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: children
    });
};
var $880805838ddb4122$export$2e2bcd8739ae039 = $880805838ddb4122$var$DetailsCardWithNested;

});

parcelRegister("3QK3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $f871ea5368030a72$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7hl6H = parcelRequire("7hl6H");

var $8xDhD = parcelRequire("8xDhD");
const $f871ea5368030a72$var$MeetingDateTime = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const startDate = new Date(props.startDate);
    const endDate = new Date(props.endDate);
    const secondsDuration = (0, $8xDhD.default)(endDate, startDate);
    const duration = {
        minutes: Math.floor(secondsDuration / 60),
        hours: Math.floor(secondsDuration / 60 / 60)
    };
    const hourLabel = t("hour"), hoursLabel = t("hours"), minLabel = t("min");
    const getMinText = (hours, minutes)=>{
        const minLeft = minutes - Math.floor(hours) * 60;
        return minLeft > 0 ? ` ${minLeft} ${minLabel}` : "";
    };
    const hourText = (hours)=>{
        hours = Math.floor(hours);
        return hours > 1 ? `${hours} ${hoursLabel}` : `1 ${hourLabel}`;
    };
    let durationText = "";
    if (duration.hours < 1) durationText = `${getMinText(0, duration.minutes).trim()}`;
    else durationText = `${hourText(duration.hours)}${getMinText(duration.hours, duration.minutes)}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                utcTime: props.startDate
            }),
            "\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    "(",
                    durationText,
                    ")"
                ]
            })
        ]
    });
};
var $f871ea5368030a72$export$2e2bcd8739ae039 = $f871ea5368030a72$var$MeetingDateTime;

});

parcelRegister("5wJjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0731f3bb0449371$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8xDhD = parcelRequire("8xDhD");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $c0731f3bb0449371$var$MeetingTimeToStart = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const calculateTimeLeft = (startDate, endDate)=>{
        const timeLeftSeconds = (0, $8xDhD.default)(startDate, endDate);
        if (timeLeftSeconds < 0) return `0 ${t("minutes")}`;
        const days = Math.floor(timeLeftSeconds / 60 / 60 / 24);
        const hours = Math.floor(timeLeftSeconds / 60 / 60) - days * 24;
        const minutes = Math.round(timeLeftSeconds / 60) - days * 1440 - hours * 60;
        let dayText = "";
        if (days >= 1) dayText = days + " " + t(days > 1 ? "days" : "day");
        let hourText = "";
        if (hours >= 1) hourText = hours + " " + t(hours > 1 ? "hours" : "hour");
        let minuteText = "";
        if (minutes > 0) minuteText = minutes + " " + t(minutes > 1 ? "minutes" : "minute");
        if (dayText !== "") {
            dayText;
            const andText = dayText !== "" && hourText !== "" ? ` ${t("and")} ` : "";
            return dayText + andText + hourText;
        }
        const andText = hourText !== "" && minuteText !== "" ? ` ${t("and")} ` : "";
        return hourText + andText + minuteText;
    };
    const startDate = new Date(props.startDate);
    const now = new Date();
    const timeLeft = calculateTimeLeft(startDate, now);
    const content = `${t("meeting:meetingDue")} ${timeLeft}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: content
    });
};
var $c0731f3bb0449371$export$2e2bcd8739ae039 = $c0731f3bb0449371$var$MeetingTimeToStart;

});

parcelRegister("c41te", function(module, exports) {

$parcel$export(module.exports, "createMeetingCaseAssetAction", () => $5c920b18dcc88d4b$export$ac7d0ef878a93ed8);
$parcel$export(module.exports, "createAllMeetingCaseAssetsAction", () => $5c920b18dcc88d4b$export$aa9ef772719ebf89);
$parcel$export(module.exports, "deleteMeetingCaseAssetAction", () => $5c920b18dcc88d4b$export$d6b4e79b1ab4d78a);

var $b9HAQ = parcelRequire("b9HAQ");
const $5c920b18dcc88d4b$export$ac7d0ef878a93ed8 = (meetingCaseId, caseAssetId)=>{
    return {
        type: (0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_MEETING_CASE_ASSET_ASYNC_PENDING,
        payload: {
            meetingCaseId: meetingCaseId,
            caseAssetId: caseAssetId
        }
    };
};
const $5c920b18dcc88d4b$export$aa9ef772719ebf89 = (meetingCaseId)=>{
    return {
        type: (0, $b9HAQ.MeetingCaseAssetsActionTypes).CREATE_ALL_MEETING_CASE_ASSETS_ASYNC_PENDING,
        payload: {
            meetingCaseId: meetingCaseId
        }
    };
};
const $5c920b18dcc88d4b$export$d6b4e79b1ab4d78a = (meetingCaseId, meetingCaseAssetId)=>{
    return {
        type: (0, $b9HAQ.MeetingCaseAssetsActionTypes).DELETE_MEETING_CASE_ASSET_ASYNC_PENDING,
        payload: {
            meetingCaseId: meetingCaseId,
            meetingCaseAssetId: meetingCaseAssetId
        }
    };
};

});

parcelRegister("2AKZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e2322887244fbd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $f1q41 = parcelRequire("f1q41");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");

var $4VtCQ = parcelRequire("4VtCQ");

var $1trOJ = parcelRequire("1trOJ");

var $3UgKa = parcelRequire("3UgKa");
const $56e2322887244fbd$var$SelectCaseAssetListItem = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, {
            meetingCaseId: props.meetingCaseId
        }));
    if (!asset) return null;
    if (!meetingCase) return null;
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponentType];
    const clickAction = (0, $hVO2M.clickableComponentAction)(props.action, assetComponentType);
    const meetingCaseAsset = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(meetingCase.meetingCaseAssets, (meetingCaseAsset)=>meetingCaseAsset.caseAssetId == props.assetId);
    const renderButton = ()=>meetingCaseAsset ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1trOJ.default), {
            meetingCaseAssetId: meetingCaseAsset.id,
            meetingCaseId: props.meetingCaseId,
            disabled: !meetingCaseAsset.permissions.canDelete
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3UgKa.default), {
            assetId: props.assetId,
            meetingCaseId: props.meetingCaseId
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "mb-1",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
            ...props,
            action: clickAction,
            noAction: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-wrap content-top h-8 ml-2 mt-1 justify-contents-end",
                children: renderButton()
            })
        })
    });
};
var $56e2322887244fbd$export$2e2bcd8739ae039 = $56e2322887244fbd$var$SelectCaseAssetListItem;

});
parcelRegister("1trOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $303f4486de6df6db$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $c41te = parcelRequire("c41te");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");
const $303f4486de6df6db$var$RemoveMeetingCaseAssetButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [clicked, setClicked] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const removeMeetingCaseAsset = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (props.disabled) return;
        if (!clicked) {
            setClicked(true);
            dispatch((0, $c41te.deleteMeetingCaseAssetAction)(props.meetingCaseId, props.meetingCaseAssetId));
        }
    };
    const variant = props.disabled ? (0, $jF0Xa.StyleVariants).GRAY : (0, $jF0Xa.StyleVariants).ORANGE;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: removeMeetingCaseAsset,
        isChunky: false,
        variant: variant,
        isDisabled: props.disabled,
        children: t("case:deselectAsset")
    });
};
var $303f4486de6df6db$export$2e2bcd8739ae039 = $303f4486de6df6db$var$RemoveMeetingCaseAssetButton;

});

parcelRegister("3UgKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0fcf8ece7c4140c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $c41te = parcelRequire("c41te");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");
const $c0fcf8ece7c4140c$var$AddMeetingCaseAssetButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [clicked, setClicked] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const addTheAsset = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (!clicked) {
            setClicked(true);
            dispatch((0, $c41te.createMeetingCaseAssetAction)(props.meetingCaseId, props.assetId));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: addTheAsset,
        isChunky: false,
        variant: (0, $jF0Xa.StyleVariants).BLUE,
        className: "h-8",
        children: t("case:selectAsset")
    });
};
var $c0fcf8ece7c4140c$export$2e2bcd8739ae039 = $c0fcf8ece7c4140c$var$AddMeetingCaseAssetButton;

});



parcelRegister("hgRGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18ba6527149fbcc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aEgqS = parcelRequire("aEgqS");

var $lxTgp = parcelRequire("lxTgp");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");
const $a18ba6527149fbcc$var$CaseRadiologyViewer = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const [targetUrl, setTargetUrl] = (0, $acw62.useState)(null);
    const link = asset?.asset;
    const fetchTargetUrl = async ()=>{
        // we swap the link on the radiology link, which points at our server, for a
        // url that points at Idonia, which we then load in the iframe
        if (!link) return;
        const { data: data } = await (0, $5s7Tw.default).get(link.link, (0, $1zizz.withAuthHeader)());
        setTargetUrl(data.link);
    };
    (0, $acw62.useEffect)(()=>{
        fetchTargetUrl();
    }, [
        props.assetId
    ]);
    if (!link) return null;
    if (!targetUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center justify-center h-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
        className: "w-full h-full",
        src: targetUrl
    });
};
var $a18ba6527149fbcc$export$2e2bcd8739ae039 = $a18ba6527149fbcc$var$CaseRadiologyViewer;

});


parcelRegister("3FWaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $58df7bb42413c274$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6gEUE = parcelRequire("6gEUE");

var $8ra4f = parcelRequire("8ra4f");

var $1p6nT = parcelRequire("1p6nT");

var $kYOLX = parcelRequire("kYOLX");

var $jpKnx = parcelRequire("jpKnx");

var $j0qQC = parcelRequire("j0qQC");

var $88nWC = parcelRequire("88nWC");

var $dQiiy = parcelRequire("dQiiy");

var $kN4w7 = parcelRequire("kN4w7");

var $e6fnW = parcelRequire("e6fnW");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");
const $58df7bb42413c274$var$LiveMeetingSharedViewAssetsObserver = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const selectedAssetId = (0, $iD0SF.useSelector)((0, $6gEUE.getLiveMeetingSharedViewSelectedAssetId));
    const selectedAsset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, {
            assetId: selectedAssetId
        }));
    const selectedAssetTypeFilters = (0, $iD0SF.useSelector)((0, $6gEUE.getLiveMeetingSharedViewSelectedAssetTypeFilters));
    const caseStage = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).caseStage;
    const users = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getMeetingUsersWithConfigAsArray)(state, props));
    const renderAssetList = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex mb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "pt-1",
                        children: t("liveMeeting:sharedViewAssetsObserverInstructions")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6fnW.default), {
                        assetTypeFilters: selectedAssetTypeFilters
                    })
                })
            ]
        });
    const selectedAssetUsesViewer = (0, $hVO2M.doesAssetUseViewer)(selectedAsset);
    const assetViewer = ()=>{
        if (!selectedAssetId) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex mb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1p6nT.default), {
                        assetId: selectedAssetId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kYOLX.default), {
                        assetId: selectedAssetId,
                        assetTypeFilters: selectedAssetTypeFilters
                    })
                })
            ]
        });
    };
    const renderConsentList = ()=>{
        if (caseStage == (0, $j0qQC.CaseStage).DEFERRING) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88nWC.default), {
            users: users,
            readOnly: true
        });
    };
    const renderRecommendationArea = ()=>{
        // TODO: this should be moved to a separate componnent, a parent of this component, which switches based on stage
        // I'm leaving it for now though, as the PR for this change is big enough as it is.
        // But if you come across this and wonder why it's here, you know that I agree that it shouldn't be.
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex flex-col flex-1 p-2 overflow-y-auto",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "h-full p-2 rounded-md mt-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpKnx.default), {
                        meetingId: props.meetingId,
                        readOnly: true
                    }),
                    renderConsentList()
                ]
            })
        });
    };
    const decideWhatToRender = ()=>{
        if (caseStage != (0, $j0qQC.CaseStage).PRESENTING) return renderRecommendationArea();
        if (selectedAssetUsesViewer) return assetViewer();
        return renderAssetList();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-1 overflow-hidden",
        children: decideWhatToRender()
    });
};
var $58df7bb42413c274$export$2e2bcd8739ae039 = $58df7bb42413c274$var$LiveMeetingSharedViewAssetsObserver;

});
parcelRegister("kYOLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff4b61d11c6cbdfd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $7twpo = parcelRequire("7twpo");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");

var $bw1cx = parcelRequire("bw1cx");

var $2WUK8 = parcelRequire("2WUK8");

var $dQiiy = parcelRequire("dQiiy");
const $ff4b61d11c6cbdfd$var$LiveMeetingSharedViewAssetObserverViewer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const pdfState = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).sharedPdfState;
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:assetNotFound")
    });
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const componentLookup = {
        [(0, $7twpo.AssetComponentTypes).Pdf]: (0, $bw1cx.default),
        [(0, $7twpo.AssetComponentTypes).Form]: (0, $bw1cx.default),
        [(0, $7twpo.AssetComponentTypes).CaseReport]: (0, $bw1cx.default),
        [(0, $7twpo.AssetComponentTypes).Image]: (0, $2WUK8.default)
    };
    const AssetViewer = componentLookup[assetComponetType];
    if (!AssetViewer) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:couldNotDisplayAsset")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(AssetViewer, {
        assetId: props.assetId,
        assetTypeFilters: props.assetTypeFilters,
        rotation: pdfState.rotation,
        hideRotateButton: true
    });
};
var $ff4b61d11c6cbdfd$export$2e2bcd8739ae039 = $ff4b61d11c6cbdfd$var$LiveMeetingSharedViewAssetObserverViewer;

});
parcelRegister("2WUK8", function(module, exports) {

$parcel$export(module.exports, "default", () => $89cd64b35e55429a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lxTgp = parcelRequire("lxTgp");

var $aEgqS = parcelRequire("aEgqS");

var $1HMOR = parcelRequire("1HMOR");
const $89cd64b35e55429a$var$LiveMeetingSharedViewImageViewerObserver = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const image = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1HMOR.default), {
        imageSrc: image.path
    });
};
var $89cd64b35e55429a$export$2e2bcd8739ae039 = $89cd64b35e55429a$var$LiveMeetingSharedViewImageViewerObserver;

});
parcelRegister("1HMOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb58ccccd2c08ad$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6gEUE = parcelRequire("6gEUE");

var $5QIbQ = parcelRequire("5QIbQ");
const $2fb58ccccd2c08ad$var$ImageZoomObserver = (props)=>{
    const sharedImageZoomState = (0, $iD0SF.useSelector)((0, $6gEUE.getLiveMeetingSharedImageZoomState));
    const imageRef = (0, $acw62.useRef)(null);
    const [pos, setPos] = (0, $acw62.useState)({
        x: 0,
        y: 0
    });
    (0, $acw62.useEffect)(()=>{
        if (!sharedImageZoomState) return;
        if (imageRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            setPos({
                x: sharedImageZoomState.posX * rect.width,
                y: sharedImageZoomState.posY * rect.height
            });
        }
    }, [
        imageRef.current,
        props
    ]);
    if (!sharedImageZoomState) return null;
    const attr = {
        zoom: sharedImageZoomState.zoom,
        imageSrc: props.imageSrc,
        posX: pos.x,
        posY: pos.y,
        imageRef: imageRef
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5QIbQ.default), {
        ...attr
    });
};
var $2fb58ccccd2c08ad$export$2e2bcd8739ae039 = $2fb58ccccd2c08ad$var$ImageZoomObserver;

});



parcelRegister("e6fnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65db7dacf7076952$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lOYBW = parcelRequire("lOYBW");

var $3mOhS = parcelRequire("3mOhS");
const $65db7dacf7076952$var$LiveMeetingAssetListObserver = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case",
        "liveMeeting",
        "shared"
    ]);
    const selectedMeetingCase = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCase));
    const hoveredAssetId = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig.sharedViewHoveredAssetId);
    const selectedAssetId = (0, $iD0SF.useSelector)((state)=>state.liveMeetingConfig.sharedViewSelectedAssetId);
    if (!selectedMeetingCase?.meetingCaseAssets?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-center text-ch-blue-alt-400",
        children: t("case:noAssets")
    });
    if (!selectedMeetingCase?.case) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: selectedMeetingCase?.meetingCaseAssets.map((meetingCaseAsset)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOYBW.default), {
                    assetTypeFilters: props.assetTypeFilters,
                    assetId: meetingCaseAsset.caseAssetId,
                    caseId: selectedMeetingCase.case,
                    isHovered: hoveredAssetId == meetingCaseAsset.caseAssetId,
                    isSelected: selectedAssetId == meetingCaseAsset.caseAssetId,
                    noAction: true
                }, meetingCaseAsset.caseAssetId);
            })
        })
    });
};
var $65db7dacf7076952$export$2e2bcd8739ae039 = $65db7dacf7076952$var$LiveMeetingAssetListObserver;

});



parcelRegister("iHApv", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeac9c9832535216$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $j0qQC = parcelRequire("j0qQC");

var $ffLrB = parcelRequire("ffLrB");

var $4Hi7B = parcelRequire("4Hi7B");

var $kQILj = parcelRequire("kQILj");

var $i3W0f = parcelRequire("i3W0f");

var $6u78b = parcelRequire("6u78b");

var $dQiiy = parcelRequire("dQiiy");
const $eeac9c9832535216$var$LiveMeetingYourView = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const selectedYourViewTab = (0, $iD0SF.useSelector)((0, $kQILj.getSelectedYourViewTab));
    const caseStage = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).caseStage;
    const decideWhatToRender = ()=>{
        if (caseStage == (0, $j0qQC.CaseStage).APPROVING) return renderConsentForm();
        else if (selectedYourViewTab === (0, $j0qQC.YourViewTabs).YOUR_VIEW) return renderYourView();
    };
    const renderConsentForm = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "h-full"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "bg-ch-blue-200 p-2",
                    children: t("liveMeeting:yourConsent")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6u78b.default), {
                    meetingId: props.meetingId
                })
            ]
        });
    };
    const renderYourView = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "h-full"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "bg-ch-blue-200 p-2",
                    children: t("liveMeeting:yourView")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i3W0f.default), {
                    meetingId: props.meetingId
                })
            ]
        });
    };
    const renderUsersView = ()=>{
        // We always need to render the users view, as at the moment, the
        // WebRTC streams are tied to them. I'm not sure there's a way around that.
        const showUsersView = selectedYourViewTab === (0, $j0qQC.YourViewTabs).USERS_VIEW && caseStage != (0, $j0qQC.CaseStage).APPROVING;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "h-full", {
                "hidden": !showUsersView
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between items-center bg-ch-blue-200 p-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: t("liveMeeting:users")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Hi7B.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-2 overflow-y-auto w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffLrB.default), {
                        meetingId: props.meetingId
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full",
        children: [
            decideWhatToRender(),
            renderUsersView()
        ]
    });
};
var $eeac9c9832535216$export$2e2bcd8739ae039 = $eeac9c9832535216$var$LiveMeetingYourView;

});
parcelRegister("ffLrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f8fb278147cbec$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $j0qQC = parcelRequire("j0qQC");

var $dvFye = parcelRequire("dvFye");

var $b6GDL = parcelRequire("b6GDL");

var $kQILj = parcelRequire("kQILj");

var $f1q41 = parcelRequire("f1q41");

var $kN4w7 = parcelRequire("kN4w7");
const $a1f8fb278147cbec$var$LiveMeetingUsersView = (props)=>{
    // this is done in this way (ie, setting components to hidden, rather then not
    // rendering them) because we must always render the grid element, in order to
    // subsribe to the WebRTC streams that are tied to them
    const selectedUsersViewTab = (0, $iD0SF.useSelector)((0, $kQILj.getSelectedUserViewTab));
    const users = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getMeetingUsersWithConfig)(state, props));
    const sortedUserIds = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(users, [
        (u)=>!u.config?.isOnline,
        (u)=>!u.config?.isPresent,
        "lastName",
        "firstName"
    ]).filter((u)=>u.activeInCurrentTenant).map((u)=>u.id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: selectedUsersViewTab == (0, $j0qQC.UsersViewTabs).GRID ? "" : "hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6GDL.default), {
                    userIds: sortedUserIds
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: selectedUsersViewTab == (0, $j0qQC.UsersViewTabs).LIST ? "" : "hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dvFye.default), {
                    userIds: sortedUserIds
                })
            })
        ]
    });
};
var $a1f8fb278147cbec$export$2e2bcd8739ae039 = $a1f8fb278147cbec$var$LiveMeetingUsersView;

});
parcelRegister("dvFye", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ee499727dd5b6f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $928oB = parcelRequire("928oB");
const $b9ee499727dd5b6f$var$LiveMeetingUserList = ({ userIds: userIds })=>{
    if (!userIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "No users"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: userIds.map((userId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $928oB.default), {
                userId: userId
            }, userId))
    });
};
var $b9ee499727dd5b6f$export$2e2bcd8739ae039 = $b9ee499727dd5b6f$var$LiveMeetingUserList;

});
parcelRegister("928oB", function(module, exports) {

$parcel$export(module.exports, "default", () => $899d8b7eb1aafecd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6t04b = parcelRequire("6t04b");

var $gJ54A = parcelRequire("gJ54A");

var $gtkc6 = parcelRequire("gtkc6");

var $fsmRZ = parcelRequire("fsmRZ");

var $kN4w7 = parcelRequire("kN4w7");

var $47nsi = parcelRequire("47nsi");

var $5KP66 = parcelRequire("5KP66");
const $899d8b7eb1aafecd$var$LiveMeetingUserListItem = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "bg-ch-gray-200 mb-1 p-2 rounded-md",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJ54A.default), {
                            userId: props.userId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mr-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                firstName: user.firstName,
                                lastName: user.lastName,
                                professionalTitle: user.professionalTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "text-sm font-thin uppercase",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fsmRZ.default), {
                                userId: props.userId
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47nsi.default), {
                            userId: props.userId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5KP66.default), {
                            userId: props.userId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtkc6.default), {
                    userId: props.userId
                })
            ]
        })
    });
};
var $899d8b7eb1aafecd$export$2e2bcd8739ae039 = $899d8b7eb1aafecd$var$LiveMeetingUserListItem;

});
parcelRegister("gtkc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10360620e6b1b97$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("jitSV");
var $80TYb = parcelRequire("80TYb");
var $3NuIO = parcelRequire("3NuIO");

var $kN4w7 = parcelRequire("kN4w7");

var $6lvMC = parcelRequire("6lvMC");

var $rDKvs = parcelRequire("rDKvs");
const $a10360620e6b1b97$var$LiveMeetingUserRoleControls = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserWithConfig));
    const onHandoverScribeControl = (userId)=>dispatch((0, $rDKvs.scribeTransferAction)(userId));
    const onHandoverPresenterControl = (userId)=>dispatch((0, $rDKvs.presenterTransferAction)(userId));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const roleActiveClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
        "text-ch-gray-600": !props.isOverlay,
        "text-white": props.isOverlay
    });
    const roleTransferableClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-ch-gray-500", {
        "hover:text-ch-gray-600": !props.isOverlay,
        "hover:text-white": props.isOverlay
    });
    if (!user.config || !currentUser.config) return null;
    const renderScribeControl = ()=>{
        if (!user.config?.isOnline) return null;
        if (user.config?.isScribe) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: roleActiveClassNames,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3NuIO.default), {
                className: "fill-current w-6 h-6",
                title: t("user:scribe")
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: "#",
            className: roleTransferableClassNames,
            onClick: ()=>onHandoverScribeControl(props.userId),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3NuIO.default), {
                className: "fill-current w-6 h-6",
                title: t("liveMeeting:handoverScribeControl")
            })
        });
    };
    const renderPresenterControl = ()=>{
        if (!user.config?.isOnline) return null;
        if (user.config?.isPresenter) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: roleActiveClassNames,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80TYb.default), {
                className: "fill-current w-6 h-6",
                title: t("user:presenter")
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: "#",
            className: roleTransferableClassNames,
            onClick: ()=>onHandoverPresenterControl(props.userId),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80TYb.default), {
                className: "fill-current w-6 h-6",
                title: t("liveMeeting:handoverPresenterControl")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "ml-2",
                children: renderPresenterControl()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "ml-2",
                children: renderScribeControl()
            })
        ]
    });
};
var $a10360620e6b1b97$export$2e2bcd8739ae039 = $a10360620e6b1b97$var$LiveMeetingUserRoleControls;

});

parcelRegister("fsmRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab51079d96ef1e58$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $kN4w7 = parcelRequire("kN4w7");
const $ab51079d96ef1e58$var$TextCoordinatorUser = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    if (!user.config?.isCoordinator) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "uppercase",
        children: [
            "(",
            t("user:coordinator"),
            ")"
        ]
    });
};
var $ab51079d96ef1e58$export$2e2bcd8739ae039 = $ab51079d96ef1e58$var$TextCoordinatorUser;

});

parcelRegister("47nsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1aac15f10cae09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $kN4w7 = parcelRequire("kN4w7");
parcelRequire("jitSV");
var $9rcVu = parcelRequire("9rcVu");
var $h8MLf = parcelRequire("h8MLf");
const $0d1aac15f10cae09$var$LiveMeetingUserMicrophoneStatus = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    const isSharingAudio = user.config?.isSharingAudio;
    if (!user.config?.isOnline) return null;
    if (isSharingAudio) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8MLf.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-4", "h-4", "mx-1", "rounded-full", "text-ch-blue-500")
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9rcVu.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-4", "h-4", "mx-1", "rounded-full", "text-ch-red-500")
    });
};
var $0d1aac15f10cae09$export$2e2bcd8739ae039 = $0d1aac15f10cae09$var$LiveMeetingUserMicrophoneStatus;

});

parcelRegister("5KP66", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ac9ba5a531e1f3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $kN4w7 = parcelRequire("kN4w7");

var $7eN5N = parcelRequire("7eN5N");
const $d8ac9ba5a531e1f3$var$LiveMeetingUserMicrophoneStatus = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, props));
    if (!user.config?.isOnline) return null;
    if (user.config?.isSharingVideo) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eN5N.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-4", "h-4", "mx-1", "rounded-full", "text-ch-blue-500")
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eN5N.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("w-4", "h-4", "mx-1", "rounded-full", "text-ch-red-500")
    });
};
var $d8ac9ba5a531e1f3$export$2e2bcd8739ae039 = $d8ac9ba5a531e1f3$var$LiveMeetingUserMicrophoneStatus;

});



parcelRegister("b6GDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72124e7b96f31d14$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dEe9Z = parcelRequire("dEe9Z");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $dQiiy = parcelRequire("dQiiy");
const $72124e7b96f31d14$var$LiveMeetingUserGrid = ({ userIds: userIds })=>{
    const meetingConfig = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig));
    if (!userIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "No users"
    });
    const sortedUserList = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(userIds, (userId)=>userId != meetingConfig.presenterId);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: "flex flex-wrap -mx-2",
        children: sortedUserList.map((userId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $dEe9Z.default), {
                userId: userId
            }, userId))
    });
};
var $72124e7b96f31d14$export$2e2bcd8739ae039 = $72124e7b96f31d14$var$LiveMeetingUserGrid;

});
parcelRegister("dEe9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a12331a6b0b1e33$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $xQehV = parcelRequire("xQehV");

var $9d16U = parcelRequire("9d16U");

var $gJ54A = parcelRequire("gJ54A");

var $6t04b = parcelRequire("6t04b");

var $fsmRZ = parcelRequire("fsmRZ");

var $gtkc6 = parcelRequire("gtkc6");

var $kN4w7 = parcelRequire("kN4w7");

var $6lvMC = parcelRequire("6lvMC");

var $47nsi = parcelRequire("47nsi");

var $dQiiy = parcelRequire("dQiiy");
const $8a12331a6b0b1e33$var$LiveMeetingUserGridItem = ({ userId: userId })=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getUserWithConfigById)(state, {
            userId: userId
        }));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const speakers = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig)).speaking;
    const subscriberOptions = currentUser.id == userId ? (0, $xQehV.currentUserStreamSubscriberOptions) : (0, $xQehV.userStreamSubscriberOptions);
    const border = speakers[user.id] ? "border-solid border-2 rounded border-ch-blue-500" : "border-solid border-2 rounded border-current";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "h-40 xl:h-56 mb-2 px-1 w-full overflow-hidden sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `relative bg-ch-gray-600 w-full h-full z-0 ${border}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "absolute w-full h-full z-10 ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "absolute p-2 left-0 top-0 flex",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJ54A.default), {
                                    userId: userId
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47nsi.default), {
                                    userId: userId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "absolute p-2 right-0 top-0",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtkc6.default), {
                                userId: userId,
                                isOverlay: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "absolute p-2 left-0 bottom-0 text-white",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "mr-1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                        firstName: user.firstName,
                                        lastName: user.lastName,
                                        professionalTitle: user.professionalTitle
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "text-sm font-thin uppercase",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fsmRZ.default), {
                                        userId: userId
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "absolute w-full h-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d16U.default), {
                        userId: user.id,
                        subscriberOptions: subscriberOptions
                    })
                })
            ]
        })
    });
};
var $8a12331a6b0b1e33$export$2e2bcd8739ae039 = $8a12331a6b0b1e33$var$LiveMeetingUserGridItem;

});



parcelRegister("4Hi7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $7226e6d867f9eafe$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $j0qQC = parcelRequire("j0qQC");
parcelRequire("jitSV");
var $cunZf = parcelRequire("cunZf");
var $OPxe7 = parcelRequire("OPxe7");

var $rDKvs = parcelRequire("rDKvs");

var $kQILj = parcelRequire("kQILj");
const $7226e6d867f9eafe$var$LiveMeetingUsersViewSwitch = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const selectedUsersViewTab = (0, $iD0SF.useSelector)((0, $kQILj.getSelectedUserViewTab));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onChangeUsersViewTab = (selectedTab)=>dispatch((0, $rDKvs.changeUsersViewTabAction)(selectedTab));
    const renderUsersViewListTab = ()=>{
        const isSelected = selectedUsersViewTab == (0, $j0qQC.UsersViewTabs).LIST;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: "#",
            onClick: ()=>onChangeUsersViewTab((0, $j0qQC.UsersViewTabs).LIST),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                "text-ch-blue-500": isSelected,
                "text-white": !isSelected
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OPxe7.default), {
                className: "fill-current h-6",
                title: t("liveMeeting:usersList")
            })
        });
    };
    const renderUsersViewGridTab = ()=>{
        const isSelected = selectedUsersViewTab == (0, $j0qQC.UsersViewTabs).GRID;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: "#",
            onClick: ()=>onChangeUsersViewTab((0, $j0qQC.UsersViewTabs).GRID),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                "text-ch-blue-500": isSelected,
                "text-white": !isSelected
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cunZf.default), {
                className: "fill-current h-6",
                title: t("liveMeeting:userGrid")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mr-3",
                children: renderUsersViewListTab()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: renderUsersViewGridTab()
            })
        ]
    });
};
var $7226e6d867f9eafe$export$2e2bcd8739ae039 = $7226e6d867f9eafe$var$LiveMeetingUsersViewSwitch;

});

parcelRegister("i3W0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1abfb2c15fd492d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $kQILj = parcelRequire("kQILj");

var $rDKvs = parcelRequire("rDKvs");

var $13yNX = parcelRequire("13yNX");

var $8ra4f = parcelRequire("8ra4f");

var $fp9J8 = parcelRequire("fp9J8");

var $1p6nT = parcelRequire("1p6nT");

var $4bQ8f = parcelRequire("4bQ8f");

var $leGkV = parcelRequire("leGkV");

var $bdmN8 = parcelRequire("bdmN8");

var $3mOhS = parcelRequire("3mOhS");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");
const $b1abfb2c15fd492d$export$72c017ba30f38c43 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $b1abfb2c15fd492d$var$LiveMeetingYourViewAssets = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const [assetTypeFilters, setAssetTypeFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const isAssetListOpen = (0, $iD0SF.useSelector)((0, $kQILj.getIsYourViewAssetListOpen));
    const selectedAssetId = (0, $iD0SF.useSelector)((0, $kQILj.getYourViewSelectedAssetId));
    const selectedMeetingCaseId = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseId));
    const selectedAsset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, {
            assetId: selectedAssetId
        }));
    const meetingCaseId = (0, $iD0SF.useSelector)((0, $3mOhS.getSelectedMeetingCaseId));
    const clearYourViewSelectedAsset = ()=>{
        dispatch((0, $rDKvs.updateYourViewSelectedAssetAction)(null));
    };
    (0, $acw62.useEffect)(clearYourViewSelectedAsset, [
        selectedMeetingCaseId
    ]);
    const renderAssetSelect = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            hasDarkBackground: isAssetListOpen,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-between mb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13yNX.default), {
                        openText: t("liveMeeting:selectItemToView")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4bQ8f.default), {
                        selectAction: (0, $rDKvs.updateYourViewSelectedAssetAction),
                        assetTypeFilters: assetTypeFilters,
                        setAssetTypeFilters: setAssetTypeFilters
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdmN8.default), {
                    meetingId: props.meetingId
                })
            ]
        });
    const renderAssetViewer = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8ra4f.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-end mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1p6nT.default), {
                            assetId: selectedAssetId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fp9J8.default), {
                            clearSelectedAsset: clearYourViewSelectedAsset
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 overflow-y-scroll pr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $leGkV.default), {
                        assetId: selectedAssetId
                    })
                })
            ]
        });
    };
    const selectedAssetUsesViewer = (0, $hVO2M.doesAssetUseViewer)(selectedAsset);
    const renderAssetOrSelect = ()=>{
        if (!meetingCaseId) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p-2 w-full",
            children: t("liveMeeting:yourViewAssetsInstructions")
        });
        if (selectedAsset && selectedAssetUsesViewer) return renderAssetViewer();
        return renderAssetSelect();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-1 overflow-hidden",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b1abfb2c15fd492d$export$72c017ba30f38c43.Provider, {
            value: assetTypeFilters,
            children: renderAssetOrSelect()
        })
    });
};
var $b1abfb2c15fd492d$export$2e2bcd8739ae039 = $b1abfb2c15fd492d$var$LiveMeetingYourViewAssets;

});
parcelRegister("leGkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $143ba52385248054$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");
const $143ba52385248054$var$LiveMeetingYourViewAssetViewer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const updateYourViewSelectedAsset = (assetId)=>dispatch(updateYourViewSelectedAsset(assetId));
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:assetNotFound")
    });
    const AssetViewer = (0, $hVO2M.lookupLiveMeetingViewerForAsset)(asset);
    if (!AssetViewer) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:couldNotDisplayAsset")
    });
    const viewerProps = {
        assetId: props.assetId,
        onSelectAsset: updateYourViewSelectedAsset
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(AssetViewer, {
        ...viewerProps
    });
};
var $143ba52385248054$export$2e2bcd8739ae039 = $143ba52385248054$var$LiveMeetingYourViewAssetViewer;

});


parcelRegister("6u78b", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd671e78d7f028a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $4KSAX = parcelRequire("4KSAX");

var $rDKvs = parcelRequire("rDKvs");

var $j0qQC = parcelRequire("j0qQC");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
var $8tyXr = parcelRequire("8tyXr");
var $4e1aD = parcelRequire("4e1aD");

var $8g1PZ = parcelRequire("8g1PZ");

var $eTqMc = parcelRequire("eTqMc");

var $aSzjr = parcelRequire("aSzjr");

var $4VtCQ = parcelRequire("4VtCQ");

var $f1q41 = parcelRequire("f1q41");

var $f4qfv = parcelRequire("f4qfv");

var $kYqkq = parcelRequire("kYqkq");

var $6lvMC = parcelRequire("6lvMC");
const $6bd671e78d7f028a$var$LiveMeetingMyConsent = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const _giveConsent = (response, text)=>dispatch((0, $rDKvs.giveConsentAction)(response, text));
    const submitConsent = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce(_giveConsent, 1000, {
        leading: true,
        maxWait: 1500
    }), []);
    const users = (0, $kYqkq.useAppSelector)((state)=>(0, $4VtCQ.getMeetingUsers)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const currentUserId = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUserId));
    const existingConsent = (0, $kYqkq.useAppSelector)((state)=>(0, $f4qfv.getLiveMeetingUserConsent)(state, currentUserId));
    const [response, setResponse] = (0, $acw62.useState)(null);
    const [comment, setComment] = (0, $acw62.useState)(null);
    const [consentFetched, setConsentFetched] = (0, $acw62.useState)(false);
    const pending = response == (0, $j0qQC.ConsentResponse).PENDING || response == undefined;
    const approved = response == (0, $j0qQC.ConsentResponse).APPROVE;
    const rejected = response == (0, $j0qQC.ConsentResponse).REJECT;
    const na = response == (0, $j0qQC.ConsentResponse).NA;
    const baseIconStyle = "fill-current w-6 g-6 lg:w-8 lg:h-8 ml-3";
    const buttonStyle = "group flex cursor-pointer items-center  px-4 py-1 rounded-full m-1 ";
    const buttonClasses = (thisResponse)=>(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(buttonStyle, {
            "bg-ch-blue-alt-500 hover:bg-ch-blue-alt-500 text-ch-gray-200": thisResponse,
            "bg-ch-blue-500 hover:bg-ch-blue-600 text-ch-gray-200": !thisResponse && pending,
            "bg-ch-blue-100 hover:bg-ch-blue-600 hover:text-ch-gray-200": !thisResponse && !pending
        });
    const iconClasses = (thisResponse)=>(0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(baseIconStyle, {
            "text-ch-gray-200": thisResponse,
            "text-ch-gray-200 group-hover:text-current": !thisResponse && pending,
            "text-ch-blue-400 group-hover:text-current": !thisResponse && !pending
        });
    const initialValues = {
        comment: comment ? comment : ""
    };
    (0, $acw62.useEffect)(()=>{
        if (!response) return;
        submitConsent(response, comment);
    }, [
        response,
        comment
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!existingConsent || consentFetched || existingConsent.consentById != currentUserId) return;
        setComment(existingConsent.comment);
        setResponse(existingConsent.response);
        setConsentFetched(true);
    }, [
        existingConsent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-col flex-1 p-2 overflow-scroll md:overflow-auto",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p-2 rounded-md mt-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                onSubmit: (_values, _actions)=>null,
                enableReinitialize: true,
                children: ({ handleBlur: handleBlur, setFieldValue: setFieldValue, values: values, errors: errors, touched: touched })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2 hidden sm:block",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "comment",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                t("shared:yourResponse"),
                                                " (",
                                                t("shared:optional"),
                                                "):"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                        maxLength: 1500,
                                        name: "comment",
                                        onBlur: handleBlur,
                                        users: users,
                                        value: values.comment,
                                        setValue: (body)=>{
                                            setComment(body);
                                            setFieldValue("comment", body);
                                        },
                                        height: 100
                                    }),
                                    pending && comment ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: t("liveMeeting:consentCommentWithoutVote")
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.comment,
                                        isVisible: errors.comment && touched.comment
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-wrap flex-1 space-x-2 lg:space-x-8 justify-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: buttonClasses(approved),
                                        onClick: ()=>setResponse((0, $j0qQC.ConsentResponse).APPROVE),
                                        children: [
                                            t("case:approveRecommendation"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                                                className: iconClasses(approved)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: buttonClasses(rejected),
                                        onClick: ()=>setResponse((0, $j0qQC.ConsentResponse).REJECT),
                                        children: [
                                            t("case:rejectRecommendation"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e1aD.default), {
                                                className: iconClasses(rejected)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: buttonClasses(na),
                                        onClick: ()=>setResponse((0, $j0qQC.ConsentResponse).NA),
                                        children: [
                                            t("shared:na"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8tyXr.default), {
                                                className: iconClasses(na)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};
var $6bd671e78d7f028a$export$2e2bcd8739ae039 = $6bd671e78d7f028a$var$LiveMeetingMyConsent;

});


parcelRegister("6rb7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70156403f69a7f1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kGUIk = parcelRequire("kGUIk");

var $g7GJo = parcelRequire("g7GJo");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $rDKvs = parcelRequire("rDKvs");

var $dyeCj = parcelRequire("dyeCj");

var $dQiiy = parcelRequire("dQiiy");

var $6lvMC = parcelRequire("6lvMC");
const $b70156403f69a7f1$var$WebRTCScreenPublisher = (props)=>{
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const dispatch = (0, $2OPjR.useDispatch)();
    const screenPublisher = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCScreenPublisher));
    const session = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCSession));
    const isScreenShareOn = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCScreenShareIsOn));
    const screenSharePreferCurrentTab = (0, $iD0SF.useSelector)((0, $dyeCj.getWebRTCScreenSharePreferCurrentTab));
    const connection = screenPublisher?.session.connection;
    const [stream, setStream] = (0, $acw62.useState)(null);
    const { presenterId: presenterId } = (0, $iD0SF.useSelector)((0, $dQiiy.getLiveMeetingConfig));
    const currentUserId = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserId));
    const displayUserMessage = (messageKey, type)=>{
        dispatch((0, $arZQw.displayUserMessageAction)({
            messageKey: messageKey,
            type: type
        }));
    };
    const handleStopEvent = (event)=>{
        const userId = (0, $g7GJo.getStreamUserId)(event.stream);
        dispatch((0, $kGUIk.updateWebRTCScreenStreamAction)(null));
        dispatch((0, $rDKvs.toggleIsSharingScreenAction)(userId, false));
    };
    const eventHandlers = {
        streamCreated: (event)=>{
            const userId = (0, $g7GJo.getStreamUserId)(event.stream);
            dispatch((0, $kGUIk.updateWebRTCScreenStreamAction)(event.stream));
            dispatch((0, $rDKvs.toggleIsSharingScreenAction)(userId, true));
        },
        streamDestroyed: handleStopEvent,
        // for some reason, the screen share in the modal (for the idonia viewer)
        // wants the following event handlers defined as well, just the
        // streamDestroyed isn't enough. Perhaps this has to do with the default
        // behaviour is not to propagate this event? I couldn't figure that out easily.
        destroyed: handleStopEvent,
        mediaStopped: handleStopEvent,
        accessDenied: (_event)=>{
            displayUserMessage("webRTCAccessDenied", (0, $jiIfA.UserMessageTypes).ERROR);
        }
    };
    // whenever the user becomes presenter, switch off their screen share
    (0, $acw62.useEffect)(()=>{
        if (!currentUserId && currentUserId != presenterId) return;
        if (stream) stream.getTracks()[0].stop();
        dispatch((0, $kGUIk.updateWebRTCScreenStreamAction)(null));
        dispatch((0, $rDKvs.toggleIsSharingScreenAction)(currentUserId, false));
    }, [
        presenterId
    ]);
    (0, $acw62.useEffect)(()=>{
        // Publish screen to session after connection has been established
        // and if screen share is turned on by user
        if (!session?.connection) return;
        if (isScreenShareOn && !screenPublisher) {
            if (screenSharePreferCurrentTab) {
                // if we want to share the current tab, we have to call getDisplayMedia
                // ourselves (otherwise we could leave it up to OT), and then, when we
                // have a MediaStreamTrack, we can pass that to OT and it will use that.
                //
                // So here, we are just asking for the stream and then setting it in the
                // state, which will trigger an effect hook (see below) to actually
                // trigger the publish screen action.
                navigator.mediaDevices.getDisplayMedia({
                    audio: false,
                    video: {
                        displaySurface: "browser"
                    },
                    preferCurrentTab: true
                }).then(setStream).catch(()=>{
                    displayUserMessage("publishScreenToWebRTCSessionError", (0, $jiIfA.UserMessageTypes).ERROR);
                });
                return;
            }
            // if we are not interested in the current tab, we can just call the
            // publish action and OT will ask for a screen to publish (because
            // videoSource will be set to 'screen').
            dispatch((0, $kGUIk.publishScreenToWebRTCSessionAction)(session, containerRef, props.publisherOptions, eventHandlers));
        } else if (!isScreenShareOn && screenPublisher) dispatch((0, $kGUIk.stopPublishScreenToWebRTCSessionAction)(session, screenPublisher));
    }, [
        session,
        isScreenShareOn
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!stream) return;
        const options = {
            ...props.publisherOptions,
            videoSource: stream.getTracks()[0]
        };
        dispatch((0, $kGUIk.publishScreenToWebRTCSessionAction)(session, containerRef, options, eventHandlers));
    }, [
        stream
    ]);
    (0, $acw62.useEffect)(()=>{
        // If connection to session if destoryed unpublish screen
        // Streams will then in turn be destroyed
        if (!connection) return;
        return ()=>{
            dispatch((0, $kGUIk.stopPublishScreenToWebRTCSessionAction)(session, screenPublisher));
        };
    }, [
        connection
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: containerRef,
        className: "hidden"
    });
};
var $b70156403f69a7f1$export$2e2bcd8739ae039 = $b70156403f69a7f1$var$WebRTCScreenPublisher;

});

parcelRegister("8UrgM", function(module, exports) {

$parcel$export(module.exports, "fetchUsersAsync", () => $8463272e0e0a02c6$export$870cc4a0f49d0ff6);
$parcel$export(module.exports, "fetchAllUsersAsync", () => $8463272e0e0a02c6$export$6d587342da095a8f);

var $cX1nf = parcelRequire("cX1nf");
const $8463272e0e0a02c6$export$870cc4a0f49d0ff6 = (searchQuery)=>{
    return {
        type: (0, $cX1nf.UsersActionTypes).FETCH_USERS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $8463272e0e0a02c6$export$6d587342da095a8f = ()=>{
    return {
        type: (0, $cX1nf.UsersActionTypes).FETCH_ALL_USERS_ASYNC_PENDING
    };
};

});

parcelRegister("2D4mW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6757440e84fea9b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $5AYDs = parcelRequire("5AYDs");

var $4KSAX = parcelRequire("4KSAX");

var $hLZlk = parcelRequire("hLZlk");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $e6757440e84fea9b$var$ChatViewOpenButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    if (props.isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "absolute right-10 bottom-10 z-50",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            onClick: ()=>props.setIsOpen(true),
            className: "flex items-center justify-center w-12 h-12 rounded-full cursor-pointer text-white bg-ch-blue-alt-500 shadow relative",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLZlk.default), {
                    count: chat?.unreadCount,
                    top: "4px"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                    className: "fill-current w-6 h-6",
                    title: t("message:shared:buttons:openChat")
                })
            ]
        })
    });
};
var $e6757440e84fea9b$export$2e2bcd8739ae039 = $e6757440e84fea9b$var$ChatViewOpenButton;

});
parcelRegister("hLZlk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf530b6b8887dbd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $6bf530b6b8887dbd$var$Counter = ({ count: count, top: top = "-3px" })=>{
    if (!count) return null;
    const countText = count < 99 ? count.toString() : "9+";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "absolute right-0 bg-ch-red-500 text-white rounded-full w-5 h-5 text-sm flex justify-center items-center p-2 -mt-2 -mr-2",
        style: {
            top: top
        },
        children: countText
    });
};
var $6bf530b6b8887dbd$export$2e2bcd8739ae039 = $6bf530b6b8887dbd$var$Counter;

});

parcelRegister("fH7G0", function(module, exports) {

$parcel$export(module.exports, "getAllChatIds", () => $391743aebe805c11$export$c807da7619722a8b);
$parcel$export(module.exports, "getChatById", () => $391743aebe805c11$export$badfb08ce901ff0f);
$parcel$export(module.exports, "getMessageById", () => $391743aebe805c11$export$1c0ca0f2ca071590);
$parcel$export(module.exports, "getMessageAssetById", () => $391743aebe805c11$export$feea9958ab0d3b62);
const $391743aebe805c11$export$c807da7619722a8b = (state)=>state.entities.chats.allIds;
const $391743aebe805c11$export$badfb08ce901ff0f = (state, ownProps)=>state.entities.chats.byId[ownProps.chatId];
const $391743aebe805c11$export$1c0ca0f2ca071590 = (state, ownProps)=>state.entities.messages.byId[ownProps.messageId];
const $391743aebe805c11$export$feea9958ab0d3b62 = (state, ownProps)=>state.entities.messageAssets.byId[ownProps.messageAssetId];

});


parcelRegister("9iUtM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1838bc4486e60b06$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $50Djh = parcelRequire("50Djh");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("jitSV");
var $chuvC = parcelRequire("chuvC");
var $5AYDs = parcelRequire("5AYDs");

var $4KSAX = parcelRequire("4KSAX");

var $aEgqS = parcelRequire("aEgqS");

var $h8nTc = parcelRequire("h8nTc");

var $7W17n = parcelRequire("7W17n");
const $1838bc4486e60b06$var$ChatView = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchChat = (chatId)=>dispatch((0, $50Djh.fetchChatAsync)(chatId));
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    (0, $acw62.useEffect)(()=>{
        if (!props.chatId) return;
        fetchChat(props.chatId);
    }, [
        props.chatId
    ]);
    const renderMessageList = ()=>{
        if (!chat) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8nTc.default), {
            chatId: props.chatId
        });
    };
    const renderCloseButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            onClick: ()=>props.setIsOpen(false),
            className: "text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chuvC.default), {
                className: "fill-current w-6 h-6",
                title: t("shared:close")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("hidden", "bg-white", "shadow", "h-full", "w-1/3", "overflow-y-scroll", "absolute", "z-30", "top-0", "right-0", {
            "md:block": props.isOpen
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-1 flex-col h-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center p-4 border-b border-ch-gray-400 relative",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "absolute left-4",
                            children: renderCloseButton()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                                    className: "fill-current w-4 h-4 text-ch-blue-alt-500 mr-2",
                                    title: t("message:meeting:buttons:openChat")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-sm font-semibold",
                                    children: t("message:meeting:title")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1 h-full overflow-hidden",
                    children: renderMessageList()
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p-4 border-t border-ch-gray-400",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7W17n.default), {
                        chatId: props.chatId
                    })
                })
            ]
        })
    });
};
var $1838bc4486e60b06$export$2e2bcd8739ae039 = $1838bc4486e60b06$var$ChatView;

});
parcelRegister("50Djh", function(module, exports) {

$parcel$export(module.exports, "fetchChatAsync", () => $7bc30beaa1014933$export$41ac94d66fa5abc6);
$parcel$export(module.exports, "endChatAsync", () => $7bc30beaa1014933$export$6af52510add45f72);
$parcel$export(module.exports, "toggleMutedChatAsync", () => $7bc30beaa1014933$export$c4883f0f1d5d6537);
$parcel$export(module.exports, "exportChatAsync", () => $7bc30beaa1014933$export$df43f45055190160);
$parcel$export(module.exports, "updateUserIsTyping", () => $7bc30beaa1014933$export$c37f186c17b2fde9);
$parcel$export(module.exports, "fetchChatAssetsAsync", () => $7bc30beaa1014933$export$69b527b529aab52b);
$parcel$export(module.exports, "markChatMessagesAsRead", () => $7bc30beaa1014933$export$2fdfc8b99afc570d);

var $fpLIl = parcelRequire("fpLIl");
const $7bc30beaa1014933$export$41ac94d66fa5abc6 = (chatId)=>{
    return {
        type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASYNC_PENDING,
        payload: chatId
    };
};
const $7bc30beaa1014933$export$6af52510add45f72 = (chatId)=>{
    return {
        type: (0, $fpLIl.ChatActionTypes).END_CHAT_ASYNC_PENDING,
        payload: chatId
    };
};
const $7bc30beaa1014933$export$c4883f0f1d5d6537 = (chatId)=>{
    return {
        type: (0, $fpLIl.ChatActionTypes).TOGGLE_MUTED_CHAT_ASYNC_PENDING,
        payload: chatId
    };
};
const $7bc30beaa1014933$export$df43f45055190160 = (chatId, exportChatData)=>{
    return {
        type: (0, $fpLIl.ChatActionTypes).EXPORT_CHAT_ASYNC_PENDING,
        payload: {
            chatId: chatId,
            exportChatData: exportChatData
        }
    };
};
const $7bc30beaa1014933$export$c37f186c17b2fde9 = (chatId, userId, isTyping)=>{
    return {
        type: (0, $fpLIl.ChatCableActionTypes).UPDATE_USER_IS_TYPING,
        payload: {
            chatId: chatId,
            userId: userId,
            isTyping: isTyping
        },
        meta: {
            isOptimistic: false
        }
    };
};
const $7bc30beaa1014933$export$69b527b529aab52b = (chatId)=>{
    return {
        type: (0, $fpLIl.ChatActionTypes).FETCH_CHAT_ASSETS_ASYNC_PENDING,
        payload: chatId
    };
};
const $7bc30beaa1014933$export$2fdfc8b99afc570d = (chatId)=>{
    return {
        type: (0, $fpLIl.ChatCableActionTypes).MARK_CHAT_MESSAGES_AS_READ,
        payload: {
            chatId: chatId
        }
    };
};

});

parcelRegister("h8nTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2ceb968006413e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Vizq = parcelRequire("9Vizq");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $glc4D = parcelRequire("glc4D");

var $kQILj = parcelRequire("kQILj");

var $9lUNX = parcelRequire("9lUNX");

var $aEgqS = parcelRequire("aEgqS");

var $bHoWy = parcelRequire("bHoWy");

var $4KSAX = parcelRequire("4KSAX");

var $hbtzA = parcelRequire("hbtzA");
const $5d2ceb968006413e$var$MessageList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const selectedChat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getChatMessagesUI)(state));
    const initialSearchQuery = {
        page: 1,
        resultsPerPage: UI.resultsPerPage
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, ()=>(0, $9lUNX.fetchChatMessagesAsync)(props.chatId, searchQuery));
    const messageListContainerRef = (0, $acw62.useRef)(null);
    const hasMore = ()=>{
        if (searchQuery.page < UI.totalPages) return true;
        return false;
    };
    const loadMore = ()=>{
        setSearchQuery({
            page: searchQuery.page + 1
        });
    };
    (0, $acw62.useEffect)(()=>{
        // load enough messages to fill the scrolling area
        if (!selectedChat.messages) return;
        if (hasMore && messageListContainerRef.current.scrollHeight <= messageListContainerRef.current.clientHeight) loadMore();
    }, [
        selectedChat.messages
    ]);
    if (!selectedChat.messages && UI.isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "messageListContainer",
        ref: messageListContainerRef,
        className: "flex h-full overflow-y-scroll flex-col-reverse",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hbtzA.default), {
                chatId: props.chatId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHoWy.default), {
                dataLength: selectedChat.messages?.length || 0,
                next: loadMore,
                className: "flex flex-col-reverse p-4",
                inverse: true,
                hasMore: hasMore(),
                loader: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-center p-10",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {})
                }),
                scrollableTarget: "messageListContainer",
                endMessage: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-center text-ch-gray-400 italic text-sm py-2",
                    children: t("message:index:endOfMessages")
                }),
                children: (selectedChat.messages || []).map((messageId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Vizq.default), {
                        messageId: messageId
                    }, messageId))
            })
        ]
    });
};
var $5d2ceb968006413e$export$2e2bcd8739ae039 = $5d2ceb968006413e$var$MessageList;

});
parcelRegister("9Vizq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cd92be75ea9a51e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $biuvr = parcelRequire("biuvr");

var $6t04b = parcelRequire("6t04b");

var $7hl6H = parcelRequire("7hl6H");

var $deJFV = parcelRequire("deJFV");

var $fH7G0 = parcelRequire("fH7G0");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jitSV");
var $91duj = parcelRequire("91duj");

var $5L9s0 = parcelRequire("5L9s0");

var $49C0p = parcelRequire("49C0p");

var $cXxNn = parcelRequire("cXxNn");
const $6cd92be75ea9a51e$var$MessageListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const message = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const dispatch = (0, $2OPjR.useDispatch)();
    const ref = (0, $acw62.useRef)(null);
    const isVisible = (0, $deJFV.default)(ref);
    const [showReadBy, setShowReadBy] = (0, $acw62.useState)(false);
    if (!message) return null;
    const throttledMarkAsRead = (0, $f1q41.throttle)((messageId)=>dispatch((0, $5L9s0.markMessageAsRead)(messageId)), 1000, {
        trailing: true
    });
    (0, $acw62.useEffect)(()=>{
        if (isVisible && !message.readAt) throttledMarkAsRead(message.id);
    }, [
        isVisible
    ]);
    const isCurrentUser = currentUser.id == message.createdBy.id;
    const renderName = ()=>{
        if (isCurrentUser) return t("message:index:you");
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
            firstName: message.createdBy.firstName,
            lastName: message.createdBy.lastName
        });
    };
    const renderReadIcon = ()=>{
        if (!isCurrentUser) return null;
        if (message.readBy.length <= 1) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            className: "cursor-pointer",
            onClick: ()=>setShowReadBy(!showReadBy),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91duj.default), {
                className: "text-ch-blue-alt-500 w-4 h-4 mr-2"
            })
        });
    };
    const renderReadBy = ()=>{
        if (!showReadBy) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "text-xs italic text-ch-gray-500 mb-1",
            children: [
                t("message:index:seenBy"),
                ":",
                message.readBy.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                        className: "ml-1",
                        firstName: r.firstName,
                        lastName: r.lastName
                    }, r.id))
            ]
        });
    };
    const renderMessage = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("px-4", "py-3", "rounded-md", "text-xs", "relative", {
                "bg-ch-gray-400": !isCurrentUser,
                "text-white": isCurrentUser,
                "bg-ch-blue-alt-500": isCurrentUser
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXxNn.default), {
                    isLeft: !isCurrentUser
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49C0p.default), {
                    messageAssetIds: message.messageAssets
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                        value: message.body,
                        users: null,
                        textColorClass: isCurrentUser ? "text-white" : "text-ch-gray-600"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-col", "max-w-md", "mb-3", {
            "ml-auto": isCurrentUser
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-xs", "mb-1", {
                    "text-right": isCurrentUser
                }),
                children: renderName()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "mb-1", "items-center", {
                    "justify-end": isCurrentUser,
                    "mr-1": isCurrentUser,
                    "ml-1": !isCurrentUser
                }),
                children: [
                    renderReadIcon(),
                    renderMessage()
                ]
            }),
            renderReadBy(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                utcTime: message.createdAt,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-xs", "italic", {
                    "text-right": isCurrentUser
                })
            })
        ]
    });
};
var $6cd92be75ea9a51e$export$2e2bcd8739ae039 = $6cd92be75ea9a51e$var$MessageListItem;

});
parcelRegister("deJFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed6481507b1e559$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 
var $acw62 = parcelRequire("acw62");
const $aed6481507b1e559$var$useOnScreen = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $acw62.useState)(false);
    const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
    (0, $acw62.useEffect)(()=>{
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isIntersecting;
};
var $aed6481507b1e559$export$2e2bcd8739ae039 = $aed6481507b1e559$var$useOnScreen;

});

parcelRegister("5L9s0", function(module, exports) {

$parcel$export(module.exports, "createChatMessageAsync", () => $2e4af11a869abd61$export$a7d3974ad1e9be45);
$parcel$export(module.exports, "markMessageAsRead", () => $2e4af11a869abd61$export$d4c7eca333a816da);

var $fpLIl = parcelRequire("fpLIl");

var $dJ0hQ = parcelRequire("dJ0hQ");
const $2e4af11a869abd61$export$a7d3974ad1e9be45 = (chatId, message)=>{
    return {
        type: (0, $dJ0hQ.ChatMessageActionTypes).CREATE_CHAT_MESSAGE_ASYNC_PENDING,
        payload: {
            chatId: chatId,
            message: message
        }
    };
};
const $2e4af11a869abd61$export$d4c7eca333a816da = (messageId)=>{
    return {
        type: (0, $fpLIl.ChatCableActionTypes).MARK_MESSAGE_AS_READ,
        payload: {
            messageId: messageId
        },
        meta: {
            isOptimistic: false
        }
    };
};

});

parcelRegister("49C0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7767e231d6aa3e1b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1NxYO = parcelRequire("1NxYO");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $8lxS4 = parcelRequire("8lxS4");
const $7767e231d6aa3e1b$var$MessageAssetList = (props)=>{
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [selectedAssetId, setSelectedAssetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const openModal = (selectedAssetId)=>{
        setSelectedAssetId(selectedAssetId);
        setIsModalOpen(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: isModalOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8lxS4.default), {
                        messageAssetId: selectedAssetId
                    })
                })
            }),
            props.messageAssetIds.map((messageAssetId)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1NxYO.default), {
                    messageAssetId: messageAssetId,
                    openAssetModal: openModal
                }, messageAssetId);
            })
        ]
    });
};
var $7767e231d6aa3e1b$export$2e2bcd8739ae039 = $7767e231d6aa3e1b$var$MessageAssetList;

});
parcelRegister("1NxYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $accea6f99033f5ff$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $irINt = parcelRequire("irINt");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");
const $accea6f99033f5ff$var$MessageAssetListItem = (props)=>{
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    const renderThumb = ()=>{
        if (messageAsset.asset.contentType == "application/pdf") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-blue-alt-400 mr-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                className: "w-6 h-6"
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-6 h-6 flex items-center justify-center mr-2 overflow-hidden",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irINt.default), {
                path: messageAsset.asset.path,
                title: messageAsset.asset.name
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        className: "flex p-2 bg-white rounded-md mb-2 min-w-48 items-center cursor-pointer text-ch-gray-600 hover:text-ch-blue-alt-400 shadow-inner",
        onClick: ()=>props.openAssetModal(props.messageAssetId),
        children: [
            renderThumb(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-xs font-semibold",
                children: messageAsset.asset.name
            })
        ]
    });
};
var $accea6f99033f5ff$export$2e2bcd8739ae039 = $accea6f99033f5ff$var$MessageAssetListItem;

});

parcelRegister("8lxS4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6502281452970c2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $7twpo = parcelRequire("7twpo");

var $hVO2M = parcelRequire("hVO2M");

var $fH7G0 = parcelRequire("fH7G0");

var $kdYBG = parcelRequire("kdYBG");

var $jw7IJ = parcelRequire("jw7IJ");

var $fu0DD = parcelRequire("fu0DD");
const $c6502281452970c2$var$MessageAssetViewer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    if (!messageAsset) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:assetNotFound")
    });
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(messageAsset);
    const componentLookup = {
        [(0, $7twpo.AssetComponentTypes).Pdf]: (0, $jw7IJ.default),
        [(0, $7twpo.AssetComponentTypes).Image]: (0, $fu0DD.default)
    };
    const AssetViewer = componentLookup[assetComponetType];
    if (!AssetViewer) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:couldNotDisplayAsset")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col w-full h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute w-full top-0 left-0 z-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kdYBG.default), {
                    messageAssetId: props.messageAssetId
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 min-h-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(AssetViewer, {
                    messageAssetId: props.messageAssetId
                })
            })
        ]
    });
};
var $c6502281452970c2$export$2e2bcd8739ae039 = $c6502281452970c2$var$MessageAssetViewer;

});
parcelRegister("kdYBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddec0459807c180$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $5ddec0459807c180$var$MessageAssetViewerHeading = (props)=>{
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    if (!messageAsset) return null;
    const headingText = messageAsset.asset?.name;
    if (!headingText) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "flex items-center justify-center flex-1 font-thin",
        children: headingText
    });
};
var $5ddec0459807c180$export$2e2bcd8739ae039 = $5ddec0459807c180$var$MessageAssetViewerHeading;

});

parcelRegister("jw7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6933b5f6ee4ddd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aEgqS = parcelRequire("aEgqS");

var $3Npjv = parcelRequire("3Npjv");

var $jUk5c = parcelRequire("jUk5c");

var $fH7G0 = parcelRequire("fH7G0");
const $1b6933b5f6ee4ddd$var$MessageAssetPdfViewer = (props)=>{
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    if (!messageAsset) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const pdf = messageAsset.asset;
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        (0, $jUk5c.default)(pdf.path, setBlobUrl);
    }, [
        pdf.path
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Npjv.default), {
        url: blobUrl,
        filename: `${pdf.name}`
    });
};
var $1b6933b5f6ee4ddd$export$2e2bcd8739ae039 = $1b6933b5f6ee4ddd$var$MessageAssetPdfViewer;

});

parcelRegister("fu0DD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb629f07183c05b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $eoSy7 = parcelRequire("eoSy7");

var $aEgqS = parcelRequire("aEgqS");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $2fb629f07183c05b$var$MessageAssetImageViewer = (props)=>{
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    if (!messageAsset) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const image = messageAsset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eoSy7.default), {
        imageSrc: image.path
    });
};
var $2fb629f07183c05b$export$2e2bcd8739ae039 = $2fb629f07183c05b$var$MessageAssetImageViewer;

});



parcelRegister("cXxNn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1d9a97e90f537b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $9f1d9a97e90f537b$var$SpeechBubbleArrow = (props)=>{
    const defaultStyle = {
        position: "absolute",
        border: "7px solid transparent"
    };
    const rightStyle = {
        right: "-7px",
        borderLeftColor: "#006F74",
        borderRight: 0
    };
    const leftStyle = {
        left: "-7px",
        borderRightColor: "#E0E0E0",
        borderLeft: 0
    };
    const style = {
        ...defaultStyle,
        ...props.isLeft ? leftStyle : rightStyle
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: style
    });
};
var $9f1d9a97e90f537b$export$2e2bcd8739ae039 = $9f1d9a97e90f537b$var$SpeechBubbleArrow;

});


parcelRegister("glc4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc3c58fc45758b62$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $f1q41 = parcelRequire("f1q41");
const $bc3c58fc45758b62$var$useSearch = (initialSearchQuery, searchAction)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const [searchQuery, _setSearchQuery] = (0, $acw62.useState)(initialSearchQuery);
    const setSearchQuery = (newSearchQuery)=>{
        const updatedSearchQuery = {
            ...searchQuery,
            ...newSearchQuery
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual(searchQuery, updatedSearchQuery)) return;
        _setSearchQuery(updatedSearchQuery);
    };
    (0, $acw62.useEffect)(()=>{
        // New query resets to page 1
        const newSearchQuery = {
            ...searchQuery,
            page: 1
        };
        setSearchQuery(newSearchQuery);
        dispatch(searchAction(newSearchQuery));
    }, [
        searchQuery.appliedFilters,
        searchQuery.orderBy,
        searchQuery.resultsPerPage,
        searchQuery.searchTerm
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch(searchAction(searchQuery));
    }, [
        searchQuery.page
    ]);
    return [
        searchQuery,
        setSearchQuery
    ];
};
var $bc3c58fc45758b62$export$2e2bcd8739ae039 = $bc3c58fc45758b62$var$useSearch;

});

parcelRegister("9lUNX", function(module, exports) {

$parcel$export(module.exports, "fetchChatMessagesAsync", () => $84673d14853d68f5$export$afc72f46442ad4d8);
$parcel$export(module.exports, "updateNotificationMessageIdAction", () => $84673d14853d68f5$export$8adbde25d23739ce);

var $5Ah2h = parcelRequire("5Ah2h");
const $84673d14853d68f5$export$afc72f46442ad4d8 = (chatId, searchQuery)=>{
    return {
        type: (0, $5Ah2h.ChatMessagesActionTypes).FETCH_CHAT_MESSAGES_ASYNC_PENDING,
        payload: {
            chatId: chatId,
            searchQuery: searchQuery
        }
    };
};
const $84673d14853d68f5$export$8adbde25d23739ce = (notificationMessageId)=>{
    return {
        type: (0, $5Ah2h.ChatMessagesActionTypes).UPDATE_NOTIFICATION_MESSAGE,
        payload: notificationMessageId
    };
};

});

parcelRegister("bHoWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $88470f16b558b31e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $88470f16b558b31e$var$extendStatics = function(d, b) {
    $88470f16b558b31e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $88470f16b558b31e$var$extendStatics(d, b);
};
function $88470f16b558b31e$var$__extends(d, b) {
    $88470f16b558b31e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $88470f16b558b31e$var$__assign = function() {
    $88470f16b558b31e$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88470f16b558b31e$var$__assign.apply(this, arguments);
};
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */ function $88470f16b558b31e$var$throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== 'boolean') {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        var self = this;
        var elapsed = Date.now() - lastExec;
        var args = arguments;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, args);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
var $88470f16b558b31e$var$ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent'
};
var $88470f16b558b31e$var$defaultThreshold = {
    unit: $88470f16b558b31e$var$ThresholdUnits.Percent,
    value: 0.8
};
function $88470f16b558b31e$var$parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') return {
        unit: $88470f16b558b31e$var$ThresholdUnits.Percent,
        value: scrollThreshold * 100
    };
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) return {
            unit: $88470f16b558b31e$var$ThresholdUnits.Pixel,
            value: parseFloat(scrollThreshold)
        };
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) return {
            unit: $88470f16b558b31e$var$ThresholdUnits.Percent,
            value: parseFloat(scrollThreshold)
        };
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return $88470f16b558b31e$var$defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return $88470f16b558b31e$var$defaultThreshold;
}
var $88470f16b558b31e$var$InfiniteScroll = /** @class */ function(_super) {
    $88470f16b558b31e$var$__extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function() {
            if (_this.props.scrollableTarget instanceof HTMLElement) return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') return document.getElementById(_this.props.scrollableTarget);
            if (_this.props.scrollableTarget === null) console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            return null;
        };
        _this.onStart = function(evt) {
            if (_this.lastScrollTop) return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) _this.startY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.startY = evt.touches[0].pageY;
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function(evt) {
            if (!_this.dragging) return;
            if (evt instanceof MouseEvent) _this.currentY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.currentY = evt.touches[0].pageY;
            // user is scrolling down to up
            if (_this.currentY < _this.startY) return;
            if (_this.currentY - _this.startY >= Number(_this.props.pullDownToRefreshThreshold)) _this.setState({
                pullToRefreshThresholdBreached: true
            });
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5) return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY - _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function() {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false
                });
            }
            requestAnimationFrame(function() {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function(event) {
            if (typeof _this.props.onScroll === 'function') // Execute this callback in next tick so that it does not affect the
            // functionality of the library.
            setTimeout(function() {
                return _this.props.onScroll && _this.props.onScroll(event);
            }, 0);
            var target = _this.props.height || _this._scrollableNode ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered) return;
            var atBottom = _this.props.inverse ? _this.isElementAtTop(target, _this.props.scrollThreshold) : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({
                    showLoader: true
                });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength
        };
        _this.throttledOnScrollListener = $88470f16b558b31e$var$throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function() {
        if (typeof this.props.dataLength === 'undefined') throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height ? this._infScroll : this._scrollableNode || window;
        if (this.el) this.el.addEventListener('scroll', this.throttledOnScrollListener);
        if (typeof this.props.initialScrollY === 'number' && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY) this.el.scrollTo(0, this.props.initialScrollY);
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function() {
        if (this.el) {
            this.el.removeEventListener('scroll', this.throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function(prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength) return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function(nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) return $88470f16b558b31e$var$__assign($88470f16b558b31e$var$__assign({}, prevState), {
            prevDataLength: nextProps.dataLength
        });
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $88470f16b558b31e$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $88470f16b558b31e$var$ThresholdUnits.Pixel) return target.scrollTop <= threshold.value + clientHeight - target.scrollHeight + 1;
        return target.scrollTop <= threshold.value / 100 + clientHeight - target.scrollHeight + 1;
    };
    InfiniteScroll.prototype.isElementAtBottom = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $88470f16b558b31e$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $88470f16b558b31e$var$ThresholdUnits.Pixel) return target.scrollTop + clientHeight >= target.scrollHeight - threshold.value;
        return target.scrollTop + clientHeight >= threshold.value / 100 * target.scrollHeight;
    };
    InfiniteScroll.prototype.render = function() {
        var _this = this;
        var style = $88470f16b558b31e$var$__assign({
            height: this.props.height || 'auto',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch'
        }, this.props.style);
        var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? {
            overflow: 'auto'
        } : {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: outerDivStyle,
            className: "infinite-scroll-component__outerdiv"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "infinite-scroll-component " + (this.props.className || ''),
            ref: function(infScroll) {
                return _this._infScroll = infScroll;
            },
            style: style
        }, this.props.pullDownToRefresh && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'relative'
            },
            ref: function(pullDown) {
                return _this._pullDown = pullDown;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: -1 * this.maxPullDownDistance
            }
        }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
    };
    return InfiniteScroll;
}((0, $acw62.Component));
var $88470f16b558b31e$export$2e2bcd8739ae039 = $88470f16b558b31e$var$InfiniteScroll;

});

parcelRegister("hbtzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $08b3901cce668a06$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $6lvMC = parcelRequire("6lvMC");

var $c0hbo = parcelRequire("c0hbo");

var $cXxNn = parcelRequire("cXxNn");
const $08b3901cce668a06$var$CurrentlyTypingIndicator = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const [filteredUsers, setFilteredUsers] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const _filteredUsers = chat?.usersTypingIds?.filter((userId)=>userId != currentUser.id);
        setFilteredUsers(_filteredUsers);
    }, [
        chat?.usersTypingIds
    ]);
    if (!filteredUsers?.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "px-4 pb-4 -mt-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col max-w-md mb-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-xs mb-1",
                    children: [
                        filteredUsers.map((userId, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    index > 0 && ", ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0hbo.default), {
                                        userId: userId
                                    })
                                ]
                            }, `${index}-${userId}`);
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                " ",
                                t("message:index:isTyping")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex mb-1 items-center ml-1 animate-pulse",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px-4 py-3 rounded-md text-xs relative bg-ch-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cXxNn.default), {
                                isLeft: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex justify-between gap-1 animate-bounce p-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-2 h-2 rounded-full bg-ch-gray-450"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-2 h-2 rounded-full bg-ch-gray-500"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-2 h-2 rounded-full bg-ch-gray-600"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $08b3901cce668a06$export$2e2bcd8739ae039 = $08b3901cce668a06$var$CurrentlyTypingIndicator;

});
parcelRegister("c0hbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $544631cfd6e6a033$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");
const $544631cfd6e6a033$var$ChatUserName = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.userId));
    if (!user) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: `${user.firstName} ${user.lastName}`
    });
};
var $544631cfd6e6a033$export$2e2bcd8739ae039 = $544631cfd6e6a033$var$ChatUserName;

});



parcelRegister("7W17n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e903e0eff857da87$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $kVrOK = parcelRequire("kVrOK");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $2EDUL = parcelRequire("2EDUL");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $aSzjr = parcelRequire("aSzjr");

var $jF0Xa = parcelRequire("jF0Xa");

var $5L9s0 = parcelRequire("5L9s0");

var $coPA5 = parcelRequire("coPA5");

var $fH7G0 = parcelRequire("fH7G0");

var $50Djh = parcelRequire("50Djh");

var $6lvMC = parcelRequire("6lvMC");

var $6nTql = parcelRequire("6nTql");
const $e903e0eff857da87$var$MessageNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const createChatMessage = (chatId, message)=>dispatch((0, $5L9s0.createChatMessageAsync)(chatId, message));
    const initialValues = {
        body: "",
        assetsAttributes: []
    };
    const formikFormRef = (0, $acw62.useRef)(null);
    let pressedKeys = [];
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!props.chatId) return null;
    const getExpiryTimestamp = ()=>{
        const time = new Date();
        time.setSeconds(time.getSeconds() + 3);
        return time;
    };
    const { seconds: seconds, restart: restart } = (0, $2EDUL.useTimer)({
        autoStart: false,
        expiryTimestamp: getExpiryTimestamp()
    });
    const broadcastIsTyping = (isTyping)=>{
        dispatch((0, $50Djh.updateUserIsTyping)(props.chatId, currentUser.id, isTyping));
    };
    const handleStartTyping = ()=>{
        if (!formikFormRef.current.values.body) return;
        restart(getExpiryTimestamp());
        broadcastIsTyping(true);
    };
    const throttledUpdateUserIsTyping = (0, $acw62.useMemo)(()=>(0, $f1q41.throttle)(handleStartTyping, 1000, {
            leading: true
        }), []);
    (0, $acw62.useEffect)(()=>{
        if (seconds == 0) broadcastIsTyping(false);
    }, [
        seconds
    ]);
    const onMessageFieldKeyDown = (event)=>{
        pressedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
            ...pressedKeys,
            event.key
        ]);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(pressedKeys, $kVrOK.VALUE_RETURN) && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(pressedKeys, $kVrOK.VALUE_SHIFT)) {
            event.preventDefault();
            formikFormRef.current.submitForm();
            broadcastIsTyping(false);
        } else {
            if (!formikFormRef.current.values.body || (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(pressedKeys, $kVrOK.VALUE_RETURN)) return;
            throttledUpdateUserIsTyping();
        }
    };
    const onMessageFieldKeyUp = (event)=>{
        const withoutKeyUp = pressedKeys.filter((key)=>key != event.key);
        pressedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(withoutKeyUp);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $coPA5.messageNewValidation),
            validateOnChange: true,
            onSubmit: (values, { setSubmitting: setSubmitting, resetForm: resetForm })=>{
                createChatMessage(props.chatId, values);
                setSubmitting(false);
                resetForm();
            },
            innerRef: formikFormRef,
            children: ({ isSubmitting: isSubmitting, values: values, handleBlur: handleBlur, setFieldValue: setFieldValue, isValid: isValid })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2 relative",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                    name: "body",
                                    setValue: (description)=>setFieldValue("body", description),
                                    onBlur: handleBlur,
                                    onKeyDown: onMessageFieldKeyDown,
                                    onKeyUp: onMessageFieldKeyUp,
                                    users: null,
                                    value: values.body,
                                    height: 62,
                                    isDisabled: chat?.endedAt !== null
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("", {
                                        "relative": values.assetsAttributes.length,
                                        "absolute": !values.assetsAttributes.length,
                                        "right-2": !values.assetsAttributes.length,
                                        "bottom-2": !values.assetsAttributes.length
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6nTql.default), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: isSubmitting || !isValid || chat?.endedAt !== null,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("message:new:buttons:send")
                            }, "1")
                        })
                    ]
                });
            }
        })
    });
};
var $e903e0eff857da87$export$2e2bcd8739ae039 = $e903e0eff857da87$var$MessageNewForm;

});
parcelRegister("kVrOK", function(module, exports) {

$parcel$export(module.exports, "VALUE_RETURN", () => $f3beb580c27354c8$export$347cb21fee7c40f5);
$parcel$export(module.exports, "VALUE_SHIFT", () => $f3beb580c27354c8$export$e949019538c55603);
// Key code constants
// Available values for `KeyboardEvent.keyCode` attribute.
var $f3beb580c27354c8$export$5b52bd51f6db9fff = 3;
var $f3beb580c27354c8$export$25a20afe5e60ebba = 6;
var $f3beb580c27354c8$export$a36fbd6225c48605 = 8;
var $f3beb580c27354c8$export$10f6869ed0a7d75b = 9;
var $f3beb580c27354c8$export$ef0a30aec79032c2 = 12;
var $f3beb580c27354c8$export$a38a780d07123ee = 13;
var $f3beb580c27354c8$export$98e2f9c8509acded = 16;
var $f3beb580c27354c8$export$73e1456d05abb60b = 17;
var $f3beb580c27354c8$export$acce4070379e156f = 18;
var $f3beb580c27354c8$export$f9670f9730ea5aca = 19;
var $f3beb580c27354c8$export$d9aee47dc35df7be = 20;
var $f3beb580c27354c8$export$929c2026f4dd54a2 = 27;
var $f3beb580c27354c8$export$e51a3576c045c8d5 = 32;
var $f3beb580c27354c8$export$f6d7f1758d78de8c = 33;
var $f3beb580c27354c8$export$87e4d19e237ae63c = 34;
var $f3beb580c27354c8$export$e2bc30913faa5db7 = 35;
var $f3beb580c27354c8$export$4af703091671bc = 36;
var $f3beb580c27354c8$export$fc4577f2a2af0ae3 = 37;
var $f3beb580c27354c8$export$390330c10ff2b9a1 = 38;
var $f3beb580c27354c8$export$c40f9845adc73fb5 = 39;
var $f3beb580c27354c8$export$a80636c6f41931fe = 40;
var $f3beb580c27354c8$export$eebe23138b6c35f9 = 44;
var $f3beb580c27354c8$export$a36d89a17a4ed3af = 45;
var $f3beb580c27354c8$export$1fd7871db6041a84 = 46;
var $f3beb580c27354c8$export$77572f9427479178 = 48;
var $f3beb580c27354c8$export$69b91aca467f3611 = 49;
var $f3beb580c27354c8$export$7ecc4c27490e5b03 = 50;
var $f3beb580c27354c8$export$a39a2cc505fdb94e = 51;
var $f3beb580c27354c8$export$97354093f237bcf8 = 52;
var $f3beb580c27354c8$export$2dd7fdd2c3213c3d = 53;
var $f3beb580c27354c8$export$7d356c626c3f141e = 54;
var $f3beb580c27354c8$export$495808184472a100 = 55;
var $f3beb580c27354c8$export$21bc1f3202cc989d = 56;
var $f3beb580c27354c8$export$4c93b4ba1cd044ba = 57;
var $f3beb580c27354c8$export$a62be707b936c199 = 65;
var $f3beb580c27354c8$export$c18be1728511ebc3 = 66;
var $f3beb580c27354c8$export$ff2b7c04ae7a400f = 67;
var $f3beb580c27354c8$export$735409f7aa94928b = 68;
var $f3beb580c27354c8$export$e521cc6fb0866243 = 69;
var $f3beb580c27354c8$export$22c2d281623e74e6 = 70;
var $f3beb580c27354c8$export$af2a2eb5f68148ae = 71;
var $f3beb580c27354c8$export$fcd8a4dcd7de38d1 = 72;
var $f3beb580c27354c8$export$ac930a2aa4f9070b = 73;
var $f3beb580c27354c8$export$58d5ddde082c12b3 = 74;
var $f3beb580c27354c8$export$adebd9143f16e27 = 75;
var $f3beb580c27354c8$export$8d780e815c3d641 = 76;
var $f3beb580c27354c8$export$2c683c4640ba22fb = 77;
var $f3beb580c27354c8$export$3ad69dc3b1f0c38b = 78;
var $f3beb580c27354c8$export$300253714f9b0a2e = 79;
var $f3beb580c27354c8$export$6f4987155cb0fabb = 80;
var $f3beb580c27354c8$export$716039473cb0a2a = 81;
var $f3beb580c27354c8$export$5ad09b0bee1b0abb = 82;
var $f3beb580c27354c8$export$78d844c917a74b0e = 83;
var $f3beb580c27354c8$export$e77d3cd8ef08ddbc = 84;
var $f3beb580c27354c8$export$92b83fb473b640ea = 85;
var $f3beb580c27354c8$export$268e5203e810beb6 = 86;
var $f3beb580c27354c8$export$2a49760c37a1b3ff = 87;
var $f3beb580c27354c8$export$2dade10f3c23753a = 88;
var $f3beb580c27354c8$export$f8a1f619e2ff4ab1 = 89;
var $f3beb580c27354c8$export$4832f13c7e3afcf9 = 90;
var $f3beb580c27354c8$export$28eb92feeb510636 = 91;
var $f3beb580c27354c8$export$7b18e07ce48bb046 = 92;
var $f3beb580c27354c8$export$13ec18870f097236 = 93;
var $f3beb580c27354c8$export$182c945535c18797 = 96;
var $f3beb580c27354c8$export$8c495972b9703ac9 = 97;
var $f3beb580c27354c8$export$e1fa39ab1d3755c6 = 98;
var $f3beb580c27354c8$export$d9ca08765796be97 = 99;
var $f3beb580c27354c8$export$4e9316c1f2aa5fbf = 100;
var $f3beb580c27354c8$export$e4c43a80f48eceaa = 101;
var $f3beb580c27354c8$export$b6e629423448ad0e = 102;
var $f3beb580c27354c8$export$a65c1af6cab883e3 = 103;
var $f3beb580c27354c8$export$1295c23b8778e7d4 = 104;
var $f3beb580c27354c8$export$a00eff25e1033b2c = 105;
var $f3beb580c27354c8$export$602521ef1c83a168 = 106;
var $f3beb580c27354c8$export$1ef76a9110834e9 = 107;
var $f3beb580c27354c8$export$59c4acf6ec6d2aa2 = 109;
var $f3beb580c27354c8$export$c28f5f159d9ddb52 = 110;
var $f3beb580c27354c8$export$2a62aa4a7b885f1c = 111;
var $f3beb580c27354c8$export$a9b2e8fe409a199 = 112;
var $f3beb580c27354c8$export$93a873cdfffc9911 = 113;
var $f3beb580c27354c8$export$40e3913eb25e86a1 = 114;
var $f3beb580c27354c8$export$b13ae03ab016b3df = 115;
var $f3beb580c27354c8$export$8c95544bb6f4c8b1 = 116;
var $f3beb580c27354c8$export$b65994f118f7db78 = 117;
var $f3beb580c27354c8$export$631bdcf5d1977b74 = 118;
var $f3beb580c27354c8$export$b189c7edaf0641a4 = 119;
var $f3beb580c27354c8$export$51318094c8da48cc = 120;
var $f3beb580c27354c8$export$60258b68f6d82d1e = 121;
var $f3beb580c27354c8$export$d2bbece2b415aa08 = 122;
var $f3beb580c27354c8$export$788ff4e5fea246a = 123;
var $f3beb580c27354c8$export$538636825c50f252 = 124;
var $f3beb580c27354c8$export$a7cd2773438721c4 = 125;
var $f3beb580c27354c8$export$f9ffdaa8ea9dcd0e = 126;
var $f3beb580c27354c8$export$e61bdc85915cb9cf = 127;
var $f3beb580c27354c8$export$796bc28d1f63f937 = 128;
var $f3beb580c27354c8$export$9e39e4e710b8d326 = 129;
var $f3beb580c27354c8$export$6287387854b4fdd0 = 130;
var $f3beb580c27354c8$export$dbde3a205c4a8135 = 131;
var $f3beb580c27354c8$export$95b11fb510e2cdf2 = 132;
var $f3beb580c27354c8$export$450e9caa3f3552cd = 133;
var $f3beb580c27354c8$export$6391fa5949809b6 = 134;
var $f3beb580c27354c8$export$f2a31e609bc46767 = 135;
var $f3beb580c27354c8$export$d181f2e66e872ba6 = 144;
var $f3beb580c27354c8$export$5bfbaa70e5a7dddf = 145;
var $f3beb580c27354c8$export$a62e0737b05a762d = 186;
var $f3beb580c27354c8$export$a94043fb7bd4b99c = 187;
var $f3beb580c27354c8$export$28eeaad6e57a690e = 188;
var $f3beb580c27354c8$export$258184a73e5f4925 = 189;
var $f3beb580c27354c8$export$fb3ffe8ca8b0e320 = 190;
var $f3beb580c27354c8$export$4893289f1f957ad8 = 191;
var $f3beb580c27354c8$export$122dbfea2a21a91f = 192;
var $f3beb580c27354c8$export$cd19fa4e169d8c16 = 219;
var $f3beb580c27354c8$export$a42ef8925e0da6ee = 220;
var $f3beb580c27354c8$export$ee7b06a88435b004 = 221;
var $f3beb580c27354c8$export$cd530d0a0a888628 = 222;
// Key code constants specific to firefox only.
var $f3beb580c27354c8$export$a19e3cde972832e8 = 14;
var $f3beb580c27354c8$export$c86efeeecc28f45 = 59;
var $f3beb580c27354c8$export$e806c2392351341f = 61;
var $f3beb580c27354c8$export$afd97499b7927b95 = 108;
var $f3beb580c27354c8$export$ad36d5baa87e9937 = 224;
// Key values constants
// Available values for `KeyboardEvent.key` attribute.
var $f3beb580c27354c8$export$86978e76a7350f38 = 'Cancel';
var $f3beb580c27354c8$export$92189c4fdd16790c = 'Help';
var $f3beb580c27354c8$export$76344d050604c9e5 = 'Backspace';
var $f3beb580c27354c8$export$1cc5be767a2af157 = 'Tab';
var $f3beb580c27354c8$export$e09223fc512eda99 = 'Clear';
var $f3beb580c27354c8$export$cf52a3805bde1f58 = 'Enter';
var $f3beb580c27354c8$export$347cb21fee7c40f5 = 'Enter';
var $f3beb580c27354c8$export$e949019538c55603 = 'Shift';
var $f3beb580c27354c8$export$9cd42dab6bd79fc7 = 'Control';
var $f3beb580c27354c8$export$f959753541ae4b89 = 'Alt';
var $f3beb580c27354c8$export$c6028579541f8a4c = 'Pause';
var $f3beb580c27354c8$export$853e917d4db82812 = 'CapsLock';
var $f3beb580c27354c8$export$2755823fcd0ff4af = 'Escape';
var $f3beb580c27354c8$export$dbb1453e9f51ff9f = ' ';
var $f3beb580c27354c8$export$3aee56a5153b596f = 'PageUp';
var $f3beb580c27354c8$export$c2828895ba2dbf34 = 'PageDown';
var $f3beb580c27354c8$export$a83dece23e600b6f = 'End';
var $f3beb580c27354c8$export$ddf0c1d3a0c119b0 = 'Home';
var $f3beb580c27354c8$export$ecf2fc45d49f34a6 = 'ArrowLeft';
var $f3beb580c27354c8$export$a4b372895d837424 = 'ArrowUp';
var $f3beb580c27354c8$export$2b2f855ad0e4dc0b = 'ArrowRight';
var $f3beb580c27354c8$export$c4ee601aed230301 = 'ArrowDown';
var $f3beb580c27354c8$export$6d149ae25ae0cd9c = 'PrintScreen';
var $f3beb580c27354c8$export$76784e8dae061fd0 = 'Insert';
var $f3beb580c27354c8$export$a6175b7116878090 = 'Delete';
var $f3beb580c27354c8$export$e65135ac75491d54 = '0';
var $f3beb580c27354c8$export$c42a7f0192c61427 = '1';
var $f3beb580c27354c8$export$ed9da2932b1c7165 = '2';
var $f3beb580c27354c8$export$257c9a483f048953 = '3';
var $f3beb580c27354c8$export$2a00b73defef2290 = '4';
var $f3beb580c27354c8$export$3dc2aca1d55e586e = '5';
var $f3beb580c27354c8$export$3db6b544faf737bc = '6';
var $f3beb580c27354c8$export$f34f9e4e60dea3de = '7';
var $f3beb580c27354c8$export$32a1ee63d6ef34ae = '8';
var $f3beb580c27354c8$export$294ebaf02b577531 = '9';
var $f3beb580c27354c8$export$15504ca8788615e1 = 'a';
var $f3beb580c27354c8$export$f34b33f8be565b4a = 'b';
var $f3beb580c27354c8$export$656c5afba01a72a5 = 'c';
var $f3beb580c27354c8$export$a368d455a8493d68 = 'd';
var $f3beb580c27354c8$export$3b615e778b04a390 = 'e';
var $f3beb580c27354c8$export$87c5e9972be2b363 = 'f';
var $f3beb580c27354c8$export$1ae96b45a7aa6cec = 'g';
var $f3beb580c27354c8$export$70698b9832ec67ab = 'h';
var $f3beb580c27354c8$export$bf92bad733dc0dd4 = 'i';
var $f3beb580c27354c8$export$c0c71ccbd7ee9d30 = 'j';
var $f3beb580c27354c8$export$96b1b73608768665 = 'k';
var $f3beb580c27354c8$export$55d65a358a65ba8c = 'l';
var $f3beb580c27354c8$export$fa0b13b0a5b732f0 = 'm';
var $f3beb580c27354c8$export$a39a015b057bb963 = 'n';
var $f3beb580c27354c8$export$f4ffa7d950107608 = 'o';
var $f3beb580c27354c8$export$e6feff2fe0c2115f = 'p';
var $f3beb580c27354c8$export$764d97454e99d911 = 'q';
var $f3beb580c27354c8$export$d9e97f4b5fac8107 = 'r';
var $f3beb580c27354c8$export$b80b16e5f51bd2ff = 's';
var $f3beb580c27354c8$export$d03bf806e0b7bf0 = 't';
var $f3beb580c27354c8$export$7b7ef70bd96c03f1 = 'u';
var $f3beb580c27354c8$export$f9c97f495b61e639 = 'v';
var $f3beb580c27354c8$export$88e79f88a911ccee = 'w';
var $f3beb580c27354c8$export$ae2f87d9cb1a3b83 = 'x';
var $f3beb580c27354c8$export$b837fd8c72919e5f = 'y';
var $f3beb580c27354c8$export$578d5262255b8746 = 'z';
var $f3beb580c27354c8$export$ce7a19d81e49e09f = 'Meta';
var $f3beb580c27354c8$export$fbdd62059aadeb41 = 'Meta';
var $f3beb580c27354c8$export$76c0736798a0637e = 'Meta';
var $f3beb580c27354c8$export$6301b61c198f6ff2 = 'ContextMenu';
var $f3beb580c27354c8$export$ca8d30b42f9d6199 = '0';
var $f3beb580c27354c8$export$47801825107a972 = '1';
var $f3beb580c27354c8$export$182a8e91ee5e3a0f = '2';
var $f3beb580c27354c8$export$4afb6e14289285a1 = '3';
var $f3beb580c27354c8$export$84bea12b3b3b29a2 = '4';
var $f3beb580c27354c8$export$e455db3d1b1f803e = '5';
var $f3beb580c27354c8$export$aaec70393647d73e = '6';
var $f3beb580c27354c8$export$81a34b6ff1c15c53 = '7';
var $f3beb580c27354c8$export$aa0c8d3609c2d873 = '8';
var $f3beb580c27354c8$export$3688553b7cbd4441 = '9';
var $f3beb580c27354c8$export$d0562845bff3e754 = '*';
var $f3beb580c27354c8$export$e81f80d10877f279 = '+';
var $f3beb580c27354c8$export$1068423313e5273d = '-';
var $f3beb580c27354c8$export$242700e2278e5b3d = '.';
var $f3beb580c27354c8$export$76d3abfdf113028d = '/';
var $f3beb580c27354c8$export$673b78181385e88c = 'F1';
var $f3beb580c27354c8$export$9d6f161127c74976 = 'F2';
var $f3beb580c27354c8$export$c74db9b9cda9f64b = 'F3';
var $f3beb580c27354c8$export$396e32bbdfb4e412 = 'F4';
var $f3beb580c27354c8$export$60115c430f66dd0f = 'F5';
var $f3beb580c27354c8$export$8df04afe903efb98 = 'F6';
var $f3beb580c27354c8$export$23bc10c71355d3d4 = 'F7';
var $f3beb580c27354c8$export$88c509174efc9dfa = 'F8';
var $f3beb580c27354c8$export$df8a90685fd0ee6a = 'F9';
var $f3beb580c27354c8$export$da8809bc772d10a8 = 'F10';
var $f3beb580c27354c8$export$8dbbdf9503015299 = 'F11';
var $f3beb580c27354c8$export$66c4cf453b0595 = 'F12';
var $f3beb580c27354c8$export$3394240dfcdc5cd4 = 'F13';
var $f3beb580c27354c8$export$65e43e9e26a12320 = 'F14';
var $f3beb580c27354c8$export$3c0656213b440da2 = 'F15';
var $f3beb580c27354c8$export$b48d4f22bcb5d7e7 = 'F16';
var $f3beb580c27354c8$export$f03b159ecde4010b = 'F17';
var $f3beb580c27354c8$export$bcc5d9f3f9bdaa0d = 'F18';
var $f3beb580c27354c8$export$afb54cfb9dfba770 = 'F19';
var $f3beb580c27354c8$export$19c243aa806dc404 = 'F20';
var $f3beb580c27354c8$export$40cb82bf135c3d38 = 'F21';
var $f3beb580c27354c8$export$4dfb082c7baa425c = 'F22';
var $f3beb580c27354c8$export$68d1f568fc19e13c = 'F23';
var $f3beb580c27354c8$export$7fef36aa78506b5e = 'F24';
var $f3beb580c27354c8$export$2fec22c1ec3c76fe = 'NumLock';
var $f3beb580c27354c8$export$67256bd509eced85 = 'ScrollLock';
var $f3beb580c27354c8$export$59c504994f71f435 = ';';
var $f3beb580c27354c8$export$52aa075b70beaa8e = '=';
var $f3beb580c27354c8$export$36268b1294a99b1d = ',';
var $f3beb580c27354c8$export$38296ee17343bf42 = '-';
var $f3beb580c27354c8$export$d6c27fa045596db9 = '.';
var $f3beb580c27354c8$export$b60b3e4abbbf0740 = '/';
var $f3beb580c27354c8$export$427d5583f1578698 = '`';
var $f3beb580c27354c8$export$a9c446473036ea69 = '[';
var $f3beb580c27354c8$export$1b250a202c6867e1 = '\\';
var $f3beb580c27354c8$export$d39c02aa7f5d8ebb = ']';
var $f3beb580c27354c8$export$b723d8bfb1dbf1a4 = "'";
// Key code constants
// Available values for `KeyboardEvent.code` attribute.
var $f3beb580c27354c8$export$9c20d0d28e4c163c = 'Unidentified';
var $f3beb580c27354c8$export$975f7d429fdbf240 = 'Escape';
var $f3beb580c27354c8$export$5d631b13133b237b = 'Minus';
var $f3beb580c27354c8$export$5a621914cd5aa093 = 'Minus';
var $f3beb580c27354c8$export$ddf841d83cd5025f = 'Equal';
var $f3beb580c27354c8$export$49fa5387d96ae995 = 'Backspace';
var $f3beb580c27354c8$export$9800482e7f450be1 = 'Tab';
var $f3beb580c27354c8$export$7a1ff769be80e694 = 'Enter';
var $f3beb580c27354c8$export$fea9eae550d9fd5e = 'Enter';
var $f3beb580c27354c8$export$8f47fd9c3fe1e52a = 'ShiftLeft';
var $f3beb580c27354c8$export$a6c0a2c9ea7d8baf = 'ShiftRight';
var $f3beb580c27354c8$export$d447d39c60274f3a = 'ControlLeft';
var $f3beb580c27354c8$export$7f5c64be379e086 = 'ControlRight';
var $f3beb580c27354c8$export$bb99e10f31332e1b = 'AltLeft';
var $f3beb580c27354c8$export$e22e821593ad78f7 = 'AltRight';
var $f3beb580c27354c8$export$8ea00db41a19b075 = 'Pause';
var $f3beb580c27354c8$export$235d86d16874eea1 = 'CapsLock';
var $f3beb580c27354c8$export$2f4a27502e931b1f = 'Space';
var $f3beb580c27354c8$export$b0bb92d4d4baa2d = 'PageUp';
var $f3beb580c27354c8$export$eb828215f747da55 = 'PageDown';
var $f3beb580c27354c8$export$5d1d3d89bd03877 = 'End';
var $f3beb580c27354c8$export$6975cad9b4969730 = 'Home';
var $f3beb580c27354c8$export$2e132b99259d4392 = 'ArrowLeft';
var $f3beb580c27354c8$export$38677642ab203309 = 'ArrowUp';
var $f3beb580c27354c8$export$a95d8e53b2f3f0e6 = 'ArrowRight';
var $f3beb580c27354c8$export$6f42746a0a060c25 = 'ArrowDown';
var $f3beb580c27354c8$export$1343f9572a0a2128 = 'PrintScreen';
var $f3beb580c27354c8$export$b0ed69e0402bdaf7 = 'Insert';
var $f3beb580c27354c8$export$c1cf8a68e4e25859 = 'Delete';
var $f3beb580c27354c8$export$e573470799236c5 = 'Digit0';
var $f3beb580c27354c8$export$e554e9ac94c080eb = 'Digit1';
var $f3beb580c27354c8$export$51a3a34a31943883 = 'Digit2';
var $f3beb580c27354c8$export$6d13fbacf7972d91 = 'Digit3';
var $f3beb580c27354c8$export$dc83a6130924bf55 = 'Digit4';
var $f3beb580c27354c8$export$e5214ef54e71e68f = 'Digit5';
var $f3beb580c27354c8$export$4919fa7fbb4ea327 = 'Digit6';
var $f3beb580c27354c8$export$5deec9b04f2b7fc8 = 'Digit7';
var $f3beb580c27354c8$export$9b13103ef9f98c02 = 'Digit8';
var $f3beb580c27354c8$export$62336bd1aad0d0aa = 'Digit9';
var $f3beb580c27354c8$export$d8f223eaf6c4a509 = 'KeyA';
var $f3beb580c27354c8$export$8ec36e92ff282f94 = 'KeyB';
var $f3beb580c27354c8$export$8d8672242d0308cc = 'KeyC';
var $f3beb580c27354c8$export$925a7f8f76138ecc = 'KeyD';
var $f3beb580c27354c8$export$ca40ef7ac34fac43 = 'KeyE';
var $f3beb580c27354c8$export$4828a513b919f106 = 'KeyF';
var $f3beb580c27354c8$export$3b86fe9cd0ca9572 = 'KeyG';
var $f3beb580c27354c8$export$462a357f5e8e6609 = 'KeyH';
var $f3beb580c27354c8$export$e1732162841adf20 = 'KeyI';
var $f3beb580c27354c8$export$5b01189ff41cdb6d = 'KeyJ';
var $f3beb580c27354c8$export$ceeb16f92fad6a3a = 'KeyK';
var $f3beb580c27354c8$export$b3d9bf8085890f45 = 'KeyL';
var $f3beb580c27354c8$export$7cdd87a7a6f772f4 = 'KeyM';
var $f3beb580c27354c8$export$864a05219d28aac = 'KeyN';
var $f3beb580c27354c8$export$4956e96b522f1412 = 'KeyO';
var $f3beb580c27354c8$export$95ae1f5e6face614 = 'KeyP';
var $f3beb580c27354c8$export$1d00374d0f6fe0e4 = 'KeyQ';
var $f3beb580c27354c8$export$92dd86b8f8eb7c6d = 'KeyR';
var $f3beb580c27354c8$export$4bfda939002d9d9d = 'KeyS';
var $f3beb580c27354c8$export$37ca3fc3ac442456 = 'KeyT';
var $f3beb580c27354c8$export$17f5c3ff93001ea7 = 'KeyU';
var $f3beb580c27354c8$export$501a0b0af1591884 = 'KeyV';
var $f3beb580c27354c8$export$718704674c6edaad = 'KeyW';
var $f3beb580c27354c8$export$517ff6d6f26ae6be = 'KeyX';
var $f3beb580c27354c8$export$d1ae561d4720d543 = 'KeyY';
var $f3beb580c27354c8$export$9a044bf492f0cc08 = 'KeyZ';
var $f3beb580c27354c8$export$1df14ece05208a0b = 'MetaLeft';
var $f3beb580c27354c8$export$b0f1cc5d4cc81931 = 'OSLeft';
var $f3beb580c27354c8$export$a1e8bcaf0ec03ac9 = 'MetaRight';
var $f3beb580c27354c8$export$f2071186b81628d2 = 'OSRight';
var $f3beb580c27354c8$export$c19ece95565c70fe = 'ContextMenu';
var $f3beb580c27354c8$export$e3d76f3e581e60df = 'Numpad0';
var $f3beb580c27354c8$export$da49a641d8e0864 = 'Numpad1';
var $f3beb580c27354c8$export$b89338a853948ff0 = 'Numpad2';
var $f3beb580c27354c8$export$806a2bb43be92c8c = 'Numpad3';
var $f3beb580c27354c8$export$88e7ea6f9b70f9d = 'Numpad4';
var $f3beb580c27354c8$export$155af4623dc97948 = 'Numpad5';
var $f3beb580c27354c8$export$499498556378194b = 'Numpad6';
var $f3beb580c27354c8$export$828d13a1be9c84e9 = 'Numpad7';
var $f3beb580c27354c8$export$2068c363990a6f2e = 'Numpad8';
var $f3beb580c27354c8$export$27863730ae793ad5 = 'Numpad9';
var $f3beb580c27354c8$export$d5b7de7999cefb82 = 'NumpadMultiply';
var $f3beb580c27354c8$export$7861539f65b1d420 = 'NumpadAdd';
var $f3beb580c27354c8$export$1547ee764c015c5f = 'NumpadSubtract';
var $f3beb580c27354c8$export$2921a8851f36156d = 'NumpadDecimal';
var $f3beb580c27354c8$export$58a36e42a843096c = 'NumpadDivide';
var $f3beb580c27354c8$export$d27073bc28a2b5d0 = 'NumpadEnter';
var $f3beb580c27354c8$export$b42c9662294dd0a = 'F1';
var $f3beb580c27354c8$export$7bf36432ac9ec1cf = 'F2';
var $f3beb580c27354c8$export$c9eab75617830c82 = 'F3';
var $f3beb580c27354c8$export$714e53474adaa713 = 'F4';
var $f3beb580c27354c8$export$33a59198bbed709e = 'F5';
var $f3beb580c27354c8$export$4c93120760140346 = 'F6';
var $f3beb580c27354c8$export$f2811f7fe1a01463 = 'F7';
var $f3beb580c27354c8$export$ec14dea76228c09 = 'F8';
var $f3beb580c27354c8$export$5c56003c4b6bafee = 'F9';
var $f3beb580c27354c8$export$46000c50f1837d2a = 'F10';
var $f3beb580c27354c8$export$eb248d663c2ef364 = 'F11';
var $f3beb580c27354c8$export$6fd83470ae3bf0de = 'F12';
var $f3beb580c27354c8$export$e1ca2d3bb93b1efd = 'F13';
var $f3beb580c27354c8$export$88cc489fd7a2fe8f = 'F14';
var $f3beb580c27354c8$export$6c7a00e6c1f8421f = 'F15';
var $f3beb580c27354c8$export$a985d049e923827a = 'F16';
var $f3beb580c27354c8$export$6e8e0351e501af01 = 'F17';
var $f3beb580c27354c8$export$c7e89fa85cb828bc = 'F18';
var $f3beb580c27354c8$export$aa0bff4f8a274c64 = 'F19';
var $f3beb580c27354c8$export$8fcf363f59f99d73 = 'F20';
var $f3beb580c27354c8$export$ce36e30846e09780 = 'F21';
var $f3beb580c27354c8$export$a446570b9fb5ab60 = 'F22';
var $f3beb580c27354c8$export$fcd8d7603b92797c = 'F23';
var $f3beb580c27354c8$export$b820622c5f27df6e = 'F24';
var $f3beb580c27354c8$export$b5fccaaf785d3ee4 = 'NumLock';
var $f3beb580c27354c8$export$5f769e3423e98f8d = 'ScrollLock';
var $f3beb580c27354c8$export$66b68c241e300139 = 'Semicolon';
var $f3beb580c27354c8$export$1b83dc1d669361a0 = 'Comma';
var $f3beb580c27354c8$export$69030d29a0518019 = 'Period';
var $f3beb580c27354c8$export$da5993adf2fc42de = 'Slash';
var $f3beb580c27354c8$export$2c7c2a93bf616085 = 'Backquote';
var $f3beb580c27354c8$export$63d2e37dd5bf9e1b = 'BracketLeft';
var $f3beb580c27354c8$export$5d9a6811f2c94fc7 = 'Backslash';
var $f3beb580c27354c8$export$a3642b5a3a8469d1 = 'BracketRight';
var $f3beb580c27354c8$export$b9796bd12705921c = 'Quote';

});

parcelRegister("2EDUL", function(module, exports) {

!function(e, t) {
    module.exports = t((parcelRequire("acw62")));
}("undefined" != typeof self ? self : module.exports, function(e) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 3);
    }([
        function(t, r) {
            t.exports = e;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Validate = t.Time = void 0;
            var n = u(r(5)), o = u(r(6));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.Time = n.default, t.Validate = o.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useInterval = void 0;
            var n = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(r(7));
            t.useInterval = n.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useTime = t.useStopwatch = t.useTimer = void 0;
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            };
            t.default = function(e) {
                if ((0, o.useEffect)(function() {
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), e.expiryTimestamp) {
                    var t = (0, u.default)(e);
                    return n({}, t, {
                        startTimer: t.start,
                        stopTimer: t.pause,
                        resetTimer: function() {}
                    });
                }
                var r = (0, i.default)(e);
                return n({}, r, {
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                });
            };
            var o = r(0), u = c(r(4)), i = c(r(8)), a = c(r(9));
            function c(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.useTimer = u.default, t.useStopwatch = i.default, t.useTime = a.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.expiryTimestamp, r = e.onExpire, s = e.autoStart, l = void 0 === s || s, d = (0, u.useState)(t), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(i.Time.getSecondsFromExpiry(v)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(l), S = o(h, 2), w = S[0], O = S[1], j = (0, u.useState)(l), x = o(j, 2), _ = x[0], M = x[1], P = (0, u.useState)(f(v)), F = o(P, 2), E = F[0], k = F[1];
                function I(e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    k(f(e)), M(t), O(t), p(e), b(i.Time.getSecondsFromExpiry(e));
                }
                function D() {
                    var e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * g), I(e);
                }
                return (0, a.useInterval)(function() {
                    E !== c && k(c);
                    var e = i.Time.getSecondsFromExpiry(v);
                    b(e), e <= 0 && (i.Validate.onExpire(r) && r(), O(!1), k(null));
                }, w ? E : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        _ ? (b(i.Time.getSecondsFromExpiry(v)), O(!0)) : D();
                    },
                    pause: function() {
                        O(!1);
                    },
                    resume: D,
                    restart: I,
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2), c = 1e3;
            function f(e) {
                if (!i.Validate.expiryTimestamp(e)) return null;
                var t = i.Time.getSecondsFromExpiry(e), r = Math.floor(1e3 * (t - Math.floor(t)));
                return r > 0 ? r : c;
            }
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "getTimeFromSeconds",
                        value: function(e) {
                            var t = Math.ceil(e), r = Math.floor(t / 86400), n = Math.floor(t % 86400 / 3600), o = Math.floor(t % 3600 / 60);
                            return {
                                seconds: Math.floor(t % 60),
                                minutes: o,
                                hours: n,
                                days: r
                            };
                        }
                    },
                    {
                        key: "getSecondsFromExpiry",
                        value: function(e, t) {
                            var r = e - (new Date).getTime();
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromPrevTime",
                        value: function(e, t) {
                            var r = (new Date).getTime() - e;
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromTimeNow",
                        value: function() {
                            var e = new Date;
                            return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                        }
                    },
                    {
                        key: "getFormattedTimeFromSeconds",
                        value: function(t, r) {
                            var n = e.getTimeFromSeconds(t), o = n.seconds, u = n.minutes, i = n.hours, a = "", c = i;
                            return "12-hour" === r && (a = i >= 12 ? "pm" : "am", c = i % 12), {
                                seconds: o,
                                minutes: u,
                                hours: c,
                                ampm: a
                            };
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "expiryTimestamp",
                        value: function(e) {
                            var t = new Date(e).getTime() > 0;
                            return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                        }
                    },
                    {
                        key: "onExpire",
                        value: function(e) {
                            var t = e && "function" == typeof e;
                            return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = function(e, t) {
                var r = (0, n.useRef)();
                (0, n.useEffect)(function() {
                    r.current = e;
                }), (0, n.useEffect)(function() {
                    if (!t) return function() {};
                    var e = setInterval(function() {
                        r.current && r.current();
                    }, t);
                    return function() {
                        return clearInterval(e);
                    };
                }, [
                    t
                ]);
            };
            var n = r(0);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.autoStart, r = e.offsetTimestamp, c = (0, u.useState)(i.Time.getSecondsFromExpiry(r, !0) || 0), f = o(c, 2), s = f[0], l = f[1], d = (0, u.useState)(new Date), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(s + i.Time.getSecondsFromPrevTime(v || 0, !0)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(t), S = o(h, 2), w = S[0], O = S[1];
                return (0, a.useInterval)(function() {
                    b(s + i.Time.getSecondsFromPrevTime(v, !0));
                }, w ? 1e3 : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        var e = new Date;
                        p(e), O(!0), b(s + i.Time.getSecondsFromPrevTime(e, !0));
                    },
                    pause: function() {
                        l(g), O(!1);
                    },
                    reset: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = i.Time.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                        p(n), l(r), O(t), b(r + i.Time.getSecondsFromPrevTime(n, !0));
                    },
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.format, r = (0, u.useState)(i.Time.getSecondsFromTimeNow()), c = o(r, 2), f = c[0], s = c[1];
                return (0, a.useInterval)(function() {
                    s(i.Time.getSecondsFromTimeNow());
                }, 1e3), n({}, i.Time.getFormattedTimeFromSeconds(f, t));
            };
            var u = r(0), i = r(1), a = r(2);
        }
    ]);
});

});

parcelRegister("coPA5", function(module, exports) {

$parcel$export(module.exports, "messageNewValidation", () => $112aa8e3c7b6f377$export$ae2e2de34d81895c);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $112aa8e3c7b6f377$export$ae2e2de34d81895c = ()=>{
    return $hDGtv.create().shape({
        body: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
    });
};

});

parcelRegister("6nTql", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c4754330a4c807$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");
parcelRequire("jitSV");
var $hTUUb = parcelRequire("hTUUb");

var $agjF2 = parcelRequire("agjF2");
const $58c4754330a4c807$var$MessageAssetsField = ()=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const onChangeFiles = (event)=>{
        const selectedFiles = Array.from(event.currentTarget.files);
        const assetsData = selectedFiles.map((file)=>{
            return {
                assetType: "MessageDocument",
                file: file
            };
        });
        setFieldValue("assetsAttributes", assetsData);
    };
    const onRemoveFile = (file)=>{
        const filteredAssetsData = values.assetsAttributes.filter((assetData)=>{
            return assetData.file != file;
        });
        setFieldValue("assetsAttributes", filteredAssetsData);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-end",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $agjF2.default), {
                messageAssetsData: values.assetsAttributes,
                removeItem: onRemoveFile
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "ml-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "file",
                        id: "file",
                        multiple: true,
                        onChange: onChangeFiles,
                        className: "hidden"
                    }, values.assetsAttributes.length),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hTUUb.default), {
                        className: "w-4 h-4 text-ch-blue-alt-500 hover:text-ch-blue-alt-600 cursor-pointer"
                    })
                ]
            })
        ]
    });
};
var $58c4754330a4c807$export$2e2bcd8739ae039 = $58c4754330a4c807$var$MessageAssetsField;

});
parcelRegister("agjF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a936cd9e2161df36$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $llBOL = parcelRequire("llBOL");
const $a936cd9e2161df36$var$MessageAssetsFieldList = (props)=>{
    if (!props.messageAssetsData) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex gap-1",
        children: props.messageAssetsData.map((data, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $llBOL.default), {
                file: data.file,
                removeItem: props.removeItem
            }, index);
        })
    });
};
var $a936cd9e2161df36$export$2e2bcd8739ae039 = $a936cd9e2161df36$var$MessageAssetsFieldList;

});
parcelRegister("llBOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d66b8e5b6a5b7a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");
var $4rRXd = parcelRequire("4rRXd");
const $36d66b8e5b6a5b7a$var$MessageAssetsFieldListItem = (props)=>{
    const [imgSrc, setImgSrc] = (0, $acw62.useState)(null);
    if (!props.file) return null;
    (0, $acw62.useEffect)(()=>{
        if (props.file.type == "application/pdf") return;
        const url = URL.createObjectURL(props.file);
        setImgSrc(url);
    }, [
        props.file
    ]);
    const renderThumb = ()=>{
        if (props.file.type == "application/pdf") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-blue-alt-400 mr-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                className: "w-5 h-5"
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex w-5 h-5 items-center justify-center mr-1 overflow-hidden",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: imgSrc
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex py-0.5 pl-2 rounded-md border border-ch-gray-400 items-center",
        children: [
            renderThumb(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-xs",
                children: props.file.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                className: "text-ch-gray-500 hover:text-ch-red-500 cursor-pointer p-1",
                onClick: ()=>props.removeItem(props.file),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4rRXd.default), {
                    className: "w-3 h-3 fill-current mr-1"
                })
            })
        ]
    });
};
var $36d66b8e5b6a5b7a$export$2e2bcd8739ae039 = $36d66b8e5b6a5b7a$var$MessageAssetsFieldListItem;

});





parcelRegister("6UuII", function(module, exports) {

$parcel$export(module.exports, "default", () => $91caa0ec7da78810$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");

var $lCZwG = parcelRequire("lCZwG");

var $04A9g = parcelRequire("04A9g");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $eucKq = parcelRequire("eucKq");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $1Cmbh = parcelRequire("1Cmbh");
function $91caa0ec7da78810$export$2e2bcd8739ae039({ isOpen: isOpen, caseId: caseId, setIsOpen: setIsOpen }) {
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const close = ()=>setIsOpen(false);
    const closeButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: close,
        variant: (0, $jF0Xa.StyleVariants).PURPLE,
        children: t("continue")
    }, "2");
    if (!caseId) return;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: isOpen,
        style: (0, $jF0Xa.dialogueModalStyle),
        onRequestClose: close,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col mt-10  justify-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bg-ch-blue-200 flex w-full place-content-between",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: " p-2",
                                    children: "The following case now is being presented:"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center items-center mb-5 relative",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                                className: "sm:mr-4",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                                    className: "fill-current w-6 h-6",
                                                    title: t("shared:case")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eucKq.default), {
                                                caseId: caseId,
                                                hasLink: false
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center items-center mb-5 relative",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                closeButton
                            ]
                        })
                    })
                ]
            })
        })
    });
}

});
parcelRegister("eucKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea628f29ab95df8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $aeos3 = parcelRequire("aeos3");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $kon2z = parcelRequire("kon2z");

var $QwmFv = parcelRequire("QwmFv");

var $7hl6H = parcelRequire("7hl6H");

var $6ic8I = parcelRequire("6ic8I");

var $ljbUa = parcelRequire("ljbUa");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $3Ukkm = parcelRequire("3Ukkm");
const $dea628f29ab95df8$var$CaseDetails = ({ hasLink: hasLink = true, ...props })=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getLeadCareUserByCaseId)(state, props));
    if (!theCase || !theCase.id) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    const renderSignedOffBy = ()=>{
        if (!theCase.signedOffBy) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:signedOffBy"),
                ": ",
                theCase.signedOffBy
            ]
        });
    };
    const caseLinkPath = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
        caseId: theCase.id
    });
    const renderGender = ()=>{
        if (!theCase.gender) return null;
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(theCase.gender);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:gender"),
                ": ",
                t(`shared:${translationKey}`)
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ljbUa.default), {
                            case: theCase,
                            hasLink: hasLink,
                            link: caseLinkPath
                        })
                    }),
                    renderGender(),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("case:dateOfBirth"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                                utcTime: theCase.dateOfBirth
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            healthcareIdLabel,
                            ": ",
                            theCase.healthcareId || "-"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            careProviderIdLabel,
                            ": ",
                            theCase.careProviderId || "-"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("case:source"),
                            ": ",
                            theCase.sourceName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderLeadCare(),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("case:type"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                                caseType: theCase.caseType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:classification"),
                            ": ",
                            theCase.classification
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("case:lastUpdated"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: theCase.updatedAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ic8I.default), {
                        caseId: props.caseId
                    }),
                    renderSignedOffBy()
                ]
            })
        ]
    });
};
var $dea628f29ab95df8$export$2e2bcd8739ae039 = $dea628f29ab95df8$var$CaseDetails;

});



parcelRegister("236Dw", function(module, exports) {

$parcel$export(module.exports, "default", () => $305f5bb643bc65c7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $1MKdI = parcelRequire("1MKdI");

var $4fo4Z = parcelRequire("4fo4Z");

var $d5eYa = parcelRequire("d5eYa");

var $6lvMC = parcelRequire("6lvMC");

var $8UrgM = parcelRequire("8UrgM");
const $305f5bb643bc65c7$var$UserNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    const renderForm = ()=>{
        if (!currentUser.abilities?.user.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1MKdI.default), {});
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:users"),
                        href: (0, $6QJY8.RoutePaths).USERS
                    },
                    {
                        pageTitle: t("user:addANewUser")
                    }
                ]
            }),
            renderForm()
        ]
    });
};
var $305f5bb643bc65c7$export$2e2bcd8739ae039 = $305f5bb643bc65c7$var$UserNewPage;

});
parcelRegister("1MKdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d923e1414a276dd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $8e5HJ = parcelRequire("8e5HJ");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $ai857 = parcelRequire("ai857");

var $lp3wt = parcelRequire("lp3wt");

var $lqbsE = parcelRequire("lqbsE");

var $c0FI2 = parcelRequire("c0FI2");

var $5GZlj = parcelRequire("5GZlj");

var $6lvMC = parcelRequire("6lvMC");

var $d8Vwn = parcelRequire("d8Vwn");

var $4qaeN = parcelRequire("4qaeN");

var $hnLuc = parcelRequire("hnLuc");
const $1d923e1414a276dd$var$UserNewForm = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const specialties = (0, $iD0SF.useSelector)((state)=>(0, $lqbsE.getAllSpecialties)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const initialValues = {
        title: "",
        professionalTitle: "",
        firstName: "",
        lastName: "",
        email: "",
        specialtyIds: [],
        local: true
    };
    const titleOptions = Object.keys((0, $8e5HJ.UserTitles)).map((key)=>{
        return {
            value: (0, $8e5HJ.UserTitles)[key],
            label: key
        };
    });
    const usersEmail = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state)), "email");
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex justify-left pl-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $lp3wt.userNewValidationSchema)(usersEmail),
            validateOnMount: true,
            onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                dispatch((0, $ai857.createUserAction)(values));
                setSubmitting(false);
            },
            children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, isValid: isValid })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "title",
                                    children: t("user:title")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "title",
                                    options: titleOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.title,
                                    isVisible: errors.title && touched.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "professionalTitle",
                                    children: t("user:professionalTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "professionalTitle",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.professionalTitle,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.professionalTitle,
                                    isVisible: errors.professionalTitle && touched.professionalTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hnLuc.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "firstName",
                                    required: true,
                                    children: t("user:firstName")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "firstName",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.firstName,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.firstName,
                                    isVisible: errors.firstName && touched.firstName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "lastName",
                                    required: true,
                                    children: t("user:lastName")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "lastName",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.lastName,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.lastName,
                                    isVisible: errors.lastName && touched.lastName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "email",
                                    required: true,
                                    children: t("user:email")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "email",
                                    name: "email",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.email,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.email,
                                    isVisible: errors.email && touched.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "specialtyIds",
                                    children: t("user:specialties")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "specialtyIds",
                                    options: specialtiesOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    isMulti: true,
                                    isGrouped: true,
                                    closeMenuOnSelect: false
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.specialtyIds,
                                    isVisible: errors.specialtyIds && touched.specialtyIds
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: isSubmitting || !isValid,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("user:createUser")
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $1d923e1414a276dd$export$2e2bcd8739ae039 = $1d923e1414a276dd$var$UserNewForm;

});
parcelRegister("lp3wt", function(module, exports) {

$parcel$export(module.exports, "userNewValidationSchema", () => $3dba15c97a41d84d$export$faccaf19bbcbd51d);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $3dba15c97a41d84d$export$faccaf19bbcbd51d = (usersEmail)=>{
    return $hDGtv.create().shape({
        firstName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        lastName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        email: $gcL7X.create().trim().email((0, $5wPBK.default).t("shared:invalidEmail")).required((0, $5wPBK.default).t("shared:required")).notOneOf(usersEmail, (0, $5wPBK.default).t("shared:emailExists"))
    });
};

});

parcelRegister("lqbsE", function(module, exports) {

$parcel$export(module.exports, "getAllSpecialties", () => $1c04bdfd941a8406$export$9cf1f796e4f99f6e);
$parcel$export(module.exports, "getSpecialtyById", () => $1c04bdfd941a8406$export$6d25da0a61b57e1c);
const $1c04bdfd941a8406$export$9cf1f796e4f99f6e = (state)=>state.entities.specialties.byId;
const $1c04bdfd941a8406$export$1ff0e13d422619af = (state)=>state.entities.specialties.allIds;
const $1c04bdfd941a8406$export$6d25da0a61b57e1c = (state, id)=>state.entities.specialties.byId[id];

});

parcelRegister("c0FI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea3e46403254fa0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $3ea3e46403254fa0$var$DenotesRequiredMessage = (_props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mb-2",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "text-ch-blue-alt-300",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-ch-purple-500",
                    children: "*"
                }),
                "\xa0",
                t("shared:denotedRequired")
            ]
        })
    });
};
var $3ea3e46403254fa0$export$2e2bcd8739ae039 = $3ea3e46403254fa0$var$DenotesRequiredMessage;

});

parcelRegister("d8Vwn", function(module, exports) {

$parcel$export(module.exports, "generateSpecialtyOptions", () => $63b5b84e405556c5$export$defaebf7996768ce);
$parcel$export(module.exports, "generateCaseClassificationOptions", () => $63b5b84e405556c5$export$a7f74e39b0c312fe);
$parcel$export(module.exports, "generateCaseSourceOptions", () => $63b5b84e405556c5$export$89082f860084cc5e);
$parcel$export(module.exports, "generateTeamOptions", () => $63b5b84e405556c5$export$ca767895a8ad506e);

var $f1q41 = parcelRequire("f1q41");

var $6qYxq = parcelRequire("6qYxq");
const $63b5b84e405556c5$export$d175e48d35ace8ba = (optionsById)=>{
    const groupedClassificationOptions = [];
    Object.values(optionsById).forEach((option)=>{
        if (option.parentId) return;
        const parentOption = {
            value: option.id,
            label: option.name,
            options: [
                {
                    value: option.id,
                    label: option.name
                }
            ]
        };
        if (option.children.length > 0) {
            const childOptions = option.children.map((optionChildId)=>{
                const optionChild = optionsById[optionChildId];
                return {
                    value: optionChild.id,
                    label: optionChild.name
                };
            });
            parentOption.options = [
                parentOption,
                ...childOptions
            ];
        }
        groupedClassificationOptions.push(parentOption);
    });
    return groupedClassificationOptions;
};
const $63b5b84e405556c5$export$defaebf7996768ce = (specialties)=>{
    return $63b5b84e405556c5$export$d175e48d35ace8ba(specialties);
};
const $63b5b84e405556c5$export$a7f74e39b0c312fe = (caseClassifications, caseType)=>{
    // Suspected Cancer case type will show same classifications as Cancer
    const fitlerCaseType = caseType == (0, $6qYxq.CaseTypes).SuspectedCancer ? (0, $6qYxq.CaseTypes).Cancer : caseType;
    const classifications = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pickBy(caseClassifications, (caseClassification)=>fitlerCaseType == caseClassification.caseType);
    return $63b5b84e405556c5$export$d175e48d35ace8ba(classifications);
};
const $63b5b84e405556c5$export$89082f860084cc5e = (sources)=>{
    const groupedSourceOptions = [];
    const groupedSources = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).groupBy(sources, "regionalTeam");
    Object.entries(groupedSources).forEach((group)=>{
        const parentOption = {
            value: group[0],
            label: group[0],
            options: group[1].map((option)=>{
                return {
                    value: option.id,
                    label: option.name
                };
            })
        };
        groupedSourceOptions.push(parentOption);
    });
    return groupedSourceOptions;
};
const $63b5b84e405556c5$export$ca767895a8ad506e = (teams)=>{
    return teams.map((team)=>{
        return {
            value: team.id,
            label: team.name
        };
    });
};

});

parcelRegister("4qaeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54b9935be7387c6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $e54b9935be7387c6$var$Card = (props)=>{
    const defaultClasses = [
        "mb-2",
        "bg-white",
        "border",
        "border-ch-gray-400",
        "rounded-md p-4"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: props.children
    });
};
var $e54b9935be7387c6$export$2e2bcd8739ae039 = $e54b9935be7387c6$var$Card;

});

parcelRegister("hnLuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $69785659353ce8c9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kQILj = parcelRequire("kQILj");
parcelRequire("jitSV");
var $9IdeF = parcelRequire("9IdeF");

var $8jo8K = parcelRequire("8jo8K");

var $9k8Fh = parcelRequire("9k8Fh");

var $ai857 = parcelRequire("ai857");

var $8eVNb = parcelRequire("8eVNb");
const $69785659353ce8c9$var$ExistingUserWarning = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { values: values, errors: errors } = (0, $7YFi7.useFormikContext)();
    const userCheckUI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getUserCheckUI)(state));
    const throttledUserCheck = (0, $acw62.useMemo)(()=>{
        const throttleOptions = {
            leading: false,
            trailing: true
        };
        return (0, $f1q41.throttle)((userCheckData)=>dispatch((0, $ai857.checkUserAction)(userCheckData)), 1000, throttleOptions);
    }, []);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $ai857.resetCheckUserAction)());
        return ()=>{
            dispatch((0, $ai857.resetCheckUserAction)());
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        // only run the check if the email is present and valid, or when both first an( last name are present
        if (values.email && !errors.email || values.firstName && values.lastName && values.lastName.length > 1) {
            const userCheckData = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email
            };
            throttledUserCheck(userCheckData);
        } else dispatch((0, $ai857.resetCheckUserAction)());
    }, [
        values.firstName,
        values.lastName,
        values.email
    ]);
    if (!userCheckUI?.existingUserIds?.length) return null;
    const inviteButtonForUser = (userId)=>{
        if (props.caseId) return [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8jo8K.default), {
                caseId: props.caseId,
                userId: userId,
                closeModal: props.closeModal
            }, userId)
        ];
        return [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8eVNb.default), {
                userId: userId,
                createAsGuest: props.canInviteAsGuest,
                closeModal: props.closeModal
            }, userId)
        ];
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "my-5 text-ch-gray-600 mb-3 p-3 rounded-md bg-ch-blue-100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "flex font-semibold text-ch-blue-alt-500 mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9IdeF.default), {
                        className: "w-5 h-5 mr-2"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t("user:userCheck:messages:existingUsersFound")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mb-2",
                children: t("user:userCheck:text:existingUserInfo")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: userCheckUI?.existingUserIds?.map((userId)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9k8Fh.default), {
                        userId: userId,
                        buttons: inviteButtonForUser(userId)
                    }, userId);
                })
            })
        ]
    });
};
var $69785659353ce8c9$export$2e2bcd8739ae039 = $69785659353ce8c9$var$ExistingUserWarning;

});
parcelRegister("8jo8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd45672febd68a6f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $cA1jy = parcelRequire("cA1jy");

var $kon2z = parcelRequire("kon2z");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $2usJc = parcelRequire("2usJc");
const $cd45672febd68a6f$var$InviteExistingGuestUserButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.userId));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    const addGuestUserToCaseMembers = ()=>{
        const data = {
            id: theCase.id,
            memberIds: [
                ...theCase.members,
                props.userId
            ]
        };
        dispatch((0, $2usJc.updateCaseMembers)(data));
        props.closeModal();
    };
    if (!theCase || !(0, $cA1jy.isGuest)(user)) return null;
    if (theCase.members.includes(props.userId)) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: t("user:userCheck:text:isAMember")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: addGuestUserToCaseMembers,
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: t("user:userCheck:buttons:inviteGuestToCase")
    }, props.userId);
};
var $cd45672febd68a6f$export$2e2bcd8739ae039 = $cd45672febd68a6f$var$InviteExistingGuestUserButton;

});

parcelRegister("9k8Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $522f2c31e87fbcc1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $6QJY8 = parcelRequire("6QJY8");

var $COwA0 = parcelRequire("COwA0");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $l30Z2 = parcelRequire("l30Z2");
const $522f2c31e87fbcc1$var$UserListItem = ({ buttons: buttons = [], ...props })=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    if (!user) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const editUserUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).USER_EDIT, {
        userId: props.userId
    });
    const renderButtons = ()=>{
        if (props.hideButtons) return null;
        if (buttons.length) return buttons;
        if (user?.permissions?.canEdit) return [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                href: editUserUrl,
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                children: t("shared:edit")
            }, props.userId)
        ];
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: renderButtons()
                    })
                })
            ]
        })
    });
};
var $522f2c31e87fbcc1$export$2e2bcd8739ae039 = $522f2c31e87fbcc1$var$UserListItem;

});
parcelRegister("ejvqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $af1a13575fc0a73e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $af1a13575fc0a73e$var$DetailsCardButtons = (props)=>{
    if (!props.buttons) return null;
    const defaultClasses = [
        "flex",
        "flex-wrap",
        "flex-1",
        "justify-center",
        "lg:justify-end"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: allClasses,
        children: props.buttons.map((button, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "ml-2 mb-2",
                children: button
            }, index);
        })
    });
};
var $af1a13575fc0a73e$export$2e2bcd8739ae039 = $af1a13575fc0a73e$var$DetailsCardButtons;

});

parcelRegister("l30Z2", function(module, exports) {

$parcel$export(module.exports, "default", () => $542d28c751619054$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $chRXN = parcelRequire("chRXN");

var $5qJbh = parcelRequire("5qJbh");
const $542d28c751619054$var$UserDetailsCard = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-1 items-center", {
            "text-ch-gray-500": !props.user.activeInCurrentTenant
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                className: "mr-4",
                colour: props.user.activeInCurrentTenant ? null : "text-ch-gray-500",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chRXN.default), {
                    className: "fill-current w-6 h-6"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5qJbh.default), {
                    userId: props.user.id,
                    nameLabel: props.nameLabel,
                    label: props.label
                })
            })
        ]
    });
};
var $542d28c751619054$export$2e2bcd8739ae039 = $542d28c751619054$var$UserDetailsCard;

});
parcelRegister("5qJbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $71554fb2a0eac85b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $kYqkq = parcelRequire("kYqkq");

var $6t04b = parcelRequire("6t04b");

var $6lvMC = parcelRequire("6lvMC");

var $pNlig = parcelRequire("pNlig");

var $4KSAX = parcelRequire("4KSAX");

var $aEgqS = parcelRequire("aEgqS");

var $cA1jy = parcelRequire("cA1jy");
const $71554fb2a0eac85b$var$UserDetails = (props)=>{
    const user = (0, $kYqkq.useAppSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    if (!user) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const renderProfessionalTitle = ()=>{
        if (!user.professionalTitle) return null;
        if (user.organisation) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                user.professionalTitle,
                " (",
                user.organisation,
                ")"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: user.professionalTitle
        });
    };
    const renderEmail = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser) || !currentUser.abilities?.user?.canList) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "truncate",
            children: user.email
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                            firstName: user.firstName,
                            lastName: user.lastName,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("font-semibold", {
                                "text-ch-gray-500": !user.activeInCurrentTenant
                            }),
                            label: props.nameLabel,
                            isPending: user.pending,
                            isGuest: (0, $cA1jy.isGuest)(user)
                        })
                    }),
                    renderProfessionalTitle()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderEmail(),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: "text-ch-gray-alt-500 italic",
                        children: [
                            t("user:lastOnline"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $pNlig.default), {
                                utcTime: user.lastSeenInCurrentTenant
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: props.label
                    })
                ]
            })
        ]
    });
};
var $71554fb2a0eac85b$export$2e2bcd8739ae039 = $71554fb2a0eac85b$var$UserDetails;

});
parcelRegister("pNlig", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a84dc354f22f096$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8xDhD = parcelRequire("8xDhD");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7hl6H = parcelRequire("7hl6H");
const $3a84dc354f22f096$var$TimeAgo = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const timeAgoInWords = (utcTime, timeNow)=>{
        const timeAgoInSeconds = (0, $8xDhD.default)(timeNow, utcTime);
        if (timeAgoInSeconds < 0) return t("shared:time:fewSecondsAgo");
        const days = Math.floor(timeAgoInSeconds / 60 / 60 / 24);
        const hours = Math.floor(timeAgoInSeconds / 60 / 60) - days * 24;
        const minutes = Math.floor(timeAgoInSeconds / 60) - days * 1440 - hours * 60;
        if (days >= 1 && days <= 3) return days + " " + (days > 1 ? t("shared:time:days") : t("shared:time:day")) + " " + t("shared:time:ago");
        if (hours >= 1) return hours + " " + (hours > 1 ? t("shared:time:hours") : t("shared:time:hour")) + " " + t("shared:time:ago");
        if (minutes >= 1) return minutes + " " + (minutes > 1 ? t("shared:time:minutes") : t("shared:time:minute")) + " " + t("shared:time:ago");
        if (minutes < 1) return t("shared:time:fewSecondsAgo");
    };
    if (!props.utcTime) return null;
    const now = new Date();
    const utcDate = new Date(props.utcTime);
    const days = Math.floor((0, $8xDhD.default)(now, utcDate) / 60 / 60 / 24);
    if (days > 3) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
            className: props.className,
            utcTime: props.utcTime,
            withoutTZ: true
        })
    });
    const timeAgoText = timeAgoInWords(utcDate, now);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: props.className,
        children: timeAgoText
    });
};
var $3a84dc354f22f096$export$2e2bcd8739ae039 = $3a84dc354f22f096$var$TimeAgo;

});




parcelRegister("8eVNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e1583c0a912b50$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $kYqkq = parcelRequire("kYqkq");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $ai857 = parcelRequire("ai857");
const $00e1583c0a912b50$var$AddUserToTenantButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const user = (0, $kYqkq.useAppSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const translationKey = props.createAsGuest ? "user:userCheck:buttons:addGuestToTenant" : "user:userCheck:buttons:addUserToTenant";
    const addGuestUserToCaseMembers = ()=>{
        const type = props.createAsGuest ? "guest" : "participant";
        dispatch((0, $ai857.addUserToCurrentTenantAction)(props.userId, type));
        if (props.closeModal) props.closeModal();
    };
    if (user.existsInCurrentTenant) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: t("user:userCheck:text:userAlreadyExistsInTenant")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: addGuestUserToCaseMembers,
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: t(translationKey)
    }, props.userId);
};
var $00e1583c0a912b50$export$2e2bcd8739ae039 = $00e1583c0a912b50$var$AddUserToTenantButton;

});



parcelRegister("4fo4Z", function(module, exports) {

$parcel$export(module.exports, "fetchSpecialtiesAsync", () => $d0633c6dd97f3604$export$c409449300259726);

var $5yBCT = parcelRequire("5yBCT");
const $d0633c6dd97f3604$export$c409449300259726 = ()=>{
    return {
        type: (0, $5yBCT.SpecialtyActionTypes).FETCH_SPECIALTIES_ASYNC_PENDING
    };
};

});

parcelRegister("d5eYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6630d0a787ad79d8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1DXYh = parcelRequire("1DXYh");
const $6630d0a787ad79d8$var$Breadcrumbs = (props)=>{
    const renderBreadcrumb = (breadcrumb)=>{
        if (breadcrumb.href) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                    href: breadcrumb.href,
                    className: "font-semibold",
                    children: breadcrumb.pageTitle
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: "\xa0/\xa0"
                })
            ]
        });
        if (!breadcrumb.href) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: breadcrumb.pageTitle
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        className: "flex flex-wrap mb-4 text-lg",
        children: props.breadcrumbs.map((breadcrumb, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: renderBreadcrumb(breadcrumb)
            }, `breadcrumb-${index}`);
        })
    });
};
var $6630d0a787ad79d8$export$2e2bcd8739ae039 = $6630d0a787ad79d8$var$Breadcrumbs;

});


parcelRegister("jcbSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4851cf4812a502be$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $4fo4Z = parcelRequire("4fo4Z");

var $d5eYa = parcelRequire("d5eYa");

var $6lvMC = parcelRequire("6lvMC");

var $8UrgM = parcelRequire("8UrgM");

var $6FjVe = parcelRequire("6FjVe");
const $4851cf4812a502be$var$UserNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    const renderForm = ()=>{
        if (!currentUser.abilities?.user.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6FjVe.default), {});
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:users"),
                        href: (0, $6QJY8.RoutePaths).USERS
                    },
                    {
                        pageTitle: t("user:addANewGuestUser")
                    }
                ]
            }),
            renderForm()
        ]
    });
};
var $4851cf4812a502be$export$2e2bcd8739ae039 = $4851cf4812a502be$var$UserNewPage;

});
parcelRegister("6FjVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f9101c3b8fe5588$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $8UrgM = parcelRequire("8UrgM");

var $lxAyE = parcelRequire("lxAyE");


var $cjnbD = parcelRequire("cjnbD");

var $ai857 = parcelRequire("ai857");

var $dBkgc = parcelRequire("dBkgc");
const $2f9101c3b8fe5588$var$GuestUserNewForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const allUsers = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    const initialValues = {
        title: "",
        professionalTitle: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        specialtyIds: []
    };
    const usersEmail = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(allUsers, "email");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $cjnbD.caseGuestUserNewValidationSchema)(usersEmail),
        validateOnMount: true,
        onSubmit: async (values)=>{
            const phoneNumberData = (0, $lxAyE.parsePhoneNumber)(values.phoneNumber);
            const data = {
                ...values,
                phoneNumber: phoneNumberData.nationalNumber,
                phoneCountryCode: phoneNumberData.countryCallingCode
            };
            dispatch((0, $ai857.createGuestUser)(data));
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dBkgc.default), {
            ...props
        })
    });
};
var $2f9101c3b8fe5588$export$2e2bcd8739ae039 = $2f9101c3b8fe5588$var$GuestUserNewForm;

});
parcelRegister("lxAyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae909b2a8c6cde8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "parsePhoneNumber", () => $fae909b2a8c6cde8$export$da44e4eaa54bc82e);
$parcel$export(module.exports, "isValidPhoneNumber", () => $fae909b2a8c6cde8$export$992e2df24bec72ba);

var $4fWe9 = parcelRequire("4fWe9");

var $jcxly = parcelRequire("jcxly");
var $4wSUA = parcelRequire("4wSUA");
var $lijQr = parcelRequire("lijQr");
var $8BZip = parcelRequire("8BZip");
var $g7TUG = parcelRequire("g7TUG");
var $gAr6H = parcelRequire("gAr6H");

var $72YWg = parcelRequire("72YWg");
function $fae909b2a8c6cde8$var$call(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4fWe9.default));
    return func.apply(this, args);
}
var $fae909b2a8c6cde8$export$2e2bcd8739ae039 = (0, $72YWg.createPhoneInput)((0, $4fWe9.default));
function $fae909b2a8c6cde8$export$da44e4eaa54bc82e() {
    return $fae909b2a8c6cde8$var$call((0, $gAr6H.default), arguments);
}
function $fae909b2a8c6cde8$export$842dcfa371c6bb83() {
    return $fae909b2a8c6cde8$var$call((0, $jcxly.default), arguments);
}
function $fae909b2a8c6cde8$export$88012462592bc004() {
    return $fae909b2a8c6cde8$var$call((0, $jcxly.formatPhoneNumberIntl), arguments);
}
function $fae909b2a8c6cde8$export$992e2df24bec72ba() {
    return $fae909b2a8c6cde8$var$call((0, $g7TUG.default), arguments);
}
function $fae909b2a8c6cde8$export$e102acdf1aeb3167() {
    return $fae909b2a8c6cde8$var$call((0, $8BZip.default), arguments);
}
function $fae909b2a8c6cde8$export$44f7508c6c352cc6() {
    return $fae909b2a8c6cde8$var$call((0, $4wSUA.default), arguments);
}
function $fae909b2a8c6cde8$export$32876ca2f1919cf0() {
    return $fae909b2a8c6cde8$var$call((0, $lijQr.getCountryCallingCode), arguments);
}
function $fae909b2a8c6cde8$export$bd9e113b8b17202a() {
    return $fae909b2a8c6cde8$var$call((0, $lijQr.isSupportedCountry), arguments);
}

});
parcelRegister("4fWe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3195bad5b20c0860$export$2e2bcd8739ae039);
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $3195bad5b20c0860$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([457]\\d{6})$",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2457]\\d{6})$",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([267]\\d{6})$",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "0|(183[12])",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[047]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:[25689]\\d|40)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-8]\\d{6})$",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-79]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "0|(1(?:[12]\\d|79)\\d\\d)",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0(4(?:[14]4|56)|[579])?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[189]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94|80\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([25-9]\\d{5})$",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d\\d|606)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-9]\\d{6})$",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "[2-489]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-489]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([25-8]\\d{5})$",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([0-24-8]\\d{5})$",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "0|(1001)"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29[1289]|389)",
                        "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|([24-9]\\d{6})$",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([34]\\d{6})$",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[3467]|9[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[04]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[489]|59"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "(?:[45]|80\\d\\d)\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[126]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "976\\d{6}|(?:26|[68]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "26[23]|69|[89]"
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-6]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3478]|64|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|(5\\d{6})$",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-479]\\d{6})$",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "(?:00|[1-57-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7|91[78]"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-46-8]\\d{6})$",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46]))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:33|55|[679]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[35-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-578]\\d{6})$",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[69]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7[24-68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "80\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "269|63"
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|(?:285|50\\d)\\d{9}|(?:[19]\\d|49)\\d{6}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "4"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "2\\d{9}(?:\\d{2})?|51\\d{7}|(?:370|51\\d)\\d{9}",
            [
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});

parcelRegister("jcxly", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa9013f08ee2b8a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatPhoneNumberIntl", () => $dfa9013f08ee2b8a$export$88012462592bc004);

var $gAr6H = parcelRequire("gAr6H");
function $dfa9013f08ee2b8a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dfa9013f08ee2b8a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dfa9013f08ee2b8a$var$_typeof(obj);
}
function $dfa9013f08ee2b8a$export$2e2bcd8739ae039(value, format, metadata) {
    if (!metadata) {
        if ($dfa9013f08ee2b8a$var$_typeof(format) === 'object') {
            metadata = format;
            format = 'NATIONAL';
        }
    }
    if (!value) return '';
    var phoneNumber = (0, $gAr6H.default)(value, metadata);
    if (!phoneNumber) return '';
     // Deprecated.
    // Legacy `format`s.
    switch(format){
        case 'National':
            format = 'NATIONAL';
            break;
        case 'International':
            format = 'INTERNATIONAL';
            break;
    }
    return phoneNumber.format(format);
}
function $dfa9013f08ee2b8a$export$88012462592bc004(value, metadata) {
    return $dfa9013f08ee2b8a$export$2e2bcd8739ae039(value, 'INTERNATIONAL', metadata);
}

});
parcelRegister("gAr6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c13509054e39a1d1$export$2e2bcd8739ae039);

var $lORaT = parcelRequire("lORaT");

var $lnAnA = parcelRequire("lnAnA");
function $c13509054e39a1d1$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $lORaT.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $lnAnA.default)(text, options, metadata);
}

});
parcelRegister("lORaT", function(module, exports) {

$parcel$export(module.exports, "normalizeArguments", () => $fe2783d9f9ccca74$export$abc60e668512edf9);

var $aKJ8g = parcelRequire("aKJ8g");
function $fe2783d9f9ccca74$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fe2783d9f9ccca74$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fe2783d9f9ccca74$var$_typeof(obj);
}
function $fe2783d9f9ccca74$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fe2783d9f9ccca74$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fe2783d9f9ccca74$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fe2783d9f9ccca74$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fe2783d9f9ccca74$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fe2783d9f9ccca74$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fe2783d9f9ccca74$var$_slicedToArray(arr, i) {
    return $fe2783d9f9ccca74$var$_arrayWithHoles(arr) || $fe2783d9f9ccca74$var$_iterableToArrayLimit(arr, i) || $fe2783d9f9ccca74$var$_unsupportedIterableToArray(arr, i) || $fe2783d9f9ccca74$var$_nonIterableRest();
}
function $fe2783d9f9ccca74$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe2783d9f9ccca74$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe2783d9f9ccca74$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe2783d9f9ccca74$var$_arrayLikeToArray(o, minLen);
}
function $fe2783d9f9ccca74$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fe2783d9f9ccca74$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fe2783d9f9ccca74$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fe2783d9f9ccca74$export$2e2bcd8739ae039() {
    var _normalizeArguments = $fe2783d9f9ccca74$export$abc60e668512edf9(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $aKJ8g.default)(text, options, metadata);
}
function $fe2783d9f9ccca74$export$abc60e668512edf9(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $fe2783d9f9ccca74$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $fe2783d9f9ccca74$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ($fe2783d9f9ccca74$var$isObject(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
} // Otherwise istanbul would show this as "branch not covered".
/* istanbul ignore next */ var $fe2783d9f9ccca74$var$isObject = function isObject(_) {
    return $fe2783d9f9ccca74$var$_typeof(_) === 'object';
};

});
parcelRegister("aKJ8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d413597caf73a03$export$2e2bcd8739ae039);

var $fQWPU = parcelRequire("fQWPU");
function $7d413597caf73a03$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d413597caf73a03$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d413597caf73a03$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7d413597caf73a03$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d413597caf73a03$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7d413597caf73a03$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d413597caf73a03$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $fQWPU.default)(text, $7d413597caf73a03$var$_objectSpread($7d413597caf73a03$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRegister("fQWPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a959fb4d51e573$export$2e2bcd8739ae039);
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $hoHfs = parcelRequire("hoHfs");

var $1nVPX = parcelRequire("1nVPX");

var $lijQr = parcelRequire("lijQr");

var $6K6oP = parcelRequire("6K6oP");

var $a5PYs = parcelRequire("a5PYs");

var $81pt0 = parcelRequire("81pt0");

var $lijQr = parcelRequire("lijQr");

var $idCyj = parcelRequire("idCyj");

var $cJRin = parcelRequire("cJRin");

var $3bOc3 = parcelRequire("3bOc3");

var $jyfse = parcelRequire("jyfse");

var $l3IVT = parcelRequire("l3IVT");


var $lO22f = parcelRequire("lO22f");


var $3wXuM = parcelRequire("3wXuM");
// This prevents malicious input from consuming CPU.
var $b8a959fb4d51e573$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $b8a959fb4d51e573$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $hoHfs.PLUS_CHARS) + (0, $hoHfs.VALID_DIGITS) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $b8a959fb4d51e573$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $hoHfs.VALID_DIGITS) + '#' + ']+$');
var $b8a959fb4d51e573$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $b8a959fb4d51e573$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $lijQr.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $1nVPX.default)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $b8a959fb4d51e573$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $1nVPX.default)('TOO_SHORT');
            throw new (0, $1nVPX.default)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $b8a959fb4d51e573$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $1nVPX.default)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $hoHfs.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $1nVPX.default)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $hoHfs.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $1nVPX.default)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $3bOc3.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $b8a959fb4d51e573$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $idCyj.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $b8a959fb4d51e573$var$extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $b8a959fb4d51e573$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $1nVPX.default)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($b8a959fb4d51e573$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($b8a959fb4d51e573$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $b8a959fb4d51e573$var$parseInput(text, v2, extract) {
    // Parse RFC 3966 phone number URI.
    if (text && text.indexOf('tel:') === 0) return (0, $cJRin.parseRFC3966)(text);
    var number = $b8a959fb4d51e573$var$extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $6K6oP.default)(number)) {
        if ((0, $6K6oP.isViablePhoneNumberStart)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $a5PYs.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $b8a959fb4d51e573$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $b8a959fb4d51e573$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $l3IVT.default)((0, $81pt0.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($b8a959fb4d51e573$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $lijQr.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $lO22f.default)((0, $81pt0.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $3wXuM.default)(countryCallingCode, nationalNumber, metadata);
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("hoHfs", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", () => $caa639c664fc3f13$export$cd8355bcbe13154);
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", () => $caa639c664fc3f13$export$85ddd8c9b243679b);
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", () => $caa639c664fc3f13$export$514717690676fb4a);
$parcel$export(module.exports, "VALID_DIGITS", () => $caa639c664fc3f13$export$852d1d4a47329634);
$parcel$export(module.exports, "VALID_PUNCTUATION", () => $caa639c664fc3f13$export$7f01587e28f9194);
$parcel$export(module.exports, "PLUS_CHARS", () => $caa639c664fc3f13$export$207c99ccf3902df8);
// The minimum length of the national significant number.
var $caa639c664fc3f13$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $caa639c664fc3f13$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $caa639c664fc3f13$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $caa639c664fc3f13$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $caa639c664fc3f13$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $caa639c664fc3f13$var$SLASHES = "\uFF0F/";
var $caa639c664fc3f13$var$DOTS = "\uFF0E.";
var $caa639c664fc3f13$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $caa639c664fc3f13$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $caa639c664fc3f13$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $caa639c664fc3f13$export$7f01587e28f9194 = "".concat($caa639c664fc3f13$var$DASHES).concat($caa639c664fc3f13$var$SLASHES).concat($caa639c664fc3f13$var$DOTS).concat($caa639c664fc3f13$export$20542845033f576e).concat($caa639c664fc3f13$var$BRACKETS).concat($caa639c664fc3f13$var$TILDES);
var $caa639c664fc3f13$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRegister("1nVPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1024cdac75ec2b33$export$2e2bcd8739ae039);
function $1024cdac75ec2b33$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1024cdac75ec2b33$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1024cdac75ec2b33$var$_typeof(obj);
}
function $1024cdac75ec2b33$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1024cdac75ec2b33$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1024cdac75ec2b33$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1024cdac75ec2b33$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1024cdac75ec2b33$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1024cdac75ec2b33$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1024cdac75ec2b33$var$_setPrototypeOf(subClass, superClass);
}
function $1024cdac75ec2b33$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1024cdac75ec2b33$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1024cdac75ec2b33$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1024cdac75ec2b33$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1024cdac75ec2b33$var$_possibleConstructorReturn(this, result);
    };
}
function $1024cdac75ec2b33$var$_possibleConstructorReturn(self, call) {
    if (call && ($1024cdac75ec2b33$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1024cdac75ec2b33$var$_assertThisInitialized(self);
}
function $1024cdac75ec2b33$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1024cdac75ec2b33$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $1024cdac75ec2b33$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$1024cdac75ec2b33$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $1024cdac75ec2b33$var$_construct(Class, arguments, $1024cdac75ec2b33$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $1024cdac75ec2b33$var$_setPrototypeOf(Wrapper, Class);
    };
    return $1024cdac75ec2b33$var$_wrapNativeSuper(Class);
}
function $1024cdac75ec2b33$var$_construct(Parent, args, Class) {
    if ($1024cdac75ec2b33$var$_isNativeReflectConstruct()) $1024cdac75ec2b33$var$_construct = Reflect.construct;
    else $1024cdac75ec2b33$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $1024cdac75ec2b33$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $1024cdac75ec2b33$var$_construct.apply(null, arguments);
}
function $1024cdac75ec2b33$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1024cdac75ec2b33$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $1024cdac75ec2b33$var$_setPrototypeOf(o, p) {
    $1024cdac75ec2b33$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1024cdac75ec2b33$var$_setPrototypeOf(o, p);
}
function $1024cdac75ec2b33$var$_getPrototypeOf(o) {
    $1024cdac75ec2b33$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1024cdac75ec2b33$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $1024cdac75ec2b33$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $1024cdac75ec2b33$var$_inherits(ParseError, _Error);
    var _super = $1024cdac75ec2b33$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $1024cdac75ec2b33$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($1024cdac75ec2b33$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $1024cdac75ec2b33$var$_createClass(ParseError);
}(/*#__PURE__*/ $1024cdac75ec2b33$var$_wrapNativeSuper(Error));

});

parcelRegister("lijQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80aac35004a54c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCountryCallingCode", () => $f80aac35004a54c3$export$32876ca2f1919cf0);
$parcel$export(module.exports, "isSupportedCountry", () => $f80aac35004a54c3$export$bd9e113b8b17202a);

var $25Yvi = parcelRequire("25Yvi");
function $f80aac35004a54c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f80aac35004a54c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f80aac35004a54c3$var$_typeof(obj);
}
function $f80aac35004a54c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f80aac35004a54c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f80aac35004a54c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f80aac35004a54c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f80aac35004a54c3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $f80aac35004a54c3$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $f80aac35004a54c3$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $f80aac35004a54c3$var$V4 = '1.7.35';
var $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $f80aac35004a54c3$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $f80aac35004a54c3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Metadata);
        $f80aac35004a54c3$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, metadata);
    }
    $f80aac35004a54c3$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $f80aac35004a54c3$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $f80aac35004a54c3$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $f80aac35004a54c3$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $f80aac35004a54c3$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $f80aac35004a54c3$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $f80aac35004a54c3$var$getType(this.types(), _type2)) return new $f80aac35004a54c3$var$Type($f80aac35004a54c3$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $f80aac35004a54c3$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $f80aac35004a54c3$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $f80aac35004a54c3$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $f80aac35004a54c3$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!$f80aac35004a54c3$var$is_object(metadata) || !$f80aac35004a54c3$var$is_object(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($f80aac35004a54c3$var$is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $f80aac35004a54c3$var$type_of(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f80aac35004a54c3$var$is_object = function is_object(_) {
    return $f80aac35004a54c3$var$_typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f80aac35004a54c3$var$type_of = function type_of(_) {
    return $f80aac35004a54c3$var$_typeof(_);
};
function $f80aac35004a54c3$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
}
function $f80aac35004a54c3$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $f80aac35004a54c3$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries[country] !== undefined;
}
function $f80aac35004a54c3$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $25Yvi.default)(version, $f80aac35004a54c3$var$V3) === -1) this.v2 = true;
        else if ((0, $25Yvi.default)(version, $f80aac35004a54c3$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("25Yvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $186afb3191e0d707$export$2e2bcd8739ae039);
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $186afb3191e0d707$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});


parcelRegister("6K6oP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8c00bca37e184a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isViablePhoneNumberStart", () => $4e8c00bca37e184a$export$4c3f76c95c05197c);

var $hoHfs = parcelRequire("hoHfs");

var $gVDsZ = parcelRequire("gVDsZ");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $hoHfs.VALID_DIGITS) + ']{' + (0, $hoHfs.MIN_LENGTH_FOR_NSN) + '}'; //
var $4e8c00bca37e184a$export$a77dd7471651eee = '[' + (0, $hoHfs.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '[' + (0, $hoHfs.VALID_DIGITS) + ']' + '){3,}' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $hoHfs.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '[' + (0, $hoHfs.VALID_DIGITS) + ']' + '){1,2}' + '$', 'i');
var $4e8c00bca37e184a$export$a2d12a04749c087d = $4e8c00bca37e184a$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $gVDsZ.default)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $4e8c00bca37e184a$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $4e8c00bca37e184a$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $hoHfs.MIN_LENGTH_FOR_NSN) && $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $4e8c00bca37e184a$export$4c3f76c95c05197c(number) {
    return $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("gVDsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5309573f87def67$export$2e2bcd8739ae039);

var $hoHfs = parcelRequire("hoHfs");
var $c5309573f87def67$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $c5309573f87def67$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $hoHfs.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $c5309573f87def67$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $c5309573f87def67$var$RFC3966_EXTN_PREFIX + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRegister("a5PYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7592affeb0e135a4$export$2e2bcd8739ae039);

var $gVDsZ = parcelRequire("gVDsZ");
// 1 or more valid digits, for use when parsing.
var $7592affeb0e135a4$var$EXTN_PATTERN = new RegExp('(?:' + (0, $gVDsZ.default)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $7592affeb0e135a4$export$2e2bcd8739ae039(number) {
    var start = number.search($7592affeb0e135a4$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($7592affeb0e135a4$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("81pt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d722be4de9b0760$export$2e2bcd8739ae039);
$parcel$export(module.exports, "parsePhoneNumberCharacter", () => $5d722be4de9b0760$export$13d8790d7fb84c28);

var $fkobN = parcelRequire("fkobN");
function $5d722be4de9b0760$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5d722be4de9b0760$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d722be4de9b0760$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d722be4de9b0760$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d722be4de9b0760$var$_arrayLikeToArray(o, minLen);
}
function $5d722be4de9b0760$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d722be4de9b0760$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $5d722be4de9b0760$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $5d722be4de9b0760$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $5d722be4de9b0760$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return '+';
    } // Allow digits.
    return (0, $fkobN.parseDigit)(character);
}

});
parcelRegister("fkobN", function(module, exports) {

$parcel$export(module.exports, "parseDigit", () => $b28b7cc57bbfdda6$export$1d16fddea1437169);
$parcel$export(module.exports, "default", () => $b28b7cc57bbfdda6$export$2e2bcd8739ae039);
function $b28b7cc57bbfdda6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b28b7cc57bbfdda6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b28b7cc57bbfdda6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b28b7cc57bbfdda6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b28b7cc57bbfdda6$var$_arrayLikeToArray(o, minLen);
}
function $b28b7cc57bbfdda6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b28b7cc57bbfdda6$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $b28b7cc57bbfdda6$export$1d16fddea1437169(character) {
    return $b28b7cc57bbfdda6$export$2848f3d68c08fe69[character];
}
function $b28b7cc57bbfdda6$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $b28b7cc57bbfdda6$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $b28b7cc57bbfdda6$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("idCyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d437589d475d3664$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isPossibleNumber", () => $d437589d475d3664$export$4f8890cedf1e0497);

var $lijQr = parcelRequire("lijQr");

var $jllIH = parcelRequire("jllIH");
function $d437589d475d3664$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $lijQr.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $d437589d475d3664$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $d437589d475d3664$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $jllIH.default)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("jllIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e150d39adca76f23$export$2e2bcd8739ae039);

var $OBrgA = parcelRequire("OBrgA");
function $e150d39adca76f23$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $OBrgA.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

});
parcelRegister("OBrgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0981b63057bf1955$export$2e2bcd8739ae039);
function $0981b63057bf1955$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0981b63057bf1955$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0981b63057bf1955$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0981b63057bf1955$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0981b63057bf1955$var$_arrayLikeToArray(o, minLen);
}
function $0981b63057bf1955$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0981b63057bf1955$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $0981b63057bf1955$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("cJRin", function(module, exports) {

$parcel$export(module.exports, "parseRFC3966", () => $946307579c3e17b5$export$26fe644d7d92bb13);
$parcel$export(module.exports, "formatRFC3966", () => $946307579c3e17b5$export$d4f2d2bc1159d115);

var $6K6oP = parcelRequire("6K6oP");
function $946307579c3e17b5$var$_slicedToArray(arr, i) {
    return $946307579c3e17b5$var$_arrayWithHoles(arr) || $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) || $946307579c3e17b5$var$_unsupportedIterableToArray(arr, i) || $946307579c3e17b5$var$_nonIterableRest();
}
function $946307579c3e17b5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $946307579c3e17b5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $946307579c3e17b5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $946307579c3e17b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $946307579c3e17b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $946307579c3e17b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $946307579c3e17b5$var$_arrayLikeToArray(o, minLen);
}
function $946307579c3e17b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $946307579c3e17b5$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $946307579c3e17b5$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $946307579c3e17b5$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $6K6oP.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $946307579c3e17b5$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

});

parcelRegister("3bOc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $25295587638b13c7$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $idCyj = parcelRequire("idCyj");

var $bYZ6l = parcelRequire("bYZ6l");


var $2oXUa = parcelRequire("2oXUa");

var $8Vlxt = parcelRequire("8Vlxt");
function $25295587638b13c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25295587638b13c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $25295587638b13c7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $25295587638b13c7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $25295587638b13c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25295587638b13c7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25295587638b13c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $25295587638b13c7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $25295587638b13c7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $25295587638b13c7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $25295587638b13c7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $25295587638b13c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
        $25295587638b13c7$var$_classCallCheck(this, PhoneNumber);
        if (!countryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _metadata = new (0, $lijQr.default)(metadata); // If country code is passed then derive `countryCallingCode` from it.
        // Also store the country code as `.country`.
        if ($25295587638b13c7$var$isCountryCode(countryCallingCode)) {
            this.country = countryCallingCode;
            _metadata.country(countryCallingCode);
            countryCallingCode = _metadata.countryCallingCode();
        } else {
            /* istanbul ignore if */ if ($25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (_metadata.isNonGeographicCallingCode(countryCallingCode)) this.country = '001';
            }
        }
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        this.metadata = metadata;
    }
    $25295587638b13c7$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $idCyj.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $bYZ6l.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $lijQr.default)(this.metadata);
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // // Is just an alias for `this.isValid() && this.country === country`.
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $2oXUa.default)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $8Vlxt.default)(this, _format, options ? $25295587638b13c7$var$_objectSpread($25295587638b13c7$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $25295587638b13c7$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};

});
parcelRegister("bYZ6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b94b1c307b2dce6$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");

var $2oXUa = parcelRequire("2oXUa");
function $8b94b1c307b2dce6$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $lijQr.default)(metadata); // This is just to support `isValidNumber({})`
    // for cases when `parseNumber()` returns `{}`.
    if (!input.country) return false;
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $2oXUa.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var national_number = options.v2 ? input.nationalNumber : input.phone;
    return (0, $jyfse.default)(national_number, metadata.nationalNumberPattern());
}

});
parcelRegister("jyfse", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd2e2fc8506edb$export$2e2bcd8739ae039);
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $e3bd2e2fc8506edb$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

});

parcelRegister("2oXUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bfc4a83ba58b3fa$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");
function $1bfc4a83ba58b3fa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1bfc4a83ba58b3fa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1bfc4a83ba58b3fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1bfc4a83ba58b3fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1bfc4a83ba58b3fa$var$_arrayLikeToArray(o, minLen);
}
function $1bfc4a83ba58b3fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $1bfc4a83ba58b3fa$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returned `{}`
    // meaning that the phone number is not a valid one.
    if (!input.country) return;
    metadata = new (0, $lijQr.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $1bfc4a83ba58b3fa$var$_createForOfIteratorHelperLoose($1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $jyfse.default)(nationalNumber, type.pattern());
}

});


parcelRegister("8Vlxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f45ac1bdf1f00b$export$2e2bcd8739ae039);

var $jyfse = parcelRequire("jyfse");

var $cQ2v2 = parcelRequire("cQ2v2");

var $lijQr = parcelRequire("lijQr");

var $daLpQ = parcelRequire("daLpQ");

var $cJRin = parcelRequire("cJRin");
function $67f45ac1bdf1f00b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $67f45ac1bdf1f00b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $67f45ac1bdf1f00b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $67f45ac1bdf1f00b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $67f45ac1bdf1f00b$var$_arrayLikeToArray(o, minLen);
}
function $67f45ac1bdf1f00b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $67f45ac1bdf1f00b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $67f45ac1bdf1f00b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $67f45ac1bdf1f00b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $67f45ac1bdf1f00b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $67f45ac1bdf1f00b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $67f45ac1bdf1f00b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
}; // Formats a phone number
function $67f45ac1bdf1f00b$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $67f45ac1bdf1f00b$var$_objectSpread($67f45ac1bdf1f00b$var$_objectSpread({}, $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS), options);
    else options = $67f45ac1bdf1f00b$var$DEFAULT_OPTIONS;
    metadata = new (0, $lijQr.default)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $67f45ac1bdf1f00b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $67f45ac1bdf1f00b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $cJRin.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $67f45ac1bdf1f00b$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $67f45ac1bdf1f00b$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $67f45ac1bdf1f00b$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $67f45ac1bdf1f00b$var$chooseFormatForNumber(metadata.formats(), number);
    if (!format) return number;
    return (0, $cQ2v2.default)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $67f45ac1bdf1f00b$var$chooseFormatForNumber(availableFormats, nationalNnumber) {
    for(var _iterator = $67f45ac1bdf1f00b$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $jyfse.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $67f45ac1bdf1f00b$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $67f45ac1bdf1f00b$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $lijQr.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $daLpQ.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($67f45ac1bdf1f00b$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}

});
parcelRegister("cQ2v2", function(module, exports) {

$parcel$export(module.exports, "FIRST_GROUP_PATTERN", () => $958c47b8ffb0646a$export$4f32ad1c51a7a6be);
$parcel$export(module.exports, "default", () => $958c47b8ffb0646a$export$2e2bcd8739ae039);

var $1o9N5 = parcelRequire("1o9N5");
var $958c47b8ffb0646a$export$4f32ad1c51a7a6be = /(\$\d)/;
function $958c47b8ffb0646a$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($958c47b8ffb0646a$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $1o9N5.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("1o9N5", function(module, exports) {

$parcel$export(module.exports, "default", () => $102fa0905276e10f$export$2e2bcd8739ae039);

var $hoHfs = parcelRequire("hoHfs");
function $102fa0905276e10f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $hoHfs.VALID_PUNCTUATION), "]+"), 'g'), ' ').trim();
}

});


parcelRegister("daLpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9970fd541d189be2$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $9970fd541d189be2$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $lijQr.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});



parcelRegister("l3IVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54cbb82e68a0281$export$2e2bcd8739ae039);

var $lQq7N = parcelRequire("lQq7N");

var $6yPcr = parcelRequire("6yPcr");

var $lijQr = parcelRequire("lijQr");

var $hoHfs = parcelRequire("hoHfs");
function $f54cbb82e68a0281$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
     // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $lQq7N.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) number = '+' + numberWithoutIDD;
        else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $6yPcr.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $lijQr.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $hoHfs.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
}

});
parcelRegister("lQq7N", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe72b81dc9349c1d$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $hoHfs = parcelRequire("hoHfs");
var $fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $hoHfs.VALID_DIGITS) + '])');
function $fe72b81dc9349c1d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $lijQr.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}

});

parcelRegister("6yPcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c6da243f5876ae1$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $jyfse = parcelRequire("jyfse");

var $lO22f = parcelRequire("lO22f");

var $jllIH = parcelRequire("jllIH");

var $lijQr = parcelRequire("lijQr");
function $4c6da243f5876ae1$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $lijQr.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $lijQr.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $lO22f.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $lO22f.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $jyfse.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $jyfse.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $jllIH.default)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("lO22f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdffd8ab78eb7a6a$export$2e2bcd8739ae039);

var $7H2OH = parcelRequire("7H2OH");

var $jyfse = parcelRequire("jyfse");

var $jllIH = parcelRequire("jllIH");
function $fdffd8ab78eb7a6a$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $7H2OH.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$fdffd8ab78eb7a6a$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$fdffd8ab78eb7a6a$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $fdffd8ab78eb7a6a$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $jyfse.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $jyfse.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $fdffd8ab78eb7a6a$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $jllIH.default)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRegister("7H2OH", function(module, exports) {

$parcel$export(module.exports, "default", () => $599ebbe585179a66$export$2e2bcd8739ae039);
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $599ebbe585179a66$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("3wXuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $292282cd70c66425$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $2oXUa = parcelRequire("2oXUa");
function $292282cd70c66425$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $292282cd70c66425$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $292282cd70c66425$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $292282cd70c66425$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $292282cd70c66425$var$_arrayLikeToArray(o, minLen);
}
function $292282cd70c66425$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $292282cd70c66425$export$2e2bcd8739ae039(callingCode, nationalPhoneNumber, metadata) {
    /* istanbul ignore if */ if ($292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    } // Is always non-empty, because `callingCode` is always valid
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return $292282cd70c66425$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}
function $292282cd70c66425$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $lijQr.default)(metadata);
    for(var _iterator = $292282cd70c66425$var$_createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // Leading digits check would be the simplest and fastest one.
        // Leading digits patterns are only defined for about 20% of all countries.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // Matching "leading digits" is a sufficient but not necessary condition.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $2oXUa.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) return country;
    }
}

});




parcelRegister("lnAnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f907f7246eca08f1$export$2e2bcd8739ae039);

var $aKJ8g = parcelRequire("aKJ8g");

var $1nVPX = parcelRequire("1nVPX");

var $lijQr = parcelRequire("lijQr");
function $f907f7246eca08f1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f907f7246eca08f1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f907f7246eca08f1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f907f7246eca08f1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f907f7246eca08f1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f907f7246eca08f1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f907f7246eca08f1$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $lijQr.isSupportedCountry)(options.defaultCountry, metadata)) options = $f907f7246eca08f1$var$_objectSpread($f907f7246eca08f1$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $aKJ8g.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $1nVPX.default)) ;
        else throw error;
    }
}

});



parcelRegister("4wSUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c4bee83c07f6dd$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");
function $34c4bee83c07f6dd$export$2e2bcd8739ae039(metadata) {
    return new (0, $lijQr.default)(metadata).getCountries();
}

});

parcelRegister("8BZip", function(module, exports) {

$parcel$export(module.exports, "default", () => $6451538427aaf2b0$export$2e2bcd8739ae039);

var $lORaT = parcelRequire("lORaT");

var $lnAnA = parcelRequire("lnAnA");
function $6451538427aaf2b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6451538427aaf2b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6451538427aaf2b0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6451538427aaf2b0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6451538427aaf2b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6451538427aaf2b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6451538427aaf2b0$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $lORaT.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $6451538427aaf2b0$var$_objectSpread($6451538427aaf2b0$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $lnAnA.default)(text, options, metadata);
    return phoneNumber && phoneNumber.isPossible() || false;
}

});

parcelRegister("g7TUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd8ac01a56cfc98$export$2e2bcd8739ae039);

var $lORaT = parcelRequire("lORaT");

var $lnAnA = parcelRequire("lnAnA");
function $bbd8ac01a56cfc98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbd8ac01a56cfc98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbd8ac01a56cfc98$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbd8ac01a56cfc98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbd8ac01a56cfc98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbd8ac01a56cfc98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbd8ac01a56cfc98$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $lORaT.normalizeArguments)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $bbd8ac01a56cfc98$var$_objectSpread($bbd8ac01a56cfc98$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $lnAnA.default)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}

});

parcelRegister("72YWg", function(module, exports) {

$parcel$export(module.exports, "createPhoneInput", () => $5217fd7be51b9855$export$6b3f3b62761c8af5);

var $acw62 = parcelRequire("acw62");


var $b2FPq = parcelRequire("b2FPq");

var $5TI8D = parcelRequire("5TI8D");

var $1Mhhu = parcelRequire("1Mhhu");
function $5217fd7be51b9855$var$_extends() {
    $5217fd7be51b9855$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5217fd7be51b9855$var$_extends.apply(this, arguments);
}
function $5217fd7be51b9855$export$6b3f3b62761c8af5(defaultMetadata) {
    var PhoneInputDefault = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1Mhhu.default), $5217fd7be51b9855$var$_extends({
            ref: ref
        }, props));
    });
    PhoneInputDefault.propTypes = {
        metadata: (0, $5TI8D.metadata).isRequired,
        labels: (0, $5TI8D.labels).isRequired
    };
    PhoneInputDefault.defaultProps = {
        metadata: defaultMetadata,
        labels: (0, $b2FPq.default)
    };
    return PhoneInputDefault;
}
var $5217fd7be51b9855$export$2e2bcd8739ae039 = $5217fd7be51b9855$export$6b3f3b62761c8af5();

});
parcelRegister("b2FPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a053da314de61a$export$2e2bcd8739ae039);
var $80a053da314de61a$export$2e2bcd8739ae039 = {
    "ext": "ext.",
    "country": "Phone number country",
    "phone": "Phone",
    "AB": "Abkhazia",
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "\xc5land Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barth\xe9lemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Congo, Democratic Republic of the",
    "CF": "Central African Republic",
    "CG": "Congo",
    "CH": "Switzerland",
    "CI": "Cote d'Ivoire",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Cura\xe7ao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Federated States of Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GS": "South Georgia and the South Sandwich Islands",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Heard Island and McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin (French Part)",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macao",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "OS": "South Ossetia",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "Sao Tome and Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Swaziland",
    "TA": "Tristan da Cunha",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "United States Minor Outlying Islands",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Holy See (Vatican City State)",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "ZZ": "International"
};

});

parcelRegister("5TI8D", function(module, exports) {

$parcel$export(module.exports, "metadata", () => $44b453c2a900e1fd$export$dbb5e893e736e4ee);
$parcel$export(module.exports, "labels", () => $44b453c2a900e1fd$export$a238cb463698c900);

var $c9Z8w = parcelRequire("c9Z8w");
var $44b453c2a900e1fd$export$dbb5e893e736e4ee = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
    country_calling_codes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    countries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
});
var $44b453c2a900e1fd$export$a238cb463698c900 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string);

});

parcelRegister("1Mhhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b7adcd5f72858f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $6YpxI = parcelRequire("6YpxI");

var $i4rHW = parcelRequire("i4rHW");

var $7oCIP = parcelRequire("7oCIP");

var $gLQDv = parcelRequire("gLQDv");

var $iSrnw = parcelRequire("iSrnw");

var $4wSUA = parcelRequire("4wSUA");
var $fpKOC = parcelRequire("fpKOC");

var $76gcd = parcelRequire("76gcd");

var $5TI8D = parcelRequire("5TI8D");

var $dTfRb = parcelRequire("dTfRb");

var $ffz1L = parcelRequire("ffz1L");
function $14b7adcd5f72858f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $14b7adcd5f72858f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $14b7adcd5f72858f$var$_typeof(obj);
}
var $14b7adcd5f72858f$var$_excluded = [
    "name",
    "disabled",
    "readOnly",
    "autoComplete",
    "style",
    "className",
    "inputRef",
    "inputComponent",
    "numberInputProps",
    "smartCaret",
    "countrySelectComponent",
    "countrySelectProps",
    "containerComponent",
    "defaultCountry",
    "countries",
    "countryOptionsOrder",
    "labels",
    "flags",
    "flagComponent",
    "flagUrl",
    "addInternationalOption",
    "internationalIcon",
    "displayInitialValueAsLocalNumber",
    "initialValueFormat",
    "onCountryChange",
    "limitMaxLength",
    "countryCallingCodeEditable",
    "focusInputOnCountrySelection",
    "reset",
    "metadata",
    "international",
    "locales"
];
function $14b7adcd5f72858f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $14b7adcd5f72858f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $14b7adcd5f72858f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $14b7adcd5f72858f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $14b7adcd5f72858f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $14b7adcd5f72858f$var$_extends() {
    $14b7adcd5f72858f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14b7adcd5f72858f$var$_extends.apply(this, arguments);
}
function $14b7adcd5f72858f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $14b7adcd5f72858f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $14b7adcd5f72858f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $14b7adcd5f72858f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $14b7adcd5f72858f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $14b7adcd5f72858f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $14b7adcd5f72858f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $14b7adcd5f72858f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $14b7adcd5f72858f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $14b7adcd5f72858f$var$_setPrototypeOf(subClass, superClass);
}
function $14b7adcd5f72858f$var$_setPrototypeOf(o, p) {
    $14b7adcd5f72858f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $14b7adcd5f72858f$var$_setPrototypeOf(o, p);
}
function $14b7adcd5f72858f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $14b7adcd5f72858f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $14b7adcd5f72858f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $14b7adcd5f72858f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $14b7adcd5f72858f$var$_possibleConstructorReturn(this, result);
    };
}
function $14b7adcd5f72858f$var$_possibleConstructorReturn(self, call) {
    if (call && ($14b7adcd5f72858f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $14b7adcd5f72858f$var$_assertThisInitialized(self);
}
function $14b7adcd5f72858f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $14b7adcd5f72858f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $14b7adcd5f72858f$var$_getPrototypeOf(o) {
    $14b7adcd5f72858f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $14b7adcd5f72858f$var$_getPrototypeOf(o);
}
function $14b7adcd5f72858f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $14b7adcd5f72858f$var$PhoneNumberInput_ = /*#__PURE__*/ function(_React$PureComponent) {
    $14b7adcd5f72858f$var$_inherits(PhoneNumberInput_, _React$PureComponent);
    var _super = $14b7adcd5f72858f$var$_createSuper(PhoneNumberInput_);
    function PhoneNumberInput_(props) {
        var _this;
        $14b7adcd5f72858f$var$_classCallCheck(this, PhoneNumberInput_);
        _this = _super.call(this, props);
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "setInputRef", function(instance) {
            _this.inputRef.current = instance;
            var ref = _this.props.inputRef;
            if (ref) {
                if (typeof ref === 'function') ref(instance);
                else ref.current = instance;
            }
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "isCountrySupportedWithError", function(country) {
            var metadata = _this.props.metadata;
            return (0, $fpKOC.isCountrySupportedWithError)(country, metadata);
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onCountryChange", function(newCountry) {
            var _this$props = _this.props, international = _this$props.international, metadata = _this$props.metadata, onChange = _this$props.onChange, focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
            var _this$state = _this.state, prevPhoneDigits = _this$state.phoneDigits, prevCountry = _this$state.country; // After the new `country` has been selected,
            // if the phone number `<input/>` holds any digits
            // then migrate those digits for the new `country`.
            var newPhoneDigits = (0, $dTfRb.getPhoneDigitsForNewCountry)(prevPhoneDigits, {
                prevCountry: prevCountry,
                newCountry: newCountry,
                metadata: metadata,
                // Convert the phone number to "national" format
                // when the user changes the selected country by hand.
                useNationalFormat: !international
            });
            var newValue = (0, $dTfRb.e164)(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.
            if (focusInputOnCountrySelection) _this.inputRef.current.focus();
             // If the user has already manually selected a country
            // then don't override that already selected country
            // if the `defaultCountry` property changes.
            // That's what `hasUserSelectedACountry` flag is for.
            _this.setState({
                country: newCountry,
                hasUserSelectedACountry: true,
                phoneDigits: newPhoneDigits,
                value: newValue
            }, function() {
                // Update the new `value` property.
                // Doing it after the `state` has been updated
                // because `onChange()` will trigger `getDerivedStateFromProps()`
                // with the new `value` which will be compared to `state.value` there.
                onChange(newValue);
            });
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onChange", function(_phoneDigits) {
            var _this$props2 = _this.props, defaultCountry = _this$props2.defaultCountry, onChange = _this$props2.onChange, addInternationalOption = _this$props2.addInternationalOption, international = _this$props2.international, limitMaxLength = _this$props2.limitMaxLength, countryCallingCodeEditable = _this$props2.countryCallingCodeEditable, metadata = _this$props2.metadata;
            var _this$state2 = _this.state, countries = _this$state2.countries, prevPhoneDigits = _this$state2.phoneDigits, currentlySelectedCountry = _this$state2.country;
            var _onPhoneDigitsChange = (0, $dTfRb.onPhoneDigitsChange)(_phoneDigits, {
                prevPhoneDigits: prevPhoneDigits,
                country: currentlySelectedCountry,
                countryRequired: !addInternationalOption,
                defaultCountry: defaultCountry,
                getAnyCountry: function getAnyCountry() {
                    return _this.getFirstSupportedCountry({
                        countries: countries
                    });
                },
                countries: countries,
                international: international,
                limitMaxLength: limitMaxLength,
                countryCallingCodeEditable: countryCallingCodeEditable,
                metadata: metadata
            }), phoneDigits = _onPhoneDigitsChange.phoneDigits, country = _onPhoneDigitsChange.country, value = _onPhoneDigitsChange.value;
            var stateUpdate = {
                phoneDigits: phoneDigits,
                value: value,
                country: country
            };
            if (countryCallingCodeEditable === false) // If it simply did `setState({ phoneDigits: intlPrefix })` here,
            // then it would have no effect when erasing an inital international prefix
            // via Backspace, because `phoneDigits` in `state` wouldn't change
            // as a result, because it was `prefix` and it became `prefix`,
            // so the component wouldn't rerender, and the user would be able
            // to erase the country calling code part, and that part is
            // assumed to be non-eraseable. That's why the component is
            // forcefully rerendered here.
            // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
            {
                if (!value && phoneDigits === _this.state.phoneDigits) // Force a re-render of the `<input/>` in order to reset its value.
                stateUpdate.forceRerender = {};
            }
            _this.setState(stateUpdate, // Doing it after the `state` has been updated
            // because `onChange()` will trigger `getDerivedStateFromProps()`
            // with the new `value` which will be compared to `state.value` there.
            function() {
                return onChange(value);
            });
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "_onFocus", function() {
            return _this.setState({
                isFocused: true
            });
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "_onBlur", function() {
            return _this.setState({
                isFocused: false
            });
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onFocus", function(event) {
            _this._onFocus();
            var onFocus = _this.props.onFocus;
            if (onFocus) onFocus(event);
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onBlur", function(event) {
            var onBlur = _this.props.onBlur;
            _this._onBlur();
            if (onBlur) onBlur(event);
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onCountryFocus", function(event) {
            _this._onFocus(); // this.setState({ countrySelectFocused: true })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onFocus = countrySelectProps.onFocus;
                if (onFocus) onFocus(event);
            }
        });
        $14b7adcd5f72858f$var$_defineProperty($14b7adcd5f72858f$var$_assertThisInitialized(_this), "onCountryBlur", function(event) {
            _this._onBlur(); // this.setState({ countrySelectFocused: false })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onBlur = countrySelectProps.onBlur;
                if (onBlur) onBlur(event);
            }
        });
        _this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        var _this$props3 = _this.props, _value = _this$props3.value, labels = _this$props3.labels, _international = _this$props3.international, _addInternationalOption = _this$props3.addInternationalOption, displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber, initialValueFormat = _this$props3.initialValueFormat, _metadata = _this$props3.metadata;
        var _this$props4 = _this.props, _defaultCountry = _this$props4.defaultCountry, _countries = _this$props4.countries; // Validate `defaultCountry`.
        if (_defaultCountry) {
            if (!_this.isCountrySupportedWithError(_defaultCountry)) _defaultCountry = undefined;
        } // Validate `countries`.
        _countries = (0, $fpKOC.getSupportedCountries)(_countries, _metadata);
        var phoneNumber = (0, $dTfRb.parsePhoneNumber)(_value, _metadata);
        _this.CountryIcon = (0, $76gcd.createCountryIconComponent)(_this.props);
        var preSelectedCountry = (0, $dTfRb.getPreSelectedCountry)({
            value: _value,
            phoneNumber: phoneNumber,
            defaultCountry: _defaultCountry,
            required: !_addInternationalOption,
            countries: _countries || (0, $4wSUA.default)(_metadata),
            getAnyCountry: function getAnyCountry() {
                return _this.getFirstSupportedCountry({
                    countries: _countries
                });
            },
            metadata: _metadata
        });
        _this.state = {
            // Workaround for `this.props` inside `getDerivedStateFromProps()`.
            props: _this.props,
            // The country selected.
            country: preSelectedCountry,
            // `countries` are stored in `this.state` because they're filtered.
            // For example, a developer might theoretically pass some unsupported
            // countries as part of the `countries` property, and because of that
            // the component uses `this.state.countries` (which are filtered)
            // instead of `this.props.countries`
            // (which could potentially contain unsupported countries).
            countries: _countries,
            // `phoneDigits` state property holds non-formatted user's input.
            // The reason is that there's no way of finding out
            // in which form should `value` be displayed: international or national.
            // E.g. if `value` is `+78005553535` then it could be input
            // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
            // Hence storing just `value` is not sufficient for correct formatting.
            // E.g. if a user entered `8 (800) 555-35-35`
            // then value is `+78005553535` and `phoneDigits` are `88005553535`
            // and if a user entered `+7 800 555 35 35`
            // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
            phoneDigits: (0, $dTfRb.getInitialPhoneDigits)({
                value: _value,
                phoneNumber: phoneNumber,
                defaultCountry: _defaultCountry,
                international: _international,
                useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
                metadata: _metadata
            }),
            // `value` property is duplicated in state.
            // The reason is that `getDerivedStateFromProps()`
            // needs this `value` to compare to the new `value` property
            // to find out if `phoneDigits` needs updating:
            // If the `value` property was changed externally
            // then it won't be equal to `state.value`
            // in which case `phoneDigits` and `country` should be updated.
            value: _value
        };
        return _this;
    }
    $14b7adcd5f72858f$var$_createClass(PhoneNumberInput_, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onCountryChange = this.props.onCountryChange;
                var defaultCountry = this.props.defaultCountry;
                var selectedCountry = this.state.country;
                if (onCountryChange) {
                    if (defaultCountry) {
                        if (!this.isCountrySupportedWithError(defaultCountry)) defaultCountry = undefined;
                    }
                    if (selectedCountry !== defaultCountry) onCountryChange(selectedCountry);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var onCountryChange = this.props.onCountryChange;
                var country = this.state.country; // Call `onCountryChange` when user selects another country.
                if (onCountryChange && country !== prevState.country) onCountryChange(country);
            }
        },
        {
            key: "getCountrySelectOptions",
            value: function getCountrySelectOptions(_ref) {
                var countries = _ref.countries;
                var _this$props5 = this.props, international = _this$props5.international, countryCallingCodeEditable = _this$props5.countryCallingCodeEditable, countryOptionsOrder = _this$props5.countryOptionsOrder, addInternationalOption = _this$props5.addInternationalOption, labels = _this$props5.labels, locales = _this$props5.locales, metadata = _this$props5.metadata;
                return this.useMemoCountrySelectOptions(function() {
                    return (0, $fpKOC.sortCountryOptions)((0, $dTfRb.getCountrySelectOptions)({
                        countries: countries || (0, $4wSUA.default)(metadata),
                        countryNames: labels,
                        addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
                        compareStringsLocales: locales // compareStrings
                    }), (0, $fpKOC.getSupportedCountryOptions)(countryOptionsOrder, metadata));
                }, [
                    countries,
                    countryOptionsOrder,
                    addInternationalOption,
                    labels,
                    metadata
                ]);
            }
        },
        {
            key: "useMemoCountrySelectOptions",
            value: function useMemoCountrySelectOptions(generator, dependencies) {
                if (!this.countrySelectOptionsMemoDependencies || !$14b7adcd5f72858f$var$areEqualArrays(dependencies, this.countrySelectOptionsMemoDependencies)) {
                    this.countrySelectOptionsMemo = generator();
                    this.countrySelectOptionsMemoDependencies = dependencies;
                }
                return this.countrySelectOptionsMemo;
            }
        },
        {
            key: "getFirstSupportedCountry",
            value: function getFirstSupportedCountry(_ref2) {
                var countries = _ref2.countries;
                var countryOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return countryOptions[0].value;
            } // A shorthand for not passing `metadata` as a second argument.
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, name = _this$props6.name, disabled = _this$props6.disabled, readOnly = _this$props6.readOnly, autoComplete = _this$props6.autoComplete, style = _this$props6.style, className = _this$props6.className, inputRef = _this$props6.inputRef, inputComponent = _this$props6.inputComponent, numberInputProps = _this$props6.numberInputProps, smartCaret = _this$props6.smartCaret, CountrySelectComponent = _this$props6.countrySelectComponent, countrySelectProps = _this$props6.countrySelectProps, ContainerComponent = _this$props6.containerComponent, defaultCountry = _this$props6.defaultCountry, countriesProperty = _this$props6.countries, countryOptionsOrder = _this$props6.countryOptionsOrder, labels = _this$props6.labels, flags = _this$props6.flags, flagComponent = _this$props6.flagComponent, flagUrl = _this$props6.flagUrl, addInternationalOption = _this$props6.addInternationalOption, internationalIcon = _this$props6.internationalIcon, displayInitialValueAsLocalNumber = _this$props6.displayInitialValueAsLocalNumber, initialValueFormat = _this$props6.initialValueFormat, onCountryChange = _this$props6.onCountryChange, limitMaxLength = _this$props6.limitMaxLength, countryCallingCodeEditable = _this$props6.countryCallingCodeEditable, focusInputOnCountrySelection = _this$props6.focusInputOnCountrySelection, reset = _this$props6.reset, metadata = _this$props6.metadata, international = _this$props6.international, locales = _this$props6.locales, rest = $14b7adcd5f72858f$var$_objectWithoutProperties(_this$props6, $14b7adcd5f72858f$var$_excluded);
                var _this$state3 = this.state, country = _this$state3.country, countries = _this$state3.countries, phoneDigits = _this$state3.phoneDigits, isFocused = _this$state3.isFocused;
                var InputComponent = smartCaret ? (0, $6YpxI.default) : (0, $i4rHW.default);
                var countrySelectOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContainerComponent, {
                    style: style,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'PhoneInput', {
                        'PhoneInput--focus': isFocused,
                        'PhoneInput--disabled': disabled,
                        'PhoneInput--readOnly': readOnly
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CountrySelectComponent, $14b7adcd5f72858f$var$_extends({
                    name: name ? "".concat(name, "Country") : undefined,
                    "aria-label": labels.country
                }, countrySelectProps, {
                    value: country,
                    options: countrySelectOptions,
                    onChange: this.onCountryChange,
                    onFocus: this.onCountryFocus,
                    onBlur: this.onCountryBlur,
                    disabled: disabled || countrySelectProps && countrySelectProps.disabled,
                    readOnly: readOnly || countrySelectProps && countrySelectProps.readOnly,
                    iconComponent: this.CountryIcon
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InputComponent, $14b7adcd5f72858f$var$_extends({
                    ref: this.setInputRef,
                    type: "tel",
                    autoComplete: autoComplete
                }, numberInputProps, rest, {
                    name: name,
                    metadata: metadata,
                    country: country,
                    value: phoneDigits || '',
                    onChange: this.onChange,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    disabled: disabled,
                    readOnly: readOnly,
                    inputComponent: inputComponent,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // * `country` — The currently selected country, e.g. `"RU"`.
            // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
            // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
            // (and a couple of other less significant properties)
            function getDerivedStateFromProps(props, state) {
                return $14b7adcd5f72858f$var$_objectSpread({
                    // Emulate `prevProps` via `state.props`.
                    props: props
                }, (0, $ffz1L.default)(props, state.props, state));
            }
        }
    ]);
    return PhoneNumberInput_;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.
var $14b7adcd5f72858f$var$PhoneNumberInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($14b7adcd5f72858f$var$PhoneNumberInput_, $14b7adcd5f72858f$var$_extends({}, props, {
        inputRef: ref
    }));
});
$14b7adcd5f72858f$var$PhoneNumberInput.propTypes = {
    /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */ // (is `"tel"` by default)
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */ // (is `undefined` by default)
    initialValueFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'national'
    ]),
    // `displayInitialValueAsLocalNumber` property has been
    // superceded by `initialValueFormat` property.
    displayInitialValueAsLocalNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */ // A two-letter country code ("ISO 3166-1 alpha-2").
    defaultCountry: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */ countries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */ labels: (0, $5TI8D.labels).isRequired,
    /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */ locales: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */ /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */ flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */ flags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType),
    /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */ flagComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */ addInternationalOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */ internationalIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */ countryOptionsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    /**
   * `<Phone/>` component CSS style object.
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * `<Phone/>` component CSS class.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */ countrySelectComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */ countrySelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */ containerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * Phone number `<input/>` component props.
   */ numberInputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */ // Is `true` by default.
    smartCaret: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */ limitMaxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */ metadata: (0, $5TI8D.metadata).isRequired,
    /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */ // People have been asking for a way to get the selected country.
    // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
    // For some it's just a "business requirement".
    // I guess it's about gathering as much info on the user as a website can
    // without introducing any addional fields that would complicate the form
    // therefore reducing "conversion" (that's a marketing term).
    // Assuming that the phone number's country is the user's country
    // is not 100% correct but in most cases I guess it's valid.
    onCountryChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
$14b7adcd5f72858f$var$PhoneNumberInput.defaultProps = {
    /**
   * Remember (and autofill) the value as a phone number.
   */ autoComplete: 'tel',
    /**
   * Country `<select/>` component.
   */ countrySelectComponent: (0, $7oCIP.CountrySelectWithIcon),
    /**
   * Flag icon component.
   */ flagComponent: (0, $gLQDv.default),
    /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */ // Must be equal to `flagUrl` in `./CountryIcon.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    /**
   * Default "International" country `<select/>` option icon.
   */ internationalIcon: (0, $iSrnw.default),
    /**
   * Phone number `<input/>` component.
   */ inputComponent: 'input',
    /**
   * Wrapping `<div/>` component.
   */ containerComponent: 'div',
    /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */ // https://github.com/catamphetamine/react-phone-number-input/issues/300
    reset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   *
   */ /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */ smartCaret: true,
    /**
   * Whether to add the "International" option
   * to the list of countries.
   */ addInternationalOption: true,
    /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */ limitMaxLength: false,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: true,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: true
};
var $14b7adcd5f72858f$export$2e2bcd8739ae039 = $14b7adcd5f72858f$var$PhoneNumberInput;
function $14b7adcd5f72858f$var$areEqualArrays(a, b) {
    if (a.length !== b.length) return false;
    var i = 0;
    while(i < a.length){
        if (a[i] !== b[i]) return false;
        i++;
    }
    return true;
}

});
parcelRegister("6YpxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $513c28f3788e7bce$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $184RJ = parcelRequire("184RJ");

var $iPkor = parcelRequire("iPkor");
var $81pt0 = parcelRequire("81pt0");

var $fgpwC = parcelRequire("fgpwC");
var $513c28f3788e7bce$var$_excluded = [
    "country",
    "international",
    "withCountryCallingCode",
    "metadata"
];
function $513c28f3788e7bce$var$_extends() {
    $513c28f3788e7bce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $513c28f3788e7bce$var$_extends.apply(this, arguments);
}
function $513c28f3788e7bce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $513c28f3788e7bce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $513c28f3788e7bce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $513c28f3788e7bce$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */ function InputSmart(_ref, ref) {
        var country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata, rest = $513c28f3788e7bce$var$_objectWithoutProperties(_ref, $513c28f3788e7bce$var$_excluded);
        var format = (0, $acw62.useCallback)(function(value) {
            // "As you type" formatter.
            var formatter = new (0, $iPkor.default)(country, metadata);
            var prefix = (0, $fgpwC.getInputValuePrefix)({
                country: country,
                international: international,
                withCountryCallingCode: withCountryCallingCode,
                metadata: metadata
            }); // Format the number.
            var text = formatter.input(prefix + value);
            var template = formatter.getTemplate();
            if (prefix) {
                text = (0, $fgpwC.removeInputValuePrefix)(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.
                if (template) template = (0, $fgpwC.removeInputValuePrefix)(template, prefix);
            }
            return {
                text: text,
                template: template
            };
        }, [
            country,
            metadata
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $184RJ.default), $513c28f3788e7bce$var$_extends({}, rest, {
            ref: ref,
            parse: (0, $81pt0.parsePhoneNumberCharacter),
            format: format
        }));
    }
    InputSmart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(InputSmart);
    InputSmart.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
    };
    InputSmart.defaultProps = {
        metadata: defaultMetadata
    };
    return InputSmart;
}
var $513c28f3788e7bce$export$2e2bcd8739ae039 = $513c28f3788e7bce$export$d80fffb1deb3b97e();

});
parcelRegister("184RJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2a50088275844b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $jcio7 = parcelRequire("jcio7");
var $0d2a50088275844b$var$_excluded = [
    "value",
    "parse",
    "format",
    "inputComponent",
    "onChange",
    "onKeyDown"
];
function $0d2a50088275844b$var$_extends() {
    $0d2a50088275844b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d2a50088275844b$var$_extends.apply(this, arguments);
}
function $0d2a50088275844b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0d2a50088275844b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0d2a50088275844b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//
function $0d2a50088275844b$var$Input(_ref, ref) {
    var value = _ref.value, parse = _ref.parse, format = _ref.format, InputComponent = _ref.inputComponent, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, rest = $0d2a50088275844b$var$_objectWithoutProperties(_ref, $0d2a50088275844b$var$_excluded);
    var internalRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(instance) {
        internalRef.current = instance;
        if (ref) {
            if (typeof ref === 'function') ref(instance);
            else ref.current = instance;
        }
    }, [
        ref
    ]);
    var _onChange = (0, $acw62.useCallback)(function(event) {
        return (0, $jcio7.onChange)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange
    ]);
    var _onKeyDown = (0, $acw62.useCallback)(function(event) {
        if (onKeyDown) onKeyDown(event);
        return (0, $jcio7.onKeyDown)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InputComponent, $0d2a50088275844b$var$_extends({}, rest, {
        ref: setRef,
        value: format($0d2a50088275844b$var$isEmptyValue(value) ? '' : value).text,
        onKeyDown: _onKeyDown,
        onChange: _onChange
    }));
}
$0d2a50088275844b$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($0d2a50088275844b$var$Input);
$0d2a50088275844b$var$Input.propTypes = {
    // Parses a single characher of `<input/>` text.
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // Formats `value` into `<input/>` text.
    format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // Renders `<input/>` by default.
    inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    // `<input/>` `type` attribute.
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // Is parsed from <input/> text.
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // This handler is called each time `<input/>` text is changed.
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // Passthrough
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onCut: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
$0d2a50088275844b$var$Input.defaultProps = {
    // Renders `<input/>` by default.
    inputComponent: 'input',
    // `<input/>` `type` attribute.
    type: 'text'
};
var $0d2a50088275844b$export$2e2bcd8739ae039 = $0d2a50088275844b$var$Input;
function $0d2a50088275844b$var$isEmptyValue(value) {
    return value === undefined || value === null;
}

});
parcelRegister("jcio7", function(module, exports) {

$parcel$export(module.exports, "onChange", () => $df9d66cd822d81ee$export$bd913411069e59d3);
$parcel$export(module.exports, "onKeyDown", () => $df9d66cd822d81ee$export$de8e1b1372cdb41b);

var $gfn9j = parcelRequire("gfn9j");

var $33shR = parcelRequire("33shR");

var $lHM9i = parcelRequire("lHM9i");

var $kr8Uy = parcelRequire("kr8Uy");
function $df9d66cd822d81ee$export$330ca67a316b532c(event, input, _parse, _format, on_change) {
    if ((0, $kr8Uy.isReadOnly)(input)) return;
     // The actual cut hasn't happened just yet hence the timeout.
    setTimeout(function() {
        return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
    }, 0);
} // Deprecated.
function $df9d66cd822d81ee$export$48aae1120b60938a(event, input, _parse, _format, on_change) {
    if ((0, $kr8Uy.isReadOnly)(input)) return;
    var selection = (0, $kr8Uy.getSelection)(input); // If selection is made,
    // just erase the selected text
    // prior to pasting
    if (selection) $df9d66cd822d81ee$var$eraseSelection(input, selection);
    $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
}
function $df9d66cd822d81ee$export$bd913411069e59d3(event, input, _parse, _format, on_change) {
    $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
function $df9d66cd822d81ee$export$de8e1b1372cdb41b(event, input, _parse, _format, on_change) {
    if ((0, $kr8Uy.isReadOnly)(input)) return;
    var operation = (0, $kr8Uy.getOperation)(event);
    switch(operation){
        case 'Delete':
        case 'Backspace':
            // Intercept this operation and perform it manually.
            event.preventDefault();
            var selection = (0, $kr8Uy.getSelection)(input); // If a selection is made, just erase the selected text.
            if (selection) {
                $df9d66cd822d81ee$var$eraseSelection(input, selection);
                return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
            } // Else, perform the (character erasing) operation manually.
            return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, operation, on_change);
        default:
    }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */ function $df9d66cd822d81ee$var$eraseSelection(input, selection) {
    var text = input.value;
    text = text.slice(0, selection.start) + text.slice(selection.end);
    input.value = text;
    (0, $kr8Uy.setCaretPosition)(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */ function $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, operation, on_change) {
    // Parse `<input/>` textual value.
    // Get the `value` and `caret` position.
    var _parse2 = (0, $33shR.default)(input.value, (0, $kr8Uy.getCaretPosition)(input), _parse), value = _parse2.value, caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
    // then apply that operation and get the new `value` and `caret` position.
    if (operation) {
        var newValueAndCaret = (0, $gfn9j.default)(value, caret, operation);
        value = newValueAndCaret.value;
        caret = newValueAndCaret.caret;
    } // Format the `value`.
    // (and reposition the caret accordingly)
    var formatted = (0, $lHM9i.default)(value, caret, _format);
    var text = formatted.text;
    caret = formatted.caret; // Set `<input/>` textual value manually
    // to prevent React from resetting the caret position
    // later inside a subsequent `render()`.
    // Doesn't work for custom `inputComponent`s for some reason.
    input.value = text; // Position the caret properly.
    (0, $kr8Uy.setCaretPosition)(input, caret); // If the `<input/>` textual value did change,
    // then the parsed `value` may have changed too.
    on_change(value);
}

});
parcelRegister("gfn9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd4000fb22cccaa7$export$2e2bcd8739ae039);
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function $bd4000fb22cccaa7$export$2e2bcd8739ae039(value, caret, operation) {
    switch(operation){
        case 'Backspace':
            // If there exists the previous character,
            // then erase it and reposition the caret.
            if (caret > 0) {
                // Remove the previous character
                value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was
                caret--;
            }
            break;
        case 'Delete':
            // Remove current digit (if any)
            value = value.slice(0, caret) + value.slice(caret + 1);
            break;
    }
    return {
        value: value,
        caret: caret
    };
}

});

parcelRegister("33shR", function(module, exports) {

$parcel$export(module.exports, "default", () => $239798236dda80d1$export$2e2bcd8739ae039);
// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function $239798236dda80d1$export$2e2bcd8739ae039(text, caret_position, parse_character) {
    var value = '';
    var focused_input_character_index = 0;
    var index = 0;
    while(index < text.length){
        var character = parse_character(text[index], value);
        if (character !== undefined) {
            value += character;
            if (caret_position !== undefined) {
                if (caret_position === index) focused_input_character_index = value.length - 1;
                else if (caret_position > index) focused_input_character_index = value.length;
            }
        }
        index++;
    } // If caret position wasn't specified
    if (caret_position === undefined) // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
    var result = {
        value: value,
        caret: focused_input_character_index
    };
    return result;
}

});

parcelRegister("lHM9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd2f67e20b50d8a$export$2e2bcd8739ae039);

var $k18on = parcelRequire("k18on");
function $fcd2f67e20b50d8a$export$2e2bcd8739ae039(value, caret, formatter) {
    if (typeof formatter === 'string') formatter = (0, $k18on.default)(formatter);
    var _ref = formatter(value) || {}, text = _ref.text, template = _ref.template;
    if (text === undefined) text = value;
    if (template) {
        if (caret === undefined) caret = text.length;
        else {
            var index = 0;
            var found = false;
            var possibly_last_input_character_index = -1;
            while(index < text.length && index < template.length){
                // Character placeholder found
                if (text[index] !== template[index]) {
                    if (caret === 0) {
                        found = true;
                        caret = index;
                        break;
                    }
                    possibly_last_input_character_index = index;
                    caret--;
                }
                index++;
            } // If the caret was positioned after last input character,
            // then the text caret index is just after the last input character.
            if (!found) caret = possibly_last_input_character_index + 1;
        }
    }
    return {
        text: text,
        caret: caret
    };
}

});
parcelRegister("k18on", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92a6929987b746f$export$2e2bcd8739ae039);

var $kIDKu = parcelRequire("kIDKu");

var $c4FeI = parcelRequire("c4FeI");
function $e92a6929987b746f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e92a6929987b746f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e92a6929987b746f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e92a6929987b746f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e92a6929987b746f$var$_arrayLikeToArray(o, minLen);
}
function $e92a6929987b746f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e92a6929987b746f$export$2e2bcd8739ae039(template) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;
    if (!template) return function(value) {
        return {
            text: value
        };
    };
    var characters_in_template = (0, $kIDKu.count_occurences)(placeholder, template);
    return function(value) {
        if (!value) return {
            text: '',
            template: template
        };
        var value_character_index = 0;
        var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
        // because the importing application doesn't neccessarily include an ES6 polyfill.
        // The `.split('')` approach discards "exotic" UTF-8 characters
        // (the ones consisting of four bytes)
        // but template placeholder characters don't fall into that range
        // and appending UTF-8 characters to a string in parts still works.
        for(var _iterator = $e92a6929987b746f$var$_createForOfIteratorHelperLoose(template.split('')), _step; !(_step = _iterator()).done;){
            var character = _step.value;
            if (character !== placeholder) {
                filled_in_template += character;
                continue;
            }
            filled_in_template += value[value_character_index];
            value_character_index++; // If the last available value character has been filled in,
            // then return the filled in template
            // (either trim the right part or retain it,
            //  if no more character placeholders in there)
            if (value_character_index === value.length) {
                // If there are more character placeholders
                // in the right part of the template
                // then simply trim it.
                if (value.length < characters_in_template) break;
            }
        }
        if (should_close_braces) filled_in_template = (0, $c4FeI.default)(filled_in_template, template);
        return {
            text: filled_in_template,
            template: template
        };
    };
}

});
parcelRegister("kIDKu", function(module, exports) {

$parcel$export(module.exports, "count_occurences", () => $f156bffdf8a1980c$export$15741e15817e73b8);
function $f156bffdf8a1980c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f156bffdf8a1980c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f156bffdf8a1980c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f156bffdf8a1980c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f156bffdf8a1980c$var$_arrayLikeToArray(o, minLen);
}
function $f156bffdf8a1980c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f156bffdf8a1980c$export$15741e15817e73b8(symbol, string) {
    var count = 0; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // so skipping such miscellaneous "exotic" characters
    // won't matter here for just counting placeholder character occurrences.
    for(var _iterator = $f156bffdf8a1980c$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
}

});

parcelRegister("c4FeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca5d86fa1fd8a83$export$2e2bcd8739ae039);

var $kIDKu = parcelRequire("kIDKu");
function $8ca5d86fa1fd8a83$export$2e2bcd8739ae039(retained_template, template) {
    var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var cut_before = retained_template.length;
    var opening_braces = (0, $kIDKu.count_occurences)('(', retained_template);
    var closing_braces = (0, $kIDKu.count_occurences)(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        retained_template += template[cut_before].replace(placeholder, empty_placeholder);
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return retained_template;
}

});



parcelRegister("kr8Uy", function(module, exports) {

$parcel$export(module.exports, "isReadOnly", () => $ee0d3dd1a63aa54b$export$2498094d90b6ac72);
$parcel$export(module.exports, "getSelection", () => $ee0d3dd1a63aa54b$export$ca798a7e6e94638c);
$parcel$export(module.exports, "getOperation", () => $ee0d3dd1a63aa54b$export$d4e837035315abd8);
$parcel$export(module.exports, "getCaretPosition", () => $ee0d3dd1a63aa54b$export$7d120213748299d3);
$parcel$export(module.exports, "setCaretPosition", () => $ee0d3dd1a63aa54b$export$97ab23b40042f8af);
function $ee0d3dd1a63aa54b$export$2498094d90b6ac72(element) {
    return element.hasAttribute('readonly');
} // Gets <input/> selection bounds
function $ee0d3dd1a63aa54b$export$ca798a7e6e94638c(element) {
    // If no selection, return nothing
    if (element.selectionStart === element.selectionEnd) return;
    return {
        start: element.selectionStart,
        end: element.selectionEnd
    };
} // Key codes
var $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26 = {
    Backspace: 8,
    Delete: 46
}; // Finds out the operation to be intercepted and performed
function $ee0d3dd1a63aa54b$export$d4e837035315abd8(event) {
    switch(event.keyCode){
        case $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26.Backspace:
            return 'Backspace';
        case $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26.Delete:
            return 'Delete';
    }
} // Gets <input/> caret position
function $ee0d3dd1a63aa54b$export$7d120213748299d3(element) {
    return element.selectionStart;
} // Sets <input/> caret position
function $ee0d3dd1a63aa54b$export$97ab23b40042f8af(element, caret_position) {
    // Sanity check
    if (caret_position === undefined) return;
     // Set caret position.
    // There has been an issue with caret positioning on Android devices.
    // https://github.com/catamphetamine/input-format/issues/2
    // I was revisiting this issue and looked for similar issues in other libraries.
    // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
    // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
    // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
    // https://github.com/text-mask/text-mask/issues/300
    // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
    // https://github.com/text-mask/text-mask/pull/400/files
    // I've implemented the same workaround here.
    if ($ee0d3dd1a63aa54b$var$isAndroid()) setTimeout(function() {
        return element.setSelectionRange(caret_position, caret_position);
    }, 0);
    else element.setSelectionRange(caret_position, caret_position);
}
function $ee0d3dd1a63aa54b$var$isAndroid() {
    // `navigator` is not defined when running mocha tests.
    if (typeof navigator !== 'undefined') return $ee0d3dd1a63aa54b$var$ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
}
var $ee0d3dd1a63aa54b$var$ANDROID_USER_AGENT_REG_EXP = /Android/i;

});



parcelRegister("iPkor", function(module, exports) {

$parcel$export(module.exports, "default", () => $db4ccf0f77fcc72f$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");

var $3bOc3 = parcelRequire("3bOc3");

var $l8K4T = parcelRequire("l8K4T");

var $ahynH = parcelRequire("ahynH");
var $lQt3h = parcelRequire("lQt3h");

var $fD8Ui = parcelRequire("fD8Ui");

var $3wXuM = parcelRequire("3wXuM");
function $db4ccf0f77fcc72f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $db4ccf0f77fcc72f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $db4ccf0f77fcc72f$var$_typeof(obj);
}
function $db4ccf0f77fcc72f$var$_slicedToArray(arr, i) {
    return $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) || $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) || $db4ccf0f77fcc72f$var$_unsupportedIterableToArray(arr, i) || $db4ccf0f77fcc72f$var$_nonIterableRest();
}
function $db4ccf0f77fcc72f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $db4ccf0f77fcc72f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $db4ccf0f77fcc72f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $db4ccf0f77fcc72f$var$_arrayLikeToArray(o, minLen);
}
function $db4ccf0f77fcc72f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $db4ccf0f77fcc72f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db4ccf0f77fcc72f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $db4ccf0f77fcc72f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $db4ccf0f77fcc72f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $db4ccf0f77fcc72f$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $lijQr.default)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $db4ccf0f77fcc72f$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $db4ccf0f77fcc72f$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ($db4ccf0f77fcc72f$var$_typeof(optionsOrDefaultCountry) === 'object') {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $l8K4T.default)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $ahynH.default)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $fD8Ui.default)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset(this.defaultCountry, this.defaultCallingCode);
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $lQt3h.DIGIT_PLACEHOLDER));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $3wXuM.default)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                if (!country && !callingCode) return;
                var phoneNumber = new (0, $3bOc3.default)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();

});
parcelRegister("l8K4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f63e1671b767c734$export$2e2bcd8739ae039);
function $f63e1671b767c734$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f63e1671b767c734$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f63e1671b767c734$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f63e1671b767c734$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f63e1671b767c734$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $f63e1671b767c734$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $f63e1671b767c734$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $f63e1671b767c734$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(defaultCountry, defaultCallingCode) {
                this.international = false;
                this.IDDPrefix = undefined;
                this.missingPlus = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();

});

parcelRegister("ahynH", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c6294fe142cf3c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => (parcelRequire("lQt3h")).DIGIT_PLACEHOLDER);

var $lQt3h = parcelRequire("lQt3h");

var $41ESN = parcelRequire("41ESN");

var $h0jgP = parcelRequire("h0jgP");

var $fkobN = parcelRequire("fkobN");

var $cQ2v2 = parcelRequire("cQ2v2");

var $hoHfs = parcelRequire("hoHfs");

var $1o9N5 = parcelRequire("1o9N5");
function $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $77c6294fe142cf3c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77c6294fe142cf3c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $77c6294fe142cf3c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $77c6294fe142cf3c$var$_arrayLikeToArray(o, minLen);
}
function $77c6294fe142cf3c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $77c6294fe142cf3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $77c6294fe142cf3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $77c6294fe142cf3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $77c6294fe142cf3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $77c6294fe142cf3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $77c6294fe142cf3c$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $lQt3h.repeat)($77c6294fe142cf3c$var$DUMMY_DIGIT, $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*' + '(\\$\\d[' + (0, $hoHfs.VALID_PUNCTUATION) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $77c6294fe142cf3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $77c6294fe142cf3c$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $77c6294fe142cf3c$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $41ESN.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $41ESN.default)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $lQt3h.DIGIT_PLACEHOLDER)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $lQt3h.DIGIT_PLACEHOLDER));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $h0jgP.default)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $lQt3h.DIGIT_PLACEHOLDER), index + 1);
                    i++;
                }
                return (0, $lQt3h.cutAndStripNonPairedParens)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $lQt3h.DIGIT_PLACEHOLDER)) + (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $77c6294fe142cf3c$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $cQ2v2.FIRST_GROUP_PATTERN), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $fkobN.default)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $fkobN.default)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $lQt3h.DIGIT_PLACEHOLDER));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($77c6294fe142cf3c$var$DUMMY_DIGIT, 'g'), (0, $lQt3h.DIGIT_PLACEHOLDER)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $lQt3h.repeat)((0, $lQt3h.DIGIT_PLACEHOLDER), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $1o9N5.default)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $lQt3h.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $lQt3h.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();

});
parcelRegister("lQt3h", function(module, exports) {

$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => $fe74fd6609d199cf$export$2a0174a7c311f338);
$parcel$export(module.exports, "repeat", () => $fe74fd6609d199cf$export$76d90c956114f2c2);
$parcel$export(module.exports, "cutAndStripNonPairedParens", () => $fe74fd6609d199cf$export$ac095dcff0205861);
$parcel$export(module.exports, "populateTemplateWithDigits", () => $fe74fd6609d199cf$export$a15547494b55ca4e);
function $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fe74fd6609d199cf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe74fd6609d199cf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe74fd6609d199cf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe74fd6609d199cf$var$_arrayLikeToArray(o, minLen);
}
function $fe74fd6609d199cf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fe74fd6609d199cf$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($fe74fd6609d199cf$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $fe74fd6609d199cf$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $fe74fd6609d199cf$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $fe74fd6609d199cf$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $fe74fd6609d199cf$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $fe74fd6609d199cf$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $fe74fd6609d199cf$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $fe74fd6609d199cf$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $fe74fd6609d199cf$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $fe74fd6609d199cf$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}

});

parcelRegister("41ESN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee6f7e5d3aef803$export$2e2bcd8739ae039);
$parcel$export(module.exports, "canFormatCompleteNumber", () => $2ee6f7e5d3aef803$export$9e33d25ea5d3e526);

var $jllIH = parcelRequire("jllIH");

var $fkobN = parcelRequire("fkobN");

var $cQ2v2 = parcelRequire("cQ2v2");
function $2ee6f7e5d3aef803$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $2ee6f7e5d3aef803$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $jllIH.default)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $cQ2v2.default)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $fkobN.default)(formattedNationalNumber) === state.getNationalDigits();
}

});

parcelRegister("h0jgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c611626fb7b38494$export$2e2bcd8739ae039);

var $aBnFQ = parcelRequire("aBnFQ");
function $c611626fb7b38494$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c611626fb7b38494$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c611626fb7b38494$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c611626fb7b38494$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c611626fb7b38494$var$_arrayLikeToArray(o, minLen);
}
function $c611626fb7b38494$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c611626fb7b38494$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c611626fb7b38494$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c611626fb7b38494$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c611626fb7b38494$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c611626fb7b38494$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $c611626fb7b38494$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $c611626fb7b38494$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $aBnFQ.default)().parse(pattern);
    }
    $c611626fb7b38494$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $c611626fb7b38494$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $c611626fb7b38494$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $c611626fb7b38494$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $c611626fb7b38494$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $c611626fb7b38494$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $c611626fb7b38494$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}

});
parcelRegister("aBnFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7fb9365e469673$export$2e2bcd8739ae039);
function $7b7fb9365e469673$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b7fb9365e469673$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7b7fb9365e469673$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7b7fb9365e469673$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7b7fb9365e469673$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $7b7fb9365e469673$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $7b7fb9365e469673$var$_classCallCheck(this, PatternParser);
    }
    $7b7fb9365e469673$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $7b7fb9365e469673$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($7b7fb9365e469673$var$OPERATOR);
                if (!match) {
                    if ($7b7fb9365e469673$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($7b7fb9365e469673$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($7b7fb9365e469673$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $7b7fb9365e469673$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $7b7fb9365e469673$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $7b7fb9365e469673$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $7b7fb9365e469673$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $7b7fb9365e469673$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}

});



parcelRegister("fD8Ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $b611684da4cccb02$export$2e2bcd8739ae039);

var $l3IVT = parcelRequire("l3IVT");

var $6yPcr = parcelRequire("6yPcr");

var $7H2OH = parcelRequire("7H2OH");

var $lQq7N = parcelRequire("lQq7N");

var $fkobN = parcelRequire("fkobN");

var $hoHfs = parcelRequire("hoHfs");
function $b611684da4cccb02$var$_slicedToArray(arr, i) {
    return $b611684da4cccb02$var$_arrayWithHoles(arr) || $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) || $b611684da4cccb02$var$_unsupportedIterableToArray(arr, i) || $b611684da4cccb02$var$_nonIterableRest();
}
function $b611684da4cccb02$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b611684da4cccb02$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b611684da4cccb02$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b611684da4cccb02$var$_arrayLikeToArray(o, minLen);
}
function $b611684da4cccb02$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b611684da4cccb02$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b611684da4cccb02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b611684da4cccb02$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b611684da4cccb02$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b611684da4cccb02$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b611684da4cccb02$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+';
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $hoHfs.PLUS_CHARS) + ']' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']*' + '|' + '[' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+' + ')';
var $b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $hoHfs.VALID_PUNCTUATION) + (0, $hoHfs.VALID_DIGITS) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $b611684da4cccb02$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $b611684da4cccb02$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $b611684da4cccb02$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $b611684da4cccb02$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $fkobN.default)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $l3IVT.default)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $7H2OH.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $7H2OH.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $lQq7N.default)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $6yPcr.default)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $b611684da4cccb02$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $b611684da4cccb02$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $b611684da4cccb02$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}

});


parcelRegister("fgpwC", function(module, exports) {

$parcel$export(module.exports, "getInputValuePrefix", () => $b1cc26643c331962$export$64c976c619d11c0e);
$parcel$export(module.exports, "removeInputValuePrefix", () => $b1cc26643c331962$export$3ecf28b47966f258);

var $lijQr = parcelRequire("lijQr");
function $b1cc26643c331962$export$64c976c619d11c0e(_ref) {
    var country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata;
    return country && international && !withCountryCallingCode ? "+".concat((0, $lijQr.getCountryCallingCode)(country, metadata)) : '';
}
function $b1cc26643c331962$export$3ecf28b47966f258(value, prefix) {
    if (prefix) {
        value = value.slice(prefix.length);
        if (value[0] === ' ') value = value.slice(1);
    }
    return value;
}

});


parcelRegister("i4rHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27e17e9551ae473$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lEUSc = parcelRequire("lEUSc");
var $81pt0 = parcelRequire("81pt0");

var $fgpwC = parcelRequire("fgpwC");
var $d27e17e9551ae473$var$_excluded = [
    "value",
    "onChange",
    "country",
    "international",
    "withCountryCallingCode",
    "metadata",
    "inputComponent"
];
function $d27e17e9551ae473$var$_extends() {
    $d27e17e9551ae473$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d27e17e9551ae473$var$_extends.apply(this, arguments);
}
function $d27e17e9551ae473$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d27e17e9551ae473$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d27e17e9551ae473$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d27e17e9551ae473$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */ function InputBasic(_ref, ref) {
        var value = _ref.value, onChange = _ref.onChange, country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata, Input = _ref.inputComponent, rest = $d27e17e9551ae473$var$_objectWithoutProperties(_ref, $d27e17e9551ae473$var$_excluded);
        var prefix = (0, $fgpwC.getInputValuePrefix)({
            country: country,
            international: international,
            withCountryCallingCode: withCountryCallingCode,
            metadata: metadata
        });
        var _onChange = (0, $acw62.useCallback)(function(event) {
            var newValue = (0, $81pt0.default)(event.target.value); // By default, if a value is something like `"(123)"`
            // then Backspace would only erase the rightmost brace
            // becoming something like `"(123"`
            // which would give the same `"123"` value
            // which would then be formatted back to `"(123)"`
            // and so a user wouldn't be able to erase the phone number.
            // Working around this issue with this simple hack.
            if (newValue === value) {
                var newValueFormatted = $d27e17e9551ae473$var$format(prefix, newValue, country, metadata);
                if (newValueFormatted.indexOf(event.target.value) === 0) // Trim the last digit (or plus sign).
                newValue = newValue.slice(0, -1);
            }
            onChange(newValue);
        }, [
            prefix,
            value,
            onChange,
            country,
            metadata
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, $d27e17e9551ae473$var$_extends({}, rest, {
            ref: ref,
            value: $d27e17e9551ae473$var$format(prefix, value, country, metadata),
            onChange: _onChange
        }));
    }
    InputBasic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(InputBasic);
    InputBasic.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
        /**
     * The `<input/>` component.
     */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired
    };
    InputBasic.defaultProps = {
        metadata: defaultMetadata,
        inputComponent: 'input'
    };
    return InputBasic;
}
var $d27e17e9551ae473$export$2e2bcd8739ae039 = $d27e17e9551ae473$export$d80fffb1deb3b97e();
function $d27e17e9551ae473$var$format(prefix, value, country, metadata) {
    return (0, $fgpwC.removeInputValuePrefix)((0, $lEUSc.default)(prefix + value, country, metadata), prefix);
}

});
parcelRegister("lEUSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4973399c9bb964$export$2e2bcd8739ae039);

var $iPkor = parcelRequire("iPkor");
function $fc4973399c9bb964$export$2e2bcd8739ae039(value, country, metadata) {
    if (!metadata) {
        metadata = country;
        country = undefined;
    }
    return new (0, $iPkor.default)(country, metadata).input(value);
}

});


parcelRegister("7oCIP", function(module, exports) {

$parcel$export(module.exports, "CountrySelectWithIcon", () => $5628cfb1236ba6bc$export$2d95fe84e9746c91);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $7RFK1 = parcelRequire("7RFK1");
var $5628cfb1236ba6bc$var$_excluded = [
    "value",
    "onChange",
    "options"
], $5628cfb1236ba6bc$var$_excluded2 = [
    "value",
    "options",
    "className",
    "iconComponent",
    "getIconAspectRatio",
    "arrowComponent",
    "unicodeFlags"
];
function $5628cfb1236ba6bc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5628cfb1236ba6bc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5628cfb1236ba6bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5628cfb1236ba6bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5628cfb1236ba6bc$var$_arrayLikeToArray(o, minLen);
}
function $5628cfb1236ba6bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5628cfb1236ba6bc$var$_extends() {
    $5628cfb1236ba6bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5628cfb1236ba6bc$var$_extends.apply(this, arguments);
}
function $5628cfb1236ba6bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5628cfb1236ba6bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5628cfb1236ba6bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5628cfb1236ba6bc$export$2e2bcd8739ae039(_ref) {
    var value = _ref.value, onChange = _ref.onChange, options = _ref.options, rest = $5628cfb1236ba6bc$var$_objectWithoutProperties(_ref, $5628cfb1236ba6bc$var$_excluded);
    var onChange_ = (0, $acw62.useCallback)(function(event) {
        var value = event.target.value;
        onChange(value === 'ZZ' ? undefined : value);
    }, [
        onChange
    ]);
    var selectedOption = (0, $acw62.useMemo)(function() {
        return $5628cfb1236ba6bc$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]); // "ZZ" means "International".
    // (HTML requires each `<option/>` have some string `value`).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", $5628cfb1236ba6bc$var$_extends({}, rest, {
        value: value || 'ZZ',
        onChange: onChange_
    }), options.map(function(_ref2) {
        var value = _ref2.value, label = _ref2.label, divider = _ref2.divider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: divider ? '|' : value || 'ZZ',
            value: divider ? '|' : value || 'ZZ',
            disabled: divider ? true : false,
            style: divider ? $5628cfb1236ba6bc$var$DIVIDER_STYLE : undefined
        }, label);
    }));
}
$5628cfb1236ba6bc$export$2e2bcd8739ae039.propTypes = {
    /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A function of `value: string`.
   * Updates the `value` property.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // `<select/>` options.
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    })).isRequired
};
var $5628cfb1236ba6bc$var$DIVIDER_STYLE = {
    fontSize: '1px',
    backgroundColor: 'currentColor',
    color: 'inherit'
};
function $5628cfb1236ba6bc$export$2d95fe84e9746c91(_ref3) {
    var value = _ref3.value, options = _ref3.options, className = _ref3.className, Icon = _ref3.iconComponent, getIconAspectRatio = _ref3.getIconAspectRatio, Arrow = _ref3.arrowComponent, unicodeFlags = _ref3.unicodeFlags, rest = $5628cfb1236ba6bc$var$_objectWithoutProperties(_ref3, $5628cfb1236ba6bc$var$_excluded2);
    var selectedOption = (0, $acw62.useMemo)(function() {
        return $5628cfb1236ba6bc$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "PhoneInputCountry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5628cfb1236ba6bc$export$2e2bcd8739ae039, $5628cfb1236ba6bc$var$_extends({}, rest, {
        value: value,
        options: options,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputCountrySelect', className)
    })), unicodeFlags && value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "PhoneInputCountryIconUnicode"
    }, (0, $7RFK1.default)(value)), !(unicodeFlags && value) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        "aria-hidden": true,
        country: value,
        label: selectedOption && selectedOption.label,
        aspectRatio: unicodeFlags ? 1 : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Arrow, null));
}
$5628cfb1236ba6bc$export$2d95fe84e9746c91.propTypes = {
    // Country flag component.
    iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // Select arrow component.
    arrowComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    // Set to `true` to render Unicode flag icons instead of SVG images.
    unicodeFlags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$5628cfb1236ba6bc$export$2d95fe84e9746c91.defaultProps = {
    arrowComponent: function arrowComponent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "PhoneInputCountrySelectArrow"
        });
    }
};
function $5628cfb1236ba6bc$var$getSelectedOption(options, value) {
    for(var _iterator = $5628cfb1236ba6bc$var$_createForOfIteratorHelperLoose(options), _step; !(_step = _iterator()).done;){
        var option = _step.value;
        if (!option.divider && option.value === value) return option;
    }
}

});
parcelRegister("7RFK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9ddc962ce49c4a$export$2e2bcd8739ae039);
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */ function $5b9ddc962ce49c4a$export$2e2bcd8739ae039(country) {
    return $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(country[0]) + $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */ function $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(letter) {
    return String.fromCodePoint(127397 + letter.toUpperCase().charCodeAt(0));
}

});


parcelRegister("gLQDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c359dd94b1ef2bdc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("8g1PZ");
var $c359dd94b1ef2bdc$var$_excluded = [
    "country",
    "countryName",
    "flags",
    "flagUrl"
];
function $c359dd94b1ef2bdc$var$_extends() {
    $c359dd94b1ef2bdc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c359dd94b1ef2bdc$var$_extends.apply(this, arguments);
}
function $c359dd94b1ef2bdc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c359dd94b1ef2bdc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c359dd94b1ef2bdc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c359dd94b1ef2bdc$export$2e2bcd8739ae039(_ref) {
    var country = _ref.country, countryName = _ref.countryName, flags = _ref.flags, flagUrl = _ref.flagUrl, rest = $c359dd94b1ef2bdc$var$_objectWithoutProperties(_ref, $c359dd94b1ef2bdc$var$_excluded);
    if (flags && flags[country]) return flags[country]({
        title: countryName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", $c359dd94b1ef2bdc$var$_extends({}, rest, {
        alt: countryName,
        role: countryName ? undefined : "presentation",
        src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
    }));
}
$c359dd94b1ef2bdc$export$2e2bcd8739ae039.propTypes = {
    // The country to be selected by default.
    // Two-letter country code ("ISO 3166-1 alpha-2").
    country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // Will be HTML `title` attribute of the `<img/>`.
    countryName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // Country flag icon components.
    // By default flag icons are inserted as `<img/>`s
    // with their `src` pointed to `country-flag-icons` gitlab pages website.
    // There might be cases (e.g. an offline application)
    // where having a large (3 megabyte) `<svg/>` flags
    // bundle is more appropriate.
    // `import flags from 'react-phone-number-input/flags'`.
    flags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType),
    // A URL for a country flag icon.
    // By default it points to `country-flag-icons` gitlab pages website.
    flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};

});

parcelRegister("iSrnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe281ed06c3f740$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $dbe281ed06c3f740$var$_excluded = [
    "aspectRatio"
], $dbe281ed06c3f740$var$_excluded2 = [
    "title"
], $dbe281ed06c3f740$var$_excluded3 = [
    "title"
];
function $dbe281ed06c3f740$var$_extends() {
    $dbe281ed06c3f740$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbe281ed06c3f740$var$_extends.apply(this, arguments);
}
function $dbe281ed06c3f740$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dbe281ed06c3f740$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dbe281ed06c3f740$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dbe281ed06c3f740$export$2e2bcd8739ae039(_ref) {
    var aspectRatio = _ref.aspectRatio, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref, $dbe281ed06c3f740$var$_excluded);
    if (aspectRatio === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dbe281ed06c3f740$var$InternationalIcon1x1, rest);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dbe281ed06c3f740$var$InternationalIcon3x2, rest);
}
$dbe281ed06c3f740$export$2e2bcd8739ae039.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $dbe281ed06c3f740$var$InternationalIcon3x2(_ref2) {
    var title = _ref2.title, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref2, $dbe281ed06c3f740$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dbe281ed06c3f740$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "26",
        y1: "25",
        x2: "74",
        y2: "25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "50",
        y1: "1",
        x2: "50",
        y2: "49"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "none",
        fill: "currentColor",
        d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
    }));
}
$dbe281ed06c3f740$var$InternationalIcon3x2.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $dbe281ed06c3f740$var$InternationalIcon1x1(_ref3) {
    var title = _ref3.title, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref3, $dbe281ed06c3f740$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dbe281ed06c3f740$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeLinecap: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "27.8",
        y1: "0.85",
        x2: "27.8",
        y2: "34.61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "15.2",
        y1: "22.23",
        x2: "49.15",
        y2: "22.23"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "transparent",
        fill: "currentColor",
        d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
    }));
}
$dbe281ed06c3f740$var$InternationalIcon1x1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};

});

parcelRegister("fpKOC", function(module, exports) {

$parcel$export(module.exports, "sortCountryOptions", () => $b38d815d67cc63c6$export$5e75b0f0f43cd233);
$parcel$export(module.exports, "getSupportedCountryOptions", () => $b38d815d67cc63c6$export$afcb8c072b7545af);
$parcel$export(module.exports, "isCountrySupportedWithError", () => $b38d815d67cc63c6$export$92e6622a86b85d10);
$parcel$export(module.exports, "getSupportedCountries", () => $b38d815d67cc63c6$export$823f1bbb8700cf79);

var $4wSUA = parcelRequire("4wSUA");
var $lijQr = parcelRequire("lijQr");
function $b38d815d67cc63c6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b38d815d67cc63c6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b38d815d67cc63c6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b38d815d67cc63c6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b38d815d67cc63c6$var$_arrayLikeToArray(o, minLen);
}
function $b38d815d67cc63c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b38d815d67cc63c6$export$5e75b0f0f43cd233(options, order) {
    if (!order) return options;
    var optionsOnTop = [];
    var optionsOnBottom = [];
    var appendTo = optionsOnTop;
    for(var _iterator = $b38d815d67cc63c6$var$_createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (element === '|') appendTo.push({
            divider: true
        });
        else if (element === '...' || element === "\u2026") appendTo = optionsOnBottom;
        else (function() {
            var countryCode = void 0;
            if (element === "\uD83C\uDF10") countryCode = undefined;
            else countryCode = element;
             // Find the position of the option.
            var index = options.indexOf(options.filter(function(option) {
                return option.value === countryCode;
            })[0]); // Get the option.
            var option = options[index]; // Remove the option from its default position.
            options.splice(index, 1); // Add the option on top.
            appendTo.push(option);
        })();
    }
    return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function $b38d815d67cc63c6$export$afcb8c072b7545af(countryOptions, metadata) {
    if (countryOptions) {
        countryOptions = countryOptions.filter(function(option) {
            switch(option){
                case "\uD83C\uDF10":
                case '|':
                case '...':
                case "\u2026":
                    return true;
                default:
                    return $b38d815d67cc63c6$export$92e6622a86b85d10(option, metadata);
            }
        });
        if (countryOptions.length > 0) return countryOptions;
    }
}
function $b38d815d67cc63c6$export$92e6622a86b85d10(country, metadata) {
    if ((0, $lijQr.isSupportedCountry)(country, metadata)) return true;
    else {
        console.error("Country not found: ".concat(country));
        return false;
    }
}
function $b38d815d67cc63c6$export$823f1bbb8700cf79(countries, metadata) {
    if (countries) {
        countries = countries.filter(function(country) {
            return $b38d815d67cc63c6$export$92e6622a86b85d10(country, metadata);
        });
        if (countries.length === 0) countries = undefined;
    }
    return countries;
}

});

parcelRegister("76gcd", function(module, exports) {

$parcel$export(module.exports, "createCountryIconComponent", () => $52b5a828ead0404a$export$c8cd064d62c67fdc);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $iSrnw = parcelRequire("iSrnw");

var $gLQDv = parcelRequire("gLQDv");
var $52b5a828ead0404a$var$_excluded = [
    "country",
    "label",
    "aspectRatio"
];
function $52b5a828ead0404a$var$_extends() {
    $52b5a828ead0404a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $52b5a828ead0404a$var$_extends.apply(this, arguments);
}
function $52b5a828ead0404a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $52b5a828ead0404a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $52b5a828ead0404a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $52b5a828ead0404a$export$c8cd064d62c67fdc(_ref) {
    var flags = _ref.flags, flagUrl = _ref.flagUrl, FlagComponent = _ref.flagComponent, InternationalIcon = _ref.internationalIcon;
    function CountryIcon(_ref2) {
        var country = _ref2.country, label = _ref2.label, aspectRatio = _ref2.aspectRatio, rest = $52b5a828ead0404a$var$_objectWithoutProperties(_ref2, $52b5a828ead0404a$var$_excluded);
        // `aspectRatio` is currently a hack for the default "International" icon
        // to render it as a square when Unicode flag icons are used.
        // So `aspectRatio` property is only used with the default "International" icon.
        var _aspectRatio = InternationalIcon === (0, $iSrnw.default) ? aspectRatio : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $52b5a828ead0404a$var$_extends({}, rest, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputCountryIcon', {
                'PhoneInputCountryIcon--square': _aspectRatio === 1,
                'PhoneInputCountryIcon--border': country
            })
        }), country ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FlagComponent, {
            country: country,
            countryName: label,
            flags: flags,
            flagUrl: flagUrl,
            className: "PhoneInputCountryIconImg"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InternationalIcon, {
            title: label,
            aspectRatio: _aspectRatio,
            className: "PhoneInputCountryIconImg"
        }));
    }
    CountryIcon.propTypes = {
        country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    };
    return CountryIcon;
}
var $52b5a828ead0404a$export$2e2bcd8739ae039 = $52b5a828ead0404a$export$c8cd064d62c67fdc({
    // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    flagComponent: (0, $gLQDv.default),
    internationalIcon: (0, $iSrnw.default)
});

});

parcelRegister("dTfRb", function(module, exports) {

$parcel$export(module.exports, "getPreSelectedCountry", () => $a1ccb640610c5bae$export$5b746bf50fbb3c55);
$parcel$export(module.exports, "getCountrySelectOptions", () => $a1ccb640610c5bae$export$85590f0e7cf668c8);
$parcel$export(module.exports, "parsePhoneNumber", () => $a1ccb640610c5bae$export$da44e4eaa54bc82e);
$parcel$export(module.exports, "getPhoneDigitsForNewCountry", () => $a1ccb640610c5bae$export$4222dedf18d79e22);
$parcel$export(module.exports, "e164", () => $a1ccb640610c5bae$export$2fa5ed24c9ef198e);
$parcel$export(module.exports, "getCountryForPartialE164Number", () => $a1ccb640610c5bae$export$e7408f1ddc48b26e);
$parcel$export(module.exports, "onPhoneDigitsChange", () => $a1ccb640610c5bae$export$b48270ccb996e66);
$parcel$export(module.exports, "getInitialPhoneDigits", () => $a1ccb640610c5bae$export$3b7f83419d3c9d9c);

var $iPkor = parcelRequire("iPkor");
var $gAr6H = parcelRequire("gAr6H");
var $lijQr = parcelRequire("lijQr");

var $1aLMe = parcelRequire("1aLMe");
function $a1ccb640610c5bae$export$5b746bf50fbb3c55(_ref) {
    var value = _ref.value, phoneNumber = _ref.phoneNumber, defaultCountry = _ref.defaultCountry, getAnyCountry = _ref.getAnyCountry, countries = _ref.countries, required = _ref.required, metadata = _ref.metadata;
    var country; // If can get country from E.164 phone number
    // then it overrides the `country` passed (or not passed).
    if (phoneNumber && phoneNumber.country) // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
    else if (defaultCountry) {
        if (!value || $a1ccb640610c5bae$export$c3b71c8ffbba4219(value, defaultCountry, metadata)) country = defaultCountry;
    } // Only pre-select a country if it's in the available `countries` list.
    if (countries && countries.indexOf(country) < 0) country = undefined;
     // If there will be no "International" option
    // then some `country` must be selected.
    // It will still be the wrong country though.
    // But still country `<select/>` can't be left in a broken state.
    if (!country && required && countries && countries.length > 0) country = getAnyCountry(); // noCountryMatchesTheNumber = true
    return country;
}
function $a1ccb640610c5bae$export$85590f0e7cf668c8(_ref2) {
    var countries = _ref2.countries, countryNames = _ref2.countryNames, addInternationalOption = _ref2.addInternationalOption, compareStringsLocales = _ref2.compareStringsLocales, _compareStrings = _ref2.compareStrings;
    // Default country name comparator uses `String.localeCompare()`.
    if (!_compareStrings) _compareStrings = $a1ccb640610c5bae$export$633da1651c3bd3f9;
     // Generates a `<Select/>` option for each country.
    var countrySelectOptions = countries.map(function(country) {
        return {
            value: country,
            // All `locale` country names included in this library
            // include all countries (this is checked at build time).
            // The only case when a country name might be missing
            // is when a developer supplies their own `labels` property.
            // To guard against such cases, a missing country name
            // is substituted by country code.
            label: countryNames[country] || country
        };
    }); // Sort the list of countries alphabetically.
    countrySelectOptions.sort(function(a, b) {
        return _compareStrings(a.label, b.label, compareStringsLocales);
    }); // Add the "International" option to the country list (if suitable)
    if (addInternationalOption) countrySelectOptions.unshift({
        label: countryNames.ZZ
    });
    return countrySelectOptions;
}
function $a1ccb640610c5bae$export$da44e4eaa54bc82e(value, metadata) {
    return (0, $gAr6H.default)(value || '', metadata);
}
function $a1ccb640610c5bae$export$3a77a656b43ad765(phoneNumber) {
    return phoneNumber.formatNational().replace(/\D/g, '');
}
function $a1ccb640610c5bae$export$4222dedf18d79e22(phoneDigits, _ref3) {
    var prevCountry = _ref3.prevCountry, newCountry = _ref3.newCountry, metadata = _ref3.metadata, useNationalFormat = _ref3.useNationalFormat;
    if (prevCountry === newCountry) return phoneDigits;
     // If `parsed_input` is empty
    // then no need to migrate anything.
    if (!phoneDigits) {
        if (useNationalFormat) return '';
        else // If `phoneDigits` is empty then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.
        return (0, $1aLMe.default)(newCountry, metadata);
    } // If switching to some country.
    // (from "International" or another country)
    // If switching from "International" then `phoneDigits` starts with a `+`.
    // Otherwise it may or may not start with a `+`.
    if (newCountry) // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    {
        if (phoneDigits[0] === '+') {
            // If the international phone number is for the new country
            // then convert it to local if required.
            if (useNationalFormat) {
                // // If a phone number is being input in international form
                // // and the country can already be derived from it,
                // // and if it is the new country, then format as a national number.
                // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
                // if (derived_country === newCountry) {
                // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
                // }
                // Actually, the two countries don't necessarily need to match:
                // the condition could be looser here, because several countries
                // might share the same international phone number format
                // (for example, "NANPA" countries like US, Canada, etc).
                // The looser condition would be just "same nternational phone number format"
                // which would mean "same country calling code" in the context of `libphonenumber-js`.
                if (phoneDigits.indexOf('+' + (0, $lijQr.getCountryCallingCode)(newCountry, metadata)) === 0) return $a1ccb640610c5bae$export$4d2c4a09d0258b4e(phoneDigits, newCountry, metadata);
                 // Simply discard the previously entered international phone number,
                // because otherwise any "smart" transformation like getting the
                // "national (significant) number" part and then prepending the
                // newly selected country's "country calling code" to it
                // would just be confusing for a user without being actually useful.
                return ''; // // Simply strip the leading `+` character
            // // therefore simply converting all digits into a "local" phone number.
            // // https://github.com/catamphetamine/react-phone-number-input/issues/287
            // return phoneDigits.slice(1)
            }
            if (prevCountry) {
                var newCountryPrefix = (0, $1aLMe.default)(newCountry, metadata);
                if (phoneDigits.indexOf(newCountryPrefix) === 0) return phoneDigits;
                else return newCountryPrefix;
            } else {
                var defaultValue = (0, $1aLMe.default)(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
                // as for the new `country`, then leave `phoneDigits` as is.
                if (phoneDigits.indexOf(defaultValue) === 0) return phoneDigits;
                 // If `phoneDigits`'s country calling code part is not the same
                // as for the new `country`, then set `phoneDigits` to
                // `+{getCountryCallingCode(newCountry)}`.
                return defaultValue;
            } // // If the international phone number already contains
        // // any country calling code then trim the country calling code part.
        // // (that could also be the newly selected country phone code prefix as well)
        // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
        // // (e.g. if a user enters an international number
        // //  not belonging to any of the reduced `countries` list).
        // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
        // // Prepend country calling code prefix
        // // for the newly selected country.
        // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`
        }
    } else {
        // If the phone number was entered in national format.
        if (phoneDigits[0] !== '+') // Format the national phone number as an international one.
        // The phone number entered not necessarily even starts with
        // the previously selected country phone prefix.
        // Even if the phone number belongs to whole another country
        // it will still be parsed into some national phone number.
        //
        // Ignore the now-uncovered `|| ''` code branch:
        // previously `e164()` function could return an empty string
        // even when `phoneDigits` were not empty.
        // Now it always returns some `value` when there're any `phoneDigits`.
        // Still, didn't remove the `|| ''` code branch just in case
        // that logic changes somehow in some future, so there're no
        // possible bugs related to that.
        //
        // (ignore the `|| ''` code branch)
        /* istanbul ignore next */ return $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, prevCountry, metadata) || '';
    }
    return phoneDigits;
}
function $a1ccb640610c5bae$export$2fa5ed24c9ef198e(number, country, metadata) {
    if (!number) return;
     // If the phone number is being input in international format.
    if (number[0] === '+') {
        // If it's just the `+` sign then return nothing.
        if (number === '+') return;
         // Return a E.164 phone number.
        //
        // Could return `number` "as is" here, but there's a possibility
        // that some user might incorrectly input an international number
        // with a "national prefix". Such numbers aren't considered valid,
        // but `libphonenumber-js` is "forgiving" when it comes to parsing
        // user's input, and this input component follows that behavior.
        //
        var asYouType = new (0, $iPkor.default)(country, metadata);
        asYouType.input(number); // This function would return `undefined` only when `number` is `"+"`,
        // but at this point it is known that `number` is not `"+"`.
        return asYouType.getNumberValue();
    } // For non-international phone numbers
    // an accompanying country code is required.
    // The situation when `country` is `undefined`
    // and a non-international phone number is passed
    // to this function shouldn't happen.
    if (!country) return;
    var partial_national_significant_number = $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata); //
    // Even if no "national (significant) number" digits have been input,
    // still return a non-`undefined` value.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
    //
    // For example, if the user has selected country `US` and entered `"1"`
    // then that `"1"` is just a "national prefix" and no "national (significant) number"
    // digits have been input yet. Still, return `"+1"` as `value` in such cases,
    // because otherwise the app would think that the input is empty and mark it as such
    // while in reality it isn't empty, which might be thought of as a "bug", or just
    // a "weird" behavior.
    //
    // if (partial_national_significant_number) {
    return "+".concat((0, $lijQr.getCountryCallingCode)(country, metadata)).concat(partial_national_significant_number || ''); // }
}
function $a1ccb640610c5bae$export$5be79a0015c5ab12(number, country, metadata) {
    var nationalSignificantNumberPart = $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata);
    if (nationalSignificantNumberPart) {
        var overflowDigitsCount = nationalSignificantNumberPart.length - $a1ccb640610c5bae$var$getMaxNumberLength(country, metadata);
        if (overflowDigitsCount > 0) return number.slice(0, number.length - overflowDigitsCount);
    }
    return number;
}
function $a1ccb640610c5bae$var$getMaxNumberLength(country, metadata) {
    // Get "possible lengths" for a phone number of the country.
    metadata = new (0, $lijQr.default)(metadata);
    metadata.selectNumberingPlan(country); // Return the last "possible length".
    return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
function $a1ccb640610c5bae$export$e7408f1ddc48b26e(partialE164Number, _ref4) {
    var country = _ref4.country, countries = _ref4.countries, required = _ref4.required, metadata = _ref4.metadata;
    if (partialE164Number === '+') // Don't change the currently selected country yet.
    return country;
    var derived_country = $a1ccb640610c5bae$export$848ed6f49dfa5296(partialE164Number, metadata); // If a phone number is being input in international form
    // and the country can already be derived from it,
    // then select that country.
    if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) return derived_country;
    else if (country && !required && !$a1ccb640610c5bae$export$c3b71c8ffbba4219(partialE164Number, country, metadata)) return undefined;
     // Don't change the currently selected country.
    return country;
}
function $a1ccb640610c5bae$export$b48270ccb996e66(phoneDigits, _ref5) {
    var prevPhoneDigits = _ref5.prevPhoneDigits, country = _ref5.country, defaultCountry = _ref5.defaultCountry, countryRequired = _ref5.countryRequired, getAnyCountry = _ref5.getAnyCountry, countries = _ref5.countries, international = _ref5.international, limitMaxLength = _ref5.limitMaxLength, countryCallingCodeEditable = _ref5.countryCallingCodeEditable, metadata = _ref5.metadata;
    if (international && countryCallingCodeEditable === false) {
        var prefix = (0, $1aLMe.default)(country, metadata); // The `<input/>` value must start with the country calling code.
        if (phoneDigits.indexOf(prefix) !== 0) {
            var _value; // If a phone number input is declared as
            // `international` and `withCountryCallingCode`,
            // then it's gonna be non-empty even before the user
            // has input anything in it.
            // This will result in its contents (the country calling code part)
            // being selected when the user tabs into such field.
            // If the user then starts inputting the national part digits,
            // then `<input/>` value changes from `+xxx` to `y`
            // because inputting anything while having the `<input/>` value
            // selected results in erasing the `<input/>` value.
            // So, the component handles such case by restoring
            // the intended `<input/>` value: `+xxxy`.
            // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
            if (phoneDigits && phoneDigits[0] !== '+') {
                phoneDigits = prefix + phoneDigits;
                _value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
            } else phoneDigits = prefix;
            return {
                phoneDigits: phoneDigits,
                value: _value,
                country: country
            };
        }
    } // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).
    if (international === false && country && phoneDigits && phoneDigits[0] === '+') phoneDigits = $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
     // Trim the input to not exceed the maximum possible number length.
    if (phoneDigits && country && limitMaxLength) phoneDigits = $a1ccb640610c5bae$export$5be79a0015c5ab12(phoneDigits, country, metadata);
     // If this `onChange()` event was triggered
    // as a result of selecting "International" country,
    // then force-prepend a `+` sign if the phone number
    // `<input/>` value isn't in international format.
    // Also, force-prepend a `+` sign if international
    // phone number input format is set.
    if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) phoneDigits = '+' + phoneDigits;
     // If the previously entered phone number
    // has been entered in international format
    // and the user decides to erase it,
    // then also reset the `country`
    // because it was most likely automatically selected
    // while the user was typing in the phone number
    // in international format.
    // This fixes the issue when a user is presented
    // with a phone number input with no country selected
    // and then types in their local phone number
    // then discovers that the input's messed up
    // (a `+` has been prepended at the start of their input
    //  and a random country has been selected),
    // decides to undo it all by erasing everything
    // and then types in their local phone number again
    // resulting in a seemingly correct phone number
    // but in reality that phone number has incorrect country.
    // https://github.com/catamphetamine/react-phone-number-input/issues/273
    if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
        if (international) country = undefined;
        else country = defaultCountry;
    } // Also resets such "randomly" selected country
    // as soon as the user erases the number
    // digit-by-digit up to the leading `+` sign.
    if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > 1) country = undefined;
     // Generate the new `value` property.
    var value;
    if (phoneDigits) {
        if (phoneDigits[0] === '+') {
            if (phoneDigits === '+') value = undefined;
            else if (country && (0, $1aLMe.default)(country, metadata).indexOf(phoneDigits) === 0) // Selected a `country` but started inputting an
            // international phone number for another country.
            // Even though the input value is non-empty,
            // the `value` is assumed `undefined` in such case.
            // The `country` will be reset (or re-selected)
            // immediately after such mismatch has been detected
            // by the phone number input component, and `value`
            // will be set to the currently entered international prefix.
            //
            // For example, if selected `country` `"US"`
            // and started inputting phone number `"+2"`
            // then `value` `undefined` will be returned from this function,
            // and then, immediately after that, `country` will be reset
            // and the `value` will be set to `"+2"`.
            //
            value = undefined;
            else value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        } else value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
    } // Derive the country from the phone number.
    // (regardless of whether there's any country currently selected,
    //  because there could be several countries corresponding to one country calling code)
    if (value) {
        country = $a1ccb640610c5bae$export$e7408f1ddc48b26e(value, {
            country: country,
            countries: countries,
            metadata: metadata
        }); // If `international` property is `false`, then it means
        // "enforce national-only format during input",
        // so, if that's the case, then remove all `+` characters,
        // but only if some country is currently selected.
        // (not if "International" country is selected).
        if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
            phoneDigits = $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.
            value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        }
    }
    if (!country && countryRequired) country = defaultCountry || getAnyCountry();
    return {
        phoneDigits: phoneDigits,
        country: country,
        value: value
    };
}
function $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(input, country, metadata) {
    // Handle the case when a user might have pasted
    // a phone number in international format.
    if (input.indexOf((0, $1aLMe.default)(country, metadata)) === 0) {
        // Create "as you type" formatter.
        var formatter = new (0, $iPkor.default)(country, metadata); // Input partial national phone number.
        formatter.input(input); // Return the parsed partial national phone number.
        var phoneNumber = formatter.getNumber();
        if (phoneNumber) // Transform the number to a national one,
        // and remove all non-digits.
        return phoneNumber.formatNational().replace(/\D/g, '');
        else return '';
    } else // Just remove the `+` sign.
    return input.replace(/\D/g, '');
}
function $a1ccb640610c5bae$export$848ed6f49dfa5296(number, metadata) {
    var formatter = new (0, $iPkor.default)(null, metadata);
    formatter.input(number); // // `001` is a special "non-geograpical entity" code
    // // in Google's `libphonenumber` library.
    // if (formatter.getCountry() === '001') {
    // 	return
    // }
    return formatter.getCountry();
}
function $a1ccb640610c5bae$export$633da1651c3bd3f9(a, b, locales) {
    // Use `String.localeCompare` if it's available.
    // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
    // Which means everyone except IE <= 10 and Safari <= 10.
    // `localeCompare()` is available in latest Node.js versions.
    /* istanbul ignore else */ if (String.prototype.localeCompare) return a.localeCompare(b, locales);
    /* istanbul ignore next */ return a < b ? -1 : a > b ? 1 : 0;
}
function $a1ccb640610c5bae$export$4d2c4a09d0258b4e(number, country, metadata) {
    // Just an optimization, so that it
    // doesn't have to iterate through all country calling codes.
    if (country) {
        var countryCallingCodePrefix = '+' + (0, $lijQr.getCountryCallingCode)(country, metadata); // If `country` fits the actual `number`.
        if (number.length < countryCallingCodePrefix.length) {
            if (countryCallingCodePrefix.indexOf(number) === 0) return '';
        } else {
            if (number.indexOf(countryCallingCodePrefix) === 0) return number.slice(countryCallingCodePrefix.length);
        }
    } // If `country` doesn't fit the actual `number`.
    // Try all available country calling codes.
    for(var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++){
        var country_calling_code = _Object$keys[_i];
        if (number.indexOf(country_calling_code) === 1) return number.slice(1 + country_calling_code.length);
    }
    return '';
}
function $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata) {
    // Create "as you type" formatter.
    var formatter = new (0, $iPkor.default)(country, metadata); // Input partial national phone number.
    formatter.input(number); // Return the parsed partial national phone number.
    var phoneNumber = formatter.getNumber();
    return phoneNumber && phoneNumber.nationalNumber;
}
function $a1ccb640610c5bae$export$c3b71c8ffbba4219(number, country, metadata) {
    var intlPhoneNumberPrefix = (0, $1aLMe.default)(country, metadata);
    var i = 0;
    while(i < number.length && i < intlPhoneNumberPrefix.length){
        if (number[i] !== intlPhoneNumberPrefix[i]) return false;
        i++;
    }
    return true;
}
function $a1ccb640610c5bae$export$3b7f83419d3c9d9c(_ref6) {
    var value = _ref6.value, phoneNumber = _ref6.phoneNumber, defaultCountry = _ref6.defaultCountry, international = _ref6.international, useNationalFormat = _ref6.useNationalFormat, metadata = _ref6.metadata;
    // If the `value` (E.164 phone number)
    // belongs to the currently selected country
    // and `useNationalFormat` is `true`
    // then convert `value` (E.164 phone number)
    // to a local phone number digits.
    // E.g. '+78005553535' -> '88005553535'.
    if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) return $a1ccb640610c5bae$export$3a77a656b43ad765(phoneNumber);
     // If `international` property is `true`,
    // meaning "enforce international phone number format",
    // then always show country calling code in the input field.
    if (!value && international && defaultCountry) return (0, $1aLMe.default)(defaultCountry, metadata);
    return value;
}

});
parcelRegister("1aLMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dabc91bce1ee96e$export$2e2bcd8739ae039);

var $lijQr = parcelRequire("lijQr");
var $0dabc91bce1ee96e$var$ONLY_DIGITS_REGEXP = /^\d+$/;
function $0dabc91bce1ee96e$export$2e2bcd8739ae039(country, metadata) {
    // Standard international phone number prefix: "+" and "country calling code".
    var prefix = '+' + (0, $lijQr.getCountryCallingCode)(country, metadata); // Get "leading digits" for a phone number of the country.
    // If there're "leading digits" then they can be part of the prefix too.
    metadata = new (0, $lijQr.default)(metadata);
    metadata.selectNumberingPlan(country);
    if (metadata.numberingPlan.leadingDigits() && $0dabc91bce1ee96e$var$ONLY_DIGITS_REGEXP.test(metadata.numberingPlan.leadingDigits())) prefix += metadata.numberingPlan.leadingDigits();
    return prefix;
}

});


parcelRegister("ffz1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a36d6ef1af5dce$export$2e2bcd8739ae039);

var $dTfRb = parcelRequire("dTfRb");

var $fpKOC = parcelRequire("fpKOC");
function $b1a36d6ef1af5dce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b1a36d6ef1af5dce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b1a36d6ef1af5dce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b1a36d6ef1af5dce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b1a36d6ef1af5dce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b1a36d6ef1af5dce$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b1a36d6ef1af5dce$export$2e2bcd8739ae039(props, prevProps, state) {
    var metadata = props.metadata, countries = props.countries, newDefaultCountry = props.defaultCountry, newValue = props.value, newReset = props.reset, international = props.international, displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber, initialValueFormat = props.initialValueFormat;
    var prevDefaultCountry = prevProps.defaultCountry, prevValue = prevProps.value, prevReset = prevProps.reset;
    var country = state.country, value = state.value, hasUserSelectedACountry = state.hasUserSelectedACountry;
    var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
        return (0, $dTfRb.getInitialPhoneDigits)($b1a36d6ef1af5dce$var$_objectSpread($b1a36d6ef1af5dce$var$_objectSpread({}, parameters), {}, {
            international: international,
            useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
            metadata: metadata
        }));
    }; // Some users requested a way to reset the component
    // (both number `<input/>` and country `<select/>`).
    // Whenever `reset` property changes both number `<input/>`
    // and country `<select/>` are reset.
    // It's not implemented as some instance `.reset()` method
    // because `ref` is forwarded to `<input/>`.
    // It's also not replaced with just resetting `country` on
    // external `value` reset, because a user could select a country
    // and then not input any `value`, and so the selected country
    // would be "stuck", if not using this `reset` property.
    // https://github.com/catamphetamine/react-phone-number-input/issues/300
    if (newReset !== prevReset) return {
        phoneDigits: _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: newDefaultCountry
        }),
        value: undefined,
        country: newDefaultCountry,
        hasUserSelectedACountry: undefined
    };
     // `value` is the value currently shown in the component:
    // it's stored in the component's `state`, and it's not the `value` property.
    // `prevValue` is "previous `value` property".
    // `newValue` is "new `value` property".
    // If the default country changed
    // (e.g. in case of ajax GeoIP detection after page loaded)
    // then select it, but only if the user hasn't already manually
    // selected a country, and no phone number has been manually entered so far.
    // Because if the user has already started inputting a phone number
    // then they're okay with no country being selected at all ("International")
    // and they don't want to be disturbed, don't want their input to be screwed, etc.
    if (newDefaultCountry !== prevDefaultCountry) {
        var isNewDefaultCountrySupported = !newDefaultCountry || (0, $fpKOC.isCountrySupportedWithError)(newDefaultCountry, metadata);
        var noValueHasBeenEnteredByTheUser = !value || // When `international` is `true`, and some country has been pre-selected,
        // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
        // so in case of `international` being `true`, "the user hasn't entered anything" situation
        // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
        international && value === _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: prevDefaultCountry
        }); // Only update the `defaultCountry` property if no phone number
        // has been entered by the user or pre-set by the application.
        var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;
        if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) return {
            country: newDefaultCountry,
            // If `phoneDigits` is empty, then automatically select the new `country`
            // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
            // The code assumes that "no phone number has been entered by the user",
            // and no `value` property has been passed, so the `phoneNumber` parameter
            // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
            phoneDigits: _getInitialPhoneDigits({
                value: undefined,
                defaultCountry: newDefaultCountry
            }),
            // `value` is `undefined` and it stays so.
            value: undefined
        };
    } // If a new `value` is set externally.
    // (e.g. as a result of an ajax API request
    //  to get user's phone after page loaded)
    // The first part — `newValue !== prevValue` —
    // is basically `props.value !== prevProps.value`
    // so it means "if value property was changed externally".
    // The second part — `newValue !== value` —
    // is for ignoring the `getDerivedStateFromProps()` call
    // which happens in `this.onChange()` right after `this.setState()`.
    // If this `getDerivedStateFromProps()` call isn't ignored
    // then the country flag would reset on each input.
    if (newValue !== prevValue && newValue !== value) {
        var phoneNumber;
        var parsedCountry;
        if (newValue) {
            phoneNumber = (0, $dTfRb.parsePhoneNumber)(newValue, metadata);
            var supportedCountries = (0, $fpKOC.getSupportedCountries)(countries, metadata);
            if (phoneNumber && phoneNumber.country) // Ignore `else` because all countries are supported in metadata.
            /* istanbul ignore next */ {
                if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) parsedCountry = phoneNumber.country;
            } else parsedCountry = (0, $dTfRb.getCountryForPartialE164Number)(newValue, {
                country: undefined,
                countries: supportedCountries,
                metadata: metadata
            });
        }
        var hasUserSelectedACountryUpdate;
        if (!newValue) // Reset `hasUserSelectedACountry` flag in `state`.
        hasUserSelectedACountryUpdate = {
            hasUserSelectedACountry: undefined
        };
        return $b1a36d6ef1af5dce$var$_objectSpread($b1a36d6ef1af5dce$var$_objectSpread({}, hasUserSelectedACountryUpdate), {}, {
            phoneDigits: _getInitialPhoneDigits({
                phoneNumber: phoneNumber,
                value: newValue,
                defaultCountry: newDefaultCountry
            }),
            value: newValue,
            country: newValue ? parsedCountry : newDefaultCountry
        });
    } // `defaultCountry` didn't change.
// `value` didn't change.
// `phoneDigits` didn't change, because `value` didn't change.
//
// So no need to update state.
}

});




parcelRegister("cjnbD", function(module, exports) {

$parcel$export(module.exports, "searchValidationSchema", () => $41d1cd47b59a4526$export$9a7b64dff54ee178);
$parcel$export(module.exports, "caseGuestUserNewValidationSchema", () => $41d1cd47b59a4526$export$34be326473349636);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $lxAyE = parcelRequire("lxAyE");
const $41d1cd47b59a4526$export$9a7b64dff54ee178 = ()=>{
    return $hDGtv.create().shape({
        searchTerm: $gcL7X.create().matches(/^[a-zA-Z0-9\s-/]*$/, (0, $5wPBK.default).t("shared:searchInputValidation"))
    });
};
const $41d1cd47b59a4526$export$34be326473349636 = (usersEmail)=>{
    return $hDGtv.create().shape({
        firstName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        lastName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        email: $gcL7X.create().trim().email((0, $5wPBK.default).t("shared:invalidEmail")).required((0, $5wPBK.default).t("shared:required")).notOneOf(usersEmail, (0, $5wPBK.default).t("shared:emailExists")),
        phoneNumber: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")).test("phoneValid", (0, $5wPBK.default).t("shared:invalidPhone"), function(value) {
            if (!value) return false;
            return (0, $lxAyE.isValidPhoneNumber)(value);
        })
    });
};

});

parcelRegister("dBkgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d819c5ea2609a55$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $4KSAX = parcelRequire("4KSAX");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $04A9g = parcelRequire("04A9g");

var $jF0Xa = parcelRequire("jF0Xa");

var $hnLuc = parcelRequire("hnLuc");

var $wwQ9q = parcelRequire("wwQ9q");

var $lCZwG = parcelRequire("lCZwG");

var $lxAyE = parcelRequire("lxAyE");

var $8e5HJ = parcelRequire("8e5HJ");
const $1d819c5ea2609a55$var$GuestUserFormContent = (props)=>{
    const { isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue, setFieldTouched: setFieldTouched, isValid: isValid } = (0, $7YFi7.useFormikContext)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const titleOptions = Object.keys((0, $8e5HJ.UserTitles)).map((key)=>{
        return {
            value: (0, $8e5HJ.UserTitles)[key],
            label: key
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "title",
                        children: t("user:title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "title",
                        options: titleOptions,
                        onChange: handleChange,
                        onBlur: handleBlur
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.title,
                        isVisible: errors.title && touched.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "professionalTitle",
                        children: t("user:professionalTitle")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "professionalTitle",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.professionalTitle,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.professionalTitle,
                        isVisible: errors.professionalTitle && touched.professionalTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "firstName",
                        required: true,
                        children: t("user:firstName")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "firstName",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.firstName,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.firstName,
                        isVisible: errors.firstName && touched.firstName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "lastName",
                        required: true,
                        children: t("user:lastName")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "lastName",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.lastName,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.lastName,
                        isVisible: errors.lastName && touched.lastName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hnLuc.default), {
                caseId: props.caseId,
                canInviteAsGuest: true,
                closeModal: props.closeModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "email",
                        required: true,
                        children: t("user:email")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "email",
                        name: "email",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.email,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.email,
                        isVisible: errors.email && touched.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "phoneNumber",
                        required: true,
                        children: t("user:phoneNumber")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lxAyE.default), {
                        value: values.phoneNumber,
                        onChange: (value)=>{
                            setFieldValue("phoneNumber", value);
                        },
                        onBlur: ()=>setFieldTouched("phoneNumber"),
                        defaultCountry: "GB",
                        // TODO: Fix flags not showing in prod when loaded with flagUrl
                        // flagUrl={`${location.origin}/images/svg/flags/{xx}.svg`}
                        flags: (0, $wwQ9q.default)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.phoneNumber,
                        isVisible: errors.phoneNumber && touched.phoneNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "organisation",
                        children: t("user:guestOrganisation")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "organisation",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.organisation,
                        autoComplete: "off"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                className: "mb-2",
                buttons: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: props.closeModal,
                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                        children: t("shared:cancel")
                    }, "1"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        isDisabled: isSubmitting || !isValid,
                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                        isSubmit: true,
                        children: t("case:guestUsers:buttons:createGuestUser")
                    }, 2)
                ]
            })
        ]
    });
};
var $1d819c5ea2609a55$export$2e2bcd8739ae039 = $1d819c5ea2609a55$var$GuestUserFormContent;

});
parcelRegister("wwQ9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $061c76a48897c687$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $061c76a48897c687$var$_excluded = [
    "title"
], $061c76a48897c687$var$_excluded2 = [
    "title"
], $061c76a48897c687$var$_excluded3 = [
    "title"
], $061c76a48897c687$var$_excluded4 = [
    "title"
], $061c76a48897c687$var$_excluded5 = [
    "title"
], $061c76a48897c687$var$_excluded6 = [
    "title"
], $061c76a48897c687$var$_excluded7 = [
    "title"
], $061c76a48897c687$var$_excluded8 = [
    "title"
], $061c76a48897c687$var$_excluded9 = [
    "title"
], $061c76a48897c687$var$_excluded10 = [
    "title"
], $061c76a48897c687$var$_excluded11 = [
    "title"
], $061c76a48897c687$var$_excluded12 = [
    "title"
], $061c76a48897c687$var$_excluded13 = [
    "title"
], $061c76a48897c687$var$_excluded14 = [
    "title"
], $061c76a48897c687$var$_excluded15 = [
    "title"
], $061c76a48897c687$var$_excluded16 = [
    "title"
], $061c76a48897c687$var$_excluded17 = [
    "title"
], $061c76a48897c687$var$_excluded18 = [
    "title"
], $061c76a48897c687$var$_excluded19 = [
    "title"
], $061c76a48897c687$var$_excluded20 = [
    "title"
], $061c76a48897c687$var$_excluded21 = [
    "title"
], $061c76a48897c687$var$_excluded22 = [
    "title"
], $061c76a48897c687$var$_excluded23 = [
    "title"
], $061c76a48897c687$var$_excluded24 = [
    "title"
], $061c76a48897c687$var$_excluded25 = [
    "title"
], $061c76a48897c687$var$_excluded26 = [
    "title"
], $061c76a48897c687$var$_excluded27 = [
    "title"
], $061c76a48897c687$var$_excluded28 = [
    "title"
], $061c76a48897c687$var$_excluded29 = [
    "title"
], $061c76a48897c687$var$_excluded30 = [
    "title"
], $061c76a48897c687$var$_excluded31 = [
    "title"
], $061c76a48897c687$var$_excluded32 = [
    "title"
], $061c76a48897c687$var$_excluded33 = [
    "title"
], $061c76a48897c687$var$_excluded34 = [
    "title"
], $061c76a48897c687$var$_excluded35 = [
    "title"
], $061c76a48897c687$var$_excluded36 = [
    "title"
], $061c76a48897c687$var$_excluded37 = [
    "title"
], $061c76a48897c687$var$_excluded38 = [
    "title"
], $061c76a48897c687$var$_excluded39 = [
    "title"
], $061c76a48897c687$var$_excluded40 = [
    "title"
], $061c76a48897c687$var$_excluded41 = [
    "title"
], $061c76a48897c687$var$_excluded42 = [
    "title"
], $061c76a48897c687$var$_excluded43 = [
    "title"
], $061c76a48897c687$var$_excluded44 = [
    "title"
], $061c76a48897c687$var$_excluded45 = [
    "title"
], $061c76a48897c687$var$_excluded46 = [
    "title"
], $061c76a48897c687$var$_excluded47 = [
    "title"
], $061c76a48897c687$var$_excluded48 = [
    "title"
], $061c76a48897c687$var$_excluded49 = [
    "title"
], $061c76a48897c687$var$_excluded50 = [
    "title"
], $061c76a48897c687$var$_excluded51 = [
    "title"
], $061c76a48897c687$var$_excluded52 = [
    "title"
], $061c76a48897c687$var$_excluded53 = [
    "title"
], $061c76a48897c687$var$_excluded54 = [
    "title"
], $061c76a48897c687$var$_excluded55 = [
    "title"
], $061c76a48897c687$var$_excluded56 = [
    "title"
], $061c76a48897c687$var$_excluded57 = [
    "title"
], $061c76a48897c687$var$_excluded58 = [
    "title"
], $061c76a48897c687$var$_excluded59 = [
    "title"
], $061c76a48897c687$var$_excluded60 = [
    "title"
], $061c76a48897c687$var$_excluded61 = [
    "title"
], $061c76a48897c687$var$_excluded62 = [
    "title"
], $061c76a48897c687$var$_excluded63 = [
    "title"
], $061c76a48897c687$var$_excluded64 = [
    "title"
], $061c76a48897c687$var$_excluded65 = [
    "title"
], $061c76a48897c687$var$_excluded66 = [
    "title"
], $061c76a48897c687$var$_excluded67 = [
    "title"
], $061c76a48897c687$var$_excluded68 = [
    "title"
], $061c76a48897c687$var$_excluded69 = [
    "title"
], $061c76a48897c687$var$_excluded70 = [
    "title"
], $061c76a48897c687$var$_excluded71 = [
    "title"
], $061c76a48897c687$var$_excluded72 = [
    "title"
], $061c76a48897c687$var$_excluded73 = [
    "title"
], $061c76a48897c687$var$_excluded74 = [
    "title"
], $061c76a48897c687$var$_excluded75 = [
    "title"
], $061c76a48897c687$var$_excluded76 = [
    "title"
], $061c76a48897c687$var$_excluded77 = [
    "title"
], $061c76a48897c687$var$_excluded78 = [
    "title"
], $061c76a48897c687$var$_excluded79 = [
    "title"
], $061c76a48897c687$var$_excluded80 = [
    "title"
], $061c76a48897c687$var$_excluded81 = [
    "title"
], $061c76a48897c687$var$_excluded82 = [
    "title"
], $061c76a48897c687$var$_excluded83 = [
    "title"
], $061c76a48897c687$var$_excluded84 = [
    "title"
], $061c76a48897c687$var$_excluded85 = [
    "title"
], $061c76a48897c687$var$_excluded86 = [
    "title"
], $061c76a48897c687$var$_excluded87 = [
    "title"
], $061c76a48897c687$var$_excluded88 = [
    "title"
], $061c76a48897c687$var$_excluded89 = [
    "title"
], $061c76a48897c687$var$_excluded90 = [
    "title"
], $061c76a48897c687$var$_excluded91 = [
    "title"
], $061c76a48897c687$var$_excluded92 = [
    "title"
], $061c76a48897c687$var$_excluded93 = [
    "title"
], $061c76a48897c687$var$_excluded94 = [
    "title"
], $061c76a48897c687$var$_excluded95 = [
    "title"
], $061c76a48897c687$var$_excluded96 = [
    "title"
], $061c76a48897c687$var$_excluded97 = [
    "title"
], $061c76a48897c687$var$_excluded98 = [
    "title"
], $061c76a48897c687$var$_excluded99 = [
    "title"
], $061c76a48897c687$var$_excluded100 = [
    "title"
], $061c76a48897c687$var$_excluded101 = [
    "title"
], $061c76a48897c687$var$_excluded102 = [
    "title"
], $061c76a48897c687$var$_excluded103 = [
    "title"
], $061c76a48897c687$var$_excluded104 = [
    "title"
], $061c76a48897c687$var$_excluded105 = [
    "title"
], $061c76a48897c687$var$_excluded106 = [
    "title"
], $061c76a48897c687$var$_excluded107 = [
    "title"
], $061c76a48897c687$var$_excluded108 = [
    "title"
], $061c76a48897c687$var$_excluded109 = [
    "title"
], $061c76a48897c687$var$_excluded110 = [
    "title"
], $061c76a48897c687$var$_excluded111 = [
    "title"
], $061c76a48897c687$var$_excluded112 = [
    "title"
], $061c76a48897c687$var$_excluded113 = [
    "title"
], $061c76a48897c687$var$_excluded114 = [
    "title"
], $061c76a48897c687$var$_excluded115 = [
    "title"
], $061c76a48897c687$var$_excluded116 = [
    "title"
], $061c76a48897c687$var$_excluded117 = [
    "title"
], $061c76a48897c687$var$_excluded118 = [
    "title"
], $061c76a48897c687$var$_excluded119 = [
    "title"
], $061c76a48897c687$var$_excluded120 = [
    "title"
], $061c76a48897c687$var$_excluded121 = [
    "title"
], $061c76a48897c687$var$_excluded122 = [
    "title"
], $061c76a48897c687$var$_excluded123 = [
    "title"
], $061c76a48897c687$var$_excluded124 = [
    "title"
], $061c76a48897c687$var$_excluded125 = [
    "title"
], $061c76a48897c687$var$_excluded126 = [
    "title"
], $061c76a48897c687$var$_excluded127 = [
    "title"
], $061c76a48897c687$var$_excluded128 = [
    "title"
], $061c76a48897c687$var$_excluded129 = [
    "title"
], $061c76a48897c687$var$_excluded130 = [
    "title"
], $061c76a48897c687$var$_excluded131 = [
    "title"
], $061c76a48897c687$var$_excluded132 = [
    "title"
], $061c76a48897c687$var$_excluded133 = [
    "title"
], $061c76a48897c687$var$_excluded134 = [
    "title"
], $061c76a48897c687$var$_excluded135 = [
    "title"
], $061c76a48897c687$var$_excluded136 = [
    "title"
], $061c76a48897c687$var$_excluded137 = [
    "title"
], $061c76a48897c687$var$_excluded138 = [
    "title"
], $061c76a48897c687$var$_excluded139 = [
    "title"
], $061c76a48897c687$var$_excluded140 = [
    "title"
], $061c76a48897c687$var$_excluded141 = [
    "title"
], $061c76a48897c687$var$_excluded142 = [
    "title"
], $061c76a48897c687$var$_excluded143 = [
    "title"
], $061c76a48897c687$var$_excluded144 = [
    "title"
], $061c76a48897c687$var$_excluded145 = [
    "title"
], $061c76a48897c687$var$_excluded146 = [
    "title"
], $061c76a48897c687$var$_excluded147 = [
    "title"
], $061c76a48897c687$var$_excluded148 = [
    "title"
], $061c76a48897c687$var$_excluded149 = [
    "title"
], $061c76a48897c687$var$_excluded150 = [
    "title"
], $061c76a48897c687$var$_excluded151 = [
    "title"
], $061c76a48897c687$var$_excluded152 = [
    "title"
], $061c76a48897c687$var$_excluded153 = [
    "title"
], $061c76a48897c687$var$_excluded154 = [
    "title"
], $061c76a48897c687$var$_excluded155 = [
    "title"
], $061c76a48897c687$var$_excluded156 = [
    "title"
], $061c76a48897c687$var$_excluded157 = [
    "title"
], $061c76a48897c687$var$_excluded158 = [
    "title"
], $061c76a48897c687$var$_excluded159 = [
    "title"
], $061c76a48897c687$var$_excluded160 = [
    "title"
], $061c76a48897c687$var$_excluded161 = [
    "title"
], $061c76a48897c687$var$_excluded162 = [
    "title"
], $061c76a48897c687$var$_excluded163 = [
    "title"
], $061c76a48897c687$var$_excluded164 = [
    "title"
], $061c76a48897c687$var$_excluded165 = [
    "title"
], $061c76a48897c687$var$_excluded166 = [
    "title"
], $061c76a48897c687$var$_excluded167 = [
    "title"
], $061c76a48897c687$var$_excluded168 = [
    "title"
], $061c76a48897c687$var$_excluded169 = [
    "title"
], $061c76a48897c687$var$_excluded170 = [
    "title"
], $061c76a48897c687$var$_excluded171 = [
    "title"
], $061c76a48897c687$var$_excluded172 = [
    "title"
], $061c76a48897c687$var$_excluded173 = [
    "title"
], $061c76a48897c687$var$_excluded174 = [
    "title"
], $061c76a48897c687$var$_excluded175 = [
    "title"
], $061c76a48897c687$var$_excluded176 = [
    "title"
], $061c76a48897c687$var$_excluded177 = [
    "title"
], $061c76a48897c687$var$_excluded178 = [
    "title"
], $061c76a48897c687$var$_excluded179 = [
    "title"
], $061c76a48897c687$var$_excluded180 = [
    "title"
], $061c76a48897c687$var$_excluded181 = [
    "title"
], $061c76a48897c687$var$_excluded182 = [
    "title"
], $061c76a48897c687$var$_excluded183 = [
    "title"
], $061c76a48897c687$var$_excluded184 = [
    "title"
], $061c76a48897c687$var$_excluded185 = [
    "title"
], $061c76a48897c687$var$_excluded186 = [
    "title"
], $061c76a48897c687$var$_excluded187 = [
    "title"
], $061c76a48897c687$var$_excluded188 = [
    "title"
], $061c76a48897c687$var$_excluded189 = [
    "title"
], $061c76a48897c687$var$_excluded190 = [
    "title"
], $061c76a48897c687$var$_excluded191 = [
    "title"
], $061c76a48897c687$var$_excluded192 = [
    "title"
], $061c76a48897c687$var$_excluded193 = [
    "title"
], $061c76a48897c687$var$_excluded194 = [
    "title"
], $061c76a48897c687$var$_excluded195 = [
    "title"
], $061c76a48897c687$var$_excluded196 = [
    "title"
], $061c76a48897c687$var$_excluded197 = [
    "title"
], $061c76a48897c687$var$_excluded198 = [
    "title"
], $061c76a48897c687$var$_excluded199 = [
    "title"
], $061c76a48897c687$var$_excluded200 = [
    "title"
], $061c76a48897c687$var$_excluded201 = [
    "title"
], $061c76a48897c687$var$_excluded202 = [
    "title"
], $061c76a48897c687$var$_excluded203 = [
    "title"
], $061c76a48897c687$var$_excluded204 = [
    "title"
], $061c76a48897c687$var$_excluded205 = [
    "title"
], $061c76a48897c687$var$_excluded206 = [
    "title"
], $061c76a48897c687$var$_excluded207 = [
    "title"
], $061c76a48897c687$var$_excluded208 = [
    "title"
], $061c76a48897c687$var$_excluded209 = [
    "title"
], $061c76a48897c687$var$_excluded210 = [
    "title"
], $061c76a48897c687$var$_excluded211 = [
    "title"
], $061c76a48897c687$var$_excluded212 = [
    "title"
], $061c76a48897c687$var$_excluded213 = [
    "title"
], $061c76a48897c687$var$_excluded214 = [
    "title"
], $061c76a48897c687$var$_excluded215 = [
    "title"
], $061c76a48897c687$var$_excluded216 = [
    "title"
], $061c76a48897c687$var$_excluded217 = [
    "title"
], $061c76a48897c687$var$_excluded218 = [
    "title"
], $061c76a48897c687$var$_excluded219 = [
    "title"
], $061c76a48897c687$var$_excluded220 = [
    "title"
], $061c76a48897c687$var$_excluded221 = [
    "title"
], $061c76a48897c687$var$_excluded222 = [
    "title"
], $061c76a48897c687$var$_excluded223 = [
    "title"
], $061c76a48897c687$var$_excluded224 = [
    "title"
], $061c76a48897c687$var$_excluded225 = [
    "title"
], $061c76a48897c687$var$_excluded226 = [
    "title"
], $061c76a48897c687$var$_excluded227 = [
    "title"
], $061c76a48897c687$var$_excluded228 = [
    "title"
], $061c76a48897c687$var$_excluded229 = [
    "title"
], $061c76a48897c687$var$_excluded230 = [
    "title"
], $061c76a48897c687$var$_excluded231 = [
    "title"
], $061c76a48897c687$var$_excluded232 = [
    "title"
], $061c76a48897c687$var$_excluded233 = [
    "title"
], $061c76a48897c687$var$_excluded234 = [
    "title"
], $061c76a48897c687$var$_excluded235 = [
    "title"
], $061c76a48897c687$var$_excluded236 = [
    "title"
], $061c76a48897c687$var$_excluded237 = [
    "title"
], $061c76a48897c687$var$_excluded238 = [
    "title"
], $061c76a48897c687$var$_excluded239 = [
    "title"
], $061c76a48897c687$var$_excluded240 = [
    "title"
], $061c76a48897c687$var$_excluded241 = [
    "title"
], $061c76a48897c687$var$_excluded242 = [
    "title"
], $061c76a48897c687$var$_excluded243 = [
    "title"
], $061c76a48897c687$var$_excluded244 = [
    "title"
], $061c76a48897c687$var$_excluded245 = [
    "title"
], $061c76a48897c687$var$_excluded246 = [
    "title"
], $061c76a48897c687$var$_excluded247 = [
    "title"
], $061c76a48897c687$var$_excluded248 = [
    "title"
], $061c76a48897c687$var$_excluded249 = [
    "title"
], $061c76a48897c687$var$_excluded250 = [
    "title"
], $061c76a48897c687$var$_excluded251 = [
    "title"
], $061c76a48897c687$var$_excluded252 = [
    "title"
], $061c76a48897c687$var$_excluded253 = [
    "title"
], $061c76a48897c687$var$_excluded254 = [
    "title"
];
function $061c76a48897c687$var$_extends() {
    $061c76a48897c687$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $061c76a48897c687$var$_extends.apply(this, arguments);
}
function $061c76a48897c687$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $061c76a48897c687$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $061c76a48897c687$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $061c76a48897c687$export$871e5f91a510f021 = function AC(_ref) {
    var title = _ref.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref, $061c76a48897c687$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#5CC85C",
        d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-82.3 291.431 225.686)",
        fill: "#F7A226",
        cx: 291.4,
        cy: 225.7,
        rx: 48.7,
        ry: 15.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-68.099 303.087 164.67)",
        fill: "#DDC7AB",
        cx: 303.1,
        cy: 164.7,
        rx: 11.7,
        ry: 7.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-81.738 291.697 271.697)",
        fill: "#DDC7AB",
        cx: 291.7,
        cy: 271.7,
        rx: 11.4,
        ry: 3.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
        fill: "#DDC7AB",
        cx: 299.6,
        cy: 269.4,
        rx: 3.3,
        ry: 11
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-21.518 314.54 201.06)",
        fill: "#DDC7AB",
        cx: 314.5,
        cy: 201.1,
        rx: 4.1,
        ry: 13.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-21.518 317.511 178.077)",
        fill: "#DDC7AB",
        cx: 317.5,
        cy: 178.1,
        rx: 13.7,
        ry: 4.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-7.7 473.781 225.857)",
        fill: "#F7A226",
        cx: 473.6,
        cy: 225.9,
        rx: 15.7,
        ry: 48.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-21.901 462.057 164.866)",
        fill: "#DDC7AB",
        cx: 462,
        cy: 164.9,
        rx: 7.2,
        ry: 11.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-8.27 473.27 271.908)",
        fill: "#DDC7AB",
        cx: 473.4,
        cy: 271.9,
        rx: 3.3,
        ry: 11.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
        fill: "#DDC7AB",
        cx: 465.5,
        cy: 269.6,
        rx: 11,
        ry: 3.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-68.482 450.552 201.247)",
        fill: "#DDC7AB",
        cx: 450.6,
        cy: 201.2,
        rx: 13.7,
        ry: 4.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        transform: "rotate(-68.482 447.58 178.265)",
        fill: "#DDC7AB",
        cx: 447.6,
        cy: 178.3,
        rx: 4.1,
        ry: 13.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#B0C6CC",
        d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }));
};
var $061c76a48897c687$export$132ea4ffd82bf2b2 = function AD(_ref2) {
    var title = _ref2.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref2, $061c76a48897c687$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, ".prefix__st0{fill:#ffda44}.prefix__st1{fill:#0052b4}.prefix__st2{fill:#d80027}.prefix__st3,.prefix__st4{fill:none;stroke:#d80027;stroke-width:7;stroke-miterlimit:10}.prefix__st4{stroke-width:4}.prefix__st5{fill:#bc8b00}"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
        stroke: "#D80027",
        strokeWidth: 7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
        stroke: "#D80027",
        strokeWidth: 5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#BC8B00",
        d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
    }));
};
var $061c76a48897c687$export$2b2c8e343c91a153 = function AE(_ref3) {
    var title = _ref3.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref3, $061c76a48897c687$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009e49",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ce1126",
        d: "M0 0h171v342H0z"
    }));
};
var $061c76a48897c687$export$515692adc069839f = function AF(_ref4) {
    var title = _ref4.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref4, $061c76a48897c687$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#DB3E00",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#479900",
        d: "M331 0h182v342H331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h181.8v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
    }));
};
var $061c76a48897c687$export$9b1a14e161c718eb = function AG(_ref5) {
    var title = _ref5.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref5, $061c76a48897c687$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0072c6",
        d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#ce1126"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256.5 342 0 0v342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M513 342V0L256 342z"
    })));
};
var $061c76a48897c687$export$d710c5f50fc7496a = function AI(_ref6) {
    var title = _ref6.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref6, $061c76a48897c687$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00318b",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#8DCCFF",
        d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D87B00",
        d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D87B00",
        d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D87B00",
        d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
    }));
};
var $061c76a48897c687$export$1bb1140fe1358b00 = function AL(_ref7) {
    var title = _ref7.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref7, $061c76a48897c687$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ED2024",
        d: "M0 0h90v60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#212121",
        d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
        fill: "#212121"
    }));
};
var $061c76a48897c687$export$1507e1869e034170 = function AM(_ref8) {
    var title = _ref8.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref8, $061c76a48897c687$var$_excluded8);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M0 228h513v114H0z"
    }));
};
var $061c76a48897c687$export$98cc8105f49bb278 = function AO(_ref9) {
    var title = _ref9.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref9, $061c76a48897c687$var$_excluded9);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 171h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        className: "prefix__st0",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#000",
        d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
    })));
};
var $061c76a48897c687$export$123513653fa883e4 = function AQ(_ref10) {
    var title = _ref10.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref10, $061c76a48897c687$var$_excluded10);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 744 496"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#3A7DCE",
        d: "M0 0h744v496H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
    }));
};
var $061c76a48897c687$export$1cd25c0dace0921a = function AR(_ref11) {
    var title = _ref11.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref11, $061c76a48897c687$var$_excluded11);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h512v114H0zm0 228h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFDA44",
        stroke: "#d6ab00",
        strokeWidth: 5,
        cx: 256.5,
        cy: 171,
        r: 40
    }));
};
var $061c76a48897c687$export$33f07343a4b8be1f = function AS(_ref12) {
    var title = _ref12.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref12, $061c76a48897c687$var$_excluded12);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#10338c",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M513 33 95.3 171 513 310.76v30.57L0 171 513 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M513 287.18v24.58L81.72 171 513 30v24.16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#EFC100",
        stroke: "#231F20",
        strokeMiterlimit: 10,
        d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
    }));
};
var $061c76a48897c687$export$537de78b98ba1ef0 = function AT(_ref13) {
    var title = _ref13.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref13, $061c76a48897c687$var$_excluded13);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0zm0 228h513v114H0z"
    }));
};
var $061c76a48897c687$export$24f205cbfb89b8fc = function AU(_ref14) {
    var title = _ref14.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref14, $061c76a48897c687$var$_excluded14);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#10338c",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "m154.6 115 100.2 55.7v-15.8L183 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m154.6 115 100.2 55.7v-15.8L183 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M99 55.7-1.2 0v15.7l71.9 40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M99 55.7-1.2 0v15.7l71.9 40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$d170d5872abbd45 = function AW(_ref15) {
    var title = _ref15.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref15, $061c76a48897c687$var$_excluded15);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 363 242"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h363v242H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f30028",
        d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$f5cd1d288a5591fb = function AX(_ref16) {
    var title = _ref16.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref16, $061c76a48897c687$var$_excluded16);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
    }));
};
var $061c76a48897c687$export$16cde7da05f651a = function AZ(_ref17) {
    var title = _ref17.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref17, $061c76a48897c687$var$_excluded17);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ef3340",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00b5e2",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#509e2f",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
    })));
};
var $061c76a48897c687$export$a73c4d14459b698d = function BA(_ref18) {
    var title = _ref18.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref18, $061c76a48897c687$var$_excluded18);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#10338C",
        d: "M0 0h513.1v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F6C500",
        d: "M99.9 0h342v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
    })));
};
var $061c76a48897c687$export$921068d8846a1559 = function BB(_ref19) {
    var title = _ref19.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref19, $061c76a48897c687$var$_excluded19);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffc726",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h171v342H0zm342 0h171v342H342z",
        fill: "#00267f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
    }));
};
var $061c76a48897c687$export$2672079d1ac1dedf = function BD(_ref20) {
    var title = _ref20.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref20, $061c76a48897c687$var$_excluded20);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2d6e41",
        d: "M0 85.331h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#F40B32",
        cx: 218.902,
        cy: 256.5,
        r: 115
    }));
};
var $061c76a48897c687$export$69784246352913ed = function BE(_ref21) {
    var title = _ref21.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref21, $061c76a48897c687$var$_excluded21);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fdda25",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ef3340",
        d: "M342 0h171v342H342z"
    }));
};
var $061c76a48897c687$export$5d7d56d6166de861 = function BF(_ref22) {
    var title = _ref22.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref22, $061c76a48897c687$var$_excluded22);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#3d944f",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ef2b2d",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
    }));
};
var $061c76a48897c687$export$7ecc97c3ec9172d0 = function BG(_ref23) {
    var title = _ref23.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref23, $061c76a48897c687$var$_excluded23);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00966e",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d62612",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$873be2d0c4c0f90f = function BH(_ref24) {
    var title = _ref24.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref24, $061c76a48897c687$var$_excluded24);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1H0V0h137.6z"
    }));
};
var $061c76a48897c687$export$2601bd2ab73f6dbe = function BI(_ref25) {
    var title = _ref25.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref25, $061c76a48897c687$var$_excluded25);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
        fill: "#47a644"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M512 26.8 296.1 170.7 512 314.6v26.7h-40.1L256 197.4 40.1 341.3H0v-26.7l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 251.6,
        cy: 170.7,
        r: 100.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
        fill: "#D80027",
        stroke: "#47a644",
        strokeWidth: 3
    }));
};
var $061c76a48897c687$export$289e628e47fc68d4 = function BJ(_ref26) {
    var title = _ref26.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref26, $061c76a48897c687$var$_excluded26);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#008751",
        d: "M0 85.333h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fcd116",
        d: "M196.666 85.333H513v171H196.666z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e8112d",
        d: "M196.666 256H513v171H196.666z"
    }));
};
var $061c76a48897c687$export$b54e584898971a5 = function BL(_ref27) {
    var title = _ref27.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref27, $061c76a48897c687$var$_excluded27);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.33"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.33H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E6BC00",
        d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ADADAD",
        d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E6BC00",
        d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#125ECC",
        d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFE600",
        d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D60537",
        d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#EACE00",
        d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#7A6920",
        d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ADADAD",
        d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 258.2,
        cy: 204.19,
        r: 16.93
    }));
};
var $061c76a48897c687$export$f063c90a7fd94f53 = function BM(_ref28) {
    var title = _ref28.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref28, $061c76a48897c687$var$_excluded28);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c8102e",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#012169",
        d: "M0 .1h256.5v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c8102e",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c8102e",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(13 5)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2F8F22",
        d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#65B5D2",
        cx: 383.65,
        cy: 214.56,
        r: 39.88
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#c8102e",
        cx: 343.77,
        cy: 194.63,
        r: 19.94
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#c8102e",
        cx: 423.52,
        cy: 194.63,
        r: 19.94
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#c8102e",
        cx: 383.65,
        cy: 154.75,
        r: 19.94
    })));
};
var $061c76a48897c687$export$ed16643e9b9e3dfe = function BN(_ref29) {
    var title = _ref29.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref29, $061c76a48897c687$var$_excluded29);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.33"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h512v341.33H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m0 193.74 512 127.19V214.26L0 97.08z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 234.26v-86.67L0 20.41v86.67"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027",
        stroke: "#231F20",
        strokeWidth: 3,
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
    })));
};
var $061c76a48897c687$export$cd6527c992e4b6fe = function BO(_ref30) {
    var title = _ref30.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref30, $061c76a48897c687$var$_excluded30);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d52b1e",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f9e300",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#007934",
        d: "M0 228h513v114H0z"
    }));
};
var $061c76a48897c687$export$2ca204c58a1fc922 = function BQ(_ref31) {
    var title = _ref31.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref31, $061c76a48897c687$var$_excluded31);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#012a87",
        d: "M0 341.3h512V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f9d90f",
        d: "M250.4 0H0v166.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#dc171d",
        d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: "#000",
        strokeWidth: 9,
        strokeMiterlimit: 10,
        cx: 140.4,
        cy: 160.6,
        r: 57.7
    }));
};
var $061c76a48897c687$export$b3e0c086157e0a90 = function BR(_ref32) {
    var title = _ref32.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref32, $061c76a48897c687$var$_excluded32);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009b3a",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fedf00",
        d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 256.5,
        cy: 171,
        r: 80.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002776",
        d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
    }));
};
var $061c76a48897c687$export$66ea4a98fa009686 = function BS(_ref33) {
    var title = _ref33.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref33, $061c76a48897c687$var$_excluded33);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffc72c",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#00778b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 256.006 0 426.668V85.331z"
    }));
};
var $061c76a48897c687$export$433b53d451a98e6d = function BT(_ref34) {
    var title = _ref34.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref34, $061c76a48897c687$var$_excluded34);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF7415",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M512 0H0v341.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 42,
        strokeMiterlimit: 10,
        d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
    }));
};
var $061c76a48897c687$export$8ba1594c72a88684 = function BV(_ref35) {
    var title = _ref35.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref35, $061c76a48897c687$var$_excluded35);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 33.333 1100 733.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ef2b2d",
        d: "M0 0h1100v800H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M300 0h200v800H300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M0 300h1100v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002868",
        d: "M350 0h100v800H350z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002868",
        d: "M0 350h1100v100H0z"
    }));
};
var $061c76a48897c687$export$cd7b90d76addb66a = function BW(_ref36) {
    var title = _ref36.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref36, $061c76a48897c687$var$_excluded36);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 238h513v104H0zM0 0h513v104H0z",
        fill: "#6da9d2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 125.5h513v89.656H0z"
    }));
};
var $061c76a48897c687$export$558af6901b7fc79a = function BY(_ref37) {
    var title = _ref37.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref37, $061c76a48897c687$var$_excluded37);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#007C30",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#CE1720",
        d: "M0 230h513V0H0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100 230V0H0v342h513-413z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
        fill: "#CE1720"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
        fill: "none",
        stroke: "#CE1720",
        strokeWidth: 7
    }));
};
var $061c76a48897c687$export$8af59566cb38fe85 = function BZ(_ref38) {
    var title = _ref38.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref38, $061c76a48897c687$var$_excluded38);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#003e87",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 260.9,
        cy: 170.9,
        r: 118.9
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "none",
        stroke: "#6DA544",
        strokeWidth: 18,
        strokeMiterlimit: 10,
        cx: 261.9,
        cy: 173.1,
        r: 94.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        stroke: "#000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#003e87",
        d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M211.3 128.1h101.3v46.7H211.3z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h512v35H0zm0 306h512v35H0z",
        fill: "#ce1127"
    }));
};
var $061c76a48897c687$export$8de6180416dff1fc = function CA(_ref39) {
    var title = _ref39.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref39, $061c76a48897c687$var$_excluded39);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
        fill: "red"
    }));
};
var $061c76a48897c687$export$183b2a0874e6e919 = function CC(_ref40) {
    var title = _ref40.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref40, $061c76a48897c687$var$_excluded40);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "green",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
    }));
};
var $061c76a48897c687$export$6ede307faf7aaec4 = function CD(_ref41) {
    var title = _ref41.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref41, $061c76a48897c687$var$_excluded41);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M512 66.9V0H411.7L0 274.4v66.9h100.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 0v40.1L60.2 341.3H0v-40.1L451.8 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
    }));
};
var $061c76a48897c687$export$ba26f2d80491fb47 = function CF(_ref42) {
    var title = _ref42.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref42, $061c76a48897c687$var$_excluded42);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d21034",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 170.7h211.5V256H0zm300.5 0H512V256H300.5z",
        fill: "#3a9927"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#003082",
        d: "M0 0v85.3h211.5V0h89v85.3H512V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M300.5 341.3h-89V256H0v85.3h512V256H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
        fill: "#ffce00"
    }));
};
var $061c76a48897c687$export$9e8da9070f3c2e68 = function CG(_ref43) {
    var title = _ref43.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref43, $061c76a48897c687$var$_excluded43);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#da1a35",
        d: "M0 85.331h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009543",
        d: "M443.726 85.331 102.4 426.657H0V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fbde4a",
        d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
    }));
};
var $061c76a48897c687$export$31ff2235b44019b8 = function CH(_ref44) {
    var title = _ref44.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref44, $061c76a48897c687$var$_excluded44);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "red",
        d: "M0 85.337h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
    }));
};
var $061c76a48897c687$export$ddcf9efc80efb978 = function CI(_ref45) {
    var title = _ref45.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref45, $061c76a48897c687$var$_excluded45);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009e60",
        d: "M330.207 85.331H512v341.337H330.207z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f77f00",
        d: "M0 85.331h181.793v341.337H0z"
    }));
};
var $061c76a48897c687$export$2779adff9720d9c9 = function CK(_ref46) {
    var title = _ref46.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref46, $061c76a48897c687$var$_excluded46);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#01237a",
        d: "M0 85.332h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
    })));
};
var $061c76a48897c687$export$9bf3043cb7503aa1 = function CL(_ref47) {
    var title = _ref47.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref47, $061c76a48897c687$var$_excluded47);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M196 0h317v171H196z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0037A1",
        d: "M0 0h196v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
    }));
};
var $061c76a48897c687$export$dcd191669c0a595f = function CM(_ref48) {
    var title = _ref48.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref48, $061c76a48897c687$var$_excluded48);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ce1126",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#007a5e",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
        fill: "#fcd116"
    }));
};
var $061c76a48897c687$export$f175668af5171efd = function CN(_ref49) {
    var title = _ref49.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref49, $061c76a48897c687$var$_excluded49);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$423e5ab65bdedcb8 = function CO(_ref50) {
    var title = _ref50.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref50, $061c76a48897c687$var$_excluded50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 343.096h512v83.567H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 256h512v87.096H0z"
    }));
};
var $061c76a48897c687$export$de92be486109a1df = function CR(_ref51) {
    var title = _ref51.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref51, $061c76a48897c687$var$_excluded51);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 211.473h512v89.043H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
        fill: "#0052B4"
    }));
};
var $061c76a48897c687$export$6f478fc577ffffe3 = function CU(_ref52) {
    var title = _ref52.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref52, $061c76a48897c687$var$_excluded52);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M0-40.8v422.9-211.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h512v68.3H0zm0 136.5h512v68.3H0zm0 136.6h512v68.3H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 170.7 0 341.3V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
    }));
};
var $061c76a48897c687$export$9c7a4b602f1ee953 = function CV(_ref53) {
    var title = _ref53.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref53, $061c76a48897c687$var$_excluded53);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#003893",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#cf2027",
        d: "M0 182.2h513v41.4H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
        fill: "#f7d116",
        stroke: "#000"
    }));
};
var $061c76a48897c687$export$640171019d58eb6d = function CW(_ref54) {
    var title = _ref54.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref54, $061c76a48897c687$var$_excluded54);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002b7f",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f9e814",
        d: "M0 233.5h513v51H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$ef748afa94c5c5f9 = function CX(_ref55) {
    var title = _ref55.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref55, $061c76a48897c687$var$_excluded55);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0021ad",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1c8a42",
        d: "M0 0h512v341.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#ffc639",
        cx: 267.1,
        cy: 170.7,
        r: 74.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1c8a42",
        d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffc639",
        d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
    }));
};
var $061c76a48897c687$export$e5e7583d5d9c5f7b = function CY(_ref56) {
    var title = _ref56.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref56, $061c76a48897c687$var$_excluded56);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#DB7D00",
        d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#006651"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
    })));
};
var $061c76a48897c687$export$3aa7db55ae20a642 = function CZ(_ref57) {
    var title = _ref57.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref57, $061c76a48897c687$var$_excluded57);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#11457e",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d7141a",
        d: "M512 256v170.663H0L215.185 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 85.337V256H215.185L0 85.337z"
    }));
};
var $061c76a48897c687$export$b2bfc53cef5629f5 = function DE(_ref58) {
    var title = _ref58.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref58, $061c76a48897c687$var$_excluded58);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.331h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 312.882h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$b116121769fff50f = function DJ(_ref59) {
    var title = _ref59.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref59, $061c76a48897c687$var$_excluded59);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#12ad2b",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6ab2e7",
        d: "M512 0v166.7L0 170.8V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 170.7 0 341.3V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d7141a",
        d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
    }));
};
var $061c76a48897c687$export$861a3271cad515fc = function DK(_ref60) {
    var title = _ref60.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref60, $061c76a48897c687$var$_excluded60);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c60c30",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
    }));
};
var $061c76a48897c687$export$c63caaa7a05b64da = function DM(_ref61) {
    var title = _ref61.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref61, $061c76a48897c687$var$_excluded61);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 110.7v120h512v-120z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 110.7h512v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 190.7h512v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M196 0h120v341.3H196z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M196 0h40v341.3h-40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M274.7 0h40v341.3h-40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#D80027",
        cx: 256,
        cy: 170.7,
        r: 123.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
        fill: "#496E2D"
    }));
};
var $061c76a48897c687$export$fe81c0b6cf107daf = function DO(_ref62) {
    var title = _ref62.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref62, $061c76a48897c687$var$_excluded62);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 215.2h211.5v126.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h211.5v126.2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M300.5 0H512v126.2H300.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M300.5 215.2H512v126.1H300.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        stroke: "#FFF",
        strokeWidth: 5,
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
    })));
};
var $061c76a48897c687$export$d2309a4fc782a0d1 = function DZ(_ref63) {
    var title = _ref63.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref63, $061c76a48897c687$var$_excluded63);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#41662E",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0h256v341.3H256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
    })));
};
var $061c76a48897c687$export$129fe12d32abc311 = function EC(_ref64) {
    var title = _ref64.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref64, $061c76a48897c687$var$_excluded64);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 170.7h512V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 256h512v85.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFDA44",
        cx: 256,
        cy: 170.7,
        r: 59.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#4C1F00",
        d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#57BA17",
        d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
    }));
};
var $061c76a48897c687$export$3f443bcc5237c742 = function EE(_ref65) {
    var title = _ref65.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref65, $061c76a48897c687$var$_excluded65);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#111",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#368FD8",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$e107e11ec3489258 = function EG(_ref66) {
    var title = _ref66.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref66, $061c76a48897c687$var$_excluded66);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h512v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 227.6h512v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#C09300",
        d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
    }));
};
var $061c76a48897c687$export$8e048a19e03780a2 = function EH(_ref67) {
    var title = _ref67.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref67, $061c76a48897c687$var$_excluded67);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h512v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#428823",
        d: "M0 227.6h512v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 170.7 0 341.3V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-4.8-34.6-23.9-34.6-46.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
    })));
};
var $061c76a48897c687$export$20e28a5cfb7c13df = function ER(_ref68) {
    var title = _ref68.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref68, $061c76a48897c687$var$_excluded68);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#56AF35",
        d: "M0 0h512v170.7H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "m0 341.3 512-170.7L0 0v341.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#ffc945"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 119.5,
        cy: 148.3,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 148.9,
        cy: 158.5,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 134.7,
        cy: 135.2,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 119.5,
        cy: 172.7,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 149.9,
        cy: 182.8,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 122.5,
        cy: 198,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 145.9,
        cy: 205.2,
        r: 17.5
    })));
};
var $061c76a48897c687$export$a723e6e41cced9bd = function ES(_ref69) {
    var title = _ref69.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref69, $061c76a48897c687$var$_excluded69);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h22.5v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D03433",
        d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FBCA46",
        d: "M0 4h22.5v7H0V4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M7.8 7h1v.5h-1V7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A41517",
        d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A41517",
        d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
    }));
};
var $061c76a48897c687$export$404386694049c788 = function ET(_ref70) {
    var title = _ref70.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref70, $061c76a48897c687$var$_excluded70);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#20AA46",
        d: "M0 0h22.5v5H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E92F3B",
        d: "M0 10h22.5v5H0v-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FADF50",
        d: "M0 5h22.5v5H0V5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#205CCA",
        cx: 11.3,
        cy: 7.5,
        r: 5.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        stroke: "#FFDB3D",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
        strokeWidth: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
        strokeWidth: 0.25
    })));
};
var $061c76a48897c687$export$f005962cdbec7017 = function EU(_ref71) {
    var title = _ref71.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref71, $061c76a48897c687$var$_excluded71);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 810 540"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#039",
        d: "M0 0h810v540H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FC0",
        d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
    }));
};
var $061c76a48897c687$export$b742dc37108d5cac = function FI(_ref72) {
    var title = _ref72.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref72, $061c76a48897c687$var$_excluded72);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M512 129.3V212H203.7v129.3H121V212H0v-82.7h121V0h82.7v129.3z"
    }));
};
var $061c76a48897c687$export$4cd493ed69e3bc18 = function FJ(_ref73) {
    var title = _ref73.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref73, $061c76a48897c687$var$_excluded73);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F3F3F3",
        d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
    }));
};
var $061c76a48897c687$export$58f4e3559034e3ed = function FK(_ref74) {
    var title = _ref74.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref74, $061c76a48897c687$var$_excluded74);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1F8BDE",
        d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#187536",
        d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
    }));
};
var $061c76a48897c687$export$ae39d226e90e08ef = function FM(_ref75) {
    var title = _ref75.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref75, $061c76a48897c687$var$_excluded75);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$3117889032a11ab0 = function FO(_ref76) {
    var title = _ref76.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref76, $061c76a48897c687$var$_excluded76);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0F61A5",
        d: "M512 214.5H206.2v126.8h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H512V192z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E50E3D",
        d: "M512 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
    }));
};
var $061c76a48897c687$export$b0bfe88d8be86eef = function FR(_ref77) {
    var title = _ref77.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref77, $061c76a48897c687$var$_excluded77);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$2c816677949efbbf = function GA(_ref78) {
    var title = _ref78.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref78, $061c76a48897c687$var$_excluded78);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$5c1daad85ece4f0d = function GB(_ref79) {
    var title = _ref79.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref79, $061c76a48897c687$var$_excluded79);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M393.785 315.358 512 381.034v-65.676zm-82.133 0L512 426.662v-31.474l-143.693-79.83zm146.982 111.304-146.982-81.664v81.664z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M90.341 315.356 0 365.546v-50.19zm110.007 14.154v97.151H25.491z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M143.693 315.358 0 395.188v31.474l200.348-111.304z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M118.215 196.634 0 130.958v65.676zm82.133 0L0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M421.659 196.636 512 146.446v50.19zm-110.007-14.154V85.331h174.857z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M368.307 196.634 512 116.804V85.33L311.652 196.634z"
    }));
};
var $061c76a48897c687$export$44132903afebf574 = function GD(_ref80) {
    var title = _ref80.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref80, $061c76a48897c687$var$_excluded80);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c60a0a",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#3E8446",
        d: "M256 170.7 44.5 296.8V44.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m256 170.7 211.5 126.1h-423zM467.5 44.5 256 170.7 44.5 44.5z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#3E8446",
        d: "M467.5 44.5v252.3L256 170.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m256 10.4 3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.9 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM256 304.2l3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.9 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#c60a0a",
        cx: 244.5,
        cy: 170.7,
        r: 76.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#A2001D",
        cx: 99.1,
        cy: 182.1,
        r: 7.4
    }));
};
var $061c76a48897c687$export$64f1adb8dced2c27 = function GE(_ref81) {
    var title = _ref81.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref81, $061c76a48897c687$var$_excluded81);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M.8 0h21v15H.8V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#eb000e",
        d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#eb000e",
        d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
    }));
};
var $061c76a48897c687$export$a1c692af90f0ad93 = function GF(_ref82) {
    var title = _ref82.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref82, $061c76a48897c687$var$_excluded82);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FDEB01",
        d: "m0 0 90 60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#58A846",
        d: "M90 0v60L0 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ED3D24",
        d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
    }));
};
var $061c76a48897c687$export$ffd553dab4f92f72 = function GG(_ref83) {
    var title = _ref83.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref83, $061c76a48897c687$var$_excluded83);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
    }));
};
var $061c76a48897c687$export$2063236980199869 = function GH(_ref84) {
    var title = _ref84.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref84, $061c76a48897c687$var$_excluded84);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m255.883 199.111 14.119 43.458 40.366 3.2-36.969 26.861 19.453 40.259-36.969-26.859-36.97 26.859 14.123-43.459-36.969-26.861h45.696z"
    }));
};
var $061c76a48897c687$export$b3b059666b470a4 = function GI(_ref85) {
    var title = _ref85.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref85, $061c76a48897c687$var$_excluded85);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 230h513v112H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
    }));
};
var $061c76a48897c687$export$bad2a840ccda93b6 = function GL(_ref86) {
    var title = _ref86.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref86, $061c76a48897c687$var$_excluded86);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M513 0v171H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 185.8,
        cy: 171.2,
        r: 117.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
    }));
};
var $061c76a48897c687$export$af02b8e3ecf08df4 = function GM(_ref87) {
    var title = _ref87.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref87, $061c76a48897c687$var$_excluded87);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1a7e25",
        d: "M0 322.783h512v103.88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#cf0d19",
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 210.877h512v89.656H0z"
    }));
};
var $061c76a48897c687$export$49b768d2cda4fc68 = function GN(_ref88) {
    var title = _ref88.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref88, $061c76a48897c687$var$_excluded88);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M342 0h171v342H342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h171v342H0z"
    }));
};
var $061c76a48897c687$export$a1e9daa76fd80d91 = function GP(_ref89) {
    var title = _ref89.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref89, $061c76a48897c687$var$_excluded89);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$64532cc081f88b3a = function GQ(_ref90) {
    var title = _ref90.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref90, $061c76a48897c687$var$_excluded90);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 227.6h513V342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0070C8",
        d: "M126 170.7 0 341.3V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#786145",
        d: "M264.5 179.8h9.8l4 25.8h-17.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
        fill: "#FFDA00",
        stroke: "#000",
        strokeMiterlimit: 10
    }));
};
var $061c76a48897c687$export$be3bb2d6fb94aa6 = function GR(_ref91) {
    var title = _ref91.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref91, $061c76a48897c687$var$_excluded91);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#0d5eaf"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h190v190H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 76h190v38H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M76 0h38v190H76z"
    })));
};
var $061c76a48897c687$export$f7fbe7cb90eabcb4 = function GS(_ref92) {
    var title = _ref92.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref92, $061c76a48897c687$var$_excluded92);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#FFF",
        cx: 443.4,
        cy: 233.6,
        rx: 29,
        ry: 43.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#FFCE00",
        cx: 406.9,
        cy: 317.7,
        rx: 22,
        ry: 9.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#FFCE00",
        cx: 364,
        cy: 317.7,
        rx: 22,
        ry: 9.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#39B200",
        d: "m342 190.1 43.4 86.9 43.5-86.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#9B9B9B",
        cx: 327.5,
        cy: 233.6,
        rx: 29,
        ry: 43.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#757575",
        d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#C6B56F",
        cx: 385.4,
        cy: 67,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#A54A00",
        cx: 386,
        cy: 88.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 443.4,
        cy: 117.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#0049FF",
        cx: 342.2,
        cy: 146.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#0041F9",
        cx: 429.8,
        cy: 146.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#F7D71E",
        cx: 386,
        cy: 233.6,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#CEC851",
        cx: 457.9,
        cy: 190.1,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 385.4,
        cy: 289.5,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#7C0B29",
        d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 327.5,
        cy: 117.4,
        r: 29
    }));
};
var $061c76a48897c687$export$b023c82b48e70453 = function GT(_ref93) {
    var title = _ref93.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref93, $061c76a48897c687$var$_excluded93);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h171v342H0zm342 0h171v342H342z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#DCC26D",
        cx: 256,
        cy: 155.8,
        r: 25.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#628A40",
        d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
    }));
};
var $061c76a48897c687$export$875a05f1afdc3a63 = function GU(_ref94) {
    var title = _ref94.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref94, $061c76a48897c687$var$_excluded94);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M11.1 11.1h489.7v319.1H11.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#7DBEF1",
        d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1C8AE6",
        d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF042",
        d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#259C7B",
        d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#8E5715",
        d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        stroke: "#D80027",
        strokeWidth: 12,
        strokeMiterlimit: 10,
        d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    }));
};
var $061c76a48897c687$export$4f7b2a18b14c6e6 = function GW(_ref95) {
    var title = _ref95.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref95, $061c76a48897c687$var$_excluded95);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h181.793v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m98.32 195.127 15.107 46.497h48.894l-39.555 28.74 15.108 46.498-39.554-28.737-39.556 28.737 15.111-46.498-39.554-28.74h48.891z"
    }));
};
var $061c76a48897c687$export$f433acc20da515b9 = function GY(_ref96) {
    var title = _ref96.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref96, $061c76a48897c687$var$_excluded96);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009E49",
        d: "M0 0h900v600H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m0 0 947 300L0 600V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFD00D",
        d: "M0 26.1 870 300 0 573.9V26.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2D2D2D",
        d: "m0 0 450 300L0 600V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D3132F",
        d: "m0 35 397.5 265L0 565V35z"
    }));
};
var $061c76a48897c687$export$7bf8e436292b0d9 = function HK(_ref97) {
    var title = _ref97.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref97, $061c76a48897c687$var$_excluded97);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        viewBox: "0 0.5 21 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h21v15H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ee1c25",
        d: "M0 0h21v15H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
        fill: "#FFF"
    })));
};
var $061c76a48897c687$export$e8ae668e70e7a813 = function HM(_ref98) {
    var title = _ref98.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref98, $061c76a48897c687$var$_excluded98);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M223.397 255.996c.273-.304.543-.609.813-.916-.27.308-.546.61-.82.916h.007zm-34.18 41.927 10.958 22.913 24.747-5.718-11.083 22.853 19.9 15.781-24.776 5.585.069 25.398-19.815-15.89-19.814 15.89.069-25.398-24.776-5.585 19.9-15.781-11.083-22.853 24.746 5.718zm197.859 28.464 5.227 10.929 11.803-2.728-5.286 10.9 9.492 7.528-11.818 2.663.032 12.114-9.45-7.578-9.45 7.578.032-12.114-11.817-2.663 9.491-7.528-5.285-10.9 11.803 2.728zm-48.623-115.939 5.227 10.93 11.803-2.729-5.286 10.901 9.491 7.528-11.817 2.663.032 12.115-9.45-7.58-9.451 7.58.033-12.115-11.818-2.663 9.491-7.528-5.284-10.901 11.802 2.729zm48.623-66.25 5.227 10.93 11.803-2.73-5.286 10.902 9.491 7.527-11.817 2.664.032 12.114-9.45-7.58-9.45 7.58.032-12.114-11.817-2.664 9.491-7.527-5.285-10.902 11.803 2.73zm42.471 49.688 5.227 10.929 11.802-2.728-5.284 10.9 9.491 7.527-11.818 2.664.033 12.114-9.451-7.578-9.45 7.578.032-12.114-11.817-2.664 9.491-7.527-5.286-10.9 11.803 2.728zm-30.368 57.97 4.11 12.652h13.304l-10.763 7.82 4.112 12.652-10.763-7.819-10.765 7.819 4.112-12.652-10.763-7.82h13.304z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.553l45.167-25.099H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$d654914ee99e1b51 = function HN(_ref99) {
    var title = _ref99.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref99, $061c76a48897c687$var$_excluded99);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
        fill: "#338AF3"
    }));
};
var $061c76a48897c687$export$41dbabafe943a3bc = function HR(_ref100) {
    var title = _ref100.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref100, $061c76a48897c687$var$_excluded100);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#D80027",
        fill: "#FFF",
        d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$3927bce5ead7457e = function HT(_ref101) {
    var title = _ref101.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref101, $061c76a48897c687$var$_excluded101);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M0 0h513v172H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 172h513v172H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#0052B4",
        cx: 270.7,
        cy: 182.3,
        r: 55.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#A2001D",
        cx: 270.7,
        cy: 182.3,
        r: 27.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M229.1 113.1h83.1l-41.5 41.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M256.8 140.8h27.7v83h-27.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
    }));
};
var $061c76a48897c687$export$2cba20fb7b4c6fda = function HU(_ref102) {
    var title = _ref102.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref102, $061c76a48897c687$var$_excluded102);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$520d469a2f25f64a = function IC(_ref103) {
    var title = _ref103.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref103, $061c76a48897c687$var$_excluded103);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 300 200"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fc0",
        d: "M0 0h300v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0768a9",
        d: "M0 0h200v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M0 0h100v200H0z"
    }));
};
var $061c76a48897c687$export$8be180ec26319f9f = function ID(_ref104) {
    var title = _ref104.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref104, $061c76a48897c687$var$_excluded104);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E00",
        d: "M0 85.333h512V256H0z"
    }));
};
var $061c76a48897c687$export$5056f4df3c1a040a = function IE(_ref105) {
    var title = _ref105.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref105, $061c76a48897c687$var$_excluded105);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$747f5b589ac90db = function IL(_ref106) {
    var title = _ref106.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref106, $061c76a48897c687$var$_excluded106);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
        fill: "#2E52B2"
    }));
};
var $061c76a48897c687$export$5e0fd3f816252990 = function IM(_ref107) {
    var title = _ref107.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref107, $061c76a48897c687$var$_excluded107);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E52D42",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F8DD4E",
        d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
    }));
};
var $061c76a48897c687$export$70824c8942178d60 = function IN(_ref108) {
    var title = _ref108.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref108, $061c76a48897c687$var$_excluded108);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#181A93",
        d: "M17.3 0h478.4v342H17.3V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFA44A",
        d: "M0 0h513v114H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1A9F0B",
        d: "M0 228h513v114H0V228z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 114h513v114H0V114z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 256.5,
        cy: 171,
        r: 34.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#181A93",
        d: "M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#181A93",
        cx: 256.5,
        cy: 171,
        r: 22.8
    }));
};
var $061c76a48897c687$export$8f8422ac5947a789 = function IO(_ref109) {
    var title = _ref109.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref109, $061c76a48897c687$var$_excluded109);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0-.3h513V342H0V-.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0-.3h256v171H0V-.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
        fill: "#A2001D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#2E52B2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#5DA51E",
        stroke: "#45602C",
        strokeWidth: 4,
        strokeMiterlimit: 10,
        d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E2DD24",
        stroke: "#525625",
        strokeWidth: 4,
        strokeMiterlimit: 10,
        d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
    }));
};
var $061c76a48897c687$export$776a9becd139230f = function IQ(_ref110) {
    var title = _ref110.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref110, $061c76a48897c687$var$_excluded110);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#CE1126",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
        fill: "#547C31"
    }));
};
var $061c76a48897c687$export$35f3e3f7e3ce71e0 = function IR(_ref111) {
    var title = _ref111.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref111, $061c76a48897c687$var$_excluded111);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
        fill: "#FFF",
        opacity: 0.5
    }));
};
var $061c76a48897c687$export$bfe27467c1de9413 = function IS(_ref112) {
    var title = _ref112.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref112, $061c76a48897c687$var$_excluded112);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
    }));
};
var $061c76a48897c687$export$c8c4756768edc1be = function IT(_ref113) {
    var title = _ref113.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref113, $061c76a48897c687$var$_excluded113);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M341.334 85.33H0v341.332h512V85.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.333h170.663V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.333H512V426.67H341.337z"
    }));
};
var $061c76a48897c687$export$7300d7e65520d9c0 = function JE(_ref114) {
    var title = _ref114.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref114, $061c76a48897c687$var$_excluded114);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
    }));
};
var $061c76a48897c687$export$62925b2b1d8826f = function JM(_ref115) {
    var title = _ref115.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref115, $061c76a48897c687$var$_excluded115);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M215.864 256.006 0 399.911V112.089zM512 112.089v287.822L296.136 256.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
    }));
};
var $061c76a48897c687$export$4ff8ba3b6e78910e = function JO(_ref116) {
    var title = _ref116.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref116, $061c76a48897c687$var$_excluded116);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.339h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.339h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 312.89h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 256.006 0 426.669V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m77.913 224.802 7.876 16.469 17.786-4.11-7.965 16.426 14.303 11.343-17.808 4.014.049 18.255-14.241-11.421-14.241 11.421.05-18.255-17.809-4.014 14.303-11.343-7.965-16.426 17.786 4.11z"
    }));
};
var $061c76a48897c687$export$4165087edc6149ea = function JP(_ref117) {
    var title = _ref117.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref117, $061c76a48897c687$var$_excluded117);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#D80027",
        cx: 256,
        cy: 255.994,
        r: 96
    }));
};
var $061c76a48897c687$export$ebf06250eda1662e = function KE(_ref118) {
    var title = _ref118.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref118, $061c76a48897c687$var$_excluded118);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.331h512v90.579H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 336.089h512v90.568H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M0 198.606h512v114.799H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m323.265 139.803-25.583-11.809L256 222.376l-41.682-94.382-25.583 11.809 51.749 116.191-51.749 116.192 25.583 11.808L256 289.613l41.682 94.381 25.583-11.808-51.749-116.192z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M273.376 150.931C263.472 140.115 256 133.898 256 133.898s-7.472 6.216-17.376 17.032v210.127C248.528 371.873 256 378.091 256 378.091s7.472-6.216 17.376-17.033V150.931z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M209.04 191.226v129.535c10.465 18.542 23.274 33.742 32.872 43.818V147.408c-9.599 10.076-22.408 25.275-32.872 43.818zm93.92 0c-10.465-18.543-23.274-33.742-32.872-43.818V364.58c9.599-10.077 22.407-25.276 32.872-43.818V191.226z",
        fill: "#A2001D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M302.96 191.226v129.535c10.594-18.774 18.784-40.973 18.784-64.767s-8.19-45.993-18.784-64.768zm-93.92 0v129.535c-10.594-18.774-18.784-40.973-18.784-64.767s8.19-45.993 18.784-64.768z"
    }));
};
var $061c76a48897c687$export$32f37961c13d8178 = function KG(_ref119) {
    var title = _ref119.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref119, $061c76a48897c687$var$_excluded119);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 256,
        cy: 170.7,
        r: 170.7
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#D80027",
        cx: 257.4,
        cy: 170.7,
        r: 71.6
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$96381358fb12b492 = function KH(_ref120) {
    var title = _ref120.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref120, $061c76a48897c687$var$_excluded120);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M303.49 281.971v-17.809h-11.873v-23.745l-11.872-11.872-11.872 11.872v-23.744L256 204.8l-11.873 11.873v23.744l-11.872-11.872-11.872 11.872v23.745H208.51v17.809h-11.872v17.808h118.724v-17.808z"
    }));
};
var $061c76a48897c687$export$8aa7bcd4299a59b9 = function KI(_ref121) {
    var title = _ref121.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref121, $061c76a48897c687$var$_excluded121);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 450 300"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#CE1126",
        d: "M0 0h450v300H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FCD116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 227.6,
        cy: 161.2,
        r: 56.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#003F87",
        d: "M0 175h450v125H0V175z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FCD116",
        d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
    }));
};
var $061c76a48897c687$export$7ca86d88f982585b = function KM(_ref122) {
    var title = _ref122.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref122, $061c76a48897c687$var$_excluded122);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 170.663h512V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 256h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M68.638 256c0-24.865 17.476-45.638 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.255-51.942 51.942s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.337-5.096-40.812-25.869-40.812-50.734z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m108.877 211.478 2.762 8.503h8.94l-7.232 5.256 2.762 8.502-7.232-5.255-7.234 5.255 2.764-8.502-7.234-5.256h8.94zm0 22.261 2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zm0 22.261 2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zm0 22.261 2.762 8.502h8.94l-7.232 5.256 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.256h8.94z"
    })));
};
var $061c76a48897c687$export$fd8f06eb7ce62883 = function KN(_ref123) {
    var title = _ref123.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref123, $061c76a48897c687$var$_excluded123);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M512 0H0v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$171643e72dc5e91 = function KP(_ref124) {
    var title = _ref124.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref124, $061c76a48897c687$var$_excluded124);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#91DC5A",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.331h512v57.188H0zM0 369.48h512v57.177H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 165.215h512v181.582H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 190.33,
        cy: 255.994,
        r: 65.668
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "m190.332 190.332 14.734 45.346h47.757l-38.65 28.028 14.849 45.481-38.69-28.16-38.631 28.107 14.79-45.428-38.616-28.028h47.722z"
    }));
};
var $061c76a48897c687$export$ced591d2396bbc3f = function KR(_ref125) {
    var title = _ref125.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref125, $061c76a48897c687$var$_excluded125);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h900v600H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "rotate(-56.31)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
        stroke: "#000",
        strokeWidth: 25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#FFF",
        strokeWidth: 12.5,
        d: "M0 753.3v125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#ca163a",
        cy: 540.8,
        r: 150
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0e4896",
        d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
        stroke: "#000",
        strokeWidth: 25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#FFF",
        strokeWidth: 12.5,
        d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
    }));
};
var $061c76a48897c687$export$867391011d376267 = function KW(_ref126) {
    var title = _ref126.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref126, $061c76a48897c687$var$_excluded126);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M166.957 312.889 0 426.663V85.337l166.957 113.774z"
    }));
};
var $061c76a48897c687$export$ea257f329676e0aa = function KY(_ref127) {
    var title = _ref127.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref127, $061c76a48897c687$var$_excluded127);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#6DA544",
        cx: 384,
        cy: 181.79,
        r: 29.682
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M332.054 174.377h103.88v44.522h-103.88z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M435.942 255.997v-.001.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M332.058 285.678v29.682h15.616c9.364 9.176 22.18 14.84 36.326 14.84 14.147 0 26.962-5.664 36.326-14.84h15.616v-29.682H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M332.058 211.475v44.522c0 39.759 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-44.522H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M383.997 235.256c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986-.001-12.986-11.873-25.973-11.873zm0-41.59c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873z",
        fill: "#F3F3F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.334v22.617l-46.069 30.709H256v64h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 85.329h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.329v15.082l57.377 38.252H80zm256 0v15.082l-57.377 38.252H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.329v15.082l57.377 38.252H80zm256 0v15.082l-57.377 38.252H176zM0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z"
    })));
};
var $061c76a48897c687$export$45edc2c6b51c02b3 = function KZ(_ref128) {
    var title = _ref128.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref128, $061c76a48897c687$var$_excluded128);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#36B6CC",
        d: "M0 0h513v342H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFD400",
        cx: 256.5,
        cy: 170.9,
        r: 68.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFD400",
        d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
    }));
};
var $061c76a48897c687$export$64f943d6c6d62030 = function LA(_ref129) {
    var title = _ref129.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref129, $061c76a48897c687$var$_excluded129);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 256.5,
        cy: 171,
        r: 65.9
    }));
};
var $061c76a48897c687$export$1dd3e96947fb44fc = function LB(_ref130) {
    var title = _ref130.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref130, $061c76a48897c687$var$_excluded130);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#14AF5A",
        d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
    }));
};
var $061c76a48897c687$export$3cb73e0e841fe17f = function LC(_ref131) {
    var title = _ref131.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref131, $061c76a48897c687$var$_excluded131);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#55B2FF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F3F3F3",
        d: "M148.5 298.1h216l-108-254.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#333",
        d: "m186 272.7 70.5-160.3L327 272.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M148.5 298.1h216l-108-101.7z"
    }));
};
var $061c76a48897c687$export$2e3013aac067a692 = function LI(_ref132) {
    var title = _ref132.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref132, $061c76a48897c687$var$_excluded132);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
    }));
};
var $061c76a48897c687$export$782aca1f2c103f6b = function LK(_ref133) {
    var title = _ref133.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref133, $061c76a48897c687$var$_excluded133);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M222.6 22.3h267.1v296.8H222.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M22.3 22.3h200.3v296.8H22.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M200.3 0h22.3v342h-22.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M22.3 22.3h89v296.8h-89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M111.3 22.3h89v296.8h-89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        stroke: "#FFDA44",
        strokeWidth: 6,
        strokeMiterlimit: 10,
        d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
    }));
};
var $061c76a48897c687$export$9e0d336de5ae0eb3 = function LR(_ref134) {
    var title = _ref134.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref134, $061c76a48897c687$var$_excluded134);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h512v31.1H0zm0 62.2h512v31.1H0zm0 62.3h512v31.1H0zm0 62.3h512v31.1H0zm0 62.5h512v31.1H0zm0 61.6h512V342H0z",
        fill: "#bf0a30"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002868",
        d: "M0 0h155.6v155.6H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
    }));
};
var $061c76a48897c687$export$c6944423ed371873 = function LS(_ref135) {
    var title = _ref135.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref135, $061c76a48897c687$var$_excluded135);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 227.6h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
    }));
};
var $061c76a48897c687$export$7158f0ceb70f54c7 = function LT(_ref136) {
    var title = _ref136.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref136, $061c76a48897c687$var$_excluded136);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$b6a2dd8a7c2d6cd5 = function LU(_ref137) {
    var title = _ref137.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref137, $061c76a48897c687$var$_excluded137);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$feea9fafc15a0118 = function LV(_ref138) {
    var title = _ref138.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref138, $061c76a48897c687$var$_excluded138);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "prefix__st1",
        d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
        fill: "#A2001D"
    }));
};
var $061c76a48897c687$export$4eb7334fca20385f = function LY(_ref139) {
    var title = _ref139.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref139, $061c76a48897c687$var$_excluded139);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m281.424 236.026 8.962 12.35 14.513-4.706-8.975 12.339 8.961 12.349-14.509-4.724-8.976 12.34.01-15.258-14.51-4.725 14.514-4.706z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256.965 286.868c-17.048 0-30.868-13.821-30.868-30.868s13.821-30.868 30.868-30.868a30.742 30.742 0 0 1 14.684 3.71c-6.851-6.698-16.218-10.833-26.556-10.833-20.982 0-37.992 17.01-37.992 37.992s17.01 37.992 37.992 37.992c10.338 0 19.706-4.135 26.556-10.833a30.738 30.738 0 0 1-14.684 3.708z"
    })));
};
var $061c76a48897c687$export$d88940c21edc1e8e = function MA(_ref140) {
    var title = _ref140.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref140, $061c76a48897c687$var$_excluded140);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337v341.326h512V85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#20661b",
        d: "M352 226.484h-73.337L256 156.738l-22.663 69.748H160l59.331 43.107-22.663 69.749L256 296.232l59.332 43.107-22.663-69.749L352 226.484zm-116.063 37.711 7.663-23.585h24.8l7.663 23.585v.001L256 278.772l-20.063-14.577zm27.873-37.711h-15.619L256 202.447l7.81 24.037zm24.269 28.982-4.827-14.856h25.274l-20.447 14.856zm-59.331-14.856-4.827 14.856-20.447-14.856h25.274zm-5.211 61.748 7.81-24.036 12.636 9.181-20.446 14.855zm44.479-14.856 12.636-9.181 7.81 24.036-20.446-14.855z"
    }));
};
var $061c76a48897c687$export$cd68417dc2ec295d = function MC(_ref141) {
    var title = _ref141.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref141, $061c76a48897c687$var$_excluded141);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#c70000",
        d: "M0 85.333h512V256H0z"
    }));
};
var $061c76a48897c687$export$3c37c3bdb860ae1e = function MD(_ref142) {
    var title = _ref142.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref142, $061c76a48897c687$var$_excluded142);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#AF7F59",
        d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
    }));
};
var $061c76a48897c687$export$4898541b722d275d = function ME(_ref143) {
    var title = _ref143.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref143, $061c76a48897c687$var$_excluded143);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E6BE53",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E01D24",
        d: "M20 20h473v302H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E6BE53",
        d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#215F90",
        d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
    }));
};
var $061c76a48897c687$export$33916af50bbab5f5 = function MF(_ref144) {
    var title = _ref144.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref144, $061c76a48897c687$var$_excluded144);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 108 72"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h108v72H0z",
        fill: "#003787"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h108L60 48v24H48V48z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 54,
        cy: 30,
        r: 8,
        fill: "#f9d90f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M44 30h20L54 48z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M54 48 38 33h32z",
        fill: "#cf142b"
    }));
};
var $061c76a48897c687$export$d7c1ae0cf4ef5274 = function MG(_ref145) {
    var title = _ref145.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref145, $061c76a48897c687$var$_excluded145);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M512 426.666V85.329H0v341.337h512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.331H0v170.666h512V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h181.793v341.337H0z"
    }));
};
var $061c76a48897c687$export$61a81a4b59098e0c = function MH(_ref146) {
    var title = _ref146.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref146, $061c76a48897c687$var$_excluded146);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1E509C",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M513 176.1V81.3L0 342l513-165.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F18D36",
        d: "M513 0v81.3L0 342 513 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
    }));
};
var $061c76a48897c687$export$9391ff7d7f7d79ce = function MK(_ref147) {
    var title = _ref147.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref147, $061c76a48897c687$var$_excluded147);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 256,
        cy: 252.29,
        r: 59.359
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFDA44",
        cx: 256,
        cy: 252.29,
        r: 44.522
    }));
};
var $061c76a48897c687$export$670dad092b145ea = function ML(_ref148) {
    var title = _ref148.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref148, $061c76a48897c687$var$_excluded148);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$eefdfd8a735ff143 = function MM(_ref149) {
    var title = _ref149.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref149, $061c76a48897c687$var$_excluded149);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
    }));
};
var $061c76a48897c687$export$30e7c6589c527eef = function MN(_ref150) {
    var title = _ref150.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref150, $061c76a48897c687$var$_excluded150);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#095FAD",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M342 0h171v342H342zM0 0h171v342H0z",
        fill: "#BE1229"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 86,
        cy: 203.4,
        r: 14.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 86,
        cy: 144,
        r: 14.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M76.3 123.9h19.5L86 108.3z"
    })));
};
var $061c76a48897c687$export$511fbc18fa6ca984 = function MO(_ref151) {
    var title = _ref151.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref151, $061c76a48897c687$var$_excluded151);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00745a",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$15b7d6cdd29b06a0 = function MP(_ref152) {
    var title = _ref152.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref152, $061c76a48897c687$var$_excluded152);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 750 500"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0071BC",
        d: "M0 0h750v500H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF",
        stroke: "#000",
        strokeWidth: 1.9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 375,
        cy: 245,
        r: 225,
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 375,
        cy: 245,
        r: 165,
        fill: "#0071BC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        stroke: "#000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#8C8A8C",
        strokeWidth: 1.9,
        d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        strokeWidth: 2,
        strokeLinejoin: "round",
        d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
    })));
};
var $061c76a48897c687$export$451b471c9c9066b = function MQ(_ref153) {
    var title = _ref153.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref153, $061c76a48897c687$var$_excluded153);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M512 148.4v44.5H278.3v148.4h-44.6V192.9H0v-44.5h233.7V0h44.6v148.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M101 36.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zm284 0c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zm-5.4 199c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7s3.4 6.5 7 6.3l1.7-.1zm-278.6 0c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8s4.2 5.9 7.8 5.2c.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1z"
    })));
};
var $061c76a48897c687$export$c4e38e98e3fb5f60 = function MR(_ref154) {
    var title = _ref154.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref154, $061c76a48897c687$var$_excluded154);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 100 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#006233",
        d: "M0 100h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#cd2a3e",
        d: "M0 100h513v46H0zm0 296h513v46H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffc400",
        d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffc400",
        d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
    }));
};
var $061c76a48897c687$export$71ad59f2e432cfe8 = function MS(_ref155) {
    var title = _ref155.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref155, $061c76a48897c687$var$_excluded155);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1B4991",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00A2B8",
        stroke: "#FFF",
        strokeWidth: 3,
        d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A35023",
        d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
    }));
};
var $061c76a48897c687$export$b900a375df2ae552 = function MT(_ref156) {
    var title = _ref156.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref156, $061c76a48897c687$var$_excluded156);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#C31B28",
        d: "M256 0h256.5v342H256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ACABB1",
        stroke: "#C31B28",
        strokeWidth: 2,
        d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
    }));
};
var $061c76a48897c687$export$c5764e4399dad848 = function MU(_ref157) {
    var title = _ref157.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref157, $061c76a48897c687$var$_excluded157);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f7ce00",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e32737",
        d: "M0 85.331h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#191f6a",
        d: "M0 170.657h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00a04e",
        d: "M0 341.331h512v85.337H0z"
    }));
};
var $061c76a48897c687$export$20138591ba7d4d60 = function MV(_ref158) {
    var title = _ref158.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref158, $061c76a48897c687$var$_excluded158);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#d01920",
        d: "M0 85.331h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#017c3b",
        d: "M144.696 174.375h222.609v163.25H144.696z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
    }));
};
var $061c76a48897c687$export$a3772f6eb527275b = function MW(_ref159) {
    var title = _ref159.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref159, $061c76a48897c687$var$_excluded159);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#272727",
        d: "M0 0h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e40112",
        d: "M0 114h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#07893f",
        d: "M0 228h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#e40112",
        cx: 256,
        cy: 125,
        r: 95
    }));
};
var $061c76a48897c687$export$80b36494c451f15f = function MX(_ref160) {
    var title = _ref160.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref160, $061c76a48897c687$var$_excluded160);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#dc2339",
        d: "M342 0H0v341.3h513V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#11865d",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M171 0h171v342H171z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#8C9157",
        d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#C59262",
        cx: 256.5,
        cy: 159.1,
        rx: 24.3,
        ry: 36.4
    }));
};
var $061c76a48897c687$export$655dc88003efaac0 = function MY(_ref161) {
    var title = _ref161.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref161, $061c76a48897c687$var$_excluded161);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
        fill: "#c00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#006",
        d: "M0 0h256.5v195.4H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
        fill: "#fc0"
    }));
};
var $061c76a48897c687$export$b5030f3cedb7f384 = function MZ(_ref162) {
    var title = _ref162.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref162, $061c76a48897c687$var$_excluded162);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f4d900",
        d: "M0 323.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#006d66",
        d: "M0 85.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 204.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#cb0f31",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f4d900",
        d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
    }));
};
var $061c76a48897c687$export$dbd1925f4fe9ec65 = function NA(_ref163) {
    var title = _ref163.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref163, $061c76a48897c687$var$_excluded163);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.337h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
    }));
};
var $061c76a48897c687$export$fbcebdb931d67ac9 = function NC(_ref164) {
    var title = _ref164.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref164, $061c76a48897c687$var$_excluded164);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 640 426.7"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#009543",
        d: "M0 293h640v133.7H0V293z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ED4135",
        d: "M0 132h640v161.3H0V132z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0035AD",
        d: "M0 0h640v133.3H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FAE600",
        stroke: "#000",
        strokeWidth: 5.3,
        cx: 240,
        cy: 213.3,
        r: 157.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        cx: 237.8,
        cy: 280.5,
        rx: 16.8,
        ry: 26.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 237.4,
        cy: 143.4,
        r: 20.9
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        cx: 238.4,
        cy: 211.1,
        rx: 19.9,
        ry: 12.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
    }));
};
var $061c76a48897c687$export$8719acbfb72c829 = function NE(_ref165) {
    var title = _ref165.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref165, $061c76a48897c687$var$_excluded165);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e05206",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0db02b",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#e05206",
        cx: 256,
        cy: 256,
        r: 32
    }));
};
var $061c76a48897c687$export$ebe65a9e9fde641f = function NF(_ref166) {
    var title = _ref166.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref166, $061c76a48897c687$var$_excluded166);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.5 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
        fill: "#007b23"
    }));
};
var $061c76a48897c687$export$d9501190a8cd7a46 = function NG(_ref167) {
    var title = _ref167.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref167, $061c76a48897c687$var$_excluded167);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.5 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.5h171v342H0zm342 0h171v342H342z",
        fill: "#007b23"
    }));
};
var $061c76a48897c687$export$2128ddd8b6e5cc05 = function NI(_ref168) {
    var title = _ref168.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref168, $061c76a48897c687$var$_excluded168);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
    }));
};
var $061c76a48897c687$export$e51d3c675bb0140d = function NL(_ref169) {
    var title = _ref169.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref169, $061c76a48897c687$var$_excluded169);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.5 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#cd1f2a",
        d: "M0 85.5h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1d4185",
        d: "M0 312h513v114H0z"
    }));
};
var $061c76a48897c687$export$c01351c0af048e39 = function NO(_ref170) {
    var title = _ref170.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref170, $061c76a48897c687$var$_excluded170);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
    }));
};
var $061c76a48897c687$export$575bf2af220888ee = function NP(_ref171) {
    var title = _ref171.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref171, $061c76a48897c687$var$_excluded171);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
    })));
};
var $061c76a48897c687$export$8885480fb36cb8cc = function NR(_ref172) {
    var title = _ref172.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref172, $061c76a48897c687$var$_excluded172);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 239.994h512v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
    }));
};
var $061c76a48897c687$export$8227ca023eb0daaa = function NU(_ref173) {
    var title = _ref173.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref173, $061c76a48897c687$var$_excluded173);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 85.329v15.083l-57.377 38.251H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.329v15.083l57.377 38.251H80z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 85.329v15.083l-57.377 38.251H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 255.997v-15.082l57.377-38.252H80z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 255.997v-15.082l-57.377-38.252H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#2E52B2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 128,
        cy: 170.66,
        r: 22.627
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$b6db8d689596ccb0 = function NZ(_ref174) {
    var title = _ref174.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref174, $061c76a48897c687$var$_excluded174);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$1ed389bd9cb529 = function OM(_ref175) {
    var title = _ref175.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref175, $061c76a48897c687$var$_excluded175);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M138 0h377v114H138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#4A7C3A",
        d: "M138 230h377v114H138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 10,
        strokeMiterlimit: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
    })));
};
var $061c76a48897c687$export$ff7e3d480d313da2 = function PA(_ref176) {
    var title = _ref176.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref176, $061c76a48897c687$var$_excluded176);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256v170.663H0V256h256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337V256H256V85.337h256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
    }));
};
var $061c76a48897c687$export$d5e55eb9565ea8d5 = function PE(_ref177) {
    var title = _ref177.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref177, $061c76a48897c687$var$_excluded177);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$7d19ebf018caa9aa = function PF(_ref178) {
    var title = _ref178.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref178, $061c76a48897c687$var$_excluded178);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$c56943b7b8ffea21 = function PG(_ref179) {
    var title = _ref179.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref179, $061c76a48897c687$var$_excluded179);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M0 85.33h512v341.332"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
    }));
};
var $061c76a48897c687$export$38ea63fabb2c685f = function PH(_ref180) {
    var title = _ref180.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref180, $061c76a48897c687$var$_excluded180);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M512 85.337V256H256L0 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 256v170.663H0L256 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$73910688e185534c = function PK(_ref181) {
    var title = _ref181.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref181, $061c76a48897c687$var$_excluded181);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.343h512v341.326H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#01411c",
        d: "M128 85.331h384v341.337H128z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$9e95f02561f2d9f9 = function PL(_ref182) {
    var title = _ref182.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref182, $061c76a48897c687$var$_excluded182);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512V256H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 256h512v170.663H0z"
    }));
};
var $061c76a48897c687$export$164607a37e7daeba = function PM(_ref183) {
    var title = _ref183.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref183, $061c76a48897c687$var$_excluded183);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 26.666 640 426.666"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00267f",
        d: "M0 0h213.3v480H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f31830",
        d: "M426.7 0H640v480H426.7z"
    })));
};
var $061c76a48897c687$export$6bc8c38c416ebf89 = function PN(_ref184) {
    var title = _ref184.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref184, $061c76a48897c687$var$_excluded184);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ACABB1",
        d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$af5f8d68aad3cd3a = function PR(_ref185) {
    var title = _ref185.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref185, $061c76a48897c687$var$_excluded185);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
    }));
};
var $061c76a48897c687$export$5adddb0645f34b2 = function PS(_ref186) {
    var title = _ref186.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref186, $061c76a48897c687$var$_excluded186);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#268024",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e4312b",
        d: "M256 256.006 0 426.668V85.331z"
    }));
};
var $061c76a48897c687$export$3961bdb9130b90e7 = function PT(_ref187) {
    var title = _ref187.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref187, $061c76a48897c687$var$_excluded187);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M196.641 85.337v341.326H0V85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFDA44",
        cx: 196.641,
        cy: 256,
        r: 64
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
    }));
};
var $061c76a48897c687$export$5f5211c171c1b47a = function PW(_ref188) {
    var title = _ref188.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref188, $061c76a48897c687$var$_excluded188);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFDA44",
        cx: 218.902,
        cy: 255.994,
        r: 74.207
    }));
};
var $061c76a48897c687$export$21b6e0fb60b525ae = function PY(_ref189) {
    var title = _ref189.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref189, $061c76a48897c687$var$_excluded189);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
    }));
};
var $061c76a48897c687$export$a7078eadaecd4b6f = function QA(_ref190) {
    var title = _ref190.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref190, $061c76a48897c687$var$_excluded190);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#751A46",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
    }));
};
var $061c76a48897c687$export$ded96516917cab2a = function RE(_ref191) {
    var title = _ref191.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref191, $061c76a48897c687$var$_excluded191);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 26.666 640 426.666"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00267f",
        d: "M0 0h213.3v480H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#f31830",
        d: "M426.7 0H640v480H426.7z"
    })));
};
var $061c76a48897c687$export$993ec495e78d530d = function RO(_ref192) {
    var title = _ref192.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref192, $061c76a48897c687$var$_excluded192);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$e9d8d46fbf5f29f6 = function RS(_ref193) {
    var title = _ref193.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref193, $061c76a48897c687$var$_excluded193);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 312.882h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
    }));
};
var $061c76a48897c687$export$6c2517b5e52f01cc = function RU(_ref194) {
    var title = _ref194.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref194, $061c76a48897c687$var$_excluded194);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.33v341.332h512V85.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.884h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$ef5ca6a08aac8ca5 = function RW(_ref195) {
    var title = _ref195.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref195, $061c76a48897c687$var$_excluded195);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 255.994h512v81.619H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 337.614h512v89.043H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
    }));
};
var $061c76a48897c687$export$da51c6332ad11d7b = function SA(_ref196) {
    var title = _ref196.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref196, $061c76a48897c687$var$_excluded196);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#055e1c",
        d: "M0 85.333h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M207.093 248.57h32.601v22.261h-32.601z"
    })));
};
var $061c76a48897c687$export$279f8048cbf05e80 = function SB(_ref197) {
    var title = _ref197.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref197, $061c76a48897c687$var$_excluded197);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.329h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$f49cccbff6374af4 = function SC(_ref198) {
    var title = _ref198.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref198, $061c76a48897c687$var$_excluded198);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M235.454 85.337 0 426.663 427.345 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M512 329.393 0 426.663h512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337h-84.655L0 426.663l512-204.512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337v341.326L235.454 85.337z"
    }));
};
var $061c76a48897c687$export$5b088def975a652b = function SD(_ref199) {
    var title = _ref199.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref199, $061c76a48897c687$var$_excluded199);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 426.668V85.331l256 170.675z"
    }));
};
var $061c76a48897c687$export$88d2e60d4be28663 = function SE(_ref200) {
    var title = _ref200.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref200, $061c76a48897c687$var$_excluded200);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
    }));
};
var $061c76a48897c687$export$bea437c40441867d = function SG(_ref201) {
    var title = _ref201.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref201, $061c76a48897c687$var$_excluded201);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
    })));
};
var $061c76a48897c687$export$c713cf928ffb5e8e = function SH(_ref202) {
    var title = _ref202.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref202, $061c76a48897c687$var$_excluded202);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffda44",
        d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#BF521B",
        d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#474747",
        d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
    }));
};
var $061c76a48897c687$export$e6702cab675b095 = function SI(_ref203) {
    var title = _ref203.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref203, $061c76a48897c687$var$_excluded203);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 199.112h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
    }));
};
var $061c76a48897c687$export$e9f025fd23256930 = function SJ(_ref204) {
    var title = _ref204.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref204, $061c76a48897c687$var$_excluded204);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
    }));
};
var $061c76a48897c687$export$5f584391ee0d99b4 = function SK(_ref205) {
    var title = _ref205.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref205, $061c76a48897c687$var$_excluded205);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 196.641h512v118.717H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 315.359h512v111.304H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
    }));
};
var $061c76a48897c687$export$b49d6918df199090 = function SL(_ref206) {
    var title = _ref206.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref206, $061c76a48897c687$var$_excluded206);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$59096964bd9627ef = function SM(_ref207) {
    var title = _ref207.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref207, $061c76a48897c687$var$_excluded207);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.34h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M512 85.334v166.69L0 256.175V85.334z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
    }));
};
var $061c76a48897c687$export$b70f9dd36a734be4 = function SN(_ref208) {
    var title = _ref208.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref208, $061c76a48897c687$var$_excluded208);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M330.207 85.331H512v341.337H330.207z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
        fill: "#496E2D"
    }));
};
var $061c76a48897c687$export$f6311706676f39f2 = function SO(_ref209) {
    var title = _ref209.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref209, $061c76a48897c687$var$_excluded209);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
    }));
};
var $061c76a48897c687$export$13acf42283a26926 = function SR(_ref210) {
    var title = _ref210.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref210, $061c76a48897c687$var$_excluded210);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M0 196.636h512v118.728H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
        fill: "#6DA544"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
    }));
};
var $061c76a48897c687$export$8cda4cf3f4deb8c2 = function SS(_ref211) {
    var title = _ref211.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref211, $061c76a48897c687$var$_excluded211);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 322.783h512v103.88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M0 210.877h512v89.656H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
    }));
};
var $061c76a48897c687$export$80980ed6b6f31397 = function ST(_ref212) {
    var title = _ref212.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref212, $061c76a48897c687$var$_excluded212);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#6DA544"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
    }));
};
var $061c76a48897c687$export$8fc936c6ebd916b3 = function SV(_ref213) {
    var title = _ref213.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref213, $061c76a48897c687$var$_excluded213);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M228.582 261.936 256 214.447l27.418 47.489z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
    }));
};
var $061c76a48897c687$export$b4f896bb97547f66 = function SX(_ref214) {
    var title = _ref214.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref214, $061c76a48897c687$var$_excluded214);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.331v166.69L0 256.173V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 118.862,
        cy: 210.287,
        r: 18.286
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F3F3F3",
        d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
    }));
};
var $061c76a48897c687$export$2e8caadc521d7cbb = function SY(_ref215) {
    var title = _ref215.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref215, $061c76a48897c687$var$_excluded215);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 312.882h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m187.31 215.184 9.208 28.341h29.802l-24.11 17.518 9.209 28.342-24.109-17.516-24.11 17.516 9.209-28.342-24.109-17.518h29.801zm137.38 0 9.209 28.341H363.7l-24.109 17.518 9.209 28.342-24.11-17.516-24.109 17.516 9.209-28.342-24.11-17.518h29.802z",
        fill: "#6DA544"
    }));
};
var $061c76a48897c687$export$988c8b3cfeed3531 = function SZ(_ref216) {
    var title = _ref216.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref216, $061c76a48897c687$var$_excluded216);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2B5DEA",
        d: "M0 0h900v600H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDF29",
        d: "M0 100h900v400H0V100z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D70000",
        d: "M0 150h900v300H0V150z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
    }));
};
var $061c76a48897c687$export$6b4abaf3a097db68 = function TA(_ref217) {
    var title = _ref217.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref217, $061c76a48897c687$var$_excluded217);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#29DBFF",
        d: "m385.4 251.7-22.9-43h45.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m385.4 165.8-22.9 42.9h45.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#FFBE57",
        cx: 474.8,
        cy: 236.8,
        rx: 16.8,
        ry: 43.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#FFBE57",
        cx: 295.3,
        cy: 236.8,
        rx: 16.8,
        ry: 43.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ellipse", {
        fill: "#A5A5A5",
        cx: 386.3,
        cy: 104.3,
        rx: 34.3,
        ry: 23.3
    }));
};
var $061c76a48897c687$export$bf91931db7b40921 = function TC(_ref218) {
    var title = _ref218.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref218, $061c76a48897c687$var$_excluded218);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#A2001D",
        d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$9cf5b401f969f5e3 = function TD(_ref219) {
    var title = _ref219.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref219, $061c76a48897c687$var$_excluded219);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $061c76a48897c687$export$4014e91f2965d3df = function TF(_ref220) {
    var title = _ref220.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref220, $061c76a48897c687$var$_excluded220);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h21v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#073AB6",
        d: "M0 0h22.5v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h11.3v7.5H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#F44653",
        d: "M7.1 0h3.6v7H7.1V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1035BB",
        d: "M0 0h3.6v7H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
    }));
};
var $061c76a48897c687$export$3909ee2d70cce411 = function TG(_ref221) {
    var title = _ref221.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref221, $061c76a48897c687$var$_excluded221);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
        fill: "#496E2D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h204.054v204.054H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
    }));
};
var $061c76a48897c687$export$2b39a3648955dd09 = function TH(_ref222) {
    var title = _ref222.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref222, $061c76a48897c687$var$_excluded222);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h512V426.66H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 194.056h512v123.882H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
        fill: "#D80027"
    }));
};
var $061c76a48897c687$export$f5448d52a2727e70 = function TJ(_ref223) {
    var title = _ref223.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref223, $061c76a48897c687$var$_excluded223);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$73184284939cbbe8 = function TK(_ref224) {
    var title = _ref224.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref224, $061c76a48897c687$var$_excluded224);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$28666a74ae2b9cff = function TL(_ref225) {
    var title = _ref225.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref225, $061c76a48897c687$var$_excluded225);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 90.691v330.618L189.217 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
    }));
};
var $061c76a48897c687$export$e3227e6e5fca8775 = function TM(_ref226) {
    var title = _ref226.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref226, $061c76a48897c687$var$_excluded226);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M83.478 85.337h89.043v341.326H83.478z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
        fill: "#FF9811"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
        fill: "#FF9811"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
        fill: "#496E2D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M120.576 248.576h14.84v14.84h-14.84z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 128,
        cy: 206.113,
        r: 7.421
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: 128,
        cy: 305.887,
        r: 7.421
    })));
};
var $061c76a48897c687$export$82039c5ab5b44a72 = function TN(_ref227) {
    var title = _ref227.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref227, $061c76a48897c687$var$_excluded227);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 256,
        cy: 255.994,
        r: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
    })));
};
var $061c76a48897c687$export$ee525e60afffec7b = function TO(_ref228) {
    var title = _ref228.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref228, $061c76a48897c687$var$_excluded228);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
    }));
};
var $061c76a48897c687$export$5582bd7183a5e873 = function TR(_ref229) {
    var title = _ref229.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref229, $061c76a48897c687$var$_excluded229);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#E30A17",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
    }));
};
var $061c76a48897c687$export$c506431d6b27243b = function TT(_ref230) {
    var title = _ref230.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref230, $061c76a48897c687$var$_excluded230);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
    }));
};
var $061c76a48897c687$export$9e799ed47e538f9d = function TV(_ref231) {
    var title = _ref231.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref231, $061c76a48897c687$var$_excluded231);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h900v600H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#00B2EE",
        d: "M0 300h450V0h450v600H0V300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M449.9 39.9v53.9h-81z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
    }));
};
var $061c76a48897c687$export$1d1fd77441e66de6 = function TW(_ref232) {
    var title = _ref232.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref232, $061c76a48897c687$var$_excluded232);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h256V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#0052B4",
        cx: 128,
        cy: 170.674,
        r: 29.006
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
    }));
};
var $061c76a48897c687$export$786aa6dc686c7fa2 = function TZ(_ref233) {
    var title = _ref233.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref233, $061c76a48897c687$var$_excluded233);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 426.663V85.337h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
    }));
};
var $061c76a48897c687$export$4b88e746e0f81154 = function UA(_ref234) {
    var title = _ref234.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref234, $061c76a48897c687$var$_excluded234);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512V256H0z"
    }));
};
var $061c76a48897c687$export$c5b3cc9fdc52ea1d = function UG(_ref235) {
    var title = _ref235.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref235, $061c76a48897c687$var$_excluded235);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#232323",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 56.9h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D32300",
        d: "M0 113.8h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 227.6h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D32300",
        d: "M0 284.4h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FFF",
        cx: 256,
        cy: 170.7,
        r: 80.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
    }));
};
var $061c76a48897c687$export$a0e1852ae1fae17b = function UM(_ref236) {
    var title = _ref236.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref236, $061c76a48897c687$var$_excluded236);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M0 0h256.5v184.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$6137fb82cd5996e9 = function US(_ref237) {
    var title = _ref237.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref237, $061c76a48897c687$var$_excluded237);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M0 0h256.5v184.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$3f448fbd9cc8b25f = function UY(_ref238) {
    var title = _ref238.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref238, $061c76a48897c687$var$_excluded238);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
        fill: "#0038a8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h256.5v190H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FED443",
        d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
    }));
};
var $061c76a48897c687$export$6553e0f362fae356 = function UZ(_ref239) {
    var title = _ref239.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref239, $061c76a48897c687$var$_excluded239);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M0 322.783h512v103.88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 210.877h512v89.656H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$8f976c058e984810 = function VA(_ref240) {
    var title = _ref240.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref240, $061c76a48897c687$var$_excluded240);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.331h256v341.337H256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ACABB1",
        d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
    }));
};
var $061c76a48897c687$export$c3ea4fdfa4d8ecb7 = function VC(_ref241) {
    var title = _ref241.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref241, $061c76a48897c687$var$_excluded241);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
        fill: "#6DA544"
    }));
};
var $061c76a48897c687$export$d7d2699f2b01bb80 = function VE(_ref242) {
    var title = _ref242.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref242, $061c76a48897c687$var$_excluded242);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFCE00",
        d: "M0 0h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#203899",
        d: "M0 5h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D82B2B",
        d: "M0 10h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
    }));
};
var $061c76a48897c687$export$42769a1039364fc6 = function VG(_ref243) {
    var title = _ref243.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref243, $061c76a48897c687$var$_excluded243);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 107.951v30.712h-46.069z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 107.951v30.712h-46.069z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M372.87 215.181h22.261v59.359H372.87z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#A2001D",
        cx: 384,
        cy: 215.181,
        r: 11.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
        fill: "#FFDA44"
    }));
};
var $061c76a48897c687$export$ae144c30ed7463e6 = function VI(_ref244) {
    var title = _ref244.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref244, $061c76a48897c687$var$_excluded244);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1583C4",
        d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1583C4",
        d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1583C4",
        d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#409347",
        d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFD836",
        stroke: "#231F20",
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        stroke: "#231F20",
        strokeMiterlimit: 10,
        d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M201.3 111.8h119.4v37.9H201.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#1583C4",
        d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
    }));
};
var $061c76a48897c687$export$4ef9166b5b9f8bef = function VN(_ref245) {
    var title = _ref245.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref245, $061c76a48897c687$var$_excluded245);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M196.641 85.337H0v341.326h512V85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
    }));
};
var $061c76a48897c687$export$e4fcd53a919210fd = function VU(_ref246) {
    var title = _ref246.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref246, $061c76a48897c687$var$_excluded246);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#6DA544",
        d: "M512 256v170.663H0L215.185 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337V256H215.185L0 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
    })));
};
var $061c76a48897c687$export$2791da67db7afdb6 = function WF(_ref247) {
    var title = _ref247.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref247, $061c76a48897c687$var$_excluded247);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 150 100"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ED2939",
        d: "M0 0h150v100H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#002395",
        d: "M0 0h20v44.33H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M20 0h20v44.33H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 3,
        d: "M0 44.33h62.75V0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
    }));
};
var $061c76a48897c687$export$911baa0677ac404c = function WS(_ref248) {
    var title = _ref248.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref248, $061c76a48897c687$var$_excluded248);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
        fill: "#FFF"
    }));
};
var $061c76a48897c687$export$ba5d28d969e41cd5 = function XK(_ref249) {
    var title = _ref249.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref249, $061c76a48897c687$var$_excluded249);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.33"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.34H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
    }));
};
var $061c76a48897c687$export$5c4a0ca5352789e5 = function YE(_ref250) {
    var title = _ref250.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref250, $061c76a48897c687$var$_excluded250);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $061c76a48897c687$export$8c2e794969bbe829 = function YT(_ref251) {
    var title = _ref251.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref251, $061c76a48897c687$var$_excluded251);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h90v60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "#7f7f7f",
        strokeWidth: 0.25,
        fill: "#ABABAB",
        d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#DE393A",
        d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#3951A3",
        d: "M31 13.1h28v15.7H31z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FEE05F",
        cx: 39.1,
        cy: 36.5,
        r: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        fill: "#FEE05F",
        cx: 50.9,
        cy: 36.5,
        r: 3
    }));
};
var $061c76a48897c687$export$b2eccbdcd109dde0 = function ZA(_ref252) {
    var title = _ref252.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref252, $061c76a48897c687$var$_excluded252);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M114.024 256.001 0 141.926v228.17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#ffb915",
        d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#007847",
        d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#000c8a",
        d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#e1392d",
        d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
    }));
};
var $061c76a48897c687$export$8b0f08115411339f = function ZM(_ref253) {
    var title = _ref253.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref253, $061c76a48897c687$var$_excluded253);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 255.994h56.888v170.663h-56.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FF9811",
        d: "M455.112 255.994H512v170.663h-56.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M398.225 255.994h56.888v170.663h-56.888z"
    }));
};
var $061c76a48897c687$export$b2fd9c01d360241f = function ZW(_ref254) {
    var title = _ref254.title, rest = $061c76a48897c687$var$_objectWithoutProperties(_ref254, $061c76a48897c687$var$_excluded254);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $061c76a48897c687$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#057f44",
        d: "M0 85.333h512v48.868H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#057f44",
        d: "M0 378.542h512v48.128H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFF",
        d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#D80027",
        d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "#FFDA44",
        d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
    }));
};
var $061c76a48897c687$export$2e2bcd8739ae039 = {
    AC: $061c76a48897c687$export$871e5f91a510f021,
    AD: $061c76a48897c687$export$132ea4ffd82bf2b2,
    AE: $061c76a48897c687$export$2b2c8e343c91a153,
    AF: $061c76a48897c687$export$515692adc069839f,
    AG: $061c76a48897c687$export$9b1a14e161c718eb,
    AI: $061c76a48897c687$export$d710c5f50fc7496a,
    AL: $061c76a48897c687$export$1bb1140fe1358b00,
    AM: $061c76a48897c687$export$1507e1869e034170,
    AO: $061c76a48897c687$export$98cc8105f49bb278,
    AQ: $061c76a48897c687$export$123513653fa883e4,
    AR: $061c76a48897c687$export$1cd25c0dace0921a,
    AS: $061c76a48897c687$export$33f07343a4b8be1f,
    AT: $061c76a48897c687$export$537de78b98ba1ef0,
    AU: $061c76a48897c687$export$24f205cbfb89b8fc,
    AW: $061c76a48897c687$export$d170d5872abbd45,
    AX: $061c76a48897c687$export$f5cd1d288a5591fb,
    AZ: $061c76a48897c687$export$16cde7da05f651a,
    BA: $061c76a48897c687$export$a73c4d14459b698d,
    BB: $061c76a48897c687$export$921068d8846a1559,
    BD: $061c76a48897c687$export$2672079d1ac1dedf,
    BE: $061c76a48897c687$export$69784246352913ed,
    BF: $061c76a48897c687$export$5d7d56d6166de861,
    BG: $061c76a48897c687$export$7ecc97c3ec9172d0,
    BH: $061c76a48897c687$export$873be2d0c4c0f90f,
    BI: $061c76a48897c687$export$2601bd2ab73f6dbe,
    BJ: $061c76a48897c687$export$289e628e47fc68d4,
    BL: $061c76a48897c687$export$b54e584898971a5,
    BM: $061c76a48897c687$export$f063c90a7fd94f53,
    BN: $061c76a48897c687$export$ed16643e9b9e3dfe,
    BO: $061c76a48897c687$export$cd6527c992e4b6fe,
    BQ: $061c76a48897c687$export$2ca204c58a1fc922,
    BR: $061c76a48897c687$export$b3e0c086157e0a90,
    BS: $061c76a48897c687$export$66ea4a98fa009686,
    BT: $061c76a48897c687$export$433b53d451a98e6d,
    BV: $061c76a48897c687$export$8ba1594c72a88684,
    BW: $061c76a48897c687$export$cd7b90d76addb66a,
    BY: $061c76a48897c687$export$558af6901b7fc79a,
    BZ: $061c76a48897c687$export$8af59566cb38fe85,
    CA: $061c76a48897c687$export$8de6180416dff1fc,
    CC: $061c76a48897c687$export$183b2a0874e6e919,
    CD: $061c76a48897c687$export$6ede307faf7aaec4,
    CF: $061c76a48897c687$export$ba26f2d80491fb47,
    CG: $061c76a48897c687$export$9e8da9070f3c2e68,
    CH: $061c76a48897c687$export$31ff2235b44019b8,
    CI: $061c76a48897c687$export$ddcf9efc80efb978,
    CK: $061c76a48897c687$export$2779adff9720d9c9,
    CL: $061c76a48897c687$export$9bf3043cb7503aa1,
    CM: $061c76a48897c687$export$dcd191669c0a595f,
    CN: $061c76a48897c687$export$f175668af5171efd,
    CO: $061c76a48897c687$export$423e5ab65bdedcb8,
    CR: $061c76a48897c687$export$de92be486109a1df,
    CU: $061c76a48897c687$export$6f478fc577ffffe3,
    CV: $061c76a48897c687$export$9c7a4b602f1ee953,
    CW: $061c76a48897c687$export$640171019d58eb6d,
    CX: $061c76a48897c687$export$ef748afa94c5c5f9,
    CY: $061c76a48897c687$export$e5e7583d5d9c5f7b,
    CZ: $061c76a48897c687$export$3aa7db55ae20a642,
    DE: $061c76a48897c687$export$b2bfc53cef5629f5,
    DJ: $061c76a48897c687$export$b116121769fff50f,
    DK: $061c76a48897c687$export$861a3271cad515fc,
    DM: $061c76a48897c687$export$c63caaa7a05b64da,
    DO: $061c76a48897c687$export$fe81c0b6cf107daf,
    DZ: $061c76a48897c687$export$d2309a4fc782a0d1,
    EC: $061c76a48897c687$export$129fe12d32abc311,
    EE: $061c76a48897c687$export$3f443bcc5237c742,
    EG: $061c76a48897c687$export$e107e11ec3489258,
    EH: $061c76a48897c687$export$8e048a19e03780a2,
    ER: $061c76a48897c687$export$20e28a5cfb7c13df,
    ES: $061c76a48897c687$export$a723e6e41cced9bd,
    ET: $061c76a48897c687$export$404386694049c788,
    EU: $061c76a48897c687$export$f005962cdbec7017,
    FI: $061c76a48897c687$export$b742dc37108d5cac,
    FJ: $061c76a48897c687$export$4cd493ed69e3bc18,
    FK: $061c76a48897c687$export$58f4e3559034e3ed,
    FM: $061c76a48897c687$export$ae39d226e90e08ef,
    FO: $061c76a48897c687$export$3117889032a11ab0,
    FR: $061c76a48897c687$export$b0bfe88d8be86eef,
    GA: $061c76a48897c687$export$2c816677949efbbf,
    GB: $061c76a48897c687$export$5c1daad85ece4f0d,
    GD: $061c76a48897c687$export$44132903afebf574,
    GE: $061c76a48897c687$export$64f1adb8dced2c27,
    GF: $061c76a48897c687$export$a1c692af90f0ad93,
    GG: $061c76a48897c687$export$ffd553dab4f92f72,
    GH: $061c76a48897c687$export$2063236980199869,
    GI: $061c76a48897c687$export$b3b059666b470a4,
    GL: $061c76a48897c687$export$bad2a840ccda93b6,
    GM: $061c76a48897c687$export$af02b8e3ecf08df4,
    GN: $061c76a48897c687$export$49b768d2cda4fc68,
    GP: $061c76a48897c687$export$a1e9daa76fd80d91,
    GQ: $061c76a48897c687$export$64532cc081f88b3a,
    GR: $061c76a48897c687$export$be3bb2d6fb94aa6,
    GS: $061c76a48897c687$export$f7fbe7cb90eabcb4,
    GT: $061c76a48897c687$export$b023c82b48e70453,
    GU: $061c76a48897c687$export$875a05f1afdc3a63,
    GW: $061c76a48897c687$export$4f7b2a18b14c6e6,
    GY: $061c76a48897c687$export$f433acc20da515b9,
    HK: $061c76a48897c687$export$7bf8e436292b0d9,
    HM: $061c76a48897c687$export$e8ae668e70e7a813,
    HN: $061c76a48897c687$export$d654914ee99e1b51,
    HR: $061c76a48897c687$export$41dbabafe943a3bc,
    HT: $061c76a48897c687$export$3927bce5ead7457e,
    HU: $061c76a48897c687$export$2cba20fb7b4c6fda,
    IC: $061c76a48897c687$export$520d469a2f25f64a,
    ID: $061c76a48897c687$export$8be180ec26319f9f,
    IE: $061c76a48897c687$export$5056f4df3c1a040a,
    IL: $061c76a48897c687$export$747f5b589ac90db,
    IM: $061c76a48897c687$export$5e0fd3f816252990,
    IN: $061c76a48897c687$export$70824c8942178d60,
    IO: $061c76a48897c687$export$8f8422ac5947a789,
    IQ: $061c76a48897c687$export$776a9becd139230f,
    IR: $061c76a48897c687$export$35f3e3f7e3ce71e0,
    IS: $061c76a48897c687$export$bfe27467c1de9413,
    IT: $061c76a48897c687$export$c8c4756768edc1be,
    JE: $061c76a48897c687$export$7300d7e65520d9c0,
    JM: $061c76a48897c687$export$62925b2b1d8826f,
    JO: $061c76a48897c687$export$4ff8ba3b6e78910e,
    JP: $061c76a48897c687$export$4165087edc6149ea,
    KE: $061c76a48897c687$export$ebf06250eda1662e,
    KG: $061c76a48897c687$export$32f37961c13d8178,
    KH: $061c76a48897c687$export$96381358fb12b492,
    KI: $061c76a48897c687$export$8aa7bcd4299a59b9,
    KM: $061c76a48897c687$export$7ca86d88f982585b,
    KN: $061c76a48897c687$export$fd8f06eb7ce62883,
    KP: $061c76a48897c687$export$171643e72dc5e91,
    KR: $061c76a48897c687$export$ced591d2396bbc3f,
    KW: $061c76a48897c687$export$867391011d376267,
    KY: $061c76a48897c687$export$ea257f329676e0aa,
    KZ: $061c76a48897c687$export$45edc2c6b51c02b3,
    LA: $061c76a48897c687$export$64f943d6c6d62030,
    LB: $061c76a48897c687$export$1dd3e96947fb44fc,
    LC: $061c76a48897c687$export$3cb73e0e841fe17f,
    LI: $061c76a48897c687$export$2e3013aac067a692,
    LK: $061c76a48897c687$export$782aca1f2c103f6b,
    LR: $061c76a48897c687$export$9e0d336de5ae0eb3,
    LS: $061c76a48897c687$export$c6944423ed371873,
    LT: $061c76a48897c687$export$7158f0ceb70f54c7,
    LU: $061c76a48897c687$export$b6a2dd8a7c2d6cd5,
    LV: $061c76a48897c687$export$feea9fafc15a0118,
    LY: $061c76a48897c687$export$4eb7334fca20385f,
    MA: $061c76a48897c687$export$d88940c21edc1e8e,
    MC: $061c76a48897c687$export$cd68417dc2ec295d,
    MD: $061c76a48897c687$export$3c37c3bdb860ae1e,
    ME: $061c76a48897c687$export$4898541b722d275d,
    MF: $061c76a48897c687$export$33916af50bbab5f5,
    MG: $061c76a48897c687$export$d7c1ae0cf4ef5274,
    MH: $061c76a48897c687$export$61a81a4b59098e0c,
    MK: $061c76a48897c687$export$9391ff7d7f7d79ce,
    ML: $061c76a48897c687$export$670dad092b145ea,
    MM: $061c76a48897c687$export$eefdfd8a735ff143,
    MN: $061c76a48897c687$export$30e7c6589c527eef,
    MO: $061c76a48897c687$export$511fbc18fa6ca984,
    MP: $061c76a48897c687$export$15b7d6cdd29b06a0,
    MQ: $061c76a48897c687$export$451b471c9c9066b,
    MR: $061c76a48897c687$export$c4e38e98e3fb5f60,
    MS: $061c76a48897c687$export$71ad59f2e432cfe8,
    MT: $061c76a48897c687$export$b900a375df2ae552,
    MU: $061c76a48897c687$export$c5764e4399dad848,
    MV: $061c76a48897c687$export$20138591ba7d4d60,
    MW: $061c76a48897c687$export$a3772f6eb527275b,
    MX: $061c76a48897c687$export$80b36494c451f15f,
    MY: $061c76a48897c687$export$655dc88003efaac0,
    MZ: $061c76a48897c687$export$b5030f3cedb7f384,
    NA: $061c76a48897c687$export$dbd1925f4fe9ec65,
    NC: $061c76a48897c687$export$fbcebdb931d67ac9,
    NE: $061c76a48897c687$export$8719acbfb72c829,
    NF: $061c76a48897c687$export$ebe65a9e9fde641f,
    NG: $061c76a48897c687$export$d9501190a8cd7a46,
    NI: $061c76a48897c687$export$2128ddd8b6e5cc05,
    NL: $061c76a48897c687$export$e51d3c675bb0140d,
    NO: $061c76a48897c687$export$c01351c0af048e39,
    NP: $061c76a48897c687$export$575bf2af220888ee,
    NR: $061c76a48897c687$export$8885480fb36cb8cc,
    NU: $061c76a48897c687$export$8227ca023eb0daaa,
    NZ: $061c76a48897c687$export$b6db8d689596ccb0,
    OM: $061c76a48897c687$export$1ed389bd9cb529,
    PA: $061c76a48897c687$export$ff7e3d480d313da2,
    PE: $061c76a48897c687$export$d5e55eb9565ea8d5,
    PF: $061c76a48897c687$export$7d19ebf018caa9aa,
    PG: $061c76a48897c687$export$c56943b7b8ffea21,
    PH: $061c76a48897c687$export$38ea63fabb2c685f,
    PK: $061c76a48897c687$export$73910688e185534c,
    PL: $061c76a48897c687$export$9e95f02561f2d9f9,
    PM: $061c76a48897c687$export$164607a37e7daeba,
    PN: $061c76a48897c687$export$6bc8c38c416ebf89,
    PR: $061c76a48897c687$export$af5f8d68aad3cd3a,
    PS: $061c76a48897c687$export$5adddb0645f34b2,
    PT: $061c76a48897c687$export$3961bdb9130b90e7,
    PW: $061c76a48897c687$export$5f5211c171c1b47a,
    PY: $061c76a48897c687$export$21b6e0fb60b525ae,
    QA: $061c76a48897c687$export$a7078eadaecd4b6f,
    RE: $061c76a48897c687$export$ded96516917cab2a,
    RO: $061c76a48897c687$export$993ec495e78d530d,
    RS: $061c76a48897c687$export$e9d8d46fbf5f29f6,
    RU: $061c76a48897c687$export$6c2517b5e52f01cc,
    RW: $061c76a48897c687$export$ef5ca6a08aac8ca5,
    SA: $061c76a48897c687$export$da51c6332ad11d7b,
    SB: $061c76a48897c687$export$279f8048cbf05e80,
    SC: $061c76a48897c687$export$f49cccbff6374af4,
    SD: $061c76a48897c687$export$5b088def975a652b,
    SE: $061c76a48897c687$export$88d2e60d4be28663,
    SG: $061c76a48897c687$export$bea437c40441867d,
    SH: $061c76a48897c687$export$c713cf928ffb5e8e,
    SI: $061c76a48897c687$export$e6702cab675b095,
    SJ: $061c76a48897c687$export$e9f025fd23256930,
    SK: $061c76a48897c687$export$5f584391ee0d99b4,
    SL: $061c76a48897c687$export$b49d6918df199090,
    SM: $061c76a48897c687$export$59096964bd9627ef,
    SN: $061c76a48897c687$export$b70f9dd36a734be4,
    SO: $061c76a48897c687$export$f6311706676f39f2,
    SR: $061c76a48897c687$export$13acf42283a26926,
    SS: $061c76a48897c687$export$8cda4cf3f4deb8c2,
    ST: $061c76a48897c687$export$80980ed6b6f31397,
    SV: $061c76a48897c687$export$8fc936c6ebd916b3,
    SX: $061c76a48897c687$export$b4f896bb97547f66,
    SY: $061c76a48897c687$export$2e8caadc521d7cbb,
    SZ: $061c76a48897c687$export$988c8b3cfeed3531,
    TA: $061c76a48897c687$export$6b4abaf3a097db68,
    TC: $061c76a48897c687$export$bf91931db7b40921,
    TD: $061c76a48897c687$export$9cf5b401f969f5e3,
    TF: $061c76a48897c687$export$4014e91f2965d3df,
    TG: $061c76a48897c687$export$3909ee2d70cce411,
    TH: $061c76a48897c687$export$2b39a3648955dd09,
    TJ: $061c76a48897c687$export$f5448d52a2727e70,
    TK: $061c76a48897c687$export$73184284939cbbe8,
    TL: $061c76a48897c687$export$28666a74ae2b9cff,
    TM: $061c76a48897c687$export$e3227e6e5fca8775,
    TN: $061c76a48897c687$export$82039c5ab5b44a72,
    TO: $061c76a48897c687$export$ee525e60afffec7b,
    TR: $061c76a48897c687$export$5582bd7183a5e873,
    TT: $061c76a48897c687$export$c506431d6b27243b,
    TV: $061c76a48897c687$export$9e799ed47e538f9d,
    TW: $061c76a48897c687$export$1d1fd77441e66de6,
    TZ: $061c76a48897c687$export$786aa6dc686c7fa2,
    UA: $061c76a48897c687$export$4b88e746e0f81154,
    UG: $061c76a48897c687$export$c5b3cc9fdc52ea1d,
    UM: $061c76a48897c687$export$a0e1852ae1fae17b,
    US: $061c76a48897c687$export$6137fb82cd5996e9,
    UY: $061c76a48897c687$export$3f448fbd9cc8b25f,
    UZ: $061c76a48897c687$export$6553e0f362fae356,
    VA: $061c76a48897c687$export$8f976c058e984810,
    VC: $061c76a48897c687$export$c3ea4fdfa4d8ecb7,
    VE: $061c76a48897c687$export$d7d2699f2b01bb80,
    VG: $061c76a48897c687$export$42769a1039364fc6,
    VI: $061c76a48897c687$export$ae144c30ed7463e6,
    VN: $061c76a48897c687$export$4ef9166b5b9f8bef,
    VU: $061c76a48897c687$export$e4fcd53a919210fd,
    WF: $061c76a48897c687$export$2791da67db7afdb6,
    WS: $061c76a48897c687$export$911baa0677ac404c,
    XK: $061c76a48897c687$export$ba5d28d969e41cd5,
    YE: $061c76a48897c687$export$5c4a0ca5352789e5,
    YT: $061c76a48897c687$export$8c2e794969bbe829,
    ZA: $061c76a48897c687$export$b2eccbdcd109dde0,
    ZM: $061c76a48897c687$export$8b0f08115411339f,
    ZW: $061c76a48897c687$export$b2fd9c01d360241f
};

});




parcelRegister("2yQbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2f6ca56ef61a56a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $4KSAX = parcelRequire("4KSAX");

var $4IfrI = parcelRequire("4IfrI");

var $Rsdju = parcelRequire("Rsdju");

var $4MSTE = parcelRequire("4MSTE");

var $eipax = parcelRequire("eipax");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4Z6GL = parcelRequire("4Z6GL");

var $32kQ2 = parcelRequire("32kQ2");

var $4VtCQ = parcelRequire("4VtCQ");

var $8UrgM = parcelRequire("8UrgM");

var $et8Rr = parcelRequire("et8Rr");

var $e5EhV = parcelRequire("e5EhV");
const $f2f6ca56ef61a56a$var$MeetingPage = ()=>{
    const { meetingId: meetingId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(0);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchMeeting = (meetingId)=>dispatch((0, $4Z6GL.fetchMeetingAction)(meetingId));
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: meetingId
        }));
    (0, $e5EhV.useBeforeunload)(()=>{
        setConnectionRefresherIndex(connectionRefresherIndex + 1);
    });
    (0, $acw62.useEffect)(()=>{
        fetchMeeting(meetingId);
        fetchUsers();
    }, []);
    if (!meeting) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("meeting:meetingNotFound")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $et8Rr.default), {
        resourceId: meetingId,
        channelName: (0, $32kQ2.MeetingChannelName),
        actionPrefix: (0, $32kQ2.MeetingCablePrefix),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Rsdju.default), {
                meetingId: meetingId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4MSTE.default), {
                meetingId: meetingId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eipax.default), {
                meetingId: meetingId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4IfrI.default), {
                meetingId: meetingId
            })
        ]
    }, connectionRefresherIndex);
};
var $f2f6ca56ef61a56a$export$2e2bcd8739ae039 = $f2f6ca56ef61a56a$var$MeetingPage;

});
parcelRegister("4IfrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d48cb6acb9a52fd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $4IfBr = parcelRequire("4IfBr");

var $kA27M = parcelRequire("kA27M");

var $jF0Xa = parcelRequire("jF0Xa");

var $3wpY0 = parcelRequire("3wpY0");

var $4VtCQ = parcelRequire("4VtCQ");

var $4qaeN = parcelRequire("4qaeN");

var $6lvMC = parcelRequire("6lvMC");

var $12fpK = parcelRequire("12fpK");
const $1d48cb6acb9a52fd$var$MeetingCases = (props)=>{
    const [isVisibleList, toggleList] = (0, $acw62.useState)(true);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const [isModalOpen, setIsModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const openModal = ()=>{
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const renderAddCaseButton = ()=>{
        if (!meeting.permissions?.canAddCase) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: openModal,
            className: "mb-2",
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("meeting:addCase")
        });
    };
    const renderAddGroup = ()=>{
        if (!meeting.permissions?.canAddCase) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4IfBr.default), {
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            action: ()=>{
                return;
            }
        });
    };
    if (!meeting || !meeting.meetingCases || !currentUser) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("shared:cases"),
                                    " (",
                                    meeting.meetingCases.length,
                                    ")"
                                ]
                            }),
                            renderAddCaseButton()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex mb-2 items-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "flex-1 pr-10 lg:pr-24",
                                children: t("meeting:casesIntro")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                isExpanded: isVisibleList,
                                action: ()=>toggleList(!isVisibleList),
                                expandText: t("meeting:showCases"),
                                collapseText: t("meeting:hideCases")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                            hidden: !isVisibleList
                        }),
                        children: [
                            renderAddGroup(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(meeting.meetingCases, (meetingCaseId)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3wpY0.default), {
                                        meetingCaseId: meetingCaseId
                                    }, meetingCaseId);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12fpK.default), {
                meetingId: props.meetingId,
                isOpen: isModalOpen,
                handleClose: closeModal
            })
        ]
    });
};
var $1d48cb6acb9a52fd$export$2e2bcd8739ae039 = $1d48cb6acb9a52fd$var$MeetingCases;

});
parcelRegister("4IfBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $57499d7f93fb877d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $asRrx = parcelRequire("asRrx");

var $jF0Xa = parcelRequire("jF0Xa");

var $2ywbu = parcelRequire("2ywbu");
const $57499d7f93fb877d$var$AddGroup = ({ className: className, action: action, variant: variant })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    if (!variant) variant = (0, $jF0Xa.StyleVariants).BLUE;
    const defaultClasses = [
        `text-${variant}-500`,
        `hover:text-${variant}-600`,
        "uppercase",
        "font-semibold",
        "bg-white"
    ];
    const renderButton = ()=>{
        const propClasses = className ? className.split(" ") : [];
        const allClasses = [
            ...defaultClasses,
            ...propClasses
        ].join(" ");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
            className: allClasses,
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            action: action,
            children: [
                t("shared:addGroup"),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $asRrx.default), {
                    className: "w-6 h-6 ml-2",
                    title: t("shared:addGroup")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex justify-center items-center relative hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex w-full justify-center items-center absolute",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute",
                        children: renderButton()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "border-t border-ch-blue-500 w-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "invisible",
                children: renderButton()
            })
        ]
    });
};
var $57499d7f93fb877d$export$2e2bcd8739ae039 = $57499d7f93fb877d$var$AddGroup;

});

parcelRegister("kA27M", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2846132a06511f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $rSxjF = parcelRequire("rSxjF");
var $hA7qy = parcelRequire("hA7qy");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");
const $2e2846132a06511f$var$ButtonExpandCollapse = ({ className: className, action: action, variant: variant, isExpanded: isExpanded, expandText: expandText, collapseText: collapseText })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    if (!variant) variant = (0, $jF0Xa.StyleVariants).BLUE;
    if (!collapseText) collapseText = t("shared:collapse");
    if (!expandText) expandText = t("shared:expand");
    const renderIcon = ()=>{
        if (isExpanded) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rSxjF.default), {
            className: "fill-current w-4 h-4",
            title: collapseText
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hA7qy.default), {
            className: "fill-current w-4 h-4",
            title: expandText
        });
    };
    const defaultClasses = [
        "flex",
        "items-center",
        `text-${variant}-500`,
        `hover:text-${variant}-600`
    ];
    const propClasses = className ? className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        href: "#",
        onClick: action,
        className: allClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mr-2",
                children: isExpanded ? t("shared:collapse") : t("shared:expand")
            }),
            " ",
            renderIcon()
        ]
    });
};
var $2e2846132a06511f$export$2e2bcd8739ae039 = $2e2846132a06511f$var$ButtonExpandCollapse;

});

parcelRegister("3wpY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7058b3fa97d026$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $1Cmbh = parcelRequire("1Cmbh");

var $ejvqu = parcelRequire("ejvqu");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $5v6Bi = parcelRequire("5v6Bi");

var $kon2z = parcelRequire("kon2z");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $fcxUP = parcelRequire("fcxUP");
var $6Hpf8 = parcelRequire("6Hpf8");

var $50NSH = parcelRequire("50NSH");
const $9a7058b3fa97d026$var$MeetingCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseByMeetingCaseId)(state, props));
    if (!theCase) return null;
    const meetingCaseDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_CASE, {
        meetingCaseId: props.meetingCaseId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mr-4 text-ch-blue-500 hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fcxUP.default), {
                        className: "fill-current w-2",
                        title: t("shared:clickToDrag")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                className: "fill-current w-6 h-6",
                                title: t("shared:case")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50NSH.default), {
                            meetingCaseId: props.meetingCaseId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                href: meetingCaseDetailsUrl,
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                children: t("shared:viewDetails")
                            }, "1")
                        ]
                    })
                })
            ]
        })
    });
};
var $9a7058b3fa97d026$export$2e2bcd8739ae039 = $9a7058b3fa97d026$var$MeetingCaseListItem;

});

parcelRegister("12fpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c8cbf1991d0b4c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $9c2AV = parcelRequire("9c2AV");

var $3QK3n = parcelRequire("3QK3n");

var $4VtCQ = parcelRequire("4VtCQ");

var $kQILj = parcelRequire("kQILj");

var $32HSV = parcelRequire("32HSV");

var $aeos3 = parcelRequire("aeos3");

var $39EfS = parcelRequire("39EfS");

var $1kXfn = parcelRequire("1kXfn");

var $9QVLZ = parcelRequire("9QVLZ");

var $lzBkr = parcelRequire("lzBkr");

var $7Bj8I = parcelRequire("7Bj8I");

var $glc4D = parcelRequire("glc4D");
const $20c8cbf1991d0b4c$var$AddCaseToMeetingModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getAddCaseToMeetingUI)(state));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const initialSearchQuery = {
        page: 1,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $lzBkr.fetchCasesAddableToMeetingsAsync));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.handleClose,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.handleClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("meeting:addCaseIntro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "md:flex md:text-lg flex-row font-semibold mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                            className: "text-ch-purple-500 self-center mr-1 w-5 h-5"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                meeting.name,
                                " ",
                                t("shared:on"),
                                "\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                            startDate: meeting.startDate,
                            endDate: meeting.endDate
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600",
                            children: t("meeting:addCaseDesc1")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600",
                            children: t("meeting:addCaseDesc2")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-start-2 md:row-start-1 self-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "case:searchBy",
                                components: {
                                    strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                },
                                values: {
                                    careProviderIdLabel: careProviderIdLabel
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-end-2 md:row-start-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("case:searchCases")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-2",
                    children: [
                        UI.totalCasesCount,
                        " ",
                        t("shared:cases")
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32HSV.default), {
                    meetingId: props.meetingId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    totalItems: UI.totalCasesCount,
                    totalPages: UI.totalPages,
                    scrollActionType: (0, $7Bj8I.ScrollActionTypes).UPDATE_MODAL_SCROLL_TO_POSITION
                })
            ]
        })
    });
};
var $20c8cbf1991d0b4c$export$2e2bcd8739ae039 = $20c8cbf1991d0b4c$var$AddCaseToMeetingModal;

});
parcelRegister("32HSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75192f524d1b79d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kQILj = parcelRequire("kQILj");

var $lFblz = parcelRequire("lFblz");
const $f75192f524d1b79d$var$AddCaseToMeetingCaseList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const caseIds = (0, $iD0SF.useSelector)((0, $kQILj.getAddCaseToMeetingUI)).resultIds;
    if (!caseIds) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("case:noCases")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: caseIds.map((caseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFblz.default), {
                caseId: caseId,
                meetingId: props.meetingId
            }, caseId);
        })
    });
};
var $f75192f524d1b79d$export$2e2bcd8739ae039 = $f75192f524d1b79d$var$AddCaseToMeetingCaseList;

});
parcelRegister("lFblz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58bc9165ef976cb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aVAGa = parcelRequire("aVAGa");

var $ejvqu = parcelRequire("ejvqu");

var $kon2z = parcelRequire("kon2z");

var $99NRk = parcelRequire("99NRk");

var $2b2d9 = parcelRequire("2b2d9");
const $f58bc9165ef976cb$var$CaseListItem = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $99NRk.getMeetingCaseByMeetingAndCaseId)(state, props));
    if (!theCase) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVAGa.default), {
        caseId: props.caseId,
        isDark: meetingCase != null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
            buttons: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b2d9.default), {
                    caseId: props.caseId,
                    meetingId: props.meetingId
                }, "1")
            ]
        })
    }, props.caseId);
};
var $f58bc9165ef976cb$export$2e2bcd8739ae039 = $f58bc9165ef976cb$var$CaseListItem;

});
parcelRegister("aVAGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed4a338cb255ef8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eucKq = parcelRequire("eucKq");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $8g1PZ = parcelRequire("8g1PZ");
const $6ed4a338cb255ef8$var$CaseListItemContainer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const renderChildren = ()=>{
        if (!props.children) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
            children: props.children
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            "text-xs": props.hasSmallText
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            isDark: props.isDark,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    width: !props.children ? "w-full" : "",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            sizeClasses: props.hasSmallText ? [
                                "w-7",
                                "h-7"
                            ] : null,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fill-current  h-6", {
                                    "w-6": !props.hasSmallText,
                                    "h-6": !props.hasSmallText,
                                    "w-4": props.hasSmallText,
                                    "h-4": props.hasSmallText
                                }),
                                title: t("shared:case")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eucKq.default), {
                            caseId: props.caseId
                        })
                    ]
                }),
                renderChildren()
            ]
        })
    });
};
var $6ed4a338cb255ef8$export$2e2bcd8739ae039 = $6ed4a338cb255ef8$var$CaseListItemContainer;

});

parcelRegister("99NRk", function(module, exports) {

$parcel$export(module.exports, "getMeetingCaseByMeetingAndCaseId", () => $7ddc6e589f9b883a$export$130f53568362eb31);

var $f1q41 = parcelRequire("f1q41");

var $6SpLG = parcelRequire("6SpLG");

var $4VtCQ = parcelRequire("4VtCQ");
const $7ddc6e589f9b883a$var$getCaseIdFromProps = (state, ownProps)=>ownProps.caseId;
const $7ddc6e589f9b883a$var$getMeetingIdFromProps = (state, ownProps)=>ownProps.meetingId;
const $7ddc6e589f9b883a$export$130f53568362eb31 = (0, $6SpLG.createSelector)((0, $4VtCQ.getAllMeetingCases), $7ddc6e589f9b883a$var$getCaseIdFromProps, $7ddc6e589f9b883a$var$getMeetingIdFromProps, (allMeetingCases, caseId, meetingId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(allMeetingCases, (meetingCase)=>{
        return meetingCase.case == caseId && meetingCase.meeting == meetingId;
    });
});

});

parcelRegister("2b2d9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b2d43235f1dd832$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $6j1K3 = parcelRequire("6j1K3");

var $99NRk = parcelRequire("99NRk");
const $8b2d43235f1dd832$var$AddCaseToMeetingButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "meeting"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $99NRk.getMeetingCaseByMeetingAndCaseId)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const createMeetingCase = (meetingId, caseId)=>dispatch((0, $6j1K3.createMeetingCaseAction)(meetingId, caseId));
    const deleteMeetingCase = (meetingId, caseId, meetingCaseId)=>dispatch((0, $6j1K3.deleteMeetingCaseAction)(meetingId, caseId, meetingCaseId));
    if (theCase.locked) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-ch-gray-alt-500",
        children: t("case:caseIsLocked")
    });
    if (meetingCase) {
        if (!meetingCase.permissions.canDelete) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>deleteMeetingCase(props.meetingId, props.caseId, meetingCase.id),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            className: "self-center self-end",
            isChunky: true,
            children: t("meeting:removeCaseFromMeeting")
        }, `removeCase-${theCase.id}`);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: ()=>createMeetingCase(props.meetingId, props.caseId),
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        className: "self-center self-end",
        isChunky: true,
        children: t("meeting:addCaseToMeeting")
    }, `addCase-${theCase.id}`);
};
var $8b2d43235f1dd832$export$2e2bcd8739ae039 = $8b2d43235f1dd832$var$AddCaseToMeetingButton;

});



parcelRegister("39EfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc51f3c992f2aa4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $4KSAX = parcelRequire("4KSAX");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $k7HLt = parcelRequire("k7HLt");

var $jF0Xa = parcelRequire("jF0Xa");
const $ddc51f3c992f2aa4$var$ValueChangeListener = ()=>{
    const { submitForm: submitForm, values: values } = (0, $7YFi7.useFormikContext)();
    const value = values;
    (0, $acw62.useEffect)(()=>{
        if (value) submitForm();
    }, [
        value,
        submitForm
    ]);
    return null;
};
const $ddc51f3c992f2aa4$var$ResultsPerPage = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const resultsPerPageOptions = Object.keys((0, $jF0Xa.ResultsPerPageOptions)).map((key)=>{
        return {
            value: (0, $jF0Xa.ResultsPerPageOptions)[key],
            label: (0, $jF0Xa.ResultsPerPageOptions)[key]
        };
    });
    const initialValues = {
        resultsPerPage: props.searchQuery.resultsPerPage
    };
    const reload = (value)=>{
        props.setSearchQuery({
            resultsPerPage: value.resultsPerPage
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: reload,
        children: ({ values: values, handleChange: handleChange, handleBlur: handleBlur })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        className: "mr-2",
                        name: "resultsPerPage",
                        children: t("resultsPerPage")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7HLt.default), {
                        options: resultsPerPageOptions,
                        type: "text",
                        name: "resultsPerPage",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.resultsPerPage.toString(),
                        className: "pt-2 pb-2 pl-2 pr-2 rounded-none text-ch-gray-100",
                        autoComplete: "off",
                        includeBlank: false,
                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                        isLight: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ddc51f3c992f2aa4$var$ValueChangeListener, {})
                ]
            });
        }
    });
};
var $ddc51f3c992f2aa4$export$2e2bcd8739ae039 = $ddc51f3c992f2aa4$var$ResultsPerPage;

});
parcelRegister("k7HLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb55d93bee71bc47$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");
const $fb55d93bee71bc47$var$StandardSelectField = ({ includeBlank: includeBlank = true, isMulti: isMulti = false, ...props })=>{
    let variant = props.variant;
    if (!variant) variant = (0, $jF0Xa.StyleVariants).GRAY;
    const renderBlankOption = ()=>{
        if (includeBlank === false) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
            value: "",
            children: props?.blankOptionsLabel
        });
    };
    const renderOptions = ()=>{
        return props.options.map((option)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                value: option.value,
                children: option.label
            }, option.value);
        });
    };
    const fillColor = props.isLight ? "white" : "%23A3C3C4";
    const arrowSVG = `<svg xmlns='http://www.w3.org/2000/svg'><path fill='${fillColor}' viewBox='0 0 9 6' width='9px' height='6px' d='M.5 0a.5.5 0 00-.374.832l4 4.5a.5.5 0 00.748 0l4-4.5A.5.5 0 008.5 0h-8z' /></svg>`;
    const backgroundPosition = "calc(100% + 0.5em) 1em";
    const iconStyle = {
        WebkitAppearance: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml;utf8,${arrowSVG}")`,
        backgroundSize: "2em",
        backgroundPosition: backgroundPosition,
        backgroundRepeat: "no-repeat"
    };
    const defaultClasses = [
        "flex",
        "mb-1",
        "py-2",
        "px-3",
        "pr-8",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "appearance-none",
        "focus:ring-2",
        "ring-ch-blue-alt-300"
    ];
    const lightClasses = [
        "text-white",
        "rounded-none",
        `bg-${variant}-400`
    ];
    const normalClasses = [
        "text-ch-gray-600",
        "border-ch-blue-alt-300",
        "rounded",
        "border"
    ];
    const additionalClasses = props.isLight ? lightClasses : normalClasses;
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...additionalClasses,
        ...propClasses
    ].join(" ");
    const _type = props.type ? props.type : "text";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Field), {
        as: "select",
        innerRef: props.innerRef,
        autoFocus: props.autoFocus,
        type: _type,
        name: props.name,
        id: props.name,
        multiple: isMulti,
        onChange: props.onChange,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        value: props.value,
        autoComplete: props.autoComplete,
        className: allClasses,
        style: iconStyle,
        children: [
            renderBlankOption(),
            renderOptions()
        ]
    });
};
var $fb55d93bee71bc47$export$2e2bcd8739ae039 = $fb55d93bee71bc47$var$StandardSelectField;

});


parcelRegister("1kXfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5296c1b793d32f8b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $cjnbD = parcelRequire("cjnbD");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $f1q41 = parcelRequire("f1q41");
const $5296c1b793d32f8b$var$SearchInput = (props)=>{
    const initialValues = {
        searchTerm: props.searchQuery.searchTerm || ""
    };
    const search = (searchTerm)=>{
        props.setSearchQuery({
            searchTerm: searchTerm
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-wrap",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $cjnbD.searchValidationSchema),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                search(values.searchTerm);
                setSubmitting(false);
            },
            children: ({ errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, submitForm: submitForm })=>{
                const debouncedSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce(submitForm, 500);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "mt-2 w-full",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "searchTerm",
                                    onChange: (e)=>{
                                        handleChange(e);
                                        debouncedSubmit();
                                    },
                                    onBlur: handleBlur,
                                    value: values.searchTerm,
                                    autoComplete: "off",
                                    autoFocus: false
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.searchTerm,
                                    isVisible: errors.searchTerm && touched.searchTerm
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: props.buttonText
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $5296c1b793d32f8b$export$2e2bcd8739ae039 = $5296c1b793d32f8b$var$SearchInput;

});

parcelRegister("9QVLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a6c4f4c342414$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");

var $4KSAX = parcelRequire("4KSAX");

var $2ywbu = parcelRequire("2ywbu");

var $jF0Xa = parcelRequire("jF0Xa");

var $7Bj8I = parcelRequire("7Bj8I");

var $2MEcG = parcelRequire("2MEcG");
const $628a6c4f4c342414$var$MaxPageElements = 9;
const $628a6c4f4c342414$var$MaxPageOffset = Math.floor($628a6c4f4c342414$var$MaxPageElements / 2);
const $628a6c4f4c342414$var$Pagination = ({ scrollActionType: scrollActionType = (0, $7Bj8I.ScrollActionTypes).UPDATE_MAIN_SCROLL_TO_POSITION, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    if (!props.totalItems || props.totalPages < 2) return null;
    const onChangePage = (page)=>{
        props.setSearchQuery({
            page: page
        });
        if (scrollActionType) props.scrollUpdatePosition(scrollActionType, 0);
    };
    const renderFirstButton = ()=>{
        if (props.searchQuery.page <= 1) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm px-2",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                action: ()=>onChangePage(1),
                noPaddingX: true,
                children: [
                    " << ",
                    " ",
                    t("shared:first")
                ]
            })
        });
    };
    const renderLastButton = ()=>{
        if (props.searchQuery.page >= props.totalPages) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm px-2",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                action: ()=>onChangePage(props.totalPages),
                noPaddingX: true,
                children: [
                    t("shared:last"),
                    " >> "
                ]
            })
        });
    };
    const renderPreviousButton = ()=>{
        if (props.searchQuery.page <= 1) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm pl-2 pr-4",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                action: ()=>onChangePage(props.searchQuery.page - 1),
                noPaddingX: true,
                children: [
                    " < ",
                    " ",
                    t("shared:previous")
                ]
            })
        });
    };
    const renderNextButton = ()=>{
        if (props.searchQuery.page >= props.totalPages) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm pl-4 pr-2",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                action: ()=>onChangePage(props.searchQuery.page + 1),
                noPaddingX: true,
                children: [
                    t("shared:next"),
                    " > "
                ]
            })
        });
    };
    const renderPageLink = (pageNumber)=>{
        if (props.searchQuery.page == pageNumber) return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm",
                variant: (0, $jF0Xa.StyleVariants).GRAY,
                noHover: true,
                children: pageNumber
            })
        }, pageNumber);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ywbu.default), {
                className: "uppercase font-semibold text-sm",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                action: ()=>onChangePage(pageNumber),
                children: pageNumber
            })
        }, pageNumber);
    };
    const elipsis = /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "text-ch-blue-500",
        children: "\u2026"
    });
    const pageNumbers = Array.from({
        length: $628a6c4f4c342414$var$MaxPageElements
    }, (_, i)=>props.searchQuery.page - $628a6c4f4c342414$var$MaxPageOffset + i).filter((i)=>i > 0 && i <= props.totalPages);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex justify-center",
        children: [
            renderFirstButton(),
            renderPreviousButton(),
            !pageNumbers.includes(1) ? elipsis : null,
            pageNumbers.map((pageNumber)=>{
                return renderPageLink(pageNumber);
            }),
            !pageNumbers.includes(props.totalPages) ? elipsis : null,
            renderNextButton(),
            renderLastButton()
        ]
    });
};
const $628a6c4f4c342414$export$9e6a17cf56877796 = (dispatch)=>{
    return {
        scrollUpdatePosition: (type, position)=>dispatch((0, $2MEcG.scrollUpdatePosition)(type, position))
    };
};
var $628a6c4f4c342414$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $628a6c4f4c342414$export$9e6a17cf56877796)($628a6c4f4c342414$var$Pagination);

});

parcelRegister("lzBkr", function(module, exports) {

$parcel$export(module.exports, "fetchCasesAddableToMeetingsAsync", () => $35f73e7547d8717e$export$3c8ee6fc9e1f784e);

var $7YL61 = parcelRequire("7YL61");
const $35f73e7547d8717e$export$3c8ee6fc9e1f784e = (searchQuery)=>{
    return {
        type: (0, $7YL61.AddCaseToMeetingActionTypes).FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_PENDING,
        payload: searchQuery
    };
};

});



parcelRegister("Rsdju", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0aa862a9a41c6a5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $cOtzh = parcelRequire("cOtzh");

var $5v6Bi = parcelRequire("5v6Bi");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $4Z6GL = parcelRequire("4Z6GL");

var $daNS5 = parcelRequire("daNS5");

var $32kQ2 = parcelRequire("32kQ2");

var $d5eYa = parcelRequire("d5eYa");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $km7PZ = parcelRequire("km7PZ");

var $3YiLD = parcelRequire("3YiLD");

var $i4wYI = parcelRequire("i4wYI");

var $7qa36 = parcelRequire("7qa36");

var $iOv3Y = parcelRequire("iOv3Y");

var $2tEnG = parcelRequire("2tEnG");
const $b0aa862a9a41c6a5$var$MeetingHeader = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const [cancelModalIsOpen, setCancelModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [endModalIsOpen, setEndModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const liveMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_LIVE, {
        meetingId: props.meetingId
    });
    if (!meeting) return null;
    const renderStartOrJoinButton = ()=>{
        if (meeting?.status == (0, $32kQ2.MeetingStatuses).InProgress && meeting.permissions?.canJoin) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: liveMeetingUrl,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("meeting:joinMeeting")
        }, "2");
        else if (meeting?.status == (0, $32kQ2.MeetingStatuses).Scheduled) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>dispatch((0, $4Z6GL.startMeetingAction)(props.meetingId)),
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("meeting:startMeeting")
        }, "2");
        else return null;
    };
    const renderEditButton = ()=>{
        if (meeting?.status != (0, $32kQ2.MeetingStatuses).Scheduled || !meeting.permissions?.canEdit) return null;
        const editMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_EDIT, {
            meetingId: props.meetingId
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: editMeetingUrl,
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("meeting:editMeeting")
        }, "1");
    };
    const renderEndButton = ()=>{
        if (meeting?.status == (0, $32kQ2.MeetingStatuses).InProgress && meeting.permissions?.canEnd) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setEndModalIsOpen(true),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("meeting:endMeeting")
        }, "1");
        else return null;
    };
    const renderCancelButton = ()=>{
        if (meeting.permissions?.canCancel && meeting?.status == (0, $32kQ2.MeetingStatuses).Scheduled) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCancelModalIsOpen(true),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("meeting:cancelMeeting")
        }, "1");
        else return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                        breadcrumbs: [
                            {
                                pageTitle: t("shared:meetings"),
                                href: (0, $6QJY8.RoutePaths).MEETINGS
                            },
                            {
                                pageTitle: meeting.name
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOtzh.default), {
                        hasPermission: meeting?.permissions?.canTrackChanges,
                        action: ()=>{
                            dispatch((0, $iOv3Y.fetchAuditEventsAsync)("Meeting", props.meetingId));
                            dispatch((0, $i4wYI.toggleIsQuickViewOpen)(props.meetingId, true));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                                    className: "fill-current w-6 h-6",
                                    title: meeting.name
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daNS5.default), {
                                meetingId: props.meetingId,
                                hasLink: false,
                                showMeetingDueIn: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3Rc9I.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                                buttons: [
                                    renderCancelButton(),
                                    renderEditButton(),
                                    renderEndButton(),
                                    renderStartOrJoinButton()
                                ]
                            }),
                            meeting.status == (0, $32kQ2.MeetingStatuses).Ended && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-right",
                                children: t("meeting:meetingEnded")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $km7PZ.default), {
                meetingId: props.meetingId,
                isOpen: endModalIsOpen,
                close: ()=>setEndModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3YiLD.default), {
                meetingId: props.meetingId,
                isOpen: cancelModalIsOpen,
                close: ()=>setCancelModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2tEnG.default), {
                    meetingCaseId: props.meetingId,
                    meeting: meeting
                })
            })
        ]
    });
};
var $b0aa862a9a41c6a5$export$2e2bcd8739ae039 = $b0aa862a9a41c6a5$var$MeetingHeader;

});
parcelRegister("cOtzh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b00eba186387cf5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jitSV");
var $h5KXb = parcelRequire("h5KXb");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $aeos3 = parcelRequire("aeos3");
const $7b00eba186387cf5$var$ButtonChangeTracking = ({ variant: variant = (0, $jF0Xa.StyleVariants).BLUE, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const { changeTrackingEnabled: changeTrackingEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const defaultClasses = [
        "flex",
        "items-center",
        "justify-center",
        `bg-${variant}-500`,
        `hover:bg-${variant}-600`,
        "text-white",
        "uppercase",
        "w-8",
        "h-8",
        "font-light",
        "rounded-full",
        "md:px-4",
        "md:py-1",
        "md:w-auto",
        "md:h-auto",
        "self-start"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    if (!changeTrackingEnabled || !props.hasPermission) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        onClick: props.action,
        className: allClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden md:block",
                children: t("shared:changeTracking")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5KXb.default), {
                className: "fill-current w-6 h-6 md:ml-2",
                title: t("shared:changeTracking")
            })
        ]
    });
};
var $7b00eba186387cf5$export$2e2bcd8739ae039 = $7b00eba186387cf5$var$ButtonChangeTracking;

});

parcelRegister("daNS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e26d580a7485a2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $3QK3n = parcelRequire("3QK3n");

var $32kQ2 = parcelRequire("32kQ2");

var $1DXYh = parcelRequire("1DXYh");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $6t04b = parcelRequire("6t04b");

var $4VtCQ = parcelRequire("4VtCQ");

var $kN4w7 = parcelRequire("kN4w7");

var $5wJjW = parcelRequire("5wJjW");

var $7nrxt = parcelRequire("7nrxt");
const $a1e26d580a7485a2$var$MeetingDetails = ({ hasLink: hasLink = true, showCaseAndUserCount: showCaseAndUserCount = true, ...props })=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const coordinator = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getMeetingCoordinator)(state, props));
    if (!meeting) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: props.meetingId
    });
    const renderMeetingName = ()=>{
        const renderText = ()=>{
            if (!hasLink) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: meeting.name
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                href: meetingDetailsUrl,
                children: meeting.name
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: renderText()
            })
        });
    };
    const renderCoordinatorDetails = ()=>{
        if (!coordinator) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("meeting:Coordinator"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: coordinator.firstName,
                    lastName: coordinator.lastName,
                    isPending: coordinator.pending
                })
            ]
        });
    };
    const renderCaseAndUserCount = ()=>{
        if (!showCaseAndUserCount) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "mr-3",
                    children: [
                        meeting.users?.length,
                        " ",
                        t("share:users")
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        meeting.meetingCases?.length,
                        " ",
                        t("share:cases")
                    ]
                })
            ]
        });
    };
    const renderMeetingTimeToStart = ()=>{
        if (!props.showMeetingDueIn) return null;
        if (meeting.status !== (0, $32kQ2.MeetingStatuses).Scheduled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "text-ch-gray-alt-500",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                startDate: meeting.startDate
            })
        });
    };
    const renderMeetingStatus = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7nrxt.default), {
                meeting: meeting
            })
        });
    };
    const renderMdtTeamName = ()=>{
        if (!meeting.mdtTeam?.name) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("meeting:mdtMeeting:MDT"),
                ": ",
                meeting.mdtTeam?.name
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderMeetingName(),
                    renderMdtTeamName(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: meeting.specialtyName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                            startDate: meeting.startDate,
                            endDate: meeting.endDate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderCoordinatorDetails(),
                    renderCaseAndUserCount(),
                    renderMeetingStatus(),
                    renderMeetingTimeToStart()
                ]
            })
        ]
    });
};
var $a1e26d580a7485a2$export$2e2bcd8739ae039 = $a1e26d580a7485a2$var$MeetingDetails;

});
parcelRegister("7nrxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5831c5ff52f6902b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $32kQ2 = parcelRequire("32kQ2");
const $5831c5ff52f6902b$var$MeetingStatus = ({ meeting: meeting })=>{
    let status = meeting.status;
    if (status == (0, $32kQ2.MeetingStatuses).InProgress) status = "inProgress";
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            t("meeting:status"),
            ": ",
            t(`meeting:${status}`)
        ]
    });
};
var $5831c5ff52f6902b$export$2e2bcd8739ae039 = $5831c5ff52f6902b$var$MeetingStatus;

});


parcelRegister("km7PZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e34db15cfd73cd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");

var $4Z6GL = parcelRequire("4Z6GL");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");
const $95e34db15cfd73cd$var$MeetingEndModal = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const endMeeting = (meetingId)=>dispatch((0, $4Z6GL.endMeetingAction)(meetingId));
    if (!meeting) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const onClickEndMeeting = ()=>{
        endMeeting(meeting.id);
        props.close();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.close,
        style: (0, $jF0Xa.dialogueModalStyle),
        overlayClassName: "ReactModal__Overlay flex justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.close,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("meeting:endMeetingTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("meeting:endMeetingDesc")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: props.close,
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("shared:cancel")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>onClickEndMeeting(),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: t("meeting:endMeeting")
                        }, "2")
                    ]
                })
            ]
        })
    });
};
var $95e34db15cfd73cd$export$2e2bcd8739ae039 = $95e34db15cfd73cd$var$MeetingEndModal;

});

parcelRegister("3YiLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a0303af6fcbc82$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");

var $4Z6GL = parcelRequire("4Z6GL");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");
const $f1a0303af6fcbc82$var$MeetingCancelModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const cancelMeeting = (meetingId)=>dispatch((0, $4Z6GL.cancelMeetingAction)(meetingId));
    if (!meeting) return null;
    const onClickCancelMeeting = ()=>{
        cancelMeeting(meeting.id);
        props.close();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.close,
        style: (0, $jF0Xa.smallModalStyle),
        overlayClassName: "ReactModal__Overlay flex justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.close,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("meeting:cancelMeetingTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("meeting:cancelMeetingDesc")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: props.close,
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("shared:back")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>onClickCancelMeeting(),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: t("meeting:cancelMeeting")
                        }, "2")
                    ]
                })
            ]
        })
    });
};
var $f1a0303af6fcbc82$export$2e2bcd8739ae039 = $f1a0303af6fcbc82$var$MeetingCancelModal;

});

parcelRegister("i4wYI", function(module, exports) {

$parcel$export(module.exports, "toggleIsMenuOpen", () => $1eae95573b1ce2b8$export$1829dd2272381e79);
$parcel$export(module.exports, "toggleIsQuickViewOpen", () => $1eae95573b1ce2b8$export$b6ae61d406f631);

var $lkuVs = parcelRequire("lkuVs");
const $1eae95573b1ce2b8$export$1829dd2272381e79 = (isMenuOpen)=>{
    return {
        type: (0, $lkuVs.NavActionTypes).TOGGLE_IS_MENU_OPEN,
        payload: isMenuOpen
    };
};
const $1eae95573b1ce2b8$export$b6ae61d406f631 = (quickViewResourceId, isQuickViewOpen)=>{
    return {
        type: (0, $lkuVs.NavActionTypes).TOGGLE_IS_QUICK_VIEW_OPEN,
        payload: {
            quickViewResourceId: quickViewResourceId,
            isQuickViewOpen: isQuickViewOpen
        }
    };
};

});

parcelRegister("7qa36", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe004e760e8f7472$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $4KSAX = parcelRequire("4KSAX");

var $i4wYI = parcelRequire("i4wYI");
parcelRequire("jitSV");
var $chuvC = parcelRequire("chuvC");

var $kQILj = parcelRequire("kQILj");
const $fe004e760e8f7472$var$QuickView = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const isQuickViewOpen = (0, $iD0SF.useSelector)((0, $kQILj.getIsQuickViewOpen));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickClose = ()=>{
        dispatch((0, $i4wYI.toggleIsQuickViewOpen)(null, false));
    };
    (0, $acw62.useEffect)(()=>{
        return onClickClose;
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("py-8 px-3 bg-white shadow h-full sm:w-2/3 md:w-1/3 w-full overflow-y-scroll absolute z-30 top-0 right-0", {
            "hidden": !isQuickViewOpen
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    onClick: ()=>onClickClose(),
                    className: "text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chuvC.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:close")
                    })
                })
            }),
            props.children
        ]
    });
};
var $fe004e760e8f7472$export$2e2bcd8739ae039 = $fe004e760e8f7472$var$QuickView;

});

parcelRegister("iOv3Y", function(module, exports) {

$parcel$export(module.exports, "fetchAuditEventsAsync", () => $09e5b654297320cd$export$71737308c710d24d);

var $aBwAi = parcelRequire("aBwAi");
const $09e5b654297320cd$export$71737308c710d24d = (entityType, entityId)=>{
    return {
        type: (0, $aBwAi.AuditEventsActionTypes).FETCH_AUDIT_EVENTS_ASYNC_PENDING,
        payload: {
            entityType: entityType,
            entityId: entityId
        }
    };
};

});

parcelRegister("2tEnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c966431586827b24$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $6t04b = parcelRequire("6t04b");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jitSV");
var $h5KXb = parcelRequire("h5KXb");
var $18j2c = parcelRequire("18j2c");

var $7nrxt = parcelRequire("7nrxt");

var $3QK3n = parcelRequire("3QK3n");

var $5wJjW = parcelRequire("5wJjW");

var $32kQ2 = parcelRequire("32kQ2");

var $hMBTE = parcelRequire("hMBTE");
const $c966431586827b24$var$MeetingChangeTracking = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meetingCoordinator = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.meeting.coordinatorId));
    const renderMeetingTimeToStart = ()=>{
        if (props.meeting.status !== (0, $32kQ2.MeetingStatuses).Scheduled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
            className: "mb-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                startDate: props.meeting.startDate
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                            className: "fill-current w-6 h-6",
                            title: props.meeting.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: props.meeting.name
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                                    startDate: props.meeting.startDate,
                                    endDate: props.meeting.endDate
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-1",
                                children: [
                                    t("meeting:Coordinator"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                        firstName: meetingCoordinator.firstName,
                                        lastName: meetingCoordinator.lastName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7nrxt.default), {
                                    meeting: props.meeting
                                })
                            }),
                            renderMeetingTimeToStart()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5KXb.default), {
                        className: "fill-current w-6 h-6 md:ml-2",
                        title: t("shared:changeTracking")
                    }),
                    " ",
                    t("shared:changeTracking")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMBTE.AuditEventList), {
                entityId: props.meeting.id
            })
        ]
    });
};
var $c966431586827b24$export$2e2bcd8739ae039 = $c966431586827b24$var$MeetingChangeTracking;

});
parcelRegister("hMBTE", function(module, exports) {

$parcel$export(module.exports, "AuditEventList", () => $ea08462ab93d207f$export$6f0d04b3ed59910c);

var $ayMG0 = parcelRequire("ayMG0");

var $47LgA = parcelRequire("47LgA");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5PDlZ = parcelRequire("5PDlZ");
const $ea08462ab93d207f$export$6f0d04b3ed59910c = (props)=>{
    const auditEventsIds = (0, $iD0SF.useSelector)((state)=>(0, $5PDlZ.getAuditEventIdsByEntityId)(state, props.entityId));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: auditEventsIds.map((auditEventId, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47LgA.AuditEventListItem), {
                    auditEventId: auditEventId,
                    currentUserId: props.currentUserId
                }, index);
            })
        })
    });
};

});
parcelRegister("47LgA", function(module, exports) {

$parcel$export(module.exports, "AuditEventListItem", () => $537cf465bff02aec$export$46e9d4a592b898cc);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5PDlZ = parcelRequire("5PDlZ");

var $6lvMC = parcelRequire("6lvMC");

var $aBwAi = parcelRequire("aBwAi");

var $5pEeb = parcelRequire("5pEeb");

var $kQD56 = parcelRequire("kQD56");

var $jmptQ = parcelRequire("jmptQ");

var $7sP2W = parcelRequire("7sP2W");

var $fa4W4 = parcelRequire("fa4W4");
const $537cf465bff02aec$export$46e9d4a592b898cc = (props)=>{
    const auditEvent = (0, $iD0SF.useSelector)((state)=>(0, $5PDlZ.getAuditEventById)(state, props.auditEventId));
    const cardData = (0, $5pEeb.getAuditEventsCardData)(auditEvent);
    const headerUser = (0, $iD0SF.useSelector)((state)=>{
        if (cardData.headerUserId) return (0, $6lvMC.getUserById)(state, cardData.headerUserId);
        return null;
    });
    const byUser = (0, $iD0SF.useSelector)((state)=>{
        const userId = cardData.byUserId || auditEvent.createdById;
        if (userId) return (0, $6lvMC.getUserById)(state, userId);
        return null;
    });
    if (cardData.hideCard) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "my-2",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2", "flex", "rounded-md", "border-2", "bg-ch-blue-100"),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7sP2W.default), {
                    icon: cardData.iconContent.iconName,
                    color: cardData.iconContent.color || (0, $aBwAi.CardIconStyle).purpleColor
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "font-semibold",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmptQ.default), {
                                auditEvent: auditEvent,
                                user: headerUser,
                                headerText: cardData.headerText
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kQD56.default), {
                            auditEvent: auditEvent,
                            user: byUser
                        }),
                        cardData.body ? cardData.body : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa4W4.default), {
                            meetingId: cardData.meetingId
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("5PDlZ", function(module, exports) {

$parcel$export(module.exports, "getAuditEventIdsByEntityId", () => $cfd6646c7fa3f848$export$fd8ed631dac1a747);
$parcel$export(module.exports, "getAuditEventById", () => $cfd6646c7fa3f848$export$8f7f34fa45e37fd5);
const $cfd6646c7fa3f848$var$EMPTY_AUDIT_IDS = [];
const $cfd6646c7fa3f848$export$fd8ed631dac1a747 = (state, entityId)=>{
    return state.entities.auditEvents.allIdsByEntityId[entityId] || $cfd6646c7fa3f848$var$EMPTY_AUDIT_IDS;
};
const $cfd6646c7fa3f848$export$8f7f34fa45e37fd5 = (state, id)=>state.entities.auditEvents.byId[id];

});

parcelRegister("5pEeb", function(module, exports) {

$parcel$export(module.exports, "getAuditEventsCardData", () => $ddda555fb9c6bc59$export$b3e3ab186986fac5);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aBwAi = parcelRequire("aBwAi");

var $1sw8d = parcelRequire("1sw8d");

var $kMADP = parcelRequire("kMADP");

var $2Qg0w = parcelRequire("2Qg0w");

var $a8hwb = parcelRequire("a8hwb");

var $casVC = parcelRequire("casVC");

var $76D3U = parcelRequire("76D3U");

var $hhkzM = parcelRequire("hhkzM");

var $iPwMW = parcelRequire("iPwMW");
const $ddda555fb9c6bc59$var$getFileIconType = (fileType, color)=>{
    switch(fileType){
        case (0, $aBwAi.AuditEventDocumentTypes).PdfFile:
            return {
                iconName: "iconPdf",
                color: color
            };
        case (0, $aBwAi.AuditEventDocumentTypes).ImagePng:
        case (0, $aBwAi.AuditEventDocumentTypes).ImageJpeg:
            return {
                iconName: "iconImage",
                color: color
            };
    }
};
const $ddda555fb9c6bc59$var$getDocumentIconType = (fileType, eventType)=>{
    switch(eventType){
        case (0, $aBwAi.AuditAssetComponentTypes).documentAdded:
            return $ddda555fb9c6bc59$var$getFileIconType(fileType, (0, $aBwAi.CardIconStyle).purpleColor);
        case (0, $aBwAi.AuditAssetComponentTypes).documentRemoved:
            return $ddda555fb9c6bc59$var$getFileIconType(fileType, (0, $aBwAi.CardIconStyle).orangeColor);
    }
};
const $ddda555fb9c6bc59$var$getDocumentAddedHeaderText = (fileType)=>{
    return fileType.includes((0, $aBwAi.AuditEventDocumentTypes).PdfFile) ? "pdfAdded" : "imageAdded";
};
const $ddda555fb9c6bc59$var$getDocumentRemovedHeaderText = (fileType)=>{
    return fileType.includes((0, $aBwAi.AuditEventDocumentTypes).PdfFile) ? "pdfDeleted" : "imageDeleted";
};
const $ddda555fb9c6bc59$var$getDocumentAuditEventCardObj = (auditEvent, meetingId)=>{
    const documentAdded = auditEvent.eventType == (0, $aBwAi.AuditAssetComponentTypes).documentAdded;
    const fileType = auditEvent.eventData?.data?.fileType;
    if (auditEvent.eventData.data) return {
        iconContent: $ddda555fb9c6bc59$var$getDocumentIconType(fileType, auditEvent.eventType),
        headerText: documentAdded ? $ddda555fb9c6bc59$var$getDocumentAddedHeaderText(fileType) : $ddda555fb9c6bc59$var$getDocumentRemovedHeaderText(fileType),
        body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
            header: "title",
            content: auditEvent.eventData.data.name
        }),
        meetingId: meetingId
    };
    else return {
        iconContent: {
            iconName: "iconTask"
        },
        headerText: documentAdded ? "documentAdded" : "documentRemoved",
        meetingId: meetingId
    };
};
const $ddda555fb9c6bc59$var$ignoreCard = {
    iconContent: null,
    headerUserId: null,
    byUserId: null,
    hideCard: true
};
const $ddda555fb9c6bc59$export$b3e3ab186986fac5 = (auditEvent)=>{
    switch(auditEvent.eventType){
        // Meeting auditEvents cards
        case (0, $aBwAi.AuditAssetComponentTypes).meetingCreated:
            return {
                iconContent: {
                    iconName: "iconMeeting"
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingUserAdded:
            return {
                iconContent: {
                    iconName: "iconUser"
                },
                headerUserId: auditEvent.eventData.data.userId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingUserRemoved:
            return {
                iconContent: {
                    iconName: "iconUser",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                },
                headerUserId: auditEvent.eventData.data.userId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingCaseAdded:
            {
                const meetingId = auditEvent.eventData.changes?.meetingId ? auditEvent.eventData.changes?.meetingId[1] : null;
                return {
                    iconContent: {
                        iconName: "iconFolder"
                    },
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).meetingCaseRemoved:
            {
                const meetingId = auditEvent.eventData.changes?.meetingId ? auditEvent.eventData.changes.meetingId : null;
                return {
                    iconContent: {
                        iconName: "iconFolder",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).meetingedited:
            return {
                iconContent: {
                    iconName: "iconMeeting",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Qg0w.default), {
                    auditEvent: auditEvent
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingInProgress:
            return {
                iconContent: {
                    iconName: "iconVideoOn"
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingUserJoined:
            return {
                iconContent: {
                    iconName: "iconUser"
                },
                headerUserId: auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingUserLeft:
            return {
                iconContent: {
                    iconName: "iconUser",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                },
                headerUserId: auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingPresenterAssigned:
            return {
                iconContent: {
                    iconName: "iconPresenter"
                },
                headerUserId: auditEvent.eventData.subjectId,
                hideCard: !auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingPresenterAccepted:
            return {
                iconContent: {
                    iconName: "iconPresenter"
                },
                headerUserId: auditEvent.createdById,
                byUserId: auditEvent.eventData.subjectId,
                hideCard: !auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingSelectedCase:
            return {
                iconContent: {
                    iconName: "iconFolder"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iPwMW.default), {
                    meetingCaseId: auditEvent.eventData.subjectId
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingScribeAssigned:
            return {
                iconContent: {
                    iconName: "iconScribe"
                },
                headerUserId: auditEvent.eventData.subjectId,
                hideCard: !auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingScribeAccepted:
            return {
                iconContent: {
                    iconName: "iconScribe"
                },
                headerUserId: auditEvent.createdById,
                byUserId: auditEvent.eventData.subjectId,
                hideCard: !auditEvent.eventData.subjectId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingEnded:
            return {
                iconContent: {
                    iconName: "iconMeeting",
                    color: (0, $aBwAi.CardIconStyle).grayColor
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).meetingCancelled:
            return {
                iconContent: {
                    iconName: "iconMeeting",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                }
            };
        // MeetingCase auditEvent cards
        case (0, $aBwAi.AuditAssetComponentTypes).commentAdd:
            {
                const meetingId = auditEvent.eventData.changes.meetingId ? auditEvent.eventData.changes.meetingId[1] : null;
                return {
                    iconContent: {
                        iconName: "iconComment"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: auditEvent.eventData.changes.title[1]
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).commentRemove:
            {
                const changes = auditEvent.eventData.changes.title;
                const meetingId = auditEvent.eventData.changes?.meetingId;
                return {
                    iconContent: {
                        iconName: "iconComment",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: changes
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).decision:
            {
                const meetingId = auditEvent.eventData.changes.meetingId ? auditEvent.eventData.changes.meetingId[1] : null;
                return {
                    iconContent: {
                        iconName: "iconHandshake"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: auditEvent.eventData.changes.title[1]
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).documentAdded:
            {
                const meetingId = auditEvent.entityType == (0, $aBwAi.AuditEventTypes).CASE ? auditEvent.eventData.data?.meetingId : null;
                return $ddda555fb9c6bc59$var$getDocumentAuditEventCardObj(auditEvent, meetingId);
            }
        case (0, $aBwAi.AuditAssetComponentTypes).documentRemoved:
            {
                const meetingId = auditEvent.entityType == (0, $aBwAi.AuditEventTypes).CASE ? auditEvent.eventData.data?.meetingId : null;
                return $ddda555fb9c6bc59$var$getDocumentAuditEventCardObj(auditEvent, meetingId);
            }
        case (0, $aBwAi.AuditAssetComponentTypes).linkAdded:
            {
                const meetingId = auditEvent.eventData.changes.meetingId ? auditEvent.eventData.changes.meetingId[1] : null;
                return {
                    iconContent: {
                        iconName: "iconLink"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: auditEvent.eventData.changes.title[1]
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).linkRemoved:
            {
                const changes = auditEvent.eventData.changes.title;
                const meetingId = auditEvent.eventData.changes.meetingId;
                return {
                    iconContent: {
                        iconName: "iconLink",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: changes
                    }),
                    meetingId: meetingId
                };
            }
        // Meeting and Case AuditEvents
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationSaved:
            {
                const meetingId = auditEvent.eventData.data?.meetingId ? auditEvent.eventData.data?.meetingId : null;
                return {
                    iconContent: {
                        iconName: "iconRecommendation"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "status",
                        content: "complete",
                        translateText: true
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).caseReportGenerated:
            {
                const meetingId = auditEvent.eventData.data?.meetingId ? auditEvent.eventData.data?.meetingId : null;
                return {
                    iconContent: {
                        iconName: "iconPdf",
                        color: (0, $aBwAi.CardIconStyle).blueColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "title",
                        content: auditEvent.eventData.data.name
                    }),
                    meetingId: meetingId
                };
            }
        // Meeting AuditEvents cards --> assets from/To meetingAssets
        case (0, $aBwAi.AuditAssetComponentTypes).commentSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconComment"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    title: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).commentRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconComment",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        title: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).decisionSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconHandshake"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    title: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).decisionRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconHandshake",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        title: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconRecommendation"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    title: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconRecommendation",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        title: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).casereportSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconPdf"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    title: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).casereportRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconPdf",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        title: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).imageSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconImage"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    name: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).imageRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconImage",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        name: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).pdfSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconPdf"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    name: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).pdfRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconPdf",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        name: true
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).linkSelectedToMeetingAssets:
            return {
                iconContent: {
                    iconName: "iconLink"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                    assetId: auditEvent.eventData.changes.caseAssetId[1],
                    title: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).linkRemovedFromMeetingAssets:
            {
                const assetId = auditEvent.eventData.changes.caseAssetId;
                return {
                    iconContent: {
                        iconName: "iconLink",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8hwb.default), {
                        assetId: assetId,
                        title: true
                    })
                };
            }
        // Meeting, MeetingCase and Case auditEvents cards
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationAdded:
            {
                const meetingData = auditEvent.eventData.data;
                const meetingId = auditEvent.eventData.changes?.meetingId ? auditEvent.eventData.changes.meetingId[1] : null;
                const recommendationStatus = auditEvent.eventData?.changes?.recommendationStatus[1];
                if (auditEvent.entityType == (0, $aBwAi.AuditEventTypes).MEETING && meetingData.recommendationStatus == "pending") return $ddda555fb9c6bc59$var$ignoreCard;
                const meetingCaseId = meetingData?.meetingCaseId;
                if (meetingCaseId) return {
                    iconContent: {
                        iconName: "iconMeeting"
                    },
                    body: meetingCaseId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iPwMW.default), {
                        meetingCaseId: meetingCaseId
                    }) : null,
                    meetingId: meetingId
                };
                else return {
                    iconContent: {
                        iconName: "iconRecommendation"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                        header: "status",
                        content: recommendationStatus,
                        translateText: true
                    }),
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationApproved:
            {
                const meetingId = auditEvent.eventData.data?.meetingId ? auditEvent.eventData.data?.meetingId : null;
                return {
                    iconContent: {
                        iconName: "iconAccept",
                        color: (0, $aBwAi.CardIconStyle).greenColor
                    },
                    body: auditEvent.eventData.changes?.consentById ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hhkzM.default), {
                        auditEvent: auditEvent
                    }) : null,
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationRejected:
            {
                const meetingId = auditEvent.eventData.data?.meetingId ? auditEvent.eventData.data?.meetingId : null;
                return {
                    iconContent: {
                        iconName: "iconReject",
                        color: (0, $aBwAi.CardIconStyle).redColor
                    },
                    body: auditEvent.eventData.changes?.consentById ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hhkzM.default), {
                        auditEvent: auditEvent
                    }) : null,
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).recommendationUpdated:
            return {
                iconContent: {
                    iconName: "iconMeeting"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76D3U.default), {
                    header: "status",
                    content: "final",
                    translateText: true
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).deferralAdded:
            {
                const meetingId = auditEvent.eventData.changes?.meetingId ? auditEvent.eventData.changes?.meetingId[1] : null;
                return {
                    iconContent: {
                        iconName: "iconDeferral"
                    },
                    meetingId: meetingId
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).meetingCaseDeferred:
            {
                const meetingCaseId = auditEvent.eventData.data?.meetingCaseId ? auditEvent.eventData.data?.meetingCaseId : null;
                if (auditEvent.entityType == (0, $aBwAi.AuditEventTypes).CASE) return $ddda555fb9c6bc59$var$ignoreCard;
                return {
                    iconContent: {
                        iconName: "iconDeferral"
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iPwMW.default), {
                        meetingCaseId: meetingCaseId
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).caseMemberAdded:
            return {
                iconContent: {
                    iconName: "iconUser"
                },
                headerUserId: auditEvent.eventData.data.userId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).caseMemberRemoved:
            return {
                iconContent: {
                    iconName: "iconUser",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                },
                headerUserId: auditEvent.eventData.data.userId
            };
        case (0, $aBwAi.AuditAssetComponentTypes).caseCreated:
            return {
                iconContent: {
                    iconName: "iconFolder"
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).caseUpdated:
            return {
                iconContent: {
                    iconName: "iconFolder",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMADP.default), {
                    auditEvent: auditEvent
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).caseLocked:
            return {
                iconContent: {
                    iconName: "iconLock"
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).caseUnlocked:
            return {
                iconContent: {
                    iconName: "iconLock",
                    color: (0, $aBwAi.CardIconStyle).orangeColor
                }
            };
        // User AuditEvent Cards
        case (0, $aBwAi.AuditAssetComponentTypes).userEdited:
            return {
                iconContent: {
                    iconName: "iconUser"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sw8d.default), {
                    auditEvent: auditEvent
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).userAddSpecialty:
            return {
                iconContent: {
                    iconName: "iconUser"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $casVC.default), {
                    specialtyId: auditEvent.eventData.changes.specialtyId[1]
                })
            };
        case (0, $aBwAi.AuditAssetComponentTypes).userRemoveSpecialty:
            {
                const specialtyId = auditEvent.eventData.changes.specialtyId;
                return {
                    iconContent: {
                        iconName: "iconUser",
                        color: (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $casVC.default), {
                        specialtyId: specialtyId
                    })
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).userCreated:
            return {
                iconContent: {
                    iconName: "iconUser",
                    color: (0, $aBwAi.CardIconStyle).grayColor
                }
            };
        case (0, $aBwAi.AuditAssetComponentTypes).userStatus:
            {
                const active = auditEvent.eventData.changes?.active[1];
                return {
                    iconContent: {
                        iconName: "iconUser",
                        color: active ? (0, $aBwAi.CardIconStyle).purpleColor : (0, $aBwAi.CardIconStyle).orangeColor
                    },
                    headerText: active ? "userActivated" : "userDisabled"
                };
            }
        case (0, $aBwAi.AuditAssetComponentTypes).userActivated:
            return {
                iconContent: {
                    iconName: "iconUser"
                }
            };
        default:
            return $ddda555fb9c6bc59$var$ignoreCard;
    }
};

});
parcelRegister("1sw8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $24179ec15eb25d1c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $jfh8i = parcelRequire("jfh8i");
const $24179ec15eb25d1c$var$AuditEventUserEditedCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const getTitle = ()=>{
        const title = props.auditEvent.eventData.changes.title;
        if (!title) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:titleChanged"),
            originalProp: title[0],
            changedProp: title[1]
        });
    };
    const getProfessionalTitle = ()=>{
        const professionalTitle = props.auditEvent.eventData.changes.professionalTitle;
        if (!professionalTitle) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:professionalTitleChanged"),
            originalProp: professionalTitle[0],
            changedProp: professionalTitle[1]
        });
    };
    const getFirstName = ()=>{
        const firstName = props.auditEvent.eventData.changes.firstName;
        if (!firstName) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:firstNameChanged"),
            originalProp: firstName[0],
            changedProp: firstName[1]
        });
    };
    const getLastName = ()=>{
        const lastName = props.auditEvent.eventData.changes.lastName;
        if (!lastName) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:lastNameChanged"),
            originalProp: lastName[0],
            changedProp: lastName[1]
        });
    };
    const getEmail = ()=>{
        const email = props.auditEvent.eventData.changes.email;
        if (!email) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:emailChaged"),
            originalProp: email[0],
            changedProp: email[1]
        });
    };
    const getRoles = ()=>{
        const roles = props.auditEvent.eventData.changes.roles;
        const getRolesString = (roles)=>{
            const translatedRoles = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(roles, (role)=>{
                return t(`auditEvent:${role}`);
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).join(translatedRoles, ", ");
        };
        if (!roles) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: t("auditEvent:rolesChaged"),
            originalProp: getRolesString(roles[0]),
            changedProp: getRolesString(roles[1])
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            getTitle(),
            getProfessionalTitle(),
            getFirstName(),
            getLastName(),
            getEmail(),
            getRoles()
        ]
    });
};
var $24179ec15eb25d1c$export$2e2bcd8739ae039 = $24179ec15eb25d1c$var$AuditEventUserEditedCard;

});
parcelRegister("jfh8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $172aa2a54a2d5c4f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $4qaeN = parcelRequire("4qaeN");
const $172aa2a54a2d5c4f$var$AuditEventSubCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "block font-semibold",
                children: t(`auditEvent:${props.title}`)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "block",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "block",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold",
                                children: t("auditEvent:original")
                            }),
                            ":\xa0",
                            props.originalProp
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "block",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold",
                                children: t("auditEvent:change")
                            }),
                            ":\xa0",
                            props.changedProp
                        ]
                    })
                ]
            })
        ]
    });
};
var $172aa2a54a2d5c4f$export$2e2bcd8739ae039 = $172aa2a54a2d5c4f$var$AuditEventSubCard;

});


parcelRegister("kMADP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1036ff663ddb639e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $eUISl = parcelRequire("eUISl");

var $jxnLW = parcelRequire("jxnLW");

var $jfh8i = parcelRequire("jfh8i");

var $6lvMC = parcelRequire("6lvMC");
const $1036ff663ddb639e$var$AuditEventCaseEditedCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const caseClassificationIds = props.auditEvent.eventData?.changes?.caseClassificationId;
    const oldClassification = (0, $iD0SF.useSelector)((state)=>caseClassificationIds ? (0, $jxnLW.getCaseClassificationById)(state, caseClassificationIds[0]) : null);
    const newClassification = (0, $iD0SF.useSelector)((state)=>caseClassificationIds ? (0, $jxnLW.getCaseClassificationById)(state, caseClassificationIds[1]) : null);
    const leadCareUserIds = props.auditEvent.eventData?.changes?.leadCareUserId;
    const oldLeadCareUser = (0, $iD0SF.useSelector)((state)=>leadCareUserIds ? (0, $6lvMC.getUserById)(state, leadCareUserIds[0]) : null);
    const newLeadCareUser = (0, $iD0SF.useSelector)((state)=>leadCareUserIds ? (0, $6lvMC.getUserById)(state, leadCareUserIds[1]) : null);
    const getSignedOffBy = ()=>{
        const signedOffBy = props.auditEvent.eventData.changes.signedOffBy;
        if (!signedOffBy) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseSignedOffByChanged",
            originalProp: signedOffBy[0],
            changedProp: signedOffBy[1]
        });
    };
    const getTargetDateFulfilled = ()=>{
        const targetDateFulfilled = props.auditEvent.eventData.changes.targetDateFulfilled;
        if (!targetDateFulfilled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseTargetDateFulfilledChanged",
            originalProp: targetDateFulfilled[0] ? t("auditEvent:targetDateFulfilled") : t("auditEvent:targetDateNotFulfilled"),
            changedProp: targetDateFulfilled[1] ? t("auditEvent:targetDateFulfilled") : t("auditEvent:targetDateNotFulfilled")
        });
    };
    const getTargetDate = ()=>{
        const targetDate = props.auditEvent.eventData.changes.targetDate;
        if (!targetDate) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseTargetDateChanged",
            originalProp: targetDate[0] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                utcTime: targetDate[0]
            }, 0) : "-",
            changedProp: targetDate[1] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                utcTime: targetDate[1]
            }, 1) : "-"
        });
    };
    const getLeadCaseUser = ()=>{
        if (!leadCareUserIds) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseleadChanged",
            originalProp: oldLeadCareUser ? `${oldLeadCareUser.firstName} ${oldLeadCareUser.lastName}` : "",
            changedProp: newLeadCareUser ? `${newLeadCareUser.firstName} ${newLeadCareUser.lastName}` : ""
        });
    };
    const getCaseType = ()=>{
        const caseType = props.auditEvent.eventData.changes.caseType;
        if (!caseType) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseTypeChanged",
            originalProp: caseType[0],
            changedProp: caseType[1]
        });
    };
    const getCaseClassification = ()=>{
        if (!caseClassificationIds) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
            title: "caseClassificationChanged",
            originalProp: oldClassification?.name ?? "",
            changedProp: newClassification?.name ?? ""
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            getCaseType(),
            getCaseClassification(),
            getLeadCaseUser(),
            getTargetDate(),
            getTargetDateFulfilled(),
            getSignedOffBy()
        ]
    });
};
var $1036ff663ddb639e$export$2e2bcd8739ae039 = $1036ff663ddb639e$var$AuditEventCaseEditedCard;

});
parcelRegister("jxnLW", function(module, exports) {

$parcel$export(module.exports, "getAllCaseClassifications", () => $7e89247643bd9880$export$2312e472e4f7fcbc);
$parcel$export(module.exports, "getCaseClassificationById", () => $7e89247643bd9880$export$e787647ae726139a);
const $7e89247643bd9880$export$2312e472e4f7fcbc = (state)=>state.entities.caseClassification.byId;
const $7e89247643bd9880$export$78c95f64e3760a12 = (state)=>state.entities.caseClassification.allIds;
const $7e89247643bd9880$export$e787647ae726139a = (state, id)=>state.entities.caseClassification.byId[id];

});


parcelRegister("2Qg0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d3679cf4fa1d5c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4qaeN = parcelRequire("4qaeN");

var $7hl6H = parcelRequire("7hl6H");

var $6lvMC = parcelRequire("6lvMC");

var $aBwAi = parcelRequire("aBwAi");

var $1XBbO = parcelRequire("1XBbO");

var $jfh8i = parcelRequire("jfh8i");
const $92d3679cf4fa1d5c$var$AuditEventMeetingEditedCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const eventData = props.auditEvent.eventData;
    const changes = eventData.changes;
    const coordinatorIds = changes.coordinatorId;
    const oldCoordinator = (0, $iD0SF.useSelector)((state)=>coordinatorIds ? (0, $6lvMC.getUserById)(state, coordinatorIds[0]) : null);
    const newCoordinator = (0, $iD0SF.useSelector)((state)=>coordinatorIds ? (0, $6lvMC.getUserById)(state, coordinatorIds[1]) : null);
    const getUserName = (user)=>{
        if (!user) return "";
        return `${user.firstName} ${user.lastName}`;
    };
    const auditEventCardDateChangeObject = (eventData)=>{
        const startDate = eventData.changes.startDate;
        const endDate = eventData.changes.endDate;
        const currentStartDate = eventData.data.currentStartDate;
        const currentEndDate = eventData.data.currentEndDate;
        if (startDate == null) return {
            original: {
                startDate: currentStartDate,
                endDate: endDate[0]
            },
            changed: {
                startDate: (0, $aBwAi.CardObjectTypes).noChangeInTime,
                endDate: endDate[1]
            },
            duration: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1XBbO.AuditEventDurationLabel), {
                startTime: currentStartDate,
                endTime: endDate[1]
            })
        };
        if (endDate == null) return {
            original: {
                startDate: startDate[0],
                endDate: currentEndDate
            },
            changed: {
                startDate: startDate[1],
                endDate: (0, $aBwAi.CardObjectTypes).noChangeInTime
            },
            duration: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1XBbO.AuditEventDurationLabel), {
                startTime: startDate[1],
                endTime: currentEndDate
            })
        };
        return {
            original: {
                startDate: startDate[0],
                endDate: endDate[0]
            },
            changed: {
                startDate: startDate[1],
                endDate: endDate[1]
            },
            duration: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1XBbO.AuditEventDurationLabel), {
                startTime: startDate[1],
                endTime: endDate[1]
            })
        };
    };
    if (!eventData.data) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            changes.name ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
                title: "titleChanged",
                originalProp: changes.name[0],
                changedProp: changes.name[1]
            }) : null,
            changes.specialtyId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
                title: "specialtyChanged",
                originalProp: eventData.data.previousSpecialtyName,
                changedProp: eventData.data.currentSpecialtyName
            }) : null,
            changes.coordinatorId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfh8i.default), {
                title: "coordinatorChanged",
                originalProp: getUserName(oldCoordinator),
                changedProp: getUserName(newCoordinator)
            }) : null,
            changes.startDate || changes.endDate ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-semibold",
                        children: t("auditEvent:meetingDateTimeChange")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "my-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold",
                                children: t("auditEvent:original")
                            }),
                            ":\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-semibold",
                                        children: t("auditEvent:StartTime")
                                    }),
                                    ":\xa0",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: auditEventCardDateChangeObject(eventData).original.startDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-semibold",
                                        children: t("auditEvent:EndTime")
                                    }),
                                    ":\xa0",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: auditEventCardDateChangeObject(eventData).original.endDate
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold",
                                children: t("auditEvent:change")
                            }),
                            ":\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-semibold",
                                        children: t("auditEvent:StartTime")
                                    }),
                                    ":\xa0",
                                    auditEventCardDateChangeObject(eventData).changed.startDate == (0, $aBwAi.CardObjectTypes).noChangeInTime ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: t("auditEvent:noChanges")
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: auditEventCardDateChangeObject(eventData).changed.startDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-semibold",
                                        children: t("auditEvent:EndTime")
                                    }),
                                    ":\xa0",
                                    auditEventCardDateChangeObject(eventData).changed.endDate == (0, $aBwAi.CardObjectTypes).noChangeInTime ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: t("auditEvent:noChanges")
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: auditEventCardDateChangeObject(eventData).changed.endDate
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold self-center",
                                children: t("auditEvent:duration")
                            }),
                            ":\xa0",
                            auditEventCardDateChangeObject(eventData).duration
                        ]
                    })
                ]
            }) : null
        ]
    });
};
var $92d3679cf4fa1d5c$export$2e2bcd8739ae039 = $92d3679cf4fa1d5c$var$AuditEventMeetingEditedCard;

});
parcelRegister("1XBbO", function(module, exports) {

$parcel$export(module.exports, "AuditEventDurationLabel", () => $fdbecf0e60e37463$export$5bcc4813df390dcd);

var $ayMG0 = parcelRequire("ayMG0");

var $6OX6Q = parcelRequire("6OX6Q");
var $8xDhD = parcelRequire("8xDhD");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $fdbecf0e60e37463$export$5bcc4813df390dcd = ({ startTime: startTime, endTime: endTime })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const duration = ()=>{
        const start = new Date(startTime), endDate = new Date(endTime), end = endDate <= start ? (0, $6OX6Q.default)(endDate, 1) : endDate;
        const diff = (0, $8xDhD.default)(end, start);
        const hours = Math.floor(diff / 3600);
        const minutes = Math.floor((diff - 3600 * hours) / 60);
        let str = "";
        if (hours > 0) str = hours + t("h");
        if (hours > 0 && minutes > 0) str += " ";
        if (minutes > 0) str += minutes + t("min");
        return str;
    };
    if (!startTime || !endTime) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: duration()
    });
};

});


parcelRegister("a8hwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3feb4840a3eda9e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lxTgp = parcelRequire("lxTgp");
const $f3feb4840a3eda9e$var$AuditEventMeetingAssetDetail = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const meetingCaseAsset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const getAssetTitle = ()=>{
        const asset = meetingCaseAsset.asset;
        return asset.title;
    };
    const getAssetName = ()=>{
        const asset = meetingCaseAsset.asset;
        return asset.name;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "font-semibold",
                children: [
                    t("auditEvent:title"),
                    ":\xa0"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "break-all",
                children: props.title ? getAssetTitle() : getAssetName()
            })
        ]
    });
};
var $f3feb4840a3eda9e$export$2e2bcd8739ae039 = $f3feb4840a3eda9e$var$AuditEventMeetingAssetDetail;

});

parcelRegister("casVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd1c46d11abda24c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lqbsE = parcelRequire("lqbsE");
const $cd1c46d11abda24c$var$AuditEventSpecialtyName = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const specialty = (0, $iD0SF.useSelector)((state)=>(0, $lqbsE.getSpecialtyById)(state, props.specialtyId));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "font-semibold",
                children: t("auditEvent:specialtyName")
            }),
            ":\xa0",
            specialty.name
        ]
    });
};
var $cd1c46d11abda24c$export$2e2bcd8739ae039 = $cd1c46d11abda24c$var$AuditEventSpecialtyName;

});

parcelRegister("76D3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afa6f07ac7bf035$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $7afa6f07ac7bf035$var$AuditEventBodyContent = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "font-semibold",
                children: [
                    t(`auditEvent:${props.header}`),
                    ":\xa0"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "break-all",
                children: props.translateText ? t(`auditEvent:${props.content}`) : props.content
            })
        ]
    });
};
var $7afa6f07ac7bf035$export$2e2bcd8739ae039 = $7afa6f07ac7bf035$var$AuditEventBodyContent;

});

parcelRegister("hhkzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc755ebd6599cdb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");
const $bbc755ebd6599cdb$var$AuditEventConsentOnBehalf = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.auditEvent.eventData.changes.userId[1]));
    if (props.auditEvent.eventData.changes.consentById[1] === props.auditEvent.eventData.changes.userId[1]) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "font-semibold",
                children: t("auditEvent:onBehalfOf")
            }),
            ":\xa0",
            user.firstName,
            "\xa0",
            user.lastName
        ]
    });
};
var $bbc755ebd6599cdb$export$2e2bcd8739ae039 = $bbc755ebd6599cdb$var$AuditEventConsentOnBehalf;

});

parcelRegister("iPwMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $84e678defdb18fca$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4VtCQ = parcelRequire("4VtCQ");

var $kon2z = parcelRequire("kon2z");

var $6t04b = parcelRequire("6t04b");
const $84e678defdb18fca$var$AuditEventCaseName = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const selectedMeetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, props));
    const caseData = (0, $iD0SF.useSelector)((state)=>{
        const caseId = selectedMeetingCase?.case;
        if (caseId) return (0, $kon2z.getCaseById)(state, {
            caseId: caseId
        });
        return null;
    });
    if (!caseData) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "font-semibold",
        children: [
            t("shared:case"),
            ":\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                firstName: caseData.firstName,
                lastName: caseData.lastName,
                title: caseData.title,
                gender: caseData.gender
            })
        ]
    });
};
var $84e678defdb18fca$export$2e2bcd8739ae039 = $84e678defdb18fca$var$AuditEventCaseName;

});


parcelRegister("kQD56", function(module, exports) {

$parcel$export(module.exports, "default", () => $96526b83694c8100$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $k5WIK = parcelRequire("k5WIK");

var $7hl6H = parcelRequire("7hl6H");

var $aBwAi = parcelRequire("aBwAi");
const $96526b83694c8100$var$AuditEventByUserNameAndDate = (props)=>{
    const textAuthorDetailsWithoutName = props.auditEvent.eventType in (0, $aBwAi.AuditEventsWithTimeOnly);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: textAuthorDetailsWithoutName ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "capitalize",
                    children: t("shared:on")
                }),
                "\xa0",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: props.auditEvent.createdAt
                })
            ]
        }) : props.user ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k5WIK.default), {
            firstName: props.user.firstName,
            lastName: props.user.lastName,
            createdAt: props.auditEvent.createdAt
        }) : null
    });
};
var $96526b83694c8100$export$2e2bcd8739ae039 = $96526b83694c8100$var$AuditEventByUserNameAndDate;

});

parcelRegister("jmptQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd862335776fd76$export$2e2bcd8739ae039);

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");
const $ccd862335776fd76$var$AuditEventCardHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "auditEvent"
    ]);
    const headerText = props.headerText ? props.headerText : (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.auditEvent.eventType);
    if (props.user) return t(`auditEvent:${headerText}`, {
        user: `${props.user.firstName} ${props.user.lastName}`
    });
    return t(`auditEvent:${headerText}`);
};
var $ccd862335776fd76$export$2e2bcd8739ae039 = $ccd862335776fd76$var$AuditEventCardHeader;

});

parcelRegister("7sP2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd349c320a5dbafa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
var $hHsFn = parcelRequire("hHsFn");
var $2D4bH = parcelRequire("2D4bH");
var $6Hpf8 = parcelRequire("6Hpf8");
var $fllUo = parcelRequire("fllUo");
var $fioxl = parcelRequire("fioxl");
var $e11eN = parcelRequire("e11eN");
var $8lynw = parcelRequire("8lynw");
var $18j2c = parcelRequire("18j2c");
var $e1x9J = parcelRequire("e1x9J");
var $80TYb = parcelRequire("80TYb");
var $lx7Y0 = parcelRequire("lx7Y0");
var $4e1aD = parcelRequire("4e1aD");
var $3NuIO = parcelRequire("3NuIO");
var $dIfKX = parcelRequire("dIfKX");
var $chRXN = parcelRequire("chRXN");
var $7eN5N = parcelRequire("7eN5N");

var $aBwAi = parcelRequire("aBwAi");
const $dd349c320a5dbafa$var$AuditEventCardIcon = (props)=>{
    const iconComponents = {
        iconAccept: (0, $ij7yF.default),
        iconRecommendation: (0, $lx7Y0.default),
        iconComment: (0, $hHsFn.default),
        iconHandshake: (0, $fllUo.default),
        iconImage: (0, $fioxl.default),
        iconLink: (0, $e11eN.default),
        iconPdf: (0, $e1x9J.default),
        iconReject: (0, $4e1aD.default),
        iconUser: (0, $chRXN.default),
        iconFolder: (0, $6Hpf8.default),
        iconMeeting: (0, $18j2c.default),
        iconLock: (0, $8lynw.default),
        iconTask: (0, $dIfKX.default),
        iconVideoOn: (0, $7eN5N.default),
        iconPresenter: (0, $80TYb.default),
        iconScribe: (0, $3NuIO.default),
        iconDeferral: (0, $2D4bH.default)
    };
    const IconComponent = iconComponents[`${props.icon}`];
    const color = props.color || (0, $aBwAi.CardIconStyle).purpleColor;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconComponent, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((0, $aBwAi.CardIconStyle).imageStyle, color)
        })
    });
};
var $dd349c320a5dbafa$export$2e2bcd8739ae039 = $dd349c320a5dbafa$var$AuditEventCardIcon;

});

parcelRegister("fa4W4", function(module, exports) {

$parcel$export(module.exports, "default", () => $725e8535f59daeb3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7hl6H = parcelRequire("7hl6H");

var $4VtCQ = parcelRequire("4VtCQ");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");
const $725e8535f59daeb3$var$AuditEventMeetingDetail = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    if (!meeting) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center my-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-purple-500 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                    className: "w-5 h-5",
                    title: meeting.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "font-thin",
                children: [
                    meeting.name,
                    " - ",
                    meeting.specialtyName,
                    " - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                        utcTime: meeting.startDate
                    })
                ]
            })
        ]
    });
};
var $725e8535f59daeb3$export$2e2bcd8739ae039 = $725e8535f59daeb3$var$AuditEventMeetingDetail;

});





parcelRegister("4MSTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e987c355103511eb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $4qaeN = parcelRequire("4qaeN");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $6EQca = parcelRequire("6EQca");

var $5xpc0 = parcelRequire("5xpc0");

var $7SwiO = parcelRequire("7SwiO");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");
const $e987c355103511eb$var$MeetingInvitation = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const meetingUser = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUserByCurrentUserId)(state, props.meetingId));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const updateMeetingUser = (meetingUserId, meetingUser)=>dispatch((0, $7SwiO.updateMeetingUserAction)(meetingUserId, meetingUser));
    const acceptInvitation = ()=>{
        updateMeetingUser(meetingUser.id, {
            ...meetingUser,
            acceptanceResponse: (0, $5xpc0.AcceptanceResponses).Accepted
        });
    };
    const rejectInvitation = ()=>{
        updateMeetingUser(meetingUser.id, {
            ...meetingUser,
            acceptanceResponse: (0, $5xpc0.AcceptanceResponses).Rejected
        });
    };
    const acceptanceResponseText = ()=>{
        if (!meetingUser.acceptanceResponse) return t("meeting:pleaseAcceptInvite");
        switch(meetingUser.acceptanceResponse){
            case (0, $5xpc0.AcceptanceResponses).Pending:
                return t("meeting:pleaseAcceptInvite");
            case (0, $5xpc0.AcceptanceResponses).Accepted:
                return t("meeting:youHaveAccepted");
            case (0, $5xpc0.AcceptanceResponses).Rejected:
                return t("meeting:youHaveRejected");
        }
    };
    if (!meetingUser || meeting.status == (0, $32kQ2.MeetingStatuses).Ended) return null;
    const accepted = meetingUser.acceptanceResponse == (0, $5xpc0.AcceptanceResponses).Accepted;
    const rejected = meetingUser.acceptanceResponse == (0, $5xpc0.AcceptanceResponses).Rejected;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
        className: "flex flex-wrap justify-center sm:justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mb-2 text-center sm:text-left sm:mb-0",
                children: acceptanceResponseText()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "ml-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: "#",
                            onClick: acceptInvitation,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "uppercase", "font-thin", "items-center", "hover:text-ch-green-300", {
                                "text-ch-gray-500": rejected,
                                "text-ch-green-300": accepted
                            }),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-ch-gray-600",
                                    children: t("meeting:accept")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4o7Oq.default), {
                                    className: "fill-current w-4 h-4 ml-2"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "ml-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: "#",
                            onClick: rejectInvitation,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "uppercase", "font-thin", "items-center", "hover:text-ch-red-500", {
                                "text-ch-gray-500": accepted,
                                "text-ch-red-500": rejected
                            }),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-ch-gray-600",
                                    children: t("meeting:reject")
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6EQca.default), {
                                    className: "fill-current w-4 h-4 ml-2"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $e987c355103511eb$export$2e2bcd8739ae039 = $e987c355103511eb$var$MeetingInvitation;

});
parcelRegister("7SwiO", function(module, exports) {

$parcel$export(module.exports, "createMeetingUserAcion", () => $b4c9090c5ce632c9$export$a2a7fe8a62908f7b);
$parcel$export(module.exports, "updateMeetingUserAction", () => $b4c9090c5ce632c9$export$d6d3a734d2788345);
$parcel$export(module.exports, "destroyMeetingUserAction", () => $b4c9090c5ce632c9$export$b2b5cf45eea07276);

var $5xpc0 = parcelRequire("5xpc0");
const $b4c9090c5ce632c9$export$a2a7fe8a62908f7b = (meetingData)=>{
    return {
        type: (0, $5xpc0.MeetingUserActionTypes).CREATE_MEETING_USER_ASYNC_PENDING,
        payload: meetingData
    };
};
const $b4c9090c5ce632c9$export$d6d3a734d2788345 = (meetingUserId, meetingUserData)=>{
    return {
        type: (0, $5xpc0.MeetingUserActionTypes).UPDATE_MEETING_USER_ASYNC_PENDING,
        payload: {
            id: meetingUserId,
            meetingUser: meetingUserData
        }
    };
};
const $b4c9090c5ce632c9$export$b2b5cf45eea07276 = (meetingUserId)=>{
    return {
        type: (0, $5xpc0.MeetingUserActionTypes).DESTROY_MEETING_USER_ASYNC_PENDING,
        payload: meetingUserId
    };
};

});


parcelRegister("eipax", function(module, exports) {

$parcel$export(module.exports, "default", () => $689a82ed646e943a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $7jD0k = parcelRequire("7jD0k");

var $9c2AV = parcelRequire("9c2AV");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");

var $32kQ2 = parcelRequire("32kQ2");

var $lFekz = parcelRequire("lFekz");

var $3QK3n = parcelRequire("3QK3n");

var $7SwiO = parcelRequire("7SwiO");

var $bFoxZ = parcelRequire("bFoxZ");

var $lOcoE = parcelRequire("lOcoE");
const $689a82ed646e943a$var$MeetingUsers = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const coordinatorMeetingUser = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUserByUserIdAndMeetingId)(state, props.meetingId, meeting.coordinatorId));
    const [isVisibleList, toggleList] = (0, $acw62.useState)(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const createMeetingUsers = (values, { setSubmitting: setSubmitting })=>{
        const data = {
            meetingId: meeting.id,
            userIds: values.users,
            teamIds: values.teams
        };
        dispatch((0, $7SwiO.createMeetingUserAcion)(data));
        setSubmitting(false);
        closeModal();
    };
    if (!meeting.users || !coordinatorMeetingUser) return null;
    // sort sorts in place
    meeting.meetingUsers?.sort((a, b)=>a == coordinatorMeetingUser.id ? -1 : b == coordinatorMeetingUser.id ? 1 : 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("shared:users"),
                                    " (",
                                    meeting.users.length,
                                    ")"
                                ]
                            }),
                            meeting.permissions && meeting.permissions.canInvite && meeting.status !== (0, $32kQ2.MeetingStatuses).Ended ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFoxZ.default), {
                                openModal: openModal,
                                label: t("meeting:inviteParticipantsOrTeams")
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex mb-2 items-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "flex-1 pr-10 lg:pr-24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                    i18nKey: "meeting:usersIntro",
                                    components: {
                                        strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                isExpanded: isVisibleList,
                                action: ()=>toggleList(!isVisibleList),
                                expandText: t("meeting:showUsers"),
                                collapseText: t("meeting:hideUsers")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                            hidden: !isVisibleList
                        }),
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(meeting.meetingUsers, (meetingUserId)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFekz.default), {
                                meetingId: props.meetingId,
                                meetingUserId: meetingUserId
                            }, meetingUserId);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("meeting:inviteParticipantsIntro")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "md:flex md:text-lg flex-row font-semibold mb-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                                    className: "text-ch-purple-500 self-center mr-1 w-5 h-5"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        meeting.name,
                                        " ",
                                        t("shared:on"),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                                    startDate: meeting.startDate,
                                    endDate: meeting.endDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-ch-blue-600",
                                    children: t("meeting:inviteParticipantsDesc1")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-ch-blue-600",
                                    children: t("meeting:inviteParticipantsDesc2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOcoE.default), {
                                submitHandler: createMeetingUsers,
                                excludedUserIds: meeting.users,
                                userLabel: t("shared:chooseUsers", {
                                    user: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).lowerCase(t("shared:participant"))
                                }),
                                teamUserListHeader: t("meeting:teamUserListHeader"),
                                buttonText: t("shared:addUsers", {
                                    users: t("shared:participants"),
                                    entity: t("shared:meeting")
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $689a82ed646e943a$export$2e2bcd8739ae039 = $689a82ed646e943a$var$MeetingUsers;

});
parcelRegister("lFekz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb349073928a6acf$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $ejvqu = parcelRequire("ejvqu");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $6EQca = parcelRequire("6EQca");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");

var $7SwiO = parcelRequire("7SwiO");

var $5xpc0 = parcelRequire("5xpc0");

var $j0coJ = parcelRequire("j0coJ");

var $6lvMC = parcelRequire("6lvMC");

var $l30Z2 = parcelRequire("l30Z2");

var $5sVSF = parcelRequire("5sVSF");
const $fb349073928a6acf$var$MeetingUserListItem = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const meetingUser = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUserByMeetingUserId)(state, props));
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, meetingUser));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const renderMeetingResponse = ()=>{
        if (meetingUser.acceptanceResponse == (0, $5xpc0.AcceptanceResponses).Accepted) return renderAccepted();
        else if (meetingUser.acceptanceResponse == (0, $5xpc0.AcceptanceResponses).Rejected) return renderRejected();
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "invisible flex uppercase font-thin text-ch-green-300 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "invisible text-ch-gray-600",
                    children: t("meeting:accepted")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4o7Oq.default), {
                    className: "fill-current w-4 h-4 ml-2"
                })
            ]
        });
    };
    const renderMeetingUserButton = ()=>{
        if (meetingUser.teamUserId) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: t("meeting:mdtMeeting:mdtMember")
        });
        if (meeting.coordinatorId == meetingUser.userId) return null;
        if (meeting.permissions.canUninvite) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0coJ.default), {
            action: removeUserFromMeeting,
            label: t("shared:remove"),
            canRemove: meeting.permissions.canUninvite
        });
    };
    const renderAccepted = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "flex uppercase font-thin text-ch-green-300 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-ch-gray-600",
                    children: t("meeting:accepted")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4o7Oq.default), {
                    className: "fill-current w-4 h-4 ml-2"
                })
            ]
        });
    };
    const renderRejected = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "flex uppercase font-thin text-ch-red-500 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-ch-gray-600",
                    children: t("meeting:rejected")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6EQca.default), {
                    className: "fill-current w-4 h-4 ml-2"
                })
            ]
        });
    };
    const removeUserFromMeeting = ()=>{
        dispatch((0, $7SwiO.destroyMeetingUserAction)(props.meetingUserId));
    };
    const renderMeetingUserAttendanceLabel = ()=>{
        if (meeting.status == (0, $32kQ2.MeetingStatuses).Ended) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5sVSF.MeetingUserAttendanceLabel), {
            meetingJoinedCount: meetingUser.joinedCount
        });
        return null;
    };
    const coordinatorLabel = ()=>{
        if (meeting.coordinatorId != meetingUser.userId) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-sm text-white px-2 rounded bg-ch-blue-alt-500 ml-1 uppercase",
            children: t("user:coordinator")
        });
    };
    const mdtRole = ()=>{
        if (!meetingUser.mdtRole) return null;
        return `${t("meeting:mdtMeeting:mdtRole")}: ${meetingUser.mdtRole}`;
    };
    if (!meetingUser || !meeting) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user,
                        nameLabel: coordinatorLabel(),
                        label: mdtRole()
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            renderMeetingResponse(),
                            renderMeetingUserButton(),
                            renderMeetingUserAttendanceLabel()
                        ]
                    })
                })
            ]
        })
    });
};
var $fb349073928a6acf$export$2e2bcd8739ae039 = $fb349073928a6acf$var$MeetingUserListItem;

});
parcelRegister("j0coJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5172feba0d38d41$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");
const $d5172feba0d38d41$var$RemoveUserButton = (props)=>{
    if (props.canRemove) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: props.action,
        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
        isDisabled: props.submitting,
        children: props.label
    }, "2");
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        isDisabled: true,
        className: "invisible",
        children: props.label
    });
};
var $d5172feba0d38d41$export$2e2bcd8739ae039 = $d5172feba0d38d41$var$RemoveUserButton;

});

parcelRegister("5sVSF", function(module, exports) {

$parcel$export(module.exports, "MeetingUserAttendanceLabel", () => $898c13125aa8fa44$export$a498e72ecc4521a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $898c13125aa8fa44$export$a498e72ecc4521a = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-sm text-white px-2  ml-1 uppercase " + (props.meetingJoinedCount > 0 ? "rounded bg-ch-green-500" : "rounded bg-ch-purple-500"),
        children: props.meetingJoinedCount > 0 ? t("user:attended") : t("user:notAttended")
    });
};

});


parcelRegister("bFoxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7221ed888b70f9ca$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");
const $7221ed888b70f9ca$var$InviteButton = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: props.openModal,
        className: "mb-2",
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: props.label
    });
};
var $7221ed888b70f9ca$export$2e2bcd8739ae039 = $7221ed888b70f9ca$var$InviteButton;

});

parcelRegister("lOcoE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb78825040c5950$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $5GZlj = parcelRequire("5GZlj");

var $acw62 = parcelRequire("acw62");

var $7UN5R = parcelRequire("7UN5R");

var $6lvMC = parcelRequire("6lvMC");

var $jTkGE = parcelRequire("jTkGE");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $eTqMc = parcelRequire("eTqMc");

var $gnvJ9 = parcelRequire("gnvJ9");

var $8UrgM = parcelRequire("8UrgM");

var $2vRvQ = parcelRequire("2vRvQ");

var $6wDTk = parcelRequire("6wDTk");

var $cA1jy = parcelRequire("cA1jy");
const $afb78825040c5950$var$AddUsersForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllActiveUsersSortedFirstNameLastName)(state));
    const teams = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getAllTeams)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [teamOptions, setTeamOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        if (!props.disableTeams) dispatch((0, $gnvJ9.fetchAllTeamsAsync)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        let availableUsers = users.filter((user)=>!props.excludedUserIds.map((uid)=>uid).includes(user.id));
        if (!props.includeGuests) availableUsers = availableUsers.filter((user)=>!(0, $cA1jy.isGuest)(user));
        const options = (0, $6wDTk.buildUserOptions)(Object.values(availableUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        if (props.disableTeams) return;
        const options = Object.values(teams).map((team)=>{
            return {
                value: team.id,
                label: team.name
            };
        });
        setTeamOptions(options);
    }, [
        teams
    ]);
    const initialValues = {
        users: [],
        teams: []
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: props.submitHandler,
        children: ({ values: values, isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, errors: errors, touched: touched, dirty: dirty })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-6 w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "users",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: props.userLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                name: "users",
                                options: userOptions,
                                isMulti: true,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                            })
                        ]
                    }),
                    props.disableTeams ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-6 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "teams",
                                        children: t("shared:chooseTeams")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                        name: "teams",
                                        options: teamOptions,
                                        isMulti: true,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        isDisabled: teamOptions.length == 0,
                                        placeholder: teamOptions.length == 0 ? "No teams available" : null
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.users,
                                        isVisible: errors.users && touched.users
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vRvQ.default), {
                                    teamIds: values.teams,
                                    header: props.teamUserListHeader
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            isDisabled: !dirty || isSubmitting,
                            variant: (0, $jF0Xa.StyleVariants).ORANGE,
                            isSubmit: true,
                            children: props.buttonText
                        })
                    })
                ]
            });
        }
    });
};
var $afb78825040c5950$export$2e2bcd8739ae039 = $afb78825040c5950$var$AddUsersForm;

});
parcelRegister("jTkGE", function(module, exports) {

$parcel$export(module.exports, "getAllTeams", () => $e3449c6070c27328$export$ff848de5b4c70793);
$parcel$export(module.exports, "getAllTeamIds", () => $e3449c6070c27328$export$f806820bd3492377);
$parcel$export(module.exports, "getTeamById", () => $e3449c6070c27328$export$5dcc6aff8319c1fe);
$parcel$export(module.exports, "getTeamByHasTeamId", () => $e3449c6070c27328$export$a0e230cb8f8bb24a);
$parcel$export(module.exports, "getTeamUserByTeamUserId", () => $e3449c6070c27328$export$2e8182fef76e0dd9);
$parcel$export(module.exports, "getTeamUserByUserIdAndTeamId", () => $e3449c6070c27328$export$b6cd03b43eea84da);
$parcel$export(module.exports, "getTeamUsersByTeamId", () => $e3449c6070c27328$export$f8d207f251cf3a28);
$parcel$export(module.exports, "getTeamMembersByTeamIds", () => $e3449c6070c27328$export$3c0394c8fb1953ed);

var $f1q41 = parcelRequire("f1q41");

var $6SpLG = parcelRequire("6SpLG");

var $6lvMC = parcelRequire("6lvMC");
const $e3449c6070c27328$export$ff848de5b4c70793 = (state)=>state.entities.teams.byId;
const $e3449c6070c27328$export$f806820bd3492377 = (state)=>state.entities.teams.allIds;
const $e3449c6070c27328$export$5dcc6aff8319c1fe = (state, id)=>state.entities.teams.byId[id];
const $e3449c6070c27328$export$a0e230cb8f8bb24a = (state, ownProps)=>$e3449c6070c27328$export$5dcc6aff8319c1fe(state, ownProps.teamId);
const $e3449c6070c27328$export$2e8182fef76e0dd9 = (state, ownProps)=>{
    return state.entities.teamUsers.byId[ownProps.teamUserId] ?? null;
};
const $e3449c6070c27328$export$b6cd03b43eea84da = (state, teamId, userId)=>{
    const team = state.entities.teams.byId[teamId];
    if (!team || !team.teamUsers) return null;
    return team.teamUsers.map((x)=>state.entities.teamUsers.byId[x]).find((user)=>{
        if (!user) return false;
        return user.userId == userId;
    });
};
const $e3449c6070c27328$var$getAllTeamUsers = (state)=>state.entities.teamUsers.byId;
const $e3449c6070c27328$export$f8d207f251cf3a28 = (0, $6SpLG.createSelector)([
    $e3449c6070c27328$export$5dcc6aff8319c1fe,
    $e3449c6070c27328$var$getAllTeamUsers
], (team, teamUsersById)=>{
    if (!team?.teamUsers) return [];
    return team.teamUsers.map((id)=>teamUsersById[id] ?? null);
});
const $e3449c6070c27328$export$3c0394c8fb1953ed = (0, $6SpLG.createSelector)([
    $e3449c6070c27328$export$ff848de5b4c70793,
    (0, $6lvMC.getAllUsers),
    (_state, teamIds)=>teamIds
], (allTeams, allUsers, teamIds)=>{
    if (!teamIds || teamIds.length === 0) return [];
    const userIds = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(teamIds.flatMap((id)=>allTeams[id]?.users || []));
    const users = userIds.map((id)=>allUsers[id]).filter(Boolean);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(users, [
        "lastName",
        "firstName"
    ]);
});

});

parcelRegister("gnvJ9", function(module, exports) {

$parcel$export(module.exports, "fetchTeamsAsync", () => $d0d070c8e3e0e038$export$24e0f077a3efb538);
$parcel$export(module.exports, "fetchAllTeamsAsync", () => $d0d070c8e3e0e038$export$b060c608f081315);

var $62Lcu = parcelRequire("62Lcu");
const $d0d070c8e3e0e038$export$24e0f077a3efb538 = (searchQuery)=>{
    return {
        type: (0, $62Lcu.TeamsActionTypes).FETCH_TEAMS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $d0d070c8e3e0e038$export$b060c608f081315 = ()=>{
    return {
        type: (0, $62Lcu.TeamsActionTypes).FETCH_ALL_TEAMS_ASYNC_PENDING
    };
};

});

parcelRegister("2vRvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5220b94841fc50c3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $jTkGE = parcelRequire("jTkGE");

var $6t04b = parcelRequire("6t04b");
const $5220b94841fc50c3$var$TeamMemberList = (props)=>{
    const teamIds = (0, $acw62.useMemo)(()=>props.teamIds ?? [], [
        props.teamIds?.join(",")
    ]);
    const sortedUsers = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamMembersByTeamIds)(state, teamIds));
    if (!sortedUsers || sortedUsers.length === 0) return null;
    const maxH = sortedUsers.length > 20 ? "max-h-64" : "max-h-32";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: props.header
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `flex flex-col flex-wrap ${maxH} place-content-start overflow-auto mb-6`,
                children: sortedUsers.map((user)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-1/6 mb-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                            firstName: user.firstName,
                            lastName: user.lastName,
                            isPending: user.pending
                        })
                    }, user.id))
            })
        ]
    });
};
var $5220b94841fc50c3$export$2e2bcd8739ae039 = $5220b94841fc50c3$var$TeamMemberList;

});

parcelRegister("6wDTk", function(module, exports) {

$parcel$export(module.exports, "filterOptionsBySearchValue", () => $2ac2a760c4669d69$export$e71d8a9be23519f0);
$parcel$export(module.exports, "buildUserOptions", () => $2ac2a760c4669d69$export$21d5b92e0e9bdb06);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $irdpp = parcelRequire("irdpp");

var $26LRi = parcelRequire("26LRi");

var $cA1jy = parcelRequire("cA1jy");
const $2ac2a760c4669d69$var$escapeSpecialSymbols = (text)=>{
    return text.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
};
const $2ac2a760c4669d69$export$e71d8a9be23519f0 = (option, text)=>{
    const regexp = new RegExp($2ac2a760c4669d69$var$escapeSpecialSymbols(text), "i");
    if (option.data.searchValue.match(regexp)) return true;
    return false;
};
const $2ac2a760c4669d69$export$21d5b92e0e9bdb06 = (users)=>users.map((user)=>{
        return {
            value: user.id,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)($2ac2a760c4669d69$var$UserOption, {
                user: user
            }),
            searchValue: $2ac2a760c4669d69$var$formatUserOptionsString(user)
        };
    });
const $2ac2a760c4669d69$var$formatUserOptionsString = (user)=>{
    if (user.professionalTitle && user.professionalTitle.length > 0) return `${user.firstName} ${user.lastName} - ${user.professionalTitle}`.trim();
    else return `${user.firstName} ${user.lastName}`.trim();
};
const $2ac2a760c4669d69$var$UserOption = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: $2ac2a760c4669d69$var$formatUserOptionsString(props.user)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irdpp.PendingLabel), {
                isPending: props.user.pending
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26LRi.GuestLabel), {
                isGuest: (0, $cA1jy.isGuest)(props.user)
            })
        ]
    });
};

});




parcelRegister("11pqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8029724efe5799f4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kg0eN = parcelRequire("kg0eN");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $1rebl = parcelRequire("1rebl");

var $jF0Xa = parcelRequire("jF0Xa");

var $ax7Du = parcelRequire("ax7Du");

var $7qa36 = parcelRequire("7qa36");

var $f14kK = parcelRequire("f14kK");

var $6QJY8 = parcelRequire("6QJY8");

var $kQILj = parcelRequire("kQILj");

var $aDFyu = parcelRequire("aDFyu");

var $1kXfn = parcelRequire("1kXfn");

var $39EfS = parcelRequire("39EfS");

var $hPcNz = parcelRequire("hPcNz");

var $kVlM3 = parcelRequire("kVlM3");

var $lCZwG = parcelRequire("lCZwG");

var $8g1PZ = parcelRequire("8g1PZ");

var $7JKXi = parcelRequire("7JKXi");

var $gGSQo = parcelRequire("gGSQo");
parcelRequire("jitSV");
var $gc4wS = parcelRequire("gc4wS");
var $9c2AV = parcelRequire("9c2AV");

var $6lvMC = parcelRequire("6lvMC");

var $glc4D = parcelRequire("glc4D");

var $1l1FS = parcelRequire("1l1FS");

var $cA1jy = parcelRequire("cA1jy");

var $iK6Ns = parcelRequire("iK6Ns");
const $8029724efe5799f4$var$MeetingsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting",
        "case",
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getMeetingsUI)(state));
    const quickViewResourceId = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getQuickViewResourceId)(state));
    const onToggleListView = (isListView)=>dispatch((0, $kg0eN.toggleListView)(isListView));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $kg0eN.fetchMeetingsAsync));
    const { width: width } = (0, $iK6Ns.default)();
    const hideCalendar = width == undefined || width < 768 || UI.isListView;
    const hideMeetingList = !hideCalendar;
    (0, $acw62.useEffect)(()=>{
        if (currentUser && (0, $cA1jy.isGuest)(currentUser)) (0, $1l1FS.default).replace("/");
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("h-full", "flex", "flex-col", {
                    "hidden": hideCalendar
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                                pageTitle: t("shared:meetings"),
                                buttonText: t("meeting:addNewMeeting"),
                                buttonHref: (0, $6QJY8.RoutePaths).MEETING_NEW,
                                hasButtonPermission: currentUser.abilities?.meeting.canCreate
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>onToggleListView(!UI.isListView),
                                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc4wS.default), {
                                                className: "text-white self-center mx-2 w-5 h-5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "hidden sm:inline",
                                                children: t("meeting:listView")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-1 flex-col-reverse lg:flex-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-col flex-grow",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7JKXi.default), {
                                    isVisible: !UI.isListView
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-col",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gGSQo.default), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("", {
                    "hidden": hideMeetingList
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                                pageTitle: t("shared:meetings"),
                                buttonText: t("meeting:addNewMeeting"),
                                buttonHref: (0, $6QJY8.RoutePaths).MEETING_NEW,
                                hasButtonPermission: currentUser.abilities?.meeting.canCreate
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>onToggleListView(!UI.isListView),
                                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                                                className: "text-white self-center mx-2 w-5 h-5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "hidden sm:inline",
                                                children: t("meeting:calendarView")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "row-start-2 md:row-start-1 self-end md:self-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                    i18nKey: "meeting:searchBy",
                                    components: {
                                        strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "row-end-2 md:row-start-1 flex justify-end",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                                    searchQuery: searchQuery,
                                    setSearchQuery: setSearchQuery
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            buttonText: t("meeting:searchMeetings")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "text-lg mb-2 text-center md:text-left",
                        children: [
                            UI.totalMeetingsCount,
                            " ",
                            t("shared:meetings")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-flow-row md:grid-flow-col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ax7Du.default), {
                                    searchQuery: searchQuery,
                                    setSearchQuery: setSearchQuery
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                                    searchQuery: searchQuery,
                                    setSearchQuery: setSearchQuery,
                                    orderByOptions: (0, $hPcNz.MeetingsOrderByOptions),
                                    useTranslation: "meeting"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1rebl.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                        searchQuery: searchQuery,
                        setSearchQuery: setSearchQuery,
                        totalItems: UI.totalMeetingsCount,
                        totalPages: UI.totalPages
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f14kK.default), {
                    meetingId: quickViewResourceId
                })
            })
        ]
    });
};
var $8029724efe5799f4$export$2e2bcd8739ae039 = $8029724efe5799f4$var$MeetingsPage;

});
parcelRegister("kg0eN", function(module, exports) {

$parcel$export(module.exports, "fetchMeetingsAsync", () => $813423c28d346570$export$2e1a23a993b4258d);
$parcel$export(module.exports, "fetchMeetingsInDateRangeAsync", () => $813423c28d346570$export$325ce99254ebba11);
$parcel$export(module.exports, "toggleListView", () => $813423c28d346570$export$ec42098f35246fdf);

var $bal3N = parcelRequire("bal3N");
const $813423c28d346570$export$2e1a23a993b4258d = (searchQuery)=>{
    return {
        type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $813423c28d346570$export$325ce99254ebba11 = (start, end)=>{
    return {
        type: (0, $bal3N.MeetingsActionTypes).FETCH_MEETINGS_IN_RANGE_ASYNC_PENDING,
        payload: {
            start: start,
            end: end
        }
    };
};
const $813423c28d346570$export$ec42098f35246fdf = (isListView)=>{
    return {
        type: (0, $bal3N.MeetingsActionTypes).TOGGLE_LIST_VIEW,
        payload: isListView
    };
};

});

parcelRegister("1rebl", function(module, exports) {

$parcel$export(module.exports, "default", () => $465e97926d985ea1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $5zbAh = parcelRequire("5zbAh");

var $4VtCQ = parcelRequire("4VtCQ");
const $465e97926d985ea1$var$MeetingList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const meetingIds = (0, $iD0SF.useSelector)((0, $4VtCQ.getAllMeetingIdsUiIndexPage));
    if (!meetingIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("meeting:noMeetings")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: meetingIds.map((meetingId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5zbAh.default), {
                meetingId: meetingId
            }, meetingId))
    });
};
var $465e97926d985ea1$export$2e2bcd8739ae039 = $465e97926d985ea1$var$MeetingList;

});
parcelRegister("5zbAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $af32293fc1786270$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $i4wYI = parcelRequire("i4wYI");

var $daNS5 = parcelRequire("daNS5");

var $5v6Bi = parcelRequire("5v6Bi");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");
const $af32293fc1786270$var$MeetingListItem = ({ showCaseAndUserCount: showCaseAndUserCount = true, meetingId: meetingId })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: meetingId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickQuickView = (meetingId)=>dispatch((0, $i4wYI.toggleIsQuickViewOpen)(meetingId, true));
    if (!meeting) return null;
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: meetingId
    });
    const liveMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_LIVE, {
        meetingId: meetingId
    });
    const inProgress = ()=>{
        return meeting.status == (0, $32kQ2.MeetingStatuses).InProgress;
    };
    const renderJoinMeetingButton = ()=>{
        if (!inProgress() || !meeting.permissions.canJoin) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: liveMeetingUrl,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("meeting:joinMeeting")
        }, "1");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            isDark: !inProgress(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                                className: "fill-current w-6 h-6",
                                title: meeting.name
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daNS5.default), {
                            meetingId: meeting.id,
                            showCaseAndUserCount: showCaseAndUserCount,
                            showMeetingDueIn: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            renderJoinMeetingButton(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>onClickQuickView(meeting.id),
                                variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                className: "hidden md:block",
                                children: t("shared:quickView")
                            }, "2"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                href: meetingDetailsUrl,
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                children: t("meeting:viewMeeting")
                            }, "3")
                        ]
                    })
                })
            ]
        })
    });
};
var $af32293fc1786270$export$2e2bcd8739ae039 = $af32293fc1786270$var$MeetingListItem;

});


parcelRegister("ax7Du", function(module, exports) {

$parcel$export(module.exports, "default", () => $f246ed490a7028e7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");

var $32kQ2 = parcelRequire("32kQ2");
const $f246ed490a7028e7$var$MeetingFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("meeting:all")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn((0, $32kQ2.MeetingStatuses).Scheduled),
                    action: ()=>{
                        updateFilters((0, $32kQ2.MeetingStatuses).Scheduled);
                    },
                    children: t("meeting:scheduled")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn((0, $32kQ2.MeetingStatuses).InProgress),
                    action: ()=>{
                        updateFilters((0, $32kQ2.MeetingStatuses).InProgress);
                    },
                    children: t("meeting:inProgress")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn((0, $32kQ2.MeetingStatuses).Ended),
                    action: ()=>{
                        updateFilters((0, $32kQ2.MeetingStatuses).Ended);
                    },
                    children: t("meeting:ended")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn((0, $32kQ2.MeetingStatuses).Cancelled),
                    action: ()=>{
                        updateFilters((0, $32kQ2.MeetingStatuses).Cancelled);
                    },
                    children: t("meeting:cancelled")
                })
            })
        ]
    });
};
var $f246ed490a7028e7$export$2e2bcd8739ae039 = $f246ed490a7028e7$var$MeetingFilter;

});

parcelRegister("f14kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8493b597443cd1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $1DXYh = parcelRequire("1DXYh");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $3QK3n = parcelRequire("3QK3n");

var $32kQ2 = parcelRequire("32kQ2");

var $5W5Rd = parcelRequire("5W5Rd");

var $7nrxt = parcelRequire("7nrxt");

var $5wJjW = parcelRequire("5wJjW");

var $4Z6GL = parcelRequire("4Z6GL");
const $9b8493b597443cd1$var$MeetingQuickView = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        if (!props.meetingId) return;
        dispatch((0, $4Z6GL.fetchMeetingAction)(props.meetingId));
    }, [
        props.meetingId
    ]);
    if (!meeting) return null;
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: props.meetingId
    });
    const renderMeetingTimeToStart = ()=>{
        if (meeting.status !== (0, $32kQ2.MeetingStatuses).Scheduled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
            className: "mb-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                startDate: meeting.startDate
            })
        });
    };
    const renderJoinButton = ()=>{
        if (meeting?.status == (0, $32kQ2.MeetingStatuses).InProgress && meeting.permissions?.canJoin) {
            const liveMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_LIVE, {
                meetingId: props.meetingId
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                href: liveMeetingUrl,
                variant: (0, $jF0Xa.StyleVariants).ORANGE,
                className: "mt-2",
                children: t("meeting:joinMeeting")
            });
        }
    };
    const renderMdtName = ()=>{
        if (!meeting.mdtTeam?.name) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("meeting:mdtMeeting:MDT"),
                ": ",
                meeting.mdtTeam?.name
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                            className: "fill-current w-6 h-6",
                            title: meeting.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                                        href: meetingDetailsUrl,
                                        children: meeting.name
                                    })
                                })
                            }),
                            renderMdtName(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: meeting.specialtyName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                                    startDate: meeting.startDate,
                                    endDate: meeting.endDate
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7nrxt.default), {
                                    meeting: meeting
                                })
                            }),
                            renderMeetingTimeToStart()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        href: meetingDetailsUrl,
                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                        children: t("meeting:viewMeeting")
                    }),
                    renderJoinButton()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5W5Rd.default), {
                meetingId: props.meetingId
            })
        ]
    });
};
var $9b8493b597443cd1$export$2e2bcd8739ae039 = $9b8493b597443cd1$var$MeetingQuickView;

});
parcelRegister("5W5Rd", function(module, exports) {

$parcel$export(module.exports, "default", () => $68f92844d4f1f59e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $cOAGM = parcelRequire("cOAGM");

var $ksy5Q = parcelRequire("ksy5Q");

var $iVDgl = parcelRequire("iVDgl");

var $4VtCQ = parcelRequire("4VtCQ");
const $68f92844d4f1f59e$var$MeetingQuickViewTabs = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    if (!meeting) return null;
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(0);
    const meetingsCasesCount = meeting.meetingCases && meeting.meetingCases.length || 0;
    const meetingUsersCount = meeting.users && meeting.users.length || 0;
    const tabText1 = `${meetingsCasesCount} ${t("shared:cases")}`;
    const tabText2 = `${meetingUsersCount} ${t("shared:users")}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVDgl.default), {
                onClick: setCurrentTab,
                text1: tabText1,
                text2: tabText2,
                value: currentTab,
                className: "mb-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 0
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOAGM.default), {
                    meetingId: props.meetingId
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 1
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ksy5Q.default), {
                    meetingId: props.meetingId
                })
            })
        ]
    });
};
var $68f92844d4f1f59e$export$2e2bcd8739ae039 = $68f92844d4f1f59e$var$MeetingQuickViewTabs;

});
parcelRegister("cOAGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4350931ee4f46c2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $eDvET = parcelRequire("eDvET");

var $4VtCQ = parcelRequire("4VtCQ");
const $a4350931ee4f46c2$var$MeetingCaseList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const meetingCaseIds = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseIds)(state, props));
    if (!meetingCaseIds || meetingCaseIds.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: t("case:noCases")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: meetingCaseIds.map((meetingCaseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDvET.default), {
                meetingCaseId: meetingCaseId
            }, meetingCaseId);
        })
    });
};
var $a4350931ee4f46c2$export$2e2bcd8739ae039 = $a4350931ee4f46c2$var$MeetingCaseList;

});
parcelRegister("eDvET", function(module, exports) {

$parcel$export(module.exports, "default", () => $2036c76d828c7ffe$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $5v6Bi = parcelRequire("5v6Bi");

var $50NSH = parcelRequire("50NSH");

var $6bZ1D = parcelRequire("6bZ1D");
const $2036c76d828c7ffe$var$MeetingCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6bZ1D.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:case")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50NSH.default), {
                        meetingCaseId: props.meetingCaseId,
                        isCondensed: true,
                        hasLink: true
                    })
                })
            ]
        })
    });
};
var $2036c76d828c7ffe$export$2e2bcd8739ae039 = $2036c76d828c7ffe$var$MeetingCaseListItem;

});
parcelRegister("6bZ1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $833c0dac610e8ab3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $833c0dac610e8ab3$var$QuickViewCard = (props)=>{
    const defaultClasses = [
        "flex",
        "flex-1",
        "mb-2",
        "bg-ch-gray-300",
        "rounded-md",
        "p-4",
        "justify-between",
        "items-center"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: allClasses,
        children: props.children
    });
};
var $833c0dac610e8ab3$export$2e2bcd8739ae039 = $833c0dac610e8ab3$var$QuickViewCard;

});



parcelRegister("ksy5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $302cebaadea210a4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $aSP6Y = parcelRequire("aSP6Y");

var $32kQ2 = parcelRequire("32kQ2");

var $4VtCQ = parcelRequire("4VtCQ");
const $302cebaadea210a4$var$MeetingUserList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    if (!meeting.meetingUsers) return null;
    if (!meeting.meetingUsers.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: t("user:noUsers")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: meeting.meetingUsers.map((meetingUserId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSP6Y.default), {
                meetingUserId: meetingUserId,
                meetingEnded: meeting.status == (0, $32kQ2.MeetingStatuses).Ended
            }, meetingUserId);
        })
    });
};
var $302cebaadea210a4$export$2e2bcd8739ae039 = $302cebaadea210a4$var$MeetingUserList;

});
parcelRegister("aSP6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb27b2209c4ee26a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4VtCQ = parcelRequire("4VtCQ");

var $6bZ1D = parcelRequire("6bZ1D");

var $6lvMC = parcelRequire("6lvMC");

var $l30Z2 = parcelRequire("l30Z2");

var $5sVSF = parcelRequire("5sVSF");
const $cb27b2209c4ee26a$var$MeetingUserListItem = (props)=>{
    const meetingUser = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUserByMeetingUserId)(state, props));
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, meetingUser));
    const meetingUserAttendanceLabel = props.meetingEnded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5sVSF.MeetingUserAttendanceLabel), {
        meetingJoinedCount: meetingUser.joinedCount
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bZ1D.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                user: user,
                label: meetingUserAttendanceLabel
            })
        })
    });
};
var $cb27b2209c4ee26a$export$2e2bcd8739ae039 = $cb27b2209c4ee26a$var$MeetingUserListItem;

});


parcelRegister("iVDgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ceff72529ba461$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $jF0Xa = parcelRequire("jF0Xa");
const $a5ceff72529ba461$var$PillSwitch = (props)=>{
    let variant = props.variant;
    if (!variant) variant = (0, $jF0Xa.StyleVariants).BLUE;
    const defaultClasses = [
        "flex",
        "justify-center",
        "font-thin"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: allClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "#",
                onClick: ()=>props.onClick(0),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-center", "text-white", "px-4", "py-1", "rounded-l-full", {
                    [`bg-${variant}-500`]: props.value === 0,
                    "bg-ch-gray-500": props.value !== 0
                }),
                children: props.text1
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "#",
                onClick: ()=>props.onClick(1),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-center", "text-white", "px-4", "py-1", "rounded-r-full", {
                    [`bg-${variant}-500`]: props.value === 1,
                    "bg-ch-gray-500": props.value !== 1
                }),
                children: props.text2
            })
        ]
    });
};
var $a5ceff72529ba461$export$2e2bcd8739ae039 = $a5ceff72529ba461$var$PillSwitch;

});



parcelRegister("aDFyu", function(module, exports) {

$parcel$export(module.exports, "TitleButtonFactory", () => $3aceaa929181c6b7$export$85e80becbe943603);
$parcel$export(module.exports, "default", () => $3aceaa929181c6b7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");
const $3aceaa929181c6b7$export$85e80becbe943603 = (action, text, key)=>{
    if (typeof action == "string") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        href: action,
        className: "ml-5",
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: text
    }, key);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: action,
        className: "ml-5",
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: text
    }, key);
};
const $3aceaa929181c6b7$var$PageTitle = ({ pageTitle: pageTitle, buttonText: buttonText, buttonHref: buttonHref, hasButtonPermission: hasButtonPermission = false, secondaryButton: secondaryButton })=>{
    const renderButtons = ()=>{
        if (!buttonText || !buttonHref || !hasButtonPermission) return null;
        if (!secondaryButton) return $3aceaa929181c6b7$export$85e80becbe943603(buttonHref, buttonText, "1");
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
            className: "flex flex-wrap flex-1 justify-left",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: $3aceaa929181c6b7$export$85e80becbe943603(buttonHref, buttonText, "1")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: secondaryButton
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center mb-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg py-1",
                children: pageTitle
            }),
            renderButtons()
        ]
    });
};
var $3aceaa929181c6b7$export$2e2bcd8739ae039 = $3aceaa929181c6b7$var$PageTitle;

});

parcelRegister("hPcNz", function(module, exports) {

$parcel$export(module.exports, "MeetingsOrderByOptions", () => $3057ee039bc93923$export$fa62e5aefb268a46);
var $3057ee039bc93923$export$fa62e5aefb268a46 = /*#__PURE__*/ function(MeetingsOrderByOptions) {
    MeetingsOrderByOptions["DateDesc"] = "date_desc";
    MeetingsOrderByOptions["DateAsc"] = "date_asc";
    MeetingsOrderByOptions["NameAsc"] = "name_asc";
    MeetingsOrderByOptions["NameDesc"] = "name_desc";
    return MeetingsOrderByOptions;
}({});

});

parcelRegister("kVlM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06ea41e683cea8a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $4KSAX = parcelRequire("4KSAX");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $k7HLt = parcelRequire("k7HLt");

var $jF0Xa = parcelRequire("jF0Xa");

var $3Ukkm = parcelRequire("3Ukkm");
const $b06ea41e683cea8a$var$ValueChangeListener = ()=>{
    const { submitForm: submitForm, values: values } = (0, $7YFi7.useFormikContext)();
    const value = values;
    (0, $acw62.useEffect)(()=>{
        if (value) submitForm();
    }, [
        value,
        submitForm
    ]);
    return null;
};
const $b06ea41e683cea8a$var$OrderBy = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        props.useTranslation
    ]);
    const orderOptions = Object.keys(props.orderByOptions).map((key)=>{
        return {
            value: props.orderByOptions[key],
            label: t(`${props.useTranslation}:${(0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(key)}`)
        };
    });
    const initialValues = {
        orderBy: props.searchQuery.orderBy
    };
    const reload = (value)=>{
        props.setSearchQuery({
            orderBy: value.orderBy
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: reload,
        children: ({ values: values, handleChange: handleChange, handleBlur: handleBlur })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        className: "mr-2",
                        name: "orderBy",
                        children: t("shared:orderBy")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7HLt.default), {
                        options: orderOptions,
                        type: "text",
                        name: "orderBy",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.orderBy,
                        className: "pt-2 pb-2 pl-2 pr-2",
                        autoComplete: "off",
                        includeBlank: false,
                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                        isLight: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b06ea41e683cea8a$var$ValueChangeListener, {})
                ]
            });
        }
    });
};
var $b06ea41e683cea8a$export$2e2bcd8739ae039 = $b06ea41e683cea8a$var$OrderBy;

});

parcelRegister("7JKXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $226c4378d6603620$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6CKPr = parcelRequire("6CKPr");

var $lVBJL = parcelRequire("lVBJL");

var $7cipo = parcelRequire("7cipo");

var $3PVfl = parcelRequire("3PVfl");

var $4VtCQ = parcelRequire("4VtCQ");

var $i4wYI = parcelRequire("i4wYI");

var $4KSAX = parcelRequire("4KSAX");

var $1Lj4p = parcelRequire("1Lj4p");

var $aEgqS = parcelRequire("aEgqS");

var $ahLi9 = parcelRequire("ahLi9");

var $ipTba = parcelRequire("ipTba");

var $6lvMC = parcelRequire("6lvMC");

var $8g1PZ = parcelRequire("8g1PZ");

var $iVT8j = parcelRequire("iVT8j");

var $kg0eN = parcelRequire("kg0eN");
const $226c4378d6603620$var$MeetingCalendar = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const { timezone: timezone, locale: locale } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const [meetingEvents, setMeetingEvents] = (0, $acw62.useState)(null);
    const meetings = (0, $iD0SF.useSelector)((0, $4VtCQ.getAllMeetingsAsArray));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickQuickView = (meetingId)=>dispatch((0, $i4wYI.toggleIsQuickViewOpen)(meetingId, true));
    const fetchMeetingsInDateRange = ({ startStr: startStr, endStr: endStr })=>dispatch((0, $kg0eN.fetchMeetingsInDateRangeAsync)(startStr, endStr));
    const updateCalendarSize = ()=>{
        window.dispatchEvent(new Event("resize"));
    };
    const formatMeetingEvents = ()=>{
        if (!currentUser || !meetings) return;
        return meetings.map((meeting)=>{
            // multidayEvents are using backgroundColor attribute
            const isCoordinator = meeting.coordinatorId == currentUser.id;
            return {
                meetingId: meeting.id,
                meetingStatus: meeting.status,
                title: meeting.name,
                start: (0, $ahLi9.utcDateToZonedTime)(meeting.startDate, timezone),
                end: (0, $ahLi9.utcDateToZonedTime)(meeting.endDate, timezone),
                backgroundColor: isCoordinator ? "#FFFFFF" : "#D0E2E3",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("overflow-hidden border rounded-sm cursor-pointer", {
                    "bg-white": isCoordinator,
                    "bg-ch-blue-200": !isCoordinator,
                    "border-ch-gray-400": isCoordinator,
                    "border-ch-blue-200": !isCoordinator
                })
            };
        });
    };
    (0, $acw62.useEffect)(()=>{
        const meetingEvents = formatMeetingEvents();
        setMeetingEvents(meetingEvents);
        setTimeout(()=>{
            updateCalendarSize();
        });
    }, [
        meetings
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!props.isVisible) return;
        setTimeout(()=>{
            updateCalendarSize();
        });
    }, [
        props.isVisible
    ]);
    const showSpinner = (isLoading)=>{
        if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        else return null;
    };
    const handleEventClick = (e)=>{
        onClickQuickView(e.event.extendedProps.meetingId);
        updateCalendarSize();
    };
    const renderEventContent = (eventInfo, _element)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-tip": eventInfo.event.title,
            children: [
                eventInfo.timeText,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ipTba.default), {
                    colorKey: eventInfo.event.extendedProps.meetingStatus
                }),
                eventInfo.event.title,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVT8j.default), {
                    backgroundColor: "white",
                    border: true,
                    borderColor: "#A3C3C4",
                    textColor: "#75A7A9"
                })
            ]
        });
    };
    const viewSettings = {
        dayGrid: {
            dayMaxEventRows: 2 //adjust for timeGridMonth
        }
    };
    const buttonText = {
        today: t("shared:today"),
        month: t("shared:month"),
        week: t("shared:week"),
        day: t("shared:day")
    };
    // the locale overrides this - Full Calender shows European time as 24 hour
    const eventTimeFormat = {
        hour: "2-digit",
        minute: "2-digit",
        meridiem: "short"
    };
    const dayHeaderContent = (args)=>{
        if (args.view.type == "dayGridMonth") return;
        return (0, $ahLi9.formatDayDate)(args.date);
    };
    const moreLinkContent = (args)=>{
        return `+ ${args.num} ${t("shared:more")}`;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex h-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex-grow p-5 bg-white border border-ch-gray-400 text-ch-gray-600",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6CKPr.default), {
                locale: locale,
                loading: showSpinner,
                height: "100%",
                plugins: [
                    (0, $lVBJL.default),
                    (0, $7cipo.default),
                    (0, $3PVfl.default)
                ],
                initialView: "dayGridMonth",
                headerToolbar: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay"
                },
                buttonText: buttonText,
                dayHeaderContent: dayHeaderContent,
                allDaySlot: false,
                events: meetingEvents,
                eventClick: handleEventClick,
                eventTimeFormat: eventTimeFormat,
                eventTextColor: "#515151",
                eventBorderColor: "#E0E0E0",
                eventContent: renderEventContent,
                fixedWeekCount: false,
                dayMaxEventRows: true,
                views: viewSettings,
                moreLinkContent: moreLinkContent,
                slotEventOverlap: false,
                datesSet: fetchMeetingsInDateRange
            })
        })
    });
};
var $226c4378d6603620$export$2e2bcd8739ae039 = $226c4378d6603620$var$MeetingCalendar;

});
parcelRegister("6CKPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2a9de4ba3516fe$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $jgkCe = parcelRequire("jgkCe");

var $9tuWU = parcelRequire("9tuWU");
const $4d2a9de4ba3516fe$var$reactMajorVersion = parseInt(String((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version).split('.')[0]);
const $4d2a9de4ba3516fe$var$syncRenderingByDefault = $4d2a9de4ba3516fe$var$reactMajorVersion < 18;
class $4d2a9de4ba3516fe$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $acw62.createRef)();
        this.isUpdating = false;
        this.isUnmounting = false;
        this.state = {
            customRenderingMap: new Map()
        };
        this.requestResize = ()=>{
            if (!this.isUnmounting) {
                this.cancelResize();
                this.resizeId = requestAnimationFrame(()=>{
                    this.doResize();
                });
            }
        };
    }
    render() {
        const customRenderingNodes = [];
        for (const customRendering of this.state.customRenderingMap.values())customRenderingNodes.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4d2a9de4ba3516fe$var$CustomRenderingComponent, {
            key: customRendering.id,
            customRendering: customRendering
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: this.elRef
        }, customRenderingNodes);
    }
    componentDidMount() {
        // reset b/c react strict-mode calls componentWillUnmount/componentDidMount
        this.isUnmounting = false;
        const customRenderingStore = new (0, $9tuWU.cv)();
        this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
        this.calendar = new (0, $jgkCe.Calendar)(this.elRef.current, Object.assign(Object.assign({}, this.props), {
            handleCustomRendering: this.handleCustomRendering
        }));
        this.calendar.render();
        // attaching with .on() will cause this to fire AFTER internal preact rendering did flushSync
        this.calendar.on('_beforeprint', ()=>{
            (0, $1u0KT.flushSync)(()=>{
            // our `customRenderingMap` state will be flushed at this point
            });
        });
        let lastRequestTimestamp;
        customRenderingStore.subscribe((customRenderingMap)=>{
            const requestTimestamp = Date.now();
            const isMounting = !lastRequestTimestamp;
            const runFunc = // don't call flushSync if React version already does sync rendering by default
            // guards against fatal errors:
            // https://github.com/fullcalendar/fullcalendar/issues/7448
            $4d2a9de4ba3516fe$var$syncRenderingByDefault || //
            isMounting || this.isUpdating || this.isUnmounting || requestTimestamp - lastRequestTimestamp < 100 // rerendering frequently
             ? $4d2a9de4ba3516fe$var$runNow // either sync rendering (first-time or React 16/17) or async (React 18)
             : (0, $1u0KT.flushSync); // guaranteed sync rendering
            runFunc(()=>{
                this.setState({
                    customRenderingMap: customRenderingMap
                }, ()=>{
                    lastRequestTimestamp = requestTimestamp;
                    if (isMounting) this.doResize();
                    else this.requestResize();
                });
            });
        });
    }
    componentDidUpdate() {
        this.isUpdating = true;
        this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), {
            handleCustomRendering: this.handleCustomRendering
        }));
        this.isUpdating = false;
    }
    componentWillUnmount() {
        this.isUnmounting = true;
        this.cancelResize();
        this.calendar.destroy();
    }
    doResize() {
        this.calendar.updateSize();
    }
    cancelResize() {
        if (this.resizeId !== undefined) {
            cancelAnimationFrame(this.resizeId);
            this.resizeId = undefined;
        }
    }
    getApi() {
        return this.calendar;
    }
}
$4d2a9de4ba3516fe$export$2e2bcd8739ae039.act = $4d2a9de4ba3516fe$var$runNow; // DEPRECATED. Not leveraged anymore
class $4d2a9de4ba3516fe$var$CustomRenderingComponent extends (0, $acw62.PureComponent) {
    render() {
        const { customRendering: customRendering } = this.props;
        const { generatorMeta: generatorMeta } = customRendering;
        const vnode = typeof generatorMeta === 'function' ? generatorMeta(customRendering.renderProps) : generatorMeta;
        return (0, $1u0KT.createPortal)(vnode, customRendering.containerEl);
    }
}
// Util
// -------------------------------------------------------------------------------------------------
function $4d2a9de4ba3516fe$var$runNow(f) {
    f();
}

});
parcelRegister("jgkCe", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $e05f80c7548aefed$export$ae829ec7b2625219);
$parcel$export(module.exports, "Calendar", () => $e05f80c7548aefed$export$e1aef45b828286de);

var $9tuWU = parcelRequire("9tuWU");

var $1Hdcz = parcelRequire("1Hdcz");
parcelRequire("jpota");
const $e05f80c7548aefed$export$794e7bef9c0b12d9 = [];
const $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
const $e05f80c7548aefed$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today (buttonText, unit) {
            return unit === 'day' ? 'Today' : `This ${buttonText}`;
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
    }
});
function $e05f80c7548aefed$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    let allRawLocales = $e05f80c7548aefed$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $e05f80c7548aefed$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $e05f80c7548aefed$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return $e05f80c7548aefed$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $e05f80c7548aefed$var$queryLocale(inputSingular, available);
}
function $e05f80c7548aefed$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $e05f80c7548aefed$var$queryRawLocale(codes, available) || $e05f80c7548aefed$var$RAW_EN_LOCALE;
    return $e05f80c7548aefed$var$parseLocale(codeArg, codes, raw);
}
function $e05f80c7548aefed$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split('-');
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $e05f80c7548aefed$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $9tuWU.m)([
        $e05f80c7548aefed$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $e05f80c7548aefed$export$ae829ec7b2625219(input) {
    return {
        id: (0, $9tuWU.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $e05f80c7548aefed$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $e05f80c7548aefed$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $e05f80c7548aefed$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $9tuWU.i)(overrideDefs, currentOverrideDefs) || !(0, $9tuWU.i)(globalDefs, currentGlobalDefs)) currentHooks = $e05f80c7548aefed$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $e05f80c7548aefed$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $e05f80c7548aefed$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $e05f80c7548aefed$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $e05f80c7548aefed$var$StandardTheme extends (0, $9tuWU.T) {
}
$e05f80c7548aefed$var$StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
$e05f80c7548aefed$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
$e05f80c7548aefed$var$StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
$e05f80c7548aefed$var$StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
$e05f80c7548aefed$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function $e05f80c7548aefed$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $e05f80c7548aefed$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $e05f80c7548aefed$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $e05f80c7548aefed$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp('component');
    let superType = queryProp('superType');
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = $e05f80c7548aefed$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $e05f80c7548aefed$var$parseViewConfigs(inputs) {
    return (0, $9tuWU.a)(inputs, $e05f80c7548aefed$var$parseViewConfig);
}
function $e05f80c7548aefed$var$parseViewConfig(input) {
    let rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $e05f80c7548aefed$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $9tuWU.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $e05f80c7548aefed$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $e05f80c7548aefed$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $1Hdcz.createElement)((0, $9tuWU.V).Consumer, null, (context)=>(0, $1Hdcz.createElement)((0, $9tuWU.C), {
                elTag: "div",
                elClasses: (0, $9tuWU.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $e05f80c7548aefed$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $e05f80c7548aefed$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $e05f80c7548aefed$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $e05f80c7548aefed$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $9tuWU.a)(viewDefs, (viewDef)=>$e05f80c7548aefed$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $e05f80c7548aefed$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = '';
    let singleUnit = '';
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $e05f80c7548aefed$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $9tuWU.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $9tuWU.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $9tuWU.e))
    };
}
// hack to get memoization working
let $e05f80c7548aefed$var$durationInputMap = {};
function $e05f80c7548aefed$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $e05f80c7548aefed$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $9tuWU.d)(durationInput);
        $e05f80c7548aefed$var$durationInputMap[json] = res;
    }
    return res;
}
function $e05f80c7548aefed$var$reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function $e05f80c7548aefed$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $e05f80c7548aefed$var$getInitialDate(options, dateEnv, nowManager) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $e05f80c7548aefed$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $e05f80c7548aefed$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $e05f80c7548aefed$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $e05f80c7548aefed$var$addSources({}, $e05f80c7548aefed$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $e05f80c7548aefed$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return $e05f80c7548aefed$var$addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return $e05f80c7548aefed$var$removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $e05f80c7548aefed$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return $e05f80c7548aefed$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $9tuWU.f)(action.sourceIds) : $e05f80c7548aefed$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return $e05f80c7548aefed$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function $e05f80c7548aefed$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $e05f80c7548aefed$var$fetchSourcesByIds(eventSources, $e05f80c7548aefed$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $e05f80c7548aefed$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $e05f80c7548aefed$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $e05f80c7548aefed$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $e05f80c7548aefed$var$removeSource(eventSourceHash, sourceId) {
    return (0, $9tuWU.h)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $e05f80c7548aefed$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $e05f80c7548aefed$var$fetchSourcesByIds(sourceHash, (0, $9tuWU.h)(sourceHash, (eventSource)=>$e05f80c7548aefed$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $e05f80c7548aefed$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $e05f80c7548aefed$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $e05f80c7548aefed$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $e05f80c7548aefed$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $9tuWU.g)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $e05f80c7548aefed$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $e05f80c7548aefed$var$excludeStaticSources(eventSources, context) {
    return (0, $9tuWU.h)(eventSources, (eventSource)=>$e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context));
}
function $e05f80c7548aefed$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $9tuWU.j)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $9tuWU.p)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $e05f80c7548aefed$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $e05f80c7548aefed$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function $e05f80c7548aefed$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $e05f80c7548aefed$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $e05f80c7548aefed$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $e05f80c7548aefed$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $e05f80c7548aefed$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $e05f80c7548aefed$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $e05f80c7548aefed$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $e05f80c7548aefed$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $e05f80c7548aefed$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === 'rtl';
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $9tuWU.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, $9tuWU.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $9tuWU.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $e05f80c7548aefed$var$ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let $e05f80c7548aefed$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $e05f80c7548aefed$var$arrayEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'array-event-source',
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef$2
    ]
});
let $e05f80c7548aefed$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $9tuWU.u)(func.bind(null, (0, $9tuWU.l)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $e05f80c7548aefed$var$funcEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'func-event-source',
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef$1
    ]
});
const $e05f80c7548aefed$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $9tuWU.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $e05f80c7548aefed$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $e05f80c7548aefed$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $9tuWU.r)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $e05f80c7548aefed$var$jsonFeedEventSourcePlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'json-event-source',
    eventSourceRefiners: $e05f80c7548aefed$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $e05f80c7548aefed$var$eventSourceDef
    ]
});
function $e05f80c7548aefed$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $e05f80c7548aefed$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $9tuWU.n),
    startTime: (0, $9tuWU.d),
    endTime: (0, $9tuWU.d),
    duration: (0, $9tuWU.d),
    startRecur: (0, $9tuWU.n),
    endRecur: (0, $9tuWU.n)
};
let $e05f80c7548aefed$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $9tuWU.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $9tuWU.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $e05f80c7548aefed$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
const $e05f80c7548aefed$var$simpleRecurringEventsPlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'simple-recurring-event',
    recurringTypes: [
        $e05f80c7548aefed$var$recurring
    ],
    eventRefiners: $e05f80c7548aefed$var$SIMPLE_RECURRING_REFINERS
});
function $e05f80c7548aefed$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    let dowHash = daysOfWeek ? (0, $9tuWU.f)(daysOfWeek) : null;
    let dayMarker = (0, $9tuWU.q)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, $9tuWU.t)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, $9tuWU.t)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $9tuWU.t)(dayMarker, 1);
    }
    return instanceStarts;
}
const $e05f80c7548aefed$var$changeHandlerPlugin = $e05f80c7548aefed$export$ae829ec7b2625219({
    name: 'change-handler',
    optionChangeHandlers: {
        events (events, context) {
            $e05f80c7548aefed$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $e05f80c7548aefed$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $e05f80c7548aefed$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $9tuWU.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $e05f80c7548aefed$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, $9tuWU.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $e05f80c7548aefed$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, $9tuWU.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $e05f80c7548aefed$export$905153d94e0757fa = [
    $e05f80c7548aefed$var$arrayEventSourcePlugin,
    $e05f80c7548aefed$var$funcEventSourcePlugin,
    $e05f80c7548aefed$var$jsonFeedEventSourcePlugin,
    $e05f80c7548aefed$var$simpleRecurringEventsPlugin,
    $e05f80c7548aefed$var$changeHandlerPlugin,
    $e05f80c7548aefed$export$ae829ec7b2625219({
        name: 'misc',
        isLoadingFuncs: [
            (state)=>$e05f80c7548aefed$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $e05f80c7548aefed$var$handleDateProfile,
            eventStore: $e05f80c7548aefed$var$handleEventStore
        }
    })
];
class $e05f80c7548aefed$var$TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $9tuWU.D)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $e05f80c7548aefed$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $9tuWU.x)(viewOptions.titleFormat || $e05f80c7548aefed$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $e05f80c7548aefed$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    let days = (0, $9tuWU.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ class $e05f80c7548aefed$var$CalendarNowManager {
    constructor(){
        this.resetListeners = new Set();
    }
    handleInput(dateEnv, nowInput) {
        const oldDateEnv = this.dateEnv;
        if (dateEnv !== oldDateEnv) {
            if (typeof nowInput === 'function') this.nowFn = nowInput;
            else if (!oldDateEnv) {
                this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                this.nowAnchorQueried = Date.now();
            }
            this.dateEnv = dateEnv;
            // not first time? fire reset handlers
            if (oldDateEnv) for (const resetListener of this.resetListeners.values())resetListener();
        }
    }
    getDateMarker() {
        return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
    }
    addResetListener(handler) {
        this.resetListeners.add(handler);
    }
    removeResetListener(handler) {
        this.resetListeners.delete(handler);
    }
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $e05f80c7548aefed$var$CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, $9tuWU.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $9tuWU.z)($e05f80c7548aefed$var$organizeRawLocales);
        this.buildLocale = (0, $9tuWU.z)($e05f80c7548aefed$var$buildLocale);
        this.buildPluginHooks = $e05f80c7548aefed$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $9tuWU.z)($e05f80c7548aefed$var$buildDateEnv$1);
        this.buildTheme = (0, $9tuWU.z)($e05f80c7548aefed$var$buildTheme);
        this.parseToolbars = (0, $9tuWU.z)($e05f80c7548aefed$var$parseToolbars);
        this.buildViewSpecs = (0, $9tuWU.z)($e05f80c7548aefed$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $9tuWU.A)($e05f80c7548aefed$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $9tuWU.z)($e05f80c7548aefed$var$buildViewApi);
        this.buildViewUiProps = (0, $9tuWU.A)($e05f80c7548aefed$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $9tuWU.z)($e05f80c7548aefed$var$buildEventUiBySource, (0, $9tuWU.E));
        this.buildEventUiBases = (0, $9tuWU.z)($e05f80c7548aefed$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $9tuWU.A)($e05f80c7548aefed$var$parseContextBusinessHours);
        this.buildTitle = (0, $9tuWU.z)($e05f80c7548aefed$var$buildTitle);
        this.nowManager = new $e05f80c7548aefed$var$CalendarNowManager();
        this.emitter = new (0, $9tuWU.F)();
        this.actionRunner = new $e05f80c7548aefed$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $e05f80c7548aefed$var$CalendarNowManager();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        let currentDate = $e05f80c7548aefed$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $9tuWU.G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $e05f80c7548aefed$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $9tuWU.H)(),
            renderableEventStore: (0, $9tuWU.H)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($e05f80c7548aefed$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: 'NOTHING'
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $e05f80c7548aefed$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $e05f80c7548aefed$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = $e05f80c7548aefed$var$reduceCurrentDate(currentDate, action);
        dateProfile = $e05f80c7548aefed$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
        action.type === 'NEXT' || // "
        !(0, $9tuWU.G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $e05f80c7548aefed$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $9tuWU.I)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $e05f80c7548aefed$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $e05f80c7548aefed$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $e05f80c7548aefed$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $e05f80c7548aefed$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $e05f80c7548aefed$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $e05f80c7548aefed$var$computeIsLoading(state, calendarContext);
        let isLoading = $e05f80c7548aefed$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger('loading', true);
        else if (wasLoading && !isLoading) emitter.trigger('loading', false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            nowManager: this.nowManager,
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $e05f80c7548aefed$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $9tuWU.J)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $9tuWU.J)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $e05f80c7548aefed$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $9tuWU.K)([
            (0, $9tuWU.e),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $e05f80c7548aefed$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $9tuWU.L)), (0, $9tuWU.M)), (0, $9tuWU.N)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $9tuWU.K)([
            (0, $9tuWU.e),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $9tuWU.O)[optionName] && optionName in currentRaw && (0, $9tuWU.O)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $e05f80c7548aefed$var$warnUnknownOptions(extra);
        this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            nowManager: this.nowManager,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $9tuWU.K)([
            (0, $9tuWU.e),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $9tuWU.L)), (0, $9tuWU.M)), (0, $9tuWU.N)), (0, $9tuWU.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $9tuWU.O)[optionName] && (0, $9tuWU.O)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $9tuWU.O)[optionName] && (0, $9tuWU.O)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
}
function $e05f80c7548aefed$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $e05f80c7548aefed$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $9tuWU.Q)({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $e05f80c7548aefed$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $e05f80c7548aefed$var$StandardTheme;
    return new ThemeClass(options);
}
function $e05f80c7548aefed$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $9tuWU.R);
    return new DateProfileGeneratorClass(props);
}
function $e05f80c7548aefed$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $e05f80c7548aefed$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $e05f80c7548aefed$var$buildEventUiBySource(eventSources) {
    return (0, $9tuWU.a)(eventSources, (eventSource)=>eventSource.ui);
}
function $e05f80c7548aefed$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        '': eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $e05f80c7548aefed$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $9tuWU.S)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $9tuWU.S)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $e05f80c7548aefed$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $e05f80c7548aefed$var$parseContextBusinessHours(calendarContext) {
    return (0, $9tuWU.U)(calendarContext.options.businessHours, calendarContext);
}
function $e05f80c7548aefed$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
}
class $e05f80c7548aefed$var$ToolbarSection extends (0, $9tuWU.B) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $1Hdcz.createElement)('div', {
            className: 'fc-toolbar-chunk'
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push((0, $1Hdcz.createElement)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass('button')
                ];
                if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                children.push((0, $1Hdcz.createElement)("button", {
                    type: "button",
                    title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(' '),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $1Hdcz.createElement)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : '')));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
            return (0, $1Hdcz.createElement)('div', {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $e05f80c7548aefed$var$Toolbar extends (0, $9tuWU.B) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : ''
        ];
        return (0, $1Hdcz.createElement)("div", {
            className: classNames.join(' ')
        }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $1Hdcz.createElement)($e05f80c7548aefed$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $e05f80c7548aefed$var$ViewHarness extends (0, $9tuWU.B) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $9tuWU.W)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            'fc-view-harness',
            aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
             : 'fc-view-harness-passive'
        ];
        let height = '';
        let paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || '';
        return (0, $1Hdcz.createElement)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(' '),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $e05f80c7548aefed$var$EventClicking extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $9tuWU.Y)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $9tuWU.Z)(ev.target, '.fc-event-forced-url');
                let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, $9tuWU._)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $9tuWU.$)(settings.el, 'click', '.fc-event', this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $e05f80c7548aefed$var$EventHovering extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $9tuWU.Y)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $9tuWU.a0)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $9tuWU.Y)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $9tuWU._)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class $e05f80c7548aefed$var$CalendarContent extends (0, $9tuWU.a1) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $9tuWU.z)((0, $9tuWU.a2));
        this.buildViewPropTransformers = (0, $9tuWU.z)($e05f80c7548aefed$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $9tuWU.z)($e05f80c7548aefed$var$buildToolbarProps);
        this.headerRef = (0, $1Hdcz.createRef)();
        this.footerRef = (0, $1Hdcz.createRef)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $9tuWU.a3)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $9tuWU.a4)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $e05f80c7548aefed$var$EventClicking,
                $e05f80c7548aefed$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $9tuWU.a5)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $9tuWU.a5)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $9tuWU.D)(()=>{
            this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger('windowResize', {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let viewVGrow = false;
        let viewHeight = '';
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = '';
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, $1Hdcz.createElement)((0, $9tuWU.V).Provider, {
            value: viewContext
        }, (0, $1Hdcz.createElement)((0, $9tuWU.a6), {
            unit: "day"
        }, (nowDate)=>{
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
            return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, toolbarConfig.header && (0, $1Hdcz.createElement)($e05f80c7548aefed$var$Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, $1Hdcz.createElement)($e05f80c7548aefed$var$ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $1Hdcz.createElement)($e05f80c7548aefed$var$Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener('resize', this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger('_unmount');
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $1Hdcz.createElement)(ViewComponent, Object.assign({}, viewProps));
    }
}
function $e05f80c7548aefed$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $9tuWU.G)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $e05f80c7548aefed$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $e05f80c7548aefed$export$e1aef45b828286de extends (0, $9tuWU.a7) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $9tuWU.a8)(()=>{
                    (0, $1Hdcz.render)((0, $1Hdcz.createElement)((0, $9tuWU.a9), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $1Hdcz.createElement)((0, $9tuWU.aa).Provider, {
                            value: this.customContentRenderId
                        }, (0, $1Hdcz.createElement)($e05f80c7548aefed$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $1Hdcz.render)(null, this.el);
                this.setClassNames([]);
                this.setHeight('');
            }
        };
        (0, $9tuWU.ab)(el);
        this.el = el;
        this.renderRunner = new (0, $9tuWU.D)(this.handleRenderRequest);
        new $e05f80c7548aefed$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $9tuWU.a8)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    }
    pauseRendering() {
        this.renderRunner.pause('pauseRendering');
    }
    resumeRendering() {
        this.renderRunner.resume('pauseRendering', true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $9tuWU.i)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $9tuWU.ac)(this.el, 'height', height);
    }
}
function $e05f80c7548aefed$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $e05f80c7548aefed$var$buildDateEnv(options);
    let formatter = (0, $9tuWU.x)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $e05f80c7548aefed$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $e05f80c7548aefed$var$buildDateEnv(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    let formatter = (0, $9tuWU.x)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $9tuWU.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $e05f80c7548aefed$var$buildDateEnv(settings) {
    let locale = $e05f80c7548aefed$var$buildLocale(settings.locale || 'en', $e05f80c7548aefed$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $9tuWU.Q)(Object.assign(Object.assign({
        timeZone: (0, $9tuWU.e).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $e05f80c7548aefed$export$3b384895d0cca0f2(props, allDay) {
    return (0, $9tuWU.ad)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $e05f80c7548aefed$export$83d89fbfd8236492 = '6.1.21';

});
parcelRegister("9tuWU", function(module, exports) {

$parcel$export(module.exports, "ct", () => $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75);
$parcel$export(module.exports, "ab", () => $6e5ed45f0fbbb6e2$export$555508cbc6add439);
$parcel$export(module.exports, "D", () => $6e5ed45f0fbbb6e2$export$96f57966bedc81b4);
$parcel$export(module.exports, "aM", () => $6e5ed45f0fbbb6e2$export$9f4f30ee63539e24);
$parcel$export(module.exports, "Z", () => $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "aO", () => $6e5ed45f0fbbb6e2$export$c03999cb2f36933f);
$parcel$export(module.exports, "aN", () => $6e5ed45f0fbbb6e2$export$faec65b429be379);
$parcel$export(module.exports, "ac", () => $6e5ed45f0fbbb6e2$export$2219238a014317b0);
$parcel$export(module.exports, "aP", () => $6e5ed45f0fbbb6e2$export$2ed0fc6709e59212);
$parcel$export(module.exports, "a3", () => $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6);
$parcel$export(module.exports, "$", () => $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "a0", () => $6e5ed45f0fbbb6e2$export$34aec0b863436764);
$parcel$export(module.exports, "b0", () => $6e5ed45f0fbbb6e2$export$8c78c7c36408ea29);
$parcel$export(module.exports, "g", () => $6e5ed45f0fbbb6e2$export$39b482c5e57630a8);
$parcel$export(module.exports, "av", () => $6e5ed45f0fbbb6e2$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "au", () => $6e5ed45f0fbbb6e2$export$1fbe638ecf81657e);
$parcel$export(module.exports, "ap", () => $6e5ed45f0fbbb6e2$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "aq", () => $6e5ed45f0fbbb6e2$export$8a5498727ef6be21);
$parcel$export(module.exports, "ar", () => $6e5ed45f0fbbb6e2$export$d24c54395ce0c509);
$parcel$export(module.exports, "as", () => $6e5ed45f0fbbb6e2$export$6554612db691658e);
$parcel$export(module.exports, "k", () => $6e5ed45f0fbbb6e2$export$342063e11d6c3cad);
$parcel$export(module.exports, "at", () => $6e5ed45f0fbbb6e2$export$493d36ec626b6698);
$parcel$export(module.exports, "d", () => $6e5ed45f0fbbb6e2$export$4368d992c4eafac0);
$parcel$export(module.exports, "bn", () => $6e5ed45f0fbbb6e2$export$acf3ba20e47771d);
$parcel$export(module.exports, "s", () => $6e5ed45f0fbbb6e2$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "bm", () => $6e5ed45f0fbbb6e2$export$55ff3cc1821e8445);
$parcel$export(module.exports, "bq", () => $6e5ed45f0fbbb6e2$export$4b170465d7badfa1);
$parcel$export(module.exports, "br", () => $6e5ed45f0fbbb6e2$export$479ac0420f53ed26);
$parcel$export(module.exports, "c", () => $6e5ed45f0fbbb6e2$export$db3b6bfb95261072);
$parcel$export(module.exports, "i", () => $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef);
$parcel$export(module.exports, "bf", () => $6e5ed45f0fbbb6e2$export$151db275011178c4);
$parcel$export(module.exports, "t", () => $6e5ed45f0fbbb6e2$export$625550452a3fa3ec);
$parcel$export(module.exports, "be", () => $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb);
$parcel$export(module.exports, "bg", () => $6e5ed45f0fbbb6e2$export$136fd86de524d3c2);
$parcel$export(module.exports, "bj", () => $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3);
$parcel$export(module.exports, "q", () => $6e5ed45f0fbbb6e2$export$9e5f44173e64f162);
$parcel$export(module.exports, "y", () => $6e5ed45f0fbbb6e2$export$4a5767248b18ef41);
$parcel$export(module.exports, "bu", () => $6e5ed45f0fbbb6e2$export$f438b12253c2b499);
$parcel$export(module.exports, "bt", () => $6e5ed45f0fbbb6e2$export$56350196709588fc);
$parcel$export(module.exports, "bv", () => $6e5ed45f0fbbb6e2$export$5dbe06c6d8c68cfb);
$parcel$export(module.exports, "bs", () => $6e5ed45f0fbbb6e2$export$4e222d082f82ee97);
$parcel$export(module.exports, "z", () => $6e5ed45f0fbbb6e2$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $6e5ed45f0fbbb6e2$export$ebd11618f299a286);
$parcel$export(module.exports, "E", () => $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "x", () => $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3);
$parcel$export(module.exports, "L", () => $6e5ed45f0fbbb6e2$export$61196ced6d74a310);
$parcel$export(module.exports, "n", () => $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "e", () => $6e5ed45f0fbbb6e2$export$f1e1789686576879);
$parcel$export(module.exports, "M", () => $6e5ed45f0fbbb6e2$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "N", () => $6e5ed45f0fbbb6e2$export$a07804094c3ecf2d);
$parcel$export(module.exports, "O", () => $6e5ed45f0fbbb6e2$export$c4ce752e73470fba);
$parcel$export(module.exports, "P", () => $6e5ed45f0fbbb6e2$export$56c0d5a1e737357d);
$parcel$export(module.exports, "K", () => $6e5ed45f0fbbb6e2$export$3466f893ebf79586);
$parcel$export(module.exports, "m", () => $6e5ed45f0fbbb6e2$export$953cecd6e717a553);
$parcel$export(module.exports, "h", () => $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "a", () => $6e5ed45f0fbbb6e2$export$407448d2b89b1813);
$parcel$export(module.exports, "f", () => $6e5ed45f0fbbb6e2$export$2d1720544b23b823);
$parcel$export(module.exports, "v", () => $6e5ed45f0fbbb6e2$export$90a7f3efeed30595);
$parcel$export(module.exports, "Q", () => $6e5ed45f0fbbb6e2$export$3722cfe417b6ed86);
$parcel$export(module.exports, "T", () => $6e5ed45f0fbbb6e2$export$971d5caa766a69d7);
$parcel$export(module.exports, "a8", () => $6e5ed45f0fbbb6e2$export$c3950d9923825c02);
$parcel$export(module.exports, "V", () => $6e5ed45f0fbbb6e2$export$e7c866399fa523f5);
$parcel$export(module.exports, "a2", () => $6e5ed45f0fbbb6e2$export$ce26c07117d59d6a);
$parcel$export(module.exports, "a1", () => $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea);
$parcel$export(module.exports, "B", () => $6e5ed45f0fbbb6e2$export$ef35774e6d314e91);
$parcel$export(module.exports, "W", () => $6e5ed45f0fbbb6e2$export$71cec2538cb2c617);
$parcel$export(module.exports, "aa", () => $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de);
$parcel$export(module.exports, "C", () => $6e5ed45f0fbbb6e2$export$e7094788287c5e9b);
$parcel$export(module.exports, "cq", () => $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd);
$parcel$export(module.exports, "b", () => $6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "o", () => $6e5ed45f0fbbb6e2$export$ae1af26003f05816);
$parcel$export(module.exports, "b7", () => $6e5ed45f0fbbb6e2$export$f074adc9fbd50943);
$parcel$export(module.exports, "G", () => $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4);
$parcel$export(module.exports, "ay", () => $6e5ed45f0fbbb6e2$export$28f7fcd39efa255);
$parcel$export(module.exports, "R", () => $6e5ed45f0fbbb6e2$export$db202ddc8be9136);
$parcel$export(module.exports, "ah", () => $6e5ed45f0fbbb6e2$export$995eb9fca571757);
$parcel$export(module.exports, "aj", () => $6e5ed45f0fbbb6e2$export$3b513254972cfc9c);
$parcel$export(module.exports, "ai", () => $6e5ed45f0fbbb6e2$export$f38c853ae54ed474);
$parcel$export(module.exports, "S", () => $6e5ed45f0fbbb6e2$export$25ce5a424b770e84);
$parcel$export(module.exports, "H", () => $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "aU", () => $6e5ed45f0fbbb6e2$export$317a3d46287192d8);
$parcel$export(module.exports, "aT", () => $6e5ed45f0fbbb6e2$export$667d3bf0c5f83305);
$parcel$export(module.exports, "p", () => $6e5ed45f0fbbb6e2$export$ffb5f4729a158638);
$parcel$export(module.exports, "j", () => $6e5ed45f0fbbb6e2$export$35e795649ee09318);
$parcel$export(module.exports, "I", () => $6e5ed45f0fbbb6e2$export$9bb611d729802a56);
$parcel$export(module.exports, "J", () => $6e5ed45f0fbbb6e2$export$b4171a6734a65d42);
$parcel$export(module.exports, "F", () => $6e5ed45f0fbbb6e2$export$d66501df72047452);
$parcel$export(module.exports, "U", () => $6e5ed45f0fbbb6e2$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "cr", () => $6e5ed45f0fbbb6e2$export$cbfbec548517f2b6);
$parcel$export(module.exports, "cs", () => $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "bV", () => $6e5ed45f0fbbb6e2$export$dabba94403d45c8e);
$parcel$export(module.exports, "_", () => $6e5ed45f0fbbb6e2$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "ad", () => $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "bN", () => $6e5ed45f0fbbb6e2$export$45aabb5431c2d04f);
$parcel$export(module.exports, "Y", () => $6e5ed45f0fbbb6e2$export$8743009a87fcb00f);
$parcel$export(module.exports, "bP", () => $6e5ed45f0fbbb6e2$export$a91cd623adc48128);
$parcel$export(module.exports, "bO", () => $6e5ed45f0fbbb6e2$export$2538633961795d6b);
$parcel$export(module.exports, "bQ", () => $6e5ed45f0fbbb6e2$export$993a080e5cb62d74);
$parcel$export(module.exports, "bR", () => $6e5ed45f0fbbb6e2$export$4d522598b426bb73);
$parcel$export(module.exports, "bS", () => $6e5ed45f0fbbb6e2$export$6dabbe08653f866f);
$parcel$export(module.exports, "bd", () => $6e5ed45f0fbbb6e2$export$7f557e5eb95176c2);
$parcel$export(module.exports, "l", () => $6e5ed45f0fbbb6e2$export$882b5998b3b9117c);
$parcel$export(module.exports, "u", () => $6e5ed45f0fbbb6e2$export$3b14a55fb2447963);
$parcel$export(module.exports, "r", () => $6e5ed45f0fbbb6e2$export$43caf9889c228507);
$parcel$export(module.exports, "a9", () => $6e5ed45f0fbbb6e2$export$a9c996f45e5784d0);
$parcel$export(module.exports, "X", () => $6e5ed45f0fbbb6e2$export$78acf4525d8a74c4);
$parcel$export(module.exports, "a4", () => $6e5ed45f0fbbb6e2$export$efca4cbe5dd06740);
$parcel$export(module.exports, "bE", () => $6e5ed45f0fbbb6e2$export$381353cf1dd55255);
$parcel$export(module.exports, "a5", () => $6e5ed45f0fbbb6e2$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a6", () => $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a7", () => $6e5ed45f0fbbb6e2$export$a93c5207d687da10);
$parcel$export(module.exports, "aD", () => $6e5ed45f0fbbb6e2$export$24baa2b76016ce0e);
$parcel$export(module.exports, "aC", () => $6e5ed45f0fbbb6e2$export$890c4ad488842ce7);
$parcel$export(module.exports, "aE", () => $6e5ed45f0fbbb6e2$export$158acd800e1ef08b);
$parcel$export(module.exports, "aF", () => $6e5ed45f0fbbb6e2$export$cf2f7c5792f80b46);
$parcel$export(module.exports, "aG", () => $6e5ed45f0fbbb6e2$export$53a70dd1ebbae346);
$parcel$export(module.exports, "aW", () => $6e5ed45f0fbbb6e2$export$9d0e2d13d04f7070);
$parcel$export(module.exports, "a_", () => $6e5ed45f0fbbb6e2$export$a17c37559e1db147);
$parcel$export(module.exports, "b1", () => $6e5ed45f0fbbb6e2$export$d29e374196577086);
$parcel$export(module.exports, "b4", () => $6e5ed45f0fbbb6e2$export$39c1cc7c062529d4);
$parcel$export(module.exports, "b3", () => $6e5ed45f0fbbb6e2$export$53c86fa97d611818);
$parcel$export(module.exports, "b8", () => $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8);
$parcel$export(module.exports, "b9", () => $6e5ed45f0fbbb6e2$export$4ae495d48253603d);
$parcel$export(module.exports, "ba", () => $6e5ed45f0fbbb6e2$export$7060da4b5db56fb9);
$parcel$export(module.exports, "bb", () => $6e5ed45f0fbbb6e2$export$c5d1328b37d47994);
$parcel$export(module.exports, "bc", () => $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a);
$parcel$export(module.exports, "by", () => $6e5ed45f0fbbb6e2$export$766bf7dcfb630b6c);
$parcel$export(module.exports, "bD", () => $6e5ed45f0fbbb6e2$export$b0165a7e514844);
$parcel$export(module.exports, "bz", () => $6e5ed45f0fbbb6e2$export$674f8f4247a5112e);
$parcel$export(module.exports, "bB", () => $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c);
$parcel$export(module.exports, "bA", () => $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b);
$parcel$export(module.exports, "bC", () => $6e5ed45f0fbbb6e2$export$d76842aa27385215);
$parcel$export(module.exports, "bF", () => $6e5ed45f0fbbb6e2$export$b2bcef12bcefba04);
$parcel$export(module.exports, "bG", () => $6e5ed45f0fbbb6e2$export$aff10ba49ece4b91);
$parcel$export(module.exports, "bH", () => $6e5ed45f0fbbb6e2$export$60bb826a6acf3081);
$parcel$export(module.exports, "bI", () => $6e5ed45f0fbbb6e2$export$27d1aff6bea49709);
$parcel$export(module.exports, "bM", () => $6e5ed45f0fbbb6e2$export$ebb8f7cd71856fb9);
$parcel$export(module.exports, "bT", () => $6e5ed45f0fbbb6e2$export$1314441b8d04e1d5);
$parcel$export(module.exports, "bU", () => $6e5ed45f0fbbb6e2$export$e0c3a065614c6254);
$parcel$export(module.exports, "bX", () => $6e5ed45f0fbbb6e2$export$6d1e945284085e64);
$parcel$export(module.exports, "bY", () => $6e5ed45f0fbbb6e2$export$545a72cc0d3f00b0);
$parcel$export(module.exports, "cd", () => $6e5ed45f0fbbb6e2$export$807f1ba34db587c7);
$parcel$export(module.exports, "c8", () => $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290);
$parcel$export(module.exports, "ca", () => $6e5ed45f0fbbb6e2$export$89e9012e902952b6);
$parcel$export(module.exports, "c9", () => $6e5ed45f0fbbb6e2$export$4ad369a19af21c23);
$parcel$export(module.exports, "bZ", () => $6e5ed45f0fbbb6e2$export$c667925124dac624);
$parcel$export(module.exports, "ck", () => $6e5ed45f0fbbb6e2$export$c1df809846363ebe);
$parcel$export(module.exports, "cg", () => $6e5ed45f0fbbb6e2$export$6735ce526161c7bd);
$parcel$export(module.exports, "ch", () => $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012);
$parcel$export(module.exports, "ci", () => $6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53);
$parcel$export(module.exports, "cj", () => $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0);
$parcel$export(module.exports, "cm", () => $6e5ed45f0fbbb6e2$export$b02498c06ddfef28);
$parcel$export(module.exports, "cl", () => $6e5ed45f0fbbb6e2$export$b975d55abac2bbe3);
$parcel$export(module.exports, "cn", () => $6e5ed45f0fbbb6e2$export$1343a74baacb0543);
$parcel$export(module.exports, "co", () => $6e5ed45f0fbbb6e2$export$87b6ab1c2cb8b955);
$parcel$export(module.exports, "cp", () => $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73);
$parcel$export(module.exports, "cv", () => $6e5ed45f0fbbb6e2$export$1776704b6532a19a);

var $1Hdcz = parcelRequire("1Hdcz");

var $jpota = parcelRequire("jpota");
const $6e5ed45f0fbbb6e2$var$styleTexts = [];
const $6e5ed45f0fbbb6e2$var$styleEls = new Map();
function $6e5ed45f0fbbb6e2$export$e9316ff9106cdb75(styleText) {
    $6e5ed45f0fbbb6e2$var$styleTexts.push(styleText);
    $6e5ed45f0fbbb6e2$var$styleEls.forEach((styleEl)=>{
        $6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText);
    });
}
function $6e5ed45f0fbbb6e2$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $6e5ed45f0fbbb6e2$var$registerStylesRoot(el.getRootNode());
}
function $6e5ed45f0fbbb6e2$var$registerStylesRoot(rootNode) {
    let styleEl = $6e5ed45f0fbbb6e2$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            const nonce = $6e5ed45f0fbbb6e2$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $6e5ed45f0fbbb6e2$var$styleEls.set(rootNode, styleEl);
        $6e5ed45f0fbbb6e2$var$hydrateStylesRoot(styleEl);
    }
}
function $6e5ed45f0fbbb6e2$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $6e5ed45f0fbbb6e2$var$styleTexts)$6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText);
}
function $6e5ed45f0fbbb6e2$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $6e5ed45f0fbbb6e2$var$queriedNonceValue;
function $6e5ed45f0fbbb6e2$var$getNonceValue() {
    if ($6e5ed45f0fbbb6e2$var$queriedNonceValue === undefined) $6e5ed45f0fbbb6e2$var$queriedNonceValue = $6e5ed45f0fbbb6e2$var$queryNonceValue();
    return $6e5ed45f0fbbb6e2$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $6e5ed45f0fbbb6e2$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    const elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') $6e5ed45f0fbbb6e2$var$registerStylesRoot(document);
var $6e5ed45f0fbbb6e2$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
$6e5ed45f0fbbb6e2$export$e9316ff9106cdb75($6e5ed45f0fbbb6e2$var$css_248z);
class $6e5ed45f0fbbb6e2$export$96f57966bedc81b4 {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = '') {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = '', force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function $6e5ed45f0fbbb6e2$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($6e5ed45f0fbbb6e2$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $6e5ed45f0fbbb6e2$export$c03999cb2f36933f(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $6e5ed45f0fbbb6e2$export$23ebac1979863676(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $6e5ed45f0fbbb6e2$export$91477dc880baac21(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $6e5ed45f0fbbb6e2$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $6e5ed45f0fbbb6e2$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $6e5ed45f0fbbb6e2$export$faec65b429be379(el, props) {
    for(let propName in props)$6e5ed45f0fbbb6e2$export$2219238a014317b0(el, propName, props[propName]);
}
function $6e5ed45f0fbbb6e2$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && $6e5ed45f0fbbb6e2$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $6e5ed45f0fbbb6e2$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $6e5ed45f0fbbb6e2$var$guid$1 = 0;
function $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6() {
    $6e5ed45f0fbbb6e2$var$guid$1 += 1;
    return 'fc-dom-' + $6e5ed45f0fbbb6e2$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    let attachedHandler = $6e5ed45f0fbbb6e2$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $6e5ed45f0fbbb6e2$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $6e5ed45f0fbbb6e2$export$3d8c2f653ac9d0b9(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $6e5ed45f0fbbb6e2$var$transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function $6e5ed45f0fbbb6e2$export$8c78c7c36408ea29(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $6e5ed45f0fbbb6e2$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $6e5ed45f0fbbb6e2$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs(handler));
}
function $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $6e5ed45f0fbbb6e2$var$guidNumber = 0;
function $6e5ed45f0fbbb6e2$export$39b482c5e57630a8() {
    $6e5ed45f0fbbb6e2$var$guidNumber += 1;
    return String($6e5ed45f0fbbb6e2$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $6e5ed45f0fbbb6e2$export$d66dc83d8cfc8dd() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function $6e5ed45f0fbbb6e2$export$1fbe638ecf81657e() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$8a5498727ef6be21(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$d24c54395ce0c509(el) {
    el.addEventListener('contextmenu', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$6554612db691658e(el) {
    el.removeEventListener('contextmenu', $6e5ed45f0fbbb6e2$export$fef3dfd9bad05307);
}
function $6e5ed45f0fbbb6e2$export$1a82df3d29112e01(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function $6e5ed45f0fbbb6e2$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $6e5ed45f0fbbb6e2$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $6e5ed45f0fbbb6e2$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $6e5ed45f0fbbb6e2$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $6e5ed45f0fbbb6e2$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$21579262ef46735b(val, len) {
    let s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter(...args);
    if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $6e5ed45f0fbbb6e2$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
const $6e5ed45f0fbbb6e2$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(input, unit) {
    if (typeof input === 'string') return $6e5ed45f0fbbb6e2$var$parseString(input);
    if (typeof input === 'object' && input) return $6e5ed45f0fbbb6e2$var$parseObject(input);
    if (typeof input === 'number') return $6e5ed45f0fbbb6e2$var$parseObject({
        [unit || 'milliseconds']: input
    });
    return null;
}
function $6e5ed45f0fbbb6e2$var$parseString(s) {
    let m = $6e5ed45f0fbbb6e2$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $6e5ed45f0fbbb6e2$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $6e5ed45f0fbbb6e2$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $6e5ed45f0fbbb6e2$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $6e5ed45f0fbbb6e2$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $6e5ed45f0fbbb6e2$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $6e5ed45f0fbbb6e2$var$asRoughYears(dur) {
    return $6e5ed45f0fbbb6e2$var$asRoughDays(dur) / 365;
}
function $6e5ed45f0fbbb6e2$var$asRoughMonths(dur) {
    return $6e5ed45f0fbbb6e2$var$asRoughDays(dur) / 30;
}
function $6e5ed45f0fbbb6e2$var$asRoughDays(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 864e5;
}
function $6e5ed45f0fbbb6e2$export$847533e5bf524f5f(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 60000;
}
function $6e5ed45f0fbbb6e2$export$b169257caa88022a(dur) {
    return $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) / 1000;
}
function $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $6e5ed45f0fbbb6e2$export$479ac0420f53ed26(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS.length; i += 1){
        let unit = $6e5ed45f0fbbb6e2$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function $6e5ed45f0fbbb6e2$export$3d12bd131bb975d1(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $6e5ed45f0fbbb6e2$var$DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function $6e5ed45f0fbbb6e2$export$151db275011178c4(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
function $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[2] += n;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
function $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(m, n) {
    let a = $6e5ed45f0fbbb6e2$var$dateToUtcArray(m);
    a[6] += n;
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $6e5ed45f0fbbb6e2$export$136fd86de524d3c2(m0, m1) {
    return $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $6e5ed45f0fbbb6e2$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $6e5ed45f0fbbb6e2$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $6e5ed45f0fbbb6e2$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $6e5ed45f0fbbb6e2$export$62d08d6fa708df47(m0, m1) {
    let m0day = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m0);
    let m1day = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $6e5ed45f0fbbb6e2$export$31e67cf12fc9668(m0, m1) {
    let d = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1) {
    if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1)) return Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfHour(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfMinute(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $6e5ed45f0fbbb6e2$var$startOfSecond(m) {
    return $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $6e5ed45f0fbbb6e2$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $6e5ed45f0fbbb6e2$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        year,
        0,
        1 + $6e5ed45f0fbbb6e2$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(marker);
    let days = Math.round($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $6e5ed45f0fbbb6e2$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $6e5ed45f0fbbb6e2$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $6e5ed45f0fbbb6e2$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $6e5ed45f0fbbb6e2$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $6e5ed45f0fbbb6e2$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $6e5ed45f0fbbb6e2$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $6e5ed45f0fbbb6e2$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $6e5ed45f0fbbb6e2$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $6e5ed45f0fbbb6e2$export$f438b12253c2b499(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $6e5ed45f0fbbb6e2$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function $6e5ed45f0fbbb6e2$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $6e5ed45f0fbbb6e2$export$4e222d082f82ee97(marker) {
    return $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCHours(), 2) + ':' + $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ':' + $6e5ed45f0fbbb6e2$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? '-' : '+';
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $6e5ed45f0fbbb6e2$export$21579262ef46735b(hours, 2)}:${$6e5ed45f0fbbb6e2$export$21579262ef46735b(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$6e5ed45f0fbbb6e2$export$21579262ef46735b(mins, 2)}` : ''}`;
}
function $6e5ed45f0fbbb6e2$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $6e5ed45f0fbbb6e2$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $6e5ed45f0fbbb6e2$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $6e5ed45f0fbbb6e2$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
const $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $6e5ed45f0fbbb6e2$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $6e5ed45f0fbbb6e2$var$COMMA_RE = /,/g; // we need re for globalness
const $6e5ed45f0fbbb6e2$var$MULTI_SPACE_RE = /\s+/g;
const $6e5ed45f0fbbb6e2$var$LTR_RE = /\u200e/g; // control character
const $6e5ed45f0fbbb6e2$var$UTC_RE = /UTC|GMT/;
class $6e5ed45f0fbbb6e2$var$NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(let name in formatSettings)if (name in $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            const severity = $6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($6e5ed45f0fbbb6e2$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $6e5ed45f0fbbb6e2$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $6e5ed45f0fbbb6e2$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $6e5ed45f0fbbb6e2$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $6e5ed45f0fbbb6e2$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getSmallestUnit() {
        switch(this.smallestUnitNum){
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    }
}
function $6e5ed45f0fbbb6e2$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>$6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$6e5ed45f0fbbb6e2$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $6e5ed45f0fbbb6e2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $6e5ed45f0fbbb6e2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $6e5ed45f0fbbb6e2$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $6e5ed45f0fbbb6e2$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $6e5ed45f0fbbb6e2$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $6e5ed45f0fbbb6e2$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($6e5ed45f0fbbb6e2$var$LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = $6e5ed45f0fbbb6e2$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $6e5ed45f0fbbb6e2$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($6e5ed45f0fbbb6e2$var$COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === 'short') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace($6e5ed45f0fbbb6e2$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($6e5ed45f0fbbb6e2$var$MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function $6e5ed45f0fbbb6e2$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($6e5ed45f0fbbb6e2$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $6e5ed45f0fbbb6e2$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $6e5ed45f0fbbb6e2$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($6e5ed45f0fbbb6e2$var$timeAsMs(d0) !== $6e5ed45f0fbbb6e2$var$timeAsMs(d1)) return 1;
    return 0;
}
function $6e5ed45f0fbbb6e2$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $6e5ed45f0fbbb6e2$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $6e5ed45f0fbbb6e2$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $6e5ed45f0fbbb6e2$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $6e5ed45f0fbbb6e2$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $6e5ed45f0fbbb6e2$var$CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class $6e5ed45f0fbbb6e2$var$FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func($6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($6e5ed45f0fbbb6e2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(input) {
    if (typeof input === 'object' && input) return new $6e5ed45f0fbbb6e2$var$NativeFormatter(input);
    if (typeof input === 'string') return new $6e5ed45f0fbbb6e2$var$CmdFormatter(input);
    if (typeof input === 'function') return new $6e5ed45f0fbbb6e2$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $6e5ed45f0fbbb6e2$export$61196ced6d74a310 = {
    navLinkDayClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    duration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    bootstrapFontAwesome: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonIcons: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customButtons: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    defaultTimedEventDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    nextDayThreshold: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    scrollTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    slotMaxTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    dayPopoverFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    slotDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    snapDuration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    headerToolbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    footerToolbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    dayHeaderClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorSnap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    locale: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventOrder: $6e5ed45f0fbbb6e2$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    contentHeight: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialDate: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    now: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    viewHeight: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventConstraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventAllow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectConstraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectOverlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectAllow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    hiddenDays: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    visibleRange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    titleFormat: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    navLinkHint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $6e5ed45f0fbbb6e2$export$f1e1789686576879 = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    },
    nowIndicatorSnap: 'auto'
};
// calendar listeners
// ------------------
const $6e5ed45f0fbbb6e2$export$3a1a48c8f6ef640e = {
    datesSet: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventsSet: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventAdd: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventChange: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventRemove: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    windowResize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventClick: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    select: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    unselect: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    loading: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _beforeprint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _afterprint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _noEventResize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _resize: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $6e5ed45f0fbbb6e2$export$a07804094c3ecf2d = {
    buttonText: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonHints: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    views: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    plugins: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    initialEvents: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    events: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventSources: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
const $6e5ed45f0fbbb6e2$export$c4ce752e73470fba = {
    headerToolbar: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    footerToolbar: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonText: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonHints: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    buttonIcons: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    dateIncrement: $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual,
    plugins: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    events: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    eventSources: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual,
    ['resources']: $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual
};
function $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) return $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $6e5ed45f0fbbb6e2$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $6e5ed45f0fbbb6e2$export$56c0d5a1e737357d = {
    type: String,
    component: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    content: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    didMount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    willUnmount: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$3466f893ebf79586(optionSets) {
    return $6e5ed45f0fbbb6e2$export$953cecd6e717a553(optionSets, $6e5ed45f0fbbb6e2$export$c4ce752e73470fba);
}
function $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
const { hasOwnProperty: $6e5ed45f0fbbb6e2$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $6e5ed45f0fbbb6e2$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $6e5ed45f0fbbb6e2$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $6e5ed45f0fbbb6e2$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $6e5ed45f0fbbb6e2$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $6e5ed45f0fbbb6e2$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $6e5ed45f0fbbb6e2$var$HANDLER_RE = /^on[A-Z]/;
function $6e5ed45f0fbbb6e2$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $6e5ed45f0fbbb6e2$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$6e5ed45f0fbbb6e2$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($6e5ed45f0fbbb6e2$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(let key in newProps){
        if (key in oldProps && $6e5ed45f0fbbb6e2$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $6e5ed45f0fbbb6e2$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $6e5ed45f0fbbb6e2$export$a05254e7c3aeba6e(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let $6e5ed45f0fbbb6e2$var$calendarSystemClassMap = {};
function $6e5ed45f0fbbb6e2$var$registerCalendarSystem(name, theClass) {
    $6e5ed45f0fbbb6e2$var$calendarSystemClassMap[name] = theClass;
}
function $6e5ed45f0fbbb6e2$var$createCalendarSystem(name) {
    return new $6e5ed45f0fbbb6e2$var$calendarSystemClassMap[name]();
}
class $6e5ed45f0fbbb6e2$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $6e5ed45f0fbbb6e2$var$dateToUtcArray(marker);
    }
}
$6e5ed45f0fbbb6e2$var$registerCalendarSystem('gregory', $6e5ed45f0fbbb6e2$var$GregorianCalendarSystem);
const $6e5ed45f0fbbb6e2$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $6e5ed45f0fbbb6e2$export$26a0a7676ca7aa04(str) {
    let m = $6e5ed45f0fbbb6e2$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($6e5ed45f0fbbb6e2$export$5521614468b862fb(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $6e5ed45f0fbbb6e2$export$3722cfe417b6ed86 {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $6e5ed45f0fbbb6e2$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate($6e5ed45f0fbbb6e2$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === 'string') return this.parse(input);
        let marker = null;
        if (typeof input === 'number') marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $6e5ed45f0fbbb6e2$var$arrayToUtcDate(input);
        if (marker === null || !$6e5ed45f0fbbb6e2$export$5521614468b862fb(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $6e5ed45f0fbbb6e2$export$26a0a7676ca7aa04(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($6e5ed45f0fbbb6e2$var$timeAsMs(m0) === $6e5ed45f0fbbb6e2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: 'year',
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: 'month',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$export$31e67cf12fc9668(m0, m1);
        if (n !== null) return {
            unit: 'week',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: 'day',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffHours(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'hour',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffMinutes(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'minute',
            value: n
        };
        n = $6e5ed45f0fbbb6e2$var$diffSeconds(m0, m1);
        if ($6e5ed45f0fbbb6e2$export$ab83b03e4111b1d0(n)) return {
            unit: 'second',
            value: n
        };
        return {
            unit: 'millisecond',
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $6e5ed45f0fbbb6e2$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $6e5ed45f0fbbb6e2$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === 'year') return this.startOfYear(m);
        if (unit === 'month') return this.startOfMonth(m);
        if (unit === 'week') return this.startOfWeek(m);
        if (unit === 'day') return $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(m);
        if (unit === 'hour') return $6e5ed45f0fbbb6e2$var$startOfHour(m);
        if (unit === 'minute') return $6e5ed45f0fbbb6e2$var$startOfMinute(m);
        if (unit === 'second') return $6e5ed45f0fbbb6e2$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $6e5ed45f0fbbb6e2$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $6e5ed45f0fbbb6e2$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === 'local') return $6e5ed45f0fbbb6e2$var$arrayToUtcDate($6e5ed45f0fbbb6e2$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
        return $6e5ed45f0fbbb6e2$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === 'local') return -$6e5ed45f0fbbb6e2$var$arrayToLocalDate($6e5ed45f0fbbb6e2$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === 'UTC') return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($6e5ed45f0fbbb6e2$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === 'local') return $6e5ed45f0fbbb6e2$var$arrayToLocalDate($6e5ed45f0fbbb6e2$var$dateToUtcArray(m));
        if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($6e5ed45f0fbbb6e2$var$dateToUtcArray(m)) * 60000);
    }
}
class $6e5ed45f0fbbb6e2$export$971d5caa766a69d7 {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || '';
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return '';
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return '';
    }
}
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.classes = {};
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.iconClasses = {};
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.baseIconClass = '';
$6e5ed45f0fbbb6e2$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $6e5ed45f0fbbb6e2$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $1Hdcz.options.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $1Hdcz.options.debounceRendering = execCallbackSync;
    $1Hdcz.render($1Hdcz.createElement($6e5ed45f0fbbb6e2$var$FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    $1Hdcz.options.debounceRendering = oldDebounceRendering;
}
class $6e5ed45f0fbbb6e2$var$FakeComponent extends $1Hdcz.Component {
    render() {
        return $1Hdcz.createElement('div', {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57(defaultValue) {
    let ContextType = $1Hdcz.createContext(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $6e5ed45f0fbbb6e2$export$49e6ee724f7f1ace {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const $6e5ed45f0fbbb6e2$export$e7c866399fa523f5 = $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57({}); // for Components
function $6e5ed45f0fbbb6e2$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder (execFunc) {
            return new $6e5ed45f0fbbb6e2$export$49e6ee724f7f1ace(execFunc, emitter, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea extends (0, $1Hdcz.Component) {
    // debug: boolean
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality /*, this.debug */ ) || !$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality /*, this.debug */ );
        // if (this.debug && shouldUpdate) {
        //   console.log('shouldUpdate!')
        // }
        return shouldUpdate;
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$6e5ed45f0fbbb6e2$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.addPropsEquality = $6e5ed45f0fbbb6e2$var$addPropsEquality;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.addStateEquality = $6e5ed45f0fbbb6e2$var$addStateEquality;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.prototype.propEquality = {};
$6e5ed45f0fbbb6e2$export$3c2fa207a37baaea.prototype.stateEquality = {};
class $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 extends $6e5ed45f0fbbb6e2$export$3c2fa207a37baaea {
}
$6e5ed45f0fbbb6e2$export$ef35774e6d314e91.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
function $6e5ed45f0fbbb6e2$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $6e5ed45f0fbbb6e2$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class $6e5ed45f0fbbb6e2$var$ContentInjector extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.id = $6e5ed45f0fbbb6e2$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options: options } = this.context;
            const { generatorName: generatorName } = this.props;
            if (!options.customRenderingReplaces || !$6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $1Hdcz.createElement)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === 'object'; // non-null
                if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, $1Hdcz.isValidElement)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $1Hdcz.createElement)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($6e5ed45f0fbbb6e2$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($6e5ed45f0fbbb6e2$export$9f4f30ee63539e24);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
$6e5ed45f0fbbb6e2$var$ContentInjector.addPropsEquality({
    elClasses: $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef,
    elStyle: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca,
    elAttrs: $6e5ed45f0fbbb6e2$var$isNonHandlerPropsEqual,
    renderProps: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $6e5ed45f0fbbb6e2$var$isTruthy(val) {
    return Boolean(val);
}
const $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de = $6e5ed45f0fbbb6e2$export$c9170ad7d4cd7e57(0);
class $6e5ed45f0fbbb6e2$export$e7094788287c5e9b extends (0, $1Hdcz.Component) {
    constructor(){
        super(...arguments);
        this.InnerContent = $6e5ed45f0fbbb6e2$var$InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props: props } = this;
        const generatedClassNames = $6e5ed45f0fbbb6e2$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $6e5ed45f0fbbb6e2$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $1Hdcz.createElement)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || 'div',
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
$6e5ed45f0fbbb6e2$export$e7094788287c5e9b.contextType = $6e5ed45f0fbbb6e2$export$7910e0436ed8d1de;
function $6e5ed45f0fbbb6e2$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $6e5ed45f0fbbb6e2$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
class $6e5ed45f0fbbb6e2$export$a3c9165b94390bcd extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }, ()=>props.children);
    }
}
function $6e5ed45f0fbbb6e2$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        'fc-view'
    ];
}
function $6e5ed45f0fbbb6e2$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $6e5ed45f0fbbb6e2$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($6e5ed45f0fbbb6e2$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $6e5ed45f0fbbb6e2$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $6e5ed45f0fbbb6e2$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $6e5ed45f0fbbb6e2$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $6e5ed45f0fbbb6e2$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $6e5ed45f0fbbb6e2$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $6e5ed45f0fbbb6e2$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    let start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.start);
    let end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $6e5ed45f0fbbb6e2$export$92108d983e8ee699(timedRange, nextDayThreshold = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(nextDayThreshold)) endDay = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $6e5ed45f0fbbb6e2$export$9fa96a7d116ea3ce(range) {
    let visibleRange = $6e5ed45f0fbbb6e2$export$92108d983e8ee699(range);
    return $6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
    return $6e5ed45f0fbbb6e2$export$62d08d6fa708df47(date0, date1); // returns a duration
}
class $6e5ed45f0fbbb6e2$export$db202ddc8be9136 {
    constructor(props){
        this.props = props;
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $6e5ed45f0fbbb6e2$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $6e5ed45f0fbbb6e2$export$c18d01048907ea92(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($6e5ed45f0fbbb6e2$var$asRoughDays(slotMinTime) < 0) {
                start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($6e5ed45f0fbbb6e2$var$asRoughDays(slotMaxTime) > 1) {
                end = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(end); // necessary?
                end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($6e5ed45f0fbbb6e2$export$4b170465d7badfa1(dateIncrement) < $6e5ed45f0fbbb6e2$export$4b170465d7badfa1(duration)) dateAlignment = $6e5ed45f0fbbb6e2$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($6e5ed45f0fbbb6e2$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $6e5ed45f0fbbb6e2$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $6e5ed45f0fbbb6e2$export$92108d983e8ee699(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(date, inc);
        return date;
    }
}
function $6e5ed45f0fbbb6e2$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $6e5ed45f0fbbb6e2$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $6e5ed45f0fbbb6e2$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $6e5ed45f0fbbb6e2$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $6e5ed45f0fbbb6e2$export$995eb9fca571757(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $6e5ed45f0fbbb6e2$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($6e5ed45f0fbbb6e2$export$9e5f44173e64f162);
    return markers;
}
const $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS = {
    start: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    end: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    date: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $6e5ed45f0fbbb6e2$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS), {
    extendedProps: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
});
function $6e5ed45f0fbbb6e2$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$3b513254972cfc9c(raw, context, refiners);
    let defaultAllDay = $6e5ed45f0fbbb6e2$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $6e5ed45f0fbbb6e2$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $6e5ed45f0fbbb6e2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $6e5ed45f0fbbb6e2$export$995eb9fca571757(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$3b513254972cfc9c(raw, context, refiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context)) {
    return $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, refiners);
}
function $6e5ed45f0fbbb6e2$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $6e5ed45f0fbbb6e2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $6e5ed45f0fbbb6e2$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $6e5ed45f0fbbb6e2$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
    let eventRefiners = $6e5ed45f0fbbb6e2$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $6e5ed45f0fbbb6e2$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple, eventStore);
    }
    return eventStore;
}
function $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple, eventStore = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $6e5ed45f0fbbb6e2$export$667d3bf0c5f83305(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (lookDef)=>$6e5ed45f0fbbb6e2$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
}
function $6e5ed45f0fbbb6e2$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $6e5ed45f0fbbb6e2$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $6e5ed45f0fbbb6e2$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $6e5ed45f0fbbb6e2$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === 'object' && input) return $6e5ed45f0fbbb6e2$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $6e5ed45f0fbbb6e2$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    overlap: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allow: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    className: $6e5ed45f0fbbb6e2$export$f96d196f7728bb5,
    classNames: $6e5ed45f0fbbb6e2$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context) {
    let constraint = $6e5ed45f0fbbb6e2$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($6e5ed45f0fbbb6e2$var$combineTwoEventUis, $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_UI);
}
function $6e5ed45f0fbbb6e2$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $6e5ed45f0fbbb6e2$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    failure: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5
};
function $6e5ed45f0fbbb6e2$export$ffb5f4729a158638(raw, context, refiners = $6e5ed45f0fbbb6e2$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === 'object' && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(rawObj, refiners);
        let metaRes = $6e5ed45f0fbbb6e2$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: $6e5ed45f0fbbb6e2$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $6e5ed45f0fbbb6e2$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS), $6e5ed45f0fbbb6e2$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $6e5ed45f0fbbb6e2$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $6e5ed45f0fbbb6e2$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return $6e5ed45f0fbbb6e2$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return $6e5ed45f0fbbb6e2$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return $6e5ed45f0fbbb6e2$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $6e5ed45f0fbbb6e2$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return $6e5ed45f0fbbb6e2$var$excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return $6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case 'REMOVE_ALL_EVENTS':
            return $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $6e5ed45f0fbbb6e2$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $6e5ed45f0fbbb6e2$var$expandRecurring(subset, fetchRange, context);
        return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e($6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $6e5ed45f0fbbb6e2$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $6e5ed45f0fbbb6e2$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $6e5ed45f0fbbb6e2$var$expandRecurring(newEventStore, activeRange, context);
}
function $6e5ed45f0fbbb6e2$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $6e5ed45f0fbbb6e2$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $6e5ed45f0fbbb6e2$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $6e5ed45f0fbbb6e2$var$expandRecurring(subset, expandRange, context);
    return $6e5ed45f0fbbb6e2$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $6e5ed45f0fbbb6e2$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $6e5ed45f0fbbb6e2$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $6e5ed45f0fbbb6e2$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $6e5ed45f0fbbb6e2$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $6e5ed45f0fbbb6e2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $6e5ed45f0fbbb6e2$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
class $6e5ed45f0fbbb6e2$export$d66501df72047452 {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $6e5ed45f0fbbb6e2$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $6e5ed45f0fbbb6e2$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function $6e5ed45f0fbbb6e2$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $6e5ed45f0fbbb6e2$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const $6e5ed45f0fbbb6e2$var$DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function $6e5ed45f0fbbb6e2$export$3a6d5c9ae78a2c08(input, context) {
    return $6e5ed45f0fbbb6e2$var$parseEvents($6e5ed45f0fbbb6e2$var$refineInputs(input), null, context);
}
function $6e5ed45f0fbbb6e2$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function $6e5ed45f0fbbb6e2$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $6e5ed45f0fbbb6e2$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $6e5ed45f0fbbb6e2$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $6e5ed45f0fbbb6e2$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $6e5ed45f0fbbb6e2$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $6e5ed45f0fbbb6e2$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $6e5ed45f0fbbb6e2$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $6e5ed45f0fbbb6e2$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(copy.range.start),
        end: $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $6e5ed45f0fbbb6e2$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $6e5ed45f0fbbb6e2$var$EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class $6e5ed45f0fbbb6e2$export$71511d61b312f219 {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $6e5ed45f0fbbb6e2$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
        else if (name === 'id') {
            val = $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS) {
            val = $6e5ed45f0fbbb6e2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS) {
            let ui = $6e5ed45f0fbbb6e2$var$EVENT_UI_REFINERS[name](val);
            if (name === 'color') ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === 'editable') ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $6e5ed45f0fbbb6e2$var$computeAlignedDayRange(instanceRange);
            let startDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $6e5ed45f0fbbb6e2$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                if ($6e5ed45f0fbbb6e2$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $6e5ed45f0fbbb6e2$export$667d3bf0c5f83305(eventStore, instance.instanceId);
            let eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: []
                }
            };
            relevantEvents = $6e5ed45f0fbbb6e2$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents
            });
            context.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $6e5ed45f0fbbb6e2$var$eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return '';
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return '';
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || 'auto';
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== 'auto') res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function $6e5ed45f0fbbb6e2$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $6e5ed45f0fbbb6e2$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $6e5ed45f0fbbb6e2$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        let slicedRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $6e5ed45f0fbbb6e2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $6e5ed45f0fbbb6e2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $6e5ed45f0fbbb6e2$export$45aabb5431c2d04f(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function $6e5ed45f0fbbb6e2$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $6e5ed45f0fbbb6e2$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $6e5ed45f0fbbb6e2$var$compileEventUis(eventDefs, eventUiBases) {
    return $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventDefs, (eventDef)=>$6e5ed45f0fbbb6e2$var$compileEventUi(eventDef, eventUiBases));
}
function $6e5ed45f0fbbb6e2$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(uis);
}
function $6e5ed45f0fbbb6e2$export$a91cd623adc48128(segs, eventOrderSpecs) {
    let objs = segs.map($6e5ed45f0fbbb6e2$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$6e5ed45f0fbbb6e2$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $6e5ed45f0fbbb6e2$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $6e5ed45f0fbbb6e2$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $6e5ed45f0fbbb6e2$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $6e5ed45f0fbbb6e2$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $6e5ed45f0fbbb6e2$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(wholeEventStart).valueOf() === $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162($6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $6e5ed45f0fbbb6e2$export$9e5f44173e64f162($6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function $6e5ed45f0fbbb6e2$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $6e5ed45f0fbbb6e2$var$getEventClassNames(props) {
    let classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $6e5ed45f0fbbb6e2$export$6dabbe08653f866f(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $6e5ed45f0fbbb6e2$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $6e5ed45f0fbbb6e2$var$STANDARD_PROPS = {
    start: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    end: $6e5ed45f0fbbb6e2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $6e5ed45f0fbbb6e2$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $6e5ed45f0fbbb6e2$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $6e5ed45f0fbbb6e2$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, $6e5ed45f0fbbb6e2$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $6e5ed45f0fbbb6e2$export$7f557e5eb95176c2(span0, span1) {
    return $6e5ed45f0fbbb6e2$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $6e5ed45f0fbbb6e2$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $6e5ed45f0fbbb6e2$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $6e5ed45f0fbbb6e2$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $6e5ed45f0fbbb6e2$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $6e5ed45f0fbbb6e2$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $6e5ed45f0fbbb6e2$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $6e5ed45f0fbbb6e2$export$3b513254972cfc9c({
        editable: false
    }, context);
    let def = $6e5ed45f0fbbb6e2$export$f38c853ae54ed474(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $6e5ed45f0fbbb6e2$var$compileEventUi(def, eventUiBases),
        instance: $6e5ed45f0fbbb6e2$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $6e5ed45f0fbbb6e2$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
class $6e5ed45f0fbbb6e2$export$f787f51d84a910ad extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $6e5ed45f0fbbb6e2$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $6e5ed45f0fbbb6e2$export$f787f51d84a910ad('Failure parsing JSON', fetchRes);
        });
        else throw new $6e5ed45f0fbbb6e2$export$f787f51d84a910ad('Request failed', fetchRes);
    });
}
let $6e5ed45f0fbbb6e2$var$canVGrowWithinCell;
function $6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9() {
    if ($6e5ed45f0fbbb6e2$var$canVGrowWithinCell == null) $6e5ed45f0fbbb6e2$var$canVGrowWithinCell = $6e5ed45f0fbbb6e2$var$computeCanVGrowWithinCell();
    return $6e5ed45f0fbbb6e2$var$canVGrowWithinCell;
}
function $6e5ed45f0fbbb6e2$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    let el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    let div = el.querySelector('div');
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class $6e5ed45f0fbbb6e2$export$a9c996f45e5784d0 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            $6e5ed45f0fbbb6e2$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            $6e5ed45f0fbbb6e2$export$c3950d9923825c02(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        let height = !isHeightAuto && options.height != null ? options.height : '';
        let classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            `fc-direction-${options.direction}`,
            props.theme.getClass('root')
        ];
        if (!$6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9()) classNames.push('fc-liquid-hack');
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    }
}
class $6e5ed45f0fbbb6e2$export$78acf4525d8a74c4 {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function $6e5ed45f0fbbb6e2$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $6e5ed45f0fbbb6e2$export$381353cf1dd55255(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $6e5ed45f0fbbb6e2$export$a8550f7dbe79f93a = {};
class $6e5ed45f0fbbb6e2$export$2e2af4578d910ddf extends (0, $1Hdcz.Component) {
    constructor(props, context){
        super(props, context);
        this.handleRefresh = ()=>{
            let timing = this.computeTiming();
            if (timing.state.nowDate.valueOf() !== this.state.nowDate.valueOf()) this.setState(timing.state);
            this.clearTimeout();
            this.setTimeout(timing.waitMs);
        };
        this.handleVisibilityChange = ()=>{
            if (!document.hidden) this.handleRefresh();
        };
        this.state = this.computeTiming().state;
    }
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
        this.context.nowManager.addResetListener(this.handleRefresh);
        // fired tab becomes visible after being hidden
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
        this.context.nowManager.removeResetListener(this.handleRefresh);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = context.nowManager.getDateMarker();
        let { nowIndicatorSnap: nowIndicatorSnap } = context.options;
        if (nowIndicatorSnap === 'auto') nowIndicatorSnap = // large unit?
        /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
        (props.unitValue || 1) === 1;
        let nowDate;
        let waitMs;
        if (nowIndicatorSnap) {
            nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
            let nextUnitStart = context.dateEnv.add(nowDate, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(1, props.unit));
            waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        } else {
            nowDate = unroundedNow;
            waitMs = 60000; // 1 minute
        }
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            state: {
                nowDate: nowDate,
                todayRange: $6e5ed45f0fbbb6e2$var$buildDayRange(nowDate)
            },
            waitMs: waitMs
        };
    }
    setTimeout(waitMs = this.computeTiming().waitMs) {
        // NOTE: timeout could take longer than expected if tab sleeps,
        // which is why we listen to 'visibilitychange'
        this.timeoutId = setTimeout(()=>{
            // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
            // This is why use use same waitMs from computeTiming, so we don't skip an interval while
            // .setState() is executing
            const timing = this.computeTiming();
            this.setState(timing.state, ()=>{
                this.setTimeout(timing.waitMs);
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
$6e5ed45f0fbbb6e2$export$2e2af4578d910ddf.contextType = $6e5ed45f0fbbb6e2$export$e7c866399fa523f5;
function $6e5ed45f0fbbb6e2$var$buildDayRange(date) {
    let start = $6e5ed45f0fbbb6e2$export$9e5f44173e64f162(date);
    let end = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $6e5ed45f0fbbb6e2$export$a93c5207d687da10 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger('_resize', true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType
                    });
                    this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: 'PREV'
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: 'NEXT'
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.nowManager.getDateMarker()
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $6e5ed45f0fbbb6e2$var$parseDateSpan(selectionInput, state.dateEnv, $6e5ed45f0fbbb6e2$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: 'SELECT_DATES',
                selection: selection
            });
            $6e5ed45f0fbbb6e2$export$cbfbec548517f2b6(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: 'UNSELECT_DATES'
            });
            $6e5ed45f0fbbb6e2$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $6e5ed45f0fbbb6e2$export$71511d61b312f219) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: $6e5ed45f0fbbb6e2$export$317a3d46287192d8({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $6e5ed45f0fbbb6e2$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) [eventSource] = $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $6e5ed45f0fbbb6e2$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: $6e5ed45f0fbbb6e2$export$317a3d46287192d8(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: $6e5ed45f0fbbb6e2$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $6e5ed45f0fbbb6e2$export$71511d61b312f219(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $6e5ed45f0fbbb6e2$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENTS'
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $6e5ed45f0fbbb6e2$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $6e5ed45f0fbbb6e2$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    eventSource
                ]
            });
            return new $6e5ed45f0fbbb6e2$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENT_SOURCES'
        });
    }
    refetchEvents() {
        this.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $6e5ed45f0fbbb6e2$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger('_scrollRequest', {
            time: time
        });
    }
}
function $6e5ed45f0fbbb6e2$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $6e5ed45f0fbbb6e2$export$890c4ad488842ce7(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $6e5ed45f0fbbb6e2$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $6e5ed45f0fbbb6e2$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $6e5ed45f0fbbb6e2$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $6e5ed45f0fbbb6e2$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
class $6e5ed45f0fbbb6e2$export$9d0e2d13d04f7070 {
    constructor(){
        this.getKeysForEventDefs = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $6e5ed45f0fbbb6e2$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $6e5ed45f0fbbb6e2$export$7f8ddf7c7c20b3cd();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $6e5ed45f0fbbb6e2$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function $6e5ed45f0fbbb6e2$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        '': $6e5ed45f0fbbb6e2$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $6e5ed45f0fbbb6e2$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $6e5ed45f0fbbb6e2$export$1a8f5705751d8277(meta, theme) {
    let classNames = [
        'fc-day',
        `fc-day-${$6e5ed45f0fbbb6e2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        'fc-slot',
        `fc-slot-${$6e5ed45f0fbbb6e2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
const $6e5ed45f0fbbb6e2$var$DAY_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
const $6e5ed45f0fbbb6e2$var$WEEK_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    week: 'long'
});
function $6e5ed45f0fbbb6e2$export$a17c37559e1db147(context, dateMarker, viewType = 'day', isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $6e5ed45f0fbbb6e2$var$WEEK_FORMAT : $6e5ed45f0fbbb6e2$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
let $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft = null;
function $6e5ed45f0fbbb6e2$export$c7ca7e4bc4f8a16e() {
    if ($6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft === null) $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft = $6e5ed45f0fbbb6e2$var$computeIsRtlScrollbarOnLeft();
    return $6e5ed45f0fbbb6e2$var$_isRtlScrollbarOnLeft;
}
function $6e5ed45f0fbbb6e2$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement('div');
    $6e5ed45f0fbbb6e2$export$faec65b429be379(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $6e5ed45f0fbbb6e2$export$9f4f30ee63539e24(outerEl);
    return res;
}
let $6e5ed45f0fbbb6e2$var$_scrollbarWidths;
function $6e5ed45f0fbbb6e2$export$a1edd97dd51cd48d() {
    if (!$6e5ed45f0fbbb6e2$var$_scrollbarWidths) $6e5ed45f0fbbb6e2$var$_scrollbarWidths = $6e5ed45f0fbbb6e2$var$computeScrollbarWidths();
    return $6e5ed45f0fbbb6e2$var$_scrollbarWidths;
}
function $6e5ed45f0fbbb6e2$var$computeScrollbarWidths() {
    let el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    let res = $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $6e5ed45f0fbbb6e2$export$2ec5befb9e6c97d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $6e5ed45f0fbbb6e2$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($6e5ed45f0fbbb6e2$export$c7ca7e4bc4f8a16e() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$d29e374196577086(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $6e5ed45f0fbbb6e2$export$39c1cc7c062529d4(el);
    let edges = $6e5ed45f0fbbb6e2$export$2ec5befb9e6c97d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $6e5ed45f0fbbb6e2$export$39c1cc7c062529d4(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $6e5ed45f0fbbb6e2$var$computeClippedClientRect(el) {
    let clippingParents = $6e5ed45f0fbbb6e2$export$53c86fa97d611818(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $6e5ed45f0fbbb6e2$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $6e5ed45f0fbbb6e2$export$53c86fa97d611818(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $6e5ed45f0fbbb6e2$export$ad4aebacdcaf47f8 {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $6e5ed45f0fbbb6e2$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $6e5ed45f0fbbb6e2$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function $6e5ed45f0fbbb6e2$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $6e5ed45f0fbbb6e2$export$7060da4b5db56fb9 extends $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class $6e5ed45f0fbbb6e2$export$c5d1328b37d47994 extends $6e5ed45f0fbbb6e2$export$4ae495d48253603d {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.uid = $6e5ed45f0fbbb6e2$export$39b482c5e57630a8();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-event-mirror');
    }
    isValidDateDownEl(el) {
        return !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-event:not(.fc-bg-event)') && !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-more-link') && // a "more.." link
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, 'a[data-navlink]') && // a clickable nav link
        !$6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(el, '.fc-popover'); // hack
    }
}
class $6e5ed45f0fbbb6e2$export$45d219bdcd8ac53c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $6e5ed45f0fbbb6e2$export$766bf7dcfb630b6c {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: $6e5ed45f0fbbb6e2$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $6e5ed45f0fbbb6e2$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $6e5ed45f0fbbb6e2$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $6e5ed45f0fbbb6e2$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$6e5ed45f0fbbb6e2$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$6e5ed45f0fbbb6e2$export$674f8f4247a5112e(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
}
function $6e5ed45f0fbbb6e2$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $6e5ed45f0fbbb6e2$export$674f8f4247a5112e(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function $6e5ed45f0fbbb6e2$export$d76842aa27385215(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($6e5ed45f0fbbb6e2$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $6e5ed45f0fbbb6e2$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $6e5ed45f0fbbb6e2$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $6e5ed45f0fbbb6e2$export$b0165a7e514844(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $6e5ed45f0fbbb6e2$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $6e5ed45f0fbbb6e2$export$b2bcef12bcefba04 {
    constructor(el, selector){
        this.emitter = new $6e5ed45f0fbbb6e2$export$d66501df72047452();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $6e5ed45f0fbbb6e2$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $6e5ed45f0fbbb6e2$var$DRAG_META_REFINERS = {
    startTime: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    duration: $6e5ed45f0fbbb6e2$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $6e5ed45f0fbbb6e2$export$60bb826a6acf3081(raw) {
    let { refined: refined, extra: extra } = $6e5ed45f0fbbb6e2$export$ee7c8ad385a60b7b(raw, $6e5ed45f0fbbb6e2$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $6e5ed45f0fbbb6e2$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
        weekday: 'long'
    }); // "Saturday"
}
const $6e5ed45f0fbbb6e2$var$CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function $6e5ed45f0fbbb6e2$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class $6e5ed45f0fbbb6e2$export$ebc5e65867841cbe extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
        let classNames = [
            $6e5ed45f0fbbb6e2$var$CLASS_NAME
        ].concat($6e5ed45f0fbbb6e2$export$1a8f5705751d8277(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $6e5ed45f0fbbb6e2$export$a17c37559e1db147(this.context, date) : {};
        let publicDate = dateEnv.toDate(date);
        // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
        // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
        if (dateEnv.namedTimeZoneImpl) publicDate = $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: publicDate,
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan,
                'data-date': !dayMeta.isDisabled ? $6e5ed45f0fbbb6e2$export$56350196709588fc(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $1Hdcz.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $1Hdcz.createElement)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ]
            })));
    }
}
const $6e5ed45f0fbbb6e2$var$WEEKDAY_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    weekday: 'long'
});
class $6e5ed45f0fbbb6e2$export$1ddf2d01943a3512 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $6e5ed45f0fbbb6e2$var$CLASS_NAME,
                ...$6e5ed45f0fbbb6e2$export$1a8f5705751d8277(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $1Hdcz.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ],
                elAttrs: {
                    'aria-label': dateEnv.format(date, $6e5ed45f0fbbb6e2$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $6e5ed45f0fbbb6e2$export$27d1aff6bea49709 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$var$createDayHeaderFormatter);
    }
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$2e2af4578d910ddf, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $1Hdcz.createElement)("tr", {
                role: "row"
            }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$ebc5e65867841cbe, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$1ddf2d01943a3512, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function $6e5ed45f0fbbb6e2$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $6e5ed45f0fbbb6e2$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
class $6e5ed45f0fbbb6e2$export$ebb8f7cd71856fb9 {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($6e5ed45f0fbbb6e2$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($6e5ed45f0fbbb6e2$export$b4d5ecaefe2b27f3(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class $6e5ed45f0fbbb6e2$export$1314441b8d04e1d5 {
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class $6e5ed45f0fbbb6e2$export$e0c3a065614c6254 {
    constructor(){
        this.sliceBusinessHours = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $6e5ed45f0fbbb6e2$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($6e5ed45f0fbbb6e2$var$expandRecurring(businessHours, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(eventStore, eventUiBases, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $6e5ed45f0fbbb6e2$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $6e5ed45f0fbbb6e2$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $6e5ed45f0fbbb6e2$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
            start: dateRange.start,
            end: $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $6e5ed45f0fbbb6e2$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $6e5ed45f0fbbb6e2$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$export$6d1e945284085e64(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$6e5ed45f0fbbb6e2$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $6e5ed45f0fbbb6e2$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $6e5ed45f0fbbb6e2$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$6e5ed45f0fbbb6e2$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $6e5ed45f0fbbb6e2$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $6e5ed45f0fbbb6e2$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $6e5ed45f0fbbb6e2$export$6b179bb11f7fd3a0)(props, context);
}
function $6e5ed45f0fbbb6e2$export$6b179bb11f7fd3a0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$6e5ed45f0fbbb6e2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$6e5ed45f0fbbb6e2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $6e5ed45f0fbbb6e2$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $6e5ed45f0fbbb6e2$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $6e5ed45f0fbbb6e2$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$6e5ed45f0fbbb6e2$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($6e5ed45f0fbbb6e2$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, origDef, origInstance);
            else eventApi = new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$6e5ed45f0fbbb6e2$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($6e5ed45f0fbbb6e2$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($6e5ed45f0fbbb6e2$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $6e5ed45f0fbbb6e2$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$6e5ed45f0fbbb6e2$var$anyRangesContainRange($6e5ed45f0fbbb6e2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $6e5ed45f0fbbb6e2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === 'object' && constraint) return $6e5ed45f0fbbb6e2$var$eventStoreToRanges($6e5ed45f0fbbb6e2$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $6e5ed45f0fbbb6e2$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $6e5ed45f0fbbb6e2$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($6e5ed45f0fbbb6e2$export$f074adc9fbd50943(outerRange, innerRange)) return true;
    }
    return false;
}
const $6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $6e5ed45f0fbbb6e2$export$54c4fabc2291e9c0 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
    }
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            'fc-scroller'
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
            else className.push('fc-scroller-liquid');
        }
        return (0, $1Hdcz.createElement)("div", {
            ref: this.handleEl,
            className: className.join(' '),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || '',
                right: isAbsolute && -(props.overcomeRight || 0) || '',
                bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                maxHeight: props.maxHeight || ''
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($6e5ed45f0fbbb6e2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $6e5ed45f0fbbb6e2$export$807f1ba34db587c7 {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $6e5ed45f0fbbb6e2$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $6e5ed45f0fbbb6e2$export$90a7f3efeed30595(this.currentMap);
    }
}
function $6e5ed45f0fbbb6e2$export$7fe88b5920ffddd2(chunkEls) {
    let shrinkCells = $6e5ed45f0fbbb6e2$export$23ebac1979863676(chunkEls, '.fc-scrollgrid-shrink');
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $6e5ed45f0fbbb6e2$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $6e5ed45f0fbbb6e2$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $6e5ed45f0fbbb6e2$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $1Hdcz.createElement)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, $1Hdcz.createElement)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $6e5ed45f0fbbb6e2$export$f5339a28e56d1baf(cols0, cols1) {
    return $6e5ed45f0fbbb6e2$export$23f2a1d2818174ef(cols0, cols1, $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca);
}
function $6e5ed45f0fbbb6e2$export$add49c223b9ce4ea(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $1Hdcz.createElement)("col", {
            style: {
                width: colProps.width === 'shrink' ? $6e5ed45f0fbbb6e2$export$df7c425476ed4f2(shrinkWidth) : colProps.width || '',
                minWidth: colProps.minWidth || ''
            }
        }));
    }
    return (0, $1Hdcz.createElement)('colgroup', {}, ...colNodes);
}
function $6e5ed45f0fbbb6e2$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $6e5ed45f0fbbb6e2$export$c69d65aa55814164(cols) {
    for (let col of cols){
        if (col.width === 'shrink') return true;
    }
    return false;
}
function $6e5ed45f0fbbb6e2$export$65ab0ebced932b79(liquid, context) {
    let classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    let classNames = [
        'fc-scrollgrid-section',
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function $6e5ed45f0fbbb6e2$export$1ec7a8278ebd1290(arg) {
    return (0, $1Hdcz.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $6e5ed45f0fbbb6e2$export$89e9012e902952b6(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function $6e5ed45f0fbbb6e2$export$4ad369a19af21c23(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
class $6e5ed45f0fbbb6e2$export$c667925124dac624 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.processCols = $6e5ed45f0fbbb6e2$export$df995fae86a55f06((a)=>a, $6e5ed45f0fbbb6e2$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $6e5ed45f0fbbb6e2$export$df995fae86a55f06($6e5ed45f0fbbb6e2$export$add49c223b9ce4ea);
        this.scrollerRefs = new $6e5ed45f0fbbb6e2$export$807f1ba34db587c7();
        this.scrollerElRefs = new $6e5ed45f0fbbb6e2$export$807f1ba34db587c7(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $6e5ed45f0fbbb6e2$export$65ab0ebced932b79(props.liquid, context);
        if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$6e5ed45f0fbbb6e2$export$738ab4df8bf92ae9();
        const roleAttrs = {
            role: 'rowgroup'
        };
        return (0, $1Hdcz.createElement)('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $1Hdcz.createElement)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $1Hdcz.createElement)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $1Hdcz.createElement)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, $1Hdcz.createElement)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $1Hdcz.createElement)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $6e5ed45f0fbbb6e2$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(' ')
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $6e5ed45f0fbbb6e2$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $6e5ed45f0fbbb6e2$export$60e660859c376841(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
        let sectionKey = sectionConfig.key;
        let content = $6e5ed45f0fbbb6e2$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $1Hdcz.createElement)(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation'
        }, (0, $1Hdcz.createElement)("div", {
            className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
        }, (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$54c4fabc2291e9c0, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $6e5ed45f0fbbb6e2$var$getSectionByKey(this.props.sections, key);
        if (section) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $6e5ed45f0fbbb6e2$export$c69d65aa55814164(this.props.cols) ? $6e5ed45f0fbbb6e2$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $6e5ed45f0fbbb6e2$export$a1edd97dd51cd48d();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
}
$6e5ed45f0fbbb6e2$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
function $6e5ed45f0fbbb6e2$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $6e5ed45f0fbbb6e2$export$c1df809846363ebe extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        // memo
        this.buildPublicEvent = $6e5ed45f0fbbb6e2$export$df995fae86a55f06((context, eventDef, eventInstance)=>new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, eventDef, eventInstance));
        this.handleEl = (el)=>{
            this.el = el;
            $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
            if (el) $6e5ed45f0fbbb6e2$var$setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $6e5ed45f0fbbb6e2$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $6e5ed45f0fbbb6e2$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $6e5ed45f0fbbb6e2$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: this.handleEl,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: [
                ...$6e5ed45f0fbbb6e2$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }, props.children);
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $6e5ed45f0fbbb6e2$var$setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class $6e5ed45f0fbbb6e2$export$6735ce526161c7bd extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $6e5ed45f0fbbb6e2$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $6e5ed45f0fbbb6e2$export$6dabbe08653f866f(seg, context),
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-event-main'
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $1Hdcz.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $1Hdcz.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
$6e5ed45f0fbbb6e2$export$6735ce526161c7bd.addPropsEquality({
    seg: $6e5ed45f0fbbb6e2$export$a9c23c6ac3fc3eca
});
function $6e5ed45f0fbbb6e2$var$renderInnerContent$1(innerProps) {
    return (0, $1Hdcz.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $1Hdcz.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $1Hdcz.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $1Hdcz.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, "\u00A0"))));
}
const $6e5ed45f0fbbb6e2$export$6e4b1d19c6e2e012 = (props)=>(0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
const $6e5ed45f0fbbb6e2$var$DAY_NUM_FORMAT = $6e5ed45f0fbbb6e2$export$d141bba7fdc215a3({
    day: 'numeric'
});
class $6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.refineRenderProps = $6e5ed45f0fbbb6e2$export$ebd11618f299a286($6e5ed45f0fbbb6e2$var$refineRenderProps);
    }
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                'data-date': $6e5ed45f0fbbb6e2$export$56350196709588fc(props.date)
            }),
            elClasses: [
                ...$6e5ed45f0fbbb6e2$export$1a8f5705751d8277(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }, props.children);
    }
}
function $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $6e5ed45f0fbbb6e2$var$hasCustomRenderingHandler('dayCellContent', options));
}
function $6e5ed45f0fbbb6e2$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $6e5ed45f0fbbb6e2$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $6e5ed45f0fbbb6e2$var$DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $6e5ed45f0fbbb6e2$export$b02498c06ddfef28 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$c1df809846363ebe, {
            elTag: "div",
            elClasses: [
                'fc-bg-event'
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $6e5ed45f0fbbb6e2$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $1Hdcz.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $6e5ed45f0fbbb6e2$export$b975d55abac2bbe3(fillType) {
    return (0, $1Hdcz.createElement)("div", {
        className: `fc-${fillType}`
    });
}
const $6e5ed45f0fbbb6e2$export$1343a74baacb0543 = (props)=>(0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $6e5ed45f0fbbb6e2$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
function $6e5ed45f0fbbb6e2$var$renderInner(innerProps) {
    return innerProps.text;
}
const $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT = 10;
class $6e5ed45f0fbbb6e2$var$Popover extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $6e5ed45f0fbbb6e2$export$2ed0fc6709e59212(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === 'Escape') this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            'fc-popover',
            theme.getClass('popover')
        ].concat(props.extraClassNames || []);
        return (0, $jpota.createPortal)((0, $1Hdcz.createElement)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(' '),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $1Hdcz.createElement)("div", {
            className: 'fc-popover-header ' + theme.getClass('popoverHeader')
        }, (0, $1Hdcz.createElement)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $1Hdcz.createElement)("span", {
            className: 'fc-popover-close ' + theme.getIconClass('close'),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $1Hdcz.createElement)("div", {
            className: 'fc-popover-body ' + theme.getClass('popoverContent')
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $6e5ed45f0fbbb6e2$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $6e5ed45f0fbbb6e2$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $6e5ed45f0fbbb6e2$export$faec65b429be379(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class $6e5ed45f0fbbb6e2$var$MorePopover extends $6e5ed45f0fbbb6e2$export$d22783b3c2400a3a {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$c5d7c1ac98841e53, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    'fc-more-popover'
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $6e5ed45f0fbbb6e2$export$d92db8a7dc823bb0(options) && (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-more-popover-misc'
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class $6e5ed45f0fbbb6e2$export$87b6ab1c2cb8b955 extends $6e5ed45f0fbbb6e2$export$ef35774e6d314e91 {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $6e5ed45f0fbbb6e2$export$6559d589eb85fbb6()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $6e5ed45f0fbbb6e2$export$71cec2538cb2c617(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $6e5ed45f0fbbb6e2$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $6e5ed45f0fbbb6e2$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $6e5ed45f0fbbb6e2$var$computeRange(props);
            let text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $6e5ed45f0fbbb6e2$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, Boolean(props.moreCnt) && (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$export$e7094788287c5e9b, {
                elTag: props.elTag || 'a',
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    'fc-more-link'
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $6e5ed45f0fbbb6e2$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    'aria-expanded': state.isPopoverOpen,
                    'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $6e5ed45f0fbbb6e2$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $1Hdcz.createElement)($6e5ed45f0fbbb6e2$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $6e5ed45f0fbbb6e2$export$dc98b0b04f4c7758(this.linkEl, '.fc-view-harness');
    }
}
function $6e5ed45f0fbbb6e2$var$renderMoreLinkInner(props) {
    return props.text;
}
function $6e5ed45f0fbbb6e2$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $6e5ed45f0fbbb6e2$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73(hiddenSegs),
        end: $6e5ed45f0fbbb6e2$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $6e5ed45f0fbbb6e2$export$cd571ca6d1702b73(segs) {
    return segs.reduce($6e5ed45f0fbbb6e2$var$pickEarliestStart).eventRange.range.start;
}
function $6e5ed45f0fbbb6e2$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $6e5ed45f0fbbb6e2$var$computeLatestSegEnd(segs) {
    return segs.reduce($6e5ed45f0fbbb6e2$var$pickLatestEnd).eventRange.range.end;
}
function $6e5ed45f0fbbb6e2$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $6e5ed45f0fbbb6e2$var$Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $6e5ed45f0fbbb6e2$export$1776704b6532a19a extends $6e5ed45f0fbbb6e2$var$Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}

});
parcelRegister("1Hdcz", function(module, exports) {

$parcel$export(module.exports, "options", () => $13c40c34b78c8ee2$export$41c562ebe57d11e2);
$parcel$export(module.exports, "isValidElement", () => $13c40c34b78c8ee2$export$a8257692ac88316c);
$parcel$export(module.exports, "createElement", () => $13c40c34b78c8ee2$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $13c40c34b78c8ee2$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $13c40c34b78c8ee2$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $13c40c34b78c8ee2$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $13c40c34b78c8ee2$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $13c40c34b78c8ee2$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $13c40c34b78c8ee2$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $13c40c34b78c8ee2$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $13c40c34b78c8ee2$export$fd42f52fd3ae1109);
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$t, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c = {}, $13c40c34b78c8ee2$var$s = [], $13c40c34b78c8ee2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $13c40c34b78c8ee2$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$p(l, f, t, r, null);
}
function $13c40c34b78c8ee2$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $13c40c34b78c8ee2$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $13c40c34b78c8ee2$var$g(n, r, l[r], u[r], i);
}
function $13c40c34b78c8ee2$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$a.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $13c40c34b78c8ee2$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $13c40c34b78c8ee2$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $13c40c34b78c8ee2$var$w : $13c40c34b78c8ee2$var$m, r) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$w : $13c40c34b78c8ee2$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $13c40c34b78c8ee2$var$m(n) {
    $13c40c34b78c8ee2$var$t = !0;
    try {
        return this.l[n.type + !1]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $13c40c34b78c8ee2$var$t = !1;
    }
}
function $13c40c34b78c8ee2$var$w(n) {
    $13c40c34b78c8ee2$var$t = !0;
    try {
        return this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $13c40c34b78c8ee2$var$t = !1;
    }
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$A(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$A(n) : null;
}
function $13c40c34b78c8ee2$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$P(n);
    }
}
function $13c40c34b78c8ee2$var$C(n) {
    $13c40c34b78c8ee2$var$t ? setTimeout(n) : $13c40c34b78c8ee2$var$f(n);
}
function $13c40c34b78c8ee2$var$T(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$r.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$C)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    var n, l, u, i, t, o, f, e;
    for($13c40c34b78c8ee2$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $13c40c34b78c8ee2$var$r.shift();)n.__d && (l = $13c40c34b78c8ee2$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $13c40c34b78c8ee2$var$h({}, o)).__v = o.__v + 1, $13c40c34b78c8ee2$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $13c40c34b78c8ee2$var$A(o) : f, o.__h), $13c40c34b78c8ee2$var$N(i, o), o.__e != f && $13c40c34b78c8ee2$var$P(o)), $13c40c34b78c8ee2$var$r.length > l && $13c40c34b78c8ee2$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $13c40c34b78c8ee2$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $13c40c34b78c8ee2$var$p(null, d, null, null, d) : Array.isArray(d) ? $13c40c34b78c8ee2$var$p($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $13c40c34b78c8ee2$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $13c40c34b78c8ee2$var$M(n, d, y = y || $13c40c34b78c8ee2$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $13c40c34b78c8ee2$var$I(d, e, n) : e = $13c40c34b78c8ee2$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $13c40c34b78c8ee2$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $13c40c34b78c8ee2$var$L(i).nextSibling), $13c40c34b78c8ee2$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$13c40c34b78c8ee2$var$S(g[h], g[++h], g[++h]);
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $13c40c34b78c8ee2$var$I(i, l, u) : $13c40c34b78c8ee2$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $13c40c34b78c8ee2$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $13c40c34b78c8ee2$var$L(u))) return i;
    }
    return null;
}
function $13c40c34b78c8ee2$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $13c40c34b78c8ee2$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $13c40c34b78c8ee2$var$h({}, a.__s)), $13c40c34b78c8ee2$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $13c40c34b78c8ee2$var$h($13c40c34b78c8ee2$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $13c40c34b78c8ee2$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $13c40c34b78c8ee2$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $13c40c34b78c8ee2$var$N(n, u) {
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $13c40c34b78c8ee2$var$n.call(l.childNodes), a = (y = i.props || $13c40c34b78c8ee2$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($13c40c34b78c8ee2$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $13c40c34b78c8ee2$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $13c40c34b78c8ee2$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $13c40c34b78c8ee2$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $13c40c34b78c8ee2$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $13c40c34b78c8ee2$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $13c40c34b78c8ee2$var$q(n, u, i) {
    var t, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $13c40c34b78c8ee2$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $13c40c34b78c8ee2$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $13c40c34b78c8ee2$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $13c40c34b78c8ee2$var$M(i, u = (!r && t || i).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $13c40c34b78c8ee2$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $13c40c34b78c8ee2$var$N(f, u);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $13c40c34b78c8ee2$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : i), $13c40c34b78c8ee2$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$s.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$var$t = !1, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$h({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$h({}, u), this.props)), n && $13c40c34b78c8ee2$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$T(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$T(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$r = [], $13c40c34b78c8ee2$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$e = 0;

});

parcelRegister("jpota", function(module, exports) {

$parcel$export(module.exports, "createPortal", () => $e21355414fd2bd2a$export$d39a5bbd09211389);

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");
function $e21355414fd2bd2a$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $e21355414fd2bd2a$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $e21355414fd2bd2a$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $e21355414fd2bd2a$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $e21355414fd2bd2a$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $e21355414fd2bd2a$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $1Hdcz.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype = new (0, $1Hdcz.Component)).isPureReactComponent = !0, $e21355414fd2bd2a$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $e21355414fd2bd2a$var$C(this.props, n) || $e21355414fd2bd2a$var$C(this.state, t);
};
var $e21355414fd2bd2a$var$x = (0, $1Hdcz.options).__b;
(0, $1Hdcz.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $e21355414fd2bd2a$var$x && $e21355414fd2bd2a$var$x(n);
};
var $e21355414fd2bd2a$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $e21355414fd2bd2a$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $e21355414fd2bd2a$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $e21355414fd2bd2a$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $e21355414fd2bd2a$var$A = function(n, t) {
    return null == n ? null : (0, $1Hdcz.toChildArray)((0, $1Hdcz.toChildArray)(n).map(t));
}, $e21355414fd2bd2a$export$dca3b0875bd9a954 = {
    map: $e21355414fd2bd2a$var$A,
    forEach: $e21355414fd2bd2a$var$A,
    count: function(n) {
        return n ? (0, $1Hdcz.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $1Hdcz.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $1Hdcz.toChildArray)
}, $e21355414fd2bd2a$var$T = (0, $1Hdcz.options).__e;
(0, $1Hdcz.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $e21355414fd2bd2a$var$T(n, t, e, r);
};
var $e21355414fd2bd2a$var$I = (0, $1Hdcz.options).unmount;
function $e21355414fd2bd2a$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $e21355414fd2bd2a$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$L(n, t, e);
    })), n;
}
function $e21355414fd2bd2a$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $e21355414fd2bd2a$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $e21355414fd2bd2a$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $e21355414fd2bd2a$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $e21355414fd2bd2a$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $1Hdcz.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $e21355414fd2bd2a$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $1Hdcz.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $e21355414fd2bd2a$var$I && $e21355414fd2bd2a$var$I(n);
}, ($e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype = new (0, $1Hdcz.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $e21355414fd2bd2a$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $e21355414fd2bd2a$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $e21355414fd2bd2a$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $e21355414fd2bd2a$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $e21355414fd2bd2a$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $e21355414fd2bd2a$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $e21355414fd2bd2a$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $1Hdcz.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $1Hdcz.render)((0, $1Hdcz.createElement)($e21355414fd2bd2a$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $e21355414fd2bd2a$export$d39a5bbd09211389(n, e) {
    var r = (0, $1Hdcz.createElement)($e21355414fd2bd2a$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($e21355414fd2bd2a$export$998bcd577473dd93.prototype = new (0, $1Hdcz.Component)).__a = function(n) {
    var t = this, e = $e21355414fd2bd2a$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $e21355414fd2bd2a$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $1Hdcz.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidUpdate = $e21355414fd2bd2a$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $e21355414fd2bd2a$var$W(n, e, t);
    });
};
var $e21355414fd2bd2a$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $e21355414fd2bd2a$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $e21355414fd2bd2a$var$H = "undefined" != typeof document, $e21355414fd2bd2a$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $e21355414fd2bd2a$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $1Hdcz.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $e21355414fd2bd2a$export$fa8d919ba61d84db(n, t, e) {
    return (0, $1Hdcz.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $1Hdcz.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $1Hdcz.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $e21355414fd2bd2a$var$G = (0, $1Hdcz.options).event;
function $e21355414fd2bd2a$var$J() {}
function $e21355414fd2bd2a$var$K() {
    return this.cancelBubble;
}
function $e21355414fd2bd2a$var$Q() {
    return this.defaultPrevented;
}
(0, $1Hdcz.options).event = function(n) {
    return $e21355414fd2bd2a$var$G && (n = $e21355414fd2bd2a$var$G(n)), n.persist = $e21355414fd2bd2a$var$J, n.isPropagationStopped = $e21355414fd2bd2a$var$K, n.isDefaultPrevented = $e21355414fd2bd2a$var$Q, n.nativeEvent = n;
};
var $e21355414fd2bd2a$var$X, $e21355414fd2bd2a$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $e21355414fd2bd2a$var$tn = (0, $1Hdcz.options).vnode;
(0, $1Hdcz.options).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $e21355414fd2bd2a$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$e21355414fd2bd2a$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $e21355414fd2bd2a$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $1Hdcz.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $1Hdcz.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($e21355414fd2bd2a$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $e21355414fd2bd2a$var$nn));
    }
    n.$$typeof = $e21355414fd2bd2a$var$z, $e21355414fd2bd2a$var$tn && $e21355414fd2bd2a$var$tn(n);
};
var $e21355414fd2bd2a$var$en = (0, $1Hdcz.options).__r;
(0, $1Hdcz.options).__r = function(n) {
    $e21355414fd2bd2a$var$en && $e21355414fd2bd2a$var$en(n), $e21355414fd2bd2a$var$X = n.__c;
};
var $e21355414fd2bd2a$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $e21355414fd2bd2a$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $e21355414fd2bd2a$export$83d89fbfd8236492 = "17.0.2";
function $e21355414fd2bd2a$export$d38cd72104c1f0e9(n) {
    return (0, $1Hdcz.createElement).bind(null, n);
}
function $e21355414fd2bd2a$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $e21355414fd2bd2a$var$z;
}
function $e21355414fd2bd2a$export$e530037191fcd5d7(n) {
    return $e21355414fd2bd2a$export$a8257692ac88316c(n) ? (0, $1Hdcz.cloneElement).apply(null, arguments) : n;
}
function $e21355414fd2bd2a$export$502457920280e6be(n) {
    return !!n.__k && ((0, $1Hdcz.render)(null, n), !0);
}
function $e21355414fd2bd2a$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $e21355414fd2bd2a$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $e21355414fd2bd2a$export$5f8d39834fd61797 = (0, $1Hdcz.Fragment);
function $e21355414fd2bd2a$export$7568632d0d33d16d(n) {
    n();
}
function $e21355414fd2bd2a$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $e21355414fd2bd2a$export$7b286972b8d8ccbf() {
    return [
        !1,
        $e21355414fd2bd2a$export$7568632d0d33d16d
    ];
}
var $e21355414fd2bd2a$export$aaabe4eda9ed9969 = (0, $2LSrt.useLayoutEffect);
function $e21355414fd2bd2a$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $2LSrt.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $2LSrt.useLayoutEffect)(function() {
        u.__ = e, u.v = t, $e21355414fd2bd2a$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $2LSrt.useEffect)(function() {
        return $e21355414fd2bd2a$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $e21355414fd2bd2a$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $e21355414fd2bd2a$export$2e2bcd8739ae039 = {
    useState: (0, $2LSrt.useState),
    useId: (0, $2LSrt.useId),
    useReducer: (0, $2LSrt.useReducer),
    useEffect: (0, $2LSrt.useEffect),
    useLayoutEffect: (0, $2LSrt.useLayoutEffect),
    useInsertionEffect: $e21355414fd2bd2a$export$aaabe4eda9ed9969,
    useTransition: $e21355414fd2bd2a$export$7b286972b8d8ccbf,
    useDeferredValue: $e21355414fd2bd2a$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $e21355414fd2bd2a$export$306c0aa65ff9ec16,
    startTransition: $e21355414fd2bd2a$export$7568632d0d33d16d,
    useRef: (0, $2LSrt.useRef),
    useImperativeHandle: (0, $2LSrt.useImperativeHandle),
    useMemo: (0, $2LSrt.useMemo),
    useCallback: (0, $2LSrt.useCallback),
    useContext: (0, $2LSrt.useContext),
    useDebugValue: (0, $2LSrt.useDebugValue),
    version: "17.0.2",
    Children: $e21355414fd2bd2a$export$dca3b0875bd9a954,
    render: $e21355414fd2bd2a$export$b3890eb0ae9dca99,
    hydrate: $e21355414fd2bd2a$export$fa8d919ba61d84db,
    unmountComponentAtNode: $e21355414fd2bd2a$export$502457920280e6be,
    createPortal: $e21355414fd2bd2a$export$d39a5bbd09211389,
    createElement: (0, $1Hdcz.createElement),
    createContext: (0, $1Hdcz.createContext),
    createFactory: $e21355414fd2bd2a$export$d38cd72104c1f0e9,
    cloneElement: $e21355414fd2bd2a$export$e530037191fcd5d7,
    createRef: (0, $1Hdcz.createRef),
    Fragment: (0, $1Hdcz.Fragment),
    isValidElement: $e21355414fd2bd2a$export$a8257692ac88316c,
    findDOMNode: $e21355414fd2bd2a$export$466bfc07425424d5,
    Component: (0, $1Hdcz.Component),
    PureComponent: $e21355414fd2bd2a$export$221d75b3f55bb0bd,
    memo: $e21355414fd2bd2a$export$7c73462e0d25e514,
    forwardRef: $e21355414fd2bd2a$export$257a8862b851cb5b,
    flushSync: $e21355414fd2bd2a$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $e21355414fd2bd2a$export$c78a37762a8d58e1,
    StrictMode: $e21355414fd2bd2a$export$5f8d39834fd61797,
    Suspense: $e21355414fd2bd2a$export$74bf444e3cd11ea5,
    SuspenseList: $e21355414fd2bd2a$export$998bcd577473dd93,
    lazy: $e21355414fd2bd2a$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $e21355414fd2bd2a$export$ae55be85d98224ed
};

});
parcelRegister("2LSrt", function(module, exports) {

$parcel$export(module.exports, "useState", () => $204a33a7557cbbd0$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $204a33a7557cbbd0$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $204a33a7557cbbd0$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $204a33a7557cbbd0$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $204a33a7557cbbd0$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $204a33a7557cbbd0$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $204a33a7557cbbd0$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $204a33a7557cbbd0$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $204a33a7557cbbd0$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $204a33a7557cbbd0$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useId", () => $204a33a7557cbbd0$export$f680877a34711e37);

var $1Hdcz = parcelRequire("1Hdcz");
var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = [], $204a33a7557cbbd0$var$e = (0, $1Hdcz.options).__b, $204a33a7557cbbd0$var$a = (0, $1Hdcz.options).__r, $204a33a7557cbbd0$var$v = (0, $1Hdcz.options).diffed, $204a33a7557cbbd0$var$l = (0, $1Hdcz.options).__c, $204a33a7557cbbd0$var$m = (0, $1Hdcz.options).unmount;
function $204a33a7557cbbd0$var$d(t, u) {
    (0, $1Hdcz.options).__h && (0, $1Hdcz.options).__h($204a33a7557cbbd0$var$r, t, $204a33a7557cbbd0$var$o || u), $204a33a7557cbbd0$var$o = 0;
    var i = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $204a33a7557cbbd0$var$c
    }), i.__[t];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$B, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        $204a33a7557cbbd0$var$r.u = !0;
        var f = $204a33a7557cbbd0$var$r.shouldComponentUpdate;
        $204a33a7557cbbd0$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !(0, $1Hdcz.options).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__H.__h.push(o));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !(0, $1Hdcz.options).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__h.push(o));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(t, r) {
    (0, $1Hdcz.options).useDebugValue && (0, $1Hdcz.options).useDebugValue(r ? r(t) : t);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$b() {
    for(var t; t = $204a33a7557cbbd0$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($204a33a7557cbbd0$var$k), t.__H.__h.forEach($204a33a7557cbbd0$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $1Hdcz.options).__e(r, t.__v);
    }
}
(0, $1Hdcz.options).__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, (0, $1Hdcz.options).__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $204a33a7557cbbd0$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$k), i.__h.forEach($204a33a7557cbbd0$var$w), i.__h = [])), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, (0, $1Hdcz.options).diffed = function(t) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(o) && $204a33a7557cbbd0$var$i === (0, $1Hdcz.options).requestAnimationFrame || (($204a33a7557cbbd0$var$i = (0, $1Hdcz.options).requestAnimationFrame) || $204a33a7557cbbd0$var$j)($204a33a7557cbbd0$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $204a33a7557cbbd0$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $204a33a7557cbbd0$var$c;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, (0, $1Hdcz.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($204a33a7557cbbd0$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $1Hdcz.options).__e(u, t.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(t, r);
}, (0, $1Hdcz.options).unmount = function(t) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $1Hdcz.options).__e(r, u.__v));
};
var $204a33a7557cbbd0$var$g = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$g && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$k(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$w(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});





parcelRegister("lVBJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6c31a575eac43e$export$2e2bcd8739ae039);

var $jgkCe = parcelRequire("jgkCe");

var $0jCox = parcelRequire("0jCox");


var $ff6c31a575eac43e$export$2e2bcd8739ae039 = (0, $jgkCe.createPlugin)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, $0jCox.DayGridView),
            dateProfileGeneratorClass: (0, $0jCox.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});

});
parcelRegister("0jCox", function(module, exports) {

$parcel$export(module.exports, "DayTable", () => $000f37fb542d3ff1$export$cd402b7558adf371);
$parcel$export(module.exports, "DayGridView", () => $000f37fb542d3ff1$export$39eed66de95896e5);
$parcel$export(module.exports, "TableDateProfileGenerator", () => $000f37fb542d3ff1$export$9fcce6e2d16ec31d);

var $9tuWU = parcelRequire("9tuWU");

var $1Hdcz = parcelRequire("1Hdcz");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $000f37fb542d3ff1$export$b3c27e869d856b7 extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $1Hdcz.createRef)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $9tuWU.ca)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $1Hdcz.createElement)((0, $9tuWU.cq), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $1Hdcz.createElement)((0, $9tuWU.bZ), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $9tuWU.ca)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $9tuWU.c9)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: 'main',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [
                {
                    key: 'main',
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: 'footer',
            key: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'main',
                    content: (0, $9tuWU.c8)
                }
            ]
        });
        return (0, $1Hdcz.createElement)((0, $9tuWU.cq), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $1Hdcz.createElement)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function $000f37fb542d3ff1$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $000f37fb542d3ff1$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $000f37fb542d3ff1$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $9tuWU.x)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function $000f37fb542d3ff1$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $000f37fb542d3ff1$var$TableBlockEvent extends (0, $9tuWU.B) {
    render() {
        let { props: props } = this;
        return (0, $1Hdcz.createElement)((0, $9tuWU.cg), Object.assign({}, props, {
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-block-event',
                'fc-h-event'
            ],
            defaultTimeFormat: $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $000f37fb542d3ff1$var$TableListItemEvent extends (0, $9tuWU.B) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $000f37fb542d3ff1$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $9tuWU.bO)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $1Hdcz.createElement)((0, $9tuWU.ck), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-dot-event'
            ],
            elAttrs: (0, $9tuWU.bS)(props.seg, context),
            defaultGenerator: $000f37fb542d3ff1$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $000f37fb542d3ff1$var$renderInnerContent(renderProps) {
    return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, (0, $1Hdcz.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $1Hdcz.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $1Hdcz.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, "\u00A0")));
}
class $000f37fb542d3ff1$var$TableCellMoreLink extends (0, $9tuWU.B) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $9tuWU.z)($000f37fb542d3ff1$var$compileSegs);
    }
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $1Hdcz.createElement)((0, $9tuWU.co), {
            elClasses: [
                'fc-daygrid-more-link'
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $1Hdcz.createElement)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                        }
                    }, $000f37fb542d3ff1$var$hasListItemDisplay(seg) ? (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $9tuWU.bQ)(seg, props.todayRange))) : (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $9tuWU.bQ)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function $000f37fb542d3ff1$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $000f37fb542d3ff1$var$DEFAULT_WEEK_NUM_FORMAT = (0, $9tuWU.x)({
    week: 'narrow'
});
class $000f37fb542d3ff1$var$TableCell extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $1Hdcz.createRef)();
        this.state = {
            dayNumberId: (0, $9tuWU.a3)()
        };
        this.handleRootEl = (el)=>{
            (0, $9tuWU.W)(this.rootElRef, el);
            (0, $9tuWU.W)(this.props.elRef, el);
        };
    }
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $000f37fb542d3ff1$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $1Hdcz.createElement)((0, $9tuWU.ci), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                'fc-daygrid-day',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                'aria-labelledby': state.dayNumberId
            } : {}), {
                role: 'gridcell'
            }),
            defaultGenerator: $000f37fb542d3ff1$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $1Hdcz.createElement)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $1Hdcz.createElement)((0, $9tuWU.cn), {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-week-number'
                ],
                elAttrs: (0, $9tuWU.a_)(context, date, 'week'),
                date: date,
                defaultFormat: $000f37fb542d3ff1$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $9tuWU.cj)(options) || props.forceDayTop) ? (0, $1Hdcz.createElement)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-day-number',
                    isMonthStart && 'fc-daygrid-month-start'
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $9tuWU.a_)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $1Hdcz.createElement)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: 'hidden'
                }
            }, (0, $1Hdcz.createElement)("a", {
                className: "fc-daygrid-day-number"
            }, "\u00A0")) : undefined, (0, $1Hdcz.createElement)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $1Hdcz.createElement)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $1Hdcz.createElement)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function $000f37fb542d3ff1$var$renderTopInner(props) {
    return props.dayNumberText || (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, "\u00A0");
}
function $000f37fb542d3ff1$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $9tuWU.be)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $000f37fb542d3ff1$var$generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function $000f37fb542d3ff1$var$generateSegUid(seg) {
    return $000f37fb542d3ff1$var$generateSegKey(seg) + ':' + seg.lastCol;
}
function $000f37fb542d3ff1$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new $000f37fb542d3ff1$var$DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = $000f37fb542d3ff1$var$generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $000f37fb542d3ff1$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $000f37fb542d3ff1$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $000f37fb542d3ff1$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $000f37fb542d3ff1$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $000f37fb542d3ff1$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $000f37fb542d3ff1$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $000f37fb542d3ff1$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $000f37fb542d3ff1$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $000f37fb542d3ff1$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $9tuWU.o)(origRange, {
        start: cells[spanStart].date,
        end: (0, $9tuWU.t)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $000f37fb542d3ff1$var$DayGridSegHierarchy extends (0, $9tuWU.by) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $9tuWU.bz)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $9tuWU.bz)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $9tuWU.bD)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, $9tuWU.bz)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class $000f37fb542d3ff1$var$TableRow extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $9tuWU.cd)(); // the <td>
        this.frameElRefs = new (0, $9tuWU.cd)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $9tuWU.cd)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $9tuWU.cd)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $1Hdcz.createRef)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $000f37fb542d3ff1$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $000f37fb542d3ff1$var$computeFgSegPlacement((0, $9tuWU.bP)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $1Hdcz.createElement)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $000f37fb542d3ff1$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, normalFgNodes), (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, mirrorFgNodes)),
                bgContent: (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $9tuWU.E)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = '';
            let right = '';
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $1Hdcz.createElement)("div", {
                className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                key: $000f37fb542d3ff1$var$generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef($000f37fb542d3ff1$var$generateSegUid(seg)),
                style: {
                    visibility: isVisible ? '' : 'hidden',
                    marginTop: isAbsolute ? '' : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : '',
                    left: left,
                    right: right
                }
            }, $000f37fb542d3ff1$var$hasListItemDisplay(seg) ? (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $9tuWU.bQ)(seg, todayRange))) : (0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $9tuWU.bQ)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $1Hdcz.createElement)("div", {
                key: (0, $9tuWU.bR)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === 'bg-event' ? (0, $1Hdcz.createElement)((0, $9tuWU.cm), Object.assign({
                seg: seg
            }, (0, $9tuWU.bQ)(seg, todayRange))) : (0, $9tuWU.cl)(fillType)));
        }
        return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $9tuWU.b8)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $9tuWU.b8)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
$000f37fb542d3ff1$var$TableRow.addStateEquality({
    segHeights: (0, $9tuWU.E)
});
function $000f37fb542d3ff1$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $000f37fb542d3ff1$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $000f37fb542d3ff1$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $000f37fb542d3ff1$export$d955b1c53830e05a extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitAllDaySegsByRow);
        this.splitFgEventSegs = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitSegsByRow);
        this.splitEventDrag = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitInteractionByRow);
        this.splitEventResize = (0, $9tuWU.z)($000f37fb542d3ff1$var$splitInteractionByRow);
        this.rowRefs = new (0, $9tuWU.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $1Hdcz.createElement)((0, $9tuWU.a6), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, props.cells.map((cells, row)=>(0, $1Hdcz.createElement)($000f37fb542d3ff1$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row],
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $9tuWU.b8)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $9tuWU.b8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $9tuWU.t)(start, 1);
        return {
            start: start,
            end: end
        };
    }
}
function $000f37fb542d3ff1$var$splitAllDaySegsByRow(segs, rowCnt) {
    return $000f37fb542d3ff1$var$splitSegsByRow(segs.filter($000f37fb542d3ff1$var$isSegAllDay), rowCnt);
}
function $000f37fb542d3ff1$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $000f37fb542d3ff1$export$54ec01a60f47d33d extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.elRef = (0, $1Hdcz.createRef)();
        this.needsScrollReset = false;
    }
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural'
        ];
        return (0, $1Hdcz.createElement)("div", {
            ref: this.elRef,
            className: classNames.join(' '),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $1Hdcz.createElement)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ''
            }
        }, props.colGroupNode, (0, $1Hdcz.createElement)("tbody", {
            role: "presentation"
        }, (0, $1Hdcz.createElement)($000f37fb542d3ff1$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $000f37fb542d3ff1$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest('.fc-daygrid-body');
                const scrollEl = originEl.closest('.fc-scroller');
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function $000f37fb542d3ff1$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $9tuWU.bv)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $9tuWU.bt)(dateProfile.currentDate)}"]`);
    return el;
}
class $000f37fb542d3ff1$export$eb38be9553e58392 extends (0, $9tuWU.bU) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class $000f37fb542d3ff1$export$cd402b7558adf371 extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.slicer = new $000f37fb542d3ff1$export$eb38be9553e58392();
        this.tableRef = (0, $1Hdcz.createRef)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $1Hdcz.createElement)($000f37fb542d3ff1$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class $000f37fb542d3ff1$export$39eed66de95896e5 extends $000f37fb542d3ff1$export$b3c27e869d856b7 {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $9tuWU.z)($000f37fb542d3ff1$export$61e79f95d746b006);
        this.headerRef = (0, $1Hdcz.createRef)();
        this.tableRef = (0, $1Hdcz.createRef)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $1Hdcz.createElement)((0, $9tuWU.bI), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $1Hdcz.createElement)($000f37fb542d3ff1$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function $000f37fb542d3ff1$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $9tuWU.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $9tuWU.bT)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class $000f37fb542d3ff1$export$9fcce6e2d16ec31d extends (0, $9tuWU.R) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $000f37fb542d3ff1$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $000f37fb542d3ff1$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $9tuWU.bf)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $9tuWU.t)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $9tuWU.bg)(lastMonthRenderStart, end));
        end = (0, $9tuWU.bf)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var $000f37fb542d3ff1$var$css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, $9tuWU.ct)($000f37fb542d3ff1$var$css_248z);

});


parcelRegister("7cipo", function(module, exports) {

$parcel$export(module.exports, "default", () => $53d7eeecb99f83a4$export$2e2bcd8739ae039);

var $jgkCe = parcelRequire("jgkCe");

var $XJb0i = parcelRequire("XJb0i");



const $53d7eeecb99f83a4$var$OPTION_REFINERS = {
    allDaySlot: Boolean
};
var $53d7eeecb99f83a4$export$2e2bcd8739ae039 = (0, $jgkCe.createPlugin)({
    name: '@fullcalendar/timegrid',
    initialView: 'timeGridWeek',
    optionRefiners: $53d7eeecb99f83a4$var$OPTION_REFINERS,
    views: {
        timeGrid: {
            component: (0, $XJb0i.DayTimeColsView),
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: '00:30:00',
            slotEventOverlap: true
        },
        timeGridDay: {
            type: 'timeGrid',
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: 'timeGrid',
            duration: {
                weeks: 1
            }
        }
    }
});

});
parcelRegister("XJb0i", function(module, exports) {

$parcel$export(module.exports, "DayTimeColsView", () => $0b388de944c7beb8$export$4b78a540ee976f33);

var $9tuWU = parcelRequire("9tuWU");

var $1Hdcz = parcelRequire("1Hdcz");

var $0jCox = parcelRequire("0jCox");
class $0b388de944c7beb8$var$AllDaySplitter extends (0, $9tuWU.aW) {
    getKeyInfo() {
        return {
            allDay: {},
            timed: {}
        };
    }
    getKeysForDateSpan(dateSpan) {
        if (dateSpan.allDay) return [
            'allDay'
        ];
        return [
            'timed'
        ];
    }
    getKeysForEventDef(eventDef) {
        if (!eventDef.allDay) return [
            'timed'
        ];
        if ((0, $9tuWU.bN)(eventDef)) return [
            'timed',
            'allDay'
        ];
        return [
            'allDay'
        ];
    }
}
const $0b388de944c7beb8$var$DEFAULT_SLAT_LABEL_FORMAT = (0, $9tuWU.x)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'short'
});
function $0b388de944c7beb8$var$TimeColsAxisCell(props) {
    let classNames = [
        'fc-timegrid-slot',
        'fc-timegrid-slot-label',
        props.isLabeled ? 'fc-scrollgrid-shrink' : 'fc-timegrid-slot-minor'
    ];
    return (0, $1Hdcz.createElement)((0, $9tuWU.V).Consumer, null, (context)=>{
        if (!props.isLabeled) return (0, $1Hdcz.createElement)("td", {
            className: classNames.join(' '),
            "data-time": props.isoTimeStr
        });
        let { dateEnv: dateEnv, options: options, viewApi: viewApi } = context;
        let labelFormat = options.slotLabelFormat == null ? $0b388de944c7beb8$var$DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $9tuWU.x)(options.slotLabelFormat[0]) : (0, $9tuWU.x)(options.slotLabelFormat);
        let renderProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $1Hdcz.createElement)((0, $9tuWU.C), {
            elTag: "td",
            elClasses: classNames,
            elAttrs: {
                'data-time': props.isoTimeStr
            },
            renderProps: renderProps,
            generatorName: "slotLabelContent",
            customGenerator: options.slotLabelContent,
            defaultGenerator: $0b388de944c7beb8$var$renderInnerContent,
            classNameGenerator: options.slotLabelClassNames,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, (InnerContent)=>(0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-slot-label-cushion',
                    'fc-scrollgrid-shrink-cushion'
                ]
            })));
    });
}
function $0b388de944c7beb8$var$renderInnerContent(props) {
    return props.text;
}
class $0b388de944c7beb8$var$TimeBodyAxis extends (0, $9tuWU.B) {
    render() {
        return this.props.slatMetas.map((slatMeta)=>(0, $1Hdcz.createElement)("tr", {
                key: slatMeta.key
            }, (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColsAxisCell, Object.assign({}, slatMeta))));
    }
}
const $0b388de944c7beb8$var$DEFAULT_WEEK_NUM_FORMAT = (0, $9tuWU.x)({
    week: 'short'
});
const $0b388de944c7beb8$var$AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
class $0b388de944c7beb8$export$667ac525945c6ff8 extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.allDaySplitter = new $0b388de944c7beb8$var$AllDaySplitter(); // for use by subclasses
        this.headerElRef = (0, $1Hdcz.createRef)();
        this.rootElRef = (0, $1Hdcz.createRef)();
        this.scrollerElRef = (0, $1Hdcz.createRef)();
        this.state = {
            slatCoords: null
        };
        this.handleScrollTopRequest = (scrollTop)=>{
            let scrollerEl = this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ this.renderHeadAxis = (rowKey, frameHeight = '')=>{
            let { options: options } = this.context;
            let { dateProfile: dateProfile } = this.props;
            let range = dateProfile.renderRange;
            let dayCnt = (0, $9tuWU.bj)(range.start, range.end);
            // only do in day views (to avoid doing in week views that dont need it)
            let navLinkAttrs = dayCnt === 1 ? (0, $9tuWU.a_)(this.context, range.start, 'week') : {};
            if (options.weekNumbers && rowKey === 'day') return (0, $1Hdcz.createElement)((0, $9tuWU.cn), {
                elTag: "th",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                date: range.start,
                defaultFormat: $0b388de944c7beb8$var$DEFAULT_WEEK_NUM_FORMAT
            }, (InnerContent)=>(0, $1Hdcz.createElement)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        'fc-timegrid-axis-frame-liquid'
                    ].join(' '),
                    style: {
                        height: frameHeight
                    }
                }, (0, $1Hdcz.createElement)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ],
                    elAttrs: navLinkAttrs
                })));
            return (0, $1Hdcz.createElement)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        this.renderTableRowAxis = (rowHeight)=>{
            let { options: options, viewApi: viewApi } = this.context;
            let renderProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $1Hdcz.createElement)((0, $9tuWU.C), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink'
                ],
                elAttrs: {
                    'aria-hidden': true
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $0b388de944c7beb8$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, (InnerContent)=>(0, $1Hdcz.createElement)("div", {
                    className: [
                        'fc-timegrid-axis-frame',
                        'fc-scrollgrid-shrink-frame',
                        rowHeight == null ? ' fc-timegrid-axis-frame-liquid' : ''
                    ].join(' '),
                    style: {
                        height: rowHeight
                    }
                }, (0, $1Hdcz.createElement)(InnerContent, {
                    elTag: "span",
                    elClasses: [
                        'fc-timegrid-axis-cushion',
                        'fc-scrollgrid-shrink-cushion',
                        'fc-scrollgrid-sync-inner'
                    ]
                }))));
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
        };
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    renderSimpleLayout(headerRowContent, allDayContent, timeContent) {
        let { context: context, props: props } = this;
        let sections = [];
        let stickyHeaderDates = (0, $9tuWU.ca)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                chunk: {
                    content: allDayContent
                }
            });
            sections.push({
                type: 'body',
                key: 'all-day-divider',
                outerContent: (0, $1Hdcz.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $1Hdcz.createElement)("td", {
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent
            }
        });
        return (0, $1Hdcz.createElement)((0, $9tuWU.cq), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $1Hdcz.createElement)((0, $9tuWU.bZ), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [
                {
                    width: 'shrink'
                }
            ],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { context: context, props: props } = this;
        let stickyHeaderDates = !props.forPrint && (0, $9tuWU.ca)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $9tuWU.c9)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            syncRowHeights: true,
            chunks: [
                {
                    key: 'axis',
                    rowContent: (arg)=>(0, $1Hdcz.createElement)("tr", {
                            role: "presentation"
                        }, this.renderHeadAxis('day', arg.rowSyncHeights[0]))
                },
                {
                    key: 'cols',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: (contentArg)=>(0, $1Hdcz.createElement)("tr", {
                                role: "presentation"
                            }, this.renderTableRowAxis(contentArg.rowSyncHeights[0]))
                    },
                    {
                        key: 'cols',
                        content: allDayContent
                    }
                ]
            });
            sections.push({
                key: 'all-day-divider',
                type: 'body',
                outerContent: (0, $1Hdcz.createElement)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $1Hdcz.createElement)("td", {
                    colSpan: 2,
                    className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded')
                }))
            });
        }
        let isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: 'axis',
                    content: (arg)=>// TODO: make this now-indicator arrow more DRY with TimeColsContent
                        (0, $1Hdcz.createElement)("div", {
                            className: "fc-timegrid-axis-chunk"
                        }, (0, $1Hdcz.createElement)("table", {
                            "aria-hidden": true,
                            style: {
                                height: arg.expandRows ? arg.clientHeight : ''
                            }
                        }, arg.tableColGroupNode, (0, $1Hdcz.createElement)("tbody", null, (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeBodyAxis, {
                            slatMetas: slatMetas
                        }))), (0, $1Hdcz.createElement)("div", {
                            className: "fc-timegrid-now-indicator-container"
                        }, (0, $1Hdcz.createElement)((0, $9tuWU.a6), {
                            unit: isNowIndicator ? 'minute' : 'day' /* hacky */ 
                        }, (nowDate)=>{
                            let nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                            if (typeof nowIndicatorTop === 'number') return (0, $1Hdcz.createElement)((0, $9tuWU.ch), {
                                elClasses: [
                                    'fc-timegrid-now-indicator-arrow'
                                ],
                                elStyle: {
                                    top: nowIndicatorTop
                                },
                                isAxis: true,
                                date: nowDate
                            });
                            return null;
                        })))
                },
                {
                    key: 'cols',
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            key: 'footer',
            type: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'axis',
                    content: (0, $9tuWU.c8)
                },
                {
                    key: 'cols',
                    content: (0, $9tuWU.c8)
                }
            ]
        });
        return (0, $1Hdcz.createElement)((0, $9tuWU.cq), {
            elRef: this.rootElRef,
            elClasses: [
                'fc-timegrid'
            ],
            viewSpec: context.viewSpec
        }, (0, $1Hdcz.createElement)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: false,
            colGroups: [
                {
                    width: 'shrink',
                    cols: [
                        {
                            width: 'shrink'
                        }
                    ]
                },
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ getAllDayMaxEventProps() {
        let { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows } = this.context.options;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            dayMaxEvents = undefined;
            dayMaxEventRows = $0b388de944c7beb8$var$AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return {
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows
        };
    }
}
function $0b388de944c7beb8$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
class $0b388de944c7beb8$export$bbb5c25f46ae511d {
    constructor(positions, dateProfile, slotDuration){
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    safeComputeTop(date) {
        let { dateProfile: dateProfile } = this;
        if ((0, $9tuWU.G)(dateProfile.currentRange, date)) {
            let startOfDayDate = (0, $9tuWU.q)(date);
            let timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= (0, $9tuWU.bq)(dateProfile.slotMinTime) && timeMs < (0, $9tuWU.bq)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $9tuWU.d)(timeMs));
        }
        return null;
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop(when, startOfDayDate) {
        if (!startOfDayDate) startOfDayDate = (0, $9tuWU.q)(when);
        return this.computeTimeTop((0, $9tuWU.d)(when.valueOf() - startOfDayDate.valueOf()));
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    computeTimeTop(duration) {
        let { positions: positions, dateProfile: dateProfile } = this;
        let len = positions.els.length;
        // floating-point value of # of slots covered
        let slatCoverage = (duration.milliseconds - (0, $9tuWU.bq)(dateProfile.slotMinTime)) / (0, $9tuWU.bq)(this.slotDuration);
        let slatIndex;
        let slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
    }
}
class $0b388de944c7beb8$var$TimeColsSlatsBody extends (0, $9tuWU.B) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { slatElRefs: slatElRefs } = props;
        return (0, $1Hdcz.createElement)("tbody", null, props.slatMetas.map((slatMeta, i)=>{
            let renderProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi
            };
            return (0, $1Hdcz.createElement)("tr", {
                key: slatMeta.key,
                ref: slatElRefs.createRef(slatMeta.key)
            }, props.axis && (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColsAxisCell, Object.assign({}, slatMeta)), (0, $1Hdcz.createElement)((0, $9tuWU.C), {
                elTag: "td",
                elClasses: [
                    'fc-timegrid-slot',
                    'fc-timegrid-slot-lane',
                    !slatMeta.isLabeled && 'fc-timegrid-slot-minor'
                ],
                elAttrs: {
                    'data-time': slatMeta.isoTimeStr
                },
                renderProps: renderProps,
                generatorName: "slotLaneContent",
                customGenerator: options.slotLaneContent,
                classNameGenerator: options.slotLaneClassNames,
                didMount: options.slotLaneDidMount,
                willUnmount: options.slotLaneWillUnmount
            }));
        }));
    }
}
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ class $0b388de944c7beb8$var$TimeColsSlats extends (0, $9tuWU.B) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $1Hdcz.createRef)();
        this.slatElRefs = new (0, $9tuWU.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        return (0, $1Hdcz.createElement)("div", {
            ref: this.rootElRef,
            className: "fc-timegrid-slots"
        }, (0, $1Hdcz.createElement)("table", {
            "aria-hidden": true,
            className: context.theme.getClass('table'),
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth,
                height: props.minHeight
            }
        }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColsSlatsBody, {
            slatElRefs: this.slatElRefs,
            axis: props.axis,
            slatMetas: props.slatMetas
        })));
    }
    componentDidMount() {
        this.updateSizing();
    }
    componentDidUpdate() {
        this.updateSizing();
    }
    componentWillUnmount() {
        if (this.props.onCoords) this.props.onCoords(null);
    }
    updateSizing() {
        let { context: context, props: props } = this;
        if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
        ) {
            let rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) props.onCoords(new $0b388de944c7beb8$export$bbb5c25f46ae511d(new (0, $9tuWU.b8)(this.rootElRef.current, $0b388de944c7beb8$var$collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
        }
    }
}
function $0b388de944c7beb8$var$collectSlatEls(elMap, slatMetas) {
    return slatMetas.map((slatMeta)=>elMap[slatMeta.key]);
}
function $0b388de944c7beb8$var$splitSegsByCol(segs, colCnt) {
    let segsByCol = [];
    let i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function $0b388de944c7beb8$var$splitInteractionByCol(ui, colCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < colCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.col].segs.push(seg);
    }
    return byRow;
}
class $0b388de944c7beb8$var$TimeColMoreLink extends (0, $9tuWU.B) {
    render() {
        let { props: props } = this;
        return (0, $1Hdcz.createElement)((0, $9tuWU.co), {
            elClasses: [
                'fc-timegrid-more-link'
            ],
            elStyle: {
                top: props.top,
                bottom: props.bottom
            },
            allDayDate: null,
            moreCnt: props.hiddenSegs.length,
            allSegs: props.hiddenSegs,
            hiddenSegs: props.hiddenSegs,
            extraDateSpan: props.extraDateSpan,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            popoverContent: ()=>$0b388de944c7beb8$var$renderPlainFgSegs(props.hiddenSegs, props),
            defaultGenerator: $0b388de944c7beb8$var$renderMoreLinkInner,
            forceTimed: true
        }, (InnerContent)=>(0, $1Hdcz.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-more-link-inner',
                    'fc-sticky'
                ]
            }));
    }
}
function $0b388de944c7beb8$var$renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function $0b388de944c7beb8$var$buildPositioning(segInputs, strictOrder, maxStackCnt) {
    let hierarchy = new (0, $9tuWU.by)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let hiddenGroups = (0, $9tuWU.bC)(hiddenEntries);
    let web = $0b388de944c7beb8$var$buildWeb(hierarchy);
    web = $0b388de944c7beb8$var$stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    let segRects = $0b388de944c7beb8$var$webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function $0b388de944c7beb8$var$buildWeb(hierarchy) {
    const { entriesByLevel: entriesByLevel } = hierarchy;
    const buildNode = $0b388de944c7beb8$var$cacheable((level, lateral)=>level + ':' + lateral, (level, lateral)=>{
        let siblingRange = $0b388de944c7beb8$var$findNextLevelSegs(hierarchy, level, lateral);
        let nextLevelRes = $0b388de944c7beb8$var$buildNodes(siblingRange, buildNode);
        let entry = entriesByLevel[level][lateral];
        return [
            Object.assign(Object.assign({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return $0b388de944c7beb8$var$buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function $0b388de944c7beb8$var$buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    let { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd } = siblingRange;
    let lateral = lateralStart;
    let pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort($0b388de944c7beb8$var$cmpDescPressures);
    return [
        pairs.map($0b388de944c7beb8$var$extractNode),
        pairs[0][1]
    ];
}
function $0b388de944c7beb8$var$cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function $0b388de944c7beb8$var$extractNode(a) {
    return a[0];
}
function $0b388de944c7beb8$var$findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    let { levelCoords: levelCoords, entriesByLevel: entriesByLevel } = hierarchy;
    let subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    let afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    let levelCnt = levelCoords.length;
    let level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        let entries = entriesByLevel[level];
        let entry;
        let searchIndex = (0, $9tuWU.bB)(entries, subjectEntry.span.start, (0, $9tuWU.bA));
        let lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        let lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function $0b388de944c7beb8$var$stretchWeb(topLevelNodes, totalThickness) {
    const stretchNode = $0b388de944c7beb8$var$cacheable((node, startCoord, prevThickness)=>(0, $9tuWU.bz)(node), (node, startCoord, prevThickness)=>{
        let { nextLevelNodes: nextLevelNodes, thickness: thickness } = node;
        let allThickness = thickness + prevThickness;
        let thicknessFraction = thickness / allThickness;
        let endCoord;
        let newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else {
            for (let childNode of nextLevelNodes)if (endCoord === undefined) {
                let res = stretchNode(childNode, startCoord, allThickness);
                endCoord = res[0];
                newChildren.push(res[1]);
            } else {
                let res = stretchNode(childNode, endCoord, 0);
                newChildren.push(res[1]);
            }
        }
        let newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            Object.assign(Object.assign({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map((node)=>stretchNode(node, 0, 0)[1]);
}
// not sorted in any particular order
function $0b388de944c7beb8$var$webToRects(topLevelNodes) {
    let rects = [];
    const processNode = $0b388de944c7beb8$var$cacheable((node, levelCoord, stackDepth)=>(0, $9tuWU.bz)(node), (node, levelCoord, stackDepth)=>{
        let rect = Object.assign(Object.assign({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        let stackForward = 0;
        for (let node of nodes)stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function $0b388de944c7beb8$var$cacheable(keyFunc, workFunc) {
    const cache = {};
    return (...args)=>{
        let key = keyFunc(...args);
        return key in cache ? cache[key] : cache[key] = workFunc(...args);
    };
}
function $0b388de944c7beb8$var$computeSegVCoords(segs, colDate, slatCoords = null, eventMinHeight = 0) {
    let vcoords = [];
    if (slatCoords) for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let spanStart = slatCoords.computeDateTop(seg.start, colDate);
        let spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function $0b388de944c7beb8$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    let segInputs = [];
    let dumbSegs = []; // segs without coords
    for(let i = 0; i < segs.length; i += 1){
        let vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    let { segRects: segRects, hiddenGroups: hiddenGroups } = $0b388de944c7beb8$var$buildPositioning(segInputs, eventOrderStrict, eventMaxStack);
    let segPlacements = [];
    for (let segRect of segRects)segPlacements.push({
        seg: segs[segRect.index],
        rect: segRect
    });
    for (let dumbSeg of dumbSegs)segPlacements.push({
        seg: dumbSeg,
        rect: null
    });
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
const $0b388de944c7beb8$var$DEFAULT_TIME_FORMAT = (0, $9tuWU.x)({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: false
});
class $0b388de944c7beb8$var$TimeColEvent extends (0, $9tuWU.B) {
    render() {
        return (0, $1Hdcz.createElement)((0, $9tuWU.cg), Object.assign({}, this.props, {
            elClasses: [
                'fc-timegrid-event',
                'fc-v-event',
                this.props.isShort && 'fc-timegrid-event-short'
            ],
            defaultTimeFormat: $0b388de944c7beb8$var$DEFAULT_TIME_FORMAT
        }));
    }
}
class $0b388de944c7beb8$var$TimeCol extends (0, $9tuWU.B) {
    constructor(){
        super(...arguments);
        this.sortEventSegs = (0, $9tuWU.z)((0, $9tuWU.bP));
    }
    // TODO: memoize event-placement?
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let isSelectMirror = options.selectMirror;
        let mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
        let interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        let sortedFgSegs = this.sortEventSegs(props.fgEventSegs, options.eventOrder);
        return (0, $1Hdcz.createElement)((0, $9tuWU.ci), {
            elTag: "td",
            elRef: props.elRef,
            elClasses: [
                'fc-timegrid-col',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'gridcell'
            }, props.extraDataAttrs),
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent)=>(0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-col-frame"
            }, (0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-col-bg"
            }, this.renderFillSegs(props.businessHourSegs, 'non-business'), this.renderFillSegs(props.bgEventSegs, 'bg-event'), this.renderFillSegs(props.dateSelectionSegs, 'highlight')), (0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror), 'mirror')), (0, $1Hdcz.createElement)("div", {
                className: "fc-timegrid-now-indicator-container"
            }, this.renderNowIndicator(props.nowIndicatorSegs)), (0, $9tuWU.cj)(options) && (0, $1Hdcz.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-timegrid-col-misc'
                ]
            })));
    }
    renderFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { props: props } = this;
        if (props.forPrint) return $0b388de944c7beb8$var$renderPlainFgSegs(sortedFgSegs, props);
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey);
    }
    renderPositionedFgSegs(segs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { eventMaxStack: eventMaxStack, eventShortHeight: eventShortHeight, eventOrderStrict: eventOrderStrict, eventMinHeight: eventMinHeight } = this.context.options;
        let { date: date, slatCoords: slatCoords, eventSelection: eventSelection, todayRange: todayRange, nowDate: nowDate } = this.props;
        let isMirror = isDragging || isResizing || isDateSelecting;
        let segVCoords = $0b388de944c7beb8$var$computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        let { segPlacements: segPlacements, hiddenGroups: hiddenGroups } = $0b388de944c7beb8$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack);
        return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map((segPlacement)=>{
            let { seg: seg, rect: rect } = segPlacement;
            let instanceId = seg.eventRange.instance.instanceId;
            let isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
            let vStyle = $0b388de944c7beb8$var$computeSegVStyle(rect && rect.span);
            let hStyle = !isMirror && rect ? this.computeSegHStyle(rect) : {
                left: 0,
                right: 0
            };
            let isInset = Boolean(rect) && rect.stackForward > 0;
            let isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
            return (0, $1Hdcz.createElement)("div", {
                className: 'fc-timegrid-event-harness' + (isInset ? ' fc-timegrid-event-harness-inset' : ''),
                key: forcedKey || instanceId,
                style: Object.assign(Object.assign({
                    visibility: isVisible ? '' : 'hidden'
                }, vStyle), hStyle)
            }, (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                isShort: isShort
            }, (0, $9tuWU.bQ)(seg, todayRange, nowDate))));
        }));
    }
    // will already have eventMinHeight applied because segInputs already had it
    renderHiddenGroups(hiddenGroups, segs) {
        let { extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize } = this.props;
        return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, hiddenGroups.map((hiddenGroup)=>{
            let positionCss = $0b388de944c7beb8$var$computeSegVStyle(hiddenGroup.span);
            let hiddenSegs = $0b388de944c7beb8$var$compileSegsFromEntries(hiddenGroup.entries, segs);
            return (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColMoreLink, {
                key: (0, $9tuWU.bu)((0, $9tuWU.cp)(hiddenSegs)),
                hiddenSegs: hiddenSegs,
                top: positionCss.top,
                bottom: positionCss.bottom,
                extraDateSpan: extraDateSpan,
                dateProfile: dateProfile,
                todayRange: todayRange,
                nowDate: nowDate,
                eventSelection: eventSelection,
                eventDrag: eventDrag,
                eventResize: eventResize
            });
        }));
    }
    renderFillSegs(segs, fillType) {
        let { props: props, context: context } = this;
        let segVCoords = $0b388de944c7beb8$var$computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        let children = segVCoords.map((vcoords, i)=>{
            let seg = segs[i];
            return (0, $1Hdcz.createElement)("div", {
                key: (0, $9tuWU.bR)(seg.eventRange),
                className: "fc-timegrid-bg-harness",
                style: $0b388de944c7beb8$var$computeSegVStyle(vcoords)
            }, fillType === 'bg-event' ? (0, $1Hdcz.createElement)((0, $9tuWU.cm), Object.assign({
                seg: seg
            }, (0, $9tuWU.bQ)(seg, props.todayRange, props.nowDate))) : (0, $9tuWU.cl)(fillType));
        });
        return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, children);
    }
    renderNowIndicator(segs) {
        let { slatCoords: slatCoords, date: date } = this.props;
        if (!slatCoords) return null;
        return segs.map((seg, i)=>(0, $1Hdcz.createElement)((0, $9tuWU.ch), {
                // key doesn't matter. will only ever be one
                key: i,
                elClasses: [
                    'fc-timegrid-now-indicator-line'
                ],
                elStyle: {
                    top: slatCoords.computeDateTop(seg.start, date)
                },
                isAxis: false,
                date: date
            }));
    }
    computeSegHStyle(segHCoords) {
        let { isRtl: isRtl, options: options } = this.context;
        let shouldOverlap = options.slotEventOverlap;
        let nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        let farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        let left; // amount of space from left edge, a fraction of the total width
        let right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
        farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        } else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        let props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + '%',
            right: right * 100 + '%'
        };
        if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[isRtl ? 'marginLeft' : 'marginRight'] = 20; // 10 is a guesstimate of the icon's width
        return props;
    }
}
function $0b388de944c7beb8$var$renderPlainFgSegs(sortedFgSegs, { todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }) {
    let hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $1Hdcz.createElement)((0, $1Hdcz.Fragment), null, sortedFgSegs.map((seg)=>{
        let instanceId = seg.eventRange.instance.instanceId;
        return (0, $1Hdcz.createElement)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? 'hidden' : ''
            }
        }, (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColEvent, Object.assign({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $9tuWU.bQ)(seg, todayRange, nowDate))));
    }));
}
function $0b388de944c7beb8$var$computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: '',
        bottom: ''
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function $0b388de944c7beb8$var$compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map((segEntry)=>allSegs[segEntry.index]);
}
class $0b388de944c7beb8$var$TimeColsContent extends (0, $9tuWU.B) {
    constructor(){
        super(...arguments);
        this.splitFgEventSegs = (0, $9tuWU.z)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitBgEventSegs = (0, $9tuWU.z)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitBusinessHourSegs = (0, $9tuWU.z)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitNowIndicatorSegs = (0, $9tuWU.z)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitDateSelectionSegs = (0, $9tuWU.z)($0b388de944c7beb8$var$splitSegsByCol);
        this.splitEventDrag = (0, $9tuWU.z)($0b388de944c7beb8$var$splitInteractionByCol);
        this.splitEventResize = (0, $9tuWU.z)($0b388de944c7beb8$var$splitInteractionByCol);
        this.rootElRef = (0, $1Hdcz.createRef)();
        this.cellElRefs = new (0, $9tuWU.cd)();
    }
    render() {
        let { props: props, context: context } = this;
        let nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
        let colCnt = props.cells.length;
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        let nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (0, $1Hdcz.createElement)("div", {
            className: "fc-timegrid-cols",
            ref: this.rootElRef
        }, (0, $1Hdcz.createElement)("table", {
            role: "presentation",
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth
            }
        }, props.tableColGroupNode, (0, $1Hdcz.createElement)("tbody", {
            role: "presentation"
        }, (0, $1Hdcz.createElement)("tr", {
            role: "row"
        }, props.axis && (0, $1Hdcz.createElement)("td", {
            "aria-hidden": true,
            className: "fc-timegrid-col fc-timegrid-axis"
        }, (0, $1Hdcz.createElement)("div", {
            className: "fc-timegrid-col-frame"
        }, (0, $1Hdcz.createElement)("div", {
            className: "fc-timegrid-now-indicator-container"
        }, typeof nowIndicatorTop === 'number' && (0, $1Hdcz.createElement)((0, $9tuWU.ch), {
            elClasses: [
                'fc-timegrid-now-indicator-arrow'
            ],
            elStyle: {
                top: nowIndicatorTop
            },
            isAxis: true,
            date: props.nowDate
        })))), props.cells.map((cell, i)=>(0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeCol, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                nowDate: props.nowDate,
                todayRange: props.todayRange,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                fgEventSegs: fgEventSegsByRow[i],
                bgEventSegs: bgEventSegsByRow[i],
                businessHourSegs: businessHourSegsByRow[i],
                nowIndicatorSegs: nowIndicatorSegsByRow[i],
                dateSelectionSegs: dateSelectionSegsByRow[i],
                eventDrag: eventDragByRow[i],
                eventResize: eventResizeByRow[i],
                slatCoords: props.slatCoords,
                eventSelection: props.eventSelection,
                forPrint: props.forPrint
            }))))));
    }
    componentDidMount() {
        this.updateCoords();
    }
    componentDidUpdate() {
        this.updateCoords();
    }
    updateCoords() {
        let { props: props } = this;
        if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
        ) props.onColCoords(new (0, $9tuWU.b8)(this.rootElRef.current, $0b388de944c7beb8$var$collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
    }
}
function $0b388de944c7beb8$var$collectCellEls(elMap, cells) {
    return cells.map((cell)=>elMap[cell.key]);
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ class $0b388de944c7beb8$export$6d0b14d80f61b392 extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.processSlotOptions = (0, $9tuWU.z)($0b388de944c7beb8$var$processSlotOptions);
        this.state = {
            slatCoords: null
        };
        this.handleRootEl = (el)=>{
            if (el) this.context.registerInteractiveComponent(this, {
                el: el,
                isHitComboAllowed: this.props.isHitComboAllowed
            });
            else this.context.unregisterInteractiveComponent(this);
        };
        this.handleScrollRequest = (request)=>{
            let { onScrollTopRequest: onScrollTopRequest } = this.props;
            let { slatCoords: slatCoords } = this.state;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    let top = slatCoords.computeTimeTop(request.time);
                    top = Math.ceil(top); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top) top += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top);
                }
                return true;
            }
            return false;
        };
        this.handleColCoords = (colCoords)=>{
            this.colCoords = colCoords;
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
            if (this.props.onSlatCoords) this.props.onSlatCoords(slatCoords);
        };
    }
    render() {
        let { props: props, state: state } = this;
        return (0, $1Hdcz.createElement)("div", {
            className: "fc-timegrid-body",
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColsSlats, {
            axis: props.axis,
            dateProfile: props.dateProfile,
            slatMetas: props.slatMetas,
            clientWidth: props.clientWidth,
            minHeight: props.expandRows ? props.clientHeight : '',
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.axis ? props.tableColGroupNode : null,
            onCoords: this.handleSlatCoords
        }), (0, $1Hdcz.createElement)($0b388de944c7beb8$var$TimeColsContent, {
            cells: props.cells,
            axis: props.axis,
            dateProfile: props.dateProfile,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            todayRange: props.todayRange,
            nowDate: props.nowDate,
            nowIndicatorSegs: props.nowIndicatorSegs,
            clientWidth: props.clientWidth,
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.tableColGroupNode,
            slatCoords: state.slatCoords,
            onColCoords: this.handleColCoords,
            forPrint: props.forPrint
        }));
    }
    componentDidMount() {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    }
    componentDidUpdate(prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    }
    componentWillUnmount() {
        this.scrollResponder.detach();
    }
    queryHit(positionLeft, positionTop) {
        let { dateEnv: dateEnv, options: options } = this.context;
        let { colCoords: colCoords } = this;
        let { dateProfile: dateProfile } = this.props;
        let { slatCoords: slatCoords } = this.state;
        let { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot } = this.processSlotOptions(this.props.slotDuration, options.snapDuration);
        let colIndex = colCoords.leftToIndex(positionLeft);
        let slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            let cell = this.props.cells[colIndex];
            let slatTop = slatCoords.positions.tops[slatIndex];
            let slatHeight = slatCoords.positions.getHeight(slatIndex);
            let partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            let localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            let snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            let dayDate = this.props.cells[colIndex].date;
            let time = (0, $9tuWU.bn)(dateProfile.slotMinTime, (0, $9tuWU.bm)(snapDuration, snapIndex));
            let start = dateEnv.add(dayDate, time);
            let end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: Object.assign({
                    range: {
                        start: start,
                        end: end
                    },
                    allDay: false
                }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight
                },
                layer: 0
            };
        }
        return null;
    }
}
function $0b388de944c7beb8$var$processSlotOptions(slotDuration, snapDurationOverride) {
    let snapDuration = snapDurationOverride || slotDuration;
    let snapsPerSlot = (0, $9tuWU.br)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
class $0b388de944c7beb8$export$ca63779cde537f3d extends (0, $9tuWU.bU) {
    sliceRange(range, dayRanges) {
        let segs = [];
        for(let col = 0; col < dayRanges.length; col += 1){
            let segRange = (0, $9tuWU.o)(range, dayRanges[col]);
            if (segRange) segs.push({
                start: segRange.start,
                end: segRange.end,
                isStart: segRange.start.valueOf() === range.start.valueOf(),
                isEnd: segRange.end.valueOf() === range.end.valueOf(),
                col: col
            });
        }
        return segs;
    }
}
class $0b388de944c7beb8$export$a1033d45b156b3eb extends (0, $9tuWU.bc) {
    constructor(){
        super(...arguments);
        this.buildDayRanges = (0, $9tuWU.z)($0b388de944c7beb8$export$718c171dfac2fa3a);
        this.slicer = new $0b388de944c7beb8$export$ca63779cde537f3d();
        this.timeColsRef = (0, $1Hdcz.createRef)();
    }
    render() {
        let { props: props, context: context } = this;
        let { dateProfile: dateProfile, dayTableModel: dayTableModel } = props;
        let { nowIndicator: nowIndicator, nextDayThreshold: nextDayThreshold } = context.options;
        let dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (0, $1Hdcz.createElement)((0, $9tuWU.a6), {
            unit: nowIndicator ? 'minute' : 'day'
        }, (nowDate, todayRange)=>(0, $1Hdcz.createElement)($0b388de944c7beb8$export$6d0b14d80f61b392, Object.assign({
                ref: this.timeColsRef
            }, this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                forPrint: props.forPrint,
                axis: props.axis,
                dateProfile: dateProfile,
                slatMetas: props.slatMetas,
                slotDuration: props.slotDuration,
                cells: dayTableModel.cells[0],
                tableColGroupNode: props.tableColGroupNode,
                tableMinWidth: props.tableMinWidth,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                expandRows: props.expandRows,
                nowDate: nowDate,
                nowIndicatorSegs: nowIndicator && this.slicer.sliceNowDate(nowDate, dateProfile, nextDayThreshold, context, dayRanges),
                todayRange: todayRange,
                onScrollTopRequest: props.onScrollTopRequest,
                onSlatCoords: props.onSlatCoords
            })));
    }
}
function $0b388de944c7beb8$export$718c171dfac2fa3a(dayTableModel, dateProfile, dateEnv) {
    let ranges = [];
    for (let date of dayTableModel.headerDates)ranges.push({
        start: dateEnv.add(date, dateProfile.slotMinTime),
        end: dateEnv.add(date, dateProfile.slotMaxTime)
    });
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
const $0b388de944c7beb8$var$STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function $0b388de944c7beb8$export$717bdb379477c13e(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    let dayStart = new Date(0);
    let slatTime = slotMinTime;
    let slatIterator = (0, $9tuWU.d)(0);
    let labelInterval = explicitLabelInterval || $0b388de944c7beb8$var$computeLabelInterval(slotDuration);
    let metas = [];
    while((0, $9tuWU.bq)(slatTime) < (0, $9tuWU.bq)(slotMaxTime)){
        let date = dateEnv.add(dayStart, slatTime);
        let isLabeled = (0, $9tuWU.br)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $9tuWU.bs)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $9tuWU.bn)(slatTime, slotDuration);
        slatIterator = (0, $9tuWU.bn)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function $0b388de944c7beb8$var$computeLabelInterval(slotDuration) {
    let i;
    let labelInterval;
    let slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = $0b388de944c7beb8$var$STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $9tuWU.d)($0b388de944c7beb8$var$STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $9tuWU.br)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
class $0b388de944c7beb8$export$4b78a540ee976f33 extends $0b388de944c7beb8$export$667ac525945c6ff8 {
    constructor(){
        super(...arguments);
        this.buildTimeColsModel = (0, $9tuWU.z)($0b388de944c7beb8$export$5596a640484dddd2);
        this.buildSlatMetas = (0, $9tuWU.z)($0b388de944c7beb8$export$717bdb379477c13e);
    }
    render() {
        let { options: options, dateEnv: dateEnv, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let { dateProfile: dateProfile } = props;
        let dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        let splitProps = this.allDaySplitter.splitProps(props);
        let slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        let { dayMinWidth: dayMinWidth } = options;
        let hasAttachedAxis = !dayMinWidth;
        let hasDetachedAxis = dayMinWidth;
        let headerContent = options.dayHeaders && (0, $1Hdcz.createElement)((0, $9tuWU.bI), {
            dates: dayTableModel.headerDates,
            dateProfile: dateProfile,
            datesRepDistinctDays: true,
            renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
        });
        let allDayContent = options.allDaySlot !== false && ((contentArg)=>(0, $1Hdcz.createElement)((0, $0jCox.DayTable), Object.assign({}, splitProps.allDay, {
                dateProfile: dateProfile,
                dayTableModel: dayTableModel,
                nextDayThreshold: options.nextDayThreshold,
                tableMinWidth: contentArg.tableMinWidth,
                colGroupNode: contentArg.tableColGroupNode,
                renderRowIntro: hasAttachedAxis ? this.renderTableRowAxis : null,
                showWeekNumbers: false,
                expandRows: false,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            }, this.getAllDayMaxEventProps())));
        let timeGridContent = (contentArg)=>(0, $1Hdcz.createElement)($0b388de944c7beb8$export$a1033d45b156b3eb, Object.assign({}, splitProps.timed, {
                dayTableModel: dayTableModel,
                dateProfile: dateProfile,
                axis: hasAttachedAxis,
                slotDuration: options.slotDuration,
                slatMetas: slatMetas,
                forPrint: props.forPrint,
                tableColGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                onSlatCoords: this.handleSlatCoords,
                expandRows: contentArg.expandRows,
                onScrollTopRequest: this.handleScrollTopRequest
            }));
        return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    }
}
function $0b388de944c7beb8$export$5596a640484dddd2(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $9tuWU.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $9tuWU.bT)(daySeries, false);
}
var $0b388de944c7beb8$var$css_248z = ".fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:\"\\00a0\"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:\"\\00a0-\\00a0\"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-arrow,.fc .fc-timegrid-now-indicator-line{pointer-events:none}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}";
(0, $9tuWU.ct)($0b388de944c7beb8$var$css_248z);

});


parcelRegister("3PVfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb28a74447ccf07$export$2e2bcd8739ae039);

var $jgkCe = parcelRequire("jgkCe");

var $9tuWU = parcelRequire("9tuWU");
(0, $9tuWU.bG).touchMouseIgnoreWait = 500;
let $2cb28a74447ccf07$var$ignoreMouseDepth = 0;
let $2cb28a74447ccf07$var$listenerCnt = 0;
let $2cb28a74447ccf07$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ class $2cb28a74447ccf07$var$PointerDragging {
    constructor(containerEl){
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ''; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = '';
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = (ev)=>{
            if (!this.shouldIgnoreMouse() && $2cb28a74447ccf07$var$isPrimaryMouseButton(ev) && this.tryStart(ev)) {
                let pev = this.createEventFromMouse(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                if (!this.shouldIgnoreMove) document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            }
        };
        this.handleMouseMove = (ev)=>{
            let pev = this.createEventFromMouse(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleMouseUp = (ev)=>{
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
            this.emitter.trigger('pointerup', this.createEventFromMouse(ev));
            this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = (ev)=>{
            if (this.tryStart(ev)) {
                this.isTouchDragging = true;
                let pev = this.createEventFromTouch(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                let targetEl = ev.target;
                if (!this.shouldIgnoreMove) targetEl.addEventListener('touchmove', this.handleTouchMove);
                targetEl.addEventListener('touchend', this.handleTouchEnd);
                targetEl.addEventListener('touchcancel', this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener('scroll', this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = (ev)=>{
            let pev = this.createEventFromTouch(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleTouchEnd = (ev)=>{
            if (this.isDragging) {
                let targetEl = ev.target;
                targetEl.removeEventListener('touchmove', this.handleTouchMove);
                targetEl.removeEventListener('touchend', this.handleTouchEnd);
                targetEl.removeEventListener('touchcancel', this.handleTouchEnd);
                window.removeEventListener('scroll', this.handleTouchScroll, true); // useCaptured=true
                this.emitter.trigger('pointerup', this.createEventFromTouch(ev));
                this.cleanup(); // call last so that pointerup has access to props
                this.isTouchDragging = false;
                $2cb28a74447ccf07$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = ()=>{
            this.wasTouchScroll = true;
        };
        this.handleScroll = (ev)=>{
            if (!this.shouldIgnoreMove) {
                let pageX = window.scrollX - this.prevScrollX + this.prevPageX;
                let pageY = window.scrollY - this.prevScrollY + this.prevPageY;
                this.emitter.trigger('pointermove', {
                    origEvent: ev,
                    isTouch: this.isTouchDragging,
                    subjectEl: this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - this.origPageX,
                    deltaY: pageY - this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $9tuWU.F)();
        containerEl.addEventListener('mousedown', this.handleMouseDown);
        containerEl.addEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        $2cb28a74447ccf07$var$listenerCreated();
    }
    destroy() {
        this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
        this.containerEl.removeEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        $2cb28a74447ccf07$var$listenerDestroyed();
    }
    tryStart(ev) {
        let subjectEl = this.querySubjectEl(ev);
        let downEl = ev.target;
        if (subjectEl && (!this.handleSelector || (0, $9tuWU.Z)(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    }
    cleanup() {
        $2cb28a74447ccf07$var$isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    }
    querySubjectEl(ev) {
        if (this.selector) return (0, $9tuWU.Z)(ev.target, this.selector);
        return this.containerEl;
    }
    shouldIgnoreMouse() {
        return $2cb28a74447ccf07$var$ignoreMouseDepth || this.isTouchDragging;
    }
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    cancelTouchScroll() {
        if (this.isDragging) $2cb28a74447ccf07$var$isWindowTouchMoveCancelled = true;
    }
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    initScrollWatch(ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener('scroll', this.handleScroll, true); // useCapture=true
        }
    }
    recordCoords(ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.scrollX;
            this.prevScrollY = window.scrollY;
        }
    }
    destroyScrollWatch() {
        if (this.shouldWatchScroll) window.removeEventListener('scroll', this.handleScroll, true); // useCaptured=true
    }
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    createEventFromMouse(ev, isFirst) {
        let deltaX = 0;
        let deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        } else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
    createEventFromTouch(ev, isFirst) {
        let touches = ev.touches;
        let pageX;
        let pageY;
        let deltaX = 0;
        let deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        } else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        } else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
}
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $2cb28a74447ccf07$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $2cb28a74447ccf07$var$startIgnoringMouse() {
    $2cb28a74447ccf07$var$ignoreMouseDepth += 1;
    setTimeout(()=>{
        $2cb28a74447ccf07$var$ignoreMouseDepth -= 1;
    }, (0, $9tuWU.bG).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $2cb28a74447ccf07$var$listenerCreated() {
    $2cb28a74447ccf07$var$listenerCnt += 1;
    if ($2cb28a74447ccf07$var$listenerCnt === 1) window.addEventListener('touchmove', $2cb28a74447ccf07$var$onWindowTouchMove, {
        passive: false
    });
}
function $2cb28a74447ccf07$var$listenerDestroyed() {
    $2cb28a74447ccf07$var$listenerCnt -= 1;
    if (!$2cb28a74447ccf07$var$listenerCnt) window.removeEventListener('touchmove', $2cb28a74447ccf07$var$onWindowTouchMove, {
        passive: false
    });
}
function $2cb28a74447ccf07$var$onWindowTouchMove(ev) {
    if ($2cb28a74447ccf07$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ class $2cb28a74447ccf07$var$ElementMirror {
    constructor(){
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    start(sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.scrollX;
        this.origScreenY = pageY - window.scrollY;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    }
    handleMove(pageX, pageY) {
        this.deltaX = pageX - window.scrollX - this.origScreenX;
        this.deltaY = pageY - window.scrollY - this.origScreenY;
        this.updateElPosition();
    }
    // can be called before start
    setIsVisible(bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = '';
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        } else if (this.isVisible) {
            if (this.mirrorEl) this.mirrorEl.style.display = 'none';
            this.isVisible = bool;
        }
    }
    // always async
    stop(needsRevertAnimation, callback) {
        let done = ()=>{
            this.cleanup();
            callback();
        };
        if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
        (this.deltaX || this.deltaY // if same coords, transition won't work
        )) this.doRevertAnimation(done, this.revertDuration);
        else setTimeout(done, 0);
    }
    doRevertAnimation(callback, revertDuration) {
        let mirrorEl = this.mirrorEl;
        let finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition = 'top ' + revertDuration + 'ms,' + 'left ' + revertDuration + 'ms';
        (0, $9tuWU.aN)(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top
        });
        (0, $9tuWU.b0)(mirrorEl, ()=>{
            mirrorEl.style.transition = '';
            callback();
        });
    }
    cleanup() {
        if (this.mirrorEl) {
            (0, $9tuWU.aM)(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    }
    updateElPosition() {
        if (this.sourceEl && this.isVisible) (0, $9tuWU.aN)(this.getMirrorEl(), {
            left: this.sourceElRect.left + this.deltaX,
            top: this.sourceElRect.top + this.deltaY
        });
    }
    getMirrorEl() {
        let sourceElRect = this.sourceElRect;
        let mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.style.userSelect = 'none';
            mirrorEl.style.webkitUserSelect = 'none';
            mirrorEl.style.pointerEvents = 'none';
            mirrorEl.classList.add('fc-event-dragging');
            (0, $9tuWU.aN)(mirrorEl, {
                position: 'fixed',
                zIndex: this.zIndex,
                visibility: '',
                boxSizing: 'border-box',
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: 'auto',
                bottom: 'auto',
                margin: 0
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    }
}
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ class $2cb28a74447ccf07$var$ScrollGeomCache extends (0, $9tuWU.b9) {
    constructor(scrollController, doesListening){
        super();
        this.handleScroll = ()=>{
            this.scrollTop = this.scrollController.getScrollTop();
            this.scrollLeft = this.scrollController.getScrollLeft();
            this.handleScrollChange();
        };
        this.scrollController = scrollController;
        this.doesListening = doesListening;
        this.scrollTop = this.origScrollTop = scrollController.getScrollTop();
        this.scrollLeft = this.origScrollLeft = scrollController.getScrollLeft();
        this.scrollWidth = scrollController.getScrollWidth();
        this.scrollHeight = scrollController.getScrollHeight();
        this.clientWidth = scrollController.getClientWidth();
        this.clientHeight = scrollController.getClientHeight();
        this.clientRect = this.computeClientRect(); // do last in case it needs cached values
        if (this.doesListening) this.getEventTarget().addEventListener('scroll', this.handleScroll);
    }
    destroy() {
        if (this.doesListening) this.getEventTarget().removeEventListener('scroll', this.handleScroll);
    }
    getScrollTop() {
        return this.scrollTop;
    }
    getScrollLeft() {
        return this.scrollLeft;
    }
    setScrollTop(top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    }
    setScrollLeft(top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    }
    getClientWidth() {
        return this.clientWidth;
    }
    getClientHeight() {
        return this.clientHeight;
    }
    getScrollWidth() {
        return this.scrollWidth;
    }
    getScrollHeight() {
        return this.scrollHeight;
    }
    handleScrollChange() {}
}
class $2cb28a74447ccf07$var$ElementScrollGeomCache extends $2cb28a74447ccf07$var$ScrollGeomCache {
    constructor(el, doesListening){
        super(new (0, $9tuWU.ba)(el), doesListening);
    }
    getEventTarget() {
        return this.scrollController.el;
    }
    computeClientRect() {
        return (0, $9tuWU.b1)(this.scrollController.el);
    }
}
class $2cb28a74447ccf07$var$WindowScrollGeomCache extends $2cb28a74447ccf07$var$ScrollGeomCache {
    constructor(doesListening){
        super(new (0, $9tuWU.bb)(), doesListening);
    }
    getEventTarget() {
        return window;
    }
    computeClientRect() {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight
        };
    }
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    handleScrollChange() {
        this.clientRect = this.computeClientRect();
    }
}
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
const $2cb28a74447ccf07$var$getTime = typeof performance === 'function' ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ class $2cb28a74447ccf07$var$AutoScroller {
    constructor(){
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            '.fc-scroller'
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = ()=>{
            if (this.isAnimating) {
                let edge = this.computeBestEdge(this.pointerScreenX + window.scrollX, this.pointerScreenY + window.scrollY);
                if (edge) {
                    let now = $2cb28a74447ccf07$var$getTime();
                    this.handleSide(edge, (now - this.msSinceRequest) / 1000);
                    this.requestAnimation(now);
                } else this.isAnimating = false; // will stop animation
            }
        };
    }
    start(pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    }
    handleMove(pageX, pageY) {
        if (this.isEnabled) {
            let pointerScreenX = pageX - window.scrollX;
            let pointerScreenY = pageY - window.scrollY;
            let yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            let xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) this.everMovedUp = true;
            else if (yDelta > 0) this.everMovedDown = true;
            if (xDelta < 0) this.everMovedLeft = true;
            else if (xDelta > 0) this.everMovedRight = true;
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation($2cb28a74447ccf07$var$getTime());
            }
        }
    }
    stop() {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (let scrollCache of this.scrollCaches)scrollCache.destroy();
            this.scrollCaches = null;
        }
    }
    requestAnimation(now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    }
    handleSide(edge, seconds) {
        let { scrollCache: scrollCache } = edge;
        let { edgeThreshold: edgeThreshold } = this;
        let invDistance = edgeThreshold - edge.distance;
        let velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
        this.maxVelocity * seconds;
        let sign = 1;
        switch(edge.name){
            case 'left':
                sign = -1;
            // falls through
            case 'right':
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case 'top':
                sign = -1;
            // falls through
            case 'bottom':
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    }
    // left/top are relative to document topleft
    computeBestEdge(left, top) {
        let { edgeThreshold: edgeThreshold } = this;
        let bestSide = null;
        let scrollCaches = this.scrollCaches || [];
        for (let scrollCache of scrollCaches){
            let rect = scrollCache.clientRect;
            let leftDist = left - rect.left;
            let rightDist = rect.right - left;
            let topDist = top - rect.top;
            let bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'top',
                    distance: topDist
                };
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'bottom',
                    distance: bottomDist
                };
                /*
                TODO: fix broken RTL scrolling. canScrollLeft always returning false
                https://github.com/fullcalendar/fullcalendar/issues/4837
                */ if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'left',
                    distance: leftDist
                };
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: 'right',
                    distance: rightDist
                };
            }
        }
        return bestSide;
    }
    buildCaches(scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map((el)=>{
            if (el === window) return new $2cb28a74447ccf07$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            return new $2cb28a74447ccf07$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    }
    queryScrollEls(scrollStartEl) {
        let els = [];
        for (let query of this.scrollQuery)if (typeof query === 'object') els.push(query);
        else /*
                TODO: in the future, always have auto-scroll happen on element where current Hit came from
                Ticket: https://github.com/fullcalendar/fullcalendar/issues/4593
                */ els.push(...Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query)));
        return els;
    }
}
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ class $2cb28a74447ccf07$var$FeaturefulElementDragging extends (0, $9tuWU.bF) {
    constructor(containerEl, selector){
        super(containerEl);
        this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        this.delay = null;
        this.minDistance = 0;
        this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        this.mirrorNeedsRevert = false;
        this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        this.isDelayEnded = false;
        this.isDistanceSurpassed = false;
        this.delayTimeoutId = null;
        this.onPointerDown = (ev)=>{
            if (!this.isDragging) {
                this.isInteracting = true;
                this.isDelayEnded = false;
                this.isDistanceSurpassed = false;
                (0, $9tuWU.ap)(document.body);
                (0, $9tuWU.ar)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                this.emitter.trigger('pointerdown', ev);
                if (this.isInteracting && // not destroyed via pointerdown handler
                !this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    this.mirror.setIsVisible(false); // reset. caller must set-visible
                    this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    this.startDelay(ev);
                    if (!this.minDistance) this.handleDistanceSurpassed(ev);
                }
            }
        };
        this.onPointerMove = (ev)=>{
            if (this.isInteracting) {
                this.emitter.trigger('pointermove', ev);
                if (!this.isDistanceSurpassed) {
                    let minDistance = this.minDistance;
                    let distanceSq; // current distance from the origin, squared
                    let { deltaX: deltaX, deltaY: deltaY } = ev;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) this.handleDistanceSurpassed(ev);
                }
                if (this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== 'scroll') {
                        this.mirror.handleMove(ev.pageX, ev.pageY);
                        this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    this.emitter.trigger('dragmove', ev);
                }
            }
        };
        this.onPointerUp = (ev)=>{
            if (this.isInteracting) {
                this.isInteracting = false;
                (0, $9tuWU.aq)(document.body);
                (0, $9tuWU.as)(document.body);
                this.emitter.trigger('pointerup', ev); // can potentially set mirrorNeedsRevert
                if (this.isDragging) {
                    this.autoScroller.stop();
                    this.tryStopDrag(ev); // which will stop the mirror
                }
                if (this.delayTimeoutId) {
                    clearTimeout(this.delayTimeoutId);
                    this.delayTimeoutId = null;
                }
            }
        };
        let pointer = this.pointer = new $2cb28a74447ccf07$var$PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.onPointerDown);
        pointer.emitter.on('pointermove', this.onPointerMove);
        pointer.emitter.on('pointerup', this.onPointerUp);
        if (selector) pointer.selector = selector;
        this.mirror = new $2cb28a74447ccf07$var$ElementMirror();
        this.autoScroller = new $2cb28a74447ccf07$var$AutoScroller();
    }
    destroy() {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    }
    startDelay(ev) {
        if (typeof this.delay === 'number') this.delayTimeoutId = setTimeout(()=>{
            this.delayTimeoutId = null;
            this.handleDelayEnd(ev);
        }, this.delay); // not assignable to number!
        else this.handleDelayEnd(ev);
    }
    handleDelayEnd(ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    }
    handleDistanceSurpassed(ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    }
    tryStartDrag(ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger('dragstart', ev);
                if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
            }
        }
    }
    tryStopDrag(ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    }
    stopDrag(ev) {
        this.isDragging = false;
        this.emitter.trigger('dragend', ev);
    }
    // fill in the implementations...
    setIgnoreMove(bool) {
        this.pointer.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        this.mirror.setIsVisible(bool);
    }
    setMirrorNeedsRevert(bool) {
        this.mirrorNeedsRevert = bool;
    }
    setAutoScrollEnabled(bool) {
        this.autoScroller.isEnabled = bool;
    }
}
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ class $2cb28a74447ccf07$var$OffsetTracker {
    constructor(el){
        this.el = el;
        this.origRect = (0, $9tuWU.b4)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $9tuWU.b3)(el).map((scrollEl)=>new $2cb28a74447ccf07$var$ElementScrollGeomCache(scrollEl, true));
    }
    destroy() {
        for (let scrollCache of this.scrollCaches)scrollCache.destroy();
    }
    computeLeft() {
        let left = this.origRect.left;
        for (let scrollCache of this.scrollCaches)left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        return left;
    }
    computeTop() {
        let top = this.origRect.top;
        for (let scrollCache of this.scrollCaches)top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        return top;
    }
    isWithinClipping(pageX, pageY) {
        let point = {
            left: pageX,
            top: pageY
        };
        for (let scrollCache of this.scrollCaches){
            if (!$2cb28a74447ccf07$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $9tuWU.aD)(point, scrollCache.clientRect)) return false;
        }
        return true;
    }
}
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $2cb28a74447ccf07$var$isIgnoredClipping(node) {
    let tagName = node.tagName;
    return tagName === 'HTML' || tagName === 'BODY';
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ class $2cb28a74447ccf07$var$HitDragging {
    constructor(dragging, droppableStore){
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.disablePointCheck = false;
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            this.initialHit = null;
            this.movingHit = null;
            this.finalHit = null;
            this.prepareHits();
            this.processFirstCoord(ev);
            if (this.initialHit || !this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                this.emitter.trigger('pointerdown', ev);
            } else dragging.setIgnoreMove(true);
        };
        this.handleDragStart = (ev)=>{
            this.emitter.trigger('dragstart', ev);
            this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = (ev)=>{
            this.emitter.trigger('dragmove', ev);
            this.handleMove(ev);
        };
        this.handlePointerUp = (ev)=>{
            this.releaseHits();
            this.emitter.trigger('pointerup', ev);
        };
        this.handleDragEnd = (ev)=>{
            if (this.movingHit) this.emitter.trigger('hitupdate', null, true, ev);
            this.finalHit = this.movingHit;
            this.movingHit = null;
            this.emitter.trigger('dragend', ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        dragging.emitter.on('dragmove', this.handleDragMove);
        dragging.emitter.on('pointerup', this.handlePointerUp);
        dragging.emitter.on('dragend', this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $9tuWU.F)();
    }
    // sets initialHit
    // sets coordAdjust
    processFirstCoord(ev) {
        let origPoint = {
            left: ev.pageX,
            top: ev.pageY
        };
        let adjustedPoint = origPoint;
        let subjectEl = ev.subjectEl;
        let subjectRect;
        if (subjectEl instanceof HTMLElement) {
            subjectRect = (0, $9tuWU.b4)(subjectEl);
            adjustedPoint = (0, $9tuWU.aE)(adjustedPoint, subjectRect);
        }
        let initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                let slicedSubjectRect = (0, $9tuWU.aC)(subjectRect, initialHit.rect);
                if (slicedSubjectRect) adjustedPoint = (0, $9tuWU.aF)(slicedSubjectRect);
            }
            this.coordAdjust = (0, $9tuWU.aG)(adjustedPoint, origPoint);
        } else this.coordAdjust = {
            left: 0,
            top: 0
        };
    }
    handleMove(ev, forceHandle) {
        let hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !$2cb28a74447ccf07$var$isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger('hitupdate', hit, false, ev);
        }
    }
    prepareHits() {
        this.offsetTrackers = (0, $9tuWU.a)(this.droppableStore, (interactionSettings)=>{
            interactionSettings.component.prepareHits();
            return new $2cb28a74447ccf07$var$OffsetTracker(interactionSettings.el);
        });
    }
    releaseHits() {
        let { offsetTrackers: offsetTrackers } = this;
        for(let id in offsetTrackers)offsetTrackers[id].destroy();
        this.offsetTrackers = {};
    }
    queryHitForOffset(offsetLeft, offsetTop) {
        let { droppableStore: droppableStore, offsetTrackers: offsetTrackers } = this;
        let bestHit = null;
        for(let id in droppableStore){
            let component = droppableStore[id].component;
            let offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
            offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                let originLeft = offsetTracker.computeLeft();
                let originTop = offsetTracker.computeTop();
                let positionLeft = offsetLeft - originLeft;
                let positionTop = offsetTop - originTop;
                let { origRect: origRect } = offsetTracker;
                let width = origRect.right - origRect.left;
                let height = origRect.bottom - origRect.top;
                if (// must be within the element's bounds
                positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                    let hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                    (0, $9tuWU.b7)(hit.dateProfile.activeRange, hit.dateSpan.range) && // Ensure the component we are querying for the hit is accessibly my the pointer
                    // Prevents obscured calendars (ex: under a modal dialog) from accepting hit
                    // https://github.com/fullcalendar/fullcalendar/issues/5026
                    (this.disablePointCheck || offsetTracker.el.contains(offsetTracker.el.getRootNode().elementFromPoint(// add-back origins to get coordinate relative to top-left of window viewport
                    positionLeft + originLeft - window.scrollX, positionTop + originTop - window.scrollY))) && (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    }
}
function $2cb28a74447ccf07$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $9tuWU.bd)(hit0.dateSpan, hit1.dateSpan);
}
function $2cb28a74447ccf07$var$buildDatePointApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.datePointTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $2cb28a74447ccf07$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $2cb28a74447ccf07$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ class $2cb28a74447ccf07$var$DateClicking extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        this.handlePointerDown = (pev)=>{
            let { dragging: dragging } = this;
            let downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        this.handleDragEnd = (ev)=>{
            let { component: component } = this;
            let { pointer: pointer } = this.dragging;
            if (!pointer.wasTouchScroll) {
                let { initialHit: initialHit, finalHit: finalHit } = this.hitDragging;
                if (initialHit && finalHit && $2cb28a74447ccf07$var$isHitsEqual(initialHit, finalHit)) {
                    let { context: context } = component;
                    let arg = Object.assign(Object.assign({}, $2cb28a74447ccf07$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger('dateClick', arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        this.dragging = new $2cb28a74447ccf07$var$FeaturefulElementDragging(settings.el);
        this.dragging.autoScroller.isEnabled = false;
        let hitDragging = this.hitDragging = new $2cb28a74447ccf07$var$HitDragging(this.dragging, (0, $9tuWU.bE)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ class $2cb28a74447ccf07$var$DateSelecting extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        this.dragSelection = null;
        this.handlePointerDown = (ev)=>{
            let { component: component, dragging: dragging } = this;
            let { options: options } = component.context;
            let canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $2cb28a74447ccf07$var$getComponentTouchDelay$1(component) : null;
        };
        this.handleDragStart = (ev)=>{
            this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            let { context: context } = this.component;
            let dragSelection = null;
            let isInvalid = false;
            if (hit) {
                let initialHit = this.hitDragging.initialHit;
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $2cb28a74447ccf07$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $9tuWU.bY)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: 'SELECT_DATES',
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: 'UNSELECT_DATES'
            });
            if (!isInvalid) (0, $9tuWU.au)();
            else (0, $9tuWU.av)();
            if (!isFinal) this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        this.handlePointerUp = (pev)=>{
            if (this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $9tuWU.cr)(this.dragSelection, pev, this.component.context);
                this.dragSelection = null;
            }
        };
        let { component: component } = settings;
        let { options: options } = component.context;
        let dragging = this.dragging = new $2cb28a74447ccf07$var$FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $2cb28a74447ccf07$var$HitDragging(this.dragging, (0, $9tuWU.bE)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.dragging.destroy();
    }
}
function $2cb28a74447ccf07$var$getComponentTouchDelay$1(component) {
    let { options: options } = component.context;
    let delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $2cb28a74447ccf07$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $9tuWU.at));
    let props = {};
    for (let transformer of dateSelectionTransformers){
        let res = transformer(hit0, hit1);
        if (res === false) return null;
        if (res) Object.assign(props, res);
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
class $2cb28a74447ccf07$var$EventDragging extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        // internal state
        this.subjectEl = null;
        this.subjectSeg = null; // the seg being selected/dragged
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null; // the events being dragged
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let origTarget = ev.origEvent.target;
            let { component: component, dragging: dragging } = this;
            let { mirror: mirror } = dragging;
            let { options: options } = component.context;
            let initialContext = component.context;
            this.subjectEl = ev.subjectEl;
            let subjectSeg = this.subjectSeg = (0, $9tuWU.Y)(ev.subjectEl);
            let eventRange = this.eventRange = subjectSeg.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            this.relevantEvents = (0, $9tuWU.aT)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $2cb28a74447ccf07$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $9tuWU.Z)(origTarget, '.fc');
            mirror.revertDuration = options.dragRevertDuration;
            let isValid = component.isValidSegDownEl(origTarget) && !(0, $9tuWU.Z)(origTarget, '.fc-event-resizer'); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            this.isDragging = isValid && ev.subjectEl.classList.contains('fc-event-draggable');
        };
        this.handleDragStart = (ev)=>{
            let initialContext = this.component.context;
            let eventRange = this.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== this.component.props.eventSelection) initialContext.dispatch({
                    type: 'SELECT_EVENT',
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: 'UNSELECT_EVENT'
            });
            if (this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger('eventDragStart', {
                    el: this.subjectEl,
                    event: new (0, $9tuWU._)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            if (!this.isDragging) return;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let initialContext = this.component.context;
            // states based on new hit
            let receivingContext = null;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $9tuWU.H)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                let receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $2cb28a74447ccf07$var$computeEventMutation(initialHit, hit, this.eventRange.instance.range.start, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $9tuWU.bV)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $9tuWU.bX)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $9tuWU.H)();
                        }
                    }
                } else receivingContext = null;
            }
            this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $9tuWU.au)();
            else (0, $9tuWU.av)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $2cb28a74447ccf07$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                this.dragging.setMirrorIsVisible(!hit || !this.subjectEl.getRootNode().querySelector('.fc-event-mirror'));
                // assign states based on new hit
                this.receivingContext = receivingContext;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handlePointerUp = ()=>{
            if (!this.isDragging) this.cleanup(); // because handleDragEnd won't fire
        };
        this.handleDragEnd = (ev)=>{
            if (this.isDragging) {
                let initialContext = this.component.context;
                let initialView = initialContext.viewApi;
                let { receivingContext: receivingContext, validMutation: validMutation } = this;
                let eventDef = this.eventRange.def;
                let eventInstance = this.eventRange.instance;
                let eventApi = new (0, $9tuWU._)(initialContext, eventDef, eventInstance);
                let relevantEvents = this.relevantEvents;
                let mutatedRelevantEvents = this.mutatedRelevantEvents;
                let { finalHit: finalHit } = this.hitDragging;
                this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger('eventDragStop', {
                    el: this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        let updatedEventApi = new (0, $9tuWU._)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $9tuWU.w)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        let transformed = {};
                        for (let transformer of initialContext.getCurrentData().pluginHooks.eventDropTransformers)Object.assign(transformed, transformer(validMutation, initialContext));
                        initialContext.emitter.trigger('eventDrop', Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger('eventChange', eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        let eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $9tuWU.w)(relevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger('eventLeave', Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger('eventRemove', eventRemoveArg);
                        let addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        let addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        let addedEventApi = new (0, $9tuWU._)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $9tuWU.w)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert () {
                                receivingContext.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger('eventAdd', eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $2cb28a74447ccf07$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger('eventReceive', Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger('_noEventDrop');
            }
            this.cleanup();
        };
        let { component: component } = this;
        let { options: options } = component.context;
        let dragging = this.dragging = new $2cb28a74447ccf07$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = $2cb28a74447ccf07$var$EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $2cb28a74447ccf07$var$HitDragging(this.dragging, (0, $9tuWU.a5));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    // render a drag state on the next receivingCalendar
    displayDrag(nextContext, state) {
        let initialContext = this.component.context;
        let prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) prevContext.dispatch({
                type: 'SET_EVENT_DRAG',
                state: {
                    affectedEvents: state.affectedEvents,
                    mutatedEvents: (0, $9tuWU.H)(),
                    isEvent: true
                }
            });
            else prevContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
        }
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state: state
        });
    }
    clearDrag() {
        let initialCalendar = this.component.context;
        let { receivingContext: receivingContext } = this;
        if (receivingContext) receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) initialCalendar.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    cleanup() {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    }
}
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
$2cb28a74447ccf07$var$EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
function $2cb28a74447ccf07$var$computeEventMutation(hit0, hit1, eventInstanceStart, massagers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let date0 = dateSpan0.range.start;
    let date1 = dateSpan1.range.start;
    let standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $9tuWU.q)(eventInstanceStart);
        else // Moving from allDate->timed
        // Doesn't matter where on the event the drag began, mutate the event's start-date to date1
        date0 = eventInstanceStart;
    }
    let delta = (0, $9tuWU.ay)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    let mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    for (let massager of massagers)massager(mutation, hit0, hit1);
    return mutation;
}
function $2cb28a74447ccf07$var$getComponentTouchDelay(component) {
    let { options: options } = component.context;
    let delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
class $2cb28a74447ccf07$var$EventResizing extends (0, $9tuWU.X) {
    constructor(settings){
        super(settings);
        // internal state
        this.draggingSegEl = null;
        this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        this.eventRange = null;
        this.relevantEvents = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let { component: component } = this;
            let segEl = this.querySegEl(ev);
            let seg = (0, $9tuWU.Y)(segEl);
            let eventRange = this.eventRange = seg.eventRange;
            this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        this.handleDragStart = (ev)=>{
            let { context: context } = this.component;
            let eventRange = this.eventRange;
            this.relevantEvents = (0, $9tuWU.aT)(context.getCurrentData().eventStore, this.eventRange.instance.instanceId);
            let segEl = this.querySegEl(ev);
            this.draggingSegEl = segEl;
            this.draggingSeg = (0, $9tuWU.Y)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger('eventResizeStart', {
                el: segEl,
                event: new (0, $9tuWU._)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { context: context } = this.component;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let eventInstance = this.eventRange.instance;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $9tuWU.H)(),
                isEvent: true
            };
            if (hit) {
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $2cb28a74447ccf07$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $9tuWU.bV)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $9tuWU.bX)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: 'SET_EVENT_RESIZE',
                state: interaction
            });
            else context.dispatch({
                type: 'UNSET_EVENT_RESIZE'
            });
            if (!isInvalid) (0, $9tuWU.au)();
            else (0, $9tuWU.av)();
            if (!isFinal) {
                if (mutation && $2cb28a74447ccf07$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handleDragEnd = (ev)=>{
            let { context: context } = this.component;
            let eventDef = this.eventRange.def;
            let eventInstance = this.eventRange.instance;
            let eventApi = new (0, $9tuWU._)(context, eventDef, eventInstance);
            let relevantEvents = this.relevantEvents;
            let mutatedRelevantEvents = this.mutatedRelevantEvents;
            context.emitter.trigger('eventResizeStop', {
                el: this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (this.validMutation) {
                let updatedEventApi = new (0, $9tuWU._)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: mutatedRelevantEvents
                });
                let eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $9tuWU.w)(mutatedRelevantEvents, context, eventInstance),
                    revert () {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger('eventResize', Object.assign(Object.assign({}, eventChangeArg), {
                    el: this.draggingSegEl,
                    startDelta: this.validMutation.startDelta || (0, $9tuWU.d)(0),
                    endDelta: this.validMutation.endDelta || (0, $9tuWU.d)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger('eventChange', eventChangeArg);
            } else context.emitter.trigger('_noEventResize');
            // reset all internal state
            this.draggingSeg = null;
            this.relevantEvents = null;
            this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        let { component: component } = settings;
        let dragging = this.dragging = new $2cb28a74447ccf07$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = '.fc-event-resizer';
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        let hitDragging = this.hitDragging = new $2cb28a74447ccf07$var$HitDragging(this.dragging, (0, $9tuWU.bE)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    querySegEl(ev) {
        return (0, $9tuWU.Z)(ev.subjectEl, '.fc-event');
    }
}
function $2cb28a74447ccf07$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    let dateEnv = hit0.context.dateEnv;
    let date0 = hit0.dateSpan.range.start;
    let date1 = hit1.dateSpan.range.start;
    let delta = (0, $9tuWU.ay)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
class $2cb28a74447ccf07$var$UnselectAuto {
    constructor(context){
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = (selectInfo)=>{
            if (selectInfo.jsEvent) this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = (pev)=>{
            let unselectCancel = this.context.options.unselectCancel;
            let downEl = (0, $9tuWU.aP)(pev.origEvent);
            this.matchesCancel = !!(0, $9tuWU.Z)(downEl, unselectCancel);
            this.matchesEvent = !!(0, $9tuWU.Z)(downEl, $2cb28a74447ccf07$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = (pev)=>{
            let { context: context } = this;
            let { documentPointer: documentPointer } = this;
            let calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    let unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !this.matchesCancel)) context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !this.matchesEvent // interaction DIDN'T start on an event
                ) context.dispatch({
                    type: 'UNSELECT_EVENT'
                });
            }
            this.isRecentPointerDateSelect = false;
        };
        let documentPointer = this.documentPointer = new $2cb28a74447ccf07$var$PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
        documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on('select', this.onSelect);
    }
    destroy() {
        this.context.emitter.off('select', this.onSelect);
        this.documentPointer.destroy();
    }
}
const $2cb28a74447ccf07$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $9tuWU.n)
};
const $2cb28a74447ccf07$var$LISTENER_REFINERS = {
    dateClick: (0, $9tuWU.n),
    eventDragStart: (0, $9tuWU.n),
    eventDragStop: (0, $9tuWU.n),
    eventDrop: (0, $9tuWU.n),
    eventResizeStart: (0, $9tuWU.n),
    eventResizeStop: (0, $9tuWU.n),
    eventResize: (0, $9tuWU.n),
    drop: (0, $9tuWU.n),
    eventReceive: (0, $9tuWU.n),
    eventLeave: (0, $9tuWU.n)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ class $2cb28a74447ccf07$var$ExternalElementDragging {
    constructor(dragging, suppliedDragMeta){
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = (ev)=>{
            this.dragMeta = this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { dragging: dragging } = this.hitDragging;
            let receivingContext = null;
            let droppableEvent = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: (0, $9tuWU.H)(),
                mutatedEvents: (0, $9tuWU.H)(),
                isEvent: this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $2cb28a74447ccf07$var$computeEventForDateSpan(hit.dateSpan, this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $9tuWU.aU)(droppableEvent);
                    isInvalid = !(0, $9tuWU.bX)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $9tuWU.H)();
                        droppableEvent = null;
                    }
                }
            }
            this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
            if (!isInvalid) (0, $9tuWU.au)();
            else (0, $9tuWU.av)();
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                this.receivingContext = receivingContext;
                this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = (pev)=>{
            let { receivingContext: receivingContext, droppableEvent: droppableEvent } = this;
            this.clearDrag();
            if (receivingContext && droppableEvent) {
                let finalHit = this.hitDragging.finalHit;
                let finalView = finalHit.context.viewApi;
                let dragMeta = this.dragMeta;
                receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, $2cb28a74447ccf07$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    let addingEvents = (0, $9tuWU.aU)(droppableEvent);
                    receivingContext.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: 'SELECT_EVENT',
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger('eventReceive', {
                        event: new (0, $9tuWU._)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert () {
                            receivingContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            this.receivingContext = null;
            this.droppableEvent = null;
        };
        let hitDragging = this.hitDragging = new $2cb28a74447ccf07$var$HitDragging(dragging, (0, $9tuWU.a5));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    buildDragMeta(subjectEl) {
        if (typeof this.suppliedDragMeta === 'object') return (0, $9tuWU.bH)(this.suppliedDragMeta);
        if (typeof this.suppliedDragMeta === 'function') return (0, $9tuWU.bH)(this.suppliedDragMeta(subjectEl));
        return $2cb28a74447ccf07$var$getDragMetaFromEl(subjectEl);
    }
    displayDrag(nextContext, state) {
        let prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) prevContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state: state
        });
    }
    clearDrag() {
        if (this.receivingContext) this.receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    canDropElOnCalendar(el, receivingContext) {
        let dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === 'function') return dropAccept.call(receivingContext.calendarApi, el);
        if (typeof dropAccept === 'string' && dropAccept) return Boolean((0, $9tuWU.aO)(el, dropAccept));
        return true;
    }
}
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $2cb28a74447ccf07$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    let defProps = Object.assign({}, dragMeta.leftoverProps);
    for (let transform of context.pluginHooks.externalDefTransforms)Object.assign(defProps, transform(dateSpan, dragMeta));
    let { refined: refined, extra: extra } = (0, $9tuWU.aj)(defProps, context);
    let def = (0, $9tuWU.ai)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    let start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    let end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $9tuWU.cs)(dateSpan.allDay, start, context);
    let instance = (0, $9tuWU.ah)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $2cb28a74447ccf07$var$getDragMetaFromEl(el) {
    let str = $2cb28a74447ccf07$var$getEmbeddedElData(el, 'event');
    let obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $9tuWU.bH)(obj);
}
(0, $9tuWU.bG).dataAttrPrefix = '';
function $2cb28a74447ccf07$var$getEmbeddedElData(el, name) {
    let prefix = (0, $9tuWU.bG).dataAttrPrefix;
    let prefixedName = (prefix ? prefix + '-' : '') + name;
    return el.getAttribute('data-' + prefixedName) || '';
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ class $2cb28a74447ccf07$export$f2a139e5d18b9882 {
    constructor(el, settings = {}){
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            let { minDistance: minDistance, longPressDelay: longPressDelay } = this.settings;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $9tuWU.e).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $9tuWU.e).longPressDelay : 0;
        };
        this.handleDragStart = (ev)=>{
            if (ev.isTouch && this.dragging.delay && ev.subjectEl.classList.contains('fc-event')) this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
        };
        this.settings = settings;
        let dragging = this.dragging = new $2cb28a74447ccf07$var$FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        new $2cb28a74447ccf07$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ class $2cb28a74447ccf07$var$InferredElementDragging extends (0, $9tuWU.bF) {
    constructor(containerEl){
        super(containerEl);
        this.shouldIgnoreMove = false;
        this.mirrorSelector = '';
        this.currentMirrorEl = null;
        this.handlePointerDown = (ev)=>{
            this.emitter.trigger('pointerdown', ev);
            if (!this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            this.emitter.trigger('dragstart', ev);
        };
        this.handlePointerMove = (ev)=>{
            if (!this.shouldIgnoreMove) this.emitter.trigger('dragmove', ev);
        };
        this.handlePointerUp = (ev)=>{
            this.emitter.trigger('pointerup', ev);
            if (!this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            this.emitter.trigger('dragend', ev);
        };
        let pointer = this.pointer = new $2cb28a74447ccf07$var$PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.handlePointerDown);
        pointer.emitter.on('pointermove', this.handlePointerMove);
        pointer.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.pointer.destroy();
    }
    setIgnoreMove(bool) {
        this.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        if (bool) // restore a previously hidden element.
        // use the reference in case the selector class has already been removed.
        {
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = '';
                this.currentMirrorEl = null;
            }
        } else {
            let mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = 'hidden';
            }
        }
    }
}
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ class $2cb28a74447ccf07$export$51e5e9a9728fcd8f {
    constructor(containerOrSettings, settings){
        let containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        let dragging = this.dragging = new $2cb28a74447ccf07$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === 'string') dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = '[data-event]';
        if (typeof settings.mirrorSelector === 'string') dragging.mirrorSelector = settings.mirrorSelector;
        let externalDragging = new $2cb28a74447ccf07$var$ExternalElementDragging(dragging, settings.eventData);
        // The hit-detection system requires that the dnd-mirror-element be pointer-events:none,
        // but this can't be guaranteed for third-party draggables, so disable
        externalDragging.hitDragging.disablePointCheck = true;
    }
    destroy() {
        this.dragging.destroy();
    }
}
var $2cb28a74447ccf07$export$2e2bcd8739ae039 = (0, $jgkCe.createPlugin)({
    name: '@fullcalendar/interaction',
    componentInteractions: [
        $2cb28a74447ccf07$var$DateClicking,
        $2cb28a74447ccf07$var$DateSelecting,
        $2cb28a74447ccf07$var$EventDragging,
        $2cb28a74447ccf07$var$EventResizing
    ],
    calendarInteractions: [
        $2cb28a74447ccf07$var$UnselectAuto
    ],
    elementDraggingImpl: $2cb28a74447ccf07$var$FeaturefulElementDragging,
    optionRefiners: $2cb28a74447ccf07$var$OPTION_REFINERS,
    listenerRefiners: $2cb28a74447ccf07$var$LISTENER_REFINERS
});

});

parcelRegister("ipTba", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb2e3ff4a5da37d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $32kQ2 = parcelRequire("32kQ2");
const $0fb2e3ff4a5da37d$var$IconCalendarCircle = (props)=>{
    const defaultClasses = [
        "border",
        "rounded-full",
        "w-2",
        "h-2",
        "mx-1"
    ];
    const assignColors = ()=>{
        switch(props.colorKey){
            case (0, $32kQ2.MeetingStatuses).Scheduled:
                return [
                    "bg-ch-blue-500",
                    "border-ch-blue-500"
                ];
            case (0, $32kQ2.MeetingStatuses).InProgress:
                return [
                    "bg-ch-purple-500",
                    "border-ch-purple-500"
                ];
            case (0, $32kQ2.MeetingStatuses).Ended:
                return [
                    "bg-ch-gray-500",
                    "border-ch-gray-500"
                ];
            default:
                return [];
        }
    };
    const colorClasses = assignColors();
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses,
        ...colorClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "inline-block self-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: allClasses
        })
    });
};
var $0fb2e3ff4a5da37d$export$2e2bcd8739ae039 = $0fb2e3ff4a5da37d$var$IconCalendarCircle;

});

parcelRegister("iVT8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8851251b4817c5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $5sKyw = parcelRequire("5sKyw");
function $dc8851251b4817c5$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc8851251b4817c5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dc8851251b4817c5$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            $dc8851251b4817c5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dc8851251b4817c5$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc8851251b4817c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc8851251b4817c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dc8851251b4817c5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc8851251b4817c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc8851251b4817c5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $dc8851251b4817c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc8851251b4817c5$var$_extends() {
    $dc8851251b4817c5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc8851251b4817c5$var$_extends.apply(this, arguments);
}
function $dc8851251b4817c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $dc8851251b4817c5$var$_setPrototypeOf(subClass, superClass);
}
function $dc8851251b4817c5$var$_getPrototypeOf(o) {
    $dc8851251b4817c5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc8851251b4817c5$var$_getPrototypeOf(o);
}
function $dc8851251b4817c5$var$_setPrototypeOf(o, p) {
    $dc8851251b4817c5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc8851251b4817c5$var$_setPrototypeOf(o, p);
}
function $dc8851251b4817c5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dc8851251b4817c5$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $dc8851251b4817c5$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $dc8851251b4817c5$var$_assertThisInitialized(self1);
}
function $dc8851251b4817c5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dc8851251b4817c5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $dc8851251b4817c5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dc8851251b4817c5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dc8851251b4817c5$var$_possibleConstructorReturn(this, result);
    };
}
function $dc8851251b4817c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc8851251b4817c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc8851251b4817c5$var$_arrayLikeToArray(o, minLen);
}
function $dc8851251b4817c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc8851251b4817c5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $dc8851251b4817c5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $dc8851251b4817c5$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $dc8851251b4817c5$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $dc8851251b4817c5$var$global$a = // eslint-disable-next-line es/no-global-this -- safe
$dc8851251b4817c5$var$check(typeof globalThis == 'object' && globalThis) || $dc8851251b4817c5$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$dc8851251b4817c5$var$check(typeof self == 'object' && self) || $dc8851251b4817c5$var$check(typeof $dc8851251b4817c5$var$commonjsGlobal == 'object' && $dc8851251b4817c5$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();
var $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor = {};
var $dc8851251b4817c5$var$fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $dc8851251b4817c5$var$fails$8 = $dc8851251b4817c5$var$fails$9;
// Detect IE8's incomplete defineProperty implementation
var $dc8851251b4817c5$var$descriptors = !$dc8851251b4817c5$var$fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $dc8851251b4817c5$var$fails$7 = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$functionBindNative = !$dc8851251b4817c5$var$fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var $dc8851251b4817c5$var$NATIVE_BIND$2 = $dc8851251b4817c5$var$functionBindNative;
var $dc8851251b4817c5$var$call$4 = Function.prototype.call;
var $dc8851251b4817c5$var$functionCall = $dc8851251b4817c5$var$NATIVE_BIND$2 ? $dc8851251b4817c5$var$call$4.bind($dc8851251b4817c5$var$call$4) : function() {
    return $dc8851251b4817c5$var$call$4.apply($dc8851251b4817c5$var$call$4, arguments);
};
var $dc8851251b4817c5$var$objectPropertyIsEnumerable = {};
var $dc8851251b4817c5$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $dc8851251b4817c5$var$NASHORN_BUG = $dc8851251b4817c5$var$getOwnPropertyDescriptor$1 && !$dc8851251b4817c5$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$dc8851251b4817c5$var$objectPropertyIsEnumerable.f = $dc8851251b4817c5$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $dc8851251b4817c5$var$$propertyIsEnumerable;
var $dc8851251b4817c5$var$createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $dc8851251b4817c5$var$NATIVE_BIND$1 = $dc8851251b4817c5$var$functionBindNative;
var $dc8851251b4817c5$var$FunctionPrototype$1 = Function.prototype;
var $dc8851251b4817c5$var$call$3 = $dc8851251b4817c5$var$FunctionPrototype$1.call;
var $dc8851251b4817c5$var$uncurryThisWithBind = $dc8851251b4817c5$var$NATIVE_BIND$1 && $dc8851251b4817c5$var$FunctionPrototype$1.bind.bind($dc8851251b4817c5$var$call$3, $dc8851251b4817c5$var$call$3);
var $dc8851251b4817c5$var$functionUncurryThisRaw = function(fn) {
    return $dc8851251b4817c5$var$NATIVE_BIND$1 ? $dc8851251b4817c5$var$uncurryThisWithBind(fn) : function() {
        return $dc8851251b4817c5$var$call$3.apply(fn, arguments);
    };
};
var $dc8851251b4817c5$var$uncurryThisRaw$1 = $dc8851251b4817c5$var$functionUncurryThisRaw;
var $dc8851251b4817c5$var$toString$1 = $dc8851251b4817c5$var$uncurryThisRaw$1({}.toString);
var $dc8851251b4817c5$var$stringSlice = $dc8851251b4817c5$var$uncurryThisRaw$1(''.slice);
var $dc8851251b4817c5$var$classofRaw$2 = function(it) {
    return $dc8851251b4817c5$var$stringSlice($dc8851251b4817c5$var$toString$1(it), 8, -1);
};
var $dc8851251b4817c5$var$classofRaw$1 = $dc8851251b4817c5$var$classofRaw$2;
var $dc8851251b4817c5$var$uncurryThisRaw = $dc8851251b4817c5$var$functionUncurryThisRaw;
var $dc8851251b4817c5$var$functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($dc8851251b4817c5$var$classofRaw$1(fn) === 'Function') return $dc8851251b4817c5$var$uncurryThisRaw(fn);
};
var $dc8851251b4817c5$var$uncurryThis$9 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$fails$6 = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$classof$3 = $dc8851251b4817c5$var$classofRaw$2;
var $dc8851251b4817c5$var$$Object$3 = Object;
var $dc8851251b4817c5$var$split = $dc8851251b4817c5$var$uncurryThis$9(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $dc8851251b4817c5$var$indexedObject = $dc8851251b4817c5$var$fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$dc8851251b4817c5$var$$Object$3('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $dc8851251b4817c5$var$classof$3(it) == 'String' ? $dc8851251b4817c5$var$split(it, '') : $dc8851251b4817c5$var$$Object$3(it);
} : $dc8851251b4817c5$var$$Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $dc8851251b4817c5$var$isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var $dc8851251b4817c5$var$isNullOrUndefined$1 = $dc8851251b4817c5$var$isNullOrUndefined$2;
var $dc8851251b4817c5$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $dc8851251b4817c5$var$requireObjectCoercible$2 = function(it) {
    if ($dc8851251b4817c5$var$isNullOrUndefined$1(it)) throw $dc8851251b4817c5$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $dc8851251b4817c5$var$IndexedObject$1 = $dc8851251b4817c5$var$indexedObject;
var $dc8851251b4817c5$var$requireObjectCoercible$1 = $dc8851251b4817c5$var$requireObjectCoercible$2;
var $dc8851251b4817c5$var$toIndexedObject$4 = function(it) {
    return $dc8851251b4817c5$var$IndexedObject$1($dc8851251b4817c5$var$requireObjectCoercible$1(it));
};
var $dc8851251b4817c5$var$documentAll$2 = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $dc8851251b4817c5$var$IS_HTMLDDA = typeof $dc8851251b4817c5$var$documentAll$2 == 'undefined' && $dc8851251b4817c5$var$documentAll$2 !== undefined;
var $dc8851251b4817c5$var$documentAll_1 = {
    all: $dc8851251b4817c5$var$documentAll$2,
    IS_HTMLDDA: $dc8851251b4817c5$var$IS_HTMLDDA
};
var $dc8851251b4817c5$var$$documentAll$1 = $dc8851251b4817c5$var$documentAll_1;
var $dc8851251b4817c5$var$documentAll$1 = $dc8851251b4817c5$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $dc8851251b4817c5$var$isCallable$c = $dc8851251b4817c5$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $dc8851251b4817c5$var$documentAll$1;
} : function(argument) {
    return typeof argument == 'function';
};
var $dc8851251b4817c5$var$isCallable$b = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$$documentAll = $dc8851251b4817c5$var$documentAll_1;
var $dc8851251b4817c5$var$documentAll = $dc8851251b4817c5$var$$documentAll.all;
var $dc8851251b4817c5$var$isObject$6 = $dc8851251b4817c5$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : $dc8851251b4817c5$var$isCallable$b(it) || it === $dc8851251b4817c5$var$documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : $dc8851251b4817c5$var$isCallable$b(it);
};
var $dc8851251b4817c5$var$global$9 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$isCallable$a = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$aFunction = function(argument) {
    return $dc8851251b4817c5$var$isCallable$a(argument) ? argument : undefined;
};
var $dc8851251b4817c5$var$getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? $dc8851251b4817c5$var$aFunction($dc8851251b4817c5$var$global$9[namespace]) : $dc8851251b4817c5$var$global$9[namespace] && $dc8851251b4817c5$var$global$9[namespace][method];
};
var $dc8851251b4817c5$var$uncurryThis$8 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$objectIsPrototypeOf = $dc8851251b4817c5$var$uncurryThis$8({}.isPrototypeOf);
var $dc8851251b4817c5$var$getBuiltIn$4 = $dc8851251b4817c5$var$getBuiltIn$5;
var $dc8851251b4817c5$var$engineUserAgent = $dc8851251b4817c5$var$getBuiltIn$4('navigator', 'userAgent') || '';
var $dc8851251b4817c5$var$global$8 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$userAgent = $dc8851251b4817c5$var$engineUserAgent;
var $dc8851251b4817c5$var$process = $dc8851251b4817c5$var$global$8.process;
var $dc8851251b4817c5$var$Deno = $dc8851251b4817c5$var$global$8.Deno;
var $dc8851251b4817c5$var$versions = $dc8851251b4817c5$var$process && $dc8851251b4817c5$var$process.versions || $dc8851251b4817c5$var$Deno && $dc8851251b4817c5$var$Deno.version;
var $dc8851251b4817c5$var$v8 = $dc8851251b4817c5$var$versions && $dc8851251b4817c5$var$versions.v8;
var $dc8851251b4817c5$var$match, $dc8851251b4817c5$var$version;
if ($dc8851251b4817c5$var$v8) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $dc8851251b4817c5$var$version = $dc8851251b4817c5$var$match[0] > 0 && $dc8851251b4817c5$var$match[0] < 4 ? 1 : +($dc8851251b4817c5$var$match[0] + $dc8851251b4817c5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$dc8851251b4817c5$var$version && $dc8851251b4817c5$var$userAgent) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$userAgent.match(/Edge\/(\d+)/);
    if (!$dc8851251b4817c5$var$match || $dc8851251b4817c5$var$match[1] >= 74) {
        $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$userAgent.match(/Chrome\/(\d+)/);
        if ($dc8851251b4817c5$var$match) $dc8851251b4817c5$var$version = +$dc8851251b4817c5$var$match[1];
    }
}
var $dc8851251b4817c5$var$engineV8Version = $dc8851251b4817c5$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $dc8851251b4817c5$var$V8_VERSION = $dc8851251b4817c5$var$engineV8Version;
var $dc8851251b4817c5$var$fails$5 = $dc8851251b4817c5$var$fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $dc8851251b4817c5$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$dc8851251b4817c5$var$fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $dc8851251b4817c5$var$V8_VERSION && $dc8851251b4817c5$var$V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $dc8851251b4817c5$var$NATIVE_SYMBOL$1 = $dc8851251b4817c5$var$symbolConstructorDetection;
var $dc8851251b4817c5$var$useSymbolAsUid = $dc8851251b4817c5$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $dc8851251b4817c5$var$getBuiltIn$3 = $dc8851251b4817c5$var$getBuiltIn$5;
var $dc8851251b4817c5$var$isCallable$9 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$isPrototypeOf = $dc8851251b4817c5$var$objectIsPrototypeOf;
var $dc8851251b4817c5$var$USE_SYMBOL_AS_UID$1 = $dc8851251b4817c5$var$useSymbolAsUid;
var $dc8851251b4817c5$var$$Object$2 = Object;
var $dc8851251b4817c5$var$isSymbol$2 = $dc8851251b4817c5$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $dc8851251b4817c5$var$getBuiltIn$3('Symbol');
    return $dc8851251b4817c5$var$isCallable$9($Symbol) && $dc8851251b4817c5$var$isPrototypeOf($Symbol.prototype, $dc8851251b4817c5$var$$Object$2(it));
};
var $dc8851251b4817c5$var$$String$1 = String;
var $dc8851251b4817c5$var$tryToString$1 = function(argument) {
    try {
        return $dc8851251b4817c5$var$$String$1(argument);
    } catch (error) {
        return 'Object';
    }
};
var $dc8851251b4817c5$var$isCallable$8 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$tryToString = $dc8851251b4817c5$var$tryToString$1;
var $dc8851251b4817c5$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $dc8851251b4817c5$var$aCallable$2 = function(argument) {
    if ($dc8851251b4817c5$var$isCallable$8(argument)) return argument;
    throw $dc8851251b4817c5$var$$TypeError$4($dc8851251b4817c5$var$tryToString(argument) + ' is not a function');
};
var $dc8851251b4817c5$var$aCallable$1 = $dc8851251b4817c5$var$aCallable$2;
var $dc8851251b4817c5$var$isNullOrUndefined = $dc8851251b4817c5$var$isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $dc8851251b4817c5$var$getMethod$1 = function(V, P) {
    var func = V[P];
    return $dc8851251b4817c5$var$isNullOrUndefined(func) ? undefined : $dc8851251b4817c5$var$aCallable$1(func);
};
var $dc8851251b4817c5$var$call$2 = $dc8851251b4817c5$var$functionCall;
var $dc8851251b4817c5$var$isCallable$7 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$isObject$5 = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $dc8851251b4817c5$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $dc8851251b4817c5$var$isCallable$7(fn = input.toString) && !$dc8851251b4817c5$var$isObject$5(val = $dc8851251b4817c5$var$call$2(fn, input))) return val;
    if ($dc8851251b4817c5$var$isCallable$7(fn = input.valueOf) && !$dc8851251b4817c5$var$isObject$5(val = $dc8851251b4817c5$var$call$2(fn, input))) return val;
    if (pref !== 'string' && $dc8851251b4817c5$var$isCallable$7(fn = input.toString) && !$dc8851251b4817c5$var$isObject$5(val = $dc8851251b4817c5$var$call$2(fn, input))) return val;
    throw $dc8851251b4817c5$var$$TypeError$3("Can't convert object to primitive value");
};
var $dc8851251b4817c5$var$shared$3 = {
    exports: {}
};
var $dc8851251b4817c5$var$global$7 = $dc8851251b4817c5$var$global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $dc8851251b4817c5$var$defineProperty$2 = Object.defineProperty;
var $dc8851251b4817c5$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $dc8851251b4817c5$var$defineProperty$2($dc8851251b4817c5$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $dc8851251b4817c5$var$global$7[key] = value;
    }
    return value;
};
var $dc8851251b4817c5$var$global$6 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$defineGlobalProperty$2 = $dc8851251b4817c5$var$defineGlobalProperty$3;
var $dc8851251b4817c5$var$SHARED = '__core-js_shared__';
var $dc8851251b4817c5$var$store$3 = $dc8851251b4817c5$var$global$6[$dc8851251b4817c5$var$SHARED] || $dc8851251b4817c5$var$defineGlobalProperty$2($dc8851251b4817c5$var$SHARED, {});
var $dc8851251b4817c5$var$sharedStore = $dc8851251b4817c5$var$store$3;
var $dc8851251b4817c5$var$store$2 = $dc8851251b4817c5$var$sharedStore;
($dc8851251b4817c5$var$shared$3.exports = function(key, value) {
    return $dc8851251b4817c5$var$store$2[key] || ($dc8851251b4817c5$var$store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.25.5',
    mode: 'global',
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});
var $dc8851251b4817c5$var$requireObjectCoercible = $dc8851251b4817c5$var$requireObjectCoercible$2;
var $dc8851251b4817c5$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $dc8851251b4817c5$var$toObject$2 = function(argument) {
    return $dc8851251b4817c5$var$$Object$1($dc8851251b4817c5$var$requireObjectCoercible(argument));
};
var $dc8851251b4817c5$var$uncurryThis$7 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$toObject$1 = $dc8851251b4817c5$var$toObject$2;
var $dc8851251b4817c5$var$hasOwnProperty = $dc8851251b4817c5$var$uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $dc8851251b4817c5$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $dc8851251b4817c5$var$hasOwnProperty($dc8851251b4817c5$var$toObject$1(it), key);
};
var $dc8851251b4817c5$var$uncurryThis$6 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$id = 0;
var $dc8851251b4817c5$var$postfix = Math.random();
var $dc8851251b4817c5$var$toString = $dc8851251b4817c5$var$uncurryThis$6(1.0.toString);
var $dc8851251b4817c5$var$uid$2 = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $dc8851251b4817c5$var$toString(++$dc8851251b4817c5$var$id + $dc8851251b4817c5$var$postfix, 36);
};
var $dc8851251b4817c5$var$global$5 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$shared$2 = $dc8851251b4817c5$var$shared$3.exports;
var $dc8851251b4817c5$var$hasOwn$6 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$uid$1 = $dc8851251b4817c5$var$uid$2;
var $dc8851251b4817c5$var$NATIVE_SYMBOL = $dc8851251b4817c5$var$symbolConstructorDetection;
var $dc8851251b4817c5$var$USE_SYMBOL_AS_UID = $dc8851251b4817c5$var$useSymbolAsUid;
var $dc8851251b4817c5$var$WellKnownSymbolsStore = $dc8851251b4817c5$var$shared$2('wks');
var $dc8851251b4817c5$var$Symbol$1 = $dc8851251b4817c5$var$global$5.Symbol;
var $dc8851251b4817c5$var$symbolFor = $dc8851251b4817c5$var$Symbol$1 && $dc8851251b4817c5$var$Symbol$1['for'];
var $dc8851251b4817c5$var$createWellKnownSymbol = $dc8851251b4817c5$var$USE_SYMBOL_AS_UID ? $dc8851251b4817c5$var$Symbol$1 : $dc8851251b4817c5$var$Symbol$1 && $dc8851251b4817c5$var$Symbol$1.withoutSetter || $dc8851251b4817c5$var$uid$1;
var $dc8851251b4817c5$var$wellKnownSymbol$5 = function(name) {
    if (!$dc8851251b4817c5$var$hasOwn$6($dc8851251b4817c5$var$WellKnownSymbolsStore, name) || !($dc8851251b4817c5$var$NATIVE_SYMBOL || typeof $dc8851251b4817c5$var$WellKnownSymbolsStore[name] == 'string')) {
        var description = 'Symbol.' + name;
        if ($dc8851251b4817c5$var$NATIVE_SYMBOL && $dc8851251b4817c5$var$hasOwn$6($dc8851251b4817c5$var$Symbol$1, name)) $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$Symbol$1[name];
        else if ($dc8851251b4817c5$var$USE_SYMBOL_AS_UID && $dc8851251b4817c5$var$symbolFor) $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$symbolFor(description);
        else $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$createWellKnownSymbol(description);
    }
    return $dc8851251b4817c5$var$WellKnownSymbolsStore[name];
};
var $dc8851251b4817c5$var$call$1 = $dc8851251b4817c5$var$functionCall;
var $dc8851251b4817c5$var$isObject$4 = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$isSymbol$1 = $dc8851251b4817c5$var$isSymbol$2;
var $dc8851251b4817c5$var$getMethod = $dc8851251b4817c5$var$getMethod$1;
var $dc8851251b4817c5$var$ordinaryToPrimitive = $dc8851251b4817c5$var$ordinaryToPrimitive$1;
var $dc8851251b4817c5$var$wellKnownSymbol$4 = $dc8851251b4817c5$var$wellKnownSymbol$5;
var $dc8851251b4817c5$var$$TypeError$2 = TypeError;
var $dc8851251b4817c5$var$TO_PRIMITIVE = $dc8851251b4817c5$var$wellKnownSymbol$4('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $dc8851251b4817c5$var$toPrimitive$1 = function(input, pref) {
    if (!$dc8851251b4817c5$var$isObject$4(input) || $dc8851251b4817c5$var$isSymbol$1(input)) return input;
    var exoticToPrim = $dc8851251b4817c5$var$getMethod(input, $dc8851251b4817c5$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $dc8851251b4817c5$var$call$1(exoticToPrim, input, pref);
        if (!$dc8851251b4817c5$var$isObject$4(result) || $dc8851251b4817c5$var$isSymbol$1(result)) return result;
        throw $dc8851251b4817c5$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $dc8851251b4817c5$var$ordinaryToPrimitive(input, pref);
};
var $dc8851251b4817c5$var$toPrimitive = $dc8851251b4817c5$var$toPrimitive$1;
var $dc8851251b4817c5$var$isSymbol = $dc8851251b4817c5$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $dc8851251b4817c5$var$toPropertyKey$2 = function(argument) {
    var key = $dc8851251b4817c5$var$toPrimitive(argument, 'string');
    return $dc8851251b4817c5$var$isSymbol(key) ? key : key + '';
};
var $dc8851251b4817c5$var$global$4 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$isObject$3 = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$document$1 = $dc8851251b4817c5$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $dc8851251b4817c5$var$EXISTS$1 = $dc8851251b4817c5$var$isObject$3($dc8851251b4817c5$var$document$1) && $dc8851251b4817c5$var$isObject$3($dc8851251b4817c5$var$document$1.createElement);
var $dc8851251b4817c5$var$documentCreateElement$1 = function(it) {
    return $dc8851251b4817c5$var$EXISTS$1 ? $dc8851251b4817c5$var$document$1.createElement(it) : {};
};
var $dc8851251b4817c5$var$DESCRIPTORS$7 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$fails$4 = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$createElement = $dc8851251b4817c5$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $dc8851251b4817c5$var$ie8DomDefine = !$dc8851251b4817c5$var$DESCRIPTORS$7 && !$dc8851251b4817c5$var$fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($dc8851251b4817c5$var$createElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $dc8851251b4817c5$var$DESCRIPTORS$6 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$call = $dc8851251b4817c5$var$functionCall;
var $dc8851251b4817c5$var$propertyIsEnumerableModule = $dc8851251b4817c5$var$objectPropertyIsEnumerable;
var $dc8851251b4817c5$var$createPropertyDescriptor$1 = $dc8851251b4817c5$var$createPropertyDescriptor$2;
var $dc8851251b4817c5$var$toIndexedObject$3 = $dc8851251b4817c5$var$toIndexedObject$4;
var $dc8851251b4817c5$var$toPropertyKey$1 = $dc8851251b4817c5$var$toPropertyKey$2;
var $dc8851251b4817c5$var$hasOwn$5 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$IE8_DOM_DEFINE$1 = $dc8851251b4817c5$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f = $dc8851251b4817c5$var$DESCRIPTORS$6 ? $dc8851251b4817c5$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $dc8851251b4817c5$var$toIndexedObject$3(O);
    P = $dc8851251b4817c5$var$toPropertyKey$1(P);
    if ($dc8851251b4817c5$var$IE8_DOM_DEFINE$1) try {
        return $dc8851251b4817c5$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($dc8851251b4817c5$var$hasOwn$5(O, P)) return $dc8851251b4817c5$var$createPropertyDescriptor$1(!$dc8851251b4817c5$var$call($dc8851251b4817c5$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $dc8851251b4817c5$var$objectDefineProperty = {};
var $dc8851251b4817c5$var$DESCRIPTORS$5 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$fails$3 = $dc8851251b4817c5$var$fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $dc8851251b4817c5$var$v8PrototypeDefineBug = $dc8851251b4817c5$var$DESCRIPTORS$5 && $dc8851251b4817c5$var$fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $dc8851251b4817c5$var$isObject$2 = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$$String = String;
var $dc8851251b4817c5$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $dc8851251b4817c5$var$anObject$4 = function(argument) {
    if ($dc8851251b4817c5$var$isObject$2(argument)) return argument;
    throw $dc8851251b4817c5$var$$TypeError$1($dc8851251b4817c5$var$$String(argument) + ' is not an object');
};
var $dc8851251b4817c5$var$DESCRIPTORS$4 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$IE8_DOM_DEFINE = $dc8851251b4817c5$var$ie8DomDefine;
var $dc8851251b4817c5$var$V8_PROTOTYPE_DEFINE_BUG$1 = $dc8851251b4817c5$var$v8PrototypeDefineBug;
var $dc8851251b4817c5$var$anObject$3 = $dc8851251b4817c5$var$anObject$4;
var $dc8851251b4817c5$var$toPropertyKey = $dc8851251b4817c5$var$toPropertyKey$2;
var $dc8851251b4817c5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $dc8851251b4817c5$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $dc8851251b4817c5$var$ENUMERABLE = 'enumerable';
var $dc8851251b4817c5$var$CONFIGURABLE$1 = 'configurable';
var $dc8851251b4817c5$var$WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$dc8851251b4817c5$var$objectDefineProperty.f = $dc8851251b4817c5$var$DESCRIPTORS$4 ? $dc8851251b4817c5$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $dc8851251b4817c5$var$anObject$3(O);
    P = $dc8851251b4817c5$var$toPropertyKey(P);
    $dc8851251b4817c5$var$anObject$3(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $dc8851251b4817c5$var$WRITABLE in Attributes && !Attributes[$dc8851251b4817c5$var$WRITABLE]) {
        var current = $dc8851251b4817c5$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$dc8851251b4817c5$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $dc8851251b4817c5$var$CONFIGURABLE$1 in Attributes ? Attributes[$dc8851251b4817c5$var$CONFIGURABLE$1] : current[$dc8851251b4817c5$var$CONFIGURABLE$1],
                enumerable: $dc8851251b4817c5$var$ENUMERABLE in Attributes ? Attributes[$dc8851251b4817c5$var$ENUMERABLE] : current[$dc8851251b4817c5$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $dc8851251b4817c5$var$$defineProperty(O, P, Attributes);
} : $dc8851251b4817c5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $dc8851251b4817c5$var$anObject$3(O);
    P = $dc8851251b4817c5$var$toPropertyKey(P);
    $dc8851251b4817c5$var$anObject$3(Attributes);
    if ($dc8851251b4817c5$var$IE8_DOM_DEFINE) try {
        return $dc8851251b4817c5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw $dc8851251b4817c5$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $dc8851251b4817c5$var$DESCRIPTORS$3 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$definePropertyModule$3 = $dc8851251b4817c5$var$objectDefineProperty;
var $dc8851251b4817c5$var$createPropertyDescriptor = $dc8851251b4817c5$var$createPropertyDescriptor$2;
var $dc8851251b4817c5$var$createNonEnumerableProperty$2 = $dc8851251b4817c5$var$DESCRIPTORS$3 ? function(object, key, value) {
    return $dc8851251b4817c5$var$definePropertyModule$3.f(object, key, $dc8851251b4817c5$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $dc8851251b4817c5$var$makeBuiltIn$2 = {
    exports: {}
};
var $dc8851251b4817c5$var$DESCRIPTORS$2 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$hasOwn$4 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$getDescriptor = $dc8851251b4817c5$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $dc8851251b4817c5$var$EXISTS = $dc8851251b4817c5$var$hasOwn$4($dc8851251b4817c5$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $dc8851251b4817c5$var$PROPER = $dc8851251b4817c5$var$EXISTS && (function something() {}).name === 'something';
var $dc8851251b4817c5$var$CONFIGURABLE = $dc8851251b4817c5$var$EXISTS && (!$dc8851251b4817c5$var$DESCRIPTORS$2 || $dc8851251b4817c5$var$DESCRIPTORS$2 && $dc8851251b4817c5$var$getDescriptor($dc8851251b4817c5$var$FunctionPrototype, 'name').configurable);
var $dc8851251b4817c5$var$functionName = {
    EXISTS: $dc8851251b4817c5$var$EXISTS,
    PROPER: $dc8851251b4817c5$var$PROPER,
    CONFIGURABLE: $dc8851251b4817c5$var$CONFIGURABLE
};
var $dc8851251b4817c5$var$uncurryThis$5 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$isCallable$6 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$store$1 = $dc8851251b4817c5$var$sharedStore;
var $dc8851251b4817c5$var$functionToString = $dc8851251b4817c5$var$uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$dc8851251b4817c5$var$isCallable$6($dc8851251b4817c5$var$store$1.inspectSource)) $dc8851251b4817c5$var$store$1.inspectSource = function(it) {
    return $dc8851251b4817c5$var$functionToString(it);
};
var $dc8851251b4817c5$var$inspectSource$2 = $dc8851251b4817c5$var$store$1.inspectSource;
var $dc8851251b4817c5$var$global$3 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$isCallable$5 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$WeakMap$1 = $dc8851251b4817c5$var$global$3.WeakMap;
var $dc8851251b4817c5$var$weakMapBasicDetection = $dc8851251b4817c5$var$isCallable$5($dc8851251b4817c5$var$WeakMap$1) && /native code/.test(String($dc8851251b4817c5$var$WeakMap$1));
var $dc8851251b4817c5$var$shared$1 = $dc8851251b4817c5$var$shared$3.exports;
var $dc8851251b4817c5$var$uid = $dc8851251b4817c5$var$uid$2;
var $dc8851251b4817c5$var$keys = $dc8851251b4817c5$var$shared$1('keys');
var $dc8851251b4817c5$var$sharedKey$2 = function(key) {
    return $dc8851251b4817c5$var$keys[key] || ($dc8851251b4817c5$var$keys[key] = $dc8851251b4817c5$var$uid(key));
};
var $dc8851251b4817c5$var$hiddenKeys$4 = {};
var $dc8851251b4817c5$var$NATIVE_WEAK_MAP = $dc8851251b4817c5$var$weakMapBasicDetection;
var $dc8851251b4817c5$var$global$2 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$isObject$1 = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$createNonEnumerableProperty$1 = $dc8851251b4817c5$var$createNonEnumerableProperty$2;
var $dc8851251b4817c5$var$hasOwn$3 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$shared = $dc8851251b4817c5$var$sharedStore;
var $dc8851251b4817c5$var$sharedKey$1 = $dc8851251b4817c5$var$sharedKey$2;
var $dc8851251b4817c5$var$hiddenKeys$3 = $dc8851251b4817c5$var$hiddenKeys$4;
var $dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $dc8851251b4817c5$var$TypeError$1 = $dc8851251b4817c5$var$global$2.TypeError;
var $dc8851251b4817c5$var$WeakMap = $dc8851251b4817c5$var$global$2.WeakMap;
var $dc8851251b4817c5$var$set, $dc8851251b4817c5$var$get, $dc8851251b4817c5$var$has;
var $dc8851251b4817c5$var$enforce = function(it) {
    return $dc8851251b4817c5$var$has(it) ? $dc8851251b4817c5$var$get(it) : $dc8851251b4817c5$var$set(it, {});
};
var $dc8851251b4817c5$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$dc8851251b4817c5$var$isObject$1(it) || (state = $dc8851251b4817c5$var$get(it)).type !== TYPE) throw $dc8851251b4817c5$var$TypeError$1('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($dc8851251b4817c5$var$NATIVE_WEAK_MAP || $dc8851251b4817c5$var$shared.state) {
    var $dc8851251b4817c5$var$store = $dc8851251b4817c5$var$shared.state || ($dc8851251b4817c5$var$shared.state = new $dc8851251b4817c5$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $dc8851251b4817c5$var$store.get = $dc8851251b4817c5$var$store.get;
    $dc8851251b4817c5$var$store.has = $dc8851251b4817c5$var$store.has;
    $dc8851251b4817c5$var$store.set = $dc8851251b4817c5$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$store.has(it)) throw $dc8851251b4817c5$var$TypeError$1($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$store.set(it, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$store.get(it) || {};
    };
    $dc8851251b4817c5$var$has = function(it) {
        return $dc8851251b4817c5$var$store.has(it);
    };
} else {
    var $dc8851251b4817c5$var$STATE = $dc8851251b4817c5$var$sharedKey$1('state');
    $dc8851251b4817c5$var$hiddenKeys$3[$dc8851251b4817c5$var$STATE] = true;
    $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$hasOwn$3(it, $dc8851251b4817c5$var$STATE)) throw $dc8851251b4817c5$var$TypeError$1($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$createNonEnumerableProperty$1(it, $dc8851251b4817c5$var$STATE, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$hasOwn$3(it, $dc8851251b4817c5$var$STATE) ? it[$dc8851251b4817c5$var$STATE] : {};
    };
    $dc8851251b4817c5$var$has = function(it) {
        return $dc8851251b4817c5$var$hasOwn$3(it, $dc8851251b4817c5$var$STATE);
    };
}
var $dc8851251b4817c5$var$internalState = {
    set: $dc8851251b4817c5$var$set,
    get: $dc8851251b4817c5$var$get,
    has: $dc8851251b4817c5$var$has,
    enforce: $dc8851251b4817c5$var$enforce,
    getterFor: $dc8851251b4817c5$var$getterFor
};
var $dc8851251b4817c5$var$fails$2 = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$isCallable$4 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$hasOwn$2 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$DESCRIPTORS$1 = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$CONFIGURABLE_FUNCTION_NAME = $dc8851251b4817c5$var$functionName.CONFIGURABLE;
var $dc8851251b4817c5$var$inspectSource$1 = $dc8851251b4817c5$var$inspectSource$2;
var $dc8851251b4817c5$var$InternalStateModule = $dc8851251b4817c5$var$internalState;
var $dc8851251b4817c5$var$enforceInternalState = $dc8851251b4817c5$var$InternalStateModule.enforce;
var $dc8851251b4817c5$var$getInternalState = $dc8851251b4817c5$var$InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $dc8851251b4817c5$var$defineProperty$1 = Object.defineProperty;
var $dc8851251b4817c5$var$CONFIGURABLE_LENGTH = $dc8851251b4817c5$var$DESCRIPTORS$1 && !$dc8851251b4817c5$var$fails$2(function() {
    return $dc8851251b4817c5$var$defineProperty$1(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $dc8851251b4817c5$var$TEMPLATE = String(String).split('String');
var $dc8851251b4817c5$var$makeBuiltIn$1 = $dc8851251b4817c5$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$dc8851251b4817c5$var$hasOwn$2(value, 'name') || $dc8851251b4817c5$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($dc8851251b4817c5$var$DESCRIPTORS$1) $dc8851251b4817c5$var$defineProperty$1(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($dc8851251b4817c5$var$CONFIGURABLE_LENGTH && options && $dc8851251b4817c5$var$hasOwn$2(options, 'arity') && value.length !== options.arity) $dc8851251b4817c5$var$defineProperty$1(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $dc8851251b4817c5$var$hasOwn$2(options, 'constructor') && options.constructor) {
            if ($dc8851251b4817c5$var$DESCRIPTORS$1) $dc8851251b4817c5$var$defineProperty$1(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $dc8851251b4817c5$var$enforceInternalState(value);
    if (!$dc8851251b4817c5$var$hasOwn$2(state, 'source')) state.source = $dc8851251b4817c5$var$TEMPLATE.join(typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $dc8851251b4817c5$var$makeBuiltIn$1(function toString() {
    return $dc8851251b4817c5$var$isCallable$4(this) && $dc8851251b4817c5$var$getInternalState(this).source || $dc8851251b4817c5$var$inspectSource$1(this);
}, 'toString');
var $dc8851251b4817c5$var$isCallable$3 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$definePropertyModule$2 = $dc8851251b4817c5$var$objectDefineProperty;
var $dc8851251b4817c5$var$makeBuiltIn = $dc8851251b4817c5$var$makeBuiltIn$2.exports;
var $dc8851251b4817c5$var$defineGlobalProperty$1 = $dc8851251b4817c5$var$defineGlobalProperty$3;
var $dc8851251b4817c5$var$defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($dc8851251b4817c5$var$isCallable$3(value)) $dc8851251b4817c5$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $dc8851251b4817c5$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $dc8851251b4817c5$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $dc8851251b4817c5$var$objectGetOwnPropertyNames = {};
var $dc8851251b4817c5$var$ceil = Math.ceil;
var $dc8851251b4817c5$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $dc8851251b4817c5$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $dc8851251b4817c5$var$floor : $dc8851251b4817c5$var$ceil)(n);
};
var $dc8851251b4817c5$var$trunc = $dc8851251b4817c5$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $dc8851251b4817c5$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $dc8851251b4817c5$var$trunc(number);
};
var $dc8851251b4817c5$var$toIntegerOrInfinity$1 = $dc8851251b4817c5$var$toIntegerOrInfinity$2;
var $dc8851251b4817c5$var$max = Math.max;
var $dc8851251b4817c5$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $dc8851251b4817c5$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $dc8851251b4817c5$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $dc8851251b4817c5$var$max(integer + length, 0) : $dc8851251b4817c5$var$min$1(integer, length);
};
var $dc8851251b4817c5$var$toIntegerOrInfinity = $dc8851251b4817c5$var$toIntegerOrInfinity$2;
var $dc8851251b4817c5$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $dc8851251b4817c5$var$toLength$1 = function(argument) {
    return argument > 0 ? $dc8851251b4817c5$var$min($dc8851251b4817c5$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $dc8851251b4817c5$var$toLength = $dc8851251b4817c5$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $dc8851251b4817c5$var$lengthOfArrayLike$2 = function(obj) {
    return $dc8851251b4817c5$var$toLength(obj.length);
};
var $dc8851251b4817c5$var$toIndexedObject$2 = $dc8851251b4817c5$var$toIndexedObject$4;
var $dc8851251b4817c5$var$toAbsoluteIndex = $dc8851251b4817c5$var$toAbsoluteIndex$1;
var $dc8851251b4817c5$var$lengthOfArrayLike$1 = $dc8851251b4817c5$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $dc8851251b4817c5$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $dc8851251b4817c5$var$toIndexedObject$2($this);
        var length = $dc8851251b4817c5$var$lengthOfArrayLike$1(O);
        var index = $dc8851251b4817c5$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $dc8851251b4817c5$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $dc8851251b4817c5$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $dc8851251b4817c5$var$createMethod$1(false)
};
var $dc8851251b4817c5$var$uncurryThis$4 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$hasOwn$1 = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$toIndexedObject$1 = $dc8851251b4817c5$var$toIndexedObject$4;
var $dc8851251b4817c5$var$indexOf = $dc8851251b4817c5$var$arrayIncludes.indexOf;
var $dc8851251b4817c5$var$hiddenKeys$2 = $dc8851251b4817c5$var$hiddenKeys$4;
var $dc8851251b4817c5$var$push$1 = $dc8851251b4817c5$var$uncurryThis$4([].push);
var $dc8851251b4817c5$var$objectKeysInternal = function(object, names) {
    var O = $dc8851251b4817c5$var$toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$dc8851251b4817c5$var$hasOwn$1($dc8851251b4817c5$var$hiddenKeys$2, key) && $dc8851251b4817c5$var$hasOwn$1(O, key) && $dc8851251b4817c5$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dc8851251b4817c5$var$hasOwn$1(O, key = names[i++])) ~$dc8851251b4817c5$var$indexOf(result, key) || $dc8851251b4817c5$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $dc8851251b4817c5$var$enumBugKeys$3 = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $dc8851251b4817c5$var$internalObjectKeys$1 = $dc8851251b4817c5$var$objectKeysInternal;
var $dc8851251b4817c5$var$enumBugKeys$2 = $dc8851251b4817c5$var$enumBugKeys$3;
var $dc8851251b4817c5$var$hiddenKeys$1 = $dc8851251b4817c5$var$enumBugKeys$2.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$dc8851251b4817c5$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dc8851251b4817c5$var$internalObjectKeys$1(O, $dc8851251b4817c5$var$hiddenKeys$1);
};
var $dc8851251b4817c5$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$dc8851251b4817c5$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $dc8851251b4817c5$var$getBuiltIn$2 = $dc8851251b4817c5$var$getBuiltIn$5;
var $dc8851251b4817c5$var$uncurryThis$3 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$getOwnPropertyNamesModule = $dc8851251b4817c5$var$objectGetOwnPropertyNames;
var $dc8851251b4817c5$var$getOwnPropertySymbolsModule = $dc8851251b4817c5$var$objectGetOwnPropertySymbols;
var $dc8851251b4817c5$var$anObject$2 = $dc8851251b4817c5$var$anObject$4;
var $dc8851251b4817c5$var$concat = $dc8851251b4817c5$var$uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var $dc8851251b4817c5$var$ownKeys$1 = $dc8851251b4817c5$var$getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $dc8851251b4817c5$var$getOwnPropertyNamesModule.f($dc8851251b4817c5$var$anObject$2(it));
    var getOwnPropertySymbols = $dc8851251b4817c5$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $dc8851251b4817c5$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $dc8851251b4817c5$var$hasOwn = $dc8851251b4817c5$var$hasOwnProperty_1;
var $dc8851251b4817c5$var$ownKeys = $dc8851251b4817c5$var$ownKeys$1;
var $dc8851251b4817c5$var$getOwnPropertyDescriptorModule = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor;
var $dc8851251b4817c5$var$definePropertyModule$1 = $dc8851251b4817c5$var$objectDefineProperty;
var $dc8851251b4817c5$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $dc8851251b4817c5$var$ownKeys(source);
    var defineProperty = $dc8851251b4817c5$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$dc8851251b4817c5$var$hasOwn(target, key) && !(exceptions && $dc8851251b4817c5$var$hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $dc8851251b4817c5$var$fails$1 = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$isCallable$2 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$replacement = /#|\.prototype\./;
var $dc8851251b4817c5$var$isForced$1 = function(feature, detection) {
    var value = $dc8851251b4817c5$var$data[$dc8851251b4817c5$var$normalize(feature)];
    return value == $dc8851251b4817c5$var$POLYFILL ? true : value == $dc8851251b4817c5$var$NATIVE ? false : $dc8851251b4817c5$var$isCallable$2(detection) ? $dc8851251b4817c5$var$fails$1(detection) : !!detection;
};
var $dc8851251b4817c5$var$normalize = $dc8851251b4817c5$var$isForced$1.normalize = function(string) {
    return String(string).replace($dc8851251b4817c5$var$replacement, '.').toLowerCase();
};
var $dc8851251b4817c5$var$data = $dc8851251b4817c5$var$isForced$1.data = {};
var $dc8851251b4817c5$var$NATIVE = $dc8851251b4817c5$var$isForced$1.NATIVE = 'N';
var $dc8851251b4817c5$var$POLYFILL = $dc8851251b4817c5$var$isForced$1.POLYFILL = 'P';
var $dc8851251b4817c5$var$isForced_1 = $dc8851251b4817c5$var$isForced$1;
var $dc8851251b4817c5$var$global$1 = $dc8851251b4817c5$var$global$a;
var $dc8851251b4817c5$var$getOwnPropertyDescriptor = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f;
var $dc8851251b4817c5$var$createNonEnumerableProperty = $dc8851251b4817c5$var$createNonEnumerableProperty$2;
var $dc8851251b4817c5$var$defineBuiltIn = $dc8851251b4817c5$var$defineBuiltIn$1;
var $dc8851251b4817c5$var$defineGlobalProperty = $dc8851251b4817c5$var$defineGlobalProperty$3;
var $dc8851251b4817c5$var$copyConstructorProperties = $dc8851251b4817c5$var$copyConstructorProperties$1;
var $dc8851251b4817c5$var$isForced = $dc8851251b4817c5$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $dc8851251b4817c5$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $dc8851251b4817c5$var$global$1;
    else if (STATIC) target = $dc8851251b4817c5$var$global$1[TARGET] || $dc8851251b4817c5$var$defineGlobalProperty(TARGET, {});
    else target = ($dc8851251b4817c5$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $dc8851251b4817c5$var$isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $dc8851251b4817c5$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $dc8851251b4817c5$var$createNonEnumerableProperty(sourceProperty, 'sham', true);
        $dc8851251b4817c5$var$defineBuiltIn(target, key, sourceProperty, options);
    }
};
var $dc8851251b4817c5$var$uncurryThis$2 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$aCallable = $dc8851251b4817c5$var$aCallable$2;
var $dc8851251b4817c5$var$NATIVE_BIND = $dc8851251b4817c5$var$functionBindNative;
var $dc8851251b4817c5$var$bind$1 = $dc8851251b4817c5$var$uncurryThis$2($dc8851251b4817c5$var$uncurryThis$2.bind);
// optional / simple context binding
var $dc8851251b4817c5$var$functionBindContext = function(fn, that) {
    $dc8851251b4817c5$var$aCallable(fn);
    return that === undefined ? fn : $dc8851251b4817c5$var$NATIVE_BIND ? $dc8851251b4817c5$var$bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $dc8851251b4817c5$var$classof$2 = $dc8851251b4817c5$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $dc8851251b4817c5$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $dc8851251b4817c5$var$classof$2(argument) == 'Array';
};
var $dc8851251b4817c5$var$wellKnownSymbol$3 = $dc8851251b4817c5$var$wellKnownSymbol$5;
var $dc8851251b4817c5$var$TO_STRING_TAG$1 = $dc8851251b4817c5$var$wellKnownSymbol$3('toStringTag');
var $dc8851251b4817c5$var$test = {};
$dc8851251b4817c5$var$test[$dc8851251b4817c5$var$TO_STRING_TAG$1] = 'z';
var $dc8851251b4817c5$var$toStringTagSupport = String($dc8851251b4817c5$var$test) === '[object z]';
var $dc8851251b4817c5$var$TO_STRING_TAG_SUPPORT = $dc8851251b4817c5$var$toStringTagSupport;
var $dc8851251b4817c5$var$isCallable$1 = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$classofRaw = $dc8851251b4817c5$var$classofRaw$2;
var $dc8851251b4817c5$var$wellKnownSymbol$2 = $dc8851251b4817c5$var$wellKnownSymbol$5;
var $dc8851251b4817c5$var$TO_STRING_TAG = $dc8851251b4817c5$var$wellKnownSymbol$2('toStringTag');
var $dc8851251b4817c5$var$$Object = Object;
// ES3 wrong here
var $dc8851251b4817c5$var$CORRECT_ARGUMENTS = $dc8851251b4817c5$var$classofRaw(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $dc8851251b4817c5$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $dc8851251b4817c5$var$classof$1 = $dc8851251b4817c5$var$TO_STRING_TAG_SUPPORT ? $dc8851251b4817c5$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $dc8851251b4817c5$var$tryGet(O = $dc8851251b4817c5$var$$Object(it), $dc8851251b4817c5$var$TO_STRING_TAG)) == 'string' ? tag : $dc8851251b4817c5$var$CORRECT_ARGUMENTS ? $dc8851251b4817c5$var$classofRaw(O) : (result = $dc8851251b4817c5$var$classofRaw(O)) == 'Object' && $dc8851251b4817c5$var$isCallable$1(O.callee) ? 'Arguments' : result;
};
var $dc8851251b4817c5$var$uncurryThis$1 = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$fails = $dc8851251b4817c5$var$fails$9;
var $dc8851251b4817c5$var$isCallable = $dc8851251b4817c5$var$isCallable$c;
var $dc8851251b4817c5$var$classof = $dc8851251b4817c5$var$classof$1;
var $dc8851251b4817c5$var$getBuiltIn$1 = $dc8851251b4817c5$var$getBuiltIn$5;
var $dc8851251b4817c5$var$inspectSource = $dc8851251b4817c5$var$inspectSource$2;
var $dc8851251b4817c5$var$noop = function() {};
var $dc8851251b4817c5$var$empty = [];
var $dc8851251b4817c5$var$construct = $dc8851251b4817c5$var$getBuiltIn$1('Reflect', 'construct');
var $dc8851251b4817c5$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $dc8851251b4817c5$var$exec = $dc8851251b4817c5$var$uncurryThis$1($dc8851251b4817c5$var$constructorRegExp.exec);
var $dc8851251b4817c5$var$INCORRECT_TO_STRING = !$dc8851251b4817c5$var$constructorRegExp.exec($dc8851251b4817c5$var$noop);
var $dc8851251b4817c5$var$isConstructorModern = function isConstructor(argument) {
    if (!$dc8851251b4817c5$var$isCallable(argument)) return false;
    try {
        $dc8851251b4817c5$var$construct($dc8851251b4817c5$var$noop, $dc8851251b4817c5$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $dc8851251b4817c5$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$dc8851251b4817c5$var$isCallable(argument)) return false;
    switch($dc8851251b4817c5$var$classof(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $dc8851251b4817c5$var$INCORRECT_TO_STRING || !!$dc8851251b4817c5$var$exec($dc8851251b4817c5$var$constructorRegExp, $dc8851251b4817c5$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$dc8851251b4817c5$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $dc8851251b4817c5$var$isConstructor$1 = !$dc8851251b4817c5$var$construct || $dc8851251b4817c5$var$fails(function() {
    var called;
    return $dc8851251b4817c5$var$isConstructorModern($dc8851251b4817c5$var$isConstructorModern.call) || !$dc8851251b4817c5$var$isConstructorModern(Object) || !$dc8851251b4817c5$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $dc8851251b4817c5$var$isConstructorLegacy : $dc8851251b4817c5$var$isConstructorModern;
var $dc8851251b4817c5$var$isArray = $dc8851251b4817c5$var$isArray$1;
var $dc8851251b4817c5$var$isConstructor = $dc8851251b4817c5$var$isConstructor$1;
var $dc8851251b4817c5$var$isObject = $dc8851251b4817c5$var$isObject$6;
var $dc8851251b4817c5$var$wellKnownSymbol$1 = $dc8851251b4817c5$var$wellKnownSymbol$5;
var $dc8851251b4817c5$var$SPECIES = $dc8851251b4817c5$var$wellKnownSymbol$1('species');
var $dc8851251b4817c5$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $dc8851251b4817c5$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($dc8851251b4817c5$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($dc8851251b4817c5$var$isConstructor(C) && (C === $dc8851251b4817c5$var$$Array || $dc8851251b4817c5$var$isArray(C.prototype))) C = undefined;
        else if ($dc8851251b4817c5$var$isObject(C)) {
            C = C[$dc8851251b4817c5$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $dc8851251b4817c5$var$$Array : C;
};
var $dc8851251b4817c5$var$arraySpeciesConstructor = $dc8851251b4817c5$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $dc8851251b4817c5$var$arraySpeciesCreate$1 = function(originalArray, length) {
    return new ($dc8851251b4817c5$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $dc8851251b4817c5$var$bind = $dc8851251b4817c5$var$functionBindContext;
var $dc8851251b4817c5$var$uncurryThis = $dc8851251b4817c5$var$functionUncurryThis;
var $dc8851251b4817c5$var$IndexedObject = $dc8851251b4817c5$var$indexedObject;
var $dc8851251b4817c5$var$toObject = $dc8851251b4817c5$var$toObject$2;
var $dc8851251b4817c5$var$lengthOfArrayLike = $dc8851251b4817c5$var$lengthOfArrayLike$2;
var $dc8851251b4817c5$var$arraySpeciesCreate = $dc8851251b4817c5$var$arraySpeciesCreate$1;
var $dc8851251b4817c5$var$push = $dc8851251b4817c5$var$uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $dc8851251b4817c5$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $dc8851251b4817c5$var$toObject($this);
        var self1 = $dc8851251b4817c5$var$IndexedObject(O);
        var boundFunction = $dc8851251b4817c5$var$bind(callbackfn, that);
        var length = $dc8851251b4817c5$var$lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || $dc8851251b4817c5$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $dc8851251b4817c5$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $dc8851251b4817c5$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $dc8851251b4817c5$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $dc8851251b4817c5$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $dc8851251b4817c5$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $dc8851251b4817c5$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $dc8851251b4817c5$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $dc8851251b4817c5$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $dc8851251b4817c5$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $dc8851251b4817c5$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $dc8851251b4817c5$var$createMethod(7)
};
var $dc8851251b4817c5$var$objectDefineProperties = {};
var $dc8851251b4817c5$var$internalObjectKeys = $dc8851251b4817c5$var$objectKeysInternal;
var $dc8851251b4817c5$var$enumBugKeys$1 = $dc8851251b4817c5$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $dc8851251b4817c5$var$objectKeys$1 = Object.keys || function keys(O) {
    return $dc8851251b4817c5$var$internalObjectKeys(O, $dc8851251b4817c5$var$enumBugKeys$1);
};
var $dc8851251b4817c5$var$DESCRIPTORS = $dc8851251b4817c5$var$descriptors;
var $dc8851251b4817c5$var$V8_PROTOTYPE_DEFINE_BUG = $dc8851251b4817c5$var$v8PrototypeDefineBug;
var $dc8851251b4817c5$var$definePropertyModule = $dc8851251b4817c5$var$objectDefineProperty;
var $dc8851251b4817c5$var$anObject$1 = $dc8851251b4817c5$var$anObject$4;
var $dc8851251b4817c5$var$toIndexedObject = $dc8851251b4817c5$var$toIndexedObject$4;
var $dc8851251b4817c5$var$objectKeys = $dc8851251b4817c5$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$dc8851251b4817c5$var$objectDefineProperties.f = $dc8851251b4817c5$var$DESCRIPTORS && !$dc8851251b4817c5$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $dc8851251b4817c5$var$anObject$1(O);
    var props = $dc8851251b4817c5$var$toIndexedObject(Properties);
    var keys = $dc8851251b4817c5$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$dc8851251b4817c5$var$definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var $dc8851251b4817c5$var$getBuiltIn = $dc8851251b4817c5$var$getBuiltIn$5;
var $dc8851251b4817c5$var$html$1 = $dc8851251b4817c5$var$getBuiltIn('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */ var $dc8851251b4817c5$var$anObject = $dc8851251b4817c5$var$anObject$4;
var $dc8851251b4817c5$var$definePropertiesModule = $dc8851251b4817c5$var$objectDefineProperties;
var $dc8851251b4817c5$var$enumBugKeys = $dc8851251b4817c5$var$enumBugKeys$3;
var $dc8851251b4817c5$var$hiddenKeys = $dc8851251b4817c5$var$hiddenKeys$4;
var $dc8851251b4817c5$var$html = $dc8851251b4817c5$var$html$1;
var $dc8851251b4817c5$var$documentCreateElement = $dc8851251b4817c5$var$documentCreateElement$1;
var $dc8851251b4817c5$var$sharedKey = $dc8851251b4817c5$var$sharedKey$2;
var $dc8851251b4817c5$var$GT = '>';
var $dc8851251b4817c5$var$LT = '<';
var $dc8851251b4817c5$var$PROTOTYPE = 'prototype';
var $dc8851251b4817c5$var$SCRIPT = 'script';
var $dc8851251b4817c5$var$IE_PROTO = $dc8851251b4817c5$var$sharedKey('IE_PROTO');
var $dc8851251b4817c5$var$EmptyConstructor = function() {};
var $dc8851251b4817c5$var$scriptTag = function(content) {
    return $dc8851251b4817c5$var$LT + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT + content + $dc8851251b4817c5$var$LT + '/' + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($dc8851251b4817c5$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $dc8851251b4817c5$var$documentCreateElement('iframe');
    var JS = 'java' + $dc8851251b4817c5$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $dc8851251b4817c5$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($dc8851251b4817c5$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $dc8851251b4817c5$var$activeXDocument;
var $dc8851251b4817c5$var$NullProtoObject = function() {
    try {
        $dc8851251b4817c5$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $dc8851251b4817c5$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $dc8851251b4817c5$var$activeXDocument ? $dc8851251b4817c5$var$NullProtoObjectViaActiveX($dc8851251b4817c5$var$activeXDocument) // old IE
     : $dc8851251b4817c5$var$NullProtoObjectViaIFrame() : $dc8851251b4817c5$var$NullProtoObjectViaActiveX($dc8851251b4817c5$var$activeXDocument); // WSH
    var length = $dc8851251b4817c5$var$enumBugKeys.length;
    while(length--)delete $dc8851251b4817c5$var$NullProtoObject[$dc8851251b4817c5$var$PROTOTYPE][$dc8851251b4817c5$var$enumBugKeys[length]];
    return $dc8851251b4817c5$var$NullProtoObject();
};
$dc8851251b4817c5$var$hiddenKeys[$dc8851251b4817c5$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $dc8851251b4817c5$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = $dc8851251b4817c5$var$anObject(O);
        result = new $dc8851251b4817c5$var$EmptyConstructor();
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$dc8851251b4817c5$var$IE_PROTO] = O;
    } else result = $dc8851251b4817c5$var$NullProtoObject();
    return Properties === undefined ? result : $dc8851251b4817c5$var$definePropertiesModule.f(result, Properties);
};
var $dc8851251b4817c5$var$wellKnownSymbol = $dc8851251b4817c5$var$wellKnownSymbol$5;
var $dc8851251b4817c5$var$create = $dc8851251b4817c5$var$objectCreate;
var $dc8851251b4817c5$var$defineProperty = $dc8851251b4817c5$var$objectDefineProperty.f;
var $dc8851251b4817c5$var$UNSCOPABLES = $dc8851251b4817c5$var$wellKnownSymbol('unscopables');
var $dc8851251b4817c5$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES] == undefined) $dc8851251b4817c5$var$defineProperty($dc8851251b4817c5$var$ArrayPrototype, $dc8851251b4817c5$var$UNSCOPABLES, {
    configurable: true,
    value: $dc8851251b4817c5$var$create(null)
});
// add a key to Array.prototype[@@unscopables]
var $dc8851251b4817c5$var$addToUnscopables$1 = function(key) {
    $dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES][key] = true;
};
var $dc8851251b4817c5$var$$ = $dc8851251b4817c5$var$_export;
var $dc8851251b4817c5$var$$find = $dc8851251b4817c5$var$arrayIteration.find;
var $dc8851251b4817c5$var$addToUnscopables = $dc8851251b4817c5$var$addToUnscopables$1;
var $dc8851251b4817c5$var$FIND = 'find';
var $dc8851251b4817c5$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($dc8851251b4817c5$var$FIND in []) Array(1)[$dc8851251b4817c5$var$FIND](function() {
    $dc8851251b4817c5$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$dc8851251b4817c5$var$$({
    target: 'Array',
    proto: true,
    forced: $dc8851251b4817c5$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $dc8851251b4817c5$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$dc8851251b4817c5$var$addToUnscopables($dc8851251b4817c5$var$FIND);
var $dc8851251b4817c5$var$CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
/**
 * Static methods for react-tooltip
 */ var $dc8851251b4817c5$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $dc8851251b4817c5$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $dc8851251b4817c5$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $dc8851251b4817c5$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        $dc8851251b4817c5$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $dc8851251b4817c5$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute('currentItem', 'false');
    else targetArray[i].setAttribute('currentItem', 'true');
};
var $dc8851251b4817c5$var$customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $dc8851251b4817c5$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $dc8851251b4817c5$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function(event) {
            ele.removeEventListener(event, $dc8851251b4817c5$var$customListeners.get(ele, event));
            var customListener = $dc8851251b4817c5$var$checkStatus.bind(_this, dataEventOff);
            $dc8851251b4817c5$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(' ').forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, $dc8851251b4817c5$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $dc8851251b4817c5$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $dc8851251b4817c5$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
/**
 * Util method to get effect
 */ var $dc8851251b4817c5$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === 'function') proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $dc8851251b4817c5$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute('data-tip') || null;
        forId = target.getAttribute('data-for') || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = $dc8851251b4817c5$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $dc8851251b4817c5$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $dc8851251b4817c5$var$getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function $dc8851251b4817c5$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $dc8851251b4817c5$var$getBody();
        var customEvents = $dc8851251b4817c5$var$findCustomEvents(targetArray, 'data-event');
        var customEventsOff = $dc8851251b4817c5$var$findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $dc8851251b4817c5$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $dc8851251b4817c5$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $dc8851251b4817c5$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            $dc8851251b4817c5$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $dc8851251b4817c5$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $dc8851251b4817c5$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $dc8851251b4817c5$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $dc8851251b4817c5$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $dc8851251b4817c5$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $dc8851251b4817c5$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $dc8851251b4817c5$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $dc8851251b4817c5$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $dc8851251b4817c5$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $dc8851251b4817c5$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $dc8851251b4817c5$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside('top'),
        bottom: inside('bottom'),
        left: inside('left'),
        right: inside('right')
    };
    function choose() {
        var allPlaces = desiredPlace.split(',').concat(place, [
            'top',
            'bottom',
            'left',
            'right'
        ]);
        var _iterator = $dc8851251b4817c5$var$_createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $dc8851251b4817c5$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var $dc8851251b4817c5$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $dc8851251b4817c5$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $dc8851251b4817c5$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var $dc8851251b4817c5$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === 'top') extraOffsetY -= parseInt(offset[key], 10);
        else if (key === 'bottom') extraOffsetY += parseInt(offset[key], 10);
        else if (key === 'left') extraOffsetX -= parseInt(offset[key], 10);
        else if (key === 'right') extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var $dc8851251b4817c5$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $dc8851251b4817c5$var$TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $dc8851251b4817c5$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $dc8851251b4817c5$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $dc8851251b4817c5$var$generateUUID() {
    return 't' + (0, $5sKyw.default)();
}
var $dc8851251b4817c5$var$baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
/**
 * Default pop-up style values (text color, background color).
 */ var $dc8851251b4817c5$var$defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function $dc8851251b4817c5$var$getDefaultPopupColors(type) {
    return $dc8851251b4817c5$var$defaultColors[type] ? $dc8851251b4817c5$var$_objectSpread2({}, $dc8851251b4817c5$var$defaultColors[type]) : undefined;
}
var $dc8851251b4817c5$var$DEFAULT_PADDING = '8px 21px';
var $dc8851251b4817c5$var$DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function $dc8851251b4817c5$var$generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return $dc8851251b4817c5$var$generateStyle(uuid, $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $dc8851251b4817c5$var$generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc8851251b4817c5$var$DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $dc8851251b4817c5$var$DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n\t    border-radius: ").concat(tooltipRadius, "px;\n\t    padding: ").concat(padding, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .").concat(uuid, ".place-top::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-bottom::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-left::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-right::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $dc8851251b4817c5$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === 'light' ? 'black' : 'white';
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $dc8851251b4817c5$var$_class, $dc8851251b4817c5$var$_class2;
/* Polyfill */ var $dc8851251b4817c5$export$2e2bcd8739ae039 = $dc8851251b4817c5$var$staticMethods($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$windowListener($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$customEvent($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$isCapture($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$getEffect($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$bodyMode($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$trackRemoval($dc8851251b4817c5$var$_class = ($dc8851251b4817c5$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $dc8851251b4817c5$var$_inherits(ReactTooltip, _React$Component);
    var _super = $dc8851251b4817c5$var$_createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        $dc8851251b4817c5$var$_classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || $dc8851251b4817c5$var$generateUUID(),
            place: props.place || 'top',
            // Direction of tooltip
            desiredPlace: props.place || 'top',
            type: props.type || 'dark',
            // Color theme of tooltip
            effect: props.effect || 'float',
            // float or fixed
            show: false,
            border: false,
            borderClass: 'border',
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $dc8851251b4817c5$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $dc8851251b4817c5$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case 'Document':
                    case 'HTMLDocument':
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case 'ShadowRoot':
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector('style[data-react-tooltip]')) {
                    var style = document.createElement('style');
                    style.textContent = $dc8851251b4817c5$var$baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = '[data-tip]:not([data-for])';
                else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
                }
                // Scan document for shadow DOM elements
                $dc8851251b4817c5$var$nodeListToArray(document.getElementsByTagName('*')).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($dc8851251b4817c5$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($dc8851251b4817c5$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute('currentItem') === null) target.setAttribute('currentItem', 'false');
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                    target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
                    if (effect === 'float') target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                    target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $dc8851251b4817c5$var$TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute('aria-describedby', this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = $dc8851251b4817c5$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(',')[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(',')[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self1.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self1.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self1.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self1.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute('data-tooltip-radius') || self1.props.tooltipRadius || '3',
                            arrow: target.getAttribute('data-arrow-radius') || self1.props.arrowRadius || '0'
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute('data-padding') || self1.props.padding,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self1.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self1.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self1.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self1.props.border) || false,
                        borderClass: target.getAttribute('data-border-class') || self1.props.borderClass || 'border',
                        extraClass: target.getAttribute('data-class') || self1.props["class"] || self1.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $dc8851251b4817c5$var$TipContent(originTooltip, '', _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute('aria-describedby');
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $dc8851251b4817c5$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === 'function') callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? '' : $dc8851251b4817c5$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' ' + this.state.borderClass : '') + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? "\n<style aria-hidden=\"true\">".concat(style, "</style>") : '');
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
                    padding: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    borderClass: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    arrowRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    tooltipRadius: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    disableInternalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $dc8851251b4817c5$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $dc8851251b4817c5$var$_objectSpread2($dc8851251b4817c5$var$_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "supportedWrappers", [
    'div',
    'span'
]), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "displayName", 'ReactTooltip'), $dc8851251b4817c5$var$_class2)) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class;

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $7qKRb = parcelRequire("7qKRb");

var $an7iz = parcelRequire("an7iz");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $an7iz.default)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $568f4ee4022ba00e$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("an7iz", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d1b6b90091f3cc$export$2e2bcd8739ae039);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $78d1b6b90091f3cc$var$byteToHex = [];
for(var $78d1b6b90091f3cc$var$i = 0; $78d1b6b90091f3cc$var$i < 256; ++$78d1b6b90091f3cc$var$i)$78d1b6b90091f3cc$var$byteToHex[$78d1b6b90091f3cc$var$i] = ($78d1b6b90091f3cc$var$i + 0x100).toString(16).substr(1);
function $78d1b6b90091f3cc$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $78d1b6b90091f3cc$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
var $78d1b6b90091f3cc$export$2e2bcd8739ae039 = $78d1b6b90091f3cc$var$bytesToUuid;

});




parcelRegister("gGSQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $607d677d49cc354a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $ipTba = parcelRequire("ipTba");

var $dV4Fn = parcelRequire("dV4Fn");

var $32kQ2 = parcelRequire("32kQ2");
const $607d677d49cc354a$var$MeetingCalendarKey = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
        className: "flex flex-wrap lg:flex-col lg:mt-2 lg:ml-2 mb-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                className: "lg:mb-5",
                children: t("meeting:calendarKey")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                className: "flex items-center lg:mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ipTba.default), {
                        className: "mx-2 h-3 w-3",
                        colorKey: (0, $32kQ2.MeetingStatuses).Scheduled
                    }),
                    t("meeting:scheduled")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                className: "flex items-center lg:mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ipTba.default), {
                        className: "mx-2 h-3 w-3",
                        colorKey: (0, $32kQ2.MeetingStatuses).InProgress
                    }),
                    t("meeting:inProgress")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                className: "flex items-center lg:mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ipTba.default), {
                        className: "mx-2 h-3 w-3",
                        colorKey: (0, $32kQ2.MeetingStatuses).Ended
                    }),
                    t("meeting:ended")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                className: "flex items-center lg:mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dV4Fn.default), {
                        className: "mx-2 h-3 w-3",
                        colorKey: (0, $32kQ2.MeetingRoles).Coordinator
                    }),
                    t("meeting:youAreCoordinator")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                className: "flex items-center lg:mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dV4Fn.default), {
                        className: "mx-2 h-3 w-3",
                        colorKey: (0, $32kQ2.MeetingRoles).Invited
                    }),
                    t("meeting:youAreInvited")
                ]
            })
        ]
    });
};
var $607d677d49cc354a$export$2e2bcd8739ae039 = $607d677d49cc354a$var$MeetingCalendarKey;

});
parcelRegister("dV4Fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa853e83f5d656c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $32kQ2 = parcelRequire("32kQ2");
const $aaa853e83f5d656c$var$IconCalendarSquare = (props)=>{
    const defaultClasses = [
        "flex-col",
        "flex-shrink-0",
        "border",
        "rounded-none",
        "w-3",
        "h-3",
        "mx-1"
    ];
    const assignColors = ()=>{
        switch(props.colorKey){
            case (0, $32kQ2.MeetingRoles).Coordinator:
                return [
                    "bg-white",
                    "border-ch-gray-400"
                ];
            case (0, $32kQ2.MeetingRoles).Invited:
                return [
                    "bg-ch-blue-200",
                    "border-ch-blue-200"
                ];
            default:
                return [];
        }
    };
    const colorClasses = assignColors();
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses,
        ...colorClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "self-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: allClasses
        })
    });
};
var $aaa853e83f5d656c$export$2e2bcd8739ae039 = $aaa853e83f5d656c$var$IconCalendarSquare;

});


parcelRegister("iK6Ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a379bc079fca282$export$2e2bcd8739ae039);
// https://usehooks.com/useWindowSize/

var $acw62 = parcelRequire("acw62");
const $2a379bc079fca282$var$useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0, $acw62.useState)({
        width: undefined,
        height: undefined
    });
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
var $2a379bc079fca282$export$2e2bcd8739ae039 = $2a379bc079fca282$var$useWindowSize;

});


parcelRegister("5Q36E", function(module, exports) {

$parcel$export(module.exports, "default", () => $45128b816fe744d7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $jpBS7 = parcelRequire("jpBS7");

var $1l1FS = parcelRequire("1l1FS");

var $dW5lH = parcelRequire("dW5lH");

var $kYqkq = parcelRequire("kYqkq");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $lCZwG = parcelRequire("lCZwG");

var $8vz7t = parcelRequire("8vz7t");

var $jSDfI = parcelRequire("jSDfI");

var $ai857 = parcelRequire("ai857");

var $lnXep = parcelRequire("lnXep");

var $6lvMC = parcelRequire("6lvMC");

var $8e5HJ = parcelRequire("8e5HJ");

var $aEgqS = parcelRequire("aEgqS");
const $45128b816fe744d7$var$url = window.location.origin;
const $45128b816fe744d7$export$a5a6e0b888b2c992 = {
    authority: "",
    client_id: "",
    redirect_uri: $45128b816fe744d7$var$url + "/",
    post_logout_redirect_uri: $45128b816fe744d7$var$url + "/signin",
    response_type: "code",
    scope: "openid profile email",
    popup_redirect_uri: $45128b816fe744d7$var$url + "/signin",
    popup_post_logout_redirect_uri: $45128b816fe744d7$var$url + "/signin",
    silent_redirect_uri: $45128b816fe744d7$var$url + "/signin",
    loadUserInfo: true,
    prompt: "select_account"
};
function $45128b816fe744d7$var$buildUserManager(authority, clientId) {
    if (!(authority && clientId)) return null;
    return new (0, $8vz7t.UserManager)({
        ...$45128b816fe744d7$export$a5a6e0b888b2c992,
        authority: authority,
        client_id: clientId
    });
}
const $45128b816fe744d7$var$SignInPage = ()=>{
    const apiToken = (0, $iD0SF.useSelector)((state)=>state.userSession.apiToken);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const { signInType: signInType, oauthAuthority: oauthAuthority, oauthClientId: oauthClientId } = (0, $iD0SF.useSelector)((0, $6lvMC.getUserSession));
    const authority = localStorage.getItem("oauthAuthority");
    const clientId = localStorage.getItem("oauthClientId");
    const [processingOauth, setProcessingOauth] = (0, $acw62.useState)(false);
    const userManager = (0, $acw62.useMemo)(()=>$45128b816fe744d7$var$buildUserManager(authority || oauthAuthority, clientId || oauthClientId), [
        oauthAuthority,
        oauthClientId
    ]);
    const _signInOIDC = ()=>{
        if (!userManager) return;
        setTimeout(()=>setProcessingOauth(true), 0);
        userManager.signinPopup().then((user)=>{
            (0, $jSDfI.setOAuthIdToken)(user.id_token);
            dispatch({
                type: (0, $lnXep.AccountActionTypes).SIGN_IN_SWAP_OAUTH_TOKEN
            });
            dispatch((0, $ai857.fetchCurrentUserAction)());
            (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).ROOT);
        }).catch(()=>{
            setProcessingOauth(false);
            (0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).SIGN_IN);
            console.error("OIDC login failed");
        });
    };
    const signInOIDC = (0, $acw62.useCallback)(_signInOIDC, [
        oauthAuthority,
        oauthClientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (oauthAuthority) localStorage.setItem("oauthAuthority", oauthAuthority);
        if (oauthClientId) localStorage.setItem("oauthClientId", oauthClientId);
    }, [
        oauthAuthority
    ]);
    (0, $acw62.useEffect)(()=>{
        if (apiToken) (0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).ROOT);
    }, [
        apiToken
    ]);
    (0, $acw62.useEffect)(()=>{
        if (window.location.pathname == "/sso") signInOIDC();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const userMessage = params.get("userMessage");
        if (!userMessage) return;
        const message = {
            messageKey: userMessage,
            type: (0, $jiIfA.UserMessageTypes).SUCCESS
        };
        dispatch((0, $arZQw.displayUserMessageAction)(message));
        setTimeout(()=>(0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).SIGN_IN), 0);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const userMessage = params.get("userError");
        if (!userMessage) return;
        const message = {
            messageKey: userMessage,
            type: (0, $jiIfA.UserMessageTypes).ERROR
        };
        dispatch((0, $arZQw.displayUserMessageAction)(message));
        setTimeout(()=>(0, $1l1FS.default).replace((0, $6QJY8.RoutePaths).SIGN_IN), 0);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const code = params.get("code");
        if (!code) return;
        // this is needed to handle the popup callback correctly.
        userManager.signinPopupCallback().then((user)=>{
            console.log("callback for", user);
        }).catch((e)=>console.error("error", e));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (signInType === (0, $8e5HJ.SignInType).Oauth) signInOIDC();
    }, [
        signInType
    ]);
    const OauthMessage = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center mb-5",
                    children: "Awaiting SSO"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dW5lH.default), {}),
            processingOauth ? /*#__PURE__*/ (0, $ayMG0.jsx)(OauthMessage, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpBS7.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: oauthAuthority ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: signInOIDC,
                        children: " Login with OIDC "
                    })
                }) : null
            })
        ]
    });
};
var $45128b816fe744d7$export$2e2bcd8739ae039 = $45128b816fe744d7$var$SignInPage;

});
parcelRegister("jpBS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b559feb5d0749d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $lCZwG = parcelRequire("lCZwG");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8e5HJ = parcelRequire("8e5HJ");

var $4KSAX = parcelRequire("4KSAX");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $jF0Xa = parcelRequire("jF0Xa");

var $6lvMC = parcelRequire("6lvMC");

var $5YAlZ = parcelRequire("5YAlZ");

var $1DXYh = parcelRequire("1DXYh");

var $99dFw = parcelRequire("99dFw");

var $2ywbu = parcelRequire("2ywbu");

var $04A9g = parcelRequire("04A9g");

var $f52QH = parcelRequire("f52QH");

var $eDQDM = parcelRequire("eDQDM");

var $5ZQE3 = parcelRequire("5ZQE3");
// This is a temporary solution to allow an O'Driscoll to sign in
// It was taken from Yup: https://github.com/jquense/yup/blob/99aa25787a8ff15fe42e54db88ec3ed547357302/src/string.ts
// Ideally we'd just use a validation schema tha uses Yup directly.
const $20b559feb5d0749d$var$emailRegex = // eslint-disable-next-line
/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const $20b559feb5d0749d$var$SignInForm = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "account"
    ]);
    const { email: email } = (0, $acw62.useContext)((0, $f52QH.QueryStringContext));
    const userFieldRef = (0, $acw62.useRef)(null);
    const passwordFieldRef = (0, $acw62.useRef)(null);
    const [showPasswordReset, updatePasswordReset] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { signInType: signInType, oauthAuthority: oauthAuthority } = (0, $iD0SF.useSelector)((0, $6lvMC.getUserSession));
    const signOutUser = ()=>dispatch((0, $5YAlZ.signOutUserAction)());
    const fetchUserSignInType = (email)=>dispatch((0, $5YAlZ.userSignInTypeAction)(email));
    const signInUser = (email, password)=>dispatch((0, $5YAlZ.signInUserAction)(email, password));
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    (0, $acw62.useEffect)(()=>{
        // TODO: If SignInType is 3party send user to redirect page
        if (signInType === (0, $8e5HJ.SignInType).Local) passwordFieldRef && passwordFieldRef.current && passwordFieldRef.current?.focus();
    }, [
        signInType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!(params.get("code") || oauthAuthority)) signOutUser();
    }, []);
    const [signInCount, setSignInCount] = (0, $acw62.useState)({});
    const togglePasswordReset = (value)=>{
        updatePasswordReset(value);
    };
    const onSubmitPassword = (email, password)=>{
        if (email && password) signInUser(email, password);
        const counts = {
            ...signInCount
        };
        counts[email] ||= 0;
        counts[email] += 1;
        setSignInCount(counts);
    };
    const validEmail = (email)=>{
        return $20b559feb5d0749d$var$emailRegex.test(email);
    };
    const showPasswordField = (email)=>{
        return signInType === (0, $8e5HJ.SignInType).Local && validEmail(email);
    };
    const onSubmitEmail = (username)=>{
        if (validEmail(username)) fetchUserSignInType(username);
    };
    const showNotRecognised = (username)=>{
        return signInType === (0, $8e5HJ.SignInType).NotFound && validEmail(username);
    };
    const renderEmailSubmitButton = (values, isSubmitting, errors)=>{
        if (showPasswordField(values.username)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: ()=>onSubmitEmail(values.username),
                isSubmit: true,
                isDisabled: isSubmitting || errors.username !== "",
                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    hidden: signInType === (0, $8e5HJ.SignInType).Oauth
                }),
                children: t("shared:next")
            })
        });
    };
    const renderPasswordSubmitButton = (values, isSubmitting)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                renderWarning(),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    reverse: true,
                    buttons: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>onSubmitPassword(values.username, values.password),
                            isSubmit: true,
                            isDisabled: isSubmitting,
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                hidden: signInType !== (0, $8e5HJ.SignInType).Local
                            }),
                            children: t("shared:next")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ywbu.default), {
                            action: ()=>{
                                signOutUser();
                            },
                            noPaddingY: true,
                            className: "py-1",
                            children: t("shared:back")
                        }, "2")
                    ]
                })
            ]
        });
    };
    const renderWarning = ()=>{
        if (!Object.values(signInCount).find((x)=>x > 4)) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDQDM.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: t("account:accountLockedMessage")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex justify-center", {
                    hidden: showPasswordReset
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    initialValues: {
                        username: email,
                        password: ""
                    },
                    validate: (values)=>{
                        const errors = {
                            username: ""
                        };
                        if (!values.username) errors.username = t("shared:required");
                        else if (!validEmail(values.username)) errors.username = t("account:invalidEmail");
                        return errors;
                    },
                    onSubmit: (_values, _actions)=>null,
                    validateOnMount: true,
                    enableReinitialize: true,
                    children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "text-lg mb-4",
                                                children: t("account:signInTitle")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex justify-center", "text-ch-blue-alt-400", "mb-2", {
                                                    hidden: signInType !== (0, $8e5HJ.SignInType).Local
                                                }),
                                                children: values.username
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                        hidden: signInType === (0, $8e5HJ.SignInType).Local
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "email",
                                            children: t("account:email")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            innerRef: userFieldRef,
                                            autoFocus: true,
                                            type: "email",
                                            name: "username",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.username,
                                            autoComplete: "username"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.username,
                                            isVisible: errors.username && touched.username
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: t("account:emailNotRecognised"),
                                            isVisible: showNotRecognised(values.username)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt-6",
                                            children: renderEmailSubmitButton(values, isSubmitting, errors)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                        hidden: !showPasswordField(values.username)
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "email",
                                            children: t("account:password")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex relative items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                    innerRef: passwordFieldRef,
                                                    type: showPassword ? "text" : "password",
                                                    name: "password",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    value: values.password,
                                                    autoComplete: "current-password password"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ZQE3.default), {
                                                    showPassword: showPassword,
                                                    setShowPassword: setShowPassword
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.password,
                                            isVisible: errors.password && touched.password
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                                            action: ()=>togglePasswordReset(true),
                                            children: t("account:forgottenYourPassword")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt-6 flex justify-center",
                                            children: renderPasswordSubmitButton(values, isSubmitting)
                                        })
                                    ]
                                })
                            ]
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex justify-center", {
                    hidden: !showPasswordReset
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99dFw.default), {
                    usernameRef: userFieldRef,
                    toggleView: togglePasswordReset
                })
            })
        ]
    });
};
var $20b559feb5d0749d$export$2e2bcd8739ae039 = $20b559feb5d0749d$var$SignInForm;

});
parcelRegister("99dFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3239dbde4f2e9515$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");

var $4KSAX = parcelRequire("4KSAX");

var $jF0Xa = parcelRequire("jF0Xa");

var $5YAlZ = parcelRequire("5YAlZ");

var $1DXYh = parcelRequire("1DXYh");
const $3239dbde4f2e9515$var$ResetPasswordInstructions = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "account"
    ]);
    const username = props.usernameRef && props.usernameRef.current && props.usernameRef.current.defaultValue ? props.usernameRef.current.defaultValue : "";
    const onSubmitPasswordReset = ()=>{
        props.sendResetLink(username);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-4",
                            children: t("account:forgottenYourPassword")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center text-ch-blue-alt-400 mb-2",
                            children: username
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mx-4",
                        children: t("account:sendResetPasswordInstructions")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mt-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            isDisabled: !username || username == "",
                            action: ()=>onSubmitPasswordReset(),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: t("account:sendResetLink")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mt-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                            action: ()=>props.toggleView(false),
                            children: t("account:backToLogin")
                        })
                    })
                ]
            })
        ]
    });
};
const $3239dbde4f2e9515$var$mapDispatchToProps = (dispatch)=>{
    return {
        sendResetLink: (email)=>dispatch((0, $5YAlZ.sendResetPasswordLinkAction)(email))
    };
};
var $3239dbde4f2e9515$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $3239dbde4f2e9515$var$mapDispatchToProps)($3239dbde4f2e9515$var$ResetPasswordInstructions);

});

parcelRegister("f52QH", function(module, exports) {

$parcel$export(module.exports, "QueryStringContext", () => $d8d7e5c8932279ef$export$c613b3d90af07f46);
$parcel$export(module.exports, "QueryStringContextProvider", () => $d8d7e5c8932279ef$export$1d630d0f88a3ca5e);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $d8d7e5c8932279ef$export$c613b3d90af07f46 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
$d8d7e5c8932279ef$export$c613b3d90af07f46.displayName = "QueryStringContext";
const $d8d7e5c8932279ef$export$1d630d0f88a3ca5e = (props)=>{
    const [email, setEmail] = (0, $acw62.useState)("");
    const [tenantId, setTenantId] = (0, $acw62.useState)(null);
    const [loginHint, setLoginHint] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const emailValue = urlParams.get("email");
        if (emailValue) setEmail(emailValue);
        const tenantIdValue = urlParams.get("tenantId");
        if (tenantIdValue) setTenantId(tenantIdValue);
        const loginHintValue = urlParams.get("login_hint");
        if (loginHintValue) setLoginHint(loginHintValue);
    }, [
        window.location.search
    ]);
    const resetQuery = ()=>{
        setEmail("");
        setTenantId(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d8d7e5c8932279ef$export$c613b3d90af07f46.Provider, {
        value: {
            email: email,
            tenantId: tenantId,
            loginHint: loginHint,
            resetQuery: resetQuery
        },
        children: props.children
    });
};

});

parcelRegister("eDQDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a97acc2cb6526d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jitSV");
var $9IdeF = parcelRequire("9IdeF");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");
const $07a97acc2cb6526d$var$WarningBanner = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
            width: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9IdeF.default), {
                    className: "text-ch-orange-500 w-6 h-4 mr-6 flex-shrink-0"
                }),
                props.children
            ]
        })
    });
};
var $07a97acc2cb6526d$export$2e2bcd8739ae039 = $07a97acc2cb6526d$var$WarningBanner;

});

parcelRegister("5ZQE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38878236bd44711$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gtSe0 = parcelRequire("gtSe0");

var $gqzfO = parcelRequire("gqzfO");

var $jF0Xa = parcelRequire("jF0Xa");
const $a38878236bd44711$var$ShowPasswordButton = (props)=>{
    const renderIcon = ()=>{
        if (props.showPassword) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gqzfO.default), {
            width: 20,
            height: 20,
            fill: (0, $jF0Xa.ColorPalette).BLUE
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtSe0.default), {
            width: 20,
            height: 20,
            fill: (0, $jF0Xa.ColorPalette).BLUE
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "absolute right-2",
        onClick: ()=>props.setShowPassword(!props.showPassword),
        children: renderIcon()
    });
};
var $a38878236bd44711$export$2e2bcd8739ae039 = $a38878236bd44711$var$ShowPasswordButton;

});
parcelRegister("gtSe0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75540883ae16a40$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $e75540883ae16a40$var$SvgIconEye = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 576 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"
        })
    });
var $e75540883ae16a40$export$2e2bcd8739ae039 = $e75540883ae16a40$var$SvgIconEye;

});

parcelRegister("gqzfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4275d8d300133829$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4275d8d300133829$var$SvgIconEyeSlash = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 640 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm184.3 144.4c25.5-23.3 59.6-37.5 96.9-37.5 79.5 0 144 64.5 144 144 0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-94.3-74.3c-22.8 29.7-39.1 59.3-48.6 82.2-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
        })
    });
var $4275d8d300133829$export$2e2bcd8739ae039 = $4275d8d300133829$var$SvgIconEyeSlash;

});



parcelRegister("dW5lH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b66e19273ed7e51b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kyrHl = parcelRequire("kyrHl");

var $eDQDM = parcelRequire("eDQDM");

var $4KSAX = parcelRequire("4KSAX");
const $b66e19273ed7e51b$var$BrowserWarning = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($kyrHl))).getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({
        mobile: {
            edge: ">=100"
        },
        // or in general
        chrome: ">=105",
        edge: ">=105",
        safari: ">=15.6"
    });
    if (isValidBrowser) return;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDQDM.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: t("shared:browserWarning")
        })
    });
};
var $b66e19273ed7e51b$export$2e2bcd8739ae039 = $b66e19273ed7e51b$var$BrowserWarning;

});
parcelRegister("kyrHl", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});


parcelRegister("8vz7t", function(module, exports) {
"use strict";
var $631c75f8a3fcffe9$var$__defProp = Object.defineProperty;
var $631c75f8a3fcffe9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $631c75f8a3fcffe9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $631c75f8a3fcffe9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $631c75f8a3fcffe9$var$__export = (target, all)=>{
    for(var name in all)$631c75f8a3fcffe9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $631c75f8a3fcffe9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $631c75f8a3fcffe9$var$__getOwnPropNames(from))if (!$631c75f8a3fcffe9$var$__hasOwnProp.call(to, key) && key !== except) $631c75f8a3fcffe9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $631c75f8a3fcffe9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $631c75f8a3fcffe9$var$__toCommonJS = (mod)=>$631c75f8a3fcffe9$var$__copyProps($631c75f8a3fcffe9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $631c75f8a3fcffe9$var$index_exports = {};
$631c75f8a3fcffe9$var$__export($631c75f8a3fcffe9$var$index_exports, {
    AccessTokenEvents: ()=>$631c75f8a3fcffe9$var$AccessTokenEvents,
    CheckSessionIFrame: ()=>$631c75f8a3fcffe9$var$CheckSessionIFrame,
    DPoPState: ()=>$631c75f8a3fcffe9$var$DPoPState,
    ErrorResponse: ()=>$631c75f8a3fcffe9$var$ErrorResponse,
    ErrorTimeout: ()=>$631c75f8a3fcffe9$var$ErrorTimeout,
    InMemoryWebStorage: ()=>$631c75f8a3fcffe9$var$InMemoryWebStorage,
    IndexedDbDPoPStore: ()=>$631c75f8a3fcffe9$var$IndexedDbDPoPStore,
    Log: ()=>$631c75f8a3fcffe9$var$Log,
    Logger: ()=>$631c75f8a3fcffe9$var$Logger,
    MetadataService: ()=>$631c75f8a3fcffe9$var$MetadataService,
    OidcClient: ()=>$631c75f8a3fcffe9$var$OidcClient,
    OidcClientSettingsStore: ()=>$631c75f8a3fcffe9$var$OidcClientSettingsStore,
    SessionMonitor: ()=>$631c75f8a3fcffe9$var$SessionMonitor,
    SigninResponse: ()=>$631c75f8a3fcffe9$var$SigninResponse,
    SigninState: ()=>$631c75f8a3fcffe9$var$SigninState,
    SignoutResponse: ()=>$631c75f8a3fcffe9$var$SignoutResponse,
    State: ()=>$631c75f8a3fcffe9$var$State,
    User: ()=>$631c75f8a3fcffe9$var$User,
    UserManager: ()=>$631c75f8a3fcffe9$var$UserManager,
    UserManagerSettingsStore: ()=>$631c75f8a3fcffe9$var$UserManagerSettingsStore,
    Version: ()=>$631c75f8a3fcffe9$var$Version,
    WebStorageStateStore: ()=>$631c75f8a3fcffe9$var$WebStorageStateStore
});
module.exports = $631c75f8a3fcffe9$var$__toCommonJS($631c75f8a3fcffe9$var$index_exports);
// src/utils/Logger.ts
var $631c75f8a3fcffe9$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $631c75f8a3fcffe9$var$level;
var $631c75f8a3fcffe9$var$logger;
var $631c75f8a3fcffe9$var$Log = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($631c75f8a3fcffe9$var$Log || {});
((Log2)=>{
    function reset() {
        $631c75f8a3fcffe9$var$level = 3 /* INFO */ ;
        $631c75f8a3fcffe9$var$logger = $631c75f8a3fcffe9$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $631c75f8a3fcffe9$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $631c75f8a3fcffe9$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($631c75f8a3fcffe9$var$Log || ($631c75f8a3fcffe9$var$Log = {}));
var $631c75f8a3fcffe9$var$Logger = class _Logger {
    constructor(_name){
        this._name = _name;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(name), ...args);
    }
};
$631c75f8a3fcffe9$var$Log.reset();

var $cVqez = parcelRequire("cVqez");
var $631c75f8a3fcffe9$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $cVqez.jwtDecode)(token);
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $631c75f8a3fcffe9$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $631c75f8a3fcffe9$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $631c75f8a3fcffe9$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $631c75f8a3fcffe9$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $631c75f8a3fcffe9$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $631c75f8a3fcffe9$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $631c75f8a3fcffe9$var$CryptoUtils = $631c75f8a3fcffe9$var$_CryptoUtils;
// src/utils/Event.ts
var $631c75f8a3fcffe9$var$Event = class {
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Event('${this._name}')`);
    }
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
};
// src/utils/PopupUtils.ts
var $631c75f8a3fcffe9$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center({ ...features }) {
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $631c75f8a3fcffe9$var$Timer = class _Timer extends $631c75f8a3fcffe9$var$Event {
    constructor(){
        super(...arguments);
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
};
// src/utils/UrlUtils.ts
var $631c75f8a3fcffe9$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $631c75f8a3fcffe9$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $631c75f8a3fcffe9$var$ErrorResponse = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $631c75f8a3fcffe9$var$Logger.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $631c75f8a3fcffe9$var$ErrorTimeout = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $631c75f8a3fcffe9$var$AccessTokenEvents = class {
    constructor(args){
        this._logger = new $631c75f8a3fcffe9$var$Logger("AccessTokenEvents");
        this._expiringTimer = new $631c75f8a3fcffe9$var$Timer("Access token expiring");
        this._expiredTimer = new $631c75f8a3fcffe9$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
};
// src/CheckSessionIFrame.ts
var $631c75f8a3fcffe9$var$CheckSessionIFrame = class {
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $631c75f8a3fcffe9$var$Logger("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
};
// src/InMemoryWebStorage.ts
var $631c75f8a3fcffe9$var$InMemoryWebStorage = class {
    constructor(){
        this._logger = new $631c75f8a3fcffe9$var$Logger("InMemoryWebStorage");
        this._data = {};
    }
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
};
// src/errors/ErrorDPoPNonce.ts
var $631c75f8a3fcffe9$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $631c75f8a3fcffe9$var$JsonService = class {
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $631c75f8a3fcffe9$var$Logger("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds, ...initFetch } = init;
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal
            });
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $631c75f8a3fcffe9$var$ErrorTimeout("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = {
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded",
            ...extraHeaders
        };
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $631c75f8a3fcffe9$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
};
// src/MetadataService.ts
var $631c75f8a3fcffe9$var$MetadataService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
};
// src/WebStorageStateStore.ts
var $631c75f8a3fcffe9$var$WebStorageStateStore = class {
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $631c75f8a3fcffe9$var$Logger("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
};
// src/OidcClientSettings.ts
var $631c75f8a3fcffe9$var$DefaultResponseType = "code";
var $631c75f8a3fcffe9$var$DefaultScope = "openid";
var $631c75f8a3fcffe9$var$DefaultClientAuthentication = "client_secret_post";
var $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds = 900;
var $631c75f8a3fcffe9$var$OidcClientSettingsStore = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $631c75f8a3fcffe9$var$DefaultResponseType, scope: scope = $631c75f8a3fcffe9$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $631c75f8a3fcffe9$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.stateStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $631c75f8a3fcffe9$var$UserInfoService = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $631c75f8a3fcffe9$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
};
// src/TokenClient.ts
var $631c75f8a3fcffe9$var$TokenClient = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("TokenClient");
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode({ grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials({ grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope, ...args }) {
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken({ grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
};
// src/ResponseValidator.ts
var $631c75f8a3fcffe9$var$ResponseValidator = class {
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ResponseValidator");
        this._userInfoService = new $631c75f8a3fcffe9$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this._settings, this._metadataService);
    }
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response, "", state.nonce);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders,
                ...state.extraTokenParams
            });
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken, nonce) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $631c75f8a3fcffe9$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (nonce && incoming.nonce !== nonce) logger2.throw(new Error("nonce in id_token does not match nonce in client storage"));
        if (existingToken) {
            const existing = $631c75f8a3fcffe9$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
};
// src/State.ts
var $631c75f8a3fcffe9$var$State = class _State {
    constructor(args){
        this.id = args.id || $631c75f8a3fcffe9$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $631c75f8a3fcffe9$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $631c75f8a3fcffe9$var$Logger.createStatic("State", "clearStaleState");
        const cutoff = $631c75f8a3fcffe9$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
};
// src/SigninState.ts
var $631c75f8a3fcffe9$var$SigninState = class _SigninState extends $631c75f8a3fcffe9$var$State {
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
        this.nonce = args.nonce;
    }
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $631c75f8a3fcffe9$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $631c75f8a3fcffe9$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState({
            ...args,
            code_verifier: code_verifier,
            code_challenge: code_challenge
        });
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo,
            nonce: this.nonce
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
};
// src/SigninRequest.ts
var $631c75f8a3fcffe9$var$_SigninRequest = class _SigninRequest {
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
    static async create({ url: // mandatory
    url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
    state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting, ...optionalParams }) {
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo,
            nonce: nonce
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries({
            response_mode: response_mode,
            ...optionalParams,
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
};
$631c75f8a3fcffe9$var$_SigninRequest._logger = new $631c75f8a3fcffe9$var$Logger("SigninRequest");
var $631c75f8a3fcffe9$var$SigninRequest = $631c75f8a3fcffe9$var$_SigninRequest;
// src/SigninResponse.ts
var $631c75f8a3fcffe9$var$OidcScope = "openid";
var $631c75f8a3fcffe9$var$SigninResponse = class {
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($631c75f8a3fcffe9$var$OidcScope)) || !!this.id_token;
    }
};
// src/SignoutRequest.ts
var $631c75f8a3fcffe9$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $631c75f8a3fcffe9$var$Logger("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $631c75f8a3fcffe9$var$State({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries({
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $631c75f8a3fcffe9$var$SignoutResponse = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $631c75f8a3fcffe9$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $631c75f8a3fcffe9$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $631c75f8a3fcffe9$var$ClaimsService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ClaimsService");
    }
    filterProtocolClaims(claims) {
        const result = {
            ...claims
        };
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $631c75f8a3fcffe9$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$631c75f8a3fcffe9$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = {
            ...claims1
        };
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
};
// src/DPoPStore.ts
var $631c75f8a3fcffe9$var$DPoPState = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $631c75f8a3fcffe9$var$OidcClient = class {
    constructor(settings, metadataService){
        this._logger = new $631c75f8a3fcffe9$var$Logger("OidcClient");
        this.settings = settings instanceof $631c75f8a3fcffe9$var$OidcClientSettingsStore ? settings : new $631c75f8a3fcffe9$var$OidcClientSettingsStore(settings);
        this.metadataService = metadataService != null ? metadataService : new $631c75f8a3fcffe9$var$MetadataService(this.settings);
        this._claimsService = new $631c75f8a3fcffe9$var$ClaimsService(this.settings);
        this._validator = new $631c75f8a3fcffe9$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this.settings, this.metadataService);
    }
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $631c75f8a3fcffe9$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $631c75f8a3fcffe9$var$SigninResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials({
            username: username,
            password: password,
            ...extraTokenParams
        });
        const signinResponse = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders,
                ...extraTokenParams
            });
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders,
                    ...extraTokenParams
                });
            } else throw err;
        }
        const response = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, {
            ...state,
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        });
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $631c75f8a3fcffe9$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $631c75f8a3fcffe9$var$SignoutResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$State.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $631c75f8a3fcffe9$var$State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
};
// src/SessionMonitor.ts
var $631c75f8a3fcffe9$var$SessionMonitor = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $631c75f8a3fcffe9$var$CheckSessionIFrame(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
};
// src/User.ts
var $631c75f8a3fcffe9$var$User = class _User {
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
};
// src/navigators/AbstractChildWindow.ts
var $631c75f8a3fcffe9$var$messageSource = "oidc-client";
var $631c75f8a3fcffe9$var$AbstractChildWindow = class {
    constructor(){
        this._abort = new $631c75f8a3fcffe9$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $631c75f8a3fcffe9$var$messageSource) return;
                try {
                    const state = $631c75f8a3fcffe9$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch  {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $631c75f8a3fcffe9$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $631c75f8a3fcffe9$var$Logger("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
};
// src/UserManagerSettings.ts
var $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $631c75f8a3fcffe9$var$DefaultPopupTarget = "_blank";
var $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds = 2;
var $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $631c75f8a3fcffe9$var$UserManagerSettingsStore = class extends $631c75f8a3fcffe9$var$OidcClientSettingsStore {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, maxSilentRenewTimeoutRetries: maxSilentRenewTimeoutRetries, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        this.maxSilentRenewTimeoutRetries = maxSilentRenewTimeoutRetries;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.userStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $631c75f8a3fcffe9$var$IFrameWindow = class _IFrameWindow extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $631c75f8a3fcffe9$var$ErrorTimeout("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
};
// src/navigators/IFrameNavigator.ts
var $631c75f8a3fcffe9$var$IFrameNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameNavigator");
    }
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $631c75f8a3fcffe9$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
};
// src/navigators/PopupWindow.ts
var $631c75f8a3fcffe9$var$checkForPopupClosedInterval = 500;
var $631c75f8a3fcffe9$var$second = 1e3;
var $631c75f8a3fcffe9$var$PopupWindow = class extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupWindow");
        const centeredPopup = $631c75f8a3fcffe9$var$PopupUtils.center({
            ...$631c75f8a3fcffe9$var$DefaultPopupWindowFeatures,
            ...popupWindowFeatures
        });
        this._window = window.open(void 0, popupWindowTarget, $631c75f8a3fcffe9$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $631c75f8a3fcffe9$var$second);
    }
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $631c75f8a3fcffe9$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
};
// src/navigators/PopupNavigator.ts
var $631c75f8a3fcffe9$var$PopupNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupNavigator");
    }
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $631c75f8a3fcffe9$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$PopupWindow.notifyOpener(url, keepOpen);
    }
};
// src/navigators/RedirectNavigator.ts
var $631c75f8a3fcffe9$var$RedirectNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("RedirectNavigator");
    }
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
};
// src/UserManagerEvents.ts
var $631c75f8a3fcffe9$var$UserManagerEvents = class extends $631c75f8a3fcffe9$var$AccessTokenEvents {
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManagerEvents");
        this._userLoaded = new $631c75f8a3fcffe9$var$Event("User loaded");
        this._userUnloaded = new $631c75f8a3fcffe9$var$Event("User unloaded");
        this._silentRenewError = new $631c75f8a3fcffe9$var$Event("Silent renew error");
        this._userSignedIn = new $631c75f8a3fcffe9$var$Event("User signed in");
        this._userSignedOut = new $631c75f8a3fcffe9$var$Event("User signed out");
        this._userSessionChanged = new $631c75f8a3fcffe9$var$Event("User session changed");
    }
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
};
// src/SilentRenewService.ts
var $631c75f8a3fcffe9$var$SilentRenewService = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $631c75f8a3fcffe9$var$Timer("Retry Silent Renew");
        this._timeoutRetryCount = 0;
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                this._timeoutRetryCount = 0;
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $631c75f8a3fcffe9$var$ErrorTimeout) {
                    this._timeoutRetryCount++;
                    const maxRetries = this._userManager.settings.maxSilentRenewTimeoutRetries;
                    const hasReachedLimit = maxRetries !== void 0 && this._timeoutRetryCount > maxRetries;
                    if (hasReachedLimit) {
                        logger2.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${maxRetries}), raising silentRenewError:`, err);
                        this._timeoutRetryCount = 0;
                        await this._userManager.events._raiseSilentRenewError(err);
                        return;
                    }
                    logger2.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, err);
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                this._timeoutRetryCount = 0;
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
};
// src/RefreshState.ts
var $631c75f8a3fcffe9$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $631c75f8a3fcffe9$var$UserManager = class {
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManager");
        this.settings = new $631c75f8a3fcffe9$var$UserManagerSettingsStore(settings);
        this._client = new $631c75f8a3fcffe9$var$OidcClient(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $631c75f8a3fcffe9$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $631c75f8a3fcffe9$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $631c75f8a3fcffe9$var$IFrameNavigator(this.settings);
        this._events = new $631c75f8a3fcffe9$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $631c75f8a3fcffe9$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $631c75f8a3fcffe9$var$SessionMonitor(this);
    }
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart({
            request_type: "si:r",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose, ...requestArgs } = args;
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $631c75f8a3fcffe9$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
            ...args
        });
        const user = new $631c75f8a3fcffe9$var$User({
            ...args.state,
            ...response
        });
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true,
            ...requestArgs
        }, handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $631c75f8a3fcffe9$var$ErrorResponse) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $631c75f8a3fcffe9$var$User(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $631c75f8a3fcffe9$var$ErrorResponse({
                    ...signinResponse,
                    error: "login_required"
                });
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, ...requestArgs } = args;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {},
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $631c75f8a3fcffe9$var$User.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
};
// package.json
var $631c75f8a3fcffe9$var$version = "3.5.0";
// src/Version.ts
var $631c75f8a3fcffe9$var$Version = $631c75f8a3fcffe9$var$version;
// src/IndexedDbDPoPStore.ts
var $631c75f8a3fcffe9$var$IndexedDbDPoPStore = class {
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
};

});
parcelRegister("cVqez", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", () => $968f28756c67bd23$export$fa1e2fb699b7861e);
class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});



parcelRegister("aesrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92ddda31df08f78$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4fo4Z = parcelRequire("4fo4Z");

var $8UrgM = parcelRequire("8UrgM");

var $6QJY8 = parcelRequire("6QJY8");

var $hKI4d = parcelRequire("hKI4d");

var $d5eYa = parcelRequire("d5eYa");

var $gnvJ9 = parcelRequire("gnvJ9");
const $e92ddda31df08f78$var$MeetingNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchSpecialties = ()=>dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const fetchAllTeams = ()=>dispatch((0, $gnvJ9.fetchAllTeamsAsync)());
    (0, $acw62.useEffect)(()=>{
        fetchSpecialties();
        fetchUsers();
        fetchAllTeams();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:meetings"),
                        href: (0, $6QJY8.RoutePaths).MEETINGS
                    },
                    {
                        pageTitle: t("meeting:addANewMeeting")
                    }
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hKI4d.default), {})
        ]
    });
};
var $e92ddda31df08f78$export$2e2bcd8739ae039 = $e92ddda31df08f78$var$MeetingNewPage;

});
parcelRegister("hKI4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8ca7d2385d70d4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $2sgOd = parcelRequire("2sgOd");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $ahLi9 = parcelRequire("ahLi9");

var $ckrEF = parcelRequire("ckrEF");

var $1Lj4p = parcelRequire("1Lj4p");

var $4qaeN = parcelRequire("4qaeN");

var $4Z6GL = parcelRequire("4Z6GL");

var $lDUJv = parcelRequire("lDUJv");

var $hnsNb = parcelRequire("hnsNb");

var $4qU6l = parcelRequire("4qU6l");

var $kYqkq = parcelRequire("kYqkq");

var $fKaTC = parcelRequire("fKaTC");
const $3c8ca7d2385d70d4$var$MeetingNewForm = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const createMeeting = (meeting)=>dispatch((0, $4Z6GL.createMeetingAction)(meeting));
    const { mdtTeamsEnabled: mdtTeamsEnabled } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    const [_typeManuallySet, setTypeManuallySet] = (0, $acw62.useState)(false);
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const [isMdtMeeting, setIsMdtMeeting] = (0, $acw62.useState)(false);
    const initialValues = {
        name: "",
        mdtTeamId: "",
        specialtyId: "",
        coordinator: "",
        users: [
            ""
        ],
        startDate: undefined,
        startTime: "",
        endTime: "",
        teams: [],
        meetingType: null
    };
    // this is commented out now because it still is a bit in flux. For the moment
    // we have decided that we want to default to General meetings, so this logic
    // is not used, but I'm not convinced that is going to stay that way, so
    // that's why I have left it commented - Niels
    //
    // useEffect(() => {
    //   if (Object.values(teams).length == 0) return
    //   const mdtTeams: ITeam[] = Object.values(teams).filter((team) => team.teamType == TeamTypes.mdt) || []
    //   if (!typeManuallySet && mdtTeamsEnabled && mdtTeams && mdtTeams.length > 0) {
    //     setIsMdtMeeting(true)
    //   }
    // }, [teamIds])
    const handlerA = ()=>{
        setIsMdtMeeting(false);
        setTypeManuallySet(true);
    };
    const handlerB = ()=>{
        setIsMdtMeeting(true);
        setTypeManuallySet(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: isMdtMeeting ? (0, $ckrEF.mdtMeetingNewValidationSchema)(timezone) : (0, $ckrEF.meetingNewValidationSchema)(timezone),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const dates = (0, $ahLi9.startEndDates)(values.startDate, values.startTime, values.endTime, timezone);
                values = (0, $ckrEF.meetingNewValidationSchema)(timezone).cast(values);
                const data = {
                    name: values.name,
                    specialtyId: values.specialtyId,
                    startDate: (0, $2sgOd.default)(dates.start),
                    endDate: (0, $2sgOd.default)(dates.end),
                    coordinatorId: values.coordinator,
                    userIds: values.users,
                    teamIds: values.teams,
                    mdtTeamId: values.mdtTeamId,
                    meetingType: values.meetingType
                };
                createMeeting(data);
                setSubmitting(false);
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                className: "w-full lg:w-2/3",
                children: [
                    mdtTeamsEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hnsNb.default), {
                        handlerA: handlerA,
                        handlerB: handlerB,
                        translationNamespace: "meeting",
                        AActive: !isMdtMeeting,
                        textAKey: "General Meeting",
                        textBKey: "MDT Meeting"
                    }) : null,
                    isMdtMeeting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qU6l.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDUJv.default), {})
                ]
            })
        })
    });
};
var $3c8ca7d2385d70d4$export$2e2bcd8739ae039 = $3c8ca7d2385d70d4$var$MeetingNewForm;

});
parcelRegister("2sgOd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c9b3c389e5703c4$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bGZx9 = parcelRequire("bGZx9");

var $4LmDH = parcelRequire("4LmDH");
function $1c9b3c389e5703c4$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $4LmDH.default)(1, arguments);
    var originalDate = (0, $gdr0J.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $bGZx9.default)(originalDate.getDate(), 2);
        var month = (0, $bGZx9.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $bGZx9.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    } // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $bGZx9.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $bGZx9.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $bGZx9.default)(originalDate.getHours(), 2);
        var minute = (0, $bGZx9.default)(originalDate.getMinutes(), 2);
        var second = (0, $bGZx9.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter); // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("ckrEF", function(module, exports) {

$parcel$export(module.exports, "meetingNewValidationSchema", () => $9bd4c3a14177b518$export$988cfe9549753f65);
$parcel$export(module.exports, "mdtMeetingNewValidationSchema", () => $9bd4c3a14177b518$export$175fdb71f3589b58);
parcelRequire("cxhNX");
var $8CK3p = parcelRequire("8CK3p");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $ahLi9 = parcelRequire("ahLi9");
const $9bd4c3a14177b518$export$988cfe9549753f65 = (timezone)=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        specialtyId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        coordinator: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        startDate: $8CK3p.create().required((0, $5wPBK.default).t("shared:required")).test("dateisFuture", (0, $5wPBK.default).t("meeting:requireFutureDate"), function(value) {
            return (0, $ahLi9.dateIsFuture)(value, this.parent.startTime, timezone);
        }),
        startTime: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")).test("timeValid", (0, $5wPBK.default).t("shared:invalidDate"), (value)=>{
            return (0, $ahLi9.timeFormatValid)(value);
        }),
        endTime: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")).test("timeValid", (0, $5wPBK.default).t("shared:invalidDate"), (value)=>{
            return (0, $ahLi9.timeFormatValid)(value);
        })
    });
};
const $9bd4c3a14177b518$export$175fdb71f3589b58 = (timezone)=>{
    return $9bd4c3a14177b518$export$988cfe9549753f65(timezone).shape({
        mdtTeamId: $gcL7X.create().required((0, $5wPBK.default).t("shared:required"))
    });
};

});

parcelRegister("lDUJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $121a90bbbf50f265$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $jdbjz = parcelRequire("jdbjz");

var $eKkKv = parcelRequire("eKkKv");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $6lvMC = parcelRequire("6lvMC");

var $ahLi9 = parcelRequire("ahLi9");

var $lqbsE = parcelRequire("lqbsE");

var $c0FI2 = parcelRequire("c0FI2");

var $d8Vwn = parcelRequire("d8Vwn");

var $5GZlj = parcelRequire("5GZlj");

var $jRidO = parcelRequire("jRidO");

var $ctA1Y = parcelRequire("ctA1Y");

var $jTkGE = parcelRequire("jTkGE");

var $2vRvQ = parcelRequire("2vRvQ");

var $6wDTk = parcelRequire("6wDTk");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $7YFi7 = parcelRequire("7YFi7");
const $121a90bbbf50f265$var$MeetingNewFormContent = ()=>{
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllInternalActiveUsersSorted)(state));
    const keyedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(users, "id");
    const specialties = (0, $iD0SF.useSelector)((0, $lqbsE.getAllSpecialties));
    const teams = (0, $iD0SF.useSelector)((0, $jTkGE.getAllTeams));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [teamOptions, setTeamOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const { isSubmitting: isSubmitting, setFieldValue: setFieldValue, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur } = (0, $7YFi7.useFormikContext)();
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(keyedUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = Object.values(teams).map((team)=>{
            return {
                value: team.id,
                label: team.name
            };
        });
        setTeamOptions(options);
    }, [
        teams
    ]);
    const renderTeamsField = (handleChange, handleBlur, errors, touched, values)=>{
        if (Object.keys(teams).length == 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "users",
                    children: t("shared:teams")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                    name: "teams",
                    options: teamOptions,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    isMulti: true,
                    closeMenuOnSelect: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: errors.users,
                    isVisible: errors.users && touched.users
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vRvQ.default), {
                    teamIds: values.teams,
                    header: t("meeting:teamUserListHeader")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "name",
                        required: true,
                        children: t("meeting:title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "name",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.name,
                        autoComplete: "off",
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.name,
                        isVisible: errors.name && touched.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "specialtyId",
                        required: true,
                        children: t("meeting:specialty")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "specialtyId",
                        options: specialtiesOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isGrouped: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.specialtyId,
                        isVisible: errors.specialtyId && touched.specialtyId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "coordinator",
                        required: true,
                        children: t("meeting:coordinator")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "coordinator",
                        options: userOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.coordinator,
                        isVisible: errors.coordinator && touched.coordinator
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "users",
                        children: t("meeting:participants")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "users",
                        options: userOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isMulti: true,
                        closeMenuOnSelect: false,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.users,
                        isVisible: errors.users && touched.users
                    })
                ]
            }),
            renderTeamsField(handleChange, handleBlur, errors, touched, values),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "startDate",
                        required: true,
                        children: t("meeting:startDateAndTime")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex mr-4 mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                            name: "startDate"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lg:h-8 my-1 ml-7 sm:h-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.startDate,
                                                isVisible: errors.startDate && touched.startDate
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex space-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                            name: "startTime",
                                                            onChange: (e)=>{
                                                                if (!values.endTime) setFieldValue("endTime", (0, $ahLi9.addHour)(e.currentTarget.value, 1));
                                                                handleChange(e);
                                                            },
                                                            onBlur: handleBlur
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mx-2",
                                                            children: "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-8 my-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                        errorMessage: errors.startTime,
                                                        isVisible: errors.startTime && touched.startTime
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                            name: "endTime",
                                                            onChange: handleChange,
                                                            onBlur: handleBlur
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "self-center mx-1 flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdbjz.default), {
                                                                    className: "text-ch-blue-500 mx-2 w-5 h-5"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "self-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eKkKv.DurationLabel), {
                                                                        startTime: values.startTime,
                                                                        endTime: values.endTime
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-8 my-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                        errorMessage: errors.endTime,
                                                        isVisible: errors.endTime && touched.endTime
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    isDisabled: isSubmitting,
                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                    isSubmit: true,
                    children: t("createMeeting")
                })
            })
        ]
    });
};
var $121a90bbbf50f265$export$2e2bcd8739ae039 = $121a90bbbf50f265$var$MeetingNewFormContent;

});
parcelRegister("eKkKv", function(module, exports) {

$parcel$export(module.exports, "DurationLabel", () => $6b2b0fb9b9c5c3dc$export$99a87b3c9bfa52f4);

var $ayMG0 = parcelRequire("ayMG0");

var $6OX6Q = parcelRequire("6OX6Q");
var $8xDhD = parcelRequire("8xDhD");
parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");
const $6b2b0fb9b9c5c3dc$export$99a87b3c9bfa52f4 = ({ startTime: startTime, endTime: endTime })=>{
    if (!startTime || !endTime) return null;
    const duration = ()=>{
        const start = (0, $ahLi9.parseTime)(startTime), endDate = (0, $ahLi9.parseTime)(endTime), end = endDate <= start ? (0, $6OX6Q.default)(endDate, 1) : endDate;
        const diff = (0, $8xDhD.default)(end, start);
        const hours = Math.floor(diff / 3600);
        const minutes = Math.floor((diff - 3600 * hours) / 60);
        let str = "";
        if (hours > 0) str = hours + "h";
        if (hours > 0 && minutes > 0) str += " ";
        if (minutes > 0) str += minutes + "min" // TODO: Translate
        ;
        return str;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: duration()
    });
};

});

parcelRegister("jRidO", function(module, exports) {

$parcel$export(module.exports, "default", () => $693ee5ef13ea2be3$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $5arZS = parcelRequire("5arZS");


var $c3iH1 = parcelRequire("c3iH1");

var $ahLi9 = parcelRequire("ahLi9");

var $9c2AV = parcelRequire("9c2AV");
const $693ee5ef13ea2be3$export$34dc4cfa15ead1 = (props)=>{
    const { setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const [field] = (0, $7YFi7.useField)(props);
    const defaultClasses = [
        "shadow",
        "appearance-none",
        "border",
        "rounded",
        "w-40",
        "py-2",
        "px-3",
        "text-gray-700",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "focus:ring-2",
        "ring-ch-blue-alt-300"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    const defaultChangeHandler = (val)=>{
        setFieldValue(field.name, val);
    };
    const changeHandler = props.onChange ? props.onChange : defaultChangeHandler;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        className: "flex flex-row items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2AV.default), {
                className: "text-ch-blue-500 self-center mx-1 w-5 h-5"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5arZS))), {
                ...field,
                id: props.name,
                locale: (0, $c3iH1.default),
                className: allClasses,
                dateFormat: (0, $ahLi9.formatDatePickerString),
                selected: field.value && new Date(field.value) || null,
                onChange: changeHandler,
                minDate: new Date(),
                showDisabledMonthNavigation: true,
                showMonthDropdown: props.showMonthDropdown,
                showYearDropdown: props.showYearDropdown
            })
        ]
    });
};
var $693ee5ef13ea2be3$export$2e2bcd8739ae039 = $693ee5ef13ea2be3$export$34dc4cfa15ead1;

});
parcelRegister("5arZS", function(module, exports) {






























































!function(e, t) {
    t(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("8g1PZ")), (parcelRequire("9BdaM")), (parcelRequire("cFZfS")), (parcelRequire("6IhJz")), (parcelRequire("bTSG2")), (parcelRequire("kehhj")), (parcelRequire("6OX6Q")), (parcelRequire("2MTnF")), (parcelRequire("eqWMS")), (parcelRequire("kbDwl")), (parcelRequire("8o58w")), (parcelRequire("58cSq")), (parcelRequire("4irF8")), (parcelRequire("lDduA")), (parcelRequire("lXe7Q")), (parcelRequire("4UG1B")), (parcelRequire("6fhf3")), (parcelRequire("aABJG")), (parcelRequire("kjLiX")), (parcelRequire("34ylv")), (parcelRequire("eZOMj")), (parcelRequire("hbMru")), (parcelRequire("4UeRq")), (parcelRequire("3LPyO")), (parcelRequire("knAHj")), (parcelRequire("2SwgK")), (parcelRequire("d0W11")), (parcelRequire("6mdUF")), (parcelRequire("gpyWg")), (parcelRequire("cZ2kT")), (parcelRequire("fVhCa")), (parcelRequire("3lKFD")), (parcelRequire("8v9st")), (parcelRequire("6atcA")), (parcelRequire("lm2ga")), (parcelRequire("1Whvr")), (parcelRequire("e4h6L")), (parcelRequire("jMhzE")), (parcelRequire("cJfMa")), (parcelRequire("7yBDJ")), (parcelRequire("5E40x")), (parcelRequire("gVPZO")), (parcelRequire("6eIgt")), (parcelRequire("6uyHy")), (parcelRequire("75XN4")), (parcelRequire("l2vHo")), (parcelRequire("gd5RE")), (parcelRequire("hjw1k")), (parcelRequire("b27pX")), (parcelRequire("R4xmB")), (parcelRequire("kggGd")), (parcelRequire("baBa1")), (parcelRequire("4YTY5")), (parcelRequire("gDwFN")), (parcelRequire("gdr0J")), (parcelRequire("auRgN")), (parcelRequire("dpjX2")), (parcelRequire("hL3CS")), (parcelRequire("1u0KT")), (parcelRequire("7tYfQ")));
}(module.exports, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, S, C, _, M, P, E, N, x, O, Y, I, T, L, R, F, A, q, W, B, K, H, j, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Se = le(D), Ce = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(S), xe = le(C), Oe = le(_), Ye = le(M), Ie = le(P), Te = le(E), Le = le(N), Re = le(x), Fe = le(O), Ae = le(Y), qe = le(I), We = le(T), Be = le(L), Ke = le(R), He = le(F), je = le(A), Qe = le(W), Ve = le(B), Ue = le(K), $e = le(H), ze = le(j), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            writable: !1
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function St(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return bt(e);
    }
    function Ct(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return St(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, xt = 12, Ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Yt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return Tt(t) ? t : null;
    }
    function It(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var p = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = Tt(p, n) && e === Lt(p, t, r)), Tt(p, n) && i && (o = p);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = Tt(o) && e === Lt(o, t, r) : Tt(o) || (t = t.match(Ot).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), Tt(o) || (o = new Date(e))), Tt(o) && i ? o : null);
    }
    function Tt(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && !nt.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Rt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ft(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Fe.default(Re.default(Le.default(e, i), o), a);
    }
    function At(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return xe.default(e, r ? {
            locale: r
        } : null);
    }
    function qt(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Bt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Kt(e) {
        return $e.default(e);
    }
    function Ht(e) {
        return Ge.default(e);
    }
    function jt(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(Ae.default(Yt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(Ae.default(Yt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(qe.default(Yt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return $t(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Yt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Ie.default(e), o = Oe.default(e), s = Ie.default(t), i = Oe.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Ie.default(e), o = Ye.default(e), s = Ie.default(t), i = Ye.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Yt(), s = Fe.default(Re.default(o, Me.default(e)), Pe.default(e)), i = Fe.default(Re.default(o, Me.default(r)), Pe.default(r)), p = Fe.default(Re.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && je.default(r, n) > 0 || a && a.every(function(e) {
            return je.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && je.default(n, r) > 0 || a && a.every(function(e) {
            return je.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) >= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) <= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xt, r = Math.ceil(Ie.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Sr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Ie.default(r) <= s), a && i && (i = Ie.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Cr = function(e) {
        wt(a, e);
        var r = Ct(a);
        function a(e) {
            var n;
            ht(this, a), Dt(bt(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(bt(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Ie.default(n.props.minDate) : null, a = n.props.maxDate ? Ie.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(n), "onChange", function(e) {
                n.props.onChange(e);
            }), Dt(bt(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), Dt(bt(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Dt(bt(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), Dt(bt(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Sr(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return yt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), _r = lt.default(Cr), Mr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Ie.default(e.props.minDate) : 1900, r = e.props.maxDate ? Ie.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Dt(bt(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function xr(e, t) {
        for(var r = [], a = Kt(e), n = Kt(t); !at.default(a, n);)r.push(Yt(a)), a = we.default(a, 1);
        return r;
    }
    var Or = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Te.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: xr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Yr = lt.default(Or), Ir = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Kt(e.props.minDate), r = Kt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Te.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Te.default(Kt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(Yr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Yt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Tr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (nt.default(d, l) || zt(d, l)) ? Gt(a, d, l) : (o && p && (at.default(d, p) || zt(d, p)) || !(!s || !p || l || !at.default(d, p) && !zt(d, p))) && Gt(a, p, d));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Oe.default(e.props.day);
            }), Dt(bt(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Oe.default(e.props.day) + 1) % 12 === e.props.month;
            }), Dt(bt(e), "isCurrentDay", function() {
                return e.isSameDay(Yt());
            }), Dt(bt(e), "isSelected", function() {
                return e.isSameDay(e.props.selected);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : At(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Bt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Tr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "isCurrentMonth", function(e, t) {
                return Ie.default(e) === Ie.default(Yt()) && t === Oe.default(Yt());
            }), Dt(bt(e), "isSelectedMonth", function(e, t, r) {
                return Oe.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "isSelectedQuarter", function(e, t, r) {
                return Ye.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Bt(Kt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Rr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Oe.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Kt(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Se.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(jt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(Ae.default(a, t), e.props),
                    "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": Oe.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = Oe.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ae.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(qe.default(a, t), e.props),
                    "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale, s = t.day, i = t.selected;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(s, t, i)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), Ar = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "isSelectedTime", function(t, r, a) {
                return e.props.selected && r === Pe.default(t) && a === Me.default(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(Yt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || Yt(), p = Pe.default(i), l = Me.default(i), d = Fe.default(Re.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0",
                        "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(Ar, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var qr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isCurrentYear", function(e) {
                return e === Ie.default(Yt());
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = Ht(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, Ht(a.props.selected)) && $t(t, Ht(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(Ht(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Ce.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Ie.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Ie.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Br(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Kr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Hr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Kr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = Yt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ae.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(Ae.default(r, Oe.default(e)), Ie.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Bt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(Ht(Ce.default(e, n)), n).endPeriod, s = r && Ie.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, c = p.previousYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(ge.default(e, n), n).startPeriod, s = r && Ie.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, c = p.nextYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Ie.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Oe.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ir, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(Yt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Ie.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Se.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Fr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(qr, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Ar, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Tt(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Br;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xt
                    };
                }
            }
        ]), r;
    }(de.default.Component), jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(jr, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(Hr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Yt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = It(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = Yt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = Yt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Se.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Ce.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Oe.default(r), s = Oe.default(n), i = Ie.default(r), p = Ie.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Rt(e, r), n = t ? Rt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Rt(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Oe.default(r) !== Oe.default(a) || Ie.default(r) !== Ie.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(jr, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xt,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Br, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("bTSG2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8a9f3e7be35784f5$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE = 60000;
function $8a9f3e7be35784f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("2MTnF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $207b05f27970aaba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $6OX6Q.default)(dirtyDate, days);
}

});

parcelRegister("eqWMS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a8211859f65764ad$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("kbDwl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb237db400049a40$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, amount * 12);
}

});

parcelRegister("8o58w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61b48c9d860cd899$export$2e2bcd8739ae039);

var $bTSG2 = parcelRequire("bTSG2");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $61b48c9d860cd899$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $bTSG2.default)(dirtyDate, -amount);
}

});

parcelRegister("58cSq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bc7b0320eecfefe$export$2e2bcd8739ae039);

var $kehhj = parcelRequire("kehhj");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $3bc7b0320eecfefe$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kehhj.default)(dirtyDate, -amount);
}

});

parcelRegister("4irF8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $320e4d083cefb0bc$export$2e2bcd8739ae039);

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $320e4d083cefb0bc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $6OX6Q.default)(dirtyDate, -amount);
}

});

parcelRegister("lDduA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fbf7b4c4dab20b8b$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $2MTnF = parcelRequire("2MTnF");

var $4LmDH = parcelRequire("4LmDH");
function $fbf7b4c4dab20b8b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $2MTnF.default)(dirtyDate, -amount);
}

});

parcelRegister("lXe7Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ffba10b3e12d8879$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $ffba10b3e12d8879$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, -amount);
}

});

parcelRegister("4UG1B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $393cfda53f7a350f$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $kbDwl = parcelRequire("kbDwl");

var $4LmDH = parcelRequire("4LmDH");
function $393cfda53f7a350f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kbDwl.default)(dirtyDate, -amount);
}

});

parcelRegister("6fhf3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48c184a62f8d0eb5$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48c184a62f8d0eb5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("aABJG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b5a89b8f9188b81$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $7b5a89b8f9188b81$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("kjLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecaa46b9ba4a249b$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ecaa46b9ba4a249b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("34ylv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $23cc632e101f8877$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $23cc632e101f8877$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("eZOMj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aeae26b52a87faed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $aeae26b52a87faed$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("hbMru", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8390a6465ec9630$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $2HjQQ = parcelRequire("2HjQQ");

var $4LmDH = parcelRequire("4LmDH");
var $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK = 604800000;
function $c8390a6465ec9630$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $Ua0Sr.default)(date).getTime() - (0, $2HjQQ.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("Ua0Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8cff7ae633de9e$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $4LmDH = parcelRequire("4LmDH");
function $0a8cff7ae633de9e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $7yBDJ.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7yBDJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5808e7e2a5fbbc4c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("2HjQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6eff01db4e8676$export$2e2bcd8739ae039);

var $i0SQV = parcelRequire("i0SQV");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $1f6eff01db4e8676$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $i0SQV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $Ua0Sr.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("i0SQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d2c6aef0e5f696$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $d1d2c6aef0e5f696$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("4UeRq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3927eb6a31e1659f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3927eb6a31e1659f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("3LPyO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2bedc1b96ccf587f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2bedc1b96ccf587f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("knAHj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ed626c0821295496$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ed626c0821295496$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $gdr0J.default)(dirtyDate).getFullYear();
}

});

parcelRegister("2SwgK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2189a7e545f8ece8$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2189a7e545f8ece8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("d0W11", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $979847221b6d59d4$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $979847221b6d59d4$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = (0, $esGEx.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("6mdUF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a0f96fdddaa35da$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4a0f96fdddaa35da$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = (0, $esGEx.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("gpyWg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf2a1543848c0a73$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bf2a1543848c0a73$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = (0, $esGEx.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("cZ2kT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $973cfe686ae8d1d7$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cPszP = parcelRequire("cPszP");

var $4LmDH = parcelRequire("4LmDH");
function $973cfe686ae8d1d7$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = (0, $esGEx.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $cPszP.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("cPszP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95706a37c0d7d1b0$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("fVhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b979d7c80aa6a726$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cZ2kT = parcelRequire("cZ2kT");

var $4LmDH = parcelRequire("4LmDH");
function $b979d7c80aa6a726$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = (0, $esGEx.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $cZ2kT.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("3lKFD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2707890d0f47c3ba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2707890d0f47c3ba$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = (0, $esGEx.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("8v9st", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $63088e2bf3abfc06$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $63088e2bf3abfc06$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $63088e2bf3abfc06$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $63088e2bf3abfc06$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $63088e2bf3abfc06$var$_typeof(obj);
}
function $63088e2bf3abfc06$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if ($63088e2bf3abfc06$var$_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("6atcA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $47da542d3f4cabcc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $47da542d3f4cabcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $47da542d3f4cabcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $47da542d3f4cabcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $47da542d3f4cabcc$var$_typeof(obj);
}
function $47da542d3f4cabcc$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if ($47da542d3f4cabcc$var$_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("lm2ga", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f8bd67cac91ee19b$export$2e2bcd8739ae039);

var $9vfYB = parcelRequire("9vfYB");

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $cJfMa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $cJfMa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("cJfMa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("1Whvr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1698c992e2cb67cc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("e4h6L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3deb5b5de15b12f$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $9vfYB = parcelRequire("9vfYB");

var $4LmDH = parcelRequire("4LmDH");
var $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK = 604800000;
function $a3deb5b5de15b12f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var startOfWeekLeft = (0, $7yBDJ.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $7yBDJ.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $9vfYB.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $9vfYB.default)(startOfWeekRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("5E40x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41c3cc0836893904$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gVPZO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c53a4d8dd17910c2$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c53a4d8dd17910c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6eIgt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48a662f07bb27222$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var cleanDate = (0, $gdr0J.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6uyHy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ba07667a7282b10$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("75XN4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52a761315a8e3e9c$export$2e2bcd8739ae039);

var $2GvpZ = parcelRequire("2GvpZ");

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("gd5RE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bcd268c28ce3da9c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bcd268c28ce3da9c$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyLeftDate);
    var dateRight = (0, $gdr0J.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("hjw1k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c9ad0c9b51445ea3$export$2e2bcd8739ae039);

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfDay = (0, $cJfMa.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $cJfMa.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("b27pX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8085a298e92e1718$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("R4xmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09f87854553a6255$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("kggGd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec023d87d9d9e040$export$2e2bcd8739ae039);

var $gVPZO = parcelRequire("gVPZO");

var $4LmDH = parcelRequire("4LmDH");
function $ec023d87d9d9e040$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $gVPZO.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $gVPZO.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("4YTY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a082e1cb0a32433$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("gDwFN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c1c9a216d559c39d$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c1c9a216d559c39d$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $4LmDH.default)(2, arguments);
    var time = (0, $gdr0J.default)(dirtyDate).getTime();
    var startTime = (0, $gdr0J.default)(interval.start).getTime();
    var endTime = (0, $gdr0J.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("dpjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c2d1611e11d9224$export$2e2bcd8739ae039);

var $6Q3SV = parcelRequire("6Q3SV");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $4LmDH.default)(1, arguments);
    var additionalDigits = (0, $esGEx.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute));
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("hL3CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $ced9a37f3aaca250$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $ced9a37f3aaca250$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $ced9a37f3aaca250$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ced9a37f3aaca250$var$_setPrototypeOf(subClass, superClass);
}
function $ced9a37f3aaca250$var$_setPrototypeOf(o, p) {
    $ced9a37f3aaca250$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ced9a37f3aaca250$var$_setPrototypeOf(o, p);
}
function $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ced9a37f3aaca250$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $ced9a37f3aaca250$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $ced9a37f3aaca250$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $ced9a37f3aaca250$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $ced9a37f3aaca250$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $ced9a37f3aaca250$var$uid = $ced9a37f3aaca250$var$autoInc();
var $ced9a37f3aaca250$var$passiveEventSupport;
var $ced9a37f3aaca250$var$handlersMap = {};
var $ced9a37f3aaca250$var$enabledInstances = {};
var $ced9a37f3aaca250$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $ced9a37f3aaca250$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $ced9a37f3aaca250$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = $ced9a37f3aaca250$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $ced9a37f3aaca250$var$passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $ced9a37f3aaca250$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $ced9a37f3aaca250$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $1u0KT.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $ced9a37f3aaca250$var$enabledInstances[_this._uid]) return;
                if (typeof $ced9a37f3aaca250$var$passiveEventSupport === 'undefined') $ced9a37f3aaca250$var$passiveEventSupport = $ced9a37f3aaca250$var$testPassiveEventSupport();
                $ced9a37f3aaca250$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $ced9a37f3aaca250$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $ced9a37f3aaca250$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($ced9a37f3aaca250$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $ced9a37f3aaca250$var$handlersMap[_this._uid], $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $ced9a37f3aaca250$var$enabledInstances[_this._uid];
                var fn = $ced9a37f3aaca250$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $ced9a37f3aaca250$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $ced9a37f3aaca250$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $acw62.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $acw62.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $ced9a37f3aaca250$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $ced9a37f3aaca250$export$2e2bcd8739ae039 = $ced9a37f3aaca250$var$onClickOutsideHOC;

});

parcelRegister("7tYfQ", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("3cbhK")).Popper);
$parcel$export(module.exports, "Manager", () => (parcelRequire("8j0J5")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("6KgD0")).Reference);
$parcel$export(module.exports, "usePopper", () => (parcelRequire("KNTYF")).usePopper);
// Public components

var $3cbhK = parcelRequire("3cbhK");

var $8j0J5 = parcelRequire("8j0J5");

var $6KgD0 = parcelRequire("6KgD0");

var $KNTYF = parcelRequire("KNTYF");
 // Public types

});
parcelRegister("3cbhK", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $253b3f1d15d57500$export$badac9ada3a0bdf9);

var $acw62 = parcelRequire("acw62");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");

var $KNTYF = parcelRequire("KNTYF");
var $253b3f1d15d57500$var$NOOP = function NOOP() {
    return void 0;
};
var $253b3f1d15d57500$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $253b3f1d15d57500$var$EMPTY_MODIFIERS = [];
function $253b3f1d15d57500$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $253b3f1d15d57500$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $8j0J5.ManagerReferenceNodeContext));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $buXxn.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $KNTYF.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $253b3f1d15d57500$var$NOOP,
            update: update || $253b3f1d15d57500$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $buXxn.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("8j0J5", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $60c0a9468407f91d$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $60c0a9468407f91d$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $60c0a9468407f91d$export$d0d38e7dec7a1a61);

var $acw62 = parcelRequire("acw62");
var $60c0a9468407f91d$export$3dbd3405086fec7b = $acw62.createContext();
var $60c0a9468407f91d$export$cbabb21c2529b130 = $acw62.createContext();
function $60c0a9468407f91d$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($60c0a9468407f91d$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("buXxn", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $85f0adf197ea687e$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $85f0adf197ea687e$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $85f0adf197ea687e$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $85f0adf197ea687e$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $85f0adf197ea687e$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $85f0adf197ea687e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $85f0adf197ea687e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $85f0adf197ea687e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $85f0adf197ea687e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $85f0adf197ea687e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $85f0adf197ea687e$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("KNTYF", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $08cb017687258e89$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $eaBvN = parcelRequire("eaBvN");

var $buXxn = parcelRequire("buXxn");
var $08cb017687258e89$var$EMPTY_MODIFIERS = [];
var $08cb017687258e89$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $08cb017687258e89$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $buXxn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $buXxn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eaBvN)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $buXxn.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");


var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");




var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");

var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");

var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("eaBvN", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a50f18ef8c22d371$var$hasElementType = typeof Element !== 'undefined';
var $a50f18ef8c22d371$var$hasMap = typeof Map === 'function';
var $a50f18ef8c22d371$var$hasSet = typeof Set === 'function';
var $a50f18ef8c22d371$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a50f18ef8c22d371$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a50f18ef8c22d371$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a50f18ef8c22d371$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a50f18ef8c22d371$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a50f18ef8c22d371$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a50f18ef8c22d371$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a50f18ef8c22d371$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a50f18ef8c22d371$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $a50f18ef8c22d371$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("6KgD0", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $4e93effa1fe7e7cd$export$e0be378c32fb70a7);

var $acw62 = parcelRequire("acw62");

var $kg9aN = parcelRequire("kg9aN");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");
function $4e93effa1fe7e7cd$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $8j0J5.ManagerReferenceNodeSetterContext));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $buXxn.setRef)(innerRef, node);
        (0, $buXxn.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $buXxn.setRef)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $buXxn.unwrapArray)(children)({
        ref: refHandler
    });
}

});




parcelRegister("ctA1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $150328ddb054911e$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $bTSG2 = parcelRequire("bTSG2");
var $6IhJz = parcelRequire("6IhJz");
var $auRgN = parcelRequire("auRgN");
parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");

var $5GZlj = parcelRequire("5GZlj");
const $150328ddb054911e$var$TimeInput = (props)=>{
    const today = (0, $auRgN.default)("06:45am", (0, $ahLi9.formatTimeString), new Date());
    const options = Array.from({
        length: 96
    }, (_, i)=>i + 1).map((i)=>{
        const time = (0, $bTSG2.default)(new Date(today), i * 15);
        return {
            label: (0, $6IhJz.default)(time, (0, $ahLi9.formatTimeString)),
            value: (0, $6IhJz.default)(time, (0, $ahLi9.formatTimeString))
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w-32",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
            name: props.name,
            onChange: props.onChange,
            onBlur: props.onBlur,
            options: options,
            placeholder: props.placeholder
        })
    });
};
var $150328ddb054911e$export$2e2bcd8739ae039 = $150328ddb054911e$var$TimeInput;

});


parcelRegister("hnsNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a501931f954aa0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $f6a501931f954aa0$var$ToggleField = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        props.translationNamespace
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex rounded-md",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "#",
                    onClick: props.handlerA,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-col border-2 border-r-0 border-ch-blue-400 items-center rounded-l-md py-1 px-2 whitespace-nowrap", {
                        "bg-ch-blue-400": props.AActive,
                        "hover:bg-ch-blue-300": !props.AActive,
                        "bg-white": !props.AActive
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t(props.textAKey)
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "#",
                    onClick: props.handlerB,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-col border-2 border-l-0 border-ch-blue-400 items-center rounded-r-md py-1 px-2 whitespace-nowrap", {
                        "bg-ch-blue-400": !props.AActive,
                        "hover:bg-ch-blue-300": props.AActive,
                        "bg-white": props.AActive
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t(props.textBKey)
                    })
                })
            })
        ]
    });
};
var $f6a501931f954aa0$export$2e2bcd8739ae039 = $f6a501931f954aa0$var$ToggleField;

});

parcelRegister("4qU6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff2326f742e0fa4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $jdbjz = parcelRequire("jdbjz");

var $eKkKv = parcelRequire("eKkKv");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $6lvMC = parcelRequire("6lvMC");

var $ahLi9 = parcelRequire("ahLi9");

var $lqbsE = parcelRequire("lqbsE");

var $c0FI2 = parcelRequire("c0FI2");

var $d8Vwn = parcelRequire("d8Vwn");

var $5GZlj = parcelRequire("5GZlj");

var $jRidO = parcelRequire("jRidO");

var $ctA1Y = parcelRequire("ctA1Y");

var $1WoI7 = parcelRequire("1WoI7");

var $jTkGE = parcelRequire("jTkGE");

var $2vRvQ = parcelRequire("2vRvQ");

var $6wDTk = parcelRequire("6wDTk");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $7YFi7 = parcelRequire("7YFi7");
const $fff2326f742e0fa4$var$MdtMeetingNewFormContent = ()=>{
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllInternalActiveUsersSorted)(state));
    const keyedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(users, "id");
    const specialties = (0, $iD0SF.useSelector)((0, $lqbsE.getAllSpecialties));
    const teams = (0, $iD0SF.useSelector)((0, $jTkGE.getAllTeams));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting",
        "team"
    ]);
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [mdtTeamOptions, setMdtTeamOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [teamOptions, setTeamOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const { isSubmitting: isSubmitting, setFieldValue: setFieldValue, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur } = (0, $7YFi7.useFormikContext)();
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(keyedUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    (0, $acw62.useEffect)(()=>{
        const allTeams = Object.values(teams).filter((team)=>values.mdtTeamId != team.id);
        const options = (0, $d8Vwn.generateTeamOptions)(allTeams);
        setTeamOptions(options);
    }, [
        teams,
        values.mdtTeamId
    ]);
    (0, $acw62.useEffect)(()=>{
        const mdtTeams = Object.values(teams).filter((team)=>team.teamType == (0, $1WoI7.TeamTypes).mdt);
        const options = (0, $d8Vwn.generateTeamOptions)(mdtTeams);
        setMdtTeamOptions(options);
    }, [
        teams
    ]);
    (0, $acw62.useEffect)(()=>{
        const team = teams[values.mdtTeamId];
        if (!team) return;
        setFieldValue("name", team.name);
        setFieldValue("coordinator", team.owner);
        setFieldValue("specialtyId", team.specialtyId);
    }, [
        values.mdtTeamId
    ]);
    (0, $acw62.useEffect)(()=>{
        setFieldValue("meetingType", "mdt");
    }, []);
    const renderTeamsField = ()=>{
        if (Object.keys(teams).length == 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "users",
                    children: t("meeting:mdtMeeting:additionalTeams")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                    name: "teams",
                    options: teamOptions,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    isMulti: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: errors.users,
                    isVisible: errors.users && touched.users
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vRvQ.default), {
                    teamIds: values.teams,
                    header: t("meeting:teamUserListHeader")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "mdtTeamId",
                        required: true,
                        children: t("team:teamTypes:mdtTeam")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "mdtTeamId",
                        options: mdtTeamOptions,
                        onChange: handleChange,
                        onBlur: handleBlur
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.users,
                        isVisible: errors.users && touched.users
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2vRvQ.default), {
                        teamIds: values.mdtTeamId ? [
                            values.mdtTeamId
                        ] : [],
                        header: t("meeting:teamUserListHeader")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "name",
                        required: true,
                        children: t("meeting:title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "name",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.name,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.name,
                        isVisible: errors.name && touched.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "specialtyId",
                        required: true,
                        children: t("meeting:specialty")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "specialtyId",
                        options: specialtiesOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isGrouped: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.specialtyId,
                        isVisible: errors.specialtyId && touched.specialtyId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "coordinator",
                        required: true,
                        children: t("meeting:coordinator")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "coordinator",
                        options: userOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.coordinator,
                        isVisible: errors.coordinator && touched.coordinator
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "users",
                        children: t("meeting:mdtMeeting:additionalParticipants")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "users",
                        options: userOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isMulti: true,
                        closeMenuOnSelect: false,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.users,
                        isVisible: errors.users && touched.users
                    })
                ]
            }),
            renderTeamsField(),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "startDate",
                        required: true,
                        children: t("meeting:startDateAndTime")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex mr-4 mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                            name: "startDate"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lg:h-8 my-1 ml-7 sm:h-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.startDate,
                                                isVisible: errors.startDate && touched.startDate
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex space-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                            name: "startTime",
                                                            onChange: (e)=>{
                                                                if (!values.endTime) setFieldValue("endTime", (0, $ahLi9.addHour)(e.currentTarget.value, 1));
                                                                handleChange(e);
                                                            },
                                                            onBlur: handleBlur
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mx-2",
                                                            children: "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-8 my-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                        errorMessage: errors.startTime,
                                                        isVisible: errors.startTime && touched.startTime
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                            name: "endTime",
                                                            onChange: handleChange,
                                                            onBlur: handleBlur
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "self-center mx-1 flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdbjz.default), {
                                                                    className: "text-ch-blue-500 mx-2 w-5 h-5"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "self-center",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eKkKv.DurationLabel), {
                                                                        startTime: values.startTime,
                                                                        endTime: values.endTime
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h-8 my-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                        errorMessage: errors.endTime,
                                                        isVisible: errors.endTime && touched.endTime
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    isDisabled: isSubmitting,
                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                    isSubmit: true,
                    children: t("createMeeting")
                })
            })
        ]
    });
};
var $fff2326f742e0fa4$export$2e2bcd8739ae039 = $fff2326f742e0fa4$var$MdtMeetingNewFormContent;

});

parcelRegister("fKaTC", function(module, exports) {

$parcel$export(module.exports, "getTenantConfig", () => $78b0e46e1666e27c$export$d6c5b4c19ef17882);
const $78b0e46e1666e27c$export$d6c5b4c19ef17882 = (state)=>{
    return state.tenantConfig;
};

});



parcelRegister("eYI5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1386b5a7bbe0d23$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4fo4Z = parcelRequire("4fo4Z");

var $8UrgM = parcelRequire("8UrgM");

var $6QJY8 = parcelRequire("6QJY8");

var $kmZNW = parcelRequire("kmZNW");

var $d5eYa = parcelRequire("d5eYa");

var $4VtCQ = parcelRequire("4VtCQ");

var $4Z6GL = parcelRequire("4Z6GL");
const $b1386b5a7bbe0d23$var$MeetingEditPage = ()=>{
    const { meetingId: meetingId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: meetingId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchSpecialties = ()=>dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const fetchMeeting = (meetingId)=>dispatch((0, $4Z6GL.fetchMeetingAction)(meetingId));
    (0, $acw62.useEffect)(()=>{
        fetchSpecialties();
        fetchUsers();
        fetchMeeting(meetingId);
    }, []);
    const viewMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: meetingId
    });
    const renderContent = ()=>{
        if (!meeting) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("meeting:meetingNotFound")
        });
        if (!meeting.permissions.canEdit) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kmZNW.default), {
            meetingId: meetingId
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:meeting"),
                        href: viewMeetingUrl
                    },
                    {
                        pageTitle: t("meeting:editMeeting")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $b1386b5a7bbe0d23$export$2e2bcd8739ae039 = $b1386b5a7bbe0d23$var$MeetingEditPage;

});
parcelRegister("kmZNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $282f66e3fd86a3c5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $6IhJz = parcelRequire("6IhJz");
var $2sgOd = parcelRequire("2sgOd");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $jdbjz = parcelRequire("jdbjz");

var $eKkKv = parcelRequire("eKkKv");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $6lvMC = parcelRequire("6lvMC");

var $4Z6GL = parcelRequire("4Z6GL");

var $ahLi9 = parcelRequire("ahLi9");

var $lqbsE = parcelRequire("lqbsE");

var $ckrEF = parcelRequire("ckrEF");

var $c0FI2 = parcelRequire("c0FI2");

var $1Lj4p = parcelRequire("1Lj4p");

var $4VtCQ = parcelRequire("4VtCQ");

var $kN4w7 = parcelRequire("kN4w7");

var $d8Vwn = parcelRequire("d8Vwn");

var $5GZlj = parcelRequire("5GZlj");

var $jRidO = parcelRequire("jRidO");

var $ctA1Y = parcelRequire("ctA1Y");

var $6wDTk = parcelRequire("6wDTk");

var $4qaeN = parcelRequire("4qaeN");
const $282f66e3fd86a3c5$var$MeetingEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state));
    const specialties = (0, $iD0SF.useSelector)((state)=>(0, $lqbsE.getAllSpecialties)(state));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const coordinator = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getMeetingCoordinator)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const meetingStartDate = (0, $ahLi9.utcDateToZonedTime)(meeting.startDate, timezone);
    const meetingEndDate = (0, $ahLi9.utcDateToZonedTime)(meeting.endDate, timezone);
    const initialValues = {
        name: meeting.name,
        specialtyId: meeting.specialtyId,
        coordinator: coordinator.id,
        users: meeting.users.filter((id)=>coordinator.id !== id),
        startDate: new Date(meetingStartDate),
        startTime: (0, $6IhJz.default)(new Date(meetingStartDate), (0, $ahLi9.formatTimeString)),
        endTime: (0, $6IhJz.default)(new Date(meetingEndDate), (0, $ahLi9.formatTimeString))
    };
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(users));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $ckrEF.meetingNewValidationSchema)(timezone),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const dates = (0, $ahLi9.startEndDates)(values.startDate, values.startTime, values.endTime, timezone);
                values = (0, $ckrEF.meetingNewValidationSchema)(timezone).cast(values);
                const data = {
                    name: values.name,
                    specialtyId: values.specialtyId,
                    startDate: (0, $2sgOd.default)(dates.start),
                    endDate: (0, $2sgOd.default)(dates.end),
                    coordinatorId: values.coordinator,
                    userIds: meeting.users
                };
                dispatch((0, $4Z6GL.updateMeetingAction)(props.meetingId, data));
                setSubmitting(false);
            },
            children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "name",
                                    required: true,
                                    children: t("meeting:title")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "name",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.name,
                                    autoComplete: "off",
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.name,
                                    isVisible: errors.name && touched.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "specialtyId",
                                    required: true,
                                    children: t("meeting:specialty")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "specialtyId",
                                    options: specialtiesOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    isGrouped: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.specialtyId,
                                    isVisible: errors.specialtyId && touched.specialtyId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "coordinator",
                                    required: true,
                                    children: t("meeting:coordinator")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "coordinator",
                                    options: userOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.coordinator,
                                    isVisible: errors.coordinator && touched.coordinator
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "startDate",
                                    required: true,
                                    children: t("meeting:startDateAndTime")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex mr-4 mb-1",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                                        name: "startDate"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lg:h-8 my-1 ml-7 sm:h-0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                            errorMessage: errors.startDate,
                                                            isVisible: errors.startDate && touched.startDate
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex space-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex flex-row items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                                        name: "startTime",
                                                                        onChange: handleChange,
                                                                        onBlur: handleBlur
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "mx-2",
                                                                        children: "-"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "h-8 my-1",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                                    errorMessage: errors.startTime,
                                                                    isVisible: errors.startTime && touched.startTime
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex flex-row items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                                        name: "endTime",
                                                                        onChange: handleChange,
                                                                        onBlur: handleBlur
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "self-center mx-1 flex",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdbjz.default), {
                                                                                className: "text-ch-blue-500 mx-2 w-5 h-5"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "self-center",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eKkKv.DurationLabel), {
                                                                                    startTime: values.startTime,
                                                                                    endTime: values.endTime
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "h-8 my-1",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                                    errorMessage: errors.endTime,
                                                                    isVisible: errors.endTime && touched.endTime
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: !dirty || isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("updateMeeting")
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $282f66e3fd86a3c5$export$2e2bcd8739ae039 = $282f66e3fd86a3c5$var$MeetingEditForm;

});


parcelRegister("2wnYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $813620f4c1f3a0c0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8UrgM = parcelRequire("8UrgM");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $dQtfu = parcelRequire("dQtfu");

var $6QJY8 = parcelRequire("6QJY8");

var $kQILj = parcelRequire("kQILj");

var $6lvMC = parcelRequire("6lvMC");

var $4LWrD = parcelRequire("4LWrD");

var $aDFyu = parcelRequire("aDFyu");

var $1kXfn = parcelRequire("1kXfn");

var $39EfS = parcelRequire("39EfS");

var $kVlM3 = parcelRequire("kVlM3");

var $glc4D = parcelRequire("glc4D");

var $c0X5y = parcelRequire("c0X5y");

var $fKaTC = parcelRequire("fKaTC");
const $813620f4c1f3a0c0$var$UsersPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getUsersUI)(state));
    const { guestUsersEnabled: guestUsersEnabled } = (0, $iD0SF.useSelector)((0, $fKaTC.getTenantConfig));
    const initialSearchQuery = {
        page: 1,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy,
        appliedFilters: UI.appliedFilters
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $8UrgM.fetchUsersAsync));
    const guestUserButton = ()=>{
        if (!guestUsersEnabled) return null;
        return (0, $aDFyu.TitleButtonFactory)((0, $6QJY8.RoutePaths).USER_NEW_GUEST, t("user:addANewGuestUser"), 2);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:users"),
                buttonText: currentUser.abilities?.user.canCreate ? t("user:addANewUser") : "",
                buttonHref: (0, $6QJY8.RoutePaths).USER_NEW,
                hasButtonPermission: currentUser.abilities?.user.canCreate,
                secondaryButton: guestUserButton()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-start-2 md:row-start-1 self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "user:searchBy",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-end-2 md:row-start-1 flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("user:searchUser")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-2",
                children: [
                    UI.totalUsersCount,
                    " ",
                    t("shared:users")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0X5y.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            orderByOptions: (0, $4LWrD.UserOrderByOptions),
                            useTranslation: "user"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dQtfu.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalUsersCount,
                totalPages: UI.totalPages
            })
        ]
    });
};
var $813620f4c1f3a0c0$export$2e2bcd8739ae039 = $813620f4c1f3a0c0$var$UsersPage;

});
parcelRegister("dQtfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc79492bf88771ec$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $9k8Fh = parcelRequire("9k8Fh");

var $6lvMC = parcelRequire("6lvMC");
const $fc79492bf88771ec$var$UserList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const userIds = (0, $iD0SF.useSelector)((0, $6lvMC.getAllUserIds));
    if (!userIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("user:noUsers")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: userIds.map((userId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9k8Fh.default), {
                userId: userId
            }, userId);
        })
    });
};
var $fc79492bf88771ec$export$2e2bcd8739ae039 = $fc79492bf88771ec$var$UserList;

});

parcelRegister("c0X5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4262b507a85d25$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $3c4262b507a85d25$var$UserFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        resetFilters();
        props.setSearchQuery({
            appliedFilters: [
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("active"),
                    action: ()=>{
                        updateFilters("active");
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "uppercase",
                        children: t("user:active")
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("pending"),
                    action: ()=>{
                        updateFilters("pending");
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "uppercase",
                        children: t("user:pending")
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("inactive"),
                    action: ()=>{
                        updateFilters("inactive");
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "uppercase",
                        children: t("user:inActive")
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("guest"),
                    action: ()=>{
                        updateFilters("guest");
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "uppercase",
                        children: t("user:guest")
                    })
                })
            })
        ]
    });
};
var $3c4262b507a85d25$export$2e2bcd8739ae039 = $3c4262b507a85d25$var$UserFilter;

});


parcelRegister("d8ZmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22b5548fee875f9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $cOo5I = parcelRequire("cOo5I");

var $kvY2o = parcelRequire("kvY2o");

var $4fo4Z = parcelRequire("4fo4Z");

var $d5eYa = parcelRequire("d5eYa");

var $ai857 = parcelRequire("ai857");

var $6lvMC = parcelRequire("6lvMC");

var $9RwYc = parcelRequire("9RwYc");

var $4vOrS = parcelRequire("4vOrS");

var $8UrgM = parcelRequire("8UrgM");

var $4qaeN = parcelRequire("4qaeN");

var $cOtzh = parcelRequire("cOtzh");

var $iOv3Y = parcelRequire("iOv3Y");

var $i4wYI = parcelRequire("i4wYI");

var $7qa36 = parcelRequire("7qa36");

var $iYbS1 = parcelRequire("iYbS1");
const $a22b5548fee875f9$var$UserEditPage = ()=>{
    const { userId: userId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, userId));
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const currentUserId = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUserId)(state));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
        dispatch((0, $ai857.fetchUserAction)(userId));
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        if (!(userId == currentUserId)) dispatch((0, $ai857.fetchUserAction)(currentUserId));
    }, []);
    const renderUserEditForm = ()=>{
        if (!userId || !currentUser) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("userMessage:userNotFound")
        });
        if (userId !== currentUser.id && !user?.permissions?.canManage) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvY2o.default), {
            userId: userId
        });
    };
    const renderUserPasswordEditForm = ()=>{
        if (userId === currentUser?.id || user?.permissions?.canManage) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4vOrS.default), {
            userId: userId
        });
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cOo5I.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                        breadcrumbs: [
                            {
                                pageTitle: t("shared:users"),
                                href: (0, $6QJY8.RoutePaths).USERS
                            },
                            {
                                pageTitle: t("user:editUser")
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOtzh.default), {
                        hasPermission: user?.permissions?.canTrackChanges,
                        action: ()=>{
                            dispatch((0, $iOv3Y.fetchAuditEventsAsync)("User", userId));
                            dispatch((0, $i4wYI.toggleIsQuickViewOpen)(userId, true));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                children: [
                    renderUserEditForm(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RwYc.default), {
                        userId: userId
                    }),
                    renderUserPasswordEditForm(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iYbS1.default), {
                            userId: userId
                        })
                    })
                ]
            })
        ]
    });
};
var $a22b5548fee875f9$export$2e2bcd8739ae039 = $a22b5548fee875f9$var$UserEditPage;

});
parcelRegister("cOo5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8363c209693bc1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4iLDL = parcelRequire("4iLDL");

var $1UW1Y = parcelRequire("1UW1Y");

var $kQILj = parcelRequire("kQILj");

var $7Bj8I = parcelRequire("7Bj8I");

var $2MEcG = parcelRequire("2MEcG");

var $jpvkd = parcelRequire("jpvkd");

var $bjGFW = parcelRequire("bjGFW");

var $kYqkq = parcelRequire("kYqkq");

var $8dfeH = parcelRequire("8dfeH");
const $7a8363c209693bc1$var$AppLayout = (props)=>{
    const scrollUIState = (0, $kYqkq.useAppSelector)((0, $kQILj.getScrollUI));
    const mainScrollToPosition = scrollUIState?.mainScrollToPosition;
    const scrollElementRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $2OPjR.useDispatch)();
    const resetScrollPosition = ()=>dispatch((0, $2MEcG.scrollUpdatePosition)((0, $7Bj8I.ScrollActionTypes).UPDATE_MAIN_SCROLL_TO_POSITION, null));
    const [showHelpModal, setShowHelpModal] = (0, $acw62.useState)(false);
    const openHelpModal = ()=>setShowHelpModal(true);
    (0, $acw62.useEffect)(()=>{
        scrollElementRef.current.scrollTo({
            top: mainScrollToPosition,
            behavior: "smooth"
        });
        resetScrollPosition();
    }, [
        mainScrollToPosition
    ]);
    const defaultClasses = "bg-ch-blue-alt-200 h-screen flex flex-col overflow-hidden relative";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjGFW.ErrorBoundary), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: defaultClasses,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8dfeH.default), {
                    open: showHelpModal,
                    setOpen: setShowHelpModal
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4iLDL.default), {
                    openHelpModal: openHelpModal
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jpvkd.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-1 overflow-hidden relative",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1UW1Y.default), {
                            openHelpModal: openHelpModal
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: scrollElementRef,
                            className: "w-full h-full p-3 md:pb-12 overflow-y-scroll",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjGFW.ErrorBoundary), {
                                children: props.children
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $7a8363c209693bc1$export$2e2bcd8739ae039 = $7a8363c209693bc1$var$AppLayout;

});
parcelRegister("4iLDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $98847e939a1f9a23$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fR7LI = parcelRequire("fR7LI");

var $bp1AQ = parcelRequire("bp1AQ");

var $aeos3 = parcelRequire("aeos3");

var $adP1p = parcelRequire("adP1p");

var $fIZpD = parcelRequire("fIZpD");

var $cQAM9 = parcelRequire("cQAM9");
const $98847e939a1f9a23$var$Header = (props)=>{
    const { tenantName: tenantName } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const renderTenantName = ()=>{
        if (!tenantName) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            className: "text-ch-gray-600 uppercase mr-2",
            children: tenantName
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "px-5 pt-2 pb-2 bg-white shadow relative z-40",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-between items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center p-1 justify-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adP1p.default), {
                            className: "h-10 mr-2"
                        }),
                        renderTenantName(),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIZpD.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "block md:hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fR7LI.default), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "hidden md:flex space-x-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cQAM9.default), {
                            action: props.openHelpModal
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bp1AQ.default), {})
                    ]
                })
            ]
        })
    });
};
var $98847e939a1f9a23$export$2e2bcd8739ae039 = $98847e939a1f9a23$var$Header;

});
parcelRegister("fR7LI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11c57d17b3dcbf4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $i4wYI = parcelRequire("i4wYI");
parcelRequire("jitSV");
var $2XYVX = parcelRequire("2XYVX");

var $kQILj = parcelRequire("kQILj");
const $d11c57d17b3dcbf4$var$MenuButton = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const isMenuOpen = (0, $iD0SF.useSelector)((0, $kQILj.getIsMenuOpen));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onToggleMenuIsOpen = (isMenuOpen)=>{
        dispatch((0, $i4wYI.toggleIsMenuOpen)(isMenuOpen));
    };
    if (isMenuOpen) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: "#",
        className: "flex flex-col items-center text-ch-gray-600 transform transition-transform duration-300 rotate-90",
        onClick: ()=>onToggleMenuIsOpen(false),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2XYVX.default), {
            className: "fill-current w-6 h-6",
            title: t("shared:closeMenu")
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: "#",
        className: "flex flex-col items-center text-ch-gray-600 transform transition-transform duration-300",
        onClick: ()=>onToggleMenuIsOpen(true),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2XYVX.default), {
            className: "fill-current w-6 h-6",
            title: t("shared:openMenu")
        })
    });
};
var $d11c57d17b3dcbf4$export$2e2bcd8739ae039 = $d11c57d17b3dcbf4$var$MenuButton;

});

parcelRegister("bp1AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2df05e45602ffb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4KSAX = parcelRequire("4KSAX");

var $1l1FS = parcelRequire("1l1FS");

var $6QJY8 = parcelRequire("6QJY8");

var $2ywbu = parcelRequire("2ywbu");
parcelRequire("jitSV");
var $77EBI = parcelRequire("77EBI");

var $1K7iS = parcelRequire("1K7iS");

var $5YAlZ = parcelRequire("5YAlZ");

var $lE7JJ = parcelRequire("lE7JJ");
const $ce2df05e45602ffb$var$SignOutButton = (props)=>{
    const { signedIn: signedIn } = (0, $lE7JJ.default)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const onClickSignOut = ()=>{
        dispatch((0, $5YAlZ.signOutUserAction)());
        (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SIGN_IN);
    };
    const renderMenuButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
            action: onClickSignOut,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77EBI.default), {
                    className: "w-6 h-6 mr-3"
                }),
                " ",
                t("shared:signout")
            ]
        });
    };
    const renderNormalButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
            action: onClickSignOut,
            noPaddingY: true,
            className: "normal-case ml-8",
            variant: "ch-gray-alt",
            children: [
                t("shared:signout"),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77EBI.default), {
                    className: "w-6 h-6 ml-2",
                    title: t("shared:signout")
                })
            ]
        });
    };
    if (!signedIn) return null;
    return props.isMenuLink ? renderMenuButton() : renderNormalButton();
};
var $ce2df05e45602ffb$export$2e2bcd8739ae039 = $ce2df05e45602ffb$var$SignOutButton;

});
parcelRegister("1K7iS", function(module, exports) {

$parcel$export(module.exports, "default", () => $026ca3c7f7edbe77$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $COwA0 = parcelRequire("COwA0");

var $i4wYI = parcelRequire("i4wYI");

var $kYqkq = parcelRequire("kYqkq");
const $026ca3c7f7edbe77$var$MenuLink = (props)=>{
    const location = (0, $COwA0.useLocation)();
    const isSelected = props.to === location.pathname;
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const clickHandler = ()=>dispatch((0, $i4wYI.toggleIsMenuOpen)(false));
    const defaultClasses = [
        "py-3",
        "px-4",
        "rounded-md",
        "flex",
        "w-full"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    const allClassesWithConditions = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(allClasses, {
        "text-ch-gray-500": !isSelected,
        "text-white": isSelected,
        "bg-ch-blue-700": isSelected,
        "hover:bg-ch-blue-700": !isSelected,
        "hover:text-white": !isSelected
    });
    if (props.action) return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        onClick: ()=>{
            if (props.onClickLink) props.onClickLink();
            props.action();
        },
        className: allClassesWithConditions,
        children: props.children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.Link), {
        to: props.to,
        className: allClassesWithConditions,
        onClick: clickHandler,
        children: props.children
    });
};
var $026ca3c7f7edbe77$export$2e2bcd8739ae039 = $026ca3c7f7edbe77$var$MenuLink;

});

parcelRegister("lE7JJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c753a906a94d9c0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $kYqkq = parcelRequire("kYqkq");

var $jSDfI = parcelRequire("jSDfI");
const $5c753a906a94d9c0$var$useSignInStatus = ()=>{
    const apiToken = (0, $kYqkq.useAppSelector)((state)=>state.userSession.apiToken);
    const { oauthIdToken: oauthIdToken } = (0, $jSDfI.getSession)();
    const [signedIn, setSignedIn] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setSignedIn(apiToken && apiToken.length > 0 || oauthIdToken && oauthIdToken.length > 0);
    }, [
        apiToken,
        oauthIdToken
    ]);
    return {
        apiToken: apiToken,
        oauthIdToken: oauthIdToken,
        signedIn: signedIn
    };
};
var $5c753a906a94d9c0$export$2e2bcd8739ae039 = $5c753a906a94d9c0$var$useSignInStatus;

});


parcelRegister("fIZpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bf3ae1fb7df4be$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $2ywbu = parcelRequire("2ywbu");
parcelRequire("jitSV");
var $jcQWI = parcelRequire("jcQWI");

var $fukkK = parcelRequire("fukkK");

var $f52QH = parcelRequire("f52QH");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $ai857 = parcelRequire("ai857");

var $55Oux = parcelRequire("55Oux");
const $64bf3ae1fb7df4be$var$SwitchTenantButton = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "tenant"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const [isModalOpen, setIsModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { tenantId: queryTenantId, resetQuery: resetQuery } = (0, $acw62.useContext)((0, $f52QH.QueryStringContext));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { totalTenantCount: totalTenantCount } = (0, $acw62.useContext)((0, $55Oux.ExternalUsersContext));
    const closeModal = ()=>setIsModalOpen(false);
    const openModal = ()=>setIsModalOpen(true);
    (0, $acw62.useEffect)(()=>{
        // when tenantId is passed in query string - switch tenant
        if (currentUser.id && queryTenantId && currentUser.currentTenantId !== queryTenantId) {
            dispatch((0, $ai857.setTenantAction)(queryTenantId));
            resetQuery();
        }
    }, [
        queryTenantId,
        currentUser.id
    ]);
    const renderSwitchTenantButton = ()=>{
        if (totalTenantCount < 2 && !currentUser.abilities?.tenant.canCreate) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
            action: openModal,
            className: "normal-case",
            variant: "ch-gray-alt",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jcQWI.default), {
                    className: "w-6 h-6 mr-3"
                }),
                " ",
                t("tenant:switchTenant")
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            renderSwitchTenantButton(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fukkK.default), {
                isOpen: isModalOpen,
                closeModal: closeModal
            })
        ]
    });
};
var $64bf3ae1fb7df4be$export$2e2bcd8739ae039 = $64bf3ae1fb7df4be$var$SwitchTenantButton;

});
parcelRegister("fukkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b9fded4f2d516f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $b5weT = parcelRequire("b5weT");

var $8GeLj = parcelRequire("8GeLj");

var $cBsn6 = parcelRequire("cBsn6");

var $lEyNr = parcelRequire("lEyNr");
const $e4b9fded4f2d516f$var$SwitchTenantModal = (props)=>{
    const [isCreateTenantOpen, setIsCreateTenantOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lEyNr.default), {
                    isCreateTenantOpen: isCreateTenantOpen,
                    setIsCreateTenantOpen: setIsCreateTenantOpen
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cBsn6.default), {
                    isVisible: isCreateTenantOpen,
                    closeAction: ()=>setIsCreateTenantOpen(false)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8GeLj.default), {
                    isVisible: !isCreateTenantOpen,
                    closeModal: props.closeModal
                })
            ]
        })
    });
};
var $e4b9fded4f2d516f$export$2e2bcd8739ae039 = $e4b9fded4f2d516f$var$SwitchTenantModal;

});
parcelRegister("8GeLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2cda3d56b14cb1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4KSAX = parcelRequire("4KSAX");

var $ai857 = parcelRequire("ai857");

var $n9kQG = parcelRequire("n9kQG");

var $jcQWI = parcelRequire("jcQWI");

var $55Oux = parcelRequire("55Oux");
const $6d2cda3d56b14cb1$var$SwitchTenantList = (props)=>{
    if (!props.isVisible) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "tenant"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { fetchExternalUsers: fetchExternalUsers, groupedExternalUsers: groupedExternalUsers } = (0, $acw62.useContext)((0, $55Oux.ExternalUsersContext));
    const setTenant = (id)=>{
        dispatch((0, $ai857.setTenantAction)(id));
        props.closeModal();
    };
    (0, $acw62.useEffect)(()=>{
        fetchExternalUsers();
    }, []);
    const renderTenantListGroup = (email)=>{
        const externalUsersGroup = groupedExternalUsers[email];
        return externalUsersGroup.map((externalUser, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $n9kQG.default), {
                externalUser: externalUser,
                setTenant: setTenant
            }, `externalUser.id-${index}`));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex flex-row items-center justify-center mb-2 font-semibold",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jcQWI.default), {
                            className: "w-6 h-6 mr-3"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: t("tenant:switchTenant")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: Object.keys(groupedExternalUsers).map((email)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-ch-blue-500 mb-2",
                                children: email
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb-4",
                                children: renderTenantListGroup(email)
                            })
                        ]
                    }, email))
            })
        ]
    });
};
var $6d2cda3d56b14cb1$export$2e2bcd8739ae039 = $6d2cda3d56b14cb1$var$SwitchTenantList;

});
parcelRegister("n9kQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeec0bbe694f1347$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $49YD1 = parcelRequire("49YD1");
const $eeec0bbe694f1347$var$SwitchTenantListGroup = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: props.externalUser.tenants.map((tenant)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49YD1.default), {
                tenant: tenant,
                setTenant: props.setTenant,
                location: props.externalUser.location,
                email: props.externalUser.email
            }, tenant.id))
    });
};
var $eeec0bbe694f1347$export$2e2bcd8739ae039 = $eeec0bbe694f1347$var$SwitchTenantListGroup;

});
parcelRegister("49YD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c55ad0c51d087f2a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $4qaeN = parcelRequire("4qaeN");

var $kYqkq = parcelRequire("kYqkq");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $8xwyy = parcelRequire("8xwyy");

var $5ofNJ = parcelRequire("5ofNJ");
const $c55ad0c51d087f2a$var$SwitchTenantListItem = (props)=>{
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "tenant"
    ]);
    const goToTenant = ()=>{
        if (window.location.origin == props.location) {
            props.setTenant(props.tenant.id);
            return;
        }
        const query = (0, $5ofNJ.default).stringify({
            tenantId: props.tenant.id,
            email: props.email
        });
        window.location.href = `${props.location}/signin?${query}`;
    };
    const renderButton = ()=>{
        if (currentUser.currentTenantId == props.tenant.id && currentUser.email == props.email && window.location.origin == props.location) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: t("tenant:currentTenant")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            action: goToTenant,
            children: t("tenant:selectTenant")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
            className: "flex-col",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8xwyy.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:case")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "mr-4 mb-2 text-lg font-semibold text-ch-blue-500",
                                        children: props.tenant.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-ch-gray-500",
                                        children: props.location
                                    })
                                ]
                            })
                        ]
                    }),
                    renderButton()
                ]
            })
        })
    }, props.tenant.id);
};
var $c55ad0c51d087f2a$export$2e2bcd8739ae039 = $c55ad0c51d087f2a$var$SwitchTenantListItem;

});



parcelRegister("cBsn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e335cc77717db7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $drVBX = parcelRequire("drVBX");

var $6WA0P = parcelRequire("6WA0P");
const $22e335cc77717db7$var$CreateTenantForm = (props)=>{
    if (!props.isVisible) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const user = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!user.abilities?.tenant.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("shared:notPermitted")
    });
    const dispatch = (0, $2OPjR.useDispatch)();
    const createTenant = (tenant)=>dispatch((0, $drVBX.createTenantAsync)(tenant));
    const initialValues = {
        name: ""
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "mb-2 font-semibold",
                children: t("tenant:newTenant")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $6WA0P.tenantNewValidationSchema),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createTenant(values);
                    setSubmitting(false);
                    props.closeAction();
                },
                children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "name",
                                        required: true,
                                        children: t("tenant:details:name")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "name",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.name,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.name,
                                        isVisible: errors.name && touched.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("tenant:buttons:createTenant")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $22e335cc77717db7$export$2e2bcd8739ae039 = $22e335cc77717db7$var$CreateTenantForm;

});
parcelRegister("drVBX", function(module, exports) {

$parcel$export(module.exports, "createTenantAsync", () => $443c693f73707672$export$d9840ef7149703d1);

var $i78re = parcelRequire("i78re");
const $443c693f73707672$export$d9840ef7149703d1 = (tenant)=>{
    return {
        type: (0, $i78re.TenantActionTypes).CREATE_TENANT_ASYNC_PENDING,
        payload: {
            tenant: tenant
        }
    };
};

});

parcelRegister("6WA0P", function(module, exports) {

$parcel$export(module.exports, "tenantNewValidationSchema", () => $7b0d4cccb6d001f0$export$48bc9489942e8177);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $7b0d4cccb6d001f0$export$48bc9489942e8177 = ()=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
    });
};

});


parcelRegister("lEyNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $53aeaa9138423198$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("cIYPX");
var $frTKF = parcelRequire("frTKF");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");
const $53aeaa9138423198$var$SwitchTenantHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "tenant"
    ]);
    const abilities = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUserAbilities));
    const renderCreateTenantButton = ()=>{
        if (props.isCreateTenantOpen || !abilities?.tenant.canCreate) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            className: "absolute right-0",
            action: ()=>{
                props.setIsCreateTenantOpen(true);
            },
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("tenant:buttons:addNewTenant")
        }, "1");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex justify-center items-center mb-5 relative",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $frTKF.default), {
                    className: "h-8"
                }),
                renderCreateTenantButton()
            ]
        })
    });
};
var $53aeaa9138423198$export$2e2bcd8739ae039 = $53aeaa9138423198$var$SwitchTenantHeader;

});




parcelRegister("1UW1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $57add22af08911fc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $32FCn = parcelRequire("32FCn");

var $1K7iS = parcelRequire("1K7iS");

var $6QJY8 = parcelRequire("6QJY8");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");
var $18j2c = parcelRequire("18j2c");
var $5AYDs = parcelRequire("5AYDs");
var $bbiXR = parcelRequire("bbiXR");
var $k6suX = parcelRequire("k6suX");
var $eEYoR = parcelRequire("eEYoR");
var $hSnpV = parcelRequire("hSnpV");
var $dIfKX = parcelRequire("dIfKX");
var $4fat5 = parcelRequire("4fat5");
var $chRXN = parcelRequire("chRXN");
var $ft8ez = parcelRequire("ft8ez");

var $6MIVx = parcelRequire("6MIVx");

var $fsUlg = parcelRequire("fsUlg");

var $bp1AQ = parcelRequire("bp1AQ");

var $kQILj = parcelRequire("kQILj");

var $6lvMC = parcelRequire("6lvMC");

var $hLZlk = parcelRequire("hLZlk");

var $aeos3 = parcelRequire("aeos3");

var $cQAM9 = parcelRequire("cQAM9");

var $cA1jy = parcelRequire("cA1jy");
const $57add22af08911fc$var$Menu = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { messagingEnabled: messagingEnabled, pathwaysEnabled: pathwaysEnabled, analyticsEnabled: analyticsEnabled, radiologyEnabled: radiologyEnabled, hideMenuItemUsers: hideMenuItemUsers } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const notificationUIState = (0, $iD0SF.useSelector)((0, $kQILj.getNotificationsUI));
    const taskUIState = (0, $iD0SF.useSelector)((0, $kQILj.getTasksUI));
    const messagesUIState = (0, $iD0SF.useSelector)((0, $kQILj.getChatMessagesUI));
    const isMenuOpen = (0, $iD0SF.useSelector)((0, $kQILj.getIsMenuOpen));
    const notificationsUnreadCount = notificationUIState?.unreadCount;
    const tasksOutstandingCount = taskUIState?.outstandingCount;
    const messagesUnreadCount = messagesUIState.unreadCount;
    const renderAdminLink = ()=>{
        if (!(0, $cA1jy.isAdmin)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).ADMIN,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chRXN.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:admin")
                ]
            })
        });
    };
    const renderAnalyticsLink = ()=>{
        if (!(0, $cA1jy.isAdmin)(currentUser) || !analyticsEnabled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).ANALYTICS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MIVx.default), {
                        width: 20,
                        height: 20,
                        className: "mr-3",
                        fill: "currentColor"
                    }),
                    " ",
                    t("shared:analytics")
                ]
            })
        });
    };
    const renderMeetingsLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).MEETINGS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:meetings")
                ]
            })
        });
    };
    const renderPathwaysLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser) || !pathwaysEnabled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).PATHWAYS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:pathways")
                ]
            })
        });
    };
    const renderUsersLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser) || hideMenuItemUsers && !currentUser.abilities?.user?.canList) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).USERS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ft8ez.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:users")
                ]
            })
        });
    };
    const renderRadiologyLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser) || !radiologyEnabled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).RADIOLOGY,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hSnpV.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:radiology")
                ]
            })
        });
    };
    const renderTeamsLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).TEAMS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                        className: "w-6 h-6 mr-3"
                    }),
                    " ",
                    t("shared:teams")
                ]
            })
        });
    };
    const renderMessagesLink = ()=>{
        if (!messagingEnabled) return null;
        if ((0, $cA1jy.isGuest)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).MESSAGES,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative mr-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLZlk.default), {
                                count: messagesUnreadCount
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                                className: "w-6 h-6"
                            })
                        ]
                    }),
                    t("shared:messages")
                ]
            })
        });
    };
    const renderTasksLink = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                to: (0, $6QJY8.RoutePaths).TASKS,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative mr-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLZlk.default), {
                                count: tasksOutstandingCount
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                                className: "w-6 h-6"
                            })
                        ]
                    }),
                    t("shared:tasks")
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-col py-8 px-3 bg-ch-blue-800 shadow h-full w-full overflow-y-scroll absolute z-20 sm:static", "sm:w-64", {
            "hidden": !isMenuOpen,
            "sm:flex": !isMenuOpen,
            "flex": isMenuOpen
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center md:hidden mb-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fsUlg.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32FCn.default), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                            to: (0, $6QJY8.RoutePaths).NOTIFICATIONS,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "relative mr-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLZlk.default), {
                                            count: notificationsUnreadCount
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbiXR.default), {
                                            className: "w-6 h-6"
                                        })
                                    ]
                                }),
                                t("shared:notifications")
                            ]
                        })
                    }),
                    renderMeetingsLink(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                            to: (0, $6QJY8.RoutePaths).CASES,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                    className: "w-6 h-6 mr-3"
                                }),
                                " ",
                                t("shared:cases")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1K7iS.default), {
                            to: (0, $6QJY8.RoutePaths).PATIENTS,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                                    className: "w-6 h-6 mr-3"
                                }),
                                " ",
                                t("shared:patients")
                            ]
                        })
                    }),
                    renderRadiologyLink(),
                    renderMessagesLink(),
                    renderTasksLink(),
                    renderPathwaysLink(),
                    renderUsersLink(),
                    renderTeamsLink(),
                    renderAnalyticsLink(),
                    renderAdminLink(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "mb-2 md:hidden",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bp1AQ.default), {
                            isMenuLink: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cQAM9.default), {
                asButton: true,
                action: props.openHelpModal
            })
        ]
    });
};
var $57add22af08911fc$export$2e2bcd8739ae039 = $57add22af08911fc$var$Menu;

});
parcelRegister("32FCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $741d9aa6b47da8e4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");
parcelRequire("jitSV");
var $7laxl = parcelRequire("7laxl");
var $chRXN = parcelRequire("chRXN");

var $2ywbu = parcelRequire("2ywbu");

var $jF0Xa = parcelRequire("jF0Xa");

var $6lvMC = parcelRequire("6lvMC");
const $741d9aa6b47da8e4$var$CurrentUserSessionDetails = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!currentUser) return null;
    const editUserUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).USER_EDIT, {
        userId: currentUser.id
    });
    const renderDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
            className: "text-ch-gray-500 text-center w-full overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("dt", {
                    className: "text-white font-semibold text-lg",
                    children: [
                        currentUser.firstName,
                        " ",
                        currentUser.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                    className: "truncate",
                    children: currentUser.email
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex justify-center items-center flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-12 h-12 rounded-full bg-white flex items-center justify-center mb-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chRXN.default), {
                    className: "text-ch-purple-500 w-6 h-6"
                })
            }),
            renderDetails(),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ywbu.default), {
                href: editUserUrl,
                className: "uppercase font-semibold text-sm",
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                children: [
                    t("shared:edit"),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7laxl.default), {
                        className: "w-4 h-4 ml-1",
                        title: t("shared:edit")
                    })
                ]
            })
        ]
    });
};
var $741d9aa6b47da8e4$export$2e2bcd8739ae039 = $741d9aa6b47da8e4$var$CurrentUserSessionDetails;

});

parcelRegister("6MIVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff280ffea22a5fb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bff280ffea22a5fb$var$SvgIconChart = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
        })
    });
var $bff280ffea22a5fb$export$2e2bcd8739ae039 = $bff280ffea22a5fb$var$SvgIconChart;

});

parcelRegister("fsUlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c86320611b4a52$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1Lj4p = parcelRequire("1Lj4p");

var $5F05s = parcelRequire("5F05s");
const $e2c86320611b4a52$var$Timezone = ()=>{
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "border-2 border-ch-gray-300 rounded-full overflow-hidden relative w-8 h-8 mr-2 hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5F05s.default), {
                    flagKey: timezone,
                    className: "absolute w-full h-full"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-ch-gray-500",
                children: timezone
            })
        ]
    });
};
var $e2c86320611b4a52$export$2e2bcd8739ae039 = $e2c86320611b4a52$var$Timezone;

});
parcelRegister("5F05s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac44b9df6adf1fa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1hO3l = parcelRequire("1hO3l");

var $1snAs = parcelRequire("1snAs");

var $9fwGv = parcelRequire("9fwGv");
// TODO: Add lots more flags...
const $5ac44b9df6adf1fa$var$flagLookup = {
    // Europe
    "Europe/London": (0, $1snAs.default),
    // Australia
    "Australia/Sydney": (0, $9fwGv.default)
};
const $5ac44b9df6adf1fa$var$Flag = ({ flagKey: flagKey, className: className })=>{
    const getFlag = ()=>{
        const defaultFlag = (0, $1snAs.default);
        return $5ac44b9df6adf1fa$var$flagLookup[flagKey] || defaultFlag;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1hO3l.Icon), {
        icon: getFlag(),
        className: className
    });
};
var $5ac44b9df6adf1fa$export$2e2bcd8739ae039 = $5ac44b9df6adf1fa$var$Flag;

});
parcelRegister("1hO3l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.InlineIcon = module.exports.Icon = void 0;

var $0efe3474e81a2eae$var$_react = $0efe3474e81a2eae$var$_interopRequireDefault((parcelRequire("acw62")));
function $0efe3474e81a2eae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0efe3474e81a2eae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0efe3474e81a2eae$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0efe3474e81a2eae$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0efe3474e81a2eae$var$_typeof(obj);
}
function $0efe3474e81a2eae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0efe3474e81a2eae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0efe3474e81a2eae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0efe3474e81a2eae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0efe3474e81a2eae$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Unique id counter
 *
 * @type {number}
 */ var $0efe3474e81a2eae$var$idCounter = 0;
/**
 * Regex used to split dimensions
 *
 * @type {RegExp}
 * @private
 */ var $0efe3474e81a2eae$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var $0efe3474e81a2eae$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
/**
 * Attributes used for icon
 *
 * @type {string[]}
 */ var $0efe3474e81a2eae$var$iconAttributes = [
    'width',
    'height',
    'inline',
    'hFlip',
    'vFlip',
    'flip',
    'rotate',
    'align',
    'color',
    'box'
];
/**
 * Default attribute values
 *
 * @type {object}
 */ var $0efe3474e81a2eae$var$defaultAttributes = {
    left: 0,
    top: 0,
    width: 16,
    height: 16,
    rotate: 0,
    hFlip: false,
    vFlip: false
};
/**
 * Add missing properties to icon
 *
 * Important: in PHP version of this library this function is part of Collection class: Collection::addMissingAttributes()
 *
 * JavaScript version uses separate file so this function could be used in React and other components without loading
 * entire Collection class.
 *
 * @param {object} data
 * @return {object}
 */ function $0efe3474e81a2eae$var$normalize(data) {
    // Object.create, compatible with IE11
    var item = Object.create(null);
    var key;
    for(key in $0efe3474e81a2eae$var$defaultAttributes)item[key] = $0efe3474e81a2eae$var$defaultAttributes[key];
    for(key in data)item[key] = data[key];
     // Attributes derived from other attributes
    if (item.inlineTop === void 0) item.inlineTop = item.top;
    if (item.inlineHeight === void 0) item.inlineHeight = item.height;
    if (item.verticalAlign === void 0) // -0.143 if icon is designed for 14px height,
    // otherwise assume icon is designed for 16px height
    item.verticalAlign = item.height % 7 === 0 && item.height % 8 !== 0 ? -0.143 : -0.125;
    return item;
}
/**
 * Get preserveAspectRatio attribute value
 *
 * @param {object} align
 * @return {string}
 * @private
 */ function $0efe3474e81a2eae$var$getAlignment(align) {
    var result;
    switch(align.horizontal){
        case 'left':
            result = 'xMin';
            break;
        case 'right':
            result = 'xMax';
            break;
        default:
            result = 'xMid';
    }
    switch(align.vertical){
        case 'top':
            result += 'YMin';
            break;
        case 'bottom':
            result += 'YMax';
            break;
        default:
            result += 'YMid';
    }
    result += align.slice ? ' slice' : ' meet';
    return result;
}
/**
 * SVG class
 *
 * @see @iconify/json-tools/src/svg.js
 */ var $0efe3474e81a2eae$var$SVG = /*#__PURE__*/ function() {
    /**
   * Constructor
   *
   * @param icon Icon data
   *  Use Collection.getIconData() to retrieve icon data
   */ function SVG(icon) {
        $0efe3474e81a2eae$var$_classCallCheck(this, SVG);
        this._item = icon;
    }
    /**
   * Get SVG attributes
   *
   * @param {object} props Custom properties (same as query string in Iconify API)
   * @returns {string}
   */ $0efe3474e81a2eae$var$_createClass(SVG, [
        {
            key: "getAttributes",
            value: function getAttributes(props) {
                var item = this._item;
                if ($0efe3474e81a2eae$var$_typeof(props) !== 'object') props = Object.create(null);
                 // Set data
                var align = {
                    horizontal: 'center',
                    vertical: 'middle',
                    slice: false
                };
                var transform = {
                    rotate: item.rotate,
                    hFlip: item.hFlip,
                    vFlip: item.vFlip
                };
                var style = Object.create(null);
                var attributes = Object.create(null); // Get width/height
                var inline = props.inline === true || props.inline === 'true' || props.inline === '1';
                var box = {
                    left: item.left,
                    top: inline ? item.inlineTop : item.top,
                    width: item.width,
                    height: inline ? item.inlineHeight : item.height
                }; // Transformations
                [
                    'hFlip',
                    'vFlip'
                ].forEach(function(key) {
                    if (props[key] !== void 0 && (props[key] === true || props[key] === 'true' || props[key] === '1')) transform[key] = !transform[key];
                });
                if (props.flip !== void 0) props.flip.toLowerCase().split(/[\s,]+/).forEach(function(value) {
                    switch(value){
                        case 'horizontal':
                            transform.hFlip = !transform.hFlip;
                            break;
                        case 'vertical':
                            transform.vFlip = !transform.vFlip;
                    }
                });
                if (props.rotate !== void 0) {
                    var value = props.rotate;
                    if (typeof value === 'number') transform.rotate += value;
                    else if (typeof value === 'string') {
                        var units = value.replace(/^-?[0-9.]*/, '');
                        if (units === '') {
                            value = parseInt(value);
                            if (!isNaN(value)) transform.rotate += value;
                        } else if (units !== value) {
                            var split = false;
                            switch(units){
                                case '%':
                                    // 25% -> 1, 50% -> 2, ...
                                    split = 25;
                                    break;
                                case 'deg':
                                    // 90deg -> 1, 180deg -> 2, ...
                                    split = 90;
                            }
                            if (split) {
                                value = parseInt(value.slice(0, value.length - units.length));
                                if (!isNaN(value)) transform.rotate += Math.round(value / split);
                            }
                        }
                    }
                } // Apply transformations to box
                var transformations = [], tempValue;
                if (transform.hFlip) {
                    if (transform.vFlip) transform.rotate += 2;
                    else {
                        // Horizontal flip
                        transformations.push('translate(' + (box.width + box.left) + ' ' + (0 - box.top) + ')');
                        transformations.push('scale(-1 1)');
                        box.top = box.left = 0;
                    }
                } else if (transform.vFlip) {
                    // Vertical flip
                    transformations.push('translate(' + (0 - box.left) + ' ' + (box.height + box.top) + ')');
                    transformations.push('scale(1 -1)');
                    box.top = box.left = 0;
                }
                switch(transform.rotate % 4){
                    case 1:
                        // 90deg
                        tempValue = box.height / 2 + box.top;
                        transformations.unshift('rotate(90 ' + tempValue + ' ' + tempValue + ')'); // swap width/height and x/y
                        if (box.left !== 0 || box.top !== 0) {
                            tempValue = box.left;
                            box.left = box.top;
                            box.top = tempValue;
                        }
                        if (box.width !== box.height) {
                            tempValue = box.width;
                            box.width = box.height;
                            box.height = tempValue;
                        }
                        break;
                    case 2:
                        // 180deg
                        transformations.unshift('rotate(180 ' + (box.width / 2 + box.left) + ' ' + (box.height / 2 + box.top) + ')');
                        break;
                    case 3:
                        // 270deg
                        tempValue = box.width / 2 + box.left;
                        transformations.unshift('rotate(-90 ' + tempValue + ' ' + tempValue + ')'); // swap width/height and x/y
                        if (box.left !== 0 || box.top !== 0) {
                            tempValue = box.left;
                            box.left = box.top;
                            box.top = tempValue;
                        }
                        if (box.width !== box.height) {
                            tempValue = box.width;
                            box.width = box.height;
                            box.height = tempValue;
                        }
                        break;
                } // Calculate dimensions
                // Values for width/height: null = default, 'auto' = from svg, false = do not set
                // Default: if both values aren't set, height defaults to '1em', width is calculated from height
                var customWidth = props.width ? props.width : null;
                var customHeight = props.height ? props.height : null;
                var width, height;
                if (customWidth === null && customHeight === null) customHeight = '1em';
                if (customWidth !== null && customHeight !== null) {
                    width = customWidth;
                    height = customHeight;
                } else if (customWidth !== null) {
                    width = customWidth;
                    height = SVG.calculateDimension(width, box.height / box.width);
                } else {
                    height = customHeight;
                    width = SVG.calculateDimension(height, box.width / box.height);
                }
                if (width !== false) attributes.width = width === 'auto' ? box.width : width;
                if (height !== false) attributes.height = height === 'auto' ? box.height : height;
                 // Add vertical-align for inline icon
                if (inline && item.verticalAlign !== 0) style['vertical-align'] = item.verticalAlign + 'em';
                 // Check custom alignment
                if (props.align !== void 0) props.align.toLowerCase().split(/[\s,]+/).forEach(function(value) {
                    switch(value){
                        case 'left':
                        case 'right':
                        case 'center':
                            align.horizontal = value;
                            break;
                        case 'top':
                        case 'bottom':
                        case 'middle':
                            align.vertical = value;
                            break;
                        case 'crop':
                            align.slice = true;
                            break;
                        case 'meet':
                            align.slice = false;
                    }
                });
                 // Generate viewBox and preserveAspectRatio attributes
                attributes.preserveAspectRatio = $0efe3474e81a2eae$var$getAlignment(align);
                attributes.viewBox = box.left + ' ' + box.top + ' ' + box.width + ' ' + box.height; // Generate body
                var body = SVG.replaceIDs(item.body);
                if (props.color !== void 0) body = body.replace(/currentColor/g, props.color);
                if (transformations.length) body = '<g transform="' + transformations.join(' ') + '">' + body + '</g>';
                if (props.box === true || props.box === 'true' || props.box === '1') // Add transparent bounding box
                body += '<rect x="' + box.left + '" y="' + box.top + '" width="' + box.width + '" height="' + box.height + '" fill="rgba(0, 0, 0, 0)" />';
                return {
                    attributes: attributes,
                    body: body,
                    style: style
                };
            }
        },
        {
            key: "getSVG",
            value: function getSVG(props, addExtra) {
                var attributes = SVG.splitAttributes(props), data = this.getAttributes(attributes.icon);
                var svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"'; // Add extra attributes - assume that their names and values are escaped
                if (addExtra) Object.keys(attributes.node).forEach(function(attr) {
                    svg += ' ' + attr + '="' + attributes.node[attr] + '"';
                });
                 // Add SVG attributes
                Object.keys(data.attributes).forEach(function(attr) {
                    svg += ' ' + attr + '="' + data.attributes[attr] + '"';
                }); // Add style with 360deg transformation to style to prevent subpixel rendering bug
                svg += ' style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);';
                Object.keys(data.style).forEach(function(attr) {
                    svg += ' ' + attr + ': ' + data.style[attr] + ';';
                });
                if (props && props.style !== void 0) svg += props.style;
                svg += '">';
                svg += data.body + '</svg>';
                return svg;
            }
        }
    ], [
        {
            key: "splitAttributes",
            value: function splitAttributes(props) {
                var result = {
                    icon: Object.create(null),
                    node: Object.create(null)
                };
                Object.keys(props).forEach(function(name) {
                    result[$0efe3474e81a2eae$var$iconAttributes.indexOf(name) === -1 ? 'node' : 'icon'][name] = props[name];
                });
                return result;
            }
        },
        {
            key: "calculateDimension",
            value: function calculateDimension(size, ratio, precision) {
                if (ratio === 1) return size;
                precision = precision === void 0 ? 100 : precision;
                if (typeof size === 'number') return Math.ceil(size * ratio * precision) / precision;
                 // split code into sets of strings and numbers
                var split = size.split($0efe3474e81a2eae$var$unitsSplit);
                if (split === null || !split.length) return null;
                var results = [], code = split.shift(), isNumber = $0efe3474e81a2eae$var$unitsTest.test(code), num;
                while(true){
                    if (isNumber) {
                        num = parseFloat(code);
                        if (isNaN(num)) results.push(code);
                        else results.push(Math.ceil(num * ratio * precision) / precision);
                    } else results.push(code);
                     // next
                    code = split.shift();
                    if (code === void 0) return results.join('');
                    isNumber = !isNumber;
                }
            }
        },
        {
            key: "replaceIDs",
            value: function replaceIDs(body) {
                var regex = /\sid="(\S+)"/g, ids = [], match, prefix;
                function strReplace(search, replace, subject) {
                    var pos = 0;
                    while((pos = subject.indexOf(search, pos)) !== -1){
                        subject = subject.slice(0, pos) + replace + subject.slice(pos + search.length);
                        pos += replace.length;
                    }
                    return subject;
                } // Find all IDs
                while(match = regex.exec(body))ids.push(match[1]);
                if (!ids.length) return body;
                prefix = 'IconifyId-' + Date.now().toString(16) + '-' + (Math.random() * 0x1000000 | 0).toString(16) + '-'; // Replace with unique ids
                ids.forEach(function(id) {
                    var newID = prefix + $0efe3474e81a2eae$var$idCounter;
                    $0efe3474e81a2eae$var$idCounter++;
                    body = strReplace('="' + id + '"', '="' + newID + '"', body);
                    body = strReplace('="#' + id + '"', '="#' + newID + '"', body);
                    body = strReplace('(#' + id + ')', '(#' + newID + ')', body);
                });
                return body;
            }
        }
    ]);
    return SVG;
}();
/**
 * Create React component with SVG data
 *
 * @param {object} props
 * @param {boolean} inline
 * @return {null|React.Component}
 */ function $0efe3474e81a2eae$var$component(props, inline) {
    if ($0efe3474e81a2eae$var$_typeof(props.icon) !== 'object') return null;
     // Split properties into SVG properties and icon properties
    var split = $0efe3474e81a2eae$var$SVG.splitAttributes(props), iconProps = split.icon, customAttributes = split.node;
    delete customAttributes.icon; // Set default inline value
    if (iconProps.inline === void 0) iconProps.inline = inline;
     // Get SVG data
    var svg = new $0efe3474e81a2eae$var$SVG($0efe3474e81a2eae$var$normalize(props.icon));
    var iconData = svg.getAttributes(iconProps); // Set style
    var style = {
        transform: 'rotate(360deg)'
    };
    if (iconData.style['vertical-align'] !== void 0) style.verticalAlign = iconData.style['vertical-align'];
    if (props.style !== void 0) for(var _key in props.style)style[_key] = props.style[_key];
     // Generate element attributes
    var attributes = {
        xmlns: 'http://www.w3.org/2000/svg',
        focusable: false,
        style: style
    };
    var key;
    for(key in customAttributes)attributes[key] = customAttributes[key];
    for(key in iconData.attributes)attributes[key] = iconData.attributes[key];
    attributes.dangerouslySetInnerHTML = {
        __html: iconData.body
    }; // Generate SVG
    return $0efe3474e81a2eae$var$_react["default"].createElement('svg', attributes, null);
}
/**
 * Icon without vertical alignment
 *
 * @param {object} props
 * @return {React.Component}
 * @constructor
 */ var $0efe3474e81a2eae$var$Icon = function Icon(props) {
    return $0efe3474e81a2eae$var$component(props, false);
};
/**
 * Icon with vertical alignment
 *
 * @param {object} props
 * @return {React.Component}
 * @constructor
 */ module.exports.Icon = $0efe3474e81a2eae$var$Icon;
var $0efe3474e81a2eae$var$InlineIcon = function InlineIcon(props) {
    return $0efe3474e81a2eae$var$component(props, true);
};
/**
 * Default export
 */ module.exports.InlineIcon = $0efe3474e81a2eae$var$InlineIcon;
var $0efe3474e81a2eae$var$_default = $0efe3474e81a2eae$var$Icon;
module.exports["default"] = $0efe3474e81a2eae$var$_default;

});

parcelRegister("1snAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fab3dead377994$export$2e2bcd8739ae039, (v) => $10fab3dead377994$export$2e2bcd8739ae039 = v);
var $10fab3dead377994$export$1e511d4a378977f5;
var $10fab3dead377994$export$2e2bcd8739ae039;
const $10fab3dead377994$var$data = {
    "width": 64,
    "height": 64,
    "body": "<path fill=\"#2a5f9e\" d=\"M22 60.3V46.5l-10.3 7.6c2.9 2.7 6.4 4.8 10.3 6.2m20 0c3.9-1.4 7.4-3.5 10.3-6.2L42 46.4v13.9M3.7 42c.3 1 .7 1.9 1.2 2.9L8.8 42H3.7m51.5 0l3.9 2.9c.4-.9.8-1.9 1.2-2.9h-5.1\"/><path fill=\"#fff\" d=\"M23.5 38H2.6c.3 1.4.7 2.7 1.1 4h5.1l-3.9 2.9c.8 1.7 1.7 3.2 2.8 4.7L18 42h4v2l-11.7 8.6l1.4 1.4L22 46.5v13.8c1.3.5 2.6.8 4 1.1V38h-2.5m37.9 0H38v23.4c1.4-.3 2.7-.7 4-1.1V46.5L52.3 54c1.4-1.3 2.6-2.7 3.8-4.2L45.4 42h6.8l6.1 4.5c.3-.5.6-1.1.8-1.6L55.2 42h5.1c.4-1.3.8-2.6 1.1-4\"/><path fill=\"#ed4c5c\" d=\"M7.7 49.6c.8 1.1 1.6 2.1 2.5 3.1L22 44.1v-2h-4L7.7 49.6M45.5 42l10.7 7.8c.4-.5.7-1 1.1-1.5c.1-.1.1-.2.2-.2c.3-.5.7-1.1 1-1.6L52.2 42h-6.7\"/><path fill=\"#2a5f9e\" d=\"M42 3.7v13.8l10.3-7.6C49.4 7.2 45.9 5.1 42 3.7m-20 0c-3.9 1.4-7.4 3.5-10.3 6.2L22 17.6V3.7M60.3 22c-.3-1-.7-1.9-1.2-2.9L55.2 22h5.1M8.8 22l-3.9-2.9c-.4 1-.8 1.9-1.2 2.9h5.1\"/><path fill=\"#fff\" d=\"M40.5 26h20.8c-.3-1.4-.7-2.7-1.1-4h-5.1l3.9-2.9c-.8-1.7-1.7-3.2-2.8-4.7L46 22h-4v-2l11.7-8.6l-1.4-1.4L42 17.5V3.7c-1.3-.5-2.6-.8-4-1.1V26h2.5M2.6 26H26V2.6c-1.4.3-2.7.7-4 1.1v13.8L11.7 10c-1.4 1.3-2.6 2.7-3.8 4.2L18.6 22h-6.8l-6.1-4.5c-.3.5-.6 1.1-.8 1.6L8.8 22H3.7c-.4 1.3-.8 2.6-1.1 4\"/><g fill=\"#ed4c5c\"><path d=\"M56.3 14.4c-.8-1.1-1.6-2.1-2.5-3.1L42 19.9v2h4l10.3-7.5M18.5 22L7.9 14.2c-.4.5-.7 1-1.1 1.5c-.1.1-.1.2-.2.2c-.3.5-.7 1.1-1 1.6l6.1 4.5h6.8\"/><path d=\"M61.4 26H38V2.6c-1.9-.4-3.9-.6-6-.6s-4.1.2-6 .6V26H2.6c-.4 1.9-.6 3.9-.6 6s.2 4.1.6 6H26v23.4c1.9.4 3.9.6 6 .6s4.1-.2 6-.6V38h23.4c.4-1.9.6-3.9.6-6s-.2-4.1-.6-6\"/></g>"
};
$10fab3dead377994$export$1e511d4a378977f5 = true;
$10fab3dead377994$export$2e2bcd8739ae039 = $10fab3dead377994$var$data;

});

parcelRegister("9fwGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bbede43c2cba24f$export$2e2bcd8739ae039, (v) => $6bbede43c2cba24f$export$2e2bcd8739ae039 = v);
var $6bbede43c2cba24f$export$1e511d4a378977f5;
var $6bbede43c2cba24f$export$2e2bcd8739ae039;
const $6bbede43c2cba24f$var$data = {
    "width": 64,
    "height": 64,
    "body": "<path fill=\"#2a5f9e\" d=\"M32 2v10H12v20H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z\"/><path fill=\"#fff\" d=\"M32 2c-4.7 0-9.1 1.1-13.1 3v6H11v7.9H5c-1.9 4-3 8.4-3 13.1h12V17l12 15h6v-7.5L23.6 14H32V2z\"/><g fill=\"#ed4c5c\"><path d=\"M15.4 14L30 32h2v-4.9L21.4 14z\"/><path d=\"M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z\"/></g><path fill=\"#fff\" d=\"m8 35.7l2.2-2.7l-.7 3.5l3.5.1l-3.1 1.6L12 41l-3.1-1.4L8 43l-.9-3.4L4 41l2.1-2.8L3 36.6l3.5-.1l-.7-3.5zm44-15.5l1.8-2.2l-.6 2.8l2.8.1l-2.5 1.3l1.7 2.2l-2.5-1.2L52 26l-.7-2.8l-2.5 1.2l1.7-2.2l-2.5-1.3l2.8-.1l-.6-2.8zm0 20l1.8-2.2l-.6 2.8l2.8.1l-2.5 1.3l1.7 2.2l-2.5-1.2L52 46l-.7-2.8l-2.5 1.2l1.7-2.2l-2.5-1.3l2.8-.1l-.6-2.8zm-10-14l1.8-2.2l-.6 2.8l2.8.1l-2.5 1.3l1.7 2.2l-2.5-1.2L42 32l-.7-2.8l-2.5 1.2l1.7-2.2l-2.5-1.3l2.8-.1l-.6-2.8z\"/>"
};
$6bbede43c2cba24f$export$1e511d4a378977f5 = true;
$6bbede43c2cba24f$export$2e2bcd8739ae039 = $6bbede43c2cba24f$var$data;

});




parcelRegister("jpvkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f42367014349694$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $2EDUL = parcelRequire("2EDUL");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $kQILj = parcelRequire("kQILj");
parcelRequire("jitSV");
var $chuvC = parcelRequire("chuvC");
var $5AYDs = parcelRequire("5AYDs");

var $9lUNX = parcelRequire("9lUNX");

var $6lvMC = parcelRequire("6lvMC");

var $6t04b = parcelRequire("6t04b");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");

var $aeos3 = parcelRequire("aeos3");
const $0f42367014349694$var$MessageNotification = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const { messagingNotificationsEnabled: messagingNotificationsEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const notificationMessageId = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getChatMessagesUI)(state))?.notificationMessageId;
    const message = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageById)(state, {
            messageId: notificationMessageId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const updateNotificationMessageId = (messageId)=>dispatch((0, $9lUNX.updateNotificationMessageIdAction)(messageId));
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const location = (0, $COwA0.useLocation)();
    const getExpiryTimestamp = ()=>{
        const time = new Date();
        time.setSeconds(time.getSeconds() + 7);
        return time;
    };
    const { seconds: seconds, start: start, pause: pause, restart: restart } = (0, $2EDUL.useTimer)({
        autoStart: false,
        expiryTimestamp: getExpiryTimestamp()
    });
    (0, $acw62.useEffect)(()=>{
        if (messagingNotificationsEnabled && message != null && message.createdBy.id != currentUser.id && location.pathname != (0, $6QJY8.RoutePaths).MESSAGES) openMessage();
    }, [
        message?.id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (seconds == 0) closeMessage();
    }, [
        seconds
    ]);
    const openMessage = ()=>{
        setIsVisible(true);
        restartTimer();
        start();
    };
    const closeMessage = ()=>{
        setIsVisible(false);
        setTimeout(()=>{
            updateNotificationMessageId(null);
        }, 500);
    };
    const onClickNotification = ()=>{
        closeMessage();
        (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).MESSAGES);
    };
    const restartTimer = ()=>{
        restart(getExpiryTimestamp());
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("absolute", "top-20", "shadow", "z-50", "border-l-4", "border-ch-purple-500", "transition-all", "duration-500", "ease-in-out", {
            "opacity-0": !isVisible,
            "opacity-100": isVisible,
            "-right-64": !isVisible,
            "right-5": isVisible
        }),
        onMouseEnter: pause,
        onMouseLeave: restartTimer,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full h-full p-4 border bg-ch-gray-200 border-r-ch-gray-400 relative",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    onClick: closeMessage,
                    className: "text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer absolute right-4 top-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chuvC.default), {
                        className: "fill-current w-4 h-4",
                        title: t("shared:close")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cursor-pointer",
                    onClick: onClickNotification,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex pr-8",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                                        className: "fill-current w-5 h-5 mr-2 text-ch-purple-500",
                                        title: t("message:shared:buttons:openChat")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-sm font-semibold truncate",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                            firstName: message?.createdBy.firstName,
                                            lastName: message?.createdBy.lastName,
                                            professionalTitle: message?.createdBy.professionalTitle
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "truncate max-h-24 max-w-sm text-sm text-ch-gray-500",
                            children: message?.body
                        })
                    ]
                })
            ]
        })
    });
};
var $0f42367014349694$export$2e2bcd8739ae039 = $0f42367014349694$var$MessageNotification;

});

parcelRegister("bjGFW", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $f5f3629c948dc37d$export$e926676385687eaf);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");

var $9EFkG = parcelRequire("9EFkG");
const $f5f3629c948dc37d$var$genericErrorMessage = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
    className: "text-xl space-y-4 flex flex-col justify-center items-center h-screen",
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            children: "Something went wrong. Please try reloading the page"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: "If the error persists please go to the home page"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: "/",
            children: "Home Page"
        })
    ]
});
class $f5f3629c948dc37d$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    state = {
        hasError: false
    };
    props = null;
    static defaultProps = {
        children: null,
        errorMessage: $f5f3629c948dc37d$var$genericErrorMessage
    };
    constructor(props){
        super(props);
        this.props = props;
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(_error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        (0, $9EFkG.default).captureError(error);
    }
    render() {
        if (this.state.hasError) return this.props.errorMessage;
        return this.props.children;
    }
}

});

parcelRegister("8dfeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ffa0f27e740124$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $kYqkq = parcelRequire("kYqkq");

var $6lvMC = parcelRequire("6lvMC");

var $i6lWx = parcelRequire("i6lWx");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $lCZwG = parcelRequire("lCZwG");

var $b5weT = parcelRequire("b5weT");

var $4KSAX = parcelRequire("4KSAX");

var $cA1jy = parcelRequire("cA1jy");
const $d5ffa0f27e740124$var$QuickStartGuide = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const { uiSettings: uiSettings } = (0, $kYqkq.useAppSelector)((state)=>state.userConfig);
    const dispatch = (0, $2OPjR.useDispatch)();
    const closeHelpModal = ()=>props.setOpen(false);
    const updateUISetting = (value)=>dispatch((0, $i6lWx.updateUISettingAction)(currentUser.id, {
            showQuickStartGuide: value
        }));
    const [variant, setVariant] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!uiSettings || (0, $cA1jy.isGuest)(currentUser)) return;
        props.setOpen(uiSettings.showQuickStartGuide);
    }, [
        uiSettings
    ]);
    (0, $acw62.useEffect)(()=>{
        const _variant = uiSettings?.showQuickStartGuide ? (0, $jF0Xa.StyleVariants).BLUE : (0, $jF0Xa.StyleVariants).GRAY;
        setVariant(_variant);
    }, [
        uiSettings
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.open,
        style: (0, $jF0Xa.defaultModalStyle),
        onRequestClose: closeHelpModal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: ()=>props.setOpen(false),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    action: ()=>updateUISetting(!uiSettings?.showQuickStartGuide),
                    variant: variant,
                    className: "absolute top-0 right-8",
                    children: uiSettings?.showQuickStartGuide ? t("shared:quickStartGuide:dontShow") : t("shared:quickStartGuide:showOnLogin")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                    src: "https://contexthealth.com/contextmdt-quick-start/",
                    width: "100%",
                    height: "100%"
                })
            ]
        })
    });
};
var $d5ffa0f27e740124$export$2e2bcd8739ae039 = $d5ffa0f27e740124$var$QuickStartGuide;

});


parcelRegister("kvY2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $552c97e21b3fb13c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $8e5HJ = parcelRequire("8e5HJ");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $ai857 = parcelRequire("ai857");

var $gMnrz = parcelRequire("gMnrz");

var $lqbsE = parcelRequire("lqbsE");

var $c0FI2 = parcelRequire("c0FI2");

var $5GZlj = parcelRequire("5GZlj");

var $6lvMC = parcelRequire("6lvMC");

var $86st8 = parcelRequire("86st8");

var $lWwtG = parcelRequire("lWwtG");

var $04A9g = parcelRequire("04A9g");

var $ayHLD = parcelRequire("ayHLD");

var $d8Vwn = parcelRequire("d8Vwn");

var $cA1jy = parcelRequire("cA1jy");

var $lxAyE = parcelRequire("lxAyE");

var $wwQ9q = parcelRequire("wwQ9q");

var $fyWUD = parcelRequire("fyWUD");
const $552c97e21b3fb13c$var$baseRoles = {
    caseAdmin: "case_admin",
    meetingAdmin: "meeting_admin",
    teamAdmin: "team_admin",
    userEditor: "user_editor",
    userAdmin: "user_admin"
};
const $552c97e21b3fb13c$var$adminAssignableRoles = {
    radiologyAdmin: "radiology_admin",
    fullAdmin: "admin"
};
const $552c97e21b3fb13c$var$UserEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const formikFormRef = (0, $acw62.useRef)(null);
    const specialties = (0, $iD0SF.useSelector)((state)=>(0, $lqbsE.getAllSpecialties)(state));
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const allUsers = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    const closeModal = ()=>{
        setIsOpen(false);
    };
    if (!user) return null;
    const initialValues = {
        title: user.title,
        professionalTitle: user.professionalTitle,
        firstName: user.firstName,
        lastName: user.lastName,
        specialtyIds: user.specialties?.map((specialty)=>specialty.id) || [],
        admin_roles: user.tenantRoles?.filter((r)=>r != "participant")?.concat(user.roles) || [],
        active: user.activeInCurrentTenant,
        mfaEnabled: user.mfaEnabled,
        email: user.email,
        organisation: user.organisation,
        phoneNumber: user.phoneNumber ? `+${user.phoneCountryCode || "44"}${user.phoneNumber}` : ""
    };
    const titleOptions = Object.keys((0, $8e5HJ.UserTitles)).map((key)=>{
        return {
            value: (0, $8e5HJ.UserTitles)[key],
            label: key
        };
    });
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    const renderRoleFields = ()=>{
        let roles;
        if ((0, $cA1jy.isGuest)(user)) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                    name: "admin_roles",
                    children: [
                        " ",
                        t("user:roles"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: t("user:isGuest")
                })
            ]
        });
        if (user.permissions.canAssignAdminRole) roles = {
            ...$552c97e21b3fb13c$var$baseRoles,
            ...$552c97e21b3fb13c$var$adminAssignableRoles
        };
        else if (user.permissions.canManage) roles = $552c97e21b3fb13c$var$baseRoles;
        else return null;
        if (user.id == currentUser.id) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-2",
            children: t("user:adminCannotChangeOwnRole")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                    name: "admin_roles",
                    children: [
                        " ",
                        t("user:roles"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "group",
                    "aria-labelledby": "checkbox-group",
                    children: Object.entries(roles).map(([key, role])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                                    type: "checkbox",
                                    name: "admin_roles",
                                    value: role,
                                    className: "mx-1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                    name: "admin_roles",
                                    children: [
                                        " ",
                                        t(`user:roleNames:${key}`),
                                        " "
                                    ]
                                })
                            ]
                        }, role))
                })
            ]
        });
    };
    const renderActiveFields = ()=>{
        if (!user.permissions?.canManage) return null;
        if (user.id == currentUser.id) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-2",
            children: t("user:adminCannotDeactivateSelf")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                    name: "admin_roles",
                    children: [
                        " ",
                        t("user:activeInactive"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                            type: "checkbox",
                            name: "active",
                            className: "mx-1"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                            name: "active",
                            children: [
                                " ",
                                t("user:active"),
                                " "
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderMfaFields = ()=>{
        if (!user.permissions?.canManage) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                    name: "admin_roles",
                    children: [
                        " ",
                        t("user:enableMfa"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                            type: "checkbox",
                            name: "mfaEnabled",
                            className: "mx-1"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                            name: "mfaEnabled",
                            children: [
                                " ",
                                t("user:mfaEnabled"),
                                " "
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderAdminButtons = ()=>{
        if (!user.permissions?.canEdit) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "md:absolute top-3 right-3 flex float-right items-end ",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                buttons: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86st8.default), {
                        user: user
                    }, "1"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lWwtG.default), {
                        user: user
                    }, "2"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fyWUD.default), {
                        user: user
                    }, "2")
                ]
            })
        });
    };
    const openModal = ()=>{
        setIsOpen(true);
    };
    const dispatchFormValues = (values)=>{
        const data = {
            ...values
        };
        const phoneNumberData = (0, $lxAyE.parsePhoneNumber)(data.phoneNumber);
        if (phoneNumberData) {
            data.phoneNumber = phoneNumberData.nationalNumber;
            data.phoneCountryCode = phoneNumberData.countryCallingCode;
        }
        dispatch((0, $ai857.updateUserAction)(props.userId, data));
    };
    const handleUserUpdate = ()=>{
        closeModal();
        dispatchFormValues(formikFormRef.current.values);
    };
    const userEmails = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(allUsers, "email").filter((e)=>e !== initialValues.email);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col md:relative",
        children: [
            renderAdminButtons(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-left pl-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    initialValues: initialValues,
                    validationSchema: (0, $gMnrz.userEditValidationSchema)(userEmails),
                    enableReinitialize: true,
                    onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                        if (values.email === initialValues.email) dispatchFormValues(values);
                        else openModal();
                        setSubmitting(false);
                    },
                    innerRef: formikFormRef,
                    children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, setFieldValue: setFieldValue })=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            className: "w-full lg:w-2/3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "title",
                                            children: t("user:title")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "title",
                                            options: titleOptions,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.title,
                                            isVisible: errors.title && touched.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "professionalTitle",
                                            children: t("user:professionalTitle")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "professionalTitle",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.professionalTitle,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.professionalTitle,
                                            isVisible: errors.professionalTitle && touched.professionalTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "firstName",
                                            required: true,
                                            children: t("user:firstName")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "firstName",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.firstName,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.firstName,
                                            isVisible: errors.firstName && touched.firstName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "lastName",
                                            required: true,
                                            children: t("user:lastName")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "lastName",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.lastName,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.lastName,
                                            isVisible: errors.lastName && touched.lastName
                                        })
                                    ]
                                }),
                                (0, $cA1jy.isAdmin)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "email",
                                            required: true,
                                            children: t("user:email")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "email",
                                            name: "email",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.email,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.email,
                                            isVisible: errors.email && touched.email
                                        })
                                    ]
                                }) : null,
                                (0, $cA1jy.isAdmin)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "phoneNumber",
                                            children: t("user:phoneNumber")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lxAyE.default), {
                                            value: values.phoneNumber,
                                            onChange: (value)=>setFieldValue("phoneNumber", value),
                                            defaultCountry: "GB",
                                            // TODO: Fix flags not showing in prod when loaded with flagUrl
                                            // flagUrl={`${location.origin}/images/svg/flags/{xx}.svg`}
                                            flags: (0, $wwQ9q.default)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.phoneNumber,
                                            isVisible: errors.phoneNumber && touched.phoneNumber
                                        })
                                    ]
                                }) : null,
                                (0, $cA1jy.isGuest)(user) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "organisation",
                                            children: t("user:organisation")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "organisation",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.organisation,
                                            autoComplete: "off"
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "specialtyIds",
                                            children: t("user:specialties")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "specialtyIds",
                                            options: specialtiesOptions,
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            isMulti: true,
                                            isGrouped: true,
                                            closeMenuOnSelect: false
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.specialtyIds,
                                            isVisible: errors.specialtyIds && touched.specialtyIds
                                        })
                                    ]
                                }),
                                renderRoleFields(),
                                renderActiveFields(),
                                renderMfaFields(),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex justify-center mb-6",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: !dirty || isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("user:updateUser")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayHLD.default), {
                                    modalIsOpen: modalIsOpen,
                                    closeModal: closeModal,
                                    handleUserUpdate: handleUserUpdate,
                                    oldEmail: user.email,
                                    newEmail: values.email
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
var $552c97e21b3fb13c$export$2e2bcd8739ae039 = $552c97e21b3fb13c$var$UserEditForm;

});
parcelRegister("gMnrz", function(module, exports) {

$parcel$export(module.exports, "userEditValidationSchema", () => $fddfbe561e2bda7b$export$3d2e534823e251cb);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $lxAyE = parcelRequire("lxAyE");
const $fddfbe561e2bda7b$export$3d2e534823e251cb = (userEmails)=>{
    return $hDGtv.create().shape({
        firstName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        lastName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        email: $gcL7X.create().trim().email((0, $5wPBK.default).t("shared:invalidEmail")).required((0, $5wPBK.default).t("shared:required")).notOneOf(userEmails, (0, $5wPBK.default).t("shared:emailExists")),
        phoneNumber: $gcL7X.create().test("phoneValid", (0, $5wPBK.default).t("shared:invalidPhone"), function(value) {
            if (!value) return true;
            return (0, $lxAyE.isValidPhoneNumber)(value);
        })
    });
};

});

parcelRegister("86st8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fdb57503dc32f00$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
const $8fdb57503dc32f00$var$ResendInviteButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const resendInvite = ()=>{
        (0, $5s7Tw.default).post(`/users/${props.user.id}/resend_invite`, props.user, (0, $1zizz.withAuthHeader)()).then(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "resendInviteSuccess",
                type: (0, $jiIfA.UserMessageTypes).SUCCESS
            }));
        }).catch(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "resendInviteFail",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        action: ()=>resendInvite(),
        children: t("user:admin:buttons:resendInvite")
    });
};
var $8fdb57503dc32f00$export$2e2bcd8739ae039 = $8fdb57503dc32f00$var$ResendInviteButton;

});

parcelRegister("lWwtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $532fc7b5c18be51d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
const $532fc7b5c18be51d$var$ClearMfaButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const clearMfa = ()=>{
        (0, $5s7Tw.default).post(`/users/${props.user.id}/clear_mfa`, props.user, (0, $1zizz.withAuthHeader)()).then(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "clearMfaSuccess",
                type: (0, $jiIfA.UserMessageTypes).SUCCESS
            }));
        }).catch(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "clearMfaFail",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        action: ()=>clearMfa(),
        children: t("user:admin:buttons:clearMfa")
    });
};
var $532fc7b5c18be51d$export$2e2bcd8739ae039 = $532fc7b5c18be51d$var$ClearMfaButton;

});

parcelRegister("ayHLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8793b52a7319a4c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $b5weT = parcelRequire("b5weT");
parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");
const $a8793b52a7319a4c$var$EmailConfirmationModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.modalIsOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.dialogueModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3 text-ch-blue-600",
                    children: t("user:emailChangeConfirmation")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "user:userEmailChangeDesc1",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            },
                            values: {
                                oldEmail: props.oldEmail
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "user:userEmailChangeDesc2",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            },
                            values: {
                                newEmail: props.newEmail
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t("user:doYouWantToContinue")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>props.closeModal(),
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "uppercase",
                                children: t("shared:no")
                            })
                        }, "3"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>props.handleUserUpdate(),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            isSubmit: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "uppercase",
                                children: t("shared:yes")
                            })
                        }, "4")
                    ]
                })
            ]
        })
    });
};
var $a8793b52a7319a4c$export$2e2bcd8739ae039 = $a8793b52a7319a4c$var$EmailConfirmationModal;

});

parcelRegister("fyWUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2722c8681e3df4e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");
const $f2722c8681e3df4e$var$UnlockButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const clearMfa = ()=>{
        (0, $5s7Tw.default).post(`/users/${props.user.id}/unlock`, props.user, (0, $1zizz.withAuthHeader)()).then(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "unlockSuccessAdmin",
                type: (0, $jiIfA.UserMessageTypes).SUCCESS
            }));
        }).catch(()=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "unlockFailAdmin",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    if (!props.user.accessLocked) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        action: ()=>clearMfa(),
        children: t("user:admin:buttons:unlockAccount")
    });
};
var $f2722c8681e3df4e$export$2e2bcd8739ae039 = $f2722c8681e3df4e$var$UnlockButton;

});


parcelRegister("9RwYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe92f60c3e9790bc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $93tzC = parcelRequire("93tzC");

var $7UN5R = parcelRequire("7UN5R");

var $i6lWx = parcelRequire("i6lWx");

var $5GZlj = parcelRequire("5GZlj");

var $6lvMC = parcelRequire("6lvMC");

var $4qaeN = parcelRequire("4qaeN");

var $kA27M = parcelRequire("kA27M");

var $1Lj4p = parcelRequire("1Lj4p");
const $fe92f60c3e9790bc$var$UserConfigEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user"
    ]);
    const [isVisibleList, toggleList] = (0, $acw62.useState)(false);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const updateUserConfig = (userId, user)=>{
        dispatch((0, $i6lWx.updateUserConfigAction)(userId, user));
    };
    const { locale: locale, timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const initialValues = {
        locale: locale,
        timezone: timezone
    };
    const localeOptions = Object.keys((0, $93tzC.UserLanguages)).map((key)=>{
        return {
            value: (0, $93tzC.UserLanguages)[key],
            label: key
        };
    });
    const timezoneOptions = Object.keys((0, $93tzC.UserTimezones)).map((key)=>{
        return {
            value: (0, $93tzC.UserTimezones)[key],
            label: key
        };
    });
    if (!user) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-left pl-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            enableReinitialize: true,
            onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                if (values.timezone == (0, $93tzC.UserTimezones).Default) values.timezone = null;
                updateUserConfig(props.userId, values);
                setSubmitting(false);
            },
            children: ({ isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                        className: "flex-col mb-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center flex-wrap",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "mr-4 mb-2 text-lg",
                                    children: t("user:systemPreferences")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex mb-2 items-end",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "flex-1 pr-10 lg:pr-24",
                                        children: t("user:systemPreferencesDesc")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                        isExpanded: isVisibleList,
                                        action: ()=>toggleList(!isVisibleList),
                                        expandText: t("user:showSystemPreferences"),
                                        collapseText: t("user:hideSystemPreferences")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                    hidden: !isVisibleList
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "locale",
                                                children: t("user:language")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                name: "locale",
                                                options: localeOptions,
                                                onChange: handleChange,
                                                onBlur: handleBlur
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "timezone",
                                                children: t("user:timezone")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "mb-2",
                                                children: t("user:timezoneDesc")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                name: "timezone",
                                                options: timezoneOptions,
                                                onChange: handleChange,
                                                onBlur: handleBlur
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            isSubmit: true,
                                            children: t("user:updateSystemPreferences")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        })
    });
};
var $fe92f60c3e9790bc$export$2e2bcd8739ae039 = $fe92f60c3e9790bc$var$UserConfigEditForm;

});

parcelRegister("4vOrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8161776080d42512$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("cxhNX");
var $gcL7X = parcelRequire("gcL7X");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $ai857 = parcelRequire("ai857");

var $6lvMC = parcelRequire("6lvMC");

var $4qaeN = parcelRequire("4qaeN");

var $kA27M = parcelRequire("kA27M");

var $9yMdm = parcelRequire("9yMdm");
const $8161776080d42512$var$UserPasswordEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "user",
        "shared"
    ]);
    const [isVisible, toggleVisible] = (0, $acw62.useState)(false);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const changePassword = (userId, data)=>{
        dispatch((0, $ai857.changePasswordAction)(userId, data));
    };
    const initialValues = {
        currentPassword: "",
        password: "",
        passwordConfirmation: ""
    };
    const validationSchema = (0, $9yMdm.setPasswordValidationSchema)().shape({
        currentPassword: $gcL7X.create().required(t("shared:Required"))
    });
    if (!user) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-left pl-4",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: validationSchema,
            onSubmit: async (values, { setSubmitting: setSubmitting, resetForm: resetForm })=>{
                changePassword(props.userId, values);
                resetForm();
                setSubmitting(false);
                toggleVisible(false);
            },
            children: ({ isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, values: values, errors: errors, touched: touched })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                        className: "flex-col mb-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center flex-wrap",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "mr-4 mb-2 text-lg",
                                    children: t("user:changePassword")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex mb-2 items-end",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "flex-1 pr-10 lg:pr-24"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                        isExpanded: isVisible,
                                        action: ()=>toggleVisible(!isVisible),
                                        expandText: t("shared:show"),
                                        collapseText: t("shared:hide")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                    hidden: !isVisible
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "currentPassword",
                                                children: t("user:currentPassword")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                type: "password",
                                                name: "currentPassword",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.currentPassword
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "password",
                                                children: t("user:password")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                type: "password",
                                                name: "password",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.password,
                                                autoComplete: "new-password"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.password,
                                                isVisible: errors.password && touched.password
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "passwordConfirmation",
                                                children: t("user:passwordConfirmation")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                type: "password",
                                                name: "passwordConfirmation",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.passwordConfirmation,
                                                autoComplete: "new-password"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.passwordConfirmation,
                                                isVisible: errors.passwordConfirmation && touched.passwordConfirmation
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            isSubmit: true,
                                            children: t("user:updatePassword")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        })
    });
};
var $8161776080d42512$export$2e2bcd8739ae039 = $8161776080d42512$var$UserPasswordEditForm;

});
parcelRegister("9yMdm", function(module, exports) {

$parcel$export(module.exports, "setPasswordValidationSchema", () => $1f04312078755fd2$export$8d116a932819e427);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $l6pyh = parcelRequire("l6pyh");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $1f04312078755fd2$export$8d116a932819e427 = ()=>{
    return $hDGtv.create().shape({
        password: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).matches(/[^a-zA-Z0-9]/, (0, $5wPBK.default).t("account:passwordMustContainSpecial")).matches(/[0-9]/, (0, $5wPBK.default).t("account:passwordMustContainNumber")).matches(/[A-Z]/, (0, $5wPBK.default).t("account:passwordMustContainUpperCase")).matches(/[a-z]/, (0, $5wPBK.default).t("account:passwordMustContainLowerCase")).min(8, (0, $5wPBK.default).t("account:passwordTooShort")),
        passwordConfirmation: $gcL7X.create().trim().oneOf([
            $l6pyh.create("password"),
            null
        ], (0, $5wPBK.default).t("account:passwordsMustMatch")).required((0, $5wPBK.default).t("shared:required"))
    });
};

});


parcelRegister("iYbS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $faea02af353c55b0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $8g1PZ = parcelRequire("8g1PZ");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $h5KXb = parcelRequire("h5KXb");
var $chRXN = parcelRequire("chRXN");

var $6t04b = parcelRequire("6t04b");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hMBTE = parcelRequire("hMBTE");
const $faea02af353c55b0$var$UserChangeTracking = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "user"
    ]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.userId));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chRXN.default), {
                            className: "fill-current w-6 h-6"
                        })
                    }),
                    user ? /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dt", {
                                className: "mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                            firstName: user.firstName,
                                            lastName: user.lastName,
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("font-semibold", {
                                                "text-center mb-3": !user.activeInCurrentTenant
                                            }),
                                            isPending: user.pending
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                                            hidden: !user.professionalTitle || user.professionalTitle.length == 0
                                        }),
                                        children: user.professionalTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "col-span-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "truncate",
                                    children: user.email
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5KXb.default), {
                        className: "fill-current w-6 h-6 md:ml-2",
                        title: t("shared:changeTracking")
                    }),
                    " ",
                    t("shared:changeTracking")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMBTE.AuditEventList), {
                currentUserId: props.userId,
                entityId: props.userId
            })
        ]
    });
};
var $faea02af353c55b0$export$2e2bcd8739ae039 = $faea02af353c55b0$var$UserChangeTracking;

});


parcelRegister("hPG5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b560d452b117874$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");

var $Nt2cC = parcelRequire("Nt2cC");

var $6lvMC = parcelRequire("6lvMC");
const $4b560d452b117874$var$SetPasswordPage = ()=>{
    const [token, setToken] = (0, $acw62.useState)(null);
    const apiToken = (0, $iD0SF.useSelector)((0, $6lvMC.getUserSession)).apiToken;
    (0, $acw62.useEffect)(()=>{
        if (apiToken) (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).MEETINGS);
    }, [
        apiToken
    ]);
    (0, $acw62.useEffect)(()=>{
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const token = params.get("token");
        if (!token) (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SIGN_IN);
        setToken(token);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Nt2cC.default), {
            token: token
        })
    });
};
var $4b560d452b117874$export$2e2bcd8739ae039 = $4b560d452b117874$var$SetPasswordPage;

});
parcelRegister("Nt2cC", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3e523634ad906d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");

var $4KSAX = parcelRequire("4KSAX");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $jF0Xa = parcelRequire("jF0Xa");

var $5YAlZ = parcelRequire("5YAlZ");

var $9yMdm = parcelRequire("9yMdm");

var $2ywbu = parcelRequire("2ywbu");
const $be3e523634ad906d$var$SetPasswordForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "account"
    ]);
    const initialValues = {
        password: "",
        passwordConfirmation: "",
        local: true,
        token: props.token
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $9yMdm.setPasswordValidationSchema),
            onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                // I don't really understand why we need to set the token here again
                // on the values,, the token should be coming from the initial values,
                // but, after having worked for a year or so, it suddenly broke.
                values.token = props.token;
                props.setPassword(values);
                setSubmitting(false);
            },
            children: ({ errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "text-lg mb-4",
                                    children: t("account:setPasswordTitle")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                t("account:passwordRulesHeader"),
                                ":",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "list-disc ml-5 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("account:passwordRuleSpecial"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("account:passwordRuleNumber"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("account:passwordRuleUpper"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("account:passwordRuleLower"),
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "password",
                                    children: t("account:password")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "password",
                                    name: "password",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.password,
                                    autoComplete: "off",
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.password,
                                    isVisible: errors.password && touched.password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "passwordConfirmation",
                                    children: t("account:passwordConfirmation")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "password",
                                    name: "passwordConfirmation",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.passwordConfirmation,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.passwordConfirmation,
                                    isVisible: errors.passwordConfirmation && touched.passwordConfirmation
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ywbu.default), {
                                    href: "/signin",
                                    children: t("account:signIn")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("account:setPassword")
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
const $be3e523634ad906d$var$mapDispatchToProps = (dispatch)=>{
    return {
        setPassword: (setPasswordData)=>dispatch((0, $5YAlZ.setPasswordAction)(setPasswordData))
    };
};
var $be3e523634ad906d$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $be3e523634ad906d$var$mapDispatchToProps)($be3e523634ad906d$var$SetPasswordForm);

});


parcelRegister("eEX4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e6cb9d0f280e14c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $051np = parcelRequire("051np");

var $g21Ia = parcelRequire("g21Ia");

var $aDFyu = parcelRequire("aDFyu");

var $9QVLZ = parcelRequire("9QVLZ");

var $7qa36 = parcelRequire("7qa36");

var $kQILj = parcelRequire("kQILj");

var $7xeph = parcelRequire("7xeph");

var $aeos3 = parcelRequire("aeos3");

var $1kXfn = parcelRequire("1kXfn");

var $39EfS = parcelRequire("39EfS");

var $kVlM3 = parcelRequire("kVlM3");

var $cthtS = parcelRequire("cthtS");

var $aZ4se = parcelRequire("aZ4se");

var $glc4D = parcelRequire("glc4D");
const $0e6cb9d0f280e14c$var$CasesPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getCasesUI)(state));
    const quickViewResourceId = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getQuickViewResourceId)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $g21Ia.fetchCasesAsync));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:cases")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-start-2 md:row-start-1 self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "case:searchBy",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            },
                            values: {
                                careProviderIdLabel: careProviderIdLabel
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-end-2 md:row-start-1 flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                buttonText: t("case:searchCases")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-2",
                children: [
                    UI.totalCasesCount,
                    " ",
                    t("shared:cases")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZ4se.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            orderByOptions: (0, $cthtS.CasesOrderByOptions),
                            useTranslation: "case"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $051np.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalCasesCount,
                totalPages: UI.totalPages
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7xeph.default), {
                    caseId: quickViewResourceId
                })
            })
        ]
    });
};
var $0e6cb9d0f280e14c$export$2e2bcd8739ae039 = $0e6cb9d0f280e14c$var$CasesPage;

});
parcelRegister("051np", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c6b59fbd5446ad$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $949n1 = parcelRequire("949n1");

var $kon2z = parcelRequire("kon2z");
const $22c6b59fbd5446ad$var$CaseList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const caseIds = (0, $iD0SF.useSelector)((0, $kon2z.getAllCaseIds));
    if (!caseIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("case:noCases")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: caseIds.map((caseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $949n1.default), {
                caseId: caseId
            }, caseId);
        })
    });
};
var $22c6b59fbd5446ad$export$2e2bcd8739ae039 = $22c6b59fbd5446ad$var$CaseList;

});
parcelRegister("949n1", function(module, exports) {

$parcel$export(module.exports, "default", () => $371083b9007f81ca$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $i4wYI = parcelRequire("i4wYI");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $kon2z = parcelRequire("kon2z");

var $aVAGa = parcelRequire("aVAGa");

var $ejvqu = parcelRequire("ejvqu");
const $371083b9007f81ca$var$CaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClickQuickView = (caseId)=>dispatch((0, $i4wYI.toggleIsQuickViewOpen)(caseId, true));
    if (!theCase) return null;
    const caseDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
        caseId: props.caseId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVAGa.default), {
        caseId: props.caseId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
            buttons: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    action: ()=>onClickQuickView(theCase.id),
                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                    className: "hidden md:block",
                    children: t("shared:quickView")
                }, "1"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    href: caseDetailsUrl,
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    children: t("shared:viewDetails")
                }, "2")
            ]
        })
    }, props.caseId);
};
var $371083b9007f81ca$export$2e2bcd8739ae039 = $371083b9007f81ca$var$CaseListItem;

});


parcelRegister("g21Ia", function(module, exports) {

$parcel$export(module.exports, "fetchCasesAsync", () => $dca60da380f5b70b$export$124f0758c3d555b9);

var $cCibL = parcelRequire("cCibL");
const $dca60da380f5b70b$export$124f0758c3d555b9 = (searchQuery)=>{
    return {
        type: (0, $cCibL.CasesActionTypes).FETCH_CASES_ASYNC_PENDING,
        payload: searchQuery
    };
};

});

parcelRegister("7xeph", function(module, exports) {

$parcel$export(module.exports, "default", () => $b656c06f46f97ee8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $aeos3 = parcelRequire("aeos3");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $6t04b = parcelRequire("6t04b");

var $1DXYh = parcelRequire("1DXYh");

var $j2STh = parcelRequire("j2STh");

var $kon2z = parcelRequire("kon2z");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $7hl6H = parcelRequire("7hl6H");

var $4SbNG = parcelRequire("4SbNG");
const $b656c06f46f97ee8$var$CaseQuickView = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getLeadCareUserByCaseId)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    if (!theCase) return null;
    const caseDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
        caseId: props.caseId
    });
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                            className: "fill-current w-6 h-6",
                            title: t("shared:case")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                                        href: caseDetailsUrl,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                            firstName: theCase.firstName,
                                            lastName: theCase.lastName,
                                            title: theCase.title,
                                            gender: theCase.gender
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-3",
                                children: [
                                    t("case:dateOfBirth"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                                        utcTime: theCase.dateOfBirth
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-1",
                                children: [
                                    healthcareIdLabel,
                                    ": ",
                                    theCase.healthcareId || "-"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-3",
                                children: [
                                    careProviderIdLabel,
                                    ": ",
                                    theCase.careProviderId || "-"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: renderLeadCare()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-3",
                                children: [
                                    t("case:lastUpdated"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: theCase.updatedAt
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        href: caseDetailsUrl,
                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                        children: t("shared:viewDetails")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4SbNG.default), {
                caseId: props.caseId
            })
        ]
    });
};
var $b656c06f46f97ee8$export$2e2bcd8739ae039 = $b656c06f46f97ee8$var$CaseQuickView;

});
parcelRegister("4SbNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e960b263c4bb733f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $gCJXL = parcelRequire("gCJXL");

var $d2Xij = parcelRequire("d2Xij");

var $iVDgl = parcelRequire("iVDgl");

var $kon2z = parcelRequire("kon2z");

var $2jvQG = parcelRequire("2jvQG");
const $e960b263c4bb733f$var$CaseQuickViewTabs = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    if (!theCase) return null;
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(0);
    const membersCount = theCase.members && theCase.members.length || 0;
    const meetingsCount = theCase.meetings && theCase.meetings.length || 0;
    const tabText1 = `${membersCount} ${t("shared:members")}`;
    const tabText2 = `${meetingsCount} ${t("shared:meetings")}`;
    const renderMembersList = ()=>{
        if (membersCount == 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(theCase.members, (userId)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2Xij.default), {
                    userId: userId
                }, userId);
            })
        });
    };
    const renderMeetingList = ()=>{
        if (meetingsCount == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "text-center text-ch-blue-alt-400",
                    children: t("case:noMeetings")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(theCase.meetings, (meetingId)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gCJXL.default), {
                    meetingId: meetingId
                }, meetingId);
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVDgl.default), {
                onClick: setCurrentTab,
                text1: tabText1,
                text2: tabText2,
                value: currentTab,
                className: "mb-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 0
                }),
                children: renderMembersList()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 1
                }),
                children: renderMeetingList()
            })
        ]
    });
};
var $e960b263c4bb733f$export$2e2bcd8739ae039 = $e960b263c4bb733f$var$CaseQuickViewTabs;

});
parcelRegister("gCJXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83e045a902b33c5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $f1q41 = parcelRequire("f1q41");

var $6bZ1D = parcelRequire("6bZ1D");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $4VtCQ = parcelRequire("4VtCQ");

var $laxqG = parcelRequire("laxqG");

var $6lvMC = parcelRequire("6lvMC");
const $e83e045a902b33c5$var$CaseMeetingList = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!props.meetingId || !meeting || !currentUser) return null;
    const userInMeeting = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(meeting.users, currentUser.id);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6bZ1D.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                        className: "fill-current w-6 h-6",
                        title: meeting.name
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $laxqG.default), {
                        meetingId: props.meetingId,
                        showCoordinator: true,
                        hasLink: userInMeeting,
                        showMeetingStatus: true
                    })
                })
            ]
        })
    });
};
var $e83e045a902b33c5$export$2e2bcd8739ae039 = $e83e045a902b33c5$var$CaseMeetingList;

});
parcelRegister("laxqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $784abc465f55fc13$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1DXYh = parcelRequire("1DXYh");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4VtCQ = parcelRequire("4VtCQ");

var $kN4w7 = parcelRequire("kN4w7");

var $8g1PZ = parcelRequire("8g1PZ");

var $3QK3n = parcelRequire("3QK3n");

var $32kQ2 = parcelRequire("32kQ2");

var $6t04b = parcelRequire("6t04b");

var $5wJjW = parcelRequire("5wJjW");
const $784abc465f55fc13$var$MeetingDetails = ({ hasLink: hasLink = true, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "meeting"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const coordinator = (0, $iD0SF.useSelector)((state)=>(0, $kN4w7.getMeetingCoordinator)(state, props));
    if (!meeting) return null;
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: props.meetingId
    });
    const renderMeetingName = ()=>{
        const renderText = ()=>{
            if (!hasLink) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: meeting.name
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                href: meetingDetailsUrl,
                children: meeting.name
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: renderText()
            })
        });
    };
    const renderCoordinatorDetails = ()=>{
        if (!coordinator || !props.showCoordinator) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("meeting:Coordinator"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: coordinator.firstName,
                    lastName: coordinator.lastName,
                    isPending: coordinator.pending
                })
            ]
        });
    };
    const renderMeetingTimeToStart = ()=>{
        if (!props.showMeetingStatus) return null;
        if (meeting.status !== (0, $32kQ2.MeetingStatuses).Scheduled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "text-ch-gray-alt-500",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                startDate: meeting.startDate
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("lg:grid", "gap-1"),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
            className: "col-span-1",
            children: [
                renderMeetingName(),
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: meeting.specialtyName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                        startDate: meeting.startDate,
                        endDate: meeting.endDate
                    })
                }),
                renderCoordinatorDetails(),
                renderMeetingTimeToStart()
            ]
        })
    });
};
var $784abc465f55fc13$export$2e2bcd8739ae039 = $784abc465f55fc13$var$MeetingDetails;

});


parcelRegister("d2Xij", function(module, exports) {

$parcel$export(module.exports, "default", () => $d902abb927a3bd93$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $6bZ1D = parcelRequire("6bZ1D");

var $l30Z2 = parcelRequire("l30Z2");
const $d902abb927a3bd93$var$CaseMemberListItem = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    if (!props.userId || !user) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bZ1D.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                user: user
            })
        })
    });
};
var $d902abb927a3bd93$export$2e2bcd8739ae039 = $d902abb927a3bd93$var$CaseMemberListItem;

});



parcelRegister("cthtS", function(module, exports) {

$parcel$export(module.exports, "CasesOrderByOptions", () => $6b50355964d89fd6$export$9e0970abd21b1aaf);
var $6b50355964d89fd6$export$9e0970abd21b1aaf = /*#__PURE__*/ function(CasesOrderByOptions) {
    CasesOrderByOptions["UpdatedDesc"] = "updated_desc";
    CasesOrderByOptions["UpdatedAsc"] = "updated_asc";
    CasesOrderByOptions["NameAsc"] = "name_asc";
    CasesOrderByOptions["NameDesc"] = "name_desc";
    CasesOrderByOptions["RecommendationDeadline"] = "recommendation_deadline_asc";
    CasesOrderByOptions["TargetDate"] = "target_date_asc";
    return CasesOrderByOptions;
}({});

});

parcelRegister("aZ4se", function(module, exports) {

$parcel$export(module.exports, "default", () => $d214b12469f144d2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $d214b12469f144d2$var$CaseFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("case:all")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("locked"),
                    action: ()=>{
                        updateFilters("locked");
                    },
                    children: t("case:locked")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("unlocked"),
                    action: ()=>{
                        updateFilters("unlocked");
                    },
                    children: t("case:unlocked")
                })
            })
        ]
    });
};
var $d214b12469f144d2$export$2e2bcd8739ae039 = $d214b12469f144d2$var$CaseFilter;

});


parcelRegister("hLLeY", function(module, exports) {

$parcel$export(module.exports, "CaseContext", () => $bf16b3fb03a665da$export$da29271b268a8ec2);
$parcel$export(module.exports, "default", () => $bf16b3fb03a665da$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6qYxq = parcelRequire("6qYxq");

var $kon2z = parcelRequire("kon2z");

var $2usJc = parcelRequire("2usJc");

var $9JDrq = parcelRequire("9JDrq");

var $7HZDe = parcelRequire("7HZDe");

var $bG4rq = parcelRequire("bG4rq");

var $8UrgM = parcelRequire("8UrgM");

var $kg0eN = parcelRequire("kg0eN");

var $fKHR9 = parcelRequire("fKHR9");

var $aDaal = parcelRequire("aDaal");

var $blYn7 = parcelRequire("blYn7");

var $h0rpN = parcelRequire("h0rpN");

var $e5EhV = parcelRequire("e5EhV");

var $et8Rr = parcelRequire("et8Rr");

var $cA1jy = parcelRequire("cA1jy");

var $6lvMC = parcelRequire("6lvMC");
const $bf16b3fb03a665da$export$da29271b268a8ec2 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $bf16b3fb03a665da$var$CasePage = ()=>{
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { caseId: caseId } = (0, $COwA0.useParams)();
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: caseId
        }));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "asset",
        "meeting",
        "caseReport",
        "userMessage"
    ]);
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(0);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchCase = (caseId)=>dispatch((0, $2usJc.fetchCaseAction)(caseId));
    const fetchCaseAssets = (caseId)=>dispatch((0, $7HZDe.fetchCaseAssetsAction)(caseId));
    const fetchCaseTasks = (caseId)=>dispatch((0, $blYn7.fetchCaseTasksAsync)(caseId));
    const fetchCasePathways = (caseId)=>dispatch((0, $h0rpN.fetchCasePathwaysAsync)(caseId));
    // TODO = return only users needed from case and meeting endpoints
    const fetchAllUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const fetchMeetings = (searchQuery)=>dispatch((0, $kg0eN.fetchMeetingsAsync)(searchQuery));
    (0, $e5EhV.useBeforeunload)(()=>{
        setConnectionRefresherIndex(connectionRefresherIndex + 1);
    });
    (0, $acw62.useEffect)(()=>{
        fetchCase(caseId);
        fetchCaseAssets(caseId);
        fetchAllUsers();
        if (!(0, $cA1jy.isGuest)(currentUser)) {
            fetchCaseTasks(caseId);
            fetchCasePathways(caseId);
            fetchMeetings(null);
        }
    }, []);
    if (!theCase) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("case:caseNotFound")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
        resourceId: caseId,
        channelName: (0, $6qYxq.CaseChannelName),
        actionPrefix: (0, $6qYxq.CaseCablePrefix),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($bf16b3fb03a665da$export$da29271b268a8ec2.Provider, {
            value: caseId,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9JDrq.default), {
                    caseId: caseId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bG4rq.default), {
                    caseId: caseId
                }),
                (0, $cA1jy.isGuest)(currentUser) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fKHR9.default), {
                    caseId: caseId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDaal.default), {
                    caseId: caseId
                })
            ]
        })
    }, connectionRefresherIndex);
};
var $bf16b3fb03a665da$export$2e2bcd8739ae039 = $bf16b3fb03a665da$var$CasePage;

});
parcelRegister("9JDrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e29510c614dca60$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $cOtzh = parcelRequire("cOtzh");

var $5v6Bi = parcelRequire("5v6Bi");

var $d5eYa = parcelRequire("d5eYa");

var $1Cmbh = parcelRequire("1Cmbh");

var $kon2z = parcelRequire("kon2z");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $eucKq = parcelRequire("eucKq");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $aGpn8 = parcelRequire("aGpn8");

var $COwA0 = parcelRequire("COwA0");

var $4VtCQ = parcelRequire("4VtCQ");

var $f1q41 = parcelRequire("f1q41");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $dF4fn = parcelRequire("dF4fn");

var $32kQ2 = parcelRequire("32kQ2");

var $6qmpz = parcelRequire("6qmpz");

var $2qME2 = parcelRequire("2qME2");

var $iOv3Y = parcelRequire("iOv3Y");

var $i4wYI = parcelRequire("i4wYI");

var $7qa36 = parcelRequire("7qa36");

var $4MHRb = parcelRequire("4MHRb");

var $9GoZH = parcelRequire("9GoZH");
const $3e29510c614dca60$var$CaseHeader = (props)=>{
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [meetingOptions, setMeetingOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meetings = (0, $iD0SF.useSelector)((0, $4VtCQ.getAllMeetingsAsArray));
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    (0, $acw62.useEffect)(()=>{
        // TODO: remove filtering here and only return meeting options from
        // the api that should be visible
        const filteredMeetingOptions = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(meetings, (meeting)=>{
            return meeting.status !== (0, $32kQ2.MeetingStatuses).Ended;
        });
        setMeetingOptions(filteredMeetingOptions.map((meeting)=>meeting.id));
    }, [
        meetings,
        theCase.meetings
    ]);
    if (!theCase?.id || !theCase?.permissions) return null;
    const renderEditButton = ()=>{
        if (!theCase.permissions.canEdit || theCase.locked) return null;
        const editCaseUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE_EDIT, {
            caseId: props.caseId
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: editCaseUrl,
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("case:editCase")
        }, "2");
    };
    const renderAddToMeetingButton = ()=>{
        if (theCase.permissions.canManage && !theCase.locked) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>openModal(),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("case:addToMeeting")
        }, "3");
        else return null;
    };
    const renderMeetingsToAdd = ()=>{
        // TODO: set up addMeetingToCase modal to mirror addCaseToMeeting modal
        // Bring this code out of the header and into top feature/redux level
        if (meetingOptions.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-lg",
                children: t("case:noCaseMeetings")
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "p-2",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(meetingOptions, (meetingId)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dF4fn.default), {
                        meetingId: meetingId,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6qmpz.default), {
                                    caseId: props.caseId,
                                    meetingId: meetingId
                                }, "4")
                            ]
                        })
                    }, meetingId);
                })
            })
        });
    };
    if (!theCase?.id || !theCase?.permissions) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                        breadcrumbs: [
                            {
                                pageTitle: t("shared:cases"),
                                href: (0, $6QJY8.RoutePaths).CASES
                            },
                            {
                                pageTitle: t("case:caseDetails")
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOtzh.default), {
                        hasPermission: theCase?.permissions?.canTrackChanges,
                        action: ()=>{
                            dispatch((0, $iOv3Y.fetchAuditEventsAsync)("Case", props.caseId));
                            dispatch((0, $4MHRb.fetchCaseClassificationAction)());
                            dispatch((0, $i4wYI.toggleIsQuickViewOpen)(props.caseId, true));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:case")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eucKq.default), {
                                caseId: props.caseId,
                                hasLink: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3Rc9I.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2qME2.default), {
                                        caseId: theCase.id
                                    }, "4"),
                                    renderEditButton(),
                                    renderAddToMeetingButton()
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-center lg:text-right mb-2 hidden",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aGpn8.default), {
                                    className: "uppercase inline-flex",
                                    caseId: props.caseId
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("case:addToMeetingIntro")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-ch-blue-600",
                                children: t("case:addToMeetingDesc1")
                            })
                        }),
                        renderMeetingsToAdd()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9GoZH.default), {
                    caseId: props.caseId
                })
            })
        ]
    });
};
var $3e29510c614dca60$export$2e2bcd8739ae039 = $3e29510c614dca60$var$CaseHeader;

});
parcelRegister("aGpn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1464e7122caa2ac8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $518YH = parcelRequire("518YH");

var $jF0Xa = parcelRequire("jF0Xa");

var $1DXYh = parcelRequire("1DXYh");
const $1464e7122caa2ac8$var$CaseWatchButton = ({ variant: variant = (0, $jF0Xa.StyleVariants).BLUE, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "liveMeeting"
    ]);
    const toggleWatchCase = (isWatchingCase)=>{
        console.log(`toggle watch case: ${isWatchingCase}`);
    };
    // TODO: Get from case
    const isWatchingCase = false;
    const renderWatchButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DXYh.default), {
            action: ()=>toggleWatchCase(false),
            className: props.className,
            variant: variant,
            children: [
                t("case:stopWatchingCase"),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $518YH.default), {
                    className: "w-6 h-6 ml-3"
                })
            ]
        });
    };
    const renderStopWatchingButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DXYh.default), {
            action: ()=>toggleWatchCase(true),
            className: props.className,
            variant: variant,
            children: [
                t("case:watchCase"),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $518YH.default), {
                    className: "w-6 h-6 ml-3"
                })
            ]
        });
    };
    return isWatchingCase ? renderStopWatchingButton() : renderWatchButton();
};
var $1464e7122caa2ac8$export$2e2bcd8739ae039 = $1464e7122caa2ac8$var$CaseWatchButton;

});

parcelRegister("dF4fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b39a535fda315e5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $daNS5 = parcelRequire("daNS5");
const $5b39a535fda315e5$var$MeetingListItemContainer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                                className: "fill-current w-6 h-6",
                                title: t("shared:meeting")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daNS5.default), {
                            meetingId: props.meetingId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: props.children
                })
            ]
        })
    });
};
var $5b39a535fda315e5$export$2e2bcd8739ae039 = $5b39a535fda315e5$var$MeetingListItemContainer;

});

parcelRegister("6qmpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $278f9b8555ba7df9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $kon2z = parcelRequire("kon2z");

var $99NRk = parcelRequire("99NRk");

var $6j1K3 = parcelRequire("6j1K3");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");
const $278f9b8555ba7df9$var$AddMeetingToCaseButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "meeting"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $99NRk.getMeetingCaseByMeetingAndCaseId)(state, props));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const createMeetingCase = (meetingId, caseId)=>dispatch((0, $6j1K3.createMeetingCaseAction)(meetingId, caseId));
    const deleteMeetingCase = (meetingId, caseId, meetingCaseId)=>dispatch((0, $6j1K3.deleteMeetingCaseAction)(meetingId, caseId, meetingCaseId));
    if (meetingCase) {
        if (meeting.status == (0, $32kQ2.MeetingStatuses).InProgress) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: t("meeting:caseInMeetingButStarted")
        });
        if (!meetingCase.permissions.canDelete) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>deleteMeetingCase(props.meetingId, props.caseId, meetingCase.id),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            className: "self-center self-end",
            isChunky: true,
            children: t("meeting:removeCaseFromMeeting")
        }, `removeCase-${props.meetingId}`);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: ()=>createMeetingCase(props.meetingId, theCase.id),
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        className: "self-center self-end",
        isChunky: true,
        children: t("meeting:addCaseToMeeting")
    }, `addCase-${props.meetingId}`);
};
var $278f9b8555ba7df9$export$2e2bcd8739ae039 = $278f9b8555ba7df9$var$AddMeetingToCaseButton;

});

parcelRegister("4MHRb", function(module, exports) {

$parcel$export(module.exports, "fetchCaseClassificationAction", () => $c7b64c6663f9cd58$export$1181c8b0f874ed1);

var $7k78k = parcelRequire("7k78k");
const $c7b64c6663f9cd58$export$1181c8b0f874ed1 = ()=>{
    return {
        type: (0, $7k78k.CaseClassificationActionTypes).FETCH_CASE_CLASSIFICATION_ASYNC_PENDING
    };
};

});

parcelRegister("9GoZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8d9f04125b1c65$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $6t04b = parcelRequire("6t04b");
parcelRequire("jitSV");
var $h5KXb = parcelRequire("h5KXb");
var $6Hpf8 = parcelRequire("6Hpf8");

var $kon2z = parcelRequire("kon2z");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");

var $hMBTE = parcelRequire("hMBTE");
const $cd8d9f04125b1c65$var$CaseChangeTracking = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const _case = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                            className: "fill-current w-6 h-6",
                            title: t("shared:_case")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                        firstName: _case.firstName,
                                        lastName: _case.lastName,
                                        title: _case.title,
                                        gender: _case.gender
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-3",
                                children: [
                                    t("case:dateOfBirth"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                                        utcTime: _case.dateOfBirth
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-1",
                                children: [
                                    healthcareIdLabel,
                                    ": ",
                                    _case.healthcareId || "-"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-3",
                                children: [
                                    careProviderIdLabel,
                                    ": ",
                                    _case.careProviderId || "-"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5KXb.default), {
                        className: "fill-current w-6 h-6 md:ml-2",
                        title: t("shared:changeTracking")
                    }),
                    " ",
                    t("shared:changeTracking")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMBTE.AuditEventList), {
                entityId: props.caseId
            })
        ]
    });
};
var $cd8d9f04125b1c65$export$2e2bcd8739ae039 = $cd8d9f04125b1c65$var$CaseChangeTracking;

});


parcelRegister("bG4rq", function(module, exports) {

$parcel$export(module.exports, "default", () => $46907af148d171f6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $gRDhG = parcelRequire("gRDhG");

var $kon2z = parcelRequire("kon2z");

var $bFoxZ = parcelRequire("bFoxZ");

var $cs1gl = parcelRequire("cs1gl");

var $4lapN = parcelRequire("4lapN");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");

var $7otXO = parcelRequire("7otXO");

var $2usJc = parcelRequire("2usJc");

var $kYqkq = parcelRequire("kYqkq");

var $fKaTC = parcelRequire("fKaTC");
const $46907af148d171f6$var$CaseMembers = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const [isVisibleList, toggleList] = (0, $acw62.useState)(false);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const [addMemberModalIsOpen, setAddMemberModalIsOpen] = (0, $acw62.useState)(false);
    const [inviteGuestUserModalIsOpen, setInviteGuestUserModalIsOpen] = (0, $acw62.useState)(false);
    const [shareAssetsModalIsOpen, setShareAssetsModalIsOpen] = (0, $acw62.useState)(false);
    const [selectedGuestUser, setSelectedGuestUser] = (0, $acw62.useState)(null);
    const { guestUsersEnabled: guestUsersEnabled } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    if (!theCase) return null;
    const renderAddMembersButtons = ()=>{
        if (!theCase.permissions?.canInvite || theCase.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex gap-2 flex-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFoxZ.default), {
                    openModal: ()=>{
                        setAddMemberModalIsOpen(true);
                        toggleList(true);
                    },
                    label: t("case:inviteMembers")
                }),
                guestUsersEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    action: ()=>setInviteGuestUserModalIsOpen(true),
                    className: "mb-2",
                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                    children: t("case:inviteGuest")
                }) : null
            ]
        });
    };
    const onClickShareAssets = (userId)=>{
        setSelectedGuestUser(userId);
        setShareAssetsModalIsOpen(true);
    };
    const onCloseShareAssetsModal = ()=>{
        dispatch((0, $2usJc.fetchCaseAction)(props.caseId));
        setShareAssetsModalIsOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("case:members"),
                                    " (",
                                    theCase.members?.length || 0,
                                    ")"
                                ]
                            }),
                            renderAddMembersButtons()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex mb-2 items-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "flex-1 pr-10 lg:pr-24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                    i18nKey: "case:caseUsersIntro",
                                    components: {
                                        strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                isExpanded: isVisibleList,
                                action: ()=>toggleList(!isVisibleList),
                                expandText: t("case:showUsers"),
                                collapseText: t("case:hideUsers")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                            hidden: !isVisibleList
                        }),
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(theCase.members, (userId)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRDhG.default), {
                                userId: userId,
                                caseId: props.caseId,
                                onClickShareAssets: onClickShareAssets
                            }, userId);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cs1gl.default), {
                caseId: props.caseId,
                isOpen: addMemberModalIsOpen,
                closeModal: ()=>setAddMemberModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4lapN.default), {
                caseId: props.caseId,
                isOpen: inviteGuestUserModalIsOpen,
                closeModal: ()=>setInviteGuestUserModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7otXO.default), {
                caseId: props.caseId,
                userId: selectedGuestUser,
                isOpen: shareAssetsModalIsOpen,
                closeModal: onCloseShareAssetsModal
            })
        ]
    });
};
var $46907af148d171f6$export$2e2bcd8739ae039 = $46907af148d171f6$var$CaseMembers;

});
parcelRegister("gRDhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8faa92e139ae947a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $ejvqu = parcelRequire("ejvqu");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $6lvMC = parcelRequire("6lvMC");

var $kon2z = parcelRequire("kon2z");

var $j0coJ = parcelRequire("j0coJ");

var $l30Z2 = parcelRequire("l30Z2");

var $2usJc = parcelRequire("2usJc");

var $dhTDp = parcelRequire("dhTDp");

var $cA1jy = parcelRequire("cA1jy");

var $eDQDM = parcelRequire("eDQDM");
const $8faa92e139ae947a$var$CaseMemberListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case",
        "shared"
    ]);
    const [buttonClicked, setButtonClicked] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const caseMembersStatus = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseMembersStatus)(state, props));
    const renderLead = ()=>{
        if (theCase.leadCareUser == props.userId) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "flex uppercase font-thin text-ch-green-300 items-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-ch-gray-600",
                children: t("case:leadCare")
            })
        });
    };
    const removeMemberFromCase = ()=>{
        setButtonClicked(true);
        const data = {
            ...theCase,
            memberIds: theCase.members.filter((user)=>user !== props.userId)
        };
        dispatch((0, $2usJc.updateCaseMembers)(data));
    };
    const renderNoAssetsSharedWarning = ()=>{
        if (!(0, $cA1jy.isGuest)(user) || caseMembersStatus[props.userId]?.sharedAssetCount > 0) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "basis-full w-full mt-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDQDM.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: t("case:guestUsers:text:noAssetsShared")
                })
            })
        });
    };
    if (!user || !theCase) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    className: "flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                            user: user
                        }),
                        renderNoAssetsSharedWarning()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dhTDp.default), {
                                action: props.onClickShareAssets,
                                canShareAssets: theCase.permissions.canShareAsset && (0, $cA1jy.isGuest)(user),
                                userId: props.userId,
                                caseId: props.caseId
                            }, 1),
                            renderLead() || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0coJ.default), {
                                action: removeMemberFromCase,
                                label: t("shared:remove"),
                                canRemove: theCase.permissions.canInvite && theCase.leadCareUser !== props.userId && !theCase.locked,
                                submitting: buttonClicked
                            }, 2)
                        ]
                    })
                })
            ]
        })
    });
};
var $8faa92e139ae947a$export$2e2bcd8739ae039 = $8faa92e139ae947a$var$CaseMemberListItem;

});
parcelRegister("dhTDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7098b11f8113f5f3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
const $7098b11f8113f5f3$var$ShareAssetsButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    if (!props.canShareAssets) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        variant: (0, $jF0Xa.StyleVariants).BLUE,
        action: ()=>props.action(props.userId),
        children: t("case:guestUsers:buttons:shareAssets")
    });
};
var $7098b11f8113f5f3$export$2e2bcd8739ae039 = $7098b11f8113f5f3$var$ShareAssetsButton;

});


parcelRegister("cs1gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $29293b5324df1fe1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $kon2z = parcelRequire("kon2z");

var $lOcoE = parcelRequire("lOcoE");

var $2usJc = parcelRequire("2usJc");
const $29293b5324df1fe1$var$CaseMemberAddModal = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const updateUsers = (values, { setSubmitting: setSubmitting })=>{
        const data = {
            id: theCase.id,
            memberIds: [
                ...theCase.members,
                ...values.users
            ],
            teamIds: values.teams
        };
        dispatch((0, $2usJc.updateCaseMembers)(data));
        setSubmitting(false);
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("case:inviteMembersIntro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600",
                            children: t("case:inviteMembersDesc1")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600",
                            children: t("case:inviteMembersDesc2")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOcoE.default), {
                        submitHandler: updateUsers,
                        excludedUserIds: theCase.members,
                        userLabel: t("shared:chooseUsers", {
                            user: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).lowerCase(t("shared:member"))
                        }),
                        teamUserListHeader: t("case:teamUserListHeader"),
                        includeGuests: true,
                        buttonText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "shared:addUsers",
                            values: {
                                users: t("shared:members"),
                                entity: t("shared:case")
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $29293b5324df1fe1$export$2e2bcd8739ae039 = $29293b5324df1fe1$var$CaseMemberAddModal;

});

parcelRegister("4lapN", function(module, exports) {

$parcel$export(module.exports, "default", () => $218217821f586ce9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $9iYHd = parcelRequire("9iYHd");

var $1wzMb = parcelRequire("1wzMb");

var $iVDgl = parcelRequire("iVDgl");
const $218217821f586ce9$var$CaseGuestUserAddModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const [formToUse, setFormToUse] = (0, $acw62.useState)(0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("case:guestUsers:titles:inviteGuestUser")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVDgl.default), {
                    text1: t("case:guestUsers:buttons:InviteGuestUsers"),
                    text2: t("case:guestUsers:buttons:createGuestUser"),
                    onClick: (n)=>setFormToUse(n),
                    value: formToUse
                }),
                formToUse == 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "text-ch-blue-600 mb-2",
                            children: t("case:guestUsers:text:inviteExistingGuestUserInfo")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1wzMb.default), {
                            caseId: props.caseId,
                            closeModal: props.closeModal
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "text-ch-blue-600 mb-2",
                            children: t("case:guestUsers:text:addNewGuestUserInfo")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iYHd.default), {
                                caseId: props.caseId,
                                closeModal: props.closeModal
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $218217821f586ce9$export$2e2bcd8739ae039 = $218217821f586ce9$var$CaseGuestUserAddModal;

});
parcelRegister("9iYHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $46256cebac85e47c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $8UrgM = parcelRequire("8UrgM");

var $lxAyE = parcelRequire("lxAyE");


var $cjnbD = parcelRequire("cjnbD");

var $ai857 = parcelRequire("ai857");

var $dBkgc = parcelRequire("dBkgc");
const $46256cebac85e47c$var$CaseGuestUserNewForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const allUsers = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    const initialValues = {
        title: "",
        professionalTitle: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        specialtyIds: []
    };
    const usersEmail = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(allUsers, "email");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $cjnbD.caseGuestUserNewValidationSchema)(usersEmail),
        validateOnMount: true,
        onSubmit: async (values)=>{
            const phoneNumberData = (0, $lxAyE.parsePhoneNumber)(values.phoneNumber);
            const data = {
                ...values,
                phoneNumber: phoneNumberData.nationalNumber,
                phoneCountryCode: phoneNumberData.countryCallingCode
            };
            dispatch((0, $ai857.createCaseGuestUser)(props.caseId, data));
            props.closeModal();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "HI"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dBkgc.default), {
                    ...props
                })
            ]
        })
    });
};
var $46256cebac85e47c$export$2e2bcd8739ae039 = $46256cebac85e47c$var$CaseGuestUserNewForm;

});

parcelRegister("1wzMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d246bd2713947a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $6wDTk = parcelRequire("6wDTk");

var $04A9g = parcelRequire("04A9g");

var $cA1jy = parcelRequire("cA1jy");

var $kon2z = parcelRequire("kon2z");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $8UrgM = parcelRequire("8UrgM");

var $2usJc = parcelRequire("2usJc");

var $2hxLr = parcelRequire("2hxLr");
const $c0d246bd2713947a$var$InviteExistingGuestUsersForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllActiveUsersSortedFirstNameLastName)(state));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const availableGuestUsers = users.filter((user)=>{
            return (0, $cA1jy.isGuest)(user) && !theCase.members.includes(user.id);
        });
        const options = (0, $6wDTk.buildUserOptions)(Object.values(availableGuestUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    const initialValues = {
        guestUserIds: []
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $2hxLr.caseGuestUserInviteExistingValidation),
        onSubmit: async (values, { setSubmitting: setSubmitting })=>{
            const data = {
                id: theCase.id,
                memberIds: [
                    ...theCase.members,
                    ...values.guestUserIds
                ]
            };
            dispatch((0, $2usJc.updateCaseMembers)(data));
            setSubmitting(false);
            props.closeModal();
        },
        children: ({ isSubmitting: isSubmitting, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "guestUserIds",
                                children: t("case:guestUsers:labels:chooseExistingGuestUsers")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                name: "guestUserIds",
                                options: userOptions,
                                isMulti: true,
                                onChange: handleChange,
                                onBlur: handleBlur,
                                filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.guestUserIds,
                                isVisible: errors.guestUserIds && touched.guestUserIds
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                        className: "mb-2",
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>{
                                    props.closeModal();
                                },
                                variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                children: t("shared:cancel")
                            }, "1"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("case:guestUsers:buttons:InviteGuestUsers")
                            }, 2)
                        ]
                    })
                ]
            });
        }
    });
};
var $c0d246bd2713947a$export$2e2bcd8739ae039 = $c0d246bd2713947a$var$InviteExistingGuestUsersForm;

});
parcelRegister("2hxLr", function(module, exports) {

$parcel$export(module.exports, "caseGuestUserInviteExistingValidation", () => $ca93c8873769fd48$export$afd186a4a72d7d2b);
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $hDGtv = parcelRequire("hDGtv");

var $5wPBK = parcelRequire("5wPBK");
const $ca93c8873769fd48$export$afd186a4a72d7d2b = ()=>{
    return $hDGtv.create().shape({
        guestUserIds: $jpuYg.create().required((0, $5wPBK.default).t("shared:required")).min(1, (0, $5wPBK.default).t("shared:mustSelectAtLeastOne"))
    });
};

});



parcelRegister("7otXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b405d544e22f5ea$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $ieYD3 = parcelRequire("ieYD3");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $l30Z2 = parcelRequire("l30Z2");

var $cHsE4 = parcelRequire("cHsE4");
const $7b405d544e22f5ea$var$ShareAssetsModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.userId));
    const [isViewAssetModalOpen, setViewAssetModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedAssetId, setSelectedAssetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const openViewAssetModal = (selectedAssetId)=>{
        setSelectedAssetId(selectedAssetId);
        setViewAssetModalIsOpen(true);
    };
    const closeViewAssetModal = ()=>{
        setViewAssetModalIsOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cHsE4.default), {
                isOpen: isViewAssetModalOpen,
                closeModal: closeViewAssetModal,
                selectedAssetId: selectedAssetId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: props.isOpen,
                onRequestClose: props.closeModal,
                style: (0, $jF0Xa.bottomModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: props.closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("case:guestUsers:titles:shareAssets")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-ch-blue-600 mb-3",
                            children: t("case:guestUsers:text:selectAssetsToShare")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                            className: "mb-6",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                                    user: user
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ieYD3.default), {
                            caseId: props.caseId,
                            userId: props.userId,
                            openAssetModal: openViewAssetModal
                        })
                    ]
                })
            })
        ]
    });
};
var $7b405d544e22f5ea$export$2e2bcd8739ae039 = $7b405d544e22f5ea$var$ShareAssetsModal;

});
parcelRegister("ieYD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eabc79ba7b92f6b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $iTB0u = parcelRequire("iTB0u");

var $ap7JG = parcelRequire("ap7JG");

var $qCyer = parcelRequire("qCyer");
const $2eabc79ba7b92f6b$var$SelectSharedAssetsList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const assetIds = (0, $iD0SF.useSelector)((state)=>(0, $iTB0u.getCaseAssetsCanBeSharedWithUser)(state, props.caseId, props.userId));
    (0, $acw62.useEffect)(()=>{
        if (!props.userId) return;
        dispatch((0, $ap7JG.fetchCaseAssetsCanBeSharedWithUserAction)(props.caseId, props.userId));
    }, [
        props.userId
    ]);
    if (!assetIds) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("case:guestUsers:text:noAssetsToShare")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: assetIds?.map((assetId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $qCyer.default), {
                assetId: assetId,
                caseId: props.caseId,
                userId: props.userId,
                action: ()=>props.openAssetModal(assetId)
            }, assetId);
        })
    });
};
var $2eabc79ba7b92f6b$export$2e2bcd8739ae039 = $2eabc79ba7b92f6b$var$SelectSharedAssetsList;

});
parcelRegister("iTB0u", function(module, exports) {

$parcel$export(module.exports, "getCaseAssetsCanBeSharedWithUser", () => $e49279d7436f29a7$export$f67d857b641f8e7a);
$parcel$export(module.exports, "getSharedAssetById", () => $e49279d7436f29a7$export$c34b79af1f458680);
const $e49279d7436f29a7$var$EMPTY_ARRAY = [];
const $e49279d7436f29a7$export$f67d857b641f8e7a = (state, caseId, userId)=>{
    if (!state.entities.sharedAssets?.canBeSharedWithUserByUserId?.[userId]) return $e49279d7436f29a7$var$EMPTY_ARRAY;
    return state.entities.sharedAssets.canBeSharedWithUserByUserId[userId][caseId] || $e49279d7436f29a7$var$EMPTY_ARRAY;
};
const $e49279d7436f29a7$export$c34b79af1f458680 = (state, assetId)=>state.entities.sharedAssets.byId[assetId];

});

parcelRegister("ap7JG", function(module, exports) {

$parcel$export(module.exports, "fetchCaseAssetsCanBeSharedWithUserAction", () => $c8e0d894996e7396$export$70422ab30fe2c67c);
$parcel$export(module.exports, "createCaseSharedAssetAction", () => $c8e0d894996e7396$export$65e4eacbf62a2d61);
$parcel$export(module.exports, "deleteCaseSharedAssetAction", () => $c8e0d894996e7396$export$dd336b5ef7f91ec);

var $dUFb6 = parcelRequire("dUFb6");
const $c8e0d894996e7396$export$70422ab30fe2c67c = (caseId, userId)=>{
    return {
        type: (0, $dUFb6.CaseSharedAssetsActionTypes).FETCH_CASE_ASSETS_CAN_BE_SHARED_WITH_USER_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            userId: userId
        }
    };
};
const $c8e0d894996e7396$export$65e4eacbf62a2d61 = (caseId, caseAssetId, userId)=>{
    return {
        type: (0, $dUFb6.CaseSharedAssetsActionTypes).CREATE_CASE_SHARED_ASSET_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            caseAssetId: caseAssetId,
            userId: userId
        }
    };
};
const $c8e0d894996e7396$export$dd336b5ef7f91ec = (caseId, userSharedAssetId, userId)=>{
    return {
        type: (0, $dUFb6.CaseSharedAssetsActionTypes).DELETE_CASE_SHARED_ASSET_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            userSharedAssetId: userSharedAssetId,
            userId: userId
        }
    };
};

});

parcelRegister("qCyer", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c28074570d3faa5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hVO2M = parcelRequire("hVO2M");

var $1Uwmi = parcelRequire("1Uwmi");

var $iTB0u = parcelRequire("iTB0u");

var $hLSum = parcelRequire("hLSum");

var $7twpo = parcelRequire("7twpo");
const $7c28074570d3faa5$var$SelectSharedAssetListItem = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $iTB0u.getSharedAssetById)(state, props.assetId));
    if (!asset) return null;
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponetType];
    const clickableComponents = [
        (0, $7twpo.AssetComponentTypes).Pdf,
        (0, $7twpo.AssetComponentTypes).Image,
        (0, $7twpo.AssetComponentTypes).CaseReport
    ];
    const clickAction = clickableComponents.includes(assetComponetType) ? props.action : undefined;
    const renderButton = ()=>{
        if (asset.userSharedAssetId) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLSum.default), {
            userSharedAssetId: asset.userSharedAssetId,
            caseId: props.caseId,
            userId: props.userId
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Uwmi.default), {
            assetId: props.assetId,
            caseId: props.caseId,
            userId: props.userId
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "mb-1",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
            assetId: props.assetId,
            caseId: props.caseId,
            action: clickAction,
            noAction: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-wrap content-top h-8 ml-2 mt-1 justify-contents-end",
                children: renderButton()
            })
        })
    });
};
var $7c28074570d3faa5$export$2e2bcd8739ae039 = $7c28074570d3faa5$var$SelectSharedAssetListItem;

});
parcelRegister("1Uwmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2f219f5d3ffac4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $ap7JG = parcelRequire("ap7JG");
const $2e2f219f5d3ffac4$var$AddSharedAssetButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [clicked, setClicked] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClick = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (!clicked) {
            setClicked(true);
            dispatch((0, $ap7JG.createCaseSharedAssetAction)(props.caseId, props.assetId, props.userId));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: onClick,
        isChunky: false,
        variant: (0, $jF0Xa.StyleVariants).BLUE,
        className: "h-8",
        children: t("case:selectAsset")
    });
};
var $2e2f219f5d3ffac4$export$2e2bcd8739ae039 = $2e2f219f5d3ffac4$var$AddSharedAssetButton;

});

parcelRegister("hLSum", function(module, exports) {

$parcel$export(module.exports, "default", () => $747dd251d1305394$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $ap7JG = parcelRequire("ap7JG");
const $747dd251d1305394$var$RemoveSharedAssetButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [clicked, setClicked] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const onClick = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (!clicked) {
            setClicked(true);
            dispatch((0, $ap7JG.deleteCaseSharedAssetAction)(props.caseId, props.userSharedAssetId, props.userId));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: onClick,
        isChunky: false,
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        className: "h-8",
        children: t("case:deselectAsset")
    });
};
var $747dd251d1305394$export$2e2bcd8739ae039 = $747dd251d1305394$var$RemoveSharedAssetButton;

});



parcelRegister("cHsE4", function(module, exports) {

$parcel$export(module.exports, "CaseAssetModalContext", () => $b01555a420c07a7a$export$c26156278d3b2a57);
$parcel$export(module.exports, "default", () => $b01555a420c07a7a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $dArHa = parcelRequire("dArHa");
const $b01555a420c07a7a$export$c26156278d3b2a57 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $b01555a420c07a7a$var$ViewAssetModal = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b01555a420c07a7a$export$c26156278d3b2a57.Provider, {
                value: {
                    closeModal: props.closeModal
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dArHa.default), {
                    assetId: props.selectedAssetId
                })
            })
        })
    });
};
var $b01555a420c07a7a$export$2e2bcd8739ae039 = $b01555a420c07a7a$var$ViewAssetModal;

});
parcelRegister("dArHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cdcdc8faf91efd6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $7twpo = parcelRequire("7twpo");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");

var $426KE = parcelRequire("426KE");

var $69GgW = parcelRequire("69GgW");

var $ar9Yt = parcelRequire("ar9Yt");

var $hgRGJ = parcelRequire("hgRGJ");

var $b7bRK = parcelRequire("b7bRK");
const $7cdcdc8faf91efd6$var$CaseAssetViewer = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "asset"
    ]);
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:assetNotFound")
    });
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const componentLookup = {
        [(0, $7twpo.AssetComponentTypes).Pdf]: (0, $ar9Yt.default),
        [(0, $7twpo.AssetComponentTypes).Image]: (0, $69GgW.default),
        [(0, $7twpo.AssetComponentTypes).CaseReport]: (0, $ar9Yt.default),
        [(0, $7twpo.AssetComponentTypes).RadiologyLink]: (0, $hgRGJ.default),
        [(0, $7twpo.AssetComponentTypes).Form]: (0, $b7bRK.default)
    };
    const AssetViewer = componentLookup[assetComponetType];
    if (!AssetViewer) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("asset:couldNotDisplayAsset")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col w-full h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute w-full top-0 left-0 z-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $426KE.default), {
                    assetId: props.assetId
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 min-h-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(AssetViewer, {
                    assetId: props.assetId
                })
            })
        ]
    });
};
var $7cdcdc8faf91efd6$export$2e2bcd8739ae039 = $7cdcdc8faf91efd6$var$CaseAssetViewer;

});
parcelRegister("426KE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b634f57468840061$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");

var $7twpo = parcelRequire("7twpo");
const $b634f57468840061$var$CaseAssetViewerHeading = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    if (!asset) return null;
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const headingLookup = {
        [(0, $7twpo.AssetComponentTypes).Pdf]: asset.asset.name,
        [(0, $7twpo.AssetComponentTypes).Image]: asset.asset.name
    };
    const headingText = headingLookup[assetComponentType];
    if (!headingText) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "flex items-center justify-center flex-1 font-thin",
        children: headingText
    });
};
var $b634f57468840061$export$2e2bcd8739ae039 = $b634f57468840061$var$CaseAssetViewerHeading;

});

parcelRegister("69GgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b1bb107f72b85e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lxTgp = parcelRequire("lxTgp");

var $eoSy7 = parcelRequire("eoSy7");

var $aEgqS = parcelRequire("aEgqS");
const $40b1bb107f72b85e$var$CaseImageViewer = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    if (!asset) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const image = asset.asset;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eoSy7.default), {
        imageSrc: image.path
    });
};
var $40b1bb107f72b85e$export$2e2bcd8739ae039 = $40b1bb107f72b85e$var$CaseImageViewer;

});

parcelRegister("ar9Yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a8f4e87b3d4555$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aEgqS = parcelRequire("aEgqS");

var $3Npjv = parcelRequire("3Npjv");

var $jUk5c = parcelRequire("jUk5c");

var $lxTgp = parcelRequire("lxTgp");
const $59a8f4e87b3d4555$var$CasePdfViewer = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const pdf = asset.asset;
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        (0, $jUk5c.default)(pdf.path, setBlobUrl);
    }, [
        pdf.path
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Npjv.default), {
        url: blobUrl,
        filename: `${pdf.name}`
    });
};
var $59a8f4e87b3d4555$export$2e2bcd8739ae039 = $59a8f4e87b3d4555$var$CasePdfViewer;

});

parcelRegister("b7bRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64520967e16c2aa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lxTgp = parcelRequire("lxTgp");

var $ar9Yt = parcelRequire("ar9Yt");

var $flerD = parcelRequire("flerD");

var $kYqkq = parcelRequire("kYqkq");
const $e64520967e16c2aa$var$CaseFormViewer = (props)=>{
    const asset = (0, $kYqkq.useAppSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const form = asset.asset;
    if (form.path) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ar9Yt.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $flerD.default), {
        ...props
    });
};
var $e64520967e16c2aa$export$2e2bcd8739ae039 = $e64520967e16c2aa$var$CaseFormViewer;

});
parcelRegister("flerD", function(module, exports) {

$parcel$export(module.exports, "default", () => $39dc119b64d4b49b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aEgqS = parcelRequire("aEgqS");

var $lxTgp = parcelRequire("lxTgp");

var $hLLeY = parcelRequire("hLLeY");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $cHsE4 = parcelRequire("cHsE4");

var $kYqkq = parcelRequire("kYqkq");

var $kLdzU = parcelRequire("kLdzU");
const $39dc119b64d4b49b$var$CaseFormIframeViewer = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const form = asset.asset;
    const [formUrl, setFormUrl] = (0, $acw62.useState)(null);
    const caseId = (0, $acw62.useContext)((0, $hLLeY.CaseContext));
    const { closeModal: closeModal } = (0, $acw62.useContext)((0, $cHsE4.CaseAssetModalContext));
    const dispatch = (0, $kYqkq.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        const handleMessage = (event)=>{
            console.log(event.data);
            if (event.data?.type === "formComplete") {
                closeModal();
                dispatch((0, $kLdzU.markFormCompleteAction)(caseId, form.id));
            }
            if (event.data?.type === "formSaved") closeModal();
        };
        window.addEventListener("message", handleMessage);
        return ()=>window.removeEventListener("message", handleMessage);
    }, []);
    (0, $acw62.useEffect)(()=>{
        // I'm not doing this in a saga, as ususal, as this is really just setting a
        // state for this component and can't really be used anywhere else.
        (0, $5s7Tw.default).get(`/cases/${caseId}/forms/${form.id}/embed`, (0, $1zizz.withAuthHeader)()).then((a)=>setFormUrl(a.data.location));
    }, []);
    if (!formUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
        className: "w-full h-full",
        src: formUrl
    });
};
var $39dc119b64d4b49b$export$2e2bcd8739ae039 = $39dc119b64d4b49b$var$CaseFormIframeViewer;

});
parcelRegister("kLdzU", function(module, exports) {

$parcel$export(module.exports, "fetchFormsForCaseAsync", () => $80f69e0788488017$export$e829696b839e03ed);
$parcel$export(module.exports, "createFormForCaseAction", () => $80f69e0788488017$export$1a5c726bbf530f2c);
$parcel$export(module.exports, "markFormCompleteAction", () => $80f69e0788488017$export$ccf3838b478fa23c);

var $udwHW = parcelRequire("udwHW");
const $80f69e0788488017$export$e829696b839e03ed = (searchQuery)=>{
    return {
        type: (0, $udwHW.AddFormToCaseActionTypes).FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $80f69e0788488017$export$1a5c726bbf530f2c = (caseId, formTemplateId, meetingCaseId)=>{
    return {
        type: (0, $udwHW.AddFormToCaseActionTypes).CREATE_FORM_FOR_CASE_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            formTemplateId: formTemplateId,
            meetingCaseId: meetingCaseId
        }
    };
};
const $80f69e0788488017$export$ccf3838b478fa23c = (caseId, formId)=>{
    return {
        type: (0, $udwHW.AddFormToCaseActionTypes).MARK_FORM_COMPLETE_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            formId: formId
        }
    };
};

});







parcelRegister("fKHR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $db859102649873a4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $bjGFW = parcelRequire("bjGFW");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $kon2z = parcelRequire("kon2z");

var $eq3HP = parcelRequire("eq3HP");
const $db859102649873a4$var$CaseMeetingUsers = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const userIds = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getUserIdsForCaseMeetings)(state, props));
    const [isVisibleList, toggleList] = (0, $acw62.useState)(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const caseMeetingOnlyUserIds = userIds.filter((id)=>!theCase.members.includes(id));
    if (!theCase || !theCase.members) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center flex-wrap",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "mr-4 mb-2 text-lg",
                        children: [
                            t("case:otherParticipants"),
                            " (",
                            caseMeetingOnlyUserIds.length,
                            ")"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex mb-2 items-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "case:otherParticipantsIntro",
                                components: {
                                    strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                            isExpanded: isVisibleList,
                            action: ()=>toggleList(!isVisibleList),
                            expandText: t("case:showUsers"),
                            collapseText: t("case:hideUsers")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                        hidden: !isVisibleList
                    }),
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(caseMeetingOnlyUserIds, (userId)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjGFW.ErrorBoundary), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eq3HP.default), {
                                userId: userId,
                                caseId: props.caseId,
                                meetingIds: theCase.meetings
                            }, userId)
                        }, userId);
                    })
                })
            ]
        })
    });
};
var $db859102649873a4$export$2e2bcd8739ae039 = $db859102649873a4$var$CaseMeetingUsers;

});
parcelRegister("eq3HP", function(module, exports) {

$parcel$export(module.exports, "default", () => $239f6f35d301099a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $kon2z = parcelRequire("kon2z");

var $lNFkE = parcelRequire("lNFkE");

var $4VtCQ = parcelRequire("4VtCQ");

var $1DXYh = parcelRequire("1DXYh");

var $jF0Xa = parcelRequire("jF0Xa");

var $6lvMC = parcelRequire("6lvMC");

var $l30Z2 = parcelRequire("l30Z2");
const $239f6f35d301099a$var$CaseMeetingUserListItem = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meetings = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingsByIdsAsArray)(state, props));
    const [isFullList, toggleIsFullList] = (0, $acw62.useState)(false);
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const userMeetings = meetings.filter((meeting)=>theCase.meetings.includes(meeting.id) && meeting.users && meeting.users.includes(props.userId));
    const maxDisplayLength = 1;
    if (!user || !theCase || !meetings) return null;
    const renderMeetingList = ()=>{
        if (userMeetings.length <= maxDisplayLength) return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(userMeetings, (meeting)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lNFkE.default), {
                    meetingId: meeting.id
                }, meeting.id);
            })
        });
        else {
            const meetingsToRender = isFullList ? userMeetings : userMeetings.slice(0, maxDisplayLength);
            const transKey = isFullList ? "case:hideMeetings" : "case:viewMoreMeetings";
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                children: [
                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(meetingsToRender, (meeting)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lNFkE.default), {
                            meetingId: meeting.id
                        }, meeting.id);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-center mt-2 lg:text-left lg:ml-8",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                            action: ()=>toggleIsFullList(!isFullList),
                            className: "inline-flex",
                            variant: (0, $jF0Xa.StyleVariants).BLUE,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: transKey,
                                values: {
                                    number: userMeetings.length - maxDisplayLength
                                }
                            })
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    className: "md:w-1/2",
                    children: renderMeetingList()
                })
            ]
        })
    });
};
var $239f6f35d301099a$export$2e2bcd8739ae039 = $239f6f35d301099a$var$CaseMeetingUserListItem;

});
parcelRegister("lNFkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12aba6d52658a37$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $4VtCQ = parcelRequire("4VtCQ");

var $7hl6H = parcelRequire("7hl6H");
const $d12aba6d52658a37$var$CaseMeetingUserMeetingListItem = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    if (!meeting) return null;
    const displaySpecialty = " - " + meeting.specialtyName + " - ";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: "flex flex-row",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                    className: "fill-current text-ch-purple-500 w-6 h-6 mr-2",
                    title: meeting.name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-semibold",
                        children: meeting.name
                    }),
                    displaySpecialty,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                        utcTime: meeting.startDate
                    })
                ]
            })
        ]
    });
};
var $d12aba6d52658a37$export$2e2bcd8739ae039 = $d12aba6d52658a37$var$CaseMeetingUserMeetingListItem;

});



parcelRegister("aDaal", function(module, exports) {

$parcel$export(module.exports, "default", () => $71effc286747657a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4qaeN = parcelRequire("4qaeN");

var $kon2z = parcelRequire("kon2z");

var $ZQZCX = parcelRequire("ZQZCX");

var $4jQEM = parcelRequire("4jQEM");

var $jWomF = parcelRequire("jWomF");

var $82PCs = parcelRequire("82PCs");

var $aeos3 = parcelRequire("aeos3");

var $6lvMC = parcelRequire("6lvMC");

var $cA1jy = parcelRequire("cA1jy");
const $71effc286747657a$var$CaseActivity = (props)=>{
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { pathwaysEnabled: pathwaysEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const mentionableUsers = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseMemberUsers)(state, {
            caseId: props.caseId
        }));
    const generateTabPath = (currentTab)=>{
        return (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
            caseId: props.caseId,
            currentTab: currentTab
        });
    };
    const renderCaseTaskPanel = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jQEM.default), {
                caseId: props.caseId,
                mentionableUsers: mentionableUsers
            })
        });
    };
    const renderCasePathwayPanel = ()=>{
        if ((0, $cA1jy.isGuest)(currentUser) || !pathwaysEnabled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82PCs.default), {
                caseId: props.caseId
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lg:grid grid-cols-2 gap-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZQZCX.default), {
                            caseId: props.caseId,
                            mentionableUsers: mentionableUsers
                        })
                    }),
                    renderCaseTaskPanel(),
                    renderCasePathwayPanel()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jWomF.default), {
                        caseId: props.caseId,
                        mentionableUsers: mentionableUsers,
                        generateTabPath: generateTabPath
                    })
                })
            })
        ]
    });
};
var $71effc286747657a$export$2e2bcd8739ae039 = $71effc286747657a$var$CaseActivity;

});
parcelRegister("ZQZCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b0361b928ef349$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1l1FS = parcelRequire("1l1FS");

var $kon2z = parcelRequire("kon2z");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $6UIB2 = parcelRequire("6UIB2");
parcelRequire("jitSV");
var $7wpDl = parcelRequire("7wpDl");
var $8Jzjq = parcelRequire("8Jzjq");

var $kWjiq = parcelRequire("kWjiq");

var $cHh3Y = parcelRequire("cHh3Y");

var $g3Umr = parcelRequire("g3Umr");

var $6LReM = parcelRequire("6LReM");

var $2jvQG = parcelRequire("2jvQG");

var $jWomF = parcelRequire("jWomF");

var $6lvMC = parcelRequire("6lvMC");

var $cA1jy = parcelRequire("cA1jy");

var $5jwmE = parcelRequire("5jwmE");

var $fKaTC = parcelRequire("fKaTC");

var $dA2J6 = parcelRequire("dA2J6");

var $lswkt = parcelRequire("lswkt");
var $87b0361b928ef349$export$b2539bed5023c21c = /*#__PURE__*/ function(Tabs) {
    Tabs["CommentNew"] = "comment_new";
    Tabs["DecisionNew"] = "decision_new";
    Tabs["RecommendationNew"] = "recommendation_new";
    Tabs["RadiologyLinkNew"] = "radiology_link_new";
    Tabs["LinkNew"] = "link_new";
    Tabs["UploadFile"] = "upload_file";
    return Tabs;
}({});
const $87b0361b928ef349$var$AddCaseAssetPanel = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(null);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const { contextFormsEnabled: contextFormsEnabled, radiologyEnabled: radiologyEnabled } = (0, $iD0SF.useSelector)((0, $fKaTC.getTenantConfig));
    const [formsModalOpen, openFormsModal, closeFormsModal] = (0, $dA2J6.default)();
    const switchToNewAssetTab = ()=>{
        if (props.meetingId) (0, $1l1FS.default).replace((0, $jWomF.CaseAssetTabNames).MEETING_ASSETS);
        else (0, $1l1FS.default).replace((0, $jWomF.CaseAssetTabNames).ASSETS);
    };
    const renderTabContent = ()=>{
        switch(currentTab){
            case "comment_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6UIB2.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    mentionableUsers: props.mentionableUsers,
                    switchToNewAssetTab: switchToNewAssetTab
                });
            case "decision_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kWjiq.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    mentionableUsers: props.mentionableUsers,
                    switchToNewAssetTab: switchToNewAssetTab
                });
            case "recommendation_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cHh3Y.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    mentionableUsers: props.mentionableUsers,
                    switchToNewAssetTab: switchToNewAssetTab
                });
            case "link_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g3Umr.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    switchToNewAssetTab: switchToNewAssetTab
                });
            case "radiology_link_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5jwmE.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    switchToNewAssetTab: switchToNewAssetTab
                });
            case "upload_file":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6LReM.default), {
                    caseId: props.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    switchToNewAssetTab: switchToNewAssetTab
                });
            default:
                return null;
        }
    };
    const renderButtons = ()=>{
        if (currentTab !== null) return null;
        if (theCase.locked) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "text-center text-ch-blue-alt-400",
                    children: t("case:addAssetsLocked")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
            ]
        });
        const commentButtons = [];
        if (!(0, $cA1jy.isGuest)(currentUser)) commentButtons.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("comment_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            children: t("case:addComment")
        }, "1"), /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("decision_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            children: t("case:addDecision")
        }, "2"), /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("recommendation_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            children: t("case:addRecommendation")
        }, "3"));
        const fileButtons = [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: ()=>setCurrentTab("upload_file"),
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                children: t("case:uploadNewFile")
            }, "1")
        ];
        if (!(0, $cA1jy.isGuest)(currentUser)) fileButtons.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("link_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("case:addNewLink")
        }, "2"));
        if (contextFormsEnabled && !(0, $cA1jy.isGuest)(currentUser)) fileButtons.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: openFormsModal,
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("case:addForm")
        }, "3"));
        if (radiologyEnabled && !(0, $cA1jy.isGuest)(currentUser)) fileButtons.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("radiology_link_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("case:addNewRadiologyLink")
        }, "2"));
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                commentButtons.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "flex mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wpDl.default), {
                            className: "w-6 h-6 mr-2 text-ch-purple-500",
                            title: t("case:commentsTitle")
                        }),
                        t("case:commentsTitle")
                    ]
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    className: "mb-2",
                    buttons: commentButtons
                }),
                fileButtons.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "flex mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Jzjq.default), {
                            className: "w-6 h-6 mr-2 text-ch-purple-500",
                            title: t("case:filesTitle")
                        }),
                        t("case:filesTitle")
                    ]
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    buttons: fileButtons
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lswkt.default), {
                isOpen: formsModalOpen,
                ...props,
                handleClose: closeFormsModal
            }),
            renderButtons(),
            renderTabContent()
        ]
    });
};
var $87b0361b928ef349$export$2e2bcd8739ae039 = $87b0361b928ef349$var$AddCaseAssetPanel;

});
parcelRegister("6UIB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $205c77353d3e594d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $hHsFn = parcelRequire("hHsFn");

var $7twpo = parcelRequire("7twpo");

var $cGOPa = parcelRequire("cGOPa");

var $7HZDe = parcelRequire("7HZDe");

var $c0FI2 = parcelRequire("c0FI2");

var $04A9g = parcelRequire("04A9g");

var $5hZNG = parcelRequire("5hZNG");

var $COwA0 = parcelRequire("COwA0");
const $205c77353d3e594d$var$CaseCommentNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const createComment = (caseId, comment, meetingCaseId)=>dispatch((0, $7HZDe.createCaseCommentAction)(caseId, comment, meetingCaseId));
    const initialValues = {
        commentType: (0, $7twpo.CommentTypes).Comment,
        title: "",
        body: "",
        meetingCaseId: meetingCaseId
    };
    console.log(meetingCaseId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHsFn.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addComment")
                    }),
                    t("case:addComment")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $cGOPa.caseCommentNewValidation),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createComment(props.caseId, values, meetingCaseId);
                    setSubmitting(false);
                    props.closeAction();
                    props.switchToNewAssetTab();
                },
                children: ({ isSubmitting: isSubmitting, setFieldValue: setFieldValue, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5hZNG.default), {
                                users: props.mentionableUsers,
                                errors: errors,
                                touched: touched,
                                values: values,
                                handleBlur: handleBlur,
                                handleChange: handleChange,
                                setFieldValue: setFieldValue
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addComment")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $205c77353d3e594d$export$2e2bcd8739ae039 = $205c77353d3e594d$var$CaseCommentNewForm;

});
parcelRegister("cGOPa", function(module, exports) {

$parcel$export(module.exports, "caseCommentNewValidation", () => $ad63bdcdadbcd56c$export$e04fc1f22077555);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $ad63bdcdadbcd56c$export$e04fc1f22077555 = ()=>{
    return $hDGtv.create().shape({
        commentType: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")),
        title: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 100
        })),
        body: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(5000, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 5000
        }))
    });
};

});

parcelRegister("5hZNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f3d53ca423ac157$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $aSzjr = parcelRequire("aSzjr");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");
const $7f3d53ca423ac157$var$CaseCommentFields = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "asset"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "title",
                        required: true,
                        children: t("asset:title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "title",
                        onChange: props.handleChange,
                        onBlur: props.handleBlur,
                        value: props.values.title,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: props.errors.title,
                        isVisible: props.errors.title && props.touched.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "body",
                        required: true,
                        children: t("asset:body")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                        name: "body",
                        setValue: (body)=>props.setFieldValue("body", body),
                        onBlur: props.handleBlur,
                        users: props.users,
                        value: props.values.body
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: props.errors.body,
                        isVisible: props.errors.body && props.touched.body
                    })
                ]
            })
        ]
    });
};
var $7f3d53ca423ac157$export$2e2bcd8739ae039 = $7f3d53ca423ac157$var$CaseCommentFields;

});


parcelRegister("kWjiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $35f34b26bf7a1f28$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $hHsFn = parcelRequire("hHsFn");

var $7twpo = parcelRequire("7twpo");

var $cGOPa = parcelRequire("cGOPa");

var $7HZDe = parcelRequire("7HZDe");

var $c0FI2 = parcelRequire("c0FI2");

var $04A9g = parcelRequire("04A9g");

var $5hZNG = parcelRequire("5hZNG");

var $COwA0 = parcelRequire("COwA0");
const $35f34b26bf7a1f28$var$CaseDecisionNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const createComment = (caseId, comment, meetingCaseId)=>dispatch((0, $7HZDe.createCaseCommentAction)(caseId, comment, meetingCaseId));
    const initialValues = {
        commentType: (0, $7twpo.CommentTypes).Decision,
        title: "",
        body: "",
        meetingCaseId: meetingCaseId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHsFn.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addDecision")
                    }),
                    t("case:addDecision")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $cGOPa.caseCommentNewValidation),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createComment(props.caseId, values, meetingCaseId);
                    setSubmitting(false);
                    props.closeAction();
                    props.switchToNewAssetTab();
                },
                children: ({ isSubmitting: isSubmitting, setFieldValue: setFieldValue, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5hZNG.default), {
                                users: props.mentionableUsers,
                                errors: errors,
                                touched: touched,
                                values: values,
                                handleBlur: handleBlur,
                                handleChange: handleChange,
                                setFieldValue: setFieldValue
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addDecision")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $35f34b26bf7a1f28$export$2e2bcd8739ae039 = $35f34b26bf7a1f28$var$CaseDecisionNewForm;

});

parcelRegister("cHh3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8ea72edc6a8f49$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $7wpDl = parcelRequire("7wpDl");

var $7YFi7 = parcelRequire("7YFi7");

var $c0FI2 = parcelRequire("c0FI2");

var $04A9g = parcelRequire("04A9g");

var $la1uP = parcelRequire("la1uP");
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $8CK3p = parcelRequire("8CK3p");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $7HZDe = parcelRequire("7HZDe");

var $kon2z = parcelRequire("kon2z");

var $ahLi9 = parcelRequire("ahLi9");

var $6OX6Q = parcelRequire("6OX6Q");
var $6IhJz = parcelRequire("6IhJz");
var $6mdUF = parcelRequire("6mdUF");

var $COwA0 = parcelRequire("COwA0");

var $kYqkq = parcelRequire("kYqkq");

var $lxTgp = parcelRequire("lxTgp");

var $eDQDM = parcelRequire("eDQDM");
const $4c8ea72edc6a8f49$export$c084437b5e3206cd = ()=>{
    return $hDGtv.create().shape({
        body: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(5000, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 5000
        })),
        requestConsentUserIds: $jpuYg.create().min(1, (0, $5wPBK.default).t("asset:selectUserForConsentErrorMessage")),
        deadlineDate: $8CK3p.create().required((0, $5wPBK.default).t("shared:required")),
        deadlineTime: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
    });
};
const $4c8ea72edc6a8f49$var$RecommendationNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const meetingCaseAssetIds = (0, $kYqkq.useAppSelector)((state)=>(0, $lxTgp.getAllMeetingCaseAssetIds)(state, {
            meetingCaseId: meetingCaseId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const createRecommendation = (caseId, recommendation, meetingCaseId)=>dispatch((0, $7HZDe.createCaseRecommendationAction)(caseId, recommendation, meetingCaseId));
    const currentCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    const time = (0, $6OX6Q.default)(new Date(), 7);
    const defaultDeadlineDate = (0, $6mdUF.default)(time, 0);
    const defaultDeadlineTime = (0, $6IhJz.default)(defaultDeadlineDate, (0, $ahLi9.formatTimeString));
    const noMeetingCaseAssetsWarning = ()=>{
        if (!meetingCaseId || !meetingCaseAssetIds || meetingCaseAssetIds?.length > 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-5",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDQDM.default), {
                children: t("case:noMeetingCaseAssets")
            })
        });
    };
    const initialValues = {
        body: "",
        requestConsentUserIds: [],
        deadlineDate: defaultDeadlineDate,
        deadlineTime: defaultDeadlineTime,
        meetingCaseId: meetingCaseId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wpDl.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addRecommendation")
                    }),
                    meetingCaseId ? t("case:addMeetingRecommendation") : t("case:addCaseRecommendation")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: $4c8ea72edc6a8f49$export$c084437b5e3206cd,
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    values.deadlineDate = (0, $ahLi9.dateWithTime)(values.deadlineDate, values.deadlineTime);
                    createRecommendation(props.caseId, values, meetingCaseId);
                    setSubmitting(false);
                    props.closeAction();
                    props.switchToNewAssetTab();
                },
                children: ({ isSubmitting: isSubmitting, isValid: isValid, dirty: dirty })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $la1uP.default), {
                                mentionableUsers: props.mentionableUsers,
                                caseId: currentCase.id
                            }),
                            noMeetingCaseAssetsWarning(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting || !isValid || !dirty,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addRecommendation")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $4c8ea72edc6a8f49$export$2e2bcd8739ae039 = $4c8ea72edc6a8f49$var$RecommendationNewForm;

});
parcelRegister("la1uP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7430cebf9f7ba3$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $aSzjr = parcelRequire("aSzjr");

var $7UN5R = parcelRequire("7UN5R");

var $eTqMc = parcelRequire("eTqMc");

var $349zg = parcelRequire("349zg");

var $jRidO = parcelRequire("jRidO");

var $jdbjz = parcelRequire("jdbjz");

var $ctA1Y = parcelRequire("ctA1Y");

var $kon2z = parcelRequire("kon2z");

var $COwA0 = parcelRequire("COwA0");

var $4VtCQ = parcelRequire("4VtCQ");

var $aeos3 = parcelRequire("aeos3");

var $kYqkq = parcelRequire("kYqkq");
const $2d7430cebf9f7ba3$var$RecommendationFields = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "asset"
    ]);
    const tenantConfig = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const { errors: errors, touched: touched, values: values, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const requestConsentList = values.requestConsentUserIds;
    const toggleEnabledForUser = (userId)=>()=>{
            let newList;
            if (requestConsentList.includes(userId)) newList = requestConsentList.filter((id)=>id != userId);
            else newList = requestConsentList.concat([
                userId
            ]);
            setFieldValue("requestConsentUserIds", newList);
        };
    let userList;
    if (meetingCaseId) {
        const meetingCase = (0, $kYqkq.useAppSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, {
                meetingCaseId: meetingCaseId
            }));
        const meeting = (0, $kYqkq.useAppSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
                meetingId: meetingCase.meeting
            }));
        userList = meeting.users;
    } else userList = (0, $kYqkq.useAppSelector)((state)=>(0, $kon2z.getCaseMemberUserIds)(state, props));
    const approvalList = userList.map((userId)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "my-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $349zg.default), {
                userId: userId,
                enabled: requestConsentList.includes(userId),
                toggleEnabled: toggleEnabledForUser(userId)
            }, userId)
        }, userId);
    });
    const selectAll = ()=>{
        setFieldValue("requestConsentUserIds", userList);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "body",
                        required: true,
                        children: t("asset:recommendation")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                        name: "body",
                        onBlur: handleBlur,
                        users: props.mentionableUsers,
                        value: values.body,
                        setValue: (body)=>{
                            setFieldValue("body", body);
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.body,
                        isVisible: errors.body && touched.body
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                name: "body",
                                required: true,
                                className: "flex-1",
                                children: [
                                    tenantConfig.recommendationConsentHeader || t("asset:approvalRequiredFrom"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                onClick: selectAll,
                                className: "font-bold text-ch-blue-500 hover:text-ch-blue-600 uppercase inline-flex cursor-pointer",
                                children: t("shared:selectAll")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-2 py-2 px-3 rounded border border-ch-blue-alt-300 appearance-none",
                        children: [
                            approvalList,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.requestConsentUserIds,
                                isVisible: touched.requestConsentUserIds
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                            name: "deadlineDate",
                            required: true,
                            children: [
                                t("asset:approvalDeadline"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex mr-4 mb-1",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                                name: "deadlineDate"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "my-1 ml-7",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                    errorMessage: errors.deadlineDate,
                                                    isVisible: errors.deadlineDate && touched.deadlineDate
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex space-between items-center",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jdbjz.default), {
                                                            className: "text-ch-blue-500 mx-2 w-5 h-5"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctA1Y.default), {
                                                            name: "deadlineTime",
                                                            onChange: handleChange,
                                                            onBlur: handleBlur
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "my-1",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                        errorMessage: errors.deadlineTime,
                                                        isVisible: errors.deadlineTime && touched.deadlineTime
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $2d7430cebf9f7ba3$export$2e2bcd8739ae039 = $2d7430cebf9f7ba3$var$RecommendationFields;

});
parcelRegister("349zg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a50e14014845b89$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $6lvMC = parcelRequire("6lvMC");

var $6t04b = parcelRequire("6t04b");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
const $7a50e14014845b89$var$RequestConsentItem = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const colour = props.enabled ? "text-green-500" : "text-ch-gray-400";
    if (!user) return null;
    const userActive = user.activeInCurrentTenant;
    const handler = userActive ? props.toggleEnabled : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        onClick: handler,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex ", {
            "cursor-pointer": userActive,
            "text-ch-gray-500": !userActive
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                firstName: user.firstName,
                lastName: user.lastName,
                professionalTitle: user.professionalTitle,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1", {
                    "font-bold": props.enabled
                }),
                disabled: !user.activeInCurrentTenant,
                isPending: user.pending
            }),
            userActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                className: `fill-current w-4 h-4 ml-4 ${colour}`
            }) : null
        ]
    });
};
var $7a50e14014845b89$export$2e2bcd8739ae039 = $7a50e14014845b89$var$RequestConsentItem;

});



parcelRegister("g3Umr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21080254db2728e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $e11eN = parcelRequire("e11eN");

var $7HZDe = parcelRequire("7HZDe");

var $3YcTh = parcelRequire("3YcTh");

var $COwA0 = parcelRequire("COwA0");
const $c21080254db2728e$var$CaseLinkNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const createLink = (caseId, link, meetingCaseId)=>dispatch((0, $7HZDe.createCaseLinkAction)(caseId, link, meetingCaseId));
    const initialValues = {
        title: "",
        link: "",
        meetingCaseId: meetingCaseId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e11eN.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addNewLink")
                    }),
                    t("case:addNewLink")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $3YcTh.caseLinkNewValidation),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createLink(props.caseId, values, meetingCaseId);
                    setSubmitting(false);
                    props.closeAction();
                    props.switchToNewAssetTab();
                },
                children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "title",
                                        required: true,
                                        children: t("asset:title")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "title",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.title,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.title,
                                        isVisible: errors.title && touched.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "link",
                                        required: true,
                                        children: t("asset:url")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "link",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.link,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.link,
                                        isVisible: errors.link && touched.link
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addLink")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $c21080254db2728e$export$2e2bcd8739ae039 = $c21080254db2728e$var$CaseLinkNewForm;

});
parcelRegister("3YcTh", function(module, exports) {

$parcel$export(module.exports, "caseLinkNewValidation", () => $2c08eda2626da9ec$export$7af6a5f83c6393ab);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $2c08eda2626da9ec$export$7af6a5f83c6393ab = ()=>{
    const urlRegex = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i;
    return $hDGtv.create().shape({
        title: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 100
        })),
        link: $gcL7X.create().matches(urlRegex, (0, $5wPBK.default).t("shared:validUrl")).required((0, $5wPBK.default).t("shared:required"))
    });
};

});


parcelRegister("6LReM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f135cce188ea1d02$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $8Jzjq = parcelRequire("8Jzjq");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $7HZDe = parcelRequire("7HZDe");

var $ifbAI = parcelRequire("ifbAI");

var $04A9g = parcelRequire("04A9g");

var $eTqMc = parcelRequire("eTqMc");

var $COwA0 = parcelRequire("COwA0");

var $4yYS5 = parcelRequire("4yYS5");

var $7lHgq = parcelRequire("7lHgq");
const $f135cce188ea1d02$var$CaseFileNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "asset"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const uploadFile = (caseId, values, meetingCaseId)=>dispatch((0, $7HZDe.uploadCaseFileAction)(caseId, values, meetingCaseId));
    const handleSubmit = (values, { setSubmitting: setSubmitting })=>{
        uploadFile(props.caseId, values, meetingCaseId);
        setSubmitting(false);
        props.closeAction();
        props.switchToNewAssetTab();
    };
    const initialValues = {
        file: null,
        name: "",
        meetingCaseId: meetingCaseId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Jzjq.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("asset:uploadFile")
                    }),
                    t("asset:uploadFile")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                onSubmit: handleSubmit,
                validateOnChange: true,
                validationSchema: (0, $4yYS5.caseFileNewValidation),
                children: ({ errors: errors, setFieldValue: setFieldValue, isSubmitting: isSubmitting, values: values, handleChange: handleChange, handleBlur: handleBlur, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                            name: "file",
                                            children: [
                                                t("asset:selectFile"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lHgq.default), {
                                            name: "file",
                                            onChange: (event)=>{
                                                setFieldValue("file", event.currentTarget.files[0]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.file,
                                            isVisible: errors.file != null
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                            name: "name",
                                            children: [
                                                t("asset:fileName"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            name: "name",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.name,
                                            isVisible: errors.name != null
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                    className: "mb-2",
                                    buttons: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            action: ()=>{
                                                props.closeAction();
                                            },
                                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                            children: t("shared:cancel")
                                        }, "1"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: values.file == null || !isValid || isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            isSubmit: true,
                                            children: t("asset:uploadFile")
                                        }, "2")
                                    ]
                                })
                            ]
                        })
                    })
            })
        ]
    });
};
var $f135cce188ea1d02$export$2e2bcd8739ae039 = $f135cce188ea1d02$var$CaseFileNewForm;

});
parcelRegister("4yYS5", function(module, exports) {

$parcel$export(module.exports, "caseFileNewValidation", () => $323224029a9a1963$export$eff2434a84130b57);
parcelRequire("cxhNX");
var $dmHdY = parcelRequire("dmHdY");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $k7EMY = parcelRequire("k7EMY");
const $323224029a9a1963$export$eff2434a84130b57 = ()=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        file: $dmHdY.create().test("fileSizeMaximum", (0, $5wPBK.default).t("shared:fileTooLarge", {
            maxFileSize: (0, $k7EMY.fileUploadOptions).maxFileSizeMB
        }), (value)=>{
            return (0, $k7EMY.isFilesSizeUnderMaximum)(value);
        }).test("acceptedFileType", (0, $5wPBK.default).t("shared:fileWrongType", {
            acceptedFileTypes: (0, $k7EMY.fileUploadOptions).acceptedFileTypes
        }), (value)=>{
            return (0, $k7EMY.isFileAcceptedType)(value);
        })
    });
};

});

parcelRegister("7lHgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6859d0db9c72329e$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $k7EMY = parcelRequire("k7EMY");
const $6859d0db9c72329e$var$options = (0, $k7EMY.fileUploadOptions).acceptedFileTypes.join(", ");
const $6859d0db9c72329e$var$FileUploadField = ({ isDisabled: isDisabled = false, acceptedFileTypes: acceptedFileTypes = $6859d0db9c72329e$var$options, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        className: "cursor-pointer",
        id: "file",
        name: "file",
        type: "file",
        disabled: isDisabled,
        accept: acceptedFileTypes,
        onChange: props.onChange
    });
};
var $6859d0db9c72329e$export$2e2bcd8739ae039 = $6859d0db9c72329e$var$FileUploadField;

});


parcelRegister("jWomF", function(module, exports) {

$parcel$export(module.exports, "CaseAssetTabNames", () => $13b5a41e4552288d$export$739dd8ad10f47d3a);
$parcel$export(module.exports, "default", () => $13b5a41e4552288d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $izy21 = parcelRequire("izy21");

var $kon2z = parcelRequire("kon2z");

var $h8dCg = parcelRequire("h8dCg");

var $76VgF = parcelRequire("76VgF");

var $b5weT = parcelRequire("b5weT");

var $iNrQr = parcelRequire("iNrQr");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $COwA0 = parcelRequire("COwA0");

var $1l1FS = parcelRequire("1l1FS");

var $1fhVa = parcelRequire("1fhVa");

var $lCZwG = parcelRequire("lCZwG");

var $32kQ2 = parcelRequire("32kQ2");

var $4VtCQ = parcelRequire("4VtCQ");

var $2f6IN = parcelRequire("2f6IN");

var $aeos3 = parcelRequire("aeos3");

var $6sHZH = parcelRequire("6sHZH");

var $cA1jy = parcelRequire("cA1jy");

var $6lvMC = parcelRequire("6lvMC");

var $cHsE4 = parcelRequire("cHsE4");

var $eDQDM = parcelRequire("eDQDM");
const $13b5a41e4552288d$export$739dd8ad10f47d3a = {
    MEETING_ASSETS: "meeting_assets",
    ASSETS: "assets",
    MEETINGS: "meetings",
    TASKS: "tasks",
    PATHWAYS: "pathways"
};
const $13b5a41e4552288d$var$CaseActivityPanel = ({ showMeetingAssetsTab: showMeetingAssetsTab = false, showMeetingsTab: showMeetingsTab = true, ...props })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const { pathwaysEnabled: pathwaysEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const [isSelectAssetModalOpen, setIsSelectAssetModalOpen] = (0, $acw62.useState)(false);
    const [isViewAssetModalOpen, setViewAssetModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedAssetId, setSelectedAssetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const { currentTab: currentTab } = (0, $COwA0.useParams)();
    const { pathname: pathname } = (0, $COwA0.useLocation)();
    const meetingsCount = theCase.meetings && theCase.meetings.length || 0;
    const outstandingTasksCount = theCase.outstandingTaskCount || 0;
    const openViewAssetModal = (selectedAssetId)=>{
        setSelectedAssetId(selectedAssetId);
        setViewAssetModalIsOpen(true);
    };
    const closeViewAssetModal = ()=>{
        setViewAssetModalIsOpen(false);
    };
    const renderSelectAssetModal = ()=>{
        if (!props.meetingCaseId || !props.meetingId || !theCase.assets) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
            isOpen: isSelectAssetModalOpen,
            onRequestClose: ()=>setIsSelectAssetModalOpen(false),
            style: (0, $jF0Xa.bottomModalStyle),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                handleClose: ()=>setIsSelectAssetModalOpen(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6sHZH.default), {
                    meetingId: props.meetingId,
                    caseId: props.caseId,
                    meetingCaseId: props.meetingCaseId,
                    openViewAssetModal: openViewAssetModal
                })
            })
        });
    };
    const tabs = [];
    if (showMeetingAssetsTab) tabs.push({
        label: t("shared:meetingAssets"),
        value: $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETING_ASSETS
    });
    tabs.push({
        label: t("shared:timeline"),
        value: $13b5a41e4552288d$export$739dd8ad10f47d3a.ASSETS
    });
    if (!(0, $cA1jy.isGuest)(currentUser) && showMeetingsTab) tabs.push({
        label: t("shared:meetings"),
        value: $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETINGS,
        count: meetingsCount
    });
    if (!(0, $cA1jy.isGuest)(currentUser)) tabs.push({
        label: t("shared:tasks"),
        value: $13b5a41e4552288d$export$739dd8ad10f47d3a.TASKS,
        count: outstandingTasksCount,
        isCountHighlighted: true
    });
    if (!(0, $cA1jy.isGuest)(currentUser) && pathwaysEnabled && theCase.casePathways?.length) tabs.push({
        label: t("shared:pathways"),
        value: $13b5a41e4552288d$export$739dd8ad10f47d3a.PATHWAYS
    });
    (0, $acw62.useEffect)(()=>{
        const defaultTab = props.meetingCaseId ? $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETING_ASSETS : $13b5a41e4552288d$export$739dd8ad10f47d3a.ASSETS;
        if (!currentTab) setCurrentTab(defaultTab);
    }, [
        pathname
    ]);
    const setCurrentTab = (value)=>{
        const url = props.generateTabPath(value);
        (0, $1l1FS.default).replace(url);
    };
    const renderSelectAssetButton = ()=>{
        if (![
            $13b5a41e4552288d$export$739dd8ad10f47d3a.ASSETS,
            $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETING_ASSETS
        ].includes(currentTab)) return null;
        if (![
            (0, $32kQ2.MeetingStatuses).Scheduled,
            (0, $32kQ2.MeetingStatuses).InProgress
        ].includes(meeting?.status)) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            className: "text-sm max-h-8",
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            action: ()=>setIsSelectAssetModalOpen(true),
            children: t("asset:selectMeetingAssets")
        });
    };
    const renderWelcomeGuestBanner = ()=>{
        if (!(0, $cA1jy.isGuest)(currentUser) || theCase?.assets?.length > 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eDQDM.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: t("case:guestUsers:text:welcomeNoAssetsYet")
            })
        });
    };
    if (!theCase) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cHsE4.default), {
                isOpen: isViewAssetModalOpen,
                closeModal: closeViewAssetModal,
                selectedAssetId: selectedAssetId
            }),
            renderSelectAssetModal(),
            renderWelcomeGuestBanner(),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap justify-center sm:justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $izy21.default), {
                        className: "mb-2 sm:mb-0 flex-1",
                        onClick: setCurrentTab,
                        tabs: tabs,
                        value: currentTab
                    }),
                    !showMeetingAssetsTab ? null : renderSelectAssetButton()
                ]
            }),
            props.meetingCaseId ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETING_ASSETS
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fhVa.default), {
                    meetingCaseId: props.meetingCaseId,
                    mentionableUsers: props.mentionableUsers,
                    openAssetModal: openViewAssetModal,
                    caseId: props.caseId
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== $13b5a41e4552288d$export$739dd8ad10f47d3a.ASSETS
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8dCg.default), {
                    openAssetModal: openViewAssetModal,
                    meetingCaseId: props.meetingCaseId,
                    mentionableUsers: props.mentionableUsers,
                    caseId: props.caseId,
                    meetingId: props.meetingId
                })
            }),
            !(0, $cA1jy.isGuest)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== $13b5a41e4552288d$export$739dd8ad10f47d3a.MEETINGS
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76VgF.default), {
                    caseId: props.caseId
                })
            }) : null,
            !(0, $cA1jy.isGuest)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== $13b5a41e4552288d$export$739dd8ad10f47d3a.TASKS
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iNrQr.default), {
                    caseId: props.caseId,
                    openAssetModal: openViewAssetModal
                })
            }) : null,
            pathwaysEnabled && !(0, $cA1jy.isGuest)(currentUser) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== $13b5a41e4552288d$export$739dd8ad10f47d3a.PATHWAYS
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f6IN.default), {
                    caseId: props.caseId
                })
            }) : null
        ]
    });
};
var $13b5a41e4552288d$export$2e2bcd8739ae039 = $13b5a41e4552288d$var$CaseActivityPanel;

});
parcelRegister("izy21", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a077a2164dfaf4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $jF0Xa = parcelRequire("jF0Xa");
const $98a077a2164dfaf4$var$Tabs = ({ variant: variant = (0, $jF0Xa.StyleVariants).BLUE, ...props })=>{
    const renderTabCount = (tab)=>{
        if (!tab.count) return null;
        if (tab.isCountHighlighted) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "bg-ch-orange-500 text-white rounded-full w-5 h-5 text-sm flex justify-center items-center p-2 ml-1 absolute right-0",
            children: tab.count
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "ml-1",
            children: [
                "(",
                tab.count,
                ")"
            ]
        });
    };
    const defaultClasses = [
        "flex"
    ];
    const propClasses = props.className ? props.className.split(" ") : [];
    const allClasses = [
        ...defaultClasses,
        ...propClasses
    ].join(" ");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: allClasses,
        children: props.tabs.map((tab, index)=>{
            const isSelected = tab.value == props.value;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-2", "text-ch-gray-500", {
                    "ml-2": index !== 0
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    onClick: ()=>props.onClick(tab.value),
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("font-semibold", "p-1", "uppercase", "relative", "flex", "items-center", {
                        "pr-6": tab.isCountHighlighted && tab.count > 0,
                        [`text-${variant}-500`]: isSelected,
                        [`border-${variant}-500`]: isSelected,
                        "border-b-4": isSelected,
                        [`hover:text-${variant}-500`]: !isSelected,
                        "cursor-pointer": !isSelected
                    }),
                    children: [
                        tab.label,
                        " ",
                        renderTabCount(tab)
                    ]
                })
            }, index);
        })
    });
};
var $98a077a2164dfaf4$export$2e2bcd8739ae039 = $98a077a2164dfaf4$var$Tabs;

});

parcelRegister("h8dCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1bb33f0dfc3bbd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lxTgp = parcelRequire("lxTgp");

var $2jvQG = parcelRequire("2jvQG");

var $juENv = parcelRequire("juENv");

var $buMa2 = parcelRequire("buMa2");

var $7HZDe = parcelRequire("7HZDe");
const $df1bb33f0dfc3bbd$var$CaseAssetList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [assetTypeFilters, setAssetTypeFilters] = (0, $acw62.useState)(null);
    const assetIds = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAllCaseAssetIds)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const deleteAsset = (caseId, assetId)=>dispatch((0, $7HZDe.deleteAssetAction)(caseId, assetId));
    const deleteTheAsset = (assetId)=>{
        deleteAsset(props.caseId, assetId);
    };
    if (!assetIds || assetIds.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:noAssets")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $buMa2.default), {
                setFilters: setAssetTypeFilters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: assetIds.map((assetId)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $juENv.default), {
                        action: ()=>props.openAssetModal(assetId),
                        assetId: assetId,
                        deleteAction: deleteTheAsset,
                        assetTypeFilters: assetTypeFilters,
                        mentionableUsers: props.mentionableUsers,
                        caseId: props.caseId,
                        meetingId: props.meetingId,
                        meetingCaseId: props.meetingCaseId,
                        isSelectingAssets: props.isSelectingAssets
                    }, assetId);
                })
            })
        ]
    });
};
var $df1bb33f0dfc3bbd$export$2e2bcd8739ae039 = $df1bb33f0dfc3bbd$var$CaseAssetList;

});
parcelRegister("juENv", function(module, exports) {

$parcel$export(module.exports, "default", () => $598dcfe469ee288a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");

var $3aAGy = parcelRequire("3aAGy");
const $598dcfe469ee288a$var$CaseAssetListItem = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const shouldRender = ()=>{
        // this logic is all to not show any assets in a meeting case that were added after the corresponding meeting was ended
        // so if there's no current meeting (ie we are looking at the case, not a meeting case), we should always render
        if (!props.meetingId) return true;
        if (!meeting) return true;
        // if the current meeting is not ended or cancelled, we should render
        if (!(meeting.status == (0, $32kQ2.MeetingStatuses).Ended || meeting.status == (0, $32kQ2.MeetingStatuses).Cancelled)) return true;
        // if the asset belongs to the current meeting (eg in case a case report was generated after the meeting was ended), always render
        if (asset?.asset && asset.asset.meetingId == props.meetingId) return true;
        // if the asset was create before the meeting was ended or cancelled, render
        if (new Date(asset.createdAt) < new Date(meeting.endDateActual)) return true;
        if (new Date(asset.createdAt) < new Date(meeting.cancelledDate)) return true;
        // if non of the above applied, we shouldn't render.
        return false;
    };
    if (!asset) return null;
    if (!shouldRender()) return null;
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponentType];
    const action = (0, $hVO2M.clickableComponentAction)(props.action, assetComponentType);
    // we're hiding the component, not returning null, because this way the
    //
    // image components don't need to reload their images.
    const hidden = (0, $hVO2M.isAssetFiltered)(Asset, props.assetTypeFilters);
    const renderDeleteButton = ()=>{
        if (!props.deleteAction || !asset.permissions.canDelete) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3aAGy.default), {
            deleteAction: props.deleteAction,
            assetId: props.assetId
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-1", {
            hidden: hidden
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
            assetId: props.assetId,
            action: props.isSelectingAssets ? null : action,
            isSelected: props.isSelected,
            caseId: props.caseId,
            mentionableUsers: props.mentionableUsers,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-wrap content-center ml-2 justify-contents-end",
                children: renderDeleteButton()
            })
        })
    });
};
var $598dcfe469ee288a$export$2e2bcd8739ae039 = $598dcfe469ee288a$var$CaseAssetListItem;

});
parcelRegister("3aAGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee7c7935e27926f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $eY7ZC = parcelRequire("eY7ZC");
const $8ee7c7935e27926f$var$DeleteAssetButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const [clicked, setClicked] = (0, $acw62.useState)(false);
    const deleteTheAsset = (e)=>{
        if (!clicked) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            setClicked(true);
            props.deleteAction(props.assetId);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: "#",
        onClick: deleteTheAsset,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eY7ZC.default), {
            className: "w-7 h-7 mr-1 text-ch-blue-500 hover:text-ch-blue-600",
            title: t("shared:delete")
        })
    });
};
var $8ee7c7935e27926f$export$2e2bcd8739ae039 = $8ee7c7935e27926f$var$DeleteAssetButton;

});



parcelRegister("76VgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ed7f4b5c5e64f9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $2jvQG = parcelRequire("2jvQG");

var $fbYRS = parcelRequire("fbYRS");
const $57ed7f4b5c5e64f9$var$CaseMeetingList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const meetingIds = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseMeetingIds)(state, props));
    if (!meetingIds || meetingIds.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:noMeetings")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: meetingIds.map((meetingId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fbYRS.default), {
                meetingId: meetingId
            }, meetingId);
        })
    });
};
var $57ed7f4b5c5e64f9$export$2e2bcd8739ae039 = $57ed7f4b5c5e64f9$var$CaseMeetingList;

});
parcelRegister("fbYRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cb23570f0d6dd6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $18j2c = parcelRequire("18j2c");

var $5v6Bi = parcelRequire("5v6Bi");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $laxqG = parcelRequire("laxqG");

var $6lvMC = parcelRequire("6lvMC");

var $f1q41 = parcelRequire("f1q41");
const $b7cb23570f0d6dd6$var$MeetingListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!meeting || !currentUser) return null;
    const userInMeeting = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(meeting.users, currentUser.id);
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: props.meetingId
    });
    const liveMeetingUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_LIVE, {
        meetingId: props.meetingId
    });
    const inProgress = ()=>{
        return meeting.status == (0, $32kQ2.MeetingStatuses).InProgress;
    };
    const renderJoinMeetingButton = ()=>{
        if (!userInMeeting || !inProgress()) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: liveMeetingUrl,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("meeting:joinMeeting")
        }, "1");
    };
    const renderViewDetailsButton = ()=>{
        if (!userInMeeting) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: meetingDetailsUrl,
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("meeting:viewMeeting")
        }, "3");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            isDark: !inProgress(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                                className: "fill-current w-6 h-6",
                                title: meeting.name
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $laxqG.default), {
                            meetingId: props.meetingId,
                            hasLink: userInMeeting,
                            showMeetingStatus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            renderJoinMeetingButton(),
                            renderViewDetailsButton()
                        ]
                    })
                })
            ]
        })
    });
};
var $b7cb23570f0d6dd6$export$2e2bcd8739ae039 = $b7cb23570f0d6dd6$var$MeetingListItem;

});


parcelRegister("iNrQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d854ab0742dc3fa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $2jvQG = parcelRequire("2jvQG");

var $9mz9n = parcelRequire("9mz9n");

var $fex4i = parcelRequire("fex4i");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $az7E7 = parcelRequire("az7E7");

var $k4WD8 = parcelRequire("k4WD8");
const $3d854ab0742dc3fa$var$CaseTaskList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const [isTaskResponseModalOpen, setTaskResponseModalIsOpen] = (0, $acw62.useState)(false);
    const [selectedTaskId, setSelectedTaskId] = (0, $acw62.useState)(null);
    const [taskFilters, setTaskFilters] = (0, $acw62.useState)(null);
    const taskIds = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getAllCaseTaskIds)(state, props));
    const openTaskModal = (selectedTaskId)=>{
        setSelectedTaskId(selectedTaskId);
        setTaskResponseModalIsOpen(true);
    };
    const closeTaskModal = ()=>{
        setTaskResponseModalIsOpen(false);
    };
    const renderTaskModal = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
            isOpen: isTaskResponseModalOpen,
            onRequestClose: closeTaskModal,
            style: (0, $jF0Xa.defaultModalStyle),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                handleClose: closeTaskModal,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $az7E7.default), {
                    caseId: props.caseId,
                    taskId: selectedTaskId,
                    closeAction: closeTaskModal
                })
            })
        });
    };
    const renderList = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: taskIds.map((taskId)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fex4i.default), {
                    taskId: taskId,
                    addResponseAction: ()=>openTaskModal(taskId),
                    taskFilters: taskFilters,
                    openAssetModal: props.openAssetModal
                }, taskId);
            })
        });
    };
    if (!taskIds || taskIds.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:noTasks")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k4WD8.default), {
                setFilters: setTaskFilters,
                initialValues: {
                    showOutstanding: true,
                    showAll: false,
                    showCompleted: false
                }
            }),
            renderList(),
            renderTaskModal()
        ]
    });
};
var $3d854ab0742dc3fa$export$2e2bcd8739ae039 = $3d854ab0742dc3fa$var$CaseTaskList;

});
parcelRegister("fex4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ddf541f7f713333$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $eky98 = parcelRequire("eky98");

var $9mz9n = parcelRequire("9mz9n");

var $iXtbw = parcelRequire("iXtbw");

var $8g1PZ = parcelRequire("8g1PZ");
const $8ddf541f7f713333$var$TaskListItem = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    if (!task) return null;
    const hidden = (0, $iXtbw.isTaskFiltered)(task, props.taskFilters);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-1", {
            hidden: hidden
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eky98.default), {
            taskId: task.id,
            addResponseAction: props.addResponseAction,
            openAssetModal: props.openAssetModal
        })
    });
};
var $8ddf541f7f713333$export$2e2bcd8739ae039 = $8ddf541f7f713333$var$TaskListItem;

});
parcelRegister("eky98", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a280eed4208573$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $9mz9n = parcelRequire("9mz9n");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");
var $k6suX = parcelRequire("k6suX");
var $dIfKX = parcelRequire("dIfKX");

var $8g1PZ = parcelRequire("8g1PZ");

var $k5WIK = parcelRequire("k5WIK");

var $4KSAX = parcelRequire("4KSAX");

var $g9gc3 = parcelRequire("g9gc3");

var $7hl6H = parcelRequire("7hl6H");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");

var $598zU = parcelRequire("598zU");

var $04A9g = parcelRequire("04A9g");

var $kACia = parcelRequire("kACia");
const $39a280eed4208573$var$TaskDetails = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const taskAssignees = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskUsers)(state, props));
    const [assignTaskModalOpen, setAssignTaskModalOpen] = (0, $acw62.useState)(false);
    const openAssignTaskModal = ()=>{
        setAssignTaskModalOpen(true);
    };
    const closeAssignTaskModal = ()=>{
        setAssignTaskModalOpen(false);
    };
    if (!task) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task",
        "case"
    ]);
    const Icon = task.casePathwayId ? (0, $k6suX.default) : (0, $dIfKX.default);
    const renderButtons = ()=>{
        if (task.isComplete) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-green-500",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                className: "fill-current w-6 h-6"
            })
        });
        if (!task.permissions.canContribute) return null;
        const respondButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            action: props.addResponseAction,
            children: t("task:addResponse")
        });
        const renderAssignButton = Object.keys(taskAssignees).length < 1 && task.casePathwayId;
        let assignButton = null;
        let assignModal = null;
        if (renderAssignButton) {
            assignButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: openAssignTaskModal,
                variant: (0, $jF0Xa.StyleVariants).ORANGE,
                children: t("case:casePathways:buttons:assignTask")
            });
            assignModal = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kACia.default), {
                isOpen: assignTaskModalOpen,
                closeModal: closeAssignTaskModal,
                casePathwayId: task.casePathwayId,
                taskId: props.taskId
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                assignModal,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    buttons: [
                        respondButton,
                        assignButton
                    ]
                })
            ]
        });
    };
    const renderCompletedTimestamp = ()=>{
        if (!task.isComplete) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "font-semibold",
            children: [
                t("task:completedOn"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: task.completedAt
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("p-2", "rounded-md", {
            "bg-ch-blue-100": !task.isComplete,
            "bg-ch-blue-200": task.isComplete
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-ch-purple-500 mr-2 mt-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                            className: "w-5 h-5",
                            title: task.action
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "font-semibold",
                                children: task.action
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k5WIK.default), {
                                firstName: task.createdBy.firstName,
                                lastName: task.createdBy.lastName,
                                createdAt: task.createdAt
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: task.description
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    t("task:assignedTo"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g9gc3.default), {
                                        taskId: props.taskId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    t("task:dueDate"),
                                    ": ",
                                    task.dueDate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                        utcTime: task.dueDate
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                        children: t("task:dueDateNotSet")
                                    })
                                ]
                            }),
                            renderCompletedTimestamp()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-wrap content-center ml-2",
                        children: renderButtons()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $598zU.default), {
                taskId: props.taskId,
                openAssetModal: props.openAssetModal
            })
        ]
    });
};
var $39a280eed4208573$export$2e2bcd8739ae039 = $39a280eed4208573$var$TaskDetails;

});
parcelRegister("g9gc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d1a98b453781c4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $9mz9n = parcelRequire("9mz9n");

var $irdpp = parcelRequire("irdpp");

var $4KSAX = parcelRequire("4KSAX");
const $78d1a98b453781c4$var$AssigneeList = (props)=>{
    const assignees = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskUsers)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    if (!props.taskId) return null;
    if (Object.keys(assignees).length <= 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
            children: t("task:notAssigned")
        })
    });
    const renderListText = ()=>{
        return Object.values(assignees).map((assignee, i, { length: length })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        assignee.firstName,
                        " ",
                        assignee.lastName,
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irdpp.PendingLabel), {
                            isPending: assignee.pending
                        }),
                        length - 1 != i ? ", " : null
                    ]
                })
            }, assignee.id);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: renderListText()
    });
};
var $78d1a98b453781c4$export$2e2bcd8739ae039 = $78d1a98b453781c4$var$AssigneeList;

});

parcelRegister("598zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e9e0d6d5ba73ffa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $9mz9n = parcelRequire("9mz9n");

var $3icBS = parcelRequire("3icBS");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");
const $8e9e0d6d5ba73ffa$var$ResponseList = (props)=>{
    const taskResponseIds = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getAllCaseTaskResponseIds)(state, props));
    if (!taskResponseIds || taskResponseIds.length == 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: taskResponseIds.map((taskResponseId, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    width: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3icBS.default), {
                        taskResponseId: taskResponseId
                    }, taskResponseId)
                })
            }, index);
        })
    });
};
var $8e9e0d6d5ba73ffa$export$2e2bcd8739ae039 = $8e9e0d6d5ba73ffa$var$ResponseList;

});
parcelRegister("3icBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc668343865a1413$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9mz9n = parcelRequire("9mz9n");

var $l5bDj = parcelRequire("l5bDj");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $dc668343865a1413$var$ResponseListItem = (props)=>{
    const taskResponse = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskResponseById)(state, props));
    if (!taskResponse) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "mb-1 w-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l5bDj.default), {
            taskResponseId: props.taskResponseId
        })
    });
};
var $dc668343865a1413$export$2e2bcd8739ae039 = $dc668343865a1413$var$ResponseListItem;

});
parcelRegister("l5bDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $288dc6f1cd90fccb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9mz9n = parcelRequire("9mz9n");

var $4KSAX = parcelRequire("4KSAX");

var $7hl6H = parcelRequire("7hl6H");

var $8g1PZ = parcelRequire("8g1PZ");

var $8DOep = parcelRequire("8DOep");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $288dc6f1cd90fccb$var$ResponseDetails = (props)=>{
    const taskResponse = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskResponseById)(state, props));
    if (!taskResponse) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "rounded-md bg-white",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "mb-2": taskResponse.asset
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                        className: "font-semibold",
                        children: [
                            taskResponse.createdBy.firstName,
                            " ",
                            taskResponse.createdBy.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            t("task:responseOn"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: taskResponse.createdAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "font-semibold",
                        children: [
                            t("task:response"),
                            ": ",
                            taskResponse.response
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8DOep.default), {
                assetId: taskResponse.asset
            })
        ]
    });
};
var $288dc6f1cd90fccb$export$2e2bcd8739ae039 = $288dc6f1cd90fccb$var$ResponseDetails;

});
parcelRegister("8DOep", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b886bd117793f12$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hVO2M = parcelRequire("hVO2M");

var $lxTgp = parcelRequire("lxTgp");

var $2f6IN = parcelRequire("2f6IN");
const $0b886bd117793f12$var$ResponseAsset = (props)=>{
    const { openAssetModal: openAssetModal } = (0, $acw62.useContext)((0, $2f6IN.AssetModalContext));
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    if (!props.assetId || !asset) return null;
    const assetComponetType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponetType];
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
        action: ()=>openAssetModal(props.assetId),
        assetId: props.assetId
    });
};
var $0b886bd117793f12$export$2e2bcd8739ae039 = $0b886bd117793f12$var$ResponseAsset;

});
parcelRegister("2f6IN", function(module, exports) {

$parcel$export(module.exports, "AssetModalContext", () => $5dd3d9434116a8c1$export$88f3088ed45e88a8);
$parcel$export(module.exports, "default", () => $5dd3d9434116a8c1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $2jvQG = parcelRequire("2jvQG");

var $9L4IW = parcelRequire("9L4IW");

var $9AKgV = parcelRequire("9AKgV");

var $7jD0k = parcelRequire("7jD0k");

var $dArHa = parcelRequire("dArHa");

var $jF0Xa = parcelRequire("jF0Xa");
const $5dd3d9434116a8c1$export$88f3088ed45e88a8 = /*#__PURE__*/ (0, $acw62.createContext)({
    openAssetModal: null
});
const $5dd3d9434116a8c1$var$CasePathwayList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const casePathwayIds = (0, $iD0SF.useSelector)((state)=>(0, $9L4IW.getAllCasePathwayIds)(state, props));
    const [isAssetModalOpen, setAssetModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [selectedAssetId, setSelectedAssetId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const openAssetModal = (selectedAssetId)=>{
        setSelectedAssetId(selectedAssetId);
        setAssetModalIsOpen(true);
    };
    const closeAssetModal = ()=>{
        setAssetModalIsOpen(false);
    };
    if (!casePathwayIds || casePathwayIds.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:casePathways:noPathways")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: isAssetModalOpen,
                onRequestClose: closeAssetModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                    handleClose: closeAssetModal,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dArHa.default), {
                        assetId: selectedAssetId
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5dd3d9434116a8c1$export$88f3088ed45e88a8.Provider, {
                    value: {
                        openAssetModal: openAssetModal
                    },
                    children: casePathwayIds.map((casePathwayId)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9AKgV.default), {
                            casePathwayId: casePathwayId
                        }, casePathwayId);
                    })
                })
            })
        ]
    });
};
var $5dd3d9434116a8c1$export$2e2bcd8739ae039 = $5dd3d9434116a8c1$var$CasePathwayList;

});
parcelRegister("9L4IW", function(module, exports) {

$parcel$export(module.exports, "getPathway", () => $c4a526f6ee31aace$export$ba3baa249106e0b);
$parcel$export(module.exports, "getPathwaysAddableToCaseIds", () => $c4a526f6ee31aace$export$26e36e16d260a688);
$parcel$export(module.exports, "getAllCasePathwayIds", () => $c4a526f6ee31aace$export$8498c3026760fdf8);

var $6SpLG = parcelRequire("6SpLG");

var $kon2z = parcelRequire("kon2z");

var $kQILj = parcelRequire("kQILj");
const $c4a526f6ee31aace$export$ba3baa249106e0b = (ownProps)=>(state)=>state.entities.pathways.byId[ownProps.pathwayId];
const $c4a526f6ee31aace$export$b5f50f4a549fd1a0 = (state, ownProps)=>state.entities.pathways.byId[ownProps.pathwayId];
const $c4a526f6ee31aace$export$26e36e16d260a688 = (0, $6SpLG.createSelector)((0, $kQILj.getAddPathwayToCaseUI), (UI)=>{
    if (!UI) return [];
    return UI.resultIds;
});
const $c4a526f6ee31aace$export$8498c3026760fdf8 = (0, $6SpLG.createSelector)((0, $kon2z.getCaseById), (caseData)=>{
    if (!caseData) return [];
    return caseData.casePathways;
});

});

parcelRegister("9AKgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea3f73b1e3d65fd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $l57jE = parcelRequire("l57jE");

var $8CYaa = parcelRequire("8CYaa");
const $4ea3f73b1e3d65fd$export$f8fc0c4a8cfac005 = (props)=>{
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    if (!casePathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: "mb-2",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8CYaa.default), {
            ...props
        })
    });
};
var $4ea3f73b1e3d65fd$export$2e2bcd8739ae039 = $4ea3f73b1e3d65fd$export$f8fc0c4a8cfac005;

});
parcelRegister("l57jE", function(module, exports) {

$parcel$export(module.exports, "getCasePathwayById", () => $98f668b7d44b4194$export$ba78ac56a11125e);
const $98f668b7d44b4194$export$ba78ac56a11125e = (ownProps)=>(state)=>state.entities.casePathways.byId[ownProps.casePathwayId];

});

parcelRegister("8CYaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9350110fd6b05218$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $k5WIK = parcelRequire("k5WIK");

var $l57jE = parcelRequire("l57jE");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");
var $7laxl = parcelRequire("7laxl");

var $4NXxH = parcelRequire("4NXxH");

var $lV7Qw = parcelRequire("lV7Qw");

var $ahLi9 = parcelRequire("ahLi9");

var $fBVzf = parcelRequire("fBVzf");

var $bRGJq = parcelRequire("bRGJq");

var $9jVwF = parcelRequire("9jVwF");

var $jWomF = parcelRequire("jWomF");

var $kon2z = parcelRequire("kon2z");

var $kA27M = parcelRequire("kA27M");
var $9350110fd6b05218$export$b2539bed5023c21c = /*#__PURE__*/ function(Tabs) {
    Tabs["TaskNew"] = "task_new";
    return Tabs;
}({});
const $9350110fd6b05218$export$60adb7813e9f159 = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: casePathway.caseId
        }));
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(null);
    const [taskListVisible, setTaskListVisible] = (0, $acw62.useState)(false);
    if (!casePathway) return null;
    const [assignDueDateModalOpen, setAssignDueDateModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openAssignDueDateModal = ()=>{
        setAssignDueDateModalOpen(true);
    };
    const closeAssignDueDateModal = ()=>{
        setAssignDueDateModalOpen(false);
    };
    const [editCasePathwayModalOpen, setEditCasePathwayModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openEditCasePathwayModal = ()=>{
        setEditCasePathwayModalOpen(true);
    };
    const closeEditCasePathwayModal = ()=>{
        setEditCasePathwayModalOpen(false);
    };
    const assignButtonText = ()=>{
        if (casePathway.dueDate) return t("case:casePathways:buttons:editDate");
        else return t("case:casePathways:buttons:assignDate");
    };
    const renderDueDate = ()=>{
        if (casePathway.dueDate) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "font-semibold",
                    children: [
                        t("case:casePathways:dueDate"),
                        ": "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        (0, $ahLi9.formatDatePicker)(new Date(casePathway.dueDate)),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-ch-gray-500 italic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lV7Qw.default), {
                        utcTime: casePathway.dueDate
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "font-semibold",
                    children: [
                        t("case:casePathways:dueDate"),
                        ": "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-ch-gray-500 italic",
                    children: t("case:casePathways:noDueDateAssigned")
                })
            ]
        });
    };
    const renderEditButton = ()=>{
        if (!casePathway.permissions.canEdit || theCase.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            onClick: openEditCasePathwayModal,
            className: "cursor-pointer",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7laxl.default), {
                className: "w-5 h-5 mr-1 text-ch-blue-500 hover:text-ch-blue-600",
                title: t("case:casePathways:buttons:editPathway")
            })
        });
    };
    const renderAssignDueDateButton = ()=>{
        if (!casePathway.permissions.canEdit || theCase.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>openAssignDueDateModal(),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: assignButtonText()
        });
    };
    const renderAddTaskButton = ()=>{
        if (theCase.locked) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>setCurrentTab("task_new"),
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("case:casePathways:buttons:addTask")
        }, "1");
    };
    const renderPathwayDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p-2 rounded-md bg-ch-blue-100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-ch-purple-500 mr-2 mt-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                className: "w-5 h-5",
                                title: casePathway.name
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "font-semibold",
                                children: casePathway.name
                            })
                        }),
                        renderEditButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k5WIK.default), {
                        firstName: casePathway.createdBy?.firstName,
                        lastName: casePathway.createdBy?.lastName,
                        createdAt: casePathway.createdAt
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: casePathway.description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-wrap gap-2 items-center mb-2",
                    children: [
                        renderDueDate(),
                        renderAssignDueDateButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-wrap gap-2 items-center justify-between mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "font-semibold",
                                        children: [
                                            t("case:casePathways:tasks"),
                                            " (",
                                            casePathway.tasks.length,
                                            "): "
                                        ]
                                    })
                                }),
                                renderAddTaskButton()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex mr-2",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                isExpanded: taskListVisible,
                                action: ()=>setTaskListVisible(!taskListVisible),
                                expandText: t("case:casePathways:buttons:showTasks"),
                                collapseText: t("case:casePathways:buttons:hideTasks")
                            }, "1")
                        })
                    ]
                }),
                taskListVisible ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4NXxH.default), {
                    taskIds: casePathway.tasks
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fBVzf.default), {
                    casePathwayId: props.casePathwayId,
                    closeModal: closeAssignDueDateModal,
                    isOpen: assignDueDateModalOpen
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bRGJq.default), {
                    casePathwayId: props.casePathwayId,
                    closeModal: closeEditCasePathwayModal,
                    isOpen: editCasePathwayModalOpen
                })
            ]
        });
    };
    const renderTabContent = ()=>{
        switch(currentTab){
            case "task_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9jVwF.default), {
                    caseId: casePathway.caseId,
                    closeAction: ()=>setCurrentTab(null),
                    casePathwayId: props.casePathwayId,
                    originTab: (0, $jWomF.CaseAssetTabNames).PATHWAYS
                });
            default:
                return renderPathwayDetails();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: renderTabContent()
    });
};
var $9350110fd6b05218$export$2e2bcd8739ae039 = $9350110fd6b05218$export$60adb7813e9f159;

});
parcelRegister("4NXxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f246df8fcf38e000$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $eOWEM = parcelRequire("eOWEM");

var $9mz9n = parcelRequire("9mz9n");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
const $f246df8fcf38e000$var$CasePathwayTaskList = (props)=>{
    const tasks = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTasksById)(state, props.taskIds));
    const sortedTasks = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(tasks, [
        "casePathwayPosition"
    ]);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "pathway"
    ]);
    if (!props.taskIds) return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
        className: "text-center",
        children: t("pathway:addPathwayToCase:noTasks")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: sortedTasks.map((task)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eOWEM.default), {
                taskId: task.id,
                casePathwayId: task.casePathwayId
            }, task.id);
        })
    });
};
var $f246df8fcf38e000$export$2e2bcd8739ae039 = $f246df8fcf38e000$var$CasePathwayTaskList;

});
parcelRegister("eOWEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $99bcd7b661a06f98$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $9mz9n = parcelRequire("9mz9n");

var $598zU = parcelRequire("598zU");

var $4qaeN = parcelRequire("4qaeN");

var $kA27M = parcelRequire("kA27M");

var $4KSAX = parcelRequire("4KSAX");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $22l7u = parcelRequire("22l7u");

var $kACia = parcelRequire("kACia");

var $c2gLZ = parcelRequire("c2gLZ");

var $RU2vz = parcelRequire("RU2vz");

var $gLVaA = parcelRequire("gLVaA");

var $l57jE = parcelRequire("l57jE");

var $h0rpN = parcelRequire("h0rpN");

var $1ysgl = parcelRequire("1ysgl");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $az7E7 = parcelRequire("az7E7");

var $b5weT = parcelRequire("b5weT");

var $kon2z = parcelRequire("kon2z");
const $99bcd7b661a06f98$var$CasePathwayTaskListItem = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: casePathway.caseId
        }));
    const [responseListVisible, setResponseListVisible] = (0, $acw62.useState)(true);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task",
        "case"
    ]);
    const [assignTaskModalOpen, setAssignTaskModalOpen] = (0, $acw62.useState)(false);
    const openAssignTaskModal = ()=>{
        setAssignTaskModalOpen(true);
    };
    const closeAssignTaskModal = ()=>{
        setAssignTaskModalOpen(false);
    };
    const [deleteTask, setDeleteTask] = (0, $acw62.useState)(null);
    const openDeleteTaskModal = (task)=>{
        setDeleteTask(task);
    };
    const closeDeleteTaskModal = ()=>{
        setDeleteTask(null);
    };
    const [editTaskModalOpen, setEditTaskModalOpen] = (0, $acw62.useState)(false);
    const openEditTaskModal = ()=>{
        setEditTaskModalOpen(true);
    };
    const closeEditTaskModal = ()=>{
        setEditTaskModalOpen(false);
    };
    const [addResponseModalOpen, setAddResponseModalOpen] = (0, $acw62.useState)(false);
    const openAddResponseModal = ()=>{
        setAddResponseModalOpen(true);
    };
    const closeAddResponseModal = ()=>{
        setAddResponseModalOpen(false);
    };
    if (!task) return null;
    const toggleReponsesButton = ()=>{
        if (!task.taskResponses?.length) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
            className: "items-center flex-none",
            buttons: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                    isExpanded: responseListVisible,
                    action: ()=>setResponseListVisible(!responseListVisible),
                    expandText: t("showReponses"),
                    collapseText: t("hideResponses")
                }, "1")
            ]
        });
    };
    const changeStepPosition = (task, position)=>{
        if (position > 0 && position <= casePathway.tasks.length) {
            task.casePathwayPosition = position;
            const editData = {
                casePathwayTask: task
            };
            task.casePathwayPosition = position;
            dispatch((0, $h0rpN.updateCasePathwayAction)(casePathway.caseId, props.casePathwayId, editData));
        }
    };
    const renderAddResponseModal = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
            isOpen: addResponseModalOpen,
            onRequestClose: closeAddResponseModal,
            style: (0, $jF0Xa.defaultModalStyle),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                handleClose: closeAddResponseModal,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $az7E7.default), {
                    caseId: task.caseId,
                    taskId: task.id,
                    closeAction: closeAddResponseModal
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                className: "bg-white rounded-md text-sm",
                hasBorder: false,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2gLZ.default), {
                        taskId: props.taskId
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col justify-between h-max",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-row items-start justify-end mb-3 mt-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RU2vz.default), {
                                            task: task
                                        }),
                                        task.permissions?.canContribute && !theCase.locked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22l7u.default), {
                                            id: task.id,
                                            actions: [
                                                {
                                                    text: t("case:casePathways:buttons:addResponse"),
                                                    action: openAddResponseModal
                                                },
                                                {
                                                    text: t("case:casePathways:buttons:assignTask"),
                                                    action: openAssignTaskModal
                                                },
                                                {
                                                    text: t("task:deleteTask"),
                                                    action: ()=>openDeleteTaskModal(task)
                                                },
                                                {
                                                    text: t("case:casePathways:buttons:editTask"),
                                                    action: openEditTaskModal
                                                },
                                                {
                                                    text: t("case:casePathways:buttons:moveTaskUp"),
                                                    action: ()=>changeStepPosition(task, task.casePathwayPosition -= 1),
                                                    isDisabled: task.casePathwayPosition == 1
                                                },
                                                {
                                                    text: t("case:casePathways:buttons:moveTaskDown"),
                                                    action: ()=>changeStepPosition(task, task.casePathwayPosition += 1),
                                                    isDisabled: task.casePathwayPosition == casePathway.tasks.length
                                                }
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex flex-row items-start justify-end mr-1",
                                    children: toggleReponsesButton()
                                })
                            ]
                        })
                    })
                ]
            }, task.casePathwayPosition + task.id),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-sm",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: responseListVisible ? "" : "hidden",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $598zU.default), {
                        ...props
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kACia.default), {
                isOpen: assignTaskModalOpen,
                closeModal: closeAssignTaskModal,
                casePathwayId: props.casePathwayId,
                taskId: props.taskId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gLVaA.default), {
                isOpen: !!deleteTask,
                closeModal: closeDeleteTaskModal,
                casePathwayId: props.casePathwayId,
                taskId: props.taskId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ysgl.default), {
                isOpen: editTaskModalOpen,
                closeModal: closeEditTaskModal,
                casePathwayId: props.casePathwayId,
                taskId: props.taskId
            }),
            renderAddResponseModal()
        ]
    });
};
var $99bcd7b661a06f98$export$2e2bcd8739ae039 = $99bcd7b661a06f98$var$CasePathwayTaskListItem;

});
parcelRegister("22l7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c31c4250c3e7851$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $iVT8j = parcelRequire("iVT8j");

var $8BOWl = parcelRequire("8BOWl");
const $3c31c4250c3e7851$var$menuLinkClasses = "block text-xs p-3 my-1 hover:bg-ch-blue-alt-300 text-ch-gray-600 min-w-32 cursor-pointer";
const $3c31c4250c3e7851$var$menuLinkDisabledClasses = "block text-xs p-3 my-1 text-ch-gray-500 min-w-32 cursor-pointer";
const $3c31c4250c3e7851$var$ContextMenu = (props)=>{
    const toolTipId = `context-menu-${props.id}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                "data-tip": true,
                "data-for": toolTipId,
                "data-event": "click",
                "data-padding": "12px 50px",
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8BOWl.default), {
                    className: "text-ch-purple-500 w-6 h-6"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVT8j.default), {
                className: "popup-menu",
                globalEventOff: "click",
                id: toolTipId,
                clickable: true,
                effect: "solid",
                backgroundColor: "white",
                border: true,
                borderColor: "#E0E0E0",
                children: props.actions.map((action, index)=>{
                    const classes = action.isDisabled ? $3c31c4250c3e7851$var$menuLinkDisabledClasses : $3c31c4250c3e7851$var$menuLinkClasses;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        onClick: action.action,
                        className: classes,
                        children: action.text
                    }, index);
                })
            })
        ]
    });
};
var $3c31c4250c3e7851$export$2e2bcd8739ae039 = $3c31c4250c3e7851$var$ContextMenu;

});

parcelRegister("kACia", function(module, exports) {

$parcel$export(module.exports, "default", () => $65eef7b4e8a8b020$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $4qaeN = parcelRequire("4qaeN");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $l57jE = parcelRequire("l57jE");

var $9mz9n = parcelRequire("9mz9n");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $h0rpN = parcelRequire("h0rpN");

var $EPx0D = parcelRequire("EPx0D");

var $c2gLZ = parcelRequire("c2gLZ");

var $RU2vz = parcelRequire("RU2vz");
const $65eef7b4e8a8b020$var$AssignCasePathwayTaskModal = (props)=>{
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const submitHandler = (taskData)=>{
        dispatch((0, $h0rpN.updateCasePathwayTaskAction)(task.caseId, props.taskId, taskData));
        props.closeModal();
    };
    if (!casePathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.smallModalStyle),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                        className: "bg-white",
                        hasBorder: false,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                    className: "sm:mr-7",
                                    sizeClasses: [
                                        "w-12",
                                        "h-12"
                                    ],
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                        className: "w-6 h-6",
                                        title: casePathway.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-1 lg:grid grid-cols-2 gap-3",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "col-span-1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "font-semibold",
                                                children: casePathway.name
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                        className: "bg-ch-blue-100 rounded-md text-sm mt-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2gLZ.default), {
                                    ...props
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex flex-row items-baseline justify-end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RU2vz.default), {
                                        task: task
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $EPx0D.default), {
                taskId: props.taskId,
                cancelHandler: props.closeModal,
                submitHandler: submitHandler
            })
        ]
    });
};
var $65eef7b4e8a8b020$export$2e2bcd8739ae039 = $65eef7b4e8a8b020$var$AssignCasePathwayTaskModal;

});
parcelRegister("h0rpN", function(module, exports) {

$parcel$export(module.exports, "fetchCasePathwaysAsync", () => $dec49def71329521$export$ba860cffbe9ff46e);
$parcel$export(module.exports, "createCasePathwayAsync", () => $dec49def71329521$export$d4f2a1121c5164d8);
$parcel$export(module.exports, "updateCasePathwayAction", () => $dec49def71329521$export$3a08f2a0d5857c8);
$parcel$export(module.exports, "updateCasePathwayTaskAction", () => $dec49def71329521$export$a9e36bfee35292aa);

var $5dOcp = parcelRequire("5dOcp");
const $dec49def71329521$export$ba860cffbe9ff46e = (caseId)=>{
    return {
        type: (0, $5dOcp.CasePathwaysActionTypes).FETCH_CASE_PATHWAYS_ASYNC_PENDING,
        payload: caseId
    };
};
const $dec49def71329521$export$d4f2a1121c5164d8 = (caseId, pathwayId)=>{
    return {
        type: (0, $5dOcp.CasePathwaysActionTypes).CREATE_CASE_PATHWAY_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            pathwayId: pathwayId
        }
    };
};
const $dec49def71329521$export$3a08f2a0d5857c8 = (caseId, casePathwayId, casePathway)=>{
    return {
        type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            casePathwayId: casePathwayId,
            casePathway: casePathway
        }
    };
};
const $dec49def71329521$export$a9e36bfee35292aa = (caseId, taskId, task)=>{
    return {
        type: (0, $5dOcp.CasePathwaysActionTypes).UPDATE_CASE_PATHWAY_TASK_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            taskId: taskId,
            task: task
        }
    };
};

});

parcelRegister("EPx0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bda4a88d18acea$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $5Hirs = parcelRequire("5Hirs");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $lCZwG = parcelRequire("lCZwG");

var $jRidO = parcelRequire("jRidO");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $6wDTk = parcelRequire("6wDTk");

var $04A9g = parcelRequire("04A9g");

var $ahLi9 = parcelRequire("ahLi9");

var $kon2z = parcelRequire("kon2z");

var $9mz9n = parcelRequire("9mz9n");

var $jF0Xa = parcelRequire("jF0Xa");

var $1Lj4p = parcelRequire("1Lj4p");
const $67bda4a88d18acea$var$validationSchema = $hDGtv.create().shape({
    userIds: $jpuYg.create().of($gcL7X.create()).nullable().min(1, ()=>(0, $5wPBK.default).t("shared:required")),
    dueDate: $gcL7X.create().nullable().required((0, $5wPBK.default).t("shared:required")),
    daysFromNow: $5Hirs.create()
});
const $67bda4a88d18acea$var$AssignCasePathwayTaskForm = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    const [userOptions, setUserOptions] = (0, $acw62.useState)([]);
    const mentionableUsers = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseMemberUsers)(state, {
            caseId: task.caseId
        }));
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(mentionableUsers));
        setUserOptions(options);
    }, [
        mentionableUsers
    ]);
    const initialValues = {
        userIds: task.users,
        daysFromNow: (0, $ahLi9.utcDateToDaysFromNow)(task.dueDate || new Date().toDateString(), timezone),
        dueDate: task.dueDate ? new Date(task.dueDate) : new Date()
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: $67bda4a88d18acea$var$validationSchema,
        onSubmit: (values, { setSubmitting: setSubmitting })=>{
            setSubmitting(true);
            props.submitHandler(values);
        },
        children: ({ values: values, isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, setFieldValue: setFieldValue, errors: errors, touched: touched, isValid: isValid })=>{
            const onChangeDueDate = (val)=>{
                const daysFromNow = val ? (0, $ahLi9.utcDateToDaysFromNow)(val, timezone) : "";
                setFieldValue("dueDate", val);
                setFieldValue("daysFromNow", daysFromNow);
            };
            const onChangeDaysFromNow = (e)=>{
                const value = e.target.value ? (0, $ahLi9.daysFromNowToDate)(e.target.value) : "";
                setFieldValue("dueDate", value);
                handleChange(e);
            };
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-6 w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "userIds",
                                        children: t("task:assignees")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                        name: "userIds",
                                        options: userOptions,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        isMulti: true,
                                        closeMenuOnSelect: false,
                                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.userIds,
                                        isVisible: !!errors.userIds
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                        name: "dueDate",
                                        children: [
                                            t("case:casePathways:dueDate"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex mr-4 mb-1",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                                            name: "dueDate",
                                                            onChange: onChangeDueDate
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                            errorMessage: errors.dueDate,
                                                            isVisible: errors.dueDate && touched.dueDate
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                            className: "mr-2",
                                                            name: "daysFromNow",
                                                            children: t("OR")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                            type: "number",
                                                            name: "daysFromNow",
                                                            onChange: onChangeDaysFromNow,
                                                            onBlur: handleBlur,
                                                            value: values.daysFromNow.toString(),
                                                            autoComplete: "off",
                                                            className: "lg:w-1/4 md:w-1/2"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "ml-2",
                                                            children: t("daysFromNow")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    action: ()=>props.cancelHandler(),
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: !dirty || !isValid || isSubmitting,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("case:casePathways:buttons:assignTask")
                                }, "2")
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $67bda4a88d18acea$export$2e2bcd8739ae039 = $67bda4a88d18acea$var$AssignCasePathwayTaskForm;

});

parcelRegister("c2gLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9575be73dad30216$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $eEtn6 = parcelRequire("eEtn6");

var $7hl6H = parcelRequire("7hl6H");

var $9mz9n = parcelRequire("9mz9n");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");

var $g9gc3 = parcelRequire("g9gc3");
const $9575be73dad30216$var$CasePathwayTaskDetails = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    if (!task) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-1 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    sizeClasses: [
                        "w-7",
                        "h-7"
                    ],
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                        className: "fill-current w-7 h-7"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                            className: "font-semibold mb-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        task.casePathwayPosition,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: task.action
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: task.description
                        }),
                        task.users.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        t("task:assignedTo"),
                                        ": ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g9gc3.default), {
                                            taskId: props.taskId
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        t("task:dueDate"),
                                        ": ",
                                        task.dueDate ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                            utcTime: task.dueDate
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                            children: t("task:dueDateNotSet")
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
var $9575be73dad30216$export$2e2bcd8739ae039 = $9575be73dad30216$var$CasePathwayTaskDetails;

});

parcelRegister("RU2vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b512a8a7b33abf5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
const $2b512a8a7b33abf5$var$buildTaskStatusLabel = (text, colour)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `text-sm text-white px-1 rounded mr-2 flex content-center ${colour}`,
        children: text
    });
};
const $2b512a8a7b33abf5$var$PathwayTaskStatusLabel = ({ task: task })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    if (task.completedAt) return $2b512a8a7b33abf5$var$buildTaskStatusLabel(t("completed"), "bg-ch-green-300");
    if (!task.users?.length) return $2b512a8a7b33abf5$var$buildTaskStatusLabel(t("unassigned"), "bg-ch-blue-alt-300");
    return $2b512a8a7b33abf5$var$buildTaskStatusLabel(t("assigned"), "bg-ch-blue-alt-500");
};
var $2b512a8a7b33abf5$export$2e2bcd8739ae039 = $2b512a8a7b33abf5$var$PathwayTaskStatusLabel;

});


parcelRegister("gLVaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5d6309dd73a19c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $7jD0k = parcelRequire("7jD0k");

var $1Cmbh = parcelRequire("1Cmbh");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $jCko4 = parcelRequire("jCko4");

var $l57jE = parcelRequire("l57jE");

var $blYn7 = parcelRequire("blYn7");

var $4KSAX = parcelRequire("4KSAX");

var $9mz9n = parcelRequire("9mz9n");
const $7f5d6309dd73a19c$var$DeleteCasePathwayTaskModal = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    if (!task || !casePathway) return null;
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task",
        "pathway"
    ]);
    const confirmDelete = (task)=>{
        dispatch((0, $blYn7.deleteCaseTaskAsync)(casePathway.caseId, task.id, casePathway.id));
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.dialogueModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-3",
                    children: [
                        t("task:deleteTaskHeader"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCko4.default), {
                        casePathwayId: props.casePathwayId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "my-3",
                    children: [
                        t("task:deleteTaskDetails"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    className: "bg-ch-gray-300",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                sizeClasses: [
                                    "w-7",
                                    "h-7"
                                ],
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                                    className: "fill-current w-7 h-7"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                        className: "font-semibold mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    task.casePathwayPosition,
                                                    ". "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: task.action
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: task.description
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "my-3",
                    children: t("pathway:details:deleteAreYouSure")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    buttons: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>props.closeModal(),
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("shared:cancel")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lCZwG.default), {
                            action: ()=>confirmDelete(task),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: [
                                t("task:deleteTask"),
                                " "
                            ]
                        }, "2")
                    ]
                })
            ]
        })
    });
};
var $7f5d6309dd73a19c$export$2e2bcd8739ae039 = $7f5d6309dd73a19c$var$DeleteCasePathwayTaskModal;

});
parcelRegister("jCko4", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f3c237223f6c3b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4qaeN = parcelRequire("4qaeN");

var $l57jE = parcelRequire("l57jE");

var $dIv7c = parcelRequire("dIv7c");
const $31f3c237223f6c3b$var$CasePathwayHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    hasBorder: false,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:pathway")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIv7c.default), {
                                casePathwayId: props.casePathwayId
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt-4 p-4 bg-ch-blue-100 rounded-md",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                children: [
                                    t("case:casePathways:summary"),
                                    ":"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: casePathway.description || t("case:casePathways:noSummary")
                        })
                    ]
                })
            ]
        })
    });
};
var $31f3c237223f6c3b$export$2e2bcd8739ae039 = $31f3c237223f6c3b$var$CasePathwayHeader;

});
parcelRegister("dIv7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $62917e0fbaae4a11$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7hl6H = parcelRequire("7hl6H");

var $l57jE = parcelRequire("l57jE");
const $62917e0fbaae4a11$export$60adb7813e9f159 = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    if (!casePathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: casePathway.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:createdBy"),
                            ": ",
                            casePathway.createdBy.firstName,
                            " ",
                            casePathway.createdBy.lastName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:lastUpdated"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: casePathway.updatedAt || casePathway.createdAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("case:casePathways:tasks"),
                            ": ",
                            casePathway.tasks.length
                        ]
                    })
                ]
            })
        ]
    });
};
var $62917e0fbaae4a11$export$2e2bcd8739ae039 = $62917e0fbaae4a11$export$60adb7813e9f159;

});


parcelRegister("blYn7", function(module, exports) {

$parcel$export(module.exports, "fetchTasksAsync", () => $0e0a4dc1588065e6$export$cf6d3e318a1f206b);
$parcel$export(module.exports, "fetchCaseTasksAsync", () => $0e0a4dc1588065e6$export$8a7a0ac138572702);
$parcel$export(module.exports, "createCaseTaskAsync", () => $0e0a4dc1588065e6$export$5222f770ee5d40c);
$parcel$export(module.exports, "deleteCaseTaskAsync", () => $0e0a4dc1588065e6$export$ab6c25570e855fd1);

var $dbP5t = parcelRequire("dbP5t");
const $0e0a4dc1588065e6$export$cf6d3e318a1f206b = (searchQuery)=>{
    return {
        type: (0, $dbP5t.TasksActionTypes).FETCH_TASKS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $0e0a4dc1588065e6$export$8a7a0ac138572702 = (caseId)=>{
    return {
        type: (0, $dbP5t.TasksActionTypes).FETCH_CASE_TASKS_ASYNC_PENDING,
        payload: caseId
    };
};
const $0e0a4dc1588065e6$export$5222f770ee5d40c = (caseId, task)=>{
    return {
        type: (0, $dbP5t.TasksActionTypes).CREATE_CASE_TASK_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            task: task,
            casePathwayId: task.casePathwayId
        }
    };
};
const $0e0a4dc1588065e6$export$ab6c25570e855fd1 = (caseId, taskId, casePathwayId)=>{
    return {
        type: (0, $dbP5t.TasksActionTypes).DELETE_CASE_TASK_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            taskId: taskId,
            casePathwayId: casePathwayId
        }
    };
};

});


parcelRegister("1ysgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8552342bc2c16b6e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $jCko4 = parcelRequire("jCko4");

var $4KSAX = parcelRequire("4KSAX");

var $9mz9n = parcelRequire("9mz9n");

var $7KrKp = parcelRequire("7KrKp");

var $h0rpN = parcelRequire("h0rpN");
const $8552342bc2c16b6e$var$EditCasePathwayTaskModal = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    if (!task) return null;
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)("pathway");
    const submitHandler = (taskData)=>{
        dispatch((0, $h0rpN.updateCasePathwayTaskAction)(task.caseId, props.taskId, taskData));
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-3",
                    children: [
                        t("task:editTaskHeader"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCko4.default), {
                        casePathwayId: props.casePathwayId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7KrKp.default), {
                    taskId: props.taskId,
                    cancelHandler: props.closeModal,
                    submitHandler: submitHandler
                })
            ]
        })
    });
};
var $8552342bc2c16b6e$export$2e2bcd8739ae039 = $8552342bc2c16b6e$var$EditCasePathwayTaskModal;

});
parcelRegister("7KrKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $db30f15da5e915e0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $lCZwG = parcelRequire("lCZwG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $aSzjr = parcelRequire("aSzjr");

var $04A9g = parcelRequire("04A9g");

var $9mz9n = parcelRequire("9mz9n");

var $jF0Xa = parcelRequire("jF0Xa");
const $db30f15da5e915e0$var$validationSchema = $hDGtv.create().shape({
    action: $gcL7X.create().nullable().required((0, $5wPBK.default).t("shared:required")),
    description: $gcL7X.create().nullable().required((0, $5wPBK.default).t("shared:required"))
});
const $db30f15da5e915e0$var$EditCasePathwayTaskForm = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    const initialValues = {
        action: task.action,
        description: task.description
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: $db30f15da5e915e0$var$validationSchema,
        onSubmit: (values, { setSubmitting: setSubmitting })=>{
            setSubmitting(true);
            props.submitHandler(values);
        },
        children: ({ values: values, isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, setFieldValue: setFieldValue, errors: errors, touched: touched, isValid: isValid })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-6 w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "action",
                                        required: true,
                                        children: t("task:action")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "action",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.action,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.action,
                                        isVisible: errors.action && touched.action
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "description",
                                        required: true,
                                        children: t("task:description")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                        name: "description",
                                        setValue: (description)=>setFieldValue("description", description),
                                        onBlur: handleBlur,
                                        users: null,
                                        value: values.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.description,
                                        isVisible: errors.description && touched.description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    action: ()=>props.cancelHandler(),
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: !dirty || !isValid || isSubmitting,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("task:updateTask")
                                }, "2")
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $db30f15da5e915e0$export$2e2bcd8739ae039 = $db30f15da5e915e0$var$EditCasePathwayTaskForm;

});


parcelRegister("az7E7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5868a2275364ef4e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $3DrkG = parcelRequire("3DrkG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $7lHgq = parcelRequire("7lHgq");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $aSzjr = parcelRequire("aSzjr");

var $04A9g = parcelRequire("04A9g");

var $9mz9n = parcelRequire("9mz9n");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");

var $diqUJ = parcelRequire("diqUJ");

var $aeAlE = parcelRequire("aeAlE");
const $5868a2275364ef4e$var$AddResponseForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const createTaskRespose = (caseId, taskId, taskResponse)=>dispatch((0, $diqUJ.createCaseTaskResponseAsync)(caseId, taskId, taskResponse));
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, {
            taskId: props.taskId
        }));
    const initialValues = {
        response: "",
        markedTaskAsComplete: false,
        caseAssetAttributes: {
            assetType: "Document",
            assetAttributes: {
                file: null,
                name: ""
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg mb-3",
                children: t("task:respondToTask")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-ch-purple-500 mr-2 mt-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                            className: "w-5 h-5",
                            title: task.action
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "font-semibold",
                        children: task.action
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "text-ch-blue-600 mb-3",
                children: [
                    t("task:responseIntro:main"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "text-ch-blue-600 mb-3 list-disc list-inside",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: t("task:responseIntro:comment")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: t("task:responseIntro:file")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: t("task:responseIntro:markComplete")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $aeAlE.caseTaskResponseNewValidation),
                validateOnChange: true,
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createTaskRespose(props.caseId, props.taskId, values);
                    setSubmitting(false);
                    props.closeAction();
                },
                children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "response",
                                        required: true,
                                        children: t("task:response")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                        name: "response",
                                        setValue: (description)=>setFieldValue("response", description),
                                        onBlur: handleBlur,
                                        users: null,
                                        value: values.response
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.response,
                                        isVisible: errors.response && touched.response
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                        name: "caseAssetAttributes.assetAttributes.file",
                                        children: [
                                            t("task:fileUpload"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lHgq.default), {
                                        name: "caseAssetAttributes.assetAttributes.file",
                                        onChange: (event)=>{
                                            setFieldValue("caseAssetAttributes.assetAttributes.file", event.currentTarget.files[0]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors?.caseAssetAttributes?.assetAttributes?.file,
                                        isVisible: errors?.caseAssetAttributes?.assetAttributes?.file && touched.caseAssetAttributes?.assetAttributes?.file
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                        name: "caseAssetAttributes.assetAttributes.name",
                                        children: [
                                            t("task:fileTitle"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        name: "caseAssetAttributes.assetAttributes.name",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values?.caseAssetAttributes?.assetAttributes.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors?.caseAssetAttributes?.assetAttributes?.name,
                                        isVisible: errors?.caseAssetAttributes?.assetAttributes?.name && touched.caseAssetAttributes?.assetAttributes?.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "my-6",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                    name: "markedTaskAsComplete",
                                    className: "flex items-center cursor-pointer p-2 rounded-md bg-ch-blue-100 justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "mr-2 font-semibold",
                                            children: [
                                                t("task:markTaskAsComplete"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3DrkG.default), {
                                            name: "markedTaskAsComplete",
                                            value: values.markedTaskAsComplete
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("task:addResponse")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $5868a2275364ef4e$export$2e2bcd8739ae039 = $5868a2275364ef4e$var$AddResponseForm;

});
parcelRegister("3DrkG", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f513948f98ac58$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");

var $7YFi7 = parcelRequire("7YFi7");

var $8g1PZ = parcelRequire("8g1PZ");
const $05f513948f98ac58$var$CheckmarkToggle = ({ variant: variant = (0, $jF0Xa.StyleVariants).BLUE, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("cursor-pointer", `hover:text-${variant}-600`, {
                    "text-ch-gray-500": !props.value,
                    [`text-${variant}-500`]: props.value
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                    className: "fill-current w-6 h-6"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                    type: "checkbox",
                    name: props.name,
                    id: props.name
                })
            })
        ]
    });
};
var $05f513948f98ac58$export$2e2bcd8739ae039 = $05f513948f98ac58$var$CheckmarkToggle;

});

parcelRegister("diqUJ", function(module, exports) {

$parcel$export(module.exports, "createCaseTaskResponseAsync", () => $4acedce247cc4d5c$export$c23a9fdbe849bd93);

var $aif7R = parcelRequire("aif7R");
const $4acedce247cc4d5c$export$c23a9fdbe849bd93 = (caseId, taskId, taskResponse)=>{
    return {
        type: (0, $aif7R.TaskResponseActionTypes).CREATE_CASE_TASK_RESPONSE_ASYNC_PENDING,
        payload: {
            caseId: caseId,
            taskId: taskId,
            taskResponse: taskResponse
        }
    };
};

});

parcelRegister("aeAlE", function(module, exports) {

$parcel$export(module.exports, "caseTaskResponseNewValidation", () => $0e313242b7ea42b2$export$159ebca65c16551b);
parcelRequire("cxhNX");
var $dmHdY = parcelRequire("dmHdY");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $k7EMY = parcelRequire("k7EMY");
const $0e313242b7ea42b2$export$159ebca65c16551b = ()=>{
    return $hDGtv.create().shape({
        response: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(1500, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 1500
        })),
        caseAssetAttributes: $hDGtv.create({
            assetAttributes: $hDGtv.create({
                name: $gcL7X.create().trim().max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
                    maxLength: 50
                })),
                file: $dmHdY.create().test("fileSizeMaximum", (0, $5wPBK.default).t("shared:fileTooLarge", {
                    maxFileSize: (0, $k7EMY.fileUploadOptions).maxFileSizeMB
                }), (value)=>{
                    return (0, $k7EMY.isFilesSizeUnderMaximum)(value);
                }).test("acceptedFileType", (0, $5wPBK.default).t("shared:fileWrongType", {
                    acceptedFileTypes: (0, $k7EMY.fileUploadOptions).acceptedFileTypes
                }), (value)=>{
                    return (0, $k7EMY.isFileAcceptedType)(value);
                })
            })
        })
    });
};

});




parcelRegister("lV7Qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ef9a38eedc965$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ahLi9 = parcelRequire("ahLi9");

var $1Lj4p = parcelRequire("1Lj4p");

var $4KSAX = parcelRequire("4KSAX");
const $633ef9a38eedc965$var$TimeDaysFromNow = ({ utcTime: utcTime, className: className })=>{
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    if (!utcTime) return null;
    const daysFromNow = (0, $ahLi9.utcDateToDaysFromNow)(utcTime, timezone);
    if (daysFromNow >= 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: className,
        children: [
            "(",
            daysFromNow,
            " ",
            t("shared:daysFromNow"),
            ")"
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: className,
        children: [
            "(",
            -daysFromNow,
            " ",
            t("shared:daysAgo"),
            ")"
        ]
    });
};
var $633ef9a38eedc965$export$2e2bcd8739ae039 = $633ef9a38eedc965$var$TimeDaysFromNow;

});

parcelRegister("fBVzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b1553bfec8dc238$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $2sgOd = parcelRequire("2sgOd");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7jD0k = parcelRequire("7jD0k");

var $ahLi9 = parcelRequire("ahLi9");

var $l57jE = parcelRequire("l57jE");

var $jF0Xa = parcelRequire("jF0Xa");

var $k7hr6 = parcelRequire("k7hr6");

var $jCko4 = parcelRequire("jCko4");

var $h0rpN = parcelRequire("h0rpN");

var $1Lj4p = parcelRequire("1Lj4p");
const $7b1553bfec8dc238$var$AssignDueDateModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const assignedDate = casePathway.dueDate ? new Date(casePathway.dueDate) : null;
    const assignDueDate = (values)=>{
        const dateWithEveningDeadline = (0, $2sgOd.default)((0, $ahLi9.zonedDateToUtc)(values.dueDate, timezone, "10:00pm"));
        const data = {
            dueDate: dateWithEveningDeadline
        };
        dispatch((0, $h0rpN.updateCasePathwayAction)(casePathway.caseId, props.casePathwayId, data));
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("case:casePathways:assignADueDate")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCko4.default), {
                    casePathwayId: props.casePathwayId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7hr6.default), {
                    submitHandler: assignDueDate,
                    cancelHandler: props.closeModal,
                    dueDate: assignedDate
                })
            ]
        })
    });
};
var $7b1553bfec8dc238$export$2e2bcd8739ae039 = $7b1553bfec8dc238$var$AssignDueDateModal;

});
parcelRegister("k7hr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $823da5da52dcf1af$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $2sgOd = parcelRequire("2sgOd");

var $lCZwG = parcelRequire("lCZwG");

var $jRidO = parcelRequire("jRidO");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $jF0Xa = parcelRequire("jF0Xa");

var $ahLi9 = parcelRequire("ahLi9");

var $1Lj4p = parcelRequire("1Lj4p");
const $823da5da52dcf1af$var$AssignDueDateForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const { timezone: timezone } = (0, $acw62.useContext)((0, $1Lj4p.UserConfigContext));
    const initialValues = {
        dueDate: props.dueDate,
        daysFromNow: props.dueDate ? (0, $ahLi9.utcDateToDaysFromNow)((0, $2sgOd.default)(props.dueDate), timezone) : ""
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: props.submitHandler,
        children: ({ values: values, isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, setFieldValue: setFieldValue })=>{
            const onChangeDueDate = (val)=>{
                const daysFromNow = (0, $ahLi9.utcDateToDaysFromNow)(val, timezone) || "";
                setFieldValue("dueDate", val);
                setFieldValue("daysFromNow", daysFromNow);
            };
            const onChangeDaysFromNow = (e)=>{
                setFieldValue("dueDate", (0, $ahLi9.daysFromNowToDate)(e.target.value));
                handleChange(e);
            };
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-6 w-full",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                    name: "dueDate",
                                    children: [
                                        t("case:casePathways:dueDate"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex mr-4 mb-1",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex flex-col",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                                    name: "dueDate",
                                                    onChange: onChangeDueDate
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-row items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                        className: "mr-2",
                                                        name: "daysFromNow",
                                                        children: t("OR")
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                        type: "number",
                                                        name: "daysFromNow",
                                                        onChange: onChangeDaysFromNow,
                                                        onBlur: handleBlur,
                                                        value: values.daysFromNow.toString(),
                                                        autoComplete: "off",
                                                        className: "lg:w-1/4 md:w-1/2"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ml-2",
                                                        children: t("daysFromNow")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    action: ()=>props.cancelHandler(),
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: !dirty || isSubmitting,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("case:casePathways:buttons:assign")
                                }, "2")
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $823da5da52dcf1af$export$2e2bcd8739ae039 = $823da5da52dcf1af$var$AssignDueDateForm;

});


parcelRegister("bRGJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7165f6b4e0cfc091$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7jD0k = parcelRequire("7jD0k");

var $l57jE = parcelRequire("l57jE");

var $jF0Xa = parcelRequire("jF0Xa");

var $jCko4 = parcelRequire("jCko4");

var $hR6sH = parcelRequire("hR6sH");

var $h0rpN = parcelRequire("h0rpN");
const $7165f6b4e0cfc091$var$EditCasePathwayModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const submitHandler = (values)=>{
        const data = {
            name: values.name,
            description: values.description
        };
        dispatch((0, $h0rpN.updateCasePathwayAction)(casePathway.caseId, props.casePathwayId, data));
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("case:casePathways:editCasePathway")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCko4.default), {
                    casePathwayId: props.casePathwayId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hR6sH.default), {
                    submitHandler: submitHandler,
                    cancelHandler: props.closeModal,
                    casePathwayId: props.casePathwayId
                })
            ]
        })
    });
};
var $7165f6b4e0cfc091$export$2e2bcd8739ae039 = $7165f6b4e0cfc091$var$EditCasePathwayModal;

});
parcelRegister("hR6sH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ed411d71df606f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $l57jE = parcelRequire("l57jE");

var $jF0Xa = parcelRequire("jF0Xa");

var $9lk2n = parcelRequire("9lk2n");
const $a0ed411d71df606f$var$EditCasePathwayForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const casePathway = (0, $iD0SF.useSelector)((0, $l57jE.getCasePathwayById)(props));
    const initialValues = {
        name: casePathway.name,
        description: casePathway.description
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        onSubmit: props.submitHandler,
        validationSchema: (0, $9lk2n.casePathwayEditValidation),
        children: ({ values: values, isSubmitting: isSubmitting, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, errors: errors, touched: touched })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "name",
                                required: true,
                                children: t("pathway:name")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                type: "text",
                                name: "name",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.name,
                                autoComplete: "off",
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.name,
                                isVisible: errors.name && touched.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "description",
                                required: true,
                                children: t("pathway:summary")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                type: "text",
                                name: "description",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.description,
                                autoComplete: "off",
                                as: "textarea",
                                className: "h-32"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.description,
                                isVisible: errors.description && touched.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    action: ()=>props.cancelHandler(),
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: !dirty || isSubmitting,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("case:casePathways:buttons:updateCasePathway")
                                }, "2")
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $a0ed411d71df606f$export$2e2bcd8739ae039 = $a0ed411d71df606f$var$EditCasePathwayForm;

});
parcelRegister("9lk2n", function(module, exports) {

$parcel$export(module.exports, "casePathwayEditValidation", () => $bceda674d95bcf5b$export$3efb2701399cc73e);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $bceda674d95bcf5b$export$3efb2701399cc73e = ()=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        description: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
    });
};

});



parcelRegister("9jVwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3dc6695b984a174$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");

var $COwA0 = parcelRequire("COwA0");

var $blYn7 = parcelRequire("blYn7");

var $cRKyh = parcelRequire("cRKyh");

var $aSzjr = parcelRequire("aSzjr");

var $5GZlj = parcelRequire("5GZlj");

var $jRidO = parcelRequire("jRidO");

var $1l1FS = parcelRequire("1l1FS");

var $6wDTk = parcelRequire("6wDTk");

var $kon2z = parcelRequire("kon2z");
const $a3dc6695b984a174$var$CaseTaskNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "task"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const [assigneeOptions, setAssigneeOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const caseMembers = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseMemberUsers)(state, {
            caseId: props.caseId
        }));
    const allAssignees = {
        ...caseMembers,
        ...props.mentionableUsers
    };
    const initialValues = {
        action: "",
        description: "",
        dueDate: undefined,
        assigneeIds: [],
        meetingCaseId: meetingCaseId,
        casePathwayId: props.casePathwayId
    };
    (0, $acw62.useEffect)(()=>{
        if (!props.mentionableUsers) return;
        const options = (0, $6wDTk.buildUserOptions)(Object.values(allAssignees));
        setAssigneeOptions(options);
    }, [
        props.mentionableUsers
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addNewTask")
                    }),
                    t("case:addNewTask")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $cRKyh.caseTaskNewValidation),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    props.createTask(props.caseId, values);
                    setSubmitting(false);
                    props.closeAction();
                    (0, $1l1FS.default).replace(props.originTab);
                },
                children: ({ setFieldValue: setFieldValue, isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "action",
                                        required: true,
                                        children: t("task:action")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "action",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.action,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.action,
                                        isVisible: errors.action && touched.action
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "description",
                                        required: true,
                                        children: t("task:description")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                        name: "description",
                                        setValue: (description)=>setFieldValue("description", description),
                                        onBlur: handleBlur,
                                        users: null,
                                        value: values.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.description,
                                        isVisible: errors.description && touched.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "assigneeIds",
                                        children: t("task:assignees")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                        name: "assigneeIds",
                                        options: assigneeOptions,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        isMulti: true,
                                        closeMenuOnSelect: false,
                                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.assigneeIds,
                                        isVisible: errors.assigneeIds && touched.assigneeIds
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "dueDate",
                                        children: t("task:dueDate")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                                        name: "dueDate"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.dueDate,
                                        isVisible: errors.dueDate && touched.dueDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addTask")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
const $a3dc6695b984a174$var$mapDispatchToProps = (dispatch)=>{
    return {
        createTask: (caseId, task)=>dispatch((0, $blYn7.createCaseTaskAsync)(caseId, task))
    };
};
var $a3dc6695b984a174$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $a3dc6695b984a174$var$mapDispatchToProps)($a3dc6695b984a174$var$CaseTaskNewForm);

});
parcelRegister("cRKyh", function(module, exports) {

$parcel$export(module.exports, "caseTaskNewValidation", () => $e694e0cc7e6f71f1$export$66b57dd327b1fc8b);
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $8CK3p = parcelRequire("8CK3p");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");

var $ahLi9 = parcelRequire("ahLi9");
const $e694e0cc7e6f71f1$export$66b57dd327b1fc8b = (timezone)=>{
    return $hDGtv.create().shape({
        action: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 100
        })),
        description: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(1500, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 1500
        })),
        assigneeIds: $jpuYg.create().required((0, $5wPBK.default).t("shared:required")).min(1, (0, $5wPBK.default).t("shared:mustSelectAtLeastOne")),
        dueDate: $8CK3p.create().required((0, $5wPBK.default).t("shared:required")).test("dateisFuture", (0, $5wPBK.default).t("shared:requireFutureDate"), function(value) {
            return (0, $ahLi9.dateIsFuture)(value, this.parent.startTime, timezone);
        })
    });
};

});










parcelRegister("iXtbw", function(module, exports) {

$parcel$export(module.exports, "isTaskFiltered", () => $8dad1cd353e1fd3b$export$38de052f94066a8b);
const $8dad1cd353e1fd3b$export$38de052f94066a8b = (task, filters)=>{
    if (!filters) return false;
    if (filters.showOutstanding && filters.showCompleted) return false;
    if (filters.showCompleted && !task.isComplete) return true;
    if (filters.showOutstanding && task.isComplete) return true;
};

});


parcelRegister("k4WD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b41c1604f9b0f5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");

var $04A9g = parcelRequire("04A9g");
const $e8b41c1604f9b0f5$var$TaskFilter = ({ setFilters: setFilters, initialValues: initialValues })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task"
    ]);
    const [showOutstanding, setShowOutstanding] = (0, $acw62.useState)(initialValues?.showOutstanding || false);
    const [showCompleted, setShowCompleted] = (0, $acw62.useState)(initialValues?.showCompleted || false);
    const setShowAll = ()=>{
        setShowOutstanding(false);
        setShowCompleted(false);
    };
    const showAll = !(showOutstanding || showCompleted);
    const filters = {
        showAll: showAll,
        showOutstanding: showOutstanding,
        showCompleted: showCompleted
    };
    (0, $acw62.useEffect)(()=>{
        setFilters(filters);
    }, [
        showOutstanding,
        showCompleted
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
        className: "text-sm",
        buttons: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showAll,
                action: ()=>setShowAll(),
                children: t("task:filter:all")
            }, 0),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showOutstanding,
                action: ()=>setShowOutstanding(!showOutstanding),
                children: t("task:filter:outstanding")
            }, 1),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                isOn: showCompleted,
                action: ()=>setShowCompleted(!showCompleted),
                children: t("task:filter:completed")
            }, 2)
        ]
    });
};
var $e8b41c1604f9b0f5$export$2e2bcd8739ae039 = $e8b41c1604f9b0f5$var$TaskFilter;

});


parcelRegister("1fhVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0b12b7246d7b9a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $2jvQG = parcelRequire("2jvQG");

var $buMa2 = parcelRequire("buMa2");

var $kIoZV = parcelRequire("kIoZV");

var $4VtCQ = parcelRequire("4VtCQ");

var $7HZDe = parcelRequire("7HZDe");
const $bd0b12b7246d7b9a$var$MeetingCaseAssetList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const deleteTheAsset = (assetId)=>dispatch((0, $7HZDe.deleteAssetAction)(props.caseId, assetId));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, props));
    const meetingCaseAssets = meetingCase.meetingCaseAssets;
    const [assetTypeFilters, setAssetTypeFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    if (!meetingCaseAssets || meetingCaseAssets.length == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:noAssets")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $buMa2.default), {
                setFilters: setAssetTypeFilters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: meetingCaseAssets.map((meetingCaseAsset)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kIoZV.default), {
                        action: ()=>props.openAssetModal(meetingCaseAsset.caseAssetId),
                        meetingCaseAsset: meetingCaseAsset,
                        assetId: meetingCaseAsset.caseAssetId,
                        assetTypeFilters: assetTypeFilters,
                        deleteAction: deleteTheAsset,
                        mentionableUsers: props.mentionableUsers,
                        caseId: props.caseId,
                        meetingCaseId: props.meetingCaseId,
                        meetingId: meetingCase.meeting
                    }, meetingCaseAsset.id);
                })
            })
        ]
    });
};
var $bd0b12b7246d7b9a$export$2e2bcd8739ae039 = $bd0b12b7246d7b9a$var$MeetingCaseAssetList;

});
parcelRegister("kIoZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ec70ac4e27960d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $lxTgp = parcelRequire("lxTgp");

var $hVO2M = parcelRequire("hVO2M");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");
const $09ec70ac4e27960d$var$MeetingCaseAssetListItem = (props)=>{
    const asset = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, props));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, {
            meetingId: props.meetingId
        }));
    const shouldRender = ()=>{
        if (!asset) return false;
        if (!props.meetingId) return true;
        if (!meeting) return true;
        if (!(meeting.status == (0, $32kQ2.MeetingStatuses).Ended || meeting.status == (0, $32kQ2.MeetingStatuses).Cancelled)) return true;
        if (asset.asset.meetingId == props.meetingId) return true;
        if (new Date(asset.createdAt) < new Date(meeting.endDateActual)) return true;
        if (new Date(asset.createdAt) < new Date(meeting.cancelledDate)) return true;
        return false;
    };
    const [returnEarly, setReturnEarly] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        setReturnEarly(!shouldRender());
    }, [
        asset
    ]);
    if (returnEarly) return null;
    if (!asset) return null;
    const assetComponentType = (0, $hVO2M.getComponentTypeForAsset)(asset);
    const Asset = (0, $hVO2M.componentLookup)[assetComponentType];
    const action = (0, $hVO2M.clickableComponentAction)(props.action, assetComponentType);
    // we're hiding the component, not returning null, because this way the
    // image components don't need to reload their images.
    const hidden = (0, $hVO2M.isAssetFiltered)(Asset, props.assetTypeFilters);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("mb-1", {
            hidden: hidden
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Asset, {
            assetId: props.assetId,
            action: action,
            isSelected: props.isSelected,
            caseId: props.caseId,
            meetingId: props.meetingId,
            mentionableUsers: props.mentionableUsers,
            meetingCaseAsset: props.meetingCaseAsset
        })
    }, props.meetingCaseAsset.id);
};
var $09ec70ac4e27960d$export$2e2bcd8739ae039 = $09ec70ac4e27960d$var$MeetingCaseAssetListItem;

});



parcelRegister("5jwmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $406a81d4cb8abe68$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $04A9g = parcelRequire("04A9g");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $e11eN = parcelRequire("e11eN");

var $7HZDe = parcelRequire("7HZDe");

var $COwA0 = parcelRequire("COwA0");

var $kYqkq = parcelRequire("kYqkq");

var $kGWov = parcelRequire("kGWov");

var $5GZlj = parcelRequire("5GZlj");

var $aEgqS = parcelRequire("aEgqS");
const $406a81d4cb8abe68$var$CaseRadiologyLinkNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "radiology"
    ]);
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const radiologyLinkIds = (0, $kYqkq.useAppSelector)((state)=>state.entities.patientRadiologyLinks.allIds);
    const radiologyLinks = (0, $kYqkq.useAppSelector)((state)=>state.entities.patientRadiologyLinks.byId);
    const fetching = (0, $kYqkq.useAppSelector)((state)=>state.ui.patientRadiologyLink.fetching);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const createLink = (caseId, link, meetingCaseId)=>{
        dispatch((0, $7HZDe.createCaseRadiologyLinkAction)(caseId, link, meetingCaseId));
    };
    const [patientLinkOptions, setPatientLinkOptions] = (0, $acw62.useState)();
    const initialValues = {
        title: "",
        fileUuid: "",
        idFile: null,
        dicomName: "",
        meetingCaseId: meetingCaseId
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $7HZDe.fetchPatientRadiologyLinksAction)(props.caseId));
    }, []);
    (0, $acw62.useEffect)(()=>{
        const options = radiologyLinkIds.map((id)=>{
            const link = radiologyLinks[id];
            return {
                value: id,
                label: link.name
            };
        });
        setPatientLinkOptions(options);
    }, [
        radiologyLinkIds
    ]);
    if (fetching) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    if (radiologyLinkIds?.length < 1) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-1 justify-center mt-3 mb-5 font-semibold",
                children: t("radiology:text:noStudiesFound")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                className: "mb-2",
                buttons: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: ()=>{
                            props.closeAction();
                        },
                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                        children: t("shared:back")
                    }, "1")
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e11eN.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("case:addNewRadiologyLink")
                    }),
                    t("case:addNewDicomLink")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                validationSchema: (0, $kGWov.caseRadiologyLinkNewValidation),
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    createLink(props.caseId, values, meetingCaseId);
                    setSubmitting(true);
                    props.closeAction();
                    props.switchToNewAssetTab();
                },
                children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "fileUuid",
                                        required: true,
                                        children: t("asset:study")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                        name: "fileUuid",
                                        options: patientLinkOptions,
                                        onChange: (e)=>{
                                            handleChange(e);
                                            setFieldValue("title", radiologyLinks[e.currentTarget.value].name);
                                            setFieldValue("dicomName", radiologyLinks[e.currentTarget.value].name);
                                            setFieldValue("idFile", radiologyLinks[e.currentTarget.value].idFile);
                                        },
                                        onBlur: handleBlur
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.title,
                                        isVisible: errors.title && touched.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                        name: "title",
                                        required: true,
                                        children: t("asset:title")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "title",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.title,
                                        autoComplete: "off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.title,
                                        isVisible: errors.title && touched.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                className: "mb-2",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        action: ()=>{
                                            props.closeAction();
                                        },
                                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                        children: t("shared:cancel")
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                        isSubmit: true,
                                        children: t("case:addLink")
                                    }, "2")
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $406a81d4cb8abe68$export$2e2bcd8739ae039 = $406a81d4cb8abe68$var$CaseRadiologyLinkNewForm;

});
parcelRegister("kGWov", function(module, exports) {

$parcel$export(module.exports, "caseRadiologyLinkNewValidation", () => $c54c7e52834e19dd$export$b59da8d50c187e5a);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $c54c7e52834e19dd$export$b59da8d50c187e5a = ()=>{
    return $hDGtv.create().shape({
        title: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 100
        }))
    });
};

});


parcelRegister("dA2J6", function(module, exports) {

$parcel$export(module.exports, "default", () => $142c94790dd85703$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $142c94790dd85703$var$useCurrentBreakPoint = ()=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const open = ()=>setIsOpen(true);
    const close = ()=>setIsOpen(false);
    return [
        isOpen,
        open,
        close
    ];
};
var $142c94790dd85703$export$2e2bcd8739ae039 = $142c94790dd85703$var$useCurrentBreakPoint;

});

parcelRegister("lswkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95b670018af11f0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $kQILj = parcelRequire("kQILj");

var $glc4D = parcelRequire("glc4D");

var $eucKq = parcelRequire("eucKq");

var $7Bj8I = parcelRequire("7Bj8I");

var $9QVLZ = parcelRequire("9QVLZ");

var $1kXfn = parcelRequire("1kXfn");

var $39EfS = parcelRequire("39EfS");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $kLdzU = parcelRequire("kLdzU");

var $kYqkq = parcelRequire("kYqkq");

var $3k5Ji = parcelRequire("3k5Ji");

var $a9JpH = parcelRequire("a9JpH");
const $e95b670018af11f0$var$AddFormToCaseModal = (props)=>{
    if (!props.isOpen) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "forms"
    ]);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getAddFormToCaseUI)(state));
    const initialSearchQuery = {
        page: 1,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        appliedFilters: []
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $kLdzU.fetchFormsForCaseAsync));
    const [previewingTemplateId, setPreviewingTemplateId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $kLdzU.fetchFormsForCaseAsync)(searchQuery));
    }, [
        searchQuery
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.handleClose,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.handleClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("forms:addFormToCase:title")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:case")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eucKq.default), {
                                caseId: props.caseId
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-start-2 md:row-start-1 self-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "forms:addFormToCase:search",
                                components: {
                                    strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-end-2 md:row-start-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("forms:addFormToCase:buttons:search")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-2 text-center md:text-left",
                    children: [
                        UI.totalItemsCount,
                        " ",
                        t("forms:forms")
                    ]
                }),
                previewingTemplateId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a9JpH.default), {
                    formTemplateId: previewingTemplateId,
                    onBack: ()=>setPreviewingTemplateId(null)
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3k5Ji.default), {
                    ...props,
                    setPreviewingTemplateId: setPreviewingTemplateId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    totalItems: UI.totalItemsCount,
                    totalPages: UI.totalPages,
                    scrollActionType: (0, $7Bj8I.ScrollActionTypes).UPDATE_MODAL_SCROLL_TO_POSITION
                })
            ]
        })
    });
};
var $e95b670018af11f0$export$2e2bcd8739ae039 = $e95b670018af11f0$var$AddFormToCaseModal;

});
parcelRegister("3k5Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $e391b24ef3d82664$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kYqkq = parcelRequire("kYqkq");

var $dFRnJ = parcelRequire("dFRnJ");
const $e391b24ef3d82664$var$AddFormToCaseList = (props)=>{
    const formTemplateIds = (0, $kYqkq.useAppSelector)((state)=>state.entities.formTemplates.allIds);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: formTemplateIds.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $dFRnJ.default), {
                formTemplateId: id,
                handleClose: props.handleClose,
                caseId: props.caseId,
                setPreviewingTemplateId: props.setPreviewingTemplateId
            }, id))
    });
};
var $e391b24ef3d82664$export$2e2bcd8739ae039 = $e391b24ef3d82664$var$AddFormToCaseList;

});
parcelRegister("dFRnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe3ad7ac1f62a532$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kYqkq = parcelRequire("kYqkq");

var $4KSAX = parcelRequire("4KSAX");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $7hl6H = parcelRequire("7hl6H");

var $lCZwG = parcelRequire("lCZwG");

var $kLdzU = parcelRequire("kLdzU");

var $jF0Xa = parcelRequire("jF0Xa");

var $COwA0 = parcelRequire("COwA0");
const $fe3ad7ac1f62a532$var$AddFormToCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "forms"
    ]);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const formTemplate = (0, $kYqkq.useAppSelector)((state)=>state.entities.formTemplates.byId[props.formTemplateId]);
    const addForm = ()=>{
        console.log(meetingCaseId);
        dispatch((0, $kLdzU.createFormForCaseAction)(props.caseId, props.formTemplateId, meetingCaseId));
        props.handleClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "border border-ch-gray-400 rounded-md p-4 mb-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-wrap justify-center lg:justify-between md:flex-nowrap mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                    className: "fill-current w-6 h-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1 lg:grid grid-cols-2 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: formTemplate.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    t("shared:lastUpdated"),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                                        utcTime: formTemplate.updatedAt
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "col-span-1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                t("forms:formTemplate:description"),
                                                ": ",
                                                formTemplate.description
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                            className: "items-center",
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: addForm,
                                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                                    children: t("forms:addFormToCase:buttons:add")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>props.setPreviewingTemplateId(props.formTemplateId),
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    children: t("forms:addFormToCase:buttons:preview")
                                }, "2")
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $fe3ad7ac1f62a532$export$2e2bcd8739ae039 = $fe3ad7ac1f62a532$var$AddFormToCaseListItem;

});


parcelRegister("a9JpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9240e532ebad1564$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aEgqS = parcelRequire("aEgqS");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $lCZwG = parcelRequire("lCZwG");

var $4KSAX = parcelRequire("4KSAX");

var $jF0Xa = parcelRequire("jF0Xa");
const $9240e532ebad1564$var$FormTemplatePreview = ({ formTemplateId: formTemplateId, onBack: onBack })=>{
    const [previewUrl, setPreviewUrl] = (0, $acw62.useState)(null);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "forms"
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $5s7Tw.default).get(`/form_templates/${formTemplateId}/preview`, (0, $1zizz.withAuthHeader)()).then((res)=>setPreviewUrl(res.data.location));
    }, [
        formTemplateId
    ]);
    if (!previewUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    action: onBack,
                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                    children: t("forms:addFormToCase:buttons:back")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 border border-ch-gray-400 rounded-md p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                    src: previewUrl,
                    className: "w-full h-96"
                })
            })
        ]
    });
};
var $9240e532ebad1564$export$2e2bcd8739ae039 = $9240e532ebad1564$var$FormTemplatePreview;

});



parcelRegister("4jQEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bbb1372799df48f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $dIfKX = parcelRequire("dIfKX");

var $2jvQG = parcelRequire("2jvQG");

var $9jVwF = parcelRequire("9jVwF");

var $jWomF = parcelRequire("jWomF");
var $6bbb1372799df48f$export$b2539bed5023c21c = /*#__PURE__*/ function(Tabs) {
    Tabs["TaskNew"] = "task_new";
    return Tabs;
}({});
const $6bbb1372799df48f$var$AddCaseTaskPanel = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(null);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    const renderTabContent = ()=>{
        switch(currentTab){
            case "task_new":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9jVwF.default), {
                    closeAction: ()=>setCurrentTab(null),
                    originTab: (0, $jWomF.CaseAssetTabNames).TASKS,
                    ...props
                });
            default:
                return null;
        }
    };
    const renderButtons = ()=>{
        if (currentTab !== null) return null;
        if (theCase.locked) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "text-center text-ch-blue-alt-400",
                    children: t("case:addTasksLocked")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "flex mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dIfKX.default), {
                            className: "w-6 h-6 mr-2 text-ch-purple-500",
                            title: t("case:tasksTitle")
                        }),
                        t("case:tasksTitle")
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    className: "mb-2",
                    buttons: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>setCurrentTab("task_new"),
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("case:addTask")
                        }, "1")
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            renderButtons(),
            renderTabContent()
        ]
    });
};
var $6bbb1372799df48f$export$2e2bcd8739ae039 = $6bbb1372799df48f$var$AddCaseTaskPanel;

});

parcelRegister("82PCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $90161f3e355c368e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $2jvQG = parcelRequire("2jvQG");

var $81vvl = parcelRequire("81vvl");

var $dA2J6 = parcelRequire("dA2J6");
var $90161f3e355c368e$export$b2539bed5023c21c = /*#__PURE__*/ function(Tabs) {
    Tabs["SelectPathway"] = "select_pathway";
    return Tabs;
}({});
const $90161f3e355c368e$var$AddCasePathwayPanel = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "pathway"
    ]);
    const caseData = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    const [isModalOpen, openModal, closeModal] = (0, $dA2J6.default)();
    if (caseData.locked) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t("case:addPathwaysLocked")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("shared:pathways")
                    }),
                    t("shared:pathways")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                className: "mb-2",
                buttons: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: openModal,
                        variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                        children: t("pathway:addPathwayToCase:buttons:selectPathway")
                    }, "1")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81vvl.default), {
                caseId: props.caseId,
                isOpen: isModalOpen,
                handleClose: closeModal
            })
        ]
    });
};
var $90161f3e355c368e$export$2e2bcd8739ae039 = $90161f3e355c368e$var$AddCasePathwayPanel;

});
parcelRegister("81vvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e2c0e9d155b42e5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $eCmSQ = parcelRequire("eCmSQ");

var $kQILj = parcelRequire("kQILj");

var $glc4D = parcelRequire("glc4D");

var $eucKq = parcelRequire("eucKq");

var $7Bj8I = parcelRequire("7Bj8I");

var $9QVLZ = parcelRequire("9QVLZ");

var $kVlM3 = parcelRequire("kVlM3");

var $1kXfn = parcelRequire("1kXfn");

var $39EfS = parcelRequire("39EfS");

var $8mOoN = parcelRequire("8mOoN");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $8ikty = parcelRequire("8ikty");

var $ezGxj = parcelRequire("ezGxj");
const $1e2c0e9d155b42e5$var$AddPathwayToCaseModal = (props)=>{
    if (!props.isOpen) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getAddPathwayToCaseUI)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $8ikty.fetchPathwaysAddableToCaseAsync));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.handleClose,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.handleClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("pathway:addPathwayToCase:title")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:case")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eucKq.default), {
                                caseId: props.caseId
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-start-2 md:row-start-1 self-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "pathway:index:searchBy",
                                components: {
                                    strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-end-2 md:row-start-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("pathway:index:buttons:searchPathways")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-2 text-center md:text-left",
                    children: [
                        UI.totalPathwaysCount,
                        " ",
                        t("shared:pathways")
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "grid grid-flow-row md:grid-flow-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ezGxj.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery,
                                orderByOptions: (0, $eCmSQ.PathwaysOrderByOptions),
                                useTranslation: "pathway:index:orderBy"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8mOoN.default), {
                    caseId: props.caseId,
                    closeModal: props.handleClose
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    totalItems: UI.totalPathwaysCount,
                    totalPages: UI.totalPages,
                    scrollActionType: (0, $7Bj8I.ScrollActionTypes).UPDATE_MODAL_SCROLL_TO_POSITION
                })
            ]
        })
    });
};
var $1e2c0e9d155b42e5$export$2e2bcd8739ae039 = $1e2c0e9d155b42e5$var$AddPathwayToCaseModal;

});
parcelRegister("8mOoN", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c517a001d02a87$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $9L4IW = parcelRequire("9L4IW");

var $58mhG = parcelRequire("58mhG");
const $22c517a001d02a87$var$AddPathwayToCaseList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "pathway"
    ]);
    const pathwayIds = (0, $iD0SF.useSelector)((state)=>(0, $9L4IW.getPathwaysAddableToCaseIds)(state));
    if (!pathwayIds) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("pathway:addPathwayToCase:noPathways")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: pathwayIds.map((pathwayId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58mhG.default), {
                caseId: props.caseId,
                pathwayId: pathwayId,
                closeModal: props.closeModal
            }, pathwayId);
        })
    });
};
var $22c517a001d02a87$export$2e2bcd8739ae039 = $22c517a001d02a87$var$AddPathwayToCaseList;

});
parcelRegister("58mhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa95399d55562b7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $4KSAX = parcelRequire("4KSAX");

var $5l38P = parcelRequire("5l38P");

var $9L4IW = parcelRequire("9L4IW");

var $4Pjcv = parcelRequire("4Pjcv");

var $kA27M = parcelRequire("kA27M");

var $8g1PZ = parcelRequire("8g1PZ");

var $kK9aK = parcelRequire("kK9aK");
const $afa95399d55562b7$export$bd21e9b6a5df167b = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    if (!pathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "border border-ch-gray-400 rounded-md p-4 mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center flex-wrap justify-center lg:justify-between md:flex-nowrap mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                    className: "sm:mr-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                        className: "fill-current w-6 h-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5l38P.default), {
                                    pathwayId: props.pathwayId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                                className: "items-center",
                                buttons: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Pjcv.default), {
                                        pathwayId: props.pathwayId,
                                        caseId: props.caseId,
                                        closeModal: props.closeModal
                                    }, "1"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                        isExpanded: isExpanded,
                                        action: ()=>setIsExpanded(!isExpanded),
                                        expandText: t("pathway:addPathwayToCase:buttons:showSteps"),
                                        collapseText: t("pathway:addPathwayToCase:buttons:hideSteps"),
                                        className: "ml-2"
                                    }, "2")
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                        "hidden": !isExpanded
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kK9aK.default), {
                        steps: pathway.steps
                    })
                })
            ]
        })
    });
};
var $afa95399d55562b7$export$2e2bcd8739ae039 = $afa95399d55562b7$export$bd21e9b6a5df167b;

});
parcelRegister("5l38P", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb067f2cad1b8eb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7hl6H = parcelRequire("7hl6H");
const $ecb067f2cad1b8eb$export$85e108a9114e803d = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((state)=>state.entities.pathways.byId[props.pathwayId]);
    if (!pathway) return null;
    const creatorOrUpdater = ()=>{
        if (pathway.lastUpdatedBy) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:lastUpdatedBy"),
                pathway.lastUpdatedBy.firstName,
                " ",
                pathway.lastUpdatedBy.lastName
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:createdBy"),
                ": ",
                pathway.createdBy.firstName,
                " ",
                pathway.createdBy.lastName
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: pathway.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:classification"),
                            ": ",
                            pathway.caseClassification.name
                        ]
                    }),
                    creatorOrUpdater()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:lastUpdated"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: pathway.updatedAt || pathway.createdAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("pathway:steps"),
                            ": ",
                            pathway.steps.length
                        ]
                    })
                ]
            })
        ]
    });
};
var $ecb067f2cad1b8eb$export$2e2bcd8739ae039 = $ecb067f2cad1b8eb$export$85e108a9114e803d;

});

parcelRegister("4Pjcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $433add25dc244cb4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $9L4IW = parcelRequire("9L4IW");

var $lCZwG = parcelRequire("lCZwG");

var $h0rpN = parcelRequire("h0rpN");

var $jF0Xa = parcelRequire("jF0Xa");
const $433add25dc244cb4$export$65cefe14a391e416 = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const addPathwayToCase = (caseId, pathwayId)=>dispatch((0, $h0rpN.createCasePathwayAsync)(caseId, pathwayId));
    if (!pathway) return null;
    const onClick = ()=>{
        addPathwayToCase(props.caseId, props.pathwayId);
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
        action: onClick,
        variant: (0, $jF0Xa.StyleVariants).ORANGE,
        children: t("pathway:addPathwayToCase:buttons:selectPathway")
    });
};
var $433add25dc244cb4$export$2e2bcd8739ae039 = $433add25dc244cb4$export$65cefe14a391e416;

});

parcelRegister("kK9aK", function(module, exports) {

$parcel$export(module.exports, "default", () => $58323383fbe0d0a8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");
parcelRequire("jitSV");
var $bKaLx = parcelRequire("bKaLx");

var $7T6sP = parcelRequire("7T6sP");
const $58323383fbe0d0a8$var$AddPathwayToCaseStepList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "pathway"
    ]);
    if (!props.steps) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("pathway:addPathwayToCase:noSteps")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: props.steps.map((step)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                className: "bg-ch-gray-300 rounded-md p-4 text-sm",
                hasBorder: false,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                sizeClasses: [
                                    "w-7",
                                    "h-7"
                                ],
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKaLx.default), {
                                    className: "fill-current w-7 h-7"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7T6sP.default), {
                                step: step
                            })
                        ]
                    })
                })
            }, step.position + step.name);
        })
    });
};
var $58323383fbe0d0a8$export$2e2bcd8739ae039 = $58323383fbe0d0a8$var$AddPathwayToCaseStepList;

});
parcelRegister("7T6sP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fb3bb65f11ab97$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b4fb3bb65f11ab97$export$bb03d422d1792782 = (props)=>{
    if (!props.step) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex-1 lg:grid grid-cols-1 gap-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
            className: "col-span-1",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                    className: "font-semibold",
                    children: [
                        props.step.position,
                        ". ",
                        props.step.name
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: props.step.description
                })
            ]
        })
    });
};
var $b4fb3bb65f11ab97$export$2e2bcd8739ae039 = $b4fb3bb65f11ab97$export$bb03d422d1792782;

});




parcelRegister("8ikty", function(module, exports) {

$parcel$export(module.exports, "fetchPathwaysAddableToCaseAsync", () => $7ddac569a19bdc2a$export$5f1d8034631c59d);

var $cmXxm = parcelRequire("cmXxm");
const $7ddac569a19bdc2a$export$5f1d8034631c59d = (searchQuery)=>{
    return {
        type: (0, $cmXxm.AddPathwayToCaseActionTypes).FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_PENDING,
        payload: searchQuery
    };
};

});

parcelRegister("ezGxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $605195cd8dbb4e09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $605195cd8dbb4e09$var$PathwayFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("shared:all")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("used_by_you"),
                    action: ()=>{
                        updateFilters("used_by_you");
                    },
                    children: t("pathway:index:filters:usedByYou")
                })
            })
        ]
    });
};
var $605195cd8dbb4e09$export$2e2bcd8739ae039 = $605195cd8dbb4e09$var$PathwayFilter;

});





parcelRegister("b703n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d039283486e544fb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $2usJc = parcelRequire("2usJc");

var $luG5F = parcelRequire("luG5F");

var $d5eYa = parcelRequire("d5eYa");

var $6QJY8 = parcelRequire("6QJY8");

var $8UrgM = parcelRequire("8UrgM");

var $bS3zB = parcelRequire("bS3zB");

var $4MHRb = parcelRequire("4MHRb");
const $d039283486e544fb$var$CaseEditPage = ()=>{
    const { caseId: caseId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: caseId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const fetchCaseClassification = ()=>dispatch((0, $4MHRb.fetchCaseClassificationAction)());
    const fetchCase = (caseId)=>dispatch((0, $2usJc.fetchCaseAction)(caseId));
    const fetchCaseSources = ()=>dispatch((0, $bS3zB.fetchCaseSourcesAction)());
    (0, $acw62.useEffect)(()=>{
        fetchCase(caseId);
        fetchCaseClassification();
        fetchUsers();
        fetchCaseSources();
    }, []);
    const caseUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
        caseId: caseId
    });
    const renderContent = ()=>{
        if (!theCase) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("case:caseNotFound")
        });
        if (!theCase.permissions.canEdit) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $luG5F.default), {
                caseId: caseId
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:case"),
                        href: caseUrl
                    },
                    {
                        pageTitle: t("case:editCase")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $d039283486e544fb$export$2e2bcd8739ae039 = $d039283486e544fb$var$CaseEditPage;

});
parcelRegister("luG5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $44db1c23bd06b350$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $2sgOd = parcelRequire("2sgOd");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $2usJc = parcelRequire("2usJc");

var $c0FI2 = parcelRequire("c0FI2");

var $aY3t8 = parcelRequire("aY3t8");

var $kon2z = parcelRequire("kon2z");

var $dfEvr = parcelRequire("dfEvr");

var $aeos3 = parcelRequire("aeos3");

var $4qaeN = parcelRequire("4qaeN");
const $44db1c23bd06b350$var$CaseEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const { signedOffByRequired: signedOffByRequired } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const initialValues = {
        caseType: theCase.caseType,
        caseClassificationId: theCase.caseClassificationId,
        leadCareUserId: theCase.leadCareUser,
        isSignedOffByRequired: signedOffByRequired,
        signedOffBy: theCase.signedOffBy || "",
        targetDate: theCase.targetDate ? new Date(theCase.targetDate) : undefined,
        targetDateFulfilled: theCase.targetDateFulfilled || false,
        sourceId: theCase.sourceId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $aY3t8.caseUpdateValidationSchema),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const targetDate = values.targetDate ? (0, $2sgOd.default)(values.targetDate) : null;
                const data = {
                    id: theCase.id,
                    caseType: values.caseType,
                    caseClassificationId: values.caseClassificationId,
                    leadCareUserId: values.leadCareUserId,
                    signedOffBy: values.signedOffBy,
                    targetDate: targetDate,
                    targetDateFulfilled: values.targetDateFulfilled,
                    sourceId: values.sourceId
                };
                dispatch((0, $2usJc.updateCase)(data));
                setSubmitting(false);
            },
            children: ({ values: values, errors: errors, touched: touched, setFieldValue: setFieldValue, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting, dirty: dirty })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfEvr.default), {
                            errors: errors,
                            touched: touched,
                            values: values,
                            handleBlur: handleBlur,
                            handleChange: handleChange,
                            setFieldValue: setFieldValue,
                            signedOffByRequired: signedOffByRequired,
                            includeTargetDateFulfilledField: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: !dirty || isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("case:updateCase")
                            })
                        })
                    ]
                })
        })
    });
};
var $44db1c23bd06b350$export$2e2bcd8739ae039 = $44db1c23bd06b350$var$CaseEditForm;

});
parcelRegister("aY3t8", function(module, exports) {

$parcel$export(module.exports, "caseUpdateValidationSchema", () => $9ccfaeef7772fe09$export$f0f55482e92f8a0a);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $9ccfaeef7772fe09$export$f0f55482e92f8a0a = ()=>{
    return $hDGtv.create().shape({
        caseType: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        caseClassificationId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        leadCareUserId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        sourceId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        signedOffBy: $gcL7X.create().when("isSignedOffByRequired", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        }))
    });
};

});

parcelRegister("dfEvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ba79c511b32dfcf$export$2e2bcd8739ae039);
/* slint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $eTqMc = parcelRequire("eTqMc");

var $7UN5R = parcelRequire("7UN5R");

var $6lvMC = parcelRequire("6lvMC");

var $6qYxq = parcelRequire("6qYxq");

var $3Ukkm = parcelRequire("3Ukkm");

var $ifbAI = parcelRequire("ifbAI");

var $jxnLW = parcelRequire("jxnLW");

var $5GZlj = parcelRequire("5GZlj");

var $d8Vwn = parcelRequire("d8Vwn");

var $jRidO = parcelRequire("jRidO");

var $3DrkG = parcelRequire("3DrkG");

var $f1q41 = parcelRequire("f1q41");

var $6wDTk = parcelRequire("6wDTk");

var $7Pvlf = parcelRequire("7Pvlf");
const $3ba79c511b32dfcf$var$CaseFields = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [caseClassificationOptions, setCaseClassificationOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [caseSourceOptions, setCaseSourceOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const keyedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(users, "id");
    const caseClassifications = (0, $iD0SF.useSelector)((0, $jxnLW.getAllCaseClassifications));
    const caseSources = (0, $iD0SF.useSelector)((0, $7Pvlf.getAllCaseSources));
    const caseTypeOptions = Object.keys((0, $6qYxq.CaseTypes)).map((key)=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $6qYxq.CaseTypes)[key]);
        return {
            value: (0, $6qYxq.CaseTypes)[key],
            label: t(`case:${translationKey}`)
        };
    });
    const setCaseClassificationOptionsForCaseType = (caseType)=>{
        const options = (0, $d8Vwn.generateCaseClassificationOptions)(caseClassifications, caseType);
        setCaseClassificationOptions(options);
    };
    const onChangeCaseType = (e)=>{
        setCaseClassificationOptionsForCaseType(e.currentTarget.value);
        props.setFieldValue("caseClassificationId", "");
        props.setFieldValue("leadCareUserId", "");
        props.handleChange(e);
    };
    const onChangeClassification = (e)=>{
        props.setFieldValue("leadCareUserId", "");
        props.handleChange(e);
    };
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(keyedUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        setCaseClassificationOptionsForCaseType(props.values.caseType);
    }, [
        caseClassifications
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateCaseSourceOptions)(caseSources);
        setCaseSourceOptions(options);
    }, [
        caseSources
    ]);
    const renderSignedOffByField = ()=>{
        if (!props.signedOffByRequired) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "signedOffBy",
                    required: props.signedOffByRequired,
                    children: t("case:signedOffBy")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                    type: "text",
                    name: "signedOffBy",
                    onChange: props.handleChange,
                    onBlur: props.handleBlur,
                    value: props.values.signedOffBy,
                    autoComplete: "off",
                    autoFocus: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: props.errors.signedOffBy,
                    isVisible: props.errors.signedOffBy && props.touched.signedOffBy
                })
            ]
        });
    };
    const renderTargetDateField = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "targetDate",
                    children: t("case:targetDate")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                    name: "targetDate"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: props.errors.targetDate,
                    isVisible: props.errors.targetDate && props.touched.targetDate
                })
            ]
        });
    };
    const renderTargetDateFulfilledField = ()=>{
        if (!props.includeTargetDateFulfilledField) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-2 md:ml-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                name: "targetDateFulfilled",
                className: "cursor-pointer",
                children: [
                    t("case:targetDateFulfilled"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3DrkG.default), {
                        name: "targetDateFulfilled",
                        value: props.values.targetDateFulfilled
                    })
                ]
            })
        });
    };
    const renderSourceField = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "source",
                    required: true,
                    children: t("case:source")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                    name: "sourceId",
                    options: caseSourceOptions,
                    isGrouped: true,
                    onBlur: props.handleBlur,
                    onChange: props.handleChange
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: props.errors.sourceId,
                    isVisible: props.errors.sourceId && props.touched.sourceId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "mb-2 text-lg",
                    children: t("case:caseDetails")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "md:flex",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2 md:w-1/3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "caseType",
                                    required: true,
                                    children: t("case:caseType")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "caseType",
                                    onChange: onChangeCaseType,
                                    onBlur: props.handleBlur,
                                    options: caseTypeOptions,
                                    placeholder: t("case:chooseCaseType")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: props.errors.caseType,
                                    isVisible: props.errors.caseType && props.touched.caseType
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 mb-2 md:ml-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "caseClassificationId",
                                    required: true,
                                    children: t("shared:classification")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "caseClassificationId",
                                    options: caseClassificationOptions,
                                    isDisabled: !props.values.caseType,
                                    isGrouped: true,
                                    onChange: onChangeClassification,
                                    onBlur: props.handleBlur
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: props.errors.caseClassificationId,
                                    isVisible: props.errors.caseClassificationId && props.touched.caseClassificationId
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                            name: "leadCareUserId",
                            required: true,
                            children: t("case:leadCare")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                            name: "leadCareUserId",
                            options: userOptions,
                            onChange: props.handleChange,
                            onBlur: props.handleBlur,
                            filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                            errorMessage: props.errors.leadCareUserId,
                            isVisible: props.errors.leadCareUserId && props.touched.leadCareUserId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "md:flex ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "md:flex flex-wrap md:w-2/5",
                            children: [
                                renderTargetDateField(),
                                renderTargetDateFulfilledField()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "md:w-3/5",
                            children: renderSourceField()
                        })
                    ]
                }),
                renderSignedOffByField()
            ]
        })
    });
};
var $3ba79c511b32dfcf$export$2e2bcd8739ae039 = $3ba79c511b32dfcf$var$CaseFields;

});
parcelRegister("7Pvlf", function(module, exports) {

$parcel$export(module.exports, "getAllCaseSources", () => $f0dcaea684aa5668$export$75d2d964ecc91582);
$parcel$export(module.exports, "getAllCaseSourceIds", () => $f0dcaea684aa5668$export$3188d003acbe2a26);
$parcel$export(module.exports, "getCaseSourceById", () => $f0dcaea684aa5668$export$cee5b48957e84abb);
const $f0dcaea684aa5668$export$75d2d964ecc91582 = (state)=>state.entities.caseSources.byId;
const $f0dcaea684aa5668$export$3188d003acbe2a26 = (state)=>state.entities.caseSources.allIds;
const $f0dcaea684aa5668$export$cee5b48957e84abb = (state, id)=>state.entities.caseSources.byId[id];

});



parcelRegister("bS3zB", function(module, exports) {

$parcel$export(module.exports, "fetchCaseSourcesAction", () => $d32b584fa7dc9051$export$2df57cd9334dd83c);

var $g7ibY = parcelRequire("g7ibY");
const $d32b584fa7dc9051$export$2df57cd9334dd83c = ()=>{
    return {
        type: (0, $g7ibY.CaseSourceActionTypes).FETCH_CASE_SOURCES_ASYNC_PENDING
    };
};

});


parcelRegister("2xY9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4fdf08ed27ac35$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $bP3DF = parcelRequire("bP3DF");

var $4VtCQ = parcelRequire("4VtCQ");

var $47EkW = parcelRequire("47EkW");

var $6j1K3 = parcelRequire("6j1K3");

var $7HZDe = parcelRequire("7HZDe");

var $gRLLc = parcelRequire("gRLLc");

var $8UrgM = parcelRequire("8UrgM");

var $lxTgp = parcelRequire("lxTgp");

var $blYn7 = parcelRequire("blYn7");

var $et8Rr = parcelRequire("et8Rr");

var $e5EhV = parcelRequire("e5EhV");

var $2usJc = parcelRequire("2usJc");

var $hLLeY = parcelRequire("hLLeY");
const $fc4fdf08ed27ac35$var$MeetingCasePage = ()=>{
    const { meetingCaseId: meetingCaseId } = (0, $COwA0.useParams)();
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, {
            meetingCaseId: meetingCaseId
        }));
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(0);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case",
        "asset",
        "meeting",
        "caseReport"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    // TODO = return only users needed from case and meeting endpoints
    (0, $e5EhV.useBeforeunload)(()=>{
        setConnectionRefresherIndex(connectionRefresherIndex + 1);
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $6j1K3.fetchMeetingCaseAction)(meetingCaseId));
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!meetingCase?.case) return;
        dispatch((0, $2usJc.fetchCaseAction)(meetingCase.case));
        dispatch((0, $7HZDe.fetchCaseAssetsAction)(meetingCase.case));
        dispatch((0, $blYn7.fetchCaseTasksAsync)(meetingCase.case));
    }, [
        meetingCase?.case
    ]);
    const latestRecommendationId = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getLatestRecommendationAssetId)(state, {
            caseId: meetingCase?.case
        }));
    const latestRecommendation = (0, $iD0SF.useSelector)((state)=>(0, $lxTgp.getAssetById)(state, {
            assetId: latestRecommendationId
        }));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $6j1K3.fetchMeetingCaseAction)(meetingCaseId));
    }, [
        latestRecommendation
    ]);
    if (!meetingCase) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("meeting:meetingCaseNotFound")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
        resourceId: meetingCase.id,
        channelName: (0, $bP3DF.MeetingCaseChannelName),
        actionPrefix: (0, $bP3DF.MeetingCaseCablePrefix),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 mr-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hLLeY.CaseContext).Provider, {
                    value: meetingCase.case,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47EkW.default), {
                            meetingId: meetingCase.meeting,
                            meetingCaseId: meetingCase.id,
                            renderLockCase: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRLLc.default), {
                            meetingCaseId: meetingCase.id,
                            meetingId: meetingCase.meeting,
                            caseId: meetingCase.case
                        })
                    ]
                })
            })
        })
    }, connectionRefresherIndex);
};
var $fc4fdf08ed27ac35$export$2e2bcd8739ae039 = $fc4fdf08ed27ac35$var$MeetingCasePage;

});
parcelRegister("47EkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $51041aa75fcd7763$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $cOtzh = parcelRequire("cOtzh");

var $5v6Bi = parcelRequire("5v6Bi");

var $4VtCQ = parcelRequire("4VtCQ");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");
var $18j2c = parcelRequire("18j2c");

var $d5eYa = parcelRequire("d5eYa");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $daNS5 = parcelRequire("daNS5");

var $32kQ2 = parcelRequire("32kQ2");

var $50NSH = parcelRequire("50NSH");

var $g91zf = parcelRequire("g91zf");

var $5wJjW = parcelRequire("5wJjW");

var $7qa36 = parcelRequire("7qa36");

var $74qmW = parcelRequire("74qmW");

var $i4wYI = parcelRequire("i4wYI");

var $iOv3Y = parcelRequire("iOv3Y");
const $51041aa75fcd7763$var$MeetingCaseHeader = (props)=>{
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    const meetingCase = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingCaseById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    if (!props.meetingCaseId || !meeting) return null;
    const meetingDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING, {
        meetingId: meeting.id
    });
    const renderBackToMeetingButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: meetingDetailsUrl,
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("meeting:backToMeeting")
        }, "1");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                        breadcrumbs: [
                            {
                                pageTitle: t("shared:meetings"),
                                href: (0, $6QJY8.RoutePaths).MEETINGS
                            },
                            {
                                pageTitle: meeting.name,
                                href: meetingDetailsUrl
                            },
                            {
                                pageTitle: t("shared:meetingCaseDetail")
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOtzh.default), {
                        hasPermission: meetingCase?.permissions?.canTrackChanges,
                        action: ()=>{
                            dispatch((0, $iOv3Y.fetchAuditEventsAsync)("MeetingCase", props.meetingCaseId));
                            dispatch((0, $i4wYI.toggleIsQuickViewOpen)(props.meetingCaseId, true));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g91zf.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                        hasBorder: false,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                        className: "sm:mr-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                                            className: "fill-current w-6 h-6",
                                            title: meeting.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daNS5.default), {
                                        meetingId: meeting.id,
                                        hasLink: false
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3Rc9I.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "text-center lg:text-right mb-2",
                                        children: meeting.status == (0, $32kQ2.MeetingStatuses).Ended ? t("meeting:meetingEnded") : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                                            startDate: meeting.startDate
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                                        buttons: [
                                            renderBackToMeetingButton()
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                        isDark: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                            width: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                    className: "sm:mr-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                                        className: "fill-current w-6 h-6",
                                        title: t("shared:case")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50NSH.default), {
                                    meetingCaseId: props.meetingCaseId,
                                    renderLockCase: props.renderLockCase,
                                    hasCaseLink: true
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74qmW.default), {
                    meetingCaseId: props.meetingCaseId,
                    meeting: meeting
                })
            })
        ]
    });
};
var $51041aa75fcd7763$export$2e2bcd8739ae039 = $51041aa75fcd7763$var$MeetingCaseHeader;

});
parcelRegister("74qmW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cae9e0bd97584ef$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $6t04b = parcelRequire("6t04b");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jitSV");
var $h5KXb = parcelRequire("h5KXb");
var $18j2c = parcelRequire("18j2c");

var $7nrxt = parcelRequire("7nrxt");

var $3QK3n = parcelRequire("3QK3n");

var $5wJjW = parcelRequire("5wJjW");

var $32kQ2 = parcelRequire("32kQ2");

var $hMBTE = parcelRequire("hMBTE");
const $7cae9e0bd97584ef$var$MeetingCaseChangeTracking = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "meeting"
    ]);
    const meetingCoordinator = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.meeting.coordinatorId));
    const renderMeetingTimeToStart = ()=>{
        if (props.meeting.status !== (0, $32kQ2.MeetingStatuses).Scheduled) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
            className: "mb-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wJjW.default), {
                startDate: props.meeting.startDate
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col mb-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18j2c.default), {
                            className: "fill-current w-6 h-6",
                            title: props.meeting.name
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: props.meeting.name
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3QK3n.default), {
                                    startDate: props.meeting.startDate,
                                    endDate: props.meeting.endDate
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-1",
                                children: [
                                    t("meeting:Coordinator"),
                                    ": ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                        firstName: meetingCoordinator.firstName,
                                        lastName: meetingCoordinator.lastName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7nrxt.default), {
                                    meeting: props.meeting
                                })
                            }),
                            renderMeetingTimeToStart()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h5KXb.default), {
                        className: "fill-current w-6 h-6 md:ml-2",
                        title: t("shared:changeTracking")
                    }),
                    " ",
                    t("shared:changeTracking")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMBTE.AuditEventList), {
                entityId: props.meetingCaseId
            })
        ]
    });
};
var $7cae9e0bd97584ef$export$2e2bcd8739ae039 = $7cae9e0bd97584ef$var$MeetingCaseChangeTracking;

});


parcelRegister("gRLLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6c4107889ff716$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4qaeN = parcelRequire("4qaeN");

var $ZQZCX = parcelRequire("ZQZCX");

var $jWomF = parcelRequire("jWomF");

var $4VtCQ = parcelRequire("4VtCQ");

var $32kQ2 = parcelRequire("32kQ2");

var $9juwB = parcelRequire("9juwB");

var $4jQEM = parcelRequire("4jQEM");

var $6QJY8 = parcelRequire("6QJY8");

var $COwA0 = parcelRequire("COwA0");
const $ba6c4107889ff716$var$MeetingCaseActivity = (props)=>{
    const mentionableUsers = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingUsers)(state, props));
    const meeting = (0, $iD0SF.useSelector)((state)=>(0, $4VtCQ.getMeetingById)(state, props));
    if (!meeting) return null;
    const renderMeetingControls = ()=>{
        const meetingStatus = meeting.status;
        if (meetingStatus == (0, $32kQ2.MeetingStatuses).Scheduled || meetingStatus == (0, $32kQ2.MeetingStatuses).InProgress) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ZQZCX.default), {
                        caseId: props.caseId,
                        meetingId: props.meetingId,
                        mentionableUsers: mentionableUsers
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jQEM.default), {
                        caseId: props.caseId,
                        meetingId: props.meetingId,
                        mentionableUsers: mentionableUsers
                    })
                })
            ]
        });
        const messageKey = meetingStatus == (0, $32kQ2.MeetingStatuses).Ended ? "asset:meetingHasEnded" : "asset:meetingWasCancelled";
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9juwB.AddCaseAssetPanelDisabled), {
                messageKey: messageKey
            })
        });
    };
    const generateTabPath = (currentTab)=>{
        return (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).MEETING_CASE, {
            meetingCaseId: props.meetingCaseId,
            currentTab: currentTab
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lg:grid grid-cols-2 gap-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: renderMeetingControls()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jWomF.default), {
                        caseId: props.caseId,
                        meetingId: props.meetingId,
                        meetingCaseId: props.meetingCaseId,
                        showMeetingsTab: false,
                        showMeetingAssetsTab: true,
                        mentionableUsers: mentionableUsers,
                        generateTabPath: generateTabPath
                    })
                })
            })
        ]
    });
};
var $ba6c4107889ff716$export$2e2bcd8739ae039 = $ba6c4107889ff716$var$MeetingCaseActivity;

});
parcelRegister("9juwB", function(module, exports) {

$parcel$export(module.exports, "AddCaseAssetPanelDisabled", () => $ffa3b769745554c4$export$603a73254922a958);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $2jvQG = parcelRequire("2jvQG");
const $ffa3b769745554c4$export$603a73254922a958 = ({ messageKey: messageKey })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "asset"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-center text-ch-blue-alt-400",
                children: t(messageKey)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
        ]
    });
};

});



parcelRegister("7Rg00", function(module, exports) {

$parcel$export(module.exports, "default", () => $49eee0f0d5afa4e3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $cRf9W = parcelRequire("cRf9W");

var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $54A9z = parcelRequire("54A9z");

var $jF0Xa = parcelRequire("jF0Xa");

var $kQILj = parcelRequire("kQILj");

var $aDFyu = parcelRequire("aDFyu");

var $39EfS = parcelRequire("39EfS");

var $8UrgM = parcelRequire("8UrgM");

var $lCZwG = parcelRequire("lCZwG");

var $6EmQ3 = parcelRequire("6EmQ3");

var $glc4D = parcelRequire("glc4D");
const $49eee0f0d5afa4e3$var$NotificationsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "notification"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getNotificationsUI)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: [
            "unread"
        ],
        resultsPerPage: UI.resultsPerPage
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $cRf9W.fetchNotificationsAsync));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:notifications")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6EmQ3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col items-center sm:flex-row sm:justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "text-lg text-center md:text-left",
                        children: [
                            UI.unreadCount,
                            " ",
                            t("notification:unreadNotifications")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>{
                                dispatch((0, $cRf9W.markAllNotififcationsAsRead)());
                            },
                            variant: (0, $jF0Xa.StyleVariants).ORANGE,
                            isDisabled: !UI.unreadCount,
                            children: t("notification:markAllAsRead")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54A9z.default), {
                refreshNotifications: ()=>dispatch((0, $cRf9W.fetchNotificationsAsync)(searchQuery))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalNotificationsCount,
                totalPages: UI.totalPages
            })
        ]
    });
};
var $49eee0f0d5afa4e3$export$2e2bcd8739ae039 = $49eee0f0d5afa4e3$var$NotificationsPage;

});
parcelRegister("cRf9W", function(module, exports) {

$parcel$export(module.exports, "fetchNotificationsAsync", () => $7f6164050fcf65ad$export$956a65647fc5b562);
$parcel$export(module.exports, "markAllNotififcationsAsRead", () => $7f6164050fcf65ad$export$5735bfd5799c8d35);
$parcel$export(module.exports, "markNotificationAsRead", () => $7f6164050fcf65ad$export$1d692c8ce2a8b02f);
$parcel$export(module.exports, "markNotificationAsUnread", () => $7f6164050fcf65ad$export$6fd4f5322a814334);

var $9VqZS = parcelRequire("9VqZS");
const $7f6164050fcf65ad$export$956a65647fc5b562 = (searchQuery)=>{
    return {
        type: (0, $9VqZS.NotificationsActionTypes).FETCH_NOTIFICATIONS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $7f6164050fcf65ad$export$5735bfd5799c8d35 = ()=>{
    return {
        type: (0, $9VqZS.NotificationsCableActionTypes).MARK_ALL_AS_READ,
        meta: {
            isOptimistic: true
        }
    };
};
const $7f6164050fcf65ad$export$1d692c8ce2a8b02f = (notificationId)=>{
    return {
        type: (0, $9VqZS.NotificationsCableActionTypes).MARK_AS_READ,
        payload: {
            notificationId: notificationId
        },
        meta: {
            isOptimistic: false
        }
    };
};
const $7f6164050fcf65ad$export$6fd4f5322a814334 = (notificationId)=>{
    return {
        type: (0, $9VqZS.NotificationsCableActionTypes).MARK_AS_UNREAD,
        payload: {
            notificationId: notificationId
        },
        meta: {
            isOptimistic: false
        }
    };
};

});

parcelRegister("54A9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $475e3895ddbd2dec$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $eQBQ5 = parcelRequire("eQBQ5");

var $loAPs = parcelRequire("loAPs");
const $475e3895ddbd2dec$var$NotificationList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "notification"
    ]);
    const notificationIds = (0, $iD0SF.useSelector)((0, $loAPs.getAllNotificationIds));
    if (!notificationIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("notification:noNotifications")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: notificationIds.map((notificationId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eQBQ5.default), {
                notificationId: notificationId,
                refreshNotifications: props.refreshNotifications
            }, notificationId);
        })
    });
};
var $475e3895ddbd2dec$export$2e2bcd8739ae039 = $475e3895ddbd2dec$var$NotificationList;

});
parcelRegister("eQBQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88b5025e83eac86$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $bbiXR = parcelRequire("bbiXR");

var $hl5jX = parcelRequire("hl5jX");

var $5v6Bi = parcelRequire("5v6Bi");

var $loAPs = parcelRequire("loAPs");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $cRf9W = parcelRequire("cRf9W");

var $1l1FS = parcelRequire("1l1FS");
const $c88b5025e83eac86$var$NotificationListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "notification"
    ]);
    const notification = (0, $iD0SF.useSelector)((state)=>(0, $loAPs.getNotificationById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const markAsRead = (notificationId)=>dispatch((0, $cRf9W.markNotificationAsRead)(notificationId));
    const markAsUnread = (notificationId)=>dispatch((0, $cRf9W.markNotificationAsUnread)(notificationId));
    const parent = (0, $acw62.useRef)(null);
    if (!notification) return null;
    const onView = ()=>{
        markAsRead(props.notificationId);
        (0, $1l1FS.default).push(notification.url);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        ref: parent,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            isDark: !!notification.readAt,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbiXR.default), {
                                className: "fill-current w-6 h-6",
                                title: t("shared:notification")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hl5jX.default), {
                            notificationId: notification.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            notification.readAt ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>{
                                    markAsUnread(props.notificationId);
                                    setTimeout(()=>{
                                        props.refreshNotifications();
                                    }, 100);
                                },
                                variant: (0, $jF0Xa.StyleVariants).GRAY,
                                children: t("notification:markUnread")
                            }, "1") : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>{
                                    markAsRead(props.notificationId);
                                    setTimeout(()=>{
                                        props.refreshNotifications();
                                    }, 100);
                                },
                                variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                children: t("notification:markRead")
                            }, "1"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>{
                                    onView();
                                },
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                children: t("shared:viewDetails")
                            }, "1")
                        ]
                    })
                })
            ]
        })
    });
};
var $c88b5025e83eac86$export$2e2bcd8739ae039 = $c88b5025e83eac86$var$NotificationListItem;

});
parcelRegister("hl5jX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aaf235613c5c1f0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $3Ukkm = parcelRequire("3Ukkm");

var $1DXYh = parcelRequire("1DXYh");

var $loAPs = parcelRequire("loAPs");

var $biuvr = parcelRequire("biuvr");

var $7hl6H = parcelRequire("7hl6H");
const $6aaf235613c5c1f0$var$NotificationDetails = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "notification"
    ]);
    const notification = (0, $iD0SF.useSelector)((state)=>(0, $loAPs.getNotificationById)(state, props));
    const notificationUsers = (0, $iD0SF.useSelector)((state)=>(0, $loAPs.getNotificationUsers)(state, props));
    const senderUser = (0, $iD0SF.useSelector)((state)=>(0, $loAPs.getNotificationSenderUser)(state, props));
    if (!notification) return null;
    const renderHeading = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(notification.type);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
            className: "font-semibold mb-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                href: notification.url,
                children: t(`notification:${translationKey}`, {
                    sender: senderUser
                })
            })
        });
    };
    const renderLabel = ()=>{
        if (!notification.label) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
            className: "font-semibold mb-1",
            children: notification.label
        });
    };
    const renderPreviewTitle = ()=>{
        if (!notification.title) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "whitespace-nowrap font-semibold mr-1",
            children: `${notification.title}:`
        });
    };
    const renderPreviewBody = ()=>{
        if (!notification.body) return null;
        const body = `${notification.body}`.replace(/\n/g, " ");
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "min-w-0 w-0 flex-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biuvr.default), {
                value: body,
                users: notificationUsers,
                isSingleLine: true
            })
        });
    };
    const renderPreview = ()=>{
        if (!notification.title && !notification.body) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-wrap mb-1",
            children: [
                renderPreviewTitle(),
                renderPreviewBody()
            ]
        });
    };
    const renderTimestamp = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
            className: "text-ch-gray-500",
            utcTime: notification.createdAt
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1",
        children: [
            renderHeading(),
            renderLabel(),
            renderPreview(),
            renderTimestamp()
        ]
    });
};
var $6aaf235613c5c1f0$export$2e2bcd8739ae039 = $6aaf235613c5c1f0$var$NotificationDetails;

});
parcelRegister("loAPs", function(module, exports) {

$parcel$export(module.exports, "getAllNotificationIds", () => $7afb684e5b95092b$export$cf7142cb14b5459c);
$parcel$export(module.exports, "getNotificationById", () => $7afb684e5b95092b$export$398a1f53d563b138);
$parcel$export(module.exports, "getNotificationUsers", () => $7afb684e5b95092b$export$7bd76ab93ec108d7);
$parcel$export(module.exports, "getNotificationSenderUser", () => $7afb684e5b95092b$export$f00636fca9917936);

var $6SpLG = parcelRequire("6SpLG");

var $f1q41 = parcelRequire("f1q41");

var $6lvMC = parcelRequire("6lvMC");
const $7afb684e5b95092b$export$cf7142cb14b5459c = (state)=>state.entities.notifications.allIds;
const $7afb684e5b95092b$export$398a1f53d563b138 = (state, ownProps)=>{
    const notificationId = ownProps.notificationId;
    return state.entities.notifications.byId[notificationId];
};
const $7afb684e5b95092b$export$7bd76ab93ec108d7 = (0, $6SpLG.createSelector)($7afb684e5b95092b$export$398a1f53d563b138, (0, $6lvMC.getAllUsers), (notification, allUsers)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pickBy(allUsers, (user)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(notification.users, user.id);
    });
});
const $7afb684e5b95092b$export$f00636fca9917936 = (0, $6SpLG.createSelector)($7afb684e5b95092b$export$398a1f53d563b138, (0, $6lvMC.getAllUsers), (notification, allUsers)=>{
    return allUsers[notification.senderId];
});

});




parcelRegister("6EmQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bb5ab5d8c0c033c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $2bb5ab5d8c0c033c$var$NotificationsFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "notification"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("shared:all")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("unread"),
                    action: ()=>{
                        updateFilters("unread");
                    },
                    children: t("notification:unread")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("read"),
                    action: ()=>{
                        updateFilters("read");
                    },
                    children: t("notification:read")
                })
            })
        ]
    });
};
var $2bb5ab5d8c0c033c$export$2e2bcd8739ae039 = $2bb5ab5d8c0c033c$var$NotificationsFilter;

});


parcelRegister("bZlxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffc067bc50f4dbcc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $5YAlZ = parcelRequire("5YAlZ");

var $kUgJk = parcelRequire("kUgJk");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $6lvMC = parcelRequire("6lvMC");

var $8UrgM = parcelRequire("8UrgM");

var $6QJY8 = parcelRequire("6QJY8");

var $1l1FS = parcelRequire("1l1FS");
const $ffc067bc50f4dbcc$var$TermsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const terms = (0, $iD0SF.useSelector)((0, $6lvMC.getTerms));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchTerms = ()=>dispatch((0, $5YAlZ.fetchTermsAction)());
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const acceptTerms = (version)=>dispatch((0, $5YAlZ.acceptTermsAction)({
            version: version
        }));
    (0, $acw62.useEffect)(()=>{
        fetchTerms(), fetchUsers();
    }, []);
    const onClickSignOut = ()=>{
        dispatch((0, $5YAlZ.signOutUserAction)());
        (0, $1l1FS.default).push((0, $6QJY8.RoutePaths).SIGN_IN);
    };
    if (!terms || !currentUser) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "text-center text-ch-blue-alt-400",
                        children: t("shared:acceptTheTermsAndConditions")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "text-center text-ch-blue-alt-400 pb-2",
                        children: currentUser.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 overflow-hidden mb-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kUgJk.default), {
                    terms: terms
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: ()=>acceptTerms(terms.version),
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            isChunky: true,
                            children: t("shared:acceptTerms")
                        }, "1")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pl-1 pr-1",
                                children: t("shared:or")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "text-ch-blue-500 hover:text-ch-blue-600 cursor-pointer -mr-2",
                                onClick: ()=>onClickSignOut(),
                                children: t("shared:signout")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ffc067bc50f4dbcc$export$2e2bcd8739ae039 = $ffc067bc50f4dbcc$var$TermsPage;

});
parcelRegister("kUgJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $79af3ac2dd0dede7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $aEgqS = parcelRequire("aEgqS");

var $3Npjv = parcelRequire("3Npjv");

var $jUk5c = parcelRequire("jUk5c");
const $79af3ac2dd0dede7$var$TermsPdfViewer = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const pdf = props.terms;
    const [blobUrl, setBlobUrl] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        (0, $jUk5c.default)(pdf.path, setBlobUrl);
    }, [
        pdf.path
    ]);
    if (!blobUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Npjv.default), {
        url: blobUrl,
        filename: `${t("shared:termsOfUse")} v${pdf.version}.pdf`
    });
};
var $79af3ac2dd0dede7$export$2e2bcd8739ae039 = $79af3ac2dd0dede7$var$TermsPdfViewer;

});


parcelRegister("1izku", function(module, exports) {

$parcel$export(module.exports, "default", () => $43803f4e47bf3e31$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $5YAlZ = parcelRequire("5YAlZ");

var $02Ftg = parcelRequire("02Ftg");

var $kLrSB = parcelRequire("kLrSB");

var $aeos3 = parcelRequire("aeos3");

var $5v6Bi = parcelRequire("5v6Bi");

var $irINt = parcelRequire("irINt");

var $1Cmbh = parcelRequire("1Cmbh");

var $1DXYh = parcelRequire("1DXYh");

var $7hl6H = parcelRequire("7hl6H");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");
const $43803f4e47bf3e31$var$AdminPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "admin"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchTerms = ()=>dispatch((0, $5YAlZ.fetchTermsAction)());
    const terms = (0, $iD0SF.useSelector)((0, $6lvMC.getTerms));
    const { tenantLogoPath: tenantLogoPath, tenantName: tenantName } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    (0, $acw62.useEffect)(()=>{
        fetchTerms();
    }, []);
    const renderTermDetails = ()=>{
        if (!terms) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg text-center",
            children: t("shared:noTermsAdmin")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex-1 lg:grid grid-cols-2 gap-3",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DXYh.default), {
                            href: (0, $6QJY8.RoutePaths).TERMS,
                            children: [
                                t("shared:versionWithNumber", {
                                    version: terms.version
                                }),
                                " - ",
                                terms.filename
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("shared:uploaded"),
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: terms.createdAt
                            })
                        ]
                    })
                ]
            })
        });
    };
    const renderTermsOfUseSection = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "mb-2 text-lg",
                    children: t("shared:termsOfUse")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                        className: "mr-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                                            className: "fill-current w-6 h-6",
                                            title: t("shared:termsOfUse")
                                        })
                                    }),
                                    renderTermDetails()
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kLrSB.default), {})
                        ]
                    })
                })
            ]
        });
    };
    const renderTenantLogoPreview = ()=>{
        if (!tenantLogoPath) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-32 h-32 p-1 flex items-center justify-center mb-2 overflow-hidden border border-ch-gray-400",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irINt.default), {
                path: tenantLogoPath,
                title: tenantName
            })
        });
    };
    const renderTenantLogoSection = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "mb-2 text-lg",
                    children: t("admin:tenantLogo")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            renderTenantLogoPreview(),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02Ftg.default), {})
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            renderTenantLogoSection(),
            renderTermsOfUseSection()
        ]
    });
};
var $43803f4e47bf3e31$export$2e2bcd8739ae039 = $43803f4e47bf3e31$var$AdminPage;

});
parcelRegister("02Ftg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96da07c4f2e807d2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $9RJx3 = parcelRequire("9RJx3");
const $96da07c4f2e807d2$var$acceptedFileTypes = [
    "image/jpeg",
    "image/png"
];
const $96da07c4f2e807d2$var$maxFileSizeMB = 2;
const $96da07c4f2e807d2$var$maxFileSize = $96da07c4f2e807d2$var$maxFileSizeMB * 1048576;
const $96da07c4f2e807d2$var$TenantLogoUploadForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "asset",
        "admin"
    ]);
    const handleSubmit = (values, { setSubmitting: setSubmitting })=>{
        props.uploadFile(values);
        setSubmitting(false);
    };
    const validate = (values)=>{
        const errors = {};
        const fileType = values.file.type;
        if (values.file.size > $96da07c4f2e807d2$var$maxFileSize) errors.file = t("shared:fileTooLarge", {
            maxFileSize: $96da07c4f2e807d2$var$maxFileSizeMB
        });
        else if (!$96da07c4f2e807d2$var$acceptedFileTypes.includes(fileType)) errors.file = t("shared:fileTypeWrong", {
            acceptedFileTypes: $96da07c4f2e807d2$var$acceptedFileTypes
        });
        return errors;
    };
    const initialValues = {
        file: null
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            onSubmit: handleSubmit,
            validateOnChange: true,
            validate: validate,
            children: ({ errors: errors, setFieldValue: setFieldValue, isSubmitting: isSubmitting, values: values, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                name: "file",
                                className: "mt-3",
                                children: [
                                    t("admin:updateLogo"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: "cursor-pointer",
                                id: "file",
                                name: "file",
                                type: "file",
                                accept: $96da07c4f2e807d2$var$acceptedFileTypes.join(", "),
                                onChange: (event)=>{
                                    setFieldValue("file", event.currentTarget.files[0]);
                                }
                            }),
                            errors.file ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-ch-red-500 text-sm mb-1",
                                children: errors.file
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                className: "mt-2 mb-4",
                                isDisabled: values.file == null || !isValid || isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("asset:uploadFile")
                            }, "2")
                        ]
                    })
                })
        })
    });
};
const $96da07c4f2e807d2$var$mapDispatchToProps = (dispatch)=>{
    return {
        uploadFile: (values)=>dispatch((0, $9RJx3.uploadTenantLogoAsync)(values))
    };
};
var $96da07c4f2e807d2$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $96da07c4f2e807d2$var$mapDispatchToProps)($96da07c4f2e807d2$var$TenantLogoUploadForm);

});
parcelRegister("9RJx3", function(module, exports) {

$parcel$export(module.exports, "uploadTermsFileAsync", () => $a8764777c767afe0$export$b5cb80e9e8621d47);
$parcel$export(module.exports, "uploadTenantLogoAsync", () => $a8764777c767afe0$export$d98ccc7e0b461a18);

var $dz6fA = parcelRequire("dz6fA");
const $a8764777c767afe0$export$b5cb80e9e8621d47 = (values)=>{
    return {
        type: (0, $dz6fA.AdminActionTypes).UPLOAD_TERMS_FILE_ASYNC_PENDING,
        payload: {
            values: values
        }
    };
};
const $a8764777c767afe0$export$d98ccc7e0b461a18 = (values)=>{
    return {
        type: (0, $dz6fA.AdminActionTypes).UPLOAD_TENANT_LOGO_ASYNC_PENDING,
        payload: {
            values: values
        }
    };
};

});


parcelRegister("kLrSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcb0ae1408ca258$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iStRg = parcelRequire("iStRg");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $9RJx3 = parcelRequire("9RJx3");
const $3fcb0ae1408ca258$var$acceptedFileTypes = [
    "application/pdf"
];
const $3fcb0ae1408ca258$var$maxFileSizeMB = 15;
const $3fcb0ae1408ca258$var$maxFileSize = $3fcb0ae1408ca258$var$maxFileSizeMB * 1048576;
const $3fcb0ae1408ca258$var$TermsFileNewForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "asset"
    ]);
    const handleSubmit = (values, { setSubmitting: setSubmitting })=>{
        props.uploadFile(values);
        setSubmitting(false);
    };
    const validate = (values)=>{
        const errors = {};
        const fileType = values.file.type;
        if (values.file.size > $3fcb0ae1408ca258$var$maxFileSize) errors.file = t("shared:fileTooLarge", {
            maxFileSize: $3fcb0ae1408ca258$var$maxFileSizeMB
        });
        else if (!$3fcb0ae1408ca258$var$acceptedFileTypes.includes(fileType)) errors.file = t("shared:fileTypeWrong", {
            acceptedFileTypes: $3fcb0ae1408ca258$var$acceptedFileTypes
        });
        return errors;
    };
    const initialValues = {
        file: null
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            onSubmit: handleSubmit,
            validateOnChange: true,
            validate: validate,
            children: ({ errors: errors, setFieldValue: setFieldValue, isSubmitting: isSubmitting, values: values, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                name: "file",
                                className: "mt-3",
                                children: [
                                    t("admin:uploadNewTerms"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: "cursor-pointer",
                                id: "file",
                                name: "file",
                                type: "file",
                                accept: $3fcb0ae1408ca258$var$acceptedFileTypes.join(", "),
                                onChange: (event)=>{
                                    setFieldValue("file", event.currentTarget.files[0]);
                                }
                            }),
                            errors.file ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-ch-red-500 text-sm mb-1",
                                children: errors.file
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                className: "mt-2 mb-4",
                                isDisabled: values.file == null || !isValid || isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("asset:uploadFile")
                            }, "2")
                        ]
                    })
                })
        })
    });
};
const $3fcb0ae1408ca258$var$mapDispatchToProps = (dispatch)=>{
    return {
        uploadFile: (values)=>dispatch((0, $9RJx3.uploadTermsFileAsync)(values))
    };
};
var $3fcb0ae1408ca258$export$2e2bcd8739ae039 = (0, $iStRg.default)(null, $3fcb0ae1408ca258$var$mapDispatchToProps)($3fcb0ae1408ca258$var$TermsFileNewForm);

});


parcelRegister("fP19p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ada7bfb7ebec90ea$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("cIYPX");
var $frTKF = parcelRequire("frTKF");
const $ada7bfb7ebec90ea$var$TermsLayout = ({ children: children })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const defaultClasses = "flex bg-ch-blue-alt-200 h-screen justify-center p-3 md:p-12";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: defaultClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg-white shadow-md rounded-md border border-ch-blue-alt-300 p-8 w-full sm:w-4/5 h-full justify-between relative flex flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center p-1 justify-center mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $frTKF.default), {
                            className: "w-64",
                            title: t("shared:contextMeeting")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-ch-blue-600 hidden",
                            children: t("shared:contextMeeting")
                        })
                    ]
                }),
                children
            ]
        })
    });
};
var $ada7bfb7ebec90ea$export$2e2bcd8739ae039 = $ada7bfb7ebec90ea$var$TermsLayout;

});

parcelRegister("lxRZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b103b09148f90aa9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $6QJY8 = parcelRequire("6QJY8");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");
const $b103b09148f90aa9$var$SetupTotpCompletePage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const renderLinkToSetupSMS = ()=>{
        if (currentUser?.mfaMethods.includes("sms")) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-5",
            children: [
                "Click ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    className: "text-ch-blue-500 hover:text-ch-blue-600",
                    href: (0, $6QJY8.RoutePaths).SETUP_MFA_INTRO,
                    children: "here"
                }),
                " if you wish to set up SMS based 2FA as well."
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-3",
                children: t("mfaSetupCompleteHeader")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5",
                children: t("mfaSetupTotpCompleteMessage")
            }),
            renderLinkToSetupSMS(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                href: (0, $6QJY8.RoutePaths).ROOT,
                children: t("mfaContinueToApp")
            })
        ]
    });
};
var $b103b09148f90aa9$export$2e2bcd8739ae039 = $b103b09148f90aa9$var$SetupTotpCompletePage;

});

parcelRegister("l1h9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a990a32c0bbf3d1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $6QJY8 = parcelRequire("6QJY8");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");
const $9a990a32c0bbf3d1$var$SetupSmsCompletePage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "account",
        "shared"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const renderLinkToSetupTotp = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mb-5",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $jfXvU.Trans), {
            i18nKey: "mfaSetupTotpAsWell",
            t: t,
            children: [
                "Click ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    className: "text-ch-blue-500 hover:text-ch-blue-600",
                    href: (0, $6QJY8.RoutePaths).SETUP_MFA_INTRO,
                    children: "here"
                }),
                " if you wish to set up TOTP based 2FA as well."
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-ch-blue-500 text-xl mb-3",
                children: t("mfaSetupCompleteHeader")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5",
                children: t("mfaSetupSmsCompleteMessage")
            }),
            currentUser?.mfaMethods.includes("totpq") ? null : renderLinkToSetupTotp,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                href: (0, $6QJY8.RoutePaths).ROOT,
                children: t("mfaContinueToApp")
            })
        ]
    });
};
var $9a990a32c0bbf3d1$export$2e2bcd8739ae039 = $9a990a32c0bbf3d1$var$SetupSmsCompletePage;

});

parcelRegister("l57QH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0cc5fe55a577eb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $aDFyu = parcelRequire("aDFyu");

var $39EfS = parcelRequire("39EfS");

var $dbP5t = parcelRequire("dbP5t");

var $kQILj = parcelRequire("kQILj");

var $blYn7 = parcelRequire("blYn7");

var $8A4CS = parcelRequire("8A4CS");

var $kVlM3 = parcelRequire("kVlM3");

var $7Thi2 = parcelRequire("7Thi2");

var $8UrgM = parcelRequire("8UrgM");

var $glc4D = parcelRequire("glc4D");
const $fe0cc5fe55a577eb$var$TasksPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getTasksUI)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $blYn7.fetchTasksAsync));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:tasks")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-end mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex flex-col items-center sm:flex-row sm:justify-between mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg text-center md:text-left",
                    children: [
                        t("task:tasksOutstanding"),
                        ": ",
                        UI.outstandingCount
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Thi2.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            orderByOptions: (0, $dbP5t.TasksOrderByOptions),
                            useTranslation: "task:orderBy"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8A4CS.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalTasksCount,
                totalPages: UI.totalPages
            })
        ]
    });
};
var $fe0cc5fe55a577eb$export$2e2bcd8739ae039 = $fe0cc5fe55a577eb$var$TasksPage;

});
parcelRegister("8A4CS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0baab5aee296c5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $5K0WH = parcelRequire("5K0WH");

var $9mz9n = parcelRequire("9mz9n");
const $7b0baab5aee296c5$var$TaskList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task"
    ]);
    const taskIds = (0, $iD0SF.useSelector)((0, $9mz9n.getAllTaskIds));
    if (!taskIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("task:noTasks")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: taskIds.map((taskId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5K0WH.default), {
                taskId: taskId
            }, taskId);
        })
    });
};
var $7b0baab5aee296c5$export$2e2bcd8739ae039 = $7b0baab5aee296c5$var$TaskList;

});
parcelRegister("5K0WH", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a209eee4c07067$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");
var $dIfKX = parcelRequire("dIfKX");

var $5v6Bi = parcelRequire("5v6Bi");

var $9mz9n = parcelRequire("9mz9n");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $gpoNB = parcelRequire("gpoNB");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $jWomF = parcelRequire("jWomF");
const $16a209eee4c07067$var$TaskListItem = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    if (!task) return null;
    const Icon = task.casePathwayId ? (0, $k6suX.default) : (0, $dIfKX.default);
    const caseDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
        caseId: task.caseId,
        currentTab: (0, $jWomF.CaseAssetTabNames).TASKS
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            isDark: task.isComplete,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                className: "fill-current w-6 h-6",
                                title: t("shared:task")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpoNB.default), {
                            taskId: task.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                href: caseDetailsUrl,
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                children: t("shared:viewDetails")
                            }, "1")
                        ]
                    })
                })
            ]
        })
    });
};
var $16a209eee4c07067$export$2e2bcd8739ae039 = $16a209eee4c07067$var$TaskListItem;

});
parcelRegister("gpoNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $817f0dba29c20554$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $k5WIK = parcelRequire("k5WIK");

var $lV7Qw = parcelRequire("lV7Qw");

var $7hl6H = parcelRequire("7hl6H");

var $9mz9n = parcelRequire("9mz9n");
parcelRequire("jitSV");
var $ij7yF = parcelRequire("ij7yF");

var $ljbUa = parcelRequire("ljbUa");

var $g9gc3 = parcelRequire("g9gc3");
const $817f0dba29c20554$var$TaskDetails = (props)=>{
    const task = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getTaskById)(state, props));
    const latestTaskResponse = (0, $iD0SF.useSelector)((state)=>(0, $9mz9n.getLatestTaskResponse)(state, props));
    if (!task) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "task"
    ]);
    const renderTaskAction = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    className: "font-semibold",
                    children: [
                        t("task:taskAction"),
                        ":"
                    ]
                }),
                " ",
                task.action
            ]
        });
    };
    const renderAssignedTo = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    className: "font-semibold",
                    children: [
                        t("task:assignedTo"),
                        ":"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $g9gc3.default), {
                    taskId: props.taskId
                })
            ]
        });
    };
    const renderTaskCreated = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            className: "text-ch-gray-500",
            children: [
                t("task:taskCreated"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: task.createdAt
                })
            ]
        });
    };
    const renderDueDate = ()=>{
        if (task.isComplete) return null;
        const dueDate = task.dueDate ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: task.dueDate
                }),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lV7Qw.default), {
                    utcTime: task.dueDate
                }),
                " "
            ]
        }) : t("task:dueDateNotSet");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    className: "font-semibold",
                    children: [
                        t("task:dueDate"),
                        ":"
                    ]
                }),
                " ",
                dueDate
            ]
        });
    };
    const renderResponseAuthor = ()=>{
        if (!latestTaskResponse) return null;
        const renderLabel = ()=>{
            if (task.isComplete) return t("task:completedBy");
            return t("task:responseBy");
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    className: "font-semibold",
                    children: [
                        renderLabel(),
                        ":"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k5WIK.default), {
                    firstName: latestTaskResponse.createdBy.firstName,
                    lastName: latestTaskResponse.createdBy.lastName,
                    createdAt: latestTaskResponse.createdAt
                })
            ]
        });
    };
    const renderLatestResponse = ()=>{
        if (!latestTaskResponse) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            className: "truncate",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    className: "font-semibold",
                    children: [
                        t("task:latestResponse"),
                        ":"
                    ]
                }),
                " ",
                latestTaskResponse.response
            ]
        });
    };
    const renderCompleteIcon = ()=>{
        if (!task.isComplete) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-green-500 mt-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ij7yF.default), {
                    className: "fill-current w-6 h-6"
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ljbUa.default), {
                            case: task.case
                        })
                    }),
                    renderTaskAction(),
                    renderAssignedTo(),
                    renderTaskCreated()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderDueDate(),
                    renderLatestResponse(),
                    renderResponseAuthor(),
                    renderCompleteIcon()
                ]
            })
        ]
    });
};
var $817f0dba29c20554$export$2e2bcd8739ae039 = $817f0dba29c20554$var$TaskDetails;

});



parcelRegister("7Thi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed3e810ea3ef6de$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $fed3e810ea3ef6de$var$TaskFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "task"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("task:filter:all")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("outstanding"),
                    action: ()=>{
                        updateFilters("outstanding");
                    },
                    children: t("task:filter:outstanding")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("completed"),
                    action: ()=>{
                        updateFilters("completed");
                    },
                    children: t("task:filter:completed")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("assigned_to_you"),
                    action: ()=>{
                        updateFilters("assigned_to_you");
                    },
                    children: t("task:filter:assignedToYou")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("created_by_you"),
                    action: ()=>{
                        updateFilters("created_by_you");
                    },
                    children: t("task:filter:createdByYou")
                })
            })
        ]
    });
};
var $fed3e810ea3ef6de$export$2e2bcd8739ae039 = $fed3e810ea3ef6de$var$TaskFilter;

});


parcelRegister("cmDWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff22b69a0a35c98f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $aDFyu = parcelRequire("aDFyu");

var $39EfS = parcelRequire("39EfS");

var $55aym = parcelRequire("55aym");

var $kQILj = parcelRequire("kQILj");

var $kceJh = parcelRequire("kceJh");

var $6it4u = parcelRequire("6it4u");

var $kVlM3 = parcelRequire("kVlM3");

var $1kXfn = parcelRequire("1kXfn");

var $aeos3 = parcelRequire("aeos3");

var $6QJY8 = parcelRequire("6QJY8");

var $6lvMC = parcelRequire("6lvMC");

var $glc4D = parcelRequire("glc4D");

var $hQqbN = parcelRequire("hQqbN");
const $ff22b69a0a35c98f$var$PatientsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const [uploadModalIsOpen, setUploadModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getPatientsUI)(state));
    const initialSearchQuery = {
        page: 1,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $kceJh.fetchPatientsAsync));
    const openUploadModal = ()=>{
        setUploadModalIsOpen(true);
    };
    const closeUploadModal = ()=>{
        setUploadModalIsOpen(false);
    };
    const secondaryButton = ()=>{
        if (!currentUser.abilities?.patient.canUpload) return null;
        return (0, $aDFyu.TitleButtonFactory)(openUploadModal, t("patient:index:buttons:bulkUpload"), "2");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:patients"),
                buttonText: t("patient:index:buttons:addNewPatient"),
                buttonHref: (0, $6QJY8.RoutePaths).PATIENT_NEW,
                hasButtonPermission: currentUser.abilities?.patient.canCreate,
                secondaryButton: secondaryButton()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-start-2 md:row-start-1 self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "patient:index:searchBy",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            },
                            values: {
                                careProviderIdLabel: careProviderIdLabel
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-end-2 md:row-start-1 flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                buttonText: t("patient:index:buttons:searchPatients")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-2 text-center md:text-left",
                children: [
                    UI.totalPatientsCount,
                    " ",
                    t("shared:patients")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                        searchQuery: searchQuery,
                        setSearchQuery: setSearchQuery,
                        orderByOptions: (0, $55aym.PatientsOrderByOptions),
                        useTranslation: "patient:index:orderBy"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6it4u.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalPatientsCount,
                totalPages: UI.totalPages
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hQqbN.default), {
                closeModal: closeUploadModal,
                isOpen: uploadModalIsOpen
            })
        ]
    });
};
var $ff22b69a0a35c98f$export$2e2bcd8739ae039 = $ff22b69a0a35c98f$var$PatientsPage;

});
parcelRegister("kceJh", function(module, exports) {

$parcel$export(module.exports, "fetchPatientsAsync", () => $0beee5e9bca8c405$export$ab893d255ef12b88);
$parcel$export(module.exports, "uploadPatientsCSVAsync", () => $0beee5e9bca8c405$export$364fabeafaf3428f);

var $55aym = parcelRequire("55aym");
const $0beee5e9bca8c405$export$ab893d255ef12b88 = (searchQuery)=>{
    return {
        type: (0, $55aym.PatientsActionTypes).FETCH_PATIENTS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $0beee5e9bca8c405$export$adc134529ab9ccd7 = ()=>{
    return {
        type: (0, $55aym.PatientsActionTypes).FETCH_ALL_PATIENTS_ASYNC_PENDING
    };
};
const $0beee5e9bca8c405$export$364fabeafaf3428f = (csvFile)=>{
    return {
        type: (0, $55aym.PatientsActionTypes).UPLOAD_PATIENTS_CSV_ASYNC_PENDING,
        payload: csvFile
    };
};

});

parcelRegister("6it4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $454abcc896c89795$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $4XCrQ = parcelRequire("4XCrQ");

var $hsbMJ = parcelRequire("hsbMJ");
const $454abcc896c89795$var$PatientList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "patient"
    ]);
    const patientIds = (0, $iD0SF.useSelector)((0, $hsbMJ.getAllPatientIds));
    if (!patientIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("patient:index:noPatients")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: patientIds.map((patientId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4XCrQ.default), {
                patientId: patientId
            }, patientId);
        })
    });
};
var $454abcc896c89795$export$2e2bcd8739ae039 = $454abcc896c89795$var$PatientList;

});
parcelRegister("4XCrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42a4c9f2eb35eb8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $eEYoR = parcelRequire("eEYoR");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $eYle3 = parcelRequire("eYle3");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $hsbMJ = parcelRequire("hsbMJ");
const $f42a4c9f2eb35eb8$var$PatientListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    if (!patient) return null;
    const patientDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT, {
        patientId: props.patientId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                                className: "fill-current w-6 h-6",
                                title: t("shared:patient")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eYle3.default), {
                            patientId: props.patientId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                href: patientDetailsUrl,
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                children: t("shared:viewDetails")
                            }, "1")
                        ]
                    })
                })
            ]
        })
    });
};
var $f42a4c9f2eb35eb8$export$2e2bcd8739ae039 = $f42a4c9f2eb35eb8$var$PatientListItem;

});
parcelRegister("eYle3", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ccdf2cf56e8a27$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $6t04b = parcelRequire("6t04b");

var $1DXYh = parcelRequire("1DXYh");

var $j2STh = parcelRequire("j2STh");

var $7hl6H = parcelRequire("7hl6H");

var $hsbMJ = parcelRequire("hsbMJ");

var $aeos3 = parcelRequire("aeos3");
const $08ccdf2cf56e8a27$var$PatientDetails = ({ hasLink: hasLink = true, patientId: patientId })=>{
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const patientDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT, {
        patientId: patient.id
    });
    const renderName = ()=>{
        const nameText = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
            firstName: patient.firstName,
            lastName: patient.lastName,
            title: patient.title
        });
        const renderText = ()=>{
            if (!hasLink) return nameText;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                href: patientDetailsUrl,
                children: nameText
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: renderText()
            })
        });
    };
    const renderGender = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(patient.gender);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:gender"),
                ": ",
                t(`shared:${translationKey}`)
            ]
        });
    };
    const renderDateOfBirth = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:dateOfBirth"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                    utcTime: patient.dateOfBirth
                })
            ]
        });
    };
    const renderCreatedBy = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:createdBy"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: patient.createdBy.firstName,
                    lastName: patient.createdBy.lastName
                })
            ]
        });
    };
    const renderHealthcareId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                healthcareIdLabel,
                ": ",
                patient.healthcareId || "-"
            ]
        });
    };
    const renderCareProviderId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                careProviderIdLabel,
                ": ",
                patient.careProviderId || "-"
            ]
        });
    };
    const renderCasesAssigned = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:casesAssigned"),
                ": ",
                patient.casesCount || 0
            ]
        });
    };
    const renderCreatedAt = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:createdAt"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: patient.createdAt
                })
            ]
        });
    };
    if (!patient) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderName(),
                    renderGender(),
                    renderDateOfBirth(),
                    renderCreatedBy()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderHealthcareId(),
                    renderCareProviderId(),
                    renderCasesAssigned(),
                    renderCreatedAt()
                ]
            })
        ]
    });
};
var $08ccdf2cf56e8a27$export$2e2bcd8739ae039 = $08ccdf2cf56e8a27$var$PatientDetails;

});
parcelRegister("hsbMJ", function(module, exports) {

$parcel$export(module.exports, "getAllPatientIds", () => $0d1d61e558f28b94$export$aace22820397b424);
$parcel$export(module.exports, "getPatientById", () => $0d1d61e558f28b94$export$31e235c3c8e95dc4);
const $0d1d61e558f28b94$export$e4d6674928102cbd = (state)=>state.entities.patients?.byId;
const $0d1d61e558f28b94$export$aace22820397b424 = (state)=>state.entities.patients?.allIds;
const $0d1d61e558f28b94$export$31e235c3c8e95dc4 = (state, ownProps)=>state.entities?.patients?.byId[ownProps?.patientId];

});




parcelRegister("hQqbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc1c76b6613ecf6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $lXapY = parcelRequire("lXapY");
const $2cc1c76b6613ecf6$var$PatientsUploadModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "patients"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.smallModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("patient:bulkUpload:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-ch-blue-600 mb-2",
                    children: t("patient:bulkUpload:emailOnCompletion")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lXapY.default), {
                    closeAction: props.closeModal
                })
            ]
        })
    });
};
var $2cc1c76b6613ecf6$export$2e2bcd8739ae039 = $2cc1c76b6613ecf6$var$PatientsUploadModal;

});
parcelRegister("lXapY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc65f55cc83517dd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4KSAX = parcelRequire("4KSAX");

var $7YFi7 = parcelRequire("7YFi7");

var $8Jzjq = parcelRequire("8Jzjq");

var $hbVCd = parcelRequire("hbVCd");

var $7UN5R = parcelRequire("7UN5R");

var $7lHgq = parcelRequire("7lHgq");

var $eTqMc = parcelRequire("eTqMc");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $k7EMY = parcelRequire("k7EMY");

var $kceJh = parcelRequire("kceJh");
const $bc65f55cc83517dd$var$PatientsUploadForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "asset"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const handleSubmit = (file, { setSubmitting: setSubmitting })=>{
        dispatch((0, $kceJh.uploadPatientsCSVAsync)(file));
        setSubmitting(false);
        props.closeAction();
    };
    const initialValues = {
        file: null
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: "flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Jzjq.default), {
                        className: "w-6 h-6 mr-2 text-ch-purple-500",
                        title: t("asset:uploadFile")
                    }),
                    t("asset:uploadFile")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: initialValues,
                onSubmit: handleSubmit,
                validateOnChange: true,
                validationSchema: (0, $hbVCd.patientsUploadValidation),
                children: ({ errors: errors, setFieldValue: setFieldValue, isSubmitting: isSubmitting, values: values, isValid: isValid })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Form), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                            name: "file",
                                            children: [
                                                t("asset:selectFile"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lHgq.default), {
                                            name: "file",
                                            acceptedFileTypes: (0, $k7EMY.fileUploadOptions).acceptedCSVTypes.join(", "),
                                            onChange: (event)=>{
                                                setFieldValue("file", event.currentTarget.files[0]);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.file,
                                            isVisible: errors.file != null
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                    className: "mb-2",
                                    buttons: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            action: ()=>{
                                                props.closeAction();
                                            },
                                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                            children: t("shared:cancel")
                                        }, "1"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: values.file == null || !isValid || isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            isSubmit: true,
                                            children: t("asset:uploadFile")
                                        }, "2")
                                    ]
                                })
                            ]
                        })
                    })
            })
        ]
    });
};
var $bc65f55cc83517dd$export$2e2bcd8739ae039 = $bc65f55cc83517dd$var$PatientsUploadForm;

});
parcelRegister("hbVCd", function(module, exports) {

$parcel$export(module.exports, "patientsUploadValidation", () => $7cb02b78500d8d75$export$550ebfb5b930ac00);
parcelRequire("cxhNX");
var $dmHdY = parcelRequire("dmHdY");
var $hDGtv = parcelRequire("hDGtv");

var $5wPBK = parcelRequire("5wPBK");

var $k7EMY = parcelRequire("k7EMY");
const $7cb02b78500d8d75$export$550ebfb5b930ac00 = ()=>{
    return $hDGtv.create().shape({
        file: $dmHdY.create().test("fileSizeMaximum", (0, $5wPBK.default).t("shared:fileTooLarge", {
            maxFileSize: (0, $k7EMY.fileUploadOptions).maxFileSizeMB
        }), (value)=>{
            return (0, $k7EMY.isFilesSizeUnderMaximum)(value);
        }).test("acceptedFileType", (0, $5wPBK.default).t("shared:csvWrongType", {
            acceptedFileTypes: (0, $k7EMY.fileUploadOptions).acceptedCSVTypes
        }), (value)=>{
            return (0, $k7EMY.isCSVAcceptedType)(value);
        })
    });
};

});




parcelRegister("5Pjrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1da520464a0df0f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $9QVLZ = parcelRequire("9QVLZ");

var $aDFyu = parcelRequire("aDFyu");

var $39EfS = parcelRequire("39EfS");

var $kQILj = parcelRequire("kQILj");

var $eCmSQ = parcelRequire("eCmSQ");

var $kVlM3 = parcelRequire("kVlM3");

var $1kXfn = parcelRequire("1kXfn");

var $glc4D = parcelRequire("glc4D");

var $1yAAK = parcelRequire("1yAAK");

var $aEkd8 = parcelRequire("aEkd8");

var $6QJY8 = parcelRequire("6QJY8");

var $7qa36 = parcelRequire("7qa36");

var $7pHTe = parcelRequire("7pHTe");

var $ezGxj = parcelRequire("ezGxj");
const $a1da520464a0df0f$var$PathwaysPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getPathwaysUI)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $1yAAK.fetchPathwaysAction));
    const quickViewResourceId = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getQuickViewResourceId)(state));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:pathways"),
                buttonText: t("pathway:addNewPathway"),
                buttonHref: (0, $6QJY8.RoutePaths).PATHWAY_NEW,
                hasButtonPermission: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-start-2 md:row-start-1 self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "pathway:index:searchBy",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-end-2 md:row-start-1 flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                buttonText: t("pathway:index:buttons:searchPathways")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-2 text-center md:text-left",
                children: [
                    UI.totalPathwaysCount,
                    " ",
                    t("shared:pathways")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ezGxj.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            orderByOptions: (0, $eCmSQ.PathwaysOrderByOptions),
                            useTranslation: "pathway:index:orderBy"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEkd8.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalPathwaysCount,
                totalPages: UI.totalPages
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qa36.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pHTe.default), {
                    pathwayId: quickViewResourceId
                })
            })
        ]
    });
};
var $a1da520464a0df0f$export$2e2bcd8739ae039 = $a1da520464a0df0f$var$PathwaysPage;

});
parcelRegister("1yAAK", function(module, exports) {

$parcel$export(module.exports, "fetchPathwaysAction", () => $b0da0785501604e9$export$c6fb137d38eeb625);

var $eCmSQ = parcelRequire("eCmSQ");
const $b0da0785501604e9$export$c6fb137d38eeb625 = (searchQuery)=>{
    return {
        type: (0, $eCmSQ.PathwaysActionTypes).FETCH_PATHWAYS_ASYNC_PENDING,
        payload: searchQuery
    };
};

});

parcelRegister("aEkd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $49102503777e8b11$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $ir4UP = parcelRequire("ir4UP");
const $49102503777e8b11$export$3b2a1d8d0a92c08 = ()=>{
    const pathwayIds = (0, $iD0SF.useSelector)((state)=>state.ui.pathways.onPage);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: pathwayIds.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ir4UP.default), {
                    pathwayId: id
                }, id))
        })
    });
};
var $49102503777e8b11$export$2e2bcd8739ae039 = $49102503777e8b11$export$3b2a1d8d0a92c08;

});
parcelRegister("ir4UP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21e8b4396fb23f5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $jF0Xa = parcelRequire("jF0Xa");

var $5l38P = parcelRequire("5l38P");

var $i4wYI = parcelRequire("i4wYI");
const $c21e8b4396fb23f5$export$7b8f5f3df0c5b633 = ({ pathwayId: pathwayId })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((state)=>state.entities.pathways.byId[pathwayId]);
    const dispatch = (0, $2OPjR.useDispatch)();
    if (!pathway) return null;
    const onClickQuickView = (pathwayId)=>dispatch((0, $i4wYI.toggleIsQuickViewOpen)(pathwayId, true));
    const pathwayDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATHWAY, {
        pathwayId: pathwayId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                className: "fill-current w-6 h-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5l38P.default), {
                            pathwayId: pathwayId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                action: ()=>onClickQuickView(pathwayId),
                                variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                className: "hidden md:block",
                                children: t("shared:quickView")
                            }, "1"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                href: pathwayDetailsUrl,
                                children: t("shared:viewDetails")
                            }, "2")
                        ]
                    })
                })
            ]
        })
    });
};
var $c21e8b4396fb23f5$export$2e2bcd8739ae039 = $c21e8b4396fb23f5$export$7b8f5f3df0c5b633;

});


parcelRegister("7pHTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d5256a525b7865$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $1DXYh = parcelRequire("1DXYh");

var $jF0Xa = parcelRequire("jF0Xa");

var $8GcjU = parcelRequire("8GcjU");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");
const $00d5256a525b7865$export$2b86402c7f961824 = ({ pathwayId: pathwayId })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((state)=>state.entities.pathways.byId[pathwayId]);
    if (!pathway) return null;
    const pathwayDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATHWAY, {
        pathwayId: pathwayId
    });
    const renderLastUpdatedBy = ()=>{
        const firstName = pathway.lastUpdatedBy ? pathway.lastUpdatedBy.firstName : pathway.createdBy.firstName;
        const lastName = pathway.lastUpdatedBy ? pathway.lastUpdatedBy.lastName : pathway.createdBy.lastName;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            className: "mb-3",
            children: [
                t("shared:lastUpdatedBy"),
                ": ",
                firstName,
                " ",
                lastName
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                            className: "fill-current w-6 h-6",
                            title: t("shared:pathway")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "text-center mb-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "font-semibold",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DXYh.default), {
                                        href: pathwayDetailsUrl,
                                        children: pathway.name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
                                className: "mb-1",
                                children: [
                                    t("shared:classification"),
                                    ": ",
                                    pathway.caseClassification.name
                                ]
                            }),
                            renderLastUpdatedBy()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-4 p-4 bg-ch-blue-100 rounded-md",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                            children: [
                                t("pathway:summary"),
                                ":"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: pathway.description || t("pathway:noSummary")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center flex-col mb-6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    href: pathwayDetailsUrl,
                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                    children: t("shared:viewDetails")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8GcjU.default), {
                pathwayId: pathwayId
            })
        ]
    });
};
var $00d5256a525b7865$export$2e2bcd8739ae039 = $00d5256a525b7865$export$2b86402c7f961824;

});
parcelRegister("8GcjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $15531c11fed3ca3b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $8g1PZ = parcelRequire("8g1PZ");

var $iVDgl = parcelRequire("iVDgl");

var $2jvQG = parcelRequire("2jvQG");

var $1Cmbh = parcelRequire("1Cmbh");

var $hLb0B = parcelRequire("hLb0B");

var $6qPsx = parcelRequire("6qPsx");
const $15531c11fed3ca3b$export$1922eac059b1cf51 = ({ pathwayId: pathwayId })=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((state)=>state.entities.pathways.byId[pathwayId]);
    if (!pathway) return null;
    const [currentTab, setCurrentTab] = (0, $acw62.useState)(0);
    const stepsCount = pathway.steps && pathway.steps.length || 0;
    const collaboratorsCount = pathway.users && pathway.users.length || 0;
    const tabText1 = `${stepsCount} ${t("pathway:steps")}`;
    const tabText2 = `${collaboratorsCount} ${t("pathway:collaborators")}`;
    const renderStepsList = ()=>{
        if (stepsCount == 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(pathway.steps, (step)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                    className: "bg-ch-gray-300",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6qPsx.default), {
                        step: step
                    })
                }, step.position + step.name);
            })
        });
    };
    const renderCollarboratorsList = ()=>{
        if (collaboratorsCount == 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "text-center text-ch-blue-alt-400",
                    children: t("pathway:noCollaborators")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jvQG.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: pathway.users.map((user)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hLb0B.default), {
                    userId: user
                }, user);
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVDgl.default), {
                onClick: setCurrentTab,
                text1: tabText1,
                text2: tabText2,
                value: currentTab,
                className: "mb-2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 0
                }),
                children: renderStepsList()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                    "hidden": currentTab !== 1
                }),
                children: renderCollarboratorsList()
            })
        ]
    });
};
var $15531c11fed3ca3b$export$2e2bcd8739ae039 = $15531c11fed3ca3b$export$1922eac059b1cf51;

});
parcelRegister("hLb0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b22b385e3b7929b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $aEgqS = parcelRequire("aEgqS");

var $l30Z2 = parcelRequire("l30Z2");
const $8b22b385e3b7929b$var$PathwayUserListItem = ({ userId: userId })=>{
    const user = (0, $iD0SF.useSelector)((state)=>state.entities.users.byId[userId]);
    if (!user) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                user: user
            })
        })
    });
};
var $8b22b385e3b7929b$export$2e2bcd8739ae039 = $8b22b385e3b7929b$var$PathwayUserListItem;

});

parcelRegister("6qPsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ff9fd8635466de$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5v6Bi = parcelRequire("5v6Bi");

var $eEtn6 = parcelRequire("eEtn6");
parcelRequire("jitSV");
var $bKaLx = parcelRequire("bKaLx");

var $7T6sP = parcelRequire("7T6sP");
const $52ff9fd8635466de$var$PathwayStep = ({ step: step })=>{
    if (!step) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
        width: "full",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-1 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKaLx.default), {
                        className: "fill-current w-6 h-6"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7T6sP.default), {
                    step: step
                })
            ]
        })
    });
};
var $52ff9fd8635466de$export$2e2bcd8739ae039 = $52ff9fd8635466de$var$PathwayStep;

});




parcelRegister("jaEgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb464d5043ff1275$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d5eYa = parcelRequire("d5eYa");

var $6QJY8 = parcelRequire("6QJY8");

var $COwA0 = parcelRequire("COwA0");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $9L4IW = parcelRequire("9L4IW");

var $8Iw27 = parcelRequire("8Iw27");

var $9v0Is = parcelRequire("9v0Is");

var $9hABc = parcelRequire("9hABc");

var $6evfm = parcelRequire("6evfm");
const $eb464d5043ff1275$var$PathwayPage = ()=>{
    const { pathwayId: pathwayId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)({
        pathwayId: pathwayId
    }));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8Iw27.fetchPathwayAction)(pathwayId));
    }, []);
    if (!pathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                    breadcrumbs: [
                        {
                            pageTitle: t("shared:pathways"),
                            href: (0, $6QJY8.RoutePaths).PATHWAYS
                        },
                        {
                            pageTitle: t("pathway:pathwayDetails")
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                ...pathwayId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9hABc.default), {
                ...pathwayId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6evfm.default), {
                ...pathwayId
            })
        ]
    });
};
var $eb464d5043ff1275$export$2e2bcd8739ae039 = $eb464d5043ff1275$var$PathwayPage;

});
parcelRegister("8Iw27", function(module, exports) {

$parcel$export(module.exports, "fetchPathwayAction", () => $fc1e797d2716282b$export$6ad1f9e77481ccd9);
$parcel$export(module.exports, "createPathwayAction", () => $fc1e797d2716282b$export$85a80a8326cef708);
$parcel$export(module.exports, "updatePathwayAction", () => $fc1e797d2716282b$export$f27a380a451a15ed);
$parcel$export(module.exports, "deletePathwayAction", () => $fc1e797d2716282b$export$726960fdd748ad48);
$parcel$export(module.exports, "createPathwayStepAction", () => $fc1e797d2716282b$export$72451268f5f7b005);
$parcel$export(module.exports, "updatePathwayStepAction", () => $fc1e797d2716282b$export$31acfab6b3ebf304);
$parcel$export(module.exports, "deletePathwayStepAction", () => $fc1e797d2716282b$export$458b67101fd20433);
$parcel$export(module.exports, "addPathwayUsersAction", () => $fc1e797d2716282b$export$639434d5c96e8b20);
$parcel$export(module.exports, "removePathwayUserAction", () => $fc1e797d2716282b$export$48630351741c6dac);

var $eGEsd = parcelRequire("eGEsd");
const $fc1e797d2716282b$export$6ad1f9e77481ccd9 = (id)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).FETCH_PATHWAY_ASYNC_PENDING,
        payload: id
    };
};
const $fc1e797d2716282b$export$85a80a8326cef708 = (pathwayData)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_ASYNC_PENDING,
        payload: pathwayData
    };
};
const $fc1e797d2716282b$export$f27a380a451a15ed = (payload)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_ASYNC_PENDING,
        payload: payload
    };
};
const $fc1e797d2716282b$export$726960fdd748ad48 = (pathwayId)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId
        }
    };
};
const $fc1e797d2716282b$export$72451268f5f7b005 = (pathwayId, values)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).CREATE_PATHWAY_STEP_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId,
            values: values
        }
    };
};
const $fc1e797d2716282b$export$31acfab6b3ebf304 = (pathwayId, values)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).UPDATE_PATHWAY_STEP_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId,
            values: values
        }
    };
};
const $fc1e797d2716282b$export$458b67101fd20433 = (pathwayId, stepId)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).DELETE_PATHWAY_STEP_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId,
            stepId: stepId
        }
    };
};
const $fc1e797d2716282b$export$639434d5c96e8b20 = (pathwayId, users)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).ADD_PATHWAY_USERS_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId,
            users: users
        }
    };
};
const $fc1e797d2716282b$export$48630351741c6dac = (pathwayId, user)=>{
    return {
        type: (0, $eGEsd.PathwayActionTypes).REMOVE_PATHWAY_USER_ASYNC_PENDING,
        payload: {
            pathwayId: pathwayId,
            user: user
        }
    };
};

});

parcelRegister("9v0Is", function(module, exports) {

$parcel$export(module.exports, "default", () => $220bc33f03fdebfd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $k6suX = parcelRequire("k6suX");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $lCZwG = parcelRequire("lCZwG");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $9L4IW = parcelRequire("9L4IW");

var $4qaeN = parcelRequire("4qaeN");

var $5l38P = parcelRequire("5l38P");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $7YFi7 = parcelRequire("7YFi7");

var $1QJ5g = parcelRequire("1QJ5g");

var $8Iw27 = parcelRequire("8Iw27");

var $c0FI2 = parcelRequire("c0FI2");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $5GZlj = parcelRequire("5GZlj");

var $jxnLW = parcelRequire("jxnLW");

var $d8Vwn = parcelRequire("d8Vwn");

var $6qYxq = parcelRequire("6qYxq");

var $3Ukkm = parcelRequire("3Ukkm");

var $eTqMc = parcelRequire("eTqMc");

var $4MHRb = parcelRequire("4MHRb");

var $04A9g = parcelRequire("04A9g");

var $3tb7E = parcelRequire("3tb7E");
const $220bc33f03fdebfd$var$PathwayHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const [editModalIsOpen, setEditModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openEditModal = ()=>{
        setEditModalIsOpen(true);
    };
    const closeEditModal = ()=>{
        setEditModalIsOpen(false);
    };
    const [caseClassificationOptions, setCaseClassificationOptions] = (0, $acw62.useState)([]);
    const classifications = (0, $iD0SF.useSelector)((0, $jxnLW.getAllCaseClassifications));
    const [caseType, setCaseType] = (0, $acw62.useState)(pathway.caseType);
    const renderEditButtons = ()=>{
        if (!pathway.permissions?.canEdit || props.hideButtons) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                buttons: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3tb7E.default), {
                        pathwayId: props.pathwayId
                    }, "1"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                        action: openEditModal,
                        children: t("pathway:buttons:editPathway")
                    }, "2")
                ]
            })
        });
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!caseType) return;
        setCaseClassificationOptionsForCaseType(caseType);
    }, [
        classifications
    ]);
    const setCaseClassificationOptionsForCaseType = (caseType)=>{
        const options = (0, $d8Vwn.generateCaseClassificationOptions)(classifications, caseType);
        setCaseClassificationOptions(options);
    };
    const onChangeCaseType = (e)=>{
        const currentCaseType = e.currentTarget.value;
        setCaseType(currentCaseType);
        setCaseClassificationOptionsForCaseType(currentCaseType);
    };
    const caseTypeOptions = Object.keys((0, $6qYxq.CaseTypes)).filter((key)=>key != "SuspectedCancer").map((key)=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $6qYxq.CaseTypes)[key]);
        return {
            value: (0, $6qYxq.CaseTypes)[key],
            label: t(`case:${translationKey}`)
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                        hasBorder: false,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                        className: "sm:mr-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k6suX.default), {
                                            className: "fill-current w-6 h-6",
                                            title: t("shared:case")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5l38P.default), {
                                        pathwayId: props.pathwayId
                                    })
                                ]
                            }),
                            renderEditButtons()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-4 p-4 bg-ch-blue-100 rounded-md",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                    children: [
                                        t("pathway:summary"),
                                        ":"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: pathway.description || t("pathway:noSummary")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: editModalIsOpen,
                onRequestClose: closeEditModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeEditModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("pathway:edit:editPathway")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                            initialValues: pathway,
                            validationSchema: (0, $1QJ5g.pathwayNewValidationSchema),
                            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                                const data = (0, $1QJ5g.pathwayNewValidationSchema)().cast(values);
                                dispatch((0, $8Iw27.updatePathwayAction)(data));
                                setSubmitting(true);
                                closeEditModal();
                            },
                            children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, isValid: isValid, dirty: dirty })=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                    className: "w-full lg:w-2/3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                    name: "name",
                                                    required: true,
                                                    children: t("pathway:name")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                    type: "text",
                                                    name: "name",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    value: values.name,
                                                    autoComplete: "off",
                                                    autoFocus: true
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                    errorMessage: errors.name,
                                                    isVisible: errors.name && touched.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "md:flex",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mb-2 md:w-1/3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                            name: "caseType",
                                                            required: true,
                                                            children: t("pathway:caseType")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                            name: "caseType",
                                                            onChange: onChangeCaseType,
                                                            onBlur: handleBlur,
                                                            options: caseTypeOptions
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                            errorMessage: errors.caseType,
                                                            isVisible: errors.caseType && touched.caseType
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex-1 mb-2 md:ml-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                            name: "caseClassificationId",
                                                            required: true,
                                                            children: t("shared:classification")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                            name: "caseClassificationId",
                                                            options: caseClassificationOptions,
                                                            isDisabled: !values.caseType,
                                                            isGrouped: true,
                                                            onChange: handleChange,
                                                            onBlur: handleBlur
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                            errorMessage: errors.caseClassificationId,
                                                            isVisible: errors.caseClassificationId && touched.caseClassificationId
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                    name: "description",
                                                    required: true,
                                                    children: t("pathway:summary")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                    type: "text",
                                                    name: "description",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    value: values.description,
                                                    autoComplete: "off",
                                                    as: "textarea",
                                                    className: "h-32"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                    errorMessage: errors.description,
                                                    isVisible: errors.description && touched.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                                buttons: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                        isDisabled: isSubmitting || !isValid,
                                                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                                                        action: closeEditModal,
                                                        children: t("shared:cancel")
                                                    }, "1"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                        isDisabled: !dirty || isSubmitting || !isValid,
                                                        variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                                        isSubmit: true,
                                                        children: t("pathway:edit:updatePathway")
                                                    }, "2")
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $220bc33f03fdebfd$export$2e2bcd8739ae039 = $220bc33f03fdebfd$var$PathwayHeader;

});
parcelRegister("1QJ5g", function(module, exports) {

$parcel$export(module.exports, "pathwayNewValidationSchema", () => $6fb4081998dc75ce$export$c0d571ac126a3d1b);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $6fb4081998dc75ce$export$c0d571ac126a3d1b = ()=>{
    const maxNameLength = 100;
    const maxDescriptionLength = 500;
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(maxNameLength, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: maxNameLength
        })),
        description: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(maxDescriptionLength, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: maxDescriptionLength
        })),
        caseClassificationId: $gcL7X.create().required((0, $5wPBK.default).t("shared:required"))
    });
};

});

parcelRegister("3tb7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $593d0ef5b41f2e8f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7jD0k = parcelRequire("7jD0k");

var $4KSAX = parcelRequire("4KSAX");

var $8Iw27 = parcelRequire("8Iw27");

var $9L4IW = parcelRequire("9L4IW");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $04A9g = parcelRequire("04A9g");

var $9v0Is = parcelRequire("9v0Is");
const $593d0ef5b41f2e8f$var$DeletePathwayButton = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const [confirmIsOpen, setConfirmIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "pathway"
    ]);
    const deletePathway = ()=>dispatch((0, $8Iw27.deletePathwayAction)(props.pathwayId));
    const openConfirm = ()=>{
        setConfirmIsOpen(true);
    };
    const closeConfirm = ()=>{
        setConfirmIsOpen(false);
    };
    if (!pathway.permissions?.canEdit) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: openConfirm,
                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                children: t("pathway:buttons:deletePathway")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: confirmIsOpen,
                onRequestClose: closeConfirm,
                style: (0, $jF0Xa.dialogueModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeConfirm,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "text-lg mb-3",
                            children: [
                                t("pathway:details:deletePathwayHeader"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                                pathwayId: props.pathwayId,
                                hideButtons: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "my-3",
                            children: t("pathway:details:deletePathwayAreYouSure")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: closeConfirm,
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>deletePathway(),
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    children: t("pathway:buttons:deletePathway")
                                }, "2")
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $593d0ef5b41f2e8f$export$2e2bcd8739ae039 = $593d0ef5b41f2e8f$var$DeletePathwayButton;

});


parcelRegister("9hABc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b54682393605bc16$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3JxJk = parcelRequire("3JxJk");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $9L4IW = parcelRequire("9L4IW");

var $4qaeN = parcelRequire("4qaeN");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $kA27M = parcelRequire("kA27M");

var $8g1PZ = parcelRequire("8g1PZ");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $bFoxZ = parcelRequire("bFoxZ");

var $9v0Is = parcelRequire("9v0Is");

var $lOcoE = parcelRequire("lOcoE");

var $8Iw27 = parcelRequire("8Iw27");
const $b54682393605bc16$var$PathwayUserList = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const [isVisibleList, toggleList] = (0, $acw62.useState)(false);
    const [modalIsOpen, setModalIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const openModal = ()=>{
        setModalIsOpen(true);
    };
    const closeModal = ()=>{
        setModalIsOpen(false);
    };
    const handleAddUsers = (values)=>{
        dispatch((0, $8Iw27.addPathwayUsersAction)(pathway.id, values.users));
        closeModal();
    };
    if (!pathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("pathway:collaborators"),
                                    " (",
                                    pathway.users.length,
                                    ")"
                                ]
                            }),
                            pathway.permissions?.canEdit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFoxZ.default), {
                                openModal: openModal,
                                label: t("pathway:details:addCollaborator")
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex mb-2 items-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "flex-1 pr-10 lg:pr-24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                    i18nKey: "pathway:details:collaboratorsIntro",
                                    components: {
                                        strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                                isExpanded: isVisibleList,
                                action: ()=>toggleList(!isVisibleList),
                                expandText: t("meeting:showUsers"),
                                collapseText: t("meeting:hideUsers")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                            hidden: !isVisibleList
                        }),
                        children: pathway.users.map((user)=>{
                            return /*#__PURE__*/ (0, $acw62.createElement)((0, $3JxJk.default), {
                                ...props,
                                userId: user,
                                key: user
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("pathway:details:wouldYouLikeToAddACollaborator")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                            pathwayId: props.pathwayId
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-ch-blue-600",
                                    children: t("pathway:details:chooseCollaborators1")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-ch-blue-600",
                                    children: t("pathway:details:chooseCollaborators2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOcoE.default), {
                            disableTeams: true,
                            submitHandler: handleAddUsers,
                            userLabel: t("pathway:collaborators"),
                            excludedUserIds: pathway.users,
                            buttonText: t("pathway:details:addCollaboratorsToPathway")
                        })
                    ]
                })
            })
        ]
    });
};
var $b54682393605bc16$export$2e2bcd8739ae039 = $b54682393605bc16$var$PathwayUserList;

});
parcelRegister("3JxJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1835522691f49aaa$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $6lvMC = parcelRequire("6lvMC");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $l30Z2 = parcelRequire("l30Z2");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $lCZwG = parcelRequire("lCZwG");

var $ejvqu = parcelRequire("ejvqu");

var $aEgqS = parcelRequire("aEgqS");

var $4KSAX = parcelRequire("4KSAX");

var $8Iw27 = parcelRequire("8Iw27");

var $9L4IW = parcelRequire("9L4IW");

var $jF0Xa = parcelRequire("jF0Xa");
const $1835522691f49aaa$var$PathwayUserListItem = (props)=>{
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const handleRemove = ()=>{
        dispatch((0, $8Iw27.removePathwayUserAction)(props.pathwayId, props.userId));
    };
    const renderButton = ()=>{
        if (props.userId == pathway.createdBy.id) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lCZwG.default), {
            action: handleRemove,
            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
            children: [
                " ",
                t("shared:remove")
            ]
        }, "1");
    };
    if (!user) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            renderButton()
                        ]
                    })
                })
            ]
        })
    });
};
var $1835522691f49aaa$export$2e2bcd8739ae039 = $1835522691f49aaa$var$PathwayUserListItem;

});


parcelRegister("6evfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4269428c183c5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $9L4IW = parcelRequire("9L4IW");

var $4qaeN = parcelRequire("4qaeN");

var $1Cmbh = parcelRequire("1Cmbh");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $3Rc9I = parcelRequire("3Rc9I");

var $7jD0k = parcelRequire("7jD0k");

var $9v0Is = parcelRequire("9v0Is");

var $jF0Xa = parcelRequire("jF0Xa");

var $lCZwG = parcelRequire("lCZwG");

var $7YFi7 = parcelRequire("7YFi7");

var $c0FI2 = parcelRequire("c0FI2");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $8Iw27 = parcelRequire("8Iw27");

var $22l7u = parcelRequire("22l7u");

var $4Zlhv = parcelRequire("4Zlhv");

var $04A9g = parcelRequire("04A9g");

var $jikC3 = parcelRequire("jikC3");
const $f8d4269428c183c5$var$PathwaySteps = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const pathway = (0, $iD0SF.useSelector)((0, $9L4IW.getPathway)(props));
    const steps = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(pathway.steps, "position");
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    const [createModalIsOpen, setCreateModalIsOpen] = (0, $acw62.useState)(false);
    const openCreateModal = ()=>{
        setCreateModalIsOpen(true);
    };
    const closeCreateModal = ()=>{
        setCreateModalIsOpen(false);
    };
    const [editStep, setEditStep] = (0, $acw62.useState)(null);
    const openEditStepModal = (step)=>{
        setEditStep(step);
    };
    const closeEditStepModal = ()=>{
        setEditStep(null);
    };
    const [deleteStep, setDeleteStep] = (0, $acw62.useState)(null);
    const openDeleteStepModal = (step)=>{
        setDeleteStep(step);
    };
    const closeDeleteStepModal = ()=>{
        setDeleteStep(null);
    };
    const confirmDelete = (step)=>{
        dispatch((0, $8Iw27.deletePathwayStepAction)(pathway.id, step.id));
        closeDeleteStepModal();
    };
    const changeStepPosition = (step, position)=>{
        if (position > 0 && position <= pathway.steps.length) {
            step.position = position;
            dispatch((0, $8Iw27.updatePathwayStepAction)(props.pathwayId, step));
        }
    };
    const initialValues = {
        name: "",
        description: ""
    };
    if (!pathway) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "mr-4 mb-2 text-lg",
                        children: [
                            t("pathway:steps"),
                            " (",
                            steps.length,
                            ")"
                        ]
                    }),
                    pathway.permissions?.canEdit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                        action: openCreateModal,
                        variant: (0, $jF0Xa.StyleVariants).BLUE,
                        children: t("pathway:details:addStep")
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex mb-4 items-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "flex-1 pr-10 lg:pr-24",
                    children: t("pathway:details:stepsIntro")
                })
            }),
            steps.length < 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-4 p-4 bg-ch-blue-100 rounded-md italic",
                children: t("pathway:details:pleaseAddSteps")
            }) : null,
            steps.map((step)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                    className: "bg-ch-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Zlhv.default), {
                            step: step
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex mt-2 flex-wrap flex-1 justify-center lg:justify-end",
                                children: pathway.permissions?.canEdit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22l7u.default), {
                                    id: step.id,
                                    actions: [
                                        {
                                            text: t("pathway:details:editStep"),
                                            action: ()=>{
                                                openEditStepModal(step);
                                            }
                                        },
                                        {
                                            text: t("pathway:details:deleteStep"),
                                            action: ()=>openDeleteStepModal(step)
                                        },
                                        {
                                            text: t("pathway:details:moveStepUp"),
                                            action: ()=>changeStepPosition(step, step.position -= 1),
                                            isDisabled: step.position == 1
                                        },
                                        {
                                            text: t("pathway:details:moveStepDown"),
                                            action: ()=>changeStepPosition(step, step.position += 1),
                                            isDisabled: step.position == pathway.steps.length
                                        }
                                    ]
                                }) : null
                            })
                        })
                    ]
                }, step.position + step.name);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: !!deleteStep,
                onRequestClose: closeDeleteStepModal,
                style: (0, $jF0Xa.dialogueModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeDeleteStepModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "text-lg mb-3",
                            children: [
                                t("pathway:details:deleteStepHeader"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                                pathwayId: props.pathwayId,
                                hideButtons: true
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "my-3",
                            children: [
                                t("pathway:details:deleteStepDetails"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                            className: "bg-ch-gray-300",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Zlhv.default), {
                                step: deleteStep
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "my-3",
                            children: t("pathway:details:deleteAreYouSure")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>closeDeleteStepModal(),
                                    variant: (0, $jF0Xa.StyleVariants).BLUE,
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lCZwG.default), {
                                    action: ()=>confirmDelete(deleteStep),
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    children: [
                                        t("pathway:details:deleteStep"),
                                        " "
                                    ]
                                }, "2")
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: !!editStep,
                onRequestClose: closeEditStepModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0k.default), {
                    handleClose: closeEditStepModal,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jikC3.default), {
                        step: editStep,
                        setStep: setEditStep,
                        pathwayId: pathway.id
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: createModalIsOpen,
                onRequestClose: closeCreateModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeCreateModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("pathway:details:addStepHeader")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                            pathwayId: props.pathwayId,
                            hideButtons: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                            initialValues: initialValues,
                            enableReinitialize: true,
                            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                                dispatch((0, $8Iw27.createPathwayStepAction)(pathway.id, values));
                                setSubmitting(true);
                                closeCreateModal();
                            },
                            children: ({ isSubmitting: isSubmitting, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty })=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                    className: "w-full lg:w-2/3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                                    name: "name",
                                                    required: true,
                                                    children: [
                                                        t("pathway:details:stepName"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                    type: "text",
                                                    name: "name",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    autoComplete: "off",
                                                    autoFocus: true
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                    errorMessage: errors.name,
                                                    isVisible: errors.name && touched.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                                    name: "description",
                                                    required: true,
                                                    children: [
                                                        t("pathway:details:stepDescription"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                    as: "textarea",
                                                    name: "description",
                                                    className: "h-24",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    autoComplete: "off"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                    errorMessage: errors.description,
                                                    isVisible: errors.description && touched.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex justify-center mb-6",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                isDisabled: !dirty || isSubmitting,
                                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                                isSubmit: true,
                                                children: t("pathway:details:addStep")
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $f8d4269428c183c5$export$2e2bcd8739ae039 = $f8d4269428c183c5$var$PathwaySteps;

});
parcelRegister("4Zlhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47d253314774e47$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $bKaLx = parcelRequire("bKaLx");

var $eEtn6 = parcelRequire("eEtn6");

var $7T6sP = parcelRequire("7T6sP");
const $f47d253314774e47$var$PathwayStep = ({ step: step })=>{
    if (!step) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-1 items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKaLx.default), {
                        className: "fill-current w-6 h-6"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7T6sP.default), {
                    step: step
                })
            ]
        })
    });
};
var $f47d253314774e47$export$2e2bcd8739ae039 = $f47d253314774e47$var$PathwayStep;

});

parcelRegister("jikC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $03793441a430dcc3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $c0FI2 = parcelRequire("c0FI2");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $04A9g = parcelRequire("04A9g");

var $8Iw27 = parcelRequire("8Iw27");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $9v0Is = parcelRequire("9v0Is");
const $03793441a430dcc3$var$EditPathwayStep = ({ step: step, pathwayId: pathwayId, setStep: setStep })=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-3",
                children: [
                    t("pathway:details:editStepHeader"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v0Is.default), {
                pathwayId: pathwayId,
                hideButtons: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                initialValues: step,
                enableReinitialize: true,
                onSubmit: (values, { setSubmitting: setSubmitting })=>{
                    setSubmitting(true);
                    dispatch((0, $8Iw27.updatePathwayStepAction)(pathwayId, values));
                    setStep(null);
                },
                children: ({ isSubmitting: isSubmitting, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty, values: values })=>{
                    if (!step) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                        className: "w-full lg:w-2/3 mt-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                        name: "name",
                                        required: true,
                                        children: [
                                            t("pathway:details:stepName"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        type: "text",
                                        name: "name",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        autoComplete: "off",
                                        autoFocus: true,
                                        value: values.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.name,
                                        isVisible: errors.name && touched.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UN5R.default), {
                                        name: "description",
                                        required: true,
                                        children: [
                                            t("pathway:details:stepDescription"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                        as: "textarea",
                                        name: "description",
                                        className: "h-24",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        autoComplete: "off",
                                        value: values.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                        errorMessage: errors.description,
                                        isVisible: errors.description && touched.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center mb-6",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                                    buttons: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                            action: ()=>setStep(null),
                                            children: t("shared:cancel")
                                        }, "1"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                            isDisabled: !dirty || isSubmitting,
                                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                            isSubmit: true,
                                            children: t("pathway:details:updateStep")
                                        }, "2")
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $03793441a430dcc3$export$2e2bcd8739ae039 = $03793441a430dcc3$var$EditPathwayStep;

});



parcelRegister("3dYgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6708fe0897593b32$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $azrSI = parcelRequire("azrSI");
const $6708fe0897593b32$var$PathwaysNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "pathway"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:pathways"),
                        href: (0, $6QJY8.RoutePaths).PATHWAYS
                    },
                    {
                        pageTitle: t("pathway:addNewPathway")
                    }
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $azrSI.default), {})
        ]
    });
};
var $6708fe0897593b32$export$2e2bcd8739ae039 = $6708fe0897593b32$var$PathwaysNewPage;

});
parcelRegister("azrSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e43a0172923d53$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $3Ukkm = parcelRequire("3Ukkm");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $6lvMC = parcelRequire("6lvMC");

var $1QJ5g = parcelRequire("1QJ5g");

var $c0FI2 = parcelRequire("c0FI2");

var $5GZlj = parcelRequire("5GZlj");

var $8Iw27 = parcelRequire("8Iw27");

var $6wDTk = parcelRequire("6wDTk");

var $d8Vwn = parcelRequire("d8Vwn");

var $jxnLW = parcelRequire("jxnLW");

var $6qYxq = parcelRequire("6qYxq");

var $4MHRb = parcelRequire("4MHRb");

var $8UrgM = parcelRequire("8UrgM");
const $40e43a0172923d53$var$PathwayNewForm = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "pathway"
    ]);
    const [userOptions, setUserOptions] = (0, $acw62.useState)([]);
    const [caseClassificationOptions, setCaseClassificationOptions] = (0, $acw62.useState)([]);
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const classifications = (0, $iD0SF.useSelector)((0, $jxnLW.getAllCaseClassifications));
    const [caseType, setCaseType] = (0, $acw62.useState)(null);
    const initialValues = {
        name: "",
        description: "",
        caseClassificationId: "",
        caseType: null,
        userIds: []
    };
    const setCaseClassificationOptionsForCaseType = (caseType)=>{
        const options = (0, $d8Vwn.generateCaseClassificationOptions)(classifications, caseType);
        setCaseClassificationOptions(options);
    };
    const caseTypeOptions = Object.keys((0, $6qYxq.CaseTypes)).filter((key)=>key != "SuspectedCancer").map((key)=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $6qYxq.CaseTypes)[key]);
        return {
            value: (0, $6qYxq.CaseTypes)[key],
            label: t(`case:${translationKey}`)
        };
    });
    const onChangeCaseType = (e)=>{
        const currentCaseType = e.currentTarget.value;
        setCaseType(currentCaseType);
        setCaseClassificationOptionsForCaseType(currentCaseType);
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(users));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!caseType) return;
        setCaseClassificationOptionsForCaseType(caseType);
    }, [
        classifications
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $1QJ5g.pathwayNewValidationSchema),
            validateOnMount: true,
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const data = (0, $1QJ5g.pathwayNewValidationSchema)().cast(values);
                dispatch((0, $8Iw27.createPathwayAction)(data));
                setSubmitting(false);
            },
            children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, isValid: isValid })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "name",
                                    required: true,
                                    children: t("pathway:name")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "name",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.name,
                                    autoComplete: "off",
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.name,
                                    isVisible: errors.name && touched.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "md:flex",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2 md:w-1/3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "caseType",
                                            required: true,
                                            children: t("pathway:caseType")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "caseType",
                                            onChange: onChangeCaseType,
                                            onBlur: handleBlur,
                                            options: caseTypeOptions
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.caseType,
                                            isVisible: errors.caseType && touched.caseType
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex-1 mb-2 md:ml-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "caseClassificationId",
                                            required: true,
                                            children: t("shared:classification")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "caseClassificationId",
                                            options: caseClassificationOptions,
                                            isDisabled: !values.caseType,
                                            isGrouped: true,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.caseClassificationId,
                                            isVisible: errors.caseClassificationId && touched.caseClassificationId
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "description",
                                    required: true,
                                    children: t("pathway:summary")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "description",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.description,
                                    autoComplete: "off",
                                    as: "textarea",
                                    className: "h-32"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.description,
                                    isVisible: errors.description && touched.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "userIds",
                                    children: t("pathway:collaborators")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "userIds",
                                    options: userOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    isMulti: true,
                                    closeMenuOnSelect: false,
                                    filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.userIds,
                                    isVisible: errors.userIds && touched.userIds
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: isSubmitting || !isValid,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("pathway:new:createPathway")
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $40e43a0172923d53$export$2e2bcd8739ae039 = $40e43a0172923d53$var$PathwayNewForm;

});


parcelRegister("2amIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62bafb2f861a68e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $kDf6E = parcelRequire("kDf6E");

var $73ewh = parcelRequire("73ewh");

var $epGsb = parcelRequire("epGsb");

var $lO9hU = parcelRequire("lO9hU");

var $caw88 = parcelRequire("caw88");

var $hsbMJ = parcelRequire("hsbMJ");
const $d62bafb2f861a68e$var$PatientPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchPatient = (patientId)=>dispatch((0, $caw88.fetchPatientAsync)(patientId));
    (0, $acw62.useEffect)(()=>{
        fetchPatient(patientId);
    }, []);
    if (!patient) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("patient:messages:patientNotFound")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lO9hU.default), {
                patientId: patientId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $epGsb.default), {
                patientId: patientId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73ewh.default), {
                patientId: patientId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kDf6E.default), {
                patientId: patientId
            })
        ]
    });
};
var $d62bafb2f861a68e$export$2e2bcd8739ae039 = $d62bafb2f861a68e$var$PatientPage;

});
parcelRegister("kDf6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $478d40ea8ca378be$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $hsbMJ = parcelRequire("hsbMJ");

var $6FjoK = parcelRequire("6FjoK");
const $478d40ea8ca378be$var$PatientAmendments = (props)=>{
    const [isVisibleList, toggleList] = (0, $acw62.useState)(true);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    if (!patient || !patient.cases) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center flex-wrap",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "mr-4 mb-2 text-lg",
                        children: t("patient:amendmentsToRecord:sectionTitle")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex mb-2 items-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: t("patient:amendmentsToRecord:intro")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                            isExpanded: isVisibleList,
                            action: ()=>toggleList(!isVisibleList),
                            expandText: t("patient:amendmentsToRecord:show"),
                            collapseText: t("patient:amendmentsToRecord:hide")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                        hidden: !isVisibleList
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(patient.patientAmendments, (patientAmendment)=>{
                            if (!patientAmendment.auditEvent) return;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6FjoK.default), {
                                amendment: patientAmendment
                            }, patientAmendment.auditEvent.id);
                        })
                    })
                })
            ]
        })
    });
};
var $478d40ea8ca378be$export$2e2bcd8739ae039 = $478d40ea8ca378be$var$PatientAmendments;

});
parcelRegister("6FjoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fbb06a843f9f99$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $6t04b = parcelRequire("6t04b");

var $7hl6H = parcelRequire("7hl6H");

var $aeos3 = parcelRequire("aeos3");
const $85fbb06a843f9f99$var$PatientAmendmentListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    if (!props.amendment) return null;
    const renderAmendmentDate = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:amendmentDate"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: props.amendment.auditEvent.createdAt
                })
            ]
        });
    };
    const renderReason = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:reason"),
                ": ",
                props.amendment.reason
            ]
        });
    };
    const renderAmendedBy = ()=>{
        const createdBy = props.amendment.auditEvent.createdBy;
        if (!createdBy) return;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:amendedBy"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: createdBy.firstName,
                    lastName: createdBy.lastName
                })
            ]
        });
    };
    const renderTypeOfChange = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.amendment.amendmentType);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:amendmentType"),
                ": ",
                t(`patient:reasonForChange:details:${translationKey}`)
            ]
        });
    };
    const renderAmendments = ()=>{
        const changes = props.amendment.auditEvent.eventData.changes;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
            children: Object.keys(changes).map((attributeName)=>{
                if (!changes[attributeName]) return;
                return renderAmendment(changes[attributeName], attributeName);
            })
        });
    };
    const attributeNameText = (attributeName)=>{
        if (attributeName == "healthcareId") return healthcareIdLabel;
        if (attributeName == "careProviderId") return careProviderIdLabel;
        return t(`patient:details:${attributeName}`);
    };
    const renderAmendment = (change, attributeName)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                attributeNameText(attributeName),
                " (",
                t("patient:reasonForChange:previous"),
                "): ",
                change[0]
            ]
        }, attributeName);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 lg:grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderAmendmentDate(),
                                renderAmendments(),
                                renderTypeOfChange()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderAmendedBy(),
                                renderReason()
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $85fbb06a843f9f99$export$2e2bcd8739ae039 = $85fbb06a843f9f99$var$PatientAmendmentListItem;

});


parcelRegister("73ewh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd01a691e74cb06$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $hsbMJ = parcelRequire("hsbMJ");

var $e2My1 = parcelRequire("e2My1");
const $0cd01a691e74cb06$var$PatientCases = (props)=>{
    const [isVisibleList, toggleList] = (0, $acw62.useState)(true);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    if (!patient || !patient.cases) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center flex-wrap",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "mr-4 mb-2 text-lg",
                        children: t("patient:cases:sectionTitle")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex mb-2 items-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: t("patient:cases:intro")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                            isExpanded: isVisibleList,
                            action: ()=>toggleList(!isVisibleList),
                            expandText: t("patient:cases:show"),
                            collapseText: t("patient:cases:hide")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                        hidden: !isVisibleList
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(patient.cases, (caseId)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2My1.default), {
                                caseId: caseId
                            }, caseId);
                        })
                    })
                })
            ]
        })
    });
};
var $0cd01a691e74cb06$export$2e2bcd8739ae039 = $0cd01a691e74cb06$var$PatientCases;

});
parcelRegister("e2My1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b3faf0faaf5ef29$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $kon2z = parcelRequire("kon2z");

var $ejvqu = parcelRequire("ejvqu");

var $3Rc9I = parcelRequire("3Rc9I");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $8r2NK = parcelRequire("8r2NK");
const $2b3faf0faaf5ef29$var$PatientCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    if (!theCase) return null;
    const renderViewDetailsButton = ()=>{
        if (theCase.permissions?.canRead) {
            const caseDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).CASE, {
                caseId: props.caseId
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                href: caseDetailsUrl,
                variant: (0, $jF0Xa.StyleVariants).BLUE,
                children: t("patient:cases:buttons:viewCase")
            }, `button-${props.caseId}`);
        } else return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "font-thin text-ch-gray-500",
            children: t("case:noAccess")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "sm:mr-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                            className: "fill-current w-6 h-6",
                            title: t("shared:case")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8r2NK.default), {
                        caseId: props.caseId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                    buttons: [
                        renderViewDetailsButton()
                    ]
                })
            })
        ]
    });
};
var $2b3faf0faaf5ef29$export$2e2bcd8739ae039 = $2b3faf0faaf5ef29$var$PatientCaseListItem;

});
parcelRegister("8r2NK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d670af506d1f026f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6t04b = parcelRequire("6t04b");

var $kon2z = parcelRequire("kon2z");

var $QwmFv = parcelRequire("QwmFv");

var $6ic8I = parcelRequire("6ic8I");

var $7hl6H = parcelRequire("7hl6H");
const $d670af506d1f026f$var$PatientCaseDetails = (props)=>{
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getLeadCareUserByCaseId)(state, props));
    if (!theCase) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "case"
    ]);
    const renderCaseType = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:type"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                    caseType: theCase.caseType
                })
            ]
        });
    };
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    const renderClassification = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": ",
                theCase.classification
            ]
        });
    };
    const renderSourceName = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:source"),
                ": ",
                theCase.sourceName
            ]
        });
    };
    const renderCreatedBy = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:createdBy"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: theCase.createdBy.firstName,
                    lastName: theCase.createdBy.lastName
                })
            ]
        });
    };
    const renderCreatedAt = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:createdAt"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                    utcTime: theCase.createdAt
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderLeadCare(),
                    renderClassification(),
                    renderSourceName()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    renderCaseType(),
                    renderCreatedBy(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ic8I.default), {
                        caseId: props.caseId
                    }),
                    renderCreatedAt()
                ]
            })
        ]
    });
};
var $d670af506d1f026f$export$2e2bcd8739ae039 = $d670af506d1f026f$var$PatientCaseDetails;

});



parcelRegister("epGsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c78bd9ed22b14d91$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kA27M = parcelRequire("kA27M");

var $4qaeN = parcelRequire("4qaeN");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $hsbMJ = parcelRequire("hsbMJ");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");
const $c78bd9ed22b14d91$var$FurtherDetails = (props)=>{
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    const [isVisible, toggleIsVisible] = (0, $acw62.useState)(false);
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    if (!patient) return null;
    const renderPatientAddress = ()=>{
        if (!patient.furtherDetails?.addressLine1) return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:address"),
                ": -"
            ]
        });
        const fullAddress = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject([
            patient.furtherDetails.addressLine1,
            patient.furtherDetails.addressLine2,
            patient.furtherDetails.city,
            patient.furtherDetails.county,
            patient.furtherDetails.country
        ], (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty).join(", ");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:address"),
                ": ",
                fullAddress
            ]
        });
    };
    const renderGPAddress = ()=>{
        if (!patient.furtherDetails?.gpAddressLine1) return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:gpAddress"),
                ": -"
            ]
        });
        const fullAddress = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject([
            patient.furtherDetails.gpAddressLine1,
            patient.furtherDetails.gpAddressLine2,
            patient.furtherDetails.gpCity,
            patient.furtherDetails.gpCounty,
            patient.furtherDetails.gpCountry
        ], (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty).join(", ");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:gpAddress"),
                ": ",
                fullAddress
            ]
        });
    };
    const renderDetail = (name)=>{
        const furtherDetails = patient.furtherDetails || {};
        if (!furtherDetails[name]) return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t(`patient:details:furtherDetails:${name}`),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t(`patient:details:furtherDetails:${name}`),
                ": ",
                furtherDetails[name]
            ]
        });
    };
    const renderEditButton = ()=>{
        if (!patient.permissions.canEdit) return null;
        const editPatientFurtherDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT_EDIT_FURTHER_DETAILS, {
            patientId: props.patientId
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: editPatientFurtherDetailsUrl,
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            className: "mb-2",
            children: t("shared:editDetails")
        }, "2");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mr-4 mb-2 text-lg",
                            children: t("patient:furtherDetails:sectionTitle")
                        }),
                        renderEditButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex mb-2 justify-end",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: t("patient:furtherDetails:info")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kA27M.default), {
                            isExpanded: isVisible,
                            action: ()=>toggleIsVisible(!isVisible),
                            expandText: t("patient:furtherDetails:show"),
                            collapseText: t("patient:furtherDetails:hide")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
                        hidden: !isVisible
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 lg:grid grid-cols-2 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                                className: "col-span-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "font-semibold",
                                            children: t("patient:furtherDetails:patientSectionTitle")
                                        })
                                    }),
                                    renderPatientAddress(),
                                    renderDetail("postcode"),
                                    renderDetail("email"),
                                    renderDetail("phoneNumber"),
                                    renderDetail("phoneNumberAlt")
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                                className: "col-span-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "font-semibold",
                                            children: t("patient:furtherDetails:gPSectionTitle")
                                        })
                                    }),
                                    renderDetail("gpName"),
                                    renderGPAddress(),
                                    renderDetail("gpPostcode"),
                                    renderDetail("gpEmail"),
                                    renderDetail("gpPhoneNumber")
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $c78bd9ed22b14d91$export$2e2bcd8739ae039 = $c78bd9ed22b14d91$var$FurtherDetails;

});

parcelRegister("lO9hU", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fea75b75fb9686$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $cOtzh = parcelRequire("cOtzh");

var $5v6Bi = parcelRequire("5v6Bi");

var $d5eYa = parcelRequire("d5eYa");

var $1Cmbh = parcelRequire("1Cmbh");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $eEYoR = parcelRequire("eEYoR");

var $eYle3 = parcelRequire("eYle3");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $hsbMJ = parcelRequire("hsbMJ");

var $COwA0 = parcelRequire("COwA0");
const $86fea75b75fb9686$var$PatientHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "patient"
    ]);
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    const renderEditButton = ()=>{
        if (!patient.permissions.canEdit) return null;
        const editPatientDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT_EDIT_DETAILS, {
            patientId: props.patientId
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: editPatientDetailsUrl,
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("patient:details:buttons:editPatient")
        }, "2");
    };
    const renderAddCaseButton = ()=>{
        if (patient.permissions.canAddCase) {
            const newPatientCaseUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT_CASE_NEW, {
                patientId: props.patientId
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                href: newPatientCaseUrl,
                variant: (0, $jF0Xa.StyleVariants).ORANGE,
                children: t("patient:details:buttons:addCase")
            }, "3");
        } else return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                        breadcrumbs: [
                            {
                                pageTitle: t("shared:patients"),
                                href: (0, $6QJY8.RoutePaths).PATIENTS
                            },
                            {
                                pageTitle: t("patient:details:sectionTitle")
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cOtzh.default), {
                        hasPermission: patient?.permissions?.canTrackChanges,
                        action: ()=>{
                            return null;
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                                    className: "fill-current w-6 h-6",
                                    title: t("shared:patient")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eYle3.default), {
                                patientId: props.patientId,
                                hasLink: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                            buttons: [
                                renderEditButton(),
                                renderAddCaseButton()
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $86fea75b75fb9686$export$2e2bcd8739ae039 = $86fea75b75fb9686$var$PatientHeader;

});

parcelRegister("caw88", function(module, exports) {

$parcel$export(module.exports, "fetchPatientAsync", () => $3b5a121feec36083$export$34673f1c00ec78bf);

var $el6QJ = parcelRequire("el6QJ");
const $3b5a121feec36083$export$34673f1c00ec78bf = (patientId)=>{
    return {
        type: (0, $el6QJ.PatientActionTypes).FETCH_PATIENT_ASYNC_PENDING,
        payload: patientId
    };
};

});


parcelRegister("beTuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be6a610761ffe14$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $1HjJZ = parcelRequire("1HjJZ");

var $587VS = parcelRequire("587VS");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $6Hpf8 = parcelRequire("6Hpf8");
var $1P0Mf = parcelRequire("1P0Mf");
var $eEYoR = parcelRequire("eEYoR");
var $9ZBPP = parcelRequire("9ZBPP");

var $9BK0b = parcelRequire("9BK0b");

var $ecRMg = parcelRequire("ecRMg");

var $3juol = parcelRequire("3juol");

var $ksknn = parcelRequire("ksknn");

var $6lvMC = parcelRequire("6lvMC");
const $5be6a610761ffe14$var$PatientNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const currentAbilities = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUserAbilities)(state));
    const [patientNewData, setPatientNewData] = (0, $acw62.useState)({
        title: "",
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        healthcareId: "",
        careProviderId: "",
        furtherDetailsAttributes: {
            id: null,
            postcode: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            county: "",
            country: "",
            email: "",
            phoneNumber: "",
            phoneNumberAlt: "",
            gpPostcode: "",
            gpPracticeName: "",
            gpAddressLine1: "",
            gpAddressLine2: "",
            gpCity: "",
            gpCounty: "",
            gpCountry: "",
            gpEmail: "",
            gpPhoneNumber: "",
            gpName: ""
        },
        casesAttributes: [
            {
                caseType: "",
                caseClassificationId: "",
                leadCareUserId: "",
                signedOffBy: "",
                targetDate: "",
                sourceId: ""
            }
        ]
    });
    const renderWizard = ()=>{
        if (!currentAbilities?.patient.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1HjJZ.default), {
            data: patientNewData,
            setData: setPatientNewData,
            steps: [
                {
                    name: t("patient:checkDetails:sectionTitle"),
                    icon: (0, $9ZBPP.default),
                    component: (0, $587VS.default),
                    nextButtonText: t("shared:next")
                },
                {
                    name: t("patient:details:newPatientTitle"),
                    icon: (0, $eEYoR.default),
                    component: (0, $9BK0b.default),
                    nextButtonText: t("shared:next"),
                    previousButtonText: t("shared:previous")
                },
                {
                    name: t("patient:furtherDetails:sectionTitle"),
                    icon: (0, $1P0Mf.default),
                    component: (0, $ecRMg.default),
                    nextButtonText: t("shared:next"),
                    previousButtonText: t("shared:previous")
                },
                {
                    name: t("patient:caseDetails:sectionTitle"),
                    icon: (0, $6Hpf8.default),
                    component: (0, $3juol.default),
                    nextButtonText: t("patient:caseDetails:buttons:createCase"),
                    previousButtonText: t("shared:previous"),
                    hasSkip: true
                },
                {
                    name: t("patient:reviewAndSave:sectionTitle"),
                    icon: (0, $4o7Oq.default),
                    component: (0, $ksknn.default),
                    nextButtonText: t("patient:reviewAndSave:buttons:savePatient"),
                    previousButtonText: t("shared:previous")
                }
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:patients"),
                        href: (0, $6QJY8.RoutePaths).PATIENTS
                    },
                    {
                        pageTitle: t("patient:addNew:sectionTitle")
                    }
                ]
            }),
            renderWizard()
        ]
    });
};
var $5be6a610761ffe14$export$2e2bcd8739ae039 = $5be6a610761ffe14$var$PatientNewPage;

});
parcelRegister("1HjJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8f366bff250717c$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $765bZ = parcelRequire("765bZ");

var $5Opa0 = parcelRequire("5Opa0");

var $l5zpH = parcelRequire("l5zpH");
const $d8f366bff250717c$var$Wizard = (props)=>{
    const [currentStepNumber, setCurrentStepNumber] = (0, $acw62.useState)(0);
    const goToNextStep = ()=>{
        goToStep(currentStepNumber + 1);
    };
    const goToPreviousStep = ()=>{
        goToStep(currentStepNumber - 1);
    };
    const goToStep = (number)=>{
        setCurrentStepNumber(number);
    };
    const renderCurrentStep = ()=>{
        const StepComponent = props.steps[currentStepNumber].component;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StepComponent, {
            goToNextStep: goToNextStep,
            data: props.data,
            setData: props.setData
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $765bZ.FormContextProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col h-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l5zpH.default), {
                    steps: props.steps,
                    currentStepNumber: currentStepNumber,
                    goToStep: goToStep
                }),
                renderCurrentStep(),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Opa0.default), {
                    steps: props.steps,
                    currentStepNumber: currentStepNumber,
                    goToNextStep: goToNextStep,
                    goToPreviousStep: goToPreviousStep
                })
            ]
        })
    });
};
var $d8f366bff250717c$export$2e2bcd8739ae039 = $d8f366bff250717c$var$Wizard;

});
parcelRegister("765bZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $54c645ce3d157781$export$c24727297075ec6a);
$parcel$export(module.exports, "FormContextProvider", () => $54c645ce3d157781$export$54e5bf86bd674b30);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $54c645ce3d157781$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
$54c645ce3d157781$export$c24727297075ec6a.displayName = "FormContext";
const $54c645ce3d157781$export$54e5bf86bd674b30 = (props)=>{
    // Note, can't add specific TS form values to useRef here because the form will change from page to page.
    const formikFormRef = (0, $acw62.useRef)(null);
    const [refresher, setRefresher] = (0, $acw62.useState)(0);
    const store = {
        formikFormRef: formikFormRef,
        // workaround to allow components to observe the ref changes like formikFormRef.current.dirty
        forceUpdate: ()=>setRefresher(refresher + 1)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($54c645ce3d157781$export$c24727297075ec6a.Provider, {
        value: store,
        children: props.children
    });
};

});

parcelRegister("5Opa0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a4977f0cff38e1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $765bZ = parcelRequire("765bZ");

var $4KSAX = parcelRequire("4KSAX");

var $04A9g = parcelRequire("04A9g");
const $a4a4977f0cff38e1$var$WizardFooter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const { formikFormRef: formikFormRef, forceUpdate: forceUpdate } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const currentStep = props.steps[props.currentStepNumber];
    const onClickNext = ()=>{
        formikFormRef.current?.submitForm();
        setTimeout(()=>{
            forceUpdate();
        });
    };
    const onClickBack = ()=>{
        props.goToPreviousStep();
        setTimeout(()=>{
            forceUpdate();
        });
    };
    const onClickSkip = ()=>{
        props.goToNextStep();
    };
    if (!formikFormRef.current) return null;
    const renderNextButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            action: onClickNext,
            isSubmit: true,
            isDisabled: !formikFormRef.current?.isValid || formikFormRef.current?.isSubmitting || currentStep.updateRequiredBeforeNext && !formikFormRef.current?.dirty,
            children: currentStep.nextButtonText
        });
    };
    const renderPreviousButton = ()=>{
        if (!props.steps[props.currentStepNumber - 1]) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            action: onClickBack,
            children: currentStep.previousButtonText
        });
    };
    const renderSkipButton = ()=>{
        const step = props.steps[props.currentStepNumber];
        if (!step.hasSkip || !props.steps[props.currentStepNumber + 1]) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            action: onClickSkip,
            children: t("shared:skip")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "my-2 flex justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: renderPreviousButton()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ml-auto",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    className: "mb-2",
                    buttons: [
                        renderSkipButton(),
                        renderNextButton()
                    ]
                })
            })
        ]
    });
};
var $a4a4977f0cff38e1$export$2e2bcd8739ae039 = $a4a4977f0cff38e1$var$WizardFooter;

});

parcelRegister("l5zpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd9618d6ec4c347e$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");
const $bd9618d6ec4c347e$var$WizardHeader = (props)=>{
    const { forceUpdate: forceUpdate } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const goToStep = (stepNumber, stepIsComplete)=>{
        if (stepIsComplete) props.goToStep(stepNumber);
        setTimeout(()=>{
            forceUpdate();
        });
    };
    const renderProgressLine = (step, index)=>{
        if (!props.steps[index + 1]) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1 w-full border-b", {
                "border-ch-gray-400": props.currentStepNumber <= index,
                "border-ch-purple-500": props.currentStepNumber > index
            })
        });
    };
    const renderStepLink = (step, index)=>{
        const Icon = step.icon;
        const stepIsComplete = props.currentStepNumber > index;
        const stepIsCurrent = props.currentStepNumber == index;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex justify-center items-center", {
                "flex-1": index != props.steps.length - 1
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex px-2 justify-center flex-col items-center", {
                        "text-ch-gray-500": !stepIsComplete,
                        "text-ch-purple-500": stepIsComplete || stepIsCurrent,
                        "opacity-50": stepIsComplete,
                        "cursor-pointer": stepIsComplete
                    }),
                    onClick: ()=>{
                        goToStep(index, stepIsComplete);
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-sm",
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                            className: "w-6 h-6 mb-1"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                            className: "text-xs",
                            children: step.name
                        })
                    ]
                }, `wizard-header-step-${index}`),
                renderProgressLine(step, index)
            ]
        }, index);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex flex-1 justify-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex justify-between", {
                    "flex-1": props.steps.length > 3,
                    "w-1/2": props.steps.length <= 3
                }),
                children: props.steps.map((step, index)=>{
                    return renderStepLink(step, index);
                })
            })
        })
    });
};
var $bd9618d6ec4c347e$export$2e2bcd8739ae039 = $bd9618d6ec4c347e$var$WizardHeader;

});


parcelRegister("587VS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a64aa361f45c3de$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $4qaeN = parcelRequire("4qaeN");

var $aEgqS = parcelRequire("aEgqS");

var $fPQZQ = parcelRequire("fPQZQ");

var $765bZ = parcelRequire("765bZ");

var $ahLi9 = parcelRequire("ahLi9");

var $kQILj = parcelRequire("kQILj");
parcelRequire("jitSV");
var $9IdeF = parcelRequire("9IdeF");

var $5WJZS = parcelRequire("5WJZS");

var $4XCrQ = parcelRequire("4XCrQ");

var $aeos3 = parcelRequire("aeos3");

var $b01GR = parcelRequire("b01GR");

var $5tA5l = parcelRequire("5tA5l");
const $1a64aa361f45c3de$var$PatientCheckForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef, forceUpdate: forceUpdate } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const [hasCheckedPatient, setHasCheckedPatient] = (0, $acw62.useState)(false);
    const patientNewUIState = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getPatientNewUI)(state));
    const existingPatientIds = patientNewUIState?.checkDetails?.existingPatientIds;
    const status = patientNewUIState?.checkDetails?.status;
    const dispatch = (0, $2OPjR.useDispatch)();
    const checkPatient = (patientCheckData)=>dispatch((0, $b01GR.checkPatientAction)(patientCheckData));
    const resetCheckPatient = ()=>dispatch((0, $b01GR.resetCheckPatientAction)());
    const initialDateOfBirth = new Date(props.data.dateOfBirth);
    const intialDobValues = {
        dobDay: initialDateOfBirth.getDate().toString(),
        dobMonth: (initialDateOfBirth.getMonth() + 1).toString(),
        dobYear: initialDateOfBirth.getFullYear().toString()
    };
    const initialValues = {
        lastName: props.data.lastName,
        dateOfBirth: props.data.dateOfBirth,
        careProviderId: props.data.careProviderId,
        ...props.data.dateOfBirth && intialDobValues
    };
    (0, $acw62.useEffect)(()=>{
        resetCheckPatient();
        return ()=>{
            resetCheckPatient();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const isNewPatient = status == (0, $5tA5l.PatientNewCheckDetailsStatuses).Not_Found;
        if (isNewPatient) props.goToNextStep();
    }, [
        status
    ]);
    const renderExistingPatient = ()=>{
        if (!status) return null;
        if (status == (0, $5tA5l.PatientNewCheckDetailsStatuses).Pending) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        if (!existingPatientIds?.length) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mt-10",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "flex font-semibold text-ch-blue-alt-500 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9IdeF.default), {
                            className: "w-5 h-5 mr-2"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: t("patient:checkDetails:messages:existingPatientsFound")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:checkDetails:existingPatientInfo")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    children: existingPatientIds.map((patientId)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4XCrQ.default), {
                            patientId: patientId
                        }, patientId);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w-full lg:w-2/3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "flex mb-2 font-semibold",
                        children: t("patient:checkDetails:sectionTitle")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                        className: "mb-2 list-decimal list-inside",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: "mb-2",
                                children: t("patient:checkDetails:intro1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: "mb-2",
                                children: t("patient:checkDetails:intro2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: "mb-2",
                                children: t("patient:checkDetails:intro3")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        validateOnMount: true,
                        initialValues: initialValues,
                        validationSchema: (0, $5WJZS.patientCheckValidation),
                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                            if (hasCheckedPatient) return props.goToNextStep();
                            const dateOfBirth = (0, $ahLi9.valuesToDateOfBirth)(values.dobDay, values.dobMonth, values.dobYear);
                            const data = {
                                lastName: values.lastName,
                                dateOfBirth: dateOfBirth,
                                careProviderId: values.careProviderId
                            };
                            props.setData({
                                ...props.data,
                                ...data
                            });
                            checkPatient(data);
                            setHasCheckedPatient(true);
                            setSubmitting(false);
                            forceUpdate();
                        },
                        innerRef: formikFormRef,
                        children: ({ errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                            const _handleChange = (e)=>{
                                handleChange(e);
                                resetCheckPatient();
                                setHasCheckedPatient(false);
                            };
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "lastName",
                                                required: true,
                                                children: t("patient:details:lastName")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                type: "text",
                                                name: "lastName",
                                                onChange: _handleChange,
                                                onBlur: handleBlur,
                                                value: values.lastName,
                                                autoComplete: "off"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.lastName,
                                                isVisible: errors.lastName && touched.lastName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "dateOfBirth",
                                                required: true,
                                                children: t("patient:details:dateOfBirth")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lg:flex lg:w-2/3",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lg:w-1/4 mb-2 lg:mb-0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                            name: "dobDay",
                                                            options: (0, $ahLi9.getDayOptions)(),
                                                            onChange: _handleChange,
                                                            onBlur: handleBlur,
                                                            placeholder: t("case:dateOfBirthDay")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lg:w-1/2 mb-2 lg:mb-0 lg:ml-2",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                            name: "dobMonth",
                                                            options: (0, $ahLi9.getMonthOptions)(t),
                                                            onChange: _handleChange,
                                                            onBlur: handleBlur,
                                                            placeholder: t("case:dateOfBirthMonth")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lg:w-1/4 lg:ml-2",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                            name: "dobYear",
                                                            options: (0, $ahLi9.getYearOptions)(),
                                                            onChange: _handleChange,
                                                            onBlur: handleBlur,
                                                            placeholder: t("case:dateOfBirthYear")
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.dateOfBirth,
                                                isVisible: errors.dateOfBirth && touched.dateOfBirth
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "careProviderId",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: careProviderIdLabel
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                                type: "text",
                                                name: "careProviderId",
                                                onChange: _handleChange,
                                                onBlur: handleBlur,
                                                value: values.careProviderId,
                                                autoComplete: "off"
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            renderExistingPatient()
        ]
    });
};
var $1a64aa361f45c3de$export$2e2bcd8739ae039 = $1a64aa361f45c3de$var$PatientCheckForm;

});
parcelRegister("fPQZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5fd8052f6e1943a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $765bZ = parcelRequire("765bZ");
const $e5fd8052f6e1943a$var$WizardForceUpdate = ()=>{
    const { values: values } = (0, $7YFi7.useFormikContext)();
    const { forceUpdate: forceUpdate } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            forceUpdate();
        });
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $e5fd8052f6e1943a$export$2e2bcd8739ae039 = $e5fd8052f6e1943a$var$WizardForceUpdate;

});

parcelRegister("5WJZS", function(module, exports) {

$parcel$export(module.exports, "patientCheckValidation", () => $e53ba028413abebd$export$9264343143190903);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $e53ba028413abebd$export$9264343143190903 = ()=>{
    return $hDGtv.create().shape({
        lastName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        dateOfBirth: $gcL7X.create().when([
            "dobDay",
            "dobMonth",
            "dobYear"
        ], {
            is: (dobDay, dobMonth, dobYear)=>{
                return !dobDay || !dobMonth || !dobYear;
            },
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        })
    });
};

});

parcelRegister("b01GR", function(module, exports) {

$parcel$export(module.exports, "checkPatientAction", () => $b1085f429d782047$export$345d22b226e86ab0);
$parcel$export(module.exports, "resetCheckPatientAction", () => $b1085f429d782047$export$81431e2a5252dab3);
$parcel$export(module.exports, "createPatientAction", () => $b1085f429d782047$export$87889284ec7ad718);

var $5tA5l = parcelRequire("5tA5l");
const $b1085f429d782047$export$345d22b226e86ab0 = (patientCheckData)=>{
    return {
        type: (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_PENDING,
        payload: {
            patientCheckData: patientCheckData
        }
    };
};
const $b1085f429d782047$export$81431e2a5252dab3 = ()=>{
    return {
        type: (0, $5tA5l.PatientNewActionTypes).CHECK_PATIENT_ASYNC_RESET
    };
};
const $b1085f429d782047$export$87889284ec7ad718 = (patient)=>{
    return {
        type: (0, $5tA5l.PatientNewActionTypes).CREATE_PATIENT_ASYNC_PENDING,
        payload: {
            patient: patient
        }
    };
};

});


parcelRegister("9BK0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c3944f8bfe2f9c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $c0FI2 = parcelRequire("c0FI2");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $765bZ = parcelRequire("765bZ");

var $ahLi9 = parcelRequire("ahLi9");

var $el6QJ = parcelRequire("el6QJ");

var $aeos3 = parcelRequire("aeos3");

var $eMEgj = parcelRequire("eMEgj");

var $4qaeN = parcelRequire("4qaeN");

var $fPQZQ = parcelRequire("fPQZQ");
const $88c3944f8bfe2f9c$var$PatientDetailsForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel, healthcareIdRequired: healthcareIdRequired, careProviderIdRequired: careProviderIdRequired } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const getGenderOptions = ()=>{
        return Object.keys((0, $el6QJ.PatientGenders)).map((key)=>{
            const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $el6QJ.PatientGenders)[key]);
            return {
                value: (0, $el6QJ.PatientGenders)[key],
                label: t(`shared:${translationKey}`)
            };
        });
    };
    const getTitleOptions = ()=>{
        return Object.keys((0, $el6QJ.PatientTitles)).map((key)=>{
            const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $el6QJ.PatientTitles)[key]);
            return {
                value: (0, $el6QJ.PatientTitles)[key],
                label: t(`shared:${translationKey}`)
            };
        });
    };
    const initialDateOfBirth = new Date(props.data.dateOfBirth);
    const initialValues = {
        isHealthcareIdRequired: healthcareIdRequired,
        isCareProviderIdRequired: careProviderIdRequired,
        title: props.data.title,
        firstName: props.data.firstName,
        lastName: props.data.lastName,
        dateOfBirth: initialDateOfBirth,
        gender: props.data.gender,
        healthcareId: props.data.healthcareId,
        careProviderId: props.data.careProviderId,
        dobDay: initialDateOfBirth.getDate().toString(),
        dobMonth: (initialDateOfBirth.getMonth() + 1).toString(),
        dobYear: initialDateOfBirth.getFullYear().toString()
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full lg:w-2/3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:details:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:details:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    validateOnMount: true,
                    initialValues: initialValues,
                    validationSchema: (0, $eMEgj.patientDetailsValidation),
                    validateOnChange: true,
                    onSubmit: (values, { setSubmitting: setSubmitting })=>{
                        const dateOfBirth = (0, $ahLi9.valuesToDateOfBirth)(values.dobDay, values.dobMonth, values.dobYear);
                        const data = {
                            title: values.title,
                            firstName: values.firstName,
                            lastName: values.lastName,
                            dateOfBirth: dateOfBirth,
                            gender: values.gender,
                            healthcareId: values.healthcareId,
                            careProviderId: values.careProviderId
                        };
                        props.setData({
                            ...props.data,
                            ...data
                        });
                        setSubmitting(false);
                        props.goToNextStep();
                    },
                    innerRef: formikFormRef,
                    children: ({ errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur })=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2 lg:w-1/4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "title",
                                            required: true,
                                            children: t("patient:details:title")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "title",
                                            options: getTitleOptions(),
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.title,
                                            isVisible: errors.title && touched.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "lastName",
                                            required: true,
                                            children: t("patient:details:lastName")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "lastName",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.lastName,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.lastName,
                                            isVisible: errors.lastName && touched.lastName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "firstName",
                                            required: true,
                                            children: t("patient:details:firstName")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "firstName",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.firstName,
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.firstName,
                                            isVisible: errors.firstName && touched.firstName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "dateOfBirth",
                                            required: true,
                                            children: t("patient:details:dateOfBirth")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lg:flex lg:w-2/3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "lg:w-1/4 mb-2 lg:mb-0",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                        name: "dobDay",
                                                        options: (0, $ahLi9.getDayOptions)(),
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        placeholder: t("case:dateOfBirthDay")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "lg:w-1/2 mb-2 lg:mb-0 lg:ml-2",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                        name: "dobMonth",
                                                        options: (0, $ahLi9.getMonthOptions)(t),
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        placeholder: t("case:dateOfBirthMonth")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "lg:w-1/4 lg:ml-2",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                        name: "dobYear",
                                                        options: (0, $ahLi9.getYearOptions)(),
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        placeholder: t("case:dateOfBirthYear")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.dateOfBirth,
                                            isVisible: errors.dateOfBirth && touched.dateOfBirth
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-4 lg:w-1/3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "gender",
                                            required: true,
                                            children: t("patient:details:gender")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                            name: "gender",
                                            options: getGenderOptions(),
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.gender,
                                            isVisible: errors.gender && touched.gender
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "mb-2 text-lg font-semibold",
                                    children: t("patient:details:identifiersTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "healthcareId",
                                            required: healthcareIdRequired,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: healthcareIdLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "healthcareId",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.healthcareId
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.healthcareId,
                                            isVisible: errors.healthcareId && touched.healthcareId
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "careProviderId",
                                            required: careProviderIdRequired,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: careProviderIdLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                            type: "text",
                                            name: "careProviderId",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.careProviderId
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                            errorMessage: errors.careProviderId,
                                            isVisible: errors.careProviderId && touched.careProviderId
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
};
var $88c3944f8bfe2f9c$export$2e2bcd8739ae039 = $88c3944f8bfe2f9c$var$PatientDetailsForm;

});
parcelRegister("eMEgj", function(module, exports) {

$parcel$export(module.exports, "patientDetailsValidation", () => $c8cde5c9b72d0767$export$50611445ceb8468c);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $c8cde5c9b72d0767$export$50611445ceb8468c = ()=>{
    return $hDGtv.create().shape({
        title: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        firstName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        lastName: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        dateOfBirth: $gcL7X.create().when([
            "dobDay",
            "dobMonth",
            "dobYear"
        ], {
            is: (dobDay, dobMonth, dobYear)=>{
                return !dobDay || !dobMonth || !dobYear;
            },
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }),
        gender: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        healthcareId: $gcL7X.create().when([
            "isHealthcareIdRequired"
        ], {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
            otherwise: $gcL7X.create().trim().nullable()
        }).max(20, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 20
        })),
        careProviderId: $gcL7X.create().nullable().when([
            "isCareProviderIdRequired"
        ], {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
            otherwise: $gcL7X.create().trim().nullable()
        }).trim().max(20, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 20
        }))
    });
};

});


parcelRegister("ecRMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $80d749f3d83442ab$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $c0FI2 = parcelRequire("c0FI2");

var $765bZ = parcelRequire("765bZ");

var $6PVlc = parcelRequire("6PVlc");

var $1AdpV = parcelRequire("1AdpV");

var $4qaeN = parcelRequire("4qaeN");

var $COwA0 = parcelRequire("COwA0");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hsbMJ = parcelRequire("hsbMJ");

var $fPQZQ = parcelRequire("fPQZQ");
const $80d749f3d83442ab$var$FurtherDetailsForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const initialValues = {
        id: patient?.furtherDetails?.id,
        postcode: props.data.furtherDetailsAttributes.postcode || "",
        addressLine1: props.data.furtherDetailsAttributes.addressLine1 || "",
        addressLine2: props.data.furtherDetailsAttributes.addressLine2 || "",
        city: props.data.furtherDetailsAttributes.city || "",
        county: props.data.furtherDetailsAttributes.county || "",
        country: props.data.furtherDetailsAttributes.country || "",
        email: props.data.furtherDetailsAttributes.email || "",
        phoneNumber: props.data.furtherDetailsAttributes.phoneNumber || "",
        phoneNumberAlt: props.data.furtherDetailsAttributes.phoneNumberAlt || "",
        gpPostcode: props.data.furtherDetailsAttributes.gpPostcode || "",
        gpPracticeName: props.data.furtherDetailsAttributes.gpPracticeName || "",
        gpAddressLine1: props.data.furtherDetailsAttributes.gpAddressLine1 || "",
        gpAddressLine2: props.data.furtherDetailsAttributes.gpAddressLine2 || "",
        gpCity: props.data.furtherDetailsAttributes.gpCity || "",
        gpCounty: props.data.furtherDetailsAttributes.gpCounty || "",
        gpCountry: props.data.furtherDetailsAttributes.gpCountry || "",
        gpEmail: props.data.furtherDetailsAttributes.gpEmail || "",
        gpPhoneNumber: props.data.furtherDetailsAttributes.gpPhoneNumber || "",
        gpName: props.data.furtherDetailsAttributes.gpName || ""
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full lg:w-2/3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:furtherDetails:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:furtherDetails:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    validateOnMount: true,
                    initialValues: initialValues,
                    onSubmit: (values, { setSubmitting: setSubmitting })=>{
                        const data = {
                            id: patient?.furtherDetails?.id,
                            postcode: values.postcode.toUpperCase(),
                            addressLine1: values.addressLine1,
                            addressLine2: values.addressLine2,
                            city: values.city,
                            county: values.county,
                            country: values.country,
                            email: values.email,
                            phoneNumber: values.phoneNumber,
                            phoneNumberAlt: values.phoneNumberAlt,
                            gpPostcode: values.gpPostcode.toUpperCase(),
                            gpPracticeName: values.gpPracticeName,
                            gpAddressLine1: values.gpAddressLine1,
                            gpAddressLine2: values.gpAddressLine2,
                            gpCity: values.gpCity,
                            gpCounty: values.gpCounty,
                            gpCountry: values.gpCountry,
                            gpEmail: values.gpEmail,
                            gpPhoneNumber: values.gpPhoneNumber,
                            gpName: values.gpName
                        };
                        props.setData({
                            ...props.data,
                            furtherDetailsAttributes: data
                        });
                        setSubmitting(false);
                        props.goToNextStep();
                    },
                    innerRef: formikFormRef,
                    children: ()=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "border-b-2 border-ch-gray-400 pb-5 mb-5",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "flex mb-2 font-semibold",
                                            children: t("patient:furtherDetails:patientSectionTitle")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6PVlc.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "flex mb-2 font-semibold",
                                            children: t("patient:furtherDetails:gPSectionTitle")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1AdpV.default), {})
                                    ]
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
};
var $80d749f3d83442ab$export$2e2bcd8739ae039 = $80d749f3d83442ab$var$FurtherDetailsForm;

});
parcelRegister("6PVlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1c51b21e60eb5f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $kaNcw = parcelRequire("kaNcw");
const $7d1c51b21e60eb5f$var$PatientFields = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { values: values, errors: errors, touched: touched, handleBlur: handleBlur, handleChange: handleChange } = (0, $7YFi7.useFormikContext)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kaNcw.default), {
                handleChange: handleChange,
                fieldNames: {
                    postcode: "postcode",
                    addressLine1: "addressLine1",
                    addressLine2: "addressLine2",
                    city: "city",
                    county: "county",
                    country: "country"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "addressLine1",
                        children: t("patient:details:furtherDetails:addressLine1")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "addressLine1",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.addressLine1,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.addressLine1,
                        isVisible: errors.addressLine1 && touched.addressLine1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "addressLine2",
                        children: t("patient:details:furtherDetails:addressLine2")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "addressLine2",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.addressLine2,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.addressLine2,
                        isVisible: errors.addressLine2 && touched.addressLine2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "city",
                        children: t("patient:details:furtherDetails:city")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "city",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.city,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.city,
                        isVisible: errors.city && touched.city
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "county",
                        children: t("patient:details:furtherDetails:county")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "county",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.county,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.county,
                        isVisible: errors.county && touched.county
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "country",
                        children: t("patient:details:furtherDetails:country")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "country",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.country,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.country,
                        isVisible: errors.country && touched.country
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "email",
                        children: t("patient:details:furtherDetails:email")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "email",
                        name: "email",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.email,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.email,
                        isVisible: errors.email && touched.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "phoneNumber",
                        children: t("patient:details:furtherDetails:phoneNumber")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "tel",
                        name: "phoneNumber",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.phoneNumber,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.phoneNumber,
                        isVisible: errors.phoneNumber && touched.phoneNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "phoneNumberAlt",
                        children: t("patient:details:furtherDetails:phoneNumberAlt")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "tel",
                        name: "phoneNumberAlt",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.phoneNumberAlt,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.phoneNumberAlt,
                        isVisible: errors.phoneNumberAlt && touched.phoneNumberAlt
                    })
                ]
            })
        ]
    });
};
var $7d1c51b21e60eb5f$export$2e2bcd8739ae039 = $7d1c51b21e60eb5f$var$PatientFields;

});
parcelRegister("kaNcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9471f8a40524c7$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $5GZlj = parcelRequire("5GZlj");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");
const $cc9471f8a40524c7$var$PostcodeLookup = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const { values: values, errors: errors, touched: touched, handleBlur: handleBlur, setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const [lookupResult, setLookupResult] = (0, $acw62.useState)(null);
    const [resultOptions, setResultOptions] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!lookupResult) return;
        const formattedOptions = lookupResult.map((address, index)=>{
            const label = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject(Object.values(address), (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty).join(", ");
            return {
                value: index.toString(),
                label: label
            };
        });
        setResultOptions(formattedOptions);
    }, [
        lookupResult
    ]);
    const onClickLookup = async ()=>{
        const postcode = values[props.fieldNames.postcode];
        await (0, $5s7Tw.default).get(`/address?postcode=${postcode}`, (0, $1zizz.withAuthHeader)()).then((response)=>{
            const addresses = response.data.addresses;
            setLookupResult(addresses);
        }).catch((_error)=>{
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "noAddressesFound",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        });
    };
    const onSelectAddress = (e)=>{
        const selectedResult = lookupResult[e.currentTarget.value];
        for (const [key, value] of Object.entries(selectedResult)){
            const fieldName = props.fieldNames[key];
            if (fieldName) setFieldValue(fieldName, value);
        }
        props.handleChange(e);
    };
    const renderResultSelect = ()=>{
        if (!resultOptions) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-2 lg:w-1/2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                placeholder: t("shared:selectAddress"),
                name: `${props.fieldNames.postcode}Address`,
                options: resultOptions,
                onChange: onSelectAddress,
                onBlur: handleBlur
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: props.fieldNames.postcode,
                        children: t("shared:postcode")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex flex-1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: props.fieldNames.postcode,
                                    onChange: props.handleChange,
                                    onBlur: handleBlur,
                                    value: values[props.fieldNames.postcode],
                                    autoComplete: "off"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                variant: (0, $jF0Xa.StyleVariants).BLUE,
                                className: "ml-2",
                                action: onClickLookup,
                                children: t("shared:lookUp")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors[props.fieldNames.postcode],
                        isVisible: errors[props.fieldNames.postcode] && touched[props.fieldNames.postcode]
                    })
                ]
            }),
            renderResultSelect()
        ]
    });
};
var $cc9471f8a40524c7$export$2e2bcd8739ae039 = $cc9471f8a40524c7$var$PostcodeLookup;

});


parcelRegister("1AdpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $50adce3daca87f53$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $kaNcw = parcelRequire("kaNcw");
const $50adce3daca87f53$var$GPFields = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { values: values, errors: errors, touched: touched, handleBlur: handleBlur, handleChange: handleChange } = (0, $7YFi7.useFormikContext)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kaNcw.default), {
                        handleChange: handleChange,
                        fieldNames: {
                            postcode: "gpPostcode",
                            addressLine1: "gpAddressLine1",
                            addressLine2: "gpAddressLine2",
                            city: "gpCity",
                            county: "gpCounty",
                            country: "gpCountry"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpAddressLine1",
                        children: t("patient:details:furtherDetails:gpAddressLine1")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "gpAddressLine1",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpAddressLine1,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpAddressLine1,
                        isVisible: errors.gpAddressLine1 && touched.gpAddressLine1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpAddressLine2",
                        children: t("patient:details:furtherDetails:gpAddressLine2")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "gpAddressLine2",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpAddressLine2,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpAddressLine2,
                        isVisible: errors.gpAddressLine2 && touched.gpAddressLine2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpCity",
                        children: t("patient:details:furtherDetails:gpCity")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "gpCity",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpCity,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpCity,
                        isVisible: errors.gpCity && touched.gpCity
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpCounty",
                        children: t("patient:details:furtherDetails:gpCounty")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "gpCounty",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpCounty,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpCounty,
                        isVisible: errors.gpCounty && touched.gpCounty
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpCountry",
                        children: t("patient:details:furtherDetails:gpCountry")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "gpCountry",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpCountry,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpCountry,
                        isVisible: errors.gpCountry && touched.gpCountry
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpEmail",
                        children: t("patient:details:furtherDetails:gpEmail")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "email",
                        name: "gpEmail",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpEmail,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpEmail,
                        isVisible: errors.gpEmail && touched.gpEmail
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpPhoneNumber",
                        children: t("patient:details:furtherDetails:gpPhoneNumber")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "tel",
                        name: "gpPhoneNumber",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpPhoneNumber,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpPhoneNumber,
                        isVisible: errors.gpPhoneNumber && touched.gpPhoneNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "gpName",
                        children: t("patient:details:furtherDetails:gpName")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "tel",
                        name: "gpName",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.gpName,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.gpName,
                        isVisible: errors.gpName && touched.gpName
                    })
                ]
            })
        ]
    });
};
var $50adce3daca87f53$export$2e2bcd8739ae039 = $50adce3daca87f53$var$GPFields;

});


parcelRegister("3juol", function(module, exports) {

$parcel$export(module.exports, "default", () => $4398337730c0aa93$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $c0FI2 = parcelRequire("c0FI2");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");

var $ctTE5 = parcelRequire("ctTE5");

var $5MDFc = parcelRequire("5MDFc");

var $7ZQlN = parcelRequire("7ZQlN");

var $aeos3 = parcelRequire("aeos3");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $8UrgM = parcelRequire("8UrgM");

var $4MHRb = parcelRequire("4MHRb");

var $fPQZQ = parcelRequire("fPQZQ");

var $bS3zB = parcelRequire("bS3zB");
const $4398337730c0aa93$var$CaseDetailsForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient",
        "case"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { signedOffByRequired: signedOffByRequired } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const initialValues = {
        caseType: "",
        caseClassificationId: "",
        leadCareUserId: "",
        signedOffBy: "",
        targetDate: undefined,
        isSignedOffByRequired: signedOffByRequired
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
        dispatch((0, $bS3zB.fetchCaseSourcesAction)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:caseDetails:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:caseDetails:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "mb-3 list-disc list-inside",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: t("patient:caseDetails:instructions1")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: t("patient:caseDetails:instructions2")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctTE5.default), {
                    data: props.data
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full lg:w-2/3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        validateOnMount: true,
                        initialValues: initialValues,
                        validationSchema: (0, $7ZQlN.caseNewValidationSchema),
                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                            const data = {
                                caseType: values.caseType,
                                caseClassificationId: values.caseClassificationId,
                                leadCareUserId: values.leadCareUserId,
                                signedOffBy: values.signedOffBy,
                                targetDate: values.targetDate,
                                sourceId: values.sourceId
                            };
                            props.setData({
                                ...props.data,
                                casesAttributes: [
                                    data
                                ]
                            });
                            setSubmitting(false);
                            props.goToNextStep();
                        },
                        innerRef: formikFormRef,
                        children: ()=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MDFc.default), {})
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $4398337730c0aa93$export$2e2bcd8739ae039 = $4398337730c0aa93$var$CaseDetailsForm;

});
parcelRegister("ctTE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe6609534e014f6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $eEYoR = parcelRequire("eEYoR");
const $fbe6609534e014f6$var$PatientDetailsFormCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const renderName = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: props.data.firstName,
                    lastName: props.data.lastName,
                    title: props.data.title
                })
            })
        });
    };
    const renderGender = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.data.gender);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:gender"),
                ": ",
                t(`shared:${translationKey}`)
            ]
        });
    };
    const renderDateOfBirth = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:dateOfBirth"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                    utcTime: props.data.dateOfBirth
                })
            ]
        });
    };
    const renderHealthcareId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                healthcareIdLabel,
                ": ",
                props.data.healthcareId || "-"
            ]
        });
    };
    const renderCareProviderId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                careProviderIdLabel,
                ": ",
                props.data.careProviderId || "-"
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:patient")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 lg:grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderName(),
                                renderGender(),
                                renderDateOfBirth()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderHealthcareId(),
                                renderCareProviderId()
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $fbe6609534e014f6$export$2e2bcd8739ae039 = $fbe6609534e014f6$var$PatientDetailsFormCard;

});

parcelRegister("5MDFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e1a5fdc80911a8$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $6qYxq = parcelRequire("6qYxq");

var $5GZlj = parcelRequire("5GZlj");

var $d8Vwn = parcelRequire("d8Vwn");

var $aeos3 = parcelRequire("aeos3");

var $jRidO = parcelRequire("jRidO");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $jxnLW = parcelRequire("jxnLW");

var $6wDTk = parcelRequire("6wDTk");

var $7Pvlf = parcelRequire("7Pvlf");
const $f6e1a5fdc80911a8$var$CaseFields = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient",
        "case"
    ]);
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [caseClassificationOptions, setCaseClassificationOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [caseSourceOptions, setCaseSourceOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const { signedOffByRequired: signedOffByRequired } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllInternalActiveUsersSorted)(state));
    const caseClassifications = (0, $iD0SF.useSelector)((0, $jxnLW.getAllCaseClassifications));
    const caseSources = (0, $iD0SF.useSelector)((0, $7Pvlf.getAllCaseSources));
    const { values: values, errors: errors, touched: touched, handleBlur: handleBlur, handleChange: handleChange, setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const caseTypeOptions = Object.keys((0, $6qYxq.CaseTypes)).map((key)=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize((0, $6qYxq.CaseTypes)[key]);
        return {
            value: (0, $6qYxq.CaseTypes)[key],
            label: t(`case:${translationKey}`)
        };
    });
    const setCaseClassificationOptionsForCaseType = (caseType)=>{
        const options = (0, $d8Vwn.generateCaseClassificationOptions)(caseClassifications, caseType);
        setCaseClassificationOptions(options);
    };
    const onChangeCaseType = (e)=>{
        setCaseClassificationOptionsForCaseType(e.currentTarget.value);
        setFieldValue("caseClassificationId", "");
        setFieldValue("leadCareUserId", "");
        handleChange(e);
    };
    const onChangeClassification = (e)=>{
        setFieldValue("leadCareUserId", "");
        handleChange(e);
    };
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(users));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        setCaseClassificationOptionsForCaseType(values.caseType);
    }, [
        caseClassifications
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateCaseSourceOptions)(caseSources);
        setCaseSourceOptions(options);
    }, [
        caseSources
    ]);
    const renderSignedOffByField = ()=>{
        if (!signedOffByRequired) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "signedOffBy",
                    required: signedOffByRequired,
                    children: t("patient:caseDetails:details:signedOffBy")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                    type: "text",
                    name: "signedOffBy",
                    onChange: handleChange,
                    onBlur: handleBlur,
                    value: values.signedOffBy,
                    autoComplete: "off",
                    autoFocus: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: errors.signedOffBy,
                    isVisible: errors.signedOffBy && touched.signedOffBy
                })
            ]
        });
    };
    const renderTargetDateField = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "targetDate",
                    children: t("patient:caseDetails:details:targetDate")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jRidO.default), {
                    name: "targetDate"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: errors.targetDate,
                    isVisible: errors.targetDate && touched.targetDate
                })
            ]
        });
    };
    const renderSourceField = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "source",
                    required: true,
                    children: t("case:source")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                    name: "sourceId",
                    options: caseSourceOptions,
                    isGrouped: true,
                    onBlur: handleBlur,
                    onChange: handleChange
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                    errorMessage: errors.sourceId,
                    isVisible: errors.sourceId && touched.sourceId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "md:flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-2 md:w-1/3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "caseType",
                                required: true,
                                children: t("patient:caseDetails:details:caseType")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                name: "caseType",
                                onChange: onChangeCaseType,
                                onBlur: handleBlur,
                                options: caseTypeOptions,
                                placeholder: t("patient:caseDetails:chooseCaseType")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.caseType,
                                isVisible: errors.caseType && touched.caseType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-1 mb-2 md:ml-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                name: "caseClassificationId",
                                required: true,
                                children: t("patient:caseDetails:details:classification")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                name: "caseClassificationId",
                                options: caseClassificationOptions,
                                isDisabled: !values.caseType,
                                isGrouped: true,
                                onChange: onChangeClassification,
                                onBlur: handleBlur
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: errors.caseClassificationId,
                                isVisible: errors.caseClassificationId && touched.caseClassificationId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "leadCareUserId",
                        required: true,
                        children: t("case:leadCare")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "leadCareUserId",
                        options: userOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.leadCareUserId,
                        isVisible: errors.leadCareUserId && touched.leadCareUserId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "md:flex ",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "md:flex flex-wrap md:w-1/3",
                        children: renderTargetDateField()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "md:w-2/3",
                        children: renderSourceField()
                    })
                ]
            }),
            renderSignedOffByField()
        ]
    });
};
var $f6e1a5fdc80911a8$export$2e2bcd8739ae039 = $f6e1a5fdc80911a8$var$CaseFields;

});

parcelRegister("7ZQlN", function(module, exports) {

$parcel$export(module.exports, "caseNewValidationSchema", () => $8cf3101354a8cbc0$export$6938d56e1c2c39d2);
parcelRequire("cxhNX");
var $bNQHE = parcelRequire("bNQHE");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $8cf3101354a8cbc0$export$6938d56e1c2c39d2 = ()=>{
    return $hDGtv.create().shape({
        isNewPatient: $bNQHE.create(),
        caseType: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        caseClassificationId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        leadCareUserId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        sourceId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        patientId: $gcL7X.create().when("isNewPatient", {
            is: false,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }),
        title: $gcL7X.create().trim().when("isNewPatient", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }),
        firstName: $gcL7X.create().when("isNewPatient", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        lastName: $gcL7X.create().when("isNewPatient", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        dateOfBirth: $gcL7X.create().when([
            "isNewPatient",
            "dobDay",
            "dobMonth",
            "dobYear"
        ], {
            is: (isNewPatient, dobDay, dobMonth, dobYear)=>{
                return isNewPatient == true && (!dobDay || !dobMonth || !dobYear);
            },
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }),
        healthcareId: $gcL7X.create().when([
            "isNewPatient",
            "isHealthcareIdRequired"
        ], {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(20, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 20
        })),
        careProviderId: $gcL7X.create().when([
            "isNewPatient",
            "isCareProviderIdRequired"
        ], {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(20, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 20
        })),
        signedOffBy: $gcL7X.create().when("isSignedOffByRequired", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        }).trim().max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        }))
    });
};

});


parcelRegister("ksknn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c98fb24a90027f45$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $ctTE5 = parcelRequire("ctTE5");

var $b01GR = parcelRequire("b01GR");

var $dp7TY = parcelRequire("dp7TY");

var $bHWav = parcelRequire("bHWav");

var $8UrgM = parcelRequire("8UrgM");

var $4MHRb = parcelRequire("4MHRb");

var $bS3zB = parcelRequire("bS3zB");

var $1qvB8 = parcelRequire("1qvB8");
const $c98fb24a90027f45$var$ReviewAndSaveForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
        dispatch((0, $bS3zB.fetchCaseSourcesAction)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:reviewAndSave:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:reviewAndSave:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        validateOnMount: true,
                        initialValues: props.data,
                        onSubmit: (_values, { setSubmitting: setSubmitting })=>{
                            const data = props.data;
                            dispatch((0, $b01GR.createPatientAction)(data));
                            setSubmitting(false);
                        },
                        innerRef: formikFormRef,
                        children: ({ submitCount: submitCount })=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1qvB8.default), {
                                        isEnabled: submitCount < 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:details:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctTE5.default), {
                                        data: props.data
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:furtherDetails:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dp7TY.default), {
                                        data: props.data
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:caseDetails:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHWav.default), {
                                        data: props.data
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $c98fb24a90027f45$export$2e2bcd8739ae039 = $c98fb24a90027f45$var$ReviewAndSaveForm;

});
parcelRegister("dp7TY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0898ac02b0cd14$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $4qaeN = parcelRequire("4qaeN");
const $ac0898ac02b0cd14$var$FurtherDetailsFormCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const renderPatientAddress = ()=>{
        if (!props.data.furtherDetailsAttributes.addressLine1) return null;
        const fullAddress = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject([
            props.data.furtherDetailsAttributes.addressLine1,
            props.data.furtherDetailsAttributes.addressLine2,
            props.data.furtherDetailsAttributes.city,
            props.data.furtherDetailsAttributes.county,
            props.data.furtherDetailsAttributes.country
        ], (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty).join(", ");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:address"),
                ": ",
                fullAddress
            ]
        });
    };
    const renderGPAddress = ()=>{
        if (!props.data.furtherDetailsAttributes.gpAddressLine1) return null;
        const fullAddress = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject([
            props.data.furtherDetailsAttributes.gpAddressLine1,
            props.data.furtherDetailsAttributes.gpAddressLine2,
            props.data.furtherDetailsAttributes.gpCity,
            props.data.furtherDetailsAttributes.gpCounty,
            props.data.furtherDetailsAttributes.gpCountry
        ], (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEmpty).join(", ");
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t("patient:details:furtherDetails:gpAddress"),
                ": ",
                fullAddress
            ]
        });
    };
    const renderDetail = (name)=>{
        const detail = props.data.furtherDetailsAttributes[name];
        if (!detail) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("dd", {
            children: [
                t(`patient:details:furtherDetails:${name}`),
                ": ",
                detail
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
            className: "flex-col",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 lg:grid grid-cols-2 gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "font-semibold",
                                    children: t("patient:furtherDetails:patientSectionTitle")
                                })
                            }),
                            renderPatientAddress(),
                            renderDetail("postcode"),
                            renderDetail("email"),
                            renderDetail("phoneNumber"),
                            renderDetail("phoneNumberAlt")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("dl", {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "font-semibold",
                                    children: t("patient:furtherDetails:gPSectionTitle")
                                })
                            }),
                            renderDetail("gpName"),
                            renderGPAddress(),
                            renderDetail("gpPostcode"),
                            renderDetail("gpEmail"),
                            renderDetail("gpPhoneNumber")
                        ]
                    })
                ]
            })
        })
    });
};
var $ac0898ac02b0cd14$export$2e2bcd8739ae039 = $ac0898ac02b0cd14$var$FurtherDetailsFormCard;

});

parcelRegister("bHWav", function(module, exports) {

$parcel$export(module.exports, "default", () => $624b91b9f2981579$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $6t04b = parcelRequire("6t04b");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $eUISl = parcelRequire("eUISl");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $QwmFv = parcelRequire("QwmFv");

var $jxnLW = parcelRequire("jxnLW");

var $7Pvlf = parcelRequire("7Pvlf");
const $624b91b9f2981579$var$CaseFormCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, props.data.casesAttributes[0].leadCareUserId));
    const caseClassificiation = (0, $iD0SF.useSelector)((state)=>(0, $jxnLW.getCaseClassificationById)(state, props.data.casesAttributes[0].caseClassificationId));
    const caseSource = (0, $iD0SF.useSelector)((state)=>(0, $7Pvlf.getCaseSourceById)(state, props.data.casesAttributes[0].sourceId));
    const renderCaseType = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:type"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                    caseType: props.data.casesAttributes[0].caseType
                })
            ]
        });
    };
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    const renderClassification = ()=>{
        if (!caseClassificiation) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": ",
                caseClassificiation.name
            ]
        });
    };
    const renderTargetDate = ()=>{
        const targetDate = props.data.casesAttributes[0].targetDate;
        if (!targetDate) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:targetDate"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:targetDate"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                    utcTime: targetDate
                })
            ]
        });
    };
    const renderSource = ()=>{
        if (!caseSource) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:source"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:source"),
                ": ",
                caseSource.name
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:case")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 lg:grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderLeadCare(),
                                renderClassification(),
                                renderCaseType()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderTargetDate(),
                                renderSource()
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $624b91b9f2981579$export$2e2bcd8739ae039 = $624b91b9f2981579$var$CaseFormCard;

});



parcelRegister("k0GJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92694921d1235a56$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $1HjJZ = parcelRequire("1HjJZ");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $6Hpf8 = parcelRequire("6Hpf8");

var $COwA0 = parcelRequire("COwA0");

var $hsbMJ = parcelRequire("hsbMJ");

var $caw88 = parcelRequire("caw88");

var $4xkOv = parcelRequire("4xkOv");

var $6D7zk = parcelRequire("6D7zk");
const $92694921d1235a56$var$PatientCaseNewPage = (_props)=>{
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const [patientCaseNewData, setPatientCaseNewData] = (0, $acw62.useState)({
        casesAttributes: [
            {
                caseType: "",
                caseClassificationId: "",
                leadCareUserId: "",
                signedOffBy: "",
                targetDate: "",
                sourceId: ""
            }
        ]
    });
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $caw88.fetchPatientAsync)(patientId));
    }, []);
    const patientUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).PATIENT, {
        patientId: patientId
    });
    const renderWizard = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1HjJZ.default), {
            data: patientCaseNewData,
            setData: setPatientCaseNewData,
            steps: [
                {
                    name: t("patient:caseDetails:sectionTitle"),
                    icon: (0, $6Hpf8.default),
                    component: (0, $4xkOv.default),
                    nextButtonText: t("patient:caseDetails:buttons:createCase")
                },
                {
                    name: t("patient:reviewAndSave:sectionTitle"),
                    icon: (0, $4o7Oq.default),
                    component: (0, $6D7zk.default),
                    nextButtonText: t("patient:reviewAndSave:buttons:savePatient"),
                    previousButtonText: t("shared:previous")
                }
            ]
        });
    };
    const renderContent = ()=>{
        if (!patient) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("patient:messages:patientNotFound")
        });
        return renderWizard();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:patient"),
                        href: patientUrl
                    },
                    {
                        pageTitle: t("patient:caseDetails:sectionTitle")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $92694921d1235a56$export$2e2bcd8739ae039 = $92694921d1235a56$var$PatientCaseNewPage;

});
parcelRegister("4xkOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f138b1ac17d89ce$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $c0FI2 = parcelRequire("c0FI2");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");

var $7ZQlN = parcelRequire("7ZQlN");

var $aeos3 = parcelRequire("aeos3");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $8UrgM = parcelRequire("8UrgM");

var $4MHRb = parcelRequire("4MHRb");

var $5MDFc = parcelRequire("5MDFc");

var $khUOM = parcelRequire("khUOM");

var $COwA0 = parcelRequire("COwA0");

var $fPQZQ = parcelRequire("fPQZQ");

var $bS3zB = parcelRequire("bS3zB");

var $kYqkq = parcelRequire("kYqkq");

var $7Pvlf = parcelRequire("7Pvlf");
const $7f138b1ac17d89ce$var$CaseDetailsForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient",
        "case"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { signedOffByRequired: signedOffByRequired } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const caseSourceIds = (0, $kYqkq.useAppSelector)((0, $7Pvlf.getAllCaseSourceIds));
    const initialCaseSourceId = caseSourceIds.length == 1 ? caseSourceIds[0] : "";
    const initialValues = {
        caseType: "",
        caseClassificationId: "",
        leadCareUserId: "",
        signedOffBy: "",
        targetDate: undefined,
        isSignedOffByRequired: signedOffByRequired,
        sourceId: initialCaseSourceId
    };
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
        dispatch((0, $bS3zB.fetchCaseSourcesAction)());
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:caseDetails:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:caseDetails:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:caseDetails:createCaseInstructions")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $khUOM.default), {
                    patientId: patientId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full lg:w-2/3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        validateOnMount: true,
                        initialValues: initialValues,
                        enableReinitialize: true,
                        validationSchema: (0, $7ZQlN.caseNewValidationSchema),
                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                            const data = {
                                caseType: values.caseType,
                                caseClassificationId: values.caseClassificationId,
                                leadCareUserId: values.leadCareUserId,
                                signedOffBy: values.signedOffBy,
                                targetDate: values.targetDate,
                                sourceId: values.sourceId
                            };
                            props.setData({
                                ...props.data,
                                casesAttributes: [
                                    data
                                ]
                            });
                            setSubmitting(false);
                            props.goToNextStep();
                        },
                        innerRef: formikFormRef,
                        children: ()=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MDFc.default), {})
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $7f138b1ac17d89ce$export$2e2bcd8739ae039 = $7f138b1ac17d89ce$var$CaseDetailsForm;

});
parcelRegister("khUOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33de6083581054a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $6t04b = parcelRequire("6t04b");

var $j2STh = parcelRequire("j2STh");

var $aeos3 = parcelRequire("aeos3");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $eEYoR = parcelRequire("eEYoR");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $caw88 = parcelRequire("caw88");

var $hsbMJ = parcelRequire("hsbMJ");

var $g91zf = parcelRequire("g91zf");

var $wz5EJ = parcelRequire("wz5EJ");
const $f33de6083581054a$var$PatientWithCasesDetailsCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $caw88.fetchPatientAsync)(props.patientId));
    }, []);
    const renderName = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "font-semibold",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: patient.firstName,
                    lastName: patient.lastName,
                    title: patient.title
                })
            })
        });
    };
    const renderGender = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(patient.gender);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:gender"),
                ": ",
                t(`shared:${translationKey}`)
            ]
        });
    };
    const renderDateOfBirth = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:details:dateOfBirth"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j2STh.default), {
                    utcTime: patient.dateOfBirth
                })
            ]
        });
    };
    const renderHealthcareId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                healthcareIdLabel,
                ": ",
                patient.healthcareId || "-"
            ]
        });
    };
    const renderCareProviderId = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                careProviderIdLabel,
                ": ",
                patient.careProviderId || "-"
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $g91zf.default), {
        className: "flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                hasBorder: false,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                                className: "fill-current w-6 h-6",
                                title: t("shared:patient")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 lg:grid grid-cols-2 gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "col-span-1",
                                    children: [
                                        renderName(),
                                        renderGender(),
                                        renderDateOfBirth()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "col-span-1",
                                    children: [
                                        renderHealthcareId(),
                                        renderCareProviderId()
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $wz5EJ.default), {
                patientId: props.patientId,
                isDark: true
            })
        ]
    });
};
var $f33de6083581054a$export$2e2bcd8739ae039 = $f33de6083581054a$var$PatientWithCasesDetailsCard;

});
parcelRegister("wz5EJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bbaa93f488ce79$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hsbMJ = parcelRequire("hsbMJ");

var $7hm8c = parcelRequire("7hm8c");
const $c4bbaa93f488ce79$var$PatientCaseList = (props)=>{
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    if (!patient?.cases.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: patient.cases.map((caseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hm8c.default), {
                caseId: caseId,
                isDark: props.isDark
            }, caseId);
        })
    });
};
var $c4bbaa93f488ce79$export$2e2bcd8739ae039 = $c4bbaa93f488ce79$var$PatientCaseList;

});
parcelRegister("7hm8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4de1ead13d4a9a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $6t04b = parcelRequire("6t04b");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");

var $eUISl = parcelRequire("eUISl");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $QwmFv = parcelRequire("QwmFv");

var $jxnLW = parcelRequire("jxnLW");

var $kon2z = parcelRequire("kon2z");
const $eb4de1ead13d4a9a$var$PatientCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const theCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, props));
    const leadCareUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserById)(state, theCase.leadCareUser));
    const caseClassificiation = (0, $iD0SF.useSelector)((state)=>(0, $jxnLW.getCaseClassificationById)(state, theCase.caseClassificationId));
    const renderCaseType = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:type"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QwmFv.default), {
                    caseType: theCase.caseType
                })
            ]
        });
    };
    const renderLeadCare = ()=>{
        if (!leadCareUser) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:leadCare"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                    firstName: leadCareUser.firstName,
                    lastName: leadCareUser.lastName,
                    professionalTitle: leadCareUser.professionalTitle,
                    isPending: leadCareUser.pending
                })
            ]
        });
    };
    const renderClassification = ()=>{
        if (!caseClassificiation) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("shared:classification"),
                ": ",
                caseClassificiation.name
            ]
        });
    };
    const renderSourceName = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:source"),
                ": ",
                theCase.sourceName
            ]
        });
    };
    const renderTargetDate = ()=>{
        const targetDate = theCase.targetDate;
        if (!targetDate) return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:targetDate"),
                ": -"
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("case:targetDate"),
                ": ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUISl.default), {
                    utcTime: targetDate
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        isDark: props.isDark,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:case")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 lg:grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderLeadCare(),
                                renderClassification(),
                                renderSourceName()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "col-span-1",
                            children: [
                                renderCaseType(),
                                renderTargetDate()
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $eb4de1ead13d4a9a$export$2e2bcd8739ae039 = $eb4de1ead13d4a9a$var$PatientCaseListItem;

});




parcelRegister("6D7zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93d45c42fdd95ff$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $8UrgM = parcelRequire("8UrgM");

var $4MHRb = parcelRequire("4MHRb");

var $COwA0 = parcelRequire("COwA0");

var $wz5EJ = parcelRequire("wz5EJ");

var $bHWav = parcelRequire("bHWav");

var $02FSz = parcelRequire("02FSz");

var $hsbMJ = parcelRequire("hsbMJ");

var $gal7S = parcelRequire("gal7S");

var $9W9ed = parcelRequire("9W9ed");

var $1qvB8 = parcelRequire("1qvB8");
const $a93d45c42fdd95ff$var$ReviewAndSaveForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const [isModalOpen, setIsModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4MHRb.fetchCaseClassificationAction)());
    }, []);
    const openModal = ()=>{
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        formikFormRef.current.setSubmitting(false);
        setIsModalOpen(false);
    };
    const handleConfirm = ()=>{
        closeModal();
        addCaseForPatient();
    };
    const addCaseForPatient = ()=>{
        const data = props.data;
        dispatch((0, $gal7S.addCaseForPatientAsync)(patientId, data));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:reviewAndSave:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:reviewAndSave:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        initialValues: props.data,
                        onSubmit: ()=>{
                            if (patient?.cases.length > 0) {
                                openModal();
                                return;
                            } else addCaseForPatient();
                        },
                        innerRef: formikFormRef,
                        children: ({ submitCount: submitCount })=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1qvB8.default), {
                                        isEnabled: submitCount < 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:details:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9W9ed.default), {
                                        patientId: patientId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:caseDetails:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHWav.default), {
                                        data: props.data
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $wz5EJ.default), {
                                        patientId: patientId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02FSz.default), {
                                        handleConfirm: handleConfirm,
                                        handleClose: closeModal,
                                        isOpen: isModalOpen
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $a93d45c42fdd95ff$export$2e2bcd8739ae039 = $a93d45c42fdd95ff$var$ReviewAndSaveForm;

});
parcelRegister("02FSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1185c1d3dd4c15b2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");

var $4KSAX = parcelRequire("4KSAX");

var $COwA0 = parcelRequire("COwA0");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $wz5EJ = parcelRequire("wz5EJ");

var $lCZwG = parcelRequire("lCZwG");

var $04A9g = parcelRequire("04A9g");
const $1185c1d3dd4c15b2$var$ConfirmModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { patientId: patientId } = (0, $COwA0.useParams)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.handleClose,
        style: (0, $jF0Xa.smallModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.handleClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-3 text-ch-blue-alt-500",
                    children: [
                        t("patient:caseDetails:caseAlreadyExistsTitle"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-8",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $wz5EJ.default), {
                        patientId: patientId
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:caseDetails:caseAlreadyExistsInfo")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:caseDetails:areYouSure")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    className: "mb-2",
                    buttons: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: props.handleClose,
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: t("shared:cancel")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: props.handleConfirm,
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("patient:caseDetails:buttons:createCase")
                        }, "2")
                    ]
                })
            ]
        })
    });
};
var $1185c1d3dd4c15b2$export$2e2bcd8739ae039 = $1185c1d3dd4c15b2$var$ConfirmModal;

});

parcelRegister("gal7S", function(module, exports) {

$parcel$export(module.exports, "updatePatientAsync", () => $6c627b332e4e1fdd$export$bd1b4ad201ff58);
$parcel$export(module.exports, "addCaseForPatientAsync", () => $6c627b332e4e1fdd$export$62484fbc30d218cd);

var $36FXQ = parcelRequire("36FXQ");
const $6c627b332e4e1fdd$export$bd1b4ad201ff58 = (patientId, patient)=>{
    return {
        type: (0, $36FXQ.PatientEditActionTypes).UPDATE_PATIENT_ASYNC_PENDING,
        payload: {
            id: patientId,
            patient: patient
        }
    };
};
const $6c627b332e4e1fdd$export$62484fbc30d218cd = (patientId, patient)=>{
    return {
        type: (0, $36FXQ.PatientEditActionTypes).ADD_CASE_FOR_PATIENT_ASYNC_PENDING,
        payload: {
            id: patientId,
            patient: patient
        }
    };
};

});

parcelRegister("9W9ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a0b91a9b9d2837$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");
parcelRequire("jitSV");
var $eEYoR = parcelRequire("eEYoR");

var $eYle3 = parcelRequire("eYle3");
const $e2a0b91a9b9d2837$var$SavedPatientDetailsFormCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                    className: "sm:mr-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEYoR.default), {
                        className: "fill-current w-6 h-6",
                        title: t("shared:patient")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eYle3.default), {
                    patientId: props.patientId,
                    hasLink: false
                })
            ]
        })
    });
};
var $e2a0b91a9b9d2837$export$2e2bcd8739ae039 = $e2a0b91a9b9d2837$var$SavedPatientDetailsFormCard;

});



parcelRegister("dlT2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $686d17e8dd0d9582$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $1HjJZ = parcelRequire("1HjJZ");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $3kOP8 = parcelRequire("3kOP8");
var $eEYoR = parcelRequire("eEYoR");

var $9BK0b = parcelRequire("9BK0b");

var $6lvMC = parcelRequire("6lvMC");

var $el6QJ = parcelRequire("el6QJ");

var $hsbMJ = parcelRequire("hsbMJ");

var $2x7UY = parcelRequire("2x7UY");

var $COwA0 = parcelRequire("COwA0");

var $caw88 = parcelRequire("caw88");

var $aEgqS = parcelRequire("aEgqS");

var $brZmd = parcelRequire("brZmd");
const $686d17e8dd0d9582$var$PatientEditDetailsPage = (_props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const [patientEditDetailsData, setPatientEditDetailsData] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $caw88.fetchPatientAsync)(patientId));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!patient) return;
        setPatientEditDetailsData({
            title: patient.title,
            firstName: patient.firstName,
            lastName: patient.lastName,
            gender: patient.gender,
            dateOfBirth: patient.dateOfBirth,
            healthcareId: patient.healthcareId,
            careProviderId: patient.careProviderId || "",
            patientAmendmentsAttributes: [
                {
                    reason: "",
                    amendmentType: (0, $el6QJ.AmendmentTypes).ErrorCorrection
                }
            ]
        });
    }, [
        patient
    ]);
    const renderWizard = ()=>{
        if (!currentUser.abilities?.patient.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        if (!patientEditDetailsData) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1HjJZ.default), {
            data: patientEditDetailsData,
            setData: setPatientEditDetailsData,
            steps: [
                {
                    name: t("patient:editPatientDetails:sectionTitle"),
                    icon: (0, $eEYoR.default),
                    component: (0, $9BK0b.default),
                    nextButtonText: t("shared:next"),
                    previousButtonText: t("shared:previous"),
                    updateRequiredBeforeNext: true
                },
                {
                    name: t("patient:reasonForChange:sectionTitle"),
                    icon: (0, $3kOP8.default),
                    component: (0, $2x7UY.default),
                    nextButtonText: t("shared:next"),
                    previousButtonText: t("shared:previous")
                },
                {
                    name: t("patient:reviewAndSave:sectionTitle"),
                    icon: (0, $4o7Oq.default),
                    component: (0, $brZmd.default),
                    nextButtonText: t("patient:reviewAndSave:buttons:savePatient"),
                    previousButtonText: t("shared:previous")
                }
            ]
        });
    };
    const renderContent = ()=>{
        if (!patient) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("patient:messages:patientNotFound")
        });
        return renderWizard();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:patients"),
                        href: (0, $6QJY8.RoutePaths).PATIENTS
                    },
                    {
                        pageTitle: t("patient:editPatientDetails:sectionTitle")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $686d17e8dd0d9582$export$2e2bcd8739ae039 = $686d17e8dd0d9582$var$PatientEditDetailsPage;

});
parcelRegister("2x7UY", function(module, exports) {

$parcel$export(module.exports, "default", () => $999d51ffb3fdaf57$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $c0FI2 = parcelRequire("c0FI2");

var $765bZ = parcelRequire("765bZ");

var $4qaeN = parcelRequire("4qaeN");

var $COwA0 = parcelRequire("COwA0");

var $el6QJ = parcelRequire("el6QJ");

var $jYu9X = parcelRequire("jYu9X");

var $7UN5R = parcelRequire("7UN5R");

var $aSzjr = parcelRequire("aSzjr");

var $eTqMc = parcelRequire("eTqMc");

var $aJAC1 = parcelRequire("aJAC1");

var $kF2ec = parcelRequire("kF2ec");

var $fPQZQ = parcelRequire("fPQZQ");
const $999d51ffb3fdaf57$var$ReasonForChangeForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const initialValues = {
        reason: "",
        amendmentType: null
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:reasonForChange:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mb-2 text-ch-blue-alt-500",
                    children: [
                        t("patient:reasonForChange:intro"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jYu9X.default), {
                    patientId: patientId,
                    data: props.data,
                    className: "mb-6"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full lg:w-2/3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        validateOnMount: true,
                        initialValues: initialValues,
                        validationSchema: (0, $aJAC1.patientAmendmentValidation),
                        onSubmit: (values, { setSubmitting: setSubmitting })=>{
                            const data = {
                                reason: values.reason,
                                amendmentType: values.amendmentType
                            };
                            props.setData({
                                ...props.data,
                                patientAmendmentsAttributes: [
                                    data
                                ]
                            });
                            setSubmitting(false);
                            props.goToNextStep();
                        },
                        innerRef: formikFormRef,
                        children: ({ errors: errors, values: values, touched: touched, handleBlur: handleBlur, setFieldValue: setFieldValue })=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fPQZQ.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "reason",
                                                required: true,
                                                children: t("patient:reasonForChange:details:reasonInfo")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                                name: "reason",
                                                setValue: (reason)=>setFieldValue("reason", reason),
                                                onBlur: handleBlur,
                                                users: null,
                                                value: values.reason
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.reason,
                                                isVisible: errors.reason && touched.reason
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                                name: "amendmentType",
                                                required: true,
                                                children: t("patient:reasonForChange:details:amendmentType")
                                            }),
                                            Object.values((0, $el6QJ.AmendmentTypes)).map((amendmentType, index)=>{
                                                const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(amendmentType);
                                                const label = t(`patient:reasonForChange:details:${translationKey}`);
                                                const labelInfo = t(`patient:reasonForChange:details:${translationKey}Info`);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kF2ec.default), {
                                                                    isSelected: amendmentType == values.amendmentType,
                                                                    name: "amendmentType",
                                                                    value: amendmentType
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "ml-2",
                                                                    children: [
                                                                        label,
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "text-ch-gray-500",
                                                                            children: [
                                                                                " - ",
                                                                                labelInfo
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        index < Object.values((0, $el6QJ.AmendmentTypes)).length - 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "text-ch-gray-500 my-4",
                                                            children: "OR"
                                                        }) : null
                                                    ]
                                                }, `amendment-type-${amendmentType}`);
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                                errorMessage: errors.amendmentType,
                                                isVisible: errors.amendmentType && touched.amendmentType
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $999d51ffb3fdaf57$export$2e2bcd8739ae039 = $999d51ffb3fdaf57$var$ReasonForChangeForm;

});
parcelRegister("jYu9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c55792e84025bc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $hsbMJ = parcelRequire("hsbMJ");

var $gVAOm = parcelRequire("gVAOm");
const $c0c55792e84025bc$var$AmendmentList = (props)=>{
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, props));
    const renderAmendment = (attributeName)=>{
        if (!props.data[attributeName] || patient[attributeName] == props.data[attributeName]) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gVAOm.default), {
                        data: props.data,
                        patient: patient,
                        attributeName: attributeName,
                        type: "original"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gVAOm.default), {
                        data: props.data,
                        patient: patient,
                        attributeName: attributeName,
                        type: "amended"
                    })
                })
            ]
        }, `patient-amendment-${attributeName}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        className: props.className,
        children: Object.keys(patient).map((attributeName)=>{
            return renderAmendment(attributeName);
        })
    });
};
var $c0c55792e84025bc$export$2e2bcd8739ae039 = $c0c55792e84025bc$var$AmendmentList;

});
parcelRegister("gVAOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c0f9413b2395b0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $aeos3 = parcelRequire("aeos3");
const $03c0f9413b2395b0$var$AmendmentText = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { healthcareIdLabel: healthcareIdLabel, careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const attributeNameText = ()=>{
        if (props.attributeName == "healthcareId") return healthcareIdLabel;
        if (props.attributeName == "careProviderId") return careProviderIdLabel;
        return t(`patient:details:${props.attributeName}`);
    };
    const renderValue = ()=>{
        if (props.type == "original") return props.patient[props.attributeName];
        if (props.type == "amended") return props.data[props.attributeName];
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: `${attributeNameText()} (${t(`patient:reasonForChange:${props.type}`)}): ${renderValue()}`
    });
};
var $03c0f9413b2395b0$export$2e2bcd8739ae039 = $03c0f9413b2395b0$var$AmendmentText;

});


parcelRegister("aJAC1", function(module, exports) {

$parcel$export(module.exports, "patientAmendmentValidation", () => $8777e1c6b31bb74d$export$df07b37e39828396);
parcelRequire("cxhNX");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $8777e1c6b31bb74d$export$df07b37e39828396 = ()=>{
    return $hDGtv.create().shape({
        reason: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(1500, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 1500
        })),
        amendmentType: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).nullable()
    });
};

});


parcelRegister("brZmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5121d3846fa9a84a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $COwA0 = parcelRequire("COwA0");

var $4qaeN = parcelRequire("4qaeN");

var $765bZ = parcelRequire("765bZ");

var $ctTE5 = parcelRequire("ctTE5");

var $gal7S = parcelRequire("gal7S");

var $jPGXg = parcelRequire("jPGXg");

var $1qvB8 = parcelRequire("1qvB8");
const $5121d3846fa9a84a$var$ReviewAndSaveForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:reviewAndSave:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:reviewAndSave:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        initialValues: props.data,
                        onSubmit: (_values, { setSubmitting: setSubmitting })=>{
                            const data = props.data;
                            dispatch((0, $gal7S.updatePatientAsync)(patientId, data));
                            setSubmitting(false);
                        },
                        innerRef: formikFormRef,
                        children: ({ submitCount: submitCount })=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1qvB8.default), {
                                        isEnabled: submitCount < 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:details:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctTE5.default), {
                                        data: props.data
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:reasonForChange:amendmentDetailsTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jPGXg.default), {
                                        data: props.data,
                                        patientId: patientId
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $5121d3846fa9a84a$export$2e2bcd8739ae039 = $5121d3846fa9a84a$var$ReviewAndSaveForm;

});
parcelRegister("jPGXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ae5fd83ce85b45$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $3Ukkm = parcelRequire("3Ukkm");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $jYu9X = parcelRequire("jYu9X");
const $52ae5fd83ce85b45$var$AmendmentDetailsFormCard = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const renderReason = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:reason"),
                ": ",
                props.data.patientAmendmentsAttributes[0].reason
            ]
        });
    };
    const renderTypeOfChange = ()=>{
        const translationKey = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).camelize(props.data.patientAmendmentsAttributes[0].amendmentType);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                t("patient:reasonForChange:details:amendmentType"),
                ": ",
                t(`patient:reasonForChange:details:${translationKey}`)
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 lg:grid grid-cols-2 gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jYu9X.default), {
                        data: props.data,
                        patientId: props.patientId,
                        className: "col-span-1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                        className: "col-span-1",
                        children: [
                            renderReason(),
                            renderTypeOfChange()
                        ]
                    })
                ]
            })
        })
    });
};
var $52ae5fd83ce85b45$export$2e2bcd8739ae039 = $52ae5fd83ce85b45$var$AmendmentDetailsFormCard;

});



parcelRegister("jvnqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b8f55b0c2413a83$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $1HjJZ = parcelRequire("1HjJZ");
parcelRequire("jitSV");
var $4o7Oq = parcelRequire("4o7Oq");
var $1P0Mf = parcelRequire("1P0Mf");

var $6lvMC = parcelRequire("6lvMC");

var $hsbMJ = parcelRequire("hsbMJ");

var $COwA0 = parcelRequire("COwA0");

var $caw88 = parcelRequire("caw88");

var $aEgqS = parcelRequire("aEgqS");

var $ecRMg = parcelRequire("ecRMg");

var $drkDa = parcelRequire("drkDa");
const $7b8f55b0c2413a83$var$PatientEditFurtherDetailsPage = (_props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    const patient = (0, $iD0SF.useSelector)((state)=>(0, $hsbMJ.getPatientById)(state, {
            patientId: patientId
        }));
    const [patientEditFurtherDetailsData, setPatientEditFurtherDetailsData] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $caw88.fetchPatientAsync)(patientId));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!patient) return;
        setPatientEditFurtherDetailsData({
            furtherDetailsAttributes: {
                id: patient.furtherDetails?.id,
                postcode: patient.furtherDetails?.postcode,
                addressLine1: patient.furtherDetails?.addressLine1,
                addressLine2: patient.furtherDetails?.addressLine2,
                city: patient.furtherDetails?.city,
                county: patient.furtherDetails?.county,
                country: patient.furtherDetails?.country,
                email: patient.furtherDetails?.email,
                phoneNumber: patient.furtherDetails?.phoneNumber,
                phoneNumberAlt: patient.furtherDetails?.phoneNumberAlt,
                gpPostcode: patient.furtherDetails?.gpPostcode,
                gpPracticeName: patient.furtherDetails?.gpPracticeName,
                gpAddressLine1: patient.furtherDetails?.gpAddressLine1,
                gpAddressLine2: patient.furtherDetails?.gpAddressLine2,
                gpCity: patient.furtherDetails?.gpCity,
                gpCounty: patient.furtherDetails?.gpCounty,
                gpCountry: patient.furtherDetails?.gpCountry,
                gpEmail: patient.furtherDetails?.gpEmail,
                gpPhoneNumber: patient.furtherDetails?.gpPhoneNumber,
                gpName: patient.furtherDetails?.gpName
            }
        });
    }, [
        patient
    ]);
    const renderWizard = ()=>{
        if (!currentUser.abilities?.patient.canCreate) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        if (!patientEditFurtherDetailsData) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1HjJZ.default), {
            data: patientEditFurtherDetailsData,
            setData: setPatientEditFurtherDetailsData,
            steps: [
                {
                    name: t("patient:editPatientDetails:sectionTitle"),
                    icon: (0, $1P0Mf.default),
                    component: (0, $ecRMg.default),
                    nextButtonText: t("shared:next"),
                    previousButtonText: t("shared:previous"),
                    updateRequiredBeforeNext: true
                },
                {
                    name: t("patient:reviewAndSave:sectionTitle"),
                    icon: (0, $4o7Oq.default),
                    component: (0, $drkDa.default),
                    nextButtonText: t("patient:reviewAndSave:buttons:savePatient"),
                    previousButtonText: t("shared:previous")
                }
            ]
        });
    };
    const renderContent = ()=>{
        if (!patient) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("patient:messages:patientNotFound")
        });
        return renderWizard();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:patients"),
                        href: (0, $6QJY8.RoutePaths).PATIENTS
                    },
                    {
                        pageTitle: t("patient:editPatientFurtherDetails:sectionTitle")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $7b8f55b0c2413a83$export$2e2bcd8739ae039 = $7b8f55b0c2413a83$var$PatientEditFurtherDetailsPage;

});
parcelRegister("drkDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $59d59558fa333093$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $COwA0 = parcelRequire("COwA0");

var $4qaeN = parcelRequire("4qaeN");

var $765bZ = parcelRequire("765bZ");

var $gal7S = parcelRequire("gal7S");

var $9W9ed = parcelRequire("9W9ed");

var $dp7TY = parcelRequire("dp7TY");

var $1qvB8 = parcelRequire("1qvB8");
const $59d59558fa333093$var$ReviewAndSaveForm = (props)=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "patient"
    ]);
    const { formikFormRef: formikFormRef } = (0, $acw62.useContext)((0, $765bZ.FormContext));
    const { patientId: patientId } = (0, $COwA0.useParams)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex-1 overflow-scroll pb-36",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "flex mb-2 font-semibold",
                    children: t("patient:reviewAndSave:sectionTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "mb-2",
                    children: t("patient:reviewAndSave:intro")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                        initialValues: props.data,
                        onSubmit: (_values, { setSubmitting: setSubmitting })=>{
                            const data = props.data;
                            dispatch((0, $gal7S.updatePatientAsync)(patientId, data));
                            setSubmitting(false);
                        },
                        innerRef: formikFormRef,
                        children: ({ submitCount: submitCount })=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1qvB8.default), {
                                        isEnabled: submitCount < 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:details:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9W9ed.default), {
                                        patientId: patientId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "flex mb-2 font-semibold",
                                        children: t("patient:furtherDetails:sectionTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dp7TY.default), {
                                        data: props.data
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $59d59558fa333093$export$2e2bcd8739ae039 = $59d59558fa333093$var$ReviewAndSaveForm;

});


parcelRegister("8k0Gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c411f904a1afbe83$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aDFyu = parcelRequire("aDFyu");

var $6QJY8 = parcelRequire("6QJY8");

var $kQILj = parcelRequire("kQILj");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $39EfS = parcelRequire("39EfS");

var $1kXfn = parcelRequire("1kXfn");

var $bCANc = parcelRequire("bCANc");

var $9QVLZ = parcelRequire("9QVLZ");

var $kVlM3 = parcelRequire("kVlM3");

var $cp84k = parcelRequire("cp84k");

var $gnvJ9 = parcelRequire("gnvJ9");

var $62Lcu = parcelRequire("62Lcu");

var $6lvMC = parcelRequire("6lvMC");

var $glc4D = parcelRequire("glc4D");
const $c411f904a1afbe83$var$TeamsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getCurrentUser)(state));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getTeamsUI)(state));
    const canCreateTeam = currentUser.abilities?.team.canCreate;
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $gnvJ9.fetchTeamsAsync));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:teams"),
                buttonText: canCreateTeam ? t("team:addANewTeam") : "",
                buttonHref: (0, $6QJY8.RoutePaths).TEAMS_NEW,
                hasButtonPermission: canCreateTeam
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-start-2 md:row-start-1 self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                            i18nKey: "team:searchBy",
                            components: {
                                strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row-end-2 md:row-start-1 flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("team:searchTeam")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "text-lg mb-2",
                children: [
                    UI.totalItems,
                    " ",
                    t("shared:teams")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-flow-row md:grid-flow-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cp84k.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kVlM3.default), {
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery,
                            orderByOptions: (0, $62Lcu.TeamsOrderByOptions),
                            useTranslation: "team"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bCANc.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                searchQuery: searchQuery,
                setSearchQuery: setSearchQuery,
                totalItems: UI.totalItems,
                totalPages: UI.totalPages
            })
        ]
    });
};
var $c411f904a1afbe83$export$2e2bcd8739ae039 = $c411f904a1afbe83$var$TeamsPage;

});
parcelRegister("bCANc", function(module, exports) {

$parcel$export(module.exports, "default", () => $655993d4ca5c263d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4KSAX = parcelRequire("4KSAX");

var $flW0a = parcelRequire("flW0a");

var $jTkGE = parcelRequire("jTkGE");
const $655993d4ca5c263d$var$TeamList = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const teamIds = (0, $iD0SF.useSelector)((0, $jTkGE.getAllTeamIds));
    if (!teamIds.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("team:noTeams")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: teamIds.map((teamId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $flW0a.default), {
                teamId: teamId
            }, teamId);
        })
    });
};
var $655993d4ca5c263d$export$2e2bcd8739ae039 = $655993d4ca5c263d$var$TeamList;

});
parcelRegister("flW0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $227f285ad3960e03$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $4KSAX = parcelRequire("4KSAX");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $jTkGE = parcelRequire("jTkGE");

var $5v6Bi = parcelRequire("5v6Bi");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $1g6OM = parcelRequire("1g6OM");
const $227f285ad3960e03$var$TeamListItem = (props)=>{
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamByHasTeamId)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const teamDetailsUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
        teamId: props.teamId
    });
    if (!team) return null;
    const renderViewButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: teamDetailsUrl,
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("shared:viewDetails")
        }, "2");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                                className: "fill-current w-6 h-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                            teamId: team.id,
                            userId: team.owner
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            renderViewButton()
                        ]
                    })
                })
            ]
        })
    });
};
var $227f285ad3960e03$export$2e2bcd8739ae039 = $227f285ad3960e03$var$TeamListItem;

});
parcelRegister("1g6OM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef10db26d960dcb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6t04b = parcelRequire("6t04b");

var $jTkGE = parcelRequire("jTkGE");

var $7hl6H = parcelRequire("7hl6H");

var $6lvMC = parcelRequire("6lvMC");

var $4KSAX = parcelRequire("4KSAX");

var $1WoI7 = parcelRequire("1WoI7");
const $1ef10db26d960dcb$var$TeamDetails = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamByHasTeamId)(state, props));
    const teamOwnerUser = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, props));
    if (!team || !teamOwnerUser) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-1 lg:grid grid-cols-2 gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "font-semibold",
                            children: [
                                team.teamType == (0, $1WoI7.TeamTypes).mdt ? `${t("team:mdt:mdt")}: ` : null,
                                team.name
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("team:specialty"),
                            ":\xa0",
                            team.specialtyName
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            team.teamType == (0, $1WoI7.TeamTypes).mdt ? t("team:mdt:mdtCoordinator") : t("team:teamOwner"),
                            ":\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                                firstName: teamOwnerUser.firstName,
                                lastName: teamOwnerUser.lastName,
                                isPending: teamOwnerUser.pending
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                className: "col-span-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("team:lastUpdated"),
                            ":\xa0",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hl6H.default), {
                                utcTime: team.updatedAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            t("team:teamMembers"),
                            ":\xa0",
                            team.users.length
                        ]
                    })
                ]
            })
        ]
    });
};
var $1ef10db26d960dcb$export$2e2bcd8739ae039 = $1ef10db26d960dcb$var$TeamDetails;

});



parcelRegister("cp84k", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac8de0bbe2892cb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $kAnkg = parcelRequire("kAnkg");
const $cac8de0bbe2892cb$var$TeamFilter = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const checkAllIsOn = ()=>{
        return props.searchQuery.appliedFilters.length == 0;
    };
    const checkIsOn = (filter)=>{
        return props.searchQuery.appliedFilters.includes(filter);
    };
    const resetFilters = ()=>{
        if (!checkAllIsOn()) props.setSearchQuery({
            appliedFilters: []
        });
    };
    const updateFilters = (filter)=>{
        const isOn = checkIsOn(filter);
        if (isOn) props.setSearchQuery({
            appliedFilters: props.searchQuery.appliedFilters.filter((i)=>i !== filter)
        });
        else props.setSearchQuery({
            appliedFilters: [
                ...props.searchQuery.appliedFilters,
                filter
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
        className: "flex flex-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("isMember"),
                    action: ()=>{
                        updateFilters("isMember");
                    },
                    children: t("team:youAreAMember")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkIsOn("isOwner"),
                    action: ()=>{
                        updateFilters("isOwner");
                    },
                    children: t("team:youAreTheOwner")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "mb-2 mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAnkg.default), {
                    isOn: checkAllIsOn(),
                    action: ()=>{
                        resetFilters();
                    },
                    children: t("team:all")
                })
            })
        ]
    });
};
var $cac8de0bbe2892cb$export$2e2bcd8739ae039 = $cac8de0bbe2892cb$var$TeamFilter;

});


parcelRegister("3EEnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2438ad17b27a66$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $4fo4Z = parcelRequire("4fo4Z");

var $8UrgM = parcelRequire("8UrgM");

var $6QJY8 = parcelRequire("6QJY8");

var $d5eYa = parcelRequire("d5eYa");

var $bLSXH = parcelRequire("bLSXH");
const $5c2438ad17b27a66$var$TeamsNewPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchSpecialties = ()=>dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    (0, $acw62.useEffect)(()=>{
        fetchSpecialties();
        fetchUsers();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:teams"),
                        href: (0, $6QJY8.RoutePaths).TEAMS
                    },
                    {
                        pageTitle: t("team:addANewTeam")
                    }
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bLSXH.default), {})
        ]
    });
};
var $5c2438ad17b27a66$export$2e2bcd8739ae039 = $5c2438ad17b27a66$var$TeamsNewPage;

});
parcelRegister("bLSXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $100124817afa08d6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $48BqW = parcelRequire("48BqW");

var $c0FI2 = parcelRequire("c0FI2");

var $3eX0C = parcelRequire("3eX0C");

var $4qaeN = parcelRequire("4qaeN");

var $hS3gM = parcelRequire("hS3gM");

var $feoOm = parcelRequire("feoOm");

var $kYqkq = parcelRequire("kYqkq");

var $fKaTC = parcelRequire("fKaTC");

var $5Zbqq = parcelRequire("5Zbqq");
const $100124817afa08d6$var$TeamNewForm = ()=>{
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const createTeam = (team)=>dispatch((0, $3eX0C.createTeamAsync)(team));
    const { mdtTeamsEnabled: mdtTeamsEnabled } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    const initialValues = {
        teamType: "basic",
        name: "",
        specialtyId: "",
        ownerId: "",
        teamUsers: []
    };
    const [isMdtTeam, setIsMdtTeam] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4qaeN.default), {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: isMdtTeam ? (0, $48BqW.mdtTeamNewValidationSchema)() : (0, $48BqW.teamNewValidationSchema)(),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const data = (0, $48BqW.teamNewValidationSchema)().cast(values);
                createTeam(data);
                setSubmitting(false);
            },
            children: ()=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        mdtTeamsEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Zbqq.default), {
                            isMdtTeam: isMdtTeam,
                            setIsMdtTeam: setIsMdtTeam
                        }) : null,
                        isMdtTeam ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $feoOm.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hS3gM.default), {})
                    ]
                });
            }
        })
    });
};
var $100124817afa08d6$export$2e2bcd8739ae039 = $100124817afa08d6$var$TeamNewForm;

});
parcelRegister("48BqW", function(module, exports) {

$parcel$export(module.exports, "teamNewValidationSchema", () => $f246508c843966cf$export$33066c786aeb2075);
$parcel$export(module.exports, "mdtTeamNewValidationSchema", () => $f246508c843966cf$export$c85e5100ee87084f);
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $f246508c843966cf$export$33066c786aeb2075 = ()=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        specialtyId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        ownerId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        teamUsers: $jpuYg.create().min(1, (0, $5wPBK.default).t("shared:teamMembersSelectAtLeastOne"))
    });
};
const $f246508c843966cf$export$c85e5100ee87084f = ()=>{
    return $hDGtv.create().shape({
        name: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(50, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 50
        })),
        specialtyId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        ownerId: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        teamUsers: $jpuYg.create().of($hDGtv.create().shape({
            userId: $gcL7X.create().required((0, $5wPBK.default).t("shared:required")),
            role: $gcL7X.create().required((0, $5wPBK.default).t("shared:required"))
        })).min(1, (0, $5wPBK.default).t("shared:teamMembersSelectAtLeastOne"))
    });
};

});

parcelRegister("3eX0C", function(module, exports) {

$parcel$export(module.exports, "fetchTeamAsync", () => $d5f13d437bd4d288$export$cd2f547d21eda36b);
$parcel$export(module.exports, "createTeamAsync", () => $d5f13d437bd4d288$export$58c43f2edea81ff1);
$parcel$export(module.exports, "updateTeamAsync", () => $d5f13d437bd4d288$export$68d4bdfb0c3cc217);
$parcel$export(module.exports, "deleteTeamAsync", () => $d5f13d437bd4d288$export$c59ca162ad682829);
$parcel$export(module.exports, "updateTeamUsersAction", () => $d5f13d437bd4d288$export$bde70be8e3c5c00c);

var $1WoI7 = parcelRequire("1WoI7");
const $d5f13d437bd4d288$export$cd2f547d21eda36b = (teamId)=>{
    return {
        type: (0, $1WoI7.TeamActionTypes).FETCH_TEAM_ASYNC_PENDING,
        payload: teamId
    };
};
const $d5f13d437bd4d288$export$58c43f2edea81ff1 = (teamData)=>{
    return {
        type: (0, $1WoI7.TeamActionTypes).CREATE_TEAM_ASYNC_PENDING,
        payload: teamData
    };
};
const $d5f13d437bd4d288$export$68d4bdfb0c3cc217 = (teamId, teamData)=>{
    return {
        type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_ASYNC_PENDING,
        payload: {
            id: teamId,
            team: teamData
        }
    };
};
const $d5f13d437bd4d288$export$c59ca162ad682829 = (teamId)=>{
    return {
        type: (0, $1WoI7.TeamActionTypes).DELETE_TEAM_ASYNC_PENDING,
        payload: teamId
    };
};
const $d5f13d437bd4d288$export$bde70be8e3c5c00c = (teamId, teamData)=>{
    return {
        type: (0, $1WoI7.TeamActionTypes).UPDATE_TEAM_USERS_ASYNC_PENDING,
        payload: {
            id: teamId,
            data: teamData
        }
    };
};

});

parcelRegister("hS3gM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2ae7ba484f71ed$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $6wDTk = parcelRequire("6wDTk");

var $d8Vwn = parcelRequire("d8Vwn");

var $lqbsE = parcelRequire("lqbsE");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");
const $1c2ae7ba484f71ed$var$TeamNewFormContent = ()=>{
    const { isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur } = (0, $7YFi7.useFormikContext)();
    const [userOptions, setUserOptions] = (0, $acw62.useState)([]);
    const [membersOptions, setMembersOptions] = (0, $acw62.useState)([]);
    const [ownerOptions, setOwnerOptions] = (0, $acw62.useState)([]);
    const [isUsersPopulated, setIsUsersPopulated] = (0, $acw62.useState)(false);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, $acw62.useState)([]);
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const specialties = (0, $iD0SF.useSelector)((0, $lqbsE.getAllSpecialties));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(users);
        setUserOptions(options);
        if (!isUsersPopulated) {
            setMembersOptions(options);
            setOwnerOptions(options);
        }
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "name",
                        required: true,
                        children: t("team:title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "name",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.name,
                        autoComplete: "off",
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.name,
                        isVisible: errors.name && touched.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "specialtyId",
                        required: true,
                        children: t("team:specialty")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "specialtyId",
                        options: specialtiesOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isGrouped: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.specialtyId,
                        isVisible: errors.specialtyId && touched.specialtyId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "ownerId",
                        required: true,
                        children: t("team:owner")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "ownerId",
                        options: ownerOptions,
                        onChange: (e)=>{
                            handleChange(e);
                            const selectedValue = e.currentTarget.value;
                            const newMemberOptions = userOptions.filter((item)=>item.value !== selectedValue);
                            setMembersOptions(newMemberOptions);
                            setIsUsersPopulated(true);
                        },
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue),
                        onBlur: handleBlur
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.ownerId,
                        isVisible: errors.ownerId && touched.ownerId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "teamUsers",
                        required: true,
                        children: t("team:members")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "teamUsers",
                        options: membersOptions,
                        onChange: (e)=>{
                            handleChange(e);
                            const selectedValue = e.currentTarget.value;
                            const newOwnerOptions = userOptions.filter((item)=>!selectedValue.includes(item.value));
                            setOwnerOptions(newOwnerOptions);
                            setIsUsersPopulated(true);
                        },
                        onBlur: handleBlur,
                        isMulti: true,
                        closeMenuOnSelect: false,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.teamUsers,
                        isVisible: errors.teamUsers && touched.teamUsers
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    isDisabled: isSubmitting,
                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                    isSubmit: true,
                    children: t("Create Team")
                })
            })
        ]
    });
};
var $1c2ae7ba484f71ed$export$2e2bcd8739ae039 = $1c2ae7ba484f71ed$var$TeamNewFormContent;

});

parcelRegister("feoOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1474eedb99bf9f7f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $ifbAI = parcelRequire("ifbAI");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $6wDTk = parcelRequire("6wDTk");

var $d8Vwn = parcelRequire("d8Vwn");

var $lqbsE = parcelRequire("lqbsE");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");

var $c34ph = parcelRequire("c34ph");
const $1474eedb99bf9f7f$var$MdtTeamNewFormContent = ()=>{
    const { isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue } = (0, $7YFi7.useFormikContext)();
    const [userOptions, setUserOptions] = (0, $acw62.useState)([]);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, $acw62.useState)([]);
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const specialties = (0, $iD0SF.useSelector)((0, $lqbsE.getAllSpecialties));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(users);
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    (0, $acw62.useEffect)(()=>{
        if (values.teamUsers && values.teamUsers.length == 0) setFieldValue("teamUsers", [
            {
                userId: null,
                role: null,
                id: ""
            }
        ]);
    }, [
        values.teamUsers
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "name",
                        required: true,
                        children: t("team:mdt:mdtName")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                        type: "text",
                        name: "name",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.name,
                        autoComplete: "off",
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.name,
                        isVisible: errors.name && touched.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "specialtyId",
                        required: true,
                        children: t("team:specialty")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "specialtyId",
                        options: specialtiesOptions,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        isGrouped: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.specialtyId,
                        isVisible: errors.specialtyId && touched.specialtyId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                        name: "ownerId",
                        required: true,
                        children: t("team:mdt:mdtCoordinator")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                        name: "ownerId",
                        options: userOptions,
                        onChange: handleChange,
                        filterOption: (0, $6wDTk.filterOptionsBySearchValue),
                        onBlur: handleBlur
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                        errorMessage: errors.ownerId,
                        isVisible: errors.ownerId && touched.ownerId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c34ph.default), {
                    userOptions: userOptions
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                    isDisabled: isSubmitting,
                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                    isSubmit: true,
                    children: t("Create Team")
                })
            })
        ]
    });
};
var $1474eedb99bf9f7f$export$2e2bcd8739ae039 = $1474eedb99bf9f7f$var$MdtTeamNewFormContent;

});
parcelRegister("c34ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc7fd5977d88e82$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $eTqMc = parcelRequire("eTqMc");

var $7UN5R = parcelRequire("7UN5R");

var $5GZlj = parcelRequire("5GZlj");

var $aEgqS = parcelRequire("aEgqS");

var $kYqkq = parcelRequire("kYqkq");

var $fKaTC = parcelRequire("fKaTC");

var $jF0Xa = parcelRequire("jF0Xa");

var $dHNYJ = parcelRequire("dHNYJ");
const $bfc7fd5977d88e82$var$MdtTeamUsersFieldArray = (props)=>{
    const { mdtRoles: mdtRoles } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const { values: values, handleChange: handleChange, handleBlur: handleBlur, errors: errors, touched: touched } = (0, $7YFi7.useFormikContext)();
    if (!mdtRoles) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
    const roleOptions = mdtRoles.map((r)=>({
            value: r,
            label: r
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.FieldArray), {
        name: "teamUsers",
        children: ({ remove: remove, push: push })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col ",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-row items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex-auto w-3/12 mr-3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "teamUsers.[].userId",
                                            required: true,
                                            children: t("team:members")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex-auto w-3/12",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                            name: "teamUsers.[].role",
                                            required: true,
                                            children: t("team:mdt:role")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-1/12",
                                        children: "\xa0"
                                    })
                                ]
                            }),
                            values.teamUsers?.length > 0 && values.teamUsers.map((teamUser, index, teamUsers)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex flex-row w-full items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Field), {
                                            type: "hidden",
                                            name: `teamUsers.${index}.id`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mr-3 flex-auto w-3/12",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dHNYJ.default), {
                                                index: index,
                                                handleChange: handleChange,
                                                handleBlur: handleBlur,
                                                userOptions: props.userOptions,
                                                teamUser: teamUser
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "flex-auto w-3/12",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                                name: `teamUsers.${index}.role`,
                                                options: roleOptions,
                                                onChange: handleChange,
                                                onBlur: handleBlur
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "ml-3 mb-2 w-1/12",
                                            children: teamUsers.length > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                                action: ()=>remove(index),
                                                children: "remove"
                                            }) : null
                                        })
                                    ]
                                }, index)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                errorMessage: t("team:mdt:teamUsersError"),
                                isVisible: errors.teamUsers && touched.teamUsers
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            variant: (0, $jF0Xa.StyleVariants).BLUE,
                            action: ()=>push({
                                    id: "",
                                    userId: null,
                                    role: null
                                }),
                            children: "Add member"
                        })
                    })
                ]
            })
    });
};
var $bfc7fd5977d88e82$export$2e2bcd8739ae039 = $bfc7fd5977d88e82$var$MdtTeamUsersFieldArray;

});
parcelRegister("dHNYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4f2fdc3c0365b9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $5GZlj = parcelRequire("5GZlj");

var $6wDTk = parcelRequire("6wDTk");
const $eb4f2fdc3c0365b9$var$TeamUserSelectField = (props)=>{
    const { values: values } = (0, $7YFi7.useFormikContext)();
    const [teamUserOptions, setTeamUserOptions] = (0, $acw62.useState)(props.userOptions);
    (0, $acw62.useEffect)(()=>{
        const selectedIds = values.teamUsers.map((m)=>m.userId);
        const currentValue = values.teamUsers[props.index].userId;
        const newTeamUserOptions = props.userOptions.filter((option)=>option.value == currentValue || !selectedIds.includes(option.value));
        setTeamUserOptions(newTeamUserOptions);
    }, [
        values.teamUsers
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
        name: `teamUsers.${props.index}.userId`,
        options: teamUserOptions,
        onChange: props.handleChange,
        onBlur: props.handleBlur,
        filterOption: (0, $6wDTk.filterOptionsBySearchValue)
    });
};
var $eb4f2fdc3c0365b9$export$2e2bcd8739ae039 = $eb4f2fdc3c0365b9$var$TeamUserSelectField;

});



parcelRegister("5Zbqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b522b0660c500315$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $hnsNb = parcelRequire("hnsNb");

var $1WoI7 = parcelRequire("1WoI7");
const $b522b0660c500315$var$MdtTeamToggleTypeField = (props)=>{
    const { initialValues: initialValues, values: values, setFieldValue: setFieldValue, resetForm: resetForm } = (0, $7YFi7.useFormikContext)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-right my-2",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                    name: "type",
                    children: "Team type"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hnsNb.default), {
                    AActive: !props.isMdtTeam,
                    handlerA: ()=>{
                        resetForm({
                            values: {
                                ...initialValues,
                                name: values.name,
                                specialtyId: values.specialtyId
                            }
                        });
                        setFieldValue("teamType", (0, $1WoI7.TeamTypes).basic);
                        props.setIsMdtTeam(false);
                    },
                    handlerB: ()=>{
                        resetForm({
                            values: {
                                ...initialValues,
                                name: values.name,
                                specialtyId: values.specialtyId
                            }
                        });
                        setFieldValue("teamType", (0, $1WoI7.TeamTypes).mdt);
                        props.setIsMdtTeam(true);
                    },
                    translationNamespace: "team",
                    textAKey: "team:teamTypes:basicTeam",
                    textBKey: "team:teamTypes:mdtTeam"
                })
            ]
        })
    });
};
var $b522b0660c500315$export$2e2bcd8739ae039 = $b522b0660c500315$var$MdtTeamToggleTypeField;

});



parcelRegister("3cQf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4144510e22172c7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $djZ3q = parcelRequire("djZ3q");

var $2RWR5 = parcelRequire("2RWR5");

var $8U3XH = parcelRequire("8U3XH");

var $3eX0C = parcelRequire("3eX0C");

var $1WoI7 = parcelRequire("1WoI7");

var $8UrgM = parcelRequire("8UrgM");

var $jTkGE = parcelRequire("jTkGE");
const $c4144510e22172c7$var$TeamPage = ()=>{
    const { teamId: teamId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, teamId));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchTeam = (teamId)=>dispatch((0, $3eX0C.fetchTeamAsync)(teamId));
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    (0, $acw62.useEffect)(()=>{
        fetchTeam(teamId);
        fetchUsers();
    }, []);
    if (!team) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg",
        children: t("team:teamNotFound")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $djZ3q.default), {
                teamId: teamId
            }),
            team.teamType == (0, $1WoI7.TeamTypes).mdt ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2RWR5.default), {
                teamId: teamId
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8U3XH.default), {
                teamId: teamId
            })
        ]
    });
};
var $c4144510e22172c7$export$2e2bcd8739ae039 = $c4144510e22172c7$var$TeamPage;

});
parcelRegister("djZ3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825320441caee6ef$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $6QJY8 = parcelRequire("6QJY8");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $d5eYa = parcelRequire("d5eYa");

var $1Cmbh = parcelRequire("1Cmbh");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $ejvqu = parcelRequire("ejvqu");

var $jTkGE = parcelRequire("jTkGE");

var $b5weT = parcelRequire("b5weT");

var $7jD0k = parcelRequire("7jD0k");

var $COwA0 = parcelRequire("COwA0");

var $3eX0C = parcelRequire("3eX0C");

var $1g6OM = parcelRequire("1g6OM");
const $825320441caee6ef$var$TeamHeader = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const dispatch = (0, $2OPjR.useDispatch)();
    const deleteTeam = (teamId)=>dispatch((0, $3eX0C.deleteTeamAsync)(teamId));
    if (!team) return null;
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const renderEditButton = ()=>{
        if (team.permissions.canEdit) {
            const editTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM_EDIT, {
                teamId: props.teamId
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                href: editTeamUrl,
                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                children: t("team:editTeam")
            }, "1");
        } else return null;
    };
    const renderDeleteButton = ()=>{
        if (team.permissions.canUninvite) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: ()=>openModal(),
            variant: (0, $jF0Xa.StyleVariants).PURPLE,
            children: t("team:deleteTeam")
        }, "2");
        else return null;
    };
    const onDeleteTeam = ()=>{
        deleteTeam(props.teamId);
        closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                    breadcrumbs: [
                        {
                            pageTitle: t("shared:teams"),
                            href: (0, $6QJY8.RoutePaths).TEAMS
                        },
                        {
                            pageTitle: team.name
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                                    className: "fill-current w-6 h-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                                teamId: team.id,
                                userId: team.owner
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                            buttons: [
                                renderDeleteButton(),
                                renderEditButton()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.smallModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
                    handleClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-lg mb-3",
                            children: t("team:deleteTeamIntro")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                                        className: "sm:mr-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                                            className: "fill-current w-6 h-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                                        teamId: team.id,
                                        userId: team.owner
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-ch-blue-600",
                                children: t("team:deleteTeamDesc")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t("team:continueDelete")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>closeModal(),
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    children: t("shared:cancel")
                                }, "3"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: ()=>onDeleteTeam(),
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    children: t("team:deleteTeam")
                                }, "4")
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $825320441caee6ef$export$2e2bcd8739ae039 = $825320441caee6ef$var$TeamHeader;

});

parcelRegister("2RWR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d70afabf856516$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $4qaeN = parcelRequire("4qaeN");

var $bFoxZ = parcelRequire("bFoxZ");

var $jTkGE = parcelRequire("jTkGE");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $9jf6A = parcelRequire("9jf6A");

var $diMwb = parcelRequire("diMwb");

var $75Wrb = parcelRequire("75Wrb");

var $kYqkq = parcelRequire("kYqkq");

var $fKaTC = parcelRequire("fKaTC");
const $a1d70afabf856516$var$MdtTeamUsers = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const team = (0, $kYqkq.useAppSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const teamUsers = (0, $kYqkq.useAppSelector)((state)=>(0, $jTkGE.getTeamUsersByTeamId)(state, props.teamId));
    const { mdtRoles: mdtRoles } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const createTeamUsers = (values, { setSubmitting: setSubmitting })=>{
        const teamUser = {
            teamId: team.id,
            userIds: values.users
        };
        dispatch((0, $9jf6A.createTeamUser)(teamUser));
        setSubmitting(false);
        closeModal();
    };
    if (!team || !team.users) return null;
    const sortedTeamUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(teamUsers, (tu)=>mdtRoles.indexOf(tu.role));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("team:members"),
                                    " (",
                                    team.users.length,
                                    ")"
                                ]
                            }),
                            team.permissions && team.permissions.canInvite ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFoxZ.default), {
                                openModal: openModal,
                                label: t("team:mdt:manageUsers")
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex mb-2 items-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "shared:teamsIntro"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(sortedTeamUsers, (teamUser)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $diMwb.default), {
                                teamUserId: teamUser.id
                            }, teamUser.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75Wrb.default), {
                    closeModal: closeModal,
                    teamId: team.id,
                    createTeamUsers: createTeamUsers
                })
            })
        ]
    });
};
var $a1d70afabf856516$export$2e2bcd8739ae039 = $a1d70afabf856516$var$MdtTeamUsers;

});
parcelRegister("9jf6A", function(module, exports) {

$parcel$export(module.exports, "createTeamUser", () => $3be40d9c2b511d83$export$9e328b47fb393700);
$parcel$export(module.exports, "destroyTeamUser", () => $3be40d9c2b511d83$export$637ede7758953beb);

var $hflQv = parcelRequire("hflQv");
const $3be40d9c2b511d83$export$9e328b47fb393700 = (teamUserData)=>{
    return {
        type: (0, $hflQv.TeamUserActionTypes).CREATE_TEAM_USER_ASYNC_PENDING,
        payload: teamUserData
    };
};
const $3be40d9c2b511d83$export$637ede7758953beb = (teamUserId)=>{
    return {
        type: (0, $hflQv.TeamUserActionTypes).DESTROY_TEAM_USER_ASYNC_PENDING,
        payload: teamUserId
    };
};

});

parcelRegister("diMwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $22126d80fa683169$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $6lvMC = parcelRequire("6lvMC");

var $jTkGE = parcelRequire("jTkGE");

var $l30Z2 = parcelRequire("l30Z2");
const $22126d80fa683169$var$MdtTeamUserListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team",
        "shared"
    ]);
    const teamUser = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamUserByTeamUserId)(state, props));
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, teamUser));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3Rc9I.default), {
                    children: [
                        t("team:mdt:role"),
                        ": ",
                        teamUser.role
                    ]
                })
            ]
        })
    });
};
var $22126d80fa683169$export$2e2bcd8739ae039 = $22126d80fa683169$var$MdtTeamUserListItem;

});

parcelRegister("75Wrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $234bf720d2bdb76e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $5v6Bi = parcelRequire("5v6Bi");

var $6wDTk = parcelRequire("6wDTk");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $7jD0k = parcelRequire("7jD0k");

var $kYqkq = parcelRequire("kYqkq");

var $jTkGE = parcelRequire("jTkGE");

var $fKaTC = parcelRequire("fKaTC");

var $6lvMC = parcelRequire("6lvMC");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");

var $c34ph = parcelRequire("c34ph");

var $1g6OM = parcelRequire("1g6OM");

var $3eX0C = parcelRequire("3eX0C");
const $234bf720d2bdb76e$var$MdtManageUsersModalContent = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const team = (0, $kYqkq.useAppSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const { mdtRoles: mdtRoles } = (0, $kYqkq.useAppSelector)((0, $fKaTC.getTenantConfig));
    const teamUsers = (0, $kYqkq.useAppSelector)((state)=>(0, $jTkGE.getTeamUsersByTeamId)(state, team.id));
    const [userOptions, setUserOptions] = (0, $acw62.useState)([]);
    const users = (0, $kYqkq.useAppSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const [teamUsersData, setTeamUsersData] = (0, $acw62.useState)([]);
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const updateMdtTeamUsers = (teamUsers)=>dispatch((0, $3eX0C.updateTeamUsersAction)(team.id, {
            teamUsers: teamUsers
        }));
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(users);
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!team || !teamUsers) return;
        const sortedTeamUserData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(teamUsers, (user)=>mdtRoles.indexOf(user.role));
        setTeamUsersData(sortedTeamUserData);
    }, [
        team.teamUsers
    ]);
    if (teamUsersData.length == 0) return;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
        handleClose: props.closeModal,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg mb-3",
                children: t("team:inviteMembersIntro")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                                className: "fill-current w-6 h-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                            teamId: team.id,
                            userId: team.owner
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("team:inviteMembersDesc1")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("team:inviteMembersDesc2")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
                    initialValues: {
                        teamUsers: teamUsersData
                    },
                    onSubmit: (values)=>{
                        updateMdtTeamUsers(values.teamUsers);
                        props.closeModal();
                    },
                    children: ({ dirty: dirty, isSubmitting: isSubmitting })=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c34ph.default), {
                                    userOptions: userOptions
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex justify-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                        isDisabled: !dirty || isSubmitting,
                                        variant: (0, $jF0Xa.StyleVariants).ORANGE,
                                        isSubmit: true,
                                        children: t("shared:save")
                                    })
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
var $234bf720d2bdb76e$export$2e2bcd8739ae039 = $234bf720d2bdb76e$var$MdtManageUsersModalContent;

});


parcelRegister("8U3XH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f4fac1d5956a6a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4qaeN = parcelRequire("4qaeN");

var $bFoxZ = parcelRequire("bFoxZ");

var $jTkGE = parcelRequire("jTkGE");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $4us5i = parcelRequire("4us5i");

var $9jf6A = parcelRequire("9jf6A");

var $clNWO = parcelRequire("clNWO");
const $a6f4fac1d5956a6a$var$TeamUsers = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openModal = ()=>{
        setIsOpen(true);
    };
    const closeModal = ()=>{
        setIsOpen(false);
    };
    const createTeamUsers = (values, { setSubmitting: setSubmitting })=>{
        const teamUser = {
            teamId: team.id,
            userIds: values.users
        };
        dispatch((0, $9jf6A.createTeamUser)(teamUser));
        setSubmitting(false);
        closeModal();
    };
    const teamOwner = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamUserByUserIdAndTeamId)(state, props.teamId, team.owner));
    const sortedTeamUsers = team.teamUsers.sort((teamUserId1, teamUserId2)=>{
        if (teamUserId1 == teamOwner.id) return -1;
        if (teamUserId2 == teamOwner.id) return 1;
        return 0;
    });
    if (!team || !team.users) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
                className: "flex-col",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "mr-4 mb-2 text-lg",
                                children: [
                                    t("team:members"),
                                    " (",
                                    team.users.length,
                                    ")"
                                ]
                            }),
                            team.permissions && team.permissions.canInvite ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bFoxZ.default), {
                                openModal: openModal,
                                label: t("team:addMembers")
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex mb-2 items-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "flex-1 pr-10 lg:pr-24",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "shared:teamsIntro"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(sortedTeamUsers, (teamUserId)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $clNWO.default), {
                                teamId: props.teamId,
                                teamUserId: teamUserId,
                                teamOwnerId: team.owner
                            }, teamUserId);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
                isOpen: modalIsOpen,
                onRequestClose: closeModal,
                style: (0, $jF0Xa.defaultModalStyle),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4us5i.default), {
                    closeModal: closeModal,
                    teamId: team.id,
                    createTeamUsers: createTeamUsers
                })
            })
        ]
    });
};
var $a6f4fac1d5956a6a$export$2e2bcd8739ae039 = $a6f4fac1d5956a6a$var$TeamUsers;

});
parcelRegister("4us5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c916fb06b6b30b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $7jD0k = parcelRequire("7jD0k");

var $lOcoE = parcelRequire("lOcoE");

var $kYqkq = parcelRequire("kYqkq");

var $jTkGE = parcelRequire("jTkGE");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");

var $1g6OM = parcelRequire("1g6OM");
const $a8c916fb06b6b30b$var$AddTeamUsersModalContent = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared"
    ]);
    const team = (0, $kYqkq.useAppSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
        handleClose: props.closeModal,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg mb-3",
                children: t("team:inviteMembersIntro")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                            className: "sm:mr-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                                className: "fill-current w-6 h-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                            teamId: team.id,
                            userId: team.owner
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("team:inviteMembersDesc1")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "text-ch-blue-600",
                        children: t("team:inviteMembersDesc2")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lOcoE.default), {
                    submitHandler: props.createTeamUsers,
                    excludedUserIds: team.users,
                    userLabel: t("shared:chooseUsers", {
                        user: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).lowerCase(t("shared:member"))
                    }),
                    buttonText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                        i18nKey: "shared:addUsers",
                        values: {
                            users: t("shared:members"),
                            entity: t("shared:team")
                        }
                    }),
                    disableTeams: true
                })
            })
        ]
    });
};
var $a8c916fb06b6b30b$export$2e2bcd8739ae039 = $a8c916fb06b6b30b$var$AddTeamUsersModalContent;

});

parcelRegister("clNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6897332de061ef43$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $1Cmbh = parcelRequire("1Cmbh");

var $ejvqu = parcelRequire("ejvqu");

var $eEtn6 = parcelRequire("eEtn6");

var $3Rc9I = parcelRequire("3Rc9I");

var $j0coJ = parcelRequire("j0coJ");

var $6lvMC = parcelRequire("6lvMC");

var $l30Z2 = parcelRequire("l30Z2");

var $jTkGE = parcelRequire("jTkGE");

var $9jf6A = parcelRequire("9jf6A");

var $duILH = parcelRequire("duILH");
const $6897332de061ef43$var$TeamUserListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team",
        "shared"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const teamUser = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamUserByTeamUserId)(state, props));
    const user = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getUserByHasUserId)(state, teamUser));
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const ownerLabel = props.teamOwnerId == teamUser.userId ? (0, $duILH.default)(t("team:owner")) : null;
    const removeUserFromTeam = ()=>{
        dispatch((0, $9jf6A.destroyTeamUser)(props.teamUserId));
    };
    const renderRemoveButton = ()=>{
        if (props.teamOwnerId == teamUser.userId) return null;
        if (team.permissions.canUninvite) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0coJ.default), {
            action: removeUserFromTeam,
            label: t("shared:remove"),
            canRemove: true
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1Cmbh.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eEtn6.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l30Z2.default), {
                        user: user,
                        nameLabel: ownerLabel
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3Rc9I.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                        className: "items-center",
                        buttons: [
                            renderRemoveButton()
                        ]
                    })
                })
            ]
        })
    });
};
var $6897332de061ef43$export$2e2bcd8739ae039 = $6897332de061ef43$var$TeamUserListItem;

});
parcelRegister("duILH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91f669a1ae8e2c0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $a91f669a1ae8e2c0$var$OwnerLabel = (text)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "text-sm text-white px-2 rounded bg-ch-blue-500 ml-2",
        children: [
            text,
            " "
        ]
    });
};
var $a91f669a1ae8e2c0$export$2e2bcd8739ae039 = $a91f669a1ae8e2c0$var$OwnerLabel;

});




parcelRegister("47VIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $269df60f3f452783$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $COwA0 = parcelRequire("COwA0");

var $6QJY8 = parcelRequire("6QJY8");

var $4fo4Z = parcelRequire("4fo4Z");

var $3eX0C = parcelRequire("3eX0C");

var $9BBzO = parcelRequire("9BBzO");

var $8UrgM = parcelRequire("8UrgM");

var $4qaeN = parcelRequire("4qaeN");

var $d5eYa = parcelRequire("d5eYa");

var $jTkGE = parcelRequire("jTkGE");
const $269df60f3f452783$var$TeamEditPage = ()=>{
    const { teamId: teamId } = (0, $COwA0.useParams)();
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "team"
    ]);
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, teamId));
    const dispatch = (0, $2OPjR.useDispatch)();
    const fetchSpecialties = ()=>dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
    const fetchUsers = ()=>dispatch((0, $8UrgM.fetchAllUsersAsync)());
    const fetchTeam = (teamId)=>dispatch((0, $3eX0C.fetchTeamAsync)(teamId));
    (0, $acw62.useEffect)(()=>{
        fetchSpecialties();
        fetchUsers();
        fetchTeam(teamId);
    }, []);
    const viewTeamUrl = (0, $COwA0.generatePath)((0, $6QJY8.RoutePaths).TEAM, {
        teamId: teamId
    });
    const renderContent = ()=>{
        if (!team) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("team:teamNotFound")
        });
        if (!team.permissions.canEdit) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
            className: "text-lg",
            children: t("shared:notPermitted")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4qaeN.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "mb-2",
                    children: t("team:editTeam")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9BBzO.default), {
                    teamId: teamId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5eYa.default), {
                breadcrumbs: [
                    {
                        pageTitle: t("shared:team"),
                        href: viewTeamUrl
                    },
                    {
                        pageTitle: t("team:editTeam")
                    }
                ]
            }),
            renderContent()
        ]
    });
};
var $269df60f3f452783$export$2e2bcd8739ae039 = $269df60f3f452783$var$TeamEditPage;

});
parcelRegister("9BBzO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c129abd5ff2a92b7$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $c0FI2 = parcelRequire("c0FI2");

var $7YFi7 = parcelRequire("7YFi7");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $5GZlj = parcelRequire("5GZlj");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $d8Vwn = parcelRequire("d8Vwn");

var $48BqW = parcelRequire("48BqW");

var $6lvMC = parcelRequire("6lvMC");

var $lqbsE = parcelRequire("lqbsE");

var $jTkGE = parcelRequire("jTkGE");

var $3eX0C = parcelRequire("3eX0C");

var $6wDTk = parcelRequire("6wDTk");
const $c129abd5ff2a92b7$var$TeamEditForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "team"
    ]);
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [specialtiesOptions, setSpecialtiesOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, props.teamId));
    const users = (0, $iD0SF.useSelector)((state)=>(0, $6lvMC.getAllUsers)(state));
    const specialties = (0, $iD0SF.useSelector)((state)=>(0, $lqbsE.getAllSpecialties)(state));
    const dispatch = (0, $2OPjR.useDispatch)();
    const initialValues = {
        name: team.name,
        specialtyId: team.specialtyId,
        ownerId: team.owner
    };
    (0, $acw62.useEffect)(()=>{
        const options = (0, $6wDTk.buildUserOptions)(Object.values(users));
        setUserOptions(options);
    }, [
        team.users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = (0, $d8Vwn.generateSpecialtyOptions)(specialties);
        setSpecialtiesOptions(options);
    }, [
        specialties
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-left lg:pl-4 sm:pl-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $48BqW.teamNewValidationSchema)(),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                const data = (0, $48BqW.teamNewValidationSchema)().cast(values);
                dispatch((0, $3eX0C.updateTeamAsync)(props.teamId, data));
                setSubmitting(false);
            },
            children: ({ isSubmitting: isSubmitting, errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, dirty: dirty })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0FI2.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "name",
                                    required: true,
                                    children: t("team:teamName")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "name",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.name,
                                    autoComplete: "off",
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.name,
                                    isVisible: errors.name && touched.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "specialtyId",
                                    required: true,
                                    children: t("team:specialty")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "specialtyId",
                                    options: specialtiesOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    isGrouped: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.specialtyId,
                                    isVisible: errors.specialtyId && touched.specialtyId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "ownerId",
                                    required: true,
                                    children: t("team:owner")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
                                    name: "ownerId",
                                    options: userOptions,
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    filterOption: (0, $6wDTk.filterOptionsBySearchValue)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.ownerId,
                                    isVisible: errors.ownerId && touched.ownerId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                isDisabled: !dirty || isSubmitting,
                                variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                isSubmit: true,
                                children: t("updateTeam")
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $c129abd5ff2a92b7$export$2e2bcd8739ae039 = $c129abd5ff2a92b7$var$TeamEditForm;

});


parcelRegister("giWzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae40b722c954c49$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $CICYC = parcelRequire("CICYC");

var $fFGTN = parcelRequire("fFGTN");

var $kQILj = parcelRequire("kQILj");

var $8UrgM = parcelRequire("8UrgM");

var $aeos3 = parcelRequire("aeos3");

var $8amDV = parcelRequire("8amDV");

var $8g1PZ = parcelRequire("8g1PZ");

var $enXOt = parcelRequire("enXOt");

var $4fo4Z = parcelRequire("4fo4Z");

var $4xHCo = parcelRequire("4xHCo");

var $koaQF = parcelRequire("koaQF");
const $fae40b722c954c49$var$MessagesPage = ()=>{
    const { messagingEnabled: messagingEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const dispatch = (0, $2OPjR.useDispatch)();
    const updateSelectedChat = (chatId)=>dispatch((0, $CICYC.updateSelectedChatId)(chatId));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getChatsUI)(state));
    const isMobileView = (0, $koaQF.default)([
        "sm",
        "md"
    ]);
    const [isNewChatFormOpen, setIsNewChatFormOpen] = (0, $acw62.useState)(!isMobileView);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $8UrgM.fetchAllUsersAsync)());
        dispatch((0, $4fo4Z.fetchSpecialtiesAsync)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (UI.selectedChatId !== null) setIsNewChatFormOpen(false);
    }, [
        UI.selectedChatId
    ]);
    if (!messagingEnabled) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4xHCo.default), {
                selectedChatId: UI.selectedChatId,
                setSelectedChatId: updateSelectedChat,
                setIsNewChatFormOpen: setIsNewChatFormOpen,
                isNewChatFormOpen: isNewChatFormOpen
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-1 h-full bg-white border border-ch-gray-400 rounded-md overflow-hidden relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-col border-r border-ch-gray-400 bg-white w-full h-full absolute z-10 lg:w-1/3 lg:static", {
                            "hidden": UI.selectedChatId !== null || isMobileView && isNewChatFormOpen,
                            "lg:flex": UI.selectedChatId !== null
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fFGTN.default), {
                            selectedChatId: UI.selectedChatId,
                            setSelectedChatId: updateSelectedChat
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-1", {
                            hidden: !isNewChatFormOpen
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $enXOt.default), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex flex-1 overflow-hidden", {
                            hidden: isNewChatFormOpen
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8amDV.default), {
                            chatId: UI.selectedChatId
                        })
                    })
                ]
            })
        ]
    });
};
var $fae40b722c954c49$export$2e2bcd8739ae039 = $fae40b722c954c49$var$MessagesPage;

});
parcelRegister("CICYC", function(module, exports) {

$parcel$export(module.exports, "fetchChatsAsync", () => $05df76fb44ed2d7d$export$565802b5378d578f);
$parcel$export(module.exports, "updateSelectedChatId", () => $05df76fb44ed2d7d$export$e84ce2c0201b5936);

var $4VdtH = parcelRequire("4VdtH");
const $05df76fb44ed2d7d$export$565802b5378d578f = (searchQuery)=>{
    return {
        type: (0, $4VdtH.ChatsActionTypes).FETCH_CHATS_ASYNC_PENDING,
        payload: searchQuery
    };
};
const $05df76fb44ed2d7d$export$e84ce2c0201b5936 = (chatId)=>{
    return {
        type: (0, $4VdtH.ChatsActionTypes).UPDATED_SELECTED_CHAT_ID,
        payload: chatId
    };
};

});

parcelRegister("fFGTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8636c81b4848d15$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Jdgl = parcelRequire("9Jdgl");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $kQILj = parcelRequire("kQILj");

var $glc4D = parcelRequire("glc4D");

var $CICYC = parcelRequire("CICYC");

var $bHoWy = parcelRequire("bHoWy");

var $aEgqS = parcelRequire("aEgqS");

var $50Djh = parcelRequire("50Djh");

var $4KSAX = parcelRequire("4KSAX");
const $d8636c81b4848d15$var$ChatList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const chatIds = (0, $iD0SF.useSelector)((0, $fH7G0.getAllChatIds));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getChatsUI)(state));
    const initialSearchQuery = {
        page: 1,
        resultsPerPage: UI.resultsPerPage
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $CICYC.fetchChatsAsync));
    const chatListContainerRef = (0, $acw62.useRef)(null);
    const hasMore = ()=>{
        if (searchQuery.page < UI.totalPages) return true;
        return false;
    };
    const loadMore = ()=>{
        setSearchQuery({
            page: searchQuery.page + 1
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!props.selectedChatId) return;
        dispatch((0, $50Djh.markChatMessagesAsRead)(props.selectedChatId));
    }, [
        props.selectedChatId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "chatListContainer",
        ref: chatListContainerRef,
        className: "flex flex-1 flex-col h-full overflow-y-scroll",
        children: chatIds.length < 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p-4",
            children: t("message:index:noMessages")
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bHoWy.default), {
            dataLength: chatIds.length,
            next: loadMore,
            className: "flex flex-col px-4 pb-4",
            hasMore: hasMore(),
            loader: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center p-10",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {})
            }),
            scrollableTarget: "chatListContainer",
            children: chatIds.map((chatId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Jdgl.default), {
                    chatId: chatId,
                    setSelectedChatId: props.setSelectedChatId,
                    selectedChatId: props.selectedChatId
                }, chatId))
        })
    });
};
var $d8636c81b4848d15$export$2e2bcd8739ae039 = $d8636c81b4848d15$var$ChatList;

});
parcelRegister("9Jdgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba3ea184aa040a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $jA5LT = parcelRequire("jA5LT");

var $hMdrU = parcelRequire("hMdrU");

var $dLRng = parcelRequire("dLRng");

var $3rbzG = parcelRequire("3rbzG");

var $cyKQr = parcelRequire("cyKQr");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $1G6b2 = parcelRequire("1G6b2");

var $6lvMC = parcelRequire("6lvMC");

var $4KSAX = parcelRequire("4KSAX");

var $c0hbo = parcelRequire("c0hbo");

var $7w7k9 = parcelRequire("7w7k9");
const $ceba3ea184aa040a$var$ChatListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const isSelected = props.selectedChatId == props.chatId;
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const [filteredTypingUsers, setFilteredTypingUsers] = (0, $acw62.useState)([]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    (0, $acw62.useEffect)(()=>{
        const filteredUsers = chat?.usersTypingIds?.filter((userId)=>userId != currentUser.id);
        setFilteredTypingUsers(filteredUsers);
    }, [
        chat?.usersTypingIds
    ]);
    const renderTypingUsersText = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex-1 truncate text-xs italic text-ch-gray-500",
            children: [
                filteredTypingUsers.map((userId, index)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            index > 0 && ", ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0hbo.default), {
                                userId: userId
                            })
                        ]
                    }, `${index}-${userId}`);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        " ",
                        t("message:index:isTyping")
                    ]
                })
            ]
        });
    };
    const renderLatestMessage = ()=>{
        if (chat.endedAt !== null) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "self-end",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1G6b2.default), {
                chatId: props.chatId
            })
        });
        if (chat.options?.muted) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "self-end",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7w7k9.default), {
                chatId: props.chatId
            })
        });
        if (filteredTypingUsers?.length) return renderTypingUsersText();
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dLRng.default), {
                    chatId: props.chatId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3rbzG.default), {
                    chatId: props.chatId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "flex-1", "w-full", "px-2", "py-4", "my-px", "border-b", "ring-ch-blue-alt-300", "hover:ring-2", "hover:rounded-md", "hover:border-white", {
            "ring-2": isSelected,
            "rounded-md": isSelected,
            "border-white": isSelected,
            "border-ch-blue-alt-300": !isSelected,
            "cursor-pointer": !isSelected,
            "cursor-default": isSelected
        }),
        onClick: ()=>{
            props.setSelectedChatId(props.chatId);
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMdrU.default), {
                chatId: props.chatId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col flex-1 overflow-hidden mx-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cyKQr.default), {
                        chatId: props.chatId
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jA5LT.default), {
                        caseId: chat.case
                    }),
                    renderLatestMessage()
                ]
            })
        ]
    });
};
var $ceba3ea184aa040a$export$2e2bcd8739ae039 = $ceba3ea184aa040a$var$ChatListItem;

});
parcelRegister("jA5LT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67dc1dd4f28d606$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6t04b = parcelRequire("6t04b");

var $kon2z = parcelRequire("kon2z");
parcelRequire("jitSV");
var $6Hpf8 = parcelRequire("6Hpf8");
const $c67dc1dd4f28d606$var$ChatCaseTag = (props)=>{
    const chatCase = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getCaseById)(state, {
            caseId: props.caseId
        }));
    if (!chatCase) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "inline-flex border border-ch-gray-400 rounded-md p-1 mb-2 self-start",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Hpf8.default), {
                className: "fill-current w-4 h-4 mr-2 text-ch-purple-500"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6t04b.default), {
                className: "text-xs",
                firstName: chatCase.firstName,
                lastName: chatCase.lastName,
                title: chatCase.title,
                gender: chatCase.gender
            })
        ]
    });
};
var $c67dc1dd4f28d606$export$2e2bcd8739ae039 = $c67dc1dd4f28d606$var$ChatCaseTag;

});

parcelRegister("hMdrU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bdbb6d86ec807a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fpLIl = parcelRequire("fpLIl");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");
var $chRXN = parcelRequire("chRXN");
const $61bdbb6d86ec807a$var$ChatIcon = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const renderIcon = ()=>{
        if (chat.type == (0, $fpLIl.ChatTypes).TEAM) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
            className: "text-ch-purple-500 w-6 h-6"
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $chRXN.default), {
            className: "text-ch-purple-500 w-4 h-4"
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w-9 h-9 rounded-full bg-white flex items-center justify-center border border-ch-gray-500",
        children: renderIcon()
    });
};
var $61bdbb6d86ec807a$export$2e2bcd8739ae039 = $61bdbb6d86ec807a$var$ChatIcon;

});

parcelRegister("dLRng", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b4e12def1db930$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $d9b4e12def1db930$var$ChatLatestMessage = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    if (!chat?.latestMessage) return null;
    const renderAuthorText = ()=>{
        if (chat.users.length <= 1) return null;
        const authorUser = chat.latestMessage.createdBy;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "font-semibold",
            children: [
                authorUser.firstName,
                " ",
                authorUser.lastName,
                ":"
            ]
        });
    };
    const renderUnreadCount = ()=>{
        if (!chat.unreadCount || chat.unreadCount == 0) return null;
        const countText = chat.unreadCount < 99 ? chat.unreadCount.toString() : "9+";
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "bg-ch-blue-alt-500 text-white rounded-full w-5 h-5 text-sm flex justify-center items-center p-2",
            children: countText
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1 truncate text-xs italic", {
                    "text-ch-gray-500": chat.latestMessage.readAt != null,
                    "text-ch-blue-alt-500": chat.latestMessage.readAt == null
                }),
                children: [
                    renderAuthorText(),
                    " ",
                    chat.latestMessage.body
                ]
            }),
            renderUnreadCount()
        ]
    });
};
var $d9b4e12def1db930$export$2e2bcd8739ae039 = $d9b4e12def1db930$var$ChatLatestMessage;

});

parcelRegister("3rbzG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2b8a6e66b17f49$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $8g1PZ = parcelRequire("8g1PZ");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $pNlig = parcelRequire("pNlig");
const $5b2b8a6e66b17f49$var$ChatLatestMessageTime = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    if (!chat?.latestMessage) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $pNlig.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("text-xs", {
            "text-ch-gray-500": chat.latestMessage.readAt != null,
            "text-ch-blue-alt-500": chat.latestMessage.readAt == null
        }),
        utcTime: chat.latestMessage.createdAt
    });
};
var $5b2b8a6e66b17f49$export$2e2bcd8739ae039 = $5b2b8a6e66b17f49$var$ChatLatestMessageTime;

});

parcelRegister("cyKQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c64873ab4c4cfeb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fpLIl = parcelRequire("fpLIl");

var $jTkGE = parcelRequire("jTkGE");

var $igPDP = parcelRequire("igPDP");
const $9c64873ab4c4cfeb$var$ChatTitle = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, chat.team));
    const renderTitleText = ()=>{
        if (chat.type == (0, $fpLIl.ChatTypes).TEAM) return renderTeamText();
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $igPDP.default), {
            chatId: props.chatId
        });
    };
    const renderTeamText = ()=>{
        if (!team) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: team.name
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "font-semibold text-sm truncate mb-1",
        children: renderTitleText()
    });
};
var $9c64873ab4c4cfeb$export$2e2bcd8739ae039 = $9c64873ab4c4cfeb$var$ChatTitle;

});
parcelRegister("igPDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b436059e865624$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $c0hbo = parcelRequire("c0hbo");
const $42b436059e865624$var$ChatTitleUserList = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const [filteredUsers, setFilteredUsers] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const _filteredUsers = chat.users.filter((userId)=>userId != currentUser.id);
        setFilteredUsers(_filteredUsers);
    }, [
        chat.users
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: filteredUsers.map((userId, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    index > 0 && ", ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0hbo.default), {
                        userId: userId
                    })
                ]
            }, `${index}-${userId}`);
        })
    });
};
var $42b436059e865624$export$2e2bcd8739ae039 = $42b436059e865624$var$ChatTitleUserList;

});


parcelRegister("1G6b2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab6b9af6063ca93$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $1ab6b9af6063ca93$var$ChatClosedText = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    if (!chat?.endedAt) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-sm text-white px-1 rounded bg-ch-gray-600 ml-2 flex content-center lowercase text-sm",
        children: t("message:index:closed")
    });
};
var $1ab6b9af6063ca93$export$2e2bcd8739ae039 = $1ab6b9af6063ca93$var$ChatClosedText;

});

parcelRegister("7w7k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab059eec68ef439$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");
const $cab059eec68ef439$var$ChatMutedText = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    if (!chat?.options?.muted || chat.endedAt !== null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-sm text-white px-1 rounded bg-ch-gray-400 ml-2 flex content-center lowercase text-sm",
        children: t("message:index:muted")
    });
};
var $cab059eec68ef439$export$2e2bcd8739ae039 = $cab059eec68ef439$var$ChatMutedText;

});



parcelRegister("8amDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68b9c055ac61db0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dvwAv = parcelRequire("dvwAv");

var $h8nTc = parcelRequire("h8nTc");

var $7W17n = parcelRequire("7W17n");

var $4KSAX = parcelRequire("4KSAX");
const $b68b9c055ac61db0$var$ChatView = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    if (!props.chatId) return null;
    const renderMessageList = ()=>{
        if (!props.chatId) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "flex justify-center text-ch-blue-alt-300 italic text-sm p-4",
            children: t("message:index:selectAChat")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8nTc.default), {
            chatId: props.chatId
        }, props.chatId);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-1 flex-col h-full overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-4 pt-4 pb-2 border-b border-ch-gray-400",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dvwAv.default), {
                    chatId: props.chatId
                }, props.chatId)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 h-full overflow-hidden",
                children: renderMessageList()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4 border-t border-ch-gray-400",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7W17n.default), {
                    chatId: props.chatId
                }, props.chatId)
            })
        ]
    });
};
var $b68b9c055ac61db0$export$2e2bcd8739ae039 = $b68b9c055ac61db0$var$ChatView;

});
parcelRegister("dvwAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a66592e8d05700$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cyKQr = parcelRequire("cyKQr");

var $hMdrU = parcelRequire("hMdrU");

var $9mZQc = parcelRequire("9mZQc");

var $1G6b2 = parcelRequire("1G6b2");

var $gAckH = parcelRequire("gAckH");

var $7w7k9 = parcelRequire("7w7k9");
const $d9a66592e8d05700$var$ChatHeader = (props)=>{
    if (!props.chatId) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex mb-2 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMdrU.default), {
                        chatId: props.chatId
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex-1 overflow-hidden mx-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cyKQr.default), {
                            chatId: props.chatId
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex self-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1G6b2.default), {
                                chatId: props.chatId
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7w7k9.default), {
                                chatId: props.chatId
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gAckH.default), {
                                chatId: props.chatId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mZQc.default), {
                chatId: props.chatId
            })
        ]
    });
};
var $d9a66592e8d05700$export$2e2bcd8739ae039 = $d9a66592e8d05700$var$ChatHeader;

});
parcelRegister("9mZQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $efaf8fb4f8f61841$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $koaQF = parcelRequire("koaQF");

var $fH7G0 = parcelRequire("fH7G0");

var $aVAGa = parcelRequire("aVAGa");

var $jA5LT = parcelRequire("jA5LT");
const $efaf8fb4f8f61841$var$ChatCaseDetails = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const isMobileView = (0, $koaQF.default)([
        "sm",
        "md"
    ]);
    if (!chat?.case) return null;
    if (isMobileView) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jA5LT.default), {
        caseId: chat.case
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVAGa.default), {
            caseId: chat.case,
            hasSmallText: true
        })
    });
};
var $efaf8fb4f8f61841$export$2e2bcd8739ae039 = $efaf8fb4f8f61841$var$ChatCaseDetails;

});
parcelRegister("koaQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b4f9304ee24d48$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8wgFo = parcelRequire("8wgFo");
const $e6b4f9304ee24d48$var$useIsMobileView = (breakpoints = [
    "sm"
])=>{
    const currentBreakpoint = (0, $8wgFo.default)();
    const mobileViewBreakpoints = breakpoints;
    const checkMobileView = ()=>{
        return mobileViewBreakpoints.includes(currentBreakpoint) || currentBreakpoint == undefined;
    };
    const [isMobileView, setIsMobileView] = (0, $acw62.useState)(checkMobileView());
    (0, $acw62.useEffect)(()=>{
        setIsMobileView(checkMobileView());
    }, [
        currentBreakpoint
    ]);
    return isMobileView;
};
var $e6b4f9304ee24d48$export$2e2bcd8739ae039 = $e6b4f9304ee24d48$var$useIsMobileView;

});
parcelRegister("8wgFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $af44128f22a5f028$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $heFOw = parcelRequire("heFOw");

var $iK6Ns = parcelRequire("iK6Ns");
const $af44128f22a5f028$var$useCurrentBreakPoint = ()=>{
    const windowSize = (0, $iK6Ns.default)();
    const [currentBreakpoint, setCurrentBreakpoint] = (0, $acw62.useState)((0, $heFOw.getCurrentBreakpoint)());
    (0, $acw62.useEffect)(()=>{
        setCurrentBreakpoint((0, $heFOw.getCurrentBreakpoint)());
    }, [
        windowSize
    ]);
    return currentBreakpoint;
};
var $af44128f22a5f028$export$2e2bcd8739ae039 = $af44128f22a5f028$var$useCurrentBreakPoint;

});
parcelRegister("heFOw", function(module, exports) {

$parcel$export(module.exports, "getCurrentBreakpoint", () => $19c01f692227a30a$export$ac5066de11224e74);

var $39A9O = parcelRequire("39A9O");

var $2mJUK = parcelRequire("2mJUK");
const $19c01f692227a30a$var$fullConfig = (0, (/*@__PURE__*/$parcel$interopDefault($39A9O)))((0, (/*@__PURE__*/$parcel$interopDefault($2mJUK))));
const $19c01f692227a30a$export$4adb988360925c51 = (value)=>+$19c01f692227a30a$var$fullConfig.theme.screens[value].slice(0, $19c01f692227a30a$var$fullConfig.theme.screens[value].indexOf("px"));
const $19c01f692227a30a$export$ac5066de11224e74 = ()=>{
    let currentBreakpoint;
    let biggestBreakpointValue = 0;
    for (const breakpoint of Object.keys($19c01f692227a30a$var$fullConfig.theme.screens)){
        const breakpointValue = $19c01f692227a30a$export$4adb988360925c51(breakpoint);
        if (breakpointValue > biggestBreakpointValue && window.innerWidth >= breakpointValue) {
            biggestBreakpointValue = breakpointValue;
            currentBreakpoint = breakpoint;
        }
    }
    return currentBreakpoint;
};

});
parcelRegister("39A9O", function(module, exports) {

var $lLWUp = parcelRequire("lLWUp");
var $24be4275a1c9d540$require$resolveConfigObjects = $lLWUp.default;

var $iBkDe = parcelRequire("iBkDe");
var $24be4275a1c9d540$require$getAllConfigs = $iBkDe.default;
module.exports = function resolveConfig(...configs) {
    const [, ...defaultConfigs] = $24be4275a1c9d540$require$getAllConfigs(configs[0]);
    return $24be4275a1c9d540$require$resolveConfigObjects([
        ...configs,
        ...defaultConfigs
    ]);
};

});
parcelRegister("lLWUp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd9baed76f09785d$var$resolveConfig;

var $fd9baed76f09785d$var$_some = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("hFXkP")));

var $fd9baed76f09785d$var$_mergeWith = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("cHPb0")));

var $fd9baed76f09785d$var$_isFunction = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("01ubZ")));

var $fd9baed76f09785d$var$_isUndefined = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("enrJD")));

var $fd9baed76f09785d$var$_defaults = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("1SWLj")));

var $fd9baed76f09785d$var$_map = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("437iZ")));

var $fd9baed76f09785d$var$_get = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("i51gj")));

var $fd9baed76f09785d$var$_uniq = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("8l7PP")));

var $fd9baed76f09785d$var$_toPath = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("ilhTG")));

var $fd9baed76f09785d$var$_head = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("6ormU")));

var $fd9baed76f09785d$var$_isPlainObject = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("xMy82")));

var $fd9baed76f09785d$var$_negateValue = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("fhXaf")));

var $fd9baed76f09785d$var$_corePluginList = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("76uRD")));

var $fd9baed76f09785d$var$_configurePlugins = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("iRqEt")));

var $fd9baed76f09785d$var$_defaultConfig = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("eQjhe")));

var $fd9baed76f09785d$var$_colors = $fd9baed76f09785d$var$_interopRequireDefault((parcelRequire("5pY61")));
function $fd9baed76f09785d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fd9baed76f09785d$var$configUtils = {
    colors: $fd9baed76f09785d$var$_colors.default,
    negative (scale) {
        return Object.keys(scale).filter((key)=>scale[key] !== '0').reduce((negativeScale, key)=>({
                ...negativeScale,
                [`-${key}`]: (0, $fd9baed76f09785d$var$_negateValue.default)(scale[key])
            }), {});
    },
    breakpoints (screens) {
        return Object.keys(screens).filter((key)=>typeof screens[key] === 'string').reduce((breakpoints, key)=>({
                ...breakpoints,
                [`screen-${key}`]: screens[key]
            }), {});
    }
};
function $fd9baed76f09785d$var$value(valueToResolve, ...args) {
    return (0, $fd9baed76f09785d$var$_isFunction.default)(valueToResolve) ? valueToResolve(...args) : valueToResolve;
}
function $fd9baed76f09785d$var$collectExtends(items) {
    return items.reduce((merged, { extend: extend })=>{
        return (0, $fd9baed76f09785d$var$_mergeWith.default)(merged, extend, (mergedValue, extendValue)=>{
            if ((0, $fd9baed76f09785d$var$_isUndefined.default)(mergedValue)) return [
                extendValue
            ];
            if (Array.isArray(mergedValue)) return [
                extendValue,
                ...mergedValue
            ];
            return [
                extendValue,
                mergedValue
            ];
        });
    }, {});
}
function $fd9baed76f09785d$var$mergeThemes(themes) {
    return {
        ...themes.reduce((merged, theme)=>(0, $fd9baed76f09785d$var$_defaults.default)(merged, theme), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: $fd9baed76f09785d$var$collectExtends(themes)
    };
}
function $fd9baed76f09785d$var$mergeExtensionCustomizer(merged, value) {
    // When we have an array of objects, we do want to merge it
    if (Array.isArray(merged) && (0, $fd9baed76f09785d$var$_isPlainObject.default)((0, $fd9baed76f09785d$var$_head.default)(merged))) return merged.concat(value);
     // When the incoming value is an array, and the existing config is an object, prepend the existing object
    if (Array.isArray(value) && (0, $fd9baed76f09785d$var$_isPlainObject.default)((0, $fd9baed76f09785d$var$_head.default)(value)) && (0, $fd9baed76f09785d$var$_isPlainObject.default)(merged)) return [
        merged,
        ...value
    ];
     // Override arrays (for example for font-families, box-shadows, ...)
    if (Array.isArray(value)) return value;
     // Execute default behaviour
    return undefined;
}
function $fd9baed76f09785d$var$mergeExtensions({ extend: extend, ...theme }) {
    return (0, $fd9baed76f09785d$var$_mergeWith.default)(theme, extend, (themeValue, extensions)=>{
        // The `extend` property is an array, so we need to check if it contains any functions
        if (!(0, $fd9baed76f09785d$var$_isFunction.default)(themeValue) && !(0, $fd9baed76f09785d$var$_some.default)(extensions, $fd9baed76f09785d$var$_isFunction.default)) return (0, $fd9baed76f09785d$var$_mergeWith.default)({}, themeValue, ...extensions, $fd9baed76f09785d$var$mergeExtensionCustomizer);
        return (resolveThemePath, utils)=>(0, $fd9baed76f09785d$var$_mergeWith.default)({}, ...[
                themeValue,
                ...extensions
            ].map((e)=>$fd9baed76f09785d$var$value(e, resolveThemePath, utils)), $fd9baed76f09785d$var$mergeExtensionCustomizer);
    });
}
function $fd9baed76f09785d$var$resolveFunctionKeys(object) {
    const resolvePath = (key, defaultValue)=>{
        const path = (0, $fd9baed76f09785d$var$_toPath.default)(key);
        let index = 0;
        let val = object;
        while(val !== undefined && val !== null && index < path.length){
            val = val[path[index++]];
            val = (0, $fd9baed76f09785d$var$_isFunction.default)(val) ? val(resolvePath, $fd9baed76f09785d$var$configUtils) : val;
        }
        return val === undefined ? defaultValue : val;
    };
    return Object.keys(object).reduce((resolved, key)=>{
        return {
            ...resolved,
            [key]: (0, $fd9baed76f09785d$var$_isFunction.default)(object[key]) ? object[key](resolvePath, $fd9baed76f09785d$var$configUtils) : object[key]
        };
    }, {});
}
function $fd9baed76f09785d$var$extractPluginConfigs(configs) {
    let allConfigs = [];
    configs.forEach((config)=>{
        allConfigs = [
            ...allConfigs,
            config
        ];
        const plugins = (0, $fd9baed76f09785d$var$_get.default)(config, 'plugins', []);
        if (plugins.length === 0) return;
        plugins.forEach((plugin)=>{
            if (plugin.__isOptionsFunction) plugin = plugin();
            allConfigs = [
                ...allConfigs,
                ...$fd9baed76f09785d$var$extractPluginConfigs([
                    (0, $fd9baed76f09785d$var$_get.default)(plugin, 'config', {})
                ])
            ];
        });
    });
    return allConfigs;
}
function $fd9baed76f09785d$var$mergeVariants(variants) {
    const mergedVariants = variants.reduce((resolved, variants)=>{
        Object.entries(variants || {}).forEach(([plugin, pluginVariants])=>{
            if ((0, $fd9baed76f09785d$var$_isFunction.default)(pluginVariants)) resolved[plugin] = pluginVariants({
                variants (path) {
                    return (0, $fd9baed76f09785d$var$_get.default)(resolved, path, []);
                },
                before (toInsert, variant, existingPluginVariants = (0, $fd9baed76f09785d$var$_get.default)(resolved, plugin, [])) {
                    if (variant === undefined) return [
                        ...toInsert,
                        ...existingPluginVariants
                    ];
                    const index = existingPluginVariants.indexOf(variant);
                    if (index === -1) return [
                        ...existingPluginVariants,
                        ...toInsert
                    ];
                    return [
                        ...existingPluginVariants.slice(0, index),
                        ...toInsert,
                        ...existingPluginVariants.slice(index)
                    ];
                },
                after (toInsert, variant, existingPluginVariants = (0, $fd9baed76f09785d$var$_get.default)(resolved, plugin, [])) {
                    if (variant === undefined) return [
                        ...existingPluginVariants,
                        ...toInsert
                    ];
                    const index = existingPluginVariants.indexOf(variant);
                    if (index === -1) return [
                        ...toInsert,
                        ...existingPluginVariants
                    ];
                    return [
                        ...existingPluginVariants.slice(0, index + 1),
                        ...toInsert,
                        ...existingPluginVariants.slice(index + 1)
                    ];
                },
                without (toRemove, existingPluginVariants = (0, $fd9baed76f09785d$var$_get.default)(resolved, plugin, [])) {
                    return existingPluginVariants.filter((v)=>!toRemove.includes(v));
                }
            });
            else resolved[plugin] = pluginVariants;
        });
        return resolved;
    }, {});
    return {
        ...mergedVariants,
        extend: $fd9baed76f09785d$var$collectExtends(variants)
    };
}
function $fd9baed76f09785d$var$mergeVariantExtensions({ extend: extend, ...variants }, variantOrder) {
    return (0, $fd9baed76f09785d$var$_mergeWith.default)(variants, extend, (variantsValue, extensions)=>{
        const merged = (0, $fd9baed76f09785d$var$_uniq.default)([
            ...variantsValue || [],
            ...extensions
        ].flat());
        if (extensions.flat().length === 0) return merged;
        return merged.sort((a, z)=>variantOrder.indexOf(a) - variantOrder.indexOf(z));
    });
}
function $fd9baed76f09785d$var$resolveVariants([firstConfig, ...variantConfigs], variantOrder) {
    // Global variants configuration like `variants: ['hover', 'focus']`
    if (Array.isArray(firstConfig)) return firstConfig;
    return $fd9baed76f09785d$var$mergeVariantExtensions($fd9baed76f09785d$var$mergeVariants([
        firstConfig,
        ...variantConfigs
    ].reverse()), variantOrder);
}
function $fd9baed76f09785d$var$resolveCorePlugins(corePluginConfigs) {
    const result = [
        ...corePluginConfigs
    ].reduceRight((resolved, corePluginConfig)=>{
        if ((0, $fd9baed76f09785d$var$_isFunction.default)(corePluginConfig)) return corePluginConfig({
            corePlugins: resolved
        });
        return (0, $fd9baed76f09785d$var$_configurePlugins.default)(corePluginConfig, resolved);
    }, $fd9baed76f09785d$var$_corePluginList.default).slice().sort((a, z)=>Math.sign($fd9baed76f09785d$var$_corePluginList.default.indexOf(a) - $fd9baed76f09785d$var$_corePluginList.default.indexOf(z)));
    return result;
}
function $fd9baed76f09785d$var$resolvePluginLists(pluginLists) {
    const result = [
        ...pluginLists
    ].reduceRight((resolved, pluginList)=>{
        return [
            ...resolved,
            ...pluginList
        ];
    }, []);
    return result;
}
function $fd9baed76f09785d$var$resolveConfig(configs) {
    const allConfigs = [
        ...$fd9baed76f09785d$var$extractPluginConfigs(configs),
        {
            darkMode: false,
            prefix: '',
            important: false,
            separator: ':',
            variantOrder: $fd9baed76f09785d$var$_defaultConfig.default.variantOrder
        }
    ];
    const { variantOrder: variantOrder } = allConfigs.find((c)=>c.variantOrder);
    return (0, $fd9baed76f09785d$var$_defaults.default)({
        theme: $fd9baed76f09785d$var$resolveFunctionKeys($fd9baed76f09785d$var$mergeExtensions($fd9baed76f09785d$var$mergeThemes((0, $fd9baed76f09785d$var$_map.default)(allConfigs, (t)=>(0, $fd9baed76f09785d$var$_get.default)(t, 'theme', {}))))),
        variants: $fd9baed76f09785d$var$resolveVariants(allConfigs.map((c)=>(0, $fd9baed76f09785d$var$_get.default)(c, 'variants', {})), variantOrder),
        corePlugins: $fd9baed76f09785d$var$resolveCorePlugins(allConfigs.map((c)=>c.corePlugins)),
        plugins: $fd9baed76f09785d$var$resolvePluginLists(configs.map((c)=>(0, $fd9baed76f09785d$var$_get.default)(c, 'plugins', [])))
    }, ...allConfigs);
}

});
parcelRegister("hFXkP", function(module, exports) {

var $eFBTL = parcelRequire("eFBTL");

var $7MWok = parcelRequire("7MWok");

var $c5Efq = parcelRequire("c5Efq");

var $o8HxT = parcelRequire("o8HxT");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $cde44aad7de4d096$var$some(collection, predicate, guard) {
    var func = $o8HxT(collection) ? $eFBTL : $c5Efq;
    if (guard && $b8mN0(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7MWok(predicate, 3));
}
module.exports = $cde44aad7de4d096$var$some;

});
parcelRegister("c5Efq", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8cd52c0fe2cccbdf$var$baseSome(collection, predicate) {
    var result;
    $4DjQp(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $8cd52c0fe2cccbdf$var$baseSome;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});



parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eMthh(object) && $iyUuu(index, object.length) : type == 'string' && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});


parcelRegister("cHPb0", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $940132c5229936a0$var$mergeWith = $i1jm6(function(object, source, srcIndex, customizer) {
    $4uZ7x(object, source, srcIndex, customizer);
});
module.exports = $940132c5229936a0$var$mergeWith;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});

parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});


parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});


parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});

parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});
parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});


parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});






parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});
parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + '');
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});
parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9HRmE(string),
        'writable': true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});
parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});


parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});





parcelRegister("enrJD", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a778ba4a8bc65100$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a778ba4a8bc65100$var$isUndefined;

});

parcelRegister("1SWLj", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $6TC8i = parcelRequire("6TC8i");

var $b8mN0 = parcelRequire("b8mN0");

var $f4lqP = parcelRequire("f4lqP");
/** Used for built-in method references. */ var $15f86a7fdfb0f225$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15f86a7fdfb0f225$var$hasOwnProperty = $15f86a7fdfb0f225$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $15f86a7fdfb0f225$var$defaults = $5iyRF(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $b8mN0(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $f4lqP(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $6TC8i(value, $15f86a7fdfb0f225$var$objectProto[key]) && !$15f86a7fdfb0f225$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $15f86a7fdfb0f225$var$defaults;

});

parcelRegister("437iZ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $o8HxT(collection) ? $i46jW : $fDc61;
    return func(collection, $7MWok(iteratee, 3));
}
module.exports = $2f2d1bf022ac3e3d$var$map;

});
parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});


parcelRegister("8l7PP", function(module, exports) {

var $5VSS6 = parcelRequire("5VSS6");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $61265cbd5811e578$var$uniq(array) {
    return array && array.length ? $5VSS6(array) : [];
}
module.exports = $61265cbd5811e578$var$uniq;

});
parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});



parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});




parcelRegister("ilhTG", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $aA0pv = parcelRequire("aA0pv");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");

var $lnP3M = parcelRequire("lnP3M");

var $6DSvu = parcelRequire("6DSvu");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $d5a812248d162412$var$toPath(value) {
    if ($o8HxT(value)) return $i46jW(value, $6DSvu);
    return $9dr3u(value) ? [
        value
    ] : $aA0pv($lnP3M($l6E2L(value)));
}
module.exports = $d5a812248d162412$var$toPath;

});

parcelRegister("6ormU", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $4a7a36c8a74a513c$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $4a7a36c8a74a513c$var$head;

});

parcelRegister("fhXaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2165659fe642f88$var$_default;

var $b2165659fe642f88$var$_reduceCssCalc = $b2165659fe642f88$var$_interopRequireDefault((parcelRequire("ehBi2")));
function $b2165659fe642f88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2165659fe642f88$var$_default(value) {
    try {
        return (0, $b2165659fe642f88$var$_reduceCssCalc.default)(`calc(${value} * -1)`);
    } catch (e) {
        return value;
    }
}

});
parcelRegister("ehBi2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6opgq = parcelRequire("6opgq");
var $a65f94378883d653$var$_postcssValueParser2 = $a65f94378883d653$var$_interopRequireDefault($6opgq);

var $3rJ6l = parcelRequire("3rJ6l");

var $J7DJt = parcelRequire("J7DJt");
var $a65f94378883d653$var$_reducer2 = $a65f94378883d653$var$_interopRequireDefault($J7DJt);

var $hlvSk = parcelRequire("hlvSk");
var $a65f94378883d653$var$_stringifier2 = $a65f94378883d653$var$_interopRequireDefault($hlvSk);
function $a65f94378883d653$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $a65f94378883d653$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
module.exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $a65f94378883d653$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== 'function' || !$a65f94378883d653$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $a65f94378883d653$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;
        var ast = $3rJ6l.parser.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $a65f94378883d653$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = 'word';
        node.value = (0, $a65f94378883d653$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
module.exports = module.exports['default'];

});
parcelRegister("6opgq", function(module, exports) {

var $fHKCb = parcelRequire("fHKCb");

var $i2K2q = parcelRequire("i2K2q");

var $fSXl4 = parcelRequire("fSXl4");
function $4a7894e05cef961d$var$ValueParser(value) {
    if (this instanceof $4a7894e05cef961d$var$ValueParser) {
        this.nodes = $fHKCb(value);
        return this;
    }
    return new $4a7894e05cef961d$var$ValueParser(value);
}
$4a7894e05cef961d$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $fSXl4(this.nodes) : "";
};
$4a7894e05cef961d$var$ValueParser.prototype.walk = function(cb, bubble) {
    $i2K2q(this.nodes, cb, bubble);
    return this;
};

$4a7894e05cef961d$var$ValueParser.unit = (parcelRequire("c2Or4"));
$4a7894e05cef961d$var$ValueParser.walk = $i2K2q;
$4a7894e05cef961d$var$ValueParser.stringify = $fSXl4;
module.exports = $4a7894e05cef961d$var$ValueParser;

});
parcelRegister("fHKCb", function(module, exports) {
var $b6ef07ea4ebc42b5$var$openParentheses = "(".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$closeParentheses = ")".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$singleQuote = "'".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$doubleQuote = '"'.charCodeAt(0);
var $b6ef07ea4ebc42b5$var$backslash = "\\".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$slash = "/".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$comma = ",".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$colon = ":".charCodeAt(0);
var $b6ef07ea4ebc42b5$var$star = "*".charCodeAt(0);
module.exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $b6ef07ea4ebc42b5$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $b6ef07ea4ebc42b5$var$comma || code === $b6ef07ea4ebc42b5$var$colon || code === $b6ef07ea4ebc42b5$var$slash && value.charCodeAt(next + 1) !== $b6ef07ea4ebc42b5$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $b6ef07ea4ebc42b5$var$singleQuote || code === $b6ef07ea4ebc42b5$var$doubleQuote) {
            next = pos;
            quote = code === $b6ef07ea4ebc42b5$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $b6ef07ea4ebc42b5$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $b6ef07ea4ebc42b5$var$slash && value.charCodeAt(pos + 1) === $b6ef07ea4ebc42b5$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $b6ef07ea4ebc42b5$var$slash || code === $b6ef07ea4ebc42b5$var$comma || code === $b6ef07ea4ebc42b5$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($b6ef07ea4ebc42b5$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $b6ef07ea4ebc42b5$var$singleQuote && code !== $b6ef07ea4ebc42b5$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $b6ef07ea4ebc42b5$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($b6ef07ea4ebc42b5$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $b6ef07ea4ebc42b5$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $b6ef07ea4ebc42b5$var$singleQuote || code === $b6ef07ea4ebc42b5$var$doubleQuote || code === $b6ef07ea4ebc42b5$var$comma || code === $b6ef07ea4ebc42b5$var$colon || code === $b6ef07ea4ebc42b5$var$slash || code === $b6ef07ea4ebc42b5$var$openParentheses || code === $b6ef07ea4ebc42b5$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($b6ef07ea4ebc42b5$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};

});

parcelRegister("i2K2q", function(module, exports) {
module.exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};

});

parcelRegister("fSXl4", function(module, exports) {
function $b909eda1b6e43f7c$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $b909eda1b6e43f7c$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $b909eda1b6e43f7c$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $b909eda1b6e43f7c$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $b909eda1b6e43f7c$var$stringifyNode(nodes, custom);
}
module.exports = $b909eda1b6e43f7c$var$stringify;

});

parcelRegister("c2Or4", function(module, exports) {
var $8c4ccb6661be4d03$var$minus = "-".charCodeAt(0);
var $8c4ccb6661be4d03$var$plus = "+".charCodeAt(0);
var $8c4ccb6661be4d03$var$dot = ".".charCodeAt(0);
var $8c4ccb6661be4d03$var$exp = "e".charCodeAt(0);
var $8c4ccb6661be4d03$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $8c4ccb6661be4d03$var$exp || code === $8c4ccb6661be4d03$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $8c4ccb6661be4d03$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $8c4ccb6661be4d03$var$plus || code === $8c4ccb6661be4d03$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});


parcelRegister("3rJ6l", function(module, exports) {

$parcel$export(module.exports, "parser", () => $2826e0e4c4ca3c4e$export$8f49e4af10703ce3, (v) => $2826e0e4c4ca3c4e$export$8f49e4af10703ce3 = v);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $2826e0e4c4ca3c4e$export$8f49e4af10703ce3;
var $2826e0e4c4ca3c4e$export$7acfa6ed01010e37;
var $2826e0e4c4ca3c4e$export$98e6a39c04603d36;
var $2826e0e4c4ca3c4e$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, 'name', {
            enumerable: false,
            writable: false,
            value: 'JisonParserError'
        });
        if (msg == null) msg = '???';
        Object.defineProperty(this, 'message', {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty('captureStackTrace')) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = 'JisonParserError';
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === 'function') {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return 'end of input';
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: 'MathExpression',
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: 'Calc',
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: 'Value',
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: 'CssVariable',
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: 'LengthValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: 'AngleValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: 'TimeValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: 'FrequencyValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: 'ResolutionValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: 'EmValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'em'
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: 'ExValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ex'
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: 'ChValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'ch'
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: 'RemValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'rem'
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: 'VhValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vh'
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: 'VwValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vw'
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: 'VminValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmin'
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: 'VmaxValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: 'vmax'
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: 'PercentageValue',
                        value: parseFloat(yyvstack[yysp]),
                        unit: '%'
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === 'function') this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === 'function') this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== 'function') ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error('assertion failed: ' + (msg || '***'));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === 'function') this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === 'function') this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== 'undefined') resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === 'function') {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === 'function') lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === 'number') errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                            else errStr = 'Parse error: ';
                            if (typeof lexer.showPosition === 'function') errStr += '\n' + lexer.showPosition(69, 10) + '\n';
                            if (expected.length) errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                            else errStr += 'Unexpected ' + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== 'undefined') retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== 'undefined') retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== 'undefined') {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== 'undefined') retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, 'name', {
                enumerable: false,
                writable: false,
                value: 'JisonLexerError'
            });
            if (msg == null) msg = '???';
            Object.defineProperty(this, 'message', {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty('captureStackTrace')) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, 'stack', {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = 'JisonLexerError';
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: '',
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: '',
            matched: '',
            matches: false,
            yytext: '',
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = '' + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === 'function') {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += '\n';
                        msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === 'function') {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') msg += '\n' + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === 'object') this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === 'function') return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === 'function') return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = '';
                if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput('', {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === 'function') el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = '';
                this.yyleng = 0;
                this.match = '';
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === 'number') rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || '';
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== 'string') {
                    if (rv) this._input = '' + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === '\n') lines = true;
                else if (ch === '\r') {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === '\n') {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = '';
                    if (this.yylloc) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(-maxLines);
                past = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = '...' + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, '\n').split('\n');
                a = a.slice(0, maxLines);
                next = a.join('\n');
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + '...';
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split('\n');
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(' ');
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ': ' + line;
                    var errpfx = new Array(lineno_display_width + 1).join('^');
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join('.');
                        var mark = new Array(len).join('^');
                        rv += '\n' + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, ' ');
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
                    intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join('\n');
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = 'line ' + l1 + ', ';
                    if (dc <= 1) rv += 'column ' + c1;
                    else rv += 'columns ' + c1 + ' .. ' + c2;
                } else rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += ' {String Offset: ' + r1 + '}';
                    else rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = '';
                        if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = '';
                    if (this.options.trackPosition) lineno_msg = ' on line ' + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === 'function') r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === 'function') // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions['INITIAL'];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                'INITIAL': {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$2826e0e4c4ca3c4e$export$8f49e4af10703ce3 = $2826e0e4c4ca3c4e$var$parser;
$2826e0e4c4ca3c4e$export$7acfa6ed01010e37 = $2826e0e4c4ca3c4e$var$parser.Parser;
$2826e0e4c4ca3c4e$export$98e6a39c04603d36 = function() {
    return $2826e0e4c4ca3c4e$var$parser.parse.apply($2826e0e4c4ca3c4e$var$parser, arguments);
};

});

parcelRegister("J7DJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flip = $087a2132b84c8216$var$flip;

var $bKwT1 = parcelRequire("bKwT1");
var $087a2132b84c8216$var$_convert2 = $087a2132b84c8216$var$_interopRequireDefault($bKwT1);
function $087a2132b84c8216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $087a2132b84c8216$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $087a2132b84c8216$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $087a2132b84c8216$var$reduce(node.value, precision);
    return node;
}
function $087a2132b84c8216$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $087a2132b84c8216$var$isValueType(type) {
    switch(type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
        case 'EmValue':
        case 'ExValue':
        case 'ChValue':
        case 'RemValue':
        case 'VhValue':
        case 'VwValue':
        case 'VminValue':
        case 'VmaxValue':
        case 'PercentageValue':
        case 'Value':
            return true;
    }
    return false;
}
function $087a2132b84c8216$var$convertMathExpression(node, precision) {
    var nodes = (0, $087a2132b84c8216$var$_convert2.default)(node.left, node.right, precision);
    var left = $087a2132b84c8216$var$reduce(nodes.left, precision);
    var right = $087a2132b84c8216$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {
            if ($087a2132b84c8216$var$isEqual(left.right, right.right)) nodes = (0, $087a2132b84c8216$var$_convert2.default)(left.left, right.left, precision);
            else if ($087a2132b84c8216$var$isEqual(left.right, right.left)) nodes = (0, $087a2132b84c8216$var$_convert2.default)(left.left, right.right, precision);
            left = $087a2132b84c8216$var$reduce(nodes.left, precision);
            right = $087a2132b84c8216$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $087a2132b84c8216$var$flip(operator) {
    return operator === '+' ? '-' : '+';
}
function $087a2132b84c8216$var$flipValue(node) {
    if ($087a2132b84c8216$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == 'MathExpression') {
        node.left = $087a2132b84c8216$var$flipValue(node.left);
        node.right = $087a2132b84c8216$var$flipValue(node.right);
    }
    return node;
}
function $087a2132b84c8216$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $087a2132b84c8216$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $087a2132b84c8216$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($087a2132b84c8216$var$isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $087a2132b84c8216$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === '-' ? $087a2132b84c8216$var$flip(right.operator) : right.operator;
            return $087a2132b84c8216$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $087a2132b84c8216$var$reduce({
                type: 'MathExpression',
                operator: op === '-' ? $087a2132b84c8216$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $087a2132b84c8216$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && $087a2132b84c8216$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $087a2132b84c8216$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $087a2132b84c8216$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === '-') {
                node.right = $087a2132b84c8216$var$reduce({
                    type: 'MathExpression',
                    operator: op === '-' ? '+' : '-',
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === '-' ? '-' : '+';
            } else node.right = $087a2132b84c8216$var$reduce({
                type: 'MathExpression',
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === '-' ? '+' : '-';
            }
            return $087a2132b84c8216$var$reduce(node, precision);
        }
    }
    return node;
}
function $087a2132b84c8216$var$reduceDivisionExpression(node, precision) {
    if (!$087a2132b84c8216$var$isValueType(node.right.type)) return node;
    if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
    if (node.right.value === 0) throw new Error('Cannot divide by zero');
    // (expr) / value
    if (node.left.type === 'MathExpression') {
        if ($087a2132b84c8216$var$isValueType(node.left.left.type) && $087a2132b84c8216$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $087a2132b84c8216$var$reduce(node.left, precision);
        }
        return node;
    } else if ($087a2132b84c8216$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $087a2132b84c8216$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
        if ($087a2132b84c8216$var$isValueType(node.left.left.type) && $087a2132b84c8216$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($087a2132b84c8216$var$isValueType(node.left.type) && node.right.type === 'Value') {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if ($087a2132b84c8216$var$isValueType(node.right.left.type) && $087a2132b84c8216$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === 'Value' && $087a2132b84c8216$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $087a2132b84c8216$var$reduceMathExpression(node, precision) {
    node = $087a2132b84c8216$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $087a2132b84c8216$var$reduceAddSubExpression(node, precision);
        case "/":
            return $087a2132b84c8216$var$reduceDivisionExpression(node, precision);
        case "*":
            return $087a2132b84c8216$var$reduceMultiplicationExpression(node);
    }
    return node;
}
module.exports.default = $087a2132b84c8216$var$reduce;

});
parcelRegister("bKwT1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ieAHC = parcelRequire("ieAHC");
var $88dd802ae81d15b8$var$_cssUnitConverter2 = $88dd802ae81d15b8$var$_interopRequireDefault($ieAHC);
function $88dd802ae81d15b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $88dd802ae81d15b8$var$convertNodes(left, right, precision) {
    switch(left.type){
        case 'LengthValue':
        case 'AngleValue':
        case 'TimeValue':
        case 'FrequencyValue':
        case 'ResolutionValue':
            return $88dd802ae81d15b8$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $88dd802ae81d15b8$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $88dd802ae81d15b8$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
module.exports.default = $88dd802ae81d15b8$var$convertNodes;
module.exports = module.exports['default'];

});
parcelRegister("ieAHC", function(module, exports) {
var $d46601254f6d69b3$var$conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0 / 2.54,
        'mm': 96.0 / 25.4,
        'in': 96,
        'pt': 96.0 / 72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54 / 96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54 / 72.0,
        'pc': 2.54 / 6.0
    },
    'mm': {
        'px': 25.4 / 96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4 / 72.0,
        'pc': 25.4 / 6.0
    },
    'in': {
        'px': 1.0 / 96.0,
        'cm': 1.0 / 2.54,
        'mm': 1.0 / 25.4,
        'in': 1,
        'pt': 1.0 / 72.0,
        'pc': 1.0 / 6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0 / 2.54,
        'mm': 72.0 / 25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 0.0625,
        'cm': 6.0 / 2.54,
        'mm': 6.0 / 25.4,
        'in': 6,
        'pt': 6.0 / 72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180 / Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400 / 360,
        'grad': 1,
        'rad': 200 / Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI / 180,
        'grad': Math.PI / 200,
        'rad': 1,
        'turn': Math.PI * 2
    },
    'turn': {
        'deg': 1 / 360,
        'grad': 1 / 400,
        'rad': 0.5 / Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 0.001
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 0.001,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0 / 2.54,
        'dppx': 1 / 96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54 / 96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0 / 2.54,
        'dppx': 1
    }
};
module.exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$d46601254f6d69b3$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$d46601254f6d69b3$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $d46601254f6d69b3$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};

});



parcelRegister("hlvSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(calc, node, precision) {
    var str = $ca0d1f9c8e1ed764$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $J7DJt = parcelRequire("J7DJt");
var $ca0d1f9c8e1ed764$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $ca0d1f9c8e1ed764$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $ca0d1f9c8e1ed764$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === 'MathExpression' && $ca0d1f9c8e1ed764$var$order[op] < $ca0d1f9c8e1ed764$var$order[left.operator]) str += "(" + $ca0d1f9c8e1ed764$var$stringify(left, prec) + ")";
            else str += $ca0d1f9c8e1ed764$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === 'MathExpression' && $ca0d1f9c8e1ed764$var$order[op] < $ca0d1f9c8e1ed764$var$order[right.operator]) str += "(" + $ca0d1f9c8e1ed764$var$stringify(right, prec) + ")";
            else if (right.type === 'MathExpression' && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $J7DJt.flip)(right.operator);
                str += $ca0d1f9c8e1ed764$var$stringify(right, prec);
            } else str += $ca0d1f9c8e1ed764$var$stringify(right, prec);
            return str;
        case "Value":
            return $ca0d1f9c8e1ed764$var$round(node.value, prec);
        case 'CssVariable':
            if (node.fallback) return "var(" + node.value + ", " + $ca0d1f9c8e1ed764$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case 'Calc':
            if (node.prefix) return "-" + node.prefix + "-calc(" + $ca0d1f9c8e1ed764$var$stringify(node.value, prec) + ")";
            return "calc(" + $ca0d1f9c8e1ed764$var$stringify(node.value, prec) + ")";
        default:
            return $ca0d1f9c8e1ed764$var$round(node.value, prec) + node.unit;
    }
}
module.exports = module.exports["default"];

});



parcelRegister("76uRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $52c108ea6e05ecb9$var$_default = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "display",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "tableLayout",
    "borderCollapse",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "userSelect",
    "resize",
    "listStylePosition",
    "listStyleType",
    "appearance",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "textOverflow",
    "whitespace",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "outline",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "content"
];
module.exports.default = $52c108ea6e05ecb9$var$_default;

});

parcelRegister("iRqEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbb1d9b808bcb797$var$_default;
function $dbb1d9b808bcb797$var$_default(pluginConfig, plugins) {
    if (pluginConfig === undefined) return plugins;
    const pluginNames = Array.isArray(pluginConfig) ? pluginConfig : [
        ...new Set(plugins.filter((pluginName)=>{
            return pluginConfig !== false && pluginConfig[pluginName] !== false;
        }).concat(Object.keys(pluginConfig).filter((pluginName)=>{
            return pluginConfig[pluginName] !== false;
        })))
    ];
    return pluginNames;
}

});

parcelRegister("eQjhe", function(module, exports) {

var $5pY61 = parcelRequire("5pY61");
module.exports = {
    purge: [],
    presets: [],
    darkMode: false,
    theme: {
        screens: {
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1536px'
        },
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            black: $5pY61.black,
            white: $5pY61.white,
            gray: $5pY61.coolGray,
            red: $5pY61.red,
            yellow: $5pY61.amber,
            green: $5pY61.emerald,
            blue: $5pY61.blue,
            indigo: $5pY61.indigo,
            purple: $5pY61.violet,
            pink: $5pY61.pink
        },
        spacing: {
            px: '1px',
            0: '0px',
            0.5: '0.125rem',
            1: '0.25rem',
            1.5: '0.375rem',
            2: '0.5rem',
            2.5: '0.625rem',
            3: '0.75rem',
            3.5: '0.875rem',
            4: '1rem',
            5: '1.25rem',
            6: '1.5rem',
            7: '1.75rem',
            8: '2rem',
            9: '2.25rem',
            10: '2.5rem',
            11: '2.75rem',
            12: '3rem',
            14: '3.5rem',
            16: '4rem',
            20: '5rem',
            24: '6rem',
            28: '7rem',
            32: '8rem',
            36: '9rem',
            40: '10rem',
            44: '11rem',
            48: '12rem',
            52: '13rem',
            56: '14rem',
            60: '15rem',
            64: '16rem',
            72: '18rem',
            80: '20rem',
            96: '24rem'
        },
        animation: {
            none: 'none',
            spin: 'spin 1s linear infinite',
            ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
            pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
            bounce: 'bounce 1s infinite'
        },
        backdropBlur: (theme)=>theme('blur'),
        backdropBrightness: (theme)=>theme('brightness'),
        backdropContrast: (theme)=>theme('contrast'),
        backdropGrayscale: (theme)=>theme('grayscale'),
        backdropHueRotate: (theme)=>theme('hueRotate'),
        backdropInvert: (theme)=>theme('invert'),
        backdropOpacity: (theme)=>theme('opacity'),
        backdropSaturate: (theme)=>theme('saturate'),
        backdropSepia: (theme)=>theme('sepia'),
        backgroundColor: (theme)=>theme('colors'),
        backgroundImage: {
            none: 'none',
            'gradient-to-t': 'linear-gradient(to top, var(--tw-gradient-stops))',
            'gradient-to-tr': 'linear-gradient(to top right, var(--tw-gradient-stops))',
            'gradient-to-r': 'linear-gradient(to right, var(--tw-gradient-stops))',
            'gradient-to-br': 'linear-gradient(to bottom right, var(--tw-gradient-stops))',
            'gradient-to-b': 'linear-gradient(to bottom, var(--tw-gradient-stops))',
            'gradient-to-bl': 'linear-gradient(to bottom left, var(--tw-gradient-stops))',
            'gradient-to-l': 'linear-gradient(to left, var(--tw-gradient-stops))',
            'gradient-to-tl': 'linear-gradient(to top left, var(--tw-gradient-stops))'
        },
        backgroundOpacity: (theme)=>theme('opacity'),
        backgroundPosition: {
            bottom: 'bottom',
            center: 'center',
            left: 'left',
            'left-bottom': 'left bottom',
            'left-top': 'left top',
            right: 'right',
            'right-bottom': 'right bottom',
            'right-top': 'right top',
            top: 'top'
        },
        backgroundSize: {
            auto: 'auto',
            cover: 'cover',
            contain: 'contain'
        },
        blur: {
            0: '0',
            none: '0',
            sm: '4px',
            DEFAULT: '8px',
            md: '12px',
            lg: '16px',
            xl: '24px',
            '2xl': '40px',
            '3xl': '64px'
        },
        brightness: {
            0: '0',
            50: '.5',
            75: '.75',
            90: '.9',
            95: '.95',
            100: '1',
            105: '1.05',
            110: '1.1',
            125: '1.25',
            150: '1.5',
            200: '2'
        },
        borderColor: (theme)=>({
                ...theme('colors'),
                DEFAULT: theme('colors.gray.200', 'currentColor')
            }),
        borderOpacity: (theme)=>theme('opacity'),
        borderRadius: {
            none: '0px',
            sm: '0.125rem',
            DEFAULT: '0.25rem',
            md: '0.375rem',
            lg: '0.5rem',
            xl: '0.75rem',
            '2xl': '1rem',
            '3xl': '1.5rem',
            full: '9999px'
        },
        borderWidth: {
            DEFAULT: '1px',
            0: '0px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        boxShadow: {
            sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
            DEFAULT: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
            md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
            none: 'none'
        },
        caretColor: (theme)=>theme('colors'),
        contrast: {
            0: '0',
            50: '.5',
            75: '.75',
            100: '1',
            125: '1.25',
            150: '1.5',
            200: '2'
        },
        container: {},
        content: {
            none: 'none'
        },
        cursor: {
            auto: 'auto',
            default: 'default',
            pointer: 'pointer',
            wait: 'wait',
            text: 'text',
            move: 'move',
            help: 'help',
            'not-allowed': 'not-allowed'
        },
        divideColor: (theme)=>theme('borderColor'),
        divideOpacity: (theme)=>theme('borderOpacity'),
        divideWidth: (theme)=>theme('borderWidth'),
        dropShadow: {
            sm: '0 1px 1px rgba(0,0,0,0.05)',
            DEFAULT: [
                '0 1px 2px rgba(0, 0, 0, 0.1)',
                '0 1px 1px rgba(0, 0, 0, 0.06)'
            ],
            md: [
                '0 4px 3px rgba(0, 0, 0, 0.07)',
                '0 2px 2px rgba(0, 0, 0, 0.06)'
            ],
            lg: [
                '0 10px 8px rgba(0, 0, 0, 0.04)',
                '0 4px 3px rgba(0, 0, 0, 0.1)'
            ],
            xl: [
                '0 20px 13px rgba(0, 0, 0, 0.03)',
                '0 8px 5px rgba(0, 0, 0, 0.08)'
            ],
            '2xl': '0 25px 25px rgba(0, 0, 0, 0.15)',
            none: '0 0 #0000'
        },
        fill: {
            current: 'currentColor'
        },
        grayscale: {
            0: '0',
            DEFAULT: '100%'
        },
        hueRotate: {
            '-180': '-180deg',
            '-90': '-90deg',
            '-60': '-60deg',
            '-30': '-30deg',
            '-15': '-15deg',
            0: '0deg',
            15: '15deg',
            30: '30deg',
            60: '60deg',
            90: '90deg',
            180: '180deg'
        },
        invert: {
            0: '0',
            DEFAULT: '100%'
        },
        flex: {
            1: '1 1 0%',
            auto: '1 1 auto',
            initial: '0 1 auto',
            none: 'none'
        },
        flexGrow: {
            0: '0',
            DEFAULT: '1'
        },
        flexShrink: {
            0: '0',
            DEFAULT: '1'
        },
        fontFamily: {
            sans: [
                'ui-sans-serif',
                'system-ui',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                '"Noto Sans"',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ],
            serif: [
                'ui-serif',
                'Georgia',
                'Cambria',
                '"Times New Roman"',
                'Times',
                'serif'
            ],
            mono: [
                'ui-monospace',
                'SFMono-Regular',
                'Menlo',
                'Monaco',
                'Consolas',
                '"Liberation Mono"',
                '"Courier New"',
                'monospace'
            ]
        },
        fontSize: {
            xs: [
                '0.75rem',
                {
                    lineHeight: '1rem'
                }
            ],
            sm: [
                '0.875rem',
                {
                    lineHeight: '1.25rem'
                }
            ],
            base: [
                '1rem',
                {
                    lineHeight: '1.5rem'
                }
            ],
            lg: [
                '1.125rem',
                {
                    lineHeight: '1.75rem'
                }
            ],
            xl: [
                '1.25rem',
                {
                    lineHeight: '1.75rem'
                }
            ],
            '2xl': [
                '1.5rem',
                {
                    lineHeight: '2rem'
                }
            ],
            '3xl': [
                '1.875rem',
                {
                    lineHeight: '2.25rem'
                }
            ],
            '4xl': [
                '2.25rem',
                {
                    lineHeight: '2.5rem'
                }
            ],
            '5xl': [
                '3rem',
                {
                    lineHeight: '1'
                }
            ],
            '6xl': [
                '3.75rem',
                {
                    lineHeight: '1'
                }
            ],
            '7xl': [
                '4.5rem',
                {
                    lineHeight: '1'
                }
            ],
            '8xl': [
                '6rem',
                {
                    lineHeight: '1'
                }
            ],
            '9xl': [
                '8rem',
                {
                    lineHeight: '1'
                }
            ]
        },
        fontWeight: {
            thin: '100',
            extralight: '200',
            light: '300',
            normal: '400',
            medium: '500',
            semibold: '600',
            bold: '700',
            extrabold: '800',
            black: '900'
        },
        gap: (theme)=>theme('spacing'),
        gradientColorStops: (theme)=>theme('colors'),
        gridAutoColumns: {
            auto: 'auto',
            min: 'min-content',
            max: 'max-content',
            fr: 'minmax(0, 1fr)'
        },
        gridAutoRows: {
            auto: 'auto',
            min: 'min-content',
            max: 'max-content',
            fr: 'minmax(0, 1fr)'
        },
        gridColumn: {
            auto: 'auto',
            'span-1': 'span 1 / span 1',
            'span-2': 'span 2 / span 2',
            'span-3': 'span 3 / span 3',
            'span-4': 'span 4 / span 4',
            'span-5': 'span 5 / span 5',
            'span-6': 'span 6 / span 6',
            'span-7': 'span 7 / span 7',
            'span-8': 'span 8 / span 8',
            'span-9': 'span 9 / span 9',
            'span-10': 'span 10 / span 10',
            'span-11': 'span 11 / span 11',
            'span-12': 'span 12 / span 12',
            'span-full': '1 / -1'
        },
        gridColumnEnd: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
            13: '13'
        },
        gridColumnStart: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
            13: '13'
        },
        gridRow: {
            auto: 'auto',
            'span-1': 'span 1 / span 1',
            'span-2': 'span 2 / span 2',
            'span-3': 'span 3 / span 3',
            'span-4': 'span 4 / span 4',
            'span-5': 'span 5 / span 5',
            'span-6': 'span 6 / span 6',
            'span-full': '1 / -1'
        },
        gridRowStart: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7'
        },
        gridRowEnd: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7'
        },
        gridTemplateColumns: {
            none: 'none',
            1: 'repeat(1, minmax(0, 1fr))',
            2: 'repeat(2, minmax(0, 1fr))',
            3: 'repeat(3, minmax(0, 1fr))',
            4: 'repeat(4, minmax(0, 1fr))',
            5: 'repeat(5, minmax(0, 1fr))',
            6: 'repeat(6, minmax(0, 1fr))',
            7: 'repeat(7, minmax(0, 1fr))',
            8: 'repeat(8, minmax(0, 1fr))',
            9: 'repeat(9, minmax(0, 1fr))',
            10: 'repeat(10, minmax(0, 1fr))',
            11: 'repeat(11, minmax(0, 1fr))',
            12: 'repeat(12, minmax(0, 1fr))'
        },
        gridTemplateRows: {
            none: 'none',
            1: 'repeat(1, minmax(0, 1fr))',
            2: 'repeat(2, minmax(0, 1fr))',
            3: 'repeat(3, minmax(0, 1fr))',
            4: 'repeat(4, minmax(0, 1fr))',
            5: 'repeat(5, minmax(0, 1fr))',
            6: 'repeat(6, minmax(0, 1fr))'
        },
        height: (theme)=>({
                auto: 'auto',
                ...theme('spacing'),
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                full: '100%',
                screen: '100vh'
            }),
        inset: (theme, { negative: negative })=>({
                auto: 'auto',
                ...theme('spacing'),
                ...negative(theme('spacing')),
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                full: '100%',
                '-1/2': '-50%',
                '-1/3': '-33.333333%',
                '-2/3': '-66.666667%',
                '-1/4': '-25%',
                '-2/4': '-50%',
                '-3/4': '-75%',
                '-full': '-100%'
            }),
        keyframes: {
            spin: {
                to: {
                    transform: 'rotate(360deg)'
                }
            },
            ping: {
                '75%, 100%': {
                    transform: 'scale(2)',
                    opacity: '0'
                }
            },
            pulse: {
                '50%': {
                    opacity: '.5'
                }
            },
            bounce: {
                '0%, 100%': {
                    transform: 'translateY(-25%)',
                    animationTimingFunction: 'cubic-bezier(0.8,0,1,1)'
                },
                '50%': {
                    transform: 'none',
                    animationTimingFunction: 'cubic-bezier(0,0,0.2,1)'
                }
            }
        },
        letterSpacing: {
            tighter: '-0.05em',
            tight: '-0.025em',
            normal: '0em',
            wide: '0.025em',
            wider: '0.05em',
            widest: '0.1em'
        },
        lineHeight: {
            none: '1',
            tight: '1.25',
            snug: '1.375',
            normal: '1.5',
            relaxed: '1.625',
            loose: '2',
            3: '.75rem',
            4: '1rem',
            5: '1.25rem',
            6: '1.5rem',
            7: '1.75rem',
            8: '2rem',
            9: '2.25rem',
            10: '2.5rem'
        },
        listStyleType: {
            none: 'none',
            disc: 'disc',
            decimal: 'decimal'
        },
        margin: (theme, { negative: negative })=>({
                auto: 'auto',
                ...theme('spacing'),
                ...negative(theme('spacing'))
            }),
        maxHeight: (theme)=>({
                ...theme('spacing'),
                full: '100%',
                screen: '100vh'
            }),
        maxWidth: (theme, { breakpoints: breakpoints })=>({
                none: 'none',
                0: '0rem',
                xs: '20rem',
                sm: '24rem',
                md: '28rem',
                lg: '32rem',
                xl: '36rem',
                '2xl': '42rem',
                '3xl': '48rem',
                '4xl': '56rem',
                '5xl': '64rem',
                '6xl': '72rem',
                '7xl': '80rem',
                full: '100%',
                min: 'min-content',
                max: 'max-content',
                prose: '65ch',
                ...breakpoints(theme('screens'))
            }),
        minHeight: {
            0: '0px',
            full: '100%',
            screen: '100vh'
        },
        minWidth: {
            0: '0px',
            full: '100%',
            min: 'min-content',
            max: 'max-content'
        },
        objectPosition: {
            bottom: 'bottom',
            center: 'center',
            left: 'left',
            'left-bottom': 'left bottom',
            'left-top': 'left top',
            right: 'right',
            'right-bottom': 'right bottom',
            'right-top': 'right top',
            top: 'top'
        },
        opacity: {
            0: '0',
            5: '0.05',
            10: '0.1',
            20: '0.2',
            25: '0.25',
            30: '0.3',
            40: '0.4',
            50: '0.5',
            60: '0.6',
            70: '0.7',
            75: '0.75',
            80: '0.8',
            90: '0.9',
            95: '0.95',
            100: '1'
        },
        order: {
            first: '-9999',
            last: '9999',
            none: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12'
        },
        outline: {
            none: [
                '2px solid transparent',
                '2px'
            ],
            white: [
                '2px dotted white',
                '2px'
            ],
            black: [
                '2px dotted black',
                '2px'
            ]
        },
        padding: (theme)=>theme('spacing'),
        placeholderColor: (theme)=>theme('colors'),
        placeholderOpacity: (theme)=>theme('opacity'),
        ringColor: (theme)=>({
                DEFAULT: theme('colors.blue.500', '#3b82f6'),
                ...theme('colors')
            }),
        ringOffsetColor: (theme)=>theme('colors'),
        ringOffsetWidth: {
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        ringOpacity: (theme)=>({
                DEFAULT: '0.5',
                ...theme('opacity')
            }),
        ringWidth: {
            DEFAULT: '3px',
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        rotate: {
            '-180': '-180deg',
            '-90': '-90deg',
            '-45': '-45deg',
            '-12': '-12deg',
            '-6': '-6deg',
            '-3': '-3deg',
            '-2': '-2deg',
            '-1': '-1deg',
            0: '0deg',
            1: '1deg',
            2: '2deg',
            3: '3deg',
            6: '6deg',
            12: '12deg',
            45: '45deg',
            90: '90deg',
            180: '180deg'
        },
        saturate: {
            0: '0',
            50: '.5',
            100: '1',
            150: '1.5',
            200: '2'
        },
        scale: {
            0: '0',
            50: '.5',
            75: '.75',
            90: '.9',
            95: '.95',
            100: '1',
            105: '1.05',
            110: '1.1',
            125: '1.25',
            150: '1.5'
        },
        sepia: {
            0: '0',
            DEFAULT: '100%'
        },
        skew: {
            '-12': '-12deg',
            '-6': '-6deg',
            '-3': '-3deg',
            '-2': '-2deg',
            '-1': '-1deg',
            0: '0deg',
            1: '1deg',
            2: '2deg',
            3: '3deg',
            6: '6deg',
            12: '12deg'
        },
        space: (theme, { negative: negative })=>({
                ...theme('spacing'),
                ...negative(theme('spacing'))
            }),
        stroke: {
            current: 'currentColor'
        },
        strokeWidth: {
            0: '0',
            1: '1',
            2: '2'
        },
        textColor: (theme)=>theme('colors'),
        textOpacity: (theme)=>theme('opacity'),
        transformOrigin: {
            center: 'center',
            top: 'top',
            'top-right': 'top right',
            right: 'right',
            'bottom-right': 'bottom right',
            bottom: 'bottom',
            'bottom-left': 'bottom left',
            left: 'left',
            'top-left': 'top left'
        },
        transitionDelay: {
            75: '75ms',
            100: '100ms',
            150: '150ms',
            200: '200ms',
            300: '300ms',
            500: '500ms',
            700: '700ms',
            1000: '1000ms'
        },
        transitionDuration: {
            DEFAULT: '150ms',
            75: '75ms',
            100: '100ms',
            150: '150ms',
            200: '200ms',
            300: '300ms',
            500: '500ms',
            700: '700ms',
            1000: '1000ms'
        },
        transitionProperty: {
            none: 'none',
            all: 'all',
            DEFAULT: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
            colors: 'background-color, border-color, color, fill, stroke',
            opacity: 'opacity',
            shadow: 'box-shadow',
            transform: 'transform'
        },
        transitionTimingFunction: {
            DEFAULT: 'cubic-bezier(0.4, 0, 0.2, 1)',
            linear: 'linear',
            in: 'cubic-bezier(0.4, 0, 1, 1)',
            out: 'cubic-bezier(0, 0, 0.2, 1)',
            'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
        },
        translate: (theme, { negative: negative })=>({
                ...theme('spacing'),
                ...negative(theme('spacing')),
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                full: '100%',
                '-1/2': '-50%',
                '-1/3': '-33.333333%',
                '-2/3': '-66.666667%',
                '-1/4': '-25%',
                '-2/4': '-50%',
                '-3/4': '-75%',
                '-full': '-100%'
            }),
        width: (theme)=>({
                auto: 'auto',
                ...theme('spacing'),
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                '1/12': '8.333333%',
                '2/12': '16.666667%',
                '3/12': '25%',
                '4/12': '33.333333%',
                '5/12': '41.666667%',
                '6/12': '50%',
                '7/12': '58.333333%',
                '8/12': '66.666667%',
                '9/12': '75%',
                '10/12': '83.333333%',
                '11/12': '91.666667%',
                full: '100%',
                screen: '100vw',
                min: 'min-content',
                max: 'max-content'
            }),
        zIndex: {
            auto: 'auto',
            0: '0',
            10: '10',
            20: '20',
            30: '30',
            40: '40',
            50: '50'
        }
    },
    variantOrder: [
        'first',
        'last',
        'odd',
        'even',
        'visited',
        'checked',
        'empty',
        'read-only',
        'group-hover',
        'group-focus',
        'focus-within',
        'hover',
        'focus',
        'focus-visible',
        'active',
        'disabled'
    ],
    variants: {
        accessibility: [
            'responsive',
            'focus-within',
            'focus'
        ],
        alignContent: [
            'responsive'
        ],
        alignItems: [
            'responsive'
        ],
        alignSelf: [
            'responsive'
        ],
        animation: [
            'responsive'
        ],
        appearance: [
            'responsive'
        ],
        backdropBlur: [
            'responsive'
        ],
        backdropBrightness: [
            'responsive'
        ],
        backdropContrast: [
            'responsive'
        ],
        backdropFilter: [
            'responsive'
        ],
        backdropGrayscale: [
            'responsive'
        ],
        backdropHueRotate: [
            'responsive'
        ],
        backdropInvert: [
            'responsive'
        ],
        backdropOpacity: [
            'responsive'
        ],
        backdropSaturate: [
            'responsive'
        ],
        backdropSepia: [
            'responsive'
        ],
        backgroundAttachment: [
            'responsive'
        ],
        backgroundBlendMode: [
            'responsive'
        ],
        backgroundClip: [
            'responsive'
        ],
        backgroundColor: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        backgroundImage: [
            'responsive'
        ],
        backgroundOpacity: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        backgroundPosition: [
            'responsive'
        ],
        backgroundRepeat: [
            'responsive'
        ],
        backgroundSize: [
            'responsive'
        ],
        backgroundOrigin: [
            'responsive'
        ],
        blur: [
            'responsive'
        ],
        borderCollapse: [
            'responsive'
        ],
        borderColor: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        borderOpacity: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        borderRadius: [
            'responsive'
        ],
        borderStyle: [
            'responsive'
        ],
        borderWidth: [
            'responsive'
        ],
        boxDecorationBreak: [
            'responsive'
        ],
        boxShadow: [
            'responsive',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        boxSizing: [
            'responsive'
        ],
        brightness: [
            'responsive'
        ],
        clear: [
            'responsive'
        ],
        container: [
            'responsive'
        ],
        contrast: [
            'responsive'
        ],
        cursor: [
            'responsive'
        ],
        display: [
            'responsive'
        ],
        divideColor: [
            'responsive',
            'dark'
        ],
        divideOpacity: [
            'responsive',
            'dark'
        ],
        divideStyle: [
            'responsive'
        ],
        divideWidth: [
            'responsive'
        ],
        dropShadow: [
            'responsive'
        ],
        fill: [
            'responsive'
        ],
        filter: [
            'responsive'
        ],
        flex: [
            'responsive'
        ],
        flexDirection: [
            'responsive'
        ],
        flexGrow: [
            'responsive'
        ],
        flexShrink: [
            'responsive'
        ],
        flexWrap: [
            'responsive'
        ],
        float: [
            'responsive'
        ],
        fontFamily: [
            'responsive'
        ],
        fontSize: [
            'responsive'
        ],
        fontSmoothing: [
            'responsive'
        ],
        fontStyle: [
            'responsive'
        ],
        fontVariantNumeric: [
            'responsive'
        ],
        fontWeight: [
            'responsive'
        ],
        gap: [
            'responsive'
        ],
        gradientColorStops: [
            'responsive',
            'dark',
            'hover',
            'focus'
        ],
        grayscale: [
            'responsive'
        ],
        gridAutoColumns: [
            'responsive'
        ],
        gridAutoFlow: [
            'responsive'
        ],
        gridAutoRows: [
            'responsive'
        ],
        gridColumn: [
            'responsive'
        ],
        gridColumnEnd: [
            'responsive'
        ],
        gridColumnStart: [
            'responsive'
        ],
        gridRow: [
            'responsive'
        ],
        gridRowEnd: [
            'responsive'
        ],
        gridRowStart: [
            'responsive'
        ],
        gridTemplateColumns: [
            'responsive'
        ],
        gridTemplateRows: [
            'responsive'
        ],
        height: [
            'responsive'
        ],
        hueRotate: [
            'responsive'
        ],
        inset: [
            'responsive'
        ],
        invert: [
            'responsive'
        ],
        isolation: [
            'responsive'
        ],
        justifyContent: [
            'responsive'
        ],
        justifyItems: [
            'responsive'
        ],
        justifySelf: [
            'responsive'
        ],
        letterSpacing: [
            'responsive'
        ],
        lineHeight: [
            'responsive'
        ],
        listStylePosition: [
            'responsive'
        ],
        listStyleType: [
            'responsive'
        ],
        margin: [
            'responsive'
        ],
        maxHeight: [
            'responsive'
        ],
        maxWidth: [
            'responsive'
        ],
        minHeight: [
            'responsive'
        ],
        minWidth: [
            'responsive'
        ],
        mixBlendMode: [
            'responsive'
        ],
        objectFit: [
            'responsive'
        ],
        objectPosition: [
            'responsive'
        ],
        opacity: [
            'responsive',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        order: [
            'responsive'
        ],
        outline: [
            'responsive',
            'focus-within',
            'focus'
        ],
        overflow: [
            'responsive'
        ],
        overscrollBehavior: [
            'responsive'
        ],
        padding: [
            'responsive'
        ],
        placeContent: [
            'responsive'
        ],
        placeItems: [
            'responsive'
        ],
        placeSelf: [
            'responsive'
        ],
        placeholderColor: [
            'responsive',
            'dark',
            'focus'
        ],
        placeholderOpacity: [
            'responsive',
            'dark',
            'focus'
        ],
        pointerEvents: [
            'responsive'
        ],
        position: [
            'responsive'
        ],
        resize: [
            'responsive'
        ],
        ringColor: [
            'responsive',
            'dark',
            'focus-within',
            'focus'
        ],
        ringOffsetColor: [
            'responsive',
            'dark',
            'focus-within',
            'focus'
        ],
        ringOffsetWidth: [
            'responsive',
            'focus-within',
            'focus'
        ],
        ringOpacity: [
            'responsive',
            'dark',
            'focus-within',
            'focus'
        ],
        ringWidth: [
            'responsive',
            'focus-within',
            'focus'
        ],
        rotate: [
            'responsive',
            'hover',
            'focus'
        ],
        saturate: [
            'responsive'
        ],
        scale: [
            'responsive',
            'hover',
            'focus'
        ],
        sepia: [
            'responsive'
        ],
        skew: [
            'responsive',
            'hover',
            'focus'
        ],
        space: [
            'responsive'
        ],
        stroke: [
            'responsive'
        ],
        strokeWidth: [
            'responsive'
        ],
        tableLayout: [
            'responsive'
        ],
        textAlign: [
            'responsive'
        ],
        textColor: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        textDecoration: [
            'responsive',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        textOpacity: [
            'responsive',
            'dark',
            'group-hover',
            'focus-within',
            'hover',
            'focus'
        ],
        textOverflow: [
            'responsive'
        ],
        textTransform: [
            'responsive'
        ],
        transform: [
            'responsive'
        ],
        transformOrigin: [
            'responsive'
        ],
        transitionDelay: [
            'responsive'
        ],
        transitionDuration: [
            'responsive'
        ],
        transitionProperty: [
            'responsive'
        ],
        transitionTimingFunction: [
            'responsive'
        ],
        translate: [
            'responsive',
            'hover',
            'focus'
        ],
        userSelect: [
            'responsive'
        ],
        verticalAlign: [
            'responsive'
        ],
        visibility: [
            'responsive'
        ],
        whitespace: [
            'responsive'
        ],
        width: [
            'responsive'
        ],
        wordBreak: [
            'responsive'
        ],
        zIndex: [
            'responsive',
            'focus-within',
            'focus'
        ]
    },
    plugins: []
};

});
parcelRegister("5pY61", function(module, exports) {
let $3f1de7645c676be5$var$warned = false;
module.exports = {
    black: '#000',
    white: '#fff',
    rose: {
        50: '#fff1f2',
        100: '#ffe4e6',
        200: '#fecdd3',
        300: '#fda4af',
        400: '#fb7185',
        500: '#f43f5e',
        600: '#e11d48',
        700: '#be123c',
        800: '#9f1239',
        900: '#881337'
    },
    pink: {
        50: '#fdf2f8',
        100: '#fce7f3',
        200: '#fbcfe8',
        300: '#f9a8d4',
        400: '#f472b6',
        500: '#ec4899',
        600: '#db2777',
        700: '#be185d',
        800: '#9d174d',
        900: '#831843'
    },
    fuchsia: {
        50: '#fdf4ff',
        100: '#fae8ff',
        200: '#f5d0fe',
        300: '#f0abfc',
        400: '#e879f9',
        500: '#d946ef',
        600: '#c026d3',
        700: '#a21caf',
        800: '#86198f',
        900: '#701a75'
    },
    purple: {
        50: '#faf5ff',
        100: '#f3e8ff',
        200: '#e9d5ff',
        300: '#d8b4fe',
        400: '#c084fc',
        500: '#a855f7',
        600: '#9333ea',
        700: '#7e22ce',
        800: '#6b21a8',
        900: '#581c87'
    },
    violet: {
        50: '#f5f3ff',
        100: '#ede9fe',
        200: '#ddd6fe',
        300: '#c4b5fd',
        400: '#a78bfa',
        500: '#8b5cf6',
        600: '#7c3aed',
        700: '#6d28d9',
        800: '#5b21b6',
        900: '#4c1d95'
    },
    indigo: {
        50: '#eef2ff',
        100: '#e0e7ff',
        200: '#c7d2fe',
        300: '#a5b4fc',
        400: '#818cf8',
        500: '#6366f1',
        600: '#4f46e5',
        700: '#4338ca',
        800: '#3730a3',
        900: '#312e81'
    },
    blue: {
        50: '#eff6ff',
        100: '#dbeafe',
        200: '#bfdbfe',
        300: '#93c5fd',
        400: '#60a5fa',
        500: '#3b82f6',
        600: '#2563eb',
        700: '#1d4ed8',
        800: '#1e40af',
        900: '#1e3a8a'
    },
    get lightBlue () {
        if (!$3f1de7645c676be5$var$warned) {
            console.log('warn - As of Tailwind CSS v2.2, `lightBlue` has been renamed to `sky`.');
            console.log('warn - Please update your color palette to eliminate this warning.');
            $3f1de7645c676be5$var$warned = true;
        }
        return {
            50: '#f0f9ff',
            100: '#e0f2fe',
            200: '#bae6fd',
            300: '#7dd3fc',
            400: '#38bdf8',
            500: '#0ea5e9',
            600: '#0284c7',
            700: '#0369a1',
            800: '#075985',
            900: '#0c4a6e'
        };
    },
    sky: {
        50: '#f0f9ff',
        100: '#e0f2fe',
        200: '#bae6fd',
        300: '#7dd3fc',
        400: '#38bdf8',
        500: '#0ea5e9',
        600: '#0284c7',
        700: '#0369a1',
        800: '#075985',
        900: '#0c4a6e'
    },
    cyan: {
        50: '#ecfeff',
        100: '#cffafe',
        200: '#a5f3fc',
        300: '#67e8f9',
        400: '#22d3ee',
        500: '#06b6d4',
        600: '#0891b2',
        700: '#0e7490',
        800: '#155e75',
        900: '#164e63'
    },
    teal: {
        50: '#f0fdfa',
        100: '#ccfbf1',
        200: '#99f6e4',
        300: '#5eead4',
        400: '#2dd4bf',
        500: '#14b8a6',
        600: '#0d9488',
        700: '#0f766e',
        800: '#115e59',
        900: '#134e4a'
    },
    emerald: {
        50: '#ecfdf5',
        100: '#d1fae5',
        200: '#a7f3d0',
        300: '#6ee7b7',
        400: '#34d399',
        500: '#10b981',
        600: '#059669',
        700: '#047857',
        800: '#065f46',
        900: '#064e3b'
    },
    green: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
    },
    lime: {
        50: '#f7fee7',
        100: '#ecfccb',
        200: '#d9f99d',
        300: '#bef264',
        400: '#a3e635',
        500: '#84cc16',
        600: '#65a30d',
        700: '#4d7c0f',
        800: '#3f6212',
        900: '#365314'
    },
    yellow: {
        50: '#fefce8',
        100: '#fef9c3',
        200: '#fef08a',
        300: '#fde047',
        400: '#facc15',
        500: '#eab308',
        600: '#ca8a04',
        700: '#a16207',
        800: '#854d0e',
        900: '#713f12'
    },
    amber: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        400: '#fbbf24',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
    },
    orange: {
        50: '#fff7ed',
        100: '#ffedd5',
        200: '#fed7aa',
        300: '#fdba74',
        400: '#fb923c',
        500: '#f97316',
        600: '#ea580c',
        700: '#c2410c',
        800: '#9a3412',
        900: '#7c2d12'
    },
    red: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
    },
    warmGray: {
        50: '#fafaf9',
        100: '#f5f5f4',
        200: '#e7e5e4',
        300: '#d6d3d1',
        400: '#a8a29e',
        500: '#78716c',
        600: '#57534e',
        700: '#44403c',
        800: '#292524',
        900: '#1c1917'
    },
    trueGray: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#e5e5e5',
        300: '#d4d4d4',
        400: '#a3a3a3',
        500: '#737373',
        600: '#525252',
        700: '#404040',
        800: '#262626',
        900: '#171717'
    },
    gray: {
        50: '#fafafa',
        100: '#f4f4f5',
        200: '#e4e4e7',
        300: '#d4d4d8',
        400: '#a1a1aa',
        500: '#71717a',
        600: '#52525b',
        700: '#3f3f46',
        800: '#27272a',
        900: '#18181b'
    },
    coolGray: {
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        500: '#6b7280',
        600: '#4b5563',
        700: '#374151',
        800: '#1f2937',
        900: '#111827'
    },
    blueGray: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1',
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
    }
};

});



parcelRegister("iBkDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8abafb7ec86998c$var$getAllConfigs;

var $d8abafb7ec86998c$var$_defaultConfigStub = $d8abafb7ec86998c$var$_interopRequireDefault((parcelRequire("eQjhe")));

var $e7TKg = parcelRequire("e7TKg");
function $d8abafb7ec86998c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d8abafb7ec86998c$var$getAllConfigs(config) {
    var _config$presets;
    const configs = ((_config$presets = config === null || config === void 0 ? void 0 : config.presets) !== null && _config$presets !== void 0 ? _config$presets : [
        $d8abafb7ec86998c$var$_defaultConfigStub.default
    ]).slice().reverse().flatMap((preset)=>$d8abafb7ec86998c$var$getAllConfigs(preset instanceof Function ? preset() : preset));
    const features = {};
    const experimentals = Object.keys(features).filter((feature)=>(0, $e7TKg.flagEnabled)(config, feature)).map((feature)=>features[feature]);
    return [
        config,
        ...experimentals,
        ...configs
    ];
}

});
parcelRegister("e7TKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flagEnabled = $a48cf5fc00c854b7$var$flagEnabled;
module.exports.issueFlagNotices = $a48cf5fc00c854b7$var$issueFlagNotices;
module.exports.default = void 0;

var $a48cf5fc00c854b7$var$_lodash = $a48cf5fc00c854b7$var$_interopRequireDefault((parcelRequire("f1q41")));

var $a48cf5fc00c854b7$var$_chalk = $a48cf5fc00c854b7$var$_interopRequireDefault((parcelRequire("54Wdc")));

var $a48cf5fc00c854b7$var$_log = $a48cf5fc00c854b7$var$_interopRequireDefault((parcelRequire("7pWKZ")));
function $a48cf5fc00c854b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a48cf5fc00c854b7$var$featureFlags = {
    future: [],
    experimental: [
        'optimizeUniversalDefaults'
    ]
};
function $a48cf5fc00c854b7$var$flagEnabled(config, flag) {
    if ($a48cf5fc00c854b7$var$featureFlags.future.includes(flag)) return config.future === 'all' || $a48cf5fc00c854b7$var$_lodash.default.get(config, [
        'future',
        flag
    ], false);
    if ($a48cf5fc00c854b7$var$featureFlags.experimental.includes(flag)) return config.experimental === 'all' || $a48cf5fc00c854b7$var$_lodash.default.get(config, [
        'experimental',
        flag
    ], false);
    return false;
}
function $a48cf5fc00c854b7$var$experimentalFlagsEnabled(config) {
    if (config.experimental === 'all') return $a48cf5fc00c854b7$var$featureFlags.experimental;
    return Object.keys($a48cf5fc00c854b7$var$_lodash.default.get(config, 'experimental', {})).filter((flag)=>$a48cf5fc00c854b7$var$featureFlags.experimental.includes(flag) && config.experimental[flag]);
}
function $a48cf5fc00c854b7$var$issueFlagNotices(config) {
    if ($a48cf5fc00c854b7$var$experimentalFlagsEnabled(config).length > 0) {
        const changes = $a48cf5fc00c854b7$var$experimentalFlagsEnabled(config).map((s)=>$a48cf5fc00c854b7$var$_chalk.default.yellow(s)).join(', ');
        $a48cf5fc00c854b7$var$_log.default.warn([
            `You have enabled experimental features: ${changes}`,
            'Experimental features are not covered by semver, may introduce breaking changes, and can change at any time.'
        ]);
    }
}
var $a48cf5fc00c854b7$var$_default = $a48cf5fc00c854b7$var$featureFlags;
module.exports.default = $a48cf5fc00c854b7$var$_default;

});
parcelRegister("54Wdc", function(module, exports) {
'use strict';

var $6BKNL = parcelRequire("6BKNL");

var $74s9X = parcelRequire("74s9X");
var $3b2a7b1de84baf79$require$stdoutColor = $74s9X.stdout;
var $3b2a7b1de84baf79$require$stderrColor = $74s9X.stderr;

var $5Lpwp = parcelRequire("5Lpwp");
var $3b2a7b1de84baf79$require$stringReplaceAll = $5Lpwp.stringReplaceAll;
var $3b2a7b1de84baf79$require$stringEncaseCRLFWithFirstIndex = $5Lpwp.stringEncaseCRLFWithFirstIndex;
const { isArray: $3b2a7b1de84baf79$var$isArray } = Array;
// `supportsColor.level` → `ansiStyles.color[name]` mapping
const $3b2a7b1de84baf79$var$levelMapping = [
    'ansi',
    'ansi',
    'ansi256',
    'ansi16m'
];
const $3b2a7b1de84baf79$var$styles = Object.create(null);
const $3b2a7b1de84baf79$var$applyOptions = (object, options = {})=>{
    if (options.level && !(Number.isInteger(options.level) && options.level >= 0 && options.level <= 3)) throw new Error('The `level` option should be an integer from 0 to 3');
    // Detect level if not set manually
    const colorLevel = $3b2a7b1de84baf79$require$stdoutColor ? $3b2a7b1de84baf79$require$stdoutColor.level : 0;
    object.level = options.level === undefined ? colorLevel : options.level;
};
class $3b2a7b1de84baf79$var$ChalkClass {
    constructor(options){
        // eslint-disable-next-line no-constructor-return
        return $3b2a7b1de84baf79$var$chalkFactory(options);
    }
}
const $3b2a7b1de84baf79$var$chalkFactory = (options)=>{
    const chalk = {};
    $3b2a7b1de84baf79$var$applyOptions(chalk, options);
    chalk.template = (...arguments_)=>$3b2a7b1de84baf79$var$chalkTag(chalk.template, ...arguments_);
    Object.setPrototypeOf(chalk, $3b2a7b1de84baf79$var$Chalk.prototype);
    Object.setPrototypeOf(chalk.template, chalk);
    chalk.template.constructor = ()=>{
        throw new Error('`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.');
    };
    chalk.template.Instance = $3b2a7b1de84baf79$var$ChalkClass;
    return chalk.template;
};
function $3b2a7b1de84baf79$var$Chalk(options) {
    return $3b2a7b1de84baf79$var$chalkFactory(options);
}
for (const [styleName, style] of Object.entries($6BKNL))$3b2a7b1de84baf79$var$styles[styleName] = {
    get () {
        const builder = $3b2a7b1de84baf79$var$createBuilder(this, $3b2a7b1de84baf79$var$createStyler(style.open, style.close, this._styler), this._isEmpty);
        Object.defineProperty(this, styleName, {
            value: builder
        });
        return builder;
    }
};
$3b2a7b1de84baf79$var$styles.visible = {
    get () {
        const builder = $3b2a7b1de84baf79$var$createBuilder(this, this._styler, true);
        Object.defineProperty(this, 'visible', {
            value: builder
        });
        return builder;
    }
};
const $3b2a7b1de84baf79$var$usedModels = [
    'rgb',
    'hex',
    'keyword',
    'hsl',
    'hsv',
    'hwb',
    'ansi',
    'ansi256'
];
for (const model of $3b2a7b1de84baf79$var$usedModels)$3b2a7b1de84baf79$var$styles[model] = {
    get () {
        const { level: level } = this;
        return function(...arguments_) {
            const styler = $3b2a7b1de84baf79$var$createStyler($6BKNL.color[$3b2a7b1de84baf79$var$levelMapping[level]][model](...arguments_), $6BKNL.color.close, this._styler);
            return $3b2a7b1de84baf79$var$createBuilder(this, styler, this._isEmpty);
        };
    }
};
for (const model of $3b2a7b1de84baf79$var$usedModels){
    const bgModel = 'bg' + model[0].toUpperCase() + model.slice(1);
    $3b2a7b1de84baf79$var$styles[bgModel] = {
        get () {
            const { level: level } = this;
            return function(...arguments_) {
                const styler = $3b2a7b1de84baf79$var$createStyler($6BKNL.bgColor[$3b2a7b1de84baf79$var$levelMapping[level]][model](...arguments_), $6BKNL.bgColor.close, this._styler);
                return $3b2a7b1de84baf79$var$createBuilder(this, styler, this._isEmpty);
            };
        }
    };
}
const $3b2a7b1de84baf79$var$proto = Object.defineProperties(()=>{}, {
    ...$3b2a7b1de84baf79$var$styles,
    level: {
        enumerable: true,
        get () {
            return this._generator.level;
        },
        set (level) {
            this._generator.level = level;
        }
    }
});
const $3b2a7b1de84baf79$var$createStyler = (open, close, parent)=>{
    let openAll;
    let closeAll;
    if (parent === undefined) {
        openAll = open;
        closeAll = close;
    } else {
        openAll = parent.openAll + open;
        closeAll = close + parent.closeAll;
    }
    return {
        open: open,
        close: close,
        openAll: openAll,
        closeAll: closeAll,
        parent: parent
    };
};
const $3b2a7b1de84baf79$var$createBuilder = (self, _styler, _isEmpty)=>{
    const builder = (...arguments_)=>{
        if ($3b2a7b1de84baf79$var$isArray(arguments_[0]) && $3b2a7b1de84baf79$var$isArray(arguments_[0].raw)) // Called as a template literal, for example: chalk.red`2 + 3 = {bold ${2+3}}`
        return $3b2a7b1de84baf79$var$applyStyle(builder, $3b2a7b1de84baf79$var$chalkTag(builder, ...arguments_));
        // Single argument is hot path, implicit coercion is faster than anything
        // eslint-disable-next-line no-implicit-coercion
        return $3b2a7b1de84baf79$var$applyStyle(builder, arguments_.length === 1 ? '' + arguments_[0] : arguments_.join(' '));
    };
    // We alter the prototype because we must return a function, but there is
    // no way to create a function with a different prototype
    Object.setPrototypeOf(builder, $3b2a7b1de84baf79$var$proto);
    builder._generator = self;
    builder._styler = _styler;
    builder._isEmpty = _isEmpty;
    return builder;
};
const $3b2a7b1de84baf79$var$applyStyle = (self, string)=>{
    if (self.level <= 0 || !string) return self._isEmpty ? '' : string;
    let styler = self._styler;
    if (styler === undefined) return string;
    const { openAll: openAll, closeAll: closeAll } = styler;
    if (string.indexOf('\u001B') !== -1) while(styler !== undefined){
        // Replace any instances already present with a re-opening code
        // otherwise only the part of the string until said closing code
        // will be colored, and the rest will simply be 'plain'.
        string = $3b2a7b1de84baf79$require$stringReplaceAll(string, styler.close, styler.open);
        styler = styler.parent;
    }
    // We can move both next actions out of loop, because remaining actions in loop won't have
    // any/visible effect on parts we add here. Close the styling before a linebreak and reopen
    // after next line to fix a bleed issue on macOS: https://github.com/chalk/chalk/pull/92
    const lfIndex = string.indexOf('\n');
    if (lfIndex !== -1) string = $3b2a7b1de84baf79$require$stringEncaseCRLFWithFirstIndex(string, closeAll, openAll, lfIndex);
    return openAll + string + closeAll;
};
let $3b2a7b1de84baf79$var$template;

const $3b2a7b1de84baf79$var$chalkTag = (chalk, ...strings)=>{
    const [firstString] = strings;
    if (!$3b2a7b1de84baf79$var$isArray(firstString) || !$3b2a7b1de84baf79$var$isArray(firstString.raw)) // If chalk() was called by itself or with a string,
    // return the string itself as a string.
    return strings.join(' ');
    const arguments_ = strings.slice(1);
    const parts = [
        firstString.raw[0]
    ];
    for(let i = 1; i < firstString.length; i++)parts.push(String(arguments_[i - 1]).replace(/[{}\\]/g, '\\$&'), String(firstString.raw[i]));
    if ($3b2a7b1de84baf79$var$template === undefined) $3b2a7b1de84baf79$var$template = (parcelRequire("kCHVr"));
    return $3b2a7b1de84baf79$var$template(chalk, parts.join(''));
};
Object.defineProperties($3b2a7b1de84baf79$var$Chalk.prototype, $3b2a7b1de84baf79$var$styles);
const $3b2a7b1de84baf79$var$chalk = $3b2a7b1de84baf79$var$Chalk(); // eslint-disable-line new-cap
$3b2a7b1de84baf79$var$chalk.supportsColor = $3b2a7b1de84baf79$require$stdoutColor;
$3b2a7b1de84baf79$var$chalk.stderr = $3b2a7b1de84baf79$var$Chalk({
    level: $3b2a7b1de84baf79$require$stderrColor ? $3b2a7b1de84baf79$require$stderrColor.level : 0
}); // eslint-disable-line new-cap
$3b2a7b1de84baf79$var$chalk.stderr.supportsColor = $3b2a7b1de84baf79$require$stderrColor;
module.exports = $3b2a7b1de84baf79$var$chalk;

});
parcelRegister("6BKNL", function(module, exports) {
'use strict';
const wrapAnsi16 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${code + offset}m`;
    };
const wrapAnsi256 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${38 + offset};5;${code}m`;
    };
const wrapAnsi16m = (fn, offset)=>(...args)=>{
        const rgb = fn(...args);
        return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
    };
const ansi2ansi = (n)=>n;
const rgb2rgb = (r, g, b)=>[
        r,
        g,
        b
    ];
const setLazyProperty = (object, property, get)=>{
    Object.defineProperty(object, property, {
        get: ()=>{
            const value = get();
            Object.defineProperty(object, property, {
                value: value,
                enumerable: true,
                configurable: true
            });
            return value;
        },
        enumerable: true,
        configurable: true
    });
};
/** @type {typeof import('color-convert')} */ let colorConvert;

const makeDynamicStyles = (wrap, targetSpace, identity, isBackground)=>{
    if (colorConvert === undefined) colorConvert = (parcelRequire("hIf3d"));
    const offset = isBackground ? 10 : 0;
    const styles = {};
    for (const [sourceSpace, suite] of Object.entries(colorConvert)){
        const name = sourceSpace === 'ansi16' ? 'ansi' : sourceSpace;
        if (sourceSpace === targetSpace) styles[name] = wrap(identity, offset);
        else if (typeof suite === 'object') styles[name] = wrap(suite[targetSpace], offset);
    }
    return styles;
};
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles)){
        for (const [styleName, style] of Object.entries(group)){
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
    }
    Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
    });
    styles.color.close = '\u001B[39m';
    styles.bgColor.close = '\u001B[49m';
    setLazyProperty(styles.color, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, false));
    setLazyProperty(styles.bgColor, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, true));
    return styles;
}
// Make the export immutable
Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
});

});
parcelRegister("hIf3d", function(module, exports) {

var $bACEm = parcelRequire("bACEm");

var $48NUw = parcelRequire("48NUw");
const $ce5238844c992f76$var$convert = {};
const $ce5238844c992f76$var$models = Object.keys($bACEm);
function $ce5238844c992f76$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $ce5238844c992f76$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$ce5238844c992f76$var$models.forEach((fromModel)=>{
    $ce5238844c992f76$var$convert[fromModel] = {};
    Object.defineProperty($ce5238844c992f76$var$convert[fromModel], 'channels', {
        value: $bACEm[fromModel].channels
    });
    Object.defineProperty($ce5238844c992f76$var$convert[fromModel], 'labels', {
        value: $bACEm[fromModel].labels
    });
    const routes = $48NUw(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $ce5238844c992f76$var$convert[fromModel][toModel] = $ce5238844c992f76$var$wrapRounded(fn);
        $ce5238844c992f76$var$convert[fromModel][toModel].raw = $ce5238844c992f76$var$wrapRaw(fn);
    });
});
module.exports = $ce5238844c992f76$var$convert;

});
parcelRegister("bACEm", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $jVuP9 = parcelRequire("jVuP9");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $87010999ebf2f889$var$reverseKeywords = {};
for (const key of Object.keys($jVuP9))$87010999ebf2f889$var$reverseKeywords[$jVuP9[key]] = key;
const $87010999ebf2f889$var$convert = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
module.exports = $87010999ebf2f889$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($87010999ebf2f889$var$convert)){
    if (!('channels' in $87010999ebf2f889$var$convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in $87010999ebf2f889$var$convert[model])) throw new Error('missing channel labels property: ' + model);
    if ($87010999ebf2f889$var$convert[model].labels.length !== $87010999ebf2f889$var$convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    const { channels: channels, labels: labels } = $87010999ebf2f889$var$convert[model];
    delete $87010999ebf2f889$var$convert[model].channels;
    delete $87010999ebf2f889$var$convert[model].labels;
    Object.defineProperty($87010999ebf2f889$var$convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty($87010999ebf2f889$var$convert[model], 'labels', {
        value: labels
    });
}
$87010999ebf2f889$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $87010999ebf2f889$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $87010999ebf2f889$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$87010999ebf2f889$var$convert.rgb.keyword = function(rgb) {
    const reversed = $87010999ebf2f889$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($jVuP9)){
        const value = $jVuP9[keyword];
        // Compute comparative distance
        const distance = $87010999ebf2f889$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$87010999ebf2f889$var$convert.keyword.rgb = function(keyword) {
    return $jVuP9[keyword];
};
$87010999ebf2f889$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$87010999ebf2f889$var$convert.rgb.lab = function(rgb) {
    const xyz = $87010999ebf2f889$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$87010999ebf2f889$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$87010999ebf2f889$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$87010999ebf2f889$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$87010999ebf2f889$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$87010999ebf2f889$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$87010999ebf2f889$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $87010999ebf2f889$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$87010999ebf2f889$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $87010999ebf2f889$var$convert.rgb.ansi16($87010999ebf2f889$var$convert.hsv.rgb(args), args[2]);
};
$87010999ebf2f889$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$87010999ebf2f889$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$87010999ebf2f889$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map((char)=>{
        return char + char;
    }).join('');
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$87010999ebf2f889$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$87010999ebf2f889$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$87010999ebf2f889$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$87010999ebf2f889$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$87010999ebf2f889$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$87010999ebf2f889$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$87010999ebf2f889$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$87010999ebf2f889$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$87010999ebf2f889$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$87010999ebf2f889$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$87010999ebf2f889$var$convert.gray.hsv = $87010999ebf2f889$var$convert.gray.hsl;
$87010999ebf2f889$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$87010999ebf2f889$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$87010999ebf2f889$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$87010999ebf2f889$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$87010999ebf2f889$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});
parcelRegister("jVuP9", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});


parcelRegister("48NUw", function(module, exports) {

var $bACEm = parcelRequire("bACEm");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $303e9ffbb6f2ff34$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($bACEm);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $303e9ffbb6f2ff34$var$deriveBFS(fromModel) {
    const graph = $303e9ffbb6f2ff34$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($bACEm[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $303e9ffbb6f2ff34$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $303e9ffbb6f2ff34$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $bACEm[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $303e9ffbb6f2ff34$var$link($bACEm[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $303e9ffbb6f2ff34$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $303e9ffbb6f2ff34$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});



parcelRegister("74s9X", function(module, exports) {
'use strict';
module.exports = {
    stdout: false,
    stderr: false
};

});

parcelRegister("5Lpwp", function(module, exports) {
'use strict';
const $4325239eef176923$var$stringReplaceAll = (string, substring, replacer)=>{
    let index = string.indexOf(substring);
    if (index === -1) return string;
    const substringLength = substring.length;
    let endIndex = 0;
    let returnValue = '';
    do {
        returnValue += string.substr(endIndex, index - endIndex) + substring + replacer;
        endIndex = index + substringLength;
        index = string.indexOf(substring, endIndex);
    }while (index !== -1);
    returnValue += string.substr(endIndex);
    return returnValue;
};
const $4325239eef176923$var$stringEncaseCRLFWithFirstIndex = (string, prefix, postfix, index)=>{
    let endIndex = 0;
    let returnValue = '';
    do {
        const gotCR = string[index - 1] === '\r';
        returnValue += string.substr(endIndex, (gotCR ? index - 1 : index) - endIndex) + prefix + (gotCR ? '\r\n' : '\n') + postfix;
        endIndex = index + 1;
        index = string.indexOf('\n', endIndex);
    }while (index !== -1);
    returnValue += string.substr(endIndex);
    return returnValue;
};
module.exports = {
    stringReplaceAll: $4325239eef176923$var$stringReplaceAll,
    stringEncaseCRLFWithFirstIndex: $4325239eef176923$var$stringEncaseCRLFWithFirstIndex
};

});

parcelRegister("kCHVr", function(module, exports) {
'use strict';
const $f0396deca2fa1d25$var$TEMPLATE_REGEX = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const $f0396deca2fa1d25$var$STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const $f0396deca2fa1d25$var$STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const $f0396deca2fa1d25$var$ESCAPE_REGEX = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi;
const $f0396deca2fa1d25$var$ESCAPES = new Map([
    [
        'n',
        '\n'
    ],
    [
        'r',
        '\r'
    ],
    [
        't',
        '\t'
    ],
    [
        'b',
        '\b'
    ],
    [
        'f',
        '\f'
    ],
    [
        'v',
        '\v'
    ],
    [
        '0',
        '\0'
    ],
    [
        '\\',
        '\\'
    ],
    [
        'e',
        '\u001B'
    ],
    [
        'a',
        '\u0007'
    ]
]);
function $f0396deca2fa1d25$var$unescape(c) {
    const u = c[0] === 'u';
    const bracket = c[1] === '{';
    if (u && !bracket && c.length === 5 || c[0] === 'x' && c.length === 3) return String.fromCharCode(parseInt(c.slice(1), 16));
    if (u && bracket) return String.fromCodePoint(parseInt(c.slice(2, -1), 16));
    return $f0396deca2fa1d25$var$ESCAPES.get(c) || c;
}
function $f0396deca2fa1d25$var$parseArguments(name, arguments_) {
    const results = [];
    const chunks = arguments_.trim().split(/\s*,\s*/g);
    let matches;
    for (const chunk of chunks){
        const number = Number(chunk);
        if (!Number.isNaN(number)) results.push(number);
        else if (matches = chunk.match($f0396deca2fa1d25$var$STRING_REGEX)) results.push(matches[2].replace($f0396deca2fa1d25$var$ESCAPE_REGEX, (m, escape, character)=>escape ? $f0396deca2fa1d25$var$unescape(escape) : character));
        else throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
    }
    return results;
}
function $f0396deca2fa1d25$var$parseStyle(style) {
    $f0396deca2fa1d25$var$STYLE_REGEX.lastIndex = 0;
    const results = [];
    let matches;
    while((matches = $f0396deca2fa1d25$var$STYLE_REGEX.exec(style)) !== null){
        const name = matches[1];
        if (matches[2]) {
            const args = $f0396deca2fa1d25$var$parseArguments(name, matches[2]);
            results.push([
                name
            ].concat(args));
        } else results.push([
            name
        ]);
    }
    return results;
}
function $f0396deca2fa1d25$var$buildStyle(chalk, styles) {
    const enabled = {};
    for (const layer of styles)for (const style of layer.styles)enabled[style[0]] = layer.inverse ? null : style.slice(1);
    let current = chalk;
    for (const [styleName, styles] of Object.entries(enabled)){
        if (!Array.isArray(styles)) continue;
        if (!(styleName in current)) throw new Error(`Unknown Chalk style: ${styleName}`);
        current = styles.length > 0 ? current[styleName](...styles) : current[styleName];
    }
    return current;
}
module.exports = (chalk, temporary)=>{
    const styles = [];
    const chunks = [];
    let chunk = [];
    // eslint-disable-next-line max-params
    temporary.replace($f0396deca2fa1d25$var$TEMPLATE_REGEX, (m, escapeCharacter, inverse, style, close, character)=>{
        if (escapeCharacter) chunk.push($f0396deca2fa1d25$var$unescape(escapeCharacter));
        else if (style) {
            const string = chunk.join('');
            chunk = [];
            chunks.push(styles.length === 0 ? string : $f0396deca2fa1d25$var$buildStyle(chalk, styles)(string));
            styles.push({
                inverse: inverse,
                styles: $f0396deca2fa1d25$var$parseStyle(style)
            });
        } else if (close) {
            if (styles.length === 0) throw new Error('Found extraneous } in Chalk template literal');
            chunks.push($f0396deca2fa1d25$var$buildStyle(chalk, styles)(chunk.join('')));
            chunk = [];
            styles.pop();
        } else chunk.push(character);
    });
    chunks.push(chunk.join(''));
    if (styles.length > 0) {
        const errMessage = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? '' : 's'} (\`}\`)`;
        throw new Error(errMessage);
    }
    return chunks.join('');
};

});


parcelRegister("7pWKZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5668721651034315$var$_chalk = $5668721651034315$var$_interopRequireDefault((parcelRequire("54Wdc")));
function $5668721651034315$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5668721651034315$var$_default = {
    info (messages) {
        console.warn('');
        messages.forEach((message)=>{
            console.warn($5668721651034315$var$_chalk.default.bold.cyan('info'), '-', message);
        });
    },
    warn (messages) {
        console.warn('');
        messages.forEach((message)=>{
            console.warn($5668721651034315$var$_chalk.default.bold.yellow('warn'), '-', message);
        });
    },
    risk (messages) {
        console.warn('');
        messages.forEach((message)=>{
            console.warn($5668721651034315$var$_chalk.default.bold.magenta('risk'), '-', message);
        });
    }
};
module.exports.default = $5668721651034315$var$_default;

});




parcelRegister("2mJUK", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/no-var-requires

var $byT7c = parcelRequire("byT7c");

module.exports = {
    purge: {
        content: [
            "./src/**/*.{js,jsx,ts,tsx,html}"
        ],
        options: {
            safelist: [
                // whitelist dynamic colours from being purged
                /ch-/,
                /sectra-blue/
            ]
        }
    },
    theme: {
        minWidth: {
            "48": "12rem",
            "36": "9rem"
        },
        extend: {
            fontFamily: {
                "sans": [
                    "'Open Sans'",
                    ...$byT7c.fontFamily.sans
                ]
            },
            colors: {
                "ch-gray": {
                    "200": "#F7F7F7",
                    "300": "#F0F0F0",
                    "400": "#E0E0E0",
                    "450": "#CECECE",
                    "500": "#ADADAD",
                    "600": "#515151"
                },
                "ch-gray-alt": {
                    "500": "#848484",
                    "600": "#4f4f4f" // ended meeting status text, switch tenant button
                },
                "ch-blue": {
                    "100": "#ECF5F5",
                    "200": "#D0E2E3",
                    "300": "#C0E9EB",
                    "400": "#84D6DA",
                    "500": "#13B7BF",
                    "600": "#0B9298",
                    "700": "#587475",
                    "800": "#455354" // nav background
                },
                "ch-blue-alt": {
                    "200": "#F2F8F8",
                    "300": "#A3C3C4",
                    "400": "#75A7A9",
                    "500": "#006F74",
                    "600": "#01494C" // not in design
                },
                "ch-orange": {
                    "500": "#E2781F",
                    "600": "#BF5C09"
                },
                "ch-purple": {
                    "500": "#730B4D",
                    "600": "#540537"
                },
                "ch-red": {
                    "500": "#C20000"
                },
                "ch-green": {
                    "200": "#C1DBA2",
                    "300": "#98C465",
                    "500": "#10B981",
                    "600": "#059669"
                },
                "ch-yellow": {
                    "200": "#FAF2DE",
                    "500": "#D1B239"
                },
                "sectra-blue": {
                    "500": "#2960a8",
                    "600": "#1f487e"
                }
            }
        }
    },
    variants: {
        extend: {
            ringWidth: [
                "hover"
            ],
            borderRadius: [
                "hover"
            ]
        }
    },
    plugins: [
        (parcelRequire("5ck6C"))
    ]
};

});
parcelRegister("byT7c", function(module, exports) {

var $iGQLm = parcelRequire("iGQLm");

var $eQjhe = parcelRequire("eQjhe");
module.exports = $iGQLm($eQjhe.theme);

});
parcelRegister("iGQLm", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d9b513d63d79678d$var$cloneDeep;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = '[object Arguments]', $ee040e257a097984$var$arrayTag = '[object Array]', $ee040e257a097984$var$boolTag = '[object Boolean]', $ee040e257a097984$var$dateTag = '[object Date]', $ee040e257a097984$var$errorTag = '[object Error]', $ee040e257a097984$var$funcTag = '[object Function]', $ee040e257a097984$var$genTag = '[object GeneratorFunction]', $ee040e257a097984$var$mapTag = '[object Map]', $ee040e257a097984$var$numberTag = '[object Number]', $ee040e257a097984$var$objectTag = '[object Object]', $ee040e257a097984$var$regexpTag = '[object RegExp]', $ee040e257a097984$var$setTag = '[object Set]', $ee040e257a097984$var$stringTag = '[object String]', $ee040e257a097984$var$symbolTag = '[object Symbol]', $ee040e257a097984$var$weakMapTag = '[object WeakMap]';
var $ee040e257a097984$var$arrayBufferTag = '[object ArrayBuffer]', $ee040e257a097984$var$dataViewTag = '[object DataView]', $ee040e257a097984$var$float32Tag = '[object Float32Array]', $ee040e257a097984$var$float64Tag = '[object Float64Array]', $ee040e257a097984$var$int8Tag = '[object Int8Array]', $ee040e257a097984$var$int16Tag = '[object Int16Array]', $ee040e257a097984$var$int32Tag = '[object Int32Array]', $ee040e257a097984$var$uint8Tag = '[object Uint8Array]', $ee040e257a097984$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee040e257a097984$var$uint16Tag = '[object Uint16Array]', $ee040e257a097984$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});

parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});

parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $392dfd68f4953502$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = '[object Boolean]', $85aa01d56b12d536$var$dateTag = '[object Date]', $85aa01d56b12d536$var$mapTag = '[object Map]', $85aa01d56b12d536$var$numberTag = '[object Number]', $85aa01d56b12d536$var$regexpTag = '[object RegExp]', $85aa01d56b12d536$var$setTag = '[object Set]', $85aa01d56b12d536$var$stringTag = '[object String]', $85aa01d56b12d536$var$symbolTag = '[object Symbol]';
var $85aa01d56b12d536$var$arrayBufferTag = '[object ArrayBuffer]', $85aa01d56b12d536$var$dataViewTag = '[object DataView]', $85aa01d56b12d536$var$float32Tag = '[object Float32Array]', $85aa01d56b12d536$var$float64Tag = '[object Float64Array]', $85aa01d56b12d536$var$int8Tag = '[object Int8Array]', $85aa01d56b12d536$var$int16Tag = '[object Int16Array]', $85aa01d56b12d536$var$int32Tag = '[object Int32Array]', $85aa01d56b12d536$var$uint8Tag = '[object Uint8Array]', $85aa01d56b12d536$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85aa01d56b12d536$var$uint16Tag = '[object Uint16Array]', $85aa01d56b12d536$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});





parcelRegister("5ck6C", function(module, exports) {

var $8lbaV = parcelRequire("8lbaV");
const $3c8dab570b97fa54$var$lineClamp = $8lbaV(function({ addUtilities: addUtilities, theme: theme, variants: variants, e: e }) {
    const values = theme('lineClamp');
    addUtilities([
        Object.entries(values).map(([key, value])=>{
            return {
                [`.${e(`line-clamp-${key}`)}`]: {
                    overflow: 'hidden',
                    display: '-webkit-box',
                    '-webkit-box-orient': 'vertical',
                    '-webkit-line-clamp': `${value}`
                }
            };
        }),
        {
            '.line-clamp-none': {
                '-webkit-line-clamp': 'unset'
            }
        }
    ], variants('lineClamp'));
}, {
    theme: {
        lineClamp: {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6'
        }
    },
    variants: {
        lineClamp: [
            'responsive'
        ]
    }
});
module.exports = $3c8dab570b97fa54$var$lineClamp;

});
parcelRegister("8lbaV", function(module, exports) {

var $3cejm = parcelRequire("3cejm");
module.exports = ($3cejm.__esModule ? $3cejm : {
    default: $3cejm
}).default;

});
parcelRegister("3cejm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $253d97ffc5d4aad4$var$createPlugin(plugin, config) {
    return {
        handler: plugin,
        config: config
    };
}
$253d97ffc5d4aad4$var$createPlugin.withOptions = function(pluginFunction, configFunction = ()=>({})) {
    const optionsFunction = function(options) {
        return {
            __options: options,
            handler: pluginFunction(options),
            config: configFunction(options)
        };
    };
    optionsFunction.__isOptionsFunction = true; // Expose plugin dependencies so that `object-hash` returns a different
    // value if anything here changes, to ensure a rebuild is triggered.
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
};
var $253d97ffc5d4aad4$var$_default = $253d97ffc5d4aad4$var$createPlugin;
module.exports.default = $253d97ffc5d4aad4$var$_default;

});








parcelRegister("gAckH", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b8b5354b7cdb44$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $cU6Is = parcelRequire("cU6Is");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $50Djh = parcelRequire("50Djh");

var $fH7G0 = parcelRequire("fH7G0");

var $fpLIl = parcelRequire("fpLIl");

var $9wrAY = parcelRequire("9wrAY");

var $luON0 = parcelRequire("luON0");

var $22l7u = parcelRequire("22l7u");
const $27b8b5354b7cdb44$var$ChatMenu = (props)=>{
    if (!props.chatId) return null;
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const [isMembersModalOpen, setIsMembersModalOpen] = (0, $acw62.useState)(false);
    const closeMembersModal = ()=>setIsMembersModalOpen(false);
    const openMembersModal = ()=>setIsMembersModalOpen(true);
    const [confirmEndModalIsOpen, setConfirmEndModalIsOpen] = (0, $acw62.useState)(false);
    const [exportChatModalIsOpen, setExportChatModalIsOpen] = (0, $acw62.useState)(false);
    const dispatch = (0, $2OPjR.useDispatch)();
    const toggleMuteChat = ()=>dispatch((0, $50Djh.toggleMutedChatAsync)(props.chatId));
    const renderMuteButton = ()=>{
        if (!chat || chat?.endedAt) return null;
        const textKey = chat.options?.muted ? "unmute" : "mute";
        return {
            text: t(`message:index:buttons:${textKey}`),
            action: toggleMuteChat
        };
    };
    const renderEndChatButton = ()=>{
        if (!chat?.permissions.canEnd || chat?.endedAt !== null || chat?.type == (0, $fpLIl.ChatTypes).MEETING) return null;
        return {
            text: t("message:shared:buttons:endChat"),
            action: ()=>setConfirmEndModalIsOpen(true)
        };
    };
    const renderExportChatButton = ()=>{
        if (!chat?.permissions.canExport || chat?.endedAt !== null || chat?.case == null) return null;
        return {
            text: t("message:exportChat:buttons:exportAndClose"),
            action: ()=>setExportChatModalIsOpen(true)
        };
    };
    const actions = [
        {
            text: t("message:index:buttons:viewMembers"),
            action: openMembersModal
        },
        renderMuteButton(),
        renderEndChatButton(),
        renderExportChatButton()
    ].filter((a)=>a) // to remove the possible `null` elements
    ;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "ml-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22l7u.default), {
                id: props.chatId,
                actions: actions
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cU6Is.default), {
                closeModal: closeMembersModal,
                isOpen: isMembersModalOpen,
                chatId: props.chatId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9wrAY.default), {
                chatId: props.chatId,
                isOpen: confirmEndModalIsOpen,
                closeModal: ()=>setConfirmEndModalIsOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $luON0.default), {
                chatId: props.chatId,
                isOpen: exportChatModalIsOpen,
                closeModal: ()=>setExportChatModalIsOpen(false)
            })
        ]
    });
};
var $27b8b5354b7cdb44$export$2e2bcd8739ae039 = $27b8b5354b7cdb44$var$ChatMenu;

});
parcelRegister("cU6Is", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35934600548d034$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $5v6Bi = parcelRequire("5v6Bi");

var $1Cmbh = parcelRequire("1Cmbh");

var $eEtn6 = parcelRequire("eEtn6");

var $7jD0k = parcelRequire("7jD0k");

var $fH7G0 = parcelRequire("fH7G0");

var $jTkGE = parcelRequire("jTkGE");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("jitSV");
var $4fat5 = parcelRequire("4fat5");

var $1g6OM = parcelRequire("1g6OM");

var $9k8Fh = parcelRequire("9k8Fh");

var $fpLIl = parcelRequire("fpLIl");
const $b35934600548d034$var$ChatMembersModal = (props)=>{
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const team = (0, $iD0SF.useSelector)((state)=>(0, $jTkGE.getTeamById)(state, chat.team));
    const renderTeamHeader = ()=>{
        if (chat.type != (0, $fpLIl.ChatTypes).TEAM || !team) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Cmbh.default), {
            className: "mb-6",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eEtn6.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v6Bi.default), {
                        className: "sm:mr-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fat5.default), {
                            className: "fill-current w-6 h-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1g6OM.default), {
                        teamId: team.id,
                        userId: team.owner
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                renderTeamHeader(),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "font-semibold mb-2",
                    children: "Members"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    children: chat.users.map((userId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9k8Fh.default), {
                            userId: userId,
                            hideButtons: true
                        }, userId))
                })
            ]
        })
    });
};
var $b35934600548d034$export$2e2bcd8739ae039 = $b35934600548d034$var$ChatMembersModal;

});

parcelRegister("9wrAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed20c08fc269c13$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $b5weT = parcelRequire("b5weT");

var $50Djh = parcelRequire("50Djh");

var $7jD0k = parcelRequire("7jD0k");

var $jF0Xa = parcelRequire("jF0Xa");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");
const $1ed20c08fc269c13$var$EndChatConfirmModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const endChat = ()=>dispatch((0, $50Djh.endChatAsync)(props.chatId));
    const onClickEndChat = ()=>{
        endChat();
        props.closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.dialogueModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("message:endChat:modalTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                    buttons: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: props.closeModal,
                            variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                            children: t("shared:cancel")
                        }, "1"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            action: onClickEndChat,
                            variant: (0, $jF0Xa.StyleVariants).PURPLE,
                            children: t("message:shared:buttons:endChat")
                        }, "2")
                    ]
                })
            ]
        })
    });
};
var $1ed20c08fc269c13$export$2e2bcd8739ae039 = $1ed20c08fc269c13$var$EndChatConfirmModal;

});

parcelRegister("luON0", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5b671c1c5f6e9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $b5weT = parcelRequire("b5weT");

var $jF0Xa = parcelRequire("jF0Xa");

var $7jD0k = parcelRequire("7jD0k");

var $50Djh = parcelRequire("50Djh");

var $8gWrT = parcelRequire("8gWrT");

var $9mZQc = parcelRequire("9mZQc");
const $23b5b671c1c5f6e9$var$ExportChatModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    (0, $acw62.useEffect)(()=>{
        if (!props.isOpen) return;
        dispatch((0, $50Djh.fetchChatAssetsAsync)(props.chatId));
    }, [
        props.isOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("message:exportChat:modalTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-ch-blue-600 mb-2",
                    children: t("message:exportChat:info1")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-ch-blue-600 mb-2",
                    children: t("message:exportChat:info2")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mZQc.default), {
                    chatId: props.chatId
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8gWrT.default), {
                    chatId: props.chatId,
                    closeModal: props.closeModal,
                    isOpen: props.isOpen
                })
            ]
        })
    });
};
var $23b5b671c1c5f6e9$export$2e2bcd8739ae039 = $23b5b671c1c5f6e9$var$ExportChatModal;

});
parcelRegister("8gWrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ea9cb7302030e8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $fH7G0 = parcelRequire("fH7G0");

var $04A9g = parcelRequire("04A9g");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $bYFMK = parcelRequire("bYFMK");

var $7UN5R = parcelRequire("7UN5R");

var $ifbAI = parcelRequire("ifbAI");

var $eTqMc = parcelRequire("eTqMc");

var $lerXT = parcelRequire("lerXT");

var $50Djh = parcelRequire("50Djh");
const $a8ea9cb7302030e8$var$ExportChatForm = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const chat = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getChatById)(state, props));
    const dispatch = (0, $2OPjR.useDispatch)();
    const exportChat = (chatId, exportChatData)=>dispatch((0, $50Djh.exportChatAsync)(chatId, exportChatData));
    const formikFormRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!formikFormRef?.current) return;
        formikFormRef.current.resetForm();
    }, [
        chat.messageAssets,
        props.isOpen
    ]);
    if (!chat.messageAssets) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "font-bold text-center",
        children: t("message:exportChat:noChatAssets")
    });
    const initialValues = {
        assetIds: chat.messageAssets,
        summary: ""
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $bYFMK.exportChatValidation),
            onSubmit: (values, { setSubmitting: setSubmitting })=>{
                exportChat(props.chatId, values);
                setSubmitting(false);
                props.closeModal();
            },
            innerRef: formikFormRef,
            children: ({ isSubmitting: isSubmitting, values: values, handleBlur: handleBlur, handleChange: handleChange, setFieldValue: setFieldValue, touched: touched, errors: errors, isValid: isValid })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "summary",
                                    required: true,
                                    children: t("message:exportChat:attributes:summary")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifbAI.default), {
                                    type: "text",
                                    name: "summary",
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: values.summary,
                                    autoComplete: "off",
                                    autoFocus: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.summary,
                                    isVisible: errors.summary && touched.summary
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7UN5R.default), {
                                    name: "assetIds",
                                    required: true,
                                    children: t("message:exportChat:attributes:assetIds")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lerXT.default), {
                                    assetIds: values.assetIds,
                                    setFieldValue: setFieldValue
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eTqMc.default), {
                                    errorMessage: errors.assetIds,
                                    isVisible: errors.assetIds && touched.assetIds
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                            buttons: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    action: props.closeModal,
                                    variant: (0, $jF0Xa.StyleVariants).BLUE_ALT,
                                    children: t("shared:cancel")
                                }, "1"),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isSubmit: true,
                                    isDisabled: isSubmitting || !isValid || chat?.endedAt !== null,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    children: t("message:exportChat:buttons:exportAndClose")
                                }, "2")
                            ]
                        })
                    ]
                });
            }
        })
    });
};
var $a8ea9cb7302030e8$export$2e2bcd8739ae039 = $a8ea9cb7302030e8$var$ExportChatForm;

});
parcelRegister("bYFMK", function(module, exports) {

$parcel$export(module.exports, "exportChatValidation", () => $3f8431f70bf8ffce$export$9023178f426904b9);
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $3f8431f70bf8ffce$export$9023178f426904b9 = ()=>{
    return $hDGtv.create().shape({
        summary: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")).max(100, (0, $5wPBK.default).t("shared:maxLengthExceeded", {
            maxLength: 100
        })),
        assetIds: $jpuYg.create().required((0, $5wPBK.default).t("shared:required")).min(1, (0, $5wPBK.default).t("shared:mustSelectAtLeastOne"))
    });
};

});

parcelRegister("lerXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee6a49c783cce7b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $36iYr = parcelRequire("36iYr");
const $8ee6a49c783cce7b$var$ExportChatAssetsSelect = (props)=>{
    const onRemoveAsset = (removedAssetId)=>{
        if (props.assetIds.length == 1) return;
        const filteredAssetIds = props.assetIds.filter((id)=>id != removedAssetId);
        props.setFieldValue("assetIds", filteredAssetIds);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex gap-1 item overflow-scroll",
        children: props.assetIds.map((messageAssetId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $36iYr.default), {
                messageAssetId: messageAssetId,
                removeItem: onRemoveAsset
            }, messageAssetId);
        })
    });
};
var $8ee6a49c783cce7b$export$2e2bcd8739ae039 = $8ee6a49c783cce7b$var$ExportChatAssetsSelect;

});
parcelRegister("36iYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a43d97278643f48$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $irINt = parcelRequire("irINt");

var $fH7G0 = parcelRequire("fH7G0");
parcelRequire("jitSV");
var $e1x9J = parcelRequire("e1x9J");
var $4rRXd = parcelRequire("4rRXd");
const $5a43d97278643f48$var$ExportChatAssetsSelectItem = (props)=>{
    const messageAsset = (0, $iD0SF.useSelector)((state)=>(0, $fH7G0.getMessageAssetById)(state, props));
    if (!messageAsset.asset) return null;
    const renderThumb = ()=>{
        if (messageAsset.asset.contentType == "application/pdf") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-blue-alt-400 mr-1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1x9J.default), {
                className: "w-5 h-5"
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex w-5 h-5 items-center justify-center mr-1 overflow-hidden",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $irINt.default), {
                path: messageAsset.asset.path,
                title: messageAsset.asset.name
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex py-0.5 pl-2 rounded-md border border-ch-gray-400 items-center",
        children: [
            renderThumb(),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "text-xs",
                children: messageAsset.asset.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                className: "text-ch-gray-500 hover:text-ch-red-500 cursor-pointer p-1",
                onClick: ()=>props.removeItem(props.messageAssetId),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4rRXd.default), {
                    className: "w-3 h-3 fill-current mr-1"
                })
            })
        ]
    });
};
var $5a43d97278643f48$export$2e2bcd8739ae039 = $5a43d97278643f48$var$ExportChatAssetsSelectItem;

});







parcelRegister("enXOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $14853857717ab43a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $7YFi7 = parcelRequire("7YFi7");

var $kVrOK = parcelRequire("kVrOK");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $lCZwG = parcelRequire("lCZwG");

var $aSzjr = parcelRequire("aSzjr");

var $jF0Xa = parcelRequire("jF0Xa");

var $fpLIl = parcelRequire("fpLIl");

var $dGW6f = parcelRequire("dGW6f");

var $3DtdZ = parcelRequire("3DtdZ");

var $2TgIT = parcelRequire("2TgIT");

var $lmRKb = parcelRequire("lmRKb");

var $6TGTW = parcelRequire("6TGTW");
const $14853857717ab43a$var$ChatNewForm = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const createChat = (chat)=>dispatch((0, $dGW6f.createChatAsync)(chat));
    const initialValues = {
        message: "",
        userIds: [],
        teamId: "",
        caseId: "",
        isTeamChat: false
    };
    const formikFormRef = (0, $acw62.useRef)(null);
    let pressedKeys = [];
    const onMessageFieldKeyDown = (event)=>{
        pressedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
            ...pressedKeys,
            event.key
        ]);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(pressedKeys, $kVrOK.VALUE_RETURN) && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(pressedKeys, $kVrOK.VALUE_SHIFT)) {
            event.preventDefault();
            formikFormRef.current.submitForm();
        }
    };
    const onMessageFieldKeyUp = (event)=>{
        const withoutKeyUp = pressedKeys.filter((key)=>key != event.key);
        pressedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(withoutKeyUp);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7YFi7.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $3DtdZ.chatNewValidation),
        validateOnChange: true,
        validateOnMount: true,
        onSubmit: (values, { setSubmitting: setSubmitting, resetForm: resetForm })=>{
            const type = values.isTeamChat ? (0, $fpLIl.ChatTypes).TEAM : "";
            const data = {
                type: type,
                messagesAttributes: [
                    {
                        body: values.message
                    }
                ],
                chatUsersAttributes: values.userIds.map((userId)=>{
                    return {
                        userId: userId
                    };
                }),
                caseId: values.caseId,
                teamId: values.teamId
            };
            createChat(data);
            setSubmitting(false);
            resetForm();
        },
        innerRef: formikFormRef,
        children: ({ isSubmitting: isSubmitting, values: values, handleBlur: handleBlur, handleChange: handleChange, setFieldValue: setFieldValue, isValid: isValid })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7YFi7.Form), {
                className: "flex flex-1 flex-col justify-between h-full",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4 border-b border-ch-gray-400 overflow-y-scroll md:overflow-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2TgIT.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-full md:w-3/4 mb-4",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lmRKb.default), {
                                            values: values,
                                            handleBlur: handleBlur,
                                            handleChange: handleChange,
                                            setFieldValue: setFieldValue
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-full mb-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TGTW.default), {
                                            values: values,
                                            setFieldValue: setFieldValue
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-4 border-t border-ch-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb-2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aSzjr.default), {
                                    name: "message",
                                    setValue: (description)=>setFieldValue("message", description),
                                    onBlur: handleBlur,
                                    onKeyDown: onMessageFieldKeyDown,
                                    onKeyUp: onMessageFieldKeyUp,
                                    users: null,
                                    value: values.message,
                                    height: 42
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                    isDisabled: isSubmitting || !isValid,
                                    variant: (0, $jF0Xa.StyleVariants).PURPLE,
                                    isSubmit: true,
                                    children: t("message:new:buttons:send")
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var $14853857717ab43a$export$2e2bcd8739ae039 = $14853857717ab43a$var$ChatNewForm;

});
parcelRegister("dGW6f", function(module, exports) {

$parcel$export(module.exports, "createChatAsync", () => $d198aa239567a7ad$export$706b7dbbfb06f1b7);

var $gyfTN = parcelRequire("gyfTN");
const $d198aa239567a7ad$export$706b7dbbfb06f1b7 = (chat)=>{
    return {
        type: (0, $gyfTN.ChatNewActionTypes).CREATE_CHAT_ASYNC_PENDING,
        payload: {
            chat: chat
        }
    };
};

});

parcelRegister("3DtdZ", function(module, exports) {

$parcel$export(module.exports, "chatNewValidation", () => $c0598f5be7d9108f$export$5bc7c82da42623c0);
parcelRequire("cxhNX");
var $jpuYg = parcelRequire("jpuYg");
var $hDGtv = parcelRequire("hDGtv");
var $gcL7X = parcelRequire("gcL7X");

var $5wPBK = parcelRequire("5wPBK");
const $c0598f5be7d9108f$export$5bc7c82da42623c0 = ()=>{
    return $hDGtv.create().shape({
        message: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required")),
        userIds: $jpuYg.create().when("isTeamChat", {
            is: false,
            then: $jpuYg.create().required((0, $5wPBK.default).t("shared:required")).min(1, (0, $5wPBK.default).t("shared:mustSelectAtLeastOne"))
        }),
        teamId: $gcL7X.create().when("isTeamChat", {
            is: true,
            then: $gcL7X.create().trim().required((0, $5wPBK.default).t("shared:required"))
        })
    });
};

});

parcelRegister("2TgIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d320801e80021345$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jitSV");
var $5AYDs = parcelRequire("5AYDs");
const $d320801e80021345$var$ChatNewHeader = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center mb-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-9 h-9 rounded-full bg-white flex items-center justify-center border border-ch-gray-500",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5AYDs.default), {
                    className: "text-ch-purple-500 w-4 h-4"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "font-semibold text-sm ml-2",
                children: t("message:new:newMessageTitle")
            })
        ]
    });
};
var $d320801e80021345$export$2e2bcd8739ae039 = $d320801e80021345$var$ChatNewHeader;

});

parcelRegister("lmRKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf3cca8b809f3622$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6wDTk = parcelRequire("6wDTk");

var $iVDgl = parcelRequire("iVDgl");

var $6lvMC = parcelRequire("6lvMC");

var $jTkGE = parcelRequire("jTkGE");

var $5GZlj = parcelRequire("5GZlj");

var $gnvJ9 = parcelRequire("gnvJ9");

var $kYqkq = parcelRequire("kYqkq");
const $bf3cca8b809f3622$var$ChatNewUsersField = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    const [userOptions, setUserOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [teamOptions, setTeamOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const users = (0, $iD0SF.useSelector)((0, $6lvMC.getAllInternalActiveUsersSorted));
    const teams = (0, $iD0SF.useSelector)((0, $jTkGE.getAllTeams));
    const dispatch = (0, $kYqkq.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $gnvJ9.fetchAllTeamsAsync)());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const filteredUsers = users.filter((user)=>{
            return user.id != currentUser.id;
        });
        const sortedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(filteredUsers, "id");
        const options = (0, $6wDTk.buildUserOptions)(Object.values(sortedUsers));
        setUserOptions(options);
    }, [
        users
    ]);
    (0, $acw62.useEffect)(()=>{
        const options = Object.values(teams).map((team)=>{
            return {
                value: team.id,
                label: team.name
            };
        });
        setTeamOptions(options);
    }, [
        teams
    ]);
    const renderSelect = ()=>{
        if (props.values.isTeamChat) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
            name: "teamId",
            options: teamOptions,
            onChange: props.handleChange,
            onBlur: props.handleBlur
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GZlj.default), {
            name: "userIds",
            options: userOptions,
            onChange: props.handleChange,
            onBlur: props.handleBlur,
            isMulti: true,
            closeMenuOnSelect: false,
            filterOption: (0, $6wDTk.filterOptionsBySearchValue)
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-sm text-ch-gray-500 italic mb-2",
                children: t("message:new:selectUsersOrTeam")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVDgl.default), {
                onClick: (value)=>{
                    props.setFieldValue("userIds", []);
                    props.setFieldValue("teamId", "");
                    props.setFieldValue("isTeamChat", Boolean(value));
                },
                text1: t("shared:users"),
                text2: t("shared:teams"),
                value: Number(props.values.isTeamChat),
                className: "mb-2 uppercase"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-2 w-full",
                children: renderSelect()
            })
        ]
    });
};
var $bf3cca8b809f3622$export$2e2bcd8739ae039 = $bf3cca8b809f3622$var$ChatNewUsersField;

});

parcelRegister("6TGTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $45169f1bc16e7333$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $aaWA5 = parcelRequire("aaWA5");

var $hHrAK = parcelRequire("hHrAK");
const $45169f1bc16e7333$var$ChatNewCaseField = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "message"
    ]);
    const [isModalOpen, setIsModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const closeModal = ()=>setIsModalOpen(false);
    const openModal = ()=>setIsModalOpen(true);
    const renderSelectCaseButton = ()=>{
        if (props.values.caseId) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            action: openModal,
            children: t("message:new:buttons:selectCase")
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "text-sm text-ch-gray-500 italic mb-2",
                children: t("message:new:selectCase")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-center",
                children: [
                    renderSelectCaseButton(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aaWA5.default), {
                        closeModal: closeModal,
                        isOpen: isModalOpen,
                        values: props.values,
                        setFieldValue: props.setFieldValue
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHrAK.default), {
                        openModal: openModal,
                        values: props.values,
                        setFieldValue: props.setFieldValue
                    })
                ]
            })
        ]
    });
};
var $45169f1bc16e7333$export$2e2bcd8739ae039 = $45169f1bc16e7333$var$ChatNewCaseField;

});
parcelRegister("aaWA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea71427dfbbf13f$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jfXvU = parcelRequire("jfXvU");
var $4KSAX = parcelRequire("4KSAX");

var $b5weT = parcelRequire("b5weT");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7jD0k = parcelRequire("7jD0k");

var $9QVLZ = parcelRequire("9QVLZ");

var $39EfS = parcelRequire("39EfS");

var $1kXfn = parcelRequire("1kXfn");

var $glc4D = parcelRequire("glc4D");

var $kQILj = parcelRequire("kQILj");

var $jF0Xa = parcelRequire("jF0Xa");

var $g21Ia = parcelRequire("g21Ia");

var $7Bj8I = parcelRequire("7Bj8I");

var $aeos3 = parcelRequire("aeos3");

var $C9xk7 = parcelRequire("C9xk7");
const $1ea71427dfbbf13f$var$ChatNewSelectCaseModal = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const { careProviderIdLabel: careProviderIdLabel } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const UI = (0, $iD0SF.useSelector)((state)=>(0, $kQILj.getCasesUI)(state));
    const initialSearchQuery = {
        page: 1,
        appliedFilters: UI.appliedFilters,
        searchTerm: UI.searchTerm,
        resultsPerPage: UI.resultsPerPage,
        orderBy: UI.orderBy
    };
    const [searchQuery, setSearchQuery] = (0, $glc4D.default)(initialSearchQuery, (0, $g21Ia.fetchCasesAsync));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5weT))), {
        isOpen: props.isOpen,
        onRequestClose: props.closeModal,
        style: (0, $jF0Xa.defaultModalStyle),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7jD0k.default), {
            handleClose: props.closeModal,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-lg mb-3",
                    children: t("message:new:selectCaseTitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "grid grid-rows-2 md:grid-rows-1 flex items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-start-2 md:row-start-1 self-center",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                                i18nKey: "case:searchBy",
                                components: {
                                    strong: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {})
                                },
                                values: {
                                    careProviderIdLabel: careProviderIdLabel
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "row-end-2 md:row-start-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39EfS.default), {
                                searchQuery: searchQuery,
                                setSearchQuery: setSearchQuery
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1kXfn.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    buttonText: t("case:searchCases")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "text-lg mb-2",
                    children: [
                        UI.totalCasesCount,
                        " ",
                        t("shared:cases")
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $C9xk7.default), {
                    values: props.values,
                    setFieldValue: props.setFieldValue,
                    closeModal: props.closeModal
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QVLZ.default), {
                    searchQuery: searchQuery,
                    setSearchQuery: setSearchQuery,
                    totalItems: UI.totalCasesCount,
                    totalPages: UI.totalPages,
                    scrollActionType: (0, $7Bj8I.ScrollActionTypes).UPDATE_MODAL_SCROLL_TO_POSITION
                })
            ]
        })
    });
};
var $1ea71427dfbbf13f$export$2e2bcd8739ae039 = $1ea71427dfbbf13f$var$ChatNewSelectCaseModal;

});
parcelRegister("C9xk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5da4a0b3eed3e4ed$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kon2z = parcelRequire("kon2z");

var $dubSf = parcelRequire("dubSf");
const $5da4a0b3eed3e4ed$var$ChatNewCaseList = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "case"
    ]);
    const caseIds = (0, $iD0SF.useSelector)((state)=>(0, $kon2z.getAllCaseIds)(state));
    if (!caseIds) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("case:noCases")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: caseIds.map((caseId)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dubSf.default), {
                caseId: caseId,
                values: props.values,
                setFieldValue: props.setFieldValue,
                closeModal: props.closeModal
            }, caseId);
        })
    });
};
var $5da4a0b3eed3e4ed$export$2e2bcd8739ae039 = $5da4a0b3eed3e4ed$var$ChatNewCaseList;

});
parcelRegister("dubSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $186be86839a38ecf$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $ejvqu = parcelRequire("ejvqu");

var $jF0Xa = parcelRequire("jF0Xa");

var $aVAGa = parcelRequire("aVAGa");
const $186be86839a38ecf$var$ChatNewCaseListItem = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    if (!props.caseId) return null;
    const onClickSelect = ()=>{
        props.setFieldValue("caseId", props.caseId);
        props.closeModal();
    };
    const renderSelectButton = ()=>{
        if (props.values.caseId == props.caseId) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-ch-gray-alt-500",
            children: t("shared:selected")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: onClickSelect,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("message:new:buttons:selectCase")
        }, props.caseId);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVAGa.default), {
        caseId: props.caseId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
            buttons: [
                renderSelectButton()
            ]
        })
    }, props.caseId);
};
var $186be86839a38ecf$export$2e2bcd8739ae039 = $186be86839a38ecf$var$ChatNewCaseListItem;

});



parcelRegister("hHrAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd2de546613dc28$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $04A9g = parcelRequire("04A9g");

var $ejvqu = parcelRequire("ejvqu");

var $koaQF = parcelRequire("koaQF");

var $jF0Xa = parcelRequire("jF0Xa");

var $aVAGa = parcelRequire("aVAGa");

var $jA5LT = parcelRequire("jA5LT");
const $7dd2de546613dc28$var$ChatNewSelectedCaseDetails = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const isMobileView = (0, $koaQF.default)([
        "sm",
        "md"
    ]);
    if (!props.values.caseId) return null;
    const onClickRemove = ()=>{
        props.setFieldValue("caseId", "");
    };
    const onClickChange = ()=>{
        props.setFieldValue("caseId", "");
        props.openModal();
    };
    const buttons = [
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: onClickChange,
            variant: (0, $jF0Xa.StyleVariants).BLUE,
            children: t("message:new:buttons:changeCase")
        }, 1),
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            action: onClickRemove,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("message:new:buttons:removeCase")
        }, 1)
    ];
    if (isMobileView) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jA5LT.default), {
                    caseId: props.values.caseId
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04A9g.default), {
                buttons: buttons
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVAGa.default), {
            caseId: props.values.caseId,
            hasSmallText: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejvqu.default), {
                buttons: buttons
            })
        }, props.values.caseId)
    });
};
var $7dd2de546613dc28$export$2e2bcd8739ae039 = $7dd2de546613dc28$var$ChatNewSelectedCaseDetails;

});



parcelRegister("4xHCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9b2684e8ec4072$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $jF0Xa = parcelRequire("jF0Xa");

var $3rq9i = parcelRequire("3rq9i");
const $ac9b2684e8ec4072$var$PageTitle = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const onClick = ()=>{
        props.setSelectedChatId(null);
        props.setIsNewChatFormOpen(false);
    };
    const renderButton = ()=>{
        if (props.selectedChatId == null && !props.isNewChatFormOpen) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lg:hidden",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                action: onClick,
                className: "ml-5",
                variant: (0, $jF0Xa.StyleVariants).ORANGE,
                children: t("shared:back")
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-between mb-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "text-lg py-1",
                children: t("shared:messages")
            }),
            renderButton(),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3rq9i.default), {
                selectedChatId: props.selectedChatId,
                setSelectedChatId: props.setSelectedChatId,
                setIsNewChatFormOpen: props.setIsNewChatFormOpen
            })
        ]
    });
};
var $ac9b2684e8ec4072$export$2e2bcd8739ae039 = $ac9b2684e8ec4072$var$PageTitle;

});
parcelRegister("3rq9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9289d95ccd0937$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $koaQF = parcelRequire("koaQF");

var $jF0Xa = parcelRequire("jF0Xa");
const $9a9289d95ccd0937$var$NewMessageButton = (props)=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "message"
    ]);
    const isMobileView = (0, $koaQF.default)([
        "sm",
        "md"
    ]);
    const onClick = ()=>{
        props.setIsNewChatFormOpen(true);
        props.setSelectedChatId(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            isDisabled: props.selectedChatId == null && !isMobileView,
            action: onClick,
            variant: (0, $jF0Xa.StyleVariants).ORANGE,
            children: t("message:index:buttons:newMessage")
        })
    });
};
var $9a9289d95ccd0937$export$2e2bcd8739ae039 = $9a9289d95ccd0937$var$NewMessageButton;

});



parcelRegister("8G3Yk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1635d7497daa4f3a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4KSAX = parcelRequire("4KSAX");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $aeos3 = parcelRequire("aeos3");

var $cA1jy = parcelRequire("cA1jy");

var $6lvMC = parcelRequire("6lvMC");

var $aEgqS = parcelRequire("aEgqS");

const $1635d7497daa4f3a$var$AnalyticsMain = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("lHI4f")));
const $1635d7497daa4f3a$var$AnalyticsPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "analytics"
    ]);
    const { analyticsEnabled: analyticsEnabled } = (0, $acw62.useContext)((0, $aeos3.TenantConfigContext));
    const currentUser = (0, $iD0SF.useSelector)((0, $6lvMC.getCurrentUser));
    if (!analyticsEnabled || !(0, $cA1jy.isAdmin)(currentUser)) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        className: "text-lg font-bold text-center",
        children: t("analytics:text:noPermission")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {}),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-full h-full",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($1635d7497daa4f3a$var$AnalyticsMain, {})
        })
    });
};
var $1635d7497daa4f3a$export$2e2bcd8739ae039 = $1635d7497daa4f3a$var$AnalyticsPage;

});
parcelRegister("lHI4f", function(module, exports) {
module.exports = import("3W59F").then(()=>parcelRequire('5Gout'));

});


parcelRegister("6XB6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $345540c30c85761f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aDFyu = parcelRequire("aDFyu");

var $4KSAX = parcelRequire("4KSAX");

var $lCZwG = parcelRequire("lCZwG");

var $kYqkq = parcelRequire("kYqkq");

var $5s7Tw = parcelRequire("5s7Tw");

var $1zizz = parcelRequire("1zizz");

var $arZQw = parcelRequire("arZQw");

var $jiIfA = parcelRequire("jiIfA");

var $jF0Xa = parcelRequire("jF0Xa");
parcelRequire("cIYPX");
var $ji22T = parcelRequire("ji22T");
var $dHVXA = parcelRequire("dHVXA");

var $6lvMC = parcelRequire("6lvMC");
const $345540c30c85761f$var$RadiologyPage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "shared",
        "radiology"
    ]);
    const currentAbilities = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUserAbilities));
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const [buttonDisabled, setButtonDisabled] = (0, $acw62.useState)(false);
    const clickHandler = async ()=>{
        setButtonDisabled(true);
        setTimeout(()=>setButtonDisabled(false), 2000);
        try {
            const { data: data } = await (0, $5s7Tw.default).get("/radiology/link", (0, $1zizz.withAuthHeader)());
            open(data.link);
        } catch  {
            dispatch((0, $arZQw.displayUserMessageAction)({
                messageKey: "radiologyLinkFailed",
                type: (0, $jiIfA.UserMessageTypes).ERROR
            }));
        }
    };
    const outerClasses = "m-auto lg:w-1/2 border border-ch-gray-400 rounded-md lg:p-4 bg-white ";
    const innerClasses = "flex flex-1 m-8 items-center text-center flex-wrap justify-center ";
    const renderIdoniaSection = ()=>{
        if (!currentAbilities?.radiology?.canManage) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: outerClasses,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: innerClasses,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ji22T.default), {
                        className: "h-28"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: innerClasses,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: t("radiology:text:tagLine")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: innerClasses,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                            variant: (0, $jF0Xa.StyleVariants).BLUE,
                            action: clickHandler,
                            isDisabled: buttonDisabled,
                            children: t("radiology:buttons:open")
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: innerClasses,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: t("radiology:text:sessionMessage")
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDFyu.default), {
                pageTitle: t("shared:radiology")
            }),
            renderIdoniaSection(),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `${outerClasses} mt-12`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: innerClasses,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                color: "#808080"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dHVXA.default), {
                                className: "h-8"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: innerClasses,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
                                external: true,
                                customColour: "sectra-blue",
                                href: "https://www.iepservice.co.uk/IEP/External/Login",
                                isDisabled: buttonDisabled,
                                children: t("radiology:buttons:IEP")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: innerClasses,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: t("radiology:text:IEPMessage")
                        })
                    })
                ]
            })
        ]
    });
};
var $345540c30c85761f$export$2e2bcd8739ae039 = $345540c30c85761f$var$RadiologyPage;

});



var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $COwA0 = parcelRequire("COwA0");

var $b5weT = parcelRequire("b5weT");

var $5wPBK = parcelRequire("5wPBK");

var $gONkJ = parcelRequire("gONkJ");

var $1l1FS = parcelRequire("1l1FS");

var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $jiIfA = parcelRequire("jiIfA");

var $arZQw = parcelRequire("arZQw");

var $4KSAX = parcelRequire("4KSAX");
const $d428a9f6148913af$export$21f2a2ec4d8120e4 = (state)=>state.userMessage;


parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
const $3454eaf910a37d32$var$UserMessage = ()=>{
    const { t: t } = (0, $4KSAX.useTranslation)([
        "userMessage"
    ]);
    const dispatch = (0, $2OPjR.useDispatch)();
    const userMessage = (0, $iD0SF.useSelector)((0, $d428a9f6148913af$export$21f2a2ec4d8120e4));
    const messageKey = userMessage?.messageKey;
    const messageArgs = userMessage?.messageArgs;
    const type = userMessage?.type;
    const isRead = userMessage?.isRead;
    const onMarkUserMessageRead = ()=>dispatch((0, $arZQw.markUserMessageRead)());
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>onMarkUserMessageRead(), 4000);
        return ()=>clearTimeout(timer);
    }, [
        messageKey,
        messageArgs
    ]);
    const renderMessage = ()=>{
        if (!messageKey) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex-1", "text-white", "font-bold", "p-2", "text-center", "mb-2", "mx-5", {
                "bg-yellow-400": type == (0, $jiIfA.UserMessageTypes).MESSAGE,
                "bg-green-400": type == (0, $jiIfA.UserMessageTypes).SUCCESS,
                "bg-red-400": type == (0, $jiIfA.UserMessageTypes).ERROR
            }),
            onClick: onMarkUserMessageRead,
            children: t(`userMessage:${messageKey}`, messageArgs)
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("flex", "absolute", "bottom-0", "items-center", "w-full", "z-999", {
            "hidden": isRead
        }),
        children: renderMessage()
    });
};
var $3454eaf910a37d32$export$2e2bcd8739ae039 = $3454eaf910a37d32$var$UserMessage;



var $aEgqS = parcelRequire("aEgqS");

var $et8Rr = parcelRequire("et8Rr");

var $6lvMC = parcelRequire("6lvMC");

var $8e5HJ = parcelRequire("8e5HJ");





var $ai857 = parcelRequire("ai857");

var $jF0Xa = parcelRequire("jF0Xa");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $9d9fd749327e8703$export$1761c188a41008af = {
    logger: typeof console !== "undefined" ? console : undefined,
    WebSocket: typeof WebSocket !== "undefined" ? WebSocket : undefined
};
var $9d9fd749327e8703$export$af88d00dbe7f521 = {
    log (...messages) {
        if (this.enabled) {
            messages.push(Date.now());
            $9d9fd749327e8703$export$1761c188a41008af.logger.log("[ActionCable]", ...messages);
        }
    }
};
const $9d9fd749327e8703$var$now = ()=>(new Date).getTime();
const $9d9fd749327e8703$var$secondsSince = (time)=>($9d9fd749327e8703$var$now() - time) / 1e3;
class $9d9fd749327e8703$export$3ef8dc0174655dd9 {
    constructor(connection){
        this.visibilityDidChange = this.visibilityDidChange.bind(this);
        this.connection = connection;
        this.reconnectAttempts = 0;
    }
    start() {
        if (!this.isRunning()) {
            this.startedAt = $9d9fd749327e8703$var$now();
            delete this.stoppedAt;
            this.startPolling();
            addEventListener("visibilitychange", this.visibilityDidChange);
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`ConnectionMonitor started. stale threshold = ${this.constructor.staleThreshold} s`);
        }
    }
    stop() {
        if (this.isRunning()) {
            this.stoppedAt = $9d9fd749327e8703$var$now();
            this.stopPolling();
            removeEventListener("visibilitychange", this.visibilityDidChange);
            $9d9fd749327e8703$export$af88d00dbe7f521.log("ConnectionMonitor stopped");
        }
    }
    isRunning() {
        return this.startedAt && !this.stoppedAt;
    }
    recordMessage() {
        this.pingedAt = $9d9fd749327e8703$var$now();
    }
    recordConnect() {
        this.reconnectAttempts = 0;
        delete this.disconnectedAt;
        $9d9fd749327e8703$export$af88d00dbe7f521.log("ConnectionMonitor recorded connect");
    }
    recordDisconnect() {
        this.disconnectedAt = $9d9fd749327e8703$var$now();
        $9d9fd749327e8703$export$af88d00dbe7f521.log("ConnectionMonitor recorded disconnect");
    }
    startPolling() {
        this.stopPolling();
        this.poll();
    }
    stopPolling() {
        clearTimeout(this.pollTimeout);
    }
    poll() {
        this.pollTimeout = setTimeout(()=>{
            this.reconnectIfStale();
            this.poll();
        }, this.getPollInterval());
    }
    getPollInterval() {
        const { staleThreshold: staleThreshold, reconnectionBackoffRate: reconnectionBackoffRate } = this.constructor;
        const backoff = Math.pow(1 + reconnectionBackoffRate, Math.min(this.reconnectAttempts, 10));
        const jitterMax = this.reconnectAttempts === 0 ? 1 : reconnectionBackoffRate;
        const jitter = jitterMax * Math.random();
        return staleThreshold * 1e3 * backoff * (1 + jitter);
    }
    reconnectIfStale() {
        if (this.connectionIsStale()) {
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`ConnectionMonitor detected stale connection. reconnectAttempts = ${this.reconnectAttempts}, time stale = ${$9d9fd749327e8703$var$secondsSince(this.refreshedAt)} s, stale threshold = ${this.constructor.staleThreshold} s`);
            this.reconnectAttempts++;
            if (this.disconnectedRecently()) $9d9fd749327e8703$export$af88d00dbe7f521.log(`ConnectionMonitor skipping reopening recent disconnect. time disconnected = ${$9d9fd749327e8703$var$secondsSince(this.disconnectedAt)} s`);
            else {
                $9d9fd749327e8703$export$af88d00dbe7f521.log("ConnectionMonitor reopening");
                this.connection.reopen();
            }
        }
    }
    get refreshedAt() {
        return this.pingedAt ? this.pingedAt : this.startedAt;
    }
    connectionIsStale() {
        return $9d9fd749327e8703$var$secondsSince(this.refreshedAt) > this.constructor.staleThreshold;
    }
    disconnectedRecently() {
        return this.disconnectedAt && $9d9fd749327e8703$var$secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
    }
    visibilityDidChange() {
        if (document.visibilityState === "visible") setTimeout(()=>{
            if (this.connectionIsStale() || !this.connection.isOpen()) {
                $9d9fd749327e8703$export$af88d00dbe7f521.log(`ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ${document.visibilityState}`);
                this.connection.reopen();
            }
        }, 200);
    }
}
$9d9fd749327e8703$export$3ef8dc0174655dd9.staleThreshold = 6;
$9d9fd749327e8703$export$3ef8dc0174655dd9.reconnectionBackoffRate = .15;
var $9d9fd749327e8703$export$e32e5bb0446b4e6 = {
    message_types: {
        welcome: "welcome",
        disconnect: "disconnect",
        ping: "ping",
        confirmation: "confirm_subscription",
        rejection: "reject_subscription"
    },
    disconnect_reasons: {
        unauthorized: "unauthorized",
        invalid_request: "invalid_request",
        server_restart: "server_restart",
        remote: "remote"
    },
    default_mount_path: "/cable",
    protocols: [
        "actioncable-v1-json",
        "actioncable-unsupported"
    ]
};
const { message_types: $9d9fd749327e8703$var$message_types, protocols: $9d9fd749327e8703$var$protocols } = $9d9fd749327e8703$export$e32e5bb0446b4e6;
const $9d9fd749327e8703$var$supportedProtocols = $9d9fd749327e8703$var$protocols.slice(0, $9d9fd749327e8703$var$protocols.length - 1);
const $9d9fd749327e8703$var$indexOf = [].indexOf;
class $9d9fd749327e8703$export$98b66c25bb38499d {
    constructor(consumer){
        this.open = this.open.bind(this);
        this.consumer = consumer;
        this.subscriptions = this.consumer.subscriptions;
        this.monitor = new $9d9fd749327e8703$export$3ef8dc0174655dd9(this);
        this.disconnected = true;
    }
    send(data) {
        if (this.isOpen()) {
            this.webSocket.send(JSON.stringify(data));
            return true;
        } else return false;
    }
    open() {
        if (this.isActive()) {
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`Attempted to open WebSocket, but existing socket is ${this.getState()}`);
            return false;
        } else {
            const socketProtocols = [
                ...$9d9fd749327e8703$var$protocols,
                ...this.consumer.subprotocols || []
            ];
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`Opening WebSocket, current state is ${this.getState()}, subprotocols: ${socketProtocols}`);
            if (this.webSocket) this.uninstallEventHandlers();
            this.webSocket = new $9d9fd749327e8703$export$1761c188a41008af.WebSocket(this.consumer.url, socketProtocols);
            this.installEventHandlers();
            this.monitor.start();
            return true;
        }
    }
    close({ allowReconnect: allowReconnect } = {
        allowReconnect: true
    }) {
        if (!allowReconnect) this.monitor.stop();
        if (this.isOpen()) return this.webSocket.close();
    }
    reopen() {
        $9d9fd749327e8703$export$af88d00dbe7f521.log(`Reopening WebSocket, current state is ${this.getState()}`);
        if (this.isActive()) try {
            return this.close();
        } catch (error) {
            $9d9fd749327e8703$export$af88d00dbe7f521.log("Failed to reopen WebSocket", error);
        } finally{
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`Reopening WebSocket in ${this.constructor.reopenDelay}ms`);
            setTimeout(this.open, this.constructor.reopenDelay);
        }
        else return this.open();
    }
    getProtocol() {
        if (this.webSocket) return this.webSocket.protocol;
    }
    isOpen() {
        return this.isState("open");
    }
    isActive() {
        return this.isState("open", "connecting");
    }
    triedToReconnect() {
        return this.monitor.reconnectAttempts > 0;
    }
    isProtocolSupported() {
        return $9d9fd749327e8703$var$indexOf.call($9d9fd749327e8703$var$supportedProtocols, this.getProtocol()) >= 0;
    }
    isState(...states) {
        return $9d9fd749327e8703$var$indexOf.call(states, this.getState()) >= 0;
    }
    getState() {
        if (this.webSocket) for(let state in $9d9fd749327e8703$export$1761c188a41008af.WebSocket){
            if ($9d9fd749327e8703$export$1761c188a41008af.WebSocket[state] === this.webSocket.readyState) return state.toLowerCase();
        }
        return null;
    }
    installEventHandlers() {
        for(let eventName in this.events){
            const handler = this.events[eventName].bind(this);
            this.webSocket[`on${eventName}`] = handler;
        }
    }
    uninstallEventHandlers() {
        for(let eventName in this.events)this.webSocket[`on${eventName}`] = function() {};
    }
}
$9d9fd749327e8703$export$98b66c25bb38499d.reopenDelay = 500;
$9d9fd749327e8703$export$98b66c25bb38499d.prototype.events = {
    message (event) {
        if (!this.isProtocolSupported()) return;
        const { identifier: identifier, message: message, reason: reason, reconnect: reconnect, type: type } = JSON.parse(event.data);
        this.monitor.recordMessage();
        switch(type){
            case $9d9fd749327e8703$var$message_types.welcome:
                if (this.triedToReconnect()) this.reconnectAttempted = true;
                this.monitor.recordConnect();
                return this.subscriptions.reload();
            case $9d9fd749327e8703$var$message_types.disconnect:
                $9d9fd749327e8703$export$af88d00dbe7f521.log(`Disconnecting. Reason: ${reason}`);
                return this.close({
                    allowReconnect: reconnect
                });
            case $9d9fd749327e8703$var$message_types.ping:
                return null;
            case $9d9fd749327e8703$var$message_types.confirmation:
                this.subscriptions.confirmSubscription(identifier);
                if (this.reconnectAttempted) {
                    this.reconnectAttempted = false;
                    return this.subscriptions.notify(identifier, "connected", {
                        reconnected: true
                    });
                } else return this.subscriptions.notify(identifier, "connected", {
                    reconnected: false
                });
            case $9d9fd749327e8703$var$message_types.rejection:
                return this.subscriptions.reject(identifier);
            default:
                return this.subscriptions.notify(identifier, "received", message);
        }
    },
    open () {
        $9d9fd749327e8703$export$af88d00dbe7f521.log(`WebSocket onopen event, using '${this.getProtocol()}' subprotocol`);
        this.disconnected = false;
        if (!this.isProtocolSupported()) {
            $9d9fd749327e8703$export$af88d00dbe7f521.log("Protocol is unsupported. Stopping monitor and disconnecting.");
            return this.close({
                allowReconnect: false
            });
        }
    },
    close (event) {
        $9d9fd749327e8703$export$af88d00dbe7f521.log("WebSocket onclose event");
        if (this.disconnected) return;
        this.disconnected = true;
        this.monitor.recordDisconnect();
        return this.subscriptions.notifyAll("disconnected", {
            willAttemptReconnect: this.monitor.isRunning()
        });
    },
    error () {
        $9d9fd749327e8703$export$af88d00dbe7f521.log("WebSocket onerror event");
    }
};
const $9d9fd749327e8703$var$extend = function(object, properties) {
    if (properties != null) for(let key in properties){
        const value = properties[key];
        object[key] = value;
    }
    return object;
};
class $9d9fd749327e8703$export$f55210826850c514 {
    constructor(consumer, params = {}, mixin){
        this.consumer = consumer;
        this.identifier = JSON.stringify(params);
        $9d9fd749327e8703$var$extend(this, mixin);
    }
    perform(action, data = {}) {
        data.action = action;
        return this.send(data);
    }
    send(data) {
        return this.consumer.send({
            command: "message",
            identifier: this.identifier,
            data: JSON.stringify(data)
        });
    }
    unsubscribe() {
        return this.consumer.subscriptions.remove(this);
    }
}
class $9d9fd749327e8703$export$b406de9d35d5578b {
    constructor(subscriptions){
        this.subscriptions = subscriptions;
        this.pendingSubscriptions = [];
    }
    guarantee(subscription) {
        if (this.pendingSubscriptions.indexOf(subscription) == -1) {
            $9d9fd749327e8703$export$af88d00dbe7f521.log(`SubscriptionGuarantor guaranteeing ${subscription.identifier}`);
            this.pendingSubscriptions.push(subscription);
        } else $9d9fd749327e8703$export$af88d00dbe7f521.log(`SubscriptionGuarantor already guaranteeing ${subscription.identifier}`);
        this.startGuaranteeing();
    }
    forget(subscription) {
        $9d9fd749327e8703$export$af88d00dbe7f521.log(`SubscriptionGuarantor forgetting ${subscription.identifier}`);
        this.pendingSubscriptions = this.pendingSubscriptions.filter((s)=>s !== subscription);
    }
    startGuaranteeing() {
        this.stopGuaranteeing();
        this.retrySubscribing();
    }
    stopGuaranteeing() {
        clearTimeout(this.retryTimeout);
    }
    retrySubscribing() {
        this.retryTimeout = setTimeout(()=>{
            if (this.subscriptions && typeof this.subscriptions.subscribe === "function") this.pendingSubscriptions.map((subscription)=>{
                $9d9fd749327e8703$export$af88d00dbe7f521.log(`SubscriptionGuarantor resubscribing ${subscription.identifier}`);
                this.subscriptions.subscribe(subscription);
            });
        }, 500);
    }
}
class $9d9fd749327e8703$export$d73dcc2e0bdfb5bd {
    constructor(consumer){
        this.consumer = consumer;
        this.guarantor = new $9d9fd749327e8703$export$b406de9d35d5578b(this);
        this.subscriptions = [];
    }
    create(channelName, mixin) {
        const channel = channelName;
        const params = typeof channel === "object" ? channel : {
            channel: channel
        };
        const subscription = new $9d9fd749327e8703$export$f55210826850c514(this.consumer, params, mixin);
        return this.add(subscription);
    }
    add(subscription) {
        this.subscriptions.push(subscription);
        this.consumer.ensureActiveConnection();
        this.notify(subscription, "initialized");
        this.subscribe(subscription);
        return subscription;
    }
    remove(subscription) {
        this.forget(subscription);
        if (!this.findAll(subscription.identifier).length) this.sendCommand(subscription, "unsubscribe");
        return subscription;
    }
    reject(identifier) {
        return this.findAll(identifier).map((subscription)=>{
            this.forget(subscription);
            this.notify(subscription, "rejected");
            return subscription;
        });
    }
    forget(subscription) {
        this.guarantor.forget(subscription);
        this.subscriptions = this.subscriptions.filter((s)=>s !== subscription);
        return subscription;
    }
    findAll(identifier) {
        return this.subscriptions.filter((s)=>s.identifier === identifier);
    }
    reload() {
        return this.subscriptions.map((subscription)=>this.subscribe(subscription));
    }
    notifyAll(callbackName, ...args) {
        return this.subscriptions.map((subscription)=>this.notify(subscription, callbackName, ...args));
    }
    notify(subscription, callbackName, ...args) {
        let subscriptions;
        if (typeof subscription === "string") subscriptions = this.findAll(subscription);
        else subscriptions = [
            subscription
        ];
        return subscriptions.map((subscription)=>typeof subscription[callbackName] === "function" ? subscription[callbackName](...args) : undefined);
    }
    subscribe(subscription) {
        if (this.sendCommand(subscription, "subscribe")) this.guarantor.guarantee(subscription);
    }
    confirmSubscription(identifier) {
        $9d9fd749327e8703$export$af88d00dbe7f521.log(`Subscription confirmed ${identifier}`);
        this.findAll(identifier).map((subscription)=>this.guarantor.forget(subscription));
    }
    sendCommand(subscription, command) {
        const { identifier: identifier } = subscription;
        return this.consumer.send({
            command: command,
            identifier: identifier
        });
    }
}
class $9d9fd749327e8703$export$b3bffd4bb7da6b8f {
    constructor(url){
        this._url = url;
        this.subscriptions = new $9d9fd749327e8703$export$d73dcc2e0bdfb5bd(this);
        this.connection = new $9d9fd749327e8703$export$98b66c25bb38499d(this);
        this.subprotocols = [];
    }
    get url() {
        return $9d9fd749327e8703$export$c98131997e57b39f(this._url);
    }
    send(data) {
        return this.connection.send(data);
    }
    connect() {
        return this.connection.open();
    }
    disconnect() {
        return this.connection.close({
            allowReconnect: false
        });
    }
    ensureActiveConnection() {
        if (!this.connection.isActive()) return this.connection.open();
    }
    addSubProtocol(subprotocol) {
        this.subprotocols = [
            ...this.subprotocols,
            subprotocol
        ];
    }
}
function $9d9fd749327e8703$export$c98131997e57b39f(url) {
    if (typeof url === "function") url = url();
    if (url && !/^wss?:/i.test(url)) {
        const a = document.createElement("a");
        a.href = url;
        a.href = a.href;
        a.protocol = a.protocol.replace("http", "ws");
        return a.href;
    } else return url;
}
function $9d9fd749327e8703$export$799d131dbb74b992(url = $9d9fd749327e8703$export$44487a86467333c3("url") || $9d9fd749327e8703$export$e32e5bb0446b4e6.default_mount_path) {
    return new $9d9fd749327e8703$export$b3bffd4bb7da6b8f(url);
}
function $9d9fd749327e8703$export$44487a86467333c3(name) {
    const element = document.head.querySelector(`meta[name='action-cable-${name}']`);
    if (element) return element.getAttribute("content");
}


parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $6lvMC = parcelRequire("6lvMC");

var $iChsq = parcelRequire("iChsq");
const $b5df3d59c545d0d7$var$CableProvider = ({ children: children })=>{
    const session = (0, $iD0SF.useSelector)((0, $6lvMC.getUserSession));
    const apiToken = session?.apiToken;
    const [consumer, setConsumer] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!apiToken) {
            if (consumer) {
                consumer.disconnect();
                setConsumer(null);
            }
            return;
        }
        const url = `${"/cable"}?token=${apiToken}`;
        const newConsumer = (0, $9d9fd749327e8703$export$799d131dbb74b992)(url);
        setConsumer(newConsumer);
        return ()=>{
            newConsumer.disconnect();
        };
    }, [
        apiToken
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iChsq.CableContext).Provider, {
        value: {
            apiToken: apiToken,
            consumer: consumer
        },
        children: children
    });
};
var $b5df3d59c545d0d7$export$2e2bcd8739ae039 = $b5df3d59c545d0d7$var$CableProvider;



var $fpLIl = parcelRequire("fpLIl");

var $bjGFW = parcelRequire("bjGFW");

var $lCZwG = parcelRequire("lCZwG");

var $9EFkG = parcelRequire("9EFkG");

var $kYqkq = parcelRequire("kYqkq");

var $2e3dz = parcelRequire("2e3dz");

var $f52QH = parcelRequire("f52QH");
0, $5wPBK.default;
0, $9EFkG.default;
const $46ba867bb76ee71f$var$Loading = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aEgqS.default), {});
};
const $46ba867bb76ee71f$var$genericErrorMessage = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
    className: "text-xl space-y-4 flex flex-col justify-center items-center h-screen",
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
            children: "Something went wrong. Please try reloading the page"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: "If the error persists please go to the home page"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lCZwG.default), {
            href: "/",
            children: "Home Page"
        })
    ]
});
const $46ba867bb76ee71f$var$App = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($b5weT))).setAppElement("#root");
    const [connectionRefresherIndex, setConnectionRefresherIndex] = (0, $acw62.useState)(null);
    const currentUser = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUser));
    const currentUserId = (0, $kYqkq.useAppSelector)((0, $6lvMC.getCurrentUserId));
    const dispatch = (0, $kYqkq.useAppDispatch)();
    const fetchCurrentUser = ()=>dispatch((0, $ai857.fetchCurrentUserAction)());
    const { tenantId: queryTenantId } = (0, $acw62.useContext)((0, $f52QH.QueryStringContext));
    (0, $acw62.useEffect)(()=>{
        if (queryTenantId) return;
        if (currentUser) setConnectionRefresherIndex(currentUser.currentTenantId);
        if (!currentUserId || currentUser) return;
        fetchCurrentUser();
    }, [
        currentUser,
        currentUserId
    ]);
    // we should really check that this prop is false, as it could also be
    // undefined, in which case we should render as a precaution
    if (currentUser && currentUser.activeInCurrentTenant == false) return /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
        children: "Your account is inactive"
    });
    const cableConnections = ()=>{
        if (!currentUser) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
                    channelName: (0, $8e5HJ.UserChannelName),
                    actionPrefix: (0, $8e5HJ.userCablePrefix)
                }, `${connectionRefresherIndex}-user`),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
                    channelName: (0, $jF0Xa.SharedChannelName),
                    actionPrefix: (0, $jF0Xa.sharedCablePrefix)
                }, `${connectionRefresherIndex}-shared`),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $et8Rr.default), {
                    channelName: (0, $fpLIl.ChatChannelName),
                    actionPrefix: (0, $fpLIl.chatCablePrefix),
                    tenantId: connectionRefresherIndex
                }, `${connectionRefresherIndex}-chat`)
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjGFW.ErrorBoundary), {
        errorMessage: $46ba867bb76ee71f$var$genericErrorMessage,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e12196636af0b10$export$311ca220e7478cda), {
            persistor: (0, $gONkJ.persistor),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5df3d59c545d0d7$export$2e2bcd8739ae039), {
                children: [
                    cableConnections(),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)($46ba867bb76ee71f$var$Loading, {}),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2e3dz.CookiesProvider), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $COwA0.RouterProvider), {
                                    router: (0, $1l1FS.router)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3454eaf910a37d32$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $46ba867bb76ee71f$export$2e2bcd8739ae039 = $46ba867bb76ee71f$var$App;



var $gONkJ = parcelRequire("gONkJ");
parcelRequire("jHTLJ");
var $4hUQH = parcelRequire("4hUQH");

var $acw62 = parcelRequire("acw62");

var $f52QH = parcelRequire("f52QH");
const $70fc9a727fa662ae$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4hUQH.default), {
        store: (0, $gONkJ.store),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f52QH.QueryStringContextProvider), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46ba867bb76ee71f$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=myapp.c60d6d2f.js.map
